import * as S from "react";
import Re, { isValidElement as dG, version as tle, useContext as Do, createContext as fp, useRef as It, useLayoutEffect as zS, useEffect as Er, useState as Wn, useCallback as Cn, useImperativeHandle as pS, forwardRef as ks, useMemo as mn, Children as nle, cloneElement as rle, Component as Cz, useDebugValue as ale, memo as fG, createElement as SE, Fragment as qL, useId as mG } from "react";
import * as sp from "react-dom";
import hb, { createPortal as ole, unstable_batchedUpdates as hG, flushSync as FS } from "react-dom";
import { getI18n as ile, useTranslation as xz, Trans as lle } from "react-i18next";
import { t as Ts, c as _1, a as pG, n as Lx, s as EN, g as sle, b as PN, f as q3, d as Ke, e as Ce, h as Ee, i as Fn, m as c3, l as d3, j as f3, k as Hx, o as B3, p as ule, q as gG, r as vG, u as bG, v as cle, w as dle, x as fle, S as kN, O as mle } from "./select.shared.js";
import { Link as hle } from "react-router-dom";
function Sb(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var DT = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var KL;
function ple() {
  return KL || (KL = 1, (function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function r() {
        for (var c = "", d = 0; d < arguments.length; d++) {
          var f = arguments[d];
          f && (c = i(c, a(f)));
        }
        return c;
      }
      function a(c) {
        if (typeof c == "string" || typeof c == "number")
          return c;
        if (typeof c != "object")
          return "";
        if (Array.isArray(c))
          return r.apply(null, c);
        if (c.toString !== Object.prototype.toString && !c.toString.toString().includes("[native code]"))
          return c.toString();
        var d = "";
        for (var f in c)
          t.call(c, f) && c[f] && (d = i(d, f));
        return d;
      }
      function i(c, d) {
        return d ? c ? c + " " + d : c + d : c;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  })(DT)), DT.exports;
}
var gle = ple();
const _e = /* @__PURE__ */ Sb(gle);
function vt() {
  return vt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var a in r) ({}).hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, vt.apply(null, arguments);
}
function Hn(e) {
  "@babel/helpers - typeof";
  return Hn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Hn(e);
}
var vle = Symbol.for("react.element"), ble = Symbol.for("react.transitional.element"), yle = Symbol.for("react.fragment");
function yG(e) {
  return (
    // Base object type
    e && Hn(e) === "object" && // React Element type
    (e.$$typeof === vle || e.$$typeof === ble) && // React Fragment type
    e.type === yle
  );
}
function Kh(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = [];
  return Re.Children.forEach(e, function(a) {
    a == null && !t.keepEmpty || (Array.isArray(a) ? r = r.concat(Kh(a)) : yG(a) && a.props ? r = r.concat(Kh(a.props.children, t)) : r.push(a));
  }), r;
}
var MN = {}, Ez = [], wle = function(t) {
  Ez.push(t);
};
function pb(e, t) {
  if (process.env.NODE_ENV !== "production" && !e && console !== void 0) {
    var r = Ez.reduce(function(a, i) {
      return i(a ?? "", "warning");
    }, t);
    r && console.error("Warning: ".concat(r));
  }
}
function Sle(e, t) {
  if (process.env.NODE_ENV !== "production" && !e && console !== void 0) {
    var r = Ez.reduce(function(a, i) {
      return i(a ?? "", "note");
    }, t);
    r && console.warn("Note: ".concat(r));
  }
}
function wG() {
  MN = {};
}
function SG(e, t, r) {
  !t && !MN[r] && (e(!1, r), MN[r] = !0);
}
function $n(e, t) {
  SG(pb, e, t);
}
function ON(e, t) {
  SG(Sle, e, t);
}
$n.preMessage = wle;
$n.resetWarned = wG;
$n.noteOnce = ON;
function Cle(e, t) {
  if (Hn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var a = r.call(e, t);
    if (Hn(a) != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function CG(e) {
  var t = Cle(e, "string");
  return Hn(t) == "symbol" ? t : t + "";
}
function ge(e, t, r) {
  return (t = CG(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function YL(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, a);
  }
  return r;
}
function ce(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? YL(Object(r), !0).forEach(function(a) {
      ge(e, a, r[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : YL(Object(r)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(r, a));
    });
  }
  return e;
}
function CE(e) {
  return e instanceof HTMLElement || e instanceof SVGElement;
}
function O9(e) {
  return e && Hn(e) === "object" && CE(e.nativeElement) ? e.nativeElement : CE(e) ? e : null;
}
function GP(e) {
  var t = O9(e);
  if (t)
    return t;
  if (e instanceof Re.Component) {
    var r;
    return (r = hb.findDOMNode) === null || r === void 0 ? void 0 : r.call(hb, e);
  }
  return null;
}
var N7 = { exports: {} }, Fi = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var QL;
function xle() {
  if (QL) return Fi;
  QL = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), c = Symbol.for("react.provider"), d = Symbol.for("react.context"), f = Symbol.for("react.server_context"), p = Symbol.for("react.forward_ref"), g = Symbol.for("react.suspense"), b = Symbol.for("react.suspense_list"), w = Symbol.for("react.memo"), x = Symbol.for("react.lazy"), E = Symbol.for("react.offscreen"), P;
  P = Symbol.for("react.module.reference");
  function k(M) {
    if (typeof M == "object" && M !== null) {
      var T = M.$$typeof;
      switch (T) {
        case e:
          switch (M = M.type, M) {
            case r:
            case i:
            case a:
            case g:
            case b:
              return M;
            default:
              switch (M = M && M.$$typeof, M) {
                case f:
                case d:
                case p:
                case x:
                case w:
                case c:
                  return M;
                default:
                  return T;
              }
          }
        case t:
          return T;
      }
    }
  }
  return Fi.ContextConsumer = d, Fi.ContextProvider = c, Fi.Element = e, Fi.ForwardRef = p, Fi.Fragment = r, Fi.Lazy = x, Fi.Memo = w, Fi.Portal = t, Fi.Profiler = i, Fi.StrictMode = a, Fi.Suspense = g, Fi.SuspenseList = b, Fi.isAsyncMode = function() {
    return !1;
  }, Fi.isConcurrentMode = function() {
    return !1;
  }, Fi.isContextConsumer = function(M) {
    return k(M) === d;
  }, Fi.isContextProvider = function(M) {
    return k(M) === c;
  }, Fi.isElement = function(M) {
    return typeof M == "object" && M !== null && M.$$typeof === e;
  }, Fi.isForwardRef = function(M) {
    return k(M) === p;
  }, Fi.isFragment = function(M) {
    return k(M) === r;
  }, Fi.isLazy = function(M) {
    return k(M) === x;
  }, Fi.isMemo = function(M) {
    return k(M) === w;
  }, Fi.isPortal = function(M) {
    return k(M) === t;
  }, Fi.isProfiler = function(M) {
    return k(M) === i;
  }, Fi.isStrictMode = function(M) {
    return k(M) === a;
  }, Fi.isSuspense = function(M) {
    return k(M) === g;
  }, Fi.isSuspenseList = function(M) {
    return k(M) === b;
  }, Fi.isValidElementType = function(M) {
    return typeof M == "string" || typeof M == "function" || M === r || M === i || M === a || M === g || M === b || M === E || typeof M == "object" && M !== null && (M.$$typeof === x || M.$$typeof === w || M.$$typeof === c || M.$$typeof === d || M.$$typeof === p || M.$$typeof === P || M.getModuleId !== void 0);
  }, Fi.typeOf = k, Fi;
}
var Wi = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var JL;
function Ele() {
  return JL || (JL = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), c = Symbol.for("react.provider"), d = Symbol.for("react.context"), f = Symbol.for("react.server_context"), p = Symbol.for("react.forward_ref"), g = Symbol.for("react.suspense"), b = Symbol.for("react.suspense_list"), w = Symbol.for("react.memo"), x = Symbol.for("react.lazy"), E = Symbol.for("react.offscreen"), P = !1, k = !1, M = !1, T = !1, N = !1, D;
    D = Symbol.for("react.module.reference");
    function $(we) {
      return !!(typeof we == "string" || typeof we == "function" || we === r || we === i || N || we === a || we === g || we === b || T || we === E || P || k || M || typeof we == "object" && we !== null && (we.$$typeof === x || we.$$typeof === w || we.$$typeof === c || we.$$typeof === d || we.$$typeof === p || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      we.$$typeof === D || we.getModuleId !== void 0));
    }
    function j(we) {
      if (typeof we == "object" && we !== null) {
        var Ne = we.$$typeof;
        switch (Ne) {
          case e:
            var pe = we.type;
            switch (pe) {
              case r:
              case i:
              case a:
              case g:
              case b:
                return pe;
              default:
                var Qe = pe && pe.$$typeof;
                switch (Qe) {
                  case f:
                  case d:
                  case p:
                  case x:
                  case w:
                  case c:
                    return Qe;
                  default:
                    return Ne;
                }
            }
          case t:
            return Ne;
        }
      }
    }
    var I = d, L = c, F = e, _ = p, W = r, Q = x, U = w, Y = t, G = i, J = a, H = g, K = b, X = !1, te = !1;
    function ie(we) {
      return X || (X = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function ee(we) {
      return te || (te = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function ne(we) {
      return j(we) === d;
    }
    function ae(we) {
      return j(we) === c;
    }
    function oe(we) {
      return typeof we == "object" && we !== null && we.$$typeof === e;
    }
    function fe(we) {
      return j(we) === p;
    }
    function be(we) {
      return j(we) === r;
    }
    function me(we) {
      return j(we) === x;
    }
    function De(we) {
      return j(we) === w;
    }
    function Me(we) {
      return j(we) === t;
    }
    function ze(we) {
      return j(we) === i;
    }
    function le(we) {
      return j(we) === a;
    }
    function se(we) {
      return j(we) === g;
    }
    function Ae(we) {
      return j(we) === b;
    }
    Wi.ContextConsumer = I, Wi.ContextProvider = L, Wi.Element = F, Wi.ForwardRef = _, Wi.Fragment = W, Wi.Lazy = Q, Wi.Memo = U, Wi.Portal = Y, Wi.Profiler = G, Wi.StrictMode = J, Wi.Suspense = H, Wi.SuspenseList = K, Wi.isAsyncMode = ie, Wi.isConcurrentMode = ee, Wi.isContextConsumer = ne, Wi.isContextProvider = ae, Wi.isElement = oe, Wi.isForwardRef = fe, Wi.isFragment = be, Wi.isLazy = me, Wi.isMemo = De, Wi.isPortal = Me, Wi.isProfiler = ze, Wi.isStrictMode = le, Wi.isSuspense = se, Wi.isSuspenseList = Ae, Wi.isValidElementType = $, Wi.typeOf = j;
  })()), Wi;
}
var ZL;
function Ple() {
  return ZL || (ZL = 1, process.env.NODE_ENV === "production" ? N7.exports = xle() : N7.exports = Ele()), N7.exports;
}
var $T = Ple();
function eC(e, t, r) {
  var a = S.useRef({});
  return (!("value" in a.current) || r(a.current.condition, t)) && (a.current.value = e(), a.current.condition = t), a.current.value;
}
var kle = Number(tle.split(".")[0]), xE = function(t, r) {
  typeof t == "function" ? t(r) : Hn(t) === "object" && t && "current" in t && (t.current = r);
}, mp = function() {
  for (var t = arguments.length, r = new Array(t), a = 0; a < t; a++)
    r[a] = arguments[a];
  var i = r.filter(Boolean);
  return i.length <= 1 ? i[0] : function(c) {
    r.forEach(function(d) {
      xE(d, c);
    });
  };
}, gS = function() {
  for (var t = arguments.length, r = new Array(t), a = 0; a < t; a++)
    r[a] = arguments[a];
  return eC(function() {
    return mp.apply(void 0, r);
  }, r, function(i, c) {
    return i.length !== c.length || i.every(function(d, f) {
      return d !== c[f];
    });
  });
}, gb = function(t) {
  var r, a;
  if (!t)
    return !1;
  if (Pz(t) && kle >= 19)
    return !0;
  var i = $T.isMemo(t) ? t.type.type : t.type;
  return !(typeof i == "function" && !((r = i.prototype) !== null && r !== void 0 && r.render) && i.$$typeof !== $T.ForwardRef || typeof t == "function" && !((a = t.prototype) !== null && a !== void 0 && a.render) && t.$$typeof !== $T.ForwardRef);
};
function Pz(e) {
  return /* @__PURE__ */ dG(e) && !yG(e);
}
var Mle = function(t) {
  return Pz(t) && gb(t);
}, m3 = function(t) {
  if (t && Pz(t)) {
    var r = t;
    return r.props.propertyIsEnumerable("ref") ? r.props.ref : r.ref;
  }
  return null;
}, TN = /* @__PURE__ */ S.createContext(null);
function Ole(e) {
  var t = e.children, r = e.onBatchResize, a = S.useRef(0), i = S.useRef([]), c = S.useContext(TN), d = S.useCallback(function(f, p, g) {
    a.current += 1;
    var b = a.current;
    i.current.push({
      size: f,
      element: p,
      data: g
    }), Promise.resolve().then(function() {
      b === a.current && (r?.(i.current), i.current = []);
    }), c?.(f, p, g);
  }, [r, c]);
  return /* @__PURE__ */ S.createElement(TN.Provider, {
    value: d
  }, t);
}
var xG = (function() {
  if (typeof Map < "u")
    return Map;
  function e(t, r) {
    var a = -1;
    return t.some(function(i, c) {
      return i[0] === r ? (a = c, !0) : !1;
    }), a;
  }
  return (
    /** @class */
    (function() {
      function t() {
        this.__entries__ = [];
      }
      return Object.defineProperty(t.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.get = function(r) {
        var a = e(this.__entries__, r), i = this.__entries__[a];
        return i && i[1];
      }, t.prototype.set = function(r, a) {
        var i = e(this.__entries__, r);
        ~i ? this.__entries__[i][1] = a : this.__entries__.push([r, a]);
      }, t.prototype.delete = function(r) {
        var a = this.__entries__, i = e(a, r);
        ~i && a.splice(i, 1);
      }, t.prototype.has = function(r) {
        return !!~e(this.__entries__, r);
      }, t.prototype.clear = function() {
        this.__entries__.splice(0);
      }, t.prototype.forEach = function(r, a) {
        a === void 0 && (a = null);
        for (var i = 0, c = this.__entries__; i < c.length; i++) {
          var d = c[i];
          r.call(a, d[1], d[0]);
        }
      }, t;
    })()
  );
})(), RN = typeof window < "u" && typeof document < "u" && window.document === document, $k = (function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
})(), Tle = (function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind($k) : function(e) {
    return setTimeout(function() {
      return e(Date.now());
    }, 1e3 / 60);
  };
})(), Rle = 2;
function Ale(e, t) {
  var r = !1, a = !1, i = 0;
  function c() {
    r && (r = !1, e()), a && f();
  }
  function d() {
    Tle(c);
  }
  function f() {
    var p = Date.now();
    if (r) {
      if (p - i < Rle)
        return;
      a = !0;
    } else
      r = !0, a = !1, setTimeout(d, t);
    i = p;
  }
  return f;
}
var Nle = 20, Dle = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], $le = typeof MutationObserver < "u", zle = (
  /** @class */
  (function() {
    function e() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = Ale(this.refresh.bind(this), Nle);
    }
    return e.prototype.addObserver = function(t) {
      ~this.observers_.indexOf(t) || this.observers_.push(t), this.connected_ || this.connect_();
    }, e.prototype.removeObserver = function(t) {
      var r = this.observers_, a = r.indexOf(t);
      ~a && r.splice(a, 1), !r.length && this.connected_ && this.disconnect_();
    }, e.prototype.refresh = function() {
      var t = this.updateObservers_();
      t && this.refresh();
    }, e.prototype.updateObservers_ = function() {
      var t = this.observers_.filter(function(r) {
        return r.gatherActive(), r.hasActive();
      });
      return t.forEach(function(r) {
        return r.broadcastActive();
      }), t.length > 0;
    }, e.prototype.connect_ = function() {
      !RN || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), $le ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, e.prototype.disconnect_ = function() {
      !RN || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, e.prototype.onTransitionEnd_ = function(t) {
      var r = t.propertyName, a = r === void 0 ? "" : r, i = Dle.some(function(c) {
        return !!~a.indexOf(c);
      });
      i && this.refresh();
    }, e.getInstance = function() {
      return this.instance_ || (this.instance_ = new e()), this.instance_;
    }, e.instance_ = null, e;
  })()
), EG = (function(e, t) {
  for (var r = 0, a = Object.keys(t); r < a.length; r++) {
    var i = a[r];
    Object.defineProperty(e, i, {
      value: t[i],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return e;
}), gx = (function(e) {
  var t = e && e.ownerDocument && e.ownerDocument.defaultView;
  return t || $k;
}), PG = T9(0, 0, 0, 0);
function zk(e) {
  return parseFloat(e) || 0;
}
function eH(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  return t.reduce(function(a, i) {
    var c = e["border-" + i + "-width"];
    return a + zk(c);
  }, 0);
}
function jle(e) {
  for (var t = ["top", "right", "bottom", "left"], r = {}, a = 0, i = t; a < i.length; a++) {
    var c = i[a], d = e["padding-" + c];
    r[c] = zk(d);
  }
  return r;
}
function Ile(e) {
  var t = e.getBBox();
  return T9(0, 0, t.width, t.height);
}
function Lle(e) {
  var t = e.clientWidth, r = e.clientHeight;
  if (!t && !r)
    return PG;
  var a = gx(e).getComputedStyle(e), i = jle(a), c = i.left + i.right, d = i.top + i.bottom, f = zk(a.width), p = zk(a.height);
  if (a.boxSizing === "border-box" && (Math.round(f + c) !== t && (f -= eH(a, "left", "right") + c), Math.round(p + d) !== r && (p -= eH(a, "top", "bottom") + d)), !Fle(e)) {
    var g = Math.round(f + c) - t, b = Math.round(p + d) - r;
    Math.abs(g) !== 1 && (f -= g), Math.abs(b) !== 1 && (p -= b);
  }
  return T9(i.left, i.top, f, p);
}
var Hle = /* @__PURE__ */ (function() {
  return typeof SVGGraphicsElement < "u" ? function(e) {
    return e instanceof gx(e).SVGGraphicsElement;
  } : function(e) {
    return e instanceof gx(e).SVGElement && typeof e.getBBox == "function";
  };
})();
function Fle(e) {
  return e === gx(e).document.documentElement;
}
function Wle(e) {
  return RN ? Hle(e) ? Ile(e) : Lle(e) : PG;
}
function Vle(e) {
  var t = e.x, r = e.y, a = e.width, i = e.height, c = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, d = Object.create(c.prototype);
  return EG(d, {
    x: t,
    y: r,
    width: a,
    height: i,
    top: r,
    right: t + a,
    bottom: i + r,
    left: t
  }), d;
}
function T9(e, t, r, a) {
  return { x: e, y: t, width: r, height: a };
}
var _le = (
  /** @class */
  (function() {
    function e(t) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = T9(0, 0, 0, 0), this.target = t;
    }
    return e.prototype.isActive = function() {
      var t = Wle(this.target);
      return this.contentRect_ = t, t.width !== this.broadcastWidth || t.height !== this.broadcastHeight;
    }, e.prototype.broadcastRect = function() {
      var t = this.contentRect_;
      return this.broadcastWidth = t.width, this.broadcastHeight = t.height, t;
    }, e;
  })()
), Ble = (
  /** @class */
  /* @__PURE__ */ (function() {
    function e(t, r) {
      var a = Vle(r);
      EG(this, { target: t, contentRect: a });
    }
    return e;
  })()
), Ule = (
  /** @class */
  (function() {
    function e(t, r, a) {
      if (this.activeObservations_ = [], this.observations_ = new xG(), typeof t != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = t, this.controller_ = r, this.callbackCtx_ = a;
    }
    return e.prototype.observe = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof gx(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var r = this.observations_;
        r.has(t) || (r.set(t, new _le(t)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, e.prototype.unobserve = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof gx(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var r = this.observations_;
        r.has(t) && (r.delete(t), r.size || this.controller_.removeObserver(this));
      }
    }, e.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, e.prototype.gatherActive = function() {
      var t = this;
      this.clearActive(), this.observations_.forEach(function(r) {
        r.isActive() && t.activeObservations_.push(r);
      });
    }, e.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var t = this.callbackCtx_, r = this.activeObservations_.map(function(a) {
          return new Ble(a.target, a.broadcastRect());
        });
        this.callback_.call(t, r, t), this.clearActive();
      }
    }, e.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, e.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, e;
  })()
), kG = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new xG(), MG = (
  /** @class */
  /* @__PURE__ */ (function() {
    function e(t) {
      if (!(this instanceof e))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var r = zle.getInstance(), a = new Ule(t, r, this);
      kG.set(this, a);
    }
    return e;
  })()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(e) {
  MG.prototype[e] = function() {
    var t;
    return (t = kG.get(this))[e].apply(t, arguments);
  };
});
var OG = (function() {
  return typeof $k.ResizeObserver < "u" ? $k.ResizeObserver : MG;
})(), Zw = /* @__PURE__ */ new Map();
function TG(e) {
  e.forEach(function(t) {
    var r, a = t.target;
    (r = Zw.get(a)) === null || r === void 0 || r.forEach(function(i) {
      return i(a);
    });
  });
}
var RG = new OG(TG);
process.env.NODE_ENV;
process.env.NODE_ENV;
function Xle(e, t) {
  Zw.has(e) || (Zw.set(e, /* @__PURE__ */ new Set()), RG.observe(e)), Zw.get(e).add(t);
}
function Gle(e, t) {
  Zw.has(e) && (Zw.get(e).delete(t), Zw.get(e).size || (RG.unobserve(e), Zw.delete(e)));
}
function Vi(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function tH(e, t) {
  for (var r = 0; r < t.length; r++) {
    var a = t[r];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, CG(a.key), a);
  }
}
function _i(e, t, r) {
  return t && tH(e.prototype, t), r && tH(e, r), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function EE(e, t) {
  return EE = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, a) {
    return r.__proto__ = a, r;
  }, EE(e, t);
}
function pd(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && EE(e, t);
}
function Yh(e) {
  return Yh = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Yh(e);
}
function tC() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (tC = function() {
    return !!e;
  })();
}
function bn(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Fx(e, t) {
  if (t && (Hn(t) == "object" || typeof t == "function")) return t;
  if (t !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return bn(e);
}
function B0(e) {
  var t = tC();
  return function() {
    var r, a = Yh(e);
    if (t) {
      var i = Yh(this).constructor;
      r = Reflect.construct(a, arguments, i);
    } else r = a.apply(this, arguments);
    return Fx(this, r);
  };
}
var qle = /* @__PURE__ */ (function(e) {
  pd(r, e);
  var t = B0(r);
  function r() {
    return Vi(this, r), t.apply(this, arguments);
  }
  return _i(r, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), r;
})(S.Component);
function Kle(e, t) {
  var r = e.children, a = e.disabled, i = S.useRef(null), c = S.useRef(null), d = S.useContext(TN), f = typeof r == "function", p = f ? r(i) : r, g = S.useRef({
    width: -1,
    height: -1,
    offsetWidth: -1,
    offsetHeight: -1
  }), b = !f && /* @__PURE__ */ S.isValidElement(p) && gb(p), w = b ? m3(p) : null, x = gS(w, i), E = function() {
    var T;
    return GP(i.current) || // Support `nativeElement` format
    (i.current && Hn(i.current) === "object" ? GP((T = i.current) === null || T === void 0 ? void 0 : T.nativeElement) : null) || GP(c.current);
  };
  S.useImperativeHandle(t, function() {
    return E();
  });
  var P = S.useRef(e);
  P.current = e;
  var k = S.useCallback(function(M) {
    var T = P.current, N = T.onResize, D = T.data, $ = M.getBoundingClientRect(), j = $.width, I = $.height, L = M.offsetWidth, F = M.offsetHeight, _ = Math.floor(j), W = Math.floor(I);
    if (g.current.width !== _ || g.current.height !== W || g.current.offsetWidth !== L || g.current.offsetHeight !== F) {
      var Q = {
        width: _,
        height: W,
        offsetWidth: L,
        offsetHeight: F
      };
      g.current = Q;
      var U = L === Math.round(j) ? j : L, Y = F === Math.round(I) ? I : F, G = ce(ce({}, Q), {}, {
        offsetWidth: U,
        offsetHeight: Y
      });
      d?.(G, M, D), N && Promise.resolve().then(function() {
        N(G, M);
      });
    }
  }, []);
  return S.useEffect(function() {
    var M = E();
    return M && !a && Xle(M, k), function() {
      return Gle(M, k);
    };
  }, [i.current, a]), /* @__PURE__ */ S.createElement(qle, {
    ref: c
  }, b ? /* @__PURE__ */ S.cloneElement(p, {
    ref: x
  }) : p);
}
var AG = /* @__PURE__ */ S.forwardRef(Kle);
process.env.NODE_ENV !== "production" && (AG.displayName = "SingleObserver");
var Yle = "rc-observer-key";
function Qle(e, t) {
  var r = e.children, a = typeof r == "function" ? [r] : Kh(r);
  return process.env.NODE_ENV !== "production" && (a.length > 1 ? pb(!1, "Find more than one child node with `children` in ResizeObserver. Please use ResizeObserver.Collection instead.") : a.length === 0 && pb(!1, "`children` of ResizeObserver is empty. Nothing is in observe.")), a.map(function(i, c) {
    var d = i?.key || "".concat(Yle, "-").concat(c);
    return /* @__PURE__ */ S.createElement(AG, vt({}, e, {
      key: d,
      ref: c === 0 ? t : void 0
    }), i);
  });
}
var hp = /* @__PURE__ */ S.forwardRef(Qle);
process.env.NODE_ENV !== "production" && (hp.displayName = "ResizeObserver");
hp.Collection = Ole;
function AN(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, a = Array(t); r < t; r++) a[r] = e[r];
  return a;
}
function Jle(e) {
  if (Array.isArray(e)) return AN(e);
}
function NG(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function kz(e, t) {
  if (e) {
    if (typeof e == "string") return AN(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? AN(e, t) : void 0;
  }
}
function Zle() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Et(e) {
  return Jle(e) || NG(e) || kz(e) || Zle();
}
var DG = function(t) {
  return +setTimeout(t, 16);
}, $G = function(t) {
  return clearTimeout(t);
};
typeof window < "u" && "requestAnimationFrame" in window && (DG = function(t) {
  return window.requestAnimationFrame(t);
}, $G = function(t) {
  return window.cancelAnimationFrame(t);
});
var nH = 0, R9 = /* @__PURE__ */ new Map();
function zG(e) {
  R9.delete(e);
}
var Pa = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  nH += 1;
  var a = nH;
  function i(c) {
    if (c === 0)
      zG(a), t();
    else {
      var d = DG(function() {
        i(c - 1);
      });
      R9.set(a, d);
    }
  }
  return i(r), a;
};
Pa.cancel = function(e) {
  var t = R9.get(e);
  return zG(e), $G(t);
};
process.env.NODE_ENV !== "production" && (Pa.ids = function() {
  return R9;
});
function jG(e) {
  if (Array.isArray(e)) return e;
}
function ese(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var a, i, c, d, f = [], p = !0, g = !1;
    try {
      if (c = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r) return;
        p = !1;
      } else for (; !(p = (a = c.call(r)).done) && (f.push(a.value), f.length !== t); p = !0) ;
    } catch (b) {
      g = !0, i = b;
    } finally {
      try {
        if (!p && r.return != null && (d = r.return(), Object(d) !== d)) return;
      } finally {
        if (g) throw i;
      }
    }
    return f;
  }
}
function IG() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function qe(e, t) {
  return jG(e) || ese(e, t) || kz(e, t) || IG();
}
function PE(e) {
  for (var t = 0, r, a = 0, i = e.length; i >= 4; ++a, i -= 4)
    r = e.charCodeAt(a) & 255 | (e.charCodeAt(++a) & 255) << 8 | (e.charCodeAt(++a) & 255) << 16 | (e.charCodeAt(++a) & 255) << 24, r = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), r ^= /* k >>> r: */
    r >>> 24, t = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (i) {
    case 3:
      t ^= (e.charCodeAt(a + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(a + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(a) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
function Ju() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function NN(e, t) {
  if (!e)
    return !1;
  if (e.contains)
    return e.contains(t);
  for (var r = t; r; ) {
    if (r === e)
      return !0;
    r = r.parentNode;
  }
  return !1;
}
var rH = "data-rc-order", aH = "data-rc-priority", tse = "rc-util-key", DN = /* @__PURE__ */ new Map();
function LG() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.mark;
  return t ? t.startsWith("data-") ? t : "data-".concat(t) : tse;
}
function A9(e) {
  if (e.attachTo)
    return e.attachTo;
  var t = document.querySelector("head");
  return t || document.body;
}
function nse(e) {
  return e === "queue" ? "prependQueue" : e ? "prepend" : "append";
}
function Mz(e) {
  return Array.from((DN.get(e) || e).children).filter(function(t) {
    return t.tagName === "STYLE";
  });
}
function HG(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!Ju())
    return null;
  var r = t.csp, a = t.prepend, i = t.priority, c = i === void 0 ? 0 : i, d = nse(a), f = d === "prependQueue", p = document.createElement("style");
  p.setAttribute(rH, d), f && c && p.setAttribute(aH, "".concat(c)), r != null && r.nonce && (p.nonce = r?.nonce), p.innerHTML = e;
  var g = A9(t), b = g.firstChild;
  if (a) {
    if (f) {
      var w = (t.styles || Mz(g)).filter(function(x) {
        if (!["prepend", "prependQueue"].includes(x.getAttribute(rH)))
          return !1;
        var E = Number(x.getAttribute(aH) || 0);
        return c >= E;
      });
      if (w.length)
        return g.insertBefore(p, w[w.length - 1].nextSibling), p;
    }
    g.insertBefore(p, b);
  } else
    g.appendChild(p);
  return p;
}
function FG(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = A9(t);
  return (t.styles || Mz(r)).find(function(a) {
    return a.getAttribute(LG(t)) === e;
  });
}
function kE(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = FG(e, t);
  if (r) {
    var a = A9(t);
    a.removeChild(r);
  }
}
function rse(e, t) {
  var r = DN.get(e);
  if (!r || !NN(document, r)) {
    var a = HG("", t), i = a.parentNode;
    DN.set(e, i), e.removeChild(a);
  }
}
function oS(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = A9(r), i = Mz(a), c = ce(ce({}, r), {}, {
    styles: i
  });
  rse(a, c);
  var d = FG(t, c);
  if (d) {
    var f, p;
    if ((f = c.csp) !== null && f !== void 0 && f.nonce && d.nonce !== ((p = c.csp) === null || p === void 0 ? void 0 : p.nonce)) {
      var g;
      d.nonce = (g = c.csp) === null || g === void 0 ? void 0 : g.nonce;
    }
    return d.innerHTML !== e && (d.innerHTML = e), d;
  }
  var b = HG(e, c);
  return b.setAttribute(LG(c), t), b;
}
function ase(e, t) {
  if (e == null) return {};
  var r = {};
  for (var a in e) if ({}.hasOwnProperty.call(e, a)) {
    if (t.indexOf(a) !== -1) continue;
    r[a] = e[a];
  }
  return r;
}
function xr(e, t) {
  if (e == null) return {};
  var r, a, i = ase(e, t);
  if (Object.getOwnPropertySymbols) {
    var c = Object.getOwnPropertySymbols(e);
    for (a = 0; a < c.length; a++) r = c[a], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function R0(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, a = /* @__PURE__ */ new Set();
  function i(c, d) {
    var f = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, p = a.has(c);
    if ($n(!p, "Warning: There may be circular references"), p)
      return !1;
    if (c === d)
      return !0;
    if (r && f > 1)
      return !1;
    a.add(c);
    var g = f + 1;
    if (Array.isArray(c)) {
      if (!Array.isArray(d) || c.length !== d.length)
        return !1;
      for (var b = 0; b < c.length; b++)
        if (!i(c[b], d[b], g))
          return !1;
      return !0;
    }
    if (c && d && Hn(c) === "object" && Hn(d) === "object") {
      var w = Object.keys(c);
      return w.length !== Object.keys(d).length ? !1 : w.every(function(x) {
        return i(c[x], d[x], g);
      });
    }
    return !1;
  }
  return i(e, t);
}
var ose = "%";
function $N(e) {
  return e.join(ose);
}
var ise = /* @__PURE__ */ (function() {
  function e(t) {
    Vi(this, e), ge(this, "instanceId", void 0), ge(this, "cache", /* @__PURE__ */ new Map()), ge(this, "extracted", /* @__PURE__ */ new Set()), this.instanceId = t;
  }
  return _i(e, [{
    key: "get",
    value: function(r) {
      return this.opGet($N(r));
    }
    /** A fast get cache with `get` concat. */
  }, {
    key: "opGet",
    value: function(r) {
      return this.cache.get(r) || null;
    }
  }, {
    key: "update",
    value: function(r, a) {
      return this.opUpdate($N(r), a);
    }
    /** A fast get cache with `get` concat. */
  }, {
    key: "opUpdate",
    value: function(r, a) {
      var i = this.cache.get(r), c = a(i);
      c === null ? this.cache.delete(r) : this.cache.set(r, c);
    }
  }]), e;
})(), lse = ["children"], vx = "data-token-hash", H1 = "data-css-hash", sse = "data-cache-path", RS = "__cssinjs_instance__";
function WG() {
  var e = Math.random().toString(12).slice(2);
  if (typeof document < "u" && document.head && document.body) {
    var t = document.body.querySelectorAll("style[".concat(H1, "]")) || [], r = document.head.firstChild;
    Array.from(t).forEach(function(i) {
      i[RS] = i[RS] || e, i[RS] === e && document.head.insertBefore(i, r);
    });
    var a = {};
    Array.from(document.querySelectorAll("style[".concat(H1, "]"))).forEach(function(i) {
      var c = i.getAttribute(H1);
      if (a[c]) {
        if (i[RS] === e) {
          var d;
          (d = i.parentNode) === null || d === void 0 || d.removeChild(i);
        }
      } else
        a[c] = !0;
    });
  }
  return new ise(e);
}
var Q4 = /* @__PURE__ */ S.createContext({
  hashPriority: "low",
  cache: WG(),
  defaultCache: !0
}), use = function(t) {
  var r = t.children, a = xr(t, lse), i = S.useContext(Q4), c = eC(function() {
    var d = ce({}, i);
    Object.keys(a).forEach(function(p) {
      var g = a[p];
      a[p] !== void 0 && (d[p] = g);
    });
    var f = a.cache;
    return d.cache = d.cache || WG(), d.defaultCache = !f && i.defaultCache, d;
  }, [i, a], function(d, f) {
    return !R0(d[0], f[0], !0) || !R0(d[1], f[1], !0);
  });
  return /* @__PURE__ */ S.createElement(Q4.Provider, {
    value: c
  }, r);
};
function cse(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var r = 0; r < e.length; r++)
    if (e[r] !== t[r])
      return !1;
  return !0;
}
var Oz = /* @__PURE__ */ (function() {
  function e() {
    Vi(this, e), ge(this, "cache", void 0), ge(this, "keys", void 0), ge(this, "cacheCallTimes", void 0), this.cache = /* @__PURE__ */ new Map(), this.keys = [], this.cacheCallTimes = 0;
  }
  return _i(e, [{
    key: "size",
    value: function() {
      return this.keys.length;
    }
  }, {
    key: "internalGet",
    value: function(r) {
      var a, i, c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, d = {
        map: this.cache
      };
      return r.forEach(function(f) {
        if (!d)
          d = void 0;
        else {
          var p;
          d = (p = d) === null || p === void 0 || (p = p.map) === null || p === void 0 ? void 0 : p.get(f);
        }
      }), (a = d) !== null && a !== void 0 && a.value && c && (d.value[1] = this.cacheCallTimes++), (i = d) === null || i === void 0 ? void 0 : i.value;
    }
  }, {
    key: "get",
    value: function(r) {
      var a;
      return (a = this.internalGet(r, !0)) === null || a === void 0 ? void 0 : a[0];
    }
  }, {
    key: "has",
    value: function(r) {
      return !!this.internalGet(r);
    }
  }, {
    key: "set",
    value: function(r, a) {
      var i = this;
      if (!this.has(r)) {
        if (this.size() + 1 > e.MAX_CACHE_SIZE + e.MAX_CACHE_OFFSET) {
          var c = this.keys.reduce(function(g, b) {
            var w = qe(g, 2), x = w[1];
            return i.internalGet(b)[1] < x ? [b, i.internalGet(b)[1]] : g;
          }, [this.keys[0], this.cacheCallTimes]), d = qe(c, 1), f = d[0];
          this.delete(f);
        }
        this.keys.push(r);
      }
      var p = this.cache;
      r.forEach(function(g, b) {
        if (b === r.length - 1)
          p.set(g, {
            value: [a, i.cacheCallTimes++]
          });
        else {
          var w = p.get(g);
          w ? w.map || (w.map = /* @__PURE__ */ new Map()) : p.set(g, {
            map: /* @__PURE__ */ new Map()
          }), p = p.get(g).map;
        }
      });
    }
  }, {
    key: "deleteByPath",
    value: function(r, a) {
      var i = r.get(a[0]);
      if (a.length === 1) {
        var c;
        return i.map ? r.set(a[0], {
          map: i.map
        }) : r.delete(a[0]), (c = i.value) === null || c === void 0 ? void 0 : c[0];
      }
      var d = this.deleteByPath(i.map, a.slice(1));
      return (!i.map || i.map.size === 0) && !i.value && r.delete(a[0]), d;
    }
  }, {
    key: "delete",
    value: function(r) {
      if (this.has(r))
        return this.keys = this.keys.filter(function(a) {
          return !cse(a, r);
        }), this.deleteByPath(this.cache, r);
    }
  }]), e;
})();
ge(Oz, "MAX_CACHE_SIZE", 20);
ge(Oz, "MAX_CACHE_OFFSET", 5);
var oH = 0, VG = /* @__PURE__ */ (function() {
  function e(t) {
    Vi(this, e), ge(this, "derivatives", void 0), ge(this, "id", void 0), this.derivatives = Array.isArray(t) ? t : [t], this.id = oH, t.length === 0 && pb(t.length > 0, "[Ant Design CSS-in-JS] Theme should have at least one derivative function."), oH += 1;
  }
  return _i(e, [{
    key: "getDerivativeToken",
    value: function(r) {
      return this.derivatives.reduce(function(a, i) {
        return i(r, a);
      }, void 0);
    }
  }]), e;
})(), zT = new Oz();
function zN(e) {
  var t = Array.isArray(e) ? e : [e];
  return zT.has(t) || zT.set(t, new VG(t)), zT.get(t);
}
var dse = /* @__PURE__ */ new WeakMap(), jT = {};
function fse(e, t) {
  for (var r = dse, a = 0; a < t.length; a += 1) {
    var i = t[a];
    r.has(i) || r.set(i, /* @__PURE__ */ new WeakMap()), r = r.get(i);
  }
  return r.has(jT) || r.set(jT, e()), r.get(jT);
}
var iH = /* @__PURE__ */ new WeakMap();
function cE(e) {
  var t = iH.get(e) || "";
  return t || (Object.keys(e).forEach(function(r) {
    var a = e[r];
    t += r, a instanceof VG ? t += a.id : a && Hn(a) === "object" ? t += cE(a) : t += a;
  }), t = PE(t), iH.set(e, t)), t;
}
function lH(e, t) {
  return PE("".concat(t, "_").concat(cE(e)));
}
var jN = Ju();
function Ye(e) {
  return typeof e == "number" ? "".concat(e, "px") : e;
}
function jk(e, t, r) {
  var a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1;
  if (i)
    return e;
  var c = ce(ce({}, a), {}, ge(ge({}, vx, t), H1, r)), d = Object.keys(c).map(function(f) {
    var p = c[f];
    return p ? "".concat(f, '="').concat(p, '"') : null;
  }).filter(function(f) {
    return f;
  }).join(" ");
  return "<style ".concat(d, ">").concat(e, "</style>");
}
var qP = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return "--".concat(r ? "".concat(r, "-") : "").concat(t).replace(/([a-z0-9])([A-Z])/g, "$1-$2").replace(/([A-Z]+)([A-Z][a-z0-9]+)/g, "$1-$2").replace(/([a-z])([A-Z0-9])/g, "$1-$2").toLowerCase();
}, mse = function(t, r, a) {
  return Object.keys(t).length ? ".".concat(r).concat(a != null && a.scope ? ".".concat(a.scope) : "", "{").concat(Object.entries(t).map(function(i) {
    var c = qe(i, 2), d = c[0], f = c[1];
    return "".concat(d, ":").concat(f, ";");
  }).join(""), "}") : "";
}, _G = function(t, r, a) {
  var i = {}, c = {};
  return Object.entries(t).forEach(function(d) {
    var f, p, g = qe(d, 2), b = g[0], w = g[1];
    if (a != null && (f = a.preserve) !== null && f !== void 0 && f[b])
      c[b] = w;
    else if ((typeof w == "string" || typeof w == "number") && !(a != null && (p = a.ignore) !== null && p !== void 0 && p[b])) {
      var x, E = qP(b, a?.prefix);
      i[E] = typeof w == "number" && !(a != null && (x = a.unitless) !== null && x !== void 0 && x[b]) ? "".concat(w, "px") : String(w), c[b] = "var(".concat(E, ")");
    }
  }), [c, mse(i, r, {
    scope: a?.scope
  })];
}, sH = process.env.NODE_ENV !== "test" && Ju() ? S.useLayoutEffect : S.useEffect, Da = function(t, r) {
  var a = S.useRef(!0);
  sH(function() {
    return t(a.current);
  }, r), sH(function() {
    return a.current = !1, function() {
      a.current = !0;
    };
  }, []);
}, IN = function(t, r) {
  Da(function(a) {
    if (!a)
      return t();
  }, r);
}, hse = ce({}, S), uH = hse.useInsertionEffect, pse = function(t, r, a) {
  S.useMemo(t, a), Da(function() {
    return r(!0);
  }, a);
}, gse = uH ? function(e, t, r) {
  return uH(function() {
    return e(), t();
  }, r);
} : pse, vse = ce({}, S), bse = vse.useInsertionEffect, yse = function(t) {
  var r = [], a = !1;
  function i(c) {
    if (a) {
      process.env.NODE_ENV !== "production" && pb(!1, "[Ant Design CSS-in-JS] You are registering a cleanup function after unmount, which will not have any effect.");
      return;
    }
    r.push(c);
  }
  return S.useEffect(function() {
    return a = !1, function() {
      a = !0, r.length && r.forEach(function(c) {
        return c();
      });
    };
  }, t), i;
}, wse = function() {
  return function(t) {
    t();
  };
}, Sse = typeof bse < "u" ? yse : wse;
function Cse() {
  return !1;
}
var LN = !1;
function xse() {
  return LN;
}
const Ese = process.env.NODE_ENV === "production" ? Cse : xse;
if (process.env.NODE_ENV !== "production" && typeof module < "u" && module && module.hot && typeof window < "u") {
  var D7 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : null;
  if (D7 && typeof D7.webpackHotUpdate == "function") {
    var Pse = D7.webpackHotUpdate;
    D7.webpackHotUpdate = function() {
      return LN = !0, setTimeout(function() {
        LN = !1;
      }, 0), Pse.apply(void 0, arguments);
    };
  }
}
function Tz(e, t, r, a, i) {
  var c = S.useContext(Q4), d = c.cache, f = [e].concat(Et(t)), p = $N(f), g = Sse([p]), b = Ese(), w = function(k) {
    d.opUpdate(p, function(M) {
      var T = M || [void 0, void 0], N = qe(T, 2), D = N[0], $ = D === void 0 ? 0 : D, j = N[1], I = j;
      process.env.NODE_ENV !== "production" && j && b && (a?.(I, b), I = null);
      var L = I || r(), F = [$, L];
      return k ? k(F) : F;
    });
  };
  S.useMemo(
    function() {
      w();
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [p]
    /* eslint-enable */
  );
  var x = d.opGet(p);
  process.env.NODE_ENV !== "production" && !x && (w(), x = d.opGet(p));
  var E = x[1];
  return gse(function() {
    i?.(E);
  }, function(P) {
    return w(function(k) {
      var M = qe(k, 2), T = M[0], N = M[1];
      return P && T === 0 && i?.(E), [T + 1, N];
    }), function() {
      d.opUpdate(p, function(k) {
        var M = k || [], T = qe(M, 2), N = T[0], D = N === void 0 ? 0 : N, $ = T[1], j = D - 1;
        return j === 0 ? (g(function() {
          (P || !d.opGet(p)) && a?.($, !1);
        }), null) : [D - 1, $];
      });
    };
  }, [p]), E;
}
var kse = {}, Mse = process.env.NODE_ENV !== "production" ? "css-dev-only-do-not-override" : "css", W4 = /* @__PURE__ */ new Map();
function Ose(e) {
  W4.set(e, (W4.get(e) || 0) + 1);
}
function Tse(e, t) {
  if (typeof document < "u") {
    var r = document.querySelectorAll("style[".concat(vx, '="').concat(e, '"]'));
    r.forEach(function(a) {
      if (a[RS] === t) {
        var i;
        (i = a.parentNode) === null || i === void 0 || i.removeChild(a);
      }
    });
  }
}
var Rse = 0;
function Ase(e, t) {
  W4.set(e, (W4.get(e) || 0) - 1);
  var r = /* @__PURE__ */ new Set();
  W4.forEach(function(a, i) {
    a <= 0 && r.add(i);
  }), W4.size - r.size > Rse && r.forEach(function(a) {
    Tse(a, t), W4.delete(a);
  });
}
var Nse = function(t, r, a, i) {
  var c = a.getDerivativeToken(t), d = ce(ce({}, c), r);
  return i && (d = i(d)), d;
}, BG = "token";
function Dse(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = Do(Q4), i = a.cache.instanceId, c = a.container, d = r.salt, f = d === void 0 ? "" : d, p = r.override, g = p === void 0 ? kse : p, b = r.formatToken, w = r.getComputedToken, x = r.cssVar, E = fse(function() {
    return Object.assign.apply(Object, [{}].concat(Et(t)));
  }, t), P = cE(E), k = cE(g), M = x ? cE(x) : "", T = Tz(BG, [f, e.id, P, k, M], function() {
    var N, D = w ? w(E, g, e) : Nse(E, g, e, b), $ = ce({}, D), j = "";
    if (x) {
      var I = _G(D, x.key, {
        prefix: x.prefix,
        ignore: x.ignore,
        unitless: x.unitless,
        preserve: x.preserve
      }), L = qe(I, 2);
      D = L[0], j = L[1];
    }
    var F = lH(D, f);
    D._tokenKey = F, $._tokenKey = lH($, f);
    var _ = (N = x?.key) !== null && N !== void 0 ? N : F;
    D._themeKey = _, Ose(_);
    var W = "".concat(Mse, "-").concat(PE(F));
    return D._hashId = W, [D, W, $, j, x?.key || ""];
  }, function(N) {
    Ase(N[0]._themeKey, i);
  }, function(N) {
    var D = qe(N, 4), $ = D[0], j = D[3];
    if (x && j) {
      var I = oS(j, PE("css-variables-".concat($._themeKey)), {
        mark: H1,
        prepend: "queue",
        attachTo: c,
        priority: -999
      });
      I[RS] = i, I.setAttribute(vx, $._themeKey);
    }
  });
  return T;
}
var $se = function(t, r, a) {
  var i = qe(t, 5), c = i[2], d = i[3], f = i[4], p = a || {}, g = p.plain;
  if (!d)
    return null;
  var b = c._tokenKey, w = -999, x = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(w)
  }, E = jk(d, f, b, x, g);
  return [w, b, E];
}, zse = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, UG = "comm", XG = "rule", GG = "decl", jse = "@import", Ise = "@namespace", Lse = "@keyframes", Hse = "@layer", qG = Math.abs, Rz = String.fromCharCode;
function KG(e) {
  return e.trim();
}
function KP(e, t, r) {
  return e.replace(t, r);
}
function Fse(e, t, r) {
  return e.indexOf(t, r);
}
function ex(e, t) {
  return e.charCodeAt(t) | 0;
}
function bx(e, t, r) {
  return e.slice(t, r);
}
function ab(e) {
  return e.length;
}
function Wse(e) {
  return e.length;
}
function $7(e, t) {
  return t.push(e), e;
}
var N9 = 1, yx = 1, YG = 0, _0 = 0, Qu = 0, Wx = "";
function Az(e, t, r, a, i, c, d, f) {
  return { value: e, root: t, parent: r, type: a, props: i, children: c, line: N9, column: yx, length: d, return: "", siblings: f };
}
function Vse() {
  return Qu;
}
function _se() {
  return Qu = _0 > 0 ? ex(Wx, --_0) : 0, yx--, Qu === 10 && (yx = 1, N9--), Qu;
}
function F1() {
  return Qu = _0 < YG ? ex(Wx, _0++) : 0, yx++, Qu === 10 && (yx = 1, N9++), Qu;
}
function AS() {
  return ex(Wx, _0);
}
function YP() {
  return _0;
}
function D9(e, t) {
  return bx(Wx, e, t);
}
function ME(e) {
  switch (e) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Bse(e) {
  return N9 = yx = 1, YG = ab(Wx = e), _0 = 0, [];
}
function Use(e) {
  return Wx = "", e;
}
function IT(e) {
  return KG(D9(_0 - 1, HN(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Xse(e) {
  for (; (Qu = AS()) && Qu < 33; )
    F1();
  return ME(e) > 2 || ME(Qu) > 3 ? "" : " ";
}
function Gse(e, t) {
  for (; --t && F1() && !(Qu < 48 || Qu > 102 || Qu > 57 && Qu < 65 || Qu > 70 && Qu < 97); )
    ;
  return D9(e, YP() + (t < 6 && AS() == 32 && F1() == 32));
}
function HN(e) {
  for (; F1(); )
    switch (Qu) {
      // ] ) " '
      case e:
        return _0;
      // " '
      case 34:
      case 39:
        e !== 34 && e !== 39 && HN(Qu);
        break;
      // (
      case 40:
        e === 41 && HN(e);
        break;
      // \
      case 92:
        F1();
        break;
    }
  return _0;
}
function qse(e, t) {
  for (; F1() && e + Qu !== 57; )
    if (e + Qu === 84 && AS() === 47)
      break;
  return "/*" + D9(t, _0 - 1) + "*" + Rz(e === 47 ? e : F1());
}
function Kse(e) {
  for (; !ME(AS()); )
    F1();
  return D9(e, _0);
}
function Yse(e) {
  return Use(QP("", null, null, null, [""], e = Bse(e), 0, [0], e));
}
function QP(e, t, r, a, i, c, d, f, p) {
  for (var g = 0, b = 0, w = d, x = 0, E = 0, P = 0, k = 1, M = 1, T = 1, N = 0, D = "", $ = i, j = c, I = a, L = D; M; )
    switch (P = N, N = F1()) {
      // (
      case 40:
        if (P != 108 && ex(L, w - 1) == 58) {
          Fse(L += KP(IT(N), "&", "&\f"), "&\f", qG(g ? f[g - 1] : 0)) != -1 && (T = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        L += IT(N);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        L += Xse(P);
        break;
      // \
      case 92:
        L += Gse(YP() - 1, 7);
        continue;
      // /
      case 47:
        switch (AS()) {
          case 42:
          case 47:
            $7(Qse(qse(F1(), YP()), t, r, p), p), (ME(P || 1) == 5 || ME(AS() || 1) == 5) && ab(L) && bx(L, -1, void 0) !== " " && (L += " ");
            break;
          default:
            L += "/";
        }
        break;
      // {
      case 123 * k:
        f[g++] = ab(L) * T;
      // } ; \0
      case 125 * k:
      case 59:
      case 0:
        switch (N) {
          // \0 }
          case 0:
          case 125:
            M = 0;
          // ;
          case 59 + b:
            T == -1 && (L = KP(L, /\f/g, "")), E > 0 && (ab(L) - w || k === 0 && P === 47) && $7(E > 32 ? dH(L + ";", a, r, w - 1, p) : dH(KP(L, " ", "") + ";", a, r, w - 2, p), p);
            break;
          // @ ;
          case 59:
            L += ";";
          // { rule/at-rule
          default:
            if ($7(I = cH(L, t, r, g, b, i, f, D, $ = [], j = [], w, c), c), N === 123)
              if (b === 0)
                QP(L, t, I, I, $, c, w, f, j);
              else {
                switch (x) {
                  // c(ontainer)
                  case 99:
                    if (ex(L, 3) === 110) break;
                  // l(ayer)
                  case 108:
                    if (ex(L, 2) === 97) break;
                  default:
                    b = 0;
                  // d(ocument) m(edia) s(upports)
                  case 100:
                  case 109:
                  case 115:
                }
                b ? QP(e, I, I, a && $7(cH(e, I, I, 0, 0, i, f, D, i, $ = [], w, j), j), i, j, w, f, a ? $ : j) : QP(L, I, I, I, [""], j, 0, f, j);
              }
        }
        g = b = E = 0, k = T = 1, D = L = "", w = d;
        break;
      // :
      case 58:
        w = 1 + ab(L), E = P;
      default:
        if (k < 1) {
          if (N == 123)
            --k;
          else if (N == 125 && k++ == 0 && _se() == 125)
            continue;
        }
        switch (L += Rz(N), N * k) {
          // &
          case 38:
            T = b > 0 ? 1 : (L += "\f", -1);
            break;
          // ,
          case 44:
            f[g++] = (ab(L) - 1) * T, T = 1;
            break;
          // @
          case 64:
            AS() === 45 && (L += IT(F1())), x = AS(), b = w = ab(D = L += Kse(YP())), N++;
            break;
          // -
          case 45:
            P === 45 && ab(L) == 2 && (k = 0);
        }
    }
  return c;
}
function cH(e, t, r, a, i, c, d, f, p, g, b, w) {
  for (var x = i - 1, E = i === 0 ? c : [""], P = Wse(E), k = 0, M = 0, T = 0; k < a; ++k)
    for (var N = 0, D = bx(e, x + 1, x = qG(M = d[k])), $ = e; N < P; ++N)
      ($ = KG(M > 0 ? E[N] + " " + D : KP(D, /&\f/g, E[N]))) && (p[T++] = $);
  return Az(e, t, r, i === 0 ? XG : f, p, g, b, w);
}
function Qse(e, t, r, a) {
  return Az(e, t, r, UG, Rz(Vse()), bx(e, 2, -2), 0, a);
}
function dH(e, t, r, a, i) {
  return Az(e, t, r, GG, bx(e, 0, a), bx(e, a + 1, -1), a, i);
}
function FN(e, t) {
  for (var r = "", a = 0; a < e.length; a++)
    r += t(e[a], a, e, t) || "";
  return r;
}
function Jse(e, t, r, a) {
  switch (e.type) {
    case Hse:
      if (e.children.length) break;
    case jse:
    case Ise:
    case GG:
      return e.return = e.return || e.value;
    case UG:
      return "";
    case Lse:
      return e.return = e.value + "{" + FN(e.children, a) + "}";
    case XG:
      if (!ab(e.value = e.props.join(","))) return "";
  }
  return ab(r = FN(e.children, a)) ? e.return = e.value + "{" + r + "}" : "";
}
function QG(e, t) {
  var r = t.path, a = t.parentSelectors;
  $n(!1, "[Ant Design CSS-in-JS] ".concat(r ? "Error in ".concat(r, ": ") : "").concat(e).concat(a.length ? " Selector: ".concat(a.join(" | ")) : ""));
}
var Zse = function(t, r, a) {
  if (t === "content") {
    var i = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, c = ["normal", "none", "initial", "inherit", "unset"];
    (typeof r != "string" || c.indexOf(r) === -1 && !i.test(r) && (r.charAt(0) !== r.charAt(r.length - 1) || r.charAt(0) !== '"' && r.charAt(0) !== "'")) && QG("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"".concat(r, "\"'`."), a);
  }
}, eue = function(t, r, a) {
  t === "animation" && a.hashId && r !== "none" && QG("You seem to be using hashed animation '".concat(r, "', in which case 'animationName' with Keyframe as value is recommended."), a);
}, fH = "data-ant-cssinjs-cache-path", JG = "_FILE_STYLE__", q4, ZG = !0;
function tue() {
  if (!q4 && (q4 = {}, Ju())) {
    var e = document.createElement("div");
    e.className = fH, e.style.position = "fixed", e.style.visibility = "hidden", e.style.top = "-9999px", document.body.appendChild(e);
    var t = getComputedStyle(e).content || "";
    t = t.replace(/^"/, "").replace(/"$/, ""), t.split(";").forEach(function(i) {
      var c = i.split(":"), d = qe(c, 2), f = d[0], p = d[1];
      q4[f] = p;
    });
    var r = document.querySelector("style[".concat(fH, "]"));
    if (r) {
      var a;
      ZG = !1, (a = r.parentNode) === null || a === void 0 || a.removeChild(r);
    }
    document.body.removeChild(e);
  }
}
function nue(e) {
  return tue(), !!q4[e];
}
function rue(e) {
  var t = q4[e], r = null;
  if (t && Ju())
    if (ZG)
      r = JG;
    else {
      var a = document.querySelector("style[".concat(H1, '="').concat(q4[e], '"]'));
      a ? r = a.innerHTML : delete q4[e];
    }
  return [r, t];
}
var eq = "_skip_check_", tq = "_multi_value_";
function JP(e) {
  var t = FN(Yse(e), Jse);
  return t.replace(/\{%%%\:[^;];}/g, ";");
}
function aue(e) {
  return Hn(e) === "object" && e && (eq in e || tq in e);
}
function mH(e, t, r) {
  if (!t)
    return e;
  var a = ".".concat(t), i = r === "low" ? ":where(".concat(a, ")") : a, c = e.split(",").map(function(d) {
    var f, p = d.trim().split(/\s+/), g = p[0] || "", b = ((f = g.match(/^\w+/)) === null || f === void 0 ? void 0 : f[0]) || "";
    return g = "".concat(b).concat(i).concat(g.slice(b.length)), [g].concat(Et(p.slice(1))).join(" ");
  });
  return c.join(",");
}
var oue = function e(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    root: !0,
    parentSelectors: []
  }, i = a.root, c = a.injectHash, d = a.parentSelectors, f = r.hashId, p = r.layer, g = r.path, b = r.hashPriority, w = r.transformers, x = w === void 0 ? [] : w, E = r.linters, P = E === void 0 ? [] : E, k = "", M = {};
  function T($) {
    var j = $.getName(f);
    if (!M[j]) {
      var I = e($.style, r, {
        root: !1,
        parentSelectors: d
      }), L = qe(I, 1), F = L[0];
      M[j] = "@keyframes ".concat($.getName(f)).concat(F);
    }
  }
  function N($) {
    var j = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return $.forEach(function(I) {
      Array.isArray(I) ? N(I, j) : I && j.push(I);
    }), j;
  }
  var D = N(Array.isArray(t) ? t : [t]);
  return D.forEach(function($) {
    var j = typeof $ == "string" && !i ? {} : $;
    if (typeof j == "string")
      k += "".concat(j, `
`);
    else if (j._keyframe)
      T(j);
    else {
      var I = x.reduce(function(L, F) {
        var _;
        return (F == null || (_ = F.visit) === null || _ === void 0 ? void 0 : _.call(F, L)) || L;
      }, j);
      Object.keys(I).forEach(function(L) {
        var F = I[L];
        if (Hn(F) === "object" && F && (L !== "animationName" || !F._keyframe) && !aue(F)) {
          var _ = !1, W = L.trim(), Q = !1;
          (i || c) && f ? W.startsWith("@") ? _ = !0 : W === "&" ? W = mH("", f, b) : W = mH(L, f, b) : i && !f && (W === "&" || W === "") && (W = "", Q = !0);
          var U = e(F, r, {
            root: Q,
            injectHash: _,
            parentSelectors: [].concat(Et(d), [W])
          }), Y = qe(U, 2), G = Y[0], J = Y[1];
          M = ce(ce({}, M), J), k += "".concat(W).concat(G);
        } else {
          let X = function(te, ie) {
            process.env.NODE_ENV !== "production" && (Hn(F) !== "object" || !(F != null && F[eq])) && [Zse, eue].concat(Et(P)).forEach(function(ae) {
              return ae(te, ie, {
                path: g,
                hashId: f,
                parentSelectors: d
              });
            });
            var ee = te.replace(/[A-Z]/g, function(ae) {
              return "-".concat(ae.toLowerCase());
            }), ne = ie;
            !zse[te] && typeof ne == "number" && ne !== 0 && (ne = "".concat(ne, "px")), te === "animationName" && ie !== null && ie !== void 0 && ie._keyframe && (T(ie), ne = ie.getName(f)), k += "".concat(ee, ":").concat(ne, ";");
          };
          var H, K = (H = F?.value) !== null && H !== void 0 ? H : F;
          Hn(F) === "object" && F !== null && F !== void 0 && F[tq] && Array.isArray(K) ? K.forEach(function(te) {
            X(L, te);
          }) : X(L, K);
        }
      });
    }
  }), i ? p && (k && (k = "@layer ".concat(p.name, " {").concat(k, "}")), p.dependencies && (M["@layer ".concat(p.name)] = p.dependencies.map(function($) {
    return "@layer ".concat($, ", ").concat(p.name, ";");
  }).join(`
`))) : k = "{".concat(k, "}"), [k, M];
};
function nq(e, t) {
  return PE("".concat(e.join("%")).concat(t));
}
function iue() {
  return null;
}
var rq = "style";
function WN(e, t) {
  var r = e.token, a = e.path, i = e.hashId, c = e.layer, d = e.nonce, f = e.clientOnly, p = e.order, g = p === void 0 ? 0 : p, b = S.useContext(Q4), w = b.autoClear, x = b.mock, E = b.defaultCache, P = b.hashPriority, k = b.container, M = b.ssrInline, T = b.transformers, N = b.linters, D = b.cache, $ = b.layer, j = r._tokenKey, I = [j];
  $ && I.push("layer"), I.push.apply(I, Et(a));
  var L = jN;
  process.env.NODE_ENV !== "production" && x !== void 0 && (L = x === "client");
  var F = Tz(
    rq,
    I,
    // Create cache if needed
    function() {
      var Y = I.join("|");
      if (nue(Y)) {
        var G = rue(Y), J = qe(G, 2), H = J[0], K = J[1];
        if (H)
          return [H, j, K, {}, f, g];
      }
      var X = t(), te = oue(X, {
        hashId: i,
        hashPriority: P,
        layer: $ ? c : void 0,
        path: a.join("-"),
        transformers: T,
        linters: N
      }), ie = qe(te, 2), ee = ie[0], ne = ie[1], ae = JP(ee), oe = nq(I, ae);
      return [ae, j, oe, ne, f, g];
    },
    // Remove cache if no need
    function(Y, G) {
      var J = qe(Y, 3), H = J[2];
      (G || w) && jN && kE(H, {
        mark: H1,
        attachTo: k
      });
    },
    // Effect: Inject style here
    function(Y) {
      var G = qe(Y, 4), J = G[0];
      G[1];
      var H = G[2], K = G[3];
      if (L && J !== JG) {
        var X = {
          mark: H1,
          prepend: $ ? !1 : "queue",
          attachTo: k,
          priority: g
        }, te = typeof d == "function" ? d() : d;
        te && (X.csp = {
          nonce: te
        });
        var ie = [], ee = [];
        Object.keys(K).forEach(function(ae) {
          ae.startsWith("@layer") ? ie.push(ae) : ee.push(ae);
        }), ie.forEach(function(ae) {
          oS(JP(K[ae]), "_layer-".concat(ae), ce(ce({}, X), {}, {
            prepend: !0
          }));
        });
        var ne = oS(J, H, X);
        ne[RS] = D.instanceId, ne.setAttribute(vx, j), process.env.NODE_ENV !== "production" && ne.setAttribute(sse, I.join("|")), ee.forEach(function(ae) {
          oS(JP(K[ae]), "_effect-".concat(ae), X);
        });
      }
    }
  ), _ = qe(F, 3), W = _[0], Q = _[1], U = _[2];
  return function(Y) {
    var G;
    return !M || L || !E ? G = /* @__PURE__ */ S.createElement(iue, null) : G = /* @__PURE__ */ S.createElement("style", vt({}, ge(ge({}, vx, Q), H1, U), {
      dangerouslySetInnerHTML: {
        __html: W
      }
    })), /* @__PURE__ */ S.createElement(S.Fragment, null, G, Y);
  };
}
var lue = function(t, r, a) {
  var i = qe(t, 6), c = i[0], d = i[1], f = i[2], p = i[3], g = i[4], b = i[5], w = a || {}, x = w.plain;
  if (g)
    return null;
  var E = c, P = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(b)
  };
  return E = jk(c, d, f, P, x), p && Object.keys(p).forEach(function(k) {
    if (!r[k]) {
      r[k] = !0;
      var M = JP(p[k]), T = jk(M, d, "_effect-".concat(k), P, x);
      k.startsWith("@layer") ? E = T + E : E += T;
    }
  }), [b, f, E];
}, aq = "cssVar", sue = function(t, r) {
  var a = t.key, i = t.prefix, c = t.unitless, d = t.ignore, f = t.token, p = t.scope, g = p === void 0 ? "" : p, b = Do(Q4), w = b.cache.instanceId, x = b.container, E = f._tokenKey, P = [].concat(Et(t.path), [a, g, E]), k = Tz(aq, P, function() {
    var M = r(), T = _G(M, a, {
      prefix: i,
      unitless: c,
      ignore: d,
      scope: g
    }), N = qe(T, 2), D = N[0], $ = N[1], j = nq(P, $);
    return [D, $, j, a];
  }, function(M) {
    var T = qe(M, 3), N = T[2];
    jN && kE(N, {
      mark: H1,
      attachTo: x
    });
  }, function(M) {
    var T = qe(M, 3), N = T[1], D = T[2];
    if (N) {
      var $ = oS(N, D, {
        mark: H1,
        prepend: "queue",
        attachTo: x,
        priority: -999
      });
      $[RS] = w, $.setAttribute(vx, a);
    }
  });
  return k;
}, uue = function(t, r, a) {
  var i = qe(t, 4), c = i[1], d = i[2], f = i[3], p = a || {}, g = p.plain;
  if (!c)
    return null;
  var b = -999, w = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(b)
  }, x = jk(c, f, d, w, g);
  return [b, d, x];
};
ge(ge(ge({}, rq, lue), BG, $se), aq, uue);
var bo = /* @__PURE__ */ (function() {
  function e(t, r) {
    Vi(this, e), ge(this, "name", void 0), ge(this, "style", void 0), ge(this, "_keyframe", !0), this.name = t, this.style = r;
  }
  return _i(e, [{
    key: "getName",
    value: function() {
      var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
      return r ? "".concat(r, "-").concat(this.name) : this.name;
    }
  }]), e;
})();
function E3(e) {
  return e.notSplit = !0, e;
}
E3(["borderTop", "borderBottom"]), E3(["borderTop"]), E3(["borderBottom"]), E3(["borderLeft", "borderRight"]), E3(["borderLeft"]), E3(["borderRight"]);
var Nz = /* @__PURE__ */ fp({});
function oq(e) {
  return jG(e) || NG(e) || kz(e) || IG();
}
function M0(e, t) {
  for (var r = e, a = 0; a < t.length; a += 1) {
    if (r == null)
      return;
    r = r[t[a]];
  }
  return r;
}
function iq(e, t, r, a) {
  if (!t.length)
    return r;
  var i = oq(t), c = i[0], d = i.slice(1), f;
  return !e && typeof c == "number" ? f = [] : Array.isArray(e) ? f = Et(e) : f = ce({}, e), a && r === void 0 && d.length === 1 ? delete f[c][d[0]] : f[c] = iq(f[c], d, r, a), f;
}
function $1(e, t, r) {
  var a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  return t.length && a && r === void 0 && !M0(e, t.slice(0, -1)) ? e : iq(e, t, r, a);
}
function cue(e) {
  return Hn(e) === "object" && e !== null && Object.getPrototypeOf(e) === Object.prototype;
}
function hH(e) {
  return Array.isArray(e) ? [] : {};
}
var due = typeof Reflect > "u" ? Object.keys : Reflect.ownKeys;
function K3() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  var a = hH(t[0]);
  return t.forEach(function(i) {
    function c(d, f) {
      var p = new Set(f), g = M0(i, d), b = Array.isArray(g);
      if (b || cue(g)) {
        if (!p.has(g)) {
          p.add(g);
          var w = M0(a, d);
          b ? a = $1(a, d, []) : (!w || Hn(w) !== "object") && (a = $1(a, d, hH(g))), due(g).forEach(function(x) {
            c([].concat(Et(d), [x]), p);
          });
        }
      } else
        a = $1(a, d, g);
    }
    c([]);
  }), a;
}
function lq() {
}
let Xw = null;
function fue() {
  Xw = null, wG();
}
let sq = lq;
process.env.NODE_ENV !== "production" && (sq = (e, t, r) => {
  $n(e, `[antd: ${t}] ${r}`), process.env.NODE_ENV === "test" && fue();
});
const nC = sq, uq = /* @__PURE__ */ S.createContext({}), To = process.env.NODE_ENV !== "production" ? (e) => {
  const {
    strict: t
  } = S.useContext(uq), r = (a, i, c) => {
    if (!a)
      if (t === !1 && i === "deprecated") {
        const d = Xw;
        Xw || (Xw = {}), Xw[e] = Xw[e] || [], Xw[e].includes(c || "") || Xw[e].push(c || ""), d || console.warn("[antd] There exists deprecated usage in your code:", Xw);
      } else
        process.env.NODE_ENV !== "production" && nC(a, e, c);
  };
  return r.deprecated = (a, i, c, d) => {
    r(a, "deprecated", `\`${i}\` is deprecated. Please use \`${c}\` instead.${d ? ` ${d}` : ""}`);
  }, r;
} : () => {
  const e = () => {
  };
  return e.deprecated = lq, e;
}, mue = /* @__PURE__ */ fp(void 0);
var cq = {
  // Options
  items_per_page: "/ page",
  jump_to: "Go to",
  jump_to_confirm: "confirm",
  page: "Page",
  // Pagination
  prev_page: "Previous Page",
  next_page: "Next Page",
  prev_5: "Previous 5 Pages",
  next_5: "Next 5 Pages",
  prev_3: "Previous 3 Pages",
  next_3: "Next 3 Pages",
  page_size: "Page Size"
}, hue = {
  yearFormat: "YYYY",
  dayFormat: "D",
  cellMeridiemFormat: "A",
  monthBeforeYear: !0
}, pue = ce(ce({}, hue), {}, {
  locale: "en_US",
  today: "Today",
  now: "Now",
  backToToday: "Back to today",
  ok: "OK",
  clear: "Clear",
  week: "Week",
  month: "Month",
  year: "Year",
  timeSelect: "select time",
  dateSelect: "select date",
  weekSelect: "Choose a week",
  monthSelect: "Choose a month",
  yearSelect: "Choose a year",
  decadeSelect: "Choose a decade",
  dateFormat: "M/D/YYYY",
  dateTimeFormat: "M/D/YYYY HH:mm:ss",
  previousMonth: "Previous month (PageUp)",
  nextMonth: "Next month (PageDown)",
  previousYear: "Last year (Control + left)",
  nextYear: "Next year (Control + right)",
  previousDecade: "Last decade",
  nextDecade: "Next decade",
  previousCentury: "Last century",
  nextCentury: "Next century"
});
const dq = {
  placeholder: "Select time",
  rangePlaceholder: ["Start time", "End time"]
}, Ik = {
  lang: Object.assign({
    placeholder: "Select date",
    yearPlaceholder: "Select year",
    quarterPlaceholder: "Select quarter",
    monthPlaceholder: "Select month",
    weekPlaceholder: "Select week",
    rangePlaceholder: ["Start date", "End date"],
    rangeYearPlaceholder: ["Start year", "End year"],
    rangeQuarterPlaceholder: ["Start quarter", "End quarter"],
    rangeMonthPlaceholder: ["Start month", "End month"],
    rangeWeekPlaceholder: ["Start week", "End week"]
  }, pue),
  timePickerLocale: Object.assign({}, dq)
}, S0 = "${label} is not a valid ${type}", vb = {
  locale: "en",
  Pagination: cq,
  DatePicker: Ik,
  TimePicker: dq,
  Calendar: Ik,
  global: {
    placeholder: "Please select",
    close: "Close"
  },
  Table: {
    filterTitle: "Filter menu",
    filterConfirm: "OK",
    filterReset: "Reset",
    filterEmptyText: "No filters",
    filterCheckAll: "Select all items",
    filterSearchPlaceholder: "Search in filters",
    emptyText: "No data",
    selectAll: "Select current page",
    selectInvert: "Invert current page",
    selectNone: "Clear all data",
    selectionAll: "Select all data",
    sortTitle: "Sort",
    expand: "Expand row",
    collapse: "Collapse row",
    triggerDesc: "Click to sort descending",
    triggerAsc: "Click to sort ascending",
    cancelSort: "Click to cancel sorting"
  },
  Tour: {
    Next: "Next",
    Previous: "Previous",
    Finish: "Finish"
  },
  Modal: {
    okText: "OK",
    cancelText: "Cancel",
    justOkText: "OK"
  },
  Popconfirm: {
    okText: "OK",
    cancelText: "Cancel"
  },
  Transfer: {
    titles: ["", ""],
    searchPlaceholder: "Search here",
    itemUnit: "item",
    itemsUnit: "items",
    remove: "Remove",
    selectCurrent: "Select current page",
    removeCurrent: "Remove current page",
    selectAll: "Select all data",
    deselectAll: "Deselect all data",
    removeAll: "Remove all data",
    selectInvert: "Invert current page"
  },
  Upload: {
    uploading: "Uploading...",
    removeFile: "Remove file",
    uploadError: "Upload error",
    previewFile: "Preview file",
    downloadFile: "Download file"
  },
  Empty: {
    description: "No data"
  },
  Icon: {
    icon: "icon"
  },
  Text: {
    edit: "Edit",
    copy: "Copy",
    copied: "Copied",
    expand: "Expand",
    collapse: "Collapse"
  },
  Form: {
    optional: "(optional)",
    defaultValidateMessages: {
      default: "Field validation error for ${label}",
      required: "Please enter ${label}",
      enum: "${label} must be one of [${enum}]",
      whitespace: "${label} cannot be a blank character",
      date: {
        format: "${label} date format is invalid",
        parse: "${label} cannot be converted to a date",
        invalid: "${label} is an invalid date"
      },
      types: {
        string: S0,
        method: S0,
        array: S0,
        object: S0,
        number: S0,
        date: S0,
        boolean: S0,
        integer: S0,
        float: S0,
        regexp: S0,
        email: S0,
        url: S0,
        hex: S0
      },
      string: {
        len: "${label} must be ${len} characters",
        min: "${label} must be at least ${min} characters",
        max: "${label} must be up to ${max} characters",
        range: "${label} must be between ${min}-${max} characters"
      },
      number: {
        len: "${label} must be equal to ${len}",
        min: "${label} must be minimum ${min}",
        max: "${label} must be maximum ${max}",
        range: "${label} must be between ${min}-${max}"
      },
      array: {
        len: "Must be ${len} ${label}",
        min: "At least ${min} ${label}",
        max: "At most ${max} ${label}",
        range: "The amount of ${label} must be between ${min}-${max}"
      },
      pattern: {
        mismatch: "${label} does not match the pattern ${pattern}"
      }
    }
  },
  Image: {
    preview: "Preview"
  },
  QRCode: {
    expired: "QR code expired",
    refresh: "Refresh",
    scanned: "Scanned"
  },
  ColorPicker: {
    presetEmpty: "Empty",
    transparent: "Transparent",
    singleColor: "Single",
    gradientColor: "Gradient"
  }
};
let ZP = Object.assign({}, vb.Modal), ek = [];
const pH = () => ek.reduce((e, t) => Object.assign(Object.assign({}, e), t), vb.Modal);
function gue(e) {
  if (e) {
    const t = Object.assign({}, e);
    return ek.push(t), ZP = pH(), () => {
      ek = ek.filter((r) => r !== t), ZP = pH();
    };
  }
  ZP = Object.assign({}, vb.Modal);
}
function fq() {
  return ZP;
}
const Dz = /* @__PURE__ */ fp(void 0), q1 = (e, t) => {
  const r = S.useContext(Dz), a = S.useMemo(() => {
    var c;
    const d = t || vb[e], f = (c = r?.[e]) !== null && c !== void 0 ? c : {};
    return Object.assign(Object.assign({}, typeof d == "function" ? d() : d), f || {});
  }, [e, t, r]), i = S.useMemo(() => {
    const c = r?.locale;
    return r?.exist && !c ? vb.locale : c;
  }, [r]);
  return [a, i];
}, mq = "internalMark", hq = (e) => {
  const {
    locale: t = {},
    children: r,
    _ANT_MARK__: a
  } = e;
  if (process.env.NODE_ENV !== "production") {
    const c = To("LocaleProvider");
    process.env.NODE_ENV !== "production" && c(a === mq, "deprecated", "`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead: http://u.ant.design/locale");
  }
  S.useEffect(() => gue(t?.Modal), [t]);
  const i = S.useMemo(() => Object.assign(Object.assign({}, t), {
    exist: !0
  }), [t]);
  return /* @__PURE__ */ S.createElement(Dz.Provider, {
    value: i
  }, r);
};
process.env.NODE_ENV !== "production" && (hq.displayName = "LocaleProvider");
const pq = {
  blue: "#1677FF",
  purple: "#722ED1",
  cyan: "#13C2C2",
  green: "#52C41A",
  magenta: "#EB2F96",
  /**
   * @deprecated Use magenta instead
   */
  pink: "#EB2F96",
  red: "#F5222D",
  orange: "#FA8C16",
  yellow: "#FADB14",
  volcano: "#FA541C",
  geekblue: "#2F54EB",
  gold: "#FAAD14",
  lime: "#A0D911"
}, OE = Object.assign(Object.assign({}, pq), {
  // Color
  colorPrimary: "#1677ff",
  colorSuccess: "#52c41a",
  colorWarning: "#faad14",
  colorError: "#ff4d4f",
  colorInfo: "#1677ff",
  colorLink: "",
  colorTextBase: "",
  colorBgBase: "",
  // Font
  fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
'Noto Color Emoji'`,
  fontFamilyCode: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  fontSize: 14,
  // Line
  lineWidth: 1,
  lineType: "solid",
  // Motion
  motionUnit: 0.1,
  motionBase: 0,
  motionEaseOutCirc: "cubic-bezier(0.08, 0.82, 0.17, 1)",
  motionEaseInOutCirc: "cubic-bezier(0.78, 0.14, 0.15, 0.86)",
  motionEaseOut: "cubic-bezier(0.215, 0.61, 0.355, 1)",
  motionEaseInOut: "cubic-bezier(0.645, 0.045, 0.355, 1)",
  motionEaseOutBack: "cubic-bezier(0.12, 0.4, 0.29, 1.46)",
  motionEaseInBack: "cubic-bezier(0.71, -0.46, 0.88, 0.6)",
  motionEaseInQuint: "cubic-bezier(0.755, 0.05, 0.855, 0.06)",
  motionEaseOutQuint: "cubic-bezier(0.23, 1, 0.32, 1)",
  // Radius
  borderRadius: 6,
  // Size
  sizeUnit: 4,
  sizeStep: 4,
  sizePopupArrow: 16,
  // Control Base
  controlHeight: 32,
  // zIndex
  zIndexBase: 0,
  zIndexPopupBase: 1e3,
  // Image
  opacityImage: 1,
  // Wireframe
  wireframe: !1,
  // Motion
  motion: !0
}), fd = Math.round;
function LT(e, t) {
  const r = e.replace(/^[^(]*\((.*)/, "$1").replace(/\).*/, "").match(/\d*\.?\d+%?/g) || [], a = r.map((i) => parseFloat(i));
  for (let i = 0; i < 3; i += 1)
    a[i] = t(a[i] || 0, r[i] || "", i);
  return r[3] ? a[3] = r[3].includes("%") ? a[3] / 100 : a[3] : a[3] = 1, a;
}
const gH = (e, t, r) => r === 0 ? e : e / 100;
function x5(e, t) {
  const r = t || 255;
  return e > r ? r : e < 0 ? 0 : e;
}
class ro {
  constructor(t) {
    ge(this, "isValid", !0), ge(this, "r", 0), ge(this, "g", 0), ge(this, "b", 0), ge(this, "a", 1), ge(this, "_h", void 0), ge(this, "_s", void 0), ge(this, "_l", void 0), ge(this, "_v", void 0), ge(this, "_max", void 0), ge(this, "_min", void 0), ge(this, "_brightness", void 0);
    function r(a) {
      return a[0] in t && a[1] in t && a[2] in t;
    }
    if (t) if (typeof t == "string") {
      let i = function(c) {
        return a.startsWith(c);
      };
      const a = t.trim();
      /^#?[A-F\d]{3,8}$/i.test(a) ? this.fromHexString(a) : i("rgb") ? this.fromRgbString(a) : i("hsl") ? this.fromHslString(a) : (i("hsv") || i("hsb")) && this.fromHsvString(a);
    } else if (t instanceof ro)
      this.r = t.r, this.g = t.g, this.b = t.b, this.a = t.a, this._h = t._h, this._s = t._s, this._l = t._l, this._v = t._v;
    else if (r("rgb"))
      this.r = x5(t.r), this.g = x5(t.g), this.b = x5(t.b), this.a = typeof t.a == "number" ? x5(t.a, 1) : 1;
    else if (r("hsl"))
      this.fromHsl(t);
    else if (r("hsv"))
      this.fromHsv(t);
    else
      throw new Error("@ant-design/fast-color: unsupported input " + JSON.stringify(t));
  }
  // ======================= Setter =======================
  setR(t) {
    return this._sc("r", t);
  }
  setG(t) {
    return this._sc("g", t);
  }
  setB(t) {
    return this._sc("b", t);
  }
  setA(t) {
    return this._sc("a", t, 1);
  }
  setHue(t) {
    const r = this.toHsv();
    return r.h = t, this._c(r);
  }
  // ======================= Getter =======================
  /**
   * Returns the perceived luminance of a color, from 0-1.
   * @see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
   */
  getLuminance() {
    function t(c) {
      const d = c / 255;
      return d <= 0.03928 ? d / 12.92 : Math.pow((d + 0.055) / 1.055, 2.4);
    }
    const r = t(this.r), a = t(this.g), i = t(this.b);
    return 0.2126 * r + 0.7152 * a + 0.0722 * i;
  }
  getHue() {
    if (typeof this._h > "u") {
      const t = this.getMax() - this.getMin();
      t === 0 ? this._h = 0 : this._h = fd(60 * (this.r === this.getMax() ? (this.g - this.b) / t + (this.g < this.b ? 6 : 0) : this.g === this.getMax() ? (this.b - this.r) / t + 2 : (this.r - this.g) / t + 4));
    }
    return this._h;
  }
  getSaturation() {
    if (typeof this._s > "u") {
      const t = this.getMax() - this.getMin();
      t === 0 ? this._s = 0 : this._s = t / this.getMax();
    }
    return this._s;
  }
  getLightness() {
    return typeof this._l > "u" && (this._l = (this.getMax() + this.getMin()) / 510), this._l;
  }
  getValue() {
    return typeof this._v > "u" && (this._v = this.getMax() / 255), this._v;
  }
  /**
   * Returns the perceived brightness of the color, from 0-255.
   * Note: this is not the b of HSB
   * @see http://www.w3.org/TR/AERT#color-contrast
   */
  getBrightness() {
    return typeof this._brightness > "u" && (this._brightness = (this.r * 299 + this.g * 587 + this.b * 114) / 1e3), this._brightness;
  }
  // ======================== Func ========================
  darken(t = 10) {
    const r = this.getHue(), a = this.getSaturation();
    let i = this.getLightness() - t / 100;
    return i < 0 && (i = 0), this._c({
      h: r,
      s: a,
      l: i,
      a: this.a
    });
  }
  lighten(t = 10) {
    const r = this.getHue(), a = this.getSaturation();
    let i = this.getLightness() + t / 100;
    return i > 1 && (i = 1), this._c({
      h: r,
      s: a,
      l: i,
      a: this.a
    });
  }
  /**
   * Mix the current color a given amount with another color, from 0 to 100.
   * 0 means no mixing (return current color).
   */
  mix(t, r = 50) {
    const a = this._c(t), i = r / 100, c = (f) => (a[f] - this[f]) * i + this[f], d = {
      r: fd(c("r")),
      g: fd(c("g")),
      b: fd(c("b")),
      a: fd(c("a") * 100) / 100
    };
    return this._c(d);
  }
  /**
   * Mix the color with pure white, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return white.
   */
  tint(t = 10) {
    return this.mix({
      r: 255,
      g: 255,
      b: 255,
      a: 1
    }, t);
  }
  /**
   * Mix the color with pure black, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return black.
   */
  shade(t = 10) {
    return this.mix({
      r: 0,
      g: 0,
      b: 0,
      a: 1
    }, t);
  }
  onBackground(t) {
    const r = this._c(t), a = this.a + r.a * (1 - this.a), i = (c) => fd((this[c] * this.a + r[c] * r.a * (1 - this.a)) / a);
    return this._c({
      r: i("r"),
      g: i("g"),
      b: i("b"),
      a
    });
  }
  // ======================= Status =======================
  isDark() {
    return this.getBrightness() < 128;
  }
  isLight() {
    return this.getBrightness() >= 128;
  }
  // ======================== MISC ========================
  equals(t) {
    return this.r === t.r && this.g === t.g && this.b === t.b && this.a === t.a;
  }
  clone() {
    return this._c(this);
  }
  // ======================= Format =======================
  toHexString() {
    let t = "#";
    const r = (this.r || 0).toString(16);
    t += r.length === 2 ? r : "0" + r;
    const a = (this.g || 0).toString(16);
    t += a.length === 2 ? a : "0" + a;
    const i = (this.b || 0).toString(16);
    if (t += i.length === 2 ? i : "0" + i, typeof this.a == "number" && this.a >= 0 && this.a < 1) {
      const c = fd(this.a * 255).toString(16);
      t += c.length === 2 ? c : "0" + c;
    }
    return t;
  }
  /** CSS support color pattern */
  toHsl() {
    return {
      h: this.getHue(),
      s: this.getSaturation(),
      l: this.getLightness(),
      a: this.a
    };
  }
  /** CSS support color pattern */
  toHslString() {
    const t = this.getHue(), r = fd(this.getSaturation() * 100), a = fd(this.getLightness() * 100);
    return this.a !== 1 ? `hsla(${t},${r}%,${a}%,${this.a})` : `hsl(${t},${r}%,${a}%)`;
  }
  /** Same as toHsb */
  toHsv() {
    return {
      h: this.getHue(),
      s: this.getSaturation(),
      v: this.getValue(),
      a: this.a
    };
  }
  toRgb() {
    return {
      r: this.r,
      g: this.g,
      b: this.b,
      a: this.a
    };
  }
  toRgbString() {
    return this.a !== 1 ? `rgba(${this.r},${this.g},${this.b},${this.a})` : `rgb(${this.r},${this.g},${this.b})`;
  }
  toString() {
    return this.toRgbString();
  }
  // ====================== Privates ======================
  /** Return a new FastColor object with one channel changed */
  _sc(t, r, a) {
    const i = this.clone();
    return i[t] = x5(r, a), i;
  }
  _c(t) {
    return new this.constructor(t);
  }
  getMax() {
    return typeof this._max > "u" && (this._max = Math.max(this.r, this.g, this.b)), this._max;
  }
  getMin() {
    return typeof this._min > "u" && (this._min = Math.min(this.r, this.g, this.b)), this._min;
  }
  fromHexString(t) {
    const r = t.replace("#", "");
    function a(i, c) {
      return parseInt(r[i] + r[c || i], 16);
    }
    r.length < 6 ? (this.r = a(0), this.g = a(1), this.b = a(2), this.a = r[3] ? a(3) / 255 : 1) : (this.r = a(0, 1), this.g = a(2, 3), this.b = a(4, 5), this.a = r[6] ? a(6, 7) / 255 : 1);
  }
  fromHsl({
    h: t,
    s: r,
    l: a,
    a: i
  }) {
    if (this._h = t % 360, this._s = r, this._l = a, this.a = typeof i == "number" ? i : 1, r <= 0) {
      const x = fd(a * 255);
      this.r = x, this.g = x, this.b = x;
    }
    let c = 0, d = 0, f = 0;
    const p = t / 60, g = (1 - Math.abs(2 * a - 1)) * r, b = g * (1 - Math.abs(p % 2 - 1));
    p >= 0 && p < 1 ? (c = g, d = b) : p >= 1 && p < 2 ? (c = b, d = g) : p >= 2 && p < 3 ? (d = g, f = b) : p >= 3 && p < 4 ? (d = b, f = g) : p >= 4 && p < 5 ? (c = b, f = g) : p >= 5 && p < 6 && (c = g, f = b);
    const w = a - g / 2;
    this.r = fd((c + w) * 255), this.g = fd((d + w) * 255), this.b = fd((f + w) * 255);
  }
  fromHsv({
    h: t,
    s: r,
    v: a,
    a: i
  }) {
    this._h = t % 360, this._s = r, this._v = a, this.a = typeof i == "number" ? i : 1;
    const c = fd(a * 255);
    if (this.r = c, this.g = c, this.b = c, r <= 0)
      return;
    const d = t / 60, f = Math.floor(d), p = d - f, g = fd(a * (1 - r) * 255), b = fd(a * (1 - r * p) * 255), w = fd(a * (1 - r * (1 - p)) * 255);
    switch (f) {
      case 0:
        this.g = w, this.b = g;
        break;
      case 1:
        this.r = b, this.b = g;
        break;
      case 2:
        this.r = g, this.b = w;
        break;
      case 3:
        this.r = g, this.g = b;
        break;
      case 4:
        this.r = w, this.g = g;
        break;
      case 5:
      default:
        this.g = g, this.b = b;
        break;
    }
  }
  fromHsvString(t) {
    const r = LT(t, gH);
    this.fromHsv({
      h: r[0],
      s: r[1],
      v: r[2],
      a: r[3]
    });
  }
  fromHslString(t) {
    const r = LT(t, gH);
    this.fromHsl({
      h: r[0],
      s: r[1],
      l: r[2],
      a: r[3]
    });
  }
  fromRgbString(t) {
    const r = LT(t, (a, i) => (
      // Convert percentage to number. e.g. 50% -> 128
      i.includes("%") ? fd(a / 100 * 255) : a
    ));
    this.r = r[0], this.g = r[1], this.b = r[2], this.a = r[3];
  }
}
var z7 = 2, vH = 0.16, vue = 0.05, bue = 0.05, yue = 0.15, gq = 5, vq = 4, wue = [{
  index: 7,
  amount: 15
}, {
  index: 6,
  amount: 25
}, {
  index: 5,
  amount: 30
}, {
  index: 5,
  amount: 45
}, {
  index: 5,
  amount: 65
}, {
  index: 5,
  amount: 85
}, {
  index: 4,
  amount: 90
}, {
  index: 3,
  amount: 95
}, {
  index: 2,
  amount: 97
}, {
  index: 1,
  amount: 98
}];
function bH(e, t, r) {
  var a;
  return Math.round(e.h) >= 60 && Math.round(e.h) <= 240 ? a = r ? Math.round(e.h) - z7 * t : Math.round(e.h) + z7 * t : a = r ? Math.round(e.h) + z7 * t : Math.round(e.h) - z7 * t, a < 0 ? a += 360 : a >= 360 && (a -= 360), a;
}
function yH(e, t, r) {
  if (e.h === 0 && e.s === 0)
    return e.s;
  var a;
  return r ? a = e.s - vH * t : t === vq ? a = e.s + vH : a = e.s + vue * t, a > 1 && (a = 1), r && t === gq && a > 0.1 && (a = 0.1), a < 0.06 && (a = 0.06), Math.round(a * 100) / 100;
}
function wH(e, t, r) {
  var a;
  return r ? a = e.v + bue * t : a = e.v - yue * t, a = Math.max(0, Math.min(1, a)), Math.round(a * 100) / 100;
}
function TE(e) {
  for (var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = [], a = new ro(e), i = a.toHsv(), c = gq; c > 0; c -= 1) {
    var d = new ro({
      h: bH(i, c, !0),
      s: yH(i, c, !0),
      v: wH(i, c, !0)
    });
    r.push(d);
  }
  r.push(a);
  for (var f = 1; f <= vq; f += 1) {
    var p = new ro({
      h: bH(i, f),
      s: yH(i, f),
      v: wH(i, f)
    });
    r.push(p);
  }
  return t.theme === "dark" ? wue.map(function(g) {
    var b = g.index, w = g.amount;
    return new ro(t.backgroundColor || "#141414").mix(r[b], w).toHexString();
  }) : r.map(function(g) {
    return g.toHexString();
  });
}
var tx = {
  red: "#F5222D",
  volcano: "#FA541C",
  orange: "#FA8C16",
  gold: "#FAAD14",
  yellow: "#FADB14",
  lime: "#A0D911",
  green: "#52C41A",
  cyan: "#13C2C2",
  blue: "#1677FF",
  geekblue: "#2F54EB",
  purple: "#722ED1",
  magenta: "#EB2F96",
  grey: "#666666"
}, VN = ["#fff1f0", "#ffccc7", "#ffa39e", "#ff7875", "#ff4d4f", "#f5222d", "#cf1322", "#a8071a", "#820014", "#5c0011"];
VN.primary = VN[5];
var _N = ["#fff2e8", "#ffd8bf", "#ffbb96", "#ff9c6e", "#ff7a45", "#fa541c", "#d4380d", "#ad2102", "#871400", "#610b00"];
_N.primary = _N[5];
var BN = ["#fff7e6", "#ffe7ba", "#ffd591", "#ffc069", "#ffa940", "#fa8c16", "#d46b08", "#ad4e00", "#873800", "#612500"];
BN.primary = BN[5];
var UN = ["#fffbe6", "#fff1b8", "#ffe58f", "#ffd666", "#ffc53d", "#faad14", "#d48806", "#ad6800", "#874d00", "#613400"];
UN.primary = UN[5];
var XN = ["#feffe6", "#ffffb8", "#fffb8f", "#fff566", "#ffec3d", "#fadb14", "#d4b106", "#ad8b00", "#876800", "#614700"];
XN.primary = XN[5];
var GN = ["#fcffe6", "#f4ffb8", "#eaff8f", "#d3f261", "#bae637", "#a0d911", "#7cb305", "#5b8c00", "#3f6600", "#254000"];
GN.primary = GN[5];
var qN = ["#f6ffed", "#d9f7be", "#b7eb8f", "#95de64", "#73d13d", "#52c41a", "#389e0d", "#237804", "#135200", "#092b00"];
qN.primary = qN[5];
var KN = ["#e6fffb", "#b5f5ec", "#87e8de", "#5cdbd3", "#36cfc9", "#13c2c2", "#08979c", "#006d75", "#00474f", "#002329"];
KN.primary = KN[5];
var wx = ["#e6f4ff", "#bae0ff", "#91caff", "#69b1ff", "#4096ff", "#1677ff", "#0958d9", "#003eb3", "#002c8c", "#001d66"];
wx.primary = wx[5];
var YN = ["#f0f5ff", "#d6e4ff", "#adc6ff", "#85a5ff", "#597ef7", "#2f54eb", "#1d39c4", "#10239e", "#061178", "#030852"];
YN.primary = YN[5];
var QN = ["#f9f0ff", "#efdbff", "#d3adf7", "#b37feb", "#9254de", "#722ed1", "#531dab", "#391085", "#22075e", "#120338"];
QN.primary = QN[5];
var JN = ["#fff0f6", "#ffd6e7", "#ffadd2", "#ff85c0", "#f759ab", "#eb2f96", "#c41d7f", "#9e1068", "#780650", "#520339"];
JN.primary = JN[5];
var ZN = ["#a6a6a6", "#999999", "#8c8c8c", "#808080", "#737373", "#666666", "#404040", "#1a1a1a", "#000000", "#000000"];
ZN.primary = ZN[5];
var HT = {
  red: VN,
  volcano: _N,
  orange: BN,
  gold: UN,
  yellow: XN,
  lime: GN,
  green: qN,
  cyan: KN,
  blue: wx,
  geekblue: YN,
  purple: QN,
  magenta: JN,
  grey: ZN
};
function Sue(e, {
  generateColorPalettes: t,
  generateNeutralColorPalettes: r
}) {
  const {
    colorSuccess: a,
    colorWarning: i,
    colorError: c,
    colorInfo: d,
    colorPrimary: f,
    colorBgBase: p,
    colorTextBase: g
  } = e, b = t(f), w = t(a), x = t(i), E = t(c), P = t(d), k = r(p, g), M = e.colorLink || e.colorInfo, T = t(M), N = new ro(E[1]).mix(new ro(E[3]), 50).toHexString();
  return Object.assign(Object.assign({}, k), {
    colorPrimaryBg: b[1],
    colorPrimaryBgHover: b[2],
    colorPrimaryBorder: b[3],
    colorPrimaryBorderHover: b[4],
    colorPrimaryHover: b[5],
    colorPrimary: b[6],
    colorPrimaryActive: b[7],
    colorPrimaryTextHover: b[8],
    colorPrimaryText: b[9],
    colorPrimaryTextActive: b[10],
    colorSuccessBg: w[1],
    colorSuccessBgHover: w[2],
    colorSuccessBorder: w[3],
    colorSuccessBorderHover: w[4],
    colorSuccessHover: w[4],
    colorSuccess: w[6],
    colorSuccessActive: w[7],
    colorSuccessTextHover: w[8],
    colorSuccessText: w[9],
    colorSuccessTextActive: w[10],
    colorErrorBg: E[1],
    colorErrorBgHover: E[2],
    colorErrorBgFilledHover: N,
    colorErrorBgActive: E[3],
    colorErrorBorder: E[3],
    colorErrorBorderHover: E[4],
    colorErrorHover: E[5],
    colorError: E[6],
    colorErrorActive: E[7],
    colorErrorTextHover: E[8],
    colorErrorText: E[9],
    colorErrorTextActive: E[10],
    colorWarningBg: x[1],
    colorWarningBgHover: x[2],
    colorWarningBorder: x[3],
    colorWarningBorderHover: x[4],
    colorWarningHover: x[4],
    colorWarning: x[6],
    colorWarningActive: x[7],
    colorWarningTextHover: x[8],
    colorWarningText: x[9],
    colorWarningTextActive: x[10],
    colorInfoBg: P[1],
    colorInfoBgHover: P[2],
    colorInfoBorder: P[3],
    colorInfoBorderHover: P[4],
    colorInfoHover: P[4],
    colorInfo: P[6],
    colorInfoActive: P[7],
    colorInfoTextHover: P[8],
    colorInfoText: P[9],
    colorInfoTextActive: P[10],
    colorLinkHover: T[4],
    colorLink: T[6],
    colorLinkActive: T[7],
    colorBgMask: new ro("#000").setA(0.45).toRgbString(),
    colorWhite: "#fff"
  });
}
const Cue = (e) => {
  let t = e, r = e, a = e, i = e;
  return e < 6 && e >= 5 ? t = e + 1 : e < 16 && e >= 6 ? t = e + 2 : e >= 16 && (t = 16), e < 7 && e >= 5 ? r = 4 : e < 8 && e >= 7 ? r = 5 : e < 14 && e >= 8 ? r = 6 : e < 16 && e >= 14 ? r = 7 : e >= 16 && (r = 8), e < 6 && e >= 2 ? a = 1 : e >= 6 && (a = 2), e > 4 && e < 8 ? i = 4 : e >= 8 && (i = 6), {
    borderRadius: e,
    borderRadiusXS: a,
    borderRadiusSM: r,
    borderRadiusLG: t,
    borderRadiusOuter: i
  };
};
function xue(e) {
  const {
    motionUnit: t,
    motionBase: r,
    borderRadius: a,
    lineWidth: i
  } = e;
  return Object.assign({
    // motion
    motionDurationFast: `${(r + t).toFixed(1)}s`,
    motionDurationMid: `${(r + t * 2).toFixed(1)}s`,
    motionDurationSlow: `${(r + t * 3).toFixed(1)}s`,
    // line
    lineWidthBold: i + 1
  }, Cue(a));
}
const Eue = (e) => {
  const {
    controlHeight: t
  } = e;
  return {
    controlHeightSM: t * 0.75,
    controlHeightXS: t * 0.5,
    controlHeightLG: t * 1.25
  };
};
function tk(e) {
  return (e + 8) / e;
}
function Pue(e) {
  const t = Array.from({
    length: 10
  }).map((r, a) => {
    const i = a - 1, c = e * Math.pow(Math.E, i / 5), d = a > 1 ? Math.floor(c) : Math.ceil(c);
    return Math.floor(d / 2) * 2;
  });
  return t[1] = e, t.map((r) => ({
    size: r,
    lineHeight: tk(r)
  }));
}
const kue = (e) => {
  const t = Pue(e), r = t.map((b) => b.size), a = t.map((b) => b.lineHeight), i = r[1], c = r[0], d = r[2], f = a[1], p = a[0], g = a[2];
  return {
    fontSizeSM: c,
    fontSize: i,
    fontSizeLG: d,
    fontSizeXL: r[3],
    fontSizeHeading1: r[6],
    fontSizeHeading2: r[5],
    fontSizeHeading3: r[4],
    fontSizeHeading4: r[3],
    fontSizeHeading5: r[2],
    lineHeight: f,
    lineHeightLG: g,
    lineHeightSM: p,
    fontHeight: Math.round(f * i),
    fontHeightLG: Math.round(g * d),
    fontHeightSM: Math.round(p * c),
    lineHeightHeading1: a[6],
    lineHeightHeading2: a[5],
    lineHeightHeading3: a[4],
    lineHeightHeading4: a[3],
    lineHeightHeading5: a[2]
  };
};
function Mue(e) {
  const {
    sizeUnit: t,
    sizeStep: r
  } = e;
  return {
    sizeXXL: t * (r + 8),
    // 48
    sizeXL: t * (r + 4),
    // 32
    sizeLG: t * (r + 2),
    // 24
    sizeMD: t * (r + 1),
    // 20
    sizeMS: t * r,
    // 16
    size: t * r,
    // 16
    sizeSM: t * (r - 1),
    // 12
    sizeXS: t * (r - 2),
    // 8
    sizeXXS: t * (r - 3)
    // 4
  };
}
const j0 = (e, t) => new ro(e).setA(t).toRgbString(), E5 = (e, t) => new ro(e).darken(t).toHexString(), Oue = (e) => {
  const t = TE(e);
  return {
    1: t[0],
    2: t[1],
    3: t[2],
    4: t[3],
    5: t[4],
    6: t[5],
    7: t[6],
    8: t[4],
    9: t[5],
    10: t[6]
    // 8: colors[7],
    // 9: colors[8],
    // 10: colors[9],
  };
}, Tue = (e, t) => {
  const r = e || "#fff", a = t || "#000";
  return {
    colorBgBase: r,
    colorTextBase: a,
    colorText: j0(a, 0.88),
    colorTextSecondary: j0(a, 0.65),
    colorTextTertiary: j0(a, 0.45),
    colorTextQuaternary: j0(a, 0.25),
    colorFill: j0(a, 0.15),
    colorFillSecondary: j0(a, 0.06),
    colorFillTertiary: j0(a, 0.04),
    colorFillQuaternary: j0(a, 0.02),
    colorBgSolid: j0(a, 1),
    colorBgSolidHover: j0(a, 0.75),
    colorBgSolidActive: j0(a, 0.95),
    colorBgLayout: E5(r, 4),
    colorBgContainer: E5(r, 0),
    colorBgElevated: E5(r, 0),
    colorBgSpotlight: j0(a, 0.85),
    colorBgBlur: "transparent",
    colorBorder: E5(r, 15),
    colorBorderSecondary: E5(r, 6)
  };
};
function Rue(e) {
  tx.pink = tx.magenta, HT.pink = HT.magenta;
  const t = Object.keys(pq).map((r) => {
    const a = e[r] === tx[r] ? HT[r] : TE(e[r]);
    return Array.from({
      length: 10
    }, () => 1).reduce((i, c, d) => (i[`${r}-${d + 1}`] = a[d], i[`${r}${d + 1}`] = a[d], i), {});
  }).reduce((r, a) => (r = Object.assign(Object.assign({}, r), a), r), {});
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, e), t), Sue(e, {
    generateColorPalettes: Oue,
    generateNeutralColorPalettes: Tue
  })), kue(e.fontSize)), Mue(e)), Eue(e)), xue(e));
}
const bq = zN(Rue), eD = {
  token: OE,
  override: {
    override: OE
  },
  hashed: !0
}, yq = /* @__PURE__ */ Re.createContext(eD), RE = "ant", $9 = "anticon", Aue = ["outlined", "borderless", "filled", "underlined"], Nue = (e, t) => t || (e ? `${RE}-${e}` : RE), Qr = /* @__PURE__ */ S.createContext({
  // We provide a default function for Context without provider
  getPrefixCls: Nue,
  iconPrefixCls: $9
}), {
  Consumer: _Ot
} = Qr, SH = {};
function om(e) {
  const t = S.useContext(Qr), {
    getPrefixCls: r,
    direction: a,
    getPopupContainer: i
  } = t, c = t[e];
  return Object.assign(Object.assign({
    classNames: SH,
    styles: SH
  }, c), {
    getPrefixCls: r,
    direction: a,
    getPopupContainer: i
  });
}
const Due = `-ant-${Date.now()}-${Math.random()}`;
function $ue(e, t) {
  const r = {}, a = (d, f) => {
    let p = d.clone();
    return p = f?.(p) || p, p.toRgbString();
  }, i = (d, f) => {
    const p = new ro(d), g = TE(p.toRgbString());
    r[`${f}-color`] = a(p), r[`${f}-color-disabled`] = g[1], r[`${f}-color-hover`] = g[4], r[`${f}-color-active`] = g[6], r[`${f}-color-outline`] = p.clone().setA(0.2).toRgbString(), r[`${f}-color-deprecated-bg`] = g[0], r[`${f}-color-deprecated-border`] = g[2];
  };
  if (t.primaryColor) {
    i(t.primaryColor, "primary");
    const d = new ro(t.primaryColor), f = TE(d.toRgbString());
    f.forEach((g, b) => {
      r[`primary-${b + 1}`] = g;
    }), r["primary-color-deprecated-l-35"] = a(d, (g) => g.lighten(35)), r["primary-color-deprecated-l-20"] = a(d, (g) => g.lighten(20)), r["primary-color-deprecated-t-20"] = a(d, (g) => g.tint(20)), r["primary-color-deprecated-t-50"] = a(d, (g) => g.tint(50)), r["primary-color-deprecated-f-12"] = a(d, (g) => g.setA(g.a * 0.12));
    const p = new ro(f[0]);
    r["primary-color-active-deprecated-f-30"] = a(p, (g) => g.setA(g.a * 0.3)), r["primary-color-active-deprecated-d-02"] = a(p, (g) => g.darken(2));
  }
  return t.successColor && i(t.successColor, "success"), t.warningColor && i(t.warningColor, "warning"), t.errorColor && i(t.errorColor, "error"), t.infoColor && i(t.infoColor, "info"), `
  :root {
    ${Object.keys(r).map((d) => `--${e}-${d}: ${r[d]};`).join(`
`)}
  }
  `.trim();
}
function zue(e, t) {
  const r = $ue(e, t);
  Ju() ? oS(r, `${Due}-dynamic-theme`) : process.env.NODE_ENV !== "production" && nC(!1, "ConfigProvider", "SSR do not support dynamic theme with css variables.");
}
const A0 = /* @__PURE__ */ S.createContext(!1), wq = ({
  children: e,
  disabled: t
}) => {
  const r = S.useContext(A0);
  return /* @__PURE__ */ S.createElement(A0.Provider, {
    value: t ?? r
  }, e);
}, Sx = /* @__PURE__ */ S.createContext(void 0), jue = ({
  children: e,
  size: t
}) => {
  const r = S.useContext(Sx);
  return /* @__PURE__ */ S.createElement(Sx.Provider, {
    value: t || r
  }, e);
};
function Iue() {
  const e = Do(A0), t = Do(Sx);
  return {
    componentDisabled: e,
    componentSize: t
  };
}
var Sq = /* @__PURE__ */ _i(function e() {
  Vi(this, e);
}), Cq = "CALC_UNIT", Lue = new RegExp(Cq, "g");
function FT(e) {
  return typeof e == "number" ? "".concat(e).concat(Cq) : e;
}
var Hue = /* @__PURE__ */ (function(e) {
  pd(r, e);
  var t = B0(r);
  function r(a, i) {
    var c;
    Vi(this, r), c = t.call(this), ge(bn(c), "result", ""), ge(bn(c), "unitlessCssVar", void 0), ge(bn(c), "lowPriority", void 0);
    var d = Hn(a);
    return c.unitlessCssVar = i, a instanceof r ? c.result = "(".concat(a.result, ")") : d === "number" ? c.result = FT(a) : d === "string" && (c.result = a), c;
  }
  return _i(r, [{
    key: "add",
    value: function(i) {
      return i instanceof r ? this.result = "".concat(this.result, " + ").concat(i.getResult()) : (typeof i == "number" || typeof i == "string") && (this.result = "".concat(this.result, " + ").concat(FT(i))), this.lowPriority = !0, this;
    }
  }, {
    key: "sub",
    value: function(i) {
      return i instanceof r ? this.result = "".concat(this.result, " - ").concat(i.getResult()) : (typeof i == "number" || typeof i == "string") && (this.result = "".concat(this.result, " - ").concat(FT(i))), this.lowPriority = !0, this;
    }
  }, {
    key: "mul",
    value: function(i) {
      return this.lowPriority && (this.result = "(".concat(this.result, ")")), i instanceof r ? this.result = "".concat(this.result, " * ").concat(i.getResult(!0)) : (typeof i == "number" || typeof i == "string") && (this.result = "".concat(this.result, " * ").concat(i)), this.lowPriority = !1, this;
    }
  }, {
    key: "div",
    value: function(i) {
      return this.lowPriority && (this.result = "(".concat(this.result, ")")), i instanceof r ? this.result = "".concat(this.result, " / ").concat(i.getResult(!0)) : (typeof i == "number" || typeof i == "string") && (this.result = "".concat(this.result, " / ").concat(i)), this.lowPriority = !1, this;
    }
  }, {
    key: "getResult",
    value: function(i) {
      return this.lowPriority || i ? "(".concat(this.result, ")") : this.result;
    }
  }, {
    key: "equal",
    value: function(i) {
      var c = this, d = i || {}, f = d.unit, p = !0;
      return typeof f == "boolean" ? p = f : Array.from(this.unitlessCssVar).some(function(g) {
        return c.result.includes(g);
      }) && (p = !1), this.result = this.result.replace(Lue, p ? "px" : ""), typeof this.lowPriority < "u" ? "calc(".concat(this.result, ")") : this.result;
    }
  }]), r;
})(Sq), Fue = /* @__PURE__ */ (function(e) {
  pd(r, e);
  var t = B0(r);
  function r(a) {
    var i;
    return Vi(this, r), i = t.call(this), ge(bn(i), "result", 0), a instanceof r ? i.result = a.result : typeof a == "number" && (i.result = a), i;
  }
  return _i(r, [{
    key: "add",
    value: function(i) {
      return i instanceof r ? this.result += i.result : typeof i == "number" && (this.result += i), this;
    }
  }, {
    key: "sub",
    value: function(i) {
      return i instanceof r ? this.result -= i.result : typeof i == "number" && (this.result -= i), this;
    }
  }, {
    key: "mul",
    value: function(i) {
      return i instanceof r ? this.result *= i.result : typeof i == "number" && (this.result *= i), this;
    }
  }, {
    key: "div",
    value: function(i) {
      return i instanceof r ? this.result /= i.result : typeof i == "number" && (this.result /= i), this;
    }
  }, {
    key: "equal",
    value: function() {
      return this.result;
    }
  }]), r;
})(Sq), Wue = function(t, r) {
  var a = t === "css" ? Hue : Fue;
  return function(i) {
    return new a(i, r);
  };
}, CH = function(t, r) {
  return "".concat([r, t.replace(/([A-Z]+)([A-Z][a-z]+)/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2")].filter(Boolean).join("-"));
};
function ra(e) {
  var t = S.useRef();
  t.current = e;
  var r = S.useCallback(function() {
    for (var a, i = arguments.length, c = new Array(i), d = 0; d < i; d++)
      c[d] = arguments[d];
    return (a = t.current) === null || a === void 0 ? void 0 : a.call.apply(a, [t].concat(c));
  }, []);
  return r;
}
function Cx(e) {
  var t = S.useRef(!1), r = S.useState(e), a = qe(r, 2), i = a[0], c = a[1];
  S.useEffect(function() {
    return t.current = !1, function() {
      t.current = !0;
    };
  }, []);
  function d(f, p) {
    p && t.current || c(f);
  }
  return [i, d];
}
function WT(e) {
  return e !== void 0;
}
function ll(e, t) {
  var r = t || {}, a = r.defaultValue, i = r.value, c = r.onChange, d = r.postState, f = Cx(function() {
    return WT(i) ? i : WT(a) ? typeof a == "function" ? a() : a : typeof e == "function" ? e() : e;
  }), p = qe(f, 2), g = p[0], b = p[1], w = i !== void 0 ? i : g, x = d ? d(w) : w, E = ra(c), P = Cx([w]), k = qe(P, 2), M = k[0], T = k[1];
  IN(function() {
    var D = M[0];
    g !== D && E(g, D);
  }, [M]), IN(function() {
    WT(i) || b(i);
  }, [i]);
  var N = ra(function(D, $) {
    b(D, $), T([w], $);
  });
  return [x, N];
}
function xH(e, t, r, a) {
  var i = ce({}, t[e]);
  if (a != null && a.deprecatedTokens) {
    var c = a.deprecatedTokens;
    c.forEach(function(f) {
      var p = qe(f, 2), g = p[0], b = p[1];
      if (process.env.NODE_ENV !== "production" && $n(!(i != null && i[g]), "Component Token `".concat(String(g), "` of ").concat(String(e), " is deprecated. Please use `").concat(String(b), "` instead.")), i != null && i[g] || i != null && i[b]) {
        var w;
        (w = i[b]) !== null && w !== void 0 || (i[b] = i?.[g]);
      }
    });
  }
  var d = ce(ce({}, r), i);
  return Object.keys(d).forEach(function(f) {
    d[f] === t[f] && delete d[f];
  }), d;
}
var xq = process.env.NODE_ENV !== "production" || typeof CSSINJS_STATISTIC < "u", tD = !0;
function lo() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  if (!xq)
    return Object.assign.apply(Object, [{}].concat(t));
  tD = !1;
  var a = {};
  return t.forEach(function(i) {
    if (Hn(i) === "object") {
      var c = Object.keys(i);
      c.forEach(function(d) {
        Object.defineProperty(a, d, {
          configurable: !0,
          enumerable: !0,
          get: function() {
            return i[d];
          }
        });
      });
    }
  }), tD = !0, a;
}
var EH = {};
function Vue() {
}
var _ue = function(t) {
  var r, a = t, i = Vue;
  return xq && typeof Proxy < "u" && (r = /* @__PURE__ */ new Set(), a = new Proxy(t, {
    get: function(d, f) {
      if (tD) {
        var p;
        (p = r) === null || p === void 0 || p.add(f);
      }
      return d[f];
    }
  }), i = function(d, f) {
    var p;
    EH[d] = {
      global: Array.from(r),
      component: ce(ce({}, (p = EH[d]) === null || p === void 0 ? void 0 : p.component), f)
    };
  }), {
    token: a,
    keys: r,
    flush: i
  };
};
function PH(e, t, r) {
  if (typeof r == "function") {
    var a;
    return r(lo(t, (a = t[e]) !== null && a !== void 0 ? a : {}));
  }
  return r ?? {};
}
function Bue(e) {
  return e === "js" ? {
    max: Math.max,
    min: Math.min
  } : {
    max: function() {
      for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
        a[i] = arguments[i];
      return "max(".concat(a.map(function(c) {
        return Ye(c);
      }).join(","), ")");
    },
    min: function() {
      for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
        a[i] = arguments[i];
      return "min(".concat(a.map(function(c) {
        return Ye(c);
      }).join(","), ")");
    }
  };
}
var Uue = 1e3 * 60 * 10, Xue = /* @__PURE__ */ (function() {
  function e() {
    Vi(this, e), ge(this, "map", /* @__PURE__ */ new Map()), ge(this, "objectIDMap", /* @__PURE__ */ new WeakMap()), ge(this, "nextID", 0), ge(this, "lastAccessBeat", /* @__PURE__ */ new Map()), ge(this, "accessBeat", 0);
  }
  return _i(e, [{
    key: "set",
    value: function(r, a) {
      this.clear();
      var i = this.getCompositeKey(r);
      this.map.set(i, a), this.lastAccessBeat.set(i, Date.now());
    }
  }, {
    key: "get",
    value: function(r) {
      var a = this.getCompositeKey(r), i = this.map.get(a);
      return this.lastAccessBeat.set(a, Date.now()), this.accessBeat += 1, i;
    }
  }, {
    key: "getCompositeKey",
    value: function(r) {
      var a = this, i = r.map(function(c) {
        return c && Hn(c) === "object" ? "obj_".concat(a.getObjectID(c)) : "".concat(Hn(c), "_").concat(c);
      });
      return i.join("|");
    }
  }, {
    key: "getObjectID",
    value: function(r) {
      if (this.objectIDMap.has(r))
        return this.objectIDMap.get(r);
      var a = this.nextID;
      return this.objectIDMap.set(r, a), this.nextID += 1, a;
    }
  }, {
    key: "clear",
    value: function() {
      var r = this;
      if (this.accessBeat > 1e4) {
        var a = Date.now();
        this.lastAccessBeat.forEach(function(i, c) {
          a - i > Uue && (r.map.delete(c), r.lastAccessBeat.delete(c));
        }), this.accessBeat = 0;
      }
    }
  }]), e;
})(), kH = new Xue();
function Gue(e, t) {
  return Re.useMemo(function() {
    var r = kH.get(t);
    if (r)
      return r;
    var a = e();
    return kH.set(t, a), a;
  }, t);
}
var que = function() {
  return {};
};
function Kue(e) {
  var t = e.useCSP, r = t === void 0 ? que : t, a = e.useToken, i = e.usePrefix, c = e.getResetStyles, d = e.getCommonStyle, f = e.getCompUnitless;
  function p(x, E, P, k) {
    var M = Array.isArray(x) ? x[0] : x;
    function T(F) {
      return "".concat(String(M)).concat(F.slice(0, 1).toUpperCase()).concat(F.slice(1));
    }
    var N = k?.unitless || {}, D = typeof f == "function" ? f(x) : {}, $ = ce(ce({}, D), {}, ge({}, T("zIndexPopup"), !0));
    Object.keys(N).forEach(function(F) {
      $[T(F)] = N[F];
    });
    var j = ce(ce({}, k), {}, {
      unitless: $,
      prefixToken: T
    }), I = b(x, E, P, j), L = g(M, P, j);
    return function(F) {
      var _ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : F, W = I(F, _), Q = qe(W, 2), U = Q[1], Y = L(_), G = qe(Y, 2), J = G[0], H = G[1];
      return [J, U, H];
    };
  }
  function g(x, E, P) {
    var k = P.unitless, M = P.injectStyle, T = M === void 0 ? !0 : M, N = P.prefixToken, D = P.ignore, $ = function(L) {
      var F = L.rootCls, _ = L.cssVar, W = _ === void 0 ? {} : _, Q = a(), U = Q.realToken;
      return sue({
        path: [x],
        prefix: W.prefix,
        key: W.key,
        unitless: k,
        ignore: D,
        token: U,
        scope: F
      }, function() {
        var Y = PH(x, U, E), G = xH(x, U, Y, {
          deprecatedTokens: P?.deprecatedTokens
        });
        return Object.keys(Y).forEach(function(J) {
          G[N(J)] = G[J], delete G[J];
        }), G;
      }), null;
    }, j = function(L) {
      var F = a(), _ = F.cssVar;
      return [function(W) {
        return T && _ ? /* @__PURE__ */ Re.createElement(Re.Fragment, null, /* @__PURE__ */ Re.createElement($, {
          rootCls: L,
          cssVar: _,
          component: x
        }), W) : W;
      }, _?.key];
    };
    return j;
  }
  function b(x, E, P) {
    var k = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, M = Array.isArray(x) ? x : [x, x], T = qe(M, 1), N = T[0], D = M.join("-"), $ = e.layer || {
      name: "antd"
    };
    return function(j) {
      var I = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : j, L = a(), F = L.theme, _ = L.realToken, W = L.hashId, Q = L.token, U = L.cssVar, Y = i(), G = Y.rootPrefixCls, J = Y.iconPrefixCls, H = r(), K = U ? "css" : "js", X = Gue(function() {
        var oe = /* @__PURE__ */ new Set();
        return U && Object.keys(k.unitless || {}).forEach(function(fe) {
          oe.add(qP(fe, U.prefix)), oe.add(qP(fe, CH(N, U.prefix)));
        }), Wue(K, oe);
      }, [K, N, U?.prefix]), te = Bue(K), ie = te.max, ee = te.min, ne = {
        theme: F,
        token: Q,
        hashId: W,
        nonce: function() {
          return H.nonce;
        },
        clientOnly: k.clientOnly,
        layer: $,
        // antd is always at top of styles
        order: k.order || -999
      };
      typeof c == "function" && WN(ce(ce({}, ne), {}, {
        clientOnly: !1,
        path: ["Shared", G]
      }), function() {
        return c(Q, {
          prefix: {
            rootPrefixCls: G,
            iconPrefixCls: J
          },
          csp: H
        });
      });
      var ae = WN(ce(ce({}, ne), {}, {
        path: [D, j, J]
      }), function() {
        if (k.injectStyle === !1)
          return [];
        var oe = _ue(Q), fe = oe.token, be = oe.flush, me = PH(N, _, P), De = ".".concat(j), Me = xH(N, _, me, {
          deprecatedTokens: k.deprecatedTokens
        });
        U && me && Hn(me) === "object" && Object.keys(me).forEach(function(Ae) {
          me[Ae] = "var(".concat(qP(Ae, CH(N, U.prefix)), ")");
        });
        var ze = lo(fe, {
          componentCls: De,
          prefixCls: j,
          iconCls: ".".concat(J),
          antCls: ".".concat(G),
          calc: X,
          // @ts-ignore
          max: ie,
          // @ts-ignore
          min: ee
        }, U ? me : Me), le = E(ze, {
          hashId: W,
          prefixCls: j,
          rootPrefixCls: G,
          iconPrefixCls: J
        });
        be(N, Me);
        var se = typeof d == "function" ? d(ze, j, I, k.resetFont) : null;
        return [k.resetStyle === !1 ? null : se, le];
      });
      return [ae, W];
    };
  }
  function w(x, E, P) {
    var k = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, M = b(x, E, P, ce({
      resetStyle: !1,
      // Sub Style should default after root one
      order: -998
    }, k)), T = function(D) {
      var $ = D.prefixCls, j = D.rootCls, I = j === void 0 ? $ : j;
      return M($, I), null;
    };
    return process.env.NODE_ENV !== "production" && (T.displayName = "SubStyle_".concat(String(Array.isArray(x) ? x.join(".") : x))), T;
  }
  return {
    genStyleHooks: p,
    genSubStyleComponent: w,
    genComponentStyleHook: b
  };
}
const WS = ["blue", "purple", "cyan", "green", "magenta", "pink", "red", "orange", "yellow", "volcano", "geekblue", "lime", "gold"], Yue = "5.29.3";
function VT(e) {
  return e >= 0 && e <= 255;
}
function nE(e, t) {
  const {
    r,
    g: a,
    b: i,
    a: c
  } = new ro(e).toRgb();
  if (c < 1)
    return e;
  const {
    r: d,
    g: f,
    b: p
  } = new ro(t).toRgb();
  for (let g = 0.01; g <= 1; g += 0.01) {
    const b = Math.round((r - d * (1 - g)) / g), w = Math.round((a - f * (1 - g)) / g), x = Math.round((i - p * (1 - g)) / g);
    if (VT(b) && VT(w) && VT(x))
      return new ro({
        r: b,
        g: w,
        b: x,
        a: Math.round(g * 100) / 100
      }).toRgbString();
  }
  return new ro({
    r,
    g: a,
    b: i,
    a: 1
  }).toRgbString();
}
var Que = function(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
    t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
};
function Eq(e) {
  const {
    override: t
  } = e, r = Que(e, ["override"]), a = Object.assign({}, t);
  Object.keys(OE).forEach((x) => {
    delete a[x];
  });
  const i = Object.assign(Object.assign({}, r), a), c = 480, d = 576, f = 768, p = 992, g = 1200, b = 1600;
  return i.motion === !1 && (i.motionDurationFast = "0s", i.motionDurationMid = "0s", i.motionDurationSlow = "0s"), Object.assign(Object.assign(Object.assign({}, i), {
    // ============== Background ============== //
    colorFillContent: i.colorFillSecondary,
    colorFillContentHover: i.colorFill,
    colorFillAlter: i.colorFillQuaternary,
    colorBgContainerDisabled: i.colorFillTertiary,
    // ============== Split ============== //
    colorBorderBg: i.colorBgContainer,
    colorSplit: nE(i.colorBorderSecondary, i.colorBgContainer),
    // ============== Text ============== //
    colorTextPlaceholder: i.colorTextQuaternary,
    colorTextDisabled: i.colorTextQuaternary,
    colorTextHeading: i.colorText,
    colorTextLabel: i.colorTextSecondary,
    colorTextDescription: i.colorTextTertiary,
    colorTextLightSolid: i.colorWhite,
    colorHighlight: i.colorError,
    colorBgTextHover: i.colorFillSecondary,
    colorBgTextActive: i.colorFill,
    colorIcon: i.colorTextTertiary,
    colorIconHover: i.colorText,
    colorErrorOutline: nE(i.colorErrorBg, i.colorBgContainer),
    colorWarningOutline: nE(i.colorWarningBg, i.colorBgContainer),
    // Font
    fontSizeIcon: i.fontSizeSM,
    // Line
    lineWidthFocus: i.lineWidth * 3,
    // Control
    lineWidth: i.lineWidth,
    controlOutlineWidth: i.lineWidth * 2,
    // Checkbox size and expand icon size
    controlInteractiveSize: i.controlHeight / 2,
    controlItemBgHover: i.colorFillTertiary,
    controlItemBgActive: i.colorPrimaryBg,
    controlItemBgActiveHover: i.colorPrimaryBgHover,
    controlItemBgActiveDisabled: i.colorFill,
    controlTmpOutline: i.colorFillQuaternary,
    controlOutline: nE(i.colorPrimaryBg, i.colorBgContainer),
    lineType: i.lineType,
    borderRadius: i.borderRadius,
    borderRadiusXS: i.borderRadiusXS,
    borderRadiusSM: i.borderRadiusSM,
    borderRadiusLG: i.borderRadiusLG,
    fontWeightStrong: 600,
    opacityLoading: 0.65,
    linkDecoration: "none",
    linkHoverDecoration: "none",
    linkFocusDecoration: "none",
    controlPaddingHorizontal: 12,
    controlPaddingHorizontalSM: 8,
    paddingXXS: i.sizeXXS,
    paddingXS: i.sizeXS,
    paddingSM: i.sizeSM,
    padding: i.size,
    paddingMD: i.sizeMD,
    paddingLG: i.sizeLG,
    paddingXL: i.sizeXL,
    paddingContentHorizontalLG: i.sizeLG,
    paddingContentVerticalLG: i.sizeMS,
    paddingContentHorizontal: i.sizeMS,
    paddingContentVertical: i.sizeSM,
    paddingContentHorizontalSM: i.size,
    paddingContentVerticalSM: i.sizeXS,
    marginXXS: i.sizeXXS,
    marginXS: i.sizeXS,
    marginSM: i.sizeSM,
    margin: i.size,
    marginMD: i.sizeMD,
    marginLG: i.sizeLG,
    marginXL: i.sizeXL,
    marginXXL: i.sizeXXL,
    boxShadow: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowSecondary: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTertiary: `
      0 1px 2px 0 rgba(0, 0, 0, 0.03),
      0 1px 6px -1px rgba(0, 0, 0, 0.02),
      0 2px 4px 0 rgba(0, 0, 0, 0.02)
    `,
    screenXS: c,
    screenXSMin: c,
    screenXSMax: d - 1,
    screenSM: d,
    screenSMMin: d,
    screenSMMax: f - 1,
    screenMD: f,
    screenMDMin: f,
    screenMDMax: p - 1,
    screenLG: p,
    screenLGMin: p,
    screenLGMax: g - 1,
    screenXL: g,
    screenXLMin: g,
    screenXLMax: b - 1,
    screenXXL: b,
    screenXXLMin: b,
    boxShadowPopoverArrow: "2px 2px 5px rgba(0, 0, 0, 0.05)",
    boxShadowCard: `
      0 1px 2px -2px ${new ro("rgba(0, 0, 0, 0.16)").toRgbString()},
      0 3px 6px 0 ${new ro("rgba(0, 0, 0, 0.12)").toRgbString()},
      0 5px 12px 4px ${new ro("rgba(0, 0, 0, 0.09)").toRgbString()}
    `,
    boxShadowDrawerRight: `
      -6px 0 16px 0 rgba(0, 0, 0, 0.08),
      -3px 0 6px -4px rgba(0, 0, 0, 0.12),
      -9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerLeft: `
      6px 0 16px 0 rgba(0, 0, 0, 0.08),
      3px 0 6px -4px rgba(0, 0, 0, 0.12),
      9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerUp: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerDown: `
      0 -6px 16px 0 rgba(0, 0, 0, 0.08),
      0 -3px 6px -4px rgba(0, 0, 0, 0.12),
      0 -9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTabsOverflowLeft: "inset 10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowRight: "inset -10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowTop: "inset 0 10px 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowBottom: "inset 0 -10px 8px -8px rgba(0, 0, 0, 0.08)"
  }), a);
}
var MH = function(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
    t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
};
const Pq = {
  lineHeight: !0,
  lineHeightSM: !0,
  lineHeightLG: !0,
  lineHeightHeading1: !0,
  lineHeightHeading2: !0,
  lineHeightHeading3: !0,
  lineHeightHeading4: !0,
  lineHeightHeading5: !0,
  opacityLoading: !0,
  fontWeightStrong: !0,
  zIndexPopupBase: !0,
  zIndexBase: !0,
  opacityImage: !0
}, Jue = {
  motionBase: !0,
  motionUnit: !0
}, Zue = {
  screenXS: !0,
  screenXSMin: !0,
  screenXSMax: !0,
  screenSM: !0,
  screenSMMin: !0,
  screenSMMax: !0,
  screenMD: !0,
  screenMDMin: !0,
  screenMDMax: !0,
  screenLG: !0,
  screenLGMin: !0,
  screenLGMax: !0,
  screenXL: !0,
  screenXLMin: !0,
  screenXLMax: !0,
  screenXXL: !0,
  screenXXLMin: !0
}, kq = (e, t, r) => {
  const a = r.getDerivativeToken(e), {
    override: i
  } = t, c = MH(t, ["override"]);
  let d = Object.assign(Object.assign({}, a), {
    override: i
  });
  return d = Eq(d), c && Object.entries(c).forEach(([f, p]) => {
    const {
      theme: g
    } = p, b = MH(p, ["theme"]);
    let w = b;
    g && (w = kq(Object.assign(Object.assign({}, d), b), {
      override: b
    }, g)), d[f] = w;
  }), d;
};
function Bf() {
  const {
    token: e,
    hashed: t,
    theme: r,
    override: a,
    cssVar: i
  } = Re.useContext(yq), c = `${Yue}-${t || ""}`, d = r || bq, [f, p, g] = Dse(d, [OE, e], {
    salt: c,
    override: a,
    getComputedToken: kq,
    // formatToken will not be consumed after 1.15.0 with getComputedToken.
    // But token will break if @ant-design/cssinjs is under 1.15.0 without it
    formatToken: Eq,
    cssVar: i && {
      prefix: i.prefix,
      key: i.key,
      unitless: Pq,
      ignore: Jue,
      preserve: Zue
    }
  });
  return [d, g, t ? p : "", f, i];
}
const VS = {
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis"
}, dl = (e, t = !1) => ({
  boxSizing: "border-box",
  margin: 0,
  padding: 0,
  color: e.colorText,
  fontSize: e.fontSize,
  // font-variant: @font-variant-base;
  lineHeight: e.lineHeight,
  listStyle: "none",
  // font-feature-settings: @font-feature-settings-base;
  fontFamily: t ? "inherit" : e.fontFamily
}), VE = () => ({
  display: "inline-flex",
  alignItems: "center",
  color: "inherit",
  fontStyle: "normal",
  lineHeight: 0,
  textAlign: "center",
  textTransform: "none",
  // for SVG icon, see https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
  verticalAlign: "-0.125em",
  textRendering: "optimizeLegibility",
  "-webkit-font-smoothing": "antialiased",
  "-moz-osx-font-smoothing": "grayscale",
  "> *": {
    lineHeight: 1
  },
  svg: {
    display: "inline-block"
  }
}), J4 = () => ({
  // https://github.com/ant-design/ant-design/issues/21301#issuecomment-583955229
  "&::before": {
    display: "table",
    content: '""'
  },
  "&::after": {
    // https://github.com/ant-design/ant-design/issues/21864
    display: "table",
    clear: "both",
    content: '""'
  }
}), ece = (e) => ({
  a: {
    color: e.colorLink,
    textDecoration: e.linkDecoration,
    backgroundColor: "transparent",
    // remove the gray background on active links in IE 10.
    outline: "none",
    cursor: "pointer",
    transition: `color ${e.motionDurationSlow}`,
    "-webkit-text-decoration-skip": "objects",
    // remove gaps in links underline in iOS 8+ and Safari 8+.
    "&:hover": {
      color: e.colorLinkHover
    },
    "&:active": {
      color: e.colorLinkActive
    },
    "&:active, &:hover": {
      textDecoration: e.linkHoverDecoration,
      outline: 0
    },
    // https://github.com/ant-design/ant-design/issues/22503
    "&:focus": {
      textDecoration: e.linkFocusDecoration,
      outline: 0
    },
    "&[disabled]": {
      color: e.colorTextDisabled,
      cursor: "not-allowed"
    }
  }
}), tce = (e, t, r, a) => {
  const i = `[class^="${t}"], [class*=" ${t}"]`, c = r ? `.${r}` : i, d = {
    boxSizing: "border-box",
    "&::before, &::after": {
      boxSizing: "border-box"
    }
  };
  let f = {};
  return a !== !1 && (f = {
    fontFamily: e.fontFamily,
    fontSize: e.fontSize
  }), {
    [c]: Object.assign(Object.assign(Object.assign({}, f), d), {
      [i]: d
    })
  };
}, _S = (e, t) => ({
  outline: `${Ye(e.lineWidthFocus)} solid ${e.colorPrimaryBorder}`,
  outlineOffset: t ?? 1,
  transition: "outline-offset 0s, outline 0s"
}), Z4 = (e, t) => ({
  "&:focus-visible": _S(e, t)
}), Mq = (e) => ({
  [`.${e}`]: Object.assign(Object.assign({}, VE()), {
    [`.${e} .${e}-icon`]: {
      display: "block"
    }
  })
}), nce = (e) => Object.assign(Object.assign({
  // FIXME: This use link but is a operation unit. Seems should be a colorPrimary.
  // And Typography use this to generate link style which should not do this.
  color: e.colorLink,
  textDecoration: e.linkDecoration,
  outline: "none",
  cursor: "pointer",
  transition: `all ${e.motionDurationSlow}`,
  border: 0,
  padding: 0,
  background: "none",
  userSelect: "none"
}, Z4(e)), {
  "&:hover": {
    color: e.colorLinkHover,
    textDecoration: e.linkHoverDecoration
  },
  "&:focus": {
    color: e.colorLinkHover,
    textDecoration: e.linkFocusDecoration
  },
  "&:active": {
    color: e.colorLinkActive,
    textDecoration: e.linkHoverDecoration
  }
}), {
  genStyleHooks: Ii,
  genComponentStyleHook: rce,
  genSubStyleComponent: $z
} = Kue({
  usePrefix: () => {
    const {
      getPrefixCls: e,
      iconPrefixCls: t
    } = Do(Qr);
    return {
      rootPrefixCls: e(),
      iconPrefixCls: t
    };
  },
  useToken: () => {
    const [e, t, r, a, i] = Bf();
    return {
      theme: e,
      realToken: t,
      hashId: r,
      token: a,
      cssVar: i
    };
  },
  useCSP: () => {
    const {
      csp: e
    } = Do(Qr);
    return e ?? {};
  },
  getResetStyles: (e, t) => {
    var r;
    const a = ece(e);
    return [a, {
      "&": a
    }, Mq((r = t?.prefix.iconPrefixCls) !== null && r !== void 0 ? r : $9)];
  },
  getCommonStyle: tce,
  getCompUnitless: () => Pq
});
function ace(e, t) {
  return WS.reduce((r, a) => {
    const i = e[`${a}1`], c = e[`${a}3`], d = e[`${a}6`], f = e[`${a}7`];
    return Object.assign(Object.assign({}, r), t(a, {
      lightColor: i,
      lightBorderColor: c,
      darkColor: d,
      textColor: f
    }));
  }, {});
}
const oce = (e, t) => {
  const [r, a] = Bf();
  return WN({
    token: a,
    hashId: "",
    path: ["ant-design-icons", e],
    nonce: () => t?.nonce,
    layer: {
      name: "antd"
    }
  }, () => Mq(e));
}, ice = Object.assign({}, S), {
  useId: OH
} = ice, lce = () => "", sce = typeof OH > "u" ? lce : OH;
function uce(e, t, r) {
  var a, i;
  const c = To("ConfigProvider"), d = e || {}, f = d.inherit === !1 || !t ? Object.assign(Object.assign({}, eD), {
    hashed: (a = t?.hashed) !== null && a !== void 0 ? a : eD.hashed,
    cssVar: t?.cssVar
  }) : t, p = sce();
  if (process.env.NODE_ENV !== "production") {
    const g = d.cssVar || f.cssVar, b = !!(typeof d.cssVar == "object" && (!((i = d.cssVar) === null || i === void 0) && i.key) || p);
    process.env.NODE_ENV !== "production" && c(!g || b, "breaking", "Missing key in `cssVar` config. Please upgrade to React 18 or set `cssVar.key` manually in each ConfigProvider inside `cssVar` enabled ConfigProvider.");
  }
  return eC(() => {
    var g, b;
    if (!e)
      return t;
    const w = Object.assign({}, f.components);
    Object.keys(e.components || {}).forEach((P) => {
      w[P] = Object.assign(Object.assign({}, w[P]), e.components[P]);
    });
    const x = `css-var-${p.replace(/:/g, "")}`, E = ((g = d.cssVar) !== null && g !== void 0 ? g : f.cssVar) && Object.assign(Object.assign(Object.assign({
      prefix: r?.prefixCls
    }, typeof f.cssVar == "object" ? f.cssVar : {}), typeof d.cssVar == "object" ? d.cssVar : {}), {
      key: typeof d.cssVar == "object" && ((b = d.cssVar) === null || b === void 0 ? void 0 : b.key) || x
    });
    return Object.assign(Object.assign(Object.assign({}, f), d), {
      token: Object.assign(Object.assign({}, f.token), d.token),
      components: w,
      cssVar: E
    });
  }, [d, f], (g, b) => g.some((w, x) => {
    const E = b[x];
    return !R0(w, E, !0);
  }));
}
var cce = ["children"], Oq = /* @__PURE__ */ S.createContext({});
function dce(e) {
  var t = e.children, r = xr(e, cce);
  return /* @__PURE__ */ S.createElement(Oq.Provider, {
    value: r
  }, t);
}
var fce = /* @__PURE__ */ (function(e) {
  pd(r, e);
  var t = B0(r);
  function r() {
    return Vi(this, r), t.apply(this, arguments);
  }
  return _i(r, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), r;
})(S.Component);
function mce(e) {
  var t = S.useReducer(function(f) {
    return f + 1;
  }, 0), r = qe(t, 2), a = r[1], i = S.useRef(e), c = ra(function() {
    return i.current;
  }), d = ra(function(f) {
    i.current = typeof f == "function" ? f(i.current) : f, a();
  });
  return [c, d];
}
var PS = "none", j7 = "appear", I7 = "enter", L7 = "leave", TH = "none", z1 = "prepare", Y3 = "start", Q3 = "active", zz = "end", Tq = "prepared";
function RH(e, t) {
  var r = {};
  return r[e.toLowerCase()] = t.toLowerCase(), r["Webkit".concat(e)] = "webkit".concat(t), r["Moz".concat(e)] = "moz".concat(t), r["ms".concat(e)] = "MS".concat(t), r["O".concat(e)] = "o".concat(t.toLowerCase()), r;
}
function hce(e, t) {
  var r = {
    animationend: RH("Animation", "AnimationEnd"),
    transitionend: RH("Transition", "TransitionEnd")
  };
  return e && ("AnimationEvent" in t || delete r.animationend.animation, "TransitionEvent" in t || delete r.transitionend.transition), r;
}
var pce = hce(Ju(), typeof window < "u" ? window : {}), Rq = {};
if (Ju()) {
  var gce = document.createElement("div");
  Rq = gce.style;
}
var H7 = {};
function Aq(e) {
  if (H7[e])
    return H7[e];
  var t = pce[e];
  if (t)
    for (var r = Object.keys(t), a = r.length, i = 0; i < a; i += 1) {
      var c = r[i];
      if (Object.prototype.hasOwnProperty.call(t, c) && c in Rq)
        return H7[e] = t[c], H7[e];
    }
  return "";
}
var Nq = Aq("animationend"), Dq = Aq("transitionend"), $q = !!(Nq && Dq), AH = Nq || "animationend", NH = Dq || "transitionend";
function DH(e, t) {
  if (!e) return null;
  if (Hn(e) === "object") {
    var r = t.replace(/-\w/g, function(a) {
      return a[1].toUpperCase();
    });
    return e[r];
  }
  return "".concat(e, "-").concat(t);
}
const vce = (function(e) {
  var t = It();
  function r(i) {
    i && (i.removeEventListener(NH, e), i.removeEventListener(AH, e));
  }
  function a(i) {
    t.current && t.current !== i && r(t.current), i && i !== t.current && (i.addEventListener(NH, e), i.addEventListener(AH, e), t.current = i);
  }
  return S.useEffect(function() {
    return function() {
      r(t.current);
    };
  }, []), [a, r];
});
var zq = Ju() ? zS : Er;
const bce = (function() {
  var e = S.useRef(null);
  function t() {
    Pa.cancel(e.current);
  }
  function r(a) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    t();
    var c = Pa(function() {
      i <= 1 ? a({
        isCanceled: function() {
          return c !== e.current;
        }
      }) : r(a, i - 1);
    });
    e.current = c;
  }
  return S.useEffect(function() {
    return function() {
      t();
    };
  }, []), [r, t];
});
var yce = [z1, Y3, Q3, zz], wce = [z1, Tq], jq = !1, Sce = !0;
function Iq(e) {
  return e === Q3 || e === zz;
}
const Cce = (function(e, t, r) {
  var a = Cx(TH), i = qe(a, 2), c = i[0], d = i[1], f = bce(), p = qe(f, 2), g = p[0], b = p[1];
  function w() {
    d(z1, !0);
  }
  var x = t ? wce : yce;
  return zq(function() {
    if (c !== TH && c !== zz) {
      var E = x.indexOf(c), P = x[E + 1], k = r(c);
      k === jq ? d(P, !0) : P && g(function(M) {
        function T() {
          M.isCanceled() || d(P, !0);
        }
        k === !0 ? T() : Promise.resolve(k).then(T);
      });
    }
  }, [e, c]), S.useEffect(function() {
    return function() {
      b();
    };
  }, []), [w, c];
});
function xce(e, t, r, a) {
  var i = a.motionEnter, c = i === void 0 ? !0 : i, d = a.motionAppear, f = d === void 0 ? !0 : d, p = a.motionLeave, g = p === void 0 ? !0 : p, b = a.motionDeadline, w = a.motionLeaveImmediately, x = a.onAppearPrepare, E = a.onEnterPrepare, P = a.onLeavePrepare, k = a.onAppearStart, M = a.onEnterStart, T = a.onLeaveStart, N = a.onAppearActive, D = a.onEnterActive, $ = a.onLeaveActive, j = a.onAppearEnd, I = a.onEnterEnd, L = a.onLeaveEnd, F = a.onVisibleChanged, _ = Cx(), W = qe(_, 2), Q = W[0], U = W[1], Y = mce(PS), G = qe(Y, 2), J = G[0], H = G[1], K = Cx(null), X = qe(K, 2), te = X[0], ie = X[1], ee = J(), ne = It(!1), ae = It(null);
  function oe() {
    return r();
  }
  var fe = It(!1);
  function be() {
    H(PS), ie(null, !0);
  }
  var me = ra(function(ye) {
    var je = J();
    if (je !== PS) {
      var Ue = oe();
      if (!(ye && !ye.deadline && ye.target !== Ue)) {
        var Fe = fe.current, tt;
        je === j7 && Fe ? tt = j?.(Ue, ye) : je === I7 && Fe ? tt = I?.(Ue, ye) : je === L7 && Fe && (tt = L?.(Ue, ye)), Fe && tt !== !1 && be();
      }
    }
  }), De = vce(me), Me = qe(De, 1), ze = Me[0], le = function(je) {
    switch (je) {
      case j7:
        return ge(ge(ge({}, z1, x), Y3, k), Q3, N);
      case I7:
        return ge(ge(ge({}, z1, E), Y3, M), Q3, D);
      case L7:
        return ge(ge(ge({}, z1, P), Y3, T), Q3, $);
      default:
        return {};
    }
  }, se = S.useMemo(function() {
    return le(ee);
  }, [ee]), Ae = Cce(ee, !e, function(ye) {
    if (ye === z1) {
      var je = se[z1];
      return je ? je(oe()) : jq;
    }
    if (pe in se) {
      var Ue;
      ie(((Ue = se[pe]) === null || Ue === void 0 ? void 0 : Ue.call(se, oe(), null)) || null);
    }
    return pe === Q3 && ee !== PS && (ze(oe()), b > 0 && (clearTimeout(ae.current), ae.current = setTimeout(function() {
      me({
        deadline: !0
      });
    }, b))), pe === Tq && be(), Sce;
  }), we = qe(Ae, 2), Ne = we[0], pe = we[1], Qe = Iq(pe);
  fe.current = Qe;
  var Le = It(null);
  zq(function() {
    if (!(ne.current && Le.current === t)) {
      U(t);
      var ye = ne.current;
      ne.current = !0;
      var je;
      !ye && t && f && (je = j7), ye && t && c && (je = I7), (ye && !t && g || !ye && w && !t && g) && (je = L7);
      var Ue = le(je);
      je && (e || Ue[z1]) ? (H(je), Ne()) : H(PS), Le.current = t;
    }
  }, [t]), Er(function() {
    // Cancel appear
    (ee === j7 && !f || // Cancel enter
    ee === I7 && !c || // Cancel leave
    ee === L7 && !g) && H(PS);
  }, [f, c, g]), Er(function() {
    return function() {
      ne.current = !1, clearTimeout(ae.current);
    };
  }, []);
  var Te = S.useRef(!1);
  Er(function() {
    Q && (Te.current = !0), Q !== void 0 && ee === PS && ((Te.current || Q) && F?.(Q), Te.current = !0);
  }, [Q, ee]);
  var Oe = te;
  return se[z1] && pe === Y3 && (Oe = ce({
    transition: "none"
  }, Oe)), [ee, pe, Oe, Q ?? t];
}
function Ece(e) {
  var t = e;
  Hn(e) === "object" && (t = e.transitionSupport);
  function r(i, c) {
    return !!(i.motionName && t && c !== !1);
  }
  var a = /* @__PURE__ */ S.forwardRef(function(i, c) {
    var d = i.visible, f = d === void 0 ? !0 : d, p = i.removeOnLeave, g = p === void 0 ? !0 : p, b = i.forceRender, w = i.children, x = i.motionName, E = i.leavedClassName, P = i.eventProps, k = S.useContext(Oq), M = k.motion, T = r(i, M), N = It(), D = It();
    function $() {
      try {
        return N.current instanceof HTMLElement ? N.current : GP(D.current);
      } catch {
        return null;
      }
    }
    var j = xce(T, f, $, i), I = qe(j, 4), L = I[0], F = I[1], _ = I[2], W = I[3], Q = S.useRef(W);
    W && (Q.current = !0);
    var U = S.useCallback(function(X) {
      N.current = X, xE(c, X);
    }, [c]), Y, G = ce(ce({}, P), {}, {
      visible: f
    });
    if (!w)
      Y = null;
    else if (L === PS)
      W ? Y = w(ce({}, G), U) : !g && Q.current && E ? Y = w(ce(ce({}, G), {}, {
        className: E
      }), U) : b || !g && !E ? Y = w(ce(ce({}, G), {}, {
        style: {
          display: "none"
        }
      }), U) : Y = null;
    else {
      var J;
      F === z1 ? J = "prepare" : Iq(F) ? J = "active" : F === Y3 && (J = "start");
      var H = DH(x, "".concat(L, "-").concat(J));
      Y = w(ce(ce({}, G), {}, {
        className: _e(DH(x, L), ge(ge({}, H, H && J), x, typeof x == "string")),
        style: _
      }), U);
    }
    if (/* @__PURE__ */ S.isValidElement(Y) && gb(Y)) {
      var K = m3(Y);
      K || (Y = /* @__PURE__ */ S.cloneElement(Y, {
        ref: U
      }));
    }
    return /* @__PURE__ */ S.createElement(fce, {
      ref: D
    }, Y);
  });
  return a.displayName = "CSSMotion", a;
}
const N0 = Ece($q);
var nD = "add", rD = "keep", aD = "remove", _T = "removed";
function Pce(e) {
  var t;
  return e && Hn(e) === "object" && "key" in e ? t = e : t = {
    key: e
  }, ce(ce({}, t), {}, {
    key: String(t.key)
  });
}
function oD() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  return e.map(Pce);
}
function kce() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], r = [], a = 0, i = t.length, c = oD(e), d = oD(t);
  c.forEach(function(g) {
    for (var b = !1, w = a; w < i; w += 1) {
      var x = d[w];
      if (x.key === g.key) {
        a < w && (r = r.concat(d.slice(a, w).map(function(E) {
          return ce(ce({}, E), {}, {
            status: nD
          });
        })), a = w), r.push(ce(ce({}, x), {}, {
          status: rD
        })), a += 1, b = !0;
        break;
      }
    }
    b || r.push(ce(ce({}, g), {}, {
      status: aD
    }));
  }), a < i && (r = r.concat(d.slice(a).map(function(g) {
    return ce(ce({}, g), {}, {
      status: nD
    });
  })));
  var f = {};
  r.forEach(function(g) {
    var b = g.key;
    f[b] = (f[b] || 0) + 1;
  });
  var p = Object.keys(f).filter(function(g) {
    return f[g] > 1;
  });
  return p.forEach(function(g) {
    r = r.filter(function(b) {
      var w = b.key, x = b.status;
      return w !== g || x !== aD;
    }), r.forEach(function(b) {
      b.key === g && (b.status = rD);
    });
  }), r;
}
var Mce = ["component", "children", "onVisibleChanged", "onAllRemoved"], Oce = ["status"], Tce = ["eventProps", "visible", "children", "motionName", "motionAppear", "motionEnter", "motionLeave", "motionLeaveImmediately", "motionDeadline", "removeOnLeave", "leavedClassName", "onAppearPrepare", "onAppearStart", "onAppearActive", "onAppearEnd", "onEnterStart", "onEnterActive", "onEnterEnd", "onLeaveStart", "onLeaveActive", "onLeaveEnd"];
function Rce(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : N0, r = /* @__PURE__ */ (function(a) {
    pd(c, a);
    var i = B0(c);
    function c() {
      var d;
      Vi(this, c);
      for (var f = arguments.length, p = new Array(f), g = 0; g < f; g++)
        p[g] = arguments[g];
      return d = i.call.apply(i, [this].concat(p)), ge(bn(d), "state", {
        keyEntities: []
      }), ge(bn(d), "removeKey", function(b) {
        d.setState(function(w) {
          var x = w.keyEntities.map(function(E) {
            return E.key !== b ? E : ce(ce({}, E), {}, {
              status: _T
            });
          });
          return {
            keyEntities: x
          };
        }, function() {
          var w = d.state.keyEntities, x = w.filter(function(E) {
            var P = E.status;
            return P !== _T;
          }).length;
          x === 0 && d.props.onAllRemoved && d.props.onAllRemoved();
        });
      }), d;
    }
    return _i(c, [{
      key: "render",
      value: function() {
        var f = this, p = this.state.keyEntities, g = this.props, b = g.component, w = g.children, x = g.onVisibleChanged;
        g.onAllRemoved;
        var E = xr(g, Mce), P = b || S.Fragment, k = {};
        return Tce.forEach(function(M) {
          k[M] = E[M], delete E[M];
        }), delete E.keys, /* @__PURE__ */ S.createElement(P, E, p.map(function(M, T) {
          var N = M.status, D = xr(M, Oce), $ = N === nD || N === rD;
          return /* @__PURE__ */ S.createElement(t, vt({}, k, {
            key: D.key,
            visible: $,
            eventProps: D,
            onVisibleChanged: function(I) {
              x?.(I, {
                key: D.key
              }), I || f.removeKey(D.key);
            }
          }), function(j, I) {
            return w(ce(ce({}, j), {}, {
              index: T
            }), I);
          });
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(f, p) {
        var g = f.keys, b = p.keyEntities, w = oD(g), x = kce(b, w);
        return {
          keyEntities: x.filter(function(E) {
            var P = b.find(function(k) {
              var M = k.key;
              return E.key === M;
            });
            return !(P && P.status === _T && E.status === aD);
          })
        };
      }
    }]), c;
  })(S.Component);
  return ge(r, "defaultProps", {
    component: "div"
  }), r;
}
const Ace = Rce($q), iD = /* @__PURE__ */ S.createContext(!0);
process.env.NODE_ENV !== "production" && (iD.displayName = "MotionCacheContext");
function Nce(e) {
  const t = S.useContext(iD), {
    children: r
  } = e, [, a] = Bf(), {
    motion: i
  } = a, c = S.useRef(!1);
  return c.current || (c.current = t !== i), c.current ? /* @__PURE__ */ S.createElement(iD.Provider, {
    value: i
  }, /* @__PURE__ */ S.createElement(dce, {
    motion: i
  }, r)) : r;
}
const Lq = /* @__PURE__ */ S.memo(({
  dropdownMatchSelectWidth: e
}) => (To("ConfigProvider").deprecated(e === void 0, "dropdownMatchSelectWidth", "popupMatchSelectWidth"), null));
process.env.NODE_ENV !== "production" && (Lq.displayName = "PropWarning");
const Dce = process.env.NODE_ENV !== "production" ? Lq : () => null;
var $ce = function(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
    t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
};
let lD = !1;
const zce = process.env.NODE_ENV !== "production" ? (e) => {
  process.env.NODE_ENV !== "production" && nC(!lD, e, "Static function can not consume context like dynamic theme. Please use 'App' component instead.");
} : (
  /* istanbul ignore next */
  null
), jce = ["getTargetContainer", "getPopupContainer", "renderEmpty", "input", "pagination", "form", "select", "button"];
let Lk, Hq, Fq, Wq;
function nk() {
  return Lk || RE;
}
function Ice() {
  return Hq || $9;
}
function Lce(e) {
  return Object.keys(e).some((t) => t.endsWith("Color"));
}
const Hce = (e) => {
  const {
    prefixCls: t,
    iconPrefixCls: r,
    theme: a,
    holderRender: i
  } = e;
  t !== void 0 && (Lk = t), r !== void 0 && (Hq = r), "holderRender" in e && (Wq = i), a && (Lce(a) ? (process.env.NODE_ENV !== "production" && nC(!1, "ConfigProvider", "`config` of css variable theme is not work in v5. Please use new `theme` config instead."), zue(nk(), a)) : Fq = a);
}, Fce = () => ({
  getPrefixCls: (e, t) => t || (e ? `${nk()}-${e}` : nk()),
  getIconPrefixCls: Ice,
  getRootPrefixCls: () => Lk || nk(),
  getTheme: () => Fq,
  holderRender: Wq
}), Wce = (e) => {
  const {
    children: t,
    csp: r,
    autoInsertSpaceInButton: a,
    alert: i,
    anchor: c,
    form: d,
    locale: f,
    componentSize: p,
    direction: g,
    space: b,
    splitter: w,
    virtual: x,
    dropdownMatchSelectWidth: E,
    popupMatchSelectWidth: P,
    popupOverflow: k,
    legacyLocale: M,
    parentContext: T,
    iconPrefixCls: N,
    theme: D,
    componentDisabled: $,
    segmented: j,
    statistic: I,
    spin: L,
    calendar: F,
    carousel: _,
    cascader: W,
    collapse: Q,
    typography: U,
    checkbox: Y,
    descriptions: G,
    divider: J,
    drawer: H,
    skeleton: K,
    steps: X,
    image: te,
    layout: ie,
    list: ee,
    mentions: ne,
    modal: ae,
    progress: oe,
    result: fe,
    slider: be,
    breadcrumb: me,
    menu: De,
    pagination: Me,
    input: ze,
    textArea: le,
    empty: se,
    badge: Ae,
    radio: we,
    rate: Ne,
    switch: pe,
    transfer: Qe,
    avatar: Le,
    message: Te,
    tag: Oe,
    table: ye,
    card: je,
    tabs: Ue,
    timeline: Fe,
    timePicker: tt,
    upload: dt,
    notification: St,
    tree: mt,
    colorPicker: Ot,
    datePicker: Rt,
    rangePicker: ct,
    flex: it,
    wave: Ct,
    dropdown: ut,
    warning: ht,
    tour: ot,
    tooltip: at,
    popover: ft,
    popconfirm: st,
    floatButton: pt,
    floatButtonGroup: bt,
    variant: Nt,
    inputNumber: $t,
    treeSelect: Pt
  } = e, hn = S.useCallback((gn, Tn) => {
    const {
      prefixCls: Gt
    } = e;
    if (Tn)
      return Tn;
    const Dt = Gt || T.getPrefixCls("");
    return gn ? `${Dt}-${gn}` : Dt;
  }, [T.getPrefixCls, e.prefixCls]), an = N || T.iconPrefixCls || $9, jn = r || T.csp;
  oce(an, jn);
  const xn = uce(D, T.theme, {
    prefixCls: hn("")
  });
  process.env.NODE_ENV !== "production" && (lD = lD || !!xn);
  const Ut = {
    csp: jn,
    autoInsertSpaceInButton: a,
    alert: i,
    anchor: c,
    locale: f || M,
    direction: g,
    space: b,
    splitter: w,
    virtual: x,
    popupMatchSelectWidth: P ?? E,
    popupOverflow: k,
    getPrefixCls: hn,
    iconPrefixCls: an,
    theme: xn,
    segmented: j,
    statistic: I,
    spin: L,
    calendar: F,
    carousel: _,
    cascader: W,
    collapse: Q,
    typography: U,
    checkbox: Y,
    descriptions: G,
    divider: J,
    drawer: H,
    skeleton: K,
    steps: X,
    image: te,
    input: ze,
    textArea: le,
    layout: ie,
    list: ee,
    mentions: ne,
    modal: ae,
    progress: oe,
    result: fe,
    slider: be,
    breadcrumb: me,
    menu: De,
    pagination: Me,
    empty: se,
    badge: Ae,
    radio: we,
    rate: Ne,
    switch: pe,
    transfer: Qe,
    avatar: Le,
    message: Te,
    tag: Oe,
    table: ye,
    card: je,
    tabs: Ue,
    timeline: Fe,
    timePicker: tt,
    upload: dt,
    notification: St,
    tree: mt,
    colorPicker: Ot,
    datePicker: Rt,
    rangePicker: ct,
    flex: it,
    wave: Ct,
    dropdown: ut,
    warning: ht,
    tour: ot,
    tooltip: at,
    popover: ft,
    popconfirm: st,
    floatButton: pt,
    floatButtonGroup: bt,
    variant: Nt,
    inputNumber: $t,
    treeSelect: Pt
  };
  process.env.NODE_ENV !== "production" && To("ConfigProvider")(!("autoInsertSpaceInButton" in e), "deprecated", "`autoInsertSpaceInButton` is deprecated. Please use `{ button: { autoInsertSpace: boolean }}` instead.");
  const pn = Object.assign({}, T);
  Object.keys(Ut).forEach((gn) => {
    Ut[gn] !== void 0 && (pn[gn] = Ut[gn]);
  }), jce.forEach((gn) => {
    const Tn = e[gn];
    Tn && (pn[gn] = Tn);
  }), typeof a < "u" && (pn.button = Object.assign({
    autoInsertSpace: a
  }, pn.button));
  const wn = eC(() => pn, pn, (gn, Tn) => {
    const Gt = Object.keys(gn), Dt = Object.keys(Tn);
    return Gt.length !== Dt.length || Gt.some((Yt) => gn[Yt] !== Tn[Yt]);
  }), {
    layer: Lt
  } = S.useContext(Q4), gt = S.useMemo(() => ({
    prefixCls: an,
    csp: jn,
    layer: Lt ? "antd" : void 0
  }), [an, jn, Lt]);
  let wt = /* @__PURE__ */ S.createElement(S.Fragment, null, /* @__PURE__ */ S.createElement(Dce, {
    dropdownMatchSelectWidth: E
  }), t);
  const Ft = S.useMemo(() => {
    var gn, Tn, Gt, Dt;
    return K3(((gn = vb.Form) === null || gn === void 0 ? void 0 : gn.defaultValidateMessages) || {}, ((Gt = (Tn = wn.locale) === null || Tn === void 0 ? void 0 : Tn.Form) === null || Gt === void 0 ? void 0 : Gt.defaultValidateMessages) || {}, ((Dt = wn.form) === null || Dt === void 0 ? void 0 : Dt.validateMessages) || {}, d?.validateMessages || {});
  }, [wn, d?.validateMessages]);
  Object.keys(Ft).length > 0 && (wt = /* @__PURE__ */ S.createElement(mue.Provider, {
    value: Ft
  }, wt)), f && (wt = /* @__PURE__ */ S.createElement(hq, {
    locale: f,
    _ANT_MARK__: mq
  }, wt)), wt = /* @__PURE__ */ S.createElement(Nz.Provider, {
    value: gt
  }, wt), p && (wt = /* @__PURE__ */ S.createElement(jue, {
    size: p
  }, wt)), wt = /* @__PURE__ */ S.createElement(Nce, null, wt);
  const yn = S.useMemo(() => {
    const gn = xn || {}, {
      algorithm: Tn,
      token: Gt,
      components: Dt,
      cssVar: Yt
    } = gn, Mn = $ce(gn, ["algorithm", "token", "components", "cssVar"]), Gn = Tn && (!Array.isArray(Tn) || Tn.length > 0) ? zN(Tn) : bq, wr = {};
    Object.entries(Dt || {}).forEach(([qn, Rr]) => {
      const Wt = Object.assign({}, Rr);
      "algorithm" in Wt && (Wt.algorithm === !0 ? Wt.theme = Gn : (Array.isArray(Wt.algorithm) || typeof Wt.algorithm == "function") && (Wt.theme = zN(Wt.algorithm)), delete Wt.algorithm), wr[qn] = Wt;
    });
    const aa = Object.assign(Object.assign({}, OE), Gt);
    return Object.assign(Object.assign({}, Mn), {
      theme: Gn,
      token: aa,
      components: wr,
      override: Object.assign({
        override: aa
      }, wr),
      cssVar: Yt
    });
  }, [xn]);
  return D && (wt = /* @__PURE__ */ S.createElement(yq.Provider, {
    value: yn
  }, wt)), wn.warning && (wt = /* @__PURE__ */ S.createElement(uq.Provider, {
    value: wn.warning
  }, wt)), $ !== void 0 && (wt = /* @__PURE__ */ S.createElement(wq, {
    disabled: $
  }, wt)), /* @__PURE__ */ S.createElement(Qr.Provider, {
    value: wn
  }, wt);
}, tc = (e) => {
  const t = S.useContext(Qr), r = S.useContext(Dz);
  return /* @__PURE__ */ S.createElement(Wce, Object.assign({
    parentContext: t,
    legacyLocale: r
  }, e));
};
tc.ConfigContext = Qr;
tc.SizeContext = Sx;
tc.config = Hce;
tc.useConfig = Iue;
Object.defineProperty(tc, "SizeContext", {
  get: () => (process.env.NODE_ENV !== "production" && nC(!1, "ConfigProvider", "ConfigProvider.SizeContext is deprecated. Please use `ConfigProvider.useConfig().componentSize` instead."), Sx)
});
process.env.NODE_ENV !== "production" && (tc.displayName = "ConfigProvider");
var Vce = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z" } }] }, name: "check-circle", theme: "filled" };
function Vq(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
}
function _ce(e) {
  return Vq(e) instanceof ShadowRoot;
}
function Hk(e) {
  return _ce(e) ? Vq(e) : null;
}
function Bce(e) {
  return e.replace(/-(.)/g, function(t, r) {
    return r.toUpperCase();
  });
}
function Uce(e, t) {
  $n(e, "[@ant-design/icons] ".concat(t));
}
function $H(e) {
  return Hn(e) === "object" && typeof e.name == "string" && typeof e.theme == "string" && (Hn(e.icon) === "object" || typeof e.icon == "function");
}
function zH() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return Object.keys(e).reduce(function(t, r) {
    var a = e[r];
    switch (r) {
      case "class":
        t.className = a, delete t.class;
        break;
      default:
        delete t[r], t[Bce(r)] = a;
    }
    return t;
  }, {});
}
function sD(e, t, r) {
  return r ? /* @__PURE__ */ Re.createElement(e.tag, ce(ce({
    key: t
  }, zH(e.attrs)), r), (e.children || []).map(function(a, i) {
    return sD(a, "".concat(t, "-").concat(e.tag, "-").concat(i));
  })) : /* @__PURE__ */ Re.createElement(e.tag, ce({
    key: t
  }, zH(e.attrs)), (e.children || []).map(function(a, i) {
    return sD(a, "".concat(t, "-").concat(e.tag, "-").concat(i));
  }));
}
function _q(e) {
  return TE(e)[0];
}
function Bq(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
var Xce = `
.anticon {
  display: inline-flex;
  align-items: center;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin::before,
.anticon-spin {
  display: inline-block;
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`, Gce = function(t) {
  var r = Do(Nz), a = r.csp, i = r.prefixCls, c = r.layer, d = Xce;
  i && (d = d.replace(/anticon/g, i)), c && (d = "@layer ".concat(c, ` {
`).concat(d, `
}`)), Er(function() {
    var f = t.current, p = Hk(f);
    oS(d, "@ant-design-icons", {
      prepend: !c,
      csp: a,
      attachTo: p
    });
  }, []);
}, qce = ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"], dE = {
  primaryColor: "#333",
  secondaryColor: "#E6E6E6",
  calculated: !1
};
function Kce(e) {
  var t = e.primaryColor, r = e.secondaryColor;
  dE.primaryColor = t, dE.secondaryColor = r || _q(t), dE.calculated = !!r;
}
function Yce() {
  return ce({}, dE);
}
var Vx = function(t) {
  var r = t.icon, a = t.className, i = t.onClick, c = t.style, d = t.primaryColor, f = t.secondaryColor, p = xr(t, qce), g = S.useRef(), b = dE;
  if (d && (b = {
    primaryColor: d,
    secondaryColor: f || _q(d)
  }), Gce(g), Uce($H(r), "icon should be icon definiton, but got ".concat(r)), !$H(r))
    return null;
  var w = r;
  return w && typeof w.icon == "function" && (w = ce(ce({}, w), {}, {
    icon: w.icon(b.primaryColor, b.secondaryColor)
  })), sD(w.icon, "svg-".concat(w.name), ce(ce({
    className: a,
    onClick: i,
    style: c,
    "data-icon": w.name,
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, p), {}, {
    ref: g
  }));
};
Vx.displayName = "IconReact";
Vx.getTwoToneColors = Yce;
Vx.setTwoToneColors = Kce;
function Uq(e) {
  var t = Bq(e), r = qe(t, 2), a = r[0], i = r[1];
  return Vx.setTwoToneColors({
    primaryColor: a,
    secondaryColor: i
  });
}
function Qce() {
  var e = Vx.getTwoToneColors();
  return e.calculated ? [e.primaryColor, e.secondaryColor] : e.primaryColor;
}
var Jce = ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"];
Uq(wx.primary);
var Ao = /* @__PURE__ */ S.forwardRef(function(e, t) {
  var r = e.className, a = e.icon, i = e.spin, c = e.rotate, d = e.tabIndex, f = e.onClick, p = e.twoToneColor, g = xr(e, Jce), b = S.useContext(Nz), w = b.prefixCls, x = w === void 0 ? "anticon" : w, E = b.rootClassName, P = _e(E, x, ge(ge({}, "".concat(x, "-").concat(a.name), !!a.name), "".concat(x, "-spin"), !!i || a.name === "loading"), r), k = d;
  k === void 0 && f && (k = -1);
  var M = c ? {
    msTransform: "rotate(".concat(c, "deg)"),
    transform: "rotate(".concat(c, "deg)")
  } : void 0, T = Bq(p), N = qe(T, 2), D = N[0], $ = N[1];
  return /* @__PURE__ */ S.createElement("span", vt({
    role: "img",
    "aria-label": a.name
  }, g, {
    ref: t,
    tabIndex: k,
    onClick: f,
    className: P
  }), /* @__PURE__ */ S.createElement(Vx, {
    icon: a,
    primaryColor: D,
    secondaryColor: $,
    style: M
  }));
});
Ao.displayName = "AntdIcon";
Ao.getTwoToneColor = Qce;
Ao.setTwoToneColor = Uq;
var Zce = function(t, r) {
  return /* @__PURE__ */ S.createElement(Ao, vt({}, t, {
    ref: r,
    icon: Vce
  }));
}, z9 = /* @__PURE__ */ S.forwardRef(Zce);
process.env.NODE_ENV !== "production" && (z9.displayName = "CheckCircleFilled");
var ede = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z" } }] }, name: "close-circle", theme: "filled" }, tde = function(t, r) {
  return /* @__PURE__ */ S.createElement(Ao, vt({}, t, {
    ref: r,
    icon: ede
  }));
}, _x = /* @__PURE__ */ S.forwardRef(tde);
process.env.NODE_ENV !== "production" && (_x.displayName = "CloseCircleFilled");
var nde = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z" } }] }, name: "close", theme: "outlined" }, rde = function(t, r) {
  return /* @__PURE__ */ S.createElement(Ao, vt({}, t, {
    ref: r,
    icon: nde
  }));
}, Bx = /* @__PURE__ */ S.forwardRef(rde);
process.env.NODE_ENV !== "production" && (Bx.displayName = "CloseOutlined");
var ade = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, name: "exclamation-circle", theme: "filled" }, ode = function(t, r) {
  return /* @__PURE__ */ S.createElement(Ao, vt({}, t, {
    ref: r,
    icon: ade
  }));
}, jz = /* @__PURE__ */ S.forwardRef(ode);
process.env.NODE_ENV !== "production" && (jz.displayName = "ExclamationCircleFilled");
var ide = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, name: "info-circle", theme: "filled" }, lde = function(t, r) {
  return /* @__PURE__ */ S.createElement(Ao, vt({}, t, {
    ref: r,
    icon: ide
  }));
}, Iz = /* @__PURE__ */ S.forwardRef(lde);
process.env.NODE_ENV !== "production" && (Iz.displayName = "InfoCircleFilled");
var sde = `accept acceptCharset accessKey action allowFullScreen allowTransparency
    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge
    charSet checked classID className colSpan cols content contentEditable contextMenu
    controls coords crossOrigin data dateTime default defer dir disabled download draggable
    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder
    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity
    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media
    mediaGroup method min minLength multiple muted name noValidate nonce open
    optimum pattern placeholder poster preload radioGroup readOnly rel required
    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected
    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style
    summary tabIndex target title type useMap value width wmode wrap`, ude = `onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown
    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick
    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown
    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel
    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough
    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata
    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError`, cde = "".concat(sde, " ").concat(ude).split(/[\s\n]+/), dde = "aria-", fde = "data-";
function jH(e, t) {
  return e.indexOf(t) === 0;
}
function Zu(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r;
  t === !1 ? r = {
    aria: !0,
    data: !0,
    attr: !0
  } : t === !0 ? r = {
    aria: !0
  } : r = ce({}, t);
  var a = {};
  return Object.keys(e).forEach(function(i) {
    // Aria
    (r.aria && (i === "role" || jH(i, dde)) || // Data
    r.data && jH(i, fde) || // Attr
    r.attr && cde.includes(i)) && (a[i] = e[i]);
  }), a;
}
function Xq(e) {
  return e && /* @__PURE__ */ Re.isValidElement(e) && e.type === Re.Fragment;
}
const mde = (e, t, r) => /* @__PURE__ */ Re.isValidElement(e) ? /* @__PURE__ */ Re.cloneElement(e, typeof r == "function" ? r(e.props || {}) : r) : t;
function up(e, t) {
  return mde(e, e, t);
}
function uD(e) {
  return e != null && e === e.window;
}
const hde = (e) => {
  var t, r;
  if (typeof window > "u")
    return 0;
  let a = 0;
  return uD(e) ? a = e.pageYOffset : e instanceof Document ? a = e.documentElement.scrollTop : (e instanceof HTMLElement || e) && (a = e.scrollTop), e && !uD(e) && typeof a != "number" && (a = (r = ((t = e.ownerDocument) !== null && t !== void 0 ? t : e).documentElement) === null || r === void 0 ? void 0 : r.scrollTop), a;
};
function pde(e, t, r, a) {
  const i = r - t;
  return e /= a / 2, e < 1 ? i / 2 * e * e * e + t : i / 2 * ((e -= 2) * e * e + 2) + t;
}
function gde(e, t = {}) {
  const {
    getContainer: r = () => window,
    callback: a,
    duration: i = 450
  } = t, c = r(), d = hde(c), f = Date.now(), p = () => {
    const b = Date.now() - f, w = pde(b > i ? i : b, d, e, i);
    uD(c) ? c.scrollTo(window.pageXOffset, w) : c instanceof Document || c.constructor.name === "HTMLDocument" ? c.documentElement.scrollTop = w : c.scrollTop = w, b < i ? Pa(p) : typeof a == "function" && a();
  };
  Pa(p);
}
const Qh = (e) => {
  const [, , , , t] = Bf();
  return t ? `${e}-css-var` : "";
};
var fn = {
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33,
  // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,
  // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35,
  // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36,
  // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST
  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40,
  // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46,
  /**
   * N
   */
  N: 78,
  /**
   * P
   */
  P: 80,
  /**
   * META
   */
  META: 91,
  // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187,
  // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224
}, vde = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z" } }] }, name: "loading", theme: "outlined" }, bde = function(t, r) {
  return /* @__PURE__ */ S.createElement(Ao, vt({}, t, {
    ref: r,
    icon: vde
  }));
}, xx = /* @__PURE__ */ S.forwardRef(bde);
process.env.NODE_ENV !== "production" && (xx.displayName = "LoadingOutlined");
function Fk(...e) {
  const t = {};
  return e.forEach((r) => {
    r && Object.keys(r).forEach((a) => {
      r[a] !== void 0 && (t[a] = r[a]);
    });
  }), t;
}
function Wk(e) {
  if (!e)
    return;
  const {
    closable: t,
    closeIcon: r
  } = e;
  return {
    closable: t,
    closeIcon: r
  };
}
function IH(e) {
  const {
    closable: t,
    closeIcon: r
  } = e || {};
  return Re.useMemo(() => {
    if (
      // If `closable`, whatever rest be should be true
      !t && (t === !1 || r === !1 || r === null)
    )
      return !1;
    if (t === void 0 && r === void 0)
      return null;
    let a = {
      closeIcon: typeof r != "boolean" && r !== null ? r : void 0
    };
    return t && typeof t == "object" && (a = Object.assign(Object.assign({}, a), t)), a;
  }, [t, r]);
}
const yde = {}, Gq = (e, t, r = yde) => {
  const a = IH(e), i = IH(t), [c] = q1("global", vb.global), d = typeof a != "boolean" ? !!a?.disabled : !1, f = Re.useMemo(() => Object.assign({
    closeIcon: /* @__PURE__ */ Re.createElement(Bx, null)
  }, r), [r]), p = Re.useMemo(() => a === !1 ? !1 : a ? Fk(f, i, a) : i === !1 ? !1 : i ? Fk(f, i) : f.closable ? f : !1, [a, i, f]);
  return Re.useMemo(() => {
    var g, b;
    if (p === !1)
      return [!1, null, d, {}];
    const {
      closeIconRender: w
    } = f, {
      closeIcon: x
    } = p;
    let E = x;
    const P = Zu(p, !0);
    return E != null && (w && (E = w(x)), E = /* @__PURE__ */ Re.isValidElement(E) ? /* @__PURE__ */ Re.cloneElement(E, Object.assign(Object.assign(Object.assign({}, E.props), {
      "aria-label": (b = (g = E.props) === null || g === void 0 ? void 0 : g["aria-label"]) !== null && b !== void 0 ? b : c.close
    }), P)) : /* @__PURE__ */ Re.createElement("span", Object.assign({
      "aria-label": c.close
    }, P), E)), [!0, E, d, P];
  }, [d, c.close, p, f]);
}, Lz = () => Re.useReducer((e) => e + 1, 0);
function qq(e, ...t) {
  const r = e || {};
  return t.reduce((a, i) => (Object.keys(i || {}).forEach((c) => {
    const d = r[c], f = i[c];
    if (d && typeof d == "object")
      if (f && typeof f == "object")
        a[c] = qq(d, a[c], f);
      else {
        const {
          _default: p
        } = d;
        p && (a[c] = a[c] || {}, a[c][p] = _e(a[c][p], f));
      }
    else
      a[c] = _e(a[c], f);
  }), a), {});
}
function wde(e, ...t) {
  return S.useMemo(() => qq.apply(void 0, [e].concat(t)), [t, e]);
}
function Sde(...e) {
  return S.useMemo(() => e.reduce((t, r = {}) => (Object.keys(r).forEach((a) => {
    t[a] = Object.assign(Object.assign({}, t[a]), r[a]);
  }), t), {}), [e]);
}
function cD(e, t) {
  const r = Object.assign({}, e);
  return Object.keys(t).forEach((a) => {
    if (a !== "_default") {
      const i = t[a], c = r[a] || {};
      r[a] = i ? cD(c, i) : c;
    }
  }), r;
}
const Cde = (e, t, r) => {
  const a = wde.apply(void 0, [r].concat(Et(e))), i = Sde.apply(void 0, Et(t));
  return S.useMemo(() => [cD(a, r), cD(i, r)], [a, i, r]);
}, xde = (e) => {
  const [t, r] = Wn(null);
  return [Cn((i, c, d) => {
    const f = t ?? i, p = Math.min(f || 0, i), g = Math.max(f || 0, i), b = c.slice(p, g + 1).map(e), w = b.some((E) => !d.has(E)), x = [];
    return b.forEach((E) => {
      w ? (d.has(E) || x.push(E), d.add(E)) : (d.delete(E), x.push(E));
    }), r(w ? g : null), x;
  }, [t]), r];
}, Ede = () => {
  const [e, t] = S.useState([]), r = S.useCallback((a) => (t((i) => [].concat(Et(i), [a])), () => {
    t((i) => i.filter((c) => c !== a));
  }), []);
  return [e, r];
};
function Pde(e, t) {
  return e._antProxy = e._antProxy || {}, Object.keys(t).forEach((r) => {
    if (!(r in e._antProxy)) {
      const a = e[r];
      e._antProxy[r] = a, e[r] = t[r];
    }
  }), e;
}
const kde = (e, t) => pS(e, () => {
  const r = t(), {
    nativeElement: a
  } = r;
  return typeof Proxy < "u" ? new Proxy(a, {
    get(i, c) {
      return r[c] ? r[c] : Reflect.get(i, c);
    }
  }) : Pde(a, r);
}), Mde = (e) => {
  const t = S.useRef(e), [, r] = Lz();
  return [() => t.current, (a) => {
    t.current = a, r();
  }];
}, Ux = /* @__PURE__ */ Re.createContext(void 0);
process.env.NODE_ENV !== "production" && (Ux.displayName = "zIndexContext");
const Kw = 100, Ode = 10, Kq = Kw * Ode, Tde = Kq + Kw, Yq = {
  Modal: Kw,
  Drawer: Kw,
  Popover: Kw,
  Popconfirm: Kw,
  Tooltip: Kw,
  Tour: Kw,
  FloatButton: Kw
}, Rde = {
  SelectLike: 50,
  Dropdown: 50,
  DatePicker: 50,
  Menu: 50,
  ImagePreview: 1
};
function Ade(e) {
  return e in Yq;
}
const vS = (e, t) => {
  const [, r] = Bf(), a = Re.useContext(Ux), i = Ade(e);
  let c;
  if (t !== void 0)
    c = [t, t];
  else {
    let d = a ?? 0;
    i ? d += // Use preset token zIndex by default but not stack when has parent container
    (a ? 0 : r.zIndexPopupBase) + // Container offset
    Yq[e] : d += Rde[e], c = [a === void 0 ? t : d, d];
  }
  if (process.env.NODE_ENV !== "production") {
    const d = To(e), f = r.zIndexPopupBase + Tde, p = c[0] || 0;
    process.env.NODE_ENV !== "production" && d(t !== void 0 || p <= f, "usage", "`zIndex` is over design token `zIndexPopupBase` too much. It may cause unexpected override.");
  }
  return c;
};
function Qq(e, t) {
  this.v = e, this.k = t;
}
function Qf(e, t, r, a) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch {
    i = 0;
  }
  Qf = function(d, f, p, g) {
    function b(w, x) {
      Qf(d, w, function(E) {
        return this._invoke(w, x, E);
      });
    }
    f ? i ? i(d, f, {
      value: p,
      enumerable: !g,
      configurable: !g,
      writable: !g
    }) : d[f] = p : (b("next", 0), b("throw", 1), b("return", 2));
  }, Qf(e, t, r, a);
}
function Hz() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e, t, r = typeof Symbol == "function" ? Symbol : {}, a = r.iterator || "@@iterator", i = r.toStringTag || "@@toStringTag";
  function c(E, P, k, M) {
    var T = P && P.prototype instanceof f ? P : f, N = Object.create(T.prototype);
    return Qf(N, "_invoke", (function(D, $, j) {
      var I, L, F, _ = 0, W = j || [], Q = !1, U = {
        p: 0,
        n: 0,
        v: e,
        a: Y,
        f: Y.bind(e, 4),
        d: function(J, H) {
          return I = J, L = 0, F = e, U.n = H, d;
        }
      };
      function Y(G, J) {
        for (L = G, F = J, t = 0; !Q && _ && !H && t < W.length; t++) {
          var H, K = W[t], X = U.p, te = K[2];
          G > 3 ? (H = te === J) && (F = K[(L = K[4]) ? 5 : (L = 3, 3)], K[4] = K[5] = e) : K[0] <= X && ((H = G < 2 && X < K[1]) ? (L = 0, U.v = J, U.n = K[1]) : X < te && (H = G < 3 || K[0] > J || J > te) && (K[4] = G, K[5] = J, U.n = te, L = 0));
        }
        if (H || G > 1) return d;
        throw Q = !0, J;
      }
      return function(G, J, H) {
        if (_ > 1) throw TypeError("Generator is already running");
        for (Q && J === 1 && Y(J, H), L = J, F = H; (t = L < 2 ? e : F) || !Q; ) {
          I || (L ? L < 3 ? (L > 1 && (U.n = -1), Y(L, F)) : U.n = F : U.v = F);
          try {
            if (_ = 2, I) {
              if (L || (G = "next"), t = I[G]) {
                if (!(t = t.call(I, F))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                F = t.value, L < 2 && (L = 0);
              } else L === 1 && (t = I.return) && t.call(I), L < 2 && (F = TypeError("The iterator does not provide a '" + G + "' method"), L = 1);
              I = e;
            } else if ((t = (Q = U.n < 0) ? F : D.call($, U)) !== d) break;
          } catch (K) {
            I = e, L = 1, F = K;
          } finally {
            _ = 1;
          }
        }
        return {
          value: t,
          done: Q
        };
      };
    })(E, k, M), !0), N;
  }
  var d = {};
  function f() {
  }
  function p() {
  }
  function g() {
  }
  t = Object.getPrototypeOf;
  var b = [][a] ? t(t([][a]())) : (Qf(t = {}, a, function() {
    return this;
  }), t), w = g.prototype = f.prototype = Object.create(b);
  function x(E) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(E, g) : (E.__proto__ = g, Qf(E, i, "GeneratorFunction")), E.prototype = Object.create(w), E;
  }
  return p.prototype = g, Qf(w, "constructor", g), Qf(g, "constructor", p), p.displayName = "GeneratorFunction", Qf(g, i, "GeneratorFunction"), Qf(w), Qf(w, i, "Generator"), Qf(w, a, function() {
    return this;
  }), Qf(w, "toString", function() {
    return "[object Generator]";
  }), (Hz = function() {
    return {
      w: c,
      m: x
    };
  })();
}
function Vk(e, t) {
  function r(i, c, d, f) {
    try {
      var p = e[i](c), g = p.value;
      return g instanceof Qq ? t.resolve(g.v).then(function(b) {
        r("next", b, d, f);
      }, function(b) {
        r("throw", b, d, f);
      }) : t.resolve(g).then(function(b) {
        p.value = b, d(p);
      }, function(b) {
        return r("throw", b, d, f);
      });
    } catch (b) {
      f(b);
    }
  }
  var a;
  this.next || (Qf(Vk.prototype), Qf(Vk.prototype, typeof Symbol == "function" && Symbol.asyncIterator || "@asyncIterator", function() {
    return this;
  })), Qf(this, "_invoke", function(i, c, d) {
    function f() {
      return new t(function(p, g) {
        r(i, d, p, g);
      });
    }
    return a = a ? a.then(f, f) : f();
  }, !0);
}
function Jq(e, t, r, a, i) {
  return new Vk(Hz().w(e, t, r, a), i || Promise);
}
function Nde(e, t, r, a, i) {
  var c = Jq(e, t, r, a, i);
  return c.next().then(function(d) {
    return d.done ? d.value : c.next();
  });
}
function Dde(e) {
  var t = Object(e), r = [];
  for (var a in t) r.unshift(a);
  return function i() {
    for (; r.length; ) if ((a = r.pop()) in t) return i.value = a, i.done = !1, i;
    return i.done = !0, i;
  };
}
function LH(e) {
  if (e != null) {
    var t = e[typeof Symbol == "function" && Symbol.iterator || "@@iterator"], r = 0;
    if (t) return t.call(e);
    if (typeof e.next == "function") return e;
    if (!isNaN(e.length)) return {
      next: function() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(Hn(e) + " is not iterable");
}
function ci() {
  var e = Hz(), t = e.m(ci), r = (Object.getPrototypeOf ? Object.getPrototypeOf(t) : t.__proto__).constructor;
  function a(d) {
    var f = typeof d == "function" && d.constructor;
    return !!f && (f === r || (f.displayName || f.name) === "GeneratorFunction");
  }
  var i = {
    throw: 1,
    return: 2,
    break: 3,
    continue: 3
  };
  function c(d) {
    var f, p;
    return function(g) {
      f || (f = {
        stop: function() {
          return p(g.a, 2);
        },
        catch: function() {
          return g.v;
        },
        abrupt: function(w, x) {
          return p(g.a, i[w], x);
        },
        delegateYield: function(w, x, E) {
          return f.resultName = x, p(g.d, LH(w), E);
        },
        finish: function(w) {
          return p(g.f, w);
        }
      }, p = function(w, x, E) {
        g.p = f.prev, g.n = f.next;
        try {
          return w(x, E);
        } finally {
          f.next = g.n;
        }
      }), f.resultName && (f[f.resultName] = g.v, f.resultName = void 0), f.sent = g.v, f.next = g.n;
      try {
        return d.call(this, f);
      } finally {
        g.p = f.prev, g.n = f.next;
      }
    };
  }
  return (ci = function() {
    return {
      wrap: function(p, g, b, w) {
        return e.w(c(p), g, b, w && w.reverse());
      },
      isGeneratorFunction: a,
      mark: e.m,
      awrap: function(p, g) {
        return new Qq(p, g);
      },
      AsyncIterator: Vk,
      async: function(p, g, b, w, x) {
        return (a(g) ? Jq : Nde)(c(p), g, b, w, x);
      },
      keys: Dde,
      values: LH
    };
  })();
}
function HH(e, t, r, a, i, c, d) {
  try {
    var f = e[c](d), p = f.value;
  } catch (g) {
    return void r(g);
  }
  f.done ? t(p) : Promise.resolve(p).then(a, i);
}
function qh(e) {
  return function() {
    var t = this, r = arguments;
    return new Promise(function(a, i) {
      var c = e.apply(t, r);
      function d(p) {
        HH(c, a, i, d, f, "next", p);
      }
      function f(p) {
        HH(c, a, i, d, f, "throw", p);
      }
      d(void 0);
    });
  };
}
var _E = ce({}, sp), $de = _E.version, BT = _E.render, zde = _E.unmountComponentAtNode, j9;
try {
  var jde = Number(($de || "").split(".")[0]);
  jde >= 18 && (j9 = _E.createRoot);
} catch {
}
function FH(e) {
  var t = _E.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  t && Hn(t) === "object" && (t.usingClientEntryPoint = e);
}
var _k = "__rc_react_root__";
function Ide(e, t) {
  FH(!0);
  var r = t[_k] || j9(t);
  FH(!1), r.render(e), t[_k] = r;
}
function Lde(e, t) {
  BT?.(e, t);
}
function Hde(e, t) {
  if (j9) {
    Ide(e, t);
    return;
  }
  Lde(e, t);
}
function Fde(e) {
  return dD.apply(this, arguments);
}
function dD() {
  return dD = qh(/* @__PURE__ */ ci().mark(function e(t) {
    return ci().wrap(function(a) {
      for (; ; ) switch (a.prev = a.next) {
        case 0:
          return a.abrupt("return", Promise.resolve().then(function() {
            var i;
            (i = t[_k]) === null || i === void 0 || i.unmount(), delete t[_k];
          }));
        case 1:
        case "end":
          return a.stop();
      }
    }, e);
  })), dD.apply(this, arguments);
}
function Wde(e) {
  zde(e);
}
function Vde(e) {
  return fD.apply(this, arguments);
}
function fD() {
  return fD = qh(/* @__PURE__ */ ci().mark(function e(t) {
    return ci().wrap(function(a) {
      for (; ; ) switch (a.prev = a.next) {
        case 0:
          if (j9 === void 0) {
            a.next = 2;
            break;
          }
          return a.abrupt("return", Fde(t));
        case 2:
          Wde(t);
        case 3:
        case "end":
          return a.stop();
      }
    }, e);
  })), fD.apply(this, arguments);
}
const _de = (e, t) => {
  if (process.env.NODE_ENV !== "production") {
    const r = Number.parseInt(S.version.split(".")[0], 10), a = Object.keys(sp);
    process.env.NODE_ENV !== "production" && nC(r < 19 || a.includes("createRoot"), "compatible", "antd v5 support React is 16 ~ 18. see https://u.ant.design/v5-for-19 for compatible.");
  }
  return Hde(e, t), () => Vde(t);
};
let WH = _de;
function Fz(e) {
  return e && (WH = e), WH;
}
const UT = () => ({
  height: 0,
  opacity: 0
}), VH = (e) => {
  const {
    scrollHeight: t
  } = e;
  return {
    height: t,
    opacity: 1
  };
}, Bde = (e) => ({
  height: e ? e.offsetHeight : 0
}), XT = (e, t) => t?.deadline === !0 || t.propertyName === "height", Wz = (e = RE) => ({
  motionName: `${e}-motion-collapse`,
  onAppearStart: UT,
  onEnterStart: UT,
  onAppearActive: VH,
  onEnterActive: VH,
  onLeaveStart: Bde,
  onLeaveActive: UT,
  onAppearEnd: XT,
  onEnterEnd: XT,
  onLeaveEnd: XT,
  motionDeadline: 500
}), uS = (e, t, r) => r !== void 0 ? r : `${e}-${t}`;
function Rs(e, t) {
  var r = Object.assign({}, e);
  return Array.isArray(t) && t.forEach(function(a) {
    delete r[a];
  }), r;
}
const BE = (function(e) {
  if (!e)
    return !1;
  if (e instanceof Element) {
    if (e.offsetParent)
      return !0;
    if (e.getBBox) {
      var t = e.getBBox(), r = t.width, a = t.height;
      if (r || a)
        return !0;
    }
    if (e.getBoundingClientRect) {
      var i = e.getBoundingClientRect(), c = i.width, d = i.height;
      if (c || d)
        return !0;
    }
  }
  return !1;
}), Ude = (e) => {
  const {
    componentCls: t,
    colorPrimary: r
  } = e;
  return {
    [t]: {
      position: "absolute",
      background: "transparent",
      pointerEvents: "none",
      boxSizing: "border-box",
      color: `var(--wave-color, ${r})`,
      boxShadow: "0 0 0 0 currentcolor",
      opacity: 0.2,
      // =================== Motion ===================
      "&.wave-motion-appear": {
        transition: [`box-shadow 0.4s ${e.motionEaseOutCirc}`, `opacity 2s ${e.motionEaseOutCirc}`].join(","),
        "&-active": {
          boxShadow: "0 0 0 6px currentcolor",
          opacity: 0
        },
        "&.wave-quick": {
          transition: [`box-shadow ${e.motionDurationSlow} ${e.motionEaseInOut}`, `opacity ${e.motionDurationSlow} ${e.motionEaseInOut}`].join(",")
        }
      }
    }
  };
}, Xde = rce("Wave", Ude), I9 = `${RE}-wave-target`;
function Gde(e) {
  return e && e !== "#fff" && e !== "#ffffff" && e !== "rgb(255, 255, 255)" && e !== "rgba(255, 255, 255, 1)" && !/rgba\((?:\d*, ){3}0\)/.test(e) && // any transparent rgba color
  e !== "transparent" && e !== "canvastext";
}
function qde(e) {
  var t;
  const {
    borderTopColor: r,
    borderColor: a,
    backgroundColor: i
  } = getComputedStyle(e);
  return (t = [r, a, i].find(Gde)) !== null && t !== void 0 ? t : null;
}
function GT(e) {
  return Number.isNaN(e) ? 0 : e;
}
const Kde = (e) => {
  const {
    className: t,
    target: r,
    component: a,
    registerUnmount: i
  } = e, c = S.useRef(null), d = S.useRef(null);
  S.useEffect(() => {
    d.current = i();
  }, []);
  const [f, p] = S.useState(null), [g, b] = S.useState([]), [w, x] = S.useState(0), [E, P] = S.useState(0), [k, M] = S.useState(0), [T, N] = S.useState(0), [D, $] = S.useState(!1), j = {
    left: w,
    top: E,
    width: k,
    height: T,
    borderRadius: g.map((F) => `${F}px`).join(" ")
  };
  f && (j["--wave-color"] = f);
  function I() {
    const F = getComputedStyle(r);
    p(qde(r));
    const _ = F.position === "static", {
      borderLeftWidth: W,
      borderTopWidth: Q
    } = F;
    x(_ ? r.offsetLeft : GT(-Number.parseFloat(W))), P(_ ? r.offsetTop : GT(-Number.parseFloat(Q))), M(r.offsetWidth), N(r.offsetHeight);
    const {
      borderTopLeftRadius: U,
      borderTopRightRadius: Y,
      borderBottomLeftRadius: G,
      borderBottomRightRadius: J
    } = F;
    b([U, Y, J, G].map((H) => GT(Number.parseFloat(H))));
  }
  if (S.useEffect(() => {
    if (r) {
      const F = Pa(() => {
        I(), $(!0);
      });
      let _;
      return typeof ResizeObserver < "u" && (_ = new ResizeObserver(I), _.observe(r)), () => {
        Pa.cancel(F), _?.disconnect();
      };
    }
  }, [r]), !D)
    return null;
  const L = (a === "Checkbox" || a === "Radio") && r?.classList.contains(I9);
  return /* @__PURE__ */ S.createElement(N0, {
    visible: !0,
    motionAppear: !0,
    motionName: "wave-motion",
    motionDeadline: 5e3,
    onAppearEnd: (F, _) => {
      var W, Q;
      if (_.deadline || _.propertyName === "opacity") {
        const U = (W = c.current) === null || W === void 0 ? void 0 : W.parentElement;
        (Q = d.current) === null || Q === void 0 || Q.call(d).then(() => {
          U?.remove();
        });
      }
      return !1;
    }
  }, ({
    className: F
  }, _) => /* @__PURE__ */ S.createElement("div", {
    ref: mp(c, _),
    className: _e(t, F, {
      "wave-quick": L
    }),
    style: j
  }));
}, Yde = (e, t) => {
  var r;
  const {
    component: a
  } = t;
  if (a === "Checkbox" && !(!((r = e.querySelector("input")) === null || r === void 0) && r.checked))
    return;
  const i = document.createElement("div");
  i.style.position = "absolute", i.style.left = "0px", i.style.top = "0px", e?.insertBefore(i, e?.firstChild);
  const c = Fz();
  let d = null;
  function f() {
    return d;
  }
  d = c(/* @__PURE__ */ S.createElement(Kde, Object.assign({}, t, {
    target: e,
    registerUnmount: f
  })), i);
}, Qde = (e, t, r) => {
  const {
    wave: a
  } = S.useContext(Qr), [, i, c] = Bf(), d = ra((g) => {
    const b = e.current;
    if (a?.disabled || !b)
      return;
    const w = b.querySelector(`.${I9}`) || b, {
      showEffect: x
    } = a || {};
    (x || Yde)(w, {
      className: t,
      token: i,
      component: r,
      event: g,
      hashId: c
    });
  }), f = S.useRef(null);
  return (g) => {
    Pa.cancel(f.current), f.current = Pa(() => {
      d(g);
    });
  };
}, L9 = (e) => {
  const {
    children: t,
    disabled: r,
    component: a
  } = e, {
    getPrefixCls: i
  } = Do(Qr), c = It(null), d = i("wave"), [, f] = Xde(d), p = Qde(c, _e(d, f), a);
  if (Re.useEffect(() => {
    const b = c.current;
    if (!b || b.nodeType !== window.Node.ELEMENT_NODE || r)
      return;
    const w = (x) => {
      !BE(x.target) || // No need wave
      !b.getAttribute || b.getAttribute("disabled") || b.disabled || b.className.includes("disabled") && !b.className.includes("disabled:") || b.getAttribute("aria-disabled") === "true" || b.className.includes("-leave") || p(x);
    };
    return b.addEventListener("click", w, !0), () => {
      b.removeEventListener("click", w, !0);
    };
  }, [r]), !/* @__PURE__ */ Re.isValidElement(t))
    return t ?? null;
  const g = gb(t) ? mp(m3(t), c) : c;
  return up(t, {
    ref: g
  });
};
process.env.NODE_ENV !== "production" && (L9.displayName = "Wave");
const Cb = (e) => {
  const t = Re.useContext(Sx);
  return Re.useMemo(() => e ? typeof e == "string" ? e ?? t : typeof e == "function" ? e(t) : t : t, [e, t]);
}, Jde = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      display: "inline-flex",
      "&-block": {
        display: "flex",
        width: "100%"
      },
      "&-vertical": {
        flexDirection: "column"
      },
      "&-rtl": {
        direction: "rtl"
      }
    }
  };
}, Zde = Ii(["Space", "Compact"], (e) => [Jde(e)], () => ({}), {
  // Space component don't apply extra font style
  // https://github.com/ant-design/ant-design/issues/40315
  resetStyle: !1
});
var Zq = function(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
    t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
};
const H9 = /* @__PURE__ */ S.createContext(null), h3 = (e, t) => {
  const r = S.useContext(H9), a = S.useMemo(() => {
    if (!r)
      return "";
    const {
      compactDirection: i,
      isFirstItem: c,
      isLastItem: d
    } = r, f = i === "vertical" ? "-vertical-" : "-";
    return _e(`${e}-compact${f}item`, {
      [`${e}-compact${f}first-item`]: c,
      [`${e}-compact${f}last-item`]: d,
      [`${e}-compact${f}item-rtl`]: t === "rtl"
    });
  }, [e, t, r]);
  return {
    compactSize: r?.compactSize,
    compactDirection: r?.compactDirection,
    compactItemClassnames: a
  };
}, efe = (e) => {
  const {
    children: t
  } = e;
  return /* @__PURE__ */ S.createElement(H9.Provider, {
    value: null
  }, t);
}, tfe = (e) => {
  const {
    children: t
  } = e, r = Zq(e, ["children"]);
  return /* @__PURE__ */ S.createElement(H9.Provider, {
    value: S.useMemo(() => r, [r])
  }, t);
}, nfe = (e) => {
  const {
    getPrefixCls: t,
    direction: r
  } = S.useContext(Qr), {
    size: a,
    direction: i,
    block: c,
    prefixCls: d,
    className: f,
    rootClassName: p,
    children: g
  } = e, b = Zq(e, ["size", "direction", "block", "prefixCls", "className", "rootClassName", "children"]), w = Cb((D) => a ?? D), x = t("space-compact", d), [E, P] = Zde(x), k = _e(x, P, {
    [`${x}-rtl`]: r === "rtl",
    [`${x}-block`]: c,
    [`${x}-vertical`]: i === "vertical"
  }, f, p), M = S.useContext(H9), T = Kh(g), N = S.useMemo(() => T.map((D, $) => {
    const j = D?.key || `${x}-item-${$}`;
    return /* @__PURE__ */ S.createElement(tfe, {
      key: j,
      compactSize: w,
      compactDirection: i,
      isFirstItem: $ === 0 && (!M || M?.isFirstItem),
      isLastItem: $ === T.length - 1 && (!M || M?.isLastItem)
    }, D);
  }), [T, M, i, w, x]);
  return T.length === 0 ? null : E(/* @__PURE__ */ S.createElement("div", Object.assign({
    className: k
  }, b), N));
};
var rfe = function(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
    t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
};
const eK = /* @__PURE__ */ S.createContext(void 0), afe = (e) => {
  const {
    getPrefixCls: t,
    direction: r
  } = S.useContext(Qr), {
    prefixCls: a,
    size: i,
    className: c
  } = e, d = rfe(e, ["prefixCls", "size", "className"]), f = t("btn-group", a), [, , p] = Bf(), g = S.useMemo(() => {
    switch (i) {
      case "large":
        return "lg";
      case "small":
        return "sm";
      default:
        return "";
    }
  }, [i]);
  if (process.env.NODE_ENV !== "production") {
    const w = To("Button.Group");
    w.deprecated(!1, "Button.Group", "Space.Compact"), process.env.NODE_ENV !== "production" && w(!i || ["large", "small", "middle"].includes(i), "usage", "Invalid prop `size`.");
  }
  const b = _e(f, {
    [`${f}-${g}`]: g,
    [`${f}-rtl`]: r === "rtl"
  }, c, p);
  return /* @__PURE__ */ S.createElement(eK.Provider, {
    value: i
  }, /* @__PURE__ */ S.createElement("div", Object.assign({}, d, {
    className: b
  })));
}, _H = /^[\u4E00-\u9FA5]{2}$/, mD = _H.test.bind(_H);
function tK(e) {
  return e === "danger" ? {
    danger: !0
  } : {
    type: e
  };
}
function BH(e) {
  return typeof e == "string";
}
function F7(e) {
  return e === "text" || e === "link";
}
function ofe(e, t) {
  if (e == null)
    return;
  const r = t ? " " : "";
  return typeof e != "string" && typeof e != "number" && BH(e.type) && mD(e.props.children) ? up(e, {
    children: e.props.children.split("").join(r)
  }) : BH(e) ? mD(e) ? /* @__PURE__ */ Re.createElement("span", null, e.split("").join(r)) : /* @__PURE__ */ Re.createElement("span", null, e) : Xq(e) ? /* @__PURE__ */ Re.createElement("span", null, e) : e;
}
function ife(e, t) {
  let r = !1;
  const a = [];
  return Re.Children.forEach(e, (i) => {
    const c = typeof i, d = c === "string" || c === "number";
    if (r && d) {
      const f = a.length - 1, p = a[f];
      a[f] = `${p}${i}`;
    } else
      a.push(i);
    r = d;
  }), Re.Children.map(a, (i) => ofe(i, t));
}
["default", "primary", "danger"].concat(Et(WS));
const nK = /* @__PURE__ */ ks((e, t) => {
  const {
    className: r,
    style: a,
    children: i,
    prefixCls: c
  } = e, d = _e(`${c}-icon`, r);
  return /* @__PURE__ */ Re.createElement("span", {
    ref: t,
    className: d,
    style: a
  }, i);
}), UH = /* @__PURE__ */ ks((e, t) => {
  const {
    prefixCls: r,
    className: a,
    style: i,
    iconClassName: c
  } = e, d = _e(`${r}-loading-icon`, a);
  return /* @__PURE__ */ Re.createElement(nK, {
    prefixCls: r,
    className: d,
    style: i,
    ref: t
  }, /* @__PURE__ */ Re.createElement(xx, {
    className: c
  }));
}), qT = () => ({
  width: 0,
  opacity: 0,
  transform: "scale(0)"
}), KT = (e) => ({
  width: e.scrollWidth,
  opacity: 1,
  transform: "scale(1)"
}), lfe = (e) => {
  const {
    prefixCls: t,
    loading: r,
    existIcon: a,
    className: i,
    style: c,
    mount: d
  } = e, f = !!r;
  return a ? /* @__PURE__ */ Re.createElement(UH, {
    prefixCls: t,
    className: i,
    style: c
  }) : /* @__PURE__ */ Re.createElement(N0, {
    visible: f,
    // Used for minus flex gap style only
    motionName: `${t}-loading-icon-motion`,
    motionAppear: !d,
    motionEnter: !d,
    motionLeave: !d,
    removeOnLeave: !0,
    onAppearStart: qT,
    onAppearActive: KT,
    onEnterStart: qT,
    onEnterActive: KT,
    onLeaveStart: KT,
    onLeaveActive: qT
  }, ({
    className: p,
    style: g
  }, b) => {
    const w = Object.assign(Object.assign({}, c), g);
    return /* @__PURE__ */ Re.createElement(UH, {
      prefixCls: t,
      className: _e(i, p),
      style: w,
      ref: b
    });
  });
}, XH = (e, t) => ({
  // Border
  [`> span, > ${e}`]: {
    "&:not(:last-child)": {
      [`&, & > ${e}`]: {
        "&:not(:disabled)": {
          borderInlineEndColor: t
        }
      }
    },
    "&:not(:first-child)": {
      [`&, & > ${e}`]: {
        "&:not(:disabled)": {
          borderInlineStartColor: t
        }
      }
    }
  }
}), sfe = (e) => {
  const {
    componentCls: t,
    fontSize: r,
    lineWidth: a,
    groupBorderColor: i,
    colorErrorHover: c
  } = e;
  return {
    [`${t}-group`]: [
      {
        position: "relative",
        display: "inline-flex",
        // Border
        [`> span, > ${t}`]: {
          "&:not(:last-child)": {
            [`&, & > ${t}`]: {
              borderStartEndRadius: 0,
              borderEndEndRadius: 0
            }
          },
          "&:not(:first-child)": {
            marginInlineStart: e.calc(a).mul(-1).equal(),
            [`&, & > ${t}`]: {
              borderStartStartRadius: 0,
              borderEndStartRadius: 0
            }
          }
        },
        [t]: {
          position: "relative",
          zIndex: 1,
          "&:hover, &:focus, &:active": {
            zIndex: 2
          },
          "&[disabled]": {
            zIndex: 0
          }
        },
        [`${t}-icon-only`]: {
          fontSize: r
        }
      },
      // Border Color
      XH(`${t}-primary`, i),
      XH(`${t}-danger`, c)
    ]
  };
};
var ufe = ["b"], cfe = ["v"], YT = function(t) {
  return Math.round(Number(t || 0));
}, dfe = function(t) {
  if (t instanceof ro)
    return t;
  if (t && Hn(t) === "object" && "h" in t && "b" in t) {
    var r = t, a = r.b, i = xr(r, ufe);
    return ce(ce({}, i), {}, {
      v: a
    });
  }
  return typeof t == "string" && /hsb/.test(t) ? t.replace(/hsb/, "hsv") : t;
}, cS = /* @__PURE__ */ (function(e) {
  pd(r, e);
  var t = B0(r);
  function r(a) {
    return Vi(this, r), t.call(this, dfe(a));
  }
  return _i(r, [{
    key: "toHsbString",
    value: function() {
      var i = this.toHsb(), c = YT(i.s * 100), d = YT(i.b * 100), f = YT(i.h), p = i.a, g = "hsb(".concat(f, ", ").concat(c, "%, ").concat(d, "%)"), b = "hsba(".concat(f, ", ").concat(c, "%, ").concat(d, "%, ").concat(p.toFixed(p === 0 ? 0 : 2), ")");
      return p === 1 ? g : b;
    }
  }, {
    key: "toHsb",
    value: function() {
      var i = this.toHsv(), c = i.v, d = xr(i, cfe);
      return ce(ce({}, d), {}, {
        b: c,
        a: this.a
      });
    }
  }]), r;
})(ro), ffe = "rc-color-picker", nx = function(t) {
  return t instanceof cS ? t : new cS(t);
}, mfe = nx("#1677ff"), rK = function(t) {
  var r = t.offset, a = t.targetRef, i = t.containerRef, c = t.color, d = t.type, f = i.current.getBoundingClientRect(), p = f.width, g = f.height, b = a.current.getBoundingClientRect(), w = b.width, x = b.height, E = w / 2, P = x / 2, k = (r.x + E) / p, M = 1 - (r.y + P) / g, T = c.toHsb(), N = k, D = (r.x + E) / p * 360;
  if (d)
    switch (d) {
      case "hue":
        return nx(ce(ce({}, T), {}, {
          h: D <= 0 ? 0 : D
        }));
      case "alpha":
        return nx(ce(ce({}, T), {}, {
          a: N <= 0 ? 0 : N
        }));
    }
  return nx({
    h: T.h,
    s: k <= 0 ? 0 : k,
    b: M >= 1 ? 1 : M,
    a: T.a
  });
}, aK = function(t, r) {
  var a = t.toHsb();
  switch (r) {
    case "hue":
      return {
        x: a.h / 360 * 100,
        y: 50
      };
    case "alpha":
      return {
        x: t.a * 100,
        y: 50
      };
    // Picker panel
    default:
      return {
        x: a.s * 100,
        y: (1 - a.b) * 100
      };
  }
}, hfe = function(t) {
  var r = t.color, a = t.prefixCls, i = t.className, c = t.style, d = t.onClick, f = "".concat(a, "-color-block");
  return /* @__PURE__ */ Re.createElement("div", {
    className: _e(f, i),
    style: c,
    onClick: d
  }, /* @__PURE__ */ Re.createElement("div", {
    className: "".concat(f, "-inner"),
    style: {
      background: r
    }
  }));
};
function pfe(e) {
  var t = "touches" in e ? e.touches[0] : e, r = document.documentElement.scrollLeft || document.body.scrollLeft || window.pageXOffset, a = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
  return {
    pageX: t.pageX - r,
    pageY: t.pageY - a
  };
}
function oK(e) {
  var t = e.targetRef, r = e.containerRef, a = e.direction, i = e.onDragChange, c = e.onDragChangeComplete, d = e.calculate, f = e.color, p = e.disabledDrag, g = Wn({
    x: 0,
    y: 0
  }), b = qe(g, 2), w = b[0], x = b[1], E = It(null), P = It(null);
  Er(function() {
    x(d());
  }, [f]), Er(function() {
    return function() {
      document.removeEventListener("mousemove", E.current), document.removeEventListener("mouseup", P.current), document.removeEventListener("touchmove", E.current), document.removeEventListener("touchend", P.current), E.current = null, P.current = null;
    };
  }, []);
  var k = function($) {
    var j = pfe($), I = j.pageX, L = j.pageY, F = r.current.getBoundingClientRect(), _ = F.x, W = F.y, Q = F.width, U = F.height, Y = t.current.getBoundingClientRect(), G = Y.width, J = Y.height, H = G / 2, K = J / 2, X = Math.max(0, Math.min(I - _, Q)) - H, te = Math.max(0, Math.min(L - W, U)) - K, ie = {
      x: X,
      y: a === "x" ? w.y : te
    };
    if (G === 0 && J === 0 || G !== J)
      return !1;
    i?.(ie);
  }, M = function($) {
    $.preventDefault(), k($);
  }, T = function($) {
    $.preventDefault(), document.removeEventListener("mousemove", E.current), document.removeEventListener("mouseup", P.current), document.removeEventListener("touchmove", E.current), document.removeEventListener("touchend", P.current), E.current = null, P.current = null, c?.();
  }, N = function($) {
    document.removeEventListener("mousemove", E.current), document.removeEventListener("mouseup", P.current), !p && (k($), document.addEventListener("mousemove", M), document.addEventListener("mouseup", T), document.addEventListener("touchmove", M), document.addEventListener("touchend", T), E.current = M, P.current = T);
  };
  return [w, N];
}
var iK = function(t) {
  var r = t.size, a = r === void 0 ? "default" : r, i = t.color, c = t.prefixCls;
  return /* @__PURE__ */ Re.createElement("div", {
    className: _e("".concat(c, "-handler"), ge({}, "".concat(c, "-handler-sm"), a === "small")),
    style: {
      backgroundColor: i
    }
  });
}, lK = function(t) {
  var r = t.children, a = t.style, i = t.prefixCls;
  return /* @__PURE__ */ Re.createElement("div", {
    className: "".concat(i, "-palette"),
    style: ce({
      position: "relative"
    }, a)
  }, r);
}, sK = /* @__PURE__ */ ks(function(e, t) {
  var r = e.children, a = e.x, i = e.y;
  return /* @__PURE__ */ Re.createElement("div", {
    ref: t,
    style: {
      position: "absolute",
      left: "".concat(a, "%"),
      top: "".concat(i, "%"),
      zIndex: 1,
      transform: "translate(-50%, -50%)"
    }
  }, r);
}), gfe = function(t) {
  var r = t.color, a = t.onChange, i = t.prefixCls, c = t.onChangeComplete, d = t.disabled, f = It(), p = It(), g = It(r), b = ra(function(k) {
    var M = rK({
      offset: k,
      targetRef: p,
      containerRef: f,
      color: r
    });
    g.current = M, a(M);
  }), w = oK({
    color: r,
    containerRef: f,
    targetRef: p,
    calculate: function() {
      return aK(r);
    },
    onDragChange: b,
    onDragChangeComplete: function() {
      return c?.(g.current);
    },
    disabledDrag: d
  }), x = qe(w, 2), E = x[0], P = x[1];
  return /* @__PURE__ */ Re.createElement("div", {
    ref: f,
    className: "".concat(i, "-select"),
    onMouseDown: P,
    onTouchStart: P
  }, /* @__PURE__ */ Re.createElement(lK, {
    prefixCls: i
  }, /* @__PURE__ */ Re.createElement(sK, {
    x: E.x,
    y: E.y,
    ref: p
  }, /* @__PURE__ */ Re.createElement(iK, {
    color: r.toRgbString(),
    prefixCls: i
  })), /* @__PURE__ */ Re.createElement("div", {
    className: "".concat(i, "-saturation"),
    style: {
      backgroundColor: "hsl(".concat(r.toHsb().h, ",100%, 50%)"),
      backgroundImage: "linear-gradient(0deg, #000, transparent),linear-gradient(90deg, #fff, hsla(0, 0%, 100%, 0))"
    }
  })));
}, vfe = function(t, r) {
  var a = ll(t, {
    value: r
  }), i = qe(a, 2), c = i[0], d = i[1], f = mn(function() {
    return nx(c);
  }, [c]);
  return [f, d];
}, bfe = function(t) {
  var r = t.colors, a = t.children, i = t.direction, c = i === void 0 ? "to right" : i, d = t.type, f = t.prefixCls, p = mn(function() {
    return r.map(function(g, b) {
      var w = nx(g);
      return d === "alpha" && b === r.length - 1 && (w = new cS(w.setA(1))), w.toRgbString();
    }).join(",");
  }, [r, d]);
  return /* @__PURE__ */ Re.createElement("div", {
    className: "".concat(f, "-gradient"),
    style: {
      position: "absolute",
      inset: 0,
      background: "linear-gradient(".concat(c, ", ").concat(p, ")")
    }
  }, a);
}, yfe = function(t) {
  var r = t.prefixCls, a = t.colors, i = t.disabled, c = t.onChange, d = t.onChangeComplete, f = t.color, p = t.type, g = It(), b = It(), w = It(f), x = function(j) {
    return p === "hue" ? j.getHue() : j.a * 100;
  }, E = ra(function($) {
    var j = rK({
      offset: $,
      targetRef: b,
      containerRef: g,
      color: f,
      type: p
    });
    w.current = j, c(x(j));
  }), P = oK({
    color: f,
    targetRef: b,
    containerRef: g,
    calculate: function() {
      return aK(f, p);
    },
    onDragChange: E,
    onDragChangeComplete: function() {
      d(x(w.current));
    },
    direction: "x",
    disabledDrag: i
  }), k = qe(P, 2), M = k[0], T = k[1], N = Re.useMemo(function() {
    if (p === "hue") {
      var $ = f.toHsb();
      $.s = 1, $.b = 1, $.a = 1;
      var j = new cS($);
      return j;
    }
    return f;
  }, [f, p]), D = Re.useMemo(function() {
    return a.map(function($) {
      return "".concat($.color, " ").concat($.percent, "%");
    });
  }, [a]);
  return /* @__PURE__ */ Re.createElement("div", {
    ref: g,
    className: _e("".concat(r, "-slider"), "".concat(r, "-slider-").concat(p)),
    onMouseDown: T,
    onTouchStart: T
  }, /* @__PURE__ */ Re.createElement(lK, {
    prefixCls: r
  }, /* @__PURE__ */ Re.createElement(sK, {
    x: M.x,
    y: M.y,
    ref: b
  }, /* @__PURE__ */ Re.createElement(iK, {
    size: "small",
    color: N.toHexString(),
    prefixCls: r
  })), /* @__PURE__ */ Re.createElement(bfe, {
    colors: D,
    type: p,
    prefixCls: r
  })));
};
function wfe(e) {
  return S.useMemo(function() {
    var t = e || {}, r = t.slider;
    return [r || yfe];
  }, [e]);
}
var Sfe = [{
  color: "rgb(255, 0, 0)",
  percent: 0
}, {
  color: "rgb(255, 255, 0)",
  percent: 17
}, {
  color: "rgb(0, 255, 0)",
  percent: 33
}, {
  color: "rgb(0, 255, 255)",
  percent: 50
}, {
  color: "rgb(0, 0, 255)",
  percent: 67
}, {
  color: "rgb(255, 0, 255)",
  percent: 83
}, {
  color: "rgb(255, 0, 0)",
  percent: 100
}], Cfe = /* @__PURE__ */ ks(function(e, t) {
  var r = e.value, a = e.defaultValue, i = e.prefixCls, c = i === void 0 ? ffe : i, d = e.onChange, f = e.onChangeComplete, p = e.className, g = e.style, b = e.panelRender, w = e.disabledAlpha, x = w === void 0 ? !1 : w, E = e.disabled, P = E === void 0 ? !1 : E, k = e.components, M = wfe(k), T = qe(M, 1), N = T[0], D = vfe(a || mfe, r), $ = qe(D, 2), j = $[0], I = $[1], L = mn(function() {
    return j.setA(1).toRgbString();
  }, [j]), F = function(te, ie) {
    r || I(te), d?.(te, ie);
  }, _ = function(te) {
    return new cS(j.setHue(te));
  }, W = function(te) {
    return new cS(j.setA(te / 100));
  }, Q = function(te) {
    F(_(te), {
      type: "hue",
      value: te
    });
  }, U = function(te) {
    F(W(te), {
      type: "alpha",
      value: te
    });
  }, Y = function(te) {
    f && f(_(te));
  }, G = function(te) {
    f && f(W(te));
  }, J = _e("".concat(c, "-panel"), p, ge({}, "".concat(c, "-panel-disabled"), P)), H = {
    prefixCls: c,
    disabled: P,
    color: j
  }, K = /* @__PURE__ */ Re.createElement(Re.Fragment, null, /* @__PURE__ */ Re.createElement(gfe, vt({
    onChange: F
  }, H, {
    onChangeComplete: f
  })), /* @__PURE__ */ Re.createElement("div", {
    className: "".concat(c, "-slider-container")
  }, /* @__PURE__ */ Re.createElement("div", {
    className: _e("".concat(c, "-slider-group"), ge({}, "".concat(c, "-slider-group-disabled-alpha"), x))
  }, /* @__PURE__ */ Re.createElement(N, vt({}, H, {
    type: "hue",
    colors: Sfe,
    min: 0,
    max: 359,
    value: j.getHue(),
    onChange: Q,
    onChangeComplete: Y
  })), !x && /* @__PURE__ */ Re.createElement(N, vt({}, H, {
    type: "alpha",
    colors: [{
      percent: 0,
      color: "rgba(255, 0, 4, 0)"
    }, {
      percent: 100,
      color: L
    }],
    min: 0,
    max: 100,
    value: j.a * 100,
    onChange: U,
    onChangeComplete: G
  }))), /* @__PURE__ */ Re.createElement(hfe, {
    color: j.toRgbString(),
    prefixCls: c
  })));
  return /* @__PURE__ */ Re.createElement("div", {
    className: J,
    style: g,
    ref: t
  }, typeof b == "function" ? b(K) : K);
});
process.env.NODE_ENV !== "production" && (Cfe.displayName = "ColorPicker");
const xfe = (e, t) => e?.replace(/[^\w/]/g, "").slice(0, t ? 8 : 6) || "", Efe = (e, t) => e ? xfe(e, t) : "";
let hD = /* @__PURE__ */ (function() {
  function e(t) {
    Vi(this, e);
    var r;
    if (this.cleared = !1, t instanceof e) {
      this.metaColor = t.metaColor.clone(), this.colors = (r = t.colors) === null || r === void 0 ? void 0 : r.map((i) => ({
        color: new e(i.color),
        percent: i.percent
      })), this.cleared = t.cleared;
      return;
    }
    const a = Array.isArray(t);
    a && t.length ? (this.colors = t.map(({
      color: i,
      percent: c
    }) => ({
      color: new e(i),
      percent: c
    })), this.metaColor = new cS(this.colors[0].color.metaColor)) : this.metaColor = new cS(a ? "" : t), (!t || a && !this.colors) && (this.metaColor = this.metaColor.setA(0), this.cleared = !0);
  }
  return _i(e, [{
    key: "toHsb",
    value: function() {
      return this.metaColor.toHsb();
    }
  }, {
    key: "toHsbString",
    value: function() {
      return this.metaColor.toHsbString();
    }
  }, {
    key: "toHex",
    value: function() {
      return Efe(this.toHexString(), this.metaColor.a < 1);
    }
  }, {
    key: "toHexString",
    value: function() {
      return this.metaColor.toHexString();
    }
  }, {
    key: "toRgb",
    value: function() {
      return this.metaColor.toRgb();
    }
  }, {
    key: "toRgbString",
    value: function() {
      return this.metaColor.toRgbString();
    }
  }, {
    key: "isGradient",
    value: function() {
      return !!this.colors && !this.cleared;
    }
  }, {
    key: "getColors",
    value: function() {
      return this.colors || [{
        color: this,
        percent: 0
      }];
    }
  }, {
    key: "toCssString",
    value: function() {
      const {
        colors: r
      } = this;
      return r ? `linear-gradient(90deg, ${r.map((i) => `${i.color.toRgbString()} ${i.percent}%`).join(", ")})` : this.metaColor.toRgbString();
    }
  }, {
    key: "equals",
    value: function(r) {
      return !r || this.isGradient() !== r.isGradient() ? !1 : this.isGradient() ? this.colors.length === r.colors.length && this.colors.every((a, i) => {
        const c = r.colors[i];
        return a.percent === c.percent && a.color.equals(c.color);
      }) : this.toHexString() === r.toHexString();
    }
  }]);
})();
var Pfe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z" } }] }, name: "right", theme: "outlined" }, kfe = function(t, r) {
  return /* @__PURE__ */ S.createElement(Ao, vt({}, t, {
    ref: r,
    icon: Pfe
  }));
}, Ex = /* @__PURE__ */ S.forwardRef(kfe);
process.env.NODE_ENV !== "production" && (Ex.displayName = "RightOutlined");
const Vz = (e) => ({
  [e.componentCls]: {
    // For common/openAnimation
    [`${e.antCls}-motion-collapse-legacy`]: {
      overflow: "hidden",
      "&-active": {
        transition: `height ${e.motionDurationMid} ${e.motionEaseInOut},
        opacity ${e.motionDurationMid} ${e.motionEaseInOut} !important`
      }
    },
    [`${e.antCls}-motion-collapse`]: {
      overflow: "hidden",
      transition: `height ${e.motionDurationMid} ${e.motionEaseInOut},
        opacity ${e.motionDurationMid} ${e.motionEaseInOut} !important`
    }
  }
}), Mfe = (e) => ({
  animationDuration: e,
  animationFillMode: "both"
}), Ofe = (e) => ({
  animationDuration: e,
  animationFillMode: "both"
}), F9 = (e, t, r, a, i = !1) => {
  const c = i ? "&" : "";
  return {
    [`
      ${c}${e}-enter,
      ${c}${e}-appear
    `]: Object.assign(Object.assign({}, Mfe(a)), {
      animationPlayState: "paused"
    }),
    [`${c}${e}-leave`]: Object.assign(Object.assign({}, Ofe(a)), {
      animationPlayState: "paused"
    }),
    [`
      ${c}${e}-enter${e}-enter-active,
      ${c}${e}-appear${e}-appear-active
    `]: {
      animationName: t,
      animationPlayState: "running"
    },
    [`${c}${e}-leave${e}-leave-active`]: {
      animationName: r,
      animationPlayState: "running",
      pointerEvents: "none"
    }
  };
}, Tfe = new bo("antFadeIn", {
  "0%": {
    opacity: 0
  },
  "100%": {
    opacity: 1
  }
}), Rfe = new bo("antFadeOut", {
  "0%": {
    opacity: 1
  },
  "100%": {
    opacity: 0
  }
}), uK = (e, t = !1) => {
  const {
    antCls: r
  } = e, a = `${r}-fade`, i = t ? "&" : "";
  return [F9(a, Tfe, Rfe, e.motionDurationMid, t), {
    [`
        ${i}${a}-enter,
        ${i}${a}-appear
      `]: {
      opacity: 0,
      animationTimingFunction: "linear"
    },
    [`${i}${a}-leave`]: {
      animationTimingFunction: "linear"
    }
  }];
}, Afe = new bo("antMoveDownIn", {
  "0%": {
    transform: "translate3d(0, 100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), Nfe = new bo("antMoveDownOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(0, 100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), Dfe = new bo("antMoveLeftIn", {
  "0%": {
    transform: "translate3d(-100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), $fe = new bo("antMoveLeftOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(-100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), zfe = new bo("antMoveRightIn", {
  "0%": {
    transform: "translate3d(100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), jfe = new bo("antMoveRightOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), Ife = new bo("antMoveUpIn", {
  "0%": {
    transform: "translate3d(0, -100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), Lfe = new bo("antMoveUpOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(0, -100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), Hfe = {
  "move-up": {
    inKeyframes: Ife,
    outKeyframes: Lfe
  },
  "move-down": {
    inKeyframes: Afe,
    outKeyframes: Nfe
  },
  "move-left": {
    inKeyframes: Dfe,
    outKeyframes: $fe
  },
  "move-right": {
    inKeyframes: zfe,
    outKeyframes: jfe
  }
}, Px = (e, t) => {
  const {
    antCls: r
  } = e, a = `${r}-${t}`, {
    inKeyframes: i,
    outKeyframes: c
  } = Hfe[t];
  return [F9(a, i, c, e.motionDurationMid), {
    [`
        ${a}-enter,
        ${a}-appear
      `]: {
      opacity: 0,
      animationTimingFunction: e.motionEaseOutCirc
    },
    [`${a}-leave`]: {
      animationTimingFunction: e.motionEaseInOutCirc
    }
  }];
}, W9 = new bo("antSlideUpIn", {
  "0%": {
    transform: "scaleY(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleY(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  }
}), V9 = new bo("antSlideUpOut", {
  "0%": {
    transform: "scaleY(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleY(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  }
}), _9 = new bo("antSlideDownIn", {
  "0%": {
    transform: "scaleY(0.8)",
    transformOrigin: "100% 100%",
    opacity: 0
  },
  "100%": {
    transform: "scaleY(1)",
    transformOrigin: "100% 100%",
    opacity: 1
  }
}), B9 = new bo("antSlideDownOut", {
  "0%": {
    transform: "scaleY(1)",
    transformOrigin: "100% 100%",
    opacity: 1
  },
  "100%": {
    transform: "scaleY(0.8)",
    transformOrigin: "100% 100%",
    opacity: 0
  }
}), Ffe = new bo("antSlideLeftIn", {
  "0%": {
    transform: "scaleX(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleX(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  }
}), Wfe = new bo("antSlideLeftOut", {
  "0%": {
    transform: "scaleX(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleX(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  }
}), Vfe = new bo("antSlideRightIn", {
  "0%": {
    transform: "scaleX(0.8)",
    transformOrigin: "100% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleX(1)",
    transformOrigin: "100% 0%",
    opacity: 1
  }
}), _fe = new bo("antSlideRightOut", {
  "0%": {
    transform: "scaleX(1)",
    transformOrigin: "100% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleX(0.8)",
    transformOrigin: "100% 0%",
    opacity: 0
  }
}), Bfe = {
  "slide-up": {
    inKeyframes: W9,
    outKeyframes: V9
  },
  "slide-down": {
    inKeyframes: _9,
    outKeyframes: B9
  },
  "slide-left": {
    inKeyframes: Ffe,
    outKeyframes: Wfe
  },
  "slide-right": {
    inKeyframes: Vfe,
    outKeyframes: _fe
  }
}, BS = (e, t) => {
  const {
    antCls: r
  } = e, a = `${r}-${t}`, {
    inKeyframes: i,
    outKeyframes: c
  } = Bfe[t];
  return [F9(a, i, c, e.motionDurationMid), {
    [`
      ${a}-enter,
      ${a}-appear
    `]: {
      transform: "scale(0)",
      transformOrigin: "0% 0%",
      opacity: 0,
      animationTimingFunction: e.motionEaseOutQuint,
      "&-prepare": {
        transform: "scale(1)"
      }
    },
    [`${a}-leave`]: {
      animationTimingFunction: e.motionEaseInQuint
    }
  }];
}, Ufe = new bo("antZoomIn", {
  "0%": {
    transform: "scale(0.2)",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    opacity: 1
  }
}), Xfe = new bo("antZoomOut", {
  "0%": {
    transform: "scale(1)"
  },
  "100%": {
    transform: "scale(0.2)",
    opacity: 0
  }
}), GH = new bo("antZoomBigIn", {
  "0%": {
    transform: "scale(0.8)",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    opacity: 1
  }
}), qH = new bo("antZoomBigOut", {
  "0%": {
    transform: "scale(1)"
  },
  "100%": {
    transform: "scale(0.8)",
    opacity: 0
  }
}), Gfe = new bo("antZoomUpIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "50% 0%"
  }
}), qfe = new bo("antZoomUpOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "50% 0%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 0%",
    opacity: 0
  }
}), Kfe = new bo("antZoomLeftIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "0% 50%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "0% 50%"
  }
}), Yfe = new bo("antZoomLeftOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "0% 50%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "0% 50%",
    opacity: 0
  }
}), Qfe = new bo("antZoomRightIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "100% 50%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "100% 50%"
  }
}), Jfe = new bo("antZoomRightOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "100% 50%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "100% 50%",
    opacity: 0
  }
}), Zfe = new bo("antZoomDownIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 100%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "50% 100%"
  }
}), eme = new bo("antZoomDownOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "50% 100%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 100%",
    opacity: 0
  }
}), tme = {
  zoom: {
    inKeyframes: Ufe,
    outKeyframes: Xfe
  },
  "zoom-big": {
    inKeyframes: GH,
    outKeyframes: qH
  },
  "zoom-big-fast": {
    inKeyframes: GH,
    outKeyframes: qH
  },
  "zoom-left": {
    inKeyframes: Kfe,
    outKeyframes: Yfe
  },
  "zoom-right": {
    inKeyframes: Qfe,
    outKeyframes: Jfe
  },
  "zoom-up": {
    inKeyframes: Gfe,
    outKeyframes: qfe
  },
  "zoom-down": {
    inKeyframes: Zfe,
    outKeyframes: eme
  }
}, UE = (e, t) => {
  const {
    antCls: r
  } = e, a = `${r}-${t}`, {
    inKeyframes: i,
    outKeyframes: c
  } = tme[t];
  return [F9(a, i, c, t === "zoom-big-fast" ? e.motionDurationFast : e.motionDurationMid), {
    [`
        ${a}-enter,
        ${a}-appear
      `]: {
      transform: "scale(0)",
      opacity: 0,
      animationTimingFunction: e.motionEaseOutCirc,
      "&-prepare": {
        transform: "none"
      }
    },
    [`${a}-leave`]: {
      animationTimingFunction: e.motionEaseInOutCirc
    }
  }];
}, nme = (e) => e instanceof hD ? e : new hD(e), rme = (e, t) => {
  const {
    r,
    g: a,
    b: i,
    a: c
  } = e.toRgb(), d = new cS(e.toRgbString()).onBackground(t).toHsv();
  return c <= 0.5 ? d.v > 0.5 : r * 0.299 + a * 0.587 + i * 0.114 > 192;
}, cK = (e) => {
  const {
    paddingInline: t,
    onlyIconSize: r
  } = e;
  return lo(e, {
    buttonPaddingHorizontal: t,
    buttonPaddingVertical: 0,
    buttonIconOnlyFontSize: r
  });
}, dK = (e) => {
  var t, r, a, i, c, d;
  const f = (t = e.contentFontSize) !== null && t !== void 0 ? t : e.fontSize, p = (r = e.contentFontSizeSM) !== null && r !== void 0 ? r : e.fontSize, g = (a = e.contentFontSizeLG) !== null && a !== void 0 ? a : e.fontSizeLG, b = (i = e.contentLineHeight) !== null && i !== void 0 ? i : tk(f), w = (c = e.contentLineHeightSM) !== null && c !== void 0 ? c : tk(p), x = (d = e.contentLineHeightLG) !== null && d !== void 0 ? d : tk(g), E = rme(new hD(e.colorBgSolid), "#fff") ? "#000" : "#fff", P = WS.reduce((k, M) => Object.assign(Object.assign({}, k), {
    [`${M}ShadowColor`]: `0 ${Ye(e.controlOutlineWidth)} 0 ${nE(e[`${M}1`], e.colorBgContainer)}`
  }), {});
  return Object.assign(Object.assign({}, P), {
    fontWeight: 400,
    iconGap: e.marginXS,
    defaultShadow: `0 ${e.controlOutlineWidth}px 0 ${e.controlTmpOutline}`,
    primaryShadow: `0 ${e.controlOutlineWidth}px 0 ${e.controlOutline}`,
    dangerShadow: `0 ${e.controlOutlineWidth}px 0 ${e.colorErrorOutline}`,
    primaryColor: e.colorTextLightSolid,
    dangerColor: e.colorTextLightSolid,
    borderColorDisabled: e.colorBorder,
    defaultGhostColor: e.colorBgContainer,
    ghostBg: "transparent",
    defaultGhostBorderColor: e.colorBgContainer,
    paddingInline: e.paddingContentHorizontal - e.lineWidth,
    paddingInlineLG: e.paddingContentHorizontal - e.lineWidth,
    paddingInlineSM: 8 - e.lineWidth,
    onlyIconSize: "inherit",
    onlyIconSizeSM: "inherit",
    onlyIconSizeLG: "inherit",
    groupBorderColor: e.colorPrimaryHover,
    linkHoverBg: "transparent",
    textTextColor: e.colorText,
    textTextHoverColor: e.colorText,
    textTextActiveColor: e.colorText,
    textHoverBg: e.colorFillTertiary,
    defaultColor: e.colorText,
    defaultBg: e.colorBgContainer,
    defaultBorderColor: e.colorBorder,
    defaultBorderColorDisabled: e.colorBorder,
    defaultHoverBg: e.colorBgContainer,
    defaultHoverColor: e.colorPrimaryHover,
    defaultHoverBorderColor: e.colorPrimaryHover,
    defaultActiveBg: e.colorBgContainer,
    defaultActiveColor: e.colorPrimaryActive,
    defaultActiveBorderColor: e.colorPrimaryActive,
    solidTextColor: E,
    contentFontSize: f,
    contentFontSizeSM: p,
    contentFontSizeLG: g,
    contentLineHeight: b,
    contentLineHeightSM: w,
    contentLineHeightLG: x,
    paddingBlock: Math.max((e.controlHeight - f * b) / 2 - e.lineWidth, 0),
    paddingBlockSM: Math.max((e.controlHeightSM - p * w) / 2 - e.lineWidth, 0),
    paddingBlockLG: Math.max((e.controlHeightLG - g * x) / 2 - e.lineWidth, 0)
  });
}, ame = (e) => {
  const {
    componentCls: t,
    iconCls: r,
    fontWeight: a,
    opacityLoading: i,
    motionDurationSlow: c,
    motionEaseInOut: d,
    iconGap: f,
    calc: p
  } = e;
  return {
    [t]: {
      outline: "none",
      position: "relative",
      display: "inline-flex",
      gap: f,
      alignItems: "center",
      justifyContent: "center",
      fontWeight: a,
      whiteSpace: "nowrap",
      textAlign: "center",
      backgroundImage: "none",
      background: "transparent",
      border: `${Ye(e.lineWidth)} ${e.lineType} transparent`,
      cursor: "pointer",
      transition: `all ${e.motionDurationMid} ${e.motionEaseInOut}`,
      userSelect: "none",
      touchAction: "manipulation",
      color: e.colorText,
      "&:disabled > *": {
        pointerEvents: "none"
      },
      // https://github.com/ant-design/ant-design/issues/51380
      [`${t}-icon > svg`]: VE(),
      "> a": {
        color: "currentColor"
      },
      "&:not(:disabled)": Z4(e),
      [`&${t}-two-chinese-chars::first-letter`]: {
        letterSpacing: "0.34em"
      },
      [`&${t}-two-chinese-chars > *:not(${r})`]: {
        marginInlineEnd: "-0.34em",
        letterSpacing: "0.34em"
      },
      [`&${t}-icon-only`]: {
        paddingInline: 0,
        // make `btn-icon-only` not too narrow
        [`&${t}-compact-item`]: {
          flex: "none"
        }
      },
      // Loading
      [`&${t}-loading`]: {
        opacity: i,
        cursor: "default"
      },
      [`${t}-loading-icon`]: {
        transition: ["width", "opacity", "margin"].map((g) => `${g} ${c} ${d}`).join(",")
      },
      // iconPosition
      [`&:not(${t}-icon-end)`]: {
        [`${t}-loading-icon-motion`]: {
          "&-appear-start, &-enter-start": {
            marginInlineEnd: p(f).mul(-1).equal()
          },
          "&-appear-active, &-enter-active": {
            marginInlineEnd: 0
          },
          "&-leave-start": {
            marginInlineEnd: 0
          },
          "&-leave-active": {
            marginInlineEnd: p(f).mul(-1).equal()
          }
        }
      },
      "&-icon-end": {
        flexDirection: "row-reverse",
        [`${t}-loading-icon-motion`]: {
          "&-appear-start, &-enter-start": {
            marginInlineStart: p(f).mul(-1).equal()
          },
          "&-appear-active, &-enter-active": {
            marginInlineStart: 0
          },
          "&-leave-start": {
            marginInlineStart: 0
          },
          "&-leave-active": {
            marginInlineStart: p(f).mul(-1).equal()
          }
        }
      }
    }
  };
}, fK = (e, t, r) => ({
  [`&:not(:disabled):not(${e}-disabled)`]: {
    "&:hover": t,
    "&:active": r
  }
}), ome = (e) => ({
  minWidth: e.controlHeight,
  paddingInline: 0,
  borderRadius: "50%"
}), ime = (e) => ({
  cursor: "not-allowed",
  borderColor: e.borderColorDisabled,
  color: e.colorTextDisabled,
  background: e.colorBgContainerDisabled,
  boxShadow: "none"
}), U9 = (e, t, r, a, i, c, d, f) => ({
  [`&${e}-background-ghost`]: Object.assign(Object.assign({
    color: r || void 0,
    background: t,
    borderColor: a || void 0,
    boxShadow: "none"
  }, fK(e, Object.assign({
    background: t
  }, d), Object.assign({
    background: t
  }, f))), {
    "&:disabled": {
      cursor: "not-allowed",
      color: i || void 0,
      borderColor: c || void 0
    }
  })
}), lme = (e) => ({
  [`&:disabled, &${e.componentCls}-disabled`]: Object.assign({}, ime(e))
}), sme = (e) => ({
  [`&:disabled, &${e.componentCls}-disabled`]: {
    cursor: "not-allowed",
    color: e.colorTextDisabled
  }
}), X9 = (e, t, r, a) => {
  const c = a && ["link", "text"].includes(a) ? sme : lme;
  return Object.assign(Object.assign({}, c(e)), fK(e.componentCls, t, r));
}, G9 = (e, t, r, a, i) => ({
  [`&${e.componentCls}-variant-solid`]: Object.assign({
    color: t,
    background: r
  }, X9(e, a, i))
}), q9 = (e, t, r, a, i) => ({
  [`&${e.componentCls}-variant-outlined, &${e.componentCls}-variant-dashed`]: Object.assign({
    borderColor: t,
    background: r
  }, X9(e, a, i))
}), K9 = (e) => ({
  [`&${e.componentCls}-variant-dashed`]: {
    borderStyle: "dashed"
  }
}), Y9 = (e, t, r, a) => ({
  [`&${e.componentCls}-variant-filled`]: Object.assign({
    boxShadow: "none",
    background: t
  }, X9(e, r, a))
}), bb = (e, t, r, a, i) => ({
  [`&${e.componentCls}-variant-${r}`]: Object.assign({
    color: t,
    boxShadow: "none"
  }, X9(e, a, i, r))
}), ume = (e) => {
  const {
    componentCls: t
  } = e;
  return WS.reduce((r, a) => {
    const i = e[`${a}6`], c = e[`${a}1`], d = e[`${a}5`], f = e[`${a}2`], p = e[`${a}3`], g = e[`${a}7`];
    return Object.assign(Object.assign({}, r), {
      [`&${t}-color-${a}`]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
        color: i,
        boxShadow: e[`${a}ShadowColor`]
      }, G9(e, e.colorTextLightSolid, i, {
        background: d
      }, {
        background: g
      })), q9(e, i, e.colorBgContainer, {
        color: d,
        borderColor: d,
        background: e.colorBgContainer
      }, {
        color: g,
        borderColor: g,
        background: e.colorBgContainer
      })), K9(e)), Y9(e, c, {
        color: i,
        background: f
      }, {
        color: i,
        background: p
      })), bb(e, i, "link", {
        color: d
      }, {
        color: g
      })), bb(e, i, "text", {
        color: d,
        background: c
      }, {
        color: g,
        background: p
      }))
    });
  }, {});
}, cme = (e) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
  color: e.defaultColor,
  boxShadow: e.defaultShadow
}, G9(e, e.solidTextColor, e.colorBgSolid, {
  color: e.solidTextColor,
  background: e.colorBgSolidHover
}, {
  color: e.solidTextColor,
  background: e.colorBgSolidActive
})), K9(e)), Y9(e, e.colorFillTertiary, {
  color: e.defaultColor,
  background: e.colorFillSecondary
}, {
  color: e.defaultColor,
  background: e.colorFill
})), U9(e.componentCls, e.ghostBg, e.defaultGhostColor, e.defaultGhostBorderColor, e.colorTextDisabled, e.colorBorder)), bb(e, e.textTextColor, "link", {
  color: e.colorLinkHover,
  background: e.linkHoverBg
}, {
  color: e.colorLinkActive
})), dme = (e) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
  color: e.colorPrimary,
  boxShadow: e.primaryShadow
}, q9(e, e.colorPrimary, e.colorBgContainer, {
  color: e.colorPrimaryTextHover,
  borderColor: e.colorPrimaryHover,
  background: e.colorBgContainer
}, {
  color: e.colorPrimaryTextActive,
  borderColor: e.colorPrimaryActive,
  background: e.colorBgContainer
})), K9(e)), Y9(e, e.colorPrimaryBg, {
  color: e.colorPrimary,
  background: e.colorPrimaryBgHover
}, {
  color: e.colorPrimary,
  background: e.colorPrimaryBorder
})), bb(e, e.colorPrimaryText, "text", {
  color: e.colorPrimaryTextHover,
  background: e.colorPrimaryBg
}, {
  color: e.colorPrimaryTextActive,
  background: e.colorPrimaryBorder
})), bb(e, e.colorPrimaryText, "link", {
  color: e.colorPrimaryTextHover,
  background: e.linkHoverBg
}, {
  color: e.colorPrimaryTextActive
})), U9(e.componentCls, e.ghostBg, e.colorPrimary, e.colorPrimary, e.colorTextDisabled, e.colorBorder, {
  color: e.colorPrimaryHover,
  borderColor: e.colorPrimaryHover
}, {
  color: e.colorPrimaryActive,
  borderColor: e.colorPrimaryActive
})), fme = (e) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
  color: e.colorError,
  boxShadow: e.dangerShadow
}, G9(e, e.dangerColor, e.colorError, {
  background: e.colorErrorHover
}, {
  background: e.colorErrorActive
})), q9(e, e.colorError, e.colorBgContainer, {
  color: e.colorErrorHover,
  borderColor: e.colorErrorBorderHover
}, {
  color: e.colorErrorActive,
  borderColor: e.colorErrorActive
})), K9(e)), Y9(e, e.colorErrorBg, {
  color: e.colorError,
  background: e.colorErrorBgFilledHover
}, {
  color: e.colorError,
  background: e.colorErrorBgActive
})), bb(e, e.colorError, "text", {
  color: e.colorErrorHover,
  background: e.colorErrorBg
}, {
  color: e.colorErrorHover,
  background: e.colorErrorBgActive
})), bb(e, e.colorError, "link", {
  color: e.colorErrorHover
}, {
  color: e.colorErrorActive
})), U9(e.componentCls, e.ghostBg, e.colorError, e.colorError, e.colorTextDisabled, e.colorBorder, {
  color: e.colorErrorHover,
  borderColor: e.colorErrorHover
}, {
  color: e.colorErrorActive,
  borderColor: e.colorErrorActive
})), mme = (e) => Object.assign(Object.assign({}, bb(e, e.colorLink, "link", {
  color: e.colorLinkHover
}, {
  color: e.colorLinkActive
})), U9(e.componentCls, e.ghostBg, e.colorInfo, e.colorInfo, e.colorTextDisabled, e.colorBorder, {
  color: e.colorInfoHover,
  borderColor: e.colorInfoHover
}, {
  color: e.colorInfoActive,
  borderColor: e.colorInfoActive
})), hme = (e) => {
  const {
    componentCls: t
  } = e;
  return Object.assign({
    [`${t}-color-default`]: cme(e),
    [`${t}-color-primary`]: dme(e),
    [`${t}-color-dangerous`]: fme(e),
    [`${t}-color-link`]: mme(e)
  }, ume(e));
}, pme = (e) => Object.assign(Object.assign(Object.assign(Object.assign({}, q9(e, e.defaultBorderColor, e.defaultBg, {
  color: e.defaultHoverColor,
  borderColor: e.defaultHoverBorderColor,
  background: e.defaultHoverBg
}, {
  color: e.defaultActiveColor,
  borderColor: e.defaultActiveBorderColor,
  background: e.defaultActiveBg
})), bb(e, e.textTextColor, "text", {
  color: e.textTextHoverColor,
  background: e.textHoverBg
}, {
  color: e.textTextActiveColor,
  background: e.colorBgTextActive
})), G9(e, e.primaryColor, e.colorPrimary, {
  background: e.colorPrimaryHover,
  color: e.primaryColor
}, {
  background: e.colorPrimaryActive,
  color: e.primaryColor
})), bb(e, e.colorLink, "link", {
  color: e.colorLinkHover,
  background: e.linkHoverBg
}, {
  color: e.colorLinkActive
})), _z = (e, t = "") => {
  const {
    componentCls: r,
    controlHeight: a,
    fontSize: i,
    borderRadius: c,
    buttonPaddingHorizontal: d,
    iconCls: f,
    buttonPaddingVertical: p,
    buttonIconOnlyFontSize: g
  } = e;
  return [
    {
      [t]: {
        fontSize: i,
        height: a,
        padding: `${Ye(p)} ${Ye(d)}`,
        borderRadius: c,
        [`&${r}-icon-only`]: {
          width: a,
          [f]: {
            fontSize: g
          }
        }
      }
    },
    // Shape - patch prefixCls again to override solid border radius style
    {
      [`${r}${r}-circle${t}`]: ome(e)
    },
    {
      [`${r}${r}-round${t}`]: {
        borderRadius: e.controlHeight,
        [`&:not(${r}-icon-only)`]: {
          paddingInline: e.buttonPaddingHorizontal
        }
      }
    }
  ];
}, gme = (e) => {
  const t = lo(e, {
    fontSize: e.contentFontSize
  });
  return _z(t, e.componentCls);
}, vme = (e) => {
  const t = lo(e, {
    controlHeight: e.controlHeightSM,
    fontSize: e.contentFontSizeSM,
    padding: e.paddingXS,
    buttonPaddingHorizontal: e.paddingInlineSM,
    buttonPaddingVertical: 0,
    borderRadius: e.borderRadiusSM,
    buttonIconOnlyFontSize: e.onlyIconSizeSM
  });
  return _z(t, `${e.componentCls}-sm`);
}, bme = (e) => {
  const t = lo(e, {
    controlHeight: e.controlHeightLG,
    fontSize: e.contentFontSizeLG,
    buttonPaddingHorizontal: e.paddingInlineLG,
    buttonPaddingVertical: 0,
    borderRadius: e.borderRadiusLG,
    buttonIconOnlyFontSize: e.onlyIconSizeLG
  });
  return _z(t, `${e.componentCls}-lg`);
}, yme = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      [`&${t}-block`]: {
        width: "100%"
      }
    }
  };
}, wme = Ii("Button", (e) => {
  const t = cK(e);
  return [
    // Shared
    ame(t),
    // Size
    gme(t),
    vme(t),
    bme(t),
    // Block
    yme(t),
    // Color
    hme(t),
    // https://github.com/ant-design/ant-design/issues/50969
    pme(t),
    // Button Group
    sfe(t)
  ];
}, dK, {
  unitless: {
    fontWeight: !0,
    contentLineHeight: !0,
    contentLineHeightSM: !0,
    contentLineHeightLG: !0
  }
});
function Sme(e, t, r, a) {
  const {
    focusElCls: i,
    focus: c,
    borderElCls: d
  } = r, f = d ? "> *" : "", p = ["hover", c ? "focus" : null, "active"].filter(Boolean).map((g) => `&:${g} ${f}`).join(",");
  return {
    [`&-item:not(${t}-last-item)`]: {
      marginInlineEnd: e.calc(e.lineWidth).mul(-1).equal()
    },
    [`&-item:not(${a}-status-success)`]: {
      zIndex: 2
    },
    "&-item": Object.assign(Object.assign({
      [p]: {
        zIndex: 3
      }
    }, i ? {
      [`&${i}`]: {
        zIndex: 3
      }
    } : {}), {
      [`&[disabled] ${f}`]: {
        zIndex: 0
      }
    })
  };
}
function Cme(e, t, r) {
  const {
    borderElCls: a
  } = r, i = a ? `> ${a}` : "";
  return {
    [`&-item:not(${t}-first-item):not(${t}-last-item) ${i}`]: {
      borderRadius: 0
    },
    [`&-item:not(${t}-last-item)${t}-first-item`]: {
      [`& ${i}, &${e}-sm ${i}, &${e}-lg ${i}`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`&-item:not(${t}-first-item)${t}-last-item`]: {
      [`& ${i}, &${e}-sm ${i}, &${e}-lg ${i}`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    }
  };
}
function XE(e, t = {
  focus: !0
}) {
  const {
    componentCls: r
  } = e, {
    componentCls: a
  } = t, i = a || r, c = `${i}-compact`;
  return {
    [c]: Object.assign(Object.assign({}, Sme(e, c, t, i)), Cme(i, c, t))
  };
}
function xme(e, t, r) {
  return {
    // border collapse
    [`&-item:not(${t}-last-item)`]: {
      marginBottom: e.calc(e.lineWidth).mul(-1).equal()
    },
    [`&-item:not(${r}-status-success)`]: {
      zIndex: 2
    },
    "&-item": {
      "&:hover,&:focus,&:active": {
        zIndex: 3
      },
      "&[disabled]": {
        zIndex: 0
      }
    }
  };
}
function Eme(e, t) {
  return {
    [`&-item:not(${t}-first-item):not(${t}-last-item)`]: {
      borderRadius: 0
    },
    [`&-item${t}-first-item:not(${t}-last-item)`]: {
      [`&, &${e}-sm, &${e}-lg`]: {
        borderEndEndRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`&-item${t}-last-item:not(${t}-first-item)`]: {
      [`&, &${e}-sm, &${e}-lg`]: {
        borderStartStartRadius: 0,
        borderStartEndRadius: 0
      }
    }
  };
}
function Pme(e) {
  const t = `${e.componentCls}-compact-vertical`;
  return {
    [t]: Object.assign(Object.assign({}, xme(e, t, e.componentCls)), Eme(e.componentCls, t))
  };
}
const kme = (e) => {
  const {
    componentCls: t,
    colorPrimaryHover: r,
    lineWidth: a,
    calc: i
  } = e, c = i(a).mul(-1).equal(), d = (f) => {
    const p = `${t}-compact${f ? "-vertical" : ""}-item${t}-primary:not([disabled])`;
    return {
      [`${p} + ${p}::before`]: {
        position: "absolute",
        top: f ? c : 0,
        insetInlineStart: f ? 0 : c,
        backgroundColor: r,
        content: '""',
        width: f ? "100%" : a,
        height: f ? a : "100%"
      }
    };
  };
  return Object.assign(Object.assign({}, d()), d(!0));
}, Mme = $z(["Button", "compact"], (e) => {
  const t = cK(e);
  return [
    // Space Compact
    XE(t),
    Pme(t),
    kme(t)
  ];
}, dK);
var Ome = function(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
    t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
};
function Tme(e) {
  if (typeof e == "object" && e) {
    let t = e?.delay;
    return t = !Number.isNaN(t) && typeof t == "number" ? t : 0, {
      loading: t <= 0,
      delay: t
    };
  }
  return {
    loading: !!e,
    delay: 0
  };
}
const Rme = {
  default: ["default", "outlined"],
  primary: ["primary", "solid"],
  dashed: ["default", "dashed"],
  // `link` is not a real color but we should compatible with it
  link: ["link", "link"],
  text: ["default", "text"]
}, Ame = /* @__PURE__ */ Re.forwardRef((e, t) => {
  var r, a;
  const {
    loading: i = !1,
    prefixCls: c,
    color: d,
    variant: f,
    type: p,
    danger: g = !1,
    shape: b,
    size: w,
    styles: x,
    disabled: E,
    className: P,
    rootClassName: k,
    children: M,
    icon: T,
    iconPosition: N = "start",
    ghost: D = !1,
    block: $ = !1,
    // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
    htmlType: j = "button",
    classNames: I,
    style: L = {},
    autoInsertSpace: F,
    autoFocus: _
  } = e, W = Ome(e, ["loading", "prefixCls", "color", "variant", "type", "danger", "shape", "size", "styles", "disabled", "className", "rootClassName", "children", "icon", "iconPosition", "ghost", "block", "htmlType", "classNames", "style", "autoInsertSpace", "autoFocus"]), Q = p || "default", {
    button: U
  } = Re.useContext(Qr), Y = b || U?.shape || "default", [G, J] = mn(() => {
    if (d && f)
      return [d, f];
    if (p || g) {
      const st = Rme[Q] || [];
      return g ? ["danger", st[1]] : st;
    }
    return U?.color && U?.variant ? [U.color, U.variant] : ["default", "outlined"];
  }, [d, f, p, g, U?.color, U?.variant, Q]), K = G === "danger" ? "dangerous" : G, {
    getPrefixCls: X,
    direction: te,
    autoInsertSpace: ie,
    className: ee,
    style: ne,
    classNames: ae,
    styles: oe
  } = om("button"), fe = (r = F ?? ie) !== null && r !== void 0 ? r : !0, be = X("btn", c), [me, De, Me] = wme(be), ze = Do(A0), le = E ?? ze, se = Do(eK), Ae = mn(() => Tme(i), [i]), [we, Ne] = Wn(Ae.loading), [pe, Qe] = Wn(!1), Le = It(null), Te = gS(t, Le), Oe = nle.count(M) === 1 && !T && !F7(J), ye = It(!0);
  Re.useEffect(() => (ye.current = !1, () => {
    ye.current = !0;
  }), []), Da(() => {
    let st = null;
    Ae.delay > 0 ? st = setTimeout(() => {
      st = null, Ne(!0);
    }, Ae.delay) : Ne(Ae.loading);
    function pt() {
      st && (clearTimeout(st), st = null);
    }
    return pt;
  }, [Ae.delay, Ae.loading]), Er(() => {
    if (!Le.current || !fe)
      return;
    const st = Le.current.textContent || "";
    Oe && mD(st) ? pe || Qe(!0) : pe && Qe(!1);
  }), Er(() => {
    _ && Le.current && Le.current.focus();
  }, []);
  const je = Re.useCallback((st) => {
    var pt;
    if (we || le) {
      st.preventDefault();
      return;
    }
    (pt = e.onClick) === null || pt === void 0 || pt.call(e, ("href" in e, st));
  }, [e.onClick, we, le]);
  if (process.env.NODE_ENV !== "production") {
    const st = To("Button");
    process.env.NODE_ENV !== "production" && st(!(typeof T == "string" && T.length > 2), "breaking", `\`icon\` is using ReactNode instead of string naming in v4. Please check \`${T}\` at https://ant.design/components/icon`), process.env.NODE_ENV !== "production" && st(!(D && F7(J)), "usage", "`link` or `text` button can't be a `ghost` button.");
  }
  const {
    compactSize: Ue,
    compactItemClassnames: Fe
  } = h3(be, te), tt = {
    large: "lg",
    small: "sm",
    middle: void 0
  }, dt = Cb((st) => {
    var pt, bt;
    return (bt = (pt = w ?? Ue) !== null && pt !== void 0 ? pt : se) !== null && bt !== void 0 ? bt : st;
  }), St = dt && (a = tt[dt]) !== null && a !== void 0 ? a : "", mt = we ? "loading" : T, Ot = Rs(W, ["navigate"]), Rt = _e(be, De, Me, {
    [`${be}-${Y}`]: Y !== "default" && Y,
    // Compatible with versions earlier than 5.21.0
    [`${be}-${Q}`]: Q,
    [`${be}-dangerous`]: g,
    [`${be}-color-${K}`]: K,
    [`${be}-variant-${J}`]: J,
    [`${be}-${St}`]: St,
    [`${be}-icon-only`]: !M && M !== 0 && !!mt,
    [`${be}-background-ghost`]: D && !F7(J),
    [`${be}-loading`]: we,
    [`${be}-two-chinese-chars`]: pe && fe && !we,
    [`${be}-block`]: $,
    [`${be}-rtl`]: te === "rtl",
    [`${be}-icon-end`]: N === "end"
  }, Fe, P, k, ee), ct = Object.assign(Object.assign({}, ne), L), it = _e(I?.icon, ae.icon), Ct = Object.assign(Object.assign({}, x?.icon || {}), oe.icon || {}), ut = (st) => /* @__PURE__ */ Re.createElement(nK, {
    prefixCls: be,
    className: it,
    style: Ct
  }, st), ht = () => /* @__PURE__ */ Re.createElement(lfe, {
    existIcon: !!T,
    prefixCls: be,
    loading: we,
    mount: ye.current
  });
  let ot;
  T && !we ? ot = ut(T) : i && typeof i == "object" && i.icon ? ot = ut(i.icon) : ot = ht();
  const at = M || M === 0 ? ife(M, Oe && fe) : null;
  if (Ot.href !== void 0)
    return me(/* @__PURE__ */ Re.createElement("a", Object.assign({}, Ot, {
      className: _e(Rt, {
        [`${be}-disabled`]: le
      }),
      href: le ? void 0 : Ot.href,
      style: ct,
      onClick: je,
      ref: Te,
      tabIndex: le ? -1 : 0,
      "aria-disabled": le
    }), ot, at));
  let ft = /* @__PURE__ */ Re.createElement("button", Object.assign({}, W, {
    type: j,
    className: Rt,
    style: ct,
    onClick: je,
    disabled: le,
    ref: Te
  }), ot, at, Fe && /* @__PURE__ */ Re.createElement(Mme, {
    prefixCls: be
  }));
  return F7(J) || (ft = /* @__PURE__ */ Re.createElement(L9, {
    component: "Button",
    disabled: we
  }, ft)), me(ft);
}), cp = Ame;
cp.Group = afe;
cp.__ANT_BUTTON = !0;
process.env.NODE_ENV !== "production" && (cp.displayName = "Button");
const QT = (e) => typeof e?.then == "function", mK = (e) => {
  const {
    type: t,
    children: r,
    prefixCls: a,
    buttonProps: i,
    close: c,
    autoFocus: d,
    emitEvent: f,
    isSilent: p,
    quitOnNullishReturnValue: g,
    actionFn: b
  } = e, w = S.useRef(!1), x = S.useRef(null), [E, P] = Cx(!1), k = (...N) => {
    c?.apply(void 0, N);
  };
  S.useEffect(() => {
    let N = null;
    return d && (N = setTimeout(() => {
      var D;
      (D = x.current) === null || D === void 0 || D.focus({
        preventScroll: !0
      });
    })), () => {
      N && clearTimeout(N);
    };
  }, [d]);
  const M = (N) => {
    QT(N) && (P(!0), N.then((...D) => {
      P(!1, !0), k.apply(void 0, D), w.current = !1;
    }, (D) => {
      if (P(!1, !0), w.current = !1, !p?.())
        return Promise.reject(D);
    }));
  }, T = (N) => {
    if (w.current)
      return;
    if (w.current = !0, !b) {
      k();
      return;
    }
    let D;
    if (f) {
      if (D = b(N), g && !QT(D)) {
        w.current = !1, k(N);
        return;
      }
    } else if (b.length)
      D = b(c), w.current = !1;
    else if (D = b(), !QT(D)) {
      k();
      return;
    }
    M(D);
  };
  return /* @__PURE__ */ S.createElement(cp, Object.assign({}, tK(t), {
    onClick: T,
    loading: E,
    prefixCls: a
  }, i, {
    ref: x
  }), r);
}, GE = /* @__PURE__ */ Re.createContext({}), {
  Provider: hK
} = GE, KH = () => {
  const {
    autoFocusButton: e,
    cancelButtonProps: t,
    cancelTextLocale: r,
    isSilent: a,
    mergedOkCancel: i,
    rootPrefixCls: c,
    close: d,
    onCancel: f,
    onConfirm: p
  } = Do(GE);
  return i ? /* @__PURE__ */ Re.createElement(mK, {
    isSilent: a,
    actionFn: f,
    close: (...g) => {
      d?.apply(void 0, g), p?.(!1);
    },
    autoFocus: e === "cancel",
    buttonProps: t,
    prefixCls: `${c}-btn`
  }, r) : null;
}, YH = () => {
  const {
    autoFocusButton: e,
    close: t,
    isSilent: r,
    okButtonProps: a,
    rootPrefixCls: i,
    okTextLocale: c,
    okType: d,
    onConfirm: f,
    onOk: p
  } = Do(GE);
  return /* @__PURE__ */ Re.createElement(mK, {
    isSilent: r,
    type: d || "primary",
    actionFn: p,
    close: (...g) => {
      t?.apply(void 0, g), f?.(!0);
    },
    autoFocus: e === "ok",
    buttonProps: a,
    prefixCls: `${i}-btn`
  }, c);
};
var pK = /* @__PURE__ */ S.createContext(null), QH = [];
function Nme(e, t) {
  var r = S.useState(function() {
    if (!Ju())
      return null;
    var P = document.createElement("div");
    return process.env.NODE_ENV !== "production" && t && P.setAttribute("data-debug", t), P;
  }), a = qe(r, 1), i = a[0], c = S.useRef(!1), d = S.useContext(pK), f = S.useState(QH), p = qe(f, 2), g = p[0], b = p[1], w = d || (c.current ? void 0 : function(P) {
    b(function(k) {
      var M = [P].concat(Et(k));
      return M;
    });
  });
  function x() {
    i.parentElement || document.body.appendChild(i), c.current = !0;
  }
  function E() {
    var P;
    (P = i.parentElement) === null || P === void 0 || P.removeChild(i), c.current = !1;
  }
  return Da(function() {
    return e ? d ? d(x) : x() : E(), E;
  }, [e]), Da(function() {
    g.length && (g.forEach(function(P) {
      return P();
    }), b(QH));
  }, [g]), [i, w];
}
var JT;
function gK(e) {
  var t = "rc-scrollbar-measure-".concat(Math.random().toString(36).substring(7)), r = document.createElement("div");
  r.id = t;
  var a = r.style;
  a.position = "absolute", a.left = "0", a.top = "0", a.width = "100px", a.height = "100px", a.overflow = "scroll";
  var i, c;
  if (e) {
    var d = getComputedStyle(e);
    a.scrollbarColor = d.scrollbarColor, a.scrollbarWidth = d.scrollbarWidth;
    var f = getComputedStyle(e, "::-webkit-scrollbar"), p = parseInt(f.width, 10), g = parseInt(f.height, 10);
    try {
      var b = p ? "width: ".concat(f.width, ";") : "", w = g ? "height: ".concat(f.height, ";") : "";
      oS(`
#`.concat(t, `::-webkit-scrollbar {
`).concat(b, `
`).concat(w, `
}`), t);
    } catch (P) {
      console.error(P), i = p, c = g;
    }
  }
  document.body.appendChild(r);
  var x = e && i && !isNaN(i) ? i : r.offsetWidth - r.clientWidth, E = e && c && !isNaN(c) ? c : r.offsetHeight - r.clientHeight;
  return document.body.removeChild(r), kE(t), {
    width: x,
    height: E
  };
}
function JH(e) {
  return typeof document > "u" ? 0 : (JT === void 0 && (JT = gK()), JT.width);
}
function pD(e) {
  return typeof document > "u" || !e || !(e instanceof Element) ? {
    width: 0,
    height: 0
  } : gK(e);
}
function Dme() {
  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}
var $me = "rc-util-locker-".concat(Date.now()), ZH = 0;
function zme(e) {
  var t = !!e, r = S.useState(function() {
    return ZH += 1, "".concat($me, "_").concat(ZH);
  }), a = qe(r, 1), i = a[0];
  Da(function() {
    if (t) {
      var c = pD(document.body).width, d = Dme();
      oS(`
html body {
  overflow-y: hidden;
  `.concat(d ? "width: calc(100% - ".concat(c, "px);") : "", `
}`), i);
    } else
      kE(i);
    return function() {
      kE(i);
    };
  }, [t, i]);
}
var jme = !1;
function Ime(e) {
  return jme;
}
var eF = function(t) {
  return t === !1 ? !1 : !Ju() || !t ? null : typeof t == "string" ? document.querySelector(t) : typeof t == "function" ? t() : t;
}, qE = /* @__PURE__ */ S.forwardRef(function(e, t) {
  var r = e.open, a = e.autoLock, i = e.getContainer, c = e.debug, d = e.autoDestroy, f = d === void 0 ? !0 : d, p = e.children, g = S.useState(r), b = qe(g, 2), w = b[0], x = b[1], E = w || r;
  process.env.NODE_ENV !== "production" && $n(Ju() || !r, "Portal only work in client side. Please call 'useEffect' to show Portal instead default render in SSR."), S.useEffect(function() {
    (f || r) && x(r);
  }, [r, f]);
  var P = S.useState(function() {
    return eF(i);
  }), k = qe(P, 2), M = k[0], T = k[1];
  S.useEffect(function() {
    var U = eF(i);
    T(U ?? null);
  });
  var N = Nme(E && !M, c), D = qe(N, 2), $ = D[0], j = D[1], I = M ?? $;
  zme(a && r && Ju() && (I === $ || I === document.body));
  var L = null;
  if (p && gb(p) && t) {
    var F = p;
    L = F.ref;
  }
  var _ = gS(L, t);
  if (!E || !Ju() || M === void 0)
    return null;
  var W = I === !1 || Ime(), Q = p;
  return t && (Q = /* @__PURE__ */ S.cloneElement(p, {
    ref: _
  })), /* @__PURE__ */ S.createElement(pK.Provider, {
    value: j
  }, W ? Q : /* @__PURE__ */ ole(Q, I));
});
process.env.NODE_ENV !== "production" && (qE.displayName = "Portal");
var vK = /* @__PURE__ */ S.createContext({});
function Lme() {
  var e = ce({}, S);
  return e.useId;
}
var tF = 0, nF = Lme();
const KE = nF ? (
  // Use React `useId`
  function(t) {
    var r = nF();
    return t || (process.env.NODE_ENV === "test" ? "test-id" : r);
  }
) : (
  // Use compatible of `useId`
  function(t) {
    var r = S.useState("ssr-id"), a = qe(r, 2), i = a[0], c = a[1];
    return S.useEffect(function() {
      var d = tF;
      tF += 1, c("rc_unique_".concat(d));
    }, []), t || (process.env.NODE_ENV === "test" ? "test-id" : i);
  }
);
function rF(e, t, r) {
  var a = t;
  return !a && r && (a = "".concat(e, "-").concat(r)), a;
}
function aF(e, t) {
  var r = e["page".concat(t ? "Y" : "X", "Offset")], a = "scroll".concat(t ? "Top" : "Left");
  if (typeof r != "number") {
    var i = e.document;
    r = i.documentElement[a], typeof r != "number" && (r = i.body[a]);
  }
  return r;
}
function Hme(e) {
  var t = e.getBoundingClientRect(), r = {
    left: t.left,
    top: t.top
  }, a = e.ownerDocument, i = a.defaultView || a.parentWindow;
  return r.left += aF(i), r.top += aF(i, !0), r;
}
const Fme = /* @__PURE__ */ S.memo(function(e) {
  var t = e.children;
  return t;
}, function(e, t) {
  var r = t.shouldUpdate;
  return !r;
});
var Wme = {
  width: 0,
  height: 0,
  overflow: "hidden",
  outline: "none"
}, Vme = {
  outline: "none"
}, Bz = /* @__PURE__ */ Re.forwardRef(function(e, t) {
  var r = e.prefixCls, a = e.className, i = e.style, c = e.title, d = e.ariaId, f = e.footer, p = e.closable, g = e.closeIcon, b = e.onClose, w = e.children, x = e.bodyStyle, E = e.bodyProps, P = e.modalRender, k = e.onMouseDown, M = e.onMouseUp, T = e.holderRef, N = e.visible, D = e.forceRender, $ = e.width, j = e.height, I = e.classNames, L = e.styles, F = Re.useContext(vK), _ = F.panel, W = gS(T, _), Q = It(), U = It();
  Re.useImperativeHandle(t, function() {
    return {
      focus: function() {
        var ne;
        (ne = Q.current) === null || ne === void 0 || ne.focus({
          preventScroll: !0
        });
      },
      changeActive: function(ne) {
        var ae = document, oe = ae.activeElement;
        ne && oe === U.current ? Q.current.focus({
          preventScroll: !0
        }) : !ne && oe === Q.current && U.current.focus({
          preventScroll: !0
        });
      }
    };
  });
  var Y = {};
  $ !== void 0 && (Y.width = $), j !== void 0 && (Y.height = j);
  var G = f ? /* @__PURE__ */ Re.createElement("div", {
    className: _e("".concat(r, "-footer"), I?.footer),
    style: ce({}, L?.footer)
  }, f) : null, J = c ? /* @__PURE__ */ Re.createElement("div", {
    className: _e("".concat(r, "-header"), I?.header),
    style: ce({}, L?.header)
  }, /* @__PURE__ */ Re.createElement("div", {
    className: "".concat(r, "-title"),
    id: d
  }, c)) : null, H = mn(function() {
    return Hn(p) === "object" && p !== null ? p : p ? {
      closeIcon: g ?? /* @__PURE__ */ Re.createElement("span", {
        className: "".concat(r, "-close-x")
      })
    } : {};
  }, [p, g, r]), K = Zu(H, !0), X = Hn(p) === "object" && p.disabled, te = p ? /* @__PURE__ */ Re.createElement("button", vt({
    type: "button",
    onClick: b,
    "aria-label": "Close"
  }, K, {
    className: "".concat(r, "-close"),
    disabled: X
  }), H.closeIcon) : null, ie = /* @__PURE__ */ Re.createElement("div", {
    className: _e("".concat(r, "-content"), I?.content),
    style: L?.content
  }, te, J, /* @__PURE__ */ Re.createElement("div", vt({
    className: _e("".concat(r, "-body"), I?.body),
    style: ce(ce({}, x), L?.body)
  }, E), w), G);
  return /* @__PURE__ */ Re.createElement("div", {
    key: "dialog-element",
    role: "dialog",
    "aria-labelledby": c ? d : null,
    "aria-modal": "true",
    ref: W,
    style: ce(ce({}, i), Y),
    className: _e(r, a),
    onMouseDown: k,
    onMouseUp: M
  }, /* @__PURE__ */ Re.createElement("div", {
    ref: Q,
    tabIndex: 0,
    style: Vme
  }, /* @__PURE__ */ Re.createElement(Fme, {
    shouldUpdate: N || D
  }, P ? P(ie) : ie)), /* @__PURE__ */ Re.createElement("div", {
    tabIndex: 0,
    ref: U,
    style: Wme
  }));
});
process.env.NODE_ENV !== "production" && (Bz.displayName = "Panel");
var bK = /* @__PURE__ */ S.forwardRef(function(e, t) {
  var r = e.prefixCls, a = e.title, i = e.style, c = e.className, d = e.visible, f = e.forceRender, p = e.destroyOnClose, g = e.motionName, b = e.ariaId, w = e.onVisibleChanged, x = e.mousePosition, E = It(), P = S.useState(), k = qe(P, 2), M = k[0], T = k[1], N = {};
  M && (N.transformOrigin = M);
  function D() {
    var $ = Hme(E.current);
    T(x && (x.x || x.y) ? "".concat(x.x - $.left, "px ").concat(x.y - $.top, "px") : "");
  }
  return /* @__PURE__ */ S.createElement(N0, {
    visible: d,
    onVisibleChanged: w,
    onAppearPrepare: D,
    onEnterPrepare: D,
    forceRender: f,
    motionName: g,
    removeOnLeave: p,
    ref: E
  }, function($, j) {
    var I = $.className, L = $.style;
    return /* @__PURE__ */ S.createElement(Bz, vt({}, e, {
      ref: t,
      title: a,
      ariaId: b,
      prefixCls: r,
      holderRef: j,
      style: ce(ce(ce({}, L), i), N),
      className: _e(c, I)
    }));
  });
});
bK.displayName = "Content";
var _me = function(t) {
  var r = t.prefixCls, a = t.style, i = t.visible, c = t.maskProps, d = t.motionName, f = t.className;
  return /* @__PURE__ */ S.createElement(N0, {
    key: "mask",
    visible: i,
    motionName: d,
    leavedClassName: "".concat(r, "-mask-hidden")
  }, function(p, g) {
    var b = p.className, w = p.style;
    return /* @__PURE__ */ S.createElement("div", vt({
      ref: g,
      style: ce(ce({}, w), a),
      className: _e("".concat(r, "-mask"), b, f)
    }, c));
  });
}, Bme = function(t) {
  var r = t.prefixCls, a = r === void 0 ? "rc-dialog" : r, i = t.zIndex, c = t.visible, d = c === void 0 ? !1 : c, f = t.keyboard, p = f === void 0 ? !0 : f, g = t.focusTriggerAfterClose, b = g === void 0 ? !0 : g, w = t.wrapStyle, x = t.wrapClassName, E = t.wrapProps, P = t.onClose, k = t.afterOpenChange, M = t.afterClose, T = t.transitionName, N = t.animation, D = t.closable, $ = D === void 0 ? !0 : D, j = t.mask, I = j === void 0 ? !0 : j, L = t.maskTransitionName, F = t.maskAnimation, _ = t.maskClosable, W = _ === void 0 ? !0 : _, Q = t.maskStyle, U = t.maskProps, Y = t.rootClassName, G = t.classNames, J = t.styles;
  process.env.NODE_ENV !== "production" && (["wrapStyle", "bodyStyle", "maskStyle"].forEach(function(Ne) {
    pb(!(Ne in t), "".concat(Ne, " is deprecated, please use styles instead."));
  }), "wrapClassName" in t && pb(!1, "wrapClassName is deprecated, please use classNames instead."));
  var H = It(), K = It(), X = It(), te = S.useState(d), ie = qe(te, 2), ee = ie[0], ne = ie[1], ae = KE();
  function oe() {
    NN(K.current, document.activeElement) || (H.current = document.activeElement);
  }
  function fe() {
    if (!NN(K.current, document.activeElement)) {
      var Ne;
      (Ne = X.current) === null || Ne === void 0 || Ne.focus();
    }
  }
  function be(Ne) {
    if (Ne)
      fe();
    else {
      if (ne(!1), I && H.current && b) {
        try {
          H.current.focus({
            preventScroll: !0
          });
        } catch {
        }
        H.current = null;
      }
      ee && M?.();
    }
    k?.(Ne);
  }
  function me(Ne) {
    P?.(Ne);
  }
  var De = It(!1), Me = It(), ze = function() {
    clearTimeout(Me.current), De.current = !0;
  }, le = function() {
    Me.current = setTimeout(function() {
      De.current = !1;
    });
  }, se = null;
  W && (se = function(pe) {
    De.current ? De.current = !1 : K.current === pe.target && me(pe);
  });
  function Ae(Ne) {
    if (p && Ne.keyCode === fn.ESC) {
      Ne.stopPropagation(), me(Ne);
      return;
    }
    d && Ne.keyCode === fn.TAB && X.current.changeActive(!Ne.shiftKey);
  }
  Er(function() {
    d && (ne(!0), oe());
  }, [d]), Er(function() {
    return function() {
      clearTimeout(Me.current);
    };
  }, []);
  var we = ce(ce(ce({
    zIndex: i
  }, w), J?.wrapper), {}, {
    display: ee ? null : "none"
  });
  return /* @__PURE__ */ S.createElement("div", vt({
    className: _e("".concat(a, "-root"), Y)
  }, Zu(t, {
    data: !0
  })), /* @__PURE__ */ S.createElement(_me, {
    prefixCls: a,
    visible: I && d,
    motionName: rF(a, L, F),
    style: ce(ce({
      zIndex: i
    }, Q), J?.mask),
    maskProps: U,
    className: G?.mask
  }), /* @__PURE__ */ S.createElement("div", vt({
    tabIndex: -1,
    onKeyDown: Ae,
    className: _e("".concat(a, "-wrap"), x, G?.wrapper),
    ref: K,
    onClick: se,
    style: we
  }, E), /* @__PURE__ */ S.createElement(bK, vt({}, t, {
    onMouseDown: ze,
    onMouseUp: le,
    ref: X,
    closable: $,
    ariaId: ae,
    prefixCls: a,
    visible: d && ee,
    onClose: me,
    onVisibleChanged: be,
    motionName: rF(a, T, N)
  }))));
}, yK = function(t) {
  var r = t.visible, a = t.getContainer, i = t.forceRender, c = t.destroyOnClose, d = c === void 0 ? !1 : c, f = t.afterClose, p = t.panelRef, g = S.useState(r), b = qe(g, 2), w = b[0], x = b[1], E = S.useMemo(function() {
    return {
      panel: p
    };
  }, [p]);
  return S.useEffect(function() {
    r && x(!0);
  }, [r]), !i && d && !w ? null : /* @__PURE__ */ S.createElement(vK.Provider, {
    value: E
  }, /* @__PURE__ */ S.createElement(qE, {
    open: r || i || w,
    autoDestroy: !1,
    getContainer: a,
    autoLock: r || w
  }, /* @__PURE__ */ S.createElement(Bme, vt({}, t, {
    destroyOnClose: d,
    afterClose: function() {
      f?.(), x(!1);
    }
  }))));
};
yK.displayName = "Dialog";
var _4 = "RC_FORM_INTERNAL_HOOKS", cl = function() {
  $n(!1, "Can not find FormContext. Please make sure you wrap Field under Form.");
}, kx = /* @__PURE__ */ S.createContext({
  getFieldValue: cl,
  getFieldsValue: cl,
  getFieldError: cl,
  getFieldWarning: cl,
  getFieldsError: cl,
  isFieldsTouched: cl,
  isFieldTouched: cl,
  isFieldValidating: cl,
  isFieldsValidating: cl,
  resetFields: cl,
  setFields: cl,
  setFieldValue: cl,
  setFieldsValue: cl,
  validateFields: cl,
  submit: cl,
  getInternalHooks: function() {
    return cl(), {
      dispatch: cl,
      initEntityValue: cl,
      registerField: cl,
      useSubscribe: cl,
      setInitialValues: cl,
      destroyForm: cl,
      setCallbacks: cl,
      registerWatch: cl,
      getFields: cl,
      setValidateMessages: cl,
      setPreserve: cl,
      getInitialValue: cl
    };
  }
}), Bk = /* @__PURE__ */ S.createContext(null);
function gD(e) {
  return e == null ? [] : Array.isArray(e) ? e : [e];
}
function Ume(e) {
  return e && !!e._init;
}
function vD() {
  return {
    default: "Validation error on field %s",
    required: "%s is required",
    enum: "%s must be one of %s",
    whitespace: "%s cannot be empty",
    date: {
      format: "%s date %s is invalid for format %s",
      parse: "%s date could not be parsed, %s is invalid ",
      invalid: "%s date %s is invalid"
    },
    types: {
      string: "%s is not a %s",
      method: "%s is not a %s (function)",
      array: "%s is not an %s",
      object: "%s is not an %s",
      number: "%s is not a %s",
      date: "%s is not a %s",
      boolean: "%s is not a %s",
      integer: "%s is not an %s",
      float: "%s is not a %s",
      regexp: "%s is not a valid %s",
      email: "%s is not a valid %s",
      tel: "%s is not a valid %s",
      url: "%s is not a valid %s",
      hex: "%s is not a valid %s"
    },
    string: {
      len: "%s must be exactly %s characters",
      min: "%s must be at least %s characters",
      max: "%s cannot be longer than %s characters",
      range: "%s must be between %s and %s characters"
    },
    number: {
      len: "%s must equal %s",
      min: "%s cannot be less than %s",
      max: "%s cannot be greater than %s",
      range: "%s must be between %s and %s"
    },
    array: {
      len: "%s must be exactly %s in length",
      min: "%s cannot be less than %s in length",
      max: "%s cannot be greater than %s in length",
      range: "%s must be between %s and %s in length"
    },
    pattern: {
      mismatch: "%s value %s does not match pattern %s"
    },
    clone: function() {
      var t = JSON.parse(JSON.stringify(this));
      return t.clone = this.clone, t;
    }
  };
}
var bD = vD();
function Xme(e) {
  try {
    return Function.toString.call(e).indexOf("[native code]") !== -1;
  } catch {
    return typeof e == "function";
  }
}
function Gme(e, t, r) {
  if (tC()) return Reflect.construct.apply(null, arguments);
  var a = [null];
  a.push.apply(a, t);
  var i = new (e.bind.apply(e, a))();
  return r && EE(i, r.prototype), i;
}
function yD(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return yD = function(a) {
    if (a === null || !Xme(a)) return a;
    if (typeof a != "function") throw new TypeError("Super expression must either be null or a function");
    if (t !== void 0) {
      if (t.has(a)) return t.get(a);
      t.set(a, i);
    }
    function i() {
      return Gme(a, arguments, Yh(this).constructor);
    }
    return i.prototype = Object.create(a.prototype, {
      constructor: {
        value: i,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), EE(i, a);
  }, yD(e);
}
var qme = /%[sdj%]/g, wK = function() {
};
typeof process < "u" && process.env && process.env.NODE_ENV !== "production" && typeof window < "u" && typeof document < "u" && (wK = function(t, r) {
  typeof console < "u" && console.warn && typeof ASYNC_VALIDATOR_NO_WARNING > "u" && r.every(function(a) {
    return typeof a == "string";
  }) && console.warn(t, r);
});
function wD(e) {
  if (!e || !e.length) return null;
  var t = {};
  return e.forEach(function(r) {
    var a = r.field;
    t[a] = t[a] || [], t[a].push(r);
  }), t;
}
function O0(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
    r[a - 1] = arguments[a];
  var i = 0, c = r.length;
  if (typeof e == "function")
    return e.apply(null, r);
  if (typeof e == "string") {
    var d = e.replace(qme, function(f) {
      if (f === "%%")
        return "%";
      if (i >= c)
        return f;
      switch (f) {
        case "%s":
          return String(r[i++]);
        case "%d":
          return Number(r[i++]);
        case "%j":
          try {
            return JSON.stringify(r[i++]);
          } catch {
            return "[Circular]";
          }
          break;
        default:
          return f;
      }
    });
    return d;
  }
  return e;
}
function Kme(e) {
  return e === "string" || e === "url" || e === "hex" || e === "email" || e === "date" || e === "pattern" || e === "tel";
}
function sd(e, t) {
  return !!(e == null || t === "array" && Array.isArray(e) && !e.length || Kme(t) && typeof e == "string" && !e);
}
function Yme(e, t, r) {
  var a = [], i = 0, c = e.length;
  function d(f) {
    a.push.apply(a, Et(f || [])), i++, i === c && r(a);
  }
  e.forEach(function(f) {
    t(f, d);
  });
}
function oF(e, t, r) {
  var a = 0, i = e.length;
  function c(d) {
    if (d && d.length) {
      r(d);
      return;
    }
    var f = a;
    a = a + 1, f < i ? t(e[f], c) : r([]);
  }
  c([]);
}
function Qme(e) {
  var t = [];
  return Object.keys(e).forEach(function(r) {
    t.push.apply(t, Et(e[r] || []));
  }), t;
}
var iF = /* @__PURE__ */ (function(e) {
  pd(r, e);
  var t = B0(r);
  function r(a, i) {
    var c;
    return Vi(this, r), c = t.call(this, "Async Validation Error"), ge(bn(c), "errors", void 0), ge(bn(c), "fields", void 0), c.errors = a, c.fields = i, c;
  }
  return _i(r);
})(/* @__PURE__ */ yD(Error));
function Jme(e, t, r, a, i) {
  if (t.first) {
    var c = new Promise(function(x, E) {
      var P = function(T) {
        return a(T), T.length ? E(new iF(T, wD(T))) : x(i);
      }, k = Qme(e);
      oF(k, r, P);
    });
    return c.catch(function(x) {
      return x;
    }), c;
  }
  var d = t.firstFields === !0 ? Object.keys(e) : t.firstFields || [], f = Object.keys(e), p = f.length, g = 0, b = [], w = new Promise(function(x, E) {
    var P = function(M) {
      if (b.push.apply(b, M), g++, g === p)
        return a(b), b.length ? E(new iF(b, wD(b))) : x(i);
    };
    f.length || (a(b), x(i)), f.forEach(function(k) {
      var M = e[k];
      d.indexOf(k) !== -1 ? oF(M, r, P) : Yme(M, r, P);
    });
  });
  return w.catch(function(x) {
    return x;
  }), w;
}
function Zme(e) {
  return !!(e && e.message !== void 0);
}
function ehe(e, t) {
  for (var r = e, a = 0; a < t.length; a++) {
    if (r == null)
      return r;
    r = r[t[a]];
  }
  return r;
}
function lF(e, t) {
  return function(r) {
    var a;
    return e.fullFields ? a = ehe(t, e.fullFields) : a = t[r.field || e.fullField], Zme(r) ? (r.field = r.field || e.fullField, r.fieldValue = a, r) : {
      message: typeof r == "function" ? r() : r,
      fieldValue: a,
      field: r.field || e.fullField
    };
  };
}
function sF(e, t) {
  if (t) {
    for (var r in t)
      if (t.hasOwnProperty(r)) {
        var a = t[r];
        Hn(a) === "object" && Hn(e[r]) === "object" ? e[r] = ce(ce({}, e[r]), a) : e[r] = a;
      }
  }
  return e;
}
var P3 = "enum", the = function(t, r, a, i, c) {
  t[P3] = Array.isArray(t[P3]) ? t[P3] : [], t[P3].indexOf(r) === -1 && i.push(O0(c.messages[P3], t.fullField, t[P3].join(", ")));
}, nhe = function(t, r, a, i, c) {
  if (t.pattern) {
    if (t.pattern instanceof RegExp)
      t.pattern.lastIndex = 0, t.pattern.test(r) || i.push(O0(c.messages.pattern.mismatch, t.fullField, r, t.pattern));
    else if (typeof t.pattern == "string") {
      var d = new RegExp(t.pattern);
      d.test(r) || i.push(O0(c.messages.pattern.mismatch, t.fullField, r, t.pattern));
    }
  }
}, rhe = function(t, r, a, i, c) {
  var d = typeof t.len == "number", f = typeof t.min == "number", p = typeof t.max == "number", g = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, b = r, w = null, x = typeof r == "number", E = typeof r == "string", P = Array.isArray(r);
  if (x ? w = "number" : E ? w = "string" : P && (w = "array"), !w)
    return !1;
  P && (b = r.length), E && (b = r.replace(g, "_").length), d ? b !== t.len && i.push(O0(c.messages[w].len, t.fullField, t.len)) : f && !p && b < t.min ? i.push(O0(c.messages[w].min, t.fullField, t.min)) : p && !f && b > t.max ? i.push(O0(c.messages[w].max, t.fullField, t.max)) : f && p && (b < t.min || b > t.max) && i.push(O0(c.messages[w].range, t.fullField, t.min, t.max));
}, SK = function(t, r, a, i, c, d) {
  t.required && (!a.hasOwnProperty(t.field) || sd(r, d || t.type)) && i.push(O0(c.messages.required, t.fullField));
}, W7;
const ahe = (function() {
  if (W7)
    return W7;
  var e = "[a-fA-F\\d:]", t = function(I) {
    return I && I.includeBoundaries ? "(?:(?<=\\s|^)(?=".concat(e, ")|(?<=").concat(e, ")(?=\\s|$))") : "";
  }, r = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}", a = "[a-fA-F\\d]{1,4}", i = [
    "(?:".concat(a, ":){7}(?:").concat(a, "|:)"),
    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8
    "(?:".concat(a, ":){6}(?:").concat(r, "|:").concat(a, "|:)"),
    // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::
    "(?:".concat(a, ":){5}(?::").concat(r, "|(?::").concat(a, "){1,2}|:)"),
    // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::
    "(?:".concat(a, ":){4}(?:(?::").concat(a, "){0,1}:").concat(r, "|(?::").concat(a, "){1,3}|:)"),
    // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::
    "(?:".concat(a, ":){3}(?:(?::").concat(a, "){0,2}:").concat(r, "|(?::").concat(a, "){1,4}|:)"),
    // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::
    "(?:".concat(a, ":){2}(?:(?::").concat(a, "){0,3}:").concat(r, "|(?::").concat(a, "){1,5}|:)"),
    // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::
    "(?:".concat(a, ":){1}(?:(?::").concat(a, "){0,4}:").concat(r, "|(?::").concat(a, "){1,6}|:)"),
    // 1::              1::3:4:5:6:7:8   1::8            1::
    "(?::(?:(?::".concat(a, "){0,5}:").concat(r, "|(?::").concat(a, "){1,7}|:))")
    // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::
  ], c = "(?:%[0-9a-zA-Z]{1,})?", d = "(?:".concat(i.join("|"), ")").concat(c), f = new RegExp("(?:^".concat(r, "$)|(?:^").concat(d, "$)")), p = new RegExp("^".concat(r, "$")), g = new RegExp("^".concat(d, "$")), b = function(I) {
    return I && I.exact ? f : new RegExp("(?:".concat(t(I)).concat(r).concat(t(I), ")|(?:").concat(t(I)).concat(d).concat(t(I), ")"), "g");
  };
  b.v4 = function(j) {
    return j && j.exact ? p : new RegExp("".concat(t(j)).concat(r).concat(t(j)), "g");
  }, b.v6 = function(j) {
    return j && j.exact ? g : new RegExp("".concat(t(j)).concat(d).concat(t(j)), "g");
  };
  var w = "(?:(?:[a-z]+:)?//)", x = "(?:\\S+(?::\\S*)?@)?", E = b.v4().source, P = b.v6().source, k = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)", M = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*", T = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))", N = "(?::\\d{2,5})?", D = '(?:[/?#][^\\s"]*)?', $ = "(?:".concat(w, "|www\\.)").concat(x, "(?:localhost|").concat(E, "|").concat(P, "|").concat(k).concat(M).concat(T, ")").concat(N).concat(D);
  return W7 = new RegExp("(?:^".concat($, "$)"), "i"), W7;
});
var ZT = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
  // url: new RegExp(
  //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
  //   'i',
  // ),
  /**
   * Phone number regex, support country code, brackets, spaces, and dashes (or non-breaking hyphen \u2011).
   * @see https://regexr.com/3c53v
   * @see https://ihateregex.io/expr/phone/
   * @see https://developers.google.com/style/phone-numbers using non-breaking hyphen \u2011
   */
  tel: /^(\+[0-9]{1,3}[-\s\u2011]?)?(\([0-9]{1,4}\)[-\s\u2011]?)?([0-9]+[-\s\u2011]?)*[0-9]+$/,
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
}, rE = {
  integer: function(t) {
    return rE.number(t) && parseInt(t, 10) === t;
  },
  float: function(t) {
    return rE.number(t) && !rE.integer(t);
  },
  array: function(t) {
    return Array.isArray(t);
  },
  regexp: function(t) {
    if (t instanceof RegExp)
      return !0;
    try {
      return !!new RegExp(t);
    } catch {
      return !1;
    }
  },
  date: function(t) {
    return typeof t.getTime == "function" && typeof t.getMonth == "function" && typeof t.getYear == "function" && !isNaN(t.getTime());
  },
  number: function(t) {
    return isNaN(t) ? !1 : typeof t == "number";
  },
  object: function(t) {
    return Hn(t) === "object" && !rE.array(t);
  },
  method: function(t) {
    return typeof t == "function";
  },
  email: function(t) {
    return typeof t == "string" && t.length <= 320 && !!t.match(ZT.email);
  },
  tel: function(t) {
    return typeof t == "string" && t.length <= 32 && !!t.match(ZT.tel);
  },
  url: function(t) {
    return typeof t == "string" && t.length <= 2048 && !!t.match(ahe());
  },
  hex: function(t) {
    return typeof t == "string" && !!t.match(ZT.hex);
  }
}, ohe = function(t, r, a, i, c) {
  if (t.required && r === void 0) {
    SK(t, r, a, i, c);
    return;
  }
  var d = ["integer", "float", "array", "regexp", "object", "method", "email", "tel", "number", "date", "url", "hex"], f = t.type;
  d.indexOf(f) > -1 ? rE[f](r) || i.push(O0(c.messages.types[f], t.fullField, t.type)) : f && Hn(r) !== t.type && i.push(O0(c.messages.types[f], t.fullField, t.type));
}, ihe = function(t, r, a, i, c) {
  (/^\s+$/.test(r) || r === "") && i.push(O0(c.messages.whitespace, t.fullField));
};
const No = {
  required: SK,
  whitespace: ihe,
  type: ohe,
  range: rhe,
  enum: the,
  pattern: nhe
};
var lhe = function(t, r, a, i, c) {
  var d = [], f = t.required || !t.required && i.hasOwnProperty(t.field);
  if (f) {
    if (sd(r) && !t.required)
      return a();
    No.required(t, r, i, d, c);
  }
  a(d);
}, she = function(t, r, a, i, c) {
  var d = [], f = t.required || !t.required && i.hasOwnProperty(t.field);
  if (f) {
    if (r == null && !t.required)
      return a();
    No.required(t, r, i, d, c, "array"), r != null && (No.type(t, r, i, d, c), No.range(t, r, i, d, c));
  }
  a(d);
}, uhe = function(t, r, a, i, c) {
  var d = [], f = t.required || !t.required && i.hasOwnProperty(t.field);
  if (f) {
    if (sd(r) && !t.required)
      return a();
    No.required(t, r, i, d, c), r !== void 0 && No.type(t, r, i, d, c);
  }
  a(d);
}, che = function(t, r, a, i, c) {
  var d = [], f = t.required || !t.required && i.hasOwnProperty(t.field);
  if (f) {
    if (sd(r, "date") && !t.required)
      return a();
    if (No.required(t, r, i, d, c), !sd(r, "date")) {
      var p;
      r instanceof Date ? p = r : p = new Date(r), No.type(t, p, i, d, c), p && No.range(t, p.getTime(), i, d, c);
    }
  }
  a(d);
}, dhe = "enum", fhe = function(t, r, a, i, c) {
  var d = [], f = t.required || !t.required && i.hasOwnProperty(t.field);
  if (f) {
    if (sd(r) && !t.required)
      return a();
    No.required(t, r, i, d, c), r !== void 0 && No[dhe](t, r, i, d, c);
  }
  a(d);
}, mhe = function(t, r, a, i, c) {
  var d = [], f = t.required || !t.required && i.hasOwnProperty(t.field);
  if (f) {
    if (sd(r) && !t.required)
      return a();
    No.required(t, r, i, d, c), r !== void 0 && (No.type(t, r, i, d, c), No.range(t, r, i, d, c));
  }
  a(d);
}, hhe = function(t, r, a, i, c) {
  var d = [], f = t.required || !t.required && i.hasOwnProperty(t.field);
  if (f) {
    if (sd(r) && !t.required)
      return a();
    No.required(t, r, i, d, c), r !== void 0 && (No.type(t, r, i, d, c), No.range(t, r, i, d, c));
  }
  a(d);
}, phe = function(t, r, a, i, c) {
  var d = [], f = t.required || !t.required && i.hasOwnProperty(t.field);
  if (f) {
    if (sd(r) && !t.required)
      return a();
    No.required(t, r, i, d, c), r !== void 0 && No.type(t, r, i, d, c);
  }
  a(d);
}, ghe = function(t, r, a, i, c) {
  var d = [], f = t.required || !t.required && i.hasOwnProperty(t.field);
  if (f) {
    if (r === "" && (r = void 0), sd(r) && !t.required)
      return a();
    No.required(t, r, i, d, c), r !== void 0 && (No.type(t, r, i, d, c), No.range(t, r, i, d, c));
  }
  a(d);
}, vhe = function(t, r, a, i, c) {
  var d = [], f = t.required || !t.required && i.hasOwnProperty(t.field);
  if (f) {
    if (sd(r) && !t.required)
      return a();
    No.required(t, r, i, d, c), r !== void 0 && No.type(t, r, i, d, c);
  }
  a(d);
}, bhe = function(t, r, a, i, c) {
  var d = [], f = t.required || !t.required && i.hasOwnProperty(t.field);
  if (f) {
    if (sd(r, "string") && !t.required)
      return a();
    No.required(t, r, i, d, c), sd(r, "string") || No.pattern(t, r, i, d, c);
  }
  a(d);
}, yhe = function(t, r, a, i, c) {
  var d = [], f = t.required || !t.required && i.hasOwnProperty(t.field);
  if (f) {
    if (sd(r) && !t.required)
      return a();
    No.required(t, r, i, d, c), sd(r) || No.type(t, r, i, d, c);
  }
  a(d);
}, whe = function(t, r, a, i, c) {
  var d = [], f = Array.isArray(r) ? "array" : Hn(r);
  No.required(t, r, i, d, c, f), a(d);
}, She = function(t, r, a, i, c) {
  var d = [], f = t.required || !t.required && i.hasOwnProperty(t.field);
  if (f) {
    if (sd(r, "string") && !t.required)
      return a();
    No.required(t, r, i, d, c, "string"), sd(r, "string") || (No.type(t, r, i, d, c), No.range(t, r, i, d, c), No.pattern(t, r, i, d, c), t.whitespace === !0 && No.whitespace(t, r, i, d, c));
  }
  a(d);
}, V7 = function(t, r, a, i, c) {
  var d = t.type, f = [], p = t.required || !t.required && i.hasOwnProperty(t.field);
  if (p) {
    if (sd(r, d) && !t.required)
      return a();
    No.required(t, r, i, f, c, d), sd(r, d) || No.type(t, r, i, f, c);
  }
  a(f);
};
const fE = {
  string: She,
  method: phe,
  number: ghe,
  boolean: uhe,
  regexp: yhe,
  integer: hhe,
  float: mhe,
  array: she,
  object: vhe,
  enum: fhe,
  pattern: bhe,
  date: che,
  url: V7,
  hex: V7,
  email: V7,
  tel: V7,
  required: whe,
  any: lhe
};
var YE = /* @__PURE__ */ (function() {
  function e(t) {
    Vi(this, e), ge(this, "rules", null), ge(this, "_messages", bD), this.define(t);
  }
  return _i(e, [{
    key: "define",
    value: function(r) {
      var a = this;
      if (!r)
        throw new Error("Cannot configure a schema with no rules");
      if (Hn(r) !== "object" || Array.isArray(r))
        throw new Error("Rules must be an object");
      this.rules = {}, Object.keys(r).forEach(function(i) {
        var c = r[i];
        a.rules[i] = Array.isArray(c) ? c : [c];
      });
    }
  }, {
    key: "messages",
    value: function(r) {
      return r && (this._messages = sF(vD(), r)), this._messages;
    }
  }, {
    key: "validate",
    value: function(r) {
      var a = this, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {
      }, d = r, f = i, p = c;
      if (typeof f == "function" && (p = f, f = {}), !this.rules || Object.keys(this.rules).length === 0)
        return p && p(null, d), Promise.resolve(d);
      function g(P) {
        var k = [], M = {};
        function T(D) {
          if (Array.isArray(D)) {
            var $;
            k = ($ = k).concat.apply($, Et(D));
          } else
            k.push(D);
        }
        for (var N = 0; N < P.length; N++)
          T(P[N]);
        k.length ? (M = wD(k), p(k, M)) : p(null, d);
      }
      if (f.messages) {
        var b = this.messages();
        b === bD && (b = vD()), sF(b, f.messages), f.messages = b;
      } else
        f.messages = this.messages();
      var w = {}, x = f.keys || Object.keys(this.rules);
      x.forEach(function(P) {
        var k = a.rules[P], M = d[P];
        k.forEach(function(T) {
          var N = T;
          typeof N.transform == "function" && (d === r && (d = ce({}, d)), M = d[P] = N.transform(M), M != null && (N.type = N.type || (Array.isArray(M) ? "array" : Hn(M)))), typeof N == "function" ? N = {
            validator: N
          } : N = ce({}, N), N.validator = a.getValidationMethod(N), N.validator && (N.field = P, N.fullField = N.fullField || P, N.type = a.getType(N), w[P] = w[P] || [], w[P].push({
            rule: N,
            value: M,
            source: d,
            field: P
          }));
        });
      });
      var E = {};
      return Jme(w, f, function(P, k) {
        var M = P.rule, T = (M.type === "object" || M.type === "array") && (Hn(M.fields) === "object" || Hn(M.defaultField) === "object");
        T = T && (M.required || !M.required && P.value), M.field = P.field;
        function N(L, F) {
          return ce(ce({}, F), {}, {
            fullField: "".concat(M.fullField, ".").concat(L),
            fullFields: M.fullFields ? [].concat(Et(M.fullFields), [L]) : [L]
          });
        }
        function D() {
          var L = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], F = Array.isArray(L) ? L : [L];
          !f.suppressWarning && F.length && e.warning("async-validator:", F), F.length && M.message !== void 0 && M.message !== null && (F = [].concat(M.message));
          var _ = F.map(lF(M, d));
          if (f.first && _.length)
            return E[M.field] = 1, k(_);
          if (!T)
            k(_);
          else {
            if (M.required && !P.value)
              return M.message !== void 0 ? _ = [].concat(M.message).map(lF(M, d)) : f.error && (_ = [f.error(M, O0(f.messages.required, M.field))]), k(_);
            var W = {};
            M.defaultField && Object.keys(P.value).map(function(Y) {
              W[Y] = M.defaultField;
            }), W = ce(ce({}, W), P.rule.fields);
            var Q = {};
            Object.keys(W).forEach(function(Y) {
              var G = W[Y], J = Array.isArray(G) ? G : [G];
              Q[Y] = J.map(N.bind(null, Y));
            });
            var U = new e(Q);
            U.messages(f.messages), P.rule.options && (P.rule.options.messages = f.messages, P.rule.options.error = f.error), U.validate(P.value, P.rule.options || f, function(Y) {
              var G = [];
              _ && _.length && G.push.apply(G, Et(_)), Y && Y.length && G.push.apply(G, Et(Y)), k(G.length ? G : null);
            });
          }
        }
        var $;
        if (M.asyncValidator)
          $ = M.asyncValidator(M, P.value, D, P.source, f);
        else if (M.validator) {
          try {
            $ = M.validator(M, P.value, D, P.source, f);
          } catch (L) {
            var j, I;
            (j = (I = console).error) === null || j === void 0 || j.call(I, L), f.suppressValidatorError || setTimeout(function() {
              throw L;
            }, 0), D(L.message);
          }
          $ === !0 ? D() : $ === !1 ? D(typeof M.message == "function" ? M.message(M.fullField || M.field) : M.message || "".concat(M.fullField || M.field, " fails")) : $ instanceof Array ? D($) : $ instanceof Error && D($.message);
        }
        $ && $.then && $.then(function() {
          return D();
        }, function(L) {
          return D(L);
        });
      }, function(P) {
        g(P);
      }, d);
    }
  }, {
    key: "getType",
    value: function(r) {
      if (r.type === void 0 && r.pattern instanceof RegExp && (r.type = "pattern"), typeof r.validator != "function" && r.type && !fE.hasOwnProperty(r.type))
        throw new Error(O0("Unknown rule type %s", r.type));
      return r.type || "string";
    }
  }, {
    key: "getValidationMethod",
    value: function(r) {
      if (typeof r.validator == "function")
        return r.validator;
      var a = Object.keys(r), i = a.indexOf("message");
      return i !== -1 && a.splice(i, 1), a.length === 1 && a[0] === "required" ? fE.required : fE[this.getType(r)] || void 0;
    }
  }]), e;
})();
ge(YE, "register", function(t, r) {
  if (typeof r != "function")
    throw new Error("Cannot register a validator by type, validator is not a function");
  fE[t] = r;
});
ge(YE, "warning", wK);
ge(YE, "messages", bD);
ge(YE, "validators", fE);
var C0 = "'${name}' is not a valid ${type}", CK = {
  default: "Validation error on field '${name}'",
  required: "'${name}' is required",
  enum: "'${name}' must be one of [${enum}]",
  whitespace: "'${name}' cannot be empty",
  date: {
    format: "'${name}' is invalid for format date",
    parse: "'${name}' could not be parsed as date",
    invalid: "'${name}' is invalid date"
  },
  types: {
    string: C0,
    method: C0,
    array: C0,
    object: C0,
    number: C0,
    date: C0,
    boolean: C0,
    integer: C0,
    float: C0,
    regexp: C0,
    email: C0,
    url: C0,
    hex: C0
  },
  string: {
    len: "'${name}' must be exactly ${len} characters",
    min: "'${name}' must be at least ${min} characters",
    max: "'${name}' cannot be longer than ${max} characters",
    range: "'${name}' must be between ${min} and ${max} characters"
  },
  number: {
    len: "'${name}' must equal ${len}",
    min: "'${name}' cannot be less than ${min}",
    max: "'${name}' cannot be greater than ${max}",
    range: "'${name}' must be between ${min} and ${max}"
  },
  array: {
    len: "'${name}' must be exactly ${len} in length",
    min: "'${name}' cannot be less than ${min} in length",
    max: "'${name}' cannot be greater than ${max} in length",
    range: "'${name}' must be between ${min} and ${max} in length"
  },
  pattern: {
    mismatch: "'${name}' does not match pattern ${pattern}"
  }
}, uF = YE;
function Che(e, t) {
  return e.replace(/\\?\$\{\w+\}/g, function(r) {
    if (r.startsWith("\\"))
      return r.slice(1);
    var a = r.slice(2, -1);
    return t[a];
  });
}
var cF = "CODE_LOGIC_ERROR";
function SD(e, t, r, a, i) {
  return CD.apply(this, arguments);
}
function CD() {
  return CD = qh(/* @__PURE__ */ ci().mark(function e(t, r, a, i, c) {
    var d, f, p, g, b, w, x, E, P;
    return ci().wrap(function(M) {
      for (; ; ) switch (M.prev = M.next) {
        case 0:
          return d = ce({}, a), delete d.ruleIndex, uF.warning = function() {
          }, d.validator && (f = d.validator, d.validator = function() {
            try {
              return f.apply(void 0, arguments);
            } catch (T) {
              return console.error(T), Promise.reject(cF);
            }
          }), p = null, d && d.type === "array" && d.defaultField && (p = d.defaultField, delete d.defaultField), g = new uF(ge({}, t, [d])), b = K3(CK, i.validateMessages), g.messages(b), w = [], M.prev = 10, M.next = 13, Promise.resolve(g.validate(ge({}, t, r), ce({}, i)));
        case 13:
          M.next = 18;
          break;
        case 15:
          M.prev = 15, M.t0 = M.catch(10), M.t0.errors && (w = M.t0.errors.map(function(T, N) {
            var D = T.message, $ = D === cF ? b.default : D;
            return /* @__PURE__ */ S.isValidElement($) ? (
              // Wrap ReactNode with `key`
              /* @__PURE__ */ S.cloneElement($, {
                key: "error_".concat(N)
              })
            ) : $;
          }));
        case 18:
          if (!(!w.length && p && Array.isArray(r) && r.length > 0)) {
            M.next = 23;
            break;
          }
          return M.next = 21, Promise.all(r.map(function(T, N) {
            return SD("".concat(t, ".").concat(N), T, p, i, c);
          }));
        case 21:
          return x = M.sent, M.abrupt("return", x.reduce(function(T, N) {
            return [].concat(Et(T), Et(N));
          }, []));
        case 23:
          return E = ce(ce({}, a), {}, {
            name: t,
            enum: (a.enum || []).join(", ")
          }, c), P = w.map(function(T) {
            return typeof T == "string" ? Che(T, E) : T;
          }), M.abrupt("return", P);
        case 26:
        case "end":
          return M.stop();
      }
    }, e, null, [[10, 15]]);
  })), CD.apply(this, arguments);
}
function xhe(e, t, r, a, i, c) {
  var d = e.join("."), f = r.map(function(b, w) {
    var x = b.validator, E = ce(ce({}, b), {}, {
      ruleIndex: w
    });
    return x && (E.validator = function(P, k, M) {
      var T = !1, N = function() {
        for (var j = arguments.length, I = new Array(j), L = 0; L < j; L++)
          I[L] = arguments[L];
        Promise.resolve().then(function() {
          $n(!T, "Your validator function has already return a promise. `callback` will be ignored."), T || M.apply(void 0, I);
        });
      }, D = x(P, k, N);
      T = D && typeof D.then == "function" && typeof D.catch == "function", $n(T, "`callback` is deprecated. Please return a promise instead."), T && D.then(function() {
        M();
      }).catch(function($) {
        M($ || " ");
      });
    }), E;
  }).sort(function(b, w) {
    var x = b.warningOnly, E = b.ruleIndex, P = w.warningOnly, k = w.ruleIndex;
    return !!x == !!P ? E - k : x ? 1 : -1;
  }), p;
  if (i === !0)
    p = new Promise(/* @__PURE__ */ (function() {
      var b = qh(/* @__PURE__ */ ci().mark(function w(x, E) {
        var P, k, M;
        return ci().wrap(function(N) {
          for (; ; ) switch (N.prev = N.next) {
            case 0:
              P = 0;
            case 1:
              if (!(P < f.length)) {
                N.next = 12;
                break;
              }
              return k = f[P], N.next = 5, SD(d, t, k, a, c);
            case 5:
              if (M = N.sent, !M.length) {
                N.next = 9;
                break;
              }
              return E([{
                errors: M,
                rule: k
              }]), N.abrupt("return");
            case 9:
              P += 1, N.next = 1;
              break;
            case 12:
              x([]);
            case 13:
            case "end":
              return N.stop();
          }
        }, w);
      }));
      return function(w, x) {
        return b.apply(this, arguments);
      };
    })());
  else {
    var g = f.map(function(b) {
      return SD(d, t, b, a, c).then(function(w) {
        return {
          errors: w,
          rule: b
        };
      });
    });
    p = (i ? Phe(g) : Ehe(g)).then(function(b) {
      return Promise.reject(b);
    });
  }
  return p.catch(function(b) {
    return b;
  }), p;
}
function Ehe(e) {
  return xD.apply(this, arguments);
}
function xD() {
  return xD = qh(/* @__PURE__ */ ci().mark(function e(t) {
    return ci().wrap(function(a) {
      for (; ; ) switch (a.prev = a.next) {
        case 0:
          return a.abrupt("return", Promise.all(t).then(function(i) {
            var c, d = (c = []).concat.apply(c, Et(i));
            return d;
          }));
        case 1:
        case "end":
          return a.stop();
      }
    }, e);
  })), xD.apply(this, arguments);
}
function Phe(e) {
  return ED.apply(this, arguments);
}
function ED() {
  return ED = qh(/* @__PURE__ */ ci().mark(function e(t) {
    var r;
    return ci().wrap(function(i) {
      for (; ; ) switch (i.prev = i.next) {
        case 0:
          return r = 0, i.abrupt("return", new Promise(function(c) {
            t.forEach(function(d) {
              d.then(function(f) {
                f.errors.length && c([f]), r += 1, r === t.length && c([]);
              });
            });
          }));
        case 2:
        case "end":
          return i.stop();
      }
    }, e);
  })), ED.apply(this, arguments);
}
function qu(e) {
  return gD(e);
}
function dF(e, t) {
  var r = {};
  return t.forEach(function(a) {
    var i = M0(e, a);
    r = $1(r, a, i);
  }), r;
}
function rx(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  return e && e.some(function(a) {
    return xK(t, a, r);
  });
}
function xK(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  return !e || !t || !r && e.length !== t.length ? !1 : t.every(function(a, i) {
    return e[i] === a;
  });
}
function khe(e, t) {
  if (e === t)
    return !0;
  if (!e && t || e && !t || !e || !t || Hn(e) !== "object" || Hn(t) !== "object")
    return !1;
  var r = Object.keys(e), a = Object.keys(t), i = new Set([].concat(r, a));
  return Et(i).every(function(c) {
    var d = e[c], f = t[c];
    return typeof d == "function" && typeof f == "function" ? !0 : d === f;
  });
}
function Mhe(e) {
  var t = arguments.length <= 1 ? void 0 : arguments[1];
  return t && t.target && Hn(t.target) === "object" && e in t.target ? t.target[e] : t;
}
function fF(e, t, r) {
  var a = e.length;
  if (t < 0 || t >= a || r < 0 || r >= a)
    return e;
  var i = e[t], c = t - r;
  return c > 0 ? [].concat(Et(e.slice(0, r)), [i], Et(e.slice(r, t)), Et(e.slice(t + 1, a))) : c < 0 ? [].concat(Et(e.slice(0, t)), Et(e.slice(t + 1, r + 1)), [i], Et(e.slice(r + 1, a))) : e;
}
var Ohe = ["name"], I0 = [];
function eR(e, t, r, a, i, c) {
  return typeof e == "function" ? e(t, r, "source" in c ? {
    source: c.source
  } : {}) : a !== i;
}
var Uz = /* @__PURE__ */ (function(e) {
  pd(r, e);
  var t = B0(r);
  function r(a) {
    var i;
    if (Vi(this, r), i = t.call(this, a), ge(bn(i), "state", {
      resetCount: 0
    }), ge(bn(i), "cancelRegisterFunc", null), ge(bn(i), "mounted", !1), ge(bn(i), "touched", !1), ge(bn(i), "dirty", !1), ge(bn(i), "validatePromise", void 0), ge(bn(i), "prevValidating", void 0), ge(bn(i), "errors", I0), ge(bn(i), "warnings", I0), ge(bn(i), "cancelRegister", function() {
      var p = i.props, g = p.preserve, b = p.isListField, w = p.name;
      i.cancelRegisterFunc && i.cancelRegisterFunc(b, g, qu(w)), i.cancelRegisterFunc = null;
    }), ge(bn(i), "getNamePath", function() {
      var p = i.props, g = p.name, b = p.fieldContext, w = b.prefixName, x = w === void 0 ? [] : w;
      return g !== void 0 ? [].concat(Et(x), Et(g)) : [];
    }), ge(bn(i), "getRules", function() {
      var p = i.props, g = p.rules, b = g === void 0 ? [] : g, w = p.fieldContext;
      return b.map(function(x) {
        return typeof x == "function" ? x(w) : x;
      });
    }), ge(bn(i), "refresh", function() {
      i.mounted && i.setState(function(p) {
        var g = p.resetCount;
        return {
          resetCount: g + 1
        };
      });
    }), ge(bn(i), "metaCache", null), ge(bn(i), "triggerMetaEvent", function(p) {
      var g = i.props.onMetaChange;
      if (g) {
        var b = ce(ce({}, i.getMeta()), {}, {
          destroy: p
        });
        R0(i.metaCache, b) || g(b), i.metaCache = b;
      } else
        i.metaCache = null;
    }), ge(bn(i), "onStoreChange", function(p, g, b) {
      var w = i.props, x = w.shouldUpdate, E = w.dependencies, P = E === void 0 ? [] : E, k = w.onReset, M = b.store, T = i.getNamePath(), N = i.getValue(p), D = i.getValue(M), $ = g && rx(g, T);
      switch (b.type === "valueUpdate" && b.source === "external" && !R0(N, D) && (i.touched = !0, i.dirty = !0, i.validatePromise = null, i.errors = I0, i.warnings = I0, i.triggerMetaEvent()), b.type) {
        case "reset":
          if (!g || $) {
            i.touched = !1, i.dirty = !1, i.validatePromise = void 0, i.errors = I0, i.warnings = I0, i.triggerMetaEvent(), k?.(), i.refresh();
            return;
          }
          break;
        /**
         * In case field with `preserve = false` nest deps like:
         * - A = 1 => show B
         * - B = 1 => show C
         * - Reset A, need clean B, C
         */
        case "remove": {
          if (x && eR(x, p, M, N, D, b)) {
            i.reRender();
            return;
          }
          break;
        }
        case "setField": {
          var j = b.data;
          if ($) {
            "touched" in j && (i.touched = j.touched), "validating" in j && !("originRCField" in j) && (i.validatePromise = j.validating ? Promise.resolve([]) : null), "errors" in j && (i.errors = j.errors || I0), "warnings" in j && (i.warnings = j.warnings || I0), i.dirty = !0, i.triggerMetaEvent(), i.reRender();
            return;
          } else if ("value" in j && rx(g, T, !0)) {
            i.reRender();
            return;
          }
          if (x && !T.length && eR(x, p, M, N, D, b)) {
            i.reRender();
            return;
          }
          break;
        }
        case "dependenciesUpdate": {
          var I = P.map(qu);
          if (I.some(function(L) {
            return rx(b.relatedFields, L);
          })) {
            i.reRender();
            return;
          }
          break;
        }
        default:
          if ($ || (!P.length || T.length || x) && eR(x, p, M, N, D, b)) {
            i.reRender();
            return;
          }
          break;
      }
      x === !0 && i.reRender();
    }), ge(bn(i), "validateRules", function(p) {
      var g = i.getNamePath(), b = i.getValue(), w = p || {}, x = w.triggerName, E = w.validateOnly, P = E === void 0 ? !1 : E, k = Promise.resolve().then(/* @__PURE__ */ qh(/* @__PURE__ */ ci().mark(function M() {
        var T, N, D, $, j, I, L;
        return ci().wrap(function(_) {
          for (; ; ) switch (_.prev = _.next) {
            case 0:
              if (i.mounted) {
                _.next = 2;
                break;
              }
              return _.abrupt("return", []);
            case 2:
              if (T = i.props, N = T.validateFirst, D = N === void 0 ? !1 : N, $ = T.messageVariables, j = T.validateDebounce, I = i.getRules(), x && (I = I.filter(function(W) {
                return W;
              }).filter(function(W) {
                var Q = W.validateTrigger;
                if (!Q)
                  return !0;
                var U = gD(Q);
                return U.includes(x);
              })), !(j && x)) {
                _.next = 10;
                break;
              }
              return _.next = 8, new Promise(function(W) {
                setTimeout(W, j);
              });
            case 8:
              if (i.validatePromise === k) {
                _.next = 10;
                break;
              }
              return _.abrupt("return", []);
            case 10:
              return L = xhe(g, b, I, p, D, $), L.catch(function(W) {
                return W;
              }).then(function() {
                var W = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : I0;
                if (i.validatePromise === k) {
                  var Q;
                  i.validatePromise = null;
                  var U = [], Y = [];
                  (Q = W.forEach) === null || Q === void 0 || Q.call(W, function(G) {
                    var J = G.rule.warningOnly, H = G.errors, K = H === void 0 ? I0 : H;
                    J ? Y.push.apply(Y, Et(K)) : U.push.apply(U, Et(K));
                  }), i.errors = U, i.warnings = Y, i.triggerMetaEvent(), i.reRender();
                }
              }), _.abrupt("return", L);
            case 13:
            case "end":
              return _.stop();
          }
        }, M);
      })));
      return P || (i.validatePromise = k, i.dirty = !0, i.errors = I0, i.warnings = I0, i.triggerMetaEvent(), i.reRender()), k;
    }), ge(bn(i), "isFieldValidating", function() {
      return !!i.validatePromise;
    }), ge(bn(i), "isFieldTouched", function() {
      return i.touched;
    }), ge(bn(i), "isFieldDirty", function() {
      if (i.dirty || i.props.initialValue !== void 0)
        return !0;
      var p = i.props.fieldContext, g = p.getInternalHooks(_4), b = g.getInitialValue;
      return b(i.getNamePath()) !== void 0;
    }), ge(bn(i), "getErrors", function() {
      return i.errors;
    }), ge(bn(i), "getWarnings", function() {
      return i.warnings;
    }), ge(bn(i), "isListField", function() {
      return i.props.isListField;
    }), ge(bn(i), "isList", function() {
      return i.props.isList;
    }), ge(bn(i), "isPreserve", function() {
      return i.props.preserve;
    }), ge(bn(i), "getMeta", function() {
      i.prevValidating = i.isFieldValidating();
      var p = {
        touched: i.isFieldTouched(),
        validating: i.prevValidating,
        errors: i.errors,
        warnings: i.warnings,
        name: i.getNamePath(),
        validated: i.validatePromise === null
      };
      return p;
    }), ge(bn(i), "getOnlyChild", function(p) {
      if (typeof p == "function") {
        var g = i.getMeta();
        return ce(ce({}, i.getOnlyChild(p(i.getControlled(), g, i.props.fieldContext))), {}, {
          isFunction: !0
        });
      }
      var b = Kh(p);
      return b.length !== 1 || !/* @__PURE__ */ S.isValidElement(b[0]) ? {
        child: b,
        isFunction: !1
      } : {
        child: b[0],
        isFunction: !1
      };
    }), ge(bn(i), "getValue", function(p) {
      var g = i.props.fieldContext.getFieldsValue, b = i.getNamePath();
      return M0(p || g(!0), b);
    }), ge(bn(i), "getControlled", function() {
      var p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, g = i.props, b = g.name, w = g.trigger, x = g.validateTrigger, E = g.getValueFromEvent, P = g.normalize, k = g.valuePropName, M = g.getValueProps, T = g.fieldContext, N = x !== void 0 ? x : T.validateTrigger, D = i.getNamePath(), $ = T.getInternalHooks, j = T.getFieldsValue, I = $(_4), L = I.dispatch, F = i.getValue(), _ = M || function(G) {
        return ge({}, k, G);
      }, W = p[w], Q = b !== void 0 ? _(F) : {};
      process.env.NODE_ENV !== "production" && Q && Object.keys(Q).forEach(function(G) {
        $n(typeof Q[G] != "function", "It's not recommended to generate dynamic function prop by `getValueProps`. Please pass it to child component directly (prop: ".concat(G, ")"));
      });
      var U = ce(ce({}, p), Q);
      U[w] = function() {
        i.touched = !0, i.dirty = !0, i.triggerMetaEvent();
        for (var G, J = arguments.length, H = new Array(J), K = 0; K < J; K++)
          H[K] = arguments[K];
        E ? G = E.apply(void 0, H) : G = Mhe.apply(void 0, [k].concat(H)), P && (G = P(G, F, j(!0))), G !== F && L({
          type: "updateValue",
          namePath: D,
          value: G
        }), W && W.apply(void 0, H);
      };
      var Y = gD(N || []);
      return Y.forEach(function(G) {
        var J = U[G];
        U[G] = function() {
          J && J.apply(void 0, arguments);
          var H = i.props.rules;
          H && H.length && L({
            type: "validateField",
            namePath: D,
            triggerName: G
          });
        };
      }), U;
    }), a.fieldContext) {
      var c = a.fieldContext.getInternalHooks, d = c(_4), f = d.initEntityValue;
      f(bn(i));
    }
    return i;
  }
  return _i(r, [{
    key: "componentDidMount",
    value: function() {
      var i = this.props, c = i.shouldUpdate, d = i.fieldContext;
      if (this.mounted = !0, d) {
        var f = d.getInternalHooks, p = f(_4), g = p.registerField;
        this.cancelRegisterFunc = g(this);
      }
      c === !0 && this.reRender();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.cancelRegister(), this.triggerMetaEvent(!0), this.mounted = !1;
    }
  }, {
    key: "reRender",
    value: function() {
      this.mounted && this.forceUpdate();
    }
  }, {
    key: "render",
    value: function() {
      var i = this.state.resetCount, c = this.props.children, d = this.getOnlyChild(c), f = d.child, p = d.isFunction, g;
      return p ? g = f : /* @__PURE__ */ S.isValidElement(f) ? g = /* @__PURE__ */ S.cloneElement(f, this.getControlled(f.props)) : ($n(!f, "`children` of Field is not validate ReactElement."), g = f), /* @__PURE__ */ S.createElement(S.Fragment, {
        key: i
      }, g);
    }
  }]), r;
})(S.Component);
ge(Uz, "contextType", kx);
ge(Uz, "defaultProps", {
  trigger: "onChange",
  valuePropName: "value"
});
function EK(e) {
  var t, r = e.name, a = xr(e, Ohe), i = S.useContext(kx), c = S.useContext(Bk), d = r !== void 0 ? qu(r) : void 0, f = (t = a.isListField) !== null && t !== void 0 ? t : !!c, p = "keep";
  return f || (p = "_".concat((d || []).join("_"))), process.env.NODE_ENV !== "production" && a.preserve === !1 && f && d.length <= 1 && $n(!1, "`preserve` should not apply on Form.List fields."), /* @__PURE__ */ S.createElement(Uz, vt({
    key: p,
    name: d,
    isListField: f
  }, a, {
    fieldContext: i
  }));
}
function The(e) {
  var t = e.name, r = e.initialValue, a = e.children, i = e.rules, c = e.validateTrigger, d = e.isListField, f = S.useContext(kx), p = S.useContext(Bk), g = S.useRef({
    keys: [],
    id: 0
  }), b = g.current, w = S.useMemo(function() {
    var k = qu(f.prefixName) || [];
    return [].concat(Et(k), Et(qu(t)));
  }, [f.prefixName, t]), x = S.useMemo(function() {
    return ce(ce({}, f), {}, {
      prefixName: w
    });
  }, [f, w]), E = S.useMemo(function() {
    return {
      getKey: function(M) {
        var T = w.length, N = M[T];
        return [b.keys[N], M.slice(T + 1)];
      }
    };
  }, [w]);
  if (typeof a != "function")
    return $n(!1, "Form.List only accepts function as children."), null;
  var P = function(M, T, N) {
    var D = N.source;
    return D === "internal" ? !1 : M !== T;
  };
  return /* @__PURE__ */ S.createElement(Bk.Provider, {
    value: E
  }, /* @__PURE__ */ S.createElement(kx.Provider, {
    value: x
  }, /* @__PURE__ */ S.createElement(EK, {
    name: [],
    shouldUpdate: P,
    rules: i,
    validateTrigger: c,
    initialValue: r,
    isList: !0,
    isListField: d ?? !!p
  }, function(k, M) {
    var T = k.value, N = T === void 0 ? [] : T, D = k.onChange, $ = f.getFieldValue, j = function() {
      var _ = $(w || []);
      return _ || [];
    }, I = {
      add: function(_, W) {
        var Q = j();
        W >= 0 && W <= Q.length ? (b.keys = [].concat(Et(b.keys.slice(0, W)), [b.id], Et(b.keys.slice(W))), D([].concat(Et(Q.slice(0, W)), [_], Et(Q.slice(W))))) : (process.env.NODE_ENV !== "production" && (W < 0 || W > Q.length) && $n(!1, "The second parameter of the add function should be a valid positive number."), b.keys = [].concat(Et(b.keys), [b.id]), D([].concat(Et(Q), [_]))), b.id += 1;
      },
      remove: function(_) {
        var W = j(), Q = new Set(Array.isArray(_) ? _ : [_]);
        Q.size <= 0 || (b.keys = b.keys.filter(function(U, Y) {
          return !Q.has(Y);
        }), D(W.filter(function(U, Y) {
          return !Q.has(Y);
        })));
      },
      move: function(_, W) {
        if (_ !== W) {
          var Q = j();
          _ < 0 || _ >= Q.length || W < 0 || W >= Q.length || (b.keys = fF(b.keys, _, W), D(fF(Q, _, W)));
        }
      }
    }, L = N || [];
    return Array.isArray(L) || (L = [], process.env.NODE_ENV !== "production" && $n(!1, "Current value of '".concat(w.join(" > "), "' is not an array type."))), a(L.map(function(F, _) {
      var W = b.keys[_];
      return W === void 0 && (b.keys[_] = b.id, W = b.keys[_], b.id += 1), {
        name: _,
        key: W,
        isListField: !0
      };
    }), I, M);
  })));
}
function Rhe(e) {
  var t = !1, r = e.length, a = [];
  return e.length ? new Promise(function(i, c) {
    e.forEach(function(d, f) {
      d.catch(function(p) {
        return t = !0, p;
      }).then(function(p) {
        r -= 1, a[f] = p, !(r > 0) && (t && c(a), i(a));
      });
    });
  }) : Promise.resolve([]);
}
var PK = "__@field_split__";
function tR(e) {
  return e.map(function(t) {
    return "".concat(Hn(t), ":").concat(t);
  }).join(PK);
}
var k3 = /* @__PURE__ */ (function() {
  function e() {
    Vi(this, e), ge(this, "kvs", /* @__PURE__ */ new Map());
  }
  return _i(e, [{
    key: "set",
    value: function(r, a) {
      this.kvs.set(tR(r), a);
    }
  }, {
    key: "get",
    value: function(r) {
      return this.kvs.get(tR(r));
    }
  }, {
    key: "update",
    value: function(r, a) {
      var i = this.get(r), c = a(i);
      c ? this.set(r, c) : this.delete(r);
    }
  }, {
    key: "delete",
    value: function(r) {
      this.kvs.delete(tR(r));
    }
    // Since we only use this in test, let simply realize this
  }, {
    key: "map",
    value: function(r) {
      return Et(this.kvs.entries()).map(function(a) {
        var i = qe(a, 2), c = i[0], d = i[1], f = c.split(PK);
        return r({
          key: f.map(function(p) {
            var g = p.match(/^([^:]*):(.*)$/), b = qe(g, 3), w = b[1], x = b[2];
            return w === "number" ? Number(x) : x;
          }),
          value: d
        });
      });
    }
  }, {
    key: "toJSON",
    value: function() {
      var r = {};
      return this.map(function(a) {
        var i = a.key, c = a.value;
        return r[i.join(".")] = c, null;
      }), r;
    }
  }]), e;
})(), Ahe = ["name"], Nhe = /* @__PURE__ */ _i(function e(t) {
  var r = this;
  Vi(this, e), ge(this, "formHooked", !1), ge(this, "forceRootUpdate", void 0), ge(this, "subscribable", !0), ge(this, "store", {}), ge(this, "fieldEntities", []), ge(this, "initialValues", {}), ge(this, "callbacks", {}), ge(this, "validateMessages", null), ge(this, "preserve", null), ge(this, "lastValidatePromise", null), ge(this, "getForm", function() {
    return {
      getFieldValue: r.getFieldValue,
      getFieldsValue: r.getFieldsValue,
      getFieldError: r.getFieldError,
      getFieldWarning: r.getFieldWarning,
      getFieldsError: r.getFieldsError,
      isFieldsTouched: r.isFieldsTouched,
      isFieldTouched: r.isFieldTouched,
      isFieldValidating: r.isFieldValidating,
      isFieldsValidating: r.isFieldsValidating,
      resetFields: r.resetFields,
      setFields: r.setFields,
      setFieldValue: r.setFieldValue,
      setFieldsValue: r.setFieldsValue,
      validateFields: r.validateFields,
      submit: r.submit,
      _init: !0,
      getInternalHooks: r.getInternalHooks
    };
  }), ge(this, "getInternalHooks", function(a) {
    return a === _4 ? (r.formHooked = !0, {
      dispatch: r.dispatch,
      initEntityValue: r.initEntityValue,
      registerField: r.registerField,
      useSubscribe: r.useSubscribe,
      setInitialValues: r.setInitialValues,
      destroyForm: r.destroyForm,
      setCallbacks: r.setCallbacks,
      setValidateMessages: r.setValidateMessages,
      getFields: r.getFields,
      setPreserve: r.setPreserve,
      getInitialValue: r.getInitialValue,
      registerWatch: r.registerWatch
    }) : ($n(!1, "`getInternalHooks` is internal usage. Should not call directly."), null);
  }), ge(this, "useSubscribe", function(a) {
    r.subscribable = a;
  }), ge(this, "prevWithoutPreserves", null), ge(this, "setInitialValues", function(a, i) {
    if (r.initialValues = a || {}, i) {
      var c, d = K3(a, r.store);
      (c = r.prevWithoutPreserves) === null || c === void 0 || c.map(function(f) {
        var p = f.key;
        d = $1(d, p, M0(a, p));
      }), r.prevWithoutPreserves = null, r.updateStore(d);
    }
  }), ge(this, "destroyForm", function(a) {
    if (a)
      r.updateStore({});
    else {
      var i = new k3();
      r.getFieldEntities(!0).forEach(function(c) {
        r.isMergedPreserve(c.isPreserve()) || i.set(c.getNamePath(), !0);
      }), r.prevWithoutPreserves = i;
    }
  }), ge(this, "getInitialValue", function(a) {
    var i = M0(r.initialValues, a);
    return a.length ? K3(i) : i;
  }), ge(this, "setCallbacks", function(a) {
    r.callbacks = a;
  }), ge(this, "setValidateMessages", function(a) {
    r.validateMessages = a;
  }), ge(this, "setPreserve", function(a) {
    r.preserve = a;
  }), ge(this, "watchList", []), ge(this, "registerWatch", function(a) {
    return r.watchList.push(a), function() {
      r.watchList = r.watchList.filter(function(i) {
        return i !== a;
      });
    };
  }), ge(this, "notifyWatch", function() {
    var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    if (r.watchList.length) {
      var i = r.getFieldsValue(), c = r.getFieldsValue(!0);
      r.watchList.forEach(function(d) {
        d(i, c, a);
      });
    }
  }), ge(this, "timeoutId", null), ge(this, "warningUnhooked", function() {
    process.env.NODE_ENV !== "production" && !r.timeoutId && typeof window < "u" && (r.timeoutId = setTimeout(function() {
      r.timeoutId = null, r.formHooked || $n(!1, "Instance created by `useForm` is not connected to any Form element. Forget to pass `form` prop?");
    }));
  }), ge(this, "updateStore", function(a) {
    r.store = a;
  }), ge(this, "getFieldEntities", function() {
    var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    return a ? r.fieldEntities.filter(function(i) {
      return i.getNamePath().length;
    }) : r.fieldEntities;
  }), ge(this, "getFieldsMap", function() {
    var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, i = new k3();
    return r.getFieldEntities(a).forEach(function(c) {
      var d = c.getNamePath();
      i.set(d, c);
    }), i;
  }), ge(this, "getFieldEntitiesForNamePathList", function(a) {
    if (!a)
      return r.getFieldEntities(!0);
    var i = r.getFieldsMap(!0);
    return a.map(function(c) {
      var d = qu(c);
      return i.get(d) || {
        INVALIDATE_NAME_PATH: qu(c)
      };
    });
  }), ge(this, "getFieldsValue", function(a, i) {
    r.warningUnhooked();
    var c, d, f;
    if (a === !0 || Array.isArray(a) ? (c = a, d = i) : a && Hn(a) === "object" && (f = a.strict, d = a.filter), c === !0 && !d)
      return r.store;
    var p = r.getFieldEntitiesForNamePathList(Array.isArray(c) ? c : null), g = [];
    return p.forEach(function(b) {
      var w, x, E = "INVALIDATE_NAME_PATH" in b ? b.INVALIDATE_NAME_PATH : b.getNamePath();
      if (f) {
        var P, k;
        if ((P = (k = b).isList) !== null && P !== void 0 && P.call(k))
          return;
      } else if (!c && (w = (x = b).isListField) !== null && w !== void 0 && w.call(x))
        return;
      if (!d)
        g.push(E);
      else {
        var M = "getMeta" in b ? b.getMeta() : null;
        d(M) && g.push(E);
      }
    }), dF(r.store, g.map(qu));
  }), ge(this, "getFieldValue", function(a) {
    r.warningUnhooked();
    var i = qu(a);
    return M0(r.store, i);
  }), ge(this, "getFieldsError", function(a) {
    r.warningUnhooked();
    var i = r.getFieldEntitiesForNamePathList(a);
    return i.map(function(c, d) {
      return c && !("INVALIDATE_NAME_PATH" in c) ? {
        name: c.getNamePath(),
        errors: c.getErrors(),
        warnings: c.getWarnings()
      } : {
        name: qu(a[d]),
        errors: [],
        warnings: []
      };
    });
  }), ge(this, "getFieldError", function(a) {
    r.warningUnhooked();
    var i = qu(a), c = r.getFieldsError([i])[0];
    return c.errors;
  }), ge(this, "getFieldWarning", function(a) {
    r.warningUnhooked();
    var i = qu(a), c = r.getFieldsError([i])[0];
    return c.warnings;
  }), ge(this, "isFieldsTouched", function() {
    r.warningUnhooked();
    for (var a = arguments.length, i = new Array(a), c = 0; c < a; c++)
      i[c] = arguments[c];
    var d = i[0], f = i[1], p, g = !1;
    i.length === 0 ? p = null : i.length === 1 ? Array.isArray(d) ? (p = d.map(qu), g = !1) : (p = null, g = d) : (p = d.map(qu), g = f);
    var b = r.getFieldEntities(!0), w = function(M) {
      return M.isFieldTouched();
    };
    if (!p)
      return g ? b.every(function(k) {
        return w(k) || k.isList();
      }) : b.some(w);
    var x = new k3();
    p.forEach(function(k) {
      x.set(k, []);
    }), b.forEach(function(k) {
      var M = k.getNamePath();
      p.forEach(function(T) {
        T.every(function(N, D) {
          return M[D] === N;
        }) && x.update(T, function(N) {
          return [].concat(Et(N), [k]);
        });
      });
    });
    var E = function(M) {
      return M.some(w);
    }, P = x.map(function(k) {
      var M = k.value;
      return M;
    });
    return g ? P.every(E) : P.some(E);
  }), ge(this, "isFieldTouched", function(a) {
    return r.warningUnhooked(), r.isFieldsTouched([a]);
  }), ge(this, "isFieldsValidating", function(a) {
    r.warningUnhooked();
    var i = r.getFieldEntities();
    if (!a)
      return i.some(function(d) {
        return d.isFieldValidating();
      });
    var c = a.map(qu);
    return i.some(function(d) {
      var f = d.getNamePath();
      return rx(c, f) && d.isFieldValidating();
    });
  }), ge(this, "isFieldValidating", function(a) {
    return r.warningUnhooked(), r.isFieldsValidating([a]);
  }), ge(this, "resetWithFieldInitialValue", function() {
    var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = new k3(), c = r.getFieldEntities(!0);
    c.forEach(function(p) {
      var g = p.props.initialValue, b = p.getNamePath();
      if (g !== void 0) {
        var w = i.get(b) || /* @__PURE__ */ new Set();
        w.add({
          entity: p,
          value: g
        }), i.set(b, w);
      }
    });
    var d = function(g) {
      g.forEach(function(b) {
        var w = b.props.initialValue;
        if (w !== void 0) {
          var x = b.getNamePath(), E = r.getInitialValue(x);
          if (E !== void 0)
            $n(!1, "Form already set 'initialValues' with path '".concat(x.join("."), "'. Field can not overwrite it."));
          else {
            var P = i.get(x);
            if (P && P.size > 1)
              $n(!1, "Multiple Field with path '".concat(x.join("."), "' set 'initialValue'. Can not decide which one to pick."));
            else if (P) {
              var k = r.getFieldValue(x), M = b.isListField();
              !M && (!a.skipExist || k === void 0) && r.updateStore($1(r.store, x, Et(P)[0].value));
            }
          }
        }
      });
    }, f;
    a.entities ? f = a.entities : a.namePathList ? (f = [], a.namePathList.forEach(function(p) {
      var g = i.get(p);
      if (g) {
        var b;
        (b = f).push.apply(b, Et(Et(g).map(function(w) {
          return w.entity;
        })));
      }
    })) : f = c, d(f);
  }), ge(this, "resetFields", function(a) {
    r.warningUnhooked();
    var i = r.store;
    if (!a) {
      r.updateStore(K3(r.initialValues)), r.resetWithFieldInitialValue(), r.notifyObservers(i, null, {
        type: "reset"
      }), r.notifyWatch();
      return;
    }
    var c = a.map(qu);
    c.forEach(function(d) {
      var f = r.getInitialValue(d);
      r.updateStore($1(r.store, d, f));
    }), r.resetWithFieldInitialValue({
      namePathList: c
    }), r.notifyObservers(i, c, {
      type: "reset"
    }), r.notifyWatch(c);
  }), ge(this, "setFields", function(a) {
    r.warningUnhooked();
    var i = r.store, c = [];
    a.forEach(function(d) {
      var f = d.name, p = xr(d, Ahe), g = qu(f);
      c.push(g), "value" in p && r.updateStore($1(r.store, g, p.value)), r.notifyObservers(i, [g], {
        type: "setField",
        data: d
      });
    }), r.notifyWatch(c);
  }), ge(this, "getFields", function() {
    var a = r.getFieldEntities(!0), i = a.map(function(c) {
      var d = c.getNamePath(), f = c.getMeta(), p = ce(ce({}, f), {}, {
        name: d,
        value: r.getFieldValue(d)
      });
      return Object.defineProperty(p, "originRCField", {
        value: !0
      }), p;
    });
    return i;
  }), ge(this, "initEntityValue", function(a) {
    var i = a.props.initialValue;
    if (i !== void 0) {
      var c = a.getNamePath(), d = M0(r.store, c);
      d === void 0 && r.updateStore($1(r.store, c, i));
    }
  }), ge(this, "isMergedPreserve", function(a) {
    var i = a !== void 0 ? a : r.preserve;
    return i ?? !0;
  }), ge(this, "registerField", function(a) {
    r.fieldEntities.push(a);
    var i = a.getNamePath();
    if (r.notifyWatch([i]), a.props.initialValue !== void 0) {
      var c = r.store;
      r.resetWithFieldInitialValue({
        entities: [a],
        skipExist: !0
      }), r.notifyObservers(c, [a.getNamePath()], {
        type: "valueUpdate",
        source: "internal"
      });
    }
    return function(d, f) {
      var p = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
      if (r.fieldEntities = r.fieldEntities.filter(function(w) {
        return w !== a;
      }), !r.isMergedPreserve(f) && (!d || p.length > 1)) {
        var g = d ? void 0 : r.getInitialValue(i);
        if (i.length && r.getFieldValue(i) !== g && r.fieldEntities.every(function(w) {
          return (
            // Only reset when no namePath exist
            !xK(w.getNamePath(), i)
          );
        })) {
          var b = r.store;
          r.updateStore($1(b, i, g, !0)), r.notifyObservers(b, [i], {
            type: "remove"
          }), r.triggerDependenciesUpdate(b, i);
        }
      }
      r.notifyWatch([i]);
    };
  }), ge(this, "dispatch", function(a) {
    switch (a.type) {
      case "updateValue": {
        var i = a.namePath, c = a.value;
        r.updateValue(i, c);
        break;
      }
      case "validateField": {
        var d = a.namePath, f = a.triggerName;
        r.validateFields([d], {
          triggerName: f
        });
        break;
      }
    }
  }), ge(this, "notifyObservers", function(a, i, c) {
    if (r.subscribable) {
      var d = ce(ce({}, c), {}, {
        store: r.getFieldsValue(!0)
      });
      r.getFieldEntities().forEach(function(f) {
        var p = f.onStoreChange;
        p(a, i, d);
      });
    } else
      r.forceRootUpdate();
  }), ge(this, "triggerDependenciesUpdate", function(a, i) {
    var c = r.getDependencyChildrenFields(i);
    return c.length && r.validateFields(c), r.notifyObservers(a, c, {
      type: "dependenciesUpdate",
      relatedFields: [i].concat(Et(c))
    }), c;
  }), ge(this, "updateValue", function(a, i) {
    var c = qu(a), d = r.store;
    r.updateStore($1(r.store, c, i)), r.notifyObservers(d, [c], {
      type: "valueUpdate",
      source: "internal"
    }), r.notifyWatch([c]);
    var f = r.triggerDependenciesUpdate(d, c), p = r.callbacks.onValuesChange;
    if (p) {
      var g = dF(r.store, [c]);
      p(g, r.getFieldsValue());
    }
    r.triggerOnFieldsChange([c].concat(Et(f)));
  }), ge(this, "setFieldsValue", function(a) {
    r.warningUnhooked();
    var i = r.store;
    if (a) {
      var c = K3(r.store, a);
      r.updateStore(c);
    }
    r.notifyObservers(i, null, {
      type: "valueUpdate",
      source: "external"
    }), r.notifyWatch();
  }), ge(this, "setFieldValue", function(a, i) {
    r.setFields([{
      name: a,
      value: i,
      errors: [],
      warnings: []
    }]);
  }), ge(this, "getDependencyChildrenFields", function(a) {
    var i = /* @__PURE__ */ new Set(), c = [], d = new k3();
    r.getFieldEntities().forEach(function(p) {
      var g = p.props.dependencies;
      (g || []).forEach(function(b) {
        var w = qu(b);
        d.update(w, function() {
          var x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : /* @__PURE__ */ new Set();
          return x.add(p), x;
        });
      });
    });
    var f = function p(g) {
      var b = d.get(g) || /* @__PURE__ */ new Set();
      b.forEach(function(w) {
        if (!i.has(w)) {
          i.add(w);
          var x = w.getNamePath();
          w.isFieldDirty() && x.length && (c.push(x), p(x));
        }
      });
    };
    return f(a), c;
  }), ge(this, "triggerOnFieldsChange", function(a, i) {
    var c = r.callbacks.onFieldsChange;
    if (c) {
      var d = r.getFields();
      if (i) {
        var f = new k3();
        i.forEach(function(g) {
          var b = g.name, w = g.errors;
          f.set(b, w);
        }), d.forEach(function(g) {
          g.errors = f.get(g.name) || g.errors;
        });
      }
      var p = d.filter(function(g) {
        var b = g.name;
        return rx(a, b);
      });
      p.length && c(p, d);
    }
  }), ge(this, "validateFields", function(a, i) {
    r.warningUnhooked();
    var c, d;
    Array.isArray(a) || typeof a == "string" || typeof i == "string" ? (c = a, d = i) : d = a;
    var f = !!c, p = f ? c.map(qu) : [], g = [], b = String(Date.now()), w = /* @__PURE__ */ new Set(), x = d || {}, E = x.recursive, P = x.dirty;
    r.getFieldEntities(!0).forEach(function(N) {
      if (f || p.push(N.getNamePath()), !(!N.props.rules || !N.props.rules.length) && !(P && !N.isFieldDirty())) {
        var D = N.getNamePath();
        if (w.add(D.join(b)), !f || rx(p, D, E)) {
          var $ = N.validateRules(ce({
            validateMessages: ce(ce({}, CK), r.validateMessages)
          }, d));
          g.push($.then(function() {
            return {
              name: D,
              errors: [],
              warnings: []
            };
          }).catch(function(j) {
            var I, L = [], F = [];
            return (I = j.forEach) === null || I === void 0 || I.call(j, function(_) {
              var W = _.rule.warningOnly, Q = _.errors;
              W ? F.push.apply(F, Et(Q)) : L.push.apply(L, Et(Q));
            }), L.length ? Promise.reject({
              name: D,
              errors: L,
              warnings: F
            }) : {
              name: D,
              errors: L,
              warnings: F
            };
          }));
        }
      }
    });
    var k = Rhe(g);
    r.lastValidatePromise = k, k.catch(function(N) {
      return N;
    }).then(function(N) {
      var D = N.map(function($) {
        var j = $.name;
        return j;
      });
      r.notifyObservers(r.store, D, {
        type: "validateFinish"
      }), r.triggerOnFieldsChange(D, N);
    });
    var M = k.then(function() {
      return r.lastValidatePromise === k ? Promise.resolve(r.getFieldsValue(p)) : Promise.reject([]);
    }).catch(function(N) {
      var D = N.filter(function($) {
        return $ && $.errors.length;
      });
      return Promise.reject({
        values: r.getFieldsValue(p),
        errorFields: D,
        outOfDate: r.lastValidatePromise !== k
      });
    });
    M.catch(function(N) {
      return N;
    });
    var T = p.filter(function(N) {
      return w.has(N.join(b));
    });
    return r.triggerOnFieldsChange(T), M;
  }), ge(this, "submit", function() {
    r.warningUnhooked(), r.validateFields().then(function(a) {
      var i = r.callbacks.onFinish;
      if (i)
        try {
          i(a);
        } catch (c) {
          console.error(c);
        }
    }).catch(function(a) {
      var i = r.callbacks.onFinishFailed;
      i && i(a);
    });
  }), this.forceRootUpdate = t;
});
function kK(e) {
  var t = S.useRef(), r = S.useState({}), a = qe(r, 2), i = a[1];
  if (!t.current)
    if (e)
      t.current = e;
    else {
      var c = function() {
        i({});
      }, d = new Nhe(c);
      t.current = d.getForm();
    }
  return [t.current];
}
var PD = /* @__PURE__ */ S.createContext({
  triggerFormChange: function() {
  },
  triggerFormFinish: function() {
  },
  registerForm: function() {
  },
  unregisterForm: function() {
  }
}), Dhe = function(t) {
  var r = t.validateMessages, a = t.onFormChange, i = t.onFormFinish, c = t.children, d = S.useContext(PD), f = S.useRef({});
  return /* @__PURE__ */ S.createElement(PD.Provider, {
    value: ce(ce({}, d), {}, {
      validateMessages: ce(ce({}, d.validateMessages), r),
      // =========================================================
      // =                  Global Form Control                  =
      // =========================================================
      triggerFormChange: function(g, b) {
        a && a(g, {
          changedFields: b,
          forms: f.current
        }), d.triggerFormChange(g, b);
      },
      triggerFormFinish: function(g, b) {
        i && i(g, {
          values: b,
          forms: f.current
        }), d.triggerFormFinish(g, b);
      },
      registerForm: function(g, b) {
        g && (f.current = ce(ce({}, f.current), {}, ge({}, g, b))), d.registerForm(g, b);
      },
      unregisterForm: function(g) {
        var b = ce({}, f.current);
        delete b[g], f.current = b, d.unregisterForm(g);
      }
    })
  }, c);
}, $he = ["name", "initialValues", "fields", "form", "preserve", "children", "component", "validateMessages", "validateTrigger", "onValuesChange", "onFieldsChange", "onFinish", "onFinishFailed", "clearOnDestroy"], zhe = function(t, r) {
  var a = t.name, i = t.initialValues, c = t.fields, d = t.form, f = t.preserve, p = t.children, g = t.component, b = g === void 0 ? "form" : g, w = t.validateMessages, x = t.validateTrigger, E = x === void 0 ? "onChange" : x, P = t.onValuesChange, k = t.onFieldsChange, M = t.onFinish, T = t.onFinishFailed, N = t.clearOnDestroy, D = xr(t, $he), $ = S.useRef(null), j = S.useContext(PD), I = kK(d), L = qe(I, 1), F = L[0], _ = F.getInternalHooks(_4), W = _.useSubscribe, Q = _.setInitialValues, U = _.setCallbacks, Y = _.setValidateMessages, G = _.setPreserve, J = _.destroyForm;
  S.useImperativeHandle(r, function() {
    return ce(ce({}, F), {}, {
      nativeElement: $.current
    });
  }), S.useEffect(function() {
    return j.registerForm(a, F), function() {
      j.unregisterForm(a);
    };
  }, [j, F, a]), Y(ce(ce({}, j.validateMessages), w)), U({
    onValuesChange: P,
    onFieldsChange: function(oe) {
      if (j.triggerFormChange(a, oe), k) {
        for (var fe = arguments.length, be = new Array(fe > 1 ? fe - 1 : 0), me = 1; me < fe; me++)
          be[me - 1] = arguments[me];
        k.apply(void 0, [oe].concat(be));
      }
    },
    onFinish: function(oe) {
      j.triggerFormFinish(a, oe), M && M(oe);
    },
    onFinishFailed: T
  }), G(f);
  var H = S.useRef(null);
  Q(i, !H.current), H.current || (H.current = !0), S.useEffect(
    function() {
      return function() {
        return J(N);
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  var K, X = typeof p == "function";
  if (X) {
    var te = F.getFieldsValue(!0);
    K = p(te, F);
  } else
    K = p;
  W(!X);
  var ie = S.useRef();
  S.useEffect(function() {
    khe(ie.current || [], c || []) || F.setFields(c || []), ie.current = c;
  }, [c, F]);
  var ee = S.useMemo(function() {
    return ce(ce({}, F), {}, {
      validateTrigger: E
    });
  }, [F, E]), ne = /* @__PURE__ */ S.createElement(Bk.Provider, {
    value: null
  }, /* @__PURE__ */ S.createElement(kx.Provider, {
    value: ee
  }, K));
  return b === !1 ? ne : /* @__PURE__ */ S.createElement(b, vt({}, D, {
    ref: $,
    onSubmit: function(oe) {
      oe.preventDefault(), oe.stopPropagation(), F.submit();
    },
    onReset: function(oe) {
      var fe;
      oe.preventDefault(), F.resetFields(), (fe = D.onReset) === null || fe === void 0 || fe.call(D, oe);
    }
  }), ne);
};
function mF(e) {
  try {
    return JSON.stringify(e);
  } catch {
    return Math.random();
  }
}
var jhe = process.env.NODE_ENV !== "production" ? function(e) {
  var t = e.join("__RC_FIELD_FORM_SPLIT__"), r = It(t);
  $n(r.current === t, "`useWatch` is not support dynamic `namePath`. Please provide static instead.");
} : function() {
};
function Ihe() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  var a = t[0], i = t[1], c = i === void 0 ? {} : i, d = Ume(c) ? {
    form: c
  } : c, f = d.form, p = Wn(), g = qe(p, 2), b = g[0], w = g[1], x = mn(function() {
    return mF(b);
  }, [b]), E = It(x);
  E.current = x;
  var P = Do(kx), k = f || P, M = k && k._init;
  process.env.NODE_ENV !== "production" && $n(t.length === 2 ? f ? M : !0 : M, "useWatch requires a form instance since it can not auto detect from context.");
  var T = qu(a), N = It(T);
  return N.current = T, jhe(T), Er(
    function() {
      if (M) {
        var D = k.getFieldsValue, $ = k.getInternalHooks, j = $(_4), I = j.registerWatch, L = function(Q, U) {
          var Y = d.preserve ? U : Q;
          return typeof a == "function" ? a(Y) : M0(Y, N.current);
        }, F = I(function(W, Q) {
          var U = L(W, Q), Y = mF(U);
          E.current !== Y && (E.current = Y, w(U));
        }), _ = L(D(), D(!0));
        return b !== _ && w(_), F;
      }
    },
    // We do not need re-register since namePath content is the same
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [M]
  ), b;
}
var Lhe = /* @__PURE__ */ S.forwardRef(zhe), QE = Lhe;
QE.FormProvider = Dhe;
QE.Field = EK;
QE.List = The;
QE.useForm = kK;
QE.useWatch = Ihe;
const yb = /* @__PURE__ */ S.createContext({});
process.env.NODE_ENV !== "production" && (yb.displayName = "FormItemInputContext");
const Hhe = ({
  children: e,
  status: t,
  override: r
}) => {
  const a = S.useContext(yb), i = S.useMemo(() => {
    const c = Object.assign({}, a);
    return r && delete c.isFormItemInput, t && (delete c.status, delete c.hasFeedback, delete c.feedbackIcon), c;
  }, [t, r, a]);
  return /* @__PURE__ */ S.createElement(yb.Provider, {
    value: i
  }, e);
}, Fhe = /* @__PURE__ */ S.createContext(void 0), dS = (e) => {
  const {
    space: t,
    form: r,
    children: a
  } = e;
  if (a == null)
    return null;
  let i = a;
  return r && (i = /* @__PURE__ */ Re.createElement(Hhe, {
    override: !0,
    status: !0
  }, i)), t && (i = /* @__PURE__ */ Re.createElement(efe, null, i)), i;
};
var MK = function(t) {
  if (Ju() && window.document.documentElement) {
    var r = Array.isArray(t) ? t : [t], a = window.document.documentElement;
    return r.some(function(i) {
      return i in a.style;
    });
  }
  return !1;
}, Whe = function(t, r) {
  if (!MK(t))
    return !1;
  var a = document.createElement("div"), i = a.style[t];
  return a.style[t] = r, a.style[t] !== i;
};
function Vhe(e, t) {
  return !Array.isArray(e) && t !== void 0 ? Whe(e, t) : MK(e);
}
const _he = () => Ju() && window.document.documentElement, Q9 = (e) => {
  const {
    prefixCls: t,
    className: r,
    style: a,
    size: i,
    shape: c
  } = e, d = _e({
    [`${t}-lg`]: i === "large",
    [`${t}-sm`]: i === "small"
  }), f = _e({
    [`${t}-circle`]: c === "circle",
    [`${t}-square`]: c === "square",
    [`${t}-round`]: c === "round"
  }), p = S.useMemo(() => typeof i == "number" ? {
    width: i,
    height: i,
    lineHeight: `${i}px`
  } : {}, [i]);
  return /* @__PURE__ */ S.createElement("span", {
    className: _e(t, d, f, r),
    style: Object.assign(Object.assign({}, p), a)
  });
}, Bhe = new bo("ant-skeleton-loading", {
  "0%": {
    backgroundPosition: "100% 50%"
  },
  "100%": {
    backgroundPosition: "0 50%"
  }
}), J9 = (e) => ({
  height: e,
  lineHeight: Ye(e)
}), ax = (e) => Object.assign({
  width: e
}, J9(e)), Uhe = (e) => ({
  background: e.skeletonLoadingBackground,
  backgroundSize: "400% 100%",
  animationName: Bhe,
  animationDuration: e.skeletonLoadingMotionDuration,
  animationTimingFunction: "ease",
  animationIterationCount: "infinite"
}), nR = (e, t) => Object.assign({
  width: t(e).mul(5).equal(),
  minWidth: t(e).mul(5).equal()
}, J9(e)), Xhe = (e) => {
  const {
    skeletonAvatarCls: t,
    gradientFromColor: r,
    controlHeight: a,
    controlHeightLG: i,
    controlHeightSM: c
  } = e;
  return {
    [t]: Object.assign({
      display: "inline-block",
      verticalAlign: "top",
      background: r
    }, ax(a)),
    [`${t}${t}-circle`]: {
      borderRadius: "50%"
    },
    [`${t}${t}-lg`]: Object.assign({}, ax(i)),
    [`${t}${t}-sm`]: Object.assign({}, ax(c))
  };
}, Ghe = (e) => {
  const {
    controlHeight: t,
    borderRadiusSM: r,
    skeletonInputCls: a,
    controlHeightLG: i,
    controlHeightSM: c,
    gradientFromColor: d,
    calc: f
  } = e;
  return {
    [a]: Object.assign({
      display: "inline-block",
      verticalAlign: "top",
      background: d,
      borderRadius: r
    }, nR(t, f)),
    [`${a}-lg`]: Object.assign({}, nR(i, f)),
    [`${a}-sm`]: Object.assign({}, nR(c, f))
  };
}, hF = (e) => Object.assign({
  width: e
}, J9(e)), qhe = (e) => {
  const {
    skeletonImageCls: t,
    imageSizeBase: r,
    gradientFromColor: a,
    borderRadiusSM: i,
    calc: c
  } = e;
  return {
    [t]: Object.assign(Object.assign({
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      verticalAlign: "middle",
      background: a,
      borderRadius: i
    }, hF(c(r).mul(2).equal())), {
      [`${t}-path`]: {
        fill: "#bfbfbf"
      },
      [`${t}-svg`]: Object.assign(Object.assign({}, hF(r)), {
        maxWidth: c(r).mul(4).equal(),
        maxHeight: c(r).mul(4).equal()
      }),
      [`${t}-svg${t}-svg-circle`]: {
        borderRadius: "50%"
      }
    }),
    [`${t}${t}-circle`]: {
      borderRadius: "50%"
    }
  };
}, rR = (e, t, r) => {
  const {
    skeletonButtonCls: a
  } = e;
  return {
    [`${r}${a}-circle`]: {
      width: t,
      minWidth: t,
      borderRadius: "50%"
    },
    [`${r}${a}-round`]: {
      borderRadius: t
    }
  };
}, aR = (e, t) => Object.assign({
  width: t(e).mul(2).equal(),
  minWidth: t(e).mul(2).equal()
}, J9(e)), Khe = (e) => {
  const {
    borderRadiusSM: t,
    skeletonButtonCls: r,
    controlHeight: a,
    controlHeightLG: i,
    controlHeightSM: c,
    gradientFromColor: d,
    calc: f
  } = e;
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
    [r]: Object.assign({
      display: "inline-block",
      verticalAlign: "top",
      background: d,
      borderRadius: t,
      width: f(a).mul(2).equal(),
      minWidth: f(a).mul(2).equal()
    }, aR(a, f))
  }, rR(e, a, r)), {
    [`${r}-lg`]: Object.assign({}, aR(i, f))
  }), rR(e, i, `${r}-lg`)), {
    [`${r}-sm`]: Object.assign({}, aR(c, f))
  }), rR(e, c, `${r}-sm`));
}, Yhe = (e) => {
  const {
    componentCls: t,
    skeletonAvatarCls: r,
    skeletonTitleCls: a,
    skeletonParagraphCls: i,
    skeletonButtonCls: c,
    skeletonInputCls: d,
    skeletonImageCls: f,
    controlHeight: p,
    controlHeightLG: g,
    controlHeightSM: b,
    gradientFromColor: w,
    padding: x,
    marginSM: E,
    borderRadius: P,
    titleHeight: k,
    blockRadius: M,
    paragraphLiHeight: T,
    controlHeightXS: N,
    paragraphMarginTop: D
  } = e;
  return {
    [t]: {
      display: "table",
      width: "100%",
      [`${t}-header`]: {
        display: "table-cell",
        paddingInlineEnd: x,
        verticalAlign: "top",
        // Avatar
        [r]: Object.assign({
          display: "inline-block",
          verticalAlign: "top",
          background: w
        }, ax(p)),
        [`${r}-circle`]: {
          borderRadius: "50%"
        },
        [`${r}-lg`]: Object.assign({}, ax(g)),
        [`${r}-sm`]: Object.assign({}, ax(b))
      },
      [`${t}-content`]: {
        display: "table-cell",
        width: "100%",
        verticalAlign: "top",
        // Title
        [a]: {
          width: "100%",
          height: k,
          background: w,
          borderRadius: M,
          [`+ ${i}`]: {
            marginBlockStart: b
          }
        },
        // paragraph
        [i]: {
          padding: 0,
          "> li": {
            width: "100%",
            height: T,
            listStyle: "none",
            background: w,
            borderRadius: M,
            "+ li": {
              marginBlockStart: N
            }
          }
        },
        [`${i}> li:last-child:not(:first-child):not(:nth-child(2))`]: {
          width: "61%"
        }
      },
      [`&-round ${t}-content`]: {
        [`${a}, ${i} > li`]: {
          borderRadius: P
        }
      }
    },
    [`${t}-with-avatar ${t}-content`]: {
      // Title
      [a]: {
        marginBlockStart: E,
        [`+ ${i}`]: {
          marginBlockStart: D
        }
      }
    },
    // Skeleton element
    [`${t}${t}-element`]: Object.assign(Object.assign(Object.assign(Object.assign({
      display: "inline-block",
      width: "auto"
    }, Khe(e)), Xhe(e)), Ghe(e)), qhe(e)),
    // Skeleton Block Button, Input
    [`${t}${t}-block`]: {
      width: "100%",
      [c]: {
        width: "100%"
      },
      [d]: {
        width: "100%"
      }
    },
    // With active animation
    [`${t}${t}-active`]: {
      [`
        ${a},
        ${i} > li,
        ${r},
        ${c},
        ${d},
        ${f}
      `]: Object.assign({}, Uhe(e))
    }
  };
}, Qhe = (e) => {
  const {
    colorFillContent: t,
    colorFill: r
  } = e, a = t, i = r;
  return {
    color: a,
    colorGradientEnd: i,
    gradientFromColor: a,
    gradientToColor: i,
    titleHeight: e.controlHeight / 2,
    blockRadius: e.borderRadiusSM,
    paragraphMarginTop: e.marginLG + e.marginXXS,
    paragraphLiHeight: e.controlHeight / 2
  };
}, Xx = Ii("Skeleton", (e) => {
  const {
    componentCls: t,
    calc: r
  } = e, a = lo(e, {
    skeletonAvatarCls: `${t}-avatar`,
    skeletonTitleCls: `${t}-title`,
    skeletonParagraphCls: `${t}-paragraph`,
    skeletonButtonCls: `${t}-button`,
    skeletonInputCls: `${t}-input`,
    skeletonImageCls: `${t}-image`,
    imageSizeBase: r(e.controlHeight).mul(1.5).equal(),
    borderRadius: 100,
    // Large number to make capsule shape
    skeletonLoadingBackground: `linear-gradient(90deg, ${e.gradientFromColor} 25%, ${e.gradientToColor} 37%, ${e.gradientFromColor} 63%)`,
    skeletonLoadingMotionDuration: "1.4s"
  });
  return Yhe(a);
}, Qhe, {
  deprecatedTokens: [["color", "gradientFromColor"], ["colorGradientEnd", "gradientToColor"]]
}), Jhe = (e) => {
  const {
    prefixCls: t,
    className: r,
    rootClassName: a,
    active: i,
    shape: c = "circle",
    size: d = "default"
  } = e, {
    getPrefixCls: f
  } = S.useContext(Qr), p = f("skeleton", t), [g, b, w] = Xx(p), x = Rs(e, ["prefixCls", "className"]), E = _e(p, `${p}-element`, {
    [`${p}-active`]: i
  }, r, a, b, w);
  return g(/* @__PURE__ */ S.createElement("div", {
    className: E
  }, /* @__PURE__ */ S.createElement(Q9, Object.assign({
    prefixCls: `${p}-avatar`,
    shape: c,
    size: d
  }, x))));
}, Zhe = (e) => {
  const {
    prefixCls: t,
    className: r,
    rootClassName: a,
    active: i,
    block: c = !1,
    size: d = "default"
  } = e, {
    getPrefixCls: f
  } = S.useContext(Qr), p = f("skeleton", t), [g, b, w] = Xx(p), x = Rs(e, ["prefixCls"]), E = _e(p, `${p}-element`, {
    [`${p}-active`]: i,
    [`${p}-block`]: c
  }, r, a, b, w);
  return g(/* @__PURE__ */ S.createElement("div", {
    className: E
  }, /* @__PURE__ */ S.createElement(Q9, Object.assign({
    prefixCls: `${p}-button`,
    size: d
  }, x))));
}, epe = "M365.714286 329.142857q0 45.714286-32.036571 77.677714t-77.677714 32.036571-77.677714-32.036571-32.036571-77.677714 32.036571-77.677714 77.677714-32.036571 77.677714 32.036571 32.036571 77.677714zM950.857143 548.571429l0 256-804.571429 0 0-109.714286 182.857143-182.857143 91.428571 91.428571 292.571429-292.571429zM1005.714286 146.285714l-914.285714 0q-7.460571 0-12.873143 5.412571t-5.412571 12.873143l0 694.857143q0 7.460571 5.412571 12.873143t12.873143 5.412571l914.285714 0q7.460571 0 12.873143-5.412571t5.412571-12.873143l0-694.857143q0-7.460571-5.412571-12.873143t-12.873143-5.412571zM1097.142857 164.571429l0 694.857143q0 37.741714-26.843429 64.585143t-64.585143 26.843429l-914.285714 0q-37.741714 0-64.585143-26.843429t-26.843429-64.585143l0-694.857143q0-37.741714 26.843429-64.585143t64.585143-26.843429l914.285714 0q37.741714 0 64.585143 26.843429t26.843429 64.585143z", tpe = (e) => {
  const {
    prefixCls: t,
    className: r,
    rootClassName: a,
    style: i,
    active: c
  } = e, {
    getPrefixCls: d
  } = S.useContext(Qr), f = d("skeleton", t), [p, g, b] = Xx(f), w = _e(f, `${f}-element`, {
    [`${f}-active`]: c
  }, r, a, g, b);
  return p(/* @__PURE__ */ S.createElement("div", {
    className: w
  }, /* @__PURE__ */ S.createElement("div", {
    className: _e(`${f}-image`, r),
    style: i
  }, /* @__PURE__ */ S.createElement("svg", {
    viewBox: "0 0 1098 1024",
    xmlns: "http://www.w3.org/2000/svg",
    className: `${f}-image-svg`
  }, /* @__PURE__ */ S.createElement("title", null, "Image placeholder"), /* @__PURE__ */ S.createElement("path", {
    d: epe,
    className: `${f}-image-path`
  })))));
}, npe = (e) => {
  const {
    prefixCls: t,
    className: r,
    rootClassName: a,
    active: i,
    block: c,
    size: d = "default"
  } = e, {
    getPrefixCls: f
  } = S.useContext(Qr), p = f("skeleton", t), [g, b, w] = Xx(p), x = Rs(e, ["prefixCls"]), E = _e(p, `${p}-element`, {
    [`${p}-active`]: i,
    [`${p}-block`]: c
  }, r, a, b, w);
  return g(/* @__PURE__ */ S.createElement("div", {
    className: E
  }, /* @__PURE__ */ S.createElement(Q9, Object.assign({
    prefixCls: `${p}-input`,
    size: d
  }, x))));
}, rpe = (e) => {
  const {
    prefixCls: t,
    className: r,
    rootClassName: a,
    style: i,
    active: c,
    children: d
  } = e, {
    getPrefixCls: f
  } = S.useContext(Qr), p = f("skeleton", t), [g, b, w] = Xx(p), x = _e(p, `${p}-element`, {
    [`${p}-active`]: c
  }, b, r, a, w);
  return g(/* @__PURE__ */ S.createElement("div", {
    className: x
  }, /* @__PURE__ */ S.createElement("div", {
    className: _e(`${p}-image`, r),
    style: i
  }, d)));
}, ape = (e, t) => {
  const {
    width: r,
    rows: a = 2
  } = t;
  if (Array.isArray(r))
    return r[e];
  if (a - 1 === e)
    return r;
}, ope = (e) => {
  const {
    prefixCls: t,
    className: r,
    style: a,
    rows: i = 0
  } = e, c = Array.from({
    length: i
  }).map((d, f) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ S.createElement("li", {
      key: f,
      style: {
        width: ape(f, e)
      }
    })
  ));
  return /* @__PURE__ */ S.createElement("ul", {
    className: _e(t, r),
    style: a
  }, c);
}, ipe = ({
  prefixCls: e,
  className: t,
  width: r,
  style: a
}) => (
  // biome-ignore lint/a11y/useHeadingContent: HOC here
  /* @__PURE__ */ S.createElement("h3", {
    className: _e(e, t),
    style: Object.assign({
      width: r
    }, a)
  })
);
function oR(e) {
  return e && typeof e == "object" ? e : {};
}
function lpe(e, t) {
  return e && !t ? {
    size: "large",
    shape: "square"
  } : {
    size: "large",
    shape: "circle"
  };
}
function spe(e, t) {
  return !e && t ? {
    width: "38%"
  } : e && t ? {
    width: "50%"
  } : {};
}
function upe(e, t) {
  const r = {};
  return (!e || !t) && (r.width = "61%"), !e && t ? r.rows = 3 : r.rows = 2, r;
}
const rC = (e) => {
  const {
    prefixCls: t,
    loading: r,
    className: a,
    rootClassName: i,
    style: c,
    children: d,
    avatar: f = !1,
    title: p = !0,
    paragraph: g = !0,
    active: b,
    round: w
  } = e, {
    getPrefixCls: x,
    direction: E,
    className: P,
    style: k
  } = om("skeleton"), M = x("skeleton", t), [T, N, D] = Xx(M);
  if (r || !("loading" in e)) {
    const $ = !!f, j = !!p, I = !!g;
    let L;
    if ($) {
      const W = Object.assign(Object.assign({
        prefixCls: `${M}-avatar`
      }, lpe(j, I)), oR(f));
      L = /* @__PURE__ */ S.createElement("div", {
        className: `${M}-header`
      }, /* @__PURE__ */ S.createElement(Q9, Object.assign({}, W)));
    }
    let F;
    if (j || I) {
      let W;
      if (j) {
        const U = Object.assign(Object.assign({
          prefixCls: `${M}-title`
        }, spe($, I)), oR(p));
        W = /* @__PURE__ */ S.createElement(ipe, Object.assign({}, U));
      }
      let Q;
      if (I) {
        const U = Object.assign(Object.assign({
          prefixCls: `${M}-paragraph`
        }, upe($, j)), oR(g));
        Q = /* @__PURE__ */ S.createElement(ope, Object.assign({}, U));
      }
      F = /* @__PURE__ */ S.createElement("div", {
        className: `${M}-content`
      }, W, Q);
    }
    const _ = _e(M, {
      [`${M}-with-avatar`]: $,
      [`${M}-active`]: b,
      [`${M}-rtl`]: E === "rtl",
      [`${M}-round`]: w
    }, P, a, i, N, D);
    return T(/* @__PURE__ */ S.createElement("div", {
      className: _,
      style: Object.assign(Object.assign({}, k), c)
    }, L, F));
  }
  return d ?? null;
};
rC.Button = Zhe;
rC.Avatar = Jhe;
rC.Input = npe;
rC.Image = tpe;
rC.Node = rpe;
process.env.NODE_ENV !== "production" && (rC.displayName = "Skeleton");
function pF() {
}
const cpe = /* @__PURE__ */ S.createContext({
  add: pF,
  remove: pF
});
function OK(e) {
  const t = S.useContext(cpe), r = S.useRef(null);
  return ra((i) => {
    if (i) {
      const c = e ? i.querySelector(e) : i;
      c && (t.add(c), r.current = c);
    } else
      t.remove(r.current);
  });
}
const gF = () => {
  const {
    cancelButtonProps: e,
    cancelTextLocale: t,
    onCancel: r
  } = Do(GE);
  return /* @__PURE__ */ Re.createElement(cp, Object.assign({
    onClick: r
  }, e), t);
}, vF = () => {
  const {
    confirmLoading: e,
    okButtonProps: t,
    okType: r,
    okTextLocale: a,
    onOk: i
  } = Do(GE);
  return /* @__PURE__ */ Re.createElement(cp, Object.assign({}, tK(r), {
    loading: e,
    onClick: i
  }, t), a);
};
function TK(e, t) {
  return /* @__PURE__ */ Re.createElement("span", {
    className: `${e}-close-x`
  }, t || /* @__PURE__ */ Re.createElement(Bx, {
    className: `${e}-close-icon`
  }));
}
const RK = (e) => {
  const {
    okText: t,
    okType: r = "primary",
    cancelText: a,
    confirmLoading: i,
    onOk: c,
    onCancel: d,
    okButtonProps: f,
    cancelButtonProps: p,
    footer: g
  } = e, [b] = q1("Modal", fq()), w = t || b?.okText, x = a || b?.cancelText, E = Re.useMemo(() => ({
    confirmLoading: i,
    okButtonProps: f,
    cancelButtonProps: p,
    okTextLocale: w,
    cancelTextLocale: x,
    okType: r,
    onOk: c,
    onCancel: d
  }), [i, f, p, w, x, r, c, d]);
  let P;
  return typeof g == "function" || typeof g > "u" ? (P = /* @__PURE__ */ Re.createElement(Re.Fragment, null, /* @__PURE__ */ Re.createElement(gF, null), /* @__PURE__ */ Re.createElement(vF, null)), typeof g == "function" && (P = g(P, {
    OkBtn: vF,
    CancelBtn: gF
  })), P = /* @__PURE__ */ Re.createElement(hK, {
    value: E
  }, P)) : P = g, /* @__PURE__ */ Re.createElement(wq, {
    disabled: !1
  }, P);
}, dpe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    // Grid system
    [t]: {
      display: "flex",
      flexFlow: "row wrap",
      minWidth: 0,
      "&::before, &::after": {
        display: "flex"
      },
      "&-no-wrap": {
        flexWrap: "nowrap"
      },
      // The origin of the X-axis
      "&-start": {
        justifyContent: "flex-start"
      },
      // The center of the X-axis
      "&-center": {
        justifyContent: "center"
      },
      // The opposite of the X-axis
      "&-end": {
        justifyContent: "flex-end"
      },
      "&-space-between": {
        justifyContent: "space-between"
      },
      "&-space-around": {
        justifyContent: "space-around"
      },
      "&-space-evenly": {
        justifyContent: "space-evenly"
      },
      // Align at the top
      "&-top": {
        alignItems: "flex-start"
      },
      // Align at the center
      "&-middle": {
        alignItems: "center"
      },
      "&-bottom": {
        alignItems: "flex-end"
      }
    }
  };
}, fpe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    // Grid system
    [t]: {
      position: "relative",
      maxWidth: "100%",
      // Prevent columns from collapsing when empty
      minHeight: 1
    }
  };
}, mpe = (e, t) => {
  const {
    prefixCls: r,
    componentCls: a,
    gridColumns: i
  } = e, c = {};
  for (let d = i; d >= 0; d--)
    d === 0 ? (c[`${a}${t}-${d}`] = {
      display: "none"
    }, c[`${a}-push-${d}`] = {
      insetInlineStart: "auto"
    }, c[`${a}-pull-${d}`] = {
      insetInlineEnd: "auto"
    }, c[`${a}${t}-push-${d}`] = {
      insetInlineStart: "auto"
    }, c[`${a}${t}-pull-${d}`] = {
      insetInlineEnd: "auto"
    }, c[`${a}${t}-offset-${d}`] = {
      marginInlineStart: 0
    }, c[`${a}${t}-order-${d}`] = {
      order: 0
    }) : (c[`${a}${t}-${d}`] = [
      // https://github.com/ant-design/ant-design/issues/44456
      // Form set `display: flex` on Col which will override `display: block`.
      // Let's get it from css variable to support override.
      {
        "--ant-display": "block",
        // Fallback to display if variable not support
        display: "block"
      },
      {
        display: "var(--ant-display)",
        flex: `0 0 ${d / i * 100}%`,
        maxWidth: `${d / i * 100}%`
      }
    ], c[`${a}${t}-push-${d}`] = {
      insetInlineStart: `${d / i * 100}%`
    }, c[`${a}${t}-pull-${d}`] = {
      insetInlineEnd: `${d / i * 100}%`
    }, c[`${a}${t}-offset-${d}`] = {
      marginInlineStart: `${d / i * 100}%`
    }, c[`${a}${t}-order-${d}`] = {
      order: d
    });
  return c[`${a}${t}-flex`] = {
    flex: `var(--${r}${t}-flex)`
  }, c;
}, kD = (e, t) => mpe(e, t), hpe = (e, t, r) => ({
  [`@media (min-width: ${Ye(t)})`]: Object.assign({}, kD(e, r))
}), ppe = () => ({}), gpe = () => ({});
Ii("Grid", dpe, ppe);
const AK = (e) => ({
  xs: e.screenXSMin,
  sm: e.screenSMMin,
  md: e.screenMDMin,
  lg: e.screenLGMin,
  xl: e.screenXLMin,
  xxl: e.screenXXLMin
});
Ii("Grid", (e) => {
  const t = lo(e, {
    gridColumns: 24
    // Row is divided into 24 parts in Grid
  }), r = AK(t);
  return delete r.xs, [fpe(t), kD(t, ""), kD(t, "-xs"), Object.keys(r).map((a) => hpe(t, r[a], `-${a}`)).reduce((a, i) => Object.assign(Object.assign({}, a), i), {})];
}, gpe);
function bF(e) {
  return {
    position: e,
    inset: 0
  };
}
const vpe = (e) => {
  const {
    componentCls: t,
    antCls: r
  } = e;
  return [{
    [`${t}-root`]: {
      [`${t}${r}-zoom-enter, ${t}${r}-zoom-appear`]: {
        // reset scale avoid mousePosition bug
        transform: "none",
        opacity: 0,
        animationDuration: e.motionDurationSlow,
        // https://github.com/ant-design/ant-design/issues/11777
        userSelect: "none"
      },
      // https://github.com/ant-design/ant-design/issues/37329
      // https://github.com/ant-design/ant-design/issues/40272
      [`${t}${r}-zoom-leave ${t}-content`]: {
        pointerEvents: "none"
      },
      [`${t}-mask`]: Object.assign(Object.assign({}, bF("fixed")), {
        zIndex: e.zIndexPopupBase,
        height: "100%",
        backgroundColor: e.colorBgMask,
        pointerEvents: "none",
        [`${t}-hidden`]: {
          display: "none"
        }
      }),
      [`${t}-wrap`]: Object.assign(Object.assign({}, bF("fixed")), {
        zIndex: e.zIndexPopupBase,
        overflow: "auto",
        outline: 0,
        WebkitOverflowScrolling: "touch"
      })
    }
  }, {
    [`${t}-root`]: uK(e)
  }];
}, bpe = (e) => {
  const {
    componentCls: t
  } = e;
  return [
    // ======================== Root =========================
    {
      [`${t}-root`]: {
        [`${t}-wrap-rtl`]: {
          direction: "rtl"
        },
        [`${t}-centered`]: {
          textAlign: "center",
          "&::before": {
            display: "inline-block",
            width: 0,
            height: "100%",
            verticalAlign: "middle",
            content: '""'
          },
          [t]: {
            top: 0,
            display: "inline-block",
            paddingBottom: 0,
            textAlign: "start",
            verticalAlign: "middle"
          }
        },
        [`@media (max-width: ${e.screenSMMax}px)`]: {
          [t]: {
            maxWidth: "calc(100vw - 16px)",
            margin: `${Ye(e.marginXS)} auto`
          },
          [`${t}-centered`]: {
            [t]: {
              flex: 1
            }
          }
        }
      }
    },
    // ======================== Modal ========================
    {
      [t]: Object.assign(Object.assign({}, dl(e)), {
        pointerEvents: "none",
        position: "relative",
        top: 100,
        width: "auto",
        maxWidth: `calc(100vw - ${Ye(e.calc(e.margin).mul(2).equal())})`,
        margin: "0 auto",
        paddingBottom: e.paddingLG,
        [`${t}-title`]: {
          margin: 0,
          color: e.titleColor,
          fontWeight: e.fontWeightStrong,
          fontSize: e.titleFontSize,
          lineHeight: e.titleLineHeight,
          wordWrap: "break-word"
        },
        [`${t}-content`]: {
          position: "relative",
          backgroundColor: e.contentBg,
          backgroundClip: "padding-box",
          border: 0,
          borderRadius: e.borderRadiusLG,
          boxShadow: e.boxShadow,
          pointerEvents: "auto",
          padding: e.contentPadding
        },
        [`${t}-close`]: Object.assign({
          position: "absolute",
          top: e.calc(e.modalHeaderHeight).sub(e.modalCloseBtnSize).div(2).equal(),
          insetInlineEnd: e.calc(e.modalHeaderHeight).sub(e.modalCloseBtnSize).div(2).equal(),
          zIndex: e.calc(e.zIndexPopupBase).add(10).equal(),
          padding: 0,
          color: e.modalCloseIconColor,
          fontWeight: e.fontWeightStrong,
          lineHeight: 1,
          textDecoration: "none",
          background: "transparent",
          borderRadius: e.borderRadiusSM,
          width: e.modalCloseBtnSize,
          height: e.modalCloseBtnSize,
          border: 0,
          outline: 0,
          cursor: "pointer",
          transition: `color ${e.motionDurationMid}, background-color ${e.motionDurationMid}`,
          "&-x": {
            display: "flex",
            fontSize: e.fontSizeLG,
            fontStyle: "normal",
            lineHeight: Ye(e.modalCloseBtnSize),
            justifyContent: "center",
            textTransform: "none",
            textRendering: "auto"
          },
          "&:disabled": {
            pointerEvents: "none"
          },
          "&:hover": {
            color: e.modalCloseIconHoverColor,
            backgroundColor: e.colorBgTextHover,
            textDecoration: "none"
          },
          "&:active": {
            backgroundColor: e.colorBgTextActive
          }
        }, Z4(e)),
        [`${t}-header`]: {
          color: e.colorText,
          background: e.headerBg,
          borderRadius: `${Ye(e.borderRadiusLG)} ${Ye(e.borderRadiusLG)} 0 0`,
          marginBottom: e.headerMarginBottom,
          padding: e.headerPadding,
          borderBottom: e.headerBorderBottom
        },
        [`${t}-body`]: {
          fontSize: e.fontSize,
          lineHeight: e.lineHeight,
          wordWrap: "break-word",
          padding: e.bodyPadding,
          [`${t}-body-skeleton`]: {
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: `${Ye(e.margin)} auto`
          }
        },
        [`${t}-footer`]: {
          textAlign: "end",
          background: e.footerBg,
          marginTop: e.footerMarginTop,
          padding: e.footerPadding,
          borderTop: e.footerBorderTop,
          borderRadius: e.footerBorderRadius,
          [`> ${e.antCls}-btn + ${e.antCls}-btn`]: {
            marginInlineStart: e.marginXS
          }
        },
        [`${t}-open`]: {
          overflow: "hidden"
        }
      })
    },
    // ======================== Pure =========================
    {
      [`${t}-pure-panel`]: {
        top: "auto",
        padding: 0,
        display: "flex",
        flexDirection: "column",
        [`${t}-content,
          ${t}-body,
          ${t}-confirm-body-wrapper`]: {
          display: "flex",
          flexDirection: "column",
          flex: "auto"
        },
        [`${t}-confirm-body`]: {
          marginBottom: "auto"
        }
      }
    }
  ];
}, ype = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-root`]: {
      [`${t}-wrap-rtl`]: {
        direction: "rtl",
        [`${t}-confirm-body`]: {
          direction: "rtl"
        }
      }
    }
  };
}, wpe = (e) => {
  const {
    componentCls: t
  } = e, r = AK(e), a = Object.assign({}, r);
  delete a.xs;
  const i = `--${t.replace(".", "")}-`, c = Object.keys(a).map((d) => ({
    [`@media (min-width: ${Ye(a[d])})`]: {
      width: `var(${i}${d}-width)`
    }
  }));
  return {
    [`${t}-root`]: {
      [t]: [].concat(Et(Object.keys(r).map((d, f) => {
        const p = Object.keys(r)[f - 1];
        return p ? {
          [`${i}${d}-width`]: `var(${i}${p}-width)`
        } : null;
      })), [{
        width: `var(${i}xs-width)`
      }], Et(c))
    }
  };
}, NK = (e) => {
  const t = e.padding, r = e.fontSizeHeading5, a = e.lineHeightHeading5;
  return lo(e, {
    modalHeaderHeight: e.calc(e.calc(a).mul(r).equal()).add(e.calc(t).mul(2).equal()).equal(),
    modalFooterBorderColorSplit: e.colorSplit,
    modalFooterBorderStyle: e.lineType,
    modalFooterBorderWidth: e.lineWidth,
    modalCloseIconColor: e.colorIcon,
    modalCloseIconHoverColor: e.colorIconHover,
    modalCloseBtnSize: e.controlHeight,
    modalConfirmIconSize: e.fontHeight,
    modalTitleHeight: e.calc(e.titleFontSize).mul(e.titleLineHeight).equal()
  });
}, DK = (e) => ({
  footerBg: "transparent",
  headerBg: e.colorBgElevated,
  titleLineHeight: e.lineHeightHeading5,
  titleFontSize: e.fontSizeHeading5,
  contentBg: e.colorBgElevated,
  titleColor: e.colorTextHeading,
  // internal
  contentPadding: e.wireframe ? 0 : `${Ye(e.paddingMD)} ${Ye(e.paddingContentHorizontalLG)}`,
  headerPadding: e.wireframe ? `${Ye(e.padding)} ${Ye(e.paddingLG)}` : 0,
  headerBorderBottom: e.wireframe ? `${Ye(e.lineWidth)} ${e.lineType} ${e.colorSplit}` : "none",
  headerMarginBottom: e.wireframe ? 0 : e.marginXS,
  bodyPadding: e.wireframe ? e.paddingLG : 0,
  footerPadding: e.wireframe ? `${Ye(e.paddingXS)} ${Ye(e.padding)}` : 0,
  footerBorderTop: e.wireframe ? `${Ye(e.lineWidth)} ${e.lineType} ${e.colorSplit}` : "none",
  footerBorderRadius: e.wireframe ? `0 0 ${Ye(e.borderRadiusLG)} ${Ye(e.borderRadiusLG)}` : 0,
  footerMarginTop: e.wireframe ? 0 : e.marginSM,
  confirmBodyPadding: e.wireframe ? `${Ye(e.padding * 2)} ${Ye(e.padding * 2)} ${Ye(e.paddingLG)}` : 0,
  confirmIconMarginInlineEnd: e.wireframe ? e.margin : e.marginSM,
  confirmBtnsMarginTop: e.wireframe ? e.marginLG : e.marginSM
}), $K = Ii("Modal", (e) => {
  const t = NK(e);
  return [bpe(t), ype(t), vpe(t), UE(t, "zoom"), wpe(t)];
}, DK, {
  unitless: {
    titleLineHeight: !0
  }
});
var Spe = function(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
    t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
};
let MD;
const Cpe = (e) => {
  MD = {
    x: e.pageX,
    y: e.pageY
  }, setTimeout(() => {
    MD = null;
  }, 100);
};
_he() && document.documentElement.addEventListener("click", Cpe, !0);
const zK = (e) => {
  const {
    prefixCls: t,
    className: r,
    rootClassName: a,
    open: i,
    wrapClassName: c,
    centered: d,
    getContainer: f,
    focusTriggerAfterClose: p = !0,
    style: g,
    // Deprecated
    visible: b,
    width: w = 520,
    footer: x,
    classNames: E,
    styles: P,
    children: k,
    loading: M,
    confirmLoading: T,
    zIndex: N,
    mousePosition: D,
    onOk: $,
    onCancel: j,
    destroyOnHidden: I,
    destroyOnClose: L,
    panelRef: F = null,
    modalRender: _
  } = e, W = Spe(e, ["prefixCls", "className", "rootClassName", "open", "wrapClassName", "centered", "getContainer", "focusTriggerAfterClose", "style", "visible", "width", "footer", "classNames", "styles", "children", "loading", "confirmLoading", "zIndex", "mousePosition", "onOk", "onCancel", "destroyOnHidden", "destroyOnClose", "panelRef", "modalRender"]), {
    getPopupContainer: Q,
    getPrefixCls: U,
    direction: Y,
    modal: G
  } = S.useContext(Qr), J = (Le) => {
    T || j?.(Le);
  }, H = (Le) => {
    $?.(Le);
  };
  if (process.env.NODE_ENV !== "production") {
    const Le = To("Modal");
    [["visible", "open"], ["bodyStyle", "styles.body"], ["maskStyle", "styles.mask"], ["destroyOnClose", "destroyOnHidden"]].forEach(([Te, Oe]) => {
      Le.deprecated(!(Te in e), Te, Oe);
    });
  }
  const K = U("modal", t), X = U(), te = Qh(K), [ie, ee, ne] = $K(K, te), ae = _e(c, {
    [`${K}-centered`]: d ?? G?.centered,
    [`${K}-wrap-rtl`]: Y === "rtl"
  }), oe = x !== null && !M ? /* @__PURE__ */ S.createElement(RK, Object.assign({}, e, {
    onOk: H,
    onCancel: J
  })) : null, [fe, be, me, De] = Gq(Wk(e), Wk(G), {
    closable: !0,
    closeIcon: /* @__PURE__ */ S.createElement(Bx, {
      className: `${K}-close-icon`
    }),
    closeIconRender: (Le) => TK(K, Le)
  }), Me = _ ? (Le) => /* @__PURE__ */ S.createElement("div", {
    className: `${K}-render`
  }, _(Le)) : void 0, ze = `.${K}-${_ ? "render" : "content"}`, le = OK(ze), se = mp(F, le), [Ae, we] = vS("Modal", N), [Ne, pe] = S.useMemo(() => w && typeof w == "object" ? [void 0, w] : [w, void 0], [w]), Qe = S.useMemo(() => {
    const Le = {};
    return pe && Object.keys(pe).forEach((Te) => {
      const Oe = pe[Te];
      Oe !== void 0 && (Le[`--${K}-${Te}-width`] = typeof Oe == "number" ? `${Oe}px` : Oe);
    }), Le;
  }, [K, pe]);
  return ie(/* @__PURE__ */ S.createElement(dS, {
    form: !0,
    space: !0
  }, /* @__PURE__ */ S.createElement(Ux.Provider, {
    value: we
  }, /* @__PURE__ */ S.createElement(yK, Object.assign({
    width: Ne
  }, W, {
    zIndex: Ae,
    getContainer: f === void 0 ? Q : f,
    prefixCls: K,
    rootClassName: _e(ee, a, ne, te),
    footer: oe,
    visible: i ?? b,
    mousePosition: D ?? MD,
    onClose: J,
    closable: fe && Object.assign({
      disabled: me,
      closeIcon: be
    }, De),
    closeIcon: be,
    focusTriggerAfterClose: p,
    transitionName: uS(X, "zoom", e.transitionName),
    maskTransitionName: uS(X, "fade", e.maskTransitionName),
    className: _e(ee, r, G?.className),
    style: Object.assign(Object.assign(Object.assign({}, G?.style), g), Qe),
    classNames: Object.assign(Object.assign(Object.assign({}, G?.classNames), E), {
      wrapper: _e(ae, E?.wrapper)
    }),
    styles: Object.assign(Object.assign({}, G?.styles), P),
    panelRef: se,
    // TODO: In the future, destroyOnClose in rc-dialog needs to be upgrade to destroyOnHidden
    destroyOnClose: I ?? L,
    modalRender: Me
  }), M ? /* @__PURE__ */ S.createElement(rC, {
    active: !0,
    title: !1,
    paragraph: {
      rows: 4
    },
    className: `${K}-body-skeleton`
  }) : k))));
}, xpe = (e) => {
  const {
    componentCls: t,
    titleFontSize: r,
    titleLineHeight: a,
    modalConfirmIconSize: i,
    fontSize: c,
    lineHeight: d,
    modalTitleHeight: f,
    fontHeight: p,
    confirmBodyPadding: g
  } = e, b = `${t}-confirm`;
  return {
    [b]: {
      "&-rtl": {
        direction: "rtl"
      },
      [`${e.antCls}-modal-header`]: {
        display: "none"
      },
      [`${b}-body-wrapper`]: Object.assign({}, J4()),
      [`&${t} ${t}-body`]: {
        padding: g
      },
      // ====================== Body ======================
      [`${b}-body`]: {
        display: "flex",
        flexWrap: "nowrap",
        alignItems: "start",
        [`> ${e.iconCls}`]: {
          flex: "none",
          fontSize: i,
          marginInlineEnd: e.confirmIconMarginInlineEnd,
          marginTop: e.calc(e.calc(p).sub(i).equal()).div(2).equal()
        },
        [`&-has-title > ${e.iconCls}`]: {
          marginTop: e.calc(e.calc(f).sub(i).equal()).div(2).equal()
        }
      },
      [`${b}-paragraph`]: {
        display: "flex",
        flexDirection: "column",
        flex: "auto",
        rowGap: e.marginXS,
        // https://github.com/ant-design/ant-design/issues/51912
        maxWidth: `calc(100% - ${Ye(e.marginSM)})`
      },
      // https://github.com/ant-design/ant-design/issues/48159
      [`${e.iconCls} + ${b}-paragraph`]: {
        maxWidth: `calc(100% - ${Ye(e.calc(e.modalConfirmIconSize).add(e.marginSM).equal())})`
      },
      [`${b}-title`]: {
        color: e.colorTextHeading,
        fontWeight: e.fontWeightStrong,
        fontSize: r,
        lineHeight: a
      },
      [`${b}-content`]: {
        color: e.colorText,
        fontSize: c,
        lineHeight: d
      },
      // ===================== Footer =====================
      [`${b}-btns`]: {
        textAlign: "end",
        marginTop: e.confirmBtnsMarginTop,
        [`${e.antCls}-btn + ${e.antCls}-btn`]: {
          marginBottom: 0,
          marginInlineStart: e.marginXS
        }
      }
    },
    [`${b}-error ${b}-body > ${e.iconCls}`]: {
      color: e.colorError
    },
    [`${b}-warning ${b}-body > ${e.iconCls},
        ${b}-confirm ${b}-body > ${e.iconCls}`]: {
      color: e.colorWarning
    },
    [`${b}-info ${b}-body > ${e.iconCls}`]: {
      color: e.colorInfo
    },
    [`${b}-success ${b}-body > ${e.iconCls}`]: {
      color: e.colorSuccess
    }
  };
}, Epe = $z(["Modal", "confirm"], (e) => {
  const t = NK(e);
  return xpe(t);
}, DK, {
  // confirm is weak than modal since no conflict here
  order: -1e3
});
var Ppe = function(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
    t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
};
const jK = (e) => {
  const {
    prefixCls: t,
    icon: r,
    okText: a,
    cancelText: i,
    confirmPrefixCls: c,
    type: d,
    okCancel: f,
    footer: p,
    // Legacy for static function usage
    locale: g
  } = e, b = Ppe(e, ["prefixCls", "icon", "okText", "cancelText", "confirmPrefixCls", "type", "okCancel", "footer", "locale"]);
  if (process.env.NODE_ENV !== "production") {
    const I = To("Modal");
    process.env.NODE_ENV !== "production" && I(!(typeof r == "string" && r.length > 2), "breaking", `\`icon\` is using ReactNode instead of string naming in v4. Please check \`${r}\` at https://ant.design/components/icon`);
  }
  let w = r;
  if (!r && r !== null)
    switch (d) {
      case "info":
        w = /* @__PURE__ */ S.createElement(Iz, null);
        break;
      case "success":
        w = /* @__PURE__ */ S.createElement(z9, null);
        break;
      case "error":
        w = /* @__PURE__ */ S.createElement(_x, null);
        break;
      default:
        w = /* @__PURE__ */ S.createElement(jz, null);
    }
  const x = f ?? d === "confirm", E = e.autoFocusButton === null ? !1 : e.autoFocusButton || "ok", [P] = q1("Modal"), k = g || P, M = a || (x ? k?.okText : k?.justOkText), T = i || k?.cancelText, N = S.useMemo(() => Object.assign({
    autoFocusButton: E,
    cancelTextLocale: T,
    okTextLocale: M,
    mergedOkCancel: x
  }, b), [E, T, M, x, b]), D = /* @__PURE__ */ S.createElement(S.Fragment, null, /* @__PURE__ */ S.createElement(KH, null), /* @__PURE__ */ S.createElement(YH, null)), $ = e.title !== void 0 && e.title !== null, j = `${c}-body`;
  return /* @__PURE__ */ S.createElement("div", {
    className: `${c}-body-wrapper`
  }, /* @__PURE__ */ S.createElement("div", {
    className: _e(j, {
      [`${j}-has-title`]: $
    })
  }, w, /* @__PURE__ */ S.createElement("div", {
    className: `${c}-paragraph`
  }, $ && /* @__PURE__ */ S.createElement("span", {
    className: `${c}-title`
  }, e.title), /* @__PURE__ */ S.createElement("div", {
    className: `${c}-content`
  }, e.content))), p === void 0 || typeof p == "function" ? /* @__PURE__ */ S.createElement(hK, {
    value: N
  }, /* @__PURE__ */ S.createElement("div", {
    className: `${c}-btns`
  }, typeof p == "function" ? p(D, {
    OkBtn: YH,
    CancelBtn: KH
  }) : D)) : p, /* @__PURE__ */ S.createElement(Epe, {
    prefixCls: t
  }));
}, IK = (e) => {
  const {
    close: t,
    zIndex: r,
    maskStyle: a,
    direction: i,
    prefixCls: c,
    wrapClassName: d,
    rootPrefixCls: f,
    bodyStyle: p,
    closable: g = !1,
    onConfirm: b,
    styles: w,
    title: x
  } = e;
  if (process.env.NODE_ENV !== "production") {
    const j = To("Modal");
    [["visible", "open"], ["bodyStyle", "styles.body"], ["maskStyle", "styles.mask"]].forEach(([I, L]) => {
      j.deprecated(!(I in e), I, L);
    });
  }
  const E = `${c}-confirm`, P = e.width || 416, k = e.style || {}, M = e.mask === void 0 ? !0 : e.mask, T = e.maskClosable === void 0 ? !1 : e.maskClosable, N = _e(E, `${E}-${e.type}`, {
    [`${E}-rtl`]: i === "rtl"
  }, e.className), [, D] = Bf(), $ = S.useMemo(() => r !== void 0 ? r : D.zIndexPopupBase + Kq, [r, D]);
  return /* @__PURE__ */ S.createElement(zK, Object.assign({}, e, {
    className: N,
    wrapClassName: _e({
      [`${E}-centered`]: !!e.centered
    }, d),
    onCancel: () => {
      t?.({
        triggerCancel: !0
      }), b?.(!1);
    },
    title: x,
    footer: null,
    transitionName: uS(f || "", "zoom", e.transitionName),
    maskTransitionName: uS(f || "", "fade", e.maskTransitionName),
    mask: M,
    maskClosable: T,
    style: k,
    styles: Object.assign({
      body: p,
      mask: a
    }, w),
    width: P,
    zIndex: $,
    closable: g
  }), /* @__PURE__ */ S.createElement(jK, Object.assign({}, e, {
    confirmPrefixCls: E
  })));
}, Xz = (e) => {
  const {
    rootPrefixCls: t,
    iconPrefixCls: r,
    direction: a,
    theme: i
  } = e;
  return /* @__PURE__ */ S.createElement(tc, {
    prefixCls: t,
    iconPrefixCls: r,
    direction: a,
    theme: i
  }, /* @__PURE__ */ S.createElement(IK, Object.assign({}, e)));
};
process.env.NODE_ENV !== "production" && (IK.displayName = "ConfirmDialog", Xz.displayName = "ConfirmDialogWrapper");
const B4 = [];
let LK = "";
function HK() {
  return LK;
}
const kpe = (e) => {
  var t, r;
  const {
    prefixCls: a,
    getContainer: i,
    direction: c
  } = e, d = fq(), f = Do(Qr), p = HK() || f.getPrefixCls(), g = a || `${p}-modal`;
  let b = i;
  return b === !1 && (b = void 0, process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && nC(!1, "Modal", "Static method not support `getContainer` to be `false` since it do not have context env.")), /* @__PURE__ */ Re.createElement(Xz, Object.assign({}, e, {
    rootPrefixCls: p,
    prefixCls: g,
    iconPrefixCls: f.iconPrefixCls,
    theme: f.theme,
    direction: c ?? f.direction,
    locale: (r = (t = f.locale) === null || t === void 0 ? void 0 : t.Modal) !== null && r !== void 0 ? r : d,
    getContainer: b
  }));
};
function JE(e) {
  const t = Fce();
  process.env.NODE_ENV !== "production" && !t.holderRender && zce("Modal");
  const r = document.createDocumentFragment();
  let a = Object.assign(Object.assign({}, e), {
    close: p,
    open: !0
  }), i, c;
  function d(...b) {
    var w;
    if (b.some((P) => P?.triggerCancel)) {
      var E;
      (w = e.onCancel) === null || w === void 0 || (E = w).call.apply(E, [e, () => {
      }].concat(Et(b.slice(1))));
    }
    for (let P = 0; P < B4.length; P++)
      if (B4[P] === p) {
        B4.splice(P, 1);
        break;
      }
    c();
  }
  const f = (b) => {
    clearTimeout(i), i = setTimeout(() => {
      const w = t.getPrefixCls(void 0, HK()), x = t.getIconPrefixCls(), E = t.getTheme(), P = /* @__PURE__ */ Re.createElement(kpe, Object.assign({}, b));
      c = Fz()(/* @__PURE__ */ Re.createElement(tc, {
        prefixCls: w,
        iconPrefixCls: x,
        theme: E
      }, typeof t.holderRender == "function" ? t.holderRender(P) : P), r);
    });
  };
  function p(...b) {
    a = Object.assign(Object.assign({}, a), {
      open: !1,
      afterClose: () => {
        typeof e.afterClose == "function" && e.afterClose(), d.apply(this, b);
      }
    }), a.visible && delete a.visible, f(a);
  }
  function g(b) {
    typeof b == "function" ? a = b(a) : a = Object.assign(Object.assign({}, a), b), f(a);
  }
  return f(a), B4.push(p), {
    destroy: p,
    update: g
  };
}
function FK(e) {
  return Object.assign(Object.assign({}, e), {
    type: "warning"
  });
}
function WK(e) {
  return Object.assign(Object.assign({}, e), {
    type: "info"
  });
}
function VK(e) {
  return Object.assign(Object.assign({}, e), {
    type: "success"
  });
}
function _K(e) {
  return Object.assign(Object.assign({}, e), {
    type: "error"
  });
}
function BK(e) {
  return Object.assign(Object.assign({}, e), {
    type: "confirm"
  });
}
function Mpe({
  rootPrefixCls: e
}) {
  process.env.NODE_ENV !== "production" && nC(!1, "Modal", "Modal.config is deprecated. Please use ConfigProvider.config instead."), LK = e;
}
var Ope = function(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
    t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
};
const Tpe = (e, t) => {
  var r, {
    afterClose: a,
    config: i
  } = e, c = Ope(e, ["afterClose", "config"]);
  const [d, f] = S.useState(!0), [p, g] = S.useState(i), {
    direction: b,
    getPrefixCls: w
  } = S.useContext(Qr), x = w("modal"), E = w(), P = () => {
    var N;
    a(), (N = p.afterClose) === null || N === void 0 || N.call(p);
  }, k = (...N) => {
    var D;
    if (f(!1), N.some((I) => I?.triggerCancel)) {
      var j;
      (D = p.onCancel) === null || D === void 0 || (j = D).call.apply(j, [p, () => {
      }].concat(Et(N.slice(1))));
    }
  };
  S.useImperativeHandle(t, () => ({
    destroy: k,
    update: (N) => {
      g((D) => {
        const $ = typeof N == "function" ? N(D) : N;
        return Object.assign(Object.assign({}, D), $);
      });
    }
  }));
  const M = (r = p.okCancel) !== null && r !== void 0 ? r : p.type === "confirm", [T] = q1("Modal", vb.Modal);
  return /* @__PURE__ */ S.createElement(Xz, Object.assign({
    prefixCls: x,
    rootPrefixCls: E
  }, p, {
    close: k,
    open: d,
    afterClose: P,
    okText: p.okText || (M ? T?.okText : T?.justOkText),
    direction: p.direction || b,
    cancelText: p.cancelText || T?.cancelText
  }, c));
}, Rpe = /* @__PURE__ */ S.forwardRef(Tpe);
let yF = 0;
const Ape = /* @__PURE__ */ S.memo(/* @__PURE__ */ S.forwardRef((e, t) => {
  const [r, a] = Ede();
  return S.useImperativeHandle(t, () => ({
    patchElement: a
  }), [a]), /* @__PURE__ */ S.createElement(S.Fragment, null, r);
}));
function Npe() {
  const e = S.useRef(null), [t, r] = S.useState([]);
  S.useEffect(() => {
    t.length && (Et(t).forEach((d) => {
      d();
    }), r([]));
  }, [t]);
  const a = S.useCallback((c) => function(f) {
    var p;
    yF += 1;
    const g = /* @__PURE__ */ S.createRef();
    let b;
    const w = new Promise((M) => {
      b = M;
    });
    let x = !1, E;
    const P = /* @__PURE__ */ S.createElement(Rpe, {
      key: `modal-${yF}`,
      config: c(f),
      ref: g,
      afterClose: () => {
        E?.();
      },
      isSilent: () => x,
      onConfirm: (M) => {
        b(M);
      }
    });
    return E = (p = e.current) === null || p === void 0 ? void 0 : p.patchElement(P), E && B4.push(E), {
      destroy: () => {
        function M() {
          var T;
          (T = g.current) === null || T === void 0 || T.destroy();
        }
        g.current ? M() : r((T) => [].concat(Et(T), [M]));
      },
      update: (M) => {
        function T() {
          var N;
          (N = g.current) === null || N === void 0 || N.update(M);
        }
        g.current ? T() : r((N) => [].concat(Et(N), [T]));
      },
      then: (M) => (x = !0, w.then(M))
    };
  }, []);
  return [S.useMemo(() => ({
    info: a(WK),
    success: a(VK),
    error: a(_K),
    warning: a(FK),
    confirm: a(BK)
  }), [a]), /* @__PURE__ */ S.createElement(Ape, {
    key: "modal-holder",
    ref: e
  })];
}
function UK(e) {
  return (t) => /* @__PURE__ */ S.createElement(tc, {
    theme: {
      token: {
        motion: !1,
        zIndexPopupBase: 0
      }
    }
  }, /* @__PURE__ */ S.createElement(e, Object.assign({}, t)));
}
const Gx = (e, t, r, a, i) => UK((d) => {
  const {
    prefixCls: f,
    style: p
  } = d, g = S.useRef(null), [b, w] = S.useState(0), [x, E] = S.useState(0), [P, k] = ll(!1, {
    value: d.open
  }), {
    getPrefixCls: M
  } = S.useContext(Qr), T = M(a || "select", f);
  S.useEffect(() => {
    if (k(!0), typeof ResizeObserver < "u") {
      const $ = new ResizeObserver((I) => {
        const L = I[0].target;
        w(L.offsetHeight + 8), E(L.offsetWidth);
      }), j = setInterval(() => {
        var I;
        const L = i ? `.${i(T)}` : `.${T}-dropdown`, F = (I = g.current) === null || I === void 0 ? void 0 : I.querySelector(L);
        F && (clearInterval(j), $.observe(F));
      }, 10);
      return () => {
        clearInterval(j), $.disconnect();
      };
    }
  }, [T]);
  let N = Object.assign(Object.assign({}, d), {
    style: Object.assign(Object.assign({}, p), {
      margin: 0
    }),
    open: P,
    visible: P,
    getPopupContainer: () => g.current
  });
  r && (N = r(N)), t && Object.assign(N, {
    [t]: {
      overflow: {
        adjustX: !1,
        adjustY: !1
      }
    }
  });
  const D = {
    paddingBottom: b,
    position: "relative",
    minWidth: x
  };
  return /* @__PURE__ */ S.createElement("div", {
    ref: g,
    style: D
  }, /* @__PURE__ */ S.createElement(e, Object.assign({}, N)));
}), XK = (function() {
  if (typeof navigator > "u" || typeof window > "u")
    return !1;
  var e = navigator.userAgent || navigator.vendor || window.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(e) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(e?.substr(0, 4));
});
var Z9 = function(t) {
  var r = t.className, a = t.customizeIcon, i = t.customizeIconProps, c = t.children, d = t.onMouseDown, f = t.onClick, p = typeof a == "function" ? a(i) : a;
  return /* @__PURE__ */ S.createElement("span", {
    className: r,
    onMouseDown: function(b) {
      b.preventDefault(), d?.(b);
    },
    style: {
      userSelect: "none",
      WebkitUserSelect: "none"
    },
    unselectable: "on",
    onClick: f,
    "aria-hidden": !0
  }, p !== void 0 ? p : /* @__PURE__ */ S.createElement("span", {
    className: _e(r.split(/\s+/).map(function(g) {
      return "".concat(g, "-icon");
    }))
  }, c));
}, Dpe = function(t, r, a, i, c) {
  var d = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : !1, f = arguments.length > 6 ? arguments[6] : void 0, p = arguments.length > 7 ? arguments[7] : void 0, g = Re.useMemo(function() {
    if (Hn(i) === "object")
      return i.clearIcon;
    if (c)
      return c;
  }, [i, c]), b = Re.useMemo(function() {
    return !!(!d && i && (a.length || f) && !(p === "combobox" && f === ""));
  }, [i, d, a.length, f, p]);
  return {
    allowClear: b,
    clearIcon: /* @__PURE__ */ Re.createElement(Z9, {
      className: "".concat(t, "-clear"),
      onMouseDown: r,
      customizeIcon: g
    }, "×")
  };
}, GK = /* @__PURE__ */ S.createContext(null);
function $pe() {
  return S.useContext(GK);
}
function zpe() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10, t = S.useState(!1), r = qe(t, 2), a = r[0], i = r[1], c = S.useRef(null), d = function() {
    window.clearTimeout(c.current);
  };
  S.useEffect(function() {
    return d;
  }, []);
  var f = function(g, b) {
    d(), c.current = window.setTimeout(function() {
      i(g), b && b();
    }, e);
  };
  return [a, f, d];
}
function qK() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 250, t = S.useRef(null), r = S.useRef(null);
  S.useEffect(function() {
    return function() {
      window.clearTimeout(r.current);
    };
  }, []);
  function a(i) {
    (i || t.current === null) && (t.current = i), window.clearTimeout(r.current), r.current = window.setTimeout(function() {
      t.current = null;
    }, e);
  }
  return [function() {
    return t.current;
  }, a];
}
function jpe(e, t, r, a) {
  var i = S.useRef(null);
  i.current = {
    open: t,
    triggerOpen: r,
    customizedTrigger: a
  }, S.useEffect(function() {
    function c(d) {
      var f;
      if (!((f = i.current) !== null && f !== void 0 && f.customizedTrigger)) {
        var p = d.target;
        p.shadowRoot && d.composed && (p = d.composedPath()[0] || p), i.current.open && e().filter(function(g) {
          return g;
        }).every(function(g) {
          return !g.contains(p) && g !== p;
        }) && i.current.triggerOpen(!1);
      }
    }
    return window.addEventListener("mousedown", c), function() {
      return window.removeEventListener("mousedown", c);
    };
  }, []);
}
function Ipe(e) {
  return (
    // Undefined for Edge bug:
    // https://github.com/ant-design/ant-design/issues/51292
    e && // Other keys
    ![
      // System function button
      fn.ESC,
      fn.SHIFT,
      fn.BACKSPACE,
      fn.TAB,
      fn.WIN_KEY,
      fn.ALT,
      fn.META,
      fn.WIN_KEY_RIGHT,
      fn.CTRL,
      fn.SEMICOLON,
      fn.EQUALS,
      fn.CAPS_LOCK,
      fn.CONTEXT_MENU,
      // F1-F12
      fn.F1,
      fn.F2,
      fn.F3,
      fn.F4,
      fn.F5,
      fn.F6,
      fn.F7,
      fn.F8,
      fn.F9,
      fn.F10,
      fn.F11,
      fn.F12
    ].includes(e)
  );
}
var Lpe = ["prefixCls", "invalidate", "item", "renderItem", "responsive", "responsiveDisabled", "registerSize", "itemKey", "className", "style", "children", "display", "order", "component"], M3 = void 0;
function Hpe(e, t) {
  var r = e.prefixCls, a = e.invalidate, i = e.item, c = e.renderItem, d = e.responsive, f = e.responsiveDisabled, p = e.registerSize, g = e.itemKey, b = e.className, w = e.style, x = e.children, E = e.display, P = e.order, k = e.component, M = k === void 0 ? "div" : k, T = xr(e, Lpe), N = d && !E;
  function D(F) {
    p(g, F);
  }
  S.useEffect(function() {
    return function() {
      D(null);
    };
  }, []);
  var $ = c && i !== M3 ? c(i, {
    index: P
  }) : x, j;
  a || (j = {
    opacity: N ? 0 : 1,
    height: N ? 0 : M3,
    overflowY: N ? "hidden" : M3,
    order: d ? P : M3,
    pointerEvents: N ? "none" : M3,
    position: N ? "absolute" : M3
  });
  var I = {};
  N && (I["aria-hidden"] = !0);
  var L = /* @__PURE__ */ S.createElement(M, vt({
    className: _e(!a && r, b),
    style: ce(ce({}, j), w)
  }, I, T, {
    ref: t
  }), $);
  return d && (L = /* @__PURE__ */ S.createElement(hp, {
    onResize: function(_) {
      var W = _.offsetWidth;
      D(W);
    },
    disabled: f
  }, L)), L;
}
var J3 = /* @__PURE__ */ S.forwardRef(Hpe);
J3.displayName = "Item";
function Fpe(e) {
  if (typeof MessageChannel > "u")
    Pa(e);
  else {
    var t = new MessageChannel();
    t.port1.onmessage = function() {
      return e();
    }, t.port2.postMessage(void 0);
  }
}
function Wpe() {
  var e = S.useRef(null), t = function(a) {
    e.current || (e.current = [], Fpe(function() {
      hG(function() {
        e.current.forEach(function(i) {
          i();
        }), e.current = null;
      });
    })), e.current.push(a);
  };
  return t;
}
function O3(e, t) {
  var r = S.useState(t), a = qe(r, 2), i = a[0], c = a[1], d = ra(function(f) {
    e(function() {
      c(f);
    });
  });
  return [i, d];
}
var Uk = /* @__PURE__ */ Re.createContext(null), Vpe = ["component"], _pe = ["className"], Bpe = ["className"], Upe = function(t, r) {
  var a = S.useContext(Uk);
  if (!a) {
    var i = t.component, c = i === void 0 ? "div" : i, d = xr(t, Vpe);
    return /* @__PURE__ */ S.createElement(c, vt({}, d, {
      ref: r
    }));
  }
  var f = a.className, p = xr(a, _pe), g = t.className, b = xr(t, Bpe);
  return /* @__PURE__ */ S.createElement(Uk.Provider, {
    value: null
  }, /* @__PURE__ */ S.createElement(J3, vt({
    ref: r,
    className: _e(f, g)
  }, p, b)));
}, KK = /* @__PURE__ */ S.forwardRef(Upe);
KK.displayName = "RawItem";
var Xpe = ["prefixCls", "data", "renderItem", "renderRawItem", "itemKey", "itemWidth", "ssr", "style", "className", "maxCount", "renderRest", "renderRawRest", "prefix", "suffix", "component", "itemComponent", "onVisibleChange"], YK = "responsive", QK = "invalidate";
function Gpe(e) {
  return "+ ".concat(e.length, " ...");
}
function qpe(e, t) {
  var r = e.prefixCls, a = r === void 0 ? "rc-overflow" : r, i = e.data, c = i === void 0 ? [] : i, d = e.renderItem, f = e.renderRawItem, p = e.itemKey, g = e.itemWidth, b = g === void 0 ? 10 : g, w = e.ssr, x = e.style, E = e.className, P = e.maxCount, k = e.renderRest, M = e.renderRawRest, T = e.prefix, N = e.suffix, D = e.component, $ = D === void 0 ? "div" : D, j = e.itemComponent, I = e.onVisibleChange, L = xr(e, Xpe), F = w === "full", _ = Wpe(), W = O3(_, null), Q = qe(W, 2), U = Q[0], Y = Q[1], G = U || 0, J = O3(_, /* @__PURE__ */ new Map()), H = qe(J, 2), K = H[0], X = H[1], te = O3(_, 0), ie = qe(te, 2), ee = ie[0], ne = ie[1], ae = O3(_, 0), oe = qe(ae, 2), fe = oe[0], be = oe[1], me = O3(_, 0), De = qe(me, 2), Me = De[0], ze = De[1], le = O3(_, 0), se = qe(le, 2), Ae = se[0], we = se[1], Ne = Wn(null), pe = qe(Ne, 2), Qe = pe[0], Le = pe[1], Te = Wn(null), Oe = qe(Te, 2), ye = Oe[0], je = Oe[1], Ue = S.useMemo(function() {
    return ye === null && F ? Number.MAX_SAFE_INTEGER : ye || 0;
  }, [ye, U]), Fe = Wn(!1), tt = qe(Fe, 2), dt = tt[0], St = tt[1], mt = "".concat(a, "-item"), Ot = Math.max(ee, fe), Rt = P === YK, ct = c.length && Rt, it = P === QK, Ct = ct || typeof P == "number" && c.length > P, ut = mn(function() {
    var gt = c;
    return ct ? U === null && F ? gt = c : gt = c.slice(0, Math.min(c.length, G / b)) : typeof P == "number" && (gt = c.slice(0, P)), gt;
  }, [c, b, U, P, ct]), ht = mn(function() {
    return ct ? c.slice(Ue + 1) : c.slice(ut.length);
  }, [c, ut, ct, Ue]), ot = Cn(function(gt, wt) {
    var Ft;
    return typeof p == "function" ? p(gt) : (Ft = p && gt?.[p]) !== null && Ft !== void 0 ? Ft : wt;
  }, [p]), at = Cn(d || function(gt) {
    return gt;
  }, [d]);
  function ft(gt, wt, Ft) {
    ye === gt && (wt === void 0 || wt === Qe) || (je(gt), Ft || (St(gt < c.length - 1), I?.(gt)), wt !== void 0 && Le(wt));
  }
  function st(gt, wt) {
    Y(wt.clientWidth);
  }
  function pt(gt, wt) {
    X(function(Ft) {
      var yn = new Map(Ft);
      return wt === null ? yn.delete(gt) : yn.set(gt, wt), yn;
    });
  }
  function bt(gt, wt) {
    be(wt), ne(fe);
  }
  function Nt(gt, wt) {
    ze(wt);
  }
  function $t(gt, wt) {
    we(wt);
  }
  function Pt(gt) {
    return K.get(ot(ut[gt], gt));
  }
  Da(function() {
    if (G && typeof Ot == "number" && ut) {
      var gt = Me + Ae, wt = ut.length, Ft = wt - 1;
      if (!wt) {
        ft(0, null);
        return;
      }
      for (var yn = 0; yn < wt; yn += 1) {
        var gn = Pt(yn);
        if (F && (gn = gn || 0), gn === void 0) {
          ft(yn - 1, void 0, !0);
          break;
        }
        if (gt += gn, // Only one means `totalWidth` is the final width
        Ft === 0 && gt <= G || // Last two width will be the final width
        yn === Ft - 1 && gt + Pt(Ft) <= G) {
          ft(Ft, null);
          break;
        } else if (gt + Ot > G) {
          ft(yn - 1, gt - gn - Ae + fe);
          break;
        }
      }
      N && Pt(0) + Ae > G && Le(null);
    }
  }, [G, K, fe, Me, Ae, ot, ut]);
  var hn = dt && !!ht.length, an = {};
  Qe !== null && ct && (an = {
    position: "absolute",
    left: Qe,
    top: 0
  });
  var jn = {
    prefixCls: mt,
    responsive: ct,
    component: j,
    invalidate: it
  }, xn = f ? function(gt, wt) {
    var Ft = ot(gt, wt);
    return /* @__PURE__ */ S.createElement(Uk.Provider, {
      key: Ft,
      value: ce(ce({}, jn), {}, {
        order: wt,
        item: gt,
        itemKey: Ft,
        registerSize: pt,
        display: wt <= Ue
      })
    }, f(gt, wt));
  } : function(gt, wt) {
    var Ft = ot(gt, wt);
    return /* @__PURE__ */ S.createElement(J3, vt({}, jn, {
      order: wt,
      key: Ft,
      item: gt,
      renderItem: at,
      itemKey: Ft,
      registerSize: pt,
      display: wt <= Ue
    }));
  }, Ut = {
    order: hn ? Ue : Number.MAX_SAFE_INTEGER,
    className: "".concat(mt, "-rest"),
    registerSize: bt,
    display: hn
  }, pn = k || Gpe, wn = M ? /* @__PURE__ */ S.createElement(Uk.Provider, {
    value: ce(ce({}, jn), Ut)
  }, M(ht)) : /* @__PURE__ */ S.createElement(J3, vt({}, jn, Ut), typeof pn == "function" ? pn(ht) : pn), Lt = /* @__PURE__ */ S.createElement($, vt({
    className: _e(!it && a, E),
    style: x,
    ref: t
  }, L), T && /* @__PURE__ */ S.createElement(J3, vt({}, jn, {
    responsive: Rt,
    responsiveDisabled: !ct,
    order: -1,
    className: "".concat(mt, "-prefix"),
    registerSize: Nt,
    display: !0
  }), T), ut.map(xn), Ct ? wn : null, N && /* @__PURE__ */ S.createElement(J3, vt({}, jn, {
    responsive: Rt,
    responsiveDisabled: !ct,
    order: Ue,
    className: "".concat(mt, "-suffix"),
    registerSize: $t,
    display: !0,
    style: an
  }), N));
  return Rt ? /* @__PURE__ */ S.createElement(hp, {
    onResize: st,
    disabled: !ct
  }, Lt) : Lt;
}
var W1 = /* @__PURE__ */ S.forwardRef(qpe);
W1.displayName = "Overflow";
W1.Item = KK;
W1.RESPONSIVE = YK;
W1.INVALIDATE = QK;
function Kpe(e, t, r) {
  var a = ce(ce({}, e), t);
  return Object.keys(t).forEach(function(i) {
    var c = t[i];
    typeof c == "function" && (a[i] = function() {
      for (var d, f = arguments.length, p = new Array(f), g = 0; g < f; g++)
        p[g] = arguments[g];
      return c.apply(void 0, p), (d = e[i]) === null || d === void 0 ? void 0 : d.call.apply(d, [e].concat(p));
    });
  }), a;
}
var Ype = ["prefixCls", "id", "inputElement", "autoFocus", "autoComplete", "editable", "activeDescendantId", "value", "open", "attrs"], Qpe = function(t, r) {
  var a = t.prefixCls, i = t.id, c = t.inputElement, d = t.autoFocus, f = t.autoComplete, p = t.editable, g = t.activeDescendantId, b = t.value, w = t.open, x = t.attrs, E = xr(t, Ype), P = c || /* @__PURE__ */ S.createElement("input", null), k = P, M = k.ref, T = k.props;
  return pb(!("maxLength" in P.props), "Passing 'maxLength' to input element directly may not work because input in BaseSelect is controlled."), P = /* @__PURE__ */ S.cloneElement(P, ce(ce(ce({
    type: "search"
  }, Kpe(E, T)), {}, {
    // Override over origin props
    id: i,
    ref: mp(r, M),
    autoComplete: f || "off",
    autoFocus: d,
    className: _e("".concat(a, "-selection-search-input"), T?.className),
    role: "combobox",
    "aria-expanded": w || !1,
    "aria-haspopup": "listbox",
    "aria-owns": "".concat(i, "_list"),
    "aria-autocomplete": "list",
    "aria-controls": "".concat(i, "_list"),
    "aria-activedescendant": w ? g : void 0
  }, x), {}, {
    value: p ? b : "",
    readOnly: !p,
    unselectable: p ? null : "on",
    style: ce(ce({}, T.style), {}, {
      opacity: p ? null : 0
    })
  })), P;
}, Gz = /* @__PURE__ */ S.forwardRef(Qpe);
process.env.NODE_ENV !== "production" && (Gz.displayName = "Input");
function qz(e) {
  return Array.isArray(e) ? e : e !== void 0 ? [e] : [];
}
var Jpe = typeof window < "u" && window.document && window.document.documentElement, Zpe = process.env.NODE_ENV !== "test" && Jpe;
function ege(e) {
  return e != null;
}
function tge(e) {
  return !e && e !== 0;
}
function wF(e) {
  return ["string", "number"].includes(Hn(e));
}
function JK(e) {
  var t = void 0;
  return e && (wF(e.title) ? t = e.title.toString() : wF(e.label) && (t = e.label.toString())), t;
}
function nge(e, t) {
  Zpe ? S.useLayoutEffect(e, t) : S.useEffect(e, t);
}
function rge(e) {
  var t;
  return (t = e.key) !== null && t !== void 0 ? t : e.value;
}
var SF = function(t) {
  t.preventDefault(), t.stopPropagation();
}, age = function(t) {
  var r = t.id, a = t.prefixCls, i = t.values, c = t.open, d = t.searchValue, f = t.autoClearSearchValue, p = t.inputRef, g = t.placeholder, b = t.disabled, w = t.mode, x = t.showSearch, E = t.autoFocus, P = t.autoComplete, k = t.activeDescendantId, M = t.tabIndex, T = t.removeIcon, N = t.maxTagCount, D = t.maxTagTextLength, $ = t.maxTagPlaceholder, j = $ === void 0 ? function(we) {
    return "+ ".concat(we.length, " ...");
  } : $, I = t.tagRender, L = t.onToggleOpen, F = t.onRemove, _ = t.onInputChange, W = t.onInputPaste, Q = t.onInputKeyDown, U = t.onInputMouseDown, Y = t.onInputCompositionStart, G = t.onInputCompositionEnd, J = t.onInputBlur, H = S.useRef(null), K = Wn(0), X = qe(K, 2), te = X[0], ie = X[1], ee = Wn(!1), ne = qe(ee, 2), ae = ne[0], oe = ne[1], fe = "".concat(a, "-selection"), be = c || w === "multiple" && f === !1 || w === "tags" ? d : "", me = w === "tags" || w === "multiple" && f === !1 || x && (c || ae);
  nge(function() {
    ie(H.current.scrollWidth);
  }, [be]);
  var De = function(Ne, pe, Qe, Le, Te) {
    return /* @__PURE__ */ S.createElement("span", {
      title: JK(Ne),
      className: _e("".concat(fe, "-item"), ge({}, "".concat(fe, "-item-disabled"), Qe))
    }, /* @__PURE__ */ S.createElement("span", {
      className: "".concat(fe, "-item-content")
    }, pe), Le && /* @__PURE__ */ S.createElement(Z9, {
      className: "".concat(fe, "-item-remove"),
      onMouseDown: SF,
      onClick: Te,
      customizeIcon: T
    }, "×"));
  }, Me = function(Ne, pe, Qe, Le, Te, Oe) {
    var ye = function(Ue) {
      SF(Ue), L(!c);
    };
    return /* @__PURE__ */ S.createElement("span", {
      onMouseDown: ye
    }, I({
      label: pe,
      value: Ne,
      disabled: Qe,
      closable: Le,
      onClose: Te,
      isMaxTag: !!Oe
    }));
  }, ze = function(Ne) {
    var pe = Ne.disabled, Qe = Ne.label, Le = Ne.value, Te = !b && !pe, Oe = Qe;
    if (typeof D == "number" && (typeof Qe == "string" || typeof Qe == "number")) {
      var ye = String(Oe);
      ye.length > D && (Oe = "".concat(ye.slice(0, D), "..."));
    }
    var je = function(Fe) {
      Fe && Fe.stopPropagation(), F(Ne);
    };
    return typeof I == "function" ? Me(Le, Oe, pe, Te, je) : De(Ne, Oe, pe, Te, je);
  }, le = function(Ne) {
    if (!i.length)
      return null;
    var pe = typeof j == "function" ? j(Ne) : j;
    return typeof I == "function" ? Me(void 0, pe, !1, !1, void 0, !0) : De({
      title: pe
    }, pe, !1);
  }, se = /* @__PURE__ */ S.createElement("div", {
    className: "".concat(fe, "-search"),
    style: {
      width: te
    },
    onFocus: function() {
      oe(!0);
    },
    onBlur: function() {
      oe(!1);
    }
  }, /* @__PURE__ */ S.createElement(Gz, {
    ref: p,
    open: c,
    prefixCls: a,
    id: r,
    inputElement: null,
    disabled: b,
    autoFocus: E,
    autoComplete: P,
    editable: me,
    activeDescendantId: k,
    value: be,
    onKeyDown: Q,
    onMouseDown: U,
    onChange: _,
    onPaste: W,
    onCompositionStart: Y,
    onCompositionEnd: G,
    onBlur: J,
    tabIndex: M,
    attrs: Zu(t, !0)
  }), /* @__PURE__ */ S.createElement("span", {
    ref: H,
    className: "".concat(fe, "-search-mirror"),
    "aria-hidden": !0
  }, be, " ")), Ae = /* @__PURE__ */ S.createElement(W1, {
    prefixCls: "".concat(fe, "-overflow"),
    data: i,
    renderItem: ze,
    renderRest: le,
    suffix: se,
    itemKey: rge,
    maxCount: N
  });
  return /* @__PURE__ */ S.createElement("span", {
    className: "".concat(fe, "-wrap")
  }, Ae, !i.length && !be && /* @__PURE__ */ S.createElement("span", {
    className: "".concat(fe, "-placeholder")
  }, g));
}, oge = function(t) {
  var r = t.inputElement, a = t.prefixCls, i = t.id, c = t.inputRef, d = t.disabled, f = t.autoFocus, p = t.autoComplete, g = t.activeDescendantId, b = t.mode, w = t.open, x = t.values, E = t.placeholder, P = t.tabIndex, k = t.showSearch, M = t.searchValue, T = t.activeValue, N = t.maxLength, D = t.onInputKeyDown, $ = t.onInputMouseDown, j = t.onInputChange, I = t.onInputPaste, L = t.onInputCompositionStart, F = t.onInputCompositionEnd, _ = t.onInputBlur, W = t.title, Q = S.useState(!1), U = qe(Q, 2), Y = U[0], G = U[1], J = b === "combobox", H = J || k, K = x[0], X = M || "";
  J && T && !Y && (X = T), S.useEffect(function() {
    J && G(!1);
  }, [J, T]);
  var te = b !== "combobox" && !w && !k ? !1 : !!X, ie = W === void 0 ? JK(K) : W, ee = S.useMemo(function() {
    return K ? null : /* @__PURE__ */ S.createElement("span", {
      className: "".concat(a, "-selection-placeholder"),
      style: te ? {
        visibility: "hidden"
      } : void 0
    }, E);
  }, [K, te, E, a]);
  return /* @__PURE__ */ S.createElement("span", {
    className: "".concat(a, "-selection-wrap")
  }, /* @__PURE__ */ S.createElement("span", {
    className: "".concat(a, "-selection-search")
  }, /* @__PURE__ */ S.createElement(Gz, {
    ref: c,
    prefixCls: a,
    id: i,
    open: w,
    inputElement: r,
    disabled: d,
    autoFocus: f,
    autoComplete: p,
    editable: H,
    activeDescendantId: g,
    value: X,
    onKeyDown: D,
    onMouseDown: $,
    onChange: function(ae) {
      G(!0), j(ae);
    },
    onPaste: I,
    onCompositionStart: L,
    onCompositionEnd: F,
    onBlur: _,
    tabIndex: P,
    attrs: Zu(t, !0),
    maxLength: J ? N : void 0
  })), !J && K ? /* @__PURE__ */ S.createElement("span", {
    className: "".concat(a, "-selection-item"),
    title: ie,
    style: te ? {
      visibility: "hidden"
    } : void 0
  }, K.label) : null, ee);
}, ige = function(t, r) {
  var a = It(null), i = It(!1), c = t.prefixCls, d = t.open, f = t.mode, p = t.showSearch, g = t.tokenWithEnter, b = t.disabled, w = t.prefix, x = t.autoClearSearchValue, E = t.onSearch, P = t.onSearchSubmit, k = t.onToggleOpen, M = t.onInputKeyDown, T = t.onInputBlur, N = t.domRef;
  S.useImperativeHandle(r, function() {
    return {
      focus: function(ie) {
        a.current.focus(ie);
      },
      blur: function() {
        a.current.blur();
      }
    };
  });
  var D = qK(0), $ = qe(D, 2), j = $[0], I = $[1], L = function(ie) {
    var ee = ie.which, ne = a.current instanceof HTMLTextAreaElement;
    !ne && d && (ee === fn.UP || ee === fn.DOWN) && ie.preventDefault(), M && M(ie), ee === fn.ENTER && f === "tags" && !i.current && !d && P?.(ie.target.value), !(ne && !d && ~[fn.UP, fn.DOWN, fn.LEFT, fn.RIGHT].indexOf(ee)) && Ipe(ee) && k(!0);
  }, F = function() {
    I(!0);
  }, _ = It(null), W = function(ie) {
    E(ie, !0, i.current) !== !1 && k(!0);
  }, Q = function() {
    i.current = !0;
  }, U = function(ie) {
    i.current = !1, f !== "combobox" && W(ie.target.value);
  }, Y = function(ie) {
    var ee = ie.target.value;
    if (g && _.current && /[\r\n]/.test(_.current)) {
      var ne = _.current.replace(/[\r\n]+$/, "").replace(/\r\n/g, " ").replace(/[\r\n]/g, " ");
      ee = ee.replace(ne, _.current);
    }
    _.current = null, W(ee);
  }, G = function(ie) {
    var ee = ie.clipboardData, ne = ee?.getData("text");
    _.current = ne || "";
  }, J = function(ie) {
    var ee = ie.target;
    if (ee !== a.current) {
      var ne = document.body.style.msTouchAction !== void 0;
      ne ? setTimeout(function() {
        a.current.focus();
      }) : a.current.focus();
    }
  }, H = function(ie) {
    var ee = j();
    ie.target !== a.current && !ee && !(f === "combobox" && b) && ie.preventDefault(), (f !== "combobox" && (!p || !ee) || !d) && (d && x !== !1 && E("", !0, !1), k());
  }, K = {
    inputRef: a,
    onInputKeyDown: L,
    onInputMouseDown: F,
    onInputChange: Y,
    onInputPaste: G,
    onInputCompositionStart: Q,
    onInputCompositionEnd: U,
    onInputBlur: T
  }, X = f === "multiple" || f === "tags" ? /* @__PURE__ */ S.createElement(age, vt({}, t, K)) : /* @__PURE__ */ S.createElement(oge, vt({}, t, K));
  return /* @__PURE__ */ S.createElement("div", {
    ref: N,
    className: "".concat(c, "-selector"),
    onClick: J,
    onMouseDown: H
  }, w && /* @__PURE__ */ S.createElement("div", {
    className: "".concat(c, "-prefix")
  }, w), X);
}, ZK = /* @__PURE__ */ S.forwardRef(ige);
process.env.NODE_ENV !== "production" && (ZK.displayName = "Selector");
function lge(e) {
  var t = e.prefixCls, r = e.align, a = e.arrow, i = e.arrowPos, c = a || {}, d = c.className, f = c.content, p = i.x, g = p === void 0 ? 0 : p, b = i.y, w = b === void 0 ? 0 : b, x = S.useRef();
  if (!r || !r.points)
    return null;
  var E = {
    position: "absolute"
  };
  if (r.autoArrow !== !1) {
    var P = r.points[0], k = r.points[1], M = P[0], T = P[1], N = k[0], D = k[1];
    M === N || !["t", "b"].includes(M) ? E.top = w : M === "t" ? E.top = 0 : E.bottom = 0, T === D || !["l", "r"].includes(T) ? E.left = g : T === "l" ? E.left = 0 : E.right = 0;
  }
  return /* @__PURE__ */ S.createElement("div", {
    ref: x,
    className: _e("".concat(t, "-arrow"), d),
    style: E
  }, f);
}
function sge(e) {
  var t = e.prefixCls, r = e.open, a = e.zIndex, i = e.mask, c = e.motion;
  return i ? /* @__PURE__ */ S.createElement(N0, vt({}, c, {
    motionAppear: !0,
    visible: r,
    removeOnLeave: !0
  }), function(d) {
    var f = d.className;
    return /* @__PURE__ */ S.createElement("div", {
      style: {
        zIndex: a
      },
      className: _e("".concat(t, "-mask"), f)
    });
  }) : null;
}
var eY = /* @__PURE__ */ S.memo(function(e) {
  var t = e.children;
  return t;
}, function(e, t) {
  return t.cache;
});
process.env.NODE_ENV !== "production" && (eY.displayName = "PopupContent");
var tY = /* @__PURE__ */ S.forwardRef(function(e, t) {
  var r = e.popup, a = e.className, i = e.prefixCls, c = e.style, d = e.target, f = e.onVisibleChanged, p = e.open, g = e.keepDom, b = e.fresh, w = e.onClick, x = e.mask, E = e.arrow, P = e.arrowPos, k = e.align, M = e.motion, T = e.maskMotion, N = e.forceRender, D = e.getPopupContainer, $ = e.autoDestroy, j = e.portal, I = e.zIndex, L = e.onMouseEnter, F = e.onMouseLeave, _ = e.onPointerEnter, W = e.onPointerDownCapture, Q = e.ready, U = e.offsetX, Y = e.offsetY, G = e.offsetR, J = e.offsetB, H = e.onAlign, K = e.onPrepare, X = e.stretch, te = e.targetWidth, ie = e.targetHeight, ee = typeof r == "function" ? r() : r, ne = p || g, ae = D?.length > 0, oe = S.useState(!D || !ae), fe = qe(oe, 2), be = fe[0], me = fe[1];
  if (Da(function() {
    !be && ae && d && me(!0);
  }, [be, ae, d]), !be)
    return null;
  var De = "auto", Me = {
    left: "-1000vw",
    top: "-1000vh",
    right: De,
    bottom: De
  };
  if (Q || !p) {
    var ze, le = k.points, se = k.dynamicInset || ((ze = k._experimental) === null || ze === void 0 ? void 0 : ze.dynamicInset), Ae = se && le[0][1] === "r", we = se && le[0][0] === "b";
    Ae ? (Me.right = G, Me.left = De) : (Me.left = U, Me.right = De), we ? (Me.bottom = J, Me.top = De) : (Me.top = Y, Me.bottom = De);
  }
  var Ne = {};
  return X && (X.includes("height") && ie ? Ne.height = ie : X.includes("minHeight") && ie && (Ne.minHeight = ie), X.includes("width") && te ? Ne.width = te : X.includes("minWidth") && te && (Ne.minWidth = te)), p || (Ne.pointerEvents = "none"), /* @__PURE__ */ S.createElement(j, {
    open: N || ne,
    getContainer: D && function() {
      return D(d);
    },
    autoDestroy: $
  }, /* @__PURE__ */ S.createElement(sge, {
    prefixCls: i,
    open: p,
    zIndex: I,
    mask: x,
    motion: T
  }), /* @__PURE__ */ S.createElement(hp, {
    onResize: H,
    disabled: !p
  }, function(pe) {
    return /* @__PURE__ */ S.createElement(N0, vt({
      motionAppear: !0,
      motionEnter: !0,
      motionLeave: !0,
      removeOnLeave: !1,
      forceRender: N,
      leavedClassName: "".concat(i, "-hidden")
    }, M, {
      onAppearPrepare: K,
      onEnterPrepare: K,
      visible: p,
      onVisibleChanged: function(Le) {
        var Te;
        M == null || (Te = M.onVisibleChanged) === null || Te === void 0 || Te.call(M, Le), f(Le);
      }
    }), function(Qe, Le) {
      var Te = Qe.className, Oe = Qe.style, ye = _e(i, Te, a);
      return /* @__PURE__ */ S.createElement("div", {
        ref: mp(pe, t, Le),
        className: ye,
        style: ce(ce(ce(ce({
          "--arrow-x": "".concat(P.x || 0, "px"),
          "--arrow-y": "".concat(P.y || 0, "px")
        }, Me), Ne), Oe), {}, {
          boxSizing: "border-box",
          zIndex: I
        }, c),
        onMouseEnter: L,
        onMouseLeave: F,
        onPointerEnter: _,
        onClick: w,
        onPointerDownCapture: W
      }, E && /* @__PURE__ */ S.createElement(lge, {
        prefixCls: i,
        arrow: E,
        arrowPos: P,
        align: k
      }), /* @__PURE__ */ S.createElement(eY, {
        cache: !p && !b
      }, ee));
    });
  }));
});
process.env.NODE_ENV !== "production" && (tY.displayName = "Popup");
var nY = /* @__PURE__ */ S.forwardRef(function(e, t) {
  var r = e.children, a = e.getTriggerDOMNode, i = gb(r), c = S.useCallback(function(f) {
    xE(t, a ? a(f) : f);
  }, [a]), d = gS(c, m3(r));
  return i ? /* @__PURE__ */ S.cloneElement(r, {
    ref: d
  }) : r;
});
process.env.NODE_ENV !== "production" && (nY.displayName = "TriggerWrapper");
var CF = /* @__PURE__ */ S.createContext(null);
function xF(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
function uge(e, t, r, a) {
  return S.useMemo(function() {
    var i = xF(r ?? t), c = xF(a ?? t), d = new Set(i), f = new Set(c);
    return e && (d.has("hover") && (d.delete("hover"), d.add("click")), f.has("hover") && (f.delete("hover"), f.add("click"))), [d, f];
  }, [e, t, r, a]);
}
function cge() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], r = arguments.length > 2 ? arguments[2] : void 0;
  return r ? e[0] === t[0] : e[0] === t[0] && e[1] === t[1];
}
function dge(e, t, r, a) {
  for (var i = r.points, c = Object.keys(e), d = 0; d < c.length; d += 1) {
    var f, p = c[d];
    if (cge((f = e[p]) === null || f === void 0 ? void 0 : f.points, i, a))
      return "".concat(t, "-placement-").concat(p);
  }
  return "";
}
function EF(e, t, r, a) {
  return t || (r ? {
    motionName: "".concat(e, "-").concat(r)
  } : a ? {
    motionName: a
  } : null);
}
function ZE(e) {
  return e.ownerDocument.defaultView;
}
function OD(e) {
  for (var t = [], r = e?.parentElement, a = ["hidden", "scroll", "clip", "auto"]; r; ) {
    var i = ZE(r).getComputedStyle(r), c = i.overflowX, d = i.overflowY, f = i.overflow;
    [c, d, f].some(function(p) {
      return a.includes(p);
    }) && t.push(r), r = r.parentElement;
  }
  return t;
}
function AE(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  return Number.isNaN(e) ? t : e;
}
function P5(e) {
  return AE(parseFloat(e), 0);
}
function PF(e, t) {
  var r = ce({}, e);
  return (t || []).forEach(function(a) {
    if (!(a instanceof HTMLBodyElement || a instanceof HTMLHtmlElement)) {
      var i = ZE(a).getComputedStyle(a), c = i.overflow, d = i.overflowClipMargin, f = i.borderTopWidth, p = i.borderBottomWidth, g = i.borderLeftWidth, b = i.borderRightWidth, w = a.getBoundingClientRect(), x = a.offsetHeight, E = a.clientHeight, P = a.offsetWidth, k = a.clientWidth, M = P5(f), T = P5(p), N = P5(g), D = P5(b), $ = AE(Math.round(w.width / P * 1e3) / 1e3), j = AE(Math.round(w.height / x * 1e3) / 1e3), I = (P - k - N - D) * $, L = (x - E - M - T) * j, F = M * j, _ = T * j, W = N * $, Q = D * $, U = 0, Y = 0;
      if (c === "clip") {
        var G = P5(d);
        U = G * $, Y = G * j;
      }
      var J = w.x + W - U, H = w.y + F - Y, K = J + w.width + 2 * U - W - Q - I, X = H + w.height + 2 * Y - F - _ - L;
      r.left = Math.max(r.left, J), r.top = Math.max(r.top, H), r.right = Math.min(r.right, K), r.bottom = Math.min(r.bottom, X);
    }
  }), r;
}
function kF(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = "".concat(t), a = r.match(/^(.*)\%$/);
  return a ? e * (parseFloat(a[1]) / 100) : parseFloat(r);
}
function MF(e, t) {
  var r = t || [], a = qe(r, 2), i = a[0], c = a[1];
  return [kF(e.width, i), kF(e.height, c)];
}
function OF() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  return [e[0], e[1]];
}
function T3(e, t) {
  var r = t[0], a = t[1], i, c;
  return r === "t" ? c = e.y : r === "b" ? c = e.y + e.height : c = e.y + e.height / 2, a === "l" ? i = e.x : a === "r" ? i = e.x + e.width : i = e.x + e.width / 2, {
    x: i,
    y: c
  };
}
function yS(e, t) {
  var r = {
    t: "b",
    b: "t",
    l: "r",
    r: "l"
  };
  return e.map(function(a, i) {
    return i === t ? r[a] || "c" : a;
  }).join("");
}
function fge(e, t, r, a, i, c, d) {
  var f = S.useState({
    ready: !1,
    offsetX: 0,
    offsetY: 0,
    offsetR: 0,
    offsetB: 0,
    arrowX: 0,
    arrowY: 0,
    scaleX: 1,
    scaleY: 1,
    align: i[a] || {}
  }), p = qe(f, 2), g = p[0], b = p[1], w = S.useRef(0), x = S.useMemo(function() {
    return t ? OD(t) : [];
  }, [t]), E = S.useRef({}), P = function() {
    E.current = {};
  };
  e || P();
  var k = ra(function() {
    if (t && r && e) {
      let pr = function(Va, pi) {
        var Li = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : tt, yo = ne.x + Va, ul = ne.y + pi, rc = yo + we, uu = ul + Ae, lm = Math.max(yo, Li.left), Jt = Math.max(ul, Li.top), nr = Math.min(rc, Li.right), ao = Math.min(uu, Li.bottom);
        return Math.max(0, (nr - lm) * (ao - Jt));
      }, tr = function() {
        Gn = ne.y + pn, wr = Gn + Ae, aa = ne.x + Ut, qn = aa + we;
      };
      var N, D, $, j, I = t, L = I.ownerDocument, F = ZE(I), _ = F.getComputedStyle(I), W = _.position, Q = I.style.left, U = I.style.top, Y = I.style.right, G = I.style.bottom, J = I.style.overflow, H = ce(ce({}, i[a]), c), K = L.createElement("div");
      (N = I.parentElement) === null || N === void 0 || N.appendChild(K), K.style.left = "".concat(I.offsetLeft, "px"), K.style.top = "".concat(I.offsetTop, "px"), K.style.position = W, K.style.height = "".concat(I.offsetHeight, "px"), K.style.width = "".concat(I.offsetWidth, "px"), I.style.left = "0", I.style.top = "0", I.style.right = "auto", I.style.bottom = "auto", I.style.overflow = "hidden";
      var X;
      if (Array.isArray(r))
        X = {
          x: r[0],
          y: r[1],
          width: 0,
          height: 0
        };
      else {
        var te, ie, ee = r.getBoundingClientRect();
        ee.x = (te = ee.x) !== null && te !== void 0 ? te : ee.left, ee.y = (ie = ee.y) !== null && ie !== void 0 ? ie : ee.top, X = {
          x: ee.x,
          y: ee.y,
          width: ee.width,
          height: ee.height
        };
      }
      var ne = I.getBoundingClientRect(), ae = F.getComputedStyle(I), oe = ae.height, fe = ae.width;
      ne.x = (D = ne.x) !== null && D !== void 0 ? D : ne.left, ne.y = ($ = ne.y) !== null && $ !== void 0 ? $ : ne.top;
      var be = L.documentElement, me = be.clientWidth, De = be.clientHeight, Me = be.scrollWidth, ze = be.scrollHeight, le = be.scrollTop, se = be.scrollLeft, Ae = ne.height, we = ne.width, Ne = X.height, pe = X.width, Qe = {
        left: 0,
        top: 0,
        right: me,
        bottom: De
      }, Le = {
        left: -se,
        top: -le,
        right: Me - se,
        bottom: ze - le
      }, Te = H.htmlRegion, Oe = "visible", ye = "visibleFirst";
      Te !== "scroll" && Te !== ye && (Te = Oe);
      var je = Te === ye, Ue = PF(Le, x), Fe = PF(Qe, x), tt = Te === Oe ? Fe : Ue, dt = je ? Fe : tt;
      I.style.left = "auto", I.style.top = "auto", I.style.right = "0", I.style.bottom = "0";
      var St = I.getBoundingClientRect();
      I.style.left = Q, I.style.top = U, I.style.right = Y, I.style.bottom = G, I.style.overflow = J, (j = I.parentElement) === null || j === void 0 || j.removeChild(K);
      var mt = AE(Math.round(we / parseFloat(fe) * 1e3) / 1e3), Ot = AE(Math.round(Ae / parseFloat(oe) * 1e3) / 1e3);
      if (mt === 0 || Ot === 0 || CE(r) && !BE(r))
        return;
      var Rt = H.offset, ct = H.targetOffset, it = MF(ne, Rt), Ct = qe(it, 2), ut = Ct[0], ht = Ct[1], ot = MF(X, ct), at = qe(ot, 2), ft = at[0], st = at[1];
      X.x -= ft, X.y -= st;
      var pt = H.points || [], bt = qe(pt, 2), Nt = bt[0], $t = bt[1], Pt = OF($t), hn = OF(Nt), an = T3(X, Pt), jn = T3(ne, hn), xn = ce({}, H), Ut = an.x - jn.x + ut, pn = an.y - jn.y + ht, wn = pr(Ut, pn), Lt = pr(Ut, pn, Fe), gt = T3(X, ["t", "l"]), wt = T3(ne, ["t", "l"]), Ft = T3(X, ["b", "r"]), yn = T3(ne, ["b", "r"]), gn = H.overflow || {}, Tn = gn.adjustX, Gt = gn.adjustY, Dt = gn.shiftX, Yt = gn.shiftY, Mn = function(pi) {
        return typeof pi == "boolean" ? pi : pi >= 0;
      }, Gn, wr, aa, qn;
      tr();
      var Rr = Mn(Gt), Wt = hn[0] === Pt[0];
      if (Rr && hn[0] === "t" && (wr > dt.bottom || E.current.bt)) {
        var en = pn;
        Wt ? en -= Ae - Ne : en = gt.y - yn.y - ht;
        var Xt = pr(Ut, en), zt = pr(Ut, en, Fe);
        // Of course use larger one
        Xt > wn || Xt === wn && (!je || // Choose recommend one
        zt >= Lt) ? (E.current.bt = !0, pn = en, ht = -ht, xn.points = [yS(hn, 0), yS(Pt, 0)]) : E.current.bt = !1;
      }
      if (Rr && hn[0] === "b" && (Gn < dt.top || E.current.tb)) {
        var kt = pn;
        Wt ? kt += Ae - Ne : kt = Ft.y - wt.y - ht;
        var Qn = pr(Ut, kt), Jn = pr(Ut, kt, Fe);
        // Of course use larger one
        Qn > wn || Qn === wn && (!je || // Choose recommend one
        Jn >= Lt) ? (E.current.tb = !0, pn = kt, ht = -ht, xn.points = [yS(hn, 0), yS(Pt, 0)]) : E.current.tb = !1;
      }
      var Nr = Mn(Tn), Hr = hn[1] === Pt[1];
      if (Nr && hn[1] === "l" && (qn > dt.right || E.current.rl)) {
        var oa = Ut;
        Hr ? oa -= we - pe : oa = gt.x - yn.x - ut;
        var dn = pr(oa, pn), Un = pr(oa, pn, Fe);
        // Of course use larger one
        dn > wn || dn === wn && (!je || // Choose recommend one
        Un >= Lt) ? (E.current.rl = !0, Ut = oa, ut = -ut, xn.points = [yS(hn, 1), yS(Pt, 1)]) : E.current.rl = !1;
      }
      if (Nr && hn[1] === "r" && (aa < dt.left || E.current.lr)) {
        var sr = Ut;
        Hr ? sr += we - pe : sr = Ft.x - wt.x - ut;
        var Yr = pr(sr, pn), Wa = pr(sr, pn, Fe);
        // Of course use larger one
        Yr > wn || Yr === wn && (!je || // Choose recommend one
        Wa >= Lt) ? (E.current.lr = !0, Ut = sr, ut = -ut, xn.points = [yS(hn, 1), yS(Pt, 1)]) : E.current.lr = !1;
      }
      tr();
      var pa = Dt === !0 ? 0 : Dt;
      typeof pa == "number" && (aa < Fe.left && (Ut -= aa - Fe.left - ut, X.x + pe < Fe.left + pa && (Ut += X.x - Fe.left + pe - pa)), qn > Fe.right && (Ut -= qn - Fe.right - ut, X.x > Fe.right - pa && (Ut += X.x - Fe.right + pa)));
      var Jr = Yt === !0 ? 0 : Yt;
      typeof Jr == "number" && (Gn < Fe.top && (pn -= Gn - Fe.top - ht, X.y + Ne < Fe.top + Jr && (pn += X.y - Fe.top + Ne - Jr)), wr > Fe.bottom && (pn -= wr - Fe.bottom - ht, X.y > Fe.bottom - Jr && (pn += X.y - Fe.bottom + Jr)));
      var si = ne.x + Ut, mi = si + we, Yo = ne.y + pn, Bi = Yo + Ae, hr = X.x, zn = hr + pe, On = X.y, Qt = On + Ne, nn = Math.max(si, hr), er = Math.min(mi, zn), ia = (nn + er) / 2, so = ia - si, hi = Math.max(Yo, On), ka = Math.min(Bi, Qt), Ui = (hi + ka) / 2, sl = Ui - Yo;
      d?.(t, xn);
      var qt = St.right - ne.x - (Ut + ne.width), Kt = St.bottom - ne.y - (pn + ne.height);
      mt === 1 && (Ut = Math.floor(Ut), qt = Math.floor(qt)), Ot === 1 && (pn = Math.floor(pn), Kt = Math.floor(Kt));
      var ur = {
        ready: !0,
        offsetX: Ut / mt,
        offsetY: pn / Ot,
        offsetR: qt / mt,
        offsetB: Kt / Ot,
        arrowX: so / mt,
        arrowY: sl / Ot,
        scaleX: mt,
        scaleY: Ot,
        align: xn
      };
      b(ur);
    }
  }), M = function() {
    w.current += 1;
    var D = w.current;
    Promise.resolve().then(function() {
      w.current === D && k();
    });
  }, T = function() {
    b(function(D) {
      return ce(ce({}, D), {}, {
        ready: !1
      });
    });
  };
  return Da(T, [a]), Da(function() {
    e || T();
  }, [e]), [g.ready, g.offsetX, g.offsetY, g.offsetR, g.offsetB, g.arrowX, g.arrowY, g.scaleX, g.scaleY, g.align, M];
}
function mge(e, t, r, a, i) {
  Da(function() {
    if (e && t && r) {
      let w = function() {
        a(), i();
      };
      var c = t, d = r, f = OD(c), p = OD(d), g = ZE(d), b = new Set([g].concat(Et(f), Et(p)));
      return b.forEach(function(x) {
        x.addEventListener("scroll", w, {
          passive: !0
        });
      }), g.addEventListener("resize", w, {
        passive: !0
      }), a(), function() {
        b.forEach(function(x) {
          x.removeEventListener("scroll", w), g.removeEventListener("resize", w);
        });
      };
    }
  }, [e, t, r]);
}
function hge(e, t, r, a, i, c, d, f) {
  var p = S.useRef(e);
  p.current = e;
  var g = S.useRef(!1);
  S.useEffect(function() {
    if (t && a && (!i || c)) {
      var w = function() {
        g.current = !1;
      }, x = function($) {
        var j;
        p.current && !d(((j = $.composedPath) === null || j === void 0 || (j = j.call($)) === null || j === void 0 ? void 0 : j[0]) || $.target) && !g.current && f(!1);
      }, E = ZE(a);
      E.addEventListener("pointerdown", w, !0), E.addEventListener("mousedown", x, !0), E.addEventListener("contextmenu", x, !0);
      var P = Hk(r);
      if (P && (P.addEventListener("mousedown", x, !0), P.addEventListener("contextmenu", x, !0)), process.env.NODE_ENV !== "production") {
        var k, M, T = r == null || (k = r.getRootNode) === null || k === void 0 ? void 0 : k.call(r), N = (M = a.getRootNode) === null || M === void 0 ? void 0 : M.call(a);
        pb(T === N, "trigger element and popup element should in same shadow root.");
      }
      return function() {
        E.removeEventListener("pointerdown", w, !0), E.removeEventListener("mousedown", x, !0), E.removeEventListener("contextmenu", x, !0), P && (P.removeEventListener("mousedown", x, !0), P.removeEventListener("contextmenu", x, !0));
      };
    }
  }, [t, r, a, i, c]);
  function b() {
    g.current = !0;
  }
  return b;
}
var pge = ["prefixCls", "children", "action", "showAction", "hideAction", "popupVisible", "defaultPopupVisible", "onPopupVisibleChange", "afterPopupVisibleChange", "mouseEnterDelay", "mouseLeaveDelay", "focusDelay", "blurDelay", "mask", "maskClosable", "getPopupContainer", "forceRender", "autoDestroy", "destroyPopupOnHide", "popup", "popupClassName", "popupStyle", "popupPlacement", "builtinPlacements", "popupAlign", "zIndex", "stretch", "getPopupClassNameFromAlign", "fresh", "alignPoint", "onPopupClick", "onPopupAlign", "arrow", "popupMotion", "maskMotion", "popupTransitionName", "popupAnimation", "maskTransitionName", "maskAnimation", "className", "getTriggerDOMNode"];
function gge() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : qE, t = /* @__PURE__ */ S.forwardRef(function(r, a) {
    var i = r.prefixCls, c = i === void 0 ? "rc-trigger-popup" : i, d = r.children, f = r.action, p = f === void 0 ? "hover" : f, g = r.showAction, b = r.hideAction, w = r.popupVisible, x = r.defaultPopupVisible, E = r.onPopupVisibleChange, P = r.afterPopupVisibleChange, k = r.mouseEnterDelay, M = r.mouseLeaveDelay, T = M === void 0 ? 0.1 : M, N = r.focusDelay, D = r.blurDelay, $ = r.mask, j = r.maskClosable, I = j === void 0 ? !0 : j, L = r.getPopupContainer, F = r.forceRender, _ = r.autoDestroy, W = r.destroyPopupOnHide, Q = r.popup, U = r.popupClassName, Y = r.popupStyle, G = r.popupPlacement, J = r.builtinPlacements, H = J === void 0 ? {} : J, K = r.popupAlign, X = r.zIndex, te = r.stretch, ie = r.getPopupClassNameFromAlign, ee = r.fresh, ne = r.alignPoint, ae = r.onPopupClick, oe = r.onPopupAlign, fe = r.arrow, be = r.popupMotion, me = r.maskMotion, De = r.popupTransitionName, Me = r.popupAnimation, ze = r.maskTransitionName, le = r.maskAnimation, se = r.className, Ae = r.getTriggerDOMNode, we = xr(r, pge), Ne = _ || W || !1, pe = S.useState(!1), Qe = qe(pe, 2), Le = Qe[0], Te = Qe[1];
    Da(function() {
      Te(XK());
    }, []);
    var Oe = S.useRef({}), ye = S.useContext(CF), je = S.useMemo(function() {
      return {
        registerSubPopup: function(nr, ao) {
          Oe.current[nr] = ao, ye?.registerSubPopup(nr, ao);
        }
      };
    }, [ye]), Ue = KE(), Fe = S.useState(null), tt = qe(Fe, 2), dt = tt[0], St = tt[1], mt = S.useRef(null), Ot = ra(function(Jt) {
      mt.current = Jt, CE(Jt) && dt !== Jt && St(Jt), ye?.registerSubPopup(Ue, Jt);
    }), Rt = S.useState(null), ct = qe(Rt, 2), it = ct[0], Ct = ct[1], ut = S.useRef(null), ht = ra(function(Jt) {
      CE(Jt) && it !== Jt && (Ct(Jt), ut.current = Jt);
    }), ot = S.Children.only(d), at = ot?.props || {}, ft = {}, st = ra(function(Jt) {
      var nr, ao, wo = it;
      return wo?.contains(Jt) || ((nr = Hk(wo)) === null || nr === void 0 ? void 0 : nr.host) === Jt || Jt === wo || dt?.contains(Jt) || ((ao = Hk(dt)) === null || ao === void 0 ? void 0 : ao.host) === Jt || Jt === dt || Object.values(Oe.current).some(function(Ea) {
        return Ea?.contains(Jt) || Jt === Ea;
      });
    }), pt = EF(c, be, Me, De), bt = EF(c, me, le, ze), Nt = S.useState(x || !1), $t = qe(Nt, 2), Pt = $t[0], hn = $t[1], an = w ?? Pt, jn = ra(function(Jt) {
      w === void 0 && hn(Jt);
    });
    Da(function() {
      hn(w || !1);
    }, [w]);
    var xn = S.useRef(an);
    xn.current = an;
    var Ut = S.useRef([]);
    Ut.current = [];
    var pn = ra(function(Jt) {
      var nr;
      jn(Jt), ((nr = Ut.current[Ut.current.length - 1]) !== null && nr !== void 0 ? nr : an) !== Jt && (Ut.current.push(Jt), E?.(Jt));
    }), wn = S.useRef(), Lt = function() {
      clearTimeout(wn.current);
    }, gt = function(nr) {
      var ao = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      Lt(), ao === 0 ? pn(nr) : wn.current = setTimeout(function() {
        pn(nr);
      }, ao * 1e3);
    };
    S.useEffect(function() {
      return Lt;
    }, []);
    var wt = S.useState(!1), Ft = qe(wt, 2), yn = Ft[0], gn = Ft[1];
    Da(function(Jt) {
      (!Jt || an) && gn(!0);
    }, [an]);
    var Tn = S.useState(null), Gt = qe(Tn, 2), Dt = Gt[0], Yt = Gt[1], Mn = S.useState(null), Gn = qe(Mn, 2), wr = Gn[0], aa = Gn[1], qn = function(nr) {
      aa([nr.clientX, nr.clientY]);
    }, Rr = fge(an, dt, ne && wr !== null ? wr : it, G, H, K, oe), Wt = qe(Rr, 11), en = Wt[0], Xt = Wt[1], zt = Wt[2], kt = Wt[3], Qn = Wt[4], Jn = Wt[5], Nr = Wt[6], Hr = Wt[7], oa = Wt[8], dn = Wt[9], Un = Wt[10], sr = uge(Le, p, g, b), Yr = qe(sr, 2), Wa = Yr[0], pa = Yr[1], Jr = Wa.has("click"), si = pa.has("click") || pa.has("contextMenu"), mi = ra(function() {
      yn || Un();
    }), Yo = function() {
      xn.current && ne && si && gt(!1);
    };
    mge(an, it, dt, mi, Yo), Da(function() {
      mi();
    }, [wr, G]), Da(function() {
      an && !(H != null && H[G]) && mi();
    }, [JSON.stringify(K)]);
    var Bi = S.useMemo(function() {
      var Jt = dge(H, c, dn, ne);
      return _e(Jt, ie?.(dn));
    }, [dn, ie, H, c, ne]);
    S.useImperativeHandle(a, function() {
      return {
        nativeElement: ut.current,
        popupElement: mt.current,
        forceAlign: mi
      };
    });
    var hr = S.useState(0), zn = qe(hr, 2), On = zn[0], Qt = zn[1], nn = S.useState(0), er = qe(nn, 2), ia = er[0], so = er[1], hi = function() {
      if (te && it) {
        var nr = it.getBoundingClientRect();
        Qt(nr.width), so(nr.height);
      }
    }, ka = function() {
      hi(), mi();
    }, Ui = function(nr) {
      gn(!1), Un(), P?.(nr);
    }, sl = function() {
      return new Promise(function(nr) {
        hi(), Yt(function() {
          return nr;
        });
      });
    };
    Da(function() {
      Dt && (Un(), Dt(), Yt(null));
    }, [Dt]);
    function qt(Jt, nr, ao, wo) {
      ft[Jt] = function(Ea) {
        var Uf;
        wo?.(Ea), gt(nr, ao);
        for (var gd = arguments.length, Zh = new Array(gd > 1 ? gd - 1 : 0), cd = 1; cd < gd; cd++)
          Zh[cd - 1] = arguments[cd];
        (Uf = at[Jt]) === null || Uf === void 0 || Uf.call.apply(Uf, [at, Ea].concat(Zh));
      };
    }
    (Jr || si) && (ft.onClick = function(Jt) {
      var nr;
      xn.current && si ? gt(!1) : !xn.current && Jr && (qn(Jt), gt(!0));
      for (var ao = arguments.length, wo = new Array(ao > 1 ? ao - 1 : 0), Ea = 1; Ea < ao; Ea++)
        wo[Ea - 1] = arguments[Ea];
      (nr = at.onClick) === null || nr === void 0 || nr.call.apply(nr, [at, Jt].concat(wo));
    });
    var Kt = hge(an, si, it, dt, $, I, st, gt), ur = Wa.has("hover"), pr = pa.has("hover"), tr, Va;
    ur && (qt("onMouseEnter", !0, k, function(Jt) {
      qn(Jt);
    }), qt("onPointerEnter", !0, k, function(Jt) {
      qn(Jt);
    }), tr = function(nr) {
      (an || yn) && dt !== null && dt !== void 0 && dt.contains(nr.target) && gt(!0, k);
    }, ne && (ft.onMouseMove = function(Jt) {
      var nr;
      (nr = at.onMouseMove) === null || nr === void 0 || nr.call(at, Jt);
    })), pr && (qt("onMouseLeave", !1, T), qt("onPointerLeave", !1, T), Va = function() {
      gt(!1, T);
    }), Wa.has("focus") && qt("onFocus", !0, N), pa.has("focus") && qt("onBlur", !1, D), Wa.has("contextMenu") && (ft.onContextMenu = function(Jt) {
      var nr;
      xn.current && pa.has("contextMenu") ? gt(!1) : (qn(Jt), gt(!0)), Jt.preventDefault();
      for (var ao = arguments.length, wo = new Array(ao > 1 ? ao - 1 : 0), Ea = 1; Ea < ao; Ea++)
        wo[Ea - 1] = arguments[Ea];
      (nr = at.onContextMenu) === null || nr === void 0 || nr.call.apply(nr, [at, Jt].concat(wo));
    }), se && (ft.className = _e(at.className, se));
    var pi = S.useRef(!1);
    pi.current || (pi.current = F || an || yn);
    var Li = ce(ce({}, at), ft), yo = {}, ul = ["onContextMenu", "onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur"];
    ul.forEach(function(Jt) {
      we[Jt] && (yo[Jt] = function() {
        for (var nr, ao = arguments.length, wo = new Array(ao), Ea = 0; Ea < ao; Ea++)
          wo[Ea] = arguments[Ea];
        (nr = Li[Jt]) === null || nr === void 0 || nr.call.apply(nr, [Li].concat(wo)), we[Jt].apply(we, wo);
      });
    });
    var rc = /* @__PURE__ */ S.cloneElement(ot, ce(ce({}, Li), yo)), uu = {
      x: Jn,
      y: Nr
    }, lm = fe ? ce({}, fe !== !0 ? fe : {}) : null;
    return /* @__PURE__ */ S.createElement(S.Fragment, null, /* @__PURE__ */ S.createElement(hp, {
      disabled: !an,
      ref: ht,
      onResize: ka
    }, /* @__PURE__ */ S.createElement(nY, {
      getTriggerDOMNode: Ae
    }, rc)), pi.current && /* @__PURE__ */ S.createElement(CF.Provider, {
      value: je
    }, /* @__PURE__ */ S.createElement(tY, {
      portal: e,
      ref: Ot,
      prefixCls: c,
      popup: Q,
      className: _e(U, Bi),
      style: Y,
      target: it,
      onMouseEnter: tr,
      onMouseLeave: Va,
      onPointerEnter: tr,
      zIndex: X,
      open: an,
      keepDom: yn,
      fresh: ee,
      onClick: ae,
      onPointerDownCapture: Kt,
      mask: $,
      motion: pt,
      maskMotion: bt,
      onVisibleChanged: Ui,
      onPrepare: sl,
      forceRender: F,
      autoDestroy: Ne,
      getPopupContainer: L,
      align: dn,
      arrow: lm,
      arrowPos: uu,
      ready: en,
      offsetX: Xt,
      offsetY: zt,
      offsetR: kt,
      offsetB: Qn,
      onAlign: mi,
      stretch: te,
      targetWidth: On / Hr,
      targetHeight: ia / oa
    })));
  });
  return process.env.NODE_ENV !== "production" && (t.displayName = "Trigger"), t;
}
const e7 = gge(qE);
var vge = ["prefixCls", "disabled", "visible", "children", "popupElement", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "direction", "placement", "builtinPlacements", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "getPopupContainer", "empty", "getTriggerDOMNode", "onPopupVisibleChange", "onPopupMouseEnter"], bge = function(t) {
  var r = t === !0 ? 0 : 1;
  return {
    bottomLeft: {
      points: ["tl", "bl"],
      offset: [0, 4],
      overflow: {
        adjustX: r,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    bottomRight: {
      points: ["tr", "br"],
      offset: [0, 4],
      overflow: {
        adjustX: r,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    topLeft: {
      points: ["bl", "tl"],
      offset: [0, -4],
      overflow: {
        adjustX: r,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    topRight: {
      points: ["br", "tr"],
      offset: [0, -4],
      overflow: {
        adjustX: r,
        adjustY: 1
      },
      htmlRegion: "scroll"
    }
  };
}, yge = function(t, r) {
  var a = t.prefixCls;
  t.disabled;
  var i = t.visible, c = t.children, d = t.popupElement, f = t.animation, p = t.transitionName, g = t.dropdownStyle, b = t.dropdownClassName, w = t.direction, x = w === void 0 ? "ltr" : w, E = t.placement, P = t.builtinPlacements, k = t.dropdownMatchSelectWidth, M = t.dropdownRender, T = t.dropdownAlign, N = t.getPopupContainer, D = t.empty, $ = t.getTriggerDOMNode, j = t.onPopupVisibleChange, I = t.onPopupMouseEnter, L = xr(t, vge), F = "".concat(a, "-dropdown"), _ = d;
  M && (_ = M(d));
  var W = S.useMemo(function() {
    return P || bge(k);
  }, [P, k]), Q = f ? "".concat(F, "-").concat(f) : p, U = typeof k == "number", Y = S.useMemo(function() {
    return U ? null : k === !1 ? "minWidth" : "width";
  }, [k, U]), G = g;
  U && (G = ce(ce({}, G), {}, {
    width: k
  }));
  var J = S.useRef(null);
  return S.useImperativeHandle(r, function() {
    return {
      getPopupElement: function() {
        var K;
        return (K = J.current) === null || K === void 0 ? void 0 : K.popupElement;
      }
    };
  }), /* @__PURE__ */ S.createElement(e7, vt({}, L, {
    showAction: j ? ["click"] : [],
    hideAction: j ? ["click"] : [],
    popupPlacement: E || (x === "rtl" ? "bottomRight" : "bottomLeft"),
    builtinPlacements: W,
    prefixCls: F,
    popupTransitionName: Q,
    popup: /* @__PURE__ */ S.createElement("div", {
      onMouseEnter: I
    }, _),
    ref: J,
    stretch: Y,
    popupAlign: T,
    popupVisible: i,
    getPopupContainer: N,
    popupClassName: _e(b, ge({}, "".concat(F, "-empty"), D)),
    popupStyle: G,
    getTriggerDOMNode: $,
    onPopupVisibleChange: j
  }), c);
}, rY = /* @__PURE__ */ S.forwardRef(yge);
process.env.NODE_ENV !== "production" && (rY.displayName = "SelectTrigger");
function TF(e, t) {
  var r = e.key, a;
  return "value" in e && (a = e.value), r ?? (a !== void 0 ? a : "rc-index-key-".concat(t));
}
function TD(e) {
  return typeof e < "u" && !Number.isNaN(e);
}
function aY(e, t) {
  var r = e || {}, a = r.label, i = r.value, c = r.options, d = r.groupLabel, f = a || (t ? "children" : "label");
  return {
    label: f,
    value: i || "value",
    options: c || "options",
    groupLabel: d || f
  };
}
function wge(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.fieldNames, a = t.childrenAsData, i = [], c = aY(r, !1), d = c.label, f = c.value, p = c.options, g = c.groupLabel;
  function b(w, x) {
    Array.isArray(w) && w.forEach(function(E) {
      if (x || !(p in E)) {
        var P = E[f];
        i.push({
          key: TF(E, i.length),
          groupOption: x,
          data: E,
          label: E[d],
          value: P
        });
      } else {
        var k = E[g];
        k === void 0 && a && (k = E.label), i.push({
          key: TF(E, i.length),
          group: !0,
          data: E,
          label: k
        }), b(E[p], !0);
      }
    });
  }
  return b(e, !1), i;
}
function RD(e) {
  var t = ce({}, e);
  return "props" in t || Object.defineProperty(t, "props", {
    get: function() {
      return $n(!1, "Return type is option instead of Option instance. Please read value directly instead of reading from `props`."), t;
    }
  }), t;
}
var Sge = function(t, r, a) {
  if (!r || !r.length)
    return null;
  var i = !1, c = function f(p, g) {
    var b = oq(g), w = b[0], x = b.slice(1);
    if (!w)
      return [p];
    var E = p.split(w);
    return i = i || E.length > 1, E.reduce(function(P, k) {
      return [].concat(Et(P), Et(f(k, x)));
    }, []).filter(Boolean);
  }, d = c(t, r);
  return i ? typeof a < "u" ? d.slice(0, a) : d : null;
}, Kz = /* @__PURE__ */ S.createContext(null);
function Cge(e) {
  var t = e.visible, r = e.values;
  if (!t)
    return null;
  var a = 50;
  return /* @__PURE__ */ S.createElement("span", {
    "aria-live": "polite",
    style: {
      width: 0,
      height: 0,
      position: "absolute",
      overflow: "hidden",
      opacity: 0
    }
  }, "".concat(r.slice(0, a).map(function(i) {
    var c = i.label, d = i.value;
    return ["number", "string"].includes(Hn(c)) ? c : d;
  }).join(", ")), r.length > a ? ", ..." : null);
}
var xge = ["id", "prefixCls", "className", "showSearch", "tagRender", "direction", "omitDomProps", "displayValues", "onDisplayValuesChange", "emptyOptions", "notFoundContent", "onClear", "mode", "disabled", "loading", "getInputElement", "getRawInputElement", "open", "defaultOpen", "onDropdownVisibleChange", "activeValue", "onActiveValueChange", "activeDescendantId", "searchValue", "autoClearSearchValue", "onSearch", "onSearchSplit", "tokenSeparators", "allowClear", "prefix", "suffixIcon", "clearIcon", "OptionList", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "placement", "builtinPlacements", "getPopupContainer", "showAction", "onFocus", "onBlur", "onKeyUp", "onKeyDown", "onMouseDown"], Ege = ["value", "onChange", "removeIcon", "placeholder", "autoFocus", "maxTagCount", "maxTagTextLength", "maxTagPlaceholder", "choiceTransitionName", "onInputKeyDown", "onPopupScroll", "tabIndex"], Xk = function(t) {
  return t === "tags" || t === "multiple";
}, oY = /* @__PURE__ */ S.forwardRef(function(e, t) {
  var r, a = e.id, i = e.prefixCls, c = e.className, d = e.showSearch, f = e.tagRender, p = e.direction, g = e.omitDomProps, b = e.displayValues, w = e.onDisplayValuesChange, x = e.emptyOptions, E = e.notFoundContent, P = E === void 0 ? "Not Found" : E, k = e.onClear, M = e.mode, T = e.disabled, N = e.loading, D = e.getInputElement, $ = e.getRawInputElement, j = e.open, I = e.defaultOpen, L = e.onDropdownVisibleChange, F = e.activeValue, _ = e.onActiveValueChange, W = e.activeDescendantId, Q = e.searchValue, U = e.autoClearSearchValue, Y = e.onSearch, G = e.onSearchSplit, J = e.tokenSeparators, H = e.allowClear, K = e.prefix, X = e.suffixIcon, te = e.clearIcon, ie = e.OptionList, ee = e.animation, ne = e.transitionName, ae = e.dropdownStyle, oe = e.dropdownClassName, fe = e.dropdownMatchSelectWidth, be = e.dropdownRender, me = e.dropdownAlign, De = e.placement, Me = e.builtinPlacements, ze = e.getPopupContainer, le = e.showAction, se = le === void 0 ? [] : le, Ae = e.onFocus, we = e.onBlur, Ne = e.onKeyUp, pe = e.onKeyDown, Qe = e.onMouseDown, Le = xr(e, xge), Te = Xk(M), Oe = (d !== void 0 ? d : Te) || M === "combobox", ye = ce({}, Le);
  Ege.forEach(function(hr) {
    delete ye[hr];
  }), g?.forEach(function(hr) {
    delete ye[hr];
  });
  var je = S.useState(!1), Ue = qe(je, 2), Fe = Ue[0], tt = Ue[1];
  S.useEffect(function() {
    tt(XK());
  }, []);
  var dt = S.useRef(null), St = S.useRef(null), mt = S.useRef(null), Ot = S.useRef(null), Rt = S.useRef(null), ct = S.useRef(!1), it = zpe(), Ct = qe(it, 3), ut = Ct[0], ht = Ct[1], ot = Ct[2];
  S.useImperativeHandle(t, function() {
    var hr, zn;
    return {
      focus: (hr = Ot.current) === null || hr === void 0 ? void 0 : hr.focus,
      blur: (zn = Ot.current) === null || zn === void 0 ? void 0 : zn.blur,
      scrollTo: function(Qt) {
        var nn;
        return (nn = Rt.current) === null || nn === void 0 ? void 0 : nn.scrollTo(Qt);
      },
      nativeElement: dt.current || St.current
    };
  });
  var at = S.useMemo(function() {
    var hr;
    if (M !== "combobox")
      return Q;
    var zn = (hr = b[0]) === null || hr === void 0 ? void 0 : hr.value;
    return typeof zn == "string" || typeof zn == "number" ? String(zn) : "";
  }, [Q, M, b]), ft = M === "combobox" && typeof D == "function" && D() || null, st = typeof $ == "function" && $(), pt = gS(St, st == null || (r = st.props) === null || r === void 0 ? void 0 : r.ref), bt = S.useState(!1), Nt = qe(bt, 2), $t = Nt[0], Pt = Nt[1];
  Da(function() {
    Pt(!0);
  }, []);
  var hn = ll(!1, {
    defaultValue: I,
    value: j
  }), an = qe(hn, 2), jn = an[0], xn = an[1], Ut = $t ? jn : !1, pn = !P && x;
  (T || pn && Ut && M === "combobox") && (Ut = !1);
  var wn = pn ? !1 : Ut, Lt = S.useCallback(function(hr) {
    var zn = hr !== void 0 ? hr : !Ut;
    T || (xn(zn), Ut !== zn && L?.(zn));
  }, [T, Ut, xn, L]), gt = S.useMemo(function() {
    return (J || []).some(function(hr) {
      return [`
`, `\r
`].includes(hr);
    });
  }, [J]), wt = S.useContext(Kz) || {}, Ft = wt.maxCount, yn = wt.rawValues, gn = function(zn, On, Qt) {
    if (!(Te && TD(Ft) && yn?.size >= Ft)) {
      var nn = !0, er = zn;
      _?.(null);
      var ia = Sge(zn, J, TD(Ft) ? Ft - yn.size : void 0), so = Qt ? null : ia;
      return M !== "combobox" && so && (er = "", G?.(so), Lt(!1), nn = !1), Y && at !== er && Y(er, {
        source: On ? "typing" : "effect"
      }), nn;
    }
  }, Tn = function(zn) {
    !zn || !zn.trim() || Y(zn, {
      source: "submit"
    });
  };
  S.useEffect(function() {
    !Ut && !Te && M !== "combobox" && gn("", !1, !1);
  }, [Ut]), S.useEffect(function() {
    jn && T && xn(!1), T && !ct.current && ht(!1);
  }, [T]);
  var Gt = qK(), Dt = qe(Gt, 2), Yt = Dt[0], Mn = Dt[1], Gn = S.useRef(!1), wr = function(zn) {
    var On = Yt(), Qt = zn.key, nn = Qt === "Enter";
    if (nn && (M !== "combobox" && zn.preventDefault(), Ut || Lt(!0)), Mn(!!at), Qt === "Backspace" && !On && Te && !at && b.length) {
      for (var er = Et(b), ia = null, so = er.length - 1; so >= 0; so -= 1) {
        var hi = er[so];
        if (!hi.disabled) {
          er.splice(so, 1), ia = hi;
          break;
        }
      }
      ia && w(er, {
        type: "remove",
        values: [ia]
      });
    }
    for (var ka = arguments.length, Ui = new Array(ka > 1 ? ka - 1 : 0), sl = 1; sl < ka; sl++)
      Ui[sl - 1] = arguments[sl];
    if (Ut && (!nn || !Gn.current)) {
      var qt;
      nn && (Gn.current = !0), (qt = Rt.current) === null || qt === void 0 || qt.onKeyDown.apply(qt, [zn].concat(Ui));
    }
    pe?.apply(void 0, [zn].concat(Ui));
  }, aa = function(zn) {
    for (var On = arguments.length, Qt = new Array(On > 1 ? On - 1 : 0), nn = 1; nn < On; nn++)
      Qt[nn - 1] = arguments[nn];
    if (Ut) {
      var er;
      (er = Rt.current) === null || er === void 0 || er.onKeyUp.apply(er, [zn].concat(Qt));
    }
    zn.key === "Enter" && (Gn.current = !1), Ne?.apply(void 0, [zn].concat(Qt));
  }, qn = function(zn) {
    var On = b.filter(function(Qt) {
      return Qt !== zn;
    });
    w(On, {
      type: "remove",
      values: [zn]
    });
  }, Rr = function() {
    Gn.current = !1;
  }, Wt = S.useRef(!1), en = function() {
    ht(!0), T || (Ae && !Wt.current && Ae.apply(void 0, arguments), se.includes("focus") && Lt(!0)), Wt.current = !0;
  }, Xt = function() {
    ct.current = !0, ht(!1, function() {
      Wt.current = !1, ct.current = !1, Lt(!1);
    }), !T && (at && (M === "tags" ? Y(at, {
      source: "submit"
    }) : M === "multiple" && Y("", {
      source: "blur"
    })), we && we.apply(void 0, arguments));
  }, zt = [];
  S.useEffect(function() {
    return function() {
      zt.forEach(function(hr) {
        return clearTimeout(hr);
      }), zt.splice(0, zt.length);
    };
  }, []);
  var kt = function(zn) {
    var On, Qt = zn.target, nn = (On = mt.current) === null || On === void 0 ? void 0 : On.getPopupElement();
    if (nn && nn.contains(Qt)) {
      var er = setTimeout(function() {
        var ka = zt.indexOf(er);
        if (ka !== -1 && zt.splice(ka, 1), ot(), !Fe && !nn.contains(document.activeElement)) {
          var Ui;
          (Ui = Ot.current) === null || Ui === void 0 || Ui.focus();
        }
      });
      zt.push(er);
    }
    for (var ia = arguments.length, so = new Array(ia > 1 ? ia - 1 : 0), hi = 1; hi < ia; hi++)
      so[hi - 1] = arguments[hi];
    Qe?.apply(void 0, [zn].concat(so));
  }, Qn = S.useState({}), Jn = qe(Qn, 2), Nr = Jn[1];
  function Hr() {
    Nr({});
  }
  var oa;
  st && (oa = function(zn) {
    Lt(zn);
  }), jpe(function() {
    var hr;
    return [dt.current, (hr = mt.current) === null || hr === void 0 ? void 0 : hr.getPopupElement()];
  }, wn, Lt, !!st);
  var dn = S.useMemo(function() {
    return ce(ce({}, e), {}, {
      notFoundContent: P,
      open: Ut,
      triggerOpen: wn,
      id: a,
      showSearch: Oe,
      multiple: Te,
      toggleOpen: Lt
    });
  }, [e, P, wn, Ut, a, Oe, Te, Lt]), Un = !!X || N, sr;
  Un && (sr = /* @__PURE__ */ S.createElement(Z9, {
    className: _e("".concat(i, "-arrow"), ge({}, "".concat(i, "-arrow-loading"), N)),
    customizeIcon: X,
    customizeIconProps: {
      loading: N,
      searchValue: at,
      open: Ut,
      focused: ut,
      showSearch: Oe
    }
  }));
  var Yr = function() {
    var zn;
    k?.(), (zn = Ot.current) === null || zn === void 0 || zn.focus(), w([], {
      type: "clear",
      values: b
    }), gn("", !1, !1);
  }, Wa = Dpe(i, Yr, b, H, te, T, at, M), pa = Wa.allowClear, Jr = Wa.clearIcon, si = /* @__PURE__ */ S.createElement(ie, {
    ref: Rt
  }), mi = _e(i, c, ge(ge(ge(ge(ge(ge(ge(ge(ge(ge({}, "".concat(i, "-focused"), ut), "".concat(i, "-multiple"), Te), "".concat(i, "-single"), !Te), "".concat(i, "-allow-clear"), H), "".concat(i, "-show-arrow"), Un), "".concat(i, "-disabled"), T), "".concat(i, "-loading"), N), "".concat(i, "-open"), Ut), "".concat(i, "-customize-input"), ft), "".concat(i, "-show-search"), Oe)), Yo = /* @__PURE__ */ S.createElement(rY, {
    ref: mt,
    disabled: T,
    prefixCls: i,
    visible: wn,
    popupElement: si,
    animation: ee,
    transitionName: ne,
    dropdownStyle: ae,
    dropdownClassName: oe,
    direction: p,
    dropdownMatchSelectWidth: fe,
    dropdownRender: be,
    dropdownAlign: me,
    placement: De,
    builtinPlacements: Me,
    getPopupContainer: ze,
    empty: x,
    getTriggerDOMNode: function(zn) {
      return (
        // TODO: This is workaround and should be removed in `rc-select`
        // And use new standard `nativeElement` for ref.
        // But we should update `rc-resize-observer` first.
        St.current || zn
      );
    },
    onPopupVisibleChange: oa,
    onPopupMouseEnter: Hr
  }, st ? /* @__PURE__ */ S.cloneElement(st, {
    ref: pt
  }) : /* @__PURE__ */ S.createElement(ZK, vt({}, e, {
    domRef: St,
    prefixCls: i,
    inputElement: ft,
    ref: Ot,
    id: a,
    prefix: K,
    showSearch: Oe,
    autoClearSearchValue: U,
    mode: M,
    activeDescendantId: W,
    tagRender: f,
    values: b,
    open: Ut,
    onToggleOpen: Lt,
    activeValue: F,
    searchValue: at,
    onSearch: gn,
    onSearchSubmit: Tn,
    onRemove: qn,
    tokenWithEnter: gt,
    onInputBlur: Rr
  }))), Bi;
  return st ? Bi = Yo : Bi = /* @__PURE__ */ S.createElement("div", vt({
    className: mi
  }, ye, {
    ref: dt,
    onMouseDown: kt,
    onKeyDown: wr,
    onKeyUp: aa,
    onFocus: en,
    onBlur: Xt
  }), /* @__PURE__ */ S.createElement(Cge, {
    visible: ut && !Ut,
    values: b
  }), Yo, sr, pa && Jr), /* @__PURE__ */ S.createElement(GK.Provider, {
    value: dn
  }, Bi);
});
process.env.NODE_ENV !== "production" && (oY.displayName = "BaseSelect");
var Yz = function() {
  return null;
};
Yz.isSelectOptGroup = !0;
var Qz = function() {
  return null;
};
Qz.isSelectOption = !0;
var iY = /* @__PURE__ */ S.forwardRef(function(e, t) {
  var r = e.height, a = e.offsetY, i = e.offsetX, c = e.children, d = e.prefixCls, f = e.onInnerResize, p = e.innerProps, g = e.rtl, b = e.extra, w = {}, x = {
    display: "flex",
    flexDirection: "column"
  };
  return a !== void 0 && (w = {
    height: r,
    position: "relative",
    overflow: "hidden"
  }, x = ce(ce({}, x), {}, ge(ge(ge(ge(ge({
    transform: "translateY(".concat(a, "px)")
  }, g ? "marginRight" : "marginLeft", -i), "position", "absolute"), "left", 0), "right", 0), "top", 0))), /* @__PURE__ */ S.createElement("div", {
    style: w
  }, /* @__PURE__ */ S.createElement(hp, {
    onResize: function(P) {
      var k = P.offsetHeight;
      k && f && f();
    }
  }, /* @__PURE__ */ S.createElement("div", vt({
    style: x,
    className: _e(ge({}, "".concat(d, "-holder-inner"), d)),
    ref: t
  }, p), c, b)));
});
iY.displayName = "Filler";
function Pge(e) {
  var t = e.children, r = e.setRef, a = S.useCallback(function(i) {
    r(i);
  }, []);
  return /* @__PURE__ */ S.cloneElement(t, {
    ref: a
  });
}
function kge(e, t, r, a, i, c, d, f) {
  var p = f.getKey;
  return e.slice(t, r + 1).map(function(g, b) {
    var w = t + b, x = d(g, w, {
      style: {
        width: a
      },
      offsetX: i
    }), E = p(g);
    return /* @__PURE__ */ S.createElement(Pge, {
      key: E,
      setRef: function(k) {
        return c(g, k);
      }
    }, x);
  });
}
function Mge(e, t, r) {
  var a = e.length, i = t.length, c, d;
  if (a === 0 && i === 0)
    return null;
  a < i ? (c = e, d = t) : (c = t, d = e);
  var f = {
    __EMPTY_ITEM__: !0
  };
  function p(P) {
    return P !== void 0 ? r(P) : f;
  }
  for (var g = null, b = Math.abs(a - i) !== 1, w = 0; w < d.length; w += 1) {
    var x = p(c[w]), E = p(d[w]);
    if (x !== E) {
      g = w, b = b || x !== p(d[w + 1]);
      break;
    }
  }
  return g === null ? null : {
    index: g,
    multiple: b
  };
}
function Oge(e, t, r) {
  var a = S.useState(e), i = qe(a, 2), c = i[0], d = i[1], f = S.useState(null), p = qe(f, 2), g = p[0], b = p[1];
  return S.useEffect(function() {
    var w = Mge(c || [], e || [], t);
    w?.index !== void 0 && b(e[w.index]), d(e);
  }, [e]), [g];
}
var RF = (typeof navigator > "u" ? "undefined" : Hn(navigator)) === "object" && /Firefox/i.test(navigator.userAgent);
const lY = (function(e, t, r, a) {
  var i = It(!1), c = It(null);
  function d() {
    clearTimeout(c.current), i.current = !0, c.current = setTimeout(function() {
      i.current = !1;
    }, 50);
  }
  var f = It({
    top: e,
    bottom: t,
    left: r,
    right: a
  });
  return f.current.top = e, f.current.bottom = t, f.current.left = r, f.current.right = a, function(p, g) {
    var b = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, w = p ? (
      // Pass origin wheel when on the left
      g < 0 && f.current.left || // Pass origin wheel when on the right
      g > 0 && f.current.right
    ) : g < 0 && f.current.top || // Pass origin wheel when on the bottom
    g > 0 && f.current.bottom;
    return b && w ? (clearTimeout(c.current), i.current = !1) : (!w || i.current) && d(), !i.current && w;
  };
});
function Tge(e, t, r, a, i, c, d) {
  var f = It(0), p = It(null), g = It(null), b = It(!1), w = lY(t, r, a, i);
  function x(N, D) {
    if (Pa.cancel(p.current), !w(!1, D)) {
      var $ = N;
      if (!$._virtualHandled)
        $._virtualHandled = !0;
      else
        return;
      f.current += D, g.current = D, RF || $.preventDefault(), p.current = Pa(function() {
        var j = b.current ? 10 : 1;
        d(f.current * j, !1), f.current = 0;
      });
    }
  }
  function E(N, D) {
    d(D, !0), RF || N.preventDefault();
  }
  var P = It(null), k = It(null);
  function M(N) {
    if (e) {
      Pa.cancel(k.current), k.current = Pa(function() {
        P.current = null;
      }, 2);
      var D = N.deltaX, $ = N.deltaY, j = N.shiftKey, I = D, L = $;
      (P.current === "sx" || !P.current && j && $ && !D) && (I = $, L = 0, P.current = "sx");
      var F = Math.abs(I), _ = Math.abs(L);
      P.current === null && (P.current = c && F > _ ? "x" : "y"), P.current === "y" ? x(N, L) : E(N, I);
    }
  }
  function T(N) {
    e && (b.current = N.detail === g.current);
  }
  return [M, T];
}
function Rge(e, t, r, a) {
  var i = S.useMemo(function() {
    return [/* @__PURE__ */ new Map(), []];
  }, [e, r.id, a]), c = qe(i, 2), d = c[0], f = c[1], p = function(b) {
    var w = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : b, x = d.get(b), E = d.get(w);
    if (x === void 0 || E === void 0)
      for (var P = e.length, k = f.length; k < P; k += 1) {
        var M, T = e[k], N = t(T);
        d.set(N, k);
        var D = (M = r.get(N)) !== null && M !== void 0 ? M : a;
        if (f[k] = (f[k - 1] || 0) + D, N === b && (x = k), N === w && (E = k), x !== void 0 && E !== void 0)
          break;
      }
    return {
      top: f[x - 1] || 0,
      bottom: f[E]
    };
  };
  return p;
}
var Age = /* @__PURE__ */ (function() {
  function e() {
    Vi(this, e), ge(this, "maps", void 0), ge(this, "id", 0), ge(this, "diffRecords", /* @__PURE__ */ new Map()), this.maps = /* @__PURE__ */ Object.create(null);
  }
  return _i(e, [{
    key: "set",
    value: function(r, a) {
      this.diffRecords.set(r, this.maps[r]), this.maps[r] = a, this.id += 1;
    }
  }, {
    key: "get",
    value: function(r) {
      return this.maps[r];
    }
    /**
     * CacheMap will record the key changed.
     * To help to know what's update in the next render.
     */
  }, {
    key: "resetRecord",
    value: function() {
      this.diffRecords.clear();
    }
  }, {
    key: "getRecord",
    value: function() {
      return this.diffRecords;
    }
  }]), e;
})();
function AF(e) {
  var t = parseFloat(e);
  return isNaN(t) ? 0 : t;
}
function Nge(e, t, r) {
  var a = S.useState(0), i = qe(a, 2), c = i[0], d = i[1], f = It(/* @__PURE__ */ new Map()), p = It(new Age()), g = It(0);
  function b() {
    g.current += 1;
  }
  function w() {
    var E = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    b();
    var P = function() {
      var T = !1;
      f.current.forEach(function(N, D) {
        if (N && N.offsetParent) {
          var $ = N.offsetHeight, j = getComputedStyle(N), I = j.marginTop, L = j.marginBottom, F = AF(I), _ = AF(L), W = $ + F + _;
          p.current.get(D) !== W && (p.current.set(D, W), T = !0);
        }
      }), T && d(function(N) {
        return N + 1;
      });
    };
    if (E)
      P();
    else {
      g.current += 1;
      var k = g.current;
      Promise.resolve().then(function() {
        k === g.current && P();
      });
    }
  }
  function x(E, P) {
    var k = e(E);
    f.current.get(k), P ? (f.current.set(k, P), w()) : f.current.delete(k);
  }
  return Er(function() {
    return b;
  }, []), [x, w, p.current, c];
}
var NF = 14 / 15;
function Dge(e, t, r) {
  var a = It(!1), i = It(0), c = It(0), d = It(null), f = It(null), p, g = function(E) {
    if (a.current) {
      var P = Math.ceil(E.touches[0].pageX), k = Math.ceil(E.touches[0].pageY), M = i.current - P, T = c.current - k, N = Math.abs(M) > Math.abs(T);
      N ? i.current = P : c.current = k;
      var D = r(N, N ? M : T, !1, E);
      D && E.preventDefault(), clearInterval(f.current), D && (f.current = setInterval(function() {
        N ? M *= NF : T *= NF;
        var $ = Math.floor(N ? M : T);
        (!r(N, $, !0) || Math.abs($) <= 0.1) && clearInterval(f.current);
      }, 16));
    }
  }, b = function() {
    a.current = !1, p();
  }, w = function(E) {
    p(), E.touches.length === 1 && !a.current && (a.current = !0, i.current = Math.ceil(E.touches[0].pageX), c.current = Math.ceil(E.touches[0].pageY), d.current = E.target, d.current.addEventListener("touchmove", g, {
      passive: !1
    }), d.current.addEventListener("touchend", b, {
      passive: !0
    }));
  };
  p = function() {
    d.current && (d.current.removeEventListener("touchmove", g), d.current.removeEventListener("touchend", b));
  }, Da(function() {
    return e && t.current.addEventListener("touchstart", w, {
      passive: !0
    }), function() {
      var x;
      (x = t.current) === null || x === void 0 || x.removeEventListener("touchstart", w), p(), clearInterval(f.current);
    };
  }, [e]);
}
function DF(e) {
  return Math.floor(Math.pow(e, 0.5));
}
function AD(e, t) {
  var r = "touches" in e ? e.touches[0] : e;
  return r[t ? "pageX" : "pageY"] - window[t ? "scrollX" : "scrollY"];
}
function $ge(e, t, r) {
  S.useEffect(function() {
    var a = t.current;
    if (e && a) {
      var i = !1, c, d, f = function() {
        Pa.cancel(c);
      }, p = function x() {
        f(), c = Pa(function() {
          r(d), x();
        });
      }, g = function() {
        i = !1, f();
      }, b = function(E) {
        if (!(E.target.draggable || E.button !== 0)) {
          var P = E;
          P._virtualHandled || (P._virtualHandled = !0, i = !0);
        }
      }, w = function(E) {
        if (i) {
          var P = AD(E, !1), k = a.getBoundingClientRect(), M = k.top, T = k.bottom;
          if (P <= M) {
            var N = M - P;
            d = -DF(N), p();
          } else if (P >= T) {
            var D = P - T;
            d = DF(D), p();
          } else
            f();
        }
      };
      return a.addEventListener("mousedown", b), a.ownerDocument.addEventListener("mouseup", g), a.ownerDocument.addEventListener("mousemove", w), a.ownerDocument.addEventListener("dragend", g), function() {
        a.removeEventListener("mousedown", b), a.ownerDocument.removeEventListener("mouseup", g), a.ownerDocument.removeEventListener("mousemove", w), a.ownerDocument.removeEventListener("dragend", g), f();
      };
    }
  }, [e]);
}
var $F = 10;
function zge(e, t, r, a, i, c, d, f) {
  var p = S.useRef(), g = S.useState(null), b = qe(g, 2), w = b[0], x = b[1];
  return Da(function() {
    if (w && w.times < $F) {
      if (!e.current) {
        x(function(te) {
          return ce({}, te);
        });
        return;
      }
      c();
      var E = w.targetAlign, P = w.originAlign, k = w.index, M = w.offset, T = e.current.clientHeight, N = !1, D = E, $ = null;
      if (T) {
        for (var j = E || P, I = 0, L = 0, F = 0, _ = Math.min(t.length - 1, k), W = 0; W <= _; W += 1) {
          var Q = i(t[W]);
          L = I;
          var U = r.get(Q);
          F = L + (U === void 0 ? a : U), I = F;
        }
        for (var Y = j === "top" ? M : T - M, G = _; G >= 0; G -= 1) {
          var J = i(t[G]), H = r.get(J);
          if (H === void 0) {
            N = !0;
            break;
          }
          if (Y -= H, Y <= 0)
            break;
        }
        switch (j) {
          case "top":
            $ = L - M;
            break;
          case "bottom":
            $ = F - T + M;
            break;
          default: {
            var K = e.current.scrollTop, X = K + T;
            L < K ? D = "top" : F > X && (D = "bottom");
          }
        }
        $ !== null && d($), $ !== w.lastTop && (N = !0);
      }
      N && x(ce(ce({}, w), {}, {
        times: w.times + 1,
        targetAlign: D,
        lastTop: $
      }));
    } else process.env.NODE_ENV !== "production" && w?.times === $F && $n(!1, "Seems `scrollTo` with `rc-virtual-list` reach the max limitation. Please fire issue for us. Thanks.");
  }, [w, e.current]), function(E) {
    if (E == null) {
      f();
      return;
    }
    if (Pa.cancel(p.current), typeof E == "number")
      d(E);
    else if (E && Hn(E) === "object") {
      var P, k = E.align;
      "index" in E ? P = E.index : P = t.findIndex(function(N) {
        return i(N) === E.key;
      });
      var M = E.offset, T = M === void 0 ? 0 : M;
      x({
        times: 0,
        index: P,
        offset: T,
        originAlign: k
      });
    }
  };
}
var ND = /* @__PURE__ */ S.forwardRef(function(e, t) {
  var r = e.prefixCls, a = e.rtl, i = e.scrollOffset, c = e.scrollRange, d = e.onStartMove, f = e.onStopMove, p = e.onScroll, g = e.horizontal, b = e.spinSize, w = e.containerSize, x = e.style, E = e.thumbStyle, P = e.showScrollBar, k = S.useState(!1), M = qe(k, 2), T = M[0], N = M[1], D = S.useState(null), $ = qe(D, 2), j = $[0], I = $[1], L = S.useState(null), F = qe(L, 2), _ = F[0], W = F[1], Q = !a, U = S.useRef(), Y = S.useRef(), G = S.useState(P), J = qe(G, 2), H = J[0], K = J[1], X = S.useRef(), te = function() {
    P === !0 || P === !1 || (clearTimeout(X.current), K(!0), X.current = setTimeout(function() {
      K(!1);
    }, 3e3));
  }, ie = c - w || 0, ee = w - b || 0, ne = S.useMemo(function() {
    if (i === 0 || ie === 0)
      return 0;
    var le = i / ie;
    return le * ee;
  }, [i, ie, ee]), ae = function(se) {
    se.stopPropagation(), se.preventDefault();
  }, oe = S.useRef({
    top: ne,
    dragging: T,
    pageY: j,
    startTop: _
  });
  oe.current = {
    top: ne,
    dragging: T,
    pageY: j,
    startTop: _
  };
  var fe = function(se) {
    N(!0), I(AD(se, g)), W(oe.current.top), d(), se.stopPropagation(), se.preventDefault();
  };
  S.useEffect(function() {
    var le = function(Ne) {
      Ne.preventDefault();
    }, se = U.current, Ae = Y.current;
    return se.addEventListener("touchstart", le, {
      passive: !1
    }), Ae.addEventListener("touchstart", fe, {
      passive: !1
    }), function() {
      se.removeEventListener("touchstart", le), Ae.removeEventListener("touchstart", fe);
    };
  }, []);
  var be = S.useRef();
  be.current = ie;
  var me = S.useRef();
  me.current = ee, S.useEffect(function() {
    if (T) {
      var le, se = function(Ne) {
        var pe = oe.current, Qe = pe.dragging, Le = pe.pageY, Te = pe.startTop;
        Pa.cancel(le);
        var Oe = U.current.getBoundingClientRect(), ye = w / (g ? Oe.width : Oe.height);
        if (Qe) {
          var je = (AD(Ne, g) - Le) * ye, Ue = Te;
          !Q && g ? Ue -= je : Ue += je;
          var Fe = be.current, tt = me.current, dt = tt ? Ue / tt : 0, St = Math.ceil(dt * Fe);
          St = Math.max(St, 0), St = Math.min(St, Fe), le = Pa(function() {
            p(St, g);
          });
        }
      }, Ae = function() {
        N(!1), f();
      };
      return window.addEventListener("mousemove", se, {
        passive: !0
      }), window.addEventListener("touchmove", se, {
        passive: !0
      }), window.addEventListener("mouseup", Ae, {
        passive: !0
      }), window.addEventListener("touchend", Ae, {
        passive: !0
      }), function() {
        window.removeEventListener("mousemove", se), window.removeEventListener("touchmove", se), window.removeEventListener("mouseup", Ae), window.removeEventListener("touchend", Ae), Pa.cancel(le);
      };
    }
  }, [T]), S.useEffect(function() {
    return te(), function() {
      clearTimeout(X.current);
    };
  }, [i]), S.useImperativeHandle(t, function() {
    return {
      delayHidden: te
    };
  });
  var De = "".concat(r, "-scrollbar"), Me = {
    position: "absolute",
    visibility: H ? null : "hidden"
  }, ze = {
    position: "absolute",
    borderRadius: 99,
    background: "var(--rc-virtual-list-scrollbar-bg, rgba(0, 0, 0, 0.5))",
    cursor: "pointer",
    userSelect: "none"
  };
  return g ? (Object.assign(Me, {
    height: 8,
    left: 0,
    right: 0,
    bottom: 0
  }), Object.assign(ze, ge({
    height: "100%",
    width: b
  }, Q ? "left" : "right", ne))) : (Object.assign(Me, ge({
    width: 8,
    top: 0,
    bottom: 0
  }, Q ? "right" : "left", 0)), Object.assign(ze, {
    width: "100%",
    height: b,
    top: ne
  })), /* @__PURE__ */ S.createElement("div", {
    ref: U,
    className: _e(De, ge(ge(ge({}, "".concat(De, "-horizontal"), g), "".concat(De, "-vertical"), !g), "".concat(De, "-visible"), H)),
    style: ce(ce({}, Me), x),
    onMouseDown: ae,
    onMouseMove: te
  }, /* @__PURE__ */ S.createElement("div", {
    ref: Y,
    className: _e("".concat(De, "-thumb"), ge({}, "".concat(De, "-thumb-moving"), T)),
    style: ce(ce({}, ze), E),
    onMouseDown: fe
  }));
});
process.env.NODE_ENV !== "production" && (ND.displayName = "ScrollBar");
var jge = 20;
function zF() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = e / t * e;
  return isNaN(r) && (r = 0), r = Math.max(r, jge), Math.floor(r);
}
var Ige = ["prefixCls", "className", "height", "itemHeight", "fullHeight", "style", "data", "children", "itemKey", "virtual", "direction", "scrollWidth", "component", "onScroll", "onVirtualScroll", "onVisibleChange", "innerProps", "extraRender", "styles", "showScrollBar"], Lge = [], Hge = {
  overflowY: "auto",
  overflowAnchor: "none"
};
function Fge(e, t) {
  var r = e.prefixCls, a = r === void 0 ? "rc-virtual-list" : r, i = e.className, c = e.height, d = e.itemHeight, f = e.fullHeight, p = f === void 0 ? !0 : f, g = e.style, b = e.data, w = e.children, x = e.itemKey, E = e.virtual, P = e.direction, k = e.scrollWidth, M = e.component, T = M === void 0 ? "div" : M, N = e.onScroll, D = e.onVirtualScroll, $ = e.onVisibleChange, j = e.innerProps, I = e.extraRender, L = e.styles, F = e.showScrollBar, _ = F === void 0 ? "optional" : F, W = xr(e, Ige), Q = S.useCallback(function(Wt) {
    return typeof x == "function" ? x(Wt) : Wt?.[x];
  }, [x]), U = Nge(Q), Y = qe(U, 4), G = Y[0], J = Y[1], H = Y[2], K = Y[3], X = !!(E !== !1 && c && d), te = S.useMemo(function() {
    return Object.values(H.maps).reduce(function(Wt, en) {
      return Wt + en;
    }, 0);
  }, [H.id, H.maps]), ie = X && b && (Math.max(d * b.length, te) > c || !!k), ee = P === "rtl", ne = _e(a, ge({}, "".concat(a, "-rtl"), ee), i), ae = b || Lge, oe = It(), fe = It(), be = It(), me = Wn(0), De = qe(me, 2), Me = De[0], ze = De[1], le = Wn(0), se = qe(le, 2), Ae = se[0], we = se[1], Ne = Wn(!1), pe = qe(Ne, 2), Qe = pe[0], Le = pe[1], Te = function() {
    Le(!0);
  }, Oe = function() {
    Le(!1);
  }, ye = {
    getKey: Q
  };
  function je(Wt) {
    ze(function(en) {
      var Xt;
      typeof Wt == "function" ? Xt = Wt(en) : Xt = Wt;
      var zt = Pt(Xt);
      return oe.current.scrollTop = zt, zt;
    });
  }
  var Ue = It({
    start: 0,
    end: ae.length
  }), Fe = It(), tt = Oge(ae, Q), dt = qe(tt, 1), St = dt[0];
  Fe.current = St;
  var mt = S.useMemo(function() {
    if (!X)
      return {
        scrollHeight: void 0,
        start: 0,
        end: ae.length - 1,
        offset: void 0
      };
    if (!ie) {
      var Wt;
      return {
        scrollHeight: ((Wt = fe.current) === null || Wt === void 0 ? void 0 : Wt.offsetHeight) || 0,
        start: 0,
        end: ae.length - 1,
        offset: void 0
      };
    }
    for (var en = 0, Xt, zt, kt, Qn = ae.length, Jn = 0; Jn < Qn; Jn += 1) {
      var Nr = ae[Jn], Hr = Q(Nr), oa = H.get(Hr), dn = en + (oa === void 0 ? d : oa);
      dn >= Me && Xt === void 0 && (Xt = Jn, zt = en), dn > Me + c && kt === void 0 && (kt = Jn), en = dn;
    }
    return Xt === void 0 && (Xt = 0, zt = 0, kt = Math.ceil(c / d)), kt === void 0 && (kt = ae.length - 1), kt = Math.min(kt + 1, ae.length - 1), {
      scrollHeight: en,
      start: Xt,
      end: kt,
      offset: zt
    };
  }, [ie, X, Me, ae, K, c]), Ot = mt.scrollHeight, Rt = mt.start, ct = mt.end, it = mt.offset;
  Ue.current.start = Rt, Ue.current.end = ct, S.useLayoutEffect(function() {
    var Wt = H.getRecord();
    if (Wt.size === 1) {
      var en = Array.from(Wt.keys())[0], Xt = Wt.get(en), zt = ae[Rt];
      if (zt && Xt === void 0) {
        var kt = Q(zt);
        if (kt === en) {
          var Qn = H.get(en), Jn = Qn - d;
          je(function(Nr) {
            return Nr + Jn;
          });
        }
      }
    }
    H.resetRecord();
  }, [Ot]);
  var Ct = S.useState({
    width: 0,
    height: c
  }), ut = qe(Ct, 2), ht = ut[0], ot = ut[1], at = function(en) {
    ot({
      width: en.offsetWidth,
      height: en.offsetHeight
    });
  }, ft = It(), st = It(), pt = S.useMemo(function() {
    return zF(ht.width, k);
  }, [ht.width, k]), bt = S.useMemo(function() {
    return zF(ht.height, Ot);
  }, [ht.height, Ot]), Nt = Ot - c, $t = It(Nt);
  $t.current = Nt;
  function Pt(Wt) {
    var en = Wt;
    return Number.isNaN($t.current) || (en = Math.min(en, $t.current)), en = Math.max(en, 0), en;
  }
  var hn = Me <= 0, an = Me >= Nt, jn = Ae <= 0, xn = Ae >= k, Ut = lY(hn, an, jn, xn), pn = function() {
    return {
      x: ee ? -Ae : Ae,
      y: Me
    };
  }, wn = It(pn()), Lt = ra(function(Wt) {
    if (D) {
      var en = ce(ce({}, pn()), Wt);
      (wn.current.x !== en.x || wn.current.y !== en.y) && (D(en), wn.current = en);
    }
  });
  function gt(Wt, en) {
    var Xt = Wt;
    en ? (FS(function() {
      we(Xt);
    }), Lt()) : je(Xt);
  }
  function wt(Wt) {
    var en = Wt.currentTarget.scrollTop;
    en !== Me && je(en), N?.(Wt), Lt();
  }
  var Ft = function(en) {
    var Xt = en, zt = k ? k - ht.width : 0;
    return Xt = Math.max(Xt, 0), Xt = Math.min(Xt, zt), Xt;
  }, yn = ra(function(Wt, en) {
    en ? (FS(function() {
      we(function(Xt) {
        var zt = Xt + (ee ? -Wt : Wt);
        return Ft(zt);
      });
    }), Lt()) : je(function(Xt) {
      var zt = Xt + Wt;
      return zt;
    });
  }), gn = Tge(X, hn, an, jn, xn, !!k, yn), Tn = qe(gn, 2), Gt = Tn[0], Dt = Tn[1];
  Dge(X, oe, function(Wt, en, Xt, zt) {
    var kt = zt;
    return Ut(Wt, en, Xt) ? !1 : !kt || !kt._virtualHandled ? (kt && (kt._virtualHandled = !0), Gt({
      preventDefault: function() {
      },
      deltaX: Wt ? en : 0,
      deltaY: Wt ? 0 : en
    }), !0) : !1;
  }), $ge(ie, oe, function(Wt) {
    je(function(en) {
      return en + Wt;
    });
  }), Da(function() {
    function Wt(Xt) {
      var zt = hn && Xt.detail < 0, kt = an && Xt.detail > 0;
      X && !zt && !kt && Xt.preventDefault();
    }
    var en = oe.current;
    return en.addEventListener("wheel", Gt, {
      passive: !1
    }), en.addEventListener("DOMMouseScroll", Dt, {
      passive: !0
    }), en.addEventListener("MozMousePixelScroll", Wt, {
      passive: !1
    }), function() {
      en.removeEventListener("wheel", Gt), en.removeEventListener("DOMMouseScroll", Dt), en.removeEventListener("MozMousePixelScroll", Wt);
    };
  }, [X, hn, an]), Da(function() {
    if (k) {
      var Wt = Ft(Ae);
      we(Wt), Lt({
        x: Wt
      });
    }
  }, [ht.width, k]);
  var Yt = function() {
    var en, Xt;
    (en = ft.current) === null || en === void 0 || en.delayHidden(), (Xt = st.current) === null || Xt === void 0 || Xt.delayHidden();
  }, Mn = zge(oe, ae, H, d, Q, function() {
    return J(!0);
  }, je, Yt);
  S.useImperativeHandle(t, function() {
    return {
      nativeElement: be.current,
      getScrollInfo: pn,
      scrollTo: function(en) {
        function Xt(zt) {
          return zt && Hn(zt) === "object" && ("left" in zt || "top" in zt);
        }
        Xt(en) ? (en.left !== void 0 && we(Ft(en.left)), Mn(en.top)) : Mn(en);
      }
    };
  }), Da(function() {
    if ($) {
      var Wt = ae.slice(Rt, ct + 1);
      $(Wt, ae);
    }
  }, [Rt, ct, ae]);
  var Gn = Rge(ae, Q, H, d), wr = I?.({
    start: Rt,
    end: ct,
    virtual: ie,
    offsetX: Ae,
    offsetY: it,
    rtl: ee,
    getSize: Gn
  }), aa = kge(ae, Rt, ct, k, Ae, G, w, ye), qn = null;
  c && (qn = ce(ge({}, p ? "height" : "maxHeight", c), Hge), X && (qn.overflowY = "hidden", k && (qn.overflowX = "hidden"), Qe && (qn.pointerEvents = "none")));
  var Rr = {};
  return ee && (Rr.dir = "rtl"), /* @__PURE__ */ S.createElement("div", vt({
    ref: be,
    style: ce(ce({}, g), {}, {
      position: "relative"
    }),
    className: ne
  }, Rr, W), /* @__PURE__ */ S.createElement(hp, {
    onResize: at
  }, /* @__PURE__ */ S.createElement(T, {
    className: "".concat(a, "-holder"),
    style: qn,
    ref: oe,
    onScroll: wt,
    onMouseEnter: Yt
  }, /* @__PURE__ */ S.createElement(iY, {
    prefixCls: a,
    height: Ot,
    offsetX: Ae,
    offsetY: it,
    scrollWidth: k,
    onInnerResize: J,
    ref: fe,
    innerProps: j,
    rtl: ee,
    extra: wr
  }, aa))), ie && Ot > c && /* @__PURE__ */ S.createElement(ND, {
    ref: ft,
    prefixCls: a,
    scrollOffset: Me,
    scrollRange: Ot,
    rtl: ee,
    onScroll: gt,
    onStartMove: Te,
    onStopMove: Oe,
    spinSize: bt,
    containerSize: ht.height,
    style: L?.verticalScrollBar,
    thumbStyle: L?.verticalScrollBarThumb,
    showScrollBar: _
  }), ie && k > ht.width && /* @__PURE__ */ S.createElement(ND, {
    ref: st,
    prefixCls: a,
    scrollOffset: Ae,
    scrollRange: k,
    rtl: ee,
    onScroll: gt,
    onStartMove: Te,
    onStopMove: Oe,
    spinSize: pt,
    containerSize: ht.width,
    horizontal: !0,
    style: L?.horizontalScrollBar,
    thumbStyle: L?.horizontalScrollBarThumb,
    showScrollBar: _
  }));
}
var eM = /* @__PURE__ */ S.forwardRef(Fge);
eM.displayName = "List";
function Wge() {
  return /(mac\sos|macintosh)/i.test(navigator.appVersion);
}
var Vge = ["disabled", "title", "children", "style", "className"];
function jF(e) {
  return typeof e == "string" || typeof e == "number";
}
var _ge = function(t, r) {
  var a = $pe(), i = a.prefixCls, c = a.id, d = a.open, f = a.multiple, p = a.mode, g = a.searchValue, b = a.toggleOpen, w = a.notFoundContent, x = a.onPopupScroll, E = S.useContext(Kz), P = E.maxCount, k = E.flattenOptions, M = E.onActiveValue, T = E.defaultActiveFirstOption, N = E.onSelect, D = E.menuItemSelectedIcon, $ = E.rawValues, j = E.fieldNames, I = E.virtual, L = E.direction, F = E.listHeight, _ = E.listItemHeight, W = E.optionRender, Q = "".concat(i, "-item"), U = eC(function() {
    return k;
  }, [d, k], function(le, se) {
    return se[0] && le[1] !== se[1];
  }), Y = S.useRef(null), G = S.useMemo(function() {
    return f && TD(P) && $?.size >= P;
  }, [f, P, $?.size]), J = function(se) {
    se.preventDefault();
  }, H = function(se) {
    var Ae;
    (Ae = Y.current) === null || Ae === void 0 || Ae.scrollTo(typeof se == "number" ? {
      index: se
    } : se);
  }, K = S.useCallback(function(le) {
    return p === "combobox" ? !1 : $.has(le);
  }, [p, Et($).toString(), $.size]), X = function(se) {
    for (var Ae = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, we = U.length, Ne = 0; Ne < we; Ne += 1) {
      var pe = (se + Ne * Ae + we) % we, Qe = U[pe] || {}, Le = Qe.group, Te = Qe.data;
      if (!Le && !(Te != null && Te.disabled) && (K(Te.value) || !G))
        return pe;
    }
    return -1;
  }, te = S.useState(function() {
    return X(0);
  }), ie = qe(te, 2), ee = ie[0], ne = ie[1], ae = function(se) {
    var Ae = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    ne(se);
    var we = {
      source: Ae ? "keyboard" : "mouse"
    }, Ne = U[se];
    if (!Ne) {
      M(null, -1, we);
      return;
    }
    M(Ne.value, se, we);
  };
  Er(function() {
    ae(T !== !1 ? X(0) : -1);
  }, [U.length, g]);
  var oe = S.useCallback(function(le) {
    return p === "combobox" ? String(le).toLowerCase() === g.toLowerCase() : $.has(le);
  }, [p, g, Et($).toString(), $.size]);
  Er(function() {
    var le = setTimeout(function() {
      if (!f && d && $.size === 1) {
        var Ae = Array.from($)[0], we = U.findIndex(function(Ne) {
          var pe = Ne.data;
          return g ? String(pe.value).startsWith(g) : pe.value === Ae;
        });
        we !== -1 && (ae(we), H(we));
      }
    });
    if (d) {
      var se;
      (se = Y.current) === null || se === void 0 || se.scrollTo(void 0);
    }
    return function() {
      return clearTimeout(le);
    };
  }, [d, g]);
  var fe = function(se) {
    se !== void 0 && N(se, {
      selected: !$.has(se)
    }), f || b(!1);
  };
  if (S.useImperativeHandle(r, function() {
    return {
      onKeyDown: function(se) {
        var Ae = se.which, we = se.ctrlKey;
        switch (Ae) {
          // >>> Arrow keys & ctrl + n/p on Mac
          case fn.N:
          case fn.P:
          case fn.UP:
          case fn.DOWN: {
            var Ne = 0;
            if (Ae === fn.UP ? Ne = -1 : Ae === fn.DOWN ? Ne = 1 : Wge() && we && (Ae === fn.N ? Ne = 1 : Ae === fn.P && (Ne = -1)), Ne !== 0) {
              var pe = X(ee + Ne, Ne);
              H(pe), ae(pe, !0);
            }
            break;
          }
          // >>> Select (Tab / Enter)
          case fn.TAB:
          case fn.ENTER: {
            var Qe, Le = U[ee];
            Le && !(Le != null && (Qe = Le.data) !== null && Qe !== void 0 && Qe.disabled) && !G ? fe(Le.value) : fe(void 0), d && se.preventDefault();
            break;
          }
          // >>> Close
          case fn.ESC:
            b(!1), d && se.stopPropagation();
        }
      },
      onKeyUp: function() {
      },
      scrollTo: function(se) {
        H(se);
      }
    };
  }), U.length === 0)
    return /* @__PURE__ */ S.createElement("div", {
      role: "listbox",
      id: "".concat(c, "_list"),
      className: "".concat(Q, "-empty"),
      onMouseDown: J
    }, w);
  var be = Object.keys(j).map(function(le) {
    return j[le];
  }), me = function(se) {
    return se.label;
  };
  function De(le, se) {
    var Ae = le.group;
    return {
      role: Ae ? "presentation" : "option",
      id: "".concat(c, "_list_").concat(se)
    };
  }
  var Me = function(se) {
    var Ae = U[se];
    if (!Ae)
      return null;
    var we = Ae.data || {}, Ne = we.value, pe = Ae.group, Qe = Zu(we, !0), Le = me(Ae);
    return Ae ? /* @__PURE__ */ S.createElement("div", vt({
      "aria-label": typeof Le == "string" && !pe ? Le : null
    }, Qe, {
      key: se
    }, De(Ae, se), {
      "aria-selected": oe(Ne)
    }), Ne) : null;
  }, ze = {
    role: "listbox",
    id: "".concat(c, "_list")
  };
  return /* @__PURE__ */ S.createElement(S.Fragment, null, I && /* @__PURE__ */ S.createElement("div", vt({}, ze, {
    style: {
      height: 0,
      width: 0,
      overflow: "hidden"
    }
  }), Me(ee - 1), Me(ee), Me(ee + 1)), /* @__PURE__ */ S.createElement(eM, {
    itemKey: "key",
    ref: Y,
    data: U,
    height: F,
    itemHeight: _,
    fullHeight: !1,
    onMouseDown: J,
    onScroll: x,
    virtual: I,
    direction: L,
    innerProps: I ? null : ze
  }, function(le, se) {
    var Ae = le.group, we = le.groupOption, Ne = le.data, pe = le.label, Qe = le.value, Le = Ne.key;
    if (Ae) {
      var Te, Oe = (Te = Ne.title) !== null && Te !== void 0 ? Te : jF(pe) ? pe.toString() : void 0;
      return /* @__PURE__ */ S.createElement("div", {
        className: _e(Q, "".concat(Q, "-group"), Ne.className),
        title: Oe
      }, pe !== void 0 ? pe : Le);
    }
    var ye = Ne.disabled, je = Ne.title;
    Ne.children;
    var Ue = Ne.style, Fe = Ne.className, tt = xr(Ne, Vge), dt = Rs(tt, be), St = K(Qe), mt = ye || !St && G, Ot = "".concat(Q, "-option"), Rt = _e(Q, Ot, Fe, ge(ge(ge(ge({}, "".concat(Ot, "-grouped"), we), "".concat(Ot, "-active"), ee === se && !mt), "".concat(Ot, "-disabled"), mt), "".concat(Ot, "-selected"), St)), ct = me(le), it = !D || typeof D == "function" || St, Ct = typeof ct == "number" ? ct : ct || Qe, ut = jF(Ct) ? Ct.toString() : void 0;
    return je !== void 0 && (ut = je), /* @__PURE__ */ S.createElement("div", vt({}, Zu(dt), I ? {} : De(le, se), {
      "aria-selected": oe(Qe),
      className: Rt,
      title: ut,
      onMouseMove: function() {
        ee === se || mt || ae(se);
      },
      onClick: function() {
        mt || fe(Qe);
      },
      style: Ue
    }), /* @__PURE__ */ S.createElement("div", {
      className: "".concat(Ot, "-content")
    }, typeof W == "function" ? W(le, {
      index: se
    }) : Ct), /* @__PURE__ */ S.isValidElement(D) || St, it && /* @__PURE__ */ S.createElement(Z9, {
      className: "".concat(Q, "-option-state"),
      customizeIcon: D,
      customizeIconProps: {
        value: Qe,
        disabled: mt,
        isSelected: St
      }
    }, St ? "✓" : null));
  }));
}, sY = /* @__PURE__ */ S.forwardRef(_ge);
process.env.NODE_ENV !== "production" && (sY.displayName = "OptionList");
const Bge = (function(e, t) {
  var r = S.useRef({
    values: /* @__PURE__ */ new Map(),
    options: /* @__PURE__ */ new Map()
  }), a = S.useMemo(function() {
    var c = r.current, d = c.values, f = c.options, p = e.map(function(w) {
      if (w.label === void 0) {
        var x;
        return ce(ce({}, w), {}, {
          label: (x = d.get(w.value)) === null || x === void 0 ? void 0 : x.label
        });
      }
      return w;
    }), g = /* @__PURE__ */ new Map(), b = /* @__PURE__ */ new Map();
    return p.forEach(function(w) {
      g.set(w.value, w), b.set(w.value, t.get(w.value) || f.get(w.value));
    }), r.current.values = g, r.current.options = b, p;
  }, [e, t]), i = S.useCallback(function(c) {
    return t.get(c) || r.current.options.get(c);
  }, [t]);
  return [a, i];
});
function iR(e, t) {
  return qz(e).join("").toUpperCase().includes(t);
}
const Uge = (function(e, t, r, a, i) {
  return S.useMemo(function() {
    if (!r || a === !1)
      return e;
    var c = t.options, d = t.label, f = t.value, p = [], g = typeof a == "function", b = r.toUpperCase(), w = g ? a : function(E, P) {
      return i ? iR(P[i], b) : P[c] ? iR(P[d !== "children" ? d : "label"], b) : iR(P[f], b);
    }, x = g ? function(E) {
      return RD(E);
    } : function(E) {
      return E;
    };
    return e.forEach(function(E) {
      if (E[c]) {
        var P = w(r, x(E));
        if (P)
          p.push(E);
        else {
          var k = E[c].filter(function(M) {
            return w(r, x(M));
          });
          k.length && p.push(ce(ce({}, E), {}, ge({}, c, k)));
        }
        return;
      }
      w(r, x(E)) && p.push(E);
    }), p;
  }, [e, a, i, r, t]);
});
var IF = 0, Xge = process.env.NODE_ENV !== "test" && Ju();
function Gge() {
  var e;
  return Xge ? (e = IF, IF += 1) : e = "TEST_OR_SSR", e;
}
function qge(e) {
  var t = S.useState(), r = qe(t, 2), a = r[0], i = r[1];
  return S.useEffect(function() {
    i("rc_select_".concat(Gge()));
  }, []), e || a;
}
var Kge = ["children", "value"], Yge = ["children"];
function Qge(e) {
  var t = e, r = t.key, a = t.props, i = a.children, c = a.value, d = xr(a, Kge);
  return ce({
    key: r,
    value: c !== void 0 ? c : r,
    children: i
  }, d);
}
function Jz(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  return Kh(e).map(function(r, a) {
    if (!/* @__PURE__ */ S.isValidElement(r) || !r.type)
      return null;
    var i = r, c = i.type.isSelectOptGroup, d = i.key, f = i.props, p = f.children, g = xr(f, Yge);
    return t || !c ? Qge(r) : ce(ce({
      key: "__RC_SELECT_GRP__".concat(d === null ? a : d, "__"),
      label: d
    }, g), {}, {
      options: Jz(p)
    });
  }).filter(function(r) {
    return r;
  });
}
var Jge = function(t, r, a, i, c) {
  return S.useMemo(function() {
    var d = t, f = !t;
    f && (d = Jz(r));
    var p = /* @__PURE__ */ new Map(), g = /* @__PURE__ */ new Map(), b = function(E, P, k) {
      k && typeof k == "string" && E.set(P[k], P);
    }, w = function x(E) {
      for (var P = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, k = 0; k < E.length; k += 1) {
        var M = E[k];
        !M[a.options] || P ? (p.set(M[a.value], M), b(g, M, a.label), b(g, M, i), b(g, M, c)) : x(M[a.options], !0);
      }
    };
    return w(d), {
      options: d,
      valueOptions: p,
      labelOptions: g
    };
  }, [t, r, a, i, c]);
};
function LF(e) {
  var t = S.useRef();
  t.current = e;
  var r = S.useCallback(function() {
    return t.current.apply(t, arguments);
  }, []);
  return r;
}
function Zge(e) {
  var t = e.mode, r = e.options, a = e.children, i = e.backfill, c = e.allowClear, d = e.placeholder, f = e.getInputElement, p = e.showSearch, g = e.onSearch, b = e.defaultOpen, w = e.autoFocus, x = e.labelInValue, E = e.value, P = e.inputValue, k = e.optionLabelProp, M = Xk(t), T = p !== void 0 ? p : M || t === "combobox", N = r || Jz(a);
  if ($n(t !== "tags" || N.every(function(I) {
    return !I.disabled;
  }), "Please avoid setting option to disabled in tags mode since user can always type text as tag."), t === "tags" || t === "combobox") {
    var D = N.some(function(I) {
      return I.options ? I.options.some(function(L) {
        return typeof ("value" in L ? L.value : L.key) == "number";
      }) : typeof ("value" in I ? I.value : I.key) == "number";
    });
    $n(!D, "`value` of Option should not use number type when `mode` is `tags` or `combobox`.");
  }
  if ($n(t !== "combobox" || !k, "`combobox` mode not support `optionLabelProp`. Please set `value` on Option directly."), $n(t === "combobox" || !i, "`backfill` only works with `combobox` mode."), $n(t === "combobox" || !f, "`getInputElement` only work with `combobox` mode."), ON(t !== "combobox" || !f || !c || !d, "Customize `getInputElement` should customize clear and placeholder logic instead of configuring `allowClear` and `placeholder`."), g && !T && t !== "combobox" && t !== "tags" && $n(!1, "`onSearch` should work with `showSearch` instead of use alone."), ON(!b || w, "`defaultOpen` makes Select open without focus which means it will not close by click outside. You can set `autoFocus` if needed."), E != null) {
    var $ = qz(E);
    $n(!x || $.every(function(I) {
      return Hn(I) === "object" && ("key" in I || "value" in I);
    }), "`value` should in shape of `{ value: string | number, label?: ReactNode }` when you set `labelInValue` to `true`"), $n(!M || Array.isArray(E), "`value` should be array when `mode` is `multiple` or `tags`");
  }
  if (a) {
    var j = null;
    Kh(a).some(function(I) {
      if (!/* @__PURE__ */ S.isValidElement(I) || !I.type)
        return !1;
      var L = I, F = L.type;
      if (F.isSelectOption)
        return !1;
      if (F.isSelectOptGroup) {
        var _ = Kh(I.props.children).every(function(W) {
          return !/* @__PURE__ */ S.isValidElement(W) || !I.type || W.type.isSelectOption ? !0 : (j = W.type, !1);
        });
        return !_;
      }
      return j = F, !0;
    }), j && $n(!1, "`children` should be `Select.Option` or `Select.OptGroup` instead of `".concat(j.displayName || j.name || j, "`.")), $n(P === void 0, "`inputValue` is deprecated, please use `searchValue` instead.");
  }
}
function e0e(e, t) {
  if (e) {
    var r = function a(i) {
      for (var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, d = 0; d < i.length; d++) {
        var f = i[d];
        if (f[t?.value] === null)
          return $n(!1, "`value` in Select options should not be `null`."), !0;
        if (!c && Array.isArray(f[t?.options]) && a(f[t?.options], !0))
          break;
      }
    };
    r(e);
  }
}
var t0e = ["id", "mode", "prefixCls", "backfill", "fieldNames", "inputValue", "searchValue", "onSearch", "autoClearSearchValue", "onSelect", "onDeselect", "dropdownMatchSelectWidth", "filterOption", "filterSort", "optionFilterProp", "optionLabelProp", "options", "optionRender", "children", "defaultActiveFirstOption", "menuItemSelectedIcon", "virtual", "direction", "listHeight", "listItemHeight", "labelRender", "value", "defaultValue", "labelInValue", "onChange", "maxCount"], n0e = ["inputValue"];
function r0e(e) {
  return !e || Hn(e) !== "object";
}
var uY = /* @__PURE__ */ S.forwardRef(function(e, t) {
  var r = e.id, a = e.mode, i = e.prefixCls, c = i === void 0 ? "rc-select" : i, d = e.backfill, f = e.fieldNames, p = e.inputValue, g = e.searchValue, b = e.onSearch, w = e.autoClearSearchValue, x = w === void 0 ? !0 : w, E = e.onSelect, P = e.onDeselect, k = e.dropdownMatchSelectWidth, M = k === void 0 ? !0 : k, T = e.filterOption, N = e.filterSort, D = e.optionFilterProp, $ = e.optionLabelProp, j = e.options, I = e.optionRender, L = e.children, F = e.defaultActiveFirstOption, _ = e.menuItemSelectedIcon, W = e.virtual, Q = e.direction, U = e.listHeight, Y = U === void 0 ? 200 : U, G = e.listItemHeight, J = G === void 0 ? 20 : G, H = e.labelRender, K = e.value, X = e.defaultValue, te = e.labelInValue, ie = e.onChange, ee = e.maxCount, ne = xr(e, t0e), ae = qge(r), oe = Xk(a), fe = !!(!j && L), be = S.useMemo(function() {
    return T === void 0 && a === "combobox" ? !1 : T;
  }, [T, a]), me = S.useMemo(
    function() {
      return aY(f, fe);
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [
      // We stringify fieldNames to avoid unnecessary re-renders.
      JSON.stringify(f),
      fe
    ]
    /* eslint-enable react-hooks/exhaustive-deps */
  ), De = ll("", {
    value: g !== void 0 ? g : p,
    postState: function(gt) {
      return gt || "";
    }
  }), Me = qe(De, 2), ze = Me[0], le = Me[1], se = Jge(j, L, me, D, $), Ae = se.valueOptions, we = se.labelOptions, Ne = se.options, pe = S.useCallback(function(Lt) {
    var gt = qz(Lt);
    return gt.map(function(wt) {
      var Ft, yn, gn, Tn, Gt;
      if (r0e(wt))
        Ft = wt;
      else {
        var Dt;
        gn = wt.key, yn = wt.label, Ft = (Dt = wt.value) !== null && Dt !== void 0 ? Dt : gn;
      }
      var Yt = Ae.get(Ft);
      if (Yt) {
        var Mn;
        if (yn === void 0 && (yn = Yt?.[$ || me.label]), gn === void 0 && (gn = (Mn = Yt?.key) !== null && Mn !== void 0 ? Mn : Ft), Tn = Yt?.disabled, Gt = Yt?.title, process.env.NODE_ENV !== "production" && !$) {
          var Gn = Yt?.[me.label];
          Gn !== void 0 && !/* @__PURE__ */ S.isValidElement(Gn) && !/* @__PURE__ */ S.isValidElement(yn) && Gn !== yn && $n(!1, "`label` of `value` is not same as `label` in Select options.");
        }
      }
      return {
        label: yn,
        value: Ft,
        key: gn,
        disabled: Tn,
        title: Gt
      };
    });
  }, [me, $, Ae]), Qe = ll(X, {
    value: K
  }), Le = qe(Qe, 2), Te = Le[0], Oe = Le[1], ye = S.useMemo(function() {
    var Lt, gt = oe && Te === null ? [] : Te, wt = pe(gt);
    return a === "combobox" && tge((Lt = wt[0]) === null || Lt === void 0 ? void 0 : Lt.value) ? [] : wt;
  }, [Te, pe, a, oe]), je = Bge(ye, Ae), Ue = qe(je, 2), Fe = Ue[0], tt = Ue[1], dt = S.useMemo(function() {
    if (!a && Fe.length === 1) {
      var Lt = Fe[0];
      if (Lt.value === null && (Lt.label === null || Lt.label === void 0))
        return [];
    }
    return Fe.map(function(gt) {
      var wt;
      return ce(ce({}, gt), {}, {
        label: (wt = typeof H == "function" ? H(gt) : gt.label) !== null && wt !== void 0 ? wt : gt.value
      });
    });
  }, [a, Fe, H]), St = S.useMemo(function() {
    return new Set(Fe.map(function(Lt) {
      return Lt.value;
    }));
  }, [Fe]);
  S.useEffect(function() {
    if (a === "combobox") {
      var Lt, gt = (Lt = Fe[0]) === null || Lt === void 0 ? void 0 : Lt.value;
      le(ege(gt) ? String(gt) : "");
    }
  }, [Fe]);
  var mt = LF(function(Lt, gt) {
    var wt = gt ?? Lt;
    return ge(ge({}, me.value, Lt), me.label, wt);
  }), Ot = S.useMemo(function() {
    if (a !== "tags")
      return Ne;
    var Lt = Et(Ne), gt = function(Ft) {
      return Ae.has(Ft);
    };
    return Et(Fe).sort(function(wt, Ft) {
      return wt.value < Ft.value ? -1 : 1;
    }).forEach(function(wt) {
      var Ft = wt.value;
      gt(Ft) || Lt.push(mt(Ft, wt.label));
    }), Lt;
  }, [mt, Ne, Ae, Fe, a]), Rt = Uge(Ot, me, ze, be, D), ct = S.useMemo(function() {
    return a !== "tags" || !ze || Rt.some(function(Lt) {
      return Lt[D || "value"] === ze;
    }) || Rt.some(function(Lt) {
      return Lt[me.value] === ze;
    }) ? Rt : [mt(ze)].concat(Et(Rt));
  }, [mt, D, a, Rt, ze, me]), it = function Lt(gt) {
    var wt = Et(gt).sort(function(Ft, yn) {
      return N(Ft, yn, {
        searchValue: ze
      });
    });
    return wt.map(function(Ft) {
      return Array.isArray(Ft.options) ? ce(ce({}, Ft), {}, {
        options: Ft.options.length > 0 ? Lt(Ft.options) : Ft.options
      }) : Ft;
    });
  }, Ct = S.useMemo(function() {
    return N ? it(ct) : ct;
  }, [ct, N, ze]), ut = S.useMemo(function() {
    return wge(Ct, {
      fieldNames: me,
      childrenAsData: fe
    });
  }, [Ct, me, fe]), ht = function(gt) {
    var wt = pe(gt);
    if (Oe(wt), ie && // Trigger event only when value changed
    (wt.length !== Fe.length || wt.some(function(gn, Tn) {
      var Gt;
      return ((Gt = Fe[Tn]) === null || Gt === void 0 ? void 0 : Gt.value) !== gn?.value;
    }))) {
      var Ft = te ? wt : wt.map(function(gn) {
        return gn.value;
      }), yn = wt.map(function(gn) {
        return RD(tt(gn.value));
      });
      ie(
        // Value
        oe ? Ft : Ft[0],
        // Option
        oe ? yn : yn[0]
      );
    }
  }, ot = S.useState(null), at = qe(ot, 2), ft = at[0], st = at[1], pt = S.useState(0), bt = qe(pt, 2), Nt = bt[0], $t = bt[1], Pt = F !== void 0 ? F : a !== "combobox", hn = S.useCallback(function(Lt, gt) {
    var wt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, Ft = wt.source, yn = Ft === void 0 ? "keyboard" : Ft;
    $t(gt), d && a === "combobox" && Lt !== null && yn === "keyboard" && st(String(Lt));
  }, [d, a]), an = function(gt, wt, Ft) {
    var yn = function() {
      var qn, Rr = tt(gt);
      return [te ? {
        label: Rr?.[me.label],
        value: gt,
        key: (qn = Rr?.key) !== null && qn !== void 0 ? qn : gt
      } : gt, RD(Rr)];
    };
    if (wt && E) {
      var gn = yn(), Tn = qe(gn, 2), Gt = Tn[0], Dt = Tn[1];
      E(Gt, Dt);
    } else if (!wt && P && Ft !== "clear") {
      var Yt = yn(), Mn = qe(Yt, 2), Gn = Mn[0], wr = Mn[1];
      P(Gn, wr);
    }
  }, jn = LF(function(Lt, gt) {
    var wt, Ft = oe ? gt.selected : !0;
    Ft ? wt = oe ? [].concat(Et(Fe), [Lt]) : [Lt] : wt = Fe.filter(function(yn) {
      return yn.value !== Lt;
    }), ht(wt), an(Lt, Ft), a === "combobox" ? st("") : (!Xk || x) && (le(""), st(""));
  }), xn = function(gt, wt) {
    ht(gt);
    var Ft = wt.type, yn = wt.values;
    (Ft === "remove" || Ft === "clear") && yn.forEach(function(gn) {
      an(gn.value, !1, Ft);
    });
  }, Ut = function(gt, wt) {
    if (le(gt), st(null), wt.source === "submit") {
      var Ft = (gt || "").trim();
      if (Ft) {
        var yn = Array.from(new Set([].concat(Et(St), [Ft])));
        ht(yn), an(Ft, !0), le("");
      }
      return;
    }
    wt.source !== "blur" && (a === "combobox" && ht(gt), b?.(gt));
  }, pn = function(gt) {
    var wt = gt;
    a !== "tags" && (wt = gt.map(function(yn) {
      var gn = we.get(yn);
      return gn?.value;
    }).filter(function(yn) {
      return yn !== void 0;
    }));
    var Ft = Array.from(new Set([].concat(Et(St), Et(wt))));
    ht(Ft), Ft.forEach(function(yn) {
      an(yn, !0);
    });
  }, wn = S.useMemo(function() {
    var Lt = W !== !1 && M !== !1;
    return ce(ce({}, se), {}, {
      flattenOptions: ut,
      onActiveValue: hn,
      defaultActiveFirstOption: Pt,
      onSelect: jn,
      menuItemSelectedIcon: _,
      rawValues: St,
      fieldNames: me,
      virtual: Lt,
      direction: Q,
      listHeight: Y,
      listItemHeight: J,
      childrenAsData: fe,
      maxCount: ee,
      optionRender: I
    });
  }, [ee, se, ut, hn, Pt, jn, _, St, me, W, M, Q, Y, J, fe, I]);
  return process.env.NODE_ENV !== "production" && (Zge(e), e0e(Ne, me)), /* @__PURE__ */ S.createElement(Kz.Provider, {
    value: wn
  }, /* @__PURE__ */ S.createElement(oY, vt({}, ne, {
    // >>> MISC
    id: ae,
    prefixCls: c,
    ref: t,
    omitDomProps: n0e,
    mode: a,
    displayValues: dt,
    onDisplayValuesChange: xn,
    direction: Q,
    searchValue: ze,
    onSearch: Ut,
    autoClearSearchValue: x,
    onSearchSplit: pn,
    dropdownMatchSelectWidth: M,
    OptionList: sY,
    emptyOptions: !ut.length,
    activeValue: ft,
    activeDescendantId: "".concat(ae, "_list_").concat(Nt)
  })));
});
process.env.NODE_ENV !== "production" && (uY.displayName = "Select");
var Zz = uY;
Zz.Option = Qz;
Zz.OptGroup = Yz;
function NE(e, t, r) {
  return _e({
    [`${e}-status-success`]: t === "success",
    [`${e}-status-warning`]: t === "warning",
    [`${e}-status-error`]: t === "error",
    [`${e}-status-validating`]: t === "validating",
    [`${e}-has-feedback`]: r
  });
}
const tM = (e, t) => t || e, cY = () => {
  const [, e] = Bf(), [t] = q1("Empty"), a = new ro(e.colorBgBase).toHsl().l < 0.5 ? {
    opacity: 0.65
  } : {};
  return /* @__PURE__ */ S.createElement("svg", {
    style: a,
    width: "184",
    height: "152",
    viewBox: "0 0 184 152",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ S.createElement("title", null, t?.description || "Empty"), /* @__PURE__ */ S.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ S.createElement("g", {
    transform: "translate(24 31.67)"
  }, /* @__PURE__ */ S.createElement("ellipse", {
    fillOpacity: ".8",
    fill: "#F5F5F7",
    cx: "67.797",
    cy: "106.89",
    rx: "67.797",
    ry: "12.668"
  }), /* @__PURE__ */ S.createElement("path", {
    d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z",
    fill: "#AEB8C2"
  }), /* @__PURE__ */ S.createElement("path", {
    d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z",
    fill: "url(#linearGradient-1)",
    transform: "translate(13.56)"
  }), /* @__PURE__ */ S.createElement("path", {
    d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
    fill: "#F5F5F7"
  }), /* @__PURE__ */ S.createElement("path", {
    d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z",
    fill: "#DCE0E6"
  })), /* @__PURE__ */ S.createElement("path", {
    d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z",
    fill: "#DCE0E6"
  }), /* @__PURE__ */ S.createElement("g", {
    transform: "translate(149.65 15.383)",
    fill: "#FFF"
  }, /* @__PURE__ */ S.createElement("ellipse", {
    cx: "20.654",
    cy: "3.167",
    rx: "2.849",
    ry: "2.815"
  }), /* @__PURE__ */ S.createElement("path", {
    d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
  }))));
};
process.env.NODE_ENV !== "production" && (cY.displayName = "EmptyImage");
const dY = () => {
  const [, e] = Bf(), [t] = q1("Empty"), {
    colorFill: r,
    colorFillTertiary: a,
    colorFillQuaternary: i,
    colorBgContainer: c
  } = e, {
    borderColor: d,
    shadowColor: f,
    contentColor: p
  } = mn(() => ({
    borderColor: new ro(r).onBackground(c).toHexString(),
    shadowColor: new ro(a).onBackground(c).toHexString(),
    contentColor: new ro(i).onBackground(c).toHexString()
  }), [r, a, i, c]);
  return /* @__PURE__ */ S.createElement("svg", {
    width: "64",
    height: "41",
    viewBox: "0 0 64 41",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ S.createElement("title", null, t?.description || "Empty"), /* @__PURE__ */ S.createElement("g", {
    transform: "translate(0 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ S.createElement("ellipse", {
    fill: f,
    cx: "32",
    cy: "33",
    rx: "32",
    ry: "7"
  }), /* @__PURE__ */ S.createElement("g", {
    fillRule: "nonzero",
    stroke: d
  }, /* @__PURE__ */ S.createElement("path", {
    d: "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
  }), /* @__PURE__ */ S.createElement("path", {
    d: "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
    fill: p
  }))));
};
process.env.NODE_ENV !== "production" && (dY.displayName = "SimpleImage");
const a0e = (e) => {
  const {
    componentCls: t,
    margin: r,
    marginXS: a,
    marginXL: i,
    fontSize: c,
    lineHeight: d
  } = e;
  return {
    [t]: {
      marginInline: a,
      fontSize: c,
      lineHeight: d,
      textAlign: "center",
      // 原来 &-image 没有父子结构，现在为了外层承担我们的 hashId，改成父子结构
      [`${t}-image`]: {
        height: e.emptyImgHeight,
        marginBottom: a,
        opacity: e.opacityImage,
        img: {
          height: "100%"
        },
        svg: {
          maxWidth: "100%",
          height: "100%",
          margin: "auto"
        }
      },
      [`${t}-description`]: {
        color: e.colorTextDescription
      },
      // 原来 &-footer 没有父子结构，现在为了外层承担我们的 hashId，改成父子结构
      [`${t}-footer`]: {
        marginTop: r
      },
      "&-normal": {
        marginBlock: i,
        color: e.colorTextDescription,
        [`${t}-description`]: {
          color: e.colorTextDescription
        },
        [`${t}-image`]: {
          height: e.emptyImgHeightMD
        }
      },
      "&-small": {
        marginBlock: a,
        color: e.colorTextDescription,
        [`${t}-image`]: {
          height: e.emptyImgHeightSM
        }
      }
    }
  };
}, o0e = Ii("Empty", (e) => {
  const {
    componentCls: t,
    controlHeightLG: r,
    calc: a
  } = e, i = lo(e, {
    emptyImgCls: `${t}-img`,
    emptyImgHeight: a(r).mul(2.5).equal(),
    emptyImgHeightMD: r,
    emptyImgHeightSM: a(r).mul(0.875).equal()
  });
  return a0e(i);
});
var i0e = function(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
    t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
};
const fY = /* @__PURE__ */ S.createElement(cY, null), mY = /* @__PURE__ */ S.createElement(dY, null), ib = (e) => {
  var t;
  const {
    className: r,
    rootClassName: a,
    prefixCls: i,
    image: c,
    description: d,
    children: f,
    imageStyle: p,
    style: g,
    classNames: b,
    styles: w
  } = e, x = i0e(e, ["className", "rootClassName", "prefixCls", "image", "description", "children", "imageStyle", "style", "classNames", "styles"]), {
    getPrefixCls: E,
    direction: P,
    className: k,
    style: M,
    classNames: T,
    styles: N,
    image: D
  } = om("empty"), $ = E("empty", i), [j, I, L] = o0e($), [F] = q1("Empty"), _ = typeof d < "u" ? d : F?.description, W = typeof _ == "string" ? _ : "empty", Q = (t = c ?? D) !== null && t !== void 0 ? t : fY;
  let U = null;
  if (typeof Q == "string" ? U = /* @__PURE__ */ S.createElement("img", {
    draggable: !1,
    alt: W,
    src: Q
  }) : U = Q, process.env.NODE_ENV !== "production") {
    const Y = To("Empty");
    [["imageStyle", "styles: { image: {} }"]].forEach(([G, J]) => {
      Y.deprecated(!(G in e), G, J);
    });
  }
  return j(/* @__PURE__ */ S.createElement("div", Object.assign({
    className: _e(I, L, $, k, {
      [`${$}-normal`]: Q === mY,
      [`${$}-rtl`]: P === "rtl"
    }, r, a, T.root, b?.root),
    style: Object.assign(Object.assign(Object.assign(Object.assign({}, N.root), M), w?.root), g)
  }, x), /* @__PURE__ */ S.createElement("div", {
    className: _e(`${$}-image`, T.image, b?.image),
    style: Object.assign(Object.assign(Object.assign({}, p), N.image), w?.image)
  }, U), _ && /* @__PURE__ */ S.createElement("div", {
    className: _e(`${$}-description`, T.description, b?.description),
    style: Object.assign(Object.assign({}, N.description), w?.description)
  }, _), f && /* @__PURE__ */ S.createElement("div", {
    className: _e(`${$}-footer`, T.footer, b?.footer),
    style: Object.assign(Object.assign({}, N.footer), w?.footer)
  }, f)));
};
ib.PRESENTED_IMAGE_DEFAULT = fY;
ib.PRESENTED_IMAGE_SIMPLE = mY;
process.env.NODE_ENV !== "production" && (ib.displayName = "Empty");
const hY = (e) => {
  const {
    componentName: t
  } = e, {
    getPrefixCls: r
  } = Do(Qr), a = r("empty");
  switch (t) {
    case "Table":
    case "List":
      return /* @__PURE__ */ Re.createElement(ib, {
        image: ib.PRESENTED_IMAGE_SIMPLE
      });
    case "Select":
    case "TreeSelect":
    case "Cascader":
    case "Transfer":
    case "Mentions":
      return /* @__PURE__ */ Re.createElement(ib, {
        image: ib.PRESENTED_IMAGE_SIMPLE,
        className: `${a}-small`
      });
    /**
     * This type of component should satisfy the nullish coalescing operator(??) on the left-hand side.
     * to let the component itself implement the logic.
     * For example `Table.filter`.
     */
    case "Table.filter":
      return null;
    default:
      return /* @__PURE__ */ Re.createElement(ib, null);
  }
}, t7 = (e, t, r) => {
  var a, i;
  const {
    variant: c,
    [e]: d
  } = S.useContext(Qr), f = S.useContext(Fhe), p = d?.variant;
  let g;
  typeof t < "u" ? g = t : r === !1 ? g = "borderless" : g = (i = (a = f ?? p) !== null && a !== void 0 ? a : c) !== null && i !== void 0 ? i : "outlined";
  const b = Aue.includes(g);
  return [g, b];
}, l0e = (e) => {
  const r = {
    overflow: {
      adjustX: !0,
      adjustY: !0,
      shiftY: !0
    },
    htmlRegion: e === "scroll" ? "scroll" : "visible",
    dynamicInset: !0
  };
  return {
    bottomLeft: Object.assign(Object.assign({}, r), {
      points: ["tl", "bl"],
      offset: [0, 4]
    }),
    bottomRight: Object.assign(Object.assign({}, r), {
      points: ["tr", "br"],
      offset: [0, 4]
    }),
    topLeft: Object.assign(Object.assign({}, r), {
      points: ["bl", "tl"],
      offset: [0, -4]
    }),
    topRight: Object.assign(Object.assign({}, r), {
      points: ["br", "tr"],
      offset: [0, -4]
    })
  };
};
function s0e(e, t) {
  return e || l0e(t);
}
const HF = (e) => {
  const {
    optionHeight: t,
    optionFontSize: r,
    optionLineHeight: a,
    optionPadding: i
  } = e;
  return {
    position: "relative",
    display: "block",
    minHeight: t,
    padding: i,
    color: e.colorText,
    fontWeight: "normal",
    fontSize: r,
    lineHeight: a,
    boxSizing: "border-box"
  };
}, u0e = (e) => {
  const {
    antCls: t,
    componentCls: r
  } = e, a = `${r}-item`, i = `&${t}-slide-up-enter${t}-slide-up-enter-active`, c = `&${t}-slide-up-appear${t}-slide-up-appear-active`, d = `&${t}-slide-up-leave${t}-slide-up-leave-active`, f = `${r}-dropdown-placement-`, p = `${a}-option-selected`;
  return [
    {
      [`${r}-dropdown`]: Object.assign(Object.assign({}, dl(e)), {
        position: "absolute",
        top: -9999,
        zIndex: e.zIndexPopup,
        boxSizing: "border-box",
        padding: e.paddingXXS,
        overflow: "hidden",
        fontSize: e.fontSize,
        // Fix select render lag of long text in chrome
        // https://github.com/ant-design/ant-design/issues/11456
        // https://github.com/ant-design/ant-design/issues/11843
        fontVariant: "initial",
        backgroundColor: e.colorBgElevated,
        borderRadius: e.borderRadiusLG,
        outline: "none",
        boxShadow: e.boxShadowSecondary,
        [`
          ${i}${f}bottomLeft,
          ${c}${f}bottomLeft
        `]: {
          animationName: W9
        },
        [`
          ${i}${f}topLeft,
          ${c}${f}topLeft,
          ${i}${f}topRight,
          ${c}${f}topRight
        `]: {
          animationName: _9
        },
        [`${d}${f}bottomLeft`]: {
          animationName: V9
        },
        [`
          ${d}${f}topLeft,
          ${d}${f}topRight
        `]: {
          animationName: B9
        },
        "&-hidden": {
          display: "none"
        },
        [a]: Object.assign(Object.assign({}, HF(e)), {
          cursor: "pointer",
          transition: `background ${e.motionDurationSlow} ease`,
          borderRadius: e.borderRadiusSM,
          // =========== Group ============
          "&-group": {
            color: e.colorTextDescription,
            fontSize: e.fontSizeSM,
            cursor: "default"
          },
          // =========== Option ===========
          "&-option": {
            display: "flex",
            "&-content": Object.assign({
              flex: "auto"
            }, VS),
            "&-state": {
              flex: "none",
              display: "flex",
              alignItems: "center"
            },
            [`&-active:not(${a}-option-disabled)`]: {
              backgroundColor: e.optionActiveBg
            },
            [`&-selected:not(${a}-option-disabled)`]: {
              color: e.optionSelectedColor,
              fontWeight: e.optionSelectedFontWeight,
              backgroundColor: e.optionSelectedBg,
              [`${a}-option-state`]: {
                color: e.colorPrimary
              }
            },
            "&-disabled": {
              [`&${a}-option-selected`]: {
                backgroundColor: e.colorBgContainerDisabled
              },
              color: e.colorTextDisabled,
              cursor: "not-allowed"
            },
            "&-grouped": {
              paddingInlineStart: e.calc(e.controlPaddingHorizontal).mul(2).equal()
            }
          },
          "&-empty": Object.assign(Object.assign({}, HF(e)), {
            color: e.colorTextDisabled
          })
        }),
        // https://github.com/ant-design/ant-design/pull/46646
        [`${p}:has(+ ${p})`]: {
          borderEndStartRadius: 0,
          borderEndEndRadius: 0,
          [`& + ${p}`]: {
            borderStartStartRadius: 0,
            borderStartEndRadius: 0
          }
        },
        // =========================== RTL ===========================
        "&-rtl": {
          direction: "rtl"
        }
      })
    },
    // Follow code may reuse in other components
    BS(e, "slide-up"),
    BS(e, "slide-down"),
    Px(e, "move-up"),
    Px(e, "move-down")
  ];
}, pY = (e) => {
  const {
    multipleSelectItemHeight: t,
    paddingXXS: r,
    lineWidth: a,
    INTERNAL_FIXED_ITEM_MARGIN: i
  } = e, c = e.max(e.calc(r).sub(a).equal(), 0), d = e.max(e.calc(c).sub(i).equal(), 0);
  return {
    basePadding: c,
    containerPadding: d,
    itemHeight: Ye(t),
    itemLineHeight: Ye(e.calc(t).sub(e.calc(e.lineWidth).mul(2)).equal())
  };
}, c0e = (e) => {
  const {
    multipleSelectItemHeight: t,
    selectHeight: r,
    lineWidth: a
  } = e;
  return e.calc(r).sub(t).div(2).sub(a).equal();
}, gY = (e) => {
  const {
    componentCls: t,
    iconCls: r,
    borderRadiusSM: a,
    motionDurationSlow: i,
    paddingXS: c,
    multipleItemColorDisabled: d,
    multipleItemBorderColorDisabled: f,
    colorIcon: p,
    colorIconHover: g,
    INTERNAL_FIXED_ITEM_MARGIN: b
  } = e;
  return {
    /**
     * Do not merge `height` & `line-height` under style with `selection` & `search`, since chrome
     * may update to redesign with its align logic.
     */
    // =========================== Overflow ===========================
    [`${t}-selection-overflow`]: {
      position: "relative",
      display: "flex",
      flex: "auto",
      flexWrap: "wrap",
      maxWidth: "100%",
      "&-item": {
        flex: "none",
        alignSelf: "center",
        // https://github.com/ant-design/ant-design/issues/54179
        maxWidth: "calc(100% - 4px)",
        display: "inline-flex"
      },
      // ======================== Selections ==========================
      [`${t}-selection-item`]: {
        display: "flex",
        alignSelf: "center",
        flex: "none",
        boxSizing: "border-box",
        maxWidth: "100%",
        marginBlock: b,
        borderRadius: a,
        cursor: "default",
        transition: `font-size ${i}, line-height ${i}, height ${i}`,
        marginInlineEnd: e.calc(b).mul(2).equal(),
        paddingInlineStart: c,
        paddingInlineEnd: e.calc(c).div(2).equal(),
        [`${t}-disabled&`]: {
          color: d,
          borderColor: f,
          cursor: "not-allowed"
        },
        // It's ok not to do this, but 24px makes bottom narrow in view should adjust
        "&-content": {
          display: "inline-block",
          marginInlineEnd: e.calc(c).div(2).equal(),
          overflow: "hidden",
          whiteSpace: "pre",
          // fix whitespace wrapping. custom tags display all whitespace within.
          textOverflow: "ellipsis"
        },
        "&-remove": Object.assign(Object.assign({}, VE()), {
          display: "inline-flex",
          alignItems: "center",
          color: p,
          fontWeight: "bold",
          fontSize: 10,
          lineHeight: "inherit",
          cursor: "pointer",
          [`> ${r}`]: {
            verticalAlign: "-0.2em"
          },
          "&:hover": {
            color: g
          }
        })
      }
    }
  };
}, d0e = (e, t) => {
  const {
    componentCls: r,
    INTERNAL_FIXED_ITEM_MARGIN: a
  } = e, i = `${r}-selection-overflow`, c = e.multipleSelectItemHeight, d = c0e(e), f = t ? `${r}-${t}` : "", p = pY(e);
  return {
    [`${r}-multiple${f}`]: Object.assign(Object.assign({}, gY(e)), {
      // ========================= Selector =========================
      [`${r}-selector`]: {
        display: "flex",
        alignItems: "center",
        width: "100%",
        height: "100%",
        // Multiple is little different that horizontal is follow the vertical
        paddingInline: p.basePadding,
        paddingBlock: p.containerPadding,
        borderRadius: e.borderRadius,
        [`${r}-disabled&`]: {
          background: e.multipleSelectorBgDisabled,
          cursor: "not-allowed"
        },
        "&:after": {
          display: "inline-block",
          width: 0,
          margin: `${Ye(a)} 0`,
          lineHeight: Ye(c),
          visibility: "hidden",
          content: '"\\a0"'
        }
      },
      // ======================== Selections ========================
      [`${r}-selection-item`]: {
        height: p.itemHeight,
        lineHeight: Ye(p.itemLineHeight)
      },
      // ========================== Wrap ===========================
      [`${r}-selection-wrap`]: {
        alignSelf: "flex-start",
        "&:after": {
          lineHeight: Ye(c),
          marginBlock: a
        }
      },
      // ========================== Input ==========================
      [`${r}-prefix`]: {
        marginInlineStart: e.calc(e.inputPaddingHorizontalBase).sub(p.basePadding).equal()
      },
      [`${i}-item + ${i}-item,
        ${r}-prefix + ${r}-selection-wrap
      `]: {
        [`${r}-selection-search`]: {
          marginInlineStart: 0
        },
        [`${r}-selection-placeholder`]: {
          insetInlineStart: 0
        }
      },
      // https://github.com/ant-design/ant-design/issues/44754
      // Same as `wrap:after`
      [`${i}-item-suffix`]: {
        minHeight: p.itemHeight,
        marginBlock: a
      },
      [`${r}-selection-search`]: {
        display: "inline-flex",
        position: "relative",
        maxWidth: "100%",
        marginInlineStart: e.calc(e.inputPaddingHorizontalBase).sub(d).equal(),
        "\n          &-input,\n          &-mirror\n        ": {
          height: c,
          fontFamily: e.fontFamily,
          lineHeight: Ye(c),
          transition: `all ${e.motionDurationSlow}`
        },
        "&-input": {
          width: "100%",
          minWidth: 4.1
          // fix search cursor missing
        },
        "&-mirror": {
          position: "absolute",
          top: 0,
          insetInlineStart: 0,
          insetInlineEnd: "auto",
          zIndex: 999,
          whiteSpace: "pre",
          // fix whitespace wrapping caused width calculation bug
          visibility: "hidden"
        }
      },
      // ======================= Placeholder =======================
      [`${r}-selection-placeholder`]: {
        position: "absolute",
        top: "50%",
        insetInlineStart: e.calc(e.inputPaddingHorizontalBase).sub(p.basePadding).equal(),
        insetInlineEnd: e.inputPaddingHorizontalBase,
        transform: "translateY(-50%)",
        transition: `all ${e.motionDurationSlow}`
      }
    })
  };
};
function lR(e, t) {
  const {
    componentCls: r
  } = e, a = t ? `${r}-${t}` : "", i = {
    [`${r}-multiple${a}`]: {
      fontSize: e.fontSize,
      // ========================= Selector =========================
      [`${r}-selector`]: {
        [`${r}-show-search&`]: {
          cursor: "text"
        }
      },
      [`
        &${r}-show-arrow ${r}-selector,
        &${r}-allow-clear ${r}-selector
      `]: {
        paddingInlineEnd: e.calc(e.fontSizeIcon).add(e.controlPaddingHorizontal).equal()
      }
    }
  };
  return [d0e(e, t), i];
}
const f0e = (e) => {
  const {
    componentCls: t
  } = e, r = lo(e, {
    selectHeight: e.controlHeightSM,
    multipleSelectItemHeight: e.multipleItemHeightSM,
    borderRadius: e.borderRadiusSM,
    borderRadiusSM: e.borderRadiusXS
  }), a = lo(e, {
    fontSize: e.fontSizeLG,
    selectHeight: e.controlHeightLG,
    multipleSelectItemHeight: e.multipleItemHeightLG,
    borderRadius: e.borderRadiusLG,
    borderRadiusSM: e.borderRadius
  });
  return [
    lR(e),
    // ======================== Small ========================
    lR(r, "sm"),
    // Padding
    {
      [`${t}-multiple${t}-sm`]: {
        [`${t}-selection-placeholder`]: {
          insetInline: e.calc(e.controlPaddingHorizontalSM).sub(e.lineWidth).equal()
        },
        // https://github.com/ant-design/ant-design/issues/29559
        [`${t}-selection-search`]: {
          marginInlineStart: 2
          // Magic Number
        }
      }
    },
    // ======================== Large ========================
    lR(a, "lg")
  ];
};
function sR(e, t) {
  const {
    componentCls: r,
    inputPaddingHorizontalBase: a,
    borderRadius: i
  } = e, c = e.calc(e.controlHeight).sub(e.calc(e.lineWidth).mul(2)).equal(), d = t ? `${r}-${t}` : "";
  return {
    [`${r}-single${d}`]: {
      fontSize: e.fontSize,
      height: e.controlHeight,
      // ========================= Selector =========================
      [`${r}-selector`]: Object.assign(Object.assign({}, dl(e, !0)), {
        display: "flex",
        borderRadius: i,
        flex: "1 1 auto",
        [`${r}-selection-wrap:after`]: {
          lineHeight: Ye(c)
        },
        [`${r}-selection-search`]: {
          position: "absolute",
          inset: 0,
          width: "100%",
          "&-input": {
            width: "100%",
            WebkitAppearance: "textfield"
          }
        },
        [`
          ${r}-selection-item,
          ${r}-selection-placeholder
        `]: {
          display: "block",
          padding: 0,
          lineHeight: Ye(c),
          transition: `all ${e.motionDurationSlow}, visibility 0s`,
          alignSelf: "center"
        },
        [`${r}-selection-placeholder`]: {
          transition: "none",
          pointerEvents: "none"
        },
        // For common baseline align
        [[
          "&:after",
          /* For '' value baseline align */
          `${r}-selection-item:empty:after`,
          /* For undefined value baseline align */
          `${r}-selection-placeholder:empty:after`
        ].join(",")]: {
          display: "inline-block",
          width: 0,
          visibility: "hidden",
          content: '"\\a0"'
        }
      }),
      [`
        &${r}-show-arrow ${r}-selection-item,
        &${r}-show-arrow ${r}-selection-search,
        &${r}-show-arrow ${r}-selection-placeholder
      `]: {
        paddingInlineEnd: e.showArrowPaddingInlineEnd
      },
      // Opacity selection if open
      [`&${r}-open ${r}-selection-item`]: {
        color: e.colorTextPlaceholder
      },
      // ========================== Input ==========================
      // We only change the style of non-customize input which is only support by `combobox` mode.
      // Not customize
      [`&:not(${r}-customize-input)`]: {
        [`${r}-selector`]: {
          width: "100%",
          height: "100%",
          alignItems: "center",
          padding: `0 ${Ye(a)}`,
          [`${r}-selection-search-input`]: {
            height: c,
            fontSize: e.fontSize
          },
          "&:after": {
            lineHeight: Ye(c)
          }
        }
      },
      [`&${r}-customize-input`]: {
        [`${r}-selector`]: {
          "&:after": {
            display: "none"
          },
          [`${r}-selection-search`]: {
            position: "static",
            width: "100%"
          },
          [`${r}-selection-placeholder`]: {
            position: "absolute",
            insetInlineStart: 0,
            insetInlineEnd: 0,
            padding: `0 ${Ye(a)}`,
            "&:after": {
              display: "none"
            }
          }
        }
      }
    }
  };
}
function m0e(e) {
  const {
    componentCls: t
  } = e, r = e.calc(e.controlPaddingHorizontalSM).sub(e.lineWidth).equal();
  return [
    sR(e),
    // ======================== Small ========================
    // Shared
    sR(lo(e, {
      controlHeight: e.controlHeightSM,
      borderRadius: e.borderRadiusSM
    }), "sm"),
    // padding
    {
      [`${t}-single${t}-sm`]: {
        [`&:not(${t}-customize-input)`]: {
          [`${t}-selector`]: {
            padding: `0 ${Ye(r)}`
          },
          // With arrow should provides `padding-right` to show the arrow
          [`&${t}-show-arrow ${t}-selection-search`]: {
            insetInlineEnd: e.calc(r).add(e.calc(e.fontSize).mul(1.5)).equal()
          },
          [`
            &${t}-show-arrow ${t}-selection-item,
            &${t}-show-arrow ${t}-selection-placeholder
          `]: {
            paddingInlineEnd: e.calc(e.fontSize).mul(1.5).equal()
          }
        }
      }
    },
    // ======================== Large ========================
    // Shared
    sR(lo(e, {
      controlHeight: e.singleItemHeightLG,
      fontSize: e.fontSizeLG,
      borderRadius: e.borderRadiusLG
    }), "lg")
  ];
}
const h0e = (e) => {
  const {
    fontSize: t,
    lineHeight: r,
    lineWidth: a,
    controlHeight: i,
    controlHeightSM: c,
    controlHeightLG: d,
    paddingXXS: f,
    controlPaddingHorizontal: p,
    zIndexPopupBase: g,
    colorText: b,
    fontWeightStrong: w,
    controlItemBgActive: x,
    controlItemBgHover: E,
    colorBgContainer: P,
    colorFillSecondary: k,
    colorBgContainerDisabled: M,
    colorTextDisabled: T,
    colorPrimaryHover: N,
    colorPrimary: D,
    controlOutline: $
  } = e, j = f * 2, I = a * 2, L = Math.min(i - j, i - I), F = Math.min(c - j, c - I), _ = Math.min(d - j, d - I);
  return {
    INTERNAL_FIXED_ITEM_MARGIN: Math.floor(f / 2),
    zIndexPopup: g + 50,
    optionSelectedColor: b,
    optionSelectedFontWeight: w,
    optionSelectedBg: x,
    optionActiveBg: E,
    optionPadding: `${(i - t * r) / 2}px ${p}px`,
    optionFontSize: t,
    optionLineHeight: r,
    optionHeight: i,
    selectorBg: P,
    clearBg: P,
    singleItemHeightLG: d,
    multipleItemBg: k,
    multipleItemBorderColor: "transparent",
    multipleItemHeight: L,
    multipleItemHeightSM: F,
    multipleItemHeightLG: _,
    multipleSelectorBgDisabled: M,
    multipleItemColorDisabled: T,
    multipleItemBorderColorDisabled: "transparent",
    showArrowPaddingInlineEnd: Math.ceil(e.fontSize * 1.25),
    hoverBorderColor: N,
    activeBorderColor: D,
    activeOutlineColor: $,
    selectAffixPadding: f
  };
}, vY = (e, t) => {
  const {
    componentCls: r,
    antCls: a,
    controlOutlineWidth: i
  } = e;
  return {
    [`&:not(${r}-customize-input) ${r}-selector`]: {
      border: `${Ye(e.lineWidth)} ${e.lineType} ${t.borderColor}`,
      background: e.selectorBg
    },
    [`&:not(${r}-disabled):not(${r}-customize-input):not(${a}-pagination-size-changer)`]: {
      [`&:hover ${r}-selector`]: {
        borderColor: t.hoverBorderHover
      },
      [`${r}-focused& ${r}-selector`]: {
        borderColor: t.activeBorderColor,
        boxShadow: `0 0 0 ${Ye(i)} ${t.activeOutlineColor}`,
        outline: 0
      },
      [`${r}-prefix`]: {
        color: t.color
      }
    }
  };
}, FF = (e, t) => ({
  [`&${e.componentCls}-status-${t.status}`]: Object.assign({}, vY(e, t))
}), p0e = (e) => ({
  "&-outlined": Object.assign(Object.assign(Object.assign(Object.assign({}, vY(e, {
    borderColor: e.colorBorder,
    hoverBorderHover: e.hoverBorderColor,
    activeBorderColor: e.activeBorderColor,
    activeOutlineColor: e.activeOutlineColor,
    color: e.colorText
  })), FF(e, {
    status: "error",
    borderColor: e.colorError,
    hoverBorderHover: e.colorErrorHover,
    activeBorderColor: e.colorError,
    activeOutlineColor: e.colorErrorOutline,
    color: e.colorError
  })), FF(e, {
    status: "warning",
    borderColor: e.colorWarning,
    hoverBorderHover: e.colorWarningHover,
    activeBorderColor: e.colorWarning,
    activeOutlineColor: e.colorWarningOutline,
    color: e.colorWarning
  })), {
    [`&${e.componentCls}-disabled`]: {
      [`&:not(${e.componentCls}-customize-input) ${e.componentCls}-selector`]: {
        background: e.colorBgContainerDisabled,
        color: e.colorTextDisabled
      }
    },
    [`&${e.componentCls}-multiple ${e.componentCls}-selection-item`]: {
      background: e.multipleItemBg,
      border: `${Ye(e.lineWidth)} ${e.lineType} ${e.multipleItemBorderColor}`
    }
  })
}), bY = (e, t) => {
  const {
    componentCls: r,
    antCls: a
  } = e;
  return {
    [`&:not(${r}-customize-input) ${r}-selector`]: {
      background: t.bg,
      border: `${Ye(e.lineWidth)} ${e.lineType} transparent`,
      color: t.color
    },
    [`&:not(${r}-disabled):not(${r}-customize-input):not(${a}-pagination-size-changer)`]: {
      [`&:hover ${r}-selector`]: {
        background: t.hoverBg
      },
      [`${r}-focused& ${r}-selector`]: {
        background: e.selectorBg,
        borderColor: t.activeBorderColor,
        outline: 0
      }
    }
  };
}, WF = (e, t) => ({
  [`&${e.componentCls}-status-${t.status}`]: Object.assign({}, bY(e, t))
}), g0e = (e) => ({
  "&-filled": Object.assign(Object.assign(Object.assign(Object.assign({}, bY(e, {
    bg: e.colorFillTertiary,
    hoverBg: e.colorFillSecondary,
    activeBorderColor: e.activeBorderColor,
    color: e.colorText
  })), WF(e, {
    status: "error",
    bg: e.colorErrorBg,
    hoverBg: e.colorErrorBgHover,
    activeBorderColor: e.colorError,
    color: e.colorError
  })), WF(e, {
    status: "warning",
    bg: e.colorWarningBg,
    hoverBg: e.colorWarningBgHover,
    activeBorderColor: e.colorWarning,
    color: e.colorWarning
  })), {
    [`&${e.componentCls}-disabled`]: {
      [`&:not(${e.componentCls}-customize-input) ${e.componentCls}-selector`]: {
        borderColor: e.colorBorder,
        background: e.colorBgContainerDisabled,
        color: e.colorTextDisabled
      }
    },
    [`&${e.componentCls}-multiple ${e.componentCls}-selection-item`]: {
      background: e.colorBgContainer,
      border: `${Ye(e.lineWidth)} ${e.lineType} ${e.colorSplit}`
    }
  })
}), v0e = (e) => ({
  "&-borderless": {
    [`${e.componentCls}-selector`]: {
      background: "transparent",
      border: `${Ye(e.lineWidth)} ${e.lineType} transparent`
    },
    [`&${e.componentCls}-disabled`]: {
      [`&:not(${e.componentCls}-customize-input) ${e.componentCls}-selector`]: {
        color: e.colorTextDisabled
      }
    },
    [`&${e.componentCls}-multiple ${e.componentCls}-selection-item`]: {
      background: e.multipleItemBg,
      border: `${Ye(e.lineWidth)} ${e.lineType} ${e.multipleItemBorderColor}`
    },
    // Status
    [`&${e.componentCls}-status-error`]: {
      [`${e.componentCls}-prefix, ${e.componentCls}-selection-item`]: {
        color: e.colorError
      }
    },
    [`&${e.componentCls}-status-warning`]: {
      [`${e.componentCls}-prefix, ${e.componentCls}-selection-item`]: {
        color: e.colorWarning
      }
    }
  }
}), yY = (e, t) => {
  const {
    componentCls: r,
    antCls: a
  } = e;
  return {
    [`&:not(${r}-customize-input) ${r}-selector`]: {
      borderWidth: `${Ye(e.lineWidth)} 0`,
      borderStyle: `${e.lineType} none`,
      borderColor: `transparent transparent ${t.borderColor} transparent`,
      background: e.selectorBg,
      borderRadius: 0
    },
    [`&:not(${r}-disabled):not(${r}-customize-input):not(${a}-pagination-size-changer)`]: {
      [`&:hover ${r}-selector`]: {
        borderColor: `transparent transparent ${t.hoverBorderHover} transparent`
      },
      [`${r}-focused& ${r}-selector`]: {
        borderColor: `transparent transparent ${t.activeBorderColor} transparent`,
        outline: 0
      },
      [`${r}-prefix`]: {
        color: t.color
      }
    }
  };
}, VF = (e, t) => ({
  [`&${e.componentCls}-status-${t.status}`]: Object.assign({}, yY(e, t))
}), b0e = (e) => ({
  "&-underlined": Object.assign(Object.assign(Object.assign(Object.assign({}, yY(e, {
    borderColor: e.colorBorder,
    hoverBorderHover: e.hoverBorderColor,
    activeBorderColor: e.activeBorderColor,
    activeOutlineColor: e.activeOutlineColor,
    color: e.colorText
  })), VF(e, {
    status: "error",
    borderColor: e.colorError,
    hoverBorderHover: e.colorErrorHover,
    activeBorderColor: e.colorError,
    activeOutlineColor: e.colorErrorOutline,
    color: e.colorError
  })), VF(e, {
    status: "warning",
    borderColor: e.colorWarning,
    hoverBorderHover: e.colorWarningHover,
    activeBorderColor: e.colorWarning,
    activeOutlineColor: e.colorWarningOutline,
    color: e.colorWarning
  })), {
    [`&${e.componentCls}-disabled`]: {
      [`&:not(${e.componentCls}-customize-input) ${e.componentCls}-selector`]: {
        color: e.colorTextDisabled
      }
    },
    [`&${e.componentCls}-multiple ${e.componentCls}-selection-item`]: {
      background: e.multipleItemBg,
      border: `${Ye(e.lineWidth)} ${e.lineType} ${e.multipleItemBorderColor}`
    }
  })
}), y0e = (e) => ({
  [e.componentCls]: Object.assign(Object.assign(Object.assign(Object.assign({}, p0e(e)), g0e(e)), v0e(e)), b0e(e))
}), w0e = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    position: "relative",
    transition: `all ${e.motionDurationMid} ${e.motionEaseInOut}`,
    input: {
      cursor: "pointer"
    },
    [`${t}-show-search&`]: {
      cursor: "text",
      input: {
        cursor: "auto",
        color: "inherit",
        height: "100%"
      }
    },
    [`${t}-disabled&`]: {
      cursor: "not-allowed",
      input: {
        cursor: "not-allowed"
      }
    }
  };
}, S0e = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-selection-search-input`]: {
      margin: 0,
      padding: 0,
      background: "transparent",
      border: "none",
      outline: "none",
      appearance: "none",
      fontFamily: "inherit",
      "&::-webkit-search-cancel-button": {
        display: "none",
        appearance: "none"
      }
    }
  };
}, C0e = (e) => {
  const {
    antCls: t,
    componentCls: r,
    inputPaddingHorizontalBase: a,
    iconCls: i
  } = e, c = {
    [`${r}-clear`]: {
      opacity: 1,
      background: e.colorBgBase,
      borderRadius: "50%"
    }
  };
  return {
    [r]: Object.assign(Object.assign({}, dl(e)), {
      position: "relative",
      display: "inline-flex",
      cursor: "pointer",
      [`&:not(${r}-customize-input) ${r}-selector`]: Object.assign(Object.assign({}, w0e(e)), S0e(e)),
      // ======================== Selection ========================
      [`${r}-selection-item`]: Object.assign(Object.assign({
        flex: 1,
        fontWeight: "normal",
        position: "relative",
        userSelect: "none"
      }, VS), {
        // https://github.com/ant-design/ant-design/issues/40421
        [`> ${t}-typography`]: {
          display: "inline"
        }
      }),
      // ======================= Placeholder =======================
      [`${r}-selection-placeholder`]: Object.assign(Object.assign({}, VS), {
        flex: 1,
        color: e.colorTextPlaceholder,
        pointerEvents: "none"
      }),
      // ========================== Arrow ==========================
      [`${r}-arrow`]: Object.assign(Object.assign({}, VE()), {
        position: "absolute",
        top: "50%",
        insetInlineStart: "auto",
        insetInlineEnd: a,
        height: e.fontSizeIcon,
        marginTop: e.calc(e.fontSizeIcon).mul(-1).div(2).equal(),
        color: e.colorTextQuaternary,
        fontSize: e.fontSizeIcon,
        lineHeight: 1,
        textAlign: "center",
        pointerEvents: "none",
        display: "flex",
        alignItems: "center",
        transition: `opacity ${e.motionDurationSlow} ease`,
        [i]: {
          verticalAlign: "top",
          transition: `transform ${e.motionDurationSlow}`,
          "> svg": {
            verticalAlign: "top"
          },
          [`&:not(${r}-suffix)`]: {
            pointerEvents: "auto"
          }
        },
        [`${r}-disabled &`]: {
          cursor: "not-allowed"
        },
        "> *:not(:last-child)": {
          marginInlineEnd: 8
          // FIXME: magic
        }
      }),
      // ========================== Wrap ===========================
      [`${r}-selection-wrap`]: {
        display: "flex",
        width: "100%",
        position: "relative",
        minWidth: 0,
        // https://github.com/ant-design/ant-design/issues/51669
        "&:after": {
          content: '"\\a0"',
          width: 0,
          overflow: "hidden"
        }
      },
      // ========================= Prefix ==========================
      [`${r}-prefix`]: {
        flex: "none",
        marginInlineEnd: e.selectAffixPadding
      },
      // ========================== Clear ==========================
      [`${r}-clear`]: {
        position: "absolute",
        top: "50%",
        insetInlineStart: "auto",
        insetInlineEnd: a,
        zIndex: 1,
        display: "inline-block",
        width: e.fontSizeIcon,
        height: e.fontSizeIcon,
        marginTop: e.calc(e.fontSizeIcon).mul(-1).div(2).equal(),
        color: e.colorTextQuaternary,
        fontSize: e.fontSizeIcon,
        fontStyle: "normal",
        lineHeight: 1,
        textAlign: "center",
        textTransform: "none",
        cursor: "pointer",
        opacity: 0,
        transition: `color ${e.motionDurationMid} ease, opacity ${e.motionDurationSlow} ease`,
        textRendering: "auto",
        // https://github.com/ant-design/ant-design/issues/54205
        // Force GPU compositing on Safari to prevent flickering on opacity/transform transitions
        transform: "translateZ(0)",
        "&:before": {
          display: "block"
        },
        "&:hover": {
          color: e.colorIcon
        }
      },
      "@media(hover:none)": c,
      "&:hover": c
    }),
    // ========================= Feedback ==========================
    [`${r}-status`]: {
      "&-error, &-warning, &-success, &-validating": {
        [`&${r}-has-feedback`]: {
          [`${r}-clear`]: {
            insetInlineEnd: e.calc(a).add(e.fontSize).add(e.paddingXS).equal()
          }
        }
      }
    }
  };
}, x0e = (e) => {
  const {
    componentCls: t
  } = e;
  return [
    {
      [t]: {
        // ==================== In Form ====================
        [`&${t}-in-form-item`]: {
          width: "100%"
        }
      }
    },
    // =====================================================
    // ==                       LTR                       ==
    // =====================================================
    // Base
    C0e(e),
    // Single
    m0e(e),
    // Multiple
    f0e(e),
    // Dropdown
    u0e(e),
    // =====================================================
    // ==                       RTL                       ==
    // =====================================================
    {
      [`${t}-rtl`]: {
        direction: "rtl"
      }
    },
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    XE(e, {
      borderElCls: `${t}-selector`,
      focusElCls: `${t}-focused`
    })
  ];
}, E0e = Ii("Select", (e, {
  rootPrefixCls: t
}) => {
  const r = lo(e, {
    rootPrefixCls: t,
    inputPaddingHorizontalBase: e.calc(e.paddingSM).sub(1).equal(),
    multipleSelectItemHeight: e.multipleItemHeight,
    selectHeight: e.controlHeight
  });
  return [x0e(r), y0e(r)];
}, h0e, {
  unitless: {
    optionLineHeight: !0,
    optionSelectedFontWeight: !0
  }
});
var P0e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" } }] }, name: "check", theme: "outlined" }, k0e = function(t, r) {
  return /* @__PURE__ */ S.createElement(Ao, vt({}, t, {
    ref: r,
    icon: P0e
  }));
}, ej = /* @__PURE__ */ S.forwardRef(k0e);
process.env.NODE_ENV !== "production" && (ej.displayName = "CheckOutlined");
var M0e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z" } }] }, name: "down", theme: "outlined" }, O0e = function(t, r) {
  return /* @__PURE__ */ S.createElement(Ao, vt({}, t, {
    ref: r,
    icon: M0e
  }));
}, tj = /* @__PURE__ */ S.forwardRef(O0e);
process.env.NODE_ENV !== "production" && (tj.displayName = "DownOutlined");
var T0e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" } }] }, name: "search", theme: "outlined" }, R0e = function(t, r) {
  return /* @__PURE__ */ S.createElement(Ao, vt({}, t, {
    ref: r,
    icon: T0e
  }));
}, nj = /* @__PURE__ */ S.forwardRef(R0e);
process.env.NODE_ENV !== "production" && (nj.displayName = "SearchOutlined");
function wY({
  suffixIcon: e,
  clearIcon: t,
  menuItemSelectedIcon: r,
  removeIcon: a,
  loading: i,
  multiple: c,
  hasFeedback: d,
  prefixCls: f,
  showSuffixIcon: p,
  feedbackIcon: g,
  showArrow: b,
  componentName: w
}) {
  process.env.NODE_ENV !== "production" && To(w).deprecated(!t, "clearIcon", "allowClear={{ clearIcon: React.ReactNode }}");
  const x = t ?? /* @__PURE__ */ S.createElement(_x, null), E = (T) => e === null && !d && !b ? null : /* @__PURE__ */ S.createElement(S.Fragment, null, p !== !1 && T, d && g);
  let P = null;
  if (e !== void 0)
    P = E(e);
  else if (i)
    P = E(/* @__PURE__ */ S.createElement(xx, {
      spin: !0
    }));
  else {
    const T = `${f}-suffix`;
    P = ({
      open: N,
      showSearch: D
    }) => E(N && D ? /* @__PURE__ */ S.createElement(nj, {
      className: T
    }) : /* @__PURE__ */ S.createElement(tj, {
      className: T
    }));
  }
  let k = null;
  r !== void 0 ? k = r : c ? k = /* @__PURE__ */ S.createElement(ej, null) : k = null;
  let M = null;
  return a !== void 0 ? M = a : M = /* @__PURE__ */ S.createElement(Bx, null), {
    clearIcon: x,
    suffixIcon: P,
    itemIcon: k,
    removeIcon: M
  };
}
function A0e(e) {
  return Re.useMemo(() => {
    if (e)
      return (...t) => /* @__PURE__ */ Re.createElement(dS, {
        space: !0
      }, e.apply(void 0, t));
  }, [e]);
}
function N0e(e, t) {
  return t !== void 0 ? t : e !== null;
}
var D0e = function(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
    t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
};
const SY = "SECRET_COMBOBOX_MODE_DO_NOT_USE", CY = (e, t) => {
  var r, a, i, c, d;
  const {
    prefixCls: f,
    bordered: p,
    className: g,
    rootClassName: b,
    getPopupContainer: w,
    popupClassName: x,
    dropdownClassName: E,
    listHeight: P = 256,
    placement: k,
    listItemHeight: M,
    size: T,
    disabled: N,
    notFoundContent: D,
    status: $,
    builtinPlacements: j,
    dropdownMatchSelectWidth: I,
    popupMatchSelectWidth: L,
    direction: F,
    style: _,
    allowClear: W,
    variant: Q,
    dropdownStyle: U,
    transitionName: Y,
    tagRender: G,
    maxCount: J,
    prefix: H,
    dropdownRender: K,
    popupRender: X,
    onDropdownVisibleChange: te,
    onOpenChange: ie,
    styles: ee,
    classNames: ne
  } = e, ae = D0e(e, ["prefixCls", "bordered", "className", "rootClassName", "getPopupContainer", "popupClassName", "dropdownClassName", "listHeight", "placement", "listItemHeight", "size", "disabled", "notFoundContent", "status", "builtinPlacements", "dropdownMatchSelectWidth", "popupMatchSelectWidth", "direction", "style", "allowClear", "variant", "dropdownStyle", "transitionName", "tagRender", "maxCount", "prefix", "dropdownRender", "popupRender", "onDropdownVisibleChange", "onOpenChange", "styles", "classNames"]), {
    getPopupContainer: oe,
    getPrefixCls: fe,
    renderEmpty: be,
    direction: me,
    virtual: De,
    popupMatchSelectWidth: Me,
    popupOverflow: ze
  } = S.useContext(Qr), {
    showSearch: le,
    style: se,
    styles: Ae,
    className: we,
    classNames: Ne
  } = om("select"), [, pe] = Bf(), Qe = M ?? pe?.controlHeight, Le = fe("select", f), Te = fe(), Oe = F ?? me, {
    compactSize: ye,
    compactItemClassnames: je
  } = h3(Le, Oe), [Ue, Fe] = t7("select", Q, p), tt = Qh(Le), [dt, St, mt] = E0e(Le, tt), Ot = S.useMemo(() => {
    const {
      mode: Ft
    } = e;
    if (Ft !== "combobox")
      return Ft === SY ? "combobox" : Ft;
  }, [e.mode]), Rt = Ot === "multiple" || Ot === "tags", ct = N0e(e.suffixIcon, e.showArrow), it = (r = L ?? I) !== null && r !== void 0 ? r : Me, Ct = ((a = ee?.popup) === null || a === void 0 ? void 0 : a.root) || ((i = Ae.popup) === null || i === void 0 ? void 0 : i.root) || U, ut = A0e(X || K), ht = ie || te, {
    status: ot,
    hasFeedback: at,
    isFormItemInput: ft,
    feedbackIcon: st
  } = S.useContext(yb), pt = tM(ot, $);
  let bt;
  D !== void 0 ? bt = D : Ot === "combobox" ? bt = null : bt = be?.("Select") || /* @__PURE__ */ S.createElement(hY, {
    componentName: "Select"
  });
  const {
    suffixIcon: Nt,
    itemIcon: $t,
    removeIcon: Pt,
    clearIcon: hn
  } = wY(Object.assign(Object.assign({}, ae), {
    multiple: Rt,
    hasFeedback: at,
    feedbackIcon: st,
    showSuffixIcon: ct,
    prefixCls: Le,
    componentName: "Select"
  })), an = W === !0 ? {
    clearIcon: hn
  } : W, jn = Rs(ae, ["suffixIcon", "itemIcon"]), xn = _e(((c = ne?.popup) === null || c === void 0 ? void 0 : c.root) || ((d = Ne?.popup) === null || d === void 0 ? void 0 : d.root) || x || E, {
    [`${Le}-dropdown-${Oe}`]: Oe === "rtl"
  }, b, Ne.root, ne?.root, mt, tt, St), Ut = Cb((Ft) => {
    var yn;
    return (yn = T ?? ye) !== null && yn !== void 0 ? yn : Ft;
  }), pn = S.useContext(A0), wn = N ?? pn, Lt = _e({
    [`${Le}-lg`]: Ut === "large",
    [`${Le}-sm`]: Ut === "small",
    [`${Le}-rtl`]: Oe === "rtl",
    [`${Le}-${Ue}`]: Fe,
    [`${Le}-in-form-item`]: ft
  }, NE(Le, pt, at), je, we, g, Ne.root, ne?.root, b, mt, tt, St), gt = S.useMemo(() => k !== void 0 ? k : Oe === "rtl" ? "bottomRight" : "bottomLeft", [k, Oe]);
  if (process.env.NODE_ENV !== "production") {
    const Ft = To("Select");
    Object.entries({
      dropdownMatchSelectWidth: "popupMatchSelectWidth",
      dropdownStyle: "styles.popup.root",
      dropdownClassName: "classNames.popup.root",
      popupClassName: "classNames.popup.root",
      dropdownRender: "popupRender",
      onDropdownVisibleChange: "onOpenChange",
      bordered: "variant"
    }).forEach(([gn, Tn]) => {
      Ft.deprecated(!(gn in e), gn, Tn);
    }), process.env.NODE_ENV !== "production" && Ft(!("showArrow" in e), "deprecated", "`showArrow` is deprecated which will be removed in next major version. It will be a default behavior, you can hide it by setting `suffixIcon` to null."), process.env.NODE_ENV !== "production" && Ft(!(typeof J < "u" && !Rt), "usage", "`maxCount` only works with mode `multiple` or `tags`");
  }
  const [wt] = vS("SelectLike", Ct?.zIndex);
  return dt(/* @__PURE__ */ S.createElement(Zz, Object.assign({
    ref: t,
    virtual: De,
    showSearch: le
  }, jn, {
    style: Object.assign(Object.assign(Object.assign(Object.assign({}, Ae.root), ee?.root), se), _),
    dropdownMatchSelectWidth: it,
    transitionName: uS(Te, "slide-up", Y),
    builtinPlacements: s0e(j, ze),
    listHeight: P,
    listItemHeight: Qe,
    mode: Ot,
    prefixCls: Le,
    placement: gt,
    direction: Oe,
    prefix: H,
    suffixIcon: Nt,
    menuItemSelectedIcon: $t,
    removeIcon: Pt,
    allowClear: an,
    notFoundContent: bt,
    className: Lt,
    getPopupContainer: w || oe,
    dropdownClassName: xn,
    disabled: wn,
    dropdownStyle: Object.assign(Object.assign({}, Ct), {
      zIndex: wt
    }),
    maxCount: Rt ? J : void 0,
    tagRender: Rt ? G : void 0,
    dropdownRender: ut,
    onDropdownVisibleChange: ht
  })));
};
process.env.NODE_ENV !== "production" && (CY.displayName = "Select");
const B1 = /* @__PURE__ */ S.forwardRef(CY), $0e = Gx(B1, "dropdownAlign");
B1.SECRET_COMBOBOX_MODE_DO_NOT_USE = SY;
B1.Option = Qz;
B1.OptGroup = Yz;
B1._InternalPanelDoNotUseOrYouWillBeFired = $0e;
process.env.NODE_ENV !== "production" && (B1.displayName = "Select");
const {
  Option: _F
} = B1;
function BF(e) {
  return e?.type && (e.type.isSelectOption || e.type.isSelectOptGroup);
}
const z0e = (e, t) => {
  var r, a;
  const {
    prefixCls: i,
    className: c,
    popupClassName: d,
    dropdownClassName: f,
    children: p,
    dataSource: g,
    dropdownStyle: b,
    dropdownRender: w,
    popupRender: x,
    onDropdownVisibleChange: E,
    onOpenChange: P,
    styles: k,
    classNames: M
  } = e, T = Kh(p), N = ((r = k?.popup) === null || r === void 0 ? void 0 : r.root) || b, D = ((a = M?.popup) === null || a === void 0 ? void 0 : a.root) || d || f, $ = x || w, j = P || E;
  let I;
  T.length === 1 && /* @__PURE__ */ S.isValidElement(T[0]) && !BF(T[0]) && ([I] = T);
  const L = I ? () => I : void 0;
  let F;
  if (T.length && BF(T[0]) ? F = p : F = g ? g.map((U) => {
    if (/* @__PURE__ */ S.isValidElement(U))
      return U;
    switch (typeof U) {
      case "string":
        return /* @__PURE__ */ S.createElement(_F, {
          key: U,
          value: U
        }, U);
      case "object": {
        const {
          value: Y
        } = U;
        return /* @__PURE__ */ S.createElement(_F, {
          key: Y,
          value: Y
        }, U.text);
      }
      default:
        return;
    }
  }) : [], process.env.NODE_ENV !== "production") {
    const U = To("AutoComplete");
    process.env.NODE_ENV !== "production" && U(!I || !("size" in e), "usage", "You need to control style self instead of setting `size` when using customize input."), Object.entries({
      dropdownMatchSelectWidth: "popupMatchSelectWidth",
      dropdownStyle: "styles.popup.root",
      dropdownClassName: "classNames.popup.root",
      popupClassName: "classNames.popup.root",
      dropdownRender: "popupRender",
      onDropdownVisibleChange: "onOpenChange",
      dataSource: "options"
    }).forEach(([G, J]) => {
      U.deprecated(!(G in e), G, J);
    });
  }
  const {
    getPrefixCls: _
  } = S.useContext(Qr), W = _("select", i), [Q] = vS("SelectLike", N?.zIndex);
  return /* @__PURE__ */ S.createElement(B1, Object.assign({
    ref: t,
    suffixIcon: null
  }, Rs(e, ["dataSource", "dropdownClassName", "popupClassName"]), {
    prefixCls: W,
    classNames: {
      popup: {
        root: D
      },
      root: M?.root
    },
    styles: {
      popup: {
        root: Object.assign(Object.assign({}, N), {
          zIndex: Q
        })
      },
      root: k?.root
    },
    className: _e(`${W}-auto-complete`, c),
    mode: B1.SECRET_COMBOBOX_MODE_DO_NOT_USE,
    popupRender: $,
    onOpenChange: j,
    // Internal api
    getInputElement: L
  }), F);
}, rj = /* @__PURE__ */ S.forwardRef(z0e);
process.env.NODE_ENV !== "production" && (rj.displayName = "AutoComplete");
const {
  Option: j0e
} = B1, I0e = Gx(rj, "dropdownAlign", (e) => Rs(e, ["visible"])), aj = rj;
aj.Option = j0e;
aj._InternalPanelDoNotUseOrYouWillBeFired = I0e;
const xY = (e, t) => {
  typeof e?.addEventListener < "u" ? e.addEventListener("change", t) : typeof e?.addListener < "u" && e.addListener(t);
}, EY = (e, t) => {
  typeof e?.removeEventListener < "u" ? e.removeEventListener("change", t) : typeof e?.removeListener < "u" && e.removeListener(t);
}, PY = ["xxl", "xl", "lg", "md", "sm", "xs"], L0e = (e) => ({
  xs: `(max-width: ${e.screenXSMax}px)`,
  sm: `(min-width: ${e.screenSM}px)`,
  md: `(min-width: ${e.screenMD}px)`,
  lg: `(min-width: ${e.screenLG}px)`,
  xl: `(min-width: ${e.screenXL}px)`,
  xxl: `(min-width: ${e.screenXXL}px)`
}), H0e = (e) => {
  const t = e, r = [].concat(PY).reverse();
  return r.forEach((a, i) => {
    const c = a.toUpperCase(), d = `screen${c}Min`, f = `screen${c}`;
    if (!(t[d] <= t[f]))
      throw new Error(`${d}<=${f} fails : !(${t[d]}<=${t[f]})`);
    if (i < r.length - 1) {
      const p = `screen${c}Max`;
      if (!(t[f] <= t[p]))
        throw new Error(`${f}<=${p} fails : !(${t[f]}<=${t[p]})`);
      const b = `screen${r[i + 1].toUpperCase()}Min`;
      if (!(t[p] <= t[b]))
        throw new Error(`${p}<=${b} fails : !(${t[p]}<=${t[b]})`);
    }
  }), e;
}, F0e = () => {
  const [, e] = Bf(), t = L0e(H0e(e));
  return Re.useMemo(() => {
    const r = /* @__PURE__ */ new Map();
    let a = -1, i = {};
    return {
      responsiveMap: t,
      matchHandlers: {},
      dispatch(c) {
        return i = c, r.forEach((d) => d(i)), r.size >= 1;
      },
      subscribe(c) {
        return r.size || this.register(), a += 1, r.set(a, c), c(i), a;
      },
      unsubscribe(c) {
        r.delete(c), r.size || this.unregister();
      },
      register() {
        Object.entries(t).forEach(([c, d]) => {
          const f = ({
            matches: g
          }) => {
            this.dispatch(Object.assign(Object.assign({}, i), {
              [c]: g
            }));
          }, p = window.matchMedia(d);
          xY(p, f), this.matchHandlers[d] = {
            mql: p,
            listener: f
          }, f(p);
        });
      },
      unregister() {
        Object.values(t).forEach((c) => {
          const d = this.matchHandlers[c];
          EY(d?.mql, d?.listener);
        }), r.clear();
      }
    };
  }, [t]);
};
function oj(e = !0, t = {}) {
  const r = It(t), [, a] = Lz(), i = F0e();
  return Da(() => {
    const c = i.subscribe((d) => {
      r.current = d, e && a();
    });
    return () => i.unsubscribe(c);
  }, []), r.current;
}
const DD = /* @__PURE__ */ S.createContext({}), W0e = (e) => {
  const {
    antCls: t,
    componentCls: r,
    iconCls: a,
    avatarBg: i,
    avatarColor: c,
    containerSize: d,
    containerSizeLG: f,
    containerSizeSM: p,
    textFontSize: g,
    textFontSizeLG: b,
    textFontSizeSM: w,
    iconFontSize: x,
    iconFontSizeLG: E,
    iconFontSizeSM: P,
    borderRadius: k,
    borderRadiusLG: M,
    borderRadiusSM: T,
    lineWidth: N,
    lineType: D
  } = e, $ = (j, I, L, F) => ({
    width: j,
    height: j,
    borderRadius: "50%",
    fontSize: I,
    [`&${r}-square`]: {
      borderRadius: F
    },
    [`&${r}-icon`]: {
      fontSize: L,
      [`> ${a}`]: {
        margin: 0
      }
    }
  });
  return {
    [r]: Object.assign(Object.assign(Object.assign(Object.assign({}, dl(e)), {
      position: "relative",
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      overflow: "hidden",
      color: c,
      whiteSpace: "nowrap",
      textAlign: "center",
      verticalAlign: "middle",
      background: i,
      border: `${Ye(N)} ${D} transparent`,
      "&-image": {
        background: "transparent"
      },
      [`${t}-image-img`]: {
        display: "block"
      }
    }), $(d, g, x, k)), {
      "&-lg": Object.assign({}, $(f, b, E, M)),
      "&-sm": Object.assign({}, $(p, w, P, T)),
      "> img": {
        display: "block",
        width: "100%",
        height: "100%",
        objectFit: "cover"
      }
    })
  };
}, V0e = (e) => {
  const {
    componentCls: t,
    groupBorderColor: r,
    groupOverlapping: a,
    groupSpace: i
  } = e;
  return {
    [`${t}-group`]: {
      display: "inline-flex",
      [t]: {
        borderColor: r
      },
      "> *:not(:first-child)": {
        marginInlineStart: a
      }
    },
    [`${t}-group-popover`]: {
      [`${t} + ${t}`]: {
        marginInlineStart: i
      }
    }
  };
}, _0e = (e) => {
  const {
    controlHeight: t,
    controlHeightLG: r,
    controlHeightSM: a,
    fontSize: i,
    fontSizeLG: c,
    fontSizeXL: d,
    fontSizeHeading3: f,
    marginXS: p,
    marginXXS: g,
    colorBorderBg: b
  } = e;
  return {
    containerSize: t,
    containerSizeLG: r,
    containerSizeSM: a,
    textFontSize: i,
    textFontSizeLG: i,
    textFontSizeSM: i,
    iconFontSize: Math.round((c + d) / 2),
    iconFontSizeLG: f,
    iconFontSizeSM: i,
    groupSpace: g,
    groupOverlapping: -p,
    groupBorderColor: b
  };
}, kY = Ii("Avatar", (e) => {
  const {
    colorTextLightSolid: t,
    colorTextPlaceholder: r
  } = e, a = lo(e, {
    avatarBg: r,
    avatarColor: t
  });
  return [W0e(a), V0e(a)];
}, _0e);
var B0e = function(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
    t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
};
const ij = /* @__PURE__ */ S.forwardRef((e, t) => {
  const {
    prefixCls: r,
    shape: a,
    size: i,
    src: c,
    srcSet: d,
    icon: f,
    className: p,
    rootClassName: g,
    style: b,
    alt: w,
    draggable: x,
    children: E,
    crossOrigin: P,
    gap: k = 4,
    onError: M
  } = e, T = B0e(e, ["prefixCls", "shape", "size", "src", "srcSet", "icon", "className", "rootClassName", "style", "alt", "draggable", "children", "crossOrigin", "gap", "onError"]), [N, D] = S.useState(1), [$, j] = S.useState(!1), [I, L] = S.useState(!0), F = S.useRef(null), _ = S.useRef(null), W = mp(t, F), {
    getPrefixCls: Q,
    avatar: U
  } = S.useContext(Qr), Y = S.useContext(DD), G = () => {
    if (!_.current || !F.current)
      return;
    const le = _.current.offsetWidth, se = F.current.offsetWidth;
    le !== 0 && se !== 0 && k * 2 < se && D(se - k * 2 < le ? (se - k * 2) / le : 1);
  };
  S.useEffect(() => {
    j(!0);
  }, []), S.useEffect(() => {
    L(!0), D(1);
  }, [c]), S.useEffect(G, [k]);
  const J = () => {
    M?.() !== !1 && L(!1);
  }, H = Cb((le) => {
    var se, Ae;
    return (Ae = (se = i ?? Y?.size) !== null && se !== void 0 ? se : le) !== null && Ae !== void 0 ? Ae : "default";
  }), K = Object.keys(typeof H == "object" ? H || {} : {}).some((le) => ["xs", "sm", "md", "lg", "xl", "xxl"].includes(le)), X = oj(K), te = S.useMemo(() => {
    if (typeof H != "object")
      return {};
    const le = PY.find((Ae) => X[Ae]), se = H[le];
    return se ? {
      width: se,
      height: se,
      fontSize: se && (f || E) ? se / 2 : 18
    } : {};
  }, [X, H, f, E]);
  if (process.env.NODE_ENV !== "production") {
    const le = To("Avatar");
    process.env.NODE_ENV !== "production" && le(!(typeof f == "string" && f.length > 2), "breaking", `\`icon\` is using ReactNode instead of string naming in v4. Please check \`${f}\` at https://ant.design/components/icon`);
  }
  const ie = Q("avatar", r), ee = Qh(ie), [ne, ae, oe] = kY(ie, ee), fe = _e({
    [`${ie}-lg`]: H === "large",
    [`${ie}-sm`]: H === "small"
  }), be = /* @__PURE__ */ S.isValidElement(c), me = a || Y?.shape || "circle", De = _e(ie, fe, U?.className, `${ie}-${me}`, {
    [`${ie}-image`]: be || c && I,
    [`${ie}-icon`]: !!f
  }, oe, ee, p, g, ae), Me = typeof H == "number" ? {
    width: H,
    height: H,
    fontSize: f ? H / 2 : 18
  } : {};
  let ze;
  if (typeof c == "string" && I)
    ze = /* @__PURE__ */ S.createElement("img", {
      src: c,
      draggable: x,
      srcSet: d,
      onError: J,
      alt: w,
      crossOrigin: P
    });
  else if (be)
    ze = c;
  else if (f)
    ze = f;
  else if ($ || N !== 1) {
    const le = `scale(${N})`, se = {
      msTransform: le,
      WebkitTransform: le,
      transform: le
    };
    ze = /* @__PURE__ */ S.createElement(hp, {
      onResize: G
    }, /* @__PURE__ */ S.createElement("span", {
      className: `${ie}-string`,
      ref: _,
      style: se
    }, E));
  } else
    ze = /* @__PURE__ */ S.createElement("span", {
      className: `${ie}-string`,
      style: {
        opacity: 0
      },
      ref: _
    }, E);
  return ne(/* @__PURE__ */ S.createElement("span", Object.assign({}, T, {
    style: Object.assign(Object.assign(Object.assign(Object.assign({}, Me), te), U?.style), b),
    className: De,
    ref: W
  }), ze));
});
process.env.NODE_ENV !== "production" && (ij.displayName = "Avatar");
const Gk = (e) => e ? typeof e == "function" ? e() : e : null;
function lj(e) {
  var t = e.children, r = e.prefixCls, a = e.id, i = e.overlayInnerStyle, c = e.bodyClassName, d = e.className, f = e.style;
  return /* @__PURE__ */ S.createElement("div", {
    className: _e("".concat(r, "-content"), d),
    style: f
  }, /* @__PURE__ */ S.createElement("div", {
    className: _e("".concat(r, "-inner"), c),
    id: a,
    role: "tooltip",
    style: i
  }, typeof t == "function" ? t() : t));
}
var R3 = {
  shiftX: 64,
  adjustY: 1
}, A3 = {
  adjustX: 1,
  shiftY: !0
}, L0 = [0, 0], U0e = {
  left: {
    points: ["cr", "cl"],
    overflow: A3,
    offset: [-4, 0],
    targetOffset: L0
  },
  right: {
    points: ["cl", "cr"],
    overflow: A3,
    offset: [4, 0],
    targetOffset: L0
  },
  top: {
    points: ["bc", "tc"],
    overflow: R3,
    offset: [0, -4],
    targetOffset: L0
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: R3,
    offset: [0, 4],
    targetOffset: L0
  },
  topLeft: {
    points: ["bl", "tl"],
    overflow: R3,
    offset: [0, -4],
    targetOffset: L0
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: A3,
    offset: [-4, 0],
    targetOffset: L0
  },
  topRight: {
    points: ["br", "tr"],
    overflow: R3,
    offset: [0, -4],
    targetOffset: L0
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: A3,
    offset: [4, 0],
    targetOffset: L0
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: R3,
    offset: [0, 4],
    targetOffset: L0
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: A3,
    offset: [4, 0],
    targetOffset: L0
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: R3,
    offset: [0, 4],
    targetOffset: L0
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: A3,
    offset: [-4, 0],
    targetOffset: L0
  }
}, X0e = ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "children", "onVisibleChange", "afterVisibleChange", "transitionName", "animation", "motion", "placement", "align", "destroyTooltipOnHide", "defaultVisible", "getTooltipContainer", "overlayInnerStyle", "arrowContent", "overlay", "id", "showArrow", "classNames", "styles"], G0e = function(t, r) {
  var a = t.overlayClassName, i = t.trigger, c = i === void 0 ? ["hover"] : i, d = t.mouseEnterDelay, f = d === void 0 ? 0 : d, p = t.mouseLeaveDelay, g = p === void 0 ? 0.1 : p, b = t.overlayStyle, w = t.prefixCls, x = w === void 0 ? "rc-tooltip" : w, E = t.children, P = t.onVisibleChange, k = t.afterVisibleChange, M = t.transitionName, T = t.animation, N = t.motion, D = t.placement, $ = D === void 0 ? "right" : D, j = t.align, I = j === void 0 ? {} : j, L = t.destroyTooltipOnHide, F = L === void 0 ? !1 : L, _ = t.defaultVisible, W = t.getTooltipContainer, Q = t.overlayInnerStyle;
  t.arrowContent;
  var U = t.overlay, Y = t.id, G = t.showArrow, J = G === void 0 ? !0 : G, H = t.classNames, K = t.styles, X = xr(t, X0e), te = KE(Y), ie = It(null);
  pS(r, function() {
    return ie.current;
  });
  var ee = ce({}, X);
  "visible" in t && (ee.popupVisible = t.visible);
  var ne = function() {
    return /* @__PURE__ */ S.createElement(lj, {
      key: "content",
      prefixCls: x,
      id: te,
      bodyClassName: H?.body,
      overlayInnerStyle: ce(ce({}, Q), K?.body)
    }, U);
  }, ae = function() {
    var fe = S.Children.only(E), be = fe?.props || {}, me = ce(ce({}, be), {}, {
      "aria-describedby": U ? te : null
    });
    return /* @__PURE__ */ S.cloneElement(E, me);
  };
  return /* @__PURE__ */ S.createElement(e7, vt({
    popupClassName: _e(a, H?.root),
    prefixCls: x,
    popup: ne,
    action: c,
    builtinPlacements: U0e,
    popupPlacement: $,
    ref: ie,
    popupAlign: I,
    getPopupContainer: W,
    onPopupVisibleChange: P,
    afterPopupVisibleChange: k,
    popupTransitionName: M,
    popupAnimation: T,
    popupMotion: N,
    defaultPopupVisible: _,
    autoDestroy: F,
    mouseLeaveDelay: g,
    popupStyle: ce(ce({}, b), K?.root),
    mouseEnterDelay: f,
    arrow: J
  }, ee), ae());
};
const q0e = /* @__PURE__ */ ks(G0e);
function nM(e) {
  const {
    sizePopupArrow: t,
    borderRadiusXS: r,
    borderRadiusOuter: a
  } = e, i = t / 2, c = 0, d = i, f = a * 1 / Math.sqrt(2), p = i - a * (1 - 1 / Math.sqrt(2)), g = i - r * (1 / Math.sqrt(2)), b = a * (Math.sqrt(2) - 1) + r * (1 / Math.sqrt(2)), w = 2 * i - g, x = b, E = 2 * i - f, P = p, k = 2 * i - c, M = d, T = i * Math.sqrt(2) + a * (Math.sqrt(2) - 2), N = a * (Math.sqrt(2) - 1), D = `polygon(${N}px 100%, 50% ${N}px, ${2 * i - N}px 100%, ${N}px 100%)`, $ = `path('M ${c} ${d} A ${a} ${a} 0 0 0 ${f} ${p} L ${g} ${b} A ${r} ${r} 0 0 1 ${w} ${x} L ${E} ${P} A ${a} ${a} 0 0 0 ${k} ${M} Z')`;
  return {
    arrowShadowWidth: T,
    arrowPath: $,
    arrowPolygon: D
  };
}
const MY = (e, t, r) => {
  const {
    sizePopupArrow: a,
    arrowPolygon: i,
    arrowPath: c,
    arrowShadowWidth: d,
    borderRadiusXS: f,
    calc: p
  } = e;
  return {
    pointerEvents: "none",
    width: a,
    height: a,
    overflow: "hidden",
    "&::before": {
      position: "absolute",
      bottom: 0,
      insetInlineStart: 0,
      width: a,
      height: p(a).div(2).equal(),
      background: t,
      clipPath: {
        _multi_value_: !0,
        value: [i, c]
      },
      content: '""'
    },
    "&::after": {
      content: '""',
      position: "absolute",
      width: d,
      height: d,
      bottom: 0,
      insetInline: 0,
      margin: "auto",
      borderRadius: {
        _skip_check_: !0,
        value: `0 0 ${Ye(f)} 0`
      },
      transform: "translateY(50%) rotate(-135deg)",
      boxShadow: r,
      zIndex: 0,
      background: "transparent"
    }
  };
}, OY = 8;
function rM(e) {
  const {
    contentRadius: t,
    limitVerticalRadius: r
  } = e, a = t > 12 ? t + 2 : 12;
  return {
    arrowOffsetHorizontal: a,
    arrowOffsetVertical: r ? OY : a
  };
}
function _7(e, t) {
  return e ? t : {};
}
function sj(e, t, r) {
  const {
    componentCls: a,
    boxShadowPopoverArrow: i,
    arrowOffsetVertical: c,
    arrowOffsetHorizontal: d
  } = e, {
    arrowDistance: f = 0,
    arrowPlacement: p = {
      left: !0,
      right: !0,
      top: !0,
      bottom: !0
    }
  } = r || {};
  return {
    [a]: Object.assign(Object.assign(Object.assign(Object.assign({
      // ============================ Basic ============================
      [`${a}-arrow`]: [Object.assign(Object.assign({
        position: "absolute",
        zIndex: 1,
        display: "block"
      }, MY(e, t, i)), {
        "&:before": {
          background: t
        }
      })]
    }, _7(!!p.top, {
      [[`&-placement-top > ${a}-arrow`, `&-placement-topLeft > ${a}-arrow`, `&-placement-topRight > ${a}-arrow`].join(",")]: {
        bottom: f,
        transform: "translateY(100%) rotate(180deg)"
      },
      [`&-placement-top > ${a}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateX(-50%) translateY(100%) rotate(180deg)"
      },
      "&-placement-topLeft": {
        "--arrow-offset-horizontal": d,
        [`> ${a}-arrow`]: {
          left: {
            _skip_check_: !0,
            value: d
          }
        }
      },
      "&-placement-topRight": {
        "--arrow-offset-horizontal": `calc(100% - ${Ye(d)})`,
        [`> ${a}-arrow`]: {
          right: {
            _skip_check_: !0,
            value: d
          }
        }
      }
    })), _7(!!p.bottom, {
      [[`&-placement-bottom > ${a}-arrow`, `&-placement-bottomLeft > ${a}-arrow`, `&-placement-bottomRight > ${a}-arrow`].join(",")]: {
        top: f,
        transform: "translateY(-100%)"
      },
      [`&-placement-bottom > ${a}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateX(-50%) translateY(-100%)"
      },
      "&-placement-bottomLeft": {
        "--arrow-offset-horizontal": d,
        [`> ${a}-arrow`]: {
          left: {
            _skip_check_: !0,
            value: d
          }
        }
      },
      "&-placement-bottomRight": {
        "--arrow-offset-horizontal": `calc(100% - ${Ye(d)})`,
        [`> ${a}-arrow`]: {
          right: {
            _skip_check_: !0,
            value: d
          }
        }
      }
    })), _7(!!p.left, {
      [[`&-placement-left > ${a}-arrow`, `&-placement-leftTop > ${a}-arrow`, `&-placement-leftBottom > ${a}-arrow`].join(",")]: {
        right: {
          _skip_check_: !0,
          value: f
        },
        transform: "translateX(100%) rotate(90deg)"
      },
      [`&-placement-left > ${a}-arrow`]: {
        top: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateY(-50%) translateX(100%) rotate(90deg)"
      },
      [`&-placement-leftTop > ${a}-arrow`]: {
        top: c
      },
      [`&-placement-leftBottom > ${a}-arrow`]: {
        bottom: c
      }
    })), _7(!!p.right, {
      [[`&-placement-right > ${a}-arrow`, `&-placement-rightTop > ${a}-arrow`, `&-placement-rightBottom > ${a}-arrow`].join(",")]: {
        left: {
          _skip_check_: !0,
          value: f
        },
        transform: "translateX(-100%) rotate(-90deg)"
      },
      [`&-placement-right > ${a}-arrow`]: {
        top: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateY(-50%) translateX(-100%) rotate(-90deg)"
      },
      [`&-placement-rightTop > ${a}-arrow`]: {
        top: c
      },
      [`&-placement-rightBottom > ${a}-arrow`]: {
        bottom: c
      }
    }))
  };
}
function K0e(e, t, r, a) {
  if (a === !1)
    return {
      adjustX: !1,
      adjustY: !1
    };
  const i = a && typeof a == "object" ? a : {}, c = {};
  switch (e) {
    case "top":
    case "bottom":
      c.shiftX = t.arrowOffsetHorizontal * 2 + r, c.shiftY = !0, c.adjustY = !0;
      break;
    case "left":
    case "right":
      c.shiftY = t.arrowOffsetVertical * 2 + r, c.shiftX = !0, c.adjustX = !0;
      break;
  }
  const d = Object.assign(Object.assign({}, c), i);
  return d.shiftX || (d.adjustX = !0), d.shiftY || (d.adjustY = !0), d;
}
const UF = {
  left: {
    points: ["cr", "cl"]
  },
  right: {
    points: ["cl", "cr"]
  },
  top: {
    points: ["bc", "tc"]
  },
  bottom: {
    points: ["tc", "bc"]
  },
  topLeft: {
    points: ["bl", "tl"]
  },
  leftTop: {
    points: ["tr", "tl"]
  },
  topRight: {
    points: ["br", "tr"]
  },
  rightTop: {
    points: ["tl", "tr"]
  },
  bottomRight: {
    points: ["tr", "br"]
  },
  rightBottom: {
    points: ["bl", "br"]
  },
  bottomLeft: {
    points: ["tl", "bl"]
  },
  leftBottom: {
    points: ["br", "bl"]
  }
}, Y0e = {
  topLeft: {
    points: ["bl", "tc"]
  },
  leftTop: {
    points: ["tr", "cl"]
  },
  topRight: {
    points: ["br", "tc"]
  },
  rightTop: {
    points: ["tl", "cr"]
  },
  bottomRight: {
    points: ["tr", "bc"]
  },
  rightBottom: {
    points: ["bl", "cr"]
  },
  bottomLeft: {
    points: ["tl", "bc"]
  },
  leftBottom: {
    points: ["br", "cl"]
  }
}, Q0e = /* @__PURE__ */ new Set(["topLeft", "topRight", "bottomLeft", "bottomRight", "leftTop", "leftBottom", "rightTop", "rightBottom"]);
function TY(e) {
  const {
    arrowWidth: t,
    autoAdjustOverflow: r,
    arrowPointAtCenter: a,
    offset: i,
    borderRadius: c,
    visibleFirst: d
  } = e, f = t / 2, p = {}, g = rM({
    contentRadius: c,
    limitVerticalRadius: !0
  });
  return Object.keys(UF).forEach((b) => {
    const w = a && Y0e[b] || UF[b], x = Object.assign(Object.assign({}, w), {
      offset: [0, 0],
      dynamicInset: !0
    });
    switch (p[b] = x, Q0e.has(b) && (x.autoArrow = !1), b) {
      case "top":
      case "topLeft":
      case "topRight":
        x.offset[1] = -f - i;
        break;
      case "bottom":
      case "bottomLeft":
      case "bottomRight":
        x.offset[1] = f + i;
        break;
      case "left":
      case "leftTop":
      case "leftBottom":
        x.offset[0] = -f - i;
        break;
      case "right":
      case "rightTop":
      case "rightBottom":
        x.offset[0] = f + i;
        break;
    }
    if (a)
      switch (b) {
        case "topLeft":
        case "bottomLeft":
          x.offset[0] = -g.arrowOffsetHorizontal - f;
          break;
        case "topRight":
        case "bottomRight":
          x.offset[0] = g.arrowOffsetHorizontal + f;
          break;
        case "leftTop":
        case "rightTop":
          x.offset[1] = -g.arrowOffsetHorizontal * 2 + f;
          break;
        case "leftBottom":
        case "rightBottom":
          x.offset[1] = g.arrowOffsetHorizontal * 2 - f;
          break;
      }
    x.overflow = K0e(b, g, t, r), d && (x.htmlRegion = "visibleFirst");
  }), p;
}
const J0e = (e) => {
  const {
    calc: t,
    componentCls: r,
    // ant-tooltip
    tooltipMaxWidth: a,
    tooltipColor: i,
    tooltipBg: c,
    tooltipBorderRadius: d,
    zIndexPopup: f,
    controlHeight: p,
    boxShadowSecondary: g,
    paddingSM: b,
    paddingXS: w,
    arrowOffsetHorizontal: x,
    sizePopupArrow: E
  } = e, P = t(d).add(E).add(x).equal(), k = t(d).mul(2).add(E).equal();
  return [
    {
      [r]: Object.assign(Object.assign(Object.assign(Object.assign({}, dl(e)), {
        position: "absolute",
        zIndex: f,
        display: "block",
        width: "max-content",
        maxWidth: a,
        visibility: "visible",
        // When use `autoArrow`, origin will follow the arrow position
        "--valid-offset-x": "var(--arrow-offset-horizontal, var(--arrow-x))",
        transformOrigin: ["var(--valid-offset-x, 50%)", "var(--arrow-y, 50%)"].join(" "),
        "&-hidden": {
          display: "none"
        },
        "--antd-arrow-background-color": c,
        // Wrapper for the tooltip content
        [`${r}-inner`]: {
          minWidth: k,
          minHeight: p,
          padding: `${Ye(e.calc(b).div(2).equal())} ${Ye(w)}`,
          color: `var(--ant-tooltip-color, ${i})`,
          textAlign: "start",
          textDecoration: "none",
          wordWrap: "break-word",
          backgroundColor: c,
          borderRadius: d,
          boxShadow: g,
          boxSizing: "border-box"
        },
        // Align placement should have another min width
        [["&-placement-topLeft", "&-placement-topRight", "&-placement-bottomLeft", "&-placement-bottomRight"].join(",")]: {
          minWidth: P
        },
        // Limit left and right placement radius
        [["&-placement-left", "&-placement-leftTop", "&-placement-leftBottom", "&-placement-right", "&-placement-rightTop", "&-placement-rightBottom"].join(",")]: {
          [`${r}-inner`]: {
            borderRadius: e.min(d, OY)
          }
        },
        [`${r}-content`]: {
          position: "relative"
        }
      }), ace(e, (M, {
        darkColor: T
      }) => ({
        [`&${r}-${M}`]: {
          [`${r}-inner`]: {
            backgroundColor: T
          },
          [`${r}-arrow`]: {
            "--antd-arrow-background-color": T
          }
        }
      }))), {
        // RTL
        "&-rtl": {
          direction: "rtl"
        }
      })
    },
    // Arrow Style
    sj(e, "var(--antd-arrow-background-color)"),
    // Pure Render
    {
      [`${r}-pure`]: {
        position: "relative",
        maxWidth: "none",
        margin: e.sizePopupArrow
      }
    }
  ];
}, Z0e = (e) => Object.assign(Object.assign({
  zIndexPopup: e.zIndexPopupBase + 70
}, rM({
  contentRadius: e.borderRadius,
  limitVerticalRadius: !0
})), nM(lo(e, {
  borderRadiusOuter: Math.min(e.borderRadiusOuter, 4)
}))), RY = (e, t = !0) => Ii("Tooltip", (a) => {
  const {
    borderRadius: i,
    colorTextLightSolid: c,
    colorBgSpotlight: d
  } = a, f = lo(a, {
    // default variables
    tooltipMaxWidth: 250,
    tooltipColor: c,
    tooltipBorderRadius: i,
    tooltipBg: d
  });
  return [J0e(f), UE(a, "zoom-big-fast")];
}, Z0e, {
  resetStyle: !1,
  // Popover use Tooltip as internal component. We do not need to handle this.
  injectStyle: t
})(e), eve = WS.map((e) => `${e}-inverse`);
function tve(e, t = !0) {
  return t ? [].concat(Et(eve), Et(WS)).includes(e) : WS.includes(e);
}
function AY(e, t) {
  const r = tve(t), a = _e({
    [`${e}-${t}`]: t && r
  }), i = {}, c = {}, d = nme(t).toRgb(), p = (0.299 * d.r + 0.587 * d.g + 0.114 * d.b) / 255 < 0.5 ? "#FFF" : "#000";
  return t && !r && (i.background = t, i["--ant-tooltip-color"] = p, c["--antd-arrow-background-color"] = t), {
    className: a,
    overlayStyle: i,
    arrowStyle: c
  };
}
const nve = (e) => {
  const {
    prefixCls: t,
    className: r,
    placement: a = "top",
    title: i,
    color: c,
    overlayInnerStyle: d
  } = e, {
    getPrefixCls: f
  } = S.useContext(Qr), p = f("tooltip", t), [g, b, w] = RY(p), x = AY(p, c), E = x.arrowStyle, P = Object.assign(Object.assign({}, d), x.overlayStyle), k = _e(b, w, p, `${p}-pure`, `${p}-placement-${a}`, r, x.className);
  return g(/* @__PURE__ */ S.createElement("div", {
    className: k,
    style: E
  }, /* @__PURE__ */ S.createElement("div", {
    className: `${p}-arrow`
  }), /* @__PURE__ */ S.createElement(lj, Object.assign({}, e, {
    className: b,
    prefixCls: p,
    overlayInnerStyle: P
  }), i)));
};
var rve = function(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
    t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
};
const ave = /* @__PURE__ */ S.forwardRef((e, t) => {
  var r, a;
  const {
    prefixCls: i,
    openClassName: c,
    getTooltipContainer: d,
    color: f,
    overlayInnerStyle: p,
    children: g,
    afterOpenChange: b,
    afterVisibleChange: w,
    destroyTooltipOnHide: x,
    destroyOnHidden: E,
    arrow: P = !0,
    title: k,
    overlay: M,
    builtinPlacements: T,
    arrowPointAtCenter: N = !1,
    autoAdjustOverflow: D = !0,
    motion: $,
    getPopupContainer: j,
    placement: I = "top",
    mouseEnterDelay: L = 0.1,
    mouseLeaveDelay: F = 0.1,
    overlayStyle: _,
    rootClassName: W,
    overlayClassName: Q,
    styles: U,
    classNames: Y
  } = e, G = rve(e, ["prefixCls", "openClassName", "getTooltipContainer", "color", "overlayInnerStyle", "children", "afterOpenChange", "afterVisibleChange", "destroyTooltipOnHide", "destroyOnHidden", "arrow", "title", "overlay", "builtinPlacements", "arrowPointAtCenter", "autoAdjustOverflow", "motion", "getPopupContainer", "placement", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "rootClassName", "overlayClassName", "styles", "classNames"]), J = !!P, [, H] = Bf(), {
    getPopupContainer: K,
    getPrefixCls: X,
    direction: te,
    className: ie,
    style: ee,
    classNames: ne,
    styles: ae
  } = om("tooltip"), oe = To("Tooltip"), fe = S.useRef(null), be = () => {
    var ct;
    (ct = fe.current) === null || ct === void 0 || ct.forceAlign();
  };
  S.useImperativeHandle(t, () => {
    var ct, it;
    return {
      forceAlign: be,
      forcePopupAlign: () => {
        oe.deprecated(!1, "forcePopupAlign", "forceAlign"), be();
      },
      nativeElement: (ct = fe.current) === null || ct === void 0 ? void 0 : ct.nativeElement,
      popupElement: (it = fe.current) === null || it === void 0 ? void 0 : it.popupElement
    };
  }), process.env.NODE_ENV !== "production" && ([["visible", "open"], ["defaultVisible", "defaultOpen"], ["onVisibleChange", "onOpenChange"], ["afterVisibleChange", "afterOpenChange"], ["destroyTooltipOnHide", "destroyOnHidden"], ["arrowPointAtCenter", "arrow={{ pointAtCenter: true }}"], ["overlayStyle", "styles={{ root: {} }}"], ["overlayInnerStyle", "styles={{ body: {} }}"], ["overlayClassName", 'classNames={{ root: "" }}']].forEach(([ct, it]) => {
    oe.deprecated(!(ct in e), ct, it);
  }), process.env.NODE_ENV !== "production" && oe(!x || typeof x == "boolean", "usage", "`destroyTooltipOnHide` no need config `keepParent` anymore. Please use `boolean` value directly."), process.env.NODE_ENV !== "production" && oe(!P || typeof P == "boolean" || !("arrowPointAtCenter" in P), "deprecated", "`arrowPointAtCenter` in `arrow` is deprecated. Please use `pointAtCenter` instead."));
  const [me, De] = ll(!1, {
    value: (r = e.open) !== null && r !== void 0 ? r : e.visible,
    defaultValue: (a = e.defaultOpen) !== null && a !== void 0 ? a : e.defaultVisible
  }), Me = !k && !M && k !== 0, ze = (ct) => {
    var it, Ct;
    De(Me ? !1 : ct), Me || ((it = e.onOpenChange) === null || it === void 0 || it.call(e, ct), (Ct = e.onVisibleChange) === null || Ct === void 0 || Ct.call(e, ct));
  }, le = S.useMemo(() => {
    var ct, it;
    let Ct = N;
    return typeof P == "object" && (Ct = (it = (ct = P.pointAtCenter) !== null && ct !== void 0 ? ct : P.arrowPointAtCenter) !== null && it !== void 0 ? it : N), T || TY({
      arrowPointAtCenter: Ct,
      autoAdjustOverflow: D,
      arrowWidth: J ? H.sizePopupArrow : 0,
      borderRadius: H.borderRadius,
      offset: H.marginXXS,
      visibleFirst: !0
    });
  }, [N, P, T, H]), se = S.useMemo(() => k === 0 ? k : M || k || "", [M, k]), Ae = /* @__PURE__ */ S.createElement(dS, {
    space: !0
  }, typeof se == "function" ? se() : se), we = X("tooltip", i), Ne = X(), pe = e["data-popover-inject"];
  let Qe = me;
  !("open" in e) && !("visible" in e) && Me && (Qe = !1);
  const Le = /* @__PURE__ */ S.isValidElement(g) && !Xq(g) ? g : /* @__PURE__ */ S.createElement("span", null, g), Te = Le.props, Oe = !Te.className || typeof Te.className == "string" ? _e(Te.className, c || `${we}-open`) : Te.className, [ye, je, Ue] = RY(we, !pe), Fe = AY(we, f), tt = Fe.arrowStyle, dt = _e(Q, {
    [`${we}-rtl`]: te === "rtl"
  }, Fe.className, W, je, Ue, ie, ne.root, Y?.root), St = _e(ne.body, Y?.body), [mt, Ot] = vS("Tooltip", G.zIndex), Rt = /* @__PURE__ */ S.createElement(q0e, Object.assign({}, G, {
    zIndex: mt,
    showArrow: J,
    placement: I,
    mouseEnterDelay: L,
    mouseLeaveDelay: F,
    prefixCls: we,
    classNames: {
      root: dt,
      body: St
    },
    styles: {
      root: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, tt), ae.root), ee), _), U?.root),
      body: Object.assign(Object.assign(Object.assign(Object.assign({}, ae.body), p), U?.body), Fe.overlayStyle)
    },
    getTooltipContainer: j || d || K,
    ref: fe,
    builtinPlacements: le,
    overlay: Ae,
    visible: Qe,
    onVisibleChange: ze,
    afterVisibleChange: b ?? w,
    arrowContent: /* @__PURE__ */ S.createElement("span", {
      className: `${we}-arrow-content`
    }),
    motion: {
      motionName: uS(Ne, "zoom-big-fast", e.transitionName),
      motionDeadline: 1e3
    },
    // TODO: In the future, destroyTooltipOnHide in rc-tooltip needs to be upgrade to destroyOnHidden
    destroyTooltipOnHide: E ?? !!x
  }), Qe ? up(Le, {
    className: Oe
  }) : Le);
  return ye(/* @__PURE__ */ S.createElement(Ux.Provider, {
    value: Ot
  }, Rt));
}), U1 = ave;
process.env.NODE_ENV !== "production" && (U1.displayName = "Tooltip");
U1._InternalPanelDoNotUseOrYouWillBeFired = nve;
const ove = (e) => {
  const {
    componentCls: t,
    popoverColor: r,
    titleMinWidth: a,
    fontWeightStrong: i,
    innerPadding: c,
    boxShadowSecondary: d,
    colorTextHeading: f,
    borderRadiusLG: p,
    zIndexPopup: g,
    titleMarginBottom: b,
    colorBgElevated: w,
    popoverBg: x,
    titleBorderBottom: E,
    innerContentPadding: P,
    titlePadding: k
  } = e;
  return [
    {
      [t]: Object.assign(Object.assign({}, dl(e)), {
        position: "absolute",
        top: 0,
        // use `left` to fix https://github.com/ant-design/ant-design/issues/39195
        left: {
          _skip_check_: !0,
          value: 0
        },
        zIndex: g,
        fontWeight: "normal",
        whiteSpace: "normal",
        textAlign: "start",
        cursor: "auto",
        userSelect: "text",
        // When use `autoArrow`, origin will follow the arrow position
        "--valid-offset-x": "var(--arrow-offset-horizontal, var(--arrow-x))",
        transformOrigin: ["var(--valid-offset-x, 50%)", "var(--arrow-y, 50%)"].join(" "),
        "--antd-arrow-background-color": w,
        width: "max-content",
        maxWidth: "100vw",
        "&-rtl": {
          direction: "rtl"
        },
        "&-hidden": {
          display: "none"
        },
        [`${t}-content`]: {
          position: "relative"
        },
        [`${t}-inner`]: {
          backgroundColor: x,
          backgroundClip: "padding-box",
          borderRadius: p,
          boxShadow: d,
          padding: c
        },
        [`${t}-title`]: {
          minWidth: a,
          marginBottom: b,
          color: f,
          fontWeight: i,
          borderBottom: E,
          padding: k
        },
        [`${t}-inner-content`]: {
          color: r,
          padding: P
        }
      })
    },
    // Arrow Style
    sj(e, "var(--antd-arrow-background-color)"),
    // Pure Render
    {
      [`${t}-pure`]: {
        position: "relative",
        maxWidth: "none",
        margin: e.sizePopupArrow,
        display: "inline-block",
        [`${t}-content`]: {
          display: "inline-block"
        }
      }
    }
  ];
}, ive = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: WS.map((r) => {
      const a = e[`${r}6`];
      return {
        [`&${t}-${r}`]: {
          "--antd-arrow-background-color": a,
          [`${t}-inner`]: {
            backgroundColor: a
          },
          [`${t}-arrow`]: {
            background: "transparent"
          }
        }
      };
    })
  };
}, lve = (e) => {
  const {
    lineWidth: t,
    controlHeight: r,
    fontHeight: a,
    padding: i,
    wireframe: c,
    zIndexPopupBase: d,
    borderRadiusLG: f,
    marginXS: p,
    lineType: g,
    colorSplit: b,
    paddingSM: w
  } = e, x = r - a, E = x / 2, P = x / 2 - t, k = i;
  return Object.assign(Object.assign(Object.assign({
    titleMinWidth: 177,
    zIndexPopup: d + 30
  }, nM(e)), rM({
    contentRadius: f,
    limitVerticalRadius: !0
  })), {
    // internal
    innerPadding: c ? 0 : 12,
    titleMarginBottom: c ? 0 : p,
    titlePadding: c ? `${E}px ${k}px ${P}px` : 0,
    titleBorderBottom: c ? `${t}px ${g} ${b}` : "none",
    innerContentPadding: c ? `${w}px ${k}px` : 0
  });
}, NY = Ii("Popover", (e) => {
  const {
    colorBgElevated: t,
    colorText: r
  } = e, a = lo(e, {
    popoverBg: t,
    popoverColor: r
  });
  return [ove(a), ive(a), UE(a, "zoom-big")];
}, lve, {
  resetStyle: !1,
  deprecatedTokens: [["width", "titleMinWidth"], ["minWidth", "titleMinWidth"]]
});
var sve = function(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
    t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
};
const DY = ({
  title: e,
  content: t,
  prefixCls: r
}) => !e && !t ? null : /* @__PURE__ */ S.createElement(S.Fragment, null, e && /* @__PURE__ */ S.createElement("div", {
  className: `${r}-title`
}, e), t && /* @__PURE__ */ S.createElement("div", {
  className: `${r}-inner-content`
}, t)), uve = (e) => {
  const {
    hashId: t,
    prefixCls: r,
    className: a,
    style: i,
    placement: c = "top",
    title: d,
    content: f,
    children: p
  } = e, g = Gk(d), b = Gk(f), w = _e(t, r, `${r}-pure`, `${r}-placement-${c}`, a);
  return /* @__PURE__ */ S.createElement("div", {
    className: w,
    style: i
  }, /* @__PURE__ */ S.createElement("div", {
    className: `${r}-arrow`
  }), /* @__PURE__ */ S.createElement(lj, Object.assign({}, e, {
    className: t,
    prefixCls: r
  }), p || /* @__PURE__ */ S.createElement(DY, {
    prefixCls: r,
    title: g,
    content: b
  })));
}, cve = (e) => {
  const {
    prefixCls: t,
    className: r
  } = e, a = sve(e, ["prefixCls", "className"]), {
    getPrefixCls: i
  } = S.useContext(Qr), c = i("popover", t), [d, f, p] = NY(c);
  return d(/* @__PURE__ */ S.createElement(uve, Object.assign({}, a, {
    prefixCls: c,
    hashId: f,
    className: _e(r, p)
  })));
};
var dve = function(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
    t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
};
const fve = /* @__PURE__ */ S.forwardRef((e, t) => {
  var r, a;
  const {
    prefixCls: i,
    title: c,
    content: d,
    overlayClassName: f,
    placement: p = "top",
    trigger: g = "hover",
    children: b,
    mouseEnterDelay: w = 0.1,
    mouseLeaveDelay: x = 0.1,
    onOpenChange: E,
    overlayStyle: P = {},
    styles: k,
    classNames: M
  } = e, T = dve(e, ["prefixCls", "title", "content", "overlayClassName", "placement", "trigger", "children", "mouseEnterDelay", "mouseLeaveDelay", "onOpenChange", "overlayStyle", "styles", "classNames"]), {
    getPrefixCls: N,
    className: D,
    style: $,
    classNames: j,
    styles: I
  } = om("popover"), L = N("popover", i), [F, _, W] = NY(L), Q = N(), U = _e(f, _, W, D, j.root, M?.root), Y = _e(j.body, M?.body), [G, J] = ll(!1, {
    value: (r = e.open) !== null && r !== void 0 ? r : e.visible,
    defaultValue: (a = e.defaultOpen) !== null && a !== void 0 ? a : e.defaultVisible
  }), H = (ee, ne) => {
    J(ee, !0), E?.(ee, ne);
  }, K = (ee) => {
    ee.keyCode === fn.ESC && H(!1, ee);
  }, X = (ee) => {
    H(ee);
  }, te = Gk(c), ie = Gk(d);
  return F(/* @__PURE__ */ S.createElement(U1, Object.assign({
    placement: p,
    trigger: g,
    mouseEnterDelay: w,
    mouseLeaveDelay: x
  }, T, {
    prefixCls: L,
    classNames: {
      root: U,
      body: Y
    },
    styles: {
      root: Object.assign(Object.assign(Object.assign(Object.assign({}, I.root), $), P), k?.root),
      body: Object.assign(Object.assign({}, I.body), k?.body)
    },
    ref: t,
    open: G,
    onOpenChange: X,
    overlay: te || ie ? /* @__PURE__ */ S.createElement(DY, {
      prefixCls: L,
      title: te,
      content: ie
    }) : null,
    transitionName: uS(Q, "zoom-big", T.transitionName),
    "data-popover-inject": !0
  }), up(b, {
    onKeyDown: (ee) => {
      var ne, ae;
      /* @__PURE__ */ dG(b) && ((ae = b == null ? void 0 : (ne = b.props).onKeyDown) === null || ae === void 0 || ae.call(ne, ee)), K(ee);
    }
  })));
}), uj = fve;
uj._InternalPanelDoNotUseOrYouWillBeFired = cve;
process.env.NODE_ENV !== "production" && (uj.displayName = "Popover");
const XF = (e) => {
  const {
    size: t,
    shape: r
  } = S.useContext(DD), a = S.useMemo(() => ({
    size: e.size || t,
    shape: e.shape || r
  }), [e.size, e.shape, t, r]);
  return /* @__PURE__ */ S.createElement(DD.Provider, {
    value: a
  }, e.children);
}, mve = (e) => {
  var t, r, a, i;
  const {
    getPrefixCls: c,
    direction: d
  } = S.useContext(Qr), {
    prefixCls: f,
    className: p,
    rootClassName: g,
    style: b,
    maxCount: w,
    maxStyle: x,
    size: E,
    shape: P,
    maxPopoverPlacement: k,
    maxPopoverTrigger: M,
    children: T,
    max: N
  } = e;
  if (process.env.NODE_ENV !== "production") {
    const Y = To("Avatar.Group");
    [["maxCount", "max={{ count: number }}"], ["maxStyle", "max={{ style: CSSProperties }}"], ["maxPopoverPlacement", "max={{ popover: PopoverProps }}"], ["maxPopoverTrigger", "max={{ popover: PopoverProps }}"]].forEach(([G, J]) => {
      Y.deprecated(!(G in e), G, J);
    });
  }
  const D = c("avatar", f), $ = `${D}-group`, j = Qh(D), [I, L, F] = kY(D, j), _ = _e($, {
    [`${$}-rtl`]: d === "rtl"
  }, F, j, p, g, L), W = Kh(T).map((Y, G) => up(Y, {
    // eslint-disable-next-line react/no-array-index-key
    key: `avatar-key-${G}`
  })), Q = N?.count || w, U = W.length;
  if (Q && Q < U) {
    const Y = W.slice(0, Q), G = W.slice(Q, U), J = N?.style || x, H = ((t = N?.popover) === null || t === void 0 ? void 0 : t.trigger) || M || "hover", K = ((r = N?.popover) === null || r === void 0 ? void 0 : r.placement) || k || "top", X = Object.assign(Object.assign({
      content: G
    }, N?.popover), {
      classNames: {
        root: _e(`${$}-popover`, (i = (a = N?.popover) === null || a === void 0 ? void 0 : a.classNames) === null || i === void 0 ? void 0 : i.root)
      },
      placement: K,
      trigger: H
    });
    return Y.push(/* @__PURE__ */ S.createElement(uj, Object.assign({
      key: "avatar-popover-key",
      destroyOnHidden: !0
    }, X), /* @__PURE__ */ S.createElement(ij, {
      style: J
    }, `+${U - Q}`))), I(/* @__PURE__ */ S.createElement(XF, {
      shape: P,
      size: E
    }, /* @__PURE__ */ S.createElement("div", {
      className: _,
      style: b
    }, Y)));
  }
  return I(/* @__PURE__ */ S.createElement(XF, {
    shape: P,
    size: E
  }, /* @__PURE__ */ S.createElement("div", {
    className: _,
    style: b
  }, W)));
}, $Y = ij;
$Y.Group = mve;
var hve = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z" } }] }, name: "left", theme: "outlined" }, pve = function(t, r) {
  return /* @__PURE__ */ S.createElement(Ao, vt({}, t, {
    ref: r,
    icon: hve
  }));
}, Mx = /* @__PURE__ */ S.forwardRef(pve);
process.env.NODE_ENV !== "production" && (Mx.displayName = "LeftOutlined");
var gve = fn.ESC, vve = fn.TAB;
function bve(e) {
  var t = e.visible, r = e.triggerRef, a = e.onVisibleChange, i = e.autoFocus, c = e.overlayRef, d = S.useRef(!1), f = function() {
    if (t) {
      var w, x;
      (w = r.current) === null || w === void 0 || (x = w.focus) === null || x === void 0 || x.call(w), a?.(!1);
    }
  }, p = function() {
    var w;
    return (w = c.current) !== null && w !== void 0 && w.focus ? (c.current.focus(), d.current = !0, !0) : !1;
  }, g = function(w) {
    switch (w.keyCode) {
      case gve:
        f();
        break;
      case vve: {
        var x = !1;
        d.current || (x = p()), x ? w.preventDefault() : f();
        break;
      }
    }
  };
  S.useEffect(function() {
    return t ? (window.addEventListener("keydown", g), i && Pa(p, 3), function() {
      window.removeEventListener("keydown", g), d.current = !1;
    }) : function() {
      d.current = !1;
    };
  }, [t]);
}
var yve = /* @__PURE__ */ ks(function(e, t) {
  var r = e.overlay, a = e.arrow, i = e.prefixCls, c = mn(function() {
    var f;
    return typeof r == "function" ? f = r() : f = r, f;
  }, [r]), d = mp(t, m3(c));
  return /* @__PURE__ */ Re.createElement(Re.Fragment, null, a && /* @__PURE__ */ Re.createElement("div", {
    className: "".concat(i, "-arrow")
  }), /* @__PURE__ */ Re.cloneElement(c, {
    ref: gb(c) ? d : void 0
  }));
}), N3 = {
  adjustX: 1,
  adjustY: 1
}, D3 = [0, 0], wve = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: N3,
    offset: [0, -4],
    targetOffset: D3
  },
  top: {
    points: ["bc", "tc"],
    overflow: N3,
    offset: [0, -4],
    targetOffset: D3
  },
  topRight: {
    points: ["br", "tr"],
    overflow: N3,
    offset: [0, -4],
    targetOffset: D3
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: N3,
    offset: [0, 4],
    targetOffset: D3
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: N3,
    offset: [0, 4],
    targetOffset: D3
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: N3,
    offset: [0, 4],
    targetOffset: D3
  }
}, Sve = ["arrow", "prefixCls", "transitionName", "animation", "align", "placement", "placements", "getPopupContainer", "showAction", "hideAction", "overlayClassName", "overlayStyle", "visible", "trigger", "autoFocus", "overlay", "children", "onVisibleChange"];
function Cve(e, t) {
  var r, a = e.arrow, i = a === void 0 ? !1 : a, c = e.prefixCls, d = c === void 0 ? "rc-dropdown" : c, f = e.transitionName, p = e.animation, g = e.align, b = e.placement, w = b === void 0 ? "bottomLeft" : b, x = e.placements, E = x === void 0 ? wve : x, P = e.getPopupContainer, k = e.showAction, M = e.hideAction, T = e.overlayClassName, N = e.overlayStyle, D = e.visible, $ = e.trigger, j = $ === void 0 ? ["hover"] : $, I = e.autoFocus, L = e.overlay, F = e.children, _ = e.onVisibleChange, W = xr(e, Sve), Q = Re.useState(), U = qe(Q, 2), Y = U[0], G = U[1], J = "visible" in e ? D : Y, H = Re.useRef(null), K = Re.useRef(null), X = Re.useRef(null);
  Re.useImperativeHandle(t, function() {
    return H.current;
  });
  var te = function(De) {
    G(De), _?.(De);
  };
  bve({
    visible: J,
    triggerRef: X,
    onVisibleChange: te,
    autoFocus: I,
    overlayRef: K
  });
  var ie = function(De) {
    var Me = e.onOverlayClick;
    G(!1), Me && Me(De);
  }, ee = function() {
    return /* @__PURE__ */ Re.createElement(yve, {
      ref: K,
      overlay: L,
      prefixCls: d,
      arrow: i
    });
  }, ne = function() {
    return typeof L == "function" ? ee : ee();
  }, ae = function() {
    var De = e.minOverlayWidthMatchTrigger, Me = e.alignPoint;
    return "minOverlayWidthMatchTrigger" in e ? De : !Me;
  }, oe = function() {
    var De = e.openClassName;
    return De !== void 0 ? De : "".concat(d, "-open");
  }, fe = /* @__PURE__ */ Re.cloneElement(F, {
    className: _e((r = F.props) === null || r === void 0 ? void 0 : r.className, J && oe()),
    ref: gb(F) ? mp(X, m3(F)) : void 0
  }), be = M;
  return !be && j.indexOf("contextMenu") !== -1 && (be = ["click"]), /* @__PURE__ */ Re.createElement(e7, vt({
    builtinPlacements: E
  }, W, {
    prefixCls: d,
    ref: H,
    popupClassName: _e(T, ge({}, "".concat(d, "-show-arrow"), i)),
    popupStyle: N,
    action: j,
    showAction: k,
    hideAction: be,
    popupPlacement: w,
    popupAlign: g,
    popupTransitionName: f,
    popupAnimation: p,
    popupVisible: J,
    stretch: ae() ? "minWidth" : "",
    popup: ne(),
    onPopupVisibleChange: te,
    onPopupClick: ie,
    getPopupContainer: P
  }), fe);
}
const xve = /* @__PURE__ */ Re.forwardRef(Cve), Eve = (e) => typeof e != "object" && typeof e != "function" || e === null;
var zY = /* @__PURE__ */ S.createContext(null);
function jY(e, t) {
  return e === void 0 ? null : "".concat(e, "-").concat(t);
}
function IY(e) {
  var t = S.useContext(zY);
  return jY(t, e);
}
var Pve = ["children", "locked"], X1 = /* @__PURE__ */ S.createContext(null);
function kve(e, t) {
  var r = ce({}, e);
  return Object.keys(t).forEach(function(a) {
    var i = t[a];
    i !== void 0 && (r[a] = i);
  }), r;
}
function DE(e) {
  var t = e.children, r = e.locked, a = xr(e, Pve), i = S.useContext(X1), c = eC(function() {
    return kve(i, a);
  }, [i, a], function(d, f) {
    return !r && (d[0] !== f[0] || !R0(d[1], f[1], !0));
  });
  return /* @__PURE__ */ S.createElement(X1.Provider, {
    value: c
  }, t);
}
var Mve = [], LY = /* @__PURE__ */ S.createContext(null);
function aM() {
  return S.useContext(LY);
}
var HY = /* @__PURE__ */ S.createContext(Mve);
function qx(e) {
  var t = S.useContext(HY);
  return S.useMemo(function() {
    return e !== void 0 ? [].concat(Et(t), [e]) : t;
  }, [t, e]);
}
var FY = /* @__PURE__ */ S.createContext(null), cj = /* @__PURE__ */ S.createContext({});
function GF(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  if (BE(e)) {
    var r = e.nodeName.toLowerCase(), a = (
      // Focusable element
      ["input", "select", "textarea", "button"].includes(r) || // Editable element
      e.isContentEditable || // Anchor with href element
      r === "a" && !!e.getAttribute("href")
    ), i = e.getAttribute("tabindex"), c = Number(i), d = null;
    return i && !Number.isNaN(c) ? d = c : a && d === null && (d = 0), a && e.disabled && (d = null), d !== null && (d >= 0 || t && d < 0);
  }
  return !1;
}
function Ove(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = Et(e.querySelectorAll("*")).filter(function(a) {
    return GF(a, t);
  });
  return GF(e, t) && r.unshift(e), r;
}
var $D = fn.LEFT, zD = fn.RIGHT, jD = fn.UP, rk = fn.DOWN, ak = fn.ENTER, WY = fn.ESC, k5 = fn.HOME, M5 = fn.END, qF = [jD, rk, $D, zD];
function Tve(e, t, r, a) {
  var i, c = "prev", d = "next", f = "children", p = "parent";
  if (e === "inline" && a === ak)
    return {
      inlineTrigger: !0
    };
  var g = ge(ge({}, jD, c), rk, d), b = ge(ge(ge(ge({}, $D, r ? d : c), zD, r ? c : d), rk, f), ak, f), w = ge(ge(ge(ge(ge(ge({}, jD, c), rk, d), ak, f), WY, p), $D, r ? f : p), zD, r ? p : f), x = {
    inline: g,
    horizontal: b,
    vertical: w,
    inlineSub: g,
    horizontalSub: w,
    verticalSub: w
  }, E = (i = x["".concat(e).concat(t ? "" : "Sub")]) === null || i === void 0 ? void 0 : i[a];
  switch (E) {
    case c:
      return {
        offset: -1,
        sibling: !0
      };
    case d:
      return {
        offset: 1,
        sibling: !0
      };
    case p:
      return {
        offset: -1,
        sibling: !1
      };
    case f:
      return {
        offset: 1,
        sibling: !1
      };
    default:
      return null;
  }
}
function Rve(e) {
  for (var t = e; t; ) {
    if (t.getAttribute("data-menu-list"))
      return t;
    t = t.parentElement;
  }
  return null;
}
function Ave(e, t) {
  for (var r = e || document.activeElement; r; ) {
    if (t.has(r))
      return r;
    r = r.parentElement;
  }
  return null;
}
function dj(e, t) {
  var r = Ove(e, !0);
  return r.filter(function(a) {
    return t.has(a);
  });
}
function KF(e, t, r) {
  var a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
  if (!e)
    return null;
  var i = dj(e, t), c = i.length, d = i.findIndex(function(f) {
    return r === f;
  });
  return a < 0 ? d === -1 ? d = c - 1 : d -= 1 : a > 0 && (d += 1), d = (d + c) % c, i[d];
}
var ID = function(t, r) {
  var a = /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Map(), c = /* @__PURE__ */ new Map();
  return t.forEach(function(d) {
    var f = document.querySelector("[data-menu-id='".concat(jY(r, d), "']"));
    f && (a.add(f), c.set(f, d), i.set(d, f));
  }), {
    elements: a,
    key2element: i,
    element2key: c
  };
};
function Nve(e, t, r, a, i, c, d, f, p, g) {
  var b = S.useRef(), w = S.useRef();
  w.current = t;
  var x = function() {
    Pa.cancel(b.current);
  };
  return S.useEffect(function() {
    return function() {
      x();
    };
  }, []), function(E) {
    var P = E.which;
    if ([].concat(qF, [ak, WY, k5, M5]).includes(P)) {
      var k = c(), M = ID(k, a), T = M, N = T.elements, D = T.key2element, $ = T.element2key, j = D.get(t), I = Ave(j, N), L = $.get(I), F = Tve(e, d(L, !0).length === 1, r, P);
      if (!F && P !== k5 && P !== M5)
        return;
      (qF.includes(P) || [k5, M5].includes(P)) && E.preventDefault();
      var _ = function(K) {
        if (K) {
          var X = K, te = K.querySelector("a");
          te != null && te.getAttribute("href") && (X = te);
          var ie = $.get(K);
          f(ie), x(), b.current = Pa(function() {
            w.current === ie && X.focus();
          });
        }
      };
      if ([k5, M5].includes(P) || F.sibling || !I) {
        var W;
        !I || e === "inline" ? W = i.current : W = Rve(I);
        var Q, U = dj(W, N);
        P === k5 ? Q = U[0] : P === M5 ? Q = U[U.length - 1] : Q = KF(W, N, I, F.offset), _(Q);
      } else if (F.inlineTrigger)
        p(L);
      else if (F.offset > 0)
        p(L, !0), x(), b.current = Pa(function() {
          M = ID(k, a);
          var H = I.getAttribute("aria-controls"), K = document.getElementById(H), X = KF(K, M.elements);
          _(X);
        }, 5);
      else if (F.offset < 0) {
        var Y = d(L, !0), G = Y[Y.length - 2], J = D.get(G);
        p(G, !1), _(J);
      }
    }
    g?.(E);
  };
}
function Dve(e) {
  Promise.resolve().then(e);
}
var fj = "__RC_UTIL_PATH_SPLIT__", YF = function(t) {
  return t.join(fj);
}, $ve = function(t) {
  return t.split(fj);
}, LD = "rc-menu-more";
function zve() {
  var e = S.useState({}), t = qe(e, 2), r = t[1], a = It(/* @__PURE__ */ new Map()), i = It(/* @__PURE__ */ new Map()), c = S.useState([]), d = qe(c, 2), f = d[0], p = d[1], g = It(0), b = It(!1), w = function() {
    b.current || r({});
  }, x = Cn(function(D, $) {
    process.env.NODE_ENV !== "production" && $n(!a.current.has(D), "Duplicated key '".concat(D, "' used in Menu by path [").concat($.join(" > "), "]"));
    var j = YF($);
    i.current.set(j, D), a.current.set(D, j), g.current += 1;
    var I = g.current;
    Dve(function() {
      I === g.current && w();
    });
  }, []), E = Cn(function(D, $) {
    var j = YF($);
    i.current.delete(j), a.current.delete(D);
  }, []), P = Cn(function(D) {
    p(D);
  }, []), k = Cn(function(D, $) {
    var j = a.current.get(D) || "", I = $ve(j);
    return $ && f.includes(I[0]) && I.unshift(LD), I;
  }, [f]), M = Cn(function(D, $) {
    return D.filter(function(j) {
      return j !== void 0;
    }).some(function(j) {
      var I = k(j, !0);
      return I.includes($);
    });
  }, [k]), T = function() {
    var $ = Et(a.current.keys());
    return f.length && $.push(LD), $;
  }, N = Cn(function(D) {
    var $ = "".concat(a.current.get(D)).concat(fj), j = /* @__PURE__ */ new Set();
    return Et(i.current.keys()).forEach(function(I) {
      I.startsWith($) && j.add(i.current.get(I));
    }), j;
  }, []);
  return S.useEffect(function() {
    return function() {
      b.current = !0;
    };
  }, []), {
    // Register
    registerPath: x,
    unregisterPath: E,
    refreshOverflowKeys: P,
    // Util
    isSubPathKey: M,
    getKeyPath: k,
    getKeys: T,
    getSubPathKeys: N
  };
}
function aE(e) {
  var t = S.useRef(e);
  t.current = e;
  var r = S.useCallback(function() {
    for (var a, i = arguments.length, c = new Array(i), d = 0; d < i; d++)
      c[d] = arguments[d];
    return (a = t.current) === null || a === void 0 ? void 0 : a.call.apply(a, [t].concat(c));
  }, []);
  return e ? r : void 0;
}
var jve = Math.random().toFixed(5).toString().slice(2), QF = 0;
function Ive(e) {
  var t = ll(e, {
    value: e
  }), r = qe(t, 2), a = r[0], i = r[1];
  return S.useEffect(function() {
    QF += 1;
    var c = process.env.NODE_ENV === "test" ? "test" : "".concat(jve, "-").concat(QF);
    i("rc-menu-uuid-".concat(c));
  }, []), a;
}
function VY(e, t, r, a) {
  var i = S.useContext(X1), c = i.activeKey, d = i.onActive, f = i.onInactive, p = {
    active: c === e
  };
  return t || (p.onMouseEnter = function(g) {
    r?.({
      key: e,
      domEvent: g
    }), d(e);
  }, p.onMouseLeave = function(g) {
    a?.({
      key: e,
      domEvent: g
    }), f(e);
  }), p;
}
function _Y(e) {
  var t = S.useContext(X1), r = t.mode, a = t.rtl, i = t.inlineIndent;
  if (r !== "inline")
    return null;
  var c = e;
  return a ? {
    paddingRight: c * i
  } : {
    paddingLeft: c * i
  };
}
function BY(e) {
  var t = e.icon, r = e.props, a = e.children, i;
  return t === null || t === !1 ? null : (typeof t == "function" ? i = /* @__PURE__ */ S.createElement(t, ce({}, r)) : typeof t != "boolean" && (i = t), i || a || null);
}
var Lve = ["item"];
function qk(e) {
  var t = e.item, r = xr(e, Lve);
  return Object.defineProperty(r, "item", {
    get: function() {
      return $n(!1, "`info.item` is deprecated since we will move to function component that not provides React Node instance in future."), t;
    }
  }), r;
}
var Hve = ["title", "attribute", "elementRef"], Fve = ["style", "className", "eventKey", "warnKey", "disabled", "itemIcon", "children", "role", "onMouseEnter", "onMouseLeave", "onClick", "onKeyDown", "onFocus"], Wve = ["active"], Vve = /* @__PURE__ */ (function(e) {
  pd(r, e);
  var t = B0(r);
  function r() {
    return Vi(this, r), t.apply(this, arguments);
  }
  return _i(r, [{
    key: "render",
    value: function() {
      var i = this.props, c = i.title, d = i.attribute, f = i.elementRef, p = xr(i, Hve), g = Rs(p, ["eventKey", "popupClassName", "popupOffset", "onTitleClick"]);
      return $n(!d, "`attribute` of Menu.Item is deprecated. Please pass attribute directly."), /* @__PURE__ */ S.createElement(W1.Item, vt({}, d, {
        title: typeof c == "string" ? c : void 0
      }, g, {
        ref: f
      }));
    }
  }]), r;
})(S.Component), _ve = /* @__PURE__ */ S.forwardRef(function(e, t) {
  var r = e.style, a = e.className, i = e.eventKey, c = e.warnKey, d = e.disabled, f = e.itemIcon, p = e.children, g = e.role, b = e.onMouseEnter, w = e.onMouseLeave, x = e.onClick, E = e.onKeyDown, P = e.onFocus, k = xr(e, Fve), M = IY(i), T = S.useContext(X1), N = T.prefixCls, D = T.onItemClick, $ = T.disabled, j = T.overflowDisabled, I = T.itemIcon, L = T.selectedKeys, F = T.onActive, _ = S.useContext(cj), W = _._internalRenderMenuItem, Q = "".concat(N, "-item"), U = S.useRef(), Y = S.useRef(), G = $ || d, J = gS(t, Y), H = qx(i);
  process.env.NODE_ENV !== "production" && c && $n(!1, "MenuItem should not leave undefined `key`.");
  var K = function(ze) {
    return {
      key: i,
      // Note: For legacy code is reversed which not like other antd component
      keyPath: Et(H).reverse(),
      item: U.current,
      domEvent: ze
    };
  }, X = f || I, te = VY(i, G, b, w), ie = te.active, ee = xr(te, Wve), ne = L.includes(i), ae = _Y(H.length), oe = function(ze) {
    if (!G) {
      var le = K(ze);
      x?.(qk(le)), D(le);
    }
  }, fe = function(ze) {
    if (E?.(ze), ze.which === fn.ENTER) {
      var le = K(ze);
      x?.(qk(le)), D(le);
    }
  }, be = function(ze) {
    F(i), P?.(ze);
  }, me = {};
  e.role === "option" && (me["aria-selected"] = ne);
  var De = /* @__PURE__ */ S.createElement(Vve, vt({
    ref: U,
    elementRef: J,
    role: g === null ? "none" : g || "menuitem",
    tabIndex: d ? null : -1,
    "data-menu-id": j && M ? null : M
  }, Rs(k, ["extra"]), ee, me, {
    component: "li",
    "aria-disabled": d,
    style: ce(ce({}, ae), r),
    className: _e(Q, ge(ge(ge({}, "".concat(Q, "-active"), ie), "".concat(Q, "-selected"), ne), "".concat(Q, "-disabled"), G), a),
    onClick: oe,
    onKeyDown: fe,
    onFocus: be
  }), p, /* @__PURE__ */ S.createElement(BY, {
    props: ce(ce({}, e), {}, {
      isSelected: ne
    }),
    icon: X
  }));
  return W && (De = W(De, e, {
    selected: ne
  })), De;
});
function Bve(e, t) {
  var r = e.eventKey, a = aM(), i = qx(r);
  return S.useEffect(function() {
    if (a)
      return a.registerPath(r, i), function() {
        a.unregisterPath(r, i);
      };
  }, [i]), a ? null : /* @__PURE__ */ S.createElement(_ve, vt({}, e, {
    ref: t
  }));
}
const oM = /* @__PURE__ */ S.forwardRef(Bve);
var Uve = ["className", "children"], Xve = function(t, r) {
  var a = t.className, i = t.children, c = xr(t, Uve), d = S.useContext(X1), f = d.prefixCls, p = d.mode, g = d.rtl;
  return /* @__PURE__ */ S.createElement("ul", vt({
    className: _e(f, g && "".concat(f, "-rtl"), "".concat(f, "-sub"), "".concat(f, "-").concat(p === "inline" ? "inline" : "vertical"), a),
    role: "menu"
  }, c, {
    "data-menu-list": !0,
    ref: r
  }), i);
}, mj = /* @__PURE__ */ S.forwardRef(Xve);
mj.displayName = "SubMenuList";
function hj(e, t) {
  return Kh(e).map(function(r, a) {
    if (/* @__PURE__ */ S.isValidElement(r)) {
      var i, c, d = r.key, f = (i = (c = r.props) === null || c === void 0 ? void 0 : c.eventKey) !== null && i !== void 0 ? i : d, p = f == null;
      p && (f = "tmp_key-".concat([].concat(Et(t), [a]).join("-")));
      var g = {
        key: f,
        eventKey: f
      };
      return process.env.NODE_ENV !== "production" && p && (g.warnKey = !0), /* @__PURE__ */ S.cloneElement(r, g);
    }
    return r;
  });
}
var Jf = {
  adjustX: 1,
  adjustY: 1
}, Gve = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: Jf
  },
  topRight: {
    points: ["br", "tr"],
    overflow: Jf
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: Jf
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: Jf
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: Jf
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: Jf
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: Jf
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: Jf
  }
}, qve = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: Jf
  },
  topRight: {
    points: ["br", "tr"],
    overflow: Jf
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: Jf
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: Jf
  },
  rightTop: {
    points: ["tr", "tl"],
    overflow: Jf
  },
  rightBottom: {
    points: ["br", "bl"],
    overflow: Jf
  },
  leftTop: {
    points: ["tl", "tr"],
    overflow: Jf
  },
  leftBottom: {
    points: ["bl", "br"],
    overflow: Jf
  }
};
function UY(e, t, r) {
  if (t)
    return t;
  if (r)
    return r[e] || r.other;
}
var Kve = {
  horizontal: "bottomLeft",
  vertical: "rightTop",
  "vertical-left": "rightTop",
  "vertical-right": "leftTop"
};
function Yve(e) {
  var t = e.prefixCls, r = e.visible, a = e.children, i = e.popup, c = e.popupStyle, d = e.popupClassName, f = e.popupOffset, p = e.disabled, g = e.mode, b = e.onVisibleChange, w = S.useContext(X1), x = w.getPopupContainer, E = w.rtl, P = w.subMenuOpenDelay, k = w.subMenuCloseDelay, M = w.builtinPlacements, T = w.triggerSubMenuAction, N = w.forceSubMenuRender, D = w.rootClassName, $ = w.motion, j = w.defaultMotions, I = S.useState(!1), L = qe(I, 2), F = L[0], _ = L[1], W = ce(E ? ce({}, qve) : ce({}, Gve), M), Q = Kve[g], U = UY(g, $, j), Y = S.useRef(U);
  g !== "inline" && (Y.current = U);
  var G = ce(ce({}, Y.current), {}, {
    leavedClassName: "".concat(t, "-hidden"),
    removeOnLeave: !1,
    motionAppear: !0
  }), J = S.useRef();
  return S.useEffect(function() {
    return J.current = Pa(function() {
      _(r);
    }), function() {
      Pa.cancel(J.current);
    };
  }, [r]), /* @__PURE__ */ S.createElement(e7, {
    prefixCls: t,
    popupClassName: _e("".concat(t, "-popup"), ge({}, "".concat(t, "-rtl"), E), d, D),
    stretch: g === "horizontal" ? "minWidth" : null,
    getPopupContainer: x,
    builtinPlacements: W,
    popupPlacement: Q,
    popupVisible: F,
    popup: i,
    popupStyle: c,
    popupAlign: f && {
      offset: f
    },
    action: p ? [] : [T],
    mouseEnterDelay: P,
    mouseLeaveDelay: k,
    onPopupVisibleChange: b,
    forceRender: N,
    popupMotion: G,
    fresh: !0
  }, a);
}
function Qve(e) {
  var t = e.id, r = e.open, a = e.keyPath, i = e.children, c = "inline", d = S.useContext(X1), f = d.prefixCls, p = d.forceSubMenuRender, g = d.motion, b = d.defaultMotions, w = d.mode, x = S.useRef(!1);
  x.current = w === c;
  var E = S.useState(!x.current), P = qe(E, 2), k = P[0], M = P[1], T = x.current ? r : !1;
  S.useEffect(function() {
    x.current && M(!1);
  }, [w]);
  var N = ce({}, UY(c, g, b));
  a.length > 1 && (N.motionAppear = !1);
  var D = N.onVisibleChanged;
  return N.onVisibleChanged = function($) {
    return !x.current && !$ && M(!0), D?.($);
  }, k ? null : /* @__PURE__ */ S.createElement(DE, {
    mode: c,
    locked: !x.current
  }, /* @__PURE__ */ S.createElement(N0, vt({
    visible: T
  }, N, {
    forceRender: p,
    removeOnLeave: !1,
    leavedClassName: "".concat(f, "-hidden")
  }), function($) {
    var j = $.className, I = $.style;
    return /* @__PURE__ */ S.createElement(mj, {
      id: t,
      className: j,
      style: I
    }, i);
  }));
}
var Jve = ["style", "className", "title", "eventKey", "warnKey", "disabled", "internalPopupClose", "children", "itemIcon", "expandIcon", "popupClassName", "popupOffset", "popupStyle", "onClick", "onMouseEnter", "onMouseLeave", "onTitleClick", "onTitleMouseEnter", "onTitleMouseLeave"], Zve = ["active"], e2e = /* @__PURE__ */ S.forwardRef(function(e, t) {
  var r = e.style, a = e.className, i = e.title, c = e.eventKey, d = e.warnKey, f = e.disabled, p = e.internalPopupClose, g = e.children, b = e.itemIcon, w = e.expandIcon, x = e.popupClassName, E = e.popupOffset, P = e.popupStyle, k = e.onClick, M = e.onMouseEnter, T = e.onMouseLeave, N = e.onTitleClick, D = e.onTitleMouseEnter, $ = e.onTitleMouseLeave, j = xr(e, Jve), I = IY(c), L = S.useContext(X1), F = L.prefixCls, _ = L.mode, W = L.openKeys, Q = L.disabled, U = L.overflowDisabled, Y = L.activeKey, G = L.selectedKeys, J = L.itemIcon, H = L.expandIcon, K = L.onItemClick, X = L.onOpenChange, te = L.onActive, ie = S.useContext(cj), ee = ie._internalRenderSubMenuItem, ne = S.useContext(FY), ae = ne.isSubPathKey, oe = qx(), fe = "".concat(F, "-submenu"), be = Q || f, me = S.useRef(), De = S.useRef();
  process.env.NODE_ENV !== "production" && d && $n(!1, "SubMenu should not leave undefined `key`.");
  var Me = b ?? J, ze = w ?? H, le = W.includes(c), se = !U && le, Ae = ae(G, c), we = VY(c, be, D, $), Ne = we.active, pe = xr(we, Zve), Qe = S.useState(!1), Le = qe(Qe, 2), Te = Le[0], Oe = Le[1], ye = function(at) {
    be || Oe(at);
  }, je = function(at) {
    ye(!0), M?.({
      key: c,
      domEvent: at
    });
  }, Ue = function(at) {
    ye(!1), T?.({
      key: c,
      domEvent: at
    });
  }, Fe = S.useMemo(function() {
    return Ne || (_ !== "inline" ? Te || ae([Y], c) : !1);
  }, [_, Ne, Y, Te, c, ae]), tt = _Y(oe.length), dt = function(at) {
    be || (N?.({
      key: c,
      domEvent: at
    }), _ === "inline" && X(c, !le));
  }, St = aE(function(ot) {
    k?.(qk(ot)), K(ot);
  }), mt = function(at) {
    _ !== "inline" && X(c, at);
  }, Ot = function() {
    te(c);
  }, Rt = I && "".concat(I, "-popup"), ct = S.useMemo(function() {
    return /* @__PURE__ */ S.createElement(BY, {
      icon: _ !== "horizontal" ? ze : void 0,
      props: ce(ce({}, e), {}, {
        isOpen: se,
        // [Legacy] Not sure why need this mark
        isSubMenu: !0
      })
    }, /* @__PURE__ */ S.createElement("i", {
      className: "".concat(fe, "-arrow")
    }));
  }, [_, ze, e, se, fe]), it = /* @__PURE__ */ S.createElement("div", vt({
    role: "menuitem",
    style: tt,
    className: "".concat(fe, "-title"),
    tabIndex: be ? null : -1,
    ref: me,
    title: typeof i == "string" ? i : null,
    "data-menu-id": U && I ? null : I,
    "aria-expanded": se,
    "aria-haspopup": !0,
    "aria-controls": Rt,
    "aria-disabled": be,
    onClick: dt,
    onFocus: Ot
  }, pe), i, ct), Ct = S.useRef(_);
  if (_ !== "inline" && oe.length > 1 ? Ct.current = "vertical" : Ct.current = _, !U) {
    var ut = Ct.current;
    it = /* @__PURE__ */ S.createElement(Yve, {
      mode: ut,
      prefixCls: fe,
      visible: !p && se && _ !== "inline",
      popupClassName: x,
      popupOffset: E,
      popupStyle: P,
      popup: /* @__PURE__ */ S.createElement(
        DE,
        {
          mode: ut === "horizontal" ? "vertical" : ut
        },
        /* @__PURE__ */ S.createElement(mj, {
          id: Rt,
          ref: De
        }, g)
      ),
      disabled: be,
      onVisibleChange: mt
    }, it);
  }
  var ht = /* @__PURE__ */ S.createElement(W1.Item, vt({
    ref: t,
    role: "none"
  }, j, {
    component: "li",
    style: r,
    className: _e(fe, "".concat(fe, "-").concat(_), a, ge(ge(ge(ge({}, "".concat(fe, "-open"), se), "".concat(fe, "-active"), Fe), "".concat(fe, "-selected"), Ae), "".concat(fe, "-disabled"), be)),
    onMouseEnter: je,
    onMouseLeave: Ue
  }), it, !U && /* @__PURE__ */ S.createElement(Qve, {
    id: Rt,
    open: se,
    keyPath: oe
  }, g));
  return ee && (ht = ee(ht, e, {
    selected: Ae,
    active: Fe,
    open: se,
    disabled: be
  })), /* @__PURE__ */ S.createElement(DE, {
    onItemClick: St,
    mode: _ === "horizontal" ? "vertical" : _,
    itemIcon: Me,
    expandIcon: ze
  }, ht);
}), n7 = /* @__PURE__ */ S.forwardRef(function(e, t) {
  var r = e.eventKey, a = e.children, i = qx(r), c = hj(a, i), d = aM();
  S.useEffect(function() {
    if (d)
      return d.registerPath(r, i), function() {
        d.unregisterPath(r, i);
      };
  }, [i]);
  var f;
  return d ? f = c : f = /* @__PURE__ */ S.createElement(e2e, vt({
    ref: t
  }, e), c), /* @__PURE__ */ S.createElement(HY.Provider, {
    value: i
  }, f);
});
process.env.NODE_ENV !== "production" && (n7.displayName = "SubMenu");
function pj(e) {
  var t = e.className, r = e.style, a = S.useContext(X1), i = a.prefixCls, c = aM();
  return c ? null : /* @__PURE__ */ S.createElement("li", {
    role: "separator",
    className: _e("".concat(i, "-item-divider"), t),
    style: r
  });
}
var t2e = ["className", "title", "eventKey", "children"], n2e = /* @__PURE__ */ S.forwardRef(function(e, t) {
  var r = e.className, a = e.title;
  e.eventKey;
  var i = e.children, c = xr(e, t2e), d = S.useContext(X1), f = d.prefixCls, p = "".concat(f, "-item-group");
  return /* @__PURE__ */ S.createElement("li", vt({
    ref: t,
    role: "presentation"
  }, c, {
    onClick: function(b) {
      return b.stopPropagation();
    },
    className: _e(p, r)
  }), /* @__PURE__ */ S.createElement("div", {
    role: "presentation",
    className: "".concat(p, "-title"),
    title: typeof a == "string" ? a : void 0
  }, a), /* @__PURE__ */ S.createElement("ul", {
    role: "group",
    className: "".concat(p, "-list")
  }, i));
}), iM = /* @__PURE__ */ S.forwardRef(function(e, t) {
  var r = e.eventKey, a = e.children, i = qx(r), c = hj(a, i), d = aM();
  return d ? c : /* @__PURE__ */ S.createElement(n2e, vt({
    ref: t
  }, Rs(e, ["warnKey"])), c);
});
process.env.NODE_ENV !== "production" && (iM.displayName = "MenuItemGroup");
var r2e = ["label", "children", "key", "type", "extra"];
function HD(e, t, r) {
  var a = t.item, i = t.group, c = t.submenu, d = t.divider;
  return (e || []).map(function(f, p) {
    if (f && Hn(f) === "object") {
      var g = f, b = g.label, w = g.children, x = g.key, E = g.type, P = g.extra, k = xr(g, r2e), M = x ?? "tmp-".concat(p);
      return w || E === "group" ? E === "group" ? /* @__PURE__ */ S.createElement(i, vt({
        key: M
      }, k, {
        title: b
      }), HD(w, t, r)) : /* @__PURE__ */ S.createElement(c, vt({
        key: M
      }, k, {
        title: b
      }), HD(w, t, r)) : E === "divider" ? /* @__PURE__ */ S.createElement(d, vt({
        key: M
      }, k)) : /* @__PURE__ */ S.createElement(a, vt({
        key: M
      }, k, {
        extra: P
      }), b, (!!P || P === 0) && /* @__PURE__ */ S.createElement("span", {
        className: "".concat(r, "-item-extra")
      }, P));
    }
    return null;
  }).filter(function(f) {
    return f;
  });
}
function JF(e, t, r, a, i) {
  var c = e, d = ce({
    divider: pj,
    item: oM,
    group: iM,
    submenu: n7
  }, a);
  return t && (c = HD(t, d, i)), hj(c, r);
}
var a2e = ["prefixCls", "rootClassName", "style", "className", "tabIndex", "items", "children", "direction", "id", "mode", "inlineCollapsed", "disabled", "disabledOverflow", "subMenuOpenDelay", "subMenuCloseDelay", "forceSubMenuRender", "defaultOpenKeys", "openKeys", "activeKey", "defaultActiveFirst", "selectable", "multiple", "defaultSelectedKeys", "selectedKeys", "onSelect", "onDeselect", "inlineIndent", "motion", "defaultMotions", "triggerSubMenuAction", "builtinPlacements", "itemIcon", "expandIcon", "overflowedIndicator", "overflowedIndicatorPopupClassName", "getPopupContainer", "onClick", "onOpenChange", "onKeyDown", "openAnimation", "openTransitionName", "_internalRenderMenuItem", "_internalRenderSubMenuItem", "_internalComponents"], $4 = [], o2e = /* @__PURE__ */ S.forwardRef(function(e, t) {
  var r, a = e, i = a.prefixCls, c = i === void 0 ? "rc-menu" : i, d = a.rootClassName, f = a.style, p = a.className, g = a.tabIndex, b = g === void 0 ? 0 : g, w = a.items, x = a.children, E = a.direction, P = a.id, k = a.mode, M = k === void 0 ? "vertical" : k, T = a.inlineCollapsed, N = a.disabled, D = a.disabledOverflow, $ = a.subMenuOpenDelay, j = $ === void 0 ? 0.1 : $, I = a.subMenuCloseDelay, L = I === void 0 ? 0.1 : I, F = a.forceSubMenuRender, _ = a.defaultOpenKeys, W = a.openKeys, Q = a.activeKey, U = a.defaultActiveFirst, Y = a.selectable, G = Y === void 0 ? !0 : Y, J = a.multiple, H = J === void 0 ? !1 : J, K = a.defaultSelectedKeys, X = a.selectedKeys, te = a.onSelect, ie = a.onDeselect, ee = a.inlineIndent, ne = ee === void 0 ? 24 : ee, ae = a.motion, oe = a.defaultMotions, fe = a.triggerSubMenuAction, be = fe === void 0 ? "hover" : fe, me = a.builtinPlacements, De = a.itemIcon, Me = a.expandIcon, ze = a.overflowedIndicator, le = ze === void 0 ? "..." : ze, se = a.overflowedIndicatorPopupClassName, Ae = a.getPopupContainer, we = a.onClick, Ne = a.onOpenChange, pe = a.onKeyDown, Qe = a.openAnimation, Le = a.openTransitionName, Te = a._internalRenderMenuItem, Oe = a._internalRenderSubMenuItem, ye = a._internalComponents, je = xr(a, a2e), Ue = S.useMemo(function() {
    return [JF(x, w, $4, ye, c), JF(x, w, $4, {}, c)];
  }, [x, w, ye]), Fe = qe(Ue, 2), tt = Fe[0], dt = Fe[1], St = S.useState(!1), mt = qe(St, 2), Ot = mt[0], Rt = mt[1], ct = S.useRef(), it = Ive(P), Ct = E === "rtl";
  process.env.NODE_ENV !== "production" && $n(!Qe && !Le, "`openAnimation` and `openTransitionName` is removed. Please use `motion` or `defaultMotion` instead.");
  var ut = ll(_, {
    value: W,
    postState: function(On) {
      return On || $4;
    }
  }), ht = qe(ut, 2), ot = ht[0], at = ht[1], ft = function(On) {
    var Qt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    function nn() {
      at(On), Ne?.(On);
    }
    Qt ? FS(nn) : nn();
  }, st = S.useState(ot), pt = qe(st, 2), bt = pt[0], Nt = pt[1], $t = S.useRef(!1), Pt = S.useMemo(function() {
    return (M === "inline" || M === "vertical") && T ? ["vertical", T] : [M, !1];
  }, [M, T]), hn = qe(Pt, 2), an = hn[0], jn = hn[1], xn = an === "inline", Ut = S.useState(an), pn = qe(Ut, 2), wn = pn[0], Lt = pn[1], gt = S.useState(jn), wt = qe(gt, 2), Ft = wt[0], yn = wt[1];
  S.useEffect(function() {
    Lt(an), yn(jn), $t.current && (xn ? at(bt) : ft($4));
  }, [an, jn]);
  var gn = S.useState(0), Tn = qe(gn, 2), Gt = Tn[0], Dt = Tn[1], Yt = Gt >= tt.length - 1 || wn !== "horizontal" || D;
  S.useEffect(function() {
    xn && Nt(ot);
  }, [ot]), S.useEffect(function() {
    return $t.current = !0, function() {
      $t.current = !1;
    };
  }, []);
  var Mn = zve(), Gn = Mn.registerPath, wr = Mn.unregisterPath, aa = Mn.refreshOverflowKeys, qn = Mn.isSubPathKey, Rr = Mn.getKeyPath, Wt = Mn.getKeys, en = Mn.getSubPathKeys, Xt = S.useMemo(function() {
    return {
      registerPath: Gn,
      unregisterPath: wr
    };
  }, [Gn, wr]), zt = S.useMemo(function() {
    return {
      isSubPathKey: qn
    };
  }, [qn]);
  S.useEffect(function() {
    aa(Yt ? $4 : tt.slice(Gt + 1).map(function(zn) {
      return zn.key;
    }));
  }, [Gt, Yt]);
  var kt = ll(Q || U && ((r = tt[0]) === null || r === void 0 ? void 0 : r.key), {
    value: Q
  }), Qn = qe(kt, 2), Jn = Qn[0], Nr = Qn[1], Hr = aE(function(zn) {
    Nr(zn);
  }), oa = aE(function() {
    Nr(void 0);
  });
  pS(t, function() {
    return {
      list: ct.current,
      focus: function(On) {
        var Qt, nn = Wt(), er = ID(nn, it), ia = er.elements, so = er.key2element, hi = er.element2key, ka = dj(ct.current, ia), Ui = Jn ?? (ka[0] ? hi.get(ka[0]) : (Qt = tt.find(function(Kt) {
          return !Kt.props.disabled;
        })) === null || Qt === void 0 ? void 0 : Qt.key), sl = so.get(Ui);
        if (Ui && sl) {
          var qt;
          sl == null || (qt = sl.focus) === null || qt === void 0 || qt.call(sl, On);
        }
      }
    };
  });
  var dn = ll(K || [], {
    value: X,
    // Legacy convert key to array
    postState: function(On) {
      return Array.isArray(On) ? On : On == null ? $4 : [On];
    }
  }), Un = qe(dn, 2), sr = Un[0], Yr = Un[1], Wa = function(On) {
    if (G) {
      var Qt = On.key, nn = sr.includes(Qt), er;
      H ? nn ? er = sr.filter(function(so) {
        return so !== Qt;
      }) : er = [].concat(Et(sr), [Qt]) : er = [Qt], Yr(er);
      var ia = ce(ce({}, On), {}, {
        selectedKeys: er
      });
      nn ? ie?.(ia) : te?.(ia);
    }
    !H && ot.length && wn !== "inline" && ft($4);
  }, pa = aE(function(zn) {
    we?.(qk(zn)), Wa(zn);
  }), Jr = aE(function(zn, On) {
    var Qt = ot.filter(function(er) {
      return er !== zn;
    });
    if (On)
      Qt.push(zn);
    else if (wn !== "inline") {
      var nn = en(zn);
      Qt = Qt.filter(function(er) {
        return !nn.has(er);
      });
    }
    R0(ot, Qt, !0) || ft(Qt, !0);
  }), si = function(On, Qt) {
    var nn = Qt ?? !ot.includes(On);
    Jr(On, nn);
  }, mi = Nve(wn, Jn, Ct, it, ct, Wt, Rr, Nr, si, pe);
  S.useEffect(function() {
    Rt(!0);
  }, []);
  var Yo = S.useMemo(function() {
    return {
      _internalRenderMenuItem: Te,
      _internalRenderSubMenuItem: Oe
    };
  }, [Te, Oe]), Bi = wn !== "horizontal" || D ? tt : (
    // Need wrap for overflow dropdown that do not response for open
    tt.map(function(zn, On) {
      return (
        // Always wrap provider to avoid sub node re-mount
        /* @__PURE__ */ S.createElement(DE, {
          key: zn.key,
          overflowDisabled: On > Gt
        }, zn)
      );
    })
  ), hr = /* @__PURE__ */ S.createElement(W1, vt({
    id: P,
    ref: ct,
    prefixCls: "".concat(c, "-overflow"),
    component: "ul",
    itemComponent: oM,
    className: _e(c, "".concat(c, "-root"), "".concat(c, "-").concat(wn), p, ge(ge({}, "".concat(c, "-inline-collapsed"), Ft), "".concat(c, "-rtl"), Ct), d),
    dir: E,
    style: f,
    role: "menu",
    tabIndex: b,
    data: Bi,
    renderRawItem: function(On) {
      return On;
    },
    renderRawRest: function(On) {
      var Qt = On.length, nn = Qt ? tt.slice(-Qt) : null;
      return /* @__PURE__ */ S.createElement(n7, {
        eventKey: LD,
        title: le,
        disabled: Yt,
        internalPopupClose: Qt === 0,
        popupClassName: se
      }, nn);
    },
    maxCount: wn !== "horizontal" || D ? W1.INVALIDATE : W1.RESPONSIVE,
    ssr: "full",
    "data-menu-list": !0,
    onVisibleChange: function(On) {
      Dt(On);
    },
    onKeyDown: mi
  }, je));
  return /* @__PURE__ */ S.createElement(cj.Provider, {
    value: Yo
  }, /* @__PURE__ */ S.createElement(zY.Provider, {
    value: it
  }, /* @__PURE__ */ S.createElement(DE, {
    prefixCls: c,
    rootClassName: d,
    mode: wn,
    openKeys: ot,
    rtl: Ct,
    disabled: N,
    motion: Ot ? ae : null,
    defaultMotions: Ot ? oe : null,
    activeKey: Jn,
    onActive: Hr,
    onInactive: oa,
    selectedKeys: sr,
    inlineIndent: ne,
    subMenuOpenDelay: j,
    subMenuCloseDelay: L,
    forceSubMenuRender: F,
    builtinPlacements: me,
    triggerSubMenuAction: be,
    getPopupContainer: Ae,
    itemIcon: De,
    expandIcon: Me,
    onItemClick: pa,
    onOpenChange: Jr
  }, /* @__PURE__ */ S.createElement(FY.Provider, {
    value: zt
  }, hr), /* @__PURE__ */ S.createElement("div", {
    style: {
      display: "none"
    },
    "aria-hidden": !0
  }, /* @__PURE__ */ S.createElement(LY.Provider, {
    value: Xt
  }, dt)))));
}), r7 = o2e;
r7.Item = oM;
r7.SubMenu = n7;
r7.ItemGroup = iM;
r7.Divider = pj;
var i2e = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, name: "bars", theme: "outlined" }, l2e = function(t, r) {
  return /* @__PURE__ */ S.createElement(Ao, vt({}, t, {
    ref: r,
    icon: i2e
  }));
}, XY = /* @__PURE__ */ S.forwardRef(l2e);
process.env.NODE_ENV !== "production" && (XY.displayName = "BarsOutlined");
const s2e = /* @__PURE__ */ S.createContext({
  siderHook: {
    addSider: () => null,
    removeSider: () => null
  }
}), u2e = (e) => {
  const {
    antCls: t,
    // .ant
    componentCls: r,
    // .ant-layout
    colorText: a,
    footerBg: i,
    headerHeight: c,
    headerPadding: d,
    headerColor: f,
    footerPadding: p,
    fontSize: g,
    bodyBg: b,
    headerBg: w
  } = e;
  return {
    [r]: {
      display: "flex",
      flex: "auto",
      flexDirection: "column",
      /* fix firefox can't set height smaller than content on flex item */
      minHeight: 0,
      background: b,
      "&, *": {
        boxSizing: "border-box"
      },
      [`&${r}-has-sider`]: {
        flexDirection: "row",
        [`> ${r}, > ${r}-content`]: {
          // https://segmentfault.com/a/1190000019498300
          width: 0
        }
      },
      [`${r}-header, &${r}-footer`]: {
        flex: "0 0 auto"
      },
      // RTL
      "&-rtl": {
        direction: "rtl"
      }
    },
    // ==================== Header ====================
    [`${r}-header`]: {
      height: c,
      padding: d,
      color: f,
      lineHeight: Ye(c),
      background: w,
      // Other components/menu/style/index.less line:686
      // Integration with header element so menu items have the same height
      [`${t}-menu`]: {
        lineHeight: "inherit"
      }
    },
    // ==================== Footer ====================
    [`${r}-footer`]: {
      padding: p,
      color: a,
      fontSize: g,
      background: i
    },
    // =================== Content ====================
    [`${r}-content`]: {
      flex: "auto",
      color: a,
      // fix firefox can't set height smaller than content on flex item
      minHeight: 0
    }
  };
}, GY = (e) => {
  const {
    colorBgLayout: t,
    controlHeight: r,
    controlHeightLG: a,
    colorText: i,
    controlHeightSM: c,
    marginXXS: d,
    colorTextLightSolid: f,
    colorBgContainer: p
  } = e, g = a * 1.25;
  return {
    // Deprecated
    colorBgHeader: "#001529",
    colorBgBody: t,
    colorBgTrigger: "#002140",
    bodyBg: t,
    headerBg: "#001529",
    headerHeight: r * 2,
    headerPadding: `0 ${g}px`,
    headerColor: i,
    footerPadding: `${c}px ${g}px`,
    footerBg: t,
    siderBg: "#001529",
    triggerHeight: a + d * 2,
    triggerBg: "#002140",
    triggerColor: f,
    zeroTriggerWidth: a,
    zeroTriggerHeight: a,
    lightSiderBg: p,
    lightTriggerBg: p,
    lightTriggerColor: i
  };
}, qY = [["colorBgBody", "bodyBg"], ["colorBgHeader", "headerBg"], ["colorBgTrigger", "triggerBg"]];
Ii("Layout", u2e, GY, {
  deprecatedTokens: qY
});
const c2e = (e) => {
  const {
    componentCls: t,
    siderBg: r,
    motionDurationMid: a,
    motionDurationSlow: i,
    antCls: c,
    triggerHeight: d,
    triggerColor: f,
    triggerBg: p,
    headerHeight: g,
    zeroTriggerWidth: b,
    zeroTriggerHeight: w,
    borderRadiusLG: x,
    lightSiderBg: E,
    lightTriggerColor: P,
    lightTriggerBg: k,
    bodyBg: M
  } = e;
  return {
    [t]: {
      position: "relative",
      // fix firefox can't set width smaller than content on flex item
      minWidth: 0,
      background: r,
      transition: `all ${a}, background 0s`,
      "&-has-trigger": {
        paddingBottom: d
      },
      "&-right": {
        order: 1
      },
      [`${t}-children`]: {
        height: "100%",
        // Hack for fixing margin collapse bug
        // https://github.com/ant-design/ant-design/issues/7967
        // solution from https://stackoverflow.com/a/33132624/3040605
        marginTop: -0.1,
        paddingTop: 0.1,
        [`${c}-menu${c}-menu-inline-collapsed`]: {
          width: "auto"
        }
      },
      [`&-zero-width ${t}-children`]: {
        overflow: "hidden"
      },
      [`${t}-trigger`]: {
        position: "fixed",
        bottom: 0,
        zIndex: 1,
        height: d,
        color: f,
        lineHeight: Ye(d),
        textAlign: "center",
        background: p,
        cursor: "pointer",
        transition: `all ${a}`
      },
      [`${t}-zero-width-trigger`]: {
        position: "absolute",
        top: g,
        insetInlineEnd: e.calc(b).mul(-1).equal(),
        zIndex: 1,
        width: b,
        height: w,
        color: f,
        fontSize: e.fontSizeXL,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: r,
        borderRadius: `0 ${Ye(x)} ${Ye(x)} 0`,
        cursor: "pointer",
        transition: `background ${i} ease`,
        "&::after": {
          position: "absolute",
          inset: 0,
          background: "transparent",
          transition: `all ${i}`,
          content: '""'
        },
        "&:hover::after": {
          background: "rgba(255, 255, 255, 0.2)"
        },
        "&-right": {
          insetInlineStart: e.calc(b).mul(-1).equal(),
          borderRadius: `${Ye(x)} 0 0 ${Ye(x)}`
        }
      },
      // Light
      "&-light": {
        background: E,
        [`${t}-trigger`]: {
          color: P,
          background: k
        },
        [`${t}-zero-width-trigger`]: {
          color: P,
          background: k,
          border: `1px solid ${M}`,
          // Safe to modify to any other color
          borderInlineStart: 0
        }
      }
    }
  };
}, d2e = Ii(["Layout", "Sider"], c2e, GY, {
  deprecatedTokens: qY
});
var f2e = function(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
    t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
};
const ZF = {
  xs: "479.98px",
  sm: "575.98px",
  md: "767.98px",
  lg: "991.98px",
  xl: "1199.98px",
  xxl: "1599.98px"
}, m2e = (e) => !Number.isNaN(Number.parseFloat(e)) && Number.isFinite(Number(e)), gj = /* @__PURE__ */ S.createContext({}), h2e = /* @__PURE__ */ (() => {
  let e = 0;
  return (t = "") => (e += 1, `${t}${e}`);
})(), p2e = /* @__PURE__ */ S.forwardRef((e, t) => {
  const {
    prefixCls: r,
    className: a,
    trigger: i,
    children: c,
    defaultCollapsed: d = !1,
    theme: f = "dark",
    style: p = {},
    collapsible: g = !1,
    reverseArrow: b = !1,
    width: w = 200,
    collapsedWidth: x = 80,
    zeroWidthTriggerStyle: E,
    breakpoint: P,
    onCollapse: k,
    onBreakpoint: M
  } = e, T = f2e(e, ["prefixCls", "className", "trigger", "children", "defaultCollapsed", "theme", "style", "collapsible", "reverseArrow", "width", "collapsedWidth", "zeroWidthTriggerStyle", "breakpoint", "onCollapse", "onBreakpoint"]), {
    siderHook: N
  } = Do(s2e), [D, $] = Wn("collapsed" in e ? e.collapsed : d), [j, I] = Wn(!1);
  Er(() => {
    "collapsed" in e && $(e.collapsed);
  }, [e.collapsed]);
  const L = (De, Me) => {
    "collapsed" in e || $(De), k?.(De, Me);
  }, {
    getPrefixCls: F,
    direction: _
  } = Do(Qr), W = F("layout-sider", r), [Q, U, Y] = d2e(W), G = It(null);
  G.current = (De) => {
    I(De.matches), M?.(De.matches), D !== De.matches && L(De.matches, "responsive");
  }, Er(() => {
    function De(ze) {
      var le;
      return (le = G.current) === null || le === void 0 ? void 0 : le.call(G, ze);
    }
    let Me;
    return typeof window?.matchMedia < "u" && P && P in ZF && (Me = window.matchMedia(`screen and (max-width: ${ZF[P]})`), xY(Me, De), De(Me)), () => {
      EY(Me, De);
    };
  }, [P]), Er(() => {
    const De = h2e("ant-sider-");
    return N.addSider(De), () => N.removeSider(De);
  }, []);
  const J = () => {
    L(!D, "clickTrigger");
  }, H = Rs(T, ["collapsed"]), K = D ? x : w, X = m2e(K) ? `${K}px` : String(K), te = Number.parseFloat(String(x || 0)) === 0 ? /* @__PURE__ */ S.createElement("span", {
    onClick: J,
    className: _e(`${W}-zero-width-trigger`, `${W}-zero-width-trigger-${b ? "right" : "left"}`),
    style: E
  }, i || /* @__PURE__ */ S.createElement(XY, null)) : null, ie = _ === "rtl" == !b, ae = {
    expanded: ie ? /* @__PURE__ */ S.createElement(Ex, null) : /* @__PURE__ */ S.createElement(Mx, null),
    collapsed: ie ? /* @__PURE__ */ S.createElement(Mx, null) : /* @__PURE__ */ S.createElement(Ex, null)
  }[D ? "collapsed" : "expanded"], oe = i !== null ? te || /* @__PURE__ */ S.createElement("div", {
    className: `${W}-trigger`,
    onClick: J,
    style: {
      width: X
    }
  }, i || ae) : null, fe = Object.assign(Object.assign({}, p), {
    flex: `0 0 ${X}`,
    maxWidth: X,
    minWidth: X,
    width: X
  }), be = _e(W, `${W}-${f}`, {
    [`${W}-collapsed`]: !!D,
    [`${W}-has-trigger`]: g && i !== null && !te,
    [`${W}-below`]: !!j,
    [`${W}-zero-width`]: Number.parseFloat(X) === 0
  }, a, U, Y), me = S.useMemo(() => ({
    siderCollapsed: D
  }), [D]);
  return Q(/* @__PURE__ */ S.createElement(gj.Provider, {
    value: me
  }, /* @__PURE__ */ S.createElement("aside", Object.assign({
    className: be
  }, H, {
    style: fe,
    ref: t
  }), /* @__PURE__ */ S.createElement("div", {
    className: `${W}-children`
  }, c), g || j && te ? oe : null)));
});
process.env.NODE_ENV !== "production" && (p2e.displayName = "Sider");
var g2e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, name: "ellipsis", theme: "outlined" }, v2e = function(t, r) {
  return /* @__PURE__ */ S.createElement(Ao, vt({}, t, {
    ref: r,
    icon: g2e
  }));
}, vj = /* @__PURE__ */ S.forwardRef(v2e);
process.env.NODE_ENV !== "production" && (vj.displayName = "EllipsisOutlined");
const Kk = /* @__PURE__ */ fp({
  prefixCls: "",
  firstLevel: !0,
  inlineCollapsed: !1
});
var b2e = function(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
    t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
};
const KY = (e) => {
  const {
    prefixCls: t,
    className: r,
    dashed: a
  } = e, i = b2e(e, ["prefixCls", "className", "dashed"]), {
    getPrefixCls: c
  } = S.useContext(Qr), d = c("menu", t), f = _e({
    [`${d}-item-divider-dashed`]: !!a
  }, r);
  return /* @__PURE__ */ S.createElement(pj, Object.assign({
    className: f
  }, i));
}, YY = (e) => {
  var t;
  const {
    className: r,
    children: a,
    icon: i,
    title: c,
    danger: d,
    extra: f
  } = e, {
    prefixCls: p,
    firstLevel: g,
    direction: b,
    disableMenuItemTitleTooltip: w,
    inlineCollapsed: x
  } = S.useContext(Kk), E = (D) => {
    const $ = a?.[0], j = /* @__PURE__ */ S.createElement("span", {
      className: _e(`${p}-title-content`, {
        [`${p}-title-content-with-extra`]: !!f || f === 0
      })
    }, a);
    return (!i || /* @__PURE__ */ S.isValidElement(a) && a.type === "span") && a && D && g && typeof $ == "string" ? /* @__PURE__ */ S.createElement("div", {
      className: `${p}-inline-collapsed-noicon`
    }, $.charAt(0)) : j;
  }, {
    siderCollapsed: P
  } = S.useContext(gj);
  let k = c;
  typeof c > "u" ? k = g ? a : "" : c === !1 && (k = "");
  const M = {
    title: k
  };
  !P && !x && (M.title = null, M.open = !1);
  const T = Kh(a).length;
  let N = /* @__PURE__ */ S.createElement(oM, Object.assign({}, Rs(e, ["title", "icon", "danger"]), {
    className: _e({
      [`${p}-item-danger`]: d,
      [`${p}-item-only-child`]: (i ? T + 1 : T) === 1
    }, r),
    title: typeof c == "string" ? c : void 0
  }), up(i, {
    className: _e(/* @__PURE__ */ S.isValidElement(i) ? (t = i.props) === null || t === void 0 ? void 0 : t.className : void 0, `${p}-item-icon`)
  }), E(x));
  return w || (N = /* @__PURE__ */ S.createElement(U1, Object.assign({}, M, {
    placement: b === "rtl" ? "left" : "right",
    classNames: {
      root: `${p}-inline-collapsed-tooltip`
    }
  }), N)), N;
};
var y2e = function(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
    t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
};
const Yk = /* @__PURE__ */ S.createContext(null), QY = /* @__PURE__ */ S.forwardRef((e, t) => {
  const {
    children: r
  } = e, a = y2e(e, ["children"]), i = S.useContext(Yk), c = S.useMemo(() => Object.assign(Object.assign({}, i), a), [
    i,
    a.prefixCls,
    // restProps.expandIcon, Not mark as deps since this is a ReactNode
    a.mode,
    a.selectable,
    a.rootClassName
    // restProps.validator, Not mark as deps since this is a function
  ]), d = Mle(r), f = gS(t, d ? m3(r) : null);
  return /* @__PURE__ */ S.createElement(Yk.Provider, {
    value: c
  }, /* @__PURE__ */ S.createElement(dS, {
    space: !0
  }, d ? /* @__PURE__ */ S.cloneElement(r, {
    ref: f
  }) : r));
}), w2e = (e) => {
  const {
    componentCls: t,
    motionDurationSlow: r,
    horizontalLineHeight: a,
    colorSplit: i,
    lineWidth: c,
    lineType: d,
    itemPaddingInline: f
  } = e;
  return {
    [`${t}-horizontal`]: {
      lineHeight: a,
      border: 0,
      borderBottom: `${Ye(c)} ${d} ${i}`,
      boxShadow: "none",
      "&::after": {
        display: "block",
        clear: "both",
        height: 0,
        content: '"\\20"'
      },
      // ======================= Item =======================
      [`${t}-item, ${t}-submenu`]: {
        position: "relative",
        display: "inline-block",
        verticalAlign: "bottom",
        paddingInline: f
      },
      [`> ${t}-item:hover,
        > ${t}-item-active,
        > ${t}-submenu ${t}-submenu-title:hover`]: {
        backgroundColor: "transparent"
      },
      [`${t}-item, ${t}-submenu-title`]: {
        transition: [`border-color ${r}`, `background ${r}`].join(",")
      },
      // ===================== Sub Menu =====================
      [`${t}-submenu-arrow`]: {
        display: "none"
      }
    }
  };
}, S2e = ({
  componentCls: e,
  menuArrowOffset: t,
  calc: r
}) => ({
  [`${e}-rtl`]: {
    direction: "rtl"
  },
  [`${e}-submenu-rtl`]: {
    transformOrigin: "100% 0"
  },
  // Vertical Arrow
  [`${e}-rtl${e}-vertical,
    ${e}-submenu-rtl ${e}-vertical`]: {
    [`${e}-submenu-arrow`]: {
      "&::before": {
        transform: `rotate(-45deg) translateY(${Ye(r(t).mul(-1).equal())})`
      },
      "&::after": {
        transform: `rotate(45deg) translateY(${Ye(t)})`
      }
    }
  }
}), eW = (e) => _S(e), tW = (e, t) => {
  const {
    componentCls: r,
    itemColor: a,
    itemSelectedColor: i,
    subMenuItemSelectedColor: c,
    groupTitleColor: d,
    itemBg: f,
    subMenuItemBg: p,
    itemSelectedBg: g,
    activeBarHeight: b,
    activeBarWidth: w,
    activeBarBorderWidth: x,
    motionDurationSlow: E,
    motionEaseInOut: P,
    motionEaseOut: k,
    itemPaddingInline: M,
    motionDurationMid: T,
    itemHoverColor: N,
    lineType: D,
    colorSplit: $,
    // Disabled
    itemDisabledColor: j,
    // Danger
    dangerItemColor: I,
    dangerItemHoverColor: L,
    dangerItemSelectedColor: F,
    dangerItemActiveBg: _,
    dangerItemSelectedBg: W,
    // Bg
    popupBg: Q,
    itemHoverBg: U,
    itemActiveBg: Y,
    menuSubMenuBg: G,
    // Horizontal
    horizontalItemSelectedColor: J,
    horizontalItemSelectedBg: H,
    horizontalItemBorderRadius: K,
    horizontalItemHoverBg: X
  } = e;
  return {
    [`${r}-${t}, ${r}-${t} > ${r}`]: {
      color: a,
      background: f,
      [`&${r}-root:focus-visible`]: Object.assign({}, eW(e)),
      // ======================== Item ========================
      [`${r}-item`]: {
        "&-group-title, &-extra": {
          color: d
        }
      },
      [`${r}-submenu-selected > ${r}-submenu-title`]: {
        color: c
      },
      [`${r}-item, ${r}-submenu-title`]: {
        color: a,
        [`&:not(${r}-item-disabled):focus-visible`]: Object.assign({}, eW(e))
      },
      // Disabled
      [`${r}-item-disabled, ${r}-submenu-disabled`]: {
        color: `${j} !important`
      },
      // Hover
      [`${r}-item:not(${r}-item-selected):not(${r}-submenu-selected)`]: {
        [`&:hover, > ${r}-submenu-title:hover`]: {
          color: N
        }
      },
      [`&:not(${r}-horizontal)`]: {
        [`${r}-item:not(${r}-item-selected)`]: {
          "&:hover": {
            backgroundColor: U
          },
          "&:active": {
            backgroundColor: Y
          }
        },
        [`${r}-submenu-title`]: {
          "&:hover": {
            backgroundColor: U
          },
          "&:active": {
            backgroundColor: Y
          }
        }
      },
      // Danger - only Item has
      [`${r}-item-danger`]: {
        color: I,
        [`&${r}-item:hover`]: {
          [`&:not(${r}-item-selected):not(${r}-submenu-selected)`]: {
            color: L
          }
        },
        [`&${r}-item:active`]: {
          background: _
        }
      },
      [`${r}-item a`]: {
        "&, &:hover": {
          color: "inherit"
        }
      },
      [`${r}-item-selected`]: {
        color: i,
        // Danger
        [`&${r}-item-danger`]: {
          color: F
        },
        "a, a:hover": {
          color: "inherit"
        }
      },
      [`& ${r}-item-selected`]: {
        backgroundColor: g,
        // Danger
        [`&${r}-item-danger`]: {
          backgroundColor: W
        }
      },
      [`&${r}-submenu > ${r}`]: {
        backgroundColor: G
      },
      // ===== 设置浮层的颜色 =======
      // ！dark 模式会被popupBg 会被rest 为 darkPopupBg
      [`&${r}-popup > ${r}`]: {
        backgroundColor: Q
      },
      [`&${r}-submenu-popup > ${r}`]: {
        backgroundColor: Q
      },
      // ===== 设置浮层的颜色 end =======
      // ====================== Horizontal ======================
      [`&${r}-horizontal`]: Object.assign(Object.assign({}, t === "dark" ? {
        borderBottom: 0
      } : {}), {
        [`> ${r}-item, > ${r}-submenu`]: {
          top: x,
          marginTop: e.calc(x).mul(-1).equal(),
          marginBottom: 0,
          borderRadius: K,
          "&::after": {
            position: "absolute",
            insetInline: M,
            bottom: 0,
            borderBottom: `${Ye(b)} solid transparent`,
            transition: `border-color ${E} ${P}`,
            content: '""'
          },
          "&:hover, &-active, &-open": {
            background: X,
            "&::after": {
              borderBottomWidth: b,
              borderBottomColor: J
            }
          },
          "&-selected": {
            color: J,
            backgroundColor: H,
            "&:hover": {
              backgroundColor: H
            },
            "&::after": {
              borderBottomWidth: b,
              borderBottomColor: J
            }
          }
        }
      }),
      // ================== Inline & Vertical ===================
      //
      [`&${r}-root`]: {
        [`&${r}-inline, &${r}-vertical`]: {
          borderInlineEnd: `${Ye(x)} ${D} ${$}`
        }
      },
      // ======================== Inline ========================
      [`&${r}-inline`]: {
        // Sub
        [`${r}-sub${r}-inline`]: {
          background: p
        },
        [`${r}-item`]: {
          position: "relative",
          "&::after": {
            position: "absolute",
            insetBlock: 0,
            insetInlineEnd: 0,
            borderInlineEnd: `${Ye(w)} solid ${i}`,
            transform: "scaleY(0.0001)",
            opacity: 0,
            transition: [`transform ${T} ${k}`, `opacity ${T} ${k}`].join(","),
            content: '""'
          },
          // Danger
          [`&${r}-item-danger`]: {
            "&::after": {
              borderInlineEndColor: F
            }
          }
        },
        [`${r}-selected, ${r}-item-selected`]: {
          "&::after": {
            transform: "scaleY(1)",
            opacity: 1,
            transition: [`transform ${T} ${P}`, `opacity ${T} ${P}`].join(",")
          }
        }
      }
    }
  };
}, nW = (e) => {
  const {
    componentCls: t,
    itemHeight: r,
    itemMarginInline: a,
    padding: i,
    menuArrowSize: c,
    marginXS: d,
    itemMarginBlock: f,
    itemWidth: p,
    itemPaddingInline: g
  } = e, b = e.calc(c).add(i).add(d).equal();
  return {
    [`${t}-item`]: {
      position: "relative",
      overflow: "hidden"
    },
    [`${t}-item, ${t}-submenu-title`]: {
      height: r,
      lineHeight: Ye(r),
      paddingInline: g,
      overflow: "hidden",
      textOverflow: "ellipsis",
      marginInline: a,
      marginBlock: f,
      width: p
    },
    [`> ${t}-item,
            > ${t}-submenu > ${t}-submenu-title`]: {
      height: r,
      lineHeight: Ye(r)
    },
    [`${t}-item-group-list ${t}-submenu-title,
            ${t}-submenu-title`]: {
      paddingInlineEnd: b
    }
  };
}, C2e = (e) => {
  const {
    componentCls: t,
    iconCls: r,
    itemHeight: a,
    colorTextLightSolid: i,
    dropdownWidth: c,
    controlHeightLG: d,
    motionEaseOut: f,
    paddingXL: p,
    itemMarginInline: g,
    fontSizeLG: b,
    motionDurationFast: w,
    motionDurationSlow: x,
    paddingXS: E,
    boxShadowSecondary: P,
    collapsedWidth: k,
    collapsedIconSize: M
  } = e, T = {
    height: a,
    lineHeight: Ye(a),
    listStylePosition: "inside",
    listStyleType: "disc"
  };
  return [
    {
      [t]: {
        "&-inline, &-vertical": Object.assign({
          [`&${t}-root`]: {
            boxShadow: "none"
          }
        }, nW(e))
      },
      [`${t}-submenu-popup`]: {
        [`${t}-vertical`]: Object.assign(Object.assign({}, nW(e)), {
          boxShadow: P
        })
      }
    },
    // Vertical only
    {
      [`${t}-submenu-popup ${t}-vertical${t}-sub`]: {
        minWidth: c,
        maxHeight: `calc(100vh - ${Ye(e.calc(d).mul(2.5).equal())})`,
        padding: "0",
        overflow: "hidden",
        borderInlineEnd: 0,
        // https://github.com/ant-design/ant-design/issues/22244
        // https://github.com/ant-design/ant-design/issues/26812
        "&:not([class*='-active'])": {
          overflowX: "hidden",
          overflowY: "auto"
        }
      }
    },
    // Inline Only
    {
      [`${t}-inline`]: {
        width: "100%",
        // Motion enhance for first level
        [`&${t}-root`]: {
          [`${t}-item, ${t}-submenu-title`]: {
            display: "flex",
            alignItems: "center",
            transition: [`border-color ${x}`, `background ${x}`, `padding ${w} ${f}`].join(","),
            [`> ${t}-title-content`]: {
              flex: "auto",
              minWidth: 0,
              overflow: "hidden",
              textOverflow: "ellipsis"
            },
            "> *": {
              flex: "none"
            }
          }
        },
        // >>>>> Sub
        [`${t}-sub${t}-inline`]: {
          padding: 0,
          border: 0,
          borderRadius: 0,
          boxShadow: "none",
          [`& > ${t}-submenu > ${t}-submenu-title`]: T,
          [`& ${t}-item-group-title`]: {
            paddingInlineStart: p
          }
        },
        // >>>>> Item
        [`${t}-item`]: T
      }
    },
    // Inline Collapse Only
    {
      [`${t}-inline-collapsed`]: {
        width: k,
        [`&${t}-root`]: {
          [`${t}-item, ${t}-submenu ${t}-submenu-title`]: {
            [`> ${t}-inline-collapsed-noicon`]: {
              fontSize: b,
              textAlign: "center"
            }
          }
        },
        [`> ${t}-item,
          > ${t}-item-group > ${t}-item-group-list > ${t}-item,
          > ${t}-item-group > ${t}-item-group-list > ${t}-submenu > ${t}-submenu-title,
          > ${t}-submenu > ${t}-submenu-title`]: {
          insetInlineStart: 0,
          paddingInline: `calc(50% - ${Ye(e.calc(M).div(2).equal())} - ${Ye(g)})`,
          textOverflow: "clip",
          [`
            ${t}-submenu-arrow,
            ${t}-submenu-expand-icon
          `]: {
            opacity: 0
          },
          [`${t}-item-icon, ${r}`]: {
            margin: 0,
            fontSize: M,
            lineHeight: Ye(a),
            "+ span": {
              display: "inline-block",
              opacity: 0
            }
          }
        },
        [`${t}-item-icon, ${r}`]: {
          display: "inline-block"
        },
        "&-tooltip": {
          pointerEvents: "none",
          [`${t}-item-icon, ${r}`]: {
            display: "none"
          },
          "a, a:hover": {
            color: i
          }
        },
        [`${t}-item-group-title`]: Object.assign(Object.assign({}, VS), {
          paddingInline: E
        })
      }
    }
  ];
}, rW = (e) => {
  const {
    componentCls: t,
    motionDurationSlow: r,
    motionDurationMid: a,
    motionEaseInOut: i,
    motionEaseOut: c,
    iconCls: d,
    iconSize: f,
    iconMarginInlineEnd: p
  } = e;
  return {
    // >>>>> Item
    [`${t}-item, ${t}-submenu-title`]: {
      position: "relative",
      display: "block",
      margin: 0,
      whiteSpace: "nowrap",
      cursor: "pointer",
      transition: [`border-color ${r}`, `background ${r}`, `padding calc(${r} + 0.1s) ${i}`].join(","),
      [`${t}-item-icon, ${d}`]: {
        minWidth: f,
        fontSize: f,
        transition: [`font-size ${a} ${c}`, `margin ${r} ${i}`, `color ${r}`].join(","),
        "+ span": {
          marginInlineStart: p,
          opacity: 1,
          transition: [`opacity ${r} ${i}`, `margin ${r}`, `color ${r}`].join(",")
        }
      },
      [`${t}-item-icon`]: Object.assign({}, VE()),
      [`&${t}-item-only-child`]: {
        [`> ${d}, > ${t}-item-icon`]: {
          marginInlineEnd: 0
        }
      }
    },
    // Disabled state sets text to gray and nukes hover/tab effects
    [`${t}-item-disabled, ${t}-submenu-disabled`]: {
      background: "none !important",
      cursor: "not-allowed",
      "&::after": {
        borderColor: "transparent !important"
      },
      a: {
        color: "inherit !important",
        cursor: "not-allowed",
        pointerEvents: "none"
      },
      [`> ${t}-submenu-title`]: {
        color: "inherit !important",
        cursor: "not-allowed"
      }
    }
  };
}, aW = (e) => {
  const {
    componentCls: t,
    motionDurationSlow: r,
    motionEaseInOut: a,
    borderRadius: i,
    menuArrowSize: c,
    menuArrowOffset: d
  } = e;
  return {
    [`${t}-submenu`]: {
      "&-expand-icon, &-arrow": {
        position: "absolute",
        top: "50%",
        insetInlineEnd: e.margin,
        width: c,
        color: "currentcolor",
        transform: "translateY(-50%)",
        transition: `transform ${r} ${a}, opacity ${r}`
      },
      "&-arrow": {
        // →
        "&::before, &::after": {
          position: "absolute",
          width: e.calc(c).mul(0.6).equal(),
          height: e.calc(c).mul(0.15).equal(),
          backgroundColor: "currentcolor",
          borderRadius: i,
          transition: [`background ${r} ${a}`, `transform ${r} ${a}`, `top ${r} ${a}`, `color ${r} ${a}`].join(","),
          content: '""'
        },
        "&::before": {
          transform: `rotate(45deg) translateY(${Ye(e.calc(d).mul(-1).equal())})`
        },
        "&::after": {
          transform: `rotate(-45deg) translateY(${Ye(d)})`
        }
      }
    }
  };
}, x2e = (e) => {
  const {
    antCls: t,
    componentCls: r,
    fontSize: a,
    motionDurationSlow: i,
    motionDurationMid: c,
    motionEaseInOut: d,
    paddingXS: f,
    padding: p,
    colorSplit: g,
    lineWidth: b,
    zIndexPopup: w,
    borderRadiusLG: x,
    subMenuItemBorderRadius: E,
    menuArrowSize: P,
    menuArrowOffset: k,
    lineType: M,
    groupTitleLineHeight: T,
    groupTitleFontSize: N
  } = e;
  return [
    // Misc
    {
      "": {
        [r]: Object.assign(Object.assign({}, J4()), {
          // Hidden
          "&-hidden": {
            display: "none"
          }
        })
      },
      [`${r}-submenu-hidden`]: {
        display: "none"
      }
    },
    {
      [r]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, dl(e)), J4()), {
        marginBottom: 0,
        paddingInlineStart: 0,
        // Override default ul/ol
        fontSize: a,
        lineHeight: 0,
        listStyle: "none",
        outline: "none",
        // Magic cubic here but smooth transition
        transition: `width ${i} cubic-bezier(0.2, 0, 0, 1) 0s`,
        "ul, ol": {
          margin: 0,
          padding: 0,
          listStyle: "none"
        },
        // Overflow ellipsis
        "&-overflow": {
          display: "flex",
          [`${r}-item`]: {
            flex: "none"
          }
        },
        [`${r}-item, ${r}-submenu, ${r}-submenu-title`]: {
          borderRadius: e.itemBorderRadius
        },
        [`${r}-item-group-title`]: {
          padding: `${Ye(f)} ${Ye(p)}`,
          fontSize: N,
          lineHeight: T,
          transition: `all ${i}`
        },
        [`&-horizontal ${r}-submenu`]: {
          transition: [`border-color ${i} ${d}`, `background ${i} ${d}`].join(",")
        },
        [`${r}-submenu, ${r}-submenu-inline`]: {
          transition: [`border-color ${i} ${d}`, `background ${i} ${d}`, `padding ${c} ${d}`].join(",")
        },
        [`${r}-submenu ${r}-sub`]: {
          cursor: "initial",
          transition: [`background ${i} ${d}`, `padding ${i} ${d}`].join(",")
        },
        [`${r}-title-content`]: {
          transition: `color ${i}`,
          "&-with-extra": {
            display: "inline-flex",
            alignItems: "center",
            width: "100%"
          },
          // https://github.com/ant-design/ant-design/issues/41143
          [`> ${t}-typography-ellipsis-single-line`]: {
            display: "inline",
            verticalAlign: "unset"
          },
          [`${r}-item-extra`]: {
            marginInlineStart: "auto",
            paddingInlineStart: e.padding
          }
        },
        [`${r}-item a`]: {
          "&::before": {
            position: "absolute",
            inset: 0,
            backgroundColor: "transparent",
            content: '""'
          }
        },
        // Removed a Badge related style seems it's safe
        // https://github.com/ant-design/ant-design/issues/19809
        // >>>>> Divider
        [`${r}-item-divider`]: {
          overflow: "hidden",
          lineHeight: 0,
          borderColor: g,
          borderStyle: M,
          borderWidth: 0,
          borderTopWidth: b,
          marginBlock: b,
          padding: 0,
          "&-dashed": {
            borderStyle: "dashed"
          }
        }
      }), rW(e)), {
        [`${r}-item-group`]: {
          [`${r}-item-group-list`]: {
            margin: 0,
            padding: 0,
            [`${r}-item, ${r}-submenu-title`]: {
              paddingInline: `${Ye(e.calc(a).mul(2).equal())} ${Ye(p)}`
            }
          }
        },
        // ======================= Sub Menu =======================
        "&-submenu": {
          "&-popup": {
            position: "absolute",
            zIndex: w,
            borderRadius: x,
            boxShadow: "none",
            transformOrigin: "0 0",
            [`&${r}-submenu`]: {
              background: "transparent"
            },
            // https://github.com/ant-design/ant-design/issues/13955
            "&::before": {
              position: "absolute",
              inset: 0,
              zIndex: -1,
              width: "100%",
              height: "100%",
              opacity: 0,
              content: '""'
            },
            [`> ${r}`]: Object.assign(Object.assign(Object.assign({
              borderRadius: x
            }, rW(e)), aW(e)), {
              [`${r}-item, ${r}-submenu > ${r}-submenu-title`]: {
                borderRadius: E
              },
              [`${r}-submenu-title::after`]: {
                transition: `transform ${i} ${d}`
              }
            })
          },
          "\n          &-placement-leftTop,\n          &-placement-bottomRight,\n          ": {
            transformOrigin: "100% 0"
          },
          "\n          &-placement-leftBottom,\n          &-placement-topRight,\n          ": {
            transformOrigin: "100% 100%"
          },
          "\n          &-placement-rightBottom,\n          &-placement-topLeft,\n          ": {
            transformOrigin: "0 100%"
          },
          "\n          &-placement-bottomLeft,\n          &-placement-rightTop,\n          ": {
            transformOrigin: "0 0"
          },
          "\n          &-placement-leftTop,\n          &-placement-leftBottom\n          ": {
            paddingInlineEnd: e.paddingXS
          },
          "\n          &-placement-rightTop,\n          &-placement-rightBottom\n          ": {
            paddingInlineStart: e.paddingXS
          },
          "\n          &-placement-topRight,\n          &-placement-topLeft\n          ": {
            paddingBottom: e.paddingXS
          },
          "\n          &-placement-bottomRight,\n          &-placement-bottomLeft\n          ": {
            paddingTop: e.paddingXS
          }
        }
      }), aW(e)), {
        [`&-inline-collapsed ${r}-submenu-arrow,
        &-inline ${r}-submenu-arrow`]: {
          // ↓
          "&::before": {
            transform: `rotate(-45deg) translateX(${Ye(k)})`
          },
          "&::after": {
            transform: `rotate(45deg) translateX(${Ye(e.calc(k).mul(-1).equal())})`
          }
        },
        [`${r}-submenu-open${r}-submenu-inline > ${r}-submenu-title > ${r}-submenu-arrow`]: {
          // ↑
          transform: `translateY(${Ye(e.calc(P).mul(0.2).mul(-1).equal())})`,
          "&::after": {
            transform: `rotate(-45deg) translateX(${Ye(e.calc(k).mul(-1).equal())})`
          },
          "&::before": {
            transform: `rotate(45deg) translateX(${Ye(k)})`
          }
        }
      })
    },
    // Integration with header element so menu items have the same height
    {
      [`${t}-layout-header`]: {
        [r]: {
          lineHeight: "inherit"
        }
      }
    }
  ];
}, E2e = (e) => {
  var t, r, a;
  const {
    colorPrimary: i,
    colorError: c,
    colorTextDisabled: d,
    colorErrorBg: f,
    colorText: p,
    colorTextDescription: g,
    colorBgContainer: b,
    colorFillAlter: w,
    colorFillContent: x,
    lineWidth: E,
    lineWidthBold: P,
    controlItemBgActive: k,
    colorBgTextHover: M,
    controlHeightLG: T,
    lineHeight: N,
    colorBgElevated: D,
    marginXXS: $,
    padding: j,
    fontSize: I,
    controlHeightSM: L,
    fontSizeLG: F,
    colorTextLightSolid: _,
    colorErrorHover: W
  } = e, Q = (t = e.activeBarWidth) !== null && t !== void 0 ? t : 0, U = (r = e.activeBarBorderWidth) !== null && r !== void 0 ? r : E, Y = (a = e.itemMarginInline) !== null && a !== void 0 ? a : e.marginXXS, G = new ro(_).setA(0.65).toRgbString();
  return {
    dropdownWidth: 160,
    zIndexPopup: e.zIndexPopupBase + 50,
    radiusItem: e.borderRadiusLG,
    itemBorderRadius: e.borderRadiusLG,
    radiusSubMenuItem: e.borderRadiusSM,
    subMenuItemBorderRadius: e.borderRadiusSM,
    colorItemText: p,
    itemColor: p,
    colorItemTextHover: p,
    itemHoverColor: p,
    colorItemTextHoverHorizontal: i,
    horizontalItemHoverColor: i,
    colorGroupTitle: g,
    groupTitleColor: g,
    colorItemTextSelected: i,
    itemSelectedColor: i,
    subMenuItemSelectedColor: i,
    colorItemTextSelectedHorizontal: i,
    horizontalItemSelectedColor: i,
    colorItemBg: b,
    itemBg: b,
    colorItemBgHover: M,
    itemHoverBg: M,
    colorItemBgActive: x,
    itemActiveBg: k,
    colorSubItemBg: w,
    subMenuItemBg: w,
    colorItemBgSelected: k,
    itemSelectedBg: k,
    colorItemBgSelectedHorizontal: "transparent",
    horizontalItemSelectedBg: "transparent",
    colorActiveBarWidth: 0,
    activeBarWidth: Q,
    colorActiveBarHeight: P,
    activeBarHeight: P,
    colorActiveBarBorderSize: E,
    activeBarBorderWidth: U,
    // Disabled
    colorItemTextDisabled: d,
    itemDisabledColor: d,
    // Danger
    colorDangerItemText: c,
    dangerItemColor: c,
    colorDangerItemTextHover: c,
    dangerItemHoverColor: c,
    colorDangerItemTextSelected: c,
    dangerItemSelectedColor: c,
    colorDangerItemBgActive: f,
    dangerItemActiveBg: f,
    colorDangerItemBgSelected: f,
    dangerItemSelectedBg: f,
    itemMarginInline: Y,
    horizontalItemBorderRadius: 0,
    horizontalItemHoverBg: "transparent",
    itemHeight: T,
    groupTitleLineHeight: N,
    collapsedWidth: T * 2,
    popupBg: D,
    itemMarginBlock: $,
    itemPaddingInline: j,
    horizontalLineHeight: `${T * 1.15}px`,
    iconSize: I,
    iconMarginInlineEnd: L - I,
    collapsedIconSize: F,
    groupTitleFontSize: I,
    // Disabled
    darkItemDisabledColor: new ro(_).setA(0.25).toRgbString(),
    // Dark
    darkItemColor: G,
    darkDangerItemColor: c,
    darkItemBg: "#001529",
    darkPopupBg: "#001529",
    darkSubMenuItemBg: "#000c17",
    darkItemSelectedColor: _,
    darkItemSelectedBg: i,
    darkDangerItemSelectedBg: c,
    darkItemHoverBg: "transparent",
    darkGroupTitleColor: G,
    darkItemHoverColor: _,
    darkDangerItemHoverColor: W,
    darkDangerItemSelectedColor: _,
    darkDangerItemActiveBg: c,
    // internal
    itemWidth: Q ? `calc(100% + ${U}px)` : `calc(100% - ${Y * 2}px)`
  };
}, P2e = (e, t = e, r = !0) => Ii("Menu", (i) => {
  const {
    colorBgElevated: c,
    controlHeightLG: d,
    fontSize: f,
    darkItemColor: p,
    darkDangerItemColor: g,
    darkItemBg: b,
    darkSubMenuItemBg: w,
    darkItemSelectedColor: x,
    darkItemSelectedBg: E,
    darkDangerItemSelectedBg: P,
    darkItemHoverBg: k,
    darkGroupTitleColor: M,
    darkItemHoverColor: T,
    darkItemDisabledColor: N,
    darkDangerItemHoverColor: D,
    darkDangerItemSelectedColor: $,
    darkDangerItemActiveBg: j,
    popupBg: I,
    darkPopupBg: L
  } = i, F = i.calc(f).div(7).mul(5).equal(), _ = lo(i, {
    menuArrowSize: F,
    menuHorizontalHeight: i.calc(d).mul(1.15).equal(),
    menuArrowOffset: i.calc(F).mul(0.25).equal(),
    menuSubMenuBg: c,
    calc: i.calc,
    popupBg: I
  }), W = lo(_, {
    itemColor: p,
    itemHoverColor: T,
    groupTitleColor: M,
    itemSelectedColor: x,
    subMenuItemSelectedColor: x,
    itemBg: b,
    popupBg: L,
    subMenuItemBg: w,
    itemActiveBg: "transparent",
    itemSelectedBg: E,
    activeBarHeight: 0,
    activeBarBorderWidth: 0,
    itemHoverBg: k,
    // Disabled
    itemDisabledColor: N,
    // Danger
    dangerItemColor: g,
    dangerItemHoverColor: D,
    dangerItemSelectedColor: $,
    dangerItemActiveBg: j,
    dangerItemSelectedBg: P,
    menuSubMenuBg: w,
    // Horizontal
    horizontalItemSelectedColor: x,
    horizontalItemSelectedBg: E
  });
  return [
    // Basic
    x2e(_),
    // Horizontal
    w2e(_),
    // Hard code for some light style
    // Vertical
    C2e(_),
    // Hard code for some light style
    // Theme
    tW(_, "light"),
    tW(W, "dark"),
    // RTL
    S2e(_),
    // Motion
    Vz(_),
    BS(_, "slide-up"),
    BS(_, "slide-down"),
    UE(_, "zoom-big")
  ];
}, E2e, {
  deprecatedTokens: [["colorGroupTitle", "groupTitleColor"], ["radiusItem", "itemBorderRadius"], ["radiusSubMenuItem", "subMenuItemBorderRadius"], ["colorItemText", "itemColor"], ["colorItemTextHover", "itemHoverColor"], ["colorItemTextHoverHorizontal", "horizontalItemHoverColor"], ["colorItemTextSelected", "itemSelectedColor"], ["colorItemTextSelectedHorizontal", "horizontalItemSelectedColor"], ["colorItemTextDisabled", "itemDisabledColor"], ["colorDangerItemText", "dangerItemColor"], ["colorDangerItemTextHover", "dangerItemHoverColor"], ["colorDangerItemTextSelected", "dangerItemSelectedColor"], ["colorDangerItemBgActive", "dangerItemActiveBg"], ["colorDangerItemBgSelected", "dangerItemSelectedBg"], ["colorItemBg", "itemBg"], ["colorItemBgHover", "itemHoverBg"], ["colorSubItemBg", "subMenuItemBg"], ["colorItemBgActive", "itemActiveBg"], ["colorItemBgSelectedHorizontal", "horizontalItemSelectedBg"], ["colorActiveBarWidth", "activeBarWidth"], ["colorActiveBarHeight", "activeBarHeight"], ["colorActiveBarBorderSize", "activeBarBorderWidth"], ["colorItemBgSelected", "itemSelectedBg"]],
  // Dropdown will handle menu style self. We do not need to handle this.
  injectStyle: r,
  unitless: {
    groupTitleLineHeight: !0
  }
})(e, t), JY = (e) => {
  var t;
  const {
    popupClassName: r,
    icon: a,
    title: i,
    theme: c
  } = e, d = S.useContext(Kk), {
    prefixCls: f,
    inlineCollapsed: p,
    theme: g
  } = d, b = qx();
  let w;
  if (!a)
    w = p && !b.length && i && typeof i == "string" ? /* @__PURE__ */ S.createElement("div", {
      className: `${f}-inline-collapsed-noicon`
    }, i.charAt(0)) : /* @__PURE__ */ S.createElement("span", {
      className: `${f}-title-content`
    }, i);
  else {
    const P = /* @__PURE__ */ S.isValidElement(i) && i.type === "span";
    w = /* @__PURE__ */ S.createElement(S.Fragment, null, up(a, {
      className: _e(/* @__PURE__ */ S.isValidElement(a) ? (t = a.props) === null || t === void 0 ? void 0 : t.className : void 0, `${f}-item-icon`)
    }), P ? i : /* @__PURE__ */ S.createElement("span", {
      className: `${f}-title-content`
    }, i));
  }
  const x = S.useMemo(() => Object.assign(Object.assign({}, d), {
    firstLevel: !1
  }), [d]), [E] = vS("Menu");
  return /* @__PURE__ */ S.createElement(Kk.Provider, {
    value: x
  }, /* @__PURE__ */ S.createElement(n7, Object.assign({}, Rs(e, ["icon"]), {
    title: w,
    popupClassName: _e(f, r, `${f}-${c || g}`),
    popupStyle: Object.assign({
      zIndex: E
    }, e.popupStyle)
  })));
};
var k2e = function(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
    t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
};
function uR(e) {
  return e === null || e === !1;
}
const M2e = {
  item: YY,
  submenu: JY,
  divider: KY
}, O2e = /* @__PURE__ */ ks((e, t) => {
  var r;
  const a = S.useContext(Yk), i = a || {}, {
    getPrefixCls: c,
    getPopupContainer: d,
    direction: f,
    menu: p
  } = S.useContext(Qr), g = c(), {
    prefixCls: b,
    className: w,
    style: x,
    theme: E = "light",
    expandIcon: P,
    _internalDisableMenuItemTitleTooltip: k,
    inlineCollapsed: M,
    siderCollapsed: T,
    rootClassName: N,
    mode: D,
    selectable: $,
    onClick: j,
    overflowedIndicatorPopupClassName: I
  } = e, L = k2e(e, ["prefixCls", "className", "style", "theme", "expandIcon", "_internalDisableMenuItemTitleTooltip", "inlineCollapsed", "siderCollapsed", "rootClassName", "mode", "selectable", "onClick", "overflowedIndicatorPopupClassName"]), F = Rs(L, ["collapsedWidth"]);
  if (process.env.NODE_ENV !== "production") {
    const ne = To("Menu");
    process.env.NODE_ENV !== "production" && ne(!("inlineCollapsed" in e && D !== "inline"), "usage", "`inlineCollapsed` should only be used when `mode` is inline."), ne.deprecated("items" in e && !e.children, "children", "items");
  }
  (r = i.validator) === null || r === void 0 || r.call(i, {
    mode: D
  });
  const _ = ra((...ne) => {
    var ae;
    j?.apply(void 0, ne), (ae = i.onClick) === null || ae === void 0 || ae.call(i);
  }), W = i.mode || D, Q = $ ?? i.selectable, U = M ?? T, Y = {
    horizontal: {
      motionName: `${g}-slide-up`
    },
    inline: Wz(g),
    other: {
      motionName: `${g}-zoom-big`
    }
  }, G = c("menu", b || i.prefixCls), J = Qh(G), [H, K, X] = P2e(G, J, !a), te = _e(`${G}-${E}`, p?.className, w), ie = S.useMemo(() => {
    var ne, ae;
    if (typeof P == "function" || uR(P))
      return P || null;
    if (typeof i.expandIcon == "function" || uR(i.expandIcon))
      return i.expandIcon || null;
    if (typeof p?.expandIcon == "function" || uR(p?.expandIcon))
      return p?.expandIcon || null;
    const oe = (ne = P ?? i?.expandIcon) !== null && ne !== void 0 ? ne : p?.expandIcon;
    return up(oe, {
      className: _e(`${G}-submenu-expand-icon`, /* @__PURE__ */ S.isValidElement(oe) ? (ae = oe.props) === null || ae === void 0 ? void 0 : ae.className : void 0)
    });
  }, [P, i?.expandIcon, p?.expandIcon, G]), ee = S.useMemo(() => ({
    prefixCls: G,
    inlineCollapsed: U || !1,
    direction: f,
    firstLevel: !0,
    theme: E,
    mode: W,
    disableMenuItemTitleTooltip: k
  }), [G, U, f, k, E]);
  return H(/* @__PURE__ */ S.createElement(Yk.Provider, {
    value: null
  }, /* @__PURE__ */ S.createElement(Kk.Provider, {
    value: ee
  }, /* @__PURE__ */ S.createElement(r7, Object.assign({
    getPopupContainer: d,
    overflowedIndicator: /* @__PURE__ */ S.createElement(vj, null),
    overflowedIndicatorPopupClassName: _e(G, `${G}-${E}`, I),
    mode: W,
    selectable: Q,
    onClick: _
  }, F, {
    inlineCollapsed: U,
    style: Object.assign(Object.assign({}, p?.style), x),
    className: te,
    prefixCls: G,
    direction: f,
    defaultMotions: Y,
    expandIcon: ie,
    ref: t,
    rootClassName: _e(N, K, i.rootClassName, X, J),
    _internalComponents: M2e
  })))));
}), aC = /* @__PURE__ */ ks((e, t) => {
  const r = It(null), a = S.useContext(gj);
  return pS(t, () => ({
    menu: r.current,
    focus: (i) => {
      var c;
      (c = r.current) === null || c === void 0 || c.focus(i);
    }
  })), /* @__PURE__ */ S.createElement(O2e, Object.assign({
    ref: r
  }, e, a));
});
aC.Item = YY;
aC.SubMenu = JY;
aC.Divider = KY;
aC.ItemGroup = iM;
process.env.NODE_ENV !== "production" && (aC.displayName = "Menu");
const T2e = (e) => {
  const {
    componentCls: t,
    menuCls: r,
    colorError: a,
    colorTextLightSolid: i
  } = e, c = `${r}-item`;
  return {
    [`${t}, ${t}-menu-submenu`]: {
      [`${r} ${c}`]: {
        [`&${c}-danger:not(${c}-disabled)`]: {
          color: a,
          "&:hover": {
            color: i,
            backgroundColor: a
          }
        }
      }
    }
  };
}, R2e = (e) => {
  const {
    componentCls: t,
    menuCls: r,
    zIndexPopup: a,
    dropdownArrowDistance: i,
    sizePopupArrow: c,
    antCls: d,
    iconCls: f,
    motionDurationMid: p,
    paddingBlock: g,
    fontSize: b,
    dropdownEdgeChildPadding: w,
    colorTextDisabled: x,
    fontSizeIcon: E,
    controlPaddingHorizontal: P,
    colorBgElevated: k
  } = e;
  return [
    {
      [t]: {
        position: "absolute",
        top: -9999,
        left: {
          _skip_check_: !0,
          value: -9999
        },
        zIndex: a,
        display: "block",
        // A placeholder out of dropdown visible range to avoid close when user moving
        "&::before": {
          position: "absolute",
          insetBlock: e.calc(c).div(2).sub(i).equal(),
          // insetInlineStart: -7, // FIXME: Seems not work for hidden element
          zIndex: -9999,
          opacity: 1e-4,
          content: '""'
        },
        // Makes vertical dropdowns have a scrollbar once they become taller than the viewport.
        "&-menu-vertical": {
          maxHeight: "100vh",
          overflowY: "auto"
        },
        [`&-trigger${d}-btn`]: {
          [`& > ${f}-down, & > ${d}-btn-icon > ${f}-down`]: {
            fontSize: E
          }
        },
        [`${t}-wrap`]: {
          position: "relative",
          [`${d}-btn > ${f}-down`]: {
            fontSize: E
          },
          [`${f}-down::before`]: {
            transition: `transform ${p}`
          }
        },
        [`${t}-wrap-open`]: {
          [`${f}-down::before`]: {
            transform: "rotate(180deg)"
          }
        },
        "\n        &-hidden,\n        &-menu-hidden,\n        &-menu-submenu-hidden\n      ": {
          display: "none"
        },
        // =============================================================
        // ==                         Motion                          ==
        // =============================================================
        // When position is not enough for dropdown, the placement will revert.
        // We will handle this with revert motion name.
        [`&${d}-slide-down-enter${d}-slide-down-enter-active${t}-placement-bottomLeft,
          &${d}-slide-down-appear${d}-slide-down-appear-active${t}-placement-bottomLeft,
          &${d}-slide-down-enter${d}-slide-down-enter-active${t}-placement-bottom,
          &${d}-slide-down-appear${d}-slide-down-appear-active${t}-placement-bottom,
          &${d}-slide-down-enter${d}-slide-down-enter-active${t}-placement-bottomRight,
          &${d}-slide-down-appear${d}-slide-down-appear-active${t}-placement-bottomRight`]: {
          animationName: W9
        },
        [`&${d}-slide-up-enter${d}-slide-up-enter-active${t}-placement-topLeft,
          &${d}-slide-up-appear${d}-slide-up-appear-active${t}-placement-topLeft,
          &${d}-slide-up-enter${d}-slide-up-enter-active${t}-placement-top,
          &${d}-slide-up-appear${d}-slide-up-appear-active${t}-placement-top,
          &${d}-slide-up-enter${d}-slide-up-enter-active${t}-placement-topRight,
          &${d}-slide-up-appear${d}-slide-up-appear-active${t}-placement-topRight`]: {
          animationName: _9
        },
        [`&${d}-slide-down-leave${d}-slide-down-leave-active${t}-placement-bottomLeft,
          &${d}-slide-down-leave${d}-slide-down-leave-active${t}-placement-bottom,
          &${d}-slide-down-leave${d}-slide-down-leave-active${t}-placement-bottomRight`]: {
          animationName: V9
        },
        [`&${d}-slide-up-leave${d}-slide-up-leave-active${t}-placement-topLeft,
          &${d}-slide-up-leave${d}-slide-up-leave-active${t}-placement-top,
          &${d}-slide-up-leave${d}-slide-up-leave-active${t}-placement-topRight`]: {
          animationName: B9
        }
      }
    },
    // =============================================================
    // ==                        Arrow style                      ==
    // =============================================================
    sj(e, k, {
      arrowPlacement: {
        top: !0,
        bottom: !0
      }
    }),
    {
      // =============================================================
      // ==                          Menu                           ==
      // =============================================================
      [`${t} ${r}`]: {
        position: "relative",
        margin: 0
      },
      [`${r}-submenu-popup`]: {
        position: "absolute",
        zIndex: a,
        background: "transparent",
        boxShadow: "none",
        transformOrigin: "0 0",
        "ul, li": {
          listStyle: "none",
          margin: 0
        }
      },
      [`${t}, ${t}-menu-submenu`]: Object.assign(Object.assign({}, dl(e)), {
        [r]: Object.assign(Object.assign({
          padding: w,
          listStyleType: "none",
          backgroundColor: k,
          backgroundClip: "padding-box",
          borderRadius: e.borderRadiusLG,
          outline: "none",
          boxShadow: e.boxShadowSecondary
        }, Z4(e)), {
          "&:empty": {
            padding: 0,
            boxShadow: "none"
          },
          [`${r}-item-group-title`]: {
            padding: `${Ye(g)} ${Ye(P)}`,
            color: e.colorTextDescription,
            transition: `all ${p}`
          },
          // ======================= Item Content =======================
          [`${r}-item`]: {
            position: "relative",
            display: "flex",
            alignItems: "center"
          },
          [`${r}-item-icon`]: {
            minWidth: b,
            marginInlineEnd: e.marginXS,
            fontSize: e.fontSizeSM
          },
          [`${r}-title-content`]: {
            flex: "auto",
            "&-with-extra": {
              display: "inline-flex",
              alignItems: "center",
              width: "100%"
            },
            "> a": {
              color: "inherit",
              transition: `all ${p}`,
              "&:hover": {
                color: "inherit"
              },
              "&::after": {
                position: "absolute",
                inset: 0,
                content: '""'
              }
            },
            [`${r}-item-extra`]: {
              paddingInlineStart: e.padding,
              marginInlineStart: "auto",
              fontSize: e.fontSizeSM,
              color: e.colorTextDescription
            }
          },
          // =========================== Item ===========================
          [`${r}-item, ${r}-submenu-title`]: Object.assign(Object.assign({
            display: "flex",
            margin: 0,
            padding: `${Ye(g)} ${Ye(P)}`,
            color: e.colorText,
            fontWeight: "normal",
            fontSize: b,
            lineHeight: e.lineHeight,
            cursor: "pointer",
            transition: `all ${p}`,
            borderRadius: e.borderRadiusSM,
            "&:hover, &-active": {
              backgroundColor: e.controlItemBgHover
            }
          }, Z4(e)), {
            "&-selected": {
              color: e.colorPrimary,
              backgroundColor: e.controlItemBgActive,
              "&:hover, &-active": {
                backgroundColor: e.controlItemBgActiveHover
              }
            },
            "&-disabled": {
              color: x,
              cursor: "not-allowed",
              "&:hover": {
                color: x,
                backgroundColor: k,
                cursor: "not-allowed"
              },
              a: {
                pointerEvents: "none"
              }
            },
            "&-divider": {
              height: 1,
              // By design
              margin: `${Ye(e.marginXXS)} 0`,
              overflow: "hidden",
              lineHeight: 0,
              backgroundColor: e.colorSplit
            },
            [`${t}-menu-submenu-expand-icon`]: {
              position: "absolute",
              insetInlineEnd: e.paddingXS,
              [`${t}-menu-submenu-arrow-icon`]: {
                marginInlineEnd: "0 !important",
                color: e.colorIcon,
                fontSize: E,
                fontStyle: "normal"
              }
            }
          }),
          [`${r}-item-group-list`]: {
            margin: `0 ${Ye(e.marginXS)}`,
            padding: 0,
            listStyle: "none"
          },
          [`${r}-submenu-title`]: {
            paddingInlineEnd: e.calc(P).add(e.fontSizeSM).equal()
          },
          [`${r}-submenu-vertical`]: {
            position: "relative"
          },
          [`${r}-submenu${r}-submenu-disabled ${t}-menu-submenu-title`]: {
            [`&, ${t}-menu-submenu-arrow-icon`]: {
              color: x,
              backgroundColor: k,
              cursor: "not-allowed"
            }
          },
          // https://github.com/ant-design/ant-design/issues/19264
          [`${r}-submenu-selected ${t}-menu-submenu-title`]: {
            color: e.colorPrimary
          }
        })
      })
    },
    // Follow code may reuse in other components
    [BS(e, "slide-up"), BS(e, "slide-down"), Px(e, "move-up"), Px(e, "move-down"), UE(e, "zoom-big")]
  ];
}, A2e = (e) => Object.assign(Object.assign({
  zIndexPopup: e.zIndexPopupBase + 50,
  paddingBlock: (e.controlHeight - e.fontSize * e.lineHeight) / 2
}, rM({
  contentRadius: e.borderRadiusLG,
  limitVerticalRadius: !0
})), nM(e)), N2e = Ii("Dropdown", (e) => {
  const {
    marginXXS: t,
    sizePopupArrow: r,
    paddingXXS: a,
    componentCls: i
  } = e, c = lo(e, {
    menuCls: `${i}-menu`,
    dropdownArrowDistance: e.calc(r).div(2).add(t).equal(),
    dropdownEdgeChildPadding: a
  });
  return [R2e(c), T2e(c)];
}, A2e, {
  resetStyle: !1
}), a7 = (e) => {
  var t;
  const {
    menu: r,
    arrow: a,
    prefixCls: i,
    children: c,
    trigger: d,
    disabled: f,
    dropdownRender: p,
    popupRender: g,
    getPopupContainer: b,
    overlayClassName: w,
    rootClassName: x,
    overlayStyle: E,
    open: P,
    onOpenChange: k,
    // Deprecated
    visible: M,
    onVisibleChange: T,
    mouseEnterDelay: N = 0.15,
    mouseLeaveDelay: D = 0.1,
    autoAdjustOverflow: $ = !0,
    placement: j = "",
    overlay: I,
    transitionName: L,
    destroyOnHidden: F,
    destroyPopupOnHide: _
  } = e, {
    getPopupContainer: W,
    getPrefixCls: Q,
    direction: U,
    dropdown: Y
  } = S.useContext(Qr), G = g || p, J = To("Dropdown");
  process.env.NODE_ENV !== "production" && (Object.entries({
    visible: "open",
    onVisibleChange: "onOpenChange",
    overlay: "menu",
    dropdownRender: "popupRender",
    destroyPopupOnHide: "destroyOnHidden"
  }).forEach(([Te, Oe]) => {
    J.deprecated(!(Te in e), Te, Oe);
  }), j.includes("Center") && J.deprecated(!j.includes("Center"), `placement: ${j}`, `placement: ${j.slice(0, j.indexOf("Center"))}`));
  const H = S.useMemo(() => {
    const Le = Q();
    return L !== void 0 ? L : j.includes("top") ? `${Le}-slide-down` : `${Le}-slide-up`;
  }, [Q, j, L]), K = S.useMemo(() => j ? j.includes("Center") ? j.slice(0, j.indexOf("Center")) : j : U === "rtl" ? "bottomRight" : "bottomLeft", [j, U]), X = Q("dropdown", i), te = Qh(X), [ie, ee, ne] = N2e(X, te), [, ae] = Bf(), oe = S.Children.only(Eve(c) ? /* @__PURE__ */ S.createElement("span", null, c) : c), fe = up(oe, {
    className: _e(`${X}-trigger`, {
      [`${X}-rtl`]: U === "rtl"
    }, oe.props.className),
    disabled: (t = oe.props.disabled) !== null && t !== void 0 ? t : f
  }), be = f ? [] : d, me = !!be?.includes("contextMenu"), [De, Me] = ll(!1, {
    value: P ?? M
  }), ze = ra((Le) => {
    k?.(Le, {
      source: "trigger"
    }), T?.(Le), Me(Le);
  }), le = _e(w, x, ee, ne, te, Y?.className, {
    [`${X}-rtl`]: U === "rtl"
  }), se = TY({
    arrowPointAtCenter: typeof a == "object" && a.pointAtCenter,
    autoAdjustOverflow: $,
    offset: ae.marginXXS,
    arrowWidth: a ? ae.sizePopupArrow : 0,
    borderRadius: ae.borderRadius
  }), Ae = ra(() => {
    r?.selectable && r?.multiple || (k?.(!1, {
      source: "menu"
    }), Me(!1));
  }), we = () => {
    let Le;
    return r?.items ? Le = /* @__PURE__ */ S.createElement(aC, Object.assign({}, r)) : typeof I == "function" ? Le = I() : Le = I, G && (Le = G(Le)), Le = S.Children.only(typeof Le == "string" ? /* @__PURE__ */ S.createElement("span", null, Le) : Le), /* @__PURE__ */ S.createElement(QY, {
      prefixCls: `${X}-menu`,
      rootClassName: _e(ne, te),
      expandIcon: /* @__PURE__ */ S.createElement("span", {
        className: `${X}-menu-submenu-arrow`
      }, U === "rtl" ? /* @__PURE__ */ S.createElement(Mx, {
        className: `${X}-menu-submenu-arrow-icon`
      }) : /* @__PURE__ */ S.createElement(Ex, {
        className: `${X}-menu-submenu-arrow-icon`
      })),
      mode: "vertical",
      selectable: !1,
      onClick: Ae,
      validator: ({
        mode: Te
      }) => {
        process.env.NODE_ENV !== "production" && J(!Te || Te === "vertical", "usage", `mode="${Te}" is not supported for Dropdown's Menu.`);
      }
    }, Le);
  }, [Ne, pe] = vS("Dropdown", E?.zIndex);
  let Qe = /* @__PURE__ */ S.createElement(xve, Object.assign({
    alignPoint: me
  }, Rs(e, ["rootClassName"]), {
    mouseEnterDelay: N,
    mouseLeaveDelay: D,
    visible: De,
    builtinPlacements: se,
    arrow: !!a,
    overlayClassName: le,
    prefixCls: X,
    getPopupContainer: b || W,
    transitionName: H,
    trigger: be,
    overlay: we,
    placement: K,
    onVisibleChange: ze,
    overlayStyle: Object.assign(Object.assign(Object.assign({}, Y?.style), E), {
      zIndex: Ne
    }),
    autoDestroy: F ?? _
  }), fe);
  return Ne && (Qe = /* @__PURE__ */ S.createElement(Ux.Provider, {
    value: pe
  }, Qe)), ie(Qe);
}, D2e = Gx(a7, "align", void 0, "dropdown", (e) => e), $2e = (e) => /* @__PURE__ */ S.createElement(D2e, Object.assign({}, e), /* @__PURE__ */ S.createElement("span", null));
a7._InternalPanelDoNotUseOrYouWillBeFired = $2e;
process.env.NODE_ENV !== "production" && (a7.displayName = "Dropdown");
var ok = { exports: {} }, z2e = ok.exports, oW;
function j2e() {
  return oW || (oW = 1, (function(e, t) {
    (function(r, a) {
      e.exports = a();
    })(z2e, (function() {
      var r = 1e3, a = 6e4, i = 36e5, c = "millisecond", d = "second", f = "minute", p = "hour", g = "day", b = "week", w = "month", x = "quarter", E = "year", P = "date", k = "Invalid Date", M = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, T = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, N = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(G) {
        var J = ["th", "st", "nd", "rd"], H = G % 100;
        return "[" + G + (J[(H - 20) % 10] || J[H] || J[0]) + "]";
      } }, D = function(G, J, H) {
        var K = String(G);
        return !K || K.length >= J ? G : "" + Array(J + 1 - K.length).join(H) + G;
      }, $ = { s: D, z: function(G) {
        var J = -G.utcOffset(), H = Math.abs(J), K = Math.floor(H / 60), X = H % 60;
        return (J <= 0 ? "+" : "-") + D(K, 2, "0") + ":" + D(X, 2, "0");
      }, m: function G(J, H) {
        if (J.date() < H.date()) return -G(H, J);
        var K = 12 * (H.year() - J.year()) + (H.month() - J.month()), X = J.clone().add(K, w), te = H - X < 0, ie = J.clone().add(K + (te ? -1 : 1), w);
        return +(-(K + (H - X) / (te ? X - ie : ie - X)) || 0);
      }, a: function(G) {
        return G < 0 ? Math.ceil(G) || 0 : Math.floor(G);
      }, p: function(G) {
        return { M: w, y: E, w: b, d: g, D: P, h: p, m: f, s: d, ms: c, Q: x }[G] || String(G || "").toLowerCase().replace(/s$/, "");
      }, u: function(G) {
        return G === void 0;
      } }, j = "en", I = {};
      I[j] = N;
      var L = "$isDayjsObject", F = function(G) {
        return G instanceof U || !(!G || !G[L]);
      }, _ = function G(J, H, K) {
        var X;
        if (!J) return j;
        if (typeof J == "string") {
          var te = J.toLowerCase();
          I[te] && (X = te), H && (I[te] = H, X = te);
          var ie = J.split("-");
          if (!X && ie.length > 1) return G(ie[0]);
        } else {
          var ee = J.name;
          I[ee] = J, X = ee;
        }
        return !K && X && (j = X), X || !K && j;
      }, W = function(G, J) {
        if (F(G)) return G.clone();
        var H = typeof J == "object" ? J : {};
        return H.date = G, H.args = arguments, new U(H);
      }, Q = $;
      Q.l = _, Q.i = F, Q.w = function(G, J) {
        return W(G, { locale: J.$L, utc: J.$u, x: J.$x, $offset: J.$offset });
      };
      var U = (function() {
        function G(H) {
          this.$L = _(H.locale, null, !0), this.parse(H), this.$x = this.$x || H.x || {}, this[L] = !0;
        }
        var J = G.prototype;
        return J.parse = function(H) {
          this.$d = (function(K) {
            var X = K.date, te = K.utc;
            if (X === null) return /* @__PURE__ */ new Date(NaN);
            if (Q.u(X)) return /* @__PURE__ */ new Date();
            if (X instanceof Date) return new Date(X);
            if (typeof X == "string" && !/Z$/i.test(X)) {
              var ie = X.match(M);
              if (ie) {
                var ee = ie[2] - 1 || 0, ne = (ie[7] || "0").substring(0, 3);
                return te ? new Date(Date.UTC(ie[1], ee, ie[3] || 1, ie[4] || 0, ie[5] || 0, ie[6] || 0, ne)) : new Date(ie[1], ee, ie[3] || 1, ie[4] || 0, ie[5] || 0, ie[6] || 0, ne);
              }
            }
            return new Date(X);
          })(H), this.init();
        }, J.init = function() {
          var H = this.$d;
          this.$y = H.getFullYear(), this.$M = H.getMonth(), this.$D = H.getDate(), this.$W = H.getDay(), this.$H = H.getHours(), this.$m = H.getMinutes(), this.$s = H.getSeconds(), this.$ms = H.getMilliseconds();
        }, J.$utils = function() {
          return Q;
        }, J.isValid = function() {
          return this.$d.toString() !== k;
        }, J.isSame = function(H, K) {
          var X = W(H);
          return this.startOf(K) <= X && X <= this.endOf(K);
        }, J.isAfter = function(H, K) {
          return W(H) < this.startOf(K);
        }, J.isBefore = function(H, K) {
          return this.endOf(K) < W(H);
        }, J.$g = function(H, K, X) {
          return Q.u(H) ? this[K] : this.set(X, H);
        }, J.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, J.valueOf = function() {
          return this.$d.getTime();
        }, J.startOf = function(H, K) {
          var X = this, te = !!Q.u(K) || K, ie = Q.p(H), ee = function(Me, ze) {
            var le = Q.w(X.$u ? Date.UTC(X.$y, ze, Me) : new Date(X.$y, ze, Me), X);
            return te ? le : le.endOf(g);
          }, ne = function(Me, ze) {
            return Q.w(X.toDate()[Me].apply(X.toDate("s"), (te ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(ze)), X);
          }, ae = this.$W, oe = this.$M, fe = this.$D, be = "set" + (this.$u ? "UTC" : "");
          switch (ie) {
            case E:
              return te ? ee(1, 0) : ee(31, 11);
            case w:
              return te ? ee(1, oe) : ee(0, oe + 1);
            case b:
              var me = this.$locale().weekStart || 0, De = (ae < me ? ae + 7 : ae) - me;
              return ee(te ? fe - De : fe + (6 - De), oe);
            case g:
            case P:
              return ne(be + "Hours", 0);
            case p:
              return ne(be + "Minutes", 1);
            case f:
              return ne(be + "Seconds", 2);
            case d:
              return ne(be + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, J.endOf = function(H) {
          return this.startOf(H, !1);
        }, J.$set = function(H, K) {
          var X, te = Q.p(H), ie = "set" + (this.$u ? "UTC" : ""), ee = (X = {}, X[g] = ie + "Date", X[P] = ie + "Date", X[w] = ie + "Month", X[E] = ie + "FullYear", X[p] = ie + "Hours", X[f] = ie + "Minutes", X[d] = ie + "Seconds", X[c] = ie + "Milliseconds", X)[te], ne = te === g ? this.$D + (K - this.$W) : K;
          if (te === w || te === E) {
            var ae = this.clone().set(P, 1);
            ae.$d[ee](ne), ae.init(), this.$d = ae.set(P, Math.min(this.$D, ae.daysInMonth())).$d;
          } else ee && this.$d[ee](ne);
          return this.init(), this;
        }, J.set = function(H, K) {
          return this.clone().$set(H, K);
        }, J.get = function(H) {
          return this[Q.p(H)]();
        }, J.add = function(H, K) {
          var X, te = this;
          H = Number(H);
          var ie = Q.p(K), ee = function(oe) {
            var fe = W(te);
            return Q.w(fe.date(fe.date() + Math.round(oe * H)), te);
          };
          if (ie === w) return this.set(w, this.$M + H);
          if (ie === E) return this.set(E, this.$y + H);
          if (ie === g) return ee(1);
          if (ie === b) return ee(7);
          var ne = (X = {}, X[f] = a, X[p] = i, X[d] = r, X)[ie] || 1, ae = this.$d.getTime() + H * ne;
          return Q.w(ae, this);
        }, J.subtract = function(H, K) {
          return this.add(-1 * H, K);
        }, J.format = function(H) {
          var K = this, X = this.$locale();
          if (!this.isValid()) return X.invalidDate || k;
          var te = H || "YYYY-MM-DDTHH:mm:ssZ", ie = Q.z(this), ee = this.$H, ne = this.$m, ae = this.$M, oe = X.weekdays, fe = X.months, be = X.meridiem, me = function(ze, le, se, Ae) {
            return ze && (ze[le] || ze(K, te)) || se[le].slice(0, Ae);
          }, De = function(ze) {
            return Q.s(ee % 12 || 12, ze, "0");
          }, Me = be || function(ze, le, se) {
            var Ae = ze < 12 ? "AM" : "PM";
            return se ? Ae.toLowerCase() : Ae;
          };
          return te.replace(T, (function(ze, le) {
            return le || (function(se) {
              switch (se) {
                case "YY":
                  return String(K.$y).slice(-2);
                case "YYYY":
                  return Q.s(K.$y, 4, "0");
                case "M":
                  return ae + 1;
                case "MM":
                  return Q.s(ae + 1, 2, "0");
                case "MMM":
                  return me(X.monthsShort, ae, fe, 3);
                case "MMMM":
                  return me(fe, ae);
                case "D":
                  return K.$D;
                case "DD":
                  return Q.s(K.$D, 2, "0");
                case "d":
                  return String(K.$W);
                case "dd":
                  return me(X.weekdaysMin, K.$W, oe, 2);
                case "ddd":
                  return me(X.weekdaysShort, K.$W, oe, 3);
                case "dddd":
                  return oe[K.$W];
                case "H":
                  return String(ee);
                case "HH":
                  return Q.s(ee, 2, "0");
                case "h":
                  return De(1);
                case "hh":
                  return De(2);
                case "a":
                  return Me(ee, ne, !0);
                case "A":
                  return Me(ee, ne, !1);
                case "m":
                  return String(ne);
                case "mm":
                  return Q.s(ne, 2, "0");
                case "s":
                  return String(K.$s);
                case "ss":
                  return Q.s(K.$s, 2, "0");
                case "SSS":
                  return Q.s(K.$ms, 3, "0");
                case "Z":
                  return ie;
              }
              return null;
            })(ze) || ie.replace(":", "");
          }));
        }, J.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, J.diff = function(H, K, X) {
          var te, ie = this, ee = Q.p(K), ne = W(H), ae = (ne.utcOffset() - this.utcOffset()) * a, oe = this - ne, fe = function() {
            return Q.m(ie, ne);
          };
          switch (ee) {
            case E:
              te = fe() / 12;
              break;
            case w:
              te = fe();
              break;
            case x:
              te = fe() / 3;
              break;
            case b:
              te = (oe - ae) / 6048e5;
              break;
            case g:
              te = (oe - ae) / 864e5;
              break;
            case p:
              te = oe / i;
              break;
            case f:
              te = oe / a;
              break;
            case d:
              te = oe / r;
              break;
            default:
              te = oe;
          }
          return X ? te : Q.a(te);
        }, J.daysInMonth = function() {
          return this.endOf(w).$D;
        }, J.$locale = function() {
          return I[this.$L];
        }, J.locale = function(H, K) {
          if (!H) return this.$L;
          var X = this.clone(), te = _(H, K, !0);
          return te && (X.$L = te), X;
        }, J.clone = function() {
          return Q.w(this.$d, this);
        }, J.toDate = function() {
          return new Date(this.valueOf());
        }, J.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, J.toISOString = function() {
          return this.$d.toISOString();
        }, J.toString = function() {
          return this.$d.toUTCString();
        }, G;
      })(), Y = U.prototype;
      return W.prototype = Y, [["$ms", c], ["$s", d], ["$m", f], ["$H", p], ["$W", g], ["$M", w], ["$y", E], ["$D", P]].forEach((function(G) {
        Y[G[1]] = function(J) {
          return this.$g(J, G[0], G[1]);
        };
      })), W.extend = function(G, J) {
        return G.$i || (G(J, U, W), G.$i = !0), W;
      }, W.locale = _, W.isDayjs = F, W.unix = function(G) {
        return W(1e3 * G);
      }, W.en = I[j], W.Ls = I, W.p = {}, W;
    }));
  })(ok)), ok.exports;
}
var I2e = j2e();
const Vf = /* @__PURE__ */ Sb(I2e);
var ik = { exports: {} }, L2e = ik.exports, iW;
function H2e() {
  return iW || (iW = 1, (function(e, t) {
    (function(r, a) {
      e.exports = a();
    })(L2e, (function() {
      return function(r, a) {
        a.prototype.weekday = function(i) {
          var c = this.$locale().weekStart || 0, d = this.$W, f = (d < c ? d + 7 : d) - c;
          return this.$utils().u(i) ? f : this.subtract(f, "day").add(i, "day");
        };
      };
    }));
  })(ik)), ik.exports;
}
var F2e = H2e();
const W2e = /* @__PURE__ */ Sb(F2e);
var lk = { exports: {} }, V2e = lk.exports, lW;
function _2e() {
  return lW || (lW = 1, (function(e, t) {
    (function(r, a) {
      e.exports = a();
    })(V2e, (function() {
      return function(r, a, i) {
        var c = a.prototype, d = function(w) {
          return w && (w.indexOf ? w : w.s);
        }, f = function(w, x, E, P, k) {
          var M = w.name ? w : w.$locale(), T = d(M[x]), N = d(M[E]), D = T || N.map((function(j) {
            return j.slice(0, P);
          }));
          if (!k) return D;
          var $ = M.weekStart;
          return D.map((function(j, I) {
            return D[(I + ($ || 0)) % 7];
          }));
        }, p = function() {
          return i.Ls[i.locale()];
        }, g = function(w, x) {
          return w.formats[x] || (function(E) {
            return E.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (function(P, k, M) {
              return k || M.slice(1);
            }));
          })(w.formats[x.toUpperCase()]);
        }, b = function() {
          var w = this;
          return { months: function(x) {
            return x ? x.format("MMMM") : f(w, "months");
          }, monthsShort: function(x) {
            return x ? x.format("MMM") : f(w, "monthsShort", "months", 3);
          }, firstDayOfWeek: function() {
            return w.$locale().weekStart || 0;
          }, weekdays: function(x) {
            return x ? x.format("dddd") : f(w, "weekdays");
          }, weekdaysMin: function(x) {
            return x ? x.format("dd") : f(w, "weekdaysMin", "weekdays", 2);
          }, weekdaysShort: function(x) {
            return x ? x.format("ddd") : f(w, "weekdaysShort", "weekdays", 3);
          }, longDateFormat: function(x) {
            return g(w.$locale(), x);
          }, meridiem: this.$locale().meridiem, ordinal: this.$locale().ordinal };
        };
        c.localeData = function() {
          return b.bind(this)();
        }, i.localeData = function() {
          var w = p();
          return { firstDayOfWeek: function() {
            return w.weekStart || 0;
          }, weekdays: function() {
            return i.weekdays();
          }, weekdaysShort: function() {
            return i.weekdaysShort();
          }, weekdaysMin: function() {
            return i.weekdaysMin();
          }, months: function() {
            return i.months();
          }, monthsShort: function() {
            return i.monthsShort();
          }, longDateFormat: function(x) {
            return g(w, x);
          }, meridiem: w.meridiem, ordinal: w.ordinal };
        }, i.months = function() {
          return f(p(), "months");
        }, i.monthsShort = function() {
          return f(p(), "monthsShort", "months", 3);
        }, i.weekdays = function(w) {
          return f(p(), "weekdays", null, null, w);
        }, i.weekdaysShort = function(w) {
          return f(p(), "weekdaysShort", "weekdays", 3, w);
        }, i.weekdaysMin = function(w) {
          return f(p(), "weekdaysMin", "weekdays", 2, w);
        };
      };
    }));
  })(lk)), lk.exports;
}
var B2e = _2e();
const U2e = /* @__PURE__ */ Sb(B2e);
var sk = { exports: {} }, X2e = sk.exports, sW;
function G2e() {
  return sW || (sW = 1, (function(e, t) {
    (function(r, a) {
      e.exports = a();
    })(X2e, (function() {
      var r = "week", a = "year";
      return function(i, c, d) {
        var f = c.prototype;
        f.week = function(p) {
          if (p === void 0 && (p = null), p !== null) return this.add(7 * (p - this.week()), "day");
          var g = this.$locale().yearStart || 1;
          if (this.month() === 11 && this.date() > 25) {
            var b = d(this).startOf(a).add(1, a).date(g), w = d(this).endOf(r);
            if (b.isBefore(w)) return 1;
          }
          var x = d(this).startOf(a).date(g).startOf(r).subtract(1, "millisecond"), E = this.diff(x, r, !0);
          return E < 0 ? d(this).startOf("week").week() : Math.ceil(E);
        }, f.weeks = function(p) {
          return p === void 0 && (p = null), this.week(p);
        };
      };
    }));
  })(sk)), sk.exports;
}
var q2e = G2e();
const K2e = /* @__PURE__ */ Sb(q2e);
var uk = { exports: {} }, Y2e = uk.exports, uW;
function Q2e() {
  return uW || (uW = 1, (function(e, t) {
    (function(r, a) {
      e.exports = a();
    })(Y2e, (function() {
      return function(r, a) {
        a.prototype.weekYear = function() {
          var i = this.month(), c = this.week(), d = this.year();
          return c === 1 && i === 11 ? d + 1 : i === 0 && c >= 52 ? d - 1 : d;
        };
      };
    }));
  })(uk)), uk.exports;
}
var J2e = Q2e();
const Z2e = /* @__PURE__ */ Sb(J2e);
var ck = { exports: {} }, e1e = ck.exports, cW;
function t1e() {
  return cW || (cW = 1, (function(e, t) {
    (function(r, a) {
      e.exports = a();
    })(e1e, (function() {
      return function(r, a) {
        var i = a.prototype, c = i.format;
        i.format = function(d) {
          var f = this, p = this.$locale();
          if (!this.isValid()) return c.bind(this)(d);
          var g = this.$utils(), b = (d || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, (function(w) {
            switch (w) {
              case "Q":
                return Math.ceil((f.$M + 1) / 3);
              case "Do":
                return p.ordinal(f.$D);
              case "gggg":
                return f.weekYear();
              case "GGGG":
                return f.isoWeekYear();
              case "wo":
                return p.ordinal(f.week(), "W");
              case "w":
              case "ww":
                return g.s(f.week(), w === "w" ? 1 : 2, "0");
              case "W":
              case "WW":
                return g.s(f.isoWeek(), w === "W" ? 1 : 2, "0");
              case "k":
              case "kk":
                return g.s(String(f.$H === 0 ? 24 : f.$H), w === "k" ? 1 : 2, "0");
              case "X":
                return Math.floor(f.$d.getTime() / 1e3);
              case "x":
                return f.$d.getTime();
              case "z":
                return "[" + f.offsetName() + "]";
              case "zzz":
                return "[" + f.offsetName("long") + "]";
              default:
                return w;
            }
          }));
          return c.bind(this)(b);
        };
      };
    }));
  })(ck)), ck.exports;
}
var n1e = t1e();
const r1e = /* @__PURE__ */ Sb(n1e);
var dk = { exports: {} }, a1e = dk.exports, dW;
function o1e() {
  return dW || (dW = 1, (function(e, t) {
    (function(r, a) {
      e.exports = a();
    })(a1e, (function() {
      var r = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, a = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, i = /\d/, c = /\d\d/, d = /\d\d?/, f = /\d*[^-_:/,()\s\d]+/, p = {}, g = function(M) {
        return (M = +M) + (M > 68 ? 1900 : 2e3);
      }, b = function(M) {
        return function(T) {
          this[M] = +T;
        };
      }, w = [/[+-]\d\d:?(\d\d)?|Z/, function(M) {
        (this.zone || (this.zone = {})).offset = (function(T) {
          if (!T || T === "Z") return 0;
          var N = T.match(/([+-]|\d\d)/g), D = 60 * N[1] + (+N[2] || 0);
          return D === 0 ? 0 : N[0] === "+" ? -D : D;
        })(M);
      }], x = function(M) {
        var T = p[M];
        return T && (T.indexOf ? T : T.s.concat(T.f));
      }, E = function(M, T) {
        var N, D = p.meridiem;
        if (D) {
          for (var $ = 1; $ <= 24; $ += 1) if (M.indexOf(D($, 0, T)) > -1) {
            N = $ > 12;
            break;
          }
        } else N = M === (T ? "pm" : "PM");
        return N;
      }, P = { A: [f, function(M) {
        this.afternoon = E(M, !1);
      }], a: [f, function(M) {
        this.afternoon = E(M, !0);
      }], Q: [i, function(M) {
        this.month = 3 * (M - 1) + 1;
      }], S: [i, function(M) {
        this.milliseconds = 100 * +M;
      }], SS: [c, function(M) {
        this.milliseconds = 10 * +M;
      }], SSS: [/\d{3}/, function(M) {
        this.milliseconds = +M;
      }], s: [d, b("seconds")], ss: [d, b("seconds")], m: [d, b("minutes")], mm: [d, b("minutes")], H: [d, b("hours")], h: [d, b("hours")], HH: [d, b("hours")], hh: [d, b("hours")], D: [d, b("day")], DD: [c, b("day")], Do: [f, function(M) {
        var T = p.ordinal, N = M.match(/\d+/);
        if (this.day = N[0], T) for (var D = 1; D <= 31; D += 1) T(D).replace(/\[|\]/g, "") === M && (this.day = D);
      }], w: [d, b("week")], ww: [c, b("week")], M: [d, b("month")], MM: [c, b("month")], MMM: [f, function(M) {
        var T = x("months"), N = (x("monthsShort") || T.map((function(D) {
          return D.slice(0, 3);
        }))).indexOf(M) + 1;
        if (N < 1) throw new Error();
        this.month = N % 12 || N;
      }], MMMM: [f, function(M) {
        var T = x("months").indexOf(M) + 1;
        if (T < 1) throw new Error();
        this.month = T % 12 || T;
      }], Y: [/[+-]?\d+/, b("year")], YY: [c, function(M) {
        this.year = g(M);
      }], YYYY: [/\d{4}/, b("year")], Z: w, ZZ: w };
      function k(M) {
        var T, N;
        T = M, N = p && p.formats;
        for (var D = (M = T.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, (function(W, Q, U) {
          var Y = U && U.toUpperCase();
          return Q || N[U] || r[U] || N[Y].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (function(G, J, H) {
            return J || H.slice(1);
          }));
        }))).match(a), $ = D.length, j = 0; j < $; j += 1) {
          var I = D[j], L = P[I], F = L && L[0], _ = L && L[1];
          D[j] = _ ? { regex: F, parser: _ } : I.replace(/^\[|\]$/g, "");
        }
        return function(W) {
          for (var Q = {}, U = 0, Y = 0; U < $; U += 1) {
            var G = D[U];
            if (typeof G == "string") Y += G.length;
            else {
              var J = G.regex, H = G.parser, K = W.slice(Y), X = J.exec(K)[0];
              H.call(Q, X), W = W.replace(X, "");
            }
          }
          return (function(te) {
            var ie = te.afternoon;
            if (ie !== void 0) {
              var ee = te.hours;
              ie ? ee < 12 && (te.hours += 12) : ee === 12 && (te.hours = 0), delete te.afternoon;
            }
          })(Q), Q;
        };
      }
      return function(M, T, N) {
        N.p.customParseFormat = !0, M && M.parseTwoDigitYear && (g = M.parseTwoDigitYear);
        var D = T.prototype, $ = D.parse;
        D.parse = function(j) {
          var I = j.date, L = j.utc, F = j.args;
          this.$u = L;
          var _ = F[1];
          if (typeof _ == "string") {
            var W = F[2] === !0, Q = F[3] === !0, U = W || Q, Y = F[2];
            Q && (Y = F[2]), p = this.$locale(), !W && Y && (p = N.Ls[Y]), this.$d = (function(K, X, te, ie) {
              try {
                if (["x", "X"].indexOf(X) > -1) return new Date((X === "X" ? 1e3 : 1) * K);
                var ee = k(X)(K), ne = ee.year, ae = ee.month, oe = ee.day, fe = ee.hours, be = ee.minutes, me = ee.seconds, De = ee.milliseconds, Me = ee.zone, ze = ee.week, le = /* @__PURE__ */ new Date(), se = oe || (ne || ae ? 1 : le.getDate()), Ae = ne || le.getFullYear(), we = 0;
                ne && !ae || (we = ae > 0 ? ae - 1 : le.getMonth());
                var Ne, pe = fe || 0, Qe = be || 0, Le = me || 0, Te = De || 0;
                return Me ? new Date(Date.UTC(Ae, we, se, pe, Qe, Le, Te + 60 * Me.offset * 1e3)) : te ? new Date(Date.UTC(Ae, we, se, pe, Qe, Le, Te)) : (Ne = new Date(Ae, we, se, pe, Qe, Le, Te), ze && (Ne = ie(Ne).week(ze).toDate()), Ne);
              } catch {
                return /* @__PURE__ */ new Date("");
              }
            })(I, _, L, N), this.init(), Y && Y !== !0 && (this.$L = this.locale(Y).$L), U && I != this.format(_) && (this.$d = /* @__PURE__ */ new Date("")), p = {};
          } else if (_ instanceof Array) for (var G = _.length, J = 1; J <= G; J += 1) {
            F[1] = _[J - 1];
            var H = N.apply(this, F);
            if (H.isValid()) {
              this.$d = H.$d, this.$L = H.$L, this.init();
              break;
            }
            J === G && (this.$d = /* @__PURE__ */ new Date(""));
          }
          else $.call(this, j);
        };
      };
    }));
  })(dk)), dk.exports;
}
var i1e = o1e();
const l1e = /* @__PURE__ */ Sb(i1e);
Vf.extend(l1e);
Vf.extend(r1e);
Vf.extend(W2e);
Vf.extend(U2e);
Vf.extend(K2e);
Vf.extend(Z2e);
Vf.extend(function(e, t) {
  var r = t.prototype, a = r.format;
  r.format = function(c) {
    var d = (c || "").replace("Wo", "wo");
    return a.bind(this)(d);
  };
});
var s1e = {
  // ar_EG:
  // az_AZ:
  // bg_BG:
  bn_BD: "bn-bd",
  by_BY: "be",
  // ca_ES:
  // cs_CZ:
  // da_DK:
  // de_DE:
  // el_GR:
  en_GB: "en-gb",
  en_US: "en",
  // es_ES:
  // et_EE:
  // fa_IR:
  // fi_FI:
  fr_BE: "fr",
  // todo: dayjs has no fr_BE locale, use fr at present
  fr_CA: "fr-ca",
  // fr_FR:
  // ga_IE:
  // gl_ES:
  // he_IL:
  // hi_IN:
  // hr_HR:
  // hu_HU:
  hy_AM: "hy-am",
  // id_ID:
  // is_IS:
  // it_IT:
  // ja_JP:
  // ka_GE:
  // kk_KZ:
  // km_KH:
  kmr_IQ: "ku",
  // kn_IN:
  // ko_KR:
  // ku_IQ: // previous ku in antd
  // lt_LT:
  // lv_LV:
  // mk_MK:
  // ml_IN:
  // mn_MN:
  // ms_MY:
  // nb_NO:
  // ne_NP:
  nl_BE: "nl-be",
  // nl_NL:
  // pl_PL:
  pt_BR: "pt-br",
  // pt_PT:
  // ro_RO:
  // ru_RU:
  // sk_SK:
  // sl_SI:
  // sr_RS:
  // sv_SE:
  // ta_IN:
  // th_TH:
  // tr_TR:
  // uk_UA:
  // ur_PK:
  // vi_VN:
  zh_CN: "zh-cn",
  zh_HK: "zh-hk",
  zh_TW: "zh-tw"
}, z4 = function(t) {
  var r = s1e[t];
  return r || t.split("_")[0];
}, u1e = {
  // get
  getNow: function() {
    var t = Vf();
    return typeof t.tz == "function" ? t.tz() : t;
  },
  getFixedDate: function(t) {
    return Vf(t, ["YYYY-M-DD", "YYYY-MM-DD"]);
  },
  getEndDate: function(t) {
    return t.endOf("month");
  },
  getWeekDay: function(t) {
    var r = t.locale("en");
    return r.weekday() + r.localeData().firstDayOfWeek();
  },
  getYear: function(t) {
    return t.year();
  },
  getMonth: function(t) {
    return t.month();
  },
  getDate: function(t) {
    return t.date();
  },
  getHour: function(t) {
    return t.hour();
  },
  getMinute: function(t) {
    return t.minute();
  },
  getSecond: function(t) {
    return t.second();
  },
  getMillisecond: function(t) {
    return t.millisecond();
  },
  // set
  addYear: function(t, r) {
    return t.add(r, "year");
  },
  addMonth: function(t, r) {
    return t.add(r, "month");
  },
  addDate: function(t, r) {
    return t.add(r, "day");
  },
  setYear: function(t, r) {
    return t.year(r);
  },
  setMonth: function(t, r) {
    return t.month(r);
  },
  setDate: function(t, r) {
    return t.date(r);
  },
  setHour: function(t, r) {
    return t.hour(r);
  },
  setMinute: function(t, r) {
    return t.minute(r);
  },
  setSecond: function(t, r) {
    return t.second(r);
  },
  setMillisecond: function(t, r) {
    return t.millisecond(r);
  },
  // Compare
  isAfter: function(t, r) {
    return t.isAfter(r);
  },
  isValidate: function(t) {
    return t.isValid();
  },
  locale: {
    getWeekFirstDay: function(t) {
      return Vf().locale(z4(t)).localeData().firstDayOfWeek();
    },
    getWeekFirstDate: function(t, r) {
      return r.locale(z4(t)).weekday(0);
    },
    getWeek: function(t, r) {
      return r.locale(z4(t)).week();
    },
    getShortWeekDays: function(t) {
      return Vf().locale(z4(t)).localeData().weekdaysMin();
    },
    getShortMonths: function(t) {
      return Vf().locale(z4(t)).localeData().monthsShort();
    },
    format: function(t, r, a) {
      return r.locale(z4(t)).format(a);
    },
    parse: function(t, r, a) {
      for (var i = z4(t), c = 0; c < a.length; c += 1) {
        var d = a[c], f = r;
        if (d.includes("wo") || d.includes("Wo")) {
          for (var p = f.split("-")[0], g = f.split("-")[1], b = Vf(p, "YYYY").startOf("year").locale(i), w = 0; w <= 52; w += 1) {
            var x = b.add(w, "week");
            if (x.format("Wo") === g)
              return x;
          }
          return null;
        }
        var E = Vf(f, d, !0).locale(i);
        if (E.isValid())
          return E;
      }
      return null;
    }
  }
};
function c1e(e, t) {
  return e !== void 0 ? e : t ? "bottomRight" : "bottomLeft";
}
var K1 = /* @__PURE__ */ S.createContext(null), d1e = {
  bottomLeft: {
    points: ["tl", "bl"],
    offset: [0, 4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  bottomRight: {
    points: ["tr", "br"],
    offset: [0, 4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  topLeft: {
    points: ["bl", "tl"],
    offset: [0, -4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  },
  topRight: {
    points: ["br", "tr"],
    offset: [0, -4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  }
};
function ZY(e) {
  var t = e.popupElement, r = e.popupStyle, a = e.popupClassName, i = e.popupAlign, c = e.transitionName, d = e.getPopupContainer, f = e.children, p = e.range, g = e.placement, b = e.builtinPlacements, w = b === void 0 ? d1e : b, x = e.direction, E = e.visible, P = e.onClose, k = S.useContext(K1), M = k.prefixCls, T = "".concat(M, "-dropdown"), N = c1e(g, x === "rtl");
  return /* @__PURE__ */ S.createElement(e7, {
    showAction: [],
    hideAction: ["click"],
    popupPlacement: N,
    builtinPlacements: w,
    prefixCls: T,
    popupTransitionName: c,
    popup: t,
    popupAlign: i,
    popupVisible: E,
    popupClassName: _e(a, ge(ge({}, "".concat(T, "-range"), p), "".concat(T, "-rtl"), x === "rtl")),
    popupStyle: r,
    stretch: "minWidth",
    getPopupContainer: d,
    onPopupVisibleChange: function($) {
      $ || P();
    }
  }, f);
}
function bj(e, t) {
  for (var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0", a = String(e); a.length < t; )
    a = "".concat(r).concat(a);
  return a;
}
function p3(e) {
  return e == null ? [] : Array.isArray(e) ? e : [e];
}
function mE(e, t, r) {
  var a = Et(e);
  return a[t] = r, a;
}
function lM(e, t) {
  var r = {}, a = t || Object.keys(e);
  return a.forEach(function(i) {
    e[i] !== void 0 && (r[i] = e[i]);
  }), r;
}
function eQ(e, t, r) {
  if (r)
    return r;
  switch (e) {
    // All from the `locale.fieldXXXFormat` first
    case "time":
      return t.fieldTimeFormat;
    case "datetime":
      return t.fieldDateTimeFormat;
    case "month":
      return t.fieldMonthFormat;
    case "year":
      return t.fieldYearFormat;
    case "quarter":
      return t.fieldQuarterFormat;
    case "week":
      return t.fieldWeekFormat;
    default:
      return t.fieldDateFormat;
  }
}
function tQ(e, t, r) {
  var a = r !== void 0 ? r : t[t.length - 1], i = t.find(function(c) {
    return e[c];
  });
  return a !== i ? e[i] : void 0;
}
function nQ(e) {
  return lM(e, ["placement", "builtinPlacements", "popupAlign", "getPopupContainer", "transitionName", "direction"]);
}
function yj(e, t, r, a) {
  process.env.NODE_ENV !== "production" && ($n(!t, "'dateRender' is deprecated. Please use 'cellRender' instead."), $n(!r, "'monthCellRender' is deprecated. Please use 'cellRender' instead."));
  var i = S.useMemo(function() {
    return e || function(d, f) {
      var p = d;
      return t && f.type === "date" ? t(p, f.today) : r && f.type === "month" ? r(p, f.locale) : f.originNode;
    };
  }, [e, r, t]), c = S.useCallback(function(d, f) {
    return i(d, ce(ce({}, f), {}, {
      range: a
    }));
  }, [i, a]);
  return c;
}
function rQ(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], a = S.useState([!1, !1]), i = qe(a, 2), c = i[0], d = i[1], f = function(b, w) {
    d(function(x) {
      return mE(x, w, b);
    });
  }, p = S.useMemo(function() {
    return c.map(function(g, b) {
      if (g)
        return !0;
      var w = e[b];
      return w ? !!(!r[b] && !w || w && t(w, {
        activeIndex: b
      })) : !1;
    });
  }, [e, c, t, r]);
  return [p, f];
}
function aQ(e, t, r, a, i) {
  var c = "", d = [];
  return e && d.push(i ? "hh" : "HH"), t && d.push("mm"), r && d.push("ss"), c = d.join(":"), a && (c += ".SSS"), i && (c += " A"), c;
}
function f1e(e, t, r, a, i, c) {
  var d = e.fieldDateTimeFormat, f = e.fieldDateFormat, p = e.fieldTimeFormat, g = e.fieldMonthFormat, b = e.fieldYearFormat, w = e.fieldWeekFormat, x = e.fieldQuarterFormat, E = e.yearFormat, P = e.cellYearFormat, k = e.cellQuarterFormat, M = e.dayFormat, T = e.cellDateFormat, N = aQ(t, r, a, i, c);
  return ce(ce({}, e), {}, {
    fieldDateTimeFormat: d || "YYYY-MM-DD ".concat(N),
    fieldDateFormat: f || "YYYY-MM-DD",
    fieldTimeFormat: p || N,
    fieldMonthFormat: g || "YYYY-MM",
    fieldYearFormat: b || "YYYY",
    fieldWeekFormat: w || "gggg-wo",
    fieldQuarterFormat: x || "YYYY-[Q]Q",
    yearFormat: E || "YYYY",
    cellYearFormat: P || "YYYY",
    cellQuarterFormat: k || "[Q]Q",
    cellDateFormat: T || M || "D"
  });
}
function oQ(e, t) {
  var r = t.showHour, a = t.showMinute, i = t.showSecond, c = t.showMillisecond, d = t.use12Hours;
  return Re.useMemo(function() {
    return f1e(e, r, a, i, c, d);
  }, [e, r, a, i, c, d]);
}
function O5(e, t, r) {
  return r ?? t.some(function(a) {
    return e.includes(a);
  });
}
var m1e = [
  // 'format',
  "showNow",
  "showHour",
  "showMinute",
  "showSecond",
  "showMillisecond",
  "use12Hours",
  "hourStep",
  "minuteStep",
  "secondStep",
  "millisecondStep",
  "hideDisabledOptions",
  "defaultValue",
  "disabledHours",
  "disabledMinutes",
  "disabledSeconds",
  "disabledMilliseconds",
  "disabledTime",
  "changeOnScroll",
  "defaultOpenValue"
];
function h1e(e) {
  var t = lM(e, m1e), r = e.format, a = e.picker, i = null;
  return r && (i = r, Array.isArray(i) && (i = i[0]), i = Hn(i) === "object" ? i.format : i), a === "time" && (t.format = i), [t, i];
}
function p1e(e) {
  return e && typeof e == "string";
}
function iQ(e, t, r, a) {
  return [e, t, r, a].some(function(i) {
    return i !== void 0;
  });
}
function lQ(e, t, r, a, i) {
  var c = t, d = r, f = a;
  if (!e && !c && !d && !f && !i)
    c = !0, d = !0, f = !0;
  else if (e) {
    var p, g, b, w = [c, d, f].some(function(P) {
      return P === !1;
    }), x = [c, d, f].some(function(P) {
      return P === !0;
    }), E = w ? !0 : !x;
    c = (p = c) !== null && p !== void 0 ? p : E, d = (g = d) !== null && g !== void 0 ? g : E, f = (b = f) !== null && b !== void 0 ? b : E;
  }
  return [c, d, f, i];
}
function sQ(e) {
  var t = e.showTime, r = h1e(e), a = qe(r, 2), i = a[0], c = a[1], d = t && Hn(t) === "object" ? t : {}, f = ce(ce({
    defaultOpenValue: d.defaultOpenValue || d.defaultValue
  }, i), d), p = f.showMillisecond, g = f.showHour, b = f.showMinute, w = f.showSecond, x = iQ(g, b, w, p), E = lQ(x, g, b, w, p), P = qe(E, 3);
  return g = P[0], b = P[1], w = P[2], [f, ce(ce({}, f), {}, {
    showHour: g,
    showMinute: b,
    showSecond: w,
    showMillisecond: p
  }), f.format, c];
}
function uQ(e, t, r, a, i) {
  var c = e === "time";
  if (e === "datetime" || c) {
    for (var d = a, f = eQ(e, i, null), p = f, g = [t, r], b = 0; b < g.length; b += 1) {
      var w = p3(g[b])[0];
      if (p1e(w)) {
        p = w;
        break;
      }
    }
    var x = d.showHour, E = d.showMinute, P = d.showSecond, k = d.showMillisecond, M = d.use12Hours, T = O5(p, ["a", "A", "LT", "LLL", "LTS"], M), N = iQ(x, E, P, k);
    N || (x = O5(p, ["H", "h", "k", "LT", "LLL"]), E = O5(p, ["m", "LT", "LLL"]), P = O5(p, ["s", "LTS"]), k = O5(p, ["SSS"]));
    var D = lQ(N, x, E, P, k), $ = qe(D, 3);
    x = $[0], E = $[1], P = $[2];
    var j = t || aQ(x, E, P, k, T);
    return ce(ce({}, d), {}, {
      // Format
      format: j,
      // Show Config
      showHour: x,
      showMinute: E,
      showSecond: P,
      showMillisecond: k,
      use12Hours: T
    });
  }
  return null;
}
function g1e(e, t, r) {
  if (process.env.NODE_ENV !== "production" && r && $n(!1, "`clearIcon` will be removed in future. Please use `allowClear` instead."), t === !1)
    return null;
  var a = t && Hn(t) === "object" ? t : {};
  return a.clearIcon || r || /* @__PURE__ */ S.createElement("span", {
    className: "".concat(e, "-clear-btn")
  });
}
var cR = 7;
function oC(e, t, r) {
  return !e && !t || e === t ? !0 : !e || !t ? !1 : r();
}
function FD(e, t, r) {
  return oC(t, r, function() {
    var a = Math.floor(e.getYear(t) / 10), i = Math.floor(e.getYear(r) / 10);
    return a === i;
  });
}
function e3(e, t, r) {
  return oC(t, r, function() {
    return e.getYear(t) === e.getYear(r);
  });
}
function fW(e, t) {
  var r = Math.floor(e.getMonth(t) / 3);
  return r + 1;
}
function v1e(e, t, r) {
  return oC(t, r, function() {
    return e3(e, t, r) && fW(e, t) === fW(e, r);
  });
}
function wj(e, t, r) {
  return oC(t, r, function() {
    return e3(e, t, r) && e.getMonth(t) === e.getMonth(r);
  });
}
function Sj(e, t, r) {
  return oC(t, r, function() {
    return e3(e, t, r) && wj(e, t, r) && e.getDate(t) === e.getDate(r);
  });
}
function cQ(e, t, r) {
  return oC(t, r, function() {
    return e.getHour(t) === e.getHour(r) && e.getMinute(t) === e.getMinute(r) && e.getSecond(t) === e.getSecond(r);
  });
}
function dQ(e, t, r) {
  return oC(t, r, function() {
    return Sj(e, t, r) && cQ(e, t, r) && e.getMillisecond(t) === e.getMillisecond(r);
  });
}
function oE(e, t, r, a) {
  return oC(r, a, function() {
    var i = e.locale.getWeekFirstDate(t, r), c = e.locale.getWeekFirstDate(t, a);
    return e3(e, i, c) && e.locale.getWeek(t, r) === e.locale.getWeek(t, a);
  });
}
function rm(e, t, r, a, i) {
  switch (i) {
    case "date":
      return Sj(e, r, a);
    case "week":
      return oE(e, t.locale, r, a);
    case "month":
      return wj(e, r, a);
    case "quarter":
      return v1e(e, r, a);
    case "year":
      return e3(e, r, a);
    case "decade":
      return FD(e, r, a);
    case "time":
      return cQ(e, r, a);
    default:
      return dQ(e, r, a);
  }
}
function sM(e, t, r, a) {
  return !t || !r || !a ? !1 : e.isAfter(a, t) && e.isAfter(r, a);
}
function B7(e, t, r, a, i) {
  return rm(e, t, r, a, i) ? !0 : e.isAfter(r, a);
}
function b1e(e, t, r) {
  var a = t.locale.getWeekFirstDay(e), i = t.setDate(r, 1), c = t.getWeekDay(i), d = t.addDate(i, a - c);
  return t.getMonth(d) === t.getMonth(r) && t.getDate(d) > 1 && (d = t.addDate(d, -7)), d;
}
function ld(e, t) {
  var r = t.generateConfig, a = t.locale, i = t.format;
  return e ? typeof i == "function" ? i(e) : r.locale.format(a.locale, e, i) : "";
}
function Qk(e, t, r) {
  var a = t, i = ["getHour", "getMinute", "getSecond", "getMillisecond"], c = ["setHour", "setMinute", "setSecond", "setMillisecond"];
  return c.forEach(function(d, f) {
    r ? a = e[d](a, e[i[f]](r)) : a = e[d](a, 0);
  }), a;
}
function y1e(e, t, r, a, i) {
  var c = ra(function(d, f) {
    return !!(r && r(d, f) || a && e.isAfter(a, d) && !rm(e, t, a, d, f.type) || i && e.isAfter(d, i) && !rm(e, t, i, d, f.type));
  });
  return c;
}
function w1e(e, t, r) {
  return S.useMemo(function() {
    var a = eQ(e, t, r), i = p3(a), c = i[0], d = Hn(c) === "object" && c.type === "mask" ? c.format : null;
    return [
      // Format list
      i.map(function(f) {
        return typeof f == "string" || typeof f == "function" ? f : f.format;
      }),
      // Mask Format
      d
    ];
  }, [e, t, r]);
}
function S1e(e, t, r) {
  return typeof e[0] == "function" || r ? !0 : t;
}
function C1e(e, t, r, a) {
  var i = ra(function(c, d) {
    var f = ce({
      type: t
    }, d);
    if (delete f.activeIndex, // Date object is invalid
    !e.isValidate(c) || // Date is disabled by `disabledDate`
    r && r(c, f))
      return !0;
    if ((t === "date" || t === "time") && a) {
      var p, g = d && d.activeIndex === 1 ? "end" : "start", b = ((p = a.disabledTime) === null || p === void 0 ? void 0 : p.call(a, c, g, {
        from: f.from
      })) || {}, w = b.disabledHours, x = b.disabledMinutes, E = b.disabledSeconds, P = b.disabledMilliseconds, k = a.disabledHours, M = a.disabledMinutes, T = a.disabledSeconds, N = w || k, D = x || M, $ = E || T, j = e.getHour(c), I = e.getMinute(c), L = e.getSecond(c), F = e.getMillisecond(c);
      if (N && N().includes(j) || D && D(j).includes(I) || $ && $(j, I).includes(L) || P && P(j, I, L).includes(F))
        return !0;
    }
    return !1;
  });
  return i;
}
function U7(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = S.useMemo(function() {
    var a = e && p3(e);
    return t && a && (a[1] = a[1] || a[0]), a;
  }, [e, t]);
  return r;
}
function fQ(e, t) {
  var r = e.generateConfig, a = e.locale, i = e.picker, c = i === void 0 ? "date" : i, d = e.prefixCls, f = d === void 0 ? "rc-picker" : d, p = e.styles, g = p === void 0 ? {} : p, b = e.classNames, w = b === void 0 ? {} : b, x = e.order, E = x === void 0 ? !0 : x, P = e.components, k = P === void 0 ? {} : P, M = e.inputRender, T = e.allowClear, N = e.clearIcon, D = e.needConfirm, $ = e.multiple, j = e.format, I = e.inputReadOnly, L = e.disabledDate, F = e.minDate, _ = e.maxDate, W = e.showTime, Q = e.value, U = e.defaultValue, Y = e.pickerValue, G = e.defaultPickerValue, J = U7(Q), H = U7(U), K = U7(Y), X = U7(G), te = c === "date" && W ? "datetime" : c, ie = te === "time" || te === "datetime", ee = ie || $, ne = D ?? ie, ae = sQ(e), oe = qe(ae, 4), fe = oe[0], be = oe[1], me = oe[2], De = oe[3], Me = oQ(a, be), ze = S.useMemo(function() {
    return uQ(te, me, De, fe, Me);
  }, [te, me, De, fe, Me]);
  process.env.NODE_ENV !== "production" && c === "time" && ["disabledHours", "disabledMinutes", "disabledSeconds"].some(function(Oe) {
    return e[Oe];
  }) && $n(!1, "'disabledHours', 'disabledMinutes', 'disabledSeconds' will be removed in the next major version, please use 'disabledTime' instead.");
  var le = S.useMemo(function() {
    return ce(ce({}, e), {}, {
      prefixCls: f,
      locale: Me,
      picker: c,
      styles: g,
      classNames: w,
      order: E,
      components: ce({
        input: M
      }, k),
      clearIcon: g1e(f, T, N),
      showTime: ze,
      value: J,
      defaultValue: H,
      pickerValue: K,
      defaultPickerValue: X
    }, t?.());
  }, [e]), se = w1e(te, Me, j), Ae = qe(se, 2), we = Ae[0], Ne = Ae[1], pe = S1e(we, I, $), Qe = y1e(r, a, L, F, _), Le = C1e(r, c, Qe, ze), Te = S.useMemo(function() {
    return ce(ce({}, le), {}, {
      needConfirm: ne,
      inputReadOnly: pe,
      disabledDate: Qe
    });
  }, [le, ne, pe, Qe]);
  return [Te, te, ee, we, Ne, Le];
}
function x1e(e, t, r) {
  var a = ll(t, {
    value: e
  }), i = qe(a, 2), c = i[0], d = i[1], f = Re.useRef(e), p = Re.useRef(), g = function() {
    Pa.cancel(p.current);
  }, b = ra(function() {
    d(f.current), r && c !== f.current && r(f.current);
  }), w = ra(function(x, E) {
    g(), f.current = x, x || E ? b() : p.current = Pa(b);
  });
  return Re.useEffect(function() {
    return g;
  }, []), [c, w];
}
function mQ(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], a = arguments.length > 3 ? arguments[3] : void 0, i = r.every(function(b) {
    return b;
  }) ? !1 : e, c = x1e(i, t || !1, a), d = qe(c, 2), f = d[0], p = d[1];
  function g(b) {
    var w = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    (!w.inherit || f) && p(b, w.force);
  }
  return [f, g];
}
function hQ(e) {
  var t = S.useRef();
  return S.useImperativeHandle(e, function() {
    var r;
    return {
      nativeElement: (r = t.current) === null || r === void 0 ? void 0 : r.nativeElement,
      focus: function(i) {
        var c;
        (c = t.current) === null || c === void 0 || c.focus(i);
      },
      blur: function() {
        var i;
        (i = t.current) === null || i === void 0 || i.blur();
      }
    };
  }), t;
}
function pQ(e, t) {
  return S.useMemo(function() {
    return e || (t ? ($n(!1, "`ranges` is deprecated. Please use `presets` instead."), Object.entries(t).map(function(r) {
      var a = qe(r, 2), i = a[0], c = a[1];
      return {
        label: i,
        value: c
      };
    })) : []);
  }, [e, t]);
}
function Cj(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, a = S.useRef(t);
  a.current = t, IN(function() {
    if (e)
      a.current(e);
    else {
      var i = Pa(function() {
        a.current(e);
      }, r);
      return function() {
        Pa.cancel(i);
      };
    }
  }, [e]);
}
function gQ(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, a = S.useState(0), i = qe(a, 2), c = i[0], d = i[1], f = S.useState(!1), p = qe(f, 2), g = p[0], b = p[1], w = S.useRef([]), x = S.useRef(null), E = S.useRef(null), P = function($) {
    x.current = $;
  }, k = function($) {
    return x.current === $;
  }, M = function($) {
    b($);
  }, T = function($) {
    return $ && (E.current = $), E.current;
  }, N = function($) {
    var j = w.current, I = new Set(j.filter(function(F) {
      return $[F] || t[F];
    })), L = j[j.length - 1] === 0 ? 1 : 0;
    return I.size >= 2 || e[L] ? null : L;
  };
  return Cj(g || r, function() {
    g || (w.current = [], P(null));
  }), S.useEffect(function() {
    g && w.current.push(c);
  }, [g, c]), [g, M, T, c, d, N, w.current, P, k];
}
function E1e(e, t, r, a, i, c) {
  var d = r[r.length - 1], f = function(g, b) {
    var w = qe(e, 2), x = w[0], E = w[1], P = ce(ce({}, b), {}, {
      from: tQ(e, r)
    });
    return d === 1 && t[0] && x && // Same date isOK
    !rm(a, i, x, g, P.type) && // Before start date
    a.isAfter(x, g) || d === 0 && t[1] && E && // Same date isOK
    !rm(a, i, E, g, P.type) && // After end date
    a.isAfter(g, E) ? !0 : c?.(g, P);
  };
  return f;
}
function iE(e, t, r, a) {
  switch (t) {
    case "date":
    case "week":
      return e.addMonth(r, a);
    case "month":
    case "quarter":
      return e.addYear(r, a);
    case "year":
      return e.addYear(r, a * 10);
    case "decade":
      return e.addYear(r, a * 100);
    default:
      return r;
  }
}
var dR = [];
function vQ(e, t, r, a, i, c, d, f) {
  var p = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : dR, g = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : dR, b = arguments.length > 10 && arguments[10] !== void 0 ? arguments[10] : dR, w = arguments.length > 11 ? arguments[11] : void 0, x = arguments.length > 12 ? arguments[12] : void 0, E = arguments.length > 13 ? arguments[13] : void 0, P = d === "time", k = c || 0, M = function(K) {
    var X = e.getNow();
    return P && (X = Qk(e, X)), p[K] || r[K] || X;
  }, T = qe(g, 2), N = T[0], D = T[1], $ = ll(function() {
    return M(0);
  }, {
    value: N
  }), j = qe($, 2), I = j[0], L = j[1], F = ll(function() {
    return M(1);
  }, {
    value: D
  }), _ = qe(F, 2), W = _[0], Q = _[1], U = S.useMemo(function() {
    var H = [I, W][k];
    return P ? H : Qk(e, H, b[k]);
  }, [P, I, W, k, e, b]), Y = function(K) {
    var X = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "panel", te = [L, Q][k];
    te(K);
    var ie = [I, W];
    ie[k] = K, w && (!rm(e, t, I, ie[0], d) || !rm(e, t, W, ie[1], d)) && w(ie, {
      source: X,
      range: k === 1 ? "end" : "start",
      mode: a
    });
  }, G = function(K, X) {
    if (f) {
      var te = {
        date: "month",
        week: "month",
        month: "year",
        quarter: "year"
      }, ie = te[d];
      if (ie && !rm(e, t, K, X, ie))
        return iE(e, d, X, -1);
      if (d === "year" && K) {
        var ee = Math.floor(e.getYear(K) / 10), ne = Math.floor(e.getYear(X) / 10);
        if (ee !== ne)
          return iE(e, d, X, -1);
      }
    }
    return X;
  }, J = S.useRef(null);
  return Da(function() {
    if (i && !p[k]) {
      var H = P ? null : e.getNow();
      if (J.current !== null && J.current !== k ? H = [I, W][k ^ 1] : r[k] ? H = k === 0 ? r[0] : G(r[0], r[1]) : r[k ^ 1] && (H = r[k ^ 1]), H) {
        x && e.isAfter(x, H) && (H = x);
        var K = f ? iE(e, d, H, 1) : H;
        E && e.isAfter(K, E) && (H = f ? iE(e, d, E, -1) : E), Y(H, "reset");
      }
    }
  }, [i, k, r[k]]), S.useEffect(function() {
    i ? J.current = k : J.current = null;
  }, [i, k]), Da(function() {
    i && p && p[k] && Y(p[k], "reset");
  }, [i, k]), [U, Y];
}
function bQ(e, t) {
  var r = S.useRef(e), a = S.useState({}), i = qe(a, 2), c = i[1], d = function(g) {
    return g && t !== void 0 ? t : r.current;
  }, f = function(g) {
    r.current = g, c({});
  };
  return [d, f, d(!0)];
}
var P1e = [];
function yQ(e, t, r) {
  var a = function(d) {
    return d.map(function(f) {
      return ld(f, {
        generateConfig: e,
        locale: t,
        format: r[0]
      });
    });
  }, i = function(d, f) {
    for (var p = Math.max(d.length, f.length), g = -1, b = 0; b < p; b += 1) {
      var w = d[b] || null, x = f[b] || null;
      if (w !== x && !dQ(e, w, x)) {
        g = b;
        break;
      }
    }
    return [g < 0, g !== 0];
  };
  return [a, i];
}
function wQ(e, t) {
  return Et(e).sort(function(r, a) {
    return t.isAfter(r, a) ? 1 : -1;
  });
}
function k1e(e) {
  var t = bQ(e), r = qe(t, 2), a = r[0], i = r[1], c = ra(function() {
    i(e);
  });
  return S.useEffect(function() {
    c();
  }, [e]), [a, i];
}
function SQ(e, t, r, a, i, c, d, f, p) {
  var g = ll(c, {
    value: d
  }), b = qe(g, 2), w = b[0], x = b[1], E = w || P1e, P = k1e(E), k = qe(P, 2), M = k[0], T = k[1], N = yQ(e, t, r), D = qe(N, 2), $ = D[0], j = D[1], I = ra(function(F) {
    var _ = Et(F);
    if (a)
      for (var W = 0; W < 2; W += 1)
        _[W] = _[W] || null;
    else i && (_ = wQ(_.filter(function(H) {
      return H;
    }), e));
    var Q = j(M(), _), U = qe(Q, 2), Y = U[0], G = U[1];
    if (!Y && (T(_), f)) {
      var J = $(_);
      f(_, J, {
        range: G ? "end" : "start"
      });
    }
  }), L = function() {
    p && p(M());
  };
  return [E, x, M, I, L];
}
function CQ(e, t, r, a, i, c, d, f, p, g) {
  var b = e.generateConfig, w = e.locale, x = e.picker, E = e.onChange, P = e.allowEmpty, k = e.order, M = c.some(function(Y) {
    return Y;
  }) ? !1 : k, T = yQ(b, w, d), N = qe(T, 2), D = N[0], $ = N[1], j = bQ(t), I = qe(j, 2), L = I[0], F = I[1], _ = ra(function() {
    F(t);
  });
  S.useEffect(function() {
    _();
  }, [t]);
  var W = ra(function(Y) {
    var G = Y === null, J = Et(Y || L());
    if (G)
      for (var H = Math.max(c.length, J.length), K = 0; K < H; K += 1)
        c[K] || (J[K] = null);
    M && J[0] && J[1] && (J = wQ(J, b)), i(J);
    var X = J, te = qe(X, 2), ie = te[0], ee = te[1], ne = !ie, ae = !ee, oe = P ? (
      // Validate empty start
      (!ne || P[0]) && // Validate empty end
      (!ae || P[1])
    ) : !0, fe = !k || ne || ae || rm(b, w, ie, ee, x) || b.isAfter(ee, ie), be = (
      // Validate start
      (c[0] || !ie || !g(ie, {
        activeIndex: 0
      })) && // Validate end
      (c[1] || !ee || !g(ee, {
        from: ie,
        activeIndex: 1
      }))
    ), me = (
      // Null value is from clear button
      G || // Normal check
      oe && fe && be
    );
    if (me) {
      r(J);
      var De = $(J, t), Me = qe(De, 1), ze = Me[0];
      E && !ze && E(
        // Return null directly if all date are empty
        G && J.every(function(le) {
          return !le;
        }) ? null : J,
        D(J)
      );
    }
    return me;
  }), Q = ra(function(Y, G) {
    var J = mE(L(), Y, a()[Y]);
    F(J), G && W();
  }), U = !f && !p;
  return Cj(!U, function() {
    U && (W(), i(t), _());
  }, 2), [Q, W];
}
function xQ(e, t, r, a, i) {
  return t !== "date" && t !== "time" ? !1 : r !== void 0 ? r : a !== void 0 ? a : !i && (e === "date" || e === "time");
}
function M1e(e, t, r, a, i, c) {
  var d = e;
  function f(w, x, E) {
    var P = c[w](d), k = E.find(function(D) {
      return D.value === P;
    });
    if (!k || k.disabled) {
      var M = E.filter(function(D) {
        return !D.disabled;
      }), T = Et(M).reverse(), N = T.find(function(D) {
        return D.value <= P;
      }) || M[0];
      N && (P = N.value, d = c[x](d, P));
    }
    return P;
  }
  var p = f("getHour", "setHour", t()), g = f("getMinute", "setMinute", r(p)), b = f("getSecond", "setSecond", a(p, g));
  return f("getMillisecond", "setMillisecond", i(p, g, b)), d;
}
function X7() {
  return [];
}
function G7(e, t) {
  for (var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], c = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 2, d = [], f = r >= 1 ? r | 0 : 1, p = e; p <= t; p += f) {
    var g = i.includes(p);
    (!g || !a) && d.push({
      label: bj(p, c),
      value: p,
      disabled: g
    });
  }
  return d;
}
function xj(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 ? arguments[2] : void 0, a = t || {}, i = a.use12Hours, c = a.hourStep, d = c === void 0 ? 1 : c, f = a.minuteStep, p = f === void 0 ? 1 : f, g = a.secondStep, b = g === void 0 ? 1 : g, w = a.millisecondStep, x = w === void 0 ? 100 : w, E = a.hideDisabledOptions, P = a.disabledTime, k = a.disabledHours, M = a.disabledMinutes, T = a.disabledSeconds, N = S.useMemo(function() {
    return r || e.getNow();
  }, [r, e]);
  if (process.env.NODE_ENV !== "production") {
    var D = 24 % d === 0, $ = 60 % p === 0, j = 60 % b === 0;
    $n(D, "`hourStep` ".concat(d, " is invalid. It should be a factor of 24.")), $n($, "`minuteStep` ".concat(p, " is invalid. It should be a factor of 60.")), $n(j, "`secondStep` ".concat(b, " is invalid. It should be a factor of 60."));
  }
  var I = S.useCallback(function(ee) {
    var ne = P?.(ee) || {};
    return [ne.disabledHours || k || X7, ne.disabledMinutes || M || X7, ne.disabledSeconds || T || X7, ne.disabledMilliseconds || X7];
  }, [P, k, M, T]), L = S.useMemo(function() {
    return I(N);
  }, [N, I]), F = qe(L, 4), _ = F[0], W = F[1], Q = F[2], U = F[3], Y = S.useCallback(function(ee, ne, ae, oe) {
    var fe = G7(0, 23, d, E, ee()), be = i ? fe.map(function(ze) {
      return ce(ce({}, ze), {}, {
        label: bj(ze.value % 12 || 12, 2)
      });
    }) : fe, me = function(le) {
      return G7(0, 59, p, E, ne(le));
    }, De = function(le, se) {
      return G7(0, 59, b, E, ae(le, se));
    }, Me = function(le, se, Ae) {
      return G7(0, 999, x, E, oe(le, se, Ae), 3);
    };
    return [be, me, De, Me];
  }, [E, d, i, x, p, b]), G = S.useMemo(function() {
    return Y(_, W, Q, U);
  }, [Y, _, W, Q, U]), J = qe(G, 4), H = J[0], K = J[1], X = J[2], te = J[3], ie = function(ne, ae) {
    var oe = function() {
      return H;
    }, fe = K, be = X, me = te;
    if (ae) {
      var De = I(ae), Me = qe(De, 4), ze = Me[0], le = Me[1], se = Me[2], Ae = Me[3], we = Y(ze, le, se, Ae), Ne = qe(we, 4), pe = Ne[0], Qe = Ne[1], Le = Ne[2], Te = Ne[3];
      oe = function() {
        return pe;
      }, fe = Qe, be = Le, me = Te;
    }
    var Oe = M1e(ne, oe, fe, be, me, e);
    return Oe;
  };
  return [
    // getValidTime
    ie,
    // Units
    H,
    K,
    X,
    te
  ];
}
function O1e(e) {
  var t = e.mode, r = e.internalMode, a = e.renderExtraFooter, i = e.showNow, c = e.showTime, d = e.onSubmit, f = e.onNow, p = e.invalid, g = e.needConfirm, b = e.generateConfig, w = e.disabledDate, x = S.useContext(K1), E = x.prefixCls, P = x.locale, k = x.button, M = k === void 0 ? "button" : k, T = b.getNow(), N = xj(b, c, T), D = qe(N, 1), $ = D[0], j = a?.(t), I = w(T, {
    type: t
  }), L = function() {
    if (!I) {
      var G = $(T);
      f(G);
    }
  }, F = "".concat(E, "-now"), _ = "".concat(F, "-btn"), W = i && /* @__PURE__ */ S.createElement("li", {
    className: F
  }, /* @__PURE__ */ S.createElement("a", {
    className: _e(_, I && "".concat(_, "-disabled")),
    "aria-disabled": I,
    onClick: L
  }, r === "date" ? P.today : P.now)), Q = g && /* @__PURE__ */ S.createElement("li", {
    className: "".concat(E, "-ok")
  }, /* @__PURE__ */ S.createElement(M, {
    disabled: p,
    onClick: d
  }, P.ok)), U = (W || Q) && /* @__PURE__ */ S.createElement("ul", {
    className: "".concat(E, "-ranges")
  }, W, Q);
  return !j && !U ? null : /* @__PURE__ */ S.createElement("div", {
    className: "".concat(E, "-footer")
  }, j && /* @__PURE__ */ S.createElement("div", {
    className: "".concat(E, "-footer-extra")
  }, j), U);
}
function EQ(e, t, r) {
  function a(i, c) {
    var d = i.findIndex(function(p) {
      return rm(e, t, p, c, r);
    });
    if (d === -1)
      return [].concat(Et(i), [c]);
    var f = Et(i);
    return f.splice(d, 1), f;
  }
  return a;
}
var g3 = /* @__PURE__ */ S.createContext(null);
function uM() {
  return S.useContext(g3);
}
function Kx(e, t) {
  var r = e.prefixCls, a = e.generateConfig, i = e.locale, c = e.disabledDate, d = e.minDate, f = e.maxDate, p = e.cellRender, g = e.hoverValue, b = e.hoverRangeValue, w = e.onHover, x = e.values, E = e.pickerValue, P = e.onSelect, k = e.prevIcon, M = e.nextIcon, T = e.superPrevIcon, N = e.superNextIcon, D = a.getNow(), $ = {
    now: D,
    values: x,
    pickerValue: E,
    prefixCls: r,
    disabledDate: c,
    minDate: d,
    maxDate: f,
    cellRender: p,
    hoverValue: g,
    hoverRangeValue: b,
    onHover: w,
    locale: i,
    generateConfig: a,
    onSelect: P,
    panelType: t,
    // Icons
    prevIcon: k,
    nextIcon: M,
    superPrevIcon: T,
    superNextIcon: N
  };
  return [$, D];
}
var iS = /* @__PURE__ */ S.createContext({});
process.env.NODE_ENV !== "production" && (iS.displayName = "PickerHackContext");
function o7(e) {
  for (var t = e.rowNum, r = e.colNum, a = e.baseDate, i = e.getCellDate, c = e.prefixColumn, d = e.rowClassName, f = e.titleFormat, p = e.getCellText, g = e.getCellClassName, b = e.headerCells, w = e.cellSelection, x = w === void 0 ? !0 : w, E = e.disabledDate, P = uM(), k = P.prefixCls, M = P.panelType, T = P.now, N = P.disabledDate, D = P.cellRender, $ = P.onHover, j = P.hoverValue, I = P.hoverRangeValue, L = P.generateConfig, F = P.values, _ = P.locale, W = P.onSelect, Q = E || N, U = "".concat(k, "-cell"), Y = S.useContext(iS), G = Y.onCellDblClick, J = function(ae) {
    return F.some(function(oe) {
      return oe && rm(L, _, ae, oe, M);
    });
  }, H = [], K = 0; K < t; K += 1) {
    for (var X = [], te = void 0, ie = function() {
      var ae = K * r + ee, oe = i(a, ae), fe = Q?.(oe, {
        type: M
      });
      ee === 0 && (te = oe, c && X.push(c(te)));
      var be = !1, me = !1, De = !1;
      if (x && I) {
        var Me = qe(I, 2), ze = Me[0], le = Me[1];
        be = sM(L, ze, le, oe), me = rm(L, _, oe, ze, M), De = rm(L, _, oe, le, M);
      }
      var se = f ? ld(oe, {
        locale: _,
        format: f,
        generateConfig: L
      }) : void 0, Ae = /* @__PURE__ */ S.createElement("div", {
        className: "".concat(U, "-inner")
      }, p(oe));
      X.push(/* @__PURE__ */ S.createElement("td", {
        key: ee,
        title: se,
        className: _e(U, ce(ge(ge(ge(ge(ge(ge({}, "".concat(U, "-disabled"), fe), "".concat(U, "-hover"), (j || []).some(function(we) {
          return rm(L, _, oe, we, M);
        })), "".concat(U, "-in-range"), be && !me && !De), "".concat(U, "-range-start"), me), "".concat(U, "-range-end"), De), "".concat(k, "-cell-selected"), !I && // WeekPicker use row instead
        M !== "week" && J(oe)), g(oe))),
        onClick: function() {
          fe || W(oe);
        },
        onDoubleClick: function() {
          !fe && G && G();
        },
        onMouseEnter: function() {
          fe || $?.(oe);
        },
        onMouseLeave: function() {
          fe || $?.(null);
        }
      }, D ? D(oe, {
        prefixCls: k,
        originNode: Ae,
        today: T,
        type: M,
        locale: _
      }) : Ae));
    }, ee = 0; ee < r; ee += 1)
      ie();
    H.push(/* @__PURE__ */ S.createElement("tr", {
      key: K,
      className: d?.(te)
    }, X));
  }
  return /* @__PURE__ */ S.createElement("div", {
    className: "".concat(k, "-body")
  }, /* @__PURE__ */ S.createElement("table", {
    className: "".concat(k, "-content")
  }, b && /* @__PURE__ */ S.createElement("thead", null, /* @__PURE__ */ S.createElement("tr", null, b)), /* @__PURE__ */ S.createElement("tbody", null, H)));
}
var q7 = {
  visibility: "hidden"
};
function Yx(e) {
  var t = e.offset, r = e.superOffset, a = e.onChange, i = e.getStart, c = e.getEnd, d = e.children, f = uM(), p = f.prefixCls, g = f.prevIcon, b = g === void 0 ? "‹" : g, w = f.nextIcon, x = w === void 0 ? "›" : w, E = f.superPrevIcon, P = E === void 0 ? "«" : E, k = f.superNextIcon, M = k === void 0 ? "»" : k, T = f.minDate, N = f.maxDate, D = f.generateConfig, $ = f.locale, j = f.pickerValue, I = f.panelType, L = "".concat(p, "-header"), F = S.useContext(iS), _ = F.hidePrev, W = F.hideNext, Q = F.hideHeader, U = S.useMemo(function() {
    if (!T || !t || !c)
      return !1;
    var ne = c(t(-1, j));
    return !B7(D, $, ne, T, I);
  }, [T, t, j, c, D, $, I]), Y = S.useMemo(function() {
    if (!T || !r || !c)
      return !1;
    var ne = c(r(-1, j));
    return !B7(D, $, ne, T, I);
  }, [T, r, j, c, D, $, I]), G = S.useMemo(function() {
    if (!N || !t || !i)
      return !1;
    var ne = i(t(1, j));
    return !B7(D, $, N, ne, I);
  }, [N, t, j, i, D, $, I]), J = S.useMemo(function() {
    if (!N || !r || !i)
      return !1;
    var ne = i(r(1, j));
    return !B7(D, $, N, ne, I);
  }, [N, r, j, i, D, $, I]), H = function(ae) {
    t && a(t(ae, j));
  }, K = function(ae) {
    r && a(r(ae, j));
  };
  if (Q)
    return null;
  var X = "".concat(L, "-prev-btn"), te = "".concat(L, "-next-btn"), ie = "".concat(L, "-super-prev-btn"), ee = "".concat(L, "-super-next-btn");
  return /* @__PURE__ */ S.createElement("div", {
    className: L
  }, r && /* @__PURE__ */ S.createElement("button", {
    type: "button",
    "aria-label": $.previousYear,
    onClick: function() {
      return K(-1);
    },
    tabIndex: -1,
    className: _e(ie, Y && "".concat(ie, "-disabled")),
    disabled: Y,
    style: _ ? q7 : {}
  }, P), t && /* @__PURE__ */ S.createElement("button", {
    type: "button",
    "aria-label": $.previousMonth,
    onClick: function() {
      return H(-1);
    },
    tabIndex: -1,
    className: _e(X, U && "".concat(X, "-disabled")),
    disabled: U,
    style: _ ? q7 : {}
  }, b), /* @__PURE__ */ S.createElement("div", {
    className: "".concat(L, "-view")
  }, d), t && /* @__PURE__ */ S.createElement("button", {
    type: "button",
    "aria-label": $.nextMonth,
    onClick: function() {
      return H(1);
    },
    tabIndex: -1,
    className: _e(te, G && "".concat(te, "-disabled")),
    disabled: G,
    style: W ? q7 : {}
  }, x), r && /* @__PURE__ */ S.createElement("button", {
    type: "button",
    "aria-label": $.nextYear,
    onClick: function() {
      return K(1);
    },
    tabIndex: -1,
    className: _e(ee, J && "".concat(ee, "-disabled")),
    disabled: J,
    style: W ? q7 : {}
  }, M));
}
function cM(e) {
  var t = e.prefixCls, r = e.panelName, a = r === void 0 ? "date" : r, i = e.locale, c = e.generateConfig, d = e.pickerValue, f = e.onPickerValueChange, p = e.onModeChange, g = e.mode, b = g === void 0 ? "date" : g, w = e.disabledDate, x = e.onSelect, E = e.onHover, P = e.showWeek, k = "".concat(t, "-").concat(a, "-panel"), M = "".concat(t, "-cell"), T = b === "week", N = Kx(e, b), D = qe(N, 2), $ = D[0], j = D[1], I = c.locale.getWeekFirstDay(i.locale), L = c.setDate(d, 1), F = b1e(i.locale, c, L), _ = c.getMonth(d), W = P === void 0 ? T : P, Q = W ? function(ne) {
    var ae = w?.(ne, {
      type: "week"
    });
    return /* @__PURE__ */ S.createElement("td", {
      key: "week",
      className: _e(M, "".concat(M, "-week"), ge({}, "".concat(M, "-disabled"), ae)),
      onClick: function() {
        ae || x(ne);
      },
      onMouseEnter: function() {
        ae || E?.(ne);
      },
      onMouseLeave: function() {
        ae || E?.(null);
      }
    }, /* @__PURE__ */ S.createElement("div", {
      className: "".concat(M, "-inner")
    }, c.locale.getWeek(i.locale, ne)));
  } : null, U = [], Y = i.shortWeekDays || (c.locale.getShortWeekDays ? c.locale.getShortWeekDays(i.locale) : []);
  Q && U.push(/* @__PURE__ */ S.createElement("th", {
    key: "empty"
  }, /* @__PURE__ */ S.createElement("span", {
    style: {
      width: 0,
      height: 0,
      position: "absolute",
      overflow: "hidden",
      opacity: 0
    }
  }, i.week)));
  for (var G = 0; G < cR; G += 1)
    U.push(/* @__PURE__ */ S.createElement("th", {
      key: G
    }, Y[(G + I) % cR]));
  var J = function(ae, oe) {
    return c.addDate(ae, oe);
  }, H = function(ae) {
    return ld(ae, {
      locale: i,
      format: i.cellDateFormat,
      generateConfig: c
    });
  }, K = function(ae) {
    var oe = ge(ge({}, "".concat(t, "-cell-in-view"), wj(c, ae, d)), "".concat(t, "-cell-today"), Sj(c, ae, j));
    return oe;
  }, X = i.shortMonths || (c.locale.getShortMonths ? c.locale.getShortMonths(i.locale) : []), te = /* @__PURE__ */ S.createElement("button", {
    type: "button",
    "aria-label": i.yearSelect,
    key: "year",
    onClick: function() {
      p("year", d);
    },
    tabIndex: -1,
    className: "".concat(t, "-year-btn")
  }, ld(d, {
    locale: i,
    format: i.yearFormat,
    generateConfig: c
  })), ie = /* @__PURE__ */ S.createElement("button", {
    type: "button",
    "aria-label": i.monthSelect,
    key: "month",
    onClick: function() {
      p("month", d);
    },
    tabIndex: -1,
    className: "".concat(t, "-month-btn")
  }, i.monthFormat ? ld(d, {
    locale: i,
    format: i.monthFormat,
    generateConfig: c
  }) : X[_]), ee = i.monthBeforeYear ? [ie, te] : [te, ie];
  return /* @__PURE__ */ S.createElement(g3.Provider, {
    value: $
  }, /* @__PURE__ */ S.createElement("div", {
    className: _e(k, P && "".concat(k, "-show-week"))
  }, /* @__PURE__ */ S.createElement(Yx, {
    offset: function(ae) {
      return c.addMonth(d, ae);
    },
    superOffset: function(ae) {
      return c.addYear(d, ae);
    },
    onChange: f,
    getStart: function(ae) {
      return c.setDate(ae, 1);
    },
    getEnd: function(ae) {
      var oe = c.setDate(ae, 1);
      return oe = c.addMonth(oe, 1), c.addDate(oe, -1);
    }
  }, ee), /* @__PURE__ */ S.createElement(o7, vt({
    titleFormat: i.fieldDateFormat
  }, e, {
    colNum: cR,
    rowNum: 6,
    baseDate: F,
    headerCells: U,
    getCellDate: J,
    getCellText: H,
    getCellClassName: K,
    prefixColumn: Q,
    cellSelection: !T
  }))));
}
var T1e = 1 / 3;
function R1e(e, t) {
  var r = S.useRef(!1), a = S.useRef(null), i = S.useRef(null), c = function() {
    return r.current;
  }, d = function() {
    Pa.cancel(a.current), r.current = !1;
  }, f = S.useRef(), p = function() {
    var w = e.current;
    if (i.current = null, f.current = 0, w) {
      var x = w.querySelector('[data-value="'.concat(t, '"]')), E = w.querySelector("li"), P = function k() {
        d(), r.current = !0, f.current += 1;
        var M = w.scrollTop, T = E.offsetTop, N = x.offsetTop, D = N - T;
        if (N === 0 && x !== E || !BE(w)) {
          f.current <= 5 && (a.current = Pa(k));
          return;
        }
        var $ = M + (D - M) * T1e, j = Math.abs(D - $);
        if (i.current !== null && i.current < j) {
          d();
          return;
        }
        if (i.current = j, j <= 1) {
          w.scrollTop = D, d();
          return;
        }
        w.scrollTop = $, a.current = Pa(k);
      };
      x && E && P();
    }
  }, g = ra(p);
  return [g, d, c];
}
var A1e = 300;
function N1e(e) {
  return e.map(function(t) {
    var r = t.value, a = t.label, i = t.disabled;
    return [r, a, i].join(",");
  }).join(";");
}
function T5(e) {
  var t = e.units, r = e.value, a = e.optionalValue, i = e.type, c = e.onChange, d = e.onHover, f = e.onDblClick, p = e.changeOnScroll, g = uM(), b = g.prefixCls, w = g.cellRender, x = g.now, E = g.locale, P = "".concat(b, "-time-panel"), k = "".concat(b, "-time-panel-cell"), M = S.useRef(null), T = S.useRef(), N = function() {
    clearTimeout(T.current);
  }, D = R1e(M, r ?? a), $ = qe(D, 3), j = $[0], I = $[1], L = $[2];
  Da(function() {
    return j(), N(), function() {
      I(), N();
    };
  }, [r, a, N1e(t)]);
  var F = function(Q) {
    N();
    var U = Q.target;
    !L() && p && (T.current = setTimeout(function() {
      var Y = M.current, G = Y.querySelector("li").offsetTop, J = Array.from(Y.querySelectorAll("li")), H = J.map(function(ee) {
        return ee.offsetTop - G;
      }), K = H.map(function(ee, ne) {
        return t[ne].disabled ? Number.MAX_SAFE_INTEGER : Math.abs(ee - U.scrollTop);
      }), X = Math.min.apply(Math, Et(K)), te = K.findIndex(function(ee) {
        return ee === X;
      }), ie = t[te];
      ie && !ie.disabled && c(ie.value);
    }, A1e));
  }, _ = "".concat(P, "-column");
  return /* @__PURE__ */ S.createElement("ul", {
    className: _,
    ref: M,
    "data-type": i,
    onScroll: F
  }, t.map(function(W) {
    var Q = W.label, U = W.value, Y = W.disabled, G = /* @__PURE__ */ S.createElement("div", {
      className: "".concat(k, "-inner")
    }, Q);
    return /* @__PURE__ */ S.createElement("li", {
      key: U,
      className: _e(k, ge(ge({}, "".concat(k, "-selected"), r === U), "".concat(k, "-disabled"), Y)),
      onClick: function() {
        Y || c(U);
      },
      onDoubleClick: function() {
        !Y && f && f();
      },
      onMouseEnter: function() {
        d(U);
      },
      onMouseLeave: function() {
        d(null);
      },
      "data-value": U
    }, w ? w(U, {
      prefixCls: b,
      originNode: G,
      today: x,
      type: "time",
      subType: i,
      locale: E
    }) : G);
  }));
}
function wS(e) {
  return e < 12;
}
function D1e(e) {
  var t = e.showHour, r = e.showMinute, a = e.showSecond, i = e.showMillisecond, c = e.use12Hours, d = e.changeOnScroll, f = uM(), p = f.prefixCls, g = f.values, b = f.generateConfig, w = f.locale, x = f.onSelect, E = f.onHover, P = E === void 0 ? function() {
  } : E, k = f.pickerValue, M = g?.[0] || null, T = S.useContext(iS), N = T.onCellDblClick, D = xj(b, e, M), $ = qe(D, 5), j = $[0], I = $[1], L = $[2], F = $[3], _ = $[4], W = function(ft) {
    var st = M && b[ft](M), pt = k && b[ft](k);
    return [st, pt];
  }, Q = W("getHour"), U = qe(Q, 2), Y = U[0], G = U[1], J = W("getMinute"), H = qe(J, 2), K = H[0], X = H[1], te = W("getSecond"), ie = qe(te, 2), ee = ie[0], ne = ie[1], ae = W("getMillisecond"), oe = qe(ae, 2), fe = oe[0], be = oe[1], me = Y === null ? null : wS(Y) ? "am" : "pm", De = S.useMemo(function() {
    return c ? wS(Y) ? I.filter(function(at) {
      return wS(at.value);
    }) : I.filter(function(at) {
      return !wS(at.value);
    }) : I;
  }, [Y, I, c]), Me = function(ft, st) {
    var pt, bt = ft.filter(function(Nt) {
      return !Nt.disabled;
    });
    return st ?? // Fallback to enabled value
    (bt == null || (pt = bt[0]) === null || pt === void 0 ? void 0 : pt.value);
  }, ze = Me(I, Y), le = S.useMemo(function() {
    return L(ze);
  }, [L, ze]), se = Me(le, K), Ae = S.useMemo(function() {
    return F(ze, se);
  }, [F, ze, se]), we = Me(Ae, ee), Ne = S.useMemo(function() {
    return _(ze, se, we);
  }, [_, ze, se, we]), pe = Me(Ne, fe), Qe = S.useMemo(function() {
    if (!c)
      return [];
    var at = b.getNow(), ft = b.setHour(at, 6), st = b.setHour(at, 18), pt = function(Nt, $t) {
      var Pt = w.cellMeridiemFormat;
      return Pt ? ld(Nt, {
        generateConfig: b,
        locale: w,
        format: Pt
      }) : $t;
    };
    return [{
      label: pt(ft, "AM"),
      value: "am",
      disabled: I.every(function(bt) {
        return bt.disabled || !wS(bt.value);
      })
    }, {
      label: pt(st, "PM"),
      value: "pm",
      disabled: I.every(function(bt) {
        return bt.disabled || wS(bt.value);
      })
    }];
  }, [I, c, b, w]), Le = function(ft) {
    var st = j(ft);
    x(st);
  }, Te = S.useMemo(function() {
    var at = M || k || b.getNow(), ft = function(pt) {
      return pt != null;
    };
    return ft(Y) ? (at = b.setHour(at, Y), at = b.setMinute(at, K), at = b.setSecond(at, ee), at = b.setMillisecond(at, fe)) : ft(G) ? (at = b.setHour(at, G), at = b.setMinute(at, X), at = b.setSecond(at, ne), at = b.setMillisecond(at, be)) : ft(ze) && (at = b.setHour(at, ze), at = b.setMinute(at, se), at = b.setSecond(at, we), at = b.setMillisecond(at, pe)), at;
  }, [M, k, Y, K, ee, fe, ze, se, we, pe, G, X, ne, be, b]), Oe = function(ft, st) {
    return ft === null ? null : b[st](Te, ft);
  }, ye = function(ft) {
    return Oe(ft, "setHour");
  }, je = function(ft) {
    return Oe(ft, "setMinute");
  }, Ue = function(ft) {
    return Oe(ft, "setSecond");
  }, Fe = function(ft) {
    return Oe(ft, "setMillisecond");
  }, tt = function(ft) {
    return ft === null ? null : ft === "am" && !wS(Y) ? b.setHour(Te, Y - 12) : ft === "pm" && wS(Y) ? b.setHour(Te, Y + 12) : Te;
  }, dt = function(ft) {
    Le(ye(ft));
  }, St = function(ft) {
    Le(je(ft));
  }, mt = function(ft) {
    Le(Ue(ft));
  }, Ot = function(ft) {
    Le(Fe(ft));
  }, Rt = function(ft) {
    Le(tt(ft));
  }, ct = function(ft) {
    P(ye(ft));
  }, it = function(ft) {
    P(je(ft));
  }, Ct = function(ft) {
    P(Ue(ft));
  }, ut = function(ft) {
    P(Fe(ft));
  }, ht = function(ft) {
    P(tt(ft));
  }, ot = {
    onDblClick: N,
    changeOnScroll: d
  };
  return /* @__PURE__ */ S.createElement("div", {
    className: "".concat(p, "-content")
  }, t && /* @__PURE__ */ S.createElement(T5, vt({
    units: De,
    value: Y,
    optionalValue: G,
    type: "hour",
    onChange: dt,
    onHover: ct
  }, ot)), r && /* @__PURE__ */ S.createElement(T5, vt({
    units: le,
    value: K,
    optionalValue: X,
    type: "minute",
    onChange: St,
    onHover: it
  }, ot)), a && /* @__PURE__ */ S.createElement(T5, vt({
    units: Ae,
    value: ee,
    optionalValue: ne,
    type: "second",
    onChange: mt,
    onHover: Ct
  }, ot)), i && /* @__PURE__ */ S.createElement(T5, vt({
    units: Ne,
    value: fe,
    optionalValue: be,
    type: "millisecond",
    onChange: Ot,
    onHover: ut
  }, ot)), c && /* @__PURE__ */ S.createElement(T5, vt({
    units: Qe,
    value: me,
    type: "meridiem",
    onChange: Rt,
    onHover: ht
  }, ot)));
}
function PQ(e) {
  var t = e.prefixCls, r = e.value, a = e.locale, i = e.generateConfig, c = e.showTime, d = c || {}, f = d.format, p = "".concat(t, "-time-panel"), g = Kx(e, "time"), b = qe(g, 1), w = b[0];
  return /* @__PURE__ */ S.createElement(g3.Provider, {
    value: w
  }, /* @__PURE__ */ S.createElement("div", {
    className: _e(p)
  }, /* @__PURE__ */ S.createElement(Yx, null, r ? ld(r, {
    locale: a,
    format: f,
    generateConfig: i
  }) : " "), /* @__PURE__ */ S.createElement(D1e, c)));
}
function $1e(e) {
  var t = e.prefixCls, r = e.generateConfig, a = e.showTime, i = e.onSelect, c = e.value, d = e.pickerValue, f = e.onHover, p = "".concat(t, "-datetime-panel"), g = xj(r, a), b = qe(g, 1), w = b[0], x = function(M) {
    return c ? Qk(r, M, c) : Qk(r, M, d);
  }, E = function(M) {
    f?.(M && x(M));
  }, P = function(M) {
    var T = x(M);
    i(w(T, T));
  };
  return /* @__PURE__ */ S.createElement("div", {
    className: p
  }, /* @__PURE__ */ S.createElement(cM, vt({}, e, {
    onSelect: P,
    onHover: E
  })), /* @__PURE__ */ S.createElement(PQ, e));
}
function z1e(e) {
  var t = e.prefixCls, r = e.locale, a = e.generateConfig, i = e.pickerValue, c = e.disabledDate, d = e.onPickerValueChange, f = "".concat(t, "-decade-panel"), p = Kx(e, "decade"), g = qe(p, 1), b = g[0], w = function(I) {
    var L = Math.floor(a.getYear(I) / 100) * 100;
    return a.setYear(I, L);
  }, x = function(I) {
    var L = w(I);
    return a.addYear(L, 99);
  }, E = w(i), P = x(i), k = a.addYear(E, -10), M = function(I, L) {
    return a.addYear(I, L * 10);
  }, T = function(I) {
    var L = r.cellYearFormat, F = ld(I, {
      locale: r,
      format: L,
      generateConfig: a
    }), _ = ld(a.addYear(I, 9), {
      locale: r,
      format: L,
      generateConfig: a
    });
    return "".concat(F, "-").concat(_);
  }, N = function(I) {
    return ge({}, "".concat(t, "-cell-in-view"), FD(a, I, E) || FD(a, I, P) || sM(a, E, P, I));
  }, D = c ? function(j, I) {
    var L = a.setDate(j, 1), F = a.setMonth(L, 0), _ = a.setYear(F, Math.floor(a.getYear(F) / 10) * 10), W = a.addYear(_, 10), Q = a.addDate(W, -1);
    return c(_, I) && c(Q, I);
  } : null, $ = "".concat(ld(E, {
    locale: r,
    format: r.yearFormat,
    generateConfig: a
  }), "-").concat(ld(P, {
    locale: r,
    format: r.yearFormat,
    generateConfig: a
  }));
  return /* @__PURE__ */ S.createElement(g3.Provider, {
    value: b
  }, /* @__PURE__ */ S.createElement("div", {
    className: f
  }, /* @__PURE__ */ S.createElement(Yx, {
    superOffset: function(I) {
      return a.addYear(i, I * 100);
    },
    onChange: d,
    getStart: w,
    getEnd: x
  }, $), /* @__PURE__ */ S.createElement(o7, vt({}, e, {
    disabledDate: D,
    colNum: 3,
    rowNum: 4,
    baseDate: k,
    getCellDate: M,
    getCellText: T,
    getCellClassName: N
  }))));
}
function j1e(e) {
  var t = e.prefixCls, r = e.locale, a = e.generateConfig, i = e.pickerValue, c = e.disabledDate, d = e.onPickerValueChange, f = e.onModeChange, p = "".concat(t, "-month-panel"), g = Kx(e, "month"), b = qe(g, 1), w = b[0], x = a.setMonth(i, 0), E = r.shortMonths || (a.locale.getShortMonths ? a.locale.getShortMonths(r.locale) : []), P = function($, j) {
    return a.addMonth($, j);
  }, k = function($) {
    var j = a.getMonth($);
    return r.monthFormat ? ld($, {
      locale: r,
      format: r.monthFormat,
      generateConfig: a
    }) : E[j];
  }, M = function() {
    return ge({}, "".concat(t, "-cell-in-view"), !0);
  }, T = c ? function(D, $) {
    var j = a.setDate(D, 1), I = a.setMonth(j, a.getMonth(j) + 1), L = a.addDate(I, -1);
    return c(j, $) && c(L, $);
  } : null, N = /* @__PURE__ */ S.createElement("button", {
    type: "button",
    key: "year",
    "aria-label": r.yearSelect,
    onClick: function() {
      f("year");
    },
    tabIndex: -1,
    className: "".concat(t, "-year-btn")
  }, ld(i, {
    locale: r,
    format: r.yearFormat,
    generateConfig: a
  }));
  return /* @__PURE__ */ S.createElement(g3.Provider, {
    value: w
  }, /* @__PURE__ */ S.createElement("div", {
    className: p
  }, /* @__PURE__ */ S.createElement(Yx, {
    superOffset: function($) {
      return a.addYear(i, $);
    },
    onChange: d,
    getStart: function($) {
      return a.setMonth($, 0);
    },
    getEnd: function($) {
      return a.setMonth($, 11);
    }
  }, N), /* @__PURE__ */ S.createElement(o7, vt({}, e, {
    disabledDate: T,
    titleFormat: r.fieldMonthFormat,
    colNum: 3,
    rowNum: 4,
    baseDate: x,
    getCellDate: P,
    getCellText: k,
    getCellClassName: M
  }))));
}
function I1e(e) {
  var t = e.prefixCls, r = e.locale, a = e.generateConfig, i = e.pickerValue, c = e.onPickerValueChange, d = e.onModeChange, f = "".concat(t, "-quarter-panel"), p = Kx(e, "quarter"), g = qe(p, 1), b = g[0], w = a.setMonth(i, 0), x = function(T, N) {
    return a.addMonth(T, N * 3);
  }, E = function(T) {
    return ld(T, {
      locale: r,
      format: r.cellQuarterFormat,
      generateConfig: a
    });
  }, P = function() {
    return ge({}, "".concat(t, "-cell-in-view"), !0);
  }, k = /* @__PURE__ */ S.createElement("button", {
    type: "button",
    key: "year",
    "aria-label": r.yearSelect,
    onClick: function() {
      d("year");
    },
    tabIndex: -1,
    className: "".concat(t, "-year-btn")
  }, ld(i, {
    locale: r,
    format: r.yearFormat,
    generateConfig: a
  }));
  return /* @__PURE__ */ S.createElement(g3.Provider, {
    value: b
  }, /* @__PURE__ */ S.createElement("div", {
    className: f
  }, /* @__PURE__ */ S.createElement(Yx, {
    superOffset: function(T) {
      return a.addYear(i, T);
    },
    onChange: c,
    getStart: function(T) {
      return a.setMonth(T, 0);
    },
    getEnd: function(T) {
      return a.setMonth(T, 11);
    }
  }, k), /* @__PURE__ */ S.createElement(o7, vt({}, e, {
    titleFormat: r.fieldQuarterFormat,
    colNum: 4,
    rowNum: 1,
    baseDate: w,
    getCellDate: x,
    getCellText: E,
    getCellClassName: P
  }))));
}
function L1e(e) {
  var t = e.prefixCls, r = e.generateConfig, a = e.locale, i = e.value, c = e.hoverValue, d = e.hoverRangeValue, f = a.locale, p = "".concat(t, "-week-panel-row"), g = function(w) {
    var x = {};
    if (d) {
      var E = qe(d, 2), P = E[0], k = E[1], M = oE(r, f, P, w), T = oE(r, f, k, w);
      x["".concat(p, "-range-start")] = M, x["".concat(p, "-range-end")] = T, x["".concat(p, "-range-hover")] = !M && !T && sM(r, P, k, w);
    }
    return c && (x["".concat(p, "-hover")] = c.some(function(N) {
      return oE(r, f, w, N);
    })), _e(
      p,
      ge({}, "".concat(p, "-selected"), !d && oE(r, f, i, w)),
      // Patch for hover range
      x
    );
  };
  return /* @__PURE__ */ S.createElement(cM, vt({}, e, {
    mode: "week",
    panelName: "week",
    rowClassName: g
  }));
}
function H1e(e) {
  var t = e.prefixCls, r = e.locale, a = e.generateConfig, i = e.pickerValue, c = e.disabledDate, d = e.onPickerValueChange, f = e.onModeChange, p = "".concat(t, "-year-panel"), g = Kx(e, "year"), b = qe(g, 1), w = b[0], x = function(L) {
    var F = Math.floor(a.getYear(L) / 10) * 10;
    return a.setYear(L, F);
  }, E = function(L) {
    var F = x(L);
    return a.addYear(F, 9);
  }, P = x(i), k = E(i), M = a.addYear(P, -1), T = function(L, F) {
    return a.addYear(L, F);
  }, N = function(L) {
    return ld(L, {
      locale: r,
      format: r.cellYearFormat,
      generateConfig: a
    });
  }, D = function(L) {
    return ge({}, "".concat(t, "-cell-in-view"), e3(a, L, P) || e3(a, L, k) || sM(a, P, k, L));
  }, $ = c ? function(I, L) {
    var F = a.setMonth(I, 0), _ = a.setDate(F, 1), W = a.addYear(_, 1), Q = a.addDate(W, -1);
    return c(_, L) && c(Q, L);
  } : null, j = /* @__PURE__ */ S.createElement("button", {
    type: "button",
    key: "decade",
    "aria-label": r.decadeSelect,
    onClick: function() {
      f("decade");
    },
    tabIndex: -1,
    className: "".concat(t, "-decade-btn")
  }, ld(P, {
    locale: r,
    format: r.yearFormat,
    generateConfig: a
  }), "-", ld(k, {
    locale: r,
    format: r.yearFormat,
    generateConfig: a
  }));
  return /* @__PURE__ */ S.createElement(g3.Provider, {
    value: w
  }, /* @__PURE__ */ S.createElement("div", {
    className: p
  }, /* @__PURE__ */ S.createElement(Yx, {
    superOffset: function(L) {
      return a.addYear(i, L * 10);
    },
    onChange: d,
    getStart: x,
    getEnd: E
  }, j), /* @__PURE__ */ S.createElement(o7, vt({}, e, {
    disabledDate: $,
    titleFormat: r.fieldYearFormat,
    colNum: 3,
    rowNum: 4,
    baseDate: M,
    getCellDate: T,
    getCellText: N,
    getCellClassName: D
  }))));
}
var F1e = {
  date: cM,
  datetime: $1e,
  week: L1e,
  month: j1e,
  quarter: I1e,
  year: H1e,
  decade: z1e,
  time: PQ
};
function W1e(e, t) {
  var r, a = e.locale, i = e.generateConfig, c = e.direction, d = e.prefixCls, f = e.tabIndex, p = f === void 0 ? 0 : f, g = e.multiple, b = e.defaultValue, w = e.value, x = e.onChange, E = e.onSelect, P = e.defaultPickerValue, k = e.pickerValue, M = e.onPickerValueChange, T = e.mode, N = e.onPanelChange, D = e.picker, $ = D === void 0 ? "date" : D, j = e.showTime, I = e.hoverValue, L = e.hoverRangeValue, F = e.cellRender, _ = e.dateRender, W = e.monthCellRender, Q = e.components, U = Q === void 0 ? {} : Q, Y = e.hideHeader, G = ((r = S.useContext(K1)) === null || r === void 0 ? void 0 : r.prefixCls) || d || "rc-picker", J = S.useRef();
  S.useImperativeHandle(t, function() {
    return {
      nativeElement: J.current
    };
  });
  var H = sQ(e), K = qe(H, 4), X = K[0], te = K[1], ie = K[2], ee = K[3], ne = oQ(a, te), ae = $ === "date" && j ? "datetime" : $, oe = S.useMemo(function() {
    return uQ(ae, ie, ee, X, ne);
  }, [ae, ie, ee, X, ne]), fe = i.getNow(), be = ll($, {
    value: T,
    postState: function(ht) {
      return ht || "date";
    }
  }), me = qe(be, 2), De = me[0], Me = me[1], ze = De === "date" && oe ? "datetime" : De, le = EQ(i, a, ae), se = ll(b, {
    value: w
  }), Ae = qe(se, 2), we = Ae[0], Ne = Ae[1], pe = S.useMemo(function() {
    var ut = p3(we).filter(function(ht) {
      return ht;
    });
    return g ? ut : ut.slice(0, 1);
  }, [we, g]), Qe = ra(function(ut) {
    Ne(ut), x && (ut === null || pe.length !== ut.length || pe.some(function(ht, ot) {
      return !rm(i, a, ht, ut[ot], ae);
    })) && x?.(g ? ut : ut[0]);
  }), Le = ra(function(ut) {
    if (E?.(ut), De === $) {
      var ht = g ? le(pe, ut) : [ut];
      Qe(ht);
    }
  }), Te = ll(P || pe[0] || fe, {
    value: k
  }), Oe = qe(Te, 2), ye = Oe[0], je = Oe[1];
  S.useEffect(function() {
    pe[0] && !k && je(pe[0]);
  }, [pe[0]]);
  var Ue = function(ht, ot) {
    N?.(ht || k, ot || De);
  }, Fe = function(ht) {
    var ot = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    je(ht), M?.(ht), ot && Ue(ht);
  }, tt = function(ht, ot) {
    Me(ht), ot && Fe(ot), Ue(ot, ht);
  }, dt = function(ht) {
    if (Le(ht), Fe(ht), De !== $) {
      var ot = ["decade", "year"], at = [].concat(ot, ["month"]), ft = {
        quarter: [].concat(ot, ["quarter"]),
        week: [].concat(Et(at), ["week"]),
        date: [].concat(Et(at), ["date"])
      }, st = ft[$] || at, pt = st.indexOf(De), bt = st[pt + 1];
      bt && tt(bt, ht);
    }
  }, St = S.useMemo(function() {
    var ut, ht;
    if (Array.isArray(L)) {
      var ot = qe(L, 2);
      ut = ot[0], ht = ot[1];
    } else
      ut = L;
    return !ut && !ht ? null : (ut = ut || ht, ht = ht || ut, i.isAfter(ut, ht) ? [ht, ut] : [ut, ht]);
  }, [L, i]), mt = yj(F, _, W), Ot = U[ze] || F1e[ze] || cM, Rt = S.useContext(iS), ct = S.useMemo(function() {
    return ce(ce({}, Rt), {}, {
      hideHeader: Y
    });
  }, [Rt, Y]);
  process.env.NODE_ENV !== "production" && $n(!pe || pe.every(function(ut) {
    return i.isValidate(ut);
  }), "Invalidate date pass to `value` or `defaultValue`.");
  var it = "".concat(G, "-panel"), Ct = lM(e, [
    // Week
    "showWeek",
    // Icons
    "prevIcon",
    "nextIcon",
    "superPrevIcon",
    "superNextIcon",
    // Disabled
    "disabledDate",
    "minDate",
    "maxDate",
    // Hover
    "onHover"
  ]);
  return /* @__PURE__ */ S.createElement(iS.Provider, {
    value: ct
  }, /* @__PURE__ */ S.createElement("div", {
    ref: J,
    tabIndex: p,
    className: _e(it, ge({}, "".concat(it, "-rtl"), c === "rtl"))
  }, /* @__PURE__ */ S.createElement(Ot, vt({}, Ct, {
    // Time
    showTime: oe,
    prefixCls: G,
    locale: ne,
    generateConfig: i,
    onModeChange: tt,
    pickerValue: ye,
    onPickerValueChange: function(ht) {
      Fe(ht, !0);
    },
    value: pe[0],
    onSelect: dt,
    values: pe,
    cellRender: mt,
    hoverRangeValue: St,
    hoverValue: I
  }))));
}
var fk = /* @__PURE__ */ S.memo(/* @__PURE__ */ S.forwardRef(W1e));
process.env.NODE_ENV !== "production" && (fk.displayName = "PanelPicker");
function V1e(e) {
  var t = e.picker, r = e.multiplePanel, a = e.pickerValue, i = e.onPickerValueChange, c = e.needConfirm, d = e.onSubmit, f = e.range, p = e.hoverValue, g = S.useContext(K1), b = g.prefixCls, w = g.generateConfig, x = S.useCallback(function(N, D) {
    return iE(w, t, N, D);
  }, [w, t]), E = S.useMemo(function() {
    return x(a, 1);
  }, [a, x]), P = function(D) {
    i(x(D, -1));
  }, k = {
    onCellDblClick: function() {
      c && d();
    }
  }, M = t === "time", T = ce(ce({}, e), {}, {
    hoverValue: null,
    hoverRangeValue: null,
    hideHeader: M
  });
  return f ? T.hoverRangeValue = p : T.hoverValue = p, r ? /* @__PURE__ */ S.createElement("div", {
    className: "".concat(b, "-panels")
  }, /* @__PURE__ */ S.createElement(iS.Provider, {
    value: ce(ce({}, k), {}, {
      hideNext: !0
    })
  }, /* @__PURE__ */ S.createElement(fk, T)), /* @__PURE__ */ S.createElement(iS.Provider, {
    value: ce(ce({}, k), {}, {
      hidePrev: !0
    })
  }, /* @__PURE__ */ S.createElement(fk, vt({}, T, {
    pickerValue: E,
    onPickerValueChange: P
  })))) : /* @__PURE__ */ S.createElement(iS.Provider, {
    value: ce({}, k)
  }, /* @__PURE__ */ S.createElement(fk, T));
}
function mW(e) {
  return typeof e == "function" ? e() : e;
}
function _1e(e) {
  var t = e.prefixCls, r = e.presets, a = e.onClick, i = e.onHover;
  return r.length ? /* @__PURE__ */ S.createElement("div", {
    className: "".concat(t, "-presets")
  }, /* @__PURE__ */ S.createElement("ul", null, r.map(function(c, d) {
    var f = c.label, p = c.value;
    return /* @__PURE__ */ S.createElement("li", {
      key: d,
      onClick: function() {
        a(mW(p));
      },
      onMouseEnter: function() {
        i(mW(p));
      },
      onMouseLeave: function() {
        i(null);
      }
    }, f);
  }))) : null;
}
function kQ(e) {
  var t = e.panelRender, r = e.internalMode, a = e.picker, i = e.showNow, c = e.range, d = e.multiple, f = e.activeInfo, p = f === void 0 ? [0, 0, 0] : f, g = e.presets, b = e.onPresetHover, w = e.onPresetSubmit, x = e.onFocus, E = e.onBlur, P = e.onPanelMouseDown, k = e.direction, M = e.value, T = e.onSelect, N = e.isInvalid, D = e.defaultOpenValue, $ = e.onOk, j = e.onSubmit, I = S.useContext(K1), L = I.prefixCls, F = "".concat(L, "-panel"), _ = k === "rtl", W = S.useRef(null), Q = S.useRef(null), U = S.useState(0), Y = qe(U, 2), G = Y[0], J = Y[1], H = S.useState(0), K = qe(H, 2), X = K[0], te = K[1], ie = S.useState(0), ee = qe(ie, 2), ne = ee[0], ae = ee[1], oe = function(dt) {
    dt.width && J(dt.width);
  }, fe = qe(p, 3), be = fe[0], me = fe[1], De = fe[2], Me = S.useState(0), ze = qe(Me, 2), le = ze[0], se = ze[1];
  S.useEffect(function() {
    se(10);
  }, [be]), S.useEffect(function() {
    if (c && Q.current) {
      var tt, dt = ((tt = W.current) === null || tt === void 0 ? void 0 : tt.offsetWidth) || 0, St = Q.current.getBoundingClientRect();
      if (!St.height || St.right < 0) {
        se(function(ct) {
          return Math.max(0, ct - 1);
        });
        return;
      }
      var mt = (_ ? me - dt : be) - St.left;
      if (ae(mt), G && G < De) {
        var Ot = _ ? St.right - (me - dt + G) : be + dt - St.left - G, Rt = Math.max(0, Ot);
        te(Rt);
      } else
        te(0);
    }
  }, [le, _, G, be, me, De, c]);
  function Ae(tt) {
    return tt.filter(function(dt) {
      return dt;
    });
  }
  var we = S.useMemo(function() {
    return Ae(p3(M));
  }, [M]), Ne = a === "time" && !we.length, pe = S.useMemo(function() {
    return Ne ? Ae([D]) : we;
  }, [Ne, we, D]), Qe = Ne ? D : we, Le = S.useMemo(function() {
    return pe.length ? pe.some(function(tt) {
      return N(tt);
    }) : !0;
  }, [pe, N]), Te = function() {
    Ne && T(D), $(), j();
  }, Oe = /* @__PURE__ */ S.createElement("div", {
    className: "".concat(L, "-panel-layout")
  }, /* @__PURE__ */ S.createElement(_1e, {
    prefixCls: L,
    presets: g,
    onClick: w,
    onHover: b
  }), /* @__PURE__ */ S.createElement("div", null, /* @__PURE__ */ S.createElement(V1e, vt({}, e, {
    value: Qe
  })), /* @__PURE__ */ S.createElement(O1e, vt({}, e, {
    showNow: d ? !1 : i,
    invalid: Le,
    onSubmit: Te
  }))));
  t && (Oe = t(Oe));
  var ye = "".concat(F, "-container"), je = "marginLeft", Ue = "marginRight", Fe = /* @__PURE__ */ S.createElement("div", {
    onMouseDown: P,
    tabIndex: -1,
    className: _e(
      ye,
      // Used for Today Button style, safe to remove if no need
      "".concat(L, "-").concat(r, "-panel-container")
    ),
    style: ge(ge({}, _ ? Ue : je, X), _ ? je : Ue, "auto"),
    onFocus: x,
    onBlur: E
  }, Oe);
  return c && (Fe = /* @__PURE__ */ S.createElement("div", {
    onMouseDown: P,
    ref: Q,
    className: _e("".concat(L, "-range-wrapper"), "".concat(L, "-").concat(a, "-range-wrapper"))
  }, /* @__PURE__ */ S.createElement("div", {
    ref: W,
    className: "".concat(L, "-range-arrow"),
    style: {
      left: ne
    }
  }), /* @__PURE__ */ S.createElement(hp, {
    onResize: oe
  }, Fe))), Fe;
}
function MQ(e, t) {
  var r = e.format, a = e.maskFormat, i = e.generateConfig, c = e.locale, d = e.preserveInvalidOnBlur, f = e.inputReadOnly, p = e.required, g = e["aria-required"], b = e.onSubmit, w = e.onFocus, x = e.onBlur, E = e.onInputChange, P = e.onInvalid, k = e.open, M = e.onOpenChange, T = e.onKeyDown, N = e.onChange, D = e.activeHelp, $ = e.name, j = e.autoComplete, I = e.id, L = e.value, F = e.invalid, _ = e.placeholder, W = e.disabled, Q = e.activeIndex, U = e.allHelp, Y = e.picker, G = function(ne, ae) {
    var oe = i.locale.parse(c.locale, ne, [ae]);
    return oe && i.isValidate(oe) ? oe : null;
  }, J = r[0], H = S.useCallback(function(ee) {
    return ld(ee, {
      locale: c,
      format: J,
      generateConfig: i
    });
  }, [c, i, J]), K = S.useMemo(function() {
    return L.map(H);
  }, [L, H]), X = S.useMemo(function() {
    var ee = Y === "time" ? 8 : 10, ne = typeof J == "function" ? J(i.getNow()).length : J.length;
    return Math.max(ee, ne) + 2;
  }, [J, Y, i]), te = function(ne) {
    for (var ae = 0; ae < r.length; ae += 1) {
      var oe = r[ae];
      if (typeof oe == "string") {
        var fe = G(ne, oe);
        if (fe)
          return fe;
      }
    }
    return !1;
  }, ie = function(ne) {
    function ae(be) {
      return ne !== void 0 ? be[ne] : be;
    }
    var oe = Zu(e, {
      aria: !0,
      data: !0
    }), fe = ce(ce({}, oe), {}, {
      // ============== Shared ==============
      format: a,
      validateFormat: function(me) {
        return !!te(me);
      },
      preserveInvalidOnBlur: d,
      readOnly: f,
      required: p,
      "aria-required": g,
      name: $,
      autoComplete: j,
      size: X,
      // ============= By Index =============
      id: ae(I),
      value: ae(K) || "",
      invalid: ae(F),
      placeholder: ae(_),
      active: Q === ne,
      helped: U || D && Q === ne,
      disabled: ae(W),
      onFocus: function(me) {
        w(me, ne);
      },
      onBlur: function(me) {
        x(me, ne);
      },
      onSubmit: b,
      // Get validate text value
      onChange: function(me) {
        E();
        var De = te(me);
        if (De) {
          P(!1, ne), N(De, ne);
          return;
        }
        P(!!me, ne);
      },
      onHelp: function() {
        M(!0, {
          index: ne
        });
      },
      onKeyDown: function(me) {
        var De = !1;
        if (T?.(me, function() {
          process.env.NODE_ENV !== "production" && $n(!1, "`preventDefault` callback is deprecated. Please call `event.preventDefault` directly."), De = !0;
        }), !me.defaultPrevented && !De)
          switch (me.key) {
            case "Escape":
              M(!1, {
                index: ne
              });
              break;
            case "Enter":
              k || M(!0);
              break;
          }
      }
    }, t?.({
      valueTexts: K
    }));
    return Object.keys(fe).forEach(function(be) {
      fe[be] === void 0 && delete fe[be];
    }), fe;
  };
  return [ie, H];
}
var B1e = ["onMouseEnter", "onMouseLeave"];
function OQ(e) {
  return S.useMemo(function() {
    return lM(e, B1e);
  }, [e]);
}
var U1e = ["icon", "type"], X1e = ["onClear"];
function dM(e) {
  var t = e.icon, r = e.type, a = xr(e, U1e), i = S.useContext(K1), c = i.prefixCls;
  return t ? /* @__PURE__ */ S.createElement("span", vt({
    className: "".concat(c, "-").concat(r)
  }, a), t) : null;
}
function WD(e) {
  var t = e.onClear, r = xr(e, X1e);
  return /* @__PURE__ */ S.createElement(dM, vt({}, r, {
    type: "clear",
    role: "button",
    onMouseDown: function(i) {
      i.preventDefault();
    },
    onClick: function(i) {
      i.stopPropagation(), t();
    }
  }));
}
var fR = ["YYYY", "MM", "DD", "HH", "mm", "ss", "SSS"], hW = "顧", G1e = /* @__PURE__ */ (function() {
  function e(t) {
    Vi(this, e), ge(this, "format", void 0), ge(this, "maskFormat", void 0), ge(this, "cells", void 0), ge(this, "maskCells", void 0), this.format = t;
    var r = fR.map(function(f) {
      return "(".concat(f, ")");
    }).join("|"), a = new RegExp(r, "g");
    this.maskFormat = t.replace(
      a,
      // Use Chinese character to avoid user use it in format
      function(f) {
        return hW.repeat(f.length);
      }
    );
    var i = new RegExp("(".concat(fR.join("|"), ")")), c = (t.split(i) || []).filter(function(f) {
      return f;
    }), d = 0;
    this.cells = c.map(function(f) {
      var p = fR.includes(f), g = d, b = d + f.length;
      return d = b, {
        text: f,
        mask: p,
        start: g,
        end: b
      };
    }), this.maskCells = this.cells.filter(function(f) {
      return f.mask;
    });
  }
  return _i(e, [{
    key: "getSelection",
    value: function(r) {
      var a = this.maskCells[r] || {}, i = a.start, c = a.end;
      return [i || 0, c || 0];
    }
    /** Check given text match format */
  }, {
    key: "match",
    value: function(r) {
      for (var a = 0; a < this.maskFormat.length; a += 1) {
        var i = this.maskFormat[a], c = r[a];
        if (!c || i !== hW && i !== c)
          return !1;
      }
      return !0;
    }
    /** Get mask cell count */
  }, {
    key: "size",
    value: function() {
      return this.maskCells.length;
    }
  }, {
    key: "getMaskCellIndex",
    value: function(r) {
      for (var a = Number.MAX_SAFE_INTEGER, i = 0, c = 0; c < this.maskCells.length; c += 1) {
        var d = this.maskCells[c], f = d.start, p = d.end;
        if (r >= f && r <= p)
          return c;
        var g = Math.min(Math.abs(r - f), Math.abs(r - p));
        g < a && (a = g, i = c);
      }
      return i;
    }
  }]), e;
})();
function q1e(e) {
  var t = {
    YYYY: [0, 9999, (/* @__PURE__ */ new Date()).getFullYear()],
    MM: [1, 12],
    DD: [1, 31],
    HH: [0, 23],
    mm: [0, 59],
    ss: [0, 59],
    SSS: [0, 999]
  };
  return t[e];
}
var K1e = ["active", "showActiveCls", "suffixIcon", "format", "validateFormat", "onChange", "onInput", "helped", "onHelp", "onSubmit", "onKeyDown", "preserveInvalidOnBlur", "invalid", "clearIcon"], Jk = /* @__PURE__ */ S.forwardRef(function(e, t) {
  var r = e.active, a = e.showActiveCls, i = a === void 0 ? !0 : a, c = e.suffixIcon, d = e.format, f = e.validateFormat, p = e.onChange;
  e.onInput;
  var g = e.helped, b = e.onHelp, w = e.onSubmit, x = e.onKeyDown, E = e.preserveInvalidOnBlur, P = E === void 0 ? !1 : E, k = e.invalid, M = e.clearIcon, T = xr(e, K1e), N = e.value, D = e.onFocus, $ = e.onBlur, j = e.onMouseUp, I = S.useContext(K1), L = I.prefixCls, F = I.input, _ = F === void 0 ? "input" : F, W = "".concat(L, "-input"), Q = S.useState(!1), U = qe(Q, 2), Y = U[0], G = U[1], J = S.useState(N), H = qe(J, 2), K = H[0], X = H[1], te = S.useState(""), ie = qe(te, 2), ee = ie[0], ne = ie[1], ae = S.useState(null), oe = qe(ae, 2), fe = oe[0], be = oe[1], me = S.useState(null), De = qe(me, 2), Me = De[0], ze = De[1], le = K || "";
  S.useEffect(function() {
    X(N);
  }, [N]);
  var se = S.useRef(), Ae = S.useRef();
  S.useImperativeHandle(t, function() {
    return {
      nativeElement: se.current,
      inputElement: Ae.current,
      focus: function(ut) {
        Ae.current.focus(ut);
      },
      blur: function() {
        Ae.current.blur();
      }
    };
  });
  var we = S.useMemo(function() {
    return new G1e(d || "");
  }, [d]), Ne = S.useMemo(function() {
    return g ? [0, 0] : we.getSelection(fe);
  }, [we, fe, g]), pe = qe(Ne, 2), Qe = pe[0], Le = pe[1], Te = function(ut) {
    ut && ut !== d && ut !== N && b();
  }, Oe = ra(function(Ct) {
    f(Ct) && p(Ct), X(Ct), Te(Ct);
  }), ye = function(ut) {
    if (!d) {
      var ht = ut.target.value;
      Te(ht), X(ht), p(ht);
    }
  }, je = function(ut) {
    var ht = ut.clipboardData.getData("text");
    f(ht) && Oe(ht);
  }, Ue = S.useRef(!1), Fe = function() {
    Ue.current = !0;
  }, tt = function(ut) {
    var ht = ut.target, ot = ht.selectionStart, at = we.getMaskCellIndex(ot);
    be(at), ze({}), j?.(ut), Ue.current = !1;
  }, dt = function(ut) {
    G(!0), be(0), ne(""), D(ut);
  }, St = function(ut) {
    $(ut);
  }, mt = function(ut) {
    G(!1), St(ut);
  };
  Cj(r, function() {
    !r && !P && X(N);
  });
  var Ot = function(ut) {
    ut.key === "Enter" && f(le) && w(), x?.(ut);
  }, Rt = function(ut) {
    Ot(ut);
    var ht = ut.key, ot = null, at = null, ft = Le - Qe, st = d.slice(Qe, Le), pt = function(Pt) {
      be(function(hn) {
        var an = hn + Pt;
        return an = Math.max(an, 0), an = Math.min(an, we.size() - 1), an;
      });
    }, bt = function(Pt) {
      var hn = q1e(st), an = qe(hn, 3), jn = an[0], xn = an[1], Ut = an[2], pn = le.slice(Qe, Le), wn = Number(pn);
      if (isNaN(wn))
        return String(Ut || (Pt > 0 ? jn : xn));
      var Lt = wn + Pt, gt = xn - jn + 1;
      return String(jn + (gt + Lt - jn) % gt);
    };
    switch (ht) {
      // =============== Remove ===============
      case "Backspace":
      case "Delete":
        ot = "", at = st;
        break;
      // =============== Arrows ===============
      // Left key
      case "ArrowLeft":
        ot = "", pt(-1);
        break;
      // Right key
      case "ArrowRight":
        ot = "", pt(1);
        break;
      // Up key
      case "ArrowUp":
        ot = "", at = bt(1);
        break;
      // Down key
      case "ArrowDown":
        ot = "", at = bt(-1);
        break;
      // =============== Number ===============
      default:
        isNaN(Number(ht)) || (ot = ee + ht, at = ot);
        break;
    }
    if (ot !== null && (ne(ot), ot.length >= ft && (pt(1), ne(""))), at !== null) {
      var Nt = (
        // before
        le.slice(0, Qe) + // replace
        bj(at, ft) + // after
        le.slice(Le)
      );
      Oe(Nt.slice(0, d.length));
    }
    ze({});
  }, ct = S.useRef();
  Da(function() {
    if (!(!Y || !d || Ue.current)) {
      if (!we.match(le)) {
        Oe(d);
        return;
      }
      return Ae.current.setSelectionRange(Qe, Le), ct.current = Pa(function() {
        Ae.current.setSelectionRange(Qe, Le);
      }), function() {
        Pa.cancel(ct.current);
      };
    }
  }, [we, d, Y, le, fe, Qe, Le, Me, Oe]);
  var it = d ? {
    onFocus: dt,
    onBlur: mt,
    onKeyDown: Rt,
    onMouseDown: Fe,
    onMouseUp: tt,
    onPaste: je
  } : {};
  return /* @__PURE__ */ S.createElement("div", {
    ref: se,
    className: _e(W, ge(ge({}, "".concat(W, "-active"), r && i), "".concat(W, "-placeholder"), g))
  }, /* @__PURE__ */ S.createElement(_, vt({
    ref: Ae,
    "aria-invalid": k,
    autoComplete: "off"
  }, T, {
    onKeyDown: Ot,
    onBlur: St
    // Replace with format
  }, it, {
    // Value
    value: le,
    onChange: ye
  })), /* @__PURE__ */ S.createElement(dM, {
    type: "suffix",
    icon: c
  }), M);
});
process.env.NODE_ENV !== "production" && (Jk.displayName = "Input");
var Y1e = ["id", "prefix", "clearIcon", "suffixIcon", "separator", "activeIndex", "activeHelp", "allHelp", "focused", "onFocus", "onBlur", "onKeyDown", "locale", "generateConfig", "placeholder", "className", "style", "onClick", "onClear", "value", "onChange", "onSubmit", "onInputChange", "format", "maskFormat", "preserveInvalidOnBlur", "onInvalid", "disabled", "invalid", "inputReadOnly", "direction", "onOpenChange", "onActiveInfo", "placement", "onMouseDown", "required", "aria-required", "autoFocus", "tabIndex"], Q1e = ["index"];
function J1e(e, t) {
  var r = e.id, a = e.prefix, i = e.clearIcon, c = e.suffixIcon, d = e.separator, f = d === void 0 ? "~" : d, p = e.activeIndex;
  e.activeHelp, e.allHelp;
  var g = e.focused;
  e.onFocus, e.onBlur, e.onKeyDown, e.locale, e.generateConfig;
  var b = e.placeholder, w = e.className, x = e.style, E = e.onClick, P = e.onClear, k = e.value;
  e.onChange, e.onSubmit, e.onInputChange, e.format, e.maskFormat, e.preserveInvalidOnBlur, e.onInvalid;
  var M = e.disabled, T = e.invalid;
  e.inputReadOnly;
  var N = e.direction;
  e.onOpenChange;
  var D = e.onActiveInfo;
  e.placement;
  var $ = e.onMouseDown;
  e.required, e["aria-required"];
  var j = e.autoFocus, I = e.tabIndex, L = xr(e, Y1e), F = N === "rtl", _ = S.useContext(K1), W = _.prefixCls, Q = S.useMemo(function() {
    if (typeof r == "string")
      return [r];
    var Me = r || {};
    return [Me.start, Me.end];
  }, [r]), U = S.useRef(), Y = S.useRef(), G = S.useRef(), J = function(ze) {
    var le;
    return (le = [Y, G][ze]) === null || le === void 0 ? void 0 : le.current;
  };
  S.useImperativeHandle(t, function() {
    return {
      nativeElement: U.current,
      focus: function(ze) {
        if (Hn(ze) === "object") {
          var le, se = ze || {}, Ae = se.index, we = Ae === void 0 ? 0 : Ae, Ne = xr(se, Q1e);
          (le = J(we)) === null || le === void 0 || le.focus(Ne);
        } else {
          var pe;
          (pe = J(ze ?? 0)) === null || pe === void 0 || pe.focus();
        }
      },
      blur: function() {
        var ze, le;
        (ze = J(0)) === null || ze === void 0 || ze.blur(), (le = J(1)) === null || le === void 0 || le.blur();
      }
    };
  });
  var H = OQ(L), K = S.useMemo(function() {
    return Array.isArray(b) ? b : [b, b];
  }, [b]), X = MQ(ce(ce({}, e), {}, {
    id: Q,
    placeholder: K
  })), te = qe(X, 1), ie = te[0], ee = S.useState({
    position: "absolute",
    width: 0
  }), ne = qe(ee, 2), ae = ne[0], oe = ne[1], fe = ra(function() {
    var Me = J(p);
    if (Me) {
      var ze = Me.nativeElement.getBoundingClientRect(), le = U.current.getBoundingClientRect(), se = ze.left - le.left;
      oe(function(Ae) {
        return ce(ce({}, Ae), {}, {
          width: ze.width,
          left: se
        });
      }), D([ze.left, ze.right, le.width]);
    }
  });
  S.useEffect(function() {
    fe();
  }, [p]);
  var be = i && (k[0] && !M[0] || k[1] && !M[1]), me = j && !M[0], De = j && !me && !M[1];
  return /* @__PURE__ */ S.createElement(hp, {
    onResize: fe
  }, /* @__PURE__ */ S.createElement("div", vt({}, H, {
    className: _e(W, "".concat(W, "-range"), ge(ge(ge(ge({}, "".concat(W, "-focused"), g), "".concat(W, "-disabled"), M.every(function(Me) {
      return Me;
    })), "".concat(W, "-invalid"), T.some(function(Me) {
      return Me;
    })), "".concat(W, "-rtl"), F), w),
    style: x,
    ref: U,
    onClick: E,
    onMouseDown: function(ze) {
      var le = ze.target;
      le !== Y.current.inputElement && le !== G.current.inputElement && ze.preventDefault(), $?.(ze);
    }
  }), a && /* @__PURE__ */ S.createElement("div", {
    className: "".concat(W, "-prefix")
  }, a), /* @__PURE__ */ S.createElement(Jk, vt({
    ref: Y
  }, ie(0), {
    autoFocus: me,
    tabIndex: I,
    "date-range": "start"
  })), /* @__PURE__ */ S.createElement("div", {
    className: "".concat(W, "-range-separator")
  }, f), /* @__PURE__ */ S.createElement(Jk, vt({
    ref: G
  }, ie(1), {
    autoFocus: De,
    tabIndex: I,
    "date-range": "end"
  })), /* @__PURE__ */ S.createElement("div", {
    className: "".concat(W, "-active-bar"),
    style: ae
  }), /* @__PURE__ */ S.createElement(dM, {
    type: "suffix",
    icon: c
  }), be && /* @__PURE__ */ S.createElement(WD, {
    icon: i,
    onClear: P
  })));
}
var TQ = /* @__PURE__ */ S.forwardRef(J1e);
process.env.NODE_ENV !== "production" && (TQ.displayName = "RangeSelector");
function pW(e, t) {
  var r = e ?? t;
  return Array.isArray(r) ? r : [r, r];
}
function K7(e) {
  return e === 1 ? "end" : "start";
}
function Z1e(e, t) {
  var r = fQ(e, function() {
    var qt = e.disabled, Kt = e.allowEmpty, ur = pW(qt, !1), pr = pW(Kt, !1);
    return {
      disabled: ur,
      allowEmpty: pr
    };
  }), a = qe(r, 6), i = a[0], c = a[1], d = a[2], f = a[3], p = a[4], g = a[5], b = i.prefixCls, w = i.styles, x = i.classNames, E = i.defaultValue, P = i.value, k = i.needConfirm, M = i.onKeyDown, T = i.disabled, N = i.allowEmpty, D = i.disabledDate, $ = i.minDate, j = i.maxDate, I = i.defaultOpen, L = i.open, F = i.onOpenChange, _ = i.locale, W = i.generateConfig, Q = i.picker, U = i.showNow, Y = i.showToday, G = i.showTime, J = i.mode, H = i.onPanelChange, K = i.onCalendarChange, X = i.onOk, te = i.defaultPickerValue, ie = i.pickerValue, ee = i.onPickerValueChange, ne = i.inputReadOnly, ae = i.suffixIcon, oe = i.onFocus, fe = i.onBlur, be = i.presets, me = i.ranges, De = i.components, Me = i.cellRender, ze = i.dateRender, le = i.monthCellRender, se = i.onClick, Ae = hQ(t), we = mQ(L, I, T, F), Ne = qe(we, 2), pe = Ne[0], Qe = Ne[1], Le = function(Kt, ur) {
    (T.some(function(pr) {
      return !pr;
    }) || !Kt) && Qe(Kt, ur);
  }, Te = SQ(W, _, f, !0, !1, E, P, K, X), Oe = qe(Te, 5), ye = Oe[0], je = Oe[1], Ue = Oe[2], Fe = Oe[3], tt = Oe[4], dt = Ue(), St = gQ(T, N, pe), mt = qe(St, 9), Ot = mt[0], Rt = mt[1], ct = mt[2], it = mt[3], Ct = mt[4], ut = mt[5], ht = mt[6], ot = mt[7], at = mt[8], ft = function(Kt, ur) {
    Rt(!0), oe?.(Kt, {
      range: K7(ur ?? it)
    });
  }, st = function(Kt, ur) {
    Rt(!1), fe?.(Kt, {
      range: K7(ur ?? it)
    });
  }, pt = S.useMemo(function() {
    if (!G)
      return null;
    var qt = G.disabledTime, Kt = qt ? function(ur) {
      var pr = K7(it), tr = tQ(dt, ht, it);
      return qt(ur, pr, {
        from: tr
      });
    } : void 0;
    return ce(ce({}, G), {}, {
      disabledTime: Kt
    });
  }, [G, it, dt, ht]), bt = ll([Q, Q], {
    value: J
  }), Nt = qe(bt, 2), $t = Nt[0], Pt = Nt[1], hn = $t[it] || Q, an = hn === "date" && pt ? "datetime" : hn, jn = an === Q && an !== "time", xn = xQ(Q, hn, U, Y, !0), Ut = CQ(i, ye, je, Ue, Fe, T, f, Ot, pe, g), pn = qe(Ut, 2), wn = pn[0], Lt = pn[1], gt = E1e(dt, T, ht, W, _, D), wt = rQ(dt, g, N), Ft = qe(wt, 2), yn = Ft[0], gn = Ft[1], Tn = vQ(W, _, dt, $t, pe, it, c, jn, te, ie, pt?.defaultOpenValue, ee, $, j), Gt = qe(Tn, 2), Dt = Gt[0], Yt = Gt[1], Mn = ra(function(qt, Kt, ur) {
    var pr = mE($t, it, Kt);
    if ((pr[0] !== $t[0] || pr[1] !== $t[1]) && Pt(pr), H && ur !== !1) {
      var tr = Et(dt);
      qt && (tr[it] = qt), H(tr, pr);
    }
  }), Gn = function(Kt, ur) {
    return (
      // Trigger change only when date changed
      mE(dt, ur, Kt)
    );
  }, wr = function(Kt, ur) {
    var pr = dt;
    Kt && (pr = Gn(Kt, it)), ot(it);
    var tr = ut(pr);
    Fe(pr), wn(it, tr === null), tr === null ? Le(!1, {
      force: !0
    }) : ur || Ae.current.focus({
      index: tr
    });
  }, aa = function(Kt) {
    var ur, pr = Kt.target.getRootNode();
    if (!Ae.current.nativeElement.contains((ur = pr.activeElement) !== null && ur !== void 0 ? ur : document.activeElement)) {
      var tr = T.findIndex(function(Va) {
        return !Va;
      });
      tr >= 0 && Ae.current.focus({
        index: tr
      });
    }
    Le(!0), se?.(Kt);
  }, qn = function() {
    Lt(null), Le(!1, {
      force: !0
    });
  }, Rr = S.useState(null), Wt = qe(Rr, 2), en = Wt[0], Xt = Wt[1], zt = S.useState(null), kt = qe(zt, 2), Qn = kt[0], Jn = kt[1], Nr = S.useMemo(function() {
    return Qn || dt;
  }, [dt, Qn]);
  S.useEffect(function() {
    pe || Jn(null);
  }, [pe]);
  var Hr = S.useState([0, 0, 0]), oa = qe(Hr, 2), dn = oa[0], Un = oa[1], sr = pQ(be, me), Yr = function(Kt) {
    Jn(Kt), Xt("preset");
  }, Wa = function(Kt) {
    var ur = Lt(Kt);
    ur && Le(!1, {
      force: !0
    });
  }, pa = function(Kt) {
    wr(Kt);
  }, Jr = function(Kt) {
    Jn(Kt ? Gn(Kt, it) : null), Xt("cell");
  }, si = function(Kt) {
    Le(!0), ft(Kt);
  }, mi = function() {
    ct("panel");
  }, Yo = function(Kt) {
    var ur = mE(dt, it, Kt);
    Fe(ur), !k && !d && c === an && wr(Kt);
  }, Bi = function() {
    Le(!1);
  }, hr = yj(Me, ze, le, K7(it)), zn = dt[it] || null, On = ra(function(qt) {
    return g(qt, {
      activeIndex: it
    });
  }), Qt = S.useMemo(function() {
    var qt = Zu(i, !1), Kt = Rs(i, [].concat(Et(Object.keys(qt)), ["onChange", "onCalendarChange", "style", "className", "onPanelChange", "disabledTime"]));
    return Kt;
  }, [i]), nn = /* @__PURE__ */ S.createElement(kQ, vt({}, Qt, {
    showNow: xn,
    showTime: pt,
    range: !0,
    multiplePanel: jn,
    activeInfo: dn,
    disabledDate: gt,
    onFocus: si,
    onBlur: st,
    onPanelMouseDown: mi,
    picker: Q,
    mode: hn,
    internalMode: an,
    onPanelChange: Mn,
    format: p,
    value: zn,
    isInvalid: On,
    onChange: null,
    onSelect: Yo,
    pickerValue: Dt,
    defaultOpenValue: p3(G?.defaultOpenValue)[it],
    onPickerValueChange: Yt,
    hoverValue: Nr,
    onHover: Jr,
    needConfirm: k,
    onSubmit: wr,
    onOk: tt,
    presets: sr,
    onPresetHover: Yr,
    onPresetSubmit: Wa,
    onNow: pa,
    cellRender: hr
  })), er = function(Kt, ur) {
    var pr = Gn(Kt, ur);
    Fe(pr);
  }, ia = function() {
    ct("input");
  }, so = function(Kt, ur) {
    var pr = ht.length, tr = ht[pr - 1];
    if (pr && tr !== ur && k && // Not change index if is not filled
    !N[tr] && !at(tr) && dt[tr]) {
      Ae.current.focus({
        index: tr
      });
      return;
    }
    ct("input"), Le(!0, {
      inherit: !0
    }), it !== ur && pe && !k && d && wr(null, !0), Ct(ur), ft(Kt, ur);
  }, hi = function(Kt, ur) {
    if (Le(!1), !k && ct() === "input") {
      var pr = ut(dt);
      wn(it, pr === null);
    }
    st(Kt, ur);
  }, ka = function(Kt, ur) {
    Kt.key === "Tab" && wr(null, !0), M?.(Kt, ur);
  }, Ui = S.useMemo(function() {
    return {
      prefixCls: b,
      locale: _,
      generateConfig: W,
      button: De.button,
      input: De.input
    };
  }, [b, _, W, De.button, De.input]);
  if (Da(function() {
    pe && it !== void 0 && Mn(null, Q, !1);
  }, [pe, it, Q]), Da(function() {
    var qt = ct();
    !pe && qt === "input" && (Le(!1), wr(null, !0)), !pe && d && !k && qt === "panel" && (Le(!0), wr());
  }, [pe]), process.env.NODE_ENV !== "production") {
    var sl = function(Kt) {
      return (
        // Value is empty
        !(P != null && P[Kt]) && // DefaultValue is empty
        !(E != null && E[Kt])
      );
    };
    T.some(function(qt, Kt) {
      return qt && sl(Kt) && !N[Kt];
    }) && $n(!1, "`disabled` should not set with empty `value`. You should set `allowEmpty` or `value` instead.");
  }
  return /* @__PURE__ */ S.createElement(K1.Provider, {
    value: Ui
  }, /* @__PURE__ */ S.createElement(ZY, vt({}, nQ(i), {
    popupElement: nn,
    popupStyle: w.popup,
    popupClassName: x.popup,
    visible: pe,
    onClose: Bi,
    range: !0
  }), /* @__PURE__ */ S.createElement(
    TQ,
    vt({}, i, {
      // Ref
      ref: Ae,
      suffixIcon: ae,
      activeIndex: Ot || pe ? it : null,
      activeHelp: !!Qn,
      allHelp: !!Qn && en === "preset",
      focused: Ot,
      onFocus: so,
      onBlur: hi,
      onKeyDown: ka,
      onSubmit: wr,
      value: Nr,
      maskFormat: p,
      onChange: er,
      onInputChange: ia,
      format: f,
      inputReadOnly: ne,
      disabled: T,
      open: pe,
      onOpenChange: Le,
      onClick: aa,
      onClear: qn,
      invalid: yn,
      onInvalid: gn,
      onActiveInfo: Un
    })
  )));
}
var RQ = /* @__PURE__ */ S.forwardRef(Z1e);
process.env.NODE_ENV !== "production" && (RQ.displayName = "RefRangePicker");
function ebe(e) {
  var t = e.prefixCls, r = e.value, a = e.onRemove, i = e.removeIcon, c = i === void 0 ? "×" : i, d = e.formatDate, f = e.disabled, p = e.maxTagCount, g = e.placeholder, b = "".concat(t, "-selector"), w = "".concat(t, "-selection"), x = "".concat(w, "-overflow");
  function E(M, T) {
    return /* @__PURE__ */ S.createElement("span", {
      className: _e("".concat(w, "-item")),
      title: typeof M == "string" ? M : null
    }, /* @__PURE__ */ S.createElement("span", {
      className: "".concat(w, "-item-content")
    }, M), !f && T && /* @__PURE__ */ S.createElement("span", {
      onMouseDown: function(D) {
        D.preventDefault();
      },
      onClick: T,
      className: "".concat(w, "-item-remove")
    }, c));
  }
  function P(M) {
    var T = d(M), N = function($) {
      $ && $.stopPropagation(), a(M);
    };
    return E(T, N);
  }
  function k(M) {
    var T = "+ ".concat(M.length, " ...");
    return E(T);
  }
  return /* @__PURE__ */ S.createElement("div", {
    className: b
  }, /* @__PURE__ */ S.createElement(W1, {
    prefixCls: x,
    data: r,
    renderItem: P,
    renderRest: k,
    itemKey: function(T) {
      return d(T);
    },
    maxCount: p
  }), !r.length && /* @__PURE__ */ S.createElement("span", {
    className: "".concat(t, "-selection-placeholder")
  }, g));
}
var tbe = ["id", "open", "prefix", "clearIcon", "suffixIcon", "activeHelp", "allHelp", "focused", "onFocus", "onBlur", "onKeyDown", "locale", "generateConfig", "placeholder", "className", "style", "onClick", "onClear", "internalPicker", "value", "onChange", "onSubmit", "onInputChange", "multiple", "maxTagCount", "format", "maskFormat", "preserveInvalidOnBlur", "onInvalid", "disabled", "invalid", "inputReadOnly", "direction", "onOpenChange", "onMouseDown", "required", "aria-required", "autoFocus", "tabIndex", "removeIcon"];
function nbe(e, t) {
  e.id;
  var r = e.open, a = e.prefix, i = e.clearIcon, c = e.suffixIcon;
  e.activeHelp, e.allHelp;
  var d = e.focused;
  e.onFocus, e.onBlur, e.onKeyDown;
  var f = e.locale, p = e.generateConfig, g = e.placeholder, b = e.className, w = e.style, x = e.onClick, E = e.onClear, P = e.internalPicker, k = e.value, M = e.onChange, T = e.onSubmit;
  e.onInputChange;
  var N = e.multiple, D = e.maxTagCount;
  e.format, e.maskFormat, e.preserveInvalidOnBlur, e.onInvalid;
  var $ = e.disabled, j = e.invalid;
  e.inputReadOnly;
  var I = e.direction;
  e.onOpenChange;
  var L = e.onMouseDown;
  e.required, e["aria-required"];
  var F = e.autoFocus, _ = e.tabIndex, W = e.removeIcon, Q = xr(e, tbe), U = I === "rtl", Y = S.useContext(K1), G = Y.prefixCls, J = S.useRef(), H = S.useRef();
  S.useImperativeHandle(t, function() {
    return {
      nativeElement: J.current,
      focus: function(me) {
        var De;
        (De = H.current) === null || De === void 0 || De.focus(me);
      },
      blur: function() {
        var me;
        (me = H.current) === null || me === void 0 || me.blur();
      }
    };
  });
  var K = OQ(Q), X = function(me) {
    M([me]);
  }, te = function(me) {
    var De = k.filter(function(Me) {
      return Me && !rm(p, f, Me, me, P);
    });
    M(De), r || T();
  }, ie = MQ(ce(ce({}, e), {}, {
    onChange: X
  }), function(be) {
    var me = be.valueTexts;
    return {
      value: me[0] || "",
      active: d
    };
  }), ee = qe(ie, 2), ne = ee[0], ae = ee[1], oe = !!(i && k.length && !$), fe = N ? /* @__PURE__ */ S.createElement(S.Fragment, null, /* @__PURE__ */ S.createElement(ebe, {
    prefixCls: G,
    value: k,
    onRemove: te,
    formatDate: ae,
    maxTagCount: D,
    disabled: $,
    removeIcon: W,
    placeholder: g
  }), /* @__PURE__ */ S.createElement("input", {
    className: "".concat(G, "-multiple-input"),
    value: k.map(ae).join(","),
    ref: H,
    readOnly: !0,
    autoFocus: F,
    tabIndex: _
  }), /* @__PURE__ */ S.createElement(dM, {
    type: "suffix",
    icon: c
  }), oe && /* @__PURE__ */ S.createElement(WD, {
    icon: i,
    onClear: E
  })) : /* @__PURE__ */ S.createElement(Jk, vt({
    ref: H
  }, ne(), {
    autoFocus: F,
    tabIndex: _,
    suffixIcon: c,
    clearIcon: oe && /* @__PURE__ */ S.createElement(WD, {
      icon: i,
      onClear: E
    }),
    showActiveCls: !1
  }));
  return /* @__PURE__ */ S.createElement("div", vt({}, K, {
    className: _e(G, ge(ge(ge(ge(ge({}, "".concat(G, "-multiple"), N), "".concat(G, "-focused"), d), "".concat(G, "-disabled"), $), "".concat(G, "-invalid"), j), "".concat(G, "-rtl"), U), b),
    style: w,
    ref: J,
    onClick: x,
    onMouseDown: function(me) {
      var De, Me = me.target;
      Me !== ((De = H.current) === null || De === void 0 ? void 0 : De.inputElement) && me.preventDefault(), L?.(me);
    }
  }), a && /* @__PURE__ */ S.createElement("div", {
    className: "".concat(G, "-prefix")
  }, a), fe);
}
var AQ = /* @__PURE__ */ S.forwardRef(nbe);
process.env.NODE_ENV !== "production" && (AQ.displayName = "SingleSelector");
function rbe(e, t) {
  var r = fQ(e), a = qe(r, 6), i = a[0], c = a[1], d = a[2], f = a[3], p = a[4], g = a[5], b = i, w = b.prefixCls, x = b.styles, E = b.classNames, P = b.order, k = b.defaultValue, M = b.value, T = b.needConfirm, N = b.onChange, D = b.onKeyDown, $ = b.disabled, j = b.disabledDate, I = b.minDate, L = b.maxDate, F = b.defaultOpen, _ = b.open, W = b.onOpenChange, Q = b.locale, U = b.generateConfig, Y = b.picker, G = b.showNow, J = b.showToday, H = b.showTime, K = b.mode, X = b.onPanelChange, te = b.onCalendarChange, ie = b.onOk, ee = b.multiple, ne = b.defaultPickerValue, ae = b.pickerValue, oe = b.onPickerValueChange, fe = b.inputReadOnly, be = b.suffixIcon, me = b.removeIcon, De = b.onFocus, Me = b.onBlur, ze = b.presets, le = b.components, se = b.cellRender, Ae = b.dateRender, we = b.monthCellRender, Ne = b.onClick, pe = hQ(t);
  function Qe(Qt) {
    return Qt === null ? null : ee ? Qt : Qt[0];
  }
  var Le = EQ(U, Q, c), Te = mQ(_, F, [$], W), Oe = qe(Te, 2), ye = Oe[0], je = Oe[1], Ue = function(nn, er, ia) {
    if (te) {
      var so = ce({}, ia);
      delete so.range, te(Qe(nn), Qe(er), so);
    }
  }, Fe = function(nn) {
    ie?.(Qe(nn));
  }, tt = SQ(U, Q, f, !1, P, k, M, Ue, Fe), dt = qe(tt, 5), St = dt[0], mt = dt[1], Ot = dt[2], Rt = dt[3], ct = dt[4], it = Ot(), Ct = gQ([$]), ut = qe(Ct, 4), ht = ut[0], ot = ut[1], at = ut[2], ft = ut[3], st = function(nn) {
    ot(!0), De?.(nn, {});
  }, pt = function(nn) {
    ot(!1), Me?.(nn, {});
  }, bt = ll(Y, {
    value: K
  }), Nt = qe(bt, 2), $t = Nt[0], Pt = Nt[1], hn = $t === "date" && H ? "datetime" : $t, an = xQ(Y, $t, G, J), jn = N && function(Qt, nn) {
    N(Qe(Qt), Qe(nn));
  }, xn = CQ(
    ce(ce({}, i), {}, {
      onChange: jn
    }),
    St,
    mt,
    Ot,
    Rt,
    [],
    //disabled,
    f,
    ht,
    ye,
    g
  ), Ut = qe(xn, 2), pn = Ut[1], wn = rQ(it, g), Lt = qe(wn, 2), gt = Lt[0], wt = Lt[1], Ft = S.useMemo(function() {
    return gt.some(function(Qt) {
      return Qt;
    });
  }, [gt]), yn = function(nn, er) {
    if (oe) {
      var ia = ce(ce({}, er), {}, {
        mode: er.mode[0]
      });
      delete ia.range, oe(nn[0], ia);
    }
  }, gn = vQ(
    U,
    Q,
    it,
    [$t],
    ye,
    ft,
    c,
    !1,
    // multiplePanel,
    ne,
    ae,
    p3(H?.defaultOpenValue),
    yn,
    I,
    L
  ), Tn = qe(gn, 2), Gt = Tn[0], Dt = Tn[1], Yt = ra(function(Qt, nn, er) {
    if (Pt(nn), X && er !== !1) {
      var ia = Qt || it[it.length - 1];
      X(ia, nn);
    }
  }), Mn = function() {
    pn(Ot()), je(!1, {
      force: !0
    });
  }, Gn = function(nn) {
    !$ && !pe.current.nativeElement.contains(document.activeElement) && pe.current.focus(), je(!0), Ne?.(nn);
  }, wr = function() {
    pn(null), je(!1, {
      force: !0
    });
  }, aa = S.useState(null), qn = qe(aa, 2), Rr = qn[0], Wt = qn[1], en = S.useState(null), Xt = qe(en, 2), zt = Xt[0], kt = Xt[1], Qn = S.useMemo(function() {
    var Qt = [zt].concat(Et(it)).filter(function(nn) {
      return nn;
    });
    return ee ? Qt : Qt.slice(0, 1);
  }, [it, zt, ee]), Jn = S.useMemo(function() {
    return !ee && zt ? [zt] : it.filter(function(Qt) {
      return Qt;
    });
  }, [it, zt, ee]);
  S.useEffect(function() {
    ye || kt(null);
  }, [ye]);
  var Nr = pQ(ze), Hr = function(nn) {
    kt(nn), Wt("preset");
  }, oa = function(nn) {
    var er = ee ? Le(Ot(), nn) : [nn], ia = pn(er);
    ia && !ee && je(!1, {
      force: !0
    });
  }, dn = function(nn) {
    oa(nn);
  }, Un = function(nn) {
    kt(nn), Wt("cell");
  }, sr = function(nn) {
    je(!0), st(nn);
  }, Yr = function(nn) {
    if (at("panel"), !(ee && hn !== Y)) {
      var er = ee ? Le(Ot(), nn) : [nn];
      Rt(er), !T && !d && c === hn && Mn();
    }
  }, Wa = function() {
    je(!1);
  }, pa = yj(se, Ae, we), Jr = S.useMemo(function() {
    var Qt = Zu(i, !1), nn = Rs(i, [].concat(Et(Object.keys(Qt)), ["onChange", "onCalendarChange", "style", "className", "onPanelChange"]));
    return ce(ce({}, nn), {}, {
      multiple: i.multiple
    });
  }, [i]), si = /* @__PURE__ */ S.createElement(kQ, vt({}, Jr, {
    showNow: an,
    showTime: H,
    disabledDate: j,
    onFocus: sr,
    onBlur: pt,
    picker: Y,
    mode: $t,
    internalMode: hn,
    onPanelChange: Yt,
    format: p,
    value: it,
    isInvalid: g,
    onChange: null,
    onSelect: Yr,
    pickerValue: Gt,
    defaultOpenValue: H?.defaultOpenValue,
    onPickerValueChange: Dt,
    hoverValue: Qn,
    onHover: Un,
    needConfirm: T,
    onSubmit: Mn,
    onOk: ct,
    presets: Nr,
    onPresetHover: Hr,
    onPresetSubmit: oa,
    onNow: dn,
    cellRender: pa
  })), mi = function(nn) {
    Rt(nn);
  }, Yo = function() {
    at("input");
  }, Bi = function(nn) {
    at("input"), je(!0, {
      inherit: !0
    }), st(nn);
  }, hr = function(nn) {
    je(!1), pt(nn);
  }, zn = function(nn, er) {
    nn.key === "Tab" && Mn(), D?.(nn, er);
  }, On = S.useMemo(function() {
    return {
      prefixCls: w,
      locale: Q,
      generateConfig: U,
      button: le.button,
      input: le.input
    };
  }, [w, Q, U, le.button, le.input]);
  return Da(function() {
    ye && ft !== void 0 && Yt(null, Y, !1);
  }, [ye, ft, Y]), Da(function() {
    var Qt = at();
    !ye && Qt === "input" && (je(!1), Mn()), !ye && d && !T && Qt === "panel" && Mn();
  }, [ye]), /* @__PURE__ */ S.createElement(K1.Provider, {
    value: On
  }, /* @__PURE__ */ S.createElement(ZY, vt({}, nQ(i), {
    popupElement: si,
    popupStyle: x.popup,
    popupClassName: E.popup,
    visible: ye,
    onClose: Wa
  }), /* @__PURE__ */ S.createElement(
    AQ,
    vt({}, i, {
      // Ref
      ref: pe,
      suffixIcon: be,
      removeIcon: me,
      activeHelp: !!zt,
      allHelp: !!zt && Rr === "preset",
      focused: ht,
      onFocus: Bi,
      onBlur: hr,
      onKeyDown: zn,
      onSubmit: Mn,
      value: Jn,
      maskFormat: p,
      onChange: mi,
      onInputChange: Yo,
      internalPicker: c,
      format: f,
      inputReadOnly: fe,
      disabled: $,
      open: ye,
      onOpenChange: je,
      onClick: Gn,
      onClear: wr,
      invalid: Ft,
      onInvalid: function(nn) {
        wt(nn, 0);
      }
    })
  )));
}
var NQ = /* @__PURE__ */ S.forwardRef(rbe);
process.env.NODE_ENV !== "production" && (NQ.displayName = "RefPicker");
const DQ = /* @__PURE__ */ S.createContext(null), abe = DQ.Provider, $Q = /* @__PURE__ */ S.createContext(null), obe = $Q.Provider;
var ibe = ["prefixCls", "className", "style", "checked", "disabled", "defaultChecked", "type", "title", "onChange"], zQ = /* @__PURE__ */ ks(function(e, t) {
  var r = e.prefixCls, a = r === void 0 ? "rc-checkbox" : r, i = e.className, c = e.style, d = e.checked, f = e.disabled, p = e.defaultChecked, g = p === void 0 ? !1 : p, b = e.type, w = b === void 0 ? "checkbox" : b, x = e.title, E = e.onChange, P = xr(e, ibe), k = It(null), M = It(null), T = ll(g, {
    value: d
  }), N = qe(T, 2), D = N[0], $ = N[1];
  pS(t, function() {
    return {
      focus: function(F) {
        var _;
        (_ = k.current) === null || _ === void 0 || _.focus(F);
      },
      blur: function() {
        var F;
        (F = k.current) === null || F === void 0 || F.blur();
      },
      input: k.current,
      nativeElement: M.current
    };
  });
  var j = _e(a, i, ge(ge({}, "".concat(a, "-checked"), D), "".concat(a, "-disabled"), f)), I = function(F) {
    f || ("checked" in e || $(F.target.checked), E?.({
      target: ce(ce({}, e), {}, {
        type: w,
        checked: F.target.checked
      }),
      stopPropagation: function() {
        F.stopPropagation();
      },
      preventDefault: function() {
        F.preventDefault();
      },
      nativeEvent: F.nativeEvent
    }));
  };
  return /* @__PURE__ */ S.createElement("span", {
    className: j,
    title: x,
    style: c,
    ref: M
  }, /* @__PURE__ */ S.createElement("input", vt({}, P, {
    className: "".concat(a, "-input"),
    ref: k,
    onChange: I,
    disabled: f,
    checked: !!D,
    type: w
  })), /* @__PURE__ */ S.createElement("span", {
    className: "".concat(a, "-inner")
  }));
});
function jQ(e) {
  const t = Re.useRef(null), r = () => {
    Pa.cancel(t.current), t.current = null;
  };
  return [() => {
    r(), t.current = Pa(() => {
      t.current = null;
    });
  }, (c) => {
    t.current && (c.stopPropagation(), r()), e?.(c);
  }];
}
const lbe = (e) => {
  const {
    componentCls: t,
    antCls: r
  } = e, a = `${t}-group`;
  return {
    [a]: Object.assign(Object.assign({}, dl(e)), {
      display: "inline-block",
      fontSize: 0,
      // RTL
      [`&${a}-rtl`]: {
        direction: "rtl"
      },
      [`&${a}-block`]: {
        display: "flex"
      },
      [`${r}-badge ${r}-badge-count`]: {
        zIndex: 1
      },
      [`> ${r}-badge:not(:first-child) > ${r}-button-wrapper`]: {
        borderInlineStart: "none"
      }
    })
  };
}, sbe = (e) => {
  const {
    componentCls: t,
    wrapperMarginInlineEnd: r,
    colorPrimary: a,
    radioSize: i,
    motionDurationSlow: c,
    motionDurationMid: d,
    motionEaseInOutCirc: f,
    colorBgContainer: p,
    colorBorder: g,
    lineWidth: b,
    colorBgContainerDisabled: w,
    colorTextDisabled: x,
    paddingXS: E,
    dotColorDisabled: P,
    lineType: k,
    radioColor: M,
    radioBgColor: T,
    calc: N
  } = e, D = `${t}-inner`, j = N(i).sub(N(4).mul(2)), I = N(1).mul(i).equal({
    unit: !0
  });
  return {
    [`${t}-wrapper`]: Object.assign(Object.assign({}, dl(e)), {
      display: "inline-flex",
      alignItems: "baseline",
      marginInlineStart: 0,
      marginInlineEnd: r,
      cursor: "pointer",
      "&:last-child": {
        marginInlineEnd: 0
      },
      // RTL
      [`&${t}-wrapper-rtl`]: {
        direction: "rtl"
      },
      "&-disabled": {
        cursor: "not-allowed",
        color: e.colorTextDisabled
      },
      "&::after": {
        display: "inline-block",
        width: 0,
        overflow: "hidden",
        content: '"\\a0"'
      },
      "&-block": {
        flex: 1,
        justifyContent: "center"
      },
      // hashId 在 wrapper 上，只能铺平
      [`${t}-checked::after`]: {
        position: "absolute",
        insetBlockStart: 0,
        insetInlineStart: 0,
        width: "100%",
        height: "100%",
        border: `${Ye(b)} ${k} ${a}`,
        borderRadius: "50%",
        visibility: "hidden",
        opacity: 0,
        content: '""'
      },
      [t]: Object.assign(Object.assign({}, dl(e)), {
        position: "relative",
        display: "inline-block",
        outline: "none",
        cursor: "pointer",
        alignSelf: "center",
        borderRadius: "50%"
      }),
      [`${t}-wrapper:hover &,
        &:hover ${D}`]: {
        borderColor: a
      },
      [`${t}-input:focus-visible + ${D}`]: _S(e),
      [`${t}:hover::after, ${t}-wrapper:hover &::after`]: {
        visibility: "visible"
      },
      [`${t}-inner`]: {
        "&::after": {
          boxSizing: "border-box",
          position: "absolute",
          insetBlockStart: "50%",
          insetInlineStart: "50%",
          display: "block",
          width: I,
          height: I,
          marginBlockStart: N(1).mul(i).div(-2).equal({
            unit: !0
          }),
          marginInlineStart: N(1).mul(i).div(-2).equal({
            unit: !0
          }),
          backgroundColor: M,
          borderBlockStart: 0,
          borderInlineStart: 0,
          borderRadius: I,
          transform: "scale(0)",
          opacity: 0,
          transition: `all ${c} ${f}`,
          content: '""'
        },
        boxSizing: "border-box",
        position: "relative",
        insetBlockStart: 0,
        insetInlineStart: 0,
        display: "block",
        width: I,
        height: I,
        backgroundColor: p,
        borderColor: g,
        borderStyle: "solid",
        borderWidth: b,
        borderRadius: "50%",
        transition: `all ${d}`
      },
      [`${t}-input`]: {
        position: "absolute",
        inset: 0,
        zIndex: 1,
        cursor: "pointer",
        opacity: 0
      },
      // 选中状态
      [`${t}-checked`]: {
        [D]: {
          borderColor: a,
          backgroundColor: T,
          "&::after": {
            transform: `scale(${e.calc(e.dotSize).div(i).equal()})`,
            opacity: 1,
            transition: `all ${c} ${f}`
          }
        }
      },
      [`${t}-disabled`]: {
        cursor: "not-allowed",
        [D]: {
          backgroundColor: w,
          borderColor: g,
          cursor: "not-allowed",
          "&::after": {
            backgroundColor: P
          }
        },
        [`${t}-input`]: {
          cursor: "not-allowed"
        },
        [`${t}-disabled + span`]: {
          color: x,
          cursor: "not-allowed"
        },
        [`&${t}-checked`]: {
          [D]: {
            "&::after": {
              transform: `scale(${N(j).div(i).equal()})`
            }
          }
        }
      },
      [`span${t} + *`]: {
        paddingInlineStart: E,
        paddingInlineEnd: E
      }
    })
  };
}, ube = (e) => {
  const {
    buttonColor: t,
    controlHeight: r,
    componentCls: a,
    lineWidth: i,
    lineType: c,
    colorBorder: d,
    motionDurationMid: f,
    buttonPaddingInline: p,
    fontSize: g,
    buttonBg: b,
    fontSizeLG: w,
    controlHeightLG: x,
    controlHeightSM: E,
    paddingXS: P,
    borderRadius: k,
    borderRadiusSM: M,
    borderRadiusLG: T,
    buttonCheckedBg: N,
    buttonSolidCheckedColor: D,
    colorTextDisabled: $,
    colorBgContainerDisabled: j,
    buttonCheckedBgDisabled: I,
    buttonCheckedColorDisabled: L,
    colorPrimary: F,
    colorPrimaryHover: _,
    colorPrimaryActive: W,
    buttonSolidCheckedBg: Q,
    buttonSolidCheckedHoverBg: U,
    buttonSolidCheckedActiveBg: Y,
    calc: G
  } = e;
  return {
    [`${a}-button-wrapper`]: {
      position: "relative",
      display: "inline-block",
      height: r,
      margin: 0,
      paddingInline: p,
      paddingBlock: 0,
      color: t,
      fontSize: g,
      lineHeight: Ye(G(r).sub(G(i).mul(2)).equal()),
      background: b,
      border: `${Ye(i)} ${c} ${d}`,
      // strange align fix for chrome but works
      // https://gw.alipayobjects.com/zos/rmsportal/VFTfKXJuogBAXcvfAUWJ.gif
      borderBlockStartWidth: G(i).add(0.02).equal(),
      borderInlineEndWidth: i,
      cursor: "pointer",
      transition: [`color ${f}`, `background ${f}`, `box-shadow ${f}`].join(","),
      a: {
        color: t
      },
      [`> ${a}-button`]: {
        position: "absolute",
        insetBlockStart: 0,
        insetInlineStart: 0,
        zIndex: -1,
        width: "100%",
        height: "100%"
      },
      "&:not(:last-child)": {
        marginInlineEnd: G(i).mul(-1).equal()
      },
      "&:first-child": {
        borderInlineStart: `${Ye(i)} ${c} ${d}`,
        borderStartStartRadius: k,
        borderEndStartRadius: k
      },
      "&:last-child": {
        borderStartEndRadius: k,
        borderEndEndRadius: k
      },
      "&:first-child:last-child": {
        borderRadius: k
      },
      [`${a}-group-large &`]: {
        height: x,
        fontSize: w,
        lineHeight: Ye(G(x).sub(G(i).mul(2)).equal()),
        "&:first-child": {
          borderStartStartRadius: T,
          borderEndStartRadius: T
        },
        "&:last-child": {
          borderStartEndRadius: T,
          borderEndEndRadius: T
        }
      },
      [`${a}-group-small &`]: {
        height: E,
        paddingInline: G(P).sub(i).equal(),
        paddingBlock: 0,
        lineHeight: Ye(G(E).sub(G(i).mul(2)).equal()),
        "&:first-child": {
          borderStartStartRadius: M,
          borderEndStartRadius: M
        },
        "&:last-child": {
          borderStartEndRadius: M,
          borderEndEndRadius: M
        }
      },
      "&:hover": {
        position: "relative",
        color: F
      },
      "&:has(:focus-visible)": _S(e),
      [`${a}-inner, input[type='checkbox'], input[type='radio']`]: {
        width: 0,
        height: 0,
        opacity: 0,
        pointerEvents: "none"
      },
      [`&-checked:not(${a}-button-wrapper-disabled)`]: {
        zIndex: 1,
        color: F,
        background: N,
        borderColor: F,
        "&::before": {
          backgroundColor: F
        },
        "&:first-child": {
          borderColor: F
        },
        "&:hover": {
          color: _,
          borderColor: _,
          "&::before": {
            backgroundColor: _
          }
        },
        "&:active": {
          color: W,
          borderColor: W,
          "&::before": {
            backgroundColor: W
          }
        }
      },
      [`${a}-group-solid &-checked:not(${a}-button-wrapper-disabled)`]: {
        color: D,
        background: Q,
        borderColor: Q,
        "&:hover": {
          color: D,
          background: U,
          borderColor: U
        },
        "&:active": {
          color: D,
          background: Y,
          borderColor: Y
        }
      },
      "&-disabled": {
        color: $,
        backgroundColor: j,
        borderColor: d,
        cursor: "not-allowed",
        "&:first-child, &:hover": {
          color: $,
          backgroundColor: j,
          borderColor: d
        }
      },
      [`&-disabled${a}-button-wrapper-checked`]: {
        color: L,
        backgroundColor: I,
        borderColor: d,
        boxShadow: "none"
      },
      "&-block": {
        flex: 1,
        textAlign: "center"
      }
    }
  };
}, cbe = (e) => {
  const {
    wireframe: t,
    padding: r,
    marginXS: a,
    lineWidth: i,
    fontSizeLG: c,
    colorText: d,
    colorBgContainer: f,
    colorTextDisabled: p,
    controlItemBgActiveDisabled: g,
    colorTextLightSolid: b,
    colorPrimary: w,
    colorPrimaryHover: x,
    colorPrimaryActive: E,
    colorWhite: P
  } = e, k = 4, M = c, T = t ? M - k * 2 : M - (k + i) * 2;
  return {
    // Radio
    radioSize: M,
    dotSize: T,
    dotColorDisabled: p,
    // Radio buttons
    buttonSolidCheckedColor: b,
    buttonSolidCheckedBg: w,
    buttonSolidCheckedHoverBg: x,
    buttonSolidCheckedActiveBg: E,
    buttonBg: f,
    buttonCheckedBg: f,
    buttonColor: d,
    buttonCheckedBgDisabled: g,
    buttonCheckedColorDisabled: p,
    buttonPaddingInline: r - i,
    wrapperMarginInlineEnd: a,
    // internal
    radioColor: t ? w : P,
    radioBgColor: t ? f : w
  };
}, IQ = Ii("Radio", (e) => {
  const {
    controlOutline: t,
    controlOutlineWidth: r
  } = e, a = `0 0 0 ${Ye(r)} ${t}`, c = lo(e, {
    radioFocusShadow: a,
    radioButtonFocusShadow: a
  });
  return [lbe(c), sbe(c), ube(c)];
}, cbe, {
  unitless: {
    radioSize: !0,
    dotSize: !0
  }
});
var dbe = function(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
    t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
};
const fbe = (e, t) => {
  var r, a;
  const i = S.useContext(DQ), c = S.useContext($Q), {
    getPrefixCls: d,
    direction: f,
    radio: p
  } = S.useContext(Qr), g = S.useRef(null), b = mp(t, g), {
    isFormItemInput: w
  } = S.useContext(yb);
  if (process.env.NODE_ENV !== "production") {
    const H = To("Radio");
    process.env.NODE_ENV !== "production" && H(!("optionType" in e), "usage", "`optionType` is only support in Radio.Group.");
  }
  const x = (H) => {
    var K, X;
    (K = e.onChange) === null || K === void 0 || K.call(e, H), (X = i?.onChange) === null || X === void 0 || X.call(i, H);
  }, {
    prefixCls: E,
    className: P,
    rootClassName: k,
    children: M,
    style: T,
    title: N
  } = e, D = dbe(e, ["prefixCls", "className", "rootClassName", "children", "style", "title"]), $ = d("radio", E), j = (i?.optionType || c) === "button", I = j ? `${$}-button` : $, L = Qh($), [F, _, W] = IQ($, L), Q = Object.assign({}, D), U = S.useContext(A0);
  i && (Q.name = i.name, Q.onChange = x, Q.checked = e.value === i.value, Q.disabled = (r = Q.disabled) !== null && r !== void 0 ? r : i.disabled), Q.disabled = (a = Q.disabled) !== null && a !== void 0 ? a : U;
  const Y = _e(`${I}-wrapper`, {
    [`${I}-wrapper-checked`]: Q.checked,
    [`${I}-wrapper-disabled`]: Q.disabled,
    [`${I}-wrapper-rtl`]: f === "rtl",
    [`${I}-wrapper-in-form-item`]: w,
    [`${I}-wrapper-block`]: !!i?.block
  }, p?.className, P, k, _, W, L), [G, J] = jQ(Q.onClick);
  return F(/* @__PURE__ */ S.createElement(L9, {
    component: "Radio",
    disabled: Q.disabled
  }, /* @__PURE__ */ S.createElement("label", {
    className: Y,
    style: Object.assign(Object.assign({}, p?.style), T),
    onMouseEnter: e.onMouseEnter,
    onMouseLeave: e.onMouseLeave,
    title: N,
    onClick: G
  }, /* @__PURE__ */ S.createElement(zQ, Object.assign({}, Q, {
    className: _e(Q.className, {
      [I9]: !j
    }),
    type: "radio",
    prefixCls: I,
    ref: b,
    onClick: J
  })), M !== void 0 ? /* @__PURE__ */ S.createElement("span", {
    className: `${I}-label`
  }, M) : null)));
}, $E = /* @__PURE__ */ S.forwardRef(fbe);
process.env.NODE_ENV !== "production" && ($E.displayName = "Radio");
function mbe(e) {
  return e === void 0 || e === !1 ? [] : Array.isArray(e) ? e : [e];
}
function hbe(e) {
  return mbe(e).join("_");
}
const pbe = /* @__PURE__ */ S.forwardRef((e, t) => {
  const {
    getPrefixCls: r,
    direction: a
  } = S.useContext(Qr), {
    name: i
  } = S.useContext(yb), c = KE(hbe(i)), {
    prefixCls: d,
    className: f,
    rootClassName: p,
    options: g,
    buttonStyle: b = "outline",
    disabled: w,
    children: x,
    size: E,
    style: P,
    id: k,
    optionType: M,
    name: T = c,
    defaultValue: N,
    value: D,
    block: $ = !1,
    onChange: j,
    onMouseEnter: I,
    onMouseLeave: L,
    onFocus: F,
    onBlur: _
  } = e, [W, Q] = ll(N, {
    value: D
  }), U = S.useCallback((ae) => {
    const oe = W, fe = ae.target.value;
    "value" in e || Q(fe), fe !== oe && j?.(ae);
  }, [W, Q, j]), Y = r("radio", d), G = `${Y}-group`, J = Qh(Y), [H, K, X] = IQ(Y, J);
  let te = x;
  g && g.length > 0 && (te = g.map((ae) => typeof ae == "string" || typeof ae == "number" ? /* @__PURE__ */ S.createElement($E, {
    key: ae.toString(),
    prefixCls: Y,
    disabled: w,
    value: ae,
    checked: W === ae
  }, ae) : /* @__PURE__ */ S.createElement($E, {
    key: `radio-group-value-options-${ae.value}`,
    prefixCls: Y,
    disabled: ae.disabled || w,
    value: ae.value,
    checked: W === ae.value,
    title: ae.title,
    style: ae.style,
    className: ae.className,
    id: ae.id,
    required: ae.required
  }, ae.label)));
  const ie = Cb(E), ee = _e(G, `${G}-${b}`, {
    [`${G}-${ie}`]: ie,
    [`${G}-rtl`]: a === "rtl",
    [`${G}-block`]: $
  }, f, p, K, X, J), ne = S.useMemo(() => ({
    onChange: U,
    value: W,
    disabled: w,
    name: T,
    optionType: M,
    block: $
  }), [U, W, w, T, M, $]);
  return H(/* @__PURE__ */ S.createElement("div", Object.assign({}, Zu(e, {
    aria: !0,
    data: !0
  }), {
    className: ee,
    style: P,
    onMouseEnter: I,
    onMouseLeave: L,
    onFocus: F,
    onBlur: _,
    id: k,
    ref: t
  }), /* @__PURE__ */ S.createElement(abe, {
    value: ne
  }, te)));
}), gbe = /* @__PURE__ */ S.memo(pbe);
var vbe = function(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
    t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
};
const bbe = (e, t) => {
  const {
    getPrefixCls: r
  } = S.useContext(Qr), {
    prefixCls: a
  } = e, i = vbe(e, ["prefixCls"]), c = r("radio", a);
  return /* @__PURE__ */ S.createElement(obe, {
    value: "button"
  }, /* @__PURE__ */ S.createElement($E, Object.assign({
    prefixCls: c
  }, i, {
    type: "radio",
    ref: t
  })));
}, ybe = /* @__PURE__ */ S.forwardRef(bbe), i7 = $E;
i7.Button = ybe;
i7.Group = gbe;
i7.__ANT_RADIO = !0;
function fM(e) {
  return lo(e, {
    inputAffixPadding: e.paddingXXS
  });
}
const mM = (e) => {
  const {
    controlHeight: t,
    fontSize: r,
    lineHeight: a,
    lineWidth: i,
    controlHeightSM: c,
    controlHeightLG: d,
    fontSizeLG: f,
    lineHeightLG: p,
    paddingSM: g,
    controlPaddingHorizontalSM: b,
    controlPaddingHorizontal: w,
    colorFillAlter: x,
    colorPrimaryHover: E,
    colorPrimary: P,
    controlOutlineWidth: k,
    controlOutline: M,
    colorErrorOutline: T,
    colorWarningOutline: N,
    colorBgContainer: D,
    inputFontSize: $,
    inputFontSizeLG: j,
    inputFontSizeSM: I
  } = e, L = $ || r, F = I || L, _ = j || f, W = Math.round((t - L * a) / 2 * 10) / 10 - i, Q = Math.round((c - F * a) / 2 * 10) / 10 - i, U = Math.ceil((d - _ * p) / 2 * 10) / 10 - i;
  return {
    paddingBlock: Math.max(W, 0),
    paddingBlockSM: Math.max(Q, 0),
    paddingBlockLG: Math.max(U, 0),
    paddingInline: g - i,
    paddingInlineSM: b - i,
    paddingInlineLG: w - i,
    addonBg: x,
    activeBorderColor: P,
    hoverBorderColor: E,
    activeShadow: `0 0 0 ${k}px ${M}`,
    errorActiveShadow: `0 0 0 ${k}px ${T}`,
    warningActiveShadow: `0 0 0 ${k}px ${N}`,
    hoverBg: D,
    activeBg: D,
    inputFontSize: L,
    inputFontSizeLG: _,
    inputFontSizeSM: F
  };
}, wbe = (e) => ({
  borderColor: e.hoverBorderColor,
  backgroundColor: e.hoverBg
}), hM = (e) => ({
  color: e.colorTextDisabled,
  backgroundColor: e.colorBgContainerDisabled,
  borderColor: e.colorBorder,
  boxShadow: "none",
  cursor: "not-allowed",
  opacity: 1,
  "input[disabled], textarea[disabled]": {
    cursor: "not-allowed"
  },
  "&:hover:not([disabled])": Object.assign({}, wbe(lo(e, {
    hoverBorderColor: e.colorBorder,
    hoverBg: e.colorBgContainerDisabled
  })))
}), Ej = (e, t) => ({
  background: e.colorBgContainer,
  borderWidth: e.lineWidth,
  borderStyle: e.lineType,
  borderColor: t.borderColor,
  "&:hover": {
    borderColor: t.hoverBorderColor,
    backgroundColor: e.hoverBg
  },
  "&:focus, &:focus-within": {
    borderColor: t.activeBorderColor,
    boxShadow: t.activeShadow,
    outline: 0,
    backgroundColor: e.activeBg
  }
}), gW = (e, t) => ({
  [`&${e.componentCls}-status-${t.status}:not(${e.componentCls}-disabled)`]: Object.assign(Object.assign({}, Ej(e, t)), {
    [`${e.componentCls}-prefix, ${e.componentCls}-suffix`]: {
      color: t.affixColor
    }
  }),
  [`&${e.componentCls}-status-${t.status}${e.componentCls}-disabled`]: {
    borderColor: t.borderColor
  }
}), LQ = (e, t) => ({
  "&-outlined": Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, Ej(e, {
    borderColor: e.colorBorder,
    hoverBorderColor: e.hoverBorderColor,
    activeBorderColor: e.activeBorderColor,
    activeShadow: e.activeShadow
  })), {
    [`&${e.componentCls}-disabled, &[disabled]`]: Object.assign({}, hM(e))
  }), gW(e, {
    status: "error",
    borderColor: e.colorError,
    hoverBorderColor: e.colorErrorBorderHover,
    activeBorderColor: e.colorError,
    activeShadow: e.errorActiveShadow,
    affixColor: e.colorError
  })), gW(e, {
    status: "warning",
    borderColor: e.colorWarning,
    hoverBorderColor: e.colorWarningBorderHover,
    activeBorderColor: e.colorWarning,
    activeShadow: e.warningActiveShadow,
    affixColor: e.colorWarning
  })), t)
}), vW = (e, t) => ({
  [`&${e.componentCls}-group-wrapper-status-${t.status}`]: {
    [`${e.componentCls}-group-addon`]: {
      borderColor: t.addonBorderColor,
      color: t.addonColor
    }
  }
}), Sbe = (e) => ({
  "&-outlined": Object.assign(Object.assign(Object.assign({
    [`${e.componentCls}-group`]: {
      "&-addon": {
        background: e.addonBg,
        border: `${Ye(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
      },
      "&-addon:first-child": {
        borderInlineEnd: 0
      },
      "&-addon:last-child": {
        borderInlineStart: 0
      }
    }
  }, vW(e, {
    status: "error",
    addonBorderColor: e.colorError,
    addonColor: e.colorErrorText
  })), vW(e, {
    status: "warning",
    addonBorderColor: e.colorWarning,
    addonColor: e.colorWarningText
  })), {
    [`&${e.componentCls}-group-wrapper-disabled`]: {
      [`${e.componentCls}-group-addon`]: Object.assign({}, hM(e))
    }
  })
}), HQ = (e, t) => {
  const {
    componentCls: r
  } = e;
  return {
    "&-borderless": Object.assign({
      background: "transparent",
      border: "none",
      "&:focus, &:focus-within": {
        outline: "none"
      },
      // >>>>> Disabled
      [`&${r}-disabled, &[disabled]`]: {
        color: e.colorTextDisabled,
        cursor: "not-allowed"
      },
      // >>>>> Status
      [`&${r}-status-error`]: {
        "&, & input, & textarea": {
          color: e.colorError
        }
      },
      [`&${r}-status-warning`]: {
        "&, & input, & textarea": {
          color: e.colorWarning
        }
      }
    }, t)
  };
}, FQ = (e, t) => {
  var r;
  return {
    background: t.bg,
    borderWidth: e.lineWidth,
    borderStyle: e.lineType,
    borderColor: "transparent",
    "input&, & input, textarea&, & textarea": {
      color: (r = t?.inputColor) !== null && r !== void 0 ? r : "unset"
    },
    "&:hover": {
      background: t.hoverBg
    },
    "&:focus, &:focus-within": {
      outline: 0,
      borderColor: t.activeBorderColor,
      backgroundColor: e.activeBg
    }
  };
}, bW = (e, t) => ({
  [`&${e.componentCls}-status-${t.status}:not(${e.componentCls}-disabled)`]: Object.assign(Object.assign({}, FQ(e, t)), {
    [`${e.componentCls}-prefix, ${e.componentCls}-suffix`]: {
      color: t.affixColor
    }
  })
}), WQ = (e, t) => ({
  "&-filled": Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, FQ(e, {
    bg: e.colorFillTertiary,
    hoverBg: e.colorFillSecondary,
    activeBorderColor: e.activeBorderColor
  })), {
    [`&${e.componentCls}-disabled, &[disabled]`]: Object.assign({}, hM(e))
  }), bW(e, {
    status: "error",
    bg: e.colorErrorBg,
    hoverBg: e.colorErrorBgHover,
    activeBorderColor: e.colorError,
    inputColor: e.colorErrorText,
    affixColor: e.colorError
  })), bW(e, {
    status: "warning",
    bg: e.colorWarningBg,
    hoverBg: e.colorWarningBgHover,
    activeBorderColor: e.colorWarning,
    inputColor: e.colorWarningText,
    affixColor: e.colorWarning
  })), t)
}), yW = (e, t) => ({
  [`&${e.componentCls}-group-wrapper-status-${t.status}`]: {
    [`${e.componentCls}-group-addon`]: {
      background: t.addonBg,
      color: t.addonColor
    }
  }
}), Cbe = (e) => ({
  "&-filled": Object.assign(Object.assign(Object.assign({
    [`${e.componentCls}-group-addon`]: {
      background: e.colorFillTertiary,
      "&:last-child": {
        position: "static"
      }
    }
  }, yW(e, {
    status: "error",
    addonBg: e.colorErrorBg,
    addonColor: e.colorErrorText
  })), yW(e, {
    status: "warning",
    addonBg: e.colorWarningBg,
    addonColor: e.colorWarningText
  })), {
    [`&${e.componentCls}-group-wrapper-disabled`]: {
      [`${e.componentCls}-group`]: {
        "&-addon": {
          background: e.colorFillTertiary,
          color: e.colorTextDisabled
        },
        "&-addon:first-child": {
          borderInlineStart: `${Ye(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderTop: `${Ye(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderBottom: `${Ye(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
        },
        "&-addon:last-child": {
          borderInlineEnd: `${Ye(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderTop: `${Ye(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderBottom: `${Ye(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
        }
      }
    }
  })
}), VQ = (e, t) => ({
  background: e.colorBgContainer,
  borderWidth: `${Ye(e.lineWidth)} 0`,
  borderStyle: `${e.lineType} none`,
  borderColor: `transparent transparent ${t.borderColor} transparent`,
  borderRadius: 0,
  "&:hover": {
    borderColor: `transparent transparent ${t.hoverBorderColor} transparent`,
    backgroundColor: e.hoverBg
  },
  "&:focus, &:focus-within": {
    borderColor: `transparent transparent ${t.activeBorderColor} transparent`,
    outline: 0,
    backgroundColor: e.activeBg
  }
}), wW = (e, t) => ({
  [`&${e.componentCls}-status-${t.status}:not(${e.componentCls}-disabled)`]: Object.assign(Object.assign({}, VQ(e, t)), {
    [`${e.componentCls}-prefix, ${e.componentCls}-suffix`]: {
      color: t.affixColor
    }
  }),
  [`&${e.componentCls}-status-${t.status}${e.componentCls}-disabled`]: {
    borderColor: `transparent transparent ${t.borderColor} transparent`
  }
}), _Q = (e, t) => ({
  "&-underlined": Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, VQ(e, {
    borderColor: e.colorBorder,
    hoverBorderColor: e.hoverBorderColor,
    activeBorderColor: e.activeBorderColor,
    activeShadow: e.activeShadow
  })), {
    // >>>>> Disabled
    [`&${e.componentCls}-disabled, &[disabled]`]: {
      color: e.colorTextDisabled,
      boxShadow: "none",
      cursor: "not-allowed",
      "&:hover": {
        borderColor: `transparent transparent ${e.colorBorder} transparent`
      }
    },
    "input[disabled], textarea[disabled]": {
      cursor: "not-allowed"
    }
  }), wW(e, {
    status: "error",
    borderColor: e.colorError,
    hoverBorderColor: e.colorErrorBorderHover,
    activeBorderColor: e.colorError,
    activeShadow: e.errorActiveShadow,
    affixColor: e.colorError
  })), wW(e, {
    status: "warning",
    borderColor: e.colorWarning,
    hoverBorderColor: e.colorWarningBorderHover,
    activeBorderColor: e.colorWarning,
    activeShadow: e.warningActiveShadow,
    affixColor: e.colorWarning
  })), t)
}), BQ = (e) => ({
  // Firefox
  "&::-moz-placeholder": {
    opacity: 1
  },
  "&::placeholder": {
    color: e,
    userSelect: "none"
    // https://github.com/ant-design/ant-design/pull/32639
  },
  "&:placeholder-shown": {
    textOverflow: "ellipsis"
  }
}), UQ = (e) => {
  const {
    paddingBlockLG: t,
    lineHeightLG: r,
    borderRadiusLG: a,
    paddingInlineLG: i
  } = e;
  return {
    padding: `${Ye(t)} ${Ye(i)}`,
    fontSize: e.inputFontSizeLG,
    lineHeight: r,
    borderRadius: a
  };
}, Pj = (e) => ({
  padding: `${Ye(e.paddingBlockSM)} ${Ye(e.paddingInlineSM)}`,
  fontSize: e.inputFontSizeSM,
  borderRadius: e.borderRadiusSM
}), kj = (e) => Object.assign(Object.assign({
  position: "relative",
  display: "inline-block",
  width: "100%",
  minWidth: 0,
  padding: `${Ye(e.paddingBlock)} ${Ye(e.paddingInline)}`,
  color: e.colorText,
  fontSize: e.inputFontSize,
  lineHeight: e.lineHeight,
  borderRadius: e.borderRadius,
  transition: `all ${e.motionDurationMid}`
}, BQ(e.colorTextPlaceholder)), {
  // Size
  "&-lg": Object.assign({}, UQ(e)),
  "&-sm": Object.assign({}, Pj(e)),
  // RTL
  "&-rtl, &-textarea-rtl": {
    direction: "rtl"
  }
}), xbe = (e) => {
  const {
    componentCls: t,
    antCls: r
  } = e;
  return {
    position: "relative",
    display: "table",
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: 0,
    // Undo padding and float of grid classes
    "&[class*='col-']": {
      paddingInlineEnd: e.paddingXS,
      "&:last-child": {
        paddingInlineEnd: 0
      }
    },
    // Sizing options
    [`&-lg ${t}, &-lg > ${t}-group-addon`]: Object.assign({}, UQ(e)),
    [`&-sm ${t}, &-sm > ${t}-group-addon`]: Object.assign({}, Pj(e)),
    // Fix https://github.com/ant-design/ant-design/issues/5754
    [`&-lg ${r}-select-single ${r}-select-selector`]: {
      height: e.controlHeightLG
    },
    [`&-sm ${r}-select-single ${r}-select-selector`]: {
      height: e.controlHeightSM
    },
    [`> ${t}`]: {
      display: "table-cell",
      "&:not(:first-child):not(:last-child)": {
        borderRadius: 0
      }
    },
    [`${t}-group`]: {
      "&-addon, &-wrap": {
        display: "table-cell",
        width: 1,
        whiteSpace: "nowrap",
        verticalAlign: "middle",
        "&:not(:first-child):not(:last-child)": {
          borderRadius: 0
        }
      },
      "&-wrap > *": {
        display: "block !important"
      },
      "&-addon": {
        position: "relative",
        padding: `0 ${Ye(e.paddingInline)}`,
        color: e.colorText,
        fontWeight: "normal",
        fontSize: e.inputFontSize,
        textAlign: "center",
        borderRadius: e.borderRadius,
        transition: `all ${e.motionDurationSlow}`,
        lineHeight: 1,
        // Reset Select's style in addon
        [`${r}-select`]: {
          margin: `${Ye(e.calc(e.paddingBlock).add(1).mul(-1).equal())} ${Ye(e.calc(e.paddingInline).mul(-1).equal())}`,
          [`&${r}-select-single:not(${r}-select-customize-input):not(${r}-pagination-size-changer)`]: {
            [`${r}-select-selector`]: {
              backgroundColor: "inherit",
              border: `${Ye(e.lineWidth)} ${e.lineType} transparent`,
              boxShadow: "none"
            }
          }
        },
        // https://github.com/ant-design/ant-design/issues/31333
        [`${r}-cascader-picker`]: {
          margin: `-9px ${Ye(e.calc(e.paddingInline).mul(-1).equal())}`,
          backgroundColor: "transparent",
          [`${r}-cascader-input`]: {
            textAlign: "start",
            border: 0,
            boxShadow: "none"
          }
        }
      }
    },
    [t]: {
      width: "100%",
      marginBottom: 0,
      textAlign: "inherit",
      "&:focus": {
        zIndex: 1,
        // Fix https://gw.alipayobjects.com/zos/rmsportal/DHNpoqfMXSfrSnlZvhsJ.png
        borderInlineEndWidth: 1
      },
      "&:hover": {
        zIndex: 1,
        borderInlineEndWidth: 1,
        [`${t}-search-with-button &`]: {
          zIndex: 0
        }
      }
    },
    // Reset rounded corners
    [`> ${t}:first-child, ${t}-group-addon:first-child`]: {
      borderStartEndRadius: 0,
      borderEndEndRadius: 0,
      // Reset Select's style in addon
      [`${r}-select ${r}-select-selector`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`> ${t}-affix-wrapper`]: {
      [`&:not(:first-child) ${t}`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      },
      [`&:not(:last-child) ${t}`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`> ${t}:last-child, ${t}-group-addon:last-child`]: {
      borderStartStartRadius: 0,
      borderEndStartRadius: 0,
      // Reset Select's style in addon
      [`${r}-select ${r}-select-selector`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`${t}-affix-wrapper`]: {
      "&:not(:last-child)": {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0,
        [`${t}-search &`]: {
          borderStartStartRadius: e.borderRadius,
          borderEndStartRadius: e.borderRadius
        }
      },
      [`&:not(:first-child), ${t}-search &:not(:first-child)`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`&${t}-group-compact`]: Object.assign(Object.assign({
      display: "block"
    }, J4()), {
      [`${t}-group-addon, ${t}-group-wrap, > ${t}`]: {
        "&:not(:first-child):not(:last-child)": {
          borderInlineEndWidth: e.lineWidth,
          "&:hover, &:focus": {
            zIndex: 1
          }
        }
      },
      "& > *": {
        display: "inline-flex",
        float: "none",
        verticalAlign: "top",
        // https://github.com/ant-design/ant-design-pro/issues/139
        borderRadius: 0
      },
      [`
        & > ${t}-affix-wrapper,
        & > ${t}-number-affix-wrapper,
        & > ${r}-picker-range
      `]: {
        display: "inline-flex"
      },
      "& > *:not(:last-child)": {
        marginInlineEnd: e.calc(e.lineWidth).mul(-1).equal(),
        borderInlineEndWidth: e.lineWidth
      },
      // Undo float for .ant-input-group .ant-input
      [t]: {
        float: "none"
      },
      // reset border for Select, DatePicker, AutoComplete, Cascader, Mention, TimePicker, Input
      [`& > ${r}-select > ${r}-select-selector,
      & > ${r}-select-auto-complete ${t},
      & > ${r}-cascader-picker ${t},
      & > ${t}-group-wrapper ${t}`]: {
        borderInlineEndWidth: e.lineWidth,
        borderRadius: 0,
        "&:hover, &:focus": {
          zIndex: 1
        }
      },
      [`& > ${r}-select-focused`]: {
        zIndex: 1
      },
      // update z-index for arrow icon
      [`& > ${r}-select > ${r}-select-arrow`]: {
        zIndex: 1
        // https://github.com/ant-design/ant-design/issues/20371
      },
      [`& > *:first-child,
      & > ${r}-select:first-child > ${r}-select-selector,
      & > ${r}-select-auto-complete:first-child ${t},
      & > ${r}-cascader-picker:first-child ${t}`]: {
        borderStartStartRadius: e.borderRadius,
        borderEndStartRadius: e.borderRadius
      },
      [`& > *:last-child,
      & > ${r}-select:last-child > ${r}-select-selector,
      & > ${r}-cascader-picker:last-child ${t},
      & > ${r}-cascader-picker-focused:last-child ${t}`]: {
        borderInlineEndWidth: e.lineWidth,
        borderStartEndRadius: e.borderRadius,
        borderEndEndRadius: e.borderRadius
      },
      // https://github.com/ant-design/ant-design/issues/12493
      [`& > ${r}-select-auto-complete ${t}`]: {
        verticalAlign: "top"
      },
      [`${t}-group-wrapper + ${t}-group-wrapper`]: {
        marginInlineStart: e.calc(e.lineWidth).mul(-1).equal(),
        [`${t}-affix-wrapper`]: {
          borderRadius: 0
        }
      },
      [`${t}-group-wrapper:not(:last-child)`]: {
        [`&${t}-search > ${t}-group`]: {
          [`& > ${t}-group-addon > ${t}-search-button`]: {
            borderRadius: 0
          },
          [`& > ${t}`]: {
            borderStartStartRadius: e.borderRadius,
            borderStartEndRadius: 0,
            borderEndEndRadius: 0,
            borderEndStartRadius: e.borderRadius
          }
        }
      }
    })
  };
}, Ebe = (e) => {
  const {
    componentCls: t,
    controlHeightSM: r,
    lineWidth: a,
    calc: i
  } = e, d = i(r).sub(i(a).mul(2)).sub(16).div(2).equal();
  return {
    [t]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, dl(e)), kj(e)), LQ(e)), WQ(e)), HQ(e)), _Q(e)), {
      '&[type="color"]': {
        height: e.controlHeight,
        [`&${t}-lg`]: {
          height: e.controlHeightLG
        },
        [`&${t}-sm`]: {
          height: r,
          paddingTop: d,
          paddingBottom: d
        }
      },
      '&[type="search"]::-webkit-search-cancel-button, &[type="search"]::-webkit-search-decoration': {
        appearance: "none"
      }
    })
  };
}, Pbe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    // ========================= Input =========================
    [`${t}-clear-icon`]: {
      margin: 0,
      padding: 0,
      lineHeight: 0,
      color: e.colorTextQuaternary,
      fontSize: e.fontSizeIcon,
      verticalAlign: -1,
      // https://github.com/ant-design/ant-design/pull/18151
      // https://codesandbox.io/s/wizardly-sun-u10br
      cursor: "pointer",
      transition: `color ${e.motionDurationSlow}`,
      border: "none",
      outline: "none",
      backgroundColor: "transparent",
      "&:hover": {
        color: e.colorIcon
      },
      "&:active": {
        color: e.colorText
      },
      "&-hidden": {
        visibility: "hidden"
      },
      "&-has-suffix": {
        margin: `0 ${Ye(e.inputAffixPadding)}`
      }
    }
  };
}, kbe = (e) => {
  const {
    componentCls: t,
    inputAffixPadding: r,
    colorTextDescription: a,
    motionDurationSlow: i,
    colorIcon: c,
    colorIconHover: d,
    iconCls: f
  } = e, p = `${t}-affix-wrapper`, g = `${t}-affix-wrapper-disabled`;
  return {
    [p]: Object.assign(Object.assign(Object.assign(Object.assign({}, kj(e)), {
      display: "inline-flex",
      [`&:not(${t}-disabled):hover`]: {
        zIndex: 1,
        [`${t}-search-with-button &`]: {
          zIndex: 0
        }
      },
      "&-focused, &:focus": {
        zIndex: 1
      },
      [`> input${t}`]: {
        padding: 0
      },
      [`> input${t}, > textarea${t}`]: {
        fontSize: "inherit",
        border: "none",
        borderRadius: 0,
        outline: "none",
        background: "transparent",
        color: "inherit",
        "&::-ms-reveal": {
          display: "none"
        },
        "&:focus": {
          boxShadow: "none !important"
        }
      },
      "&::before": {
        display: "inline-block",
        width: 0,
        visibility: "hidden",
        content: '"\\a0"'
      },
      [t]: {
        "&-prefix, &-suffix": {
          display: "flex",
          flex: "none",
          alignItems: "center",
          "> *:not(:last-child)": {
            marginInlineEnd: e.paddingXS
          }
        },
        "&-show-count-suffix": {
          color: a,
          direction: "ltr"
        },
        "&-show-count-has-suffix": {
          marginInlineEnd: e.paddingXXS
        },
        "&-prefix": {
          marginInlineEnd: r
        },
        "&-suffix": {
          marginInlineStart: r
        }
      }
    }), Pbe(e)), {
      // password
      [`${f}${t}-password-icon`]: {
        color: c,
        cursor: "pointer",
        transition: `all ${i}`,
        "&:hover": {
          color: d
        }
      }
    }),
    // 覆盖 affix-wrapper borderRadius！
    [`${t}-underlined`]: {
      borderRadius: 0
    },
    [g]: {
      // password disabled
      [`${f}${t}-password-icon`]: {
        color: c,
        cursor: "not-allowed",
        "&:hover": {
          color: c
        }
      }
    }
  };
}, Mbe = (e) => {
  const {
    componentCls: t,
    borderRadiusLG: r,
    borderRadiusSM: a
  } = e;
  return {
    [`${t}-group`]: Object.assign(Object.assign(Object.assign({}, dl(e)), xbe(e)), {
      "&-rtl": {
        direction: "rtl"
      },
      "&-wrapper": Object.assign(Object.assign(Object.assign({
        display: "inline-block",
        width: "100%",
        textAlign: "start",
        verticalAlign: "top",
        "&-rtl": {
          direction: "rtl"
        },
        // Size
        "&-lg": {
          [`${t}-group-addon`]: {
            borderRadius: r,
            fontSize: e.inputFontSizeLG
          }
        },
        "&-sm": {
          [`${t}-group-addon`]: {
            borderRadius: a
          }
        }
      }, Sbe(e)), Cbe(e)), {
        // '&-disabled': {
        //   [`${componentCls}-group-addon`]: {
        //     ...genDisabledStyle(token),
        //   },
        // },
        // Fix the issue of using icons in Space Compact mode
        // https://github.com/ant-design/ant-design/issues/42122
        [`&:not(${t}-compact-first-item):not(${t}-compact-last-item)${t}-compact-item`]: {
          [`${t}, ${t}-group-addon`]: {
            borderRadius: 0
          }
        },
        [`&:not(${t}-compact-last-item)${t}-compact-first-item`]: {
          [`${t}, ${t}-group-addon`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0
          }
        },
        [`&:not(${t}-compact-first-item)${t}-compact-last-item`]: {
          [`${t}, ${t}-group-addon`]: {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0
          }
        },
        // Fix the issue of input use show-count param in space compact mode
        // https://github.com/ant-design/ant-design/issues/46872
        [`&:not(${t}-compact-last-item)${t}-compact-item`]: {
          [`${t}-affix-wrapper`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0
          }
        },
        // Fix the issue of input use `addonAfter` param in space compact mode
        // https://github.com/ant-design/ant-design/issues/52483
        [`&:not(${t}-compact-first-item)${t}-compact-item`]: {
          [`${t}-affix-wrapper`]: {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0
          }
        }
      })
    })
  };
}, Obe = (e) => {
  const {
    componentCls: t,
    antCls: r
  } = e, a = `${t}-search`;
  return {
    [a]: {
      [t]: {
        "&:not([disabled]):hover, &:not([disabled]):focus": {
          [`+ ${t}-group-addon ${a}-button:not(${r}-btn-color-primary):not(${r}-btn-variant-text)`]: {
            borderInlineStartColor: e.colorPrimaryHover
          }
        }
      },
      [`${t}-affix-wrapper`]: {
        height: e.controlHeight,
        borderRadius: 0
      },
      // fix slight height diff in Firefox:
      // https://ant.design/components/auto-complete-cn/#auto-complete-demo-certain-category
      [`${t}-lg`]: {
        lineHeight: e.calc(e.lineHeightLG).sub(2e-4).equal()
      },
      [`> ${t}-group`]: {
        [`> ${t}-group-addon:last-child`]: {
          insetInlineStart: -1,
          padding: 0,
          border: 0,
          [`${a}-button`]: {
            // Fix https://github.com/ant-design/ant-design/issues/47150
            marginInlineEnd: -1,
            borderStartStartRadius: 0,
            borderEndStartRadius: 0,
            boxShadow: "none"
          },
          [`${a}-button:not(${r}-btn-color-primary)`]: {
            color: e.colorTextDescription,
            "&:not([disabled]):hover": {
              color: e.colorPrimaryHover
            },
            "&:active": {
              color: e.colorPrimaryActive
            },
            [`&${r}-btn-loading::before`]: {
              inset: 0
            }
          }
        }
      },
      [`${a}-button`]: {
        height: e.controlHeight,
        "&:hover, &:focus": {
          zIndex: 1
        }
      },
      "&-large": {
        [`${t}-affix-wrapper, ${a}-button`]: {
          height: e.controlHeightLG
        }
      },
      "&-small": {
        [`${t}-affix-wrapper, ${a}-button`]: {
          height: e.controlHeightSM
        }
      },
      "&-rtl": {
        direction: "rtl"
      },
      // ===================== Compact Item Customized Styles =====================
      [`&${t}-compact-item`]: {
        [`&:not(${t}-compact-last-item)`]: {
          [`${t}-group-addon`]: {
            [`${t}-search-button`]: {
              marginInlineEnd: e.calc(e.lineWidth).mul(-1).equal(),
              borderRadius: 0
            }
          }
        },
        [`&:not(${t}-compact-first-item)`]: {
          [`${t},${t}-affix-wrapper`]: {
            borderRadius: 0
          }
        },
        [`> ${t}-group-addon ${t}-search-button,
        > ${t},
        ${t}-affix-wrapper`]: {
          "&:hover, &:focus, &:active": {
            zIndex: 2
          }
        },
        [`> ${t}-affix-wrapper-focused`]: {
          zIndex: 2
        }
      }
    }
  };
}, Tbe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-out-of-range`]: {
      [`&, & input, & textarea, ${t}-show-count-suffix, ${t}-data-count`]: {
        color: e.colorError
      }
    }
  };
}, Rbe = Ii(["Input", "Shared"], (e) => {
  const t = lo(e, fM(e));
  return [Ebe(t), kbe(t)];
}, mM, {
  resetFont: !1
}), Abe = Ii(["Input", "Component"], (e) => {
  const t = lo(e, fM(e));
  return [
    Mbe(t),
    Obe(t),
    Tbe(t),
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    XE(t)
  ];
}, mM, {
  resetFont: !1
}), mR = (e, t) => {
  const {
    componentCls: r,
    controlHeight: a
  } = e, i = t ? `${r}-${t}` : "", c = pY(e);
  return [
    // genSelectionStyle(token, suffix),
    {
      [`${r}-multiple${i}`]: {
        paddingBlock: c.containerPadding,
        paddingInlineStart: c.basePadding,
        minHeight: a,
        // ======================== Selections ========================
        [`${r}-selection-item`]: {
          height: c.itemHeight,
          lineHeight: Ye(c.itemLineHeight)
        }
      }
    }
  ];
}, Nbe = (e) => {
  const {
    componentCls: t,
    calc: r,
    lineWidth: a
  } = e, i = lo(e, {
    fontHeight: e.fontSize,
    selectHeight: e.controlHeightSM,
    multipleSelectItemHeight: e.multipleItemHeightSM,
    borderRadius: e.borderRadiusSM,
    borderRadiusSM: e.borderRadiusXS,
    controlHeight: e.controlHeightSM
  }), c = lo(e, {
    fontHeight: r(e.multipleItemHeightLG).sub(r(a).mul(2).equal()).equal(),
    fontSize: e.fontSizeLG,
    selectHeight: e.controlHeightLG,
    multipleSelectItemHeight: e.multipleItemHeightLG,
    borderRadius: e.borderRadiusLG,
    borderRadiusSM: e.borderRadius,
    controlHeight: e.controlHeightLG
  });
  return [
    // ======================== Size ========================
    mR(i, "small"),
    mR(e),
    mR(c, "large"),
    // ====================== Selection ======================
    {
      [`${t}${t}-multiple`]: Object.assign(Object.assign({
        width: "100%",
        cursor: "text",
        // ==================== Selector =====================
        [`${t}-selector`]: {
          flex: "auto",
          padding: 0,
          position: "relative",
          "&:after": {
            margin: 0
          },
          // ================== placeholder ==================
          [`${t}-selection-placeholder`]: {
            position: "absolute",
            top: "50%",
            insetInlineStart: e.inputPaddingHorizontalBase,
            insetInlineEnd: 0,
            transform: "translateY(-50%)",
            transition: `all ${e.motionDurationSlow}`,
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            flex: 1,
            color: e.colorTextPlaceholder,
            pointerEvents: "none"
          }
        }
      }, gY(e)), {
        // ====================== Input ======================
        // Input is `readonly`, which is used for a11y only
        [`${t}-multiple-input`]: {
          width: 0,
          height: 0,
          border: 0,
          visibility: "hidden",
          position: "absolute",
          zIndex: -1
        }
      })
    }
  ];
}, Dbe = (e) => {
  const {
    pickerCellCls: t,
    pickerCellInnerCls: r,
    cellHeight: a,
    borderRadiusSM: i,
    motionDurationMid: c,
    cellHoverBg: d,
    lineWidth: f,
    lineType: p,
    colorPrimary: g,
    cellActiveWithRangeBg: b,
    colorTextLightSolid: w,
    colorTextDisabled: x,
    cellBgDisabled: E,
    colorFillSecondary: P
  } = e;
  return {
    "&::before": {
      position: "absolute",
      top: "50%",
      insetInlineStart: 0,
      insetInlineEnd: 0,
      zIndex: 1,
      height: a,
      transform: "translateY(-50%)",
      content: '""',
      pointerEvents: "none"
    },
    // >>> Default
    [r]: {
      position: "relative",
      zIndex: 2,
      display: "inline-block",
      minWidth: a,
      height: a,
      lineHeight: Ye(a),
      borderRadius: i,
      transition: `background ${c}`
    },
    // >>> Hover
    [`&:hover:not(${t}-in-view):not(${t}-disabled),
    &:hover:not(${t}-selected):not(${t}-range-start):not(${t}-range-end):not(${t}-disabled)`]: {
      [r]: {
        background: d
      }
    },
    // >>> Today
    [`&-in-view${t}-today ${r}`]: {
      "&::before": {
        position: "absolute",
        top: 0,
        insetInlineEnd: 0,
        bottom: 0,
        insetInlineStart: 0,
        zIndex: 1,
        border: `${Ye(f)} ${p} ${g}`,
        borderRadius: i,
        content: '""'
      }
    },
    // >>> In Range
    [`&-in-view${t}-in-range,
      &-in-view${t}-range-start,
      &-in-view${t}-range-end`]: {
      position: "relative",
      [`&:not(${t}-disabled):before`]: {
        background: b
      }
    },
    // >>> Selected
    [`&-in-view${t}-selected,
      &-in-view${t}-range-start,
      &-in-view${t}-range-end`]: {
      [`&:not(${t}-disabled) ${r}`]: {
        color: w,
        background: g
      },
      [`&${t}-disabled ${r}`]: {
        background: P
      }
    },
    [`&-in-view${t}-range-start:not(${t}-disabled):before`]: {
      insetInlineStart: "50%"
    },
    [`&-in-view${t}-range-end:not(${t}-disabled):before`]: {
      insetInlineEnd: "50%"
    },
    // range start border-radius
    [`&-in-view${t}-range-start:not(${t}-range-end) ${r}`]: {
      borderStartStartRadius: i,
      borderEndStartRadius: i,
      borderStartEndRadius: 0,
      borderEndEndRadius: 0
    },
    // range end border-radius
    [`&-in-view${t}-range-end:not(${t}-range-start) ${r}`]: {
      borderStartStartRadius: 0,
      borderEndStartRadius: 0,
      borderStartEndRadius: i,
      borderEndEndRadius: i
    },
    // >>> Disabled
    "&-disabled": {
      color: x,
      cursor: "not-allowed",
      [r]: {
        background: "transparent"
      },
      "&::before": {
        background: E
      }
    },
    [`&-disabled${t}-today ${r}::before`]: {
      borderColor: x
    }
  };
}, $be = (e) => {
  const {
    componentCls: t,
    pickerCellCls: r,
    pickerCellInnerCls: a,
    pickerYearMonthCellWidth: i,
    pickerControlIconSize: c,
    cellWidth: d,
    paddingSM: f,
    paddingXS: p,
    paddingXXS: g,
    colorBgContainer: b,
    lineWidth: w,
    lineType: x,
    borderRadiusLG: E,
    colorPrimary: P,
    colorTextHeading: k,
    colorSplit: M,
    pickerControlIconBorderWidth: T,
    colorIcon: N,
    textHeight: D,
    motionDurationMid: $,
    colorIconHover: j,
    fontWeightStrong: I,
    cellHeight: L,
    pickerCellPaddingVertical: F,
    colorTextDisabled: _,
    colorText: W,
    fontSize: Q,
    motionDurationSlow: U,
    withoutTimeCellHeight: Y,
    pickerQuarterPanelContentHeight: G,
    borderRadiusSM: J,
    colorTextLightSolid: H,
    cellHoverBg: K,
    timeColumnHeight: X,
    timeColumnWidth: te,
    timeCellHeight: ie,
    controlItemBgActive: ee,
    marginXXS: ne,
    pickerDatePanelPaddingHorizontal: ae,
    pickerControlIconMargin: oe
  } = e, fe = e.calc(d).mul(7).add(e.calc(ae).mul(2)).equal();
  return {
    [t]: {
      "&-panel": {
        display: "inline-flex",
        flexDirection: "column",
        textAlign: "center",
        background: b,
        borderRadius: E,
        outline: "none",
        "&-focused": {
          borderColor: P
        },
        "&-rtl": {
          [`${t}-prev-icon,
              ${t}-super-prev-icon`]: {
            transform: "rotate(45deg)"
          },
          [`${t}-next-icon,
              ${t}-super-next-icon`]: {
            transform: "rotate(-135deg)"
          },
          [`${t}-time-panel`]: {
            [`${t}-content`]: {
              direction: "ltr",
              "> *": {
                direction: "rtl"
              }
            }
          }
        }
      },
      // ========================================================
      // =                     Shared Panel                     =
      // ========================================================
      "&-decade-panel,\n        &-year-panel,\n        &-quarter-panel,\n        &-month-panel,\n        &-week-panel,\n        &-date-panel,\n        &-time-panel": {
        display: "flex",
        flexDirection: "column",
        width: fe
      },
      // ======================= Header =======================
      "&-header": {
        display: "flex",
        padding: `0 ${Ye(p)}`,
        color: k,
        borderBottom: `${Ye(w)} ${x} ${M}`,
        "> *": {
          flex: "none"
        },
        button: {
          padding: 0,
          color: N,
          lineHeight: Ye(D),
          background: "transparent",
          border: 0,
          cursor: "pointer",
          transition: `color ${$}`,
          fontSize: "inherit",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          "&:empty": {
            display: "none"
          }
        },
        "> button": {
          minWidth: "1.6em",
          fontSize: Q,
          "&:hover": {
            color: j
          },
          "&:disabled": {
            opacity: 0.25,
            pointerEvents: "none"
          }
        },
        "&-view": {
          flex: "auto",
          fontWeight: I,
          lineHeight: Ye(D),
          "> button": {
            color: "inherit",
            fontWeight: "inherit",
            verticalAlign: "top",
            "&:not(:first-child)": {
              marginInlineStart: p
            },
            "&:hover": {
              color: P
            }
          }
        }
      },
      // Arrow button
      "&-prev-icon,\n        &-next-icon,\n        &-super-prev-icon,\n        &-super-next-icon": {
        position: "relative",
        width: c,
        height: c,
        "&::before": {
          position: "absolute",
          top: 0,
          insetInlineStart: 0,
          width: c,
          height: c,
          border: "0 solid currentcolor",
          borderBlockStartWidth: T,
          borderInlineStartWidth: T,
          content: '""'
        }
      },
      "&-super-prev-icon,\n        &-super-next-icon": {
        "&::after": {
          position: "absolute",
          top: oe,
          insetInlineStart: oe,
          display: "inline-block",
          width: c,
          height: c,
          border: "0 solid currentcolor",
          borderBlockStartWidth: T,
          borderInlineStartWidth: T,
          content: '""'
        }
      },
      "&-prev-icon, &-super-prev-icon": {
        transform: "rotate(-45deg)"
      },
      "&-next-icon, &-super-next-icon": {
        transform: "rotate(135deg)"
      },
      // ======================== Body ========================
      "&-content": {
        width: "100%",
        tableLayout: "fixed",
        borderCollapse: "collapse",
        "th, td": {
          position: "relative",
          minWidth: L,
          fontWeight: "normal"
        },
        th: {
          height: e.calc(L).add(e.calc(F).mul(2)).equal(),
          color: W,
          verticalAlign: "middle"
        }
      },
      "&-cell": Object.assign({
        padding: `${Ye(F)} 0`,
        color: _,
        cursor: "pointer",
        // In view
        "&-in-view": {
          color: W
        }
      }, Dbe(e)),
      "&-decade-panel,\n        &-year-panel,\n        &-quarter-panel,\n        &-month-panel": {
        [`${t}-content`]: {
          height: e.calc(Y).mul(4).equal()
        },
        [a]: {
          padding: `0 ${Ye(p)}`
        }
      },
      "&-quarter-panel": {
        [`${t}-content`]: {
          height: G
        }
      },
      // ========================================================
      // =                       Special                        =
      // ========================================================
      // ===================== Decade Panel =====================
      "&-decade-panel": {
        [a]: {
          padding: `0 ${Ye(e.calc(p).div(2).equal())}`
        },
        [`${t}-cell::before`]: {
          display: "none"
        }
      },
      // ============= Year & Quarter & Month Panel =============
      "&-year-panel,\n        &-quarter-panel,\n        &-month-panel": {
        [`${t}-body`]: {
          padding: `0 ${Ye(p)}`
        },
        [a]: {
          width: i
        }
      },
      // ====================== Date Panel ======================
      "&-date-panel": {
        [`${t}-body`]: {
          padding: `${Ye(p)} ${Ye(ae)}`
        },
        [`${t}-content th`]: {
          boxSizing: "border-box",
          padding: 0
        }
      },
      // ====================== Week Panel ======================
      "&-week-panel-row": {
        td: {
          "&:before": {
            transition: `background ${$}`
          },
          "&:first-child:before": {
            borderStartStartRadius: J,
            borderEndStartRadius: J
          },
          "&:last-child:before": {
            borderStartEndRadius: J,
            borderEndEndRadius: J
          }
        },
        "&:hover td:before": {
          background: K
        },
        "&-range-start td, &-range-end td, &-selected td, &-hover td": {
          // Rise priority to override hover style
          [`&${r}`]: {
            "&:before": {
              background: P
            },
            [`&${t}-cell-week`]: {
              color: new ro(H).setA(0.5).toHexString()
            },
            [a]: {
              color: H
            }
          }
        },
        "&-range-hover td:before": {
          background: ee
        }
      },
      // >>> ShowWeek
      "&-week-panel, &-date-panel-show-week": {
        [`${t}-body`]: {
          padding: `${Ye(p)} ${Ye(f)}`
        },
        [`${t}-content th`]: {
          width: "auto"
        }
      },
      // ==================== Datetime Panel ====================
      "&-datetime-panel": {
        display: "flex",
        [`${t}-time-panel`]: {
          borderInlineStart: `${Ye(w)} ${x} ${M}`
        },
        [`${t}-date-panel,
          ${t}-time-panel`]: {
          transition: `opacity ${U}`
        },
        // Keyboard
        "&-active": {
          [`${t}-date-panel,
            ${t}-time-panel`]: {
            opacity: 0.3,
            "&-active": {
              opacity: 1
            }
          }
        }
      },
      // ====================== Time Panel ======================
      "&-time-panel": {
        width: "auto",
        minWidth: "auto",
        [`${t}-content`]: {
          display: "flex",
          flex: "auto",
          height: X
        },
        "&-column": {
          flex: "1 0 auto",
          width: te,
          margin: `${Ye(g)} 0`,
          padding: 0,
          overflowY: "hidden",
          textAlign: "start",
          listStyle: "none",
          transition: `background ${$}`,
          overflowX: "hidden",
          "&::-webkit-scrollbar": {
            width: 8,
            backgroundColor: "transparent"
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: e.colorTextTertiary,
            borderRadius: e.borderRadiusSM
          },
          // For Firefox
          "&": {
            scrollbarWidth: "thin",
            scrollbarColor: `${e.colorTextTertiary} transparent`
          },
          "&::after": {
            display: "block",
            height: `calc(100% - ${Ye(ie)})`,
            content: '""'
          },
          "&:not(:first-child)": {
            borderInlineStart: `${Ye(w)} ${x} ${M}`
          },
          "&-active": {
            background: new ro(ee).setA(0.2).toHexString()
          },
          "&:hover": {
            overflowY: "auto"
          },
          "> li": {
            margin: 0,
            padding: 0,
            [`&${t}-time-panel-cell`]: {
              marginInline: ne,
              [`${t}-time-panel-cell-inner`]: {
                display: "block",
                width: e.calc(te).sub(e.calc(ne).mul(2)).equal(),
                height: ie,
                margin: 0,
                paddingBlock: 0,
                paddingInlineEnd: 0,
                paddingInlineStart: e.calc(te).sub(ie).div(2).equal(),
                color: W,
                lineHeight: Ye(ie),
                borderRadius: J,
                cursor: "pointer",
                transition: `background ${$}`,
                "&:hover": {
                  background: K
                }
              },
              "&-selected": {
                [`${t}-time-panel-cell-inner`]: {
                  background: ee
                }
              },
              "&-disabled": {
                [`${t}-time-panel-cell-inner`]: {
                  color: _,
                  background: "transparent",
                  cursor: "not-allowed"
                }
              }
            }
          }
        }
      }
    }
  };
}, zbe = (e) => {
  const {
    componentCls: t,
    textHeight: r,
    lineWidth: a,
    paddingSM: i,
    antCls: c,
    colorPrimary: d,
    cellActiveWithRangeBg: f,
    colorPrimaryBorder: p,
    lineType: g,
    colorSplit: b
  } = e;
  return {
    [`${t}-dropdown`]: {
      // ======================== Footer ========================
      [`${t}-footer`]: {
        borderTop: `${Ye(a)} ${g} ${b}`,
        "&-extra": {
          padding: `0 ${Ye(i)}`,
          lineHeight: Ye(e.calc(r).sub(e.calc(a).mul(2)).equal()),
          textAlign: "start",
          "&:not(:last-child)": {
            borderBottom: `${Ye(a)} ${g} ${b}`
          }
        }
      },
      // ==================== Footer > Ranges ===================
      [`${t}-panels + ${t}-footer ${t}-ranges`]: {
        justifyContent: "space-between"
      },
      [`${t}-ranges`]: {
        marginBlock: 0,
        paddingInline: Ye(i),
        overflow: "hidden",
        textAlign: "start",
        listStyle: "none",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        "> li": {
          lineHeight: Ye(e.calc(r).sub(e.calc(a).mul(2)).equal()),
          display: "inline-block"
        },
        [`${t}-now-btn-disabled`]: {
          pointerEvents: "none",
          color: e.colorTextDisabled
        },
        // https://github.com/ant-design/ant-design/issues/23687
        [`${t}-preset > ${c}-tag-blue`]: {
          color: d,
          background: f,
          borderColor: p,
          cursor: "pointer"
        },
        [`${t}-ok`]: {
          paddingBlock: e.calc(a).mul(2).equal(),
          marginInlineStart: "auto"
        }
      }
    }
  };
}, jbe = (e) => {
  const {
    componentCls: t,
    controlHeightLG: r,
    paddingXXS: a,
    padding: i
  } = e;
  return {
    pickerCellCls: `${t}-cell`,
    pickerCellInnerCls: `${t}-cell-inner`,
    pickerYearMonthCellWidth: e.calc(r).mul(1.5).equal(),
    pickerQuarterPanelContentHeight: e.calc(r).mul(1.4).equal(),
    pickerCellPaddingVertical: e.calc(a).add(e.calc(a).div(2)).equal(),
    pickerCellBorderGap: 2,
    // Magic for gap between cells
    pickerControlIconSize: 7,
    pickerControlIconMargin: 4,
    pickerControlIconBorderWidth: 1.5,
    pickerDatePanelPaddingHorizontal: e.calc(i).add(e.calc(a).div(2)).equal()
    // 18 in normal
  };
}, Ibe = (e) => {
  const {
    colorBgContainerDisabled: t,
    controlHeight: r,
    controlHeightSM: a,
    controlHeightLG: i,
    paddingXXS: c,
    lineWidth: d
  } = e, f = c * 2, p = d * 2, g = Math.min(r - f, r - p), b = Math.min(a - f, a - p), w = Math.min(i - f, i - p);
  return {
    INTERNAL_FIXED_ITEM_MARGIN: Math.floor(c / 2),
    cellHoverBg: e.controlItemBgHover,
    cellActiveWithRangeBg: e.controlItemBgActive,
    cellHoverWithRangeBg: new ro(e.colorPrimary).lighten(35).toHexString(),
    cellRangeBorderColor: new ro(e.colorPrimary).lighten(20).toHexString(),
    cellBgDisabled: t,
    timeColumnWidth: i * 1.4,
    timeColumnHeight: 224,
    timeCellHeight: 28,
    cellWidth: a * 1.5,
    cellHeight: a,
    textHeight: i,
    withoutTimeCellHeight: i * 1.65,
    multipleItemBg: e.colorFillSecondary,
    multipleItemBorderColor: "transparent",
    multipleItemHeight: g,
    multipleItemHeightSM: b,
    multipleItemHeightLG: w,
    multipleSelectorBgDisabled: t,
    multipleItemColorDisabled: e.colorTextDisabled,
    multipleItemBorderColorDisabled: "transparent"
  };
}, Lbe = (e) => Object.assign(Object.assign(Object.assign(Object.assign({}, mM(e)), Ibe(e)), nM(e)), {
  presetsWidth: 120,
  presetsMaxWidth: 200,
  zIndexPopup: e.zIndexPopupBase + 50
}), Hbe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: [
      Object.assign(Object.assign(Object.assign(Object.assign({}, LQ(e)), _Q(e)), WQ(e)), HQ(e)),
      // ========================= Multiple =========================
      {
        "&-outlined": {
          [`&${t}-multiple ${t}-selection-item`]: {
            background: e.multipleItemBg,
            border: `${Ye(e.lineWidth)} ${e.lineType} ${e.multipleItemBorderColor}`
          }
        },
        "&-filled": {
          [`&${t}-multiple ${t}-selection-item`]: {
            background: e.colorBgContainer,
            border: `${Ye(e.lineWidth)} ${e.lineType} ${e.colorSplit}`
          }
        },
        "&-borderless": {
          [`&${t}-multiple ${t}-selection-item`]: {
            background: e.multipleItemBg,
            border: `${Ye(e.lineWidth)} ${e.lineType} ${e.multipleItemBorderColor}`
          }
        },
        "&-underlined": {
          [`&${t}-multiple ${t}-selection-item`]: {
            background: e.multipleItemBg,
            border: `${Ye(e.lineWidth)} ${e.lineType} ${e.multipleItemBorderColor}`
          }
        }
      }
    ]
  };
}, hR = (e, t) => ({
  padding: `${Ye(e)} ${Ye(t)}`
}), Fbe = (e) => {
  const {
    componentCls: t,
    colorError: r,
    colorWarning: a
  } = e;
  return {
    [`${t}:not(${t}-disabled):not([disabled])`]: {
      [`&${t}-status-error`]: {
        [`${t}-active-bar`]: {
          background: r
        }
      },
      [`&${t}-status-warning`]: {
        [`${t}-active-bar`]: {
          background: a
        }
      }
    }
  };
}, Wbe = (e) => {
  var t;
  const {
    componentCls: r,
    antCls: a,
    paddingInline: i,
    lineWidth: c,
    lineType: d,
    colorBorder: f,
    borderRadius: p,
    motionDurationMid: g,
    colorTextDisabled: b,
    colorTextPlaceholder: w,
    colorTextQuaternary: x,
    fontSizeLG: E,
    inputFontSizeLG: P,
    fontSizeSM: k,
    inputFontSizeSM: M,
    controlHeightSM: T,
    paddingInlineSM: N,
    paddingXS: D,
    marginXS: $,
    colorIcon: j,
    lineWidthBold: I,
    colorPrimary: L,
    motionDurationSlow: F,
    zIndexPopup: _,
    paddingXXS: W,
    sizePopupArrow: Q,
    colorBgElevated: U,
    borderRadiusLG: Y,
    boxShadowSecondary: G,
    borderRadiusSM: J,
    colorSplit: H,
    cellHoverBg: K,
    presetsWidth: X,
    presetsMaxWidth: te,
    boxShadowPopoverArrow: ie,
    fontHeight: ee,
    lineHeightLG: ne
  } = e;
  return [
    {
      [r]: Object.assign(Object.assign(Object.assign({}, dl(e)), hR(e.paddingBlock, e.paddingInline)), {
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        lineHeight: 1,
        borderRadius: p,
        transition: `border ${g}, box-shadow ${g}, background ${g}`,
        [`${r}-prefix`]: {
          flex: "0 0 auto",
          marginInlineEnd: e.inputAffixPadding
        },
        // ======================== Input =========================
        [`${r}-input`]: {
          position: "relative",
          display: "inline-flex",
          alignItems: "center",
          width: "100%",
          "> input": Object.assign(Object.assign({
            position: "relative",
            display: "inline-block",
            width: "100%",
            color: "inherit",
            fontSize: (t = e.inputFontSize) !== null && t !== void 0 ? t : e.fontSize,
            lineHeight: e.lineHeight,
            transition: `all ${g}`
          }, BQ(w)), {
            flex: "auto",
            // Fix Firefox flex not correct:
            // https://github.com/ant-design/ant-design/pull/20023#issuecomment-564389553
            minWidth: 1,
            height: "auto",
            padding: 0,
            background: "transparent",
            border: 0,
            fontFamily: "inherit",
            "&:focus": {
              boxShadow: "none",
              outline: 0
            },
            "&[disabled]": {
              background: "transparent",
              color: b,
              cursor: "not-allowed"
            }
          }),
          "&-placeholder": {
            "> input": {
              color: w
            }
          }
        },
        // Size
        "&-large": Object.assign(Object.assign({}, hR(e.paddingBlockLG, e.paddingInlineLG)), {
          [`${r}-input > input`]: {
            fontSize: P ?? E,
            lineHeight: ne
          }
        }),
        "&-small": Object.assign(Object.assign({}, hR(e.paddingBlockSM, e.paddingInlineSM)), {
          [`${r}-input > input`]: {
            fontSize: M ?? k
          }
        }),
        [`${r}-suffix`]: {
          display: "flex",
          flex: "none",
          alignSelf: "center",
          marginInlineStart: e.calc(D).div(2).equal(),
          color: x,
          lineHeight: 1,
          pointerEvents: "none",
          transition: `opacity ${g}, color ${g}`,
          "> *": {
            verticalAlign: "top",
            "&:not(:last-child)": {
              marginInlineEnd: $
            }
          }
        },
        [`${r}-clear`]: {
          position: "absolute",
          top: "50%",
          insetInlineEnd: 0,
          color: x,
          lineHeight: 1,
          transform: "translateY(-50%)",
          cursor: "pointer",
          opacity: 0,
          transition: `opacity ${g}, color ${g}`,
          "> *": {
            verticalAlign: "top"
          },
          "&:hover": {
            color: j
          }
        },
        "&:hover": {
          [`${r}-clear`]: {
            opacity: 1
          },
          // Should use the following selector, but since `:has` has poor compatibility,
          // we use `:not(:last-child)` instead, which may cause some problems in some cases.
          // [`${componentCls}-suffix:has(+ ${componentCls}-clear)`]: {
          [`${r}-suffix:not(:last-child)`]: {
            opacity: 0
          }
        },
        [`${r}-separator`]: {
          position: "relative",
          display: "inline-block",
          width: "1em",
          height: E,
          color: x,
          fontSize: E,
          verticalAlign: "top",
          cursor: "default",
          [`${r}-focused &`]: {
            color: j
          },
          [`${r}-range-separator &`]: {
            [`${r}-disabled &`]: {
              cursor: "not-allowed"
            }
          }
        },
        // ======================== Range =========================
        "&-range": {
          position: "relative",
          display: "inline-flex",
          // Active bar
          [`${r}-active-bar`]: {
            bottom: e.calc(c).mul(-1).equal(),
            height: I,
            background: L,
            opacity: 0,
            transition: `all ${F} ease-out`,
            pointerEvents: "none"
          },
          [`&${r}-focused`]: {
            [`${r}-active-bar`]: {
              opacity: 1
            }
          },
          [`${r}-range-separator`]: {
            alignItems: "center",
            padding: `0 ${Ye(D)}`,
            lineHeight: 1
          }
        },
        // ======================== Clear =========================
        "&-range, &-multiple": {
          // Clear
          [`${r}-clear`]: {
            insetInlineEnd: i
          },
          [`&${r}-small`]: {
            [`${r}-clear`]: {
              insetInlineEnd: N
            }
          }
        },
        // ======================= Dropdown =======================
        "&-dropdown": Object.assign(Object.assign(Object.assign({}, dl(e)), $be(e)), {
          pointerEvents: "none",
          position: "absolute",
          // Fix incorrect position of picker popup
          // https://github.com/ant-design/ant-design/issues/35590
          top: -9999,
          left: {
            _skip_check_: !0,
            value: -9999
          },
          zIndex: _,
          [`&${r}-dropdown-hidden`]: {
            display: "none"
          },
          "&-rtl": {
            direction: "rtl"
          },
          [`&${r}-dropdown-placement-bottomLeft,
            &${r}-dropdown-placement-bottomRight`]: {
            [`${r}-range-arrow`]: {
              top: 0,
              display: "block",
              transform: "translateY(-100%)"
            }
          },
          [`&${r}-dropdown-placement-topLeft,
            &${r}-dropdown-placement-topRight`]: {
            [`${r}-range-arrow`]: {
              bottom: 0,
              display: "block",
              transform: "translateY(100%) rotate(180deg)"
            }
          },
          [`&${a}-slide-up-appear, &${a}-slide-up-enter`]: {
            [`${r}-range-arrow${r}-range-arrow`]: {
              transition: "none"
            }
          },
          [`&${a}-slide-up-enter${a}-slide-up-enter-active${r}-dropdown-placement-topLeft,
          &${a}-slide-up-enter${a}-slide-up-enter-active${r}-dropdown-placement-topRight,
          &${a}-slide-up-appear${a}-slide-up-appear-active${r}-dropdown-placement-topLeft,
          &${a}-slide-up-appear${a}-slide-up-appear-active${r}-dropdown-placement-topRight`]: {
            animationName: _9
          },
          [`&${a}-slide-up-enter${a}-slide-up-enter-active${r}-dropdown-placement-bottomLeft,
          &${a}-slide-up-enter${a}-slide-up-enter-active${r}-dropdown-placement-bottomRight,
          &${a}-slide-up-appear${a}-slide-up-appear-active${r}-dropdown-placement-bottomLeft,
          &${a}-slide-up-appear${a}-slide-up-appear-active${r}-dropdown-placement-bottomRight`]: {
            animationName: W9
          },
          // https://github.com/ant-design/ant-design/issues/48727
          [`&${a}-slide-up-leave ${r}-panel-container`]: {
            pointerEvents: "none"
          },
          [`&${a}-slide-up-leave${a}-slide-up-leave-active${r}-dropdown-placement-topLeft,
          &${a}-slide-up-leave${a}-slide-up-leave-active${r}-dropdown-placement-topRight`]: {
            animationName: B9
          },
          [`&${a}-slide-up-leave${a}-slide-up-leave-active${r}-dropdown-placement-bottomLeft,
          &${a}-slide-up-leave${a}-slide-up-leave-active${r}-dropdown-placement-bottomRight`]: {
            animationName: V9
          },
          // Time picker with additional style
          [`${r}-panel > ${r}-time-panel`]: {
            paddingTop: W
          },
          // ======================== Ranges ========================
          [`${r}-range-wrapper`]: {
            display: "flex",
            position: "relative"
          },
          [`${r}-range-arrow`]: Object.assign(Object.assign({
            position: "absolute",
            zIndex: 1,
            display: "none",
            paddingInline: e.calc(i).mul(1.5).equal(),
            boxSizing: "content-box",
            transition: `all ${F} ease-out`
          }, MY(e, U, ie)), {
            "&:before": {
              insetInlineStart: e.calc(i).mul(1.5).equal()
            }
          }),
          [`${r}-panel-container`]: {
            overflow: "hidden",
            verticalAlign: "top",
            background: U,
            borderRadius: Y,
            boxShadow: G,
            transition: `margin ${F}`,
            display: "inline-block",
            pointerEvents: "auto",
            // ======================== Layout ========================
            [`${r}-panel-layout`]: {
              display: "flex",
              flexWrap: "nowrap",
              alignItems: "stretch"
            },
            // ======================== Preset ========================
            [`${r}-presets`]: {
              display: "flex",
              flexDirection: "column",
              minWidth: X,
              maxWidth: te,
              ul: {
                height: 0,
                flex: "auto",
                listStyle: "none",
                overflow: "auto",
                margin: 0,
                padding: D,
                borderInlineEnd: `${Ye(c)} ${d} ${H}`,
                li: Object.assign(Object.assign({}, VS), {
                  borderRadius: J,
                  paddingInline: D,
                  paddingBlock: e.calc(T).sub(ee).div(2).equal(),
                  cursor: "pointer",
                  transition: `all ${F}`,
                  "+ li": {
                    marginTop: $
                  },
                  "&:hover": {
                    background: K
                  }
                })
              }
            },
            // ======================== Panels ========================
            [`${r}-panels`]: {
              display: "inline-flex",
              flexWrap: "nowrap",
              // [`${componentCls}-panel`]: {
              //   borderWidth: `0 0 ${unit(lineWidth)}`,
              // },
              "&:last-child": {
                [`${r}-panel`]: {
                  borderWidth: 0
                }
              }
            },
            [`${r}-panel`]: {
              verticalAlign: "top",
              background: "transparent",
              borderRadius: 0,
              borderWidth: 0,
              [`${r}-content, table`]: {
                textAlign: "center"
              },
              "&-focused": {
                borderColor: f
              }
            }
          }
        }),
        "&-dropdown-range": {
          padding: `${Ye(e.calc(Q).mul(2).div(3).equal())} 0`,
          "&-hidden": {
            display: "none"
          }
        },
        "&-rtl": {
          direction: "rtl",
          [`${r}-separator`]: {
            transform: "scale(-1, 1)"
          },
          [`${r}-footer`]: {
            "&-extra": {
              direction: "rtl"
            }
          }
        }
      })
    },
    // Follow code may reuse in other components
    BS(e, "slide-up"),
    BS(e, "slide-down"),
    Px(e, "move-up"),
    Px(e, "move-down")
  ];
}, XQ = Ii("DatePicker", (e) => {
  const t = lo(fM(e), jbe(e), {
    inputPaddingHorizontalBase: e.calc(e.paddingSM).sub(1).equal(),
    multipleSelectItemHeight: e.multipleItemHeight,
    selectHeight: e.controlHeight
  });
  return [
    zbe(t),
    Wbe(t),
    Hbe(t),
    Fbe(t),
    Nbe(t),
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    XE(e, {
      focusElCls: `${e.componentCls}-focused`
    })
  ];
}, Lbe);
var Vbe = {
  animating: !1,
  autoplaying: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlide: 0,
  direction: 1,
  dragging: !1,
  edgeDragged: !1,
  initialized: !1,
  lazyLoadedList: [],
  listHeight: null,
  listWidth: null,
  scrolling: !1,
  slideCount: null,
  slideHeight: null,
  slideWidth: null,
  swipeLeft: null,
  swiped: !1,
  // used by swipeEvent. differentites between touch and swipe.
  swiping: !1,
  touchObject: {
    startX: 0,
    startY: 0,
    curX: 0,
    curY: 0
  },
  trackStyle: {},
  trackWidth: 0,
  targetSlide: 0
};
function _be(e, t, r) {
  var a = r || {}, i = a.noTrailing, c = i === void 0 ? !1 : i, d = a.noLeading, f = d === void 0 ? !1 : d, p = a.debounceMode, g = p === void 0 ? void 0 : p, b, w = !1, x = 0;
  function E() {
    b && clearTimeout(b);
  }
  function P(M) {
    var T = M || {}, N = T.upcomingOnly, D = N === void 0 ? !1 : N;
    E(), w = !D;
  }
  function k() {
    for (var M = arguments.length, T = new Array(M), N = 0; N < M; N++)
      T[N] = arguments[N];
    var D = this, $ = Date.now() - x;
    if (w)
      return;
    function j() {
      x = Date.now(), t.apply(D, T);
    }
    function I() {
      b = void 0;
    }
    !f && g && !b && j(), E(), g === void 0 && $ > e ? f ? (x = Date.now(), c || (b = setTimeout(g ? I : j, e))) : j() : c !== !0 && (b = setTimeout(g ? I : j, g === void 0 ? e - $ : e));
  }
  return k.cancel = P, k;
}
function GQ(e, t, r) {
  var a = {}, i = a.atBegin, c = i === void 0 ? !1 : i;
  return _be(e, t, {
    debounceMode: c !== !1
  });
}
var VD = {
  accessibility: !0,
  adaptiveHeight: !1,
  afterChange: null,
  appendDots: function(t) {
    return /* @__PURE__ */ Re.createElement("ul", {
      style: {
        display: "block"
      }
    }, t);
  },
  arrows: !0,
  autoplay: !1,
  autoplaySpeed: 3e3,
  beforeChange: null,
  centerMode: !1,
  centerPadding: "50px",
  className: "",
  cssEase: "ease",
  customPaging: function(t) {
    return /* @__PURE__ */ Re.createElement("button", null, t + 1);
  },
  dots: !1,
  dotsClass: "slick-dots",
  draggable: !0,
  easing: "linear",
  edgeFriction: 0.35,
  fade: !1,
  focusOnSelect: !1,
  infinite: !0,
  initialSlide: 0,
  lazyLoad: null,
  nextArrow: null,
  onEdge: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: !1,
  pauseOnFocus: !1,
  pauseOnHover: !0,
  prevArrow: null,
  responsive: null,
  rows: 1,
  rtl: !1,
  slide: "div",
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: !0,
  swipeEvent: null,
  swipeToSlide: !1,
  touchMove: !0,
  touchThreshold: 5,
  useCSS: !0,
  useTransform: !0,
  variableWidth: !1,
  vertical: !1,
  waitForAnimate: !0,
  asNavFor: null
};
function _D(e, t, r) {
  return Math.max(t, Math.min(e, r));
}
var ox = function(t) {
  var r = ["onTouchStart", "onTouchMove", "onWheel"];
  r.includes(t._reactName) || t.preventDefault();
}, Zk = function(t) {
  for (var r = [], a = qQ(t), i = KQ(t), c = a; c < i; c++)
    t.lazyLoadedList.indexOf(c) < 0 && r.push(c);
  return r;
}, qQ = function(t) {
  return t.currentSlide - Bbe(t);
}, KQ = function(t) {
  return t.currentSlide + Ube(t);
}, Bbe = function(t) {
  return t.centerMode ? Math.floor(t.slidesToShow / 2) + (parseInt(t.centerPadding) > 0 ? 1 : 0) : 0;
}, Ube = function(t) {
  return t.centerMode ? Math.floor((t.slidesToShow - 1) / 2) + 1 + (parseInt(t.centerPadding) > 0 ? 1 : 0) : t.slidesToShow;
}, BD = function(t) {
  return t && t.offsetWidth || 0;
}, Mj = function(t) {
  return t && t.offsetHeight || 0;
}, YQ = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, a, i, c, d;
  return a = t.startX - t.curX, i = t.startY - t.curY, c = Math.atan2(i, a), d = Math.round(c * 180 / Math.PI), d < 0 && (d = 360 - Math.abs(d)), d <= 45 && d >= 0 || d <= 360 && d >= 315 ? "left" : d >= 135 && d <= 225 ? "right" : r === !0 ? d >= 35 && d <= 135 ? "up" : "down" : "vertical";
}, pM = function(t) {
  var r = !0;
  return t.infinite || (t.centerMode && t.currentSlide >= t.slideCount - 1 || t.slideCount <= t.slidesToShow || t.currentSlide >= t.slideCount - t.slidesToShow) && (r = !1), r;
}, pR = function(t, r) {
  var a = {};
  return r.forEach(function(i) {
    return a[i] = t[i];
  }), a;
}, Xbe = function(t) {
  var r = Re.Children.count(t.children), a = t.listRef, i = Math.ceil(BD(a)), c = t.trackRef && t.trackRef.node, d = Math.ceil(BD(c)), f;
  if (t.vertical)
    f = i;
  else {
    var p = t.centerMode && parseInt(t.centerPadding) * 2;
    typeof t.centerPadding == "string" && t.centerPadding.slice(-1) === "%" && (p *= i / 100), f = Math.ceil((i - p) / t.slidesToShow);
  }
  var g = a && Mj(a.querySelector('[data-index="0"]')), b = g * t.slidesToShow, w = t.currentSlide === void 0 ? t.initialSlide : t.currentSlide;
  t.rtl && t.currentSlide === void 0 && (w = r - 1 - t.initialSlide);
  var x = t.lazyLoadedList || [], E = Zk(ce(ce({}, t), {}, {
    currentSlide: w,
    lazyLoadedList: x
  }));
  x = x.concat(E);
  var P = {
    slideCount: r,
    slideWidth: f,
    listWidth: i,
    trackWidth: d,
    currentSlide: w,
    slideHeight: g,
    listHeight: b,
    lazyLoadedList: x
  };
  return t.autoplaying === null && t.autoplay && (P.autoplaying = "playing"), P;
}, Gbe = function(t) {
  var r = t.waitForAnimate, a = t.animating, i = t.fade, c = t.infinite, d = t.index, f = t.slideCount, p = t.lazyLoad, g = t.currentSlide, b = t.centerMode, w = t.slidesToScroll, x = t.slidesToShow, E = t.useCSS, P = t.lazyLoadedList;
  if (r && a) return {};
  var k = d, M, T, N, D = {}, $ = {}, j = c ? d : _D(d, 0, f - 1);
  if (i) {
    if (!c && (d < 0 || d >= f)) return {};
    d < 0 ? k = d + f : d >= f && (k = d - f), p && P.indexOf(k) < 0 && (P = P.concat(k)), D = {
      animating: !0,
      currentSlide: k,
      lazyLoadedList: P,
      targetSlide: k
    }, $ = {
      animating: !1,
      targetSlide: k
    };
  } else
    M = k, k < 0 ? (M = k + f, c ? f % w !== 0 && (M = f - f % w) : M = 0) : !pM(t) && k > g ? k = M = g : b && k >= f ? (k = c ? f : f - 1, M = c ? 0 : f - 1) : k >= f && (M = k - f, c ? f % w !== 0 && (M = 0) : M = f - x), !c && k + x >= f && (M = f - x), T = jE(ce(ce({}, t), {}, {
      slideIndex: k
    })), N = jE(ce(ce({}, t), {}, {
      slideIndex: M
    })), c || (T === N && (k = M), T = N), p && (P = P.concat(Zk(ce(ce({}, t), {}, {
      currentSlide: k
    })))), E ? (D = {
      animating: !0,
      currentSlide: M,
      trackStyle: QQ(ce(ce({}, t), {}, {
        left: T
      })),
      lazyLoadedList: P,
      targetSlide: j
    }, $ = {
      animating: !1,
      currentSlide: M,
      trackStyle: zE(ce(ce({}, t), {}, {
        left: N
      })),
      swipeLeft: null,
      targetSlide: j
    }) : D = {
      currentSlide: M,
      trackStyle: zE(ce(ce({}, t), {}, {
        left: N
      })),
      lazyLoadedList: P,
      targetSlide: j
    };
  return {
    state: D,
    nextState: $
  };
}, qbe = function(t, r) {
  var a, i, c, d, f, p = t.slidesToScroll, g = t.slidesToShow, b = t.slideCount, w = t.currentSlide, x = t.targetSlide, E = t.lazyLoad, P = t.infinite;
  if (d = b % p !== 0, a = d ? 0 : (b - w) % p, r.message === "previous")
    c = a === 0 ? p : g - a, f = w - c, E && !P && (i = w - c, f = i === -1 ? b - 1 : i), P || (f = x - p);
  else if (r.message === "next")
    c = a === 0 ? p : a, f = w + c, E && !P && (f = (w + p) % b + a), P || (f = x + p);
  else if (r.message === "dots")
    f = r.index * r.slidesToScroll;
  else if (r.message === "children") {
    if (f = r.index, P) {
      var k = tye(ce(ce({}, t), {}, {
        targetSlide: f
      }));
      f > r.currentSlide && k === "left" ? f = f - b : f < r.currentSlide && k === "right" && (f = f + b);
    }
  } else r.message === "index" && (f = Number(r.index));
  return f;
}, Kbe = function(t, r, a) {
  return t.target.tagName.match("TEXTAREA|INPUT|SELECT") || !r ? "" : t.keyCode === 37 ? a ? "next" : "previous" : t.keyCode === 39 ? a ? "previous" : "next" : "";
}, Ybe = function(t, r, a) {
  return t.target.tagName === "IMG" && ox(t), !r || !a && t.type.indexOf("mouse") !== -1 ? "" : {
    dragging: !0,
    touchObject: {
      startX: t.touches ? t.touches[0].pageX : t.clientX,
      startY: t.touches ? t.touches[0].pageY : t.clientY,
      curX: t.touches ? t.touches[0].pageX : t.clientX,
      curY: t.touches ? t.touches[0].pageY : t.clientY
    }
  };
}, Qbe = function(t, r) {
  var a = r.scrolling, i = r.animating, c = r.vertical, d = r.swipeToSlide, f = r.verticalSwiping, p = r.rtl, g = r.currentSlide, b = r.edgeFriction, w = r.edgeDragged, x = r.onEdge, E = r.swiped, P = r.swiping, k = r.slideCount, M = r.slidesToScroll, T = r.infinite, N = r.touchObject, D = r.swipeEvent, $ = r.listHeight, j = r.listWidth;
  if (!a) {
    if (i) return ox(t);
    c && d && f && ox(t);
    var I, L = {}, F = jE(r);
    N.curX = t.touches ? t.touches[0].pageX : t.clientX, N.curY = t.touches ? t.touches[0].pageY : t.clientY, N.swipeLength = Math.round(Math.sqrt(Math.pow(N.curX - N.startX, 2)));
    var _ = Math.round(Math.sqrt(Math.pow(N.curY - N.startY, 2)));
    if (!f && !P && _ > 10)
      return {
        scrolling: !0
      };
    f && (N.swipeLength = _);
    var W = (p ? -1 : 1) * (N.curX > N.startX ? 1 : -1);
    f && (W = N.curY > N.startY ? 1 : -1);
    var Q = Math.ceil(k / M), U = YQ(r.touchObject, f), Y = N.swipeLength;
    return T || (g === 0 && (U === "right" || U === "down") || g + 1 >= Q && (U === "left" || U === "up") || !pM(r) && (U === "left" || U === "up")) && (Y = N.swipeLength * b, w === !1 && x && (x(U), L.edgeDragged = !0)), !E && D && (D(U), L.swiped = !0), c ? I = F + Y * ($ / j) * W : p ? I = F - Y * W : I = F + Y * W, f && (I = F + Y * W), L = ce(ce({}, L), {}, {
      touchObject: N,
      swipeLeft: I,
      trackStyle: zE(ce(ce({}, r), {}, {
        left: I
      }))
    }), Math.abs(N.curX - N.startX) < Math.abs(N.curY - N.startY) * 0.8 || N.swipeLength > 10 && (L.swiping = !0, ox(t)), L;
  }
}, Jbe = function(t, r) {
  var a = r.dragging, i = r.swipe, c = r.touchObject, d = r.listWidth, f = r.touchThreshold, p = r.verticalSwiping, g = r.listHeight, b = r.swipeToSlide, w = r.scrolling, x = r.onSwipe, E = r.targetSlide, P = r.currentSlide, k = r.infinite;
  if (!a)
    return i && ox(t), {};
  var M = p ? g / f : d / f, T = YQ(c, p), N = {
    dragging: !1,
    edgeDragged: !1,
    scrolling: !1,
    swiping: !1,
    swiped: !1,
    swipeLeft: null,
    touchObject: {}
  };
  if (w || !c.swipeLength)
    return N;
  if (c.swipeLength > M) {
    ox(t), x && x(T);
    var D, $, j = k ? P : E;
    switch (T) {
      case "left":
      case "up":
        $ = j + CW(r), D = b ? SW(r, $) : $, N.currentDirection = 0;
        break;
      case "right":
      case "down":
        $ = j - CW(r), D = b ? SW(r, $) : $, N.currentDirection = 1;
        break;
      default:
        D = j;
    }
    N.triggerSlideHandler = D;
  } else {
    var I = jE(r);
    N.trackStyle = QQ(ce(ce({}, r), {}, {
      left: I
    }));
  }
  return N;
}, Zbe = function(t) {
  for (var r = t.infinite ? t.slideCount * 2 : t.slideCount, a = t.infinite ? t.slidesToShow * -1 : 0, i = t.infinite ? t.slidesToShow * -1 : 0, c = []; a < r; )
    c.push(a), a = i + t.slidesToScroll, i += Math.min(t.slidesToScroll, t.slidesToShow);
  return c;
}, SW = function(t, r) {
  var a = Zbe(t), i = 0;
  if (r > a[a.length - 1])
    r = a[a.length - 1];
  else
    for (var c in a) {
      if (r < a[c]) {
        r = i;
        break;
      }
      i = a[c];
    }
  return r;
}, CW = function(t) {
  var r = t.centerMode ? t.slideWidth * Math.floor(t.slidesToShow / 2) : 0;
  if (t.swipeToSlide) {
    var a, i = t.listRef, c = i.querySelectorAll && i.querySelectorAll(".slick-slide") || [];
    if (Array.from(c).every(function(p) {
      if (t.vertical) {
        if (p.offsetTop + Mj(p) / 2 > t.swipeLeft * -1)
          return a = p, !1;
      } else if (p.offsetLeft - r + BD(p) / 2 > t.swipeLeft * -1)
        return a = p, !1;
      return !0;
    }), !a)
      return 0;
    var d = t.rtl === !0 ? t.slideCount - t.currentSlide : t.currentSlide, f = Math.abs(a.dataset.index - d) || 1;
    return f;
  } else
    return t.slidesToScroll;
}, Oj = function(t, r) {
  return (
    // eslint-disable-next-line no-prototype-builtins
    r.reduce(function(a, i) {
      return a && t.hasOwnProperty(i);
    }, !0) ? null : console.error("Keys Missing:", t)
  );
}, zE = function(t) {
  Oj(t, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var r, a;
  if (!t.vertical)
    r = eye(t) * t.slideWidth;
  else {
    var i = t.unslick ? t.slideCount : t.slideCount + 2 * t.slidesToShow;
    a = i * t.slideHeight;
  }
  var c = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };
  if (t.useTransform) {
    var d = t.vertical ? "translate3d(0px, " + t.left + "px, 0px)" : "translate3d(" + t.left + "px, 0px, 0px)", f = t.vertical ? "translate3d(0px, " + t.left + "px, 0px)" : "translate3d(" + t.left + "px, 0px, 0px)", p = t.vertical ? "translateY(" + t.left + "px)" : "translateX(" + t.left + "px)";
    c = ce(ce({}, c), {}, {
      WebkitTransform: d,
      transform: f,
      msTransform: p
    });
  } else
    t.vertical ? c.top = t.left : c.left = t.left;
  return t.fade && (c = {
    opacity: 1
  }), r && (c.width = r), a && (c.height = a), window && !window.addEventListener && window.attachEvent && (t.vertical ? c.marginTop = t.left + "px" : c.marginLeft = t.left + "px"), c;
}, QQ = function(t) {
  Oj(t, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var r = zE(t);
  return t.useTransform ? (r.WebkitTransition = "-webkit-transform " + t.speed + "ms " + t.cssEase, r.transition = "transform " + t.speed + "ms " + t.cssEase) : t.vertical ? r.transition = "top " + t.speed + "ms " + t.cssEase : r.transition = "left " + t.speed + "ms " + t.cssEase, r;
}, jE = function(t) {
  if (t.unslick)
    return 0;
  Oj(t, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
  var r = t.slideIndex, a = t.trackRef, i = t.infinite, c = t.centerMode, d = t.slideCount, f = t.slidesToShow, p = t.slidesToScroll, g = t.slideWidth, b = t.listWidth, w = t.variableWidth, x = t.slideHeight, E = t.fade, P = t.vertical, k = 0, M, T, N = 0;
  if (E || t.slideCount === 1)
    return 0;
  var D = 0;
  if (i ? (D = -eS(t), d % p !== 0 && r + p > d && (D = -(r > d ? f - (r - d) : d % p)), c && (D += parseInt(f / 2))) : (d % p !== 0 && r + p > d && (D = f - d % p), c && (D = parseInt(f / 2))), k = D * g, N = D * x, P ? M = r * x * -1 + N : M = r * g * -1 + k, w === !0) {
    var $, j = a && a.node;
    if ($ = r + eS(t), T = j && j.childNodes[$], M = T ? T.offsetLeft * -1 : 0, c === !0) {
      $ = i ? r + eS(t) : r, T = j && j.children[$], M = 0;
      for (var I = 0; I < $; I++)
        M -= j && j.children[I] && j.children[I].offsetWidth;
      M -= parseInt(t.centerPadding), M += T && (b - T.offsetWidth) / 2;
    }
  }
  return M;
}, eS = function(t) {
  return t.unslick || !t.infinite ? 0 : t.variableWidth ? t.slideCount : t.slidesToShow + (t.centerMode ? 1 : 0);
}, mk = function(t) {
  return t.unslick || !t.infinite ? 0 : t.slideCount;
}, eye = function(t) {
  return t.slideCount === 1 ? 1 : eS(t) + t.slideCount + mk(t);
}, tye = function(t) {
  return t.targetSlide > t.currentSlide ? t.targetSlide > t.currentSlide + nye(t) ? "left" : "right" : t.targetSlide < t.currentSlide - rye(t) ? "right" : "left";
}, nye = function(t) {
  var r = t.slidesToShow, a = t.centerMode, i = t.rtl, c = t.centerPadding;
  if (a) {
    var d = (r - 1) / 2 + 1;
    return parseInt(c) > 0 && (d += 1), i && r % 2 === 0 && (d += 1), d;
  }
  return i ? 0 : r - 1;
}, rye = function(t) {
  var r = t.slidesToShow, a = t.centerMode, i = t.rtl, c = t.centerPadding;
  if (a) {
    var d = (r - 1) / 2 + 1;
    return parseInt(c) > 0 && (d += 1), !i && r % 2 === 0 && (d += 1), d;
  }
  return i ? r - 1 : 0;
}, xW = function() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}, aye = Object.keys(VD);
function oye(e) {
  return aye.reduce(function(t, r) {
    return e.hasOwnProperty(r) && (t[r] = e[r]), t;
  }, {});
}
function iye(e, t, r) {
  return t = Yh(t), Fx(e, tC() ? Reflect.construct(t, r || [], Yh(e).constructor) : t.apply(e, r));
}
var gR = function(t) {
  var r, a, i, c, d;
  t.rtl ? d = t.slideCount - 1 - t.index : d = t.index, i = d < 0 || d >= t.slideCount, t.centerMode ? (c = Math.floor(t.slidesToShow / 2), a = (d - t.currentSlide) % t.slideCount === 0, d > t.currentSlide - c - 1 && d <= t.currentSlide + c && (r = !0)) : r = t.currentSlide <= d && d < t.currentSlide + t.slidesToShow;
  var f;
  t.targetSlide < 0 ? f = t.targetSlide + t.slideCount : t.targetSlide >= t.slideCount ? f = t.targetSlide - t.slideCount : f = t.targetSlide;
  var p = d === f;
  return {
    "slick-slide": !0,
    "slick-active": r,
    "slick-center": a,
    "slick-cloned": i,
    "slick-current": p
    // dubious in case of RTL
  };
}, lye = function(t) {
  var r = {};
  return (t.variableWidth === void 0 || t.variableWidth === !1) && (r.width = t.slideWidth), t.fade && (r.position = "relative", t.vertical && t.slideHeight ? r.top = -t.index * parseInt(t.slideHeight) : r.left = -t.index * parseInt(t.slideWidth), r.opacity = t.currentSlide === t.index ? 1 : 0, r.zIndex = t.currentSlide === t.index ? 999 : 998, t.useCSS && (r.transition = "opacity " + t.speed + "ms " + t.cssEase + ", visibility " + t.speed + "ms " + t.cssEase)), r;
}, vR = function(t, r) {
  return t.key + "-" + r;
}, sye = function(t) {
  var r, a = [], i = [], c = [], d = Re.Children.count(t.children), f = qQ(t), p = KQ(t);
  return Re.Children.forEach(t.children, function(g, b) {
    var w, x = {
      message: "children",
      index: b,
      slidesToScroll: t.slidesToScroll,
      currentSlide: t.currentSlide
    };
    !t.lazyLoad || t.lazyLoad && t.lazyLoadedList.indexOf(b) >= 0 ? w = g : w = /* @__PURE__ */ Re.createElement("div", null);
    var E = lye(ce(ce({}, t), {}, {
      index: b
    })), P = w.props.className || "", k = gR(ce(ce({}, t), {}, {
      index: b
    }));
    if (a.push(/* @__PURE__ */ Re.cloneElement(w, {
      key: "original" + vR(w, b),
      "data-index": b,
      className: _e(k, P),
      tabIndex: "-1",
      "aria-hidden": !k["slick-active"],
      style: ce(ce({
        outline: "none"
      }, w.props.style || {}), E),
      onClick: function(N) {
        w.props && w.props.onClick && w.props.onClick(N), t.focusOnSelect && t.focusOnSelect(x);
      }
    })), t.infinite && d > 1 && t.fade === !1 && !t.unslick) {
      var M = d - b;
      M <= eS(t) && (r = -M, r >= f && (w = g), k = gR(ce(ce({}, t), {}, {
        index: r
      })), i.push(/* @__PURE__ */ Re.cloneElement(w, {
        key: "precloned" + vR(w, r),
        "data-index": r,
        tabIndex: "-1",
        className: _e(k, P),
        "aria-hidden": !k["slick-active"],
        style: ce(ce({}, w.props.style || {}), E),
        onClick: function(N) {
          w.props && w.props.onClick && w.props.onClick(N), t.focusOnSelect && t.focusOnSelect(x);
        }
      }))), r = d + b, r < p && (w = g), k = gR(ce(ce({}, t), {}, {
        index: r
      })), c.push(/* @__PURE__ */ Re.cloneElement(w, {
        key: "postcloned" + vR(w, r),
        "data-index": r,
        tabIndex: "-1",
        className: _e(k, P),
        "aria-hidden": !k["slick-active"],
        style: ce(ce({}, w.props.style || {}), E),
        onClick: function(N) {
          w.props && w.props.onClick && w.props.onClick(N), t.focusOnSelect && t.focusOnSelect(x);
        }
      }));
    }
  }), t.rtl ? i.concat(a, c).reverse() : i.concat(a, c);
}, uye = /* @__PURE__ */ (function(e) {
  function t() {
    var r;
    Vi(this, t);
    for (var a = arguments.length, i = new Array(a), c = 0; c < a; c++)
      i[c] = arguments[c];
    return r = iye(this, t, [].concat(i)), ge(r, "node", null), ge(r, "handleRef", function(d) {
      r.node = d;
    }), r;
  }
  return pd(t, e), _i(t, [{
    key: "render",
    value: function() {
      var a = sye(this.props), i = this.props, c = i.onMouseEnter, d = i.onMouseOver, f = i.onMouseLeave, p = {
        onMouseEnter: c,
        onMouseOver: d,
        onMouseLeave: f
      };
      return /* @__PURE__ */ Re.createElement("div", vt({
        ref: this.handleRef,
        className: "slick-track",
        style: this.props.trackStyle
      }, p), a);
    }
  }]);
})(Re.PureComponent);
function cye(e, t, r) {
  return t = Yh(t), Fx(e, tC() ? Reflect.construct(t, r || [], Yh(e).constructor) : t.apply(e, r));
}
var dye = function(t) {
  var r;
  return t.infinite ? r = Math.ceil(t.slideCount / t.slidesToScroll) : r = Math.ceil((t.slideCount - t.slidesToShow) / t.slidesToScroll) + 1, r;
}, fye = /* @__PURE__ */ (function(e) {
  function t() {
    return Vi(this, t), cye(this, t, arguments);
  }
  return pd(t, e), _i(t, [{
    key: "clickHandler",
    value: function(a, i) {
      i.preventDefault(), this.props.clickHandler(a);
    }
  }, {
    key: "render",
    value: function() {
      for (var a = this.props, i = a.onMouseEnter, c = a.onMouseOver, d = a.onMouseLeave, f = a.infinite, p = a.slidesToScroll, g = a.slidesToShow, b = a.slideCount, w = a.currentSlide, x = dye({
        slideCount: b,
        slidesToScroll: p,
        slidesToShow: g,
        infinite: f
      }), E = {
        onMouseEnter: i,
        onMouseOver: c,
        onMouseLeave: d
      }, P = [], k = 0; k < x; k++) {
        var M = (k + 1) * p - 1, T = f ? M : _D(M, 0, b - 1), N = T - (p - 1), D = f ? N : _D(N, 0, b - 1), $ = _e({
          "slick-active": f ? w >= D && w <= T : w === D
        }), j = {
          message: "dots",
          index: k,
          slidesToScroll: p,
          currentSlide: w
        }, I = this.clickHandler.bind(this, j);
        P = P.concat(/* @__PURE__ */ Re.createElement("li", {
          key: k,
          className: $
        }, /* @__PURE__ */ Re.cloneElement(this.props.customPaging(k), {
          onClick: I
        })));
      }
      return /* @__PURE__ */ Re.cloneElement(this.props.appendDots(P), ce({
        className: this.props.dotsClass
      }, E));
    }
  }]);
})(Re.PureComponent);
function JQ(e, t, r) {
  return t = Yh(t), Fx(e, tC() ? Reflect.construct(t, r || [], Yh(e).constructor) : t.apply(e, r));
}
var mye = /* @__PURE__ */ (function(e) {
  function t() {
    return Vi(this, t), JQ(this, t, arguments);
  }
  return pd(t, e), _i(t, [{
    key: "clickHandler",
    value: function(a, i) {
      i && i.preventDefault(), this.props.clickHandler(a, i);
    }
  }, {
    key: "render",
    value: function() {
      var a = {
        "slick-arrow": !0,
        "slick-prev": !0
      }, i = this.clickHandler.bind(this, {
        message: "previous"
      });
      !this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow) && (a["slick-disabled"] = !0, i = null);
      var c = {
        key: "0",
        "data-role": "none",
        className: _e(a),
        style: {
          display: "block"
        },
        onClick: i
      }, d = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      }, f;
      return this.props.prevArrow ? f = /* @__PURE__ */ Re.cloneElement(this.props.prevArrow, ce(ce({}, c), d)) : f = /* @__PURE__ */ Re.createElement("button", vt({
        key: "0",
        type: "button"
      }, c), " ", "Previous"), f;
    }
  }]);
})(Re.PureComponent), hye = /* @__PURE__ */ (function(e) {
  function t() {
    return Vi(this, t), JQ(this, t, arguments);
  }
  return pd(t, e), _i(t, [{
    key: "clickHandler",
    value: function(a, i) {
      i && i.preventDefault(), this.props.clickHandler(a, i);
    }
  }, {
    key: "render",
    value: function() {
      var a = {
        "slick-arrow": !0,
        "slick-next": !0
      }, i = this.clickHandler.bind(this, {
        message: "next"
      });
      pM(this.props) || (a["slick-disabled"] = !0, i = null);
      var c = {
        key: "1",
        "data-role": "none",
        className: _e(a),
        style: {
          display: "block"
        },
        onClick: i
      }, d = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      }, f;
      return this.props.nextArrow ? f = /* @__PURE__ */ Re.cloneElement(this.props.nextArrow, ce(ce({}, c), d)) : f = /* @__PURE__ */ Re.createElement("button", vt({
        key: "1",
        type: "button"
      }, c), " ", "Next"), f;
    }
  }]);
})(Re.PureComponent), pye = ["animating"];
function gye(e, t, r) {
  return t = Yh(t), Fx(e, tC() ? Reflect.construct(t, r || [], Yh(e).constructor) : t.apply(e, r));
}
var vye = /* @__PURE__ */ (function(e) {
  function t(r) {
    var a;
    Vi(this, t), a = gye(this, t, [r]), ge(a, "listRefHandler", function(c) {
      return a.list = c;
    }), ge(a, "trackRefHandler", function(c) {
      return a.track = c;
    }), ge(a, "adaptHeight", function() {
      if (a.props.adaptiveHeight && a.list) {
        var c = a.list.querySelector('[data-index="'.concat(a.state.currentSlide, '"]'));
        a.list.style.height = Mj(c) + "px";
      }
    }), ge(a, "componentDidMount", function() {
      if (a.props.onInit && a.props.onInit(), a.props.lazyLoad) {
        var c = Zk(ce(ce({}, a.props), a.state));
        c.length > 0 && (a.setState(function(f) {
          return {
            lazyLoadedList: f.lazyLoadedList.concat(c)
          };
        }), a.props.onLazyLoad && a.props.onLazyLoad(c));
      }
      var d = ce({
        listRef: a.list,
        trackRef: a.track
      }, a.props);
      a.updateState(d, !0, function() {
        a.adaptHeight(), a.props.autoplay && a.autoPlay("playing");
      }), a.props.lazyLoad === "progressive" && (a.lazyLoadTimer = setInterval(a.progressiveLazyLoad, 1e3)), a.ro = new OG(function() {
        a.state.animating ? (a.onWindowResized(!1), a.callbackTimers.push(setTimeout(function() {
          return a.onWindowResized();
        }, a.props.speed))) : a.onWindowResized();
      }), a.ro.observe(a.list), document.querySelectorAll && Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function(f) {
        f.onfocus = a.props.pauseOnFocus ? a.onSlideFocus : null, f.onblur = a.props.pauseOnFocus ? a.onSlideBlur : null;
      }), window.addEventListener ? window.addEventListener("resize", a.onWindowResized) : window.attachEvent("onresize", a.onWindowResized);
    }), ge(a, "componentWillUnmount", function() {
      a.animationEndCallback && clearTimeout(a.animationEndCallback), a.lazyLoadTimer && clearInterval(a.lazyLoadTimer), a.callbackTimers.length && (a.callbackTimers.forEach(function(c) {
        return clearTimeout(c);
      }), a.callbackTimers = []), window.addEventListener ? window.removeEventListener("resize", a.onWindowResized) : window.detachEvent("onresize", a.onWindowResized), a.autoplayTimer && clearInterval(a.autoplayTimer), a.ro.disconnect();
    }), ge(a, "componentDidUpdate", function(c) {
      if (a.checkImagesLoad(), a.props.onReInit && a.props.onReInit(), a.props.lazyLoad) {
        var d = Zk(ce(ce({}, a.props), a.state));
        d.length > 0 && (a.setState(function(g) {
          return {
            lazyLoadedList: g.lazyLoadedList.concat(d)
          };
        }), a.props.onLazyLoad && a.props.onLazyLoad(d));
      }
      a.adaptHeight();
      var f = ce(ce({
        listRef: a.list,
        trackRef: a.track
      }, a.props), a.state), p = a.didPropsChange(c);
      p && a.updateState(f, p, function() {
        a.state.currentSlide >= Re.Children.count(a.props.children) && a.changeSlide({
          message: "index",
          index: Re.Children.count(a.props.children) - a.props.slidesToShow,
          currentSlide: a.state.currentSlide
        }), (c.autoplay !== a.props.autoplay || c.autoplaySpeed !== a.props.autoplaySpeed) && (!c.autoplay && a.props.autoplay ? a.autoPlay("playing") : a.props.autoplay ? a.autoPlay("update") : a.pause("paused"));
      });
    }), ge(a, "onWindowResized", function(c) {
      a.debouncedResize && a.debouncedResize.cancel(), a.debouncedResize = GQ(50, function() {
        return a.resizeWindow(c);
      }), a.debouncedResize();
    }), ge(a, "resizeWindow", function() {
      var c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0, d = !!(a.track && a.track.node);
      if (d) {
        var f = ce(ce({
          listRef: a.list,
          trackRef: a.track
        }, a.props), a.state);
        a.updateState(f, c, function() {
          a.props.autoplay ? a.autoPlay("update") : a.pause("paused");
        }), a.setState({
          animating: !1
        }), clearTimeout(a.animationEndCallback), delete a.animationEndCallback;
      }
    }), ge(a, "updateState", function(c, d, f) {
      var p = Xbe(c);
      c = ce(ce(ce({}, c), p), {}, {
        slideIndex: p.currentSlide
      });
      var g = jE(c);
      c = ce(ce({}, c), {}, {
        left: g
      });
      var b = zE(c);
      (d || Re.Children.count(a.props.children) !== Re.Children.count(c.children)) && (p.trackStyle = b), a.setState(p, f);
    }), ge(a, "ssrInit", function() {
      if (a.props.variableWidth) {
        var c = 0, d = 0, f = [], p = eS(ce(ce(ce({}, a.props), a.state), {}, {
          slideCount: a.props.children.length
        })), g = mk(ce(ce(ce({}, a.props), a.state), {}, {
          slideCount: a.props.children.length
        }));
        a.props.children.forEach(function(I) {
          f.push(I.props.style.width), c += I.props.style.width;
        });
        for (var b = 0; b < p; b++)
          d += f[f.length - 1 - b], c += f[f.length - 1 - b];
        for (var w = 0; w < g; w++)
          c += f[w];
        for (var x = 0; x < a.state.currentSlide; x++)
          d += f[x];
        var E = {
          width: c + "px",
          left: -d + "px"
        };
        if (a.props.centerMode) {
          var P = "".concat(f[a.state.currentSlide], "px");
          E.left = "calc(".concat(E.left, " + (100% - ").concat(P, ") / 2 ) ");
        }
        return {
          trackStyle: E
        };
      }
      var k = Re.Children.count(a.props.children), M = ce(ce(ce({}, a.props), a.state), {}, {
        slideCount: k
      }), T = eS(M) + mk(M) + k, N = 100 / a.props.slidesToShow * T, D = 100 / T, $ = -D * (eS(M) + a.state.currentSlide) * N / 100;
      a.props.centerMode && ($ += (100 - D * N / 100) / 2);
      var j = {
        width: N + "%",
        left: $ + "%"
      };
      return {
        slideWidth: D + "%",
        trackStyle: j
      };
    }), ge(a, "checkImagesLoad", function() {
      var c = a.list && a.list.querySelectorAll && a.list.querySelectorAll(".slick-slide img") || [], d = c.length, f = 0;
      Array.prototype.forEach.call(c, function(p) {
        var g = function() {
          return ++f && f >= d && a.onWindowResized();
        };
        if (!p.onclick)
          p.onclick = function() {
            return p.parentNode.focus();
          };
        else {
          var b = p.onclick;
          p.onclick = function(w) {
            b(w), p.parentNode.focus();
          };
        }
        p.onload || (a.props.lazyLoad ? p.onload = function() {
          a.adaptHeight(), a.callbackTimers.push(setTimeout(a.onWindowResized, a.props.speed));
        } : (p.onload = g, p.onerror = function() {
          g(), a.props.onLazyLoadError && a.props.onLazyLoadError();
        }));
      });
    }), ge(a, "progressiveLazyLoad", function() {
      for (var c = [], d = ce(ce({}, a.props), a.state), f = a.state.currentSlide; f < a.state.slideCount + mk(d); f++)
        if (a.state.lazyLoadedList.indexOf(f) < 0) {
          c.push(f);
          break;
        }
      for (var p = a.state.currentSlide - 1; p >= -eS(d); p--)
        if (a.state.lazyLoadedList.indexOf(p) < 0) {
          c.push(p);
          break;
        }
      c.length > 0 ? (a.setState(function(g) {
        return {
          lazyLoadedList: g.lazyLoadedList.concat(c)
        };
      }), a.props.onLazyLoad && a.props.onLazyLoad(c)) : a.lazyLoadTimer && (clearInterval(a.lazyLoadTimer), delete a.lazyLoadTimer);
    }), ge(a, "slideHandler", function(c) {
      var d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, f = a.props, p = f.asNavFor, g = f.beforeChange, b = f.onLazyLoad, w = f.speed, x = f.afterChange, E = a.state.currentSlide, P = Gbe(ce(ce(ce({
        index: c
      }, a.props), a.state), {}, {
        trackRef: a.track,
        useCSS: a.props.useCSS && !d
      })), k = P.state, M = P.nextState;
      if (k) {
        g && g(E, k.currentSlide);
        var T = k.lazyLoadedList.filter(function(N) {
          return a.state.lazyLoadedList.indexOf(N) < 0;
        });
        b && T.length > 0 && b(T), !a.props.waitForAnimate && a.animationEndCallback && (clearTimeout(a.animationEndCallback), x && x(E), delete a.animationEndCallback), a.setState(k, function() {
          p && a.asNavForIndex !== c && (a.asNavForIndex = c, p.innerSlider.slideHandler(c)), M && (a.animationEndCallback = setTimeout(function() {
            var N = M.animating, D = xr(M, pye);
            a.setState(D, function() {
              a.callbackTimers.push(setTimeout(function() {
                return a.setState({
                  animating: N
                });
              }, 10)), x && x(k.currentSlide), delete a.animationEndCallback;
            });
          }, w));
        });
      }
    }), ge(a, "changeSlide", function(c) {
      var d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, f = ce(ce({}, a.props), a.state), p = qbe(f, c);
      if (!(p !== 0 && !p) && (d === !0 ? a.slideHandler(p, d) : a.slideHandler(p), a.props.autoplay && a.autoPlay("update"), a.props.focusOnSelect)) {
        var g = a.list.querySelectorAll(".slick-current");
        g[0] && g[0].focus();
      }
    }), ge(a, "clickHandler", function(c) {
      a.clickable === !1 && (c.stopPropagation(), c.preventDefault()), a.clickable = !0;
    }), ge(a, "keyHandler", function(c) {
      var d = Kbe(c, a.props.accessibility, a.props.rtl);
      d !== "" && a.changeSlide({
        message: d
      });
    }), ge(a, "selectHandler", function(c) {
      a.changeSlide(c);
    }), ge(a, "disableBodyScroll", function() {
      var c = function(f) {
        f = f || window.event, f.preventDefault && f.preventDefault(), f.returnValue = !1;
      };
      window.ontouchmove = c;
    }), ge(a, "enableBodyScroll", function() {
      window.ontouchmove = null;
    }), ge(a, "swipeStart", function(c) {
      a.props.verticalSwiping && a.disableBodyScroll();
      var d = Ybe(c, a.props.swipe, a.props.draggable);
      d !== "" && a.setState(d);
    }), ge(a, "swipeMove", function(c) {
      var d = Qbe(c, ce(ce(ce({}, a.props), a.state), {}, {
        trackRef: a.track,
        listRef: a.list,
        slideIndex: a.state.currentSlide
      }));
      d && (d.swiping && (a.clickable = !1), a.setState(d));
    }), ge(a, "swipeEnd", function(c) {
      var d = Jbe(c, ce(ce(ce({}, a.props), a.state), {}, {
        trackRef: a.track,
        listRef: a.list,
        slideIndex: a.state.currentSlide
      }));
      if (d) {
        var f = d.triggerSlideHandler;
        delete d.triggerSlideHandler, a.setState(d), f !== void 0 && (a.slideHandler(f), a.props.verticalSwiping && a.enableBodyScroll());
      }
    }), ge(a, "touchEnd", function(c) {
      a.swipeEnd(c), a.clickable = !0;
    }), ge(a, "slickPrev", function() {
      a.callbackTimers.push(setTimeout(function() {
        return a.changeSlide({
          message: "previous"
        });
      }, 0));
    }), ge(a, "slickNext", function() {
      a.callbackTimers.push(setTimeout(function() {
        return a.changeSlide({
          message: "next"
        });
      }, 0));
    }), ge(a, "slickGoTo", function(c) {
      var d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      if (c = Number(c), isNaN(c)) return "";
      a.callbackTimers.push(setTimeout(function() {
        return a.changeSlide({
          message: "index",
          index: c,
          currentSlide: a.state.currentSlide
        }, d);
      }, 0));
    }), ge(a, "play", function() {
      var c;
      if (a.props.rtl)
        c = a.state.currentSlide - a.props.slidesToScroll;
      else if (pM(ce(ce({}, a.props), a.state)))
        c = a.state.currentSlide + a.props.slidesToScroll;
      else
        return !1;
      a.slideHandler(c);
    }), ge(a, "autoPlay", function(c) {
      a.autoplayTimer && clearInterval(a.autoplayTimer);
      var d = a.state.autoplaying;
      if (c === "update") {
        if (d === "hovered" || d === "focused" || d === "paused")
          return;
      } else if (c === "leave") {
        if (d === "paused" || d === "focused")
          return;
      } else if (c === "blur" && (d === "paused" || d === "hovered"))
        return;
      a.autoplayTimer = setInterval(a.play, a.props.autoplaySpeed + 50), a.setState({
        autoplaying: "playing"
      });
    }), ge(a, "pause", function(c) {
      a.autoplayTimer && (clearInterval(a.autoplayTimer), a.autoplayTimer = null);
      var d = a.state.autoplaying;
      c === "paused" ? a.setState({
        autoplaying: "paused"
      }) : c === "focused" ? (d === "hovered" || d === "playing") && a.setState({
        autoplaying: "focused"
      }) : d === "playing" && a.setState({
        autoplaying: "hovered"
      });
    }), ge(a, "onDotsOver", function() {
      return a.props.autoplay && a.pause("hovered");
    }), ge(a, "onDotsLeave", function() {
      return a.props.autoplay && a.state.autoplaying === "hovered" && a.autoPlay("leave");
    }), ge(a, "onTrackOver", function() {
      return a.props.autoplay && a.pause("hovered");
    }), ge(a, "onTrackLeave", function() {
      return a.props.autoplay && a.state.autoplaying === "hovered" && a.autoPlay("leave");
    }), ge(a, "onSlideFocus", function() {
      return a.props.autoplay && a.pause("focused");
    }), ge(a, "onSlideBlur", function() {
      return a.props.autoplay && a.state.autoplaying === "focused" && a.autoPlay("blur");
    }), ge(a, "render", function() {
      var c = _e("slick-slider", a.props.className, {
        "slick-vertical": a.props.vertical,
        "slick-initialized": !0
      }), d = ce(ce({}, a.props), a.state), f = pR(d, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding", "targetSlide", "useCSS"]), p = a.props.pauseOnHover;
      f = ce(ce({}, f), {}, {
        onMouseEnter: p ? a.onTrackOver : null,
        onMouseLeave: p ? a.onTrackLeave : null,
        onMouseOver: p ? a.onTrackOver : null,
        focusOnSelect: a.props.focusOnSelect && a.clickable ? a.selectHandler : null
      });
      var g;
      if (a.props.dots === !0 && a.state.slideCount >= a.props.slidesToShow) {
        var b = pR(d, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]), w = a.props.pauseOnDotsHover;
        b = ce(ce({}, b), {}, {
          clickHandler: a.changeSlide,
          onMouseEnter: w ? a.onDotsLeave : null,
          onMouseOver: w ? a.onDotsOver : null,
          onMouseLeave: w ? a.onDotsLeave : null
        }), g = /* @__PURE__ */ Re.createElement(fye, b);
      }
      var x, E, P = pR(d, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      P.clickHandler = a.changeSlide, a.props.arrows && (x = /* @__PURE__ */ Re.createElement(mye, P), E = /* @__PURE__ */ Re.createElement(hye, P));
      var k = null;
      a.props.vertical && (k = {
        height: a.state.listHeight
      });
      var M = null;
      a.props.vertical === !1 ? a.props.centerMode === !0 && (M = {
        padding: "0px " + a.props.centerPadding
      }) : a.props.centerMode === !0 && (M = {
        padding: a.props.centerPadding + " 0px"
      });
      var T = ce(ce({}, k), M), N = a.props.touchMove, D = {
        className: "slick-list",
        style: T,
        onClick: a.clickHandler,
        onMouseDown: N ? a.swipeStart : null,
        onMouseMove: a.state.dragging && N ? a.swipeMove : null,
        onMouseUp: N ? a.swipeEnd : null,
        onMouseLeave: a.state.dragging && N ? a.swipeEnd : null,
        onTouchStart: N ? a.swipeStart : null,
        onTouchMove: a.state.dragging && N ? a.swipeMove : null,
        onTouchEnd: N ? a.touchEnd : null,
        onTouchCancel: a.state.dragging && N ? a.swipeEnd : null,
        onKeyDown: a.props.accessibility ? a.keyHandler : null
      }, $ = {
        className: c,
        dir: "ltr",
        style: a.props.style
      };
      return a.props.unslick && (D = {
        className: "slick-list"
      }, $ = {
        className: c,
        style: a.props.style
      }), /* @__PURE__ */ Re.createElement("div", $, a.props.unslick ? "" : x, /* @__PURE__ */ Re.createElement("div", vt({
        ref: a.listRefHandler
      }, D), /* @__PURE__ */ Re.createElement(uye, vt({
        ref: a.trackRefHandler
      }, f), a.props.children)), a.props.unslick ? "" : E, a.props.unslick ? "" : g);
    }), a.list = null, a.track = null, a.state = ce(ce({}, Vbe), {}, {
      currentSlide: a.props.initialSlide,
      targetSlide: a.props.initialSlide ? a.props.initialSlide : 0,
      slideCount: Re.Children.count(a.props.children)
    }), a.callbackTimers = [], a.clickable = !0, a.debouncedResize = null;
    var i = a.ssrInit();
    return a.state = ce(ce({}, a.state), i), a;
  }
  return pd(t, e), _i(t, [{
    key: "didPropsChange",
    value: function(a) {
      for (var i = !1, c = 0, d = Object.keys(this.props); c < d.length; c++) {
        var f = d[c];
        if (!a.hasOwnProperty(f)) {
          i = !0;
          break;
        }
        if (!(Hn(a[f]) === "object" || typeof a[f] == "function" || isNaN(a[f])) && a[f] !== this.props[f]) {
          i = !0;
          break;
        }
      }
      return i || Re.Children.count(this.props.children) !== Re.Children.count(a.children);
    }
  }]);
})(Re.Component), bR, EW;
function bye() {
  if (EW) return bR;
  EW = 1;
  var e = function(t) {
    return t.replace(/[A-Z]/g, function(r) {
      return "-" + r.toLowerCase();
    }).toLowerCase();
  };
  return bR = e, bR;
}
var yR, PW;
function yye() {
  if (PW) return yR;
  PW = 1;
  var e = bye(), t = function(i) {
    var c = /[height|width]$/;
    return c.test(i);
  }, r = function(i) {
    var c = "", d = Object.keys(i);
    return d.forEach(function(f, p) {
      var g = i[f];
      f = e(f), t(f) && typeof g == "number" && (g = g + "px"), g === !0 ? c += f : g === !1 ? c += "not " + f : c += "(" + f + ": " + g + ")", p < d.length - 1 && (c += " and ");
    }), c;
  }, a = function(i) {
    var c = "";
    return typeof i == "string" ? i : i instanceof Array ? (i.forEach(function(d, f) {
      c += r(d), f < i.length - 1 && (c += ", ");
    }), c) : r(i);
  };
  return yR = a, yR;
}
var wye = yye();
const wR = /* @__PURE__ */ Sb(wye);
function Sye(e, t, r) {
  return t = Yh(t), Fx(e, tC() ? Reflect.construct(t, r || [], Yh(e).constructor) : t.apply(e, r));
}
var Cye = /* @__PURE__ */ (function(e) {
  function t(r) {
    var a;
    return Vi(this, t), a = Sye(this, t, [r]), ge(a, "innerSliderRefHandler", function(i) {
      return a.innerSlider = i;
    }), ge(a, "slickPrev", function() {
      return a.innerSlider.slickPrev();
    }), ge(a, "slickNext", function() {
      return a.innerSlider.slickNext();
    }), ge(a, "slickGoTo", function(i) {
      var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      return a.innerSlider.slickGoTo(i, c);
    }), ge(a, "slickPause", function() {
      return a.innerSlider.pause("paused");
    }), ge(a, "slickPlay", function() {
      return a.innerSlider.autoPlay("play");
    }), a.state = {
      breakpoint: null
    }, a._responsiveMediaHandlers = [], a;
  }
  return pd(t, e), _i(t, [{
    key: "media",
    value: function(a, i) {
      var c = window.matchMedia(a), d = function(p) {
        var g = p.matches;
        g && i();
      };
      c.addListener(d), d(c), this._responsiveMediaHandlers.push({
        mql: c,
        query: a,
        listener: d
      });
    }
    // handles responsive breakpoints
  }, {
    key: "componentDidMount",
    value: function() {
      var a = this;
      if (this.props.responsive) {
        var i = this.props.responsive.map(function(d) {
          return d.breakpoint;
        });
        i.sort(function(d, f) {
          return d - f;
        }), i.forEach(function(d, f) {
          var p;
          f === 0 ? p = wR({
            minWidth: 0,
            maxWidth: d
          }) : p = wR({
            minWidth: i[f - 1] + 1,
            maxWidth: d
          }), xW() && a.media(p, function() {
            a.setState({
              breakpoint: d
            });
          });
        });
        var c = wR({
          minWidth: i.slice(-1)[0]
        });
        xW() && this.media(c, function() {
          a.setState({
            breakpoint: null
          });
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this._responsiveMediaHandlers.forEach(function(a) {
        a.mql.removeListener(a.listener);
      });
    }
  }, {
    key: "render",
    value: function() {
      var a = this, i, c;
      this.state.breakpoint ? (c = this.props.responsive.filter(function(k) {
        return k.breakpoint === a.state.breakpoint;
      }), i = c[0].settings === "unslick" ? "unslick" : ce(ce(ce({}, VD), this.props), c[0].settings)) : i = ce(ce({}, VD), this.props), i.centerMode && (i.slidesToScroll > 1 && process.env.NODE_ENV !== "production" && console.warn("slidesToScroll should be equal to 1 in centerMode, you are using ".concat(i.slidesToScroll)), i.slidesToScroll = 1), i.fade && (i.slidesToShow > 1 && process.env.NODE_ENV !== "production" && console.warn("slidesToShow should be equal to 1 when fade is true, you're using ".concat(i.slidesToShow)), i.slidesToScroll > 1 && process.env.NODE_ENV !== "production" && console.warn("slidesToScroll should be equal to 1 when fade is true, you're using ".concat(i.slidesToScroll)), i.slidesToShow = 1, i.slidesToScroll = 1);
      var d = Re.Children.toArray(this.props.children);
      d = d.filter(function(k) {
        return typeof k == "string" ? !!k.trim() : !!k;
      }), i.variableWidth && (i.rows > 1 || i.slidesPerRow > 1) && (console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1"), i.variableWidth = !1);
      for (var f = [], p = null, g = 0; g < d.length; g += i.rows * i.slidesPerRow) {
        for (var b = [], w = g; w < g + i.rows * i.slidesPerRow; w += i.slidesPerRow) {
          for (var x = [], E = w; E < w + i.slidesPerRow && (i.variableWidth && d[E].props.style && (p = d[E].props.style.width), !(E >= d.length)); E += 1)
            x.push(/* @__PURE__ */ Re.cloneElement(d[E], {
              key: 100 * g + 10 * w + E,
              tabIndex: -1,
              style: {
                width: "".concat(100 / i.slidesPerRow, "%"),
                display: "inline-block"
              }
            }));
          b.push(/* @__PURE__ */ Re.createElement("div", {
            key: 10 * g + w
          }, x));
        }
        i.variableWidth ? f.push(/* @__PURE__ */ Re.createElement("div", {
          key: g,
          style: {
            width: p
          }
        }, b)) : f.push(/* @__PURE__ */ Re.createElement("div", {
          key: g
        }, b));
      }
      if (i === "unslick") {
        var P = "regular slider " + (this.props.className || "");
        return /* @__PURE__ */ Re.createElement("div", {
          className: P
        }, d);
      } else f.length <= i.slidesToShow && !i.infinite && (i.unslick = !0);
      return /* @__PURE__ */ Re.createElement(vye, vt({
        style: this.props.style,
        ref: this.innerSliderRefHandler
      }, oye(i)), f);
    }
  }]);
})(Re.Component);
const Tj = "--dot-duration", xye = (e) => {
  const {
    componentCls: t,
    antCls: r
  } = e;
  return {
    [t]: Object.assign(Object.assign({}, dl(e)), {
      ".slick-slider": {
        position: "relative",
        display: "block",
        boxSizing: "border-box",
        touchAction: "pan-y",
        WebkitTouchCallout: "none",
        WebkitTapHighlightColor: "transparent",
        ".slick-track, .slick-list": {
          transform: "translate3d(0, 0, 0)",
          touchAction: "pan-y"
        }
      },
      ".slick-list": {
        position: "relative",
        display: "block",
        margin: 0,
        padding: 0,
        overflow: "hidden",
        "&:focus": {
          outline: "none"
        },
        "&.dragging": {
          cursor: "pointer"
        },
        ".slick-slide": {
          pointerEvents: "none",
          // https://github.com/ant-design/ant-design/issues/23294
          [`input${r}-radio-input, input${r}-checkbox-input`]: {
            visibility: "hidden"
          },
          "&.slick-active": {
            pointerEvents: "auto",
            [`input${r}-radio-input, input${r}-checkbox-input`]: {
              visibility: "visible"
            }
          },
          // fix Carousel content height not match parent node
          // when children is empty node
          // https://github.com/ant-design/ant-design/issues/25878
          "> div > div": {
            verticalAlign: "bottom"
          }
        }
      },
      ".slick-track": {
        position: "relative",
        top: 0,
        insetInlineStart: 0,
        display: "block",
        "&::before, &::after": {
          display: "table",
          content: '""'
        },
        "&::after": {
          clear: "both"
        }
      },
      ".slick-slide": {
        display: "none",
        float: "left",
        height: "100%",
        minHeight: 1,
        img: {
          display: "block"
        },
        "&.dragging img": {
          pointerEvents: "none"
        }
      },
      ".slick-initialized .slick-slide": {
        display: "block"
      },
      ".slick-vertical .slick-slide": {
        display: "block",
        height: "auto"
      }
    })
  };
}, Eye = (e) => {
  const {
    componentCls: t,
    motionDurationSlow: r,
    arrowSize: a,
    arrowOffset: i
  } = e, c = e.calc(a).div(Math.SQRT2).equal();
  return {
    [t]: {
      // Arrows
      ".slick-prev, .slick-next": {
        position: "absolute",
        top: "50%",
        width: a,
        height: a,
        transform: "translateY(-50%)",
        color: "#fff",
        opacity: 0.4,
        background: "transparent",
        padding: 0,
        lineHeight: 0,
        border: 0,
        outline: "none",
        cursor: "pointer",
        zIndex: 1,
        transition: `opacity ${r}`,
        "&:hover, &:focus": {
          opacity: 1
        },
        "&.slick-disabled": {
          pointerEvents: "none",
          opacity: 0
        },
        "&::after": {
          boxSizing: "border-box",
          position: "absolute",
          top: e.calc(a).sub(c).div(2).equal(),
          insetInlineStart: e.calc(a).sub(c).div(2).equal(),
          display: "inline-block",
          width: c,
          height: c,
          border: "0 solid currentcolor",
          borderInlineStartWidth: 2,
          borderBlockStartWidth: 2,
          borderRadius: 1,
          content: '""'
        }
      },
      ".slick-prev": {
        insetInlineStart: i,
        "&::after": {
          transform: "rotate(-45deg)"
        }
      },
      ".slick-next": {
        insetInlineEnd: i,
        "&::after": {
          transform: "rotate(135deg)"
        }
      }
    }
  };
}, Pye = (e) => {
  const {
    componentCls: t,
    dotOffset: r,
    dotWidth: a,
    dotHeight: i,
    dotGap: c,
    colorBgContainer: d,
    motionDurationSlow: f
  } = e, p = new bo(`${e.prefixCls}-dot-animation`, {
    from: {
      width: 0
    },
    to: {
      width: e.dotActiveWidth
    }
  });
  return {
    [t]: {
      ".slick-dots": {
        position: "absolute",
        insetInlineEnd: 0,
        bottom: 0,
        insetInlineStart: 0,
        zIndex: 15,
        display: "flex !important",
        justifyContent: "center",
        paddingInlineStart: 0,
        margin: 0,
        listStyle: "none",
        "&-bottom": {
          bottom: r
        },
        "&-top": {
          top: r,
          bottom: "auto"
        },
        li: {
          position: "relative",
          display: "inline-block",
          flex: "0 1 auto",
          boxSizing: "content-box",
          width: a,
          height: i,
          marginInline: c,
          padding: 0,
          textAlign: "center",
          textIndent: -999,
          verticalAlign: "top",
          transition: `all ${f}`,
          borderRadius: i,
          overflow: "hidden",
          "&::after": {
            display: "block",
            position: "absolute",
            top: 0,
            insetInlineStart: 0,
            width: 0,
            height: i,
            content: '""',
            background: "transparent",
            borderRadius: i,
            opacity: 1,
            outline: "none",
            cursor: "pointer",
            overflow: "hidden"
          },
          button: {
            position: "relative",
            display: "block",
            width: "100%",
            height: i,
            padding: 0,
            color: "transparent",
            fontSize: 0,
            background: d,
            border: 0,
            borderRadius: i,
            outline: "none",
            cursor: "pointer",
            opacity: 0.2,
            transition: `all ${f}`,
            overflow: "hidden",
            "&:hover": {
              opacity: 0.75
            },
            "&::after": {
              position: "absolute",
              inset: e.calc(c).mul(-1).equal(),
              content: '""'
            }
          },
          "&.slick-active": {
            width: e.dotActiveWidth,
            position: "relative",
            "&:hover": {
              opacity: 1
            },
            "&::after": {
              background: d,
              animationName: p,
              animationDuration: `var(${Tj})`,
              animationTimingFunction: "ease-out",
              animationFillMode: "forwards"
            }
          }
        }
      }
    }
  };
}, kye = (e) => {
  const {
    componentCls: t,
    dotOffset: r,
    arrowOffset: a,
    marginXXS: i
  } = e, c = new bo(`${e.prefixCls}-dot-vertical-animation`, {
    from: {
      height: 0
    },
    to: {
      height: e.dotActiveWidth
    }
  }), d = {
    width: e.dotHeight,
    height: e.dotWidth
  };
  return {
    [`${t}-vertical`]: {
      ".slick-prev, .slick-next": {
        insetInlineStart: "50%",
        marginBlockStart: "unset",
        transform: "translateX(-50%)"
      },
      ".slick-prev": {
        insetBlockStart: a,
        insetInlineStart: "50%",
        "&::after": {
          transform: "rotate(45deg)"
        }
      },
      ".slick-next": {
        insetBlockStart: "auto",
        insetBlockEnd: a,
        "&::after": {
          transform: "rotate(-135deg)"
        }
      },
      ".slick-dots": {
        top: "50%",
        bottom: "auto",
        flexDirection: "column",
        width: e.dotHeight,
        height: "auto",
        margin: 0,
        transform: "translateY(-50%)",
        "&-left": {
          insetInlineEnd: "auto",
          insetInlineStart: r
        },
        "&-right": {
          insetInlineEnd: r,
          insetInlineStart: "auto"
        },
        li: Object.assign(Object.assign({}, d), {
          margin: `${Ye(i)} 0`,
          verticalAlign: "baseline",
          button: d,
          "&::after": Object.assign(Object.assign({}, d), {
            height: 0
          }),
          "&.slick-active": Object.assign(Object.assign({}, d), {
            height: e.dotActiveWidth,
            button: Object.assign(Object.assign({}, d), {
              height: e.dotActiveWidth
            }),
            "&::after": Object.assign(Object.assign({}, d), {
              animationName: c,
              animationDuration: `var(${Tj})`,
              animationTimingFunction: "ease-out",
              animationFillMode: "forwards"
            })
          })
        })
      }
    }
  };
}, Mye = (e) => {
  const {
    componentCls: t
  } = e;
  return [{
    [`${t}-rtl`]: {
      direction: "rtl"
    }
  }, {
    [`${t}-vertical`]: {
      ".slick-dots": {
        [`${t}-rtl&`]: {
          flexDirection: "column"
        }
      }
    }
  }];
}, Oye = (e) => ({
  arrowSize: 16,
  arrowOffset: e.marginXS,
  dotWidth: 16,
  dotHeight: 3,
  dotGap: e.marginXXS,
  dotOffset: 12,
  dotWidthActive: 24,
  dotActiveWidth: 24
}), Tye = Ii("Carousel", (e) => [xye(e), Eye(e), Pye(e), kye(e), Mye(e)], Oye, {
  deprecatedTokens: [["dotWidthActive", "dotActiveWidth"]]
});
var ZQ = function(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
    t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
};
const kW = "slick-dots", MW = (e) => {
  var {
    currentSlide: t,
    slideCount: r
  } = e, a = ZQ(e, ["currentSlide", "slideCount"]);
  return /* @__PURE__ */ S.createElement("button", Object.assign({
    type: "button"
  }, a));
}, eJ = /* @__PURE__ */ S.forwardRef((e, t) => {
  const {
    dots: r = !0,
    arrows: a = !1,
    prevArrow: i,
    nextArrow: c,
    draggable: d = !1,
    waitForAnimate: f = !1,
    dotPosition: p = "bottom",
    vertical: g = p === "left" || p === "right",
    rootClassName: b,
    className: w,
    style: x,
    id: E,
    autoplay: P = !1,
    autoplaySpeed: k = 3e3,
    rtl: M
  } = e, T = ZQ(e, ["dots", "arrows", "prevArrow", "nextArrow", "draggable", "waitForAnimate", "dotPosition", "vertical", "rootClassName", "className", "style", "id", "autoplay", "autoplaySpeed", "rtl"]), {
    getPrefixCls: N,
    direction: D,
    className: $,
    style: j
  } = om("carousel"), I = S.useRef(null), L = (ne, ae = !1) => {
    I.current.slickGoTo(ne, ae);
  };
  S.useImperativeHandle(t, () => ({
    goTo: L,
    autoPlay: I.current.innerSlider.autoPlay,
    innerSlider: I.current.innerSlider,
    prev: I.current.slickPrev,
    next: I.current.slickNext
  }), [I.current]);
  const {
    children: F,
    initialSlide: _ = 0
  } = e, W = S.Children.count(F), Q = (M ?? D === "rtl") && !g;
  S.useEffect(() => {
    if (W > 0) {
      const ne = Q ? W - _ - 1 : _;
      L(ne, !1);
    }
  }, [W, _, Q]);
  const U = Object.assign({
    vertical: g,
    className: _e(w, $),
    style: Object.assign(Object.assign({}, j), x),
    autoplay: !!P
  }, T);
  U.effect === "fade" && (U.fade = !0);
  const Y = N("carousel", U.prefixCls), G = !!r, J = _e(kW, `${kW}-${p}`, typeof r == "boolean" ? !1 : r?.className), [H, K, X] = Tye(Y), te = _e(Y, {
    [`${Y}-rtl`]: Q,
    [`${Y}-vertical`]: U.vertical
  }, K, X, b), ee = P && (typeof P == "object" ? P.dotDuration : !1) ? {
    [Tj]: `${k}ms`
  } : {};
  return H(/* @__PURE__ */ S.createElement("div", {
    className: te,
    id: E,
    style: ee
  }, /* @__PURE__ */ S.createElement(Cye, Object.assign({
    ref: I
  }, U, {
    dots: G,
    dotsClass: J,
    arrows: a,
    prevArrow: i ?? /* @__PURE__ */ S.createElement(MW, {
      "aria-label": Q ? "next" : "prev"
    }),
    nextArrow: c ?? /* @__PURE__ */ S.createElement(MW, {
      "aria-label": Q ? "prev" : "next"
    }),
    draggable: d,
    verticalSwiping: g,
    autoplaySpeed: k,
    waitForAnimate: f,
    rtl: Q
  }))));
});
process.env.NODE_ENV !== "production" && (eJ.displayName = "Carousel");
function np(e, t) {
  return e[t];
}
var Rye = ["children"];
function tJ(e, t) {
  return "".concat(e, "-").concat(t);
}
function Aye(e) {
  return e && e.type && e.type.isTreeNode;
}
function l7(e, t) {
  return e ?? t;
}
function Ox(e) {
  var t = e || {}, r = t.title, a = t._title, i = t.key, c = t.children, d = r || "title";
  return {
    title: d,
    _title: a || [d],
    key: i || "key",
    children: c || "children"
  };
}
function Nye(e, t) {
  var r = /* @__PURE__ */ new Map();
  function a(i) {
    var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    (i || []).forEach(function(d) {
      var f = d[t.key], p = d[t.children];
      $n(f != null, "Tree node must have a certain key: [".concat(c).concat(f, "]"));
      var g = String(f);
      $n(!r.has(g) || f === null || f === void 0, "Same 'key' exist in the Tree: ".concat(g)), r.set(g, !0), a(p, "".concat(c).concat(g, " > "));
    });
  }
  a(e);
}
function nJ(e) {
  function t(r) {
    var a = Kh(r);
    return a.map(function(i) {
      if (!Aye(i))
        return $n(!i, "Tree/TreeNode can only accept TreeNode as children."), null;
      var c = i.key, d = i.props, f = d.children, p = xr(d, Rye), g = ce({
        key: c
      }, p), b = t(f);
      return b.length && (g.children = b), g;
    }).filter(function(i) {
      return i;
    });
  }
  return t(e);
}
function SR(e, t, r) {
  var a = Ox(r), i = a._title, c = a.key, d = a.children, f = new Set(t === !0 ? [] : t), p = [];
  function g(b) {
    var w = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    return b.map(function(x, E) {
      for (var P = tJ(w ? w.pos : "0", E), k = l7(x[c], P), M, T = 0; T < i.length; T += 1) {
        var N = i[T];
        if (x[N] !== void 0) {
          M = x[N];
          break;
        }
      }
      var D = Object.assign(Rs(x, [].concat(Et(i), [c, d])), {
        title: M,
        key: k,
        parent: w,
        pos: P,
        children: null,
        data: x,
        isStart: [].concat(Et(w ? w.isStart : []), [E === 0]),
        isEnd: [].concat(Et(w ? w.isEnd : []), [E === b.length - 1])
      });
      return p.push(D), t === !0 || f.has(k) ? D.children = g(x[d] || [], D) : D.children = [], D;
    });
  }
  return g(e), p;
}
function Dye(e, t, r) {
  var a = {};
  Hn(r) === "object" ? a = r : a = {
    externalGetKey: r
  }, a = a || {};
  var i = a, c = i.childrenPropName, d = i.externalGetKey, f = i.fieldNames, p = Ox(f), g = p.key, b = p.children, w = c || b, x;
  d ? typeof d == "string" ? x = function(k) {
    return k[d];
  } : typeof d == "function" && (x = function(k) {
    return d(k);
  }) : x = function(k, M) {
    return l7(k[g], M);
  };
  function E(P, k, M, T) {
    var N = P ? P[w] : e, D = P ? tJ(M.pos, k) : "0", $ = P ? [].concat(Et(T), [P]) : [];
    if (P) {
      var j = x(P, D), I = {
        node: P,
        index: k,
        pos: D,
        key: j,
        parentPos: M.node ? M.pos : null,
        level: M.level + 1,
        nodes: $
      };
      t(I);
    }
    N && N.forEach(function(L, F) {
      E(L, F, {
        node: P,
        pos: D,
        level: M ? M.level + 1 : -1
      }, $);
    });
  }
  E(null);
}
function Rj(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.initWrapper, a = t.processEntity, i = t.onProcessFinished, c = t.externalGetKey, d = t.childrenPropName, f = t.fieldNames, p = arguments.length > 2 ? arguments[2] : void 0, g = c || p, b = {}, w = {}, x = {
    posEntities: b,
    keyEntities: w
  };
  return r && (x = r(x) || x), Dye(e, function(E) {
    var P = E.node, k = E.index, M = E.pos, T = E.key, N = E.parentPos, D = E.level, $ = E.nodes, j = {
      node: P,
      nodes: $,
      index: k,
      key: T,
      pos: M,
      level: D
    }, I = l7(T, M);
    b[M] = j, w[I] = j, j.parent = b[N], j.parent && (j.parent.children = j.parent.children || [], j.parent.children.push(j)), a && a(j, x);
  }, {
    externalGetKey: g,
    childrenPropName: d,
    fieldNames: f
  }), i && i(x), x;
}
function hE(e, t) {
  var r = t.expandedKeys, a = t.selectedKeys, i = t.loadedKeys, c = t.loadingKeys, d = t.checkedKeys, f = t.halfCheckedKeys, p = t.dragOverNodeKey, g = t.dropPosition, b = t.keyEntities, w = np(b, e), x = {
    eventKey: e,
    expanded: r.indexOf(e) !== -1,
    selected: a.indexOf(e) !== -1,
    loaded: i.indexOf(e) !== -1,
    loading: c.indexOf(e) !== -1,
    checked: d.indexOf(e) !== -1,
    halfChecked: f.indexOf(e) !== -1,
    pos: String(w ? w.pos : ""),
    // [Legacy] Drag props
    // Since the interaction of drag is changed, the semantic of the props are
    // not accuracy, I think it should be finally removed
    dragOver: p === e && g === 0,
    dragOverGapTop: p === e && g === -1,
    dragOverGapBottom: p === e && g === 1
  };
  return x;
}
function Yu(e) {
  var t = e.data, r = e.expanded, a = e.selected, i = e.checked, c = e.loaded, d = e.loading, f = e.halfChecked, p = e.dragOver, g = e.dragOverGapTop, b = e.dragOverGapBottom, w = e.pos, x = e.active, E = e.eventKey, P = ce(ce({}, t), {}, {
    expanded: r,
    selected: a,
    checked: i,
    loaded: c,
    loading: d,
    halfChecked: f,
    dragOver: p,
    dragOverGapTop: g,
    dragOverGapBottom: b,
    pos: w,
    active: x,
    key: E
  });
  return "props" in P || Object.defineProperty(P, "props", {
    get: function() {
      return $n(!1, "Second param return from event is node data instead of TreeNode instance. Please read value directly instead of reading from `props`."), e;
    }
  }), P;
}
function rJ(e, t) {
  var r = /* @__PURE__ */ new Set();
  return e.forEach(function(a) {
    t.has(a) || r.add(a);
  }), r;
}
function $ye(e) {
  var t = e || {}, r = t.disabled, a = t.disableCheckbox, i = t.checkable;
  return !!(r || a) || i === !1;
}
function zye(e, t, r, a) {
  for (var i = new Set(e), c = /* @__PURE__ */ new Set(), d = 0; d <= r; d += 1) {
    var f = t.get(d) || /* @__PURE__ */ new Set();
    f.forEach(function(w) {
      var x = w.key, E = w.node, P = w.children, k = P === void 0 ? [] : P;
      i.has(x) && !a(E) && k.filter(function(M) {
        return !a(M.node);
      }).forEach(function(M) {
        i.add(M.key);
      });
    });
  }
  for (var p = /* @__PURE__ */ new Set(), g = r; g >= 0; g -= 1) {
    var b = t.get(g) || /* @__PURE__ */ new Set();
    b.forEach(function(w) {
      var x = w.parent, E = w.node;
      if (!(a(E) || !w.parent || p.has(w.parent.key))) {
        if (a(w.parent.node)) {
          p.add(x.key);
          return;
        }
        var P = !0, k = !1;
        (x.children || []).filter(function(M) {
          return !a(M.node);
        }).forEach(function(M) {
          var T = M.key, N = i.has(T);
          P && !N && (P = !1), !k && (N || c.has(T)) && (k = !0);
        }), P && i.add(x.key), k && c.add(x.key), p.add(x.key);
      }
    });
  }
  return {
    checkedKeys: Array.from(i),
    halfCheckedKeys: Array.from(rJ(c, i))
  };
}
function jye(e, t, r, a, i) {
  for (var c = new Set(e), d = new Set(t), f = 0; f <= a; f += 1) {
    var p = r.get(f) || /* @__PURE__ */ new Set();
    p.forEach(function(x) {
      var E = x.key, P = x.node, k = x.children, M = k === void 0 ? [] : k;
      !c.has(E) && !d.has(E) && !i(P) && M.filter(function(T) {
        return !i(T.node);
      }).forEach(function(T) {
        c.delete(T.key);
      });
    });
  }
  d = /* @__PURE__ */ new Set();
  for (var g = /* @__PURE__ */ new Set(), b = a; b >= 0; b -= 1) {
    var w = r.get(b) || /* @__PURE__ */ new Set();
    w.forEach(function(x) {
      var E = x.parent, P = x.node;
      if (!(i(P) || !x.parent || g.has(x.parent.key))) {
        if (i(x.parent.node)) {
          g.add(E.key);
          return;
        }
        var k = !0, M = !1;
        (E.children || []).filter(function(T) {
          return !i(T.node);
        }).forEach(function(T) {
          var N = T.key, D = c.has(N);
          k && !D && (k = !1), !M && (D || d.has(N)) && (M = !0);
        }), k || c.delete(E.key), M && d.add(E.key), g.add(E.key);
      }
    });
  }
  return {
    checkedKeys: Array.from(c),
    halfCheckedKeys: Array.from(rJ(d, c))
  };
}
function ix(e, t, r, a) {
  var i = [], c;
  a ? c = a : c = $ye;
  var d = new Set(e.filter(function(b) {
    var w = !!np(r, b);
    return w || i.push(b), w;
  })), f = /* @__PURE__ */ new Map(), p = 0;
  Object.keys(r).forEach(function(b) {
    var w = r[b], x = w.level, E = f.get(x);
    E || (E = /* @__PURE__ */ new Set(), f.set(x, E)), E.add(w), p = Math.max(p, x);
  }), $n(!i.length, "Tree missing follow keys: ".concat(i.slice(0, 100).map(function(b) {
    return "'".concat(b, "'");
  }).join(", ")));
  var g;
  return t === !0 ? g = zye(d, f, p, c) : g = jye(d, t.halfCheckedKeys, f, p, c), g;
}
const Iye = (e) => {
  const {
    checkboxCls: t
  } = e, r = `${t}-wrapper`;
  return [
    // ===================== Basic =====================
    {
      // Group
      [`${t}-group`]: Object.assign(Object.assign({}, dl(e)), {
        display: "inline-flex",
        flexWrap: "wrap",
        columnGap: e.marginXS,
        // Group > Grid
        [`> ${e.antCls}-row`]: {
          flex: 1
        }
      }),
      // Wrapper
      [r]: Object.assign(Object.assign({}, dl(e)), {
        display: "inline-flex",
        alignItems: "baseline",
        cursor: "pointer",
        // Fix checkbox & radio in flex align #30260
        "&:after": {
          display: "inline-block",
          width: 0,
          overflow: "hidden",
          content: "'\\a0'"
        },
        // Checkbox near checkbox
        [`& + ${r}`]: {
          marginInlineStart: 0
        },
        [`&${r}-in-form-item`]: {
          'input[type="checkbox"]': {
            width: 14,
            // FIXME: magic
            height: 14
            // FIXME: magic
          }
        }
      }),
      // Wrapper > Checkbox
      [t]: Object.assign(Object.assign({}, dl(e)), {
        position: "relative",
        whiteSpace: "nowrap",
        lineHeight: 1,
        cursor: "pointer",
        borderRadius: e.borderRadiusSM,
        // To make alignment right when `controlHeight` is changed
        // Ref: https://github.com/ant-design/ant-design/issues/41564
        alignSelf: "center",
        // Wrapper > Checkbox > input
        [`${t}-input`]: {
          position: "absolute",
          // Since baseline align will get additional space offset,
          // we need to move input to top to make it align with text.
          // Ref: https://github.com/ant-design/ant-design/issues/38926#issuecomment-1486137799
          inset: 0,
          zIndex: 1,
          cursor: "pointer",
          opacity: 0,
          margin: 0,
          [`&:focus-visible + ${t}-inner`]: _S(e)
        },
        // Wrapper > Checkbox > inner
        [`${t}-inner`]: {
          boxSizing: "border-box",
          display: "block",
          width: e.checkboxSize,
          height: e.checkboxSize,
          direction: "ltr",
          backgroundColor: e.colorBgContainer,
          border: `${Ye(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderRadius: e.borderRadiusSM,
          borderCollapse: "separate",
          transition: `all ${e.motionDurationSlow}`,
          "&:after": {
            boxSizing: "border-box",
            position: "absolute",
            top: "50%",
            insetInlineStart: "25%",
            display: "table",
            width: e.calc(e.checkboxSize).div(14).mul(5).equal(),
            height: e.calc(e.checkboxSize).div(14).mul(8).equal(),
            border: `${Ye(e.lineWidthBold)} solid ${e.colorWhite}`,
            borderTop: 0,
            borderInlineStart: 0,
            transform: "rotate(45deg) scale(0) translate(-50%,-50%)",
            opacity: 0,
            content: '""',
            transition: `all ${e.motionDurationFast} ${e.motionEaseInBack}, opacity ${e.motionDurationFast}`
          }
        },
        // Wrapper > Checkbox + Text
        "& + span": {
          paddingInlineStart: e.paddingXS,
          paddingInlineEnd: e.paddingXS
        }
      })
    },
    // ===================== Hover =====================
    {
      // Wrapper & Wrapper > Checkbox
      [`
        ${r}:not(${r}-disabled),
        ${t}:not(${t}-disabled)
      `]: {
        [`&:hover ${t}-inner`]: {
          borderColor: e.colorPrimary
        }
      },
      [`${r}:not(${r}-disabled)`]: {
        [`&:hover ${t}-checked:not(${t}-disabled) ${t}-inner`]: {
          backgroundColor: e.colorPrimaryHover,
          borderColor: "transparent"
        },
        [`&:hover ${t}-checked:not(${t}-disabled):after`]: {
          borderColor: e.colorPrimaryHover
        }
      }
    },
    // ==================== Checked ====================
    {
      // Wrapper > Checkbox
      [`${t}-checked`]: {
        [`${t}-inner`]: {
          backgroundColor: e.colorPrimary,
          borderColor: e.colorPrimary,
          "&:after": {
            opacity: 1,
            transform: "rotate(45deg) scale(1) translate(-50%,-50%)",
            transition: `all ${e.motionDurationMid} ${e.motionEaseOutBack} ${e.motionDurationFast}`
          }
        }
      },
      [`
        ${r}-checked:not(${r}-disabled),
        ${t}-checked:not(${t}-disabled)
      `]: {
        [`&:hover ${t}-inner`]: {
          backgroundColor: e.colorPrimaryHover,
          borderColor: "transparent"
        }
      }
    },
    // ================= Indeterminate =================
    {
      [t]: {
        "&-indeterminate": {
          "&": {
            // Wrapper > Checkbox > inner
            [`${t}-inner`]: {
              backgroundColor: `${e.colorBgContainer}`,
              borderColor: `${e.colorBorder}`,
              "&:after": {
                top: "50%",
                insetInlineStart: "50%",
                width: e.calc(e.fontSizeLG).div(2).equal(),
                height: e.calc(e.fontSizeLG).div(2).equal(),
                backgroundColor: e.colorPrimary,
                border: 0,
                transform: "translate(-50%, -50%) scale(1)",
                opacity: 1,
                content: '""'
              }
            },
            // https://github.com/ant-design/ant-design/issues/50074
            [`&:hover ${t}-inner`]: {
              backgroundColor: `${e.colorBgContainer}`,
              borderColor: `${e.colorPrimary}`
            }
          }
        }
      }
    },
    // ==================== Disable ====================
    {
      // Wrapper
      [`${r}-disabled`]: {
        cursor: "not-allowed"
      },
      // Wrapper > Checkbox
      [`${t}-disabled`]: {
        // Wrapper > Checkbox > input
        [`&, ${t}-input`]: {
          cursor: "not-allowed",
          // Disabled for native input to enable Tooltip event handler
          // ref: https://github.com/ant-design/ant-design/issues/39822#issuecomment-1365075901
          pointerEvents: "none"
        },
        // Wrapper > Checkbox > inner
        [`${t}-inner`]: {
          background: e.colorBgContainerDisabled,
          borderColor: e.colorBorder,
          "&:after": {
            borderColor: e.colorTextDisabled
          }
        },
        "&:after": {
          display: "none"
        },
        "& + span": {
          color: e.colorTextDisabled
        },
        [`&${t}-indeterminate ${t}-inner::after`]: {
          background: e.colorTextDisabled
        }
      }
    }
  ];
};
function aJ(e, t) {
  const r = lo(t, {
    checkboxCls: `.${e}`,
    checkboxSize: t.controlInteractiveSize
  });
  return Iye(r);
}
const oJ = Ii("Checkbox", (e, {
  prefixCls: t
}) => [aJ(t, e)]), iJ = /* @__PURE__ */ Re.createContext(null);
var Lye = function(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
    t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
};
const Hye = (e, t) => {
  var r;
  const {
    prefixCls: a,
    className: i,
    rootClassName: c,
    children: d,
    indeterminate: f = !1,
    style: p,
    onMouseEnter: g,
    onMouseLeave: b,
    skipGroup: w = !1,
    disabled: x
  } = e, E = Lye(e, ["prefixCls", "className", "rootClassName", "children", "indeterminate", "style", "onMouseEnter", "onMouseLeave", "skipGroup", "disabled"]), {
    getPrefixCls: P,
    direction: k,
    checkbox: M
  } = S.useContext(Qr), T = S.useContext(iJ), {
    isFormItemInput: N
  } = S.useContext(yb), D = S.useContext(A0), $ = (r = T?.disabled || x) !== null && r !== void 0 ? r : D, j = S.useRef(E.value), I = S.useRef(null), L = mp(t, I);
  if (process.env.NODE_ENV !== "production") {
    const X = To("Checkbox");
    process.env.NODE_ENV !== "production" && X("checked" in E || !!T || !("value" in E), "usage", "`value` is not a valid prop, do you mean `checked`?");
  }
  S.useEffect(() => {
    T?.registerValue(E.value);
  }, []), S.useEffect(() => {
    if (!w)
      return E.value !== j.current && (T?.cancelValue(j.current), T?.registerValue(E.value), j.current = E.value), () => T?.cancelValue(E.value);
  }, [E.value]), S.useEffect(() => {
    var X;
    !((X = I.current) === null || X === void 0) && X.input && (I.current.input.indeterminate = f);
  }, [f]);
  const F = P("checkbox", a), _ = Qh(F), [W, Q, U] = oJ(F, _), Y = Object.assign({}, E);
  T && !w && (Y.onChange = (...X) => {
    E.onChange && E.onChange.apply(E, X), T.toggleOption && T.toggleOption({
      label: d,
      value: E.value
    });
  }, Y.name = T.name, Y.checked = T.value.includes(E.value));
  const G = _e(`${F}-wrapper`, {
    [`${F}-rtl`]: k === "rtl",
    [`${F}-wrapper-checked`]: Y.checked,
    [`${F}-wrapper-disabled`]: $,
    [`${F}-wrapper-in-form-item`]: N
  }, M?.className, i, c, U, _, Q), J = _e({
    [`${F}-indeterminate`]: f
  }, I9, Q), [H, K] = jQ(Y.onClick);
  return W(/* @__PURE__ */ S.createElement(L9, {
    component: "Checkbox",
    disabled: $
  }, /* @__PURE__ */ S.createElement("label", {
    className: G,
    style: Object.assign(Object.assign({}, M?.style), p),
    onMouseEnter: g,
    onMouseLeave: b,
    onClick: H
  }, /* @__PURE__ */ S.createElement(zQ, Object.assign({}, Y, {
    onClick: K,
    prefixCls: F,
    className: J,
    disabled: $,
    ref: L
  })), d != null && /* @__PURE__ */ S.createElement("span", {
    className: `${F}-label`
  }, d))));
}, Aj = /* @__PURE__ */ S.forwardRef(Hye);
process.env.NODE_ENV !== "production" && (Aj.displayName = "Checkbox");
var Fye = function(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
    t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
};
const Wye = /* @__PURE__ */ S.forwardRef((e, t) => {
  const {
    defaultValue: r,
    children: a,
    options: i = [],
    prefixCls: c,
    className: d,
    rootClassName: f,
    style: p,
    onChange: g
  } = e, b = Fye(e, ["defaultValue", "children", "options", "prefixCls", "className", "rootClassName", "style", "onChange"]), {
    getPrefixCls: w,
    direction: x
  } = S.useContext(Qr), [E, P] = S.useState(b.value || r || []), [k, M] = S.useState([]);
  S.useEffect(() => {
    "value" in b && P(b.value || []);
  }, [b.value]);
  const T = S.useMemo(() => i.map((J) => typeof J == "string" || typeof J == "number" ? {
    label: J,
    value: J
  } : J), [i]), N = (J) => {
    M((H) => H.filter((K) => K !== J));
  }, D = (J) => {
    M((H) => [].concat(Et(H), [J]));
  }, $ = (J) => {
    const H = E.indexOf(J.value), K = Et(E);
    H === -1 ? K.push(J.value) : K.splice(H, 1), "value" in b || P(K), g?.(K.filter((X) => k.includes(X)).sort((X, te) => {
      const ie = T.findIndex((ne) => ne.value === X), ee = T.findIndex((ne) => ne.value === te);
      return ie - ee;
    }));
  }, j = w("checkbox", c), I = `${j}-group`, L = Qh(j), [F, _, W] = oJ(j, L), Q = Rs(b, ["value", "disabled"]), U = i.length ? T.map((J) => /* @__PURE__ */ S.createElement(Aj, {
    prefixCls: j,
    key: J.value.toString(),
    disabled: "disabled" in J ? J.disabled : b.disabled,
    value: J.value,
    checked: E.includes(J.value),
    onChange: J.onChange,
    className: _e(`${I}-item`, J.className),
    style: J.style,
    title: J.title,
    id: J.id,
    required: J.required
  }, J.label)) : a, Y = S.useMemo(() => ({
    toggleOption: $,
    value: E,
    disabled: b.disabled,
    name: b.name,
    // https://github.com/ant-design/ant-design/issues/16376
    registerValue: D,
    cancelValue: N
  }), [$, E, b.disabled, b.name, D, N]), G = _e(I, {
    [`${I}-rtl`]: x === "rtl"
  }, d, f, W, L, _);
  return F(/* @__PURE__ */ S.createElement("div", Object.assign({
    className: G,
    style: p
  }, Q, {
    ref: t
  }), /* @__PURE__ */ S.createElement(iJ.Provider, {
    value: Y
  }, U)));
}), t3 = Aj;
t3.Group = Wye;
t3.__ANT_CHECKBOX = !0;
process.env.NODE_ENV !== "production" && (t3.displayName = "Checkbox");
function Vye(e) {
  return !!(e.addonBefore || e.addonAfter);
}
function _ye(e) {
  return !!(e.prefix || e.suffix || e.allowClear);
}
function OW(e, t, r) {
  var a = t.cloneNode(!0), i = Object.create(e, {
    target: {
      value: a
    },
    currentTarget: {
      value: a
    }
  });
  return a.value = r, typeof t.selectionStart == "number" && typeof t.selectionEnd == "number" && (a.selectionStart = t.selectionStart, a.selectionEnd = t.selectionEnd), a.setSelectionRange = function() {
    t.setSelectionRange.apply(t, arguments);
  }, i;
}
function TW(e, t, r, a) {
  if (r) {
    var i = t;
    if (t.type === "click") {
      i = OW(t, e, ""), r(i);
      return;
    }
    if (e.type !== "file" && a !== void 0) {
      i = OW(t, e, a), r(i);
      return;
    }
    r(i);
  }
}
function Bye(e, t) {
  if (e) {
    e.focus(t);
    var r = t || {}, a = r.cursor;
    if (a) {
      var i = e.value.length;
      switch (a) {
        case "start":
          e.setSelectionRange(0, 0);
          break;
        case "end":
          e.setSelectionRange(i, i);
          break;
        default:
          e.setSelectionRange(0, i);
      }
    }
  }
}
var Uye = /* @__PURE__ */ Re.forwardRef(function(e, t) {
  var r, a, i, c = e.inputElement, d = e.children, f = e.prefixCls, p = e.prefix, g = e.suffix, b = e.addonBefore, w = e.addonAfter, x = e.className, E = e.style, P = e.disabled, k = e.readOnly, M = e.focused, T = e.triggerFocus, N = e.allowClear, D = e.value, $ = e.handleReset, j = e.hidden, I = e.classes, L = e.classNames, F = e.dataAttrs, _ = e.styles, W = e.components, Q = e.onClear, U = d ?? c, Y = W?.affixWrapper || "span", G = W?.groupWrapper || "span", J = W?.wrapper || "span", H = W?.groupAddon || "span", K = It(null), X = function(Ne) {
    var pe;
    (pe = K.current) !== null && pe !== void 0 && pe.contains(Ne.target) && T?.();
  }, te = _ye(e), ie = /* @__PURE__ */ rle(U, {
    value: D,
    className: _e((r = U.props) === null || r === void 0 ? void 0 : r.className, !te && L?.variant) || null
  }), ee = It(null);
  if (Re.useImperativeHandle(t, function() {
    return {
      nativeElement: ee.current || K.current
    };
  }), te) {
    var ne = null;
    if (N) {
      var ae = !P && !k && D, oe = "".concat(f, "-clear-icon"), fe = Hn(N) === "object" && N !== null && N !== void 0 && N.clearIcon ? N.clearIcon : "✖";
      ne = /* @__PURE__ */ Re.createElement("button", {
        type: "button",
        tabIndex: -1,
        onClick: function(Ne) {
          $?.(Ne), Q?.();
        },
        onMouseDown: function(Ne) {
          return Ne.preventDefault();
        },
        className: _e(oe, ge(ge({}, "".concat(oe, "-hidden"), !ae), "".concat(oe, "-has-suffix"), !!g))
      }, fe);
    }
    var be = "".concat(f, "-affix-wrapper"), me = _e(be, ge(ge(ge(ge(ge({}, "".concat(f, "-disabled"), P), "".concat(be, "-disabled"), P), "".concat(be, "-focused"), M), "".concat(be, "-readonly"), k), "".concat(be, "-input-with-clear-btn"), g && N && D), I?.affixWrapper, L?.affixWrapper, L?.variant), De = (g || N) && /* @__PURE__ */ Re.createElement("span", {
      className: _e("".concat(f, "-suffix"), L?.suffix),
      style: _?.suffix
    }, ne, g);
    ie = /* @__PURE__ */ Re.createElement(Y, vt({
      className: me,
      style: _?.affixWrapper,
      onClick: X
    }, F?.affixWrapper, {
      ref: K
    }), p && /* @__PURE__ */ Re.createElement("span", {
      className: _e("".concat(f, "-prefix"), L?.prefix),
      style: _?.prefix
    }, p), ie, De);
  }
  if (Vye(e)) {
    var Me = "".concat(f, "-group"), ze = "".concat(Me, "-addon"), le = "".concat(Me, "-wrapper"), se = _e("".concat(f, "-wrapper"), Me, I?.wrapper, L?.wrapper), Ae = _e(le, ge({}, "".concat(le, "-disabled"), P), I?.group, L?.groupWrapper);
    ie = /* @__PURE__ */ Re.createElement(G, {
      className: Ae,
      ref: ee
    }, /* @__PURE__ */ Re.createElement(J, {
      className: se
    }, b && /* @__PURE__ */ Re.createElement(H, {
      className: ze
    }, b), ie, w && /* @__PURE__ */ Re.createElement(H, {
      className: ze
    }, w)));
  }
  return /* @__PURE__ */ Re.cloneElement(ie, {
    className: _e((a = ie.props) === null || a === void 0 ? void 0 : a.className, x) || null,
    style: ce(ce({}, (i = ie.props) === null || i === void 0 ? void 0 : i.style), E),
    hidden: j
  });
}), Xye = ["show"];
function Gye(e, t) {
  return S.useMemo(function() {
    var r = {};
    t && (r.show = Hn(t) === "object" && t.formatter ? t.formatter : !!t), r = ce(ce({}, r), e);
    var a = r, i = a.show, c = xr(a, Xye);
    return ce(ce({}, c), {}, {
      show: !!i,
      showFormatter: typeof i == "function" ? i : void 0,
      strategy: c.strategy || function(d) {
        return d.length;
      }
    });
  }, [e, t]);
}
var qye = ["autoComplete", "onChange", "onFocus", "onBlur", "onPressEnter", "onKeyDown", "onKeyUp", "prefixCls", "disabled", "htmlSize", "className", "maxLength", "suffix", "showCount", "count", "type", "classes", "classNames", "styles", "onCompositionStart", "onCompositionEnd"], Kye = /* @__PURE__ */ ks(function(e, t) {
  var r = e.autoComplete, a = e.onChange, i = e.onFocus, c = e.onBlur, d = e.onPressEnter, f = e.onKeyDown, p = e.onKeyUp, g = e.prefixCls, b = g === void 0 ? "rc-input" : g, w = e.disabled, x = e.htmlSize, E = e.className, P = e.maxLength, k = e.suffix, M = e.showCount, T = e.count, N = e.type, D = N === void 0 ? "text" : N, $ = e.classes, j = e.classNames, I = e.styles, L = e.onCompositionStart, F = e.onCompositionEnd, _ = xr(e, qye), W = Wn(!1), Q = qe(W, 2), U = Q[0], Y = Q[1], G = It(!1), J = It(!1), H = It(null), K = It(null), X = function(Fe) {
    H.current && Bye(H.current, Fe);
  }, te = ll(e.defaultValue, {
    value: e.value
  }), ie = qe(te, 2), ee = ie[0], ne = ie[1], ae = ee == null ? "" : String(ee), oe = Wn(null), fe = qe(oe, 2), be = fe[0], me = fe[1], De = Gye(T, M), Me = De.max || P, ze = De.strategy(ae), le = !!Me && ze > Me;
  pS(t, function() {
    var Ue;
    return {
      focus: X,
      blur: function() {
        var tt;
        (tt = H.current) === null || tt === void 0 || tt.blur();
      },
      setSelectionRange: function(tt, dt, St) {
        var mt;
        (mt = H.current) === null || mt === void 0 || mt.setSelectionRange(tt, dt, St);
      },
      select: function() {
        var tt;
        (tt = H.current) === null || tt === void 0 || tt.select();
      },
      input: H.current,
      nativeElement: ((Ue = K.current) === null || Ue === void 0 ? void 0 : Ue.nativeElement) || H.current
    };
  }), Er(function() {
    J.current && (J.current = !1), Y(function(Ue) {
      return Ue && w ? !1 : Ue;
    });
  }, [w]);
  var se = function(Fe, tt, dt) {
    var St = tt;
    if (!G.current && De.exceedFormatter && De.max && De.strategy(tt) > De.max) {
      if (St = De.exceedFormatter(tt, {
        max: De.max
      }), tt !== St) {
        var mt, Ot;
        me([((mt = H.current) === null || mt === void 0 ? void 0 : mt.selectionStart) || 0, ((Ot = H.current) === null || Ot === void 0 ? void 0 : Ot.selectionEnd) || 0]);
      }
    } else if (dt.source === "compositionEnd")
      return;
    ne(St), H.current && TW(H.current, Fe, a, St);
  };
  Er(function() {
    if (be) {
      var Ue;
      (Ue = H.current) === null || Ue === void 0 || Ue.setSelectionRange.apply(Ue, Et(be));
    }
  }, [be]);
  var Ae = function(Fe) {
    se(Fe, Fe.target.value, {
      source: "change"
    });
  }, we = function(Fe) {
    G.current = !1, se(Fe, Fe.currentTarget.value, {
      source: "compositionEnd"
    }), F?.(Fe);
  }, Ne = function(Fe) {
    d && Fe.key === "Enter" && !J.current && (J.current = !0, d(Fe)), f?.(Fe);
  }, pe = function(Fe) {
    Fe.key === "Enter" && (J.current = !1), p?.(Fe);
  }, Qe = function(Fe) {
    Y(!0), i?.(Fe);
  }, Le = function(Fe) {
    J.current && (J.current = !1), Y(!1), c?.(Fe);
  }, Te = function(Fe) {
    ne(""), X(), H.current && TW(H.current, Fe, a);
  }, Oe = le && "".concat(b, "-out-of-range"), ye = function() {
    var Fe = Rs(e, [
      "prefixCls",
      "onPressEnter",
      "addonBefore",
      "addonAfter",
      "prefix",
      "suffix",
      "allowClear",
      // Input elements must be either controlled or uncontrolled,
      // specify either the value prop, or the defaultValue prop, but not both.
      "defaultValue",
      "showCount",
      "count",
      "classes",
      "htmlSize",
      "styles",
      "classNames",
      "onClear"
    ]);
    return /* @__PURE__ */ Re.createElement("input", vt({
      autoComplete: r
    }, Fe, {
      onChange: Ae,
      onFocus: Qe,
      onBlur: Le,
      onKeyDown: Ne,
      onKeyUp: pe,
      className: _e(b, ge({}, "".concat(b, "-disabled"), w), j?.input),
      style: I?.input,
      ref: H,
      size: x,
      type: D,
      onCompositionStart: function(dt) {
        G.current = !0, L?.(dt);
      },
      onCompositionEnd: we
    }));
  }, je = function() {
    var Fe = Number(Me) > 0;
    if (k || De.show) {
      var tt = De.showFormatter ? De.showFormatter({
        value: ae,
        count: ze,
        maxLength: Me
      }) : "".concat(ze).concat(Fe ? " / ".concat(Me) : "");
      return /* @__PURE__ */ Re.createElement(Re.Fragment, null, De.show && /* @__PURE__ */ Re.createElement("span", {
        className: _e("".concat(b, "-show-count-suffix"), ge({}, "".concat(b, "-show-count-has-suffix"), !!k), j?.count),
        style: ce({}, I?.count)
      }, tt), k);
    }
    return null;
  };
  return /* @__PURE__ */ Re.createElement(Uye, vt({}, _, {
    prefixCls: b,
    className: _e(E, Oe),
    handleReset: Te,
    value: ae,
    focused: U,
    triggerFocus: X,
    suffix: je(),
    disabled: w,
    classes: $,
    classNames: j,
    styles: I,
    ref: K
  }), ye());
});
const Yye = (e) => {
  let t;
  return typeof e == "object" && e?.clearIcon ? t = e : e && (t = {
    clearIcon: /* @__PURE__ */ Re.createElement(_x, null)
  }), t;
};
function Qye(e, t) {
  const r = It([]), a = () => {
    r.current.push(setTimeout(() => {
      var i, c, d, f;
      !((i = e.current) === null || i === void 0) && i.input && ((c = e.current) === null || c === void 0 ? void 0 : c.input.getAttribute("type")) === "password" && (!((d = e.current) === null || d === void 0) && d.input.hasAttribute("value")) && ((f = e.current) === null || f === void 0 || f.input.removeAttribute("value"));
    }));
  };
  return Er(() => (a(), () => r.current.forEach((i) => {
    i && clearTimeout(i);
  })), []), a;
}
function Jye(e) {
  return !!(e.prefix || e.suffix || e.allowClear || e.showCount);
}
var Zye = function(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
    t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
};
const lJ = /* @__PURE__ */ ks((e, t) => {
  const {
    prefixCls: r,
    bordered: a = !0,
    status: i,
    size: c,
    disabled: d,
    onBlur: f,
    onFocus: p,
    suffix: g,
    allowClear: b,
    addonAfter: w,
    addonBefore: x,
    className: E,
    style: P,
    styles: k,
    rootClassName: M,
    onChange: T,
    classNames: N,
    variant: D,
    _skipAddonWarning: $
  } = e, j = Zye(e, ["prefixCls", "bordered", "status", "size", "disabled", "onBlur", "onFocus", "suffix", "allowClear", "addonAfter", "addonBefore", "className", "style", "styles", "rootClassName", "onChange", "classNames", "variant", "_skipAddonWarning"]);
  if (process.env.NODE_ENV !== "production") {
    const {
      deprecated: Oe
    } = To("Input");
    Oe(!("bordered" in e), "bordered", "variant"), $ || [["addonAfter", "Space.Compact"], ["addonBefore", "Space.Compact"]].forEach(([ye, je]) => {
      Oe(!(ye in e), ye, je);
    });
  }
  const {
    getPrefixCls: I,
    direction: L,
    allowClear: F,
    autoComplete: _,
    className: W,
    style: Q,
    classNames: U,
    styles: Y
  } = om("input"), G = I("input", r), J = It(null), H = Qh(G), [K, X, te] = Rbe(G, M), [ie] = Abe(G, H), {
    compactSize: ee,
    compactItemClassnames: ne
  } = h3(G, L), ae = Cb((Oe) => {
    var ye;
    return (ye = c ?? ee) !== null && ye !== void 0 ? ye : Oe;
  }), oe = Re.useContext(A0), fe = d ?? oe, {
    status: be,
    hasFeedback: me,
    feedbackIcon: De
  } = Do(yb), Me = tM(be, i), ze = Jye(e) || !!me, le = It(ze);
  if (process.env.NODE_ENV !== "production") {
    const Oe = To("Input");
    Er(() => {
      var ye;
      ze && !le.current && process.env.NODE_ENV !== "production" && Oe(document.activeElement === ((ye = J.current) === null || ye === void 0 ? void 0 : ye.input), "usage", "When Input is focused, dynamic add or remove prefix / suffix will make it lose focus caused by dom structure change. Read more: https://ant.design/components/input/#FAQ"), le.current = ze;
    }, [ze]);
  }
  const se = Qye(J), Ae = (Oe) => {
    se(), f?.(Oe);
  }, we = (Oe) => {
    se(), p?.(Oe);
  }, Ne = (Oe) => {
    se(), T?.(Oe);
  }, pe = (me || g) && /* @__PURE__ */ Re.createElement(Re.Fragment, null, g, me && De), Qe = Yye(b ?? F), [Le, Te] = t7("input", D, a);
  return K(ie(/* @__PURE__ */ Re.createElement(Kye, Object.assign({
    ref: mp(t, J),
    prefixCls: G,
    autoComplete: _
  }, j, {
    disabled: fe,
    onBlur: Ae,
    onFocus: we,
    style: Object.assign(Object.assign({}, Q), P),
    styles: Object.assign(Object.assign({}, Y), k),
    suffix: pe,
    allowClear: Qe,
    className: _e(E, M, te, H, ne, W),
    onChange: Ne,
    addonBefore: x && /* @__PURE__ */ Re.createElement(dS, {
      form: !0,
      space: !0
    }, x),
    addonAfter: w && /* @__PURE__ */ Re.createElement(dS, {
      form: !0,
      space: !0
    }, w),
    classNames: Object.assign(Object.assign(Object.assign({}, N), U), {
      input: _e({
        [`${G}-sm`]: ae === "small",
        [`${G}-lg`]: ae === "large",
        [`${G}-rtl`]: L === "rtl"
      }, N?.input, U.input, X),
      variant: _e({
        [`${G}-${Le}`]: Te
      }, NE(G, Me)),
      affixWrapper: _e({
        [`${G}-affix-wrapper-sm`]: ae === "small",
        [`${G}-affix-wrapper-lg`]: ae === "large",
        [`${G}-affix-wrapper-rtl`]: L === "rtl"
      }, X),
      wrapper: _e({
        [`${G}-group-rtl`]: L === "rtl"
      }, X),
      groupWrapper: _e({
        [`${G}-group-wrapper-sm`]: ae === "small",
        [`${G}-group-wrapper-lg`]: ae === "large",
        [`${G}-group-wrapper-rtl`]: L === "rtl",
        [`${G}-group-wrapper-${Le}`]: Te
      }, NE(`${G}-group-wrapper`, Me, me), X)
    })
  }))));
});
process.env.NODE_ENV !== "production" && (lJ.displayName = "Input");
function UD(e, t, r) {
  return (e - t) / (r - t);
}
function Nj(e, t, r, a) {
  var i = UD(t, r, a), c = {};
  switch (e) {
    case "rtl":
      c.right = "".concat(i * 100, "%"), c.transform = "translateX(50%)";
      break;
    case "btt":
      c.bottom = "".concat(i * 100, "%"), c.transform = "translateY(50%)";
      break;
    case "ttb":
      c.top = "".concat(i * 100, "%"), c.transform = "translateY(-50%)";
      break;
    default:
      c.left = "".concat(i * 100, "%"), c.transform = "translateX(-50%)";
      break;
  }
  return c;
}
function V4(e, t) {
  return Array.isArray(e) ? e[t] : e;
}
var v3 = /* @__PURE__ */ S.createContext({
  min: 0,
  max: 0,
  direction: "ltr",
  step: 1,
  includedStart: 0,
  includedEnd: 0,
  tabIndex: 0,
  keyboard: !0,
  styles: {},
  classNames: {}
}), ewe = /* @__PURE__ */ S.createContext({}), twe = ["prefixCls", "value", "valueIndex", "onStartMove", "onDelete", "style", "render", "dragging", "draggingDelete", "onOffsetChange", "onChangeComplete", "onFocus", "onMouseEnter"], XD = /* @__PURE__ */ S.forwardRef(function(e, t) {
  var r = e.prefixCls, a = e.value, i = e.valueIndex, c = e.onStartMove, d = e.onDelete, f = e.style, p = e.render, g = e.dragging, b = e.draggingDelete, w = e.onOffsetChange, x = e.onChangeComplete, E = e.onFocus, P = e.onMouseEnter, k = xr(e, twe), M = S.useContext(v3), T = M.min, N = M.max, D = M.direction, $ = M.disabled, j = M.keyboard, I = M.range, L = M.tabIndex, F = M.ariaLabelForHandle, _ = M.ariaLabelledByForHandle, W = M.ariaRequired, Q = M.ariaValueTextFormatterForHandle, U = M.styles, Y = M.classNames, G = "".concat(r, "-handle"), J = function(fe) {
    $ || c(fe, i);
  }, H = function(fe) {
    E?.(fe, i);
  }, K = function(fe) {
    P(fe, i);
  }, X = function(fe) {
    if (!$ && j) {
      var be = null;
      switch (fe.which || fe.keyCode) {
        case fn.LEFT:
          be = D === "ltr" || D === "btt" ? -1 : 1;
          break;
        case fn.RIGHT:
          be = D === "ltr" || D === "btt" ? 1 : -1;
          break;
        // Up is plus
        case fn.UP:
          be = D !== "ttb" ? 1 : -1;
          break;
        // Down is minus
        case fn.DOWN:
          be = D !== "ttb" ? -1 : 1;
          break;
        case fn.HOME:
          be = "min";
          break;
        case fn.END:
          be = "max";
          break;
        case fn.PAGE_UP:
          be = 2;
          break;
        case fn.PAGE_DOWN:
          be = -2;
          break;
        case fn.BACKSPACE:
        case fn.DELETE:
          d?.(i);
          break;
      }
      be !== null && (fe.preventDefault(), w(be, i));
    }
  }, te = function(fe) {
    switch (fe.which || fe.keyCode) {
      case fn.LEFT:
      case fn.RIGHT:
      case fn.UP:
      case fn.DOWN:
      case fn.HOME:
      case fn.END:
      case fn.PAGE_UP:
      case fn.PAGE_DOWN:
        x?.();
        break;
    }
  }, ie = Nj(D, a, T, N), ee = {};
  if (i !== null) {
    var ne;
    ee = {
      tabIndex: $ ? null : V4(L, i),
      role: "slider",
      "aria-valuemin": T,
      "aria-valuemax": N,
      "aria-valuenow": a,
      "aria-disabled": $,
      "aria-label": V4(F, i),
      "aria-labelledby": V4(_, i),
      "aria-required": V4(W, i),
      "aria-valuetext": (ne = V4(Q, i)) === null || ne === void 0 ? void 0 : ne(a),
      "aria-orientation": D === "ltr" || D === "rtl" ? "horizontal" : "vertical",
      onMouseDown: J,
      onTouchStart: J,
      onFocus: H,
      onMouseEnter: K,
      onKeyDown: X,
      onKeyUp: te
    };
  }
  var ae = /* @__PURE__ */ S.createElement("div", vt({
    ref: t,
    className: _e(G, ge(ge(ge({}, "".concat(G, "-").concat(i + 1), i !== null && I), "".concat(G, "-dragging"), g), "".concat(G, "-dragging-delete"), b), Y.handle),
    style: ce(ce(ce({}, ie), f), U.handle)
  }, ee, k));
  return p && (ae = p(ae, {
    index: i,
    prefixCls: r,
    value: a,
    dragging: g,
    draggingDelete: b
  })), ae;
});
process.env.NODE_ENV !== "production" && (XD.displayName = "Handle");
var nwe = ["prefixCls", "style", "onStartMove", "onOffsetChange", "values", "handleRender", "activeHandleRender", "draggingIndex", "draggingDelete", "onFocus"], sJ = /* @__PURE__ */ S.forwardRef(function(e, t) {
  var r = e.prefixCls, a = e.style, i = e.onStartMove, c = e.onOffsetChange, d = e.values, f = e.handleRender, p = e.activeHandleRender, g = e.draggingIndex, b = e.draggingDelete, w = e.onFocus, x = xr(e, nwe), E = S.useRef({}), P = S.useState(!1), k = qe(P, 2), M = k[0], T = k[1], N = S.useState(-1), D = qe(N, 2), $ = D[0], j = D[1], I = function(Q) {
    j(Q), T(!0);
  }, L = function(Q, U) {
    I(U), w?.(Q);
  }, F = function(Q, U) {
    I(U);
  };
  S.useImperativeHandle(t, function() {
    return {
      focus: function(Q) {
        var U;
        (U = E.current[Q]) === null || U === void 0 || U.focus();
      },
      hideHelp: function() {
        FS(function() {
          T(!1);
        });
      }
    };
  });
  var _ = ce({
    prefixCls: r,
    onStartMove: i,
    onOffsetChange: c,
    render: f,
    onFocus: L,
    onMouseEnter: F
  }, x);
  return /* @__PURE__ */ S.createElement(S.Fragment, null, d.map(function(W, Q) {
    var U = g === Q;
    return /* @__PURE__ */ S.createElement(XD, vt({
      ref: function(G) {
        G ? E.current[Q] = G : delete E.current[Q];
      },
      dragging: U,
      draggingDelete: U && b,
      style: V4(a, Q),
      key: Q,
      value: W,
      valueIndex: Q
    }, _));
  }), p && M && /* @__PURE__ */ S.createElement(XD, vt({
    key: "a11y"
  }, _, {
    value: d[$],
    valueIndex: null,
    dragging: g !== -1,
    draggingDelete: b,
    render: p,
    style: {
      pointerEvents: "none"
    },
    tabIndex: null,
    "aria-hidden": !0
  })));
});
process.env.NODE_ENV !== "production" && (sJ.displayName = "Handles");
var rwe = function(t) {
  var r = t.prefixCls, a = t.style, i = t.children, c = t.value, d = t.onClick, f = S.useContext(v3), p = f.min, g = f.max, b = f.direction, w = f.includedStart, x = f.includedEnd, E = f.included, P = "".concat(r, "-text"), k = Nj(b, c, p, g);
  return /* @__PURE__ */ S.createElement("span", {
    className: _e(P, ge({}, "".concat(P, "-active"), E && w <= c && c <= x)),
    style: ce(ce({}, k), a),
    onMouseDown: function(T) {
      T.stopPropagation();
    },
    onClick: function() {
      d(c);
    }
  }, i);
}, awe = function(t) {
  var r = t.prefixCls, a = t.marks, i = t.onClick, c = "".concat(r, "-mark");
  return a.length ? /* @__PURE__ */ S.createElement("div", {
    className: c
  }, a.map(function(d) {
    var f = d.value, p = d.style, g = d.label;
    return /* @__PURE__ */ S.createElement(rwe, {
      key: f,
      prefixCls: c,
      style: p,
      value: f,
      onClick: i
    }, g);
  })) : null;
}, owe = function(t) {
  var r = t.prefixCls, a = t.value, i = t.style, c = t.activeStyle, d = S.useContext(v3), f = d.min, p = d.max, g = d.direction, b = d.included, w = d.includedStart, x = d.includedEnd, E = "".concat(r, "-dot"), P = b && w <= a && a <= x, k = ce(ce({}, Nj(g, a, f, p)), typeof i == "function" ? i(a) : i);
  return P && (k = ce(ce({}, k), typeof c == "function" ? c(a) : c)), /* @__PURE__ */ S.createElement("span", {
    className: _e(E, ge({}, "".concat(E, "-active"), P)),
    style: k
  });
}, iwe = function(t) {
  var r = t.prefixCls, a = t.marks, i = t.dots, c = t.style, d = t.activeStyle, f = S.useContext(v3), p = f.min, g = f.max, b = f.step, w = S.useMemo(function() {
    var x = /* @__PURE__ */ new Set();
    if (a.forEach(function(P) {
      x.add(P.value);
    }), i && b !== null)
      for (var E = p; E <= g; )
        x.add(E), E += b;
    return Array.from(x);
  }, [p, g, b, i, a]);
  return /* @__PURE__ */ S.createElement("div", {
    className: "".concat(r, "-step")
  }, w.map(function(x) {
    return /* @__PURE__ */ S.createElement(owe, {
      prefixCls: r,
      key: x,
      value: x,
      style: c,
      activeStyle: d
    });
  }));
}, RW = function(t) {
  var r = t.prefixCls, a = t.style, i = t.start, c = t.end, d = t.index, f = t.onStartMove, p = t.replaceCls, g = S.useContext(v3), b = g.direction, w = g.min, x = g.max, E = g.disabled, P = g.range, k = g.classNames, M = "".concat(r, "-track"), T = UD(i, w, x), N = UD(c, w, x), D = function(L) {
    !E && f && f(L, -1);
  }, $ = {};
  switch (b) {
    case "rtl":
      $.right = "".concat(T * 100, "%"), $.width = "".concat(N * 100 - T * 100, "%");
      break;
    case "btt":
      $.bottom = "".concat(T * 100, "%"), $.height = "".concat(N * 100 - T * 100, "%");
      break;
    case "ttb":
      $.top = "".concat(T * 100, "%"), $.height = "".concat(N * 100 - T * 100, "%");
      break;
    default:
      $.left = "".concat(T * 100, "%"), $.width = "".concat(N * 100 - T * 100, "%");
  }
  var j = p || _e(M, ge(ge({}, "".concat(M, "-").concat(d + 1), d !== null && P), "".concat(r, "-track-draggable"), f), k.track);
  return /* @__PURE__ */ S.createElement("div", {
    className: j,
    style: ce(ce({}, $), a),
    onMouseDown: D,
    onTouchStart: D
  });
}, lwe = function(t) {
  var r = t.prefixCls, a = t.style, i = t.values, c = t.startPoint, d = t.onStartMove, f = S.useContext(v3), p = f.included, g = f.range, b = f.min, w = f.styles, x = f.classNames, E = S.useMemo(function() {
    if (!g) {
      if (i.length === 0)
        return [];
      var k = c ?? b, M = i[0];
      return [{
        start: Math.min(k, M),
        end: Math.max(k, M)
      }];
    }
    for (var T = [], N = 0; N < i.length - 1; N += 1)
      T.push({
        start: i[N],
        end: i[N + 1]
      });
    return T;
  }, [i, g, c, b]);
  if (!p)
    return null;
  var P = E != null && E.length && (x.tracks || w.tracks) ? /* @__PURE__ */ S.createElement(RW, {
    index: null,
    prefixCls: r,
    start: E[0].start,
    end: E[E.length - 1].end,
    replaceCls: _e(x.tracks, "".concat(r, "-tracks")),
    style: w.tracks
  }) : null;
  return /* @__PURE__ */ S.createElement(S.Fragment, null, P, E.map(function(k, M) {
    var T = k.start, N = k.end;
    return /* @__PURE__ */ S.createElement(RW, {
      index: M,
      prefixCls: r,
      style: ce(ce({}, V4(a, M)), w.track),
      start: T,
      end: N,
      key: M,
      onStartMove: d
    });
  }));
}, swe = 130;
function AW(e) {
  var t = "targetTouches" in e ? e.targetTouches[0] : e;
  return {
    pageX: t.pageX,
    pageY: t.pageY
  };
}
function uwe(e, t, r, a, i, c, d, f, p, g, b) {
  var w = S.useState(null), x = qe(w, 2), E = x[0], P = x[1], k = S.useState(-1), M = qe(k, 2), T = M[0], N = M[1], D = S.useState(!1), $ = qe(D, 2), j = $[0], I = $[1], L = S.useState(r), F = qe(L, 2), _ = F[0], W = F[1], Q = S.useState(r), U = qe(Q, 2), Y = U[0], G = U[1], J = S.useRef(null), H = S.useRef(null), K = S.useRef(null), X = S.useContext(ewe), te = X.onDragStart, ie = X.onDragChange;
  Da(function() {
    T === -1 && W(r);
  }, [r, T]), S.useEffect(function() {
    return function() {
      document.removeEventListener("mousemove", J.current), document.removeEventListener("mouseup", H.current), K.current && (K.current.removeEventListener("touchmove", J.current), K.current.removeEventListener("touchend", H.current));
    };
  }, []);
  var ee = function(be, me, De) {
    me !== void 0 && P(me), W(be);
    var Me = be;
    De && (Me = be.filter(function(ze, le) {
      return le !== T;
    })), d(Me), ie && ie({
      rawValues: be,
      deleteIndex: De ? T : -1,
      draggingIndex: T,
      draggingValue: me
    });
  }, ne = ra(function(fe, be, me) {
    if (fe === -1) {
      var De = Y[0], Me = Y[Y.length - 1], ze = a - De, le = i - Me, se = be * (i - a);
      se = Math.max(se, ze), se = Math.min(se, le);
      var Ae = c(De + se);
      se = Ae - De;
      var we = Y.map(function(Le) {
        return Le + se;
      });
      ee(we);
    } else {
      var Ne = (i - a) * be, pe = Et(_);
      pe[fe] = Y[fe];
      var Qe = p(pe, Ne, fe, "dist");
      ee(Qe.values, Qe.value, me);
    }
  }), ae = function(be, me, De) {
    be.stopPropagation();
    var Me = De || r, ze = Me[me];
    N(me), P(ze), G(Me), W(Me), I(!1);
    var le = AW(be), se = le.pageX, Ae = le.pageY, we = !1;
    te && te({
      rawValues: Me,
      draggingIndex: me,
      draggingValue: ze
    });
    var Ne = function(Le) {
      Le.preventDefault();
      var Te = AW(Le), Oe = Te.pageX, ye = Te.pageY, je = Oe - se, Ue = ye - Ae, Fe = e.current.getBoundingClientRect(), tt = Fe.width, dt = Fe.height, St, mt;
      switch (t) {
        case "btt":
          St = -Ue / dt, mt = je;
          break;
        case "ttb":
          St = Ue / dt, mt = je;
          break;
        case "rtl":
          St = -je / tt, mt = Ue;
          break;
        default:
          St = je / tt, mt = Ue;
      }
      we = g ? Math.abs(mt) > swe && b < _.length : !1, I(we), ne(me, St, we);
    }, pe = function Qe(Le) {
      Le.preventDefault(), document.removeEventListener("mouseup", Qe), document.removeEventListener("mousemove", Ne), K.current && (K.current.removeEventListener("touchmove", J.current), K.current.removeEventListener("touchend", H.current)), J.current = null, H.current = null, K.current = null, f(we), N(-1), I(!1);
    };
    document.addEventListener("mouseup", pe), document.addEventListener("mousemove", Ne), be.currentTarget.addEventListener("touchend", pe), be.currentTarget.addEventListener("touchmove", Ne), J.current = Ne, H.current = pe, K.current = be.currentTarget;
  }, oe = S.useMemo(function() {
    var fe = Et(r).sort(function(ze, le) {
      return ze - le;
    }), be = Et(_).sort(function(ze, le) {
      return ze - le;
    }), me = {};
    be.forEach(function(ze) {
      me[ze] = (me[ze] || 0) + 1;
    }), fe.forEach(function(ze) {
      me[ze] = (me[ze] || 0) - 1;
    });
    var De = g ? 1 : 0, Me = Object.values(me).reduce(function(ze, le) {
      return ze + Math.abs(le);
    }, 0);
    return Me <= De ? _ : r;
  }, [r, _, g]);
  return [T, E, j, oe, ae];
}
function cwe(e, t, r, a, i, c) {
  var d = S.useCallback(function(E) {
    return Math.max(e, Math.min(t, E));
  }, [e, t]), f = S.useCallback(function(E) {
    if (r !== null) {
      var P = e + Math.round((d(E) - e) / r) * r, k = function(D) {
        return (String(D).split(".")[1] || "").length;
      }, M = Math.max(k(r), k(t), k(e)), T = Number(P.toFixed(M));
      return e <= T && T <= t ? T : null;
    }
    return null;
  }, [r, e, t, d]), p = S.useCallback(function(E) {
    var P = d(E), k = a.map(function(N) {
      return N.value;
    });
    r !== null && k.push(f(E)), k.push(e, t);
    var M = k[0], T = t - e;
    return k.forEach(function(N) {
      var D = Math.abs(P - N);
      D <= T && (M = N, T = D);
    }), M;
  }, [e, t, a, r, d, f]), g = function E(P, k, M) {
    var T = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unit";
    if (typeof k == "number") {
      var N, D = P[M], $ = D + k, j = [];
      a.forEach(function(W) {
        j.push(W.value);
      }), j.push(e, t), j.push(f(D));
      var I = k > 0 ? 1 : -1;
      T === "unit" ? j.push(f(D + I * r)) : j.push(f($)), j = j.filter(function(W) {
        return W !== null;
      }).filter(function(W) {
        return k < 0 ? W <= D : W >= D;
      }), T === "unit" && (j = j.filter(function(W) {
        return W !== D;
      }));
      var L = T === "unit" ? D : $;
      N = j[0];
      var F = Math.abs(N - L);
      if (j.forEach(function(W) {
        var Q = Math.abs(W - L);
        Q < F && (N = W, F = Q);
      }), N === void 0)
        return k < 0 ? e : t;
      if (T === "dist")
        return N;
      if (Math.abs(k) > 1) {
        var _ = Et(P);
        return _[M] = N, E(_, k - I, M, T);
      }
      return N;
    } else {
      if (k === "min")
        return e;
      if (k === "max")
        return t;
    }
  }, b = function(P, k, M) {
    var T = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unit", N = P[M], D = g(P, k, M, T);
    return {
      value: D,
      changed: D !== N
    };
  }, w = function(P) {
    return c === null && P === 0 || typeof c == "number" && P < c;
  }, x = function(P, k, M) {
    var T = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unit", N = P.map(p), D = N[M], $ = g(N, k, M, T);
    if (N[M] = $, i === !1) {
      var j = c || 0;
      M > 0 && N[M - 1] !== D && (N[M] = Math.max(N[M], N[M - 1] + j)), M < N.length - 1 && N[M + 1] !== D && (N[M] = Math.min(N[M], N[M + 1] - j));
    } else if (typeof c == "number" || c === null) {
      for (var I = M + 1; I < N.length; I += 1)
        for (var L = !0; w(N[I] - N[I - 1]) && L; ) {
          var F = b(N, 1, I);
          N[I] = F.value, L = F.changed;
        }
      for (var _ = M; _ > 0; _ -= 1)
        for (var W = !0; w(N[_] - N[_ - 1]) && W; ) {
          var Q = b(N, -1, _ - 1);
          N[_ - 1] = Q.value, W = Q.changed;
        }
      for (var U = N.length - 1; U > 0; U -= 1)
        for (var Y = !0; w(N[U] - N[U - 1]) && Y; ) {
          var G = b(N, -1, U - 1);
          N[U - 1] = G.value, Y = G.changed;
        }
      for (var J = 0; J < N.length - 1; J += 1)
        for (var H = !0; w(N[J + 1] - N[J]) && H; ) {
          var K = b(N, 1, J + 1);
          N[J + 1] = K.value, H = K.changed;
        }
    }
    return {
      value: N[M],
      values: N
    };
  };
  return [p, x];
}
function dwe(e) {
  return mn(function() {
    if (e === !0 || !e)
      return [!!e, !1, !1, 0];
    var t = e.editable, r = e.draggableTrack, a = e.minCount, i = e.maxCount;
    return process.env.NODE_ENV !== "production" && pb(!t || !r, "`editable` can not work with `draggableTrack`."), [!0, t, !t && r, a || 0, i];
  }, [e]);
}
var uJ = /* @__PURE__ */ S.forwardRef(function(e, t) {
  var r = e.prefixCls, a = r === void 0 ? "rc-slider" : r, i = e.className, c = e.style, d = e.classNames, f = e.styles, p = e.id, g = e.disabled, b = g === void 0 ? !1 : g, w = e.keyboard, x = w === void 0 ? !0 : w, E = e.autoFocus, P = e.onFocus, k = e.onBlur, M = e.min, T = M === void 0 ? 0 : M, N = e.max, D = N === void 0 ? 100 : N, $ = e.step, j = $ === void 0 ? 1 : $, I = e.value, L = e.defaultValue, F = e.range, _ = e.count, W = e.onChange, Q = e.onBeforeChange, U = e.onAfterChange, Y = e.onChangeComplete, G = e.allowCross, J = G === void 0 ? !0 : G, H = e.pushable, K = H === void 0 ? !1 : H, X = e.reverse, te = e.vertical, ie = e.included, ee = ie === void 0 ? !0 : ie, ne = e.startPoint, ae = e.trackStyle, oe = e.handleStyle, fe = e.railStyle, be = e.dotStyle, me = e.activeDotStyle, De = e.marks, Me = e.dots, ze = e.handleRender, le = e.activeHandleRender, se = e.track, Ae = e.tabIndex, we = Ae === void 0 ? 0 : Ae, Ne = e.ariaLabelForHandle, pe = e.ariaLabelledByForHandle, Qe = e.ariaRequired, Le = e.ariaValueTextFormatterForHandle, Te = S.useRef(null), Oe = S.useRef(null), ye = S.useMemo(function() {
    return te ? X ? "ttb" : "btt" : X ? "rtl" : "ltr";
  }, [X, te]), je = dwe(F), Ue = qe(je, 5), Fe = Ue[0], tt = Ue[1], dt = Ue[2], St = Ue[3], mt = Ue[4], Ot = S.useMemo(function() {
    return isFinite(T) ? T : 0;
  }, [T]), Rt = S.useMemo(function() {
    return isFinite(D) ? D : 100;
  }, [D]), ct = S.useMemo(function() {
    return j !== null && j <= 0 ? 1 : j;
  }, [j]), it = S.useMemo(function() {
    return typeof K == "boolean" ? K ? ct : !1 : K >= 0 ? K : !1;
  }, [K, ct]), Ct = S.useMemo(function() {
    return Object.keys(De || {}).map(function(Xt) {
      var zt = De[Xt], kt = {
        value: Number(Xt)
      };
      return zt && Hn(zt) === "object" && !/* @__PURE__ */ S.isValidElement(zt) && ("label" in zt || "style" in zt) ? (kt.style = zt.style, kt.label = zt.label) : kt.label = zt, kt;
    }).filter(function(Xt) {
      var zt = Xt.label;
      return zt || typeof zt == "number";
    }).sort(function(Xt, zt) {
      return Xt.value - zt.value;
    });
  }, [De]), ut = cwe(Ot, Rt, ct, Ct, J, it), ht = qe(ut, 2), ot = ht[0], at = ht[1], ft = ll(L, {
    value: I
  }), st = qe(ft, 2), pt = st[0], bt = st[1], Nt = S.useMemo(function() {
    var Xt = pt == null ? [] : Array.isArray(pt) ? pt : [pt], zt = qe(Xt, 1), kt = zt[0], Qn = kt === void 0 ? Ot : kt, Jn = pt === null ? [] : [Qn];
    if (Fe) {
      if (Jn = Et(Xt), _ || pt === void 0) {
        var Nr = _ >= 0 ? _ + 1 : 2;
        for (Jn = Jn.slice(0, Nr); Jn.length < Nr; ) {
          var Hr;
          Jn.push((Hr = Jn[Jn.length - 1]) !== null && Hr !== void 0 ? Hr : Ot);
        }
      }
      Jn.sort(function(oa, dn) {
        return oa - dn;
      });
    }
    return Jn.forEach(function(oa, dn) {
      Jn[dn] = ot(oa);
    }), Jn;
  }, [pt, Fe, Ot, _, ot]), $t = function(zt) {
    return Fe ? zt : zt[0];
  }, Pt = ra(function(Xt) {
    var zt = Et(Xt).sort(function(kt, Qn) {
      return kt - Qn;
    });
    W && !R0(zt, Nt, !0) && W($t(zt)), bt(zt);
  }), hn = ra(function(Xt) {
    Xt && Te.current.hideHelp();
    var zt = $t(Nt);
    U?.(zt), $n(!U, "[rc-slider] `onAfterChange` is deprecated. Please use `onChangeComplete` instead."), Y?.(zt);
  }), an = function(zt) {
    if (!(b || !tt || Nt.length <= St)) {
      var kt = Et(Nt);
      kt.splice(zt, 1), Q?.($t(kt)), Pt(kt);
      var Qn = Math.max(0, zt - 1);
      Te.current.hideHelp(), Te.current.focus(Qn);
    }
  }, jn = uwe(Oe, ye, Nt, Ot, Rt, ot, Pt, hn, at, tt, St), xn = qe(jn, 5), Ut = xn[0], pn = xn[1], wn = xn[2], Lt = xn[3], gt = xn[4], wt = function(zt, kt) {
    if (!b) {
      var Qn = Et(Nt), Jn = 0, Nr = 0, Hr = Rt - Ot;
      Nt.forEach(function(Yr, Wa) {
        var pa = Math.abs(zt - Yr);
        pa <= Hr && (Hr = pa, Jn = Wa), Yr < zt && (Nr = Wa);
      });
      var oa = Jn;
      tt && Hr !== 0 && (!mt || Nt.length < mt) ? (Qn.splice(Nr + 1, 0, zt), oa = Nr + 1) : Qn[Jn] = zt, Fe && !Nt.length && _ === void 0 && Qn.push(zt);
      var dn = $t(Qn);
      if (Q?.(dn), Pt(Qn), kt) {
        var Un, sr;
        (Un = document.activeElement) === null || Un === void 0 || (sr = Un.blur) === null || sr === void 0 || sr.call(Un), Te.current.focus(oa), gt(kt, oa, Qn);
      } else
        U?.(dn), $n(!U, "[rc-slider] `onAfterChange` is deprecated. Please use `onChangeComplete` instead."), Y?.(dn);
    }
  }, Ft = function(zt) {
    zt.preventDefault();
    var kt = Oe.current.getBoundingClientRect(), Qn = kt.width, Jn = kt.height, Nr = kt.left, Hr = kt.top, oa = kt.bottom, dn = kt.right, Un = zt.clientX, sr = zt.clientY, Yr;
    switch (ye) {
      case "btt":
        Yr = (oa - sr) / Jn;
        break;
      case "ttb":
        Yr = (sr - Hr) / Jn;
        break;
      case "rtl":
        Yr = (dn - Un) / Qn;
        break;
      default:
        Yr = (Un - Nr) / Qn;
    }
    var Wa = Ot + Yr * (Rt - Ot);
    wt(ot(Wa), zt);
  }, yn = S.useState(null), gn = qe(yn, 2), Tn = gn[0], Gt = gn[1], Dt = function(zt, kt) {
    if (!b) {
      var Qn = at(Nt, zt, kt);
      Q?.($t(Nt)), Pt(Qn.values), Gt(Qn.value);
    }
  };
  S.useEffect(function() {
    if (Tn !== null) {
      var Xt = Nt.indexOf(Tn);
      Xt >= 0 && Te.current.focus(Xt);
    }
    Gt(null);
  }, [Tn]);
  var Yt = S.useMemo(function() {
    return dt && ct === null ? (process.env.NODE_ENV !== "production" && $n(!1, "`draggableTrack` is not supported when `step` is `null`."), !1) : dt;
  }, [dt, ct]), Mn = ra(function(Xt, zt) {
    gt(Xt, zt), Q?.($t(Nt));
  }), Gn = Ut !== -1;
  S.useEffect(function() {
    if (!Gn) {
      var Xt = Nt.lastIndexOf(pn);
      Te.current.focus(Xt);
    }
  }, [Gn]);
  var wr = S.useMemo(function() {
    return Et(Lt).sort(function(Xt, zt) {
      return Xt - zt;
    });
  }, [Lt]), aa = S.useMemo(function() {
    return Fe ? [wr[0], wr[wr.length - 1]] : [Ot, wr[0]];
  }, [wr, Fe, Ot]), qn = qe(aa, 2), Rr = qn[0], Wt = qn[1];
  S.useImperativeHandle(t, function() {
    return {
      focus: function() {
        Te.current.focus(0);
      },
      blur: function() {
        var zt, kt = document, Qn = kt.activeElement;
        (zt = Oe.current) !== null && zt !== void 0 && zt.contains(Qn) && Qn?.blur();
      }
    };
  }), S.useEffect(function() {
    E && Te.current.focus(0);
  }, []);
  var en = S.useMemo(function() {
    return {
      min: Ot,
      max: Rt,
      direction: ye,
      disabled: b,
      keyboard: x,
      step: ct,
      included: ee,
      includedStart: Rr,
      includedEnd: Wt,
      range: Fe,
      tabIndex: we,
      ariaLabelForHandle: Ne,
      ariaLabelledByForHandle: pe,
      ariaRequired: Qe,
      ariaValueTextFormatterForHandle: Le,
      styles: f || {},
      classNames: d || {}
    };
  }, [Ot, Rt, ye, b, x, ct, ee, Rr, Wt, Fe, we, Ne, pe, Qe, Le, f, d]);
  return /* @__PURE__ */ S.createElement(v3.Provider, {
    value: en
  }, /* @__PURE__ */ S.createElement("div", {
    ref: Oe,
    className: _e(a, i, ge(ge(ge(ge({}, "".concat(a, "-disabled"), b), "".concat(a, "-vertical"), te), "".concat(a, "-horizontal"), !te), "".concat(a, "-with-marks"), Ct.length)),
    style: c,
    onMouseDown: Ft,
    id: p
  }, /* @__PURE__ */ S.createElement("div", {
    className: _e("".concat(a, "-rail"), d?.rail),
    style: ce(ce({}, fe), f?.rail)
  }), se !== !1 && /* @__PURE__ */ S.createElement(lwe, {
    prefixCls: a,
    style: ae,
    values: Nt,
    startPoint: ne,
    onStartMove: Yt ? Mn : void 0
  }), /* @__PURE__ */ S.createElement(iwe, {
    prefixCls: a,
    marks: Ct,
    dots: Me,
    style: be,
    activeStyle: me
  }), /* @__PURE__ */ S.createElement(sJ, {
    ref: Te,
    prefixCls: a,
    style: oe,
    values: Lt,
    draggingIndex: Ut,
    draggingDelete: wn,
    onStartMove: Mn,
    onOffsetChange: Dt,
    onFocus: P,
    onBlur: k,
    handleRender: ze,
    activeHandleRender: le,
    onChangeComplete: hn,
    onDelete: tt ? an : void 0
  }), /* @__PURE__ */ S.createElement(awe, {
    prefixCls: a,
    marks: Ct,
    onClick: wt
  })));
});
process.env.NODE_ENV !== "production" && (uJ.displayName = "Slider");
const fwe = /* @__PURE__ */ fp({}), GD = /* @__PURE__ */ S.forwardRef((e, t) => {
  const {
    open: r,
    draggingDelete: a,
    value: i
  } = e, c = It(null), d = r && !a, f = It(null);
  function p() {
    Pa.cancel(f.current), f.current = null;
  }
  function g() {
    f.current = Pa(() => {
      var b;
      (b = c.current) === null || b === void 0 || b.forceAlign(), f.current = null;
    });
  }
  return S.useEffect(() => (d ? g() : p(), p), [d, e.title, i]), /* @__PURE__ */ S.createElement(U1, Object.assign({
    ref: mp(c, t)
  }, e, {
    open: d
  }));
});
process.env.NODE_ENV !== "production" && (GD.displayName = "SliderTooltip");
const mwe = (e) => {
  const {
    componentCls: t,
    antCls: r,
    controlSize: a,
    dotSize: i,
    marginFull: c,
    marginPart: d,
    colorFillContentHover: f,
    handleColorDisabled: p,
    calc: g,
    handleSize: b,
    handleSizeHover: w,
    handleActiveColor: x,
    handleActiveOutlineColor: E,
    handleLineWidth: P,
    handleLineWidthHover: k,
    motionDurationMid: M
  } = e;
  return {
    [t]: Object.assign(Object.assign({}, dl(e)), {
      position: "relative",
      height: a,
      margin: `${Ye(d)} ${Ye(c)}`,
      padding: 0,
      cursor: "pointer",
      touchAction: "none",
      "&-vertical": {
        margin: `${Ye(c)} ${Ye(d)}`
      },
      [`${t}-rail`]: {
        position: "absolute",
        backgroundColor: e.railBg,
        borderRadius: e.borderRadiusXS,
        transition: `background-color ${M}`
      },
      [`${t}-track,${t}-tracks`]: {
        position: "absolute",
        transition: `background-color ${M}`
      },
      [`${t}-track`]: {
        backgroundColor: e.trackBg,
        borderRadius: e.borderRadiusXS
      },
      [`${t}-track-draggable`]: {
        boxSizing: "content-box",
        backgroundClip: "content-box",
        border: "solid rgba(0,0,0,0)"
      },
      "&:hover": {
        [`${t}-rail`]: {
          backgroundColor: e.railHoverBg
        },
        [`${t}-track`]: {
          backgroundColor: e.trackHoverBg
        },
        [`${t}-dot`]: {
          borderColor: f
        },
        [`${t}-handle::after`]: {
          boxShadow: `0 0 0 ${Ye(P)} ${e.colorPrimaryBorderHover}`
        },
        [`${t}-dot-active`]: {
          borderColor: e.dotActiveBorderColor
        }
      },
      [`${t}-handle`]: {
        position: "absolute",
        width: b,
        height: b,
        outline: "none",
        userSelect: "none",
        // Dragging status
        "&-dragging-delete": {
          opacity: 0
        },
        // 扩大选区
        "&::before": {
          content: '""',
          position: "absolute",
          insetInlineStart: g(P).mul(-1).equal(),
          insetBlockStart: g(P).mul(-1).equal(),
          width: g(b).add(g(P).mul(2)).equal(),
          height: g(b).add(g(P).mul(2)).equal(),
          backgroundColor: "transparent"
        },
        "&::after": {
          content: '""',
          position: "absolute",
          insetBlockStart: 0,
          insetInlineStart: 0,
          width: b,
          height: b,
          backgroundColor: e.colorBgElevated,
          boxShadow: `0 0 0 ${Ye(P)} ${e.handleColor}`,
          outline: "0px solid transparent",
          borderRadius: "50%",
          cursor: "pointer",
          transition: `
            inset-inline-start ${M},
            inset-block-start ${M},
            width ${M},
            height ${M},
            box-shadow ${M},
            outline ${M}
          `
        },
        "&:hover, &:active, &:focus": {
          "&::before": {
            insetInlineStart: g(w).sub(b).div(2).add(k).mul(-1).equal(),
            insetBlockStart: g(w).sub(b).div(2).add(k).mul(-1).equal(),
            width: g(w).add(g(k).mul(2)).equal(),
            height: g(w).add(g(k).mul(2)).equal()
          },
          "&::after": {
            boxShadow: `0 0 0 ${Ye(k)} ${x}`,
            outline: `6px solid ${E}`,
            width: w,
            height: w,
            insetInlineStart: e.calc(b).sub(w).div(2).equal(),
            insetBlockStart: e.calc(b).sub(w).div(2).equal()
          }
        }
      },
      [`&-lock ${t}-handle`]: {
        "&::before, &::after": {
          transition: "none"
        }
      },
      [`${t}-mark`]: {
        position: "absolute",
        fontSize: e.fontSize
      },
      [`${t}-mark-text`]: {
        position: "absolute",
        display: "inline-block",
        color: e.colorTextDescription,
        textAlign: "center",
        wordBreak: "keep-all",
        cursor: "pointer",
        userSelect: "none",
        "&-active": {
          color: e.colorText
        }
      },
      [`${t}-step`]: {
        position: "absolute",
        background: "transparent",
        pointerEvents: "none"
      },
      [`${t}-dot`]: {
        position: "absolute",
        width: i,
        height: i,
        backgroundColor: e.colorBgElevated,
        border: `${Ye(P)} solid ${e.dotBorderColor}`,
        borderRadius: "50%",
        cursor: "pointer",
        transition: `border-color ${e.motionDurationSlow}`,
        pointerEvents: "auto",
        "&-active": {
          borderColor: e.dotActiveBorderColor
        }
      },
      [`&${t}-disabled`]: {
        cursor: "not-allowed",
        [`${t}-rail`]: {
          backgroundColor: `${e.railBg} !important`
        },
        [`${t}-track`]: {
          backgroundColor: `${e.trackBgDisabled} !important`
        },
        [`
          ${t}-dot
        `]: {
          backgroundColor: e.colorBgElevated,
          borderColor: e.trackBgDisabled,
          boxShadow: "none",
          cursor: "not-allowed"
        },
        [`${t}-handle::after`]: {
          backgroundColor: e.colorBgElevated,
          cursor: "not-allowed",
          width: b,
          height: b,
          boxShadow: `0 0 0 ${Ye(P)} ${p}`,
          insetInlineStart: 0,
          insetBlockStart: 0
        },
        [`
          ${t}-mark-text,
          ${t}-dot
        `]: {
          cursor: "not-allowed !important"
        }
      },
      [`&-tooltip ${r}-tooltip-inner`]: {
        minWidth: "unset"
      }
    })
  };
}, cJ = (e, t) => {
  const {
    componentCls: r,
    railSize: a,
    handleSize: i,
    dotSize: c,
    marginFull: d,
    calc: f
  } = e, p = t ? "paddingBlock" : "paddingInline", g = t ? "width" : "height", b = t ? "height" : "width", w = t ? "insetBlockStart" : "insetInlineStart", x = t ? "top" : "insetInlineStart", E = f(a).mul(3).sub(i).div(2).equal(), P = f(i).sub(a).div(2).equal(), k = t ? {
    borderWidth: `${Ye(P)} 0`,
    transform: `translateY(${Ye(f(P).mul(-1).equal())})`
  } : {
    borderWidth: `0 ${Ye(P)}`,
    transform: `translateX(${Ye(e.calc(P).mul(-1).equal())})`
  };
  return {
    [p]: a,
    [b]: f(a).mul(3).equal(),
    [`${r}-rail`]: {
      [g]: "100%",
      [b]: a
    },
    [`${r}-track,${r}-tracks`]: {
      [b]: a
    },
    [`${r}-track-draggable`]: Object.assign({}, k),
    [`${r}-handle`]: {
      [w]: E
    },
    [`${r}-mark`]: {
      // Reset all
      insetInlineStart: 0,
      top: 0,
      // https://github.com/ant-design/ant-design/issues/43731
      [x]: f(a).mul(3).add(t ? 0 : d).equal(),
      [g]: "100%"
    },
    [`${r}-step`]: {
      // Reset all
      insetInlineStart: 0,
      top: 0,
      [x]: a,
      [g]: "100%",
      [b]: a
    },
    [`${r}-dot`]: {
      position: "absolute",
      [w]: f(a).sub(c).div(2).equal()
    }
  };
}, hwe = (e) => {
  const {
    componentCls: t,
    marginPartWithMark: r
  } = e;
  return {
    [`${t}-horizontal`]: Object.assign(Object.assign({}, cJ(e, !0)), {
      [`&${t}-with-marks`]: {
        marginBottom: r
      }
    })
  };
}, pwe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-vertical`]: Object.assign(Object.assign({}, cJ(e, !1)), {
      height: "100%"
    })
  };
}, gwe = (e) => {
  const r = e.controlHeightLG / 4, a = e.controlHeightSM / 2, i = e.lineWidth + 1, c = e.lineWidth + 1 * 1.5, d = e.colorPrimary, f = new ro(d).setA(0.2).toRgbString();
  return {
    controlSize: r,
    railSize: 4,
    handleSize: r,
    handleSizeHover: a,
    dotSize: 8,
    handleLineWidth: i,
    handleLineWidthHover: c,
    railBg: e.colorFillTertiary,
    railHoverBg: e.colorFillSecondary,
    trackBg: e.colorPrimaryBorder,
    trackHoverBg: e.colorPrimaryBorderHover,
    handleColor: e.colorPrimaryBorder,
    handleActiveColor: d,
    handleActiveOutlineColor: f,
    handleColorDisabled: new ro(e.colorTextDisabled).onBackground(e.colorBgContainer).toHexString(),
    dotBorderColor: e.colorBorderSecondary,
    dotActiveBorderColor: e.colorPrimaryBorder,
    trackBgDisabled: e.colorBgContainerDisabled
  };
}, vwe = Ii("Slider", (e) => {
  const t = lo(e, {
    marginPart: e.calc(e.controlHeight).sub(e.controlSize).div(2).equal(),
    marginFull: e.calc(e.controlSize).div(2).equal(),
    marginPartWithMark: e.calc(e.controlHeightLG).sub(e.controlSize).equal()
  });
  return [mwe(t), hwe(t), pwe(t)];
}, gwe);
function CR() {
  const [e, t] = S.useState(!1), r = S.useRef(null), a = () => {
    Pa.cancel(r.current);
  }, i = (c) => {
    a(), c ? t(c) : r.current = Pa(() => {
      t(c);
    });
  };
  return S.useEffect(() => a, []), [e, i];
}
var bwe = function(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
    t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
};
function ywe(e, t) {
  return e || e === null ? e : t || t === null ? t : (r) => typeof r == "number" ? r.toString() : "";
}
const hk = /* @__PURE__ */ Re.forwardRef((e, t) => {
  const {
    prefixCls: r,
    range: a,
    className: i,
    rootClassName: c,
    style: d,
    disabled: f,
    // Deprecated Props
    tooltipPrefixCls: p,
    tipFormatter: g,
    tooltipVisible: b,
    getTooltipPopupContainer: w,
    tooltipPlacement: x,
    tooltip: E = {},
    onChangeComplete: P,
    classNames: k,
    styles: M
  } = e, T = bwe(e, ["prefixCls", "range", "className", "rootClassName", "style", "disabled", "tooltipPrefixCls", "tipFormatter", "tooltipVisible", "getTooltipPopupContainer", "tooltipPlacement", "tooltip", "onChangeComplete", "classNames", "styles"]), {
    vertical: N
  } = e, {
    getPrefixCls: D,
    direction: $,
    className: j,
    style: I,
    classNames: L,
    styles: F,
    getPopupContainer: _
  } = om("slider"), W = Re.useContext(A0), Q = f ?? W, {
    handleRender: U,
    direction: Y
  } = Re.useContext(fwe), J = (Y || $) === "rtl", [H, K] = CR(), [X, te] = CR(), ie = Object.assign({}, E), {
    open: ee,
    placement: ne,
    getPopupContainer: ae,
    prefixCls: oe,
    formatter: fe
  } = ie, be = ee ?? b, me = (H || X) && be !== !1, De = ywe(fe, g), [Me, ze] = CR(), le = (Fe) => {
    P?.(Fe), ze(!1);
  }, se = (Fe, tt) => Fe || (tt ? J ? "left" : "right" : "top"), Ae = D("slider", r), [we, Ne, pe] = vwe(Ae), Qe = _e(i, j, L.root, k?.root, c, {
    [`${Ae}-rtl`]: J,
    [`${Ae}-lock`]: Me
  }, Ne, pe);
  if (J && !T.vertical && (T.reverse = !T.reverse), process.env.NODE_ENV !== "production") {
    const Fe = To("Slider");
    [["tooltipPrefixCls", "prefixCls"], ["getTooltipPopupContainer", "getPopupContainer"], ["tipFormatter", "formatter"], ["tooltipPlacement", "placement"], ["tooltipVisible", "open"]].forEach(([tt, dt]) => {
      Fe.deprecated(!(tt in e), tt, `tooltip.${dt}`);
    });
  }
  Re.useEffect(() => {
    const Fe = () => {
      Pa(() => {
        te(!1);
      }, 1);
    };
    return document.addEventListener("mouseup", Fe), () => {
      document.removeEventListener("mouseup", Fe);
    };
  }, []);
  const Le = a && !be, Te = U || ((Fe, tt) => {
    const {
      index: dt
    } = tt, St = Fe.props;
    function mt(it, Ct, ut) {
      var ht, ot, at, ft;
      ut && ((ot = (ht = T)[it]) === null || ot === void 0 || ot.call(ht, Ct)), (ft = (at = St)[it]) === null || ft === void 0 || ft.call(at, Ct);
    }
    const Ot = Object.assign(Object.assign({}, St), {
      onMouseEnter: (it) => {
        K(!0), mt("onMouseEnter", it);
      },
      onMouseLeave: (it) => {
        K(!1), mt("onMouseLeave", it);
      },
      onMouseDown: (it) => {
        te(!0), ze(!0), mt("onMouseDown", it);
      },
      onFocus: (it) => {
        var Ct;
        te(!0), (Ct = T.onFocus) === null || Ct === void 0 || Ct.call(T, it), mt("onFocus", it, !0);
      },
      onBlur: (it) => {
        var Ct;
        te(!1), (Ct = T.onBlur) === null || Ct === void 0 || Ct.call(T, it), mt("onBlur", it, !0);
      }
    }), Rt = /* @__PURE__ */ Re.cloneElement(Fe, Ot), ct = (!!be || me) && De !== null;
    return Le ? Rt : /* @__PURE__ */ Re.createElement(GD, Object.assign({}, ie, {
      prefixCls: D("tooltip", oe ?? p),
      title: De ? De(tt.value) : "",
      value: tt.value,
      open: ct,
      placement: se(ne ?? x, N),
      key: dt,
      classNames: {
        root: `${Ae}-tooltip`
      },
      getPopupContainer: ae || w || _
    }), Rt);
  }), Oe = Le ? (Fe, tt) => {
    const dt = /* @__PURE__ */ Re.cloneElement(Fe, {
      style: Object.assign(Object.assign({}, Fe.props.style), {
        visibility: "hidden"
      })
    });
    return /* @__PURE__ */ Re.createElement(GD, Object.assign({}, ie, {
      prefixCls: D("tooltip", oe ?? p),
      title: De ? De(tt.value) : "",
      open: De !== null && me,
      placement: se(ne ?? x, N),
      key: "tooltip",
      classNames: {
        root: `${Ae}-tooltip`
      },
      getPopupContainer: ae || w || _,
      draggingDelete: tt.draggingDelete
    }), dt);
  } : void 0, ye = Object.assign(Object.assign(Object.assign(Object.assign({}, F.root), I), M?.root), d), je = Object.assign(Object.assign({}, F.tracks), M?.tracks), Ue = _e(L.tracks, k?.tracks);
  return we(
    // @ts-ignore
    /* @__PURE__ */ Re.createElement(uJ, Object.assign({}, T, {
      classNames: Object.assign({
        handle: _e(L.handle, k?.handle),
        rail: _e(L.rail, k?.rail),
        track: _e(L.track, k?.track)
      }, Ue ? {
        tracks: Ue
      } : {}),
      styles: Object.assign({
        handle: Object.assign(Object.assign({}, F.handle), M?.handle),
        rail: Object.assign(Object.assign({}, F.rail), M?.rail),
        track: Object.assign(Object.assign({}, F.track), M?.track)
      }, Object.keys(je).length ? {
        tracks: je
      } : {}),
      step: T.step,
      range: a,
      className: Qe,
      style: ye,
      disabled: Q,
      ref: t,
      prefixCls: Ae,
      handleRender: Te,
      activeHandleRender: Oe,
      onChangeComplete: le
    }))
  );
});
process.env.NODE_ENV !== "production" && (hk.displayName = "Slider");
var wwe = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M873.1 596.2l-164-208A32 32 0 00684 376h-64.8c-6.7 0-10.4 7.7-6.3 13l144.3 183H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h695.9c26.8 0 41.7-30.8 25.2-51.8z" } }] }, name: "swap-right", theme: "outlined" }, Swe = function(t, r) {
  return /* @__PURE__ */ S.createElement(Ao, vt({}, t, {
    ref: r,
    icon: wwe
  }));
}, dJ = /* @__PURE__ */ S.forwardRef(Swe);
process.env.NODE_ENV !== "production" && (dJ.displayName = "SwapRightOutlined");
const fJ = (e, t, r, a, i) => {
  const {
    classNames: c,
    styles: d
  } = om(e), [f, p] = Cde([c, t], [d, r], {
    popup: {
      _default: "root"
    }
  });
  return S.useMemo(() => {
    var g, b;
    const w = Object.assign(Object.assign({}, f), {
      popup: Object.assign(Object.assign({}, f.popup), {
        root: _e((g = f.popup) === null || g === void 0 ? void 0 : g.root, a)
      })
    }), x = Object.assign(Object.assign({}, p), {
      popup: Object.assign(Object.assign({}, p.popup), {
        root: Object.assign(Object.assign({}, (b = p.popup) === null || b === void 0 ? void 0 : b.root), i)
      })
    });
    return [w, x];
  }, [f, p, a, i]);
};
function Cwe(e, t, r) {
  return r !== void 0 ? r : t === "year" && e.lang.yearPlaceholder ? e.lang.yearPlaceholder : t === "quarter" && e.lang.quarterPlaceholder ? e.lang.quarterPlaceholder : t === "month" && e.lang.monthPlaceholder ? e.lang.monthPlaceholder : t === "week" && e.lang.weekPlaceholder ? e.lang.weekPlaceholder : t === "time" && e.timePickerLocale.placeholder ? e.timePickerLocale.placeholder : e.lang.placeholder;
}
function xwe(e, t, r) {
  return r !== void 0 ? r : t === "year" && e.lang.yearPlaceholder ? e.lang.rangeYearPlaceholder : t === "quarter" && e.lang.quarterPlaceholder ? e.lang.rangeQuarterPlaceholder : t === "month" && e.lang.monthPlaceholder ? e.lang.rangeMonthPlaceholder : t === "week" && e.lang.weekPlaceholder ? e.lang.rangeWeekPlaceholder : t === "time" && e.timePickerLocale.placeholder ? e.timePickerLocale.rangePlaceholder : e.lang.rangePlaceholder;
}
function mJ(e, t) {
  const {
    allowClear: r = !0
  } = e, {
    clearIcon: a,
    removeIcon: i
  } = wY(Object.assign(Object.assign({}, e), {
    prefixCls: t,
    componentName: "DatePicker"
  }));
  return [S.useMemo(() => r === !1 ? !1 : Object.assign({
    clearIcon: a
  }, r === !0 ? {} : r), [r, a]), i];
}
const [Ewe, Pwe] = ["week", "WeekPicker"], [kwe, Mwe] = ["month", "MonthPicker"], [Owe, Twe] = ["year", "YearPicker"], [Rwe, Awe] = ["quarter", "QuarterPicker"], [Dj, NW] = ["time", "TimePicker"];
var Nwe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z" } }] }, name: "calendar", theme: "outlined" }, Dwe = function(t, r) {
  return /* @__PURE__ */ S.createElement(Ao, vt({}, t, {
    ref: r,
    icon: Nwe
  }));
}, hJ = /* @__PURE__ */ S.forwardRef(Dwe);
process.env.NODE_ENV !== "production" && (hJ.displayName = "CalendarOutlined");
var $we = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { tag: "path", attrs: { d: "M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z" } }] }, name: "clock-circle", theme: "outlined" }, zwe = function(t, r) {
  return /* @__PURE__ */ S.createElement(Ao, vt({}, t, {
    ref: r,
    icon: $we
  }));
}, pJ = /* @__PURE__ */ S.forwardRef(zwe);
process.env.NODE_ENV !== "production" && (pJ.displayName = "ClockCircleOutlined");
const gJ = ({
  picker: e,
  hasFeedback: t,
  feedbackIcon: r,
  suffixIcon: a
}) => a === null || a === !1 ? null : a === !0 || a === void 0 ? /* @__PURE__ */ Re.createElement(Re.Fragment, null, e === Dj ? /* @__PURE__ */ Re.createElement(pJ, null) : /* @__PURE__ */ Re.createElement(hJ, null), t && r) : a, jwe = (e) => /* @__PURE__ */ S.createElement(cp, Object.assign({
  size: "small",
  type: "primary"
}, e));
function vJ(e) {
  return mn(() => Object.assign({
    button: jwe
  }, e), [e]);
}
var Iwe = function(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
    t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
};
const Lwe = (e) => {
  const t = /* @__PURE__ */ ks((r, a) => {
    var i;
    const {
      prefixCls: c,
      getPopupContainer: d,
      components: f,
      className: p,
      style: g,
      placement: b,
      size: w,
      disabled: x,
      bordered: E = !0,
      placeholder: P,
      popupStyle: k,
      popupClassName: M,
      dropdownClassName: T,
      status: N,
      rootClassName: D,
      variant: $,
      picker: j,
      styles: I,
      classNames: L,
      suffixIcon: F
    } = r, _ = Iwe(r, ["prefixCls", "getPopupContainer", "components", "className", "style", "placement", "size", "disabled", "bordered", "placeholder", "popupStyle", "popupClassName", "dropdownClassName", "status", "rootClassName", "variant", "picker", "styles", "classNames", "suffixIcon"]), W = j === Dj ? "timePicker" : "datePicker", Q = S.useRef(null), {
      getPrefixCls: U,
      direction: Y,
      getPopupContainer: G,
      rangePicker: J
    } = Do(Qr), H = U("picker", c), {
      compactSize: K,
      compactItemClassnames: X
    } = h3(H, Y), te = U(), [ie, ee] = t7("rangePicker", $, E), ne = Qh(H), [ae, oe, fe] = XQ(H, ne);
    if (process.env.NODE_ENV !== "production") {
      const ye = To("DatePicker.RangePicker");
      Object.entries({
        dropdownClassName: "classNames.popup.root",
        popupClassName: "classNames.popup.root",
        popupStyle: "styles.popup.root",
        bordered: "variant",
        onSelect: "onCalendarChange"
      }).forEach(([Ue, Fe]) => {
        ye.deprecated(!(Ue in r), Ue, Fe);
      });
    }
    const [be, me] = fJ(W, L, I, M || T, k), [De] = mJ(r, H), Me = vJ(f), ze = Cb((ye) => {
      var je;
      return (je = w ?? K) !== null && je !== void 0 ? je : ye;
    }), le = S.useContext(A0), se = x ?? le, Ae = Do(yb), {
      hasFeedback: we,
      status: Ne,
      feedbackIcon: pe
    } = Ae, Qe = /* @__PURE__ */ S.createElement(gJ, {
      picker: j,
      hasFeedback: we,
      feedbackIcon: pe,
      suffixIcon: F
    });
    pS(a, () => Q.current);
    const [Le] = q1("Calendar", Ik), Te = Object.assign(Object.assign({}, Le), r.locale), [Oe] = vS("DatePicker", (i = me.popup.root) === null || i === void 0 ? void 0 : i.zIndex);
    return ae(/* @__PURE__ */ S.createElement(dS, {
      space: !0
    }, /* @__PURE__ */ S.createElement(RQ, Object.assign({
      separator: /* @__PURE__ */ S.createElement("span", {
        "aria-label": "to",
        className: `${H}-separator`
      }, /* @__PURE__ */ S.createElement(dJ, null)),
      disabled: se,
      ref: Q,
      placement: b,
      placeholder: xwe(Te, j, P),
      suffixIcon: Qe,
      prevIcon: /* @__PURE__ */ S.createElement("span", {
        className: `${H}-prev-icon`
      }),
      nextIcon: /* @__PURE__ */ S.createElement("span", {
        className: `${H}-next-icon`
      }),
      superPrevIcon: /* @__PURE__ */ S.createElement("span", {
        className: `${H}-super-prev-icon`
      }),
      superNextIcon: /* @__PURE__ */ S.createElement("span", {
        className: `${H}-super-next-icon`
      }),
      transitionName: `${te}-slide-up`,
      picker: j
    }, _, {
      className: _e({
        [`${H}-${ze}`]: ze,
        [`${H}-${ie}`]: ee
      }, NE(H, tM(Ne, N), we), oe, X, p, J?.className, fe, ne, D, be.root),
      style: Object.assign(Object.assign(Object.assign({}, J?.style), g), me.root),
      locale: Te.lang,
      prefixCls: H,
      getPopupContainer: d || G,
      generateConfig: e,
      components: Me,
      direction: Y,
      classNames: {
        popup: _e(oe, fe, ne, D, be.popup.root)
      },
      styles: {
        popup: Object.assign(Object.assign({}, me.popup.root), {
          zIndex: Oe
        })
      },
      allowClear: De
    }))));
  });
  return process.env.NODE_ENV !== "production" && (t.displayName = "RangePicker"), t;
};
var Hwe = function(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
    t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
};
const Fwe = (e) => {
  const t = (p, g) => {
    const b = g === NW ? "timePicker" : "datePicker", w = /* @__PURE__ */ ks((x, E) => {
      var P;
      const {
        prefixCls: k,
        getPopupContainer: M,
        components: T,
        style: N,
        className: D,
        rootClassName: $,
        size: j,
        bordered: I,
        placement: L,
        placeholder: F,
        popupStyle: _,
        popupClassName: W,
        dropdownClassName: Q,
        disabled: U,
        status: Y,
        variant: G,
        onCalendarChange: J,
        styles: H,
        classNames: K,
        suffixIcon: X
      } = x, te = Hwe(x, ["prefixCls", "getPopupContainer", "components", "style", "className", "rootClassName", "size", "bordered", "placement", "placeholder", "popupStyle", "popupClassName", "dropdownClassName", "disabled", "status", "variant", "onCalendarChange", "styles", "classNames", "suffixIcon"]), {
        getPrefixCls: ie,
        direction: ee,
        getPopupContainer: ne,
        // Consume different styles according to different names
        [b]: ae
      } = Do(Qr), oe = ie("picker", k), {
        compactSize: fe,
        compactItemClassnames: be
      } = h3(oe, ee), me = S.useRef(null), [De, Me] = t7("datePicker", G, I), ze = Qh(oe), [le, se, Ae] = XQ(oe, ze);
      pS(E, () => me.current);
      const we = {
        showToday: !0
      }, Ne = p || x.picker, pe = ie(), {
        onSelect: Qe,
        multiple: Le
      } = te, Te = Qe && p === "time" && !Le, Oe = (at, ft, st) => {
        J?.(at, ft, st), Te && Qe(at);
      };
      if (process.env.NODE_ENV !== "production") {
        const at = To(g || "DatePicker");
        process.env.NODE_ENV !== "production" && at(p !== "quarter", "deprecated", `DatePicker.${g} is legacy usage. Please use DatePicker[picker='${p}'] directly.`), Object.entries({
          dropdownClassName: "classNames.popup.root",
          popupClassName: "classNames.popup.root",
          popupStyle: "styles.popup.root",
          bordered: "variant",
          onSelect: "onCalendarChange"
        }).forEach(([st, pt]) => {
          at.deprecated(!(st in x), st, pt);
        });
      }
      const [ye, je] = fJ(b, K, H, W || Q, _), [Ue, Fe] = mJ(x, oe), tt = vJ(T), dt = Cb((at) => {
        var ft;
        return (ft = j ?? fe) !== null && ft !== void 0 ? ft : at;
      }), St = S.useContext(A0), mt = U ?? St, Ot = Do(yb), {
        hasFeedback: Rt,
        status: ct,
        feedbackIcon: it
      } = Ot, Ct = /* @__PURE__ */ S.createElement(gJ, {
        picker: Ne,
        hasFeedback: Rt,
        feedbackIcon: it,
        suffixIcon: X
      }), [ut] = q1("DatePicker", Ik), ht = Object.assign(Object.assign({}, ut), x.locale), [ot] = vS("DatePicker", (P = je.popup.root) === null || P === void 0 ? void 0 : P.zIndex);
      return le(/* @__PURE__ */ S.createElement(dS, {
        space: !0
      }, /* @__PURE__ */ S.createElement(NQ, Object.assign({
        ref: me,
        placeholder: Cwe(ht, Ne, F),
        suffixIcon: Ct,
        placement: L,
        prevIcon: /* @__PURE__ */ S.createElement("span", {
          className: `${oe}-prev-icon`
        }),
        nextIcon: /* @__PURE__ */ S.createElement("span", {
          className: `${oe}-next-icon`
        }),
        superPrevIcon: /* @__PURE__ */ S.createElement("span", {
          className: `${oe}-super-prev-icon`
        }),
        superNextIcon: /* @__PURE__ */ S.createElement("span", {
          className: `${oe}-super-next-icon`
        }),
        transitionName: `${pe}-slide-up`,
        picker: p,
        onCalendarChange: Oe
      }, we, te, {
        locale: ht.lang,
        className: _e({
          [`${oe}-${dt}`]: dt,
          [`${oe}-${De}`]: Me
        }, NE(oe, tM(ct, Y), Rt), se, be, ae?.className, D, Ae, ze, $, ye.root),
        style: Object.assign(Object.assign(Object.assign({}, ae?.style), N), je.root),
        prefixCls: oe,
        getPopupContainer: M || ne,
        generateConfig: e,
        components: tt,
        direction: ee,
        disabled: mt,
        classNames: {
          popup: _e(se, Ae, ze, $, ye.popup.root)
        },
        styles: {
          popup: Object.assign(Object.assign({}, je.popup.root), {
            zIndex: ot
          })
        },
        allowClear: Ue,
        removeIcon: Fe
      }))));
    });
    return process.env.NODE_ENV !== "production" && g && (w.displayName = g), w;
  }, r = t(), a = t(Ewe, Pwe), i = t(kwe, Mwe), c = t(Owe, Twe), d = t(Rwe, Awe), f = t(Dj, NW);
  return {
    DatePicker: r,
    WeekPicker: a,
    MonthPicker: i,
    YearPicker: c,
    TimePicker: f,
    QuarterPicker: d
  };
}, bJ = (e) => {
  const {
    DatePicker: t,
    WeekPicker: r,
    MonthPicker: a,
    YearPicker: i,
    TimePicker: c,
    QuarterPicker: d
  } = Fwe(e), f = Lwe(e), p = t;
  return p.WeekPicker = r, p.MonthPicker = a, p.YearPicker = i, p.RangePicker = f, p.TimePicker = c, p.QuarterPicker = d, process.env.NODE_ENV !== "production" && (p.displayName = "DatePicker"), p;
}, Qx = bJ(u1e), Wwe = Gx(Qx, "popupAlign", void 0, "picker");
Qx._InternalPanelDoNotUseOrYouWillBeFired = Wwe;
const Vwe = Gx(Qx.RangePicker, "popupAlign", void 0, "picker");
Qx._InternalRangePanelDoNotUseOrYouWillBeFired = Vwe;
Qx.generatePicker = bJ;
var DW = /* @__PURE__ */ S.createContext(null), yJ = /* @__PURE__ */ S.createContext({}), _we = ["prefixCls", "className", "containerRef"], wJ = function(t) {
  var r = t.prefixCls, a = t.className, i = t.containerRef, c = xr(t, _we), d = S.useContext(yJ), f = d.panel, p = gS(f, i);
  return /* @__PURE__ */ S.createElement("div", vt({
    className: _e("".concat(r, "-content"), a),
    role: "dialog",
    ref: p
  }, Zu(t, {
    aria: !0
  }), {
    "aria-modal": "true"
  }, c));
};
process.env.NODE_ENV !== "production" && (wJ.displayName = "DrawerPanel");
function $W(e) {
  return typeof e == "string" && String(Number(e)) === e ? ($n(!1, "Invalid value type of `width` or `height` which should be number type instead."), Number(e)) : e;
}
function Bwe(e) {
  $n(!("wrapperClassName" in e), "'wrapperClassName' is removed. Please use 'rootClassName' instead."), $n(Ju() || !e.open, "Drawer with 'open' in SSR is not work since no place to createPortal. Please move to 'useEffect' instead.");
}
var zW = {
  width: 0,
  height: 0,
  overflow: "hidden",
  outline: "none",
  position: "absolute"
};
function Uwe(e, t) {
  var r, a, i, c = e.prefixCls, d = e.open, f = e.placement, p = e.inline, g = e.push, b = e.forceRender, w = e.autoFocus, x = e.keyboard, E = e.classNames, P = e.rootClassName, k = e.rootStyle, M = e.zIndex, T = e.className, N = e.id, D = e.style, $ = e.motion, j = e.width, I = e.height, L = e.children, F = e.mask, _ = e.maskClosable, W = e.maskMotion, Q = e.maskClassName, U = e.maskStyle, Y = e.afterOpenChange, G = e.onClose, J = e.onMouseEnter, H = e.onMouseOver, K = e.onMouseLeave, X = e.onClick, te = e.onKeyDown, ie = e.onKeyUp, ee = e.styles, ne = e.drawerRender, ae = S.useRef(), oe = S.useRef(), fe = S.useRef();
  S.useImperativeHandle(t, function() {
    return ae.current;
  });
  var be = function(je) {
    var Ue = je.keyCode, Fe = je.shiftKey;
    switch (Ue) {
      // Tab active
      case fn.TAB: {
        if (Ue === fn.TAB) {
          if (!Fe && document.activeElement === fe.current) {
            var tt;
            (tt = oe.current) === null || tt === void 0 || tt.focus({
              preventScroll: !0
            });
          } else if (Fe && document.activeElement === oe.current) {
            var dt;
            (dt = fe.current) === null || dt === void 0 || dt.focus({
              preventScroll: !0
            });
          }
        }
        break;
      }
      // Close
      case fn.ESC: {
        G && x && (je.stopPropagation(), G(je));
        break;
      }
    }
  };
  S.useEffect(function() {
    if (d && w) {
      var ye;
      (ye = ae.current) === null || ye === void 0 || ye.focus({
        preventScroll: !0
      });
    }
  }, [d]);
  var me = S.useState(!1), De = qe(me, 2), Me = De[0], ze = De[1], le = S.useContext(DW), se;
  typeof g == "boolean" ? se = g ? {} : {
    distance: 0
  } : se = g || {};
  var Ae = (r = (a = (i = se) === null || i === void 0 ? void 0 : i.distance) !== null && a !== void 0 ? a : le?.pushDistance) !== null && r !== void 0 ? r : 180, we = S.useMemo(function() {
    return {
      pushDistance: Ae,
      push: function() {
        ze(!0);
      },
      pull: function() {
        ze(!1);
      }
    };
  }, [Ae]);
  S.useEffect(function() {
    if (d) {
      var ye;
      le == null || (ye = le.push) === null || ye === void 0 || ye.call(le);
    } else {
      var je;
      le == null || (je = le.pull) === null || je === void 0 || je.call(le);
    }
  }, [d]), S.useEffect(function() {
    return function() {
      var ye;
      le == null || (ye = le.pull) === null || ye === void 0 || ye.call(le);
    };
  }, []);
  var Ne = /* @__PURE__ */ S.createElement(N0, vt({
    key: "mask"
  }, W, {
    visible: F && d
  }), function(ye, je) {
    var Ue = ye.className, Fe = ye.style;
    return /* @__PURE__ */ S.createElement("div", {
      className: _e("".concat(c, "-mask"), Ue, E?.mask, Q),
      style: ce(ce(ce({}, Fe), U), ee?.mask),
      onClick: _ && d ? G : void 0,
      ref: je
    });
  }), pe = typeof $ == "function" ? $(f) : $, Qe = {};
  if (Me && Ae)
    switch (f) {
      case "top":
        Qe.transform = "translateY(".concat(Ae, "px)");
        break;
      case "bottom":
        Qe.transform = "translateY(".concat(-Ae, "px)");
        break;
      case "left":
        Qe.transform = "translateX(".concat(Ae, "px)");
        break;
      default:
        Qe.transform = "translateX(".concat(-Ae, "px)");
        break;
    }
  f === "left" || f === "right" ? Qe.width = $W(j) : Qe.height = $W(I);
  var Le = {
    onMouseEnter: J,
    onMouseOver: H,
    onMouseLeave: K,
    onClick: X,
    onKeyDown: te,
    onKeyUp: ie
  }, Te = /* @__PURE__ */ S.createElement(N0, vt({
    key: "panel"
  }, pe, {
    visible: d,
    forceRender: b,
    onVisibleChanged: function(je) {
      Y?.(je);
    },
    removeOnLeave: !1,
    leavedClassName: "".concat(c, "-content-wrapper-hidden")
  }), function(ye, je) {
    var Ue = ye.className, Fe = ye.style, tt = /* @__PURE__ */ S.createElement(wJ, vt({
      id: N,
      containerRef: je,
      prefixCls: c,
      className: _e(T, E?.content),
      style: ce(ce({}, D), ee?.content)
    }, Zu(e, {
      aria: !0
    }), Le), L);
    return /* @__PURE__ */ S.createElement("div", vt({
      className: _e("".concat(c, "-content-wrapper"), E?.wrapper, Ue),
      style: ce(ce(ce({}, Qe), Fe), ee?.wrapper)
    }, Zu(e, {
      data: !0
    })), ne ? ne(tt) : tt);
  }), Oe = ce({}, k);
  return M && (Oe.zIndex = M), /* @__PURE__ */ S.createElement(DW.Provider, {
    value: we
  }, /* @__PURE__ */ S.createElement("div", {
    className: _e(c, "".concat(c, "-").concat(f), P, ge(ge({}, "".concat(c, "-open"), d), "".concat(c, "-inline"), p)),
    style: Oe,
    tabIndex: -1,
    ref: ae,
    onKeyDown: be
  }, Ne, /* @__PURE__ */ S.createElement("div", {
    tabIndex: 0,
    ref: oe,
    style: zW,
    "aria-hidden": "true",
    "data-sentinel": "start"
  }), Te, /* @__PURE__ */ S.createElement("div", {
    tabIndex: 0,
    ref: fe,
    style: zW,
    "aria-hidden": "true",
    "data-sentinel": "end"
  })));
}
var SJ = /* @__PURE__ */ S.forwardRef(Uwe);
process.env.NODE_ENV !== "production" && (SJ.displayName = "DrawerPopup");
var CJ = function(t) {
  var r = t.open, a = r === void 0 ? !1 : r, i = t.prefixCls, c = i === void 0 ? "rc-drawer" : i, d = t.placement, f = d === void 0 ? "right" : d, p = t.autoFocus, g = p === void 0 ? !0 : p, b = t.keyboard, w = b === void 0 ? !0 : b, x = t.width, E = x === void 0 ? 378 : x, P = t.mask, k = P === void 0 ? !0 : P, M = t.maskClosable, T = M === void 0 ? !0 : M, N = t.getContainer, D = t.forceRender, $ = t.afterOpenChange, j = t.destroyOnClose, I = t.onMouseEnter, L = t.onMouseOver, F = t.onMouseLeave, _ = t.onClick, W = t.onKeyDown, Q = t.onKeyUp, U = t.panelRef, Y = S.useState(!1), G = qe(Y, 2), J = G[0], H = G[1];
  process.env.NODE_ENV !== "production" && Bwe(t);
  var K = S.useState(!1), X = qe(K, 2), te = X[0], ie = X[1];
  Da(function() {
    ie(!0);
  }, []);
  var ee = te ? a : !1, ne = S.useRef(), ae = S.useRef();
  Da(function() {
    ee && (ae.current = document.activeElement);
  }, [ee]);
  var oe = function(Me) {
    var ze;
    if (H(Me), $?.(Me), !Me && ae.current && !((ze = ne.current) !== null && ze !== void 0 && ze.contains(ae.current))) {
      var le;
      (le = ae.current) === null || le === void 0 || le.focus({
        preventScroll: !0
      });
    }
  }, fe = S.useMemo(function() {
    return {
      panel: U
    };
  }, [U]);
  if (!D && !J && !ee && j)
    return null;
  var be = {
    onMouseEnter: I,
    onMouseOver: L,
    onMouseLeave: F,
    onClick: _,
    onKeyDown: W,
    onKeyUp: Q
  }, me = ce(ce({}, t), {}, {
    open: ee,
    prefixCls: c,
    placement: f,
    autoFocus: g,
    keyboard: w,
    width: E,
    mask: k,
    maskClosable: T,
    inline: N === !1,
    afterOpenChange: oe,
    ref: ne
  }, be);
  return /* @__PURE__ */ S.createElement(yJ.Provider, {
    value: fe
  }, /* @__PURE__ */ S.createElement(qE, {
    open: ee || D || J,
    autoDestroy: !1,
    getContainer: N,
    autoLock: k && (ee || J)
  }, /* @__PURE__ */ S.createElement(SJ, me)));
};
process.env.NODE_ENV !== "production" && (CJ.displayName = "Drawer");
const xJ = (e) => {
  var t, r;
  const {
    prefixCls: a,
    ariaId: i,
    title: c,
    footer: d,
    extra: f,
    closable: p,
    loading: g,
    onClose: b,
    headerStyle: w,
    bodyStyle: x,
    footerStyle: E,
    children: P,
    classNames: k,
    styles: M
  } = e, T = om("drawer");
  let N;
  p === !1 ? N = void 0 : p === void 0 || p === !0 ? N = "start" : N = p?.placement === "end" ? "end" : "start";
  const D = S.useCallback((F) => /* @__PURE__ */ S.createElement("button", {
    type: "button",
    onClick: b,
    className: _e(`${a}-close`, {
      [`${a}-close-${N}`]: N === "end"
    })
  }, F), [b, a, N]), [$, j] = Gq(Wk(e), Wk(T), {
    closable: !0,
    closeIconRender: D
  }), I = () => {
    var F, _;
    return !c && !$ ? null : /* @__PURE__ */ S.createElement("div", {
      style: Object.assign(Object.assign(Object.assign({}, (F = T.styles) === null || F === void 0 ? void 0 : F.header), w), M?.header),
      className: _e(`${a}-header`, {
        [`${a}-header-close-only`]: $ && !c && !f
      }, (_ = T.classNames) === null || _ === void 0 ? void 0 : _.header, k?.header)
    }, /* @__PURE__ */ S.createElement("div", {
      className: `${a}-header-title`
    }, N === "start" && j, c && /* @__PURE__ */ S.createElement("div", {
      className: `${a}-title`,
      id: i
    }, c)), f && /* @__PURE__ */ S.createElement("div", {
      className: `${a}-extra`
    }, f), N === "end" && j);
  }, L = () => {
    var F, _;
    if (!d)
      return null;
    const W = `${a}-footer`;
    return /* @__PURE__ */ S.createElement("div", {
      className: _e(W, (F = T.classNames) === null || F === void 0 ? void 0 : F.footer, k?.footer),
      style: Object.assign(Object.assign(Object.assign({}, (_ = T.styles) === null || _ === void 0 ? void 0 : _.footer), E), M?.footer)
    }, d);
  };
  return /* @__PURE__ */ S.createElement(S.Fragment, null, I(), /* @__PURE__ */ S.createElement("div", {
    className: _e(`${a}-body`, k?.body, (t = T.classNames) === null || t === void 0 ? void 0 : t.body),
    style: Object.assign(Object.assign(Object.assign({}, (r = T.styles) === null || r === void 0 ? void 0 : r.body), x), M?.body)
  }, g ? /* @__PURE__ */ S.createElement(rC, {
    active: !0,
    title: !1,
    paragraph: {
      rows: 5
    },
    className: `${a}-body-skeleton`
  }) : P), L());
}, Xwe = (e) => {
  const t = "100%";
  return {
    left: `translateX(-${t})`,
    right: `translateX(${t})`,
    top: `translateY(-${t})`,
    bottom: `translateY(${t})`
  }[e];
}, EJ = (e, t) => ({
  "&-enter, &-appear": Object.assign(Object.assign({}, e), {
    "&-active": t
  }),
  "&-leave": Object.assign(Object.assign({}, t), {
    "&-active": e
  })
}), PJ = (e, t) => Object.assign({
  "&-enter, &-appear, &-leave": {
    "&-start": {
      transition: "none"
    },
    "&-active": {
      transition: `all ${t}`
    }
  }
}, EJ({
  opacity: e
}, {
  opacity: 1
})), Gwe = (e, t) => [PJ(0.7, t), EJ({
  transform: Xwe(e)
}, {
  transform: "none"
})], qwe = (e) => {
  const {
    componentCls: t,
    motionDurationSlow: r
  } = e;
  return {
    [t]: {
      // ======================== Mask ========================
      [`${t}-mask-motion`]: PJ(0, r),
      // ======================= Panel ========================
      [`${t}-panel-motion`]: ["left", "right", "top", "bottom"].reduce((a, i) => Object.assign(Object.assign({}, a), {
        [`&-${i}`]: Gwe(i, r)
      }), {})
    }
  };
}, Kwe = (e) => {
  const {
    borderRadiusSM: t,
    componentCls: r,
    zIndexPopup: a,
    colorBgMask: i,
    colorBgElevated: c,
    motionDurationSlow: d,
    motionDurationMid: f,
    paddingXS: p,
    padding: g,
    paddingLG: b,
    fontSizeLG: w,
    lineHeightLG: x,
    lineWidth: E,
    lineType: P,
    colorSplit: k,
    marginXS: M,
    colorIcon: T,
    colorIconHover: N,
    colorBgTextHover: D,
    colorBgTextActive: $,
    colorText: j,
    fontWeightStrong: I,
    footerPaddingBlock: L,
    footerPaddingInline: F,
    calc: _
  } = e, W = `${r}-content-wrapper`;
  return {
    [r]: {
      position: "fixed",
      inset: 0,
      zIndex: a,
      pointerEvents: "none",
      color: j,
      "&-pure": {
        position: "relative",
        background: c,
        display: "flex",
        flexDirection: "column",
        [`&${r}-left`]: {
          boxShadow: e.boxShadowDrawerLeft
        },
        [`&${r}-right`]: {
          boxShadow: e.boxShadowDrawerRight
        },
        [`&${r}-top`]: {
          boxShadow: e.boxShadowDrawerUp
        },
        [`&${r}-bottom`]: {
          boxShadow: e.boxShadowDrawerDown
        }
      },
      "&-inline": {
        position: "absolute"
      },
      // ====================== Mask ======================
      [`${r}-mask`]: {
        position: "absolute",
        inset: 0,
        zIndex: a,
        background: i,
        pointerEvents: "auto"
      },
      // ==================== Content =====================
      [W]: {
        position: "absolute",
        zIndex: a,
        maxWidth: "100vw",
        transition: `all ${d}`,
        "&-hidden": {
          display: "none"
        }
      },
      // Placement
      [`&-left > ${W}`]: {
        top: 0,
        bottom: 0,
        left: {
          _skip_check_: !0,
          value: 0
        },
        boxShadow: e.boxShadowDrawerLeft
      },
      [`&-right > ${W}`]: {
        top: 0,
        right: {
          _skip_check_: !0,
          value: 0
        },
        bottom: 0,
        boxShadow: e.boxShadowDrawerRight
      },
      [`&-top > ${W}`]: {
        top: 0,
        insetInline: 0,
        boxShadow: e.boxShadowDrawerUp
      },
      [`&-bottom > ${W}`]: {
        bottom: 0,
        insetInline: 0,
        boxShadow: e.boxShadowDrawerDown
      },
      [`${r}-content`]: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        overflow: "auto",
        background: c,
        pointerEvents: "auto"
      },
      // Header
      [`${r}-header`]: {
        display: "flex",
        flex: 0,
        alignItems: "center",
        padding: `${Ye(g)} ${Ye(b)}`,
        fontSize: w,
        lineHeight: x,
        borderBottom: `${Ye(E)} ${P} ${k}`,
        "&-title": {
          display: "flex",
          flex: 1,
          alignItems: "center",
          minWidth: 0,
          minHeight: 0
        }
      },
      [`${r}-extra`]: {
        flex: "none"
      },
      [`${r}-close`]: Object.assign({
        display: "inline-flex",
        width: _(w).add(p).equal(),
        height: _(w).add(p).equal(),
        borderRadius: t,
        justifyContent: "center",
        alignItems: "center",
        color: T,
        fontWeight: I,
        fontSize: w,
        fontStyle: "normal",
        lineHeight: 1,
        textAlign: "center",
        textTransform: "none",
        textDecoration: "none",
        background: "transparent",
        border: 0,
        cursor: "pointer",
        transition: `all ${f}`,
        textRendering: "auto",
        [`&${r}-close-end`]: {
          marginInlineStart: M
        },
        [`&:not(${r}-close-end)`]: {
          marginInlineEnd: M
        },
        "&:hover": {
          color: N,
          backgroundColor: D,
          textDecoration: "none"
        },
        "&:active": {
          backgroundColor: $
        }
      }, Z4(e)),
      [`${r}-title`]: {
        flex: 1,
        margin: 0,
        fontWeight: e.fontWeightStrong,
        fontSize: w,
        lineHeight: x
      },
      // Body
      [`${r}-body`]: {
        flex: 1,
        minWidth: 0,
        minHeight: 0,
        padding: b,
        overflow: "auto",
        [`${r}-body-skeleton`]: {
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center"
        }
      },
      // Footer
      [`${r}-footer`]: {
        flexShrink: 0,
        padding: `${Ye(L)} ${Ye(F)}`,
        borderTop: `${Ye(E)} ${P} ${k}`
      },
      // ====================== RTL =======================
      "&-rtl": {
        direction: "rtl"
      }
    }
  };
}, Ywe = (e) => ({
  zIndexPopup: e.zIndexPopupBase,
  footerPaddingBlock: e.paddingXS,
  footerPaddingInline: e.padding
}), kJ = Ii("Drawer", (e) => {
  const t = lo(e, {});
  return [Kwe(t), qwe(t)];
}, Ywe);
var MJ = function(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
    t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
};
const Qwe = {
  distance: 180
}, $j = (e) => {
  var t;
  const {
    rootClassName: r,
    width: a,
    height: i,
    size: c = "default",
    mask: d = !0,
    push: f = Qwe,
    open: p,
    afterOpenChange: g,
    onClose: b,
    prefixCls: w,
    getContainer: x,
    panelRef: E = null,
    style: P,
    className: k,
    "aria-labelledby": M,
    // Deprecated
    visible: T,
    afterVisibleChange: N,
    maskStyle: D,
    drawerStyle: $,
    contentWrapperStyle: j,
    destroyOnClose: I,
    destroyOnHidden: L
  } = e, F = MJ(e, ["rootClassName", "width", "height", "size", "mask", "push", "open", "afterOpenChange", "onClose", "prefixCls", "getContainer", "panelRef", "style", "className", "aria-labelledby", "visible", "afterVisibleChange", "maskStyle", "drawerStyle", "contentWrapperStyle", "destroyOnClose", "destroyOnHidden"]), _ = KE(), W = F.title ? _ : void 0, {
    getPopupContainer: Q,
    getPrefixCls: U,
    direction: Y,
    className: G,
    style: J,
    classNames: H,
    styles: K
  } = om("drawer"), X = U("drawer", w), [te, ie, ee] = kJ(X), ne = (
    // 有可能为 false，所以不能直接判断
    x === void 0 && Q ? () => Q(document.body) : x
  ), ae = _e({
    "no-mask": !d,
    [`${X}-rtl`]: Y === "rtl"
  }, r, ie, ee);
  if (process.env.NODE_ENV !== "production") {
    const we = To("Drawer");
    [["visible", "open"], ["afterVisibleChange", "afterOpenChange"], ["headerStyle", "styles.header"], ["bodyStyle", "styles.body"], ["footerStyle", "styles.footer"], ["contentWrapperStyle", "styles.wrapper"], ["maskStyle", "styles.mask"], ["drawerStyle", "styles.content"], ["destroyInactivePanel", "destroyOnHidden"]].forEach(([Ne, pe]) => {
      we.deprecated(!(Ne in e), Ne, pe);
    }), ne !== void 0 && ((t = e.style) === null || t === void 0 ? void 0 : t.position) === "absolute" && process.env.NODE_ENV !== "production" && we(!1, "breaking", "`style` is replaced by `rootStyle` in v5. Please check that `position: absolute` is necessary.");
  }
  const oe = S.useMemo(() => a ?? (c === "large" ? 736 : 378), [a, c]), fe = S.useMemo(() => i ?? (c === "large" ? 736 : 378), [i, c]), be = {
    motionName: uS(X, "mask-motion"),
    motionAppear: !0,
    motionEnter: !0,
    motionLeave: !0,
    motionDeadline: 500
  }, me = (we) => ({
    motionName: uS(X, `panel-motion-${we}`),
    motionAppear: !0,
    motionEnter: !0,
    motionLeave: !0,
    motionDeadline: 500
  }), De = OK(), Me = mp(E, De), [ze, le] = vS("Drawer", F.zIndex), {
    classNames: se = {},
    styles: Ae = {}
  } = F;
  return te(/* @__PURE__ */ S.createElement(dS, {
    form: !0,
    space: !0
  }, /* @__PURE__ */ S.createElement(Ux.Provider, {
    value: le
  }, /* @__PURE__ */ S.createElement(CJ, Object.assign({
    prefixCls: X,
    onClose: b,
    maskMotion: be,
    motion: me
  }, F, {
    classNames: {
      mask: _e(se.mask, H.mask),
      content: _e(se.content, H.content),
      wrapper: _e(se.wrapper, H.wrapper)
    },
    styles: {
      mask: Object.assign(Object.assign(Object.assign({}, Ae.mask), D), K.mask),
      content: Object.assign(Object.assign(Object.assign({}, Ae.content), $), K.content),
      wrapper: Object.assign(Object.assign(Object.assign({}, Ae.wrapper), j), K.wrapper)
    },
    open: p ?? T,
    mask: d,
    push: f,
    width: oe,
    height: fe,
    style: Object.assign(Object.assign({}, J), P),
    className: _e(G, k),
    rootClassName: ae,
    getContainer: ne,
    afterOpenChange: g ?? N,
    panelRef: Me,
    zIndex: ze,
    "aria-labelledby": M ?? W,
    // TODO: In the future, destroyOnClose in rc-drawer needs to be upgrade to destroyOnHidden
    destroyOnClose: L ?? I
  }), /* @__PURE__ */ S.createElement(xJ, Object.assign({
    prefixCls: X
  }, F, {
    ariaId: W,
    onClose: b
  }))))));
}, Jwe = (e) => {
  const {
    prefixCls: t,
    style: r,
    className: a,
    placement: i = "right"
  } = e, c = MJ(e, ["prefixCls", "style", "className", "placement"]), {
    getPrefixCls: d
  } = S.useContext(Qr), f = d("drawer", t), [p, g, b] = kJ(f), w = _e(f, `${f}-pure`, `${f}-${i}`, g, b, a);
  return p(/* @__PURE__ */ S.createElement("div", {
    className: w,
    style: r
  }, /* @__PURE__ */ S.createElement(xJ, Object.assign({
    prefixCls: f
  }, c))));
};
$j._InternalPanelDoNotUseOrYouWillBeFired = Jwe;
process.env.NODE_ENV !== "production" && ($j.displayName = "Drawer");
function jW(e) {
  return ["small", "middle", "large"].includes(e);
}
function IW(e) {
  return e ? typeof e == "number" && !Number.isNaN(e) : !1;
}
const Zwe = (e) => {
  const {
    componentCls: t,
    borderRadius: r,
    paddingSM: a,
    colorBorder: i,
    paddingXS: c,
    fontSizeLG: d,
    fontSizeSM: f,
    borderRadiusLG: p,
    borderRadiusSM: g,
    colorBgContainerDisabled: b,
    lineWidth: w
  } = e;
  return {
    [t]: [{
      display: "inline-flex",
      alignItems: "center",
      gap: 0,
      paddingInline: a,
      margin: 0,
      background: b,
      borderWidth: w,
      borderStyle: "solid",
      borderColor: i,
      borderRadius: r,
      "&-large": {
        fontSize: d,
        borderRadius: p
      },
      "&-small": {
        paddingInline: c,
        borderRadius: g,
        fontSize: f
      },
      "&-compact-last-item": {
        borderEndStartRadius: 0,
        borderStartStartRadius: 0
      },
      "&-compact-first-item": {
        borderEndEndRadius: 0,
        borderStartEndRadius: 0
      },
      "&-compact-item:not(:first-child):not(:last-child)": {
        borderRadius: 0
      },
      "&-compact-item:not(:last-child)": {
        borderInlineEndWidth: 0
      }
    }, XE(e, {
      focus: !1
    })]
  };
}, eSe = Ii(["Space", "Addon"], (e) => [Zwe(e)]);
var tSe = function(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
    t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
};
const nSe = /* @__PURE__ */ Re.forwardRef((e, t) => {
  const {
    className: r,
    children: a,
    style: i,
    prefixCls: c
  } = e, d = tSe(e, ["className", "children", "style", "prefixCls"]), {
    getPrefixCls: f,
    direction: p
  } = Re.useContext(Qr), g = f("space-addon", c), [b, w, x] = eSe(g), {
    compactItemClassnames: E,
    compactSize: P
  } = h3(g, p), k = _e(g, w, E, x, {
    [`${g}-${P}`]: P
  }, r);
  return b(/* @__PURE__ */ Re.createElement("div", Object.assign({
    ref: t,
    className: k,
    style: i
  }, d), a));
}), OJ = /* @__PURE__ */ Re.createContext({
  latestIndex: 0
}), rSe = OJ.Provider, aSe = ({
  className: e,
  index: t,
  children: r,
  split: a,
  style: i
}) => {
  const {
    latestIndex: c
  } = S.useContext(OJ);
  return r == null ? null : /* @__PURE__ */ S.createElement(S.Fragment, null, /* @__PURE__ */ S.createElement("div", {
    className: e,
    style: i
  }, r), t < c && a && /* @__PURE__ */ S.createElement("span", {
    className: `${e}-split`
  }, a));
}, oSe = (e) => {
  const {
    componentCls: t,
    antCls: r
  } = e;
  return {
    [t]: {
      display: "inline-flex",
      "&-rtl": {
        direction: "rtl"
      },
      "&-vertical": {
        flexDirection: "column"
      },
      "&-align": {
        flexDirection: "column",
        "&-center": {
          alignItems: "center"
        },
        "&-start": {
          alignItems: "flex-start"
        },
        "&-end": {
          alignItems: "flex-end"
        },
        "&-baseline": {
          alignItems: "baseline"
        }
      },
      [`${t}-item:empty`]: {
        display: "none"
      },
      // https://github.com/ant-design/ant-design/issues/47875
      [`${t}-item > ${r}-badge-not-a-wrapper:only-child`]: {
        display: "block"
      }
    }
  };
}, iSe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      "&-gap-row-small": {
        rowGap: e.spaceGapSmallSize
      },
      "&-gap-row-middle": {
        rowGap: e.spaceGapMiddleSize
      },
      "&-gap-row-large": {
        rowGap: e.spaceGapLargeSize
      },
      "&-gap-col-small": {
        columnGap: e.spaceGapSmallSize
      },
      "&-gap-col-middle": {
        columnGap: e.spaceGapMiddleSize
      },
      "&-gap-col-large": {
        columnGap: e.spaceGapLargeSize
      }
    }
  };
}, lSe = Ii("Space", (e) => {
  const t = lo(e, {
    spaceGapSmallSize: e.paddingXS,
    spaceGapMiddleSize: e.padding,
    spaceGapLargeSize: e.paddingLG
  });
  return [oSe(t), iSe(t)];
}, () => ({}), {
  // Space component don't apply extra font style
  // https://github.com/ant-design/ant-design/issues/40315
  resetStyle: !1
});
var sSe = function(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
    t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
};
const uSe = /* @__PURE__ */ S.forwardRef((e, t) => {
  var r;
  const {
    getPrefixCls: a,
    direction: i,
    size: c,
    className: d,
    style: f,
    classNames: p,
    styles: g
  } = om("space"), {
    size: b = c ?? "small",
    align: w,
    className: x,
    rootClassName: E,
    children: P,
    direction: k = "horizontal",
    prefixCls: M,
    split: T,
    style: N,
    wrap: D = !1,
    classNames: $,
    styles: j
  } = e, I = sSe(e, ["size", "align", "className", "rootClassName", "children", "direction", "prefixCls", "split", "style", "wrap", "classNames", "styles"]), [L, F] = Array.isArray(b) ? b : [b, b], _ = jW(F), W = jW(L), Q = IW(F), U = IW(L), Y = Kh(P, {
    keepEmpty: !0
  }), G = w === void 0 && k === "horizontal" ? "center" : w, J = a("space", M), [H, K, X] = lSe(J), te = _e(J, d, K, `${J}-${k}`, {
    [`${J}-rtl`]: i === "rtl",
    [`${J}-align-${G}`]: G,
    [`${J}-gap-row-${F}`]: _,
    [`${J}-gap-col-${L}`]: W
  }, x, E, X), ie = _e(`${J}-item`, (r = $?.item) !== null && r !== void 0 ? r : p.item), ee = Object.assign(Object.assign({}, g.item), j?.item), ne = Y.map((fe, be) => {
    const me = fe?.key || `${ie}-${be}`;
    return /* @__PURE__ */ S.createElement(aSe, {
      className: ie,
      key: me,
      index: be,
      split: T,
      style: ee
    }, fe);
  }), ae = S.useMemo(() => ({
    latestIndex: Y.reduce((be, me, De) => me != null ? De : be, 0)
  }), [Y]);
  if (Y.length === 0)
    return null;
  const oe = {};
  return D && (oe.flexWrap = "wrap"), !W && U && (oe.columnGap = L), !_ && Q && (oe.rowGap = F), H(/* @__PURE__ */ S.createElement("div", Object.assign({
    ref: t,
    className: te,
    style: Object.assign(Object.assign(Object.assign({}, oe), f), N)
  }, I), /* @__PURE__ */ S.createElement(rSe, {
    value: ae
  }, ne)));
}), s7 = uSe;
s7.Compact = nfe;
s7.Addon = nSe;
process.env.NODE_ENV !== "production" && (s7.displayName = "Space");
var cSe = function(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
    t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
};
const TJ = (e) => {
  const {
    getPopupContainer: t,
    getPrefixCls: r,
    direction: a
  } = S.useContext(Qr), {
    prefixCls: i,
    type: c = "default",
    danger: d,
    disabled: f,
    loading: p,
    onClick: g,
    htmlType: b,
    children: w,
    className: x,
    menu: E,
    arrow: P,
    autoFocus: k,
    overlay: M,
    trigger: T,
    align: N,
    open: D,
    onOpenChange: $,
    placement: j,
    getPopupContainer: I,
    href: L,
    icon: F = /* @__PURE__ */ S.createElement(vj, null),
    title: _,
    buttonsRender: W = (le) => le,
    mouseEnterDelay: Q,
    mouseLeaveDelay: U,
    overlayClassName: Y,
    overlayStyle: G,
    destroyOnHidden: J,
    destroyPopupOnHide: H,
    dropdownRender: K,
    popupRender: X
  } = e, te = cSe(e, ["prefixCls", "type", "danger", "disabled", "loading", "onClick", "htmlType", "children", "className", "menu", "arrow", "autoFocus", "overlay", "trigger", "align", "open", "onOpenChange", "placement", "getPopupContainer", "href", "icon", "title", "buttonsRender", "mouseEnterDelay", "mouseLeaveDelay", "overlayClassName", "overlayStyle", "destroyOnHidden", "destroyPopupOnHide", "dropdownRender", "popupRender"]), ie = r("dropdown", i), ee = `${ie}-button`, ae = {
    menu: E,
    arrow: P,
    autoFocus: k,
    align: N,
    disabled: f,
    trigger: f ? [] : T,
    onOpenChange: $,
    getPopupContainer: I || t,
    mouseEnterDelay: Q,
    mouseLeaveDelay: U,
    overlayClassName: Y,
    overlayStyle: G,
    destroyOnHidden: J,
    popupRender: X || K
  }, {
    compactSize: oe,
    compactItemClassnames: fe
  } = h3(ie, a), be = _e(ee, fe, x);
  "destroyPopupOnHide" in e && (ae.destroyPopupOnHide = H), "overlay" in e && (ae.overlay = M), "open" in e && (ae.open = D), "placement" in e ? ae.placement = j : ae.placement = a === "rtl" ? "bottomLeft" : "bottomRight";
  const me = /* @__PURE__ */ S.createElement(cp, {
    type: c,
    danger: d,
    disabled: f,
    loading: p,
    onClick: g,
    htmlType: b,
    href: L,
    title: _
  }, w), De = /* @__PURE__ */ S.createElement(cp, {
    type: c,
    danger: d,
    icon: F
  }), [Me, ze] = W([me, De]);
  return /* @__PURE__ */ S.createElement(s7.Compact, Object.assign({
    className: be,
    size: oe,
    block: !0
  }, te), Me, /* @__PURE__ */ S.createElement(a7, Object.assign({}, ae), ze));
};
TJ.__ANT_BUTTON = !0;
const gM = a7;
gM.Button = TJ;
var dSe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z" } }] }, name: "eye", theme: "outlined" }, fSe = function(t, r) {
  return /* @__PURE__ */ S.createElement(Ao, vt({}, t, {
    ref: r,
    icon: dSe
  }));
}, RJ = /* @__PURE__ */ S.forwardRef(fSe);
process.env.NODE_ENV !== "production" && (RJ.displayName = "EyeOutlined");
function LW(e, t, r, a) {
  var i = hb.unstable_batchedUpdates ? function(d) {
    hb.unstable_batchedUpdates(r, d);
  } : r;
  return e != null && e.addEventListener && e.addEventListener(t, i, a), {
    remove: function() {
      e != null && e.removeEventListener && e.removeEventListener(t, i, a);
    }
  };
}
var mSe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z" } }] }, name: "double-left", theme: "outlined" }, hSe = function(t, r) {
  return /* @__PURE__ */ S.createElement(Ao, vt({}, t, {
    ref: r,
    icon: mSe
  }));
}, qD = /* @__PURE__ */ S.forwardRef(hSe);
process.env.NODE_ENV !== "production" && (qD.displayName = "DoubleLeftOutlined");
var pSe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z" } }] }, name: "double-right", theme: "outlined" }, gSe = function(t, r) {
  return /* @__PURE__ */ S.createElement(Ao, vt({}, t, {
    ref: r,
    icon: pSe
  }));
}, KD = /* @__PURE__ */ S.forwardRef(gSe);
process.env.NODE_ENV !== "production" && (KD.displayName = "DoubleRightOutlined");
var vSe = {
  // Options
  items_per_page: "条/页",
  jump_to: "跳至",
  jump_to_confirm: "确定",
  page: "页",
  // Pagination
  prev_page: "上一页",
  next_page: "下一页",
  prev_5: "向前 5 页",
  next_5: "向后 5 页",
  prev_3: "向前 3 页",
  next_3: "向后 3 页",
  page_size: "页码"
}, bSe = [10, 20, 50, 100], AJ = function(t) {
  var r = t.pageSizeOptions, a = r === void 0 ? bSe : r, i = t.locale, c = t.changeSize, d = t.pageSize, f = t.goButton, p = t.quickGo, g = t.rootPrefixCls, b = t.disabled, w = t.buildOptionText, x = t.showSizeChanger, E = t.sizeChangerRender, P = Re.useState(""), k = qe(P, 2), M = k[0], T = k[1], N = function() {
    return !M || Number.isNaN(M) ? void 0 : Number(M);
  }, D = typeof w == "function" ? w : function(U) {
    return "".concat(U, " ").concat(i.items_per_page);
  }, $ = function(Y) {
    T(Y.target.value);
  }, j = function(Y) {
    f || M === "" || (T(""), !(Y.relatedTarget && (Y.relatedTarget.className.indexOf("".concat(g, "-item-link")) >= 0 || Y.relatedTarget.className.indexOf("".concat(g, "-item")) >= 0)) && p?.(N()));
  }, I = function(Y) {
    M !== "" && (Y.keyCode === fn.ENTER || Y.type === "click") && (T(""), p?.(N()));
  }, L = function() {
    return a.some(function(Y) {
      return Y.toString() === d.toString();
    }) ? a : a.concat([d]).sort(function(Y, G) {
      var J = Number.isNaN(Number(Y)) ? 0 : Number(Y), H = Number.isNaN(Number(G)) ? 0 : Number(G);
      return J - H;
    });
  }, F = "".concat(g, "-options");
  if (!x && !p)
    return null;
  var _ = null, W = null, Q = null;
  return x && E && (_ = E({
    disabled: b,
    size: d,
    onSizeChange: function(Y) {
      c?.(Number(Y));
    },
    "aria-label": i.page_size,
    className: "".concat(F, "-size-changer"),
    options: L().map(function(U) {
      return {
        label: D(U),
        value: U
      };
    })
  })), p && (f && (Q = typeof f == "boolean" ? /* @__PURE__ */ Re.createElement("button", {
    type: "button",
    onClick: I,
    onKeyUp: I,
    disabled: b,
    className: "".concat(F, "-quick-jumper-button")
  }, i.jump_to_confirm) : /* @__PURE__ */ Re.createElement("span", {
    onClick: I,
    onKeyUp: I
  }, f)), W = /* @__PURE__ */ Re.createElement("div", {
    className: "".concat(F, "-quick-jumper")
  }, i.jump_to, /* @__PURE__ */ Re.createElement("input", {
    disabled: b,
    type: "text",
    value: M,
    onChange: $,
    onKeyUp: I,
    onBlur: j,
    "aria-label": i.page
  }), i.page, Q)), /* @__PURE__ */ Re.createElement("li", {
    className: F
  }, _, W);
};
process.env.NODE_ENV !== "production" && (AJ.displayName = "Options");
var U3 = function(t) {
  var r = t.rootPrefixCls, a = t.page, i = t.active, c = t.className, d = t.showTitle, f = t.onClick, p = t.onKeyPress, g = t.itemRender, b = "".concat(r, "-item"), w = _e(b, "".concat(b, "-").concat(a), ge(ge({}, "".concat(b, "-active"), i), "".concat(b, "-disabled"), !a), c), x = function() {
    f(a);
  }, E = function(M) {
    p(M, f, a);
  }, P = g(a, "page", /* @__PURE__ */ Re.createElement("a", {
    rel: "nofollow"
  }, a));
  return P ? /* @__PURE__ */ Re.createElement("li", {
    title: d ? String(a) : null,
    className: w,
    onClick: x,
    onKeyDown: E,
    tabIndex: 0
  }, P) : null;
};
process.env.NODE_ENV !== "production" && (U3.displayName = "Pager");
var ySe = function(t, r, a) {
  return a;
};
function xR() {
}
function HW(e) {
  var t = Number(e);
  return typeof t == "number" && !Number.isNaN(t) && isFinite(t) && Math.floor(t) === t;
}
function j4(e, t, r) {
  var a = typeof e > "u" ? t : e;
  return Math.floor((r - 1) / a) + 1;
}
var NJ = function(t) {
  var r = t.prefixCls, a = r === void 0 ? "rc-pagination" : r, i = t.selectPrefixCls, c = i === void 0 ? "rc-select" : i, d = t.className, f = t.current, p = t.defaultCurrent, g = p === void 0 ? 1 : p, b = t.total, w = b === void 0 ? 0 : b, x = t.pageSize, E = t.defaultPageSize, P = E === void 0 ? 10 : E, k = t.onChange, M = k === void 0 ? xR : k, T = t.hideOnSinglePage, N = t.align, D = t.showPrevNextJumpers, $ = D === void 0 ? !0 : D, j = t.showQuickJumper, I = t.showLessItems, L = t.showTitle, F = L === void 0 ? !0 : L, _ = t.onShowSizeChange, W = _ === void 0 ? xR : _, Q = t.locale, U = Q === void 0 ? vSe : Q, Y = t.style, G = t.totalBoundaryShowSizeChanger, J = G === void 0 ? 50 : G, H = t.disabled, K = t.simple, X = t.showTotal, te = t.showSizeChanger, ie = te === void 0 ? w > J : te, ee = t.sizeChangerRender, ne = t.pageSizeOptions, ae = t.itemRender, oe = ae === void 0 ? ySe : ae, fe = t.jumpPrevIcon, be = t.jumpNextIcon, me = t.prevIcon, De = t.nextIcon, Me = Re.useRef(null), ze = ll(10, {
    value: x,
    defaultValue: P
  }), le = qe(ze, 2), se = le[0], Ae = le[1], we = ll(1, {
    value: f,
    defaultValue: g,
    postState: function(Un) {
      return Math.max(1, Math.min(Un, j4(void 0, se, w)));
    }
  }), Ne = qe(we, 2), pe = Ne[0], Qe = Ne[1], Le = Re.useState(pe), Te = qe(Le, 2), Oe = Te[0], ye = Te[1];
  Er(function() {
    ye(pe);
  }, [pe]);
  var je = M !== xR, Ue = "current" in t;
  process.env.NODE_ENV !== "production" && $n(Ue ? je : !0, "You provided a `current` prop to a Pagination component without an `onChange` handler. This will render a read-only component.");
  var Fe = Math.max(1, pe - (I ? 3 : 5)), tt = Math.min(j4(void 0, se, w), pe + (I ? 3 : 5));
  function dt(dn, Un) {
    var sr = dn || /* @__PURE__ */ Re.createElement("button", {
      type: "button",
      "aria-label": Un,
      className: "".concat(a, "-item-link")
    });
    return typeof dn == "function" && (sr = /* @__PURE__ */ Re.createElement(dn, ce({}, t))), sr;
  }
  function St(dn) {
    var Un = dn.target.value, sr = j4(void 0, se, w), Yr;
    return Un === "" ? Yr = Un : Number.isNaN(Number(Un)) ? Yr = Oe : Un >= sr ? Yr = sr : Yr = Number(Un), Yr;
  }
  function mt(dn) {
    return HW(dn) && dn !== pe && HW(w) && w > 0;
  }
  var Ot = w > se ? j : !1;
  function Rt(dn) {
    (dn.keyCode === fn.UP || dn.keyCode === fn.DOWN) && dn.preventDefault();
  }
  function ct(dn) {
    var Un = St(dn);
    switch (Un !== Oe && ye(Un), dn.keyCode) {
      case fn.ENTER:
        ut(Un);
        break;
      case fn.UP:
        ut(Un - 1);
        break;
      case fn.DOWN:
        ut(Un + 1);
        break;
    }
  }
  function it(dn) {
    ut(St(dn));
  }
  function Ct(dn) {
    var Un = j4(dn, se, w), sr = pe > Un && Un !== 0 ? Un : pe;
    Ae(dn), ye(sr), W?.(pe, dn), Qe(sr), M?.(sr, dn);
  }
  function ut(dn) {
    if (mt(dn) && !H) {
      var Un = j4(void 0, se, w), sr = dn;
      return dn > Un ? sr = Un : dn < 1 && (sr = 1), sr !== Oe && ye(sr), Qe(sr), M?.(sr, se), sr;
    }
    return pe;
  }
  var ht = pe > 1, ot = pe < j4(void 0, se, w);
  function at() {
    ht && ut(pe - 1);
  }
  function ft() {
    ot && ut(pe + 1);
  }
  function st() {
    ut(Fe);
  }
  function pt() {
    ut(tt);
  }
  function bt(dn, Un) {
    if (dn.key === "Enter" || dn.charCode === fn.ENTER || dn.keyCode === fn.ENTER) {
      for (var sr = arguments.length, Yr = new Array(sr > 2 ? sr - 2 : 0), Wa = 2; Wa < sr; Wa++)
        Yr[Wa - 2] = arguments[Wa];
      Un.apply(void 0, Yr);
    }
  }
  function Nt(dn) {
    bt(dn, at);
  }
  function $t(dn) {
    bt(dn, ft);
  }
  function Pt(dn) {
    bt(dn, st);
  }
  function hn(dn) {
    bt(dn, pt);
  }
  function an(dn) {
    var Un = oe(dn, "prev", dt(me, "prev page"));
    return /* @__PURE__ */ Re.isValidElement(Un) ? /* @__PURE__ */ Re.cloneElement(Un, {
      disabled: !ht
    }) : Un;
  }
  function jn(dn) {
    var Un = oe(dn, "next", dt(De, "next page"));
    return /* @__PURE__ */ Re.isValidElement(Un) ? /* @__PURE__ */ Re.cloneElement(Un, {
      disabled: !ot
    }) : Un;
  }
  function xn(dn) {
    (dn.type === "click" || dn.keyCode === fn.ENTER) && ut(Oe);
  }
  var Ut = null, pn = Zu(t, {
    aria: !0,
    data: !0
  }), wn = X && /* @__PURE__ */ Re.createElement("li", {
    className: "".concat(a, "-total-text")
  }, X(w, [w === 0 ? 0 : (pe - 1) * se + 1, pe * se > w ? w : pe * se])), Lt = null, gt = j4(void 0, se, w);
  if (T && w <= se)
    return null;
  var wt = [], Ft = {
    rootPrefixCls: a,
    onClick: ut,
    onKeyPress: bt,
    showTitle: F,
    itemRender: oe,
    page: -1
  }, yn = pe - 1 > 0 ? pe - 1 : 0, gn = pe + 1 < gt ? pe + 1 : gt, Tn = j && j.goButton, Gt = Hn(K) === "object" ? K.readOnly : !K, Dt = Tn, Yt = null;
  K && (Tn && (typeof Tn == "boolean" ? Dt = /* @__PURE__ */ Re.createElement("button", {
    type: "button",
    onClick: xn,
    onKeyUp: xn
  }, U.jump_to_confirm) : Dt = /* @__PURE__ */ Re.createElement("span", {
    onClick: xn,
    onKeyUp: xn
  }, Tn), Dt = /* @__PURE__ */ Re.createElement("li", {
    title: F ? "".concat(U.jump_to).concat(pe, "/").concat(gt) : null,
    className: "".concat(a, "-simple-pager")
  }, Dt)), Yt = /* @__PURE__ */ Re.createElement("li", {
    title: F ? "".concat(pe, "/").concat(gt) : null,
    className: "".concat(a, "-simple-pager")
  }, Gt ? Oe : /* @__PURE__ */ Re.createElement("input", {
    type: "text",
    "aria-label": U.jump_to,
    value: Oe,
    disabled: H,
    onKeyDown: Rt,
    onKeyUp: ct,
    onChange: ct,
    onBlur: it,
    size: 3
  }), /* @__PURE__ */ Re.createElement("span", {
    className: "".concat(a, "-slash")
  }, "/"), gt));
  var Mn = I ? 1 : 2;
  if (gt <= 3 + Mn * 2) {
    gt || wt.push(/* @__PURE__ */ Re.createElement(U3, vt({}, Ft, {
      key: "noPager",
      page: 1,
      className: "".concat(a, "-item-disabled")
    })));
    for (var Gn = 1; Gn <= gt; Gn += 1)
      wt.push(/* @__PURE__ */ Re.createElement(U3, vt({}, Ft, {
        key: Gn,
        page: Gn,
        active: pe === Gn
      })));
  } else {
    var wr = I ? U.prev_3 : U.prev_5, aa = I ? U.next_3 : U.next_5, qn = oe(Fe, "jump-prev", dt(fe, "prev page")), Rr = oe(tt, "jump-next", dt(be, "next page"));
    $ && (Ut = qn ? /* @__PURE__ */ Re.createElement("li", {
      title: F ? wr : null,
      key: "prev",
      onClick: st,
      tabIndex: 0,
      onKeyDown: Pt,
      className: _e("".concat(a, "-jump-prev"), ge({}, "".concat(a, "-jump-prev-custom-icon"), !!fe))
    }, qn) : null, Lt = Rr ? /* @__PURE__ */ Re.createElement("li", {
      title: F ? aa : null,
      key: "next",
      onClick: pt,
      tabIndex: 0,
      onKeyDown: hn,
      className: _e("".concat(a, "-jump-next"), ge({}, "".concat(a, "-jump-next-custom-icon"), !!be))
    }, Rr) : null);
    var Wt = Math.max(1, pe - Mn), en = Math.min(pe + Mn, gt);
    pe - 1 <= Mn && (en = 1 + Mn * 2), gt - pe <= Mn && (Wt = gt - Mn * 2);
    for (var Xt = Wt; Xt <= en; Xt += 1)
      wt.push(/* @__PURE__ */ Re.createElement(U3, vt({}, Ft, {
        key: Xt,
        page: Xt,
        active: pe === Xt
      })));
    if (pe - 1 >= Mn * 2 && pe !== 3 && (wt[0] = /* @__PURE__ */ Re.cloneElement(wt[0], {
      className: _e("".concat(a, "-item-after-jump-prev"), wt[0].props.className)
    }), wt.unshift(Ut)), gt - pe >= Mn * 2 && pe !== gt - 2) {
      var zt = wt[wt.length - 1];
      wt[wt.length - 1] = /* @__PURE__ */ Re.cloneElement(zt, {
        className: _e("".concat(a, "-item-before-jump-next"), zt.props.className)
      }), wt.push(Lt);
    }
    Wt !== 1 && wt.unshift(/* @__PURE__ */ Re.createElement(U3, vt({}, Ft, {
      key: 1,
      page: 1
    }))), en !== gt && wt.push(/* @__PURE__ */ Re.createElement(U3, vt({}, Ft, {
      key: gt,
      page: gt
    })));
  }
  var kt = an(yn);
  if (kt) {
    var Qn = !ht || !gt;
    kt = /* @__PURE__ */ Re.createElement("li", {
      title: F ? U.prev_page : null,
      onClick: at,
      tabIndex: Qn ? null : 0,
      onKeyDown: Nt,
      className: _e("".concat(a, "-prev"), ge({}, "".concat(a, "-disabled"), Qn)),
      "aria-disabled": Qn
    }, kt);
  }
  var Jn = jn(gn);
  if (Jn) {
    var Nr, Hr;
    K ? (Nr = !ot, Hr = ht ? 0 : null) : (Nr = !ot || !gt, Hr = Nr ? null : 0), Jn = /* @__PURE__ */ Re.createElement("li", {
      title: F ? U.next_page : null,
      onClick: ft,
      tabIndex: Hr,
      onKeyDown: $t,
      className: _e("".concat(a, "-next"), ge({}, "".concat(a, "-disabled"), Nr)),
      "aria-disabled": Nr
    }, Jn);
  }
  var oa = _e(a, d, ge(ge(ge(ge(ge({}, "".concat(a, "-start"), N === "start"), "".concat(a, "-center"), N === "center"), "".concat(a, "-end"), N === "end"), "".concat(a, "-simple"), K), "".concat(a, "-disabled"), H));
  return /* @__PURE__ */ Re.createElement("ul", vt({
    className: oa,
    style: Y,
    ref: Me
  }, pn), wn, kt, K ? Yt : wt, Jn, /* @__PURE__ */ Re.createElement(AJ, {
    locale: U,
    rootPrefixCls: a,
    disabled: H,
    selectPrefixCls: c,
    changeSize: Ct,
    pageSize: se,
    pageSizeOptions: ne,
    quickGo: Ot ? ut : null,
    goButton: Dt,
    showSizeChanger: ie,
    sizeChangerRender: ee
  }));
};
process.env.NODE_ENV !== "production" && (NJ.displayName = "Pagination");
const wSe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-disabled`]: {
      "&, &:hover": {
        cursor: "not-allowed",
        [`${t}-item-link`]: {
          color: e.colorTextDisabled,
          cursor: "not-allowed"
        }
      },
      "&:focus-visible": {
        cursor: "not-allowed",
        [`${t}-item-link`]: {
          color: e.colorTextDisabled,
          cursor: "not-allowed"
        }
      }
    },
    [`&${t}-disabled`]: {
      cursor: "not-allowed",
      [`${t}-item`]: {
        cursor: "not-allowed",
        backgroundColor: "transparent",
        "&:hover, &:active": {
          backgroundColor: "transparent"
        },
        a: {
          color: e.colorTextDisabled,
          backgroundColor: "transparent",
          border: "none",
          cursor: "not-allowed"
        },
        "&-active": {
          borderColor: e.colorBorder,
          backgroundColor: e.itemActiveBgDisabled,
          "&:hover, &:active": {
            backgroundColor: e.itemActiveBgDisabled
          },
          a: {
            color: e.itemActiveColorDisabled
          }
        }
      },
      [`${t}-item-link`]: {
        color: e.colorTextDisabled,
        cursor: "not-allowed",
        "&:hover, &:active": {
          backgroundColor: "transparent"
        },
        [`${t}-simple&`]: {
          backgroundColor: "transparent",
          "&:hover, &:active": {
            backgroundColor: "transparent"
          }
        }
      },
      [`${t}-simple-pager`]: {
        color: e.colorTextDisabled
      },
      [`${t}-jump-prev, ${t}-jump-next`]: {
        [`${t}-item-link-icon`]: {
          opacity: 0
        },
        [`${t}-item-ellipsis`]: {
          opacity: 1
        }
      }
    }
  };
}, SSe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`&${t}-mini ${t}-total-text, &${t}-mini ${t}-simple-pager`]: {
      height: e.itemSizeSM,
      lineHeight: Ye(e.itemSizeSM)
    },
    [`&${t}-mini ${t}-item`]: {
      minWidth: e.itemSizeSM,
      height: e.itemSizeSM,
      margin: 0,
      lineHeight: Ye(e.calc(e.itemSizeSM).sub(2).equal())
    },
    [`&${t}-mini ${t}-prev, &${t}-mini ${t}-next`]: {
      minWidth: e.itemSizeSM,
      height: e.itemSizeSM,
      margin: 0,
      lineHeight: Ye(e.itemSizeSM)
    },
    [`&${t}-mini:not(${t}-disabled)`]: {
      [`${t}-prev, ${t}-next`]: {
        [`&:hover ${t}-item-link`]: {
          backgroundColor: e.colorBgTextHover
        },
        [`&:active ${t}-item-link`]: {
          backgroundColor: e.colorBgTextActive
        },
        [`&${t}-disabled:hover ${t}-item-link`]: {
          backgroundColor: "transparent"
        }
      }
    },
    [`
    &${t}-mini ${t}-prev ${t}-item-link,
    &${t}-mini ${t}-next ${t}-item-link
    `]: {
      backgroundColor: "transparent",
      borderColor: "transparent",
      "&::after": {
        height: e.itemSizeSM,
        lineHeight: Ye(e.itemSizeSM)
      }
    },
    [`&${t}-mini ${t}-jump-prev, &${t}-mini ${t}-jump-next`]: {
      height: e.itemSizeSM,
      marginInlineEnd: 0,
      lineHeight: Ye(e.itemSizeSM)
    },
    [`&${t}-mini ${t}-options`]: {
      marginInlineStart: e.paginationMiniOptionsMarginInlineStart,
      "&-size-changer": {
        top: e.miniOptionsSizeChangerTop
      },
      "&-quick-jumper": {
        height: e.itemSizeSM,
        lineHeight: Ye(e.itemSizeSM),
        input: Object.assign(Object.assign({}, Pj(e)), {
          width: e.paginationMiniQuickJumperInputWidth,
          height: e.controlHeightSM
        })
      }
    }
  };
}, CSe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`&${t}-simple`]: {
      [`${t}-prev, ${t}-next`]: {
        height: e.itemSize,
        lineHeight: Ye(e.itemSize),
        verticalAlign: "top",
        [`${t}-item-link`]: {
          height: e.itemSize,
          backgroundColor: "transparent",
          border: 0,
          "&:hover": {
            backgroundColor: e.colorBgTextHover
          },
          "&:active": {
            backgroundColor: e.colorBgTextActive
          },
          "&::after": {
            height: e.itemSize,
            lineHeight: Ye(e.itemSize)
          }
        }
      },
      [`${t}-simple-pager`]: {
        display: "inline-flex",
        alignItems: "center",
        height: e.itemSize,
        marginInlineEnd: e.marginXS,
        input: {
          boxSizing: "border-box",
          height: "100%",
          width: e.quickJumperInputWidth,
          padding: `0 ${Ye(e.paginationItemPaddingInline)}`,
          textAlign: "center",
          backgroundColor: e.itemInputBg,
          border: `${Ye(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderRadius: e.borderRadius,
          outline: "none",
          transition: `border-color ${e.motionDurationMid}`,
          color: "inherit",
          "&:hover": {
            borderColor: e.colorPrimary
          },
          "&:focus": {
            borderColor: e.colorPrimaryHover,
            boxShadow: `${Ye(e.inputOutlineOffset)} 0 ${Ye(e.controlOutlineWidth)} ${e.controlOutline}`
          },
          "&[disabled]": {
            color: e.colorTextDisabled,
            backgroundColor: e.colorBgContainerDisabled,
            borderColor: e.colorBorder,
            cursor: "not-allowed"
          }
        }
      },
      [`&${t}-disabled`]: {
        [`${t}-prev, ${t}-next`]: {
          [`${t}-item-link`]: {
            "&:hover, &:active": {
              backgroundColor: "transparent"
            }
          }
        }
      },
      [`&${t}-mini`]: {
        [`${t}-prev, ${t}-next`]: {
          height: e.itemSizeSM,
          lineHeight: Ye(e.itemSizeSM),
          [`${t}-item-link`]: {
            height: e.itemSizeSM,
            "&::after": {
              height: e.itemSizeSM,
              lineHeight: Ye(e.itemSizeSM)
            }
          }
        },
        [`${t}-simple-pager`]: {
          height: e.itemSizeSM,
          input: {
            width: e.paginationMiniQuickJumperInputWidth
          }
        }
      }
    }
  };
}, xSe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-jump-prev, ${t}-jump-next`]: {
      outline: 0,
      [`${t}-item-container`]: {
        position: "relative",
        [`${t}-item-link-icon`]: {
          color: e.colorPrimary,
          fontSize: e.fontSizeSM,
          opacity: 0,
          transition: `all ${e.motionDurationMid}`,
          "&-svg": {
            top: 0,
            insetInlineEnd: 0,
            bottom: 0,
            insetInlineStart: 0,
            margin: "auto"
          }
        },
        [`${t}-item-ellipsis`]: {
          position: "absolute",
          top: 0,
          insetInlineEnd: 0,
          bottom: 0,
          insetInlineStart: 0,
          display: "block",
          margin: "auto",
          color: e.colorTextDisabled,
          letterSpacing: e.paginationEllipsisLetterSpacing,
          textAlign: "center",
          textIndent: e.paginationEllipsisTextIndent,
          opacity: 1,
          transition: `all ${e.motionDurationMid}`
        }
      },
      "&:hover": {
        [`${t}-item-link-icon`]: {
          opacity: 1
        },
        [`${t}-item-ellipsis`]: {
          opacity: 0
        }
      }
    },
    [`
    ${t}-prev,
    ${t}-jump-prev,
    ${t}-jump-next
    `]: {
      marginInlineEnd: e.marginXS
    },
    [`
    ${t}-prev,
    ${t}-next,
    ${t}-jump-prev,
    ${t}-jump-next
    `]: {
      display: "inline-block",
      minWidth: e.itemSize,
      height: e.itemSize,
      color: e.colorText,
      fontFamily: e.fontFamily,
      lineHeight: Ye(e.itemSize),
      textAlign: "center",
      verticalAlign: "middle",
      listStyle: "none",
      borderRadius: e.borderRadius,
      cursor: "pointer",
      transition: `all ${e.motionDurationMid}`
    },
    [`${t}-prev, ${t}-next`]: {
      outline: 0,
      button: {
        color: e.colorText,
        cursor: "pointer",
        userSelect: "none"
      },
      [`${t}-item-link`]: {
        display: "block",
        width: "100%",
        height: "100%",
        padding: 0,
        fontSize: e.fontSizeSM,
        textAlign: "center",
        backgroundColor: "transparent",
        border: `${Ye(e.lineWidth)} ${e.lineType} transparent`,
        borderRadius: e.borderRadius,
        outline: "none",
        transition: `all ${e.motionDurationMid}`
      },
      [`&:hover ${t}-item-link`]: {
        backgroundColor: e.colorBgTextHover
      },
      [`&:active ${t}-item-link`]: {
        backgroundColor: e.colorBgTextActive
      },
      [`&${t}-disabled:hover`]: {
        [`${t}-item-link`]: {
          backgroundColor: "transparent"
        }
      }
    },
    [`${t}-slash`]: {
      marginInlineEnd: e.paginationSlashMarginInlineEnd,
      marginInlineStart: e.paginationSlashMarginInlineStart
    },
    [`${t}-options`]: {
      display: "inline-block",
      marginInlineStart: e.margin,
      verticalAlign: "middle",
      "&-size-changer": {
        display: "inline-block",
        width: "auto"
      },
      "&-quick-jumper": {
        display: "inline-block",
        height: e.controlHeight,
        marginInlineStart: e.marginXS,
        lineHeight: Ye(e.controlHeight),
        verticalAlign: "top",
        input: Object.assign(Object.assign(Object.assign({}, kj(e)), Ej(e, {
          borderColor: e.colorBorder,
          hoverBorderColor: e.colorPrimaryHover,
          activeBorderColor: e.colorPrimary,
          activeShadow: e.activeShadow
        })), {
          "&[disabled]": Object.assign({}, hM(e)),
          width: e.quickJumperInputWidth,
          height: e.controlHeight,
          boxSizing: "border-box",
          margin: 0,
          marginInlineStart: e.marginXS,
          marginInlineEnd: e.marginXS
        })
      }
    }
  };
}, ESe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-item`]: {
      display: "inline-block",
      minWidth: e.itemSize,
      height: e.itemSize,
      marginInlineEnd: e.marginXS,
      fontFamily: e.fontFamily,
      lineHeight: Ye(e.calc(e.itemSize).sub(2).equal()),
      textAlign: "center",
      verticalAlign: "middle",
      listStyle: "none",
      backgroundColor: e.itemBg,
      border: `${Ye(e.lineWidth)} ${e.lineType} transparent`,
      borderRadius: e.borderRadius,
      outline: 0,
      cursor: "pointer",
      userSelect: "none",
      a: {
        display: "block",
        padding: `0 ${Ye(e.paginationItemPaddingInline)}`,
        color: e.colorText,
        "&:hover": {
          textDecoration: "none"
        }
      },
      [`&:not(${t}-item-active)`]: {
        "&:hover": {
          transition: `all ${e.motionDurationMid}`,
          backgroundColor: e.colorBgTextHover
        },
        "&:active": {
          backgroundColor: e.colorBgTextActive
        }
      },
      "&-active": {
        fontWeight: e.fontWeightStrong,
        backgroundColor: e.itemActiveBg,
        borderColor: e.colorPrimary,
        a: {
          color: e.itemActiveColor
        },
        "&:hover": {
          borderColor: e.colorPrimaryHover
        },
        "&:hover a": {
          color: e.itemActiveColorHover
        }
      }
    }
  };
}, PSe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, dl(e)), {
      display: "flex",
      flexWrap: "wrap",
      rowGap: e.paddingXS,
      "&-start": {
        justifyContent: "start"
      },
      "&-center": {
        justifyContent: "center"
      },
      "&-end": {
        justifyContent: "end"
      },
      "ul, ol": {
        margin: 0,
        padding: 0,
        listStyle: "none"
      },
      "&::after": {
        display: "block",
        clear: "both",
        height: 0,
        overflow: "hidden",
        visibility: "hidden",
        content: '""'
      },
      [`${t}-total-text`]: {
        display: "inline-block",
        height: e.itemSize,
        marginInlineEnd: e.marginXS,
        lineHeight: Ye(e.calc(e.itemSize).sub(2).equal()),
        verticalAlign: "middle"
      }
    }), ESe(e)), xSe(e)), CSe(e)), SSe(e)), wSe(e)), {
      // media query style
      [`@media only screen and (max-width: ${e.screenLG}px)`]: {
        [`${t}-item`]: {
          "&-after-jump-prev, &-before-jump-next": {
            display: "none"
          }
        }
      },
      [`@media only screen and (max-width: ${e.screenSM}px)`]: {
        [`${t}-options`]: {
          display: "none"
        }
      }
    }),
    // rtl style
    [`&${e.componentCls}-rtl`]: {
      direction: "rtl"
    }
  };
}, kSe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}:not(${t}-disabled)`]: {
      [`${t}-item`]: Object.assign({}, Z4(e)),
      [`${t}-jump-prev, ${t}-jump-next`]: {
        "&:focus-visible": Object.assign({
          [`${t}-item-link-icon`]: {
            opacity: 1
          },
          [`${t}-item-ellipsis`]: {
            opacity: 0
          }
        }, _S(e))
      },
      [`${t}-prev, ${t}-next`]: {
        [`&:focus-visible ${t}-item-link`]: _S(e)
      }
    }
  };
}, DJ = (e) => Object.assign({
  itemBg: e.colorBgContainer,
  itemSize: e.controlHeight,
  itemSizeSM: e.controlHeightSM,
  itemActiveBg: e.colorBgContainer,
  itemActiveColor: e.colorPrimary,
  itemActiveColorHover: e.colorPrimaryHover,
  itemLinkBg: e.colorBgContainer,
  itemActiveColorDisabled: e.colorTextDisabled,
  itemActiveBgDisabled: e.controlItemBgActiveDisabled,
  itemInputBg: e.colorBgContainer,
  miniOptionsSizeChangerTop: 0
}, mM(e)), $J = (e) => lo(e, {
  inputOutlineOffset: 0,
  quickJumperInputWidth: e.calc(e.controlHeightLG).mul(1.25).equal(),
  paginationMiniOptionsMarginInlineStart: e.calc(e.marginXXS).div(2).equal(),
  paginationMiniQuickJumperInputWidth: e.calc(e.controlHeightLG).mul(1.1).equal(),
  paginationItemPaddingInline: e.calc(e.marginXXS).mul(1.5).equal(),
  paginationEllipsisLetterSpacing: e.calc(e.marginXXS).div(2).equal(),
  paginationSlashMarginInlineStart: e.marginSM,
  paginationSlashMarginInlineEnd: e.marginSM,
  paginationEllipsisTextIndent: "0.13em"
  // magic for ui experience
}, fM(e)), MSe = Ii("Pagination", (e) => {
  const t = $J(e);
  return [PSe(t), kSe(t)];
}, DJ), OSe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}${t}-bordered${t}-disabled:not(${t}-mini)`]: {
      "&, &:hover": {
        [`${t}-item-link`]: {
          borderColor: e.colorBorder
        }
      },
      "&:focus-visible": {
        [`${t}-item-link`]: {
          borderColor: e.colorBorder
        }
      },
      [`${t}-item, ${t}-item-link`]: {
        backgroundColor: e.colorBgContainerDisabled,
        borderColor: e.colorBorder,
        [`&:hover:not(${t}-item-active)`]: {
          backgroundColor: e.colorBgContainerDisabled,
          borderColor: e.colorBorder,
          a: {
            color: e.colorTextDisabled
          }
        },
        [`&${t}-item-active`]: {
          backgroundColor: e.itemActiveBgDisabled
        }
      },
      [`${t}-prev, ${t}-next`]: {
        "&:hover button": {
          backgroundColor: e.colorBgContainerDisabled,
          borderColor: e.colorBorder,
          color: e.colorTextDisabled
        },
        [`${t}-item-link`]: {
          backgroundColor: e.colorBgContainerDisabled,
          borderColor: e.colorBorder
        }
      }
    },
    [`${t}${t}-bordered:not(${t}-mini)`]: {
      [`${t}-prev, ${t}-next`]: {
        "&:hover button": {
          borderColor: e.colorPrimaryHover,
          backgroundColor: e.itemBg
        },
        [`${t}-item-link`]: {
          backgroundColor: e.itemLinkBg,
          borderColor: e.colorBorder
        },
        [`&:hover ${t}-item-link`]: {
          borderColor: e.colorPrimary,
          backgroundColor: e.itemBg,
          color: e.colorPrimary
        },
        [`&${t}-disabled`]: {
          [`${t}-item-link`]: {
            borderColor: e.colorBorder,
            color: e.colorTextDisabled
          }
        }
      },
      [`${t}-item`]: {
        backgroundColor: e.itemBg,
        border: `${Ye(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
        [`&:hover:not(${t}-item-active)`]: {
          borderColor: e.colorPrimary,
          backgroundColor: e.itemBg,
          a: {
            color: e.colorPrimary
          }
        },
        "&-active": {
          borderColor: e.colorPrimary
        }
      }
    }
  };
}, TSe = $z(["Pagination", "bordered"], (e) => {
  const t = $J(e);
  return OSe(t);
}, DJ);
function FW(e) {
  return mn(() => typeof e == "boolean" ? [e, {}] : e && typeof e == "object" ? [!0, e] : [void 0, void 0], [e]);
}
var RSe = function(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
    t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
};
const zJ = (e) => {
  const {
    align: t,
    prefixCls: r,
    selectPrefixCls: a,
    className: i,
    rootClassName: c,
    style: d,
    size: f,
    locale: p,
    responsive: g,
    showSizeChanger: b,
    selectComponentClass: w,
    pageSizeOptions: x
  } = e, E = RSe(e, ["align", "prefixCls", "selectPrefixCls", "className", "rootClassName", "style", "size", "locale", "responsive", "showSizeChanger", "selectComponentClass", "pageSizeOptions"]), {
    xs: P
  } = oj(g), [, k] = Bf(), {
    getPrefixCls: M,
    direction: T,
    showSizeChanger: N,
    className: D,
    style: $
  } = om("pagination"), j = M("pagination", r), [I, L, F] = MSe(j), _ = Cb(f), W = _ === "small" || !!(P && !_ && g), [Q] = q1("Pagination", cq), U = Object.assign(Object.assign({}, Q), p), [Y, G] = FW(b), [J, H] = FW(N), K = Y ?? J, X = G ?? H, te = w || B1, ie = S.useMemo(() => x ? x.map((be) => Number(be)) : void 0, [x]), ee = (be) => {
    var me;
    const {
      disabled: De,
      size: Me,
      onSizeChange: ze,
      "aria-label": le,
      className: se,
      options: Ae
    } = be, {
      className: we,
      onChange: Ne
    } = X || {}, pe = (me = Ae.find((Qe) => String(Qe.value) === String(Me))) === null || me === void 0 ? void 0 : me.value;
    return /* @__PURE__ */ S.createElement(te, Object.assign({
      disabled: De,
      showSearch: !0,
      popupMatchSelectWidth: !1,
      getPopupContainer: (Qe) => Qe.parentNode,
      "aria-label": le,
      options: Ae
    }, X, {
      value: pe,
      onChange: (Qe, Le) => {
        ze?.(Qe), Ne?.(Qe, Le);
      },
      size: W ? "small" : "middle",
      className: _e(se, we)
    }));
  };
  if (process.env.NODE_ENV !== "production") {
    const be = To("Pagination");
    process.env.NODE_ENV !== "production" && be(!w, "usage", "`selectComponentClass` is not official api which will be removed.");
  }
  const ne = S.useMemo(() => {
    const be = /* @__PURE__ */ S.createElement("span", {
      className: `${j}-item-ellipsis`
    }, "•••"), me = /* @__PURE__ */ S.createElement("button", {
      className: `${j}-item-link`,
      type: "button",
      tabIndex: -1
    }, T === "rtl" ? /* @__PURE__ */ S.createElement(Ex, null) : /* @__PURE__ */ S.createElement(Mx, null)), De = /* @__PURE__ */ S.createElement("button", {
      className: `${j}-item-link`,
      type: "button",
      tabIndex: -1
    }, T === "rtl" ? /* @__PURE__ */ S.createElement(Mx, null) : /* @__PURE__ */ S.createElement(Ex, null)), Me = (
      // biome-ignore lint/a11y/useValidAnchor: it is hard to refactor
      /* @__PURE__ */ S.createElement("a", {
        className: `${j}-item-link`
      }, /* @__PURE__ */ S.createElement("div", {
        className: `${j}-item-container`
      }, T === "rtl" ? /* @__PURE__ */ S.createElement(KD, {
        className: `${j}-item-link-icon`
      }) : /* @__PURE__ */ S.createElement(qD, {
        className: `${j}-item-link-icon`
      }), be))
    ), ze = (
      // biome-ignore lint/a11y/useValidAnchor: it is hard to refactor
      /* @__PURE__ */ S.createElement("a", {
        className: `${j}-item-link`
      }, /* @__PURE__ */ S.createElement("div", {
        className: `${j}-item-container`
      }, T === "rtl" ? /* @__PURE__ */ S.createElement(qD, {
        className: `${j}-item-link-icon`
      }) : /* @__PURE__ */ S.createElement(KD, {
        className: `${j}-item-link-icon`
      }), be))
    );
    return {
      prevIcon: me,
      nextIcon: De,
      jumpPrevIcon: Me,
      jumpNextIcon: ze
    };
  }, [T, j]), ae = M("select", a), oe = _e({
    [`${j}-${t}`]: !!t,
    [`${j}-mini`]: W,
    [`${j}-rtl`]: T === "rtl",
    [`${j}-bordered`]: k.wireframe
  }, D, i, c, L, F), fe = Object.assign(Object.assign({}, $), d);
  return I(/* @__PURE__ */ S.createElement(S.Fragment, null, k.wireframe && /* @__PURE__ */ S.createElement(TSe, {
    prefixCls: j
  }), /* @__PURE__ */ S.createElement(NJ, Object.assign({}, ne, E, {
    style: fe,
    prefixCls: j,
    selectPrefixCls: ae,
    className: oe,
    locale: U,
    pageSizeOptions: ie,
    showSizeChanger: K,
    sizeChangerRender: ee
  }))));
};
process.env.NODE_ENV !== "production" && (zJ.displayName = "Pagination");
const e9 = 100, jJ = e9 / 5, IJ = e9 / 2 - jJ / 2, ER = IJ * 2 * Math.PI, WW = 50, VW = (e) => {
  const {
    dotClassName: t,
    style: r,
    hasCircleCls: a
  } = e;
  return /* @__PURE__ */ S.createElement("circle", {
    className: _e(`${t}-circle`, {
      [`${t}-circle-bg`]: a
    }),
    r: IJ,
    cx: WW,
    cy: WW,
    strokeWidth: jJ,
    style: r
  });
}, ASe = ({
  percent: e,
  prefixCls: t
}) => {
  const r = `${t}-dot`, a = `${r}-holder`, i = `${a}-hidden`, [c, d] = S.useState(!1);
  Da(() => {
    e !== 0 && d(!0);
  }, [e !== 0]);
  const f = Math.max(Math.min(e, 100), 0);
  if (!c)
    return null;
  const p = {
    strokeDashoffset: `${ER / 4}`,
    strokeDasharray: `${ER * f / 100} ${ER * (100 - f) / 100}`
  };
  return /* @__PURE__ */ S.createElement("span", {
    className: _e(a, `${r}-progress`, f <= 0 && i)
  }, /* @__PURE__ */ S.createElement("svg", {
    viewBox: `0 0 ${e9} ${e9}`,
    role: "progressbar",
    "aria-valuemin": 0,
    "aria-valuemax": 100,
    "aria-valuenow": f
  }, /* @__PURE__ */ S.createElement(VW, {
    dotClassName: r,
    hasCircleCls: !0
  }), /* @__PURE__ */ S.createElement(VW, {
    dotClassName: r,
    style: p
  })));
};
function NSe(e) {
  const {
    prefixCls: t,
    percent: r = 0
  } = e, a = `${t}-dot`, i = `${a}-holder`, c = `${i}-hidden`;
  return /* @__PURE__ */ S.createElement(S.Fragment, null, /* @__PURE__ */ S.createElement("span", {
    className: _e(i, r > 0 && c)
  }, /* @__PURE__ */ S.createElement("span", {
    className: _e(a, `${t}-dot-spin`)
  }, [1, 2, 3, 4].map((d) => /* @__PURE__ */ S.createElement("i", {
    className: `${t}-dot-item`,
    key: d
  })))), /* @__PURE__ */ S.createElement(ASe, {
    prefixCls: t,
    percent: r
  }));
}
function DSe(e) {
  var t;
  const {
    prefixCls: r,
    indicator: a,
    percent: i
  } = e, c = `${r}-dot`;
  return a && /* @__PURE__ */ S.isValidElement(a) ? up(a, {
    className: _e((t = a.props) === null || t === void 0 ? void 0 : t.className, c),
    percent: i
  }) : /* @__PURE__ */ S.createElement(NSe, {
    prefixCls: r,
    percent: i
  });
}
const $Se = new bo("antSpinMove", {
  to: {
    opacity: 1
  }
}), zSe = new bo("antRotate", {
  to: {
    transform: "rotate(405deg)"
  }
}), jSe = (e) => {
  const {
    componentCls: t,
    calc: r
  } = e;
  return {
    [t]: Object.assign(Object.assign({}, dl(e)), {
      position: "absolute",
      display: "none",
      color: e.colorPrimary,
      fontSize: 0,
      textAlign: "center",
      verticalAlign: "middle",
      opacity: 0,
      transition: `transform ${e.motionDurationSlow} ${e.motionEaseInOutCirc}`,
      "&-spinning": {
        position: "relative",
        display: "inline-block",
        opacity: 1
      },
      [`${t}-text`]: {
        fontSize: e.fontSize,
        paddingTop: r(r(e.dotSize).sub(e.fontSize)).div(2).add(2).equal()
      },
      "&-fullscreen": {
        position: "fixed",
        width: "100vw",
        height: "100vh",
        backgroundColor: e.colorBgMask,
        zIndex: e.zIndexPopupBase,
        inset: 0,
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        opacity: 0,
        visibility: "hidden",
        transition: `all ${e.motionDurationMid}`,
        "&-show": {
          opacity: 1,
          visibility: "visible"
        },
        [t]: {
          [`${t}-dot-holder`]: {
            color: e.colorWhite
          },
          [`${t}-text`]: {
            color: e.colorTextLightSolid
          }
        }
      },
      "&-nested-loading": {
        position: "relative",
        [`> div > ${t}`]: {
          position: "absolute",
          top: 0,
          insetInlineStart: 0,
          zIndex: 4,
          display: "block",
          width: "100%",
          height: "100%",
          maxHeight: e.contentHeight,
          [`${t}-dot`]: {
            position: "absolute",
            top: "50%",
            insetInlineStart: "50%",
            margin: r(e.dotSize).mul(-1).div(2).equal()
          },
          [`${t}-text`]: {
            position: "absolute",
            top: "50%",
            width: "100%",
            textShadow: `0 1px 2px ${e.colorBgContainer}`
            // FIXME: shadow
          },
          [`&${t}-show-text ${t}-dot`]: {
            marginTop: r(e.dotSize).div(2).mul(-1).sub(10).equal()
          },
          "&-sm": {
            [`${t}-dot`]: {
              margin: r(e.dotSizeSM).mul(-1).div(2).equal()
            },
            [`${t}-text`]: {
              paddingTop: r(r(e.dotSizeSM).sub(e.fontSize)).div(2).add(2).equal()
            },
            [`&${t}-show-text ${t}-dot`]: {
              marginTop: r(e.dotSizeSM).div(2).mul(-1).sub(10).equal()
            }
          },
          "&-lg": {
            [`${t}-dot`]: {
              margin: r(e.dotSizeLG).mul(-1).div(2).equal()
            },
            [`${t}-text`]: {
              paddingTop: r(r(e.dotSizeLG).sub(e.fontSize)).div(2).add(2).equal()
            },
            [`&${t}-show-text ${t}-dot`]: {
              marginTop: r(e.dotSizeLG).div(2).mul(-1).sub(10).equal()
            }
          }
        },
        [`${t}-container`]: {
          position: "relative",
          transition: `opacity ${e.motionDurationSlow}`,
          "&::after": {
            position: "absolute",
            top: 0,
            insetInlineEnd: 0,
            bottom: 0,
            insetInlineStart: 0,
            zIndex: 10,
            width: "100%",
            height: "100%",
            background: e.colorBgContainer,
            opacity: 0,
            transition: `all ${e.motionDurationSlow}`,
            content: '""',
            pointerEvents: "none"
          }
        },
        [`${t}-blur`]: {
          clear: "both",
          opacity: 0.5,
          userSelect: "none",
          pointerEvents: "none",
          "&::after": {
            opacity: 0.4,
            pointerEvents: "auto"
          }
        }
      },
      // tip
      // ------------------------------
      "&-tip": {
        color: e.spinDotDefault
      },
      // holder
      // ------------------------------
      [`${t}-dot-holder`]: {
        width: "1em",
        height: "1em",
        fontSize: e.dotSize,
        display: "inline-block",
        transition: `transform ${e.motionDurationSlow} ease, opacity ${e.motionDurationSlow} ease`,
        transformOrigin: "50% 50%",
        lineHeight: 1,
        color: e.colorPrimary,
        "&-hidden": {
          transform: "scale(0.3)",
          opacity: 0
        }
      },
      // progress
      // ------------------------------
      [`${t}-dot-progress`]: {
        position: "absolute",
        inset: 0
      },
      // dots
      // ------------------------------
      [`${t}-dot`]: {
        position: "relative",
        display: "inline-block",
        fontSize: e.dotSize,
        width: "1em",
        height: "1em",
        "&-item": {
          position: "absolute",
          display: "block",
          width: r(e.dotSize).sub(r(e.marginXXS).div(2)).div(2).equal(),
          height: r(e.dotSize).sub(r(e.marginXXS).div(2)).div(2).equal(),
          background: "currentColor",
          borderRadius: "100%",
          transform: "scale(0.75)",
          transformOrigin: "50% 50%",
          opacity: 0.3,
          animationName: $Se,
          animationDuration: "1s",
          animationIterationCount: "infinite",
          animationTimingFunction: "linear",
          animationDirection: "alternate",
          "&:nth-child(1)": {
            top: 0,
            insetInlineStart: 0,
            animationDelay: "0s"
          },
          "&:nth-child(2)": {
            top: 0,
            insetInlineEnd: 0,
            animationDelay: "0.4s"
          },
          "&:nth-child(3)": {
            insetInlineEnd: 0,
            bottom: 0,
            animationDelay: "0.8s"
          },
          "&:nth-child(4)": {
            bottom: 0,
            insetInlineStart: 0,
            animationDelay: "1.2s"
          }
        },
        "&-spin": {
          transform: "rotate(45deg)",
          animationName: zSe,
          animationDuration: "1.2s",
          animationIterationCount: "infinite",
          animationTimingFunction: "linear"
        },
        "&-circle": {
          strokeLinecap: "round",
          transition: ["stroke-dashoffset", "stroke-dasharray", "stroke", "stroke-width", "opacity"].map((a) => `${a} ${e.motionDurationSlow} ease`).join(","),
          fillOpacity: 0,
          stroke: "currentcolor"
        },
        "&-circle-bg": {
          stroke: e.colorFillSecondary
        }
      },
      // small
      [`&-sm ${t}-dot`]: {
        "&, &-holder": {
          fontSize: e.dotSizeSM
        }
      },
      [`&-sm ${t}-dot-holder`]: {
        i: {
          width: r(r(e.dotSizeSM).sub(r(e.marginXXS).div(2))).div(2).equal(),
          height: r(r(e.dotSizeSM).sub(r(e.marginXXS).div(2))).div(2).equal()
        }
      },
      // large
      [`&-lg ${t}-dot`]: {
        "&, &-holder": {
          fontSize: e.dotSizeLG
        }
      },
      [`&-lg ${t}-dot-holder`]: {
        i: {
          width: r(r(e.dotSizeLG).sub(e.marginXXS)).div(2).equal(),
          height: r(r(e.dotSizeLG).sub(e.marginXXS)).div(2).equal()
        }
      },
      [`&${t}-show-text ${t}-text`]: {
        display: "block"
      }
    })
  };
}, ISe = (e) => {
  const {
    controlHeightLG: t,
    controlHeight: r
  } = e;
  return {
    contentHeight: 400,
    dotSize: t / 2,
    dotSizeSM: t * 0.35,
    dotSizeLG: r
  };
}, LSe = Ii("Spin", (e) => {
  const t = lo(e, {
    spinDotDefault: e.colorTextDescription
  });
  return jSe(t);
}, ISe), HSe = 200, _W = [[30, 0.05], [70, 0.03], [96, 0.01]];
function FSe(e, t) {
  const [r, a] = S.useState(0), i = S.useRef(null), c = t === "auto";
  return S.useEffect(() => (c && e && (a(0), i.current = setInterval(() => {
    a((d) => {
      const f = 100 - d;
      for (let p = 0; p < _W.length; p += 1) {
        const [g, b] = _W[p];
        if (d <= g)
          return d + f * b;
      }
      return d;
    });
  }, HSe)), () => {
    i.current && (clearInterval(i.current), i.current = null);
  }), [c, e]), c ? r : t;
}
var WSe = function(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
    t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
};
let LJ;
function VSe(e, t) {
  return !!e && !!t && !Number.isNaN(Number(t));
}
const zj = (e) => {
  var t;
  const {
    prefixCls: r,
    spinning: a = !0,
    delay: i = 0,
    className: c,
    rootClassName: d,
    size: f = "default",
    tip: p,
    wrapperClassName: g,
    style: b,
    children: w,
    fullscreen: x = !1,
    indicator: E,
    percent: P
  } = e, k = WSe(e, ["prefixCls", "spinning", "delay", "className", "rootClassName", "size", "tip", "wrapperClassName", "style", "children", "fullscreen", "indicator", "percent"]), {
    getPrefixCls: M,
    direction: T,
    className: N,
    style: D,
    indicator: $
  } = om("spin"), j = M("spin", r), [I, L, F] = LSe(j), [_, W] = S.useState(() => a && !VSe(a, i)), Q = FSe(_, P);
  S.useEffect(() => {
    if (a) {
      const X = GQ(i, () => {
        W(!0);
      });
      return X(), () => {
        var te;
        (te = X?.cancel) === null || te === void 0 || te.call(X);
      };
    }
    W(!1);
  }, [i, a]);
  const U = S.useMemo(() => typeof w < "u" && !x, [w, x]);
  if (process.env.NODE_ENV !== "production") {
    const X = To("Spin");
    process.env.NODE_ENV !== "production" && X(!p || U || x, "usage", "`tip` only work in nest or fullscreen pattern.");
  }
  const Y = _e(j, N, {
    [`${j}-sm`]: f === "small",
    [`${j}-lg`]: f === "large",
    [`${j}-spinning`]: _,
    [`${j}-show-text`]: !!p,
    [`${j}-rtl`]: T === "rtl"
  }, c, !x && d, L, F), G = _e(`${j}-container`, {
    [`${j}-blur`]: _
  }), J = (t = E ?? $) !== null && t !== void 0 ? t : LJ, H = Object.assign(Object.assign({}, D), b), K = /* @__PURE__ */ S.createElement("div", Object.assign({}, k, {
    style: H,
    className: Y,
    "aria-live": "polite",
    "aria-busy": _
  }), /* @__PURE__ */ S.createElement(DSe, {
    prefixCls: j,
    indicator: J,
    percent: Q
  }), p && (U || x) ? /* @__PURE__ */ S.createElement("div", {
    className: `${j}-text`
  }, p) : null);
  return I(U ? /* @__PURE__ */ S.createElement("div", Object.assign({}, k, {
    className: _e(`${j}-nested-loading`, g, L, F)
  }), _ && /* @__PURE__ */ S.createElement("div", {
    key: "loading"
  }, K), /* @__PURE__ */ S.createElement("div", {
    className: G,
    key: "container"
  }, w)) : x ? /* @__PURE__ */ S.createElement("div", {
    className: _e(`${j}-fullscreen`, {
      [`${j}-fullscreen-show`]: _
    }, d, L, F)
  }, K) : K);
};
zj.setDefaultIndicator = (e) => {
  LJ = e;
};
process.env.NODE_ENV !== "production" && (zj.displayName = "Spin");
var _Se = function(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
    t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
};
const BSe = (e) => {
  const {
    prefixCls: t,
    className: r,
    closeIcon: a,
    closable: i,
    type: c,
    title: d,
    children: f,
    footer: p
  } = e, g = _Se(e, ["prefixCls", "className", "closeIcon", "closable", "type", "title", "children", "footer"]), {
    getPrefixCls: b
  } = S.useContext(Qr), w = b(), x = t || b("modal"), E = Qh(w), [P, k, M] = $K(x, E), T = `${x}-confirm`;
  let N = {};
  return c ? N = {
    closable: i ?? !1,
    title: "",
    footer: "",
    children: /* @__PURE__ */ S.createElement(jK, Object.assign({}, e, {
      prefixCls: x,
      confirmPrefixCls: T,
      rootPrefixCls: w,
      content: f
    }))
  } : N = {
    closable: i ?? !0,
    title: d,
    footer: p !== null && /* @__PURE__ */ S.createElement(RK, Object.assign({}, e)),
    children: f
  }, P(/* @__PURE__ */ S.createElement(Bz, Object.assign({
    prefixCls: x,
    className: _e(k, `${x}-pure-panel`, c && T, c && `${T}-${c}`, r, M, E)
  }, g, {
    closeIcon: TK(x, a),
    closable: i
  }, N)));
}, USe = UK(BSe);
function HJ(e) {
  return JE(FK(e));
}
const U0 = zK;
U0.useModal = Npe;
U0.info = function(t) {
  return JE(WK(t));
};
U0.success = function(t) {
  return JE(VK(t));
};
U0.error = function(t) {
  return JE(_K(t));
};
U0.warning = HJ;
U0.warn = HJ;
U0.confirm = function(t) {
  return JE(BK(t));
};
U0.destroyAll = function() {
  for (; B4.length; ) {
    const t = B4.pop();
    t && t();
  }
};
U0.config = Mpe;
U0._InternalPanelDoNotUseOrYouWillBeFired = USe;
process.env.NODE_ENV !== "production" && (U0.displayName = "Modal");
var XSe = {
  percent: 0,
  prefixCls: "rc-progress",
  strokeColor: "#2db7f5",
  strokeLinecap: "round",
  strokeWidth: 1,
  trailColor: "#D9D9D9",
  trailWidth: 1,
  gapPosition: "bottom"
}, GSe = function() {
  var t = It([]), r = It(null);
  return Er(function() {
    var a = Date.now(), i = !1;
    t.current.forEach(function(c) {
      if (c) {
        i = !0;
        var d = c.style;
        d.transitionDuration = ".3s, .3s, .3s, .06s", r.current && a - r.current < 100 && (d.transitionDuration = "0s, 0s");
      }
    }), i && (r.current = Date.now());
  }), t.current;
};
process.env.NODE_ENV;
var BW = 0, qSe = process.env.NODE_ENV !== "test" && Ju();
function KSe() {
  var e;
  return qSe ? (e = BW, BW += 1) : e = "TEST_OR_SSR", e;
}
const YSe = (function(e) {
  var t = S.useState(), r = qe(t, 2), a = r[0], i = r[1];
  return S.useEffect(function() {
    i("rc_progress_".concat(KSe()));
  }, []), e || a;
});
var UW = function(t) {
  var r = t.bg, a = t.children;
  return /* @__PURE__ */ S.createElement("div", {
    style: {
      width: "100%",
      height: "100%",
      background: r
    }
  }, a);
};
function XW(e, t) {
  return Object.keys(e).map(function(r) {
    var a = parseFloat(r), i = "".concat(Math.floor(a * t), "%");
    return "".concat(e[r], " ").concat(i);
  });
}
var FJ = /* @__PURE__ */ S.forwardRef(function(e, t) {
  var r = e.prefixCls, a = e.color, i = e.gradientId, c = e.radius, d = e.style, f = e.ptg, p = e.strokeLinecap, g = e.strokeWidth, b = e.size, w = e.gapDegree, x = a && Hn(a) === "object", E = x ? "#FFF" : void 0, P = b / 2, k = /* @__PURE__ */ S.createElement("circle", {
    className: "".concat(r, "-circle-path"),
    r: c,
    cx: P,
    cy: P,
    stroke: E,
    strokeLinecap: p,
    strokeWidth: g,
    opacity: f === 0 ? 0 : 1,
    style: d,
    ref: t
  });
  if (!x)
    return k;
  var M = "".concat(i, "-conic"), T = w ? "".concat(180 + w / 2, "deg") : "0deg", N = XW(a, (360 - w) / 360), D = XW(a, 1), $ = "conic-gradient(from ".concat(T, ", ").concat(N.join(", "), ")"), j = "linear-gradient(to ".concat(w ? "bottom" : "top", ", ").concat(D.join(", "), ")");
  return /* @__PURE__ */ S.createElement(S.Fragment, null, /* @__PURE__ */ S.createElement("mask", {
    id: M
  }, k), /* @__PURE__ */ S.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: b,
    height: b,
    mask: "url(#".concat(M, ")")
  }, /* @__PURE__ */ S.createElement(UW, {
    bg: j
  }, /* @__PURE__ */ S.createElement(UW, {
    bg: $
  }))));
});
process.env.NODE_ENV !== "production" && (FJ.displayName = "PtgCircle");
var lE = 100, PR = function(t, r, a, i, c, d, f, p, g, b) {
  var w = arguments.length > 10 && arguments[10] !== void 0 ? arguments[10] : 0, x = a / 100 * 360 * ((360 - d) / 360), E = d === 0 ? 0 : {
    bottom: 0,
    top: 180,
    left: 90,
    right: -90
  }[f], P = (100 - i) / 100 * r;
  g === "round" && i !== 100 && (P += b / 2, P >= r && (P = r - 0.01));
  var k = lE / 2;
  return {
    stroke: typeof p == "string" ? p : void 0,
    strokeDasharray: "".concat(r, "px ").concat(t),
    strokeDashoffset: P + w,
    transform: "rotate(".concat(c + x + E, "deg)"),
    transformOrigin: "".concat(k, "px ").concat(k, "px"),
    transition: "stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s, stroke-width .06s ease .3s, opacity .3s ease 0s",
    fillOpacity: 0
  };
}, QSe = ["id", "prefixCls", "steps", "strokeWidth", "trailWidth", "gapDegree", "gapPosition", "trailColor", "strokeLinecap", "style", "className", "strokeColor", "percent"];
function GW(e) {
  var t = e ?? [];
  return Array.isArray(t) ? t : [t];
}
var WJ = function(t) {
  var r = ce(ce({}, XSe), t), a = r.id, i = r.prefixCls, c = r.steps, d = r.strokeWidth, f = r.trailWidth, p = r.gapDegree, g = p === void 0 ? 0 : p, b = r.gapPosition, w = r.trailColor, x = r.strokeLinecap, E = r.style, P = r.className, k = r.strokeColor, M = r.percent, T = xr(r, QSe), N = lE / 2, D = YSe(a), $ = "".concat(D, "-gradient"), j = N - d / 2, I = Math.PI * 2 * j, L = g > 0 ? 90 + g / 2 : -90, F = I * ((360 - g) / 360), _ = Hn(c) === "object" ? c : {
    count: c,
    gap: 2
  }, W = _.count, Q = _.gap, U = GW(M), Y = GW(k), G = Y.find(function(ee) {
    return ee && Hn(ee) === "object";
  }), J = G && Hn(G) === "object", H = J ? "butt" : x, K = PR(I, F, 0, 100, L, g, b, w, H, d), X = GSe(), te = function() {
    var ne = 0;
    return U.map(function(ae, oe) {
      var fe = Y[oe] || Y[Y.length - 1], be = PR(I, F, ne, ae, L, g, b, fe, H, d);
      return ne += ae, /* @__PURE__ */ S.createElement(FJ, {
        key: oe,
        color: fe,
        ptg: ae,
        radius: j,
        prefixCls: i,
        gradientId: $,
        style: be,
        strokeLinecap: H,
        strokeWidth: d,
        gapDegree: g,
        ref: function(De) {
          X[oe] = De;
        },
        size: lE
      });
    }).reverse();
  }, ie = function() {
    var ne = Math.round(W * (U[0] / 100)), ae = 100 / W, oe = 0;
    return new Array(W).fill(null).map(function(fe, be) {
      var me = be <= ne - 1 ? Y[0] : w, De = me && Hn(me) === "object" ? "url(#".concat($, ")") : void 0, Me = PR(I, F, oe, ae, L, g, b, me, "butt", d, Q);
      return oe += (F - Me.strokeDashoffset + Q) * 100 / F, /* @__PURE__ */ S.createElement("circle", {
        key: be,
        className: "".concat(i, "-circle-path"),
        r: j,
        cx: N,
        cy: N,
        stroke: De,
        strokeWidth: d,
        opacity: 1,
        style: Me,
        ref: function(le) {
          X[be] = le;
        }
      });
    });
  };
  return /* @__PURE__ */ S.createElement("svg", vt({
    className: _e("".concat(i, "-circle"), P),
    viewBox: "0 0 ".concat(lE, " ").concat(lE),
    style: E,
    id: a,
    role: "presentation"
  }, T), !W && /* @__PURE__ */ S.createElement("circle", {
    className: "".concat(i, "-circle-trail"),
    r: j,
    cx: N,
    cy: N,
    stroke: w,
    strokeLinecap: H,
    strokeWidth: f || d,
    style: K
  }), W ? ie() : te());
};
process.env.NODE_ENV !== "production" && (WJ.displayName = "Circle");
function jS(e) {
  return !e || e < 0 ? 0 : e > 100 ? 100 : e;
}
function t9({
  success: e,
  successPercent: t
}) {
  let r = t;
  return e && "progress" in e && (r = e.progress), e && "percent" in e && (r = e.percent), r;
}
const JSe = ({
  percent: e,
  success: t,
  successPercent: r
}) => {
  const a = jS(t9({
    success: t,
    successPercent: r
  }));
  return [a, jS(jS(e) - a)];
}, ZSe = ({
  success: e = {},
  strokeColor: t
}) => {
  const {
    strokeColor: r
  } = e;
  return [r || tx.green, t || null];
}, vM = (e, t, r) => {
  var a, i, c, d;
  let f = -1, p = -1;
  if (t === "step") {
    const g = r.steps, b = r.strokeWidth;
    typeof e == "string" || typeof e > "u" ? (f = e === "small" ? 2 : 14, p = b ?? 8) : typeof e == "number" ? [f, p] = [e, e] : [f = 14, p = 8] = Array.isArray(e) ? e : [e.width, e.height], f *= g;
  } else if (t === "line") {
    const g = r?.strokeWidth;
    typeof e == "string" || typeof e > "u" ? p = g || (e === "small" ? 6 : 8) : typeof e == "number" ? [f, p] = [e, e] : [f = -1, p = 8] = Array.isArray(e) ? e : [e.width, e.height];
  } else (t === "circle" || t === "dashboard") && (typeof e == "string" || typeof e > "u" ? [f, p] = e === "small" ? [60, 60] : [120, 120] : typeof e == "number" ? [f, p] = [e, e] : Array.isArray(e) && (f = (i = (a = e[0]) !== null && a !== void 0 ? a : e[1]) !== null && i !== void 0 ? i : 120, p = (d = (c = e[0]) !== null && c !== void 0 ? c : e[1]) !== null && d !== void 0 ? d : 120));
  return [f, p];
}, eCe = 3, tCe = (e) => eCe / e * 100, nCe = (e) => {
  const {
    prefixCls: t,
    trailColor: r = null,
    strokeLinecap: a = "round",
    gapPosition: i,
    gapDegree: c,
    width: d = 120,
    type: f,
    children: p,
    success: g,
    size: b = d,
    steps: w
  } = e, [x, E] = vM(b, "circle");
  let {
    strokeWidth: P
  } = e;
  P === void 0 && (P = Math.max(tCe(x), 6));
  const k = {
    width: x,
    height: E,
    fontSize: x * 0.15 + 6
  }, M = S.useMemo(() => {
    if (c || c === 0)
      return c;
    if (f === "dashboard")
      return 75;
  }, [c, f]), T = JSe(e), N = i || f === "dashboard" && "bottom" || void 0, D = Object.prototype.toString.call(e.strokeColor) === "[object Object]", $ = ZSe({
    success: g,
    strokeColor: e.strokeColor
  }), j = _e(`${t}-inner`, {
    [`${t}-circle-gradient`]: D
  }), I = /* @__PURE__ */ S.createElement(WJ, {
    steps: w,
    percent: w ? T[1] : T,
    strokeWidth: P,
    trailWidth: P,
    strokeColor: w ? $[1] : $,
    strokeLinecap: a,
    trailColor: r,
    prefixCls: t,
    gapDegree: M,
    gapPosition: N
  }), L = x <= 20, F = /* @__PURE__ */ S.createElement("div", {
    className: j,
    style: k
  }, I, !L && p);
  return L ? /* @__PURE__ */ S.createElement(U1, {
    title: p
  }, F) : F;
}, n9 = "--progress-line-stroke-color", VJ = "--progress-percent", qW = (e) => {
  const t = e ? "100%" : "-100%";
  return new bo(`antProgress${e ? "RTL" : "LTR"}Active`, {
    "0%": {
      transform: `translateX(${t}) scaleX(0)`,
      opacity: 0.1
    },
    "20%": {
      transform: `translateX(${t}) scaleX(0)`,
      opacity: 0.5
    },
    to: {
      transform: "translateX(0) scaleX(1)",
      opacity: 0
    }
  });
}, rCe = (e) => {
  const {
    componentCls: t,
    iconCls: r
  } = e;
  return {
    [t]: Object.assign(Object.assign({}, dl(e)), {
      display: "inline-block",
      "&-rtl": {
        direction: "rtl"
      },
      "&-line": {
        position: "relative",
        width: "100%",
        fontSize: e.fontSize
      },
      [`${t}-outer`]: {
        display: "inline-flex",
        alignItems: "center",
        width: "100%"
      },
      [`${t}-inner`]: {
        position: "relative",
        display: "inline-block",
        width: "100%",
        flex: 1,
        overflow: "hidden",
        verticalAlign: "middle",
        backgroundColor: e.remainingColor,
        borderRadius: e.lineBorderRadius
      },
      [`${t}-inner:not(${t}-circle-gradient)`]: {
        [`${t}-circle-path`]: {
          stroke: e.defaultColor
        }
      },
      [`${t}-success-bg, ${t}-bg`]: {
        position: "relative",
        background: e.defaultColor,
        borderRadius: e.lineBorderRadius,
        transition: `all ${e.motionDurationSlow} ${e.motionEaseInOutCirc}`
      },
      [`${t}-layout-bottom`]: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        [`${t}-text`]: {
          width: "max-content",
          marginInlineStart: 0,
          marginTop: e.marginXXS
        }
      },
      [`${t}-bg`]: {
        overflow: "hidden",
        "&::after": {
          content: '""',
          background: {
            _multi_value_: !0,
            value: ["inherit", `var(${n9})`]
          },
          height: "100%",
          width: `calc(1 / var(${VJ}) * 100%)`,
          display: "block"
        },
        [`&${t}-bg-inner`]: {
          minWidth: "max-content",
          "&::after": {
            content: "none"
          },
          [`${t}-text-inner`]: {
            color: e.colorWhite,
            [`&${t}-text-bright`]: {
              color: "rgba(0, 0, 0, 0.45)"
            }
          }
        }
      },
      [`${t}-success-bg`]: {
        position: "absolute",
        insetBlockStart: 0,
        insetInlineStart: 0,
        backgroundColor: e.colorSuccess
      },
      [`${t}-text`]: {
        display: "inline-block",
        marginInlineStart: e.marginXS,
        color: e.colorText,
        lineHeight: 1,
        width: "2em",
        whiteSpace: "nowrap",
        textAlign: "start",
        verticalAlign: "middle",
        wordBreak: "normal",
        [r]: {
          fontSize: e.fontSize
        },
        [`&${t}-text-outer`]: {
          width: "max-content"
        },
        [`&${t}-text-outer${t}-text-start`]: {
          width: "max-content",
          marginInlineStart: 0,
          marginInlineEnd: e.marginXS
        }
      },
      [`${t}-text-inner`]: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
        marginInlineStart: 0,
        padding: `0 ${Ye(e.paddingXXS)}`,
        [`&${t}-text-start`]: {
          justifyContent: "start"
        },
        [`&${t}-text-end`]: {
          justifyContent: "end"
        }
      },
      [`&${t}-status-active`]: {
        [`${t}-bg::before`]: {
          position: "absolute",
          inset: 0,
          backgroundColor: e.colorBgContainer,
          borderRadius: e.lineBorderRadius,
          opacity: 0,
          animationName: qW(),
          animationDuration: e.progressActiveMotionDuration,
          animationTimingFunction: e.motionEaseOutQuint,
          animationIterationCount: "infinite",
          content: '""'
        }
      },
      [`&${t}-rtl${t}-status-active`]: {
        [`${t}-bg::before`]: {
          animationName: qW(!0)
        }
      },
      [`&${t}-status-exception`]: {
        [`${t}-bg`]: {
          backgroundColor: e.colorError
        },
        [`${t}-text`]: {
          color: e.colorError
        }
      },
      [`&${t}-status-exception ${t}-inner:not(${t}-circle-gradient)`]: {
        [`${t}-circle-path`]: {
          stroke: e.colorError
        }
      },
      [`&${t}-status-success`]: {
        [`${t}-bg`]: {
          backgroundColor: e.colorSuccess
        },
        [`${t}-text`]: {
          color: e.colorSuccess
        }
      },
      [`&${t}-status-success ${t}-inner:not(${t}-circle-gradient)`]: {
        [`${t}-circle-path`]: {
          stroke: e.colorSuccess
        }
      }
    })
  };
}, aCe = (e) => {
  const {
    componentCls: t,
    iconCls: r
  } = e;
  return {
    [t]: {
      [`${t}-circle-trail`]: {
        stroke: e.remainingColor
      },
      [`&${t}-circle ${t}-inner`]: {
        position: "relative",
        lineHeight: 1,
        backgroundColor: "transparent"
      },
      [`&${t}-circle ${t}-text`]: {
        position: "absolute",
        insetBlockStart: "50%",
        insetInlineStart: 0,
        width: "100%",
        margin: 0,
        padding: 0,
        color: e.circleTextColor,
        fontSize: e.circleTextFontSize,
        lineHeight: 1,
        whiteSpace: "normal",
        textAlign: "center",
        transform: "translateY(-50%)",
        [r]: {
          fontSize: e.circleIconFontSize
        }
      },
      [`${t}-circle&-status-exception`]: {
        [`${t}-text`]: {
          color: e.colorError
        }
      },
      [`${t}-circle&-status-success`]: {
        [`${t}-text`]: {
          color: e.colorSuccess
        }
      }
    },
    [`${t}-inline-circle`]: {
      lineHeight: 1,
      [`${t}-inner`]: {
        verticalAlign: "bottom"
      }
    }
  };
}, oCe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      [`${t}-steps`]: {
        display: "inline-block",
        "&-outer": {
          display: "flex",
          flexDirection: "row",
          alignItems: "center"
        },
        "&-item": {
          flexShrink: 0,
          minWidth: e.progressStepMinWidth,
          marginInlineEnd: e.progressStepMarginInlineEnd,
          backgroundColor: e.remainingColor,
          transition: `all ${e.motionDurationSlow}`,
          "&-active": {
            backgroundColor: e.defaultColor
          }
        }
      }
    }
  };
}, iCe = (e) => {
  const {
    componentCls: t,
    iconCls: r
  } = e;
  return {
    [t]: {
      [`${t}-small&-line, ${t}-small&-line ${t}-text ${r}`]: {
        fontSize: e.fontSizeSM
      }
    }
  };
}, lCe = (e) => ({
  circleTextColor: e.colorText,
  defaultColor: e.colorInfo,
  remainingColor: e.colorFillSecondary,
  lineBorderRadius: 100,
  // magic for capsule shape, should be a very large number
  circleTextFontSize: "1em",
  circleIconFontSize: `${e.fontSize / e.fontSizeSM}em`
}), sCe = Ii("Progress", (e) => {
  const t = e.calc(e.marginXXS).div(2).equal(), r = lo(e, {
    progressStepMarginInlineEnd: t,
    progressStepMinWidth: t,
    progressActiveMotionDuration: "2.4s"
  });
  return [rCe(r), aCe(r), oCe(r), iCe(r)];
}, lCe);
var uCe = function(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
    t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
};
const cCe = (e) => {
  let t = [];
  return Object.keys(e).forEach((r) => {
    const a = Number.parseFloat(r.replace(/%/g, ""));
    Number.isNaN(a) || t.push({
      key: a,
      value: e[r]
    });
  }), t = t.sort((r, a) => r.key - a.key), t.map(({
    key: r,
    value: a
  }) => `${a} ${r}%`).join(", ");
}, dCe = (e, t) => {
  const {
    from: r = tx.blue,
    to: a = tx.blue,
    direction: i = t === "rtl" ? "to left" : "to right"
  } = e, c = uCe(e, ["from", "to", "direction"]);
  if (Object.keys(c).length !== 0) {
    const f = cCe(c), p = `linear-gradient(${i}, ${f})`;
    return {
      background: p,
      [n9]: p
    };
  }
  const d = `linear-gradient(${i}, ${r}, ${a})`;
  return {
    background: d,
    [n9]: d
  };
}, fCe = (e) => {
  const {
    prefixCls: t,
    direction: r,
    percent: a,
    size: i,
    strokeWidth: c,
    strokeColor: d,
    strokeLinecap: f = "round",
    children: p,
    trailColor: g = null,
    percentPosition: b,
    success: w
  } = e, {
    align: x,
    type: E
  } = b, P = d && typeof d != "string" ? dCe(d, r) : {
    [n9]: d,
    background: d
  }, k = f === "square" || f === "butt" ? 0 : void 0, M = i ?? [-1, c || (i === "small" ? 6 : 8)], [T, N] = vM(M, "line", {
    strokeWidth: c
  });
  process.env.NODE_ENV !== "production" && To("Progress").deprecated(!("strokeWidth" in e), "strokeWidth", "size");
  const D = {
    backgroundColor: g || void 0,
    borderRadius: k
  }, $ = Object.assign(Object.assign({
    width: `${jS(a)}%`,
    height: N,
    borderRadius: k
  }, P), {
    [VJ]: jS(a) / 100
  }), j = t9(e), I = {
    width: `${jS(j)}%`,
    height: N,
    borderRadius: k,
    backgroundColor: w?.strokeColor
  }, L = {
    width: T < 0 ? "100%" : T
  }, F = /* @__PURE__ */ S.createElement("div", {
    className: `${t}-inner`,
    style: D
  }, /* @__PURE__ */ S.createElement("div", {
    className: _e(`${t}-bg`, `${t}-bg-${E}`),
    style: $
  }, E === "inner" && p), j !== void 0 && /* @__PURE__ */ S.createElement("div", {
    className: `${t}-success-bg`,
    style: I
  })), _ = E === "outer" && x === "start", W = E === "outer" && x === "end";
  return E === "outer" && x === "center" ? /* @__PURE__ */ S.createElement("div", {
    className: `${t}-layout-bottom`
  }, F, p) : /* @__PURE__ */ S.createElement("div", {
    className: `${t}-outer`,
    style: L
  }, _ && p, F, W && p);
}, mCe = (e) => {
  const {
    size: t,
    steps: r,
    rounding: a = Math.round,
    percent: i = 0,
    strokeWidth: c = 8,
    strokeColor: d,
    trailColor: f = null,
    prefixCls: p,
    children: g
  } = e, b = a(r * (i / 100)), x = t ?? [t === "small" ? 2 : 14, c], [E, P] = vM(x, "step", {
    steps: r,
    strokeWidth: c
  }), k = E / r, M = Array.from({
    length: r
  });
  for (let T = 0; T < r; T++) {
    const N = Array.isArray(d) ? d[T] : d;
    M[T] = /* @__PURE__ */ S.createElement("div", {
      key: T,
      className: _e(`${p}-steps-item`, {
        [`${p}-steps-item-active`]: T <= b - 1
      }),
      style: {
        backgroundColor: T <= b - 1 ? N : f,
        width: k,
        height: P
      }
    });
  }
  return /* @__PURE__ */ S.createElement("div", {
    className: `${p}-steps-outer`
  }, M, g);
};
var hCe = function(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
    t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
};
const pCe = ["normal", "exception", "active", "success"], _J = /* @__PURE__ */ S.forwardRef((e, t) => {
  const {
    prefixCls: r,
    className: a,
    rootClassName: i,
    steps: c,
    strokeColor: d,
    percent: f = 0,
    size: p = "default",
    showInfo: g = !0,
    type: b = "line",
    status: w,
    format: x,
    style: E,
    percentPosition: P = {}
  } = e, k = hCe(e, ["prefixCls", "className", "rootClassName", "steps", "strokeColor", "percent", "size", "showInfo", "type", "status", "format", "style", "percentPosition"]), {
    align: M = "end",
    type: T = "outer"
  } = P, N = Array.isArray(d) ? d[0] : d, D = typeof d == "string" || Array.isArray(d) ? d : void 0, $ = S.useMemo(() => {
    if (N) {
      const te = typeof N == "string" ? N : Object.values(N)[0];
      return new ro(te).isLight();
    }
    return !1;
  }, [d]), j = S.useMemo(() => {
    var te, ie;
    const ee = t9(e);
    return Number.parseInt(ee !== void 0 ? (te = ee ?? 0) === null || te === void 0 ? void 0 : te.toString() : (ie = f ?? 0) === null || ie === void 0 ? void 0 : ie.toString(), 10);
  }, [f, e.success, e.successPercent]), I = S.useMemo(() => !pCe.includes(w) && j >= 100 ? "success" : w || "normal", [w, j]), {
    getPrefixCls: L,
    direction: F,
    progress: _
  } = S.useContext(Qr), W = L("progress", r), [Q, U, Y] = sCe(W), G = b === "line", J = G && !c, H = S.useMemo(() => {
    if (!g)
      return null;
    const te = t9(e);
    let ie;
    const ee = x || ((ae) => `${ae}%`), ne = G && $ && T === "inner";
    return T === "inner" || x || I !== "exception" && I !== "success" ? ie = ee(jS(f), jS(te)) : I === "exception" ? ie = G ? /* @__PURE__ */ S.createElement(_x, null) : /* @__PURE__ */ S.createElement(Bx, null) : I === "success" && (ie = G ? /* @__PURE__ */ S.createElement(z9, null) : /* @__PURE__ */ S.createElement(ej, null)), /* @__PURE__ */ S.createElement("span", {
      className: _e(`${W}-text`, {
        [`${W}-text-bright`]: ne,
        [`${W}-text-${M}`]: J,
        [`${W}-text-${T}`]: J
      }),
      title: typeof ie == "string" ? ie : void 0
    }, ie);
  }, [g, f, j, I, b, W, x]);
  if (process.env.NODE_ENV !== "production") {
    const te = To("Progress");
    te.deprecated(!("successPercent" in e), "successPercent", "success.percent"), te.deprecated(!("width" in e), "width", "size"), (b === "circle" || b === "dashboard") && (Array.isArray(p) ? process.env.NODE_ENV !== "production" && te(!1, "usage", 'Type "circle" and "dashboard" do not accept array as `size`, please use number or preset size instead.') : typeof p == "object" && process.env.NODE_ENV !== "production" && te(!1, "usage", 'Type "circle" and "dashboard" do not accept object as `size`, please use number or preset size instead.')), e.success && "progress" in e.success && te.deprecated(!1, "success.progress", "success.percent");
  }
  let K;
  b === "line" ? K = c ? /* @__PURE__ */ S.createElement(mCe, Object.assign({}, e, {
    strokeColor: D,
    prefixCls: W,
    steps: typeof c == "object" ? c.count : c
  }), H) : /* @__PURE__ */ S.createElement(fCe, Object.assign({}, e, {
    strokeColor: N,
    prefixCls: W,
    direction: F,
    percentPosition: {
      align: M,
      type: T
    }
  }), H) : (b === "circle" || b === "dashboard") && (K = /* @__PURE__ */ S.createElement(nCe, Object.assign({}, e, {
    strokeColor: N,
    prefixCls: W,
    progressStatus: I
  }), H));
  const X = _e(W, `${W}-status-${I}`, {
    [`${W}-${b === "dashboard" && "circle" || b}`]: b !== "line",
    [`${W}-inline-circle`]: b === "circle" && vM(p, "circle")[0] <= 20,
    [`${W}-line`]: J,
    [`${W}-line-align-${M}`]: J,
    [`${W}-line-position-${T}`]: J,
    [`${W}-steps`]: c,
    [`${W}-show-info`]: g,
    [`${W}-${p}`]: typeof p == "string",
    [`${W}-rtl`]: F === "rtl"
  }, _?.className, a, i, U, Y);
  return Q(/* @__PURE__ */ S.createElement("div", Object.assign({
    ref: t,
    style: Object.assign(Object.assign({}, _?.style), E),
    className: X,
    role: "progressbar",
    "aria-valuenow": j,
    "aria-valuemin": 0,
    "aria-valuemax": 100
  }, Rs(k, ["trailColor", "strokeWidth", "width", "gapDegree", "gapPosition", "strokeLinecap", "success", "successPercent"])), K));
});
process.env.NODE_ENV !== "production" && (_J.displayName = "Progress");
var tb = {}, u7 = "rc-table-internal-hook";
function jj(e) {
  var t = /* @__PURE__ */ S.createContext(void 0), r = function(i) {
    var c = i.value, d = i.children, f = S.useRef(c);
    f.current = c;
    var p = S.useState(function() {
      return {
        getValue: function() {
          return f.current;
        },
        listeners: /* @__PURE__ */ new Set()
      };
    }), g = qe(p, 1), b = g[0];
    return Da(function() {
      hG(function() {
        b.listeners.forEach(function(w) {
          w(c);
        });
      });
    }, [c]), /* @__PURE__ */ S.createElement(t.Provider, {
      value: b
    }, d);
  };
  return {
    Context: t,
    Provider: r,
    defaultValue: e
  };
}
function hd(e, t) {
  var r = ra(typeof t == "function" ? t : function(w) {
    if (t === void 0)
      return w;
    if (!Array.isArray(t))
      return w[t];
    var x = {};
    return t.forEach(function(E) {
      x[E] = w[E];
    }), x;
  }), a = S.useContext(e?.Context), i = a || {}, c = i.listeners, d = i.getValue, f = S.useRef();
  f.current = r(a ? d() : e?.defaultValue);
  var p = S.useState({}), g = qe(p, 2), b = g[1];
  return Da(function() {
    if (!a)
      return;
    function w(x) {
      var E = r(x);
      R0(f.current, E, !0) || b({});
    }
    return c.add(w), function() {
      c.delete(w);
    };
  }, [a]), f.current;
}
function gCe() {
  var e = /* @__PURE__ */ S.createContext(null);
  function t() {
    return S.useContext(e);
  }
  function r(i, c) {
    var d = gb(i), f = function(g, b) {
      var w = d ? {
        ref: b
      } : {}, x = S.useRef(0), E = S.useRef(g), P = t();
      return P !== null ? /* @__PURE__ */ S.createElement(i, vt({}, g, w)) : (
        // Always trigger re-render if not provide `notTriggerRender`
        ((!c || c(E.current, g)) && (x.current += 1), E.current = g, /* @__PURE__ */ S.createElement(e.Provider, {
          value: x.current
        }, /* @__PURE__ */ S.createElement(i, vt({}, g, w))))
      );
    };
    return process.env.NODE_ENV !== "production" && (f.displayName = "ImmutableRoot(".concat(i.displayName || i.name, ")")), d ? /* @__PURE__ */ S.forwardRef(f) : f;
  }
  function a(i, c) {
    var d = gb(i), f = function(g, b) {
      var w = d ? {
        ref: b
      } : {};
      return t(), /* @__PURE__ */ S.createElement(i, vt({}, g, w));
    };
    return process.env.NODE_ENV !== "production" && (f.displayName = "ImmutableResponse(".concat(i.displayName || i.name, ")")), d ? /* @__PURE__ */ S.memo(/* @__PURE__ */ S.forwardRef(f), c) : /* @__PURE__ */ S.memo(f, c);
  }
  return {
    makeImmutable: r,
    responseImmutable: a,
    useImmutableMark: t
  };
}
var Ij = gCe(), BJ = Ij.makeImmutable, Jx = Ij.responseImmutable, vCe = Ij.useImmutableMark, im = jj();
function UJ(e, t) {
  var r = S.useRef(0);
  r.current += 1;
  var a = S.useRef(e), i = [];
  Object.keys(e || {}).map(function(d) {
    var f;
    e?.[d] !== ((f = a.current) === null || f === void 0 ? void 0 : f[d]) && i.push(d);
  }), a.current = e;
  var c = S.useRef([]);
  return i.length && (c.current = i), S.useDebugValue(r.current), S.useDebugValue(c.current.join(", ")), t && console.log("".concat(t, ":"), r.current, c.current), r.current;
}
const US = process.env.NODE_ENV !== "production" ? UJ : function() {
};
var bCe = /* @__PURE__ */ S.memo(function() {
  var e = UJ();
  return /* @__PURE__ */ S.createElement("h1", null, "Render Times: ", e);
});
process.env.NODE_ENV !== "production" && (bCe.displayName = "RenderBlock");
var XJ = /* @__PURE__ */ S.createContext({
  renderWithProps: !1
}), yCe = "RC_TABLE_KEY";
function wCe(e) {
  return e == null ? [] : Array.isArray(e) ? e : [e];
}
function bM(e) {
  var t = [], r = {};
  return e.forEach(function(a) {
    for (var i = a || {}, c = i.key, d = i.dataIndex, f = c || wCe(d).join("-") || yCe; r[f]; )
      f = "".concat(f, "_next");
    r[f] = !0, t.push(f);
  }), t;
}
function YD(e) {
  return e != null;
}
function SCe(e) {
  return typeof e == "number" && !Number.isNaN(e);
}
function CCe(e) {
  return e && Hn(e) === "object" && !Array.isArray(e) && !/* @__PURE__ */ S.isValidElement(e);
}
function xCe(e, t, r, a, i, c) {
  var d = S.useContext(XJ), f = vCe(), p = eC(function() {
    if (YD(a))
      return [a];
    var g = t == null || t === "" ? [] : Array.isArray(t) ? t : [t], b = M0(e, g), w = b, x = void 0;
    if (i) {
      var E = i(b, e, r);
      CCe(E) ? (process.env.NODE_ENV !== "production" && $n(!1, "`columns.render` return cell props is deprecated with perf issue, please use `onCell` instead."), w = E.children, x = E.props, d.renderWithProps = !0) : w = E;
    }
    return [w, x];
  }, [
    // Force update deps
    f,
    // Normal deps
    e,
    a,
    t,
    i,
    r
  ], function(g, b) {
    if (c) {
      var w = qe(g, 2), x = w[1], E = qe(b, 2), P = E[1];
      return c(P, x);
    }
    return d.renderWithProps ? !0 : !R0(g, b, !0);
  });
  return p;
}
function ECe(e, t, r, a) {
  var i = e + t - 1;
  return e <= a && i >= r;
}
function PCe(e, t) {
  return hd(im, function(r) {
    var a = ECe(e, t || 1, r.hoverStartRow, r.hoverEndRow);
    return [a, r.onHover];
  });
}
var kCe = function(t) {
  var r = t.ellipsis, a = t.rowType, i = t.children, c, d = r === !0 ? {
    showTitle: !0
  } : r;
  return d && (d.showTitle || a === "header") && (typeof i == "string" || typeof i == "number" ? c = i.toString() : /* @__PURE__ */ S.isValidElement(i) && typeof i.props.children == "string" && (c = i.props.children)), c;
};
function MCe(e) {
  var t, r, a, i, c, d, f, p;
  process.env.NODE_ENV !== "production" && US(e);
  var g = e.component, b = e.children, w = e.ellipsis, x = e.scope, E = e.prefixCls, P = e.className, k = e.align, M = e.record, T = e.render, N = e.dataIndex, D = e.renderIndex, $ = e.shouldCellUpdate, j = e.index, I = e.rowType, L = e.colSpan, F = e.rowSpan, _ = e.fixLeft, W = e.fixRight, Q = e.firstFixLeft, U = e.lastFixLeft, Y = e.firstFixRight, G = e.lastFixRight, J = e.appendNode, H = e.additionalProps, K = H === void 0 ? {} : H, X = e.isSticky, te = "".concat(E, "-cell"), ie = hd(im, ["supportSticky", "allColumnsFixedLeft", "rowHoverable"]), ee = ie.supportSticky, ne = ie.allColumnsFixedLeft, ae = ie.rowHoverable, oe = xCe(M, N, D, b, T, $), fe = qe(oe, 2), be = fe[0], me = fe[1], De = {}, Me = typeof _ == "number" && ee, ze = typeof W == "number" && ee;
  Me && (De.position = "sticky", De.left = _), ze && (De.position = "sticky", De.right = W);
  var le = (t = (r = (a = me?.colSpan) !== null && a !== void 0 ? a : K.colSpan) !== null && r !== void 0 ? r : L) !== null && t !== void 0 ? t : 1, se = (i = (c = (d = me?.rowSpan) !== null && d !== void 0 ? d : K.rowSpan) !== null && c !== void 0 ? c : F) !== null && i !== void 0 ? i : 1, Ae = PCe(j, se), we = qe(Ae, 2), Ne = we[0], pe = we[1], Qe = ra(function(Fe) {
    var tt;
    M && pe(j, j + se - 1), K == null || (tt = K.onMouseEnter) === null || tt === void 0 || tt.call(K, Fe);
  }), Le = ra(function(Fe) {
    var tt;
    M && pe(-1, -1), K == null || (tt = K.onMouseLeave) === null || tt === void 0 || tt.call(K, Fe);
  });
  if (le === 0 || se === 0)
    return null;
  var Te = (f = K.title) !== null && f !== void 0 ? f : kCe({
    rowType: I,
    ellipsis: w,
    children: be
  }), Oe = _e(te, P, (p = {}, ge(ge(ge(ge(ge(ge(ge(ge(ge(ge(p, "".concat(te, "-fix-left"), Me && ee), "".concat(te, "-fix-left-first"), Q && ee), "".concat(te, "-fix-left-last"), U && ee), "".concat(te, "-fix-left-all"), U && ne && ee), "".concat(te, "-fix-right"), ze && ee), "".concat(te, "-fix-right-first"), Y && ee), "".concat(te, "-fix-right-last"), G && ee), "".concat(te, "-ellipsis"), w), "".concat(te, "-with-append"), J), "".concat(te, "-fix-sticky"), (Me || ze) && X && ee), ge(p, "".concat(te, "-row-hover"), !me && Ne)), K.className, me?.className), ye = {};
  k && (ye.textAlign = k);
  var je = ce(ce(ce(ce({}, me?.style), De), ye), K.style), Ue = be;
  return Hn(Ue) === "object" && !Array.isArray(Ue) && !/* @__PURE__ */ S.isValidElement(Ue) && (Ue = null), w && (U || Y) && (Ue = /* @__PURE__ */ S.createElement("span", {
    className: "".concat(te, "-content")
  }, Ue)), /* @__PURE__ */ S.createElement(g, vt({}, me, K, {
    className: Oe,
    style: je,
    title: Te,
    scope: x,
    onMouseEnter: ae ? Qe : void 0,
    onMouseLeave: ae ? Le : void 0,
    colSpan: le !== 1 ? le : null,
    rowSpan: se !== 1 ? se : null
  }), J, Ue);
}
const Zx = /* @__PURE__ */ S.memo(MCe);
function Lj(e, t, r, a, i) {
  var c = r[e] || {}, d = r[t] || {}, f, p;
  c.fixed === "left" ? f = a.left[i === "rtl" ? t : e] : d.fixed === "right" && (p = a.right[i === "rtl" ? e : t]);
  var g = !1, b = !1, w = !1, x = !1, E = r[t + 1], P = r[e - 1], k = E && !E.fixed || P && !P.fixed || r.every(function($) {
    return $.fixed === "left";
  });
  if (i === "rtl") {
    if (f !== void 0) {
      var M = P && P.fixed === "left";
      x = !M && k;
    } else if (p !== void 0) {
      var T = E && E.fixed === "right";
      w = !T && k;
    }
  } else if (f !== void 0) {
    var N = E && E.fixed === "left";
    g = !N && k;
  } else if (p !== void 0) {
    var D = P && P.fixed === "right";
    b = !D && k;
  }
  return {
    fixLeft: f,
    fixRight: p,
    lastFixLeft: g,
    firstFixRight: b,
    lastFixRight: w,
    firstFixLeft: x,
    isSticky: a.isSticky
  };
}
var GJ = /* @__PURE__ */ S.createContext({});
function OCe(e) {
  var t = e.className, r = e.index, a = e.children, i = e.colSpan, c = i === void 0 ? 1 : i, d = e.rowSpan, f = e.align, p = hd(im, ["prefixCls", "direction"]), g = p.prefixCls, b = p.direction, w = S.useContext(GJ), x = w.scrollColumnIndex, E = w.stickyOffsets, P = w.flattenColumns, k = r + c - 1, M = k + 1 === x ? c + 1 : c, T = Lj(r, r + M - 1, P, E, b);
  return /* @__PURE__ */ S.createElement(Zx, vt({
    className: t,
    index: r,
    component: "td",
    prefixCls: g,
    record: null,
    dataIndex: null,
    align: f,
    colSpan: M,
    rowSpan: d,
    render: function() {
      return a;
    }
  }, T));
}
var TCe = ["children"];
function RCe(e) {
  var t = e.children, r = xr(e, TCe);
  return /* @__PURE__ */ S.createElement("tr", r, t);
}
function yM(e) {
  var t = e.children;
  return t;
}
yM.Row = RCe;
yM.Cell = OCe;
function ACe(e) {
  process.env.NODE_ENV !== "production" && US(e);
  var t = e.children, r = e.stickyOffsets, a = e.flattenColumns, i = hd(im, "prefixCls"), c = a.length - 1, d = a[c], f = S.useMemo(function() {
    return {
      stickyOffsets: r,
      flattenColumns: a,
      scrollColumnIndex: d != null && d.scrollbar ? c : null
    };
  }, [d, a, c, r]);
  return /* @__PURE__ */ S.createElement(GJ.Provider, {
    value: f
  }, /* @__PURE__ */ S.createElement("tfoot", {
    className: "".concat(i, "-summary")
  }, t));
}
const Y7 = Jx(ACe);
var qJ = yM;
function NCe(e) {
  return null;
}
function DCe(e) {
  return null;
}
function KJ(e, t, r, a, i, c, d) {
  var f = c(t, d);
  e.push({
    record: t,
    indent: r,
    index: d,
    rowKey: f
  });
  var p = i?.has(f);
  if (t && Array.isArray(t[a]) && p)
    for (var g = 0; g < t[a].length; g += 1)
      KJ(e, t[a][g], r + 1, a, i, c, g);
}
function YJ(e, t, r, a) {
  var i = S.useMemo(function() {
    if (r != null && r.size) {
      for (var c = [], d = 0; d < e?.length; d += 1) {
        var f = e[d];
        KJ(c, f, 0, t, r, a, d);
      }
      return c;
    }
    return e?.map(function(p, g) {
      return {
        record: p,
        indent: 0,
        index: g,
        rowKey: a(p, g)
      };
    });
  }, [e, t, r, a]);
  return i;
}
function QJ(e, t, r, a) {
  var i = hd(im, ["prefixCls", "fixedInfoList", "flattenColumns", "expandableType", "expandRowByClick", "onTriggerExpand", "rowClassName", "expandedRowClassName", "indentSize", "expandIcon", "expandedRowRender", "expandIconColumnIndex", "expandedKeys", "childrenColumnName", "rowExpandable", "onRow"]), c = i.flattenColumns, d = i.expandableType, f = i.expandedKeys, p = i.childrenColumnName, g = i.onTriggerExpand, b = i.rowExpandable, w = i.onRow, x = i.expandRowByClick, E = i.rowClassName, P = d === "nest", k = d === "row" && (!b || b(e)), M = k || P, T = f && f.has(t), N = p && e && e[p], D = ra(g), $ = w?.(e, r), j = $?.onClick, I = function(W) {
    x && M && g(e, W);
    for (var Q = arguments.length, U = new Array(Q > 1 ? Q - 1 : 0), Y = 1; Y < Q; Y++)
      U[Y - 1] = arguments[Y];
    j?.apply(void 0, [W].concat(U));
  }, L;
  typeof E == "string" ? L = E : typeof E == "function" && (L = E(e, r, a));
  var F = bM(c);
  return ce(ce({}, i), {}, {
    columnsKey: F,
    nestExpandable: P,
    expanded: T,
    hasNestChildren: N,
    record: e,
    onTriggerExpand: D,
    rowSupportExpand: k,
    expandable: M,
    rowProps: ce(ce({}, $), {}, {
      className: _e(L, $?.className),
      onClick: I
    })
  });
}
function JJ(e) {
  process.env.NODE_ENV !== "production" && US(e);
  var t = e.prefixCls, r = e.children, a = e.component, i = e.cellComponent, c = e.className, d = e.expanded, f = e.colSpan, p = e.isEmpty, g = e.stickyOffset, b = g === void 0 ? 0 : g, w = hd(im, ["scrollbarSize", "fixHeader", "fixColumn", "componentWidth", "horizonScroll"]), x = w.scrollbarSize, E = w.fixHeader, P = w.fixColumn, k = w.componentWidth, M = w.horizonScroll, T = r;
  return (p ? M && k : P) && (T = /* @__PURE__ */ S.createElement("div", {
    style: {
      width: k - b - (E && !p ? x : 0),
      position: "sticky",
      left: b,
      overflow: "hidden"
    },
    className: "".concat(t, "-expanded-row-fixed")
  }, T)), /* @__PURE__ */ S.createElement(a, {
    className: c,
    style: {
      display: d ? null : "none"
    }
  }, /* @__PURE__ */ S.createElement(Zx, {
    component: i,
    prefixCls: t,
    colSpan: f
  }, T));
}
function $Ce(e) {
  var t = e.prefixCls, r = e.record, a = e.onExpand, i = e.expanded, c = e.expandable, d = "".concat(t, "-row-expand-icon");
  if (!c)
    return /* @__PURE__ */ S.createElement("span", {
      className: _e(d, "".concat(t, "-row-spaced"))
    });
  var f = function(g) {
    a(r, g), g.stopPropagation();
  };
  return /* @__PURE__ */ S.createElement("span", {
    className: _e(d, ge(ge({}, "".concat(t, "-row-expanded"), i), "".concat(t, "-row-collapsed"), !i)),
    onClick: f
  });
}
function zCe(e, t, r) {
  var a = [];
  function i(c) {
    (c || []).forEach(function(d, f) {
      a.push(t(d, f)), i(d[r]);
    });
  }
  return i(e), a;
}
function ZJ(e, t, r, a) {
  return typeof e == "string" ? e : typeof e == "function" ? e(t, r, a) : "";
}
function eZ(e, t, r, a, i) {
  var c, d = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : [], f = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : 0, p = e.record, g = e.prefixCls, b = e.columnsKey, w = e.fixedInfoList, x = e.expandIconColumnIndex, E = e.nestExpandable, P = e.indentSize, k = e.expandIcon, M = e.expanded, T = e.hasNestChildren, N = e.onTriggerExpand, D = e.expandable, $ = e.expandedKeys, j = b[r], I = w[r], L;
  r === (x || 0) && E && (L = /* @__PURE__ */ S.createElement(S.Fragment, null, /* @__PURE__ */ S.createElement("span", {
    style: {
      paddingLeft: "".concat(P * a, "px")
    },
    className: "".concat(g, "-row-indent indent-level-").concat(a)
  }), k({
    prefixCls: g,
    expanded: M,
    expandable: T,
    record: p,
    onExpand: N
  })));
  var F = ((c = t.onCell) === null || c === void 0 ? void 0 : c.call(t, p, i)) || {};
  if (f) {
    var _ = F.rowSpan, W = _ === void 0 ? 1 : _;
    if (D && W && r < f) {
      for (var Q = W, U = i; U < i + W; U += 1) {
        var Y = d[U];
        $.has(Y) && (Q += 1);
      }
      F.rowSpan = Q;
    }
  }
  return {
    key: j,
    fixedInfo: I,
    appendCellNode: L,
    additionalCellProps: F
  };
}
function tZ(e) {
  process.env.NODE_ENV !== "production" && US(e);
  var t = e.className, r = e.style, a = e.record, i = e.index, c = e.renderIndex, d = e.rowKey, f = e.rowKeys, p = e.indent, g = p === void 0 ? 0 : p, b = e.rowComponent, w = e.cellComponent, x = e.scopeCellComponent, E = e.expandedRowInfo, P = QJ(a, d, i, g), k = P.prefixCls, M = P.flattenColumns, T = P.expandedRowClassName, N = P.expandedRowRender, D = P.rowProps, $ = P.expanded, j = P.rowSupportExpand, I = S.useRef(!1);
  I.current || (I.current = $), process.env.NODE_ENV !== "production" && US(e);
  var L = ZJ(T, a, i, g), F = /* @__PURE__ */ S.createElement(b, vt({}, D, {
    "data-row-key": d,
    className: _e(t, "".concat(k, "-row"), "".concat(k, "-row-level-").concat(g), D?.className, ge({}, L, g >= 1)),
    style: ce(ce({}, r), D?.style)
  }), M.map(function(Q, U) {
    var Y = Q.render, G = Q.dataIndex, J = Q.className, H = eZ(P, Q, U, g, i, f, E?.offset), K = H.key, X = H.fixedInfo, te = H.appendCellNode, ie = H.additionalCellProps;
    return /* @__PURE__ */ S.createElement(Zx, vt({
      className: J,
      ellipsis: Q.ellipsis,
      align: Q.align,
      scope: Q.rowScope,
      component: Q.rowScope ? x : w,
      prefixCls: k,
      key: K,
      record: a,
      index: i,
      renderIndex: c,
      dataIndex: G,
      render: Y,
      shouldCellUpdate: Q.shouldCellUpdate
    }, X, {
      appendNode: te,
      additionalProps: ie
    }));
  })), _;
  if (j && (I.current || $)) {
    var W = N(a, i, g + 1, $);
    _ = /* @__PURE__ */ S.createElement(JJ, {
      expanded: $,
      className: _e("".concat(k, "-expanded-row"), "".concat(k, "-expanded-row-level-").concat(g + 1), L),
      prefixCls: k,
      component: b,
      cellComponent: w,
      colSpan: E ? E.colSpan : M.length,
      stickyOffset: E?.sticky,
      isEmpty: !1
    }, W);
  }
  return /* @__PURE__ */ S.createElement(S.Fragment, null, F, _);
}
process.env.NODE_ENV !== "production" && (tZ.displayName = "BodyRow");
const jCe = Jx(tZ);
function ICe(e) {
  var t = e.columnKey, r = e.onColumnResize, a = e.prefixCls, i = e.title, c = S.useRef();
  return Da(function() {
    c.current && r(t, c.current.offsetWidth);
  }, []), /* @__PURE__ */ S.createElement(hp, {
    data: t
  }, /* @__PURE__ */ S.createElement("th", {
    ref: c,
    className: "".concat(a, "-measure-cell")
  }, /* @__PURE__ */ S.createElement("div", {
    className: "".concat(a, "-measure-cell-content")
  }, i || " ")));
}
function LCe(e) {
  var t = e.prefixCls, r = e.columnsKey, a = e.onColumnResize, i = e.columns, c = S.useRef(null), d = hd(im, ["measureRowRender"]), f = d.measureRowRender, p = /* @__PURE__ */ S.createElement("tr", {
    "aria-hidden": "true",
    className: "".concat(t, "-measure-row"),
    ref: c,
    tabIndex: -1
  }, /* @__PURE__ */ S.createElement(hp.Collection, {
    onBatchResize: function(b) {
      BE(c.current) && b.forEach(function(w) {
        var x = w.data, E = w.size;
        a(x, E.offsetWidth);
      });
    }
  }, r.map(function(g) {
    var b = i.find(function(E) {
      return E.key === g;
    }), w = b?.title, x = /* @__PURE__ */ S.isValidElement(w) ? /* @__PURE__ */ S.cloneElement(w, {
      ref: null
    }) : w;
    return /* @__PURE__ */ S.createElement(ICe, {
      prefixCls: t,
      key: g,
      columnKey: g,
      onColumnResize: a,
      title: x
    });
  })));
  return f ? f(p) : p;
}
function nZ(e) {
  process.env.NODE_ENV !== "production" && US(e);
  var t = e.data, r = e.measureColumnWidth, a = hd(im, ["prefixCls", "getComponent", "onColumnResize", "flattenColumns", "getRowKey", "expandedKeys", "childrenColumnName", "emptyNode", "expandedRowOffset", "fixedInfoList", "colWidths"]), i = a.prefixCls, c = a.getComponent, d = a.onColumnResize, f = a.flattenColumns, p = a.getRowKey, g = a.expandedKeys, b = a.childrenColumnName, w = a.emptyNode, x = a.expandedRowOffset, E = x === void 0 ? 0 : x, P = a.colWidths, k = YJ(t, b, g, p), M = S.useMemo(function() {
    return k.map(function(_) {
      return _.rowKey;
    });
  }, [k]), T = S.useRef({
    renderWithProps: !1
  }), N = S.useMemo(function() {
    for (var _ = f.length - E, W = 0, Q = 0; Q < E; Q += 1)
      W += P[Q] || 0;
    return {
      offset: E,
      colSpan: _,
      sticky: W
    };
  }, [f.length, E, P]), D = c(["body", "wrapper"], "tbody"), $ = c(["body", "row"], "tr"), j = c(["body", "cell"], "td"), I = c(["body", "cell"], "th"), L;
  t.length ? L = k.map(function(_, W) {
    var Q = _.record, U = _.indent, Y = _.index, G = _.rowKey;
    return /* @__PURE__ */ S.createElement(jCe, {
      key: G,
      rowKey: G,
      rowKeys: M,
      record: Q,
      index: W,
      renderIndex: Y,
      rowComponent: $,
      cellComponent: j,
      scopeCellComponent: I,
      indent: U,
      expandedRowInfo: N
    });
  }) : L = /* @__PURE__ */ S.createElement(JJ, {
    expanded: !0,
    className: "".concat(i, "-placeholder"),
    prefixCls: i,
    component: $,
    cellComponent: j,
    colSpan: f.length,
    isEmpty: !0
  }, w);
  var F = bM(f);
  return /* @__PURE__ */ S.createElement(XJ.Provider, {
    value: T.current
  }, /* @__PURE__ */ S.createElement(D, {
    className: "".concat(i, "-tbody")
  }, r && /* @__PURE__ */ S.createElement(LCe, {
    prefixCls: i,
    columnsKey: F,
    onColumnResize: d,
    columns: f
  }), L));
}
process.env.NODE_ENV !== "production" && (nZ.displayName = "Body");
const HCe = Jx(nZ);
var FCe = ["expandable"], pE = "RC_TABLE_INTERNAL_COL_DEFINE";
function WCe(e) {
  var t = e.expandable, r = xr(e, FCe), a;
  return "expandable" in e ? a = ce(ce({}, r), t) : (process.env.NODE_ENV !== "production" && ["indentSize", "expandedRowKeys", "defaultExpandedRowKeys", "defaultExpandAllRows", "expandedRowRender", "expandRowByClick", "expandIcon", "onExpand", "onExpandedRowsChange", "expandedRowClassName", "expandIconColumnIndex", "showExpandColumn", "title"].some(function(i) {
    return i in e;
  }) && $n(!1, "expanded related props have been moved into `expandable`."), a = r), a.showExpandColumn === !1 && (a.expandIconColumnIndex = -1), a;
}
var VCe = ["columnType"];
function rZ(e) {
  for (var t = e.colWidths, r = e.columns, a = e.columCount, i = hd(im, ["tableLayout"]), c = i.tableLayout, d = [], f = a || r.length, p = !1, g = f - 1; g >= 0; g -= 1) {
    var b = t[g], w = r && r[g], x = void 0, E = void 0;
    if (w && (x = w[pE], c === "auto" && (E = w.minWidth)), b || E || x || p) {
      var P = x || {};
      P.columnType;
      var k = xr(P, VCe);
      d.unshift(/* @__PURE__ */ S.createElement("col", vt({
        key: g,
        style: {
          width: b,
          minWidth: E
        }
      }, k))), p = !0;
    }
  }
  return d.length > 0 ? /* @__PURE__ */ S.createElement("colgroup", null, d) : null;
}
var _Ce = ["className", "noData", "columns", "flattenColumns", "colWidths", "colGroup", "columCount", "stickyOffsets", "direction", "fixHeader", "stickyTopOffset", "stickyBottomOffset", "stickyClassName", "scrollX", "tableLayout", "onScroll", "children"];
function BCe(e, t) {
  return mn(function() {
    for (var r = [], a = 0; a < t; a += 1) {
      var i = e[a];
      if (i !== void 0)
        r[a] = i;
      else
        return null;
    }
    return r;
  }, [e.join("_"), t]);
}
var aZ = /* @__PURE__ */ S.forwardRef(function(e, t) {
  process.env.NODE_ENV !== "production" && US(e);
  var r = e.className, a = e.noData, i = e.columns, c = e.flattenColumns, d = e.colWidths, f = e.colGroup, p = e.columCount, g = e.stickyOffsets, b = e.direction, w = e.fixHeader, x = e.stickyTopOffset, E = e.stickyBottomOffset, P = e.stickyClassName, k = e.scrollX, M = e.tableLayout, T = M === void 0 ? "fixed" : M, N = e.onScroll, D = e.children, $ = xr(e, _Ce), j = hd(im, ["prefixCls", "scrollbarSize", "isSticky", "getComponent"]), I = j.prefixCls, L = j.scrollbarSize, F = j.isSticky, _ = j.getComponent, W = _(["header", "table"], "table"), Q = F && !w ? 0 : L, U = S.useRef(null), Y = S.useCallback(function(ee) {
    xE(t, ee), xE(U, ee);
  }, []);
  S.useEffect(function() {
    function ee(ae) {
      var oe = ae, fe = oe.currentTarget, be = oe.deltaX;
      be && (N({
        currentTarget: fe,
        scrollLeft: fe.scrollLeft + be
      }), ae.preventDefault());
    }
    var ne = U.current;
    return ne?.addEventListener("wheel", ee, {
      passive: !1
    }), function() {
      ne?.removeEventListener("wheel", ee);
    };
  }, []);
  var G = c[c.length - 1], J = {
    fixed: G ? G.fixed : null,
    scrollbar: !0,
    onHeaderCell: function() {
      return {
        className: "".concat(I, "-cell-scrollbar")
      };
    }
  }, H = mn(function() {
    return Q ? [].concat(Et(i), [J]) : i;
  }, [Q, i]), K = mn(function() {
    return Q ? [].concat(Et(c), [J]) : c;
  }, [Q, c]), X = mn(function() {
    var ee = g.right, ne = g.left;
    return ce(ce({}, g), {}, {
      left: b === "rtl" ? [].concat(Et(ne.map(function(ae) {
        return ae + Q;
      })), [0]) : ne,
      right: b === "rtl" ? ee : [].concat(Et(ee.map(function(ae) {
        return ae + Q;
      })), [0]),
      isSticky: F
    });
  }, [Q, g, F]), te = BCe(d, p), ie = mn(function() {
    var ee = !te || !te.length || te.every(function(ne) {
      return !ne;
    });
    return a || ee;
  }, [a, te]);
  return /* @__PURE__ */ S.createElement("div", {
    style: ce({
      overflow: "hidden"
    }, F ? {
      top: x,
      bottom: E
    } : {}),
    ref: Y,
    className: _e(r, ge({}, P, !!P))
  }, /* @__PURE__ */ S.createElement(W, {
    style: {
      tableLayout: T,
      minWidth: "100%",
      // https://github.com/ant-design/ant-design/issues/54894
      width: k
    }
  }, ie ? f : /* @__PURE__ */ S.createElement(rZ, {
    colWidths: [].concat(Et(te), [Q]),
    columCount: p + 1,
    columns: K
  }), D(ce(ce({}, $), {}, {
    stickyOffsets: X,
    columns: H,
    flattenColumns: K
  }))));
});
process.env.NODE_ENV !== "production" && (aZ.displayName = "FixedHolder");
const KW = /* @__PURE__ */ S.memo(aZ);
var oZ = function(t) {
  var r = t.cells, a = t.stickyOffsets, i = t.flattenColumns, c = t.rowComponent, d = t.cellComponent, f = t.onHeaderRow, p = t.index, g = hd(im, ["prefixCls", "direction"]), b = g.prefixCls, w = g.direction, x;
  f && (x = f(r.map(function(P) {
    return P.column;
  }), p));
  var E = bM(r.map(function(P) {
    return P.column;
  }));
  return /* @__PURE__ */ S.createElement(c, x, r.map(function(P, k) {
    var M = P.column, T = Lj(P.colStart, P.colEnd, i, a, w), N;
    return M && M.onHeaderCell && (N = P.column.onHeaderCell(M)), /* @__PURE__ */ S.createElement(Zx, vt({}, P, {
      scope: M.title ? P.colSpan > 1 ? "colgroup" : "col" : null,
      ellipsis: M.ellipsis,
      align: M.align,
      component: d,
      prefixCls: b,
      key: E[k]
    }, T, {
      additionalProps: N,
      rowType: "header"
    }));
  }));
};
process.env.NODE_ENV !== "production" && (oZ.displayName = "HeaderRow");
function UCe(e) {
  var t = [];
  function r(d, f) {
    var p = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    t[p] = t[p] || [];
    var g = f, b = d.filter(Boolean).map(function(w) {
      var x = {
        key: w.key,
        className: w.className || "",
        children: w.title,
        column: w,
        colStart: g
      }, E = 1, P = w.children;
      return P && P.length > 0 && (E = r(P, g, p + 1).reduce(function(k, M) {
        return k + M;
      }, 0), x.hasSubColumns = !0), "colSpan" in w && (E = w.colSpan), "rowSpan" in w && (x.rowSpan = w.rowSpan), x.colSpan = E, x.colEnd = x.colStart + E - 1, t[p].push(x), g += E, E;
    });
    return b;
  }
  r(e, 0);
  for (var a = t.length, i = function(f) {
    t[f].forEach(function(p) {
      !("rowSpan" in p) && !p.hasSubColumns && (p.rowSpan = a - f);
    });
  }, c = 0; c < a; c += 1)
    i(c);
  return t;
}
var XCe = function(t) {
  process.env.NODE_ENV !== "production" && US(t);
  var r = t.stickyOffsets, a = t.columns, i = t.flattenColumns, c = t.onHeaderRow, d = hd(im, ["prefixCls", "getComponent"]), f = d.prefixCls, p = d.getComponent, g = S.useMemo(function() {
    return UCe(a);
  }, [a]), b = p(["header", "wrapper"], "thead"), w = p(["header", "row"], "tr"), x = p(["header", "cell"], "th");
  return /* @__PURE__ */ S.createElement(b, {
    className: "".concat(f, "-thead")
  }, g.map(function(E, P) {
    var k = /* @__PURE__ */ S.createElement(oZ, {
      key: P,
      flattenColumns: i,
      cells: E,
      stickyOffsets: r,
      rowComponent: w,
      cellComponent: x,
      onHeaderRow: c,
      index: P
    });
    return k;
  }));
};
const YW = Jx(XCe);
function QW(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return typeof t == "number" ? t : t.endsWith("%") ? e * parseFloat(t) / 100 : null;
}
function GCe(e, t, r) {
  return S.useMemo(function() {
    if (t && t > 0) {
      var a = 0, i = 0;
      e.forEach(function(x) {
        var E = QW(t, x.width);
        E ? a += E : i += 1;
      });
      var c = Math.max(t, r), d = Math.max(c - a, i), f = i, p = d / i, g = 0, b = e.map(function(x) {
        var E = ce({}, x), P = QW(t, E.width);
        if (P)
          E.width = P;
        else {
          var k = Math.floor(p);
          E.width = f === 1 ? d : k, d -= k, f -= 1;
        }
        return g += E.width, E;
      });
      if (g < c) {
        var w = c / g;
        d = c, b.forEach(function(x, E) {
          var P = Math.floor(x.width * w);
          x.width = E === b.length - 1 ? d : P, d -= P;
        });
      }
      return [b, Math.max(g, c)];
    }
    return [e, t];
  }, [e, t, r]);
}
var qCe = ["children"], KCe = ["fixed"];
function Hj(e) {
  return Kh(e).filter(function(t) {
    return /* @__PURE__ */ S.isValidElement(t);
  }).map(function(t) {
    var r = t.key, a = t.props, i = a.children, c = xr(a, qCe), d = ce({
      key: r
    }, c);
    return i && (d.children = Hj(i)), d;
  });
}
function iZ(e) {
  return e.filter(function(t) {
    return t && Hn(t) === "object" && !t.hidden;
  }).map(function(t) {
    var r = t.children;
    return r && r.length > 0 ? ce(ce({}, t), {}, {
      children: iZ(r)
    }) : t;
  });
}
function QD(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "key";
  return e.filter(function(r) {
    return r && Hn(r) === "object";
  }).reduce(function(r, a, i) {
    var c = a.fixed, d = c === !0 ? "left" : c, f = "".concat(t, "-").concat(i), p = a.children;
    return p && p.length > 0 ? [].concat(Et(r), Et(QD(p, f).map(function(g) {
      var b;
      return ce(ce({}, g), {}, {
        fixed: (b = g.fixed) !== null && b !== void 0 ? b : d
      });
    }))) : [].concat(Et(r), [ce(ce({
      key: f
    }, a), {}, {
      fixed: d
    })]);
  }, []);
}
function YCe(e) {
  return e.map(function(t) {
    var r = t.fixed, a = xr(t, KCe), i = r;
    return r === "left" ? i = "right" : r === "right" && (i = "left"), ce({
      fixed: i
    }, a);
  });
}
function QCe(e, t) {
  var r = e.prefixCls, a = e.columns, i = e.children, c = e.expandable, d = e.expandedKeys, f = e.columnTitle, p = e.getRowKey, g = e.onTriggerExpand, b = e.expandIcon, w = e.rowExpandable, x = e.expandIconColumnIndex, E = e.expandedRowOffset, P = E === void 0 ? 0 : E, k = e.direction, M = e.expandRowByClick, T = e.columnWidth, N = e.fixed, D = e.scrollWidth, $ = e.clientWidth, j = S.useMemo(function() {
    var G = a || Hj(i) || [];
    return iZ(G.slice());
  }, [a, i]), I = S.useMemo(function() {
    if (c) {
      var G = j.slice();
      if (process.env.NODE_ENV !== "production" && x >= 0 && $n(!1, "`expandIconColumnIndex` is deprecated. Please use `Table.EXPAND_COLUMN` in `columns` instead."), !G.includes(tb)) {
        var J = x || 0, H = J === 0 && N === "right" ? j.length : J;
        H >= 0 && G.splice(H, 0, tb);
      }
      process.env.NODE_ENV !== "production" && G.filter(function(ee) {
        return ee === tb;
      }).length > 1 && $n(!1, "There exist more than one `EXPAND_COLUMN` in `columns`.");
      var K = G.indexOf(tb);
      G = G.filter(function(ee, ne) {
        return ee !== tb || ne === K;
      });
      var X = j[K], te;
      N ? te = N : te = X ? X.fixed : null;
      var ie = ge(ge(ge(ge(ge(ge({}, pE, {
        className: "".concat(r, "-expand-icon-col"),
        columnType: "EXPAND_COLUMN"
      }), "title", f), "fixed", te), "className", "".concat(r, "-row-expand-icon-cell")), "width", T), "render", function(ne, ae, oe) {
        var fe = p(ae, oe), be = d.has(fe), me = w ? w(ae) : !0, De = b({
          prefixCls: r,
          expanded: be,
          expandable: me,
          record: ae,
          onExpand: g
        });
        return M ? /* @__PURE__ */ S.createElement("span", {
          onClick: function(ze) {
            return ze.stopPropagation();
          }
        }, De) : De;
      });
      return G.map(function(ee, ne) {
        var ae = ee === tb ? ie : ee;
        return ne < P ? ce(ce({}, ae), {}, {
          fixed: ae.fixed || "left"
        }) : ae;
      });
    }
    return process.env.NODE_ENV !== "production" && j.includes(tb) && $n(!1, "`expandable` is not config but there exist `EXPAND_COLUMN` in `columns`."), j.filter(function(ee) {
      return ee !== tb;
    });
  }, [c, j, p, d, b, k, P]), L = S.useMemo(function() {
    var G = I;
    return t && (G = t(G)), G.length || (G = [{
      render: function() {
        return null;
      }
    }]), G;
  }, [t, I, k]), F = S.useMemo(function() {
    return k === "rtl" ? YCe(QD(L)) : QD(L);
  }, [L, k, D]), _ = S.useMemo(function() {
    for (var G = -1, J = F.length - 1; J >= 0; J -= 1) {
      var H = F[J].fixed;
      if (H === "left" || H === !0) {
        G = J;
        break;
      }
    }
    if (G >= 0)
      for (var K = 0; K <= G; K += 1) {
        var X = F[K].fixed;
        if (X !== "left" && X !== !0)
          return !0;
      }
    var te = F.findIndex(function(ne) {
      var ae = ne.fixed;
      return ae === "right";
    });
    if (te >= 0)
      for (var ie = te; ie < F.length; ie += 1) {
        var ee = F[ie].fixed;
        if (ee !== "right")
          return !0;
      }
    return !1;
  }, [F]), W = GCe(F, D, $), Q = qe(W, 2), U = Q[0], Y = Q[1];
  return [L, U, Y, _];
}
function JCe(e, t, r) {
  var a = WCe(e), i = a.expandIcon, c = a.expandedRowKeys, d = a.defaultExpandedRowKeys, f = a.defaultExpandAllRows, p = a.expandedRowRender, g = a.onExpand, b = a.onExpandedRowsChange, w = a.childrenColumnName, x = i || $Ce, E = w || "children", P = S.useMemo(function() {
    return p ? "row" : e.expandable && e.internalHooks === u7 && e.expandable.__PARENT_RENDER_ICON__ || t.some(function(j) {
      return j && Hn(j) === "object" && j[E];
    }) ? "nest" : !1;
  }, [!!p, t]), k = S.useState(function() {
    return d || (f ? zCe(t, r, E) : []);
  }), M = qe(k, 2), T = M[0], N = M[1], D = S.useMemo(function() {
    return new Set(c || T || []);
  }, [c, T]), $ = S.useCallback(function(j) {
    var I = r(j, t.indexOf(j)), L, F = D.has(I);
    F ? (D.delete(I), L = Et(D)) : L = [].concat(Et(D), [I]), N(L), g && g(!F, j), b && b(L);
  }, [r, D, t, g, b]);
  return process.env.NODE_ENV !== "production" && p && t.some(function(j) {
    return Array.isArray(j?.[E]);
  }) && $n(!1, "`expandedRowRender` should not use with nested Table"), [a, P, D, x, E, $];
}
function ZCe(e, t, r) {
  var a = e.map(function(i, c) {
    return Lj(c, c, e, t, r);
  });
  return eC(function() {
    return a;
  }, [a], function(i, c) {
    return !R0(i, c);
  });
}
function e4e(e) {
  var t = It(e), r = Wn({}), a = qe(r, 2), i = a[1], c = It(null), d = It([]);
  function f(p) {
    d.current.push(p);
    var g = Promise.resolve();
    c.current = g, g.then(function() {
      if (c.current === g) {
        var b = d.current, w = t.current;
        d.current = [], b.forEach(function(x) {
          t.current = x(t.current);
        }), c.current = null, w !== t.current && i({});
      }
    });
  }
  return Er(function() {
    return function() {
      c.current = null;
    };
  }, []), [t.current, f];
}
function t4e(e) {
  var t = It(null), r = It();
  function a() {
    window.clearTimeout(r.current);
  }
  function i(d) {
    t.current = d, a(), r.current = window.setTimeout(function() {
      t.current = null, r.current = void 0;
    }, 100);
  }
  function c() {
    return t.current;
  }
  return Er(function() {
    return a;
  }, []), [i, c];
}
function n4e() {
  var e = S.useState(-1), t = qe(e, 2), r = t[0], a = t[1], i = S.useState(-1), c = qe(i, 2), d = c[0], f = c[1], p = S.useCallback(function(g, b) {
    a(g), f(b);
  }, []);
  return [r, d, p];
}
var JW = Ju() ? window : null;
function r4e(e, t) {
  var r = Hn(e) === "object" ? e : {}, a = r.offsetHeader, i = a === void 0 ? 0 : a, c = r.offsetSummary, d = c === void 0 ? 0 : c, f = r.offsetScroll, p = f === void 0 ? 0 : f, g = r.getContainer, b = g === void 0 ? function() {
    return JW;
  } : g, w = b() || JW, x = !!e;
  return S.useMemo(function() {
    return {
      isSticky: x,
      stickyClassName: x ? "".concat(t, "-sticky-holder") : "",
      offsetHeader: i,
      offsetSummary: d,
      offsetScroll: p,
      container: w
    };
  }, [x, p, i, d, t, w]);
}
function a4e(e, t, r) {
  var a = mn(function() {
    var i = t.length, c = function(g, b, w) {
      for (var x = [], E = 0, P = g; P !== b; P += w)
        x.push(E), t[P].fixed && (E += e[P] || 0);
      return x;
    }, d = c(0, i, 1), f = c(i - 1, -1, -1).reverse();
    return r === "rtl" ? {
      left: f,
      right: d
    } : {
      left: d,
      right: f
    };
  }, [e, t, r]);
  return a;
}
function ZW(e) {
  var t = e.className, r = e.children;
  return /* @__PURE__ */ S.createElement("div", {
    className: t
  }, r);
}
function eV(e) {
  var t = O9(e), r = t.getBoundingClientRect(), a = document.documentElement;
  return {
    left: r.left + (window.pageXOffset || a.scrollLeft) - (a.clientLeft || document.body.clientLeft || 0),
    top: r.top + (window.pageYOffset || a.scrollTop) - (a.clientTop || document.body.clientTop || 0)
  };
}
var o4e = function(t, r) {
  var a, i, c = t.scrollBodyRef, d = t.onScroll, f = t.offsetScroll, p = t.container, g = t.direction, b = hd(im, "prefixCls"), w = ((a = c.current) === null || a === void 0 ? void 0 : a.scrollWidth) || 0, x = ((i = c.current) === null || i === void 0 ? void 0 : i.clientWidth) || 0, E = w && x * (x / w), P = S.useRef(), k = e4e({
    scrollLeft: 0,
    isHiddenScrollBar: !0
  }), M = qe(k, 2), T = M[0], N = M[1], D = S.useRef({
    delta: 0,
    x: 0
  }), $ = S.useState(!1), j = qe($, 2), I = j[0], L = j[1], F = S.useRef(null);
  S.useEffect(function() {
    return function() {
      Pa.cancel(F.current);
    };
  }, []);
  var _ = function() {
    L(!1);
  }, W = function(J) {
    J.persist(), D.current.delta = J.pageX - T.scrollLeft, D.current.x = 0, L(!0), J.preventDefault();
  }, Q = function(J) {
    var H, K = J || ((H = window) === null || H === void 0 ? void 0 : H.event), X = K.buttons;
    if (!I || X === 0) {
      I && L(!1);
      return;
    }
    var te = D.current.x + J.pageX - D.current.x - D.current.delta, ie = g === "rtl";
    te = Math.max(ie ? E - x : 0, Math.min(ie ? 0 : x - E, te));
    var ee = !ie || Math.abs(te) + Math.abs(E) < x;
    ee && (d({
      scrollLeft: te / x * (w + 2)
    }), D.current.x = J.pageX);
  }, U = function() {
    Pa.cancel(F.current), F.current = Pa(function() {
      if (c.current) {
        var J = eV(c.current).top, H = J + c.current.offsetHeight, K = p === window ? document.documentElement.scrollTop + window.innerHeight : eV(p).top + p.clientHeight;
        N(function(X) {
          return ce(ce({}, X), {}, {
            isHiddenScrollBar: H - JH() <= K || J >= K - f
          });
        });
      }
    });
  }, Y = function(J) {
    N(function(H) {
      return ce(ce({}, H), {}, {
        scrollLeft: w ? J / w * x : 0
      });
    });
  };
  return S.useImperativeHandle(r, function() {
    return {
      setScrollLeft: Y,
      checkScrollBarVisible: U
    };
  }), S.useEffect(function() {
    var G = LW(document.body, "mouseup", _, !1), J = LW(document.body, "mousemove", Q, !1);
    return U(), function() {
      G.remove(), J.remove();
    };
  }, [E, I]), S.useEffect(function() {
    if (c.current) {
      for (var G = [], J = O9(c.current); J; )
        G.push(J), J = J.parentElement;
      return G.forEach(function(H) {
        return H.addEventListener("scroll", U, !1);
      }), window.addEventListener("resize", U, !1), window.addEventListener("scroll", U, !1), p.addEventListener("scroll", U, !1), function() {
        G.forEach(function(H) {
          return H.removeEventListener("scroll", U);
        }), window.removeEventListener("resize", U), window.removeEventListener("scroll", U), p.removeEventListener("scroll", U);
      };
    }
  }, [p]), S.useEffect(function() {
    T.isHiddenScrollBar || N(function(G) {
      var J = c.current;
      return J ? ce(ce({}, G), {}, {
        scrollLeft: J.scrollLeft / J.scrollWidth * J.clientWidth
      }) : G;
    });
  }, [T.isHiddenScrollBar]), w <= x || !E || T.isHiddenScrollBar ? null : /* @__PURE__ */ S.createElement("div", {
    style: {
      height: JH(),
      width: x,
      bottom: f
    },
    className: "".concat(b, "-sticky-scroll")
  }, /* @__PURE__ */ S.createElement("div", {
    onMouseDown: W,
    ref: P,
    className: _e("".concat(b, "-sticky-scroll-bar"), ge({}, "".concat(b, "-sticky-scroll-bar-active"), I)),
    style: {
      width: "".concat(E, "px"),
      transform: "translate3d(".concat(T.scrollLeft, "px, 0, 0)")
    }
  }));
};
const i4e = /* @__PURE__ */ S.forwardRef(o4e);
var lZ = "rc-table", l4e = [], s4e = {};
function u4e() {
  return "No Data";
}
function c4e(e, t) {
  var r = ce({
    rowKey: "key",
    prefixCls: lZ,
    emptyText: u4e
  }, e), a = r.prefixCls, i = r.className, c = r.rowClassName, d = r.style, f = r.data, p = r.rowKey, g = r.scroll, b = r.tableLayout, w = r.direction, x = r.title, E = r.footer, P = r.summary, k = r.caption, M = r.id, T = r.showHeader, N = r.components, D = r.emptyText, $ = r.onRow, j = r.onHeaderRow, I = r.measureRowRender, L = r.onScroll, F = r.internalHooks, _ = r.transformColumns, W = r.internalRefs, Q = r.tailor, U = r.getContainerWidth, Y = r.sticky, G = r.rowHoverable, J = G === void 0 ? !0 : G, H = f || l4e, K = !!H.length, X = F === u7;
  process.env.NODE_ENV !== "production" && (["onRowClick", "onRowDoubleClick", "onRowContextMenu", "onRowMouseEnter", "onRowMouseLeave"].forEach(function(qt) {
    $n(r[qt] === void 0, "`".concat(qt, "` is removed, please use `onRow` instead."));
  }), $n(!("getBodyWrapper" in r), "`getBodyWrapper` is deprecated, please use custom `components` instead."));
  var te = S.useCallback(function(qt, Kt) {
    return M0(N, qt) || Kt;
  }, [N]), ie = S.useMemo(function() {
    return typeof p == "function" ? p : function(qt) {
      var Kt = qt && qt[p];
      return process.env.NODE_ENV !== "production" && $n(Kt !== void 0, "Each record in table should have a unique `key` prop, or set `rowKey` to an unique primary key."), Kt;
    };
  }, [p]), ee = te(["body"]), ne = n4e(), ae = qe(ne, 3), oe = ae[0], fe = ae[1], be = ae[2], me = JCe(r, H, ie), De = qe(me, 6), Me = De[0], ze = De[1], le = De[2], se = De[3], Ae = De[4], we = De[5], Ne = g?.x, pe = S.useState(0), Qe = qe(pe, 2), Le = Qe[0], Te = Qe[1], Oe = QCe(ce(ce(ce({}, r), Me), {}, {
    expandable: !!Me.expandedRowRender,
    columnTitle: Me.columnTitle,
    expandedKeys: le,
    getRowKey: ie,
    // https://github.com/ant-design/ant-design/issues/23894
    onTriggerExpand: we,
    expandIcon: se,
    expandIconColumnIndex: Me.expandIconColumnIndex,
    direction: w,
    scrollWidth: X && Q && typeof Ne == "number" ? Ne : null,
    clientWidth: Le
  }), X ? _ : null), ye = qe(Oe, 4), je = ye[0], Ue = ye[1], Fe = ye[2], tt = ye[3], dt = Fe ?? Ne, St = S.useMemo(function() {
    return {
      columns: je,
      flattenColumns: Ue
    };
  }, [je, Ue]), mt = S.useRef(), Ot = S.useRef(), Rt = S.useRef(), ct = S.useRef();
  S.useImperativeHandle(t, function() {
    return {
      nativeElement: mt.current,
      scrollTo: function(Kt) {
        var ur;
        if (Rt.current instanceof HTMLElement) {
          var pr = Kt.index, tr = Kt.top, Va = Kt.key;
          if (SCe(tr)) {
            var pi;
            (pi = Rt.current) === null || pi === void 0 || pi.scrollTo({
              top: tr
            });
          } else {
            var Li, yo = Va ?? ie(H[pr]);
            (Li = Rt.current.querySelector('[data-row-key="'.concat(yo, '"]'))) === null || Li === void 0 || Li.scrollIntoView();
          }
        } else (ur = Rt.current) !== null && ur !== void 0 && ur.scrollTo && Rt.current.scrollTo(Kt);
      }
    };
  });
  var it = S.useRef(), Ct = S.useState(!1), ut = qe(Ct, 2), ht = ut[0], ot = ut[1], at = S.useState(!1), ft = qe(at, 2), st = ft[0], pt = ft[1], bt = S.useState(/* @__PURE__ */ new Map()), Nt = qe(bt, 2), $t = Nt[0], Pt = Nt[1], hn = bM(Ue), an = hn.map(function(qt) {
    return $t.get(qt);
  }), jn = S.useMemo(function() {
    return an;
  }, [an.join("_")]), xn = a4e(jn, Ue, w), Ut = g && YD(g.y), pn = g && YD(dt) || !!Me.fixed, wn = pn && Ue.some(function(qt) {
    var Kt = qt.fixed;
    return Kt;
  }), Lt = S.useRef(), gt = r4e(Y, a), wt = gt.isSticky, Ft = gt.offsetHeader, yn = gt.offsetSummary, gn = gt.offsetScroll, Tn = gt.stickyClassName, Gt = gt.container, Dt = S.useMemo(function() {
    return P?.(H);
  }, [P, H]), Yt = (Ut || wt) && /* @__PURE__ */ S.isValidElement(Dt) && Dt.type === yM && Dt.props.fixed, Mn, Gn, wr;
  Ut && (Gn = {
    overflowY: K ? "scroll" : "auto",
    maxHeight: g.y
  }), pn && (Mn = {
    overflowX: "auto"
  }, Ut || (Gn = {
    overflowY: "hidden"
  }), wr = {
    width: dt === !0 ? "auto" : dt,
    minWidth: "100%"
  });
  var aa = S.useCallback(function(qt, Kt) {
    Pt(function(ur) {
      if (ur.get(qt) !== Kt) {
        var pr = new Map(ur);
        return pr.set(qt, Kt), pr;
      }
      return ur;
    });
  }, []), qn = t4e(), Rr = qe(qn, 2), Wt = Rr[0], en = Rr[1];
  function Xt(qt, Kt) {
    Kt && (typeof Kt == "function" ? Kt(qt) : Kt.scrollLeft !== qt && (Kt.scrollLeft = qt, Kt.scrollLeft !== qt && setTimeout(function() {
      Kt.scrollLeft = qt;
    }, 0)));
  }
  var zt = ra(function(qt) {
    var Kt = qt.currentTarget, ur = qt.scrollLeft, pr = w === "rtl", tr = typeof ur == "number" ? ur : Kt.scrollLeft, Va = Kt || s4e;
    if (!en() || en() === Va) {
      var pi;
      Wt(Va), Xt(tr, Ot.current), Xt(tr, Rt.current), Xt(tr, it.current), Xt(tr, (pi = Lt.current) === null || pi === void 0 ? void 0 : pi.setScrollLeft);
    }
    var Li = Kt || Ot.current;
    if (Li) {
      var yo = (
        // Should use mergedScrollX in virtual table(useInternalHooks && tailor === true)
        X && Q && typeof dt == "number" ? dt : Li.scrollWidth
      ), ul = Li.clientWidth;
      if (yo === ul) {
        ot(!1), pt(!1);
        return;
      }
      pr ? (ot(-tr < yo - ul), pt(-tr > 0)) : (ot(tr > 0), pt(tr < yo - ul));
    }
  }), kt = ra(function(qt) {
    zt(qt), L?.(qt);
  }), Qn = function() {
    if (pn && Rt.current) {
      var Kt;
      zt({
        currentTarget: O9(Rt.current),
        scrollLeft: (Kt = Rt.current) === null || Kt === void 0 ? void 0 : Kt.scrollLeft
      });
    } else
      ot(!1), pt(!1);
  }, Jn = function(Kt) {
    var ur, pr = Kt.width;
    (ur = Lt.current) === null || ur === void 0 || ur.checkScrollBarVisible();
    var tr = mt.current ? mt.current.offsetWidth : pr;
    X && U && mt.current && (tr = U(mt.current, tr) || tr), tr !== Le && (Qn(), Te(tr));
  }, Nr = S.useRef(!1);
  S.useEffect(function() {
    Nr.current && Qn();
  }, [pn, f, je.length]), S.useEffect(function() {
    Nr.current = !0;
  }, []);
  var Hr = S.useState(0), oa = qe(Hr, 2), dn = oa[0], Un = oa[1], sr = S.useState(!0), Yr = qe(sr, 2), Wa = Yr[0], pa = Yr[1];
  Da(function() {
    (!Q || !X) && (Rt.current instanceof Element ? Un(pD(Rt.current).width) : Un(pD(ct.current).width)), pa(Vhe("position", "sticky"));
  }, []), S.useEffect(function() {
    X && W && (W.body.current = Rt.current);
  });
  var Jr = S.useCallback(function(qt) {
    return /* @__PURE__ */ S.createElement(S.Fragment, null, /* @__PURE__ */ S.createElement(YW, qt), Yt === "top" && /* @__PURE__ */ S.createElement(Y7, qt, Dt));
  }, [Yt, Dt]), si = S.useCallback(function(qt) {
    return /* @__PURE__ */ S.createElement(Y7, qt, Dt);
  }, [Dt]), mi = te(["table"], "table"), Yo = S.useMemo(function() {
    return b || (wn ? dt === "max-content" ? "auto" : "fixed" : Ut || wt || Ue.some(function(qt) {
      var Kt = qt.ellipsis;
      return Kt;
    }) ? "fixed" : "auto");
  }, [Ut, wn, Ue, b, wt]), Bi, hr = {
    colWidths: jn,
    columCount: Ue.length,
    stickyOffsets: xn,
    onHeaderRow: j,
    fixHeader: Ut,
    scroll: g
  }, zn = S.useMemo(function() {
    return K ? null : typeof D == "function" ? D() : D;
  }, [K, D]), On = /* @__PURE__ */ S.createElement(HCe, {
    data: H,
    measureColumnWidth: Ut || pn || wt
  }), Qt = /* @__PURE__ */ S.createElement(rZ, {
    colWidths: Ue.map(function(qt) {
      var Kt = qt.width;
      return Kt;
    }),
    columns: Ue
  }), nn = k != null ? /* @__PURE__ */ S.createElement("caption", {
    className: "".concat(a, "-caption")
  }, k) : void 0, er = Zu(r, {
    data: !0
  }), ia = Zu(r, {
    aria: !0
  });
  if (Ut || wt) {
    var so;
    typeof ee == "function" ? (so = ee(H, {
      scrollbarSize: dn,
      ref: Rt,
      onScroll: zt
    }), hr.colWidths = Ue.map(function(qt, Kt) {
      var ur = qt.width, pr = Kt === Ue.length - 1 ? ur - dn : ur;
      return typeof pr == "number" && !Number.isNaN(pr) ? pr : (process.env.NODE_ENV !== "production" && $n(r.columns.length === 0, "When use `components.body` with render props. Each column should have a fixed `width` value."), 0);
    })) : so = /* @__PURE__ */ S.createElement("div", {
      style: ce(ce({}, Mn), Gn),
      onScroll: kt,
      ref: Rt,
      className: _e("".concat(a, "-body"))
    }, /* @__PURE__ */ S.createElement(mi, vt({
      style: ce(ce({}, wr), {}, {
        tableLayout: Yo
      })
    }, ia), nn, Qt, On, !Yt && Dt && /* @__PURE__ */ S.createElement(Y7, {
      stickyOffsets: xn,
      flattenColumns: Ue
    }, Dt)));
    var hi = ce(ce(ce({
      noData: !H.length
    }, hr), St), {}, {
      direction: w,
      stickyClassName: Tn,
      scrollX: dt,
      tableLayout: Yo,
      onScroll: zt
    });
    Bi = /* @__PURE__ */ S.createElement(S.Fragment, null, T !== !1 && /* @__PURE__ */ S.createElement(KW, vt({}, hi, {
      stickyTopOffset: Ft,
      className: "".concat(a, "-header"),
      ref: Ot,
      colGroup: Qt
    }), Jr), so, Yt && Yt !== "top" && /* @__PURE__ */ S.createElement(KW, vt({}, hi, {
      stickyBottomOffset: yn,
      className: "".concat(a, "-summary"),
      ref: it,
      colGroup: Qt
    }), si), wt && Rt.current && Rt.current instanceof Element && /* @__PURE__ */ S.createElement(i4e, {
      ref: Lt,
      offsetScroll: gn,
      scrollBodyRef: Rt,
      onScroll: zt,
      container: Gt,
      direction: w
    }));
  } else
    Bi = /* @__PURE__ */ S.createElement("div", {
      style: ce(ce({}, Mn), Gn),
      className: _e("".concat(a, "-content")),
      onScroll: zt,
      ref: Rt
    }, /* @__PURE__ */ S.createElement(mi, vt({
      style: ce(ce({}, wr), {}, {
        tableLayout: Yo
      })
    }, ia), nn, Qt, T !== !1 && /* @__PURE__ */ S.createElement(YW, vt({}, hr, St)), On, Dt && /* @__PURE__ */ S.createElement(Y7, {
      stickyOffsets: xn,
      flattenColumns: Ue
    }, Dt)));
  var ka = /* @__PURE__ */ S.createElement("div", vt({
    className: _e(a, i, ge(ge(ge(ge(ge(ge(ge(ge(ge(ge({}, "".concat(a, "-rtl"), w === "rtl"), "".concat(a, "-ping-left"), ht), "".concat(a, "-ping-right"), st), "".concat(a, "-layout-fixed"), b === "fixed"), "".concat(a, "-fixed-header"), Ut), "".concat(a, "-fixed-column"), wn), "".concat(a, "-fixed-column-gapped"), wn && tt), "".concat(a, "-scroll-horizontal"), pn), "".concat(a, "-has-fix-left"), Ue[0] && Ue[0].fixed), "".concat(a, "-has-fix-right"), Ue[Ue.length - 1] && Ue[Ue.length - 1].fixed === "right")),
    style: d,
    id: M,
    ref: mt
  }, er), x && /* @__PURE__ */ S.createElement(ZW, {
    className: "".concat(a, "-title")
  }, x(H)), /* @__PURE__ */ S.createElement("div", {
    ref: ct,
    className: "".concat(a, "-container")
  }, Bi), E && /* @__PURE__ */ S.createElement(ZW, {
    className: "".concat(a, "-footer")
  }, E(H)));
  pn && (ka = /* @__PURE__ */ S.createElement(hp, {
    onResize: Jn
  }, ka));
  var Ui = ZCe(Ue, xn, w), sl = S.useMemo(function() {
    return {
      // Scroll
      scrollX: dt,
      // Table
      prefixCls: a,
      getComponent: te,
      scrollbarSize: dn,
      direction: w,
      fixedInfoList: Ui,
      isSticky: wt,
      supportSticky: Wa,
      componentWidth: Le,
      fixHeader: Ut,
      fixColumn: wn,
      horizonScroll: pn,
      // Body
      tableLayout: Yo,
      rowClassName: c,
      expandedRowClassName: Me.expandedRowClassName,
      expandIcon: se,
      expandableType: ze,
      expandRowByClick: Me.expandRowByClick,
      expandedRowRender: Me.expandedRowRender,
      expandedRowOffset: Me.expandedRowOffset,
      onTriggerExpand: we,
      expandIconColumnIndex: Me.expandIconColumnIndex,
      indentSize: Me.indentSize,
      allColumnsFixedLeft: Ue.every(function(qt) {
        return qt.fixed === "left";
      }),
      emptyNode: zn,
      // Column
      columns: je,
      flattenColumns: Ue,
      onColumnResize: aa,
      colWidths: jn,
      // Row
      hoverStartRow: oe,
      hoverEndRow: fe,
      onHover: be,
      rowExpandable: Me.rowExpandable,
      onRow: $,
      getRowKey: ie,
      expandedKeys: le,
      childrenColumnName: Ae,
      rowHoverable: J,
      // Measure Row
      measureRowRender: I
    };
  }, [
    // Scroll
    dt,
    // Table
    a,
    te,
    dn,
    w,
    Ui,
    wt,
    Wa,
    Le,
    Ut,
    wn,
    pn,
    // Body
    Yo,
    c,
    Me.expandedRowClassName,
    se,
    ze,
    Me.expandRowByClick,
    Me.expandedRowRender,
    Me.expandedRowOffset,
    we,
    Me.expandIconColumnIndex,
    Me.indentSize,
    zn,
    // Column
    je,
    Ue,
    aa,
    jn,
    // Row
    oe,
    fe,
    be,
    Me.rowExpandable,
    $,
    ie,
    le,
    Ae,
    J,
    I
  ]);
  return /* @__PURE__ */ S.createElement(im.Provider, {
    value: sl
  }, ka);
}
var sZ = /* @__PURE__ */ S.forwardRef(c4e);
process.env.NODE_ENV !== "production" && (sZ.displayName = "Table");
function uZ(e) {
  return BJ(sZ, e);
}
var e6 = uZ();
e6.EXPAND_COLUMN = tb;
e6.INTERNAL_HOOKS = u7;
e6.Column = NCe;
e6.ColumnGroup = DCe;
e6.Summary = qJ;
var Fj = jj(null), cZ = jj(null);
function d4e(e, t, r) {
  var a = t || 1;
  return r[e + a] - (r[e] || 0);
}
function f4e(e) {
  var t = e.rowInfo, r = e.column, a = e.colIndex, i = e.indent, c = e.index, d = e.component, f = e.renderIndex, p = e.record, g = e.style, b = e.className, w = e.inverse, x = e.getHeight, E = r.render, P = r.dataIndex, k = r.className, M = r.width, T = hd(cZ, ["columnsOffset"]), N = T.columnsOffset, D = eZ(t, r, a, i, c), $ = D.key, j = D.fixedInfo, I = D.appendCellNode, L = D.additionalCellProps, F = L.style, _ = L.colSpan, W = _ === void 0 ? 1 : _, Q = L.rowSpan, U = Q === void 0 ? 1 : Q, Y = a - 1, G = d4e(Y, W, N), J = W > 1 ? M - G : 0, H = ce(ce(ce({}, F), g), {}, {
    flex: "0 0 ".concat(G, "px"),
    width: "".concat(G, "px"),
    marginRight: J,
    pointerEvents: "auto"
  }), K = S.useMemo(function() {
    return w ? U <= 1 : W === 0 || U === 0 || U > 1;
  }, [U, W, w]);
  K ? H.visibility = "hidden" : w && (H.height = x?.(U));
  var X = K ? function() {
    return null;
  } : E, te = {};
  return (U === 0 || W === 0) && (te.rowSpan = 1, te.colSpan = 1), /* @__PURE__ */ S.createElement(Zx, vt({
    className: _e(k, b),
    ellipsis: r.ellipsis,
    align: r.align,
    scope: r.rowScope,
    component: d,
    prefixCls: t.prefixCls,
    key: $,
    record: p,
    index: c,
    renderIndex: f,
    dataIndex: P,
    render: X,
    shouldCellUpdate: r.shouldCellUpdate
  }, j, {
    appendNode: I,
    additionalProps: ce(ce({}, L), {}, {
      style: H
    }, te)
  }));
}
var m4e = ["data", "index", "className", "rowKey", "style", "extra", "getHeight"], h4e = /* @__PURE__ */ S.forwardRef(function(e, t) {
  var r = e.data, a = e.index, i = e.className, c = e.rowKey, d = e.style, f = e.extra, p = e.getHeight, g = xr(e, m4e), b = r.record, w = r.indent, x = r.index, E = hd(im, ["prefixCls", "flattenColumns", "fixColumn", "componentWidth", "scrollX"]), P = E.scrollX, k = E.flattenColumns, M = E.prefixCls, T = E.fixColumn, N = E.componentWidth, D = hd(Fj, ["getComponent"]), $ = D.getComponent, j = QJ(b, c, a, w), I = $(["body", "row"], "div"), L = $(["body", "cell"], "div"), F = j.rowSupportExpand, _ = j.expanded, W = j.rowProps, Q = j.expandedRowRender, U = j.expandedRowClassName, Y;
  if (F && _) {
    var G = Q(b, a, w + 1, _), J = ZJ(U, b, a, w), H = {};
    T && (H = {
      style: ge({}, "--virtual-width", "".concat(N, "px"))
    });
    var K = "".concat(M, "-expanded-row-cell");
    Y = /* @__PURE__ */ S.createElement(I, {
      className: _e("".concat(M, "-expanded-row"), "".concat(M, "-expanded-row-level-").concat(w + 1), J)
    }, /* @__PURE__ */ S.createElement(Zx, {
      component: L,
      prefixCls: M,
      className: _e(K, ge({}, "".concat(K, "-fixed"), T)),
      additionalProps: H
    }, G));
  }
  var X = ce(ce({}, d), {}, {
    width: P
  });
  f && (X.position = "absolute", X.pointerEvents = "none");
  var te = /* @__PURE__ */ S.createElement(I, vt({}, W, g, {
    "data-row-key": c,
    ref: F ? null : t,
    className: _e(i, "".concat(M, "-row"), W?.className, ge({}, "".concat(M, "-row-extra"), f)),
    style: ce(ce({}, X), W?.style)
  }), k.map(function(ie, ee) {
    return /* @__PURE__ */ S.createElement(f4e, {
      key: ee,
      component: L,
      rowInfo: j,
      column: ie,
      colIndex: ee,
      indent: w,
      index: a,
      renderIndex: x,
      record: b,
      inverse: f,
      getHeight: p
    });
  }));
  return F ? /* @__PURE__ */ S.createElement("div", {
    ref: t
  }, te, Y) : te;
}), JD = Jx(h4e);
process.env.NODE_ENV !== "production" && (JD.displayName = "BodyLine");
var p4e = /* @__PURE__ */ S.forwardRef(function(e, t) {
  var r = e.data, a = e.onScroll, i = hd(im, ["flattenColumns", "onColumnResize", "getRowKey", "prefixCls", "expandedKeys", "childrenColumnName", "scrollX", "direction"]), c = i.flattenColumns, d = i.onColumnResize, f = i.getRowKey, p = i.expandedKeys, g = i.prefixCls, b = i.childrenColumnName, w = i.scrollX, x = i.direction, E = hd(Fj), P = E.sticky, k = E.scrollY, M = E.listItemHeight, T = E.getComponent, N = E.onScroll, D = S.useRef(), $ = YJ(r, b, p, f), j = S.useMemo(function() {
    var Y = 0;
    return c.map(function(G) {
      var J = G.width, H = G.minWidth, K = G.key, X = Math.max(J || 0, H || 0);
      return Y += X, [K, X, Y];
    });
  }, [c]), I = S.useMemo(function() {
    return j.map(function(Y) {
      return Y[2];
    });
  }, [j]);
  S.useEffect(function() {
    j.forEach(function(Y) {
      var G = qe(Y, 2), J = G[0], H = G[1];
      d(J, H);
    });
  }, [j]), S.useImperativeHandle(t, function() {
    var Y, G = {
      scrollTo: function(H) {
        var K;
        (K = D.current) === null || K === void 0 || K.scrollTo(H);
      },
      nativeElement: (Y = D.current) === null || Y === void 0 ? void 0 : Y.nativeElement
    };
    return Object.defineProperty(G, "scrollLeft", {
      get: function() {
        var H;
        return ((H = D.current) === null || H === void 0 ? void 0 : H.getScrollInfo().x) || 0;
      },
      set: function(H) {
        var K;
        (K = D.current) === null || K === void 0 || K.scrollTo({
          left: H
        });
      }
    }), Object.defineProperty(G, "scrollTop", {
      get: function() {
        var H;
        return ((H = D.current) === null || H === void 0 ? void 0 : H.getScrollInfo().y) || 0;
      },
      set: function(H) {
        var K;
        (K = D.current) === null || K === void 0 || K.scrollTo({
          top: H
        });
      }
    }), G;
  });
  var L = function(G, J) {
    var H, K = (H = $[J]) === null || H === void 0 ? void 0 : H.record, X = G.onCell;
    if (X) {
      var te, ie = X(K, J);
      return (te = ie?.rowSpan) !== null && te !== void 0 ? te : 1;
    }
    return 1;
  }, F = function(G) {
    var J = G.start, H = G.end, K = G.getSize, X = G.offsetY;
    if (H < 0)
      return null;
    for (var te = c.filter(
      // rowSpan is 0
      function(le) {
        return L(le, J) === 0;
      }
    ), ie = J, ee = function(se) {
      if (te = te.filter(function(Ae) {
        return L(Ae, se) === 0;
      }), !te.length)
        return ie = se, 1;
    }, ne = J; ne >= 0 && !ee(ne); ne -= 1)
      ;
    for (var ae = c.filter(
      // rowSpan is not 1
      function(le) {
        return L(le, H) !== 1;
      }
    ), oe = H, fe = function(se) {
      if (ae = ae.filter(function(Ae) {
        return L(Ae, se) !== 1;
      }), !ae.length)
        return oe = Math.max(se - 1, H), 1;
    }, be = H; be < $.length && !fe(be); be += 1)
      ;
    for (var me = [], De = function(se) {
      var Ae = $[se];
      if (!Ae)
        return 1;
      c.some(function(we) {
        return L(we, se) > 1;
      }) && me.push(se);
    }, Me = ie; Me <= oe; Me += 1)
      De(Me);
    var ze = me.map(function(le) {
      var se = $[le], Ae = f(se.record, le), we = function(Qe) {
        var Le = le + Qe - 1, Te = f($[Le].record, Le), Oe = K(Ae, Te);
        return Oe.bottom - Oe.top;
      }, Ne = K(Ae);
      return /* @__PURE__ */ S.createElement(JD, {
        key: le,
        data: se,
        rowKey: Ae,
        index: le,
        style: {
          top: -X + Ne.top
        },
        extra: !0,
        getHeight: we
      });
    });
    return ze;
  }, _ = S.useMemo(function() {
    return {
      columnsOffset: I
    };
  }, [I]), W = "".concat(g, "-tbody"), Q = T(["body", "wrapper"]), U = {};
  return P && (U.position = "sticky", U.bottom = 0, Hn(P) === "object" && P.offsetScroll && (U.bottom = P.offsetScroll)), /* @__PURE__ */ S.createElement(cZ.Provider, {
    value: _
  }, /* @__PURE__ */ S.createElement(eM, {
    fullHeight: !1,
    ref: D,
    prefixCls: "".concat(W, "-virtual"),
    styles: {
      horizontalScrollBar: U
    },
    className: W,
    height: k,
    itemHeight: M || 24,
    data: $,
    itemKey: function(G) {
      return f(G.record);
    },
    component: Q,
    scrollWidth: w,
    direction: x,
    onVirtualScroll: function(G) {
      var J, H = G.x;
      a({
        currentTarget: (J = D.current) === null || J === void 0 ? void 0 : J.nativeElement,
        scrollLeft: H
      });
    },
    onScroll: N,
    extraRender: F
  }, function(Y, G, J) {
    var H = f(Y.record, G);
    return /* @__PURE__ */ S.createElement(JD, {
      data: Y,
      rowKey: H,
      index: G,
      style: J.style
    });
  }));
}), dZ = Jx(p4e);
process.env.NODE_ENV !== "production" && (dZ.displayName = "ResponseGrid");
var g4e = function(t, r) {
  var a = r.ref, i = r.onScroll;
  return /* @__PURE__ */ S.createElement(dZ, {
    ref: a,
    data: t,
    onScroll: i
  });
};
function v4e(e, t) {
  var r = e.data, a = e.columns, i = e.scroll, c = e.sticky, d = e.prefixCls, f = d === void 0 ? lZ : d, p = e.className, g = e.listItemHeight, b = e.components, w = e.onScroll, x = i || {}, E = x.x, P = x.y;
  typeof E != "number" && (process.env.NODE_ENV !== "production" && $n(!E, "`scroll.x` in virtual table must be number."), E = 1), typeof P != "number" && (P = 500, process.env.NODE_ENV !== "production" && $n(!1, "`scroll.y` in virtual table must be number."));
  var k = ra(function(N, D) {
    return M0(b, N) || D;
  }), M = ra(w), T = S.useMemo(function() {
    return {
      sticky: c,
      scrollY: P,
      listItemHeight: g,
      getComponent: k,
      onScroll: M
    };
  }, [c, P, g, k, M]);
  return /* @__PURE__ */ S.createElement(Fj.Provider, {
    value: T
  }, /* @__PURE__ */ S.createElement(e6, vt({}, e, {
    className: _e(p, "".concat(f, "-virtual")),
    scroll: ce(ce({}, i), {}, {
      x: E
    }),
    components: ce(ce({}, b), {}, {
      // fix https://github.com/ant-design/ant-design/issues/48991
      body: r != null && r.length ? g4e : void 0
    }),
    columns: a,
    internalHooks: u7,
    tailor: !0,
    ref: t
  })));
}
var fZ = /* @__PURE__ */ S.forwardRef(v4e);
process.env.NODE_ENV !== "production" && (fZ.displayName = "VirtualTable");
function mZ(e) {
  return BJ(fZ, e);
}
mZ();
const b4e = (e) => null, y4e = (e) => null;
var Wj = /* @__PURE__ */ S.createContext(null), w4e = /* @__PURE__ */ S.createContext({}), S4e = function(t) {
  for (var r = t.prefixCls, a = t.level, i = t.isStart, c = t.isEnd, d = "".concat(r, "-indent-unit"), f = [], p = 0; p < a; p += 1)
    f.push(/* @__PURE__ */ S.createElement("span", {
      key: p,
      className: _e(d, ge(ge({}, "".concat(d, "-start"), i[p]), "".concat(d, "-end"), c[p]))
    }));
  return /* @__PURE__ */ S.createElement("span", {
    "aria-hidden": "true",
    className: "".concat(r, "-indent")
  }, f);
};
const C4e = /* @__PURE__ */ S.memo(S4e);
var x4e = ["eventKey", "className", "style", "dragOver", "dragOverGapTop", "dragOverGapBottom", "isLeaf", "isStart", "isEnd", "expanded", "selected", "checked", "halfChecked", "loading", "domRef", "active", "data", "onMouseMove", "selectable"], tV = "open", nV = "close", E4e = "---", Tx = function(t) {
  var r, a, i, c = t.eventKey, d = t.className, f = t.style, p = t.dragOver, g = t.dragOverGapTop, b = t.dragOverGapBottom, w = t.isLeaf, x = t.isStart, E = t.isEnd, P = t.expanded, k = t.selected, M = t.checked, T = t.halfChecked, N = t.loading, D = t.domRef, $ = t.active, j = t.data, I = t.onMouseMove, L = t.selectable, F = xr(t, x4e), _ = Re.useContext(Wj), W = Re.useContext(w4e), Q = Re.useRef(null), U = Re.useState(!1), Y = qe(U, 2), G = Y[0], J = Y[1], H = !!(_.disabled || t.disabled || (r = W.nodeDisabled) !== null && r !== void 0 && r.call(W, j)), K = Re.useMemo(function() {
    return !_.checkable || t.checkable === !1 ? !1 : _.checkable;
  }, [_.checkable, t.checkable]), X = function(it) {
    H || _.onNodeSelect(it, Yu(t));
  }, te = function(it) {
    H || !K || t.disableCheckbox || _.onNodeCheck(it, Yu(t), !M);
  }, ie = Re.useMemo(function() {
    return typeof L == "boolean" ? L : _.selectable;
  }, [L, _.selectable]), ee = function(it) {
    _.onNodeClick(it, Yu(t)), ie ? X(it) : te(it);
  }, ne = function(it) {
    _.onNodeDoubleClick(it, Yu(t));
  }, ae = function(it) {
    _.onNodeMouseEnter(it, Yu(t));
  }, oe = function(it) {
    _.onNodeMouseLeave(it, Yu(t));
  }, fe = function(it) {
    _.onNodeContextMenu(it, Yu(t));
  }, be = Re.useMemo(function() {
    return !!(_.draggable && (!_.draggable.nodeDraggable || _.draggable.nodeDraggable(j)));
  }, [_.draggable, j]), me = function(it) {
    it.stopPropagation(), J(!0), _.onNodeDragStart(it, t);
    try {
      it.dataTransfer.setData("text/plain", "");
    } catch {
    }
  }, De = function(it) {
    it.preventDefault(), it.stopPropagation(), _.onNodeDragEnter(it, t);
  }, Me = function(it) {
    it.preventDefault(), it.stopPropagation(), _.onNodeDragOver(it, t);
  }, ze = function(it) {
    it.stopPropagation(), _.onNodeDragLeave(it, t);
  }, le = function(it) {
    it.stopPropagation(), J(!1), _.onNodeDragEnd(it, t);
  }, se = function(it) {
    it.preventDefault(), it.stopPropagation(), J(!1), _.onNodeDrop(it, t);
  }, Ae = function(it) {
    N || _.onNodeExpand(it, Yu(t));
  }, we = Re.useMemo(function() {
    var ct = np(_.keyEntities, c) || {}, it = ct.children;
    return !!(it || []).length;
  }, [_.keyEntities, c]), Ne = Re.useMemo(function() {
    return w === !1 ? !1 : w || !_.loadData && !we || _.loadData && t.loaded && !we;
  }, [w, _.loadData, we, t.loaded]);
  Re.useEffect(function() {
    N || typeof _.loadData == "function" && P && !Ne && !t.loaded && _.onNodeLoad(Yu(t));
  }, [N, _.loadData, _.onNodeLoad, P, Ne, t]);
  var pe = Re.useMemo(function() {
    var ct;
    return (ct = _.draggable) !== null && ct !== void 0 && ct.icon ? /* @__PURE__ */ Re.createElement("span", {
      className: "".concat(_.prefixCls, "-draggable-icon")
    }, _.draggable.icon) : null;
  }, [_.draggable]), Qe = function(it) {
    var Ct = t.switcherIcon || _.switcherIcon;
    return typeof Ct == "function" ? Ct(ce(ce({}, t), {}, {
      isLeaf: it
    })) : Ct;
  }, Le = function() {
    if (Ne) {
      var it = Qe(!0);
      return it !== !1 ? /* @__PURE__ */ Re.createElement("span", {
        className: _e("".concat(_.prefixCls, "-switcher"), "".concat(_.prefixCls, "-switcher-noop"))
      }, it) : null;
    }
    var Ct = Qe(!1);
    return Ct !== !1 ? /* @__PURE__ */ Re.createElement("span", {
      onClick: Ae,
      className: _e("".concat(_.prefixCls, "-switcher"), "".concat(_.prefixCls, "-switcher_").concat(P ? tV : nV))
    }, Ct) : null;
  }, Te = Re.useMemo(function() {
    if (!K)
      return null;
    var ct = typeof K != "boolean" ? K : null;
    return /* @__PURE__ */ Re.createElement("span", {
      className: _e("".concat(_.prefixCls, "-checkbox"), ge(ge(ge({}, "".concat(_.prefixCls, "-checkbox-checked"), M), "".concat(_.prefixCls, "-checkbox-indeterminate"), !M && T), "".concat(_.prefixCls, "-checkbox-disabled"), H || t.disableCheckbox)),
      onClick: te,
      role: "checkbox",
      "aria-checked": T ? "mixed" : M,
      "aria-disabled": H || t.disableCheckbox,
      "aria-label": "Select ".concat(typeof t.title == "string" ? t.title : "tree node")
    }, ct);
  }, [K, M, T, H, t.disableCheckbox, t.title]), Oe = Re.useMemo(function() {
    return Ne ? null : P ? tV : nV;
  }, [Ne, P]), ye = Re.useMemo(function() {
    return /* @__PURE__ */ Re.createElement("span", {
      className: _e("".concat(_.prefixCls, "-iconEle"), "".concat(_.prefixCls, "-icon__").concat(Oe || "docu"), ge({}, "".concat(_.prefixCls, "-icon_loading"), N))
    });
  }, [_.prefixCls, Oe, N]), je = Re.useMemo(function() {
    var ct = !!_.draggable, it = !t.disabled && ct && _.dragOverNodeKey === c;
    return it ? _.dropIndicatorRender({
      dropPosition: _.dropPosition,
      dropLevelOffset: _.dropLevelOffset,
      indent: _.indent,
      prefixCls: _.prefixCls,
      direction: _.direction
    }) : null;
  }, [_.dropPosition, _.dropLevelOffset, _.indent, _.prefixCls, _.direction, _.draggable, _.dragOverNodeKey, _.dropIndicatorRender]), Ue = Re.useMemo(function() {
    var ct = t.title, it = ct === void 0 ? E4e : ct, Ct = "".concat(_.prefixCls, "-node-content-wrapper"), ut;
    if (_.showIcon) {
      var ht = t.icon || _.icon;
      ut = ht ? /* @__PURE__ */ Re.createElement("span", {
        className: _e("".concat(_.prefixCls, "-iconEle"), "".concat(_.prefixCls, "-icon__customize"))
      }, typeof ht == "function" ? ht(t) : ht) : ye;
    } else _.loadData && N && (ut = ye);
    var ot;
    return typeof it == "function" ? ot = it(j) : _.titleRender ? ot = _.titleRender(j) : ot = it, /* @__PURE__ */ Re.createElement("span", {
      ref: Q,
      title: typeof it == "string" ? it : "",
      className: _e(Ct, "".concat(Ct, "-").concat(Oe || "normal"), ge({}, "".concat(_.prefixCls, "-node-selected"), !H && (k || G))),
      onMouseEnter: ae,
      onMouseLeave: oe,
      onContextMenu: fe,
      onClick: ee,
      onDoubleClick: ne
    }, ut, /* @__PURE__ */ Re.createElement("span", {
      className: "".concat(_.prefixCls, "-title")
    }, ot), je);
  }, [_.prefixCls, _.showIcon, t, _.icon, ye, _.titleRender, j, Oe, ae, oe, fe, ee, ne]), Fe = Zu(F, {
    aria: !0,
    data: !0
  }), tt = np(_.keyEntities, c) || {}, dt = tt.level, St = E[E.length - 1], mt = !H && be, Ot = _.draggingNodeKey === c, Rt = L !== void 0 ? {
    "aria-selected": !!L
  } : void 0;
  return /* @__PURE__ */ Re.createElement("div", vt({
    ref: D,
    role: "treeitem",
    "aria-expanded": w ? void 0 : P,
    className: _e(d, "".concat(_.prefixCls, "-treenode"), (i = {}, ge(ge(ge(ge(ge(ge(ge(ge(ge(ge(i, "".concat(_.prefixCls, "-treenode-disabled"), H), "".concat(_.prefixCls, "-treenode-switcher-").concat(P ? "open" : "close"), !w), "".concat(_.prefixCls, "-treenode-checkbox-checked"), M), "".concat(_.prefixCls, "-treenode-checkbox-indeterminate"), T), "".concat(_.prefixCls, "-treenode-selected"), k), "".concat(_.prefixCls, "-treenode-loading"), N), "".concat(_.prefixCls, "-treenode-active"), $), "".concat(_.prefixCls, "-treenode-leaf-last"), St), "".concat(_.prefixCls, "-treenode-draggable"), be), "dragging", Ot), ge(ge(ge(ge(ge(ge(ge(i, "drop-target", _.dropTargetKey === c), "drop-container", _.dropContainerKey === c), "drag-over", !H && p), "drag-over-gap-top", !H && g), "drag-over-gap-bottom", !H && b), "filter-node", (a = _.filterTreeNode) === null || a === void 0 ? void 0 : a.call(_, Yu(t))), "".concat(_.prefixCls, "-treenode-leaf"), Ne))),
    style: f,
    draggable: mt,
    onDragStart: mt ? me : void 0,
    onDragEnter: be ? De : void 0,
    onDragOver: be ? Me : void 0,
    onDragLeave: be ? ze : void 0,
    onDrop: be ? se : void 0,
    onDragEnd: be ? le : void 0,
    onMouseMove: I
  }, Rt, Fe), /* @__PURE__ */ Re.createElement(C4e, {
    prefixCls: _.prefixCls,
    level: dt,
    isStart: x,
    isEnd: E
  }), pe, Le(), Te, Ue);
};
Tx.isTreeNode = 1;
process.env.NODE_ENV !== "production" && (Tx.displayName = "TreeNode");
function Z1(e, t) {
  if (!e) return [];
  var r = e.slice(), a = r.indexOf(t);
  return a >= 0 && r.splice(a, 1), r;
}
function Gw(e, t) {
  var r = (e || []).slice();
  return r.indexOf(t) === -1 && r.push(t), r;
}
function Vj(e) {
  return e.split("-");
}
function P4e(e, t) {
  var r = [], a = np(t, e);
  function i() {
    var c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    c.forEach(function(d) {
      var f = d.key, p = d.children;
      r.push(f), i(p);
    });
  }
  return i(a.children), r;
}
function k4e(e) {
  if (e.parent) {
    var t = Vj(e.pos);
    return Number(t[t.length - 1]) === e.parent.children.length - 1;
  }
  return !1;
}
function M4e(e) {
  var t = Vj(e.pos);
  return Number(t[t.length - 1]) === 0;
}
function rV(e, t, r, a, i, c, d, f, p, g) {
  var b, w = e.clientX, x = e.clientY, E = e.target.getBoundingClientRect(), P = E.top, k = E.height, M = (g === "rtl" ? -1 : 1) * ((i?.x || 0) - w), T = (M - 12) / a, N = p.filter(function(H) {
    var K;
    return (K = f[H]) === null || K === void 0 || (K = K.children) === null || K === void 0 ? void 0 : K.length;
  }), D = np(f, r.eventKey);
  if (x < P + k / 2) {
    var $ = d.findIndex(function(H) {
      return H.key === D.key;
    }), j = $ <= 0 ? 0 : $ - 1, I = d[j].key;
    D = np(f, I);
  }
  var L = D.key, F = D, _ = D.key, W = 0, Q = 0;
  if (!N.includes(L))
    for (var U = 0; U < T && k4e(D); U += 1)
      D = D.parent, Q += 1;
  var Y = t.data, G = D.node, J = !0;
  return M4e(D) && D.level === 0 && x < P + k / 2 && c({
    dragNode: Y,
    dropNode: G,
    dropPosition: -1
  }) && D.key === r.eventKey ? W = -1 : (F.children || []).length && N.includes(_) ? c({
    dragNode: Y,
    dropNode: G,
    dropPosition: 0
  }) ? W = 0 : J = !1 : Q === 0 ? T > -1.5 ? c({
    dragNode: Y,
    dropNode: G,
    dropPosition: 1
  }) ? W = 1 : J = !1 : c({
    dragNode: Y,
    dropNode: G,
    dropPosition: 0
  }) ? W = 0 : c({
    dragNode: Y,
    dropNode: G,
    dropPosition: 1
  }) ? W = 1 : J = !1 : c({
    dragNode: Y,
    dropNode: G,
    dropPosition: 1
  }) ? W = 1 : J = !1, {
    dropPosition: W,
    dropLevelOffset: Q,
    dropTargetKey: D.key,
    dropTargetPos: D.pos,
    dragOverNodeKey: _,
    dropContainerKey: W === 0 ? null : ((b = D.parent) === null || b === void 0 ? void 0 : b.key) || null,
    dropAllowed: J
  };
}
function aV(e, t) {
  if (e) {
    var r = t.multiple;
    return r ? e.slice() : e.length ? [e[0]] : e;
  }
}
function kR(e) {
  if (!e)
    return null;
  var t;
  if (Array.isArray(e))
    t = {
      checkedKeys: e,
      halfCheckedKeys: void 0
    };
  else if (Hn(e) === "object")
    t = {
      checkedKeys: e.checked || void 0,
      halfCheckedKeys: e.halfChecked || void 0
    };
  else
    return $n(!1, "`checkedKeys` is not an array or an object"), null;
  return t;
}
function ZD(e, t) {
  var r = /* @__PURE__ */ new Set();
  function a(i) {
    if (!r.has(i)) {
      var c = np(t, i);
      if (c) {
        r.add(i);
        var d = c.parent, f = c.node;
        f.disabled || d && a(d.key);
      }
    }
  }
  return (e || []).forEach(function(i) {
    a(i);
  }), Et(r);
}
const eb = {}, e$ = "SELECT_ALL", t$ = "SELECT_INVERT", n$ = "SELECT_NONE", oV = [], hZ = (e, t, r = []) => ((t || []).forEach((a) => {
  r.push(a), a && typeof a == "object" && e in a && hZ(e, a[e], r);
}), r), O4e = (e, t) => {
  const {
    preserveSelectedRowKeys: r,
    selectedRowKeys: a,
    defaultSelectedRowKeys: i,
    getCheckboxProps: c,
    getTitleCheckboxProps: d,
    onChange: f,
    onSelect: p,
    onSelectAll: g,
    onSelectInvert: b,
    onSelectNone: w,
    onSelectMultiple: x,
    columnWidth: E,
    type: P,
    selections: k,
    fixed: M,
    renderCell: T,
    hideSelectAll: N,
    checkStrictly: D = !0
  } = t || {}, {
    prefixCls: $,
    data: j,
    pageData: I,
    getRecordByKey: L,
    getRowKey: F,
    expandType: _,
    childrenColumnName: W,
    locale: Q,
    getPopupContainer: U
  } = e, Y = To("Table"), [G, J] = xde((se) => se), [H, K] = ll(a || i || oV, {
    value: a
  }), X = S.useRef(/* @__PURE__ */ new Map()), te = Cn((se) => {
    if (r) {
      const Ae = /* @__PURE__ */ new Map();
      se.forEach((we) => {
        let Ne = L(we);
        !Ne && X.current.has(we) && (Ne = X.current.get(we)), Ae.set(we, Ne);
      }), X.current = Ae;
    }
  }, [L, r]);
  S.useEffect(() => {
    te(H);
  }, [H]);
  const ie = mn(() => hZ(W, I), [W, I]), {
    keyEntities: ee
  } = mn(() => {
    if (D)
      return {
        keyEntities: null
      };
    let se = j;
    if (r) {
      const Ae = new Set(ie.map((Ne, pe) => F(Ne, pe))), we = Array.from(X.current).reduce((Ne, [pe, Qe]) => Ae.has(pe) ? Ne : Ne.concat(Qe), []);
      se = [].concat(Et(se), Et(we));
    }
    return Rj(se, {
      externalGetKey: F,
      childrenPropName: W
    });
  }, [j, F, D, W, r, ie]), ne = mn(() => {
    const se = /* @__PURE__ */ new Map();
    return ie.forEach((Ae, we) => {
      const Ne = F(Ae, we), pe = (c ? c(Ae) : null) || {};
      se.set(Ne, pe), process.env.NODE_ENV !== "production" && Y(!("checked" in pe || "defaultChecked" in pe), "usage", "Do not set `checked` or `defaultChecked` in `getCheckboxProps`. Please use `selectedRowKeys` instead.");
    }), se;
  }, [ie, F, c]), ae = Cn((se) => {
    const Ae = F(se);
    let we;
    return ne.has(Ae) ? we = ne.get(F(se)) : we = c ? c(se) : void 0, !!we?.disabled;
  }, [ne, F]), [oe, fe] = mn(() => {
    if (D)
      return [H || [], []];
    const {
      checkedKeys: se,
      halfCheckedKeys: Ae
    } = ix(H, !0, ee, ae);
    return [se || [], Ae];
  }, [H, D, ee, ae]), be = mn(() => {
    const se = P === "radio" ? oe.slice(0, 1) : oe;
    return new Set(se);
  }, [oe, P]), me = mn(() => P === "radio" ? /* @__PURE__ */ new Set() : new Set(fe), [fe, P]);
  S.useEffect(() => {
    t || K(oV);
  }, [!!t]);
  const De = Cn((se, Ae) => {
    let we, Ne;
    te(se), r ? (we = se, Ne = se.map((pe) => X.current.get(pe))) : (we = [], Ne = [], se.forEach((pe) => {
      const Qe = L(pe);
      Qe !== void 0 && (we.push(pe), Ne.push(Qe));
    })), K(we), f?.(we, Ne, {
      type: Ae
    });
  }, [K, L, f, r]), Me = Cn((se, Ae, we, Ne) => {
    if (p) {
      const pe = we.map((Qe) => L(Qe));
      p(L(se), Ae, pe, Ne);
    }
    De(we, "single");
  }, [p, L, De]), ze = mn(() => !k || N ? null : (k === !0 ? [e$, t$, n$] : k).map((Ae) => Ae === e$ ? {
    key: "all",
    text: Q.selectionAll,
    onSelect() {
      De(j.map((we, Ne) => F(we, Ne)).filter((we) => {
        const Ne = ne.get(we);
        return !Ne?.disabled || be.has(we);
      }), "all");
    }
  } : Ae === t$ ? {
    key: "invert",
    text: Q.selectInvert,
    onSelect() {
      const we = new Set(be);
      I.forEach((pe, Qe) => {
        const Le = F(pe, Qe), Te = ne.get(Le);
        Te?.disabled || (we.has(Le) ? we.delete(Le) : we.add(Le));
      });
      const Ne = Array.from(we);
      b && (Y.deprecated(!1, "onSelectInvert", "onChange"), b(Ne)), De(Ne, "invert");
    }
  } : Ae === n$ ? {
    key: "none",
    text: Q.selectNone,
    onSelect() {
      w?.(), De(Array.from(be).filter((we) => {
        const Ne = ne.get(we);
        return Ne?.disabled;
      }), "none");
    }
  } : Ae).map((Ae) => Object.assign(Object.assign({}, Ae), {
    onSelect: (...we) => {
      var Ne, pe;
      (pe = Ae.onSelect) === null || pe === void 0 || (Ne = pe).call.apply(Ne, [Ae].concat(we)), J(null);
    }
  })), [k, be, I, F, b, De]);
  return [Cn((se) => {
    var Ae;
    if (!t)
      return process.env.NODE_ENV !== "production" && Y(!se.includes(eb), "usage", "`rowSelection` is not config but `SELECTION_COLUMN` exists in the `columns`."), se.filter((ct) => ct !== eb);
    let we = Et(se);
    const Ne = new Set(be), pe = ie.map(F).filter((ct) => !ne.get(ct).disabled), Qe = pe.every((ct) => Ne.has(ct)), Le = pe.some((ct) => Ne.has(ct)), Te = () => {
      const ct = [];
      Qe ? pe.forEach((Ct) => {
        Ne.delete(Ct), ct.push(Ct);
      }) : pe.forEach((Ct) => {
        Ne.has(Ct) || (Ne.add(Ct), ct.push(Ct));
      });
      const it = Array.from(Ne);
      g?.(!Qe, it.map((Ct) => L(Ct)), ct.map((Ct) => L(Ct))), De(it, "all"), J(null);
    };
    let Oe, ye;
    if (P !== "radio") {
      let ct;
      if (ze) {
        const st = {
          getPopupContainer: U,
          items: ze.map((pt, bt) => {
            const {
              key: Nt,
              text: $t,
              onSelect: Pt
            } = pt;
            return {
              key: Nt ?? bt,
              onClick: () => {
                Pt?.(pe);
              },
              label: $t
            };
          })
        };
        ct = /* @__PURE__ */ S.createElement("div", {
          className: `${$}-selection-extra`
        }, /* @__PURE__ */ S.createElement(gM, {
          menu: st,
          getPopupContainer: U
        }, /* @__PURE__ */ S.createElement("span", null, /* @__PURE__ */ S.createElement(tj, null))));
      }
      const it = ie.map((st, pt) => {
        const bt = F(st, pt), Nt = ne.get(bt) || {};
        return Object.assign({
          checked: Ne.has(bt)
        }, Nt);
      }).filter(({
        disabled: st
      }) => st), Ct = !!it.length && it.length === ie.length, ut = Ct && it.every(({
        checked: st
      }) => st), ht = Ct && it.some(({
        checked: st
      }) => st), ot = d?.() || {}, {
        onChange: at,
        disabled: ft
      } = ot;
      ye = /* @__PURE__ */ S.createElement(t3, Object.assign({
        "aria-label": ct ? "Custom selection" : "Select all"
      }, ot, {
        checked: Ct ? ut : !!ie.length && Qe,
        indeterminate: Ct ? !ut && ht : !Qe && Le,
        onChange: (st) => {
          Te(), at?.(st);
        },
        disabled: ft ?? (ie.length === 0 || Ct),
        skipGroup: !0
      })), Oe = !N && /* @__PURE__ */ S.createElement("div", {
        className: `${$}-selection`
      }, ye, ct);
    }
    let je;
    P === "radio" ? je = (ct, it, Ct) => {
      const ut = F(it, Ct), ht = Ne.has(ut), ot = ne.get(ut);
      return {
        node: /* @__PURE__ */ S.createElement(i7, Object.assign({}, ot, {
          checked: ht,
          onClick: (at) => {
            var ft;
            at.stopPropagation(), (ft = ot?.onClick) === null || ft === void 0 || ft.call(ot, at);
          },
          onChange: (at) => {
            var ft;
            Ne.has(ut) || Me(ut, !0, [ut], at.nativeEvent), (ft = ot?.onChange) === null || ft === void 0 || ft.call(ot, at);
          }
        })),
        checked: ht
      };
    } : je = (ct, it, Ct) => {
      var ut;
      const ht = F(it, Ct), ot = Ne.has(ht), at = me.has(ht), ft = ne.get(ht);
      let st;
      return _ === "nest" ? (st = at, process.env.NODE_ENV !== "production" && Y(typeof ft?.indeterminate != "boolean", "usage", "set `indeterminate` using `rowSelection.getCheckboxProps` is not allowed with tree structured dataSource.")) : st = (ut = ft?.indeterminate) !== null && ut !== void 0 ? ut : at, {
        node: /* @__PURE__ */ S.createElement(t3, Object.assign({}, ft, {
          indeterminate: st,
          checked: ot,
          skipGroup: !0,
          onClick: (pt) => {
            var bt;
            pt.stopPropagation(), (bt = ft?.onClick) === null || bt === void 0 || bt.call(ft, pt);
          },
          onChange: (pt) => {
            var bt;
            const {
              nativeEvent: Nt
            } = pt, {
              shiftKey: $t
            } = Nt, Pt = pe.indexOf(ht), hn = oe.some((an) => pe.includes(an));
            if ($t && D && hn) {
              const an = G(Pt, pe, Ne), jn = Array.from(Ne);
              x?.(!ot, jn.map((xn) => L(xn)), an.map((xn) => L(xn))), De(jn, "multiple");
            } else {
              const an = oe;
              if (D) {
                const jn = ot ? Z1(an, ht) : Gw(an, ht);
                Me(ht, !ot, jn, Nt);
              } else {
                const jn = ix([].concat(Et(an), [ht]), !0, ee, ae), {
                  checkedKeys: xn,
                  halfCheckedKeys: Ut
                } = jn;
                let pn = xn;
                if (ot) {
                  const wn = new Set(xn);
                  wn.delete(ht), pn = ix(Array.from(wn), {
                    halfCheckedKeys: Ut
                  }, ee, ae).checkedKeys;
                }
                Me(ht, !ot, pn, Nt);
              }
            }
            J(ot ? null : Pt), (bt = ft?.onChange) === null || bt === void 0 || bt.call(ft, pt);
          }
        })),
        checked: ot
      };
    };
    const Ue = (ct, it, Ct) => {
      const {
        node: ut,
        checked: ht
      } = je(ct, it, Ct);
      return T ? T(ht, it, Ct, ut) : ut;
    };
    if (!we.includes(eb))
      if (we.findIndex((ct) => {
        var it;
        return ((it = ct[pE]) === null || it === void 0 ? void 0 : it.columnType) === "EXPAND_COLUMN";
      }) === 0) {
        const [ct, ...it] = we;
        we = [ct, eb].concat(Et(it));
      } else
        we = [eb].concat(Et(we));
    const Fe = we.indexOf(eb);
    process.env.NODE_ENV !== "production" && Y(we.filter((ct) => ct === eb).length <= 1, "usage", "Multiple `SELECTION_COLUMN` exist in `columns`."), we = we.filter((ct, it) => ct !== eb || it === Fe);
    const tt = we[Fe - 1], dt = we[Fe + 1];
    let St = M;
    St === void 0 && (dt?.fixed !== void 0 ? St = dt.fixed : tt?.fixed !== void 0 && (St = tt.fixed)), St && tt && ((Ae = tt[pE]) === null || Ae === void 0 ? void 0 : Ae.columnType) === "EXPAND_COLUMN" && tt.fixed === void 0 && (tt.fixed = St);
    const mt = _e(`${$}-selection-col`, {
      [`${$}-selection-col-with-dropdown`]: k && P === "checkbox"
    }), Ot = () => t?.columnTitle ? typeof t.columnTitle == "function" ? t.columnTitle(ye) : t.columnTitle : Oe, Rt = {
      fixed: St,
      width: E,
      className: `${$}-selection-column`,
      title: Ot(),
      render: Ue,
      onCell: t.onCell,
      align: t.align,
      [pE]: {
        className: mt
      }
    };
    return we.map((ct) => ct === eb ? Rt : ct);
  }, [F, ie, t, oe, be, me, E, ze, _, ne, x, Me, ae]), be];
};
function T4e(e) {
  return (t) => {
    const {
      prefixCls: r,
      onExpand: a,
      record: i,
      expanded: c,
      expandable: d
    } = t, f = `${r}-row-expand-icon`;
    return /* @__PURE__ */ S.createElement("button", {
      type: "button",
      onClick: (p) => {
        a(i, p), p.stopPropagation();
      },
      className: _e(f, {
        [`${f}-spaced`]: !d,
        [`${f}-expanded`]: d && c,
        [`${f}-collapsed`]: d && !c
      }),
      "aria-label": c ? e.collapse : e.expand,
      "aria-expanded": c
    });
  };
}
function R4e(e) {
  return (r, a) => {
    const i = r.querySelector(`.${e}-container`);
    let c = a;
    if (i) {
      const d = getComputedStyle(i), f = Number.parseInt(d.borderLeftWidth, 10), p = Number.parseInt(d.borderRightWidth, 10);
      c = a - f - p;
    }
    return c;
  };
}
const XS = (e, t) => "key" in e && e.key !== void 0 && e.key !== null ? e.key : e.dataIndex ? Array.isArray(e.dataIndex) ? e.dataIndex.join(".") : e.dataIndex : t;
function t6(e, t) {
  return t ? `${t}-${e}` : `${e}`;
}
const wM = (e, t) => typeof e == "function" ? e(t) : e, A4e = (e, t) => {
  const r = wM(e, t);
  return Object.prototype.toString.call(r) === "[object Object]" ? "" : r;
};
var N4e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V642H349v196zm531.1-684H143.9c-24.5 0-39.8 26.7-27.5 48l221.3 376h348.8l221.3-376c12.1-21.3-3.2-48-27.7-48z" } }] }, name: "filter", theme: "filled" }, D4e = function(t, r) {
  return /* @__PURE__ */ S.createElement(Ao, vt({}, t, {
    ref: r,
    icon: N4e
  }));
}, pZ = /* @__PURE__ */ S.forwardRef(D4e);
process.env.NODE_ENV !== "production" && (pZ.displayName = "FilterFilled");
var gZ = function(t) {
  var r = t.dropPosition, a = t.dropLevelOffset, i = t.indent, c = {
    pointerEvents: "none",
    position: "absolute",
    right: 0,
    backgroundColor: "red",
    height: 2
  };
  switch (r) {
    case -1:
      c.top = 0, c.left = -a * i;
      break;
    case 1:
      c.bottom = 0, c.left = -a * i;
      break;
    case 0:
      c.bottom = 0, c.left = i;
      break;
  }
  return /* @__PURE__ */ Re.createElement("div", {
    style: c
  });
};
process.env.NODE_ENV !== "production" && (gZ.displayName = "DropIndicator");
function vZ(e) {
  if (e == null) throw new TypeError("Cannot destructure " + e);
}
function $4e(e, t) {
  var r = S.useState(!1), a = qe(r, 2), i = a[0], c = a[1];
  Da(function() {
    if (i)
      return e(), function() {
        t();
      };
  }, [i]), Da(function() {
    return c(!0), function() {
      c(!1);
    };
  }, []);
}
var z4e = ["className", "style", "motion", "motionNodes", "motionType", "onMotionStart", "onMotionEnd", "active", "treeNodeRequiredProps"], bZ = /* @__PURE__ */ S.forwardRef(function(e, t) {
  var r = e.className, a = e.style, i = e.motion, c = e.motionNodes, d = e.motionType, f = e.onMotionStart, p = e.onMotionEnd, g = e.active, b = e.treeNodeRequiredProps, w = xr(e, z4e), x = S.useState(!0), E = qe(x, 2), P = E[0], k = E[1], M = S.useContext(Wj), T = M.prefixCls, N = c && d !== "hide";
  Da(function() {
    c && N !== P && k(N);
  }, [c]);
  var D = function() {
    c && f();
  }, $ = S.useRef(!1), j = function() {
    c && !$.current && ($.current = !0, p());
  };
  $4e(D, j);
  var I = function(F) {
    N === F && j();
  };
  return c ? /* @__PURE__ */ S.createElement(N0, vt({
    ref: t,
    visible: P
  }, i, {
    motionAppear: d === "show",
    onVisibleChanged: I
  }), function(L, F) {
    var _ = L.className, W = L.style;
    return /* @__PURE__ */ S.createElement("div", {
      ref: F,
      className: _e("".concat(T, "-treenode-motion"), _),
      style: W
    }, c.map(function(Q) {
      var U = Object.assign({}, (vZ(Q.data), Q.data)), Y = Q.title, G = Q.key, J = Q.isStart, H = Q.isEnd;
      delete U.children;
      var K = hE(G, b);
      return /* @__PURE__ */ S.createElement(Tx, vt({}, U, K, {
        title: Y,
        active: g,
        data: Q.data,
        key: G,
        isStart: J,
        isEnd: H
      }));
    }));
  }) : /* @__PURE__ */ S.createElement(Tx, vt({
    domRef: t,
    className: r,
    style: a
  }, w, {
    active: g
  }));
});
process.env.NODE_ENV !== "production" && (bZ.displayName = "MotionTreeNode");
function j4e() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], r = e.length, a = t.length;
  if (Math.abs(r - a) !== 1)
    return {
      add: !1,
      key: null
    };
  function i(c, d) {
    var f = /* @__PURE__ */ new Map();
    c.forEach(function(g) {
      f.set(g, !0);
    });
    var p = d.filter(function(g) {
      return !f.has(g);
    });
    return p.length === 1 ? p[0] : null;
  }
  return r < a ? {
    add: !0,
    key: i(e, t)
  } : {
    add: !1,
    key: i(t, e)
  };
}
function iV(e, t, r) {
  var a = e.findIndex(function(f) {
    return f.key === r;
  }), i = e[a + 1], c = t.findIndex(function(f) {
    return f.key === r;
  });
  if (i) {
    var d = t.findIndex(function(f) {
      return f.key === i.key;
    });
    return t.slice(c + 1, d);
  }
  return t.slice(c + 1);
}
var I4e = ["prefixCls", "data", "selectable", "checkable", "expandedKeys", "selectedKeys", "checkedKeys", "loadedKeys", "loadingKeys", "halfCheckedKeys", "keyEntities", "disabled", "dragging", "dragOverNodeKey", "dropPosition", "motion", "height", "itemHeight", "virtual", "scrollWidth", "focusable", "activeItem", "focused", "tabIndex", "onKeyDown", "onFocus", "onBlur", "onActiveChange", "onListChangeStart", "onListChangeEnd"], lV = {
  width: 0,
  height: 0,
  display: "flex",
  overflow: "hidden",
  opacity: 0,
  border: 0,
  padding: 0,
  margin: 0
}, L4e = function() {
}, n3 = "RC_TREE_MOTION_".concat(Math.random()), r$ = {
  key: n3
}, yZ = {
  key: n3,
  level: 0,
  index: 0,
  pos: "0",
  node: r$,
  nodes: [r$]
}, sV = {
  parent: null,
  children: [],
  pos: yZ.pos,
  data: r$,
  title: null,
  key: n3,
  /** Hold empty list here since we do not use it */
  isStart: [],
  isEnd: []
};
function uV(e, t, r, a) {
  return t === !1 || !r ? e : e.slice(0, Math.ceil(r / a) + 1);
}
function cV(e) {
  var t = e.key, r = e.pos;
  return l7(t, r);
}
function H4e(e) {
  for (var t = String(e.data.key), r = e; r.parent; )
    r = r.parent, t = "".concat(r.data.key, " > ").concat(t);
  return t;
}
var wZ = /* @__PURE__ */ S.forwardRef(function(e, t) {
  var r = e.prefixCls, a = e.data;
  e.selectable, e.checkable;
  var i = e.expandedKeys, c = e.selectedKeys, d = e.checkedKeys, f = e.loadedKeys, p = e.loadingKeys, g = e.halfCheckedKeys, b = e.keyEntities, w = e.disabled, x = e.dragging, E = e.dragOverNodeKey, P = e.dropPosition, k = e.motion, M = e.height, T = e.itemHeight, N = e.virtual, D = e.scrollWidth, $ = e.focusable, j = e.activeItem, I = e.focused, L = e.tabIndex, F = e.onKeyDown, _ = e.onFocus, W = e.onBlur, Q = e.onActiveChange, U = e.onListChangeStart, Y = e.onListChangeEnd, G = xr(e, I4e), J = S.useRef(null), H = S.useRef(null);
  S.useImperativeHandle(t, function() {
    return {
      scrollTo: function(je) {
        J.current.scrollTo(je);
      },
      getIndentWidth: function() {
        return H.current.offsetWidth;
      }
    };
  });
  var K = S.useState(i), X = qe(K, 2), te = X[0], ie = X[1], ee = S.useState(a), ne = qe(ee, 2), ae = ne[0], oe = ne[1], fe = S.useState(a), be = qe(fe, 2), me = be[0], De = be[1], Me = S.useState([]), ze = qe(Me, 2), le = ze[0], se = ze[1], Ae = S.useState(null), we = qe(Ae, 2), Ne = we[0], pe = we[1], Qe = S.useRef(a);
  Qe.current = a;
  function Le() {
    var ye = Qe.current;
    oe(ye), De(ye), se([]), pe(null), Y();
  }
  Da(function() {
    ie(i);
    var ye = j4e(te, i);
    if (ye.key !== null)
      if (ye.add) {
        var je = ae.findIndex(function(mt) {
          var Ot = mt.key;
          return Ot === ye.key;
        }), Ue = uV(iV(ae, a, ye.key), N, M, T), Fe = ae.slice();
        Fe.splice(je + 1, 0, sV), De(Fe), se(Ue), pe("show");
      } else {
        var tt = a.findIndex(function(mt) {
          var Ot = mt.key;
          return Ot === ye.key;
        }), dt = uV(iV(a, ae, ye.key), N, M, T), St = a.slice();
        St.splice(tt + 1, 0, sV), De(St), se(dt), pe("hide");
      }
    else ae !== a && (oe(a), De(a));
  }, [i, a]), S.useEffect(function() {
    x || Le();
  }, [x]);
  var Te = k ? me : a, Oe = {
    expandedKeys: i,
    selectedKeys: c,
    loadedKeys: f,
    loadingKeys: p,
    checkedKeys: d,
    halfCheckedKeys: g,
    dragOverNodeKey: E,
    dropPosition: P,
    keyEntities: b
  };
  return /* @__PURE__ */ S.createElement(S.Fragment, null, I && j && /* @__PURE__ */ S.createElement("span", {
    style: lV,
    "aria-live": "assertive"
  }, H4e(j)), /* @__PURE__ */ S.createElement("div", null, /* @__PURE__ */ S.createElement("input", {
    style: lV,
    disabled: $ === !1 || w,
    tabIndex: $ !== !1 ? L : null,
    onKeyDown: F,
    onFocus: _,
    onBlur: W,
    value: "",
    onChange: L4e,
    "aria-label": "for screen reader"
  })), /* @__PURE__ */ S.createElement("div", {
    className: "".concat(r, "-treenode"),
    "aria-hidden": !0,
    style: {
      position: "absolute",
      pointerEvents: "none",
      visibility: "hidden",
      height: 0,
      overflow: "hidden",
      border: 0,
      padding: 0
    }
  }, /* @__PURE__ */ S.createElement("div", {
    className: "".concat(r, "-indent")
  }, /* @__PURE__ */ S.createElement("div", {
    ref: H,
    className: "".concat(r, "-indent-unit")
  }))), /* @__PURE__ */ S.createElement(eM, vt({}, G, {
    data: Te,
    itemKey: cV,
    height: M,
    fullHeight: !1,
    virtual: N,
    itemHeight: T,
    scrollWidth: D,
    prefixCls: "".concat(r, "-list"),
    ref: J,
    role: "tree",
    onVisibleChange: function(je) {
      je.every(function(Ue) {
        return cV(Ue) !== n3;
      }) && Le();
    }
  }), function(ye) {
    var je = ye.pos, Ue = Object.assign({}, (vZ(ye.data), ye.data)), Fe = ye.title, tt = ye.key, dt = ye.isStart, St = ye.isEnd, mt = l7(tt, je);
    delete Ue.key, delete Ue.children;
    var Ot = hE(mt, Oe);
    return /* @__PURE__ */ S.createElement(bZ, vt({}, Ue, Ot, {
      title: Fe,
      active: !!j && tt === j.key,
      pos: je,
      data: ye.data,
      isStart: dt,
      isEnd: St,
      motion: k,
      motionNodes: tt === n3 ? le : null,
      motionType: Ne,
      onMotionStart: U,
      onMotionEnd: Le,
      treeNodeRequiredProps: Oe,
      onMouseMove: function() {
        Q(null);
      }
    }));
  }));
});
process.env.NODE_ENV !== "production" && (wZ.displayName = "NodeList");
var F4e = 10, _j = /* @__PURE__ */ (function(e) {
  pd(r, e);
  var t = B0(r);
  function r() {
    var a;
    Vi(this, r);
    for (var i = arguments.length, c = new Array(i), d = 0; d < i; d++)
      c[d] = arguments[d];
    return a = t.call.apply(t, [this].concat(c)), ge(bn(a), "destroyed", !1), ge(bn(a), "delayedDragEnterLogic", void 0), ge(bn(a), "loadingRetryTimes", {}), ge(bn(a), "state", {
      keyEntities: {},
      indent: null,
      selectedKeys: [],
      checkedKeys: [],
      halfCheckedKeys: [],
      loadedKeys: [],
      loadingKeys: [],
      expandedKeys: [],
      draggingNodeKey: null,
      dragChildrenKeys: [],
      // dropTargetKey is the key of abstract-drop-node
      // the abstract-drop-node is the real drop node when drag and drop
      // not the DOM drag over node
      dropTargetKey: null,
      dropPosition: null,
      // the drop position of abstract-drop-node, inside 0, top -1, bottom 1
      dropContainerKey: null,
      // the container key of abstract-drop-node if dropPosition is -1 or 1
      dropLevelOffset: null,
      // the drop level offset of abstract-drag-over-node
      dropTargetPos: null,
      // the pos of abstract-drop-node
      dropAllowed: !0,
      // if drop to abstract-drop-node is allowed
      // the abstract-drag-over-node
      // if mouse is on the bottom of top dom node or no the top of the bottom dom node
      // abstract-drag-over-node is the top node
      dragOverNodeKey: null,
      treeData: [],
      flattenNodes: [],
      focused: !1,
      activeKey: null,
      listChanging: !1,
      prevProps: null,
      fieldNames: Ox()
    }), ge(bn(a), "dragStartMousePosition", null), ge(bn(a), "dragNodeProps", null), ge(bn(a), "currentMouseOverDroppableNodeKey", null), ge(bn(a), "listRef", /* @__PURE__ */ S.createRef()), ge(bn(a), "onNodeDragStart", function(f, p) {
      var g = a.state, b = g.expandedKeys, w = g.keyEntities, x = a.props.onDragStart, E = p.eventKey;
      a.dragNodeProps = p, a.dragStartMousePosition = {
        x: f.clientX,
        y: f.clientY
      };
      var P = Z1(b, E);
      a.setState({
        draggingNodeKey: E,
        dragChildrenKeys: P4e(E, w),
        indent: a.listRef.current.getIndentWidth()
      }), a.setExpandedKeys(P), window.addEventListener("dragend", a.onWindowDragEnd), x?.({
        event: f,
        node: Yu(p)
      });
    }), ge(bn(a), "onNodeDragEnter", function(f, p) {
      var g = a.state, b = g.expandedKeys, w = g.keyEntities, x = g.dragChildrenKeys, E = g.flattenNodes, P = g.indent, k = a.props, M = k.onDragEnter, T = k.onExpand, N = k.allowDrop, D = k.direction, $ = p.pos, j = p.eventKey;
      if (a.currentMouseOverDroppableNodeKey !== j && (a.currentMouseOverDroppableNodeKey = j), !a.dragNodeProps) {
        a.resetDragState();
        return;
      }
      var I = rV(f, a.dragNodeProps, p, P, a.dragStartMousePosition, N, E, w, b, D), L = I.dropPosition, F = I.dropLevelOffset, _ = I.dropTargetKey, W = I.dropContainerKey, Q = I.dropTargetPos, U = I.dropAllowed, Y = I.dragOverNodeKey;
      if (
        // don't allow drop inside its children
        x.includes(_) || // don't allow drop when drop is not allowed caculated by calcDropPosition
        !U
      ) {
        a.resetDragState();
        return;
      }
      if (a.delayedDragEnterLogic || (a.delayedDragEnterLogic = {}), Object.keys(a.delayedDragEnterLogic).forEach(function(G) {
        clearTimeout(a.delayedDragEnterLogic[G]);
      }), a.dragNodeProps.eventKey !== p.eventKey && (f.persist(), a.delayedDragEnterLogic[$] = window.setTimeout(function() {
        if (a.state.draggingNodeKey !== null) {
          var G = Et(b), J = np(w, p.eventKey);
          J && (J.children || []).length && (G = Gw(b, p.eventKey)), a.props.hasOwnProperty("expandedKeys") || a.setExpandedKeys(G), T?.(G, {
            node: Yu(p),
            expanded: !0,
            nativeEvent: f.nativeEvent
          });
        }
      }, 800)), a.dragNodeProps.eventKey === _ && F === 0) {
        a.resetDragState();
        return;
      }
      a.setState({
        dragOverNodeKey: Y,
        dropPosition: L,
        dropLevelOffset: F,
        dropTargetKey: _,
        dropContainerKey: W,
        dropTargetPos: Q,
        dropAllowed: U
      }), M?.({
        event: f,
        node: Yu(p),
        expandedKeys: b
      });
    }), ge(bn(a), "onNodeDragOver", function(f, p) {
      var g = a.state, b = g.dragChildrenKeys, w = g.flattenNodes, x = g.keyEntities, E = g.expandedKeys, P = g.indent, k = a.props, M = k.onDragOver, T = k.allowDrop, N = k.direction;
      if (a.dragNodeProps) {
        var D = rV(f, a.dragNodeProps, p, P, a.dragStartMousePosition, T, w, x, E, N), $ = D.dropPosition, j = D.dropLevelOffset, I = D.dropTargetKey, L = D.dropContainerKey, F = D.dropTargetPos, _ = D.dropAllowed, W = D.dragOverNodeKey;
        b.includes(I) || !_ || (a.dragNodeProps.eventKey === I && j === 0 ? a.state.dropPosition === null && a.state.dropLevelOffset === null && a.state.dropTargetKey === null && a.state.dropContainerKey === null && a.state.dropTargetPos === null && a.state.dropAllowed === !1 && a.state.dragOverNodeKey === null || a.resetDragState() : $ === a.state.dropPosition && j === a.state.dropLevelOffset && I === a.state.dropTargetKey && L === a.state.dropContainerKey && F === a.state.dropTargetPos && _ === a.state.dropAllowed && W === a.state.dragOverNodeKey || a.setState({
          dropPosition: $,
          dropLevelOffset: j,
          dropTargetKey: I,
          dropContainerKey: L,
          dropTargetPos: F,
          dropAllowed: _,
          dragOverNodeKey: W
        }), M?.({
          event: f,
          node: Yu(p)
        }));
      }
    }), ge(bn(a), "onNodeDragLeave", function(f, p) {
      a.currentMouseOverDroppableNodeKey === p.eventKey && !f.currentTarget.contains(f.relatedTarget) && (a.resetDragState(), a.currentMouseOverDroppableNodeKey = null);
      var g = a.props.onDragLeave;
      g?.({
        event: f,
        node: Yu(p)
      });
    }), ge(bn(a), "onWindowDragEnd", function(f) {
      a.onNodeDragEnd(f, null, !0), window.removeEventListener("dragend", a.onWindowDragEnd);
    }), ge(bn(a), "onNodeDragEnd", function(f, p) {
      var g = a.props.onDragEnd;
      a.setState({
        dragOverNodeKey: null
      }), a.cleanDragState(), g?.({
        event: f,
        node: Yu(p)
      }), a.dragNodeProps = null, window.removeEventListener("dragend", a.onWindowDragEnd);
    }), ge(bn(a), "onNodeDrop", function(f, p) {
      var g, b = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, w = a.state, x = w.dragChildrenKeys, E = w.dropPosition, P = w.dropTargetKey, k = w.dropTargetPos, M = w.dropAllowed;
      if (M) {
        var T = a.props.onDrop;
        if (a.setState({
          dragOverNodeKey: null
        }), a.cleanDragState(), P !== null) {
          var N = ce(ce({}, hE(P, a.getTreeNodeRequiredProps())), {}, {
            active: ((g = a.getActiveItem()) === null || g === void 0 ? void 0 : g.key) === P,
            data: np(a.state.keyEntities, P).node
          }), D = x.includes(P);
          $n(!D, "Can not drop to dragNode's children node. This is a bug of rc-tree. Please report an issue.");
          var $ = Vj(k), j = {
            event: f,
            node: Yu(N),
            dragNode: a.dragNodeProps ? Yu(a.dragNodeProps) : null,
            dragNodesKeys: [a.dragNodeProps.eventKey].concat(x),
            dropToGap: E !== 0,
            dropPosition: E + Number($[$.length - 1])
          };
          b || T?.(j), a.dragNodeProps = null;
        }
      }
    }), ge(bn(a), "cleanDragState", function() {
      var f = a.state.draggingNodeKey;
      f !== null && a.setState({
        draggingNodeKey: null,
        dropPosition: null,
        dropContainerKey: null,
        dropTargetKey: null,
        dropLevelOffset: null,
        dropAllowed: !0,
        dragOverNodeKey: null
      }), a.dragStartMousePosition = null, a.currentMouseOverDroppableNodeKey = null;
    }), ge(bn(a), "triggerExpandActionExpand", function(f, p) {
      var g = a.state, b = g.expandedKeys, w = g.flattenNodes, x = p.expanded, E = p.key, P = p.isLeaf;
      if (!(P || f.shiftKey || f.metaKey || f.ctrlKey)) {
        var k = w.filter(function(T) {
          return T.key === E;
        })[0], M = Yu(ce(ce({}, hE(E, a.getTreeNodeRequiredProps())), {}, {
          data: k.data
        }));
        a.setExpandedKeys(x ? Z1(b, E) : Gw(b, E)), a.onNodeExpand(f, M);
      }
    }), ge(bn(a), "onNodeClick", function(f, p) {
      var g = a.props, b = g.onClick, w = g.expandAction;
      w === "click" && a.triggerExpandActionExpand(f, p), b?.(f, p);
    }), ge(bn(a), "onNodeDoubleClick", function(f, p) {
      var g = a.props, b = g.onDoubleClick, w = g.expandAction;
      w === "doubleClick" && a.triggerExpandActionExpand(f, p), b?.(f, p);
    }), ge(bn(a), "onNodeSelect", function(f, p) {
      var g = a.state.selectedKeys, b = a.state, w = b.keyEntities, x = b.fieldNames, E = a.props, P = E.onSelect, k = E.multiple, M = p.selected, T = p[x.key], N = !M;
      N ? k ? g = Gw(g, T) : g = [T] : g = Z1(g, T);
      var D = g.map(function($) {
        var j = np(w, $);
        return j ? j.node : null;
      }).filter(Boolean);
      a.setUncontrolledState({
        selectedKeys: g
      }), P?.(g, {
        event: "select",
        selected: N,
        node: p,
        selectedNodes: D,
        nativeEvent: f.nativeEvent
      });
    }), ge(bn(a), "onNodeCheck", function(f, p, g) {
      var b = a.state, w = b.keyEntities, x = b.checkedKeys, E = b.halfCheckedKeys, P = a.props, k = P.checkStrictly, M = P.onCheck, T = p.key, N, D = {
        event: "check",
        node: p,
        checked: g,
        nativeEvent: f.nativeEvent
      };
      if (k) {
        var $ = g ? Gw(x, T) : Z1(x, T), j = Z1(E, T);
        N = {
          checked: $,
          halfChecked: j
        }, D.checkedNodes = $.map(function(Q) {
          return np(w, Q);
        }).filter(Boolean).map(function(Q) {
          return Q.node;
        }), a.setUncontrolledState({
          checkedKeys: $
        });
      } else {
        var I = ix([].concat(Et(x), [T]), !0, w), L = I.checkedKeys, F = I.halfCheckedKeys;
        if (!g) {
          var _ = new Set(L);
          _.delete(T);
          var W = ix(Array.from(_), {
            halfCheckedKeys: F
          }, w);
          L = W.checkedKeys, F = W.halfCheckedKeys;
        }
        N = L, D.checkedNodes = [], D.checkedNodesPositions = [], D.halfCheckedKeys = F, L.forEach(function(Q) {
          var U = np(w, Q);
          if (U) {
            var Y = U.node, G = U.pos;
            D.checkedNodes.push(Y), D.checkedNodesPositions.push({
              node: Y,
              pos: G
            });
          }
        }), a.setUncontrolledState({
          checkedKeys: L
        }, !1, {
          halfCheckedKeys: F
        });
      }
      M?.(N, D);
    }), ge(bn(a), "onNodeLoad", function(f) {
      var p, g = f.key, b = a.state.keyEntities, w = np(b, g);
      if (!(w != null && (p = w.children) !== null && p !== void 0 && p.length)) {
        var x = new Promise(function(E, P) {
          a.setState(function(k) {
            var M = k.loadedKeys, T = M === void 0 ? [] : M, N = k.loadingKeys, D = N === void 0 ? [] : N, $ = a.props, j = $.loadData, I = $.onLoad;
            if (!j || T.includes(g) || D.includes(g))
              return null;
            var L = j(f);
            return L.then(function() {
              var F = a.state.loadedKeys, _ = Gw(F, g);
              I?.(_, {
                event: "load",
                node: f
              }), a.setUncontrolledState({
                loadedKeys: _
              }), a.setState(function(W) {
                return {
                  loadingKeys: Z1(W.loadingKeys, g)
                };
              }), E();
            }).catch(function(F) {
              if (a.setState(function(W) {
                return {
                  loadingKeys: Z1(W.loadingKeys, g)
                };
              }), a.loadingRetryTimes[g] = (a.loadingRetryTimes[g] || 0) + 1, a.loadingRetryTimes[g] >= F4e) {
                var _ = a.state.loadedKeys;
                $n(!1, "Retry for `loadData` many times but still failed. No more retry."), a.setUncontrolledState({
                  loadedKeys: Gw(_, g)
                }), E();
              }
              P(F);
            }), {
              loadingKeys: Gw(D, g)
            };
          });
        });
        return x.catch(function() {
        }), x;
      }
    }), ge(bn(a), "onNodeMouseEnter", function(f, p) {
      var g = a.props.onMouseEnter;
      g?.({
        event: f,
        node: p
      });
    }), ge(bn(a), "onNodeMouseLeave", function(f, p) {
      var g = a.props.onMouseLeave;
      g?.({
        event: f,
        node: p
      });
    }), ge(bn(a), "onNodeContextMenu", function(f, p) {
      var g = a.props.onRightClick;
      g && (f.preventDefault(), g({
        event: f,
        node: p
      }));
    }), ge(bn(a), "onFocus", function() {
      var f = a.props.onFocus;
      a.setState({
        focused: !0
      });
      for (var p = arguments.length, g = new Array(p), b = 0; b < p; b++)
        g[b] = arguments[b];
      f?.apply(void 0, g);
    }), ge(bn(a), "onBlur", function() {
      var f = a.props.onBlur;
      a.setState({
        focused: !1
      }), a.onActiveChange(null);
      for (var p = arguments.length, g = new Array(p), b = 0; b < p; b++)
        g[b] = arguments[b];
      f?.apply(void 0, g);
    }), ge(bn(a), "getTreeNodeRequiredProps", function() {
      var f = a.state, p = f.expandedKeys, g = f.selectedKeys, b = f.loadedKeys, w = f.loadingKeys, x = f.checkedKeys, E = f.halfCheckedKeys, P = f.dragOverNodeKey, k = f.dropPosition, M = f.keyEntities;
      return {
        expandedKeys: p || [],
        selectedKeys: g || [],
        loadedKeys: b || [],
        loadingKeys: w || [],
        checkedKeys: x || [],
        halfCheckedKeys: E || [],
        dragOverNodeKey: P,
        dropPosition: k,
        keyEntities: M
      };
    }), ge(bn(a), "setExpandedKeys", function(f) {
      var p = a.state, g = p.treeData, b = p.fieldNames, w = SR(g, f, b);
      a.setUncontrolledState({
        expandedKeys: f,
        flattenNodes: w
      }, !0);
    }), ge(bn(a), "onNodeExpand", function(f, p) {
      var g = a.state.expandedKeys, b = a.state, w = b.listChanging, x = b.fieldNames, E = a.props, P = E.onExpand, k = E.loadData, M = p.expanded, T = p[x.key];
      if (!w) {
        var N = g.includes(T), D = !M;
        if ($n(M && N || !M && !N, "Expand state not sync with index check"), g = D ? Gw(g, T) : Z1(g, T), a.setExpandedKeys(g), P?.(g, {
          node: p,
          expanded: D,
          nativeEvent: f.nativeEvent
        }), D && k) {
          var $ = a.onNodeLoad(p);
          $ && $.then(function() {
            var j = SR(a.state.treeData, g, x);
            a.setUncontrolledState({
              flattenNodes: j
            });
          }).catch(function() {
            var j = a.state.expandedKeys, I = Z1(j, T);
            a.setExpandedKeys(I);
          });
        }
      }
    }), ge(bn(a), "onListChangeStart", function() {
      a.setUncontrolledState({
        listChanging: !0
      });
    }), ge(bn(a), "onListChangeEnd", function() {
      setTimeout(function() {
        a.setUncontrolledState({
          listChanging: !1
        });
      });
    }), ge(bn(a), "onActiveChange", function(f) {
      var p = a.state.activeKey, g = a.props, b = g.onActiveChange, w = g.itemScrollOffset, x = w === void 0 ? 0 : w;
      p !== f && (a.setState({
        activeKey: f
      }), f !== null && a.scrollTo({
        key: f,
        offset: x
      }), b?.(f));
    }), ge(bn(a), "getActiveItem", function() {
      var f = a.state, p = f.activeKey, g = f.flattenNodes;
      return p === null ? null : g.find(function(b) {
        var w = b.key;
        return w === p;
      }) || null;
    }), ge(bn(a), "offsetActiveKey", function(f) {
      var p = a.state, g = p.flattenNodes, b = p.activeKey, w = g.findIndex(function(P) {
        var k = P.key;
        return k === b;
      });
      w === -1 && f < 0 && (w = g.length), w = (w + f + g.length) % g.length;
      var x = g[w];
      if (x) {
        var E = x.key;
        a.onActiveChange(E);
      } else
        a.onActiveChange(null);
    }), ge(bn(a), "onKeyDown", function(f) {
      var p = a.state, g = p.activeKey, b = p.expandedKeys, w = p.checkedKeys, x = p.fieldNames, E = a.props, P = E.onKeyDown, k = E.checkable, M = E.selectable;
      switch (f.which) {
        case fn.UP: {
          a.offsetActiveKey(-1), f.preventDefault();
          break;
        }
        case fn.DOWN: {
          a.offsetActiveKey(1), f.preventDefault();
          break;
        }
      }
      var T = a.getActiveItem();
      if (T && T.data) {
        var N = a.getTreeNodeRequiredProps(), D = T.data.isLeaf === !1 || !!(T.data[x.children] || []).length, $ = Yu(ce(ce({}, hE(g, N)), {}, {
          data: T.data,
          active: !0
        }));
        switch (f.which) {
          // >>> Expand
          case fn.LEFT: {
            D && b.includes(g) ? a.onNodeExpand({}, $) : T.parent && a.onActiveChange(T.parent.key), f.preventDefault();
            break;
          }
          case fn.RIGHT: {
            D && !b.includes(g) ? a.onNodeExpand({}, $) : T.children && T.children.length && a.onActiveChange(T.children[0].key), f.preventDefault();
            break;
          }
          // Selection
          case fn.ENTER:
          case fn.SPACE: {
            k && !$.disabled && $.checkable !== !1 && !$.disableCheckbox ? a.onNodeCheck({}, $, !w.includes(g)) : !k && M && !$.disabled && $.selectable !== !1 && a.onNodeSelect({}, $);
            break;
          }
        }
      }
      P?.(f);
    }), ge(bn(a), "setUncontrolledState", function(f) {
      var p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, g = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      if (!a.destroyed) {
        var b = !1, w = !0, x = {};
        Object.keys(f).forEach(function(E) {
          if (a.props.hasOwnProperty(E)) {
            w = !1;
            return;
          }
          b = !0, x[E] = f[E];
        }), b && (!p || w) && a.setState(ce(ce({}, x), g));
      }
    }), ge(bn(a), "scrollTo", function(f) {
      a.listRef.current.scrollTo(f);
    }), a;
  }
  return _i(r, [{
    key: "componentDidMount",
    value: function() {
      this.destroyed = !1, this.onUpdated();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.onUpdated();
    }
  }, {
    key: "onUpdated",
    value: function() {
      var i = this.props, c = i.activeKey, d = i.itemScrollOffset, f = d === void 0 ? 0 : d;
      c !== void 0 && c !== this.state.activeKey && (this.setState({
        activeKey: c
      }), c !== null && this.scrollTo({
        key: c,
        offset: f
      }));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      window.removeEventListener("dragend", this.onWindowDragEnd), this.destroyed = !0;
    }
  }, {
    key: "resetDragState",
    value: function() {
      this.setState({
        dragOverNodeKey: null,
        dropPosition: null,
        dropLevelOffset: null,
        dropTargetKey: null,
        dropContainerKey: null,
        dropTargetPos: null,
        dropAllowed: !1
      });
    }
  }, {
    key: "render",
    value: function() {
      var i = this.state, c = i.focused, d = i.flattenNodes, f = i.keyEntities, p = i.draggingNodeKey, g = i.activeKey, b = i.dropLevelOffset, w = i.dropContainerKey, x = i.dropTargetKey, E = i.dropPosition, P = i.dragOverNodeKey, k = i.indent, M = this.props, T = M.prefixCls, N = M.className, D = M.style, $ = M.showLine, j = M.focusable, I = M.tabIndex, L = I === void 0 ? 0 : I, F = M.selectable, _ = M.showIcon, W = M.icon, Q = M.switcherIcon, U = M.draggable, Y = M.checkable, G = M.checkStrictly, J = M.disabled, H = M.motion, K = M.loadData, X = M.filterTreeNode, te = M.height, ie = M.itemHeight, ee = M.scrollWidth, ne = M.virtual, ae = M.titleRender, oe = M.dropIndicatorRender, fe = M.onContextMenu, be = M.onScroll, me = M.direction, De = M.rootClassName, Me = M.rootStyle, ze = Zu(this.props, {
        aria: !0,
        data: !0
      }), le;
      U && (Hn(U) === "object" ? le = U : typeof U == "function" ? le = {
        nodeDraggable: U
      } : le = {});
      var se = {
        prefixCls: T,
        selectable: F,
        showIcon: _,
        icon: W,
        switcherIcon: Q,
        draggable: le,
        draggingNodeKey: p,
        checkable: Y,
        checkStrictly: G,
        disabled: J,
        keyEntities: f,
        dropLevelOffset: b,
        dropContainerKey: w,
        dropTargetKey: x,
        dropPosition: E,
        dragOverNodeKey: P,
        indent: k,
        direction: me,
        dropIndicatorRender: oe,
        loadData: K,
        filterTreeNode: X,
        titleRender: ae,
        onNodeClick: this.onNodeClick,
        onNodeDoubleClick: this.onNodeDoubleClick,
        onNodeExpand: this.onNodeExpand,
        onNodeSelect: this.onNodeSelect,
        onNodeCheck: this.onNodeCheck,
        onNodeLoad: this.onNodeLoad,
        onNodeMouseEnter: this.onNodeMouseEnter,
        onNodeMouseLeave: this.onNodeMouseLeave,
        onNodeContextMenu: this.onNodeContextMenu,
        onNodeDragStart: this.onNodeDragStart,
        onNodeDragEnter: this.onNodeDragEnter,
        onNodeDragOver: this.onNodeDragOver,
        onNodeDragLeave: this.onNodeDragLeave,
        onNodeDragEnd: this.onNodeDragEnd,
        onNodeDrop: this.onNodeDrop
      };
      return /* @__PURE__ */ S.createElement(Wj.Provider, {
        value: se
      }, /* @__PURE__ */ S.createElement("div", {
        className: _e(T, N, De, ge(ge(ge({}, "".concat(T, "-show-line"), $), "".concat(T, "-focused"), c), "".concat(T, "-active-focused"), g !== null)),
        style: Me
      }, /* @__PURE__ */ S.createElement(wZ, vt({
        ref: this.listRef,
        prefixCls: T,
        style: D,
        data: d,
        disabled: J,
        selectable: F,
        checkable: !!Y,
        motion: H,
        dragging: p !== null,
        height: te,
        itemHeight: ie,
        virtual: ne,
        focusable: j,
        focused: c,
        tabIndex: L,
        activeItem: this.getActiveItem(),
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onKeyDown: this.onKeyDown,
        onActiveChange: this.onActiveChange,
        onListChangeStart: this.onListChangeStart,
        onListChangeEnd: this.onListChangeEnd,
        onContextMenu: fe,
        onScroll: be,
        scrollWidth: ee
      }, this.getTreeNodeRequiredProps(), ze))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(i, c) {
      var d = c.prevProps, f = {
        prevProps: i
      };
      function p(L) {
        return !d && i.hasOwnProperty(L) || d && d[L] !== i[L];
      }
      var g, b = c.fieldNames;
      if (p("fieldNames") && (b = Ox(i.fieldNames), f.fieldNames = b), p("treeData") ? g = i.treeData : p("children") && ($n(!1, "`children` of Tree is deprecated. Please use `treeData` instead."), g = nJ(i.children)), g) {
        f.treeData = g;
        var w = Rj(g, {
          fieldNames: b
        });
        f.keyEntities = ce(ge({}, n3, yZ), w.keyEntities), process.env.NODE_ENV !== "production" && Nye(g, b);
      }
      var x = f.keyEntities || c.keyEntities;
      if (p("expandedKeys") || d && p("autoExpandParent"))
        f.expandedKeys = i.autoExpandParent || !d && i.defaultExpandParent ? ZD(i.expandedKeys, x) : i.expandedKeys;
      else if (!d && i.defaultExpandAll) {
        var E = ce({}, x);
        delete E[n3];
        var P = [];
        Object.keys(E).forEach(function(L) {
          var F = E[L];
          F.children && F.children.length && P.push(F.key);
        }), f.expandedKeys = P;
      } else !d && i.defaultExpandedKeys && (f.expandedKeys = i.autoExpandParent || i.defaultExpandParent ? ZD(i.defaultExpandedKeys, x) : i.defaultExpandedKeys);
      if (f.expandedKeys || delete f.expandedKeys, g || f.expandedKeys) {
        var k = SR(g || c.treeData, f.expandedKeys || c.expandedKeys, b);
        f.flattenNodes = k;
      }
      if (i.selectable && (p("selectedKeys") ? f.selectedKeys = aV(i.selectedKeys, i) : !d && i.defaultSelectedKeys && (f.selectedKeys = aV(i.defaultSelectedKeys, i))), i.checkable) {
        var M;
        if (p("checkedKeys") ? M = kR(i.checkedKeys) || {} : !d && i.defaultCheckedKeys ? M = kR(i.defaultCheckedKeys) || {} : g && (M = kR(i.checkedKeys) || {
          checkedKeys: c.checkedKeys,
          halfCheckedKeys: c.halfCheckedKeys
        }), M) {
          var T = M, N = T.checkedKeys, D = N === void 0 ? [] : N, $ = T.halfCheckedKeys, j = $ === void 0 ? [] : $;
          if (!i.checkStrictly) {
            var I = ix(D, !0, x);
            D = I.checkedKeys, j = I.halfCheckedKeys;
          }
          f.checkedKeys = D, f.halfCheckedKeys = j;
        }
      }
      return p("loadedKeys") && (f.loadedKeys = i.loadedKeys), f;
    }
  }]), r;
})(S.Component);
ge(_j, "defaultProps", {
  prefixCls: "rc-tree",
  showLine: !1,
  showIcon: !0,
  selectable: !0,
  multiple: !1,
  checkable: !1,
  disabled: !1,
  checkStrictly: !1,
  draggable: !1,
  defaultExpandParent: !0,
  autoExpandParent: !1,
  defaultExpandAll: !1,
  defaultExpandedKeys: [],
  defaultCheckedKeys: [],
  defaultSelectedKeys: [],
  dropIndicatorRender: gZ,
  allowDrop: function() {
    return !0;
  },
  expandAction: !1
});
ge(_j, "TreeNode", Tx);
var W4e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z" } }] }, name: "file", theme: "outlined" }, V4e = function(t, r) {
  return /* @__PURE__ */ S.createElement(Ao, vt({}, t, {
    ref: r,
    icon: W4e
  }));
}, Bj = /* @__PURE__ */ S.forwardRef(V4e);
process.env.NODE_ENV !== "production" && (Bj.displayName = "FileOutlined");
var _4e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 00-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z" } }] }, name: "folder-open", theme: "outlined" }, B4e = function(t, r) {
  return /* @__PURE__ */ S.createElement(Ao, vt({}, t, {
    ref: r,
    icon: _4e
  }));
}, SZ = /* @__PURE__ */ S.forwardRef(B4e);
process.env.NODE_ENV !== "production" && (SZ.displayName = "FolderOpenOutlined");
var U4e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z" } }] }, name: "folder", theme: "outlined" }, X4e = function(t, r) {
  return /* @__PURE__ */ S.createElement(Ao, vt({}, t, {
    ref: r,
    icon: U4e
  }));
}, CZ = /* @__PURE__ */ S.forwardRef(X4e);
process.env.NODE_ENV !== "production" && (CZ.displayName = "FolderOutlined");
var G4e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M300 276.5a56 56 0 1056-97 56 56 0 00-56 97zm0 284a56 56 0 1056-97 56 56 0 00-56 97zM640 228a56 56 0 10112 0 56 56 0 00-112 0zm0 284a56 56 0 10112 0 56 56 0 00-112 0zM300 844.5a56 56 0 1056-97 56 56 0 00-56 97zM640 796a56 56 0 10112 0 56 56 0 00-112 0z" } }] }, name: "holder", theme: "outlined" }, q4e = function(t, r) {
  return /* @__PURE__ */ S.createElement(Ao, vt({}, t, {
    ref: r,
    icon: G4e
  }));
}, xZ = /* @__PURE__ */ S.forwardRef(q4e);
process.env.NODE_ENV !== "production" && (xZ.displayName = "HolderOutlined");
const K4e = ({
  treeCls: e,
  treeNodeCls: t,
  directoryNodeSelectedBg: r,
  directoryNodeSelectedColor: a,
  motionDurationMid: i,
  borderRadius: c,
  controlItemBgHover: d
}) => ({
  [`${e}${e}-directory ${t}`]: {
    // >>> Title
    [`${e}-node-content-wrapper`]: {
      position: "static",
      [`&:has(${e}-drop-indicator)`]: {
        position: "relative"
      },
      [`> *:not(${e}-drop-indicator)`]: {
        position: "relative"
      },
      "&:hover": {
        background: "transparent"
      },
      // Expand interactive area to whole line
      "&:before": {
        position: "absolute",
        inset: 0,
        transition: `background-color ${i}`,
        content: '""',
        borderRadius: c
      },
      "&:hover:before": {
        background: d
      }
    },
    [`${e}-switcher, ${e}-checkbox, ${e}-draggable-icon`]: {
      zIndex: 1
    },
    // ============= Selected =============
    "&-selected": {
      background: r,
      borderRadius: c,
      [`${e}-switcher, ${e}-draggable-icon`]: {
        color: a
      },
      // >>> Title
      [`${e}-node-content-wrapper`]: {
        color: a,
        background: "transparent",
        "&, &:hover": {
          color: a
        },
        "&:before, &:hover:before": {
          background: r
        }
      }
    }
  }
}), Y4e = new bo("ant-tree-node-fx-do-not-use", {
  "0%": {
    opacity: 0
  },
  "100%": {
    opacity: 1
  }
}), Q4e = (e, t) => ({
  [`.${e}-switcher-icon`]: {
    display: "inline-block",
    fontSize: 10,
    verticalAlign: "baseline",
    svg: {
      transition: `transform ${t.motionDurationSlow}`
    }
  }
}), J4e = (e, t) => ({
  [`.${e}-drop-indicator`]: {
    position: "absolute",
    // it should displayed over the following node
    zIndex: 1,
    height: 2,
    backgroundColor: t.colorPrimary,
    borderRadius: 1,
    pointerEvents: "none",
    "&:after": {
      position: "absolute",
      top: -3,
      insetInlineStart: -6,
      width: 8,
      height: 8,
      backgroundColor: "transparent",
      border: `${Ye(t.lineWidthBold)} solid ${t.colorPrimary}`,
      borderRadius: "50%",
      content: '""'
    }
  }
}), Z4e = (e, t) => {
  const {
    treeCls: r,
    treeNodeCls: a,
    treeNodePadding: i,
    titleHeight: c,
    indentSize: d,
    nodeSelectedBg: f,
    nodeHoverBg: p,
    colorTextQuaternary: g,
    controlItemBgActiveDisabled: b
  } = t;
  return {
    [r]: Object.assign(Object.assign({}, dl(t)), {
      // fix https://github.com/ant-design/ant-design/issues/50316
      "--rc-virtual-list-scrollbar-bg": t.colorSplit,
      background: t.colorBgContainer,
      borderRadius: t.borderRadius,
      transition: `background-color ${t.motionDurationSlow}`,
      "&-rtl": {
        direction: "rtl"
      },
      [`&${r}-rtl ${r}-switcher_close ${r}-switcher-icon svg`]: {
        transform: "rotate(90deg)"
      },
      [`&-focused:not(:hover):not(${r}-active-focused)`]: _S(t),
      // =================== Virtual List ===================
      [`${r}-list-holder-inner`]: {
        alignItems: "flex-start"
      },
      [`&${r}-block-node`]: {
        [`${r}-list-holder-inner`]: {
          alignItems: "stretch",
          // >>> Title
          [`${r}-node-content-wrapper`]: {
            flex: "auto"
          },
          // >>> Drag
          [`${a}.dragging:after`]: {
            position: "absolute",
            inset: 0,
            border: `1px solid ${t.colorPrimary}`,
            opacity: 0,
            animationName: Y4e,
            animationDuration: t.motionDurationSlow,
            animationPlayState: "running",
            animationFillMode: "forwards",
            content: '""',
            pointerEvents: "none",
            borderRadius: t.borderRadius
          }
        }
      },
      // ===================== TreeNode =====================
      [a]: {
        display: "flex",
        alignItems: "flex-start",
        marginBottom: i,
        lineHeight: Ye(c),
        position: "relative",
        // 非常重要，避免 drop-indicator 在拖拽过程中闪烁
        "&:before": {
          content: '""',
          position: "absolute",
          zIndex: 1,
          insetInlineStart: 0,
          width: "100%",
          top: "100%",
          height: i
        },
        // Disabled
        [`&-disabled ${r}-node-content-wrapper`]: {
          color: t.colorTextDisabled,
          cursor: "not-allowed",
          "&:hover": {
            background: "transparent"
          }
        },
        [`${r}-checkbox-disabled + ${r}-node-selected,&${a}-disabled${a}-selected ${r}-node-content-wrapper`]: {
          backgroundColor: b
        },
        // we can not set pointer-events to none for checkbox in tree
        // ref: https://github.com/ant-design/ant-design/issues/39822#issuecomment-2605234058
        [`${r}-checkbox-disabled`]: {
          pointerEvents: "unset"
        },
        // not disable
        [`&:not(${a}-disabled)`]: {
          // >>> Title
          [`${r}-node-content-wrapper`]: {
            "&:hover": {
              color: t.nodeHoverColor
            }
          }
        },
        [`&-active ${r}-node-content-wrapper`]: {
          background: t.controlItemBgHover
        },
        [`&:not(${a}-disabled).filter-node ${r}-title`]: {
          color: t.colorPrimary,
          fontWeight: t.fontWeightStrong
        },
        "&-draggable": {
          cursor: "grab",
          [`${r}-draggable-icon`]: {
            // https://github.com/ant-design/ant-design/issues/41915
            flexShrink: 0,
            width: c,
            textAlign: "center",
            visibility: "visible",
            color: g
          },
          [`&${a}-disabled ${r}-draggable-icon`]: {
            visibility: "hidden"
          }
        }
      },
      // >>> Indent
      [`${r}-indent`]: {
        alignSelf: "stretch",
        whiteSpace: "nowrap",
        userSelect: "none",
        "&-unit": {
          display: "inline-block",
          width: d
        }
      },
      // >>> Drag Handler
      [`${r}-draggable-icon`]: {
        visibility: "hidden"
      },
      // Switcher / Checkbox
      [`${r}-switcher, ${r}-checkbox`]: {
        marginInlineEnd: t.calc(t.calc(c).sub(t.controlInteractiveSize)).div(2).equal()
      },
      // >>> Switcher
      [`${r}-switcher`]: Object.assign(Object.assign({}, Q4e(e, t)), {
        position: "relative",
        flex: "none",
        alignSelf: "stretch",
        width: c,
        textAlign: "center",
        cursor: "pointer",
        userSelect: "none",
        transition: `all ${t.motionDurationSlow}`,
        "&-noop": {
          cursor: "unset"
        },
        "&:before": {
          pointerEvents: "none",
          content: '""',
          width: c,
          height: c,
          position: "absolute",
          left: {
            _skip_check_: !0,
            value: 0
          },
          top: 0,
          borderRadius: t.borderRadius,
          transition: `all ${t.motionDurationSlow}`
        },
        [`&:not(${r}-switcher-noop):hover:before`]: {
          backgroundColor: t.colorBgTextHover
        },
        [`&_close ${r}-switcher-icon svg`]: {
          transform: "rotate(-90deg)"
        },
        "&-loading-icon": {
          color: t.colorPrimary
        },
        "&-leaf-line": {
          position: "relative",
          zIndex: 1,
          display: "inline-block",
          width: "100%",
          height: "100%",
          // https://github.com/ant-design/ant-design/issues/31884
          "&:before": {
            position: "absolute",
            top: 0,
            insetInlineEnd: t.calc(c).div(2).equal(),
            bottom: t.calc(i).mul(-1).equal(),
            marginInlineStart: -1,
            borderInlineEnd: `1px solid ${t.colorBorder}`,
            content: '""'
          },
          "&:after": {
            position: "absolute",
            width: t.calc(t.calc(c).div(2).equal()).mul(0.8).equal(),
            height: t.calc(c).div(2).equal(),
            borderBottom: `1px solid ${t.colorBorder}`,
            content: '""'
          }
        }
      }),
      // >>> Title
      // add `${treeCls}-checkbox + span` to cover checkbox `${checkboxCls} + span`
      [`${r}-node-content-wrapper`]: Object.assign(Object.assign({
        position: "relative",
        minHeight: c,
        paddingBlock: 0,
        paddingInline: t.paddingXS,
        background: "transparent",
        borderRadius: t.borderRadius,
        cursor: "pointer",
        transition: `all ${t.motionDurationMid}, border 0s, line-height 0s, box-shadow 0s`
      }, J4e(e, t)), {
        "&:hover": {
          backgroundColor: p
        },
        [`&${r}-node-selected`]: {
          color: t.nodeSelectedColor,
          backgroundColor: f
        },
        // Icon
        [`${r}-iconEle`]: {
          display: "inline-block",
          width: c,
          height: c,
          textAlign: "center",
          verticalAlign: "top",
          "&:empty": {
            display: "none"
          }
        }
      }),
      // https://github.com/ant-design/ant-design/issues/28217
      [`${r}-unselectable ${r}-node-content-wrapper:hover`]: {
        backgroundColor: "transparent"
      },
      [`${a}.drop-container > [draggable]`]: {
        boxShadow: `0 0 0 2px ${t.colorPrimary}`
      },
      // ==================== Show Line =====================
      "&-show-line": {
        // ================ Indent lines ================
        [`${r}-indent-unit`]: {
          position: "relative",
          height: "100%",
          "&:before": {
            position: "absolute",
            top: 0,
            insetInlineEnd: t.calc(c).div(2).equal(),
            bottom: t.calc(i).mul(-1).equal(),
            borderInlineEnd: `1px solid ${t.colorBorder}`,
            content: '""'
          },
          "&-end:before": {
            display: "none"
          }
        },
        // ============== Cover Background ==============
        [`${r}-switcher`]: {
          background: "transparent",
          "&-line-icon": {
            // https://github.com/ant-design/ant-design/issues/32813
            verticalAlign: "-0.15em"
          }
        }
      },
      [`${a}-leaf-last ${r}-switcher-leaf-line:before`]: {
        top: "auto !important",
        bottom: "auto !important",
        height: `${Ye(t.calc(c).div(2).equal())} !important`
      }
    })
  };
}, e3e = (e, t, r = !0) => {
  const a = `.${e}`, i = `${a}-treenode`, c = t.calc(t.paddingXS).div(2).equal(), d = lo(t, {
    treeCls: a,
    treeNodeCls: i,
    treeNodePadding: c
  });
  return [
    // Basic
    Z4e(e, d),
    // Directory
    r && K4e(d)
  ].filter(Boolean);
}, t3e = (e) => {
  const {
    controlHeightSM: t,
    controlItemBgHover: r,
    controlItemBgActive: a
  } = e, i = t;
  return {
    titleHeight: i,
    indentSize: i,
    nodeHoverBg: r,
    nodeHoverColor: e.colorText,
    nodeSelectedBg: a,
    nodeSelectedColor: e.colorText
  };
}, n3e = (e) => {
  const {
    colorTextLightSolid: t,
    colorPrimary: r
  } = e;
  return Object.assign(Object.assign({}, t3e(e)), {
    directoryNodeSelectedColor: t,
    directoryNodeSelectedBg: r
  });
}, r3e = Ii("Tree", (e, {
  prefixCls: t
}) => [{
  [e.componentCls]: aJ(`${t}-checkbox`, e)
}, e3e(t, e), Vz(e)], n3e), dV = 4;
function a3e(e) {
  const {
    dropPosition: t,
    dropLevelOffset: r,
    prefixCls: a,
    indent: i,
    direction: c = "ltr"
  } = e, d = c === "ltr" ? "left" : "right", f = c === "ltr" ? "right" : "left", p = {
    [d]: -r * i + dV,
    [f]: 0
  };
  switch (t) {
    case -1:
      p.top = -3;
      break;
    case 1:
      p.bottom = -3;
      break;
    default:
      p.bottom = -3, p[d] = i + dV;
      break;
  }
  return /* @__PURE__ */ Re.createElement("div", {
    style: p,
    className: `${a}-drop-indicator`
  });
}
var o3e = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" } }] }, name: "caret-down", theme: "filled" }, i3e = function(t, r) {
  return /* @__PURE__ */ S.createElement(Ao, vt({}, t, {
    ref: r,
    icon: o3e
  }));
}, EZ = /* @__PURE__ */ S.forwardRef(i3e);
process.env.NODE_ENV !== "production" && (EZ.displayName = "CaretDownFilled");
var l3e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }, { tag: "path", attrs: { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, name: "minus-square", theme: "outlined" }, s3e = function(t, r) {
  return /* @__PURE__ */ S.createElement(Ao, vt({}, t, {
    ref: r,
    icon: l3e
  }));
}, PZ = /* @__PURE__ */ S.forwardRef(s3e);
process.env.NODE_ENV !== "production" && (PZ.displayName = "MinusSquareOutlined");
var u3e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }, { tag: "path", attrs: { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, name: "plus-square", theme: "outlined" }, c3e = function(t, r) {
  return /* @__PURE__ */ S.createElement(Ao, vt({}, t, {
    ref: r,
    icon: u3e
  }));
}, kZ = /* @__PURE__ */ S.forwardRef(c3e);
process.env.NODE_ENV !== "production" && (kZ.displayName = "PlusSquareOutlined");
const d3e = (e) => {
  var t, r;
  const {
    prefixCls: a,
    switcherIcon: i,
    treeNodeProps: c,
    showLine: d,
    switcherLoadingIcon: f
  } = e, {
    isLeaf: p,
    expanded: g,
    loading: b
  } = c;
  if (b)
    return /* @__PURE__ */ S.isValidElement(f) ? f : /* @__PURE__ */ S.createElement(xx, {
      className: `${a}-switcher-loading-icon`
    });
  let w;
  if (d && typeof d == "object" && (w = d.showLeafIcon), p) {
    if (!d)
      return null;
    if (typeof w != "boolean" && w) {
      const P = typeof w == "function" ? w(c) : w, k = `${a}-switcher-line-custom-icon`;
      return /* @__PURE__ */ S.isValidElement(P) ? up(P, {
        className: _e((t = P.props) === null || t === void 0 ? void 0 : t.className, k)
      }) : P;
    }
    return w ? /* @__PURE__ */ S.createElement(Bj, {
      className: `${a}-switcher-line-icon`
    }) : /* @__PURE__ */ S.createElement("span", {
      className: `${a}-switcher-leaf-line`
    });
  }
  const x = `${a}-switcher-icon`, E = typeof i == "function" ? i(c) : i;
  return /* @__PURE__ */ S.isValidElement(E) ? up(E, {
    className: _e((r = E.props) === null || r === void 0 ? void 0 : r.className, x)
  }) : E !== void 0 ? E : d ? g ? /* @__PURE__ */ S.createElement(PZ, {
    className: `${a}-switcher-line-icon`
  }) : /* @__PURE__ */ S.createElement(kZ, {
    className: `${a}-switcher-line-icon`
  }) : /* @__PURE__ */ S.createElement(EZ, {
    className: x
  });
}, Uj = /* @__PURE__ */ Re.forwardRef((e, t) => {
  var r;
  const {
    getPrefixCls: a,
    direction: i,
    virtual: c,
    tree: d
  } = Re.useContext(Qr), {
    prefixCls: f,
    className: p,
    showIcon: g = !1,
    showLine: b,
    switcherIcon: w,
    switcherLoadingIcon: x,
    blockNode: E = !1,
    children: P,
    checkable: k = !1,
    selectable: M = !0,
    draggable: T,
    disabled: N,
    motion: D,
    style: $
  } = e, j = a("tree", f), I = a(), L = Re.useContext(A0), F = N ?? L, _ = D ?? Object.assign(Object.assign({}, Wz(I)), {
    motionAppear: !1
  }), W = Object.assign(Object.assign({}, e), {
    checkable: k,
    selectable: M,
    showIcon: g,
    motion: _,
    blockNode: E,
    disabled: F,
    showLine: !!b,
    dropIndicatorRender: a3e
  }), [Q, U, Y] = r3e(j), [, G] = Bf(), J = G.paddingXS / 2 + (((r = G.Tree) === null || r === void 0 ? void 0 : r.titleHeight) || G.controlHeightSM), H = Re.useMemo(() => {
    if (!T)
      return !1;
    let X = {};
    switch (typeof T) {
      case "function":
        X.nodeDraggable = T;
        break;
      case "object":
        X = Object.assign({}, T);
        break;
    }
    return X.icon !== !1 && (X.icon = X.icon || /* @__PURE__ */ Re.createElement(xZ, null)), X;
  }, [T]), K = (X) => /* @__PURE__ */ Re.createElement(d3e, {
    prefixCls: j,
    switcherIcon: w,
    switcherLoadingIcon: x,
    treeNodeProps: X,
    showLine: b
  });
  return Q(
    // @ts-ignore
    /* @__PURE__ */ Re.createElement(_j, Object.assign({
      itemHeight: J,
      ref: t,
      virtual: c
    }, W, {
      // newProps may contain style so declare style below it
      style: Object.assign(Object.assign({}, d?.style), $),
      prefixCls: j,
      className: _e({
        [`${j}-icon-hide`]: !g,
        [`${j}-block-node`]: E,
        [`${j}-unselectable`]: !M,
        [`${j}-rtl`]: i === "rtl",
        [`${j}-disabled`]: F
      }, d?.className, p, U, Y),
      direction: i,
      checkable: k && /* @__PURE__ */ Re.createElement("span", {
        className: `${j}-checkbox-inner`
      }),
      selectable: M,
      switcherIcon: K,
      draggable: H
    }), P)
  );
});
process.env.NODE_ENV !== "production" && (Uj.displayName = "Tree");
const fV = 0, MR = 1, mV = 2;
function Xj(e, t, r) {
  const {
    key: a,
    children: i
  } = r;
  function c(d) {
    const f = d[a], p = d[i];
    t(f, d) !== !1 && Xj(p || [], t, r);
  }
  e.forEach(c);
}
function f3e({
  treeData: e,
  expandedKeys: t,
  startKey: r,
  endKey: a,
  fieldNames: i
}) {
  const c = [];
  let d = fV;
  if (r && r === a)
    return [r];
  if (!r || !a)
    return [];
  function f(p) {
    return p === r || p === a;
  }
  return Xj(e, (p) => {
    if (d === mV)
      return !1;
    if (f(p)) {
      if (c.push(p), d === fV)
        d = MR;
      else if (d === MR)
        return d = mV, !1;
    } else d === MR && c.push(p);
    return t.includes(p);
  }, Ox(i)), c;
}
function OR(e, t, r) {
  const a = Et(t), i = [];
  return Xj(e, (c, d) => {
    const f = a.indexOf(c);
    return f !== -1 && (i.push(d), a.splice(f, 1)), !!a.length;
  }, Ox(r)), i;
}
var hV = function(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
    t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
};
function m3e(e) {
  const {
    isLeaf: t,
    expanded: r
  } = e;
  return t ? /* @__PURE__ */ S.createElement(Bj, null) : r ? /* @__PURE__ */ S.createElement(SZ, null) : /* @__PURE__ */ S.createElement(CZ, null);
}
function pV({
  treeData: e,
  children: t
}) {
  return e || nJ(t);
}
const h3e = (e, t) => {
  var {
    defaultExpandAll: r,
    defaultExpandParent: a,
    defaultExpandedKeys: i
  } = e, c = hV(e, ["defaultExpandAll", "defaultExpandParent", "defaultExpandedKeys"]);
  const d = S.useRef(null), f = S.useRef(null), p = () => {
    const {
      keyEntities: F
    } = Rj(pV(c), {
      fieldNames: c.fieldNames
    });
    let _;
    return r ? _ = Object.keys(F) : a ? _ = ZD(c.expandedKeys || i || [], F) : _ = c.expandedKeys || i || [], _;
  }, [g, b] = S.useState(c.selectedKeys || c.defaultSelectedKeys || []), [w, x] = S.useState(() => p());
  S.useEffect(() => {
    "selectedKeys" in c && b(c.selectedKeys);
  }, [c.selectedKeys]), S.useEffect(() => {
    "expandedKeys" in c && x(c.expandedKeys);
  }, [c.expandedKeys]);
  const E = (F, _) => {
    var W;
    return "expandedKeys" in c || x(F), (W = c.onExpand) === null || W === void 0 ? void 0 : W.call(c, F, _);
  }, P = (F, _) => {
    var W;
    const {
      multiple: Q,
      fieldNames: U
    } = c, {
      node: Y,
      nativeEvent: G
    } = _, {
      key: J = ""
    } = Y, H = pV(c), K = Object.assign(Object.assign({}, _), {
      selected: !0
    }), X = G?.ctrlKey || G?.metaKey, te = G?.shiftKey;
    let ie;
    Q && X ? (ie = F, d.current = J, f.current = ie, K.selectedNodes = OR(H, ie, U)) : Q && te ? (ie = Array.from(new Set([].concat(Et(f.current || []), Et(f3e({
      treeData: H,
      expandedKeys: w,
      startKey: J,
      endKey: d.current,
      fieldNames: U
    }))))), K.selectedNodes = OR(H, ie, U)) : (ie = [J], d.current = J, f.current = ie, K.selectedNodes = OR(H, ie, U)), (W = c.onSelect) === null || W === void 0 || W.call(c, ie, K), "selectedKeys" in c || b(ie);
  }, {
    getPrefixCls: k,
    direction: M
  } = S.useContext(Qr), {
    prefixCls: T,
    className: N,
    showIcon: D = !0,
    expandAction: $ = "click"
  } = c, j = hV(c, ["prefixCls", "className", "showIcon", "expandAction"]), I = k("tree", T), L = _e(`${I}-directory`, {
    [`${I}-directory-rtl`]: M === "rtl"
  }, N);
  return /* @__PURE__ */ S.createElement(Uj, Object.assign({
    icon: m3e,
    ref: t,
    blockNode: !0
  }, j, {
    showIcon: D,
    expandAction: $,
    prefixCls: I,
    className: L,
    expandedKeys: w,
    selectedKeys: g,
    onSelect: P,
    onExpand: E
  }));
}, MZ = /* @__PURE__ */ S.forwardRef(h3e);
process.env.NODE_ENV !== "production" && (MZ.displayName = "DirectoryTree");
const Gj = Uj;
Gj.DirectoryTree = MZ;
Gj.TreeNode = Tx;
const gV = (e) => {
  const {
    value: t,
    filterSearch: r,
    tablePrefixCls: a,
    locale: i,
    onChange: c
  } = e;
  return r ? /* @__PURE__ */ S.createElement("div", {
    className: `${a}-filter-dropdown-search`
  }, /* @__PURE__ */ S.createElement(lJ, {
    prefix: /* @__PURE__ */ S.createElement(nj, null),
    placeholder: i.filterSearchPlaceholder,
    onChange: c,
    value: t,
    // for skip min-width of input
    htmlSize: 1,
    className: `${a}-filter-dropdown-search-input`
  })) : null;
}, p3e = (e) => {
  const {
    keyCode: t
  } = e;
  t === fn.ENTER && e.stopPropagation();
}, OZ = /* @__PURE__ */ S.forwardRef((e, t) => /* @__PURE__ */ S.createElement("div", {
  className: e.className,
  onClick: (r) => r.stopPropagation(),
  onKeyDown: p3e,
  ref: t
}, e.children));
process.env.NODE_ENV !== "production" && (OZ.displayName = "FilterDropdownMenuWrapper");
function lx(e) {
  let t = [];
  return (e || []).forEach(({
    value: r,
    children: a
  }) => {
    t.push(r), a && (t = [].concat(Et(t), Et(lx(a))));
  }), t;
}
function g3e(e) {
  return e.some(({
    children: t
  }) => t);
}
function TZ(e, t) {
  return typeof t == "string" || typeof t == "number" ? t?.toString().toLowerCase().includes(e.trim().toLowerCase()) : !1;
}
function RZ({
  filters: e,
  prefixCls: t,
  filteredKeys: r,
  filterMultiple: a,
  searchValue: i,
  filterSearch: c
}) {
  return e.map((d, f) => {
    const p = String(d.value);
    if (d.children)
      return {
        key: p || f,
        label: d.text,
        popupClassName: `${t}-dropdown-submenu`,
        children: RZ({
          filters: d.children,
          prefixCls: t,
          filteredKeys: r,
          filterMultiple: a,
          searchValue: i,
          filterSearch: c
        })
      };
    const g = a ? t3 : i7, b = {
      key: d.value !== void 0 ? p : f,
      label: /* @__PURE__ */ S.createElement(S.Fragment, null, /* @__PURE__ */ S.createElement(g, {
        checked: r.includes(p)
      }), /* @__PURE__ */ S.createElement("span", null, d.text))
    };
    return i.trim() ? typeof c == "function" ? c(i, d) ? b : null : TZ(i, d.text) ? b : null : b;
  });
}
function TR(e) {
  return e || [];
}
const v3e = (e) => {
  var t, r, a, i;
  const {
    tablePrefixCls: c,
    prefixCls: d,
    column: f,
    dropdownPrefixCls: p,
    columnKey: g,
    filterOnClose: b,
    filterMultiple: w,
    filterMode: x = "menu",
    filterSearch: E = !1,
    filterState: P,
    triggerFilter: k,
    locale: M,
    children: T,
    getPopupContainer: N,
    rootClassName: D
  } = e, {
    filterResetToDefaultFilteredValue: $,
    defaultFilteredValue: j,
    filterDropdownProps: I = {},
    // Deprecated
    filterDropdownOpen: L,
    filterDropdownVisible: F,
    onFilterDropdownVisibleChange: _,
    onFilterDropdownOpenChange: W
  } = f, [Q, U] = S.useState(!1), Y = !!(P && (!((t = P.filteredKeys) === null || t === void 0) && t.length || P.forceFiltered)), G = (ye) => {
    var je;
    U(ye), (je = I.onOpenChange) === null || je === void 0 || je.call(I, ye), W?.(ye), _?.(ye);
  };
  if (process.env.NODE_ENV !== "production") {
    const ye = To("Table");
    [["filterDropdownOpen", "filterDropdownProps.open"], ["filterDropdownVisible", "filterDropdownProps.open"], ["onFilterDropdownOpenChange", "filterDropdownProps.onOpenChange"], ["onFilterDropdownVisibleChange", "filterDropdownProps.onOpenChange"]].forEach(([Ue, Fe]) => {
      ye.deprecated(!(Ue in f), Ue, Fe);
    }), ye.deprecated(!("filterCheckall" in M), "filterCheckall", "locale.filterCheckAll");
  }
  const J = (i = (a = (r = I.open) !== null && r !== void 0 ? r : L) !== null && a !== void 0 ? a : F) !== null && i !== void 0 ? i : Q, H = P?.filteredKeys, [K, X] = Mde(TR(H)), te = ({
    selectedKeys: ye
  }) => {
    X(ye);
  }, ie = (ye, {
    node: je,
    checked: Ue
  }) => {
    te(w ? {
      selectedKeys: ye
    } : {
      selectedKeys: Ue && je.key ? [je.key] : []
    });
  };
  S.useEffect(() => {
    Q && te({
      selectedKeys: TR(H)
    });
  }, [H]);
  const [ee, ne] = S.useState([]), ae = (ye) => {
    ne(ye);
  }, [oe, fe] = S.useState(""), be = (ye) => {
    const {
      value: je
    } = ye.target;
    fe(je);
  };
  S.useEffect(() => {
    Q || fe("");
  }, [Q]);
  const me = (ye) => {
    const je = ye?.length ? ye : null;
    if (je === null && (!P || !P.filteredKeys) || R0(je, P?.filteredKeys, !0))
      return null;
    k({
      column: f,
      key: g,
      filteredKeys: je
    });
  }, De = () => {
    G(!1), me(K());
  }, Me = ({
    confirm: ye,
    closeDropdown: je
  } = {
    confirm: !1,
    closeDropdown: !1
  }) => {
    ye && me([]), je && G(!1), fe(""), X($ ? (j || []).map((Ue) => String(Ue)) : []);
  }, ze = ({
    closeDropdown: ye
  } = {
    closeDropdown: !0
  }) => {
    ye && G(!1), me(K());
  }, le = (ye, je) => {
    je.source === "trigger" && (ye && H !== void 0 && X(TR(H)), G(ye), !ye && !f.filterDropdown && b && De());
  }, se = _e({
    [`${p}-menu-without-submenu`]: !g3e(f.filters || [])
  }), Ae = (ye) => {
    if (ye.target.checked) {
      const je = lx(f?.filters).map((Ue) => String(Ue));
      X(je);
    } else
      X([]);
  }, we = ({
    filters: ye
  }) => (ye || []).map((je, Ue) => {
    const Fe = String(je.value), tt = {
      title: je.text,
      key: je.value !== void 0 ? Fe : String(Ue)
    };
    return je.children && (tt.children = we({
      filters: je.children
    })), tt;
  }), Ne = (ye) => {
    var je;
    return Object.assign(Object.assign({}, ye), {
      text: ye.title,
      value: ye.key,
      children: ((je = ye.children) === null || je === void 0 ? void 0 : je.map((Ue) => Ne(Ue))) || []
    });
  };
  let pe;
  const {
    direction: Qe,
    renderEmpty: Le
  } = S.useContext(Qr);
  if (typeof f.filterDropdown == "function")
    pe = f.filterDropdown({
      prefixCls: `${p}-custom`,
      setSelectedKeys: (ye) => te({
        selectedKeys: ye
      }),
      selectedKeys: K(),
      confirm: ze,
      clearFilters: Me,
      filters: f.filters,
      visible: J,
      close: () => {
        G(!1);
      }
    });
  else if (f.filterDropdown)
    pe = f.filterDropdown;
  else {
    const ye = K() || [], je = () => {
      var Fe, tt;
      const dt = (Fe = Le?.("Table.filter")) !== null && Fe !== void 0 ? Fe : /* @__PURE__ */ S.createElement(ib, {
        image: ib.PRESENTED_IMAGE_SIMPLE,
        description: M.filterEmptyText,
        styles: {
          image: {
            height: 24
          }
        },
        style: {
          margin: 0,
          padding: "16px 0"
        }
      });
      if ((f.filters || []).length === 0)
        return dt;
      if (x === "tree")
        return /* @__PURE__ */ S.createElement(S.Fragment, null, /* @__PURE__ */ S.createElement(gV, {
          filterSearch: E,
          value: oe,
          onChange: be,
          tablePrefixCls: c,
          locale: M
        }), /* @__PURE__ */ S.createElement("div", {
          className: `${c}-filter-dropdown-tree`
        }, w ? /* @__PURE__ */ S.createElement(t3, {
          checked: ye.length === lx(f.filters).length,
          indeterminate: ye.length > 0 && ye.length < lx(f.filters).length,
          className: `${c}-filter-dropdown-checkall`,
          onChange: Ae
        }, (tt = M?.filterCheckall) !== null && tt !== void 0 ? tt : M?.filterCheckAll) : null, /* @__PURE__ */ S.createElement(Gj, {
          checkable: !0,
          selectable: !1,
          blockNode: !0,
          multiple: w,
          checkStrictly: !w,
          className: `${p}-menu`,
          onCheck: ie,
          checkedKeys: ye,
          selectedKeys: ye,
          showIcon: !1,
          treeData: we({
            filters: f.filters
          }),
          autoExpandParent: !0,
          defaultExpandAll: !0,
          filterTreeNode: oe.trim() ? (Ot) => typeof E == "function" ? E(oe, Ne(Ot)) : TZ(oe, Ot.title) : void 0
        })));
      const St = RZ({
        filters: f.filters || [],
        filterSearch: E,
        prefixCls: d,
        filteredKeys: K(),
        filterMultiple: w,
        searchValue: oe
      }), mt = St.every((Ot) => Ot === null);
      return /* @__PURE__ */ S.createElement(S.Fragment, null, /* @__PURE__ */ S.createElement(gV, {
        filterSearch: E,
        value: oe,
        onChange: be,
        tablePrefixCls: c,
        locale: M
      }), mt ? dt : /* @__PURE__ */ S.createElement(aC, {
        selectable: !0,
        multiple: w,
        prefixCls: `${p}-menu`,
        className: se,
        onSelect: te,
        onDeselect: te,
        selectedKeys: ye,
        getPopupContainer: N,
        openKeys: ee,
        onOpenChange: ae,
        items: St
      }));
    }, Ue = () => $ ? R0((j || []).map((Fe) => String(Fe)), ye, !0) : ye.length === 0;
    pe = /* @__PURE__ */ S.createElement(S.Fragment, null, je(), /* @__PURE__ */ S.createElement("div", {
      className: `${d}-dropdown-btns`
    }, /* @__PURE__ */ S.createElement(cp, {
      type: "link",
      size: "small",
      disabled: Ue(),
      onClick: () => Me()
    }, M.filterReset), /* @__PURE__ */ S.createElement(cp, {
      type: "primary",
      size: "small",
      onClick: De
    }, M.filterConfirm)));
  }
  f.filterDropdown && (pe = /* @__PURE__ */ S.createElement(QY, {
    selectable: void 0
  }, pe)), pe = /* @__PURE__ */ S.createElement(OZ, {
    className: `${d}-dropdown`
  }, pe);
  const Oe = Fk({
    trigger: ["click"],
    placement: Qe === "rtl" ? "bottomLeft" : "bottomRight",
    children: (() => {
      let ye;
      return typeof f.filterIcon == "function" ? ye = f.filterIcon(Y) : f.filterIcon ? ye = f.filterIcon : ye = /* @__PURE__ */ S.createElement(pZ, null), /* @__PURE__ */ S.createElement("span", {
        role: "button",
        tabIndex: -1,
        className: _e(`${d}-trigger`, {
          active: Y
        }),
        onClick: (je) => {
          je.stopPropagation();
        }
      }, ye);
    })(),
    getPopupContainer: N
  }, Object.assign(Object.assign({}, I), {
    rootClassName: _e(D, I.rootClassName),
    open: J,
    onOpenChange: le,
    popupRender: () => typeof I?.dropdownRender == "function" ? I.dropdownRender(pe) : pe
  }));
  return /* @__PURE__ */ S.createElement("div", {
    className: `${d}-column`
  }, /* @__PURE__ */ S.createElement("span", {
    className: `${c}-column-title`
  }, T), /* @__PURE__ */ S.createElement(gM, Object.assign({}, Oe)));
}, a$ = (e, t, r) => {
  let a = [];
  return (e || []).forEach((i, c) => {
    var d;
    const f = t6(c, r), p = i.filterDropdown !== void 0;
    if (i.filters || p || "onFilter" in i)
      if ("filteredValue" in i) {
        let g = i.filteredValue;
        p || (g = (d = g?.map(String)) !== null && d !== void 0 ? d : g), a.push({
          column: i,
          key: XS(i, f),
          filteredKeys: g,
          forceFiltered: i.filtered
        });
      } else
        a.push({
          column: i,
          key: XS(i, f),
          filteredKeys: t && i.defaultFilteredValue ? i.defaultFilteredValue : void 0,
          forceFiltered: i.filtered
        });
    "children" in i && (a = [].concat(Et(a), Et(a$(i.children, t, f))));
  }), a;
};
function AZ(e, t, r, a, i, c, d, f, p) {
  return r.map((g, b) => {
    const w = t6(b, f), {
      filterOnClose: x = !0,
      filterMultiple: E = !0,
      filterMode: P,
      filterSearch: k
    } = g;
    let M = g;
    if (M.filters || M.filterDropdown) {
      const T = XS(M, w), N = a.find(({
        key: D
      }) => T === D);
      M = Object.assign(Object.assign({}, M), {
        title: (D) => /* @__PURE__ */ S.createElement(v3e, {
          tablePrefixCls: e,
          prefixCls: `${e}-filter`,
          dropdownPrefixCls: t,
          column: M,
          columnKey: T,
          filterState: N,
          filterOnClose: x,
          filterMultiple: E,
          filterMode: P,
          filterSearch: k,
          triggerFilter: c,
          locale: i,
          getPopupContainer: d,
          rootClassName: p
        }, wM(g.title, D))
      });
    }
    return "children" in M && (M = Object.assign(Object.assign({}, M), {
      children: AZ(e, t, M.children, a, i, c, d, w, p)
    })), M;
  });
}
const vV = (e) => {
  const t = {};
  return e.forEach(({
    key: r,
    filteredKeys: a,
    column: i
  }) => {
    const c = r, {
      filters: d,
      filterDropdown: f
    } = i;
    if (f)
      t[c] = a || null;
    else if (Array.isArray(a)) {
      const p = lx(d);
      t[c] = p.filter((g) => a.includes(String(g)));
    } else
      t[c] = null;
  }), t;
}, o$ = (e, t, r) => t.reduce((i, c) => {
  const {
    column: {
      onFilter: d,
      filters: f
    },
    filteredKeys: p
  } = c;
  return d && p && p.length ? i.map((g) => Object.assign({}, g)).filter((g) => p.some((b) => {
    const w = lx(f), x = w.findIndex((P) => String(P) === String(b)), E = x !== -1 ? w[x] : b;
    return g[r] && (g[r] = o$(g[r], t, r)), d(E, g);
  })) : i;
}, e), NZ = (e) => e.flatMap((t) => "children" in t ? [t].concat(Et(NZ(t.children || []))) : [t]), b3e = (e) => {
  const {
    prefixCls: t,
    dropdownPrefixCls: r,
    mergedColumns: a,
    onFilterChange: i,
    getPopupContainer: c,
    locale: d,
    rootClassName: f
  } = e, p = To("Table"), g = S.useMemo(() => NZ(a || []), [a]), [b, w] = S.useState(() => a$(g, !0)), x = S.useMemo(() => {
    const M = a$(g, !1);
    if (M.length === 0)
      return M;
    let T = !0, N = !0;
    if (M.forEach(({
      filteredKeys: D
    }) => {
      D !== void 0 ? T = !1 : N = !1;
    }), T) {
      const D = (g || []).map(($, j) => XS($, t6(j)));
      return b.filter(({
        key: $
      }) => D.includes($)).map(($) => {
        const j = g[D.indexOf($.key)];
        return Object.assign(Object.assign({}, $), {
          column: Object.assign(Object.assign({}, $.column), j),
          forceFiltered: j.filtered
        });
      });
    }
    return process.env.NODE_ENV !== "production" && p(N, "usage", "Columns should all contain `filteredValue` or not contain `filteredValue`."), M;
  }, [g, b]), E = S.useMemo(() => vV(x), [x]), P = (M) => {
    const T = x.filter(({
      key: N
    }) => N !== M.key);
    T.push(M), w(T), i(vV(T), T);
  };
  return [(M) => AZ(t, r, M, x, d, P, c, void 0, f), x, E];
}, y3e = (e, t, r) => {
  const a = S.useRef({});
  function i(c) {
    var d;
    if (!a.current || a.current.data !== e || a.current.childrenColumnName !== t || a.current.getRowKey !== r) {
      let p = function(g) {
        g.forEach((b, w) => {
          const x = r(b, w);
          f.set(x, b), b && typeof b == "object" && t in b && p(b[t] || []);
        });
      };
      const f = /* @__PURE__ */ new Map();
      p(e), a.current = {
        data: e,
        childrenColumnName: t,
        kvMap: f,
        getRowKey: r
      };
    }
    return (d = a.current.kvMap) === null || d === void 0 ? void 0 : d.get(c);
  }
  return [i];
};
var w3e = function(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
    t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
};
const DZ = 10;
function S3e(e, t) {
  const r = {
    current: e.current,
    pageSize: e.pageSize
  };
  return Object.keys(t && typeof t == "object" ? t : {}).forEach((i) => {
    const c = e[i];
    typeof c != "function" && (r[i] = c);
  }), r;
}
function C3e(e, t, r) {
  const a = r && typeof r == "object" ? r : {}, {
    total: i = 0
  } = a, c = w3e(a, ["total"]), [d, f] = Wn(() => ({
    current: "defaultCurrent" in c ? c.defaultCurrent : 1,
    pageSize: "defaultPageSize" in c ? c.defaultPageSize : DZ
  })), p = Fk(d, c, {
    total: i > 0 ? i : e
  }), g = Math.ceil((i || e) / p.pageSize);
  p.current > g && (p.current = g || 1);
  const b = (x, E) => {
    f({
      current: x ?? 1,
      pageSize: E || p.pageSize
    });
  }, w = (x, E) => {
    var P;
    r && ((P = r.onChange) === null || P === void 0 || P.call(r, x, E)), b(x, E), t(x, E || p?.pageSize);
  };
  return r === !1 ? [{}, () => {
  }] : [Object.assign(Object.assign({}, p), {
    onChange: w
  }), b];
}
var x3e = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" } }] }, name: "caret-down", theme: "outlined" }, E3e = function(t, r) {
  return /* @__PURE__ */ S.createElement(Ao, vt({}, t, {
    ref: r,
    icon: x3e
  }));
}, $Z = /* @__PURE__ */ S.forwardRef(E3e);
process.env.NODE_ENV !== "production" && ($Z.displayName = "CaretDownOutlined");
var P3e = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z" } }] }, name: "caret-up", theme: "outlined" }, k3e = function(t, r) {
  return /* @__PURE__ */ S.createElement(Ao, vt({}, t, {
    ref: r,
    icon: P3e
  }));
}, zZ = /* @__PURE__ */ S.forwardRef(k3e);
process.env.NODE_ENV !== "production" && (zZ.displayName = "CaretUpOutlined");
const pk = "ascend", RR = "descend", r9 = (e) => typeof e.sorter == "object" && typeof e.sorter.multiple == "number" ? e.sorter.multiple : !1, bV = (e) => typeof e == "function" ? e : e && typeof e == "object" && e.compare ? e.compare : !1, M3e = (e, t) => t ? e[e.indexOf(t) + 1] : e[0], i$ = (e, t, r) => {
  let a = [];
  const i = (c, d) => {
    a.push({
      column: c,
      key: XS(c, d),
      multiplePriority: r9(c),
      sortOrder: c.sortOrder
    });
  };
  return (e || []).forEach((c, d) => {
    const f = t6(d, r);
    c.children ? ("sortOrder" in c && i(c, f), a = [].concat(Et(a), Et(i$(c.children, t, f)))) : c.sorter && ("sortOrder" in c ? i(c, f) : t && c.defaultSortOrder && a.push({
      column: c,
      key: XS(c, f),
      multiplePriority: r9(c),
      sortOrder: c.defaultSortOrder
    }));
  }), a;
}, jZ = (e, t, r, a, i, c, d, f) => (t || []).map((g, b) => {
  const w = t6(b, f);
  let x = g;
  if (x.sorter) {
    const E = x.sortDirections || i, P = x.showSorterTooltip === void 0 ? d : x.showSorterTooltip, k = XS(x, w), M = r.find(({
      key: _
    }) => _ === k), T = M ? M.sortOrder : null, N = M3e(E, T);
    let D;
    if (g.sortIcon)
      D = g.sortIcon({
        sortOrder: T
      });
    else {
      const _ = E.includes(pk) && /* @__PURE__ */ S.createElement(zZ, {
        className: _e(`${e}-column-sorter-up`, {
          active: T === pk
        })
      }), W = E.includes(RR) && /* @__PURE__ */ S.createElement($Z, {
        className: _e(`${e}-column-sorter-down`, {
          active: T === RR
        })
      });
      D = /* @__PURE__ */ S.createElement("span", {
        className: _e(`${e}-column-sorter`, {
          [`${e}-column-sorter-full`]: !!(_ && W)
        })
      }, /* @__PURE__ */ S.createElement("span", {
        className: `${e}-column-sorter-inner`,
        "aria-hidden": "true"
      }, _, W));
    }
    const {
      cancelSort: $,
      triggerAsc: j,
      triggerDesc: I
    } = c || {};
    let L = $;
    N === RR ? L = I : N === pk && (L = j);
    const F = typeof P == "object" ? Object.assign({
      title: L
    }, P) : {
      title: L
    };
    x = Object.assign(Object.assign({}, x), {
      className: _e(x.className, {
        [`${e}-column-sort`]: T
      }),
      title: (_) => {
        const W = `${e}-column-sorters`, Q = /* @__PURE__ */ S.createElement("span", {
          className: `${e}-column-title`
        }, wM(g.title, _)), U = /* @__PURE__ */ S.createElement("div", {
          className: W
        }, Q, D);
        return P ? typeof P != "boolean" && P?.target === "sorter-icon" ? /* @__PURE__ */ S.createElement("div", {
          className: _e(W, `${W}-tooltip-target-sorter`)
        }, Q, /* @__PURE__ */ S.createElement(U1, Object.assign({}, F), D)) : /* @__PURE__ */ S.createElement(U1, Object.assign({}, F), U) : U;
      },
      onHeaderCell: (_) => {
        var W;
        const Q = ((W = g.onHeaderCell) === null || W === void 0 ? void 0 : W.call(g, _)) || {}, U = Q.onClick, Y = Q.onKeyDown;
        Q.onClick = (H) => {
          a({
            column: g,
            key: k,
            sortOrder: N,
            multiplePriority: r9(g)
          }), U?.(H);
        }, Q.onKeyDown = (H) => {
          H.keyCode === fn.ENTER && (a({
            column: g,
            key: k,
            sortOrder: N,
            multiplePriority: r9(g)
          }), Y?.(H));
        };
        const G = A4e(g.title, {}), J = G?.toString();
        return T && (Q["aria-sort"] = T === "ascend" ? "ascending" : "descending"), Q["aria-label"] = J || "", Q.className = _e(Q.className, `${e}-column-has-sorters`), Q.tabIndex = 0, g.ellipsis && (Q.title = (G ?? "").toString()), Q;
      }
    });
  }
  return "children" in x && (x = Object.assign(Object.assign({}, x), {
    children: jZ(e, x.children, r, a, i, c, d, w)
  })), x;
}), yV = (e) => {
  const {
    column: t,
    sortOrder: r
  } = e;
  return {
    column: t,
    order: r,
    field: t.dataIndex,
    columnKey: t.key
  };
}, wV = (e) => {
  const t = e.filter(({
    sortOrder: r
  }) => r).map(yV);
  if (t.length === 0 && e.length) {
    const r = e.length - 1;
    return Object.assign(Object.assign({}, yV(e[r])), {
      column: void 0,
      order: void 0,
      field: void 0,
      columnKey: void 0
    });
  }
  return t.length <= 1 ? t[0] || {} : t;
}, l$ = (e, t, r) => {
  const a = t.slice().sort((d, f) => f.multiplePriority - d.multiplePriority), i = e.slice(), c = a.filter(({
    column: {
      sorter: d
    },
    sortOrder: f
  }) => bV(d) && f);
  return c.length ? i.sort((d, f) => {
    for (let p = 0; p < c.length; p += 1) {
      const g = c[p], {
        column: {
          sorter: b
        },
        sortOrder: w
      } = g, x = bV(b);
      if (x && w) {
        const E = x(d, f, w);
        if (E !== 0)
          return w === pk ? E : -E;
      }
    }
    return 0;
  }).map((d) => {
    const f = d[r];
    return f ? Object.assign(Object.assign({}, d), {
      [r]: l$(f, t, r)
    }) : d;
  }) : i;
}, O3e = (e) => {
  const {
    prefixCls: t,
    mergedColumns: r,
    sortDirections: a,
    tableLocale: i,
    showSorterTooltip: c,
    onSorterChange: d
  } = e, [f, p] = S.useState(() => i$(r, !0)), g = (k, M) => {
    const T = [];
    return k.forEach((N, D) => {
      const $ = t6(D, M);
      if (T.push(XS(N, $)), Array.isArray(N.children)) {
        const j = g(N.children, $);
        T.push.apply(T, Et(j));
      }
    }), T;
  }, b = S.useMemo(() => {
    let k = !0;
    const M = i$(r, !1);
    if (!M.length) {
      const $ = g(r);
      return f.filter(({
        key: j
      }) => $.includes(j));
    }
    const T = [];
    function N($) {
      k ? T.push($) : T.push(Object.assign(Object.assign({}, $), {
        sortOrder: null
      }));
    }
    let D = null;
    return M.forEach(($) => {
      D === null ? (N($), $.sortOrder && ($.multiplePriority === !1 ? k = !1 : D = !0)) : (D && $.multiplePriority !== !1 || (k = !1), N($));
    }), T;
  }, [r, f]), w = S.useMemo(() => {
    var k, M;
    const T = b.map(({
      column: N,
      sortOrder: D
    }) => ({
      column: N,
      order: D
    }));
    return {
      sortColumns: T,
      // Legacy
      sortColumn: (k = T[0]) === null || k === void 0 ? void 0 : k.column,
      sortOrder: (M = T[0]) === null || M === void 0 ? void 0 : M.order
    };
  }, [b]), x = (k) => {
    let M;
    k.multiplePriority === !1 || !b.length || b[0].multiplePriority === !1 ? M = [k] : M = [].concat(Et(b.filter(({
      key: T
    }) => T !== k.key)), [k]), p(M), d(wV(M), M);
  };
  return [(k) => jZ(t, k, b, x, a, i, c), b, w, () => wV(b)];
}, IZ = (e, t) => e.map((a) => {
  const i = Object.assign({}, a);
  return i.title = wM(a.title, t), "children" in i && (i.children = IZ(i.children, t)), i;
}), T3e = (e) => [S.useCallback((r) => IZ(r, e), [e])], R3e = uZ((e, t) => {
  const {
    _renderTimes: r
  } = e, {
    _renderTimes: a
  } = t;
  return r !== a;
}), A3e = mZ((e, t) => {
  const {
    _renderTimes: r
  } = e, {
    _renderTimes: a
  } = t;
  return r !== a;
}), N3e = (e) => {
  const {
    componentCls: t,
    lineWidth: r,
    lineType: a,
    tableBorderColor: i,
    tableHeaderBg: c,
    tablePaddingVertical: d,
    tablePaddingHorizontal: f,
    calc: p
  } = e, g = `${Ye(r)} ${a} ${i}`, b = (w, x, E) => ({
    [`&${t}-${w}`]: {
      [`> ${t}-container`]: {
        [`> ${t}-content, > ${t}-body`]: {
          "\n            > table > tbody > tr > th,\n            > table > tbody > tr > td\n          ": {
            [`> ${t}-expanded-row-fixed`]: {
              margin: `${Ye(p(x).mul(-1).equal())}
              ${Ye(p(p(E).add(r)).mul(-1).equal())}`
            }
          }
        }
      }
    }
  });
  return {
    [`${t}-wrapper`]: {
      [`${t}${t}-bordered`]: Object.assign(Object.assign(Object.assign({
        // ============================ Title =============================
        [`> ${t}-title`]: {
          border: g,
          borderBottom: 0
        },
        // ============================ Content ============================
        [`> ${t}-container`]: {
          borderInlineStart: g,
          borderTop: g,
          [`
            > ${t}-content,
            > ${t}-header,
            > ${t}-body,
            > ${t}-summary
          `]: {
            "> table": {
              // ============================= Cell =============================
              "\n                > thead > tr > th,\n                > thead > tr > td,\n                > tbody > tr > th,\n                > tbody > tr > td,\n                > tfoot > tr > th,\n                > tfoot > tr > td\n              ": {
                borderInlineEnd: g
              },
              // ============================ Header ============================
              "> thead": {
                "> tr:not(:last-child) > th": {
                  borderBottom: g
                },
                "> tr > th::before": {
                  backgroundColor: "transparent !important"
                }
              },
              // Fixed right should provides additional border
              "\n                > thead > tr,\n                > tbody > tr,\n                > tfoot > tr\n              ": {
                [`> ${t}-cell-fix-right-first::after`]: {
                  borderInlineEnd: g
                }
              },
              // ========================== Expandable ==========================
              "\n                > tbody > tr > th,\n                > tbody > tr > td\n              ": {
                [`> ${t}-expanded-row-fixed`]: {
                  margin: `${Ye(p(d).mul(-1).equal())} ${Ye(p(p(f).add(r)).mul(-1).equal())}`,
                  "&::after": {
                    position: "absolute",
                    top: 0,
                    insetInlineEnd: r,
                    bottom: 0,
                    borderInlineEnd: g,
                    content: '""'
                  }
                }
              }
            }
          }
        },
        // ============================ Scroll ============================
        [`&${t}-scroll-horizontal`]: {
          [`> ${t}-container > ${t}-body`]: {
            "> table > tbody": {
              [`
                > tr${t}-expanded-row,
                > tr${t}-placeholder
              `]: {
                "> th, > td": {
                  borderInlineEnd: 0
                }
              }
            }
          }
        }
      }, b("middle", e.tablePaddingVerticalMiddle, e.tablePaddingHorizontalMiddle)), b("small", e.tablePaddingVerticalSmall, e.tablePaddingHorizontalSmall)), {
        // ============================ Footer ============================
        [`> ${t}-footer`]: {
          border: g,
          borderTop: 0
        }
      }),
      // ============================ Nested ============================
      [`${t}-cell`]: {
        [`${t}-container:first-child`]: {
          // :first-child to avoid the case when bordered and title is set
          borderTop: 0
        },
        // https://github.com/ant-design/ant-design/issues/35577
        "&-scrollbar:not([rowspan])": {
          boxShadow: `0 ${Ye(r)} 0 ${Ye(r)} ${c}`
        }
      },
      [`${t}-bordered ${t}-cell-scrollbar`]: {
        borderInlineEnd: g
      }
    }
  };
}, D3e = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-wrapper`]: {
      [`${t}-cell-ellipsis`]: Object.assign(Object.assign({}, VS), {
        wordBreak: "keep-all",
        // Fixed first or last should special process
        [`
          &${t}-cell-fix-left-last,
          &${t}-cell-fix-right-first
        `]: {
          overflow: "visible",
          [`${t}-cell-content`]: {
            display: "block",
            overflow: "hidden",
            textOverflow: "ellipsis"
          }
        },
        [`${t}-column-title`]: {
          overflow: "hidden",
          textOverflow: "ellipsis",
          wordBreak: "keep-all"
        }
      })
    }
  };
}, $3e = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-wrapper`]: {
      [`${t}-tbody > tr${t}-placeholder`]: {
        textAlign: "center",
        color: e.colorTextDisabled,
        "\n          &:hover > th,\n          &:hover > td,\n        ": {
          background: e.colorBgContainer
        }
      }
    }
  };
}, z3e = (e) => {
  const {
    componentCls: t,
    antCls: r,
    motionDurationSlow: a,
    lineWidth: i,
    paddingXS: c,
    lineType: d,
    tableBorderColor: f,
    tableExpandIconBg: p,
    tableExpandColumnWidth: g,
    borderRadius: b,
    tablePaddingVertical: w,
    tablePaddingHorizontal: x,
    tableExpandedRowBg: E,
    paddingXXS: P,
    expandIconMarginTop: k,
    expandIconSize: M,
    expandIconHalfInner: T,
    expandIconScale: N,
    calc: D
  } = e, $ = `${Ye(i)} ${d} ${f}`, j = D(P).sub(i).equal();
  return {
    [`${t}-wrapper`]: {
      [`${t}-expand-icon-col`]: {
        width: g
      },
      [`${t}-row-expand-icon-cell`]: {
        textAlign: "center",
        [`${t}-row-expand-icon`]: {
          display: "inline-flex",
          float: "none",
          verticalAlign: "sub"
        }
      },
      [`${t}-row-indent`]: {
        height: 1,
        float: "left"
      },
      [`${t}-row-expand-icon`]: Object.assign(Object.assign({}, nce(e)), {
        position: "relative",
        float: "left",
        width: M,
        height: M,
        color: "inherit",
        lineHeight: Ye(M),
        background: p,
        border: $,
        borderRadius: b,
        transform: `scale(${N})`,
        "&:focus, &:hover, &:active": {
          borderColor: "currentcolor"
        },
        "&::before, &::after": {
          position: "absolute",
          background: "currentcolor",
          transition: `transform ${a} ease-out`,
          content: '""'
        },
        "&::before": {
          top: T,
          insetInlineEnd: j,
          insetInlineStart: j,
          height: i
        },
        "&::after": {
          top: j,
          bottom: j,
          insetInlineStart: T,
          width: i,
          transform: "rotate(90deg)"
        },
        // Motion effect
        "&-collapsed::before": {
          transform: "rotate(-180deg)"
        },
        "&-collapsed::after": {
          transform: "rotate(0deg)"
        },
        "&-spaced": {
          "&::before, &::after": {
            display: "none",
            content: "none"
          },
          background: "transparent",
          border: 0,
          visibility: "hidden"
        }
      }),
      [`${t}-row-indent + ${t}-row-expand-icon`]: {
        marginTop: k,
        marginInlineEnd: c
      },
      [`tr${t}-expanded-row`]: {
        "&, &:hover": {
          "> th, > td": {
            background: E
          }
        },
        // https://github.com/ant-design/ant-design/issues/25573
        [`${r}-descriptions-view`]: {
          display: "flex",
          table: {
            flex: "auto",
            width: "100%"
          }
        }
      },
      // With fixed
      [`${t}-expanded-row-fixed`]: {
        position: "relative",
        margin: `${Ye(D(w).mul(-1).equal())} ${Ye(D(x).mul(-1).equal())}`,
        padding: `${Ye(w)} ${Ye(x)}`
      }
    }
  };
}, j3e = (e) => {
  const {
    componentCls: t,
    antCls: r,
    iconCls: a,
    tableFilterDropdownWidth: i,
    tableFilterDropdownSearchWidth: c,
    paddingXXS: d,
    paddingXS: f,
    colorText: p,
    lineWidth: g,
    lineType: b,
    tableBorderColor: w,
    headerIconColor: x,
    fontSizeSM: E,
    tablePaddingHorizontal: P,
    borderRadius: k,
    motionDurationSlow: M,
    colorIcon: T,
    colorPrimary: N,
    tableHeaderFilterActiveBg: D,
    colorTextDisabled: $,
    tableFilterDropdownBg: j,
    tableFilterDropdownHeight: I,
    controlItemBgHover: L,
    controlItemBgActive: F,
    boxShadowSecondary: _,
    filterDropdownMenuBg: W,
    calc: Q
  } = e, U = `${r}-dropdown`, Y = `${t}-filter-dropdown`, G = `${r}-tree`, J = `${Ye(g)} ${b} ${w}`;
  return [
    {
      [`${t}-wrapper`]: {
        [`${t}-filter-column`]: {
          display: "flex",
          justifyContent: "space-between"
        },
        [`${t}-filter-trigger`]: {
          position: "relative",
          display: "flex",
          alignItems: "center",
          marginBlock: Q(d).mul(-1).equal(),
          marginInline: `${Ye(d)} ${Ye(Q(P).div(2).mul(-1).equal())}`,
          padding: `0 ${Ye(d)}`,
          color: x,
          fontSize: E,
          borderRadius: k,
          cursor: "pointer",
          transition: `all ${M}`,
          "&:hover": {
            color: T,
            background: D
          },
          "&.active": {
            color: N
          }
        }
      }
    },
    {
      // Dropdown
      [`${r}-dropdown`]: {
        [Y]: Object.assign(Object.assign({}, dl(e)), {
          minWidth: i,
          backgroundColor: j,
          borderRadius: k,
          boxShadow: _,
          overflow: "hidden",
          // Reset menu
          [`${U}-menu`]: {
            // https://github.com/ant-design/ant-design/issues/4916
            // https://github.com/ant-design/ant-design/issues/19542
            maxHeight: I,
            overflowX: "hidden",
            border: 0,
            boxShadow: "none",
            borderRadius: "unset",
            backgroundColor: W,
            "&:empty::after": {
              display: "block",
              padding: `${Ye(f)} 0`,
              color: $,
              fontSize: E,
              textAlign: "center",
              content: '"Not Found"'
            }
          },
          [`${Y}-tree`]: {
            paddingBlock: `${Ye(f)} 0`,
            paddingInline: f,
            [G]: {
              padding: 0
            },
            [`${G}-treenode ${G}-node-content-wrapper:hover`]: {
              backgroundColor: L
            },
            [`${G}-treenode-checkbox-checked ${G}-node-content-wrapper`]: {
              "&, &:hover": {
                backgroundColor: F
              }
            }
          },
          [`${Y}-search`]: {
            padding: f,
            borderBottom: J,
            "&-input": {
              input: {
                minWidth: c
              },
              [a]: {
                color: $
              }
            }
          },
          [`${Y}-checkall`]: {
            width: "100%",
            marginBottom: d,
            marginInlineStart: d
          },
          // Operation
          [`${Y}-btns`]: {
            display: "flex",
            justifyContent: "space-between",
            padding: `${Ye(Q(f).sub(g).equal())} ${Ye(f)}`,
            overflow: "hidden",
            borderTop: J
          }
        })
      }
    },
    // Dropdown Menu & SubMenu
    {
      // submenu of table filter dropdown
      [`${r}-dropdown ${Y}, ${Y}-submenu`]: {
        // Checkbox
        [`${r}-checkbox-wrapper + span`]: {
          paddingInlineStart: f,
          color: p
        },
        "> ul": {
          maxHeight: "calc(100vh - 130px)",
          overflowX: "hidden",
          overflowY: "auto"
        }
      }
    }
  ];
}, I3e = (e) => {
  const {
    componentCls: t,
    lineWidth: r,
    colorSplit: a,
    motionDurationSlow: i,
    zIndexTableFixed: c,
    tableBg: d,
    zIndexTableSticky: f,
    calc: p
  } = e, g = a;
  return {
    [`${t}-wrapper`]: {
      [`
        ${t}-cell-fix-left,
        ${t}-cell-fix-right
      `]: {
        position: "sticky !important",
        zIndex: c,
        background: d
      },
      [`
        ${t}-cell-fix-left-first::after,
        ${t}-cell-fix-left-last::after
      `]: {
        position: "absolute",
        top: 0,
        right: {
          _skip_check_: !0,
          value: 0
        },
        bottom: p(r).mul(-1).equal(),
        width: 30,
        transform: "translateX(100%)",
        transition: `box-shadow ${i}`,
        content: '""',
        pointerEvents: "none",
        // fix issues: https://github.com/ant-design/ant-design/issues/54587
        willChange: "transform"
      },
      [`${t}-cell-fix-left-all::after`]: {
        display: "none"
      },
      [`
        ${t}-cell-fix-right-first::after,
        ${t}-cell-fix-right-last::after
      `]: {
        position: "absolute",
        top: 0,
        bottom: p(r).mul(-1).equal(),
        left: {
          _skip_check_: !0,
          value: 0
        },
        width: 30,
        transform: "translateX(-100%)",
        transition: `box-shadow ${i}`,
        content: '""',
        pointerEvents: "none"
      },
      [`${t}-container`]: {
        position: "relative",
        "&::before, &::after": {
          position: "absolute",
          top: 0,
          bottom: 0,
          zIndex: p(f).add(1).equal({
            unit: !1
          }),
          width: 30,
          transition: `box-shadow ${i}`,
          content: '""',
          pointerEvents: "none"
        },
        "&::before": {
          insetInlineStart: 0
        },
        "&::after": {
          insetInlineEnd: 0
        }
      },
      [`${t}-ping-left`]: {
        [`&:not(${t}-has-fix-left) ${t}-container::before`]: {
          boxShadow: `inset 10px 0 8px -8px ${g}`
        },
        [`
          ${t}-cell-fix-left-first::after,
          ${t}-cell-fix-left-last::after
        `]: {
          boxShadow: `inset 10px 0 8px -8px ${g}`
        },
        [`${t}-cell-fix-left-last::before`]: {
          backgroundColor: "transparent !important"
        }
      },
      [`${t}-ping-right`]: {
        [`&:not(${t}-has-fix-right) ${t}-container::after`]: {
          boxShadow: `inset -10px 0 8px -8px ${g}`
        },
        [`
          ${t}-cell-fix-right-first::after,
          ${t}-cell-fix-right-last::after
        `]: {
          boxShadow: `inset -10px 0 8px -8px ${g}`
        }
      },
      // Gapped fixed Columns do not show the shadow
      [`${t}-fixed-column-gapped`]: {
        [`
        ${t}-cell-fix-left-first::after,
        ${t}-cell-fix-left-last::after,
        ${t}-cell-fix-right-first::after,
        ${t}-cell-fix-right-last::after
      `]: {
          boxShadow: "none"
        }
      }
    }
  };
}, L3e = (e) => {
  const {
    componentCls: t,
    antCls: r,
    margin: a
  } = e;
  return {
    [`${t}-wrapper ${t}-pagination${r}-pagination`]: {
      margin: `${Ye(a)} 0`
    }
  };
}, H3e = (e) => {
  const {
    componentCls: t,
    tableRadius: r
  } = e;
  return {
    [`${t}-wrapper`]: {
      [t]: {
        // https://github.com/ant-design/ant-design/issues/39115#issuecomment-1362314574
        [`${t}-title, ${t}-header`]: {
          borderRadius: `${Ye(r)} ${Ye(r)} 0 0`
        },
        [`${t}-title + ${t}-container`]: {
          borderStartStartRadius: 0,
          borderStartEndRadius: 0,
          // https://github.com/ant-design/ant-design/issues/41975
          [`${t}-header, table`]: {
            borderRadius: 0
          },
          "table > thead > tr:first-child": {
            "th:first-child, th:last-child, td:first-child, td:last-child": {
              borderRadius: 0
            }
          }
        },
        "&-container": {
          borderStartStartRadius: r,
          borderStartEndRadius: r,
          "table > thead > tr:first-child": {
            "> *:first-child": {
              borderStartStartRadius: r
            },
            "> *:last-child": {
              borderStartEndRadius: r
            }
          }
        },
        "&-footer": {
          borderRadius: `0 0 ${Ye(r)} ${Ye(r)}`
        }
      }
    }
  };
}, F3e = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-wrapper-rtl`]: {
      direction: "rtl",
      table: {
        direction: "rtl"
      },
      [`${t}-pagination-left`]: {
        justifyContent: "flex-end"
      },
      [`${t}-pagination-right`]: {
        justifyContent: "flex-start"
      },
      [`${t}-row-expand-icon`]: {
        float: "right",
        "&::after": {
          transform: "rotate(-90deg)"
        },
        "&-collapsed::before": {
          transform: "rotate(180deg)"
        },
        "&-collapsed::after": {
          transform: "rotate(0deg)"
        }
      },
      [`${t}-container`]: {
        "&::before": {
          insetInlineStart: "unset",
          insetInlineEnd: 0
        },
        "&::after": {
          insetInlineStart: 0,
          insetInlineEnd: "unset"
        },
        [`${t}-row-indent`]: {
          float: "right"
        }
      }
    }
  };
}, W3e = (e) => {
  const {
    componentCls: t,
    antCls: r,
    iconCls: a,
    fontSizeIcon: i,
    padding: c,
    paddingXS: d,
    headerIconColor: f,
    headerIconHoverColor: p,
    tableSelectionColumnWidth: g,
    tableSelectedRowBg: b,
    tableSelectedRowHoverBg: w,
    tableRowHoverBg: x,
    tablePaddingHorizontal: E,
    calc: P
  } = e;
  return {
    [`${t}-wrapper`]: {
      // ========================== Selections ==========================
      [`${t}-selection-col`]: {
        width: g,
        [`&${t}-selection-col-with-dropdown`]: {
          width: P(g).add(i).add(P(c).div(4)).equal()
        }
      },
      [`${t}-bordered ${t}-selection-col`]: {
        width: P(g).add(P(d).mul(2)).equal(),
        [`&${t}-selection-col-with-dropdown`]: {
          width: P(g).add(i).add(P(c).div(4)).add(P(d).mul(2)).equal()
        }
      },
      [`
        table tr th${t}-selection-column,
        table tr td${t}-selection-column,
        ${t}-selection-column
      `]: {
        paddingInlineEnd: e.paddingXS,
        paddingInlineStart: e.paddingXS,
        textAlign: "center",
        [`${r}-radio-wrapper`]: {
          marginInlineEnd: 0
        }
      },
      [`table tr th${t}-selection-column${t}-cell-fix-left`]: {
        zIndex: P(e.zIndexTableFixed).add(1).equal({
          unit: !1
        })
      },
      [`table tr th${t}-selection-column::after`]: {
        backgroundColor: "transparent !important"
      },
      [`${t}-selection`]: {
        position: "relative",
        display: "inline-flex",
        flexDirection: "column"
      },
      [`${t}-selection-extra`]: {
        position: "absolute",
        top: 0,
        zIndex: 1,
        cursor: "pointer",
        transition: `all ${e.motionDurationSlow}`,
        marginInlineStart: "100%",
        paddingInlineStart: Ye(P(E).div(4).equal()),
        [a]: {
          color: f,
          fontSize: i,
          verticalAlign: "baseline",
          "&:hover": {
            color: p
          }
        }
      },
      // ============================= Rows =============================
      [`${t}-tbody`]: {
        [`${t}-row`]: {
          [`&${t}-row-selected`]: {
            [`> ${t}-cell`]: {
              background: b,
              "&-row-hover": {
                background: w
              }
            }
          },
          [`> ${t}-cell-row-hover`]: {
            background: x
          }
        }
      }
    }
  };
}, V3e = (e) => {
  const {
    componentCls: t,
    tableExpandColumnWidth: r,
    calc: a
  } = e, i = (c, d, f, p) => ({
    [`${t}${t}-${c}`]: {
      fontSize: p,
      [`
        ${t}-title,
        ${t}-footer,
        ${t}-cell,
        ${t}-thead > tr > th,
        ${t}-tbody > tr > th,
        ${t}-tbody > tr > td,
        tfoot > tr > th,
        tfoot > tr > td
      `]: {
        padding: `${Ye(d)} ${Ye(f)}`
      },
      [`${t}-filter-trigger`]: {
        marginInlineEnd: Ye(a(f).div(2).mul(-1).equal())
      },
      [`${t}-expanded-row-fixed`]: {
        margin: `${Ye(a(d).mul(-1).equal())} ${Ye(a(f).mul(-1).equal())}`
      },
      [`${t}-tbody`]: {
        // ========================= Nest Table ===========================
        [`${t}-wrapper:only-child ${t}`]: {
          marginBlock: Ye(a(d).mul(-1).equal()),
          marginInline: `${Ye(a(r).sub(f).equal())} ${Ye(a(f).mul(-1).equal())}`
        }
      },
      // https://github.com/ant-design/ant-design/issues/35167
      [`${t}-selection-extra`]: {
        paddingInlineStart: Ye(a(f).div(4).equal())
      }
    }
  });
  return {
    [`${t}-wrapper`]: Object.assign(Object.assign({}, i("middle", e.tablePaddingVerticalMiddle, e.tablePaddingHorizontalMiddle, e.tableFontSizeMiddle)), i("small", e.tablePaddingVerticalSmall, e.tablePaddingHorizontalSmall, e.tableFontSizeSmall))
  };
}, _3e = (e) => {
  const {
    componentCls: t,
    marginXXS: r,
    fontSizeIcon: a,
    headerIconColor: i,
    headerIconHoverColor: c
  } = e;
  return {
    [`${t}-wrapper`]: {
      [`${t}-thead th${t}-column-has-sorters`]: {
        outline: "none",
        cursor: "pointer",
        // why left 0s? Avoid column header move with transition when left is changed
        // https://github.com/ant-design/ant-design/issues/50588
        transition: `all ${e.motionDurationSlow}, left 0s`,
        "&:hover": {
          background: e.tableHeaderSortHoverBg,
          "&::before": {
            backgroundColor: "transparent !important"
          }
        },
        "&:focus-visible": {
          color: e.colorPrimary
        },
        // https://github.com/ant-design/ant-design/issues/30969
        [`
          &${t}-cell-fix-left:hover,
          &${t}-cell-fix-right:hover
        `]: {
          background: e.tableFixedHeaderSortActiveBg
        }
      },
      [`${t}-thead th${t}-column-sort`]: {
        background: e.tableHeaderSortBg,
        "&::before": {
          backgroundColor: "transparent !important"
        }
      },
      [`td${t}-column-sort`]: {
        background: e.tableBodySortBg
      },
      [`${t}-column-title`]: {
        position: "relative",
        zIndex: 1,
        flex: 1,
        minWidth: 0
      },
      [`${t}-column-sorters`]: {
        display: "flex",
        flex: "auto",
        alignItems: "center",
        justifyContent: "space-between",
        "&::after": {
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          content: '""'
        }
      },
      [`${t}-column-sorters-tooltip-target-sorter`]: {
        "&::after": {
          content: "none"
        }
      },
      [`${t}-column-sorter`]: {
        marginInlineStart: r,
        color: i,
        fontSize: 0,
        transition: `color ${e.motionDurationSlow}`,
        "&-inner": {
          display: "inline-flex",
          flexDirection: "column",
          alignItems: "center"
        },
        "&-up, &-down": {
          fontSize: a,
          "&.active": {
            color: e.colorPrimary
          }
        },
        [`${t}-column-sorter-up + ${t}-column-sorter-down`]: {
          marginTop: "-0.3em"
        }
      },
      [`${t}-column-sorters:hover ${t}-column-sorter`]: {
        color: c
      }
    }
  };
}, B3e = (e) => {
  const {
    componentCls: t,
    opacityLoading: r,
    tableScrollThumbBg: a,
    tableScrollThumbBgHover: i,
    tableScrollThumbSize: c,
    tableScrollBg: d,
    zIndexTableSticky: f,
    stickyScrollBarBorderRadius: p,
    lineWidth: g,
    lineType: b,
    tableBorderColor: w
  } = e, x = `${Ye(g)} ${b} ${w}`;
  return {
    [`${t}-wrapper`]: {
      [`${t}-sticky`]: {
        "&-holder": {
          position: "sticky",
          zIndex: f,
          background: e.colorBgContainer
        },
        "&-scroll": {
          position: "sticky",
          bottom: 0,
          height: `${Ye(c)} !important`,
          zIndex: f,
          display: "flex",
          alignItems: "center",
          background: d,
          borderTop: x,
          opacity: r,
          "&:hover": {
            transformOrigin: "center bottom"
          },
          // fake scrollbar style of sticky
          "&-bar": {
            height: c,
            backgroundColor: a,
            borderRadius: p,
            transition: `all ${e.motionDurationSlow}, transform 0s`,
            position: "absolute",
            bottom: 0,
            "&:hover, &-active": {
              backgroundColor: i
            }
          }
        }
      }
    }
  };
}, SV = (e) => {
  const {
    componentCls: t,
    lineWidth: r,
    tableBorderColor: a,
    calc: i
  } = e, c = `${Ye(r)} ${e.lineType} ${a}`;
  return {
    [`${t}-wrapper`]: {
      [`${t}-summary`]: {
        position: "relative",
        zIndex: e.zIndexTableFixed,
        background: e.tableBg,
        "> tr": {
          "> th, > td": {
            borderBottom: c
          }
        }
      },
      [`div${t}-summary`]: {
        boxShadow: `0 ${Ye(i(r).mul(-1).equal())} 0 ${a}`
      }
    }
  };
}, U3e = (e) => {
  const {
    componentCls: t,
    motionDurationMid: r,
    lineWidth: a,
    lineType: i,
    tableBorderColor: c,
    calc: d
  } = e, f = `${Ye(a)} ${i} ${c}`, p = `${t}-expanded-row-cell`;
  return {
    [`${t}-wrapper`]: {
      // ========================== Row ==========================
      [`${t}-tbody-virtual`]: {
        [`${t}-tbody-virtual-holder-inner`]: {
          [`
            & > ${t}-row, 
            & > div:not(${t}-row) > ${t}-row
          `]: {
            display: "flex",
            boxSizing: "border-box",
            width: "100%"
          }
        },
        [`${t}-cell`]: {
          borderBottom: f,
          transition: `background ${r}`
        },
        [`${t}-expanded-row`]: {
          [`${p}${p}-fixed`]: {
            position: "sticky",
            insetInlineStart: 0,
            overflow: "hidden",
            width: `calc(var(--virtual-width) - ${Ye(a)})`,
            borderInlineEnd: "none"
          }
        }
      },
      // ======================== Border =========================
      [`${t}-bordered`]: {
        [`${t}-tbody-virtual`]: {
          "&:after": {
            content: '""',
            insetInline: 0,
            bottom: 0,
            borderBottom: f,
            position: "absolute"
          },
          [`${t}-cell`]: {
            borderInlineEnd: f,
            [`&${t}-cell-fix-right-first:before`]: {
              content: '""',
              position: "absolute",
              insetBlock: 0,
              insetInlineStart: d(a).mul(-1).equal(),
              borderInlineStart: f
            }
          }
        },
        // Empty placeholder
        [`&${t}-virtual`]: {
          [`${t}-placeholder ${t}-cell`]: {
            borderInlineEnd: f,
            borderBottom: f
          }
        }
      }
    }
  };
}, X3e = (e) => {
  const {
    componentCls: t,
    fontWeightStrong: r,
    tablePaddingVertical: a,
    tablePaddingHorizontal: i,
    tableExpandColumnWidth: c,
    lineWidth: d,
    lineType: f,
    tableBorderColor: p,
    tableFontSize: g,
    tableBg: b,
    tableRadius: w,
    tableHeaderTextColor: x,
    motionDurationMid: E,
    tableHeaderBg: P,
    tableHeaderCellSplitColor: k,
    tableFooterTextColor: M,
    tableFooterBg: T,
    calc: N
  } = e, D = `${Ye(d)} ${f} ${p}`;
  return {
    [`${t}-wrapper`]: Object.assign(Object.assign({
      clear: "both",
      maxWidth: "100%",
      // fix https://github.com/ant-design/ant-design/issues/46177
      "--rc-virtual-list-scrollbar-bg": e.tableScrollBg
    }, J4()), {
      [t]: Object.assign(Object.assign({}, dl(e)), {
        fontSize: g,
        background: b,
        borderRadius: `${Ye(w)} ${Ye(w)} 0 0`,
        // https://github.com/ant-design/ant-design/issues/47486
        scrollbarColor: `${e.tableScrollThumbBg} ${e.tableScrollBg}`
      }),
      // https://github.com/ant-design/ant-design/issues/17611
      table: {
        width: "100%",
        textAlign: "start",
        borderRadius: `${Ye(w)} ${Ye(w)} 0 0`,
        borderCollapse: "separate",
        borderSpacing: 0
      },
      // ============================= Cell ==============================
      [`
          ${t}-cell,
          ${t}-thead > tr > th,
          ${t}-tbody > tr > th,
          ${t}-tbody > tr > td,
          tfoot > tr > th,
          tfoot > tr > td
        `]: {
        position: "relative",
        padding: `${Ye(a)} ${Ye(i)}`,
        overflowWrap: "break-word"
      },
      // ============================ Title =============================
      [`${t}-title`]: {
        padding: `${Ye(a)} ${Ye(i)}`
      },
      // ============================ Header ============================
      [`${t}-thead`]: {
        "\n          > tr > th,\n          > tr > td\n        ": {
          position: "relative",
          color: x,
          fontWeight: r,
          textAlign: "start",
          background: P,
          borderBottom: D,
          transition: `background ${E} ease`,
          "&[colspan]:not([colspan='1'])": {
            textAlign: "center"
          },
          [`&:not(:last-child):not(${t}-selection-column):not(${t}-row-expand-icon-cell):not([colspan])::before`]: {
            position: "absolute",
            top: "50%",
            insetInlineEnd: 0,
            width: 1,
            height: "1.6em",
            backgroundColor: k,
            transform: "translateY(-50%)",
            transition: `background-color ${E}`,
            content: '""'
          }
        },
        "> tr:not(:last-child) > th[colspan]": {
          borderBottom: 0
        }
      },
      // ============================ Body ============================
      [`${t}-tbody`]: {
        "> tr": {
          "> th, > td": {
            transition: `background ${E}, border-color ${E}`,
            borderBottom: D,
            // ========================= Nest Table ===========================
            [`
              > ${t}-wrapper:only-child,
              > ${t}-expanded-row-fixed > ${t}-wrapper:only-child
            `]: {
              [t]: {
                marginBlock: Ye(N(a).mul(-1).equal()),
                marginInline: `${Ye(N(c).sub(i).equal())}
                ${Ye(N(i).mul(-1).equal())}`,
                [`${t}-tbody > tr:last-child > td`]: {
                  borderBottomWidth: 0,
                  "&:first-child, &:last-child": {
                    borderRadius: 0
                  }
                }
              }
            }
          },
          "> th": {
            position: "relative",
            color: x,
            fontWeight: r,
            textAlign: "start",
            background: P,
            borderBottom: D,
            transition: `background ${E} ease`
          },
          // measure cell styles
          [`& > ${t}-measure-cell`]: {
            paddingBlock: "0 !important",
            borderBlock: "0 !important",
            [`${t}-measure-cell-content`]: {
              height: 0,
              overflow: "hidden",
              pointerEvents: "none"
            }
          }
        }
      },
      // ============================ Footer ============================
      [`${t}-footer`]: {
        padding: `${Ye(a)} ${Ye(i)}`,
        color: M,
        background: T
      }
    })
  };
}, G3e = (e) => {
  const {
    colorFillAlter: t,
    colorBgContainer: r,
    colorTextHeading: a,
    colorFillSecondary: i,
    colorFillContent: c,
    controlItemBgActive: d,
    controlItemBgActiveHover: f,
    padding: p,
    paddingSM: g,
    paddingXS: b,
    colorBorderSecondary: w,
    borderRadiusLG: x,
    controlHeight: E,
    colorTextPlaceholder: P,
    fontSize: k,
    fontSizeSM: M,
    lineHeight: T,
    lineWidth: N,
    colorIcon: D,
    colorIconHover: $,
    opacityLoading: j,
    controlInteractiveSize: I
  } = e, L = new ro(i).onBackground(r).toHexString(), F = new ro(c).onBackground(r).toHexString(), _ = new ro(t).onBackground(r).toHexString(), W = new ro(D), Q = new ro($), U = I / 2 - N, Y = U * 2 + N * 3;
  return {
    headerBg: _,
    headerColor: a,
    headerSortActiveBg: L,
    headerSortHoverBg: F,
    bodySortBg: _,
    rowHoverBg: _,
    rowSelectedBg: d,
    rowSelectedHoverBg: f,
    rowExpandedBg: t,
    cellPaddingBlock: p,
    cellPaddingInline: p,
    cellPaddingBlockMD: g,
    cellPaddingInlineMD: b,
    cellPaddingBlockSM: b,
    cellPaddingInlineSM: b,
    borderColor: w,
    headerBorderRadius: x,
    footerBg: _,
    footerColor: a,
    cellFontSize: k,
    cellFontSizeMD: k,
    cellFontSizeSM: k,
    headerSplitColor: w,
    fixedHeaderSortActiveBg: L,
    headerFilterHoverBg: c,
    filterDropdownMenuBg: r,
    filterDropdownBg: r,
    expandIconBg: r,
    selectionColumnWidth: E,
    stickyScrollBarBg: P,
    stickyScrollBarBorderRadius: 100,
    expandIconMarginTop: (k * T - N * 3) / 2 - Math.ceil((M * 1.4 - N * 3) / 2),
    headerIconColor: W.clone().setA(W.a * j).toRgbString(),
    headerIconHoverColor: Q.clone().setA(Q.a * j).toRgbString(),
    expandIconHalfInner: U,
    expandIconSize: Y,
    expandIconScale: I / Y
  };
}, CV = 2, q3e = Ii("Table", (e) => {
  const {
    colorTextHeading: t,
    colorSplit: r,
    colorBgContainer: a,
    controlInteractiveSize: i,
    headerBg: c,
    headerColor: d,
    headerSortActiveBg: f,
    headerSortHoverBg: p,
    bodySortBg: g,
    rowHoverBg: b,
    rowSelectedBg: w,
    rowSelectedHoverBg: x,
    rowExpandedBg: E,
    cellPaddingBlock: P,
    cellPaddingInline: k,
    cellPaddingBlockMD: M,
    cellPaddingInlineMD: T,
    cellPaddingBlockSM: N,
    cellPaddingInlineSM: D,
    borderColor: $,
    footerBg: j,
    footerColor: I,
    headerBorderRadius: L,
    cellFontSize: F,
    cellFontSizeMD: _,
    cellFontSizeSM: W,
    headerSplitColor: Q,
    fixedHeaderSortActiveBg: U,
    headerFilterHoverBg: Y,
    filterDropdownBg: G,
    expandIconBg: J,
    selectionColumnWidth: H,
    stickyScrollBarBg: K,
    calc: X
  } = e, te = lo(e, {
    tableFontSize: F,
    tableBg: a,
    tableRadius: L,
    tablePaddingVertical: P,
    tablePaddingHorizontal: k,
    tablePaddingVerticalMiddle: M,
    tablePaddingHorizontalMiddle: T,
    tablePaddingVerticalSmall: N,
    tablePaddingHorizontalSmall: D,
    tableBorderColor: $,
    tableHeaderTextColor: d,
    tableHeaderBg: c,
    tableFooterTextColor: I,
    tableFooterBg: j,
    tableHeaderCellSplitColor: Q,
    tableHeaderSortBg: f,
    tableHeaderSortHoverBg: p,
    tableBodySortBg: g,
    tableFixedHeaderSortActiveBg: U,
    tableHeaderFilterActiveBg: Y,
    tableFilterDropdownBg: G,
    tableRowHoverBg: b,
    tableSelectedRowBg: w,
    tableSelectedRowHoverBg: x,
    zIndexTableFixed: CV,
    zIndexTableSticky: X(CV).add(1).equal({
      unit: !1
    }),
    tableFontSizeMiddle: _,
    tableFontSizeSmall: W,
    tableSelectionColumnWidth: H,
    tableExpandIconBg: J,
    tableExpandColumnWidth: X(i).add(X(e.padding).mul(2)).equal(),
    tableExpandedRowBg: E,
    // Dropdown
    tableFilterDropdownWidth: 120,
    tableFilterDropdownHeight: 264,
    tableFilterDropdownSearchWidth: 140,
    // Virtual Scroll Bar
    tableScrollThumbSize: 8,
    // Mac scroll bar size
    tableScrollThumbBg: K,
    tableScrollThumbBgHover: t,
    tableScrollBg: r
  });
  return [X3e(te), L3e(te), SV(te), _3e(te), j3e(te), N3e(te), H3e(te), z3e(te), SV(te), $3e(te), W3e(te), I3e(te), B3e(te), D3e(te), V3e(te), F3e(te), U3e(te)];
}, G3e, {
  unitless: {
    expandIconScale: !0
  }
}), xV = [], K3e = (e, t) => {
  var r, a;
  const {
    prefixCls: i,
    className: c,
    rootClassName: d,
    style: f,
    size: p,
    bordered: g,
    dropdownPrefixCls: b,
    dataSource: w,
    pagination: x,
    rowSelection: E,
    rowKey: P = "key",
    rowClassName: k,
    columns: M,
    children: T,
    childrenColumnName: N,
    onChange: D,
    getPopupContainer: $,
    loading: j,
    expandIcon: I,
    expandable: L,
    expandedRowRender: F,
    expandIconColumnIndex: _,
    indentSize: W,
    scroll: Q,
    sortDirections: U,
    locale: Y,
    showSorterTooltip: G = {
      target: "full-header"
    },
    virtual: J
  } = e, H = To("Table");
  process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && H(!(typeof P == "function" && P.length > 1), "usage", "`index` parameter of `rowKey` function is deprecated. There is no guarantee that it will work as expected.");
  const K = S.useMemo(() => M || Hj(T), [M, T]), X = S.useMemo(() => K.some((Dt) => Dt.responsive), [K]), te = oj(X), ie = S.useMemo(() => {
    const Dt = new Set(Object.keys(te).filter((Yt) => te[Yt]));
    return K.filter((Yt) => !Yt.responsive || Yt.responsive.some((Mn) => Dt.has(Mn)));
  }, [K, te]), ee = Rs(e, ["className", "style", "columns"]), {
    locale: ne = vb,
    direction: ae,
    table: oe,
    renderEmpty: fe,
    getPrefixCls: be,
    getPopupContainer: me
  } = S.useContext(Qr), De = Cb(p), Me = Object.assign(Object.assign({}, ne.Table), Y), ze = w || xV, le = be("table", i), se = be("dropdown", b), [, Ae] = Bf(), we = Qh(le), [Ne, pe, Qe] = q3e(le, we), Le = Object.assign(Object.assign({
    childrenColumnName: N,
    expandIconColumnIndex: _
  }, L), {
    expandIcon: (r = L?.expandIcon) !== null && r !== void 0 ? r : (a = oe?.expandable) === null || a === void 0 ? void 0 : a.expandIcon
  }), {
    childrenColumnName: Te = "children"
  } = Le, Oe = S.useMemo(() => ze.some((Dt) => Dt?.[Te]) ? "nest" : F || L?.expandedRowRender ? "row" : null, [ze]), ye = {
    body: S.useRef(null)
  }, je = R4e(le), Ue = S.useRef(null), Fe = S.useRef(null);
  kde(t, () => Object.assign(Object.assign({}, Fe.current), {
    nativeElement: Ue.current
  }));
  const tt = S.useMemo(() => typeof P == "function" ? P : (Dt) => Dt?.[P], [P]), [dt] = y3e(ze, Te, tt), St = {}, mt = (Dt, Yt, Mn = !1) => {
    var Gn, wr, aa, qn;
    const Rr = Object.assign(Object.assign({}, St), Dt);
    Mn && ((Gn = St.resetPagination) === null || Gn === void 0 || Gn.call(St), !((wr = Rr.pagination) === null || wr === void 0) && wr.current && (Rr.pagination.current = 1), x && ((aa = x.onChange) === null || aa === void 0 || aa.call(x, 1, (qn = Rr.pagination) === null || qn === void 0 ? void 0 : qn.pageSize))), Q && Q.scrollToFirstRowOnChange !== !1 && ye.body.current && gde(0, {
      getContainer: () => ye.body.current
    }), D?.(Rr.pagination, Rr.filters, Rr.sorter, {
      currentDataSource: o$(l$(ze, Rr.sorterStates, Te), Rr.filterStates, Te),
      action: Yt
    });
  }, Ot = (Dt, Yt) => {
    mt({
      sorter: Dt,
      sorterStates: Yt
    }, "sort", !1);
  }, [Rt, ct, it, Ct] = O3e({
    prefixCls: le,
    mergedColumns: ie,
    onSorterChange: Ot,
    sortDirections: U || ["ascend", "descend"],
    tableLocale: Me,
    showSorterTooltip: G
  }), ut = S.useMemo(() => l$(ze, ct, Te), [ze, ct]);
  St.sorter = Ct(), St.sorterStates = ct;
  const ht = (Dt, Yt) => {
    mt({
      filters: Dt,
      filterStates: Yt
    }, "filter", !0);
  }, [ot, at, ft] = b3e({
    prefixCls: le,
    locale: Me,
    dropdownPrefixCls: se,
    mergedColumns: ie,
    onFilterChange: ht,
    getPopupContainer: $ || me,
    rootClassName: _e(d, we)
  }), st = o$(ut, at, Te);
  St.filters = ft, St.filterStates = at;
  const pt = S.useMemo(() => {
    const Dt = {};
    return Object.keys(ft).forEach((Yt) => {
      ft[Yt] !== null && (Dt[Yt] = ft[Yt]);
    }), Object.assign(Object.assign({}, it), {
      filters: Dt
    });
  }, [it, ft]), [bt] = T3e(pt), Nt = (Dt, Yt) => {
    mt({
      pagination: Object.assign(Object.assign({}, St.pagination), {
        current: Dt,
        pageSize: Yt
      })
    }, "paginate");
  }, [$t, Pt] = C3e(st.length, Nt, x);
  St.pagination = x === !1 ? {} : S3e($t, x), St.resetPagination = Pt;
  const hn = S.useMemo(() => {
    if (x === !1 || !$t.pageSize)
      return st;
    const {
      current: Dt = 1,
      total: Yt,
      pageSize: Mn = DZ
    } = $t;
    return process.env.NODE_ENV !== "production" && H(Dt > 0, "usage", "`current` should be positive number."), st.length < Yt ? st.length > Mn ? (process.env.NODE_ENV !== "production" && H(!1, "usage", "`dataSource` length is less than `pagination.total` but large than `pagination.pageSize`. Please make sure your config correct data with async mode."), st.slice((Dt - 1) * Mn, Dt * Mn)) : st : st.slice((Dt - 1) * Mn, Dt * Mn);
  }, [!!x, st, $t?.current, $t?.pageSize, $t?.total]), [an, jn] = O4e({
    prefixCls: le,
    data: st,
    pageData: hn,
    getRowKey: tt,
    getRecordByKey: dt,
    expandType: Oe,
    childrenColumnName: Te,
    locale: Me,
    getPopupContainer: $ || me
  }, E), xn = (Dt, Yt, Mn) => {
    let Gn;
    return typeof k == "function" ? Gn = _e(k(Dt, Yt, Mn)) : Gn = _e(k), _e({
      [`${le}-row-selected`]: jn.has(tt(Dt, Yt))
    }, Gn);
  };
  Le.__PARENT_RENDER_ICON__ = Le.expandIcon, Le.expandIcon = Le.expandIcon || I || T4e(Me), Oe === "nest" && Le.expandIconColumnIndex === void 0 ? Le.expandIconColumnIndex = E ? 1 : 0 : Le.expandIconColumnIndex > 0 && E && (Le.expandIconColumnIndex -= 1), typeof Le.indentSize != "number" && (Le.indentSize = typeof W == "number" ? W : 15);
  const Ut = S.useCallback((Dt) => bt(an(ot(Rt(Dt)))), [Rt, ot, an]), pn = () => {
    if (x === !1 || !$t?.total)
      return {};
    const Dt = () => $t.size || (De === "small" || De === "middle" ? "small" : void 0), Yt = (kt) => {
      const Qn = kt === "left" ? "start" : kt === "right" ? "end" : kt;
      return /* @__PURE__ */ S.createElement(zJ, Object.assign({}, $t, {
        align: $t.align || Qn,
        className: _e(`${le}-pagination`, $t.className),
        size: Dt()
      }));
    }, Mn = ae === "rtl" ? "left" : "right", Gn = $t.position;
    if (Gn === null || !Array.isArray(Gn))
      return {
        bottom: Yt(Mn)
      };
    const wr = Gn.find((kt) => typeof kt == "string" && kt.toLowerCase().includes("top")), aa = Gn.find((kt) => typeof kt == "string" && kt.toLowerCase().includes("bottom")), qn = Gn.every((kt) => `${kt}` == "none"), Rr = wr ? wr.toLowerCase().replace("top", "") : "", Wt = aa ? aa.toLowerCase().replace("bottom", "") : "", en = !wr && !aa && !qn, Xt = () => Rr ? Yt(Rr) : void 0, zt = () => {
      if (Wt)
        return Yt(Wt);
      if (en)
        return Yt(Mn);
    };
    return {
      top: Xt(),
      bottom: zt()
    };
  }, wn = S.useMemo(() => typeof j == "boolean" ? {
    spinning: j
  } : typeof j == "object" && j !== null ? Object.assign({
    spinning: !0
  }, j) : void 0, [j]), Lt = _e(Qe, we, `${le}-wrapper`, oe?.className, {
    [`${le}-wrapper-rtl`]: ae === "rtl"
  }, c, d, pe), gt = Object.assign(Object.assign({}, oe?.style), f), wt = S.useMemo(() => wn?.spinning && ze === xV ? null : typeof Y?.emptyText < "u" ? Y.emptyText : fe?.("Table") || /* @__PURE__ */ S.createElement(hY, {
    componentName: "Table"
  }), [wn?.spinning, ze, Y?.emptyText, fe]), Ft = J ? A3e : R3e, yn = {}, gn = S.useMemo(() => {
    const {
      fontSize: Dt,
      lineHeight: Yt,
      lineWidth: Mn,
      padding: Gn,
      paddingXS: wr,
      paddingSM: aa
    } = Ae, qn = Math.floor(Dt * Yt);
    switch (De) {
      case "middle":
        return aa * 2 + qn + Mn;
      case "small":
        return wr * 2 + qn + Mn;
      default:
        return Gn * 2 + qn + Mn;
    }
  }, [Ae, De]);
  J && (yn.listItemHeight = gn);
  const {
    top: Tn,
    bottom: Gt
  } = pn();
  return Ne(/* @__PURE__ */ S.createElement("div", {
    ref: Ue,
    className: Lt,
    style: gt
  }, /* @__PURE__ */ S.createElement(zj, Object.assign({
    spinning: !1
  }, wn), Tn, /* @__PURE__ */ S.createElement(Ft, Object.assign({}, yn, ee, {
    ref: Fe,
    columns: ie,
    direction: ae,
    expandable: Le,
    prefixCls: le,
    className: _e({
      [`${le}-middle`]: De === "middle",
      [`${le}-small`]: De === "small",
      [`${le}-bordered`]: g,
      [`${le}-empty`]: ze.length === 0
    }, Qe, we, pe),
    data: hn,
    rowKey: tt,
    rowClassName: xn,
    emptyText: wt,
    // Internal
    internalHooks: u7,
    internalRefs: ye,
    transformColumns: Ut,
    getContainerWidth: je,
    measureRowRender: (Dt) => /* @__PURE__ */ S.createElement(tc, {
      getPopupContainer: (Yt) => Yt
    }, Dt)
  })), Gt)));
}, Y3e = /* @__PURE__ */ S.forwardRef(K3e), Q3e = (e, t) => {
  const r = S.useRef(0);
  return r.current += 1, /* @__PURE__ */ S.createElement(Y3e, Object.assign({}, e, {
    ref: t,
    _renderTimes: r.current
  }));
}, xb = /* @__PURE__ */ S.forwardRef(Q3e);
xb.SELECTION_COLUMN = eb;
xb.EXPAND_COLUMN = tb;
xb.SELECTION_ALL = e$;
xb.SELECTION_INVERT = t$;
xb.SELECTION_NONE = n$;
xb.Column = b4e;
xb.ColumnGroup = y4e;
xb.Summary = qJ;
process.env.NODE_ENV !== "production" && (xb.displayName = "Table");
var J3e = function(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
    t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
};
const {
  TimePicker: Z3e,
  RangePicker: exe
} = Qx, txe = /* @__PURE__ */ S.forwardRef((e, t) => /* @__PURE__ */ S.createElement(exe, Object.assign({}, e, {
  picker: "time",
  mode: void 0,
  ref: t
}))), b3 = /* @__PURE__ */ S.forwardRef((e, t) => {
  var {
    addon: r,
    renderExtraFooter: a,
    variant: i,
    bordered: c
  } = e, d = J3e(e, ["addon", "renderExtraFooter", "variant", "bordered"]);
  process.env.NODE_ENV !== "production" && To("TimePicker").deprecated(!r, "addon", "renderExtraFooter");
  const [f] = t7("timePicker", i, c), p = S.useMemo(() => {
    if (a)
      return a;
    if (r)
      return r;
  }, [r, a]);
  return /* @__PURE__ */ S.createElement(Z3e, Object.assign({}, d, {
    mode: void 0,
    ref: t,
    renderExtraFooter: p,
    variant: f
  }));
});
process.env.NODE_ENV !== "production" && (b3.displayName = "TimePicker");
const LZ = Gx(b3, "popupAlign", void 0, "picker");
b3._InternalPanelDoNotUseOrYouWillBeFired = LZ;
b3.RangePicker = txe;
b3._InternalPanelDoNotUseOrYouWillBeFired = LZ;
var nxe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z" } }] }, name: "delete", theme: "outlined" }, rxe = function(t, r) {
  return /* @__PURE__ */ S.createElement(Ao, vt({}, t, {
    ref: r,
    icon: nxe
  }));
}, HZ = /* @__PURE__ */ S.forwardRef(rxe);
process.env.NODE_ENV !== "production" && (HZ.displayName = "DeleteOutlined");
const AR = (function(e, t) {
  if (e && t) {
    var r = Array.isArray(t) ? t : t.split(","), a = e.name || "", i = e.type || "", c = i.replace(/\/.*$/, "");
    return r.some(function(d) {
      var f = d.trim();
      if (/^\*(\/\*)?$/.test(d))
        return !0;
      if (f.charAt(0) === ".") {
        var p = a.toLowerCase(), g = f.toLowerCase(), b = [g];
        return (g === ".jpg" || g === ".jpeg") && (b = [".jpg", ".jpeg"]), b.some(function(w) {
          return p.endsWith(w);
        });
      }
      return /\/\*$/.test(f) ? c === f.replace(/\/.*$/, "") : i === f ? !0 : /^\w+$/.test(f) ? ($n(!1, "Upload takes an invalidate 'accept' type '".concat(f, "'.Skip for check.")), !0) : !1;
    });
  }
  return !0;
});
function axe(e, t) {
  var r = "cannot ".concat(e.method, " ").concat(e.action, " ").concat(t.status, "'"), a = new Error(r);
  return a.status = t.status, a.method = e.method, a.url = e.action, a;
}
function EV(e) {
  var t = e.responseText || e.response;
  if (!t)
    return t;
  try {
    return JSON.parse(t);
  } catch {
    return t;
  }
}
function PV(e) {
  var t = new XMLHttpRequest();
  e.onProgress && t.upload && (t.upload.onprogress = function(c) {
    c.total > 0 && (c.percent = c.loaded / c.total * 100), e.onProgress(c);
  });
  var r = new FormData();
  e.data && Object.keys(e.data).forEach(function(i) {
    var c = e.data[i];
    if (Array.isArray(c)) {
      c.forEach(function(d) {
        r.append("".concat(i, "[]"), d);
      });
      return;
    }
    r.append(i, c);
  }), e.file instanceof Blob ? r.append(e.filename, e.file, e.file.name) : r.append(e.filename, e.file), t.onerror = function(c) {
    e.onError(c);
  }, t.onload = function() {
    return t.status < 200 || t.status >= 300 ? e.onError(axe(e, t), EV(t)) : e.onSuccess(EV(t), t);
  }, t.open(e.method, e.action, !0), e.withCredentials && "withCredentials" in t && (t.withCredentials = !0);
  var a = e.headers || {};
  return a["X-Requested-With"] !== null && t.setRequestHeader("X-Requested-With", "XMLHttpRequest"), Object.keys(a).forEach(function(i) {
    a[i] !== null && t.setRequestHeader(i, a[i]);
  }), t.send(r), {
    abort: function() {
      t.abort();
    }
  };
}
var oxe = /* @__PURE__ */ (function() {
  var e = qh(/* @__PURE__ */ ci().mark(function t(r, a) {
    var i, c, d, f, p, g, b, w;
    return ci().wrap(function(E) {
      for (; ; ) switch (E.prev = E.next) {
        case 0:
          g = function() {
            return g = qh(/* @__PURE__ */ ci().mark(function k(M) {
              return ci().wrap(function(N) {
                for (; ; ) switch (N.prev = N.next) {
                  case 0:
                    return N.abrupt("return", new Promise(function(D) {
                      M.file(function($) {
                        a($) ? (M.fullPath && !$.webkitRelativePath && (Object.defineProperties($, {
                          webkitRelativePath: {
                            writable: !0
                          }
                        }), $.webkitRelativePath = M.fullPath.replace(/^\//, ""), Object.defineProperties($, {
                          webkitRelativePath: {
                            writable: !1
                          }
                        })), D($)) : D(null);
                      });
                    }));
                  case 1:
                  case "end":
                    return N.stop();
                }
              }, k);
            })), g.apply(this, arguments);
          }, p = function(k) {
            return g.apply(this, arguments);
          }, f = function() {
            return f = qh(/* @__PURE__ */ ci().mark(function k(M) {
              var T, N, D, $, j;
              return ci().wrap(function(L) {
                for (; ; ) switch (L.prev = L.next) {
                  case 0:
                    T = M.createReader(), N = [];
                  case 2:
                    return L.next = 5, new Promise(function(F) {
                      T.readEntries(F, function() {
                        return F([]);
                      });
                    });
                  case 5:
                    if (D = L.sent, $ = D.length, $) {
                      L.next = 9;
                      break;
                    }
                    return L.abrupt("break", 12);
                  case 9:
                    for (j = 0; j < $; j++)
                      N.push(D[j]);
                    L.next = 2;
                    break;
                  case 12:
                    return L.abrupt("return", N);
                  case 13:
                  case "end":
                    return L.stop();
                }
              }, k);
            })), f.apply(this, arguments);
          }, d = function(k) {
            return f.apply(this, arguments);
          }, i = [], c = [], r.forEach(function(P) {
            return c.push(P.webkitGetAsEntry());
          }), b = /* @__PURE__ */ (function() {
            var P = qh(/* @__PURE__ */ ci().mark(function k(M, T) {
              var N, D;
              return ci().wrap(function(j) {
                for (; ; ) switch (j.prev = j.next) {
                  case 0:
                    if (M) {
                      j.next = 2;
                      break;
                    }
                    return j.abrupt("return");
                  case 2:
                    if (M.path = T || "", !M.isFile) {
                      j.next = 10;
                      break;
                    }
                    return j.next = 6, p(M);
                  case 6:
                    N = j.sent, N && i.push(N), j.next = 15;
                    break;
                  case 10:
                    if (!M.isDirectory) {
                      j.next = 15;
                      break;
                    }
                    return j.next = 13, d(M);
                  case 13:
                    D = j.sent, c.push.apply(c, Et(D));
                  case 15:
                  case "end":
                    return j.stop();
                }
              }, k);
            }));
            return function(M, T) {
              return P.apply(this, arguments);
            };
          })(), w = 0;
        case 9:
          if (!(w < c.length)) {
            E.next = 15;
            break;
          }
          return E.next = 12, b(c[w]);
        case 12:
          w++, E.next = 9;
          break;
        case 15:
          return E.abrupt("return", i);
        case 16:
        case "end":
          return E.stop();
      }
    }, t);
  }));
  return function(r, a) {
    return e.apply(this, arguments);
  };
})(), ixe = +/* @__PURE__ */ new Date(), lxe = 0;
function NR() {
  return "rc-upload-".concat(ixe, "-").concat(++lxe);
}
var sxe = ["component", "prefixCls", "className", "classNames", "disabled", "id", "name", "style", "styles", "multiple", "accept", "capture", "children", "directory", "folder", "openFileDialogOnClick", "onMouseEnter", "onMouseLeave", "hasControlInside"], uxe = /* @__PURE__ */ (function(e) {
  pd(r, e);
  var t = B0(r);
  function r() {
    var a;
    Vi(this, r);
    for (var i = arguments.length, c = new Array(i), d = 0; d < i; d++)
      c[d] = arguments[d];
    return a = t.call.apply(t, [this].concat(c)), ge(bn(a), "state", {
      uid: NR()
    }), ge(bn(a), "reqs", {}), ge(bn(a), "fileInput", void 0), ge(bn(a), "_isMounted", void 0), ge(bn(a), "onChange", function(f) {
      var p = a.props, g = p.accept, b = p.directory, w = f.target.files, x = Et(w).filter(function(E) {
        return !b || AR(E, g);
      });
      a.uploadFiles(x), a.reset();
    }), ge(bn(a), "onClick", function(f) {
      var p = a.fileInput;
      if (p) {
        var g = f.target, b = a.props.onClick;
        if (g && g.tagName === "BUTTON") {
          var w = p.parentNode;
          w.focus(), g.blur();
        }
        p.click(), b && b(f);
      }
    }), ge(bn(a), "onKeyDown", function(f) {
      f.key === "Enter" && a.onClick(f);
    }), ge(bn(a), "onDataTransferFiles", /* @__PURE__ */ (function() {
      var f = qh(/* @__PURE__ */ ci().mark(function p(g, b) {
        var w, x, E, P, k, M, T;
        return ci().wrap(function(D) {
          for (; ; ) switch (D.prev = D.next) {
            case 0:
              if (w = a.props, x = w.multiple, E = w.accept, P = w.directory, k = Et(g.items || []), M = Et(g.files || []), (M.length > 0 || k.some(function($) {
                return $.kind === "file";
              })) && b?.(), !P) {
                D.next = 11;
                break;
              }
              return D.next = 7, oxe(Array.prototype.slice.call(k), function($) {
                return AR($, a.props.accept);
              });
            case 7:
              M = D.sent, a.uploadFiles(M), D.next = 14;
              break;
            case 11:
              T = Et(M).filter(function($) {
                return AR($, E);
              }), x === !1 && (T = M.slice(0, 1)), a.uploadFiles(T);
            case 14:
            case "end":
              return D.stop();
          }
        }, p);
      }));
      return function(p, g) {
        return f.apply(this, arguments);
      };
    })()), ge(bn(a), "onFilePaste", /* @__PURE__ */ (function() {
      var f = qh(/* @__PURE__ */ ci().mark(function p(g) {
        var b, w;
        return ci().wrap(function(E) {
          for (; ; ) switch (E.prev = E.next) {
            case 0:
              if (b = a.props.pastable, b) {
                E.next = 3;
                break;
              }
              return E.abrupt("return");
            case 3:
              if (g.type !== "paste") {
                E.next = 6;
                break;
              }
              return w = g.clipboardData, E.abrupt("return", a.onDataTransferFiles(w, function() {
                g.preventDefault();
              }));
            case 6:
            case "end":
              return E.stop();
          }
        }, p);
      }));
      return function(p) {
        return f.apply(this, arguments);
      };
    })()), ge(bn(a), "onFileDragOver", function(f) {
      f.preventDefault();
    }), ge(bn(a), "onFileDrop", /* @__PURE__ */ (function() {
      var f = qh(/* @__PURE__ */ ci().mark(function p(g) {
        var b;
        return ci().wrap(function(x) {
          for (; ; ) switch (x.prev = x.next) {
            case 0:
              if (g.preventDefault(), g.type !== "drop") {
                x.next = 4;
                break;
              }
              return b = g.dataTransfer, x.abrupt("return", a.onDataTransferFiles(b));
            case 4:
            case "end":
              return x.stop();
          }
        }, p);
      }));
      return function(p) {
        return f.apply(this, arguments);
      };
    })()), ge(bn(a), "uploadFiles", function(f) {
      var p = Et(f), g = p.map(function(b) {
        return b.uid = NR(), a.processFile(b, p);
      });
      Promise.all(g).then(function(b) {
        var w = a.props.onBatchStart;
        w?.(b.map(function(x) {
          var E = x.origin, P = x.parsedFile;
          return {
            file: E,
            parsedFile: P
          };
        })), b.filter(function(x) {
          return x.parsedFile !== null;
        }).forEach(function(x) {
          a.post(x);
        });
      });
    }), ge(bn(a), "processFile", /* @__PURE__ */ (function() {
      var f = qh(/* @__PURE__ */ ci().mark(function p(g, b) {
        var w, x, E, P, k, M, T, N, D;
        return ci().wrap(function(j) {
          for (; ; ) switch (j.prev = j.next) {
            case 0:
              if (w = a.props.beforeUpload, x = g, !w) {
                j.next = 14;
                break;
              }
              return j.prev = 3, j.next = 6, w(g, b);
            case 6:
              x = j.sent, j.next = 12;
              break;
            case 9:
              j.prev = 9, j.t0 = j.catch(3), x = !1;
            case 12:
              if (x !== !1) {
                j.next = 14;
                break;
              }
              return j.abrupt("return", {
                origin: g,
                parsedFile: null,
                action: null,
                data: null
              });
            case 14:
              if (E = a.props.action, typeof E != "function") {
                j.next = 21;
                break;
              }
              return j.next = 18, E(g);
            case 18:
              P = j.sent, j.next = 22;
              break;
            case 21:
              P = E;
            case 22:
              if (k = a.props.data, typeof k != "function") {
                j.next = 29;
                break;
              }
              return j.next = 26, k(g);
            case 26:
              M = j.sent, j.next = 30;
              break;
            case 29:
              M = k;
            case 30:
              return T = // string type is from legacy `transformFile`.
              // Not sure if this will work since no related test case works with it
              (Hn(x) === "object" || typeof x == "string") && x ? x : g, T instanceof File ? N = T : N = new File([T], g.name, {
                type: g.type
              }), D = N, D.uid = g.uid, j.abrupt("return", {
                origin: g,
                data: M,
                parsedFile: D,
                action: P
              });
            case 35:
            case "end":
              return j.stop();
          }
        }, p, null, [[3, 9]]);
      }));
      return function(p, g) {
        return f.apply(this, arguments);
      };
    })()), ge(bn(a), "saveFileInput", function(f) {
      a.fileInput = f;
    }), a;
  }
  return _i(r, [{
    key: "componentDidMount",
    value: function() {
      this._isMounted = !0;
      var i = this.props.pastable;
      i && document.addEventListener("paste", this.onFilePaste);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this._isMounted = !1, this.abort(), document.removeEventListener("paste", this.onFilePaste);
    }
  }, {
    key: "componentDidUpdate",
    value: function(i) {
      var c = this.props.pastable;
      c && !i.pastable ? document.addEventListener("paste", this.onFilePaste) : !c && i.pastable && document.removeEventListener("paste", this.onFilePaste);
    }
  }, {
    key: "post",
    value: function(i) {
      var c = this, d = i.data, f = i.origin, p = i.action, g = i.parsedFile;
      if (this._isMounted) {
        var b = this.props, w = b.onStart, x = b.customRequest, E = b.name, P = b.headers, k = b.withCredentials, M = b.method, T = f.uid, N = x || PV, D = {
          action: p,
          filename: E,
          data: d,
          file: g,
          headers: P,
          withCredentials: k,
          method: M || "post",
          onProgress: function(j) {
            var I = c.props.onProgress;
            I?.(j, g);
          },
          onSuccess: function(j, I) {
            var L = c.props.onSuccess;
            L?.(j, g, I), delete c.reqs[T];
          },
          onError: function(j, I) {
            var L = c.props.onError;
            L?.(j, I, g), delete c.reqs[T];
          }
        };
        w(f), this.reqs[T] = N(D, {
          defaultRequest: PV
        });
      }
    }
  }, {
    key: "reset",
    value: function() {
      this.setState({
        uid: NR()
      });
    }
  }, {
    key: "abort",
    value: function(i) {
      var c = this.reqs;
      if (i) {
        var d = i.uid ? i.uid : i;
        c[d] && c[d].abort && c[d].abort(), delete c[d];
      } else
        Object.keys(c).forEach(function(f) {
          c[f] && c[f].abort && c[f].abort(), delete c[f];
        });
    }
  }, {
    key: "render",
    value: function() {
      var i = this.props, c = i.component, d = i.prefixCls, f = i.className, p = i.classNames, g = p === void 0 ? {} : p, b = i.disabled, w = i.id, x = i.name, E = i.style, P = i.styles, k = P === void 0 ? {} : P, M = i.multiple, T = i.accept, N = i.capture, D = i.children, $ = i.directory, j = i.folder, I = i.openFileDialogOnClick, L = i.onMouseEnter, F = i.onMouseLeave, _ = i.hasControlInside, W = xr(i, sxe), Q = _e(ge(ge(ge({}, d, !0), "".concat(d, "-disabled"), b), f, f)), U = $ || j ? {
        directory: "directory",
        webkitdirectory: "webkitdirectory"
      } : {}, Y = b ? {} : {
        onClick: I ? this.onClick : function() {
        },
        onKeyDown: I ? this.onKeyDown : function() {
        },
        onMouseEnter: L,
        onMouseLeave: F,
        onDrop: this.onFileDrop,
        onDragOver: this.onFileDragOver,
        tabIndex: _ ? void 0 : "0"
      };
      return /* @__PURE__ */ Re.createElement(c, vt({}, Y, {
        className: Q,
        role: _ ? void 0 : "button",
        style: E
      }), /* @__PURE__ */ Re.createElement("input", vt({}, Zu(W, {
        aria: !0,
        data: !0
      }), {
        id: w,
        name: x,
        disabled: b,
        type: "file",
        ref: this.saveFileInput,
        onClick: function(J) {
          return J.stopPropagation();
        },
        key: this.state.uid,
        style: ce({
          display: "none"
        }, k.input),
        className: g.input,
        accept: T
      }, U, {
        multiple: M,
        onChange: this.onChange
      }, N != null ? {
        capture: N
      } : {})), D);
    }
  }]), r;
})(Cz);
function DR() {
}
var s$ = /* @__PURE__ */ (function(e) {
  pd(r, e);
  var t = B0(r);
  function r() {
    var a;
    Vi(this, r);
    for (var i = arguments.length, c = new Array(i), d = 0; d < i; d++)
      c[d] = arguments[d];
    return a = t.call.apply(t, [this].concat(c)), ge(bn(a), "uploader", void 0), ge(bn(a), "saveUploader", function(f) {
      a.uploader = f;
    }), a;
  }
  return _i(r, [{
    key: "abort",
    value: function(i) {
      this.uploader.abort(i);
    }
  }, {
    key: "render",
    value: function() {
      return /* @__PURE__ */ Re.createElement(uxe, vt({}, this.props, {
        ref: this.saveUploader
      }));
    }
  }]), r;
})(Cz);
ge(s$, "defaultProps", {
  component: "span",
  prefixCls: "rc-upload",
  data: {},
  headers: {},
  name: "file",
  multipart: !1,
  onStart: DR,
  onError: DR,
  onSuccess: DR,
  multiple: !1,
  beforeUpload: null,
  customRequest: null,
  withCredentials: !1,
  openFileDialogOnClick: !0,
  hasControlInside: !1
});
const cxe = (e) => {
  const {
    componentCls: t,
    iconCls: r
  } = e;
  return {
    [`${t}-wrapper`]: {
      [`${t}-drag`]: {
        position: "relative",
        width: "100%",
        height: "100%",
        textAlign: "center",
        background: e.colorFillAlter,
        border: `${Ye(e.lineWidth)} dashed ${e.colorBorder}`,
        borderRadius: e.borderRadiusLG,
        cursor: "pointer",
        transition: `border-color ${e.motionDurationSlow}`,
        [t]: {
          padding: e.padding
        },
        [`${t}-btn`]: {
          display: "table",
          width: "100%",
          height: "100%",
          outline: "none",
          borderRadius: e.borderRadiusLG,
          "&:focus-visible": {
            outline: `${Ye(e.lineWidthFocus)} solid ${e.colorPrimaryBorder}`
          }
        },
        [`${t}-drag-container`]: {
          display: "table-cell",
          verticalAlign: "middle"
        },
        [`
          &:not(${t}-disabled):hover,
          &-hover:not(${t}-disabled)
        `]: {
          borderColor: e.colorPrimaryHover
        },
        [`p${t}-drag-icon`]: {
          marginBottom: e.margin,
          [r]: {
            color: e.colorPrimary,
            fontSize: e.uploadThumbnailSize
          }
        },
        [`p${t}-text`]: {
          margin: `0 0 ${Ye(e.marginXXS)}`,
          color: e.colorTextHeading,
          fontSize: e.fontSizeLG
        },
        [`p${t}-hint`]: {
          color: e.colorTextDescription,
          fontSize: e.fontSize
        },
        // ===================== Disabled =====================
        [`&${t}-disabled`]: {
          [`p${t}-drag-icon ${r},
            p${t}-text,
            p${t}-hint
          `]: {
            color: e.colorTextDisabled
          }
        }
      }
    }
  };
}, dxe = (e) => {
  const {
    componentCls: t,
    iconCls: r,
    fontSize: a,
    lineHeight: i,
    calc: c
  } = e, d = `${t}-list-item`, f = `${d}-actions`, p = `${d}-action`;
  return {
    [`${t}-wrapper`]: {
      [`${t}-list`]: Object.assign(Object.assign({}, J4()), {
        lineHeight: e.lineHeight,
        [d]: {
          position: "relative",
          height: c(e.lineHeight).mul(a).equal(),
          marginTop: e.marginXS,
          fontSize: a,
          display: "flex",
          alignItems: "center",
          transition: `background-color ${e.motionDurationSlow}`,
          borderRadius: e.borderRadiusSM,
          "&:hover": {
            backgroundColor: e.controlItemBgHover
          },
          [`${d}-name`]: Object.assign(Object.assign({}, VS), {
            padding: `0 ${Ye(e.paddingXS)}`,
            lineHeight: i,
            flex: "auto",
            transition: `all ${e.motionDurationSlow}`
          }),
          [f]: {
            whiteSpace: "nowrap",
            [p]: {
              opacity: 0
            },
            [r]: {
              color: e.actionsColor,
              transition: `all ${e.motionDurationSlow}`
            },
            [`
              ${p}:focus-visible,
              &.picture ${p}
            `]: {
              opacity: 1
            }
          },
          [`${t}-icon ${r}`]: {
            color: e.colorIcon,
            fontSize: a
          },
          [`${d}-progress`]: {
            position: "absolute",
            bottom: e.calc(e.uploadProgressOffset).mul(-1).equal(),
            width: "100%",
            paddingInlineStart: c(a).add(e.paddingXS).equal(),
            fontSize: a,
            lineHeight: 0,
            pointerEvents: "none",
            "> div": {
              margin: 0
            }
          }
        },
        [`${d}:hover ${p}`]: {
          opacity: 1
        },
        [`${d}-error`]: {
          color: e.colorError,
          [`${d}-name, ${t}-icon ${r}`]: {
            color: e.colorError
          },
          [f]: {
            [`${r}, ${r}:hover`]: {
              color: e.colorError
            },
            [p]: {
              opacity: 1
            }
          }
        },
        [`${t}-list-item-container`]: {
          transition: `opacity ${e.motionDurationSlow}, height ${e.motionDurationSlow}`,
          // For smooth removing animation
          "&::before": {
            display: "table",
            width: 0,
            height: 0,
            content: '""'
          }
        }
      })
    }
  };
}, fxe = (e) => {
  const {
    componentCls: t
  } = e, r = new bo("uploadAnimateInlineIn", {
    from: {
      width: 0,
      height: 0,
      padding: 0,
      opacity: 0,
      margin: e.calc(e.marginXS).div(-2).equal()
    }
  }), a = new bo("uploadAnimateInlineOut", {
    to: {
      width: 0,
      height: 0,
      padding: 0,
      opacity: 0,
      margin: e.calc(e.marginXS).div(-2).equal()
    }
  }), i = `${t}-animate-inline`;
  return [{
    [`${t}-wrapper`]: {
      [`${i}-appear, ${i}-enter, ${i}-leave`]: {
        animationDuration: e.motionDurationSlow,
        animationTimingFunction: e.motionEaseInOutCirc,
        animationFillMode: "forwards"
      },
      [`${i}-appear, ${i}-enter`]: {
        animationName: r
      },
      [`${i}-leave`]: {
        animationName: a
      }
    }
  }, {
    [`${t}-wrapper`]: uK(e)
  }, r, a];
}, mxe = (e) => {
  const {
    componentCls: t,
    iconCls: r,
    uploadThumbnailSize: a,
    uploadProgressOffset: i,
    calc: c
  } = e, d = `${t}-list`, f = `${d}-item`;
  return {
    [`${t}-wrapper`]: {
      // ${listCls} 增加优先级
      [`
        ${d}${d}-picture,
        ${d}${d}-picture-card,
        ${d}${d}-picture-circle
      `]: {
        [f]: {
          position: "relative",
          height: c(a).add(c(e.lineWidth).mul(2)).add(c(e.paddingXS).mul(2)).equal(),
          padding: e.paddingXS,
          border: `${Ye(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderRadius: e.borderRadiusLG,
          "&:hover": {
            background: "transparent"
          },
          [`${f}-thumbnail`]: Object.assign(Object.assign({}, VS), {
            width: a,
            height: a,
            lineHeight: Ye(c(a).add(e.paddingSM).equal()),
            textAlign: "center",
            flex: "none",
            [r]: {
              fontSize: e.fontSizeHeading2,
              color: e.colorPrimary
            },
            img: {
              display: "block",
              width: "100%",
              height: "100%",
              overflow: "hidden"
            }
          }),
          [`${f}-progress`]: {
            bottom: i,
            width: `calc(100% - ${Ye(c(e.paddingSM).mul(2).equal())})`,
            marginTop: 0,
            paddingInlineStart: c(a).add(e.paddingXS).equal()
          }
        },
        [`${f}-error`]: {
          borderColor: e.colorError,
          // Adjust the color of the error icon : https://github.com/ant-design/ant-design/pull/24160
          [`${f}-thumbnail ${r}`]: {
            [`svg path[fill='${wx[0]}']`]: {
              fill: e.colorErrorBg
            },
            [`svg path[fill='${wx.primary}']`]: {
              fill: e.colorError
            }
          }
        },
        [`${f}-uploading`]: {
          borderStyle: "dashed",
          [`${f}-name`]: {
            marginBottom: i
          }
        }
      },
      [`${d}${d}-picture-circle ${f}`]: {
        [`&, &::before, ${f}-thumbnail`]: {
          borderRadius: "50%"
        }
      }
    }
  };
}, hxe = (e) => {
  const {
    componentCls: t,
    iconCls: r,
    fontSizeLG: a,
    colorTextLightSolid: i,
    calc: c
  } = e, d = `${t}-list`, f = `${d}-item`, p = e.uploadPicCardSize;
  return {
    [`
      ${t}-wrapper${t}-picture-card-wrapper,
      ${t}-wrapper${t}-picture-circle-wrapper
    `]: Object.assign(Object.assign({}, J4()), {
      display: "block",
      [`${t}${t}-select`]: {
        width: p,
        height: p,
        textAlign: "center",
        verticalAlign: "top",
        backgroundColor: e.colorFillAlter,
        border: `${Ye(e.lineWidth)} dashed ${e.colorBorder}`,
        borderRadius: e.borderRadiusLG,
        cursor: "pointer",
        transition: `border-color ${e.motionDurationSlow}`,
        [`> ${t}`]: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          textAlign: "center"
        },
        [`&:not(${t}-disabled):hover`]: {
          borderColor: e.colorPrimary
        }
      },
      // list
      [`${d}${d}-picture-card, ${d}${d}-picture-circle`]: {
        display: "flex",
        flexWrap: "wrap",
        "@supports not (gap: 1px)": {
          "& > *": {
            marginBlockEnd: e.marginXS,
            marginInlineEnd: e.marginXS
          }
        },
        "@supports (gap: 1px)": {
          gap: e.marginXS
        },
        [`${d}-item-container`]: {
          display: "inline-block",
          width: p,
          height: p,
          verticalAlign: "top"
        },
        "&::after": {
          display: "none"
        },
        "&::before": {
          display: "none"
        },
        [f]: {
          height: "100%",
          margin: 0,
          "&::before": {
            position: "absolute",
            zIndex: 1,
            width: `calc(100% - ${Ye(c(e.paddingXS).mul(2).equal())})`,
            height: `calc(100% - ${Ye(c(e.paddingXS).mul(2).equal())})`,
            backgroundColor: e.colorBgMask,
            opacity: 0,
            transition: `all ${e.motionDurationSlow}`,
            content: '" "'
          }
        },
        [`${f}:hover`]: {
          [`&::before, ${f}-actions`]: {
            opacity: 1
          }
        },
        [`${f}-actions`]: {
          position: "absolute",
          insetInlineStart: 0,
          zIndex: 10,
          width: "100%",
          whiteSpace: "nowrap",
          textAlign: "center",
          opacity: 0,
          transition: `all ${e.motionDurationSlow}`,
          [`
            ${r}-eye,
            ${r}-download,
            ${r}-delete
          `]: {
            zIndex: 10,
            width: a,
            margin: `0 ${Ye(e.marginXXS)}`,
            fontSize: a,
            cursor: "pointer",
            transition: `all ${e.motionDurationSlow}`,
            color: i,
            "&:hover": {
              color: i
            },
            svg: {
              verticalAlign: "baseline"
            }
          }
        },
        [`${f}-thumbnail, ${f}-thumbnail img`]: {
          position: "static",
          display: "block",
          width: "100%",
          height: "100%",
          objectFit: "contain"
        },
        [`${f}-name`]: {
          display: "none",
          textAlign: "center"
        },
        [`${f}-file + ${f}-name`]: {
          position: "absolute",
          bottom: e.margin,
          display: "block",
          width: `calc(100% - ${Ye(c(e.paddingXS).mul(2).equal())})`
        },
        [`${f}-uploading`]: {
          [`&${f}`]: {
            backgroundColor: e.colorFillAlter
          },
          [`&::before, ${r}-eye, ${r}-download, ${r}-delete`]: {
            display: "none"
          }
        },
        [`${f}-progress`]: {
          bottom: e.marginXL,
          width: `calc(100% - ${Ye(c(e.paddingXS).mul(2).equal())})`,
          paddingInlineStart: 0
        }
      }
    }),
    [`${t}-wrapper${t}-picture-circle-wrapper`]: {
      [`${t}${t}-select`]: {
        borderRadius: "50%"
      }
    }
  };
}, pxe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-rtl`]: {
      direction: "rtl"
    }
  };
}, gxe = (e) => {
  const {
    componentCls: t,
    colorTextDisabled: r
  } = e;
  return {
    [`${t}-wrapper`]: Object.assign(Object.assign({}, dl(e)), {
      [t]: {
        outline: 0,
        "input[type='file']": {
          cursor: "pointer"
        }
      },
      [`${t}-select`]: {
        display: "inline-block"
      },
      [`${t}-hidden`]: {
        display: "none"
      },
      [`${t}-disabled`]: {
        color: r,
        cursor: "not-allowed"
      }
    })
  };
}, vxe = (e) => ({
  actionsColor: e.colorIcon,
  pictureCardSize: e.controlHeightLG * 2.55
}), bxe = Ii("Upload", (e) => {
  const {
    fontSizeHeading3: t,
    fontHeight: r,
    lineWidth: a,
    pictureCardSize: i,
    calc: c
  } = e, d = lo(e, {
    uploadThumbnailSize: c(t).mul(2).equal(),
    uploadProgressOffset: c(c(r).div(2)).add(a).equal(),
    uploadPicCardSize: i
  });
  return [gxe(d), cxe(d), mxe(d), hxe(d), dxe(d), fxe(d), pxe(d), Vz(d)];
}, vxe);
var yxe = { icon: function(t, r) {
  return { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M534 352V136H232v752h560V394H576a42 42 0 01-42-42z", fill: r } }, { tag: "path", attrs: { d: "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", fill: t } }] };
}, name: "file", theme: "twotone" }, wxe = function(t, r) {
  return /* @__PURE__ */ S.createElement(Ao, vt({}, t, {
    ref: r,
    icon: yxe
  }));
}, FZ = /* @__PURE__ */ S.forwardRef(wxe);
process.env.NODE_ENV !== "production" && (FZ.displayName = "FileTwoTone");
var Sxe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 00174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z" } }] }, name: "paper-clip", theme: "outlined" }, Cxe = function(t, r) {
  return /* @__PURE__ */ S.createElement(Ao, vt({}, t, {
    ref: r,
    icon: Sxe
  }));
}, WZ = /* @__PURE__ */ S.forwardRef(Cxe);
process.env.NODE_ENV !== "production" && (WZ.displayName = "PaperClipOutlined");
var xxe = { icon: function(t, r) {
  return { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2z", fill: t } }, { tag: "path", attrs: { d: "M424.6 765.8l-150.1-178L136 752.1V792h752v-30.4L658.1 489z", fill: r } }, { tag: "path", attrs: { d: "M136 652.7l132.4-157c3.2-3.8 9-3.8 12.2 0l144 170.7L652 396.8c3.2-3.8 9-3.8 12.2 0L888 662.2V232H136v420.7zM304 280a88 88 0 110 176 88 88 0 010-176z", fill: r } }, { tag: "path", attrs: { d: "M276 368a28 28 0 1056 0 28 28 0 10-56 0z", fill: r } }, { tag: "path", attrs: { d: "M304 456a88 88 0 100-176 88 88 0 000 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z", fill: t } }] };
}, name: "picture", theme: "twotone" }, Exe = function(t, r) {
  return /* @__PURE__ */ S.createElement(Ao, vt({}, t, {
    ref: r,
    icon: xxe
  }));
}, VZ = /* @__PURE__ */ S.forwardRef(Exe);
process.env.NODE_ENV !== "production" && (VZ.displayName = "PictureTwoTone");
function Q7(e) {
  return Object.assign(Object.assign({}, e), {
    lastModified: e.lastModified,
    lastModifiedDate: e.lastModifiedDate,
    name: e.name,
    size: e.size,
    type: e.type,
    uid: e.uid,
    percent: 0,
    originFileObj: e
  });
}
function J7(e, t) {
  const r = Et(t), a = r.findIndex(({
    uid: i
  }) => i === e.uid);
  return a === -1 ? r.push(e) : r[a] = e, r;
}
function $R(e, t) {
  const r = e.uid !== void 0 ? "uid" : "name";
  return t.filter((a) => a[r] === e[r])[0];
}
function Pxe(e, t) {
  const r = e.uid !== void 0 ? "uid" : "name", a = t.filter((i) => i[r] !== e[r]);
  return a.length === t.length ? null : a;
}
const kxe = (e = "") => {
  const t = e.split("/"), a = t[t.length - 1].split(/#|\?/)[0];
  return (/\.[^./\\]*$/.exec(a) || [""])[0];
}, _Z = (e) => e.indexOf("image/") === 0, Mxe = (e) => {
  if (e.type && !e.thumbUrl)
    return _Z(e.type);
  const t = e.thumbUrl || e.url || "", r = kxe(t);
  return /^data:image\//.test(t) || /(webp|svg|png|gif|jpg|jpeg|jfif|bmp|dpg|ico|heic|heif)$/i.test(r) ? !0 : !(/^data:/.test(t) || r);
}, SS = 200;
function Oxe(e) {
  return new Promise((t) => {
    if (!e.type || !_Z(e.type)) {
      t("");
      return;
    }
    const r = document.createElement("canvas");
    r.width = SS, r.height = SS, r.style.cssText = `position: fixed; left: 0; top: 0; width: ${SS}px; height: ${SS}px; z-index: 9999; display: none;`, document.body.appendChild(r);
    const a = r.getContext("2d"), i = new Image();
    if (i.onload = () => {
      const {
        width: c,
        height: d
      } = i;
      let f = SS, p = SS, g = 0, b = 0;
      c > d ? (p = d * (SS / c), b = -(p - f) / 2) : (f = c * (SS / d), g = -(f - p) / 2), a.drawImage(i, g, b, f, p);
      const w = r.toDataURL();
      document.body.removeChild(r), window.URL.revokeObjectURL(i.src), t(w);
    }, i.crossOrigin = "anonymous", e.type.startsWith("image/svg+xml")) {
      const c = new FileReader();
      c.onload = () => {
        c.result && typeof c.result == "string" && (i.src = c.result);
      }, c.readAsDataURL(e);
    } else if (e.type.startsWith("image/gif")) {
      const c = new FileReader();
      c.onload = () => {
        c.result && t(c.result);
      }, c.readAsDataURL(e);
    } else
      i.src = window.URL.createObjectURL(e);
  });
}
var Txe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M505.7 661a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z" } }] }, name: "download", theme: "outlined" }, Rxe = function(t, r) {
  return /* @__PURE__ */ S.createElement(Ao, vt({}, t, {
    ref: r,
    icon: Txe
  }));
}, BZ = /* @__PURE__ */ S.forwardRef(Rxe);
process.env.NODE_ENV !== "production" && (BZ.displayName = "DownloadOutlined");
const Axe = /* @__PURE__ */ S.forwardRef(({
  prefixCls: e,
  className: t,
  style: r,
  locale: a,
  listType: i,
  file: c,
  items: d,
  progress: f,
  iconRender: p,
  actionIconRender: g,
  itemRender: b,
  isImgUrl: w,
  showPreviewIcon: x,
  showRemoveIcon: E,
  showDownloadIcon: P,
  previewIcon: k,
  removeIcon: M,
  downloadIcon: T,
  extra: N,
  onPreview: D,
  onDownload: $,
  onClose: j
}, I) => {
  var L, F;
  const {
    status: _
  } = c, [W, Q] = S.useState(_);
  S.useEffect(() => {
    _ !== "removed" && Q(_);
  }, [_]);
  const [U, Y] = S.useState(!1);
  S.useEffect(() => {
    const se = setTimeout(() => {
      Y(!0);
    }, 300);
    return () => {
      clearTimeout(se);
    };
  }, []);
  const G = p(c);
  let J = /* @__PURE__ */ S.createElement("div", {
    className: `${e}-icon`
  }, G);
  if (i === "picture" || i === "picture-card" || i === "picture-circle")
    if (W === "uploading" || !c.thumbUrl && !c.url) {
      const se = _e(`${e}-list-item-thumbnail`, {
        [`${e}-list-item-file`]: W !== "uploading"
      });
      J = /* @__PURE__ */ S.createElement("div", {
        className: se
      }, G);
    } else {
      const se = w?.(c) ? /* @__PURE__ */ S.createElement("img", {
        src: c.thumbUrl || c.url,
        alt: c.name,
        className: `${e}-list-item-image`,
        crossOrigin: c.crossOrigin
      }) : G, Ae = _e(`${e}-list-item-thumbnail`, {
        [`${e}-list-item-file`]: w && !w(c)
      });
      J = /* @__PURE__ */ S.createElement("a", {
        className: Ae,
        onClick: (we) => D(c, we),
        href: c.url || c.thumbUrl,
        target: "_blank",
        rel: "noopener noreferrer"
      }, se);
    }
  const H = _e(`${e}-list-item`, `${e}-list-item-${W}`), K = typeof c.linkProps == "string" ? JSON.parse(c.linkProps) : c.linkProps, X = (typeof E == "function" ? E(c) : E) ? g(
    (typeof M == "function" ? M(c) : M) || /* @__PURE__ */ S.createElement(HZ, null),
    () => j(c),
    e,
    a.removeFile,
    // acceptUploadDisabled is true, only remove icon will follow Upload disabled prop
    // https://github.com/ant-design/ant-design/issues/46171
    !0
  ) : null, te = (typeof P == "function" ? P(c) : P) && W === "done" ? g((typeof T == "function" ? T(c) : T) || /* @__PURE__ */ S.createElement(BZ, null), () => $(c), e, a.downloadFile) : null, ie = i !== "picture-card" && i !== "picture-circle" && /* @__PURE__ */ S.createElement("span", {
    key: "download-delete",
    className: _e(`${e}-list-item-actions`, {
      picture: i === "picture"
    })
  }, te, X), ee = typeof N == "function" ? N(c) : N, ne = ee && /* @__PURE__ */ S.createElement("span", {
    className: `${e}-list-item-extra`
  }, ee), ae = _e(`${e}-list-item-name`), oe = c.url ? /* @__PURE__ */ S.createElement("a", Object.assign({
    key: "view",
    target: "_blank",
    rel: "noopener noreferrer",
    className: ae,
    title: c.name
  }, K, {
    href: c.url,
    onClick: (se) => D(c, se)
  }), c.name, ne) : /* @__PURE__ */ S.createElement("span", {
    key: "view",
    className: ae,
    onClick: (se) => D(c, se),
    title: c.name
  }, c.name, ne), fe = (typeof x == "function" ? x(c) : x) && (c.url || c.thumbUrl) ? /* @__PURE__ */ S.createElement("a", {
    href: c.url || c.thumbUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: (se) => D(c, se),
    title: a.previewFile
  }, typeof k == "function" ? k(c) : k || /* @__PURE__ */ S.createElement(RJ, null)) : null, be = (i === "picture-card" || i === "picture-circle") && W !== "uploading" && /* @__PURE__ */ S.createElement("span", {
    className: `${e}-list-item-actions`
  }, fe, W === "done" && te, X), {
    getPrefixCls: me
  } = S.useContext(Qr), De = me(), Me = /* @__PURE__ */ S.createElement("div", {
    className: H
  }, J, oe, ie, be, U && /* @__PURE__ */ S.createElement(N0, {
    motionName: `${De}-fade`,
    visible: W === "uploading",
    motionDeadline: 2e3
  }, ({
    className: se
  }) => {
    const Ae = "percent" in c ? /* @__PURE__ */ S.createElement(_J, Object.assign({
      type: "line",
      percent: c.percent,
      "aria-label": c["aria-label"],
      "aria-labelledby": c["aria-labelledby"]
    }, f)) : null;
    return /* @__PURE__ */ S.createElement("div", {
      className: _e(`${e}-list-item-progress`, se)
    }, Ae);
  })), ze = c.response && typeof c.response == "string" ? c.response : ((L = c.error) === null || L === void 0 ? void 0 : L.statusText) || ((F = c.error) === null || F === void 0 ? void 0 : F.message) || a.uploadError, le = W === "error" ? /* @__PURE__ */ S.createElement(U1, {
    title: ze,
    getPopupContainer: (se) => se.parentNode
  }, Me) : Me;
  return /* @__PURE__ */ S.createElement("div", {
    className: _e(`${e}-list-item-container`, t),
    style: r,
    ref: I
  }, b ? b(le, c, d, {
    download: $.bind(null, c),
    preview: D.bind(null, c),
    remove: j.bind(null, c)
  }) : le);
}), Nxe = (e, t) => {
  const {
    listType: r = "text",
    previewFile: a = Oxe,
    onPreview: i,
    onDownload: c,
    onRemove: d,
    locale: f,
    iconRender: p,
    isImageUrl: g = Mxe,
    prefixCls: b,
    items: w = [],
    showPreviewIcon: x = !0,
    showRemoveIcon: E = !0,
    showDownloadIcon: P = !1,
    removeIcon: k,
    previewIcon: M,
    downloadIcon: T,
    extra: N,
    progress: D = {
      size: [-1, 2],
      showInfo: !1
    },
    appendAction: $,
    appendActionVisible: j = !0,
    itemRender: I,
    disabled: L
  } = e, [, F] = Lz(), [_, W] = S.useState(!1), Q = ["picture-card", "picture-circle"].includes(r);
  S.useEffect(() => {
    r.startsWith("picture") && (w || []).forEach((ae) => {
      !(ae.originFileObj instanceof File || ae.originFileObj instanceof Blob) || ae.thumbUrl !== void 0 || (ae.thumbUrl = "", a?.(ae.originFileObj).then((oe) => {
        ae.thumbUrl = oe || "", F();
      }));
    });
  }, [r, w, a]), S.useEffect(() => {
    W(!0);
  }, []);
  const U = (ae, oe) => {
    if (i)
      return oe?.preventDefault(), i(ae);
  }, Y = (ae) => {
    typeof c == "function" ? c(ae) : ae.url && window.open(ae.url);
  }, G = (ae) => {
    d?.(ae);
  }, J = (ae) => {
    if (p)
      return p(ae, r);
    const oe = ae.status === "uploading";
    if (r.startsWith("picture")) {
      const fe = r === "picture" ? /* @__PURE__ */ S.createElement(xx, null) : f.uploading, be = g?.(ae) ? /* @__PURE__ */ S.createElement(VZ, null) : /* @__PURE__ */ S.createElement(FZ, null);
      return oe ? fe : be;
    }
    return oe ? /* @__PURE__ */ S.createElement(xx, null) : /* @__PURE__ */ S.createElement(WZ, null);
  }, H = (ae, oe, fe, be, me) => {
    const De = {
      type: "text",
      size: "small",
      title: be,
      onClick: (Me) => {
        var ze, le;
        oe(), /* @__PURE__ */ S.isValidElement(ae) && ((le = (ze = ae.props).onClick) === null || le === void 0 || le.call(ze, Me));
      },
      className: `${fe}-list-item-action`,
      disabled: me ? L : !1
    };
    return /* @__PURE__ */ S.isValidElement(ae) ? /* @__PURE__ */ S.createElement(cp, Object.assign({}, De, {
      icon: up(ae, Object.assign(Object.assign({}, ae.props), {
        onClick: () => {
        }
      }))
    })) : /* @__PURE__ */ S.createElement(cp, Object.assign({}, De), /* @__PURE__ */ S.createElement("span", null, ae));
  };
  S.useImperativeHandle(t, () => ({
    handlePreview: U,
    handleDownload: Y
  }));
  const {
    getPrefixCls: K
  } = S.useContext(Qr), X = K("upload", b), te = K(), ie = _e(`${X}-list`, `${X}-list-${r}`), ee = S.useMemo(() => Rs(Wz(te), ["onAppearEnd", "onEnterEnd", "onLeaveEnd"]), [te]), ne = Object.assign(Object.assign({}, Q ? {} : ee), {
    motionDeadline: 2e3,
    motionName: `${X}-${Q ? "animate-inline" : "animate"}`,
    keys: Et(w.map((ae) => ({
      key: ae.uid,
      file: ae
    }))),
    motionAppear: _
  });
  return /* @__PURE__ */ S.createElement("div", {
    className: ie
  }, /* @__PURE__ */ S.createElement(Ace, Object.assign({}, ne, {
    component: !1
  }), ({
    key: ae,
    file: oe,
    className: fe,
    style: be
  }) => /* @__PURE__ */ S.createElement(Axe, {
    key: ae,
    locale: f,
    prefixCls: X,
    className: fe,
    style: be,
    file: oe,
    items: w,
    progress: D,
    listType: r,
    isImgUrl: g,
    showPreviewIcon: x,
    showRemoveIcon: E,
    showDownloadIcon: P,
    removeIcon: k,
    previewIcon: M,
    downloadIcon: T,
    extra: N,
    iconRender: J,
    actionIconRender: H,
    itemRender: I,
    onPreview: U,
    onDownload: Y,
    onClose: G
  })), $ && /* @__PURE__ */ S.createElement(N0, Object.assign({}, ne, {
    visible: j,
    forceRender: !0
  }), ({
    className: ae,
    style: oe
  }) => up($, (fe) => ({
    className: _e(fe.className, ae),
    style: Object.assign(Object.assign(Object.assign({}, oe), {
      // prevent the element has hover css pseudo-class that may cause animation to end prematurely.
      pointerEvents: ae ? "none" : void 0
    }), fe.style)
  }))));
}, UZ = /* @__PURE__ */ S.forwardRef(Nxe);
process.env.NODE_ENV !== "production" && (UZ.displayName = "UploadList");
var Dxe = function(e, t, r, a) {
  function i(c) {
    return c instanceof r ? c : new r(function(d) {
      d(c);
    });
  }
  return new (r || (r = Promise))(function(c, d) {
    function f(b) {
      try {
        g(a.next(b));
      } catch (w) {
        d(w);
      }
    }
    function p(b) {
      try {
        g(a.throw(b));
      } catch (w) {
        d(w);
      }
    }
    function g(b) {
      b.done ? c(b.value) : i(b.value).then(f, p);
    }
    g((a = a.apply(e, t || [])).next());
  });
};
const sE = `__LIST_IGNORE_${Date.now()}__`, $xe = (e, t) => {
  const r = om("upload"), {
    fileList: a,
    defaultFileList: i,
    onRemove: c,
    showUploadList: d = !0,
    listType: f = "text",
    onPreview: p,
    onDownload: g,
    onChange: b,
    onDrop: w,
    previewFile: x,
    disabled: E,
    locale: P,
    iconRender: k,
    isImageUrl: M,
    progress: T,
    prefixCls: N,
    className: D,
    type: $ = "select",
    children: j,
    style: I,
    itemRender: L,
    maxCount: F,
    data: _ = {},
    multiple: W = !1,
    hasControlInside: Q = !0,
    action: U = "",
    accept: Y = "",
    supportServerRender: G = !0,
    rootClassName: J
  } = e, H = S.useContext(A0), K = E ?? H, X = e.customRequest || r.customRequest, [te, ie] = ll(i || [], {
    value: a,
    postState: (ot) => ot ?? []
  }), [ee, ne] = S.useState("drop"), ae = S.useRef(null), oe = S.useRef(null);
  if (process.env.NODE_ENV !== "production") {
    const ot = To("Upload");
    process.env.NODE_ENV !== "production" && ot("fileList" in e || !("value" in e), "usage", "`value` is not a valid prop, do you mean `fileList`?"), ot.deprecated(!("transformFile" in e), "transformFile", "beforeUpload");
  }
  S.useMemo(() => {
    const ot = Date.now();
    (a || []).forEach((at, ft) => {
      !at.uid && !Object.isFrozen(at) && (at.uid = `__AUTO__${ot}_${ft}__`);
    });
  }, [a]);
  const fe = (ot, at, ft) => {
    let st = Et(at), pt = !1;
    F === 1 ? st = st.slice(-1) : F && (pt = st.length > F, st = st.slice(0, F)), FS(() => {
      ie(st);
    });
    const bt = {
      file: ot,
      fileList: st
    };
    ft && (bt.event = ft), (!pt || ot.status === "removed" || // We should ignore event if current file is exceed `maxCount`
    st.some((Nt) => Nt.uid === ot.uid)) && FS(() => {
      b?.(bt);
    });
  }, be = (ot, at) => Dxe(void 0, void 0, void 0, function* () {
    const {
      beforeUpload: ft,
      transformFile: st
    } = e;
    let pt = ot;
    if (ft) {
      const bt = yield ft(ot, at);
      if (bt === !1)
        return !1;
      if (delete ot[sE], bt === sE)
        return Object.defineProperty(ot, sE, {
          value: !0,
          configurable: !0
        }), !1;
      typeof bt == "object" && bt && (pt = bt);
    }
    return st && (pt = yield st(pt)), pt;
  }), me = (ot) => {
    const at = ot.filter((pt) => !pt.file[sE]);
    if (!at.length)
      return;
    const ft = at.map((pt) => Q7(pt.file));
    let st = Et(te);
    ft.forEach((pt) => {
      st = J7(pt, st);
    }), ft.forEach((pt, bt) => {
      let Nt = pt;
      if (at[bt].parsedFile)
        pt.status = "uploading";
      else {
        const {
          originFileObj: $t
        } = pt;
        let Pt;
        try {
          Pt = new File([$t], $t.name, {
            type: $t.type
          });
        } catch {
          Pt = new Blob([$t], {
            type: $t.type
          }), Pt.name = $t.name, Pt.lastModifiedDate = /* @__PURE__ */ new Date(), Pt.lastModified = (/* @__PURE__ */ new Date()).getTime();
        }
        Pt.uid = pt.uid, Nt = Pt;
      }
      fe(Nt, st);
    });
  }, De = (ot, at, ft) => {
    try {
      typeof ot == "string" && (ot = JSON.parse(ot));
    } catch {
    }
    if (!$R(at, te))
      return;
    const st = Q7(at);
    st.status = "done", st.percent = 100, st.response = ot, st.xhr = ft;
    const pt = J7(st, te);
    fe(st, pt);
  }, Me = (ot, at) => {
    if (!$R(at, te))
      return;
    const ft = Q7(at);
    ft.status = "uploading", ft.percent = ot.percent;
    const st = J7(ft, te);
    fe(ft, st, ot);
  }, ze = (ot, at, ft) => {
    if (!$R(ft, te))
      return;
    const st = Q7(ft);
    st.error = ot, st.response = at, st.status = "error";
    const pt = J7(st, te);
    fe(st, pt);
  }, le = (ot) => {
    let at;
    Promise.resolve(typeof c == "function" ? c(ot) : c).then((ft) => {
      var st;
      if (ft === !1)
        return;
      const pt = Pxe(ot, te);
      pt && (at = Object.assign(Object.assign({}, ot), {
        status: "removed"
      }), te?.forEach((bt) => {
        const Nt = at.uid !== void 0 ? "uid" : "name";
        bt[Nt] === at[Nt] && !Object.isFrozen(bt) && (bt.status = "removed");
      }), (st = ae.current) === null || st === void 0 || st.abort(at), fe(at, pt));
    });
  }, se = (ot) => {
    ne(ot.type), ot.type === "drop" && w?.(ot);
  };
  S.useImperativeHandle(t, () => ({
    onBatchStart: me,
    onSuccess: De,
    onProgress: Me,
    onError: ze,
    fileList: te,
    upload: ae.current,
    nativeElement: oe.current
  }));
  const {
    getPrefixCls: Ae,
    direction: we,
    upload: Ne
  } = S.useContext(Qr), pe = Ae("upload", N), Qe = Object.assign(Object.assign({
    onBatchStart: me,
    onError: ze,
    onProgress: Me,
    onSuccess: De
  }, e), {
    customRequest: X,
    data: _,
    multiple: W,
    action: U,
    accept: Y,
    supportServerRender: G,
    prefixCls: pe,
    disabled: K,
    beforeUpload: be,
    onChange: void 0,
    hasControlInside: Q
  });
  delete Qe.className, delete Qe.style, (!j || K) && delete Qe.id;
  const Le = `${pe}-wrapper`, [Te, Oe, ye] = bxe(pe, Le), [je] = q1("Upload", vb.Upload), {
    showRemoveIcon: Ue,
    showPreviewIcon: Fe,
    showDownloadIcon: tt,
    removeIcon: dt,
    previewIcon: St,
    downloadIcon: mt,
    extra: Ot
  } = typeof d == "boolean" ? {} : d, Rt = typeof Ue > "u" ? !K : Ue, ct = (ot, at) => d ? /* @__PURE__ */ S.createElement(UZ, {
    prefixCls: pe,
    listType: f,
    items: te,
    previewFile: x,
    onPreview: p,
    onDownload: g,
    onRemove: le,
    showRemoveIcon: Rt,
    showPreviewIcon: Fe,
    showDownloadIcon: tt,
    removeIcon: dt,
    previewIcon: St,
    downloadIcon: mt,
    iconRender: k,
    extra: Ot,
    locale: Object.assign(Object.assign({}, je), P),
    isImageUrl: M,
    progress: T,
    appendAction: ot,
    appendActionVisible: at,
    itemRender: L,
    disabled: K
  }) : ot, it = _e(Le, D, J, Oe, ye, Ne?.className, {
    [`${pe}-rtl`]: we === "rtl",
    [`${pe}-picture-card-wrapper`]: f === "picture-card",
    [`${pe}-picture-circle-wrapper`]: f === "picture-circle"
  }), Ct = Object.assign(Object.assign({}, Ne?.style), I);
  if ($ === "drag") {
    const ot = _e(Oe, pe, `${pe}-drag`, {
      [`${pe}-drag-uploading`]: te.some((at) => at.status === "uploading"),
      [`${pe}-drag-hover`]: ee === "dragover",
      [`${pe}-disabled`]: K,
      [`${pe}-rtl`]: we === "rtl"
    });
    return Te(/* @__PURE__ */ S.createElement("span", {
      className: it,
      ref: oe
    }, /* @__PURE__ */ S.createElement("div", {
      className: ot,
      style: Ct,
      onDrop: se,
      onDragOver: se,
      onDragLeave: se
    }, /* @__PURE__ */ S.createElement(s$, Object.assign({}, Qe, {
      ref: ae,
      className: `${pe}-btn`
    }), /* @__PURE__ */ S.createElement("div", {
      className: `${pe}-drag-container`
    }, j))), ct()));
  }
  const ut = _e(pe, `${pe}-select`, {
    [`${pe}-disabled`]: K,
    [`${pe}-hidden`]: !j
  }), ht = /* @__PURE__ */ S.createElement("div", {
    className: ut,
    style: Ct
  }, /* @__PURE__ */ S.createElement(s$, Object.assign({}, Qe, {
    ref: ae
  })));
  return Te(f === "picture-card" || f === "picture-circle" ? /* @__PURE__ */ S.createElement("span", {
    className: it,
    ref: oe
  }, ct(ht, !!j)) : /* @__PURE__ */ S.createElement("span", {
    className: it,
    ref: oe
  }, ht, ct()));
}, qj = /* @__PURE__ */ S.forwardRef($xe);
process.env.NODE_ENV !== "production" && (qj.displayName = "Upload");
var zxe = function(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
    t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
};
const XZ = /* @__PURE__ */ S.forwardRef((e, t) => {
  const {
    style: r,
    height: a,
    hasControlInside: i = !1,
    children: c
  } = e, d = zxe(e, ["style", "height", "hasControlInside", "children"]), f = Object.assign(Object.assign({}, r), {
    height: a
  });
  return /* @__PURE__ */ S.createElement(qj, Object.assign({
    ref: t,
    hasControlInside: i
  }, d, {
    style: f,
    type: "drag"
  }), c);
});
process.env.NODE_ENV !== "production" && (XZ.displayName = "Dragger");
const n6 = qj;
n6.Dragger = XZ;
n6.LIST_IGNORE = sE;
var Z7 = { exports: {} }, R5 = {}, eP = { exports: {} }, zR = {};
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var kV;
function jxe() {
  return kV || (kV = 1, (function(e) {
    function t(H, K) {
      var X = H.length;
      H.push(K);
      e: for (; 0 < X; ) {
        var te = X - 1 >>> 1, ie = H[te];
        if (0 < i(ie, K))
          H[te] = K, H[X] = ie, X = te;
        else break e;
      }
    }
    function r(H) {
      return H.length === 0 ? null : H[0];
    }
    function a(H) {
      if (H.length === 0) return null;
      var K = H[0], X = H.pop();
      if (X !== K) {
        H[0] = X;
        e: for (var te = 0, ie = H.length, ee = ie >>> 1; te < ee; ) {
          var ne = 2 * (te + 1) - 1, ae = H[ne], oe = ne + 1, fe = H[oe];
          if (0 > i(ae, X))
            oe < ie && 0 > i(fe, ae) ? (H[te] = fe, H[oe] = X, te = oe) : (H[te] = ae, H[ne] = X, te = ne);
          else if (oe < ie && 0 > i(fe, X))
            H[te] = fe, H[oe] = X, te = oe;
          else break e;
        }
      }
      return K;
    }
    function i(H, K) {
      var X = H.sortIndex - K.sortIndex;
      return X !== 0 ? X : H.id - K.id;
    }
    if (e.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
      var c = performance;
      e.unstable_now = function() {
        return c.now();
      };
    } else {
      var d = Date, f = d.now();
      e.unstable_now = function() {
        return d.now() - f;
      };
    }
    var p = [], g = [], b = 1, w = null, x = 3, E = !1, P = !1, k = !1, M = !1, T = typeof setTimeout == "function" ? setTimeout : null, N = typeof clearTimeout == "function" ? clearTimeout : null, D = typeof setImmediate < "u" ? setImmediate : null;
    function $(H) {
      for (var K = r(g); K !== null; ) {
        if (K.callback === null) a(g);
        else if (K.startTime <= H)
          a(g), K.sortIndex = K.expirationTime, t(p, K);
        else break;
        K = r(g);
      }
    }
    function j(H) {
      if (k = !1, $(H), !P)
        if (r(p) !== null)
          P = !0, I || (I = !0, U());
        else {
          var K = r(g);
          K !== null && J(j, K.startTime - H);
        }
    }
    var I = !1, L = -1, F = 5, _ = -1;
    function W() {
      return M ? !0 : !(e.unstable_now() - _ < F);
    }
    function Q() {
      if (M = !1, I) {
        var H = e.unstable_now();
        _ = H;
        var K = !0;
        try {
          e: {
            P = !1, k && (k = !1, N(L), L = -1), E = !0;
            var X = x;
            try {
              t: {
                for ($(H), w = r(p); w !== null && !(w.expirationTime > H && W()); ) {
                  var te = w.callback;
                  if (typeof te == "function") {
                    w.callback = null, x = w.priorityLevel;
                    var ie = te(
                      w.expirationTime <= H
                    );
                    if (H = e.unstable_now(), typeof ie == "function") {
                      w.callback = ie, $(H), K = !0;
                      break t;
                    }
                    w === r(p) && a(p), $(H);
                  } else a(p);
                  w = r(p);
                }
                if (w !== null) K = !0;
                else {
                  var ee = r(g);
                  ee !== null && J(
                    j,
                    ee.startTime - H
                  ), K = !1;
                }
              }
              break e;
            } finally {
              w = null, x = X, E = !1;
            }
            K = void 0;
          }
        } finally {
          K ? U() : I = !1;
        }
      }
    }
    var U;
    if (typeof D == "function")
      U = function() {
        D(Q);
      };
    else if (typeof MessageChannel < "u") {
      var Y = new MessageChannel(), G = Y.port2;
      Y.port1.onmessage = Q, U = function() {
        G.postMessage(null);
      };
    } else
      U = function() {
        T(Q, 0);
      };
    function J(H, K) {
      L = T(function() {
        H(e.unstable_now());
      }, K);
    }
    e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(H) {
      H.callback = null;
    }, e.unstable_forceFrameRate = function(H) {
      0 > H || 125 < H ? console.error(
        "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
      ) : F = 0 < H ? Math.floor(1e3 / H) : 5;
    }, e.unstable_getCurrentPriorityLevel = function() {
      return x;
    }, e.unstable_next = function(H) {
      switch (x) {
        case 1:
        case 2:
        case 3:
          var K = 3;
          break;
        default:
          K = x;
      }
      var X = x;
      x = K;
      try {
        return H();
      } finally {
        x = X;
      }
    }, e.unstable_requestPaint = function() {
      M = !0;
    }, e.unstable_runWithPriority = function(H, K) {
      switch (H) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          H = 3;
      }
      var X = x;
      x = H;
      try {
        return K();
      } finally {
        x = X;
      }
    }, e.unstable_scheduleCallback = function(H, K, X) {
      var te = e.unstable_now();
      switch (typeof X == "object" && X !== null ? (X = X.delay, X = typeof X == "number" && 0 < X ? te + X : te) : X = te, H) {
        case 1:
          var ie = -1;
          break;
        case 2:
          ie = 250;
          break;
        case 5:
          ie = 1073741823;
          break;
        case 4:
          ie = 1e4;
          break;
        default:
          ie = 5e3;
      }
      return ie = X + ie, H = {
        id: b++,
        callback: K,
        priorityLevel: H,
        startTime: X,
        expirationTime: ie,
        sortIndex: -1
      }, X > te ? (H.sortIndex = X, t(g, H), r(p) === null && H === r(g) && (k ? (N(L), L = -1) : k = !0, J(j, X - te))) : (H.sortIndex = ie, t(p, H), P || E || (P = !0, I || (I = !0, U()))), H;
    }, e.unstable_shouldYield = W, e.unstable_wrapCallback = function(H) {
      var K = x;
      return function() {
        var X = x;
        x = K;
        try {
          return H.apply(this, arguments);
        } finally {
          x = X;
        }
      };
    };
  })(zR)), zR;
}
var jR = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var MV;
function Ixe() {
  return MV || (MV = 1, (function(e) {
    process.env.NODE_ENV !== "production" && (function() {
      function t() {
        if (j = !1, _) {
          var H = e.unstable_now();
          U = H;
          var K = !0;
          try {
            e: {
              D = !1, $ && ($ = !1, L(W), W = -1), N = !0;
              var X = T;
              try {
                t: {
                  for (d(H), M = a(E); M !== null && !(M.expirationTime > H && p()); ) {
                    var te = M.callback;
                    if (typeof te == "function") {
                      M.callback = null, T = M.priorityLevel;
                      var ie = te(
                        M.expirationTime <= H
                      );
                      if (H = e.unstable_now(), typeof ie == "function") {
                        M.callback = ie, d(H), K = !0;
                        break t;
                      }
                      M === a(E) && i(E), d(H);
                    } else i(E);
                    M = a(E);
                  }
                  if (M !== null) K = !0;
                  else {
                    var ee = a(P);
                    ee !== null && g(
                      f,
                      ee.startTime - H
                    ), K = !1;
                  }
                }
                break e;
              } finally {
                M = null, T = X, N = !1;
              }
              K = void 0;
            }
          } finally {
            K ? Y() : _ = !1;
          }
        }
      }
      function r(H, K) {
        var X = H.length;
        H.push(K);
        e: for (; 0 < X; ) {
          var te = X - 1 >>> 1, ie = H[te];
          if (0 < c(ie, K))
            H[te] = K, H[X] = ie, X = te;
          else break e;
        }
      }
      function a(H) {
        return H.length === 0 ? null : H[0];
      }
      function i(H) {
        if (H.length === 0) return null;
        var K = H[0], X = H.pop();
        if (X !== K) {
          H[0] = X;
          e: for (var te = 0, ie = H.length, ee = ie >>> 1; te < ee; ) {
            var ne = 2 * (te + 1) - 1, ae = H[ne], oe = ne + 1, fe = H[oe];
            if (0 > c(ae, X))
              oe < ie && 0 > c(fe, ae) ? (H[te] = fe, H[oe] = X, te = oe) : (H[te] = ae, H[ne] = X, te = ne);
            else if (oe < ie && 0 > c(fe, X))
              H[te] = fe, H[oe] = X, te = oe;
            else break e;
          }
        }
        return K;
      }
      function c(H, K) {
        var X = H.sortIndex - K.sortIndex;
        return X !== 0 ? X : H.id - K.id;
      }
      function d(H) {
        for (var K = a(P); K !== null; ) {
          if (K.callback === null) i(P);
          else if (K.startTime <= H)
            i(P), K.sortIndex = K.expirationTime, r(E, K);
          else break;
          K = a(P);
        }
      }
      function f(H) {
        if ($ = !1, d(H), !D)
          if (a(E) !== null)
            D = !0, _ || (_ = !0, Y());
          else {
            var K = a(P);
            K !== null && g(
              f,
              K.startTime - H
            );
          }
      }
      function p() {
        return j ? !0 : !(e.unstable_now() - U < Q);
      }
      function g(H, K) {
        W = I(function() {
          H(e.unstable_now());
        }, K);
      }
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error()), e.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
        var b = performance;
        e.unstable_now = function() {
          return b.now();
        };
      } else {
        var w = Date, x = w.now();
        e.unstable_now = function() {
          return w.now() - x;
        };
      }
      var E = [], P = [], k = 1, M = null, T = 3, N = !1, D = !1, $ = !1, j = !1, I = typeof setTimeout == "function" ? setTimeout : null, L = typeof clearTimeout == "function" ? clearTimeout : null, F = typeof setImmediate < "u" ? setImmediate : null, _ = !1, W = -1, Q = 5, U = -1;
      if (typeof F == "function")
        var Y = function() {
          F(t);
        };
      else if (typeof MessageChannel < "u") {
        var G = new MessageChannel(), J = G.port2;
        G.port1.onmessage = t, Y = function() {
          J.postMessage(null);
        };
      } else
        Y = function() {
          I(t, 0);
        };
      e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(H) {
        H.callback = null;
      }, e.unstable_forceFrameRate = function(H) {
        0 > H || 125 < H ? console.error(
          "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
        ) : Q = 0 < H ? Math.floor(1e3 / H) : 5;
      }, e.unstable_getCurrentPriorityLevel = function() {
        return T;
      }, e.unstable_next = function(H) {
        switch (T) {
          case 1:
          case 2:
          case 3:
            var K = 3;
            break;
          default:
            K = T;
        }
        var X = T;
        T = K;
        try {
          return H();
        } finally {
          T = X;
        }
      }, e.unstable_requestPaint = function() {
        j = !0;
      }, e.unstable_runWithPriority = function(H, K) {
        switch (H) {
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
            break;
          default:
            H = 3;
        }
        var X = T;
        T = H;
        try {
          return K();
        } finally {
          T = X;
        }
      }, e.unstable_scheduleCallback = function(H, K, X) {
        var te = e.unstable_now();
        switch (typeof X == "object" && X !== null ? (X = X.delay, X = typeof X == "number" && 0 < X ? te + X : te) : X = te, H) {
          case 1:
            var ie = -1;
            break;
          case 2:
            ie = 250;
            break;
          case 5:
            ie = 1073741823;
            break;
          case 4:
            ie = 1e4;
            break;
          default:
            ie = 5e3;
        }
        return ie = X + ie, H = {
          id: k++,
          callback: K,
          priorityLevel: H,
          startTime: X,
          expirationTime: ie,
          sortIndex: -1
        }, X > te ? (H.sortIndex = X, r(P, H), a(E) === null && H === a(P) && ($ ? (L(W), W = -1) : $ = !0, g(f, X - te))) : (H.sortIndex = ie, r(E, H), D || N || (D = !0, _ || (_ = !0, Y()))), H;
      }, e.unstable_shouldYield = p, e.unstable_wrapCallback = function(H) {
        var K = T;
        return function() {
          var X = T;
          T = K;
          try {
            return H.apply(this, arguments);
          } finally {
            T = X;
          }
        };
      }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
    })();
  })(jR)), jR;
}
var OV;
function GZ() {
  return OV || (OV = 1, process.env.NODE_ENV === "production" ? eP.exports = jxe() : eP.exports = Ixe()), eP.exports;
}
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var TV;
function Lxe() {
  if (TV) return R5;
  TV = 1;
  var e = GZ(), t = Re, r = hb;
  function a(l) {
    var u = "https://react.dev/errors/" + l;
    if (1 < arguments.length) {
      u += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var m = 2; m < arguments.length; m++)
        u += "&args[]=" + encodeURIComponent(arguments[m]);
    }
    return "Minified React error #" + l + "; visit " + u + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function i(l) {
    return !(!l || l.nodeType !== 1 && l.nodeType !== 9 && l.nodeType !== 11);
  }
  function c(l) {
    var u = l, m = l;
    if (l.alternate) for (; u.return; ) u = u.return;
    else {
      l = u;
      do
        u = l, (u.flags & 4098) !== 0 && (m = u.return), l = u.return;
      while (l);
    }
    return u.tag === 3 ? m : null;
  }
  function d(l) {
    if (l.tag === 13) {
      var u = l.memoizedState;
      if (u === null && (l = l.alternate, l !== null && (u = l.memoizedState)), u !== null) return u.dehydrated;
    }
    return null;
  }
  function f(l) {
    if (l.tag === 31) {
      var u = l.memoizedState;
      if (u === null && (l = l.alternate, l !== null && (u = l.memoizedState)), u !== null) return u.dehydrated;
    }
    return null;
  }
  function p(l) {
    if (c(l) !== l)
      throw Error(a(188));
  }
  function g(l) {
    var u = l.alternate;
    if (!u) {
      if (u = c(l), u === null) throw Error(a(188));
      return u !== l ? null : l;
    }
    for (var m = l, v = u; ; ) {
      var O = m.return;
      if (O === null) break;
      var R = O.alternate;
      if (R === null) {
        if (v = O.return, v !== null) {
          m = v;
          continue;
        }
        break;
      }
      if (O.child === R.child) {
        for (R = O.child; R; ) {
          if (R === m) return p(O), l;
          if (R === v) return p(O), u;
          R = R.sibling;
        }
        throw Error(a(188));
      }
      if (m.return !== v.return) m = O, v = R;
      else {
        for (var B = !1, re = O.child; re; ) {
          if (re === m) {
            B = !0, m = O, v = R;
            break;
          }
          if (re === v) {
            B = !0, v = O, m = R;
            break;
          }
          re = re.sibling;
        }
        if (!B) {
          for (re = R.child; re; ) {
            if (re === m) {
              B = !0, m = R, v = O;
              break;
            }
            if (re === v) {
              B = !0, v = R, m = O;
              break;
            }
            re = re.sibling;
          }
          if (!B) throw Error(a(189));
        }
      }
      if (m.alternate !== v) throw Error(a(190));
    }
    if (m.tag !== 3) throw Error(a(188));
    return m.stateNode.current === m ? l : u;
  }
  function b(l) {
    var u = l.tag;
    if (u === 5 || u === 26 || u === 27 || u === 6) return l;
    for (l = l.child; l !== null; ) {
      if (u = b(l), u !== null) return u;
      l = l.sibling;
    }
    return null;
  }
  var w = Object.assign, x = Symbol.for("react.element"), E = Symbol.for("react.transitional.element"), P = Symbol.for("react.portal"), k = Symbol.for("react.fragment"), M = Symbol.for("react.strict_mode"), T = Symbol.for("react.profiler"), N = Symbol.for("react.consumer"), D = Symbol.for("react.context"), $ = Symbol.for("react.forward_ref"), j = Symbol.for("react.suspense"), I = Symbol.for("react.suspense_list"), L = Symbol.for("react.memo"), F = Symbol.for("react.lazy"), _ = Symbol.for("react.activity"), W = Symbol.for("react.memo_cache_sentinel"), Q = Symbol.iterator;
  function U(l) {
    return l === null || typeof l != "object" ? null : (l = Q && l[Q] || l["@@iterator"], typeof l == "function" ? l : null);
  }
  var Y = Symbol.for("react.client.reference");
  function G(l) {
    if (l == null) return null;
    if (typeof l == "function")
      return l.$$typeof === Y ? null : l.displayName || l.name || null;
    if (typeof l == "string") return l;
    switch (l) {
      case k:
        return "Fragment";
      case T:
        return "Profiler";
      case M:
        return "StrictMode";
      case j:
        return "Suspense";
      case I:
        return "SuspenseList";
      case _:
        return "Activity";
    }
    if (typeof l == "object")
      switch (l.$$typeof) {
        case P:
          return "Portal";
        case D:
          return l.displayName || "Context";
        case N:
          return (l._context.displayName || "Context") + ".Consumer";
        case $:
          var u = l.render;
          return l = l.displayName, l || (l = u.displayName || u.name || "", l = l !== "" ? "ForwardRef(" + l + ")" : "ForwardRef"), l;
        case L:
          return u = l.displayName || null, u !== null ? u : G(l.type) || "Memo";
        case F:
          u = l._payload, l = l._init;
          try {
            return G(l(u));
          } catch {
          }
      }
    return null;
  }
  var J = Array.isArray, H = t.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, K = r.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, X = {
    pending: !1,
    data: null,
    method: null,
    action: null
  }, te = [], ie = -1;
  function ee(l) {
    return { current: l };
  }
  function ne(l) {
    0 > ie || (l.current = te[ie], te[ie] = null, ie--);
  }
  function ae(l, u) {
    ie++, te[ie] = l.current, l.current = u;
  }
  var oe = ee(null), fe = ee(null), be = ee(null), me = ee(null);
  function De(l, u) {
    switch (ae(be, u), ae(fe, l), ae(oe, null), u.nodeType) {
      case 9:
      case 11:
        l = (l = u.documentElement) && (l = l.namespaceURI) ? zy(l) : 0;
        break;
      default:
        if (l = u.tagName, u = u.namespaceURI)
          u = zy(u), l = M2(u, l);
        else
          switch (l) {
            case "svg":
              l = 1;
              break;
            case "math":
              l = 2;
              break;
            default:
              l = 0;
          }
    }
    ne(oe), ae(oe, l);
  }
  function Me() {
    ne(oe), ne(fe), ne(be);
  }
  function ze(l) {
    l.memoizedState !== null && ae(me, l);
    var u = oe.current, m = M2(u, l.type);
    u !== m && (ae(fe, l), ae(oe, m));
  }
  function le(l) {
    fe.current === l && (ne(oe), ne(fe)), me.current === l && (ne(me), mh._currentValue = X);
  }
  var se, Ae;
  function we(l) {
    if (se === void 0)
      try {
        throw Error();
      } catch (m) {
        var u = m.stack.trim().match(/\n( *(at )?)/);
        se = u && u[1] || "", Ae = -1 < m.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < m.stack.indexOf("@") ? "@unknown:0:0" : "";
      }
    return `
` + se + l + Ae;
  }
  var Ne = !1;
  function pe(l, u) {
    if (!l || Ne) return "";
    Ne = !0;
    var m = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var v = {
        DetermineComponentFrameRoot: function() {
          try {
            if (u) {
              var nt = function() {
                throw Error();
              };
              if (Object.defineProperty(nt.prototype, "props", {
                set: function() {
                  throw Error();
                }
              }), typeof Reflect == "object" && Reflect.construct) {
                try {
                  Reflect.construct(nt, []);
                } catch (Ge) {
                  var We = Ge;
                }
                Reflect.construct(l, [], nt);
              } else {
                try {
                  nt.call();
                } catch (Ge) {
                  We = Ge;
                }
                l.call(nt.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (Ge) {
                We = Ge;
              }
              (nt = l()) && typeof nt.catch == "function" && nt.catch(function() {
              });
            }
          } catch (Ge) {
            if (Ge && We && typeof Ge.stack == "string")
              return [Ge.stack, We.stack];
          }
          return [null, null];
        }
      };
      v.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var O = Object.getOwnPropertyDescriptor(
        v.DetermineComponentFrameRoot,
        "name"
      );
      O && O.configurable && Object.defineProperty(
        v.DetermineComponentFrameRoot,
        "name",
        { value: "DetermineComponentFrameRoot" }
      );
      var R = v.DetermineComponentFrameRoot(), B = R[0], re = R[1];
      if (B && re) {
        var ve = B.split(`
`), He = re.split(`
`);
        for (O = v = 0; v < ve.length && !ve[v].includes("DetermineComponentFrameRoot"); )
          v++;
        for (; O < He.length && !He[O].includes(
          "DetermineComponentFrameRoot"
        ); )
          O++;
        if (v === ve.length || O === He.length)
          for (v = ve.length - 1, O = He.length - 1; 1 <= v && 0 <= O && ve[v] !== He[O]; )
            O--;
        for (; 1 <= v && 0 <= O; v--, O--)
          if (ve[v] !== He[O]) {
            if (v !== 1 || O !== 1)
              do
                if (v--, O--, 0 > O || ve[v] !== He[O]) {
                  var Je = `
` + ve[v].replace(" at new ", " at ");
                  return l.displayName && Je.includes("<anonymous>") && (Je = Je.replace("<anonymous>", l.displayName)), Je;
                }
              while (1 <= v && 0 <= O);
            break;
          }
      }
    } finally {
      Ne = !1, Error.prepareStackTrace = m;
    }
    return (m = l ? l.displayName || l.name : "") ? we(m) : "";
  }
  function Qe(l, u) {
    switch (l.tag) {
      case 26:
      case 27:
      case 5:
        return we(l.type);
      case 16:
        return we("Lazy");
      case 13:
        return l.child !== u && u !== null ? we("Suspense Fallback") : we("Suspense");
      case 19:
        return we("SuspenseList");
      case 0:
      case 15:
        return pe(l.type, !1);
      case 11:
        return pe(l.type.render, !1);
      case 1:
        return pe(l.type, !0);
      case 31:
        return we("Activity");
      default:
        return "";
    }
  }
  function Le(l) {
    try {
      var u = "", m = null;
      do
        u += Qe(l, m), m = l, l = l.return;
      while (l);
      return u;
    } catch (v) {
      return `
Error generating stack: ` + v.message + `
` + v.stack;
    }
  }
  var Te = Object.prototype.hasOwnProperty, Oe = e.unstable_scheduleCallback, ye = e.unstable_cancelCallback, je = e.unstable_shouldYield, Ue = e.unstable_requestPaint, Fe = e.unstable_now, tt = e.unstable_getCurrentPriorityLevel, dt = e.unstable_ImmediatePriority, St = e.unstable_UserBlockingPriority, mt = e.unstable_NormalPriority, Ot = e.unstable_LowPriority, Rt = e.unstable_IdlePriority, ct = e.log, it = e.unstable_setDisableYieldValue, Ct = null, ut = null;
  function ht(l) {
    if (typeof ct == "function" && it(l), ut && typeof ut.setStrictMode == "function")
      try {
        ut.setStrictMode(Ct, l);
      } catch {
      }
  }
  var ot = Math.clz32 ? Math.clz32 : st, at = Math.log, ft = Math.LN2;
  function st(l) {
    return l >>>= 0, l === 0 ? 32 : 31 - (at(l) / ft | 0) | 0;
  }
  var pt = 256, bt = 262144, Nt = 4194304;
  function $t(l) {
    var u = l & 42;
    if (u !== 0) return u;
    switch (l & -l) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
        return 64;
      case 128:
        return 128;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
        return l & 261888;
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return l & 3932160;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return l & 62914560;
      case 67108864:
        return 67108864;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 0;
      default:
        return l;
    }
  }
  function Pt(l, u, m) {
    var v = l.pendingLanes;
    if (v === 0) return 0;
    var O = 0, R = l.suspendedLanes, B = l.pingedLanes;
    l = l.warmLanes;
    var re = v & 134217727;
    return re !== 0 ? (v = re & ~R, v !== 0 ? O = $t(v) : (B &= re, B !== 0 ? O = $t(B) : m || (m = re & ~l, m !== 0 && (O = $t(m))))) : (re = v & ~R, re !== 0 ? O = $t(re) : B !== 0 ? O = $t(B) : m || (m = v & ~l, m !== 0 && (O = $t(m)))), O === 0 ? 0 : u !== 0 && u !== O && (u & R) === 0 && (R = O & -O, m = u & -u, R >= m || R === 32 && (m & 4194048) !== 0) ? u : O;
  }
  function hn(l, u) {
    return (l.pendingLanes & ~(l.suspendedLanes & ~l.pingedLanes) & u) === 0;
  }
  function an(l, u) {
    switch (l) {
      case 1:
      case 2:
      case 4:
      case 8:
      case 64:
        return u + 250;
      case 16:
      case 32:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return u + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return -1;
      case 67108864:
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function jn() {
    var l = Nt;
    return Nt <<= 1, (Nt & 62914560) === 0 && (Nt = 4194304), l;
  }
  function xn(l) {
    for (var u = [], m = 0; 31 > m; m++) u.push(l);
    return u;
  }
  function Ut(l, u) {
    l.pendingLanes |= u, u !== 268435456 && (l.suspendedLanes = 0, l.pingedLanes = 0, l.warmLanes = 0);
  }
  function pn(l, u, m, v, O, R) {
    var B = l.pendingLanes;
    l.pendingLanes = m, l.suspendedLanes = 0, l.pingedLanes = 0, l.warmLanes = 0, l.expiredLanes &= m, l.entangledLanes &= m, l.errorRecoveryDisabledLanes &= m, l.shellSuspendCounter = 0;
    var re = l.entanglements, ve = l.expirationTimes, He = l.hiddenUpdates;
    for (m = B & ~m; 0 < m; ) {
      var Je = 31 - ot(m), nt = 1 << Je;
      re[Je] = 0, ve[Je] = -1;
      var We = He[Je];
      if (We !== null)
        for (He[Je] = null, Je = 0; Je < We.length; Je++) {
          var Ge = We[Je];
          Ge !== null && (Ge.lane &= -536870913);
        }
      m &= ~nt;
    }
    v !== 0 && wn(l, v, 0), R !== 0 && O === 0 && l.tag !== 0 && (l.suspendedLanes |= R & ~(B & ~u));
  }
  function wn(l, u, m) {
    l.pendingLanes |= u, l.suspendedLanes &= ~u;
    var v = 31 - ot(u);
    l.entangledLanes |= u, l.entanglements[v] = l.entanglements[v] | 1073741824 | m & 261930;
  }
  function Lt(l, u) {
    var m = l.entangledLanes |= u;
    for (l = l.entanglements; m; ) {
      var v = 31 - ot(m), O = 1 << v;
      O & u | l[v] & u && (l[v] |= u), m &= ~O;
    }
  }
  function gt(l, u) {
    var m = u & -u;
    return m = (m & 42) !== 0 ? 1 : wt(m), (m & (l.suspendedLanes | u)) !== 0 ? 0 : m;
  }
  function wt(l) {
    switch (l) {
      case 2:
        l = 1;
        break;
      case 8:
        l = 4;
        break;
      case 32:
        l = 16;
        break;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        l = 128;
        break;
      case 268435456:
        l = 134217728;
        break;
      default:
        l = 0;
    }
    return l;
  }
  function Ft(l) {
    return l &= -l, 2 < l ? 8 < l ? (l & 134217727) !== 0 ? 32 : 268435456 : 8 : 2;
  }
  function yn() {
    var l = K.p;
    return l !== 0 ? l : (l = window.event, l === void 0 ? 32 : hh(l.type));
  }
  function gn(l, u) {
    var m = K.p;
    try {
      return K.p = l, u();
    } finally {
      K.p = m;
    }
  }
  var Tn = Math.random().toString(36).slice(2), Gt = "__reactFiber$" + Tn, Dt = "__reactProps$" + Tn, Yt = "__reactContainer$" + Tn, Mn = "__reactEvents$" + Tn, Gn = "__reactListeners$" + Tn, wr = "__reactHandles$" + Tn, aa = "__reactResources$" + Tn, qn = "__reactMarker$" + Tn;
  function Rr(l) {
    delete l[Gt], delete l[Dt], delete l[Mn], delete l[Gn], delete l[wr];
  }
  function Wt(l) {
    var u = l[Gt];
    if (u) return u;
    for (var m = l.parentNode; m; ) {
      if (u = m[Yt] || m[Gt]) {
        if (m = u.alternate, u.child !== null || m !== null && m.child !== null)
          for (l = Nl(l); l !== null; ) {
            if (m = l[Gt]) return m;
            l = Nl(l);
          }
        return u;
      }
      l = m, m = l.parentNode;
    }
    return null;
  }
  function en(l) {
    if (l = l[Gt] || l[Yt]) {
      var u = l.tag;
      if (u === 5 || u === 6 || u === 13 || u === 31 || u === 26 || u === 27 || u === 3)
        return l;
    }
    return null;
  }
  function Xt(l) {
    var u = l.tag;
    if (u === 5 || u === 26 || u === 27 || u === 6) return l.stateNode;
    throw Error(a(33));
  }
  function zt(l) {
    var u = l[aa];
    return u || (u = l[aa] = { hoistableStyles: /* @__PURE__ */ new Map(), hoistableScripts: /* @__PURE__ */ new Map() }), u;
  }
  function kt(l) {
    l[qn] = !0;
  }
  var Qn = /* @__PURE__ */ new Set(), Jn = {};
  function Nr(l, u) {
    Hr(l, u), Hr(l + "Capture", u);
  }
  function Hr(l, u) {
    for (Jn[l] = u, l = 0; l < u.length; l++)
      Qn.add(u[l]);
  }
  var oa = RegExp(
    "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
  ), dn = {}, Un = {};
  function sr(l) {
    return Te.call(Un, l) ? !0 : Te.call(dn, l) ? !1 : oa.test(l) ? Un[l] = !0 : (dn[l] = !0, !1);
  }
  function Yr(l, u, m) {
    if (sr(u))
      if (m === null) l.removeAttribute(u);
      else {
        switch (typeof m) {
          case "undefined":
          case "function":
          case "symbol":
            l.removeAttribute(u);
            return;
          case "boolean":
            var v = u.toLowerCase().slice(0, 5);
            if (v !== "data-" && v !== "aria-") {
              l.removeAttribute(u);
              return;
            }
        }
        l.setAttribute(u, "" + m);
      }
  }
  function Wa(l, u, m) {
    if (m === null) l.removeAttribute(u);
    else {
      switch (typeof m) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          l.removeAttribute(u);
          return;
      }
      l.setAttribute(u, "" + m);
    }
  }
  function pa(l, u, m, v) {
    if (v === null) l.removeAttribute(m);
    else {
      switch (typeof v) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          l.removeAttribute(m);
          return;
      }
      l.setAttributeNS(u, m, "" + v);
    }
  }
  function Jr(l) {
    switch (typeof l) {
      case "bigint":
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return l;
      case "object":
        return l;
      default:
        return "";
    }
  }
  function si(l) {
    var u = l.type;
    return (l = l.nodeName) && l.toLowerCase() === "input" && (u === "checkbox" || u === "radio");
  }
  function mi(l, u, m) {
    var v = Object.getOwnPropertyDescriptor(
      l.constructor.prototype,
      u
    );
    if (!l.hasOwnProperty(u) && typeof v < "u" && typeof v.get == "function" && typeof v.set == "function") {
      var O = v.get, R = v.set;
      return Object.defineProperty(l, u, {
        configurable: !0,
        get: function() {
          return O.call(this);
        },
        set: function(B) {
          m = "" + B, R.call(this, B);
        }
      }), Object.defineProperty(l, u, {
        enumerable: v.enumerable
      }), {
        getValue: function() {
          return m;
        },
        setValue: function(B) {
          m = "" + B;
        },
        stopTracking: function() {
          l._valueTracker = null, delete l[u];
        }
      };
    }
  }
  function Yo(l) {
    if (!l._valueTracker) {
      var u = si(l) ? "checked" : "value";
      l._valueTracker = mi(
        l,
        u,
        "" + l[u]
      );
    }
  }
  function Bi(l) {
    if (!l) return !1;
    var u = l._valueTracker;
    if (!u) return !0;
    var m = u.getValue(), v = "";
    return l && (v = si(l) ? l.checked ? "true" : "false" : l.value), l = v, l !== m ? (u.setValue(l), !0) : !1;
  }
  function hr(l) {
    if (l = l || (typeof document < "u" ? document : void 0), typeof l > "u") return null;
    try {
      return l.activeElement || l.body;
    } catch {
      return l.body;
    }
  }
  var zn = /[\n"\\]/g;
  function On(l) {
    return l.replace(
      zn,
      function(u) {
        return "\\" + u.charCodeAt(0).toString(16) + " ";
      }
    );
  }
  function Qt(l, u, m, v, O, R, B, re) {
    l.name = "", B != null && typeof B != "function" && typeof B != "symbol" && typeof B != "boolean" ? l.type = B : l.removeAttribute("type"), u != null ? B === "number" ? (u === 0 && l.value === "" || l.value != u) && (l.value = "" + Jr(u)) : l.value !== "" + Jr(u) && (l.value = "" + Jr(u)) : B !== "submit" && B !== "reset" || l.removeAttribute("value"), u != null ? er(l, B, Jr(u)) : m != null ? er(l, B, Jr(m)) : v != null && l.removeAttribute("value"), O == null && R != null && (l.defaultChecked = !!R), O != null && (l.checked = O && typeof O != "function" && typeof O != "symbol"), re != null && typeof re != "function" && typeof re != "symbol" && typeof re != "boolean" ? l.name = "" + Jr(re) : l.removeAttribute("name");
  }
  function nn(l, u, m, v, O, R, B, re) {
    if (R != null && typeof R != "function" && typeof R != "symbol" && typeof R != "boolean" && (l.type = R), u != null || m != null) {
      if (!(R !== "submit" && R !== "reset" || u != null)) {
        Yo(l);
        return;
      }
      m = m != null ? "" + Jr(m) : "", u = u != null ? "" + Jr(u) : m, re || u === l.value || (l.value = u), l.defaultValue = u;
    }
    v = v ?? O, v = typeof v != "function" && typeof v != "symbol" && !!v, l.checked = re ? l.checked : !!v, l.defaultChecked = !!v, B != null && typeof B != "function" && typeof B != "symbol" && typeof B != "boolean" && (l.name = B), Yo(l);
  }
  function er(l, u, m) {
    u === "number" && hr(l.ownerDocument) === l || l.defaultValue === "" + m || (l.defaultValue = "" + m);
  }
  function ia(l, u, m, v) {
    if (l = l.options, u) {
      u = {};
      for (var O = 0; O < m.length; O++)
        u["$" + m[O]] = !0;
      for (m = 0; m < l.length; m++)
        O = u.hasOwnProperty("$" + l[m].value), l[m].selected !== O && (l[m].selected = O), O && v && (l[m].defaultSelected = !0);
    } else {
      for (m = "" + Jr(m), u = null, O = 0; O < l.length; O++) {
        if (l[O].value === m) {
          l[O].selected = !0, v && (l[O].defaultSelected = !0);
          return;
        }
        u !== null || l[O].disabled || (u = l[O]);
      }
      u !== null && (u.selected = !0);
    }
  }
  function so(l, u, m) {
    if (u != null && (u = "" + Jr(u), u !== l.value && (l.value = u), m == null)) {
      l.defaultValue !== u && (l.defaultValue = u);
      return;
    }
    l.defaultValue = m != null ? "" + Jr(m) : "";
  }
  function hi(l, u, m, v) {
    if (u == null) {
      if (v != null) {
        if (m != null) throw Error(a(92));
        if (J(v)) {
          if (1 < v.length) throw Error(a(93));
          v = v[0];
        }
        m = v;
      }
      m == null && (m = ""), u = m;
    }
    m = Jr(u), l.defaultValue = m, v = l.textContent, v === m && v !== "" && v !== null && (l.value = v), Yo(l);
  }
  function ka(l, u) {
    if (u) {
      var m = l.firstChild;
      if (m && m === l.lastChild && m.nodeType === 3) {
        m.nodeValue = u;
        return;
      }
    }
    l.textContent = u;
  }
  var Ui = new Set(
    "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
      " "
    )
  );
  function sl(l, u, m) {
    var v = u.indexOf("--") === 0;
    m == null || typeof m == "boolean" || m === "" ? v ? l.setProperty(u, "") : u === "float" ? l.cssFloat = "" : l[u] = "" : v ? l.setProperty(u, m) : typeof m != "number" || m === 0 || Ui.has(u) ? u === "float" ? l.cssFloat = m : l[u] = ("" + m).trim() : l[u] = m + "px";
  }
  function qt(l, u, m) {
    if (u != null && typeof u != "object")
      throw Error(a(62));
    if (l = l.style, m != null) {
      for (var v in m)
        !m.hasOwnProperty(v) || u != null && u.hasOwnProperty(v) || (v.indexOf("--") === 0 ? l.setProperty(v, "") : v === "float" ? l.cssFloat = "" : l[v] = "");
      for (var O in u)
        v = u[O], u.hasOwnProperty(O) && m[O] !== v && sl(l, O, v);
    } else
      for (var R in u)
        u.hasOwnProperty(R) && sl(l, R, u[R]);
  }
  function Kt(l) {
    if (l.indexOf("-") === -1) return !1;
    switch (l) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var ur = /* @__PURE__ */ new Map([
    ["acceptCharset", "accept-charset"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"],
    ["crossOrigin", "crossorigin"],
    ["accentHeight", "accent-height"],
    ["alignmentBaseline", "alignment-baseline"],
    ["arabicForm", "arabic-form"],
    ["baselineShift", "baseline-shift"],
    ["capHeight", "cap-height"],
    ["clipPath", "clip-path"],
    ["clipRule", "clip-rule"],
    ["colorInterpolation", "color-interpolation"],
    ["colorInterpolationFilters", "color-interpolation-filters"],
    ["colorProfile", "color-profile"],
    ["colorRendering", "color-rendering"],
    ["dominantBaseline", "dominant-baseline"],
    ["enableBackground", "enable-background"],
    ["fillOpacity", "fill-opacity"],
    ["fillRule", "fill-rule"],
    ["floodColor", "flood-color"],
    ["floodOpacity", "flood-opacity"],
    ["fontFamily", "font-family"],
    ["fontSize", "font-size"],
    ["fontSizeAdjust", "font-size-adjust"],
    ["fontStretch", "font-stretch"],
    ["fontStyle", "font-style"],
    ["fontVariant", "font-variant"],
    ["fontWeight", "font-weight"],
    ["glyphName", "glyph-name"],
    ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
    ["glyphOrientationVertical", "glyph-orientation-vertical"],
    ["horizAdvX", "horiz-adv-x"],
    ["horizOriginX", "horiz-origin-x"],
    ["imageRendering", "image-rendering"],
    ["letterSpacing", "letter-spacing"],
    ["lightingColor", "lighting-color"],
    ["markerEnd", "marker-end"],
    ["markerMid", "marker-mid"],
    ["markerStart", "marker-start"],
    ["overlinePosition", "overline-position"],
    ["overlineThickness", "overline-thickness"],
    ["paintOrder", "paint-order"],
    ["panose-1", "panose-1"],
    ["pointerEvents", "pointer-events"],
    ["renderingIntent", "rendering-intent"],
    ["shapeRendering", "shape-rendering"],
    ["stopColor", "stop-color"],
    ["stopOpacity", "stop-opacity"],
    ["strikethroughPosition", "strikethrough-position"],
    ["strikethroughThickness", "strikethrough-thickness"],
    ["strokeDasharray", "stroke-dasharray"],
    ["strokeDashoffset", "stroke-dashoffset"],
    ["strokeLinecap", "stroke-linecap"],
    ["strokeLinejoin", "stroke-linejoin"],
    ["strokeMiterlimit", "stroke-miterlimit"],
    ["strokeOpacity", "stroke-opacity"],
    ["strokeWidth", "stroke-width"],
    ["textAnchor", "text-anchor"],
    ["textDecoration", "text-decoration"],
    ["textRendering", "text-rendering"],
    ["transformOrigin", "transform-origin"],
    ["underlinePosition", "underline-position"],
    ["underlineThickness", "underline-thickness"],
    ["unicodeBidi", "unicode-bidi"],
    ["unicodeRange", "unicode-range"],
    ["unitsPerEm", "units-per-em"],
    ["vAlphabetic", "v-alphabetic"],
    ["vHanging", "v-hanging"],
    ["vIdeographic", "v-ideographic"],
    ["vMathematical", "v-mathematical"],
    ["vectorEffect", "vector-effect"],
    ["vertAdvY", "vert-adv-y"],
    ["vertOriginX", "vert-origin-x"],
    ["vertOriginY", "vert-origin-y"],
    ["wordSpacing", "word-spacing"],
    ["writingMode", "writing-mode"],
    ["xmlnsXlink", "xmlns:xlink"],
    ["xHeight", "x-height"]
  ]), pr = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function tr(l) {
    return pr.test("" + l) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : l;
  }
  function Va() {
  }
  var pi = null;
  function Li(l) {
    return l = l.target || l.srcElement || window, l.correspondingUseElement && (l = l.correspondingUseElement), l.nodeType === 3 ? l.parentNode : l;
  }
  var yo = null, ul = null;
  function rc(l) {
    var u = en(l);
    if (u && (l = u.stateNode)) {
      var m = l[Dt] || null;
      e: switch (l = u.stateNode, u.type) {
        case "input":
          if (Qt(
            l,
            m.value,
            m.defaultValue,
            m.defaultValue,
            m.checked,
            m.defaultChecked,
            m.type,
            m.name
          ), u = m.name, m.type === "radio" && u != null) {
            for (m = l; m.parentNode; ) m = m.parentNode;
            for (m = m.querySelectorAll(
              'input[name="' + On(
                "" + u
              ) + '"][type="radio"]'
            ), u = 0; u < m.length; u++) {
              var v = m[u];
              if (v !== l && v.form === l.form) {
                var O = v[Dt] || null;
                if (!O) throw Error(a(90));
                Qt(
                  v,
                  O.value,
                  O.defaultValue,
                  O.defaultValue,
                  O.checked,
                  O.defaultChecked,
                  O.type,
                  O.name
                );
              }
            }
            for (u = 0; u < m.length; u++)
              v = m[u], v.form === l.form && Bi(v);
          }
          break e;
        case "textarea":
          so(l, m.value, m.defaultValue);
          break e;
        case "select":
          u = m.value, u != null && ia(l, !!m.multiple, u, !1);
      }
    }
  }
  var uu = !1;
  function lm(l, u, m) {
    if (uu) return l(u, m);
    uu = !0;
    try {
      var v = l(u);
      return v;
    } finally {
      if (uu = !1, (yo !== null || ul !== null) && (Qd(), yo && (u = yo, l = ul, ul = yo = null, rc(u), l)))
        for (u = 0; u < l.length; u++) rc(l[u]);
    }
  }
  function Jt(l, u) {
    var m = l.stateNode;
    if (m === null) return null;
    var v = m[Dt] || null;
    if (v === null) return null;
    m = v[u];
    e: switch (u) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (v = !v.disabled) || (l = l.type, v = !(l === "button" || l === "input" || l === "select" || l === "textarea")), l = !v;
        break e;
      default:
        l = !1;
    }
    if (l) return null;
    if (m && typeof m != "function")
      throw Error(
        a(231, u, typeof m)
      );
    return m;
  }
  var nr = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), ao = !1;
  if (nr)
    try {
      var wo = {};
      Object.defineProperty(wo, "passive", {
        get: function() {
          ao = !0;
        }
      }), window.addEventListener("test", wo, wo), window.removeEventListener("test", wo, wo);
    } catch {
      ao = !1;
    }
  var Ea = null, Uf = null, gd = null;
  function Zh() {
    if (gd) return gd;
    var l, u = Uf, m = u.length, v, O = "value" in Ea ? Ea.value : Ea.textContent, R = O.length;
    for (l = 0; l < m && u[l] === O[l]; l++) ;
    var B = m - l;
    for (v = 1; v <= B && u[m - v] === O[R - v]; v++) ;
    return gd = O.slice(l, 1 < v ? 1 - v : void 0);
  }
  function cd(l) {
    var u = l.keyCode;
    return "charCode" in l ? (l = l.charCode, l === 0 && u === 13 && (l = 13)) : l = u, l === 10 && (l = 13), 32 <= l || l === 13 ? l : 0;
  }
  function sm() {
    return !0;
  }
  function Mb() {
    return !1;
  }
  function uo(l) {
    function u(m, v, O, R, B) {
      this._reactName = m, this._targetInst = O, this.type = v, this.nativeEvent = R, this.target = B, this.currentTarget = null;
      for (var re in l)
        l.hasOwnProperty(re) && (m = l[re], this[re] = m ? m(R) : R[re]);
      return this.isDefaultPrevented = (R.defaultPrevented != null ? R.defaultPrevented : R.returnValue === !1) ? sm : Mb, this.isPropagationStopped = Mb, this;
    }
    return w(u.prototype, {
      preventDefault: function() {
        this.defaultPrevented = !0;
        var m = this.nativeEvent;
        m && (m.preventDefault ? m.preventDefault() : typeof m.returnValue != "unknown" && (m.returnValue = !1), this.isDefaultPrevented = sm);
      },
      stopPropagation: function() {
        var m = this.nativeEvent;
        m && (m.stopPropagation ? m.stopPropagation() : typeof m.cancelBubble != "unknown" && (m.cancelBubble = !0), this.isPropagationStopped = sm);
      },
      persist: function() {
      },
      isPersistent: sm
    }), u;
  }
  var cu = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(l) {
      return l.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
  }, um = uo(cu), vd = w({}, cu, { view: 0, detail: 0 }), dC = uo(vd), K0, Y0, cm, pp = w({}, vd, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: Xi,
    button: 0,
    buttons: 0,
    relatedTarget: function(l) {
      return l.relatedTarget === void 0 ? l.fromElement === l.srcElement ? l.toElement : l.fromElement : l.relatedTarget;
    },
    movementX: function(l) {
      return "movementX" in l ? l.movementX : (l !== cm && (cm && l.type === "mousemove" ? (K0 = l.screenX - cm.screenX, Y0 = l.screenY - cm.screenY) : Y0 = K0 = 0, cm = l), K0);
    },
    movementY: function(l) {
      return "movementY" in l ? l.movementY : Y0;
    }
  }), bd = uo(pp), Ob = w({}, pp, { dataTransfer: 0 }), Tb = uo(Ob), Rb = w({}, vd, { relatedTarget: 0 }), gp = uo(Rb), Q0 = w({}, cu, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), Ab = uo(Q0), ac = w({}, cu, {
    clipboardData: function(l) {
      return "clipboardData" in l ? l.clipboardData : window.clipboardData;
    }
  }), oc = uo(ac), ml = w({}, cu, { data: 0 }), Nb = uo(ml), J0 = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, Vl = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, Db = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
  };
  function hl(l) {
    var u = this.nativeEvent;
    return u.getModifierState ? u.getModifierState(l) : (l = Db[l]) ? !!u[l] : !1;
  }
  function Xi() {
    return hl;
  }
  var vp = w({}, vd, {
    key: function(l) {
      if (l.key) {
        var u = J0[l.key] || l.key;
        if (u !== "Unidentified") return u;
      }
      return l.type === "keypress" ? (l = cd(l), l === 13 ? "Enter" : String.fromCharCode(l)) : l.type === "keydown" || l.type === "keyup" ? Vl[l.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: Xi,
    charCode: function(l) {
      return l.type === "keypress" ? cd(l) : 0;
    },
    keyCode: function(l) {
      return l.type === "keydown" || l.type === "keyup" ? l.keyCode : 0;
    },
    which: function(l) {
      return l.type === "keypress" ? cd(l) : l.type === "keydown" || l.type === "keyup" ? l.keyCode : 0;
    }
  }), bp = uo(vp), Z0 = w({}, pp, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
  }), pl = uo(Z0), fC = w({}, vd, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: Xi
  }), $b = uo(fC), zb = w({}, cu, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), mC = uo(zb), ev = w({}, pp, {
    deltaX: function(l) {
      return "deltaX" in l ? l.deltaX : "wheelDeltaX" in l ? -l.wheelDeltaX : 0;
    },
    deltaY: function(l) {
      return "deltaY" in l ? l.deltaY : "wheelDeltaY" in l ? -l.wheelDeltaY : "wheelDelta" in l ? -l.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), hC = uo(ev), jb = w({}, cu, {
    newState: 0,
    oldState: 0
  }), tv = uo(jb), yp = [9, 13, 27, 32], yd = nr && "CompositionEvent" in window, ic = null;
  nr && "documentMode" in document && (ic = document.documentMode);
  var So = nr && "TextEvent" in window && !ic, nv = nr && (!yd || ic && 8 < ic && 11 >= ic), dm = " ", du = !1;
  function wp(l, u) {
    switch (l) {
      case "keyup":
        return yp.indexOf(u.keyCode) !== -1;
      case "keydown":
        return u.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function rv(l) {
    return l = l.detail, typeof l == "object" && "data" in l ? l.data : null;
  }
  var lc = !1;
  function Ib(l, u) {
    switch (l) {
      case "compositionend":
        return rv(u);
      case "keypress":
        return u.which !== 32 ? null : (du = !0, dm);
      case "textInput":
        return l = u.data, l === dm && du ? null : l;
      default:
        return null;
    }
  }
  function pC(l, u) {
    if (lc)
      return l === "compositionend" || !yd && wp(l, u) ? (l = Zh(), gd = Uf = Ea = null, lc = !1, l) : null;
    switch (l) {
      case "paste":
        return null;
      case "keypress":
        if (!(u.ctrlKey || u.altKey || u.metaKey) || u.ctrlKey && u.altKey) {
          if (u.char && 1 < u.char.length)
            return u.char;
          if (u.which) return String.fromCharCode(u.which);
        }
        return null;
      case "compositionend":
        return nv && u.locale !== "ko" ? null : u.data;
      default:
        return null;
    }
  }
  var av = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
  };
  function _l(l) {
    var u = l && l.nodeName && l.nodeName.toLowerCase();
    return u === "input" ? !!av[l.type] : u === "textarea";
  }
  function ov(l, u, m, v) {
    yo ? ul ? ul.push(v) : ul = [v] : yo = v, u = lh(u, "onChange"), 0 < u.length && (m = new um(
      "onChange",
      "change",
      null,
      m,
      v
    ), l.push({ event: m, listeners: u }));
  }
  var sc = null, fu = null;
  function uc(l) {
    Ny(l, 0);
  }
  function wd(l) {
    var u = Xt(l);
    if (Bi(u)) return l;
  }
  function iv(l, u) {
    if (l === "change") return u;
  }
  var Sp = !1;
  if (nr) {
    var $o;
    if (nr) {
      var gl = "oninput" in document;
      if (!gl) {
        var lv = document.createElement("div");
        lv.setAttribute("oninput", "return;"), gl = typeof lv.oninput == "function";
      }
      $o = gl;
    } else $o = !1;
    Sp = $o && (!document.documentMode || 9 < document.documentMode);
  }
  function Cp() {
    sc && (sc.detachEvent("onpropertychange", xp), fu = sc = null);
  }
  function xp(l) {
    if (l.propertyName === "value" && wd(fu)) {
      var u = [];
      ov(
        u,
        fu,
        l,
        Li(l)
      ), lm(uc, u);
    }
  }
  function Lb(l, u, m) {
    l === "focusin" ? (Cp(), sc = u, fu = m, sc.attachEvent("onpropertychange", xp)) : l === "focusout" && Cp();
  }
  function Hb(l) {
    if (l === "selectionchange" || l === "keyup" || l === "keydown")
      return wd(fu);
  }
  function mu(l, u) {
    if (l === "click") return wd(u);
  }
  function cc(l, u) {
    if (l === "input" || l === "change")
      return wd(u);
  }
  function Fb(l, u) {
    return l === u && (l !== 0 || 1 / l === 1 / u) || l !== l && u !== u;
  }
  var Co = typeof Object.is == "function" ? Object.is : Fb;
  function Gi(l, u) {
    if (Co(l, u)) return !0;
    if (typeof l != "object" || l === null || typeof u != "object" || u === null)
      return !1;
    var m = Object.keys(l), v = Object.keys(u);
    if (m.length !== v.length) return !1;
    for (v = 0; v < m.length; v++) {
      var O = m[v];
      if (!Te.call(u, O) || !Co(l[O], u[O]))
        return !1;
    }
    return !0;
  }
  function sv(l) {
    for (; l && l.firstChild; ) l = l.firstChild;
    return l;
  }
  function uv(l, u) {
    var m = sv(l);
    l = 0;
    for (var v; m; ) {
      if (m.nodeType === 3) {
        if (v = l + m.textContent.length, l <= u && v >= u)
          return { node: m, offset: u - l };
        l = v;
      }
      e: {
        for (; m; ) {
          if (m.nextSibling) {
            m = m.nextSibling;
            break e;
          }
          m = m.parentNode;
        }
        m = void 0;
      }
      m = sv(m);
    }
  }
  function dc(l, u) {
    return l && u ? l === u ? !0 : l && l.nodeType === 3 ? !1 : u && u.nodeType === 3 ? dc(l, u.parentNode) : "contains" in l ? l.contains(u) : l.compareDocumentPosition ? !!(l.compareDocumentPosition(u) & 16) : !1 : !1;
  }
  function hu(l) {
    l = l != null && l.ownerDocument != null && l.ownerDocument.defaultView != null ? l.ownerDocument.defaultView : window;
    for (var u = hr(l.document); u instanceof l.HTMLIFrameElement; ) {
      try {
        var m = typeof u.contentWindow.location.href == "string";
      } catch {
        m = !1;
      }
      if (m) l = u.contentWindow;
      else break;
      u = hr(l.document);
    }
    return u;
  }
  function fm(l) {
    var u = l && l.nodeName && l.nodeName.toLowerCase();
    return u && (u === "input" && (l.type === "text" || l.type === "search" || l.type === "tel" || l.type === "url" || l.type === "password") || u === "textarea" || l.contentEditable === "true");
  }
  var mm = nr && "documentMode" in document && 11 >= document.documentMode, pu = null, Sd = null, qi = null, vl = !1;
  function Ep(l, u, m) {
    var v = m.window === m ? m.document : m.nodeType === 9 ? m : m.ownerDocument;
    vl || pu == null || pu !== hr(v) || (v = pu, "selectionStart" in v && fm(v) ? v = { start: v.selectionStart, end: v.selectionEnd } : (v = (v.ownerDocument && v.ownerDocument.defaultView || window).getSelection(), v = {
      anchorNode: v.anchorNode,
      anchorOffset: v.anchorOffset,
      focusNode: v.focusNode,
      focusOffset: v.focusOffset
    }), qi && Gi(qi, v) || (qi = v, v = lh(Sd, "onSelect"), 0 < v.length && (u = new um(
      "onSelect",
      "select",
      null,
      u,
      m
    ), l.push({ event: u, listeners: v }), u.target = pu)));
  }
  function As(l, u) {
    var m = {};
    return m[l.toLowerCase()] = u.toLowerCase(), m["Webkit" + l] = "webkit" + u, m["Moz" + l] = "moz" + u, m;
  }
  var bl = {
    animationend: As("Animation", "AnimationEnd"),
    animationiteration: As("Animation", "AnimationIteration"),
    animationstart: As("Animation", "AnimationStart"),
    transitionrun: As("Transition", "TransitionRun"),
    transitionstart: As("Transition", "TransitionStart"),
    transitioncancel: As("Transition", "TransitionCancel"),
    transitionend: As("Transition", "TransitionEnd")
  }, Cd = {}, gu = {};
  nr && (gu = document.createElement("div").style, "AnimationEvent" in window || (delete bl.animationend.animation, delete bl.animationiteration.animation, delete bl.animationstart.animation), "TransitionEvent" in window || delete bl.transitionend.transition);
  function cr(l) {
    if (Cd[l]) return Cd[l];
    if (!bl[l]) return l;
    var u = bl[l], m;
    for (m in u)
      if (u.hasOwnProperty(m) && m in gu)
        return Cd[l] = u[m];
    return l;
  }
  var hm = cr("animationend"), cv = cr("animationiteration"), Pp = cr("animationstart"), fc = cr("transitionrun"), pm = cr("transitionstart"), Bl = cr("transitioncancel"), Wb = cr("transitionend"), Ul = /* @__PURE__ */ new Map(), xd = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
    " "
  );
  xd.push("scrollEnd");
  function zo(l, u) {
    Ul.set(l, u), Nr(u, [l]);
  }
  var mc = typeof reportError == "function" ? reportError : function(l) {
    if (typeof window == "object" && typeof window.ErrorEvent == "function") {
      var u = new window.ErrorEvent("error", {
        bubbles: !0,
        cancelable: !0,
        message: typeof l == "object" && l !== null && typeof l.message == "string" ? String(l.message) : String(l),
        error: l
      });
      if (!window.dispatchEvent(u)) return;
    } else if (typeof process == "object" && typeof process.emit == "function") {
      process.emit("uncaughtException", l);
      return;
    }
    console.error(l);
  }, _r = [], _a = 0, Ki = 0;
  function gi() {
    for (var l = _a, u = Ki = _a = 0; u < l; ) {
      var m = _r[u];
      _r[u++] = null;
      var v = _r[u];
      _r[u++] = null;
      var O = _r[u];
      _r[u++] = null;
      var R = _r[u];
      if (_r[u++] = null, v !== null && O !== null) {
        var B = v.pending;
        B === null ? O.next = O : (O.next = B.next, B.next = O), v.pending = O;
      }
      R !== 0 && kp(m, O, R);
    }
  }
  function vi(l, u, m, v) {
    _r[_a++] = l, _r[_a++] = u, _r[_a++] = m, _r[_a++] = v, Ki |= v, l.lanes |= v, l = l.alternate, l !== null && (l.lanes |= v);
  }
  function Yi(l, u, m, v) {
    return vi(l, u, m, v), gm(l);
  }
  function Ns(l, u) {
    return vi(l, null, null, u), gm(l);
  }
  function kp(l, u, m) {
    l.lanes |= m;
    var v = l.alternate;
    v !== null && (v.lanes |= m);
    for (var O = !1, R = l.return; R !== null; )
      R.childLanes |= m, v = R.alternate, v !== null && (v.childLanes |= m), R.tag === 22 && (l = R.stateNode, l === null || l._visibility & 1 || (O = !0)), l = R, R = R.return;
    return l.tag === 3 ? (R = l.stateNode, O && u !== null && (O = 31 - ot(m), l = R.hiddenUpdates, v = l[O], v === null ? l[O] = [u] : v.push(u), u.lane = m | 536870912), R) : null;
  }
  function gm(l) {
    if (50 < Yd)
      throw Yd = 0, Jm = null, Error(a(185));
    for (var u = l.return; u !== null; )
      l = u, u = l.return;
    return l.tag === 3 ? l.stateNode : null;
  }
  var jo = {};
  function Vb(l, u, m, v) {
    this.tag = l, this.key = m, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = u, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = v, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function ca(l, u, m, v) {
    return new Vb(l, u, m, v);
  }
  function hc(l) {
    return l = l.prototype, !(!l || !l.isReactComponent);
  }
  function Ds(l, u) {
    var m = l.alternate;
    return m === null ? (m = ca(
      l.tag,
      u,
      l.key,
      l.mode
    ), m.elementType = l.elementType, m.type = l.type, m.stateNode = l.stateNode, m.alternate = l, l.alternate = m) : (m.pendingProps = u, m.type = l.type, m.flags = 0, m.subtreeFlags = 0, m.deletions = null), m.flags = l.flags & 65011712, m.childLanes = l.childLanes, m.lanes = l.lanes, m.child = l.child, m.memoizedProps = l.memoizedProps, m.memoizedState = l.memoizedState, m.updateQueue = l.updateQueue, u = l.dependencies, m.dependencies = u === null ? null : { lanes: u.lanes, firstContext: u.firstContext }, m.sibling = l.sibling, m.index = l.index, m.ref = l.ref, m.refCleanup = l.refCleanup, m;
  }
  function dv(l, u) {
    l.flags &= 65011714;
    var m = l.alternate;
    return m === null ? (l.childLanes = 0, l.lanes = u, l.child = null, l.subtreeFlags = 0, l.memoizedProps = null, l.memoizedState = null, l.updateQueue = null, l.dependencies = null, l.stateNode = null) : (l.childLanes = m.childLanes, l.lanes = m.lanes, l.child = m.child, l.subtreeFlags = 0, l.deletions = null, l.memoizedProps = m.memoizedProps, l.memoizedState = m.memoizedState, l.updateQueue = m.updateQueue, l.type = m.type, u = m.dependencies, l.dependencies = u === null ? null : {
      lanes: u.lanes,
      firstContext: u.firstContext
    }), l;
  }
  function Mp(l, u, m, v, O, R) {
    var B = 0;
    if (v = l, typeof l == "function") hc(l) && (B = 1);
    else if (typeof l == "string")
      B = $2(
        l,
        m,
        oe.current
      ) ? 26 : l === "html" || l === "head" || l === "body" ? 27 : 5;
    else
      e: switch (l) {
        case _:
          return l = ca(31, m, u, O), l.elementType = _, l.lanes = R, l;
        case k:
          return $s(m.children, O, R, u);
        case M:
          B = 8, O |= 24;
          break;
        case T:
          return l = ca(12, m, u, O | 2), l.elementType = T, l.lanes = R, l;
        case j:
          return l = ca(13, m, u, O), l.elementType = j, l.lanes = R, l;
        case I:
          return l = ca(19, m, u, O), l.elementType = I, l.lanes = R, l;
        default:
          if (typeof l == "object" && l !== null)
            switch (l.$$typeof) {
              case D:
                B = 10;
                break e;
              case N:
                B = 9;
                break e;
              case $:
                B = 11;
                break e;
              case L:
                B = 14;
                break e;
              case F:
                B = 16, v = null;
                break e;
            }
          B = 29, m = Error(
            a(130, l === null ? "null" : typeof l, "")
          ), v = null;
      }
    return u = ca(B, m, u, O), u.elementType = l, u.type = v, u.lanes = R, u;
  }
  function $s(l, u, m, v) {
    return l = ca(7, l, v, u), l.lanes = m, l;
  }
  function Ed(l, u, m) {
    return l = ca(6, l, null, u), l.lanes = m, l;
  }
  function fv(l) {
    var u = ca(18, null, null, 0);
    return u.stateNode = l, u;
  }
  function Op(l, u, m) {
    return u = ca(
      4,
      l.children !== null ? l.children : [],
      l.key,
      u
    ), u.lanes = m, u.stateNode = {
      containerInfo: l.containerInfo,
      pendingChildren: null,
      implementation: l.implementation
    }, u;
  }
  var mv = /* @__PURE__ */ new WeakMap();
  function bi(l, u) {
    if (typeof l == "object" && l !== null) {
      var m = mv.get(l);
      return m !== void 0 ? m : (u = {
        value: l,
        source: u,
        stack: Le(u)
      }, mv.set(l, u), u);
    }
    return {
      value: l,
      source: u,
      stack: Le(u)
    };
  }
  var yi = [], pc = 0, vm = null, va = 0, Jo = [], Io = 0, yl = null, Zo = 1, wl = "";
  function Qi(l, u) {
    yi[pc++] = va, yi[pc++] = vm, vm = l, va = u;
  }
  function hv(l, u, m) {
    Jo[Io++] = Zo, Jo[Io++] = wl, Jo[Io++] = yl, yl = l;
    var v = Zo;
    l = wl;
    var O = 32 - ot(v) - 1;
    v &= ~(1 << O), m += 1;
    var R = 32 - ot(u) + O;
    if (30 < R) {
      var B = O - O % 5;
      R = (v & (1 << B) - 1).toString(32), v >>= B, O -= B, Zo = 1 << 32 - ot(u) + O | m << O | v, wl = R + l;
    } else
      Zo = 1 << R | m << O | v, wl = l;
  }
  function Pd(l) {
    l.return !== null && (Qi(l, 1), hv(l, 1, 0));
  }
  function Tp(l) {
    for (; l === vm; )
      vm = yi[--pc], yi[pc] = null, va = yi[--pc], yi[pc] = null;
    for (; l === yl; )
      yl = Jo[--Io], Jo[Io] = null, wl = Jo[--Io], Jo[Io] = null, Zo = Jo[--Io], Jo[Io] = null;
  }
  function bm(l, u) {
    Jo[Io++] = Zo, Jo[Io++] = wl, Jo[Io++] = yl, Zo = u.id, wl = u.overflow, yl = l;
  }
  var Ba = null, $r = null, _n = !1, Xl = null, $a = !1, Gl = Error(a(519));
  function Ji(l) {
    var u = Error(
      a(
        418,
        1 < arguments.length && arguments[1] !== void 0 && arguments[1] ? "text" : "HTML",
        ""
      )
    );
    throw Md(bi(u, l)), Gl;
  }
  function ym(l) {
    var u = l.stateNode, m = l.type, v = l.memoizedProps;
    switch (u[Gt] = l, u[Dt] = v, m) {
      case "dialog":
        Vn("cancel", u), Vn("close", u);
        break;
      case "iframe":
      case "object":
      case "embed":
        Vn("load", u);
        break;
      case "video":
      case "audio":
        for (m = 0; m < nf.length; m++)
          Vn(nf[m], u);
        break;
      case "source":
        Vn("error", u);
        break;
      case "img":
      case "image":
      case "link":
        Vn("error", u), Vn("load", u);
        break;
      case "details":
        Vn("toggle", u);
        break;
      case "input":
        Vn("invalid", u), nn(
          u,
          v.value,
          v.defaultValue,
          v.checked,
          v.defaultChecked,
          v.type,
          v.name,
          !0
        );
        break;
      case "select":
        Vn("invalid", u);
        break;
      case "textarea":
        Vn("invalid", u), hi(u, v.value, v.defaultValue, v.children);
    }
    m = v.children, typeof m != "string" && typeof m != "number" && typeof m != "bigint" || u.textContent === "" + m || v.suppressHydrationWarning === !0 || x2(u.textContent, m) ? (v.popover != null && (Vn("beforetoggle", u), Vn("toggle", u)), v.onScroll != null && Vn("scroll", u), v.onScrollEnd != null && Vn("scrollend", u), v.onClick != null && (u.onclick = Va), u = !0) : u = !1, u || Ji(l, !0);
  }
  function kd(l) {
    for (Ba = l.return; Ba; )
      switch (Ba.tag) {
        case 5:
        case 31:
        case 13:
          $a = !1;
          return;
        case 27:
        case 3:
          $a = !0;
          return;
        default:
          Ba = Ba.return;
      }
  }
  function ql(l) {
    if (l !== Ba) return !1;
    if (!_n) return kd(l), _n = !0, !1;
    var u = l.tag, m;
    if ((m = u !== 3 && u !== 27) && ((m = u === 5) && (m = l.type, m = !(m !== "form" && m !== "button") || af(l.type, l.memoizedProps)), m = !m), m && $r && Ji(l), kd(l), u === 13) {
      if (l = l.memoizedState, l = l !== null ? l.dehydrated : null, !l) throw Error(a(317));
      $r = Ng(l);
    } else if (u === 31) {
      if (l = l.memoizedState, l = l !== null ? l.dehydrated : null, !l) throw Error(a(317));
      $r = Ng(l);
    } else
      u === 27 ? (u = $r, Al(l.type) ? (l = ch, ch = null, $r = l) : $r = u) : $r = Ba ? Go(l.stateNode.nextSibling) : null;
    return !0;
  }
  function vu() {
    $r = Ba = null, _n = !1;
  }
  function pv() {
    var l = Xl;
    return l !== null && (ta === null ? ta = l : ta.push.apply(
      ta,
      l
    ), Xl = null), l;
  }
  function Md(l) {
    Xl === null ? Xl = [l] : Xl.push(l);
  }
  var Rp = ee(null), zs = null, Sl = null;
  function Lo(l, u, m) {
    ae(Rp, u._currentValue), u._currentValue = m;
  }
  function Cl(l) {
    l._currentValue = Rp.current, ne(Rp);
  }
  function Ap(l, u, m) {
    for (; l !== null; ) {
      var v = l.alternate;
      if ((l.childLanes & u) !== u ? (l.childLanes |= u, v !== null && (v.childLanes |= u)) : v !== null && (v.childLanes & u) !== u && (v.childLanes |= u), l === m) break;
      l = l.return;
    }
  }
  function Kl(l, u, m, v) {
    var O = l.child;
    for (O !== null && (O.return = l); O !== null; ) {
      var R = O.dependencies;
      if (R !== null) {
        var B = O.child;
        R = R.firstContext;
        e: for (; R !== null; ) {
          var re = R;
          R = O;
          for (var ve = 0; ve < u.length; ve++)
            if (re.context === u[ve]) {
              R.lanes |= m, re = R.alternate, re !== null && (re.lanes |= m), Ap(
                R.return,
                m,
                l
              ), v || (B = null);
              break e;
            }
          R = re.next;
        }
      } else if (O.tag === 18) {
        if (B = O.return, B === null) throw Error(a(341));
        B.lanes |= m, R = B.alternate, R !== null && (R.lanes |= m), Ap(B, m, l), B = null;
      } else B = O.child;
      if (B !== null) B.return = O;
      else
        for (B = O; B !== null; ) {
          if (B === l) {
            B = null;
            break;
          }
          if (O = B.sibling, O !== null) {
            O.return = B.return, B = O;
            break;
          }
          B = B.return;
        }
      O = B;
    }
  }
  function Ua(l, u, m, v) {
    l = null;
    for (var O = u, R = !1; O !== null; ) {
      if (!R) {
        if ((O.flags & 524288) !== 0) R = !0;
        else if ((O.flags & 262144) !== 0) break;
      }
      if (O.tag === 10) {
        var B = O.alternate;
        if (B === null) throw Error(a(387));
        if (B = B.memoizedProps, B !== null) {
          var re = O.type;
          Co(O.pendingProps.value, B.value) || (l !== null ? l.push(re) : l = [re]);
        }
      } else if (O === me.current) {
        if (B = O.alternate, B === null) throw Error(a(387));
        B.memoizedState.memoizedState !== O.memoizedState.memoizedState && (l !== null ? l.push(mh) : l = [mh]);
      }
      O = O.return;
    }
    l !== null && Kl(
      u,
      l,
      m,
      v
    ), u.flags |= 262144;
  }
  function gc(l) {
    for (l = l.firstContext; l !== null; ) {
      if (!Co(
        l.context._currentValue,
        l.memoizedValue
      ))
        return !0;
      l = l.next;
    }
    return !1;
  }
  function sn(l) {
    zs = l, Sl = null, l = l.dependencies, l !== null && (l.firstContext = null);
  }
  function rt(l) {
    return wm(zs, l);
  }
  function js(l, u) {
    return zs === null && sn(l), wm(l, u);
  }
  function wm(l, u) {
    var m = u._currentValue;
    if (u = { context: u, memoizedValue: m, next: null }, Sl === null) {
      if (l === null) throw Error(a(308));
      Sl = u, l.dependencies = { lanes: 0, firstContext: u }, l.flags |= 524288;
    } else Sl = Sl.next = u;
    return m;
  }
  var da = typeof AbortController < "u" ? AbortController : function() {
    var l = [], u = this.signal = {
      aborted: !1,
      addEventListener: function(m, v) {
        l.push(v);
      }
    };
    this.abort = function() {
      u.aborted = !0, l.forEach(function(m) {
        return m();
      });
    };
  }, gv = e.unstable_scheduleCallback, vv = e.unstable_NormalPriority, ba = {
    $$typeof: D,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
  };
  function Sm() {
    return {
      controller: new da(),
      data: /* @__PURE__ */ new Map(),
      refCount: 0
    };
  }
  function Cm(l) {
    l.refCount--, l.refCount === 0 && gv(vv, function() {
      l.controller.abort();
    });
  }
  var vc = null, xm = 0, bu = 0, Ma = null;
  function gr(l, u) {
    if (vc === null) {
      var m = vc = [];
      xm = 0, bu = Eg(), Ma = {
        status: "pending",
        value: void 0,
        then: function(v) {
          m.push(v);
        }
      };
    }
    return xm++, u.then(Em, Em), u;
  }
  function Em() {
    if (--xm === 0 && vc !== null) {
      Ma !== null && (Ma.status = "fulfilled");
      var l = vc;
      vc = null, bu = 0, Ma = null;
      for (var u = 0; u < l.length; u++) (0, l[u])();
    }
  }
  function Pm(l, u) {
    var m = [], v = {
      status: "pending",
      value: null,
      reason: null,
      then: function(O) {
        m.push(O);
      }
    };
    return l.then(
      function() {
        v.status = "fulfilled", v.value = u;
        for (var O = 0; O < m.length; O++) (0, m[O])(u);
      },
      function(O) {
        for (v.status = "rejected", v.reason = O, O = 0; O < m.length; O++)
          (0, m[O])(void 0);
      }
    ), v;
  }
  var Is = H.S;
  H.S = function(l, u) {
    c2 = Fe(), typeof u == "object" && u !== null && typeof u.then == "function" && gr(l, u), Is !== null && Is(l, u);
  };
  var wi = ee(null);
  function Si() {
    var l = wi.current;
    return l !== null ? l : kr.pooledCache;
  }
  function Od(l, u) {
    u === null ? ae(wi, wi.current) : ae(wi, u.pool);
  }
  function bc() {
    var l = Si();
    return l === null ? null : { parent: ba._currentValue, pool: l };
  }
  var yu = Error(a(460)), yc = Error(a(474)), Td = Error(a(542)), wc = { then: function() {
  } };
  function bv(l) {
    return l = l.status, l === "fulfilled" || l === "rejected";
  }
  function yv(l, u, m) {
    switch (m = l[m], m === void 0 ? l.push(u) : m !== u && (u.then(Va, Va), u = m), u.status) {
      case "fulfilled":
        return u.value;
      case "rejected":
        throw l = u.reason, Np(l), l;
      default:
        if (typeof u.status == "string") u.then(Va, Va);
        else {
          if (l = kr, l !== null && 100 < l.shellSuspendCounter)
            throw Error(a(482));
          l = u, l.status = "pending", l.then(
            function(v) {
              if (u.status === "pending") {
                var O = u;
                O.status = "fulfilled", O.value = v;
              }
            },
            function(v) {
              if (u.status === "pending") {
                var O = u;
                O.status = "rejected", O.reason = v;
              }
            }
          );
        }
        switch (u.status) {
          case "fulfilled":
            return u.value;
          case "rejected":
            throw l = u.reason, Np(l), l;
        }
        throw Su = u, yu;
    }
  }
  function wu(l) {
    try {
      var u = l._init;
      return u(l._payload);
    } catch (m) {
      throw m !== null && typeof m == "object" && typeof m.then == "function" ? (Su = m, yu) : m;
    }
  }
  var Su = null;
  function wv() {
    if (Su === null) throw Error(a(459));
    var l = Su;
    return Su = null, l;
  }
  function Np(l) {
    if (l === yu || l === Td)
      throw Error(a(483));
  }
  var Cu = null, Sc = 0;
  function km(l) {
    var u = Sc;
    return Sc += 1, Cu === null && (Cu = []), yv(Cu, l, u);
  }
  function Rd(l, u) {
    u = u.props.ref, l.ref = u !== void 0 ? u : null;
  }
  function Mm(l, u) {
    throw u.$$typeof === x ? Error(a(525)) : (l = Object.prototype.toString.call(u), Error(
      a(
        31,
        l === "[object Object]" ? "object with keys {" + Object.keys(u).join(", ") + "}" : l
      )
    ));
  }
  function _b(l) {
    function u($e, Pe) {
      if (l) {
        var Ie = $e.deletions;
        Ie === null ? ($e.deletions = [Pe], $e.flags |= 16) : Ie.push(Pe);
      }
    }
    function m($e, Pe) {
      if (!l) return null;
      for (; Pe !== null; )
        u($e, Pe), Pe = Pe.sibling;
      return null;
    }
    function v($e) {
      for (var Pe = /* @__PURE__ */ new Map(); $e !== null; )
        $e.key !== null ? Pe.set($e.key, $e) : Pe.set($e.index, $e), $e = $e.sibling;
      return Pe;
    }
    function O($e, Pe) {
      return $e = Ds($e, Pe), $e.index = 0, $e.sibling = null, $e;
    }
    function R($e, Pe, Ie) {
      return $e.index = Ie, l ? (Ie = $e.alternate, Ie !== null ? (Ie = Ie.index, Ie < Pe ? ($e.flags |= 67108866, Pe) : Ie) : ($e.flags |= 67108866, Pe)) : ($e.flags |= 1048576, Pe);
    }
    function B($e) {
      return l && $e.alternate === null && ($e.flags |= 67108866), $e;
    }
    function re($e, Pe, Ie, et) {
      return Pe === null || Pe.tag !== 6 ? (Pe = Ed(Ie, $e.mode, et), Pe.return = $e, Pe) : (Pe = O(Pe, Ie), Pe.return = $e, Pe);
    }
    function ve($e, Pe, Ie, et) {
      var Vt = Ie.type;
      return Vt === k ? Je(
        $e,
        Pe,
        Ie.props.children,
        et,
        Ie.key
      ) : Pe !== null && (Pe.elementType === Vt || typeof Vt == "object" && Vt !== null && Vt.$$typeof === F && wu(Vt) === Pe.type) ? (Pe = O(Pe, Ie.props), Rd(Pe, Ie), Pe.return = $e, Pe) : (Pe = Mp(
        Ie.type,
        Ie.key,
        Ie.props,
        null,
        $e.mode,
        et
      ), Rd(Pe, Ie), Pe.return = $e, Pe);
    }
    function He($e, Pe, Ie, et) {
      return Pe === null || Pe.tag !== 4 || Pe.stateNode.containerInfo !== Ie.containerInfo || Pe.stateNode.implementation !== Ie.implementation ? (Pe = Op(Ie, $e.mode, et), Pe.return = $e, Pe) : (Pe = O(Pe, Ie.children || []), Pe.return = $e, Pe);
    }
    function Je($e, Pe, Ie, et, Vt) {
      return Pe === null || Pe.tag !== 7 ? (Pe = $s(
        Ie,
        $e.mode,
        et,
        Vt
      ), Pe.return = $e, Pe) : (Pe = O(Pe, Ie), Pe.return = $e, Pe);
    }
    function nt($e, Pe, Ie) {
      if (typeof Pe == "string" && Pe !== "" || typeof Pe == "number" || typeof Pe == "bigint")
        return Pe = Ed(
          "" + Pe,
          $e.mode,
          Ie
        ), Pe.return = $e, Pe;
      if (typeof Pe == "object" && Pe !== null) {
        switch (Pe.$$typeof) {
          case E:
            return Ie = Mp(
              Pe.type,
              Pe.key,
              Pe.props,
              null,
              $e.mode,
              Ie
            ), Rd(Ie, Pe), Ie.return = $e, Ie;
          case P:
            return Pe = Op(
              Pe,
              $e.mode,
              Ie
            ), Pe.return = $e, Pe;
          case F:
            return Pe = wu(Pe), nt($e, Pe, Ie);
        }
        if (J(Pe) || U(Pe))
          return Pe = $s(
            Pe,
            $e.mode,
            Ie,
            null
          ), Pe.return = $e, Pe;
        if (typeof Pe.then == "function")
          return nt($e, km(Pe), Ie);
        if (Pe.$$typeof === D)
          return nt(
            $e,
            js($e, Pe),
            Ie
          );
        Mm($e, Pe);
      }
      return null;
    }
    function We($e, Pe, Ie, et) {
      var Vt = Pe !== null ? Pe.key : null;
      if (typeof Ie == "string" && Ie !== "" || typeof Ie == "number" || typeof Ie == "bigint")
        return Vt !== null ? null : re($e, Pe, "" + Ie, et);
      if (typeof Ie == "object" && Ie !== null) {
        switch (Ie.$$typeof) {
          case E:
            return Ie.key === Vt ? ve($e, Pe, Ie, et) : null;
          case P:
            return Ie.key === Vt ? He($e, Pe, Ie, et) : null;
          case F:
            return Ie = wu(Ie), We($e, Pe, Ie, et);
        }
        if (J(Ie) || U(Ie))
          return Vt !== null ? null : Je($e, Pe, Ie, et, null);
        if (typeof Ie.then == "function")
          return We(
            $e,
            Pe,
            km(Ie),
            et
          );
        if (Ie.$$typeof === D)
          return We(
            $e,
            Pe,
            js($e, Ie),
            et
          );
        Mm($e, Ie);
      }
      return null;
    }
    function Ge($e, Pe, Ie, et, Vt) {
      if (typeof et == "string" && et !== "" || typeof et == "number" || typeof et == "bigint")
        return $e = $e.get(Ie) || null, re(Pe, $e, "" + et, Vt);
      if (typeof et == "object" && et !== null) {
        switch (et.$$typeof) {
          case E:
            return $e = $e.get(
              et.key === null ? Ie : et.key
            ) || null, ve(Pe, $e, et, Vt);
          case P:
            return $e = $e.get(
              et.key === null ? Ie : et.key
            ) || null, He(Pe, $e, et, Vt);
          case F:
            return et = wu(et), Ge(
              $e,
              Pe,
              Ie,
              et,
              Vt
            );
        }
        if (J(et) || U(et))
          return $e = $e.get(Ie) || null, Je(Pe, $e, et, Vt, null);
        if (typeof et.then == "function")
          return Ge(
            $e,
            Pe,
            Ie,
            km(et),
            Vt
          );
        if (et.$$typeof === D)
          return Ge(
            $e,
            Pe,
            Ie,
            js(Pe, et),
            Vt
          );
        Mm(Pe, et);
      }
      return null;
    }
    function At($e, Pe, Ie, et) {
      for (var Vt = null, rr = null, jt = Pe, vn = Pe = 0, Pn = null; jt !== null && vn < Ie.length; vn++) {
        jt.index > vn ? (Pn = jt, jt = null) : Pn = jt.sibling;
        var lr = We(
          $e,
          jt,
          Ie[vn],
          et
        );
        if (lr === null) {
          jt === null && (jt = Pn);
          break;
        }
        l && jt && lr.alternate === null && u($e, jt), Pe = R(lr, Pe, vn), rr === null ? Vt = lr : rr.sibling = lr, rr = lr, jt = Pn;
      }
      if (vn === Ie.length)
        return m($e, jt), _n && Qi($e, vn), Vt;
      if (jt === null) {
        for (; vn < Ie.length; vn++)
          jt = nt($e, Ie[vn], et), jt !== null && (Pe = R(
            jt,
            Pe,
            vn
          ), rr === null ? Vt = jt : rr.sibling = jt, rr = jt);
        return _n && Qi($e, vn), Vt;
      }
      for (jt = v(jt); vn < Ie.length; vn++)
        Pn = Ge(
          jt,
          $e,
          vn,
          Ie[vn],
          et
        ), Pn !== null && (l && Pn.alternate !== null && jt.delete(
          Pn.key === null ? vn : Pn.key
        ), Pe = R(
          Pn,
          Pe,
          vn
        ), rr === null ? Vt = Pn : rr.sibling = Pn, rr = Pn);
      return l && jt.forEach(function($l) {
        return u($e, $l);
      }), _n && Qi($e, vn), Vt;
    }
    function Zt($e, Pe, Ie, et) {
      if (Ie == null) throw Error(a(151));
      for (var Vt = null, rr = null, jt = Pe, vn = Pe = 0, Pn = null, lr = Ie.next(); jt !== null && !lr.done; vn++, lr = Ie.next()) {
        jt.index > vn ? (Pn = jt, jt = null) : Pn = jt.sibling;
        var $l = We($e, jt, lr.value, et);
        if ($l === null) {
          jt === null && (jt = Pn);
          break;
        }
        l && jt && $l.alternate === null && u($e, jt), Pe = R($l, Pe, vn), rr === null ? Vt = $l : rr.sibling = $l, rr = $l, jt = Pn;
      }
      if (lr.done)
        return m($e, jt), _n && Qi($e, vn), Vt;
      if (jt === null) {
        for (; !lr.done; vn++, lr = Ie.next())
          lr = nt($e, lr.value, et), lr !== null && (Pe = R(lr, Pe, vn), rr === null ? Vt = lr : rr.sibling = lr, rr = lr);
        return _n && Qi($e, vn), Vt;
      }
      for (jt = v(jt); !lr.done; vn++, lr = Ie.next())
        lr = Ge(jt, $e, vn, lr.value, et), lr !== null && (l && lr.alternate !== null && jt.delete(lr.key === null ? vn : lr.key), Pe = R(lr, Pe, vn), rr === null ? Vt = lr : rr.sibling = lr, rr = lr);
      return l && jt.forEach(function(Gy) {
        return u($e, Gy);
      }), _n && Qi($e, vn), Vt;
    }
    function Or($e, Pe, Ie, et) {
      if (typeof Ie == "object" && Ie !== null && Ie.type === k && Ie.key === null && (Ie = Ie.props.children), typeof Ie == "object" && Ie !== null) {
        switch (Ie.$$typeof) {
          case E:
            e: {
              for (var Vt = Ie.key; Pe !== null; ) {
                if (Pe.key === Vt) {
                  if (Vt = Ie.type, Vt === k) {
                    if (Pe.tag === 7) {
                      m(
                        $e,
                        Pe.sibling
                      ), et = O(
                        Pe,
                        Ie.props.children
                      ), et.return = $e, $e = et;
                      break e;
                    }
                  } else if (Pe.elementType === Vt || typeof Vt == "object" && Vt !== null && Vt.$$typeof === F && wu(Vt) === Pe.type) {
                    m(
                      $e,
                      Pe.sibling
                    ), et = O(Pe, Ie.props), Rd(et, Ie), et.return = $e, $e = et;
                    break e;
                  }
                  m($e, Pe);
                  break;
                } else u($e, Pe);
                Pe = Pe.sibling;
              }
              Ie.type === k ? (et = $s(
                Ie.props.children,
                $e.mode,
                et,
                Ie.key
              ), et.return = $e, $e = et) : (et = Mp(
                Ie.type,
                Ie.key,
                Ie.props,
                null,
                $e.mode,
                et
              ), Rd(et, Ie), et.return = $e, $e = et);
            }
            return B($e);
          case P:
            e: {
              for (Vt = Ie.key; Pe !== null; ) {
                if (Pe.key === Vt)
                  if (Pe.tag === 4 && Pe.stateNode.containerInfo === Ie.containerInfo && Pe.stateNode.implementation === Ie.implementation) {
                    m(
                      $e,
                      Pe.sibling
                    ), et = O(Pe, Ie.children || []), et.return = $e, $e = et;
                    break e;
                  } else {
                    m($e, Pe);
                    break;
                  }
                else u($e, Pe);
                Pe = Pe.sibling;
              }
              et = Op(Ie, $e.mode, et), et.return = $e, $e = et;
            }
            return B($e);
          case F:
            return Ie = wu(Ie), Or(
              $e,
              Pe,
              Ie,
              et
            );
        }
        if (J(Ie))
          return At(
            $e,
            Pe,
            Ie,
            et
          );
        if (U(Ie)) {
          if (Vt = U(Ie), typeof Vt != "function") throw Error(a(150));
          return Ie = Vt.call(Ie), Zt(
            $e,
            Pe,
            Ie,
            et
          );
        }
        if (typeof Ie.then == "function")
          return Or(
            $e,
            Pe,
            km(Ie),
            et
          );
        if (Ie.$$typeof === D)
          return Or(
            $e,
            Pe,
            js($e, Ie),
            et
          );
        Mm($e, Ie);
      }
      return typeof Ie == "string" && Ie !== "" || typeof Ie == "number" || typeof Ie == "bigint" ? (Ie = "" + Ie, Pe !== null && Pe.tag === 6 ? (m($e, Pe.sibling), et = O(Pe, Ie), et.return = $e, $e = et) : (m($e, Pe), et = Ed(Ie, $e.mode, et), et.return = $e, $e = et), B($e)) : m($e, Pe);
    }
    return function($e, Pe, Ie, et) {
      try {
        Sc = 0;
        var Vt = Or(
          $e,
          Pe,
          Ie,
          et
        );
        return Cu = null, Vt;
      } catch (jt) {
        if (jt === yu || jt === Td) throw jt;
        var rr = ca(29, jt, null, $e.mode);
        return rr.lanes = et, rr.return = $e, rr;
      } finally {
      }
    };
  }
  var xu = _b(!0), Sv = _b(!1), Ls = !1;
  function Om(l) {
    l.updateQueue = {
      baseState: l.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: { pending: null, lanes: 0, hiddenCallbacks: null },
      callbacks: null
    };
  }
  function Dp(l, u) {
    l = l.updateQueue, u.updateQueue === l && (u.updateQueue = {
      baseState: l.baseState,
      firstBaseUpdate: l.firstBaseUpdate,
      lastBaseUpdate: l.lastBaseUpdate,
      shared: l.shared,
      callbacks: null
    });
  }
  function Hs(l) {
    return { lane: l, tag: 0, payload: null, callback: null, next: null };
  }
  function Ci(l, u, m) {
    var v = l.updateQueue;
    if (v === null) return null;
    if (v = v.shared, (ir & 2) !== 0) {
      var O = v.pending;
      return O === null ? u.next = u : (u.next = O.next, O.next = u), v.pending = u, u = gm(l), kp(l, null, m), u;
    }
    return vi(l, v, u, m), gm(l);
  }
  function Eu(l, u, m) {
    if (u = u.updateQueue, u !== null && (u = u.shared, (m & 4194048) !== 0)) {
      var v = u.lanes;
      v &= l.pendingLanes, m |= v, u.lanes = m, Lt(l, m);
    }
  }
  function $p(l, u) {
    var m = l.updateQueue, v = l.alternate;
    if (v !== null && (v = v.updateQueue, m === v)) {
      var O = null, R = null;
      if (m = m.firstBaseUpdate, m !== null) {
        do {
          var B = {
            lane: m.lane,
            tag: m.tag,
            payload: m.payload,
            callback: null,
            next: null
          };
          R === null ? O = R = B : R = R.next = B, m = m.next;
        } while (m !== null);
        R === null ? O = R = u : R = R.next = u;
      } else O = R = u;
      m = {
        baseState: v.baseState,
        firstBaseUpdate: O,
        lastBaseUpdate: R,
        shared: v.shared,
        callbacks: v.callbacks
      }, l.updateQueue = m;
      return;
    }
    l = m.lastBaseUpdate, l === null ? m.firstBaseUpdate = u : l.next = u, m.lastBaseUpdate = u;
  }
  var Cv = !1;
  function Pu() {
    if (Cv) {
      var l = Ma;
      if (l !== null) throw l;
    }
  }
  function Yl(l, u, m, v) {
    Cv = !1;
    var O = l.updateQueue;
    Ls = !1;
    var R = O.firstBaseUpdate, B = O.lastBaseUpdate, re = O.shared.pending;
    if (re !== null) {
      O.shared.pending = null;
      var ve = re, He = ve.next;
      ve.next = null, B === null ? R = He : B.next = He, B = ve;
      var Je = l.alternate;
      Je !== null && (Je = Je.updateQueue, re = Je.lastBaseUpdate, re !== B && (re === null ? Je.firstBaseUpdate = He : re.next = He, Je.lastBaseUpdate = ve));
    }
    if (R !== null) {
      var nt = O.baseState;
      B = 0, Je = He = ve = null, re = R;
      do {
        var We = re.lane & -536870913, Ge = We !== re.lane;
        if (Ge ? (In & We) === We : (v & We) === We) {
          We !== 0 && We === bu && (Cv = !0), Je !== null && (Je = Je.next = {
            lane: 0,
            tag: re.tag,
            payload: re.payload,
            callback: null,
            next: null
          });
          e: {
            var At = l, Zt = re;
            We = u;
            var Or = m;
            switch (Zt.tag) {
              case 1:
                if (At = Zt.payload, typeof At == "function") {
                  nt = At.call(Or, nt, We);
                  break e;
                }
                nt = At;
                break e;
              case 3:
                At.flags = At.flags & -65537 | 128;
              case 0:
                if (At = Zt.payload, We = typeof At == "function" ? At.call(Or, nt, We) : At, We == null) break e;
                nt = w({}, nt, We);
                break e;
              case 2:
                Ls = !0;
            }
          }
          We = re.callback, We !== null && (l.flags |= 64, Ge && (l.flags |= 8192), Ge = O.callbacks, Ge === null ? O.callbacks = [We] : Ge.push(We));
        } else
          Ge = {
            lane: We,
            tag: re.tag,
            payload: re.payload,
            callback: re.callback,
            next: null
          }, Je === null ? (He = Je = Ge, ve = nt) : Je = Je.next = Ge, B |= We;
        if (re = re.next, re === null) {
          if (re = O.shared.pending, re === null)
            break;
          Ge = re, re = Ge.next, Ge.next = null, O.lastBaseUpdate = Ge, O.shared.pending = null;
        }
      } while (!0);
      Je === null && (ve = nt), O.baseState = ve, O.firstBaseUpdate = He, O.lastBaseUpdate = Je, R === null && (O.shared.lanes = 0), Tl |= B, l.lanes = B, l.memoizedState = nt;
    }
  }
  function zp(l, u) {
    if (typeof l != "function")
      throw Error(a(191, l));
    l.call(u);
  }
  function ku(l, u) {
    var m = l.callbacks;
    if (m !== null)
      for (l.callbacks = null, l = 0; l < m.length; l++)
        zp(m[l], u);
  }
  var za = ee(null), Cc = ee(0);
  function Bb(l, u) {
    l = Ol, ae(Cc, l), ae(za, u), Ol = l | u.baseLanes;
  }
  function Tm() {
    ae(Cc, Ol), ae(za, za.current);
  }
  function Ad() {
    Ol = Cc.current, ne(za), ne(Cc);
  }
  var Ho = ee(null), Hi = null;
  function Ql(l) {
    var u = l.alternate;
    ae(Br, Br.current & 1), ae(Ho, l), Hi === null && (u === null || za.current !== null || u.memoizedState !== null) && (Hi = l);
  }
  function Nd(l) {
    ae(Br, Br.current), ae(Ho, l), Hi === null && (Hi = l);
  }
  function jp(l) {
    l.tag === 22 ? (ae(Br, Br.current), ae(Ho, l), Hi === null && (Hi = l)) : xl();
  }
  function xl() {
    ae(Br, Br.current), ae(Ho, Ho.current);
  }
  function Fo(l) {
    ne(Ho), Hi === l && (Hi = null), ne(Br);
  }
  var Br = ee(0);
  function Dd(l) {
    for (var u = l; u !== null; ) {
      if (u.tag === 13) {
        var m = u.memoizedState;
        if (m !== null && (m = m.dehydrated, m === null || nl(m) || Lu(m)))
          return u;
      } else if (u.tag === 19 && (u.memoizedProps.revealOrder === "forwards" || u.memoizedProps.revealOrder === "backwards" || u.memoizedProps.revealOrder === "unstable_legacy-backwards" || u.memoizedProps.revealOrder === "together")) {
        if ((u.flags & 128) !== 0) return u;
      } else if (u.child !== null) {
        u.child.return = u, u = u.child;
        continue;
      }
      if (u === l) break;
      for (; u.sibling === null; ) {
        if (u.return === null || u.return === l) return null;
        u = u.return;
      }
      u.sibling.return = u.return, u = u.sibling;
    }
    return null;
  }
  var Jl = 0, Sn = null, vr = null, ya = null, xc = !1, Ec = !1, Fs = !1, Rm = 0, $d = 0, Mu = null, Ub = 0;
  function Zr() {
    throw Error(a(321));
  }
  function Ws(l, u) {
    if (u === null) return !1;
    for (var m = 0; m < u.length && m < l.length; m++)
      if (!Co(l[m], u[m])) return !1;
    return !0;
  }
  function Am(l, u, m, v, O, R) {
    return Jl = R, Sn = u, u.memoizedState = null, u.updateQueue = null, u.lanes = 0, H.H = l === null || l.memoizedState === null ? Zb : Zp, Fs = !1, R = m(v, O), Fs = !1, Ec && (R = Xb(
      u,
      m,
      v,
      O
    )), Ip(l), R;
  }
  function Ip(l) {
    H.H = Fm;
    var u = vr !== null && vr.next !== null;
    if (Jl = 0, ya = vr = Sn = null, xc = !1, $d = 0, Mu = null, u) throw Error(a(300));
    l === null || wa || (l = l.dependencies, l !== null && gc(l) && (wa = !0));
  }
  function Xb(l, u, m, v) {
    Sn = l;
    var O = 0;
    do {
      if (Ec && (Mu = null), $d = 0, Ec = !1, 25 <= O) throw Error(a(301));
      if (O += 1, ya = vr = null, l.updateQueue != null) {
        var R = l.updateQueue;
        R.lastEffect = null, R.events = null, R.stores = null, R.memoCache != null && (R.memoCache.index = 0);
      }
      H.H = ey, R = u(m, v);
    } while (Ec);
    return R;
  }
  function gC() {
    var l = H.H, u = l.useState()[0];
    return u = typeof u.then == "function" ? kc(u) : u, l = l.useState()[0], (vr !== null ? vr.memoizedState : null) !== l && (Sn.flags |= 1024), u;
  }
  function Lp() {
    var l = Rm !== 0;
    return Rm = 0, l;
  }
  function Pc(l, u, m) {
    u.updateQueue = l.updateQueue, u.flags &= -2053, l.lanes &= ~m;
  }
  function Nm(l) {
    if (xc) {
      for (l = l.memoizedState; l !== null; ) {
        var u = l.queue;
        u !== null && (u.pending = null), l = l.next;
      }
      xc = !1;
    }
    Jl = 0, ya = vr = Sn = null, Ec = !1, $d = Rm = 0, Mu = null;
  }
  function Xa() {
    var l = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null
    };
    return ya === null ? Sn.memoizedState = ya = l : ya = ya.next = l, ya;
  }
  function fa() {
    if (vr === null) {
      var l = Sn.alternate;
      l = l !== null ? l.memoizedState : null;
    } else l = vr.next;
    var u = ya === null ? Sn.memoizedState : ya.next;
    if (u !== null)
      ya = u, vr = l;
    else {
      if (l === null)
        throw Sn.alternate === null ? Error(a(467)) : Error(a(310));
      vr = l, l = {
        memoizedState: vr.memoizedState,
        baseState: vr.baseState,
        baseQueue: vr.baseQueue,
        queue: vr.queue,
        next: null
      }, ya === null ? Sn.memoizedState = ya = l : ya = ya.next = l;
    }
    return ya;
  }
  function Dm() {
    return { lastEffect: null, events: null, stores: null, memoCache: null };
  }
  function kc(l) {
    var u = $d;
    return $d += 1, Mu === null && (Mu = []), l = yv(Mu, l, u), u = Sn, (ya === null ? u.memoizedState : ya.next) === null && (u = u.alternate, H.H = u === null || u.memoizedState === null ? Zb : Zp), l;
  }
  function zd(l) {
    if (l !== null && typeof l == "object") {
      if (typeof l.then == "function") return kc(l);
      if (l.$$typeof === D) return rt(l);
    }
    throw Error(a(438, String(l)));
  }
  function Hp(l) {
    var u = null, m = Sn.updateQueue;
    if (m !== null && (u = m.memoCache), u == null) {
      var v = Sn.alternate;
      v !== null && (v = v.updateQueue, v !== null && (v = v.memoCache, v != null && (u = {
        data: v.data.map(function(O) {
          return O.slice();
        }),
        index: 0
      })));
    }
    if (u == null && (u = { data: [], index: 0 }), m === null && (m = Dm(), Sn.updateQueue = m), m.memoCache = u, m = u.data[u.index], m === void 0)
      for (m = u.data[u.index] = Array(l), v = 0; v < l; v++)
        m[v] = W;
    return u.index++, m;
  }
  function Zl(l, u) {
    return typeof u == "function" ? u(l) : u;
  }
  function es(l) {
    var u = fa();
    return Fp(u, vr, l);
  }
  function Fp(l, u, m) {
    var v = l.queue;
    if (v === null) throw Error(a(311));
    v.lastRenderedReducer = m;
    var O = l.baseQueue, R = v.pending;
    if (R !== null) {
      if (O !== null) {
        var B = O.next;
        O.next = R.next, R.next = B;
      }
      u.baseQueue = O = R, v.pending = null;
    }
    if (R = l.baseState, O === null) l.memoizedState = R;
    else {
      u = O.next;
      var re = B = null, ve = null, He = u, Je = !1;
      do {
        var nt = He.lane & -536870913;
        if (nt !== He.lane ? (In & nt) === nt : (Jl & nt) === nt) {
          var We = He.revertLane;
          if (We === 0)
            ve !== null && (ve = ve.next = {
              lane: 0,
              revertLane: 0,
              gesture: null,
              action: He.action,
              hasEagerState: He.hasEagerState,
              eagerState: He.eagerState,
              next: null
            }), nt === bu && (Je = !0);
          else if ((Jl & We) === We) {
            He = He.next, We === bu && (Je = !0);
            continue;
          } else
            nt = {
              lane: 0,
              revertLane: He.revertLane,
              gesture: null,
              action: He.action,
              hasEagerState: He.hasEagerState,
              eagerState: He.eagerState,
              next: null
            }, ve === null ? (re = ve = nt, B = R) : ve = ve.next = nt, Sn.lanes |= We, Tl |= We;
          nt = He.action, Fs && m(R, nt), R = He.hasEagerState ? He.eagerState : m(R, nt);
        } else
          We = {
            lane: nt,
            revertLane: He.revertLane,
            gesture: He.gesture,
            action: He.action,
            hasEagerState: He.hasEagerState,
            eagerState: He.eagerState,
            next: null
          }, ve === null ? (re = ve = We, B = R) : ve = ve.next = We, Sn.lanes |= nt, Tl |= nt;
        He = He.next;
      } while (He !== null && He !== u);
      if (ve === null ? B = R : ve.next = re, !Co(R, l.memoizedState) && (wa = !0, Je && (m = Ma, m !== null)))
        throw m;
      l.memoizedState = R, l.baseState = B, l.baseQueue = ve, v.lastRenderedState = R;
    }
    return O === null && (v.lanes = 0), [l.memoizedState, v.dispatch];
  }
  function Wp(l) {
    var u = fa(), m = u.queue;
    if (m === null) throw Error(a(311));
    m.lastRenderedReducer = l;
    var v = m.dispatch, O = m.pending, R = u.memoizedState;
    if (O !== null) {
      m.pending = null;
      var B = O = O.next;
      do
        R = l(R, B.action), B = B.next;
      while (B !== O);
      Co(R, u.memoizedState) || (wa = !0), u.memoizedState = R, u.baseQueue === null && (u.baseState = R), m.lastRenderedState = R;
    }
    return [R, v];
  }
  function xv(l, u, m) {
    var v = Sn, O = fa(), R = _n;
    if (R) {
      if (m === void 0) throw Error(a(407));
      m = m();
    } else m = u();
    var B = !Co(
      (vr || O).memoizedState,
      m
    );
    if (B && (O.memoizedState = m, wa = !0), O = O.queue, Xp(Vp.bind(null, v, O, l), [
      l
    ]), O.getSnapshot !== u || B || ya !== null && ya.memoizedState.tag & 1) {
      if (v.flags |= 2048, Oc(
        9,
        { destroy: void 0 },
        Ev.bind(
          null,
          v,
          O,
          m,
          u
        ),
        null
      ), kr === null) throw Error(a(349));
      R || (Jl & 127) !== 0 || $m(v, u, m);
    }
    return m;
  }
  function $m(l, u, m) {
    l.flags |= 16384, l = { getSnapshot: u, value: m }, u = Sn.updateQueue, u === null ? (u = Dm(), Sn.updateQueue = u, u.stores = [l]) : (m = u.stores, m === null ? u.stores = [l] : m.push(l));
  }
  function Ev(l, u, m, v) {
    u.value = m, u.getSnapshot = v, _p(u) && Bp(l);
  }
  function Vp(l, u, m) {
    return m(function() {
      _p(u) && Bp(l);
    });
  }
  function _p(l) {
    var u = l.getSnapshot;
    l = l.value;
    try {
      var m = u();
      return !Co(l, m);
    } catch {
      return !0;
    }
  }
  function Bp(l) {
    var u = Ns(l, 2);
    u !== null && Xo(u, l, 2);
  }
  function Pv(l) {
    var u = Xa();
    if (typeof l == "function") {
      var m = l;
      if (l = m(), Fs) {
        ht(!0);
        try {
          m();
        } finally {
          ht(!1);
        }
      }
    }
    return u.memoizedState = u.baseState = l, u.queue = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: Zl,
      lastRenderedState: l
    }, u;
  }
  function Ga(l, u, m, v) {
    return l.baseState = m, Fp(
      l,
      vr,
      typeof v == "function" ? v : Zl
    );
  }
  function Gb(l, u, m, v, O) {
    if (Hm(l)) throw Error(a(485));
    if (l = u.action, l !== null) {
      var R = {
        payload: O,
        action: l,
        next: null,
        isTransition: !0,
        status: "pending",
        value: null,
        reason: null,
        listeners: [],
        then: function(B) {
          R.listeners.push(B);
        }
      };
      H.T !== null ? m(!0) : R.isTransition = !1, v(R), m = u.pending, m === null ? (R.next = u.pending = R, kv(u, R)) : (R.next = m.next, u.pending = m.next = R);
    }
  }
  function kv(l, u) {
    var m = u.action, v = u.payload, O = l.state;
    if (u.isTransition) {
      var R = H.T, B = {};
      H.T = B;
      try {
        var re = m(O, v), ve = H.S;
        ve !== null && ve(B, re), Mv(l, u, re);
      } catch (He) {
        Mc(l, u, He);
      } finally {
        R !== null && B.types !== null && (R.types = B.types), H.T = R;
      }
    } else
      try {
        R = m(O, v), Mv(l, u, R);
      } catch (He) {
        Mc(l, u, He);
      }
  }
  function Mv(l, u, m) {
    m !== null && typeof m == "object" && typeof m.then == "function" ? m.then(
      function(v) {
        Ov(l, u, v);
      },
      function(v) {
        return Mc(l, u, v);
      }
    ) : Ov(l, u, m);
  }
  function Ov(l, u, m) {
    u.status = "fulfilled", u.value = m, Tv(u), l.state = m, u = l.pending, u !== null && (m = u.next, m === u ? l.pending = null : (m = m.next, u.next = m, kv(l, m)));
  }
  function Mc(l, u, m) {
    var v = l.pending;
    if (l.pending = null, v !== null) {
      v = v.next;
      do
        u.status = "rejected", u.reason = m, Tv(u), u = u.next;
      while (u !== v);
    }
    l.action = null;
  }
  function Tv(l) {
    l = l.listeners;
    for (var u = 0; u < l.length; u++) (0, l[u])();
  }
  function zm(l, u) {
    return u;
  }
  function Rv(l, u) {
    if (_n) {
      var m = kr.formState;
      if (m !== null) {
        e: {
          var v = Sn;
          if (_n) {
            if ($r) {
              t: {
                for (var O = $r, R = $a; O.nodeType !== 8; ) {
                  if (!R) {
                    O = null;
                    break t;
                  }
                  if (O = Go(
                    O.nextSibling
                  ), O === null) {
                    O = null;
                    break t;
                  }
                }
                R = O.data, O = R === "F!" || R === "F" ? O : null;
              }
              if (O) {
                $r = Go(
                  O.nextSibling
                ), v = O.data === "F!";
                break e;
              }
            }
            Ji(v);
          }
          v = !1;
        }
        v && (u = m[0]);
      }
    }
    return m = Xa(), m.memoizedState = m.baseState = u, v = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: zm,
      lastRenderedState: u
    }, m.queue = v, m = Qp.bind(
      null,
      Sn,
      v
    ), v.dispatch = m, v = Pv(!1), R = Ou.bind(
      null,
      Sn,
      !1,
      v.queue
    ), v = Xa(), O = {
      state: u,
      dispatch: null,
      action: l,
      pending: null
    }, v.queue = O, m = Gb.bind(
      null,
      Sn,
      O,
      R,
      m
    ), O.dispatch = m, v.memoizedState = l, [u, m, !1];
  }
  function qb(l) {
    var u = fa();
    return jm(u, vr, l);
  }
  function jm(l, u, m) {
    if (u = Fp(
      l,
      u,
      zm
    )[0], l = es(Zl)[0], typeof u == "object" && u !== null && typeof u.then == "function")
      try {
        var v = kc(u);
      } catch (B) {
        throw B === yu ? Td : B;
      }
    else v = u;
    u = fa();
    var O = u.queue, R = O.dispatch;
    return m !== u.memoizedState && (Sn.flags |= 2048, Oc(
      9,
      { destroy: void 0 },
      Av.bind(null, O, m),
      null
    )), [v, R, l];
  }
  function Av(l, u) {
    l.action = u;
  }
  function Nv(l) {
    var u = fa(), m = vr;
    if (m !== null)
      return jm(u, m, l);
    fa(), u = u.memoizedState, m = fa();
    var v = m.queue.dispatch;
    return m.memoizedState = l, [u, v, !1];
  }
  function Oc(l, u, m, v) {
    return l = { tag: l, create: m, deps: v, inst: u, next: null }, u = Sn.updateQueue, u === null && (u = Dm(), Sn.updateQueue = u), m = u.lastEffect, m === null ? u.lastEffect = l.next = l : (v = m.next, m.next = l, l.next = v, u.lastEffect = l), l;
  }
  function Dv() {
    return fa().memoizedState;
  }
  function jd(l, u, m, v) {
    var O = Xa();
    Sn.flags |= l, O.memoizedState = Oc(
      1 | u,
      { destroy: void 0 },
      m,
      v === void 0 ? null : v
    );
  }
  function Id(l, u, m, v) {
    var O = fa();
    v = v === void 0 ? null : v;
    var R = O.memoizedState.inst;
    vr !== null && v !== null && Ws(v, vr.memoizedState.deps) ? O.memoizedState = Oc(u, R, m, v) : (Sn.flags |= l, O.memoizedState = Oc(
      1 | u,
      R,
      m,
      v
    ));
  }
  function Up(l, u) {
    jd(8390656, 8, l, u);
  }
  function Xp(l, u) {
    Id(2048, 8, l, u);
  }
  function $v(l) {
    Sn.flags |= 4;
    var u = Sn.updateQueue;
    if (u === null)
      u = Dm(), Sn.updateQueue = u, u.events = [l];
    else {
      var m = u.events;
      m === null ? u.events = [l] : m.push(l);
    }
  }
  function Im(l) {
    var u = fa().memoizedState;
    return $v({ ref: u, nextImpl: l }), function() {
      if ((ir & 2) !== 0) throw Error(a(440));
      return u.impl.apply(void 0, arguments);
    };
  }
  function Gp(l, u) {
    return Id(4, 2, l, u);
  }
  function zv(l, u) {
    return Id(4, 4, l, u);
  }
  function qp(l, u) {
    if (typeof u == "function") {
      l = l();
      var m = u(l);
      return function() {
        typeof m == "function" ? m() : u(null);
      };
    }
    if (u != null)
      return l = l(), u.current = l, function() {
        u.current = null;
      };
  }
  function jv(l, u, m) {
    m = m != null ? m.concat([l]) : null, Id(4, 4, qp.bind(null, u, l), m);
  }
  function El() {
  }
  function Kp(l, u) {
    var m = fa();
    u = u === void 0 ? null : u;
    var v = m.memoizedState;
    return u !== null && Ws(u, v[1]) ? v[0] : (m.memoizedState = [l, u], l);
  }
  function Kb(l, u) {
    var m = fa();
    u = u === void 0 ? null : u;
    var v = m.memoizedState;
    if (u !== null && Ws(u, v[1]))
      return v[0];
    if (v = l(), Fs) {
      ht(!0);
      try {
        l();
      } finally {
        ht(!1);
      }
    }
    return m.memoizedState = [v, u], v;
  }
  function Lm(l, u, m) {
    return m === void 0 || (Jl & 1073741824) !== 0 && (In & 261930) === 0 ? l.memoizedState = u : (l.memoizedState = m, l = cy(), Sn.lanes |= l, Tl |= l, m);
  }
  function ts(l, u, m, v) {
    return Co(m, u) ? m : za.current !== null ? (l = Lm(l, m, v), Co(l, u) || (wa = !0), l) : (Jl & 42) === 0 || (Jl & 1073741824) !== 0 && (In & 261930) === 0 ? (wa = !0, l.memoizedState = m) : (l = cy(), Sn.lanes |= l, Tl |= l, u);
  }
  function Yp(l, u, m, v, O) {
    var R = K.p;
    K.p = R !== 0 && 8 > R ? R : 8;
    var B = H.T, re = {};
    H.T = re, Ou(l, !1, u, m);
    try {
      var ve = O(), He = H.S;
      if (He !== null && He(re, ve), ve !== null && typeof ve == "object" && typeof ve.then == "function") {
        var Je = Pm(
          ve,
          v
        );
        Vs(
          l,
          u,
          Je,
          ri(l)
        );
      } else
        Vs(
          l,
          u,
          v,
          ri(l)
        );
    } catch (nt) {
      Vs(
        l,
        u,
        { then: function() {
        }, status: "rejected", reason: nt },
        ri()
      );
    } finally {
      K.p = R, B !== null && re.types !== null && (B.types = re.types), H.T = B;
    }
  }
  function Yb() {
  }
  function Ld(l, u, m, v) {
    if (l.tag !== 5) throw Error(a(476));
    var O = Hd(l).queue;
    Yp(
      l,
      O,
      u,
      X,
      m === null ? Yb : function() {
        return Pr(l), m(v);
      }
    );
  }
  function Hd(l) {
    var u = l.memoizedState;
    if (u !== null) return u;
    u = {
      memoizedState: X,
      baseState: X,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Zl,
        lastRenderedState: X
      },
      next: null
    };
    var m = {};
    return u.next = {
      memoizedState: m,
      baseState: m,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Zl,
        lastRenderedState: m
      },
      next: null
    }, l.memoizedState = u, l = l.alternate, l !== null && (l.memoizedState = u), u;
  }
  function Pr(l) {
    var u = Hd(l);
    u.next === null && (u = l.alternate.memoizedState), Vs(
      l,
      u.next.queue,
      {},
      ri()
    );
  }
  function Iv() {
    return rt(mh);
  }
  function Qb() {
    return fa().memoizedState;
  }
  function Lv() {
    return fa().memoizedState;
  }
  function ns(l) {
    for (var u = l.return; u !== null; ) {
      switch (u.tag) {
        case 24:
        case 3:
          var m = ri();
          l = Hs(m);
          var v = Ci(u, l, m);
          v !== null && (Xo(v, u, m), Eu(v, u, m)), u = { cache: Sm() }, l.payload = u;
          return;
      }
      u = u.return;
    }
  }
  function Jb(l, u, m) {
    var v = ri();
    m = {
      lane: v,
      revertLane: 0,
      gesture: null,
      action: m,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, Hm(l) ? Jp(u, m) : (m = Yi(l, u, m, v), m !== null && (Xo(m, l, v), Hv(m, u, v)));
  }
  function Qp(l, u, m) {
    var v = ri();
    Vs(l, u, m, v);
  }
  function Vs(l, u, m, v) {
    var O = {
      lane: v,
      revertLane: 0,
      gesture: null,
      action: m,
      hasEagerState: !1,
      eagerState: null,
      next: null
    };
    if (Hm(l)) Jp(u, O);
    else {
      var R = l.alternate;
      if (l.lanes === 0 && (R === null || R.lanes === 0) && (R = u.lastRenderedReducer, R !== null))
        try {
          var B = u.lastRenderedState, re = R(B, m);
          if (O.hasEagerState = !0, O.eagerState = re, Co(re, B))
            return vi(l, u, O, 0), kr === null && gi(), !1;
        } catch {
        } finally {
        }
      if (m = Yi(l, u, O, v), m !== null)
        return Xo(m, l, v), Hv(m, u, v), !0;
    }
    return !1;
  }
  function Ou(l, u, m, v) {
    if (v = {
      lane: 2,
      revertLane: Eg(),
      gesture: null,
      action: v,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, Hm(l)) {
      if (u) throw Error(a(479));
    } else
      u = Yi(
        l,
        m,
        v,
        2
      ), u !== null && Xo(u, l, 2);
  }
  function Hm(l) {
    var u = l.alternate;
    return l === Sn || u !== null && u === Sn;
  }
  function Jp(l, u) {
    Ec = xc = !0;
    var m = l.pending;
    m === null ? u.next = u : (u.next = m.next, m.next = u), l.pending = u;
  }
  function Hv(l, u, m) {
    if ((m & 4194048) !== 0) {
      var v = u.lanes;
      v &= l.pendingLanes, m |= v, u.lanes = m, Lt(l, m);
    }
  }
  var Fm = {
    readContext: rt,
    use: zd,
    useCallback: Zr,
    useContext: Zr,
    useEffect: Zr,
    useImperativeHandle: Zr,
    useLayoutEffect: Zr,
    useInsertionEffect: Zr,
    useMemo: Zr,
    useReducer: Zr,
    useRef: Zr,
    useState: Zr,
    useDebugValue: Zr,
    useDeferredValue: Zr,
    useTransition: Zr,
    useSyncExternalStore: Zr,
    useId: Zr,
    useHostTransitionStatus: Zr,
    useFormState: Zr,
    useActionState: Zr,
    useOptimistic: Zr,
    useMemoCache: Zr,
    useCacheRefresh: Zr
  };
  Fm.useEffectEvent = Zr;
  var Zb = {
    readContext: rt,
    use: zd,
    useCallback: function(l, u) {
      return Xa().memoizedState = [
        l,
        u === void 0 ? null : u
      ], l;
    },
    useContext: rt,
    useEffect: Up,
    useImperativeHandle: function(l, u, m) {
      m = m != null ? m.concat([l]) : null, jd(
        4194308,
        4,
        qp.bind(null, u, l),
        m
      );
    },
    useLayoutEffect: function(l, u) {
      return jd(4194308, 4, l, u);
    },
    useInsertionEffect: function(l, u) {
      jd(4, 2, l, u);
    },
    useMemo: function(l, u) {
      var m = Xa();
      u = u === void 0 ? null : u;
      var v = l();
      if (Fs) {
        ht(!0);
        try {
          l();
        } finally {
          ht(!1);
        }
      }
      return m.memoizedState = [v, u], v;
    },
    useReducer: function(l, u, m) {
      var v = Xa();
      if (m !== void 0) {
        var O = m(u);
        if (Fs) {
          ht(!0);
          try {
            m(u);
          } finally {
            ht(!1);
          }
        }
      } else O = u;
      return v.memoizedState = v.baseState = O, l = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: l,
        lastRenderedState: O
      }, v.queue = l, l = l.dispatch = Jb.bind(
        null,
        Sn,
        l
      ), [v.memoizedState, l];
    },
    useRef: function(l) {
      var u = Xa();
      return l = { current: l }, u.memoizedState = l;
    },
    useState: function(l) {
      l = Pv(l);
      var u = l.queue, m = Qp.bind(null, Sn, u);
      return u.dispatch = m, [l.memoizedState, m];
    },
    useDebugValue: El,
    useDeferredValue: function(l, u) {
      var m = Xa();
      return Lm(m, l, u);
    },
    useTransition: function() {
      var l = Pv(!1);
      return l = Yp.bind(
        null,
        Sn,
        l.queue,
        !0,
        !1
      ), Xa().memoizedState = l, [!1, l];
    },
    useSyncExternalStore: function(l, u, m) {
      var v = Sn, O = Xa();
      if (_n) {
        if (m === void 0)
          throw Error(a(407));
        m = m();
      } else {
        if (m = u(), kr === null)
          throw Error(a(349));
        (In & 127) !== 0 || $m(v, u, m);
      }
      O.memoizedState = m;
      var R = { value: m, getSnapshot: u };
      return O.queue = R, Up(Vp.bind(null, v, R, l), [
        l
      ]), v.flags |= 2048, Oc(
        9,
        { destroy: void 0 },
        Ev.bind(
          null,
          v,
          R,
          m,
          u
        ),
        null
      ), m;
    },
    useId: function() {
      var l = Xa(), u = kr.identifierPrefix;
      if (_n) {
        var m = wl, v = Zo;
        m = (v & ~(1 << 32 - ot(v) - 1)).toString(32) + m, u = "_" + u + "R_" + m, m = Rm++, 0 < m && (u += "H" + m.toString(32)), u += "_";
      } else
        m = Ub++, u = "_" + u + "r_" + m.toString(32) + "_";
      return l.memoizedState = u;
    },
    useHostTransitionStatus: Iv,
    useFormState: Rv,
    useActionState: Rv,
    useOptimistic: function(l) {
      var u = Xa();
      u.memoizedState = u.baseState = l;
      var m = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
      };
      return u.queue = m, u = Ou.bind(
        null,
        Sn,
        !0,
        m
      ), m.dispatch = u, [l, u];
    },
    useMemoCache: Hp,
    useCacheRefresh: function() {
      return Xa().memoizedState = ns.bind(
        null,
        Sn
      );
    },
    useEffectEvent: function(l) {
      var u = Xa(), m = { impl: l };
      return u.memoizedState = m, function() {
        if ((ir & 2) !== 0)
          throw Error(a(440));
        return m.impl.apply(void 0, arguments);
      };
    }
  }, Zp = {
    readContext: rt,
    use: zd,
    useCallback: Kp,
    useContext: rt,
    useEffect: Xp,
    useImperativeHandle: jv,
    useInsertionEffect: Gp,
    useLayoutEffect: zv,
    useMemo: Kb,
    useReducer: es,
    useRef: Dv,
    useState: function() {
      return es(Zl);
    },
    useDebugValue: El,
    useDeferredValue: function(l, u) {
      var m = fa();
      return ts(
        m,
        vr.memoizedState,
        l,
        u
      );
    },
    useTransition: function() {
      var l = es(Zl)[0], u = fa().memoizedState;
      return [
        typeof l == "boolean" ? l : kc(l),
        u
      ];
    },
    useSyncExternalStore: xv,
    useId: Qb,
    useHostTransitionStatus: Iv,
    useFormState: qb,
    useActionState: qb,
    useOptimistic: function(l, u) {
      var m = fa();
      return Ga(m, vr, l, u);
    },
    useMemoCache: Hp,
    useCacheRefresh: Lv
  };
  Zp.useEffectEvent = Im;
  var ey = {
    readContext: rt,
    use: zd,
    useCallback: Kp,
    useContext: rt,
    useEffect: Xp,
    useImperativeHandle: jv,
    useInsertionEffect: Gp,
    useLayoutEffect: zv,
    useMemo: Kb,
    useReducer: Wp,
    useRef: Dv,
    useState: function() {
      return Wp(Zl);
    },
    useDebugValue: El,
    useDeferredValue: function(l, u) {
      var m = fa();
      return vr === null ? Lm(m, l, u) : ts(
        m,
        vr.memoizedState,
        l,
        u
      );
    },
    useTransition: function() {
      var l = Wp(Zl)[0], u = fa().memoizedState;
      return [
        typeof l == "boolean" ? l : kc(l),
        u
      ];
    },
    useSyncExternalStore: xv,
    useId: Qb,
    useHostTransitionStatus: Iv,
    useFormState: Nv,
    useActionState: Nv,
    useOptimistic: function(l, u) {
      var m = fa();
      return vr !== null ? Ga(m, vr, l, u) : (m.baseState = l, [l, m.queue.dispatch]);
    },
    useMemoCache: Hp,
    useCacheRefresh: Lv
  };
  ey.useEffectEvent = Im;
  function Tc(l, u, m, v) {
    u = l.memoizedState, m = m(v, u), m = m == null ? u : w({}, u, m), l.memoizedState = m, l.lanes === 0 && (l.updateQueue.baseState = m);
  }
  var Zi = {
    enqueueSetState: function(l, u, m) {
      l = l._reactInternals;
      var v = ri(), O = Hs(v);
      O.payload = u, m != null && (O.callback = m), u = Ci(l, O, v), u !== null && (Xo(u, l, v), Eu(u, l, v));
    },
    enqueueReplaceState: function(l, u, m) {
      l = l._reactInternals;
      var v = ri(), O = Hs(v);
      O.tag = 1, O.payload = u, m != null && (O.callback = m), u = Ci(l, O, v), u !== null && (Xo(u, l, v), Eu(u, l, v));
    },
    enqueueForceUpdate: function(l, u) {
      l = l._reactInternals;
      var m = ri(), v = Hs(m);
      v.tag = 2, u != null && (v.callback = u), u = Ci(l, v, m), u !== null && (Xo(u, l, m), Eu(u, l, m));
    }
  };
  function Fv(l, u, m, v, O, R, B) {
    return l = l.stateNode, typeof l.shouldComponentUpdate == "function" ? l.shouldComponentUpdate(v, R, B) : u.prototype && u.prototype.isPureReactComponent ? !Gi(m, v) || !Gi(O, R) : !0;
  }
  function ty(l, u, m, v) {
    l = u.state, typeof u.componentWillReceiveProps == "function" && u.componentWillReceiveProps(m, v), typeof u.UNSAFE_componentWillReceiveProps == "function" && u.UNSAFE_componentWillReceiveProps(m, v), u.state !== l && Zi.enqueueReplaceState(u, u.state, null);
  }
  function Tu(l, u) {
    var m = u;
    if ("ref" in u) {
      m = {};
      for (var v in u)
        v !== "ref" && (m[v] = u[v]);
    }
    if (l = l.defaultProps) {
      m === u && (m = w({}, m));
      for (var O in l)
        m[O] === void 0 && (m[O] = l[O]);
    }
    return m;
  }
  function eg(l) {
    mc(l);
  }
  function Wv(l) {
    console.error(l);
  }
  function tg(l) {
    mc(l);
  }
  function Fd(l, u) {
    try {
      var m = l.onUncaughtError;
      m(u.value, { componentStack: u.stack });
    } catch (v) {
      setTimeout(function() {
        throw v;
      });
    }
  }
  function Wm(l, u, m) {
    try {
      var v = l.onCaughtError;
      v(m.value, {
        componentStack: m.stack,
        errorBoundary: u.tag === 1 ? u.stateNode : null
      });
    } catch (O) {
      setTimeout(function() {
        throw O;
      });
    }
  }
  function Vv(l, u, m) {
    return m = Hs(m), m.tag = 3, m.payload = { element: null }, m.callback = function() {
      Fd(l, u);
    }, m;
  }
  function _v(l) {
    return l = Hs(l), l.tag = 3, l;
  }
  function Bv(l, u, m, v) {
    var O = m.type.getDerivedStateFromError;
    if (typeof O == "function") {
      var R = v.value;
      l.payload = function() {
        return O(R);
      }, l.callback = function() {
        Wm(u, m, v);
      };
    }
    var B = m.stateNode;
    B !== null && typeof B.componentDidCatch == "function" && (l.callback = function() {
      Wm(u, m, v), typeof O != "function" && (Ur === null ? Ur = /* @__PURE__ */ new Set([this]) : Ur.add(this));
      var re = v.stack;
      this.componentDidCatch(v.value, {
        componentStack: re !== null ? re : ""
      });
    });
  }
  function vC(l, u, m, v, O) {
    if (m.flags |= 32768, v !== null && typeof v == "object" && typeof v.then == "function") {
      if (u = m.alternate, u !== null && Ua(
        u,
        m,
        O,
        !0
      ), m = Ho.current, m !== null) {
        switch (m.tag) {
          case 31:
          case 13:
            return Hi === null ? wg() : m.alternate === null && jr === 0 && (jr = 3), m.flags &= -257, m.flags |= 65536, m.lanes = O, v === wc ? m.flags |= 16384 : (u = m.updateQueue, u === null ? m.updateQueue = /* @__PURE__ */ new Set([v]) : u.add(v), th(l, v, O)), !1;
          case 22:
            return m.flags |= 65536, v === wc ? m.flags |= 16384 : (u = m.updateQueue, u === null ? (u = {
              transitions: null,
              markerInstances: null,
              retryQueue: /* @__PURE__ */ new Set([v])
            }, m.updateQueue = u) : (m = u.retryQueue, m === null ? u.retryQueue = /* @__PURE__ */ new Set([v]) : m.add(v)), th(l, v, O)), !1;
        }
        throw Error(a(435, m.tag));
      }
      return th(l, v, O), wg(), !1;
    }
    if (_n)
      return u = Ho.current, u !== null ? ((u.flags & 65536) === 0 && (u.flags |= 256), u.flags |= 65536, u.lanes = O, v !== Gl && (l = Error(a(422), { cause: v }), Md(bi(l, m)))) : (v !== Gl && (u = Error(a(423), {
        cause: v
      }), Md(
        bi(u, m)
      )), l = l.current.alternate, l.flags |= 65536, O &= -O, l.lanes |= O, v = bi(v, m), O = Vv(
        l.stateNode,
        v,
        O
      ), $p(l, O), jr !== 4 && (jr = 2)), !1;
    var R = Error(a(520), { cause: v });
    if (R = bi(R, m), Qm === null ? Qm = [R] : Qm.push(R), jr !== 4 && (jr = 2), u === null) return !0;
    v = bi(v, m), m = u;
    do {
      switch (m.tag) {
        case 3:
          return m.flags |= 65536, l = O & -O, m.lanes |= l, l = Vv(m.stateNode, v, l), $p(m, l), !1;
        case 1:
          if (u = m.type, R = m.stateNode, (m.flags & 128) === 0 && (typeof u.getDerivedStateFromError == "function" || R !== null && typeof R.componentDidCatch == "function" && (Ur === null || !Ur.has(R))))
            return m.flags |= 65536, O &= -O, m.lanes |= O, O = _v(O), Bv(
              O,
              l,
              m,
              v
            ), $p(m, O), !1;
      }
      m = m.return;
    } while (m !== null);
    return !1;
  }
  var ng = Error(a(461)), wa = !1;
  function Wr(l, u, m, v) {
    u.child = l === null ? Sv(u, null, m, v) : xu(
      u,
      l.child,
      m,
      v
    );
  }
  function Uv(l, u, m, v, O) {
    m = m.render;
    var R = u.ref;
    if ("ref" in v) {
      var B = {};
      for (var re in v)
        re !== "ref" && (B[re] = v[re]);
    } else B = v;
    return sn(u), v = Am(
      l,
      u,
      m,
      B,
      R,
      O
    ), re = Lp(), l !== null && !wa ? (Pc(l, u, O), Pi(l, u, O)) : (_n && re && Pd(u), u.flags |= 1, Wr(l, u, v, O), u.child);
  }
  function Xv(l, u, m, v, O) {
    if (l === null) {
      var R = m.type;
      return typeof R == "function" && !hc(R) && R.defaultProps === void 0 && m.compare === null ? (u.tag = 15, u.type = R, Gv(
        l,
        u,
        R,
        v,
        O
      )) : (l = Mp(
        m.type,
        null,
        v,
        u,
        u.mode,
        O
      ), l.ref = u.ref, l.return = u, u.child = l);
    }
    if (R = l.child, !og(l, O)) {
      var B = R.memoizedProps;
      if (m = m.compare, m = m !== null ? m : Gi, m(B, v) && l.ref === u.ref)
        return Pi(l, u, O);
    }
    return u.flags |= 1, l = Ds(R, v), l.ref = u.ref, l.return = u, u.child = l;
  }
  function Gv(l, u, m, v, O) {
    if (l !== null) {
      var R = l.memoizedProps;
      if (Gi(R, v) && l.ref === u.ref)
        if (wa = !1, u.pendingProps = v = R, og(l, O))
          (l.flags & 131072) !== 0 && (wa = !0);
        else
          return u.lanes = l.lanes, Pi(l, u, O);
    }
    return rg(
      l,
      u,
      m,
      v,
      O
    );
  }
  function ny(l, u, m, v) {
    var O = v.children, R = l !== null ? l.memoizedState : null;
    if (l === null && u.stateNode === null && (u.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }), v.mode === "hidden") {
      if ((u.flags & 128) !== 0) {
        if (R = R !== null ? R.baseLanes | m : m, l !== null) {
          for (v = u.child = l.child, O = 0; v !== null; )
            O = O | v.lanes | v.childLanes, v = v.sibling;
          v = O & ~R;
        } else v = 0, u.child = null;
        return Wo(
          l,
          u,
          R,
          m,
          v
        );
      }
      if ((m & 536870912) !== 0)
        u.memoizedState = { baseLanes: 0, cachePool: null }, l !== null && Od(
          u,
          R !== null ? R.cachePool : null
        ), R !== null ? Bb(u, R) : Tm(), jp(u);
      else
        return v = u.lanes = 536870912, Wo(
          l,
          u,
          R !== null ? R.baseLanes | m : m,
          m,
          v
        );
    } else
      R !== null ? (Od(u, R.cachePool), Bb(u, R), xl(), u.memoizedState = null) : (l !== null && Od(u, null), Tm(), xl());
    return Wr(l, u, O, m), u.child;
  }
  function Ru(l, u) {
    return l !== null && l.tag === 22 || u.stateNode !== null || (u.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }), u.sibling;
  }
  function Wo(l, u, m, v, O) {
    var R = Si();
    return R = R === null ? null : { parent: ba._currentValue, pool: R }, u.memoizedState = {
      baseLanes: m,
      cachePool: R
    }, l !== null && Od(u, null), Tm(), jp(u), l !== null && Ua(l, u, v, !0), u.childLanes = O, null;
  }
  function Vm(l, u) {
    return u = Um(
      { mode: u.mode, children: u.children },
      l.mode
    ), u.ref = l.ref, l.child = u, u.return = l, u;
  }
  function Vo(l, u, m) {
    return xu(u, l.child, null, m), l = Vm(u, u.pendingProps), l.flags |= 2, Fo(u), u.memoizedState = null, l;
  }
  function ry(l, u, m) {
    var v = u.pendingProps, O = (u.flags & 128) !== 0;
    if (u.flags &= -129, l === null) {
      if (_n) {
        if (v.mode === "hidden")
          return l = Vm(u, v), u.lanes = 536870912, Ru(null, l);
        if (Nd(u), (l = $r) ? (l = Ly(
          l,
          $a
        ), l = l !== null && l.data === "&" ? l : null, l !== null && (u.memoizedState = {
          dehydrated: l,
          treeContext: yl !== null ? { id: Zo, overflow: wl } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, m = fv(l), m.return = u, u.child = m, Ba = u, $r = null)) : l = null, l === null) throw Ji(u);
        return u.lanes = 536870912, null;
      }
      return Vm(u, v);
    }
    var R = l.memoizedState;
    if (R !== null) {
      var B = R.dehydrated;
      if (Nd(u), O)
        if (u.flags & 256)
          u.flags &= -257, u = Vo(
            l,
            u,
            m
          );
        else if (u.memoizedState !== null)
          u.child = l.child, u.flags |= 128, u = null;
        else throw Error(a(558));
      else if (wa || Ua(l, u, m, !1), O = (m & l.childLanes) !== 0, wa || O) {
        if (v = kr, v !== null && (B = gt(v, m), B !== 0 && B !== R.retryLane))
          throw R.retryLane = B, Ns(l, B), Xo(v, l, B), ng;
        wg(), u = Vo(
          l,
          u,
          m
        );
      } else
        l = R.treeContext, $r = Go(B.nextSibling), Ba = u, _n = !0, Xl = null, $a = !1, l !== null && bm(u, l), u = Vm(u, v), u.flags |= 4096;
      return u;
    }
    return l = Ds(l.child, {
      mode: v.mode,
      children: v.children
    }), l.ref = u.ref, u.child = l, l.return = u, l;
  }
  function xi(l, u) {
    var m = u.ref;
    if (m === null)
      l !== null && l.ref !== null && (u.flags |= 4194816);
    else {
      if (typeof m != "function" && typeof m != "object")
        throw Error(a(284));
      (l === null || l.ref !== m) && (u.flags |= 4194816);
    }
  }
  function rg(l, u, m, v, O) {
    return sn(u), m = Am(
      l,
      u,
      m,
      v,
      void 0,
      O
    ), v = Lp(), l !== null && !wa ? (Pc(l, u, O), Pi(l, u, O)) : (_n && v && Pd(u), u.flags |= 1, Wr(l, u, m, O), u.child);
  }
  function Au(l, u, m, v, O, R) {
    return sn(u), u.updateQueue = null, m = Xb(
      u,
      v,
      m,
      O
    ), Ip(l), v = Lp(), l !== null && !wa ? (Pc(l, u, R), Pi(l, u, R)) : (_n && v && Pd(u), u.flags |= 1, Wr(l, u, m, R), u.child);
  }
  function qv(l, u, m, v, O) {
    if (sn(u), u.stateNode === null) {
      var R = jo, B = m.contextType;
      typeof B == "object" && B !== null && (R = rt(B)), R = new m(v, R), u.memoizedState = R.state !== null && R.state !== void 0 ? R.state : null, R.updater = Zi, u.stateNode = R, R._reactInternals = u, R = u.stateNode, R.props = v, R.state = u.memoizedState, R.refs = {}, Om(u), B = m.contextType, R.context = typeof B == "object" && B !== null ? rt(B) : jo, R.state = u.memoizedState, B = m.getDerivedStateFromProps, typeof B == "function" && (Tc(
        u,
        m,
        B,
        v
      ), R.state = u.memoizedState), typeof m.getDerivedStateFromProps == "function" || typeof R.getSnapshotBeforeUpdate == "function" || typeof R.UNSAFE_componentWillMount != "function" && typeof R.componentWillMount != "function" || (B = R.state, typeof R.componentWillMount == "function" && R.componentWillMount(), typeof R.UNSAFE_componentWillMount == "function" && R.UNSAFE_componentWillMount(), B !== R.state && Zi.enqueueReplaceState(R, R.state, null), Yl(u, v, R, O), Pu(), R.state = u.memoizedState), typeof R.componentDidMount == "function" && (u.flags |= 4194308), v = !0;
    } else if (l === null) {
      R = u.stateNode;
      var re = u.memoizedProps, ve = Tu(m, re);
      R.props = ve;
      var He = R.context, Je = m.contextType;
      B = jo, typeof Je == "object" && Je !== null && (B = rt(Je));
      var nt = m.getDerivedStateFromProps;
      Je = typeof nt == "function" || typeof R.getSnapshotBeforeUpdate == "function", re = u.pendingProps !== re, Je || typeof R.UNSAFE_componentWillReceiveProps != "function" && typeof R.componentWillReceiveProps != "function" || (re || He !== B) && ty(
        u,
        R,
        v,
        B
      ), Ls = !1;
      var We = u.memoizedState;
      R.state = We, Yl(u, v, R, O), Pu(), He = u.memoizedState, re || We !== He || Ls ? (typeof nt == "function" && (Tc(
        u,
        m,
        nt,
        v
      ), He = u.memoizedState), (ve = Ls || Fv(
        u,
        m,
        ve,
        v,
        We,
        He,
        B
      )) ? (Je || typeof R.UNSAFE_componentWillMount != "function" && typeof R.componentWillMount != "function" || (typeof R.componentWillMount == "function" && R.componentWillMount(), typeof R.UNSAFE_componentWillMount == "function" && R.UNSAFE_componentWillMount()), typeof R.componentDidMount == "function" && (u.flags |= 4194308)) : (typeof R.componentDidMount == "function" && (u.flags |= 4194308), u.memoizedProps = v, u.memoizedState = He), R.props = v, R.state = He, R.context = B, v = ve) : (typeof R.componentDidMount == "function" && (u.flags |= 4194308), v = !1);
    } else {
      R = u.stateNode, Dp(l, u), B = u.memoizedProps, Je = Tu(m, B), R.props = Je, nt = u.pendingProps, We = R.context, He = m.contextType, ve = jo, typeof He == "object" && He !== null && (ve = rt(He)), re = m.getDerivedStateFromProps, (He = typeof re == "function" || typeof R.getSnapshotBeforeUpdate == "function") || typeof R.UNSAFE_componentWillReceiveProps != "function" && typeof R.componentWillReceiveProps != "function" || (B !== nt || We !== ve) && ty(
        u,
        R,
        v,
        ve
      ), Ls = !1, We = u.memoizedState, R.state = We, Yl(u, v, R, O), Pu();
      var Ge = u.memoizedState;
      B !== nt || We !== Ge || Ls || l !== null && l.dependencies !== null && gc(l.dependencies) ? (typeof re == "function" && (Tc(
        u,
        m,
        re,
        v
      ), Ge = u.memoizedState), (Je = Ls || Fv(
        u,
        m,
        Je,
        v,
        We,
        Ge,
        ve
      ) || l !== null && l.dependencies !== null && gc(l.dependencies)) ? (He || typeof R.UNSAFE_componentWillUpdate != "function" && typeof R.componentWillUpdate != "function" || (typeof R.componentWillUpdate == "function" && R.componentWillUpdate(v, Ge, ve), typeof R.UNSAFE_componentWillUpdate == "function" && R.UNSAFE_componentWillUpdate(
        v,
        Ge,
        ve
      )), typeof R.componentDidUpdate == "function" && (u.flags |= 4), typeof R.getSnapshotBeforeUpdate == "function" && (u.flags |= 1024)) : (typeof R.componentDidUpdate != "function" || B === l.memoizedProps && We === l.memoizedState || (u.flags |= 4), typeof R.getSnapshotBeforeUpdate != "function" || B === l.memoizedProps && We === l.memoizedState || (u.flags |= 1024), u.memoizedProps = v, u.memoizedState = Ge), R.props = v, R.state = Ge, R.context = ve, v = Je) : (typeof R.componentDidUpdate != "function" || B === l.memoizedProps && We === l.memoizedState || (u.flags |= 4), typeof R.getSnapshotBeforeUpdate != "function" || B === l.memoizedProps && We === l.memoizedState || (u.flags |= 1024), v = !1);
    }
    return R = v, xi(l, u), v = (u.flags & 128) !== 0, R || v ? (R = u.stateNode, m = v && typeof m.getDerivedStateFromError != "function" ? null : R.render(), u.flags |= 1, l !== null && v ? (u.child = xu(
      u,
      l.child,
      null,
      O
    ), u.child = xu(
      u,
      null,
      m,
      O
    )) : Wr(l, u, m, O), u.memoizedState = R.state, l = u.child) : l = Pi(
      l,
      u,
      O
    ), l;
  }
  function Pl(l, u, m, v) {
    return vu(), u.flags |= 256, Wr(l, u, m, v), u.child;
  }
  var _m = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
  };
  function Bm(l) {
    return { baseLanes: l, cachePool: bc() };
  }
  function Ei(l, u, m) {
    return l = l !== null ? l.childLanes & ~m : 0, u && (l |= Uo), l;
  }
  function Kv(l, u, m) {
    var v = u.pendingProps, O = !1, R = (u.flags & 128) !== 0, B;
    if ((B = R) || (B = l !== null && l.memoizedState === null ? !1 : (Br.current & 2) !== 0), B && (O = !0, u.flags &= -129), B = (u.flags & 32) !== 0, u.flags &= -33, l === null) {
      if (_n) {
        if (O ? Ql(u) : xl(), (l = $r) ? (l = Ly(
          l,
          $a
        ), l = l !== null && l.data !== "&" ? l : null, l !== null && (u.memoizedState = {
          dehydrated: l,
          treeContext: yl !== null ? { id: Zo, overflow: wl } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, m = fv(l), m.return = u, u.child = m, Ba = u, $r = null)) : l = null, l === null) throw Ji(u);
        return Lu(l) ? u.lanes = 32 : u.lanes = 536870912, null;
      }
      var re = v.children;
      return v = v.fallback, O ? (xl(), O = u.mode, re = Um(
        { mode: "hidden", children: re },
        O
      ), v = $s(
        v,
        O,
        m,
        null
      ), re.return = u, v.return = u, re.sibling = v, u.child = re, v = u.child, v.memoizedState = Bm(m), v.childLanes = Ei(
        l,
        B,
        m
      ), u.memoizedState = _m, Ru(null, v)) : (Ql(u), Nu(u, re));
    }
    var ve = l.memoizedState;
    if (ve !== null && (re = ve.dehydrated, re !== null)) {
      if (R)
        u.flags & 256 ? (Ql(u), u.flags &= -257, u = Rc(
          l,
          u,
          m
        )) : u.memoizedState !== null ? (xl(), u.child = l.child, u.flags |= 128, u = null) : (xl(), re = v.fallback, O = u.mode, v = Um(
          { mode: "visible", children: v.children },
          O
        ), re = $s(
          re,
          O,
          m,
          null
        ), re.flags |= 2, v.return = u, re.return = u, v.sibling = re, u.child = v, xu(
          u,
          l.child,
          null,
          m
        ), v = u.child, v.memoizedState = Bm(m), v.childLanes = Ei(
          l,
          B,
          m
        ), u.memoizedState = _m, u = Ru(null, v));
      else if (Ql(u), Lu(re)) {
        if (B = re.nextSibling && re.nextSibling.dataset, B) var He = B.dgst;
        B = He, v = Error(a(419)), v.stack = "", v.digest = B, Md({ value: v, source: null, stack: null }), u = Rc(
          l,
          u,
          m
        );
      } else if (wa || Ua(l, u, m, !1), B = (m & l.childLanes) !== 0, wa || B) {
        if (B = kr, B !== null && (v = gt(B, m), v !== 0 && v !== ve.retryLane))
          throw ve.retryLane = v, Ns(l, v), Xo(B, l, v), ng;
        nl(re) || wg(), u = Rc(
          l,
          u,
          m
        );
      } else
        nl(re) ? (u.flags |= 192, u.child = l.child, u = null) : (l = ve.treeContext, $r = Go(
          re.nextSibling
        ), Ba = u, _n = !0, Xl = null, $a = !1, l !== null && bm(u, l), u = Nu(
          u,
          v.children
        ), u.flags |= 4096);
      return u;
    }
    return O ? (xl(), re = v.fallback, O = u.mode, ve = l.child, He = ve.sibling, v = Ds(ve, {
      mode: "hidden",
      children: v.children
    }), v.subtreeFlags = ve.subtreeFlags & 65011712, He !== null ? re = Ds(
      He,
      re
    ) : (re = $s(
      re,
      O,
      m,
      null
    ), re.flags |= 2), re.return = u, v.return = u, v.sibling = re, u.child = v, Ru(null, v), v = u.child, re = l.child.memoizedState, re === null ? re = Bm(m) : (O = re.cachePool, O !== null ? (ve = ba._currentValue, O = O.parent !== ve ? { parent: ve, pool: ve } : O) : O = bc(), re = {
      baseLanes: re.baseLanes | m,
      cachePool: O
    }), v.memoizedState = re, v.childLanes = Ei(
      l,
      B,
      m
    ), u.memoizedState = _m, Ru(l.child, v)) : (Ql(u), m = l.child, l = m.sibling, m = Ds(m, {
      mode: "visible",
      children: v.children
    }), m.return = u, m.sibling = null, l !== null && (B = u.deletions, B === null ? (u.deletions = [l], u.flags |= 16) : B.push(l)), u.child = m, u.memoizedState = null, m);
  }
  function Nu(l, u) {
    return u = Um(
      { mode: "visible", children: u },
      l.mode
    ), u.return = l, l.child = u;
  }
  function Um(l, u) {
    return l = ca(22, l, null, u), l.lanes = 0, l;
  }
  function Rc(l, u, m) {
    return xu(u, l.child, null, m), l = Nu(
      u,
      u.pendingProps.children
    ), l.flags |= 2, u.memoizedState = null, l;
  }
  function Ac(l, u, m) {
    l.lanes |= u;
    var v = l.alternate;
    v !== null && (v.lanes |= u), Ap(l.return, u, m);
  }
  function ag(l, u, m, v, O, R) {
    var B = l.memoizedState;
    B === null ? l.memoizedState = {
      isBackwards: u,
      rendering: null,
      renderingStartTime: 0,
      last: v,
      tail: m,
      tailMode: O,
      treeForkCount: R
    } : (B.isBackwards = u, B.rendering = null, B.renderingStartTime = 0, B.last = v, B.tail = m, B.tailMode = O, B.treeForkCount = R);
  }
  function Yv(l, u, m) {
    var v = u.pendingProps, O = v.revealOrder, R = v.tail;
    v = v.children;
    var B = Br.current, re = (B & 2) !== 0;
    if (re ? (B = B & 1 | 2, u.flags |= 128) : B &= 1, ae(Br, B), Wr(l, u, v, m), v = _n ? va : 0, !re && l !== null && (l.flags & 128) !== 0)
      e: for (l = u.child; l !== null; ) {
        if (l.tag === 13)
          l.memoizedState !== null && Ac(l, m, u);
        else if (l.tag === 19)
          Ac(l, m, u);
        else if (l.child !== null) {
          l.child.return = l, l = l.child;
          continue;
        }
        if (l === u) break e;
        for (; l.sibling === null; ) {
          if (l.return === null || l.return === u)
            break e;
          l = l.return;
        }
        l.sibling.return = l.return, l = l.sibling;
      }
    switch (O) {
      case "forwards":
        for (m = u.child, O = null; m !== null; )
          l = m.alternate, l !== null && Dd(l) === null && (O = m), m = m.sibling;
        m = O, m === null ? (O = u.child, u.child = null) : (O = m.sibling, m.sibling = null), ag(
          u,
          !1,
          O,
          m,
          R,
          v
        );
        break;
      case "backwards":
      case "unstable_legacy-backwards":
        for (m = null, O = u.child, u.child = null; O !== null; ) {
          if (l = O.alternate, l !== null && Dd(l) === null) {
            u.child = O;
            break;
          }
          l = O.sibling, O.sibling = m, m = O, O = l;
        }
        ag(
          u,
          !0,
          m,
          null,
          R,
          v
        );
        break;
      case "together":
        ag(
          u,
          !1,
          null,
          null,
          void 0,
          v
        );
        break;
      default:
        u.memoizedState = null;
    }
    return u.child;
  }
  function Pi(l, u, m) {
    if (l !== null && (u.dependencies = l.dependencies), Tl |= u.lanes, (m & u.childLanes) === 0)
      if (l !== null) {
        if (Ua(
          l,
          u,
          m,
          !1
        ), (m & u.childLanes) === 0)
          return null;
      } else return null;
    if (l !== null && u.child !== l.child)
      throw Error(a(153));
    if (u.child !== null) {
      for (l = u.child, m = Ds(l, l.pendingProps), u.child = m, m.return = u; l.sibling !== null; )
        l = l.sibling, m = m.sibling = Ds(l, l.pendingProps), m.return = u;
      m.sibling = null;
    }
    return u.child;
  }
  function og(l, u) {
    return (l.lanes & u) !== 0 ? !0 : (l = l.dependencies, !!(l !== null && gc(l)));
  }
  function ig(l, u, m) {
    switch (u.tag) {
      case 3:
        De(u, u.stateNode.containerInfo), Lo(u, ba, l.memoizedState.cache), vu();
        break;
      case 27:
      case 5:
        ze(u);
        break;
      case 4:
        De(u, u.stateNode.containerInfo);
        break;
      case 10:
        Lo(
          u,
          u.type,
          u.memoizedProps.value
        );
        break;
      case 31:
        if (u.memoizedState !== null)
          return u.flags |= 128, Nd(u), null;
        break;
      case 13:
        var v = u.memoizedState;
        if (v !== null)
          return v.dehydrated !== null ? (Ql(u), u.flags |= 128, null) : (m & u.child.childLanes) !== 0 ? Kv(l, u, m) : (Ql(u), l = Pi(
            l,
            u,
            m
          ), l !== null ? l.sibling : null);
        Ql(u);
        break;
      case 19:
        var O = (l.flags & 128) !== 0;
        if (v = (m & u.childLanes) !== 0, v || (Ua(
          l,
          u,
          m,
          !1
        ), v = (m & u.childLanes) !== 0), O) {
          if (v)
            return Yv(
              l,
              u,
              m
            );
          u.flags |= 128;
        }
        if (O = u.memoizedState, O !== null && (O.rendering = null, O.tail = null, O.lastEffect = null), ae(Br, Br.current), v) break;
        return null;
      case 22:
        return u.lanes = 0, ny(
          l,
          u,
          m,
          u.pendingProps
        );
      case 24:
        Lo(u, ba, l.memoizedState.cache);
    }
    return Pi(l, u, m);
  }
  function Qv(l, u, m) {
    if (l !== null)
      if (l.memoizedProps !== u.pendingProps)
        wa = !0;
      else {
        if (!og(l, m) && (u.flags & 128) === 0)
          return wa = !1, ig(
            l,
            u,
            m
          );
        wa = (l.flags & 131072) !== 0;
      }
    else
      wa = !1, _n && (u.flags & 1048576) !== 0 && hv(u, va, u.index);
    switch (u.lanes = 0, u.tag) {
      case 16:
        e: {
          var v = u.pendingProps;
          if (l = wu(u.elementType), u.type = l, typeof l == "function")
            hc(l) ? (v = Tu(l, v), u.tag = 1, u = qv(
              null,
              u,
              l,
              v,
              m
            )) : (u.tag = 0, u = rg(
              null,
              u,
              l,
              v,
              m
            ));
          else {
            if (l != null) {
              var O = l.$$typeof;
              if (O === $) {
                u.tag = 11, u = Uv(
                  null,
                  u,
                  l,
                  v,
                  m
                );
                break e;
              } else if (O === L) {
                u.tag = 14, u = Xv(
                  null,
                  u,
                  l,
                  v,
                  m
                );
                break e;
              }
            }
            throw u = G(l) || l, Error(a(306, u, ""));
          }
        }
        return u;
      case 0:
        return rg(
          l,
          u,
          u.type,
          u.pendingProps,
          m
        );
      case 1:
        return v = u.type, O = Tu(
          v,
          u.pendingProps
        ), qv(
          l,
          u,
          v,
          O,
          m
        );
      case 3:
        e: {
          if (De(
            u,
            u.stateNode.containerInfo
          ), l === null) throw Error(a(387));
          v = u.pendingProps;
          var R = u.memoizedState;
          O = R.element, Dp(l, u), Yl(u, v, null, m);
          var B = u.memoizedState;
          if (v = B.cache, Lo(u, ba, v), v !== R.cache && Kl(
            u,
            [ba],
            m,
            !0
          ), Pu(), v = B.element, R.isDehydrated)
            if (R = {
              element: v,
              isDehydrated: !1,
              cache: B.cache
            }, u.updateQueue.baseState = R, u.memoizedState = R, u.flags & 256) {
              u = Pl(
                l,
                u,
                v,
                m
              );
              break e;
            } else if (v !== O) {
              O = bi(
                Error(a(424)),
                u
              ), Md(O), u = Pl(
                l,
                u,
                v,
                m
              );
              break e;
            } else {
              switch (l = u.stateNode.containerInfo, l.nodeType) {
                case 9:
                  l = l.body;
                  break;
                default:
                  l = l.nodeName === "HTML" ? l.ownerDocument.body : l;
              }
              for ($r = Go(l.firstChild), Ba = u, _n = !0, Xl = null, $a = !0, m = Sv(
                u,
                null,
                v,
                m
              ), u.child = m; m; )
                m.flags = m.flags & -3 | 4096, m = m.sibling;
            }
          else {
            if (vu(), v === O) {
              u = Pi(
                l,
                u,
                m
              );
              break e;
            }
            Wr(l, u, v, m);
          }
          u = u.child;
        }
        return u;
      case 26:
        return xi(l, u), l === null ? (m = uf(
          u.type,
          null,
          u.pendingProps,
          null
        )) ? u.memoizedState = m : _n || (m = u.type, l = u.pendingProps, v = Iu(
          be.current
        ).createElement(m), v[Gt] = u, v[Dt] = l, co(v, m, l), kt(v), u.stateNode = v) : u.memoizedState = uf(
          u.type,
          l.memoizedProps,
          u.pendingProps,
          l.memoizedState
        ), null;
      case 27:
        return ze(u), l === null && _n && (v = u.stateNode = lf(
          u.type,
          u.pendingProps,
          be.current
        ), Ba = u, $a = !0, O = $r, Al(u.type) ? (ch = O, $r = Go(v.firstChild)) : $r = O), Wr(
          l,
          u,
          u.pendingProps.children,
          m
        ), xi(l, u), l === null && (u.flags |= 4194304), u.child;
      case 5:
        return l === null && _n && ((O = v = $r) && (v = wC(
          v,
          u.type,
          u.pendingProps,
          $a
        ), v !== null ? (u.stateNode = v, Ba = u, $r = Go(v.firstChild), $a = !1, O = !0) : O = !1), O || Ji(u)), ze(u), O = u.type, R = u.pendingProps, B = l !== null ? l.memoizedProps : null, v = R.children, af(O, R) ? v = null : B !== null && af(O, B) && (u.flags |= 32), u.memoizedState !== null && (O = Am(
          l,
          u,
          gC,
          null,
          null,
          m
        ), mh._currentValue = O), xi(l, u), Wr(l, u, v, m), u.child;
      case 6:
        return l === null && _n && ((l = m = $r) && (m = Rn(
          m,
          u.pendingProps,
          $a
        ), m !== null ? (u.stateNode = m, Ba = u, $r = null, l = !0) : l = !1), l || Ji(u)), null;
      case 13:
        return Kv(l, u, m);
      case 4:
        return De(
          u,
          u.stateNode.containerInfo
        ), v = u.pendingProps, l === null ? u.child = xu(
          u,
          null,
          v,
          m
        ) : Wr(l, u, v, m), u.child;
      case 11:
        return Uv(
          l,
          u,
          u.type,
          u.pendingProps,
          m
        );
      case 7:
        return Wr(
          l,
          u,
          u.pendingProps,
          m
        ), u.child;
      case 8:
        return Wr(
          l,
          u,
          u.pendingProps.children,
          m
        ), u.child;
      case 12:
        return Wr(
          l,
          u,
          u.pendingProps.children,
          m
        ), u.child;
      case 10:
        return v = u.pendingProps, Lo(u, u.type, v.value), Wr(l, u, v.children, m), u.child;
      case 9:
        return O = u.type._context, v = u.pendingProps.children, sn(u), O = rt(O), v = v(O), u.flags |= 1, Wr(l, u, v, m), u.child;
      case 14:
        return Xv(
          l,
          u,
          u.type,
          u.pendingProps,
          m
        );
      case 15:
        return Gv(
          l,
          u,
          u.type,
          u.pendingProps,
          m
        );
      case 19:
        return Yv(l, u, m);
      case 31:
        return ry(l, u, m);
      case 22:
        return ny(
          l,
          u,
          m,
          u.pendingProps
        );
      case 24:
        return sn(u), v = rt(ba), l === null ? (O = Si(), O === null && (O = kr, R = Sm(), O.pooledCache = R, R.refCount++, R !== null && (O.pooledCacheLanes |= m), O = R), u.memoizedState = { parent: v, cache: O }, Om(u), Lo(u, ba, O)) : ((l.lanes & m) !== 0 && (Dp(l, u), Yl(u, null, null, m), Pu()), O = l.memoizedState, R = u.memoizedState, O.parent !== v ? (O = { parent: v, cache: v }, u.memoizedState = O, u.lanes === 0 && (u.memoizedState = u.updateQueue.baseState = O), Lo(u, ba, v)) : (v = R.cache, Lo(u, ba, v), v !== O.cache && Kl(
          u,
          [ba],
          m,
          !0
        ))), Wr(
          l,
          u,
          u.pendingProps.children,
          m
        ), u.child;
      case 29:
        throw u.pendingProps;
    }
    throw Error(a(156, u.tag));
  }
  function rs(l) {
    l.flags |= 4;
  }
  function Jv(l, u, m, v, O) {
    if ((u = (l.mode & 32) !== 0) && (u = !1), u) {
      if (l.flags |= 16777216, (O & 335544128) === O)
        if (l.stateNode.complete) l.flags |= 8192;
        else if (my()) l.flags |= 8192;
        else
          throw Su = wc, yc;
    } else l.flags &= -16777217;
  }
  function Zv(l, u) {
    if (u.type !== "stylesheet" || (u.state.loading & 4) !== 0)
      l.flags &= -16777217;
    else if (l.flags |= 16777216, !oi(u))
      if (my()) l.flags |= 8192;
      else
        throw Su = wc, yc;
  }
  function xo(l, u) {
    u !== null && (l.flags |= 4), l.flags & 16384 && (u = l.tag !== 22 ? jn() : 536870912, l.lanes |= u, ea |= u);
  }
  function Wd(l, u) {
    if (!_n)
      switch (l.tailMode) {
        case "hidden":
          u = l.tail;
          for (var m = null; u !== null; )
            u.alternate !== null && (m = u), u = u.sibling;
          m === null ? l.tail = null : m.sibling = null;
          break;
        case "collapsed":
          m = l.tail;
          for (var v = null; m !== null; )
            m.alternate !== null && (v = m), m = m.sibling;
          v === null ? u || l.tail === null ? l.tail = null : l.tail.sibling = null : v.sibling = null;
      }
  }
  function ln(l) {
    var u = l.alternate !== null && l.alternate.child === l.child, m = 0, v = 0;
    if (u)
      for (var O = l.child; O !== null; )
        m |= O.lanes | O.childLanes, v |= O.subtreeFlags & 65011712, v |= O.flags & 65011712, O.return = l, O = O.sibling;
    else
      for (O = l.child; O !== null; )
        m |= O.lanes | O.childLanes, v |= O.subtreeFlags, v |= O.flags, O.return = l, O = O.sibling;
    return l.subtreeFlags |= v, l.childLanes = m, u;
  }
  function ay(l, u, m) {
    var v = u.pendingProps;
    switch (Tp(u), u.tag) {
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return ln(u), null;
      case 1:
        return ln(u), null;
      case 3:
        return m = u.stateNode, v = null, l !== null && (v = l.memoizedState.cache), u.memoizedState.cache !== v && (u.flags |= 2048), Cl(ba), Me(), m.pendingContext && (m.context = m.pendingContext, m.pendingContext = null), (l === null || l.child === null) && (ql(u) ? rs(u) : l === null || l.memoizedState.isDehydrated && (u.flags & 256) === 0 || (u.flags |= 1024, pv())), ln(u), null;
      case 26:
        var O = u.type, R = u.memoizedState;
        return l === null ? (rs(u), R !== null ? (ln(u), Zv(u, R)) : (ln(u), Jv(
          u,
          O,
          null,
          v,
          m
        ))) : R ? R !== l.memoizedState ? (rs(u), ln(u), Zv(u, R)) : (ln(u), u.flags &= -16777217) : (l = l.memoizedProps, l !== v && rs(u), ln(u), Jv(
          u,
          O,
          l,
          v,
          m
        )), null;
      case 27:
        if (le(u), m = be.current, O = u.type, l !== null && u.stateNode != null)
          l.memoizedProps !== v && rs(u);
        else {
          if (!v) {
            if (u.stateNode === null)
              throw Error(a(166));
            return ln(u), null;
          }
          l = oe.current, ql(u) ? ym(u) : (l = lf(O, v, m), u.stateNode = l, rs(u));
        }
        return ln(u), null;
      case 5:
        if (le(u), O = u.type, l !== null && u.stateNode != null)
          l.memoizedProps !== v && rs(u);
        else {
          if (!v) {
            if (u.stateNode === null)
              throw Error(a(166));
            return ln(u), null;
          }
          if (R = oe.current, ql(u))
            ym(u);
          else {
            var B = Iu(
              be.current
            );
            switch (R) {
              case 1:
                R = B.createElementNS(
                  "http://www.w3.org/2000/svg",
                  O
                );
                break;
              case 2:
                R = B.createElementNS(
                  "http://www.w3.org/1998/Math/MathML",
                  O
                );
                break;
              default:
                switch (O) {
                  case "svg":
                    R = B.createElementNS(
                      "http://www.w3.org/2000/svg",
                      O
                    );
                    break;
                  case "math":
                    R = B.createElementNS(
                      "http://www.w3.org/1998/Math/MathML",
                      O
                    );
                    break;
                  case "script":
                    R = B.createElement("div"), R.innerHTML = "<script><\/script>", R = R.removeChild(
                      R.firstChild
                    );
                    break;
                  case "select":
                    R = typeof v.is == "string" ? B.createElement("select", {
                      is: v.is
                    }) : B.createElement("select"), v.multiple ? R.multiple = !0 : v.size && (R.size = v.size);
                    break;
                  default:
                    R = typeof v.is == "string" ? B.createElement(O, { is: v.is }) : B.createElement(O);
                }
            }
            R[Gt] = u, R[Dt] = v;
            e: for (B = u.child; B !== null; ) {
              if (B.tag === 5 || B.tag === 6)
                R.appendChild(B.stateNode);
              else if (B.tag !== 4 && B.tag !== 27 && B.child !== null) {
                B.child.return = B, B = B.child;
                continue;
              }
              if (B === u) break e;
              for (; B.sibling === null; ) {
                if (B.return === null || B.return === u)
                  break e;
                B = B.return;
              }
              B.sibling.return = B.return, B = B.sibling;
            }
            u.stateNode = R;
            e: switch (co(R, O, v), O) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                v = !!v.autoFocus;
                break e;
              case "img":
                v = !0;
                break e;
              default:
                v = !1;
            }
            v && rs(u);
          }
        }
        return ln(u), Jv(
          u,
          u.type,
          l === null ? null : l.memoizedProps,
          u.pendingProps,
          m
        ), null;
      case 6:
        if (l && u.stateNode != null)
          l.memoizedProps !== v && rs(u);
        else {
          if (typeof v != "string" && u.stateNode === null)
            throw Error(a(166));
          if (l = be.current, ql(u)) {
            if (l = u.stateNode, m = u.memoizedProps, v = null, O = Ba, O !== null)
              switch (O.tag) {
                case 27:
                case 5:
                  v = O.memoizedProps;
              }
            l[Gt] = u, l = !!(l.nodeValue === m || v !== null && v.suppressHydrationWarning === !0 || x2(l.nodeValue, m)), l || Ji(u, !0);
          } else
            l = Iu(l).createTextNode(
              v
            ), l[Gt] = u, u.stateNode = l;
        }
        return ln(u), null;
      case 31:
        if (m = u.memoizedState, l === null || l.memoizedState !== null) {
          if (v = ql(u), m !== null) {
            if (l === null) {
              if (!v) throw Error(a(318));
              if (l = u.memoizedState, l = l !== null ? l.dehydrated : null, !l) throw Error(a(557));
              l[Gt] = u;
            } else
              vu(), (u.flags & 128) === 0 && (u.memoizedState = null), u.flags |= 4;
            ln(u), l = !1;
          } else
            m = pv(), l !== null && l.memoizedState !== null && (l.memoizedState.hydrationErrors = m), l = !0;
          if (!l)
            return u.flags & 256 ? (Fo(u), u) : (Fo(u), null);
          if ((u.flags & 128) !== 0)
            throw Error(a(558));
        }
        return ln(u), null;
      case 13:
        if (v = u.memoizedState, l === null || l.memoizedState !== null && l.memoizedState.dehydrated !== null) {
          if (O = ql(u), v !== null && v.dehydrated !== null) {
            if (l === null) {
              if (!O) throw Error(a(318));
              if (O = u.memoizedState, O = O !== null ? O.dehydrated : null, !O) throw Error(a(317));
              O[Gt] = u;
            } else
              vu(), (u.flags & 128) === 0 && (u.memoizedState = null), u.flags |= 4;
            ln(u), O = !1;
          } else
            O = pv(), l !== null && l.memoizedState !== null && (l.memoizedState.hydrationErrors = O), O = !0;
          if (!O)
            return u.flags & 256 ? (Fo(u), u) : (Fo(u), null);
        }
        return Fo(u), (u.flags & 128) !== 0 ? (u.lanes = m, u) : (m = v !== null, l = l !== null && l.memoizedState !== null, m && (v = u.child, O = null, v.alternate !== null && v.alternate.memoizedState !== null && v.alternate.memoizedState.cachePool !== null && (O = v.alternate.memoizedState.cachePool.pool), R = null, v.memoizedState !== null && v.memoizedState.cachePool !== null && (R = v.memoizedState.cachePool.pool), R !== O && (v.flags |= 2048)), m !== l && m && (u.child.flags |= 8192), xo(u, u.updateQueue), ln(u), null);
      case 4:
        return Me(), l === null && rf(u.stateNode.containerInfo), ln(u), null;
      case 10:
        return Cl(u.type), ln(u), null;
      case 19:
        if (ne(Br), v = u.memoizedState, v === null) return ln(u), null;
        if (O = (u.flags & 128) !== 0, R = v.rendering, R === null)
          if (O) Wd(v, !1);
          else {
            if (jr !== 0 || l !== null && (l.flags & 128) !== 0)
              for (l = u.child; l !== null; ) {
                if (R = Dd(l), R !== null) {
                  for (u.flags |= 128, Wd(v, !1), l = R.updateQueue, u.updateQueue = l, xo(u, l), u.subtreeFlags = 0, l = m, m = u.child; m !== null; )
                    dv(m, l), m = m.sibling;
                  return ae(
                    Br,
                    Br.current & 1 | 2
                  ), _n && Qi(u, v.treeForkCount), u.child;
                }
                l = l.sibling;
              }
            v.tail !== null && Fe() > dr && (u.flags |= 128, O = !0, Wd(v, !1), u.lanes = 4194304);
          }
        else {
          if (!O)
            if (l = Dd(R), l !== null) {
              if (u.flags |= 128, O = !0, l = l.updateQueue, u.updateQueue = l, xo(u, l), Wd(v, !0), v.tail === null && v.tailMode === "hidden" && !R.alternate && !_n)
                return ln(u), null;
            } else
              2 * Fe() - v.renderingStartTime > dr && m !== 536870912 && (u.flags |= 128, O = !0, Wd(v, !1), u.lanes = 4194304);
          v.isBackwards ? (R.sibling = u.child, u.child = R) : (l = v.last, l !== null ? l.sibling = R : u.child = R, v.last = R);
        }
        return v.tail !== null ? (l = v.tail, v.rendering = l, v.tail = l.sibling, v.renderingStartTime = Fe(), l.sibling = null, m = Br.current, ae(
          Br,
          O ? m & 1 | 2 : m & 1
        ), _n && Qi(u, v.treeForkCount), l) : (ln(u), null);
      case 22:
      case 23:
        return Fo(u), Ad(), v = u.memoizedState !== null, l !== null ? l.memoizedState !== null !== v && (u.flags |= 8192) : v && (u.flags |= 8192), v ? (m & 536870912) !== 0 && (u.flags & 128) === 0 && (ln(u), u.subtreeFlags & 6 && (u.flags |= 8192)) : ln(u), m = u.updateQueue, m !== null && xo(u, m.retryQueue), m = null, l !== null && l.memoizedState !== null && l.memoizedState.cachePool !== null && (m = l.memoizedState.cachePool.pool), v = null, u.memoizedState !== null && u.memoizedState.cachePool !== null && (v = u.memoizedState.cachePool.pool), v !== m && (u.flags |= 2048), l !== null && ne(wi), null;
      case 24:
        return m = null, l !== null && (m = l.memoizedState.cache), u.memoizedState.cache !== m && (u.flags |= 2048), Cl(ba), ln(u), null;
      case 25:
        return null;
      case 30:
        return null;
    }
    throw Error(a(156, u.tag));
  }
  function oy(l, u) {
    switch (Tp(u), u.tag) {
      case 1:
        return l = u.flags, l & 65536 ? (u.flags = l & -65537 | 128, u) : null;
      case 3:
        return Cl(ba), Me(), l = u.flags, (l & 65536) !== 0 && (l & 128) === 0 ? (u.flags = l & -65537 | 128, u) : null;
      case 26:
      case 27:
      case 5:
        return le(u), null;
      case 31:
        if (u.memoizedState !== null) {
          if (Fo(u), u.alternate === null)
            throw Error(a(340));
          vu();
        }
        return l = u.flags, l & 65536 ? (u.flags = l & -65537 | 128, u) : null;
      case 13:
        if (Fo(u), l = u.memoizedState, l !== null && l.dehydrated !== null) {
          if (u.alternate === null)
            throw Error(a(340));
          vu();
        }
        return l = u.flags, l & 65536 ? (u.flags = l & -65537 | 128, u) : null;
      case 19:
        return ne(Br), null;
      case 4:
        return Me(), null;
      case 10:
        return Cl(u.type), null;
      case 22:
      case 23:
        return Fo(u), Ad(), l !== null && ne(wi), l = u.flags, l & 65536 ? (u.flags = l & -65537 | 128, u) : null;
      case 24:
        return Cl(ba), null;
      case 25:
        return null;
      default:
        return null;
    }
  }
  function iy(l, u) {
    switch (Tp(u), u.tag) {
      case 3:
        Cl(ba), Me();
        break;
      case 26:
      case 27:
      case 5:
        le(u);
        break;
      case 4:
        Me();
        break;
      case 31:
        u.memoizedState !== null && Fo(u);
        break;
      case 13:
        Fo(u);
        break;
      case 19:
        ne(Br);
        break;
      case 10:
        Cl(u.type);
        break;
      case 22:
      case 23:
        Fo(u), Ad(), l !== null && ne(wi);
        break;
      case 24:
        Cl(ba);
    }
  }
  function el(l, u) {
    try {
      var m = u.updateQueue, v = m !== null ? m.lastEffect : null;
      if (v !== null) {
        var O = v.next;
        m = O;
        do {
          if ((m.tag & l) === l) {
            v = void 0;
            var R = m.create, B = m.inst;
            v = R(), B.destroy = v;
          }
          m = m.next;
        } while (m !== O);
      }
    } catch (re) {
      yr(u, u.return, re);
    }
  }
  function ki(l, u, m) {
    try {
      var v = u.updateQueue, O = v !== null ? v.lastEffect : null;
      if (O !== null) {
        var R = O.next;
        v = R;
        do {
          if ((v.tag & l) === l) {
            var B = v.inst, re = B.destroy;
            if (re !== void 0) {
              B.destroy = void 0, O = u;
              var ve = m, He = re;
              try {
                He();
              } catch (Je) {
                yr(
                  O,
                  ve,
                  Je
                );
              }
            }
          }
          v = v.next;
        } while (v !== R);
      }
    } catch (Je) {
      yr(u, u.return, Je);
    }
  }
  function lg(l) {
    var u = l.updateQueue;
    if (u !== null) {
      var m = l.stateNode;
      try {
        ku(u, m);
      } catch (v) {
        yr(l, l.return, v);
      }
    }
  }
  function Du(l, u, m) {
    m.props = Tu(
      l.type,
      l.memoizedProps
    ), m.state = l.memoizedState;
    try {
      m.componentWillUnmount();
    } catch (v) {
      yr(l, u, v);
    }
  }
  function as(l, u) {
    try {
      var m = l.ref;
      if (m !== null) {
        switch (l.tag) {
          case 26:
          case 27:
          case 5:
            var v = l.stateNode;
            break;
          case 30:
            v = l.stateNode;
            break;
          default:
            v = l.stateNode;
        }
        typeof m == "function" ? l.refCleanup = m(v) : m.current = v;
      }
    } catch (O) {
      yr(l, u, O);
    }
  }
  function kl(l, u) {
    var m = l.ref, v = l.refCleanup;
    if (m !== null)
      if (typeof v == "function")
        try {
          v();
        } catch (O) {
          yr(l, u, O);
        } finally {
          l.refCleanup = null, l = l.alternate, l != null && (l.refCleanup = null);
        }
      else if (typeof m == "function")
        try {
          m(null);
        } catch (O) {
          yr(l, u, O);
        }
      else m.current = null;
  }
  function e2(l) {
    var u = l.type, m = l.memoizedProps, v = l.stateNode;
    try {
      e: switch (u) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          m.autoFocus && v.focus();
          break e;
        case "img":
          m.src ? v.src = m.src : m.srcSet && (v.srcset = m.srcSet);
      }
    } catch (O) {
      yr(l, l.return, O);
    }
  }
  function sg(l, u, m) {
    try {
      var v = l.stateNode;
      P2(v, l.type, m, u), v[Dt] = u;
    } catch (O) {
      yr(l, l.return, O);
    }
  }
  function t2(l) {
    return l.tag === 5 || l.tag === 3 || l.tag === 26 || l.tag === 27 && Al(l.type) || l.tag === 4;
  }
  function Vd(l) {
    e: for (; ; ) {
      for (; l.sibling === null; ) {
        if (l.return === null || t2(l.return)) return null;
        l = l.return;
      }
      for (l.sibling.return = l.return, l = l.sibling; l.tag !== 5 && l.tag !== 6 && l.tag !== 18; ) {
        if (l.tag === 27 && Al(l.type) || l.flags & 2 || l.child === null || l.tag === 4) continue e;
        l.child.return = l, l = l.child;
      }
      if (!(l.flags & 2)) return l.stateNode;
    }
  }
  function _d(l, u, m) {
    var v = l.tag;
    if (v === 5 || v === 6)
      l = l.stateNode, u ? (m.nodeType === 9 ? m.body : m.nodeName === "HTML" ? m.ownerDocument.body : m).insertBefore(l, u) : (u = m.nodeType === 9 ? m.body : m.nodeName === "HTML" ? m.ownerDocument.body : m, u.appendChild(l), m = m._reactRootContainer, m != null || u.onclick !== null || (u.onclick = Va));
    else if (v !== 4 && (v === 27 && Al(l.type) && (m = l.stateNode, u = null), l = l.child, l !== null))
      for (_d(l, u, m), l = l.sibling; l !== null; )
        _d(l, u, m), l = l.sibling;
  }
  function Bd(l, u, m) {
    var v = l.tag;
    if (v === 5 || v === 6)
      l = l.stateNode, u ? m.insertBefore(l, u) : m.appendChild(l);
    else if (v !== 4 && (v === 27 && Al(l.type) && (m = l.stateNode), l = l.child, l !== null))
      for (Bd(l, u, m), l = l.sibling; l !== null; )
        Bd(l, u, m), l = l.sibling;
  }
  function n2(l) {
    var u = l.stateNode, m = l.memoizedProps;
    try {
      for (var v = l.type, O = u.attributes; O.length; )
        u.removeAttributeNode(O[0]);
      co(u, v, m), u[Gt] = l, u[Dt] = m;
    } catch (R) {
      yr(l, l.return, R);
    }
  }
  var _s = !1, Oa = !1, ug = !1, r2 = typeof WeakSet == "function" ? WeakSet : Set, qa = null;
  function Ud(l, u) {
    if (l = l.containerInfo, Tg = Ia, l = hu(l), fm(l)) {
      if ("selectionStart" in l)
        var m = {
          start: l.selectionStart,
          end: l.selectionEnd
        };
      else
        e: {
          m = (m = l.ownerDocument) && m.defaultView || window;
          var v = m.getSelection && m.getSelection();
          if (v && v.rangeCount !== 0) {
            m = v.anchorNode;
            var O = v.anchorOffset, R = v.focusNode;
            v = v.focusOffset;
            try {
              m.nodeType, R.nodeType;
            } catch {
              m = null;
              break e;
            }
            var B = 0, re = -1, ve = -1, He = 0, Je = 0, nt = l, We = null;
            t: for (; ; ) {
              for (var Ge; nt !== m || O !== 0 && nt.nodeType !== 3 || (re = B + O), nt !== R || v !== 0 && nt.nodeType !== 3 || (ve = B + v), nt.nodeType === 3 && (B += nt.nodeValue.length), (Ge = nt.firstChild) !== null; )
                We = nt, nt = Ge;
              for (; ; ) {
                if (nt === l) break t;
                if (We === m && ++He === O && (re = B), We === R && ++Je === v && (ve = B), (Ge = nt.nextSibling) !== null) break;
                nt = We, We = nt.parentNode;
              }
              nt = Ge;
            }
            m = re === -1 || ve === -1 ? null : { start: re, end: ve };
          } else m = null;
        }
      m = m || { start: 0, end: 0 };
    } else m = null;
    for (Rg = { focusedElem: l, selectionRange: m }, Ia = !1, qa = u; qa !== null; )
      if (u = qa, l = u.child, (u.subtreeFlags & 1028) !== 0 && l !== null)
        l.return = u, qa = l;
      else
        for (; qa !== null; ) {
          switch (u = qa, R = u.alternate, l = u.flags, u.tag) {
            case 0:
              if ((l & 4) !== 0 && (l = u.updateQueue, l = l !== null ? l.events : null, l !== null))
                for (m = 0; m < l.length; m++)
                  O = l[m], O.ref.impl = O.nextImpl;
              break;
            case 11:
            case 15:
              break;
            case 1:
              if ((l & 1024) !== 0 && R !== null) {
                l = void 0, m = u, O = R.memoizedProps, R = R.memoizedState, v = m.stateNode;
                try {
                  var At = Tu(
                    m.type,
                    O
                  );
                  l = v.getSnapshotBeforeUpdate(
                    At,
                    R
                  ), v.__reactInternalSnapshotBeforeUpdate = l;
                } catch (Zt) {
                  yr(
                    m,
                    m.return,
                    Zt
                  );
                }
              }
              break;
            case 3:
              if ((l & 1024) !== 0) {
                if (l = u.stateNode.containerInfo, m = l.nodeType, m === 9)
                  uh(l);
                else if (m === 1)
                  switch (l.nodeName) {
                    case "HEAD":
                    case "HTML":
                    case "BODY":
                      uh(l);
                      break;
                    default:
                      l.textContent = "";
                  }
              }
              break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
              break;
            default:
              if ((l & 1024) !== 0) throw Error(a(163));
          }
          if (l = u.sibling, l !== null) {
            l.return = u.return, qa = l;
            break;
          }
          qa = u.return;
        }
  }
  function Xm(l, u, m) {
    var v = m.flags;
    switch (m.tag) {
      case 0:
      case 11:
      case 15:
        Bs(l, m), v & 4 && el(5, m);
        break;
      case 1:
        if (Bs(l, m), v & 4)
          if (l = m.stateNode, u === null)
            try {
              l.componentDidMount();
            } catch (B) {
              yr(m, m.return, B);
            }
          else {
            var O = Tu(
              m.type,
              u.memoizedProps
            );
            u = u.memoizedState;
            try {
              l.componentDidUpdate(
                O,
                u,
                l.__reactInternalSnapshotBeforeUpdate
              );
            } catch (B) {
              yr(
                m,
                m.return,
                B
              );
            }
          }
        v & 64 && lg(m), v & 512 && as(m, m.return);
        break;
      case 3:
        if (Bs(l, m), v & 64 && (l = m.updateQueue, l !== null)) {
          if (u = null, m.child !== null)
            switch (m.child.tag) {
              case 27:
              case 5:
                u = m.child.stateNode;
                break;
              case 1:
                u = m.child.stateNode;
            }
          try {
            ku(l, u);
          } catch (B) {
            yr(m, m.return, B);
          }
        }
        break;
      case 27:
        u === null && v & 4 && n2(m);
      case 26:
      case 5:
        Bs(l, m), u === null && v & 4 && e2(m), v & 512 && as(m, m.return);
        break;
      case 12:
        Bs(l, m);
        break;
      case 31:
        Bs(l, m), v & 4 && ly(l, m);
        break;
      case 13:
        Bs(l, m), v & 4 && i2(l, m), v & 64 && (l = m.memoizedState, l !== null && (l = l.dehydrated, l !== null && (m = Mi.bind(
          null,
          m
        ), of(l, m))));
        break;
      case 22:
        if (v = m.memoizedState !== null || _s, !v) {
          u = u !== null && u.memoizedState !== null || Oa, O = _s;
          var R = Oa;
          _s = v, (Oa = u) && !R ? Ml(
            l,
            m,
            (m.subtreeFlags & 8772) !== 0
          ) : Bs(l, m), _s = O, Oa = R;
        }
        break;
      case 30:
        break;
      default:
        Bs(l, m);
    }
  }
  function a2(l) {
    var u = l.alternate;
    u !== null && (l.alternate = null, a2(u)), l.child = null, l.deletions = null, l.sibling = null, l.tag === 5 && (u = l.stateNode, u !== null && Rr(u)), l.stateNode = null, l.return = null, l.dependencies = null, l.memoizedProps = null, l.memoizedState = null, l.pendingProps = null, l.stateNode = null, l.updateQueue = null;
  }
  var zr = null, _o = !1;
  function os(l, u, m) {
    for (m = m.child; m !== null; )
      o2(l, u, m), m = m.sibling;
  }
  function o2(l, u, m) {
    if (ut && typeof ut.onCommitFiberUnmount == "function")
      try {
        ut.onCommitFiberUnmount(Ct, m);
      } catch {
      }
    switch (m.tag) {
      case 26:
        Oa || kl(m, u), os(
          l,
          u,
          m
        ), m.memoizedState ? m.memoizedState.count-- : m.stateNode && (m = m.stateNode, m.parentNode.removeChild(m));
        break;
      case 27:
        Oa || kl(m, u);
        var v = zr, O = _o;
        Al(m.type) && (zr = m.stateNode, _o = !1), os(
          l,
          u,
          m
        ), Hc(m.stateNode), zr = v, _o = O;
        break;
      case 5:
        Oa || kl(m, u);
      case 6:
        if (v = zr, O = _o, zr = null, os(
          l,
          u,
          m
        ), zr = v, _o = O, zr !== null)
          if (_o)
            try {
              (zr.nodeType === 9 ? zr.body : zr.nodeName === "HTML" ? zr.ownerDocument.body : zr).removeChild(m.stateNode);
            } catch (R) {
              yr(
                m,
                u,
                R
              );
            }
          else
            try {
              zr.removeChild(m.stateNode);
            } catch (R) {
              yr(
                m,
                u,
                R
              );
            }
        break;
      case 18:
        zr !== null && (_o ? (l = zr, T2(
          l.nodeType === 9 ? l.body : l.nodeName === "HTML" ? l.ownerDocument.body : l,
          m.stateNode
        ), vf(l)) : T2(zr, m.stateNode));
        break;
      case 4:
        v = zr, O = _o, zr = m.stateNode.containerInfo, _o = !0, os(
          l,
          u,
          m
        ), zr = v, _o = O;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        ki(2, m, u), Oa || ki(4, m, u), os(
          l,
          u,
          m
        );
        break;
      case 1:
        Oa || (kl(m, u), v = m.stateNode, typeof v.componentWillUnmount == "function" && Du(
          m,
          u,
          v
        )), os(
          l,
          u,
          m
        );
        break;
      case 21:
        os(
          l,
          u,
          m
        );
        break;
      case 22:
        Oa = (v = Oa) || m.memoizedState !== null, os(
          l,
          u,
          m
        ), Oa = v;
        break;
      default:
        os(
          l,
          u,
          m
        );
    }
  }
  function ly(l, u) {
    if (u.memoizedState === null && (l = u.alternate, l !== null && (l = l.memoizedState, l !== null))) {
      l = l.dehydrated;
      try {
        vf(l);
      } catch (m) {
        yr(u, u.return, m);
      }
    }
  }
  function i2(l, u) {
    if (u.memoizedState === null && (l = u.alternate, l !== null && (l = l.memoizedState, l !== null && (l = l.dehydrated, l !== null))))
      try {
        vf(l);
      } catch (m) {
        yr(u, u.return, m);
      }
  }
  function Gm(l) {
    switch (l.tag) {
      case 31:
      case 13:
      case 19:
        var u = l.stateNode;
        return u === null && (u = l.stateNode = new r2()), u;
      case 22:
        return l = l.stateNode, u = l._retryCache, u === null && (u = l._retryCache = new r2()), u;
      default:
        throw Error(a(435, l.tag));
    }
  }
  function qm(l, u) {
    var m = Gm(l);
    u.forEach(function(v) {
      if (!m.has(v)) {
        m.add(v);
        var O = Oy.bind(null, l, v);
        v.then(O, O);
      }
    });
  }
  function Bo(l, u) {
    var m = u.deletions;
    if (m !== null)
      for (var v = 0; v < m.length; v++) {
        var O = m[v], R = l, B = u, re = B;
        e: for (; re !== null; ) {
          switch (re.tag) {
            case 27:
              if (Al(re.type)) {
                zr = re.stateNode, _o = !1;
                break e;
              }
              break;
            case 5:
              zr = re.stateNode, _o = !1;
              break e;
            case 3:
            case 4:
              zr = re.stateNode.containerInfo, _o = !0;
              break e;
          }
          re = re.return;
        }
        if (zr === null) throw Error(a(160));
        o2(R, B, O), zr = null, _o = !1, R = O.alternate, R !== null && (R.return = null), O.return = null;
      }
    if (u.subtreeFlags & 13886)
      for (u = u.child; u !== null; )
        cg(u, l), u = u.sibling;
  }
  var En = null;
  function cg(l, u) {
    var m = l.alternate, v = l.flags;
    switch (l.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        Bo(u, l), ei(l), v & 4 && (ki(3, l, l.return), el(3, l), ki(5, l, l.return));
        break;
      case 1:
        Bo(u, l), ei(l), v & 512 && (Oa || m === null || kl(m, m.return)), v & 64 && _s && (l = l.updateQueue, l !== null && (v = l.callbacks, v !== null && (m = l.shared.hiddenCallbacks, l.shared.hiddenCallbacks = m === null ? v : m.concat(v))));
        break;
      case 26:
        var O = En;
        if (Bo(u, l), ei(l), v & 512 && (Oa || m === null || kl(m, m.return)), v & 4) {
          var R = m !== null ? m.memoizedState : null;
          if (v = l.memoizedState, m === null)
            if (v === null)
              if (l.stateNode === null) {
                e: {
                  v = l.type, m = l.memoizedProps, O = O.ownerDocument || O;
                  t: switch (v) {
                    case "title":
                      R = O.getElementsByTagName("title")[0], (!R || R[qn] || R[Gt] || R.namespaceURI === "http://www.w3.org/2000/svg" || R.hasAttribute("itemprop")) && (R = O.createElement(v), O.head.insertBefore(
                        R,
                        O.querySelector("head > title")
                      )), co(R, v, m), R[Gt] = l, kt(R), v = R;
                      break e;
                    case "link":
                      var B = D2(
                        "link",
                        "href",
                        O
                      ).get(v + (m.href || ""));
                      if (B) {
                        for (var re = 0; re < B.length; re++)
                          if (R = B[re], R.getAttribute("href") === (m.href == null || m.href === "" ? null : m.href) && R.getAttribute("rel") === (m.rel == null ? null : m.rel) && R.getAttribute("title") === (m.title == null ? null : m.title) && R.getAttribute("crossorigin") === (m.crossOrigin == null ? null : m.crossOrigin)) {
                            B.splice(re, 1);
                            break t;
                          }
                      }
                      R = O.createElement(v), co(R, v, m), O.head.appendChild(R);
                      break;
                    case "meta":
                      if (B = D2(
                        "meta",
                        "content",
                        O
                      ).get(v + (m.content || ""))) {
                        for (re = 0; re < B.length; re++)
                          if (R = B[re], R.getAttribute("content") === (m.content == null ? null : "" + m.content) && R.getAttribute("name") === (m.name == null ? null : m.name) && R.getAttribute("property") === (m.property == null ? null : m.property) && R.getAttribute("http-equiv") === (m.httpEquiv == null ? null : m.httpEquiv) && R.getAttribute("charset") === (m.charSet == null ? null : m.charSet)) {
                            B.splice(re, 1);
                            break t;
                          }
                      }
                      R = O.createElement(v), co(R, v, m), O.head.appendChild(R);
                      break;
                    default:
                      throw Error(a(468, v));
                  }
                  R[Gt] = l, kt(R), v = R;
                }
                l.stateNode = v;
              } else
                zg(
                  O,
                  l.type,
                  l.stateNode
                );
            else
              l.stateNode = N2(
                O,
                v,
                l.memoizedProps
              );
          else
            R !== v ? (R === null ? m.stateNode !== null && (m = m.stateNode, m.parentNode.removeChild(m)) : R.count--, v === null ? zg(
              O,
              l.type,
              l.stateNode
            ) : N2(
              O,
              v,
              l.memoizedProps
            )) : v === null && l.stateNode !== null && sg(
              l,
              l.memoizedProps,
              m.memoizedProps
            );
        }
        break;
      case 27:
        Bo(u, l), ei(l), v & 512 && (Oa || m === null || kl(m, m.return)), m !== null && v & 4 && sg(
          l,
          l.memoizedProps,
          m.memoizedProps
        );
        break;
      case 5:
        if (Bo(u, l), ei(l), v & 512 && (Oa || m === null || kl(m, m.return)), l.flags & 32) {
          O = l.stateNode;
          try {
            ka(O, "");
          } catch (At) {
            yr(l, l.return, At);
          }
        }
        v & 4 && l.stateNode != null && (O = l.memoizedProps, sg(
          l,
          O,
          m !== null ? m.memoizedProps : O
        )), v & 1024 && (ug = !0);
        break;
      case 6:
        if (Bo(u, l), ei(l), v & 4) {
          if (l.stateNode === null)
            throw Error(a(162));
          v = l.memoizedProps, m = l.stateNode;
          try {
            m.nodeValue = v;
          } catch (At) {
            yr(l, l.return, At);
          }
        }
        break;
      case 3:
        if (ff = null, O = En, En = Eo(u.containerInfo), Bo(u, l), En = O, ei(l), v & 4 && m !== null && m.memoizedState.isDehydrated)
          try {
            vf(u.containerInfo);
          } catch (At) {
            yr(l, l.return, At);
          }
        ug && (ug = !1, l2(l));
        break;
      case 4:
        v = En, En = Eo(
          l.stateNode.containerInfo
        ), Bo(u, l), ei(l), En = v;
        break;
      case 12:
        Bo(u, l), ei(l);
        break;
      case 31:
        Bo(u, l), ei(l), v & 4 && (v = l.updateQueue, v !== null && (l.updateQueue = null, qm(l, v)));
        break;
      case 13:
        Bo(u, l), ei(l), l.child.flags & 8192 && l.memoizedState !== null != (m !== null && m.memoizedState !== null) && (Rl = Fe()), v & 4 && (v = l.updateQueue, v !== null && (l.updateQueue = null, qm(l, v)));
        break;
      case 22:
        O = l.memoizedState !== null;
        var ve = m !== null && m.memoizedState !== null, He = _s, Je = Oa;
        if (_s = He || O, Oa = Je || ve, Bo(u, l), Oa = Je, _s = He, ei(l), v & 8192)
          e: for (u = l.stateNode, u._visibility = O ? u._visibility & -2 : u._visibility | 1, O && (m === null || ve || _s || Oa || Nc(l)), m = null, u = l; ; ) {
            if (u.tag === 5 || u.tag === 26) {
              if (m === null) {
                ve = m = u;
                try {
                  if (R = ve.stateNode, O)
                    B = R.style, typeof B.setProperty == "function" ? B.setProperty("display", "none", "important") : B.display = "none";
                  else {
                    re = ve.stateNode;
                    var nt = ve.memoizedProps.style, We = nt != null && nt.hasOwnProperty("display") ? nt.display : null;
                    re.style.display = We == null || typeof We == "boolean" ? "" : ("" + We).trim();
                  }
                } catch (At) {
                  yr(ve, ve.return, At);
                }
              }
            } else if (u.tag === 6) {
              if (m === null) {
                ve = u;
                try {
                  ve.stateNode.nodeValue = O ? "" : ve.memoizedProps;
                } catch (At) {
                  yr(ve, ve.return, At);
                }
              }
            } else if (u.tag === 18) {
              if (m === null) {
                ve = u;
                try {
                  var Ge = ve.stateNode;
                  O ? Sa(Ge, !0) : Sa(ve.stateNode, !1);
                } catch (At) {
                  yr(ve, ve.return, At);
                }
              }
            } else if ((u.tag !== 22 && u.tag !== 23 || u.memoizedState === null || u === l) && u.child !== null) {
              u.child.return = u, u = u.child;
              continue;
            }
            if (u === l) break e;
            for (; u.sibling === null; ) {
              if (u.return === null || u.return === l) break e;
              m === u && (m = null), u = u.return;
            }
            m === u && (m = null), u.sibling.return = u.return, u = u.sibling;
          }
        v & 4 && (v = l.updateQueue, v !== null && (m = v.retryQueue, m !== null && (v.retryQueue = null, qm(l, m))));
        break;
      case 19:
        Bo(u, l), ei(l), v & 4 && (v = l.updateQueue, v !== null && (l.updateQueue = null, qm(l, v)));
        break;
      case 30:
        break;
      case 21:
        break;
      default:
        Bo(u, l), ei(l);
    }
  }
  function ei(l) {
    var u = l.flags;
    if (u & 2) {
      try {
        for (var m, v = l.return; v !== null; ) {
          if (t2(v)) {
            m = v;
            break;
          }
          v = v.return;
        }
        if (m == null) throw Error(a(160));
        switch (m.tag) {
          case 27:
            var O = m.stateNode, R = Vd(l);
            Bd(l, R, O);
            break;
          case 5:
            var B = m.stateNode;
            m.flags & 32 && (ka(B, ""), m.flags &= -33);
            var re = Vd(l);
            Bd(l, re, B);
            break;
          case 3:
          case 4:
            var ve = m.stateNode.containerInfo, He = Vd(l);
            _d(
              l,
              He,
              ve
            );
            break;
          default:
            throw Error(a(161));
        }
      } catch (Je) {
        yr(l, l.return, Je);
      }
      l.flags &= -3;
    }
    u & 4096 && (l.flags &= -4097);
  }
  function l2(l) {
    if (l.subtreeFlags & 1024)
      for (l = l.child; l !== null; ) {
        var u = l;
        l2(u), u.tag === 5 && u.flags & 1024 && u.stateNode.reset(), l = l.sibling;
      }
  }
  function Bs(l, u) {
    if (u.subtreeFlags & 8772)
      for (u = u.child; u !== null; )
        Xm(l, u.alternate, u), u = u.sibling;
  }
  function Nc(l) {
    for (l = l.child; l !== null; ) {
      var u = l;
      switch (u.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          ki(4, u, u.return), Nc(u);
          break;
        case 1:
          kl(u, u.return);
          var m = u.stateNode;
          typeof m.componentWillUnmount == "function" && Du(
            u,
            u.return,
            m
          ), Nc(u);
          break;
        case 27:
          Hc(u.stateNode);
        case 26:
        case 5:
          kl(u, u.return), Nc(u);
          break;
        case 22:
          u.memoizedState === null && Nc(u);
          break;
        case 30:
          Nc(u);
          break;
        default:
          Nc(u);
      }
      l = l.sibling;
    }
  }
  function Ml(l, u, m) {
    for (m = m && (u.subtreeFlags & 8772) !== 0, u = u.child; u !== null; ) {
      var v = u.alternate, O = l, R = u, B = R.flags;
      switch (R.tag) {
        case 0:
        case 11:
        case 15:
          Ml(
            O,
            R,
            m
          ), el(4, R);
          break;
        case 1:
          if (Ml(
            O,
            R,
            m
          ), v = R, O = v.stateNode, typeof O.componentDidMount == "function")
            try {
              O.componentDidMount();
            } catch (He) {
              yr(v, v.return, He);
            }
          if (v = R, O = v.updateQueue, O !== null) {
            var re = v.stateNode;
            try {
              var ve = O.shared.hiddenCallbacks;
              if (ve !== null)
                for (O.shared.hiddenCallbacks = null, O = 0; O < ve.length; O++)
                  zp(ve[O], re);
            } catch (He) {
              yr(v, v.return, He);
            }
          }
          m && B & 64 && lg(R), as(R, R.return);
          break;
        case 27:
          n2(R);
        case 26:
        case 5:
          Ml(
            O,
            R,
            m
          ), m && v === null && B & 4 && e2(R), as(R, R.return);
          break;
        case 12:
          Ml(
            O,
            R,
            m
          );
          break;
        case 31:
          Ml(
            O,
            R,
            m
          ), m && B & 4 && ly(O, R);
          break;
        case 13:
          Ml(
            O,
            R,
            m
          ), m && B & 4 && i2(O, R);
          break;
        case 22:
          R.memoizedState === null && Ml(
            O,
            R,
            m
          ), as(R, R.return);
          break;
        case 30:
          break;
        default:
          Ml(
            O,
            R,
            m
          );
      }
      u = u.sibling;
    }
  }
  function dg(l, u) {
    var m = null;
    l !== null && l.memoizedState !== null && l.memoizedState.cachePool !== null && (m = l.memoizedState.cachePool.pool), l = null, u.memoizedState !== null && u.memoizedState.cachePool !== null && (l = u.memoizedState.cachePool.pool), l !== m && (l != null && l.refCount++, m != null && Cm(m));
  }
  function fg(l, u) {
    l = null, u.alternate !== null && (l = u.alternate.memoizedState.cache), u = u.memoizedState.cache, u !== l && (u.refCount++, l != null && Cm(l));
  }
  function tl(l, u, m, v) {
    if (u.subtreeFlags & 10256)
      for (u = u.child; u !== null; )
        Xd(
          l,
          u,
          m,
          v
        ), u = u.sibling;
  }
  function Xd(l, u, m, v) {
    var O = u.flags;
    switch (u.tag) {
      case 0:
      case 11:
      case 15:
        tl(
          l,
          u,
          m,
          v
        ), O & 2048 && el(9, u);
        break;
      case 1:
        tl(
          l,
          u,
          m,
          v
        );
        break;
      case 3:
        tl(
          l,
          u,
          m,
          v
        ), O & 2048 && (l = null, u.alternate !== null && (l = u.alternate.memoizedState.cache), u = u.memoizedState.cache, u !== l && (u.refCount++, l != null && Cm(l)));
        break;
      case 12:
        if (O & 2048) {
          tl(
            l,
            u,
            m,
            v
          ), l = u.stateNode;
          try {
            var R = u.memoizedProps, B = R.id, re = R.onPostCommit;
            typeof re == "function" && re(
              B,
              u.alternate === null ? "mount" : "update",
              l.passiveEffectDuration,
              -0
            );
          } catch (ve) {
            yr(u, u.return, ve);
          }
        } else
          tl(
            l,
            u,
            m,
            v
          );
        break;
      case 31:
        tl(
          l,
          u,
          m,
          v
        );
        break;
      case 13:
        tl(
          l,
          u,
          m,
          v
        );
        break;
      case 23:
        break;
      case 22:
        R = u.stateNode, B = u.alternate, u.memoizedState !== null ? R._visibility & 2 ? tl(
          l,
          u,
          m,
          v
        ) : Km(l, u) : R._visibility & 2 ? tl(
          l,
          u,
          m,
          v
        ) : (R._visibility |= 2, Gd(
          l,
          u,
          m,
          v,
          (u.subtreeFlags & 10256) !== 0 || !1
        )), O & 2048 && dg(B, u);
        break;
      case 24:
        tl(
          l,
          u,
          m,
          v
        ), O & 2048 && fg(u.alternate, u);
        break;
      default:
        tl(
          l,
          u,
          m,
          v
        );
    }
  }
  function Gd(l, u, m, v, O) {
    for (O = O && ((u.subtreeFlags & 10256) !== 0 || !1), u = u.child; u !== null; ) {
      var R = l, B = u, re = m, ve = v, He = B.flags;
      switch (B.tag) {
        case 0:
        case 11:
        case 15:
          Gd(
            R,
            B,
            re,
            ve,
            O
          ), el(8, B);
          break;
        case 23:
          break;
        case 22:
          var Je = B.stateNode;
          B.memoizedState !== null ? Je._visibility & 2 ? Gd(
            R,
            B,
            re,
            ve,
            O
          ) : Km(
            R,
            B
          ) : (Je._visibility |= 2, Gd(
            R,
            B,
            re,
            ve,
            O
          )), O && He & 2048 && dg(
            B.alternate,
            B
          );
          break;
        case 24:
          Gd(
            R,
            B,
            re,
            ve,
            O
          ), O && He & 2048 && fg(B.alternate, B);
          break;
        default:
          Gd(
            R,
            B,
            re,
            ve,
            O
          );
      }
      u = u.sibling;
    }
  }
  function Km(l, u) {
    if (u.subtreeFlags & 10256)
      for (u = u.child; u !== null; ) {
        var m = l, v = u, O = v.flags;
        switch (v.tag) {
          case 22:
            Km(m, v), O & 2048 && dg(
              v.alternate,
              v
            );
            break;
          case 24:
            Km(m, v), O & 2048 && fg(v.alternate, v);
            break;
          default:
            Km(m, v);
        }
        u = u.sibling;
      }
  }
  var ti = 8192;
  function is(l, u, m) {
    if (l.subtreeFlags & ti)
      for (l = l.child; l !== null; )
        sy(
          l,
          u,
          m
        ), l = l.sibling;
  }
  function sy(l, u, m) {
    switch (l.tag) {
      case 26:
        is(
          l,
          u,
          m
        ), l.flags & ti && l.memoizedState !== null && ds(
          m,
          En,
          l.memoizedState,
          l.memoizedProps
        );
        break;
      case 5:
        is(
          l,
          u,
          m
        );
        break;
      case 3:
      case 4:
        var v = En;
        En = Eo(l.stateNode.containerInfo), is(
          l,
          u,
          m
        ), En = v;
        break;
      case 22:
        l.memoizedState === null && (v = l.alternate, v !== null && v.memoizedState !== null ? (v = ti, ti = 16777216, is(
          l,
          u,
          m
        ), ti = v) : is(
          l,
          u,
          m
        ));
        break;
      default:
        is(
          l,
          u,
          m
        );
    }
  }
  function mg(l) {
    var u = l.alternate;
    if (u !== null && (l = u.child, l !== null)) {
      u.child = null;
      do
        u = l.sibling, l.sibling = null, l = u;
      while (l !== null);
    }
  }
  function qd(l) {
    var u = l.deletions;
    if ((l.flags & 16) !== 0) {
      if (u !== null)
        for (var m = 0; m < u.length; m++) {
          var v = u[m];
          qa = v, hg(
            v,
            l
          );
        }
      mg(l);
    }
    if (l.subtreeFlags & 10256)
      for (l = l.child; l !== null; )
        s2(l), l = l.sibling;
  }
  function s2(l) {
    switch (l.tag) {
      case 0:
      case 11:
      case 15:
        qd(l), l.flags & 2048 && ki(9, l, l.return);
        break;
      case 3:
        qd(l);
        break;
      case 12:
        qd(l);
        break;
      case 22:
        var u = l.stateNode;
        l.memoizedState !== null && u._visibility & 2 && (l.return === null || l.return.tag !== 13) ? (u._visibility &= -3, Ym(l)) : qd(l);
        break;
      default:
        qd(l);
    }
  }
  function Ym(l) {
    var u = l.deletions;
    if ((l.flags & 16) !== 0) {
      if (u !== null)
        for (var m = 0; m < u.length; m++) {
          var v = u[m];
          qa = v, hg(
            v,
            l
          );
        }
      mg(l);
    }
    for (l = l.child; l !== null; ) {
      switch (u = l, u.tag) {
        case 0:
        case 11:
        case 15:
          ki(8, u, u.return), Ym(u);
          break;
        case 22:
          m = u.stateNode, m._visibility & 2 && (m._visibility &= -3, Ym(u));
          break;
        default:
          Ym(u);
      }
      l = l.sibling;
    }
  }
  function hg(l, u) {
    for (; qa !== null; ) {
      var m = qa;
      switch (m.tag) {
        case 0:
        case 11:
        case 15:
          ki(8, m, u);
          break;
        case 23:
        case 22:
          if (m.memoizedState !== null && m.memoizedState.cachePool !== null) {
            var v = m.memoizedState.cachePool.pool;
            v != null && v.refCount++;
          }
          break;
        case 24:
          Cm(m.memoizedState.cache);
      }
      if (v = m.child, v !== null) v.return = m, qa = v;
      else
        e: for (m = l; qa !== null; ) {
          v = qa;
          var O = v.sibling, R = v.return;
          if (a2(v), v === m) {
            qa = null;
            break e;
          }
          if (O !== null) {
            O.return = R, qa = O;
            break e;
          }
          qa = R;
        }
    }
  }
  var uy = {
    getCacheForType: function(l) {
      var u = rt(ba), m = u.data.get(l);
      return m === void 0 && (m = l(), u.data.set(l, m)), m;
    },
    cacheSignal: function() {
      return rt(ba).controller.signal;
    }
  }, u2 = typeof WeakMap == "function" ? WeakMap : Map, ir = 0, kr = null, Bn = null, In = 0, br = 0, rn = null, ls = !1, $u = !1, pg = !1, Ol = 0, jr = 0, Tl = 0, Dc = 0, gg = 0, Uo = 0, ea = 0, Qm = null, ta = null, vg = !1, Rl = 0, c2 = 0, dr = 1 / 0, Kd = null, Ur = null, ja = 0, Us = null, zu = null, ss = 0, ni = 0, bg = null, yg = null, Yd = 0, Jm = null;
  function ri() {
    return (ir & 2) !== 0 && In !== 0 ? In & -In : H.T !== null ? Eg() : yn();
  }
  function cy() {
    if (Uo === 0)
      if ((In & 536870912) === 0 || _n) {
        var l = bt;
        bt <<= 1, (bt & 3932160) === 0 && (bt = 262144), Uo = l;
      } else Uo = 536870912;
    return l = Ho.current, l !== null && (l.flags |= 32), Uo;
  }
  function Xo(l, u, m) {
    (l === kr && (br === 2 || br === 9) || l.cancelPendingCommit !== null) && (us(l, 0), Xs(
      l,
      In,
      Uo,
      !1
    )), Ut(l, m), ((ir & 2) === 0 || l !== kr) && (l === kr && ((ir & 2) === 0 && (Dc |= m), jr === 4 && Xs(
      l,
      In,
      Uo,
      !1
    )), cs(l));
  }
  function dy(l, u, m) {
    if ((ir & 6) !== 0) throw Error(a(327));
    var v = !m && (u & 127) === 0 && (u & l.expiredLanes) === 0 || hn(l, u), O = v ? gy(l, u) : Sg(l, u, !0), R = v;
    do {
      if (O === 0) {
        $u && !v && Xs(l, u, 0, !1);
        break;
      } else {
        if (m = l.current.alternate, R && !fy(m)) {
          O = Sg(l, u, !1), R = !1;
          continue;
        }
        if (O === 2) {
          if (R = u, l.errorRecoveryDisabledLanes & R)
            var B = 0;
          else
            B = l.pendingLanes & -536870913, B = B !== 0 ? B : B & 536870912 ? 536870912 : 0;
          if (B !== 0) {
            u = B;
            e: {
              var re = l;
              O = Qm;
              var ve = re.current.memoizedState.isDehydrated;
              if (ve && (us(re, B).flags |= 256), B = Sg(
                re,
                B,
                !1
              ), B !== 2) {
                if (pg && !ve) {
                  re.errorRecoveryDisabledLanes |= R, Dc |= R, O = 4;
                  break e;
                }
                R = ta, ta = O, R !== null && (ta === null ? ta = R : ta.push.apply(
                  ta,
                  R
                ));
              }
              O = B;
            }
            if (R = !1, O !== 2) continue;
          }
        }
        if (O === 1) {
          us(l, 0), Xs(l, u, 0, !0);
          break;
        }
        e: {
          switch (v = l, R = O, R) {
            case 0:
            case 1:
              throw Error(a(345));
            case 4:
              if ((u & 4194048) !== u) break;
            case 6:
              Xs(
                v,
                u,
                Uo,
                !ls
              );
              break e;
            case 2:
              ta = null;
              break;
            case 3:
            case 5:
              break;
            default:
              throw Error(a(329));
          }
          if ((u & 62914560) === u && (O = Rl + 300 - Fe(), 10 < O)) {
            if (Xs(
              v,
              u,
              Uo,
              !ls
            ), Pt(v, 0, !0) !== 0) break e;
            ss = u, v.timeoutHandle = sh(
              Zm.bind(
                null,
                v,
                m,
                ta,
                Kd,
                vg,
                u,
                Uo,
                Dc,
                ea,
                ls,
                R,
                "Throttled",
                -0,
                0
              ),
              O
            );
            break e;
          }
          Zm(
            v,
            m,
            ta,
            Kd,
            vg,
            u,
            Uo,
            Dc,
            ea,
            ls,
            R,
            null,
            -0,
            0
          );
        }
      }
      break;
    } while (!0);
    cs(l);
  }
  function Zm(l, u, m, v, O, R, B, re, ve, He, Je, nt, We, Ge) {
    if (l.timeoutHandle = -1, nt = u.subtreeFlags, nt & 8192 || (nt & 16785408) === 16785408) {
      nt = {
        stylesheets: null,
        count: 0,
        imgCount: 0,
        imgBytes: 0,
        suspenseyImages: [],
        waitingForImages: !0,
        waitingForViewTransition: !1,
        unsuspend: Va
      }, sy(
        u,
        R,
        nt
      );
      var At = (R & 62914560) === R ? Rl - Fe() : (R & 4194048) === R ? c2 - Fe() : 0;
      if (At = z2(
        nt,
        At
      ), At !== null) {
        ss = R, l.cancelPendingCommit = At(
          wy.bind(
            null,
            l,
            u,
            R,
            m,
            v,
            O,
            B,
            re,
            ve,
            Je,
            nt,
            null,
            We,
            Ge
          )
        ), Xs(l, R, B, !He);
        return;
      }
    }
    wy(
      l,
      u,
      R,
      m,
      v,
      O,
      B,
      re,
      ve
    );
  }
  function fy(l) {
    for (var u = l; ; ) {
      var m = u.tag;
      if ((m === 0 || m === 11 || m === 15) && u.flags & 16384 && (m = u.updateQueue, m !== null && (m = m.stores, m !== null)))
        for (var v = 0; v < m.length; v++) {
          var O = m[v], R = O.getSnapshot;
          O = O.value;
          try {
            if (!Co(R(), O)) return !1;
          } catch {
            return !1;
          }
        }
      if (m = u.child, u.subtreeFlags & 16384 && m !== null)
        m.return = u, u = m;
      else {
        if (u === l) break;
        for (; u.sibling === null; ) {
          if (u.return === null || u.return === l) return !0;
          u = u.return;
        }
        u.sibling.return = u.return, u = u.sibling;
      }
    }
    return !0;
  }
  function Xs(l, u, m, v) {
    u &= ~gg, u &= ~Dc, l.suspendedLanes |= u, l.pingedLanes &= ~u, v && (l.warmLanes |= u), v = l.expirationTimes;
    for (var O = u; 0 < O; ) {
      var R = 31 - ot(O), B = 1 << R;
      v[R] = -1, O &= ~B;
    }
    m !== 0 && wn(l, m, u);
  }
  function Qd() {
    return (ir & 6) === 0 ? (qs(0), !1) : !0;
  }
  function d2() {
    if (Bn !== null) {
      if (br === 0)
        var l = Bn.return;
      else
        l = Bn, Sl = zs = null, Nm(l), Cu = null, Sc = 0, l = Bn;
      for (; l !== null; )
        iy(l.alternate, l), l = l.return;
      Bn = null;
    }
  }
  function us(l, u) {
    var m = l.timeoutHandle;
    m !== -1 && (l.timeoutHandle = -1, jy(m)), m = l.cancelPendingCommit, m !== null && (l.cancelPendingCommit = null, m()), ss = 0, d2(), kr = l, Bn = m = Ds(l.current, null), In = u, br = 0, rn = null, ls = !1, $u = hn(l, u), pg = !1, ea = Uo = gg = Dc = Tl = jr = 0, ta = Qm = null, vg = !1, (u & 8) !== 0 && (u |= u & 32);
    var v = l.entangledLanes;
    if (v !== 0)
      for (l = l.entanglements, v &= u; 0 < v; ) {
        var O = 31 - ot(v), R = 1 << O;
        u |= l[O], v &= ~R;
      }
    return Ol = u, gi(), m;
  }
  function Jd(l, u) {
    Sn = null, H.H = Fm, u === yu || u === Td ? (u = wv(), br = 3) : u === yc ? (u = wv(), br = 4) : br = u === ng ? 8 : u !== null && typeof u == "object" && typeof u.then == "function" ? 6 : 1, rn = u, Bn === null && (jr = 1, Fd(
      l,
      bi(u, l.current)
    ));
  }
  function my() {
    var l = Ho.current;
    return l === null ? !0 : (In & 4194048) === In ? Hi === null : (In & 62914560) === In || (In & 536870912) !== 0 ? l === Hi : !1;
  }
  function hy() {
    var l = H.H;
    return H.H = Fm, l === null ? Fm : l;
  }
  function py() {
    var l = H.A;
    return H.A = uy, l;
  }
  function wg() {
    jr = 4, ls || (In & 4194048) !== In && Ho.current !== null || ($u = !0), (Tl & 134217727) === 0 && (Dc & 134217727) === 0 || kr === null || Xs(
      kr,
      In,
      Uo,
      !1
    );
  }
  function Sg(l, u, m) {
    var v = ir;
    ir |= 2;
    var O = hy(), R = py();
    (kr !== l || In !== u) && (Kd = null, us(l, u)), u = !1;
    var B = jr;
    e: do
      try {
        if (br !== 0 && Bn !== null) {
          var re = Bn, ve = rn;
          switch (br) {
            case 8:
              d2(), B = 6;
              break e;
            case 3:
            case 2:
            case 9:
            case 6:
              Ho.current === null && (u = !0);
              var He = br;
              if (br = 0, rn = null, $c(l, re, ve, He), m && $u) {
                B = 0;
                break e;
              }
              break;
            default:
              He = br, br = 0, rn = null, $c(l, re, ve, He);
          }
        }
        bC(), B = jr;
        break;
      } catch (Je) {
        Jd(l, Je);
      }
    while (!0);
    return u && l.shellSuspendCounter++, Sl = zs = null, ir = v, H.H = O, H.A = R, Bn === null && (kr = null, In = 0, gi()), B;
  }
  function bC() {
    for (; Bn !== null; ) vy(Bn);
  }
  function gy(l, u) {
    var m = ir;
    ir |= 2;
    var v = hy(), O = py();
    kr !== l || In !== u ? (Kd = null, dr = Fe() + 500, us(l, u)) : $u = hn(
      l,
      u
    );
    e: do
      try {
        if (br !== 0 && Bn !== null) {
          u = Bn;
          var R = rn;
          t: switch (br) {
            case 1:
              br = 0, rn = null, $c(l, u, R, 1);
              break;
            case 2:
            case 9:
              if (bv(R)) {
                br = 0, rn = null, by(u);
                break;
              }
              u = function() {
                br !== 2 && br !== 9 || kr !== l || (br = 7), cs(l);
              }, R.then(u, u);
              break e;
            case 3:
              br = 7;
              break e;
            case 4:
              br = 5;
              break e;
            case 7:
              bv(R) ? (br = 0, rn = null, by(u)) : (br = 0, rn = null, $c(l, u, R, 7));
              break;
            case 5:
              var B = null;
              switch (Bn.tag) {
                case 26:
                  B = Bn.memoizedState;
                case 5:
                case 27:
                  var re = Bn;
                  if (B ? oi(B) : re.stateNode.complete) {
                    br = 0, rn = null;
                    var ve = re.sibling;
                    if (ve !== null) Bn = ve;
                    else {
                      var He = re.return;
                      He !== null ? (Bn = He, eh(He)) : Bn = null;
                    }
                    break t;
                  }
              }
              br = 0, rn = null, $c(l, u, R, 5);
              break;
            case 6:
              br = 0, rn = null, $c(l, u, R, 6);
              break;
            case 8:
              d2(), jr = 6;
              break e;
            default:
              throw Error(a(462));
          }
        }
        ju();
        break;
      } catch (Je) {
        Jd(l, Je);
      }
    while (!0);
    return Sl = zs = null, H.H = v, H.A = O, ir = m, Bn !== null ? 0 : (kr = null, In = 0, gi(), jr);
  }
  function ju() {
    for (; Bn !== null && !je(); )
      vy(Bn);
  }
  function vy(l) {
    var u = Qv(l.alternate, l, Ol);
    l.memoizedProps = l.pendingProps, u === null ? eh(l) : Bn = u;
  }
  function by(l) {
    var u = l, m = u.alternate;
    switch (u.tag) {
      case 15:
      case 0:
        u = Au(
          m,
          u,
          u.pendingProps,
          u.type,
          void 0,
          In
        );
        break;
      case 11:
        u = Au(
          m,
          u,
          u.pendingProps,
          u.type.render,
          u.ref,
          In
        );
        break;
      case 5:
        Nm(u);
      default:
        iy(m, u), u = Bn = dv(u, Ol), u = Qv(m, u, Ol);
    }
    l.memoizedProps = l.pendingProps, u === null ? eh(l) : Bn = u;
  }
  function $c(l, u, m, v) {
    Sl = zs = null, Nm(u), Cu = null, Sc = 0;
    var O = u.return;
    try {
      if (vC(
        l,
        O,
        u,
        m,
        In
      )) {
        jr = 1, Fd(
          l,
          bi(m, l.current)
        ), Bn = null;
        return;
      }
    } catch (R) {
      if (O !== null) throw Bn = O, R;
      jr = 1, Fd(
        l,
        bi(m, l.current)
      ), Bn = null;
      return;
    }
    u.flags & 32768 ? (_n || v === 1 ? l = !0 : $u || (In & 536870912) !== 0 ? l = !1 : (ls = l = !0, (v === 2 || v === 9 || v === 3 || v === 6) && (v = Ho.current, v !== null && v.tag === 13 && (v.flags |= 16384))), yy(u, l)) : eh(u);
  }
  function eh(l) {
    var u = l;
    do {
      if ((u.flags & 32768) !== 0) {
        yy(
          u,
          ls
        );
        return;
      }
      l = u.return;
      var m = ay(
        u.alternate,
        u,
        Ol
      );
      if (m !== null) {
        Bn = m;
        return;
      }
      if (u = u.sibling, u !== null) {
        Bn = u;
        return;
      }
      Bn = u = l;
    } while (u !== null);
    jr === 0 && (jr = 5);
  }
  function yy(l, u) {
    do {
      var m = oy(l.alternate, l);
      if (m !== null) {
        m.flags &= 32767, Bn = m;
        return;
      }
      if (m = l.return, m !== null && (m.flags |= 32768, m.subtreeFlags = 0, m.deletions = null), !u && (l = l.sibling, l !== null)) {
        Bn = l;
        return;
      }
      Bn = l = m;
    } while (l !== null);
    jr = 6, Bn = null;
  }
  function wy(l, u, m, v, O, R, B, re, ve) {
    l.cancelPendingCommit = null;
    do
      Zd();
    while (ja !== 0);
    if ((ir & 6) !== 0) throw Error(a(327));
    if (u !== null) {
      if (u === l.current) throw Error(a(177));
      if (R = u.lanes | u.childLanes, R |= Ki, pn(
        l,
        m,
        R,
        B,
        re,
        ve
      ), l === kr && (Bn = kr = null, In = 0), zu = u, Us = l, ss = m, ni = R, bg = O, yg = v, (u.subtreeFlags & 10256) !== 0 || (u.flags & 10256) !== 0 ? (l.callbackNode = null, l.callbackPriority = 0, Ty(mt, function() {
        return Py(), null;
      })) : (l.callbackNode = null, l.callbackPriority = 0), v = (u.flags & 13878) !== 0, (u.subtreeFlags & 13878) !== 0 || v) {
        v = H.T, H.T = null, O = K.p, K.p = 2, B = ir, ir |= 4;
        try {
          Ud(l, u, m);
        } finally {
          ir = B, K.p = O, H.T = v;
        }
      }
      ja = 1, Sy(), Cy(), xy();
    }
  }
  function Sy() {
    if (ja === 1) {
      ja = 0;
      var l = Us, u = zu, m = (u.flags & 13878) !== 0;
      if ((u.subtreeFlags & 13878) !== 0 || m) {
        m = H.T, H.T = null;
        var v = K.p;
        K.p = 2;
        var O = ir;
        ir |= 4;
        try {
          cg(u, l);
          var R = Rg, B = hu(l.containerInfo), re = R.focusedElem, ve = R.selectionRange;
          if (B !== re && re && re.ownerDocument && dc(
            re.ownerDocument.documentElement,
            re
          )) {
            if (ve !== null && fm(re)) {
              var He = ve.start, Je = ve.end;
              if (Je === void 0 && (Je = He), "selectionStart" in re)
                re.selectionStart = He, re.selectionEnd = Math.min(
                  Je,
                  re.value.length
                );
              else {
                var nt = re.ownerDocument || document, We = nt && nt.defaultView || window;
                if (We.getSelection) {
                  var Ge = We.getSelection(), At = re.textContent.length, Zt = Math.min(ve.start, At), Or = ve.end === void 0 ? Zt : Math.min(ve.end, At);
                  !Ge.extend && Zt > Or && (B = Or, Or = Zt, Zt = B);
                  var $e = uv(
                    re,
                    Zt
                  ), Pe = uv(
                    re,
                    Or
                  );
                  if ($e && Pe && (Ge.rangeCount !== 1 || Ge.anchorNode !== $e.node || Ge.anchorOffset !== $e.offset || Ge.focusNode !== Pe.node || Ge.focusOffset !== Pe.offset)) {
                    var Ie = nt.createRange();
                    Ie.setStart($e.node, $e.offset), Ge.removeAllRanges(), Zt > Or ? (Ge.addRange(Ie), Ge.extend(Pe.node, Pe.offset)) : (Ie.setEnd(Pe.node, Pe.offset), Ge.addRange(Ie));
                  }
                }
              }
            }
            for (nt = [], Ge = re; Ge = Ge.parentNode; )
              Ge.nodeType === 1 && nt.push({
                element: Ge,
                left: Ge.scrollLeft,
                top: Ge.scrollTop
              });
            for (typeof re.focus == "function" && re.focus(), re = 0; re < nt.length; re++) {
              var et = nt[re];
              et.element.scrollLeft = et.left, et.element.scrollTop = et.top;
            }
          }
          Ia = !!Tg, Rg = Tg = null;
        } finally {
          ir = O, K.p = v, H.T = m;
        }
      }
      l.current = u, ja = 2;
    }
  }
  function Cy() {
    if (ja === 2) {
      ja = 0;
      var l = Us, u = zu, m = (u.flags & 8772) !== 0;
      if ((u.subtreeFlags & 8772) !== 0 || m) {
        m = H.T, H.T = null;
        var v = K.p;
        K.p = 2;
        var O = ir;
        ir |= 4;
        try {
          Xm(l, u.alternate, u);
        } finally {
          ir = O, K.p = v, H.T = m;
        }
      }
      ja = 3;
    }
  }
  function xy() {
    if (ja === 4 || ja === 3) {
      ja = 0, Ue();
      var l = Us, u = zu, m = ss, v = yg;
      (u.subtreeFlags & 10256) !== 0 || (u.flags & 10256) !== 0 ? ja = 5 : (ja = 0, zu = Us = null, Ey(l, l.pendingLanes));
      var O = l.pendingLanes;
      if (O === 0 && (Ur = null), Ft(m), u = u.stateNode, ut && typeof ut.onCommitFiberRoot == "function")
        try {
          ut.onCommitFiberRoot(
            Ct,
            u,
            void 0,
            (u.current.flags & 128) === 128
          );
        } catch {
        }
      if (v !== null) {
        u = H.T, O = K.p, K.p = 2, H.T = null;
        try {
          for (var R = l.onRecoverableError, B = 0; B < v.length; B++) {
            var re = v[B];
            R(re.value, {
              componentStack: re.stack
            });
          }
        } finally {
          H.T = u, K.p = O;
        }
      }
      (ss & 3) !== 0 && Zd(), cs(l), O = l.pendingLanes, (m & 261930) !== 0 && (O & 42) !== 0 ? l === Jm ? Yd++ : (Yd = 0, Jm = l) : Yd = 0, qs(0);
    }
  }
  function Ey(l, u) {
    (l.pooledCacheLanes &= u) === 0 && (u = l.pooledCache, u != null && (l.pooledCache = null, Cm(u)));
  }
  function Zd() {
    return Sy(), Cy(), xy(), Py();
  }
  function Py() {
    if (ja !== 5) return !1;
    var l = Us, u = ni;
    ni = 0;
    var m = Ft(ss), v = H.T, O = K.p;
    try {
      K.p = 32 > m ? 32 : m, H.T = null, m = bg, bg = null;
      var R = Us, B = ss;
      if (ja = 0, zu = Us = null, ss = 0, (ir & 6) !== 0) throw Error(a(331));
      var re = ir;
      if (ir |= 4, s2(R.current), Xd(
        R,
        R.current,
        B,
        m
      ), ir = re, qs(0, !1), ut && typeof ut.onPostCommitFiberRoot == "function")
        try {
          ut.onPostCommitFiberRoot(Ct, R);
        } catch {
        }
      return !0;
    } finally {
      K.p = O, H.T = v, Ey(l, u);
    }
  }
  function ky(l, u, m) {
    u = bi(m, u), u = Vv(l.stateNode, u, 2), l = Ci(l, u, 2), l !== null && (Ut(l, 2), cs(l));
  }
  function yr(l, u, m) {
    if (l.tag === 3)
      ky(l, l, m);
    else
      for (; u !== null; ) {
        if (u.tag === 3) {
          ky(
            u,
            l,
            m
          );
          break;
        } else if (u.tag === 1) {
          var v = u.stateNode;
          if (typeof u.type.getDerivedStateFromError == "function" || typeof v.componentDidCatch == "function" && (Ur === null || !Ur.has(v))) {
            l = bi(m, l), m = _v(2), v = Ci(u, m, 2), v !== null && (Bv(
              m,
              v,
              u,
              l
            ), Ut(v, 2), cs(v));
            break;
          }
        }
        u = u.return;
      }
  }
  function th(l, u, m) {
    var v = l.pingCache;
    if (v === null) {
      v = l.pingCache = new u2();
      var O = /* @__PURE__ */ new Set();
      v.set(u, O);
    } else
      O = v.get(u), O === void 0 && (O = /* @__PURE__ */ new Set(), v.set(u, O));
    O.has(m) || (pg = !0, O.add(m), l = f2.bind(null, l, u, m), u.then(l, l));
  }
  function f2(l, u, m) {
    var v = l.pingCache;
    v !== null && v.delete(u), l.pingedLanes |= l.suspendedLanes & m, l.warmLanes &= ~m, kr === l && (In & m) === m && (jr === 4 || jr === 3 && (In & 62914560) === In && 300 > Fe() - Rl ? (ir & 2) === 0 && us(l, 0) : gg |= m, ea === In && (ea = 0)), cs(l);
  }
  function My(l, u) {
    u === 0 && (u = jn()), l = Ns(l, u), l !== null && (Ut(l, u), cs(l));
  }
  function Mi(l) {
    var u = l.memoizedState, m = 0;
    u !== null && (m = u.retryLane), My(l, m);
  }
  function Oy(l, u) {
    var m = 0;
    switch (l.tag) {
      case 31:
      case 13:
        var v = l.stateNode, O = l.memoizedState;
        O !== null && (m = O.retryLane);
        break;
      case 19:
        v = l.stateNode;
        break;
      case 22:
        v = l.stateNode._retryCache;
        break;
      default:
        throw Error(a(314));
    }
    v !== null && v.delete(u), My(l, m);
  }
  function Ty(l, u) {
    return Oe(l, u);
  }
  var ef = null, zc = null, m2 = !1, Cg = !1, h2 = !1, Gs = 0;
  function cs(l) {
    l !== zc && l.next === null && (zc === null ? ef = zc = l : zc = zc.next = l), Cg = !0, m2 || (m2 = !0, rh());
  }
  function qs(l, u) {
    if (!h2 && Cg) {
      h2 = !0;
      do
        for (var m = !1, v = ef; v !== null; ) {
          if (l !== 0) {
            var O = v.pendingLanes;
            if (O === 0) var R = 0;
            else {
              var B = v.suspendedLanes, re = v.pingedLanes;
              R = (1 << 31 - ot(42 | l) + 1) - 1, R &= O & ~(B & ~re), R = R & 201326741 ? R & 201326741 | 1 : R ? R | 2 : 0;
            }
            R !== 0 && (m = !0, jc(v, R));
          } else
            R = In, R = Pt(
              v,
              v === kr ? R : 0,
              v.cancelPendingCommit !== null || v.timeoutHandle !== -1
            ), (R & 3) === 0 || hn(v, R) || (m = !0, jc(v, R));
          v = v.next;
        }
      while (m);
      h2 = !1;
    }
  }
  function xg() {
    p2();
  }
  function p2() {
    Cg = m2 = !1;
    var l = 0;
    Gs !== 0 && yC() && (l = Gs);
    for (var u = Fe(), m = null, v = ef; v !== null; ) {
      var O = v.next, R = g2(v, u);
      R === 0 ? (v.next = null, m === null ? ef = O : m.next = O, O === null && (zc = m)) : (m = v, (l !== 0 || (R & 3) !== 0) && (Cg = !0)), v = O;
    }
    ja !== 0 && ja !== 5 || qs(l), Gs !== 0 && (Gs = 0);
  }
  function g2(l, u) {
    for (var m = l.suspendedLanes, v = l.pingedLanes, O = l.expirationTimes, R = l.pendingLanes & -62914561; 0 < R; ) {
      var B = 31 - ot(R), re = 1 << B, ve = O[B];
      ve === -1 ? ((re & m) === 0 || (re & v) !== 0) && (O[B] = an(re, u)) : ve <= u && (l.expiredLanes |= re), R &= ~re;
    }
    if (u = kr, m = In, m = Pt(
      l,
      l === u ? m : 0,
      l.cancelPendingCommit !== null || l.timeoutHandle !== -1
    ), v = l.callbackNode, m === 0 || l === u && (br === 2 || br === 9) || l.cancelPendingCommit !== null)
      return v !== null && v !== null && ye(v), l.callbackNode = null, l.callbackPriority = 0;
    if ((m & 3) === 0 || hn(l, m)) {
      if (u = m & -m, u === l.callbackPriority) return u;
      switch (v !== null && ye(v), Ft(m)) {
        case 2:
        case 8:
          m = St;
          break;
        case 32:
          m = mt;
          break;
        case 268435456:
          m = Rt;
          break;
        default:
          m = mt;
      }
      return v = nh.bind(null, l), m = Oe(m, v), l.callbackPriority = u, l.callbackNode = m, u;
    }
    return v !== null && v !== null && ye(v), l.callbackPriority = 2, l.callbackNode = null, 2;
  }
  function nh(l, u) {
    if (ja !== 0 && ja !== 5)
      return l.callbackNode = null, l.callbackPriority = 0, null;
    var m = l.callbackNode;
    if (Zd() && l.callbackNode !== m)
      return null;
    var v = In;
    return v = Pt(
      l,
      l === kr ? v : 0,
      l.cancelPendingCommit !== null || l.timeoutHandle !== -1
    ), v === 0 ? null : (dy(l, v, u), g2(l, Fe()), l.callbackNode != null && l.callbackNode === m ? nh.bind(null, l) : null);
  }
  function jc(l, u) {
    if (Zd()) return null;
    dy(l, u, !0);
  }
  function rh() {
    Iy(function() {
      (ir & 6) !== 0 ? Oe(
        dt,
        xg
      ) : p2();
    });
  }
  function Eg() {
    if (Gs === 0) {
      var l = bu;
      l === 0 && (l = pt, pt <<= 1, (pt & 261888) === 0 && (pt = 256)), Gs = l;
    }
    return Gs;
  }
  function Ry(l) {
    return l == null || typeof l == "symbol" || typeof l == "boolean" ? null : typeof l == "function" ? l : tr("" + l);
  }
  function Ic(l, u) {
    var m = u.ownerDocument.createElement("input");
    return m.name = u.name, m.value = u.value, l.id && m.setAttribute("form", l.id), u.parentNode.insertBefore(m, u), l = new FormData(l), m.parentNode.removeChild(m), l;
  }
  function ah(l, u, m, v, O) {
    if (u === "submit" && m && m.stateNode === O) {
      var R = Ry(
        (O[Dt] || null).action
      ), B = v.submitter;
      B && (u = (u = B[Dt] || null) ? Ry(u.formAction) : B.getAttribute("formAction"), u !== null && (R = u, B = null));
      var re = new um(
        "action",
        "action",
        null,
        v,
        O
      );
      l.push({
        event: re,
        listeners: [
          {
            instance: null,
            listener: function() {
              if (v.defaultPrevented) {
                if (Gs !== 0) {
                  var ve = B ? Ic(O, B) : new FormData(O);
                  Ld(
                    m,
                    {
                      pending: !0,
                      data: ve,
                      method: O.method,
                      action: R
                    },
                    null,
                    ve
                  );
                }
              } else
                typeof R == "function" && (re.preventDefault(), ve = B ? Ic(O, B) : new FormData(O), Ld(
                  m,
                  {
                    pending: !0,
                    data: ve,
                    method: O.method,
                    action: R
                  },
                  R,
                  ve
                ));
            },
            currentTarget: O
          }
        ]
      });
    }
  }
  for (var Pg = 0; Pg < xd.length; Pg++) {
    var tf = xd[Pg], v2 = tf.toLowerCase(), b2 = tf[0].toUpperCase() + tf.slice(1);
    zo(
      v2,
      "on" + b2
    );
  }
  zo(hm, "onAnimationEnd"), zo(cv, "onAnimationIteration"), zo(Pp, "onAnimationStart"), zo("dblclick", "onDoubleClick"), zo("focusin", "onFocus"), zo("focusout", "onBlur"), zo(fc, "onTransitionRun"), zo(pm, "onTransitionStart"), zo(Bl, "onTransitionCancel"), zo(Wb, "onTransitionEnd"), Hr("onMouseEnter", ["mouseout", "mouseover"]), Hr("onMouseLeave", ["mouseout", "mouseover"]), Hr("onPointerEnter", ["pointerout", "pointerover"]), Hr("onPointerLeave", ["pointerout", "pointerover"]), Nr(
    "onChange",
    "change click focusin focusout input keydown keyup selectionchange".split(" ")
  ), Nr(
    "onSelect",
    "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
      " "
    )
  ), Nr("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
  ]), Nr(
    "onCompositionEnd",
    "compositionend focusout keydown keypress keyup mousedown".split(" ")
  ), Nr(
    "onCompositionStart",
    "compositionstart focusout keydown keypress keyup mousedown".split(" ")
  ), Nr(
    "onCompositionUpdate",
    "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
  );
  var nf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
    " "
  ), Ay = new Set(
    "beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(nf)
  );
  function Ny(l, u) {
    u = (u & 4) !== 0;
    for (var m = 0; m < l.length; m++) {
      var v = l[m], O = v.event;
      v = v.listeners;
      e: {
        var R = void 0;
        if (u)
          for (var B = v.length - 1; 0 <= B; B--) {
            var re = v[B], ve = re.instance, He = re.currentTarget;
            if (re = re.listener, ve !== R && O.isPropagationStopped())
              break e;
            R = re, O.currentTarget = He;
            try {
              R(O);
            } catch (Je) {
              mc(Je);
            }
            O.currentTarget = null, R = ve;
          }
        else
          for (B = 0; B < v.length; B++) {
            if (re = v[B], ve = re.instance, He = re.currentTarget, re = re.listener, ve !== R && O.isPropagationStopped())
              break e;
            R = re, O.currentTarget = He;
            try {
              R(O);
            } catch (Je) {
              mc(Je);
            }
            O.currentTarget = null, R = ve;
          }
      }
    }
  }
  function Vn(l, u) {
    var m = u[Mn];
    m === void 0 && (m = u[Mn] = /* @__PURE__ */ new Set());
    var v = l + "__bubble";
    m.has(v) || (oh(u, l, 2, !1), m.add(v));
  }
  function y2(l, u, m) {
    var v = 0;
    u && (v |= 4), oh(
      m,
      l,
      v,
      u
    );
  }
  var kg = "_reactListening" + Math.random().toString(36).slice(2);
  function rf(l) {
    if (!l[kg]) {
      l[kg] = !0, Qn.forEach(function(m) {
        m !== "selectionchange" && (Ay.has(m) || y2(m, !1, l), y2(m, !0, l));
      });
      var u = l.nodeType === 9 ? l : l.ownerDocument;
      u === null || u[kg] || (u[kg] = !0, y2("selectionchange", !1, u));
    }
  }
  function oh(l, u, m, v) {
    switch (hh(u)) {
      case 2:
        var O = fs;
        break;
      case 8:
        O = ms;
        break;
      default:
        O = fo;
    }
    m = O.bind(
      null,
      u,
      m,
      l
    ), O = void 0, !ao || u !== "touchstart" && u !== "touchmove" && u !== "wheel" || (O = !0), v ? O !== void 0 ? l.addEventListener(u, m, {
      capture: !0,
      passive: O
    }) : l.addEventListener(u, m, !0) : O !== void 0 ? l.addEventListener(u, m, {
      passive: O
    }) : l.addEventListener(u, m, !1);
  }
  function w2(l, u, m, v, O) {
    var R = v;
    if ((u & 1) === 0 && (u & 2) === 0 && v !== null)
      e: for (; ; ) {
        if (v === null) return;
        var B = v.tag;
        if (B === 3 || B === 4) {
          var re = v.stateNode.containerInfo;
          if (re === O) break;
          if (B === 4)
            for (B = v.return; B !== null; ) {
              var ve = B.tag;
              if ((ve === 3 || ve === 4) && B.stateNode.containerInfo === O)
                return;
              B = B.return;
            }
          for (; re !== null; ) {
            if (B = Wt(re), B === null) return;
            if (ve = B.tag, ve === 5 || ve === 6 || ve === 26 || ve === 27) {
              v = R = B;
              continue e;
            }
            re = re.parentNode;
          }
        }
        v = v.return;
      }
    lm(function() {
      var He = R, Je = Li(m), nt = [];
      e: {
        var We = Ul.get(l);
        if (We !== void 0) {
          var Ge = um, At = l;
          switch (l) {
            case "keypress":
              if (cd(m) === 0) break e;
            case "keydown":
            case "keyup":
              Ge = bp;
              break;
            case "focusin":
              At = "focus", Ge = gp;
              break;
            case "focusout":
              At = "blur", Ge = gp;
              break;
            case "beforeblur":
            case "afterblur":
              Ge = gp;
              break;
            case "click":
              if (m.button === 2) break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              Ge = bd;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              Ge = Tb;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              Ge = $b;
              break;
            case hm:
            case cv:
            case Pp:
              Ge = Ab;
              break;
            case Wb:
              Ge = mC;
              break;
            case "scroll":
            case "scrollend":
              Ge = dC;
              break;
            case "wheel":
              Ge = hC;
              break;
            case "copy":
            case "cut":
            case "paste":
              Ge = oc;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              Ge = pl;
              break;
            case "toggle":
            case "beforetoggle":
              Ge = tv;
          }
          var Zt = (u & 4) !== 0, Or = !Zt && (l === "scroll" || l === "scrollend"), $e = Zt ? We !== null ? We + "Capture" : null : We;
          Zt = [];
          for (var Pe = He, Ie; Pe !== null; ) {
            var et = Pe;
            if (Ie = et.stateNode, et = et.tag, et !== 5 && et !== 26 && et !== 27 || Ie === null || $e === null || (et = Jt(Pe, $e), et != null && Zt.push(
              ih(Pe, et, Ie)
            )), Or) break;
            Pe = Pe.return;
          }
          0 < Zt.length && (We = new Ge(
            We,
            At,
            null,
            m,
            Je
          ), nt.push({ event: We, listeners: Zt }));
        }
      }
      if ((u & 7) === 0) {
        e: {
          if (We = l === "mouseover" || l === "pointerover", Ge = l === "mouseout" || l === "pointerout", We && m !== pi && (At = m.relatedTarget || m.fromElement) && (Wt(At) || At[Yt]))
            break e;
          if ((Ge || We) && (We = Je.window === Je ? Je : (We = Je.ownerDocument) ? We.defaultView || We.parentWindow : window, Ge ? (At = m.relatedTarget || m.toElement, Ge = He, At = At ? Wt(At) : null, At !== null && (Or = c(At), Zt = At.tag, At !== Or || Zt !== 5 && Zt !== 27 && Zt !== 6) && (At = null)) : (Ge = null, At = He), Ge !== At)) {
            if (Zt = bd, et = "onMouseLeave", $e = "onMouseEnter", Pe = "mouse", (l === "pointerout" || l === "pointerover") && (Zt = pl, et = "onPointerLeave", $e = "onPointerEnter", Pe = "pointer"), Or = Ge == null ? We : Xt(Ge), Ie = At == null ? We : Xt(At), We = new Zt(
              et,
              Pe + "leave",
              Ge,
              m,
              Je
            ), We.target = Or, We.relatedTarget = Ie, et = null, Wt(Je) === He && (Zt = new Zt(
              $e,
              Pe + "enter",
              At,
              m,
              Je
            ), Zt.target = Ie, Zt.relatedTarget = Or, et = Zt), Or = et, Ge && At)
              t: {
                for (Zt = Dy, $e = Ge, Pe = At, Ie = 0, et = $e; et; et = Zt(et))
                  Ie++;
                et = 0;
                for (var Vt = Pe; Vt; Vt = Zt(Vt))
                  et++;
                for (; 0 < Ie - et; )
                  $e = Zt($e), Ie--;
                for (; 0 < et - Ie; )
                  Pe = Zt(Pe), et--;
                for (; Ie--; ) {
                  if ($e === Pe || Pe !== null && $e === Pe.alternate) {
                    Zt = $e;
                    break t;
                  }
                  $e = Zt($e), Pe = Zt(Pe);
                }
                Zt = null;
              }
            else Zt = null;
            Ge !== null && Mg(
              nt,
              We,
              Ge,
              Zt,
              !1
            ), At !== null && Or !== null && Mg(
              nt,
              Or,
              At,
              Zt,
              !0
            );
          }
        }
        e: {
          if (We = He ? Xt(He) : window, Ge = We.nodeName && We.nodeName.toLowerCase(), Ge === "select" || Ge === "input" && We.type === "file")
            var rr = iv;
          else if (_l(We))
            if (Sp)
              rr = cc;
            else {
              rr = Hb;
              var jt = Lb;
            }
          else
            Ge = We.nodeName, !Ge || Ge.toLowerCase() !== "input" || We.type !== "checkbox" && We.type !== "radio" ? He && Kt(He.elementType) && (rr = iv) : rr = mu;
          if (rr && (rr = rr(l, He))) {
            ov(
              nt,
              rr,
              m,
              Je
            );
            break e;
          }
          jt && jt(l, We, He), l === "focusout" && He && We.type === "number" && He.memoizedProps.value != null && er(We, "number", We.value);
        }
        switch (jt = He ? Xt(He) : window, l) {
          case "focusin":
            (_l(jt) || jt.contentEditable === "true") && (pu = jt, Sd = He, qi = null);
            break;
          case "focusout":
            qi = Sd = pu = null;
            break;
          case "mousedown":
            vl = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            vl = !1, Ep(nt, m, Je);
            break;
          case "selectionchange":
            if (mm) break;
          case "keydown":
          case "keyup":
            Ep(nt, m, Je);
        }
        var vn;
        if (yd)
          e: {
            switch (l) {
              case "compositionstart":
                var Pn = "onCompositionStart";
                break e;
              case "compositionend":
                Pn = "onCompositionEnd";
                break e;
              case "compositionupdate":
                Pn = "onCompositionUpdate";
                break e;
            }
            Pn = void 0;
          }
        else
          lc ? wp(l, m) && (Pn = "onCompositionEnd") : l === "keydown" && m.keyCode === 229 && (Pn = "onCompositionStart");
        Pn && (nv && m.locale !== "ko" && (lc || Pn !== "onCompositionStart" ? Pn === "onCompositionEnd" && lc && (vn = Zh()) : (Ea = Je, Uf = "value" in Ea ? Ea.value : Ea.textContent, lc = !0)), jt = lh(He, Pn), 0 < jt.length && (Pn = new Nb(
          Pn,
          l,
          null,
          m,
          Je
        ), nt.push({ event: Pn, listeners: jt }), vn ? Pn.data = vn : (vn = rv(m), vn !== null && (Pn.data = vn)))), (vn = So ? Ib(l, m) : pC(l, m)) && (Pn = lh(He, "onBeforeInput"), 0 < Pn.length && (jt = new Nb(
          "onBeforeInput",
          "beforeinput",
          null,
          m,
          Je
        ), nt.push({
          event: jt,
          listeners: Pn
        }), jt.data = vn)), ah(
          nt,
          l,
          He,
          m,
          Je
        );
      }
      Ny(nt, u);
    });
  }
  function ih(l, u, m) {
    return {
      instance: l,
      listener: u,
      currentTarget: m
    };
  }
  function lh(l, u) {
    for (var m = u + "Capture", v = []; l !== null; ) {
      var O = l, R = O.stateNode;
      if (O = O.tag, O !== 5 && O !== 26 && O !== 27 || R === null || (O = Jt(l, m), O != null && v.unshift(
        ih(l, O, R)
      ), O = Jt(l, u), O != null && v.push(
        ih(l, O, R)
      )), l.tag === 3) return v;
      l = l.return;
    }
    return [];
  }
  function Dy(l) {
    if (l === null) return null;
    do
      l = l.return;
    while (l && l.tag !== 5 && l.tag !== 27);
    return l || null;
  }
  function Mg(l, u, m, v, O) {
    for (var R = u._reactName, B = []; m !== null && m !== v; ) {
      var re = m, ve = re.alternate, He = re.stateNode;
      if (re = re.tag, ve !== null && ve === v) break;
      re !== 5 && re !== 26 && re !== 27 || He === null || (ve = He, O ? (He = Jt(m, R), He != null && B.unshift(
        ih(m, He, ve)
      )) : O || (He = Jt(m, R), He != null && B.push(
        ih(m, He, ve)
      ))), m = m.return;
    }
    B.length !== 0 && l.push({ event: u, listeners: B });
  }
  var $y = /\r\n?/g, S2 = /\u0000|\uFFFD/g;
  function C2(l) {
    return (typeof l == "string" ? l : "" + l).replace($y, `
`).replace(S2, "");
  }
  function x2(l, u) {
    return u = C2(u), C2(l) === u;
  }
  function Mr(l, u, m, v, O, R) {
    switch (m) {
      case "children":
        typeof v == "string" ? u === "body" || u === "textarea" && v === "" || ka(l, v) : (typeof v == "number" || typeof v == "bigint") && u !== "body" && ka(l, "" + v);
        break;
      case "className":
        Wa(l, "class", v);
        break;
      case "tabIndex":
        Wa(l, "tabindex", v);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        Wa(l, m, v);
        break;
      case "style":
        qt(l, v, R);
        break;
      case "data":
        if (u !== "object") {
          Wa(l, "data", v);
          break;
        }
      case "src":
      case "href":
        if (v === "" && (u !== "a" || m !== "href")) {
          l.removeAttribute(m);
          break;
        }
        if (v == null || typeof v == "function" || typeof v == "symbol" || typeof v == "boolean") {
          l.removeAttribute(m);
          break;
        }
        v = tr("" + v), l.setAttribute(m, v);
        break;
      case "action":
      case "formAction":
        if (typeof v == "function") {
          l.setAttribute(
            m,
            "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
          );
          break;
        } else
          typeof R == "function" && (m === "formAction" ? (u !== "input" && Mr(l, u, "name", O.name, O, null), Mr(
            l,
            u,
            "formEncType",
            O.formEncType,
            O,
            null
          ), Mr(
            l,
            u,
            "formMethod",
            O.formMethod,
            O,
            null
          ), Mr(
            l,
            u,
            "formTarget",
            O.formTarget,
            O,
            null
          )) : (Mr(l, u, "encType", O.encType, O, null), Mr(l, u, "method", O.method, O, null), Mr(l, u, "target", O.target, O, null)));
        if (v == null || typeof v == "symbol" || typeof v == "boolean") {
          l.removeAttribute(m);
          break;
        }
        v = tr("" + v), l.setAttribute(m, v);
        break;
      case "onClick":
        v != null && (l.onclick = Va);
        break;
      case "onScroll":
        v != null && Vn("scroll", l);
        break;
      case "onScrollEnd":
        v != null && Vn("scrollend", l);
        break;
      case "dangerouslySetInnerHTML":
        if (v != null) {
          if (typeof v != "object" || !("__html" in v))
            throw Error(a(61));
          if (m = v.__html, m != null) {
            if (O.children != null) throw Error(a(60));
            l.innerHTML = m;
          }
        }
        break;
      case "multiple":
        l.multiple = v && typeof v != "function" && typeof v != "symbol";
        break;
      case "muted":
        l.muted = v && typeof v != "function" && typeof v != "symbol";
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "ref":
        break;
      case "autoFocus":
        break;
      case "xlinkHref":
        if (v == null || typeof v == "function" || typeof v == "boolean" || typeof v == "symbol") {
          l.removeAttribute("xlink:href");
          break;
        }
        m = tr("" + v), l.setAttributeNS(
          "http://www.w3.org/1999/xlink",
          "xlink:href",
          m
        );
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        v != null && typeof v != "function" && typeof v != "symbol" ? l.setAttribute(m, "" + v) : l.removeAttribute(m);
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        v && typeof v != "function" && typeof v != "symbol" ? l.setAttribute(m, "") : l.removeAttribute(m);
        break;
      case "capture":
      case "download":
        v === !0 ? l.setAttribute(m, "") : v !== !1 && v != null && typeof v != "function" && typeof v != "symbol" ? l.setAttribute(m, v) : l.removeAttribute(m);
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        v != null && typeof v != "function" && typeof v != "symbol" && !isNaN(v) && 1 <= v ? l.setAttribute(m, v) : l.removeAttribute(m);
        break;
      case "rowSpan":
      case "start":
        v == null || typeof v == "function" || typeof v == "symbol" || isNaN(v) ? l.removeAttribute(m) : l.setAttribute(m, v);
        break;
      case "popover":
        Vn("beforetoggle", l), Vn("toggle", l), Yr(l, "popover", v);
        break;
      case "xlinkActuate":
        pa(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:actuate",
          v
        );
        break;
      case "xlinkArcrole":
        pa(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:arcrole",
          v
        );
        break;
      case "xlinkRole":
        pa(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:role",
          v
        );
        break;
      case "xlinkShow":
        pa(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:show",
          v
        );
        break;
      case "xlinkTitle":
        pa(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:title",
          v
        );
        break;
      case "xlinkType":
        pa(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:type",
          v
        );
        break;
      case "xmlBase":
        pa(
          l,
          "http://www.w3.org/XML/1998/namespace",
          "xml:base",
          v
        );
        break;
      case "xmlLang":
        pa(
          l,
          "http://www.w3.org/XML/1998/namespace",
          "xml:lang",
          v
        );
        break;
      case "xmlSpace":
        pa(
          l,
          "http://www.w3.org/XML/1998/namespace",
          "xml:space",
          v
        );
        break;
      case "is":
        Yr(l, "is", v);
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        (!(2 < m.length) || m[0] !== "o" && m[0] !== "O" || m[1] !== "n" && m[1] !== "N") && (m = ur.get(m) || m, Yr(l, m, v));
    }
  }
  function E2(l, u, m, v, O, R) {
    switch (m) {
      case "style":
        qt(l, v, R);
        break;
      case "dangerouslySetInnerHTML":
        if (v != null) {
          if (typeof v != "object" || !("__html" in v))
            throw Error(a(61));
          if (m = v.__html, m != null) {
            if (O.children != null) throw Error(a(60));
            l.innerHTML = m;
          }
        }
        break;
      case "children":
        typeof v == "string" ? ka(l, v) : (typeof v == "number" || typeof v == "bigint") && ka(l, "" + v);
        break;
      case "onScroll":
        v != null && Vn("scroll", l);
        break;
      case "onScrollEnd":
        v != null && Vn("scrollend", l);
        break;
      case "onClick":
        v != null && (l.onclick = Va);
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "innerHTML":
      case "ref":
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        if (!Jn.hasOwnProperty(m))
          e: {
            if (m[0] === "o" && m[1] === "n" && (O = m.endsWith("Capture"), u = m.slice(2, O ? m.length - 7 : void 0), R = l[Dt] || null, R = R != null ? R[m] : null, typeof R == "function" && l.removeEventListener(u, R, O), typeof v == "function")) {
              typeof R != "function" && R !== null && (m in l ? l[m] = null : l.hasAttribute(m) && l.removeAttribute(m)), l.addEventListener(u, v, O);
              break e;
            }
            m in l ? l[m] = v : v === !0 ? l.setAttribute(m, "") : Yr(l, m, v);
          }
    }
  }
  function co(l, u, m) {
    switch (u) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "img":
        Vn("error", l), Vn("load", l);
        var v = !1, O = !1, R;
        for (R in m)
          if (m.hasOwnProperty(R)) {
            var B = m[R];
            if (B != null)
              switch (R) {
                case "src":
                  v = !0;
                  break;
                case "srcSet":
                  O = !0;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(a(137, u));
                default:
                  Mr(l, u, R, B, m, null);
              }
          }
        O && Mr(l, u, "srcSet", m.srcSet, m, null), v && Mr(l, u, "src", m.src, m, null);
        return;
      case "input":
        Vn("invalid", l);
        var re = R = B = O = null, ve = null, He = null;
        for (v in m)
          if (m.hasOwnProperty(v)) {
            var Je = m[v];
            if (Je != null)
              switch (v) {
                case "name":
                  O = Je;
                  break;
                case "type":
                  B = Je;
                  break;
                case "checked":
                  ve = Je;
                  break;
                case "defaultChecked":
                  He = Je;
                  break;
                case "value":
                  R = Je;
                  break;
                case "defaultValue":
                  re = Je;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (Je != null)
                    throw Error(a(137, u));
                  break;
                default:
                  Mr(l, u, v, Je, m, null);
              }
          }
        nn(
          l,
          R,
          re,
          ve,
          He,
          B,
          O,
          !1
        );
        return;
      case "select":
        Vn("invalid", l), v = B = R = null;
        for (O in m)
          if (m.hasOwnProperty(O) && (re = m[O], re != null))
            switch (O) {
              case "value":
                R = re;
                break;
              case "defaultValue":
                B = re;
                break;
              case "multiple":
                v = re;
              default:
                Mr(l, u, O, re, m, null);
            }
        u = R, m = B, l.multiple = !!v, u != null ? ia(l, !!v, u, !1) : m != null && ia(l, !!v, m, !0);
        return;
      case "textarea":
        Vn("invalid", l), R = O = v = null;
        for (B in m)
          if (m.hasOwnProperty(B) && (re = m[B], re != null))
            switch (B) {
              case "value":
                v = re;
                break;
              case "defaultValue":
                O = re;
                break;
              case "children":
                R = re;
                break;
              case "dangerouslySetInnerHTML":
                if (re != null) throw Error(a(91));
                break;
              default:
                Mr(l, u, B, re, m, null);
            }
        hi(l, v, O, R);
        return;
      case "option":
        for (ve in m)
          if (m.hasOwnProperty(ve) && (v = m[ve], v != null))
            switch (ve) {
              case "selected":
                l.selected = v && typeof v != "function" && typeof v != "symbol";
                break;
              default:
                Mr(l, u, ve, v, m, null);
            }
        return;
      case "dialog":
        Vn("beforetoggle", l), Vn("toggle", l), Vn("cancel", l), Vn("close", l);
        break;
      case "iframe":
      case "object":
        Vn("load", l);
        break;
      case "video":
      case "audio":
        for (v = 0; v < nf.length; v++)
          Vn(nf[v], l);
        break;
      case "image":
        Vn("error", l), Vn("load", l);
        break;
      case "details":
        Vn("toggle", l);
        break;
      case "embed":
      case "source":
      case "link":
        Vn("error", l), Vn("load", l);
      case "area":
      case "base":
      case "br":
      case "col":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "track":
      case "wbr":
      case "menuitem":
        for (He in m)
          if (m.hasOwnProperty(He) && (v = m[He], v != null))
            switch (He) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(a(137, u));
              default:
                Mr(l, u, He, v, m, null);
            }
        return;
      default:
        if (Kt(u)) {
          for (Je in m)
            m.hasOwnProperty(Je) && (v = m[Je], v !== void 0 && E2(
              l,
              u,
              Je,
              v,
              m,
              void 0
            ));
          return;
        }
    }
    for (re in m)
      m.hasOwnProperty(re) && (v = m[re], v != null && Mr(l, u, re, v, m, null));
  }
  function P2(l, u, m, v) {
    switch (u) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "input":
        var O = null, R = null, B = null, re = null, ve = null, He = null, Je = null;
        for (Ge in m) {
          var nt = m[Ge];
          if (m.hasOwnProperty(Ge) && nt != null)
            switch (Ge) {
              case "checked":
                break;
              case "value":
                break;
              case "defaultValue":
                ve = nt;
              default:
                v.hasOwnProperty(Ge) || Mr(l, u, Ge, null, v, nt);
            }
        }
        for (var We in v) {
          var Ge = v[We];
          if (nt = m[We], v.hasOwnProperty(We) && (Ge != null || nt != null))
            switch (We) {
              case "type":
                R = Ge;
                break;
              case "name":
                O = Ge;
                break;
              case "checked":
                He = Ge;
                break;
              case "defaultChecked":
                Je = Ge;
                break;
              case "value":
                B = Ge;
                break;
              case "defaultValue":
                re = Ge;
                break;
              case "children":
              case "dangerouslySetInnerHTML":
                if (Ge != null)
                  throw Error(a(137, u));
                break;
              default:
                Ge !== nt && Mr(
                  l,
                  u,
                  We,
                  Ge,
                  v,
                  nt
                );
            }
        }
        Qt(
          l,
          B,
          re,
          ve,
          He,
          Je,
          R,
          O
        );
        return;
      case "select":
        Ge = B = re = We = null;
        for (R in m)
          if (ve = m[R], m.hasOwnProperty(R) && ve != null)
            switch (R) {
              case "value":
                break;
              case "multiple":
                Ge = ve;
              default:
                v.hasOwnProperty(R) || Mr(
                  l,
                  u,
                  R,
                  null,
                  v,
                  ve
                );
            }
        for (O in v)
          if (R = v[O], ve = m[O], v.hasOwnProperty(O) && (R != null || ve != null))
            switch (O) {
              case "value":
                We = R;
                break;
              case "defaultValue":
                re = R;
                break;
              case "multiple":
                B = R;
              default:
                R !== ve && Mr(
                  l,
                  u,
                  O,
                  R,
                  v,
                  ve
                );
            }
        u = re, m = B, v = Ge, We != null ? ia(l, !!m, We, !1) : !!v != !!m && (u != null ? ia(l, !!m, u, !0) : ia(l, !!m, m ? [] : "", !1));
        return;
      case "textarea":
        Ge = We = null;
        for (re in m)
          if (O = m[re], m.hasOwnProperty(re) && O != null && !v.hasOwnProperty(re))
            switch (re) {
              case "value":
                break;
              case "children":
                break;
              default:
                Mr(l, u, re, null, v, O);
            }
        for (B in v)
          if (O = v[B], R = m[B], v.hasOwnProperty(B) && (O != null || R != null))
            switch (B) {
              case "value":
                We = O;
                break;
              case "defaultValue":
                Ge = O;
                break;
              case "children":
                break;
              case "dangerouslySetInnerHTML":
                if (O != null) throw Error(a(91));
                break;
              default:
                O !== R && Mr(l, u, B, O, v, R);
            }
        so(l, We, Ge);
        return;
      case "option":
        for (var At in m)
          if (We = m[At], m.hasOwnProperty(At) && We != null && !v.hasOwnProperty(At))
            switch (At) {
              case "selected":
                l.selected = !1;
                break;
              default:
                Mr(
                  l,
                  u,
                  At,
                  null,
                  v,
                  We
                );
            }
        for (ve in v)
          if (We = v[ve], Ge = m[ve], v.hasOwnProperty(ve) && We !== Ge && (We != null || Ge != null))
            switch (ve) {
              case "selected":
                l.selected = We && typeof We != "function" && typeof We != "symbol";
                break;
              default:
                Mr(
                  l,
                  u,
                  ve,
                  We,
                  v,
                  Ge
                );
            }
        return;
      case "img":
      case "link":
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
      case "menuitem":
        for (var Zt in m)
          We = m[Zt], m.hasOwnProperty(Zt) && We != null && !v.hasOwnProperty(Zt) && Mr(l, u, Zt, null, v, We);
        for (He in v)
          if (We = v[He], Ge = m[He], v.hasOwnProperty(He) && We !== Ge && (We != null || Ge != null))
            switch (He) {
              case "children":
              case "dangerouslySetInnerHTML":
                if (We != null)
                  throw Error(a(137, u));
                break;
              default:
                Mr(
                  l,
                  u,
                  He,
                  We,
                  v,
                  Ge
                );
            }
        return;
      default:
        if (Kt(u)) {
          for (var Or in m)
            We = m[Or], m.hasOwnProperty(Or) && We !== void 0 && !v.hasOwnProperty(Or) && E2(
              l,
              u,
              Or,
              void 0,
              v,
              We
            );
          for (Je in v)
            We = v[Je], Ge = m[Je], !v.hasOwnProperty(Je) || We === Ge || We === void 0 && Ge === void 0 || E2(
              l,
              u,
              Je,
              We,
              v,
              Ge
            );
          return;
        }
    }
    for (var $e in m)
      We = m[$e], m.hasOwnProperty($e) && We != null && !v.hasOwnProperty($e) && Mr(l, u, $e, null, v, We);
    for (nt in v)
      We = v[nt], Ge = m[nt], !v.hasOwnProperty(nt) || We === Ge || We == null && Ge == null || Mr(l, u, nt, We, v, Ge);
  }
  function Og(l) {
    switch (l) {
      case "css":
      case "script":
      case "font":
      case "img":
      case "image":
      case "input":
      case "link":
        return !0;
      default:
        return !1;
    }
  }
  function k2() {
    if (typeof performance.getEntriesByType == "function") {
      for (var l = 0, u = 0, m = performance.getEntriesByType("resource"), v = 0; v < m.length; v++) {
        var O = m[v], R = O.transferSize, B = O.initiatorType, re = O.duration;
        if (R && re && Og(B)) {
          for (B = 0, re = O.responseEnd, v += 1; v < m.length; v++) {
            var ve = m[v], He = ve.startTime;
            if (He > re) break;
            var Je = ve.transferSize, nt = ve.initiatorType;
            Je && Og(nt) && (ve = ve.responseEnd, B += Je * (ve < re ? 1 : (re - He) / (ve - He)));
          }
          if (--v, u += 8 * (R + B) / (O.duration / 1e3), l++, 10 < l) break;
        }
      }
      if (0 < l) return u / l / 1e6;
    }
    return navigator.connection && (l = navigator.connection.downlink, typeof l == "number") ? l : 5;
  }
  var Tg = null, Rg = null;
  function Iu(l) {
    return l.nodeType === 9 ? l : l.ownerDocument;
  }
  function zy(l) {
    switch (l) {
      case "http://www.w3.org/2000/svg":
        return 1;
      case "http://www.w3.org/1998/Math/MathML":
        return 2;
      default:
        return 0;
    }
  }
  function M2(l, u) {
    if (l === 0)
      switch (u) {
        case "svg":
          return 1;
        case "math":
          return 2;
        default:
          return 0;
      }
    return l === 1 && u === "foreignObject" ? 0 : l;
  }
  function af(l, u) {
    return l === "textarea" || l === "noscript" || typeof u.children == "string" || typeof u.children == "number" || typeof u.children == "bigint" || typeof u.dangerouslySetInnerHTML == "object" && u.dangerouslySetInnerHTML !== null && u.dangerouslySetInnerHTML.__html != null;
  }
  var Ag = null;
  function yC() {
    var l = window.event;
    return l && l.type === "popstate" ? l === Ag ? !1 : (Ag = l, !0) : (Ag = null, !1);
  }
  var sh = typeof setTimeout == "function" ? setTimeout : void 0, jy = typeof clearTimeout == "function" ? clearTimeout : void 0, Lc = typeof Promise == "function" ? Promise : void 0, Iy = typeof queueMicrotask == "function" ? queueMicrotask : typeof Lc < "u" ? function(l) {
    return Lc.resolve(null).then(l).catch(O2);
  } : sh;
  function O2(l) {
    setTimeout(function() {
      throw l;
    });
  }
  function Al(l) {
    return l === "head";
  }
  function T2(l, u) {
    var m = u, v = 0;
    do {
      var O = m.nextSibling;
      if (l.removeChild(m), O && O.nodeType === 8)
        if (m = O.data, m === "/$" || m === "/&") {
          if (v === 0) {
            l.removeChild(O), vf(u);
            return;
          }
          v--;
        } else if (m === "$" || m === "$?" || m === "$~" || m === "$!" || m === "&")
          v++;
        else if (m === "html")
          Hc(l.ownerDocument.documentElement);
        else if (m === "head") {
          m = l.ownerDocument.head, Hc(m);
          for (var R = m.firstChild; R; ) {
            var B = R.nextSibling, re = R.nodeName;
            R[qn] || re === "SCRIPT" || re === "STYLE" || re === "LINK" && R.rel.toLowerCase() === "stylesheet" || m.removeChild(R), R = B;
          }
        } else
          m === "body" && Hc(l.ownerDocument.body);
      m = O;
    } while (m);
    vf(u);
  }
  function Sa(l, u) {
    var m = l;
    l = 0;
    do {
      var v = m.nextSibling;
      if (m.nodeType === 1 ? u ? (m._stashedDisplay = m.style.display, m.style.display = "none") : (m.style.display = m._stashedDisplay || "", m.getAttribute("style") === "" && m.removeAttribute("style")) : m.nodeType === 3 && (u ? (m._stashedText = m.nodeValue, m.nodeValue = "") : m.nodeValue = m._stashedText || ""), v && v.nodeType === 8)
        if (m = v.data, m === "/$") {
          if (l === 0) break;
          l--;
        } else
          m !== "$" && m !== "$?" && m !== "$~" && m !== "$!" || l++;
      m = v;
    } while (m);
  }
  function uh(l) {
    var u = l.firstChild;
    for (u && u.nodeType === 10 && (u = u.nextSibling); u; ) {
      var m = u;
      switch (u = u.nextSibling, m.nodeName) {
        case "HTML":
        case "HEAD":
        case "BODY":
          uh(m), Rr(m);
          continue;
        case "SCRIPT":
        case "STYLE":
          continue;
        case "LINK":
          if (m.rel.toLowerCase() === "stylesheet") continue;
      }
      l.removeChild(m);
    }
  }
  function wC(l, u, m, v) {
    for (; l.nodeType === 1; ) {
      var O = m;
      if (l.nodeName.toLowerCase() !== u.toLowerCase()) {
        if (!v && (l.nodeName !== "INPUT" || l.type !== "hidden"))
          break;
      } else if (v) {
        if (!l[qn])
          switch (u) {
            case "meta":
              if (!l.hasAttribute("itemprop")) break;
              return l;
            case "link":
              if (R = l.getAttribute("rel"), R === "stylesheet" && l.hasAttribute("data-precedence"))
                break;
              if (R !== O.rel || l.getAttribute("href") !== (O.href == null || O.href === "" ? null : O.href) || l.getAttribute("crossorigin") !== (O.crossOrigin == null ? null : O.crossOrigin) || l.getAttribute("title") !== (O.title == null ? null : O.title))
                break;
              return l;
            case "style":
              if (l.hasAttribute("data-precedence")) break;
              return l;
            case "script":
              if (R = l.getAttribute("src"), (R !== (O.src == null ? null : O.src) || l.getAttribute("type") !== (O.type == null ? null : O.type) || l.getAttribute("crossorigin") !== (O.crossOrigin == null ? null : O.crossOrigin)) && R && l.hasAttribute("async") && !l.hasAttribute("itemprop"))
                break;
              return l;
            default:
              return l;
          }
      } else if (u === "input" && l.type === "hidden") {
        var R = O.name == null ? null : "" + O.name;
        if (O.type === "hidden" && l.getAttribute("name") === R)
          return l;
      } else return l;
      if (l = Go(l.nextSibling), l === null) break;
    }
    return null;
  }
  function Rn(l, u, m) {
    if (u === "") return null;
    for (; l.nodeType !== 3; )
      if ((l.nodeType !== 1 || l.nodeName !== "INPUT" || l.type !== "hidden") && !m || (l = Go(l.nextSibling), l === null)) return null;
    return l;
  }
  function Ly(l, u) {
    for (; l.nodeType !== 8; )
      if ((l.nodeType !== 1 || l.nodeName !== "INPUT" || l.type !== "hidden") && !u || (l = Go(l.nextSibling), l === null)) return null;
    return l;
  }
  function nl(l) {
    return l.data === "$?" || l.data === "$~";
  }
  function Lu(l) {
    return l.data === "$!" || l.data === "$?" && l.ownerDocument.readyState !== "loading";
  }
  function of(l, u) {
    var m = l.ownerDocument;
    if (l.data === "$~") l._reactRetry = u;
    else if (l.data !== "$?" || m.readyState !== "loading")
      u();
    else {
      var v = function() {
        u(), m.removeEventListener("DOMContentLoaded", v);
      };
      m.addEventListener("DOMContentLoaded", v), l._reactRetry = v;
    }
  }
  function Go(l) {
    for (; l != null; l = l.nextSibling) {
      var u = l.nodeType;
      if (u === 1 || u === 3) break;
      if (u === 8) {
        if (u = l.data, u === "$" || u === "$!" || u === "$?" || u === "$~" || u === "&" || u === "F!" || u === "F")
          break;
        if (u === "/$" || u === "/&") return null;
      }
    }
    return l;
  }
  var ch = null;
  function Ng(l) {
    l = l.nextSibling;
    for (var u = 0; l; ) {
      if (l.nodeType === 8) {
        var m = l.data;
        if (m === "/$" || m === "/&") {
          if (u === 0)
            return Go(l.nextSibling);
          u--;
        } else
          m !== "$" && m !== "$!" && m !== "$?" && m !== "$~" && m !== "&" || u++;
      }
      l = l.nextSibling;
    }
    return null;
  }
  function Nl(l) {
    l = l.previousSibling;
    for (var u = 0; l; ) {
      if (l.nodeType === 8) {
        var m = l.data;
        if (m === "$" || m === "$!" || m === "$?" || m === "$~" || m === "&") {
          if (u === 0) return l;
          u--;
        } else m !== "/$" && m !== "/&" || u++;
      }
      l = l.previousSibling;
    }
    return null;
  }
  function lf(l, u, m) {
    switch (u = Iu(m), l) {
      case "html":
        if (l = u.documentElement, !l) throw Error(a(452));
        return l;
      case "head":
        if (l = u.head, !l) throw Error(a(453));
        return l;
      case "body":
        if (l = u.body, !l) throw Error(a(454));
        return l;
      default:
        throw Error(a(451));
    }
  }
  function Hc(l) {
    for (var u = l.attributes; u.length; )
      l.removeAttributeNode(u[0]);
    Rr(l);
  }
  var ai = /* @__PURE__ */ new Map(), dh = /* @__PURE__ */ new Set();
  function Eo(l) {
    return typeof l.getRootNode == "function" ? l.getRootNode() : l.nodeType === 9 ? l : l.ownerDocument;
  }
  var Dl = K.d;
  K.d = {
    f: SC,
    r: Hy,
    D: Xe,
    C: fr,
    L: CC,
    m: R2,
    X: Ks,
    S: A2,
    M: Hu
  };
  function SC() {
    var l = Dl.f(), u = Qd();
    return l || u;
  }
  function Hy(l) {
    var u = en(l);
    u !== null && u.tag === 5 && u.type === "form" ? Pr(u) : Dl.r(l);
  }
  var sf = typeof document > "u" ? null : document;
  function Ta(l, u, m) {
    var v = sf;
    if (v && typeof u == "string" && u) {
      var O = On(u);
      O = 'link[rel="' + l + '"][href="' + O + '"]', typeof m == "string" && (O += '[crossorigin="' + m + '"]'), dh.has(O) || (dh.add(O), l = { rel: l, crossOrigin: m, href: u }, v.querySelector(O) === null && (u = v.createElement("link"), co(u, "link", l), kt(u), v.head.appendChild(u)));
    }
  }
  function Xe(l) {
    Dl.D(l), Ta("dns-prefetch", l, null);
  }
  function fr(l, u) {
    Dl.C(l, u), Ta("preconnect", l, u);
  }
  function CC(l, u, m) {
    Dl.L(l, u, m);
    var v = sf;
    if (v && l && u) {
      var O = 'link[rel="preload"][as="' + On(u) + '"]';
      u === "image" && m && m.imageSrcSet ? (O += '[imagesrcset="' + On(
        m.imageSrcSet
      ) + '"]', typeof m.imageSizes == "string" && (O += '[imagesizes="' + On(
        m.imageSizes
      ) + '"]')) : O += '[href="' + On(l) + '"]';
      var R = O;
      switch (u) {
        case "style":
          R = Oi(l);
          break;
        case "script":
          R = Fc(l);
      }
      ai.has(R) || (l = w(
        {
          rel: "preload",
          href: u === "image" && m && m.imageSrcSet ? void 0 : l,
          as: u
        },
        m
      ), ai.set(R, l), v.querySelector(O) !== null || u === "style" && v.querySelector(Fu(R)) || u === "script" && v.querySelector(df(R)) || (u = v.createElement("link"), co(u, "link", l), kt(u), v.head.appendChild(u)));
    }
  }
  function R2(l, u) {
    Dl.m(l, u);
    var m = sf;
    if (m && l) {
      var v = u && typeof u.as == "string" ? u.as : "script", O = 'link[rel="modulepreload"][as="' + On(v) + '"][href="' + On(l) + '"]', R = O;
      switch (v) {
        case "audioworklet":
        case "paintworklet":
        case "serviceworker":
        case "sharedworker":
        case "worker":
        case "script":
          R = Fc(l);
      }
      if (!ai.has(R) && (l = w({ rel: "modulepreload", href: l }, u), ai.set(R, l), m.querySelector(O) === null)) {
        switch (v) {
          case "audioworklet":
          case "paintworklet":
          case "serviceworker":
          case "sharedworker":
          case "worker":
          case "script":
            if (m.querySelector(df(R)))
              return;
        }
        v = m.createElement("link"), co(v, "link", l), kt(v), m.head.appendChild(v);
      }
    }
  }
  function A2(l, u, m) {
    Dl.S(l, u, m);
    var v = sf;
    if (v && l) {
      var O = zt(v).hoistableStyles, R = Oi(l);
      u = u || "default";
      var B = O.get(R);
      if (!B) {
        var re = { loading: 0, preload: null };
        if (B = v.querySelector(
          Fu(R)
        ))
          re.loading = 5;
        else {
          l = w(
            { rel: "stylesheet", href: l, "data-precedence": u },
            m
          ), (m = ai.get(R)) && Dg(l, m);
          var ve = B = v.createElement("link");
          kt(ve), co(ve, "link", l), ve._p = new Promise(function(He, Je) {
            ve.onload = He, ve.onerror = Je;
          }), ve.addEventListener("load", function() {
            re.loading |= 1;
          }), ve.addEventListener("error", function() {
            re.loading |= 2;
          }), re.loading |= 4, fh(B, u, v);
        }
        B = {
          type: "stylesheet",
          instance: B,
          count: 1,
          state: re
        }, O.set(R, B);
      }
    }
  }
  function Ks(l, u) {
    Dl.X(l, u);
    var m = sf;
    if (m && l) {
      var v = zt(m).hoistableScripts, O = Fc(l), R = v.get(O);
      R || (R = m.querySelector(df(O)), R || (l = w({ src: l, async: !0 }, u), (u = ai.get(O)) && $g(l, u), R = m.createElement("script"), kt(R), co(R, "link", l), m.head.appendChild(R)), R = {
        type: "script",
        instance: R,
        count: 1,
        state: null
      }, v.set(O, R));
    }
  }
  function Hu(l, u) {
    Dl.M(l, u);
    var m = sf;
    if (m && l) {
      var v = zt(m).hoistableScripts, O = Fc(l), R = v.get(O);
      R || (R = m.querySelector(df(O)), R || (l = w({ src: l, async: !0, type: "module" }, u), (u = ai.get(O)) && $g(l, u), R = m.createElement("script"), kt(R), co(R, "link", l), m.head.appendChild(R)), R = {
        type: "script",
        instance: R,
        count: 1,
        state: null
      }, v.set(O, R));
    }
  }
  function uf(l, u, m, v) {
    var O = (O = be.current) ? Eo(O) : null;
    if (!O) throw Error(a(446));
    switch (l) {
      case "meta":
      case "title":
        return null;
      case "style":
        return typeof m.precedence == "string" && typeof m.href == "string" ? (u = Oi(m.href), m = zt(
          O
        ).hoistableStyles, v = m.get(u), v || (v = {
          type: "style",
          instance: null,
          count: 0,
          state: null
        }, m.set(u, v)), v) : { type: "void", instance: null, count: 0, state: null };
      case "link":
        if (m.rel === "stylesheet" && typeof m.href == "string" && typeof m.precedence == "string") {
          l = Oi(m.href);
          var R = zt(
            O
          ).hoistableStyles, B = R.get(l);
          if (B || (O = O.ownerDocument || O, B = {
            type: "stylesheet",
            instance: null,
            count: 0,
            state: { loading: 0, preload: null }
          }, R.set(l, B), (R = O.querySelector(
            Fu(l)
          )) && !R._p && (B.instance = R, B.state.loading = 5), ai.has(l) || (m = {
            rel: "preload",
            as: "style",
            href: m.href,
            crossOrigin: m.crossOrigin,
            integrity: m.integrity,
            media: m.media,
            hrefLang: m.hrefLang,
            referrerPolicy: m.referrerPolicy
          }, ai.set(l, m), R || Fy(
            O,
            l,
            m,
            B.state
          ))), u && v === null)
            throw Error(a(528, ""));
          return B;
        }
        if (u && v !== null)
          throw Error(a(529, ""));
        return null;
      case "script":
        return u = m.async, m = m.src, typeof m == "string" && u && typeof u != "function" && typeof u != "symbol" ? (u = Fc(m), m = zt(
          O
        ).hoistableScripts, v = m.get(u), v || (v = {
          type: "script",
          instance: null,
          count: 0,
          state: null
        }, m.set(u, v)), v) : { type: "void", instance: null, count: 0, state: null };
      default:
        throw Error(a(444, l));
    }
  }
  function Oi(l) {
    return 'href="' + On(l) + '"';
  }
  function Fu(l) {
    return 'link[rel="stylesheet"][' + l + "]";
  }
  function cf(l) {
    return w({}, l, {
      "data-precedence": l.precedence,
      precedence: null
    });
  }
  function Fy(l, u, m, v) {
    l.querySelector('link[rel="preload"][as="style"][' + u + "]") ? v.loading = 1 : (u = l.createElement("link"), v.preload = u, u.addEventListener("load", function() {
      return v.loading |= 1;
    }), u.addEventListener("error", function() {
      return v.loading |= 2;
    }), co(u, "link", m), kt(u), l.head.appendChild(u));
  }
  function Fc(l) {
    return '[src="' + On(l) + '"]';
  }
  function df(l) {
    return "script[async]" + l;
  }
  function N2(l, u, m) {
    if (u.count++, u.instance === null)
      switch (u.type) {
        case "style":
          var v = l.querySelector(
            'style[data-href~="' + On(m.href) + '"]'
          );
          if (v)
            return u.instance = v, kt(v), v;
          var O = w({}, m, {
            "data-href": m.href,
            "data-precedence": m.precedence,
            href: null,
            precedence: null
          });
          return v = (l.ownerDocument || l).createElement(
            "style"
          ), kt(v), co(v, "style", O), fh(v, m.precedence, l), u.instance = v;
        case "stylesheet":
          O = Oi(m.href);
          var R = l.querySelector(
            Fu(O)
          );
          if (R)
            return u.state.loading |= 4, u.instance = R, kt(R), R;
          v = cf(m), (O = ai.get(O)) && Dg(v, O), R = (l.ownerDocument || l).createElement("link"), kt(R);
          var B = R;
          return B._p = new Promise(function(re, ve) {
            B.onload = re, B.onerror = ve;
          }), co(R, "link", v), u.state.loading |= 4, fh(R, m.precedence, l), u.instance = R;
        case "script":
          return R = Fc(m.src), (O = l.querySelector(
            df(R)
          )) ? (u.instance = O, kt(O), O) : (v = m, (O = ai.get(R)) && (v = w({}, m), $g(v, O)), l = l.ownerDocument || l, O = l.createElement("script"), kt(O), co(O, "link", v), l.head.appendChild(O), u.instance = O);
        case "void":
          return null;
        default:
          throw Error(a(443, u.type));
      }
    else
      u.type === "stylesheet" && (u.state.loading & 4) === 0 && (v = u.instance, u.state.loading |= 4, fh(v, m.precedence, l));
    return u.instance;
  }
  function fh(l, u, m) {
    for (var v = m.querySelectorAll(
      'link[rel="stylesheet"][data-precedence],style[data-precedence]'
    ), O = v.length ? v[v.length - 1] : null, R = O, B = 0; B < v.length; B++) {
      var re = v[B];
      if (re.dataset.precedence === u) R = re;
      else if (R !== O) break;
    }
    R ? R.parentNode.insertBefore(l, R.nextSibling) : (u = m.nodeType === 9 ? m.head : m, u.insertBefore(l, u.firstChild));
  }
  function Dg(l, u) {
    l.crossOrigin == null && (l.crossOrigin = u.crossOrigin), l.referrerPolicy == null && (l.referrerPolicy = u.referrerPolicy), l.title == null && (l.title = u.title);
  }
  function $g(l, u) {
    l.crossOrigin == null && (l.crossOrigin = u.crossOrigin), l.referrerPolicy == null && (l.referrerPolicy = u.referrerPolicy), l.integrity == null && (l.integrity = u.integrity);
  }
  var ff = null;
  function D2(l, u, m) {
    if (ff === null) {
      var v = /* @__PURE__ */ new Map(), O = ff = /* @__PURE__ */ new Map();
      O.set(m, v);
    } else
      O = ff, v = O.get(m), v || (v = /* @__PURE__ */ new Map(), O.set(m, v));
    if (v.has(l)) return v;
    for (v.set(l, null), m = m.getElementsByTagName(l), O = 0; O < m.length; O++) {
      var R = m[O];
      if (!(R[qn] || R[Gt] || l === "link" && R.getAttribute("rel") === "stylesheet") && R.namespaceURI !== "http://www.w3.org/2000/svg") {
        var B = R.getAttribute(u) || "";
        B = l + B;
        var re = v.get(B);
        re ? re.push(R) : v.set(B, [R]);
      }
    }
    return v;
  }
  function zg(l, u, m) {
    l = l.ownerDocument || l, l.head.insertBefore(
      m,
      u === "title" ? l.querySelector("head > title") : null
    );
  }
  function $2(l, u, m) {
    if (m === 1 || u.itemProp != null) return !1;
    switch (l) {
      case "meta":
      case "title":
        return !0;
      case "style":
        if (typeof u.precedence != "string" || typeof u.href != "string" || u.href === "")
          break;
        return !0;
      case "link":
        if (typeof u.rel != "string" || typeof u.href != "string" || u.href === "" || u.onLoad || u.onError)
          break;
        switch (u.rel) {
          case "stylesheet":
            return l = u.disabled, typeof u.precedence == "string" && l == null;
          default:
            return !0;
        }
      case "script":
        if (u.async && typeof u.async != "function" && typeof u.async != "symbol" && !u.onLoad && !u.onError && u.src && typeof u.src == "string")
          return !0;
    }
    return !1;
  }
  function oi(l) {
    return !(l.type === "stylesheet" && (l.state.loading & 3) === 0);
  }
  function ds(l, u, m, v) {
    if (m.type === "stylesheet" && (typeof v.media != "string" || matchMedia(v.media).matches !== !1) && (m.state.loading & 4) === 0) {
      if (m.instance === null) {
        var O = Oi(v.href), R = u.querySelector(
          Fu(O)
        );
        if (R) {
          u = R._p, u !== null && typeof u == "object" && typeof u.then == "function" && (l.count++, l = jg.bind(l), u.then(l, l)), m.state.loading |= 4, m.instance = R, kt(R);
          return;
        }
        R = u.ownerDocument || u, v = cf(v), (O = ai.get(O)) && Dg(v, O), R = R.createElement("link"), kt(R);
        var B = R;
        B._p = new Promise(function(re, ve) {
          B.onload = re, B.onerror = ve;
        }), co(R, "link", v), m.instance = R;
      }
      l.stylesheets === null && (l.stylesheets = /* @__PURE__ */ new Map()), l.stylesheets.set(m, u), (u = m.state.preload) && (m.state.loading & 3) === 0 && (l.count++, m = jg.bind(l), u.addEventListener("load", m), u.addEventListener("error", m));
    }
  }
  var Ti = 0;
  function z2(l, u) {
    return l.stylesheets && l.count === 0 && Lg(l, l.stylesheets), 0 < l.count || 0 < l.imgCount ? function(m) {
      var v = setTimeout(function() {
        if (l.stylesheets && Lg(l, l.stylesheets), l.unsuspend) {
          var R = l.unsuspend;
          l.unsuspend = null, R();
        }
      }, 6e4 + u);
      0 < l.imgBytes && Ti === 0 && (Ti = 62500 * k2());
      var O = setTimeout(
        function() {
          if (l.waitingForImages = !1, l.count === 0 && (l.stylesheets && Lg(l, l.stylesheets), l.unsuspend)) {
            var R = l.unsuspend;
            l.unsuspend = null, R();
          }
        },
        (l.imgBytes > Ti ? 50 : 800) + u
      );
      return l.unsuspend = m, function() {
        l.unsuspend = null, clearTimeout(v), clearTimeout(O);
      };
    } : null;
  }
  function jg() {
    if (this.count--, this.count === 0 && (this.imgCount === 0 || !this.waitingForImages)) {
      if (this.stylesheets) Lg(this, this.stylesheets);
      else if (this.unsuspend) {
        var l = this.unsuspend;
        this.unsuspend = null, l();
      }
    }
  }
  var Ig = null;
  function Lg(l, u) {
    l.stylesheets = null, l.unsuspend !== null && (l.count++, Ig = /* @__PURE__ */ new Map(), u.forEach(Ka, l), Ig = null, jg.call(l));
  }
  function Ka(l, u) {
    if (!(u.state.loading & 4)) {
      var m = Ig.get(l);
      if (m) var v = m.get(null);
      else {
        m = /* @__PURE__ */ new Map(), Ig.set(l, m);
        for (var O = l.querySelectorAll(
          "link[data-precedence],style[data-precedence]"
        ), R = 0; R < O.length; R++) {
          var B = O[R];
          (B.nodeName === "LINK" || B.getAttribute("media") !== "not all") && (m.set(B.dataset.precedence, B), v = B);
        }
        v && m.set(null, v);
      }
      O = u.instance, B = O.getAttribute("data-precedence"), R = m.get(B) || v, R === v && m.set(null, O), m.set(B, O), this.count++, v = jg.bind(this), O.addEventListener("load", v), O.addEventListener("error", v), R ? R.parentNode.insertBefore(O, R.nextSibling) : (l = l.nodeType === 9 ? l.head : l, l.insertBefore(O, l.firstChild)), u.state.loading |= 4;
    }
  }
  var mh = {
    $$typeof: D,
    Provider: null,
    Consumer: null,
    _currentValue: X,
    _currentValue2: X,
    _threadCount: 0
  };
  function j2(l, u, m, v, O, R, B, re, ve) {
    this.tag = 1, this.containerInfo = l, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = xn(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = xn(0), this.hiddenUpdates = xn(null), this.identifierPrefix = v, this.onUncaughtError = O, this.onCaughtError = R, this.onRecoverableError = B, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = ve, this.incompleteTransitions = /* @__PURE__ */ new Map();
  }
  function Hg(l, u, m, v, O, R, B, re, ve, He, Je, nt) {
    return l = new j2(
      l,
      u,
      m,
      B,
      ve,
      He,
      Je,
      nt,
      re
    ), u = 1, R === !0 && (u |= 24), R = ca(3, null, null, u), l.current = R, R.stateNode = l, u = Sm(), u.refCount++, l.pooledCache = u, u.refCount++, R.memoizedState = {
      element: v,
      isDehydrated: m,
      cache: u
    }, Om(R), l;
  }
  function Wc(l) {
    return l ? (l = jo, l) : jo;
  }
  function Wy(l, u, m, v, O, R) {
    O = Wc(O), v.context === null ? v.context = O : v.pendingContext = O, v = Hs(u), v.payload = { element: m }, R = R === void 0 ? null : R, R !== null && (v.callback = R), m = Ci(l, v, u), m !== null && (Xo(m, l, u), Eu(m, l, u));
  }
  function Fg(l, u) {
    if (l = l.memoizedState, l !== null && l.dehydrated !== null) {
      var m = l.retryLane;
      l.retryLane = m !== 0 && m < u ? m : u;
    }
  }
  function I2(l, u) {
    Fg(l, u), (l = l.alternate) && Fg(l, u);
  }
  function Vy(l) {
    if (l.tag === 13 || l.tag === 31) {
      var u = Ns(l, 67108864);
      u !== null && Xo(u, l, 67108864), I2(l, 67108864);
    }
  }
  function Vc(l) {
    if (l.tag === 13 || l.tag === 31) {
      var u = ri();
      u = wt(u);
      var m = Ns(l, u);
      m !== null && Xo(m, l, u), I2(l, u);
    }
  }
  var Ia = !0;
  function fs(l, u, m, v) {
    var O = H.T;
    H.T = null;
    var R = K.p;
    try {
      K.p = 2, fo(l, u, m, v);
    } finally {
      K.p = R, H.T = O;
    }
  }
  function ms(l, u, m, v) {
    var O = H.T;
    H.T = null;
    var R = K.p;
    try {
      K.p = 8, fo(l, u, m, v);
    } finally {
      K.p = R, H.T = O;
    }
  }
  function fo(l, u, m, v) {
    if (Ia) {
      var O = L2(v);
      if (O === null)
        w2(
          l,
          u,
          v,
          Wg,
          m
        ), Ys(l, v);
      else if (xC(
        O,
        l,
        u,
        m,
        v
      ))
        v.stopPropagation();
      else if (Ys(l, v), u & 4 && -1 < qo.indexOf(l)) {
        for (; O !== null; ) {
          var R = en(O);
          if (R !== null)
            switch (R.tag) {
              case 3:
                if (R = R.stateNode, R.current.memoizedState.isDehydrated) {
                  var B = $t(R.pendingLanes);
                  if (B !== 0) {
                    var re = R;
                    for (re.pendingLanes |= 2, re.entangledLanes |= 2; B; ) {
                      var ve = 1 << 31 - ot(B);
                      re.entanglements[1] |= ve, B &= ~ve;
                    }
                    cs(R), (ir & 6) === 0 && (dr = Fe() + 500, qs(0));
                  }
                }
                break;
              case 31:
              case 13:
                re = Ns(R, 2), re !== null && Xo(re, R, 2), Qd(), I2(R, 2);
            }
          if (R = L2(v), R === null && w2(
            l,
            u,
            v,
            Wg,
            m
          ), R === O) break;
          O = R;
        }
        O !== null && v.stopPropagation();
      } else
        w2(
          l,
          u,
          v,
          null,
          m
        );
    }
  }
  function L2(l) {
    return l = Li(l), mf(l);
  }
  var Wg = null;
  function mf(l) {
    if (Wg = null, l = Wt(l), l !== null) {
      var u = c(l);
      if (u === null) l = null;
      else {
        var m = u.tag;
        if (m === 13) {
          if (l = d(u), l !== null) return l;
          l = null;
        } else if (m === 31) {
          if (l = f(u), l !== null) return l;
          l = null;
        } else if (m === 3) {
          if (u.stateNode.current.memoizedState.isDehydrated)
            return u.tag === 3 ? u.stateNode.containerInfo : null;
          l = null;
        } else u !== l && (l = null);
      }
    }
    return Wg = l, null;
  }
  function hh(l) {
    switch (l) {
      case "beforetoggle":
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "toggle":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 2;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 8;
      case "message":
        switch (tt()) {
          case dt:
            return 2;
          case St:
            return 8;
          case mt:
          case Ot:
            return 32;
          case Rt:
            return 268435456;
          default:
            return 32;
        }
      default:
        return 32;
    }
  }
  var hf = !1, La = null, mo = null, Po = null, Wu = /* @__PURE__ */ new Map(), rl = /* @__PURE__ */ new Map(), Xr = [], qo = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
    " "
  );
  function Ys(l, u) {
    switch (l) {
      case "focusin":
      case "focusout":
        La = null;
        break;
      case "dragenter":
      case "dragleave":
        mo = null;
        break;
      case "mouseover":
      case "mouseout":
        Po = null;
        break;
      case "pointerover":
      case "pointerout":
        Wu.delete(u.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        rl.delete(u.pointerId);
    }
  }
  function _c(l, u, m, v, O, R) {
    return l === null || l.nativeEvent !== R ? (l = {
      blockedOn: u,
      domEventName: m,
      eventSystemFlags: v,
      nativeEvent: R,
      targetContainers: [O]
    }, u !== null && (u = en(u), u !== null && Vy(u)), l) : (l.eventSystemFlags |= v, u = l.targetContainers, O !== null && u.indexOf(O) === -1 && u.push(O), l);
  }
  function xC(l, u, m, v, O) {
    switch (u) {
      case "focusin":
        return La = _c(
          La,
          l,
          u,
          m,
          v,
          O
        ), !0;
      case "dragenter":
        return mo = _c(
          mo,
          l,
          u,
          m,
          v,
          O
        ), !0;
      case "mouseover":
        return Po = _c(
          Po,
          l,
          u,
          m,
          v,
          O
        ), !0;
      case "pointerover":
        var R = O.pointerId;
        return Wu.set(
          R,
          _c(
            Wu.get(R) || null,
            l,
            u,
            m,
            v,
            O
          )
        ), !0;
      case "gotpointercapture":
        return R = O.pointerId, rl.set(
          R,
          _c(
            rl.get(R) || null,
            l,
            u,
            m,
            v,
            O
          )
        ), !0;
    }
    return !1;
  }
  function _y(l) {
    var u = Wt(l.target);
    if (u !== null) {
      var m = c(u);
      if (m !== null) {
        if (u = m.tag, u === 13) {
          if (u = d(m), u !== null) {
            l.blockedOn = u, gn(l.priority, function() {
              Vc(m);
            });
            return;
          }
        } else if (u === 31) {
          if (u = f(m), u !== null) {
            l.blockedOn = u, gn(l.priority, function() {
              Vc(m);
            });
            return;
          }
        } else if (u === 3 && m.stateNode.current.memoizedState.isDehydrated) {
          l.blockedOn = m.tag === 3 ? m.stateNode.containerInfo : null;
          return;
        }
      }
    }
    l.blockedOn = null;
  }
  function ph(l) {
    if (l.blockedOn !== null) return !1;
    for (var u = l.targetContainers; 0 < u.length; ) {
      var m = L2(l.nativeEvent);
      if (m === null) {
        m = l.nativeEvent;
        var v = new m.constructor(
          m.type,
          m
        );
        pi = v, m.target.dispatchEvent(v), pi = null;
      } else
        return u = en(m), u !== null && Vy(u), l.blockedOn = m, !1;
      u.shift();
    }
    return !0;
  }
  function pf(l, u, m) {
    ph(l) && m.delete(u);
  }
  function By() {
    hf = !1, La !== null && ph(La) && (La = null), mo !== null && ph(mo) && (mo = null), Po !== null && ph(Po) && (Po = null), Wu.forEach(pf), rl.forEach(pf);
  }
  function hs(l, u) {
    l.blockedOn === u && (l.blockedOn = null, hf || (hf = !0, e.unstable_scheduleCallback(
      e.unstable_NormalPriority,
      By
    )));
  }
  var gf = null;
  function Uy(l) {
    gf !== l && (gf = l, e.unstable_scheduleCallback(
      e.unstable_NormalPriority,
      function() {
        gf === l && (gf = null);
        for (var u = 0; u < l.length; u += 3) {
          var m = l[u], v = l[u + 1], O = l[u + 2];
          if (typeof v != "function") {
            if (mf(v || m) === null)
              continue;
            break;
          }
          var R = en(m);
          R !== null && (l.splice(u, 3), u -= 3, Ld(
            R,
            {
              pending: !0,
              data: O,
              method: m.method,
              action: v
            },
            v,
            O
          ));
        }
      }
    ));
  }
  function vf(l) {
    function u(ve) {
      return hs(ve, l);
    }
    La !== null && hs(La, l), mo !== null && hs(mo, l), Po !== null && hs(Po, l), Wu.forEach(u), rl.forEach(u);
    for (var m = 0; m < Xr.length; m++) {
      var v = Xr[m];
      v.blockedOn === l && (v.blockedOn = null);
    }
    for (; 0 < Xr.length && (m = Xr[0], m.blockedOn === null); )
      _y(m), m.blockedOn === null && Xr.shift();
    if (m = (l.ownerDocument || l).$$reactFormReplay, m != null)
      for (v = 0; v < m.length; v += 3) {
        var O = m[v], R = m[v + 1], B = O[Dt] || null;
        if (typeof R == "function")
          B || Uy(m);
        else if (B) {
          var re = null;
          if (R && R.hasAttribute("formAction")) {
            if (O = R, B = R[Dt] || null)
              re = B.formAction;
            else if (mf(O) !== null) continue;
          } else re = B.action;
          typeof re == "function" ? m[v + 1] = re : (m.splice(v, 3), v -= 3), Uy(m);
        }
      }
  }
  function H2() {
    function l(R) {
      R.canIntercept && R.info === "react-transition" && R.intercept({
        handler: function() {
          return new Promise(function(B) {
            return O = B;
          });
        },
        focusReset: "manual",
        scroll: "manual"
      });
    }
    function u() {
      O !== null && (O(), O = null), v || setTimeout(m, 20);
    }
    function m() {
      if (!v && !navigation.transition) {
        var R = navigation.currentEntry;
        R && R.url != null && navigation.navigate(R.url, {
          state: R.getState(),
          info: "react-transition",
          history: "replace"
        });
      }
    }
    if (typeof navigation == "object") {
      var v = !1, O = null;
      return navigation.addEventListener("navigate", l), navigation.addEventListener("navigatesuccess", u), navigation.addEventListener("navigateerror", u), setTimeout(m, 100), function() {
        v = !0, navigation.removeEventListener("navigate", l), navigation.removeEventListener("navigatesuccess", u), navigation.removeEventListener("navigateerror", u), O !== null && (O(), O = null);
      };
    }
  }
  function Vg(l) {
    this._internalRoot = l;
  }
  _g.prototype.render = Vg.prototype.render = function(l) {
    var u = this._internalRoot;
    if (u === null) throw Error(a(409));
    var m = u.current, v = ri();
    Wy(m, v, l, u, null, null);
  }, _g.prototype.unmount = Vg.prototype.unmount = function() {
    var l = this._internalRoot;
    if (l !== null) {
      this._internalRoot = null;
      var u = l.containerInfo;
      Wy(l.current, 2, null, l, null, null), Qd(), u[Yt] = null;
    }
  };
  function _g(l) {
    this._internalRoot = l;
  }
  _g.prototype.unstable_scheduleHydration = function(l) {
    if (l) {
      var u = yn();
      l = { blockedOn: null, target: l, priority: u };
      for (var m = 0; m < Xr.length && u !== 0 && u < Xr[m].priority; m++) ;
      Xr.splice(m, 0, l), m === 0 && _y(l);
    }
  };
  var F2 = t.version;
  if (F2 !== "19.2.4")
    throw Error(
      a(
        527,
        F2,
        "19.2.4"
      )
    );
  K.findDOMNode = function(l) {
    var u = l._reactInternals;
    if (u === void 0)
      throw typeof l.render == "function" ? Error(a(188)) : (l = Object.keys(l).join(","), Error(a(268, l)));
    return l = g(u), l = l !== null ? b(l) : null, l = l === null ? null : l.stateNode, l;
  };
  var Xy = {
    bundleType: 0,
    version: "19.2.4",
    rendererPackageName: "react-dom",
    currentDispatcherRef: H,
    reconcilerVersion: "19.2.4"
  };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var gh = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!gh.isDisabled && gh.supportsFiber)
      try {
        Ct = gh.inject(
          Xy
        ), ut = gh;
      } catch {
      }
  }
  return R5.createRoot = function(l, u) {
    if (!i(l)) throw Error(a(299));
    var m = !1, v = "", O = eg, R = Wv, B = tg;
    return u != null && (u.unstable_strictMode === !0 && (m = !0), u.identifierPrefix !== void 0 && (v = u.identifierPrefix), u.onUncaughtError !== void 0 && (O = u.onUncaughtError), u.onCaughtError !== void 0 && (R = u.onCaughtError), u.onRecoverableError !== void 0 && (B = u.onRecoverableError)), u = Hg(
      l,
      1,
      !1,
      null,
      null,
      m,
      v,
      null,
      O,
      R,
      B,
      H2
    ), l[Yt] = u.current, rf(l), new Vg(u);
  }, R5.hydrateRoot = function(l, u, m) {
    if (!i(l)) throw Error(a(299));
    var v = !1, O = "", R = eg, B = Wv, re = tg, ve = null;
    return m != null && (m.unstable_strictMode === !0 && (v = !0), m.identifierPrefix !== void 0 && (O = m.identifierPrefix), m.onUncaughtError !== void 0 && (R = m.onUncaughtError), m.onCaughtError !== void 0 && (B = m.onCaughtError), m.onRecoverableError !== void 0 && (re = m.onRecoverableError), m.formState !== void 0 && (ve = m.formState)), u = Hg(
      l,
      1,
      !0,
      u,
      m ?? null,
      v,
      O,
      ve,
      R,
      B,
      re,
      H2
    ), u.context = Wc(null), m = u.current, v = ri(), v = wt(v), O = Hs(v), O.callback = null, Ci(m, O, v), m = v, u.current.lanes = m, Ut(u, m), cs(u), l[Yt] = u.current, rf(l), new _g(u);
  }, R5.version = "19.2.4", R5;
}
var A5 = {};
/**
 * @license React
 * react-dom-client.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var RV;
function Hxe() {
  return RV || (RV = 1, process.env.NODE_ENV !== "production" && (function() {
    function e(n, o) {
      for (n = n.memoizedState; n !== null && 0 < o; )
        n = n.next, o--;
      return n;
    }
    function t(n, o, s, h) {
      if (s >= o.length) return h;
      var y = o[s], C = Ta(n) ? n.slice() : Rn({}, n);
      return C[y] = t(n[y], o, s + 1, h), C;
    }
    function r(n, o, s) {
      if (o.length !== s.length)
        console.warn("copyWithRename() expects paths of the same length");
      else {
        for (var h = 0; h < s.length - 1; h++)
          if (o[h] !== s[h]) {
            console.warn(
              "copyWithRename() expects paths to be the same except for the deepest key"
            );
            return;
          }
        return a(n, o, s, 0);
      }
    }
    function a(n, o, s, h) {
      var y = o[h], C = Ta(n) ? n.slice() : Rn({}, n);
      return h + 1 === o.length ? (C[s[h]] = C[y], Ta(C) ? C.splice(y, 1) : delete C[y]) : C[y] = a(
        n[y],
        o,
        s,
        h + 1
      ), C;
    }
    function i(n, o, s) {
      var h = o[s], y = Ta(n) ? n.slice() : Rn({}, n);
      return s + 1 === o.length ? (Ta(y) ? y.splice(h, 1) : delete y[h], y) : (y[h] = i(n[h], o, s + 1), y);
    }
    function c() {
      return !1;
    }
    function d() {
      return null;
    }
    function f() {
      console.error(
        "Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://react.dev/link/rules-of-hooks"
      );
    }
    function p() {
      console.error(
        "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."
      );
    }
    function g() {
    }
    function b() {
    }
    function w(n) {
      var o = [];
      return n.forEach(function(s) {
        o.push(s);
      }), o.sort().join(", ");
    }
    function x(n, o, s, h) {
      return new pC(n, o, s, h);
    }
    function E(n, o) {
      n.context === Sf && (Mg(n.current, 2, o, n, null, null), ki());
    }
    function P(n, o) {
      if (vs !== null) {
        var s = o.staleFamilies;
        o = o.updatedFamilies, Gm(), Ib(
          n.current,
          o,
          s
        ), ki();
      }
    }
    function k(n) {
      vs = n;
    }
    function M(n) {
      return !(!n || n.nodeType !== 1 && n.nodeType !== 9 && n.nodeType !== 11);
    }
    function T(n) {
      var o = n, s = n;
      if (n.alternate) for (; o.return; ) o = o.return;
      else {
        n = o;
        do
          o = n, (o.flags & 4098) !== 0 && (s = o.return), n = o.return;
        while (n);
      }
      return o.tag === 3 ? s : null;
    }
    function N(n) {
      if (n.tag === 13) {
        var o = n.memoizedState;
        if (o === null && (n = n.alternate, n !== null && (o = n.memoizedState)), o !== null) return o.dehydrated;
      }
      return null;
    }
    function D(n) {
      if (n.tag === 31) {
        var o = n.memoizedState;
        if (o === null && (n = n.alternate, n !== null && (o = n.memoizedState)), o !== null) return o.dehydrated;
      }
      return null;
    }
    function $(n) {
      if (T(n) !== n)
        throw Error("Unable to find node on an unmounted component.");
    }
    function j(n) {
      var o = n.alternate;
      if (!o) {
        if (o = T(n), o === null)
          throw Error("Unable to find node on an unmounted component.");
        return o !== n ? null : n;
      }
      for (var s = n, h = o; ; ) {
        var y = s.return;
        if (y === null) break;
        var C = y.alternate;
        if (C === null) {
          if (h = y.return, h !== null) {
            s = h;
            continue;
          }
          break;
        }
        if (y.child === C.child) {
          for (C = y.child; C; ) {
            if (C === s) return $(y), n;
            if (C === h) return $(y), o;
            C = C.sibling;
          }
          throw Error("Unable to find node on an unmounted component.");
        }
        if (s.return !== h.return) s = y, h = C;
        else {
          for (var A = !1, z = y.child; z; ) {
            if (z === s) {
              A = !0, s = y, h = C;
              break;
            }
            if (z === h) {
              A = !0, h = y, s = C;
              break;
            }
            z = z.sibling;
          }
          if (!A) {
            for (z = C.child; z; ) {
              if (z === s) {
                A = !0, s = C, h = y;
                break;
              }
              if (z === h) {
                A = !0, h = C, s = y;
                break;
              }
              z = z.sibling;
            }
            if (!A)
              throw Error(
                "Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue."
              );
          }
        }
        if (s.alternate !== h)
          throw Error(
            "Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue."
          );
      }
      if (s.tag !== 3)
        throw Error("Unable to find node on an unmounted component.");
      return s.stateNode.current === s ? n : o;
    }
    function I(n) {
      var o = n.tag;
      if (o === 5 || o === 26 || o === 27 || o === 6) return n;
      for (n = n.child; n !== null; ) {
        if (o = I(n), o !== null) return o;
        n = n.sibling;
      }
      return null;
    }
    function L(n) {
      return n === null || typeof n != "object" ? null : (n = Hy && n[Hy] || n["@@iterator"], typeof n == "function" ? n : null);
    }
    function F(n) {
      if (n == null) return null;
      if (typeof n == "function")
        return n.$$typeof === sf ? null : n.displayName || n.name || null;
      if (typeof n == "string") return n;
      switch (n) {
        case of:
          return "Fragment";
        case ch:
          return "Profiler";
        case Go:
          return "StrictMode";
        case Hc:
          return "Suspense";
        case ai:
          return "SuspenseList";
        case Dl:
          return "Activity";
      }
      if (typeof n == "object")
        switch (typeof n.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), n.$$typeof) {
          case Lu:
            return "Portal";
          case Nl:
            return n.displayName || "Context";
          case Ng:
            return (n._context.displayName || "Context") + ".Consumer";
          case lf:
            var o = n.render;
            return n = n.displayName, n || (n = o.displayName || o.name || "", n = n !== "" ? "ForwardRef(" + n + ")" : "ForwardRef"), n;
          case dh:
            return o = n.displayName || null, o !== null ? o : F(n.type) || "Memo";
          case Eo:
            o = n._payload, n = n._init;
            try {
              return F(n(o));
            } catch {
            }
        }
      return null;
    }
    function _(n) {
      return typeof n.tag == "number" ? W(n) : typeof n.name == "string" ? n.name : null;
    }
    function W(n) {
      var o = n.type;
      switch (n.tag) {
        case 31:
          return "Activity";
        case 24:
          return "Cache";
        case 9:
          return (o._context.displayName || "Context") + ".Consumer";
        case 10:
          return o.displayName || "Context";
        case 18:
          return "DehydratedFragment";
        case 11:
          return n = o.render, n = n.displayName || n.name || "", o.displayName || (n !== "" ? "ForwardRef(" + n + ")" : "ForwardRef");
        case 7:
          return "Fragment";
        case 26:
        case 27:
        case 5:
          return o;
        case 4:
          return "Portal";
        case 3:
          return "Root";
        case 6:
          return "Text";
        case 16:
          return F(o);
        case 8:
          return o === Go ? "StrictMode" : "Mode";
        case 22:
          return "Offscreen";
        case 12:
          return "Profiler";
        case 21:
          return "Scope";
        case 13:
          return "Suspense";
        case 19:
          return "SuspenseList";
        case 25:
          return "TracingMarker";
        case 1:
        case 0:
        case 14:
        case 15:
          if (typeof o == "function")
            return o.displayName || o.name || null;
          if (typeof o == "string") return o;
          break;
        case 29:
          if (o = n._debugInfo, o != null) {
            for (var s = o.length - 1; 0 <= s; s--)
              if (typeof o[s].name == "string") return o[s].name;
          }
          if (n.return !== null)
            return W(n.return);
      }
      return null;
    }
    function Q(n) {
      return { current: n };
    }
    function U(n, o) {
      0 > Ks ? console.error("Unexpected pop.") : (o !== A2[Ks] && console.error("Unexpected Fiber popped."), n.current = R2[Ks], R2[Ks] = null, A2[Ks] = null, Ks--);
    }
    function Y(n, o, s) {
      Ks++, R2[Ks] = n.current, A2[Ks] = s, n.current = o;
    }
    function G(n) {
      return n === null && console.error(
        "Expected host context to exist. This error is likely caused by a bug in React. Please file an issue."
      ), n;
    }
    function J(n, o) {
      Y(Oi, o, n), Y(uf, n, n), Y(Hu, null, n);
      var s = o.nodeType;
      switch (s) {
        case 9:
        case 11:
          s = s === 9 ? "#document" : "#fragment", o = (o = o.documentElement) && (o = o.namespaceURI) ? fy(o) : dd;
          break;
        default:
          if (s = o.tagName, o = o.namespaceURI)
            o = fy(o), o = Xs(
              o,
              s
            );
          else
            switch (s) {
              case "svg":
                o = y0;
                break;
              case "math":
                o = Iw;
                break;
              default:
                o = dd;
            }
      }
      s = s.toLowerCase(), s = Bi(null, s), s = {
        context: o,
        ancestorInfo: s
      }, U(Hu, n), Y(Hu, s, n);
    }
    function H(n) {
      U(Hu, n), U(uf, n), U(Oi, n);
    }
    function K() {
      return G(Hu.current);
    }
    function X(n) {
      n.memoizedState !== null && Y(Fu, n, n);
      var o = G(Hu.current), s = n.type, h = Xs(o.context, s);
      s = Bi(o.ancestorInfo, s), h = { context: h, ancestorInfo: s }, o !== h && (Y(uf, n, n), Y(Hu, h, n));
    }
    function te(n) {
      uf.current === n && (U(Hu, n), U(uf, n)), Fu.current === n && (U(Fu, n), T1._currentValue = Hh);
    }
    function ie() {
    }
    function ee() {
      if (cf === 0) {
        Fy = console.log, Fc = console.info, df = console.warn, N2 = console.error, fh = console.group, Dg = console.groupCollapsed, $g = console.groupEnd;
        var n = {
          configurable: !0,
          enumerable: !0,
          value: ie,
          writable: !0
        };
        Object.defineProperties(console, {
          info: n,
          log: n,
          warn: n,
          error: n,
          group: n,
          groupCollapsed: n,
          groupEnd: n
        });
      }
      cf++;
    }
    function ne() {
      if (cf--, cf === 0) {
        var n = { configurable: !0, enumerable: !0, writable: !0 };
        Object.defineProperties(console, {
          log: Rn({}, n, { value: Fy }),
          info: Rn({}, n, { value: Fc }),
          warn: Rn({}, n, { value: df }),
          error: Rn({}, n, { value: N2 }),
          group: Rn({}, n, { value: fh }),
          groupCollapsed: Rn({}, n, { value: Dg }),
          groupEnd: Rn({}, n, { value: $g })
        });
      }
      0 > cf && console.error(
        "disabledDepth fell below zero. This is a bug in React. Please file an issue."
      );
    }
    function ae(n) {
      var o = Error.prepareStackTrace;
      if (Error.prepareStackTrace = void 0, n = n.stack, Error.prepareStackTrace = o, n.startsWith(`Error: react-stack-top-frame
`) && (n = n.slice(29)), o = n.indexOf(`
`), o !== -1 && (n = n.slice(o + 1)), o = n.indexOf("react_stack_bottom_frame"), o !== -1 && (o = n.lastIndexOf(
        `
`,
        o
      )), o !== -1)
        n = n.slice(0, o);
      else return "";
      return n;
    }
    function oe(n) {
      if (ff === void 0)
        try {
          throw Error();
        } catch (s) {
          var o = s.stack.trim().match(/\n( *(at )?)/);
          ff = o && o[1] || "", D2 = -1 < s.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < s.stack.indexOf("@") ? "@unknown:0:0" : "";
        }
      return `
` + ff + n + D2;
    }
    function fe(n, o) {
      if (!n || zg) return "";
      var s = $2.get(n);
      if (s !== void 0) return s;
      zg = !0, s = Error.prepareStackTrace, Error.prepareStackTrace = void 0;
      var h = null;
      h = Xe.H, Xe.H = null, ee();
      try {
        var y = {
          DetermineComponentFrameRoot: function() {
            try {
              if (o) {
                var de = function() {
                  throw Error();
                };
                if (Object.defineProperty(de.prototype, "props", {
                  set: function() {
                    throw Error();
                  }
                }), typeof Reflect == "object" && Reflect.construct) {
                  try {
                    Reflect.construct(de, []);
                  } catch (yt) {
                    var Ve = yt;
                  }
                  Reflect.construct(n, [], de);
                } else {
                  try {
                    de.call();
                  } catch (yt) {
                    Ve = yt;
                  }
                  n.call(de.prototype);
                }
              } else {
                try {
                  throw Error();
                } catch (yt) {
                  Ve = yt;
                }
                (de = n()) && typeof de.catch == "function" && de.catch(function() {
                });
              }
            } catch (yt) {
              if (yt && Ve && typeof yt.stack == "string")
                return [yt.stack, Ve.stack];
            }
            return [null, null];
          }
        };
        y.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var C = Object.getOwnPropertyDescriptor(
          y.DetermineComponentFrameRoot,
          "name"
        );
        C && C.configurable && Object.defineProperty(
          y.DetermineComponentFrameRoot,
          "name",
          { value: "DetermineComponentFrameRoot" }
        );
        var A = y.DetermineComponentFrameRoot(), z = A[0], q = A[1];
        if (z && q) {
          var Z = z.split(`
`), xe = q.split(`
`);
          for (A = C = 0; C < Z.length && !Z[C].includes(
            "DetermineComponentFrameRoot"
          ); )
            C++;
          for (; A < xe.length && !xe[A].includes(
            "DetermineComponentFrameRoot"
          ); )
            A++;
          if (C === Z.length || A === xe.length)
            for (C = Z.length - 1, A = xe.length - 1; 1 <= C && 0 <= A && Z[C] !== xe[A]; )
              A--;
          for (; 1 <= C && 0 <= A; C--, A--)
            if (Z[C] !== xe[A]) {
              if (C !== 1 || A !== 1)
                do
                  if (C--, A--, 0 > A || Z[C] !== xe[A]) {
                    var ke = `
` + Z[C].replace(
                      " at new ",
                      " at "
                    );
                    return n.displayName && ke.includes("<anonymous>") && (ke = ke.replace("<anonymous>", n.displayName)), typeof n == "function" && $2.set(n, ke), ke;
                  }
                while (1 <= C && 0 <= A);
              break;
            }
        }
      } finally {
        zg = !1, Xe.H = h, ne(), Error.prepareStackTrace = s;
      }
      return Z = (Z = n ? n.displayName || n.name : "") ? oe(Z) : "", typeof n == "function" && $2.set(n, Z), Z;
    }
    function be(n, o) {
      switch (n.tag) {
        case 26:
        case 27:
        case 5:
          return oe(n.type);
        case 16:
          return oe("Lazy");
        case 13:
          return n.child !== o && o !== null ? oe("Suspense Fallback") : oe("Suspense");
        case 19:
          return oe("SuspenseList");
        case 0:
        case 15:
          return fe(n.type, !1);
        case 11:
          return fe(n.type.render, !1);
        case 1:
          return fe(n.type, !0);
        case 31:
          return oe("Activity");
        default:
          return "";
      }
    }
    function me(n) {
      try {
        var o = "", s = null;
        do {
          o += be(n, s);
          var h = n._debugInfo;
          if (h)
            for (var y = h.length - 1; 0 <= y; y--) {
              var C = h[y];
              if (typeof C.name == "string") {
                var A = o;
                e: {
                  var z = C.name, q = C.env, Z = C.debugLocation;
                  if (Z != null) {
                    var xe = ae(Z), ke = xe.lastIndexOf(`
`), de = ke === -1 ? xe : xe.slice(ke + 1);
                    if (de.indexOf(z) !== -1) {
                      var Ve = `
` + de;
                      break e;
                    }
                  }
                  Ve = oe(
                    z + (q ? " [" + q + "]" : "")
                  );
                }
                o = A + Ve;
              }
            }
          s = n, n = n.return;
        } while (n);
        return o;
      } catch (yt) {
        return `
Error generating stack: ` + yt.message + `
` + yt.stack;
      }
    }
    function De(n) {
      return (n = n ? n.displayName || n.name : "") ? oe(n) : "";
    }
    function Me() {
      if (oi === null) return null;
      var n = oi._debugOwner;
      return n != null ? _(n) : null;
    }
    function ze() {
      if (oi === null) return "";
      var n = oi;
      try {
        var o = "";
        switch (n.tag === 6 && (n = n.return), n.tag) {
          case 26:
          case 27:
          case 5:
            o += oe(n.type);
            break;
          case 13:
            o += oe("Suspense");
            break;
          case 19:
            o += oe("SuspenseList");
            break;
          case 31:
            o += oe("Activity");
            break;
          case 30:
          case 0:
          case 15:
          case 1:
            n._debugOwner || o !== "" || (o += De(
              n.type
            ));
            break;
          case 11:
            n._debugOwner || o !== "" || (o += De(
              n.type.render
            ));
        }
        for (; n; )
          if (typeof n.tag == "number") {
            var s = n;
            n = s._debugOwner;
            var h = s._debugStack;
            if (n && h) {
              var y = ae(h);
              y !== "" && (o += `
` + y);
            }
          } else if (n.debugStack != null) {
            var C = n.debugStack;
            (n = n.owner) && C && (o += `
` + ae(C));
          } else break;
        var A = o;
      } catch (z) {
        A = `
Error generating stack: ` + z.message + `
` + z.stack;
      }
      return A;
    }
    function le(n, o, s, h, y, C, A) {
      var z = oi;
      se(n);
      try {
        return n !== null && n._debugTask ? n._debugTask.run(
          o.bind(null, s, h, y, C, A)
        ) : o(s, h, y, C, A);
      } finally {
        se(z);
      }
      throw Error(
        "runWithFiberInDEV should never be called in production. This is a bug in React."
      );
    }
    function se(n) {
      Xe.getCurrentStack = n === null ? null : ze, ds = !1, oi = n;
    }
    function Ae(n) {
      return typeof Symbol == "function" && Symbol.toStringTag && n[Symbol.toStringTag] || n.constructor.name || "Object";
    }
    function we(n) {
      try {
        return Ne(n), !1;
      } catch {
        return !0;
      }
    }
    function Ne(n) {
      return "" + n;
    }
    function pe(n, o) {
      if (we(n))
        return console.error(
          "The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before using it here.",
          o,
          Ae(n)
        ), Ne(n);
    }
    function Qe(n, o) {
      if (we(n))
        return console.error(
          "The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before using it here.",
          o,
          Ae(n)
        ), Ne(n);
    }
    function Le(n) {
      if (we(n))
        return console.error(
          "Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before using it here.",
          Ae(n)
        ), Ne(n);
    }
    function Te(n) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u") return !1;
      var o = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (o.isDisabled) return !0;
      if (!o.supportsFiber)
        return console.error(
          "The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://react.dev/link/react-devtools"
        ), !0;
      try {
        Vc = o.inject(n), Ia = o;
      } catch (s) {
        console.error("React instrumentation encountered an error: %o.", s);
      }
      return !!o.checkDCE;
    }
    function Oe(n) {
      if (typeof I2 == "function" && Vy(n), Ia && typeof Ia.setStrictMode == "function")
        try {
          Ia.setStrictMode(Vc, n);
        } catch (o) {
          fs || (fs = !0, console.error(
            "React instrumentation encountered an error: %o",
            o
          ));
        }
    }
    function ye(n) {
      return n >>>= 0, n === 0 ? 32 : 31 - (L2(n) / Wg | 0) | 0;
    }
    function je(n) {
      var o = n & 42;
      if (o !== 0) return o;
      switch (n & -n) {
        case 1:
          return 1;
        case 2:
          return 2;
        case 4:
          return 4;
        case 8:
          return 8;
        case 16:
          return 16;
        case 32:
          return 32;
        case 64:
          return 64;
        case 128:
          return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
          return n & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return n & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
          return n & 62914560;
        case 67108864:
          return 67108864;
        case 134217728:
          return 134217728;
        case 268435456:
          return 268435456;
        case 536870912:
          return 536870912;
        case 1073741824:
          return 0;
        default:
          return console.error(
            "Should have found matching lanes. This is a bug in React."
          ), n;
      }
    }
    function Ue(n, o, s) {
      var h = n.pendingLanes;
      if (h === 0) return 0;
      var y = 0, C = n.suspendedLanes, A = n.pingedLanes;
      n = n.warmLanes;
      var z = h & 134217727;
      return z !== 0 ? (h = z & ~C, h !== 0 ? y = je(h) : (A &= z, A !== 0 ? y = je(A) : s || (s = z & ~n, s !== 0 && (y = je(s))))) : (z = h & ~C, z !== 0 ? y = je(z) : A !== 0 ? y = je(A) : s || (s = h & ~n, s !== 0 && (y = je(s)))), y === 0 ? 0 : o !== 0 && o !== y && (o & C) === 0 && (C = y & -y, s = o & -o, C >= s || C === 32 && (s & 4194048) !== 0) ? o : y;
    }
    function Fe(n, o) {
      return (n.pendingLanes & ~(n.suspendedLanes & ~n.pingedLanes) & o) === 0;
    }
    function tt(n, o) {
      switch (n) {
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
          return o + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return o + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
          return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
          return -1;
        default:
          return console.error(
            "Should have found matching lanes. This is a bug in React."
          ), -1;
      }
    }
    function dt() {
      var n = hf;
      return hf <<= 1, (hf & 62914560) === 0 && (hf = 4194304), n;
    }
    function St(n) {
      for (var o = [], s = 0; 31 > s; s++) o.push(n);
      return o;
    }
    function mt(n, o) {
      n.pendingLanes |= o, o !== 268435456 && (n.suspendedLanes = 0, n.pingedLanes = 0, n.warmLanes = 0);
    }
    function Ot(n, o, s, h, y, C) {
      var A = n.pendingLanes;
      n.pendingLanes = s, n.suspendedLanes = 0, n.pingedLanes = 0, n.warmLanes = 0, n.expiredLanes &= s, n.entangledLanes &= s, n.errorRecoveryDisabledLanes &= s, n.shellSuspendCounter = 0;
      var z = n.entanglements, q = n.expirationTimes, Z = n.hiddenUpdates;
      for (s = A & ~s; 0 < s; ) {
        var xe = 31 - fo(s), ke = 1 << xe;
        z[xe] = 0, q[xe] = -1;
        var de = Z[xe];
        if (de !== null)
          for (Z[xe] = null, xe = 0; xe < de.length; xe++) {
            var Ve = de[xe];
            Ve !== null && (Ve.lane &= -536870913);
          }
        s &= ~ke;
      }
      h !== 0 && Rt(n, h, 0), C !== 0 && y === 0 && n.tag !== 0 && (n.suspendedLanes |= C & ~(A & ~o));
    }
    function Rt(n, o, s) {
      n.pendingLanes |= o, n.suspendedLanes &= ~o;
      var h = 31 - fo(o);
      n.entangledLanes |= o, n.entanglements[h] = n.entanglements[h] | 1073741824 | s & 261930;
    }
    function ct(n, o) {
      var s = n.entangledLanes |= o;
      for (n = n.entanglements; s; ) {
        var h = 31 - fo(s), y = 1 << h;
        y & o | n[h] & o && (n[h] |= o), s &= ~y;
      }
    }
    function it(n, o) {
      var s = o & -o;
      return s = (s & 42) !== 0 ? 1 : Ct(s), (s & (n.suspendedLanes | o)) !== 0 ? 0 : s;
    }
    function Ct(n) {
      switch (n) {
        case 2:
          n = 1;
          break;
        case 8:
          n = 4;
          break;
        case 32:
          n = 16;
          break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
          n = 128;
          break;
        case 268435456:
          n = 134217728;
          break;
        default:
          n = 0;
      }
      return n;
    }
    function ut(n, o, s) {
      if (ms)
        for (n = n.pendingUpdatersLaneMap; 0 < s; ) {
          var h = 31 - fo(s), y = 1 << h;
          n[h].add(o), s &= ~y;
        }
    }
    function ht(n, o) {
      if (ms)
        for (var s = n.pendingUpdatersLaneMap, h = n.memoizedUpdaters; 0 < o; ) {
          var y = 31 - fo(o);
          n = 1 << y, y = s[y], 0 < y.size && (y.forEach(function(C) {
            var A = C.alternate;
            A !== null && h.has(A) || h.add(C);
          }), y.clear()), o &= ~n;
        }
    }
    function ot(n) {
      return n &= -n, La < n ? mo < n ? (n & 134217727) !== 0 ? Po : Wu : mo : La;
    }
    function at() {
      var n = fr.p;
      return n !== 0 ? n : (n = window.event, n === void 0 ? Po : Tg(n.type));
    }
    function ft(n, o) {
      var s = fr.p;
      try {
        return fr.p = n, o();
      } finally {
        fr.p = s;
      }
    }
    function st(n) {
      delete n[Xr], delete n[qo], delete n[_c], delete n[xC], delete n[_y];
    }
    function pt(n) {
      var o = n[Xr];
      if (o) return o;
      for (var s = n.parentNode; s; ) {
        if (o = s[Ys] || s[Xr]) {
          if (s = o.alternate, o.child !== null || s !== null && s.child !== null)
            for (n = zc(n); n !== null; ) {
              if (s = n[Xr])
                return s;
              n = zc(n);
            }
          return o;
        }
        n = s, s = n.parentNode;
      }
      return null;
    }
    function bt(n) {
      if (n = n[Xr] || n[Ys]) {
        var o = n.tag;
        if (o === 5 || o === 6 || o === 13 || o === 31 || o === 26 || o === 27 || o === 3)
          return n;
      }
      return null;
    }
    function Nt(n) {
      var o = n.tag;
      if (o === 5 || o === 26 || o === 27 || o === 6)
        return n.stateNode;
      throw Error("getNodeFromInstance: Invalid argument.");
    }
    function $t(n) {
      var o = n[ph];
      return o || (o = n[ph] = { hoistableStyles: /* @__PURE__ */ new Map(), hoistableScripts: /* @__PURE__ */ new Map() }), o;
    }
    function Pt(n) {
      n[pf] = !0;
    }
    function hn(n, o) {
      an(n, o), an(n + "Capture", o);
    }
    function an(n, o) {
      hs[n] && console.error(
        "EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.",
        n
      ), hs[n] = o;
      var s = n.toLowerCase();
      for (gf[s] = n, n === "onDoubleClick" && (gf.ondblclick = n), n = 0; n < o.length; n++)
        By.add(o[n]);
    }
    function jn(n, o) {
      Uy[o.type] || o.onChange || o.onInput || o.readOnly || o.disabled || o.value == null || console.error(
        n === "select" ? "You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set `onChange`." : "You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."
      ), o.onChange || o.readOnly || o.disabled || o.checked == null || console.error(
        "You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`."
      );
    }
    function xn(n) {
      return Ti.call(Vg, n) ? !0 : Ti.call(H2, n) ? !1 : vf.test(n) ? Vg[n] = !0 : (H2[n] = !0, console.error("Invalid attribute name: `%s`", n), !1);
    }
    function Ut(n, o, s) {
      if (xn(o)) {
        if (!n.hasAttribute(o)) {
          switch (typeof s) {
            case "symbol":
            case "object":
              return s;
            case "function":
              return s;
            case "boolean":
              if (s === !1) return s;
          }
          return s === void 0 ? void 0 : null;
        }
        return n = n.getAttribute(o), n === "" && s === !0 ? !0 : (pe(s, o), n === "" + s ? s : n);
      }
    }
    function pn(n, o, s) {
      if (xn(o))
        if (s === null) n.removeAttribute(o);
        else {
          switch (typeof s) {
            case "undefined":
            case "function":
            case "symbol":
              n.removeAttribute(o);
              return;
            case "boolean":
              var h = o.toLowerCase().slice(0, 5);
              if (h !== "data-" && h !== "aria-") {
                n.removeAttribute(o);
                return;
              }
          }
          pe(s, o), n.setAttribute(o, "" + s);
        }
    }
    function wn(n, o, s) {
      if (s === null) n.removeAttribute(o);
      else {
        switch (typeof s) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            n.removeAttribute(o);
            return;
        }
        pe(s, o), n.setAttribute(o, "" + s);
      }
    }
    function Lt(n, o, s, h) {
      if (h === null) n.removeAttribute(s);
      else {
        switch (typeof h) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            n.removeAttribute(s);
            return;
        }
        pe(h, s), n.setAttributeNS(o, s, "" + h);
      }
    }
    function gt(n) {
      switch (typeof n) {
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return n;
        case "object":
          return Le(n), n;
        default:
          return "";
      }
    }
    function wt(n) {
      var o = n.type;
      return (n = n.nodeName) && n.toLowerCase() === "input" && (o === "checkbox" || o === "radio");
    }
    function Ft(n, o, s) {
      var h = Object.getOwnPropertyDescriptor(
        n.constructor.prototype,
        o
      );
      if (!n.hasOwnProperty(o) && typeof h < "u" && typeof h.get == "function" && typeof h.set == "function") {
        var y = h.get, C = h.set;
        return Object.defineProperty(n, o, {
          configurable: !0,
          get: function() {
            return y.call(this);
          },
          set: function(A) {
            Le(A), s = "" + A, C.call(this, A);
          }
        }), Object.defineProperty(n, o, {
          enumerable: h.enumerable
        }), {
          getValue: function() {
            return s;
          },
          setValue: function(A) {
            Le(A), s = "" + A;
          },
          stopTracking: function() {
            n._valueTracker = null, delete n[o];
          }
        };
      }
    }
    function yn(n) {
      if (!n._valueTracker) {
        var o = wt(n) ? "checked" : "value";
        n._valueTracker = Ft(
          n,
          o,
          "" + n[o]
        );
      }
    }
    function gn(n) {
      if (!n) return !1;
      var o = n._valueTracker;
      if (!o) return !0;
      var s = o.getValue(), h = "";
      return n && (h = wt(n) ? n.checked ? "true" : "false" : n.value), n = h, n !== s ? (o.setValue(n), !0) : !1;
    }
    function Tn(n) {
      if (n = n || (typeof document < "u" ? document : void 0), typeof n > "u") return null;
      try {
        return n.activeElement || n.body;
      } catch {
        return n.body;
      }
    }
    function Gt(n) {
      return n.replace(
        _g,
        function(o) {
          return "\\" + o.charCodeAt(0).toString(16) + " ";
        }
      );
    }
    function Dt(n, o) {
      o.checked === void 0 || o.defaultChecked === void 0 || Xy || (console.error(
        "%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components",
        Me() || "A component",
        o.type
      ), Xy = !0), o.value === void 0 || o.defaultValue === void 0 || F2 || (console.error(
        "%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components",
        Me() || "A component",
        o.type
      ), F2 = !0);
    }
    function Yt(n, o, s, h, y, C, A, z) {
      n.name = "", A != null && typeof A != "function" && typeof A != "symbol" && typeof A != "boolean" ? (pe(A, "type"), n.type = A) : n.removeAttribute("type"), o != null ? A === "number" ? (o === 0 && n.value === "" || n.value != o) && (n.value = "" + gt(o)) : n.value !== "" + gt(o) && (n.value = "" + gt(o)) : A !== "submit" && A !== "reset" || n.removeAttribute("value"), o != null ? Gn(n, A, gt(o)) : s != null ? Gn(n, A, gt(s)) : h != null && n.removeAttribute("value"), y == null && C != null && (n.defaultChecked = !!C), y != null && (n.checked = y && typeof y != "function" && typeof y != "symbol"), z != null && typeof z != "function" && typeof z != "symbol" && typeof z != "boolean" ? (pe(z, "name"), n.name = "" + gt(z)) : n.removeAttribute("name");
    }
    function Mn(n, o, s, h, y, C, A, z) {
      if (C != null && typeof C != "function" && typeof C != "symbol" && typeof C != "boolean" && (pe(C, "type"), n.type = C), o != null || s != null) {
        if (!(C !== "submit" && C !== "reset" || o != null)) {
          yn(n);
          return;
        }
        s = s != null ? "" + gt(s) : "", o = o != null ? "" + gt(o) : s, z || o === n.value || (n.value = o), n.defaultValue = o;
      }
      h = h ?? y, h = typeof h != "function" && typeof h != "symbol" && !!h, n.checked = z ? n.checked : !!h, n.defaultChecked = !!h, A != null && typeof A != "function" && typeof A != "symbol" && typeof A != "boolean" && (pe(A, "name"), n.name = A), yn(n);
    }
    function Gn(n, o, s) {
      o === "number" && Tn(n.ownerDocument) === n || n.defaultValue === "" + s || (n.defaultValue = "" + s);
    }
    function wr(n, o) {
      o.value == null && (typeof o.children == "object" && o.children !== null ? uh.Children.forEach(o.children, function(s) {
        s == null || typeof s == "string" || typeof s == "number" || typeof s == "bigint" || l || (l = !0, console.error(
          "Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>."
        ));
      }) : o.dangerouslySetInnerHTML == null || u || (u = !0, console.error(
        "Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected."
      ))), o.selected == null || gh || (console.error(
        "Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."
      ), gh = !0);
    }
    function aa() {
      var n = Me();
      return n ? `

Check the render method of \`` + n + "`." : "";
    }
    function qn(n, o, s, h) {
      if (n = n.options, o) {
        o = {};
        for (var y = 0; y < s.length; y++)
          o["$" + s[y]] = !0;
        for (s = 0; s < n.length; s++)
          y = o.hasOwnProperty("$" + n[s].value), n[s].selected !== y && (n[s].selected = y), y && h && (n[s].defaultSelected = !0);
      } else {
        for (s = "" + gt(s), o = null, y = 0; y < n.length; y++) {
          if (n[y].value === s) {
            n[y].selected = !0, h && (n[y].defaultSelected = !0);
            return;
          }
          o !== null || n[y].disabled || (o = n[y]);
        }
        o !== null && (o.selected = !0);
      }
    }
    function Rr(n, o) {
      for (n = 0; n < v.length; n++) {
        var s = v[n];
        if (o[s] != null) {
          var h = Ta(o[s]);
          o.multiple && !h ? console.error(
            "The `%s` prop supplied to <select> must be an array if `multiple` is true.%s",
            s,
            aa()
          ) : !o.multiple && h && console.error(
            "The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s",
            s,
            aa()
          );
        }
      }
      o.value === void 0 || o.defaultValue === void 0 || m || (console.error(
        "Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://react.dev/link/controlled-components"
      ), m = !0);
    }
    function Wt(n, o) {
      o.value === void 0 || o.defaultValue === void 0 || O || (console.error(
        "%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://react.dev/link/controlled-components",
        Me() || "A component"
      ), O = !0), o.children != null && o.value == null && console.error(
        "Use the `defaultValue` or `value` props instead of setting children on <textarea>."
      );
    }
    function en(n, o, s) {
      if (o != null && (o = "" + gt(o), o !== n.value && (n.value = o), s == null)) {
        n.defaultValue !== o && (n.defaultValue = o);
        return;
      }
      n.defaultValue = s != null ? "" + gt(s) : "";
    }
    function Xt(n, o, s, h) {
      if (o == null) {
        if (h != null) {
          if (s != null)
            throw Error(
              "If you supply `defaultValue` on a <textarea>, do not pass children."
            );
          if (Ta(h)) {
            if (1 < h.length)
              throw Error("<textarea> can only have at most one child.");
            h = h[0];
          }
          s = h;
        }
        s == null && (s = ""), o = s;
      }
      s = gt(o), n.defaultValue = s, h = n.textContent, h === s && h !== "" && h !== null && (n.value = h), yn(n);
    }
    function zt(n, o) {
      return n.serverProps === void 0 && n.serverTail.length === 0 && n.children.length === 1 && 3 < n.distanceFromLeaf && n.distanceFromLeaf > 15 - o ? zt(n.children[0], o) : n;
    }
    function kt(n) {
      return "  " + "  ".repeat(n);
    }
    function Qn(n) {
      return "+ " + "  ".repeat(n);
    }
    function Jn(n) {
      return "- " + "  ".repeat(n);
    }
    function Nr(n) {
      switch (n.tag) {
        case 26:
        case 27:
        case 5:
          return n.type;
        case 16:
          return "Lazy";
        case 31:
          return "Activity";
        case 13:
          return "Suspense";
        case 19:
          return "SuspenseList";
        case 0:
        case 15:
          return n = n.type, n.displayName || n.name || null;
        case 11:
          return n = n.type.render, n.displayName || n.name || null;
        case 1:
          return n = n.type, n.displayName || n.name || null;
        default:
          return null;
      }
    }
    function Hr(n, o) {
      return R.test(n) ? (n = JSON.stringify(n), n.length > o - 2 ? 8 > o ? '{"..."}' : "{" + n.slice(0, o - 7) + '..."}' : "{" + n + "}") : n.length > o ? 5 > o ? '{"..."}' : n.slice(0, o - 3) + "..." : n;
    }
    function oa(n, o, s) {
      var h = 120 - 2 * s;
      if (o === null)
        return Qn(s) + Hr(n, h) + `
`;
      if (typeof o == "string") {
        for (var y = 0; y < o.length && y < n.length && o.charCodeAt(y) === n.charCodeAt(y); y++) ;
        return y > h - 8 && 10 < y && (n = "..." + n.slice(y - 8), o = "..." + o.slice(y - 8)), Qn(s) + Hr(n, h) + `
` + Jn(s) + Hr(o, h) + `
`;
      }
      return kt(s) + Hr(n, h) + `
`;
    }
    function dn(n) {
      return Object.prototype.toString.call(n).replace(/^\[object (.*)\]$/, function(o, s) {
        return s;
      });
    }
    function Un(n, o) {
      switch (typeof n) {
        case "string":
          return n = JSON.stringify(n), n.length > o ? 5 > o ? '"..."' : n.slice(0, o - 4) + '..."' : n;
        case "object":
          if (n === null) return "null";
          if (Ta(n)) return "[...]";
          if (n.$$typeof === nl)
            return (o = F(n.type)) ? "<" + o + ">" : "<...>";
          var s = dn(n);
          if (s === "Object") {
            s = "", o -= 2;
            for (var h in n)
              if (n.hasOwnProperty(h)) {
                var y = JSON.stringify(h);
                if (y !== '"' + h + '"' && (h = y), o -= h.length - 2, y = Un(
                  n[h],
                  15 > o ? o : 15
                ), o -= y.length, 0 > o) {
                  s += s === "" ? "..." : ", ...";
                  break;
                }
                s += (s === "" ? "" : ",") + h + ":" + y;
              }
            return "{" + s + "}";
          }
          return s;
        case "function":
          return (o = n.displayName || n.name) ? "function " + o : "function";
        default:
          return String(n);
      }
    }
    function sr(n, o) {
      return typeof n != "string" || R.test(n) ? "{" + Un(n, o - 2) + "}" : n.length > o - 2 ? 5 > o ? '"..."' : '"' + n.slice(0, o - 5) + '..."' : '"' + n + '"';
    }
    function Yr(n, o, s) {
      var h = 120 - s.length - n.length, y = [], C;
      for (C in o)
        if (o.hasOwnProperty(C) && C !== "children") {
          var A = sr(
            o[C],
            120 - s.length - C.length - 1
          );
          h -= C.length + A.length + 2, y.push(C + "=" + A);
        }
      return y.length === 0 ? s + "<" + n + `>
` : 0 < h ? s + "<" + n + " " + y.join(" ") + `>
` : s + "<" + n + `
` + s + "  " + y.join(`
` + s + "  ") + `
` + s + `>
`;
    }
    function Wa(n, o, s) {
      var h = "", y = Rn({}, o), C;
      for (C in n)
        if (n.hasOwnProperty(C)) {
          delete y[C];
          var A = 120 - 2 * s - C.length - 2, z = Un(n[C], A);
          o.hasOwnProperty(C) ? (A = Un(o[C], A), h += Qn(s) + C + ": " + z + `
`, h += Jn(s) + C + ": " + A + `
`) : h += Qn(s) + C + ": " + z + `
`;
        }
      for (var q in y)
        y.hasOwnProperty(q) && (n = Un(
          y[q],
          120 - 2 * s - q.length - 2
        ), h += Jn(s) + q + ": " + n + `
`);
      return h;
    }
    function pa(n, o, s, h) {
      var y = "", C = /* @__PURE__ */ new Map();
      for (Z in s)
        s.hasOwnProperty(Z) && C.set(
          Z.toLowerCase(),
          Z
        );
      if (C.size === 1 && C.has("children"))
        y += Yr(
          n,
          o,
          kt(h)
        );
      else {
        for (var A in o)
          if (o.hasOwnProperty(A) && A !== "children") {
            var z = 120 - 2 * (h + 1) - A.length - 1, q = C.get(A.toLowerCase());
            if (q !== void 0) {
              C.delete(A.toLowerCase());
              var Z = o[A];
              q = s[q];
              var xe = sr(
                Z,
                z
              );
              z = sr(
                q,
                z
              ), typeof Z == "object" && Z !== null && typeof q == "object" && q !== null && dn(Z) === "Object" && dn(q) === "Object" && (2 < Object.keys(Z).length || 2 < Object.keys(q).length || -1 < xe.indexOf("...") || -1 < z.indexOf("...")) ? y += kt(h + 1) + A + `={{
` + Wa(
                Z,
                q,
                h + 2
              ) + kt(h + 1) + `}}
` : (y += Qn(h + 1) + A + "=" + xe + `
`, y += Jn(h + 1) + A + "=" + z + `
`);
            } else
              y += kt(h + 1) + A + "=" + sr(o[A], z) + `
`;
          }
        C.forEach(function(ke) {
          if (ke !== "children") {
            var de = 120 - 2 * (h + 1) - ke.length - 1;
            y += Jn(h + 1) + ke + "=" + sr(s[ke], de) + `
`;
          }
        }), y = y === "" ? kt(h) + "<" + n + `>
` : kt(h) + "<" + n + `
` + y + kt(h) + `>
`;
      }
      return n = s.children, o = o.children, typeof n == "string" || typeof n == "number" || typeof n == "bigint" ? (C = "", (typeof o == "string" || typeof o == "number" || typeof o == "bigint") && (C = "" + o), y += oa(C, "" + n, h + 1)) : (typeof o == "string" || typeof o == "number" || typeof o == "bigint") && (y = n == null ? y + oa("" + o, null, h + 1) : y + oa("" + o, void 0, h + 1)), y;
    }
    function Jr(n, o) {
      var s = Nr(n);
      if (s === null) {
        for (s = "", n = n.child; n; )
          s += Jr(n, o), n = n.sibling;
        return s;
      }
      return kt(o) + "<" + s + `>
`;
    }
    function si(n, o) {
      var s = zt(n, o);
      if (s !== n && (n.children.length !== 1 || n.children[0] !== s))
        return kt(o) + `...
` + si(s, o + 1);
      s = "";
      var h = n.fiber._debugInfo;
      if (h)
        for (var y = 0; y < h.length; y++) {
          var C = h[y].name;
          typeof C == "string" && (s += kt(o) + "<" + C + `>
`, o++);
        }
      if (h = "", y = n.fiber.pendingProps, n.fiber.tag === 6)
        h = oa(y, n.serverProps, o), o++;
      else if (C = Nr(n.fiber), C !== null)
        if (n.serverProps === void 0) {
          h = o;
          var A = 120 - 2 * h - C.length - 2, z = "";
          for (Z in y)
            if (y.hasOwnProperty(Z) && Z !== "children") {
              var q = sr(y[Z], 15);
              if (A -= Z.length + q.length + 2, 0 > A) {
                z += " ...";
                break;
              }
              z += " " + Z + "=" + q;
            }
          h = kt(h) + "<" + C + z + `>
`, o++;
        } else
          n.serverProps === null ? (h = Yr(
            C,
            y,
            Qn(o)
          ), o++) : typeof n.serverProps == "string" ? console.error(
            "Should not have matched a non HostText fiber to a Text node. This is a bug in React."
          ) : (h = pa(
            C,
            y,
            n.serverProps,
            o
          ), o++);
      var Z = "";
      for (y = n.fiber.child, C = 0; y && C < n.children.length; )
        A = n.children[C], A.fiber === y ? (Z += si(A, o), C++) : Z += Jr(y, o), y = y.sibling;
      for (y && 0 < n.children.length && (Z += kt(o) + `...
`), y = n.serverTail, n.serverProps === null && o--, n = 0; n < y.length; n++)
        C = y[n], Z = typeof C == "string" ? Z + (Jn(o) + Hr(C, 120 - 2 * o) + `
`) : Z + Yr(
          C.type,
          C.props,
          Jn(o)
        );
      return s + h + Z;
    }
    function mi(n) {
      try {
        return `

` + si(n, 0);
      } catch {
        return "";
      }
    }
    function Yo(n, o, s) {
      for (var h = o, y = null, C = 0; h; )
        h === n && (C = 0), y = {
          fiber: h,
          children: y !== null ? [y] : [],
          serverProps: h === o ? s : h === n ? null : void 0,
          serverTail: [],
          distanceFromLeaf: C
        }, C++, h = h.return;
      return y !== null ? mi(y).replaceAll(/^[+-]/gm, ">") : "";
    }
    function Bi(n, o) {
      var s = Rn({}, n || Je), h = { tag: o };
      return re.indexOf(o) !== -1 && (s.aTagInScope = null, s.buttonTagInScope = null, s.nobrTagInScope = null), ve.indexOf(o) !== -1 && (s.pTagInButtonScope = null), B.indexOf(o) !== -1 && o !== "address" && o !== "div" && o !== "p" && (s.listItemTagAutoclosing = null, s.dlItemTagAutoclosing = null), s.current = h, o === "form" && (s.formTag = h), o === "a" && (s.aTagInScope = h), o === "button" && (s.buttonTagInScope = h), o === "nobr" && (s.nobrTagInScope = h), o === "p" && (s.pTagInButtonScope = h), o === "li" && (s.listItemTagAutoclosing = h), (o === "dd" || o === "dt") && (s.dlItemTagAutoclosing = h), o === "#document" || o === "html" ? s.containerTagInScope = null : s.containerTagInScope || (s.containerTagInScope = h), n !== null || o !== "#document" && o !== "html" && o !== "body" ? s.implicitRootScope === !0 && (s.implicitRootScope = !1) : s.implicitRootScope = !0, s;
    }
    function hr(n, o, s) {
      switch (o) {
        case "select":
          return n === "hr" || n === "option" || n === "optgroup" || n === "script" || n === "template" || n === "#text";
        case "optgroup":
          return n === "option" || n === "#text";
        case "option":
          return n === "#text";
        case "tr":
          return n === "th" || n === "td" || n === "style" || n === "script" || n === "template";
        case "tbody":
        case "thead":
        case "tfoot":
          return n === "tr" || n === "style" || n === "script" || n === "template";
        case "colgroup":
          return n === "col" || n === "template";
        case "table":
          return n === "caption" || n === "colgroup" || n === "tbody" || n === "tfoot" || n === "thead" || n === "style" || n === "script" || n === "template";
        case "head":
          return n === "base" || n === "basefont" || n === "bgsound" || n === "link" || n === "meta" || n === "title" || n === "noscript" || n === "noframes" || n === "style" || n === "script" || n === "template";
        case "html":
          if (s) break;
          return n === "head" || n === "body" || n === "frameset";
        case "frameset":
          return n === "frame";
        case "#document":
          if (!s) return n === "html";
      }
      switch (n) {
        case "h1":
        case "h2":
        case "h3":
        case "h4":
        case "h5":
        case "h6":
          return o !== "h1" && o !== "h2" && o !== "h3" && o !== "h4" && o !== "h5" && o !== "h6";
        case "rp":
        case "rt":
          return He.indexOf(o) === -1;
        case "caption":
        case "col":
        case "colgroup":
        case "frameset":
        case "frame":
        case "tbody":
        case "td":
        case "tfoot":
        case "th":
        case "thead":
        case "tr":
          return o == null;
        case "head":
          return s || o === null;
        case "html":
          return s && o === "#document" || o === null;
        case "body":
          return s && (o === "#document" || o === "html") || o === null;
      }
      return !0;
    }
    function zn(n, o) {
      switch (n) {
        case "address":
        case "article":
        case "aside":
        case "blockquote":
        case "center":
        case "details":
        case "dialog":
        case "dir":
        case "div":
        case "dl":
        case "fieldset":
        case "figcaption":
        case "figure":
        case "footer":
        case "header":
        case "hgroup":
        case "main":
        case "menu":
        case "nav":
        case "ol":
        case "p":
        case "section":
        case "summary":
        case "ul":
        case "pre":
        case "listing":
        case "table":
        case "hr":
        case "xmp":
        case "h1":
        case "h2":
        case "h3":
        case "h4":
        case "h5":
        case "h6":
          return o.pTagInButtonScope;
        case "form":
          return o.formTag || o.pTagInButtonScope;
        case "li":
          return o.listItemTagAutoclosing;
        case "dd":
        case "dt":
          return o.dlItemTagAutoclosing;
        case "button":
          return o.buttonTagInScope;
        case "a":
          return o.aTagInScope;
        case "nobr":
          return o.nobrTagInScope;
      }
      return null;
    }
    function On(n, o) {
      for (; n; ) {
        switch (n.tag) {
          case 5:
          case 26:
          case 27:
            if (n.type === o) return n;
        }
        n = n.return;
      }
      return null;
    }
    function Qt(n, o) {
      o = o || Je;
      var s = o.current;
      if (o = (s = hr(
        n,
        s && s.tag,
        o.implicitRootScope
      ) ? null : s) ? null : zn(n, o), o = s || o, !o) return !0;
      var h = o.tag;
      if (o = String(!!s) + "|" + n + "|" + h, nt[o]) return !1;
      nt[o] = !0;
      var y = (o = oi) ? On(o.return, h) : null, C = o !== null && y !== null ? Yo(y, o, null) : "", A = "<" + n + ">";
      return s ? (s = "", h === "table" && n === "tr" && (s += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), console.error(
        `In HTML, %s cannot be a child of <%s>.%s
This will cause a hydration error.%s`,
        A,
        h,
        s,
        C
      )) : console.error(
        `In HTML, %s cannot be a descendant of <%s>.
This will cause a hydration error.%s`,
        A,
        h,
        C
      ), o && (n = o.return, y === null || n === null || y === n && n._debugOwner === o._debugOwner || le(y, function() {
        console.error(
          `<%s> cannot contain a nested %s.
See this log for the ancestor stack trace.`,
          h,
          A
        );
      })), !1;
    }
    function nn(n, o, s) {
      if (s || hr("#text", o, !1))
        return !0;
      if (s = "#text|" + o, nt[s]) return !1;
      nt[s] = !0;
      var h = (s = oi) ? On(s, o) : null;
      return s = s !== null && h !== null ? Yo(
        h,
        s,
        s.tag !== 6 ? { children: null } : null
      ) : "", /\S/.test(n) ? console.error(
        `In HTML, text nodes cannot be a child of <%s>.
This will cause a hydration error.%s`,
        o,
        s
      ) : console.error(
        `In HTML, whitespace text nodes cannot be a child of <%s>. Make sure you don't have any extra whitespace between tags on each line of your source code.
This will cause a hydration error.%s`,
        o,
        s
      ), !1;
    }
    function er(n, o) {
      if (o) {
        var s = n.firstChild;
        if (s && s === n.lastChild && s.nodeType === 3) {
          s.nodeValue = o;
          return;
        }
      }
      n.textContent = o;
    }
    function ia(n) {
      return n.replace($e, function(o, s) {
        return s.toUpperCase();
      });
    }
    function so(n, o, s) {
      var h = o.indexOf("--") === 0;
      h || (-1 < o.indexOf("-") ? Ie.hasOwnProperty(o) && Ie[o] || (Ie[o] = !0, console.error(
        "Unsupported style property %s. Did you mean %s?",
        o,
        ia(o.replace(Or, "ms-"))
      )) : Zt.test(o) ? Ie.hasOwnProperty(o) && Ie[o] || (Ie[o] = !0, console.error(
        "Unsupported vendor-prefixed style property %s. Did you mean %s?",
        o,
        o.charAt(0).toUpperCase() + o.slice(1)
      )) : !Pe.test(s) || et.hasOwnProperty(s) && et[s] || (et[s] = !0, console.error(
        `Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`,
        o,
        s.replace(Pe, "")
      )), typeof s == "number" && (isNaN(s) ? Vt || (Vt = !0, console.error(
        "`NaN` is an invalid value for the `%s` css style property.",
        o
      )) : isFinite(s) || rr || (rr = !0, console.error(
        "`Infinity` is an invalid value for the `%s` css style property.",
        o
      )))), s == null || typeof s == "boolean" || s === "" ? h ? n.setProperty(o, "") : o === "float" ? n.cssFloat = "" : n[o] = "" : h ? n.setProperty(o, s) : typeof s != "number" || s === 0 || jt.has(o) ? o === "float" ? n.cssFloat = s : (Qe(s, o), n[o] = ("" + s).trim()) : n[o] = s + "px";
    }
    function hi(n, o, s) {
      if (o != null && typeof o != "object")
        throw Error(
          "The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX."
        );
      if (o && Object.freeze(o), n = n.style, s != null) {
        if (o) {
          var h = {};
          if (s) {
            for (var y in s)
              if (s.hasOwnProperty(y) && !o.hasOwnProperty(y))
                for (var C = We[y] || [y], A = 0; A < C.length; A++)
                  h[C[A]] = y;
          }
          for (var z in o)
            if (o.hasOwnProperty(z) && (!s || s[z] !== o[z]))
              for (y = We[z] || [z], C = 0; C < y.length; C++)
                h[y[C]] = z;
          z = {};
          for (var q in o)
            for (y = We[q] || [q], C = 0; C < y.length; C++)
              z[y[C]] = q;
          q = {};
          for (var Z in h)
            if (y = h[Z], (C = z[Z]) && y !== C && (A = y + "," + C, !q[A])) {
              q[A] = !0, A = console;
              var xe = o[y];
              A.error.call(
                A,
                "%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.",
                xe == null || typeof xe == "boolean" || xe === "" ? "Removing" : "Updating",
                y,
                C
              );
            }
        }
        for (var ke in s)
          !s.hasOwnProperty(ke) || o != null && o.hasOwnProperty(ke) || (ke.indexOf("--") === 0 ? n.setProperty(ke, "") : ke === "float" ? n.cssFloat = "" : n[ke] = "");
        for (var de in o)
          Z = o[de], o.hasOwnProperty(de) && s[de] !== Z && so(n, de, Z);
      } else
        for (h in o)
          o.hasOwnProperty(h) && so(n, h, o[h]);
    }
    function ka(n) {
      if (n.indexOf("-") === -1) return !1;
      switch (n) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    function Ui(n) {
      return lr.get(n) || n;
    }
    function sl(n, o) {
      if (Ti.call(Bg, o) && Bg[o])
        return !0;
      if (dO.test(o)) {
        if (n = "aria-" + o.slice(4).toLowerCase(), n = Gy.hasOwnProperty(n) ? n : null, n == null)
          return console.error(
            "Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.",
            o
          ), Bg[o] = !0;
        if (o !== n)
          return console.error(
            "Invalid ARIA attribute `%s`. Did you mean `%s`?",
            o,
            n
          ), Bg[o] = !0;
      }
      if (cO.test(o)) {
        if (n = o.toLowerCase(), n = Gy.hasOwnProperty(n) ? n : null, n == null) return Bg[o] = !0, !1;
        o !== n && (console.error(
          "Unknown ARIA attribute `%s`. Did you mean `%s`?",
          o,
          n
        ), Bg[o] = !0);
      }
      return !0;
    }
    function qt(n, o) {
      var s = [], h;
      for (h in o)
        sl(n, h) || s.push(h);
      o = s.map(function(y) {
        return "`" + y + "`";
      }).join(", "), s.length === 1 ? console.error(
        "Invalid aria prop %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props",
        o,
        n
      ) : 1 < s.length && console.error(
        "Invalid aria props %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props",
        o,
        n
      );
    }
    function Kt(n, o, s, h) {
      if (Ti.call(Ri, o) && Ri[o])
        return !0;
      var y = o.toLowerCase();
      if (y === "onfocusin" || y === "onfocusout")
        return console.error(
          "React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."
        ), Ri[o] = !0;
      if (typeof s == "function" && (n === "form" && o === "action" || n === "input" && o === "formAction" || n === "button" && o === "formAction"))
        return !0;
      if (h != null) {
        if (n = h.possibleRegistrationNames, h.registrationNameDependencies.hasOwnProperty(o))
          return !0;
        if (h = n.hasOwnProperty(y) ? n[y] : null, h != null)
          return console.error(
            "Invalid event handler property `%s`. Did you mean `%s`?",
            o,
            h
          ), Ri[o] = !0;
        if (p6.test(o))
          return console.error(
            "Unknown event handler property `%s`. It will be ignored.",
            o
          ), Ri[o] = !0;
      } else if (p6.test(o))
        return fO.test(o) && console.error(
          "Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.",
          o
        ), Ri[o] = !0;
      if (mO.test(o) || hO.test(o)) return !0;
      if (y === "innerhtml")
        return console.error(
          "Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."
        ), Ri[o] = !0;
      if (y === "aria")
        return console.error(
          "The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."
        ), Ri[o] = !0;
      if (y === "is" && s !== null && s !== void 0 && typeof s != "string")
        return console.error(
          "Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.",
          typeof s
        ), Ri[o] = !0;
      if (typeof s == "number" && isNaN(s))
        return console.error(
          "Received NaN for the `%s` attribute. If this is expected, cast the value to a string.",
          o
        ), Ri[o] = !0;
      if ($l.hasOwnProperty(y)) {
        if (y = $l[y], y !== o)
          return console.error(
            "Invalid DOM property `%s`. Did you mean `%s`?",
            o,
            y
          ), Ri[o] = !0;
      } else if (o !== y)
        return console.error(
          "React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.",
          o,
          y
        ), Ri[o] = !0;
      switch (o) {
        case "dangerouslySetInnerHTML":
        case "children":
        case "style":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
          return !0;
        case "innerText":
        case "textContent":
          return !0;
      }
      switch (typeof s) {
        case "boolean":
          switch (o) {
            case "autoFocus":
            case "checked":
            case "multiple":
            case "muted":
            case "selected":
            case "contentEditable":
            case "spellCheck":
            case "draggable":
            case "value":
            case "autoReverse":
            case "externalResourcesRequired":
            case "focusable":
            case "preserveAlpha":
            case "allowFullScreen":
            case "async":
            case "autoPlay":
            case "controls":
            case "default":
            case "defer":
            case "disabled":
            case "disablePictureInPicture":
            case "disableRemotePlayback":
            case "formNoValidate":
            case "hidden":
            case "loop":
            case "noModule":
            case "noValidate":
            case "open":
            case "playsInline":
            case "readOnly":
            case "required":
            case "reversed":
            case "scoped":
            case "seamless":
            case "itemScope":
            case "capture":
            case "download":
            case "inert":
              return !0;
            default:
              return y = o.toLowerCase().slice(0, 5), y === "data-" || y === "aria-" ? !0 : (s ? console.error(
                'Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.',
                s,
                o,
                o,
                s,
                o
              ) : console.error(
                'Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.',
                s,
                o,
                o,
                s,
                o,
                o,
                o
              ), Ri[o] = !0);
          }
        case "function":
        case "symbol":
          return Ri[o] = !0, !1;
        case "string":
          if (s === "false" || s === "true") {
            switch (o) {
              case "checked":
              case "selected":
              case "multiple":
              case "muted":
              case "allowFullScreen":
              case "async":
              case "autoPlay":
              case "controls":
              case "default":
              case "defer":
              case "disabled":
              case "disablePictureInPicture":
              case "disableRemotePlayback":
              case "formNoValidate":
              case "hidden":
              case "loop":
              case "noModule":
              case "noValidate":
              case "open":
              case "playsInline":
              case "readOnly":
              case "required":
              case "reversed":
              case "scoped":
              case "seamless":
              case "itemScope":
              case "inert":
                break;
              default:
                return !0;
            }
            console.error(
              "Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?",
              s,
              o,
              s === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".',
              o,
              s
            ), Ri[o] = !0;
          }
      }
      return !0;
    }
    function ur(n, o, s) {
      var h = [], y;
      for (y in o)
        Kt(n, y, o[y], s) || h.push(y);
      o = h.map(function(C) {
        return "`" + C + "`";
      }).join(", "), h.length === 1 ? console.error(
        "Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://react.dev/link/attribute-behavior ",
        o,
        n
      ) : 1 < h.length && console.error(
        "Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://react.dev/link/attribute-behavior ",
        o,
        n
      );
    }
    function pr(n) {
      return pO.test("" + n) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : n;
    }
    function tr() {
    }
    function Va(n) {
      return n = n.target || n.srcElement || window, n.correspondingUseElement && (n = n.correspondingUseElement), n.nodeType === 3 ? n.parentNode : n;
    }
    function pi(n) {
      var o = bt(n);
      if (o && (n = o.stateNode)) {
        var s = n[qo] || null;
        e: switch (n = o.stateNode, o.type) {
          case "input":
            if (Yt(
              n,
              s.value,
              s.defaultValue,
              s.defaultValue,
              s.checked,
              s.defaultChecked,
              s.type,
              s.name
            ), o = s.name, s.type === "radio" && o != null) {
              for (s = n; s.parentNode; ) s = s.parentNode;
              for (pe(o, "name"), s = s.querySelectorAll(
                'input[name="' + Gt(
                  "" + o
                ) + '"][type="radio"]'
              ), o = 0; o < s.length; o++) {
                var h = s[o];
                if (h !== n && h.form === n.form) {
                  var y = h[qo] || null;
                  if (!y)
                    throw Error(
                      "ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported."
                    );
                  Yt(
                    h,
                    y.value,
                    y.defaultValue,
                    y.defaultValue,
                    y.checked,
                    y.defaultChecked,
                    y.type,
                    y.name
                  );
                }
              }
              for (o = 0; o < s.length; o++)
                h = s[o], h.form === n.form && gn(h);
            }
            break e;
          case "textarea":
            en(n, s.value, s.defaultValue);
            break e;
          case "select":
            o = s.value, o != null && qn(n, !!s.multiple, o, !1);
        }
      }
    }
    function Li(n, o, s) {
      if (EC) return n(o, s);
      EC = !0;
      try {
        var h = n(o);
        return h;
      } finally {
        if (EC = !1, (Ug !== null || Xg !== null) && (ki(), Ug && (o = Ug, n = Xg, Xg = Ug = null, pi(o), n)))
          for (o = 0; o < n.length; o++) pi(n[o]);
      }
    }
    function yo(n, o) {
      var s = n.stateNode;
      if (s === null) return null;
      var h = s[qo] || null;
      if (h === null) return null;
      s = h[o];
      e: switch (o) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          (h = !h.disabled) || (n = n.type, h = !(n === "button" || n === "input" || n === "select" || n === "textarea")), n = !h;
          break e;
        default:
          n = !1;
      }
      if (n) return null;
      if (s && typeof s != "function")
        throw Error(
          "Expected `" + o + "` listener to be a function, instead got a value of `" + typeof s + "` type."
        );
      return s;
    }
    function ul() {
      if (qy) return qy;
      var n, o = kC, s = o.length, h, y = "value" in bf ? bf.value : bf.textContent, C = y.length;
      for (n = 0; n < s && o[n] === y[n]; n++) ;
      var A = s - n;
      for (h = 1; h <= A && o[s - h] === y[C - h]; h++) ;
      return qy = y.slice(n, 1 < h ? 1 - h : void 0);
    }
    function rc(n) {
      var o = n.keyCode;
      return "charCode" in n ? (n = n.charCode, n === 0 && o === 13 && (n = 13)) : n = o, n === 10 && (n = 13), 32 <= n || n === 13 ? n : 0;
    }
    function uu() {
      return !0;
    }
    function lm() {
      return !1;
    }
    function Jt(n) {
      function o(s, h, y, C, A) {
        this._reactName = s, this._targetInst = y, this.type = h, this.nativeEvent = C, this.target = A, this.currentTarget = null;
        for (var z in n)
          n.hasOwnProperty(z) && (s = n[z], this[z] = s ? s(C) : C[z]);
        return this.isDefaultPrevented = (C.defaultPrevented != null ? C.defaultPrevented : C.returnValue === !1) ? uu : lm, this.isPropagationStopped = lm, this;
      }
      return Rn(o.prototype, {
        preventDefault: function() {
          this.defaultPrevented = !0;
          var s = this.nativeEvent;
          s && (s.preventDefault ? s.preventDefault() : typeof s.returnValue != "unknown" && (s.returnValue = !1), this.isDefaultPrevented = uu);
        },
        stopPropagation: function() {
          var s = this.nativeEvent;
          s && (s.stopPropagation ? s.stopPropagation() : typeof s.cancelBubble != "unknown" && (s.cancelBubble = !0), this.isPropagationStopped = uu);
        },
        persist: function() {
        },
        isPersistent: uu
      }), o;
    }
    function nr(n) {
      var o = this.nativeEvent;
      return o.getModifierState ? o.getModifierState(n) : (n = OO[n]) ? !!o[n] : !1;
    }
    function ao() {
      return nr;
    }
    function wo(n, o) {
      switch (n) {
        case "keyup":
          return FO.indexOf(o.keyCode) !== -1;
        case "keydown":
          return o.keyCode !== y6;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function Ea(n) {
      return n = n.detail, typeof n == "object" && "data" in n ? n.data : null;
    }
    function Uf(n, o) {
      switch (n) {
        case "compositionend":
          return Ea(o);
        case "keypress":
          return o.which !== S6 ? null : (x6 = !0, C6);
        case "textInput":
          return n = o.data, n === C6 && x6 ? null : n;
        default:
          return null;
      }
    }
    function gd(n, o) {
      if (Gg)
        return n === "compositionend" || !RC && wo(n, o) ? (n = ul(), qy = kC = bf = null, Gg = !1, n) : null;
      switch (n) {
        case "paste":
          return null;
        case "keypress":
          if (!(o.ctrlKey || o.altKey || o.metaKey) || o.ctrlKey && o.altKey) {
            if (o.char && 1 < o.char.length)
              return o.char;
            if (o.which)
              return String.fromCharCode(o.which);
          }
          return null;
        case "compositionend":
          return w6 && o.locale !== "ko" ? null : o.data;
        default:
          return null;
      }
    }
    function Zh(n) {
      var o = n && n.nodeName && n.nodeName.toLowerCase();
      return o === "input" ? !!VO[n.type] : o === "textarea";
    }
    function cd(n) {
      if (!Vu) return !1;
      n = "on" + n;
      var o = n in document;
      return o || (o = document.createElement("div"), o.setAttribute(n, "return;"), o = typeof o[n] == "function"), o;
    }
    function sm(n, o, s, h) {
      Ug ? Xg ? Xg.push(h) : Xg = [h] : Ug = h, o = Tl(o, "onChange"), 0 < o.length && (s = new Ky(
        "onChange",
        "change",
        null,
        s,
        h
      ), n.push({ event: s, listeners: o }));
    }
    function Mb(n) {
      br(n, 0);
    }
    function uo(n) {
      var o = Nt(n);
      if (gn(o)) return n;
    }
    function cu(n, o) {
      if (n === "change") return o;
    }
    function um() {
      X2 && (X2.detachEvent("onpropertychange", vd), G2 = X2 = null);
    }
    function vd(n) {
      if (n.propertyName === "value" && uo(G2)) {
        var o = [];
        sm(
          o,
          G2,
          n,
          Va(n)
        ), Li(Mb, o);
      }
    }
    function dC(n, o, s) {
      n === "focusin" ? (um(), X2 = o, G2 = s, X2.attachEvent("onpropertychange", vd)) : n === "focusout" && um();
    }
    function K0(n) {
      if (n === "selectionchange" || n === "keyup" || n === "keydown")
        return uo(G2);
    }
    function Y0(n, o) {
      if (n === "click") return uo(o);
    }
    function cm(n, o) {
      if (n === "input" || n === "change")
        return uo(o);
    }
    function pp(n, o) {
      return n === o && (n !== 0 || 1 / n === 1 / o) || n !== n && o !== o;
    }
    function bd(n, o) {
      if (Ai(n, o)) return !0;
      if (typeof n != "object" || n === null || typeof o != "object" || o === null)
        return !1;
      var s = Object.keys(n), h = Object.keys(o);
      if (s.length !== h.length) return !1;
      for (h = 0; h < s.length; h++) {
        var y = s[h];
        if (!Ti.call(o, y) || !Ai(n[y], o[y]))
          return !1;
      }
      return !0;
    }
    function Ob(n) {
      for (; n && n.firstChild; ) n = n.firstChild;
      return n;
    }
    function Tb(n, o) {
      var s = Ob(n);
      n = 0;
      for (var h; s; ) {
        if (s.nodeType === 3) {
          if (h = n + s.textContent.length, n <= o && h >= o)
            return { node: s, offset: o - n };
          n = h;
        }
        e: {
          for (; s; ) {
            if (s.nextSibling) {
              s = s.nextSibling;
              break e;
            }
            s = s.parentNode;
          }
          s = void 0;
        }
        s = Ob(s);
      }
    }
    function Rb(n, o) {
      return n && o ? n === o ? !0 : n && n.nodeType === 3 ? !1 : o && o.nodeType === 3 ? Rb(n, o.parentNode) : "contains" in n ? n.contains(o) : n.compareDocumentPosition ? !!(n.compareDocumentPosition(o) & 16) : !1 : !1;
    }
    function gp(n) {
      n = n != null && n.ownerDocument != null && n.ownerDocument.defaultView != null ? n.ownerDocument.defaultView : window;
      for (var o = Tn(n.document); o instanceof n.HTMLIFrameElement; ) {
        try {
          var s = typeof o.contentWindow.location.href == "string";
        } catch {
          s = !1;
        }
        if (s) n = o.contentWindow;
        else break;
        o = Tn(n.document);
      }
      return o;
    }
    function Q0(n) {
      var o = n && n.nodeName && n.nodeName.toLowerCase();
      return o && (o === "input" && (n.type === "text" || n.type === "search" || n.type === "tel" || n.type === "url" || n.type === "password") || o === "textarea" || n.contentEditable === "true");
    }
    function Ab(n, o, s) {
      var h = s.window === s ? s.document : s.nodeType === 9 ? s : s.ownerDocument;
      NC || qg == null || qg !== Tn(h) || (h = qg, "selectionStart" in h && Q0(h) ? h = { start: h.selectionStart, end: h.selectionEnd } : (h = (h.ownerDocument && h.ownerDocument.defaultView || window).getSelection(), h = {
        anchorNode: h.anchorNode,
        anchorOffset: h.anchorOffset,
        focusNode: h.focusNode,
        focusOffset: h.focusOffset
      }), q2 && bd(q2, h) || (q2 = h, h = Tl(AC, "onSelect"), 0 < h.length && (o = new Ky(
        "onSelect",
        "select",
        null,
        o,
        s
      ), n.push({ event: o, listeners: h }), o.target = qg)));
    }
    function ac(n, o) {
      var s = {};
      return s[n.toLowerCase()] = o.toLowerCase(), s["Webkit" + n] = "webkit" + o, s["Moz" + n] = "moz" + o, s;
    }
    function oc(n) {
      if (DC[n]) return DC[n];
      if (!Kg[n]) return n;
      var o = Kg[n], s;
      for (s in o)
        if (o.hasOwnProperty(s) && s in P6)
          return DC[n] = o[s];
      return n;
    }
    function ml(n, o) {
      R6.set(n, o), hn(o, [n]);
    }
    function Nb(n) {
      for (var o = Qy, s = 0; s < n.length; s++) {
        var h = n[s];
        if (typeof h == "object" && h !== null)
          if (Ta(h) && h.length === 2 && typeof h[0] == "string") {
            if (o !== Qy && o !== LC)
              return jC;
            o = LC;
          } else return jC;
        else {
          if (typeof h == "function" || typeof h == "string" && 50 < h.length || o !== Qy && o !== IC)
            return jC;
          o = IC;
        }
      }
      return o;
    }
    function J0(n, o, s, h) {
      for (var y in n)
        Ti.call(n, y) && y[0] !== "_" && Vl(y, n[y], o, s, h);
    }
    function Vl(n, o, s, h, y) {
      switch (typeof o) {
        case "object":
          if (o === null) {
            o = "null";
            break;
          } else {
            if (o.$$typeof === nl) {
              var C = F(o.type) || "…", A = o.key;
              o = o.props;
              var z = Object.keys(o), q = z.length;
              if (A == null && q === 0) {
                o = "<" + C + " />";
                break;
              }
              if (3 > h || q === 1 && z[0] === "children" && A == null) {
                o = "<" + C + " … />";
                break;
              }
              s.push([
                y + "  ".repeat(h) + n,
                "<" + C
              ]), A !== null && Vl(
                "key",
                A,
                s,
                h + 1,
                y
              ), n = !1;
              for (var Z in o)
                Z === "children" ? o.children != null && (!Ta(o.children) || 0 < o.children.length) && (n = !0) : Ti.call(o, Z) && Z[0] !== "_" && Vl(
                  Z,
                  o[Z],
                  s,
                  h + 1,
                  y
                );
              s.push([
                "",
                n ? ">…</" + C + ">" : "/>"
              ]);
              return;
            }
            if (C = Object.prototype.toString.call(o), C = C.slice(8, C.length - 1), C === "Array") {
              if (Z = Nb(o), Z === IC || Z === Qy) {
                o = JSON.stringify(o);
                break;
              } else if (Z === LC) {
                for (s.push([
                  y + "  ".repeat(h) + n,
                  ""
                ]), n = 0; n < o.length; n++)
                  C = o[n], Vl(
                    C[0],
                    C[1],
                    s,
                    h + 1,
                    y
                  );
                return;
              }
            }
            if (C === "Promise") {
              if (o.status === "fulfilled") {
                if (C = s.length, Vl(
                  n,
                  o.value,
                  s,
                  h,
                  y
                ), s.length > C) {
                  s = s[C], s[1] = "Promise<" + (s[1] || "Object") + ">";
                  return;
                }
              } else if (o.status === "rejected" && (C = s.length, Vl(
                n,
                o.reason,
                s,
                h,
                y
              ), s.length > C)) {
                s = s[C], s[1] = "Rejected Promise<" + s[1] + ">";
                return;
              }
              s.push([
                "  ".repeat(h) + n,
                "Promise"
              ]);
              return;
            }
            C === "Object" && (Z = Object.getPrototypeOf(o)) && typeof Z.constructor == "function" && (C = Z.constructor.name), s.push([
              y + "  ".repeat(h) + n,
              C === "Object" ? 3 > h ? "" : "…" : C
            ]), 3 > h && J0(o, s, h + 1, y);
            return;
          }
        case "function":
          o = o.name === "" ? "() => {}" : o.name + "() {}";
          break;
        case "string":
          o = o === KO ? "…" : JSON.stringify(o);
          break;
        case "undefined":
          o = "undefined";
          break;
        case "boolean":
          o = o ? "true" : "false";
          break;
        default:
          o = String(o);
      }
      s.push([
        y + "  ".repeat(h) + n,
        o
      ]);
    }
    function Db(n, o, s, h) {
      var y = !0;
      for (A in n)
        A in o || (s.push([
          Jy + "  ".repeat(h) + A,
          "…"
        ]), y = !1);
      for (var C in o)
        if (C in n) {
          var A = n[C], z = o[C];
          if (A !== z) {
            if (h === 0 && C === "children")
              y = "  ".repeat(h) + C, s.push(
                [Jy + y, "…"],
                [Zy + y, "…"]
              );
            else {
              if (!(3 <= h)) {
                if (typeof A == "object" && typeof z == "object" && A !== null && z !== null && A.$$typeof === z.$$typeof)
                  if (z.$$typeof === nl) {
                    if (A.type === z.type && A.key === z.key) {
                      A = F(z.type) || "…", y = "  ".repeat(h) + C, A = "<" + A + " … />", s.push(
                        [Jy + y, A],
                        [Zy + y, A]
                      ), y = !1;
                      continue;
                    }
                  } else {
                    var q = Object.prototype.toString.call(A), Z = Object.prototype.toString.call(z);
                    if (q === Z && (Z === "[object Object]" || Z === "[object Array]")) {
                      q = [
                        D6 + "  ".repeat(h) + C,
                        Z === "[object Array]" ? "Array" : ""
                      ], s.push(q), Z = s.length, Db(
                        A,
                        z,
                        s,
                        h + 1
                      ) ? Z === s.length && (q[1] = "Referentially unequal but deeply equal objects. Consider memoization.") : y = !1;
                      continue;
                    }
                  }
                else if (typeof A == "function" && typeof z == "function" && A.name === z.name && A.length === z.length && (q = Function.prototype.toString.call(A), Z = Function.prototype.toString.call(z), q === Z)) {
                  A = z.name === "" ? "() => {}" : z.name + "() {}", s.push([
                    D6 + "  ".repeat(h) + C,
                    A + " Referentially unequal function closure. Consider memoization."
                  ]);
                  continue;
                }
              }
              Vl(C, A, s, h, Jy), Vl(C, z, s, h, Zy);
            }
            y = !1;
          }
        } else
          s.push([
            Zy + "  ".repeat(h) + C,
            "…"
          ]), y = !1;
      return y;
    }
    function hl(n) {
      Zn = n & 63 ? "Blocking" : n & 64 ? "Gesture" : n & 4194176 ? "Transition" : n & 62914560 ? "Suspense" : n & 2080374784 ? "Idle" : "Other";
    }
    function Xi(n, o, s, h) {
      Gr && (wf.start = o, wf.end = s, Bc.color = "warning", Bc.tooltipText = h, Bc.properties = null, (n = n._debugTask) ? n.run(
        performance.measure.bind(
          performance,
          h,
          wf
        )
      ) : performance.measure(h, wf));
    }
    function vp(n, o, s) {
      Xi(n, o, s, "Reconnect");
    }
    function bp(n, o, s, h, y) {
      var C = W(n);
      if (C !== null && Gr) {
        var A = n.alternate, z = n.actualDuration;
        if (A === null || A.child !== n.child)
          for (var q = n.child; q !== null; q = q.sibling)
            z -= q.actualDuration;
        h = 0.5 > z ? h ? "tertiary-light" : "primary-light" : 10 > z ? h ? "tertiary" : "primary" : 100 > z ? h ? "tertiary-dark" : "primary-dark" : "error";
        var Z = n.memoizedProps;
        z = n._debugTask, Z !== null && A !== null && A.memoizedProps !== Z ? (q = [YO], Z = Db(
          A.memoizedProps,
          Z,
          q,
          0
        ), 1 < q.length && (Z && !yf && (A.lanes & y) === 0 && 100 < n.actualDuration ? (yf = !0, q[0] = QO, Bc.color = "warning", Bc.tooltipText = $6) : (Bc.color = h, Bc.tooltipText = C), Bc.properties = q, wf.start = o, wf.end = s, z != null ? z.run(
          performance.measure.bind(
            performance,
            "​" + C,
            wf
          )
        ) : performance.measure(
          "​" + C,
          wf
        ))) : z != null ? z.run(
          console.timeStamp.bind(
            console,
            C,
            o,
            s,
            ps,
            void 0,
            h
          )
        ) : console.timeStamp(
          C,
          o,
          s,
          ps,
          void 0,
          h
        );
      }
    }
    function Z0(n, o, s, h) {
      if (Gr) {
        var y = W(n);
        if (y !== null) {
          for (var C = null, A = [], z = 0; z < h.length; z++) {
            var q = h[z];
            C == null && q.source !== null && (C = q.source._debugTask), q = q.value, A.push([
              "Error",
              typeof q == "object" && q !== null && typeof q.message == "string" ? String(q.message) : String(q)
            ]);
          }
          n.key !== null && Vl("key", n.key, A, 0, ""), n.memoizedProps !== null && J0(n.memoizedProps, A, 0, ""), C == null && (C = n._debugTask), n = {
            start: o,
            end: s,
            detail: {
              devtools: {
                color: "error",
                track: ps,
                tooltipText: n.tag === 13 ? "Hydration failed" : "Error boundary caught an error",
                properties: A
              }
            }
          }, C ? C.run(
            performance.measure.bind(performance, "​" + y, n)
          ) : performance.measure("​" + y, n);
        }
      }
    }
    function pl(n, o, s, h, y) {
      if (y !== null) {
        if (Gr) {
          var C = W(n);
          if (C !== null) {
            h = [];
            for (var A = 0; A < y.length; A++) {
              var z = y[A].value;
              h.push([
                "Error",
                typeof z == "object" && z !== null && typeof z.message == "string" ? String(z.message) : String(z)
              ]);
            }
            n.key !== null && Vl("key", n.key, h, 0, ""), n.memoizedProps !== null && J0(n.memoizedProps, h, 0, ""), o = {
              start: o,
              end: s,
              detail: {
                devtools: {
                  color: "error",
                  track: ps,
                  tooltipText: "A lifecycle or effect errored",
                  properties: h
                }
              }
            }, (n = n._debugTask) ? n.run(
              performance.measure.bind(
                performance,
                "​" + C,
                o
              )
            ) : performance.measure("​" + C, o);
          }
        }
      } else
        C = W(n), C !== null && Gr && (y = 1 > h ? "secondary-light" : 100 > h ? "secondary" : 500 > h ? "secondary-dark" : "error", (n = n._debugTask) ? n.run(
          console.timeStamp.bind(
            console,
            C,
            o,
            s,
            ps,
            void 0,
            y
          )
        ) : console.timeStamp(
          C,
          o,
          s,
          ps,
          void 0,
          y
        ));
    }
    function fC(n, o, s, h) {
      if (Gr && !(o <= n)) {
        var y = (s & 738197653) === s ? "tertiary-dark" : "primary-dark";
        s = (s & 536870912) === s ? "Prepared" : (s & 201326741) === s ? "Hydrated" : "Render", h ? h.run(
          console.timeStamp.bind(
            console,
            s,
            n,
            o,
            Zn,
            Kn,
            y
          )
        ) : console.timeStamp(
          s,
          n,
          o,
          Zn,
          Kn,
          y
        );
      }
    }
    function $b(n, o, s, h) {
      !Gr || o <= n || (s = (s & 738197653) === s ? "tertiary-dark" : "primary-dark", h ? h.run(
        console.timeStamp.bind(
          console,
          "Prewarm",
          n,
          o,
          Zn,
          Kn,
          s
        )
      ) : console.timeStamp(
        "Prewarm",
        n,
        o,
        Zn,
        Kn,
        s
      ));
    }
    function zb(n, o, s, h) {
      !Gr || o <= n || (s = (s & 738197653) === s ? "tertiary-dark" : "primary-dark", h ? h.run(
        console.timeStamp.bind(
          console,
          "Suspended",
          n,
          o,
          Zn,
          Kn,
          s
        )
      ) : console.timeStamp(
        "Suspended",
        n,
        o,
        Zn,
        Kn,
        s
      ));
    }
    function mC(n, o, s, h, y, C) {
      if (Gr && !(o <= n)) {
        s = [];
        for (var A = 0; A < h.length; A++) {
          var z = h[A].value;
          s.push([
            "Recoverable Error",
            typeof z == "object" && z !== null && typeof z.message == "string" ? String(z.message) : String(z)
          ]);
        }
        n = {
          start: n,
          end: o,
          detail: {
            devtools: {
              color: "primary-dark",
              track: Zn,
              trackGroup: Kn,
              tooltipText: y ? "Hydration Failed" : "Recovered after Error",
              properties: s
            }
          }
        }, C ? C.run(
          performance.measure.bind(performance, "Recovered", n)
        ) : performance.measure("Recovered", n);
      }
    }
    function ev(n, o, s, h) {
      !Gr || o <= n || (h ? h.run(
        console.timeStamp.bind(
          console,
          "Errored",
          n,
          o,
          Zn,
          Kn,
          "error"
        )
      ) : console.timeStamp(
        "Errored",
        n,
        o,
        Zn,
        Kn,
        "error"
      ));
    }
    function hC(n, o, s, h) {
      !Gr || o <= n || (h ? h.run(
        console.timeStamp.bind(
          console,
          s,
          n,
          o,
          Zn,
          Kn,
          "secondary-light"
        )
      ) : console.timeStamp(
        s,
        n,
        o,
        Zn,
        Kn,
        "secondary-light"
      ));
    }
    function jb(n, o, s, h, y) {
      if (Gr && !(o <= n)) {
        for (var C = [], A = 0; A < s.length; A++) {
          var z = s[A].value;
          C.push([
            "Error",
            typeof z == "object" && z !== null && typeof z.message == "string" ? String(z.message) : String(z)
          ]);
        }
        n = {
          start: n,
          end: o,
          detail: {
            devtools: {
              color: "error",
              track: Zn,
              trackGroup: Kn,
              tooltipText: h ? "Remaining Effects Errored" : "Commit Errored",
              properties: C
            }
          }
        }, y ? y.run(
          performance.measure.bind(performance, "Errored", n)
        ) : performance.measure("Errored", n);
      }
    }
    function tv(n, o, s) {
      !Gr || o <= n || console.timeStamp(
        "Animating",
        n,
        o,
        Zn,
        Kn,
        "secondary-dark"
      );
    }
    function yp() {
      for (var n = Yg, o = HC = Yg = 0; o < n; ) {
        var s = gs[o];
        gs[o++] = null;
        var h = gs[o];
        gs[o++] = null;
        var y = gs[o];
        gs[o++] = null;
        var C = gs[o];
        if (gs[o++] = null, h !== null && y !== null) {
          var A = h.pending;
          A === null ? y.next = y : (y.next = A.next, A.next = y), h.pending = y;
        }
        C !== 0 && nv(s, y, C);
      }
    }
    function yd(n, o, s, h) {
      gs[Yg++] = n, gs[Yg++] = o, gs[Yg++] = s, gs[Yg++] = h, HC |= h, n.lanes |= h, n = n.alternate, n !== null && (n.lanes |= h);
    }
    function ic(n, o, s, h) {
      return yd(n, o, s, h), dm(n);
    }
    function So(n, o) {
      return yd(n, null, null, o), dm(n);
    }
    function nv(n, o, s) {
      n.lanes |= s;
      var h = n.alternate;
      h !== null && (h.lanes |= s);
      for (var y = !1, C = n.return; C !== null; )
        C.childLanes |= s, h = C.alternate, h !== null && (h.childLanes |= s), C.tag === 22 && (n = C.stateNode, n === null || n._visibility & K2 || (y = !0)), n = C, C = C.return;
      return n.tag === 3 ? (C = n.stateNode, y && o !== null && (y = 31 - fo(s), n = C.hiddenUpdates, h = n[y], h === null ? n[y] = [o] : h.push(o), o.lane = s | 536870912), C) : null;
    }
    function dm(n) {
      if (C1 > hT)
        throw Dh = C1 = 0, x1 = b4 = null, Error(
          "Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops."
        );
      Dh > pT && (Dh = 0, x1 = null, console.error(
        "Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."
      )), n.alternate === null && (n.flags & 4098) !== 0 && tl(n);
      for (var o = n, s = o.return; s !== null; )
        o.alternate === null && (o.flags & 4098) !== 0 && tl(n), o = s, s = o.return;
      return o.tag === 3 ? o.stateNode : null;
    }
    function du(n) {
      if (vs === null) return n;
      var o = vs(n);
      return o === void 0 ? n : o.current;
    }
    function wp(n) {
      if (vs === null) return n;
      var o = vs(n);
      return o === void 0 ? n != null && typeof n.render == "function" && (o = du(n.render), n.render !== o) ? (o = { $$typeof: lf, render: o }, n.displayName !== void 0 && (o.displayName = n.displayName), o) : n : o.current;
    }
    function rv(n, o) {
      if (vs === null) return !1;
      var s = n.elementType;
      o = o.type;
      var h = !1, y = typeof o == "object" && o !== null ? o.$$typeof : null;
      switch (n.tag) {
        case 1:
          typeof o == "function" && (h = !0);
          break;
        case 0:
          (typeof o == "function" || y === Eo) && (h = !0);
          break;
        case 11:
          (y === lf || y === Eo) && (h = !0);
          break;
        case 14:
        case 15:
          (y === dh || y === Eo) && (h = !0);
          break;
        default:
          return !1;
      }
      return !!(h && (n = vs(s), n !== void 0 && n === vs(o)));
    }
    function lc(n) {
      vs !== null && typeof WeakSet == "function" && (Qg === null && (Qg = /* @__PURE__ */ new WeakSet()), Qg.add(n));
    }
    function Ib(n, o, s) {
      do {
        var h = n, y = h.alternate, C = h.child, A = h.sibling, z = h.tag;
        h = h.type;
        var q = null;
        switch (z) {
          case 0:
          case 15:
          case 1:
            q = h;
            break;
          case 11:
            q = h.render;
        }
        if (vs === null)
          throw Error("Expected resolveFamily to be set during hot reload.");
        var Z = !1;
        if (h = !1, q !== null && (q = vs(q), q !== void 0 && (s.has(q) ? h = !0 : o.has(q) && (z === 1 ? h = !0 : Z = !0))), Qg !== null && (Qg.has(n) || y !== null && Qg.has(y)) && (h = !0), h && (n._debugNeedsRemount = !0), (h || Z) && (y = So(n, 2), y !== null && ln(y, n, 2)), C === null || h || Ib(
          C,
          o,
          s
        ), A === null) break;
        n = A;
      } while (!0);
    }
    function pC(n, o, s, h) {
      this.tag = n, this.key = s, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = o, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = h, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null, this.actualDuration = -0, this.actualStartTime = -1.1, this.treeBaseDuration = this.selfBaseDuration = -0, this._debugTask = this._debugStack = this._debugOwner = this._debugInfo = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, z6 || typeof Object.preventExtensions != "function" || Object.preventExtensions(this);
    }
    function av(n) {
      return n = n.prototype, !(!n || !n.isReactComponent);
    }
    function _l(n, o) {
      var s = n.alternate;
      switch (s === null ? (s = x(
        n.tag,
        o,
        n.key,
        n.mode
      ), s.elementType = n.elementType, s.type = n.type, s.stateNode = n.stateNode, s._debugOwner = n._debugOwner, s._debugStack = n._debugStack, s._debugTask = n._debugTask, s._debugHookTypes = n._debugHookTypes, s.alternate = n, n.alternate = s) : (s.pendingProps = o, s.type = n.type, s.flags = 0, s.subtreeFlags = 0, s.deletions = null, s.actualDuration = -0, s.actualStartTime = -1.1), s.flags = n.flags & 65011712, s.childLanes = n.childLanes, s.lanes = n.lanes, s.child = n.child, s.memoizedProps = n.memoizedProps, s.memoizedState = n.memoizedState, s.updateQueue = n.updateQueue, o = n.dependencies, s.dependencies = o === null ? null : {
        lanes: o.lanes,
        firstContext: o.firstContext,
        _debugThenableState: o._debugThenableState
      }, s.sibling = n.sibling, s.index = n.index, s.ref = n.ref, s.refCleanup = n.refCleanup, s.selfBaseDuration = n.selfBaseDuration, s.treeBaseDuration = n.treeBaseDuration, s._debugInfo = n._debugInfo, s._debugNeedsRemount = n._debugNeedsRemount, s.tag) {
        case 0:
        case 15:
          s.type = du(n.type);
          break;
        case 1:
          s.type = du(n.type);
          break;
        case 11:
          s.type = wp(n.type);
      }
      return s;
    }
    function ov(n, o) {
      n.flags &= 65011714;
      var s = n.alternate;
      return s === null ? (n.childLanes = 0, n.lanes = o, n.child = null, n.subtreeFlags = 0, n.memoizedProps = null, n.memoizedState = null, n.updateQueue = null, n.dependencies = null, n.stateNode = null, n.selfBaseDuration = 0, n.treeBaseDuration = 0) : (n.childLanes = s.childLanes, n.lanes = s.lanes, n.child = s.child, n.subtreeFlags = 0, n.deletions = null, n.memoizedProps = s.memoizedProps, n.memoizedState = s.memoizedState, n.updateQueue = s.updateQueue, n.type = s.type, o = s.dependencies, n.dependencies = o === null ? null : {
        lanes: o.lanes,
        firstContext: o.firstContext,
        _debugThenableState: o._debugThenableState
      }, n.selfBaseDuration = s.selfBaseDuration, n.treeBaseDuration = s.treeBaseDuration), n;
    }
    function sc(n, o, s, h, y, C) {
      var A = 0, z = n;
      if (typeof n == "function")
        av(n) && (A = 1), z = du(z);
      else if (typeof n == "string")
        A = K(), A = Ny(n, s, A) ? 26 : n === "html" || n === "head" || n === "body" ? 27 : 5;
      else
        e: switch (n) {
          case Dl:
            return o = x(31, s, o, y), o.elementType = Dl, o.lanes = C, o;
          case of:
            return uc(
              s.children,
              y,
              C,
              o
            );
          case Go:
            A = 8, y |= ii, y |= Qs;
            break;
          case ch:
            return n = s, h = y, typeof n.id != "string" && console.error(
              'Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.',
              typeof n.id
            ), o = x(12, n, o, h | An), o.elementType = ch, o.lanes = C, o.stateNode = { effectDuration: 0, passiveEffectDuration: 0 }, o;
          case Hc:
            return o = x(13, s, o, y), o.elementType = Hc, o.lanes = C, o;
          case ai:
            return o = x(19, s, o, y), o.elementType = ai, o.lanes = C, o;
          default:
            if (typeof n == "object" && n !== null)
              switch (n.$$typeof) {
                case Nl:
                  A = 10;
                  break e;
                case Ng:
                  A = 9;
                  break e;
                case lf:
                  A = 11, z = wp(z);
                  break e;
                case dh:
                  A = 14;
                  break e;
                case Eo:
                  A = 16, z = null;
                  break e;
              }
            z = "", (n === void 0 || typeof n == "object" && n !== null && Object.keys(n).length === 0) && (z += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), n === null ? s = "null" : Ta(n) ? s = "array" : n !== void 0 && n.$$typeof === nl ? (s = "<" + (F(n.type) || "Unknown") + " />", z = " Did you accidentally export a JSX literal instead of a component?") : s = typeof n, (A = h ? _(h) : null) && (z += `

Check the render method of \`` + A + "`."), A = 29, s = Error(
              "Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (s + "." + z)
            ), z = null;
        }
      return o = x(A, s, o, y), o.elementType = n, o.type = z, o.lanes = C, o._debugOwner = h, o;
    }
    function fu(n, o, s) {
      return o = sc(
        n.type,
        n.key,
        n.props,
        n._owner,
        o,
        s
      ), o._debugOwner = n._owner, o._debugStack = n._debugStack, o._debugTask = n._debugTask, o;
    }
    function uc(n, o, s, h) {
      return n = x(7, n, h, o), n.lanes = s, n;
    }
    function wd(n, o, s) {
      return n = x(6, n, null, o), n.lanes = s, n;
    }
    function iv(n) {
      var o = x(18, null, null, on);
      return o.stateNode = n, o;
    }
    function Sp(n, o, s) {
      return o = x(
        4,
        n.children !== null ? n.children : [],
        n.key,
        o
      ), o.lanes = s, o.stateNode = {
        containerInfo: n.containerInfo,
        pendingChildren: null,
        implementation: n.implementation
      }, o;
    }
    function $o(n, o) {
      if (typeof n == "object" && n !== null) {
        var s = FC.get(n);
        return s !== void 0 ? s : (o = {
          value: n,
          source: o,
          stack: me(o)
        }, FC.set(n, o), o);
      }
      return {
        value: n,
        source: o,
        stack: me(o)
      };
    }
    function gl(n, o) {
      mu(), Jg[Zg++] = Y2, Jg[Zg++] = ew, ew = n, Y2 = o;
    }
    function lv(n, o, s) {
      mu(), bs[ys++] = Xc, bs[ys++] = Gc, bs[ys++] = bh, bh = n;
      var h = Xc;
      n = Gc;
      var y = 32 - fo(h) - 1;
      h &= ~(1 << y), s += 1;
      var C = 32 - fo(o) + y;
      if (30 < C) {
        var A = y - y % 5;
        C = (h & (1 << A) - 1).toString(32), h >>= A, y -= A, Xc = 1 << 32 - fo(o) + y | s << y | h, Gc = C + n;
      } else
        Xc = 1 << C | s << y | h, Gc = n;
    }
    function Cp(n) {
      mu(), n.return !== null && (gl(n, 1), lv(n, 1, 0));
    }
    function xp(n) {
      for (; n === ew; )
        ew = Jg[--Zg], Jg[Zg] = null, Y2 = Jg[--Zg], Jg[Zg] = null;
      for (; n === bh; )
        bh = bs[--ys], bs[ys] = null, Gc = bs[--ys], bs[ys] = null, Xc = bs[--ys], bs[ys] = null;
    }
    function Lb() {
      return mu(), bh !== null ? { id: Xc, overflow: Gc } : null;
    }
    function Hb(n, o) {
      mu(), bs[ys++] = Xc, bs[ys++] = Gc, bs[ys++] = bh, Xc = o.id, Gc = o.overflow, bh = n;
    }
    function mu() {
      Xn || console.error(
        "Expected to be hydrating. This is a bug in React. Please file an issue."
      );
    }
    function cc(n, o) {
      if (n.return === null) {
        if (zl === null)
          zl = {
            fiber: n,
            children: [],
            serverProps: void 0,
            serverTail: [],
            distanceFromLeaf: o
          };
        else {
          if (zl.fiber !== n)
            throw Error(
              "Saw multiple hydration diff roots in a pass. This is a bug in React."
            );
          zl.distanceFromLeaf > o && (zl.distanceFromLeaf = o);
        }
        return zl;
      }
      var s = cc(
        n.return,
        o + 1
      ).children;
      return 0 < s.length && s[s.length - 1].fiber === n ? (s = s[s.length - 1], s.distanceFromLeaf > o && (s.distanceFromLeaf = o), s) : (o = {
        fiber: n,
        children: [],
        serverProps: void 0,
        serverTail: [],
        distanceFromLeaf: o
      }, s.push(o), o);
    }
    function Fb() {
      Xn && console.error(
        "We should not be hydrating here. This is a bug in React. Please file a bug."
      );
    }
    function Co(n, o) {
      _u || (n = cc(n, 0), n.serverProps = null, o !== null && (o = Oy(o), n.serverTail.push(o)));
    }
    function Gi(n) {
      var o = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : !1, s = "", h = zl;
      throw h !== null && (zl = null, s = mi(h)), mm(
        $o(
          Error(
            "Hydration failed because the server rendered " + (o ? "text" : "HTML") + ` didn't match the client. As a result this tree will be regenerated on the client. This can happen if a SSR-ed Client Component used:

- A server/client branch \`if (typeof window !== 'undefined')\`.
- Variable input such as \`Date.now()\` or \`Math.random()\` which changes each time it's called.
- Date formatting in a user's locale which doesn't match the server.
- External changing data without sending a snapshot of it along with the HTML.
- Invalid HTML tag nesting.

It can also happen if the client has a browser extension installed which messes with the HTML before React loaded.

https://react.dev/link/hydration-mismatch` + s
          ),
          n
        )
      ), WC;
    }
    function sv(n) {
      var o = n.stateNode, s = n.type, h = n.memoizedProps;
      switch (o[Xr] = n, o[qo] = h, Uo(s, h), s) {
        case "dialog":
          rn("cancel", o), rn("close", o);
          break;
        case "iframe":
        case "object":
        case "embed":
          rn("load", o);
          break;
        case "video":
        case "audio":
          for (s = 0; s < E1.length; s++)
            rn(E1[s], o);
          break;
        case "source":
          rn("error", o);
          break;
        case "img":
        case "image":
        case "link":
          rn("error", o), rn("load", o);
          break;
        case "details":
          rn("toggle", o);
          break;
        case "input":
          jn("input", h), rn("invalid", o), Dt(o, h), Mn(
            o,
            h.value,
            h.defaultValue,
            h.checked,
            h.defaultChecked,
            h.type,
            h.name,
            !0
          );
          break;
        case "option":
          wr(o, h);
          break;
        case "select":
          jn("select", h), rn("invalid", o), Rr(o, h);
          break;
        case "textarea":
          jn("textarea", h), rn("invalid", o), Wt(o, h), Xt(
            o,
            h.value,
            h.defaultValue,
            h.children
          );
      }
      s = h.children, typeof s != "string" && typeof s != "number" && typeof s != "bigint" || o.textContent === "" + s || h.suppressHydrationWarning === !0 || c2(o.textContent, s) ? (h.popover != null && (rn("beforetoggle", o), rn("toggle", o)), h.onScroll != null && rn("scroll", o), h.onScrollEnd != null && rn("scrollend", o), h.onClick != null && (o.onclick = tr), o = !0) : o = !1, o || Gi(n, !0);
    }
    function uv(n) {
      for (Ko = n.return; Ko; )
        switch (Ko.tag) {
          case 5:
          case 31:
          case 13:
            ws = !1;
            return;
          case 27:
          case 3:
            ws = !0;
            return;
          default:
            Ko = Ko.return;
        }
    }
    function dc(n) {
      if (n !== Ko) return !1;
      if (!Xn)
        return uv(n), Xn = !0, !1;
      var o = n.tag, s;
      if ((s = o !== 3 && o !== 27) && ((s = o === 5) && (s = n.type, s = !(s !== "form" && s !== "button") || Qd(n.type, n.memoizedProps)), s = !s), s && qr) {
        for (s = qr; s; ) {
          var h = cc(n, 0), y = Oy(s);
          h.serverTail.push(y), s = y.type === "Suspense" ? ef(s) : Mi(s.nextSibling);
        }
        Gi(n);
      }
      if (uv(n), o === 13) {
        if (n = n.memoizedState, n = n !== null ? n.dehydrated : null, !n)
          throw Error(
            "Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue."
          );
        qr = ef(n);
      } else if (o === 31) {
        if (n = n.memoizedState, n = n !== null ? n.dehydrated : null, !n)
          throw Error(
            "Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue."
          );
        qr = ef(n);
      } else
        o === 27 ? (o = qr, ju(n.type) ? (n = R4, R4 = null, qr = n) : qr = o) : qr = Ko ? Mi(n.stateNode.nextSibling) : null;
      return !0;
    }
    function hu() {
      qr = Ko = null, _u = Xn = !1;
    }
    function fm() {
      var n = Cf;
      return n !== null && (zi === null ? zi = n : zi.push.apply(
        zi,
        n
      ), Cf = null), n;
    }
    function mm(n) {
      Cf === null ? Cf = [n] : Cf.push(n);
    }
    function pu() {
      var n = zl;
      if (n !== null) {
        zl = null;
        for (var o = mi(n); 0 < n.children.length; )
          n = n.children[0];
        le(n.fiber, function() {
          console.error(
            `A tree hydrated but some attributes of the server rendered HTML didn't match the client properties. This won't be patched up. This can happen if a SSR-ed Client Component used:

- A server/client branch \`if (typeof window !== 'undefined')\`.
- Variable input such as \`Date.now()\` or \`Math.random()\` which changes each time it's called.
- Date formatting in a user's locale which doesn't match the server.
- External changing data without sending a snapshot of it along with the HTML.
- Invalid HTML tag nesting.

It can also happen if the client has a browser extension installed which messes with the HTML before React loaded.

%s%s`,
            "https://react.dev/link/hydration-mismatch",
            o
          );
        });
      }
    }
    function Sd() {
      e0 = tw = null, t0 = !1;
    }
    function qi(n, o, s) {
      Y(VC, o._currentValue, n), o._currentValue = s, Y(_C, o._currentRenderer, n), o._currentRenderer !== void 0 && o._currentRenderer !== null && o._currentRenderer !== j6 && console.error(
        "Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."
      ), o._currentRenderer = j6;
    }
    function vl(n, o) {
      n._currentValue = VC.current;
      var s = _C.current;
      U(_C, o), n._currentRenderer = s, U(VC, o);
    }
    function Ep(n, o, s) {
      for (; n !== null; ) {
        var h = n.alternate;
        if ((n.childLanes & o) !== o ? (n.childLanes |= o, h !== null && (h.childLanes |= o)) : h !== null && (h.childLanes & o) !== o && (h.childLanes |= o), n === s) break;
        n = n.return;
      }
      n !== s && console.error(
        "Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue."
      );
    }
    function As(n, o, s, h) {
      var y = n.child;
      for (y !== null && (y.return = n); y !== null; ) {
        var C = y.dependencies;
        if (C !== null) {
          var A = y.child;
          C = C.firstContext;
          e: for (; C !== null; ) {
            var z = C;
            C = y;
            for (var q = 0; q < o.length; q++)
              if (z.context === o[q]) {
                C.lanes |= s, z = C.alternate, z !== null && (z.lanes |= s), Ep(
                  C.return,
                  s,
                  n
                ), h || (A = null);
                break e;
              }
            C = z.next;
          }
        } else if (y.tag === 18) {
          if (A = y.return, A === null)
            throw Error(
              "We just came from a parent so we must have had a parent. This is a bug in React."
            );
          A.lanes |= s, C = A.alternate, C !== null && (C.lanes |= s), Ep(
            A,
            s,
            n
          ), A = null;
        } else A = y.child;
        if (A !== null) A.return = y;
        else
          for (A = y; A !== null; ) {
            if (A === n) {
              A = null;
              break;
            }
            if (y = A.sibling, y !== null) {
              y.return = A.return, A = y;
              break;
            }
            A = A.return;
          }
        y = A;
      }
    }
    function bl(n, o, s, h) {
      n = null;
      for (var y = o, C = !1; y !== null; ) {
        if (!C) {
          if ((y.flags & 524288) !== 0) C = !0;
          else if ((y.flags & 262144) !== 0) break;
        }
        if (y.tag === 10) {
          var A = y.alternate;
          if (A === null)
            throw Error("Should have a current fiber. This is a bug in React.");
          if (A = A.memoizedProps, A !== null) {
            var z = y.type;
            Ai(y.pendingProps.value, A.value) || (n !== null ? n.push(z) : n = [z]);
          }
        } else if (y === Fu.current) {
          if (A = y.alternate, A === null)
            throw Error("Should have a current fiber. This is a bug in React.");
          A.memoizedState.memoizedState !== y.memoizedState.memoizedState && (n !== null ? n.push(T1) : n = [T1]);
        }
        y = y.return;
      }
      n !== null && As(
        o,
        n,
        s,
        h
      ), o.flags |= 262144;
    }
    function Cd(n) {
      for (n = n.firstContext; n !== null; ) {
        if (!Ai(
          n.context._currentValue,
          n.memoizedValue
        ))
          return !0;
        n = n.next;
      }
      return !1;
    }
    function gu(n) {
      tw = n, e0 = null, n = n.dependencies, n !== null && (n.firstContext = null);
    }
    function cr(n) {
      return t0 && console.error(
        "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."
      ), cv(tw, n);
    }
    function hm(n, o) {
      return tw === null && gu(n), cv(n, o);
    }
    function cv(n, o) {
      var s = o._currentValue;
      if (o = { context: o, memoizedValue: s, next: null }, e0 === null) {
        if (n === null)
          throw Error(
            "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."
          );
        e0 = o, n.dependencies = {
          lanes: 0,
          firstContext: o,
          _debugThenableState: null
        }, n.flags |= 524288;
      } else e0 = e0.next = o;
      return s;
    }
    function Pp() {
      return {
        controller: new tT(),
        data: /* @__PURE__ */ new Map(),
        refCount: 0
      };
    }
    function fc(n) {
      n.controller.signal.aborted && console.warn(
        "A cache instance was retained after it was already freed. This likely indicates a bug in React."
      ), n.refCount++;
    }
    function pm(n) {
      n.refCount--, 0 > n.refCount && console.warn(
        "A cache instance was released after it was already freed. This likely indicates a bug in React."
      ), n.refCount === 0 && nT(rT, function() {
        n.controller.abort();
      });
    }
    function Bl(n, o, s) {
      (n & 127) !== 0 ? 0 > Bu && (Bu = Qa(), J2 = nw(o), BC = o, s != null && (UC = W(s)), (ar & (po | Ll)) !== Oo && (Ca = !0, Ef = Q2), n = Jd(), o = us(), n !== n0 || o !== Z2 ? n0 = -1.1 : o !== null && (Ef = Q2), Sh = n, Z2 = o) : (n & 4194048) !== 0 && 0 > Ss && (Ss = Qa(), e1 = nw(o), I6 = o, s != null && (L6 = W(s)), 0 > Qc) && (n = Jd(), o = us(), (n !== kf || o !== Ch) && (kf = -1.1), Pf = n, Ch = o);
    }
    function Wb(n) {
      if (0 > Bu) {
        Bu = Qa(), J2 = n._debugTask != null ? n._debugTask : null, (ar & (po | Ll)) !== Oo && (Ef = Q2);
        var o = Jd(), s = us();
        o !== n0 || s !== Z2 ? n0 = -1.1 : s !== null && (Ef = Q2), Sh = o, Z2 = s;
      }
      0 > Ss && (Ss = Qa(), e1 = n._debugTask != null ? n._debugTask : null, 0 > Qc) && (n = Jd(), o = us(), (n !== kf || o !== Ch) && (kf = -1.1), Pf = n, Ch = o);
    }
    function Ul() {
      var n = yh;
      return yh = 0, n;
    }
    function xd(n) {
      var o = yh;
      return yh = n, o;
    }
    function zo(n) {
      var o = yh;
      return yh += n, o;
    }
    function mc() {
      tn = Bt = -1.1;
    }
    function _r() {
      var n = Bt;
      return Bt = -1.1, n;
    }
    function _a(n) {
      0 <= n && (Bt = n);
    }
    function Ki() {
      var n = ma;
      return ma = -0, n;
    }
    function gi(n) {
      0 <= n && (ma = n);
    }
    function vi() {
      var n = na;
      return na = null, n;
    }
    function Yi() {
      var n = Ca;
      return Ca = !1, n;
    }
    function Ns(n) {
      Ni = Qa(), 0 > n.actualStartTime && (n.actualStartTime = Ni);
    }
    function kp(n) {
      if (0 <= Ni) {
        var o = Qa() - Ni;
        n.actualDuration += o, n.selfBaseDuration = o, Ni = -1;
      }
    }
    function gm(n) {
      if (0 <= Ni) {
        var o = Qa() - Ni;
        n.actualDuration += o, Ni = -1;
      }
    }
    function jo() {
      if (0 <= Ni) {
        var n = Qa(), o = n - Ni;
        Ni = -1, yh += o, ma += o, tn = n;
      }
    }
    function Vb(n) {
      na === null && (na = []), na.push(n), Kc === null && (Kc = []), Kc.push(n);
    }
    function ca() {
      Ni = Qa(), 0 > Bt && (Bt = Ni);
    }
    function hc(n) {
      for (var o = n.child; o; )
        n.actualDuration += o.actualDuration, o = o.sibling;
    }
    function Ds(n, o) {
      if (n1 === null) {
        var s = n1 = [];
        GC = 0, xh = u2(), r0 = {
          status: "pending",
          value: void 0,
          then: function(h) {
            s.push(h);
          }
        };
      }
      return GC++, o.then(dv, dv), o;
    }
    function dv() {
      if (--GC === 0 && (-1 < Ss || (Qc = -1.1), n1 !== null)) {
        r0 !== null && (r0.status = "fulfilled");
        var n = n1;
        n1 = null, xh = 0, r0 = null;
        for (var o = 0; o < n.length; o++) (0, n[o])();
      }
    }
    function Mp(n, o) {
      var s = [], h = {
        status: "pending",
        value: null,
        reason: null,
        then: function(y) {
          s.push(y);
        }
      };
      return n.then(
        function() {
          h.status = "fulfilled", h.value = o;
          for (var y = 0; y < s.length; y++) (0, s[y])(o);
        },
        function(y) {
          for (h.status = "rejected", h.reason = y, y = 0; y < s.length; y++)
            (0, s[y])(void 0);
        }
      ), h;
    }
    function $s() {
      var n = Eh.current;
      return n !== null ? n : Lr.pooledCache;
    }
    function Ed(n, o) {
      o === null ? Y(Eh, Eh.current, n) : Y(Eh, o.pool, n);
    }
    function fv() {
      var n = $s();
      return n === null ? null : { parent: Ya._currentValue, pool: n };
    }
    function Op() {
      return { didWarnAboutUncachedPromise: !1, thenables: [] };
    }
    function mv(n) {
      return n = n.status, n === "fulfilled" || n === "rejected";
    }
    function bi(n, o, s) {
      Xe.actQueue !== null && (Xe.didUsePromise = !0);
      var h = n.thenables;
      if (s = h[s], s === void 0 ? h.push(o) : s !== o && (n.didWarnAboutUncachedPromise || (n.didWarnAboutUncachedPromise = !0, console.error(
        "A component was suspended by an uncached promise. Creating promises inside a Client Component or hook is not yet supported, except via a Suspense-compatible library or framework."
      )), o.then(tr, tr), o = s), o._debugInfo === void 0) {
        n = performance.now(), h = o.displayName;
        var y = {
          name: typeof h == "string" ? h : "Promise",
          start: n,
          end: n,
          value: o
        };
        o._debugInfo = [{ awaited: y }], o.status !== "fulfilled" && o.status !== "rejected" && (n = function() {
          y.end = performance.now();
        }, o.then(n, n));
      }
      switch (o.status) {
        case "fulfilled":
          return o.value;
        case "rejected":
          throw n = o.reason, vm(n), n;
        default:
          if (typeof o.status == "string")
            o.then(tr, tr);
          else {
            if (n = Lr, n !== null && 100 < n.shellSuspendCounter)
              throw Error(
                "An unknown Component is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server."
              );
            n = o, n.status = "pending", n.then(
              function(C) {
                if (o.status === "pending") {
                  var A = o;
                  A.status = "fulfilled", A.value = C;
                }
              },
              function(C) {
                if (o.status === "pending") {
                  var A = o;
                  A.status = "rejected", A.reason = C;
                }
              }
            );
          }
          switch (o.status) {
            case "fulfilled":
              return o.value;
            case "rejected":
              throw n = o.reason, vm(n), n;
          }
          throw kh = o, u1 = !0, a0;
      }
    }
    function yi(n) {
      try {
        return sT(n);
      } catch (o) {
        throw o !== null && typeof o == "object" && typeof o.then == "function" ? (kh = o, u1 = !0, a0) : o;
      }
    }
    function pc() {
      if (kh === null)
        throw Error(
          "Expected a suspended thenable. This is a bug in React. Please file an issue."
        );
      var n = kh;
      return kh = null, u1 = !1, n;
    }
    function vm(n) {
      if (n === a0 || n === cw)
        throw Error(
          "Hooks are not supported inside an async component. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server."
        );
    }
    function va(n) {
      var o = Nn;
      return n != null && (Nn = o === null ? n : o.concat(n)), o;
    }
    function Jo() {
      var n = Nn;
      if (n != null) {
        for (var o = n.length - 1; 0 <= o; o--)
          if (n[o].name != null) {
            var s = n[o].debugTask;
            if (s != null) return s;
          }
      }
      return null;
    }
    function Io(n, o, s) {
      for (var h = Object.keys(n.props), y = 0; y < h.length; y++) {
        var C = h[y];
        if (C !== "children" && C !== "key") {
          o === null && (o = fu(n, s.mode, 0), o._debugInfo = Nn, o.return = s), le(
            o,
            function(A) {
              console.error(
                "Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.",
                A
              );
            },
            C
          );
          break;
        }
      }
    }
    function yl(n) {
      var o = c1;
      return c1 += 1, o0 === null && (o0 = Op()), bi(o0, n, o);
    }
    function Zo(n, o) {
      o = o.props.ref, n.ref = o !== void 0 ? o : null;
    }
    function wl(n, o) {
      throw o.$$typeof === Ly ? Error(
        `A React Element from an older version of React was rendered. This is not supported. It can happen if:
- Multiple copies of the "react" package is used.
- A library pre-bundled an old copy of "react" or "react/jsx-runtime".
- A compiler tries to "inline" JSX instead of using the runtime.`
      ) : (n = Object.prototype.toString.call(o), Error(
        "Objects are not valid as a React child (found: " + (n === "[object Object]" ? "object with keys {" + Object.keys(o).join(", ") + "}" : n) + "). If you meant to render a collection of children, use an array instead."
      ));
    }
    function Qi(n, o) {
      var s = Jo();
      s !== null ? s.run(
        wl.bind(null, n, o)
      ) : wl(n, o);
    }
    function hv(n, o) {
      var s = W(n) || "Component";
      a8[s] || (a8[s] = !0, o = o.displayName || o.name || "Component", n.tag === 3 ? console.error(
        `Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.
  root.render(%s)`,
        o,
        o,
        o
      ) : console.error(
        `Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.
  <%s>{%s}</%s>`,
        o,
        o,
        s,
        o,
        s
      ));
    }
    function Pd(n, o) {
      var s = Jo();
      s !== null ? s.run(
        hv.bind(null, n, o)
      ) : hv(n, o);
    }
    function Tp(n, o) {
      var s = W(n) || "Component";
      o8[s] || (o8[s] = !0, o = String(o), n.tag === 3 ? console.error(
        `Symbols are not valid as a React child.
  root.render(%s)`,
        o
      ) : console.error(
        `Symbols are not valid as a React child.
  <%s>%s</%s>`,
        s,
        o,
        s
      ));
    }
    function bm(n, o) {
      var s = Jo();
      s !== null ? s.run(
        Tp.bind(null, n, o)
      ) : Tp(n, o);
    }
    function Ba(n) {
      function o(ue, he) {
        if (n) {
          var Se = ue.deletions;
          Se === null ? (ue.deletions = [he], ue.flags |= 16) : Se.push(he);
        }
      }
      function s(ue, he) {
        if (!n) return null;
        for (; he !== null; )
          o(ue, he), he = he.sibling;
        return null;
      }
      function h(ue) {
        for (var he = /* @__PURE__ */ new Map(); ue !== null; )
          ue.key !== null ? he.set(ue.key, ue) : he.set(ue.index, ue), ue = ue.sibling;
        return he;
      }
      function y(ue, he) {
        return ue = _l(ue, he), ue.index = 0, ue.sibling = null, ue;
      }
      function C(ue, he, Se) {
        return ue.index = Se, n ? (Se = ue.alternate, Se !== null ? (Se = Se.index, Se < he ? (ue.flags |= 67108866, he) : Se) : (ue.flags |= 67108866, he)) : (ue.flags |= 1048576, he);
      }
      function A(ue) {
        return n && ue.alternate === null && (ue.flags |= 67108866), ue;
      }
      function z(ue, he, Se, Ze) {
        return he === null || he.tag !== 6 ? (he = wd(
          Se,
          ue.mode,
          Ze
        ), he.return = ue, he._debugOwner = ue, he._debugTask = ue._debugTask, he._debugInfo = Nn, he) : (he = y(he, Se), he.return = ue, he._debugInfo = Nn, he);
      }
      function q(ue, he, Se, Ze) {
        var xt = Se.type;
        return xt === of ? (he = xe(
          ue,
          he,
          Se.props.children,
          Ze,
          Se.key
        ), Io(Se, he, ue), he) : he !== null && (he.elementType === xt || rv(he, Se) || typeof xt == "object" && xt !== null && xt.$$typeof === Eo && yi(xt) === he.type) ? (he = y(he, Se.props), Zo(he, Se), he.return = ue, he._debugOwner = Se._owner, he._debugInfo = Nn, he) : (he = fu(Se, ue.mode, Ze), Zo(he, Se), he.return = ue, he._debugInfo = Nn, he);
      }
      function Z(ue, he, Se, Ze) {
        return he === null || he.tag !== 4 || he.stateNode.containerInfo !== Se.containerInfo || he.stateNode.implementation !== Se.implementation ? (he = Sp(Se, ue.mode, Ze), he.return = ue, he._debugInfo = Nn, he) : (he = y(he, Se.children || []), he.return = ue, he._debugInfo = Nn, he);
      }
      function xe(ue, he, Se, Ze, xt) {
        return he === null || he.tag !== 7 ? (he = uc(
          Se,
          ue.mode,
          Ze,
          xt
        ), he.return = ue, he._debugOwner = ue, he._debugTask = ue._debugTask, he._debugInfo = Nn, he) : (he = y(he, Se), he.return = ue, he._debugInfo = Nn, he);
      }
      function ke(ue, he, Se) {
        if (typeof he == "string" && he !== "" || typeof he == "number" || typeof he == "bigint")
          return he = wd(
            "" + he,
            ue.mode,
            Se
          ), he.return = ue, he._debugOwner = ue, he._debugTask = ue._debugTask, he._debugInfo = Nn, he;
        if (typeof he == "object" && he !== null) {
          switch (he.$$typeof) {
            case nl:
              return Se = fu(
                he,
                ue.mode,
                Se
              ), Zo(Se, he), Se.return = ue, ue = va(he._debugInfo), Se._debugInfo = Nn, Nn = ue, Se;
            case Lu:
              return he = Sp(
                he,
                ue.mode,
                Se
              ), he.return = ue, he._debugInfo = Nn, he;
            case Eo:
              var Ze = va(he._debugInfo);
              return he = yi(he), ue = ke(ue, he, Se), Nn = Ze, ue;
          }
          if (Ta(he) || L(he))
            return Se = uc(
              he,
              ue.mode,
              Se,
              null
            ), Se.return = ue, Se._debugOwner = ue, Se._debugTask = ue._debugTask, ue = va(he._debugInfo), Se._debugInfo = Nn, Nn = ue, Se;
          if (typeof he.then == "function")
            return Ze = va(he._debugInfo), ue = ke(
              ue,
              yl(he),
              Se
            ), Nn = Ze, ue;
          if (he.$$typeof === Nl)
            return ke(
              ue,
              hm(ue, he),
              Se
            );
          Qi(ue, he);
        }
        return typeof he == "function" && Pd(ue, he), typeof he == "symbol" && bm(ue, he), null;
      }
      function de(ue, he, Se, Ze) {
        var xt = he !== null ? he.key : null;
        if (typeof Se == "string" && Se !== "" || typeof Se == "number" || typeof Se == "bigint")
          return xt !== null ? null : z(ue, he, "" + Se, Ze);
        if (typeof Se == "object" && Se !== null) {
          switch (Se.$$typeof) {
            case nl:
              return Se.key === xt ? (xt = va(Se._debugInfo), ue = q(
                ue,
                he,
                Se,
                Ze
              ), Nn = xt, ue) : null;
            case Lu:
              return Se.key === xt ? Z(ue, he, Se, Ze) : null;
            case Eo:
              return xt = va(Se._debugInfo), Se = yi(Se), ue = de(
                ue,
                he,
                Se,
                Ze
              ), Nn = xt, ue;
          }
          if (Ta(Se) || L(Se))
            return xt !== null ? null : (xt = va(Se._debugInfo), ue = xe(
              ue,
              he,
              Se,
              Ze,
              null
            ), Nn = xt, ue);
          if (typeof Se.then == "function")
            return xt = va(Se._debugInfo), ue = de(
              ue,
              he,
              yl(Se),
              Ze
            ), Nn = xt, ue;
          if (Se.$$typeof === Nl)
            return de(
              ue,
              he,
              hm(ue, Se),
              Ze
            );
          Qi(ue, Se);
        }
        return typeof Se == "function" && Pd(ue, Se), typeof Se == "symbol" && bm(ue, Se), null;
      }
      function Ve(ue, he, Se, Ze, xt) {
        if (typeof Ze == "string" && Ze !== "" || typeof Ze == "number" || typeof Ze == "bigint")
          return ue = ue.get(Se) || null, z(he, ue, "" + Ze, xt);
        if (typeof Ze == "object" && Ze !== null) {
          switch (Ze.$$typeof) {
            case nl:
              return Se = ue.get(
                Ze.key === null ? Se : Ze.key
              ) || null, ue = va(Ze._debugInfo), he = q(
                he,
                Se,
                Ze,
                xt
              ), Nn = ue, he;
            case Lu:
              return ue = ue.get(
                Ze.key === null ? Se : Ze.key
              ) || null, Z(he, ue, Ze, xt);
            case Eo:
              var cn = va(Ze._debugInfo);
              return Ze = yi(Ze), he = Ve(
                ue,
                he,
                Se,
                Ze,
                xt
              ), Nn = cn, he;
          }
          if (Ta(Ze) || L(Ze))
            return Se = ue.get(Se) || null, ue = va(Ze._debugInfo), he = xe(
              he,
              Se,
              Ze,
              xt,
              null
            ), Nn = ue, he;
          if (typeof Ze.then == "function")
            return cn = va(Ze._debugInfo), he = Ve(
              ue,
              he,
              Se,
              yl(Ze),
              xt
            ), Nn = cn, he;
          if (Ze.$$typeof === Nl)
            return Ve(
              ue,
              he,
              Se,
              hm(he, Ze),
              xt
            );
          Qi(he, Ze);
        }
        return typeof Ze == "function" && Pd(he, Ze), typeof Ze == "symbol" && bm(he, Ze), null;
      }
      function yt(ue, he, Se, Ze) {
        if (typeof Se != "object" || Se === null) return Ze;
        switch (Se.$$typeof) {
          case nl:
          case Lu:
            b(ue, he, Se);
            var xt = Se.key;
            if (typeof xt != "string") break;
            if (Ze === null) {
              Ze = /* @__PURE__ */ new Set(), Ze.add(xt);
              break;
            }
            if (!Ze.has(xt)) {
              Ze.add(xt);
              break;
            }
            le(he, function() {
              console.error(
                "Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.",
                xt
              );
            });
            break;
          case Eo:
            Se = yi(Se), yt(ue, he, Se, Ze);
        }
        return Ze;
      }
      function Mt(ue, he, Se, Ze) {
        for (var xt = null, cn = null, _t = null, Ht = he, kn = he = 0, Kr = null; Ht !== null && kn < Se.length; kn++) {
          Ht.index > kn ? (Kr = Ht, Ht = null) : Kr = Ht.sibling;
          var Fa = de(
            ue,
            Ht,
            Se[kn],
            Ze
          );
          if (Fa === null) {
            Ht === null && (Ht = Kr);
            break;
          }
          xt = yt(
            ue,
            Fa,
            Se[kn],
            xt
          ), n && Ht && Fa.alternate === null && o(ue, Ht), he = C(Fa, he, kn), _t === null ? cn = Fa : _t.sibling = Fa, _t = Fa, Ht = Kr;
        }
        if (kn === Se.length)
          return s(ue, Ht), Xn && gl(ue, kn), cn;
        if (Ht === null) {
          for (; kn < Se.length; kn++)
            Ht = ke(ue, Se[kn], Ze), Ht !== null && (xt = yt(
              ue,
              Ht,
              Se[kn],
              xt
            ), he = C(
              Ht,
              he,
              kn
            ), _t === null ? cn = Ht : _t.sibling = Ht, _t = Ht);
          return Xn && gl(ue, kn), cn;
        }
        for (Ht = h(Ht); kn < Se.length; kn++)
          Kr = Ve(
            Ht,
            ue,
            kn,
            Se[kn],
            Ze
          ), Kr !== null && (xt = yt(
            ue,
            Kr,
            Se[kn],
            xt
          ), n && Kr.alternate !== null && Ht.delete(
            Kr.key === null ? kn : Kr.key
          ), he = C(
            Kr,
            he,
            kn
          ), _t === null ? cn = Kr : _t.sibling = Kr, _t = Kr);
        return n && Ht.forEach(function(ad) {
          return o(ue, ad);
        }), Xn && gl(ue, kn), cn;
      }
      function Vr(ue, he, Se, Ze) {
        if (Se == null)
          throw Error("An iterable object provided no iterator.");
        for (var xt = null, cn = null, _t = he, Ht = he = 0, kn = null, Kr = null, Fa = Se.next(); _t !== null && !Fa.done; Ht++, Fa = Se.next()) {
          _t.index > Ht ? (kn = _t, _t = null) : kn = _t.sibling;
          var ad = de(ue, _t, Fa.value, Ze);
          if (ad === null) {
            _t === null && (_t = kn);
            break;
          }
          Kr = yt(
            ue,
            ad,
            Fa.value,
            Kr
          ), n && _t && ad.alternate === null && o(ue, _t), he = C(ad, he, Ht), cn === null ? xt = ad : cn.sibling = ad, cn = ad, _t = kn;
        }
        if (Fa.done)
          return s(ue, _t), Xn && gl(ue, Ht), xt;
        if (_t === null) {
          for (; !Fa.done; Ht++, Fa = Se.next())
            _t = ke(ue, Fa.value, Ze), _t !== null && (Kr = yt(
              ue,
              _t,
              Fa.value,
              Kr
            ), he = C(
              _t,
              he,
              Ht
            ), cn === null ? xt = _t : cn.sibling = _t, cn = _t);
          return Xn && gl(ue, Ht), xt;
        }
        for (_t = h(_t); !Fa.done; Ht++, Fa = Se.next())
          kn = Ve(
            _t,
            ue,
            Ht,
            Fa.value,
            Ze
          ), kn !== null && (Kr = yt(
            ue,
            kn,
            Fa.value,
            Kr
          ), n && kn.alternate !== null && _t.delete(
            kn.key === null ? Ht : kn.key
          ), he = C(
            kn,
            he,
            Ht
          ), cn === null ? xt = kn : cn.sibling = kn, cn = kn);
        return n && _t.forEach(function(NT) {
          return o(ue, NT);
        }), Xn && gl(ue, Ht), xt;
      }
      function Yn(ue, he, Se, Ze) {
        if (typeof Se == "object" && Se !== null && Se.type === of && Se.key === null && (Io(Se, null, ue), Se = Se.props.children), typeof Se == "object" && Se !== null) {
          switch (Se.$$typeof) {
            case nl:
              var xt = va(Se._debugInfo);
              e: {
                for (var cn = Se.key; he !== null; ) {
                  if (he.key === cn) {
                    if (cn = Se.type, cn === of) {
                      if (he.tag === 7) {
                        s(
                          ue,
                          he.sibling
                        ), Ze = y(
                          he,
                          Se.props.children
                        ), Ze.return = ue, Ze._debugOwner = Se._owner, Ze._debugInfo = Nn, Io(Se, Ze, ue), ue = Ze;
                        break e;
                      }
                    } else if (he.elementType === cn || rv(
                      he,
                      Se
                    ) || typeof cn == "object" && cn !== null && cn.$$typeof === Eo && yi(cn) === he.type) {
                      s(
                        ue,
                        he.sibling
                      ), Ze = y(he, Se.props), Zo(Ze, Se), Ze.return = ue, Ze._debugOwner = Se._owner, Ze._debugInfo = Nn, ue = Ze;
                      break e;
                    }
                    s(ue, he);
                    break;
                  } else o(ue, he);
                  he = he.sibling;
                }
                Se.type === of ? (Ze = uc(
                  Se.props.children,
                  ue.mode,
                  Ze,
                  Se.key
                ), Ze.return = ue, Ze._debugOwner = ue, Ze._debugTask = ue._debugTask, Ze._debugInfo = Nn, Io(Se, Ze, ue), ue = Ze) : (Ze = fu(
                  Se,
                  ue.mode,
                  Ze
                ), Zo(Ze, Se), Ze.return = ue, Ze._debugInfo = Nn, ue = Ze);
              }
              return ue = A(ue), Nn = xt, ue;
            case Lu:
              e: {
                for (xt = Se, Se = xt.key; he !== null; ) {
                  if (he.key === Se)
                    if (he.tag === 4 && he.stateNode.containerInfo === xt.containerInfo && he.stateNode.implementation === xt.implementation) {
                      s(
                        ue,
                        he.sibling
                      ), Ze = y(
                        he,
                        xt.children || []
                      ), Ze.return = ue, ue = Ze;
                      break e;
                    } else {
                      s(ue, he);
                      break;
                    }
                  else o(ue, he);
                  he = he.sibling;
                }
                Ze = Sp(
                  xt,
                  ue.mode,
                  Ze
                ), Ze.return = ue, ue = Ze;
              }
              return A(ue);
            case Eo:
              return xt = va(Se._debugInfo), Se = yi(Se), ue = Yn(
                ue,
                he,
                Se,
                Ze
              ), Nn = xt, ue;
          }
          if (Ta(Se))
            return xt = va(Se._debugInfo), ue = Mt(
              ue,
              he,
              Se,
              Ze
            ), Nn = xt, ue;
          if (L(Se)) {
            if (xt = va(Se._debugInfo), cn = L(Se), typeof cn != "function")
              throw Error(
                "An object is not an iterable. This error is likely caused by a bug in React. Please file an issue."
              );
            var _t = cn.call(Se);
            return _t === Se ? (ue.tag !== 0 || Object.prototype.toString.call(ue.type) !== "[object GeneratorFunction]" || Object.prototype.toString.call(_t) !== "[object Generator]") && (n8 || console.error(
              "Using Iterators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. You can also use an Iterable that can iterate multiple times over the same items."
            ), n8 = !0) : Se.entries !== cn || QC || (console.error(
              "Using Maps as children is not supported. Use an array of keyed ReactElements instead."
            ), QC = !0), ue = Vr(
              ue,
              he,
              _t,
              Ze
            ), Nn = xt, ue;
          }
          if (typeof Se.then == "function")
            return xt = va(Se._debugInfo), ue = Yn(
              ue,
              he,
              yl(Se),
              Ze
            ), Nn = xt, ue;
          if (Se.$$typeof === Nl)
            return Yn(
              ue,
              he,
              hm(ue, Se),
              Ze
            );
          Qi(ue, Se);
        }
        return typeof Se == "string" && Se !== "" || typeof Se == "number" || typeof Se == "bigint" ? (xt = "" + Se, he !== null && he.tag === 6 ? (s(
          ue,
          he.sibling
        ), Ze = y(he, xt), Ze.return = ue, ue = Ze) : (s(ue, he), Ze = wd(
          xt,
          ue.mode,
          Ze
        ), Ze.return = ue, Ze._debugOwner = ue, Ze._debugTask = ue._debugTask, Ze._debugInfo = Nn, ue = Ze), A(ue)) : (typeof Se == "function" && Pd(ue, Se), typeof Se == "symbol" && bm(ue, Se), s(ue, he));
      }
      return function(ue, he, Se, Ze) {
        var xt = Nn;
        Nn = null;
        try {
          c1 = 0;
          var cn = Yn(
            ue,
            he,
            Se,
            Ze
          );
          return o0 = null, cn;
        } catch (Kr) {
          if (Kr === a0 || Kr === cw) throw Kr;
          var _t = x(29, Kr, null, ue.mode);
          _t.lanes = Ze, _t.return = ue;
          var Ht = _t._debugInfo = Nn;
          if (_t._debugOwner = ue._debugOwner, _t._debugTask = ue._debugTask, Ht != null) {
            for (var kn = Ht.length - 1; 0 <= kn; kn--)
              if (typeof Ht[kn].stack == "string") {
                _t._debugOwner = Ht[kn], _t._debugTask = Ht[kn].debugTask;
                break;
              }
          }
          return _t;
        } finally {
          Nn = xt;
        }
      };
    }
    function $r(n, o) {
      var s = Ta(n);
      return n = !s && typeof L(n) == "function", s || n ? (s = s ? "array" : "iterable", console.error(
        "A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>",
        s,
        o,
        s
      ), !1) : !0;
    }
    function _n(n) {
      n.updateQueue = {
        baseState: n.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: { pending: null, lanes: 0, hiddenCallbacks: null },
        callbacks: null
      };
    }
    function Xl(n, o) {
      n = n.updateQueue, o.updateQueue === n && (o.updateQueue = {
        baseState: n.baseState,
        firstBaseUpdate: n.firstBaseUpdate,
        lastBaseUpdate: n.lastBaseUpdate,
        shared: n.shared,
        callbacks: null
      });
    }
    function $a(n) {
      return {
        lane: n,
        tag: l8,
        payload: null,
        callback: null,
        next: null
      };
    }
    function Gl(n, o, s) {
      var h = n.updateQueue;
      if (h === null) return null;
      if (h = h.shared, ZC === h && !c8) {
        var y = W(n);
        console.error(
          `An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.

Please update the following component: %s`,
          y
        ), c8 = !0;
      }
      return (ar & po) !== Oo ? (y = h.pending, y === null ? o.next = o : (o.next = y.next, y.next = o), h.pending = o, o = dm(n), nv(n, null, s), o) : (yd(n, h, o, s), dm(n));
    }
    function Ji(n, o, s) {
      if (o = o.updateQueue, o !== null && (o = o.shared, (s & 4194048) !== 0)) {
        var h = o.lanes;
        h &= n.pendingLanes, s |= h, o.lanes = s, ct(n, s);
      }
    }
    function ym(n, o) {
      var s = n.updateQueue, h = n.alternate;
      if (h !== null && (h = h.updateQueue, s === h)) {
        var y = null, C = null;
        if (s = s.firstBaseUpdate, s !== null) {
          do {
            var A = {
              lane: s.lane,
              tag: s.tag,
              payload: s.payload,
              callback: null,
              next: null
            };
            C === null ? y = C = A : C = C.next = A, s = s.next;
          } while (s !== null);
          C === null ? y = C = o : C = C.next = o;
        } else y = C = o;
        s = {
          baseState: h.baseState,
          firstBaseUpdate: y,
          lastBaseUpdate: C,
          shared: h.shared,
          callbacks: h.callbacks
        }, n.updateQueue = s;
        return;
      }
      n = s.lastBaseUpdate, n === null ? s.firstBaseUpdate = o : n.next = o, s.lastBaseUpdate = o;
    }
    function kd() {
      if (e4) {
        var n = r0;
        if (n !== null) throw n;
      }
    }
    function ql(n, o, s, h) {
      e4 = !1;
      var y = n.updateQueue;
      Mf = !1, ZC = y.shared;
      var C = y.firstBaseUpdate, A = y.lastBaseUpdate, z = y.shared.pending;
      if (z !== null) {
        y.shared.pending = null;
        var q = z, Z = q.next;
        q.next = null, A === null ? C = Z : A.next = Z, A = q;
        var xe = n.alternate;
        xe !== null && (xe = xe.updateQueue, z = xe.lastBaseUpdate, z !== A && (z === null ? xe.firstBaseUpdate = Z : z.next = Z, xe.lastBaseUpdate = q));
      }
      if (C !== null) {
        var ke = y.baseState;
        A = 0, xe = Z = q = null, z = C;
        do {
          var de = z.lane & -536870913, Ve = de !== z.lane;
          if (Ve ? (Dn & de) === de : (h & de) === de) {
            de !== 0 && de === xh && (e4 = !0), xe !== null && (xe = xe.next = {
              lane: 0,
              tag: z.tag,
              payload: z.payload,
              callback: null,
              next: null
            });
            e: {
              de = n;
              var yt = z, Mt = o, Vr = s;
              switch (yt.tag) {
                case s8:
                  if (yt = yt.payload, typeof yt == "function") {
                    t0 = !0;
                    var Yn = yt.call(
                      Vr,
                      ke,
                      Mt
                    );
                    if (de.mode & ii) {
                      Oe(!0);
                      try {
                        yt.call(Vr, ke, Mt);
                      } finally {
                        Oe(!1);
                      }
                    }
                    t0 = !1, ke = Yn;
                    break e;
                  }
                  ke = yt;
                  break e;
                case JC:
                  de.flags = de.flags & -65537 | 128;
                case l8:
                  if (Yn = yt.payload, typeof Yn == "function") {
                    if (t0 = !0, yt = Yn.call(
                      Vr,
                      ke,
                      Mt
                    ), de.mode & ii) {
                      Oe(!0);
                      try {
                        Yn.call(Vr, ke, Mt);
                      } finally {
                        Oe(!1);
                      }
                    }
                    t0 = !1;
                  } else yt = Yn;
                  if (yt == null) break e;
                  ke = Rn({}, ke, yt);
                  break e;
                case u8:
                  Mf = !0;
              }
            }
            de = z.callback, de !== null && (n.flags |= 64, Ve && (n.flags |= 8192), Ve = y.callbacks, Ve === null ? y.callbacks = [de] : Ve.push(de));
          } else
            Ve = {
              lane: de,
              tag: z.tag,
              payload: z.payload,
              callback: z.callback,
              next: null
            }, xe === null ? (Z = xe = Ve, q = ke) : xe = xe.next = Ve, A |= de;
          if (z = z.next, z === null) {
            if (z = y.shared.pending, z === null)
              break;
            Ve = z, z = Ve.next, Ve.next = null, y.lastBaseUpdate = Ve, y.shared.pending = null;
          }
        } while (!0);
        xe === null && (q = ke), y.baseState = q, y.firstBaseUpdate = Z, y.lastBaseUpdate = xe, C === null && (y.shared.lanes = 0), Rf |= A, n.lanes = A, n.memoizedState = ke;
      }
      ZC = null;
    }
    function vu(n, o) {
      if (typeof n != "function")
        throw Error(
          "Invalid argument passed as callback. Expected a function. Instead received: " + n
        );
      n.call(o);
    }
    function pv(n, o) {
      var s = n.shared.hiddenCallbacks;
      if (s !== null)
        for (n.shared.hiddenCallbacks = null, n = 0; n < s.length; n++)
          vu(s[n], o);
    }
    function Md(n, o) {
      var s = n.callbacks;
      if (s !== null)
        for (n.callbacks = null, n = 0; n < s.length; n++)
          vu(s[n], o);
    }
    function Rp(n, o) {
      var s = Xu;
      Y(fw, s, n), Y(i0, o, n), Xu = s | o.baseLanes;
    }
    function zs(n) {
      Y(fw, Xu, n), Y(
        i0,
        i0.current,
        n
      );
    }
    function Sl(n) {
      Xu = fw.current, U(i0, n), U(fw, n);
    }
    function Lo(n) {
      var o = n.alternate;
      Y(
        Ha,
        Ha.current & l0,
        n
      ), Y(jl, n, n), Ms === null && (o === null || i0.current !== null || o.memoizedState !== null) && (Ms = n);
    }
    function Cl(n) {
      Y(Ha, Ha.current, n), Y(jl, n, n), Ms === null && (Ms = n);
    }
    function Ap(n) {
      n.tag === 22 ? (Y(Ha, Ha.current, n), Y(jl, n, n), Ms === null && (Ms = n)) : Kl(n);
    }
    function Kl(n) {
      Y(Ha, Ha.current, n), Y(
        jl,
        jl.current,
        n
      );
    }
    function Ua(n) {
      U(jl, n), Ms === n && (Ms = null), U(Ha, n);
    }
    function gc(n) {
      for (var o = n; o !== null; ) {
        if (o.tag === 13) {
          var s = o.memoizedState;
          if (s !== null && (s = s.dehydrated, s === null || th(s) || f2(s)))
            return o;
        } else if (o.tag === 19 && (o.memoizedProps.revealOrder === "forwards" || o.memoizedProps.revealOrder === "backwards" || o.memoizedProps.revealOrder === "unstable_legacy-backwards" || o.memoizedProps.revealOrder === "together")) {
          if ((o.flags & 128) !== 0) return o;
        } else if (o.child !== null) {
          o.child.return = o, o = o.child;
          continue;
        }
        if (o === n) break;
        for (; o.sibling === null; ) {
          if (o.return === null || o.return === n) return null;
          o = o.return;
        }
        o.sibling.return = o.return, o = o.sibling;
      }
      return null;
    }
    function sn() {
      var n = Be;
      xs === null ? xs = [n] : xs.push(n);
    }
    function rt() {
      var n = Be;
      if (xs !== null && (ed++, xs[ed] !== n)) {
        var o = W(un);
        if (!d8.has(o) && (d8.add(o), xs !== null)) {
          for (var s = "", h = 0; h <= ed; h++) {
            var y = xs[h], C = h === ed ? n : y;
            for (y = h + 1 + ". " + y; 30 > y.length; )
              y += " ";
            y += C + `
`, s += y;
          }
          console.error(
            `React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://react.dev/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`,
            o,
            s
          );
        }
      }
    }
    function js(n) {
      n == null || Ta(n) || console.error(
        "%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.",
        Be,
        typeof n
      );
    }
    function wm() {
      var n = W(un);
      m8.has(n) || (m8.add(n), console.error(
        "ReactDOM.useFormState has been renamed to React.useActionState. Please update %s to use React.useActionState.",
        n
      ));
    }
    function da() {
      throw Error(
        `Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.`
      );
    }
    function gv(n, o) {
      if (m1) return !1;
      if (o === null)
        return console.error(
          "%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.",
          Be
        ), !1;
      n.length !== o.length && console.error(
        `The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`,
        Be,
        "[" + o.join(", ") + "]",
        "[" + n.join(", ") + "]"
      );
      for (var s = 0; s < o.length && s < n.length; s++)
        if (!Ai(n[s], o[s])) return !1;
      return !0;
    }
    function vv(n, o, s, h, y, C) {
      Jc = C, un = o, xs = n !== null ? n._debugHookTypes : null, ed = -1, m1 = n !== null && n.type !== o.type, (Object.prototype.toString.call(s) === "[object AsyncFunction]" || Object.prototype.toString.call(s) === "[object AsyncGeneratorFunction]") && (C = W(un), t4.has(C) || (t4.add(C), console.error(
        "%s is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server.",
        C === null ? "An unknown Component" : "<" + C + ">"
      ))), o.memoizedState = null, o.updateQueue = null, o.lanes = 0, Xe.H = n !== null && n.memoizedState !== null ? r4 : xs !== null ? h8 : n4, Oh = C = (o.mode & ii) !== on;
      var A = qC(s, h, y);
      if (Oh = !1, u0 && (A = Sm(
        o,
        s,
        h,
        y
      )), C) {
        Oe(!0);
        try {
          A = Sm(
            o,
            s,
            h,
            y
          );
        } finally {
          Oe(!1);
        }
      }
      return ba(n, o), A;
    }
    function ba(n, o) {
      o._debugHookTypes = xs, o.dependencies === null ? Zc !== null && (o.dependencies = {
        lanes: 0,
        firstContext: null,
        _debugThenableState: Zc
      }) : o.dependencies._debugThenableState = Zc, Xe.H = h1;
      var s = Ir !== null && Ir.next !== null;
      if (Jc = 0, xs = Be = Ja = Ir = un = null, ed = -1, n !== null && (n.flags & 65011712) !== (o.flags & 65011712) && console.error(
        "Internal React error: Expected static flag was missing. Please notify the React team."
      ), hw = !1, f1 = 0, Zc = null, s)
        throw Error(
          "Rendered fewer hooks than expected. This may be caused by an accidental early return statement."
        );
      n === null || Za || (n = n.dependencies, n !== null && Cd(n) && (Za = !0)), u1 ? (u1 = !1, n = !0) : n = !1, n && (o = W(o) || "Unknown", f8.has(o) || t4.has(o) || (f8.add(o), console.error(
        "`use` was called from inside a try/catch block. This is not allowed and can lead to unexpected behavior. To handle errors triggered by `use`, wrap your component in a error boundary."
      )));
    }
    function Sm(n, o, s, h) {
      un = n;
      var y = 0;
      do {
        if (u0 && (Zc = null), f1 = 0, u0 = !1, y >= cT)
          throw Error(
            "Too many re-renders. React limits the number of renders to prevent an infinite loop."
          );
        if (y += 1, m1 = !1, Ja = Ir = null, n.updateQueue != null) {
          var C = n.updateQueue;
          C.lastEffect = null, C.events = null, C.stores = null, C.memoCache != null && (C.memoCache.index = 0);
        }
        ed = -1, Xe.H = p8, C = qC(o, s, h);
      } while (u0);
      return C;
    }
    function Cm() {
      var n = Xe.H, o = n.useState()[0];
      return o = typeof o.then == "function" ? Pm(o) : o, n = n.useState()[0], (Ir !== null ? Ir.memoizedState : null) !== n && (un.flags |= 1024), o;
    }
    function vc() {
      var n = pw !== 0;
      return pw = 0, n;
    }
    function xm(n, o, s) {
      o.updateQueue = n.updateQueue, o.flags = (o.mode & Qs) !== on ? o.flags & -402655237 : o.flags & -2053, n.lanes &= ~s;
    }
    function bu(n) {
      if (hw) {
        for (n = n.memoizedState; n !== null; ) {
          var o = n.queue;
          o !== null && (o.pending = null), n = n.next;
        }
        hw = !1;
      }
      Jc = 0, xs = Ja = Ir = un = null, ed = -1, Be = null, u0 = !1, f1 = pw = 0, Zc = null;
    }
    function Ma() {
      var n = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return Ja === null ? un.memoizedState = Ja = n : Ja = Ja.next = n, Ja;
    }
    function gr() {
      if (Ir === null) {
        var n = un.alternate;
        n = n !== null ? n.memoizedState : null;
      } else n = Ir.next;
      var o = Ja === null ? un.memoizedState : Ja.next;
      if (o !== null)
        Ja = o, Ir = n;
      else {
        if (n === null)
          throw un.alternate === null ? Error(
            "Update hook called on initial render. This is likely a bug in React. Please file an issue."
          ) : Error("Rendered more hooks than during the previous render.");
        Ir = n, n = {
          memoizedState: Ir.memoizedState,
          baseState: Ir.baseState,
          baseQueue: Ir.baseQueue,
          queue: Ir.queue,
          next: null
        }, Ja === null ? un.memoizedState = Ja = n : Ja = Ja.next = n;
      }
      return Ja;
    }
    function Em() {
      return { lastEffect: null, events: null, stores: null, memoCache: null };
    }
    function Pm(n) {
      var o = f1;
      return f1 += 1, Zc === null && (Zc = Op()), n = bi(Zc, n, o), o = un, (Ja === null ? o.memoizedState : Ja.next) === null && (o = o.alternate, Xe.H = o !== null && o.memoizedState !== null ? r4 : n4), n;
    }
    function Is(n) {
      if (n !== null && typeof n == "object") {
        if (typeof n.then == "function") return Pm(n);
        if (n.$$typeof === Nl) return cr(n);
      }
      throw Error("An unsupported type was passed to use(): " + String(n));
    }
    function wi(n) {
      var o = null, s = un.updateQueue;
      if (s !== null && (o = s.memoCache), o == null) {
        var h = un.alternate;
        h !== null && (h = h.updateQueue, h !== null && (h = h.memoCache, h != null && (o = {
          data: h.data.map(function(y) {
            return y.slice();
          }),
          index: 0
        })));
      }
      if (o == null && (o = { data: [], index: 0 }), s === null && (s = Em(), un.updateQueue = s), s.memoCache = o, s = o.data[o.index], s === void 0 || m1)
        for (s = o.data[o.index] = Array(n), h = 0; h < n; h++)
          s[h] = SC;
      else
        s.length !== n && console.error(
          "Expected a constant size argument for each invocation of useMemoCache. The previous cache was allocated with size %s but size %s was requested.",
          s.length,
          n
        );
      return o.index++, s;
    }
    function Si(n, o) {
      return typeof o == "function" ? o(n) : o;
    }
    function Od(n, o, s) {
      var h = Ma();
      if (s !== void 0) {
        var y = s(o);
        if (Oh) {
          Oe(!0);
          try {
            s(o);
          } finally {
            Oe(!1);
          }
        }
      } else y = o;
      return h.memoizedState = h.baseState = y, n = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: n,
        lastRenderedState: y
      }, h.queue = n, n = n.dispatch = gC.bind(
        null,
        un,
        n
      ), [h.memoizedState, n];
    }
    function bc(n) {
      var o = gr();
      return yu(o, Ir, n);
    }
    function yu(n, o, s) {
      var h = n.queue;
      if (h === null)
        throw Error(
          "Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)"
        );
      h.lastRenderedReducer = s;
      var y = n.baseQueue, C = h.pending;
      if (C !== null) {
        if (y !== null) {
          var A = y.next;
          y.next = C.next, C.next = A;
        }
        o.baseQueue !== y && console.error(
          "Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."
        ), o.baseQueue = y = C, h.pending = null;
      }
      if (C = n.baseState, y === null) n.memoizedState = C;
      else {
        o = y.next;
        var z = A = null, q = null, Z = o, xe = !1;
        do {
          var ke = Z.lane & -536870913;
          if (ke !== Z.lane ? (Dn & ke) === ke : (Jc & ke) === ke) {
            var de = Z.revertLane;
            if (de === 0)
              q !== null && (q = q.next = {
                lane: 0,
                revertLane: 0,
                gesture: null,
                action: Z.action,
                hasEagerState: Z.hasEagerState,
                eagerState: Z.eagerState,
                next: null
              }), ke === xh && (xe = !0);
            else if ((Jc & de) === de) {
              Z = Z.next, de === xh && (xe = !0);
              continue;
            } else
              ke = {
                lane: 0,
                revertLane: Z.revertLane,
                gesture: null,
                action: Z.action,
                hasEagerState: Z.hasEagerState,
                eagerState: Z.eagerState,
                next: null
              }, q === null ? (z = q = ke, A = C) : q = q.next = ke, un.lanes |= de, Rf |= de;
            ke = Z.action, Oh && s(C, ke), C = Z.hasEagerState ? Z.eagerState : s(C, ke);
          } else
            de = {
              lane: ke,
              revertLane: Z.revertLane,
              gesture: Z.gesture,
              action: Z.action,
              hasEagerState: Z.hasEagerState,
              eagerState: Z.eagerState,
              next: null
            }, q === null ? (z = q = de, A = C) : q = q.next = de, un.lanes |= ke, Rf |= ke;
          Z = Z.next;
        } while (Z !== null && Z !== o);
        if (q === null ? A = C : q.next = z, !Ai(C, n.memoizedState) && (Za = !0, xe && (s = r0, s !== null)))
          throw s;
        n.memoizedState = C, n.baseState = A, n.baseQueue = q, h.lastRenderedState = C;
      }
      return y === null && (h.lanes = 0), [n.memoizedState, h.dispatch];
    }
    function yc(n) {
      var o = gr(), s = o.queue;
      if (s === null)
        throw Error(
          "Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)"
        );
      s.lastRenderedReducer = n;
      var h = s.dispatch, y = s.pending, C = o.memoizedState;
      if (y !== null) {
        s.pending = null;
        var A = y = y.next;
        do
          C = n(C, A.action), A = A.next;
        while (A !== y);
        Ai(C, o.memoizedState) || (Za = !0), o.memoizedState = C, o.baseQueue === null && (o.baseState = C), s.lastRenderedState = C;
      }
      return [C, h];
    }
    function Td(n, o, s) {
      var h = un, y = Ma();
      if (Xn) {
        if (s === void 0)
          throw Error(
            "Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering."
          );
        var C = s();
        s0 || C === s() || (console.error(
          "The result of getServerSnapshot should be cached to avoid an infinite loop"
        ), s0 = !0);
      } else {
        if (C = o(), s0 || (s = o(), Ai(C, s) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), s0 = !0)), Lr === null)
          throw Error(
            "Expected a work-in-progress root. This is a bug in React. Please file an issue."
          );
        (Dn & 127) !== 0 || bv(h, o, C);
      }
      return y.memoizedState = C, s = { value: C, getSnapshot: o }, y.queue = s, Cc(
        wu.bind(null, h, s, n),
        [n]
      ), h.flags |= 2048, Yl(
        Cs | $i,
        { destroy: void 0 },
        yv.bind(
          null,
          h,
          s,
          C,
          o
        ),
        null
      ), C;
    }
    function wc(n, o, s) {
      var h = un, y = gr(), C = Xn;
      if (C) {
        if (s === void 0)
          throw Error(
            "Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering."
          );
        s = s();
      } else if (s = o(), !s0) {
        var A = o();
        Ai(s, A) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), s0 = !0);
      }
      (A = !Ai(
        (Ir || y).memoizedState,
        s
      )) && (y.memoizedState = s, Za = !0), y = y.queue;
      var z = wu.bind(null, h, y, n);
      if (za(2048, $i, z, [n]), y.getSnapshot !== o || A || Ja !== null && Ja.memoizedState.tag & Cs) {
        if (h.flags |= 2048, Yl(
          Cs | $i,
          { destroy: void 0 },
          yv.bind(
            null,
            h,
            y,
            s,
            o
          ),
          null
        ), Lr === null)
          throw Error(
            "Expected a work-in-progress root. This is a bug in React. Please file an issue."
          );
        C || (Jc & 127) !== 0 || bv(h, o, s);
      }
      return s;
    }
    function bv(n, o, s) {
      n.flags |= 16384, n = { getSnapshot: o, value: s }, o = un.updateQueue, o === null ? (o = Em(), un.updateQueue = o, o.stores = [n]) : (s = o.stores, s === null ? o.stores = [n] : s.push(n));
    }
    function yv(n, o, s, h) {
      o.value = s, o.getSnapshot = h, Su(o) && wv(n);
    }
    function wu(n, o, s) {
      return s(function() {
        Su(o) && (Bl(2, "updateSyncExternalStore()", n), wv(n));
      });
    }
    function Su(n) {
      var o = n.getSnapshot;
      n = n.value;
      try {
        var s = o();
        return !Ai(n, s);
      } catch {
        return !0;
      }
    }
    function wv(n) {
      var o = So(n, 2);
      o !== null && ln(o, n, 2);
    }
    function Np(n) {
      var o = Ma();
      if (typeof n == "function") {
        var s = n;
        if (n = s(), Oh) {
          Oe(!0);
          try {
            s();
          } finally {
            Oe(!1);
          }
        }
      }
      return o.memoizedState = o.baseState = n, o.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Si,
        lastRenderedState: n
      }, o;
    }
    function Cu(n) {
      n = Np(n);
      var o = n.queue, s = Lp.bind(null, un, o);
      return o.dispatch = s, [n.memoizedState, s];
    }
    function Sc(n) {
      var o = Ma();
      o.memoizedState = o.baseState = n;
      var s = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
      };
      return o.queue = s, o = Nm.bind(
        null,
        un,
        !0,
        s
      ), s.dispatch = o, [n, o];
    }
    function km(n, o) {
      var s = gr();
      return Rd(s, Ir, n, o);
    }
    function Rd(n, o, s, h) {
      return n.baseState = s, yu(
        n,
        Ir,
        typeof h == "function" ? h : Si
      );
    }
    function Mm(n, o) {
      var s = gr();
      return Ir !== null ? Rd(s, Ir, n, o) : (s.baseState = n, [n, s.queue.dispatch]);
    }
    function _b(n, o, s, h, y) {
      if (Xa(n))
        throw Error("Cannot update form state while rendering.");
      if (n = o.action, n !== null) {
        var C = {
          payload: y,
          action: n,
          next: null,
          isTransition: !0,
          status: "pending",
          value: null,
          reason: null,
          listeners: [],
          then: function(A) {
            C.listeners.push(A);
          }
        };
        Xe.T !== null ? s(!0) : C.isTransition = !1, h(C), s = o.pending, s === null ? (C.next = o.pending = C, xu(o, C)) : (C.next = s.next, o.pending = s.next = C);
      }
    }
    function xu(n, o) {
      var s = o.action, h = o.payload, y = n.state;
      if (o.isTransition) {
        var C = Xe.T, A = {};
        A._updatedFibers = /* @__PURE__ */ new Set(), Xe.T = A;
        try {
          var z = s(y, h), q = Xe.S;
          q !== null && q(A, z), Sv(n, o, z);
        } catch (Z) {
          Om(n, o, Z);
        } finally {
          C !== null && A.types !== null && (C.types !== null && C.types !== A.types && console.error(
            "We expected inner Transitions to have transferred the outer types set and that you cannot add to the outer Transition while inside the inner.This is a bug in React."
          ), C.types = A.types), Xe.T = C, C === null && A._updatedFibers && (n = A._updatedFibers.size, A._updatedFibers.clear(), 10 < n && console.warn(
            "Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."
          ));
        }
      } else
        try {
          A = s(y, h), Sv(n, o, A);
        } catch (Z) {
          Om(n, o, Z);
        }
    }
    function Sv(n, o, s) {
      s !== null && typeof s == "object" && typeof s.then == "function" ? (Xe.asyncTransitions++, s.then(xc, xc), s.then(
        function(h) {
          Ls(n, o, h);
        },
        function(h) {
          return Om(n, o, h);
        }
      ), o.isTransition || console.error(
        "An async function with useActionState was called outside of a transition. This is likely not what you intended (for example, isPending will not update correctly). Either call the returned function inside startTransition, or pass it to an `action` or `formAction` prop."
      )) : Ls(n, o, s);
    }
    function Ls(n, o, s) {
      o.status = "fulfilled", o.value = s, Dp(o), n.state = s, o = n.pending, o !== null && (s = o.next, s === o ? n.pending = null : (s = s.next, o.next = s, xu(n, s)));
    }
    function Om(n, o, s) {
      var h = n.pending;
      if (n.pending = null, h !== null) {
        h = h.next;
        do
          o.status = "rejected", o.reason = s, Dp(o), o = o.next;
        while (o !== h);
      }
      n.action = null;
    }
    function Dp(n) {
      n = n.listeners;
      for (var o = 0; o < n.length; o++) (0, n[o])();
    }
    function Hs(n, o) {
      return o;
    }
    function Ci(n, o) {
      if (Xn) {
        var s = Lr.formState;
        if (s !== null) {
          e: {
            var h = un;
            if (Xn) {
              if (qr) {
                t: {
                  for (var y = qr, C = ws; y.nodeType !== 8; ) {
                    if (!C) {
                      y = null;
                      break t;
                    }
                    if (y = Mi(
                      y.nextSibling
                    ), y === null) {
                      y = null;
                      break t;
                    }
                  }
                  C = y.data, y = C === k4 || C === e5 ? y : null;
                }
                if (y) {
                  qr = Mi(
                    y.nextSibling
                  ), h = y.data === k4;
                  break e;
                }
              }
              Gi(h);
            }
            h = !1;
          }
          h && (o = s[0]);
        }
      }
      return s = Ma(), s.memoizedState = s.baseState = o, h = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Hs,
        lastRenderedState: o
      }, s.queue = h, s = Lp.bind(
        null,
        un,
        h
      ), h.dispatch = s, h = Np(!1), C = Nm.bind(
        null,
        un,
        !1,
        h.queue
      ), h = Ma(), y = {
        state: o,
        dispatch: null,
        action: n,
        pending: null
      }, h.queue = y, s = _b.bind(
        null,
        un,
        y,
        C,
        s
      ), y.dispatch = s, h.memoizedState = n, [o, s, !1];
    }
    function Eu(n) {
      var o = gr();
      return $p(o, Ir, n);
    }
    function $p(n, o, s) {
      if (o = yu(
        n,
        o,
        Hs
      )[0], n = bc(Si)[0], typeof o == "object" && o !== null && typeof o.then == "function")
        try {
          var h = Pm(o);
        } catch (A) {
          throw A === a0 ? cw : A;
        }
      else h = o;
      o = gr();
      var y = o.queue, C = y.dispatch;
      return s !== o.memoizedState && (un.flags |= 2048, Yl(
        Cs | $i,
        { destroy: void 0 },
        Cv.bind(null, y, s),
        null
      )), [h, C, n];
    }
    function Cv(n, o) {
      n.action = o;
    }
    function Pu(n) {
      var o = gr(), s = Ir;
      if (s !== null)
        return $p(o, s, n);
      gr(), o = o.memoizedState, s = gr();
      var h = s.queue.dispatch;
      return s.memoizedState = n, [o, h, !1];
    }
    function Yl(n, o, s, h) {
      return n = { tag: n, create: s, deps: h, inst: o, next: null }, o = un.updateQueue, o === null && (o = Em(), un.updateQueue = o), s = o.lastEffect, s === null ? o.lastEffect = n.next = n : (h = s.next, s.next = n, n.next = h, o.lastEffect = n), n;
    }
    function zp(n) {
      var o = Ma();
      return n = { current: n }, o.memoizedState = n;
    }
    function ku(n, o, s, h) {
      var y = Ma();
      un.flags |= n, y.memoizedState = Yl(
        Cs | o,
        { destroy: void 0 },
        s,
        h === void 0 ? null : h
      );
    }
    function za(n, o, s, h) {
      var y = gr();
      h = h === void 0 ? null : h;
      var C = y.memoizedState.inst;
      Ir !== null && h !== null && gv(h, Ir.memoizedState.deps) ? y.memoizedState = Yl(o, C, s, h) : (un.flags |= n, y.memoizedState = Yl(
        Cs | o,
        C,
        s,
        h
      ));
    }
    function Cc(n, o) {
      (un.mode & Qs) !== on ? ku(276826112, $i, n, o) : ku(8390656, $i, n, o);
    }
    function Bb(n) {
      un.flags |= 4;
      var o = un.updateQueue;
      if (o === null)
        o = Em(), un.updateQueue = o, o.events = [n];
      else {
        var s = o.events;
        s === null ? o.events = [n] : s.push(n);
      }
    }
    function Tm(n) {
      var o = Ma(), s = { impl: n };
      return o.memoizedState = s, function() {
        if ((ar & po) !== Oo)
          throw Error(
            "A function wrapped in useEffectEvent can't be called during rendering."
          );
        return s.impl.apply(void 0, arguments);
      };
    }
    function Ad(n) {
      var o = gr().memoizedState;
      return Bb({ ref: o, nextImpl: n }), function() {
        if ((ar & po) !== Oo)
          throw Error(
            "A function wrapped in useEffectEvent can't be called during rendering."
          );
        return o.impl.apply(void 0, arguments);
      };
    }
    function Ho(n, o) {
      var s = 4194308;
      return (un.mode & Qs) !== on && (s |= 134217728), ku(s, Il, n, o);
    }
    function Hi(n, o) {
      if (typeof o == "function") {
        n = n();
        var s = o(n);
        return function() {
          typeof s == "function" ? s() : o(null);
        };
      }
      if (o != null)
        return o.hasOwnProperty("current") || console.error(
          "Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.",
          "an object with keys {" + Object.keys(o).join(", ") + "}"
        ), n = n(), o.current = n, function() {
          o.current = null;
        };
    }
    function Ql(n, o, s) {
      typeof o != "function" && console.error(
        "Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.",
        o !== null ? typeof o : "null"
      ), s = s != null ? s.concat([n]) : null;
      var h = 4194308;
      (un.mode & Qs) !== on && (h |= 134217728), ku(
        h,
        Il,
        Hi.bind(null, o, n),
        s
      );
    }
    function Nd(n, o, s) {
      typeof o != "function" && console.error(
        "Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.",
        o !== null ? typeof o : "null"
      ), s = s != null ? s.concat([n]) : null, za(
        4,
        Il,
        Hi.bind(null, o, n),
        s
      );
    }
    function jp(n, o) {
      return Ma().memoizedState = [
        n,
        o === void 0 ? null : o
      ], n;
    }
    function xl(n, o) {
      var s = gr();
      o = o === void 0 ? null : o;
      var h = s.memoizedState;
      return o !== null && gv(o, h[1]) ? h[0] : (s.memoizedState = [n, o], n);
    }
    function Fo(n, o) {
      var s = Ma();
      o = o === void 0 ? null : o;
      var h = n();
      if (Oh) {
        Oe(!0);
        try {
          n();
        } finally {
          Oe(!1);
        }
      }
      return s.memoizedState = [h, o], h;
    }
    function Br(n, o) {
      var s = gr();
      o = o === void 0 ? null : o;
      var h = s.memoizedState;
      if (o !== null && gv(o, h[1]))
        return h[0];
      if (h = n(), Oh) {
        Oe(!0);
        try {
          n();
        } finally {
          Oe(!1);
        }
      }
      return s.memoizedState = [h, o], h;
    }
    function Dd(n, o) {
      var s = Ma();
      return vr(s, n, o);
    }
    function Jl(n, o) {
      var s = gr();
      return ya(
        s,
        Ir.memoizedState,
        n,
        o
      );
    }
    function Sn(n, o) {
      var s = gr();
      return Ir === null ? vr(s, n, o) : ya(
        s,
        Ir.memoizedState,
        n,
        o
      );
    }
    function vr(n, o, s) {
      return s === void 0 || (Jc & 1073741824) !== 0 && (Dn & 261930) === 0 ? n.memoizedState = o : (n.memoizedState = s, n = Wd(), un.lanes |= n, Rf |= n, s);
    }
    function ya(n, o, s, h) {
      return Ai(s, o) ? s : i0.current !== null ? (n = vr(n, s, h), Ai(n, o) || (Za = !0), n) : (Jc & 42) === 0 || (Jc & 1073741824) !== 0 && (Dn & 261930) === 0 ? (Za = !0, n.memoizedState = s) : (n = Wd(), un.lanes |= n, Rf |= n, o);
    }
    function xc() {
      Xe.asyncTransitions--;
    }
    function Ec(n, o, s, h, y) {
      var C = fr.p;
      fr.p = C !== 0 && C < mo ? C : mo;
      var A = Xe.T, z = {};
      z._updatedFibers = /* @__PURE__ */ new Set(), Xe.T = z, Nm(n, !1, o, s);
      try {
        var q = y(), Z = Xe.S;
        if (Z !== null && Z(z, q), q !== null && typeof q == "object" && typeof q.then == "function") {
          Xe.asyncTransitions++, q.then(xc, xc);
          var xe = Mp(
            q,
            h
          );
          Pc(
            n,
            o,
            xe,
            xo(n)
          );
        } else
          Pc(
            n,
            o,
            h,
            xo(n)
          );
      } catch (ke) {
        Pc(
          n,
          o,
          { then: function() {
          }, status: "rejected", reason: ke },
          xo(n)
        );
      } finally {
        fr.p = C, A !== null && z.types !== null && (A.types !== null && A.types !== z.types && console.error(
          "We expected inner Transitions to have transferred the outer types set and that you cannot add to the outer Transition while inside the inner.This is a bug in React."
        ), A.types = z.types), Xe.T = A, A === null && z._updatedFibers && (n = z._updatedFibers.size, z._updatedFibers.clear(), 10 < n && console.warn(
          "Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."
        ));
      }
    }
    function Fs(n, o, s, h) {
      if (n.tag !== 5)
        throw Error(
          "Expected the form instance to be a HostComponent. This is a bug in React."
        );
      var y = Rm(n).queue;
      Wb(n), Ec(
        n,
        y,
        o,
        Hh,
        s === null ? g : function() {
          return $d(n), s(h);
        }
      );
    }
    function Rm(n) {
      var o = n.memoizedState;
      if (o !== null) return o;
      o = {
        memoizedState: Hh,
        baseState: Hh,
        baseQueue: null,
        queue: {
          pending: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: Si,
          lastRenderedState: Hh
        },
        next: null
      };
      var s = {};
      return o.next = {
        memoizedState: s,
        baseState: s,
        baseQueue: null,
        queue: {
          pending: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: Si,
          lastRenderedState: s
        },
        next: null
      }, n.memoizedState = o, n = n.alternate, n !== null && (n.memoizedState = o), o;
    }
    function $d(n) {
      Xe.T === null && console.error(
        "requestFormReset was called outside a transition or action. To fix, move to an action, or wrap with startTransition."
      );
      var o = Rm(n);
      o.next === null && (o = n.alternate.memoizedState), Pc(
        n,
        o.next.queue,
        {},
        xo(n)
      );
    }
    function Mu() {
      var n = Np(!1);
      return n = Ec.bind(
        null,
        un,
        n.queue,
        !0,
        !1
      ), Ma().memoizedState = n, [!1, n];
    }
    function Ub() {
      var n = bc(Si)[0], o = gr().memoizedState;
      return [
        typeof n == "boolean" ? n : Pm(n),
        o
      ];
    }
    function Zr() {
      var n = yc(Si)[0], o = gr().memoizedState;
      return [
        typeof n == "boolean" ? n : Pm(n),
        o
      ];
    }
    function Ws() {
      return cr(T1);
    }
    function Am() {
      var n = Ma(), o = Lr.identifierPrefix;
      if (Xn) {
        var s = Gc, h = Xc;
        s = (h & ~(1 << 32 - fo(h) - 1)).toString(32) + s, o = "_" + o + "R_" + s, s = pw++, 0 < s && (o += "H" + s.toString(32)), o += "_";
      } else
        s = uT++, o = "_" + o + "r_" + s.toString(32) + "_";
      return n.memoizedState = o;
    }
    function Ip() {
      return Ma().memoizedState = Xb.bind(
        null,
        un
      );
    }
    function Xb(n, o) {
      for (var s = n.return; s !== null; ) {
        switch (s.tag) {
          case 24:
          case 3:
            var h = xo(s), y = $a(h), C = Gl(s, y, h);
            C !== null && (Bl(h, "refresh()", n), ln(C, s, h), Ji(C, s, h)), n = Pp(), o != null && C !== null && console.error(
              "The seed argument is not enabled outside experimental channels."
            ), y.payload = { cache: n };
            return;
        }
        s = s.return;
      }
    }
    function gC(n, o, s) {
      var h = arguments;
      typeof h[3] == "function" && console.error(
        "State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect()."
      ), h = xo(n);
      var y = {
        lane: h,
        revertLane: 0,
        gesture: null,
        action: s,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      Xa(n) ? fa(o, y) : (y = ic(n, o, y, h), y !== null && (Bl(h, "dispatch()", n), ln(y, n, h), Dm(y, o, h)));
    }
    function Lp(n, o, s) {
      var h = arguments;
      typeof h[3] == "function" && console.error(
        "State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect()."
      ), h = xo(n), Pc(n, o, s, h) && Bl(h, "setState()", n);
    }
    function Pc(n, o, s, h) {
      var y = {
        lane: h,
        revertLane: 0,
        gesture: null,
        action: s,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (Xa(n)) fa(o, y);
      else {
        var C = n.alternate;
        if (n.lanes === 0 && (C === null || C.lanes === 0) && (C = o.lastRenderedReducer, C !== null)) {
          var A = Xe.H;
          Xe.H = Zs;
          try {
            var z = o.lastRenderedState, q = C(z, s);
            if (y.hasEagerState = !0, y.eagerState = q, Ai(q, z))
              return yd(n, o, y, 0), Lr === null && yp(), !1;
          } catch {
          } finally {
            Xe.H = A;
          }
        }
        if (s = ic(n, o, y, h), s !== null)
          return ln(s, n, h), Dm(s, o, h), !0;
      }
      return !1;
    }
    function Nm(n, o, s, h) {
      if (Xe.T === null && xh === 0 && console.error(
        "An optimistic state update occurred outside a transition or action. To fix, move the update to an action, or wrap with startTransition."
      ), h = {
        lane: 2,
        revertLane: u2(),
        gesture: null,
        action: h,
        hasEagerState: !1,
        eagerState: null,
        next: null
      }, Xa(n)) {
        if (o)
          throw Error("Cannot update optimistic state while rendering.");
        console.error("Cannot call startTransition while rendering.");
      } else
        o = ic(
          n,
          s,
          h,
          2
        ), o !== null && (Bl(2, "setOptimistic()", n), ln(o, n, 2));
    }
    function Xa(n) {
      var o = n.alternate;
      return n === un || o !== null && o === un;
    }
    function fa(n, o) {
      u0 = hw = !0;
      var s = n.pending;
      s === null ? o.next = o : (o.next = s.next, s.next = o), n.pending = o;
    }
    function Dm(n, o, s) {
      if ((s & 4194048) !== 0) {
        var h = o.lanes;
        h &= n.pendingLanes, s |= h, o.lanes = s, ct(n, s);
      }
    }
    function kc(n) {
      if (n !== null && typeof n != "function") {
        var o = String(n);
        k8.has(o) || (k8.add(o), console.error(
          "Expected the last optional `callback` argument to be a function. Instead received: %s.",
          n
        ));
      }
    }
    function zd(n, o, s, h) {
      var y = n.memoizedState, C = s(h, y);
      if (n.mode & ii) {
        Oe(!0);
        try {
          C = s(h, y);
        } finally {
          Oe(!1);
        }
      }
      C === void 0 && (o = F(o) || "Component", C8.has(o) || (C8.add(o), console.error(
        "%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.",
        o
      ))), y = C == null ? y : Rn({}, y, C), n.memoizedState = y, n.lanes === 0 && (n.updateQueue.baseState = y);
    }
    function Hp(n, o, s, h, y, C, A) {
      var z = n.stateNode;
      if (typeof z.shouldComponentUpdate == "function") {
        if (s = z.shouldComponentUpdate(
          h,
          C,
          A
        ), n.mode & ii) {
          Oe(!0);
          try {
            s = z.shouldComponentUpdate(
              h,
              C,
              A
            );
          } finally {
            Oe(!1);
          }
        }
        return s === void 0 && console.error(
          "%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.",
          F(o) || "Component"
        ), s;
      }
      return o.prototype && o.prototype.isPureReactComponent ? !bd(s, h) || !bd(y, C) : !0;
    }
    function Zl(n, o, s, h) {
      var y = o.state;
      typeof o.componentWillReceiveProps == "function" && o.componentWillReceiveProps(s, h), typeof o.UNSAFE_componentWillReceiveProps == "function" && o.UNSAFE_componentWillReceiveProps(s, h), o.state !== y && (n = W(n) || "Component", v8.has(n) || (v8.add(n), console.error(
        "%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.",
        n
      )), a4.enqueueReplaceState(
        o,
        o.state,
        null
      ));
    }
    function es(n, o) {
      var s = o;
      if ("ref" in o) {
        s = {};
        for (var h in o)
          h !== "ref" && (s[h] = o[h]);
      }
      if (n = n.defaultProps) {
        s === o && (s = Rn({}, s));
        for (var y in n)
          s[y] === void 0 && (s[y] = n[y]);
      }
      return s;
    }
    function Fp(n) {
      zC(n), console.warn(
        `%s

%s
`,
        c0 ? "An error occurred in the <" + c0 + "> component." : "An error occurred in one of your React components.",
        `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://react.dev/link/error-boundaries to learn more about error boundaries.`
      );
    }
    function Wp(n) {
      var o = c0 ? "The above error occurred in the <" + c0 + "> component." : "The above error occurred in one of your React components.", s = "React will try to recreate this component tree from scratch using the error boundary you provided, " + ((o4 || "Anonymous") + ".");
      if (typeof n == "object" && n !== null && typeof n.environmentName == "string") {
        var h = n.environmentName;
        n = [
          `%o

%s

%s
`,
          n,
          o,
          s
        ].slice(0), typeof n[0] == "string" ? n.splice(
          0,
          1,
          s5 + " " + n[0],
          u5,
          Fw + h + Fw,
          c5
        ) : n.splice(
          0,
          0,
          s5,
          u5,
          Fw + h + Fw,
          c5
        ), n.unshift(console), h = RT.apply(console.error, n), h();
      } else
        console.error(
          `%o

%s

%s
`,
          n,
          o,
          s
        );
    }
    function xv(n) {
      zC(n);
    }
    function $m(n, o) {
      try {
        c0 = o.source ? W(o.source) : null, o4 = null;
        var s = o.value;
        if (Xe.actQueue !== null)
          Xe.thrownErrors.push(s);
        else {
          var h = n.onUncaughtError;
          h(s, { componentStack: o.stack });
        }
      } catch (y) {
        setTimeout(function() {
          throw y;
        });
      }
    }
    function Ev(n, o, s) {
      try {
        c0 = s.source ? W(s.source) : null, o4 = W(o);
        var h = n.onCaughtError;
        h(s.value, {
          componentStack: s.stack,
          errorBoundary: o.tag === 1 ? o.stateNode : null
        });
      } catch (y) {
        setTimeout(function() {
          throw y;
        });
      }
    }
    function Vp(n, o, s) {
      return s = $a(s), s.tag = JC, s.payload = { element: null }, s.callback = function() {
        le(o.source, $m, n, o);
      }, s;
    }
    function _p(n) {
      return n = $a(n), n.tag = JC, n;
    }
    function Bp(n, o, s, h) {
      var y = s.type.getDerivedStateFromError;
      if (typeof y == "function") {
        var C = h.value;
        n.payload = function() {
          return y(C);
        }, n.callback = function() {
          lc(s), le(
            h.source,
            Ev,
            o,
            s,
            h
          );
        };
      }
      var A = s.stateNode;
      A !== null && typeof A.componentDidCatch == "function" && (n.callback = function() {
        lc(s), le(
          h.source,
          Ev,
          o,
          s,
          h
        ), typeof y != "function" && (Nf === null ? Nf = /* @__PURE__ */ new Set([this]) : Nf.add(this)), oT(this, h), typeof y == "function" || (s.lanes & 2) === 0 && console.error(
          "%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.",
          W(s) || "Unknown"
        );
      });
    }
    function Pv(n, o, s, h, y) {
      if (s.flags |= 32768, ms && Xd(n, y), h !== null && typeof h == "object" && typeof h.then == "function") {
        if (o = s.alternate, o !== null && bl(
          o,
          s,
          y,
          !0
        ), Xn && (_u = !0), s = jl.current, s !== null) {
          switch (s.tag) {
            case 31:
            case 13:
              return Ms === null ? _d() : s.alternate === null && ha === nd && (ha = bw), s.flags &= -257, s.flags |= 65536, s.lanes = y, h === dw ? s.flags |= 16384 : (o = s.updateQueue, o === null ? s.updateQueue = /* @__PURE__ */ new Set([h]) : o.add(h), cg(n, h, y)), !1;
            case 22:
              return s.flags |= 65536, h === dw ? s.flags |= 16384 : (o = s.updateQueue, o === null ? (o = {
                transitions: null,
                markerInstances: null,
                retryQueue: /* @__PURE__ */ new Set([h])
              }, s.updateQueue = o) : (s = o.retryQueue, s === null ? o.retryQueue = /* @__PURE__ */ new Set([h]) : s.add(h)), cg(n, h, y)), !1;
          }
          throw Error(
            "Unexpected Suspense handler tag (" + s.tag + "). This is a bug in React."
          );
        }
        return cg(n, h, y), _d(), !1;
      }
      if (Xn)
        return _u = !0, o = jl.current, o !== null ? ((o.flags & 65536) === 0 && (o.flags |= 256), o.flags |= 65536, o.lanes = y, h !== WC && mm(
          $o(
            Error(
              "There was an error while hydrating but React was able to recover by instead client rendering from the nearest Suspense boundary.",
              { cause: h }
            ),
            s
          )
        )) : (h !== WC && mm(
          $o(
            Error(
              "There was an error while hydrating but React was able to recover by instead client rendering the entire root.",
              { cause: h }
            ),
            s
          )
        ), n = n.current.alternate, n.flags |= 65536, y &= -y, n.lanes |= y, h = $o(h, s), y = Vp(
          n.stateNode,
          h,
          y
        ), ym(n, y), ha !== Of && (ha = Th)), !1;
      var C = $o(
        Error(
          "There was an error during concurrent rendering but React was able to recover by instead synchronously rendering the entire root.",
          { cause: h }
        ),
        s
      );
      if (w1 === null ? w1 = [C] : w1.push(C), ha !== Of && (ha = Th), o === null) return !0;
      h = $o(h, s), s = o;
      do {
        switch (s.tag) {
          case 3:
            return s.flags |= 65536, n = y & -y, s.lanes |= n, n = Vp(
              s.stateNode,
              h,
              n
            ), ym(s, n), !1;
          case 1:
            if (o = s.type, C = s.stateNode, (s.flags & 128) === 0 && (typeof o.getDerivedStateFromError == "function" || C !== null && typeof C.componentDidCatch == "function" && (Nf === null || !Nf.has(C))))
              return s.flags |= 65536, y &= -y, s.lanes |= y, y = _p(y), Bp(
                y,
                n,
                s,
                h
              ), ym(s, y), !1;
        }
        s = s.return;
      } while (s !== null);
      return !1;
    }
    function Ga(n, o, s, h) {
      o.child = n === null ? i8(o, null, s, h) : Mh(
        o,
        n.child,
        s,
        h
      );
    }
    function Gb(n, o, s, h, y) {
      s = s.render;
      var C = o.ref;
      if ("ref" in h) {
        var A = {};
        for (var z in h)
          z !== "ref" && (A[z] = h[z]);
      } else A = h;
      return gu(o), h = vv(
        n,
        o,
        s,
        A,
        C,
        y
      ), z = vc(), n !== null && !Za ? (xm(n, o, y), El(n, o, y)) : (Xn && z && Cp(o), o.flags |= 1, Ga(n, o, h, y), o.child);
    }
    function kv(n, o, s, h, y) {
      if (n === null) {
        var C = s.type;
        return typeof C == "function" && !av(C) && C.defaultProps === void 0 && s.compare === null ? (s = du(C), o.tag = 15, o.type = s, jd(o, C), Mv(
          n,
          o,
          s,
          h,
          y
        )) : (n = sc(
          s.type,
          null,
          h,
          o,
          o.mode,
          y
        ), n.ref = o.ref, n.return = o, o.child = n);
      }
      if (C = n.child, !Kp(n, y)) {
        var A = C.memoizedProps;
        if (s = s.compare, s = s !== null ? s : bd, s(A, h) && n.ref === o.ref)
          return El(
            n,
            o,
            y
          );
      }
      return o.flags |= 1, n = _l(C, h), n.ref = o.ref, n.return = o, o.child = n;
    }
    function Mv(n, o, s, h, y) {
      if (n !== null) {
        var C = n.memoizedProps;
        if (bd(C, h) && n.ref === o.ref && o.type === n.type)
          if (Za = !1, o.pendingProps = h = C, Kp(n, y))
            (n.flags & 131072) !== 0 && (Za = !0);
          else
            return o.lanes = n.lanes, El(n, o, y);
      }
      return Av(
        n,
        o,
        s,
        h,
        y
      );
    }
    function Ov(n, o, s, h) {
      var y = h.children, C = n !== null ? n.memoizedState : null;
      if (n === null && o.stateNode === null && (o.stateNode = {
        _visibility: K2,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
      }), h.mode === "hidden") {
        if ((o.flags & 128) !== 0) {
          if (C = C !== null ? C.baseLanes | s : s, n !== null) {
            for (h = o.child = n.child, y = 0; h !== null; )
              y = y | h.lanes | h.childLanes, h = h.sibling;
            h = y & ~C;
          } else h = 0, o.child = null;
          return Tv(
            n,
            o,
            C,
            s,
            h
          );
        }
        if ((s & 536870912) !== 0)
          o.memoizedState = { baseLanes: 0, cachePool: null }, n !== null && Ed(
            o,
            C !== null ? C.cachePool : null
          ), C !== null ? Rp(o, C) : zs(o), Ap(o);
        else
          return h = o.lanes = 536870912, Tv(
            n,
            o,
            C !== null ? C.baseLanes | s : s,
            s,
            h
          );
      } else
        C !== null ? (Ed(o, C.cachePool), Rp(o, C), Kl(o), o.memoizedState = null) : (n !== null && Ed(o, null), zs(o), Kl(o));
      return Ga(n, o, y, s), o.child;
    }
    function Mc(n, o) {
      return n !== null && n.tag === 22 || o.stateNode !== null || (o.stateNode = {
        _visibility: K2,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
      }), o.sibling;
    }
    function Tv(n, o, s, h, y) {
      var C = $s();
      return C = C === null ? null : {
        parent: Ya._currentValue,
        pool: C
      }, o.memoizedState = {
        baseLanes: s,
        cachePool: C
      }, n !== null && Ed(o, null), zs(o), Ap(o), n !== null && bl(n, o, h, !0), o.childLanes = y, null;
    }
    function zm(n, o) {
      var s = o.hidden;
      return s !== void 0 && console.error(
        `<Activity> doesn't accept a hidden prop. Use mode="hidden" instead.
- <Activity %s>
+ <Activity %s>`,
        s === !0 ? "hidden" : s === !1 ? "hidden={false}" : "hidden={...}",
        s ? 'mode="hidden"' : 'mode="visible"'
      ), o = Im(
        { mode: o.mode, children: o.children },
        n.mode
      ), o.ref = n.ref, n.child = o, o.return = n, o;
    }
    function Rv(n, o, s) {
      return Mh(o, n.child, null, s), n = zm(
        o,
        o.pendingProps
      ), n.flags |= 2, Ua(o), o.memoizedState = null, n;
    }
    function qb(n, o, s) {
      var h = o.pendingProps, y = (o.flags & 128) !== 0;
      if (o.flags &= -129, n === null) {
        if (Xn) {
          if (h.mode === "hidden")
            return n = zm(o, h), o.lanes = 536870912, Mc(null, n);
          if (Cl(o), (n = qr) ? (s = yr(
            n,
            ws
          ), s = s !== null && s.data === zh ? s : null, s !== null && (h = {
            dehydrated: s,
            treeContext: Lb(),
            retryLane: 536870912,
            hydrationErrors: null
          }, o.memoizedState = h, h = iv(s), h.return = o, o.child = h, Ko = o, qr = null)) : s = null, s === null)
            throw Co(o, n), Gi(o);
          return o.lanes = 536870912, null;
        }
        return zm(o, h);
      }
      var C = n.memoizedState;
      if (C !== null) {
        var A = C.dehydrated;
        if (Cl(o), y)
          if (o.flags & 256)
            o.flags &= -257, o = Rv(
              n,
              o,
              s
            );
          else if (o.memoizedState !== null)
            o.child = n.child, o.flags |= 128, o = null;
          else
            throw Error(
              "Client rendering an Activity suspended it again. This is a bug in React."
            );
        else if (Fb(), (s & 536870912) !== 0 && Vd(o), Za || bl(
          n,
          o,
          s,
          !1
        ), y = (s & n.childLanes) !== 0, Za || y) {
          if (h = Lr, h !== null && (A = it(
            h,
            s
          ), A !== 0 && A !== C.retryLane))
            throw C.retryLane = A, So(n, A), ln(h, n, A), i4;
          _d(), o = Rv(
            n,
            o,
            s
          );
        } else
          n = C.treeContext, qr = Mi(
            A.nextSibling
          ), Ko = o, Xn = !0, Cf = null, _u = !1, zl = null, ws = !1, n !== null && Hb(o, n), o = zm(o, h), o.flags |= 4096;
        return o;
      }
      return C = n.child, h = { mode: h.mode, children: h.children }, (s & 536870912) !== 0 && (s & n.lanes) !== 0 && Vd(o), n = _l(C, h), n.ref = o.ref, o.child = n, n.return = o, n;
    }
    function jm(n, o) {
      var s = o.ref;
      if (s === null)
        n !== null && n.ref !== null && (o.flags |= 4194816);
      else {
        if (typeof s != "function" && typeof s != "object")
          throw Error(
            "Expected ref to be a function, an object returned by React.createRef(), or undefined/null."
          );
        (n === null || n.ref !== s) && (o.flags |= 4194816);
      }
    }
    function Av(n, o, s, h, y) {
      if (s.prototype && typeof s.prototype.render == "function") {
        var C = F(s) || "Unknown";
        M8[C] || (console.error(
          "The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.",
          C,
          C
        ), M8[C] = !0);
      }
      return o.mode & ii && Js.recordLegacyContextWarning(
        o,
        null
      ), n === null && (jd(o, o.type), s.contextTypes && (C = F(s) || "Unknown", T8[C] || (T8[C] = !0, console.error(
        "%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with React.useContext() instead. (https://react.dev/link/legacy-context)",
        C
      )))), gu(o), s = vv(
        n,
        o,
        s,
        h,
        void 0,
        y
      ), h = vc(), n !== null && !Za ? (xm(n, o, y), El(n, o, y)) : (Xn && h && Cp(o), o.flags |= 1, Ga(n, o, s, y), o.child);
    }
    function Nv(n, o, s, h, y, C) {
      return gu(o), ed = -1, m1 = n !== null && n.type !== o.type, o.updateQueue = null, s = Sm(
        o,
        h,
        s,
        y
      ), ba(n, o), h = vc(), n !== null && !Za ? (xm(n, o, C), El(n, o, C)) : (Xn && h && Cp(o), o.flags |= 1, Ga(n, o, s, C), o.child);
    }
    function Oc(n, o, s, h, y) {
      switch (d(o)) {
        case !1:
          var C = o.stateNode, A = new o.type(
            o.memoizedProps,
            C.context
          ).state;
          C.updater.enqueueSetState(C, A, null);
          break;
        case !0:
          o.flags |= 128, o.flags |= 65536, C = Error("Simulated error coming from DevTools");
          var z = y & -y;
          if (o.lanes |= z, A = Lr, A === null)
            throw Error(
              "Expected a work-in-progress root. This is a bug in React. Please file an issue."
            );
          z = _p(z), Bp(
            z,
            A,
            o,
            $o(C, o)
          ), ym(o, z);
      }
      if (gu(o), o.stateNode === null) {
        if (A = Sf, C = s.contextType, "contextType" in s && C !== null && (C === void 0 || C.$$typeof !== Nl) && !P8.has(s) && (P8.add(s), z = C === void 0 ? " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof C != "object" ? " However, it is set to a " + typeof C + "." : C.$$typeof === Ng ? " Did you accidentally pass the Context.Consumer instead?" : " However, it is set to an object with keys {" + Object.keys(C).join(", ") + "}.", console.error(
          "%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s",
          F(s) || "Component",
          z
        )), typeof C == "object" && C !== null && (A = cr(C)), C = new s(h, A), o.mode & ii) {
          Oe(!0);
          try {
            C = new s(h, A);
          } finally {
            Oe(!1);
          }
        }
        if (A = o.memoizedState = C.state !== null && C.state !== void 0 ? C.state : null, C.updater = a4, o.stateNode = C, C._reactInternals = o, C._reactInternalInstance = g8, typeof s.getDerivedStateFromProps == "function" && A === null && (A = F(s) || "Component", b8.has(A) || (b8.add(A), console.error(
          "`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.",
          A,
          C.state === null ? "null" : "undefined",
          A
        ))), typeof s.getDerivedStateFromProps == "function" || typeof C.getSnapshotBeforeUpdate == "function") {
          var q = z = A = null;
          if (typeof C.componentWillMount == "function" && C.componentWillMount.__suppressDeprecationWarning !== !0 ? A = "componentWillMount" : typeof C.UNSAFE_componentWillMount == "function" && (A = "UNSAFE_componentWillMount"), typeof C.componentWillReceiveProps == "function" && C.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? z = "componentWillReceiveProps" : typeof C.UNSAFE_componentWillReceiveProps == "function" && (z = "UNSAFE_componentWillReceiveProps"), typeof C.componentWillUpdate == "function" && C.componentWillUpdate.__suppressDeprecationWarning !== !0 ? q = "componentWillUpdate" : typeof C.UNSAFE_componentWillUpdate == "function" && (q = "UNSAFE_componentWillUpdate"), A !== null || z !== null || q !== null) {
            C = F(s) || "Component";
            var Z = typeof s.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            w8.has(C) || (w8.add(C), console.error(
              `Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://react.dev/link/unsafe-component-lifecycles`,
              C,
              Z,
              A !== null ? `
  ` + A : "",
              z !== null ? `
  ` + z : "",
              q !== null ? `
  ` + q : ""
            ));
          }
        }
        C = o.stateNode, A = F(s) || "Component", C.render || (s.prototype && typeof s.prototype.render == "function" ? console.error(
          "No `render` method found on the %s instance: did you accidentally return an object from the constructor?",
          A
        ) : console.error(
          "No `render` method found on the %s instance: you may have forgotten to define `render`.",
          A
        )), !C.getInitialState || C.getInitialState.isReactClassApproved || C.state || console.error(
          "getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?",
          A
        ), C.getDefaultProps && !C.getDefaultProps.isReactClassApproved && console.error(
          "getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.",
          A
        ), C.contextType && console.error(
          "contextType was defined as an instance property on %s. Use a static property to define contextType instead.",
          A
        ), s.childContextTypes && !E8.has(s) && (E8.add(s), console.error(
          "%s uses the legacy childContextTypes API which was removed in React 19. Use React.createContext() instead. (https://react.dev/link/legacy-context)",
          A
        )), s.contextTypes && !x8.has(s) && (x8.add(s), console.error(
          "%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with static contextType instead. (https://react.dev/link/legacy-context)",
          A
        )), typeof C.componentShouldUpdate == "function" && console.error(
          "%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.",
          A
        ), s.prototype && s.prototype.isPureReactComponent && typeof C.shouldComponentUpdate < "u" && console.error(
          "%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.",
          F(s) || "A pure component"
        ), typeof C.componentDidUnmount == "function" && console.error(
          "%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?",
          A
        ), typeof C.componentDidReceiveProps == "function" && console.error(
          "%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().",
          A
        ), typeof C.componentWillRecieveProps == "function" && console.error(
          "%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?",
          A
        ), typeof C.UNSAFE_componentWillRecieveProps == "function" && console.error(
          "%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?",
          A
        ), z = C.props !== h, C.props !== void 0 && z && console.error(
          "When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.",
          A
        ), C.defaultProps && console.error(
          "Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.",
          A,
          A
        ), typeof C.getSnapshotBeforeUpdate != "function" || typeof C.componentDidUpdate == "function" || y8.has(s) || (y8.add(s), console.error(
          "%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.",
          F(s)
        )), typeof C.getDerivedStateFromProps == "function" && console.error(
          "%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.",
          A
        ), typeof C.getDerivedStateFromError == "function" && console.error(
          "%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.",
          A
        ), typeof s.getSnapshotBeforeUpdate == "function" && console.error(
          "%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.",
          A
        ), (z = C.state) && (typeof z != "object" || Ta(z)) && console.error("%s.state: must be set to an object or null", A), typeof C.getChildContext == "function" && typeof s.childContextTypes != "object" && console.error(
          "%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().",
          A
        ), C = o.stateNode, C.props = h, C.state = o.memoizedState, C.refs = {}, _n(o), A = s.contextType, C.context = typeof A == "object" && A !== null ? cr(A) : Sf, C.state === h && (A = F(s) || "Component", S8.has(A) || (S8.add(A), console.error(
          "%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.",
          A
        ))), o.mode & ii && Js.recordLegacyContextWarning(
          o,
          C
        ), Js.recordUnsafeLifecycleWarnings(
          o,
          C
        ), C.state = o.memoizedState, A = s.getDerivedStateFromProps, typeof A == "function" && (zd(
          o,
          s,
          A,
          h
        ), C.state = o.memoizedState), typeof s.getDerivedStateFromProps == "function" || typeof C.getSnapshotBeforeUpdate == "function" || typeof C.UNSAFE_componentWillMount != "function" && typeof C.componentWillMount != "function" || (A = C.state, typeof C.componentWillMount == "function" && C.componentWillMount(), typeof C.UNSAFE_componentWillMount == "function" && C.UNSAFE_componentWillMount(), A !== C.state && (console.error(
          "%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.",
          W(o) || "Component"
        ), a4.enqueueReplaceState(
          C,
          C.state,
          null
        )), ql(o, h, C, y), kd(), C.state = o.memoizedState), typeof C.componentDidMount == "function" && (o.flags |= 4194308), (o.mode & Qs) !== on && (o.flags |= 134217728), C = !0;
      } else if (n === null) {
        C = o.stateNode;
        var xe = o.memoizedProps;
        z = es(s, xe), C.props = z;
        var ke = C.context;
        q = s.contextType, A = Sf, typeof q == "object" && q !== null && (A = cr(q)), Z = s.getDerivedStateFromProps, q = typeof Z == "function" || typeof C.getSnapshotBeforeUpdate == "function", xe = o.pendingProps !== xe, q || typeof C.UNSAFE_componentWillReceiveProps != "function" && typeof C.componentWillReceiveProps != "function" || (xe || ke !== A) && Zl(
          o,
          C,
          h,
          A
        ), Mf = !1;
        var de = o.memoizedState;
        C.state = de, ql(o, h, C, y), kd(), ke = o.memoizedState, xe || de !== ke || Mf ? (typeof Z == "function" && (zd(
          o,
          s,
          Z,
          h
        ), ke = o.memoizedState), (z = Mf || Hp(
          o,
          s,
          z,
          h,
          de,
          ke,
          A
        )) ? (q || typeof C.UNSAFE_componentWillMount != "function" && typeof C.componentWillMount != "function" || (typeof C.componentWillMount == "function" && C.componentWillMount(), typeof C.UNSAFE_componentWillMount == "function" && C.UNSAFE_componentWillMount()), typeof C.componentDidMount == "function" && (o.flags |= 4194308), (o.mode & Qs) !== on && (o.flags |= 134217728)) : (typeof C.componentDidMount == "function" && (o.flags |= 4194308), (o.mode & Qs) !== on && (o.flags |= 134217728), o.memoizedProps = h, o.memoizedState = ke), C.props = h, C.state = ke, C.context = A, C = z) : (typeof C.componentDidMount == "function" && (o.flags |= 4194308), (o.mode & Qs) !== on && (o.flags |= 134217728), C = !1);
      } else {
        C = o.stateNode, Xl(n, o), A = o.memoizedProps, q = es(s, A), C.props = q, Z = o.pendingProps, de = C.context, ke = s.contextType, z = Sf, typeof ke == "object" && ke !== null && (z = cr(ke)), xe = s.getDerivedStateFromProps, (ke = typeof xe == "function" || typeof C.getSnapshotBeforeUpdate == "function") || typeof C.UNSAFE_componentWillReceiveProps != "function" && typeof C.componentWillReceiveProps != "function" || (A !== Z || de !== z) && Zl(
          o,
          C,
          h,
          z
        ), Mf = !1, de = o.memoizedState, C.state = de, ql(o, h, C, y), kd();
        var Ve = o.memoizedState;
        A !== Z || de !== Ve || Mf || n !== null && n.dependencies !== null && Cd(n.dependencies) ? (typeof xe == "function" && (zd(
          o,
          s,
          xe,
          h
        ), Ve = o.memoizedState), (q = Mf || Hp(
          o,
          s,
          q,
          h,
          de,
          Ve,
          z
        ) || n !== null && n.dependencies !== null && Cd(n.dependencies)) ? (ke || typeof C.UNSAFE_componentWillUpdate != "function" && typeof C.componentWillUpdate != "function" || (typeof C.componentWillUpdate == "function" && C.componentWillUpdate(h, Ve, z), typeof C.UNSAFE_componentWillUpdate == "function" && C.UNSAFE_componentWillUpdate(
          h,
          Ve,
          z
        )), typeof C.componentDidUpdate == "function" && (o.flags |= 4), typeof C.getSnapshotBeforeUpdate == "function" && (o.flags |= 1024)) : (typeof C.componentDidUpdate != "function" || A === n.memoizedProps && de === n.memoizedState || (o.flags |= 4), typeof C.getSnapshotBeforeUpdate != "function" || A === n.memoizedProps && de === n.memoizedState || (o.flags |= 1024), o.memoizedProps = h, o.memoizedState = Ve), C.props = h, C.state = Ve, C.context = z, C = q) : (typeof C.componentDidUpdate != "function" || A === n.memoizedProps && de === n.memoizedState || (o.flags |= 4), typeof C.getSnapshotBeforeUpdate != "function" || A === n.memoizedProps && de === n.memoizedState || (o.flags |= 1024), C = !1);
      }
      if (z = C, jm(n, o), A = (o.flags & 128) !== 0, z || A) {
        if (z = o.stateNode, se(o), A && typeof s.getDerivedStateFromError != "function")
          s = null, Ni = -1;
        else if (s = X6(z), o.mode & ii) {
          Oe(!0);
          try {
            X6(z);
          } finally {
            Oe(!1);
          }
        }
        o.flags |= 1, n !== null && A ? (o.child = Mh(
          o,
          n.child,
          null,
          y
        ), o.child = Mh(
          o,
          null,
          s,
          y
        )) : Ga(n, o, s, y), o.memoizedState = z.state, n = o.child;
      } else
        n = El(
          n,
          o,
          y
        );
      return y = o.stateNode, C && y.props !== h && (d0 || console.error(
        "It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.",
        W(o) || "a component"
      ), d0 = !0), n;
    }
    function Dv(n, o, s, h) {
      return hu(), o.flags |= 256, Ga(n, o, s, h), o.child;
    }
    function jd(n, o) {
      o && o.childContextTypes && console.error(
        `childContextTypes cannot be defined on a function component.
  %s.childContextTypes = ...`,
        o.displayName || o.name || "Component"
      ), typeof o.getDerivedStateFromProps == "function" && (n = F(o) || "Unknown", R8[n] || (console.error(
        "%s: Function components do not support getDerivedStateFromProps.",
        n
      ), R8[n] = !0)), typeof o.contextType == "object" && o.contextType !== null && (o = F(o) || "Unknown", O8[o] || (console.error(
        "%s: Function components do not support contextType.",
        o
      ), O8[o] = !0));
    }
    function Id(n) {
      return { baseLanes: n, cachePool: fv() };
    }
    function Up(n, o, s) {
      return n = n !== null ? n.childLanes & ~s : 0, o && (n |= il), n;
    }
    function Xp(n, o, s) {
      var h, y = o.pendingProps;
      c(o) && (o.flags |= 128);
      var C = !1, A = (o.flags & 128) !== 0;
      if ((h = A) || (h = n !== null && n.memoizedState === null ? !1 : (Ha.current & d1) !== 0), h && (C = !0, o.flags &= -129), h = (o.flags & 32) !== 0, o.flags &= -33, n === null) {
        if (Xn) {
          if (C ? Lo(o) : Kl(o), (n = qr) ? (s = yr(
            n,
            ws
          ), s = s !== null && s.data !== zh ? s : null, s !== null && (h = {
            dehydrated: s,
            treeContext: Lb(),
            retryLane: 536870912,
            hydrationErrors: null
          }, o.memoizedState = h, h = iv(s), h.return = o, o.child = h, Ko = o, qr = null)) : s = null, s === null)
            throw Co(o, n), Gi(o);
          return f2(s) ? o.lanes = 32 : o.lanes = 536870912, null;
        }
        var z = y.children;
        if (y = y.fallback, C) {
          Kl(o);
          var q = o.mode;
          return z = Im(
            { mode: "hidden", children: z },
            q
          ), y = uc(
            y,
            q,
            s,
            null
          ), z.return = o, y.return = o, z.sibling = y, o.child = z, y = o.child, y.memoizedState = Id(s), y.childLanes = Up(
            n,
            h,
            s
          ), o.memoizedState = l4, Mc(
            null,
            y
          );
        }
        return Lo(o), $v(
          o,
          z
        );
      }
      var Z = n.memoizedState;
      if (Z !== null) {
        var xe = Z.dehydrated;
        if (xe !== null) {
          if (A)
            o.flags & 256 ? (Lo(o), o.flags &= -257, o = Gp(
              n,
              o,
              s
            )) : o.memoizedState !== null ? (Kl(o), o.child = n.child, o.flags |= 128, o = null) : (Kl(o), z = y.fallback, q = o.mode, y = Im(
              {
                mode: "visible",
                children: y.children
              },
              q
            ), z = uc(
              z,
              q,
              s,
              null
            ), z.flags |= 2, y.return = o, z.return = o, y.sibling = z, o.child = y, Mh(
              o,
              n.child,
              null,
              s
            ), y = o.child, y.memoizedState = Id(s), y.childLanes = Up(
              n,
              h,
              s
            ), o.memoizedState = l4, o = Mc(
              null,
              y
            ));
          else if (Lo(o), Fb(), (s & 536870912) !== 0 && Vd(o), f2(
            xe
          )) {
            if (h = xe.nextSibling && xe.nextSibling.dataset, h) {
              z = h.dgst;
              var ke = h.msg;
              q = h.stck;
              var de = h.cstck;
            }
            C = ke, h = z, y = q, xe = de, z = C, q = xe, z = Error(z || "The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering."), z.stack = y || "", z.digest = h, h = q === void 0 ? null : q, y = {
              value: z,
              source: null,
              stack: h
            }, typeof h == "string" && FC.set(
              z,
              y
            ), mm(y), o = Gp(
              n,
              o,
              s
            );
          } else if (Za || bl(
            n,
            o,
            s,
            !1
          ), h = (s & n.childLanes) !== 0, Za || h) {
            if (h = Lr, h !== null && (y = it(
              h,
              s
            ), y !== 0 && y !== Z.retryLane))
              throw Z.retryLane = y, So(
                n,
                y
              ), ln(
                h,
                n,
                y
              ), i4;
            th(
              xe
            ) || _d(), o = Gp(
              n,
              o,
              s
            );
          } else
            th(
              xe
            ) ? (o.flags |= 192, o.child = n.child, o = null) : (n = Z.treeContext, qr = Mi(
              xe.nextSibling
            ), Ko = o, Xn = !0, Cf = null, _u = !1, zl = null, ws = !1, n !== null && Hb(o, n), o = $v(
              o,
              y.children
            ), o.flags |= 4096);
          return o;
        }
      }
      return C ? (Kl(o), z = y.fallback, q = o.mode, de = n.child, xe = de.sibling, y = _l(
        de,
        {
          mode: "hidden",
          children: y.children
        }
      ), y.subtreeFlags = de.subtreeFlags & 65011712, xe !== null ? z = _l(
        xe,
        z
      ) : (z = uc(
        z,
        q,
        s,
        null
      ), z.flags |= 2), z.return = o, y.return = o, y.sibling = z, o.child = y, Mc(null, y), y = o.child, z = n.child.memoizedState, z === null ? z = Id(s) : (q = z.cachePool, q !== null ? (de = Ya._currentValue, q = q.parent !== de ? { parent: de, pool: de } : q) : q = fv(), z = {
        baseLanes: z.baseLanes | s,
        cachePool: q
      }), y.memoizedState = z, y.childLanes = Up(
        n,
        h,
        s
      ), o.memoizedState = l4, Mc(
        n.child,
        y
      )) : (Z !== null && (s & 62914560) === s && (s & n.lanes) !== 0 && Vd(o), Lo(o), s = n.child, n = s.sibling, s = _l(s, {
        mode: "visible",
        children: y.children
      }), s.return = o, s.sibling = null, n !== null && (h = o.deletions, h === null ? (o.deletions = [n], o.flags |= 16) : h.push(n)), o.child = s, o.memoizedState = null, s);
    }
    function $v(n, o) {
      return o = Im(
        { mode: "visible", children: o },
        n.mode
      ), o.return = n, n.child = o;
    }
    function Im(n, o) {
      return n = x(22, n, null, o), n.lanes = 0, n;
    }
    function Gp(n, o, s) {
      return Mh(o, n.child, null, s), n = $v(
        o,
        o.pendingProps.children
      ), n.flags |= 2, o.memoizedState = null, n;
    }
    function zv(n, o, s) {
      n.lanes |= o;
      var h = n.alternate;
      h !== null && (h.lanes |= o), Ep(
        n.return,
        o,
        s
      );
    }
    function qp(n, o, s, h, y, C) {
      var A = n.memoizedState;
      A === null ? n.memoizedState = {
        isBackwards: o,
        rendering: null,
        renderingStartTime: 0,
        last: h,
        tail: s,
        tailMode: y,
        treeForkCount: C
      } : (A.isBackwards = o, A.rendering = null, A.renderingStartTime = 0, A.last = h, A.tail = s, A.tailMode = y, A.treeForkCount = C);
    }
    function jv(n, o, s) {
      var h = o.pendingProps, y = h.revealOrder, C = h.tail, A = h.children, z = Ha.current;
      if ((h = (z & d1) !== 0) ? (z = z & l0 | d1, o.flags |= 128) : z &= l0, Y(Ha, z, o), z = y ?? "null", y !== "forwards" && y !== "unstable_legacy-backwards" && y !== "together" && y !== "independent" && !A8[z])
        if (A8[z] = !0, y == null)
          console.error(
            'The default for the <SuspenseList revealOrder="..."> prop is changing. To be future compatible you must explictly specify either "independent" (the current default), "together", "forwards" or "legacy_unstable-backwards".'
          );
        else if (y === "backwards")
          console.error(
            'The rendering order of <SuspenseList revealOrder="backwards"> is changing. To be future compatible you must specify revealOrder="legacy_unstable-backwards" instead.'
          );
        else if (typeof y == "string")
          switch (y.toLowerCase()) {
            case "together":
            case "forwards":
            case "backwards":
            case "independent":
              console.error(
                '"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.',
                y,
                y.toLowerCase()
              );
              break;
            case "forward":
            case "backward":
              console.error(
                '"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.',
                y,
                y.toLowerCase()
              );
              break;
            default:
              console.error(
                '"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "independent", "together", "forwards" or "backwards"?',
                y
              );
          }
        else
          console.error(
            '%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "independent", "together", "forwards" or "backwards"?',
            y
          );
      z = C ?? "null", vw[z] || (C == null ? (y === "forwards" || y === "backwards" || y === "unstable_legacy-backwards") && (vw[z] = !0, console.error(
        'The default for the <SuspenseList tail="..."> prop is changing. To be future compatible you must explictly specify either "visible" (the current default), "collapsed" or "hidden".'
      )) : C !== "visible" && C !== "collapsed" && C !== "hidden" ? (vw[z] = !0, console.error(
        '"%s" is not a supported value for tail on <SuspenseList />. Did you mean "visible", "collapsed" or "hidden"?',
        C
      )) : y !== "forwards" && y !== "backwards" && y !== "unstable_legacy-backwards" && (vw[z] = !0, console.error(
        '<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?',
        C
      )));
      e: if ((y === "forwards" || y === "backwards" || y === "unstable_legacy-backwards") && A !== void 0 && A !== null && A !== !1)
        if (Ta(A)) {
          for (z = 0; z < A.length; z++)
            if (!$r(
              A[z],
              z
            ))
              break e;
        } else if (z = L(A), typeof z == "function") {
          if (z = z.call(A))
            for (var q = z.next(), Z = 0; !q.done; q = z.next()) {
              if (!$r(q.value, Z)) break e;
              Z++;
            }
        } else
          console.error(
            'A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?',
            y
          );
      if (Ga(n, o, A, s), Xn ? (mu(), A = Y2) : A = 0, !h && n !== null && (n.flags & 128) !== 0)
        e: for (n = o.child; n !== null; ) {
          if (n.tag === 13)
            n.memoizedState !== null && zv(n, s, o);
          else if (n.tag === 19)
            zv(n, s, o);
          else if (n.child !== null) {
            n.child.return = n, n = n.child;
            continue;
          }
          if (n === o) break e;
          for (; n.sibling === null; ) {
            if (n.return === null || n.return === o)
              break e;
            n = n.return;
          }
          n.sibling.return = n.return, n = n.sibling;
        }
      switch (y) {
        case "forwards":
          for (s = o.child, y = null; s !== null; )
            n = s.alternate, n !== null && gc(n) === null && (y = s), s = s.sibling;
          s = y, s === null ? (y = o.child, o.child = null) : (y = s.sibling, s.sibling = null), qp(
            o,
            !1,
            y,
            s,
            C,
            A
          );
          break;
        case "backwards":
        case "unstable_legacy-backwards":
          for (s = null, y = o.child, o.child = null; y !== null; ) {
            if (n = y.alternate, n !== null && gc(n) === null) {
              o.child = y;
              break;
            }
            n = y.sibling, y.sibling = s, s = y, y = n;
          }
          qp(
            o,
            !0,
            s,
            null,
            C,
            A
          );
          break;
        case "together":
          qp(
            o,
            !1,
            null,
            null,
            void 0,
            A
          );
          break;
        default:
          o.memoizedState = null;
      }
      return o.child;
    }
    function El(n, o, s) {
      if (n !== null && (o.dependencies = n.dependencies), Ni = -1, Rf |= o.lanes, (s & o.childLanes) === 0)
        if (n !== null) {
          if (bl(
            n,
            o,
            s,
            !1
          ), (s & o.childLanes) === 0)
            return null;
        } else return null;
      if (n !== null && o.child !== n.child)
        throw Error("Resuming work not yet implemented.");
      if (o.child !== null) {
        for (n = o.child, s = _l(n, n.pendingProps), o.child = s, s.return = o; n.sibling !== null; )
          n = n.sibling, s = s.sibling = _l(n, n.pendingProps), s.return = o;
        s.sibling = null;
      }
      return o.child;
    }
    function Kp(n, o) {
      return (n.lanes & o) !== 0 ? !0 : (n = n.dependencies, !!(n !== null && Cd(n)));
    }
    function Kb(n, o, s) {
      switch (o.tag) {
        case 3:
          J(
            o,
            o.stateNode.containerInfo
          ), qi(
            o,
            Ya,
            n.memoizedState.cache
          ), hu();
          break;
        case 27:
        case 5:
          X(o);
          break;
        case 4:
          J(
            o,
            o.stateNode.containerInfo
          );
          break;
        case 10:
          qi(
            o,
            o.type,
            o.memoizedProps.value
          );
          break;
        case 12:
          (s & o.childLanes) !== 0 && (o.flags |= 4), o.flags |= 2048;
          var h = o.stateNode;
          h.effectDuration = -0, h.passiveEffectDuration = -0;
          break;
        case 31:
          if (o.memoizedState !== null)
            return o.flags |= 128, Cl(o), null;
          break;
        case 13:
          if (h = o.memoizedState, h !== null)
            return h.dehydrated !== null ? (Lo(o), o.flags |= 128, null) : (s & o.child.childLanes) !== 0 ? Xp(
              n,
              o,
              s
            ) : (Lo(o), n = El(
              n,
              o,
              s
            ), n !== null ? n.sibling : null);
          Lo(o);
          break;
        case 19:
          var y = (n.flags & 128) !== 0;
          if (h = (s & o.childLanes) !== 0, h || (bl(
            n,
            o,
            s,
            !1
          ), h = (s & o.childLanes) !== 0), y) {
            if (h)
              return jv(
                n,
                o,
                s
              );
            o.flags |= 128;
          }
          if (y = o.memoizedState, y !== null && (y.rendering = null, y.tail = null, y.lastEffect = null), Y(
            Ha,
            Ha.current,
            o
          ), h) break;
          return null;
        case 22:
          return o.lanes = 0, Ov(
            n,
            o,
            s,
            o.pendingProps
          );
        case 24:
          qi(
            o,
            Ya,
            n.memoizedState.cache
          );
      }
      return El(n, o, s);
    }
    function Lm(n, o, s) {
      if (o._debugNeedsRemount && n !== null) {
        s = sc(
          o.type,
          o.key,
          o.pendingProps,
          o._debugOwner || null,
          o.mode,
          o.lanes
        ), s._debugStack = o._debugStack, s._debugTask = o._debugTask;
        var h = o.return;
        if (h === null) throw Error("Cannot swap the root fiber.");
        if (n.alternate = null, o.alternate = null, s.index = o.index, s.sibling = o.sibling, s.return = o.return, s.ref = o.ref, s._debugInfo = o._debugInfo, o === h.child)
          h.child = s;
        else {
          var y = h.child;
          if (y === null)
            throw Error("Expected parent to have a child.");
          for (; y.sibling !== o; )
            if (y = y.sibling, y === null)
              throw Error("Expected to find the previous sibling.");
          y.sibling = s;
        }
        return o = h.deletions, o === null ? (h.deletions = [n], h.flags |= 16) : o.push(n), s.flags |= 2, s;
      }
      if (n !== null)
        if (n.memoizedProps !== o.pendingProps || o.type !== n.type)
          Za = !0;
        else {
          if (!Kp(n, s) && (o.flags & 128) === 0)
            return Za = !1, Kb(
              n,
              o,
              s
            );
          Za = (n.flags & 131072) !== 0;
        }
      else
        Za = !1, (h = Xn) && (mu(), h = (o.flags & 1048576) !== 0), h && (h = o.index, mu(), lv(o, Y2, h));
      switch (o.lanes = 0, o.tag) {
        case 16:
          e: if (h = o.pendingProps, n = yi(o.elementType), o.type = n, typeof n == "function")
            av(n) ? (h = es(
              n,
              h
            ), o.tag = 1, o.type = n = du(n), o = Oc(
              null,
              o,
              n,
              h,
              s
            )) : (o.tag = 0, jd(o, n), o.type = n = du(n), o = Av(
              null,
              o,
              n,
              h,
              s
            ));
          else {
            if (n != null) {
              if (y = n.$$typeof, y === lf) {
                o.tag = 11, o.type = n = wp(n), o = Gb(
                  null,
                  o,
                  n,
                  h,
                  s
                );
                break e;
              } else if (y === dh) {
                o.tag = 14, o = kv(
                  null,
                  o,
                  n,
                  h,
                  s
                );
                break e;
              }
            }
            throw o = "", n !== null && typeof n == "object" && n.$$typeof === Eo && (o = " Did you wrap a component in React.lazy() more than once?"), s = F(n) || n, Error(
              "Element type is invalid. Received a promise that resolves to: " + s + ". Lazy element type must resolve to a class or function." + o
            );
          }
          return o;
        case 0:
          return Av(
            n,
            o,
            o.type,
            o.pendingProps,
            s
          );
        case 1:
          return h = o.type, y = es(
            h,
            o.pendingProps
          ), Oc(
            n,
            o,
            h,
            y,
            s
          );
        case 3:
          e: {
            if (J(
              o,
              o.stateNode.containerInfo
            ), n === null)
              throw Error(
                "Should have a current fiber. This is a bug in React."
              );
            h = o.pendingProps;
            var C = o.memoizedState;
            y = C.element, Xl(n, o), ql(o, h, null, s);
            var A = o.memoizedState;
            if (h = A.cache, qi(o, Ya, h), h !== C.cache && As(
              o,
              [Ya],
              s,
              !0
            ), kd(), h = A.element, C.isDehydrated)
              if (C = {
                element: h,
                isDehydrated: !1,
                cache: A.cache
              }, o.updateQueue.baseState = C, o.memoizedState = C, o.flags & 256) {
                o = Dv(
                  n,
                  o,
                  h,
                  s
                );
                break e;
              } else if (h !== y) {
                y = $o(
                  Error(
                    "This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."
                  ),
                  o
                ), mm(y), o = Dv(
                  n,
                  o,
                  h,
                  s
                );
                break e;
              } else {
                switch (n = o.stateNode.containerInfo, n.nodeType) {
                  case 9:
                    n = n.body;
                    break;
                  default:
                    n = n.nodeName === "HTML" ? n.ownerDocument.body : n;
                }
                for (qr = Mi(n.firstChild), Ko = o, Xn = !0, Cf = null, _u = !1, zl = null, ws = !0, s = i8(
                  o,
                  null,
                  h,
                  s
                ), o.child = s; s; )
                  s.flags = s.flags & -3 | 4096, s = s.sibling;
              }
            else {
              if (hu(), h === y) {
                o = El(
                  n,
                  o,
                  s
                );
                break e;
              }
              Ga(
                n,
                o,
                h,
                s
              );
            }
            o = o.child;
          }
          return o;
        case 26:
          return jm(n, o), n === null ? (s = g2(
            o.type,
            null,
            o.pendingProps,
            null
          )) ? o.memoizedState = s : Xn || (s = o.type, n = o.pendingProps, h = G(
            Oi.current
          ), h = Zm(
            h
          ).createElement(s), h[Xr] = o, h[qo] = n, Ur(h, s, n), Pt(h), o.stateNode = h) : o.memoizedState = g2(
            o.type,
            n.memoizedProps,
            o.pendingProps,
            n.memoizedState
          ), null;
        case 27:
          return X(o), n === null && Xn && (h = G(Oi.current), y = K(), h = o.stateNode = Gs(
            o.type,
            o.pendingProps,
            h,
            y,
            !1
          ), _u || (y = ri(
            h,
            o.type,
            o.pendingProps,
            y
          ), y !== null && (cc(o, 0).serverProps = y)), Ko = o, ws = !0, y = qr, ju(o.type) ? (R4 = y, qr = Mi(
            h.firstChild
          )) : qr = y), Ga(
            n,
            o,
            o.pendingProps.children,
            s
          ), jm(n, o), n === null && (o.flags |= 4194304), o.child;
        case 5:
          return n === null && Xn && (C = K(), h = Qt(
            o.type,
            C.ancestorInfo
          ), y = qr, (A = !y) || (A = Py(
            y,
            o.type,
            o.pendingProps,
            ws
          ), A !== null ? (o.stateNode = A, _u || (C = ri(
            A,
            o.type,
            o.pendingProps,
            C
          ), C !== null && (cc(o, 0).serverProps = C)), Ko = o, qr = Mi(
            A.firstChild
          ), ws = !1, C = !0) : C = !1, A = !C), A && (h && Co(o, y), Gi(o))), X(o), y = o.type, C = o.pendingProps, A = n !== null ? n.memoizedProps : null, h = C.children, Qd(y, C) ? h = null : A !== null && Qd(y, A) && (o.flags |= 32), o.memoizedState !== null && (y = vv(
            n,
            o,
            Cm,
            null,
            null,
            s
          ), T1._currentValue = y), jm(n, o), Ga(
            n,
            o,
            h,
            s
          ), o.child;
        case 6:
          return n === null && Xn && (s = o.pendingProps, n = K(), h = n.ancestorInfo.current, s = h != null ? nn(
            s,
            h.tag,
            n.ancestorInfo.implicitRootScope
          ) : !0, n = qr, (h = !n) || (h = ky(
            n,
            o.pendingProps,
            ws
          ), h !== null ? (o.stateNode = h, Ko = o, qr = null, h = !0) : h = !1, h = !h), h && (s && Co(o, n), Gi(o))), null;
        case 13:
          return Xp(n, o, s);
        case 4:
          return J(
            o,
            o.stateNode.containerInfo
          ), h = o.pendingProps, n === null ? o.child = Mh(
            o,
            null,
            h,
            s
          ) : Ga(
            n,
            o,
            h,
            s
          ), o.child;
        case 11:
          return Gb(
            n,
            o,
            o.type,
            o.pendingProps,
            s
          );
        case 7:
          return Ga(
            n,
            o,
            o.pendingProps,
            s
          ), o.child;
        case 8:
          return Ga(
            n,
            o,
            o.pendingProps.children,
            s
          ), o.child;
        case 12:
          return o.flags |= 4, o.flags |= 2048, h = o.stateNode, h.effectDuration = -0, h.passiveEffectDuration = -0, Ga(
            n,
            o,
            o.pendingProps.children,
            s
          ), o.child;
        case 10:
          return h = o.type, y = o.pendingProps, C = y.value, "value" in y || N8 || (N8 = !0, console.error(
            "The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"
          )), qi(o, h, C), Ga(
            n,
            o,
            y.children,
            s
          ), o.child;
        case 9:
          return y = o.type._context, h = o.pendingProps.children, typeof h != "function" && console.error(
            "A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."
          ), gu(o), y = cr(y), h = qC(
            h,
            y,
            void 0
          ), o.flags |= 1, Ga(
            n,
            o,
            h,
            s
          ), o.child;
        case 14:
          return kv(
            n,
            o,
            o.type,
            o.pendingProps,
            s
          );
        case 15:
          return Mv(
            n,
            o,
            o.type,
            o.pendingProps,
            s
          );
        case 19:
          return jv(
            n,
            o,
            s
          );
        case 31:
          return qb(n, o, s);
        case 22:
          return Ov(
            n,
            o,
            s,
            o.pendingProps
          );
        case 24:
          return gu(o), h = cr(Ya), n === null ? (y = $s(), y === null && (y = Lr, C = Pp(), y.pooledCache = C, fc(C), C !== null && (y.pooledCacheLanes |= s), y = C), o.memoizedState = {
            parent: h,
            cache: y
          }, _n(o), qi(o, Ya, y)) : ((n.lanes & s) !== 0 && (Xl(n, o), ql(o, null, null, s), kd()), y = n.memoizedState, C = o.memoizedState, y.parent !== h ? (y = {
            parent: h,
            cache: h
          }, o.memoizedState = y, o.lanes === 0 && (o.memoizedState = o.updateQueue.baseState = y), qi(o, Ya, h)) : (h = C.cache, qi(o, Ya, h), h !== y.cache && As(
            o,
            [Ya],
            s,
            !0
          ))), Ga(
            n,
            o,
            o.pendingProps.children,
            s
          ), o.child;
        case 29:
          throw o.pendingProps;
      }
      throw Error(
        "Unknown unit of work tag (" + o.tag + "). This error is likely caused by a bug in React. Please file an issue."
      );
    }
    function ts(n) {
      n.flags |= 4;
    }
    function Yp(n, o, s, h, y) {
      if ((o = (n.mode & ZO) !== on) && (o = !1), o) {
        if (n.flags |= 16777216, (y & 335544128) === y)
          if (n.stateNode.complete) n.flags |= 8192;
          else if (e2()) n.flags |= 8192;
          else
            throw kh = dw, YC;
      } else n.flags &= -16777217;
    }
    function Yb(n, o) {
      if (o.type !== "stylesheet" || (o.state.loading & Es) !== Lh)
        n.flags &= -16777217;
      else if (n.flags |= 16777216, !Vn(o))
        if (e2()) n.flags |= 8192;
        else
          throw kh = dw, YC;
    }
    function Ld(n, o) {
      o !== null && (n.flags |= 4), n.flags & 16384 && (o = n.tag !== 22 ? dt() : 536870912, n.lanes |= o, Nh |= o);
    }
    function Hd(n, o) {
      if (!Xn)
        switch (n.tailMode) {
          case "hidden":
            o = n.tail;
            for (var s = null; o !== null; )
              o.alternate !== null && (s = o), o = o.sibling;
            s === null ? n.tail = null : s.sibling = null;
            break;
          case "collapsed":
            s = n.tail;
            for (var h = null; s !== null; )
              s.alternate !== null && (h = s), s = s.sibling;
            h === null ? o || n.tail === null ? n.tail = null : n.tail.sibling = null : h.sibling = null;
        }
    }
    function Pr(n) {
      var o = n.alternate !== null && n.alternate.child === n.child, s = 0, h = 0;
      if (o)
        if ((n.mode & An) !== on) {
          for (var y = n.selfBaseDuration, C = n.child; C !== null; )
            s |= C.lanes | C.childLanes, h |= C.subtreeFlags & 65011712, h |= C.flags & 65011712, y += C.treeBaseDuration, C = C.sibling;
          n.treeBaseDuration = y;
        } else
          for (y = n.child; y !== null; )
            s |= y.lanes | y.childLanes, h |= y.subtreeFlags & 65011712, h |= y.flags & 65011712, y.return = n, y = y.sibling;
      else if ((n.mode & An) !== on) {
        y = n.actualDuration, C = n.selfBaseDuration;
        for (var A = n.child; A !== null; )
          s |= A.lanes | A.childLanes, h |= A.subtreeFlags, h |= A.flags, y += A.actualDuration, C += A.treeBaseDuration, A = A.sibling;
        n.actualDuration = y, n.treeBaseDuration = C;
      } else
        for (y = n.child; y !== null; )
          s |= y.lanes | y.childLanes, h |= y.subtreeFlags, h |= y.flags, y.return = n, y = y.sibling;
      return n.subtreeFlags |= h, n.childLanes = s, o;
    }
    function Iv(n, o, s) {
      var h = o.pendingProps;
      switch (xp(o), o.tag) {
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
          return Pr(o), null;
        case 1:
          return Pr(o), null;
        case 3:
          return s = o.stateNode, h = null, n !== null && (h = n.memoizedState.cache), o.memoizedState.cache !== h && (o.flags |= 2048), vl(Ya, o), H(o), s.pendingContext && (s.context = s.pendingContext, s.pendingContext = null), (n === null || n.child === null) && (dc(o) ? (pu(), ts(o)) : n === null || n.memoizedState.isDehydrated && (o.flags & 256) === 0 || (o.flags |= 1024, fm())), Pr(o), null;
        case 26:
          var y = o.type, C = o.memoizedState;
          return n === null ? (ts(o), C !== null ? (Pr(o), Yb(
            o,
            C
          )) : (Pr(o), Yp(
            o,
            y,
            null,
            h,
            s
          ))) : C ? C !== n.memoizedState ? (ts(o), Pr(o), Yb(
            o,
            C
          )) : (Pr(o), o.flags &= -16777217) : (n = n.memoizedProps, n !== h && ts(o), Pr(o), Yp(
            o,
            y,
            n,
            h,
            s
          )), null;
        case 27:
          if (te(o), s = G(Oi.current), y = o.type, n !== null && o.stateNode != null)
            n.memoizedProps !== h && ts(o);
          else {
            if (!h) {
              if (o.stateNode === null)
                throw Error(
                  "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue."
                );
              return Pr(o), null;
            }
            n = K(), dc(o) ? sv(o) : (n = Gs(
              y,
              h,
              s,
              n,
              !0
            ), o.stateNode = n, ts(o));
          }
          return Pr(o), null;
        case 5:
          if (te(o), y = o.type, n !== null && o.stateNode != null)
            n.memoizedProps !== h && ts(o);
          else {
            if (!h) {
              if (o.stateNode === null)
                throw Error(
                  "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue."
                );
              return Pr(o), null;
            }
            var A = K();
            if (dc(o))
              sv(o);
            else {
              switch (C = G(Oi.current), Qt(y, A.ancestorInfo), A = A.context, C = Zm(C), A) {
                case y0:
                  C = C.createElementNS(
                    Pn,
                    y
                  );
                  break;
                case Iw:
                  C = C.createElementNS(
                    vn,
                    y
                  );
                  break;
                default:
                  switch (y) {
                    case "svg":
                      C = C.createElementNS(
                        Pn,
                        y
                      );
                      break;
                    case "math":
                      C = C.createElementNS(
                        vn,
                        y
                      );
                      break;
                    case "script":
                      C = C.createElement("div"), C.innerHTML = "<script><\/script>", C = C.removeChild(
                        C.firstChild
                      );
                      break;
                    case "select":
                      C = typeof h.is == "string" ? C.createElement("select", {
                        is: h.is
                      }) : C.createElement("select"), h.multiple ? C.multiple = !0 : h.size && (C.size = h.size);
                      break;
                    default:
                      C = typeof h.is == "string" ? C.createElement(y, {
                        is: h.is
                      }) : C.createElement(y), y.indexOf("-") === -1 && (y !== y.toLowerCase() && console.error(
                        "<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.",
                        y
                      ), Object.prototype.toString.call(C) !== "[object HTMLUnknownElement]" || Ti.call(n5, y) || (n5[y] = !0, console.error(
                        "The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.",
                        y
                      )));
                  }
              }
              C[Xr] = o, C[qo] = h;
              e: for (A = o.child; A !== null; ) {
                if (A.tag === 5 || A.tag === 6)
                  C.appendChild(A.stateNode);
                else if (A.tag !== 4 && A.tag !== 27 && A.child !== null) {
                  A.child.return = A, A = A.child;
                  continue;
                }
                if (A === o) break e;
                for (; A.sibling === null; ) {
                  if (A.return === null || A.return === o)
                    break e;
                  A = A.return;
                }
                A.sibling.return = A.return, A = A.sibling;
              }
              o.stateNode = C;
              e: switch (Ur(C, y, h), y) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  h = !!h.autoFocus;
                  break e;
                case "img":
                  h = !0;
                  break e;
                default:
                  h = !1;
              }
              h && ts(o);
            }
          }
          return Pr(o), Yp(
            o,
            o.type,
            n === null ? null : n.memoizedProps,
            o.pendingProps,
            s
          ), null;
        case 6:
          if (n && o.stateNode != null)
            n.memoizedProps !== h && ts(o);
          else {
            if (typeof h != "string" && o.stateNode === null)
              throw Error(
                "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue."
              );
            if (n = G(Oi.current), s = K(), dc(o)) {
              if (n = o.stateNode, s = o.memoizedProps, y = !_u, h = null, C = Ko, C !== null)
                switch (C.tag) {
                  case 3:
                    y && (y = Ty(
                      n,
                      s,
                      h
                    ), y !== null && (cc(o, 0).serverProps = y));
                    break;
                  case 27:
                  case 5:
                    h = C.memoizedProps, y && (y = Ty(
                      n,
                      s,
                      h
                    ), y !== null && (cc(
                      o,
                      0
                    ).serverProps = y));
                }
              n[Xr] = o, n = !!(n.nodeValue === s || h !== null && h.suppressHydrationWarning === !0 || c2(n.nodeValue, s)), n || Gi(o, !0);
            } else
              y = s.ancestorInfo.current, y != null && nn(
                h,
                y.tag,
                s.ancestorInfo.implicitRootScope
              ), n = Zm(n).createTextNode(
                h
              ), n[Xr] = o, o.stateNode = n;
          }
          return Pr(o), null;
        case 31:
          if (s = o.memoizedState, n === null || n.memoizedState !== null) {
            if (h = dc(o), s !== null) {
              if (n === null) {
                if (!h)
                  throw Error(
                    "A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React."
                  );
                if (n = o.memoizedState, n = n !== null ? n.dehydrated : null, !n)
                  throw Error(
                    "Expected to have a hydrated activity instance. This error is likely caused by a bug in React. Please file an issue."
                  );
                n[Xr] = o, Pr(o), (o.mode & An) !== on && s !== null && (n = o.child, n !== null && (o.treeBaseDuration -= n.treeBaseDuration));
              } else
                pu(), hu(), (o.flags & 128) === 0 && (s = o.memoizedState = null), o.flags |= 4, Pr(o), (o.mode & An) !== on && s !== null && (n = o.child, n !== null && (o.treeBaseDuration -= n.treeBaseDuration));
              n = !1;
            } else
              s = fm(), n !== null && n.memoizedState !== null && (n.memoizedState.hydrationErrors = s), n = !0;
            if (!n)
              return o.flags & 256 ? (Ua(o), o) : (Ua(o), null);
            if ((o.flags & 128) !== 0)
              throw Error(
                "Client rendering an Activity suspended it again. This is a bug in React."
              );
          }
          return Pr(o), null;
        case 13:
          if (h = o.memoizedState, n === null || n.memoizedState !== null && n.memoizedState.dehydrated !== null) {
            if (y = h, C = dc(o), y !== null && y.dehydrated !== null) {
              if (n === null) {
                if (!C)
                  throw Error(
                    "A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React."
                  );
                if (C = o.memoizedState, C = C !== null ? C.dehydrated : null, !C)
                  throw Error(
                    "Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue."
                  );
                C[Xr] = o, Pr(o), (o.mode & An) !== on && y !== null && (y = o.child, y !== null && (o.treeBaseDuration -= y.treeBaseDuration));
              } else
                pu(), hu(), (o.flags & 128) === 0 && (y = o.memoizedState = null), o.flags |= 4, Pr(o), (o.mode & An) !== on && y !== null && (y = o.child, y !== null && (o.treeBaseDuration -= y.treeBaseDuration));
              y = !1;
            } else
              y = fm(), n !== null && n.memoizedState !== null && (n.memoizedState.hydrationErrors = y), y = !0;
            if (!y)
              return o.flags & 256 ? (Ua(o), o) : (Ua(o), null);
          }
          return Ua(o), (o.flags & 128) !== 0 ? (o.lanes = s, (o.mode & An) !== on && hc(o), o) : (s = h !== null, n = n !== null && n.memoizedState !== null, s && (h = o.child, y = null, h.alternate !== null && h.alternate.memoizedState !== null && h.alternate.memoizedState.cachePool !== null && (y = h.alternate.memoizedState.cachePool.pool), C = null, h.memoizedState !== null && h.memoizedState.cachePool !== null && (C = h.memoizedState.cachePool.pool), C !== y && (h.flags |= 2048)), s !== n && s && (o.child.flags |= 8192), Ld(o, o.updateQueue), Pr(o), (o.mode & An) !== on && s && (n = o.child, n !== null && (o.treeBaseDuration -= n.treeBaseDuration)), null);
        case 4:
          return H(o), n === null && $u(
            o.stateNode.containerInfo
          ), Pr(o), null;
        case 10:
          return vl(o.type, o), Pr(o), null;
        case 19:
          if (U(Ha, o), h = o.memoizedState, h === null) return Pr(o), null;
          if (y = (o.flags & 128) !== 0, C = h.rendering, C === null)
            if (y) Hd(h, !1);
            else {
              if (ha !== nd || n !== null && (n.flags & 128) !== 0)
                for (n = o.child; n !== null; ) {
                  if (C = gc(n), C !== null) {
                    for (o.flags |= 128, Hd(h, !1), n = C.updateQueue, o.updateQueue = n, Ld(o, n), o.subtreeFlags = 0, n = s, s = o.child; s !== null; )
                      ov(s, n), s = s.sibling;
                    return Y(
                      Ha,
                      Ha.current & l0 | d1,
                      o
                    ), Xn && gl(o, h.treeForkCount), o.child;
                  }
                  n = n.sibling;
                }
              h.tail !== null && Ka() > Ew && (o.flags |= 128, y = !0, Hd(h, !1), o.lanes = 4194304);
            }
          else {
            if (!y)
              if (n = gc(C), n !== null) {
                if (o.flags |= 128, y = !0, n = n.updateQueue, o.updateQueue = n, Ld(o, n), Hd(h, !0), h.tail === null && h.tailMode === "hidden" && !C.alternate && !Xn)
                  return Pr(o), null;
              } else
                2 * Ka() - h.renderingStartTime > Ew && s !== 536870912 && (o.flags |= 128, y = !0, Hd(h, !1), o.lanes = 4194304);
            h.isBackwards ? (C.sibling = o.child, o.child = C) : (n = h.last, n !== null ? n.sibling = C : o.child = C, h.last = C);
          }
          return h.tail !== null ? (n = h.tail, h.rendering = n, h.tail = n.sibling, h.renderingStartTime = Ka(), n.sibling = null, s = Ha.current, s = y ? s & l0 | d1 : s & l0, Y(Ha, s, o), Xn && gl(o, h.treeForkCount), n) : (Pr(o), null);
        case 22:
        case 23:
          return Ua(o), Sl(o), h = o.memoizedState !== null, n !== null ? n.memoizedState !== null !== h && (o.flags |= 8192) : h && (o.flags |= 8192), h ? (s & 536870912) !== 0 && (o.flags & 128) === 0 && (Pr(o), o.subtreeFlags & 6 && (o.flags |= 8192)) : Pr(o), s = o.updateQueue, s !== null && Ld(o, s.retryQueue), s = null, n !== null && n.memoizedState !== null && n.memoizedState.cachePool !== null && (s = n.memoizedState.cachePool.pool), h = null, o.memoizedState !== null && o.memoizedState.cachePool !== null && (h = o.memoizedState.cachePool.pool), h !== s && (o.flags |= 2048), n !== null && U(Eh, o), null;
        case 24:
          return s = null, n !== null && (s = n.memoizedState.cache), o.memoizedState.cache !== s && (o.flags |= 2048), vl(Ya, o), Pr(o), null;
        case 25:
          return null;
        case 30:
          return null;
      }
      throw Error(
        "Unknown unit of work tag (" + o.tag + "). This error is likely caused by a bug in React. Please file an issue."
      );
    }
    function Qb(n, o) {
      switch (xp(o), o.tag) {
        case 1:
          return n = o.flags, n & 65536 ? (o.flags = n & -65537 | 128, (o.mode & An) !== on && hc(o), o) : null;
        case 3:
          return vl(Ya, o), H(o), n = o.flags, (n & 65536) !== 0 && (n & 128) === 0 ? (o.flags = n & -65537 | 128, o) : null;
        case 26:
        case 27:
        case 5:
          return te(o), null;
        case 31:
          if (o.memoizedState !== null) {
            if (Ua(o), o.alternate === null)
              throw Error(
                "Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue."
              );
            hu();
          }
          return n = o.flags, n & 65536 ? (o.flags = n & -65537 | 128, (o.mode & An) !== on && hc(o), o) : null;
        case 13:
          if (Ua(o), n = o.memoizedState, n !== null && n.dehydrated !== null) {
            if (o.alternate === null)
              throw Error(
                "Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue."
              );
            hu();
          }
          return n = o.flags, n & 65536 ? (o.flags = n & -65537 | 128, (o.mode & An) !== on && hc(o), o) : null;
        case 19:
          return U(Ha, o), null;
        case 4:
          return H(o), null;
        case 10:
          return vl(o.type, o), null;
        case 22:
        case 23:
          return Ua(o), Sl(o), n !== null && U(Eh, o), n = o.flags, n & 65536 ? (o.flags = n & -65537 | 128, (o.mode & An) !== on && hc(o), o) : null;
        case 24:
          return vl(Ya, o), null;
        case 25:
          return null;
        default:
          return null;
      }
    }
    function Lv(n, o) {
      switch (xp(o), o.tag) {
        case 3:
          vl(Ya, o), H(o);
          break;
        case 26:
        case 27:
        case 5:
          te(o);
          break;
        case 4:
          H(o);
          break;
        case 31:
          o.memoizedState !== null && Ua(o);
          break;
        case 13:
          Ua(o);
          break;
        case 19:
          U(Ha, o);
          break;
        case 10:
          vl(o.type, o);
          break;
        case 22:
        case 23:
          Ua(o), Sl(o), n !== null && U(Eh, o);
          break;
        case 24:
          vl(Ya, o);
      }
    }
    function ns(n) {
      return (n.mode & An) !== on;
    }
    function Jb(n, o) {
      ns(n) ? (ca(), Vs(o, n), jo()) : Vs(o, n);
    }
    function Qp(n, o, s) {
      ns(n) ? (ca(), Ou(
        s,
        n,
        o
      ), jo()) : Ou(
        s,
        n,
        o
      );
    }
    function Vs(n, o) {
      try {
        var s = o.updateQueue, h = s !== null ? s.lastEffect : null;
        if (h !== null) {
          var y = h.next;
          s = y;
          do {
            if ((s.tag & n) === n && (h = void 0, (n & Di) !== mw && (g0 = !0), h = le(
              o,
              iT,
              s
            ), (n & Di) !== mw && (g0 = !1), h !== void 0 && typeof h != "function")) {
              var C = void 0;
              C = (s.tag & Il) !== 0 ? "useLayoutEffect" : (s.tag & Di) !== 0 ? "useInsertionEffect" : "useEffect";
              var A = void 0;
              A = h === null ? " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof h.then == "function" ? `

It looks like you wrote ` + C + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + C + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://react.dev/link/hooks-data-fetching` : " You returned: " + h, le(
                o,
                function(z, q) {
                  console.error(
                    "%s must not return anything besides a function, which is used for clean-up.%s",
                    z,
                    q
                  );
                },
                C,
                A
              );
            }
            s = s.next;
          } while (s !== y);
        }
      } catch (z) {
        En(o, o.return, z);
      }
    }
    function Ou(n, o, s) {
      try {
        var h = o.updateQueue, y = h !== null ? h.lastEffect : null;
        if (y !== null) {
          var C = y.next;
          h = C;
          do {
            if ((h.tag & n) === n) {
              var A = h.inst, z = A.destroy;
              z !== void 0 && (A.destroy = void 0, (n & Di) !== mw && (g0 = !0), y = o, le(
                y,
                lT,
                y,
                s,
                z
              ), (n & Di) !== mw && (g0 = !1));
            }
            h = h.next;
          } while (h !== C);
        }
      } catch (q) {
        En(o, o.return, q);
      }
    }
    function Hm(n, o) {
      ns(n) ? (ca(), Vs(o, n), jo()) : Vs(o, n);
    }
    function Jp(n, o, s) {
      ns(n) ? (ca(), Ou(
        s,
        n,
        o
      ), jo()) : Ou(
        s,
        n,
        o
      );
    }
    function Hv(n) {
      var o = n.updateQueue;
      if (o !== null) {
        var s = n.stateNode;
        n.type.defaultProps || "ref" in n.memoizedProps || d0 || (s.props !== n.memoizedProps && console.error(
          "Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
          W(n) || "instance"
        ), s.state !== n.memoizedState && console.error(
          "Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
          W(n) || "instance"
        ));
        try {
          le(
            n,
            Md,
            o,
            s
          );
        } catch (h) {
          En(n, n.return, h);
        }
      }
    }
    function Fm(n, o, s) {
      return n.getSnapshotBeforeUpdate(o, s);
    }
    function Zb(n, o) {
      var s = o.memoizedProps, h = o.memoizedState;
      o = n.stateNode, n.type.defaultProps || "ref" in n.memoizedProps || d0 || (o.props !== n.memoizedProps && console.error(
        "Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
        W(n) || "instance"
      ), o.state !== n.memoizedState && console.error(
        "Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
        W(n) || "instance"
      ));
      try {
        var y = es(
          n.type,
          s
        ), C = le(
          n,
          Fm,
          o,
          y,
          h
        );
        s = D8, C !== void 0 || s.has(n.type) || (s.add(n.type), le(n, function() {
          console.error(
            "%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.",
            W(n)
          );
        })), o.__reactInternalSnapshotBeforeUpdate = C;
      } catch (A) {
        En(n, n.return, A);
      }
    }
    function Zp(n, o, s) {
      s.props = es(
        n.type,
        n.memoizedProps
      ), s.state = n.memoizedState, ns(n) ? (ca(), le(
        n,
        J6,
        n,
        o,
        s
      ), jo()) : le(
        n,
        J6,
        n,
        o,
        s
      );
    }
    function ey(n) {
      var o = n.ref;
      if (o !== null) {
        switch (n.tag) {
          case 26:
          case 27:
          case 5:
            var s = n.stateNode;
            break;
          case 30:
            s = n.stateNode;
            break;
          default:
            s = n.stateNode;
        }
        if (typeof o == "function")
          if (ns(n))
            try {
              ca(), n.refCleanup = o(s);
            } finally {
              jo();
            }
          else n.refCleanup = o(s);
        else
          typeof o == "string" ? console.error("String refs are no longer supported.") : o.hasOwnProperty("current") || console.error(
            "Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().",
            W(n)
          ), o.current = s;
      }
    }
    function Tc(n, o) {
      try {
        le(n, ey, n);
      } catch (s) {
        En(n, o, s);
      }
    }
    function Zi(n, o) {
      var s = n.ref, h = n.refCleanup;
      if (s !== null)
        if (typeof h == "function")
          try {
            if (ns(n))
              try {
                ca(), le(n, h);
              } finally {
                jo(n);
              }
            else le(n, h);
          } catch (y) {
            En(n, o, y);
          } finally {
            n.refCleanup = null, n = n.alternate, n != null && (n.refCleanup = null);
          }
        else if (typeof s == "function")
          try {
            if (ns(n))
              try {
                ca(), le(n, s, null);
              } finally {
                jo(n);
              }
            else le(n, s, null);
          } catch (y) {
            En(n, o, y);
          }
        else s.current = null;
    }
    function Fv(n, o, s, h) {
      var y = n.memoizedProps, C = y.id, A = y.onCommit;
      y = y.onRender, o = o === null ? "mount" : "update", lw && (o = "nested-update"), typeof y == "function" && y(
        C,
        o,
        n.actualDuration,
        n.treeBaseDuration,
        n.actualStartTime,
        s
      ), typeof A == "function" && A(C, o, h, s);
    }
    function ty(n, o, s, h) {
      var y = n.memoizedProps;
      n = y.id, y = y.onPostCommit, o = o === null ? "mount" : "update", lw && (o = "nested-update"), typeof y == "function" && y(
        n,
        o,
        h,
        s
      );
    }
    function Tu(n) {
      var o = n.type, s = n.memoizedProps, h = n.stateNode;
      try {
        le(
          n,
          hy,
          h,
          o,
          s,
          n
        );
      } catch (y) {
        En(n, n.return, y);
      }
    }
    function eg(n, o, s) {
      try {
        le(
          n,
          wg,
          n.stateNode,
          n.type,
          s,
          o,
          n
        );
      } catch (h) {
        En(n, n.return, h);
      }
    }
    function Wv(n) {
      return n.tag === 5 || n.tag === 3 || n.tag === 26 || n.tag === 27 && ju(n.type) || n.tag === 4;
    }
    function tg(n) {
      e: for (; ; ) {
        for (; n.sibling === null; ) {
          if (n.return === null || Wv(n.return)) return null;
          n = n.return;
        }
        for (n.sibling.return = n.return, n = n.sibling; n.tag !== 5 && n.tag !== 6 && n.tag !== 18; ) {
          if (n.tag === 27 && ju(n.type) || n.flags & 2 || n.child === null || n.tag === 4) continue e;
          n.child.return = n, n = n.child;
        }
        if (!(n.flags & 2)) return n.stateNode;
      }
    }
    function Fd(n, o, s) {
      var h = n.tag;
      if (h === 5 || h === 6)
        n = n.stateNode, o ? (gy(s), (s.nodeType === 9 ? s.body : s.nodeName === "HTML" ? s.ownerDocument.body : s).insertBefore(n, o)) : (gy(s), o = s.nodeType === 9 ? s.body : s.nodeName === "HTML" ? s.ownerDocument.body : s, o.appendChild(n), s = s._reactRootContainer, s != null || o.onclick !== null || (o.onclick = tr));
      else if (h !== 4 && (h === 27 && ju(n.type) && (s = n.stateNode, o = null), n = n.child, n !== null))
        for (Fd(n, o, s), n = n.sibling; n !== null; )
          Fd(n, o, s), n = n.sibling;
    }
    function Wm(n, o, s) {
      var h = n.tag;
      if (h === 5 || h === 6)
        n = n.stateNode, o ? s.insertBefore(n, o) : s.appendChild(n);
      else if (h !== 4 && (h === 27 && ju(n.type) && (s = n.stateNode), n = n.child, n !== null))
        for (Wm(n, o, s), n = n.sibling; n !== null; )
          Wm(n, o, s), n = n.sibling;
    }
    function Vv(n) {
      for (var o, s = n.return; s !== null; ) {
        if (Wv(s)) {
          o = s;
          break;
        }
        s = s.return;
      }
      if (o == null)
        throw Error(
          "Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue."
        );
      switch (o.tag) {
        case 27:
          o = o.stateNode, s = tg(n), Wm(
            n,
            s,
            o
          );
          break;
        case 5:
          s = o.stateNode, o.flags & 32 && (Sg(s), o.flags &= -33), o = tg(n), Wm(
            n,
            o,
            s
          );
          break;
        case 3:
        case 4:
          o = o.stateNode.containerInfo, s = tg(n), Fd(
            n,
            s,
            o
          );
          break;
        default:
          throw Error(
            "Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue."
          );
      }
    }
    function _v(n) {
      var o = n.stateNode, s = n.memoizedProps;
      try {
        le(
          n,
          cs,
          n.type,
          s,
          o,
          n
        );
      } catch (h) {
        En(n, n.return, h);
      }
    }
    function Bv(n, o) {
      return o.tag === 31 ? (o = o.memoizedState, n.memoizedState !== null && o === null) : o.tag === 13 ? (n = n.memoizedState, o = o.memoizedState, n !== null && n.dehydrated !== null && (o === null || o.dehydrated === null)) : o.tag === 3 ? n.memoizedState.isDehydrated && (o.flags & 256) === 0 : !1;
    }
    function vC(n, o) {
      if (n = n.containerInfo, M4 = Ww, n = gp(n), Q0(n)) {
        if ("selectionStart" in n)
          var s = {
            start: n.selectionStart,
            end: n.selectionEnd
          };
        else
          e: {
            s = (s = n.ownerDocument) && s.defaultView || window;
            var h = s.getSelection && s.getSelection();
            if (h && h.rangeCount !== 0) {
              s = h.anchorNode;
              var y = h.anchorOffset, C = h.focusNode;
              h = h.focusOffset;
              try {
                s.nodeType, C.nodeType;
              } catch {
                s = null;
                break e;
              }
              var A = 0, z = -1, q = -1, Z = 0, xe = 0, ke = n, de = null;
              t: for (; ; ) {
                for (var Ve; ke !== s || y !== 0 && ke.nodeType !== 3 || (z = A + y), ke !== C || h !== 0 && ke.nodeType !== 3 || (q = A + h), ke.nodeType === 3 && (A += ke.nodeValue.length), (Ve = ke.firstChild) !== null; )
                  de = ke, ke = Ve;
                for (; ; ) {
                  if (ke === n) break t;
                  if (de === s && ++Z === y && (z = A), de === C && ++xe === h && (q = A), (Ve = ke.nextSibling) !== null) break;
                  ke = de, de = ke.parentNode;
                }
                ke = Ve;
              }
              s = z === -1 || q === -1 ? null : { start: z, end: q };
            } else s = null;
          }
        s = s || { start: 0, end: 0 };
      } else s = null;
      for (O4 = {
        focusedElem: n,
        selectionRange: s
      }, Ww = !1, Mo = o; Mo !== null; )
        if (o = Mo, n = o.child, (o.subtreeFlags & 1028) !== 0 && n !== null)
          n.return = o, Mo = n;
        else
          for (; Mo !== null; ) {
            switch (n = o = Mo, s = n.alternate, y = n.flags, n.tag) {
              case 0:
                if ((y & 4) !== 0 && (n = n.updateQueue, n = n !== null ? n.events : null, n !== null))
                  for (s = 0; s < n.length; s++)
                    y = n[s], y.ref.impl = y.nextImpl;
                break;
              case 11:
              case 15:
                break;
              case 1:
                (y & 1024) !== 0 && s !== null && Zb(n, s);
                break;
              case 3:
                if ((y & 1024) !== 0) {
                  if (n = n.stateNode.containerInfo, s = n.nodeType, s === 9)
                    Zd(n);
                  else if (s === 1)
                    switch (n.nodeName) {
                      case "HEAD":
                      case "HTML":
                      case "BODY":
                        Zd(n);
                        break;
                      default:
                        n.textContent = "";
                    }
                }
                break;
              case 5:
              case 26:
              case 27:
              case 6:
              case 4:
              case 17:
                break;
              default:
                if ((y & 1024) !== 0)
                  throw Error(
                    "This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue."
                  );
            }
            if (n = o.sibling, n !== null) {
              n.return = o.return, Mo = n;
              break;
            }
            Mo = o.return;
          }
    }
    function ng(n, o, s) {
      var h = _r(), y = Ki(), C = vi(), A = Yi(), z = s.flags;
      switch (s.tag) {
        case 0:
        case 11:
        case 15:
          xi(n, s), z & 4 && Jb(s, Il | Cs);
          break;
        case 1:
          if (xi(n, s), z & 4)
            if (n = s.stateNode, o === null)
              s.type.defaultProps || "ref" in s.memoizedProps || d0 || (n.props !== s.memoizedProps && console.error(
                "Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
                W(s) || "instance"
              ), n.state !== s.memoizedState && console.error(
                "Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
                W(s) || "instance"
              )), ns(s) ? (ca(), le(
                s,
                KC,
                s,
                n
              ), jo()) : le(
                s,
                KC,
                s,
                n
              );
            else {
              var q = es(
                s.type,
                o.memoizedProps
              );
              o = o.memoizedState, s.type.defaultProps || "ref" in s.memoizedProps || d0 || (n.props !== s.memoizedProps && console.error(
                "Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
                W(s) || "instance"
              ), n.state !== s.memoizedState && console.error(
                "Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
                W(s) || "instance"
              )), ns(s) ? (ca(), le(
                s,
                K6,
                s,
                n,
                q,
                o,
                n.__reactInternalSnapshotBeforeUpdate
              ), jo()) : le(
                s,
                K6,
                s,
                n,
                q,
                o,
                n.__reactInternalSnapshotBeforeUpdate
              );
            }
          z & 64 && Hv(s), z & 512 && Tc(s, s.return);
          break;
        case 3:
          if (o = Ul(), xi(n, s), z & 64 && (z = s.updateQueue, z !== null)) {
            if (q = null, s.child !== null)
              switch (s.child.tag) {
                case 27:
                case 5:
                  q = s.child.stateNode;
                  break;
                case 1:
                  q = s.child.stateNode;
              }
            try {
              le(
                s,
                Md,
                z,
                q
              );
            } catch (xe) {
              En(s, s.return, xe);
            }
          }
          n.effectDuration += xd(o);
          break;
        case 27:
          o === null && z & 4 && _v(s);
        case 26:
        case 5:
          if (xi(n, s), o === null) {
            if (z & 4) Tu(s);
            else if (z & 64) {
              n = s.type, o = s.memoizedProps, q = s.stateNode;
              try {
                le(
                  s,
                  py,
                  q,
                  n,
                  o,
                  s
                );
              } catch (xe) {
                En(
                  s,
                  s.return,
                  xe
                );
              }
            }
          }
          z & 512 && Tc(s, s.return);
          break;
        case 12:
          if (z & 4) {
            z = Ul(), xi(n, s), n = s.stateNode, n.effectDuration += zo(z);
            try {
              le(
                s,
                Fv,
                s,
                o,
                xf,
                n.effectDuration
              );
            } catch (xe) {
              En(s, s.return, xe);
            }
          } else xi(n, s);
          break;
        case 31:
          xi(n, s), z & 4 && Xv(n, s);
          break;
        case 13:
          xi(n, s), z & 4 && Gv(n, s), z & 64 && (n = s.memoizedState, n !== null && (n = n.dehydrated, n !== null && (z = Bs.bind(
            null,
            s
          ), My(n, z))));
          break;
        case 22:
          if (z = s.memoizedState !== null || td, !z) {
            o = o !== null && o.memoizedState !== null || eo, q = td;
            var Z = eo;
            td = z, (eo = o) && !Z ? (Pl(
              n,
              s,
              (s.subtreeFlags & 8772) !== 0
            ), (s.mode & An) !== on && 0 <= Bt && 0 <= tn && 0.05 < tn - Bt && vp(
              s,
              Bt,
              tn
            )) : xi(n, s), td = q, eo = Z;
          }
          break;
        case 30:
          break;
        default:
          xi(n, s);
      }
      (s.mode & An) !== on && 0 <= Bt && 0 <= tn && ((Ca || 0.05 < ma) && pl(
        s,
        Bt,
        tn,
        ma,
        na
      ), s.alternate === null && s.return !== null && s.return.alternate !== null && 0.05 < tn - Bt && (Bv(
        s.return.alternate,
        s.return
      ) || Xi(
        s,
        Bt,
        tn,
        "Mount"
      ))), _a(h), gi(y), na = C, Ca = A;
    }
    function wa(n) {
      var o = n.alternate;
      o !== null && (n.alternate = null, wa(o)), n.child = null, n.deletions = null, n.sibling = null, n.tag === 5 && (o = n.stateNode, o !== null && st(o)), n.stateNode = null, n._debugOwner = null, n.return = null, n.dependencies = null, n.memoizedProps = null, n.memoizedState = null, n.pendingProps = null, n.stateNode = null, n.updateQueue = null;
    }
    function Wr(n, o, s) {
      for (s = s.child; s !== null; )
        Uv(
          n,
          o,
          s
        ), s = s.sibling;
    }
    function Uv(n, o, s) {
      if (Ia && typeof Ia.onCommitFiberUnmount == "function")
        try {
          Ia.onCommitFiberUnmount(Vc, s);
        } catch (Z) {
          fs || (fs = !0, console.error(
            "React instrumentation encountered an error: %o",
            Z
          ));
        }
      var h = _r(), y = Ki(), C = vi(), A = Yi();
      switch (s.tag) {
        case 26:
          eo || Zi(s, o), Wr(
            n,
            o,
            s
          ), s.memoizedState ? s.memoizedState.count-- : s.stateNode && (n = s.stateNode, n.parentNode.removeChild(n));
          break;
        case 27:
          eo || Zi(s, o);
          var z = to, q = al;
          ju(s.type) && (to = s.stateNode, al = !1), Wr(
            n,
            o,
            s
          ), le(
            s,
            qs,
            s.stateNode
          ), to = z, al = q;
          break;
        case 5:
          eo || Zi(s, o);
        case 6:
          if (z = to, q = al, to = null, Wr(
            n,
            o,
            s
          ), to = z, al = q, to !== null)
            if (al)
              try {
                le(
                  s,
                  by,
                  to,
                  s.stateNode
                );
              } catch (Z) {
                En(
                  s,
                  o,
                  Z
                );
              }
            else
              try {
                le(
                  s,
                  vy,
                  to,
                  s.stateNode
                );
              } catch (Z) {
                En(
                  s,
                  o,
                  Z
                );
              }
          break;
        case 18:
          to !== null && (al ? (n = to, $c(
            n.nodeType === 9 ? n.body : n.nodeName === "HTML" ? n.ownerDocument.body : n,
            s.stateNode
          ), Lc(n)) : $c(to, s.stateNode));
          break;
        case 4:
          z = to, q = al, to = s.stateNode.containerInfo, al = !0, Wr(
            n,
            o,
            s
          ), to = z, al = q;
          break;
        case 0:
        case 11:
        case 14:
        case 15:
          Ou(
            Di,
            s,
            o
          ), eo || Qp(
            s,
            o,
            Il
          ), Wr(
            n,
            o,
            s
          );
          break;
        case 1:
          eo || (Zi(s, o), z = s.stateNode, typeof z.componentWillUnmount == "function" && Zp(
            s,
            o,
            z
          )), Wr(
            n,
            o,
            s
          );
          break;
        case 21:
          Wr(
            n,
            o,
            s
          );
          break;
        case 22:
          eo = (z = eo) || s.memoizedState !== null, Wr(
            n,
            o,
            s
          ), eo = z;
          break;
        default:
          Wr(
            n,
            o,
            s
          );
      }
      (s.mode & An) !== on && 0 <= Bt && 0 <= tn && (Ca || 0.05 < ma) && pl(
        s,
        Bt,
        tn,
        ma,
        na
      ), _a(h), gi(y), na = C, Ca = A;
    }
    function Xv(n, o) {
      if (o.memoizedState === null && (n = o.alternate, n !== null && (n = n.memoizedState, n !== null))) {
        n = n.dehydrated;
        try {
          le(
            o,
            Cg,
            n
          );
        } catch (s) {
          En(o, o.return, s);
        }
      }
    }
    function Gv(n, o) {
      if (o.memoizedState === null && (n = o.alternate, n !== null && (n = n.memoizedState, n !== null && (n = n.dehydrated, n !== null))))
        try {
          le(
            o,
            h2,
            n
          );
        } catch (s) {
          En(o, o.return, s);
        }
    }
    function ny(n) {
      switch (n.tag) {
        case 31:
        case 13:
        case 19:
          var o = n.stateNode;
          return o === null && (o = n.stateNode = new $8()), o;
        case 22:
          return n = n.stateNode, o = n._retryCache, o === null && (o = n._retryCache = new $8()), o;
        default:
          throw Error(
            "Unexpected Suspense handler tag (" + n.tag + "). This is a bug in React."
          );
      }
    }
    function Ru(n, o) {
      var s = ny(n);
      o.forEach(function(h) {
        if (!s.has(h)) {
          if (s.add(h), ms)
            if (f0 !== null && m0 !== null)
              Xd(m0, f0);
            else
              throw Error(
                "Expected finished root and lanes to be set. This is a bug in React."
              );
          var y = Nc.bind(null, n, h);
          h.then(y, y);
        }
      });
    }
    function Wo(n, o) {
      var s = o.deletions;
      if (s !== null)
        for (var h = 0; h < s.length; h++) {
          var y = n, C = o, A = s[h], z = _r(), q = C;
          e: for (; q !== null; ) {
            switch (q.tag) {
              case 27:
                if (ju(q.type)) {
                  to = q.stateNode, al = !1;
                  break e;
                }
                break;
              case 5:
                to = q.stateNode, al = !1;
                break e;
              case 3:
              case 4:
                to = q.stateNode.containerInfo, al = !0;
                break e;
            }
            q = q.return;
          }
          if (to === null)
            throw Error(
              "Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue."
            );
          Uv(y, C, A), to = null, al = !1, (A.mode & An) !== on && 0 <= Bt && 0 <= tn && 0.05 < tn - Bt && Xi(
            A,
            Bt,
            tn,
            "Unmount"
          ), _a(z), y = A, C = y.alternate, C !== null && (C.return = null), y.return = null;
        }
      if (o.subtreeFlags & 13886)
        for (o = o.child; o !== null; )
          Vm(o, n), o = o.sibling;
    }
    function Vm(n, o) {
      var s = _r(), h = Ki(), y = vi(), C = Yi(), A = n.alternate, z = n.flags;
      switch (n.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          Wo(o, n), Vo(n), z & 4 && (Ou(
            Di | Cs,
            n,
            n.return
          ), Vs(Di | Cs, n), Qp(
            n,
            n.return,
            Il | Cs
          ));
          break;
        case 1:
          if (Wo(o, n), Vo(n), z & 512 && (eo || A === null || Zi(A, A.return)), z & 64 && td && (z = n.updateQueue, z !== null && (A = z.callbacks, A !== null))) {
            var q = z.shared.hiddenCallbacks;
            z.shared.hiddenCallbacks = q === null ? A : q.concat(A);
          }
          break;
        case 26:
          if (q = eu, Wo(o, n), Vo(n), z & 512 && (eo || A === null || Zi(A, A.return)), z & 4) {
            var Z = A !== null ? A.memoizedState : null;
            if (z = n.memoizedState, A === null)
              if (z === null)
                if (n.stateNode === null) {
                  e: {
                    z = n.type, A = n.memoizedProps, q = q.ownerDocument || q;
                    t: switch (z) {
                      case "title":
                        Z = q.getElementsByTagName(
                          "title"
                        )[0], (!Z || Z[pf] || Z[Xr] || Z.namespaceURI === Pn || Z.hasAttribute("itemprop")) && (Z = q.createElement(z), q.head.insertBefore(
                          Z,
                          q.querySelector(
                            "head > title"
                          )
                        )), Ur(Z, z, A), Z[Xr] = n, Pt(Z), z = Z;
                        break e;
                      case "link":
                        var xe = nf(
                          "link",
                          "href",
                          q
                        ).get(z + (A.href || ""));
                        if (xe) {
                          for (var ke = 0; ke < xe.length; ke++)
                            if (Z = xe[ke], Z.getAttribute("href") === (A.href == null || A.href === "" ? null : A.href) && Z.getAttribute("rel") === (A.rel == null ? null : A.rel) && Z.getAttribute("title") === (A.title == null ? null : A.title) && Z.getAttribute("crossorigin") === (A.crossOrigin == null ? null : A.crossOrigin)) {
                              xe.splice(ke, 1);
                              break t;
                            }
                        }
                        Z = q.createElement(z), Ur(Z, z, A), q.head.appendChild(
                          Z
                        );
                        break;
                      case "meta":
                        if (xe = nf(
                          "meta",
                          "content",
                          q
                        ).get(z + (A.content || ""))) {
                          for (ke = 0; ke < xe.length; ke++)
                            if (Z = xe[ke], pe(
                              A.content,
                              "content"
                            ), Z.getAttribute("content") === (A.content == null ? null : "" + A.content) && Z.getAttribute("name") === (A.name == null ? null : A.name) && Z.getAttribute("property") === (A.property == null ? null : A.property) && Z.getAttribute("http-equiv") === (A.httpEquiv == null ? null : A.httpEquiv) && Z.getAttribute("charset") === (A.charSet == null ? null : A.charSet)) {
                              xe.splice(ke, 1);
                              break t;
                            }
                        }
                        Z = q.createElement(z), Ur(Z, z, A), q.head.appendChild(
                          Z
                        );
                        break;
                      default:
                        throw Error(
                          'getNodesForType encountered a type it did not expect: "' + z + '". This is a bug in React.'
                        );
                    }
                    Z[Xr] = n, Pt(Z), z = Z;
                  }
                  n.stateNode = z;
                } else
                  Ay(
                    q,
                    n.type,
                    n.stateNode
                  );
              else
                n.stateNode = Pg(
                  q,
                  z,
                  n.memoizedProps
                );
            else
              Z !== z ? (Z === null ? A.stateNode !== null && (A = A.stateNode, A.parentNode.removeChild(A)) : Z.count--, z === null ? Ay(
                q,
                n.type,
                n.stateNode
              ) : Pg(
                q,
                z,
                n.memoizedProps
              )) : z === null && n.stateNode !== null && eg(
                n,
                n.memoizedProps,
                A.memoizedProps
              );
          }
          break;
        case 27:
          Wo(o, n), Vo(n), z & 512 && (eo || A === null || Zi(A, A.return)), A !== null && z & 4 && eg(
            n,
            n.memoizedProps,
            A.memoizedProps
          );
          break;
        case 5:
          if (Wo(o, n), Vo(n), z & 512 && (eo || A === null || Zi(A, A.return)), n.flags & 32) {
            q = n.stateNode;
            try {
              le(
                n,
                Sg,
                q
              );
            } catch (Mt) {
              En(n, n.return, Mt);
            }
          }
          z & 4 && n.stateNode != null && (q = n.memoizedProps, eg(
            n,
            q,
            A !== null ? A.memoizedProps : q
          )), z & 1024 && (s4 = !0, n.type !== "form" && console.error(
            "Unexpected host component type. Expected a form. This is a bug in React."
          ));
          break;
        case 6:
          if (Wo(o, n), Vo(n), z & 4) {
            if (n.stateNode === null)
              throw Error(
                "This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue."
              );
            z = n.memoizedProps, A = A !== null ? A.memoizedProps : z, q = n.stateNode;
            try {
              le(
                n,
                bC,
                q,
                A,
                z
              );
            } catch (Mt) {
              En(n, n.return, Mt);
            }
          }
          break;
        case 3:
          if (q = Ul(), Lw = null, Z = eu, eu = xg(o.containerInfo), Wo(o, n), eu = Z, Vo(n), z & 4 && A !== null && A.memoizedState.isDehydrated)
            try {
              le(
                n,
                m2,
                o.containerInfo
              );
            } catch (Mt) {
              En(n, n.return, Mt);
            }
          s4 && (s4 = !1, ry(n)), o.effectDuration += xd(
            q
          );
          break;
        case 4:
          z = eu, eu = xg(
            n.stateNode.containerInfo
          ), Wo(o, n), Vo(n), eu = z;
          break;
        case 12:
          z = Ul(), Wo(o, n), Vo(n), n.stateNode.effectDuration += zo(z);
          break;
        case 31:
          Wo(o, n), Vo(n), z & 4 && (z = n.updateQueue, z !== null && (n.updateQueue = null, Ru(n, z)));
          break;
        case 13:
          Wo(o, n), Vo(n), n.child.flags & 8192 && n.memoizedState !== null != (A !== null && A.memoizedState !== null) && (xw = Ka()), z & 4 && (z = n.updateQueue, z !== null && (n.updateQueue = null, Ru(n, z)));
          break;
        case 22:
          q = n.memoizedState !== null;
          var de = A !== null && A.memoizedState !== null, Ve = td, yt = eo;
          if (td = Ve || q, eo = yt || de, Wo(o, n), eo = yt, td = Ve, de && !q && !Ve && !yt && (n.mode & An) !== on && 0 <= Bt && 0 <= tn && 0.05 < tn - Bt && vp(
            n,
            Bt,
            tn
          ), Vo(n), z & 8192)
            e: for (o = n.stateNode, o._visibility = q ? o._visibility & ~K2 : o._visibility | K2, !q || A === null || de || td || eo || (Au(n), (n.mode & An) !== on && 0 <= Bt && 0 <= tn && 0.05 < tn - Bt && Xi(
              n,
              Bt,
              tn,
              "Disconnect"
            )), A = null, o = n; ; ) {
              if (o.tag === 5 || o.tag === 26) {
                if (A === null) {
                  de = A = o;
                  try {
                    Z = de.stateNode, q ? le(
                      de,
                      wy,
                      Z
                    ) : le(
                      de,
                      xy,
                      de.stateNode,
                      de.memoizedProps
                    );
                  } catch (Mt) {
                    En(de, de.return, Mt);
                  }
                }
              } else if (o.tag === 6) {
                if (A === null) {
                  de = o;
                  try {
                    xe = de.stateNode, q ? le(
                      de,
                      Sy,
                      xe
                    ) : le(
                      de,
                      Ey,
                      xe,
                      de.memoizedProps
                    );
                  } catch (Mt) {
                    En(de, de.return, Mt);
                  }
                }
              } else if (o.tag === 18) {
                if (A === null) {
                  de = o;
                  try {
                    ke = de.stateNode, q ? le(
                      de,
                      yy,
                      ke
                    ) : le(
                      de,
                      Cy,
                      de.stateNode
                    );
                  } catch (Mt) {
                    En(de, de.return, Mt);
                  }
                }
              } else if ((o.tag !== 22 && o.tag !== 23 || o.memoizedState === null || o === n) && o.child !== null) {
                o.child.return = o, o = o.child;
                continue;
              }
              if (o === n) break e;
              for (; o.sibling === null; ) {
                if (o.return === null || o.return === n)
                  break e;
                A === o && (A = null), o = o.return;
              }
              A === o && (A = null), o.sibling.return = o.return, o = o.sibling;
            }
          z & 4 && (z = n.updateQueue, z !== null && (A = z.retryQueue, A !== null && (z.retryQueue = null, Ru(n, A))));
          break;
        case 19:
          Wo(o, n), Vo(n), z & 4 && (z = n.updateQueue, z !== null && (n.updateQueue = null, Ru(n, z)));
          break;
        case 30:
          break;
        case 21:
          break;
        default:
          Wo(o, n), Vo(n);
      }
      (n.mode & An) !== on && 0 <= Bt && 0 <= tn && ((Ca || 0.05 < ma) && pl(
        n,
        Bt,
        tn,
        ma,
        na
      ), n.alternate === null && n.return !== null && n.return.alternate !== null && 0.05 < tn - Bt && (Bv(
        n.return.alternate,
        n.return
      ) || Xi(
        n,
        Bt,
        tn,
        "Mount"
      ))), _a(s), gi(h), na = y, Ca = C;
    }
    function Vo(n) {
      var o = n.flags;
      if (o & 2) {
        try {
          le(n, Vv, n);
        } catch (s) {
          En(n, n.return, s);
        }
        n.flags &= -3;
      }
      o & 4096 && (n.flags &= -4097);
    }
    function ry(n) {
      if (n.subtreeFlags & 1024)
        for (n = n.child; n !== null; ) {
          var o = n;
          ry(o), o.tag === 5 && o.flags & 1024 && o.stateNode.reset(), n = n.sibling;
        }
    }
    function xi(n, o) {
      if (o.subtreeFlags & 8772)
        for (o = o.child; o !== null; )
          ng(n, o.alternate, o), o = o.sibling;
    }
    function rg(n) {
      var o = _r(), s = Ki(), h = vi(), y = Yi();
      switch (n.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          Qp(
            n,
            n.return,
            Il
          ), Au(n);
          break;
        case 1:
          Zi(n, n.return);
          var C = n.stateNode;
          typeof C.componentWillUnmount == "function" && Zp(
            n,
            n.return,
            C
          ), Au(n);
          break;
        case 27:
          le(
            n,
            qs,
            n.stateNode
          );
        case 26:
        case 5:
          Zi(n, n.return), Au(n);
          break;
        case 22:
          n.memoizedState === null && Au(n);
          break;
        case 30:
          Au(n);
          break;
        default:
          Au(n);
      }
      (n.mode & An) !== on && 0 <= Bt && 0 <= tn && (Ca || 0.05 < ma) && pl(
        n,
        Bt,
        tn,
        ma,
        na
      ), _a(o), gi(s), na = h, Ca = y;
    }
    function Au(n) {
      for (n = n.child; n !== null; )
        rg(n), n = n.sibling;
    }
    function qv(n, o, s, h) {
      var y = _r(), C = Ki(), A = vi(), z = Yi(), q = s.flags;
      switch (s.tag) {
        case 0:
        case 11:
        case 15:
          Pl(
            n,
            s,
            h
          ), Jb(s, Il);
          break;
        case 1:
          if (Pl(
            n,
            s,
            h
          ), o = s.stateNode, typeof o.componentDidMount == "function" && le(
            s,
            KC,
            s,
            o
          ), o = s.updateQueue, o !== null) {
            n = s.stateNode;
            try {
              le(
                s,
                pv,
                o,
                n
              );
            } catch (Z) {
              En(s, s.return, Z);
            }
          }
          h && q & 64 && Hv(s), Tc(s, s.return);
          break;
        case 27:
          _v(s);
        case 26:
        case 5:
          Pl(
            n,
            s,
            h
          ), h && o === null && q & 4 && Tu(s), Tc(s, s.return);
          break;
        case 12:
          if (h && q & 4) {
            q = Ul(), Pl(
              n,
              s,
              h
            ), h = s.stateNode, h.effectDuration += zo(q);
            try {
              le(
                s,
                Fv,
                s,
                o,
                xf,
                h.effectDuration
              );
            } catch (Z) {
              En(s, s.return, Z);
            }
          } else
            Pl(
              n,
              s,
              h
            );
          break;
        case 31:
          Pl(
            n,
            s,
            h
          ), h && q & 4 && Xv(n, s);
          break;
        case 13:
          Pl(
            n,
            s,
            h
          ), h && q & 4 && Gv(n, s);
          break;
        case 22:
          s.memoizedState === null && Pl(
            n,
            s,
            h
          ), Tc(s, s.return);
          break;
        case 30:
          break;
        default:
          Pl(
            n,
            s,
            h
          );
      }
      (s.mode & An) !== on && 0 <= Bt && 0 <= tn && (Ca || 0.05 < ma) && pl(
        s,
        Bt,
        tn,
        ma,
        na
      ), _a(y), gi(C), na = A, Ca = z;
    }
    function Pl(n, o, s) {
      for (s = s && (o.subtreeFlags & 8772) !== 0, o = o.child; o !== null; )
        qv(
          n,
          o.alternate,
          o,
          s
        ), o = o.sibling;
    }
    function _m(n, o) {
      var s = null;
      n !== null && n.memoizedState !== null && n.memoizedState.cachePool !== null && (s = n.memoizedState.cachePool.pool), n = null, o.memoizedState !== null && o.memoizedState.cachePool !== null && (n = o.memoizedState.cachePool.pool), n !== s && (n != null && fc(n), s != null && pm(s));
    }
    function Bm(n, o) {
      n = null, o.alternate !== null && (n = o.alternate.memoizedState.cache), o = o.memoizedState.cache, o !== n && (fc(o), n != null && pm(n));
    }
    function Ei(n, o, s, h, y) {
      if (o.subtreeFlags & 10256 || o.actualDuration !== 0 && (o.alternate === null || o.alternate.child !== o.child))
        for (o = o.child; o !== null; ) {
          var C = o.sibling;
          Kv(
            n,
            o,
            s,
            h,
            C !== null ? C.actualStartTime : y
          ), o = C;
        }
    }
    function Kv(n, o, s, h, y) {
      var C = _r(), A = Ki(), z = vi(), q = Yi(), Z = yf, xe = o.flags;
      switch (o.tag) {
        case 0:
        case 11:
        case 15:
          (o.mode & An) !== on && 0 < o.actualStartTime && (o.flags & 1) !== 0 && bp(
            o,
            o.actualStartTime,
            y,
            ho,
            s
          ), Ei(
            n,
            o,
            s,
            h,
            y
          ), xe & 2048 && Hm(o, $i | Cs);
          break;
        case 1:
          (o.mode & An) !== on && 0 < o.actualStartTime && ((o.flags & 128) !== 0 ? Z0(
            o,
            o.actualStartTime,
            y,
            []
          ) : (o.flags & 1) !== 0 && bp(
            o,
            o.actualStartTime,
            y,
            ho,
            s
          )), Ei(
            n,
            o,
            s,
            h,
            y
          );
          break;
        case 3:
          var ke = Ul(), de = ho;
          ho = o.alternate !== null && o.alternate.memoizedState.isDehydrated && (o.flags & 256) === 0, Ei(
            n,
            o,
            s,
            h,
            y
          ), ho = de, xe & 2048 && (s = null, o.alternate !== null && (s = o.alternate.memoizedState.cache), h = o.memoizedState.cache, h !== s && (fc(h), s != null && pm(s))), n.passiveEffectDuration += xd(
            ke
          );
          break;
        case 12:
          if (xe & 2048) {
            xe = Ul(), Ei(
              n,
              o,
              s,
              h,
              y
            ), n = o.stateNode, n.passiveEffectDuration += zo(xe);
            try {
              le(
                o,
                ty,
                o,
                o.alternate,
                xf,
                n.passiveEffectDuration
              );
            } catch (Ve) {
              En(o, o.return, Ve);
            }
          } else
            Ei(
              n,
              o,
              s,
              h,
              y
            );
          break;
        case 31:
          xe = ho, ke = o.alternate !== null ? o.alternate.memoizedState : null, de = o.memoizedState, ke !== null && de === null ? (de = o.deletions, de !== null && 0 < de.length && de[0].tag === 18 ? (ho = !1, ke = ke.hydrationErrors, ke !== null && Z0(
            o,
            o.actualStartTime,
            y,
            ke
          )) : ho = !0) : ho = !1, Ei(
            n,
            o,
            s,
            h,
            y
          ), ho = xe;
          break;
        case 13:
          xe = ho, ke = o.alternate !== null ? o.alternate.memoizedState : null, de = o.memoizedState, ke === null || ke.dehydrated === null || de !== null && de.dehydrated !== null ? ho = !1 : (de = o.deletions, de !== null && 0 < de.length && de[0].tag === 18 ? (ho = !1, ke = ke.hydrationErrors, ke !== null && Z0(
            o,
            o.actualStartTime,
            y,
            ke
          )) : ho = !0), Ei(
            n,
            o,
            s,
            h,
            y
          ), ho = xe;
          break;
        case 23:
          break;
        case 22:
          de = o.stateNode, ke = o.alternate, o.memoizedState !== null ? de._visibility & Uc ? Ei(
            n,
            o,
            s,
            h,
            y
          ) : Rc(
            n,
            o,
            s,
            h,
            y
          ) : de._visibility & Uc ? Ei(
            n,
            o,
            s,
            h,
            y
          ) : (de._visibility |= Uc, Nu(
            n,
            o,
            s,
            h,
            (o.subtreeFlags & 10256) !== 0 || o.actualDuration !== 0 && (o.alternate === null || o.alternate.child !== o.child),
            y
          ), (o.mode & An) === on || ho || (n = o.actualStartTime, 0 <= n && 0.05 < y - n && vp(o, n, y), 0 <= Bt && 0 <= tn && 0.05 < tn - Bt && vp(
            o,
            Bt,
            tn
          ))), xe & 2048 && _m(
            ke,
            o
          );
          break;
        case 24:
          Ei(
            n,
            o,
            s,
            h,
            y
          ), xe & 2048 && Bm(o.alternate, o);
          break;
        default:
          Ei(
            n,
            o,
            s,
            h,
            y
          );
      }
      (o.mode & An) !== on && ((n = !ho && o.alternate === null && o.return !== null && o.return.alternate !== null) && (s = o.actualStartTime, 0 <= s && 0.05 < y - s && Xi(
        o,
        s,
        y,
        "Mount"
      )), 0 <= Bt && 0 <= tn && ((Ca || 0.05 < ma) && pl(
        o,
        Bt,
        tn,
        ma,
        na
      ), n && 0.05 < tn - Bt && Xi(
        o,
        Bt,
        tn,
        "Mount"
      ))), _a(C), gi(A), na = z, Ca = q, yf = Z;
    }
    function Nu(n, o, s, h, y, C) {
      for (y = y && ((o.subtreeFlags & 10256) !== 0 || o.actualDuration !== 0 && (o.alternate === null || o.alternate.child !== o.child)), o = o.child; o !== null; ) {
        var A = o.sibling;
        Um(
          n,
          o,
          s,
          h,
          y,
          A !== null ? A.actualStartTime : C
        ), o = A;
      }
    }
    function Um(n, o, s, h, y, C) {
      var A = _r(), z = Ki(), q = vi(), Z = Yi(), xe = yf;
      y && (o.mode & An) !== on && 0 < o.actualStartTime && (o.flags & 1) !== 0 && bp(
        o,
        o.actualStartTime,
        C,
        ho,
        s
      );
      var ke = o.flags;
      switch (o.tag) {
        case 0:
        case 11:
        case 15:
          Nu(
            n,
            o,
            s,
            h,
            y,
            C
          ), Hm(o, $i);
          break;
        case 23:
          break;
        case 22:
          var de = o.stateNode;
          o.memoizedState !== null ? de._visibility & Uc ? Nu(
            n,
            o,
            s,
            h,
            y,
            C
          ) : Rc(
            n,
            o,
            s,
            h,
            C
          ) : (de._visibility |= Uc, Nu(
            n,
            o,
            s,
            h,
            y,
            C
          )), y && ke & 2048 && _m(
            o.alternate,
            o
          );
          break;
        case 24:
          Nu(
            n,
            o,
            s,
            h,
            y,
            C
          ), y && ke & 2048 && Bm(o.alternate, o);
          break;
        default:
          Nu(
            n,
            o,
            s,
            h,
            y,
            C
          );
      }
      (o.mode & An) !== on && 0 <= Bt && 0 <= tn && (Ca || 0.05 < ma) && pl(
        o,
        Bt,
        tn,
        ma,
        na
      ), _a(A), gi(z), na = q, Ca = Z, yf = xe;
    }
    function Rc(n, o, s, h, y) {
      if (o.subtreeFlags & 10256 || o.actualDuration !== 0 && (o.alternate === null || o.alternate.child !== o.child))
        for (var C = o.child; C !== null; ) {
          o = C.sibling;
          var A = n, z = s, q = h, Z = o !== null ? o.actualStartTime : y, xe = yf;
          (C.mode & An) !== on && 0 < C.actualStartTime && (C.flags & 1) !== 0 && bp(
            C,
            C.actualStartTime,
            Z,
            ho,
            z
          );
          var ke = C.flags;
          switch (C.tag) {
            case 22:
              Rc(
                A,
                C,
                z,
                q,
                Z
              ), ke & 2048 && _m(C.alternate, C);
              break;
            case 24:
              Rc(
                A,
                C,
                z,
                q,
                Z
              ), ke & 2048 && Bm(C.alternate, C);
              break;
            default:
              Rc(
                A,
                C,
                z,
                q,
                Z
              );
          }
          yf = xe, C = o;
        }
    }
    function Ac(n, o, s) {
      if (n.subtreeFlags & p1)
        for (n = n.child; n !== null; )
          ag(
            n,
            o,
            s
          ), n = n.sibling;
    }
    function ag(n, o, s) {
      switch (n.tag) {
        case 26:
          Ac(
            n,
            o,
            s
          ), n.flags & p1 && n.memoizedState !== null && y2(
            s,
            eu,
            n.memoizedState,
            n.memoizedProps
          );
          break;
        case 5:
          Ac(
            n,
            o,
            s
          );
          break;
        case 3:
        case 4:
          var h = eu;
          eu = xg(
            n.stateNode.containerInfo
          ), Ac(
            n,
            o,
            s
          ), eu = h;
          break;
        case 22:
          n.memoizedState === null && (h = n.alternate, h !== null && h.memoizedState !== null ? (h = p1, p1 = 16777216, Ac(
            n,
            o,
            s
          ), p1 = h) : Ac(
            n,
            o,
            s
          ));
          break;
        default:
          Ac(
            n,
            o,
            s
          );
      }
    }
    function Yv(n) {
      var o = n.alternate;
      if (o !== null && (n = o.child, n !== null)) {
        o.child = null;
        do
          o = n.sibling, n.sibling = null, n = o;
        while (n !== null);
      }
    }
    function Pi(n) {
      var o = n.deletions;
      if ((n.flags & 16) !== 0) {
        if (o !== null)
          for (var s = 0; s < o.length; s++) {
            var h = o[s], y = _r();
            Mo = h, rs(
              h,
              n
            ), (h.mode & An) !== on && 0 <= Bt && 0 <= tn && 0.05 < tn - Bt && Xi(
              h,
              Bt,
              tn,
              "Unmount"
            ), _a(y);
          }
        Yv(n);
      }
      if (n.subtreeFlags & 10256)
        for (n = n.child; n !== null; )
          og(n), n = n.sibling;
    }
    function og(n) {
      var o = _r(), s = Ki(), h = vi(), y = Yi();
      switch (n.tag) {
        case 0:
        case 11:
        case 15:
          Pi(n), n.flags & 2048 && Jp(
            n,
            n.return,
            $i | Cs
          );
          break;
        case 3:
          var C = Ul();
          Pi(n), n.stateNode.passiveEffectDuration += xd(C);
          break;
        case 12:
          C = Ul(), Pi(n), n.stateNode.passiveEffectDuration += zo(C);
          break;
        case 22:
          C = n.stateNode, n.memoizedState !== null && C._visibility & Uc && (n.return === null || n.return.tag !== 13) ? (C._visibility &= ~Uc, ig(n), (n.mode & An) !== on && 0 <= Bt && 0 <= tn && 0.05 < tn - Bt && Xi(
            n,
            Bt,
            tn,
            "Disconnect"
          )) : Pi(n);
          break;
        default:
          Pi(n);
      }
      (n.mode & An) !== on && 0 <= Bt && 0 <= tn && (Ca || 0.05 < ma) && pl(
        n,
        Bt,
        tn,
        ma,
        na
      ), _a(o), gi(s), Ca = y, na = h;
    }
    function ig(n) {
      var o = n.deletions;
      if ((n.flags & 16) !== 0) {
        if (o !== null)
          for (var s = 0; s < o.length; s++) {
            var h = o[s], y = _r();
            Mo = h, rs(
              h,
              n
            ), (h.mode & An) !== on && 0 <= Bt && 0 <= tn && 0.05 < tn - Bt && Xi(
              h,
              Bt,
              tn,
              "Unmount"
            ), _a(y);
          }
        Yv(n);
      }
      for (n = n.child; n !== null; )
        Qv(n), n = n.sibling;
    }
    function Qv(n) {
      var o = _r(), s = Ki(), h = vi(), y = Yi();
      switch (n.tag) {
        case 0:
        case 11:
        case 15:
          Jp(
            n,
            n.return,
            $i
          ), ig(n);
          break;
        case 22:
          var C = n.stateNode;
          C._visibility & Uc && (C._visibility &= ~Uc, ig(n));
          break;
        default:
          ig(n);
      }
      (n.mode & An) !== on && 0 <= Bt && 0 <= tn && (Ca || 0.05 < ma) && pl(
        n,
        Bt,
        tn,
        ma,
        na
      ), _a(o), gi(s), Ca = y, na = h;
    }
    function rs(n, o) {
      for (; Mo !== null; ) {
        var s = Mo, h = s, y = o, C = _r(), A = Ki(), z = vi(), q = Yi();
        switch (h.tag) {
          case 0:
          case 11:
          case 15:
            Jp(
              h,
              y,
              $i
            );
            break;
          case 23:
          case 22:
            h.memoizedState !== null && h.memoizedState.cachePool !== null && (y = h.memoizedState.cachePool.pool, y != null && fc(y));
            break;
          case 24:
            pm(h.memoizedState.cache);
        }
        if ((h.mode & An) !== on && 0 <= Bt && 0 <= tn && (Ca || 0.05 < ma) && pl(
          h,
          Bt,
          tn,
          ma,
          na
        ), _a(C), gi(A), Ca = q, na = z, h = s.child, h !== null) h.return = s, Mo = h;
        else
          e: for (s = n; Mo !== null; ) {
            if (h = Mo, C = h.sibling, A = h.return, wa(h), h === s) {
              Mo = null;
              break e;
            }
            if (C !== null) {
              C.return = A, Mo = C;
              break e;
            }
            Mo = A;
          }
      }
    }
    function Jv() {
      fT.forEach(function(n) {
        return n();
      });
    }
    function Zv() {
      var n = typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0;
      return n || Xe.actQueue === null || console.error(
        "The current testing environment is not configured to support act(...)"
      ), n;
    }
    function xo(n) {
      if ((ar & po) !== Oo && Dn !== 0)
        return Dn & -Dn;
      var o = Xe.T;
      return o !== null ? (o._updatedFibers || (o._updatedFibers = /* @__PURE__ */ new Set()), o._updatedFibers.add(n), u2()) : at();
    }
    function Wd() {
      if (il === 0)
        if ((Dn & 536870912) === 0 || Xn) {
          var n = hh;
          hh <<= 1, (hh & 3932160) === 0 && (hh = 262144), il = n;
        } else il = 536870912;
      return n = jl.current, n !== null && (n.flags |= 32), il;
    }
    function ln(n, o, s) {
      if (g0 && console.error("useInsertionEffect must not schedule updates."), y4 && (Mw = !0), (n === Lr && (Tr === Rh || Tr === Ah) || n.cancelPendingCommit !== null) && (as(n, 0), el(
        n,
        Dn,
        il,
        !1
      )), mt(n, s), (ar & po) !== Oo && n === Lr) {
        if (ds)
          switch (o.tag) {
            case 0:
            case 11:
            case 15:
              n = Ln && W(Ln) || "Unknown", K8.has(n) || (K8.add(n), o = W(o) || "Unknown", console.error(
                "Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://react.dev/link/setstate-in-render",
                o,
                n,
                n
              ));
              break;
            case 1:
              q8 || (console.error(
                "Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."
              ), q8 = !0);
          }
      } else
        ms && ut(n, o, s), Km(o), n === Lr && ((ar & po) === Oo && (Af |= s), ha === Of && el(
          n,
          Dn,
          il,
          !1
        )), ti(n);
    }
    function ay(n, o, s) {
      if ((ar & (po | Ll)) !== Oo)
        throw Error("Should not already be working.");
      if (Dn !== 0 && Ln !== null) {
        var h = Ln, y = Ka();
        switch (W6) {
          case b1:
          case Rh:
            var C = t1;
            Gr && ((h = h._debugTask) ? h.run(
              console.timeStamp.bind(
                console,
                "Suspended",
                C,
                y,
                ps,
                void 0,
                "primary-light"
              )
            ) : console.timeStamp(
              "Suspended",
              C,
              y,
              ps,
              void 0,
              "primary-light"
            ));
            break;
          case Ah:
            C = t1, Gr && ((h = h._debugTask) ? h.run(
              console.timeStamp.bind(
                console,
                "Action",
                C,
                y,
                ps,
                void 0,
                "primary-light"
              )
            ) : console.timeStamp(
              "Action",
              C,
              y,
              ps,
              void 0,
              "primary-light"
            ));
            break;
          default:
            Gr && (h = y - t1, 3 > h || console.timeStamp(
              "Blocked",
              t1,
              y,
              ps,
              void 0,
              5 > h ? "primary-light" : 10 > h ? "primary" : 100 > h ? "primary-dark" : "error"
            ));
        }
      }
      C = (s = !s && (o & 127) === 0 && (o & n.expiredLanes) === 0 || Fe(n, o)) ? _s(n, o) : Bd(n, o, !0);
      var A = s;
      do {
        if (C === nd) {
          h0 && !s && el(n, o, 0, !1), o = Tr, t1 = Qa(), W6 = o;
          break;
        } else {
          if (h = Ka(), y = n.current.alternate, A && !iy(y)) {
            hl(o), y = ko, C = h, !Gr || C <= y || (Ra ? Ra.run(
              console.timeStamp.bind(
                console,
                "Teared Render",
                y,
                C,
                Zn,
                Kn,
                "error"
              )
            ) : console.timeStamp(
              "Teared Render",
              y,
              C,
              Zn,
              Kn,
              "error"
            )), Du(o, h), C = Bd(n, o, !1), A = !1;
            continue;
          }
          if (C === Th) {
            if (A = o, n.errorRecoveryDisabledLanes & A)
              var z = 0;
            else
              z = n.pendingLanes & -536870913, z = z !== 0 ? z : z & 536870912 ? 536870912 : 0;
            if (z !== 0) {
              hl(o), ev(
                ko,
                h,
                o,
                Ra
              ), Du(o, h), o = z;
              e: {
                h = n, C = A, A = w1;
                var q = h.current.memoizedState.isDehydrated;
                if (q && (as(h, z).flags |= 256), z = Bd(
                  h,
                  z,
                  !1
                ), z !== Th) {
                  if (d4 && !q) {
                    h.errorRecoveryDisabledLanes |= C, Af |= C, C = Of;
                    break e;
                  }
                  h = zi, zi = A, h !== null && (zi === null ? zi = h : zi.push.apply(
                    zi,
                    h
                  ));
                }
                C = z;
              }
              if (A = !1, C !== Th) continue;
              h = Ka();
            }
          }
          if (C === v1) {
            hl(o), ev(
              ko,
              h,
              o,
              Ra
            ), Du(o, h), as(n, 0), el(n, o, 0, !0);
            break;
          }
          e: {
            switch (s = n, C) {
              case nd:
              case v1:
                throw Error("Root did not complete. This is a bug in React.");
              case Of:
                if ((o & 4194048) !== o) break;
              case yw:
                hl(o), $b(
                  ko,
                  h,
                  o,
                  Ra
                ), Du(o, h), y = o, (y & 127) !== 0 ? aw = h : (y & 4194048) !== 0 && (ow = h), el(
                  s,
                  o,
                  il,
                  !Tf
                );
                break e;
              case Th:
                zi = null;
                break;
              case bw:
              case z8:
                break;
              default:
                throw Error("Unknown root exit status.");
            }
            if (Xe.actQueue !== null)
              zr(
                s,
                y,
                o,
                zi,
                S1,
                Cw,
                il,
                Af,
                Nh,
                C,
                null,
                null,
                ko,
                h
              );
            else {
              if ((o & 62914560) === o && (A = xw + L8 - Ka(), 10 < A)) {
                if (el(
                  s,
                  o,
                  il,
                  !Tf
                ), Ue(s, 0, !0) !== 0) break e;
                tu = o, s.timeoutHandle = r5(
                  oy.bind(
                    null,
                    s,
                    y,
                    zi,
                    S1,
                    Cw,
                    o,
                    il,
                    Af,
                    Nh,
                    Tf,
                    C,
                    "Throttled",
                    ko,
                    h
                  ),
                  A
                );
                break e;
              }
              oy(
                s,
                y,
                zi,
                S1,
                Cw,
                o,
                il,
                Af,
                Nh,
                Tf,
                C,
                null,
                ko,
                h
              );
            }
          }
        }
        break;
      } while (!0);
      ti(n);
    }
    function oy(n, o, s, h, y, C, A, z, q, Z, xe, ke, de, Ve) {
      n.timeoutHandle = Ih;
      var yt = o.subtreeFlags, Mt = null;
      if ((yt & 8192 || (yt & 16785408) === 16785408) && (Mt = {
        stylesheets: null,
        count: 0,
        imgCount: 0,
        imgBytes: 0,
        suspenseyImages: [],
        waitingForImages: !0,
        waitingForViewTransition: !1,
        unsuspend: tr
      }, ag(o, C, Mt), yt = (C & 62914560) === C ? xw - Ka() : (C & 4194048) === C ? I8 - Ka() : 0, yt = kg(Mt, yt), yt !== null)) {
        tu = C, n.cancelPendingCommit = yt(
          zr.bind(
            null,
            n,
            o,
            C,
            s,
            h,
            y,
            A,
            z,
            q,
            xe,
            Mt,
            Mt.waitingForViewTransition ? "Waiting for the previous Animation" : 0 < Mt.count ? 0 < Mt.imgCount ? "Suspended on CSS and Images" : "Suspended on CSS" : Mt.imgCount === 1 ? "Suspended on an Image" : 0 < Mt.imgCount ? "Suspended on Images" : null,
            de,
            Ve
          )
        ), el(
          n,
          C,
          A,
          !Z
        );
        return;
      }
      zr(
        n,
        o,
        C,
        s,
        h,
        y,
        A,
        z,
        q,
        xe,
        Mt,
        ke,
        de,
        Ve
      );
    }
    function iy(n) {
      for (var o = n; ; ) {
        var s = o.tag;
        if ((s === 0 || s === 11 || s === 15) && o.flags & 16384 && (s = o.updateQueue, s !== null && (s = s.stores, s !== null)))
          for (var h = 0; h < s.length; h++) {
            var y = s[h], C = y.getSnapshot;
            y = y.value;
            try {
              if (!Ai(C(), y)) return !1;
            } catch {
              return !1;
            }
          }
        if (s = o.child, o.subtreeFlags & 16384 && s !== null)
          s.return = o, o = s;
        else {
          if (o === n) break;
          for (; o.sibling === null; ) {
            if (o.return === null || o.return === n) return !0;
            o = o.return;
          }
          o.sibling.return = o.return, o = o.sibling;
        }
      }
      return !0;
    }
    function el(n, o, s, h) {
      o &= ~f4, o &= ~Af, n.suspendedLanes |= o, n.pingedLanes &= ~o, h && (n.warmLanes |= o), h = n.expirationTimes;
      for (var y = o; 0 < y; ) {
        var C = 31 - fo(y), A = 1 << C;
        h[C] = -1, y &= ~A;
      }
      s !== 0 && Rt(n, s, o);
    }
    function ki() {
      return (ar & (po | Ll)) === Oo ? (is(0), !1) : !0;
    }
    function lg() {
      if (Ln !== null) {
        if (Tr === ol)
          var n = Ln.return;
        else
          n = Ln, Sd(), bu(n), o0 = null, c1 = 0, n = Ln;
        for (; n !== null; )
          Lv(n.alternate, n), n = n.return;
        Ln = null;
      }
    }
    function Du(n, o) {
      (n & 127) !== 0 && (wh = o), (n & 4194048) !== 0 && (Yc = o), (n & 62914560) !== 0 && (H6 = o), (n & 2080374784) !== 0 && (F6 = o);
    }
    function as(n, o) {
      Gr && (console.timeStamp(
        "Blocking Track",
        3e-3,
        3e-3,
        "Blocking",
        Kn,
        "primary-light"
      ), console.timeStamp(
        "Transition Track",
        3e-3,
        3e-3,
        "Transition",
        Kn,
        "primary-light"
      ), console.timeStamp(
        "Suspense Track",
        3e-3,
        3e-3,
        "Suspense",
        Kn,
        "primary-light"
      ), console.timeStamp(
        "Idle Track",
        3e-3,
        3e-3,
        "Idle",
        Kn,
        "primary-light"
      ));
      var s = ko;
      if (ko = Qa(), Dn !== 0 && 0 < s) {
        if (hl(Dn), ha === bw || ha === Of)
          $b(
            s,
            ko,
            o,
            Ra
          );
        else {
          var h = ko, y = Ra;
          if (Gr && !(h <= s)) {
            var C = (o & 738197653) === o ? "tertiary-dark" : "primary-dark", A = (o & 536870912) === o ? "Prewarm" : (o & 201326741) === o ? "Interrupted Hydration" : "Interrupted Render";
            y ? y.run(
              console.timeStamp.bind(
                console,
                A,
                s,
                h,
                Zn,
                Kn,
                C
              )
            ) : console.timeStamp(
              A,
              s,
              h,
              Zn,
              Kn,
              C
            );
          }
        }
        Du(Dn, ko);
      }
      if (s = Ra, Ra = null, (o & 127) !== 0) {
        Ra = J2, y = 0 <= Bu && Bu < wh ? wh : Bu, h = 0 <= Sh && Sh < wh ? wh : Sh, C = 0 <= h ? h : 0 <= y ? y : ko, 0 <= aw ? (hl(2), zb(
          aw,
          C,
          o,
          s
        )) : iw & 127, s = y;
        var z = h, q = Z2, Z = 0 < n0, xe = Ef === Q2, ke = Ef === rw;
        if (y = ko, h = J2, C = BC, A = UC, Gr) {
          if (Zn = "Blocking", 0 < s ? s > y && (s = y) : s = y, 0 < z ? z > s && (z = s) : z = s, q !== null && s > z) {
            var de = Z ? "secondary-light" : "warning";
            h ? h.run(
              console.timeStamp.bind(
                console,
                Z ? "Consecutive" : "Event: " + q,
                z,
                s,
                Zn,
                Kn,
                de
              )
            ) : console.timeStamp(
              Z ? "Consecutive" : "Event: " + q,
              z,
              s,
              Zn,
              Kn,
              de
            );
          }
          y > s && (z = xe ? "error" : (o & 738197653) === o ? "tertiary-light" : "primary-light", xe = ke ? "Promise Resolved" : xe ? "Cascading Update" : 5 < y - s ? "Update Blocked" : "Update", ke = [], A != null && ke.push(["Component name", A]), C != null && ke.push(["Method name", C]), s = {
            start: s,
            end: y,
            detail: {
              devtools: {
                properties: ke,
                track: Zn,
                trackGroup: Kn,
                color: z
              }
            }
          }, h ? h.run(
            performance.measure.bind(
              performance,
              xe,
              s
            )
          ) : performance.measure(xe, s));
        }
        Bu = -1.1, Ef = 0, UC = BC = null, aw = -1.1, n0 = Sh, Sh = -1.1, wh = Qa();
      }
      if ((o & 4194048) !== 0 && (Ra = e1, y = 0 <= Qc && Qc < Yc ? Yc : Qc, s = 0 <= Ss && Ss < Yc ? Yc : Ss, h = 0 <= Pf && Pf < Yc ? Yc : Pf, C = 0 <= h ? h : 0 <= s ? s : ko, 0 <= ow ? (hl(256), zb(
        ow,
        C,
        o,
        Ra
      )) : iw & 4194048, ke = h, z = Ch, q = 0 < kf, Z = XC === rw, C = ko, h = e1, A = I6, xe = L6, Gr && (Zn = "Transition", 0 < s ? s > C && (s = C) : s = C, 0 < y ? y > s && (y = s) : y = s, 0 < ke ? ke > y && (ke = y) : ke = y, y > ke && z !== null && (de = q ? "secondary-light" : "warning", h ? h.run(
        console.timeStamp.bind(
          console,
          q ? "Consecutive" : "Event: " + z,
          ke,
          y,
          Zn,
          Kn,
          de
        )
      ) : console.timeStamp(
        q ? "Consecutive" : "Event: " + z,
        ke,
        y,
        Zn,
        Kn,
        de
      )), s > y && (h ? h.run(
        console.timeStamp.bind(
          console,
          "Action",
          y,
          s,
          Zn,
          Kn,
          "primary-dark"
        )
      ) : console.timeStamp(
        "Action",
        y,
        s,
        Zn,
        Kn,
        "primary-dark"
      )), C > s && (y = Z ? "Promise Resolved" : 5 < C - s ? "Update Blocked" : "Update", ke = [], xe != null && ke.push(["Component name", xe]), A != null && ke.push(["Method name", A]), s = {
        start: s,
        end: C,
        detail: {
          devtools: {
            properties: ke,
            track: Zn,
            trackGroup: Kn,
            color: "primary-light"
          }
        }
      }, h ? h.run(
        performance.measure.bind(
          performance,
          y,
          s
        )
      ) : performance.measure(y, s))), Ss = Qc = -1.1, XC = 0, ow = -1.1, kf = Pf, Pf = -1.1, Yc = Qa()), (o & 62914560) !== 0 && (iw & 62914560) !== 0 && (hl(4194304), tv(H6, ko)), (o & 2080374784) !== 0 && (iw & 2080374784) !== 0 && (hl(268435456), tv(F6, ko)), s = n.timeoutHandle, s !== Ih && (n.timeoutHandle = Ih, PT(s)), s = n.cancelPendingCommit, s !== null && (n.cancelPendingCommit = null, s()), tu = 0, lg(), Lr = n, Ln = s = _l(
        n.current,
        null
      ), Dn = o, Tr = ol, Hl = null, Tf = !1, h0 = Fe(n, o), d4 = !1, ha = nd, Nh = il = f4 = Af = Rf = 0, zi = w1 = null, Cw = !1, (o & 8) !== 0 && (o |= o & 32), h = n.entangledLanes, h !== 0)
        for (n = n.entanglements, h &= o; 0 < h; )
          y = 31 - fo(h), C = 1 << y, o |= n[y], h &= ~C;
      return Xu = o, yp(), n = N6(), 1e3 < n - A6 && (Xe.recentlyCreatedOwnerStacks = 0, A6 = n), Js.discardPendingWarnings(), s;
    }
    function kl(n, o) {
      un = null, Xe.H = h1, Xe.getCurrentStack = null, ds = !1, oi = null, o === a0 || o === cw ? (o = pc(), Tr = b1) : o === YC ? (o = pc(), Tr = j8) : Tr = o === i4 ? c4 : o !== null && typeof o == "object" && typeof o.then == "function" ? y1 : ww, Hl = o;
      var s = Ln;
      s === null ? (ha = v1, $m(
        n,
        $o(o, n.current)
      )) : s.mode & An && kp(s);
    }
    function e2() {
      var n = jl.current;
      return n === null ? !0 : (Dn & 4194048) === Dn ? Ms === null : (Dn & 62914560) === Dn || (Dn & 536870912) !== 0 ? n === Ms : !1;
    }
    function sg() {
      var n = Xe.H;
      return Xe.H = h1, n === null ? h1 : n;
    }
    function t2() {
      var n = Xe.A;
      return Xe.A = dT, n;
    }
    function Vd(n) {
      Ra === null && (Ra = n._debugTask == null ? null : n._debugTask);
    }
    function _d() {
      ha = Of, Tf || (Dn & 4194048) !== Dn && jl.current !== null || (h0 = !0), (Rf & 134217727) === 0 && (Af & 134217727) === 0 || Lr === null || el(
        Lr,
        Dn,
        il,
        !1
      );
    }
    function Bd(n, o, s) {
      var h = ar;
      ar |= po;
      var y = sg(), C = t2();
      if (Lr !== n || Dn !== o) {
        if (ms) {
          var A = n.memoizedUpdaters;
          0 < A.size && (Xd(n, Dn), A.clear()), ht(n, o);
        }
        S1 = null, as(n, o);
      }
      o = !1, A = ha;
      e: do
        try {
          if (Tr !== ol && Ln !== null) {
            var z = Ln, q = Hl;
            switch (Tr) {
              case c4:
                lg(), A = yw;
                break e;
              case b1:
              case Rh:
              case Ah:
              case y1:
                jl.current === null && (o = !0);
                var Z = Tr;
                if (Tr = ol, Hl = null, Ud(n, z, q, Z), s && h0) {
                  A = nd;
                  break e;
                }
                break;
              default:
                Z = Tr, Tr = ol, Hl = null, Ud(n, z, q, Z);
            }
          }
          n2(), A = ha;
          break;
        } catch (xe) {
          kl(n, xe);
        }
      while (!0);
      return o && n.shellSuspendCounter++, Sd(), ar = h, Xe.H = y, Xe.A = C, Ln === null && (Lr = null, Dn = 0, yp()), A;
    }
    function n2() {
      for (; Ln !== null; ) ug(Ln);
    }
    function _s(n, o) {
      var s = ar;
      ar |= po;
      var h = sg(), y = t2();
      if (Lr !== n || Dn !== o) {
        if (ms) {
          var C = n.memoizedUpdaters;
          0 < C.size && (Xd(n, Dn), C.clear()), ht(n, o);
        }
        S1 = null, Ew = Ka() + H8, as(n, o);
      } else
        h0 = Fe(
          n,
          o
        );
      e: do
        try {
          if (Tr !== ol && Ln !== null)
            t: switch (o = Ln, C = Hl, Tr) {
              case ww:
                Tr = ol, Hl = null, Ud(
                  n,
                  o,
                  C,
                  ww
                );
                break;
              case Rh:
              case Ah:
                if (mv(C)) {
                  Tr = ol, Hl = null, r2(o);
                  break;
                }
                o = function() {
                  Tr !== Rh && Tr !== Ah || Lr !== n || (Tr = Sw), ti(n);
                }, C.then(o, o);
                break e;
              case b1:
                Tr = Sw;
                break e;
              case j8:
                Tr = u4;
                break e;
              case Sw:
                mv(C) ? (Tr = ol, Hl = null, r2(o)) : (Tr = ol, Hl = null, Ud(
                  n,
                  o,
                  C,
                  Sw
                ));
                break;
              case u4:
                var A = null;
                switch (Ln.tag) {
                  case 26:
                    A = Ln.memoizedState;
                  case 5:
                  case 27:
                    var z = Ln;
                    if (A ? Vn(A) : z.stateNode.complete) {
                      Tr = ol, Hl = null;
                      var q = z.sibling;
                      if (q !== null) Ln = q;
                      else {
                        var Z = z.return;
                        Z !== null ? (Ln = Z, Xm(Z)) : Ln = null;
                      }
                      break t;
                    }
                    break;
                  default:
                    console.error(
                      "Unexpected type of fiber triggered a suspensey commit. This is a bug in React."
                    );
                }
                Tr = ol, Hl = null, Ud(
                  n,
                  o,
                  C,
                  u4
                );
                break;
              case y1:
                Tr = ol, Hl = null, Ud(
                  n,
                  o,
                  C,
                  y1
                );
                break;
              case c4:
                lg(), ha = yw;
                break e;
              default:
                throw Error(
                  "Unexpected SuspendedReason. This is a bug in React."
                );
            }
          Xe.actQueue !== null ? n2() : Oa();
          break;
        } catch (xe) {
          kl(n, xe);
        }
      while (!0);
      return Sd(), Xe.H = h, Xe.A = y, ar = s, Ln !== null ? nd : (Lr = null, Dn = 0, yp(), ha);
    }
    function Oa() {
      for (; Ln !== null && !Ig(); )
        ug(Ln);
    }
    function ug(n) {
      var o = n.alternate;
      (n.mode & An) !== on ? (Ns(n), o = le(
        n,
        Lm,
        o,
        n,
        Xu
      ), kp(n)) : o = le(
        n,
        Lm,
        o,
        n,
        Xu
      ), n.memoizedProps = n.pendingProps, o === null ? Xm(n) : Ln = o;
    }
    function r2(n) {
      var o = le(n, qa, n);
      n.memoizedProps = n.pendingProps, o === null ? Xm(n) : Ln = o;
    }
    function qa(n) {
      var o = n.alternate, s = (n.mode & An) !== on;
      switch (s && Ns(n), n.tag) {
        case 15:
        case 0:
          o = Nv(
            o,
            n,
            n.pendingProps,
            n.type,
            void 0,
            Dn
          );
          break;
        case 11:
          o = Nv(
            o,
            n,
            n.pendingProps,
            n.type.render,
            n.ref,
            Dn
          );
          break;
        case 5:
          bu(n);
        default:
          Lv(o, n), n = Ln = ov(n, Xu), o = Lm(o, n, Xu);
      }
      return s && kp(n), o;
    }
    function Ud(n, o, s, h) {
      Sd(), bu(o), o0 = null, c1 = 0;
      var y = o.return;
      try {
        if (Pv(
          n,
          y,
          o,
          s,
          Dn
        )) {
          ha = v1, $m(
            n,
            $o(s, n.current)
          ), Ln = null;
          return;
        }
      } catch (C) {
        if (y !== null) throw Ln = y, C;
        ha = v1, $m(
          n,
          $o(s, n.current)
        ), Ln = null;
        return;
      }
      o.flags & 32768 ? (Xn || h === ww ? n = !0 : h0 || (Dn & 536870912) !== 0 ? n = !1 : (Tf = n = !0, (h === Rh || h === Ah || h === b1 || h === y1) && (h = jl.current, h !== null && h.tag === 13 && (h.flags |= 16384))), a2(o, n)) : Xm(o);
    }
    function Xm(n) {
      var o = n;
      do {
        if ((o.flags & 32768) !== 0) {
          a2(
            o,
            Tf
          );
          return;
        }
        var s = o.alternate;
        if (n = o.return, Ns(o), s = le(
          o,
          Iv,
          s,
          o,
          Xu
        ), (o.mode & An) !== on && gm(o), s !== null) {
          Ln = s;
          return;
        }
        if (o = o.sibling, o !== null) {
          Ln = o;
          return;
        }
        Ln = o = n;
      } while (o !== null);
      ha === nd && (ha = z8);
    }
    function a2(n, o) {
      do {
        var s = Qb(n.alternate, n);
        if (s !== null) {
          s.flags &= 32767, Ln = s;
          return;
        }
        if ((n.mode & An) !== on) {
          gm(n), s = n.actualDuration;
          for (var h = n.child; h !== null; )
            s += h.actualDuration, h = h.sibling;
          n.actualDuration = s;
        }
        if (s = n.return, s !== null && (s.flags |= 32768, s.subtreeFlags = 0, s.deletions = null), !o && (n = n.sibling, n !== null)) {
          Ln = n;
          return;
        }
        Ln = n = s;
      } while (n !== null);
      ha = yw, Ln = null;
    }
    function zr(n, o, s, h, y, C, A, z, q, Z, xe, ke, de, Ve) {
      n.cancelPendingCommit = null;
      do
        Gm();
      while (no !== Df);
      if (Js.flushLegacyContextWarning(), Js.flushPendingUnsafeLifecycleWarnings(), (ar & (po | Ll)) !== Oo)
        throw Error("Should not already be working.");
      if (hl(s), Z === Th ? ev(
        de,
        Ve,
        s,
        Ra
      ) : h !== null ? mC(
        de,
        Ve,
        s,
        h,
        o !== null && o.alternate !== null && o.alternate.memoizedState.isDehydrated && (o.flags & 256) !== 0,
        Ra
      ) : fC(
        de,
        Ve,
        s,
        Ra
      ), o !== null) {
        if (s === 0 && console.error(
          "finishedLanes should not be empty during a commit. This is a bug in React."
        ), o === n.current)
          throw Error(
            "Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue."
          );
        if (C = o.lanes | o.childLanes, C |= HC, Ot(
          n,
          s,
          C,
          A,
          z,
          q
        ), n === Lr && (Ln = Lr = null, Dn = 0), p0 = o, $f = n, tu = s, p4 = C, v4 = y, U8 = h, g4 = Ve, X8 = ke, nu = Pw, G8 = null, o.actualDuration !== 0 || (o.subtreeFlags & 10256) !== 0 || (o.flags & 10256) !== 0 ? (n.callbackNode = null, n.callbackPriority = 0, Gd(Wc, function() {
          return M1 = window.event, nu === Pw && (nu = h4), qm(), null;
        })) : (n.callbackNode = null, n.callbackPriority = 0), Kc = null, xf = Qa(), ke !== null && hC(
          Ve,
          xf,
          ke,
          Ra
        ), h = (o.flags & 13878) !== 0, (o.subtreeFlags & 13878) !== 0 || h) {
          h = Xe.T, Xe.T = null, y = fr.p, fr.p = La, A = ar, ar |= Ll;
          try {
            vC(n, o, s);
          } finally {
            ar = A, fr.p = y, Xe.T = h;
          }
        }
        no = W8, _o(), os(), o2();
      }
    }
    function _o() {
      if (no === W8) {
        no = Df;
        var n = $f, o = p0, s = tu, h = (o.flags & 13878) !== 0;
        if ((o.subtreeFlags & 13878) !== 0 || h) {
          h = Xe.T, Xe.T = null;
          var y = fr.p;
          fr.p = La;
          var C = ar;
          ar |= Ll;
          try {
            f0 = s, m0 = n, mc(), Vm(o, n), m0 = f0 = null, s = O4;
            var A = gp(n.containerInfo), z = s.focusedElem, q = s.selectionRange;
            if (A !== z && z && z.ownerDocument && Rb(
              z.ownerDocument.documentElement,
              z
            )) {
              if (q !== null && Q0(z)) {
                var Z = q.start, xe = q.end;
                if (xe === void 0 && (xe = Z), "selectionStart" in z)
                  z.selectionStart = Z, z.selectionEnd = Math.min(
                    xe,
                    z.value.length
                  );
                else {
                  var ke = z.ownerDocument || document, de = ke && ke.defaultView || window;
                  if (de.getSelection) {
                    var Ve = de.getSelection(), yt = z.textContent.length, Mt = Math.min(
                      q.start,
                      yt
                    ), Vr = q.end === void 0 ? Mt : Math.min(q.end, yt);
                    !Ve.extend && Mt > Vr && (A = Vr, Vr = Mt, Mt = A);
                    var Yn = Tb(
                      z,
                      Mt
                    ), ue = Tb(
                      z,
                      Vr
                    );
                    if (Yn && ue && (Ve.rangeCount !== 1 || Ve.anchorNode !== Yn.node || Ve.anchorOffset !== Yn.offset || Ve.focusNode !== ue.node || Ve.focusOffset !== ue.offset)) {
                      var he = ke.createRange();
                      he.setStart(Yn.node, Yn.offset), Ve.removeAllRanges(), Mt > Vr ? (Ve.addRange(he), Ve.extend(ue.node, ue.offset)) : (he.setEnd(ue.node, ue.offset), Ve.addRange(he));
                    }
                  }
                }
              }
              for (ke = [], Ve = z; Ve = Ve.parentNode; )
                Ve.nodeType === 1 && ke.push({
                  element: Ve,
                  left: Ve.scrollLeft,
                  top: Ve.scrollTop
                });
              for (typeof z.focus == "function" && z.focus(), z = 0; z < ke.length; z++) {
                var Se = ke[z];
                Se.element.scrollLeft = Se.left, Se.element.scrollTop = Se.top;
              }
            }
            Ww = !!M4, O4 = M4 = null;
          } finally {
            ar = C, fr.p = y, Xe.T = h;
          }
        }
        n.current = o, no = V8;
      }
    }
    function os() {
      if (no === V8) {
        no = Df;
        var n = G8;
        if (n !== null) {
          xf = Qa();
          var o = qc, s = xf;
          !Gr || s <= o || console.timeStamp(
            n,
            o,
            s,
            Zn,
            Kn,
            "secondary-light"
          );
        }
        n = $f, o = p0, s = tu;
        var h = (o.flags & 8772) !== 0;
        if ((o.subtreeFlags & 8772) !== 0 || h) {
          h = Xe.T, Xe.T = null;
          var y = fr.p;
          fr.p = La;
          var C = ar;
          ar |= Ll;
          try {
            f0 = s, m0 = n, mc(), ng(
              n,
              o.alternate,
              o
            ), m0 = f0 = null;
          } finally {
            ar = C, fr.p = y, Xe.T = h;
          }
        }
        n = g4, o = X8, qc = Qa(), n = o === null ? n : xf, o = qc, s = nu === m4, h = Ra, Kc !== null ? jb(
          n,
          o,
          Kc,
          !1,
          h
        ) : !Gr || o <= n || (h ? h.run(
          console.timeStamp.bind(
            console,
            s ? "Commit Interrupted View Transition" : "Commit",
            n,
            o,
            Zn,
            Kn,
            s ? "error" : "secondary-dark"
          )
        ) : console.timeStamp(
          s ? "Commit Interrupted View Transition" : "Commit",
          n,
          o,
          Zn,
          Kn,
          s ? "error" : "secondary-dark"
        )), no = _8;
      }
    }
    function o2() {
      if (no === B8 || no === _8) {
        if (no === B8) {
          var n = qc;
          qc = Qa();
          var o = qc, s = nu === m4;
          !Gr || o <= n || console.timeStamp(
            s ? "Interrupted View Transition" : "Starting Animation",
            n,
            o,
            Zn,
            Kn,
            s ? " error" : "secondary-light"
          ), nu !== m4 && (nu = F8);
        }
        no = Df, Lg(), n = $f;
        var h = p0;
        o = tu, s = U8;
        var y = h.actualDuration !== 0 || (h.subtreeFlags & 10256) !== 0 || (h.flags & 10256) !== 0;
        y ? no = kw : (no = Df, p0 = $f = null, i2(
          n,
          n.pendingLanes
        ), Dh = 0, x1 = null);
        var C = n.pendingLanes;
        if (C === 0 && (Nf = null), y || fg(n), C = ot(o), h = h.stateNode, Ia && typeof Ia.onCommitFiberRoot == "function")
          try {
            var A = (h.current.flags & 128) === 128;
            switch (C) {
              case La:
                var z = j2;
                break;
              case mo:
                z = Hg;
                break;
              case Po:
                z = Wc;
                break;
              case Wu:
                z = Fg;
                break;
              default:
                z = Wc;
            }
            Ia.onCommitFiberRoot(
              Vc,
              h,
              z,
              A
            );
          } catch (ke) {
            fs || (fs = !0, console.error(
              "React instrumentation encountered an error: %o",
              ke
            ));
          }
        if (ms && n.memoizedUpdaters.clear(), Jv(), s !== null) {
          A = Xe.T, z = fr.p, fr.p = La, Xe.T = null;
          try {
            var q = n.onRecoverableError;
            for (h = 0; h < s.length; h++) {
              var Z = s[h], xe = ly(Z.stack);
              le(
                Z.source,
                q,
                Z.value,
                xe
              );
            }
          } finally {
            Xe.T = A, fr.p = z;
          }
        }
        (tu & 3) !== 0 && Gm(), ti(n), C = n.pendingLanes, (o & 261930) !== 0 && (C & 42) !== 0 ? (sw = !0, n === b4 ? C1++ : (C1 = 0, b4 = n)) : C1 = 0, y || Du(o, qc), is(0);
      }
    }
    function ly(n) {
      return n = { componentStack: n }, Object.defineProperty(n, "digest", {
        get: function() {
          console.error(
            'You are accessing "digest" from the errorInfo object passed to onRecoverableError. This property is no longer provided as part of errorInfo but can be accessed as a property of the Error instance itself.'
          );
        }
      }), n;
    }
    function i2(n, o) {
      (n.pooledCacheLanes &= o) === 0 && (o = n.pooledCache, o != null && (n.pooledCache = null, pm(o)));
    }
    function Gm() {
      return _o(), os(), o2(), qm();
    }
    function qm() {
      if (no !== kw) return !1;
      var n = $f, o = p4;
      p4 = 0;
      var s = ot(tu), h = Po > s ? Po : s;
      s = Xe.T;
      var y = fr.p;
      try {
        fr.p = h, Xe.T = null;
        var C = v4;
        v4 = null, h = $f;
        var A = tu;
        if (no = Df, p0 = $f = null, tu = 0, (ar & (po | Ll)) !== Oo)
          throw Error("Cannot flush passive effects while already rendering.");
        hl(A), y4 = !0, Mw = !1;
        var z = 0;
        if (Kc = null, z = Ka(), nu === F8)
          tv(
            qc,
            z,
            aT
          );
        else {
          var q = qc, Z = z, xe = nu === h4;
          !Gr || Z <= q || (Ra ? Ra.run(
            console.timeStamp.bind(
              console,
              xe ? "Waiting for Paint" : "Waiting",
              q,
              Z,
              Zn,
              Kn,
              "secondary-light"
            )
          ) : console.timeStamp(
            xe ? "Waiting for Paint" : "Waiting",
            q,
            Z,
            Zn,
            Kn,
            "secondary-light"
          ));
        }
        q = ar, ar |= Ll;
        var ke = h.current;
        mc(), og(ke);
        var de = h.current;
        ke = g4, mc(), Kv(
          h,
          de,
          A,
          C,
          ke
        ), fg(h), ar = q;
        var Ve = Ka();
        if (de = z, ke = Ra, Kc !== null ? jb(
          de,
          Ve,
          Kc,
          !0,
          ke
        ) : !Gr || Ve <= de || (ke ? ke.run(
          console.timeStamp.bind(
            console,
            "Remaining Effects",
            de,
            Ve,
            Zn,
            Kn,
            "secondary-dark"
          )
        ) : console.timeStamp(
          "Remaining Effects",
          de,
          Ve,
          Zn,
          Kn,
          "secondary-dark"
        )), Du(A, Ve), is(0, !1), Mw ? h === x1 ? Dh++ : (Dh = 0, x1 = h) : Dh = 0, Mw = y4 = !1, Ia && typeof Ia.onPostCommitFiberRoot == "function")
          try {
            Ia.onPostCommitFiberRoot(Vc, h);
          } catch (Mt) {
            fs || (fs = !0, console.error(
              "React instrumentation encountered an error: %o",
              Mt
            ));
          }
        var yt = h.current.stateNode;
        return yt.effectDuration = 0, yt.passiveEffectDuration = 0, !0;
      } finally {
        fr.p = y, Xe.T = s, i2(n, o);
      }
    }
    function Bo(n, o, s) {
      o = $o(s, o), Vb(o), o = Vp(n.stateNode, o, 2), n = Gl(n, o, 2), n !== null && (mt(n, 2), ti(n));
    }
    function En(n, o, s) {
      if (g0 = !1, n.tag === 3)
        Bo(n, n, s);
      else {
        for (; o !== null; ) {
          if (o.tag === 3) {
            Bo(
              o,
              n,
              s
            );
            return;
          }
          if (o.tag === 1) {
            var h = o.stateNode;
            if (typeof o.type.getDerivedStateFromError == "function" || typeof h.componentDidCatch == "function" && (Nf === null || !Nf.has(h))) {
              n = $o(s, n), Vb(n), s = _p(2), h = Gl(o, s, 2), h !== null && (Bp(
                s,
                h,
                o,
                n
              ), mt(h, 2), ti(h));
              return;
            }
          }
          o = o.return;
        }
        console.error(
          `Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Potential causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`,
          s
        );
      }
    }
    function cg(n, o, s) {
      var h = n.pingCache;
      if (h === null) {
        h = n.pingCache = new mT();
        var y = /* @__PURE__ */ new Set();
        h.set(o, y);
      } else
        y = h.get(o), y === void 0 && (y = /* @__PURE__ */ new Set(), h.set(o, y));
      y.has(s) || (d4 = !0, y.add(s), h = ei.bind(null, n, o, s), ms && Xd(n, s), o.then(h, h));
    }
    function ei(n, o, s) {
      var h = n.pingCache;
      h !== null && h.delete(o), n.pingedLanes |= n.suspendedLanes & s, n.warmLanes &= ~s, (s & 127) !== 0 ? 0 > Bu && (wh = Bu = Qa(), J2 = nw("Promise Resolved"), Ef = rw) : (s & 4194048) !== 0 && 0 > Ss && (Yc = Ss = Qa(), e1 = nw("Promise Resolved"), XC = rw), Zv() && Xe.actQueue === null && console.error(
        `A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act`
      ), Lr === n && (Dn & s) === s && (ha === Of || ha === bw && (Dn & 62914560) === Dn && Ka() - xw < L8 ? (ar & po) === Oo && as(n, 0) : f4 |= s, Nh === Dn && (Nh = 0)), ti(n);
    }
    function l2(n, o) {
      o === 0 && (o = dt()), n = So(n, o), n !== null && (mt(n, o), ti(n));
    }
    function Bs(n) {
      var o = n.memoizedState, s = 0;
      o !== null && (s = o.retryLane), l2(n, s);
    }
    function Nc(n, o) {
      var s = 0;
      switch (n.tag) {
        case 31:
        case 13:
          var h = n.stateNode, y = n.memoizedState;
          y !== null && (s = y.retryLane);
          break;
        case 19:
          h = n.stateNode;
          break;
        case 22:
          h = n.stateNode._retryCache;
          break;
        default:
          throw Error(
            "Pinged unknown suspense boundary type. This is probably a bug in React."
          );
      }
      h !== null && h.delete(o), l2(n, s);
    }
    function Ml(n, o, s) {
      if ((o.subtreeFlags & 67117056) !== 0)
        for (o = o.child; o !== null; ) {
          var h = n, y = o, C = y.type === Go;
          C = s || C, y.tag !== 22 ? y.flags & 67108864 ? C && le(
            y,
            dg,
            h,
            y
          ) : Ml(
            h,
            y,
            C
          ) : y.memoizedState === null && (C && y.flags & 8192 ? le(
            y,
            dg,
            h,
            y
          ) : y.subtreeFlags & 67108864 && le(
            y,
            Ml,
            h,
            y,
            C
          )), o = o.sibling;
        }
    }
    function dg(n, o) {
      Oe(!0);
      try {
        rg(o), Qv(o), qv(n, o.alternate, o, !1), Um(n, o, 0, null, !1, 0);
      } finally {
        Oe(!1);
      }
    }
    function fg(n) {
      var o = !0;
      n.current.mode & (ii | Qs) || (o = !1), Ml(
        n,
        n.current,
        o
      );
    }
    function tl(n) {
      if ((ar & po) === Oo) {
        var o = n.tag;
        if (o === 3 || o === 1 || o === 0 || o === 11 || o === 14 || o === 15) {
          if (o = W(n) || "ReactComponent", Ow !== null) {
            if (Ow.has(o)) return;
            Ow.add(o);
          } else Ow = /* @__PURE__ */ new Set([o]);
          le(n, function() {
            console.error(
              "Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously tries to update the component. Move this work to useEffect instead."
            );
          });
        }
      }
    }
    function Xd(n, o) {
      ms && n.memoizedUpdaters.forEach(function(s) {
        ut(n, s, o);
      });
    }
    function Gd(n, o) {
      var s = Xe.actQueue;
      return s !== null ? (s.push(o), gT) : z2(n, o);
    }
    function Km(n) {
      Zv() && Xe.actQueue === null && le(n, function() {
        console.error(
          `An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act`,
          W(n)
        );
      });
    }
    function ti(n) {
      n !== v0 && n.next === null && (v0 === null ? Tw = v0 = n : v0 = v0.next = n), Rw = !0, Xe.actQueue !== null ? S4 || (S4 = !0, uy()) : w4 || (w4 = !0, uy());
    }
    function is(n, o) {
      if (!C4 && Rw) {
        C4 = !0;
        do
          for (var s = !1, h = Tw; h !== null; ) {
            if (n !== 0) {
              var y = h.pendingLanes;
              if (y === 0) var C = 0;
              else {
                var A = h.suspendedLanes, z = h.pingedLanes;
                C = (1 << 31 - fo(42 | n) + 1) - 1, C &= y & ~(A & ~z), C = C & 201326741 ? C & 201326741 | 1 : C ? C | 2 : 0;
              }
              C !== 0 && (s = !0, Ym(h, C));
            } else
              C = Dn, C = Ue(
                h,
                h === Lr ? C : 0,
                h.cancelPendingCommit !== null || h.timeoutHandle !== Ih
              ), (C & 3) === 0 || Fe(h, C) || (s = !0, Ym(h, C));
            h = h.next;
          }
        while (s);
        C4 = !1;
      }
    }
    function sy() {
      M1 = window.event, mg();
    }
    function mg() {
      Rw = S4 = w4 = !1;
      var n = 0;
      zf !== 0 && d2() && (n = zf);
      for (var o = Ka(), s = null, h = Tw; h !== null; ) {
        var y = h.next, C = qd(h, o);
        C === 0 ? (h.next = null, s === null ? Tw = y : s.next = y, y === null && (v0 = s)) : (s = h, (n !== 0 || (C & 3) !== 0) && (Rw = !0)), h = y;
      }
      no !== Df && no !== kw || is(n), zf !== 0 && (zf = 0);
    }
    function qd(n, o) {
      for (var s = n.suspendedLanes, h = n.pingedLanes, y = n.expirationTimes, C = n.pendingLanes & -62914561; 0 < C; ) {
        var A = 31 - fo(C), z = 1 << A, q = y[A];
        q === -1 ? ((z & s) === 0 || (z & h) !== 0) && (y[A] = tt(z, o)) : q <= o && (n.expiredLanes |= z), C &= ~z;
      }
      if (o = Lr, s = Dn, s = Ue(
        n,
        n === o ? s : 0,
        n.cancelPendingCommit !== null || n.timeoutHandle !== Ih
      ), h = n.callbackNode, s === 0 || n === o && (Tr === Rh || Tr === Ah) || n.cancelPendingCommit !== null)
        return h !== null && hg(h), n.callbackNode = null, n.callbackPriority = 0;
      if ((s & 3) === 0 || Fe(n, s)) {
        if (o = s & -s, o !== n.callbackPriority || Xe.actQueue !== null && h !== x4)
          hg(h);
        else return o;
        switch (ot(s)) {
          case La:
          case mo:
            s = Hg;
            break;
          case Po:
            s = Wc;
            break;
          case Wu:
            s = Fg;
            break;
          default:
            s = Wc;
        }
        return h = s2.bind(null, n), Xe.actQueue !== null ? (Xe.actQueue.push(h), s = x4) : s = z2(s, h), n.callbackPriority = o, n.callbackNode = s, o;
      }
      return h !== null && hg(h), n.callbackPriority = 2, n.callbackNode = null, 2;
    }
    function s2(n, o) {
      if (sw = lw = !1, M1 = window.event, no !== Df && no !== kw)
        return n.callbackNode = null, n.callbackPriority = 0, null;
      var s = n.callbackNode;
      if (nu === Pw && (nu = h4), Gm() && n.callbackNode !== s)
        return null;
      var h = Dn;
      return h = Ue(
        n,
        n === Lr ? h : 0,
        n.cancelPendingCommit !== null || n.timeoutHandle !== Ih
      ), h === 0 ? null : (ay(
        n,
        h,
        o
      ), qd(n, Ka()), n.callbackNode != null && n.callbackNode === s ? s2.bind(null, n) : null);
    }
    function Ym(n, o) {
      if (Gm()) return null;
      lw = sw, sw = !1, ay(n, o, !0);
    }
    function hg(n) {
      n !== x4 && n !== null && jg(n);
    }
    function uy() {
      Xe.actQueue !== null && Xe.actQueue.push(function() {
        return mg(), null;
      }), kT(function() {
        (ar & (po | Ll)) !== Oo ? z2(
          j2,
          sy
        ) : mg();
      });
    }
    function u2() {
      if (zf === 0) {
        var n = xh;
        n === 0 && (n = mf, mf <<= 1, (mf & 261888) === 0 && (mf = 256)), zf = n;
      }
      return zf;
    }
    function ir(n) {
      return n == null || typeof n == "symbol" || typeof n == "boolean" ? null : typeof n == "function" ? n : (pe(n, "action"), pr("" + n));
    }
    function kr(n, o) {
      var s = o.ownerDocument.createElement("input");
      return s.name = o.name, s.value = o.value, n.id && s.setAttribute("form", n.id), o.parentNode.insertBefore(s, o), n = new FormData(n), s.parentNode.removeChild(s), n;
    }
    function Bn(n, o, s, h, y) {
      if (o === "submit" && s && s.stateNode === y) {
        var C = ir(
          (y[qo] || null).action
        ), A = h.submitter;
        A && (o = (o = A[qo] || null) ? ir(o.formAction) : A.getAttribute("formAction"), o !== null && (C = o, A = null));
        var z = new Ky(
          "action",
          "action",
          null,
          h,
          y
        );
        n.push({
          event: z,
          listeners: [
            {
              instance: null,
              listener: function() {
                if (h.defaultPrevented) {
                  if (zf !== 0) {
                    var q = A ? kr(
                      y,
                      A
                    ) : new FormData(y), Z = {
                      pending: !0,
                      data: q,
                      method: y.method,
                      action: C
                    };
                    Object.freeze(Z), Fs(
                      s,
                      Z,
                      null,
                      q
                    );
                  }
                } else
                  typeof C == "function" && (z.preventDefault(), q = A ? kr(
                    y,
                    A
                  ) : new FormData(y), Z = {
                    pending: !0,
                    data: q,
                    method: y.method,
                    action: C
                  }, Object.freeze(Z), Fs(
                    s,
                    Z,
                    C,
                    q
                  ));
              },
              currentTarget: y
            }
          ]
        });
      }
    }
    function In(n, o, s) {
      n.currentTarget = s;
      try {
        o(n);
      } catch (h) {
        zC(h);
      }
      n.currentTarget = null;
    }
    function br(n, o) {
      o = (o & 4) !== 0;
      for (var s = 0; s < n.length; s++) {
        var h = n[s];
        e: {
          var y = void 0, C = h.event;
          if (h = h.listeners, o)
            for (var A = h.length - 1; 0 <= A; A--) {
              var z = h[A], q = z.instance, Z = z.currentTarget;
              if (z = z.listener, q !== y && C.isPropagationStopped())
                break e;
              q !== null ? le(
                q,
                In,
                C,
                z,
                Z
              ) : In(C, z, Z), y = q;
            }
          else
            for (A = 0; A < h.length; A++) {
              if (z = h[A], q = z.instance, Z = z.currentTarget, z = z.listener, q !== y && C.isPropagationStopped())
                break e;
              q !== null ? le(
                q,
                In,
                C,
                z,
                Z
              ) : In(C, z, Z), y = q;
            }
        }
      }
    }
    function rn(n, o) {
      E4.has(n) || console.error(
        'Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.',
        n
      );
      var s = o[_c];
      s === void 0 && (s = o[_c] = /* @__PURE__ */ new Set());
      var h = n + "__bubble";
      s.has(h) || (pg(o, n, 2, !1), s.add(h));
    }
    function ls(n, o, s) {
      E4.has(n) && !o && console.error(
        'Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.',
        n
      );
      var h = 0;
      o && (h |= 4), pg(
        s,
        n,
        h,
        o
      );
    }
    function $u(n) {
      if (!n[Aw]) {
        n[Aw] = !0, By.forEach(function(s) {
          s !== "selectionchange" && (E4.has(s) || ls(s, !1, n), ls(s, !0, n));
        });
        var o = n.nodeType === 9 ? n : n.ownerDocument;
        o === null || o[Aw] || (o[Aw] = !0, ls("selectionchange", !1, o));
      }
    }
    function pg(n, o, s, h) {
      switch (Tg(o)) {
        case La:
          var y = E2;
          break;
        case mo:
          y = co;
          break;
        default:
          y = P2;
      }
      s = y.bind(
        null,
        o,
        s,
        n
      ), y = void 0, !PC || o !== "touchstart" && o !== "touchmove" && o !== "wheel" || (y = !0), h ? y !== void 0 ? n.addEventListener(o, s, {
        capture: !0,
        passive: y
      }) : n.addEventListener(o, s, !0) : y !== void 0 ? n.addEventListener(o, s, {
        passive: y
      }) : n.addEventListener(
        o,
        s,
        !1
      );
    }
    function Ol(n, o, s, h, y) {
      var C = h;
      if ((o & 1) === 0 && (o & 2) === 0 && h !== null)
        e: for (; ; ) {
          if (h === null) return;
          var A = h.tag;
          if (A === 3 || A === 4) {
            var z = h.stateNode.containerInfo;
            if (z === y) break;
            if (A === 4)
              for (A = h.return; A !== null; ) {
                var q = A.tag;
                if ((q === 3 || q === 4) && A.stateNode.containerInfo === y)
                  return;
                A = A.return;
              }
            for (; z !== null; ) {
              if (A = pt(z), A === null) return;
              if (q = A.tag, q === 5 || q === 6 || q === 26 || q === 27) {
                h = C = A;
                continue e;
              }
              z = z.parentNode;
            }
          }
          h = h.return;
        }
      Li(function() {
        var Z = C, xe = Va(s), ke = [];
        e: {
          var de = R6.get(n);
          if (de !== void 0) {
            var Ve = Ky, yt = n;
            switch (n) {
              case "keypress":
                if (rc(s) === 0) break e;
              case "keydown":
              case "keyup":
                Ve = RO;
                break;
              case "focusin":
                yt = "focus", Ve = TC;
                break;
              case "focusout":
                yt = "blur", Ve = TC;
                break;
              case "beforeblur":
              case "afterblur":
                Ve = TC;
                break;
              case "click":
                if (s.button === 2) break e;
              case "auxclick":
              case "dblclick":
              case "mousedown":
              case "mousemove":
              case "mouseup":
              case "mouseout":
              case "mouseover":
              case "contextmenu":
                Ve = g6;
                break;
              case "drag":
              case "dragend":
              case "dragenter":
              case "dragexit":
              case "dragleave":
              case "dragover":
              case "dragstart":
              case "drop":
                Ve = bO;
                break;
              case "touchcancel":
              case "touchend":
              case "touchmove":
              case "touchstart":
                Ve = DO;
                break;
              case k6:
              case M6:
              case O6:
                Ve = SO;
                break;
              case T6:
                Ve = zO;
                break;
              case "scroll":
              case "scrollend":
                Ve = gO;
                break;
              case "wheel":
                Ve = IO;
                break;
              case "copy":
              case "cut":
              case "paste":
                Ve = xO;
                break;
              case "gotpointercapture":
              case "lostpointercapture":
              case "pointercancel":
              case "pointerdown":
              case "pointermove":
              case "pointerout":
              case "pointerover":
              case "pointerup":
                Ve = b6;
                break;
              case "toggle":
              case "beforetoggle":
                Ve = HO;
            }
            var Mt = (o & 4) !== 0, Vr = !Mt && (n === "scroll" || n === "scrollend"), Yn = Mt ? de !== null ? de + "Capture" : null : de;
            Mt = [];
            for (var ue = Z, he; ue !== null; ) {
              var Se = ue;
              if (he = Se.stateNode, Se = Se.tag, Se !== 5 && Se !== 26 && Se !== 27 || he === null || Yn === null || (Se = yo(ue, Yn), Se != null && Mt.push(
                jr(
                  ue,
                  Se,
                  he
                )
              )), Vr) break;
              ue = ue.return;
            }
            0 < Mt.length && (de = new Ve(
              de,
              yt,
              null,
              s,
              xe
            ), ke.push({
              event: de,
              listeners: Mt
            }));
          }
        }
        if ((o & 7) === 0) {
          e: {
            if (de = n === "mouseover" || n === "pointerover", Ve = n === "mouseout" || n === "pointerout", de && s !== W2 && (yt = s.relatedTarget || s.fromElement) && (pt(yt) || yt[Ys]))
              break e;
            if ((Ve || de) && (de = xe.window === xe ? xe : (de = xe.ownerDocument) ? de.defaultView || de.parentWindow : window, Ve ? (yt = s.relatedTarget || s.toElement, Ve = Z, yt = yt ? pt(yt) : null, yt !== null && (Vr = T(yt), Mt = yt.tag, yt !== Vr || Mt !== 5 && Mt !== 27 && Mt !== 6) && (yt = null)) : (Ve = null, yt = Z), Ve !== yt)) {
              if (Mt = g6, Se = "onMouseLeave", Yn = "onMouseEnter", ue = "mouse", (n === "pointerout" || n === "pointerover") && (Mt = b6, Se = "onPointerLeave", Yn = "onPointerEnter", ue = "pointer"), Vr = Ve == null ? de : Nt(Ve), he = yt == null ? de : Nt(yt), de = new Mt(
                Se,
                ue + "leave",
                Ve,
                s,
                xe
              ), de.target = Vr, de.relatedTarget = he, Se = null, pt(xe) === Z && (Mt = new Mt(
                Yn,
                ue + "enter",
                yt,
                s,
                xe
              ), Mt.target = he, Mt.relatedTarget = Vr, Se = Mt), Vr = Se, Ve && yt)
                t: {
                  for (Mt = Dc, Yn = Ve, ue = yt, he = 0, Se = Yn; Se; Se = Mt(Se))
                    he++;
                  Se = 0;
                  for (var Ze = ue; Ze; Ze = Mt(Ze))
                    Se++;
                  for (; 0 < he - Se; )
                    Yn = Mt(Yn), he--;
                  for (; 0 < Se - he; )
                    ue = Mt(ue), Se--;
                  for (; he--; ) {
                    if (Yn === ue || ue !== null && Yn === ue.alternate) {
                      Mt = Yn;
                      break t;
                    }
                    Yn = Mt(Yn), ue = Mt(ue);
                  }
                  Mt = null;
                }
              else Mt = null;
              Ve !== null && gg(
                ke,
                de,
                Ve,
                Mt,
                !1
              ), yt !== null && Vr !== null && gg(
                ke,
                Vr,
                yt,
                Mt,
                !0
              );
            }
          }
          e: {
            if (de = Z ? Nt(Z) : window, Ve = de.nodeName && de.nodeName.toLowerCase(), Ve === "select" || Ve === "input" && de.type === "file")
              var xt = cu;
            else if (Zh(de))
              if (E6)
                xt = cm;
              else {
                xt = K0;
                var cn = dC;
              }
            else
              Ve = de.nodeName, !Ve || Ve.toLowerCase() !== "input" || de.type !== "checkbox" && de.type !== "radio" ? Z && ka(Z.elementType) && (xt = cu) : xt = Y0;
            if (xt && (xt = xt(n, Z))) {
              sm(
                ke,
                xt,
                s,
                xe
              );
              break e;
            }
            cn && cn(n, de, Z), n === "focusout" && Z && de.type === "number" && Z.memoizedProps.value != null && Gn(de, "number", de.value);
          }
          switch (cn = Z ? Nt(Z) : window, n) {
            case "focusin":
              (Zh(cn) || cn.contentEditable === "true") && (qg = cn, AC = Z, q2 = null);
              break;
            case "focusout":
              q2 = AC = qg = null;
              break;
            case "mousedown":
              NC = !0;
              break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
              NC = !1, Ab(
                ke,
                s,
                xe
              );
              break;
            case "selectionchange":
              if (_O) break;
            case "keydown":
            case "keyup":
              Ab(
                ke,
                s,
                xe
              );
          }
          var _t;
          if (RC)
            e: {
              switch (n) {
                case "compositionstart":
                  var Ht = "onCompositionStart";
                  break e;
                case "compositionend":
                  Ht = "onCompositionEnd";
                  break e;
                case "compositionupdate":
                  Ht = "onCompositionUpdate";
                  break e;
              }
              Ht = void 0;
            }
          else
            Gg ? wo(n, s) && (Ht = "onCompositionEnd") : n === "keydown" && s.keyCode === y6 && (Ht = "onCompositionStart");
          Ht && (w6 && s.locale !== "ko" && (Gg || Ht !== "onCompositionStart" ? Ht === "onCompositionEnd" && Gg && (_t = ul()) : (bf = xe, kC = "value" in bf ? bf.value : bf.textContent, Gg = !0)), cn = Tl(
            Z,
            Ht
          ), 0 < cn.length && (Ht = new v6(
            Ht,
            n,
            null,
            s,
            xe
          ), ke.push({
            event: Ht,
            listeners: cn
          }), _t ? Ht.data = _t : (_t = Ea(s), _t !== null && (Ht.data = _t)))), (_t = WO ? Uf(n, s) : gd(n, s)) && (Ht = Tl(
            Z,
            "onBeforeInput"
          ), 0 < Ht.length && (cn = new PO(
            "onBeforeInput",
            "beforeinput",
            null,
            s,
            xe
          ), ke.push({
            event: cn,
            listeners: Ht
          }), cn.data = _t)), Bn(
            ke,
            n,
            Z,
            s,
            xe
          );
        }
        br(ke, o);
      });
    }
    function jr(n, o, s) {
      return {
        instance: n,
        listener: o,
        currentTarget: s
      };
    }
    function Tl(n, o) {
      for (var s = o + "Capture", h = []; n !== null; ) {
        var y = n, C = y.stateNode;
        if (y = y.tag, y !== 5 && y !== 26 && y !== 27 || C === null || (y = yo(n, s), y != null && h.unshift(
          jr(n, y, C)
        ), y = yo(n, o), y != null && h.push(
          jr(n, y, C)
        )), n.tag === 3) return h;
        n = n.return;
      }
      return [];
    }
    function Dc(n) {
      if (n === null) return null;
      do
        n = n.return;
      while (n && n.tag !== 5 && n.tag !== 27);
      return n || null;
    }
    function gg(n, o, s, h, y) {
      for (var C = o._reactName, A = []; s !== null && s !== h; ) {
        var z = s, q = z.alternate, Z = z.stateNode;
        if (z = z.tag, q !== null && q === h) break;
        z !== 5 && z !== 26 && z !== 27 || Z === null || (q = Z, y ? (Z = yo(s, C), Z != null && A.unshift(
          jr(s, Z, q)
        )) : y || (Z = yo(s, C), Z != null && A.push(
          jr(s, Z, q)
        ))), s = s.return;
      }
      A.length !== 0 && n.push({ event: o, listeners: A });
    }
    function Uo(n, o) {
      qt(n, o), n !== "input" && n !== "textarea" && n !== "select" || o == null || o.value !== null || h6 || (h6 = !0, n === "select" && o.multiple ? console.error(
        "`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.",
        n
      ) : console.error(
        "`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.",
        n
      ));
      var s = {
        registrationNameDependencies: hs,
        possibleRegistrationNames: gf
      };
      ka(n) || typeof o.is == "string" || ur(n, o, s), o.contentEditable && !o.suppressContentEditableWarning && o.children != null && console.error(
        "A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."
      );
    }
    function ea(n, o, s, h) {
      o !== s && (s = Rl(s), Rl(o) !== s && (h[n] = o));
    }
    function Qm(n, o, s) {
      o.forEach(function(h) {
        s[Us(h)] = h === "style" ? zu(n) : n.getAttribute(h);
      });
    }
    function ta(n, o) {
      o === !1 ? console.error(
        "Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.",
        n,
        n,
        n
      ) : console.error(
        "Expected `%s` listener to be a function, instead got a value of `%s` type.",
        n,
        typeof o
      );
    }
    function vg(n, o) {
      return n = n.namespaceURI === vn || n.namespaceURI === Pn ? n.ownerDocument.createElementNS(
        n.namespaceURI,
        n.tagName
      ) : n.ownerDocument.createElement(n.tagName), n.innerHTML = o, n.innerHTML;
    }
    function Rl(n) {
      return we(n) && (console.error(
        "The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before using it here.",
        Ae(n)
      ), Ne(n)), (typeof n == "string" ? n : "" + n).replace(vT, `
`).replace(bT, "");
    }
    function c2(n, o) {
      return o = Rl(o), Rl(n) === o;
    }
    function dr(n, o, s, h, y, C) {
      switch (s) {
        case "children":
          typeof h == "string" ? (nn(h, o, !1), o === "body" || o === "textarea" && h === "" || er(n, h)) : (typeof h == "number" || typeof h == "bigint") && (nn("" + h, o, !1), o !== "body" && er(n, "" + h));
          break;
        case "className":
          wn(n, "class", h);
          break;
        case "tabIndex":
          wn(n, "tabindex", h);
          break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
          wn(n, s, h);
          break;
        case "style":
          hi(n, h, C);
          break;
        case "data":
          if (o !== "object") {
            wn(n, "data", h);
            break;
          }
        case "src":
        case "href":
          if (h === "" && (o !== "a" || s !== "href")) {
            console.error(
              s === "src" ? 'An empty string ("") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string.' : 'An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.',
              s,
              s
            ), n.removeAttribute(s);
            break;
          }
          if (h == null || typeof h == "function" || typeof h == "symbol" || typeof h == "boolean") {
            n.removeAttribute(s);
            break;
          }
          pe(h, s), h = pr("" + h), n.setAttribute(s, h);
          break;
        case "action":
        case "formAction":
          if (h != null && (o === "form" ? s === "formAction" ? console.error(
            "You can only pass the formAction prop to <input> or <button>. Use the action prop on <form>."
          ) : typeof h == "function" && (y.encType == null && y.method == null || $w || ($w = !0, console.error(
            "Cannot specify a encType or method for a form that specifies a function as the action. React provides those automatically. They will get overridden."
          )), y.target == null || Dw || (Dw = !0, console.error(
            "Cannot specify a target for a form that specifies a function as the action. The function will always be executed in the same window."
          ))) : o === "input" || o === "button" ? s === "action" ? console.error(
            "You can only pass the action prop to <form>. Use the formAction prop on <input> or <button>."
          ) : o !== "input" || y.type === "submit" || y.type === "image" || Nw ? o !== "button" || y.type == null || y.type === "submit" || Nw ? typeof h == "function" && (y.name == null || J8 || (J8 = !0, console.error(
            'Cannot specify a "name" prop for a button that specifies a function as a formAction. React needs it to encode which action should be invoked. It will get overridden.'
          )), y.formEncType == null && y.formMethod == null || $w || ($w = !0, console.error(
            "Cannot specify a formEncType or formMethod for a button that specifies a function as a formAction. React provides those automatically. They will get overridden."
          )), y.formTarget == null || Dw || (Dw = !0, console.error(
            "Cannot specify a formTarget for a button that specifies a function as a formAction. The function will always be executed in the same window."
          ))) : (Nw = !0, console.error(
            'A button can only specify a formAction along with type="submit" or no type.'
          )) : (Nw = !0, console.error(
            'An input can only specify a formAction along with type="submit" or type="image".'
          )) : console.error(
            s === "action" ? "You can only pass the action prop to <form>." : "You can only pass the formAction prop to <input> or <button>."
          )), typeof h == "function") {
            n.setAttribute(
              s,
              "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
            );
            break;
          } else
            typeof C == "function" && (s === "formAction" ? (o !== "input" && dr(n, o, "name", y.name, y, null), dr(
              n,
              o,
              "formEncType",
              y.formEncType,
              y,
              null
            ), dr(
              n,
              o,
              "formMethod",
              y.formMethod,
              y,
              null
            ), dr(
              n,
              o,
              "formTarget",
              y.formTarget,
              y,
              null
            )) : (dr(
              n,
              o,
              "encType",
              y.encType,
              y,
              null
            ), dr(n, o, "method", y.method, y, null), dr(
              n,
              o,
              "target",
              y.target,
              y,
              null
            )));
          if (h == null || typeof h == "symbol" || typeof h == "boolean") {
            n.removeAttribute(s);
            break;
          }
          pe(h, s), h = pr("" + h), n.setAttribute(s, h);
          break;
        case "onClick":
          h != null && (typeof h != "function" && ta(s, h), n.onclick = tr);
          break;
        case "onScroll":
          h != null && (typeof h != "function" && ta(s, h), rn("scroll", n));
          break;
        case "onScrollEnd":
          h != null && (typeof h != "function" && ta(s, h), rn("scrollend", n));
          break;
        case "dangerouslySetInnerHTML":
          if (h != null) {
            if (typeof h != "object" || !("__html" in h))
              throw Error(
                "`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information."
              );
            if (s = h.__html, s != null) {
              if (y.children != null)
                throw Error(
                  "Can only set one of `children` or `props.dangerouslySetInnerHTML`."
                );
              n.innerHTML = s;
            }
          }
          break;
        case "multiple":
          n.multiple = h && typeof h != "function" && typeof h != "symbol";
          break;
        case "muted":
          n.muted = h && typeof h != "function" && typeof h != "symbol";
          break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
          break;
        case "autoFocus":
          break;
        case "xlinkHref":
          if (h == null || typeof h == "function" || typeof h == "boolean" || typeof h == "symbol") {
            n.removeAttribute("xlink:href");
            break;
          }
          pe(h, s), s = pr("" + h), n.setAttributeNS($h, "xlink:href", s);
          break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
          h != null && typeof h != "function" && typeof h != "symbol" ? (pe(h, s), n.setAttribute(s, "" + h)) : n.removeAttribute(s);
          break;
        case "inert":
          h !== "" || zw[s] || (zw[s] = !0, console.error(
            "Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.",
            s
          ));
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
          h && typeof h != "function" && typeof h != "symbol" ? n.setAttribute(s, "") : n.removeAttribute(s);
          break;
        case "capture":
        case "download":
          h === !0 ? n.setAttribute(s, "") : h !== !1 && h != null && typeof h != "function" && typeof h != "symbol" ? (pe(h, s), n.setAttribute(s, h)) : n.removeAttribute(s);
          break;
        case "cols":
        case "rows":
        case "size":
        case "span":
          h != null && typeof h != "function" && typeof h != "symbol" && !isNaN(h) && 1 <= h ? (pe(h, s), n.setAttribute(s, h)) : n.removeAttribute(s);
          break;
        case "rowSpan":
        case "start":
          h == null || typeof h == "function" || typeof h == "symbol" || isNaN(h) ? n.removeAttribute(s) : (pe(h, s), n.setAttribute(s, h));
          break;
        case "popover":
          rn("beforetoggle", n), rn("toggle", n), pn(n, "popover", h);
          break;
        case "xlinkActuate":
          Lt(
            n,
            $h,
            "xlink:actuate",
            h
          );
          break;
        case "xlinkArcrole":
          Lt(
            n,
            $h,
            "xlink:arcrole",
            h
          );
          break;
        case "xlinkRole":
          Lt(
            n,
            $h,
            "xlink:role",
            h
          );
          break;
        case "xlinkShow":
          Lt(
            n,
            $h,
            "xlink:show",
            h
          );
          break;
        case "xlinkTitle":
          Lt(
            n,
            $h,
            "xlink:title",
            h
          );
          break;
        case "xlinkType":
          Lt(
            n,
            $h,
            "xlink:type",
            h
          );
          break;
        case "xmlBase":
          Lt(
            n,
            P4,
            "xml:base",
            h
          );
          break;
        case "xmlLang":
          Lt(
            n,
            P4,
            "xml:lang",
            h
          );
          break;
        case "xmlSpace":
          Lt(
            n,
            P4,
            "xml:space",
            h
          );
          break;
        case "is":
          C != null && console.error(
            'Cannot update the "is" prop after it has been initialized.'
          ), pn(n, "is", h);
          break;
        case "innerText":
        case "textContent":
          break;
        case "popoverTarget":
          Z8 || h == null || typeof h != "object" || (Z8 = !0, console.error(
            "The `popoverTarget` prop expects the ID of an Element as a string. Received %s instead.",
            h
          ));
        default:
          !(2 < s.length) || s[0] !== "o" && s[0] !== "O" || s[1] !== "n" && s[1] !== "N" ? (s = Ui(s), pn(n, s, h)) : hs.hasOwnProperty(s) && h != null && typeof h != "function" && ta(s, h);
      }
    }
    function Kd(n, o, s, h, y, C) {
      switch (s) {
        case "style":
          hi(n, h, C);
          break;
        case "dangerouslySetInnerHTML":
          if (h != null) {
            if (typeof h != "object" || !("__html" in h))
              throw Error(
                "`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information."
              );
            if (s = h.__html, s != null) {
              if (y.children != null)
                throw Error(
                  "Can only set one of `children` or `props.dangerouslySetInnerHTML`."
                );
              n.innerHTML = s;
            }
          }
          break;
        case "children":
          typeof h == "string" ? er(n, h) : (typeof h == "number" || typeof h == "bigint") && er(n, "" + h);
          break;
        case "onScroll":
          h != null && (typeof h != "function" && ta(s, h), rn("scroll", n));
          break;
        case "onScrollEnd":
          h != null && (typeof h != "function" && ta(s, h), rn("scrollend", n));
          break;
        case "onClick":
          h != null && (typeof h != "function" && ta(s, h), n.onclick = tr);
          break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
          break;
        case "innerText":
        case "textContent":
          break;
        default:
          if (hs.hasOwnProperty(s))
            h != null && typeof h != "function" && ta(s, h);
          else
            e: {
              if (s[0] === "o" && s[1] === "n" && (y = s.endsWith("Capture"), o = s.slice(2, y ? s.length - 7 : void 0), C = n[qo] || null, C = C != null ? C[s] : null, typeof C == "function" && n.removeEventListener(o, C, y), typeof h == "function")) {
                typeof C != "function" && C !== null && (s in n ? n[s] = null : n.hasAttribute(s) && n.removeAttribute(s)), n.addEventListener(o, h, y);
                break e;
              }
              s in n ? n[s] = h : h === !0 ? n.setAttribute(s, "") : pn(n, s, h);
            }
      }
    }
    function Ur(n, o, s) {
      switch (Uo(o, s), o) {
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
          break;
        case "img":
          rn("error", n), rn("load", n);
          var h = !1, y = !1, C;
          for (C in s)
            if (s.hasOwnProperty(C)) {
              var A = s[C];
              if (A != null)
                switch (C) {
                  case "src":
                    h = !0;
                    break;
                  case "srcSet":
                    y = !0;
                    break;
                  case "children":
                  case "dangerouslySetInnerHTML":
                    throw Error(
                      o + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                    );
                  default:
                    dr(n, o, C, A, s, null);
                }
            }
          y && dr(n, o, "srcSet", s.srcSet, s, null), h && dr(n, o, "src", s.src, s, null);
          return;
        case "input":
          jn("input", s), rn("invalid", n);
          var z = C = A = y = null, q = null, Z = null;
          for (h in s)
            if (s.hasOwnProperty(h)) {
              var xe = s[h];
              if (xe != null)
                switch (h) {
                  case "name":
                    y = xe;
                    break;
                  case "type":
                    A = xe;
                    break;
                  case "checked":
                    q = xe;
                    break;
                  case "defaultChecked":
                    Z = xe;
                    break;
                  case "value":
                    C = xe;
                    break;
                  case "defaultValue":
                    z = xe;
                    break;
                  case "children":
                  case "dangerouslySetInnerHTML":
                    if (xe != null)
                      throw Error(
                        o + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                      );
                    break;
                  default:
                    dr(n, o, h, xe, s, null);
                }
            }
          Dt(n, s), Mn(
            n,
            C,
            z,
            q,
            Z,
            A,
            y,
            !1
          );
          return;
        case "select":
          jn("select", s), rn("invalid", n), h = A = C = null;
          for (y in s)
            if (s.hasOwnProperty(y) && (z = s[y], z != null))
              switch (y) {
                case "value":
                  C = z;
                  break;
                case "defaultValue":
                  A = z;
                  break;
                case "multiple":
                  h = z;
                default:
                  dr(
                    n,
                    o,
                    y,
                    z,
                    s,
                    null
                  );
              }
          Rr(n, s), o = C, s = A, n.multiple = !!h, o != null ? qn(n, !!h, o, !1) : s != null && qn(n, !!h, s, !0);
          return;
        case "textarea":
          jn("textarea", s), rn("invalid", n), C = y = h = null;
          for (A in s)
            if (s.hasOwnProperty(A) && (z = s[A], z != null))
              switch (A) {
                case "value":
                  h = z;
                  break;
                case "defaultValue":
                  y = z;
                  break;
                case "children":
                  C = z;
                  break;
                case "dangerouslySetInnerHTML":
                  if (z != null)
                    throw Error(
                      "`dangerouslySetInnerHTML` does not make sense on <textarea>."
                    );
                  break;
                default:
                  dr(
                    n,
                    o,
                    A,
                    z,
                    s,
                    null
                  );
              }
          Wt(n, s), Xt(n, h, y, C);
          return;
        case "option":
          wr(n, s);
          for (q in s)
            if (s.hasOwnProperty(q) && (h = s[q], h != null))
              switch (q) {
                case "selected":
                  n.selected = h && typeof h != "function" && typeof h != "symbol";
                  break;
                default:
                  dr(n, o, q, h, s, null);
              }
          return;
        case "dialog":
          rn("beforetoggle", n), rn("toggle", n), rn("cancel", n), rn("close", n);
          break;
        case "iframe":
        case "object":
          rn("load", n);
          break;
        case "video":
        case "audio":
          for (h = 0; h < E1.length; h++)
            rn(E1[h], n);
          break;
        case "image":
          rn("error", n), rn("load", n);
          break;
        case "details":
          rn("toggle", n);
          break;
        case "embed":
        case "source":
        case "link":
          rn("error", n), rn("load", n);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
          for (Z in s)
            if (s.hasOwnProperty(Z) && (h = s[Z], h != null))
              switch (Z) {
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(
                    o + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                  );
                default:
                  dr(n, o, Z, h, s, null);
              }
          return;
        default:
          if (ka(o)) {
            for (xe in s)
              s.hasOwnProperty(xe) && (h = s[xe], h !== void 0 && Kd(
                n,
                o,
                xe,
                h,
                s,
                void 0
              ));
            return;
          }
      }
      for (z in s)
        s.hasOwnProperty(z) && (h = s[z], h != null && dr(n, o, z, h, s, null));
    }
    function ja(n, o, s, h) {
      switch (Uo(o, h), o) {
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
          break;
        case "input":
          var y = null, C = null, A = null, z = null, q = null, Z = null, xe = null;
          for (Ve in s) {
            var ke = s[Ve];
            if (s.hasOwnProperty(Ve) && ke != null)
              switch (Ve) {
                case "checked":
                  break;
                case "value":
                  break;
                case "defaultValue":
                  q = ke;
                default:
                  h.hasOwnProperty(Ve) || dr(
                    n,
                    o,
                    Ve,
                    null,
                    h,
                    ke
                  );
              }
          }
          for (var de in h) {
            var Ve = h[de];
            if (ke = s[de], h.hasOwnProperty(de) && (Ve != null || ke != null))
              switch (de) {
                case "type":
                  C = Ve;
                  break;
                case "name":
                  y = Ve;
                  break;
                case "checked":
                  Z = Ve;
                  break;
                case "defaultChecked":
                  xe = Ve;
                  break;
                case "value":
                  A = Ve;
                  break;
                case "defaultValue":
                  z = Ve;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (Ve != null)
                    throw Error(
                      o + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                    );
                  break;
                default:
                  Ve !== ke && dr(
                    n,
                    o,
                    de,
                    Ve,
                    h,
                    ke
                  );
              }
          }
          o = s.type === "checkbox" || s.type === "radio" ? s.checked != null : s.value != null, h = h.type === "checkbox" || h.type === "radio" ? h.checked != null : h.value != null, o || !h || Q8 || (console.error(
            "A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://react.dev/link/controlled-components"
          ), Q8 = !0), !o || h || Y8 || (console.error(
            "A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://react.dev/link/controlled-components"
          ), Y8 = !0), Yt(
            n,
            A,
            z,
            q,
            Z,
            xe,
            C,
            y
          );
          return;
        case "select":
          Ve = A = z = de = null;
          for (C in s)
            if (q = s[C], s.hasOwnProperty(C) && q != null)
              switch (C) {
                case "value":
                  break;
                case "multiple":
                  Ve = q;
                default:
                  h.hasOwnProperty(C) || dr(
                    n,
                    o,
                    C,
                    null,
                    h,
                    q
                  );
              }
          for (y in h)
            if (C = h[y], q = s[y], h.hasOwnProperty(y) && (C != null || q != null))
              switch (y) {
                case "value":
                  de = C;
                  break;
                case "defaultValue":
                  z = C;
                  break;
                case "multiple":
                  A = C;
                default:
                  C !== q && dr(
                    n,
                    o,
                    y,
                    C,
                    h,
                    q
                  );
              }
          h = z, o = A, s = Ve, de != null ? qn(n, !!o, de, !1) : !!s != !!o && (h != null ? qn(n, !!o, h, !0) : qn(n, !!o, o ? [] : "", !1));
          return;
        case "textarea":
          Ve = de = null;
          for (z in s)
            if (y = s[z], s.hasOwnProperty(z) && y != null && !h.hasOwnProperty(z))
              switch (z) {
                case "value":
                  break;
                case "children":
                  break;
                default:
                  dr(n, o, z, null, h, y);
              }
          for (A in h)
            if (y = h[A], C = s[A], h.hasOwnProperty(A) && (y != null || C != null))
              switch (A) {
                case "value":
                  de = y;
                  break;
                case "defaultValue":
                  Ve = y;
                  break;
                case "children":
                  break;
                case "dangerouslySetInnerHTML":
                  if (y != null)
                    throw Error(
                      "`dangerouslySetInnerHTML` does not make sense on <textarea>."
                    );
                  break;
                default:
                  y !== C && dr(n, o, A, y, h, C);
              }
          en(n, de, Ve);
          return;
        case "option":
          for (var yt in s)
            if (de = s[yt], s.hasOwnProperty(yt) && de != null && !h.hasOwnProperty(yt))
              switch (yt) {
                case "selected":
                  n.selected = !1;
                  break;
                default:
                  dr(
                    n,
                    o,
                    yt,
                    null,
                    h,
                    de
                  );
              }
          for (q in h)
            if (de = h[q], Ve = s[q], h.hasOwnProperty(q) && de !== Ve && (de != null || Ve != null))
              switch (q) {
                case "selected":
                  n.selected = de && typeof de != "function" && typeof de != "symbol";
                  break;
                default:
                  dr(
                    n,
                    o,
                    q,
                    de,
                    h,
                    Ve
                  );
              }
          return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
          for (var Mt in s)
            de = s[Mt], s.hasOwnProperty(Mt) && de != null && !h.hasOwnProperty(Mt) && dr(
              n,
              o,
              Mt,
              null,
              h,
              de
            );
          for (Z in h)
            if (de = h[Z], Ve = s[Z], h.hasOwnProperty(Z) && de !== Ve && (de != null || Ve != null))
              switch (Z) {
                case "children":
                case "dangerouslySetInnerHTML":
                  if (de != null)
                    throw Error(
                      o + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                    );
                  break;
                default:
                  dr(
                    n,
                    o,
                    Z,
                    de,
                    h,
                    Ve
                  );
              }
          return;
        default:
          if (ka(o)) {
            for (var Vr in s)
              de = s[Vr], s.hasOwnProperty(Vr) && de !== void 0 && !h.hasOwnProperty(Vr) && Kd(
                n,
                o,
                Vr,
                void 0,
                h,
                de
              );
            for (xe in h)
              de = h[xe], Ve = s[xe], !h.hasOwnProperty(xe) || de === Ve || de === void 0 && Ve === void 0 || Kd(
                n,
                o,
                xe,
                de,
                h,
                Ve
              );
            return;
          }
      }
      for (var Yn in s)
        de = s[Yn], s.hasOwnProperty(Yn) && de != null && !h.hasOwnProperty(Yn) && dr(n, o, Yn, null, h, de);
      for (ke in h)
        de = h[ke], Ve = s[ke], !h.hasOwnProperty(ke) || de === Ve || de == null && Ve == null || dr(n, o, ke, de, h, Ve);
    }
    function Us(n) {
      switch (n) {
        case "class":
          return "className";
        case "for":
          return "htmlFor";
        default:
          return n;
      }
    }
    function zu(n) {
      var o = {};
      n = n.style;
      for (var s = 0; s < n.length; s++) {
        var h = n[s];
        o[h] = n.getPropertyValue(h);
      }
      return o;
    }
    function ss(n, o, s) {
      if (o != null && typeof o != "object")
        console.error(
          "The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX."
        );
      else {
        var h, y = h = "", C;
        for (C in o)
          if (o.hasOwnProperty(C)) {
            var A = o[C];
            A != null && typeof A != "boolean" && A !== "" && (C.indexOf("--") === 0 ? (Qe(A, C), h += y + C + ":" + ("" + A).trim()) : typeof A != "number" || A === 0 || jt.has(C) ? (Qe(A, C), h += y + C.replace(Ge, "-$1").toLowerCase().replace(At, "-ms-") + ":" + ("" + A).trim()) : h += y + C.replace(Ge, "-$1").toLowerCase().replace(At, "-ms-") + ":" + A + "px", y = ";");
          }
        h = h || null, o = n.getAttribute("style"), o !== h && (h = Rl(h), Rl(o) !== h && (s.style = zu(n)));
      }
    }
    function ni(n, o, s, h, y, C) {
      if (y.delete(s), n = n.getAttribute(s), n === null)
        switch (typeof h) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            return;
        }
      else if (h != null)
        switch (typeof h) {
          case "function":
          case "symbol":
          case "boolean":
            break;
          default:
            if (pe(h, o), n === "" + h)
              return;
        }
      ea(o, n, h, C);
    }
    function bg(n, o, s, h, y, C) {
      if (y.delete(s), n = n.getAttribute(s), n === null) {
        switch (typeof h) {
          case "function":
          case "symbol":
            return;
        }
        if (!h) return;
      } else
        switch (typeof h) {
          case "function":
          case "symbol":
            break;
          default:
            if (h) return;
        }
      ea(o, n, h, C);
    }
    function yg(n, o, s, h, y, C) {
      if (y.delete(s), n = n.getAttribute(s), n === null)
        switch (typeof h) {
          case "undefined":
          case "function":
          case "symbol":
            return;
        }
      else if (h != null)
        switch (typeof h) {
          case "function":
          case "symbol":
            break;
          default:
            if (pe(h, s), n === "" + h)
              return;
        }
      ea(o, n, h, C);
    }
    function Yd(n, o, s, h, y, C) {
      if (y.delete(s), n = n.getAttribute(s), n === null)
        switch (typeof h) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            return;
          default:
            if (isNaN(h)) return;
        }
      else if (h != null)
        switch (typeof h) {
          case "function":
          case "symbol":
          case "boolean":
            break;
          default:
            if (!isNaN(h) && (pe(h, o), n === "" + h))
              return;
        }
      ea(o, n, h, C);
    }
    function Jm(n, o, s, h, y, C) {
      if (y.delete(s), n = n.getAttribute(s), n === null)
        switch (typeof h) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            return;
        }
      else if (h != null)
        switch (typeof h) {
          case "function":
          case "symbol":
          case "boolean":
            break;
          default:
            if (pe(h, o), s = pr("" + h), n === s)
              return;
        }
      ea(o, n, h, C);
    }
    function ri(n, o, s, h) {
      for (var y = {}, C = /* @__PURE__ */ new Set(), A = n.attributes, z = 0; z < A.length; z++)
        switch (A[z].name.toLowerCase()) {
          case "value":
            break;
          case "checked":
            break;
          case "selected":
            break;
          default:
            C.add(A[z].name);
        }
      if (ka(o)) {
        for (var q in s)
          if (s.hasOwnProperty(q)) {
            var Z = s[q];
            if (Z != null) {
              if (hs.hasOwnProperty(q))
                typeof Z != "function" && ta(q, Z);
              else if (s.suppressHydrationWarning !== !0)
                switch (q) {
                  case "children":
                    typeof Z != "string" && typeof Z != "number" || ea(
                      "children",
                      n.textContent,
                      Z,
                      y
                    );
                    continue;
                  case "suppressContentEditableWarning":
                  case "suppressHydrationWarning":
                  case "defaultValue":
                  case "defaultChecked":
                  case "innerHTML":
                  case "ref":
                    continue;
                  case "dangerouslySetInnerHTML":
                    A = n.innerHTML, Z = Z ? Z.__html : void 0, Z != null && (Z = vg(n, Z), ea(
                      q,
                      A,
                      Z,
                      y
                    ));
                    continue;
                  case "style":
                    C.delete(q), ss(n, Z, y);
                    continue;
                  case "offsetParent":
                  case "offsetTop":
                  case "offsetLeft":
                  case "offsetWidth":
                  case "offsetHeight":
                  case "isContentEditable":
                  case "outerText":
                  case "outerHTML":
                    C.delete(q.toLowerCase()), console.error(
                      "Assignment to read-only property will result in a no-op: `%s`",
                      q
                    );
                    continue;
                  case "className":
                    C.delete("class"), A = Ut(
                      n,
                      "class",
                      Z
                    ), ea(
                      "className",
                      A,
                      Z,
                      y
                    );
                    continue;
                  default:
                    h.context === dd && o !== "svg" && o !== "math" ? C.delete(q.toLowerCase()) : C.delete(q), A = Ut(
                      n,
                      q,
                      Z
                    ), ea(
                      q,
                      A,
                      Z,
                      y
                    );
                }
            }
          }
      } else
        for (Z in s)
          if (s.hasOwnProperty(Z) && (q = s[Z], q != null)) {
            if (hs.hasOwnProperty(Z))
              typeof q != "function" && ta(Z, q);
            else if (s.suppressHydrationWarning !== !0)
              switch (Z) {
                case "children":
                  typeof q != "string" && typeof q != "number" || ea(
                    "children",
                    n.textContent,
                    q,
                    y
                  );
                  continue;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                case "value":
                case "checked":
                case "selected":
                case "defaultValue":
                case "defaultChecked":
                case "innerHTML":
                case "ref":
                  continue;
                case "dangerouslySetInnerHTML":
                  A = n.innerHTML, q = q ? q.__html : void 0, q != null && (q = vg(n, q), A !== q && (y[Z] = { __html: A }));
                  continue;
                case "className":
                  ni(
                    n,
                    Z,
                    "class",
                    q,
                    C,
                    y
                  );
                  continue;
                case "tabIndex":
                  ni(
                    n,
                    Z,
                    "tabindex",
                    q,
                    C,
                    y
                  );
                  continue;
                case "style":
                  C.delete(Z), ss(n, q, y);
                  continue;
                case "multiple":
                  C.delete(Z), ea(
                    Z,
                    n.multiple,
                    q,
                    y
                  );
                  continue;
                case "muted":
                  C.delete(Z), ea(
                    Z,
                    n.muted,
                    q,
                    y
                  );
                  continue;
                case "autoFocus":
                  C.delete("autofocus"), ea(
                    Z,
                    n.autofocus,
                    q,
                    y
                  );
                  continue;
                case "data":
                  if (o !== "object") {
                    C.delete(Z), A = n.getAttribute("data"), ea(
                      Z,
                      A,
                      q,
                      y
                    );
                    continue;
                  }
                case "src":
                case "href":
                  if (!(q !== "" || o === "a" && Z === "href" || o === "object" && Z === "data")) {
                    console.error(
                      Z === "src" ? 'An empty string ("") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string.' : 'An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.',
                      Z,
                      Z
                    );
                    continue;
                  }
                  Jm(
                    n,
                    Z,
                    Z,
                    q,
                    C,
                    y
                  );
                  continue;
                case "action":
                case "formAction":
                  if (A = n.getAttribute(Z), typeof q == "function") {
                    C.delete(Z.toLowerCase()), Z === "formAction" ? (C.delete("name"), C.delete("formenctype"), C.delete("formmethod"), C.delete("formtarget")) : (C.delete("enctype"), C.delete("method"), C.delete("target"));
                    continue;
                  } else if (A === yT) {
                    C.delete(Z.toLowerCase()), ea(
                      Z,
                      "function",
                      q,
                      y
                    );
                    continue;
                  }
                  Jm(
                    n,
                    Z,
                    Z.toLowerCase(),
                    q,
                    C,
                    y
                  );
                  continue;
                case "xlinkHref":
                  Jm(
                    n,
                    Z,
                    "xlink:href",
                    q,
                    C,
                    y
                  );
                  continue;
                case "contentEditable":
                  yg(
                    n,
                    Z,
                    "contenteditable",
                    q,
                    C,
                    y
                  );
                  continue;
                case "spellCheck":
                  yg(
                    n,
                    Z,
                    "spellcheck",
                    q,
                    C,
                    y
                  );
                  continue;
                case "draggable":
                case "autoReverse":
                case "externalResourcesRequired":
                case "focusable":
                case "preserveAlpha":
                  yg(
                    n,
                    Z,
                    Z,
                    q,
                    C,
                    y
                  );
                  continue;
                case "allowFullScreen":
                case "async":
                case "autoPlay":
                case "controls":
                case "default":
                case "defer":
                case "disabled":
                case "disablePictureInPicture":
                case "disableRemotePlayback":
                case "formNoValidate":
                case "hidden":
                case "loop":
                case "noModule":
                case "noValidate":
                case "open":
                case "playsInline":
                case "readOnly":
                case "required":
                case "reversed":
                case "scoped":
                case "seamless":
                case "itemScope":
                  bg(
                    n,
                    Z,
                    Z.toLowerCase(),
                    q,
                    C,
                    y
                  );
                  continue;
                case "capture":
                case "download":
                  e: {
                    z = n;
                    var xe = A = Z, ke = y;
                    if (C.delete(xe), z = z.getAttribute(xe), z === null)
                      switch (typeof q) {
                        case "undefined":
                        case "function":
                        case "symbol":
                          break e;
                        default:
                          if (q === !1) break e;
                      }
                    else if (q != null)
                      switch (typeof q) {
                        case "function":
                        case "symbol":
                          break;
                        case "boolean":
                          if (q === !0 && z === "") break e;
                          break;
                        default:
                          if (pe(q, A), z === "" + q)
                            break e;
                      }
                    ea(
                      A,
                      z,
                      q,
                      ke
                    );
                  }
                  continue;
                case "cols":
                case "rows":
                case "size":
                case "span":
                  e: {
                    if (z = n, xe = A = Z, ke = y, C.delete(xe), z = z.getAttribute(xe), z === null)
                      switch (typeof q) {
                        case "undefined":
                        case "function":
                        case "symbol":
                        case "boolean":
                          break e;
                        default:
                          if (isNaN(q) || 1 > q) break e;
                      }
                    else if (q != null)
                      switch (typeof q) {
                        case "function":
                        case "symbol":
                        case "boolean":
                          break;
                        default:
                          if (!(isNaN(q) || 1 > q) && (pe(q, A), z === "" + q))
                            break e;
                      }
                    ea(
                      A,
                      z,
                      q,
                      ke
                    );
                  }
                  continue;
                case "rowSpan":
                  Yd(
                    n,
                    Z,
                    "rowspan",
                    q,
                    C,
                    y
                  );
                  continue;
                case "start":
                  Yd(
                    n,
                    Z,
                    Z,
                    q,
                    C,
                    y
                  );
                  continue;
                case "xHeight":
                  ni(
                    n,
                    Z,
                    "x-height",
                    q,
                    C,
                    y
                  );
                  continue;
                case "xlinkActuate":
                  ni(
                    n,
                    Z,
                    "xlink:actuate",
                    q,
                    C,
                    y
                  );
                  continue;
                case "xlinkArcrole":
                  ni(
                    n,
                    Z,
                    "xlink:arcrole",
                    q,
                    C,
                    y
                  );
                  continue;
                case "xlinkRole":
                  ni(
                    n,
                    Z,
                    "xlink:role",
                    q,
                    C,
                    y
                  );
                  continue;
                case "xlinkShow":
                  ni(
                    n,
                    Z,
                    "xlink:show",
                    q,
                    C,
                    y
                  );
                  continue;
                case "xlinkTitle":
                  ni(
                    n,
                    Z,
                    "xlink:title",
                    q,
                    C,
                    y
                  );
                  continue;
                case "xlinkType":
                  ni(
                    n,
                    Z,
                    "xlink:type",
                    q,
                    C,
                    y
                  );
                  continue;
                case "xmlBase":
                  ni(
                    n,
                    Z,
                    "xml:base",
                    q,
                    C,
                    y
                  );
                  continue;
                case "xmlLang":
                  ni(
                    n,
                    Z,
                    "xml:lang",
                    q,
                    C,
                    y
                  );
                  continue;
                case "xmlSpace":
                  ni(
                    n,
                    Z,
                    "xml:space",
                    q,
                    C,
                    y
                  );
                  continue;
                case "inert":
                  q !== "" || zw[Z] || (zw[Z] = !0, console.error(
                    "Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.",
                    Z
                  )), bg(
                    n,
                    Z,
                    Z,
                    q,
                    C,
                    y
                  );
                  continue;
                default:
                  if (!(2 < Z.length) || Z[0] !== "o" && Z[0] !== "O" || Z[1] !== "n" && Z[1] !== "N") {
                    z = Ui(Z), A = !1, h.context === dd && o !== "svg" && o !== "math" ? C.delete(z.toLowerCase()) : (xe = Z.toLowerCase(), xe = $l.hasOwnProperty(
                      xe
                    ) && $l[xe] || null, xe !== null && xe !== Z && (A = !0, C.delete(xe)), C.delete(z));
                    e: if (xe = n, ke = z, z = q, xn(ke))
                      if (xe.hasAttribute(ke))
                        xe = xe.getAttribute(
                          ke
                        ), pe(
                          z,
                          ke
                        ), z = xe === "" + z ? z : xe;
                      else {
                        switch (typeof z) {
                          case "function":
                          case "symbol":
                            break e;
                          case "boolean":
                            if (xe = ke.toLowerCase().slice(0, 5), xe !== "data-" && xe !== "aria-")
                              break e;
                        }
                        z = z === void 0 ? void 0 : null;
                      }
                    else z = void 0;
                    A || ea(
                      Z,
                      z,
                      q,
                      y
                    );
                  }
              }
          }
      return 0 < C.size && s.suppressHydrationWarning !== !0 && Qm(n, C, y), Object.keys(y).length === 0 ? null : y;
    }
    function cy(n, o) {
      switch (n.length) {
        case 0:
          return "";
        case 1:
          return n[0];
        case 2:
          return n[0] + " " + o + " " + n[1];
        default:
          return n.slice(0, -1).join(", ") + ", " + o + " " + n[n.length - 1];
      }
    }
    function Xo(n) {
      switch (n) {
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
          return !0;
        default:
          return !1;
      }
    }
    function dy() {
      if (typeof performance.getEntriesByType == "function") {
        for (var n = 0, o = 0, s = performance.getEntriesByType("resource"), h = 0; h < s.length; h++) {
          var y = s[h], C = y.transferSize, A = y.initiatorType, z = y.duration;
          if (C && z && Xo(A)) {
            for (A = 0, z = y.responseEnd, h += 1; h < s.length; h++) {
              var q = s[h], Z = q.startTime;
              if (Z > z) break;
              var xe = q.transferSize, ke = q.initiatorType;
              xe && Xo(ke) && (q = q.responseEnd, A += xe * (q < z ? 1 : (z - Z) / (q - Z)));
            }
            if (--h, o += 8 * (C + A) / (y.duration / 1e3), n++, 10 < n) break;
          }
        }
        if (0 < n) return o / n / 1e6;
      }
      return navigator.connection && (n = navigator.connection.downlink, typeof n == "number") ? n : 5;
    }
    function Zm(n) {
      return n.nodeType === 9 ? n : n.ownerDocument;
    }
    function fy(n) {
      switch (n) {
        case Pn:
          return y0;
        case vn:
          return Iw;
        default:
          return dd;
      }
    }
    function Xs(n, o) {
      if (n === dd)
        switch (o) {
          case "svg":
            return y0;
          case "math":
            return Iw;
          default:
            return dd;
        }
      return n === y0 && o === "foreignObject" ? dd : n;
    }
    function Qd(n, o) {
      return n === "textarea" || n === "noscript" || typeof o.children == "string" || typeof o.children == "number" || typeof o.children == "bigint" || typeof o.dangerouslySetInnerHTML == "object" && o.dangerouslySetInnerHTML !== null && o.dangerouslySetInnerHTML.__html != null;
    }
    function d2() {
      var n = window.event;
      return n && n.type === "popstate" ? n === T4 ? !1 : (T4 = n, !0) : (T4 = null, !1);
    }
    function us() {
      var n = window.event;
      return n && n !== M1 ? n.type : null;
    }
    function Jd() {
      var n = window.event;
      return n && n !== M1 ? n.timeStamp : -1.1;
    }
    function my(n) {
      setTimeout(function() {
        throw n;
      });
    }
    function hy(n, o, s) {
      switch (o) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          s.autoFocus && n.focus();
          break;
        case "img":
          s.src ? n.src = s.src : s.srcSet && (n.srcset = s.srcSet);
      }
    }
    function py() {
    }
    function wg(n, o, s, h) {
      ja(n, o, s, h), n[qo] = h;
    }
    function Sg(n) {
      er(n, "");
    }
    function bC(n, o, s) {
      n.nodeValue = s;
    }
    function gy(n) {
      if (!n.__reactWarnedAboutChildrenConflict) {
        var o = n[qo] || null;
        if (o !== null) {
          var s = bt(n);
          s !== null && (typeof o.children == "string" || typeof o.children == "number" ? (n.__reactWarnedAboutChildrenConflict = !0, le(s, function() {
            console.error(
              'Cannot use a ref on a React element as a container to `createRoot` or `createPortal` if that element also sets "children" text content using React. It should be a leaf with no children. Otherwise it\'s ambiguous which children should be used.'
            );
          })) : o.dangerouslySetInnerHTML != null && (n.__reactWarnedAboutChildrenConflict = !0, le(s, function() {
            console.error(
              'Cannot use a ref on a React element as a container to `createRoot` or `createPortal` if that element also sets "dangerouslySetInnerHTML" using React. It should be a leaf with no children. Otherwise it\'s ambiguous which children should be used.'
            );
          })));
        }
      }
    }
    function ju(n) {
      return n === "head";
    }
    function vy(n, o) {
      n.removeChild(o);
    }
    function by(n, o) {
      (n.nodeType === 9 ? n.body : n.nodeName === "HTML" ? n.ownerDocument.body : n).removeChild(o);
    }
    function $c(n, o) {
      var s = o, h = 0;
      do {
        var y = s.nextSibling;
        if (n.removeChild(s), y && y.nodeType === 8)
          if (s = y.data, s === k1 || s === jw) {
            if (h === 0) {
              n.removeChild(y), Lc(o);
              return;
            }
            h--;
          } else if (s === P1 || s === jf || s === jh || s === b0 || s === zh)
            h++;
          else if (s === ST)
            qs(
              n.ownerDocument.documentElement
            );
          else if (s === xT) {
            s = n.ownerDocument.head, qs(s);
            for (var C = s.firstChild; C; ) {
              var A = C.nextSibling, z = C.nodeName;
              C[pf] || z === "SCRIPT" || z === "STYLE" || z === "LINK" && C.rel.toLowerCase() === "stylesheet" || s.removeChild(C), C = A;
            }
          } else
            s === CT && qs(n.ownerDocument.body);
        s = y;
      } while (s);
      Lc(o);
    }
    function eh(n, o) {
      var s = n;
      n = 0;
      do {
        var h = s.nextSibling;
        if (s.nodeType === 1 ? o ? (s._stashedDisplay = s.style.display, s.style.display = "none") : (s.style.display = s._stashedDisplay || "", s.getAttribute("style") === "" && s.removeAttribute("style")) : s.nodeType === 3 && (o ? (s._stashedText = s.nodeValue, s.nodeValue = "") : s.nodeValue = s._stashedText || ""), h && h.nodeType === 8)
          if (s = h.data, s === k1) {
            if (n === 0) break;
            n--;
          } else
            s !== P1 && s !== jf && s !== jh && s !== b0 || n++;
        s = h;
      } while (s);
    }
    function yy(n) {
      eh(n, !0);
    }
    function wy(n) {
      n = n.style, typeof n.setProperty == "function" ? n.setProperty("display", "none", "important") : n.display = "none";
    }
    function Sy(n) {
      n.nodeValue = "";
    }
    function Cy(n) {
      eh(n, !1);
    }
    function xy(n, o) {
      o = o[ET], o = o != null && o.hasOwnProperty("display") ? o.display : null, n.style.display = o == null || typeof o == "boolean" ? "" : ("" + o).trim();
    }
    function Ey(n, o) {
      n.nodeValue = o;
    }
    function Zd(n) {
      var o = n.firstChild;
      for (o && o.nodeType === 10 && (o = o.nextSibling); o; ) {
        var s = o;
        switch (o = o.nextSibling, s.nodeName) {
          case "HTML":
          case "HEAD":
          case "BODY":
            Zd(s), st(s);
            continue;
          case "SCRIPT":
          case "STYLE":
            continue;
          case "LINK":
            if (s.rel.toLowerCase() === "stylesheet") continue;
        }
        n.removeChild(s);
      }
    }
    function Py(n, o, s, h) {
      for (; n.nodeType === 1; ) {
        var y = s;
        if (n.nodeName.toLowerCase() !== o.toLowerCase()) {
          if (!h && (n.nodeName !== "INPUT" || n.type !== "hidden"))
            break;
        } else if (h) {
          if (!n[pf])
            switch (o) {
              case "meta":
                if (!n.hasAttribute("itemprop")) break;
                return n;
              case "link":
                if (C = n.getAttribute("rel"), C === "stylesheet" && n.hasAttribute("data-precedence"))
                  break;
                if (C !== y.rel || n.getAttribute("href") !== (y.href == null || y.href === "" ? null : y.href) || n.getAttribute("crossorigin") !== (y.crossOrigin == null ? null : y.crossOrigin) || n.getAttribute("title") !== (y.title == null ? null : y.title))
                  break;
                return n;
              case "style":
                if (n.hasAttribute("data-precedence")) break;
                return n;
              case "script":
                if (C = n.getAttribute("src"), (C !== (y.src == null ? null : y.src) || n.getAttribute("type") !== (y.type == null ? null : y.type) || n.getAttribute("crossorigin") !== (y.crossOrigin == null ? null : y.crossOrigin)) && C && n.hasAttribute("async") && !n.hasAttribute("itemprop"))
                  break;
                return n;
              default:
                return n;
            }
        } else if (o === "input" && n.type === "hidden") {
          pe(y.name, "name");
          var C = y.name == null ? null : "" + y.name;
          if (y.type === "hidden" && n.getAttribute("name") === C)
            return n;
        } else return n;
        if (n = Mi(n.nextSibling), n === null) break;
      }
      return null;
    }
    function ky(n, o, s) {
      if (o === "") return null;
      for (; n.nodeType !== 3; )
        if ((n.nodeType !== 1 || n.nodeName !== "INPUT" || n.type !== "hidden") && !s || (n = Mi(n.nextSibling), n === null)) return null;
      return n;
    }
    function yr(n, o) {
      for (; n.nodeType !== 8; )
        if ((n.nodeType !== 1 || n.nodeName !== "INPUT" || n.type !== "hidden") && !o || (n = Mi(n.nextSibling), n === null)) return null;
      return n;
    }
    function th(n) {
      return n.data === jf || n.data === jh;
    }
    function f2(n) {
      return n.data === b0 || n.data === jf && n.ownerDocument.readyState !== t5;
    }
    function My(n, o) {
      var s = n.ownerDocument;
      if (n.data === jh)
        n._reactRetry = o;
      else if (n.data !== jf || s.readyState !== t5)
        o();
      else {
        var h = function() {
          o(), s.removeEventListener("DOMContentLoaded", h);
        };
        s.addEventListener("DOMContentLoaded", h), n._reactRetry = h;
      }
    }
    function Mi(n) {
      for (; n != null; n = n.nextSibling) {
        var o = n.nodeType;
        if (o === 1 || o === 3) break;
        if (o === 8) {
          if (o = n.data, o === P1 || o === b0 || o === jf || o === jh || o === zh || o === k4 || o === e5)
            break;
          if (o === k1 || o === jw)
            return null;
        }
      }
      return n;
    }
    function Oy(n) {
      if (n.nodeType === 1) {
        for (var o = n.nodeName.toLowerCase(), s = {}, h = n.attributes, y = 0; y < h.length; y++) {
          var C = h[y];
          s[Us(C.name)] = C.name.toLowerCase() === "style" ? zu(n) : C.value;
        }
        return { type: o, props: s };
      }
      return n.nodeType === 8 ? n.data === zh ? { type: "Activity", props: {} } : { type: "Suspense", props: {} } : n.nodeValue;
    }
    function Ty(n, o, s) {
      return s === null || s[wT] !== !0 ? (n.nodeValue === o ? n = null : (o = Rl(o), n = Rl(n.nodeValue) === o ? null : n.nodeValue), n) : null;
    }
    function ef(n) {
      n = n.nextSibling;
      for (var o = 0; n; ) {
        if (n.nodeType === 8) {
          var s = n.data;
          if (s === k1 || s === jw) {
            if (o === 0)
              return Mi(n.nextSibling);
            o--;
          } else
            s !== P1 && s !== b0 && s !== jf && s !== jh && s !== zh || o++;
        }
        n = n.nextSibling;
      }
      return null;
    }
    function zc(n) {
      n = n.previousSibling;
      for (var o = 0; n; ) {
        if (n.nodeType === 8) {
          var s = n.data;
          if (s === P1 || s === b0 || s === jf || s === jh || s === zh) {
            if (o === 0) return n;
            o--;
          } else
            s !== k1 && s !== jw || o++;
        }
        n = n.previousSibling;
      }
      return null;
    }
    function m2(n) {
      Lc(n);
    }
    function Cg(n) {
      Lc(n);
    }
    function h2(n) {
      Lc(n);
    }
    function Gs(n, o, s, h, y) {
      switch (y && Qt(n, h.ancestorInfo), o = Zm(s), n) {
        case "html":
          if (n = o.documentElement, !n)
            throw Error(
              "React expected an <html> element (document.documentElement) to exist in the Document but one was not found. React never removes the documentElement for any Document it renders into so the cause is likely in some other script running on this page."
            );
          return n;
        case "head":
          if (n = o.head, !n)
            throw Error(
              "React expected a <head> element (document.head) to exist in the Document but one was not found. React never removes the head for any Document it renders into so the cause is likely in some other script running on this page."
            );
          return n;
        case "body":
          if (n = o.body, !n)
            throw Error(
              "React expected a <body> element (document.body) to exist in the Document but one was not found. React never removes the body for any Document it renders into so the cause is likely in some other script running on this page."
            );
          return n;
        default:
          throw Error(
            "resolveSingletonInstance was called with an element type that is not supported. This is a bug in React."
          );
      }
    }
    function cs(n, o, s, h) {
      if (!s[Ys] && bt(s)) {
        var y = s.tagName.toLowerCase();
        console.error(
          "You are mounting a new %s component when a previous one has not first unmounted. It is an error to render more than one %s component at a time and attributes and children of these components will likely fail in unpredictable ways. Please only render a single instance of <%s> and if you need to mount a new one, ensure any previous ones have unmounted first.",
          y,
          y,
          y
        );
      }
      switch (n) {
        case "html":
        case "head":
        case "body":
          break;
        default:
          console.error(
            "acquireSingletonInstance was called with an element type that is not supported. This is a bug in React."
          );
      }
      for (y = s.attributes; y.length; )
        s.removeAttributeNode(y[0]);
      Ur(s, n, o), s[Xr] = h, s[qo] = o;
    }
    function qs(n) {
      for (var o = n.attributes; o.length; )
        n.removeAttributeNode(o[0]);
      st(n);
    }
    function xg(n) {
      return typeof n.getRootNode == "function" ? n.getRootNode() : n.nodeType === 9 ? n : n.ownerDocument;
    }
    function p2(n, o, s) {
      var h = w0;
      if (h && typeof o == "string" && o) {
        var y = Gt(o);
        y = 'link[rel="' + n + '"][href="' + y + '"]', typeof s == "string" && (y += '[crossorigin="' + s + '"]'), l5.has(y) || (l5.add(y), n = { rel: n, crossOrigin: s, href: o }, h.querySelector(y) === null && (o = h.createElement("link"), Ur(o, "link", n), Pt(o), h.head.appendChild(o)));
      }
    }
    function g2(n, o, s, h) {
      var y = (y = Oi.current) ? xg(y) : null;
      if (!y)
        throw Error(
          '"resourceRoot" was expected to exist. This is a bug in React.'
        );
      switch (n) {
        case "meta":
        case "title":
          return null;
        case "style":
          return typeof s.precedence == "string" && typeof s.href == "string" ? (s = jc(s.href), o = $t(y).hoistableStyles, h = o.get(s), h || (h = {
            type: "style",
            instance: null,
            count: 0,
            state: null
          }, o.set(s, h)), h) : { type: "void", instance: null, count: 0, state: null };
        case "link":
          if (s.rel === "stylesheet" && typeof s.href == "string" && typeof s.precedence == "string") {
            n = jc(s.href);
            var C = $t(y).hoistableStyles, A = C.get(n);
            if (!A && (y = y.ownerDocument || y, A = {
              type: "stylesheet",
              instance: null,
              count: 0,
              state: { loading: Lh, preload: null }
            }, C.set(n, A), (C = y.querySelector(
              rh(n)
            )) && !C._p && (A.instance = C, A.state.loading = O1 | Es), !Ps.has(n))) {
              var z = {
                rel: "preload",
                as: "style",
                href: s.href,
                crossOrigin: s.crossOrigin,
                integrity: s.integrity,
                media: s.media,
                hrefLang: s.hrefLang,
                referrerPolicy: s.referrerPolicy
              };
              Ps.set(n, z), C || Ry(
                y,
                n,
                z,
                A.state
              );
            }
            if (o && h === null)
              throw s = `

  - ` + nh(o) + `
  + ` + nh(s), Error(
                "Expected <link> not to update to be updated to a stylesheet with precedence. Check the `rel`, `href`, and `precedence` props of this component. Alternatively, check whether two different <link> components render in the same slot or share the same key." + s
              );
            return A;
          }
          if (o && h !== null)
            throw s = `

  - ` + nh(o) + `
  + ` + nh(s), Error(
              "Expected stylesheet with precedence to not be updated to a different kind of <link>. Check the `rel`, `href`, and `precedence` props of this component. Alternatively, check whether two different <link> components render in the same slot or share the same key." + s
            );
          return null;
        case "script":
          return o = s.async, s = s.src, typeof s == "string" && o && typeof o != "function" && typeof o != "symbol" ? (s = Ic(s), o = $t(y).hoistableScripts, h = o.get(s), h || (h = {
            type: "script",
            instance: null,
            count: 0,
            state: null
          }, o.set(s, h)), h) : { type: "void", instance: null, count: 0, state: null };
        default:
          throw Error(
            'getResource encountered a type it did not expect: "' + n + '". this is a bug in React.'
          );
      }
    }
    function nh(n) {
      var o = 0, s = "<link";
      return typeof n.rel == "string" ? (o++, s += ' rel="' + n.rel + '"') : Ti.call(n, "rel") && (o++, s += ' rel="' + (n.rel === null ? "null" : "invalid type " + typeof n.rel) + '"'), typeof n.href == "string" ? (o++, s += ' href="' + n.href + '"') : Ti.call(n, "href") && (o++, s += ' href="' + (n.href === null ? "null" : "invalid type " + typeof n.href) + '"'), typeof n.precedence == "string" ? (o++, s += ' precedence="' + n.precedence + '"') : Ti.call(n, "precedence") && (o++, s += " precedence={" + (n.precedence === null ? "null" : "invalid type " + typeof n.precedence) + "}"), Object.getOwnPropertyNames(n).length > o && (s += " ..."), s + " />";
    }
    function jc(n) {
      return 'href="' + Gt(n) + '"';
    }
    function rh(n) {
      return 'link[rel="stylesheet"][' + n + "]";
    }
    function Eg(n) {
      return Rn({}, n, {
        "data-precedence": n.precedence,
        precedence: null
      });
    }
    function Ry(n, o, s, h) {
      n.querySelector(
        'link[rel="preload"][as="style"][' + o + "]"
      ) ? h.loading = O1 : (o = n.createElement("link"), h.preload = o, o.addEventListener("load", function() {
        return h.loading |= O1;
      }), o.addEventListener("error", function() {
        return h.loading |= o5;
      }), Ur(o, "link", s), Pt(o), n.head.appendChild(o));
    }
    function Ic(n) {
      return '[src="' + Gt(n) + '"]';
    }
    function ah(n) {
      return "script[async]" + n;
    }
    function Pg(n, o, s) {
      if (o.count++, o.instance === null)
        switch (o.type) {
          case "style":
            var h = n.querySelector(
              'style[data-href~="' + Gt(s.href) + '"]'
            );
            if (h)
              return o.instance = h, Pt(h), h;
            var y = Rn({}, s, {
              "data-href": s.href,
              "data-precedence": s.precedence,
              href: null,
              precedence: null
            });
            return h = (n.ownerDocument || n).createElement("style"), Pt(h), Ur(h, "style", y), tf(h, s.precedence, n), o.instance = h;
          case "stylesheet":
            y = jc(s.href);
            var C = n.querySelector(
              rh(y)
            );
            if (C)
              return o.state.loading |= Es, o.instance = C, Pt(C), C;
            h = Eg(s), (y = Ps.get(y)) && v2(h, y), C = (n.ownerDocument || n).createElement("link"), Pt(C);
            var A = C;
            return A._p = new Promise(function(z, q) {
              A.onload = z, A.onerror = q;
            }), Ur(C, "link", h), o.state.loading |= Es, tf(C, s.precedence, n), o.instance = C;
          case "script":
            return C = Ic(s.src), (y = n.querySelector(
              ah(C)
            )) ? (o.instance = y, Pt(y), y) : (h = s, (y = Ps.get(C)) && (h = Rn({}, s), b2(h, y)), n = n.ownerDocument || n, y = n.createElement("script"), Pt(y), Ur(y, "link", h), n.head.appendChild(y), o.instance = y);
          case "void":
            return null;
          default:
            throw Error(
              'acquireResource encountered a resource type it did not expect: "' + o.type + '". this is a bug in React.'
            );
        }
      else
        o.type === "stylesheet" && (o.state.loading & Es) === Lh && (h = o.instance, o.state.loading |= Es, tf(h, s.precedence, n));
      return o.instance;
    }
    function tf(n, o, s) {
      for (var h = s.querySelectorAll(
        'link[rel="stylesheet"][data-precedence],style[data-precedence]'
      ), y = h.length ? h[h.length - 1] : null, C = y, A = 0; A < h.length; A++) {
        var z = h[A];
        if (z.dataset.precedence === o) C = z;
        else if (C !== y) break;
      }
      C ? C.parentNode.insertBefore(n, C.nextSibling) : (o = s.nodeType === 9 ? s.head : s, o.insertBefore(n, o.firstChild));
    }
    function v2(n, o) {
      n.crossOrigin == null && (n.crossOrigin = o.crossOrigin), n.referrerPolicy == null && (n.referrerPolicy = o.referrerPolicy), n.title == null && (n.title = o.title);
    }
    function b2(n, o) {
      n.crossOrigin == null && (n.crossOrigin = o.crossOrigin), n.referrerPolicy == null && (n.referrerPolicy = o.referrerPolicy), n.integrity == null && (n.integrity = o.integrity);
    }
    function nf(n, o, s) {
      if (Lw === null) {
        var h = /* @__PURE__ */ new Map(), y = Lw = /* @__PURE__ */ new Map();
        y.set(s, h);
      } else
        y = Lw, h = y.get(s), h || (h = /* @__PURE__ */ new Map(), y.set(s, h));
      if (h.has(n)) return h;
      for (h.set(n, null), s = s.getElementsByTagName(n), y = 0; y < s.length; y++) {
        var C = s[y];
        if (!(C[pf] || C[Xr] || n === "link" && C.getAttribute("rel") === "stylesheet") && C.namespaceURI !== Pn) {
          var A = C.getAttribute(o) || "";
          A = n + A;
          var z = h.get(A);
          z ? z.push(C) : h.set(A, [C]);
        }
      }
      return h;
    }
    function Ay(n, o, s) {
      n = n.ownerDocument || n, n.head.insertBefore(
        s,
        o === "title" ? n.querySelector("head > title") : null
      );
    }
    function Ny(n, o, s) {
      var h = !s.ancestorInfo.containerTagInScope;
      if (s.context === y0 || o.itemProp != null)
        return !h || o.itemProp == null || n !== "meta" && n !== "title" && n !== "style" && n !== "link" && n !== "script" || console.error(
          "Cannot render a <%s> outside the main document if it has an `itemProp` prop. `itemProp` suggests the tag belongs to an `itemScope` which can appear anywhere in the DOM. If you were intending for React to hoist this <%s> remove the `itemProp` prop. Otherwise, try moving this tag into the <head> or <body> of the Document.",
          n,
          n
        ), !1;
      switch (n) {
        case "meta":
        case "title":
          return !0;
        case "style":
          if (typeof o.precedence != "string" || typeof o.href != "string" || o.href === "") {
            h && console.error(
              'Cannot render a <style> outside the main document without knowing its precedence and a unique href key. React can hoist and deduplicate <style> tags if you provide a `precedence` prop along with an `href` prop that does not conflict with the `href` values used in any other hoisted <style> or <link rel="stylesheet" ...> tags.  Note that hoisting <style> tags is considered an advanced feature that most will not use directly. Consider moving the <style> tag to the <head> or consider adding a `precedence="default"` and `href="some unique resource identifier"`.'
            );
            break;
          }
          return !0;
        case "link":
          if (typeof o.rel != "string" || typeof o.href != "string" || o.href === "" || o.onLoad || o.onError) {
            if (o.rel === "stylesheet" && typeof o.precedence == "string") {
              n = o.href;
              var y = o.onError, C = o.disabled;
              s = [], o.onLoad && s.push("`onLoad`"), y && s.push("`onError`"), C != null && s.push("`disabled`"), y = cy(s, "and"), y += s.length === 1 ? " prop" : " props", C = s.length === 1 ? "an " + y : "the " + y, s.length && console.error(
                'React encountered a <link rel="stylesheet" href="%s" ... /> with a `precedence` prop that also included %s. The presence of loading and error handlers indicates an intent to manage the stylesheet loading state from your from your Component code and React will not hoist or deduplicate this stylesheet. If your intent was to have React hoist and deduplciate this stylesheet using the `precedence` prop remove the %s, otherwise remove the `precedence` prop.',
                n,
                C,
                y
              );
            }
            h && (typeof o.rel != "string" || typeof o.href != "string" || o.href === "" ? console.error(
              "Cannot render a <link> outside the main document without a `rel` and `href` prop. Try adding a `rel` and/or `href` prop to this <link> or moving the link into the <head> tag"
            ) : (o.onError || o.onLoad) && console.error(
              "Cannot render a <link> with onLoad or onError listeners outside the main document. Try removing onLoad={...} and onError={...} or moving it into the root <head> tag or somewhere in the <body>."
            ));
            break;
          }
          switch (o.rel) {
            case "stylesheet":
              return n = o.precedence, o = o.disabled, typeof n != "string" && h && console.error(
                'Cannot render a <link rel="stylesheet" /> outside the main document without knowing its precedence. Consider adding precedence="default" or moving it into the root <head> tag.'
              ), typeof n == "string" && o == null;
            default:
              return !0;
          }
        case "script":
          if (n = o.async && typeof o.async != "function" && typeof o.async != "symbol", !n || o.onLoad || o.onError || !o.src || typeof o.src != "string") {
            h && (n ? o.onLoad || o.onError ? console.error(
              "Cannot render a <script> with onLoad or onError listeners outside the main document. Try removing onLoad={...} and onError={...} or moving it into the root <head> tag or somewhere in the <body>."
            ) : console.error(
              "Cannot render a <script> outside the main document without `async={true}` and a non-empty `src` prop. Ensure there is a valid `src` and either make the script async or move it into the root <head> tag or somewhere in the <body>."
            ) : console.error(
              'Cannot render a sync or defer <script> outside the main document without knowing its order. Try adding async="" or moving it into the root <head> tag.'
            ));
            break;
          }
          return !0;
        case "noscript":
        case "template":
          h && console.error(
            "Cannot render <%s> outside the main document. Try moving it into the root <head> tag.",
            n
          );
      }
      return !1;
    }
    function Vn(n) {
      return !(n.type === "stylesheet" && (n.state.loading & i5) === Lh);
    }
    function y2(n, o, s, h) {
      if (s.type === "stylesheet" && (typeof h.media != "string" || matchMedia(h.media).matches !== !1) && (s.state.loading & Es) === Lh) {
        if (s.instance === null) {
          var y = jc(h.href), C = o.querySelector(
            rh(y)
          );
          if (C) {
            o = C._p, o !== null && typeof o == "object" && typeof o.then == "function" && (n.count++, n = rf.bind(n), o.then(n, n)), s.state.loading |= Es, s.instance = C, Pt(C);
            return;
          }
          C = o.ownerDocument || o, h = Eg(h), (y = Ps.get(y)) && v2(h, y), C = C.createElement("link"), Pt(C);
          var A = C;
          A._p = new Promise(function(z, q) {
            A.onload = z, A.onerror = q;
          }), Ur(C, "link", h), s.instance = C;
        }
        n.stylesheets === null && (n.stylesheets = /* @__PURE__ */ new Map()), n.stylesheets.set(s, o), (o = s.state.preload) && (s.state.loading & i5) === Lh && (n.count++, s = rf.bind(n), o.addEventListener("load", s), o.addEventListener("error", s));
      }
    }
    function kg(n, o) {
      return n.stylesheets && n.count === 0 && oh(n, n.stylesheets), 0 < n.count || 0 < n.imgCount ? function(s) {
        var h = setTimeout(function() {
          if (n.stylesheets && oh(n, n.stylesheets), n.unsuspend) {
            var C = n.unsuspend;
            n.unsuspend = null, C();
          }
        }, MT + o);
        0 < n.imgBytes && A4 === 0 && (A4 = 125 * dy() * TT);
        var y = setTimeout(
          function() {
            if (n.waitingForImages = !1, n.count === 0 && (n.stylesheets && oh(n, n.stylesheets), n.unsuspend)) {
              var C = n.unsuspend;
              n.unsuspend = null, C();
            }
          },
          (n.imgBytes > A4 ? 50 : OT) + o
        );
        return n.unsuspend = s, function() {
          n.unsuspend = null, clearTimeout(h), clearTimeout(y);
        };
      } : null;
    }
    function rf() {
      if (this.count--, this.count === 0 && (this.imgCount === 0 || !this.waitingForImages)) {
        if (this.stylesheets)
          oh(this, this.stylesheets);
        else if (this.unsuspend) {
          var n = this.unsuspend;
          this.unsuspend = null, n();
        }
      }
    }
    function oh(n, o) {
      n.stylesheets = null, n.unsuspend !== null && (n.count++, Hw = /* @__PURE__ */ new Map(), o.forEach(w2, n), Hw = null, rf.call(n));
    }
    function w2(n, o) {
      if (!(o.state.loading & Es)) {
        var s = Hw.get(n);
        if (s) var h = s.get(N4);
        else {
          s = /* @__PURE__ */ new Map(), Hw.set(n, s);
          for (var y = n.querySelectorAll(
            "link[data-precedence],style[data-precedence]"
          ), C = 0; C < y.length; C++) {
            var A = y[C];
            (A.nodeName === "LINK" || A.getAttribute("media") !== "not all") && (s.set(A.dataset.precedence, A), h = A);
          }
          h && s.set(N4, h);
        }
        y = o.instance, A = y.getAttribute("data-precedence"), C = s.get(A) || h, C === h && s.set(N4, y), s.set(A, y), this.count++, h = rf.bind(this), y.addEventListener("load", h), y.addEventListener("error", h), C ? C.parentNode.insertBefore(y, C.nextSibling) : (n = n.nodeType === 9 ? n.head : n, n.insertBefore(y, n.firstChild)), o.state.loading |= Es;
      }
    }
    function ih(n, o, s, h, y, C, A, z, q) {
      for (this.tag = 1, this.containerInfo = n, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = Ih, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = St(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = St(0), this.hiddenUpdates = St(null), this.identifierPrefix = h, this.onUncaughtError = y, this.onCaughtError = C, this.onRecoverableError = A, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = q, this.incompleteTransitions = /* @__PURE__ */ new Map(), this.passiveEffectDuration = this.effectDuration = -0, this.memoizedUpdaters = /* @__PURE__ */ new Set(), n = this.pendingUpdatersLaneMap = [], o = 0; 31 > o; o++) n.push(/* @__PURE__ */ new Set());
      this._debugRootType = s ? "hydrateRoot()" : "createRoot()";
    }
    function lh(n, o, s, h, y, C, A, z, q, Z, xe, ke) {
      return n = new ih(
        n,
        o,
        s,
        A,
        q,
        Z,
        xe,
        ke,
        z
      ), o = JO, C === !0 && (o |= ii | Qs), o |= An, C = x(3, null, null, o), n.current = C, C.stateNode = n, o = Pp(), fc(o), n.pooledCache = o, fc(o), C.memoizedState = {
        element: h,
        isDehydrated: s,
        cache: o
      }, _n(C), n;
    }
    function Dy(n) {
      return n ? (n = Sf, n) : Sf;
    }
    function Mg(n, o, s, h, y, C) {
      if (Ia && typeof Ia.onScheduleFiberRoot == "function")
        try {
          Ia.onScheduleFiberRoot(Vc, h, s);
        } catch (A) {
          fs || (fs = !0, console.error(
            "React instrumentation encountered an error: %o",
            A
          ));
        }
      y = Dy(y), h.context === null ? h.context = y : h.pendingContext = y, ds && oi !== null && !d5 && (d5 = !0, console.error(
        `Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`,
        W(oi) || "Unknown"
      )), h = $a(o), h.payload = { element: s }, C = C === void 0 ? null : C, C !== null && (typeof C != "function" && console.error(
        "Expected the last optional `callback` argument to be a function. Instead received: %s.",
        C
      ), h.callback = C), s = Gl(n, h, o), s !== null && (Bl(o, "root.render()", null), ln(s, n, o), Ji(s, n, o));
    }
    function $y(n, o) {
      if (n = n.memoizedState, n !== null && n.dehydrated !== null) {
        var s = n.retryLane;
        n.retryLane = s !== 0 && s < o ? s : o;
      }
    }
    function S2(n, o) {
      $y(n, o), (n = n.alternate) && $y(n, o);
    }
    function C2(n) {
      if (n.tag === 13 || n.tag === 31) {
        var o = So(n, 67108864);
        o !== null && ln(o, n, 67108864), S2(n, 67108864);
      }
    }
    function x2(n) {
      if (n.tag === 13 || n.tag === 31) {
        var o = xo(n);
        o = Ct(o);
        var s = So(n, o);
        s !== null && ln(s, n, o), S2(n, o);
      }
    }
    function Mr() {
      return oi;
    }
    function E2(n, o, s, h) {
      var y = Xe.T;
      Xe.T = null;
      var C = fr.p;
      try {
        fr.p = La, P2(n, o, s, h);
      } finally {
        fr.p = C, Xe.T = y;
      }
    }
    function co(n, o, s, h) {
      var y = Xe.T;
      Xe.T = null;
      var C = fr.p;
      try {
        fr.p = mo, P2(n, o, s, h);
      } finally {
        fr.p = C, Xe.T = y;
      }
    }
    function P2(n, o, s, h) {
      if (Ww) {
        var y = Og(h);
        if (y === null)
          Ol(
            n,
            o,
            h,
            Vw,
            s
          ), Rg(n, h);
        else if (zy(
          y,
          n,
          o,
          s,
          h
        ))
          h.stopPropagation();
        else if (Rg(n, h), o & 4 && -1 < AT.indexOf(n)) {
          for (; y !== null; ) {
            var C = bt(y);
            if (C !== null)
              switch (C.tag) {
                case 3:
                  if (C = C.stateNode, C.current.memoizedState.isDehydrated) {
                    var A = je(C.pendingLanes);
                    if (A !== 0) {
                      var z = C;
                      for (z.pendingLanes |= 2, z.entangledLanes |= 2; A; ) {
                        var q = 1 << 31 - fo(A);
                        z.entanglements[1] |= q, A &= ~q;
                      }
                      ti(C), (ar & (po | Ll)) === Oo && (Ew = Ka() + H8, is(0));
                    }
                  }
                  break;
                case 31:
                case 13:
                  z = So(C, 2), z !== null && ln(z, C, 2), ki(), S2(C, 2);
              }
            if (C = Og(h), C === null && Ol(
              n,
              o,
              h,
              Vw,
              s
            ), C === y) break;
            y = C;
          }
          y !== null && h.stopPropagation();
        } else
          Ol(
            n,
            o,
            h,
            null,
            s
          );
      }
    }
    function Og(n) {
      return n = Va(n), k2(n);
    }
    function k2(n) {
      if (Vw = null, n = pt(n), n !== null) {
        var o = T(n);
        if (o === null) n = null;
        else {
          var s = o.tag;
          if (s === 13) {
            if (n = N(o), n !== null) return n;
            n = null;
          } else if (s === 31) {
            if (n = D(o), n !== null) return n;
            n = null;
          } else if (s === 3) {
            if (o.stateNode.current.memoizedState.isDehydrated)
              return o.tag === 3 ? o.stateNode.containerInfo : null;
            n = null;
          } else o !== n && (n = null);
        }
      }
      return Vw = n, null;
    }
    function Tg(n) {
      switch (n) {
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return La;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return mo;
        case "message":
          switch (mh()) {
            case j2:
              return La;
            case Hg:
              return mo;
            case Wc:
            case Wy:
              return Po;
            case Fg:
              return Wu;
            default:
              return Po;
          }
        default:
          return Po;
      }
    }
    function Rg(n, o) {
      switch (n) {
        case "focusin":
        case "focusout":
          If = null;
          break;
        case "dragenter":
        case "dragleave":
          Lf = null;
          break;
        case "mouseover":
        case "mouseout":
          Hf = null;
          break;
        case "pointerover":
        case "pointerout":
          R1.delete(o.pointerId);
          break;
        case "gotpointercapture":
        case "lostpointercapture":
          A1.delete(o.pointerId);
      }
    }
    function Iu(n, o, s, h, y, C) {
      return n === null || n.nativeEvent !== C ? (n = {
        blockedOn: o,
        domEventName: s,
        eventSystemFlags: h,
        nativeEvent: C,
        targetContainers: [y]
      }, o !== null && (o = bt(o), o !== null && C2(o)), n) : (n.eventSystemFlags |= h, o = n.targetContainers, y !== null && o.indexOf(y) === -1 && o.push(y), n);
    }
    function zy(n, o, s, h, y) {
      switch (o) {
        case "focusin":
          return If = Iu(
            If,
            n,
            o,
            s,
            h,
            y
          ), !0;
        case "dragenter":
          return Lf = Iu(
            Lf,
            n,
            o,
            s,
            h,
            y
          ), !0;
        case "mouseover":
          return Hf = Iu(
            Hf,
            n,
            o,
            s,
            h,
            y
          ), !0;
        case "pointerover":
          var C = y.pointerId;
          return R1.set(
            C,
            Iu(
              R1.get(C) || null,
              n,
              o,
              s,
              h,
              y
            )
          ), !0;
        case "gotpointercapture":
          return C = y.pointerId, A1.set(
            C,
            Iu(
              A1.get(C) || null,
              n,
              o,
              s,
              h,
              y
            )
          ), !0;
      }
      return !1;
    }
    function M2(n) {
      var o = pt(n.target);
      if (o !== null) {
        var s = T(o);
        if (s !== null) {
          if (o = s.tag, o === 13) {
            if (o = N(s), o !== null) {
              n.blockedOn = o, ft(n.priority, function() {
                x2(s);
              });
              return;
            }
          } else if (o === 31) {
            if (o = D(s), o !== null) {
              n.blockedOn = o, ft(n.priority, function() {
                x2(s);
              });
              return;
            }
          } else if (o === 3 && s.stateNode.current.memoizedState.isDehydrated) {
            n.blockedOn = s.tag === 3 ? s.stateNode.containerInfo : null;
            return;
          }
        }
      }
      n.blockedOn = null;
    }
    function af(n) {
      if (n.blockedOn !== null) return !1;
      for (var o = n.targetContainers; 0 < o.length; ) {
        var s = Og(n.nativeEvent);
        if (s === null) {
          s = n.nativeEvent;
          var h = new s.constructor(
            s.type,
            s
          ), y = h;
          W2 !== null && console.error(
            "Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."
          ), W2 = y, s.target.dispatchEvent(h), W2 === null && console.error(
            "Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."
          ), W2 = null;
        } else
          return o = bt(s), o !== null && C2(o), n.blockedOn = s, !1;
        o.shift();
      }
      return !0;
    }
    function Ag(n, o, s) {
      af(n) && s.delete(o);
    }
    function yC() {
      D4 = !1, If !== null && af(If) && (If = null), Lf !== null && af(Lf) && (Lf = null), Hf !== null && af(Hf) && (Hf = null), R1.forEach(Ag), A1.forEach(Ag);
    }
    function sh(n, o) {
      n.blockedOn === o && (n.blockedOn = null, D4 || (D4 = !0, Sa.unstable_scheduleCallback(
        Sa.unstable_NormalPriority,
        yC
      )));
    }
    function jy(n) {
      _w !== n && (_w = n, Sa.unstable_scheduleCallback(
        Sa.unstable_NormalPriority,
        function() {
          _w === n && (_w = null);
          for (var o = 0; o < n.length; o += 3) {
            var s = n[o], h = n[o + 1], y = n[o + 2];
            if (typeof h != "function") {
              if (k2(h || s) === null)
                continue;
              break;
            }
            var C = bt(s);
            C !== null && (n.splice(o, 3), o -= 3, s = {
              pending: !0,
              data: y,
              method: s.method,
              action: h
            }, Object.freeze(s), Fs(
              C,
              s,
              h,
              y
            ));
          }
        }
      ));
    }
    function Lc(n) {
      function o(q) {
        return sh(q, n);
      }
      If !== null && sh(If, n), Lf !== null && sh(Lf, n), Hf !== null && sh(Hf, n), R1.forEach(o), A1.forEach(o);
      for (var s = 0; s < Ff.length; s++) {
        var h = Ff[s];
        h.blockedOn === n && (h.blockedOn = null);
      }
      for (; 0 < Ff.length && (s = Ff[0], s.blockedOn === null); )
        M2(s), s.blockedOn === null && Ff.shift();
      if (s = (n.ownerDocument || n).$$reactFormReplay, s != null)
        for (h = 0; h < s.length; h += 3) {
          var y = s[h], C = s[h + 1], A = y[qo] || null;
          if (typeof C == "function")
            A || jy(s);
          else if (A) {
            var z = null;
            if (C && C.hasAttribute("formAction")) {
              if (y = C, A = C[qo] || null)
                z = A.formAction;
              else if (k2(y) !== null) continue;
            } else z = A.action;
            typeof z == "function" ? s[h + 1] = z : (s.splice(h, 3), h -= 3), jy(s);
          }
        }
    }
    function Iy() {
      function n(C) {
        C.canIntercept && C.info === "react-transition" && C.intercept({
          handler: function() {
            return new Promise(function(A) {
              return y = A;
            });
          },
          focusReset: "manual",
          scroll: "manual"
        });
      }
      function o() {
        y !== null && (y(), y = null), h || setTimeout(s, 20);
      }
      function s() {
        if (!h && !navigation.transition) {
          var C = navigation.currentEntry;
          C && C.url != null && navigation.navigate(C.url, {
            state: C.getState(),
            info: "react-transition",
            history: "replace"
          });
        }
      }
      if (typeof navigation == "object") {
        var h = !1, y = null;
        return navigation.addEventListener("navigate", n), navigation.addEventListener("navigatesuccess", o), navigation.addEventListener("navigateerror", o), setTimeout(s, 100), function() {
          h = !0, navigation.removeEventListener("navigate", n), navigation.removeEventListener(
            "navigatesuccess",
            o
          ), navigation.removeEventListener(
            "navigateerror",
            o
          ), y !== null && (y(), y = null);
        };
      }
    }
    function O2(n) {
      this._internalRoot = n;
    }
    function Al(n) {
      this._internalRoot = n;
    }
    function T2(n) {
      n[Ys] && (n._reactRootContainer ? console.error(
        "You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported."
      ) : console.error(
        "You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."
      ));
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var Sa = GZ(), uh = Re, wC = hb, Rn = Object.assign, Ly = Symbol.for("react.element"), nl = Symbol.for("react.transitional.element"), Lu = Symbol.for("react.portal"), of = Symbol.for("react.fragment"), Go = Symbol.for("react.strict_mode"), ch = Symbol.for("react.profiler"), Ng = Symbol.for("react.consumer"), Nl = Symbol.for("react.context"), lf = Symbol.for("react.forward_ref"), Hc = Symbol.for("react.suspense"), ai = Symbol.for("react.suspense_list"), dh = Symbol.for("react.memo"), Eo = Symbol.for("react.lazy"), Dl = Symbol.for("react.activity"), SC = Symbol.for("react.memo_cache_sentinel"), Hy = Symbol.iterator, sf = Symbol.for("react.client.reference"), Ta = Array.isArray, Xe = uh.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, fr = wC.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, CC = Object.freeze({
      pending: !1,
      data: null,
      method: null,
      action: null
    }), R2 = [], A2 = [], Ks = -1, Hu = Q(null), uf = Q(null), Oi = Q(null), Fu = Q(null), cf = 0, Fy, Fc, df, N2, fh, Dg, $g;
    ie.__reactDisabledLog = !0;
    var ff, D2, zg = !1, $2 = new (typeof WeakMap == "function" ? WeakMap : Map)(), oi = null, ds = !1, Ti = Object.prototype.hasOwnProperty, z2 = Sa.unstable_scheduleCallback, jg = Sa.unstable_cancelCallback, Ig = Sa.unstable_shouldYield, Lg = Sa.unstable_requestPaint, Ka = Sa.unstable_now, mh = Sa.unstable_getCurrentPriorityLevel, j2 = Sa.unstable_ImmediatePriority, Hg = Sa.unstable_UserBlockingPriority, Wc = Sa.unstable_NormalPriority, Wy = Sa.unstable_LowPriority, Fg = Sa.unstable_IdlePriority, I2 = Sa.log, Vy = Sa.unstable_setDisableYieldValue, Vc = null, Ia = null, fs = !1, ms = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u", fo = Math.clz32 ? Math.clz32 : ye, L2 = Math.log, Wg = Math.LN2, mf = 256, hh = 262144, hf = 4194304, La = 2, mo = 8, Po = 32, Wu = 268435456, rl = Math.random().toString(36).slice(2), Xr = "__reactFiber$" + rl, qo = "__reactProps$" + rl, Ys = "__reactContainer$" + rl, _c = "__reactEvents$" + rl, xC = "__reactListeners$" + rl, _y = "__reactHandles$" + rl, ph = "__reactResources$" + rl, pf = "__reactMarker$" + rl, By = /* @__PURE__ */ new Set(), hs = {}, gf = {}, Uy = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    }, vf = RegExp(
      "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), H2 = {}, Vg = {}, _g = /[\n"\\]/g, F2 = !1, Xy = !1, gh = !1, l = !1, u = !1, m = !1, v = ["value", "defaultValue"], O = !1, R = /["'&<>\n\t]|^\s|\s$/, B = "address applet area article aside base basefont bgsound blockquote body br button caption center col colgroup dd details dir div dl dt embed fieldset figcaption figure footer form frame frameset h1 h2 h3 h4 h5 h6 head header hgroup hr html iframe img input isindex li link listing main marquee menu menuitem meta nav noembed noframes noscript object ol p param plaintext pre script section select source style summary table tbody td template textarea tfoot th thead title tr track ul wbr xmp".split(
      " "
    ), re = "applet caption html table td th marquee object template foreignObject desc title".split(
      " "
    ), ve = re.concat(["button"]), He = "dd dt li option optgroup p rp rt".split(" "), Je = {
      current: null,
      formTag: null,
      aTagInScope: null,
      buttonTagInScope: null,
      nobrTagInScope: null,
      pTagInButtonScope: null,
      listItemTagAutoclosing: null,
      dlItemTagAutoclosing: null,
      containerTagInScope: null,
      implicitRootScope: !1
    }, nt = {}, We = {
      animation: "animationDelay animationDirection animationDuration animationFillMode animationIterationCount animationName animationPlayState animationTimingFunction".split(
        " "
      ),
      background: "backgroundAttachment backgroundClip backgroundColor backgroundImage backgroundOrigin backgroundPositionX backgroundPositionY backgroundRepeat backgroundSize".split(
        " "
      ),
      backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
      border: "borderBottomColor borderBottomStyle borderBottomWidth borderImageOutset borderImageRepeat borderImageSlice borderImageSource borderImageWidth borderLeftColor borderLeftStyle borderLeftWidth borderRightColor borderRightStyle borderRightWidth borderTopColor borderTopStyle borderTopWidth".split(
        " "
      ),
      borderBlockEnd: [
        "borderBlockEndColor",
        "borderBlockEndStyle",
        "borderBlockEndWidth"
      ],
      borderBlockStart: [
        "borderBlockStartColor",
        "borderBlockStartStyle",
        "borderBlockStartWidth"
      ],
      borderBottom: [
        "borderBottomColor",
        "borderBottomStyle",
        "borderBottomWidth"
      ],
      borderColor: [
        "borderBottomColor",
        "borderLeftColor",
        "borderRightColor",
        "borderTopColor"
      ],
      borderImage: [
        "borderImageOutset",
        "borderImageRepeat",
        "borderImageSlice",
        "borderImageSource",
        "borderImageWidth"
      ],
      borderInlineEnd: [
        "borderInlineEndColor",
        "borderInlineEndStyle",
        "borderInlineEndWidth"
      ],
      borderInlineStart: [
        "borderInlineStartColor",
        "borderInlineStartStyle",
        "borderInlineStartWidth"
      ],
      borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
      borderRadius: [
        "borderBottomLeftRadius",
        "borderBottomRightRadius",
        "borderTopLeftRadius",
        "borderTopRightRadius"
      ],
      borderRight: [
        "borderRightColor",
        "borderRightStyle",
        "borderRightWidth"
      ],
      borderStyle: [
        "borderBottomStyle",
        "borderLeftStyle",
        "borderRightStyle",
        "borderTopStyle"
      ],
      borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderWidth: [
        "borderBottomWidth",
        "borderLeftWidth",
        "borderRightWidth",
        "borderTopWidth"
      ],
      columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
      columns: ["columnCount", "columnWidth"],
      flex: ["flexBasis", "flexGrow", "flexShrink"],
      flexFlow: ["flexDirection", "flexWrap"],
      font: "fontFamily fontFeatureSettings fontKerning fontLanguageOverride fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontVariantAlternates fontVariantCaps fontVariantEastAsian fontVariantLigatures fontVariantNumeric fontVariantPosition fontWeight lineHeight".split(
        " "
      ),
      fontVariant: "fontVariantAlternates fontVariantCaps fontVariantEastAsian fontVariantLigatures fontVariantNumeric fontVariantPosition".split(
        " "
      ),
      gap: ["columnGap", "rowGap"],
      grid: "gridAutoColumns gridAutoFlow gridAutoRows gridTemplateAreas gridTemplateColumns gridTemplateRows".split(
        " "
      ),
      gridArea: [
        "gridColumnEnd",
        "gridColumnStart",
        "gridRowEnd",
        "gridRowStart"
      ],
      gridColumn: ["gridColumnEnd", "gridColumnStart"],
      gridColumnGap: ["columnGap"],
      gridGap: ["columnGap", "rowGap"],
      gridRow: ["gridRowEnd", "gridRowStart"],
      gridRowGap: ["rowGap"],
      gridTemplate: [
        "gridTemplateAreas",
        "gridTemplateColumns",
        "gridTemplateRows"
      ],
      listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
      margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
      marker: ["markerEnd", "markerMid", "markerStart"],
      mask: "maskClip maskComposite maskImage maskMode maskOrigin maskPositionX maskPositionY maskRepeat maskSize".split(
        " "
      ),
      maskPosition: ["maskPositionX", "maskPositionY"],
      outline: ["outlineColor", "outlineStyle", "outlineWidth"],
      overflow: ["overflowX", "overflowY"],
      padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
      placeContent: ["alignContent", "justifyContent"],
      placeItems: ["alignItems", "justifyItems"],
      placeSelf: ["alignSelf", "justifySelf"],
      textDecoration: [
        "textDecorationColor",
        "textDecorationLine",
        "textDecorationStyle"
      ],
      textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
      transition: [
        "transitionDelay",
        "transitionDuration",
        "transitionProperty",
        "transitionTimingFunction"
      ],
      wordWrap: ["overflowWrap"]
    }, Ge = /([A-Z])/g, At = /^ms-/, Zt = /^(?:webkit|moz|o)[A-Z]/, Or = /^-ms-/, $e = /-(.)/g, Pe = /;\s*$/, Ie = {}, et = {}, Vt = !1, rr = !1, jt = new Set(
      "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
        " "
      )
    ), vn = "http://www.w3.org/1998/Math/MathML", Pn = "http://www.w3.org/2000/svg", lr = /* @__PURE__ */ new Map([
      ["acceptCharset", "accept-charset"],
      ["htmlFor", "for"],
      ["httpEquiv", "http-equiv"],
      ["crossOrigin", "crossorigin"],
      ["accentHeight", "accent-height"],
      ["alignmentBaseline", "alignment-baseline"],
      ["arabicForm", "arabic-form"],
      ["baselineShift", "baseline-shift"],
      ["capHeight", "cap-height"],
      ["clipPath", "clip-path"],
      ["clipRule", "clip-rule"],
      ["colorInterpolation", "color-interpolation"],
      ["colorInterpolationFilters", "color-interpolation-filters"],
      ["colorProfile", "color-profile"],
      ["colorRendering", "color-rendering"],
      ["dominantBaseline", "dominant-baseline"],
      ["enableBackground", "enable-background"],
      ["fillOpacity", "fill-opacity"],
      ["fillRule", "fill-rule"],
      ["floodColor", "flood-color"],
      ["floodOpacity", "flood-opacity"],
      ["fontFamily", "font-family"],
      ["fontSize", "font-size"],
      ["fontSizeAdjust", "font-size-adjust"],
      ["fontStretch", "font-stretch"],
      ["fontStyle", "font-style"],
      ["fontVariant", "font-variant"],
      ["fontWeight", "font-weight"],
      ["glyphName", "glyph-name"],
      ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
      ["glyphOrientationVertical", "glyph-orientation-vertical"],
      ["horizAdvX", "horiz-adv-x"],
      ["horizOriginX", "horiz-origin-x"],
      ["imageRendering", "image-rendering"],
      ["letterSpacing", "letter-spacing"],
      ["lightingColor", "lighting-color"],
      ["markerEnd", "marker-end"],
      ["markerMid", "marker-mid"],
      ["markerStart", "marker-start"],
      ["overlinePosition", "overline-position"],
      ["overlineThickness", "overline-thickness"],
      ["paintOrder", "paint-order"],
      ["panose-1", "panose-1"],
      ["pointerEvents", "pointer-events"],
      ["renderingIntent", "rendering-intent"],
      ["shapeRendering", "shape-rendering"],
      ["stopColor", "stop-color"],
      ["stopOpacity", "stop-opacity"],
      ["strikethroughPosition", "strikethrough-position"],
      ["strikethroughThickness", "strikethrough-thickness"],
      ["strokeDasharray", "stroke-dasharray"],
      ["strokeDashoffset", "stroke-dashoffset"],
      ["strokeLinecap", "stroke-linecap"],
      ["strokeLinejoin", "stroke-linejoin"],
      ["strokeMiterlimit", "stroke-miterlimit"],
      ["strokeOpacity", "stroke-opacity"],
      ["strokeWidth", "stroke-width"],
      ["textAnchor", "text-anchor"],
      ["textDecoration", "text-decoration"],
      ["textRendering", "text-rendering"],
      ["transformOrigin", "transform-origin"],
      ["underlinePosition", "underline-position"],
      ["underlineThickness", "underline-thickness"],
      ["unicodeBidi", "unicode-bidi"],
      ["unicodeRange", "unicode-range"],
      ["unitsPerEm", "units-per-em"],
      ["vAlphabetic", "v-alphabetic"],
      ["vHanging", "v-hanging"],
      ["vIdeographic", "v-ideographic"],
      ["vMathematical", "v-mathematical"],
      ["vectorEffect", "vector-effect"],
      ["vertAdvY", "vert-adv-y"],
      ["vertOriginX", "vert-origin-x"],
      ["vertOriginY", "vert-origin-y"],
      ["wordSpacing", "word-spacing"],
      ["writingMode", "writing-mode"],
      ["xmlnsXlink", "xmlns:xlink"],
      ["xHeight", "x-height"]
    ]), $l = {
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      fetchpriority: "fetchPriority",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      inert: "inert",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      popover: "popover",
      popovertarget: "popoverTarget",
      popovertargetaction: "popoverTargetAction",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      transformorigin: "transformOrigin",
      "transform-origin": "transformOrigin",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, Gy = {
      "aria-current": 0,
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      "aria-hidden": 0,
      "aria-invalid": 0,
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0,
      "aria-braillelabel": 0,
      "aria-brailleroledescription": 0,
      "aria-colindextext": 0,
      "aria-rowindextext": 0
    }, Bg = {}, cO = RegExp(
      "^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), dO = RegExp(
      "^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), h6 = !1, Ri = {}, p6 = /^on./, fO = /^on[^A-Z]/, mO = RegExp(
      "^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), hO = RegExp(
      "^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), pO = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i, W2 = null, Ug = null, Xg = null, EC = !1, Vu = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), PC = !1;
    if (Vu)
      try {
        var V2 = {};
        Object.defineProperty(V2, "passive", {
          get: function() {
            PC = !0;
          }
        }), window.addEventListener("test", V2, V2), window.removeEventListener("test", V2, V2);
      } catch {
        PC = !1;
      }
    var bf = null, kC = null, qy = null, vh = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function(n) {
        return n.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    }, Ky = Jt(vh), _2 = Rn({}, vh, { view: 0, detail: 0 }), gO = Jt(_2), MC, OC, B2, Yy = Rn({}, _2, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: ao,
      button: 0,
      buttons: 0,
      relatedTarget: function(n) {
        return n.relatedTarget === void 0 ? n.fromElement === n.srcElement ? n.toElement : n.fromElement : n.relatedTarget;
      },
      movementX: function(n) {
        return "movementX" in n ? n.movementX : (n !== B2 && (B2 && n.type === "mousemove" ? (MC = n.screenX - B2.screenX, OC = n.screenY - B2.screenY) : OC = MC = 0, B2 = n), MC);
      },
      movementY: function(n) {
        return "movementY" in n ? n.movementY : OC;
      }
    }), g6 = Jt(Yy), vO = Rn({}, Yy, { dataTransfer: 0 }), bO = Jt(vO), yO = Rn({}, _2, { relatedTarget: 0 }), TC = Jt(yO), wO = Rn({}, vh, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), SO = Jt(wO), CO = Rn({}, vh, {
      clipboardData: function(n) {
        return "clipboardData" in n ? n.clipboardData : window.clipboardData;
      }
    }), xO = Jt(CO), EO = Rn({}, vh, { data: 0 }), v6 = Jt(
      EO
    ), PO = v6, kO = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, MO = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    }, OO = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    }, TO = Rn({}, _2, {
      key: function(n) {
        if (n.key) {
          var o = kO[n.key] || n.key;
          if (o !== "Unidentified") return o;
        }
        return n.type === "keypress" ? (n = rc(n), n === 13 ? "Enter" : String.fromCharCode(n)) : n.type === "keydown" || n.type === "keyup" ? MO[n.keyCode] || "Unidentified" : "";
      },
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: ao,
      charCode: function(n) {
        return n.type === "keypress" ? rc(n) : 0;
      },
      keyCode: function(n) {
        return n.type === "keydown" || n.type === "keyup" ? n.keyCode : 0;
      },
      which: function(n) {
        return n.type === "keypress" ? rc(n) : n.type === "keydown" || n.type === "keyup" ? n.keyCode : 0;
      }
    }), RO = Jt(TO), AO = Rn({}, Yy, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }), b6 = Jt(AO), NO = Rn({}, _2, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: ao
    }), DO = Jt(NO), $O = Rn({}, vh, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), zO = Jt($O), jO = Rn({}, Yy, {
      deltaX: function(n) {
        return "deltaX" in n ? n.deltaX : "wheelDeltaX" in n ? -n.wheelDeltaX : 0;
      },
      deltaY: function(n) {
        return "deltaY" in n ? n.deltaY : "wheelDeltaY" in n ? -n.wheelDeltaY : "wheelDelta" in n ? -n.wheelDelta : 0;
      },
      deltaZ: 0,
      deltaMode: 0
    }), IO = Jt(jO), LO = Rn({}, vh, {
      newState: 0,
      oldState: 0
    }), HO = Jt(LO), FO = [9, 13, 27, 32], y6 = 229, RC = Vu && "CompositionEvent" in window, U2 = null;
    Vu && "documentMode" in document && (U2 = document.documentMode);
    var WO = Vu && "TextEvent" in window && !U2, w6 = Vu && (!RC || U2 && 8 < U2 && 11 >= U2), S6 = 32, C6 = String.fromCharCode(S6), x6 = !1, Gg = !1, VO = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    }, X2 = null, G2 = null, E6 = !1;
    Vu && (E6 = cd("input") && (!document.documentMode || 9 < document.documentMode));
    var Ai = typeof Object.is == "function" ? Object.is : pp, _O = Vu && "documentMode" in document && 11 >= document.documentMode, qg = null, AC = null, q2 = null, NC = !1, Kg = {
      animationend: ac("Animation", "AnimationEnd"),
      animationiteration: ac("Animation", "AnimationIteration"),
      animationstart: ac("Animation", "AnimationStart"),
      transitionrun: ac("Transition", "TransitionRun"),
      transitionstart: ac("Transition", "TransitionStart"),
      transitioncancel: ac("Transition", "TransitionCancel"),
      transitionend: ac("Transition", "TransitionEnd")
    }, DC = {}, P6 = {};
    Vu && (P6 = document.createElement("div").style, "AnimationEvent" in window || (delete Kg.animationend.animation, delete Kg.animationiteration.animation, delete Kg.animationstart.animation), "TransitionEvent" in window || delete Kg.transitionend.transition);
    var k6 = oc("animationend"), M6 = oc("animationiteration"), O6 = oc("animationstart"), BO = oc("transitionrun"), UO = oc("transitionstart"), XO = oc("transitioncancel"), T6 = oc("transitionend"), R6 = /* @__PURE__ */ new Map(), $C = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
      " "
    );
    $C.push("scrollEnd");
    var A6 = 0;
    if (typeof performance == "object" && typeof performance.now == "function")
      var GO = performance, N6 = function() {
        return GO.now();
      };
    else {
      var qO = Date;
      N6 = function() {
        return qO.now();
      };
    }
    var zC = typeof reportError == "function" ? reportError : function(n) {
      if (typeof window == "object" && typeof window.ErrorEvent == "function") {
        var o = new window.ErrorEvent("error", {
          bubbles: !0,
          cancelable: !0,
          message: typeof n == "object" && n !== null && typeof n.message == "string" ? String(n.message) : String(n),
          error: n
        });
        if (!window.dispatchEvent(o)) return;
      } else if (typeof process == "object" && typeof process.emit == "function") {
        process.emit("uncaughtException", n);
        return;
      }
      console.error(n);
    }, KO = "This object has been omitted by React in the console log to avoid sending too much data from the server. Try logging smaller or more specific objects.", Qy = 0, jC = 1, IC = 2, LC = 3, Jy = "– ", Zy = "+ ", D6 = "  ", Gr = typeof console < "u" && typeof console.timeStamp == "function" && typeof performance < "u" && typeof performance.measure == "function", ps = "Components ⚛", Kn = "Scheduler ⚛", Zn = "Blocking", yf = !1, Bc = {
      color: "primary",
      properties: null,
      tooltipText: "",
      track: ps
    }, wf = {
      start: -0,
      end: -0,
      detail: { devtools: Bc }
    }, YO = ["Changed Props", ""], $6 = "This component received deeply equal props. It might benefit from useMemo or the React Compiler in its owner.", QO = ["Changed Props", $6], K2 = 1, Uc = 2, gs = [], Yg = 0, HC = 0, Sf = {};
    Object.freeze(Sf);
    var vs = null, Qg = null, on = 0, JO = 1, An = 2, ii = 8, Qs = 16, ZO = 32, z6 = !1;
    try {
      var eT = Object.preventExtensions({});
    } catch {
      z6 = !0;
    }
    var FC = /* @__PURE__ */ new WeakMap(), Jg = [], Zg = 0, ew = null, Y2 = 0, bs = [], ys = 0, bh = null, Xc = 1, Gc = "", Ko = null, qr = null, Xn = !1, _u = !1, zl = null, Cf = null, ws = !1, WC = Error(
      "Hydration Mismatch Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."
    ), VC = Q(null), _C = Q(null), j6 = {}, tw = null, e0 = null, t0 = !1, tT = typeof AbortController < "u" ? AbortController : function() {
      var n = [], o = this.signal = {
        aborted: !1,
        addEventListener: function(s, h) {
          n.push(h);
        }
      };
      this.abort = function() {
        o.aborted = !0, n.forEach(function(s) {
          return s();
        });
      };
    }, nT = Sa.unstable_scheduleCallback, rT = Sa.unstable_NormalPriority, Ya = {
      $$typeof: Nl,
      Consumer: null,
      Provider: null,
      _currentValue: null,
      _currentValue2: null,
      _threadCount: 0,
      _currentRenderer: null,
      _currentRenderer2: null
    }, Qa = Sa.unstable_now, nw = console.createTask ? console.createTask : function() {
      return null;
    }, Q2 = 1, rw = 2, ko = -0, xf = -0, qc = -0, Kc = null, Ni = -1.1, yh = -0, ma = -0, Bt = -1.1, tn = -1.1, na = null, Ca = !1, wh = -0, Bu = -1.1, J2 = null, Ef = 0, BC = null, UC = null, Sh = -1.1, Z2 = null, n0 = -1.1, aw = -1.1, Yc = -0, Qc = -1.1, Ss = -1.1, XC = 0, e1 = null, I6 = null, L6 = null, Pf = -1.1, Ch = null, kf = -1.1, ow = -1.1, H6 = -0, F6 = -0, iw = 0, aT = null, W6 = 0, t1 = -1.1, lw = !1, sw = !1, n1 = null, GC = 0, xh = 0, r0 = null, V6 = Xe.S;
    Xe.S = function(n, o) {
      if (I8 = Ka(), typeof o == "object" && o !== null && typeof o.then == "function") {
        if (0 > Qc && 0 > Ss) {
          Qc = Qa();
          var s = Jd(), h = us();
          (s !== kf || h !== Ch) && (kf = -1.1), Pf = s, Ch = h;
        }
        Ds(n, o);
      }
      V6 !== null && V6(n, o);
    };
    var Eh = Q(null), Js = {
      recordUnsafeLifecycleWarnings: function() {
      },
      flushPendingUnsafeLifecycleWarnings: function() {
      },
      recordLegacyContextWarning: function() {
      },
      flushLegacyContextWarning: function() {
      },
      discardPendingWarnings: function() {
      }
    }, r1 = [], a1 = [], o1 = [], i1 = [], l1 = [], s1 = [], Ph = /* @__PURE__ */ new Set();
    Js.recordUnsafeLifecycleWarnings = function(n, o) {
      Ph.has(n.type) || (typeof o.componentWillMount == "function" && o.componentWillMount.__suppressDeprecationWarning !== !0 && r1.push(n), n.mode & ii && typeof o.UNSAFE_componentWillMount == "function" && a1.push(n), typeof o.componentWillReceiveProps == "function" && o.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && o1.push(n), n.mode & ii && typeof o.UNSAFE_componentWillReceiveProps == "function" && i1.push(n), typeof o.componentWillUpdate == "function" && o.componentWillUpdate.__suppressDeprecationWarning !== !0 && l1.push(n), n.mode & ii && typeof o.UNSAFE_componentWillUpdate == "function" && s1.push(n));
    }, Js.flushPendingUnsafeLifecycleWarnings = function() {
      var n = /* @__PURE__ */ new Set();
      0 < r1.length && (r1.forEach(function(z) {
        n.add(
          W(z) || "Component"
        ), Ph.add(z.type);
      }), r1 = []);
      var o = /* @__PURE__ */ new Set();
      0 < a1.length && (a1.forEach(function(z) {
        o.add(
          W(z) || "Component"
        ), Ph.add(z.type);
      }), a1 = []);
      var s = /* @__PURE__ */ new Set();
      0 < o1.length && (o1.forEach(function(z) {
        s.add(
          W(z) || "Component"
        ), Ph.add(z.type);
      }), o1 = []);
      var h = /* @__PURE__ */ new Set();
      0 < i1.length && (i1.forEach(
        function(z) {
          h.add(
            W(z) || "Component"
          ), Ph.add(z.type);
        }
      ), i1 = []);
      var y = /* @__PURE__ */ new Set();
      0 < l1.length && (l1.forEach(function(z) {
        y.add(
          W(z) || "Component"
        ), Ph.add(z.type);
      }), l1 = []);
      var C = /* @__PURE__ */ new Set();
      if (0 < s1.length && (s1.forEach(function(z) {
        C.add(
          W(z) || "Component"
        ), Ph.add(z.type);
      }), s1 = []), 0 < o.size) {
        var A = w(
          o
        );
        console.error(
          `Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`,
          A
        );
      }
      0 < h.size && (A = w(
        h
      ), console.error(
        `Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://react.dev/link/derived-state

Please update the following components: %s`,
        A
      )), 0 < C.size && (A = w(
        C
      ), console.error(
        `Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`,
        A
      )), 0 < n.size && (A = w(n), console.warn(
        `componentWillMount has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`,
        A
      )), 0 < s.size && (A = w(
        s
      ), console.warn(
        `componentWillReceiveProps has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://react.dev/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`,
        A
      )), 0 < y.size && (A = w(y), console.warn(
        `componentWillUpdate has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`,
        A
      ));
    };
    var uw = /* @__PURE__ */ new Map(), _6 = /* @__PURE__ */ new Set();
    Js.recordLegacyContextWarning = function(n, o) {
      for (var s = null, h = n; h !== null; )
        h.mode & ii && (s = h), h = h.return;
      s === null ? console.error(
        "Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue."
      ) : !_6.has(n.type) && (h = uw.get(s), n.type.contextTypes != null || n.type.childContextTypes != null || o !== null && typeof o.getChildContext == "function") && (h === void 0 && (h = [], uw.set(s, h)), h.push(n));
    }, Js.flushLegacyContextWarning = function() {
      uw.forEach(function(n) {
        if (n.length !== 0) {
          var o = n[0], s = /* @__PURE__ */ new Set();
          n.forEach(function(y) {
            s.add(W(y) || "Component"), _6.add(y.type);
          });
          var h = w(s);
          le(o, function() {
            console.error(
              `Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://react.dev/link/legacy-context`,
              h
            );
          });
        }
      });
    }, Js.discardPendingWarnings = function() {
      r1 = [], a1 = [], o1 = [], i1 = [], l1 = [], s1 = [], uw = /* @__PURE__ */ new Map();
    };
    var B6 = {
      react_stack_bottom_frame: function(n, o, s) {
        var h = ds;
        ds = !0;
        try {
          return n(o, s);
        } finally {
          ds = h;
        }
      }
    }, qC = B6.react_stack_bottom_frame.bind(B6), U6 = {
      react_stack_bottom_frame: function(n) {
        var o = ds;
        ds = !0;
        try {
          return n.render();
        } finally {
          ds = o;
        }
      }
    }, X6 = U6.react_stack_bottom_frame.bind(U6), G6 = {
      react_stack_bottom_frame: function(n, o) {
        try {
          o.componentDidMount();
        } catch (s) {
          En(n, n.return, s);
        }
      }
    }, KC = G6.react_stack_bottom_frame.bind(
      G6
    ), q6 = {
      react_stack_bottom_frame: function(n, o, s, h, y) {
        try {
          o.componentDidUpdate(s, h, y);
        } catch (C) {
          En(n, n.return, C);
        }
      }
    }, K6 = q6.react_stack_bottom_frame.bind(
      q6
    ), Y6 = {
      react_stack_bottom_frame: function(n, o) {
        var s = o.stack;
        n.componentDidCatch(o.value, {
          componentStack: s !== null ? s : ""
        });
      }
    }, oT = Y6.react_stack_bottom_frame.bind(
      Y6
    ), Q6 = {
      react_stack_bottom_frame: function(n, o, s) {
        try {
          s.componentWillUnmount();
        } catch (h) {
          En(n, o, h);
        }
      }
    }, J6 = Q6.react_stack_bottom_frame.bind(
      Q6
    ), Z6 = {
      react_stack_bottom_frame: function(n) {
        var o = n.create;
        return n = n.inst, o = o(), n.destroy = o;
      }
    }, iT = Z6.react_stack_bottom_frame.bind(Z6), e8 = {
      react_stack_bottom_frame: function(n, o, s) {
        try {
          s();
        } catch (h) {
          En(n, o, h);
        }
      }
    }, lT = e8.react_stack_bottom_frame.bind(e8), t8 = {
      react_stack_bottom_frame: function(n) {
        var o = n._init;
        return o(n._payload);
      }
    }, sT = t8.react_stack_bottom_frame.bind(t8), a0 = Error(
      "Suspense Exception: This is not a real error! It's an implementation detail of `use` to interrupt the current render. You must either rethrow it immediately, or move the `use` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary, or call the promise's `.catch` method and pass the result to `use`."
    ), YC = Error(
      "Suspense Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."
    ), cw = Error(
      "Suspense Exception: This is not a real error! It's an implementation detail of `useActionState` to interrupt the current render. You must either rethrow it immediately, or move the `useActionState` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary."
    ), dw = {
      then: function() {
        console.error(
          'Internal React error: A listener was unexpectedly attached to a "noop" thenable. This is a bug in React. Please file an issue.'
        );
      }
    }, kh = null, u1 = !1, o0 = null, c1 = 0, Nn = null, QC, n8 = QC = !1, r8 = {}, a8 = {}, o8 = {};
    b = function(n, o, s) {
      if (s !== null && typeof s == "object" && s._store && (!s._store.validated && s.key == null || s._store.validated === 2)) {
        if (typeof s._store != "object")
          throw Error(
            "React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue."
          );
        s._store.validated = 1;
        var h = W(n), y = h || "null";
        if (!r8[y]) {
          r8[y] = !0, s = s._owner, n = n._debugOwner;
          var C = "";
          n && typeof n.tag == "number" && (y = W(n)) && (C = `

Check the render method of \`` + y + "`."), C || h && (C = `

Check the top-level render call using <` + h + ">.");
          var A = "";
          s != null && n !== s && (h = null, typeof s.tag == "number" ? h = W(s) : typeof s.name == "string" && (h = s.name), h && (A = " It was passed a child from " + h + ".")), le(o, function() {
            console.error(
              'Each child in a list should have a unique "key" prop.%s%s See https://react.dev/link/warning-keys for more information.',
              C,
              A
            );
          });
        }
      }
    };
    var Mh = Ba(!0), i8 = Ba(!1), l8 = 0, s8 = 1, u8 = 2, JC = 3, Mf = !1, c8 = !1, ZC = null, e4 = !1, i0 = Q(null), fw = Q(0), jl = Q(null), Ms = null, l0 = 1, d1 = 2, Ha = Q(0), mw = 0, Cs = 1, Di = 2, Il = 4, $i = 8, s0, d8 = /* @__PURE__ */ new Set(), f8 = /* @__PURE__ */ new Set(), t4 = /* @__PURE__ */ new Set(), m8 = /* @__PURE__ */ new Set(), Jc = 0, un = null, Ir = null, Ja = null, hw = !1, u0 = !1, Oh = !1, pw = 0, f1 = 0, Zc = null, uT = 0, cT = 25, Be = null, xs = null, ed = -1, m1 = !1, h1 = {
      readContext: cr,
      use: Is,
      useCallback: da,
      useContext: da,
      useEffect: da,
      useImperativeHandle: da,
      useLayoutEffect: da,
      useInsertionEffect: da,
      useMemo: da,
      useReducer: da,
      useRef: da,
      useState: da,
      useDebugValue: da,
      useDeferredValue: da,
      useTransition: da,
      useSyncExternalStore: da,
      useId: da,
      useHostTransitionStatus: da,
      useFormState: da,
      useActionState: da,
      useOptimistic: da,
      useMemoCache: da,
      useCacheRefresh: da
    };
    h1.useEffectEvent = da;
    var n4 = null, h8 = null, r4 = null, p8 = null, Uu = null, Zs = null, gw = null;
    n4 = {
      readContext: function(n) {
        return cr(n);
      },
      use: Is,
      useCallback: function(n, o) {
        return Be = "useCallback", sn(), js(o), jp(n, o);
      },
      useContext: function(n) {
        return Be = "useContext", sn(), cr(n);
      },
      useEffect: function(n, o) {
        return Be = "useEffect", sn(), js(o), Cc(n, o);
      },
      useImperativeHandle: function(n, o, s) {
        return Be = "useImperativeHandle", sn(), js(s), Ql(n, o, s);
      },
      useInsertionEffect: function(n, o) {
        Be = "useInsertionEffect", sn(), js(o), ku(4, Di, n, o);
      },
      useLayoutEffect: function(n, o) {
        return Be = "useLayoutEffect", sn(), js(o), Ho(n, o);
      },
      useMemo: function(n, o) {
        Be = "useMemo", sn(), js(o);
        var s = Xe.H;
        Xe.H = Uu;
        try {
          return Fo(n, o);
        } finally {
          Xe.H = s;
        }
      },
      useReducer: function(n, o, s) {
        Be = "useReducer", sn();
        var h = Xe.H;
        Xe.H = Uu;
        try {
          return Od(n, o, s);
        } finally {
          Xe.H = h;
        }
      },
      useRef: function(n) {
        return Be = "useRef", sn(), zp(n);
      },
      useState: function(n) {
        Be = "useState", sn();
        var o = Xe.H;
        Xe.H = Uu;
        try {
          return Cu(n);
        } finally {
          Xe.H = o;
        }
      },
      useDebugValue: function() {
        Be = "useDebugValue", sn();
      },
      useDeferredValue: function(n, o) {
        return Be = "useDeferredValue", sn(), Dd(n, o);
      },
      useTransition: function() {
        return Be = "useTransition", sn(), Mu();
      },
      useSyncExternalStore: function(n, o, s) {
        return Be = "useSyncExternalStore", sn(), Td(
          n,
          o,
          s
        );
      },
      useId: function() {
        return Be = "useId", sn(), Am();
      },
      useFormState: function(n, o) {
        return Be = "useFormState", sn(), wm(), Ci(n, o);
      },
      useActionState: function(n, o) {
        return Be = "useActionState", sn(), Ci(n, o);
      },
      useOptimistic: function(n) {
        return Be = "useOptimistic", sn(), Sc(n);
      },
      useHostTransitionStatus: Ws,
      useMemoCache: wi,
      useCacheRefresh: function() {
        return Be = "useCacheRefresh", sn(), Ip();
      },
      useEffectEvent: function(n) {
        return Be = "useEffectEvent", sn(), Tm(n);
      }
    }, h8 = {
      readContext: function(n) {
        return cr(n);
      },
      use: Is,
      useCallback: function(n, o) {
        return Be = "useCallback", rt(), jp(n, o);
      },
      useContext: function(n) {
        return Be = "useContext", rt(), cr(n);
      },
      useEffect: function(n, o) {
        return Be = "useEffect", rt(), Cc(n, o);
      },
      useImperativeHandle: function(n, o, s) {
        return Be = "useImperativeHandle", rt(), Ql(n, o, s);
      },
      useInsertionEffect: function(n, o) {
        Be = "useInsertionEffect", rt(), ku(4, Di, n, o);
      },
      useLayoutEffect: function(n, o) {
        return Be = "useLayoutEffect", rt(), Ho(n, o);
      },
      useMemo: function(n, o) {
        Be = "useMemo", rt();
        var s = Xe.H;
        Xe.H = Uu;
        try {
          return Fo(n, o);
        } finally {
          Xe.H = s;
        }
      },
      useReducer: function(n, o, s) {
        Be = "useReducer", rt();
        var h = Xe.H;
        Xe.H = Uu;
        try {
          return Od(n, o, s);
        } finally {
          Xe.H = h;
        }
      },
      useRef: function(n) {
        return Be = "useRef", rt(), zp(n);
      },
      useState: function(n) {
        Be = "useState", rt();
        var o = Xe.H;
        Xe.H = Uu;
        try {
          return Cu(n);
        } finally {
          Xe.H = o;
        }
      },
      useDebugValue: function() {
        Be = "useDebugValue", rt();
      },
      useDeferredValue: function(n, o) {
        return Be = "useDeferredValue", rt(), Dd(n, o);
      },
      useTransition: function() {
        return Be = "useTransition", rt(), Mu();
      },
      useSyncExternalStore: function(n, o, s) {
        return Be = "useSyncExternalStore", rt(), Td(
          n,
          o,
          s
        );
      },
      useId: function() {
        return Be = "useId", rt(), Am();
      },
      useActionState: function(n, o) {
        return Be = "useActionState", rt(), Ci(n, o);
      },
      useFormState: function(n, o) {
        return Be = "useFormState", rt(), wm(), Ci(n, o);
      },
      useOptimistic: function(n) {
        return Be = "useOptimistic", rt(), Sc(n);
      },
      useHostTransitionStatus: Ws,
      useMemoCache: wi,
      useCacheRefresh: function() {
        return Be = "useCacheRefresh", rt(), Ip();
      },
      useEffectEvent: function(n) {
        return Be = "useEffectEvent", rt(), Tm(n);
      }
    }, r4 = {
      readContext: function(n) {
        return cr(n);
      },
      use: Is,
      useCallback: function(n, o) {
        return Be = "useCallback", rt(), xl(n, o);
      },
      useContext: function(n) {
        return Be = "useContext", rt(), cr(n);
      },
      useEffect: function(n, o) {
        Be = "useEffect", rt(), za(2048, $i, n, o);
      },
      useImperativeHandle: function(n, o, s) {
        return Be = "useImperativeHandle", rt(), Nd(n, o, s);
      },
      useInsertionEffect: function(n, o) {
        return Be = "useInsertionEffect", rt(), za(4, Di, n, o);
      },
      useLayoutEffect: function(n, o) {
        return Be = "useLayoutEffect", rt(), za(4, Il, n, o);
      },
      useMemo: function(n, o) {
        Be = "useMemo", rt();
        var s = Xe.H;
        Xe.H = Zs;
        try {
          return Br(n, o);
        } finally {
          Xe.H = s;
        }
      },
      useReducer: function(n, o, s) {
        Be = "useReducer", rt();
        var h = Xe.H;
        Xe.H = Zs;
        try {
          return bc(n, o, s);
        } finally {
          Xe.H = h;
        }
      },
      useRef: function() {
        return Be = "useRef", rt(), gr().memoizedState;
      },
      useState: function() {
        Be = "useState", rt();
        var n = Xe.H;
        Xe.H = Zs;
        try {
          return bc(Si);
        } finally {
          Xe.H = n;
        }
      },
      useDebugValue: function() {
        Be = "useDebugValue", rt();
      },
      useDeferredValue: function(n, o) {
        return Be = "useDeferredValue", rt(), Jl(n, o);
      },
      useTransition: function() {
        return Be = "useTransition", rt(), Ub();
      },
      useSyncExternalStore: function(n, o, s) {
        return Be = "useSyncExternalStore", rt(), wc(
          n,
          o,
          s
        );
      },
      useId: function() {
        return Be = "useId", rt(), gr().memoizedState;
      },
      useFormState: function(n) {
        return Be = "useFormState", rt(), wm(), Eu(n);
      },
      useActionState: function(n) {
        return Be = "useActionState", rt(), Eu(n);
      },
      useOptimistic: function(n, o) {
        return Be = "useOptimistic", rt(), km(n, o);
      },
      useHostTransitionStatus: Ws,
      useMemoCache: wi,
      useCacheRefresh: function() {
        return Be = "useCacheRefresh", rt(), gr().memoizedState;
      },
      useEffectEvent: function(n) {
        return Be = "useEffectEvent", rt(), Ad(n);
      }
    }, p8 = {
      readContext: function(n) {
        return cr(n);
      },
      use: Is,
      useCallback: function(n, o) {
        return Be = "useCallback", rt(), xl(n, o);
      },
      useContext: function(n) {
        return Be = "useContext", rt(), cr(n);
      },
      useEffect: function(n, o) {
        Be = "useEffect", rt(), za(2048, $i, n, o);
      },
      useImperativeHandle: function(n, o, s) {
        return Be = "useImperativeHandle", rt(), Nd(n, o, s);
      },
      useInsertionEffect: function(n, o) {
        return Be = "useInsertionEffect", rt(), za(4, Di, n, o);
      },
      useLayoutEffect: function(n, o) {
        return Be = "useLayoutEffect", rt(), za(4, Il, n, o);
      },
      useMemo: function(n, o) {
        Be = "useMemo", rt();
        var s = Xe.H;
        Xe.H = gw;
        try {
          return Br(n, o);
        } finally {
          Xe.H = s;
        }
      },
      useReducer: function(n, o, s) {
        Be = "useReducer", rt();
        var h = Xe.H;
        Xe.H = gw;
        try {
          return yc(n, o, s);
        } finally {
          Xe.H = h;
        }
      },
      useRef: function() {
        return Be = "useRef", rt(), gr().memoizedState;
      },
      useState: function() {
        Be = "useState", rt();
        var n = Xe.H;
        Xe.H = gw;
        try {
          return yc(Si);
        } finally {
          Xe.H = n;
        }
      },
      useDebugValue: function() {
        Be = "useDebugValue", rt();
      },
      useDeferredValue: function(n, o) {
        return Be = "useDeferredValue", rt(), Sn(n, o);
      },
      useTransition: function() {
        return Be = "useTransition", rt(), Zr();
      },
      useSyncExternalStore: function(n, o, s) {
        return Be = "useSyncExternalStore", rt(), wc(
          n,
          o,
          s
        );
      },
      useId: function() {
        return Be = "useId", rt(), gr().memoizedState;
      },
      useFormState: function(n) {
        return Be = "useFormState", rt(), wm(), Pu(n);
      },
      useActionState: function(n) {
        return Be = "useActionState", rt(), Pu(n);
      },
      useOptimistic: function(n, o) {
        return Be = "useOptimistic", rt(), Mm(n, o);
      },
      useHostTransitionStatus: Ws,
      useMemoCache: wi,
      useCacheRefresh: function() {
        return Be = "useCacheRefresh", rt(), gr().memoizedState;
      },
      useEffectEvent: function(n) {
        return Be = "useEffectEvent", rt(), Ad(n);
      }
    }, Uu = {
      readContext: function(n) {
        return p(), cr(n);
      },
      use: function(n) {
        return f(), Is(n);
      },
      useCallback: function(n, o) {
        return Be = "useCallback", f(), sn(), jp(n, o);
      },
      useContext: function(n) {
        return Be = "useContext", f(), sn(), cr(n);
      },
      useEffect: function(n, o) {
        return Be = "useEffect", f(), sn(), Cc(n, o);
      },
      useImperativeHandle: function(n, o, s) {
        return Be = "useImperativeHandle", f(), sn(), Ql(n, o, s);
      },
      useInsertionEffect: function(n, o) {
        Be = "useInsertionEffect", f(), sn(), ku(4, Di, n, o);
      },
      useLayoutEffect: function(n, o) {
        return Be = "useLayoutEffect", f(), sn(), Ho(n, o);
      },
      useMemo: function(n, o) {
        Be = "useMemo", f(), sn();
        var s = Xe.H;
        Xe.H = Uu;
        try {
          return Fo(n, o);
        } finally {
          Xe.H = s;
        }
      },
      useReducer: function(n, o, s) {
        Be = "useReducer", f(), sn();
        var h = Xe.H;
        Xe.H = Uu;
        try {
          return Od(n, o, s);
        } finally {
          Xe.H = h;
        }
      },
      useRef: function(n) {
        return Be = "useRef", f(), sn(), zp(n);
      },
      useState: function(n) {
        Be = "useState", f(), sn();
        var o = Xe.H;
        Xe.H = Uu;
        try {
          return Cu(n);
        } finally {
          Xe.H = o;
        }
      },
      useDebugValue: function() {
        Be = "useDebugValue", f(), sn();
      },
      useDeferredValue: function(n, o) {
        return Be = "useDeferredValue", f(), sn(), Dd(n, o);
      },
      useTransition: function() {
        return Be = "useTransition", f(), sn(), Mu();
      },
      useSyncExternalStore: function(n, o, s) {
        return Be = "useSyncExternalStore", f(), sn(), Td(
          n,
          o,
          s
        );
      },
      useId: function() {
        return Be = "useId", f(), sn(), Am();
      },
      useFormState: function(n, o) {
        return Be = "useFormState", f(), sn(), Ci(n, o);
      },
      useActionState: function(n, o) {
        return Be = "useActionState", f(), sn(), Ci(n, o);
      },
      useOptimistic: function(n) {
        return Be = "useOptimistic", f(), sn(), Sc(n);
      },
      useMemoCache: function(n) {
        return f(), wi(n);
      },
      useHostTransitionStatus: Ws,
      useCacheRefresh: function() {
        return Be = "useCacheRefresh", sn(), Ip();
      },
      useEffectEvent: function(n) {
        return Be = "useEffectEvent", f(), sn(), Tm(n);
      }
    }, Zs = {
      readContext: function(n) {
        return p(), cr(n);
      },
      use: function(n) {
        return f(), Is(n);
      },
      useCallback: function(n, o) {
        return Be = "useCallback", f(), rt(), xl(n, o);
      },
      useContext: function(n) {
        return Be = "useContext", f(), rt(), cr(n);
      },
      useEffect: function(n, o) {
        Be = "useEffect", f(), rt(), za(2048, $i, n, o);
      },
      useImperativeHandle: function(n, o, s) {
        return Be = "useImperativeHandle", f(), rt(), Nd(n, o, s);
      },
      useInsertionEffect: function(n, o) {
        return Be = "useInsertionEffect", f(), rt(), za(4, Di, n, o);
      },
      useLayoutEffect: function(n, o) {
        return Be = "useLayoutEffect", f(), rt(), za(4, Il, n, o);
      },
      useMemo: function(n, o) {
        Be = "useMemo", f(), rt();
        var s = Xe.H;
        Xe.H = Zs;
        try {
          return Br(n, o);
        } finally {
          Xe.H = s;
        }
      },
      useReducer: function(n, o, s) {
        Be = "useReducer", f(), rt();
        var h = Xe.H;
        Xe.H = Zs;
        try {
          return bc(n, o, s);
        } finally {
          Xe.H = h;
        }
      },
      useRef: function() {
        return Be = "useRef", f(), rt(), gr().memoizedState;
      },
      useState: function() {
        Be = "useState", f(), rt();
        var n = Xe.H;
        Xe.H = Zs;
        try {
          return bc(Si);
        } finally {
          Xe.H = n;
        }
      },
      useDebugValue: function() {
        Be = "useDebugValue", f(), rt();
      },
      useDeferredValue: function(n, o) {
        return Be = "useDeferredValue", f(), rt(), Jl(n, o);
      },
      useTransition: function() {
        return Be = "useTransition", f(), rt(), Ub();
      },
      useSyncExternalStore: function(n, o, s) {
        return Be = "useSyncExternalStore", f(), rt(), wc(
          n,
          o,
          s
        );
      },
      useId: function() {
        return Be = "useId", f(), rt(), gr().memoizedState;
      },
      useFormState: function(n) {
        return Be = "useFormState", f(), rt(), Eu(n);
      },
      useActionState: function(n) {
        return Be = "useActionState", f(), rt(), Eu(n);
      },
      useOptimistic: function(n, o) {
        return Be = "useOptimistic", f(), rt(), km(n, o);
      },
      useMemoCache: function(n) {
        return f(), wi(n);
      },
      useHostTransitionStatus: Ws,
      useCacheRefresh: function() {
        return Be = "useCacheRefresh", rt(), gr().memoizedState;
      },
      useEffectEvent: function(n) {
        return Be = "useEffectEvent", f(), rt(), Ad(n);
      }
    }, gw = {
      readContext: function(n) {
        return p(), cr(n);
      },
      use: function(n) {
        return f(), Is(n);
      },
      useCallback: function(n, o) {
        return Be = "useCallback", f(), rt(), xl(n, o);
      },
      useContext: function(n) {
        return Be = "useContext", f(), rt(), cr(n);
      },
      useEffect: function(n, o) {
        Be = "useEffect", f(), rt(), za(2048, $i, n, o);
      },
      useImperativeHandle: function(n, o, s) {
        return Be = "useImperativeHandle", f(), rt(), Nd(n, o, s);
      },
      useInsertionEffect: function(n, o) {
        return Be = "useInsertionEffect", f(), rt(), za(4, Di, n, o);
      },
      useLayoutEffect: function(n, o) {
        return Be = "useLayoutEffect", f(), rt(), za(4, Il, n, o);
      },
      useMemo: function(n, o) {
        Be = "useMemo", f(), rt();
        var s = Xe.H;
        Xe.H = Zs;
        try {
          return Br(n, o);
        } finally {
          Xe.H = s;
        }
      },
      useReducer: function(n, o, s) {
        Be = "useReducer", f(), rt();
        var h = Xe.H;
        Xe.H = Zs;
        try {
          return yc(n, o, s);
        } finally {
          Xe.H = h;
        }
      },
      useRef: function() {
        return Be = "useRef", f(), rt(), gr().memoizedState;
      },
      useState: function() {
        Be = "useState", f(), rt();
        var n = Xe.H;
        Xe.H = Zs;
        try {
          return yc(Si);
        } finally {
          Xe.H = n;
        }
      },
      useDebugValue: function() {
        Be = "useDebugValue", f(), rt();
      },
      useDeferredValue: function(n, o) {
        return Be = "useDeferredValue", f(), rt(), Sn(n, o);
      },
      useTransition: function() {
        return Be = "useTransition", f(), rt(), Zr();
      },
      useSyncExternalStore: function(n, o, s) {
        return Be = "useSyncExternalStore", f(), rt(), wc(
          n,
          o,
          s
        );
      },
      useId: function() {
        return Be = "useId", f(), rt(), gr().memoizedState;
      },
      useFormState: function(n) {
        return Be = "useFormState", f(), rt(), Pu(n);
      },
      useActionState: function(n) {
        return Be = "useActionState", f(), rt(), Pu(n);
      },
      useOptimistic: function(n, o) {
        return Be = "useOptimistic", f(), rt(), Mm(n, o);
      },
      useMemoCache: function(n) {
        return f(), wi(n);
      },
      useHostTransitionStatus: Ws,
      useCacheRefresh: function() {
        return Be = "useCacheRefresh", rt(), gr().memoizedState;
      },
      useEffectEvent: function(n) {
        return Be = "useEffectEvent", f(), rt(), Ad(n);
      }
    };
    var g8 = {}, v8 = /* @__PURE__ */ new Set(), b8 = /* @__PURE__ */ new Set(), y8 = /* @__PURE__ */ new Set(), w8 = /* @__PURE__ */ new Set(), S8 = /* @__PURE__ */ new Set(), C8 = /* @__PURE__ */ new Set(), x8 = /* @__PURE__ */ new Set(), E8 = /* @__PURE__ */ new Set(), P8 = /* @__PURE__ */ new Set(), k8 = /* @__PURE__ */ new Set();
    Object.freeze(g8);
    var a4 = {
      enqueueSetState: function(n, o, s) {
        n = n._reactInternals;
        var h = xo(n), y = $a(h);
        y.payload = o, s != null && (kc(s), y.callback = s), o = Gl(n, y, h), o !== null && (Bl(h, "this.setState()", n), ln(o, n, h), Ji(o, n, h));
      },
      enqueueReplaceState: function(n, o, s) {
        n = n._reactInternals;
        var h = xo(n), y = $a(h);
        y.tag = s8, y.payload = o, s != null && (kc(s), y.callback = s), o = Gl(n, y, h), o !== null && (Bl(h, "this.replaceState()", n), ln(o, n, h), Ji(o, n, h));
      },
      enqueueForceUpdate: function(n, o) {
        n = n._reactInternals;
        var s = xo(n), h = $a(s);
        h.tag = u8, o != null && (kc(o), h.callback = o), o = Gl(n, h, s), o !== null && (Bl(s, "this.forceUpdate()", n), ln(o, n, s), Ji(o, n, s));
      }
    }, c0 = null, o4 = null, i4 = Error(
      "This is not a real error. It's an implementation detail of React's selective hydration feature. If this leaks into userspace, it's a bug in React. Please file an issue."
    ), Za = !1, M8 = {}, O8 = {}, T8 = {}, R8 = {}, d0 = !1, A8 = {}, vw = {}, l4 = {
      dehydrated: null,
      treeContext: null,
      retryLane: 0,
      hydrationErrors: null
    }, N8 = !1, D8 = null;
    D8 = /* @__PURE__ */ new Set();
    var td = !1, eo = !1, s4 = !1, $8 = typeof WeakSet == "function" ? WeakSet : Set, Mo = null, f0 = null, m0 = null, to = null, al = !1, eu = null, ho = !1, p1 = 8192, dT = {
      getCacheForType: function(n) {
        var o = cr(Ya), s = o.data.get(n);
        return s === void 0 && (s = n(), o.data.set(n, s)), s;
      },
      cacheSignal: function() {
        return cr(Ya).controller.signal;
      },
      getOwner: function() {
        return oi;
      }
    };
    if (typeof Symbol == "function" && Symbol.for) {
      var g1 = Symbol.for;
      g1("selector.component"), g1("selector.has_pseudo_class"), g1("selector.role"), g1("selector.test_id"), g1("selector.text");
    }
    var fT = [], mT = typeof WeakMap == "function" ? WeakMap : Map, Oo = 0, po = 2, Ll = 4, nd = 0, v1 = 1, Th = 2, bw = 3, Of = 4, yw = 6, z8 = 5, ar = Oo, Lr = null, Ln = null, Dn = 0, ol = 0, ww = 1, Rh = 2, b1 = 3, j8 = 4, u4 = 5, y1 = 6, Sw = 7, c4 = 8, Ah = 9, Tr = ol, Hl = null, Tf = !1, h0 = !1, d4 = !1, Xu = 0, ha = nd, Rf = 0, Af = 0, f4 = 0, il = 0, Nh = 0, w1 = null, zi = null, Cw = !1, xw = 0, I8 = 0, L8 = 300, Ew = 1 / 0, H8 = 500, S1 = null, Ra = null, Nf = null, Pw = 0, m4 = 1, h4 = 2, F8 = 3, Df = 0, W8 = 1, V8 = 2, _8 = 3, B8 = 4, kw = 5, no = 0, $f = null, p0 = null, tu = 0, p4 = 0, g4 = -0, v4 = null, U8 = null, X8 = null, nu = Pw, G8 = null, hT = 50, C1 = 0, b4 = null, y4 = !1, Mw = !1, pT = 50, Dh = 0, x1 = null, g0 = !1, Ow = null, q8 = !1, K8 = /* @__PURE__ */ new Set(), gT = {}, Tw = null, v0 = null, w4 = !1, S4 = !1, Rw = !1, C4 = !1, zf = 0, x4 = {};
    (function() {
      for (var n = 0; n < $C.length; n++) {
        var o = $C[n], s = o.toLowerCase();
        o = o[0].toUpperCase() + o.slice(1), ml(s, "on" + o);
      }
      ml(k6, "onAnimationEnd"), ml(M6, "onAnimationIteration"), ml(O6, "onAnimationStart"), ml("dblclick", "onDoubleClick"), ml("focusin", "onFocus"), ml("focusout", "onBlur"), ml(BO, "onTransitionRun"), ml(UO, "onTransitionStart"), ml(XO, "onTransitionCancel"), ml(T6, "onTransitionEnd");
    })(), an("onMouseEnter", ["mouseout", "mouseover"]), an("onMouseLeave", ["mouseout", "mouseover"]), an("onPointerEnter", ["pointerout", "pointerover"]), an("onPointerLeave", ["pointerout", "pointerover"]), hn(
      "onChange",
      "change click focusin focusout input keydown keyup selectionchange".split(
        " "
      )
    ), hn(
      "onSelect",
      "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
        " "
      )
    ), hn("onBeforeInput", [
      "compositionend",
      "keypress",
      "textInput",
      "paste"
    ]), hn(
      "onCompositionEnd",
      "compositionend focusout keydown keypress keyup mousedown".split(" ")
    ), hn(
      "onCompositionStart",
      "compositionstart focusout keydown keypress keyup mousedown".split(" ")
    ), hn(
      "onCompositionUpdate",
      "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
    );
    var E1 = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
      " "
    ), E4 = new Set(
      "beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(E1)
    ), Aw = "_reactListening" + Math.random().toString(36).slice(2), Y8 = !1, Q8 = !1, Nw = !1, J8 = !1, Dw = !1, $w = !1, Z8 = !1, zw = {}, vT = /\r\n?/g, bT = /\u0000|\uFFFD/g, $h = "http://www.w3.org/1999/xlink", P4 = "http://www.w3.org/XML/1998/namespace", yT = "javascript:throw new Error('React form unexpectedly submitted.')", wT = "suppressHydrationWarning", zh = "&", jw = "/&", P1 = "$", k1 = "/$", jf = "$?", jh = "$~", b0 = "$!", ST = "html", CT = "body", xT = "head", k4 = "F!", e5 = "F", t5 = "loading", ET = "style", dd = 0, y0 = 1, Iw = 2, M4 = null, O4 = null, n5 = { dialog: !0, webview: !0 }, T4 = null, M1 = void 0, r5 = typeof setTimeout == "function" ? setTimeout : void 0, PT = typeof clearTimeout == "function" ? clearTimeout : void 0, Ih = -1, a5 = typeof Promise == "function" ? Promise : void 0, kT = typeof queueMicrotask == "function" ? queueMicrotask : typeof a5 < "u" ? function(n) {
      return a5.resolve(null).then(n).catch(my);
    } : r5, R4 = null, Lh = 0, O1 = 1, o5 = 2, i5 = 3, Es = 4, Ps = /* @__PURE__ */ new Map(), l5 = /* @__PURE__ */ new Set(), rd = fr.d;
    fr.d = {
      f: function() {
        var n = rd.f(), o = ki();
        return n || o;
      },
      r: function(n) {
        var o = bt(n);
        o !== null && o.tag === 5 && o.type === "form" ? $d(o) : rd.r(n);
      },
      D: function(n) {
        rd.D(n), p2("dns-prefetch", n, null);
      },
      C: function(n, o) {
        rd.C(n, o), p2("preconnect", n, o);
      },
      L: function(n, o, s) {
        rd.L(n, o, s);
        var h = w0;
        if (h && n && o) {
          var y = 'link[rel="preload"][as="' + Gt(o) + '"]';
          o === "image" && s && s.imageSrcSet ? (y += '[imagesrcset="' + Gt(
            s.imageSrcSet
          ) + '"]', typeof s.imageSizes == "string" && (y += '[imagesizes="' + Gt(
            s.imageSizes
          ) + '"]')) : y += '[href="' + Gt(n) + '"]';
          var C = y;
          switch (o) {
            case "style":
              C = jc(n);
              break;
            case "script":
              C = Ic(n);
          }
          Ps.has(C) || (n = Rn(
            {
              rel: "preload",
              href: o === "image" && s && s.imageSrcSet ? void 0 : n,
              as: o
            },
            s
          ), Ps.set(C, n), h.querySelector(y) !== null || o === "style" && h.querySelector(
            rh(C)
          ) || o === "script" && h.querySelector(ah(C)) || (o = h.createElement("link"), Ur(o, "link", n), Pt(o), h.head.appendChild(o)));
        }
      },
      m: function(n, o) {
        rd.m(n, o);
        var s = w0;
        if (s && n) {
          var h = o && typeof o.as == "string" ? o.as : "script", y = 'link[rel="modulepreload"][as="' + Gt(h) + '"][href="' + Gt(n) + '"]', C = y;
          switch (h) {
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
              C = Ic(n);
          }
          if (!Ps.has(C) && (n = Rn({ rel: "modulepreload", href: n }, o), Ps.set(C, n), s.querySelector(y) === null)) {
            switch (h) {
              case "audioworklet":
              case "paintworklet":
              case "serviceworker":
              case "sharedworker":
              case "worker":
              case "script":
                if (s.querySelector(ah(C)))
                  return;
            }
            h = s.createElement("link"), Ur(h, "link", n), Pt(h), s.head.appendChild(h);
          }
        }
      },
      X: function(n, o) {
        rd.X(n, o);
        var s = w0;
        if (s && n) {
          var h = $t(s).hoistableScripts, y = Ic(n), C = h.get(y);
          C || (C = s.querySelector(
            ah(y)
          ), C || (n = Rn({ src: n, async: !0 }, o), (o = Ps.get(y)) && b2(n, o), C = s.createElement("script"), Pt(C), Ur(C, "link", n), s.head.appendChild(C)), C = {
            type: "script",
            instance: C,
            count: 1,
            state: null
          }, h.set(y, C));
        }
      },
      S: function(n, o, s) {
        rd.S(n, o, s);
        var h = w0;
        if (h && n) {
          var y = $t(h).hoistableStyles, C = jc(n);
          o = o || "default";
          var A = y.get(C);
          if (!A) {
            var z = { loading: Lh, preload: null };
            if (A = h.querySelector(
              rh(C)
            ))
              z.loading = O1 | Es;
            else {
              n = Rn(
                {
                  rel: "stylesheet",
                  href: n,
                  "data-precedence": o
                },
                s
              ), (s = Ps.get(C)) && v2(n, s);
              var q = A = h.createElement("link");
              Pt(q), Ur(q, "link", n), q._p = new Promise(function(Z, xe) {
                q.onload = Z, q.onerror = xe;
              }), q.addEventListener("load", function() {
                z.loading |= O1;
              }), q.addEventListener("error", function() {
                z.loading |= o5;
              }), z.loading |= Es, tf(A, o, h);
            }
            A = {
              type: "stylesheet",
              instance: A,
              count: 1,
              state: z
            }, y.set(C, A);
          }
        }
      },
      M: function(n, o) {
        rd.M(n, o);
        var s = w0;
        if (s && n) {
          var h = $t(s).hoistableScripts, y = Ic(n), C = h.get(y);
          C || (C = s.querySelector(
            ah(y)
          ), C || (n = Rn({ src: n, async: !0, type: "module" }, o), (o = Ps.get(y)) && b2(n, o), C = s.createElement("script"), Pt(C), Ur(C, "link", n), s.head.appendChild(C)), C = {
            type: "script",
            instance: C,
            count: 1,
            state: null
          }, h.set(y, C));
        }
      }
    };
    var w0 = typeof document > "u" ? null : document, Lw = null, MT = 6e4, OT = 800, TT = 500, A4 = 0, N4 = null, Hw = null, Hh = CC, T1 = {
      $$typeof: Nl,
      Provider: null,
      Consumer: null,
      _currentValue: Hh,
      _currentValue2: Hh,
      _threadCount: 0
    }, s5 = "%c%s%c", u5 = "background: #e6e6e6;background: light-dark(rgba(0,0,0,0.1), rgba(255,255,255,0.25));color: #000000;color: light-dark(#000000, #ffffff);border-radius: 2px", c5 = "", Fw = " ", RT = Function.prototype.bind, d5 = !1, f5 = null, m5 = null, h5 = null, p5 = null, g5 = null, v5 = null, b5 = null, y5 = null, w5 = null, S5 = null;
    f5 = function(n, o, s, h) {
      o = e(n, o), o !== null && (s = t(o.memoizedState, s, 0, h), o.memoizedState = s, o.baseState = s, n.memoizedProps = Rn({}, n.memoizedProps), s = So(n, 2), s !== null && ln(s, n, 2));
    }, m5 = function(n, o, s) {
      o = e(n, o), o !== null && (s = i(o.memoizedState, s, 0), o.memoizedState = s, o.baseState = s, n.memoizedProps = Rn({}, n.memoizedProps), s = So(n, 2), s !== null && ln(s, n, 2));
    }, h5 = function(n, o, s, h) {
      o = e(n, o), o !== null && (s = r(o.memoizedState, s, h), o.memoizedState = s, o.baseState = s, n.memoizedProps = Rn({}, n.memoizedProps), s = So(n, 2), s !== null && ln(s, n, 2));
    }, p5 = function(n, o, s) {
      n.pendingProps = t(n.memoizedProps, o, 0, s), n.alternate && (n.alternate.pendingProps = n.pendingProps), o = So(n, 2), o !== null && ln(o, n, 2);
    }, g5 = function(n, o) {
      n.pendingProps = i(n.memoizedProps, o, 0), n.alternate && (n.alternate.pendingProps = n.pendingProps), o = So(n, 2), o !== null && ln(o, n, 2);
    }, v5 = function(n, o, s) {
      n.pendingProps = r(
        n.memoizedProps,
        o,
        s
      ), n.alternate && (n.alternate.pendingProps = n.pendingProps), o = So(n, 2), o !== null && ln(o, n, 2);
    }, b5 = function(n) {
      var o = So(n, 2);
      o !== null && ln(o, n, 2);
    }, y5 = function(n) {
      var o = dt(), s = So(n, o);
      s !== null && ln(s, n, o);
    }, w5 = function(n) {
      d = n;
    }, S5 = function(n) {
      c = n;
    };
    var Ww = !0, Vw = null, D4 = !1, If = null, Lf = null, Hf = null, R1 = /* @__PURE__ */ new Map(), A1 = /* @__PURE__ */ new Map(), Ff = [], AT = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
      " "
    ), _w = null;
    if (Al.prototype.render = O2.prototype.render = function(n) {
      var o = this._internalRoot;
      if (o === null) throw Error("Cannot update an unmounted root.");
      var s = arguments;
      typeof s[1] == "function" ? console.error(
        "does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect()."
      ) : M(s[1]) ? console.error(
        "You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root."
      ) : typeof s[1] < "u" && console.error(
        "You passed a second argument to root.render(...) but it only accepts one argument."
      ), s = n;
      var h = o.current, y = xo(h);
      Mg(h, y, s, o, null, null);
    }, Al.prototype.unmount = O2.prototype.unmount = function() {
      var n = arguments;
      if (typeof n[0] == "function" && console.error(
        "does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect()."
      ), n = this._internalRoot, n !== null) {
        this._internalRoot = null;
        var o = n.containerInfo;
        (ar & (po | Ll)) !== Oo && console.error(
          "Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."
        ), Mg(n.current, 2, null, n, null, null), ki(), o[Ys] = null;
      }
    }, Al.prototype.unstable_scheduleHydration = function(n) {
      if (n) {
        var o = at();
        n = { blockedOn: null, target: n, priority: o };
        for (var s = 0; s < Ff.length && o !== 0 && o < Ff[s].priority; s++) ;
        Ff.splice(s, 0, n), s === 0 && M2(n);
      }
    }, (function() {
      var n = uh.version;
      if (n !== "19.2.4")
        throw Error(
          `Incompatible React versions: The "react" and "react-dom" packages must have the exact same version. Instead got:
  - react:      ` + (n + `
  - react-dom:  19.2.4
Learn more: https://react.dev/warnings/version-mismatch`)
        );
    })(), typeof Map == "function" && Map.prototype != null && typeof Map.prototype.forEach == "function" && typeof Set == "function" && Set.prototype != null && typeof Set.prototype.clear == "function" && typeof Set.prototype.forEach == "function" || console.error(
      "React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://react.dev/link/react-polyfills"
    ), fr.findDOMNode = function(n) {
      var o = n._reactInternals;
      if (o === void 0)
        throw typeof n.render == "function" ? Error("Unable to find node on an unmounted component.") : (n = Object.keys(n).join(","), Error(
          "Argument appears to not be a ReactComponent. Keys: " + n
        ));
      return n = j(o), n = n !== null ? I(n) : null, n = n === null ? null : n.stateNode, n;
    }, !(function() {
      var n = {
        bundleType: 1,
        version: "19.2.4",
        rendererPackageName: "react-dom",
        currentDispatcherRef: Xe,
        reconcilerVersion: "19.2.4"
      };
      return n.overrideHookState = f5, n.overrideHookStateDeletePath = m5, n.overrideHookStateRenamePath = h5, n.overrideProps = p5, n.overridePropsDeletePath = g5, n.overridePropsRenamePath = v5, n.scheduleUpdate = b5, n.scheduleRetry = y5, n.setErrorHandler = w5, n.setSuspenseHandler = S5, n.scheduleRefresh = P, n.scheduleRoot = E, n.setRefreshHandler = k, n.getCurrentFiber = Mr, Te(n);
    })() && Vu && window.top === window.self && (-1 < navigator.userAgent.indexOf("Chrome") && navigator.userAgent.indexOf("Edge") === -1 || -1 < navigator.userAgent.indexOf("Firefox"))) {
      var C5 = window.location.protocol;
      /^(https?|file):$/.test(C5) && console.info(
        "%cDownload the React DevTools for a better development experience: https://react.dev/link/react-devtools" + (C5 === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://react.dev/link/react-devtools-faq` : ""),
        "font-weight:bold"
      );
    }
    A5.createRoot = function(n, o) {
      if (!M(n))
        throw Error("Target container is not a DOM element.");
      T2(n);
      var s = !1, h = "", y = Fp, C = Wp, A = xv;
      return o != null && (o.hydrate ? console.warn(
        "hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead."
      ) : typeof o == "object" && o !== null && o.$$typeof === nl && console.error(
        `You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`
      ), o.unstable_strictMode === !0 && (s = !0), o.identifierPrefix !== void 0 && (h = o.identifierPrefix), o.onUncaughtError !== void 0 && (y = o.onUncaughtError), o.onCaughtError !== void 0 && (C = o.onCaughtError), o.onRecoverableError !== void 0 && (A = o.onRecoverableError)), o = lh(
        n,
        1,
        !1,
        null,
        null,
        s,
        h,
        null,
        y,
        C,
        A,
        Iy
      ), n[Ys] = o.current, $u(n), new O2(o);
    }, A5.hydrateRoot = function(n, o, s) {
      if (!M(n))
        throw Error("Target container is not a DOM element.");
      T2(n), o === void 0 && console.error(
        "Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)"
      );
      var h = !1, y = "", C = Fp, A = Wp, z = xv, q = null;
      return s != null && (s.unstable_strictMode === !0 && (h = !0), s.identifierPrefix !== void 0 && (y = s.identifierPrefix), s.onUncaughtError !== void 0 && (C = s.onUncaughtError), s.onCaughtError !== void 0 && (A = s.onCaughtError), s.onRecoverableError !== void 0 && (z = s.onRecoverableError), s.formState !== void 0 && (q = s.formState)), o = lh(
        n,
        1,
        !0,
        o,
        s ?? null,
        h,
        y,
        q,
        C,
        A,
        z,
        Iy
      ), o.context = Dy(null), s = o.current, h = xo(s), h = Ct(h), y = $a(h), y.callback = null, Gl(s, y, h), Bl(h, "hydrateRoot()", null), s = h, o.current.lanes = s, mt(o, s), ti(o), n[Ys] = o.current, $u(n), new Al(o);
    }, A5.version = "19.2.4", typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), A5;
}
var AV;
function Fxe() {
  if (AV) return Z7.exports;
  AV = 1;
  function e() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
      if (process.env.NODE_ENV !== "production")
        throw new Error("^_^");
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e);
      } catch (t) {
        console.error(t);
      }
    }
  }
  return process.env.NODE_ENV === "production" ? (e(), Z7.exports = Lxe()) : Z7.exports = Hxe(), Z7.exports;
}
var Wxe = Fxe();
Fz(function(e, t) {
  t._reactRoot || (t._reactRoot = Wxe.createRoot(t));
  var r = t._reactRoot;
  return r.render(e), function() {
    return new Promise(function(a) {
      setTimeout(function() {
        r.unmount(), a();
      }, 0);
    });
  };
});
const Vxe = {
  uikit: {
    alertBanner: {
      close: "Close"
    }
  }
}, _xe = {
  uikit: {
    capsHeader: {
      logo: {
        "alt.text": "Dealer Portal",
        label: "Go to Dealer Portal"
      },
      loading: "Loading...",
      user: "Welcome {{userName}} {{userRole}} - {{dealerLongName}} ({{dealerShortName}})",
      unproxy: "Unproxy",
      changeDealership: "Change Dealership",
      inventoryIssues: "Inventory Issues ({{inventoryIssueCount}})",
      signout: "Sign Out",
      navItem: {
        home: "Home",
        leads: "Leads",
        deals: "Deals",
        approvals: {
          new: "New Approval",
          process: "Approvals in Process"
        },
        contracts: "Contracts in Process",
        collections: "Collection Connection",
        account: {
          status: "Obtain Account Status",
          payments: "Record Account Payments",
          info: "Provide Account Info"
        },
        dispositions: "Disposition Descriptions",
        vehicles: {
          menu: "Vehicles",
          add: "Add Vehicle",
          all: "View All Vehicles"
        },
        inventory: "Review Inventory Issues",
        benefits: {
          menu: "Benefits",
          poolPurchaseOffers: "Pool Purchase Offers",
          loyaltyBenefits: "Loyalty Benefits"
        },
        resources: "Resources",
        settings: "Settings",
        profile: "Dealer Profile",
        user: "User Setup",
        password: "Change Password",
        applications: "Create Applications",
        contact: "Contact Us",
        customerTools: "Customer Tools",
        notifications: "Notifications",
        salesTools: "Sales Tools",
        inbox: "Inbox"
      },
      mobile: {
        menu: {
          open: "Open menu",
          close: "Close menu"
        }
      }
    },
    noAccessModal: {
      message: "You do not have access to this screen. Please contact your Dealership's CAPS Administrator",
      ok: "OK",
      header: "CAPS WARNING"
    }
  }
}, Bxe = {
  uikit: {
    dealerPageFooter: {
      terms: "<1>Terms</1> under which the CAPS system is provided for your use.",
      copyright: "© 2012 - {{currentYear}} Copyright Credit Acceptance Corporation. All Rights Reserved.",
      californiaResidentNotice: "California Residents: Please click <1>here</1> and select the link for the Notice of Collection on the first page of the California Consumer Privacy Policy for the notice regarding the personal information Credit Acceptance may collect from you."
    }
  }
}, Uxe = {
  uikit: {
    errorBoundary: {
      somethingWentWrong: "Oops! Something went wrong",
      contactSupportText: "We apologize for the inconvenience. Please try refreshing the page or contact support if the issue persists.",
      refreshPage: "Refresh page"
    }
  }
}, Xxe = {
  uikit: {
    datepicker: {
      "select.date": "Select date",
      today: "Today"
    },
    monthpicker: {
      "select.month": "Select month"
    }
  }
}, Gxe = {
  uikit: {
    input: {
      clearButtonLabel: "Clear input",
      clearButtonIconLabel: "Close circle"
    }
  }
}, qxe = {
  uikit: {
    removeXItem: "Remove {{item}}",
    removeSelectedItem: "Remove selected item",
    noData: "No data"
  }
}, Kxe = {
  uikit: {
    inputSet: {
      addInput: "Add Input",
      removeInput: "Remove Input"
    }
  }
}, Yxe = {
  uikit: {
    loading: {
      default: "Loading..."
    }
  }
}, Qxe = {
  uikit: {
    modal: {
      close: "Close",
      error: {
        footer: {
          buttons: {
            required: "Footer buttons are required.",
            onePrimary: "At most one footer button should be marked kind='primary'"
          }
        }
      }
    }
  }
}, qZ = {
  uikit: {
    overrideEditor: {
      header: "Page hosting override",
      csp: "Content Security Policy",
      feedbackMessage: {
        savedCookie: "Cookie has been saved!"
      },
      buttons: {
        saveCookie: "Save Override Cookie",
        localDev: "Set Vite local dev",
        deleteCookie: "Delete Override Cookie",
        goToOverridenPage: "Go to overriden page",
        copySharableLink: "Copy Link"
      },
      inputHeadings: {
        scripts: "Entry point scripts",
        styles: "Entry point styles",
        secondaryScripts: "Secondary scripts",
        secondaryStyles: "Secondary styles",
        images: "Images",
        fonts: "Fonts",
        data: "Data"
      },
      pathname: {
        heading: "Pathname",
        placeholder: "(Without leading / ) example: link/to/page"
      },
      localDevPort: "What port is your localhost running on?"
    }
  }
}, Jxe = {
  uikit: {
    overrideBanner: {
      message: "You are using a page override cookie to view static assets other than the defaults provided for this page.",
      edit: "Edit",
      remove: "Remove"
    },
    ...qZ.uikit
  }
}, Zxe = {
  uikit: {
    pagination: {
      navigationLabel: "Pagination",
      previous: {
        ariaLabel: "Go to previous page",
        label: "Previous"
      },
      next: {
        ariaLabel: "Go to next page",
        label: "Next"
      },
      ellipsis: {
        srLabel: "More pages"
      }
    }
  }
}, e6e = {
  uikit: {
    labels: {
      mobilePhone: "Mobile phone",
      email: "Email",
      address: "Address",
      creditScore: "Credit Score",
      secondSigner: "Second Signer",
      programFinancing: {
        title: "{{program}} Financing",
        description: "This approval is eligible for {{program}} Financing"
      },
      notAvailable: "N/A",
      unavailableData: "--"
    },
    programStatus: {
      standard: "Standard",
      gold: "Gold",
      silver: "Silver",
      platinum: "Platinum"
    }
  }
}, t6e = {
  uikit: {
    rehashHeader: {
      rehash: "Rehash",
      approval: "Approval ID:",
      menuItems: {
        dealStructure: "Deal Structure",
        alternativeDeals: "Alternative Deals",
        stipulations: "Stipulations",
        changeVehicle: "Change Vehicle"
      }
    }
  }
}, n6e = {
  uikit: {
    capsStepIndicator: {
      step1: "Customer",
      step2: "Income",
      step3: "Vehicle",
      step4: "Deal",
      step5: "Submit",
      step6: "Fund"
    },
    approvalInformation: {
      scoringProgramLogo: {
        "alt.text": "Scoring program logo"
      },
      applicationStatus: " ({{applicationStatus}})",
      driverDetails: "{{driver}} (Credit Score: {{driverCapsCreditScore}})",
      secondDriverDetails: "{{secondSigner}} (Credit Score: {{secondSignerCapsCreditScore}})",
      approval: "Approval #:",
      driver: "Driver:",
      secondSigner: "2nd Signer:",
      platinumProgramMoreInfo: "The PLATINUM financing option is available for qualifying customers with a 660+ credit score. Dealers benefit from higher advances, lower fees, and interest rates as low as 6.99%.",
      goldProgramMoreInfo: "The GOLD financing option is available for qualifying customers with a 600+ FICO. Dealers benefit from higher advances, lower fees, and interest rates as low as 11.99%.",
      silverProgramMoreInfo: "The SILVER financing option is available for qualifying customers with a 550+ credit score. Dealers benefit from higher advances, lower fees, and interest rates as low as 15.99%."
    }
  }
}, r6e = {
  uikit: {
    dataTable: {
      noResults: "No results.",
      pagination: {
        itemsPerPage: "Items per page",
        showingRange: "Showing {{start}}-{{end}} of {{total}}"
      }
    }
  }
}, BOt = {
  uikit: {
    ...Vxe.uikit,
    ..._xe.uikit,
    ...Bxe.uikit,
    ...Uxe.uikit,
    ...Yxe.uikit,
    ...Jxe.uikit,
    ...qZ.uikit,
    ...n6e.uikit,
    ...Kxe.uikit,
    ...Gxe.uikit,
    ...Xxe.uikit,
    ...qxe.uikit,
    ...Qxe.uikit,
    ...t6e.uikit,
    ...e6e.uikit,
    ...r6e.uikit,
    ...Zxe.uikit
  }
};
var tP = { exports: {} }, N5 = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var NV;
function a6e() {
  if (NV) return N5;
  NV = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.fragment");
  function r(a, i, c) {
    var d = null;
    if (c !== void 0 && (d = "" + c), i.key !== void 0 && (d = "" + i.key), "key" in i) {
      c = {};
      for (var f in i)
        f !== "key" && (c[f] = i[f]);
    } else c = i;
    return i = c.ref, {
      $$typeof: e,
      type: a,
      key: d,
      ref: i !== void 0 ? i : null,
      props: c
    };
  }
  return N5.Fragment = t, N5.jsx = r, N5.jsxs = r, N5;
}
var D5 = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var DV;
function o6e() {
  return DV || (DV = 1, process.env.NODE_ENV !== "production" && (function() {
    function e(ee) {
      if (ee == null) return null;
      if (typeof ee == "function")
        return ee.$$typeof === Q ? null : ee.displayName || ee.name || null;
      if (typeof ee == "string") return ee;
      switch (ee) {
        case M:
          return "Fragment";
        case N:
          return "Profiler";
        case T:
          return "StrictMode";
        case I:
          return "Suspense";
        case L:
          return "SuspenseList";
        case W:
          return "Activity";
      }
      if (typeof ee == "object")
        switch (typeof ee.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), ee.$$typeof) {
          case k:
            return "Portal";
          case $:
            return ee.displayName || "Context";
          case D:
            return (ee._context.displayName || "Context") + ".Consumer";
          case j:
            var ne = ee.render;
            return ee = ee.displayName, ee || (ee = ne.displayName || ne.name || "", ee = ee !== "" ? "ForwardRef(" + ee + ")" : "ForwardRef"), ee;
          case F:
            return ne = ee.displayName || null, ne !== null ? ne : e(ee.type) || "Memo";
          case _:
            ne = ee._payload, ee = ee._init;
            try {
              return e(ee(ne));
            } catch {
            }
        }
      return null;
    }
    function t(ee) {
      return "" + ee;
    }
    function r(ee) {
      try {
        t(ee);
        var ne = !1;
      } catch {
        ne = !0;
      }
      if (ne) {
        ne = console;
        var ae = ne.error, oe = typeof Symbol == "function" && Symbol.toStringTag && ee[Symbol.toStringTag] || ee.constructor.name || "Object";
        return ae.call(
          ne,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          oe
        ), t(ee);
      }
    }
    function a(ee) {
      if (ee === M) return "<>";
      if (typeof ee == "object" && ee !== null && ee.$$typeof === _)
        return "<...>";
      try {
        var ne = e(ee);
        return ne ? "<" + ne + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function i() {
      var ee = U.A;
      return ee === null ? null : ee.getOwner();
    }
    function c() {
      return Error("react-stack-top-frame");
    }
    function d(ee) {
      if (Y.call(ee, "key")) {
        var ne = Object.getOwnPropertyDescriptor(ee, "key").get;
        if (ne && ne.isReactWarning) return !1;
      }
      return ee.key !== void 0;
    }
    function f(ee, ne) {
      function ae() {
        H || (H = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          ne
        ));
      }
      ae.isReactWarning = !0, Object.defineProperty(ee, "key", {
        get: ae,
        configurable: !0
      });
    }
    function p() {
      var ee = e(this.type);
      return K[ee] || (K[ee] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), ee = this.props.ref, ee !== void 0 ? ee : null;
    }
    function g(ee, ne, ae, oe, fe, be) {
      var me = ae.ref;
      return ee = {
        $$typeof: P,
        type: ee,
        key: ne,
        props: ae,
        _owner: oe
      }, (me !== void 0 ? me : null) !== null ? Object.defineProperty(ee, "ref", {
        enumerable: !1,
        get: p
      }) : Object.defineProperty(ee, "ref", { enumerable: !1, value: null }), ee._store = {}, Object.defineProperty(ee._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(ee, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(ee, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: fe
      }), Object.defineProperty(ee, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: be
      }), Object.freeze && (Object.freeze(ee.props), Object.freeze(ee)), ee;
    }
    function b(ee, ne, ae, oe, fe, be) {
      var me = ne.children;
      if (me !== void 0)
        if (oe)
          if (G(me)) {
            for (oe = 0; oe < me.length; oe++)
              w(me[oe]);
            Object.freeze && Object.freeze(me);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else w(me);
      if (Y.call(ne, "key")) {
        me = e(ee);
        var De = Object.keys(ne).filter(function(ze) {
          return ze !== "key";
        });
        oe = 0 < De.length ? "{key: someKey, " + De.join(": ..., ") + ": ...}" : "{key: someKey}", ie[me + oe] || (De = 0 < De.length ? "{" + De.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          oe,
          me,
          De,
          me
        ), ie[me + oe] = !0);
      }
      if (me = null, ae !== void 0 && (r(ae), me = "" + ae), d(ne) && (r(ne.key), me = "" + ne.key), "key" in ne) {
        ae = {};
        for (var Me in ne)
          Me !== "key" && (ae[Me] = ne[Me]);
      } else ae = ne;
      return me && f(
        ae,
        typeof ee == "function" ? ee.displayName || ee.name || "Unknown" : ee
      ), g(
        ee,
        me,
        ae,
        i(),
        fe,
        be
      );
    }
    function w(ee) {
      x(ee) ? ee._store && (ee._store.validated = 1) : typeof ee == "object" && ee !== null && ee.$$typeof === _ && (ee._payload.status === "fulfilled" ? x(ee._payload.value) && ee._payload.value._store && (ee._payload.value._store.validated = 1) : ee._store && (ee._store.validated = 1));
    }
    function x(ee) {
      return typeof ee == "object" && ee !== null && ee.$$typeof === P;
    }
    var E = Re, P = Symbol.for("react.transitional.element"), k = Symbol.for("react.portal"), M = Symbol.for("react.fragment"), T = Symbol.for("react.strict_mode"), N = Symbol.for("react.profiler"), D = Symbol.for("react.consumer"), $ = Symbol.for("react.context"), j = Symbol.for("react.forward_ref"), I = Symbol.for("react.suspense"), L = Symbol.for("react.suspense_list"), F = Symbol.for("react.memo"), _ = Symbol.for("react.lazy"), W = Symbol.for("react.activity"), Q = Symbol.for("react.client.reference"), U = E.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, Y = Object.prototype.hasOwnProperty, G = Array.isArray, J = console.createTask ? console.createTask : function() {
      return null;
    };
    E = {
      react_stack_bottom_frame: function(ee) {
        return ee();
      }
    };
    var H, K = {}, X = E.react_stack_bottom_frame.bind(
      E,
      c
    )(), te = J(a(c)), ie = {};
    D5.Fragment = M, D5.jsx = function(ee, ne, ae) {
      var oe = 1e4 > U.recentlyCreatedOwnerStacks++;
      return b(
        ee,
        ne,
        ae,
        !1,
        oe ? Error("react-stack-top-frame") : X,
        oe ? J(a(ee)) : te
      );
    }, D5.jsxs = function(ee, ne, ae) {
      var oe = 1e4 > U.recentlyCreatedOwnerStacks++;
      return b(
        ee,
        ne,
        ae,
        !0,
        oe ? Error("react-stack-top-frame") : X,
        oe ? J(a(ee)) : te
      );
    };
  })()), D5;
}
var $V;
function i6e() {
  return $V || ($V = 1, process.env.NODE_ENV === "production" ? tP.exports = a6e() : tP.exports = o6e()), tP.exports;
}
var V = i6e();
function KZ(e) {
  var t, r, a = "";
  if (typeof e == "string" || typeof e == "number") a += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var i = e.length;
    for (t = 0; t < i; t++) e[t] && (r = KZ(e[t])) && (a && (a += " "), a += r);
  } else for (r in e) e[r] && (a && (a += " "), a += r);
  return a;
}
function YZ() {
  for (var e, t, r = 0, a = "", i = arguments.length; r < i; r++) (e = arguments[r]) && (t = KZ(e)) && (a && (a += " "), a += t);
  return a;
}
const zV = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, jV = YZ, fl = (e, t) => (r) => {
  var a;
  if (t?.variants == null) return jV(e, r?.class, r?.className);
  const { variants: i, defaultVariants: c } = t, d = Object.keys(i).map((g) => {
    const b = r?.[g], w = c?.[g];
    if (b === null) return null;
    const x = zV(b) || zV(w);
    return i[g][x];
  }), f = r && Object.entries(r).reduce((g, b) => {
    let [w, x] = b;
    return x === void 0 || (g[w] = x), g;
  }, {}), p = t == null || (a = t.compoundVariants) === null || a === void 0 ? void 0 : a.reduce((g, b) => {
    let { class: w, className: x, ...E } = b;
    return Object.entries(E).every((P) => {
      let [k, M] = P;
      return Array.isArray(M) ? M.includes({
        ...c,
        ...f
      }[k]) : {
        ...c,
        ...f
      }[k] === M;
    }) ? [
      ...g,
      w,
      x
    ] : g;
  }, []);
  return jV(e, d, p, r?.class, r?.className);
}, l6e = {
  // Used 1 time, for activity-content padding
  extraSmall: 420,
  // Used 6 times, for navbar background/shadow, dialog font/padding, portlet-topper display, table-responsive border
  preSmall: 767,
  // Used 29 times, above this is apparently considered desktop (except with header),
  // used for sm col layout,
  // allow word break, dialog height/padding/background/position(height),
  // image viewer background/border/color, portlet-topper width/display/position, portlet border/transform,
  // desktop float, hide on mobile, lead font size, dt/dd float/width, form width/margin/padding/font size, navbar dropdown menu position, nav display/border/float
  small: 768,
  maxMobile: 768,
  // Used 1 time, for gold/silver badge display
  dealerBadgeDisplay: 959,
  // Used 1 time, display mobile header here and below
  maxMobileHeader: 979,
  // Used 1 time, hide desktop, banner/header visibility/etc.
  minDesktopHeader: 980,
  // Used 1 time, for responsive-table display/wrapping
  responsiveTable: 991,
  // Used 5 times
  // for md col layout,
  // modify-pages? padding/display, navigation-pane padding, portlet-topper width, container width
  medium: 992,
  // Used 3 times
  // for large col layout,
  // portlet-topper width, container width
  large: 1200
};
function SM(e) {
  const t = ile();
  if (!t?.isInitialized)
    return e;
  const r = t.t(e);
  return r == null ? e : String(r);
}
function CM(e, t) {
  let r = e;
  for (const a of t)
    if (r && typeof r == "object" && a in r)
      r = r[a];
    else
      return;
  return r;
}
function s6e(e) {
  const t = e.lastIndexOf(".");
  return t === -1 ? e : e.slice(t + 1);
}
function u6e(e, t, r, a, i, c, d, f, p, g, b) {
  return {
    kind: "text",
    name: e,
    value: CM(r, a),
    onChange: (w) => i(a, w),
    label: SM(t),
    size: "small",
    width: c,
    disabled: d,
    required: f,
    error: p,
    placeholder: g,
    maxLength: b
  };
}
function c6e(e, t, r, a, i, c, d, f, p) {
  return {
    kind: "number",
    name: e,
    value: CM(r, a),
    onChange: (g) => i(a, g),
    label: SM(t),
    size: "small",
    width: c,
    disabled: d,
    required: f,
    error: p
  };
}
function d6e(e, t, r, a, i, c, d, f, p, g, b) {
  return {
    kind: "select",
    name: e,
    value: CM(r, a),
    onChange: (w) => i(a, w),
    label: SM(t),
    size: "small",
    options: f,
    width: c,
    disabled: d,
    required: p,
    error: g,
    placeholder: b
  };
}
function f6e(e, t, r, a, i, c, d, f, p, g) {
  return {
    kind: "date",
    name: e,
    value: CM(r, a),
    onChange: (b) => i(a, b),
    label: SM(t),
    size: "small",
    width: c,
    disabled: d,
    required: f,
    error: p,
    placeholder: g
  };
}
function IV(e, t, r, a) {
  const {
    kind: i,
    labelKey: c,
    path: d,
    options: f,
    required: p,
    isDisabled: g,
    error: b,
    placeholder: w,
    maxLength: x
  } = e;
  switch (i) {
    case "text":
      return u6e(
        d[0],
        c,
        t,
        d,
        r,
        a,
        g || !1,
        p || !1,
        b,
        w,
        x
      );
    case "select":
      return d6e(
        d[0],
        c,
        t,
        d,
        r,
        a,
        g || !1,
        f || [],
        p || !1,
        b,
        w
      );
    case "date":
      return f6e(
        d[0],
        c,
        t,
        d,
        r,
        a,
        g || !1,
        p || !1,
        b,
        w
      );
    case "number":
      return c6e(
        d[0],
        c,
        t,
        d,
        r,
        a,
        g || !1,
        p || !1,
        b
      );
  }
}
function m6e(e, t) {
  return !e || Object.keys(e).length === 0 ? t : {
    ...t,
    classNames: {
      ...e,
      ...t.classNames,
      label: lt(e.label, t.classNames?.label)
    }
  };
}
function UOt(e) {
  const {
    data: t,
    handleChange: r,
    inputWidth: a,
    fieldMapFunction: i,
    errorKeys: c,
    fieldMapArguments: d = [],
    classNames: f
  } = e, p = r ?? ((b, w) => {
  });
  return i(...d).map(function(b) {
    const w = c && c.length > 0 ? IV(
      c.includes(s6e(b.labelKey)) ? { ...b, error: !0 } : b,
      t,
      p,
      b.inputWidth ?? a
    ) : IV(
      b,
      t,
      p,
      b.inputWidth ?? a
    );
    return m6e(f, w);
  });
}
const mr = (e) => {
  const t = e.startsWith("--") ? e : `--${e}`;
  return window.getComputedStyle(window.document.documentElement).getPropertyValue(t).trim();
}, vo = (e) => Number.parseFloat(mr(e)), h6e = () => (/* @__PURE__ */ new Date()).getFullYear();
function XOt(e, t) {
  return `/iframe.html?${new URLSearchParams({ id: e, ...t }).toString()}`;
}
const Kj = fp("classic");
function fi(...e) {
  const t = e[0], r = e[1], {
    t: a,
    i18n: i,
    ready: c
  } = xz(t, r), d = Object.assign(
    p6e.bind(void 0, a, i),
    a
  );
  return Object.assign([d, i, c], {
    i18n: i,
    ready: c,
    t: d
  });
}
function p6e(e, t, ...r) {
  const a = QZ(
    t,
    ...r
  );
  return e(...a);
}
function QZ(e, ...t) {
  const [r, a] = t;
  let i = r, c = a;
  if (!(e && e.options))
    return t;
  const { ns: d = [], resources: { en: f = {} } = {} } = e.options;
  return Object.keys(f).includes("uikit") ? (c = {
    defaultValue: typeof a == "string" ? a : a?.defaultValue
  }, a && typeof a == "object" && (c = { ...c, ...a }), c.ns || (c.ns = "uikit")) : (console.warn(
    `When initializing i18next in your project, please declare the "uikit" namespace and assign any i18n resources imported from uikit to that namespace, e.g.:

      // src/i18n.ts
      import i18n from "i18next";
      import { i18n as uikitResources } from "@credit-acceptance/uikit";
      import { otherNamespaces } from "./other-resources"; // import other namespaces as needed
 
      i18n
        .init({
          defaultNS: "translation", // or false if you don't want a default namespace
          fallbackLng: "en",
          interpolation: { escapeValue: false },
          lng: "en",
          ns: ["translation", "uikit", ...Object.keys(otherNamespaces)],
          react: { useSuspense: false },
          supportedLngs: ["en"],
          resources: { 
            en: { 
              // The default namespace is "translation"
              translation: myAppResources, 
              ...otherNamespaces, // include other namespaces as needed 
              ...uikitResources,
            } 
          },
        });

Currently detected declared namespaces [init({ ns })]:`,
    d,
    `
Currently detected namespaces in resources [init({ resources: { en: { ...namespaces } } })]:`,
    Object.keys(f)
  ), i = JZ(r)), [i, c];
}
function JZ(e) {
  return Array.isArray(e) ? e.map((t) => JZ(t)) : typeof e == "string" ? e.startsWith("uikit.") ? e : `uikit.${e}` : (console.error('Failed to include "uikit" namespace for key', e), e);
}
const LV = (e) => {
  const { i18n: t } = xz(), [r, a] = QZ(
    t,
    e.i18nKey,
    e.tOptions
  ), i = a && typeof a == "object" ? a.ns : void 0;
  return /* @__PURE__ */ V.jsx(
    lle,
    {
      ...e,
      ns: i,
      i18nKey: r,
      tOptions: a
    }
  );
}, g6e = (e, t) => {
  const r = new Array(e.length + t.length);
  for (let a = 0; a < e.length; a++)
    r[a] = e[a];
  for (let a = 0; a < t.length; a++)
    r[e.length + a] = t[a];
  return r;
}, v6e = (e, t) => ({
  classGroupId: e,
  validator: t
}), ZZ = (e = /* @__PURE__ */ new Map(), t = null, r) => ({
  nextPart: e,
  validators: t,
  classGroupId: r
}), a9 = "-", HV = [], b6e = "arbitrary..", y6e = (e) => {
  const t = S6e(e), {
    conflictingClassGroups: r,
    conflictingClassGroupModifiers: a
  } = e;
  return {
    getClassGroupId: (d) => {
      if (d.startsWith("[") && d.endsWith("]"))
        return w6e(d);
      const f = d.split(a9), p = f[0] === "" && f.length > 1 ? 1 : 0;
      return eee(f, p, t);
    },
    getConflictingClassGroupIds: (d, f) => {
      if (f) {
        const p = a[d], g = r[d];
        return p ? g ? g6e(g, p) : p : g || HV;
      }
      return r[d] || HV;
    }
  };
}, eee = (e, t, r) => {
  if (e.length - t === 0)
    return r.classGroupId;
  const i = e[t], c = r.nextPart.get(i);
  if (c) {
    const g = eee(e, t + 1, c);
    if (g) return g;
  }
  const d = r.validators;
  if (d === null)
    return;
  const f = t === 0 ? e.join(a9) : e.slice(t).join(a9), p = d.length;
  for (let g = 0; g < p; g++) {
    const b = d[g];
    if (b.validator(f))
      return b.classGroupId;
  }
}, w6e = (e) => e.slice(1, -1).indexOf(":") === -1 ? void 0 : (() => {
  const t = e.slice(1, -1), r = t.indexOf(":"), a = t.slice(0, r);
  return a ? b6e + a : void 0;
})(), S6e = (e) => {
  const {
    theme: t,
    classGroups: r
  } = e;
  return C6e(r, t);
}, C6e = (e, t) => {
  const r = ZZ();
  for (const a in e) {
    const i = e[a];
    Yj(i, r, a, t);
  }
  return r;
}, Yj = (e, t, r, a) => {
  const i = e.length;
  for (let c = 0; c < i; c++) {
    const d = e[c];
    x6e(d, t, r, a);
  }
}, x6e = (e, t, r, a) => {
  if (typeof e == "string") {
    E6e(e, t, r);
    return;
  }
  if (typeof e == "function") {
    P6e(e, t, r, a);
    return;
  }
  k6e(e, t, r, a);
}, E6e = (e, t, r) => {
  const a = e === "" ? t : tee(t, e);
  a.classGroupId = r;
}, P6e = (e, t, r, a) => {
  if (M6e(e)) {
    Yj(e(a), t, r, a);
    return;
  }
  t.validators === null && (t.validators = []), t.validators.push(v6e(r, e));
}, k6e = (e, t, r, a) => {
  const i = Object.entries(e), c = i.length;
  for (let d = 0; d < c; d++) {
    const [f, p] = i[d];
    Yj(p, tee(t, f), r, a);
  }
}, tee = (e, t) => {
  let r = e;
  const a = t.split(a9), i = a.length;
  for (let c = 0; c < i; c++) {
    const d = a[c];
    let f = r.nextPart.get(d);
    f || (f = ZZ(), r.nextPart.set(d, f)), r = f;
  }
  return r;
}, M6e = (e) => "isThemeGetter" in e && e.isThemeGetter === !0, O6e = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, r = /* @__PURE__ */ Object.create(null), a = /* @__PURE__ */ Object.create(null);
  const i = (c, d) => {
    r[c] = d, t++, t > e && (t = 0, a = r, r = /* @__PURE__ */ Object.create(null));
  };
  return {
    get(c) {
      let d = r[c];
      if (d !== void 0)
        return d;
      if ((d = a[c]) !== void 0)
        return i(c, d), d;
    },
    set(c, d) {
      c in r ? r[c] = d : i(c, d);
    }
  };
}, u$ = "!", FV = ":", T6e = [], WV = (e, t, r, a, i) => ({
  modifiers: e,
  hasImportantModifier: t,
  baseClassName: r,
  maybePostfixModifierPosition: a,
  isExternal: i
}), R6e = (e) => {
  const {
    prefix: t,
    experimentalParseClassName: r
  } = e;
  let a = (i) => {
    const c = [];
    let d = 0, f = 0, p = 0, g;
    const b = i.length;
    for (let k = 0; k < b; k++) {
      const M = i[k];
      if (d === 0 && f === 0) {
        if (M === FV) {
          c.push(i.slice(p, k)), p = k + 1;
          continue;
        }
        if (M === "/") {
          g = k;
          continue;
        }
      }
      M === "[" ? d++ : M === "]" ? d-- : M === "(" ? f++ : M === ")" && f--;
    }
    const w = c.length === 0 ? i : i.slice(p);
    let x = w, E = !1;
    w.endsWith(u$) ? (x = w.slice(0, -1), E = !0) : (
      /**
       * In Tailwind CSS v3 the important modifier was at the start of the base class name. This is still supported for legacy reasons.
       * @see https://github.com/dcastil/tailwind-merge/issues/513#issuecomment-2614029864
       */
      w.startsWith(u$) && (x = w.slice(1), E = !0)
    );
    const P = g && g > p ? g - p : void 0;
    return WV(c, E, x, P);
  };
  if (t) {
    const i = t + FV, c = a;
    a = (d) => d.startsWith(i) ? c(d.slice(i.length)) : WV(T6e, !1, d, void 0, !0);
  }
  if (r) {
    const i = a;
    a = (c) => r({
      className: c,
      parseClassName: i
    });
  }
  return a;
}, A6e = (e) => {
  const t = /* @__PURE__ */ new Map();
  return e.orderSensitiveModifiers.forEach((r, a) => {
    t.set(r, 1e6 + a);
  }), (r) => {
    const a = [];
    let i = [];
    for (let c = 0; c < r.length; c++) {
      const d = r[c], f = d[0] === "[", p = t.has(d);
      f || p ? (i.length > 0 && (i.sort(), a.push(...i), i = []), a.push(d)) : i.push(d);
    }
    return i.length > 0 && (i.sort(), a.push(...i)), a;
  };
}, N6e = (e) => ({
  cache: O6e(e.cacheSize),
  parseClassName: R6e(e),
  sortModifiers: A6e(e),
  ...y6e(e)
}), D6e = /\s+/, $6e = (e, t) => {
  const {
    parseClassName: r,
    getClassGroupId: a,
    getConflictingClassGroupIds: i,
    sortModifiers: c
  } = t, d = [], f = e.trim().split(D6e);
  let p = "";
  for (let g = f.length - 1; g >= 0; g -= 1) {
    const b = f[g], {
      isExternal: w,
      modifiers: x,
      hasImportantModifier: E,
      baseClassName: P,
      maybePostfixModifierPosition: k
    } = r(b);
    if (w) {
      p = b + (p.length > 0 ? " " + p : p);
      continue;
    }
    let M = !!k, T = a(M ? P.substring(0, k) : P);
    if (!T) {
      if (!M) {
        p = b + (p.length > 0 ? " " + p : p);
        continue;
      }
      if (T = a(P), !T) {
        p = b + (p.length > 0 ? " " + p : p);
        continue;
      }
      M = !1;
    }
    const N = x.length === 0 ? "" : x.length === 1 ? x[0] : c(x).join(":"), D = E ? N + u$ : N, $ = D + T;
    if (d.indexOf($) > -1)
      continue;
    d.push($);
    const j = i(T, M);
    for (let I = 0; I < j.length; ++I) {
      const L = j[I];
      d.push(D + L);
    }
    p = b + (p.length > 0 ? " " + p : p);
  }
  return p;
}, z6e = (...e) => {
  let t = 0, r, a, i = "";
  for (; t < e.length; )
    (r = e[t++]) && (a = nee(r)) && (i && (i += " "), i += a);
  return i;
}, nee = (e) => {
  if (typeof e == "string")
    return e;
  let t, r = "";
  for (let a = 0; a < e.length; a++)
    e[a] && (t = nee(e[a])) && (r && (r += " "), r += t);
  return r;
}, j6e = (e, ...t) => {
  let r, a, i, c;
  const d = (p) => {
    const g = t.reduce((b, w) => w(b), e());
    return r = N6e(g), a = r.cache.get, i = r.cache.set, c = f, f(p);
  }, f = (p) => {
    const g = a(p);
    if (g)
      return g;
    const b = $6e(p, r);
    return i(p, b), b;
  };
  return c = d, (...p) => c(z6e(...p));
}, I6e = [], od = (e) => {
  const t = (r) => r[e] || I6e;
  return t.isThemeGetter = !0, t;
}, ree = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, aee = /^\((?:(\w[\w-]*):)?(.+)\)$/i, L6e = /^\d+\/\d+$/, H6e = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, F6e = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, W6e = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, V6e = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, _6e = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, $3 = (e) => L6e.test(e), go = (e) => !!e && !Number.isNaN(Number(e)), CS = (e) => !!e && Number.isInteger(Number(e)), IR = (e) => e.endsWith("%") && go(e.slice(0, -1)), Bw = (e) => H6e.test(e), B6e = () => !0, U6e = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  F6e.test(e) && !W6e.test(e)
), oee = () => !1, X6e = (e) => V6e.test(e), G6e = (e) => _6e.test(e), q6e = (e) => !Sr(e) && !Cr(e), K6e = (e) => r6(e, see, oee), Sr = (e) => ree.test(e), I4 = (e) => r6(e, uee, U6e), LR = (e) => r6(e, e8e, go), VV = (e) => r6(e, iee, oee), Y6e = (e) => r6(e, lee, G6e), nP = (e) => r6(e, cee, X6e), Cr = (e) => aee.test(e), $5 = (e) => a6(e, uee), Q6e = (e) => a6(e, t8e), _V = (e) => a6(e, iee), J6e = (e) => a6(e, see), Z6e = (e) => a6(e, lee), rP = (e) => a6(e, cee, !0), r6 = (e, t, r) => {
  const a = ree.exec(e);
  return a ? a[1] ? t(a[1]) : r(a[2]) : !1;
}, a6 = (e, t, r = !1) => {
  const a = aee.exec(e);
  return a ? a[1] ? t(a[1]) : r : !1;
}, iee = (e) => e === "position" || e === "percentage", lee = (e) => e === "image" || e === "url", see = (e) => e === "length" || e === "size" || e === "bg-size", uee = (e) => e === "length", e8e = (e) => e === "number", t8e = (e) => e === "family-name", cee = (e) => e === "shadow", n8e = () => {
  const e = od("color"), t = od("font"), r = od("text"), a = od("font-weight"), i = od("tracking"), c = od("leading"), d = od("breakpoint"), f = od("container"), p = od("spacing"), g = od("radius"), b = od("shadow"), w = od("inset-shadow"), x = od("text-shadow"), E = od("drop-shadow"), P = od("blur"), k = od("perspective"), M = od("aspect"), T = od("ease"), N = od("animate"), D = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], $ = () => [
    "center",
    "top",
    "bottom",
    "left",
    "right",
    "top-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-top",
    "top-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-top",
    "bottom-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-bottom",
    "bottom-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-bottom"
  ], j = () => [...$(), Cr, Sr], I = () => ["auto", "hidden", "clip", "visible", "scroll"], L = () => ["auto", "contain", "none"], F = () => [Cr, Sr, p], _ = () => [$3, "full", "auto", ...F()], W = () => [CS, "none", "subgrid", Cr, Sr], Q = () => ["auto", {
    span: ["full", CS, Cr, Sr]
  }, CS, Cr, Sr], U = () => [CS, "auto", Cr, Sr], Y = () => ["auto", "min", "max", "fr", Cr, Sr], G = () => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline", "center-safe", "end-safe"], J = () => ["start", "end", "center", "stretch", "center-safe", "end-safe"], H = () => ["auto", ...F()], K = () => [$3, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...F()], X = () => [e, Cr, Sr], te = () => [...$(), _V, VV, {
    position: [Cr, Sr]
  }], ie = () => ["no-repeat", {
    repeat: ["", "x", "y", "space", "round"]
  }], ee = () => ["auto", "cover", "contain", J6e, K6e, {
    size: [Cr, Sr]
  }], ne = () => [IR, $5, I4], ae = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    "full",
    g,
    Cr,
    Sr
  ], oe = () => ["", go, $5, I4], fe = () => ["solid", "dashed", "dotted", "double"], be = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], me = () => [go, IR, _V, VV], De = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    P,
    Cr,
    Sr
  ], Me = () => ["none", go, Cr, Sr], ze = () => ["none", go, Cr, Sr], le = () => [go, Cr, Sr], se = () => [$3, "full", ...F()];
  return {
    cacheSize: 500,
    theme: {
      animate: ["spin", "ping", "pulse", "bounce"],
      aspect: ["video"],
      blur: [Bw],
      breakpoint: [Bw],
      color: [B6e],
      container: [Bw],
      "drop-shadow": [Bw],
      ease: ["in", "out", "in-out"],
      font: [q6e],
      "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
      "inset-shadow": [Bw],
      leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
      perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
      radius: [Bw],
      shadow: [Bw],
      spacing: ["px", go],
      text: [Bw],
      "text-shadow": [Bw],
      tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
    },
    classGroups: {
      // --------------
      // --- Layout ---
      // --------------
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", $3, Sr, Cr, M]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [go, Sr, Cr, f]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": D()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": D()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: j()
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: I()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": I()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": I()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: L()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": L()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": L()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: _()
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": _()
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": _()
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: _()
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: _()
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: _()
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: _()
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: _()
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: _()
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: [CS, "auto", Cr, Sr]
      }],
      // ------------------------
      // --- Flexbox and Grid ---
      // ------------------------
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [$3, "full", "auto", f, ...F()]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["nowrap", "wrap", "wrap-reverse"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: [go, $3, "auto", "initial", "none", Sr]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ["", go, Cr, Sr]
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ["", go, Cr, Sr]
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: [CS, "first", "last", "none", Cr, Sr]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": W()
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: Q()
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": U()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": U()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": W()
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: Q()
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": U()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": U()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": Y()
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": Y()
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: F()
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": F()
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": F()
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: [...G(), "normal"]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": [...J(), "normal"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", ...J()]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...G()]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: [...J(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", ...J(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": G()
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": [...J(), "baseline"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", ...J()]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: F()
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: F()
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: F()
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: F()
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: F()
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: F()
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: F()
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: F()
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: F()
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: H()
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: H()
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: H()
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: H()
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: H()
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: H()
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: H()
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: H()
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: H()
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x": [{
        "space-x": F()
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y": [{
        "space-y": F()
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y-reverse": ["space-y-reverse"],
      // --------------
      // --- Sizing ---
      // --------------
      /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */
      size: [{
        size: K()
      }],
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: [f, "screen", ...K()]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [
          f,
          "screen",
          /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "none",
          ...K()
        ]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [
          f,
          "screen",
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "prose",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          {
            screen: [d]
          },
          ...K()
        ]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: ["screen", "lh", ...K()]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["screen", "lh", "none", ...K()]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": ["screen", "lh", ...K()]
      }],
      // ------------------
      // --- Typography ---
      // ------------------
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", r, $5, I4]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: [a, Cr, LR]
      }],
      /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */
      "font-stretch": [{
        "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", IR, Sr]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Q6e, Sr, t]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: [i, Cr, Sr]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": [go, "none", Cr, LR]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: [
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          c,
          ...F()
        ]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", Cr, Sr]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["disc", "decimal", "none", Cr, Sr]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: X()
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: X()
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...fe(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: [go, "from-font", "auto", Cr, I4]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: X()
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": [go, "auto", Cr, Sr]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: F()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", Cr, Sr]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */
      wrap: [{
        wrap: ["break-word", "anywhere", "normal"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", Cr, Sr]
      }],
      // -------------------
      // --- Backgrounds ---
      // -------------------
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: te()
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ie()
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ee()
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          linear: [{
            to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, CS, Cr, Sr],
          radial: ["", Cr, Sr],
          conic: [CS, Cr, Sr]
        }, Z6e, Y6e]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: X()
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: ne()
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: ne()
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: ne()
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: X()
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: X()
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: X()
      }],
      // ---------------
      // --- Borders ---
      // ---------------
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: ae()
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": ae()
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": ae()
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": ae()
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": ae()
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": ae()
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": ae()
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": ae()
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": ae()
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": ae()
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": ae()
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": ae()
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": ae()
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": ae()
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": ae()
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: oe()
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": oe()
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": oe()
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": oe()
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": oe()
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": oe()
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": oe()
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": oe()
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": oe()
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x": [{
        "divide-x": oe()
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y": [{
        "divide-y": oe()
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...fe(), "hidden", "none"]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */
      "divide-style": [{
        divide: [...fe(), "hidden", "none"]
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: X()
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": X()
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": X()
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": X()
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": X()
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": X()
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": X()
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": X()
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": X()
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: X()
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [...fe(), "none", "hidden"]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [go, Cr, Sr]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: ["", go, $5, I4]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: X()
      }],
      // ---------------
      // --- Effects ---
      // ---------------
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          b,
          rP,
          nP
        ]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */
      "shadow-color": [{
        shadow: X()
      }],
      /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */
      "inset-shadow": [{
        "inset-shadow": ["none", w, rP, nP]
      }],
      /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */
      "inset-shadow-color": [{
        "inset-shadow": X()
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */
      "ring-w": [{
        ring: oe()
      }],
      /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */
      "ring-color": [{
        ring: X()
      }],
      /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-w": [{
        "ring-offset": [go, I4]
      }],
      /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-color": [{
        "ring-offset": X()
      }],
      /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */
      "inset-ring-w": [{
        "inset-ring": oe()
      }],
      /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */
      "inset-ring-color": [{
        "inset-ring": X()
      }],
      /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */
      "text-shadow": [{
        "text-shadow": ["none", x, rP, nP]
      }],
      /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */
      "text-shadow-color": [{
        "text-shadow": X()
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [go, Cr, Sr]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...be(), "plus-darker", "plus-lighter"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": be()
      }],
      /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */
      "mask-clip": [{
        "mask-clip": ["border", "padding", "content", "fill", "stroke", "view"]
      }, "mask-no-clip"],
      /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */
      "mask-composite": [{
        mask: ["add", "subtract", "intersect", "exclude"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image-linear-pos": [{
        "mask-linear": [go]
      }],
      "mask-image-linear-from-pos": [{
        "mask-linear-from": me()
      }],
      "mask-image-linear-to-pos": [{
        "mask-linear-to": me()
      }],
      "mask-image-linear-from-color": [{
        "mask-linear-from": X()
      }],
      "mask-image-linear-to-color": [{
        "mask-linear-to": X()
      }],
      "mask-image-t-from-pos": [{
        "mask-t-from": me()
      }],
      "mask-image-t-to-pos": [{
        "mask-t-to": me()
      }],
      "mask-image-t-from-color": [{
        "mask-t-from": X()
      }],
      "mask-image-t-to-color": [{
        "mask-t-to": X()
      }],
      "mask-image-r-from-pos": [{
        "mask-r-from": me()
      }],
      "mask-image-r-to-pos": [{
        "mask-r-to": me()
      }],
      "mask-image-r-from-color": [{
        "mask-r-from": X()
      }],
      "mask-image-r-to-color": [{
        "mask-r-to": X()
      }],
      "mask-image-b-from-pos": [{
        "mask-b-from": me()
      }],
      "mask-image-b-to-pos": [{
        "mask-b-to": me()
      }],
      "mask-image-b-from-color": [{
        "mask-b-from": X()
      }],
      "mask-image-b-to-color": [{
        "mask-b-to": X()
      }],
      "mask-image-l-from-pos": [{
        "mask-l-from": me()
      }],
      "mask-image-l-to-pos": [{
        "mask-l-to": me()
      }],
      "mask-image-l-from-color": [{
        "mask-l-from": X()
      }],
      "mask-image-l-to-color": [{
        "mask-l-to": X()
      }],
      "mask-image-x-from-pos": [{
        "mask-x-from": me()
      }],
      "mask-image-x-to-pos": [{
        "mask-x-to": me()
      }],
      "mask-image-x-from-color": [{
        "mask-x-from": X()
      }],
      "mask-image-x-to-color": [{
        "mask-x-to": X()
      }],
      "mask-image-y-from-pos": [{
        "mask-y-from": me()
      }],
      "mask-image-y-to-pos": [{
        "mask-y-to": me()
      }],
      "mask-image-y-from-color": [{
        "mask-y-from": X()
      }],
      "mask-image-y-to-color": [{
        "mask-y-to": X()
      }],
      "mask-image-radial": [{
        "mask-radial": [Cr, Sr]
      }],
      "mask-image-radial-from-pos": [{
        "mask-radial-from": me()
      }],
      "mask-image-radial-to-pos": [{
        "mask-radial-to": me()
      }],
      "mask-image-radial-from-color": [{
        "mask-radial-from": X()
      }],
      "mask-image-radial-to-color": [{
        "mask-radial-to": X()
      }],
      "mask-image-radial-shape": [{
        "mask-radial": ["circle", "ellipse"]
      }],
      "mask-image-radial-size": [{
        "mask-radial": [{
          closest: ["side", "corner"],
          farthest: ["side", "corner"]
        }]
      }],
      "mask-image-radial-pos": [{
        "mask-radial-at": $()
      }],
      "mask-image-conic-pos": [{
        "mask-conic": [go]
      }],
      "mask-image-conic-from-pos": [{
        "mask-conic-from": me()
      }],
      "mask-image-conic-to-pos": [{
        "mask-conic-to": me()
      }],
      "mask-image-conic-from-color": [{
        "mask-conic-from": X()
      }],
      "mask-image-conic-to-color": [{
        "mask-conic-to": X()
      }],
      /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */
      "mask-mode": [{
        mask: ["alpha", "luminance", "match"]
      }],
      /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */
      "mask-origin": [{
        "mask-origin": ["border", "padding", "content", "fill", "stroke", "view"]
      }],
      /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */
      "mask-position": [{
        mask: te()
      }],
      /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */
      "mask-repeat": [{
        mask: ie()
      }],
      /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */
      "mask-size": [{
        mask: ee()
      }],
      /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */
      "mask-type": [{
        "mask-type": ["alpha", "luminance"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image": [{
        mask: ["none", Cr, Sr]
      }],
      // ---------------
      // --- Filters ---
      // ---------------
      /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          Cr,
          Sr
        ]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: De()
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [go, Cr, Sr]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [go, Cr, Sr]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          E,
          rP,
          nP
        ]
      }],
      /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */
      "drop-shadow-color": [{
        "drop-shadow": X()
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: ["", go, Cr, Sr]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [go, Cr, Sr]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: ["", go, Cr, Sr]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [go, Cr, Sr]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: ["", go, Cr, Sr]
      }],
      /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          Cr,
          Sr
        ]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": De()
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [go, Cr, Sr]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [go, Cr, Sr]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": ["", go, Cr, Sr]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [go, Cr, Sr]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": ["", go, Cr, Sr]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [go, Cr, Sr]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [go, Cr, Sr]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": ["", go, Cr, Sr]
      }],
      // --------------
      // --- Tables ---
      // --------------
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": F()
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": F()
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": F()
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // ---------------------------------
      // --- Transitions and Animation ---
      // ---------------------------------
      /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", Cr, Sr]
      }],
      /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */
      "transition-behavior": [{
        transition: ["normal", "discrete"]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: [go, "initial", Cr, Sr]
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "initial", T, Cr, Sr]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: [go, Cr, Sr]
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", N, Cr, Sr]
      }],
      // ------------------
      // --- Transforms ---
      // ------------------
      /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */
      backface: [{
        backface: ["hidden", "visible"]
      }],
      /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */
      perspective: [{
        perspective: [k, Cr, Sr]
      }],
      /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */
      "perspective-origin": [{
        "perspective-origin": j()
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: Me()
      }],
      /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-x": [{
        "rotate-x": Me()
      }],
      /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-y": [{
        "rotate-y": Me()
      }],
      /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-z": [{
        "rotate-z": Me()
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: ze()
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": ze()
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": ze()
      }],
      /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-z": [{
        "scale-z": ze()
      }],
      /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-3d": ["scale-3d"],
      /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */
      skew: [{
        skew: le()
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": le()
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": le()
      }],
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: [Cr, Sr, "", "none", "gpu", "cpu"]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: j()
      }],
      /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */
      "transform-style": [{
        transform: ["3d", "flat"]
      }],
      /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */
      translate: [{
        translate: se()
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": se()
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": se()
      }],
      /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-z": [{
        "translate-z": se()
      }],
      /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-none": ["translate-none"],
      // ---------------------
      // --- Interactivity ---
      // ---------------------
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: X()
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: X()
      }],
      /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */
      "color-scheme": [{
        scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", Cr, Sr]
      }],
      /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */
      "field-sizing": [{
        "field-sizing": ["fixed", "content"]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["auto", "none"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "", "y", "x"]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": F()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": F()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": F()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": F()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": F()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": F()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": F()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": F()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": F()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": F()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": F()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": F()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": F()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": F()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": F()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": F()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": F()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": F()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", Cr, Sr]
      }],
      // -----------
      // --- SVG ---
      // -----------
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: ["none", ...X()]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [go, $5, I4, LR]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: ["none", ...X()]
      }],
      // ---------------------
      // --- Accessibility ---
      // ---------------------
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-x", "border-w-y", "border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-x", "border-color-y", "border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      translate: ["translate-x", "translate-y", "translate-none"],
      "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    },
    orderSensitiveModifiers: ["*", "**", "after", "backdrop", "before", "details-content", "file", "first-letter", "first-line", "marker", "placeholder", "selection"]
  };
}, r8e = /* @__PURE__ */ j6e(n8e);
function lt(...e) {
  return r8e(YZ(e));
}
const BV = (e) => ({
  info: "var(--alert-banner-text-info)",
  warning: "var(--alert-banner-text-warning)",
  error: "var(--alert-banner-text-error)",
  success: "var(--alert-banner-text-success)"
})[e];
function a8e({
  dataTestId: e,
  onClose: t,
  kind: r
}) {
  const { t: a } = fi(), [i, c] = Wn(!1);
  return t ? /* @__PURE__ */ V.jsx(
    "button",
    {
      className: lt("cursor-pointer border-none bg-transparent outline-none"),
      "data-role": "button",
      "data-slot": "close",
      "data-testid": `${e}-close`,
      onClick: t,
      onMouseEnter: () => c(!0),
      onMouseLeave: () => c(!1),
      onFocus: () => c(!0),
      onBlur: () => c(!1),
      "aria-label": a("alertBanner.close"),
      children: /* @__PURE__ */ V.jsx(
        _f,
        {
          name: "closeOutlined",
          color: BV(r),
          size: 16
        }
      )
    }
  ) : null;
}
function o8e({
  actions: e,
  dataTestId: t,
  onClose: r,
  kind: a
}) {
  return !e?.length && !r ? null : /* @__PURE__ */ V.jsxs(
    "div",
    {
      className: lt("flex justify-between gap-2"),
      "data-testid": `${t}-actions`,
      children: [
        e && e.map((i, c) => {
          const d = i.data_testid ?? i.id ?? c, f = i.id ?? d;
          return /* @__PURE__ */ V.jsx(
            Qw,
            {
              "data-slot": "alert-action-button",
              "data-testid": `${t}-action-${d}`,
              ...i
            },
            f
          );
        }),
        /* @__PURE__ */ V.jsx(a8e, { dataTestId: t, onClose: r, kind: a })
      ]
    }
  );
}
function i8e({
  className: e,
  dataTestId: t,
  ...r
}) {
  return /* @__PURE__ */ V.jsx(
    "p",
    {
      className: lt(
        "text-muted-foreground grid justify-items-start gap-1 text-sm [&_p]:leading-relaxed",
        e
      ),
      "data-slot": "alert-description",
      "data-testid": `${t}-description`,
      ...r
    }
  );
}
function UV({
  className: e,
  dataTestId: t,
  ...r
}) {
  return /* @__PURE__ */ V.jsx(
    "header",
    {
      className: lt(
        "col-start-2 line-clamp-1 min-h-4 font-medium tracking-tight",
        e
      ),
      "data-slot": "alert-title",
      "data-testid": `${t}-heading`,
      ...r
    }
  );
}
function l8e({
  dataTestId: e,
  iconName: t,
  iconColor: r,
  primaryText: a,
  secondaryText: i
}) {
  return /* @__PURE__ */ V.jsxs(
    "div",
    {
      className: lt("flex items-center justify-between gap-2"),
      "data-testid": `${e}-message`,
      children: [
        t && /* @__PURE__ */ V.jsx(
          _f,
          {
            className: lt("shrink-0"),
            name: t,
            size: 12,
            color: r
          }
        ),
        !i && /* @__PURE__ */ V.jsx(UV, { dataTestId: e, children: a }),
        i && /* @__PURE__ */ V.jsxs("div", { className: lt("flex flex-col justify-between"), children: [
          /* @__PURE__ */ V.jsx(UV, { className: "text-lg", dataTestId: e, children: a }),
          /* @__PURE__ */ V.jsx(i8e, { dataTestId: e, children: i })
        ] })
      ]
    }
  );
}
const s8e = {
  info: "infoOutlined",
  warning: "warning",
  error: "circleAlertOutlined",
  success: "circleChecked"
}, u8e = fl(
  lt(
    "flex items-center justify-between gap-2",
    "relative rounded-lg border p-3 text-sm has-[>svg]:gap-x-3 gap-y-0.5 [&>svg]:size-4 [&>svg]:translate-y-0.5 [&>svg]:text-current",
    "transition-colors duration-200"
  ),
  {
    variants: {
      kind: {
        info: "bg-[var(--alert-banner-background-info)] border-(--alert-banner-border-info) text-[var(--alert-banner-text-info)] hover:bg-[var(--alert-banner-background-info-hover)]",
        warning: "bg-[var(--alert-banner-background-warning)] border-(--alert-banner-border-warning) text-[var(--alert-banner-text-warning)] hover:bg-[var(--alert-banner-background-warning-hover)]",
        error: "bg-[var(--alert-banner-background-error)] border-(--alert-banner-border-error) text-[var(--alert-banner-text-error)] hover:bg-[var(--alert-banner-background-error-hover)]",
        success: "bg-[var(--alert-banner-background-success)] border-(--alert-banner-border-success) text-[var(--alert-banner-text-success)] hover:bg-[var(--alert-banner-background-success-hover)]"
      },
      topOfPage: {
        true: "fixed top-0 left-1/2 transform -translate-x-1/2 w-3/5 z-1",
        false: ""
      }
    },
    defaultVariants: {
      kind: "info"
    }
  }
);
function dee({
  actions: e,
  dataTestId: t = `alert-banner=${Date.now()}`,
  heading: r,
  iconName: a,
  kind: i,
  message: c,
  onClose: d,
  topOfPage: f = !1
}) {
  const p = r ?? c, g = r && c ? c : void 0, b = a === "none" ? void 0 : a || s8e[i];
  return /* @__PURE__ */ V.jsxs(
    "aside",
    {
      "data-slot": "alert",
      "data-testid": t,
      role: "alert",
      className: lt(
        "flex items-center justify-between",
        u8e({ kind: i, topOfPage: f })
      ),
      children: [
        /* @__PURE__ */ V.jsx(
          l8e,
          {
            dataTestId: t,
            iconName: b,
            primaryText: p,
            secondaryText: g
          }
        ),
        /* @__PURE__ */ V.jsx(
          o8e,
          {
            actions: e,
            dataTestId: t,
            onClose: d,
            kind: i
          }
        )
      ]
    }
  );
}
function GOt({ children: e }) {
  return /* @__PURE__ */ V.jsx(use, { layer: !0, children: /* @__PURE__ */ V.jsx(tc, { children: e }) });
}
function qOt({
  className: e = "",
  children: t,
  ...r
}) {
  const a = {
    token: {
      fontFamily: "inherit"
    }
  };
  return /* @__PURE__ */ V.jsx(tc, { theme: a, children: /* @__PURE__ */ V.jsx($Y, { className: e, ...r, children: t }) });
}
const c8e = fl(
  lt(
    "inline-flex shadow-sm items-center justify-center gap-(--button-gap) leading-0 whitespace-nowrap rounded-(--button-radius) transition",
    "font-(family-name:--font-sans)",
    "focus-visible:outline-(color:--button-outline-color) focus-visible:outline-(length:--button-outline-width) focus-visible:outline-offset-(--button-outline-offset)",
    "disabled:shadow-none disabled:cursor-not-allowed"
  ),
  {
    variants: {
      kind: {
        primary: lt(
          "bg-(--background-primary-base) text-(--text-primary-base)",
          "hover:bg-(--background-primary-hover)",
          "active:bg-(--background-primary-active) active:duration-300",
          "not-active:data-[selected=true]:bg-[#2563eb]",
          "disabled:bg-(--background-primary-disabled) disabled:text-(--text-primary-disabled)",
          "data-[loading=true]:bg-(--background-primary-disabled) data-[loading=true]:text-(--text-primary-disabled)"
        ),
        secondary: lt(
          "bg-(--background-secondary-base) text-(--text-secondary-base)",
          "border border-(--border-secondary-base)",
          "hover:bg-(--background-secondary-hover)",
          "active:bg-(--background-secondary-active) active:duration-300",
          "not-active:data-[selected=true]:bg-[#60a5fa]",
          "disabled:bg-(--background-secondary-disabled) disabled:text-(--text-secondary-disabled) disabled:border-0",
          "data-[loading=true]:bg-(--background-secondary-disabled) data-[loading=true]:text-(--text-secondary-disabled)"
        ),
        destructive: lt(
          "bg-(--background-destructive-inverted) text-(--text-destructive-inverted)",
          "hover:bg-(--background-destructive-base) hover:text-(--text-destructive-base)",
          "active:bg-(--background-destructive-active) active:text-(--text-destructive-active) active:duration-300",
          "data-[selected=true]:outline-(--border-secondary-base) data-[selected=true]:outline-1 data-[selected=true]:outline-offset-0",
          "not-active:data-[selected=true]:bg-(--background-destructive-hover) not-active:data-[selected=true]:text-(--text-destructive-base)",
          "disabled:bg-(--background-destructive-disabled) disabled:text-(--text-destructive-disabled)",
          "data-[loading=true]:bg-(--background-destructive-disabled) data-[loading=true]:text-(--text-destructive-disabled)"
        ),
        text: lt(
          "bg-transparent shadow-none text-[#1677ff] enabled:hover:bg-[rgba(0,0,0,0.04)] enabled:active:bg-[rgba(0,0,0,0.15)] data-[loading=true]:opacity-[0.65] disabled:opacity-[0.65]",
          "data-[selected=true]:outline-(--border-secondary-base) data-[selected=true]:outline-1 data-[selected=true]:outline-offset-0",
          "not-active:data-[selected=true]:bg-[rgba(0,0,0,0.04)]"
        )
      },
      size: {
        small: "h-(--button-height-sm) px-(--button-padding-x-sm) text-(length:--button-font-size-sm)",
        medium: "h-(--button-height-md) px-(--button-padding-x-md) text-(length:--button-font-size-md)",
        large: "h-(--button-height-lg) px-(--button-padding-x-lg) text-(length:--button-font-size-lg)"
      },
      theme: {
        apollo: [],
        classic: []
      },
      iconPosition: {
        left: "flex-row",
        right: "flex-row-reverse"
      },
      loading: {
        true: "cursor-default pointer-events-none",
        false: "cursor-pointer"
      }
    },
    defaultVariants: {
      kind: "secondary",
      size: "medium",
      iconPosition: "left",
      loading: !1
    }
  }
), Qw = ks(
  ({
    altText: e,
    className: t,
    data_testid: r,
    htmlType: a = "button",
    iconColor: i,
    iconName: c,
    iconPosition: d = "left",
    iconSize: f,
    iconWidth: p,
    kind: g,
    label: b,
    loading: w = !1,
    margin: x,
    selected: E = !1,
    size: P,
    theme: k,
    width: M,
    children: T,
    ...N
  }, D) => {
    const $ = T || b, j = Do(Kj), I = k ?? j ?? "classic";
    return /* @__PURE__ */ V.jsx("span", { "data-preflight": !0, className: "contents", children: /* @__PURE__ */ V.jsxs(
      "button",
      {
        ref: D,
        "data-slot": "button",
        style: { margin: x, width: M },
        className: lt(
          c8e({
            iconPosition: d,
            kind: g,
            loading: w,
            size: P,
            theme: I
          }),
          t
        ),
        "aria-label": e,
        type: a,
        "data-selected": E ? "true" : "false",
        "data-testid": r,
        "data-loading": w ? "true" : "false",
        ...N,
        children: [
          w ? /* @__PURE__ */ V.jsx(
            _f,
            {
              name: "loadingOutlined",
              size: P === "small" ? 13 : P === "large" ? 18 : 16,
              color: i,
              className: "shrink-0"
            }
          ) : c && /* @__PURE__ */ V.jsx(
            _f,
            {
              name: c,
              size: f,
              width: p,
              color: i,
              className: "shrink-0"
            }
          ),
          $
        ]
      }
    ) });
  }
);
Qw.displayName = "Button";
const d8e = [
  "lab",
  "dev",
  "test",
  "qa",
  "production"
], fee = [
  "Test1",
  "Test2",
  "Test3",
  "Test4",
  "Test5"
], J1 = [
  ...d8e,
  ...fee,
  "local",
  "unknown"
], mee = {
  unknown: {},
  local: {},
  lab: { pageHosting: "uilab" },
  dev: { pageHosting: "uidev" },
  production: {
    caps: "caps",
    login: "cacb2ccaps",
    customerPortal: "customer",
    dealmax: "dealmax",
    pageHosting: "ui"
  },
  qa: {
    caps: "capsqa",
    login: "cacnonprdb2ccapsqa",
    customerPortal: "customerqa",
    dealmax: "dealmaxqa",
    pageHosting: "uiqa"
  },
  Test5: {
    caps: "capstst005",
    customerPortal: "customertest5",
    pageHosting: "uitest"
  },
  Test4: {
    caps: "capstst004",
    customerPortal: "customertest4",
    pageHosting: "uitest"
  },
  Test3: {
    caps: "capstst3",
    customerPortal: "customertest3",
    pageHosting: "uitest"
  },
  Test2: {
    caps: "capstst002",
    customerPortal: "customertest2",
    pageHosting: "uitest"
  },
  Test1: {
    caps: "capstst001",
    customerPortal: "customertest1",
    pageHosting: "uitest"
  },
  test: {
    caps: "capstst002",
    customerPortal: "customertest2",
    dealmax: "dealmaxtst",
    pageHosting: "uitest"
  }
}, ui = {
  LAB: J1[0],
  DEV: J1[1],
  TEST: J1[2],
  QA: J1[3],
  PRODUCTION: J1[4],
  TEST1: J1[5],
  TEST2: J1[6],
  TEST3: J1[7],
  TEST4: J1[8],
  TEST5: J1[9]
}, f8e = "SALESPERSON (APPROVAL ENTRY)", m8e = "OWNER", h8e = "SALESPERSON", p8e = "MANAGER", g8e = [
  m8e,
  p8e,
  h8e,
  f8e
];
function XV(e, t = window.location.origin) {
  const { hostname: r } = new URL(e, t), a = r.split(".").shift();
  if (!a)
    return "unknown";
  for (const [i, c] of Object.entries(mee)) {
    const d = Object.values(c);
    if (d && d.includes(a))
      return i;
  }
  return "unknown";
}
const c$ = "capsTestEnv";
function Qj(e, t) {
  if (window?.environment) {
    const { environment: r } = window;
    if (r === "test") {
      const a = sessionStorage.getItem(c$) ?? localStorage.getItem(c$);
      if (a && fee.includes(
        a
      ))
        return a;
      const i = XV(
        window.location.href,
        t
      );
      if (i.startsWith("Test"))
        return i;
    }
    return r;
  }
  return XV(
    window?.location.href ?? "",
    window?.location.origin ?? ""
  );
}
const v8e = /\/+/g;
function b8e(...e) {
  return e.join("/").replaceAll(v8e, "/");
}
function c7(e, t) {
  const r = Qj();
  if (r === "unknown" && t === "dealmax")
    return new URL(e, "https://dealmaxtst.creditacceptance.com").toString();
  if (r === "local" && t === "caps")
    return new URL(e, "http://localhost:7001").toString();
  if (r === "unknown")
    return new URL(e, window.location.origin).toString();
  if (t === "login") {
    let i, c;
    switch (r) {
      case "local":
      // We can't run login locally, but if we're running another application locally, use the Test tenant for login
      case "lab":
      case "dev":
      case "test":
      case "Test1":
      case "Test2":
      case "Test3":
      case "Test4":
      case "Test5": {
        i = "https://cacnonprdb2ccaps.b2clogin.com", c = "/cacnonprdb2ccaps.onmicrosoft.com/";
        break;
      }
      case "qa": {
        i = "https://cacnonprdb2ccapsqa.b2clogin.com", c = "/cacnonprdb2ccapsqa.onmicrosoft.com/";
        break;
      }
      case "production": {
        i = "https://cacb2ccaps.b2clogin.com", c = "/cacb2ccaps.onmicrosoft.com/";
        break;
      }
    }
    return new URL(b8e(c, e), i).toString();
  } else if (t === "dealmax") {
    let i;
    switch (r) {
      case "local":
      case "lab":
      case "dev":
      case "test":
      case "Test1":
      case "Test2":
      case "Test3":
      case "Test4":
      case "Test5": {
        i = "https://dealmaxtst.creditacceptance.com";
        break;
      }
      case "qa": {
        i = "https://dealmaxqa.creditacceptance.com";
        break;
      }
      case "production": {
        i = "https://dealmax.creditacceptance.com";
        break;
      }
    }
    return new URL(e, i).toString();
  }
  const a = (mee[r] ?? {})[t];
  if (!a)
    throw new Error(
      `${t === "caps" ? "CAPS" : "Dealer Portal"} does not exist in the ${r} environment.`
    );
  return new URL(e, `https://${a}.creditacceptance.com`).toString();
}
function Jj(e) {
  return c7(e, "caps");
}
function y8e(e) {
  return c7(e, "login");
}
function w8e(e) {
  return c7(e, "customerPortal");
}
function S8e(e) {
  return c7(e, "dealmax");
}
function C8e(e) {
  return c7(e, "pageHosting");
}
function x8e(e) {
  return e == null;
}
function hee(e) {
  return x8e(e) ? !0 : typeof e == "string" || Array.isArray(e) ? e.length === 0 : e instanceof Map || e instanceof Set ? e.size === 0 : typeof e == "object" ? Object.keys(e).length === 0 : !1;
}
function E8e(e) {
  const t = e.toUpperCase().trim();
  return !g8e.includes(t);
}
var xM = /* @__PURE__ */ ((e) => (e.CAPS = "CAPS", e.DVM = "DVM", e.DST = "DST", e.CAPS_BACKEND = "CAPS_BACKEND", e.PROOF_PORTAL = "PROOF_PORTAL", e))(xM || {});
const P8e = {
  CAPS: {
    [ui.DEV]: "66607fdbb7dd8410c663ed5d",
    [ui.PRODUCTION]: "66607f99d6a35910503bf8a2",
    [ui.QA]: "66607fede3f9710fe60923ff",
    [ui.TEST]: "66607f99d6a35910503bf8a1"
  },
  DVM: {
    [ui.DEV]: "6660dccfec448d1091acdc26",
    [ui.PRODUCTION]: "6660dcb4adc7361007bdff8d",
    [ui.QA]: "6660dcdccb91220fd8860bee",
    [ui.TEST]: "6660dcb4adc7361007bdff8c"
  },
  DST: {
    [ui.DEV]: "684fcb35bc58e7094bc0bda0",
    [ui.PRODUCTION]: "684fb737e6ea920938bc7aad",
    [ui.QA]: "684fb7c7fb80e70934c11505",
    [ui.TEST]: "684fb737e6ea920938bc7aac"
  },
  CAPS_BACKEND: {
    [ui.PRODUCTION]: "68093cab2067c708f2787eba",
    [ui.QA]: "6812697c1aae710df869ac86",
    [ui.TEST]: "68093cab2067c708f2787eb9"
  },
  PROOF_PORTAL: {
    [ui.DEV]: "689f47d7ef86ab099c4b1376",
    [ui.TEST]: "689f47947145060990902229",
    [ui.QA]: "689f47c8e061ab09983c7d84",
    [ui.PRODUCTION]: "689f4794714506099090222a"
  }
}, md = "release-dealer-experience-caps-dealer-portal-", k8e = "release-dealer-sales-tools-caps-dealer-portal-", sx = {
  approvals: `${md}approval-in-process`,
  contracts: `${md}contracts-in-progress`,
  collectionsStatus: `${md}collections-status`,
  collectionsPayments: `${md}collections-payments`,
  collectionsAccount: `${md}collections-account`,
  collectionsDispositions: `${md}collections-dispositions`,
  vehiclesNew: `${md}vehicles-new`,
  vehiclesAll: `${md}vehicles-all`,
  inventoryIssues: `${md}inventory-issues`,
  dealerProfile: `${md}dealer-profile`,
  userSetup: `${md}user-setup`,
  unproxy: `${md}unproxy`,
  signOut: `${md}signout`,
  updateVehicleFromStep3: `${md}update-vehicle-from-step-3`,
  step4: `${md}step-4`,
  step5: `${md}step-5`,
  step6: `${md}step-6`,
  notifications: `${md}notifications-page`,
  salesTools: `${k8e}auto-response-setup-page`,
  leads: "release-lead-management-system-caps-dealer-portal-leads-navigation-to-lms-leads",
  rehashAlternativeDeals: "release-dealer-experience-caps-rehash-header-alternative-deals",
  alternativeDealsNewExperience: "release-dealer-experience-caps-rehash-header-alternative-deals-new-experience",
  rehashDisplayProgramOptions: "release-dealer-experience-caps-rehash-display-program-options",
  inventoryRehash: "release-dealer-experience-caps-rehash-header-inventory-tab",
  adobeTagManager: "adobe-tag-manager-enabled"
}, M8e = {
  [sx.leads]: (e) => !hee(e),
  [sx.notifications]: Boolean,
  [sx.salesTools]: Boolean
}, O8e = {
  customerTools: "dealer-enabled"
}, T8e = [
  "actionType",
  "approvalId",
  "carLotPK",
  "count",
  "crmRegistryId",
  "dealMaxId",
  "errorId",
  "goTo",
  "isProgramCoordTrained",
  "isTpapGapEligible",
  "isTpapVscEligible",
  "pageHostingReturnPath",
  "vehicleId",
  "warningCode"
], ru = Object.fromEntries(
  T8e.map((e) => [e, `{{${e}}}`])
), d$ = {
  login: {
    domain: "caps",
    pathname: `/steps/login.jsf?pageHostingPath=${ru.pageHostingReturnPath}`
  },
  home: {
    domain: "pageHosting",
    pathname: "/pages/dealer/home"
  },
  leads: {
    domain: "caps",
    pathname: "/steps/pages/mydeals/aip/myDealsAIP.jsf?dealtype=NEW_LEAD"
  },
  newApproval: {
    domain: "pageHosting",
    pathname: "/pages/dealer/steps/step1"
  },
  approvals: {
    domain: "caps",
    pathname: "/steps/pages/mydeals/aip/myDealsAIP.jsf?origin=liferay"
  },
  contracts: {
    domain: "caps",
    pathname: "/steps/pages/mydeals/cip/myDealsCIP.jsf?origin=liferay"
  },
  collectionsStatus: {
    domain: "caps",
    pathname: "/steps/pages/collectionconnection/accountstatus.jsf?origin=liferay"
  },
  collectionsPayments: {
    domain: "caps",
    pathname: "/steps/pages/collectionconnection/accountpayment.jsf?origin=liferay"
  },
  collectionsAccount: {
    domain: "caps",
    pathname: "/steps/pages/collectionconnection/provideaccountinfo.jsf?origin=liferay"
  },
  collectionsDispositions: {
    domain: "caps",
    pathname: "/steps/pages/collectionconnection/dispositionCodes.jsf?origin=liferay"
  },
  updateAllVehicles: {
    domain: "caps",
    pathname: "/steps/pages/utililty/liferayhandshake.jsp?modulename=updateallvehicle&origin=liferay"
  },
  vehiclesNew: {
    domain: "caps",
    pathname: "/steps/pages/utililty/liferayhandshake.jsp?modulename=addvehicle&origin=liferay"
  },
  vehiclesAll: {
    domain: "caps",
    pathname: "/steps/pages/utililty/liferayhandshake.jsp?modulename=updateallvehicle&origin=liferay"
  },
  inventoryIssues: {
    domain: "caps",
    pathname: "/steps/pages/utililty/liferayhandshake.jsp?modulename=dailyinvetoryexception"
  },
  loyaltyBenefits: {
    domain: "caps",
    pathname: "/steps/pages/benefits/loyalty.jsf?origin=liferay"
  },
  poolPurchaseOffers: {
    domain: "caps",
    pathname: "/steps/pages/benefits/portfolio.jsf?origin=liferay"
  },
  resources: {
    domain: "pageHosting",
    pathname: "/pages/dealer/resources"
  },
  dealerProfile: {
    domain: "caps",
    pathname: "/steps/pages/dealersetup/dealersetup_main.jsf?origin=liferay"
  },
  userSetup: {
    domain: "caps",
    pathname: "/steps/pages/dealersetup/dealersetup_usersetup_usersearch.jsf?origin=liferay"
  },
  changePassword: {
    domain: "login",
    pathname: "PLACEHOLDER"
  },
  createApplications: {
    domain: "caps",
    pathname: "/steps/pages/contractsetup/createApprovalsExt.jsf?origin=liferay"
  },
  contactUs: {
    domain: "pageHosting",
    pathname: "/pages/dealer/contact-us"
  },
  unproxy: {
    domain: "caps",
    pathname: "/steps/pages/admin/dealer_search.jsf"
  },
  changeDealership: {
    domain: "caps",
    pathname: "/steps/pages/lotselection.jsf"
  },
  unreadEmails: {
    domain: "caps",
    pathname: "steps/pages/utililty/liferayhandshake.jsp?modulename=plusprofit"
  },
  signOut: {
    domain: "caps",
    pathname: "/steps/logout.jsf"
  },
  dealmaxView: {
    domain: "dealmax",
    pathname: `/ords/camobile/r/dealmax/detail-view?value=${ru.approvalId}`
  },
  dealmaxRestCall: {
    domain: "caps",
    pathname: `/steps/rest/dealMaxVerification?approvalId=${ru.approvalId}&carLotPK=${ru.carLotPK}&isTpapVscEligible=${ru.isTpapVscEligible}&isTpapGapEligible=${ru.isTpapGapEligible}&isProgramCoordTrained=${ru.isProgramCoordTrained}&count=${ru.count}`
  },
  checkAutoRunFlagValueDealmax: {
    domain: "caps",
    pathname: "/steps/rest/dealMaxVerification/autoRunDealmax"
  },
  dealerTerms: {
    domain: "caps",
    pathname: "/steps/pdfs/DealerUserAgreement.pdf"
  },
  dealerCaliforniaTerms: {
    domain: "customerPortal",
    pathname: "/consumer-privacy-act"
  },
  shoppingCart: {
    domain: "caps",
    pathname: "/steps/rest/navigation/shopping_cart_from_step3"
  },
  updateVehicleFromStep3: {
    domain: "caps",
    pathname: "/steps/rest/navigation/add_vehicle_from_step3"
  },
  step1: {
    domain: "pageHosting",
    pathname: `/pages/dealer/steps/step1/${ru.approvalId}`
  },
  step2: {
    domain: "pageHosting",
    pathname: `/pages/dealer/steps/step2/${ru.approvalId}`
  },
  step3: {
    domain: "pageHosting",
    pathname: `/pages/dealer/steps/step3/${ru.approvalId}`
  },
  step4: {
    domain: "caps",
    pathname: "/steps/pages/step4/step4.jsf"
  },
  step4ExistingStock: {
    domain: "caps",
    pathname: "/steps/rest/navigation/step4_with_existing_stock"
  },
  step5: {
    domain: "caps",
    pathname: "/steps/pages/step5/step5.jsf"
  },
  step6: {
    domain: "caps",
    pathname: "/steps/pages/step6/step6.jsf"
  },
  inventoryDownloadServlet: {
    domain: "caps",
    pathname: "/steps/pages/utililty/liferayhandshake.jsp?origin=liferay&modulename=dwreport&goTo=inventory/pages/portal/downloadServlet_Dealer.dwrep?contentType=octet-stream&reportName=missing_titles_detail&reportType=Weekly"
  },
  dealerUserAgreement: {
    domain: "caps",
    pathname: "/inventory/pages/inventory/downloadServlet_Dealer.dprep?contentType=octet-stream&reportName=user_agreement&reportCateg=Adhoc"
  },
  goldPDF: {
    domain: "caps",
    pathname: "/inventory/pages/portal/downloadServlet_Dealer.trep?contentType=octet-stream&reportName=gold_program_info"
  },
  customerTools: {
    domain: "pageHosting",
    pathname: "/pages/dealer/customer-tools"
  },
  notifications: {
    domain: "pageHosting",
    pathname: "/pages/dealer/settings/notifications"
  },
  salesTools: {
    domain: "pageHosting",
    pathname: "/pages/dealer/settings/sales-tools"
  },
  capsDealMaxUrl: {
    domain: "caps",
    pathname: `/steps/login.jsf?dealMaxId=${ru.dealMaxId}`
  },
  capsHandshakeUrl: {
    domain: "caps",
    // Unfortunately, the caps-steps handshake is inept to properly url-decode query params. So DON'T try to url-encode the goTo param.
    pathname: `/steps/pages/utililty/liferayhandshake.jsp?origin=liferay&modulename=dwreport&goTo=${ru.goTo}`
  },
  pullAndViewBureau: {
    domain: "caps",
    pathname: "/steps/pages/bureau/view_credit_bureau.jsf"
  },
  enrollmentFactSheet: {
    domain: "caps",
    pathname: `/steps/pages/capscrm/applicationFactSheet.jsf?registryID=${ru.crmRegistryId}`
  },
  inventoryWarningStockNumber: {
    domain: "caps",
    pathname: `/steps/pages/utililty/liferayhandshake.jsp?modulename=addvehicle&vehicleId=${ru.vehicleId}&actionType=${ru.actionType}&warningCode=${ru.warningCode}&origin=pageHosting`
  },
  inventoryErrorStockNumber: {
    domain: "caps",
    pathname: `/steps/pages/utililty/liferayhandshake.jsp?modulename=addvehicle&vehicleId=${ru.errorId}&actionType=${ru.actionType}&origin=pageHosting`
  },
  dealStructureRehash: {
    domain: "caps",
    pathname: `steps/authenticate.jsf?appID=${ru.approvalId}`
  },
  alternativeDealsRehash: {
    domain: "pageHosting",
    pathname: `/pages/dealer/alternative-deals/${ru.approvalId}`
  },
  stipulationsRehash: {
    domain: "pageHosting",
    pathname: `pages/proof-portal/dealer/${ru.approvalId}`
  },
  chargebacks: {
    domain: "pageHosting",
    pathname: "/pages/dealer/outstanding-chargebacks"
  },
  changeVehicleRehash: {
    domain: "pageHosting",
    pathname: `/pages/dealer/change-vehicle/${ru.approvalId}`
  },
  unauthorizedPage: {
    domain: "caps",
    //caps will redirect inactive dealers to /web/guest/caps-auth-exception
    pathname: "/steps/pages/unauthorized_user.jsf"
  }
};
function R8e() {
  let e, t, r;
  try {
    const c = Qj();
    r = Jj(""), c === "qa" ? (e = "B2C_1A_QA_CHANGEPASSWORD", t = "58d48733-0983-4d6b-ad6c-54f826e0d88b") : c === "production" ? (e = "B2C_1A_CHANGEPASSWORD", t = "73144a60-68e9-4c88-8943-b78f5c6c3fa0") : (e = "UNKNOWN", t = "UNKNOWN");
  } catch {
    e = "UNKNOWN", t = "UNKNOWN", r = "UNKNOWN";
  }
  const a = encodeURIComponent(r), i = `/oauth2/v2.0/authorize?p=${e}&client_id=${t}&nonce=defaultNonce&redirect_uri=${a}&scope=openid&response_type=id_token`;
  return {
    ...d$,
    changePassword: {
      ...d$.changePassword,
      pathname: i
    }
  };
}
function pee(e) {
  return !!d$[e];
}
function gee(e, t) {
  if (!t)
    return e;
  let r = e;
  for (const [a, i] of Object.entries(t)) {
    const c = new RegExp(`{{${a}}}`, "g");
    r = r.replace(c, i);
  }
  return r;
}
function tS(e, t, r) {
  if (!pee(e))
    throw new Error(`Unknown Location ${e}`);
  if (r) {
    const d = bee(e, t, r);
    if (d)
      return d;
  }
  const a = R8e()[e];
  let { pathname: i } = a;
  t && (i = gee(
    i,
    t
  ));
  let c;
  switch (a.domain) {
    case "caps": {
      c = Jj("");
      break;
    }
    case "dealmax": {
      c = S8e("");
      break;
    }
    case "customerPortal": {
      c = w8e("");
      break;
    }
    case "pageHosting": {
      c = C8e("");
      break;
    }
    default:
      return y8e(a.pathname);
  }
  return new URL(i, c).toString();
}
function vee(e, t, r) {
  window.location.href = tS(e, t, r);
}
function bee(e, t, r) {
  if (!pee(e))
    throw new Error(`Unknown Location ${e}`);
  const a = sx[e];
  if (!a)
    return tS(e, t);
  try {
    if (!r)
      return tS(e, t);
    const i = r.allFlags()[a];
    return typeof i != "string" || !i ? tS(e, t) : gee(i, t);
  } catch (i) {
    return console.error("Launch darkly initialization failed", i), tS(e, t);
  }
}
var HR = { exports: {} }, FR = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var GV;
function A8e() {
  if (GV) return FR;
  GV = 1;
  var e = Re;
  function t(w, x) {
    return w === x && (w !== 0 || 1 / w === 1 / x) || w !== w && x !== x;
  }
  var r = typeof Object.is == "function" ? Object.is : t, a = e.useState, i = e.useEffect, c = e.useLayoutEffect, d = e.useDebugValue;
  function f(w, x) {
    var E = x(), P = a({ inst: { value: E, getSnapshot: x } }), k = P[0].inst, M = P[1];
    return c(
      function() {
        k.value = E, k.getSnapshot = x, p(k) && M({ inst: k });
      },
      [w, E, x]
    ), i(
      function() {
        return p(k) && M({ inst: k }), w(function() {
          p(k) && M({ inst: k });
        });
      },
      [w]
    ), d(E), E;
  }
  function p(w) {
    var x = w.getSnapshot;
    w = w.value;
    try {
      var E = x();
      return !r(w, E);
    } catch {
      return !0;
    }
  }
  function g(w, x) {
    return x();
  }
  var b = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? g : f;
  return FR.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : b, FR;
}
var qV = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var KV;
function N8e() {
  return KV || (KV = 1, process.env.NODE_ENV !== "production" && (function() {
    function e(E, P) {
      return E === P && (E !== 0 || 1 / E === 1 / P) || E !== E && P !== P;
    }
    function t(E, P) {
      b || i.startTransition === void 0 || (b = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var k = P();
      if (!w) {
        var M = P();
        c(k, M) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), w = !0);
      }
      M = d({
        inst: { value: k, getSnapshot: P }
      });
      var T = M[0].inst, N = M[1];
      return p(
        function() {
          T.value = k, T.getSnapshot = P, r(T) && N({ inst: T });
        },
        [E, k, P]
      ), f(
        function() {
          return r(T) && N({ inst: T }), E(function() {
            r(T) && N({ inst: T });
          });
        },
        [E]
      ), g(k), k;
    }
    function r(E) {
      var P = E.getSnapshot;
      E = E.value;
      try {
        var k = P();
        return !c(E, k);
      } catch {
        return !0;
      }
    }
    function a(E, P) {
      return P();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var i = Re, c = typeof Object.is == "function" ? Object.is : e, d = i.useState, f = i.useEffect, p = i.useLayoutEffect, g = i.useDebugValue, b = !1, w = !1, x = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? a : t;
    qV.useSyncExternalStore = i.useSyncExternalStore !== void 0 ? i.useSyncExternalStore : x, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), qV;
}
var YV;
function D8e() {
  return YV || (YV = 1, process.env.NODE_ENV === "production" ? HR.exports = A8e() : HR.exports = N8e()), HR.exports;
}
var QV = D8e();
const yee = 0, wee = 1, See = 2, JV = 3;
var ZV = Object.prototype.hasOwnProperty;
function f$(e, t) {
  var r, a;
  if (e === t) return !0;
  if (e && t && (r = e.constructor) === t.constructor) {
    if (r === Date) return e.getTime() === t.getTime();
    if (r === RegExp) return e.toString() === t.toString();
    if (r === Array) {
      if ((a = e.length) === t.length)
        for (; a-- && f$(e[a], t[a]); ) ;
      return a === -1;
    }
    if (!r || typeof e == "object") {
      a = 0;
      for (r in e)
        if (ZV.call(e, r) && ++a && !ZV.call(t, r) || !(r in t) || !f$(e[r], t[r])) return !1;
      return Object.keys(t).length === a;
    }
  }
  return e !== e && t !== t;
}
const Jw = /* @__PURE__ */ new WeakMap(), nS = () => {
}, em = (
  /*#__NOINLINE__*/
  nS()
), m$ = Object, li = (e) => e === em, lb = (e) => typeof e == "function", GS = (e, t) => ({
  ...e,
  ...t
}), Cee = (e) => lb(e.then), WR = {}, aP = {}, Zj = "undefined", d7 = typeof window != Zj, h$ = typeof document != Zj, $8e = d7 && "Deno" in window, z8e = () => d7 && typeof window.requestAnimationFrame != Zj, xee = (e, t) => {
  const r = Jw.get(e);
  return [
    // Getter
    () => !li(t) && e.get(t) || WR,
    // Setter
    (a) => {
      if (!li(t)) {
        const i = e.get(t);
        t in aP || (aP[t] = i), r[5](t, GS(i, a), i || WR);
      }
    },
    // Subscriber
    r[6],
    // Get server cache snapshot
    () => !li(t) && t in aP ? aP[t] : !li(t) && e.get(t) || WR
  ];
};
let p$ = !0;
const j8e = () => p$, [g$, v$] = d7 && window.addEventListener ? [
  window.addEventListener.bind(window),
  window.removeEventListener.bind(window)
] : [
  nS,
  nS
], I8e = () => {
  const e = h$ && document.visibilityState;
  return li(e) || e !== "hidden";
}, L8e = (e) => (h$ && document.addEventListener("visibilitychange", e), g$("focus", e), () => {
  h$ && document.removeEventListener("visibilitychange", e), v$("focus", e);
}), H8e = (e) => {
  const t = () => {
    p$ = !0, e();
  }, r = () => {
    p$ = !1;
  };
  return g$("online", t), g$("offline", r), () => {
    v$("online", t), v$("offline", r);
  };
}, F8e = {
  isOnline: j8e,
  isVisible: I8e
}, W8e = {
  initFocus: L8e,
  initReconnect: H8e
}, e_ = !Re.useId, ux = !d7 || $8e, V8e = (e) => z8e() ? window.requestAnimationFrame(e) : setTimeout(e, 1), VR = ux ? Er : zS, _R = typeof navigator < "u" && navigator.connection, t_ = !ux && _R && ([
  "slow-2g",
  "2g"
].includes(_R.effectiveType) || _R.saveData), oP = /* @__PURE__ */ new WeakMap(), _8e = (e) => m$.prototype.toString.call(e), BR = (e, t) => e === `[object ${t}]`;
let B8e = 0;
const b$ = (e) => {
  const t = typeof e, r = _8e(e), a = BR(r, "Date"), i = BR(r, "RegExp"), c = BR(r, "Object");
  let d, f;
  if (m$(e) === e && !a && !i) {
    if (d = oP.get(e), d) return d;
    if (d = ++B8e + "~", oP.set(e, d), Array.isArray(e)) {
      for (d = "@", f = 0; f < e.length; f++)
        d += b$(e[f]) + ",";
      oP.set(e, d);
    }
    if (c) {
      d = "#";
      const p = m$.keys(e).sort();
      for (; !li(f = p.pop()); )
        li(e[f]) || (d += f + ":" + b$(e[f]) + ",");
      oP.set(e, d);
    }
  } else
    d = a ? e.toJSON() : t == "symbol" ? e.toString() : t == "string" ? JSON.stringify(e) : "" + e;
  return d;
}, eI = (e) => {
  if (lb(e))
    try {
      e = e();
    } catch {
      e = "";
    }
  const t = e;
  return e = typeof e == "string" ? e : (Array.isArray(e) ? e.length : e) ? b$(e) : "", [
    e,
    t
  ];
};
let U8e = 0;
const y$ = () => ++U8e;
async function Eee(...e) {
  const [t, r, a, i] = e, c = GS({
    populateCache: !0,
    throwOnError: !0
  }, typeof i == "boolean" ? {
    revalidate: i
  } : i || {});
  let d = c.populateCache;
  const f = c.rollbackOnError;
  let p = c.optimisticData;
  const g = (x) => typeof f == "function" ? f(x) : f !== !1, b = c.throwOnError;
  if (lb(r)) {
    const x = r, E = [], P = t.keys();
    for (const k of P)
      !/^\$(inf|sub)\$/.test(k) && x(t.get(k)._k) && E.push(k);
    return Promise.all(E.map(w));
  }
  return w(r);
  async function w(x) {
    const [E] = eI(x);
    if (!E) return;
    const [P, k] = xee(t, E), [M, T, N, D] = Jw.get(t), $ = () => {
      const G = M[E];
      return (lb(c.revalidate) ? c.revalidate(P().data, x) : c.revalidate !== !1) && (delete N[E], delete D[E], G && G[0]) ? G[0](See).then(() => P().data) : P().data;
    };
    if (e.length < 3)
      return $();
    let j = a, I, L = !1;
    const F = y$();
    T[E] = [
      F,
      0
    ];
    const _ = !li(p), W = P(), Q = W.data, U = W._c, Y = li(U) ? Q : U;
    if (_ && (p = lb(p) ? p(Y, Q) : p, k({
      data: p,
      _c: Y
    })), lb(j))
      try {
        j = j(Y);
      } catch (G) {
        I = G, L = !0;
      }
    if (j && Cee(j))
      if (j = await j.catch((G) => {
        I = G, L = !0;
      }), F !== T[E][0]) {
        if (L) throw I;
        return j;
      } else L && _ && g(I) && (d = !0, k({
        data: Y,
        _c: em
      }));
    if (d && !L)
      if (lb(d)) {
        const G = d(j, Y);
        k({
          data: G,
          error: em,
          _c: em
        });
      } else
        k({
          data: j,
          error: em,
          _c: em
        });
    if (T[E][1] = y$(), Promise.resolve($()).then(() => {
      k({
        _c: em
      });
    }), L) {
      if (b) throw I;
      return;
    }
    return j;
  }
}
const n_ = (e, t) => {
  for (const r in e)
    e[r][0] && e[r][0](t);
}, X8e = (e, t) => {
  if (!Jw.has(e)) {
    const r = GS(W8e, t), a = /* @__PURE__ */ Object.create(null), i = Eee.bind(em, e);
    let c = nS;
    const d = /* @__PURE__ */ Object.create(null), f = (b, w) => {
      const x = d[b] || [];
      return d[b] = x, x.push(w), () => x.splice(x.indexOf(w), 1);
    }, p = (b, w, x) => {
      e.set(b, w);
      const E = d[b];
      if (E)
        for (const P of E)
          P(w, x);
    }, g = () => {
      if (!Jw.has(e) && (Jw.set(e, [
        a,
        /* @__PURE__ */ Object.create(null),
        /* @__PURE__ */ Object.create(null),
        /* @__PURE__ */ Object.create(null),
        i,
        p,
        f
      ]), !ux)) {
        const b = r.initFocus(setTimeout.bind(em, n_.bind(em, a, yee))), w = r.initReconnect(setTimeout.bind(em, n_.bind(em, a, wee)));
        c = () => {
          b && b(), w && w(), Jw.delete(e);
        };
      }
    };
    return g(), [
      e,
      i,
      g,
      c
    ];
  }
  return [
    e,
    Jw.get(e)[4]
  ];
}, G8e = (e, t, r, a, i) => {
  const c = r.errorRetryCount, d = i.retryCount, f = ~~((Math.random() + 0.5) * (1 << (d < 8 ? d : 8))) * r.errorRetryInterval;
  !li(c) && d > c || setTimeout(a, f, i);
}, q8e = f$, [Pee, K8e] = X8e(/* @__PURE__ */ new Map()), Y8e = GS(
  {
    // events
    onLoadingSlow: nS,
    onSuccess: nS,
    onError: nS,
    onErrorRetry: G8e,
    onDiscarded: nS,
    // switches
    revalidateOnFocus: !0,
    revalidateOnReconnect: !0,
    revalidateIfStale: !0,
    shouldRetryOnError: !0,
    // timeouts
    errorRetryInterval: t_ ? 1e4 : 5e3,
    focusThrottleInterval: 5 * 1e3,
    dedupingInterval: 2 * 1e3,
    loadingTimeout: t_ ? 5e3 : 3e3,
    // providers
    compare: q8e,
    isPaused: () => !1,
    cache: Pee,
    mutate: K8e,
    fallback: {}
  },
  // use web preset by default
  F8e
), Q8e = (e, t) => {
  const r = GS(e, t);
  if (t) {
    const { use: a, fallback: i } = e, { use: c, fallback: d } = t;
    a && c && (r.use = a.concat(c)), i && d && (r.fallback = GS(i, d));
  }
  return r;
}, J8e = fp({}), Z8e = "$inf$", kee = d7 && window.__SWR_DEVTOOLS_USE__, e5e = kee ? window.__SWR_DEVTOOLS_USE__ : [], t5e = () => {
  kee && (window.__SWR_DEVTOOLS_REACT__ = Re);
}, n5e = (e) => lb(e[1]) ? [
  e[0],
  e[1],
  e[2] || {}
] : [
  e[0],
  null,
  (e[1] === null ? e[2] : e[1]) || {}
], r5e = () => {
  const e = Do(J8e);
  return mn(() => GS(Y8e, e), [
    e
  ]);
}, a5e = (e) => (t, r, a) => e(t, r && ((...i) => {
  const [c] = eI(t), [, , , d] = Jw.get(Pee);
  if (c.startsWith(Z8e))
    return r(...i);
  const f = d[c];
  return li(f) ? r(...i) : (delete d[c], f);
}), a), o5e = e5e.concat(a5e), i5e = (e) => function(...t) {
  const r = r5e(), [a, i, c] = n5e(t), d = Q8e(r, c);
  let f = e;
  const { use: p } = d, g = (p || []).concat(o5e);
  for (let b = g.length; b--; )
    f = g[b](f);
  return f(a, i || d.fetcher || null, d);
}, l5e = (e, t, r) => {
  const a = t[e] || (t[e] = []);
  return a.push(r), () => {
    const i = a.indexOf(r);
    i >= 0 && (a[i] = a[a.length - 1], a.pop());
  };
};
t5e();
const UR = Re.use || // This extra generic is to avoid TypeScript mixing up the generic and JSX sytax
// and emitting an error.
// We assume that this is only for the `use(thenable)` case, not `use(context)`.
// https://github.com/facebook/react/blob/aed00dacfb79d17c53218404c52b1c7aa59c4a89/packages/react-server/src/ReactFizzThenable.js#L45
((e) => {
  switch (e.status) {
    case "pending":
      throw e;
    case "fulfilled":
      return e.value;
    case "rejected":
      throw e.reason;
    default:
      throw e.status = "pending", e.then((t) => {
        e.status = "fulfilled", e.value = t;
      }, (t) => {
        e.status = "rejected", e.reason = t;
      }), e;
  }
}), XR = {
  dedupe: !0
}, r_ = Promise.resolve(em), s5e = (e, t, r) => {
  const { cache: a, compare: i, suspense: c, fallbackData: d, revalidateOnMount: f, revalidateIfStale: p, refreshInterval: g, refreshWhenHidden: b, refreshWhenOffline: w, keepPreviousData: x, strictServerPrefetchWarning: E } = r, [P, k, M, T] = Jw.get(a), [N, D] = eI(e), $ = It(!1), j = It(!1), I = It(N), L = It(t), F = It(r), _ = () => F.current, W = () => _().isVisible() && _().isOnline(), [Q, U, Y, G] = xee(a, N), J = It({}).current, H = li(d) ? li(r.fallback) ? em : r.fallback[N] : d, K = (Ne, pe) => {
    for (const Qe in J) {
      const Le = Qe;
      if (Le === "data") {
        if (!i(Ne[Le], pe[Le]) && (!li(Ne[Le]) || !i(be, pe[Le])))
          return !1;
      } else if (pe[Le] !== Ne[Le])
        return !1;
    }
    return !0;
  }, X = mn(() => {
    const Ne = !N || !t ? !1 : li(f) ? _().isPaused() || c ? !1 : p !== !1 : f, pe = (je) => {
      const Ue = GS(je);
      return delete Ue._k, Ne ? {
        isValidating: !0,
        isLoading: !0,
        ...Ue
      } : Ue;
    }, Qe = Q(), Le = G(), Te = pe(Qe), Oe = Qe === Le ? Te : pe(Le);
    let ye = Te;
    return [
      () => {
        const je = pe(Q());
        return K(je, ye) ? (ye.data = je.data, ye.isLoading = je.isLoading, ye.isValidating = je.isValidating, ye.error = je.error, ye) : (ye = je, je);
      },
      () => Oe
    ];
  }, [
    a,
    N
  ]), te = QV.useSyncExternalStore(Cn(
    (Ne) => Y(N, (pe, Qe) => {
      K(Qe, pe) || Ne();
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      a,
      N
    ]
  ), X[0], X[1]), ie = !$.current, ee = P[N] && P[N].length > 0, ne = te.data, ae = li(ne) ? H && Cee(H) ? UR(H) : H : ne, oe = te.error, fe = It(ae), be = x ? li(ne) ? li(fe.current) ? ae : fe.current : ne : ae, me = N && li(ae), De = !ux && // eslint-disable-next-line react-hooks/rules-of-hooks
  QV.useSyncExternalStore(() => nS, () => !1, () => !0);
  E && De && !c && me && console.warn(`Missing pre-initiated data for serialized key "${N}" during server-side rendering. Data fethcing should be initiated on the server and provided to SWR via fallback data. You can set "strictServerPrefetchWarning: false" to disable this warning.`);
  const Me = ee && !li(oe) ? !1 : ie && !li(f) ? f : _().isPaused() ? !1 : c ? li(ae) ? !1 : p : li(ae) || p, ze = !!(N && t && ie && Me), le = li(te.isValidating) ? ze : te.isValidating, se = li(te.isLoading) ? ze : te.isLoading, Ae = Cn(
    async (Ne) => {
      const pe = L.current;
      if (!N || !pe || j.current || _().isPaused())
        return !1;
      let Qe, Le, Te = !0;
      const Oe = Ne || {}, ye = !M[N] || !Oe.dedupe, je = () => e_ ? !j.current && N === I.current && $.current : N === I.current, Ue = {
        isValidating: !1,
        isLoading: !1
      }, Fe = () => {
        U(Ue);
      }, tt = () => {
        const St = M[N];
        St && St[1] === Le && delete M[N];
      }, dt = {
        isValidating: !0
      };
      li(Q().data) && (dt.isLoading = !0);
      try {
        if (ye && (U(dt), r.loadingTimeout && li(Q().data) && setTimeout(() => {
          Te && je() && _().onLoadingSlow(N, r);
        }, r.loadingTimeout), M[N] = [
          pe(D),
          y$()
        ]), [Qe, Le] = M[N], Qe = await Qe, ye && setTimeout(tt, r.dedupingInterval), !M[N] || M[N][1] !== Le)
          return ye && je() && _().onDiscarded(N), !1;
        Ue.error = em;
        const St = k[N];
        if (!li(St) && // case 1
        (Le <= St[0] || // case 2
        Le <= St[1] || // case 3
        St[1] === 0))
          return Fe(), ye && je() && _().onDiscarded(N), !1;
        const mt = Q().data;
        Ue.data = i(mt, Qe) ? mt : Qe, ye && je() && _().onSuccess(Qe, N, r);
      } catch (St) {
        tt();
        const mt = _(), { shouldRetryOnError: Ot } = mt;
        mt.isPaused() || (Ue.error = St, ye && je() && (mt.onError(St, N, mt), (Ot === !0 || lb(Ot) && Ot(St)) && (!_().revalidateOnFocus || !_().revalidateOnReconnect || W()) && mt.onErrorRetry(St, N, mt, (Rt) => {
          const ct = P[N];
          ct && ct[0] && ct[0](JV, Rt);
        }, {
          retryCount: (Oe.retryCount || 0) + 1,
          dedupe: !0
        })));
      }
      return Te = !1, Fe(), !0;
    },
    // `setState` is immutable, and `eventsCallback`, `fnArg`, and
    // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      N,
      a
    ]
  ), we = Cn(
    // Use callback to make sure `keyRef.current` returns latest result every time
    (...Ne) => Eee(a, I.current, ...Ne),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  if (VR(() => {
    L.current = t, F.current = r, li(ne) || (fe.current = ne);
  }), VR(() => {
    if (!N) return;
    const Ne = Ae.bind(em, XR);
    let pe = 0;
    _().revalidateOnFocus && (pe = Date.now() + _().focusThrottleInterval);
    const Qe = l5e(N, P, (Le, Te = {}) => {
      if (Le == yee) {
        const Oe = Date.now();
        _().revalidateOnFocus && Oe > pe && W() && (pe = Oe + _().focusThrottleInterval, Ne());
      } else if (Le == wee)
        _().revalidateOnReconnect && W() && Ne();
      else {
        if (Le == See)
          return Ae();
        if (Le == JV)
          return Ae(Te);
      }
    });
    return j.current = !1, I.current = N, $.current = !0, U({
      _k: D
    }), Me && (M[N] || (li(ae) || ux ? Ne() : V8e(Ne))), () => {
      j.current = !0, Qe();
    };
  }, [
    N
  ]), VR(() => {
    let Ne;
    function pe() {
      const Le = lb(g) ? g(Q().data) : g;
      Le && Ne !== -1 && (Ne = setTimeout(Qe, Le));
    }
    function Qe() {
      !Q().error && (b || _().isVisible()) && (w || _().isOnline()) ? Ae(XR).then(pe) : pe();
    }
    return pe(), () => {
      Ne && (clearTimeout(Ne), Ne = -1);
    };
  }, [
    g,
    b,
    w,
    N
  ]), ale(be), c) {
    if (!e_ && ux && me)
      throw new Error("Fallback data is required when using Suspense in SSR.");
    me && (L.current = t, F.current = r, j.current = !1);
    const Ne = T[N], pe = !li(Ne) && me ? we(Ne) : r_;
    if (UR(pe), !li(oe) && me)
      throw oe;
    const Qe = me ? Ae(XR) : r_;
    !li(be) && me && (Qe.status = "fulfilled", Qe.value = !0), UR(Qe);
  }
  return {
    mutate: we,
    get data() {
      return J.data = !0, be;
    },
    get error() {
      return J.error = !0, oe;
    },
    get isValidating() {
      return J.isValidating = !0, le;
    },
    get isLoading() {
      return J.isLoading = !0, se;
    }
  };
}, a_ = i5e(s5e);
async function o_(e) {
  const [t, r] = Array.isArray(e) ? e : [e, void 0], a = typeof t == "string" ? t : t(), i = await fetch(a, {
    credentials: "include",
    mode: "cors"
  });
  if (!i.ok)
    throw new Error(`Failed to retrieve ${r}. Status: ${i.status}`);
  try {
    return await i.json();
  } catch (c) {
    throw console.error(
      `Failed to parse JSON from ${r}. Received Response:`,
      i
    ), new Error(`Failed to retrieve ${r}. Error: ${c}`);
  }
}
function Mee(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: u5e } = Object.prototype, { getPrototypeOf: tI } = Object, { iterator: EM, toStringTag: Oee } = Symbol, PM = /* @__PURE__ */ ((e) => (t) => {
  const r = u5e.call(t);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Y1 = (e) => (e = e.toLowerCase(), (t) => PM(t) === e), kM = (e) => (t) => typeof t === e, { isArray: o6 } = Array, Rx = kM("undefined");
function f7(e) {
  return e !== null && !Rx(e) && e.constructor !== null && !Rx(e.constructor) && op(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Tee = Y1("ArrayBuffer");
function c5e(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Tee(e.buffer), t;
}
const d5e = kM("string"), op = kM("function"), Ree = kM("number"), m7 = (e) => e !== null && typeof e == "object", f5e = (e) => e === !0 || e === !1, gk = (e) => {
  if (PM(e) !== "object")
    return !1;
  const t = tI(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Oee in e) && !(EM in e);
}, m5e = (e) => {
  if (!m7(e) || f7(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, h5e = Y1("Date"), p5e = Y1("File"), g5e = Y1("Blob"), v5e = Y1("FileList"), b5e = (e) => m7(e) && op(e.pipe), y5e = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || op(e.append) && ((t = PM(e)) === "formdata" || // detect form-data instance
  t === "object" && op(e.toString) && e.toString() === "[object FormData]"));
}, w5e = Y1("URLSearchParams"), [S5e, C5e, x5e, E5e] = [
  "ReadableStream",
  "Request",
  "Response",
  "Headers"
].map(Y1), P5e = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function h7(e, t, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let a, i;
  if (typeof e != "object" && (e = [e]), o6(e))
    for (a = 0, i = e.length; a < i; a++)
      t.call(null, e[a], a, e);
  else {
    if (f7(e))
      return;
    const c = r ? Object.getOwnPropertyNames(e) : Object.keys(e), d = c.length;
    let f;
    for (a = 0; a < d; a++)
      f = c[a], t.call(null, e[f], f, e);
  }
}
function Aee(e, t) {
  if (f7(e))
    return null;
  t = t.toLowerCase();
  const r = Object.keys(e);
  let a = r.length, i;
  for (; a-- > 0; )
    if (i = r[a], t === i.toLowerCase())
      return i;
  return null;
}
const U4 = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Nee = (e) => !Rx(e) && e !== U4;
function w$() {
  const { caseless: e, skipUndefined: t } = Nee(this) && this || {}, r = {}, a = (i, c) => {
    if (c === "__proto__" || c === "constructor" || c === "prototype")
      return;
    const d = e && Aee(r, c) || c;
    gk(r[d]) && gk(i) ? r[d] = w$(r[d], i) : gk(i) ? r[d] = w$({}, i) : o6(i) ? r[d] = i.slice() : (!t || !Rx(i)) && (r[d] = i);
  };
  for (let i = 0, c = arguments.length; i < c; i++)
    arguments[i] && h7(arguments[i], a);
  return r;
}
const k5e = (e, t, r, { allOwnKeys: a } = {}) => (h7(
  t,
  (i, c) => {
    r && op(i) ? Object.defineProperty(e, c, {
      value: Mee(i, r),
      writable: !0,
      enumerable: !0,
      configurable: !0
    }) : Object.defineProperty(e, c, {
      value: i,
      writable: !0,
      enumerable: !0,
      configurable: !0
    });
  },
  { allOwnKeys: a }
), e), M5e = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), O5e = (e, t, r, a) => {
  e.prototype = Object.create(
    t.prototype,
    a
  ), Object.defineProperty(e.prototype, "constructor", {
    value: e,
    writable: !0,
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e, "super", {
    value: t.prototype
  }), r && Object.assign(e.prototype, r);
}, T5e = (e, t, r, a) => {
  let i, c, d;
  const f = {};
  if (t = t || {}, e == null) return t;
  do {
    for (i = Object.getOwnPropertyNames(e), c = i.length; c-- > 0; )
      d = i[c], (!a || a(d, e, t)) && !f[d] && (t[d] = e[d], f[d] = !0);
    e = r !== !1 && tI(e);
  } while (e && (!r || r(e, t)) && e !== Object.prototype);
  return t;
}, R5e = (e, t, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= t.length;
  const a = e.indexOf(t, r);
  return a !== -1 && a === r;
}, A5e = (e) => {
  if (!e) return null;
  if (o6(e)) return e;
  let t = e.length;
  if (!Ree(t)) return null;
  const r = new Array(t);
  for (; t-- > 0; )
    r[t] = e[t];
  return r;
}, N5e = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && tI(Uint8Array)), D5e = (e, t) => {
  const r = (e && e[EM]).call(e);
  let a;
  for (; (a = r.next()) && !a.done; ) {
    const i = a.value;
    t.call(e, i[0], i[1]);
  }
}, $5e = (e, t) => {
  let r;
  const a = [];
  for (; (r = e.exec(t)) !== null; )
    a.push(r);
  return a;
}, z5e = Y1("HTMLFormElement"), j5e = (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(t, r, a) {
  return r.toUpperCase() + a;
}), i_ = (({ hasOwnProperty: e }) => (t, r) => e.call(t, r))(Object.prototype), I5e = Y1("RegExp"), Dee = (e, t) => {
  const r = Object.getOwnPropertyDescriptors(e), a = {};
  h7(r, (i, c) => {
    let d;
    (d = t(i, c, e)) !== !1 && (a[c] = d || i);
  }), Object.defineProperties(e, a);
}, L5e = (e) => {
  Dee(e, (t, r) => {
    if (op(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const a = e[r];
    if (op(a)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, H5e = (e, t) => {
  const r = {}, a = (i) => {
    i.forEach((c) => {
      r[c] = !0;
    });
  };
  return o6(e) ? a(e) : a(String(e).split(t)), r;
}, F5e = () => {
}, W5e = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function V5e(e) {
  return !!(e && op(e.append) && e[Oee] === "FormData" && e[EM]);
}
const _5e = (e) => {
  const t = new Array(10), r = (a, i) => {
    if (m7(a)) {
      if (t.indexOf(a) >= 0)
        return;
      if (f7(a))
        return a;
      if (!("toJSON" in a)) {
        t[i] = a;
        const c = o6(a) ? [] : {};
        return h7(a, (d, f) => {
          const p = r(d, i + 1);
          !Rx(p) && (c[f] = p);
        }), t[i] = void 0, c;
      }
    }
    return a;
  };
  return r(e, 0);
}, B5e = Y1("AsyncFunction"), U5e = (e) => e && (m7(e) || op(e)) && op(e.then) && op(e.catch), $ee = ((e, t) => e ? setImmediate : t ? ((r, a) => (U4.addEventListener(
  "message",
  ({ source: i, data: c }) => {
    i === U4 && c === r && a.length && a.shift()();
  },
  !1
), (i) => {
  a.push(i), U4.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(typeof setImmediate == "function", op(U4.postMessage)), X5e = typeof queueMicrotask < "u" ? queueMicrotask.bind(U4) : typeof process < "u" && process.nextTick || $ee, G5e = (e) => e != null && op(e[EM]), Tt = {
  isArray: o6,
  isArrayBuffer: Tee,
  isBuffer: f7,
  isFormData: y5e,
  isArrayBufferView: c5e,
  isString: d5e,
  isNumber: Ree,
  isBoolean: f5e,
  isObject: m7,
  isPlainObject: gk,
  isEmptyObject: m5e,
  isReadableStream: S5e,
  isRequest: C5e,
  isResponse: x5e,
  isHeaders: E5e,
  isUndefined: Rx,
  isDate: h5e,
  isFile: p5e,
  isBlob: g5e,
  isRegExp: I5e,
  isFunction: op,
  isStream: b5e,
  isURLSearchParams: w5e,
  isTypedArray: N5e,
  isFileList: v5e,
  forEach: h7,
  merge: w$,
  extend: k5e,
  trim: P5e,
  stripBOM: M5e,
  inherits: O5e,
  toFlatObject: T5e,
  kindOf: PM,
  kindOfTest: Y1,
  endsWith: R5e,
  toArray: A5e,
  forEachEntry: D5e,
  matchAll: $5e,
  isHTMLForm: z5e,
  hasOwnProperty: i_,
  hasOwnProp: i_,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Dee,
  freezeMethods: L5e,
  toObjectSet: H5e,
  toCamelCase: j5e,
  noop: F5e,
  toFiniteNumber: W5e,
  findKey: Aee,
  global: U4,
  isContextDefined: Nee,
  isSpecCompliantForm: V5e,
  toJSONObject: _5e,
  isAsyncFn: B5e,
  isThenable: U5e,
  setImmediate: $ee,
  asap: X5e,
  isIterable: G5e
};
let ga = class zee extends Error {
  static from(t, r, a, i, c, d) {
    const f = new zee(t.message, r || t.code, a, i, c);
    return f.cause = t, f.name = t.name, d && Object.assign(f, d), f;
  }
  /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */
  constructor(t, r, a, i, c) {
    super(t), this.name = "AxiosError", this.isAxiosError = !0, r && (this.code = r), a && (this.config = a), i && (this.request = i), c && (this.response = c, this.status = c.status);
  }
  toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: Tt.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
};
ga.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE";
ga.ERR_BAD_OPTION = "ERR_BAD_OPTION";
ga.ECONNABORTED = "ECONNABORTED";
ga.ETIMEDOUT = "ETIMEDOUT";
ga.ERR_NETWORK = "ERR_NETWORK";
ga.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS";
ga.ERR_DEPRECATED = "ERR_DEPRECATED";
ga.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE";
ga.ERR_BAD_REQUEST = "ERR_BAD_REQUEST";
ga.ERR_CANCELED = "ERR_CANCELED";
ga.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT";
ga.ERR_INVALID_URL = "ERR_INVALID_URL";
const q5e = null;
function S$(e) {
  return Tt.isPlainObject(e) || Tt.isArray(e);
}
function jee(e) {
  return Tt.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function l_(e, t, r) {
  return e ? e.concat(t).map(function(a, i) {
    return a = jee(a), !r && i ? "[" + a + "]" : a;
  }).join(r ? "." : "") : t;
}
function K5e(e) {
  return Tt.isArray(e) && !e.some(S$);
}
const Y5e = Tt.toFlatObject(Tt, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function MM(e, t, r) {
  if (!Tt.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), r = Tt.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(E, P) {
    return !Tt.isUndefined(P[E]);
  });
  const a = r.metaTokens, i = r.visitor || g, c = r.dots, d = r.indexes, f = (r.Blob || typeof Blob < "u" && Blob) && Tt.isSpecCompliantForm(t);
  if (!Tt.isFunction(i))
    throw new TypeError("visitor must be a function");
  function p(E) {
    if (E === null) return "";
    if (Tt.isDate(E))
      return E.toISOString();
    if (Tt.isBoolean(E))
      return E.toString();
    if (!f && Tt.isBlob(E))
      throw new ga("Blob is not supported. Use a Buffer instead.");
    return Tt.isArrayBuffer(E) || Tt.isTypedArray(E) ? f && typeof Blob == "function" ? new Blob([E]) : Buffer.from(E) : E;
  }
  function g(E, P, k) {
    let M = E;
    if (E && !k && typeof E == "object") {
      if (Tt.endsWith(P, "{}"))
        P = a ? P : P.slice(0, -2), E = JSON.stringify(E);
      else if (Tt.isArray(E) && K5e(E) || (Tt.isFileList(E) || Tt.endsWith(P, "[]")) && (M = Tt.toArray(E)))
        return P = jee(P), M.forEach(function(T, N) {
          !(Tt.isUndefined(T) || T === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            d === !0 ? l_([P], N, c) : d === null ? P : P + "[]",
            p(T)
          );
        }), !1;
    }
    return S$(E) ? !0 : (t.append(l_(k, P, c), p(E)), !1);
  }
  const b = [], w = Object.assign(Y5e, {
    defaultVisitor: g,
    convertValue: p,
    isVisitable: S$
  });
  function x(E, P) {
    if (!Tt.isUndefined(E)) {
      if (b.indexOf(E) !== -1)
        throw Error("Circular reference detected in " + P.join("."));
      b.push(E), Tt.forEach(E, function(k, M) {
        (!(Tt.isUndefined(k) || k === null) && i.call(
          t,
          k,
          Tt.isString(M) ? M.trim() : M,
          P,
          w
        )) === !0 && x(k, P ? P.concat(M) : [M]);
      }), b.pop();
    }
  }
  if (!Tt.isObject(e))
    throw new TypeError("data must be an object");
  return x(e), t;
}
function s_(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function nI(e, t) {
  this._pairs = [], e && MM(e, this, t);
}
const Iee = nI.prototype;
Iee.append = function(e, t) {
  this._pairs.push([e, t]);
};
Iee.toString = function(e) {
  const t = e ? function(r) {
    return e.call(this, r, s_);
  } : s_;
  return this._pairs.map(function(r) {
    return t(r[0]) + "=" + t(r[1]);
  }, "").join("&");
};
function Q5e(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function Lee(e, t, r) {
  if (!t)
    return e;
  const a = r && r.encode || Q5e, i = Tt.isFunction(r) ? {
    serialize: r
  } : r, c = i && i.serialize;
  let d;
  if (c ? d = c(t, i) : d = Tt.isURLSearchParams(t) ? t.toString() : new nI(t, i).toString(a), d) {
    const f = e.indexOf("#");
    f !== -1 && (e = e.slice(0, f)), e += (e.indexOf("?") === -1 ? "?" : "&") + d;
  }
  return e;
}
class u_ {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, r, a) {
    return this.handlers.push({
      fulfilled: t,
      rejected: r,
      synchronous: a ? a.synchronous : !1,
      runWhen: a ? a.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    Tt.forEach(this.handlers, function(r) {
      r !== null && t(r);
    });
  }
}
const rI = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1,
  legacyInterceptorReqResOrdering: !0
}, J5e = typeof URLSearchParams < "u" ? URLSearchParams : nI, Z5e = typeof FormData < "u" ? FormData : null, eEe = typeof Blob < "u" ? Blob : null, tEe = {
  isBrowser: !0,
  classes: {
    URLSearchParams: J5e,
    FormData: Z5e,
    Blob: eEe
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, aI = typeof window < "u" && typeof document < "u", C$ = typeof navigator == "object" && navigator || void 0, nEe = aI && (!C$ || ["ReactNative", "NativeScript", "NS"].indexOf(C$.product) < 0), rEe = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", aEe = aI && window.location.href || "http://localhost", oEe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: aI,
  hasStandardBrowserEnv: nEe,
  hasStandardBrowserWebWorkerEnv: rEe,
  navigator: C$,
  origin: aEe
}, Symbol.toStringTag, { value: "Module" })), nm = {
  ...oEe,
  ...tEe
};
function iEe(e, t) {
  return MM(e, new nm.classes.URLSearchParams(), {
    visitor: function(r, a, i, c) {
      return nm.isNode && Tt.isBuffer(r) ? (this.append(a, r.toString("base64")), !1) : c.defaultVisitor.apply(this, arguments);
    },
    ...t
  });
}
function lEe(e) {
  return Tt.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function sEe(e) {
  const t = {}, r = Object.keys(e);
  let a;
  const i = r.length;
  let c;
  for (a = 0; a < i; a++)
    c = r[a], t[c] = e[c];
  return t;
}
function Hee(e) {
  function t(r, a, i, c) {
    let d = r[c++];
    if (d === "__proto__") return !0;
    const f = Number.isFinite(+d), p = c >= r.length;
    return d = !d && Tt.isArray(i) ? i.length : d, p ? (Tt.hasOwnProp(i, d) ? i[d] = [i[d], a] : i[d] = a, !f) : ((!i[d] || !Tt.isObject(i[d])) && (i[d] = []), t(r, a, i[d], c) && Tt.isArray(i[d]) && (i[d] = sEe(i[d])), !f);
  }
  if (Tt.isFormData(e) && Tt.isFunction(e.entries)) {
    const r = {};
    return Tt.forEachEntry(e, (a, i) => {
      t(lEe(a), i, r, 0);
    }), r;
  }
  return null;
}
function uEe(e, t, r) {
  if (Tt.isString(e))
    try {
      return (t || JSON.parse)(e), Tt.trim(e);
    } catch (a) {
      if (a.name !== "SyntaxError")
        throw a;
    }
  return (r || JSON.stringify)(e);
}
const p7 = {
  transitional: rI,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, t) {
    const r = t.getContentType() || "", a = r.indexOf("application/json") > -1, i = Tt.isObject(e);
    if (i && Tt.isHTMLForm(e) && (e = new FormData(e)), Tt.isFormData(e))
      return a ? JSON.stringify(Hee(e)) : e;
    if (Tt.isArrayBuffer(e) || Tt.isBuffer(e) || Tt.isStream(e) || Tt.isFile(e) || Tt.isBlob(e) || Tt.isReadableStream(e))
      return e;
    if (Tt.isArrayBufferView(e))
      return e.buffer;
    if (Tt.isURLSearchParams(e))
      return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let c;
    if (i) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return iEe(e, this.formSerializer).toString();
      if ((c = Tt.isFileList(e)) || r.indexOf("multipart/form-data") > -1) {
        const d = this.env && this.env.FormData;
        return MM(
          c ? { "files[]": e } : e,
          d && new d(),
          this.formSerializer
        );
      }
    }
    return i || a ? (t.setContentType("application/json", !1), uEe(e)) : e;
  }],
  transformResponse: [function(e) {
    const t = this.transitional || p7.transitional, r = t && t.forcedJSONParsing, a = this.responseType === "json";
    if (Tt.isResponse(e) || Tt.isReadableStream(e))
      return e;
    if (e && Tt.isString(e) && (r && !this.responseType || a)) {
      const i = !(t && t.silentJSONParsing) && a;
      try {
        return JSON.parse(e, this.parseReviver);
      } catch (c) {
        if (i)
          throw c.name === "SyntaxError" ? ga.from(c, ga.ERR_BAD_RESPONSE, this, null, this.response) : c;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: nm.classes.FormData,
    Blob: nm.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
Tt.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  p7.headers[e] = {};
});
const cEe = Tt.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), dEe = (e) => {
  const t = {};
  let r, a, i;
  return e && e.split(`
`).forEach(function(c) {
    i = c.indexOf(":"), r = c.substring(0, i).trim().toLowerCase(), a = c.substring(i + 1).trim(), !(!r || t[r] && cEe[r]) && (r === "set-cookie" ? t[r] ? t[r].push(a) : t[r] = [a] : t[r] = t[r] ? t[r] + ", " + a : a);
  }), t;
}, c_ = Symbol("internals");
function z5(e) {
  return e && String(e).trim().toLowerCase();
}
function vk(e) {
  return e === !1 || e == null ? e : Tt.isArray(e) ? e.map(vk) : String(e);
}
function fEe(e) {
  const t = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let a;
  for (; a = r.exec(e); )
    t[a[1]] = a[2];
  return t;
}
const mEe = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function GR(e, t, r, a, i) {
  if (Tt.isFunction(a))
    return a.call(this, t, r);
  if (i && (t = r), !!Tt.isString(t)) {
    if (Tt.isString(a))
      return t.indexOf(a) !== -1;
    if (Tt.isRegExp(a))
      return a.test(t);
  }
}
function hEe(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, r, a) => r.toUpperCase() + a);
}
function pEe(e, t) {
  const r = Tt.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((a) => {
    Object.defineProperty(e, a + r, {
      value: function(i, c, d) {
        return this[a].call(this, t, i, c, d);
      },
      configurable: !0
    });
  });
}
let ip = class {
  constructor(e) {
    e && this.set(e);
  }
  set(e, t, r) {
    const a = this;
    function i(d, f, p) {
      const g = z5(f);
      if (!g)
        throw new Error("header name must be a non-empty string");
      const b = Tt.findKey(a, g);
      (!b || a[b] === void 0 || p === !0 || p === void 0 && a[b] !== !1) && (a[b || f] = vk(d));
    }
    const c = (d, f) => Tt.forEach(d, (p, g) => i(p, g, f));
    if (Tt.isPlainObject(e) || e instanceof this.constructor)
      c(e, t);
    else if (Tt.isString(e) && (e = e.trim()) && !mEe(e))
      c(dEe(e), t);
    else if (Tt.isObject(e) && Tt.isIterable(e)) {
      let d = {}, f, p;
      for (const g of e) {
        if (!Tt.isArray(g))
          throw TypeError("Object iterator must return a key-value pair");
        d[p = g[0]] = (f = d[p]) ? Tt.isArray(f) ? [...f, g[1]] : [f, g[1]] : g[1];
      }
      c(d, t);
    } else
      e != null && i(t, e, r);
    return this;
  }
  get(e, t) {
    if (e = z5(e), e) {
      const r = Tt.findKey(this, e);
      if (r) {
        const a = this[r];
        if (!t)
          return a;
        if (t === !0)
          return fEe(a);
        if (Tt.isFunction(t))
          return t.call(this, a, r);
        if (Tt.isRegExp(t))
          return t.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, t) {
    if (e = z5(e), e) {
      const r = Tt.findKey(this, e);
      return !!(r && this[r] !== void 0 && (!t || GR(this, this[r], r, t)));
    }
    return !1;
  }
  delete(e, t) {
    const r = this;
    let a = !1;
    function i(c) {
      if (c = z5(c), c) {
        const d = Tt.findKey(r, c);
        d && (!t || GR(r, r[d], d, t)) && (delete r[d], a = !0);
      }
    }
    return Tt.isArray(e) ? e.forEach(i) : i(e), a;
  }
  clear(e) {
    const t = Object.keys(this);
    let r = t.length, a = !1;
    for (; r--; ) {
      const i = t[r];
      (!e || GR(this, this[i], i, e, !0)) && (delete this[i], a = !0);
    }
    return a;
  }
  normalize(e) {
    const t = this, r = {};
    return Tt.forEach(this, (a, i) => {
      const c = Tt.findKey(r, i);
      if (c) {
        t[c] = vk(a), delete t[i];
        return;
      }
      const d = e ? hEe(i) : String(i).trim();
      d !== i && delete t[i], t[d] = vk(a), r[d] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const t = /* @__PURE__ */ Object.create(null);
    return Tt.forEach(this, (r, a) => {
      r != null && r !== !1 && (t[a] = e && Tt.isArray(r) ? r.join(", ") : r);
    }), t;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, t]) => e + ": " + t).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...t) {
    const r = new this(e);
    return t.forEach((a) => r.set(a)), r;
  }
  static accessor(e) {
    const t = (this[c_] = this[c_] = {
      accessors: {}
    }).accessors, r = this.prototype;
    function a(i) {
      const c = z5(i);
      t[c] || (pEe(r, i), t[c] = !0);
    }
    return Tt.isArray(e) ? e.forEach(a) : a(e), this;
  }
};
ip.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
Tt.reduceDescriptors(ip.prototype, ({ value: e }, t) => {
  let r = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(a) {
      this[r] = a;
    }
  };
});
Tt.freezeMethods(ip);
function qR(e, t) {
  const r = this || p7, a = t || r, i = ip.from(a.headers);
  let c = a.data;
  return Tt.forEach(e, function(d) {
    c = d.call(r, c, i.normalize(), t ? t.status : void 0);
  }), i.normalize(), c;
}
function Fee(e) {
  return !!(e && e.__CANCEL__);
}
let g7 = class extends ga {
  /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */
  constructor(e, t, r) {
    super(e ?? "canceled", ga.ERR_CANCELED, t, r), this.name = "CanceledError", this.__CANCEL__ = !0;
  }
};
function Wee(e, t, r) {
  const a = r.config.validateStatus;
  !r.status || !a || a(r.status) ? e(r) : t(new ga(
    "Request failed with status code " + r.status,
    [ga.ERR_BAD_REQUEST, ga.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
function gEe(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function vEe(e, t) {
  e = e || 10;
  const r = new Array(e), a = new Array(e);
  let i = 0, c = 0, d;
  return t = t !== void 0 ? t : 1e3, function(f) {
    const p = Date.now(), g = a[c];
    d || (d = p), r[i] = f, a[i] = p;
    let b = c, w = 0;
    for (; b !== i; )
      w += r[b++], b = b % e;
    if (i = (i + 1) % e, i === c && (c = (c + 1) % e), p - d < t)
      return;
    const x = g && p - g;
    return x ? Math.round(w * 1e3 / x) : void 0;
  };
}
function bEe(e, t) {
  let r = 0, a = 1e3 / t, i, c;
  const d = (f, p = Date.now()) => {
    r = p, i = null, c && (clearTimeout(c), c = null), e(...f);
  };
  return [(...f) => {
    const p = Date.now(), g = p - r;
    g >= a ? d(f, p) : (i = f, c || (c = setTimeout(() => {
      c = null, d(i);
    }, a - g)));
  }, () => i && d(i)];
}
const o9 = (e, t, r = 3) => {
  let a = 0;
  const i = vEe(50, 250);
  return bEe((c) => {
    const d = c.loaded, f = c.lengthComputable ? c.total : void 0, p = d - a, g = i(p), b = d <= f;
    a = d;
    const w = {
      loaded: d,
      total: f,
      progress: f ? d / f : void 0,
      bytes: p,
      rate: g || void 0,
      estimated: g && f && b ? (f - d) / g : void 0,
      event: c,
      lengthComputable: f != null,
      [t ? "download" : "upload"]: !0
    };
    e(w);
  }, r);
}, d_ = (e, t) => {
  const r = e != null;
  return [(a) => t[0]({
    lengthComputable: r,
    total: e,
    loaded: a
  }), t[1]];
}, f_ = (e) => (...t) => Tt.asap(() => e(...t)), yEe = nm.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (r) => (r = new URL(r, nm.origin), e.protocol === r.protocol && e.host === r.host && (t || e.port === r.port)))(
  new URL(nm.origin),
  nm.navigator && /(msie|trident)/i.test(nm.navigator.userAgent)
) : () => !0, wEe = nm.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, r, a, i, c, d) {
      if (typeof document > "u") return;
      const f = [`${e}=${encodeURIComponent(t)}`];
      Tt.isNumber(r) && f.push(`expires=${new Date(r).toUTCString()}`), Tt.isString(a) && f.push(`path=${a}`), Tt.isString(i) && f.push(`domain=${i}`), c === !0 && f.push("secure"), Tt.isString(d) && f.push(`SameSite=${d}`), document.cookie = f.join("; ");
    },
    read(e) {
      if (typeof document > "u") return null;
      const t = document.cookie.match(new RegExp("(?:^|; )" + e + "=([^;]*)"));
      return t ? decodeURIComponent(t[1]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function SEe(e) {
  return typeof e != "string" ? !1 : /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function CEe(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function Vee(e, t, r) {
  let a = !SEe(t);
  return e && (a || r == !1) ? CEe(e, t) : t;
}
const m_ = (e) => e instanceof ip ? { ...e } : e;
function r3(e, t) {
  t = t || {};
  const r = {};
  function a(g, b, w, x) {
    return Tt.isPlainObject(g) && Tt.isPlainObject(b) ? Tt.merge.call({ caseless: x }, g, b) : Tt.isPlainObject(b) ? Tt.merge({}, b) : Tt.isArray(b) ? b.slice() : b;
  }
  function i(g, b, w, x) {
    if (Tt.isUndefined(b)) {
      if (!Tt.isUndefined(g))
        return a(void 0, g, w, x);
    } else return a(g, b, w, x);
  }
  function c(g, b) {
    if (!Tt.isUndefined(b))
      return a(void 0, b);
  }
  function d(g, b) {
    if (Tt.isUndefined(b)) {
      if (!Tt.isUndefined(g))
        return a(void 0, g);
    } else return a(void 0, b);
  }
  function f(g, b, w) {
    if (w in t)
      return a(g, b);
    if (w in e)
      return a(void 0, g);
  }
  const p = {
    url: c,
    method: c,
    data: c,
    baseURL: d,
    transformRequest: d,
    transformResponse: d,
    paramsSerializer: d,
    timeout: d,
    timeoutMessage: d,
    withCredentials: d,
    withXSRFToken: d,
    adapter: d,
    responseType: d,
    xsrfCookieName: d,
    xsrfHeaderName: d,
    onUploadProgress: d,
    onDownloadProgress: d,
    decompress: d,
    maxContentLength: d,
    maxBodyLength: d,
    beforeRedirect: d,
    transport: d,
    httpAgent: d,
    httpsAgent: d,
    cancelToken: d,
    socketPath: d,
    responseEncoding: d,
    validateStatus: f,
    headers: (g, b, w) => i(m_(g), m_(b), w, !0)
  };
  return Tt.forEach(
    Object.keys({ ...e, ...t }),
    function(g) {
      if (g === "__proto__" || g === "constructor" || g === "prototype")
        return;
      const b = Tt.hasOwnProp(p, g) ? p[g] : i, w = b(e[g], t[g], g);
      Tt.isUndefined(w) && b !== f || (r[g] = w);
    }
  ), r;
}
const _ee = (e) => {
  const t = r3({}, e);
  let { data: r, withXSRFToken: a, xsrfHeaderName: i, xsrfCookieName: c, headers: d, auth: f } = t;
  if (t.headers = d = ip.from(d), t.url = Lee(Vee(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer), f && d.set(
    "Authorization",
    "Basic " + btoa((f.username || "") + ":" + (f.password ? unescape(encodeURIComponent(f.password)) : ""))
  ), Tt.isFormData(r)) {
    if (nm.hasStandardBrowserEnv || nm.hasStandardBrowserWebWorkerEnv)
      d.setContentType(void 0);
    else if (Tt.isFunction(r.getHeaders)) {
      const p = r.getHeaders(), g = ["content-type", "content-length"];
      Object.entries(p).forEach(([b, w]) => {
        g.includes(b.toLowerCase()) && d.set(b, w);
      });
    }
  }
  if (nm.hasStandardBrowserEnv && (a && Tt.isFunction(a) && (a = a(t)), a || a !== !1 && yEe(t.url))) {
    const p = i && c && wEe.read(c);
    p && d.set(i, p);
  }
  return t;
}, xEe = typeof XMLHttpRequest < "u", EEe = xEe && function(e) {
  return new Promise(function(t, r) {
    const a = _ee(e);
    let i = a.data;
    const c = ip.from(a.headers).normalize();
    let { responseType: d, onUploadProgress: f, onDownloadProgress: p } = a, g, b, w, x, E;
    function P() {
      x && x(), E && E(), a.cancelToken && a.cancelToken.unsubscribe(g), a.signal && a.signal.removeEventListener("abort", g);
    }
    let k = new XMLHttpRequest();
    k.open(a.method.toUpperCase(), a.url, !0), k.timeout = a.timeout;
    function M() {
      if (!k)
        return;
      const N = ip.from(
        "getAllResponseHeaders" in k && k.getAllResponseHeaders()
      ), D = {
        data: !d || d === "text" || d === "json" ? k.responseText : k.response,
        status: k.status,
        statusText: k.statusText,
        headers: N,
        config: e,
        request: k
      };
      Wee(function($) {
        t($), P();
      }, function($) {
        r($), P();
      }, D), k = null;
    }
    "onloadend" in k ? k.onloadend = M : k.onreadystatechange = function() {
      !k || k.readyState !== 4 || k.status === 0 && !(k.responseURL && k.responseURL.indexOf("file:") === 0) || setTimeout(M);
    }, k.onabort = function() {
      k && (r(new ga("Request aborted", ga.ECONNABORTED, e, k)), k = null);
    }, k.onerror = function(N) {
      const D = N && N.message ? N.message : "Network Error", $ = new ga(D, ga.ERR_NETWORK, e, k);
      $.event = N || null, r($), k = null;
    }, k.ontimeout = function() {
      let N = a.timeout ? "timeout of " + a.timeout + "ms exceeded" : "timeout exceeded";
      const D = a.transitional || rI;
      a.timeoutErrorMessage && (N = a.timeoutErrorMessage), r(new ga(
        N,
        D.clarifyTimeoutError ? ga.ETIMEDOUT : ga.ECONNABORTED,
        e,
        k
      )), k = null;
    }, i === void 0 && c.setContentType(null), "setRequestHeader" in k && Tt.forEach(c.toJSON(), function(N, D) {
      k.setRequestHeader(D, N);
    }), Tt.isUndefined(a.withCredentials) || (k.withCredentials = !!a.withCredentials), d && d !== "json" && (k.responseType = a.responseType), p && ([w, E] = o9(p, !0), k.addEventListener("progress", w)), f && k.upload && ([b, x] = o9(f), k.upload.addEventListener("progress", b), k.upload.addEventListener("loadend", x)), (a.cancelToken || a.signal) && (g = (N) => {
      k && (r(!N || N.type ? new g7(null, e, k) : N), k.abort(), k = null);
    }, a.cancelToken && a.cancelToken.subscribe(g), a.signal && (a.signal.aborted ? g() : a.signal.addEventListener("abort", g)));
    const T = gEe(a.url);
    if (T && nm.protocols.indexOf(T) === -1) {
      r(new ga("Unsupported protocol " + T + ":", ga.ERR_BAD_REQUEST, e));
      return;
    }
    k.send(i || null);
  });
}, PEe = (e, t) => {
  const { length: r } = e = e ? e.filter(Boolean) : [];
  if (t || r) {
    let a = new AbortController(), i;
    const c = function(g) {
      if (!i) {
        i = !0, f();
        const b = g instanceof Error ? g : this.reason;
        a.abort(b instanceof ga ? b : new g7(b instanceof Error ? b.message : b));
      }
    };
    let d = t && setTimeout(() => {
      d = null, c(new ga(`timeout of ${t}ms exceeded`, ga.ETIMEDOUT));
    }, t);
    const f = () => {
      e && (d && clearTimeout(d), d = null, e.forEach((g) => {
        g.unsubscribe ? g.unsubscribe(c) : g.removeEventListener("abort", c);
      }), e = null);
    };
    e.forEach((g) => g.addEventListener("abort", c));
    const { signal: p } = a;
    return p.unsubscribe = () => Tt.asap(f), p;
  }
}, kEe = function* (e, t) {
  let r = e.byteLength;
  if (r < t) {
    yield e;
    return;
  }
  let a = 0, i;
  for (; a < r; )
    i = a + t, yield e.slice(a, i), a = i;
}, MEe = async function* (e, t) {
  for await (const r of OEe(e))
    yield* kEe(r, t);
}, OEe = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: a } = await t.read();
      if (r)
        break;
      yield a;
    }
  } finally {
    await t.cancel();
  }
}, h_ = (e, t, r, a) => {
  const i = MEe(e, t);
  let c = 0, d, f = (p) => {
    d || (d = !0, a && a(p));
  };
  return new ReadableStream({
    async pull(p) {
      try {
        const { done: g, value: b } = await i.next();
        if (g) {
          f(), p.close();
          return;
        }
        let w = b.byteLength;
        if (r) {
          let x = c += w;
          r(x);
        }
        p.enqueue(new Uint8Array(b));
      } catch (g) {
        throw f(g), g;
      }
    },
    cancel(p) {
      return f(p), i.return();
    }
  }, {
    highWaterMark: 2
  });
}, p_ = 64 * 1024, { isFunction: iP } = Tt, TEe = (({ Request: e, Response: t }) => ({
  Request: e,
  Response: t
}))(Tt.global), {
  ReadableStream: g_,
  TextEncoder: v_
} = Tt.global, b_ = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, REe = (e) => {
  e = Tt.merge.call({
    skipUndefined: !0
  }, TEe, e);
  const { fetch: t, Request: r, Response: a } = e, i = t ? iP(t) : typeof fetch == "function", c = iP(r), d = iP(a);
  if (!i)
    return !1;
  const f = i && iP(g_), p = i && (typeof v_ == "function" ? /* @__PURE__ */ ((P) => (k) => P.encode(k))(new v_()) : async (P) => new Uint8Array(await new r(P).arrayBuffer())), g = c && f && b_(() => {
    let P = !1;
    const k = new r(nm.origin, {
      body: new g_(),
      method: "POST",
      get duplex() {
        return P = !0, "half";
      }
    }).headers.has("Content-Type");
    return P && !k;
  }), b = d && f && b_(() => Tt.isReadableStream(new a("").body)), w = {
    stream: b && ((P) => P.body)
  };
  i && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((P) => {
    !w[P] && (w[P] = (k, M) => {
      let T = k && k[P];
      if (T)
        return T.call(k);
      throw new ga(`Response type '${P}' is not supported`, ga.ERR_NOT_SUPPORT, M);
    });
  });
  const x = async (P) => {
    if (P == null)
      return 0;
    if (Tt.isBlob(P))
      return P.size;
    if (Tt.isSpecCompliantForm(P))
      return (await new r(nm.origin, {
        method: "POST",
        body: P
      }).arrayBuffer()).byteLength;
    if (Tt.isArrayBufferView(P) || Tt.isArrayBuffer(P))
      return P.byteLength;
    if (Tt.isURLSearchParams(P) && (P = P + ""), Tt.isString(P))
      return (await p(P)).byteLength;
  }, E = async (P, k) => Tt.toFiniteNumber(P.getContentLength()) ?? x(k);
  return async (P) => {
    let {
      url: k,
      method: M,
      data: T,
      signal: N,
      cancelToken: D,
      timeout: $,
      onDownloadProgress: j,
      onUploadProgress: I,
      responseType: L,
      headers: F,
      withCredentials: _ = "same-origin",
      fetchOptions: W
    } = _ee(P), Q = t || fetch;
    L = L ? (L + "").toLowerCase() : "text";
    let U = PEe([N, D && D.toAbortSignal()], $), Y = null;
    const G = U && U.unsubscribe && (() => {
      U.unsubscribe();
    });
    let J;
    try {
      if (I && g && M !== "get" && M !== "head" && (J = await E(F, T)) !== 0) {
        let ee = new r(k, {
          method: "POST",
          body: T,
          duplex: "half"
        }), ne;
        if (Tt.isFormData(T) && (ne = ee.headers.get("content-type")) && F.setContentType(ne), ee.body) {
          const [ae, oe] = d_(
            J,
            o9(f_(I))
          );
          T = h_(ee.body, p_, ae, oe);
        }
      }
      Tt.isString(_) || (_ = _ ? "include" : "omit");
      const H = c && "credentials" in r.prototype, K = {
        ...W,
        signal: U,
        method: M.toUpperCase(),
        headers: F.normalize().toJSON(),
        body: T,
        duplex: "half",
        credentials: H ? _ : void 0
      };
      Y = c && new r(k, K);
      let X = await (c ? Q(Y, W) : Q(k, K));
      const te = b && (L === "stream" || L === "response");
      if (b && (j || te && G)) {
        const ee = {};
        ["status", "statusText", "headers"].forEach((fe) => {
          ee[fe] = X[fe];
        });
        const ne = Tt.toFiniteNumber(X.headers.get("content-length")), [ae, oe] = j && d_(
          ne,
          o9(f_(j), !0)
        ) || [];
        X = new a(
          h_(X.body, p_, ae, () => {
            oe && oe(), G && G();
          }),
          ee
        );
      }
      L = L || "text";
      let ie = await w[Tt.findKey(w, L) || "text"](X, P);
      return !te && G && G(), await new Promise((ee, ne) => {
        Wee(ee, ne, {
          data: ie,
          headers: ip.from(X.headers),
          status: X.status,
          statusText: X.statusText,
          config: P,
          request: Y
        });
      });
    } catch (H) {
      throw G && G(), H && H.name === "TypeError" && /Load failed|fetch/i.test(H.message) ? Object.assign(
        new ga("Network Error", ga.ERR_NETWORK, P, Y, H && H.response),
        {
          cause: H.cause || H
        }
      ) : ga.from(H, H && H.code, P, Y, H && H.response);
    }
  };
}, AEe = /* @__PURE__ */ new Map(), Bee = (e) => {
  let t = e && e.env || {};
  const { fetch: r, Request: a, Response: i } = t, c = [
    a,
    i,
    r
  ];
  let d = c.length, f = d, p, g, b = AEe;
  for (; f--; )
    p = c[f], g = b.get(p), g === void 0 && b.set(p, g = f ? /* @__PURE__ */ new Map() : REe(t)), b = g;
  return g;
};
Bee();
const oI = {
  http: q5e,
  xhr: EEe,
  fetch: {
    get: Bee
  }
};
Tt.forEach(oI, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const y_ = (e) => `- ${e}`, NEe = (e) => Tt.isFunction(e) || e === null || e === !1;
function DEe(e, t) {
  e = Tt.isArray(e) ? e : [e];
  const { length: r } = e;
  let a, i;
  const c = {};
  for (let d = 0; d < r; d++) {
    a = e[d];
    let f;
    if (i = a, !NEe(a) && (i = oI[(f = String(a)).toLowerCase()], i === void 0))
      throw new ga(`Unknown adapter '${f}'`);
    if (i && (Tt.isFunction(i) || (i = i.get(t))))
      break;
    c[f || "#" + d] = i;
  }
  if (!i) {
    const d = Object.entries(c).map(
      ([p, g]) => `adapter ${p} ` + (g === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let f = r ? d.length > 1 ? `since :
` + d.map(y_).join(`
`) : " " + y_(d[0]) : "as no adapter specified";
    throw new ga(
      "There is no suitable adapter to dispatch the request " + f,
      "ERR_NOT_SUPPORT"
    );
  }
  return i;
}
const Uee = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: DEe,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: oI
};
function KR(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new g7(null, e);
}
function w_(e) {
  return KR(e), e.headers = ip.from(e.headers), e.data = qR.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Uee.getAdapter(e.adapter || p7.adapter, e)(e).then(function(t) {
    return KR(e), t.data = qR.call(
      e,
      e.transformResponse,
      t
    ), t.headers = ip.from(t.headers), t;
  }, function(t) {
    return Fee(t) || (KR(e), t && t.response && (t.response.data = qR.call(
      e,
      e.transformResponse,
      t.response
    ), t.response.headers = ip.from(t.response.headers))), Promise.reject(t);
  });
}
const Xee = "1.13.5", OM = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  OM[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const S_ = {};
OM.transitional = function(e, t, r) {
  function a(i, c) {
    return "[Axios v" + Xee + "] Transitional option '" + i + "'" + c + (r ? ". " + r : "");
  }
  return (i, c, d) => {
    if (e === !1)
      throw new ga(
        a(c, " has been removed" + (t ? " in " + t : "")),
        ga.ERR_DEPRECATED
      );
    return t && !S_[c] && (S_[c] = !0, console.warn(
      a(
        c,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), e ? e(i, c, d) : !0;
  };
};
OM.spelling = function(e) {
  return (t, r) => (console.warn(`${r} is likely a misspelling of ${e}`), !0);
};
function $Ee(e, t, r) {
  if (typeof e != "object")
    throw new ga("options must be an object", ga.ERR_BAD_OPTION_VALUE);
  const a = Object.keys(e);
  let i = a.length;
  for (; i-- > 0; ) {
    const c = a[i], d = t[c];
    if (d) {
      const f = e[c], p = f === void 0 || d(f, c, e);
      if (p !== !0)
        throw new ga("option " + c + " must be " + p, ga.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new ga("Unknown option " + c, ga.ERR_BAD_OPTION);
  }
}
const bk = {
  assertOptions: $Ee,
  validators: OM
}, H0 = bk.validators;
let K4 = class {
  constructor(e) {
    this.defaults = e || {}, this.interceptors = {
      request: new u_(),
      response: new u_()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, t) {
    try {
      return await this._request(e, t);
    } catch (r) {
      if (r instanceof Error) {
        let a = {};
        Error.captureStackTrace ? Error.captureStackTrace(a) : a = new Error();
        const i = a.stack ? a.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? i && !String(r.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + i) : r.stack = i;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(e, t) {
    typeof e == "string" ? (t = t || {}, t.url = e) : t = e || {}, t = r3(this.defaults, t);
    const { transitional: r, paramsSerializer: a, headers: i } = t;
    r !== void 0 && bk.assertOptions(r, {
      silentJSONParsing: H0.transitional(H0.boolean),
      forcedJSONParsing: H0.transitional(H0.boolean),
      clarifyTimeoutError: H0.transitional(H0.boolean),
      legacyInterceptorReqResOrdering: H0.transitional(H0.boolean)
    }, !1), a != null && (Tt.isFunction(a) ? t.paramsSerializer = {
      serialize: a
    } : bk.assertOptions(a, {
      encode: H0.function,
      serialize: H0.function
    }, !0)), t.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? t.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : t.allowAbsoluteUrls = !0), bk.assertOptions(t, {
      baseUrl: H0.spelling("baseURL"),
      withXsrfToken: H0.spelling("withXSRFToken")
    }, !0), t.method = (t.method || this.defaults.method || "get").toLowerCase();
    let c = i && Tt.merge(
      i.common,
      i[t.method]
    );
    i && Tt.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (E) => {
        delete i[E];
      }
    ), t.headers = ip.concat(c, i);
    const d = [];
    let f = !0;
    this.interceptors.request.forEach(function(E) {
      if (typeof E.runWhen == "function" && E.runWhen(t) === !1)
        return;
      f = f && E.synchronous;
      const P = t.transitional || rI;
      P && P.legacyInterceptorReqResOrdering ? d.unshift(E.fulfilled, E.rejected) : d.push(E.fulfilled, E.rejected);
    });
    const p = [];
    this.interceptors.response.forEach(function(E) {
      p.push(E.fulfilled, E.rejected);
    });
    let g, b = 0, w;
    if (!f) {
      const E = [w_.bind(this), void 0];
      for (E.unshift(...d), E.push(...p), w = E.length, g = Promise.resolve(t); b < w; )
        g = g.then(E[b++], E[b++]);
      return g;
    }
    w = d.length;
    let x = t;
    for (; b < w; ) {
      const E = d[b++], P = d[b++];
      try {
        x = E(x);
      } catch (k) {
        P.call(this, k);
        break;
      }
    }
    try {
      g = w_.call(this, x);
    } catch (E) {
      return Promise.reject(E);
    }
    for (b = 0, w = p.length; b < w; )
      g = g.then(p[b++], p[b++]);
    return g;
  }
  getUri(e) {
    e = r3(this.defaults, e);
    const t = Vee(e.baseURL, e.url, e.allowAbsoluteUrls);
    return Lee(t, e.params, e.paramsSerializer);
  }
};
Tt.forEach(["delete", "get", "head", "options"], function(e) {
  K4.prototype[e] = function(t, r) {
    return this.request(r3(r || {}, {
      method: e,
      url: t,
      data: (r || {}).data
    }));
  };
});
Tt.forEach(["post", "put", "patch"], function(e) {
  function t(r) {
    return function(a, i, c) {
      return this.request(r3(c || {}, {
        method: e,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: a,
        data: i
      }));
    };
  }
  K4.prototype[e] = t(), K4.prototype[e + "Form"] = t(!0);
});
let zEe = class Gee {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(i) {
      r = i;
    });
    const a = this;
    this.promise.then((i) => {
      if (!a._listeners) return;
      let c = a._listeners.length;
      for (; c-- > 0; )
        a._listeners[c](i);
      a._listeners = null;
    }), this.promise.then = (i) => {
      let c;
      const d = new Promise((f) => {
        a.subscribe(f), c = f;
      }).then(i);
      return d.cancel = function() {
        a.unsubscribe(c);
      }, d;
    }, t(function(i, c, d) {
      a.reason || (a.reason = new g7(i, c, d), r(a.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(t);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), r = (a) => {
      t.abort(a);
    };
    return this.subscribe(r), t.signal.unsubscribe = () => this.unsubscribe(r), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new Gee(function(r) {
        t = r;
      }),
      cancel: t
    };
  }
};
function jEe(e) {
  return function(t) {
    return e.apply(null, t);
  };
}
function IEe(e) {
  return Tt.isObject(e) && e.isAxiosError === !0;
}
const x$ = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(x$).forEach(([e, t]) => {
  x$[t] = e;
});
function qee(e) {
  const t = new K4(e), r = Mee(K4.prototype.request, t);
  return Tt.extend(r, K4.prototype, t, { allOwnKeys: !0 }), Tt.extend(r, t, null, { allOwnKeys: !0 }), r.create = function(a) {
    return qee(r3(e, a));
  }, r;
}
const ec = qee(p7);
ec.Axios = K4;
ec.CanceledError = g7;
ec.CancelToken = zEe;
ec.isCancel = Fee;
ec.VERSION = Xee;
ec.toFormData = MM;
ec.AxiosError = ga;
ec.Cancel = ec.CanceledError;
ec.all = function(e) {
  return Promise.all(e);
};
ec.spread = jEe;
ec.isAxiosError = IEe;
ec.mergeConfig = r3;
ec.AxiosHeaders = ip;
ec.formToJSON = (e) => Hee(Tt.isHTMLForm(e) ? new FormData(e) : e);
ec.getAdapter = Uee.getAdapter;
ec.HttpStatusCode = x$;
ec.default = ec;
const {
  Axios: KOt,
  AxiosError: YOt,
  CanceledError: QOt,
  isCancel: JOt,
  CancelToken: ZOt,
  VERSION: eTt,
  all: tTt,
  Cancel: nTt,
  isAxiosError: rTt,
  spread: aTt,
  toFormData: oTt,
  AxiosHeaders: iTt,
  HttpStatusCode: lTt,
  formToJSON: sTt,
  getAdapter: uTt,
  mergeConfig: cTt
} = ec;
var YR = { exports: {} }, j5 = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var C_;
function LEe() {
  if (C_) return j5;
  C_ = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.fragment");
  function r(a, i, c) {
    var d = null;
    if (c !== void 0 && (d = "" + c), i.key !== void 0 && (d = "" + i.key), "key" in i) {
      c = {};
      for (var f in i)
        f !== "key" && (c[f] = i[f]);
    } else c = i;
    return i = c.ref, {
      $$typeof: e,
      type: a,
      key: d,
      ref: i !== void 0 ? i : null,
      props: c
    };
  }
  return j5.Fragment = t, j5.jsx = r, j5.jsxs = r, j5;
}
var lP = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var x_;
function HEe() {
  return x_ || (x_ = 1, process.env.NODE_ENV !== "production" && (function() {
    function e(ee) {
      if (ee == null) return null;
      if (typeof ee == "function")
        return ee.$$typeof === Q ? null : ee.displayName || ee.name || null;
      if (typeof ee == "string") return ee;
      switch (ee) {
        case M:
          return "Fragment";
        case N:
          return "Profiler";
        case T:
          return "StrictMode";
        case I:
          return "Suspense";
        case L:
          return "SuspenseList";
        case W:
          return "Activity";
      }
      if (typeof ee == "object")
        switch (typeof ee.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), ee.$$typeof) {
          case k:
            return "Portal";
          case $:
            return ee.displayName || "Context";
          case D:
            return (ee._context.displayName || "Context") + ".Consumer";
          case j:
            var ne = ee.render;
            return ee = ee.displayName, ee || (ee = ne.displayName || ne.name || "", ee = ee !== "" ? "ForwardRef(" + ee + ")" : "ForwardRef"), ee;
          case F:
            return ne = ee.displayName || null, ne !== null ? ne : e(ee.type) || "Memo";
          case _:
            ne = ee._payload, ee = ee._init;
            try {
              return e(ee(ne));
            } catch {
            }
        }
      return null;
    }
    function t(ee) {
      return "" + ee;
    }
    function r(ee) {
      try {
        t(ee);
        var ne = !1;
      } catch {
        ne = !0;
      }
      if (ne) {
        ne = console;
        var ae = ne.error, oe = typeof Symbol == "function" && Symbol.toStringTag && ee[Symbol.toStringTag] || ee.constructor.name || "Object";
        return ae.call(
          ne,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          oe
        ), t(ee);
      }
    }
    function a(ee) {
      if (ee === M) return "<>";
      if (typeof ee == "object" && ee !== null && ee.$$typeof === _)
        return "<...>";
      try {
        var ne = e(ee);
        return ne ? "<" + ne + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function i() {
      var ee = U.A;
      return ee === null ? null : ee.getOwner();
    }
    function c() {
      return Error("react-stack-top-frame");
    }
    function d(ee) {
      if (Y.call(ee, "key")) {
        var ne = Object.getOwnPropertyDescriptor(ee, "key").get;
        if (ne && ne.isReactWarning) return !1;
      }
      return ee.key !== void 0;
    }
    function f(ee, ne) {
      function ae() {
        H || (H = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          ne
        ));
      }
      ae.isReactWarning = !0, Object.defineProperty(ee, "key", {
        get: ae,
        configurable: !0
      });
    }
    function p() {
      var ee = e(this.type);
      return K[ee] || (K[ee] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), ee = this.props.ref, ee !== void 0 ? ee : null;
    }
    function g(ee, ne, ae, oe, fe, be) {
      var me = ae.ref;
      return ee = {
        $$typeof: P,
        type: ee,
        key: ne,
        props: ae,
        _owner: oe
      }, (me !== void 0 ? me : null) !== null ? Object.defineProperty(ee, "ref", {
        enumerable: !1,
        get: p
      }) : Object.defineProperty(ee, "ref", { enumerable: !1, value: null }), ee._store = {}, Object.defineProperty(ee._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(ee, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(ee, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: fe
      }), Object.defineProperty(ee, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: be
      }), Object.freeze && (Object.freeze(ee.props), Object.freeze(ee)), ee;
    }
    function b(ee, ne, ae, oe, fe, be) {
      var me = ne.children;
      if (me !== void 0)
        if (oe)
          if (G(me)) {
            for (oe = 0; oe < me.length; oe++)
              w(me[oe]);
            Object.freeze && Object.freeze(me);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else w(me);
      if (Y.call(ne, "key")) {
        me = e(ee);
        var De = Object.keys(ne).filter(function(ze) {
          return ze !== "key";
        });
        oe = 0 < De.length ? "{key: someKey, " + De.join(": ..., ") + ": ...}" : "{key: someKey}", ie[me + oe] || (De = 0 < De.length ? "{" + De.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          oe,
          me,
          De,
          me
        ), ie[me + oe] = !0);
      }
      if (me = null, ae !== void 0 && (r(ae), me = "" + ae), d(ne) && (r(ne.key), me = "" + ne.key), "key" in ne) {
        ae = {};
        for (var Me in ne)
          Me !== "key" && (ae[Me] = ne[Me]);
      } else ae = ne;
      return me && f(
        ae,
        typeof ee == "function" ? ee.displayName || ee.name || "Unknown" : ee
      ), g(
        ee,
        me,
        ae,
        i(),
        fe,
        be
      );
    }
    function w(ee) {
      x(ee) ? ee._store && (ee._store.validated = 1) : typeof ee == "object" && ee !== null && ee.$$typeof === _ && (ee._payload.status === "fulfilled" ? x(ee._payload.value) && ee._payload.value._store && (ee._payload.value._store.validated = 1) : ee._store && (ee._store.validated = 1));
    }
    function x(ee) {
      return typeof ee == "object" && ee !== null && ee.$$typeof === P;
    }
    var E = Re, P = Symbol.for("react.transitional.element"), k = Symbol.for("react.portal"), M = Symbol.for("react.fragment"), T = Symbol.for("react.strict_mode"), N = Symbol.for("react.profiler"), D = Symbol.for("react.consumer"), $ = Symbol.for("react.context"), j = Symbol.for("react.forward_ref"), I = Symbol.for("react.suspense"), L = Symbol.for("react.suspense_list"), F = Symbol.for("react.memo"), _ = Symbol.for("react.lazy"), W = Symbol.for("react.activity"), Q = Symbol.for("react.client.reference"), U = E.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, Y = Object.prototype.hasOwnProperty, G = Array.isArray, J = console.createTask ? console.createTask : function() {
      return null;
    };
    E = {
      react_stack_bottom_frame: function(ee) {
        return ee();
      }
    };
    var H, K = {}, X = E.react_stack_bottom_frame.bind(
      E,
      c
    )(), te = J(a(c)), ie = {};
    lP.Fragment = M, lP.jsx = function(ee, ne, ae) {
      var oe = 1e4 > U.recentlyCreatedOwnerStacks++;
      return b(
        ee,
        ne,
        ae,
        !1,
        oe ? Error("react-stack-top-frame") : X,
        oe ? J(a(ee)) : te
      );
    }, lP.jsxs = function(ee, ne, ae) {
      var oe = 1e4 > U.recentlyCreatedOwnerStacks++;
      return b(
        ee,
        ne,
        ae,
        !0,
        oe ? Error("react-stack-top-frame") : X,
        oe ? J(a(ee)) : te
      );
    };
  })()), lP;
}
var E_;
function FEe() {
  return E_ || (E_ = 1, process.env.NODE_ENV === "production" ? YR.exports = LEe() : YR.exports = HEe()), YR.exports;
}
FEe();
const WEe = "/steps/rest/user?role=true", VEe = "/api/dms/v1/users/{userName}", _Ee = "User details", BEe = "Car lot information";
function UEe({
  carLots: e = !1,
  dealerInfo: t = !1,
  enabled: r = !0
} = {}) {
  const a = t === !0 ? "&dealerInfo=true" : "";
  XEe();
  let i, c;
  try {
    i = Jj(WEe + a);
  } catch (T) {
    c = `${T}`;
  }
  const {
    data: d,
    error: f,
    isLoading: p,
    mutate: g
  } = a_(
    r ? [i, _Ee] : void 0,
    o_,
    {
      revalidateOnFocus: !1
      // Do not revalidate on re-focus of the window tab
    }
  ), b = e && d?.userName ? VEe.replace("{userName}", d.userName) : void 0, {
    data: w,
    isLoading: x,
    error: E,
    mutate: P
  } = a_(
    b ? [b, BEe] : void 0,
    o_,
    {
      revalidateOnFocus: !1
    }
  ), k = mn(() => e ? d && (E || w) ? w ? { ...d, ...w } : d : void 0 : d, [d, w, e, E]), M = c ?? f ?? E ? `${c ?? f ?? E}` : void 0;
  return {
    user: k,
    isLoading: M ? !1 : p || e && x || !1,
    error: M,
    mutate: async () => {
      const T = await g();
      if (e && T?.userName) {
        const N = await P();
        return N ? { ...T, ...N } : T;
      }
      return T;
    }
  };
}
function XEe() {
  if (window.environment !== "test")
    return;
  const e = document.referrer;
  if (!e)
    return;
  const t = new URL(e, window.location.origin).hostname.split(".")?.[0];
  if (t.startsWith("capstst")) {
    const r = t.at(-1);
    Number.isNaN(Number(r)) || sessionStorage.setItem(c$, `Test${r}`);
  }
}
function P_(e) {
  return "dealerId" in e;
}
function GEe(e) {
  return "kind" in e;
}
function k_(e) {
  return {
    kind: "user",
    key: `D${e.dealerId}`
  };
}
function E$(...e) {
  if (e.length === 1) {
    const r = e[0];
    return P_(r) ? k_(r) : r;
  }
  const t = {
    kind: "multi"
  };
  for (const r of e)
    P_(r) ? t.user = k_(r) : GEe(r) && (r.kind === "multi" ? Object.assign(t, r) : t[r.kind] = r);
  return t;
}
function qS(e) {
  function t(r, a) {
    Error.captureStackTrace && Error.captureStackTrace(this, this.constructor), this.message = r, this.code = a;
  }
  return t.prototype = new Error(), t.prototype.name = e, t.prototype.constructor = t, t;
}
const qEe = qS("LaunchDarklyUnexpectedResponseError"), KEe = qS("LaunchDarklyInvalidEnvironmentIdError"), YEe = qS("LaunchDarklyInvalidUserError"), QEe = qS("LaunchDarklyInvalidEventKeyError"), JEe = qS("LaunchDarklyInvalidArgumentError"), ZEe = qS("LaunchDarklyFlagFetchError");
for (var iu = { LDUnexpectedResponseError: qEe, LDInvalidEnvironmentIdError: KEe, LDInvalidUserError: YEe, LDInvalidEventKeyError: QEe, LDInvalidArgumentError: JEe, LDInvalidDataError: qS("LaunchDarklyInvalidDataError"), LDFlagFetchError: ZEe, LDTimeoutError: qS("LaunchDarklyTimeoutError"), isHttpErrorRecoverable: function(e) {
  return !(e >= 400 && e < 500) || e === 400 || e === 408 || e === 429;
} }, e7e = function(e) {
  var t = O_(e), r = t[0], a = t[1];
  return 3 * (r + a) / 4 - a;
}, t7e = function(e) {
  var t, r, a = O_(e), i = a[0], c = a[1], d = new r7e((function(g, b, w) {
    return 3 * (b + w) / 4 - w;
  })(0, i, c)), f = 0, p = c > 0 ? i - 4 : i;
  for (r = 0; r < p; r += 4) t = F0[e.charCodeAt(r)] << 18 | F0[e.charCodeAt(r + 1)] << 12 | F0[e.charCodeAt(r + 2)] << 6 | F0[e.charCodeAt(r + 3)], d[f++] = t >> 16 & 255, d[f++] = t >> 8 & 255, d[f++] = 255 & t;
  return c === 2 && (t = F0[e.charCodeAt(r)] << 2 | F0[e.charCodeAt(r + 1)] >> 4, d[f++] = 255 & t), c === 1 && (t = F0[e.charCodeAt(r)] << 10 | F0[e.charCodeAt(r + 1)] << 4 | F0[e.charCodeAt(r + 2)] >> 2, d[f++] = t >> 8 & 255, d[f++] = 255 & t), d;
}, n7e = function(e) {
  for (var t, r = e.length, a = r % 3, i = [], c = 16383, d = 0, f = r - a; d < f; d += c) i.push(o7e(e, d, d + c > f ? f : d + c));
  return a === 1 ? (t = e[r - 1], i.push(ob[t >> 2] + ob[t << 4 & 63] + "==")) : a === 2 && (t = (e[r - 2] << 8) + e[r - 1], i.push(ob[t >> 10] + ob[t >> 4 & 63] + ob[t << 2 & 63] + "=")), i.join("");
}, ob = [], F0 = [], r7e = typeof Uint8Array < "u" ? Uint8Array : Array, M_ = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", z3 = 0; z3 < 64; ++z3) ob[z3] = M_[z3], F0[M_.charCodeAt(z3)] = z3;
function O_(e) {
  var t = e.length;
  if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
  var r = e.indexOf("=");
  return r === -1 && (r = t), [r, r === t ? 0 : 4 - r % 4];
}
function a7e(e) {
  return ob[e >> 18 & 63] + ob[e >> 12 & 63] + ob[e >> 6 & 63] + ob[63 & e];
}
function o7e(e, t, r) {
  for (var a, i = [], c = t; c < r; c += 3) a = (e[c] << 16 & 16711680) + (e[c + 1] << 8 & 65280) + (255 & e[c + 2]), i.push(a7e(a));
  return i.join("");
}
F0[45] = 62, F0[95] = 63;
var i7e = { byteLength: e7e, toByteArray: t7e, fromByteArray: n7e }, T_ = Array.isArray, R_ = Object.keys, l7e = Object.prototype.hasOwnProperty, s7e = function e(t, r) {
  if (t === r) return !0;
  if (t && r && typeof t == "object" && typeof r == "object") {
    var a, i, c, d = T_(t), f = T_(r);
    if (d && f) {
      if ((i = t.length) != r.length) return !1;
      for (a = i; a-- !== 0; ) if (!e(t[a], r[a])) return !1;
      return !0;
    }
    if (d != f) return !1;
    var p = t instanceof Date, g = r instanceof Date;
    if (p != g) return !1;
    if (p && g) return t.getTime() == r.getTime();
    var b = t instanceof RegExp, w = r instanceof RegExp;
    if (b != w) return !1;
    if (b && w) return t.toString() == r.toString();
    var x = R_(t);
    if ((i = x.length) !== R_(r).length) return !1;
    for (a = i; a-- !== 0; ) if (!l7e.call(r, x[a])) return !1;
    for (a = i; a-- !== 0; ) if (!e(t[c = x[a]], r[c])) return !1;
    return !0;
  }
  return t != t && r != r;
};
const u7e = ["key", "ip", "country", "email", "firstName", "lastName", "avatar", "name"];
function A_(e) {
  const t = unescape(encodeURIComponent(e));
  return i7e.fromByteArray((function(r) {
    const a = [];
    for (let i = 0; i < r.length; i++) a.push(r.charCodeAt(i));
    return a;
  })(t));
}
function QR(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
var JR, Na = { appendUrlPath: function(e, t) {
  return (e.endsWith("/") ? e.substring(0, e.length - 1) : e) + (t.startsWith("/") ? "" : "/") + t;
}, base64URLEncode: function(e) {
  return A_(e).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}, btoa: A_, clone: function(e) {
  return JSON.parse(JSON.stringify(e));
}, deepEquals: function(e, t) {
  return s7e(e, t);
}, extend: function(...e) {
  return e.reduce((t, r) => ({ ...t, ...r }), {});
}, getLDUserAgentString: function(e) {
  const t = e.version || "?";
  return e.userAgent + "/" + t;
}, objectHasOwnProperty: QR, onNextTick: function(e) {
  setTimeout(e, 0);
}, sanitizeContext: function(e) {
  if (!e) return e;
  let t;
  return e.kind !== null && e.kind !== void 0 || u7e.forEach((r) => {
    const a = e[r];
    a !== void 0 && typeof a != "string" && (t = t || { ...e }, t[r] = String(a));
  }), t || e;
}, transformValuesToVersionedValues: function(e) {
  const t = {};
  for (const r in e) QR(e, r) && (t[r] = { value: e[r], version: 0 });
  return t;
}, transformVersionedValuesToValues: function(e) {
  const t = {};
  for (const r in e) QR(e, r) && (t[r] = e[r].value);
  return t;
}, wrapPromiseCallback: function(e, t) {
  const r = e.then((a) => (t && setTimeout(() => {
    t(null, a);
  }, 0), a), (a) => {
    if (!t) return Promise.reject(a);
    setTimeout(() => {
      t(a, null);
    }, 0);
  });
  return t ? void 0 : r;
}, once: function(e) {
  let t, r = !1;
  return function(...a) {
    return r || (r = !0, t = e.apply(this, a)), t;
  };
} }, c7e = new Uint8Array(16);
function N_() {
  if (!JR && !(JR = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto))) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return JR(c7e);
}
var d7e = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function i9(e) {
  return typeof e == "string" && d7e.test(e);
}
for (var D_, ZR, Wf = [], eA = 0; eA < 256; ++eA) Wf.push((eA + 256).toString(16).substr(1));
function yk(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = (Wf[e[t + 0]] + Wf[e[t + 1]] + Wf[e[t + 2]] + Wf[e[t + 3]] + "-" + Wf[e[t + 4]] + Wf[e[t + 5]] + "-" + Wf[e[t + 6]] + Wf[e[t + 7]] + "-" + Wf[e[t + 8]] + Wf[e[t + 9]] + "-" + Wf[e[t + 10]] + Wf[e[t + 11]] + Wf[e[t + 12]] + Wf[e[t + 13]] + Wf[e[t + 14]] + Wf[e[t + 15]]).toLowerCase();
  if (!i9(r)) throw TypeError("Stringified UUID is invalid");
  return r;
}
var tA = 0, nA = 0;
function Kee(e) {
  if (!i9(e)) throw TypeError("Invalid UUID");
  var t, r = new Uint8Array(16);
  return r[0] = (t = parseInt(e.slice(0, 8), 16)) >>> 24, r[1] = t >>> 16 & 255, r[2] = t >>> 8 & 255, r[3] = 255 & t, r[4] = (t = parseInt(e.slice(9, 13), 16)) >>> 8, r[5] = 255 & t, r[6] = (t = parseInt(e.slice(14, 18), 16)) >>> 8, r[7] = 255 & t, r[8] = (t = parseInt(e.slice(19, 23), 16)) >>> 8, r[9] = 255 & t, r[10] = (t = parseInt(e.slice(24, 36), 16)) / 1099511627776 & 255, r[11] = t / 4294967296 & 255, r[12] = t >>> 24 & 255, r[13] = t >>> 16 & 255, r[14] = t >>> 8 & 255, r[15] = 255 & t, r;
}
function Yee(e, t, r) {
  function a(i, c, d, f) {
    if (typeof i == "string" && (i = (function(b) {
      b = unescape(encodeURIComponent(b));
      for (var w = [], x = 0; x < b.length; ++x) w.push(b.charCodeAt(x));
      return w;
    })(i)), typeof c == "string" && (c = Kee(c)), c.length !== 16) throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    var p = new Uint8Array(16 + i.length);
    if (p.set(c), p.set(i, c.length), (p = r(p))[6] = 15 & p[6] | t, p[8] = 63 & p[8] | 128, d) {
      f = f || 0;
      for (var g = 0; g < 16; ++g) d[f + g] = p[g];
      return d;
    }
    return yk(p);
  }
  try {
    a.name = e;
  } catch {
  }
  return a.DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", a.URL = "6ba7b811-9dad-11d1-80b4-00c04fd430c8", a;
}
function $_(e) {
  return 14 + (e + 64 >>> 9 << 4) + 1;
}
function NS(e, t) {
  var r = (65535 & e) + (65535 & t);
  return (e >> 16) + (t >> 16) + (r >> 16) << 16 | 65535 & r;
}
function TM(e, t, r, a, i, c) {
  return NS((d = NS(NS(t, e), NS(a, c))) << (f = i) | d >>> 32 - f, r);
  var d, f;
}
function Xf(e, t, r, a, i, c, d) {
  return TM(t & r | ~t & a, e, t, i, c, d);
}
function Gf(e, t, r, a, i, c, d) {
  return TM(t & a | r & ~a, e, t, i, c, d);
}
function qf(e, t, r, a, i, c, d) {
  return TM(t ^ r ^ a, e, t, i, c, d);
}
function Kf(e, t, r, a, i, c, d) {
  return TM(r ^ (t | ~a), e, t, i, c, d);
}
var f7e = Yee("v3", 48, function(e) {
  if (typeof e == "string") {
    var t = unescape(encodeURIComponent(e));
    e = new Uint8Array(t.length);
    for (var r = 0; r < t.length; ++r) e[r] = t.charCodeAt(r);
  }
  return (function(a) {
    for (var i = [], c = 32 * a.length, d = "0123456789abcdef", f = 0; f < c; f += 8) {
      var p = a[f >> 5] >>> f % 32 & 255, g = parseInt(d.charAt(p >>> 4 & 15) + d.charAt(15 & p), 16);
      i.push(g);
    }
    return i;
  })((function(a, i) {
    a[i >> 5] |= 128 << i % 32, a[$_(i) - 1] = i;
    for (var c = 1732584193, d = -271733879, f = -1732584194, p = 271733878, g = 0; g < a.length; g += 16) {
      var b = c, w = d, x = f, E = p;
      c = Xf(c, d, f, p, a[g], 7, -680876936), p = Xf(p, c, d, f, a[g + 1], 12, -389564586), f = Xf(f, p, c, d, a[g + 2], 17, 606105819), d = Xf(d, f, p, c, a[g + 3], 22, -1044525330), c = Xf(c, d, f, p, a[g + 4], 7, -176418897), p = Xf(p, c, d, f, a[g + 5], 12, 1200080426), f = Xf(f, p, c, d, a[g + 6], 17, -1473231341), d = Xf(d, f, p, c, a[g + 7], 22, -45705983), c = Xf(c, d, f, p, a[g + 8], 7, 1770035416), p = Xf(p, c, d, f, a[g + 9], 12, -1958414417), f = Xf(f, p, c, d, a[g + 10], 17, -42063), d = Xf(d, f, p, c, a[g + 11], 22, -1990404162), c = Xf(c, d, f, p, a[g + 12], 7, 1804603682), p = Xf(p, c, d, f, a[g + 13], 12, -40341101), f = Xf(f, p, c, d, a[g + 14], 17, -1502002290), c = Gf(c, d = Xf(d, f, p, c, a[g + 15], 22, 1236535329), f, p, a[g + 1], 5, -165796510), p = Gf(p, c, d, f, a[g + 6], 9, -1069501632), f = Gf(f, p, c, d, a[g + 11], 14, 643717713), d = Gf(d, f, p, c, a[g], 20, -373897302), c = Gf(c, d, f, p, a[g + 5], 5, -701558691), p = Gf(p, c, d, f, a[g + 10], 9, 38016083), f = Gf(f, p, c, d, a[g + 15], 14, -660478335), d = Gf(d, f, p, c, a[g + 4], 20, -405537848), c = Gf(c, d, f, p, a[g + 9], 5, 568446438), p = Gf(p, c, d, f, a[g + 14], 9, -1019803690), f = Gf(f, p, c, d, a[g + 3], 14, -187363961), d = Gf(d, f, p, c, a[g + 8], 20, 1163531501), c = Gf(c, d, f, p, a[g + 13], 5, -1444681467), p = Gf(p, c, d, f, a[g + 2], 9, -51403784), f = Gf(f, p, c, d, a[g + 7], 14, 1735328473), c = qf(c, d = Gf(d, f, p, c, a[g + 12], 20, -1926607734), f, p, a[g + 5], 4, -378558), p = qf(p, c, d, f, a[g + 8], 11, -2022574463), f = qf(f, p, c, d, a[g + 11], 16, 1839030562), d = qf(d, f, p, c, a[g + 14], 23, -35309556), c = qf(c, d, f, p, a[g + 1], 4, -1530992060), p = qf(p, c, d, f, a[g + 4], 11, 1272893353), f = qf(f, p, c, d, a[g + 7], 16, -155497632), d = qf(d, f, p, c, a[g + 10], 23, -1094730640), c = qf(c, d, f, p, a[g + 13], 4, 681279174), p = qf(p, c, d, f, a[g], 11, -358537222), f = qf(f, p, c, d, a[g + 3], 16, -722521979), d = qf(d, f, p, c, a[g + 6], 23, 76029189), c = qf(c, d, f, p, a[g + 9], 4, -640364487), p = qf(p, c, d, f, a[g + 12], 11, -421815835), f = qf(f, p, c, d, a[g + 15], 16, 530742520), c = Kf(c, d = qf(d, f, p, c, a[g + 2], 23, -995338651), f, p, a[g], 6, -198630844), p = Kf(p, c, d, f, a[g + 7], 10, 1126891415), f = Kf(f, p, c, d, a[g + 14], 15, -1416354905), d = Kf(d, f, p, c, a[g + 5], 21, -57434055), c = Kf(c, d, f, p, a[g + 12], 6, 1700485571), p = Kf(p, c, d, f, a[g + 3], 10, -1894986606), f = Kf(f, p, c, d, a[g + 10], 15, -1051523), d = Kf(d, f, p, c, a[g + 1], 21, -2054922799), c = Kf(c, d, f, p, a[g + 8], 6, 1873313359), p = Kf(p, c, d, f, a[g + 15], 10, -30611744), f = Kf(f, p, c, d, a[g + 6], 15, -1560198380), d = Kf(d, f, p, c, a[g + 13], 21, 1309151649), c = Kf(c, d, f, p, a[g + 4], 6, -145523070), p = Kf(p, c, d, f, a[g + 11], 10, -1120210379), f = Kf(f, p, c, d, a[g + 2], 15, 718787259), d = Kf(d, f, p, c, a[g + 9], 21, -343485551), c = NS(c, b), d = NS(d, w), f = NS(f, x), p = NS(p, E);
    }
    return [c, d, f, p];
  })((function(a) {
    if (a.length === 0) return [];
    for (var i = 8 * a.length, c = new Uint32Array($_(i)), d = 0; d < i; d += 8) c[d >> 5] |= (255 & a[d / 8]) << d % 32;
    return c;
  })(e), 8 * e.length));
}), m7e = f7e;
function h7e(e, t, r, a) {
  switch (e) {
    case 0:
      return t & r ^ ~t & a;
    case 1:
    case 3:
      return t ^ r ^ a;
    case 2:
      return t & r ^ t & a ^ r & a;
  }
}
function rA(e, t) {
  return e << t | e >>> 32 - t;
}
var p7e = Yee("v5", 80, function(e) {
  var t = [1518500249, 1859775393, 2400959708, 3395469782], r = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof e == "string") {
    var a = unescape(encodeURIComponent(e));
    e = [];
    for (var i = 0; i < a.length; ++i) e.push(a.charCodeAt(i));
  } else Array.isArray(e) || (e = Array.prototype.slice.call(e));
  e.push(128);
  for (var c = e.length / 4 + 2, d = Math.ceil(c / 16), f = new Array(d), p = 0; p < d; ++p) {
    for (var g = new Uint32Array(16), b = 0; b < 16; ++b) g[b] = e[64 * p + 4 * b] << 24 | e[64 * p + 4 * b + 1] << 16 | e[64 * p + 4 * b + 2] << 8 | e[64 * p + 4 * b + 3];
    f[p] = g;
  }
  f[d - 1][14] = 8 * (e.length - 1) / Math.pow(2, 32), f[d - 1][14] = Math.floor(f[d - 1][14]), f[d - 1][15] = 8 * (e.length - 1) & 4294967295;
  for (var w = 0; w < d; ++w) {
    for (var x = new Uint32Array(80), E = 0; E < 16; ++E) x[E] = f[w][E];
    for (var P = 16; P < 80; ++P) x[P] = rA(x[P - 3] ^ x[P - 8] ^ x[P - 14] ^ x[P - 16], 1);
    for (var k = r[0], M = r[1], T = r[2], N = r[3], D = r[4], $ = 0; $ < 80; ++$) {
      var j = Math.floor($ / 20), I = rA(k, 5) + h7e(j, M, T, N) + D + t[j] + x[$] >>> 0;
      D = N, N = T, T = rA(M, 30) >>> 0, M = k, k = I;
    }
    r[0] = r[0] + k >>> 0, r[1] = r[1] + M >>> 0, r[2] = r[2] + T >>> 0, r[3] = r[3] + N >>> 0, r[4] = r[4] + D >>> 0;
  }
  return [r[0] >> 24 & 255, r[0] >> 16 & 255, r[0] >> 8 & 255, 255 & r[0], r[1] >> 24 & 255, r[1] >> 16 & 255, r[1] >> 8 & 255, 255 & r[1], r[2] >> 24 & 255, r[2] >> 16 & 255, r[2] >> 8 & 255, 255 & r[2], r[3] >> 24 & 255, r[3] >> 16 & 255, r[3] >> 8 & 255, 255 & r[3], r[4] >> 24 & 255, r[4] >> 16 & 255, r[4] >> 8 & 255, 255 & r[4]];
}), g7e = p7e, iI = Object.freeze({ __proto__: null, v1: function(e, t, r) {
  var a = t && r || 0, i = t || new Array(16), c = (e = e || {}).node || D_, d = e.clockseq !== void 0 ? e.clockseq : ZR;
  if (c == null || d == null) {
    var f = e.random || (e.rng || N_)();
    c == null && (c = D_ = [1 | f[0], f[1], f[2], f[3], f[4], f[5]]), d == null && (d = ZR = 16383 & (f[6] << 8 | f[7]));
  }
  var p = e.msecs !== void 0 ? e.msecs : Date.now(), g = e.nsecs !== void 0 ? e.nsecs : nA + 1, b = p - tA + (g - nA) / 1e4;
  if (b < 0 && e.clockseq === void 0 && (d = d + 1 & 16383), (b < 0 || p > tA) && e.nsecs === void 0 && (g = 0), g >= 1e4) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  tA = p, nA = g, ZR = d;
  var w = (1e4 * (268435455 & (p += 122192928e5)) + g) % 4294967296;
  i[a++] = w >>> 24 & 255, i[a++] = w >>> 16 & 255, i[a++] = w >>> 8 & 255, i[a++] = 255 & w;
  var x = p / 4294967296 * 1e4 & 268435455;
  i[a++] = x >>> 8 & 255, i[a++] = 255 & x, i[a++] = x >>> 24 & 15 | 16, i[a++] = x >>> 16 & 255, i[a++] = d >>> 8 | 128, i[a++] = 255 & d;
  for (var E = 0; E < 6; ++E) i[a + E] = c[E];
  return t || yk(i);
}, v3: m7e, v4: function(e, t, r) {
  var a = (e = e || {}).random || (e.rng || N_)();
  if (a[6] = 15 & a[6] | 64, a[8] = 63 & a[8] | 128, t) {
    r = r || 0;
    for (var i = 0; i < 16; ++i) t[r + i] = a[i];
    return t;
  }
  return yk(a);
}, v5: g7e, NIL: "00000000-0000-0000-0000-000000000000", version: function(e) {
  if (!i9(e)) throw TypeError("Invalid UUID");
  return parseInt(e.substr(14, 1), 16);
}, validate: i9, stringify: yk, parse: Kee });
const I5 = ["debug", "info", "warn", "error", "none"];
var lI = { commonBasicLogger: function(e, t) {
  if (e && e.destination && typeof e.destination != "function") throw new Error("destination for basicLogger was set to a non-function");
  function r(g) {
    return function(b) {
      console && console[g] && console[g].call(console, b);
    };
  }
  const a = e && e.destination ? [e.destination, e.destination, e.destination, e.destination] : [r("log"), r("info"), r("warn"), r("error")], i = !(!e || !e.destination), c = e && e.prefix !== void 0 && e.prefix !== null ? e.prefix : "[LaunchDarkly] ";
  let d = 1;
  if (e && e.level) for (let g = 0; g < I5.length; g++) I5[g] === e.level && (d = g);
  function f(g, b, w) {
    if (w.length < 1) return;
    let x;
    const E = i ? b + ": " + c : c;
    if (w.length !== 1 && t) {
      const P = [...w];
      P[0] = E + P[0], x = t(...P);
    } else x = E + w[0];
    try {
      a[g](x);
    } catch (P) {
      console && console.log && console.log("[LaunchDarkly] Configured logger's " + b + " method threw an exception: " + P);
    }
  }
  const p = {};
  for (let g = 0; g < I5.length; g++) {
    const b = I5[g];
    if (b !== "none") if (g < d) p[b] = () => {
    };
    else {
      const w = g;
      p[b] = function() {
        f(w, b, arguments);
      };
    }
  }
  return p;
}, validateLogger: function(e) {
  I5.forEach((t) => {
    if (t !== "none" && (!e[t] || typeof e[t] != "function")) throw new Error("Provided logger instance must support logger." + t + "(...) method");
  });
} };
function sP(e) {
  return e && e.message ? e.message : typeof e == "string" || e instanceof String ? e : JSON.stringify(e);
}
const j3 = " Please see https://docs.launchdarkly.com/sdk/client-side/javascript#initialize-the-client for instructions on SDK initialization.";
var xa = { bootstrapInvalid: function() {
  return "LaunchDarkly bootstrap data is not available because the back end could not read the flags.";
}, bootstrapOldFormat: function() {
  return "LaunchDarkly client was initialized with bootstrap data that did not include flag metadata. Events may not be sent correctly." + j3;
}, clientInitialized: function() {
  return "LaunchDarkly client initialized";
}, clientNotReady: function() {
  return "LaunchDarkly client is not ready";
}, debugEnqueueingEvent: function(e) {
  return 'enqueueing "' + e + '" event';
}, debugPostingDiagnosticEvent: function(e) {
  return "sending diagnostic event (" + e.kind + ")";
}, debugPostingEvents: function(e) {
  return "sending " + e + " events";
}, debugStreamDelete: function(e) {
  return 'received streaming deletion for flag "' + e + '"';
}, debugStreamDeleteIgnored: function(e) {
  return 'received streaming deletion for flag "' + e + '" but ignored due to version check';
}, debugStreamPatch: function(e) {
  return 'received streaming update for flag "' + e + '"';
}, debugStreamPatchIgnored: function(e) {
  return 'received streaming update for flag "' + e + '" but ignored due to version check';
}, debugStreamPing: function() {
  return "received ping message from stream";
}, debugPolling: function(e) {
  return "polling for feature flags at " + e;
}, debugStreamPut: function() {
  return "received streaming update for all flags";
}, deprecated: function(e, t) {
  return t ? '"' + e + '" is deprecated, please use "' + t + '"' : '"' + e + '" is deprecated';
}, environmentNotFound: function() {
  return "Environment not found. Double check that you specified a valid environment/client-side ID." + j3;
}, environmentNotSpecified: function() {
  return "No environment/client-side ID was specified." + j3;
}, errorFetchingFlags: function(e) {
  return "Error fetching flag settings: " + sP(e);
}, eventCapacityExceeded: function() {
  return "Exceeded event queue capacity. Increase capacity to avoid dropping events.";
}, eventWithoutContext: function() {
  return "Be sure to call `identify` in the LaunchDarkly client: https://docs.launchdarkly.com/sdk/features/identify#javascript";
}, httpErrorMessage: function(e, t, r) {
  return "Received error " + e + (e === 401 ? " (invalid SDK key)" : "") + " for " + t + " - " + (iu.isHttpErrorRecoverable(e) ? r : "giving up permanently");
}, httpUnavailable: function() {
  return "Cannot make HTTP requests in this environment." + j3;
}, identifyDisabled: function() {
  return "identify() has no effect here; it must be called on the main client instance";
}, inspectorMethodError: (e, t) => `an inspector: "${t}" of type: "${e}" generated an exception`, invalidContentType: function(e) {
  return 'Expected application/json content type but got "' + e + '"';
}, invalidData: function() {
  return "Invalid data received from LaunchDarkly; connection may have been interrupted";
}, invalidInspector: (e, t) => `an inspector: "${t}" of an invalid type (${e}) was configured`, invalidKey: function() {
  return "Event key must be a string";
}, invalidMetricValue: (e) => `The track function was called with a non-numeric "metricValue" (${e}), only numeric metric values are supported.`, invalidContext: function() {
  return "Invalid context specified." + j3;
}, invalidTagValue: (e) => `Config option "${e}" must only contain letters, numbers, ., _ or -.`, localStorageUnavailable: function(e) {
  return "local storage is unavailable: " + sP(e);
}, networkError: (e) => "network error" + (e ? " (" + e + ")" : ""), optionBelowMinimum: (e, t, r) => 'Config option "' + e + '" was set to ' + t + ", changing to minimum value of " + r, streamClosing: function() {
  return "Closing stream connection";
}, streamConnecting: function(e) {
  return "Opening stream connection to " + e;
}, streamError: function(e, t) {
  return "Error on stream connection: " + sP(e) + ", will continue retrying after " + t + " milliseconds.";
}, tagValueTooLong: (e) => `Value of "${e}" was longer than 64 characters and was discarded.`, unknownCustomEventKey: function(e) {
  return 'Custom event "' + e + '" does not exist';
}, unknownOption: (e) => 'Ignoring unknown config option "' + e + '"', contextNotSpecified: function() {
  return "No context specified." + j3;
}, unrecoverableStreamError: (e) => `Error on stream connection ${sP(e)}, giving up permanently`, wrongOptionType: (e, t, r) => 'Config option "' + e + '" should be of type ' + t + ", got " + r + ", using default value", wrongOptionTypeBoolean: (e, t) => 'Config option "' + e + '" should be a boolean, got ' + t + ", converting to boolean" };
const { validateLogger: v7e } = lI, z_ = { baseUrl: { default: "https://app.launchdarkly.com" }, streamUrl: { default: "https://clientstream.launchdarkly.com" }, eventsUrl: { default: "https://events.launchdarkly.com" }, sendEvents: { default: !0 }, streaming: { type: "boolean" }, sendLDHeaders: { default: !0 }, requestHeaderTransform: { type: "function" }, sendEventsOnlyForVariation: { default: !1 }, useReport: { default: !1 }, evaluationReasons: { default: !1 }, eventCapacity: { default: 100, minimum: 1 }, flushInterval: { default: 2e3, minimum: 2e3 }, samplingInterval: { default: 0, minimum: 0 }, streamReconnectDelay: { default: 1e3, minimum: 0 }, allAttributesPrivate: { default: !1 }, privateAttributes: { default: [] }, bootstrap: { type: "string|object" }, diagnosticRecordingInterval: { default: 9e5, minimum: 2e3 }, diagnosticOptOut: { default: !1 }, wrapperName: { type: "string" }, wrapperVersion: { type: "string" }, stateProvider: { type: "object" }, application: { validator: function(e, t, r) {
  const a = {};
  return t.id && (a.id = j_(`${e}.id`, t.id, r)), t.version && (a.version = j_(`${e}.version`, t.version, r)), a;
} }, inspectors: { default: [] }, hooks: { default: [] }, plugins: { default: [] } }, b7e = /^(\w|\.|-)+$/;
function aA(e) {
  return e && e.replace(/\/+$/, "");
}
function j_(e, t, r) {
  if (typeof t == "string" && t.match(b7e)) {
    if (!(t.length > 64)) return t;
    r.warn(xa.tagValueTooLong(e));
  } else r.warn(xa.invalidTagValue(e));
}
var sI = { baseOptionDefs: z_, validate: function(e, t, r, a) {
  const i = Na.extend({ logger: { default: a } }, z_, r), c = {};
  function d(p) {
    Na.onNextTick(() => {
      t && t.maybeReportError(new iu.LDInvalidArgumentError(p));
    });
  }
  let f = Na.extend({}, e || {});
  return (function(p) {
    const g = p;
    Object.keys(c).forEach((b) => {
      if (g[b] !== void 0) {
        const w = c[b];
        a && a.warn(xa.deprecated(b, w)), w && (g[w] === void 0 && (g[w] = g[b]), delete g[b]);
      }
    });
  })(f), f = (function(p) {
    const g = Na.extend({}, p);
    return Object.keys(i).forEach((b) => {
      g[b] !== void 0 && g[b] !== null || (g[b] = i[b] && i[b].default);
    }), g;
  })(f), f = (function(p) {
    const g = Na.extend({}, p), b = (w) => {
      if (w === null) return "any";
      if (w === void 0) return;
      if (Array.isArray(w)) return "array";
      const x = typeof w;
      return x === "boolean" || x === "string" || x === "number" || x === "function" ? x : "object";
    };
    return Object.keys(p).forEach((w) => {
      const x = p[w];
      if (x != null) {
        const E = i[w];
        if (E === void 0) d(xa.unknownOption(w));
        else {
          const P = E.type || b(E.default), k = E.validator;
          if (k) {
            const M = k(w, p[w], a);
            M !== void 0 ? g[w] = M : delete g[w];
          } else if (P !== "any") {
            const M = P.split("|"), T = b(x);
            M.indexOf(T) < 0 ? P === "boolean" ? (g[w] = !!x, d(xa.wrongOptionTypeBoolean(w, T))) : (d(xa.wrongOptionType(w, P, T)), g[w] = E.default) : T === "number" && E.minimum !== void 0 && x < E.minimum && (d(xa.optionBelowMinimum(w, x, E.minimum)), g[w] = E.minimum);
          }
        }
      }
    }), g.baseUrl = aA(g.baseUrl), g.streamUrl = aA(g.streamUrl), g.eventsUrl = aA(g.eventsUrl), g;
  })(f), v7e(f.logger), f;
}, getTags: function(e) {
  const t = {};
  return e && (e.application && e.application.id !== void 0 && e.application.id !== null && (t["application-id"] = [e.application.id]), e.application && e.application.version !== void 0 && e.application.id !== null && (t["application-version"] = [e.application.version])), t;
} };
const { getLDUserAgentString: y7e } = Na;
var uI = { getLDHeaders: function(e, t) {
  if (t && !t.sendLDHeaders) return {};
  const r = {};
  r[e.userAgentHeaderName || "User-Agent"] = y7e(e), t && t.wrapperName && (r["X-LaunchDarkly-Wrapper"] = t.wrapperVersion ? t.wrapperName + "/" + t.wrapperVersion : t.wrapperName);
  const a = sI.getTags(t), i = Object.keys(a);
  return i.length && (r["x-launchdarkly-tags"] = i.sort().map((c) => Array.isArray(a[c]) ? a[c].sort().map((d) => `${c}/${d}`) : [`${c}/${a[c]}`]).reduce((c, d) => c.concat(d), []).join(" ")), r;
}, transformHeaders: function(e, t) {
  return t && t.requestHeaderTransform ? t.requestHeaderTransform({ ...e }) : e;
} };
const { v1: w7e } = iI, { getLDHeaders: S7e, transformHeaders: C7e } = uI;
var Qee = function(e, t, r) {
  const a = Na.extend({ "Content-Type": "application/json" }, S7e(e, r)), i = {};
  return i.sendEvents = (c, d, f) => {
    if (!e.httpRequest) return Promise.resolve();
    const p = JSON.stringify(c), g = f ? null : w7e();
    return (function b(w) {
      const x = f ? a : Na.extend({}, a, { "X-LaunchDarkly-Event-Schema": "4", "X-LaunchDarkly-Payload-ID": g });
      return e.httpRequest("POST", d, C7e(x, r), p).promise.then((E) => {
        if (E) return E.status >= 400 && iu.isHttpErrorRecoverable(E.status) && w ? b(!1) : (function(P) {
          const k = { status: P.status }, M = P.header("date");
          if (M) {
            const T = Date.parse(M);
            T && (k.serverTime = T);
          }
          return k;
        })(E);
      }).catch(() => w ? b(!1) : Promise.reject());
    })(!0).catch(() => {
    });
  }, i;
}, x7e = function e(t, r = []) {
  if (t === null || typeof t != "object") return JSON.stringify(t);
  if (r.includes(t)) throw new Error("Cycle detected");
  return Array.isArray(t) ? `[${t.map((a) => e(a, [...r, t])).map((a) => a === void 0 ? "null" : a).join(",")}]` : `{${Object.keys(t).sort().map((a) => {
    const i = e(t[a], [...r, t]);
    if (i !== void 0) return `${JSON.stringify(a)}:${i}`;
  }).filter((a) => a !== void 0).join(",")}}`;
};
const { commonBasicLogger: E7e } = lI;
function I_(e) {
  return typeof e == "string" && e !== "kind" && e.match(/^(\w|\.|-)+$/);
}
var RM = { checkContext: function(e, t) {
  if (e) {
    if (t && (e.kind === void 0 || e.kind === null)) return e.key !== void 0 && e.key !== null;
    const r = e.key, a = e.kind === void 0 ? "user" : e.kind, i = I_(a), c = a === "multi" || r != null && r !== "";
    if (a === "multi") {
      const d = Object.keys(e).filter((f) => f !== "kind");
      return c && d.every((f) => I_(f)) && d.every((f) => {
        const p = e[f].key;
        return p != null && p !== "";
      });
    }
    return c && i;
  }
  return !1;
}, getContextKeys: function(e, t = E7e()) {
  if (!e) return;
  const r = {}, { kind: a, key: i } = e;
  switch (a) {
    case void 0:
      r.user = `${i}`;
      break;
    case "multi":
      Object.entries(e).filter(([c]) => c !== "kind").forEach(([c, d]) => {
        d && d.key && (r[c] = d.key);
      });
      break;
    case null:
      t.warn(`null is not a valid context kind: ${e}`);
      break;
    case "":
      t.warn(`'' is not a valid context kind: ${e}`);
      break;
    default:
      r[a] = `${i}`;
  }
  return r;
}, getContextKinds: function(e) {
  return e ? e.kind === null || e.kind === void 0 ? ["user"] : e.kind !== "multi" ? [e.kind] : Object.keys(e).filter((t) => t !== "kind") : [];
} };
const { getContextKinds: P7e } = RM;
var k7e = function() {
  const e = {};
  let t = 0, r = 0, a = {}, i = {};
  return e.summarizeEvent = (c) => {
    if (c.kind === "feature") {
      const d = c.key + ":" + (c.variation !== null && c.variation !== void 0 ? c.variation : "") + ":" + (c.version !== null && c.version !== void 0 ? c.version : ""), f = a[d];
      let p = i[c.key];
      p || (p = /* @__PURE__ */ new Set(), i[c.key] = p), (function(g) {
        return g.context ? P7e(g.context) : g.contextKeys ? Object.keys(g.contextKeys) : [];
      })(c).forEach((g) => p.add(g)), f ? f.count = f.count + 1 : a[d] = { count: 1, key: c.key, version: c.version, variation: c.variation, value: c.value, default: c.default }, (t === 0 || c.creationDate < t) && (t = c.creationDate), c.creationDate > r && (r = c.creationDate);
    }
  }, e.getSummary = () => {
    const c = {};
    let d = !0;
    for (const f of Object.values(a)) {
      let p = c[f.key];
      p || (p = { default: f.default, counters: [], contextKinds: [...i[f.key]] }, c[f.key] = p);
      const g = { value: f.value, count: f.count };
      f.variation !== void 0 && f.variation !== null && (g.variation = f.variation), f.version !== void 0 && f.version !== null ? g.version = f.version : g.unknown = !0, p.counters.push(g), d = !1;
    }
    return d ? null : { startDate: t, endDate: r, features: c, kind: "summary" };
  }, e.clearSummary = () => {
    t = 0, r = 0, a = {}, i = {};
  }, e;
}, M7e = function(e) {
  let t = {}, r = {};
  return { summarizeEvent: function(a) {
    if (a.kind === "feature") {
      const i = x7e(a.context);
      if (!i) return;
      let c = t[i];
      c || (t[i] = k7e(), c = t[i], r[i] = a.context), c.summarizeEvent(a);
    }
  }, getSummaries: function() {
    const a = t, i = r;
    return t = {}, r = {}, Object.entries(a).map(([c, d]) => {
      const f = d.getSummary();
      return f.context = e.filter(i[c]), f;
    });
  } };
};
function Jee(e) {
  return e.replace(/~/g, "~0").replace(/\//g, "~1");
}
function L_(e) {
  return (e.startsWith("/") ? e.substring(1) : e).split("/").map((t) => t.indexOf("~") >= 0 ? t.replace(/~1/g, "/").replace(/~0/g, "~") : t);
}
function H_(e) {
  return !e.startsWith("/");
}
function F_(e, t) {
  const r = H_(e), a = H_(t);
  if (r && a) return e === t;
  if (r) {
    const i = L_(t);
    return i.length === 1 && e === i[0];
  }
  if (a) {
    const i = L_(e);
    return i.length === 1 && t === i[0];
  }
  return e === t;
}
function W_(e) {
  return `/${Jee(e)}`;
}
var oA = { cloneExcluding: function(e, t) {
  const r = [], a = {}, i = [];
  for (r.push(...Object.keys(e).map((c) => ({ key: c, ptr: W_(c), source: e, parent: a, visited: [e] }))); r.length; ) {
    const c = r.pop();
    if (t.some((d) => F_(d, c.ptr))) i.push(c.ptr);
    else {
      const d = c.source[c.key];
      if (d === null) c.parent[c.key] = d;
      else if (Array.isArray(d)) c.parent[c.key] = [...d];
      else if (typeof d == "object") {
        if (c.visited.includes(d)) continue;
        c.parent[c.key] = {}, r.push(...Object.keys(d).map((f) => {
          return { key: f, ptr: (p = c.ptr, g = Jee(f), `${p}/${g}`), source: d, parent: c.parent[c.key], visited: [...c.visited, d] };
          var p, g;
        }));
      } else c.parent[c.key] = d;
    }
  }
  return { cloned: a, excluded: i.sort() };
}, compare: F_, literalToReference: W_ }, O7e = function(e) {
  const t = {}, r = e.allAttributesPrivate, a = e.privateAttributes || [], i = ["key", "kind", "_meta", "anonymous"], c = ["name", "ip", "firstName", "lastName", "email", "avatar", "country"], d = (f, p) => {
    if (typeof f != "object" || f === null || Array.isArray(f)) return;
    const { cloned: g, excluded: b } = oA.cloneExcluding(f, ((w, x) => (r || x && w.anonymous ? Object.keys(w) : [...a, ...w._meta && w._meta.privateAttributes || []]).filter((E) => !i.some((P) => oA.compare(E, P))))(f, p));
    return g.key = String(g.key), b.length && (g._meta || (g._meta = {}), g._meta.redactedAttributes = b), g._meta && (delete g._meta.privateAttributes, Object.keys(g._meta).length === 0 && delete g._meta), g.anonymous !== void 0 && (g.anonymous = !!g.anonymous), g;
  };
  return t.filter = (f, p = !1) => f.kind === void 0 || f.kind === null ? d(((g) => {
    const b = { ...g.custom || {}, kind: "user", key: g.key };
    g.anonymous !== void 0 && (b.anonymous = !!g.anonymous);
    for (const w of c) delete b[w], g[w] !== void 0 && g[w] !== null && (b[w] = String(g[w]));
    return g.privateAttributeNames !== void 0 && g.privateAttributeNames !== null && (b._meta = b._meta || {}, b._meta.privateAttributes = g.privateAttributeNames.map((w) => w.startsWith("/") ? oA.literalToReference(w) : w)), b;
  })(f), p) : f.kind === "multi" ? ((g, b) => {
    const w = { kind: g.kind }, x = Object.keys(g);
    for (const E of x) if (E !== "kind") {
      const P = d(g[E], b);
      P && (w[E] = P);
    }
    return w;
  })(f, p) : d(f, p), t;
};
const { getContextKeys: T7e } = RM;
var R7e = function(e, t, r, a = null, i = null, c = null) {
  const d = {}, f = c || Qee(e, r, t), p = Na.appendUrlPath(t.eventsUrl, "/events/bulk/" + r), g = O7e(t), b = M7e(g), w = t.samplingInterval, x = t.eventCapacity, E = t.flushInterval, P = t.logger;
  let k, M = [], T = 0, N = !1, D = !1;
  function $() {
    return w === 0 || Math.floor(Math.random() * w) === 0;
  }
  function j(L) {
    const F = Na.extend({}, L);
    return L.kind === "identify" || L.kind === "feature" || L.kind === "custom" ? F.context = g.filter(L.context) : (F.contextKeys = T7e(L.context, P), delete F.context), L.kind === "feature" && (delete F.trackEvents, delete F.debugEventsUntilDate), F;
  }
  function I(L) {
    M.length < x ? (M.push(L), D = !1) : (D || (D = !0, P.warn(xa.eventCapacityExceeded())), a && a.incrementDroppedEvents());
  }
  return d.enqueue = function(L) {
    if (N) return;
    let F = !1, _ = !1;
    var W;
    if (b.summarizeEvent(L), L.kind === "feature" ? $() && (F = !!L.trackEvents, _ = !!(W = L).debugEventsUntilDate && W.debugEventsUntilDate > T && W.debugEventsUntilDate > (/* @__PURE__ */ new Date()).getTime()) : F = $(), F && I(j(L)), _) {
      const Q = Na.extend({}, L, { kind: "debug" });
      Q.context = g.filter(Q.context), delete Q.trackEvents, delete Q.debugEventsUntilDate, I(Q);
    }
  }, d.flush = async function() {
    if (N) return Promise.resolve();
    const L = M;
    return b.getSummaries().forEach((F) => {
      Object.keys(F.features).length && L.push(F);
    }), a && a.setEventsInLastBatch(L.length), L.length === 0 ? Promise.resolve() : (M = [], P.debug(xa.debugPostingEvents(L.length)), f.sendEvents(L, p).then((F) => {
      F && (F.serverTime && (T = F.serverTime), iu.isHttpErrorRecoverable(F.status) || (N = !0), F.status >= 400 && Na.onNextTick(() => {
        i.maybeReportError(new iu.LDUnexpectedResponseError(xa.httpErrorMessage(F.status, "event posting", "some events were dropped")));
      }));
    }));
  }, d.start = function() {
    const L = () => {
      d.flush(), k = setTimeout(L, E);
    };
    k = setTimeout(L, E);
  }, d.stop = function() {
    clearTimeout(k);
  }, d;
}, A7e = function(e) {
  const t = {}, r = {};
  return t.on = function(a, i, c) {
    r[a] = r[a] || [], r[a] = r[a].concat({ handler: i, context: c });
  }, t.off = function(a, i, c) {
    if (r[a]) for (let d = 0; d < r[a].length; d++) r[a][d].handler === i && r[a][d].context === c && (r[a] = r[a].slice(0, d).concat(r[a].slice(d + 1)));
  }, t.emit = function(a) {
    if (!r[a]) return;
    const i = r[a].slice(0);
    for (let c = 0; c < i.length; c++) i[c].handler.apply(i[c].context, Array.prototype.slice.call(arguments, 1));
  }, t.getEvents = function() {
    return Object.keys(r);
  }, t.getEventListenerCount = function(a) {
    return r[a] ? r[a].length : 0;
  }, t.maybeReportError = function(a) {
    a && (r.error ? this.emit("error", a) : (e || console).error(a.message));
  }, t;
};
const uP = "ready", iA = "initialized", lA = "failed";
var N7e = function(e) {
  let t = !1, r = !1, a = null, i = null;
  const c = new Promise((d) => {
    const f = () => {
      e.off(uP, f), d();
    };
    e.on(uP, f);
  }).catch(() => {
  });
  return { getInitializationPromise: () => i || (t ? Promise.resolve() : r ? Promise.reject(a) : (i = new Promise((d, f) => {
    const p = () => {
      e.off(iA, p), d();
    }, g = (b) => {
      e.off(lA, g), f(b);
    };
    e.on(iA, p), e.on(lA, g);
  }), i)), getReadyPromise: () => c, signalSuccess: () => {
    t || r || (t = !0, e.emit(iA), e.emit(uP));
  }, signalFailure: (d) => {
    t || r || (r = !0, a = d, e.emit(lA, d), e.emit(uP)), e.maybeReportError(d);
  } };
}, D7e = function(e, t, r, a) {
  const i = {};
  function c() {
    let d = "";
    const f = a.getContext();
    return f && (d = r || Na.btoa(JSON.stringify(f))), "ld:" + t + ":" + d;
  }
  return i.loadFlags = () => e.get(c()).then((d) => {
    if (d == null) return null;
    try {
      let f = JSON.parse(d);
      if (f) {
        const p = f.$schema;
        p === void 0 || p < 1 ? f = Na.transformValuesToVersionedValues(f) : delete f.$schema;
      }
      return f;
    } catch {
      return i.clearFlags().then(() => null);
    }
  }), i.saveFlags = (d) => {
    const f = Na.extend({}, d, { $schema: 1 });
    return e.set(c(), JSON.stringify(f));
  }, i.clearFlags = () => e.clear(c()), i;
}, $7e = function(e, t) {
  const r = {};
  let a = !1;
  const i = (c) => {
    a || (a = !0, t.warn(xa.localStorageUnavailable(c)));
  };
  return r.isEnabled = () => !!e, r.get = (c) => new Promise((d) => {
    e ? e.get(c).then(d).catch((f) => {
      i(f), d(void 0);
    }) : d(void 0);
  }), r.set = (c, d) => new Promise((f) => {
    e ? e.set(c, d).then(() => f(!0)).catch((p) => {
      i(p), f(!1);
    }) : f(!1);
  }), r.clear = (c) => new Promise((d) => {
    e ? e.clear(c).then(() => d(!0)).catch((f) => {
      i(f), d(!1);
    }) : d(!1);
  }), r;
};
const { appendUrlPath: V_, base64URLEncode: z7e, objectHasOwnProperty: j7e } = Na, { getLDHeaders: I7e, transformHeaders: L7e } = uI, { isHttpErrorRecoverable: H7e } = iu;
var F7e = function(e, t, r, a) {
  const i = t.streamUrl, c = t.logger, d = {}, f = V_(i, "/eval/" + r), p = t.useReport, g = t.evaluationReasons, b = t.streamReconnectDelay, w = I7e(e, t);
  let x, E = !1, P = null, k = null, M = null, T = null, N = null, D = 0;
  function $() {
    const W = (Q = (function() {
      const U = b * Math.pow(2, D);
      return U > 3e4 ? 3e4 : U;
    })(), Q - Math.trunc(0.5 * Math.random() * Q));
    var Q;
    return D += 1, W;
  }
  function j(W) {
    if (W.status && typeof W.status == "number" && !H7e(W.status)) return F(), c.error(xa.unrecoverableStreamError(W)), void (k && (clearTimeout(k), k = null));
    const Q = $();
    E || (c.warn(xa.streamError(W, Q)), E = !0), _(!1), F(), I(Q);
  }
  function I(W) {
    k || (W ? k = setTimeout(L, W) : L());
  }
  function L() {
    let W;
    k = null;
    let Q = "";
    const U = { headers: w, readTimeoutMillis: 3e5 };
    if (e.eventSourceFactory) {
      T != null && (Q = "h=" + T), p ? e.eventSourceAllowsReport ? (W = f, U.method = "REPORT", U.headers["Content-Type"] = "application/json", U.body = JSON.stringify(M)) : (W = V_(i, "/ping/" + r), Q = "") : W = f + "/" + z7e(JSON.stringify(M)), U.headers = L7e(U.headers, t), g && (Q = Q + (Q ? "&" : "") + "withReasons=true"), W = W + (Q ? "?" : "") + Q, F(), c.info(xa.streamConnecting(W)), x = (/* @__PURE__ */ new Date()).getTime(), P = e.eventSourceFactory(W, U);
      for (const Y in N) j7e(N, Y) && P.addEventListener(Y, N[Y]);
      P.onerror = j, P.onopen = () => {
        D = 0;
      };
    }
  }
  function F() {
    P && (c.info(xa.streamClosing()), P.close(), P = null);
  }
  function _(W) {
    x && a && a.recordStreamInit(x, !W, (/* @__PURE__ */ new Date()).getTime() - x), x = null;
  }
  return d.connect = function(W, Q, U) {
    M = W, T = Q, N = {};
    for (const Y in U || {}) N[Y] = function(G) {
      E = !1, _(!0), U[Y] && U[Y](G);
    };
    I();
  }, d.disconnect = function() {
    clearTimeout(k), k = null, F();
  }, d.isConnected = function() {
    return !!(P && e.eventSourceIsActive && e.eventSourceIsActive(P));
  }, d;
}, W7e = function(e) {
  let t, r, a, i;
  const c = { addPromise: (d, f) => {
    t = d, r && r(), r = f, d.then((p) => {
      t === d && (a(p), e && e());
    }, (p) => {
      t === d && (i(p), e && e());
    });
  } };
  return c.resultPromise = new Promise((d, f) => {
    a = d, i = f;
  }), c;
};
const { transformHeaders: V7e, getLDHeaders: _7e } = uI, __ = "application/json";
var B7e = function(e, t, r) {
  const a = t.baseUrl, i = t.useReport, c = t.evaluationReasons, d = t.logger, f = {}, p = {};
  function g(b, w) {
    if (!e.httpRequest) return new Promise((T, N) => {
      N(new iu.LDFlagFetchError(xa.httpUnavailable()));
    });
    const x = w ? "REPORT" : "GET", E = _7e(e, t);
    w && (E["Content-Type"] = __);
    let P = p[b];
    P || (P = W7e(() => {
      delete p[b];
    }), p[b] = P);
    const k = e.httpRequest(x, b, V7e(E, t), w), M = k.promise.then((T) => {
      if (T.status === 200) {
        if (T.header("content-type") && T.header("content-type").substring(0, 16) === __) return JSON.parse(T.body);
        {
          const N = xa.invalidContentType(T.header("content-type") || "");
          return Promise.reject(new iu.LDFlagFetchError(N));
        }
      }
      return Promise.reject((function(N) {
        return N.status === 404 ? new iu.LDInvalidEnvironmentIdError(xa.environmentNotFound()) : new iu.LDFlagFetchError(xa.errorFetchingFlags(N.statusText || String(N.status)));
      })(T));
    }, (T) => Promise.reject(new iu.LDFlagFetchError(xa.networkError(T))));
    return P.addPromise(M, () => {
      k.cancel && k.cancel();
    }), P.resultPromise;
  }
  return f.fetchJSON = function(b) {
    return g(Na.appendUrlPath(a, b), null);
  }, f.fetchFlagSettings = function(b, w) {
    let x, E, P, k = "";
    return i ? (E = [a, "/sdk/evalx/", r, "/context"].join(""), P = JSON.stringify(b)) : (x = Na.base64URLEncode(JSON.stringify(b)), E = [a, "/sdk/evalx/", r, "/contexts/", x].join("")), w && (k = "h=" + w), c && (k = k + (k ? "&" : "") + "withReasons=true"), E = E + (k ? "?" : "") + k, d.debug(xa.debugPolling(E)), g(E, P);
  }, f;
}, U7e = function(e, t) {
  const r = {};
  let a;
  return r.setContext = function(i) {
    a = Na.sanitizeContext(i), a && t && t(Na.clone(a));
  }, r.getContext = function() {
    return a ? Na.clone(a) : null;
  }, r;
};
const { v1: X7e } = iI, { getContextKinds: G7e } = RM;
var q7e = function(e) {
  function t(a) {
    return a == null || a === "user" ? "ld:$anonUserId" : `ld:$contextKey:${a}`;
  }
  function r(a, i) {
    return i.key !== null && i.key !== void 0 ? (i.key = i.key.toString(), Promise.resolve(i)) : i.anonymous ? (function(c) {
      return e.get(t(c));
    })(a).then((c) => {
      if (c) return i.key = c, i;
      {
        const d = X7e();
        return i.key = d, (function(f, p) {
          return e.set(t(p), f);
        })(d, a).then(() => i);
      }
    }) : Promise.reject(new iu.LDInvalidUserError(xa.invalidContext()));
  }
  this.processContext = (a) => {
    if (!a) return Promise.reject(new iu.LDInvalidUserError(xa.contextNotSpecified()));
    const i = Na.clone(a);
    if (a.kind === "multi") {
      const c = G7e(i);
      return Promise.all(c.map((d) => r(d, i[d]))).then(() => i);
    }
    return r(a.kind, i);
  };
};
const { v1: K7e } = iI, { baseOptionDefs: sA } = sI, { appendUrlPath: Y7e } = Na;
var uA = { DiagnosticId: function(e) {
  const t = { diagnosticId: K7e() };
  return e && (t.sdkKeySuffix = e.length > 6 ? e.substring(e.length - 6) : e), t;
}, DiagnosticsAccumulator: function(e) {
  let t, r, a, i;
  function c(d) {
    t = d, r = 0, a = 0, i = [];
  }
  return c(e), { getProps: () => ({ dataSinceDate: t, droppedEvents: r, eventsInLastBatch: a, streamInits: i }), setProps: (d) => {
    t = d.dataSinceDate, r = d.droppedEvents || 0, a = d.eventsInLastBatch || 0, i = d.streamInits || [];
  }, incrementDroppedEvents: () => {
    r++;
  }, setEventsInLastBatch: (d) => {
    a = d;
  }, recordStreamInit: (d, f, p) => {
    const g = { timestamp: d, failed: f, durationMillis: p };
    i.push(g);
  }, reset: c };
}, DiagnosticsManager: function(e, t, r, a, i, c, d) {
  const f = !!e.diagnosticUseCombinedEvent, p = "ld:" + i + ":$diagnostics", g = Y7e(c.eventsUrl, "/events/diagnostic/" + i), b = c.diagnosticRecordingInterval, w = r;
  let x, E, P = !!c.streaming;
  const k = {};
  function M() {
    return { sdk: D(), configuration: $(), platform: e.diagnosticPlatformData };
  }
  function T(j) {
    c.logger && c.logger.debug(xa.debugPostingDiagnosticEvent(j)), a.sendEvents(j, g, !0).then(() => {
    }).catch(() => {
    });
  }
  function N() {
    T((function() {
      const j = (/* @__PURE__ */ new Date()).getTime();
      let I = { kind: f ? "diagnostic-combined" : "diagnostic", id: d, creationDate: j, ...w.getProps() };
      return f && (I = { ...I, ...M() }), w.reset(j), I;
    })()), E = setTimeout(N, b), x = (/* @__PURE__ */ new Date()).getTime(), f && (function() {
      if (t.isEnabled()) {
        const j = { ...w.getProps() };
        t.set(p, JSON.stringify(j));
      }
    })();
  }
  function D() {
    const j = { ...e.diagnosticSdkData };
    return c.wrapperName && (j.wrapperName = c.wrapperName), c.wrapperVersion && (j.wrapperVersion = c.wrapperVersion), j;
  }
  function $() {
    return { customBaseURI: c.baseUrl !== sA.baseUrl.default, customStreamURI: c.streamUrl !== sA.streamUrl.default, customEventsURI: c.eventsUrl !== sA.eventsUrl.default, eventsCapacity: c.eventCapacity, eventsFlushIntervalMillis: c.flushInterval, reconnectTimeMillis: c.streamReconnectDelay, streamingDisabled: !P, allAttributesPrivate: !!c.allAttributesPrivate, diagnosticRecordingIntervalMillis: c.diagnosticRecordingInterval, usingSecureMode: !!c.hash, bootstrapMode: !!c.bootstrap, fetchGoalsDisabled: !c.fetchGoals, sendEventsOnlyForVariation: !!c.sendEventsOnlyForVariation };
  }
  return k.start = () => {
    f ? (function(j) {
      if (!t.isEnabled()) return j(!1);
      t.get(p).then((I) => {
        if (I) try {
          const L = JSON.parse(I);
          w.setProps(L), x = L.dataSinceDate;
        } catch {
        }
        j(!0);
      }).catch(() => {
        j(!1);
      });
    })((j) => {
      if (j) {
        const I = (x || 0) + b, L = (/* @__PURE__ */ new Date()).getTime();
        L >= I ? N() : E = setTimeout(N, I - L);
      } else Math.floor(4 * Math.random()) === 0 ? N() : E = setTimeout(N, b);
    }) : (T({ kind: "diagnostic-init", id: d, creationDate: w.getProps().dataSinceDate, ...M() }), E = setTimeout(N, b));
  }, k.stop = () => {
    E && clearTimeout(E);
  }, k.setStreaming = (j) => {
    P = j;
  }, k;
} }, Q7e = function(e, t) {
  let r = !1;
  const a = { type: e.type, name: e.name, synchronous: e.synchronous, method: (...i) => {
    try {
      e.method(...i);
    } catch {
      r || (r = !0, t.warn(xa.inspectorMethodError(a.type, a.name)));
    }
  } };
  return a;
};
const { onNextTick: cP } = Na, ep = { flagUsed: "flag-used", flagDetailsChanged: "flag-details-changed", flagDetailChanged: "flag-detail-changed", clientIdentityChanged: "client-identity-changed" };
Object.freeze(ep);
var J7e = { InspectorTypes: ep, InspectorManager: function(e, t) {
  const r = {}, a = { [ep.flagUsed]: [], [ep.flagDetailsChanged]: [], [ep.flagDetailChanged]: [], [ep.clientIdentityChanged]: [] }, i = { [ep.flagUsed]: [], [ep.flagDetailsChanged]: [], [ep.flagDetailChanged]: [], [ep.clientIdentityChanged]: [] }, c = e && e.map((d) => Q7e(d, t));
  return c && c.forEach((d) => {
    Object.prototype.hasOwnProperty.call(a, d.type) && !d.synchronous ? a[d.type].push(d) : Object.prototype.hasOwnProperty.call(i, d.type) && d.synchronous ? i[d.type].push(d) : t.warn(xa.invalidInspector(d.type, d.name));
  }), r.hasListeners = (d) => a[d] && a[d].length || i[d] && i[d].length, r.onFlagUsed = (d, f, p) => {
    const g = ep.flagUsed;
    i[g].length && i[g].forEach((b) => b.method(d, f, p)), a[g].length && cP(() => {
      a[g].forEach((b) => b.method(d, f, p));
    });
  }, r.onFlags = (d) => {
    const f = ep.flagDetailsChanged;
    i[f].length && i[f].forEach((p) => p.method(d)), a[f].length && cP(() => {
      a[f].forEach((p) => p.method(d));
    });
  }, r.onFlagChanged = (d, f) => {
    const p = ep.flagDetailChanged;
    i[p].length && i[p].forEach((g) => g.method(d, f)), a[p].length && cP(() => {
      a[p].forEach((g) => g.method(d, f));
    });
  }, r.onIdentityChanged = (d) => {
    const f = ep.clientIdentityChanged;
    i[f].length && i[f].forEach((p) => p.method(d)), a[f].length && cP(() => {
      a[f].forEach((p) => p.method(d));
    });
  }, r;
} };
const { LDTimeoutError: Z7e } = iu;
var ePe = function(e, t) {
  return new Promise((r, a) => {
    setTimeout(() => {
      a(new Z7e(`${t} timed out after ${e} seconds.`));
    }, 1e3 * e);
  });
};
const B_ = "unknown hook";
function L5(e, t, r, a, i) {
  try {
    return a();
  } catch (c) {
    return e?.error(`An error was encountered in "${t}" of the "${r}" hook: ${c}`), i;
  }
}
function H5(e, t) {
  try {
    return t.getMetadata().name || B_;
  } catch {
    return e.error("Exception thrown getting metadata for hook. Unable to get hook name."), B_;
  }
}
var tPe = function(e, t) {
  const r = t ? [...t] : [];
  return { withEvaluation: function(a, i, c, d) {
    if (r.length === 0) return d();
    const f = [...r], p = { flagKey: a, context: i, defaultValue: c }, g = (function(w, x, E) {
      return x.map((P) => L5(w, "beforeEvaluation", H5(w, P), () => P?.beforeEvaluation?.(E, {}) ?? {}, {}));
    })(e, f, p), b = d();
    return (function(w, x, E, P, k) {
      for (let M = x.length - 1; M >= 0; M -= 1) {
        const T = x[M], N = P[M];
        L5(w, "afterEvaluation", H5(w, T), () => T?.afterEvaluation?.(E, N, k) ?? {}, {});
      }
    })(e, f, p, g, b), b;
  }, identify: function(a, i) {
    const c = [...r], d = { context: a, timeout: i }, f = (function(p, g, b) {
      return g.map((w) => L5(p, "beforeIdentify", H5(p, w), () => w?.beforeIdentify?.(b, {}) ?? {}, {}));
    })(e, c, d);
    return (p) => {
      (function(g, b, w, x, E) {
        for (let P = b.length - 1; P >= 0; P -= 1) {
          const k = b[P], M = x[P];
          L5(g, "afterIdentify", H5(g, k), () => k?.afterIdentify?.(w, M, E) ?? {}, {});
        }
      })(e, c, d, f, p);
    };
  }, addHook: function(a) {
    r.push(a);
  }, afterTrack: function(a) {
    if (r.length === 0) return;
    const i = [...r];
    (function(c, d, f) {
      for (let p = d.length - 1; p >= 0; p -= 1) {
        const g = d[p];
        L5(c, "afterTrack", H5(c, g), () => g?.afterTrack?.(f), void 0);
      }
    })(e, i, a);
  } };
}, nPe = function() {
  let e, t = {};
  function r(a) {
    return e && Na.objectHasOwnProperty(e, a) && e[a] ? e[a] : t && Na.objectHasOwnProperty(t, a) && t[a] && !t[a].deleted ? t[a] : null;
  }
  return { clearAllOverrides: function() {
    if (!e) return {};
    const a = { ...e };
    return e = void 0, a;
  }, get: r, getFlagOverrides: function() {
    return e || {};
  }, getFlags: function() {
    return t;
  }, getFlagsWithOverrides: function() {
    const a = {};
    for (const i in t) {
      const c = r(i);
      c && (a[i] = c);
    }
    if (e) for (const i in e) {
      const c = r(i);
      c && (a[i] = c);
    }
    return a;
  }, removeOverride: function(a) {
    e && e[a] && (delete e[a], Object.keys(e).length === 0 && (e = void 0));
  }, setFlags: function(a) {
    t = { ...a };
  }, setOverride: function(a, i) {
    e || (e = {}), e[a] = { value: i };
  } };
};
const U_ = "unknown plugin";
function dP(e, t) {
  try {
    return t.getMetadata().name || U_;
  } catch {
    return e.error("Exception thrown getting metadata for plugin. Unable to get plugin name."), U_;
  }
}
var rPe = { getPluginHooks: function(e, t, r) {
  const a = [];
  return r.forEach((i) => {
    try {
      const c = i.getHooks?.(t);
      c === void 0 ? e.error(`Plugin ${dP(e, i)} returned undefined from getHooks.`) : c && c.length > 0 && a.push(...c);
    } catch {
      e.error(`Exception thrown getting hooks for plugin ${dP(e, i)}. Unable to get hooks.`);
    }
  }), a;
}, registerPlugins: function(e, t, r, a) {
  a.forEach((i) => {
    try {
      i.register(r, t);
    } catch {
      e.error(`Exception thrown registering plugin ${dP(e, i)}.`);
    }
  });
}, registerPluginsForDebugOverride: function(e, t, r) {
  r.forEach((a) => {
    try {
      a.registerDebug?.(t);
    } catch {
      e.error(`Exception thrown registering debug override with plugin ${dP(e, a)}.`);
    }
  });
}, createPluginEnvironment: function(e, t, r) {
  const a = {};
  e.userAgent && (a.name = e.userAgent), e.version && (a.version = e.version), r.wrapperName && (a.wrapperName = r.wrapperName), r.wrapperVersion && (a.wrapperVersion = r.wrapperVersion);
  const i = {};
  r.application && (r.application.name && (i.name = r.application.name), r.application.version && (i.version = r.application.version));
  const c = { sdk: a, clientSideId: t };
  return Object.keys(i).length > 0 && (c.application = i), c;
} };
const { commonBasicLogger: aPe } = lI, { checkContext: oPe } = RM, { InspectorTypes: fP, InspectorManager: iPe } = J7e, { getPluginHooks: lPe, registerPlugins: sPe, registerPluginsForDebugOverride: uPe, createPluginEnvironment: cPe } = rPe, mP = "change", X_ = "internal-change";
var Zee = { initialize: function(e, t, r, a, i) {
  const c = (function() {
    return r && r.logger ? r.logger : i && i.logger && i.logger.default || aPe("warn");
  })(), d = A7e(c), f = N7e(d), p = sI.validate(r, d, i, c), g = iPe(p.inspectors, c), b = p.sendEvents;
  let w = e, x = p.hash;
  const E = [...p.plugins], P = cPe(a, e, p), k = lPe(c, P, E), M = tPe(c, [...p.hooks, ...k]), T = $7e(a.localStorage, c), N = Qee(a, w, p), D = p.sendEvents && !p.diagnosticOptOut, $ = D ? uA.DiagnosticId(w) : null, j = D ? uA.DiagnosticsAccumulator((/* @__PURE__ */ new Date()).getTime()) : null, I = D ? uA.DiagnosticsManager(a, T, j, N, w, p, $) : null, L = F7e(a, p, w, j), F = p.eventProcessor || R7e(a, p, w, j, d, N), _ = B7e(a, p, w), W = nPe();
  let Q, U, Y, G = p.streaming, J = !1, H = !1, K = !0;
  const X = p.stateProvider, te = U7e(null, function(Te) {
    (function(Oe) {
      X || Oe && ne({ kind: "identify", context: Oe, creationDate: (/* @__PURE__ */ new Date()).getTime() });
    })(Te), g.hasListeners(fP.clientIdentityChanged) && g.onIdentityChanged(te.getContext());
  }), ie = new q7e(T), ee = T.isEnabled() ? D7e(T, w, x, te) : null;
  function ne(Te) {
    w && (X && X.enqueueEvent && X.enqueueEvent(Te) || (Te.context ? (K = !1, !b || H || a.isDoNotTrack() || (c.debug(xa.debugEnqueueingEvent(Te.kind)), F.enqueue(Te))) : K && (c.warn(xa.eventWithoutContext()), K = !1)));
  }
  function ae(Te, Oe) {
    g.hasListeners(fP.flagDetailChanged) && g.onFlagChanged(Te.key, De(Oe));
  }
  function oe() {
    g.hasListeners(fP.flagDetailsChanged) && g.onFlags(Object.entries(W.getFlagsWithOverrides()).map(([Te, Oe]) => ({ key: Te, detail: De(Oe) })).reduce((Te, Oe) => (Te[Oe.key] = Oe.detail, Te), {}));
  }
  function fe(Te, Oe, ye, je) {
    const Ue = te.getContext(), Fe = /* @__PURE__ */ new Date(), tt = { kind: "feature", key: Te, context: Ue, value: Oe ? Oe.value : null, variation: Oe ? Oe.variationIndex : null, default: ye, creationDate: Fe.getTime() }, dt = W.getFlags()[Te];
    dt && (tt.version = dt.flagVersion ? dt.flagVersion : dt.version, tt.trackEvents = dt.trackEvents, tt.debugEventsUntilDate = dt.debugEventsUntilDate), (je || dt && dt.trackReason) && Oe && (tt.reason = Oe.reason), ne(tt);
  }
  function be(Te) {
    return oPe(Te, !1) ? Promise.resolve(Te) : Promise.reject(new iu.LDInvalidUserError(xa.invalidContext()));
  }
  function me(Te, Oe, ye, je, Ue, Fe) {
    let tt;
    const dt = W.get(Te);
    return dt ? (tt = De(dt), dt.value !== null && dt.value !== void 0 || (tt.value = Oe)) : tt = { value: Oe, variationIndex: null, reason: { kind: "ERROR", errorKind: "FLAG_NOT_FOUND" } }, ye && (Ue || dt?.prerequisites?.forEach((St) => {
      me(St, void 0, ye, !1, !1, !1);
    }), fe(Te, tt, Oe, je)), !Ue && Fe && (function(St, mt) {
      g.hasListeners(fP.flagUsed) && g.onFlagUsed(St, mt, te.getContext());
    })(Te, tt), tt;
  }
  function De(Te) {
    return { value: Te.value, variationIndex: Te.variation === void 0 ? null : Te.variation, reason: Te.reason || null };
  }
  function Me() {
    if (U = !0, !te.getContext()) return;
    const Te = (Oe) => {
      try {
        return JSON.parse(Oe);
      } catch {
        return void d.maybeReportError(new iu.LDInvalidDataError(xa.invalidData()));
      }
    };
    L.connect(te.getContext(), x, { ping: function() {
      c.debug(xa.debugStreamPing());
      const Oe = te.getContext();
      _.fetchFlagSettings(Oe, x).then((ye) => {
        Na.deepEquals(Oe, te.getContext()) && le(ye || {});
      }).catch((ye) => {
        d.maybeReportError(new iu.LDFlagFetchError(xa.errorFetchingFlags(ye)));
      });
    }, put: function(Oe) {
      const ye = Te(Oe.data);
      ye && (c.debug(xa.debugStreamPut()), le(ye));
    }, patch: function(Oe) {
      const ye = Te(Oe.data);
      if (!ye) return;
      const je = W.getFlags(), Ue = je[ye.key];
      if (!Ue || !Ue.version || !ye.version || Ue.version < ye.version) {
        c.debug(xa.debugStreamPatch(ye.key));
        const Fe = {}, tt = Na.extend({}, ye);
        delete tt.key, je[ye.key] = tt, W.setFlags(je);
        const dt = De(tt);
        Fe[ye.key] = Ue ? { previous: Ue.value, current: dt } : { current: dt }, ae(ye, tt), se(Fe);
      } else c.debug(xa.debugStreamPatchIgnored(ye.key));
    }, delete: function(Oe) {
      const ye = Te(Oe.data);
      if (!ye) return;
      const je = W.getFlags();
      if (!je[ye.key] || je[ye.key].version < ye.version) {
        c.debug(xa.debugStreamDelete(ye.key));
        const Ue = {};
        je[ye.key] && !je[ye.key].deleted && (Ue[ye.key] = { previous: je[ye.key].value }), je[ye.key] = { version: ye.version, deleted: !0 }, W.setFlags(je), ae(ye, je[ye.key]), se(Ue);
      } else c.debug(xa.debugStreamDeleteIgnored(ye.key));
    } });
  }
  function ze() {
    U && (L.disconnect(), U = !1);
  }
  function le(Te) {
    const Oe = {};
    if (!Te) return Promise.resolve();
    const ye = W.getFlags();
    for (const je in ye) Na.objectHasOwnProperty(ye, je) && ye[je] && (Te[je] && !Na.deepEquals(Te[je].value, ye[je].value) ? Oe[je] = { previous: ye[je].value, current: De(Te[je]) } : Te[je] && !Te[je].deleted || (Oe[je] = { previous: ye[je].value }));
    for (const je in Te) Na.objectHasOwnProperty(Te, je) && Te[je] && (!ye[je] || ye[je].deleted) && (Oe[je] = { current: De(Te[je]) });
    return W.setFlags({ ...Te }), oe(), se(Oe).catch(() => {
    });
  }
  function se(Te) {
    const Oe = Object.keys(Te);
    if (Oe.length > 0) {
      const ye = {};
      Oe.forEach((je) => {
        const Ue = Te[je].current, Fe = Ue ? Ue.value : void 0, tt = Te[je].previous;
        d.emit(mP + ":" + je, Fe, tt), ye[je] = Ue ? { current: Fe, previous: tt } : { previous: tt };
      }), d.emit(mP, ye), d.emit(X_, W.getFlagsWithOverrides()), p.sendEventsOnlyForVariation || X || Oe.forEach((je) => {
        fe(je, Te[je].current);
      });
    }
    return Q && ee ? ee.saveFlags(W.getFlags()) : Promise.resolve();
  }
  function Ae() {
    const Te = G || Y && G === void 0;
    Te && !U ? Me() : !Te && U && ze(), I && I.setStreaming(Te);
  }
  function we(Te) {
    return Te === mP || Te.substr(0, 7) === mP + ":";
  }
  if (typeof p.bootstrap == "string" && p.bootstrap.toUpperCase() === "LOCALSTORAGE" && (ee ? Q = !0 : c.warn(xa.localStorageUnavailable())), typeof p.bootstrap == "object" && W.setFlags((function(Te) {
    const Oe = Object.keys(Te), ye = "$flagsState", je = "$valid", Ue = Te[ye];
    !Ue && Oe.length && c.warn(xa.bootstrapOldFormat()), Te[je] === !1 && c.warn(xa.bootstrapInvalid());
    const Fe = {};
    return Oe.forEach((tt) => {
      if (tt !== ye && tt !== je) {
        let dt = { value: Te[tt] };
        Ue && Ue[tt] ? dt = Na.extend(dt, Ue[tt]) : dt.version = 0, Fe[tt] = dt;
      }
    }), Fe;
  })(p.bootstrap)), X) {
    const Te = X.getInitialState();
    Te ? Ne(Te) : X.on("init", Ne), X.on("update", function(Oe) {
      Oe.context && te.setContext(Oe.context), Oe.flags && le(Oe.flags);
    });
  } else (function() {
    if (!e) return Promise.reject(new iu.LDInvalidEnvironmentIdError(xa.environmentNotSpecified()));
    let Te;
    return ie.processContext(t).then(be).then((Oe) => (Te = Na.once(M.identify(Oe, void 0)), Oe)).then((Oe) => (Te?.({ status: "completed" }), te.setContext(Oe), typeof p.bootstrap == "object" ? pe() : Q ? ee.loadFlags().then((ye) => ye == null ? (W.setFlags({}), _.fetchFlagSettings(te.getContext(), x).then((je) => le(je || {})).then(pe).catch((je) => {
      Qe(new iu.LDFlagFetchError(xa.errorFetchingFlags(je)));
    })) : (W.setFlags(ye), Na.onNextTick(pe), _.fetchFlagSettings(te.getContext(), x).then((je) => le(je)).catch((je) => d.maybeReportError(je)))) : _.fetchFlagSettings(te.getContext(), x).then((ye) => {
      W.setFlags(ye || {}), oe(), pe();
    }).catch((ye) => {
      W.setFlags({}), Qe(ye);
    }))).catch((Oe) => {
      throw Te?.({ status: "error" }), Oe;
    });
  })().catch(Qe);
  function Ne(Te) {
    w = Te.environment, te.setContext(Te.context), W.setFlags({ ...Te.flags }), Na.onNextTick(pe);
  }
  function pe() {
    c.info(xa.clientInitialized()), J = !0, Ae(), f.signalSuccess();
  }
  function Qe(Te) {
    f.signalFailure(Te);
  }
  const Le = { waitForInitialization: function(Te = void 0) {
    if (Te != null) {
      if (typeof Te == "number") return (function(Oe) {
        Oe > 5 && c.warn("The waitForInitialization function was called with a timeout greater than 5 seconds. We recommend a timeout of 5 seconds or less.");
        const ye = f.getInitializationPromise(), je = ePe(Oe, "waitForInitialization");
        return Promise.race([je, ye]).catch((Ue) => {
          throw Ue instanceof iu.LDTimeoutError && c.error(`waitForInitialization error: ${Ue}`), Ue;
        });
      })(Te);
      c.warn("The waitForInitialization method was provided with a non-numeric timeout.");
    }
    return c.warn("The waitForInitialization function was called without a timeout specified. In a future version a default timeout will be applied."), f.getInitializationPromise();
  }, waitUntilReady: () => f.getReadyPromise(), identify: function(Te, Oe, ye) {
    if (H) return Na.wrapPromiseCallback(Promise.resolve({}), ye);
    if (X) return c.warn(xa.identifyDisabled()), Na.wrapPromiseCallback(Promise.resolve(Na.transformVersionedValuesToValues(W.getFlagsWithOverrides())), ye);
    let je;
    const Ue = Q && ee ? ee.clearFlags() : Promise.resolve();
    return Na.wrapPromiseCallback(Ue.then(() => ie.processContext(Te)).then(be).then((Fe) => (je = Na.once(M.identify(Fe, void 0)), Fe)).then((Fe) => _.fetchFlagSettings(Fe, Oe).then((tt) => {
      const dt = Na.transformVersionedValuesToValues(tt);
      return te.setContext(Fe), x = Oe, tt ? le(tt).then(() => dt) : dt;
    })).then((Fe) => (je?.({ status: "completed" }), U && Me(), Fe)).catch((Fe) => (je?.({ status: "error" }), d.maybeReportError(Fe), Promise.reject(Fe))), ye);
  }, getContext: function() {
    return te.getContext();
  }, variation: function(Te, Oe) {
    const { value: ye } = M.withEvaluation(Te, te.getContext(), Oe, () => me(Te, Oe, !0, !1, !1, !0));
    return ye;
  }, variationDetail: function(Te, Oe) {
    return M.withEvaluation(Te, te.getContext(), Oe, () => me(Te, Oe, !0, !0, !1, !0));
  }, track: function(Te, Oe, ye) {
    if (typeof Te != "string") return void d.maybeReportError(new iu.LDInvalidEventKeyError(xa.unknownCustomEventKey(Te)));
    ye !== void 0 && typeof ye != "number" && c.warn(xa.invalidMetricValue(typeof ye)), a.customEventFilter && !a.customEventFilter(Te) && c.warn(xa.unknownCustomEventKey(Te));
    const je = te.getContext(), Ue = { kind: "custom", key: Te, context: je, url: a.getCurrentUrl(), creationDate: (/* @__PURE__ */ new Date()).getTime() };
    je && je.anonymous && (Ue.contextKind = je.anonymous ? "anonymousUser" : "user"), Oe != null && (Ue.data = Oe), ye != null && (Ue.metricValue = ye), ne(Ue), M.afterTrack({ context: je, key: Te, data: Oe, metricValue: ye });
  }, on: function(Te, Oe, ye) {
    we(Te) ? (Y = !0, J && Ae(), d.on(Te, Oe, ye)) : d.on(...arguments);
  }, off: function(Te) {
    if (d.off(...arguments), we(Te)) {
      let Oe = !1;
      d.getEvents().forEach((ye) => {
        we(ye) && d.getEventListenerCount(ye) > 0 && (Oe = !0);
      }), Oe || (Y = !1, U && G === void 0 && ze());
    }
  }, setStreaming: function(Te) {
    const Oe = Te === null ? void 0 : Te;
    Oe !== G && (G = Oe, Ae());
  }, flush: function(Te) {
    return Na.wrapPromiseCallback(b ? F.flush() : Promise.resolve(), Te);
  }, allFlags: function() {
    const Te = {}, Oe = W.getFlagsWithOverrides();
    if (!Oe) return Te;
    for (const ye in Oe) Te[ye] = me(ye, null, !p.sendEventsOnlyForVariation, !1, !0, !1).value;
    return Te;
  }, close: function(Te) {
    if (H) return Na.wrapPromiseCallback(Promise.resolve(), Te);
    const Oe = () => {
      H = !0, W.setFlags({});
    }, ye = Promise.resolve().then(() => {
      if (ze(), I && I.stop(), b) return F.stop(), F.flush();
    }).then(Oe).catch(Oe);
    return Na.wrapPromiseCallback(ye, Te);
  }, addHook: function(Te) {
    M.addHook(Te);
  } };
  return sPe(c, P, Le, E), uPe(c, { setOverride: function(Te, Oe) {
    const ye = {}, je = W.get(Te), Ue = je ? je.value : null;
    if (Ue === Oe) return void c.debug(`setOverride: No change needed for ${Te}, value already ${Oe}`);
    W.setOverride(Te, Oe);
    const Fe = W.get(Te), tt = De(Fe);
    ye[Te] = { previous: Ue, current: tt }, ae({ key: Te }, Fe), se(ye);
  }, removeOverride: function(Te) {
    const Oe = W.getFlagOverrides();
    if (!Oe[Te]) return;
    const ye = {}, je = Oe[Te], Ue = W.getFlags()[Te];
    ye[Te] = { previous: je.value, current: Ue ? De(Ue) : void 0 }, W.removeOverride(Te), ae({ key: Te }, Ue), se(ye);
  }, clearAllOverrides: function() {
    const Te = W.getFlagOverrides();
    if (Object.keys(Te).length === 0) return;
    const Oe = {}, ye = W.getFlags();
    Object.keys(Te).forEach((je) => {
      const Ue = Te[je], Fe = ye[je];
      Oe[je] = { previous: Ue.value, current: Fe ? De(Fe) : void 0 };
    }), W.clearAllOverrides(), Object.keys(Oe).length > 0 && se(Oe);
  }, getAllOverrides: function() {
    const Te = W.getFlagOverrides();
    if (!Te) return {};
    const Oe = {};
    return Object.keys(Te).forEach((ye) => {
      const je = Te[ye];
      je && (Oe[ye] = je.value);
    }), Oe;
  } }, E), { client: Le, options: p, emitter: d, ident: te, logger: c, requestor: _, start: function() {
    b && (I && I.start(), F.start());
  }, enqueueEvent: ne, getFlagsInternal: function() {
    return W.getFlagsWithOverrides();
  }, getEnvironmentId: () => w, internalChangeEventName: X_ };
}, errors: iu }, dPe = Zee.initialize, fPe = Zee.errors;
function mPe(e, t, r) {
  return (t = (function(a) {
    var i = (function(c, d) {
      if (typeof c != "object" || !c) return c;
      var f = c[Symbol.toPrimitive];
      if (f !== void 0) {
        var p = f.call(c, d);
        if (typeof p != "object") return p;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (d === "string" ? String : Number)(c);
    })(a, "string");
    return typeof i == "symbol" ? i : i + "";
  })(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function G_(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, a);
  }
  return r;
}
function q_(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? G_(Object(r), !0).forEach(function(a) {
      mPe(e, a, r[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : G_(Object(r)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(r, a));
    });
  }
  return e;
}
var K_ = { promise: Promise.resolve({ status: 200, header: function() {
  return null;
}, body: null }) };
function hPe(e, t, r, a, i) {
  if (i && !(function() {
    var g = window.navigator && window.navigator.userAgent;
    if (g) {
      var b = g.match(/Chrom(e|ium)\/([0-9]+)\./);
      if (b) return parseInt(b[2], 10) < 73;
    }
    return !0;
  })()) return K_;
  var c = new window.XMLHttpRequest();
  for (var d in c.open(e, t, !i), r || {}) Object.prototype.hasOwnProperty.call(r, d) && c.setRequestHeader(d, r[d]);
  if (i) {
    try {
      c.send(a);
    } catch {
    }
    return K_;
  }
  var f, p = new Promise(function(g, b) {
    c.addEventListener("load", function() {
      f || g({ status: c.status, header: function(w) {
        return c.getResponseHeader(w);
      }, body: c.responseText });
    }), c.addEventListener("error", function() {
      f || b(new Error());
    }), c.send(a);
  });
  return { promise: p, cancel: function() {
    f = !0, c.abort();
  } };
}
var cA = (e) => {
  if (typeof e != "string") throw new TypeError("Expected a string");
  return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
};
function pPe(e, t, r, a) {
  var i, c, d = ((e.kind === "substring" || e.kind === "regex") && a.includes("/") ? t : t.replace(a, "")).replace(r, "");
  switch (e.kind) {
    case "exact":
      c = t, i = new RegExp("^" + cA(e.url) + "/?$");
      break;
    case "canonical":
      c = d, i = new RegExp("^" + cA(e.url) + "/?$");
      break;
    case "substring":
      c = d, i = new RegExp(".*" + cA(e.substring) + ".*$");
      break;
    case "regex":
      c = d, i = new RegExp(e.pattern);
      break;
    default:
      return !1;
  }
  return i.test(c);
}
function Y_(e, t) {
  for (var r = {}, a = null, i = [], c = 0; c < e.length; c++) for (var d = e[c], f = d.urls || [], p = 0; p < f.length; p++) if (pPe(f[p], window.location.href, window.location.search, window.location.hash)) {
    d.kind === "pageview" ? t("pageview", d) : (i.push(d), t("click_pageview", d));
    break;
  }
  return i.length > 0 && (a = function(g) {
    for (var b = (function(x, E) {
      for (var P = [], k = 0; k < E.length; k++) for (var M = x.target, T = E[k], N = T.selector, D = document.querySelectorAll(N); M && D.length > 0; ) {
        for (var $ = 0; $ < D.length; $++) M === D[$] && P.push(T);
        M = M.parentNode;
      }
      return P;
    })(g, i), w = 0; w < b.length; w++) t("click", b[w]);
  }, document.addEventListener("click", a)), r.dispose = function() {
    document.removeEventListener("click", a);
  }, r;
}
function gPe(e, t) {
  var r, a;
  function i() {
    a && a.dispose(), r && r.length && (a = Y_(r, c));
  }
  function c(d, f) {
    var p = e.ident.getContext(), g = { kind: d, key: f.key, data: null, url: window.location.href, creationDate: (/* @__PURE__ */ new Date()).getTime(), context: p };
    return d === "click" && (g.selector = f.selector), e.enqueueEvent(g);
  }
  return e.requestor.fetchJSON("/sdk/goals/" + e.getEnvironmentId()).then(function(d) {
    d && d.length > 0 && (a = Y_(r = d, c), (function(f, p) {
      var g, b = window.location.href;
      function w() {
        (g = window.location.href) !== b && (b = g, p());
      }
      (function x(E, P) {
        E(), setTimeout(function() {
          x(E, P);
        }, P);
      })(w, f), window.history && window.history.pushState ? window.addEventListener("popstate", w) : window.addEventListener("hashchange", w);
    })(300, i)), t();
  }).catch(function(d) {
    e.emitter.maybeReportError(new fPe.LDUnexpectedResponseError((d && d.message, d.message))), t();
  }), {};
}
var hP = "goalsReady", vPe = { fetchGoals: { default: !0 }, hash: { type: "string" }, eventProcessor: { type: "object" }, eventUrlTransformer: { type: "function" }, disableSyncEventPost: { default: !1 } };
function bPe(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = (function(b) {
    var w, x = { userAgentHeaderName: "X-LaunchDarkly-User-Agent", synchronousFlush: !1 };
    if (window.XMLHttpRequest) {
      var E = b && b.disableSyncEventPost;
      x.httpRequest = function(T, N, D, $) {
        var j = x.synchronousFlush & !E;
        return x.synchronousFlush = !1, hPe(T, N, D, $, j);
      };
    }
    x.httpAllowsPost = function() {
      return w === void 0 && (w = !!window.XMLHttpRequest && "withCredentials" in new window.XMLHttpRequest()), w;
    }, x.httpFallbackPing = function(T) {
      new window.Image().src = T;
    };
    var P, k = b && b.eventUrlTransformer;
    x.getCurrentUrl = function() {
      return k ? k(window.location.href) : window.location.href;
    }, x.isDoNotTrack = function() {
      var T;
      return (T = window.navigator && window.navigator.doNotTrack !== void 0 ? window.navigator.doNotTrack : window.navigator && window.navigator.msDoNotTrack !== void 0 ? window.navigator.msDoNotTrack : window.doNotTrack) === 1 || T === !0 || T === "1" || T === "yes";
    };
    try {
      window.localStorage && (x.localStorage = { get: function(T) {
        return new Promise(function(N) {
          N(window.localStorage.getItem(T));
        });
      }, set: function(T, N) {
        return new Promise(function(D) {
          window.localStorage.setItem(T, N), D();
        });
      }, clear: function(T) {
        return new Promise(function(N) {
          window.localStorage.removeItem(T), N();
        });
      } });
    } catch {
      x.localStorage = null;
    }
    if (b && b.useReport && typeof window.EventSourcePolyfill == "function" && window.EventSourcePolyfill.supportedOptions && window.EventSourcePolyfill.supportedOptions.method ? (x.eventSourceAllowsReport = !0, P = window.EventSourcePolyfill) : (x.eventSourceAllowsReport = !1, P = window.EventSource), window.EventSource) {
      var M = 3e5;
      x.eventSourceFactory = function(T, N) {
        var D = q_(q_({}, { heartbeatTimeout: M, silentTimeout: M, skipDefaultHeaders: !0 }), N);
        return new P(T, D);
      }, x.eventSourceIsActive = function(T) {
        return T.readyState === window.EventSource.OPEN || T.readyState === window.EventSource.CONNECTING;
      };
    }
    return x.userAgent = "JSClient", x.version = "3.9.0", x.diagnosticSdkData = { name: "js-client-sdk", version: "3.9.0" }, x.diagnosticPlatformData = { name: "JS" }, x.diagnosticUseCombinedEvent = !0, x;
  })(r), i = dPe(e, t, r, a, vPe), c = i.client, d = i.options, f = i.emitter, p = new Promise(function(b) {
    var w = f.on(hP, function() {
      f.off(hP, w), b();
    });
  });
  c.waitUntilGoalsReady = function() {
    return p;
  }, d.fetchGoals ? gPe(i, function() {
    return f.emit(hP);
  }) : f.emit(hP), document.readyState !== "complete" ? window.addEventListener("load", i.start) : i.start();
  var g = function() {
    a.synchronousFlush = !0, c.flush().catch(function() {
    }), a.synchronousFlush = !1;
  };
  return document.addEventListener("visibilitychange", function() {
    document.visibilityState === "hidden" && g();
  }), window.addEventListener("pagehide", g), c;
}
function yPe(e = xM.CAPS) {
  const t = P8e[e];
  switch (Qj()) {
    case ui.DEV:
    case ui.LAB:
      return t[ui.DEV];
    case ui.QA:
      return t[ui.QA];
    case ui.TEST:
    case ui.TEST1:
    case ui.TEST2:
    case ui.TEST3:
    case ui.TEST4:
    case ui.TEST5:
      return t[ui.TEST];
    default:
      return t[ui.PRODUCTION];
  }
}
function wPe(e, t) {
  const r = e.getContext();
  return JSON.stringify(r) !== JSON.stringify(t);
}
let kS;
const pP = {};
function dA(e, t) {
  console.error(`Failed to ${e} LaunchDarkly client context`, t);
}
function Q_() {
  kS = void 0;
}
async function SPe(e) {
  const { context: t, project: r = xM.CAPS } = e || {};
  if (pP[r] && kS) {
    kS = pP[r];
    const i = t && E$(t);
    if (i && wPe(kS, i))
      try {
        await kS.identify(i);
      } catch (c) {
        dA("update", c);
      }
    return kS;
  }
  if (!t)
    throw new Error(
      "Cannot initialize LaunchDarkly client without a Context or User"
    );
  let a;
  try {
    a = bPe(
      yPe(r),
      E$(t)
    );
  } catch (i) {
    dA("initialize", i), Q_();
    return;
  }
  try {
    await a.waitForInitialization(5), pP[r] = a, kS = pP[r];
  } catch (i) {
    dA("finish initializing", i), Q_();
    return;
  }
  return kS;
}
function cI(e) {
  const { user: t, isLoading: r, error: a } = UEe(), [i, c] = Wn(!0), [d, f] = Wn(a), [p, g] = Wn(), { context: b, project: w, shouldDeferInitialization: x } = e ?? {};
  return Er(() => {
    f(a);
  }, [a]), Er(() => {
    (async () => {
      if (!(t && !r && !a)) {
        c(!1);
        return;
      }
      if (c(!0), g(void 0), x)
        return;
      const E = [t, ...b ? [b] : []];
      try {
        g(
          await SPe({
            context: E$(...E),
            project: w
          })
        );
      } catch (P) {
        f(`${P}`);
      } finally {
        c(!1);
      }
    })();
  }, [
    b,
    w,
    t,
    a,
    r,
    x
  ]), {
    launchDarklyClient: p,
    isLoading: !p && !d && !a && (i || r),
    error: d
  };
}
function CPe(e) {
  const [t, r] = Wn(), [a, i] = Wn({
    goTo: fA.bind(void 0, void 0, r),
    toURL: mA.bind(void 0, void 0)
  });
  return Er(() => {
    if (!e) {
      i({
        goTo: fA.bind(
          void 0,
          void 0,
          r
        ),
        toURL: mA.bind(void 0, void 0)
      });
      return;
    }
    i({
      goTo: fA.bind(
        void 0,
        e,
        r
      ),
      toURL: mA.bind(void 0, e)
    });
  }, [e]), Er(() => {
    t && e && (vee(t[0], t[1], e), r(void 0));
  }, [t, e]), a;
}
function fA(e, t, r, a) {
  if (!e) {
    t([r, a]);
    return;
  }
  try {
    vee(r, a, e);
  } catch (i) {
    console.error("Error in goTo:", i);
  }
}
function mA(e, t, r) {
  let a = "";
  try {
    a = tS(t, r, e);
  } catch (i) {
    console.error("Error in toURL:", i);
  }
  return a;
}
const xPe = "fs-exclude";
var EPe = function(e) {
  return e === "window" ? "document" : "".concat(e, ".document");
}, PPe = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.shouldInsertScript, r = t === void 0 ? !0 : t, a = e.globalVar, i = a === void 0 ? "window" : a, c = e.apiVersion, d = c === void 0 ? "1.3.0" : c;
  return `(function(m,n,e,t,l,o,g,y){
    if (e in m) {if(m.console && m.console.log) { m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].');} return;}
    g=m[e]=function(a,b,s){g.q?g.q.push([a,b,s]):g._api(a,b,s);};g.q=[];`.concat(r ? `
    o=n.createElement(t);o.async=1;o.crossOrigin='anonymous';o.src='https://'+_fs_script;
    y=n.getElementsByTagName(t)[0];y.parentNode.insertBefore(o,y);` : "", `
    g.identify=function(i,v,s){g(l,{uid:i},s);if(v)g(l,v,s)};g.setUserVars=function(v,s){g(l,v,s)};g.event=function(i,v,s){g('event',{n:i,p:v},s)};
    g.anonymize=function(){g.identify(!!0)};
    g.shutdown=function(){g("rec",!1)};g.restart=function(){g("rec",!0)};
    g.log = function(a,b){g("log",[a,b])};
    g.consent=function(a){g("consent",!arguments.length||a)};
    g.identifyAccount=function(i,v){o='account';v=v||{};v.acctId=i;g(o,v)};
    g.clearUserCookie=function(){};
    g.setVars=function(n, p){g('setVars',[n,p]);};
    g._w={};y='XMLHttpRequest';g._w[y]=m[y];y='fetch';g._w[y]=m[y];
    if(m[y])m[y]=function(){return g._w[y].apply(this,arguments)};
    g._v="`).concat(d, `";
})(`).concat(i, ",").concat(EPe(i), ",").concat(i, "['_fs_namespace'],'script','user');");
};
PPe();
var gP = { exports: {} }, F5 = {}, hA = { exports: {} }, J_ = {};
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Z_;
function kPe() {
  return Z_ || (Z_ = 1, (function(e) {
    function t(H, K) {
      var X = H.length;
      H.push(K);
      e: for (; 0 < X; ) {
        var te = X - 1 >>> 1, ie = H[te];
        if (0 < i(ie, K))
          H[te] = K, H[X] = ie, X = te;
        else break e;
      }
    }
    function r(H) {
      return H.length === 0 ? null : H[0];
    }
    function a(H) {
      if (H.length === 0) return null;
      var K = H[0], X = H.pop();
      if (X !== K) {
        H[0] = X;
        e: for (var te = 0, ie = H.length, ee = ie >>> 1; te < ee; ) {
          var ne = 2 * (te + 1) - 1, ae = H[ne], oe = ne + 1, fe = H[oe];
          if (0 > i(ae, X))
            oe < ie && 0 > i(fe, ae) ? (H[te] = fe, H[oe] = X, te = oe) : (H[te] = ae, H[ne] = X, te = ne);
          else if (oe < ie && 0 > i(fe, X))
            H[te] = fe, H[oe] = X, te = oe;
          else break e;
        }
      }
      return K;
    }
    function i(H, K) {
      var X = H.sortIndex - K.sortIndex;
      return X !== 0 ? X : H.id - K.id;
    }
    if (e.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
      var c = performance;
      e.unstable_now = function() {
        return c.now();
      };
    } else {
      var d = Date, f = d.now();
      e.unstable_now = function() {
        return d.now() - f;
      };
    }
    var p = [], g = [], b = 1, w = null, x = 3, E = !1, P = !1, k = !1, M = !1, T = typeof setTimeout == "function" ? setTimeout : null, N = typeof clearTimeout == "function" ? clearTimeout : null, D = typeof setImmediate < "u" ? setImmediate : null;
    function $(H) {
      for (var K = r(g); K !== null; ) {
        if (K.callback === null) a(g);
        else if (K.startTime <= H)
          a(g), K.sortIndex = K.expirationTime, t(p, K);
        else break;
        K = r(g);
      }
    }
    function j(H) {
      if (k = !1, $(H), !P)
        if (r(p) !== null)
          P = !0, I || (I = !0, U());
        else {
          var K = r(g);
          K !== null && J(j, K.startTime - H);
        }
    }
    var I = !1, L = -1, F = 5, _ = -1;
    function W() {
      return M ? !0 : !(e.unstable_now() - _ < F);
    }
    function Q() {
      if (M = !1, I) {
        var H = e.unstable_now();
        _ = H;
        var K = !0;
        try {
          e: {
            P = !1, k && (k = !1, N(L), L = -1), E = !0;
            var X = x;
            try {
              t: {
                for ($(H), w = r(p); w !== null && !(w.expirationTime > H && W()); ) {
                  var te = w.callback;
                  if (typeof te == "function") {
                    w.callback = null, x = w.priorityLevel;
                    var ie = te(
                      w.expirationTime <= H
                    );
                    if (H = e.unstable_now(), typeof ie == "function") {
                      w.callback = ie, $(H), K = !0;
                      break t;
                    }
                    w === r(p) && a(p), $(H);
                  } else a(p);
                  w = r(p);
                }
                if (w !== null) K = !0;
                else {
                  var ee = r(g);
                  ee !== null && J(
                    j,
                    ee.startTime - H
                  ), K = !1;
                }
              }
              break e;
            } finally {
              w = null, x = X, E = !1;
            }
            K = void 0;
          }
        } finally {
          K ? U() : I = !1;
        }
      }
    }
    var U;
    if (typeof D == "function")
      U = function() {
        D(Q);
      };
    else if (typeof MessageChannel < "u") {
      var Y = new MessageChannel(), G = Y.port2;
      Y.port1.onmessage = Q, U = function() {
        G.postMessage(null);
      };
    } else
      U = function() {
        T(Q, 0);
      };
    function J(H, K) {
      L = T(function() {
        H(e.unstable_now());
      }, K);
    }
    e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(H) {
      H.callback = null;
    }, e.unstable_forceFrameRate = function(H) {
      0 > H || 125 < H ? console.error(
        "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
      ) : F = 0 < H ? Math.floor(1e3 / H) : 5;
    }, e.unstable_getCurrentPriorityLevel = function() {
      return x;
    }, e.unstable_next = function(H) {
      switch (x) {
        case 1:
        case 2:
        case 3:
          var K = 3;
          break;
        default:
          K = x;
      }
      var X = x;
      x = K;
      try {
        return H();
      } finally {
        x = X;
      }
    }, e.unstable_requestPaint = function() {
      M = !0;
    }, e.unstable_runWithPriority = function(H, K) {
      switch (H) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          H = 3;
      }
      var X = x;
      x = H;
      try {
        return K();
      } finally {
        x = X;
      }
    }, e.unstable_scheduleCallback = function(H, K, X) {
      var te = e.unstable_now();
      switch (typeof X == "object" && X !== null ? (X = X.delay, X = typeof X == "number" && 0 < X ? te + X : te) : X = te, H) {
        case 1:
          var ie = -1;
          break;
        case 2:
          ie = 250;
          break;
        case 5:
          ie = 1073741823;
          break;
        case 4:
          ie = 1e4;
          break;
        default:
          ie = 5e3;
      }
      return ie = X + ie, H = {
        id: b++,
        callback: K,
        priorityLevel: H,
        startTime: X,
        expirationTime: ie,
        sortIndex: -1
      }, X > te ? (H.sortIndex = X, t(g, H), r(p) === null && H === r(g) && (k ? (N(L), L = -1) : k = !0, J(j, X - te))) : (H.sortIndex = ie, t(p, H), P || E || (P = !0, I || (I = !0, U()))), H;
    }, e.unstable_shouldYield = W, e.unstable_wrapCallback = function(H) {
      var K = x;
      return function() {
        var X = x;
        x = K;
        try {
          return H.apply(this, arguments);
        } finally {
          x = X;
        }
      };
    };
  })(J_)), J_;
}
var eB = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var tB;
function MPe() {
  return tB || (tB = 1, (function(e) {
    process.env.NODE_ENV !== "production" && (function() {
      function t() {
        if (j = !1, _) {
          var H = e.unstable_now();
          U = H;
          var K = !0;
          try {
            e: {
              D = !1, $ && ($ = !1, L(W), W = -1), N = !0;
              var X = T;
              try {
                t: {
                  for (d(H), M = a(E); M !== null && !(M.expirationTime > H && p()); ) {
                    var te = M.callback;
                    if (typeof te == "function") {
                      M.callback = null, T = M.priorityLevel;
                      var ie = te(
                        M.expirationTime <= H
                      );
                      if (H = e.unstable_now(), typeof ie == "function") {
                        M.callback = ie, d(H), K = !0;
                        break t;
                      }
                      M === a(E) && i(E), d(H);
                    } else i(E);
                    M = a(E);
                  }
                  if (M !== null) K = !0;
                  else {
                    var ee = a(P);
                    ee !== null && g(
                      f,
                      ee.startTime - H
                    ), K = !1;
                  }
                }
                break e;
              } finally {
                M = null, T = X, N = !1;
              }
              K = void 0;
            }
          } finally {
            K ? Y() : _ = !1;
          }
        }
      }
      function r(H, K) {
        var X = H.length;
        H.push(K);
        e: for (; 0 < X; ) {
          var te = X - 1 >>> 1, ie = H[te];
          if (0 < c(ie, K))
            H[te] = K, H[X] = ie, X = te;
          else break e;
        }
      }
      function a(H) {
        return H.length === 0 ? null : H[0];
      }
      function i(H) {
        if (H.length === 0) return null;
        var K = H[0], X = H.pop();
        if (X !== K) {
          H[0] = X;
          e: for (var te = 0, ie = H.length, ee = ie >>> 1; te < ee; ) {
            var ne = 2 * (te + 1) - 1, ae = H[ne], oe = ne + 1, fe = H[oe];
            if (0 > c(ae, X))
              oe < ie && 0 > c(fe, ae) ? (H[te] = fe, H[oe] = X, te = oe) : (H[te] = ae, H[ne] = X, te = ne);
            else if (oe < ie && 0 > c(fe, X))
              H[te] = fe, H[oe] = X, te = oe;
            else break e;
          }
        }
        return K;
      }
      function c(H, K) {
        var X = H.sortIndex - K.sortIndex;
        return X !== 0 ? X : H.id - K.id;
      }
      function d(H) {
        for (var K = a(P); K !== null; ) {
          if (K.callback === null) i(P);
          else if (K.startTime <= H)
            i(P), K.sortIndex = K.expirationTime, r(E, K);
          else break;
          K = a(P);
        }
      }
      function f(H) {
        if ($ = !1, d(H), !D)
          if (a(E) !== null)
            D = !0, _ || (_ = !0, Y());
          else {
            var K = a(P);
            K !== null && g(
              f,
              K.startTime - H
            );
          }
      }
      function p() {
        return j ? !0 : !(e.unstable_now() - U < Q);
      }
      function g(H, K) {
        W = I(function() {
          H(e.unstable_now());
        }, K);
      }
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error()), e.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
        var b = performance;
        e.unstable_now = function() {
          return b.now();
        };
      } else {
        var w = Date, x = w.now();
        e.unstable_now = function() {
          return w.now() - x;
        };
      }
      var E = [], P = [], k = 1, M = null, T = 3, N = !1, D = !1, $ = !1, j = !1, I = typeof setTimeout == "function" ? setTimeout : null, L = typeof clearTimeout == "function" ? clearTimeout : null, F = typeof setImmediate < "u" ? setImmediate : null, _ = !1, W = -1, Q = 5, U = -1;
      if (typeof F == "function")
        var Y = function() {
          F(t);
        };
      else if (typeof MessageChannel < "u") {
        var G = new MessageChannel(), J = G.port2;
        G.port1.onmessage = t, Y = function() {
          J.postMessage(null);
        };
      } else
        Y = function() {
          I(t, 0);
        };
      e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(H) {
        H.callback = null;
      }, e.unstable_forceFrameRate = function(H) {
        0 > H || 125 < H ? console.error(
          "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
        ) : Q = 0 < H ? Math.floor(1e3 / H) : 5;
      }, e.unstable_getCurrentPriorityLevel = function() {
        return T;
      }, e.unstable_next = function(H) {
        switch (T) {
          case 1:
          case 2:
          case 3:
            var K = 3;
            break;
          default:
            K = T;
        }
        var X = T;
        T = K;
        try {
          return H();
        } finally {
          T = X;
        }
      }, e.unstable_requestPaint = function() {
        j = !0;
      }, e.unstable_runWithPriority = function(H, K) {
        switch (H) {
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
            break;
          default:
            H = 3;
        }
        var X = T;
        T = H;
        try {
          return K();
        } finally {
          T = X;
        }
      }, e.unstable_scheduleCallback = function(H, K, X) {
        var te = e.unstable_now();
        switch (typeof X == "object" && X !== null ? (X = X.delay, X = typeof X == "number" && 0 < X ? te + X : te) : X = te, H) {
          case 1:
            var ie = -1;
            break;
          case 2:
            ie = 250;
            break;
          case 5:
            ie = 1073741823;
            break;
          case 4:
            ie = 1e4;
            break;
          default:
            ie = 5e3;
        }
        return ie = X + ie, H = {
          id: k++,
          callback: K,
          priorityLevel: H,
          startTime: X,
          expirationTime: ie,
          sortIndex: -1
        }, X > te ? (H.sortIndex = X, r(P, H), a(E) === null && H === a(P) && ($ ? (L(W), W = -1) : $ = !0, g(f, X - te))) : (H.sortIndex = ie, r(E, H), D || N || (D = !0, _ || (_ = !0, Y()))), H;
      }, e.unstable_shouldYield = p, e.unstable_wrapCallback = function(H) {
        var K = T;
        return function() {
          var X = T;
          T = K;
          try {
            return H.apply(this, arguments);
          } finally {
            T = X;
          }
        };
      }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
    })();
  })(eB)), eB;
}
var nB;
function ete() {
  return nB || (nB = 1, process.env.NODE_ENV === "production" ? hA.exports = kPe() : hA.exports = MPe()), hA.exports;
}
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var rB;
function OPe() {
  if (rB) return F5;
  rB = 1;
  var e = ete(), t = Re, r = hb;
  function a(l) {
    var u = "https://react.dev/errors/" + l;
    if (1 < arguments.length) {
      u += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var m = 2; m < arguments.length; m++)
        u += "&args[]=" + encodeURIComponent(arguments[m]);
    }
    return "Minified React error #" + l + "; visit " + u + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function i(l) {
    return !(!l || l.nodeType !== 1 && l.nodeType !== 9 && l.nodeType !== 11);
  }
  function c(l) {
    var u = l, m = l;
    if (l.alternate) for (; u.return; ) u = u.return;
    else {
      l = u;
      do
        u = l, (u.flags & 4098) !== 0 && (m = u.return), l = u.return;
      while (l);
    }
    return u.tag === 3 ? m : null;
  }
  function d(l) {
    if (l.tag === 13) {
      var u = l.memoizedState;
      if (u === null && (l = l.alternate, l !== null && (u = l.memoizedState)), u !== null) return u.dehydrated;
    }
    return null;
  }
  function f(l) {
    if (l.tag === 31) {
      var u = l.memoizedState;
      if (u === null && (l = l.alternate, l !== null && (u = l.memoizedState)), u !== null) return u.dehydrated;
    }
    return null;
  }
  function p(l) {
    if (c(l) !== l)
      throw Error(a(188));
  }
  function g(l) {
    var u = l.alternate;
    if (!u) {
      if (u = c(l), u === null) throw Error(a(188));
      return u !== l ? null : l;
    }
    for (var m = l, v = u; ; ) {
      var O = m.return;
      if (O === null) break;
      var R = O.alternate;
      if (R === null) {
        if (v = O.return, v !== null) {
          m = v;
          continue;
        }
        break;
      }
      if (O.child === R.child) {
        for (R = O.child; R; ) {
          if (R === m) return p(O), l;
          if (R === v) return p(O), u;
          R = R.sibling;
        }
        throw Error(a(188));
      }
      if (m.return !== v.return) m = O, v = R;
      else {
        for (var B = !1, re = O.child; re; ) {
          if (re === m) {
            B = !0, m = O, v = R;
            break;
          }
          if (re === v) {
            B = !0, v = O, m = R;
            break;
          }
          re = re.sibling;
        }
        if (!B) {
          for (re = R.child; re; ) {
            if (re === m) {
              B = !0, m = R, v = O;
              break;
            }
            if (re === v) {
              B = !0, v = R, m = O;
              break;
            }
            re = re.sibling;
          }
          if (!B) throw Error(a(189));
        }
      }
      if (m.alternate !== v) throw Error(a(190));
    }
    if (m.tag !== 3) throw Error(a(188));
    return m.stateNode.current === m ? l : u;
  }
  function b(l) {
    var u = l.tag;
    if (u === 5 || u === 26 || u === 27 || u === 6) return l;
    for (l = l.child; l !== null; ) {
      if (u = b(l), u !== null) return u;
      l = l.sibling;
    }
    return null;
  }
  var w = Object.assign, x = Symbol.for("react.element"), E = Symbol.for("react.transitional.element"), P = Symbol.for("react.portal"), k = Symbol.for("react.fragment"), M = Symbol.for("react.strict_mode"), T = Symbol.for("react.profiler"), N = Symbol.for("react.consumer"), D = Symbol.for("react.context"), $ = Symbol.for("react.forward_ref"), j = Symbol.for("react.suspense"), I = Symbol.for("react.suspense_list"), L = Symbol.for("react.memo"), F = Symbol.for("react.lazy"), _ = Symbol.for("react.activity"), W = Symbol.for("react.memo_cache_sentinel"), Q = Symbol.iterator;
  function U(l) {
    return l === null || typeof l != "object" ? null : (l = Q && l[Q] || l["@@iterator"], typeof l == "function" ? l : null);
  }
  var Y = Symbol.for("react.client.reference");
  function G(l) {
    if (l == null) return null;
    if (typeof l == "function")
      return l.$$typeof === Y ? null : l.displayName || l.name || null;
    if (typeof l == "string") return l;
    switch (l) {
      case k:
        return "Fragment";
      case T:
        return "Profiler";
      case M:
        return "StrictMode";
      case j:
        return "Suspense";
      case I:
        return "SuspenseList";
      case _:
        return "Activity";
    }
    if (typeof l == "object")
      switch (l.$$typeof) {
        case P:
          return "Portal";
        case D:
          return l.displayName || "Context";
        case N:
          return (l._context.displayName || "Context") + ".Consumer";
        case $:
          var u = l.render;
          return l = l.displayName, l || (l = u.displayName || u.name || "", l = l !== "" ? "ForwardRef(" + l + ")" : "ForwardRef"), l;
        case L:
          return u = l.displayName || null, u !== null ? u : G(l.type) || "Memo";
        case F:
          u = l._payload, l = l._init;
          try {
            return G(l(u));
          } catch {
          }
      }
    return null;
  }
  var J = Array.isArray, H = t.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, K = r.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, X = {
    pending: !1,
    data: null,
    method: null,
    action: null
  }, te = [], ie = -1;
  function ee(l) {
    return { current: l };
  }
  function ne(l) {
    0 > ie || (l.current = te[ie], te[ie] = null, ie--);
  }
  function ae(l, u) {
    ie++, te[ie] = l.current, l.current = u;
  }
  var oe = ee(null), fe = ee(null), be = ee(null), me = ee(null);
  function De(l, u) {
    switch (ae(be, u), ae(fe, l), ae(oe, null), u.nodeType) {
      case 9:
      case 11:
        l = (l = u.documentElement) && (l = l.namespaceURI) ? zy(l) : 0;
        break;
      default:
        if (l = u.tagName, u = u.namespaceURI)
          u = zy(u), l = M2(u, l);
        else
          switch (l) {
            case "svg":
              l = 1;
              break;
            case "math":
              l = 2;
              break;
            default:
              l = 0;
          }
    }
    ne(oe), ae(oe, l);
  }
  function Me() {
    ne(oe), ne(fe), ne(be);
  }
  function ze(l) {
    l.memoizedState !== null && ae(me, l);
    var u = oe.current, m = M2(u, l.type);
    u !== m && (ae(fe, l), ae(oe, m));
  }
  function le(l) {
    fe.current === l && (ne(oe), ne(fe)), me.current === l && (ne(me), mh._currentValue = X);
  }
  var se, Ae;
  function we(l) {
    if (se === void 0)
      try {
        throw Error();
      } catch (m) {
        var u = m.stack.trim().match(/\n( *(at )?)/);
        se = u && u[1] || "", Ae = -1 < m.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < m.stack.indexOf("@") ? "@unknown:0:0" : "";
      }
    return `
` + se + l + Ae;
  }
  var Ne = !1;
  function pe(l, u) {
    if (!l || Ne) return "";
    Ne = !0;
    var m = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var v = {
        DetermineComponentFrameRoot: function() {
          try {
            if (u) {
              var nt = function() {
                throw Error();
              };
              if (Object.defineProperty(nt.prototype, "props", {
                set: function() {
                  throw Error();
                }
              }), typeof Reflect == "object" && Reflect.construct) {
                try {
                  Reflect.construct(nt, []);
                } catch (Ge) {
                  var We = Ge;
                }
                Reflect.construct(l, [], nt);
              } else {
                try {
                  nt.call();
                } catch (Ge) {
                  We = Ge;
                }
                l.call(nt.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (Ge) {
                We = Ge;
              }
              (nt = l()) && typeof nt.catch == "function" && nt.catch(function() {
              });
            }
          } catch (Ge) {
            if (Ge && We && typeof Ge.stack == "string")
              return [Ge.stack, We.stack];
          }
          return [null, null];
        }
      };
      v.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var O = Object.getOwnPropertyDescriptor(
        v.DetermineComponentFrameRoot,
        "name"
      );
      O && O.configurable && Object.defineProperty(
        v.DetermineComponentFrameRoot,
        "name",
        { value: "DetermineComponentFrameRoot" }
      );
      var R = v.DetermineComponentFrameRoot(), B = R[0], re = R[1];
      if (B && re) {
        var ve = B.split(`
`), He = re.split(`
`);
        for (O = v = 0; v < ve.length && !ve[v].includes("DetermineComponentFrameRoot"); )
          v++;
        for (; O < He.length && !He[O].includes(
          "DetermineComponentFrameRoot"
        ); )
          O++;
        if (v === ve.length || O === He.length)
          for (v = ve.length - 1, O = He.length - 1; 1 <= v && 0 <= O && ve[v] !== He[O]; )
            O--;
        for (; 1 <= v && 0 <= O; v--, O--)
          if (ve[v] !== He[O]) {
            if (v !== 1 || O !== 1)
              do
                if (v--, O--, 0 > O || ve[v] !== He[O]) {
                  var Je = `
` + ve[v].replace(" at new ", " at ");
                  return l.displayName && Je.includes("<anonymous>") && (Je = Je.replace("<anonymous>", l.displayName)), Je;
                }
              while (1 <= v && 0 <= O);
            break;
          }
      }
    } finally {
      Ne = !1, Error.prepareStackTrace = m;
    }
    return (m = l ? l.displayName || l.name : "") ? we(m) : "";
  }
  function Qe(l, u) {
    switch (l.tag) {
      case 26:
      case 27:
      case 5:
        return we(l.type);
      case 16:
        return we("Lazy");
      case 13:
        return l.child !== u && u !== null ? we("Suspense Fallback") : we("Suspense");
      case 19:
        return we("SuspenseList");
      case 0:
      case 15:
        return pe(l.type, !1);
      case 11:
        return pe(l.type.render, !1);
      case 1:
        return pe(l.type, !0);
      case 31:
        return we("Activity");
      default:
        return "";
    }
  }
  function Le(l) {
    try {
      var u = "", m = null;
      do
        u += Qe(l, m), m = l, l = l.return;
      while (l);
      return u;
    } catch (v) {
      return `
Error generating stack: ` + v.message + `
` + v.stack;
    }
  }
  var Te = Object.prototype.hasOwnProperty, Oe = e.unstable_scheduleCallback, ye = e.unstable_cancelCallback, je = e.unstable_shouldYield, Ue = e.unstable_requestPaint, Fe = e.unstable_now, tt = e.unstable_getCurrentPriorityLevel, dt = e.unstable_ImmediatePriority, St = e.unstable_UserBlockingPriority, mt = e.unstable_NormalPriority, Ot = e.unstable_LowPriority, Rt = e.unstable_IdlePriority, ct = e.log, it = e.unstable_setDisableYieldValue, Ct = null, ut = null;
  function ht(l) {
    if (typeof ct == "function" && it(l), ut && typeof ut.setStrictMode == "function")
      try {
        ut.setStrictMode(Ct, l);
      } catch {
      }
  }
  var ot = Math.clz32 ? Math.clz32 : st, at = Math.log, ft = Math.LN2;
  function st(l) {
    return l >>>= 0, l === 0 ? 32 : 31 - (at(l) / ft | 0) | 0;
  }
  var pt = 256, bt = 262144, Nt = 4194304;
  function $t(l) {
    var u = l & 42;
    if (u !== 0) return u;
    switch (l & -l) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
        return 64;
      case 128:
        return 128;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
        return l & 261888;
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return l & 3932160;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return l & 62914560;
      case 67108864:
        return 67108864;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 0;
      default:
        return l;
    }
  }
  function Pt(l, u, m) {
    var v = l.pendingLanes;
    if (v === 0) return 0;
    var O = 0, R = l.suspendedLanes, B = l.pingedLanes;
    l = l.warmLanes;
    var re = v & 134217727;
    return re !== 0 ? (v = re & ~R, v !== 0 ? O = $t(v) : (B &= re, B !== 0 ? O = $t(B) : m || (m = re & ~l, m !== 0 && (O = $t(m))))) : (re = v & ~R, re !== 0 ? O = $t(re) : B !== 0 ? O = $t(B) : m || (m = v & ~l, m !== 0 && (O = $t(m)))), O === 0 ? 0 : u !== 0 && u !== O && (u & R) === 0 && (R = O & -O, m = u & -u, R >= m || R === 32 && (m & 4194048) !== 0) ? u : O;
  }
  function hn(l, u) {
    return (l.pendingLanes & ~(l.suspendedLanes & ~l.pingedLanes) & u) === 0;
  }
  function an(l, u) {
    switch (l) {
      case 1:
      case 2:
      case 4:
      case 8:
      case 64:
        return u + 250;
      case 16:
      case 32:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return u + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return -1;
      case 67108864:
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function jn() {
    var l = Nt;
    return Nt <<= 1, (Nt & 62914560) === 0 && (Nt = 4194304), l;
  }
  function xn(l) {
    for (var u = [], m = 0; 31 > m; m++) u.push(l);
    return u;
  }
  function Ut(l, u) {
    l.pendingLanes |= u, u !== 268435456 && (l.suspendedLanes = 0, l.pingedLanes = 0, l.warmLanes = 0);
  }
  function pn(l, u, m, v, O, R) {
    var B = l.pendingLanes;
    l.pendingLanes = m, l.suspendedLanes = 0, l.pingedLanes = 0, l.warmLanes = 0, l.expiredLanes &= m, l.entangledLanes &= m, l.errorRecoveryDisabledLanes &= m, l.shellSuspendCounter = 0;
    var re = l.entanglements, ve = l.expirationTimes, He = l.hiddenUpdates;
    for (m = B & ~m; 0 < m; ) {
      var Je = 31 - ot(m), nt = 1 << Je;
      re[Je] = 0, ve[Je] = -1;
      var We = He[Je];
      if (We !== null)
        for (He[Je] = null, Je = 0; Je < We.length; Je++) {
          var Ge = We[Je];
          Ge !== null && (Ge.lane &= -536870913);
        }
      m &= ~nt;
    }
    v !== 0 && wn(l, v, 0), R !== 0 && O === 0 && l.tag !== 0 && (l.suspendedLanes |= R & ~(B & ~u));
  }
  function wn(l, u, m) {
    l.pendingLanes |= u, l.suspendedLanes &= ~u;
    var v = 31 - ot(u);
    l.entangledLanes |= u, l.entanglements[v] = l.entanglements[v] | 1073741824 | m & 261930;
  }
  function Lt(l, u) {
    var m = l.entangledLanes |= u;
    for (l = l.entanglements; m; ) {
      var v = 31 - ot(m), O = 1 << v;
      O & u | l[v] & u && (l[v] |= u), m &= ~O;
    }
  }
  function gt(l, u) {
    var m = u & -u;
    return m = (m & 42) !== 0 ? 1 : wt(m), (m & (l.suspendedLanes | u)) !== 0 ? 0 : m;
  }
  function wt(l) {
    switch (l) {
      case 2:
        l = 1;
        break;
      case 8:
        l = 4;
        break;
      case 32:
        l = 16;
        break;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        l = 128;
        break;
      case 268435456:
        l = 134217728;
        break;
      default:
        l = 0;
    }
    return l;
  }
  function Ft(l) {
    return l &= -l, 2 < l ? 8 < l ? (l & 134217727) !== 0 ? 32 : 268435456 : 8 : 2;
  }
  function yn() {
    var l = K.p;
    return l !== 0 ? l : (l = window.event, l === void 0 ? 32 : hh(l.type));
  }
  function gn(l, u) {
    var m = K.p;
    try {
      return K.p = l, u();
    } finally {
      K.p = m;
    }
  }
  var Tn = Math.random().toString(36).slice(2), Gt = "__reactFiber$" + Tn, Dt = "__reactProps$" + Tn, Yt = "__reactContainer$" + Tn, Mn = "__reactEvents$" + Tn, Gn = "__reactListeners$" + Tn, wr = "__reactHandles$" + Tn, aa = "__reactResources$" + Tn, qn = "__reactMarker$" + Tn;
  function Rr(l) {
    delete l[Gt], delete l[Dt], delete l[Mn], delete l[Gn], delete l[wr];
  }
  function Wt(l) {
    var u = l[Gt];
    if (u) return u;
    for (var m = l.parentNode; m; ) {
      if (u = m[Yt] || m[Gt]) {
        if (m = u.alternate, u.child !== null || m !== null && m.child !== null)
          for (l = Nl(l); l !== null; ) {
            if (m = l[Gt]) return m;
            l = Nl(l);
          }
        return u;
      }
      l = m, m = l.parentNode;
    }
    return null;
  }
  function en(l) {
    if (l = l[Gt] || l[Yt]) {
      var u = l.tag;
      if (u === 5 || u === 6 || u === 13 || u === 31 || u === 26 || u === 27 || u === 3)
        return l;
    }
    return null;
  }
  function Xt(l) {
    var u = l.tag;
    if (u === 5 || u === 26 || u === 27 || u === 6) return l.stateNode;
    throw Error(a(33));
  }
  function zt(l) {
    var u = l[aa];
    return u || (u = l[aa] = { hoistableStyles: /* @__PURE__ */ new Map(), hoistableScripts: /* @__PURE__ */ new Map() }), u;
  }
  function kt(l) {
    l[qn] = !0;
  }
  var Qn = /* @__PURE__ */ new Set(), Jn = {};
  function Nr(l, u) {
    Hr(l, u), Hr(l + "Capture", u);
  }
  function Hr(l, u) {
    for (Jn[l] = u, l = 0; l < u.length; l++)
      Qn.add(u[l]);
  }
  var oa = RegExp(
    "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
  ), dn = {}, Un = {};
  function sr(l) {
    return Te.call(Un, l) ? !0 : Te.call(dn, l) ? !1 : oa.test(l) ? Un[l] = !0 : (dn[l] = !0, !1);
  }
  function Yr(l, u, m) {
    if (sr(u))
      if (m === null) l.removeAttribute(u);
      else {
        switch (typeof m) {
          case "undefined":
          case "function":
          case "symbol":
            l.removeAttribute(u);
            return;
          case "boolean":
            var v = u.toLowerCase().slice(0, 5);
            if (v !== "data-" && v !== "aria-") {
              l.removeAttribute(u);
              return;
            }
        }
        l.setAttribute(u, "" + m);
      }
  }
  function Wa(l, u, m) {
    if (m === null) l.removeAttribute(u);
    else {
      switch (typeof m) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          l.removeAttribute(u);
          return;
      }
      l.setAttribute(u, "" + m);
    }
  }
  function pa(l, u, m, v) {
    if (v === null) l.removeAttribute(m);
    else {
      switch (typeof v) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          l.removeAttribute(m);
          return;
      }
      l.setAttributeNS(u, m, "" + v);
    }
  }
  function Jr(l) {
    switch (typeof l) {
      case "bigint":
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return l;
      case "object":
        return l;
      default:
        return "";
    }
  }
  function si(l) {
    var u = l.type;
    return (l = l.nodeName) && l.toLowerCase() === "input" && (u === "checkbox" || u === "radio");
  }
  function mi(l, u, m) {
    var v = Object.getOwnPropertyDescriptor(
      l.constructor.prototype,
      u
    );
    if (!l.hasOwnProperty(u) && typeof v < "u" && typeof v.get == "function" && typeof v.set == "function") {
      var O = v.get, R = v.set;
      return Object.defineProperty(l, u, {
        configurable: !0,
        get: function() {
          return O.call(this);
        },
        set: function(B) {
          m = "" + B, R.call(this, B);
        }
      }), Object.defineProperty(l, u, {
        enumerable: v.enumerable
      }), {
        getValue: function() {
          return m;
        },
        setValue: function(B) {
          m = "" + B;
        },
        stopTracking: function() {
          l._valueTracker = null, delete l[u];
        }
      };
    }
  }
  function Yo(l) {
    if (!l._valueTracker) {
      var u = si(l) ? "checked" : "value";
      l._valueTracker = mi(
        l,
        u,
        "" + l[u]
      );
    }
  }
  function Bi(l) {
    if (!l) return !1;
    var u = l._valueTracker;
    if (!u) return !0;
    var m = u.getValue(), v = "";
    return l && (v = si(l) ? l.checked ? "true" : "false" : l.value), l = v, l !== m ? (u.setValue(l), !0) : !1;
  }
  function hr(l) {
    if (l = l || (typeof document < "u" ? document : void 0), typeof l > "u") return null;
    try {
      return l.activeElement || l.body;
    } catch {
      return l.body;
    }
  }
  var zn = /[\n"\\]/g;
  function On(l) {
    return l.replace(
      zn,
      function(u) {
        return "\\" + u.charCodeAt(0).toString(16) + " ";
      }
    );
  }
  function Qt(l, u, m, v, O, R, B, re) {
    l.name = "", B != null && typeof B != "function" && typeof B != "symbol" && typeof B != "boolean" ? l.type = B : l.removeAttribute("type"), u != null ? B === "number" ? (u === 0 && l.value === "" || l.value != u) && (l.value = "" + Jr(u)) : l.value !== "" + Jr(u) && (l.value = "" + Jr(u)) : B !== "submit" && B !== "reset" || l.removeAttribute("value"), u != null ? er(l, B, Jr(u)) : m != null ? er(l, B, Jr(m)) : v != null && l.removeAttribute("value"), O == null && R != null && (l.defaultChecked = !!R), O != null && (l.checked = O && typeof O != "function" && typeof O != "symbol"), re != null && typeof re != "function" && typeof re != "symbol" && typeof re != "boolean" ? l.name = "" + Jr(re) : l.removeAttribute("name");
  }
  function nn(l, u, m, v, O, R, B, re) {
    if (R != null && typeof R != "function" && typeof R != "symbol" && typeof R != "boolean" && (l.type = R), u != null || m != null) {
      if (!(R !== "submit" && R !== "reset" || u != null)) {
        Yo(l);
        return;
      }
      m = m != null ? "" + Jr(m) : "", u = u != null ? "" + Jr(u) : m, re || u === l.value || (l.value = u), l.defaultValue = u;
    }
    v = v ?? O, v = typeof v != "function" && typeof v != "symbol" && !!v, l.checked = re ? l.checked : !!v, l.defaultChecked = !!v, B != null && typeof B != "function" && typeof B != "symbol" && typeof B != "boolean" && (l.name = B), Yo(l);
  }
  function er(l, u, m) {
    u === "number" && hr(l.ownerDocument) === l || l.defaultValue === "" + m || (l.defaultValue = "" + m);
  }
  function ia(l, u, m, v) {
    if (l = l.options, u) {
      u = {};
      for (var O = 0; O < m.length; O++)
        u["$" + m[O]] = !0;
      for (m = 0; m < l.length; m++)
        O = u.hasOwnProperty("$" + l[m].value), l[m].selected !== O && (l[m].selected = O), O && v && (l[m].defaultSelected = !0);
    } else {
      for (m = "" + Jr(m), u = null, O = 0; O < l.length; O++) {
        if (l[O].value === m) {
          l[O].selected = !0, v && (l[O].defaultSelected = !0);
          return;
        }
        u !== null || l[O].disabled || (u = l[O]);
      }
      u !== null && (u.selected = !0);
    }
  }
  function so(l, u, m) {
    if (u != null && (u = "" + Jr(u), u !== l.value && (l.value = u), m == null)) {
      l.defaultValue !== u && (l.defaultValue = u);
      return;
    }
    l.defaultValue = m != null ? "" + Jr(m) : "";
  }
  function hi(l, u, m, v) {
    if (u == null) {
      if (v != null) {
        if (m != null) throw Error(a(92));
        if (J(v)) {
          if (1 < v.length) throw Error(a(93));
          v = v[0];
        }
        m = v;
      }
      m == null && (m = ""), u = m;
    }
    m = Jr(u), l.defaultValue = m, v = l.textContent, v === m && v !== "" && v !== null && (l.value = v), Yo(l);
  }
  function ka(l, u) {
    if (u) {
      var m = l.firstChild;
      if (m && m === l.lastChild && m.nodeType === 3) {
        m.nodeValue = u;
        return;
      }
    }
    l.textContent = u;
  }
  var Ui = new Set(
    "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
      " "
    )
  );
  function sl(l, u, m) {
    var v = u.indexOf("--") === 0;
    m == null || typeof m == "boolean" || m === "" ? v ? l.setProperty(u, "") : u === "float" ? l.cssFloat = "" : l[u] = "" : v ? l.setProperty(u, m) : typeof m != "number" || m === 0 || Ui.has(u) ? u === "float" ? l.cssFloat = m : l[u] = ("" + m).trim() : l[u] = m + "px";
  }
  function qt(l, u, m) {
    if (u != null && typeof u != "object")
      throw Error(a(62));
    if (l = l.style, m != null) {
      for (var v in m)
        !m.hasOwnProperty(v) || u != null && u.hasOwnProperty(v) || (v.indexOf("--") === 0 ? l.setProperty(v, "") : v === "float" ? l.cssFloat = "" : l[v] = "");
      for (var O in u)
        v = u[O], u.hasOwnProperty(O) && m[O] !== v && sl(l, O, v);
    } else
      for (var R in u)
        u.hasOwnProperty(R) && sl(l, R, u[R]);
  }
  function Kt(l) {
    if (l.indexOf("-") === -1) return !1;
    switch (l) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var ur = /* @__PURE__ */ new Map([
    ["acceptCharset", "accept-charset"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"],
    ["crossOrigin", "crossorigin"],
    ["accentHeight", "accent-height"],
    ["alignmentBaseline", "alignment-baseline"],
    ["arabicForm", "arabic-form"],
    ["baselineShift", "baseline-shift"],
    ["capHeight", "cap-height"],
    ["clipPath", "clip-path"],
    ["clipRule", "clip-rule"],
    ["colorInterpolation", "color-interpolation"],
    ["colorInterpolationFilters", "color-interpolation-filters"],
    ["colorProfile", "color-profile"],
    ["colorRendering", "color-rendering"],
    ["dominantBaseline", "dominant-baseline"],
    ["enableBackground", "enable-background"],
    ["fillOpacity", "fill-opacity"],
    ["fillRule", "fill-rule"],
    ["floodColor", "flood-color"],
    ["floodOpacity", "flood-opacity"],
    ["fontFamily", "font-family"],
    ["fontSize", "font-size"],
    ["fontSizeAdjust", "font-size-adjust"],
    ["fontStretch", "font-stretch"],
    ["fontStyle", "font-style"],
    ["fontVariant", "font-variant"],
    ["fontWeight", "font-weight"],
    ["glyphName", "glyph-name"],
    ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
    ["glyphOrientationVertical", "glyph-orientation-vertical"],
    ["horizAdvX", "horiz-adv-x"],
    ["horizOriginX", "horiz-origin-x"],
    ["imageRendering", "image-rendering"],
    ["letterSpacing", "letter-spacing"],
    ["lightingColor", "lighting-color"],
    ["markerEnd", "marker-end"],
    ["markerMid", "marker-mid"],
    ["markerStart", "marker-start"],
    ["overlinePosition", "overline-position"],
    ["overlineThickness", "overline-thickness"],
    ["paintOrder", "paint-order"],
    ["panose-1", "panose-1"],
    ["pointerEvents", "pointer-events"],
    ["renderingIntent", "rendering-intent"],
    ["shapeRendering", "shape-rendering"],
    ["stopColor", "stop-color"],
    ["stopOpacity", "stop-opacity"],
    ["strikethroughPosition", "strikethrough-position"],
    ["strikethroughThickness", "strikethrough-thickness"],
    ["strokeDasharray", "stroke-dasharray"],
    ["strokeDashoffset", "stroke-dashoffset"],
    ["strokeLinecap", "stroke-linecap"],
    ["strokeLinejoin", "stroke-linejoin"],
    ["strokeMiterlimit", "stroke-miterlimit"],
    ["strokeOpacity", "stroke-opacity"],
    ["strokeWidth", "stroke-width"],
    ["textAnchor", "text-anchor"],
    ["textDecoration", "text-decoration"],
    ["textRendering", "text-rendering"],
    ["transformOrigin", "transform-origin"],
    ["underlinePosition", "underline-position"],
    ["underlineThickness", "underline-thickness"],
    ["unicodeBidi", "unicode-bidi"],
    ["unicodeRange", "unicode-range"],
    ["unitsPerEm", "units-per-em"],
    ["vAlphabetic", "v-alphabetic"],
    ["vHanging", "v-hanging"],
    ["vIdeographic", "v-ideographic"],
    ["vMathematical", "v-mathematical"],
    ["vectorEffect", "vector-effect"],
    ["vertAdvY", "vert-adv-y"],
    ["vertOriginX", "vert-origin-x"],
    ["vertOriginY", "vert-origin-y"],
    ["wordSpacing", "word-spacing"],
    ["writingMode", "writing-mode"],
    ["xmlnsXlink", "xmlns:xlink"],
    ["xHeight", "x-height"]
  ]), pr = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function tr(l) {
    return pr.test("" + l) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : l;
  }
  function Va() {
  }
  var pi = null;
  function Li(l) {
    return l = l.target || l.srcElement || window, l.correspondingUseElement && (l = l.correspondingUseElement), l.nodeType === 3 ? l.parentNode : l;
  }
  var yo = null, ul = null;
  function rc(l) {
    var u = en(l);
    if (u && (l = u.stateNode)) {
      var m = l[Dt] || null;
      e: switch (l = u.stateNode, u.type) {
        case "input":
          if (Qt(
            l,
            m.value,
            m.defaultValue,
            m.defaultValue,
            m.checked,
            m.defaultChecked,
            m.type,
            m.name
          ), u = m.name, m.type === "radio" && u != null) {
            for (m = l; m.parentNode; ) m = m.parentNode;
            for (m = m.querySelectorAll(
              'input[name="' + On(
                "" + u
              ) + '"][type="radio"]'
            ), u = 0; u < m.length; u++) {
              var v = m[u];
              if (v !== l && v.form === l.form) {
                var O = v[Dt] || null;
                if (!O) throw Error(a(90));
                Qt(
                  v,
                  O.value,
                  O.defaultValue,
                  O.defaultValue,
                  O.checked,
                  O.defaultChecked,
                  O.type,
                  O.name
                );
              }
            }
            for (u = 0; u < m.length; u++)
              v = m[u], v.form === l.form && Bi(v);
          }
          break e;
        case "textarea":
          so(l, m.value, m.defaultValue);
          break e;
        case "select":
          u = m.value, u != null && ia(l, !!m.multiple, u, !1);
      }
    }
  }
  var uu = !1;
  function lm(l, u, m) {
    if (uu) return l(u, m);
    uu = !0;
    try {
      var v = l(u);
      return v;
    } finally {
      if (uu = !1, (yo !== null || ul !== null) && (Qd(), yo && (u = yo, l = ul, ul = yo = null, rc(u), l)))
        for (u = 0; u < l.length; u++) rc(l[u]);
    }
  }
  function Jt(l, u) {
    var m = l.stateNode;
    if (m === null) return null;
    var v = m[Dt] || null;
    if (v === null) return null;
    m = v[u];
    e: switch (u) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (v = !v.disabled) || (l = l.type, v = !(l === "button" || l === "input" || l === "select" || l === "textarea")), l = !v;
        break e;
      default:
        l = !1;
    }
    if (l) return null;
    if (m && typeof m != "function")
      throw Error(
        a(231, u, typeof m)
      );
    return m;
  }
  var nr = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), ao = !1;
  if (nr)
    try {
      var wo = {};
      Object.defineProperty(wo, "passive", {
        get: function() {
          ao = !0;
        }
      }), window.addEventListener("test", wo, wo), window.removeEventListener("test", wo, wo);
    } catch {
      ao = !1;
    }
  var Ea = null, Uf = null, gd = null;
  function Zh() {
    if (gd) return gd;
    var l, u = Uf, m = u.length, v, O = "value" in Ea ? Ea.value : Ea.textContent, R = O.length;
    for (l = 0; l < m && u[l] === O[l]; l++) ;
    var B = m - l;
    for (v = 1; v <= B && u[m - v] === O[R - v]; v++) ;
    return gd = O.slice(l, 1 < v ? 1 - v : void 0);
  }
  function cd(l) {
    var u = l.keyCode;
    return "charCode" in l ? (l = l.charCode, l === 0 && u === 13 && (l = 13)) : l = u, l === 10 && (l = 13), 32 <= l || l === 13 ? l : 0;
  }
  function sm() {
    return !0;
  }
  function Mb() {
    return !1;
  }
  function uo(l) {
    function u(m, v, O, R, B) {
      this._reactName = m, this._targetInst = O, this.type = v, this.nativeEvent = R, this.target = B, this.currentTarget = null;
      for (var re in l)
        l.hasOwnProperty(re) && (m = l[re], this[re] = m ? m(R) : R[re]);
      return this.isDefaultPrevented = (R.defaultPrevented != null ? R.defaultPrevented : R.returnValue === !1) ? sm : Mb, this.isPropagationStopped = Mb, this;
    }
    return w(u.prototype, {
      preventDefault: function() {
        this.defaultPrevented = !0;
        var m = this.nativeEvent;
        m && (m.preventDefault ? m.preventDefault() : typeof m.returnValue != "unknown" && (m.returnValue = !1), this.isDefaultPrevented = sm);
      },
      stopPropagation: function() {
        var m = this.nativeEvent;
        m && (m.stopPropagation ? m.stopPropagation() : typeof m.cancelBubble != "unknown" && (m.cancelBubble = !0), this.isPropagationStopped = sm);
      },
      persist: function() {
      },
      isPersistent: sm
    }), u;
  }
  var cu = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(l) {
      return l.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
  }, um = uo(cu), vd = w({}, cu, { view: 0, detail: 0 }), dC = uo(vd), K0, Y0, cm, pp = w({}, vd, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: Xi,
    button: 0,
    buttons: 0,
    relatedTarget: function(l) {
      return l.relatedTarget === void 0 ? l.fromElement === l.srcElement ? l.toElement : l.fromElement : l.relatedTarget;
    },
    movementX: function(l) {
      return "movementX" in l ? l.movementX : (l !== cm && (cm && l.type === "mousemove" ? (K0 = l.screenX - cm.screenX, Y0 = l.screenY - cm.screenY) : Y0 = K0 = 0, cm = l), K0);
    },
    movementY: function(l) {
      return "movementY" in l ? l.movementY : Y0;
    }
  }), bd = uo(pp), Ob = w({}, pp, { dataTransfer: 0 }), Tb = uo(Ob), Rb = w({}, vd, { relatedTarget: 0 }), gp = uo(Rb), Q0 = w({}, cu, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), Ab = uo(Q0), ac = w({}, cu, {
    clipboardData: function(l) {
      return "clipboardData" in l ? l.clipboardData : window.clipboardData;
    }
  }), oc = uo(ac), ml = w({}, cu, { data: 0 }), Nb = uo(ml), J0 = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, Vl = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, Db = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
  };
  function hl(l) {
    var u = this.nativeEvent;
    return u.getModifierState ? u.getModifierState(l) : (l = Db[l]) ? !!u[l] : !1;
  }
  function Xi() {
    return hl;
  }
  var vp = w({}, vd, {
    key: function(l) {
      if (l.key) {
        var u = J0[l.key] || l.key;
        if (u !== "Unidentified") return u;
      }
      return l.type === "keypress" ? (l = cd(l), l === 13 ? "Enter" : String.fromCharCode(l)) : l.type === "keydown" || l.type === "keyup" ? Vl[l.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: Xi,
    charCode: function(l) {
      return l.type === "keypress" ? cd(l) : 0;
    },
    keyCode: function(l) {
      return l.type === "keydown" || l.type === "keyup" ? l.keyCode : 0;
    },
    which: function(l) {
      return l.type === "keypress" ? cd(l) : l.type === "keydown" || l.type === "keyup" ? l.keyCode : 0;
    }
  }), bp = uo(vp), Z0 = w({}, pp, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
  }), pl = uo(Z0), fC = w({}, vd, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: Xi
  }), $b = uo(fC), zb = w({}, cu, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), mC = uo(zb), ev = w({}, pp, {
    deltaX: function(l) {
      return "deltaX" in l ? l.deltaX : "wheelDeltaX" in l ? -l.wheelDeltaX : 0;
    },
    deltaY: function(l) {
      return "deltaY" in l ? l.deltaY : "wheelDeltaY" in l ? -l.wheelDeltaY : "wheelDelta" in l ? -l.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), hC = uo(ev), jb = w({}, cu, {
    newState: 0,
    oldState: 0
  }), tv = uo(jb), yp = [9, 13, 27, 32], yd = nr && "CompositionEvent" in window, ic = null;
  nr && "documentMode" in document && (ic = document.documentMode);
  var So = nr && "TextEvent" in window && !ic, nv = nr && (!yd || ic && 8 < ic && 11 >= ic), dm = " ", du = !1;
  function wp(l, u) {
    switch (l) {
      case "keyup":
        return yp.indexOf(u.keyCode) !== -1;
      case "keydown":
        return u.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function rv(l) {
    return l = l.detail, typeof l == "object" && "data" in l ? l.data : null;
  }
  var lc = !1;
  function Ib(l, u) {
    switch (l) {
      case "compositionend":
        return rv(u);
      case "keypress":
        return u.which !== 32 ? null : (du = !0, dm);
      case "textInput":
        return l = u.data, l === dm && du ? null : l;
      default:
        return null;
    }
  }
  function pC(l, u) {
    if (lc)
      return l === "compositionend" || !yd && wp(l, u) ? (l = Zh(), gd = Uf = Ea = null, lc = !1, l) : null;
    switch (l) {
      case "paste":
        return null;
      case "keypress":
        if (!(u.ctrlKey || u.altKey || u.metaKey) || u.ctrlKey && u.altKey) {
          if (u.char && 1 < u.char.length)
            return u.char;
          if (u.which) return String.fromCharCode(u.which);
        }
        return null;
      case "compositionend":
        return nv && u.locale !== "ko" ? null : u.data;
      default:
        return null;
    }
  }
  var av = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
  };
  function _l(l) {
    var u = l && l.nodeName && l.nodeName.toLowerCase();
    return u === "input" ? !!av[l.type] : u === "textarea";
  }
  function ov(l, u, m, v) {
    yo ? ul ? ul.push(v) : ul = [v] : yo = v, u = lh(u, "onChange"), 0 < u.length && (m = new um(
      "onChange",
      "change",
      null,
      m,
      v
    ), l.push({ event: m, listeners: u }));
  }
  var sc = null, fu = null;
  function uc(l) {
    Ny(l, 0);
  }
  function wd(l) {
    var u = Xt(l);
    if (Bi(u)) return l;
  }
  function iv(l, u) {
    if (l === "change") return u;
  }
  var Sp = !1;
  if (nr) {
    var $o;
    if (nr) {
      var gl = "oninput" in document;
      if (!gl) {
        var lv = document.createElement("div");
        lv.setAttribute("oninput", "return;"), gl = typeof lv.oninput == "function";
      }
      $o = gl;
    } else $o = !1;
    Sp = $o && (!document.documentMode || 9 < document.documentMode);
  }
  function Cp() {
    sc && (sc.detachEvent("onpropertychange", xp), fu = sc = null);
  }
  function xp(l) {
    if (l.propertyName === "value" && wd(fu)) {
      var u = [];
      ov(
        u,
        fu,
        l,
        Li(l)
      ), lm(uc, u);
    }
  }
  function Lb(l, u, m) {
    l === "focusin" ? (Cp(), sc = u, fu = m, sc.attachEvent("onpropertychange", xp)) : l === "focusout" && Cp();
  }
  function Hb(l) {
    if (l === "selectionchange" || l === "keyup" || l === "keydown")
      return wd(fu);
  }
  function mu(l, u) {
    if (l === "click") return wd(u);
  }
  function cc(l, u) {
    if (l === "input" || l === "change")
      return wd(u);
  }
  function Fb(l, u) {
    return l === u && (l !== 0 || 1 / l === 1 / u) || l !== l && u !== u;
  }
  var Co = typeof Object.is == "function" ? Object.is : Fb;
  function Gi(l, u) {
    if (Co(l, u)) return !0;
    if (typeof l != "object" || l === null || typeof u != "object" || u === null)
      return !1;
    var m = Object.keys(l), v = Object.keys(u);
    if (m.length !== v.length) return !1;
    for (v = 0; v < m.length; v++) {
      var O = m[v];
      if (!Te.call(u, O) || !Co(l[O], u[O]))
        return !1;
    }
    return !0;
  }
  function sv(l) {
    for (; l && l.firstChild; ) l = l.firstChild;
    return l;
  }
  function uv(l, u) {
    var m = sv(l);
    l = 0;
    for (var v; m; ) {
      if (m.nodeType === 3) {
        if (v = l + m.textContent.length, l <= u && v >= u)
          return { node: m, offset: u - l };
        l = v;
      }
      e: {
        for (; m; ) {
          if (m.nextSibling) {
            m = m.nextSibling;
            break e;
          }
          m = m.parentNode;
        }
        m = void 0;
      }
      m = sv(m);
    }
  }
  function dc(l, u) {
    return l && u ? l === u ? !0 : l && l.nodeType === 3 ? !1 : u && u.nodeType === 3 ? dc(l, u.parentNode) : "contains" in l ? l.contains(u) : l.compareDocumentPosition ? !!(l.compareDocumentPosition(u) & 16) : !1 : !1;
  }
  function hu(l) {
    l = l != null && l.ownerDocument != null && l.ownerDocument.defaultView != null ? l.ownerDocument.defaultView : window;
    for (var u = hr(l.document); u instanceof l.HTMLIFrameElement; ) {
      try {
        var m = typeof u.contentWindow.location.href == "string";
      } catch {
        m = !1;
      }
      if (m) l = u.contentWindow;
      else break;
      u = hr(l.document);
    }
    return u;
  }
  function fm(l) {
    var u = l && l.nodeName && l.nodeName.toLowerCase();
    return u && (u === "input" && (l.type === "text" || l.type === "search" || l.type === "tel" || l.type === "url" || l.type === "password") || u === "textarea" || l.contentEditable === "true");
  }
  var mm = nr && "documentMode" in document && 11 >= document.documentMode, pu = null, Sd = null, qi = null, vl = !1;
  function Ep(l, u, m) {
    var v = m.window === m ? m.document : m.nodeType === 9 ? m : m.ownerDocument;
    vl || pu == null || pu !== hr(v) || (v = pu, "selectionStart" in v && fm(v) ? v = { start: v.selectionStart, end: v.selectionEnd } : (v = (v.ownerDocument && v.ownerDocument.defaultView || window).getSelection(), v = {
      anchorNode: v.anchorNode,
      anchorOffset: v.anchorOffset,
      focusNode: v.focusNode,
      focusOffset: v.focusOffset
    }), qi && Gi(qi, v) || (qi = v, v = lh(Sd, "onSelect"), 0 < v.length && (u = new um(
      "onSelect",
      "select",
      null,
      u,
      m
    ), l.push({ event: u, listeners: v }), u.target = pu)));
  }
  function As(l, u) {
    var m = {};
    return m[l.toLowerCase()] = u.toLowerCase(), m["Webkit" + l] = "webkit" + u, m["Moz" + l] = "moz" + u, m;
  }
  var bl = {
    animationend: As("Animation", "AnimationEnd"),
    animationiteration: As("Animation", "AnimationIteration"),
    animationstart: As("Animation", "AnimationStart"),
    transitionrun: As("Transition", "TransitionRun"),
    transitionstart: As("Transition", "TransitionStart"),
    transitioncancel: As("Transition", "TransitionCancel"),
    transitionend: As("Transition", "TransitionEnd")
  }, Cd = {}, gu = {};
  nr && (gu = document.createElement("div").style, "AnimationEvent" in window || (delete bl.animationend.animation, delete bl.animationiteration.animation, delete bl.animationstart.animation), "TransitionEvent" in window || delete bl.transitionend.transition);
  function cr(l) {
    if (Cd[l]) return Cd[l];
    if (!bl[l]) return l;
    var u = bl[l], m;
    for (m in u)
      if (u.hasOwnProperty(m) && m in gu)
        return Cd[l] = u[m];
    return l;
  }
  var hm = cr("animationend"), cv = cr("animationiteration"), Pp = cr("animationstart"), fc = cr("transitionrun"), pm = cr("transitionstart"), Bl = cr("transitioncancel"), Wb = cr("transitionend"), Ul = /* @__PURE__ */ new Map(), xd = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
    " "
  );
  xd.push("scrollEnd");
  function zo(l, u) {
    Ul.set(l, u), Nr(u, [l]);
  }
  var mc = typeof reportError == "function" ? reportError : function(l) {
    if (typeof window == "object" && typeof window.ErrorEvent == "function") {
      var u = new window.ErrorEvent("error", {
        bubbles: !0,
        cancelable: !0,
        message: typeof l == "object" && l !== null && typeof l.message == "string" ? String(l.message) : String(l),
        error: l
      });
      if (!window.dispatchEvent(u)) return;
    } else if (typeof process == "object" && typeof process.emit == "function") {
      process.emit("uncaughtException", l);
      return;
    }
    console.error(l);
  }, _r = [], _a = 0, Ki = 0;
  function gi() {
    for (var l = _a, u = Ki = _a = 0; u < l; ) {
      var m = _r[u];
      _r[u++] = null;
      var v = _r[u];
      _r[u++] = null;
      var O = _r[u];
      _r[u++] = null;
      var R = _r[u];
      if (_r[u++] = null, v !== null && O !== null) {
        var B = v.pending;
        B === null ? O.next = O : (O.next = B.next, B.next = O), v.pending = O;
      }
      R !== 0 && kp(m, O, R);
    }
  }
  function vi(l, u, m, v) {
    _r[_a++] = l, _r[_a++] = u, _r[_a++] = m, _r[_a++] = v, Ki |= v, l.lanes |= v, l = l.alternate, l !== null && (l.lanes |= v);
  }
  function Yi(l, u, m, v) {
    return vi(l, u, m, v), gm(l);
  }
  function Ns(l, u) {
    return vi(l, null, null, u), gm(l);
  }
  function kp(l, u, m) {
    l.lanes |= m;
    var v = l.alternate;
    v !== null && (v.lanes |= m);
    for (var O = !1, R = l.return; R !== null; )
      R.childLanes |= m, v = R.alternate, v !== null && (v.childLanes |= m), R.tag === 22 && (l = R.stateNode, l === null || l._visibility & 1 || (O = !0)), l = R, R = R.return;
    return l.tag === 3 ? (R = l.stateNode, O && u !== null && (O = 31 - ot(m), l = R.hiddenUpdates, v = l[O], v === null ? l[O] = [u] : v.push(u), u.lane = m | 536870912), R) : null;
  }
  function gm(l) {
    if (50 < Yd)
      throw Yd = 0, Jm = null, Error(a(185));
    for (var u = l.return; u !== null; )
      l = u, u = l.return;
    return l.tag === 3 ? l.stateNode : null;
  }
  var jo = {};
  function Vb(l, u, m, v) {
    this.tag = l, this.key = m, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = u, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = v, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function ca(l, u, m, v) {
    return new Vb(l, u, m, v);
  }
  function hc(l) {
    return l = l.prototype, !(!l || !l.isReactComponent);
  }
  function Ds(l, u) {
    var m = l.alternate;
    return m === null ? (m = ca(
      l.tag,
      u,
      l.key,
      l.mode
    ), m.elementType = l.elementType, m.type = l.type, m.stateNode = l.stateNode, m.alternate = l, l.alternate = m) : (m.pendingProps = u, m.type = l.type, m.flags = 0, m.subtreeFlags = 0, m.deletions = null), m.flags = l.flags & 65011712, m.childLanes = l.childLanes, m.lanes = l.lanes, m.child = l.child, m.memoizedProps = l.memoizedProps, m.memoizedState = l.memoizedState, m.updateQueue = l.updateQueue, u = l.dependencies, m.dependencies = u === null ? null : { lanes: u.lanes, firstContext: u.firstContext }, m.sibling = l.sibling, m.index = l.index, m.ref = l.ref, m.refCleanup = l.refCleanup, m;
  }
  function dv(l, u) {
    l.flags &= 65011714;
    var m = l.alternate;
    return m === null ? (l.childLanes = 0, l.lanes = u, l.child = null, l.subtreeFlags = 0, l.memoizedProps = null, l.memoizedState = null, l.updateQueue = null, l.dependencies = null, l.stateNode = null) : (l.childLanes = m.childLanes, l.lanes = m.lanes, l.child = m.child, l.subtreeFlags = 0, l.deletions = null, l.memoizedProps = m.memoizedProps, l.memoizedState = m.memoizedState, l.updateQueue = m.updateQueue, l.type = m.type, u = m.dependencies, l.dependencies = u === null ? null : {
      lanes: u.lanes,
      firstContext: u.firstContext
    }), l;
  }
  function Mp(l, u, m, v, O, R) {
    var B = 0;
    if (v = l, typeof l == "function") hc(l) && (B = 1);
    else if (typeof l == "string")
      B = $2(
        l,
        m,
        oe.current
      ) ? 26 : l === "html" || l === "head" || l === "body" ? 27 : 5;
    else
      e: switch (l) {
        case _:
          return l = ca(31, m, u, O), l.elementType = _, l.lanes = R, l;
        case k:
          return $s(m.children, O, R, u);
        case M:
          B = 8, O |= 24;
          break;
        case T:
          return l = ca(12, m, u, O | 2), l.elementType = T, l.lanes = R, l;
        case j:
          return l = ca(13, m, u, O), l.elementType = j, l.lanes = R, l;
        case I:
          return l = ca(19, m, u, O), l.elementType = I, l.lanes = R, l;
        default:
          if (typeof l == "object" && l !== null)
            switch (l.$$typeof) {
              case D:
                B = 10;
                break e;
              case N:
                B = 9;
                break e;
              case $:
                B = 11;
                break e;
              case L:
                B = 14;
                break e;
              case F:
                B = 16, v = null;
                break e;
            }
          B = 29, m = Error(
            a(130, l === null ? "null" : typeof l, "")
          ), v = null;
      }
    return u = ca(B, m, u, O), u.elementType = l, u.type = v, u.lanes = R, u;
  }
  function $s(l, u, m, v) {
    return l = ca(7, l, v, u), l.lanes = m, l;
  }
  function Ed(l, u, m) {
    return l = ca(6, l, null, u), l.lanes = m, l;
  }
  function fv(l) {
    var u = ca(18, null, null, 0);
    return u.stateNode = l, u;
  }
  function Op(l, u, m) {
    return u = ca(
      4,
      l.children !== null ? l.children : [],
      l.key,
      u
    ), u.lanes = m, u.stateNode = {
      containerInfo: l.containerInfo,
      pendingChildren: null,
      implementation: l.implementation
    }, u;
  }
  var mv = /* @__PURE__ */ new WeakMap();
  function bi(l, u) {
    if (typeof l == "object" && l !== null) {
      var m = mv.get(l);
      return m !== void 0 ? m : (u = {
        value: l,
        source: u,
        stack: Le(u)
      }, mv.set(l, u), u);
    }
    return {
      value: l,
      source: u,
      stack: Le(u)
    };
  }
  var yi = [], pc = 0, vm = null, va = 0, Jo = [], Io = 0, yl = null, Zo = 1, wl = "";
  function Qi(l, u) {
    yi[pc++] = va, yi[pc++] = vm, vm = l, va = u;
  }
  function hv(l, u, m) {
    Jo[Io++] = Zo, Jo[Io++] = wl, Jo[Io++] = yl, yl = l;
    var v = Zo;
    l = wl;
    var O = 32 - ot(v) - 1;
    v &= ~(1 << O), m += 1;
    var R = 32 - ot(u) + O;
    if (30 < R) {
      var B = O - O % 5;
      R = (v & (1 << B) - 1).toString(32), v >>= B, O -= B, Zo = 1 << 32 - ot(u) + O | m << O | v, wl = R + l;
    } else
      Zo = 1 << R | m << O | v, wl = l;
  }
  function Pd(l) {
    l.return !== null && (Qi(l, 1), hv(l, 1, 0));
  }
  function Tp(l) {
    for (; l === vm; )
      vm = yi[--pc], yi[pc] = null, va = yi[--pc], yi[pc] = null;
    for (; l === yl; )
      yl = Jo[--Io], Jo[Io] = null, wl = Jo[--Io], Jo[Io] = null, Zo = Jo[--Io], Jo[Io] = null;
  }
  function bm(l, u) {
    Jo[Io++] = Zo, Jo[Io++] = wl, Jo[Io++] = yl, Zo = u.id, wl = u.overflow, yl = l;
  }
  var Ba = null, $r = null, _n = !1, Xl = null, $a = !1, Gl = Error(a(519));
  function Ji(l) {
    var u = Error(
      a(
        418,
        1 < arguments.length && arguments[1] !== void 0 && arguments[1] ? "text" : "HTML",
        ""
      )
    );
    throw Md(bi(u, l)), Gl;
  }
  function ym(l) {
    var u = l.stateNode, m = l.type, v = l.memoizedProps;
    switch (u[Gt] = l, u[Dt] = v, m) {
      case "dialog":
        Vn("cancel", u), Vn("close", u);
        break;
      case "iframe":
      case "object":
      case "embed":
        Vn("load", u);
        break;
      case "video":
      case "audio":
        for (m = 0; m < nf.length; m++)
          Vn(nf[m], u);
        break;
      case "source":
        Vn("error", u);
        break;
      case "img":
      case "image":
      case "link":
        Vn("error", u), Vn("load", u);
        break;
      case "details":
        Vn("toggle", u);
        break;
      case "input":
        Vn("invalid", u), nn(
          u,
          v.value,
          v.defaultValue,
          v.checked,
          v.defaultChecked,
          v.type,
          v.name,
          !0
        );
        break;
      case "select":
        Vn("invalid", u);
        break;
      case "textarea":
        Vn("invalid", u), hi(u, v.value, v.defaultValue, v.children);
    }
    m = v.children, typeof m != "string" && typeof m != "number" && typeof m != "bigint" || u.textContent === "" + m || v.suppressHydrationWarning === !0 || x2(u.textContent, m) ? (v.popover != null && (Vn("beforetoggle", u), Vn("toggle", u)), v.onScroll != null && Vn("scroll", u), v.onScrollEnd != null && Vn("scrollend", u), v.onClick != null && (u.onclick = Va), u = !0) : u = !1, u || Ji(l, !0);
  }
  function kd(l) {
    for (Ba = l.return; Ba; )
      switch (Ba.tag) {
        case 5:
        case 31:
        case 13:
          $a = !1;
          return;
        case 27:
        case 3:
          $a = !0;
          return;
        default:
          Ba = Ba.return;
      }
  }
  function ql(l) {
    if (l !== Ba) return !1;
    if (!_n) return kd(l), _n = !0, !1;
    var u = l.tag, m;
    if ((m = u !== 3 && u !== 27) && ((m = u === 5) && (m = l.type, m = !(m !== "form" && m !== "button") || af(l.type, l.memoizedProps)), m = !m), m && $r && Ji(l), kd(l), u === 13) {
      if (l = l.memoizedState, l = l !== null ? l.dehydrated : null, !l) throw Error(a(317));
      $r = Ng(l);
    } else if (u === 31) {
      if (l = l.memoizedState, l = l !== null ? l.dehydrated : null, !l) throw Error(a(317));
      $r = Ng(l);
    } else
      u === 27 ? (u = $r, Al(l.type) ? (l = ch, ch = null, $r = l) : $r = u) : $r = Ba ? Go(l.stateNode.nextSibling) : null;
    return !0;
  }
  function vu() {
    $r = Ba = null, _n = !1;
  }
  function pv() {
    var l = Xl;
    return l !== null && (ta === null ? ta = l : ta.push.apply(
      ta,
      l
    ), Xl = null), l;
  }
  function Md(l) {
    Xl === null ? Xl = [l] : Xl.push(l);
  }
  var Rp = ee(null), zs = null, Sl = null;
  function Lo(l, u, m) {
    ae(Rp, u._currentValue), u._currentValue = m;
  }
  function Cl(l) {
    l._currentValue = Rp.current, ne(Rp);
  }
  function Ap(l, u, m) {
    for (; l !== null; ) {
      var v = l.alternate;
      if ((l.childLanes & u) !== u ? (l.childLanes |= u, v !== null && (v.childLanes |= u)) : v !== null && (v.childLanes & u) !== u && (v.childLanes |= u), l === m) break;
      l = l.return;
    }
  }
  function Kl(l, u, m, v) {
    var O = l.child;
    for (O !== null && (O.return = l); O !== null; ) {
      var R = O.dependencies;
      if (R !== null) {
        var B = O.child;
        R = R.firstContext;
        e: for (; R !== null; ) {
          var re = R;
          R = O;
          for (var ve = 0; ve < u.length; ve++)
            if (re.context === u[ve]) {
              R.lanes |= m, re = R.alternate, re !== null && (re.lanes |= m), Ap(
                R.return,
                m,
                l
              ), v || (B = null);
              break e;
            }
          R = re.next;
        }
      } else if (O.tag === 18) {
        if (B = O.return, B === null) throw Error(a(341));
        B.lanes |= m, R = B.alternate, R !== null && (R.lanes |= m), Ap(B, m, l), B = null;
      } else B = O.child;
      if (B !== null) B.return = O;
      else
        for (B = O; B !== null; ) {
          if (B === l) {
            B = null;
            break;
          }
          if (O = B.sibling, O !== null) {
            O.return = B.return, B = O;
            break;
          }
          B = B.return;
        }
      O = B;
    }
  }
  function Ua(l, u, m, v) {
    l = null;
    for (var O = u, R = !1; O !== null; ) {
      if (!R) {
        if ((O.flags & 524288) !== 0) R = !0;
        else if ((O.flags & 262144) !== 0) break;
      }
      if (O.tag === 10) {
        var B = O.alternate;
        if (B === null) throw Error(a(387));
        if (B = B.memoizedProps, B !== null) {
          var re = O.type;
          Co(O.pendingProps.value, B.value) || (l !== null ? l.push(re) : l = [re]);
        }
      } else if (O === me.current) {
        if (B = O.alternate, B === null) throw Error(a(387));
        B.memoizedState.memoizedState !== O.memoizedState.memoizedState && (l !== null ? l.push(mh) : l = [mh]);
      }
      O = O.return;
    }
    l !== null && Kl(
      u,
      l,
      m,
      v
    ), u.flags |= 262144;
  }
  function gc(l) {
    for (l = l.firstContext; l !== null; ) {
      if (!Co(
        l.context._currentValue,
        l.memoizedValue
      ))
        return !0;
      l = l.next;
    }
    return !1;
  }
  function sn(l) {
    zs = l, Sl = null, l = l.dependencies, l !== null && (l.firstContext = null);
  }
  function rt(l) {
    return wm(zs, l);
  }
  function js(l, u) {
    return zs === null && sn(l), wm(l, u);
  }
  function wm(l, u) {
    var m = u._currentValue;
    if (u = { context: u, memoizedValue: m, next: null }, Sl === null) {
      if (l === null) throw Error(a(308));
      Sl = u, l.dependencies = { lanes: 0, firstContext: u }, l.flags |= 524288;
    } else Sl = Sl.next = u;
    return m;
  }
  var da = typeof AbortController < "u" ? AbortController : function() {
    var l = [], u = this.signal = {
      aborted: !1,
      addEventListener: function(m, v) {
        l.push(v);
      }
    };
    this.abort = function() {
      u.aborted = !0, l.forEach(function(m) {
        return m();
      });
    };
  }, gv = e.unstable_scheduleCallback, vv = e.unstable_NormalPriority, ba = {
    $$typeof: D,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
  };
  function Sm() {
    return {
      controller: new da(),
      data: /* @__PURE__ */ new Map(),
      refCount: 0
    };
  }
  function Cm(l) {
    l.refCount--, l.refCount === 0 && gv(vv, function() {
      l.controller.abort();
    });
  }
  var vc = null, xm = 0, bu = 0, Ma = null;
  function gr(l, u) {
    if (vc === null) {
      var m = vc = [];
      xm = 0, bu = Eg(), Ma = {
        status: "pending",
        value: void 0,
        then: function(v) {
          m.push(v);
        }
      };
    }
    return xm++, u.then(Em, Em), u;
  }
  function Em() {
    if (--xm === 0 && vc !== null) {
      Ma !== null && (Ma.status = "fulfilled");
      var l = vc;
      vc = null, bu = 0, Ma = null;
      for (var u = 0; u < l.length; u++) (0, l[u])();
    }
  }
  function Pm(l, u) {
    var m = [], v = {
      status: "pending",
      value: null,
      reason: null,
      then: function(O) {
        m.push(O);
      }
    };
    return l.then(
      function() {
        v.status = "fulfilled", v.value = u;
        for (var O = 0; O < m.length; O++) (0, m[O])(u);
      },
      function(O) {
        for (v.status = "rejected", v.reason = O, O = 0; O < m.length; O++)
          (0, m[O])(void 0);
      }
    ), v;
  }
  var Is = H.S;
  H.S = function(l, u) {
    c2 = Fe(), typeof u == "object" && u !== null && typeof u.then == "function" && gr(l, u), Is !== null && Is(l, u);
  };
  var wi = ee(null);
  function Si() {
    var l = wi.current;
    return l !== null ? l : kr.pooledCache;
  }
  function Od(l, u) {
    u === null ? ae(wi, wi.current) : ae(wi, u.pool);
  }
  function bc() {
    var l = Si();
    return l === null ? null : { parent: ba._currentValue, pool: l };
  }
  var yu = Error(a(460)), yc = Error(a(474)), Td = Error(a(542)), wc = { then: function() {
  } };
  function bv(l) {
    return l = l.status, l === "fulfilled" || l === "rejected";
  }
  function yv(l, u, m) {
    switch (m = l[m], m === void 0 ? l.push(u) : m !== u && (u.then(Va, Va), u = m), u.status) {
      case "fulfilled":
        return u.value;
      case "rejected":
        throw l = u.reason, Np(l), l;
      default:
        if (typeof u.status == "string") u.then(Va, Va);
        else {
          if (l = kr, l !== null && 100 < l.shellSuspendCounter)
            throw Error(a(482));
          l = u, l.status = "pending", l.then(
            function(v) {
              if (u.status === "pending") {
                var O = u;
                O.status = "fulfilled", O.value = v;
              }
            },
            function(v) {
              if (u.status === "pending") {
                var O = u;
                O.status = "rejected", O.reason = v;
              }
            }
          );
        }
        switch (u.status) {
          case "fulfilled":
            return u.value;
          case "rejected":
            throw l = u.reason, Np(l), l;
        }
        throw Su = u, yu;
    }
  }
  function wu(l) {
    try {
      var u = l._init;
      return u(l._payload);
    } catch (m) {
      throw m !== null && typeof m == "object" && typeof m.then == "function" ? (Su = m, yu) : m;
    }
  }
  var Su = null;
  function wv() {
    if (Su === null) throw Error(a(459));
    var l = Su;
    return Su = null, l;
  }
  function Np(l) {
    if (l === yu || l === Td)
      throw Error(a(483));
  }
  var Cu = null, Sc = 0;
  function km(l) {
    var u = Sc;
    return Sc += 1, Cu === null && (Cu = []), yv(Cu, l, u);
  }
  function Rd(l, u) {
    u = u.props.ref, l.ref = u !== void 0 ? u : null;
  }
  function Mm(l, u) {
    throw u.$$typeof === x ? Error(a(525)) : (l = Object.prototype.toString.call(u), Error(
      a(
        31,
        l === "[object Object]" ? "object with keys {" + Object.keys(u).join(", ") + "}" : l
      )
    ));
  }
  function _b(l) {
    function u($e, Pe) {
      if (l) {
        var Ie = $e.deletions;
        Ie === null ? ($e.deletions = [Pe], $e.flags |= 16) : Ie.push(Pe);
      }
    }
    function m($e, Pe) {
      if (!l) return null;
      for (; Pe !== null; )
        u($e, Pe), Pe = Pe.sibling;
      return null;
    }
    function v($e) {
      for (var Pe = /* @__PURE__ */ new Map(); $e !== null; )
        $e.key !== null ? Pe.set($e.key, $e) : Pe.set($e.index, $e), $e = $e.sibling;
      return Pe;
    }
    function O($e, Pe) {
      return $e = Ds($e, Pe), $e.index = 0, $e.sibling = null, $e;
    }
    function R($e, Pe, Ie) {
      return $e.index = Ie, l ? (Ie = $e.alternate, Ie !== null ? (Ie = Ie.index, Ie < Pe ? ($e.flags |= 67108866, Pe) : Ie) : ($e.flags |= 67108866, Pe)) : ($e.flags |= 1048576, Pe);
    }
    function B($e) {
      return l && $e.alternate === null && ($e.flags |= 67108866), $e;
    }
    function re($e, Pe, Ie, et) {
      return Pe === null || Pe.tag !== 6 ? (Pe = Ed(Ie, $e.mode, et), Pe.return = $e, Pe) : (Pe = O(Pe, Ie), Pe.return = $e, Pe);
    }
    function ve($e, Pe, Ie, et) {
      var Vt = Ie.type;
      return Vt === k ? Je(
        $e,
        Pe,
        Ie.props.children,
        et,
        Ie.key
      ) : Pe !== null && (Pe.elementType === Vt || typeof Vt == "object" && Vt !== null && Vt.$$typeof === F && wu(Vt) === Pe.type) ? (Pe = O(Pe, Ie.props), Rd(Pe, Ie), Pe.return = $e, Pe) : (Pe = Mp(
        Ie.type,
        Ie.key,
        Ie.props,
        null,
        $e.mode,
        et
      ), Rd(Pe, Ie), Pe.return = $e, Pe);
    }
    function He($e, Pe, Ie, et) {
      return Pe === null || Pe.tag !== 4 || Pe.stateNode.containerInfo !== Ie.containerInfo || Pe.stateNode.implementation !== Ie.implementation ? (Pe = Op(Ie, $e.mode, et), Pe.return = $e, Pe) : (Pe = O(Pe, Ie.children || []), Pe.return = $e, Pe);
    }
    function Je($e, Pe, Ie, et, Vt) {
      return Pe === null || Pe.tag !== 7 ? (Pe = $s(
        Ie,
        $e.mode,
        et,
        Vt
      ), Pe.return = $e, Pe) : (Pe = O(Pe, Ie), Pe.return = $e, Pe);
    }
    function nt($e, Pe, Ie) {
      if (typeof Pe == "string" && Pe !== "" || typeof Pe == "number" || typeof Pe == "bigint")
        return Pe = Ed(
          "" + Pe,
          $e.mode,
          Ie
        ), Pe.return = $e, Pe;
      if (typeof Pe == "object" && Pe !== null) {
        switch (Pe.$$typeof) {
          case E:
            return Ie = Mp(
              Pe.type,
              Pe.key,
              Pe.props,
              null,
              $e.mode,
              Ie
            ), Rd(Ie, Pe), Ie.return = $e, Ie;
          case P:
            return Pe = Op(
              Pe,
              $e.mode,
              Ie
            ), Pe.return = $e, Pe;
          case F:
            return Pe = wu(Pe), nt($e, Pe, Ie);
        }
        if (J(Pe) || U(Pe))
          return Pe = $s(
            Pe,
            $e.mode,
            Ie,
            null
          ), Pe.return = $e, Pe;
        if (typeof Pe.then == "function")
          return nt($e, km(Pe), Ie);
        if (Pe.$$typeof === D)
          return nt(
            $e,
            js($e, Pe),
            Ie
          );
        Mm($e, Pe);
      }
      return null;
    }
    function We($e, Pe, Ie, et) {
      var Vt = Pe !== null ? Pe.key : null;
      if (typeof Ie == "string" && Ie !== "" || typeof Ie == "number" || typeof Ie == "bigint")
        return Vt !== null ? null : re($e, Pe, "" + Ie, et);
      if (typeof Ie == "object" && Ie !== null) {
        switch (Ie.$$typeof) {
          case E:
            return Ie.key === Vt ? ve($e, Pe, Ie, et) : null;
          case P:
            return Ie.key === Vt ? He($e, Pe, Ie, et) : null;
          case F:
            return Ie = wu(Ie), We($e, Pe, Ie, et);
        }
        if (J(Ie) || U(Ie))
          return Vt !== null ? null : Je($e, Pe, Ie, et, null);
        if (typeof Ie.then == "function")
          return We(
            $e,
            Pe,
            km(Ie),
            et
          );
        if (Ie.$$typeof === D)
          return We(
            $e,
            Pe,
            js($e, Ie),
            et
          );
        Mm($e, Ie);
      }
      return null;
    }
    function Ge($e, Pe, Ie, et, Vt) {
      if (typeof et == "string" && et !== "" || typeof et == "number" || typeof et == "bigint")
        return $e = $e.get(Ie) || null, re(Pe, $e, "" + et, Vt);
      if (typeof et == "object" && et !== null) {
        switch (et.$$typeof) {
          case E:
            return $e = $e.get(
              et.key === null ? Ie : et.key
            ) || null, ve(Pe, $e, et, Vt);
          case P:
            return $e = $e.get(
              et.key === null ? Ie : et.key
            ) || null, He(Pe, $e, et, Vt);
          case F:
            return et = wu(et), Ge(
              $e,
              Pe,
              Ie,
              et,
              Vt
            );
        }
        if (J(et) || U(et))
          return $e = $e.get(Ie) || null, Je(Pe, $e, et, Vt, null);
        if (typeof et.then == "function")
          return Ge(
            $e,
            Pe,
            Ie,
            km(et),
            Vt
          );
        if (et.$$typeof === D)
          return Ge(
            $e,
            Pe,
            Ie,
            js(Pe, et),
            Vt
          );
        Mm(Pe, et);
      }
      return null;
    }
    function At($e, Pe, Ie, et) {
      for (var Vt = null, rr = null, jt = Pe, vn = Pe = 0, Pn = null; jt !== null && vn < Ie.length; vn++) {
        jt.index > vn ? (Pn = jt, jt = null) : Pn = jt.sibling;
        var lr = We(
          $e,
          jt,
          Ie[vn],
          et
        );
        if (lr === null) {
          jt === null && (jt = Pn);
          break;
        }
        l && jt && lr.alternate === null && u($e, jt), Pe = R(lr, Pe, vn), rr === null ? Vt = lr : rr.sibling = lr, rr = lr, jt = Pn;
      }
      if (vn === Ie.length)
        return m($e, jt), _n && Qi($e, vn), Vt;
      if (jt === null) {
        for (; vn < Ie.length; vn++)
          jt = nt($e, Ie[vn], et), jt !== null && (Pe = R(
            jt,
            Pe,
            vn
          ), rr === null ? Vt = jt : rr.sibling = jt, rr = jt);
        return _n && Qi($e, vn), Vt;
      }
      for (jt = v(jt); vn < Ie.length; vn++)
        Pn = Ge(
          jt,
          $e,
          vn,
          Ie[vn],
          et
        ), Pn !== null && (l && Pn.alternate !== null && jt.delete(
          Pn.key === null ? vn : Pn.key
        ), Pe = R(
          Pn,
          Pe,
          vn
        ), rr === null ? Vt = Pn : rr.sibling = Pn, rr = Pn);
      return l && jt.forEach(function($l) {
        return u($e, $l);
      }), _n && Qi($e, vn), Vt;
    }
    function Zt($e, Pe, Ie, et) {
      if (Ie == null) throw Error(a(151));
      for (var Vt = null, rr = null, jt = Pe, vn = Pe = 0, Pn = null, lr = Ie.next(); jt !== null && !lr.done; vn++, lr = Ie.next()) {
        jt.index > vn ? (Pn = jt, jt = null) : Pn = jt.sibling;
        var $l = We($e, jt, lr.value, et);
        if ($l === null) {
          jt === null && (jt = Pn);
          break;
        }
        l && jt && $l.alternate === null && u($e, jt), Pe = R($l, Pe, vn), rr === null ? Vt = $l : rr.sibling = $l, rr = $l, jt = Pn;
      }
      if (lr.done)
        return m($e, jt), _n && Qi($e, vn), Vt;
      if (jt === null) {
        for (; !lr.done; vn++, lr = Ie.next())
          lr = nt($e, lr.value, et), lr !== null && (Pe = R(lr, Pe, vn), rr === null ? Vt = lr : rr.sibling = lr, rr = lr);
        return _n && Qi($e, vn), Vt;
      }
      for (jt = v(jt); !lr.done; vn++, lr = Ie.next())
        lr = Ge(jt, $e, vn, lr.value, et), lr !== null && (l && lr.alternate !== null && jt.delete(lr.key === null ? vn : lr.key), Pe = R(lr, Pe, vn), rr === null ? Vt = lr : rr.sibling = lr, rr = lr);
      return l && jt.forEach(function(Gy) {
        return u($e, Gy);
      }), _n && Qi($e, vn), Vt;
    }
    function Or($e, Pe, Ie, et) {
      if (typeof Ie == "object" && Ie !== null && Ie.type === k && Ie.key === null && (Ie = Ie.props.children), typeof Ie == "object" && Ie !== null) {
        switch (Ie.$$typeof) {
          case E:
            e: {
              for (var Vt = Ie.key; Pe !== null; ) {
                if (Pe.key === Vt) {
                  if (Vt = Ie.type, Vt === k) {
                    if (Pe.tag === 7) {
                      m(
                        $e,
                        Pe.sibling
                      ), et = O(
                        Pe,
                        Ie.props.children
                      ), et.return = $e, $e = et;
                      break e;
                    }
                  } else if (Pe.elementType === Vt || typeof Vt == "object" && Vt !== null && Vt.$$typeof === F && wu(Vt) === Pe.type) {
                    m(
                      $e,
                      Pe.sibling
                    ), et = O(Pe, Ie.props), Rd(et, Ie), et.return = $e, $e = et;
                    break e;
                  }
                  m($e, Pe);
                  break;
                } else u($e, Pe);
                Pe = Pe.sibling;
              }
              Ie.type === k ? (et = $s(
                Ie.props.children,
                $e.mode,
                et,
                Ie.key
              ), et.return = $e, $e = et) : (et = Mp(
                Ie.type,
                Ie.key,
                Ie.props,
                null,
                $e.mode,
                et
              ), Rd(et, Ie), et.return = $e, $e = et);
            }
            return B($e);
          case P:
            e: {
              for (Vt = Ie.key; Pe !== null; ) {
                if (Pe.key === Vt)
                  if (Pe.tag === 4 && Pe.stateNode.containerInfo === Ie.containerInfo && Pe.stateNode.implementation === Ie.implementation) {
                    m(
                      $e,
                      Pe.sibling
                    ), et = O(Pe, Ie.children || []), et.return = $e, $e = et;
                    break e;
                  } else {
                    m($e, Pe);
                    break;
                  }
                else u($e, Pe);
                Pe = Pe.sibling;
              }
              et = Op(Ie, $e.mode, et), et.return = $e, $e = et;
            }
            return B($e);
          case F:
            return Ie = wu(Ie), Or(
              $e,
              Pe,
              Ie,
              et
            );
        }
        if (J(Ie))
          return At(
            $e,
            Pe,
            Ie,
            et
          );
        if (U(Ie)) {
          if (Vt = U(Ie), typeof Vt != "function") throw Error(a(150));
          return Ie = Vt.call(Ie), Zt(
            $e,
            Pe,
            Ie,
            et
          );
        }
        if (typeof Ie.then == "function")
          return Or(
            $e,
            Pe,
            km(Ie),
            et
          );
        if (Ie.$$typeof === D)
          return Or(
            $e,
            Pe,
            js($e, Ie),
            et
          );
        Mm($e, Ie);
      }
      return typeof Ie == "string" && Ie !== "" || typeof Ie == "number" || typeof Ie == "bigint" ? (Ie = "" + Ie, Pe !== null && Pe.tag === 6 ? (m($e, Pe.sibling), et = O(Pe, Ie), et.return = $e, $e = et) : (m($e, Pe), et = Ed(Ie, $e.mode, et), et.return = $e, $e = et), B($e)) : m($e, Pe);
    }
    return function($e, Pe, Ie, et) {
      try {
        Sc = 0;
        var Vt = Or(
          $e,
          Pe,
          Ie,
          et
        );
        return Cu = null, Vt;
      } catch (jt) {
        if (jt === yu || jt === Td) throw jt;
        var rr = ca(29, jt, null, $e.mode);
        return rr.lanes = et, rr.return = $e, rr;
      } finally {
      }
    };
  }
  var xu = _b(!0), Sv = _b(!1), Ls = !1;
  function Om(l) {
    l.updateQueue = {
      baseState: l.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: { pending: null, lanes: 0, hiddenCallbacks: null },
      callbacks: null
    };
  }
  function Dp(l, u) {
    l = l.updateQueue, u.updateQueue === l && (u.updateQueue = {
      baseState: l.baseState,
      firstBaseUpdate: l.firstBaseUpdate,
      lastBaseUpdate: l.lastBaseUpdate,
      shared: l.shared,
      callbacks: null
    });
  }
  function Hs(l) {
    return { lane: l, tag: 0, payload: null, callback: null, next: null };
  }
  function Ci(l, u, m) {
    var v = l.updateQueue;
    if (v === null) return null;
    if (v = v.shared, (ir & 2) !== 0) {
      var O = v.pending;
      return O === null ? u.next = u : (u.next = O.next, O.next = u), v.pending = u, u = gm(l), kp(l, null, m), u;
    }
    return vi(l, v, u, m), gm(l);
  }
  function Eu(l, u, m) {
    if (u = u.updateQueue, u !== null && (u = u.shared, (m & 4194048) !== 0)) {
      var v = u.lanes;
      v &= l.pendingLanes, m |= v, u.lanes = m, Lt(l, m);
    }
  }
  function $p(l, u) {
    var m = l.updateQueue, v = l.alternate;
    if (v !== null && (v = v.updateQueue, m === v)) {
      var O = null, R = null;
      if (m = m.firstBaseUpdate, m !== null) {
        do {
          var B = {
            lane: m.lane,
            tag: m.tag,
            payload: m.payload,
            callback: null,
            next: null
          };
          R === null ? O = R = B : R = R.next = B, m = m.next;
        } while (m !== null);
        R === null ? O = R = u : R = R.next = u;
      } else O = R = u;
      m = {
        baseState: v.baseState,
        firstBaseUpdate: O,
        lastBaseUpdate: R,
        shared: v.shared,
        callbacks: v.callbacks
      }, l.updateQueue = m;
      return;
    }
    l = m.lastBaseUpdate, l === null ? m.firstBaseUpdate = u : l.next = u, m.lastBaseUpdate = u;
  }
  var Cv = !1;
  function Pu() {
    if (Cv) {
      var l = Ma;
      if (l !== null) throw l;
    }
  }
  function Yl(l, u, m, v) {
    Cv = !1;
    var O = l.updateQueue;
    Ls = !1;
    var R = O.firstBaseUpdate, B = O.lastBaseUpdate, re = O.shared.pending;
    if (re !== null) {
      O.shared.pending = null;
      var ve = re, He = ve.next;
      ve.next = null, B === null ? R = He : B.next = He, B = ve;
      var Je = l.alternate;
      Je !== null && (Je = Je.updateQueue, re = Je.lastBaseUpdate, re !== B && (re === null ? Je.firstBaseUpdate = He : re.next = He, Je.lastBaseUpdate = ve));
    }
    if (R !== null) {
      var nt = O.baseState;
      B = 0, Je = He = ve = null, re = R;
      do {
        var We = re.lane & -536870913, Ge = We !== re.lane;
        if (Ge ? (In & We) === We : (v & We) === We) {
          We !== 0 && We === bu && (Cv = !0), Je !== null && (Je = Je.next = {
            lane: 0,
            tag: re.tag,
            payload: re.payload,
            callback: null,
            next: null
          });
          e: {
            var At = l, Zt = re;
            We = u;
            var Or = m;
            switch (Zt.tag) {
              case 1:
                if (At = Zt.payload, typeof At == "function") {
                  nt = At.call(Or, nt, We);
                  break e;
                }
                nt = At;
                break e;
              case 3:
                At.flags = At.flags & -65537 | 128;
              case 0:
                if (At = Zt.payload, We = typeof At == "function" ? At.call(Or, nt, We) : At, We == null) break e;
                nt = w({}, nt, We);
                break e;
              case 2:
                Ls = !0;
            }
          }
          We = re.callback, We !== null && (l.flags |= 64, Ge && (l.flags |= 8192), Ge = O.callbacks, Ge === null ? O.callbacks = [We] : Ge.push(We));
        } else
          Ge = {
            lane: We,
            tag: re.tag,
            payload: re.payload,
            callback: re.callback,
            next: null
          }, Je === null ? (He = Je = Ge, ve = nt) : Je = Je.next = Ge, B |= We;
        if (re = re.next, re === null) {
          if (re = O.shared.pending, re === null)
            break;
          Ge = re, re = Ge.next, Ge.next = null, O.lastBaseUpdate = Ge, O.shared.pending = null;
        }
      } while (!0);
      Je === null && (ve = nt), O.baseState = ve, O.firstBaseUpdate = He, O.lastBaseUpdate = Je, R === null && (O.shared.lanes = 0), Tl |= B, l.lanes = B, l.memoizedState = nt;
    }
  }
  function zp(l, u) {
    if (typeof l != "function")
      throw Error(a(191, l));
    l.call(u);
  }
  function ku(l, u) {
    var m = l.callbacks;
    if (m !== null)
      for (l.callbacks = null, l = 0; l < m.length; l++)
        zp(m[l], u);
  }
  var za = ee(null), Cc = ee(0);
  function Bb(l, u) {
    l = Ol, ae(Cc, l), ae(za, u), Ol = l | u.baseLanes;
  }
  function Tm() {
    ae(Cc, Ol), ae(za, za.current);
  }
  function Ad() {
    Ol = Cc.current, ne(za), ne(Cc);
  }
  var Ho = ee(null), Hi = null;
  function Ql(l) {
    var u = l.alternate;
    ae(Br, Br.current & 1), ae(Ho, l), Hi === null && (u === null || za.current !== null || u.memoizedState !== null) && (Hi = l);
  }
  function Nd(l) {
    ae(Br, Br.current), ae(Ho, l), Hi === null && (Hi = l);
  }
  function jp(l) {
    l.tag === 22 ? (ae(Br, Br.current), ae(Ho, l), Hi === null && (Hi = l)) : xl();
  }
  function xl() {
    ae(Br, Br.current), ae(Ho, Ho.current);
  }
  function Fo(l) {
    ne(Ho), Hi === l && (Hi = null), ne(Br);
  }
  var Br = ee(0);
  function Dd(l) {
    for (var u = l; u !== null; ) {
      if (u.tag === 13) {
        var m = u.memoizedState;
        if (m !== null && (m = m.dehydrated, m === null || nl(m) || Lu(m)))
          return u;
      } else if (u.tag === 19 && (u.memoizedProps.revealOrder === "forwards" || u.memoizedProps.revealOrder === "backwards" || u.memoizedProps.revealOrder === "unstable_legacy-backwards" || u.memoizedProps.revealOrder === "together")) {
        if ((u.flags & 128) !== 0) return u;
      } else if (u.child !== null) {
        u.child.return = u, u = u.child;
        continue;
      }
      if (u === l) break;
      for (; u.sibling === null; ) {
        if (u.return === null || u.return === l) return null;
        u = u.return;
      }
      u.sibling.return = u.return, u = u.sibling;
    }
    return null;
  }
  var Jl = 0, Sn = null, vr = null, ya = null, xc = !1, Ec = !1, Fs = !1, Rm = 0, $d = 0, Mu = null, Ub = 0;
  function Zr() {
    throw Error(a(321));
  }
  function Ws(l, u) {
    if (u === null) return !1;
    for (var m = 0; m < u.length && m < l.length; m++)
      if (!Co(l[m], u[m])) return !1;
    return !0;
  }
  function Am(l, u, m, v, O, R) {
    return Jl = R, Sn = u, u.memoizedState = null, u.updateQueue = null, u.lanes = 0, H.H = l === null || l.memoizedState === null ? Zb : Zp, Fs = !1, R = m(v, O), Fs = !1, Ec && (R = Xb(
      u,
      m,
      v,
      O
    )), Ip(l), R;
  }
  function Ip(l) {
    H.H = Fm;
    var u = vr !== null && vr.next !== null;
    if (Jl = 0, ya = vr = Sn = null, xc = !1, $d = 0, Mu = null, u) throw Error(a(300));
    l === null || wa || (l = l.dependencies, l !== null && gc(l) && (wa = !0));
  }
  function Xb(l, u, m, v) {
    Sn = l;
    var O = 0;
    do {
      if (Ec && (Mu = null), $d = 0, Ec = !1, 25 <= O) throw Error(a(301));
      if (O += 1, ya = vr = null, l.updateQueue != null) {
        var R = l.updateQueue;
        R.lastEffect = null, R.events = null, R.stores = null, R.memoCache != null && (R.memoCache.index = 0);
      }
      H.H = ey, R = u(m, v);
    } while (Ec);
    return R;
  }
  function gC() {
    var l = H.H, u = l.useState()[0];
    return u = typeof u.then == "function" ? kc(u) : u, l = l.useState()[0], (vr !== null ? vr.memoizedState : null) !== l && (Sn.flags |= 1024), u;
  }
  function Lp() {
    var l = Rm !== 0;
    return Rm = 0, l;
  }
  function Pc(l, u, m) {
    u.updateQueue = l.updateQueue, u.flags &= -2053, l.lanes &= ~m;
  }
  function Nm(l) {
    if (xc) {
      for (l = l.memoizedState; l !== null; ) {
        var u = l.queue;
        u !== null && (u.pending = null), l = l.next;
      }
      xc = !1;
    }
    Jl = 0, ya = vr = Sn = null, Ec = !1, $d = Rm = 0, Mu = null;
  }
  function Xa() {
    var l = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null
    };
    return ya === null ? Sn.memoizedState = ya = l : ya = ya.next = l, ya;
  }
  function fa() {
    if (vr === null) {
      var l = Sn.alternate;
      l = l !== null ? l.memoizedState : null;
    } else l = vr.next;
    var u = ya === null ? Sn.memoizedState : ya.next;
    if (u !== null)
      ya = u, vr = l;
    else {
      if (l === null)
        throw Sn.alternate === null ? Error(a(467)) : Error(a(310));
      vr = l, l = {
        memoizedState: vr.memoizedState,
        baseState: vr.baseState,
        baseQueue: vr.baseQueue,
        queue: vr.queue,
        next: null
      }, ya === null ? Sn.memoizedState = ya = l : ya = ya.next = l;
    }
    return ya;
  }
  function Dm() {
    return { lastEffect: null, events: null, stores: null, memoCache: null };
  }
  function kc(l) {
    var u = $d;
    return $d += 1, Mu === null && (Mu = []), l = yv(Mu, l, u), u = Sn, (ya === null ? u.memoizedState : ya.next) === null && (u = u.alternate, H.H = u === null || u.memoizedState === null ? Zb : Zp), l;
  }
  function zd(l) {
    if (l !== null && typeof l == "object") {
      if (typeof l.then == "function") return kc(l);
      if (l.$$typeof === D) return rt(l);
    }
    throw Error(a(438, String(l)));
  }
  function Hp(l) {
    var u = null, m = Sn.updateQueue;
    if (m !== null && (u = m.memoCache), u == null) {
      var v = Sn.alternate;
      v !== null && (v = v.updateQueue, v !== null && (v = v.memoCache, v != null && (u = {
        data: v.data.map(function(O) {
          return O.slice();
        }),
        index: 0
      })));
    }
    if (u == null && (u = { data: [], index: 0 }), m === null && (m = Dm(), Sn.updateQueue = m), m.memoCache = u, m = u.data[u.index], m === void 0)
      for (m = u.data[u.index] = Array(l), v = 0; v < l; v++)
        m[v] = W;
    return u.index++, m;
  }
  function Zl(l, u) {
    return typeof u == "function" ? u(l) : u;
  }
  function es(l) {
    var u = fa();
    return Fp(u, vr, l);
  }
  function Fp(l, u, m) {
    var v = l.queue;
    if (v === null) throw Error(a(311));
    v.lastRenderedReducer = m;
    var O = l.baseQueue, R = v.pending;
    if (R !== null) {
      if (O !== null) {
        var B = O.next;
        O.next = R.next, R.next = B;
      }
      u.baseQueue = O = R, v.pending = null;
    }
    if (R = l.baseState, O === null) l.memoizedState = R;
    else {
      u = O.next;
      var re = B = null, ve = null, He = u, Je = !1;
      do {
        var nt = He.lane & -536870913;
        if (nt !== He.lane ? (In & nt) === nt : (Jl & nt) === nt) {
          var We = He.revertLane;
          if (We === 0)
            ve !== null && (ve = ve.next = {
              lane: 0,
              revertLane: 0,
              gesture: null,
              action: He.action,
              hasEagerState: He.hasEagerState,
              eagerState: He.eagerState,
              next: null
            }), nt === bu && (Je = !0);
          else if ((Jl & We) === We) {
            He = He.next, We === bu && (Je = !0);
            continue;
          } else
            nt = {
              lane: 0,
              revertLane: He.revertLane,
              gesture: null,
              action: He.action,
              hasEagerState: He.hasEagerState,
              eagerState: He.eagerState,
              next: null
            }, ve === null ? (re = ve = nt, B = R) : ve = ve.next = nt, Sn.lanes |= We, Tl |= We;
          nt = He.action, Fs && m(R, nt), R = He.hasEagerState ? He.eagerState : m(R, nt);
        } else
          We = {
            lane: nt,
            revertLane: He.revertLane,
            gesture: He.gesture,
            action: He.action,
            hasEagerState: He.hasEagerState,
            eagerState: He.eagerState,
            next: null
          }, ve === null ? (re = ve = We, B = R) : ve = ve.next = We, Sn.lanes |= nt, Tl |= nt;
        He = He.next;
      } while (He !== null && He !== u);
      if (ve === null ? B = R : ve.next = re, !Co(R, l.memoizedState) && (wa = !0, Je && (m = Ma, m !== null)))
        throw m;
      l.memoizedState = R, l.baseState = B, l.baseQueue = ve, v.lastRenderedState = R;
    }
    return O === null && (v.lanes = 0), [l.memoizedState, v.dispatch];
  }
  function Wp(l) {
    var u = fa(), m = u.queue;
    if (m === null) throw Error(a(311));
    m.lastRenderedReducer = l;
    var v = m.dispatch, O = m.pending, R = u.memoizedState;
    if (O !== null) {
      m.pending = null;
      var B = O = O.next;
      do
        R = l(R, B.action), B = B.next;
      while (B !== O);
      Co(R, u.memoizedState) || (wa = !0), u.memoizedState = R, u.baseQueue === null && (u.baseState = R), m.lastRenderedState = R;
    }
    return [R, v];
  }
  function xv(l, u, m) {
    var v = Sn, O = fa(), R = _n;
    if (R) {
      if (m === void 0) throw Error(a(407));
      m = m();
    } else m = u();
    var B = !Co(
      (vr || O).memoizedState,
      m
    );
    if (B && (O.memoizedState = m, wa = !0), O = O.queue, Xp(Vp.bind(null, v, O, l), [
      l
    ]), O.getSnapshot !== u || B || ya !== null && ya.memoizedState.tag & 1) {
      if (v.flags |= 2048, Oc(
        9,
        { destroy: void 0 },
        Ev.bind(
          null,
          v,
          O,
          m,
          u
        ),
        null
      ), kr === null) throw Error(a(349));
      R || (Jl & 127) !== 0 || $m(v, u, m);
    }
    return m;
  }
  function $m(l, u, m) {
    l.flags |= 16384, l = { getSnapshot: u, value: m }, u = Sn.updateQueue, u === null ? (u = Dm(), Sn.updateQueue = u, u.stores = [l]) : (m = u.stores, m === null ? u.stores = [l] : m.push(l));
  }
  function Ev(l, u, m, v) {
    u.value = m, u.getSnapshot = v, _p(u) && Bp(l);
  }
  function Vp(l, u, m) {
    return m(function() {
      _p(u) && Bp(l);
    });
  }
  function _p(l) {
    var u = l.getSnapshot;
    l = l.value;
    try {
      var m = u();
      return !Co(l, m);
    } catch {
      return !0;
    }
  }
  function Bp(l) {
    var u = Ns(l, 2);
    u !== null && Xo(u, l, 2);
  }
  function Pv(l) {
    var u = Xa();
    if (typeof l == "function") {
      var m = l;
      if (l = m(), Fs) {
        ht(!0);
        try {
          m();
        } finally {
          ht(!1);
        }
      }
    }
    return u.memoizedState = u.baseState = l, u.queue = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: Zl,
      lastRenderedState: l
    }, u;
  }
  function Ga(l, u, m, v) {
    return l.baseState = m, Fp(
      l,
      vr,
      typeof v == "function" ? v : Zl
    );
  }
  function Gb(l, u, m, v, O) {
    if (Hm(l)) throw Error(a(485));
    if (l = u.action, l !== null) {
      var R = {
        payload: O,
        action: l,
        next: null,
        isTransition: !0,
        status: "pending",
        value: null,
        reason: null,
        listeners: [],
        then: function(B) {
          R.listeners.push(B);
        }
      };
      H.T !== null ? m(!0) : R.isTransition = !1, v(R), m = u.pending, m === null ? (R.next = u.pending = R, kv(u, R)) : (R.next = m.next, u.pending = m.next = R);
    }
  }
  function kv(l, u) {
    var m = u.action, v = u.payload, O = l.state;
    if (u.isTransition) {
      var R = H.T, B = {};
      H.T = B;
      try {
        var re = m(O, v), ve = H.S;
        ve !== null && ve(B, re), Mv(l, u, re);
      } catch (He) {
        Mc(l, u, He);
      } finally {
        R !== null && B.types !== null && (R.types = B.types), H.T = R;
      }
    } else
      try {
        R = m(O, v), Mv(l, u, R);
      } catch (He) {
        Mc(l, u, He);
      }
  }
  function Mv(l, u, m) {
    m !== null && typeof m == "object" && typeof m.then == "function" ? m.then(
      function(v) {
        Ov(l, u, v);
      },
      function(v) {
        return Mc(l, u, v);
      }
    ) : Ov(l, u, m);
  }
  function Ov(l, u, m) {
    u.status = "fulfilled", u.value = m, Tv(u), l.state = m, u = l.pending, u !== null && (m = u.next, m === u ? l.pending = null : (m = m.next, u.next = m, kv(l, m)));
  }
  function Mc(l, u, m) {
    var v = l.pending;
    if (l.pending = null, v !== null) {
      v = v.next;
      do
        u.status = "rejected", u.reason = m, Tv(u), u = u.next;
      while (u !== v);
    }
    l.action = null;
  }
  function Tv(l) {
    l = l.listeners;
    for (var u = 0; u < l.length; u++) (0, l[u])();
  }
  function zm(l, u) {
    return u;
  }
  function Rv(l, u) {
    if (_n) {
      var m = kr.formState;
      if (m !== null) {
        e: {
          var v = Sn;
          if (_n) {
            if ($r) {
              t: {
                for (var O = $r, R = $a; O.nodeType !== 8; ) {
                  if (!R) {
                    O = null;
                    break t;
                  }
                  if (O = Go(
                    O.nextSibling
                  ), O === null) {
                    O = null;
                    break t;
                  }
                }
                R = O.data, O = R === "F!" || R === "F" ? O : null;
              }
              if (O) {
                $r = Go(
                  O.nextSibling
                ), v = O.data === "F!";
                break e;
              }
            }
            Ji(v);
          }
          v = !1;
        }
        v && (u = m[0]);
      }
    }
    return m = Xa(), m.memoizedState = m.baseState = u, v = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: zm,
      lastRenderedState: u
    }, m.queue = v, m = Qp.bind(
      null,
      Sn,
      v
    ), v.dispatch = m, v = Pv(!1), R = Ou.bind(
      null,
      Sn,
      !1,
      v.queue
    ), v = Xa(), O = {
      state: u,
      dispatch: null,
      action: l,
      pending: null
    }, v.queue = O, m = Gb.bind(
      null,
      Sn,
      O,
      R,
      m
    ), O.dispatch = m, v.memoizedState = l, [u, m, !1];
  }
  function qb(l) {
    var u = fa();
    return jm(u, vr, l);
  }
  function jm(l, u, m) {
    if (u = Fp(
      l,
      u,
      zm
    )[0], l = es(Zl)[0], typeof u == "object" && u !== null && typeof u.then == "function")
      try {
        var v = kc(u);
      } catch (B) {
        throw B === yu ? Td : B;
      }
    else v = u;
    u = fa();
    var O = u.queue, R = O.dispatch;
    return m !== u.memoizedState && (Sn.flags |= 2048, Oc(
      9,
      { destroy: void 0 },
      Av.bind(null, O, m),
      null
    )), [v, R, l];
  }
  function Av(l, u) {
    l.action = u;
  }
  function Nv(l) {
    var u = fa(), m = vr;
    if (m !== null)
      return jm(u, m, l);
    fa(), u = u.memoizedState, m = fa();
    var v = m.queue.dispatch;
    return m.memoizedState = l, [u, v, !1];
  }
  function Oc(l, u, m, v) {
    return l = { tag: l, create: m, deps: v, inst: u, next: null }, u = Sn.updateQueue, u === null && (u = Dm(), Sn.updateQueue = u), m = u.lastEffect, m === null ? u.lastEffect = l.next = l : (v = m.next, m.next = l, l.next = v, u.lastEffect = l), l;
  }
  function Dv() {
    return fa().memoizedState;
  }
  function jd(l, u, m, v) {
    var O = Xa();
    Sn.flags |= l, O.memoizedState = Oc(
      1 | u,
      { destroy: void 0 },
      m,
      v === void 0 ? null : v
    );
  }
  function Id(l, u, m, v) {
    var O = fa();
    v = v === void 0 ? null : v;
    var R = O.memoizedState.inst;
    vr !== null && v !== null && Ws(v, vr.memoizedState.deps) ? O.memoizedState = Oc(u, R, m, v) : (Sn.flags |= l, O.memoizedState = Oc(
      1 | u,
      R,
      m,
      v
    ));
  }
  function Up(l, u) {
    jd(8390656, 8, l, u);
  }
  function Xp(l, u) {
    Id(2048, 8, l, u);
  }
  function $v(l) {
    Sn.flags |= 4;
    var u = Sn.updateQueue;
    if (u === null)
      u = Dm(), Sn.updateQueue = u, u.events = [l];
    else {
      var m = u.events;
      m === null ? u.events = [l] : m.push(l);
    }
  }
  function Im(l) {
    var u = fa().memoizedState;
    return $v({ ref: u, nextImpl: l }), function() {
      if ((ir & 2) !== 0) throw Error(a(440));
      return u.impl.apply(void 0, arguments);
    };
  }
  function Gp(l, u) {
    return Id(4, 2, l, u);
  }
  function zv(l, u) {
    return Id(4, 4, l, u);
  }
  function qp(l, u) {
    if (typeof u == "function") {
      l = l();
      var m = u(l);
      return function() {
        typeof m == "function" ? m() : u(null);
      };
    }
    if (u != null)
      return l = l(), u.current = l, function() {
        u.current = null;
      };
  }
  function jv(l, u, m) {
    m = m != null ? m.concat([l]) : null, Id(4, 4, qp.bind(null, u, l), m);
  }
  function El() {
  }
  function Kp(l, u) {
    var m = fa();
    u = u === void 0 ? null : u;
    var v = m.memoizedState;
    return u !== null && Ws(u, v[1]) ? v[0] : (m.memoizedState = [l, u], l);
  }
  function Kb(l, u) {
    var m = fa();
    u = u === void 0 ? null : u;
    var v = m.memoizedState;
    if (u !== null && Ws(u, v[1]))
      return v[0];
    if (v = l(), Fs) {
      ht(!0);
      try {
        l();
      } finally {
        ht(!1);
      }
    }
    return m.memoizedState = [v, u], v;
  }
  function Lm(l, u, m) {
    return m === void 0 || (Jl & 1073741824) !== 0 && (In & 261930) === 0 ? l.memoizedState = u : (l.memoizedState = m, l = cy(), Sn.lanes |= l, Tl |= l, m);
  }
  function ts(l, u, m, v) {
    return Co(m, u) ? m : za.current !== null ? (l = Lm(l, m, v), Co(l, u) || (wa = !0), l) : (Jl & 42) === 0 || (Jl & 1073741824) !== 0 && (In & 261930) === 0 ? (wa = !0, l.memoizedState = m) : (l = cy(), Sn.lanes |= l, Tl |= l, u);
  }
  function Yp(l, u, m, v, O) {
    var R = K.p;
    K.p = R !== 0 && 8 > R ? R : 8;
    var B = H.T, re = {};
    H.T = re, Ou(l, !1, u, m);
    try {
      var ve = O(), He = H.S;
      if (He !== null && He(re, ve), ve !== null && typeof ve == "object" && typeof ve.then == "function") {
        var Je = Pm(
          ve,
          v
        );
        Vs(
          l,
          u,
          Je,
          ri(l)
        );
      } else
        Vs(
          l,
          u,
          v,
          ri(l)
        );
    } catch (nt) {
      Vs(
        l,
        u,
        { then: function() {
        }, status: "rejected", reason: nt },
        ri()
      );
    } finally {
      K.p = R, B !== null && re.types !== null && (B.types = re.types), H.T = B;
    }
  }
  function Yb() {
  }
  function Ld(l, u, m, v) {
    if (l.tag !== 5) throw Error(a(476));
    var O = Hd(l).queue;
    Yp(
      l,
      O,
      u,
      X,
      m === null ? Yb : function() {
        return Pr(l), m(v);
      }
    );
  }
  function Hd(l) {
    var u = l.memoizedState;
    if (u !== null) return u;
    u = {
      memoizedState: X,
      baseState: X,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Zl,
        lastRenderedState: X
      },
      next: null
    };
    var m = {};
    return u.next = {
      memoizedState: m,
      baseState: m,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Zl,
        lastRenderedState: m
      },
      next: null
    }, l.memoizedState = u, l = l.alternate, l !== null && (l.memoizedState = u), u;
  }
  function Pr(l) {
    var u = Hd(l);
    u.next === null && (u = l.alternate.memoizedState), Vs(
      l,
      u.next.queue,
      {},
      ri()
    );
  }
  function Iv() {
    return rt(mh);
  }
  function Qb() {
    return fa().memoizedState;
  }
  function Lv() {
    return fa().memoizedState;
  }
  function ns(l) {
    for (var u = l.return; u !== null; ) {
      switch (u.tag) {
        case 24:
        case 3:
          var m = ri();
          l = Hs(m);
          var v = Ci(u, l, m);
          v !== null && (Xo(v, u, m), Eu(v, u, m)), u = { cache: Sm() }, l.payload = u;
          return;
      }
      u = u.return;
    }
  }
  function Jb(l, u, m) {
    var v = ri();
    m = {
      lane: v,
      revertLane: 0,
      gesture: null,
      action: m,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, Hm(l) ? Jp(u, m) : (m = Yi(l, u, m, v), m !== null && (Xo(m, l, v), Hv(m, u, v)));
  }
  function Qp(l, u, m) {
    var v = ri();
    Vs(l, u, m, v);
  }
  function Vs(l, u, m, v) {
    var O = {
      lane: v,
      revertLane: 0,
      gesture: null,
      action: m,
      hasEagerState: !1,
      eagerState: null,
      next: null
    };
    if (Hm(l)) Jp(u, O);
    else {
      var R = l.alternate;
      if (l.lanes === 0 && (R === null || R.lanes === 0) && (R = u.lastRenderedReducer, R !== null))
        try {
          var B = u.lastRenderedState, re = R(B, m);
          if (O.hasEagerState = !0, O.eagerState = re, Co(re, B))
            return vi(l, u, O, 0), kr === null && gi(), !1;
        } catch {
        } finally {
        }
      if (m = Yi(l, u, O, v), m !== null)
        return Xo(m, l, v), Hv(m, u, v), !0;
    }
    return !1;
  }
  function Ou(l, u, m, v) {
    if (v = {
      lane: 2,
      revertLane: Eg(),
      gesture: null,
      action: v,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, Hm(l)) {
      if (u) throw Error(a(479));
    } else
      u = Yi(
        l,
        m,
        v,
        2
      ), u !== null && Xo(u, l, 2);
  }
  function Hm(l) {
    var u = l.alternate;
    return l === Sn || u !== null && u === Sn;
  }
  function Jp(l, u) {
    Ec = xc = !0;
    var m = l.pending;
    m === null ? u.next = u : (u.next = m.next, m.next = u), l.pending = u;
  }
  function Hv(l, u, m) {
    if ((m & 4194048) !== 0) {
      var v = u.lanes;
      v &= l.pendingLanes, m |= v, u.lanes = m, Lt(l, m);
    }
  }
  var Fm = {
    readContext: rt,
    use: zd,
    useCallback: Zr,
    useContext: Zr,
    useEffect: Zr,
    useImperativeHandle: Zr,
    useLayoutEffect: Zr,
    useInsertionEffect: Zr,
    useMemo: Zr,
    useReducer: Zr,
    useRef: Zr,
    useState: Zr,
    useDebugValue: Zr,
    useDeferredValue: Zr,
    useTransition: Zr,
    useSyncExternalStore: Zr,
    useId: Zr,
    useHostTransitionStatus: Zr,
    useFormState: Zr,
    useActionState: Zr,
    useOptimistic: Zr,
    useMemoCache: Zr,
    useCacheRefresh: Zr
  };
  Fm.useEffectEvent = Zr;
  var Zb = {
    readContext: rt,
    use: zd,
    useCallback: function(l, u) {
      return Xa().memoizedState = [
        l,
        u === void 0 ? null : u
      ], l;
    },
    useContext: rt,
    useEffect: Up,
    useImperativeHandle: function(l, u, m) {
      m = m != null ? m.concat([l]) : null, jd(
        4194308,
        4,
        qp.bind(null, u, l),
        m
      );
    },
    useLayoutEffect: function(l, u) {
      return jd(4194308, 4, l, u);
    },
    useInsertionEffect: function(l, u) {
      jd(4, 2, l, u);
    },
    useMemo: function(l, u) {
      var m = Xa();
      u = u === void 0 ? null : u;
      var v = l();
      if (Fs) {
        ht(!0);
        try {
          l();
        } finally {
          ht(!1);
        }
      }
      return m.memoizedState = [v, u], v;
    },
    useReducer: function(l, u, m) {
      var v = Xa();
      if (m !== void 0) {
        var O = m(u);
        if (Fs) {
          ht(!0);
          try {
            m(u);
          } finally {
            ht(!1);
          }
        }
      } else O = u;
      return v.memoizedState = v.baseState = O, l = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: l,
        lastRenderedState: O
      }, v.queue = l, l = l.dispatch = Jb.bind(
        null,
        Sn,
        l
      ), [v.memoizedState, l];
    },
    useRef: function(l) {
      var u = Xa();
      return l = { current: l }, u.memoizedState = l;
    },
    useState: function(l) {
      l = Pv(l);
      var u = l.queue, m = Qp.bind(null, Sn, u);
      return u.dispatch = m, [l.memoizedState, m];
    },
    useDebugValue: El,
    useDeferredValue: function(l, u) {
      var m = Xa();
      return Lm(m, l, u);
    },
    useTransition: function() {
      var l = Pv(!1);
      return l = Yp.bind(
        null,
        Sn,
        l.queue,
        !0,
        !1
      ), Xa().memoizedState = l, [!1, l];
    },
    useSyncExternalStore: function(l, u, m) {
      var v = Sn, O = Xa();
      if (_n) {
        if (m === void 0)
          throw Error(a(407));
        m = m();
      } else {
        if (m = u(), kr === null)
          throw Error(a(349));
        (In & 127) !== 0 || $m(v, u, m);
      }
      O.memoizedState = m;
      var R = { value: m, getSnapshot: u };
      return O.queue = R, Up(Vp.bind(null, v, R, l), [
        l
      ]), v.flags |= 2048, Oc(
        9,
        { destroy: void 0 },
        Ev.bind(
          null,
          v,
          R,
          m,
          u
        ),
        null
      ), m;
    },
    useId: function() {
      var l = Xa(), u = kr.identifierPrefix;
      if (_n) {
        var m = wl, v = Zo;
        m = (v & ~(1 << 32 - ot(v) - 1)).toString(32) + m, u = "_" + u + "R_" + m, m = Rm++, 0 < m && (u += "H" + m.toString(32)), u += "_";
      } else
        m = Ub++, u = "_" + u + "r_" + m.toString(32) + "_";
      return l.memoizedState = u;
    },
    useHostTransitionStatus: Iv,
    useFormState: Rv,
    useActionState: Rv,
    useOptimistic: function(l) {
      var u = Xa();
      u.memoizedState = u.baseState = l;
      var m = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
      };
      return u.queue = m, u = Ou.bind(
        null,
        Sn,
        !0,
        m
      ), m.dispatch = u, [l, u];
    },
    useMemoCache: Hp,
    useCacheRefresh: function() {
      return Xa().memoizedState = ns.bind(
        null,
        Sn
      );
    },
    useEffectEvent: function(l) {
      var u = Xa(), m = { impl: l };
      return u.memoizedState = m, function() {
        if ((ir & 2) !== 0)
          throw Error(a(440));
        return m.impl.apply(void 0, arguments);
      };
    }
  }, Zp = {
    readContext: rt,
    use: zd,
    useCallback: Kp,
    useContext: rt,
    useEffect: Xp,
    useImperativeHandle: jv,
    useInsertionEffect: Gp,
    useLayoutEffect: zv,
    useMemo: Kb,
    useReducer: es,
    useRef: Dv,
    useState: function() {
      return es(Zl);
    },
    useDebugValue: El,
    useDeferredValue: function(l, u) {
      var m = fa();
      return ts(
        m,
        vr.memoizedState,
        l,
        u
      );
    },
    useTransition: function() {
      var l = es(Zl)[0], u = fa().memoizedState;
      return [
        typeof l == "boolean" ? l : kc(l),
        u
      ];
    },
    useSyncExternalStore: xv,
    useId: Qb,
    useHostTransitionStatus: Iv,
    useFormState: qb,
    useActionState: qb,
    useOptimistic: function(l, u) {
      var m = fa();
      return Ga(m, vr, l, u);
    },
    useMemoCache: Hp,
    useCacheRefresh: Lv
  };
  Zp.useEffectEvent = Im;
  var ey = {
    readContext: rt,
    use: zd,
    useCallback: Kp,
    useContext: rt,
    useEffect: Xp,
    useImperativeHandle: jv,
    useInsertionEffect: Gp,
    useLayoutEffect: zv,
    useMemo: Kb,
    useReducer: Wp,
    useRef: Dv,
    useState: function() {
      return Wp(Zl);
    },
    useDebugValue: El,
    useDeferredValue: function(l, u) {
      var m = fa();
      return vr === null ? Lm(m, l, u) : ts(
        m,
        vr.memoizedState,
        l,
        u
      );
    },
    useTransition: function() {
      var l = Wp(Zl)[0], u = fa().memoizedState;
      return [
        typeof l == "boolean" ? l : kc(l),
        u
      ];
    },
    useSyncExternalStore: xv,
    useId: Qb,
    useHostTransitionStatus: Iv,
    useFormState: Nv,
    useActionState: Nv,
    useOptimistic: function(l, u) {
      var m = fa();
      return vr !== null ? Ga(m, vr, l, u) : (m.baseState = l, [l, m.queue.dispatch]);
    },
    useMemoCache: Hp,
    useCacheRefresh: Lv
  };
  ey.useEffectEvent = Im;
  function Tc(l, u, m, v) {
    u = l.memoizedState, m = m(v, u), m = m == null ? u : w({}, u, m), l.memoizedState = m, l.lanes === 0 && (l.updateQueue.baseState = m);
  }
  var Zi = {
    enqueueSetState: function(l, u, m) {
      l = l._reactInternals;
      var v = ri(), O = Hs(v);
      O.payload = u, m != null && (O.callback = m), u = Ci(l, O, v), u !== null && (Xo(u, l, v), Eu(u, l, v));
    },
    enqueueReplaceState: function(l, u, m) {
      l = l._reactInternals;
      var v = ri(), O = Hs(v);
      O.tag = 1, O.payload = u, m != null && (O.callback = m), u = Ci(l, O, v), u !== null && (Xo(u, l, v), Eu(u, l, v));
    },
    enqueueForceUpdate: function(l, u) {
      l = l._reactInternals;
      var m = ri(), v = Hs(m);
      v.tag = 2, u != null && (v.callback = u), u = Ci(l, v, m), u !== null && (Xo(u, l, m), Eu(u, l, m));
    }
  };
  function Fv(l, u, m, v, O, R, B) {
    return l = l.stateNode, typeof l.shouldComponentUpdate == "function" ? l.shouldComponentUpdate(v, R, B) : u.prototype && u.prototype.isPureReactComponent ? !Gi(m, v) || !Gi(O, R) : !0;
  }
  function ty(l, u, m, v) {
    l = u.state, typeof u.componentWillReceiveProps == "function" && u.componentWillReceiveProps(m, v), typeof u.UNSAFE_componentWillReceiveProps == "function" && u.UNSAFE_componentWillReceiveProps(m, v), u.state !== l && Zi.enqueueReplaceState(u, u.state, null);
  }
  function Tu(l, u) {
    var m = u;
    if ("ref" in u) {
      m = {};
      for (var v in u)
        v !== "ref" && (m[v] = u[v]);
    }
    if (l = l.defaultProps) {
      m === u && (m = w({}, m));
      for (var O in l)
        m[O] === void 0 && (m[O] = l[O]);
    }
    return m;
  }
  function eg(l) {
    mc(l);
  }
  function Wv(l) {
    console.error(l);
  }
  function tg(l) {
    mc(l);
  }
  function Fd(l, u) {
    try {
      var m = l.onUncaughtError;
      m(u.value, { componentStack: u.stack });
    } catch (v) {
      setTimeout(function() {
        throw v;
      });
    }
  }
  function Wm(l, u, m) {
    try {
      var v = l.onCaughtError;
      v(m.value, {
        componentStack: m.stack,
        errorBoundary: u.tag === 1 ? u.stateNode : null
      });
    } catch (O) {
      setTimeout(function() {
        throw O;
      });
    }
  }
  function Vv(l, u, m) {
    return m = Hs(m), m.tag = 3, m.payload = { element: null }, m.callback = function() {
      Fd(l, u);
    }, m;
  }
  function _v(l) {
    return l = Hs(l), l.tag = 3, l;
  }
  function Bv(l, u, m, v) {
    var O = m.type.getDerivedStateFromError;
    if (typeof O == "function") {
      var R = v.value;
      l.payload = function() {
        return O(R);
      }, l.callback = function() {
        Wm(u, m, v);
      };
    }
    var B = m.stateNode;
    B !== null && typeof B.componentDidCatch == "function" && (l.callback = function() {
      Wm(u, m, v), typeof O != "function" && (Ur === null ? Ur = /* @__PURE__ */ new Set([this]) : Ur.add(this));
      var re = v.stack;
      this.componentDidCatch(v.value, {
        componentStack: re !== null ? re : ""
      });
    });
  }
  function vC(l, u, m, v, O) {
    if (m.flags |= 32768, v !== null && typeof v == "object" && typeof v.then == "function") {
      if (u = m.alternate, u !== null && Ua(
        u,
        m,
        O,
        !0
      ), m = Ho.current, m !== null) {
        switch (m.tag) {
          case 31:
          case 13:
            return Hi === null ? wg() : m.alternate === null && jr === 0 && (jr = 3), m.flags &= -257, m.flags |= 65536, m.lanes = O, v === wc ? m.flags |= 16384 : (u = m.updateQueue, u === null ? m.updateQueue = /* @__PURE__ */ new Set([v]) : u.add(v), th(l, v, O)), !1;
          case 22:
            return m.flags |= 65536, v === wc ? m.flags |= 16384 : (u = m.updateQueue, u === null ? (u = {
              transitions: null,
              markerInstances: null,
              retryQueue: /* @__PURE__ */ new Set([v])
            }, m.updateQueue = u) : (m = u.retryQueue, m === null ? u.retryQueue = /* @__PURE__ */ new Set([v]) : m.add(v)), th(l, v, O)), !1;
        }
        throw Error(a(435, m.tag));
      }
      return th(l, v, O), wg(), !1;
    }
    if (_n)
      return u = Ho.current, u !== null ? ((u.flags & 65536) === 0 && (u.flags |= 256), u.flags |= 65536, u.lanes = O, v !== Gl && (l = Error(a(422), { cause: v }), Md(bi(l, m)))) : (v !== Gl && (u = Error(a(423), {
        cause: v
      }), Md(
        bi(u, m)
      )), l = l.current.alternate, l.flags |= 65536, O &= -O, l.lanes |= O, v = bi(v, m), O = Vv(
        l.stateNode,
        v,
        O
      ), $p(l, O), jr !== 4 && (jr = 2)), !1;
    var R = Error(a(520), { cause: v });
    if (R = bi(R, m), Qm === null ? Qm = [R] : Qm.push(R), jr !== 4 && (jr = 2), u === null) return !0;
    v = bi(v, m), m = u;
    do {
      switch (m.tag) {
        case 3:
          return m.flags |= 65536, l = O & -O, m.lanes |= l, l = Vv(m.stateNode, v, l), $p(m, l), !1;
        case 1:
          if (u = m.type, R = m.stateNode, (m.flags & 128) === 0 && (typeof u.getDerivedStateFromError == "function" || R !== null && typeof R.componentDidCatch == "function" && (Ur === null || !Ur.has(R))))
            return m.flags |= 65536, O &= -O, m.lanes |= O, O = _v(O), Bv(
              O,
              l,
              m,
              v
            ), $p(m, O), !1;
      }
      m = m.return;
    } while (m !== null);
    return !1;
  }
  var ng = Error(a(461)), wa = !1;
  function Wr(l, u, m, v) {
    u.child = l === null ? Sv(u, null, m, v) : xu(
      u,
      l.child,
      m,
      v
    );
  }
  function Uv(l, u, m, v, O) {
    m = m.render;
    var R = u.ref;
    if ("ref" in v) {
      var B = {};
      for (var re in v)
        re !== "ref" && (B[re] = v[re]);
    } else B = v;
    return sn(u), v = Am(
      l,
      u,
      m,
      B,
      R,
      O
    ), re = Lp(), l !== null && !wa ? (Pc(l, u, O), Pi(l, u, O)) : (_n && re && Pd(u), u.flags |= 1, Wr(l, u, v, O), u.child);
  }
  function Xv(l, u, m, v, O) {
    if (l === null) {
      var R = m.type;
      return typeof R == "function" && !hc(R) && R.defaultProps === void 0 && m.compare === null ? (u.tag = 15, u.type = R, Gv(
        l,
        u,
        R,
        v,
        O
      )) : (l = Mp(
        m.type,
        null,
        v,
        u,
        u.mode,
        O
      ), l.ref = u.ref, l.return = u, u.child = l);
    }
    if (R = l.child, !og(l, O)) {
      var B = R.memoizedProps;
      if (m = m.compare, m = m !== null ? m : Gi, m(B, v) && l.ref === u.ref)
        return Pi(l, u, O);
    }
    return u.flags |= 1, l = Ds(R, v), l.ref = u.ref, l.return = u, u.child = l;
  }
  function Gv(l, u, m, v, O) {
    if (l !== null) {
      var R = l.memoizedProps;
      if (Gi(R, v) && l.ref === u.ref)
        if (wa = !1, u.pendingProps = v = R, og(l, O))
          (l.flags & 131072) !== 0 && (wa = !0);
        else
          return u.lanes = l.lanes, Pi(l, u, O);
    }
    return rg(
      l,
      u,
      m,
      v,
      O
    );
  }
  function ny(l, u, m, v) {
    var O = v.children, R = l !== null ? l.memoizedState : null;
    if (l === null && u.stateNode === null && (u.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }), v.mode === "hidden") {
      if ((u.flags & 128) !== 0) {
        if (R = R !== null ? R.baseLanes | m : m, l !== null) {
          for (v = u.child = l.child, O = 0; v !== null; )
            O = O | v.lanes | v.childLanes, v = v.sibling;
          v = O & ~R;
        } else v = 0, u.child = null;
        return Wo(
          l,
          u,
          R,
          m,
          v
        );
      }
      if ((m & 536870912) !== 0)
        u.memoizedState = { baseLanes: 0, cachePool: null }, l !== null && Od(
          u,
          R !== null ? R.cachePool : null
        ), R !== null ? Bb(u, R) : Tm(), jp(u);
      else
        return v = u.lanes = 536870912, Wo(
          l,
          u,
          R !== null ? R.baseLanes | m : m,
          m,
          v
        );
    } else
      R !== null ? (Od(u, R.cachePool), Bb(u, R), xl(), u.memoizedState = null) : (l !== null && Od(u, null), Tm(), xl());
    return Wr(l, u, O, m), u.child;
  }
  function Ru(l, u) {
    return l !== null && l.tag === 22 || u.stateNode !== null || (u.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }), u.sibling;
  }
  function Wo(l, u, m, v, O) {
    var R = Si();
    return R = R === null ? null : { parent: ba._currentValue, pool: R }, u.memoizedState = {
      baseLanes: m,
      cachePool: R
    }, l !== null && Od(u, null), Tm(), jp(u), l !== null && Ua(l, u, v, !0), u.childLanes = O, null;
  }
  function Vm(l, u) {
    return u = Um(
      { mode: u.mode, children: u.children },
      l.mode
    ), u.ref = l.ref, l.child = u, u.return = l, u;
  }
  function Vo(l, u, m) {
    return xu(u, l.child, null, m), l = Vm(u, u.pendingProps), l.flags |= 2, Fo(u), u.memoizedState = null, l;
  }
  function ry(l, u, m) {
    var v = u.pendingProps, O = (u.flags & 128) !== 0;
    if (u.flags &= -129, l === null) {
      if (_n) {
        if (v.mode === "hidden")
          return l = Vm(u, v), u.lanes = 536870912, Ru(null, l);
        if (Nd(u), (l = $r) ? (l = Ly(
          l,
          $a
        ), l = l !== null && l.data === "&" ? l : null, l !== null && (u.memoizedState = {
          dehydrated: l,
          treeContext: yl !== null ? { id: Zo, overflow: wl } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, m = fv(l), m.return = u, u.child = m, Ba = u, $r = null)) : l = null, l === null) throw Ji(u);
        return u.lanes = 536870912, null;
      }
      return Vm(u, v);
    }
    var R = l.memoizedState;
    if (R !== null) {
      var B = R.dehydrated;
      if (Nd(u), O)
        if (u.flags & 256)
          u.flags &= -257, u = Vo(
            l,
            u,
            m
          );
        else if (u.memoizedState !== null)
          u.child = l.child, u.flags |= 128, u = null;
        else throw Error(a(558));
      else if (wa || Ua(l, u, m, !1), O = (m & l.childLanes) !== 0, wa || O) {
        if (v = kr, v !== null && (B = gt(v, m), B !== 0 && B !== R.retryLane))
          throw R.retryLane = B, Ns(l, B), Xo(v, l, B), ng;
        wg(), u = Vo(
          l,
          u,
          m
        );
      } else
        l = R.treeContext, $r = Go(B.nextSibling), Ba = u, _n = !0, Xl = null, $a = !1, l !== null && bm(u, l), u = Vm(u, v), u.flags |= 4096;
      return u;
    }
    return l = Ds(l.child, {
      mode: v.mode,
      children: v.children
    }), l.ref = u.ref, u.child = l, l.return = u, l;
  }
  function xi(l, u) {
    var m = u.ref;
    if (m === null)
      l !== null && l.ref !== null && (u.flags |= 4194816);
    else {
      if (typeof m != "function" && typeof m != "object")
        throw Error(a(284));
      (l === null || l.ref !== m) && (u.flags |= 4194816);
    }
  }
  function rg(l, u, m, v, O) {
    return sn(u), m = Am(
      l,
      u,
      m,
      v,
      void 0,
      O
    ), v = Lp(), l !== null && !wa ? (Pc(l, u, O), Pi(l, u, O)) : (_n && v && Pd(u), u.flags |= 1, Wr(l, u, m, O), u.child);
  }
  function Au(l, u, m, v, O, R) {
    return sn(u), u.updateQueue = null, m = Xb(
      u,
      v,
      m,
      O
    ), Ip(l), v = Lp(), l !== null && !wa ? (Pc(l, u, R), Pi(l, u, R)) : (_n && v && Pd(u), u.flags |= 1, Wr(l, u, m, R), u.child);
  }
  function qv(l, u, m, v, O) {
    if (sn(u), u.stateNode === null) {
      var R = jo, B = m.contextType;
      typeof B == "object" && B !== null && (R = rt(B)), R = new m(v, R), u.memoizedState = R.state !== null && R.state !== void 0 ? R.state : null, R.updater = Zi, u.stateNode = R, R._reactInternals = u, R = u.stateNode, R.props = v, R.state = u.memoizedState, R.refs = {}, Om(u), B = m.contextType, R.context = typeof B == "object" && B !== null ? rt(B) : jo, R.state = u.memoizedState, B = m.getDerivedStateFromProps, typeof B == "function" && (Tc(
        u,
        m,
        B,
        v
      ), R.state = u.memoizedState), typeof m.getDerivedStateFromProps == "function" || typeof R.getSnapshotBeforeUpdate == "function" || typeof R.UNSAFE_componentWillMount != "function" && typeof R.componentWillMount != "function" || (B = R.state, typeof R.componentWillMount == "function" && R.componentWillMount(), typeof R.UNSAFE_componentWillMount == "function" && R.UNSAFE_componentWillMount(), B !== R.state && Zi.enqueueReplaceState(R, R.state, null), Yl(u, v, R, O), Pu(), R.state = u.memoizedState), typeof R.componentDidMount == "function" && (u.flags |= 4194308), v = !0;
    } else if (l === null) {
      R = u.stateNode;
      var re = u.memoizedProps, ve = Tu(m, re);
      R.props = ve;
      var He = R.context, Je = m.contextType;
      B = jo, typeof Je == "object" && Je !== null && (B = rt(Je));
      var nt = m.getDerivedStateFromProps;
      Je = typeof nt == "function" || typeof R.getSnapshotBeforeUpdate == "function", re = u.pendingProps !== re, Je || typeof R.UNSAFE_componentWillReceiveProps != "function" && typeof R.componentWillReceiveProps != "function" || (re || He !== B) && ty(
        u,
        R,
        v,
        B
      ), Ls = !1;
      var We = u.memoizedState;
      R.state = We, Yl(u, v, R, O), Pu(), He = u.memoizedState, re || We !== He || Ls ? (typeof nt == "function" && (Tc(
        u,
        m,
        nt,
        v
      ), He = u.memoizedState), (ve = Ls || Fv(
        u,
        m,
        ve,
        v,
        We,
        He,
        B
      )) ? (Je || typeof R.UNSAFE_componentWillMount != "function" && typeof R.componentWillMount != "function" || (typeof R.componentWillMount == "function" && R.componentWillMount(), typeof R.UNSAFE_componentWillMount == "function" && R.UNSAFE_componentWillMount()), typeof R.componentDidMount == "function" && (u.flags |= 4194308)) : (typeof R.componentDidMount == "function" && (u.flags |= 4194308), u.memoizedProps = v, u.memoizedState = He), R.props = v, R.state = He, R.context = B, v = ve) : (typeof R.componentDidMount == "function" && (u.flags |= 4194308), v = !1);
    } else {
      R = u.stateNode, Dp(l, u), B = u.memoizedProps, Je = Tu(m, B), R.props = Je, nt = u.pendingProps, We = R.context, He = m.contextType, ve = jo, typeof He == "object" && He !== null && (ve = rt(He)), re = m.getDerivedStateFromProps, (He = typeof re == "function" || typeof R.getSnapshotBeforeUpdate == "function") || typeof R.UNSAFE_componentWillReceiveProps != "function" && typeof R.componentWillReceiveProps != "function" || (B !== nt || We !== ve) && ty(
        u,
        R,
        v,
        ve
      ), Ls = !1, We = u.memoizedState, R.state = We, Yl(u, v, R, O), Pu();
      var Ge = u.memoizedState;
      B !== nt || We !== Ge || Ls || l !== null && l.dependencies !== null && gc(l.dependencies) ? (typeof re == "function" && (Tc(
        u,
        m,
        re,
        v
      ), Ge = u.memoizedState), (Je = Ls || Fv(
        u,
        m,
        Je,
        v,
        We,
        Ge,
        ve
      ) || l !== null && l.dependencies !== null && gc(l.dependencies)) ? (He || typeof R.UNSAFE_componentWillUpdate != "function" && typeof R.componentWillUpdate != "function" || (typeof R.componentWillUpdate == "function" && R.componentWillUpdate(v, Ge, ve), typeof R.UNSAFE_componentWillUpdate == "function" && R.UNSAFE_componentWillUpdate(
        v,
        Ge,
        ve
      )), typeof R.componentDidUpdate == "function" && (u.flags |= 4), typeof R.getSnapshotBeforeUpdate == "function" && (u.flags |= 1024)) : (typeof R.componentDidUpdate != "function" || B === l.memoizedProps && We === l.memoizedState || (u.flags |= 4), typeof R.getSnapshotBeforeUpdate != "function" || B === l.memoizedProps && We === l.memoizedState || (u.flags |= 1024), u.memoizedProps = v, u.memoizedState = Ge), R.props = v, R.state = Ge, R.context = ve, v = Je) : (typeof R.componentDidUpdate != "function" || B === l.memoizedProps && We === l.memoizedState || (u.flags |= 4), typeof R.getSnapshotBeforeUpdate != "function" || B === l.memoizedProps && We === l.memoizedState || (u.flags |= 1024), v = !1);
    }
    return R = v, xi(l, u), v = (u.flags & 128) !== 0, R || v ? (R = u.stateNode, m = v && typeof m.getDerivedStateFromError != "function" ? null : R.render(), u.flags |= 1, l !== null && v ? (u.child = xu(
      u,
      l.child,
      null,
      O
    ), u.child = xu(
      u,
      null,
      m,
      O
    )) : Wr(l, u, m, O), u.memoizedState = R.state, l = u.child) : l = Pi(
      l,
      u,
      O
    ), l;
  }
  function Pl(l, u, m, v) {
    return vu(), u.flags |= 256, Wr(l, u, m, v), u.child;
  }
  var _m = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
  };
  function Bm(l) {
    return { baseLanes: l, cachePool: bc() };
  }
  function Ei(l, u, m) {
    return l = l !== null ? l.childLanes & ~m : 0, u && (l |= Uo), l;
  }
  function Kv(l, u, m) {
    var v = u.pendingProps, O = !1, R = (u.flags & 128) !== 0, B;
    if ((B = R) || (B = l !== null && l.memoizedState === null ? !1 : (Br.current & 2) !== 0), B && (O = !0, u.flags &= -129), B = (u.flags & 32) !== 0, u.flags &= -33, l === null) {
      if (_n) {
        if (O ? Ql(u) : xl(), (l = $r) ? (l = Ly(
          l,
          $a
        ), l = l !== null && l.data !== "&" ? l : null, l !== null && (u.memoizedState = {
          dehydrated: l,
          treeContext: yl !== null ? { id: Zo, overflow: wl } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, m = fv(l), m.return = u, u.child = m, Ba = u, $r = null)) : l = null, l === null) throw Ji(u);
        return Lu(l) ? u.lanes = 32 : u.lanes = 536870912, null;
      }
      var re = v.children;
      return v = v.fallback, O ? (xl(), O = u.mode, re = Um(
        { mode: "hidden", children: re },
        O
      ), v = $s(
        v,
        O,
        m,
        null
      ), re.return = u, v.return = u, re.sibling = v, u.child = re, v = u.child, v.memoizedState = Bm(m), v.childLanes = Ei(
        l,
        B,
        m
      ), u.memoizedState = _m, Ru(null, v)) : (Ql(u), Nu(u, re));
    }
    var ve = l.memoizedState;
    if (ve !== null && (re = ve.dehydrated, re !== null)) {
      if (R)
        u.flags & 256 ? (Ql(u), u.flags &= -257, u = Rc(
          l,
          u,
          m
        )) : u.memoizedState !== null ? (xl(), u.child = l.child, u.flags |= 128, u = null) : (xl(), re = v.fallback, O = u.mode, v = Um(
          { mode: "visible", children: v.children },
          O
        ), re = $s(
          re,
          O,
          m,
          null
        ), re.flags |= 2, v.return = u, re.return = u, v.sibling = re, u.child = v, xu(
          u,
          l.child,
          null,
          m
        ), v = u.child, v.memoizedState = Bm(m), v.childLanes = Ei(
          l,
          B,
          m
        ), u.memoizedState = _m, u = Ru(null, v));
      else if (Ql(u), Lu(re)) {
        if (B = re.nextSibling && re.nextSibling.dataset, B) var He = B.dgst;
        B = He, v = Error(a(419)), v.stack = "", v.digest = B, Md({ value: v, source: null, stack: null }), u = Rc(
          l,
          u,
          m
        );
      } else if (wa || Ua(l, u, m, !1), B = (m & l.childLanes) !== 0, wa || B) {
        if (B = kr, B !== null && (v = gt(B, m), v !== 0 && v !== ve.retryLane))
          throw ve.retryLane = v, Ns(l, v), Xo(B, l, v), ng;
        nl(re) || wg(), u = Rc(
          l,
          u,
          m
        );
      } else
        nl(re) ? (u.flags |= 192, u.child = l.child, u = null) : (l = ve.treeContext, $r = Go(
          re.nextSibling
        ), Ba = u, _n = !0, Xl = null, $a = !1, l !== null && bm(u, l), u = Nu(
          u,
          v.children
        ), u.flags |= 4096);
      return u;
    }
    return O ? (xl(), re = v.fallback, O = u.mode, ve = l.child, He = ve.sibling, v = Ds(ve, {
      mode: "hidden",
      children: v.children
    }), v.subtreeFlags = ve.subtreeFlags & 65011712, He !== null ? re = Ds(
      He,
      re
    ) : (re = $s(
      re,
      O,
      m,
      null
    ), re.flags |= 2), re.return = u, v.return = u, v.sibling = re, u.child = v, Ru(null, v), v = u.child, re = l.child.memoizedState, re === null ? re = Bm(m) : (O = re.cachePool, O !== null ? (ve = ba._currentValue, O = O.parent !== ve ? { parent: ve, pool: ve } : O) : O = bc(), re = {
      baseLanes: re.baseLanes | m,
      cachePool: O
    }), v.memoizedState = re, v.childLanes = Ei(
      l,
      B,
      m
    ), u.memoizedState = _m, Ru(l.child, v)) : (Ql(u), m = l.child, l = m.sibling, m = Ds(m, {
      mode: "visible",
      children: v.children
    }), m.return = u, m.sibling = null, l !== null && (B = u.deletions, B === null ? (u.deletions = [l], u.flags |= 16) : B.push(l)), u.child = m, u.memoizedState = null, m);
  }
  function Nu(l, u) {
    return u = Um(
      { mode: "visible", children: u },
      l.mode
    ), u.return = l, l.child = u;
  }
  function Um(l, u) {
    return l = ca(22, l, null, u), l.lanes = 0, l;
  }
  function Rc(l, u, m) {
    return xu(u, l.child, null, m), l = Nu(
      u,
      u.pendingProps.children
    ), l.flags |= 2, u.memoizedState = null, l;
  }
  function Ac(l, u, m) {
    l.lanes |= u;
    var v = l.alternate;
    v !== null && (v.lanes |= u), Ap(l.return, u, m);
  }
  function ag(l, u, m, v, O, R) {
    var B = l.memoizedState;
    B === null ? l.memoizedState = {
      isBackwards: u,
      rendering: null,
      renderingStartTime: 0,
      last: v,
      tail: m,
      tailMode: O,
      treeForkCount: R
    } : (B.isBackwards = u, B.rendering = null, B.renderingStartTime = 0, B.last = v, B.tail = m, B.tailMode = O, B.treeForkCount = R);
  }
  function Yv(l, u, m) {
    var v = u.pendingProps, O = v.revealOrder, R = v.tail;
    v = v.children;
    var B = Br.current, re = (B & 2) !== 0;
    if (re ? (B = B & 1 | 2, u.flags |= 128) : B &= 1, ae(Br, B), Wr(l, u, v, m), v = _n ? va : 0, !re && l !== null && (l.flags & 128) !== 0)
      e: for (l = u.child; l !== null; ) {
        if (l.tag === 13)
          l.memoizedState !== null && Ac(l, m, u);
        else if (l.tag === 19)
          Ac(l, m, u);
        else if (l.child !== null) {
          l.child.return = l, l = l.child;
          continue;
        }
        if (l === u) break e;
        for (; l.sibling === null; ) {
          if (l.return === null || l.return === u)
            break e;
          l = l.return;
        }
        l.sibling.return = l.return, l = l.sibling;
      }
    switch (O) {
      case "forwards":
        for (m = u.child, O = null; m !== null; )
          l = m.alternate, l !== null && Dd(l) === null && (O = m), m = m.sibling;
        m = O, m === null ? (O = u.child, u.child = null) : (O = m.sibling, m.sibling = null), ag(
          u,
          !1,
          O,
          m,
          R,
          v
        );
        break;
      case "backwards":
      case "unstable_legacy-backwards":
        for (m = null, O = u.child, u.child = null; O !== null; ) {
          if (l = O.alternate, l !== null && Dd(l) === null) {
            u.child = O;
            break;
          }
          l = O.sibling, O.sibling = m, m = O, O = l;
        }
        ag(
          u,
          !0,
          m,
          null,
          R,
          v
        );
        break;
      case "together":
        ag(
          u,
          !1,
          null,
          null,
          void 0,
          v
        );
        break;
      default:
        u.memoizedState = null;
    }
    return u.child;
  }
  function Pi(l, u, m) {
    if (l !== null && (u.dependencies = l.dependencies), Tl |= u.lanes, (m & u.childLanes) === 0)
      if (l !== null) {
        if (Ua(
          l,
          u,
          m,
          !1
        ), (m & u.childLanes) === 0)
          return null;
      } else return null;
    if (l !== null && u.child !== l.child)
      throw Error(a(153));
    if (u.child !== null) {
      for (l = u.child, m = Ds(l, l.pendingProps), u.child = m, m.return = u; l.sibling !== null; )
        l = l.sibling, m = m.sibling = Ds(l, l.pendingProps), m.return = u;
      m.sibling = null;
    }
    return u.child;
  }
  function og(l, u) {
    return (l.lanes & u) !== 0 ? !0 : (l = l.dependencies, !!(l !== null && gc(l)));
  }
  function ig(l, u, m) {
    switch (u.tag) {
      case 3:
        De(u, u.stateNode.containerInfo), Lo(u, ba, l.memoizedState.cache), vu();
        break;
      case 27:
      case 5:
        ze(u);
        break;
      case 4:
        De(u, u.stateNode.containerInfo);
        break;
      case 10:
        Lo(
          u,
          u.type,
          u.memoizedProps.value
        );
        break;
      case 31:
        if (u.memoizedState !== null)
          return u.flags |= 128, Nd(u), null;
        break;
      case 13:
        var v = u.memoizedState;
        if (v !== null)
          return v.dehydrated !== null ? (Ql(u), u.flags |= 128, null) : (m & u.child.childLanes) !== 0 ? Kv(l, u, m) : (Ql(u), l = Pi(
            l,
            u,
            m
          ), l !== null ? l.sibling : null);
        Ql(u);
        break;
      case 19:
        var O = (l.flags & 128) !== 0;
        if (v = (m & u.childLanes) !== 0, v || (Ua(
          l,
          u,
          m,
          !1
        ), v = (m & u.childLanes) !== 0), O) {
          if (v)
            return Yv(
              l,
              u,
              m
            );
          u.flags |= 128;
        }
        if (O = u.memoizedState, O !== null && (O.rendering = null, O.tail = null, O.lastEffect = null), ae(Br, Br.current), v) break;
        return null;
      case 22:
        return u.lanes = 0, ny(
          l,
          u,
          m,
          u.pendingProps
        );
      case 24:
        Lo(u, ba, l.memoizedState.cache);
    }
    return Pi(l, u, m);
  }
  function Qv(l, u, m) {
    if (l !== null)
      if (l.memoizedProps !== u.pendingProps)
        wa = !0;
      else {
        if (!og(l, m) && (u.flags & 128) === 0)
          return wa = !1, ig(
            l,
            u,
            m
          );
        wa = (l.flags & 131072) !== 0;
      }
    else
      wa = !1, _n && (u.flags & 1048576) !== 0 && hv(u, va, u.index);
    switch (u.lanes = 0, u.tag) {
      case 16:
        e: {
          var v = u.pendingProps;
          if (l = wu(u.elementType), u.type = l, typeof l == "function")
            hc(l) ? (v = Tu(l, v), u.tag = 1, u = qv(
              null,
              u,
              l,
              v,
              m
            )) : (u.tag = 0, u = rg(
              null,
              u,
              l,
              v,
              m
            ));
          else {
            if (l != null) {
              var O = l.$$typeof;
              if (O === $) {
                u.tag = 11, u = Uv(
                  null,
                  u,
                  l,
                  v,
                  m
                );
                break e;
              } else if (O === L) {
                u.tag = 14, u = Xv(
                  null,
                  u,
                  l,
                  v,
                  m
                );
                break e;
              }
            }
            throw u = G(l) || l, Error(a(306, u, ""));
          }
        }
        return u;
      case 0:
        return rg(
          l,
          u,
          u.type,
          u.pendingProps,
          m
        );
      case 1:
        return v = u.type, O = Tu(
          v,
          u.pendingProps
        ), qv(
          l,
          u,
          v,
          O,
          m
        );
      case 3:
        e: {
          if (De(
            u,
            u.stateNode.containerInfo
          ), l === null) throw Error(a(387));
          v = u.pendingProps;
          var R = u.memoizedState;
          O = R.element, Dp(l, u), Yl(u, v, null, m);
          var B = u.memoizedState;
          if (v = B.cache, Lo(u, ba, v), v !== R.cache && Kl(
            u,
            [ba],
            m,
            !0
          ), Pu(), v = B.element, R.isDehydrated)
            if (R = {
              element: v,
              isDehydrated: !1,
              cache: B.cache
            }, u.updateQueue.baseState = R, u.memoizedState = R, u.flags & 256) {
              u = Pl(
                l,
                u,
                v,
                m
              );
              break e;
            } else if (v !== O) {
              O = bi(
                Error(a(424)),
                u
              ), Md(O), u = Pl(
                l,
                u,
                v,
                m
              );
              break e;
            } else {
              switch (l = u.stateNode.containerInfo, l.nodeType) {
                case 9:
                  l = l.body;
                  break;
                default:
                  l = l.nodeName === "HTML" ? l.ownerDocument.body : l;
              }
              for ($r = Go(l.firstChild), Ba = u, _n = !0, Xl = null, $a = !0, m = Sv(
                u,
                null,
                v,
                m
              ), u.child = m; m; )
                m.flags = m.flags & -3 | 4096, m = m.sibling;
            }
          else {
            if (vu(), v === O) {
              u = Pi(
                l,
                u,
                m
              );
              break e;
            }
            Wr(l, u, v, m);
          }
          u = u.child;
        }
        return u;
      case 26:
        return xi(l, u), l === null ? (m = uf(
          u.type,
          null,
          u.pendingProps,
          null
        )) ? u.memoizedState = m : _n || (m = u.type, l = u.pendingProps, v = Iu(
          be.current
        ).createElement(m), v[Gt] = u, v[Dt] = l, co(v, m, l), kt(v), u.stateNode = v) : u.memoizedState = uf(
          u.type,
          l.memoizedProps,
          u.pendingProps,
          l.memoizedState
        ), null;
      case 27:
        return ze(u), l === null && _n && (v = u.stateNode = lf(
          u.type,
          u.pendingProps,
          be.current
        ), Ba = u, $a = !0, O = $r, Al(u.type) ? (ch = O, $r = Go(v.firstChild)) : $r = O), Wr(
          l,
          u,
          u.pendingProps.children,
          m
        ), xi(l, u), l === null && (u.flags |= 4194304), u.child;
      case 5:
        return l === null && _n && ((O = v = $r) && (v = wC(
          v,
          u.type,
          u.pendingProps,
          $a
        ), v !== null ? (u.stateNode = v, Ba = u, $r = Go(v.firstChild), $a = !1, O = !0) : O = !1), O || Ji(u)), ze(u), O = u.type, R = u.pendingProps, B = l !== null ? l.memoizedProps : null, v = R.children, af(O, R) ? v = null : B !== null && af(O, B) && (u.flags |= 32), u.memoizedState !== null && (O = Am(
          l,
          u,
          gC,
          null,
          null,
          m
        ), mh._currentValue = O), xi(l, u), Wr(l, u, v, m), u.child;
      case 6:
        return l === null && _n && ((l = m = $r) && (m = Rn(
          m,
          u.pendingProps,
          $a
        ), m !== null ? (u.stateNode = m, Ba = u, $r = null, l = !0) : l = !1), l || Ji(u)), null;
      case 13:
        return Kv(l, u, m);
      case 4:
        return De(
          u,
          u.stateNode.containerInfo
        ), v = u.pendingProps, l === null ? u.child = xu(
          u,
          null,
          v,
          m
        ) : Wr(l, u, v, m), u.child;
      case 11:
        return Uv(
          l,
          u,
          u.type,
          u.pendingProps,
          m
        );
      case 7:
        return Wr(
          l,
          u,
          u.pendingProps,
          m
        ), u.child;
      case 8:
        return Wr(
          l,
          u,
          u.pendingProps.children,
          m
        ), u.child;
      case 12:
        return Wr(
          l,
          u,
          u.pendingProps.children,
          m
        ), u.child;
      case 10:
        return v = u.pendingProps, Lo(u, u.type, v.value), Wr(l, u, v.children, m), u.child;
      case 9:
        return O = u.type._context, v = u.pendingProps.children, sn(u), O = rt(O), v = v(O), u.flags |= 1, Wr(l, u, v, m), u.child;
      case 14:
        return Xv(
          l,
          u,
          u.type,
          u.pendingProps,
          m
        );
      case 15:
        return Gv(
          l,
          u,
          u.type,
          u.pendingProps,
          m
        );
      case 19:
        return Yv(l, u, m);
      case 31:
        return ry(l, u, m);
      case 22:
        return ny(
          l,
          u,
          m,
          u.pendingProps
        );
      case 24:
        return sn(u), v = rt(ba), l === null ? (O = Si(), O === null && (O = kr, R = Sm(), O.pooledCache = R, R.refCount++, R !== null && (O.pooledCacheLanes |= m), O = R), u.memoizedState = { parent: v, cache: O }, Om(u), Lo(u, ba, O)) : ((l.lanes & m) !== 0 && (Dp(l, u), Yl(u, null, null, m), Pu()), O = l.memoizedState, R = u.memoizedState, O.parent !== v ? (O = { parent: v, cache: v }, u.memoizedState = O, u.lanes === 0 && (u.memoizedState = u.updateQueue.baseState = O), Lo(u, ba, v)) : (v = R.cache, Lo(u, ba, v), v !== O.cache && Kl(
          u,
          [ba],
          m,
          !0
        ))), Wr(
          l,
          u,
          u.pendingProps.children,
          m
        ), u.child;
      case 29:
        throw u.pendingProps;
    }
    throw Error(a(156, u.tag));
  }
  function rs(l) {
    l.flags |= 4;
  }
  function Jv(l, u, m, v, O) {
    if ((u = (l.mode & 32) !== 0) && (u = !1), u) {
      if (l.flags |= 16777216, (O & 335544128) === O)
        if (l.stateNode.complete) l.flags |= 8192;
        else if (my()) l.flags |= 8192;
        else
          throw Su = wc, yc;
    } else l.flags &= -16777217;
  }
  function Zv(l, u) {
    if (u.type !== "stylesheet" || (u.state.loading & 4) !== 0)
      l.flags &= -16777217;
    else if (l.flags |= 16777216, !oi(u))
      if (my()) l.flags |= 8192;
      else
        throw Su = wc, yc;
  }
  function xo(l, u) {
    u !== null && (l.flags |= 4), l.flags & 16384 && (u = l.tag !== 22 ? jn() : 536870912, l.lanes |= u, ea |= u);
  }
  function Wd(l, u) {
    if (!_n)
      switch (l.tailMode) {
        case "hidden":
          u = l.tail;
          for (var m = null; u !== null; )
            u.alternate !== null && (m = u), u = u.sibling;
          m === null ? l.tail = null : m.sibling = null;
          break;
        case "collapsed":
          m = l.tail;
          for (var v = null; m !== null; )
            m.alternate !== null && (v = m), m = m.sibling;
          v === null ? u || l.tail === null ? l.tail = null : l.tail.sibling = null : v.sibling = null;
      }
  }
  function ln(l) {
    var u = l.alternate !== null && l.alternate.child === l.child, m = 0, v = 0;
    if (u)
      for (var O = l.child; O !== null; )
        m |= O.lanes | O.childLanes, v |= O.subtreeFlags & 65011712, v |= O.flags & 65011712, O.return = l, O = O.sibling;
    else
      for (O = l.child; O !== null; )
        m |= O.lanes | O.childLanes, v |= O.subtreeFlags, v |= O.flags, O.return = l, O = O.sibling;
    return l.subtreeFlags |= v, l.childLanes = m, u;
  }
  function ay(l, u, m) {
    var v = u.pendingProps;
    switch (Tp(u), u.tag) {
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return ln(u), null;
      case 1:
        return ln(u), null;
      case 3:
        return m = u.stateNode, v = null, l !== null && (v = l.memoizedState.cache), u.memoizedState.cache !== v && (u.flags |= 2048), Cl(ba), Me(), m.pendingContext && (m.context = m.pendingContext, m.pendingContext = null), (l === null || l.child === null) && (ql(u) ? rs(u) : l === null || l.memoizedState.isDehydrated && (u.flags & 256) === 0 || (u.flags |= 1024, pv())), ln(u), null;
      case 26:
        var O = u.type, R = u.memoizedState;
        return l === null ? (rs(u), R !== null ? (ln(u), Zv(u, R)) : (ln(u), Jv(
          u,
          O,
          null,
          v,
          m
        ))) : R ? R !== l.memoizedState ? (rs(u), ln(u), Zv(u, R)) : (ln(u), u.flags &= -16777217) : (l = l.memoizedProps, l !== v && rs(u), ln(u), Jv(
          u,
          O,
          l,
          v,
          m
        )), null;
      case 27:
        if (le(u), m = be.current, O = u.type, l !== null && u.stateNode != null)
          l.memoizedProps !== v && rs(u);
        else {
          if (!v) {
            if (u.stateNode === null)
              throw Error(a(166));
            return ln(u), null;
          }
          l = oe.current, ql(u) ? ym(u) : (l = lf(O, v, m), u.stateNode = l, rs(u));
        }
        return ln(u), null;
      case 5:
        if (le(u), O = u.type, l !== null && u.stateNode != null)
          l.memoizedProps !== v && rs(u);
        else {
          if (!v) {
            if (u.stateNode === null)
              throw Error(a(166));
            return ln(u), null;
          }
          if (R = oe.current, ql(u))
            ym(u);
          else {
            var B = Iu(
              be.current
            );
            switch (R) {
              case 1:
                R = B.createElementNS(
                  "http://www.w3.org/2000/svg",
                  O
                );
                break;
              case 2:
                R = B.createElementNS(
                  "http://www.w3.org/1998/Math/MathML",
                  O
                );
                break;
              default:
                switch (O) {
                  case "svg":
                    R = B.createElementNS(
                      "http://www.w3.org/2000/svg",
                      O
                    );
                    break;
                  case "math":
                    R = B.createElementNS(
                      "http://www.w3.org/1998/Math/MathML",
                      O
                    );
                    break;
                  case "script":
                    R = B.createElement("div"), R.innerHTML = "<script><\/script>", R = R.removeChild(
                      R.firstChild
                    );
                    break;
                  case "select":
                    R = typeof v.is == "string" ? B.createElement("select", {
                      is: v.is
                    }) : B.createElement("select"), v.multiple ? R.multiple = !0 : v.size && (R.size = v.size);
                    break;
                  default:
                    R = typeof v.is == "string" ? B.createElement(O, { is: v.is }) : B.createElement(O);
                }
            }
            R[Gt] = u, R[Dt] = v;
            e: for (B = u.child; B !== null; ) {
              if (B.tag === 5 || B.tag === 6)
                R.appendChild(B.stateNode);
              else if (B.tag !== 4 && B.tag !== 27 && B.child !== null) {
                B.child.return = B, B = B.child;
                continue;
              }
              if (B === u) break e;
              for (; B.sibling === null; ) {
                if (B.return === null || B.return === u)
                  break e;
                B = B.return;
              }
              B.sibling.return = B.return, B = B.sibling;
            }
            u.stateNode = R;
            e: switch (co(R, O, v), O) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                v = !!v.autoFocus;
                break e;
              case "img":
                v = !0;
                break e;
              default:
                v = !1;
            }
            v && rs(u);
          }
        }
        return ln(u), Jv(
          u,
          u.type,
          l === null ? null : l.memoizedProps,
          u.pendingProps,
          m
        ), null;
      case 6:
        if (l && u.stateNode != null)
          l.memoizedProps !== v && rs(u);
        else {
          if (typeof v != "string" && u.stateNode === null)
            throw Error(a(166));
          if (l = be.current, ql(u)) {
            if (l = u.stateNode, m = u.memoizedProps, v = null, O = Ba, O !== null)
              switch (O.tag) {
                case 27:
                case 5:
                  v = O.memoizedProps;
              }
            l[Gt] = u, l = !!(l.nodeValue === m || v !== null && v.suppressHydrationWarning === !0 || x2(l.nodeValue, m)), l || Ji(u, !0);
          } else
            l = Iu(l).createTextNode(
              v
            ), l[Gt] = u, u.stateNode = l;
        }
        return ln(u), null;
      case 31:
        if (m = u.memoizedState, l === null || l.memoizedState !== null) {
          if (v = ql(u), m !== null) {
            if (l === null) {
              if (!v) throw Error(a(318));
              if (l = u.memoizedState, l = l !== null ? l.dehydrated : null, !l) throw Error(a(557));
              l[Gt] = u;
            } else
              vu(), (u.flags & 128) === 0 && (u.memoizedState = null), u.flags |= 4;
            ln(u), l = !1;
          } else
            m = pv(), l !== null && l.memoizedState !== null && (l.memoizedState.hydrationErrors = m), l = !0;
          if (!l)
            return u.flags & 256 ? (Fo(u), u) : (Fo(u), null);
          if ((u.flags & 128) !== 0)
            throw Error(a(558));
        }
        return ln(u), null;
      case 13:
        if (v = u.memoizedState, l === null || l.memoizedState !== null && l.memoizedState.dehydrated !== null) {
          if (O = ql(u), v !== null && v.dehydrated !== null) {
            if (l === null) {
              if (!O) throw Error(a(318));
              if (O = u.memoizedState, O = O !== null ? O.dehydrated : null, !O) throw Error(a(317));
              O[Gt] = u;
            } else
              vu(), (u.flags & 128) === 0 && (u.memoizedState = null), u.flags |= 4;
            ln(u), O = !1;
          } else
            O = pv(), l !== null && l.memoizedState !== null && (l.memoizedState.hydrationErrors = O), O = !0;
          if (!O)
            return u.flags & 256 ? (Fo(u), u) : (Fo(u), null);
        }
        return Fo(u), (u.flags & 128) !== 0 ? (u.lanes = m, u) : (m = v !== null, l = l !== null && l.memoizedState !== null, m && (v = u.child, O = null, v.alternate !== null && v.alternate.memoizedState !== null && v.alternate.memoizedState.cachePool !== null && (O = v.alternate.memoizedState.cachePool.pool), R = null, v.memoizedState !== null && v.memoizedState.cachePool !== null && (R = v.memoizedState.cachePool.pool), R !== O && (v.flags |= 2048)), m !== l && m && (u.child.flags |= 8192), xo(u, u.updateQueue), ln(u), null);
      case 4:
        return Me(), l === null && rf(u.stateNode.containerInfo), ln(u), null;
      case 10:
        return Cl(u.type), ln(u), null;
      case 19:
        if (ne(Br), v = u.memoizedState, v === null) return ln(u), null;
        if (O = (u.flags & 128) !== 0, R = v.rendering, R === null)
          if (O) Wd(v, !1);
          else {
            if (jr !== 0 || l !== null && (l.flags & 128) !== 0)
              for (l = u.child; l !== null; ) {
                if (R = Dd(l), R !== null) {
                  for (u.flags |= 128, Wd(v, !1), l = R.updateQueue, u.updateQueue = l, xo(u, l), u.subtreeFlags = 0, l = m, m = u.child; m !== null; )
                    dv(m, l), m = m.sibling;
                  return ae(
                    Br,
                    Br.current & 1 | 2
                  ), _n && Qi(u, v.treeForkCount), u.child;
                }
                l = l.sibling;
              }
            v.tail !== null && Fe() > dr && (u.flags |= 128, O = !0, Wd(v, !1), u.lanes = 4194304);
          }
        else {
          if (!O)
            if (l = Dd(R), l !== null) {
              if (u.flags |= 128, O = !0, l = l.updateQueue, u.updateQueue = l, xo(u, l), Wd(v, !0), v.tail === null && v.tailMode === "hidden" && !R.alternate && !_n)
                return ln(u), null;
            } else
              2 * Fe() - v.renderingStartTime > dr && m !== 536870912 && (u.flags |= 128, O = !0, Wd(v, !1), u.lanes = 4194304);
          v.isBackwards ? (R.sibling = u.child, u.child = R) : (l = v.last, l !== null ? l.sibling = R : u.child = R, v.last = R);
        }
        return v.tail !== null ? (l = v.tail, v.rendering = l, v.tail = l.sibling, v.renderingStartTime = Fe(), l.sibling = null, m = Br.current, ae(
          Br,
          O ? m & 1 | 2 : m & 1
        ), _n && Qi(u, v.treeForkCount), l) : (ln(u), null);
      case 22:
      case 23:
        return Fo(u), Ad(), v = u.memoizedState !== null, l !== null ? l.memoizedState !== null !== v && (u.flags |= 8192) : v && (u.flags |= 8192), v ? (m & 536870912) !== 0 && (u.flags & 128) === 0 && (ln(u), u.subtreeFlags & 6 && (u.flags |= 8192)) : ln(u), m = u.updateQueue, m !== null && xo(u, m.retryQueue), m = null, l !== null && l.memoizedState !== null && l.memoizedState.cachePool !== null && (m = l.memoizedState.cachePool.pool), v = null, u.memoizedState !== null && u.memoizedState.cachePool !== null && (v = u.memoizedState.cachePool.pool), v !== m && (u.flags |= 2048), l !== null && ne(wi), null;
      case 24:
        return m = null, l !== null && (m = l.memoizedState.cache), u.memoizedState.cache !== m && (u.flags |= 2048), Cl(ba), ln(u), null;
      case 25:
        return null;
      case 30:
        return null;
    }
    throw Error(a(156, u.tag));
  }
  function oy(l, u) {
    switch (Tp(u), u.tag) {
      case 1:
        return l = u.flags, l & 65536 ? (u.flags = l & -65537 | 128, u) : null;
      case 3:
        return Cl(ba), Me(), l = u.flags, (l & 65536) !== 0 && (l & 128) === 0 ? (u.flags = l & -65537 | 128, u) : null;
      case 26:
      case 27:
      case 5:
        return le(u), null;
      case 31:
        if (u.memoizedState !== null) {
          if (Fo(u), u.alternate === null)
            throw Error(a(340));
          vu();
        }
        return l = u.flags, l & 65536 ? (u.flags = l & -65537 | 128, u) : null;
      case 13:
        if (Fo(u), l = u.memoizedState, l !== null && l.dehydrated !== null) {
          if (u.alternate === null)
            throw Error(a(340));
          vu();
        }
        return l = u.flags, l & 65536 ? (u.flags = l & -65537 | 128, u) : null;
      case 19:
        return ne(Br), null;
      case 4:
        return Me(), null;
      case 10:
        return Cl(u.type), null;
      case 22:
      case 23:
        return Fo(u), Ad(), l !== null && ne(wi), l = u.flags, l & 65536 ? (u.flags = l & -65537 | 128, u) : null;
      case 24:
        return Cl(ba), null;
      case 25:
        return null;
      default:
        return null;
    }
  }
  function iy(l, u) {
    switch (Tp(u), u.tag) {
      case 3:
        Cl(ba), Me();
        break;
      case 26:
      case 27:
      case 5:
        le(u);
        break;
      case 4:
        Me();
        break;
      case 31:
        u.memoizedState !== null && Fo(u);
        break;
      case 13:
        Fo(u);
        break;
      case 19:
        ne(Br);
        break;
      case 10:
        Cl(u.type);
        break;
      case 22:
      case 23:
        Fo(u), Ad(), l !== null && ne(wi);
        break;
      case 24:
        Cl(ba);
    }
  }
  function el(l, u) {
    try {
      var m = u.updateQueue, v = m !== null ? m.lastEffect : null;
      if (v !== null) {
        var O = v.next;
        m = O;
        do {
          if ((m.tag & l) === l) {
            v = void 0;
            var R = m.create, B = m.inst;
            v = R(), B.destroy = v;
          }
          m = m.next;
        } while (m !== O);
      }
    } catch (re) {
      yr(u, u.return, re);
    }
  }
  function ki(l, u, m) {
    try {
      var v = u.updateQueue, O = v !== null ? v.lastEffect : null;
      if (O !== null) {
        var R = O.next;
        v = R;
        do {
          if ((v.tag & l) === l) {
            var B = v.inst, re = B.destroy;
            if (re !== void 0) {
              B.destroy = void 0, O = u;
              var ve = m, He = re;
              try {
                He();
              } catch (Je) {
                yr(
                  O,
                  ve,
                  Je
                );
              }
            }
          }
          v = v.next;
        } while (v !== R);
      }
    } catch (Je) {
      yr(u, u.return, Je);
    }
  }
  function lg(l) {
    var u = l.updateQueue;
    if (u !== null) {
      var m = l.stateNode;
      try {
        ku(u, m);
      } catch (v) {
        yr(l, l.return, v);
      }
    }
  }
  function Du(l, u, m) {
    m.props = Tu(
      l.type,
      l.memoizedProps
    ), m.state = l.memoizedState;
    try {
      m.componentWillUnmount();
    } catch (v) {
      yr(l, u, v);
    }
  }
  function as(l, u) {
    try {
      var m = l.ref;
      if (m !== null) {
        switch (l.tag) {
          case 26:
          case 27:
          case 5:
            var v = l.stateNode;
            break;
          case 30:
            v = l.stateNode;
            break;
          default:
            v = l.stateNode;
        }
        typeof m == "function" ? l.refCleanup = m(v) : m.current = v;
      }
    } catch (O) {
      yr(l, u, O);
    }
  }
  function kl(l, u) {
    var m = l.ref, v = l.refCleanup;
    if (m !== null)
      if (typeof v == "function")
        try {
          v();
        } catch (O) {
          yr(l, u, O);
        } finally {
          l.refCleanup = null, l = l.alternate, l != null && (l.refCleanup = null);
        }
      else if (typeof m == "function")
        try {
          m(null);
        } catch (O) {
          yr(l, u, O);
        }
      else m.current = null;
  }
  function e2(l) {
    var u = l.type, m = l.memoizedProps, v = l.stateNode;
    try {
      e: switch (u) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          m.autoFocus && v.focus();
          break e;
        case "img":
          m.src ? v.src = m.src : m.srcSet && (v.srcset = m.srcSet);
      }
    } catch (O) {
      yr(l, l.return, O);
    }
  }
  function sg(l, u, m) {
    try {
      var v = l.stateNode;
      P2(v, l.type, m, u), v[Dt] = u;
    } catch (O) {
      yr(l, l.return, O);
    }
  }
  function t2(l) {
    return l.tag === 5 || l.tag === 3 || l.tag === 26 || l.tag === 27 && Al(l.type) || l.tag === 4;
  }
  function Vd(l) {
    e: for (; ; ) {
      for (; l.sibling === null; ) {
        if (l.return === null || t2(l.return)) return null;
        l = l.return;
      }
      for (l.sibling.return = l.return, l = l.sibling; l.tag !== 5 && l.tag !== 6 && l.tag !== 18; ) {
        if (l.tag === 27 && Al(l.type) || l.flags & 2 || l.child === null || l.tag === 4) continue e;
        l.child.return = l, l = l.child;
      }
      if (!(l.flags & 2)) return l.stateNode;
    }
  }
  function _d(l, u, m) {
    var v = l.tag;
    if (v === 5 || v === 6)
      l = l.stateNode, u ? (m.nodeType === 9 ? m.body : m.nodeName === "HTML" ? m.ownerDocument.body : m).insertBefore(l, u) : (u = m.nodeType === 9 ? m.body : m.nodeName === "HTML" ? m.ownerDocument.body : m, u.appendChild(l), m = m._reactRootContainer, m != null || u.onclick !== null || (u.onclick = Va));
    else if (v !== 4 && (v === 27 && Al(l.type) && (m = l.stateNode, u = null), l = l.child, l !== null))
      for (_d(l, u, m), l = l.sibling; l !== null; )
        _d(l, u, m), l = l.sibling;
  }
  function Bd(l, u, m) {
    var v = l.tag;
    if (v === 5 || v === 6)
      l = l.stateNode, u ? m.insertBefore(l, u) : m.appendChild(l);
    else if (v !== 4 && (v === 27 && Al(l.type) && (m = l.stateNode), l = l.child, l !== null))
      for (Bd(l, u, m), l = l.sibling; l !== null; )
        Bd(l, u, m), l = l.sibling;
  }
  function n2(l) {
    var u = l.stateNode, m = l.memoizedProps;
    try {
      for (var v = l.type, O = u.attributes; O.length; )
        u.removeAttributeNode(O[0]);
      co(u, v, m), u[Gt] = l, u[Dt] = m;
    } catch (R) {
      yr(l, l.return, R);
    }
  }
  var _s = !1, Oa = !1, ug = !1, r2 = typeof WeakSet == "function" ? WeakSet : Set, qa = null;
  function Ud(l, u) {
    if (l = l.containerInfo, Tg = Ia, l = hu(l), fm(l)) {
      if ("selectionStart" in l)
        var m = {
          start: l.selectionStart,
          end: l.selectionEnd
        };
      else
        e: {
          m = (m = l.ownerDocument) && m.defaultView || window;
          var v = m.getSelection && m.getSelection();
          if (v && v.rangeCount !== 0) {
            m = v.anchorNode;
            var O = v.anchorOffset, R = v.focusNode;
            v = v.focusOffset;
            try {
              m.nodeType, R.nodeType;
            } catch {
              m = null;
              break e;
            }
            var B = 0, re = -1, ve = -1, He = 0, Je = 0, nt = l, We = null;
            t: for (; ; ) {
              for (var Ge; nt !== m || O !== 0 && nt.nodeType !== 3 || (re = B + O), nt !== R || v !== 0 && nt.nodeType !== 3 || (ve = B + v), nt.nodeType === 3 && (B += nt.nodeValue.length), (Ge = nt.firstChild) !== null; )
                We = nt, nt = Ge;
              for (; ; ) {
                if (nt === l) break t;
                if (We === m && ++He === O && (re = B), We === R && ++Je === v && (ve = B), (Ge = nt.nextSibling) !== null) break;
                nt = We, We = nt.parentNode;
              }
              nt = Ge;
            }
            m = re === -1 || ve === -1 ? null : { start: re, end: ve };
          } else m = null;
        }
      m = m || { start: 0, end: 0 };
    } else m = null;
    for (Rg = { focusedElem: l, selectionRange: m }, Ia = !1, qa = u; qa !== null; )
      if (u = qa, l = u.child, (u.subtreeFlags & 1028) !== 0 && l !== null)
        l.return = u, qa = l;
      else
        for (; qa !== null; ) {
          switch (u = qa, R = u.alternate, l = u.flags, u.tag) {
            case 0:
              if ((l & 4) !== 0 && (l = u.updateQueue, l = l !== null ? l.events : null, l !== null))
                for (m = 0; m < l.length; m++)
                  O = l[m], O.ref.impl = O.nextImpl;
              break;
            case 11:
            case 15:
              break;
            case 1:
              if ((l & 1024) !== 0 && R !== null) {
                l = void 0, m = u, O = R.memoizedProps, R = R.memoizedState, v = m.stateNode;
                try {
                  var At = Tu(
                    m.type,
                    O
                  );
                  l = v.getSnapshotBeforeUpdate(
                    At,
                    R
                  ), v.__reactInternalSnapshotBeforeUpdate = l;
                } catch (Zt) {
                  yr(
                    m,
                    m.return,
                    Zt
                  );
                }
              }
              break;
            case 3:
              if ((l & 1024) !== 0) {
                if (l = u.stateNode.containerInfo, m = l.nodeType, m === 9)
                  uh(l);
                else if (m === 1)
                  switch (l.nodeName) {
                    case "HEAD":
                    case "HTML":
                    case "BODY":
                      uh(l);
                      break;
                    default:
                      l.textContent = "";
                  }
              }
              break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
              break;
            default:
              if ((l & 1024) !== 0) throw Error(a(163));
          }
          if (l = u.sibling, l !== null) {
            l.return = u.return, qa = l;
            break;
          }
          qa = u.return;
        }
  }
  function Xm(l, u, m) {
    var v = m.flags;
    switch (m.tag) {
      case 0:
      case 11:
      case 15:
        Bs(l, m), v & 4 && el(5, m);
        break;
      case 1:
        if (Bs(l, m), v & 4)
          if (l = m.stateNode, u === null)
            try {
              l.componentDidMount();
            } catch (B) {
              yr(m, m.return, B);
            }
          else {
            var O = Tu(
              m.type,
              u.memoizedProps
            );
            u = u.memoizedState;
            try {
              l.componentDidUpdate(
                O,
                u,
                l.__reactInternalSnapshotBeforeUpdate
              );
            } catch (B) {
              yr(
                m,
                m.return,
                B
              );
            }
          }
        v & 64 && lg(m), v & 512 && as(m, m.return);
        break;
      case 3:
        if (Bs(l, m), v & 64 && (l = m.updateQueue, l !== null)) {
          if (u = null, m.child !== null)
            switch (m.child.tag) {
              case 27:
              case 5:
                u = m.child.stateNode;
                break;
              case 1:
                u = m.child.stateNode;
            }
          try {
            ku(l, u);
          } catch (B) {
            yr(m, m.return, B);
          }
        }
        break;
      case 27:
        u === null && v & 4 && n2(m);
      case 26:
      case 5:
        Bs(l, m), u === null && v & 4 && e2(m), v & 512 && as(m, m.return);
        break;
      case 12:
        Bs(l, m);
        break;
      case 31:
        Bs(l, m), v & 4 && ly(l, m);
        break;
      case 13:
        Bs(l, m), v & 4 && i2(l, m), v & 64 && (l = m.memoizedState, l !== null && (l = l.dehydrated, l !== null && (m = Mi.bind(
          null,
          m
        ), of(l, m))));
        break;
      case 22:
        if (v = m.memoizedState !== null || _s, !v) {
          u = u !== null && u.memoizedState !== null || Oa, O = _s;
          var R = Oa;
          _s = v, (Oa = u) && !R ? Ml(
            l,
            m,
            (m.subtreeFlags & 8772) !== 0
          ) : Bs(l, m), _s = O, Oa = R;
        }
        break;
      case 30:
        break;
      default:
        Bs(l, m);
    }
  }
  function a2(l) {
    var u = l.alternate;
    u !== null && (l.alternate = null, a2(u)), l.child = null, l.deletions = null, l.sibling = null, l.tag === 5 && (u = l.stateNode, u !== null && Rr(u)), l.stateNode = null, l.return = null, l.dependencies = null, l.memoizedProps = null, l.memoizedState = null, l.pendingProps = null, l.stateNode = null, l.updateQueue = null;
  }
  var zr = null, _o = !1;
  function os(l, u, m) {
    for (m = m.child; m !== null; )
      o2(l, u, m), m = m.sibling;
  }
  function o2(l, u, m) {
    if (ut && typeof ut.onCommitFiberUnmount == "function")
      try {
        ut.onCommitFiberUnmount(Ct, m);
      } catch {
      }
    switch (m.tag) {
      case 26:
        Oa || kl(m, u), os(
          l,
          u,
          m
        ), m.memoizedState ? m.memoizedState.count-- : m.stateNode && (m = m.stateNode, m.parentNode.removeChild(m));
        break;
      case 27:
        Oa || kl(m, u);
        var v = zr, O = _o;
        Al(m.type) && (zr = m.stateNode, _o = !1), os(
          l,
          u,
          m
        ), Hc(m.stateNode), zr = v, _o = O;
        break;
      case 5:
        Oa || kl(m, u);
      case 6:
        if (v = zr, O = _o, zr = null, os(
          l,
          u,
          m
        ), zr = v, _o = O, zr !== null)
          if (_o)
            try {
              (zr.nodeType === 9 ? zr.body : zr.nodeName === "HTML" ? zr.ownerDocument.body : zr).removeChild(m.stateNode);
            } catch (R) {
              yr(
                m,
                u,
                R
              );
            }
          else
            try {
              zr.removeChild(m.stateNode);
            } catch (R) {
              yr(
                m,
                u,
                R
              );
            }
        break;
      case 18:
        zr !== null && (_o ? (l = zr, T2(
          l.nodeType === 9 ? l.body : l.nodeName === "HTML" ? l.ownerDocument.body : l,
          m.stateNode
        ), vf(l)) : T2(zr, m.stateNode));
        break;
      case 4:
        v = zr, O = _o, zr = m.stateNode.containerInfo, _o = !0, os(
          l,
          u,
          m
        ), zr = v, _o = O;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        ki(2, m, u), Oa || ki(4, m, u), os(
          l,
          u,
          m
        );
        break;
      case 1:
        Oa || (kl(m, u), v = m.stateNode, typeof v.componentWillUnmount == "function" && Du(
          m,
          u,
          v
        )), os(
          l,
          u,
          m
        );
        break;
      case 21:
        os(
          l,
          u,
          m
        );
        break;
      case 22:
        Oa = (v = Oa) || m.memoizedState !== null, os(
          l,
          u,
          m
        ), Oa = v;
        break;
      default:
        os(
          l,
          u,
          m
        );
    }
  }
  function ly(l, u) {
    if (u.memoizedState === null && (l = u.alternate, l !== null && (l = l.memoizedState, l !== null))) {
      l = l.dehydrated;
      try {
        vf(l);
      } catch (m) {
        yr(u, u.return, m);
      }
    }
  }
  function i2(l, u) {
    if (u.memoizedState === null && (l = u.alternate, l !== null && (l = l.memoizedState, l !== null && (l = l.dehydrated, l !== null))))
      try {
        vf(l);
      } catch (m) {
        yr(u, u.return, m);
      }
  }
  function Gm(l) {
    switch (l.tag) {
      case 31:
      case 13:
      case 19:
        var u = l.stateNode;
        return u === null && (u = l.stateNode = new r2()), u;
      case 22:
        return l = l.stateNode, u = l._retryCache, u === null && (u = l._retryCache = new r2()), u;
      default:
        throw Error(a(435, l.tag));
    }
  }
  function qm(l, u) {
    var m = Gm(l);
    u.forEach(function(v) {
      if (!m.has(v)) {
        m.add(v);
        var O = Oy.bind(null, l, v);
        v.then(O, O);
      }
    });
  }
  function Bo(l, u) {
    var m = u.deletions;
    if (m !== null)
      for (var v = 0; v < m.length; v++) {
        var O = m[v], R = l, B = u, re = B;
        e: for (; re !== null; ) {
          switch (re.tag) {
            case 27:
              if (Al(re.type)) {
                zr = re.stateNode, _o = !1;
                break e;
              }
              break;
            case 5:
              zr = re.stateNode, _o = !1;
              break e;
            case 3:
            case 4:
              zr = re.stateNode.containerInfo, _o = !0;
              break e;
          }
          re = re.return;
        }
        if (zr === null) throw Error(a(160));
        o2(R, B, O), zr = null, _o = !1, R = O.alternate, R !== null && (R.return = null), O.return = null;
      }
    if (u.subtreeFlags & 13886)
      for (u = u.child; u !== null; )
        cg(u, l), u = u.sibling;
  }
  var En = null;
  function cg(l, u) {
    var m = l.alternate, v = l.flags;
    switch (l.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        Bo(u, l), ei(l), v & 4 && (ki(3, l, l.return), el(3, l), ki(5, l, l.return));
        break;
      case 1:
        Bo(u, l), ei(l), v & 512 && (Oa || m === null || kl(m, m.return)), v & 64 && _s && (l = l.updateQueue, l !== null && (v = l.callbacks, v !== null && (m = l.shared.hiddenCallbacks, l.shared.hiddenCallbacks = m === null ? v : m.concat(v))));
        break;
      case 26:
        var O = En;
        if (Bo(u, l), ei(l), v & 512 && (Oa || m === null || kl(m, m.return)), v & 4) {
          var R = m !== null ? m.memoizedState : null;
          if (v = l.memoizedState, m === null)
            if (v === null)
              if (l.stateNode === null) {
                e: {
                  v = l.type, m = l.memoizedProps, O = O.ownerDocument || O;
                  t: switch (v) {
                    case "title":
                      R = O.getElementsByTagName("title")[0], (!R || R[qn] || R[Gt] || R.namespaceURI === "http://www.w3.org/2000/svg" || R.hasAttribute("itemprop")) && (R = O.createElement(v), O.head.insertBefore(
                        R,
                        O.querySelector("head > title")
                      )), co(R, v, m), R[Gt] = l, kt(R), v = R;
                      break e;
                    case "link":
                      var B = D2(
                        "link",
                        "href",
                        O
                      ).get(v + (m.href || ""));
                      if (B) {
                        for (var re = 0; re < B.length; re++)
                          if (R = B[re], R.getAttribute("href") === (m.href == null || m.href === "" ? null : m.href) && R.getAttribute("rel") === (m.rel == null ? null : m.rel) && R.getAttribute("title") === (m.title == null ? null : m.title) && R.getAttribute("crossorigin") === (m.crossOrigin == null ? null : m.crossOrigin)) {
                            B.splice(re, 1);
                            break t;
                          }
                      }
                      R = O.createElement(v), co(R, v, m), O.head.appendChild(R);
                      break;
                    case "meta":
                      if (B = D2(
                        "meta",
                        "content",
                        O
                      ).get(v + (m.content || ""))) {
                        for (re = 0; re < B.length; re++)
                          if (R = B[re], R.getAttribute("content") === (m.content == null ? null : "" + m.content) && R.getAttribute("name") === (m.name == null ? null : m.name) && R.getAttribute("property") === (m.property == null ? null : m.property) && R.getAttribute("http-equiv") === (m.httpEquiv == null ? null : m.httpEquiv) && R.getAttribute("charset") === (m.charSet == null ? null : m.charSet)) {
                            B.splice(re, 1);
                            break t;
                          }
                      }
                      R = O.createElement(v), co(R, v, m), O.head.appendChild(R);
                      break;
                    default:
                      throw Error(a(468, v));
                  }
                  R[Gt] = l, kt(R), v = R;
                }
                l.stateNode = v;
              } else
                zg(
                  O,
                  l.type,
                  l.stateNode
                );
            else
              l.stateNode = N2(
                O,
                v,
                l.memoizedProps
              );
          else
            R !== v ? (R === null ? m.stateNode !== null && (m = m.stateNode, m.parentNode.removeChild(m)) : R.count--, v === null ? zg(
              O,
              l.type,
              l.stateNode
            ) : N2(
              O,
              v,
              l.memoizedProps
            )) : v === null && l.stateNode !== null && sg(
              l,
              l.memoizedProps,
              m.memoizedProps
            );
        }
        break;
      case 27:
        Bo(u, l), ei(l), v & 512 && (Oa || m === null || kl(m, m.return)), m !== null && v & 4 && sg(
          l,
          l.memoizedProps,
          m.memoizedProps
        );
        break;
      case 5:
        if (Bo(u, l), ei(l), v & 512 && (Oa || m === null || kl(m, m.return)), l.flags & 32) {
          O = l.stateNode;
          try {
            ka(O, "");
          } catch (At) {
            yr(l, l.return, At);
          }
        }
        v & 4 && l.stateNode != null && (O = l.memoizedProps, sg(
          l,
          O,
          m !== null ? m.memoizedProps : O
        )), v & 1024 && (ug = !0);
        break;
      case 6:
        if (Bo(u, l), ei(l), v & 4) {
          if (l.stateNode === null)
            throw Error(a(162));
          v = l.memoizedProps, m = l.stateNode;
          try {
            m.nodeValue = v;
          } catch (At) {
            yr(l, l.return, At);
          }
        }
        break;
      case 3:
        if (ff = null, O = En, En = Eo(u.containerInfo), Bo(u, l), En = O, ei(l), v & 4 && m !== null && m.memoizedState.isDehydrated)
          try {
            vf(u.containerInfo);
          } catch (At) {
            yr(l, l.return, At);
          }
        ug && (ug = !1, l2(l));
        break;
      case 4:
        v = En, En = Eo(
          l.stateNode.containerInfo
        ), Bo(u, l), ei(l), En = v;
        break;
      case 12:
        Bo(u, l), ei(l);
        break;
      case 31:
        Bo(u, l), ei(l), v & 4 && (v = l.updateQueue, v !== null && (l.updateQueue = null, qm(l, v)));
        break;
      case 13:
        Bo(u, l), ei(l), l.child.flags & 8192 && l.memoizedState !== null != (m !== null && m.memoizedState !== null) && (Rl = Fe()), v & 4 && (v = l.updateQueue, v !== null && (l.updateQueue = null, qm(l, v)));
        break;
      case 22:
        O = l.memoizedState !== null;
        var ve = m !== null && m.memoizedState !== null, He = _s, Je = Oa;
        if (_s = He || O, Oa = Je || ve, Bo(u, l), Oa = Je, _s = He, ei(l), v & 8192)
          e: for (u = l.stateNode, u._visibility = O ? u._visibility & -2 : u._visibility | 1, O && (m === null || ve || _s || Oa || Nc(l)), m = null, u = l; ; ) {
            if (u.tag === 5 || u.tag === 26) {
              if (m === null) {
                ve = m = u;
                try {
                  if (R = ve.stateNode, O)
                    B = R.style, typeof B.setProperty == "function" ? B.setProperty("display", "none", "important") : B.display = "none";
                  else {
                    re = ve.stateNode;
                    var nt = ve.memoizedProps.style, We = nt != null && nt.hasOwnProperty("display") ? nt.display : null;
                    re.style.display = We == null || typeof We == "boolean" ? "" : ("" + We).trim();
                  }
                } catch (At) {
                  yr(ve, ve.return, At);
                }
              }
            } else if (u.tag === 6) {
              if (m === null) {
                ve = u;
                try {
                  ve.stateNode.nodeValue = O ? "" : ve.memoizedProps;
                } catch (At) {
                  yr(ve, ve.return, At);
                }
              }
            } else if (u.tag === 18) {
              if (m === null) {
                ve = u;
                try {
                  var Ge = ve.stateNode;
                  O ? Sa(Ge, !0) : Sa(ve.stateNode, !1);
                } catch (At) {
                  yr(ve, ve.return, At);
                }
              }
            } else if ((u.tag !== 22 && u.tag !== 23 || u.memoizedState === null || u === l) && u.child !== null) {
              u.child.return = u, u = u.child;
              continue;
            }
            if (u === l) break e;
            for (; u.sibling === null; ) {
              if (u.return === null || u.return === l) break e;
              m === u && (m = null), u = u.return;
            }
            m === u && (m = null), u.sibling.return = u.return, u = u.sibling;
          }
        v & 4 && (v = l.updateQueue, v !== null && (m = v.retryQueue, m !== null && (v.retryQueue = null, qm(l, m))));
        break;
      case 19:
        Bo(u, l), ei(l), v & 4 && (v = l.updateQueue, v !== null && (l.updateQueue = null, qm(l, v)));
        break;
      case 30:
        break;
      case 21:
        break;
      default:
        Bo(u, l), ei(l);
    }
  }
  function ei(l) {
    var u = l.flags;
    if (u & 2) {
      try {
        for (var m, v = l.return; v !== null; ) {
          if (t2(v)) {
            m = v;
            break;
          }
          v = v.return;
        }
        if (m == null) throw Error(a(160));
        switch (m.tag) {
          case 27:
            var O = m.stateNode, R = Vd(l);
            Bd(l, R, O);
            break;
          case 5:
            var B = m.stateNode;
            m.flags & 32 && (ka(B, ""), m.flags &= -33);
            var re = Vd(l);
            Bd(l, re, B);
            break;
          case 3:
          case 4:
            var ve = m.stateNode.containerInfo, He = Vd(l);
            _d(
              l,
              He,
              ve
            );
            break;
          default:
            throw Error(a(161));
        }
      } catch (Je) {
        yr(l, l.return, Je);
      }
      l.flags &= -3;
    }
    u & 4096 && (l.flags &= -4097);
  }
  function l2(l) {
    if (l.subtreeFlags & 1024)
      for (l = l.child; l !== null; ) {
        var u = l;
        l2(u), u.tag === 5 && u.flags & 1024 && u.stateNode.reset(), l = l.sibling;
      }
  }
  function Bs(l, u) {
    if (u.subtreeFlags & 8772)
      for (u = u.child; u !== null; )
        Xm(l, u.alternate, u), u = u.sibling;
  }
  function Nc(l) {
    for (l = l.child; l !== null; ) {
      var u = l;
      switch (u.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          ki(4, u, u.return), Nc(u);
          break;
        case 1:
          kl(u, u.return);
          var m = u.stateNode;
          typeof m.componentWillUnmount == "function" && Du(
            u,
            u.return,
            m
          ), Nc(u);
          break;
        case 27:
          Hc(u.stateNode);
        case 26:
        case 5:
          kl(u, u.return), Nc(u);
          break;
        case 22:
          u.memoizedState === null && Nc(u);
          break;
        case 30:
          Nc(u);
          break;
        default:
          Nc(u);
      }
      l = l.sibling;
    }
  }
  function Ml(l, u, m) {
    for (m = m && (u.subtreeFlags & 8772) !== 0, u = u.child; u !== null; ) {
      var v = u.alternate, O = l, R = u, B = R.flags;
      switch (R.tag) {
        case 0:
        case 11:
        case 15:
          Ml(
            O,
            R,
            m
          ), el(4, R);
          break;
        case 1:
          if (Ml(
            O,
            R,
            m
          ), v = R, O = v.stateNode, typeof O.componentDidMount == "function")
            try {
              O.componentDidMount();
            } catch (He) {
              yr(v, v.return, He);
            }
          if (v = R, O = v.updateQueue, O !== null) {
            var re = v.stateNode;
            try {
              var ve = O.shared.hiddenCallbacks;
              if (ve !== null)
                for (O.shared.hiddenCallbacks = null, O = 0; O < ve.length; O++)
                  zp(ve[O], re);
            } catch (He) {
              yr(v, v.return, He);
            }
          }
          m && B & 64 && lg(R), as(R, R.return);
          break;
        case 27:
          n2(R);
        case 26:
        case 5:
          Ml(
            O,
            R,
            m
          ), m && v === null && B & 4 && e2(R), as(R, R.return);
          break;
        case 12:
          Ml(
            O,
            R,
            m
          );
          break;
        case 31:
          Ml(
            O,
            R,
            m
          ), m && B & 4 && ly(O, R);
          break;
        case 13:
          Ml(
            O,
            R,
            m
          ), m && B & 4 && i2(O, R);
          break;
        case 22:
          R.memoizedState === null && Ml(
            O,
            R,
            m
          ), as(R, R.return);
          break;
        case 30:
          break;
        default:
          Ml(
            O,
            R,
            m
          );
      }
      u = u.sibling;
    }
  }
  function dg(l, u) {
    var m = null;
    l !== null && l.memoizedState !== null && l.memoizedState.cachePool !== null && (m = l.memoizedState.cachePool.pool), l = null, u.memoizedState !== null && u.memoizedState.cachePool !== null && (l = u.memoizedState.cachePool.pool), l !== m && (l != null && l.refCount++, m != null && Cm(m));
  }
  function fg(l, u) {
    l = null, u.alternate !== null && (l = u.alternate.memoizedState.cache), u = u.memoizedState.cache, u !== l && (u.refCount++, l != null && Cm(l));
  }
  function tl(l, u, m, v) {
    if (u.subtreeFlags & 10256)
      for (u = u.child; u !== null; )
        Xd(
          l,
          u,
          m,
          v
        ), u = u.sibling;
  }
  function Xd(l, u, m, v) {
    var O = u.flags;
    switch (u.tag) {
      case 0:
      case 11:
      case 15:
        tl(
          l,
          u,
          m,
          v
        ), O & 2048 && el(9, u);
        break;
      case 1:
        tl(
          l,
          u,
          m,
          v
        );
        break;
      case 3:
        tl(
          l,
          u,
          m,
          v
        ), O & 2048 && (l = null, u.alternate !== null && (l = u.alternate.memoizedState.cache), u = u.memoizedState.cache, u !== l && (u.refCount++, l != null && Cm(l)));
        break;
      case 12:
        if (O & 2048) {
          tl(
            l,
            u,
            m,
            v
          ), l = u.stateNode;
          try {
            var R = u.memoizedProps, B = R.id, re = R.onPostCommit;
            typeof re == "function" && re(
              B,
              u.alternate === null ? "mount" : "update",
              l.passiveEffectDuration,
              -0
            );
          } catch (ve) {
            yr(u, u.return, ve);
          }
        } else
          tl(
            l,
            u,
            m,
            v
          );
        break;
      case 31:
        tl(
          l,
          u,
          m,
          v
        );
        break;
      case 13:
        tl(
          l,
          u,
          m,
          v
        );
        break;
      case 23:
        break;
      case 22:
        R = u.stateNode, B = u.alternate, u.memoizedState !== null ? R._visibility & 2 ? tl(
          l,
          u,
          m,
          v
        ) : Km(l, u) : R._visibility & 2 ? tl(
          l,
          u,
          m,
          v
        ) : (R._visibility |= 2, Gd(
          l,
          u,
          m,
          v,
          (u.subtreeFlags & 10256) !== 0 || !1
        )), O & 2048 && dg(B, u);
        break;
      case 24:
        tl(
          l,
          u,
          m,
          v
        ), O & 2048 && fg(u.alternate, u);
        break;
      default:
        tl(
          l,
          u,
          m,
          v
        );
    }
  }
  function Gd(l, u, m, v, O) {
    for (O = O && ((u.subtreeFlags & 10256) !== 0 || !1), u = u.child; u !== null; ) {
      var R = l, B = u, re = m, ve = v, He = B.flags;
      switch (B.tag) {
        case 0:
        case 11:
        case 15:
          Gd(
            R,
            B,
            re,
            ve,
            O
          ), el(8, B);
          break;
        case 23:
          break;
        case 22:
          var Je = B.stateNode;
          B.memoizedState !== null ? Je._visibility & 2 ? Gd(
            R,
            B,
            re,
            ve,
            O
          ) : Km(
            R,
            B
          ) : (Je._visibility |= 2, Gd(
            R,
            B,
            re,
            ve,
            O
          )), O && He & 2048 && dg(
            B.alternate,
            B
          );
          break;
        case 24:
          Gd(
            R,
            B,
            re,
            ve,
            O
          ), O && He & 2048 && fg(B.alternate, B);
          break;
        default:
          Gd(
            R,
            B,
            re,
            ve,
            O
          );
      }
      u = u.sibling;
    }
  }
  function Km(l, u) {
    if (u.subtreeFlags & 10256)
      for (u = u.child; u !== null; ) {
        var m = l, v = u, O = v.flags;
        switch (v.tag) {
          case 22:
            Km(m, v), O & 2048 && dg(
              v.alternate,
              v
            );
            break;
          case 24:
            Km(m, v), O & 2048 && fg(v.alternate, v);
            break;
          default:
            Km(m, v);
        }
        u = u.sibling;
      }
  }
  var ti = 8192;
  function is(l, u, m) {
    if (l.subtreeFlags & ti)
      for (l = l.child; l !== null; )
        sy(
          l,
          u,
          m
        ), l = l.sibling;
  }
  function sy(l, u, m) {
    switch (l.tag) {
      case 26:
        is(
          l,
          u,
          m
        ), l.flags & ti && l.memoizedState !== null && ds(
          m,
          En,
          l.memoizedState,
          l.memoizedProps
        );
        break;
      case 5:
        is(
          l,
          u,
          m
        );
        break;
      case 3:
      case 4:
        var v = En;
        En = Eo(l.stateNode.containerInfo), is(
          l,
          u,
          m
        ), En = v;
        break;
      case 22:
        l.memoizedState === null && (v = l.alternate, v !== null && v.memoizedState !== null ? (v = ti, ti = 16777216, is(
          l,
          u,
          m
        ), ti = v) : is(
          l,
          u,
          m
        ));
        break;
      default:
        is(
          l,
          u,
          m
        );
    }
  }
  function mg(l) {
    var u = l.alternate;
    if (u !== null && (l = u.child, l !== null)) {
      u.child = null;
      do
        u = l.sibling, l.sibling = null, l = u;
      while (l !== null);
    }
  }
  function qd(l) {
    var u = l.deletions;
    if ((l.flags & 16) !== 0) {
      if (u !== null)
        for (var m = 0; m < u.length; m++) {
          var v = u[m];
          qa = v, hg(
            v,
            l
          );
        }
      mg(l);
    }
    if (l.subtreeFlags & 10256)
      for (l = l.child; l !== null; )
        s2(l), l = l.sibling;
  }
  function s2(l) {
    switch (l.tag) {
      case 0:
      case 11:
      case 15:
        qd(l), l.flags & 2048 && ki(9, l, l.return);
        break;
      case 3:
        qd(l);
        break;
      case 12:
        qd(l);
        break;
      case 22:
        var u = l.stateNode;
        l.memoizedState !== null && u._visibility & 2 && (l.return === null || l.return.tag !== 13) ? (u._visibility &= -3, Ym(l)) : qd(l);
        break;
      default:
        qd(l);
    }
  }
  function Ym(l) {
    var u = l.deletions;
    if ((l.flags & 16) !== 0) {
      if (u !== null)
        for (var m = 0; m < u.length; m++) {
          var v = u[m];
          qa = v, hg(
            v,
            l
          );
        }
      mg(l);
    }
    for (l = l.child; l !== null; ) {
      switch (u = l, u.tag) {
        case 0:
        case 11:
        case 15:
          ki(8, u, u.return), Ym(u);
          break;
        case 22:
          m = u.stateNode, m._visibility & 2 && (m._visibility &= -3, Ym(u));
          break;
        default:
          Ym(u);
      }
      l = l.sibling;
    }
  }
  function hg(l, u) {
    for (; qa !== null; ) {
      var m = qa;
      switch (m.tag) {
        case 0:
        case 11:
        case 15:
          ki(8, m, u);
          break;
        case 23:
        case 22:
          if (m.memoizedState !== null && m.memoizedState.cachePool !== null) {
            var v = m.memoizedState.cachePool.pool;
            v != null && v.refCount++;
          }
          break;
        case 24:
          Cm(m.memoizedState.cache);
      }
      if (v = m.child, v !== null) v.return = m, qa = v;
      else
        e: for (m = l; qa !== null; ) {
          v = qa;
          var O = v.sibling, R = v.return;
          if (a2(v), v === m) {
            qa = null;
            break e;
          }
          if (O !== null) {
            O.return = R, qa = O;
            break e;
          }
          qa = R;
        }
    }
  }
  var uy = {
    getCacheForType: function(l) {
      var u = rt(ba), m = u.data.get(l);
      return m === void 0 && (m = l(), u.data.set(l, m)), m;
    },
    cacheSignal: function() {
      return rt(ba).controller.signal;
    }
  }, u2 = typeof WeakMap == "function" ? WeakMap : Map, ir = 0, kr = null, Bn = null, In = 0, br = 0, rn = null, ls = !1, $u = !1, pg = !1, Ol = 0, jr = 0, Tl = 0, Dc = 0, gg = 0, Uo = 0, ea = 0, Qm = null, ta = null, vg = !1, Rl = 0, c2 = 0, dr = 1 / 0, Kd = null, Ur = null, ja = 0, Us = null, zu = null, ss = 0, ni = 0, bg = null, yg = null, Yd = 0, Jm = null;
  function ri() {
    return (ir & 2) !== 0 && In !== 0 ? In & -In : H.T !== null ? Eg() : yn();
  }
  function cy() {
    if (Uo === 0)
      if ((In & 536870912) === 0 || _n) {
        var l = bt;
        bt <<= 1, (bt & 3932160) === 0 && (bt = 262144), Uo = l;
      } else Uo = 536870912;
    return l = Ho.current, l !== null && (l.flags |= 32), Uo;
  }
  function Xo(l, u, m) {
    (l === kr && (br === 2 || br === 9) || l.cancelPendingCommit !== null) && (us(l, 0), Xs(
      l,
      In,
      Uo,
      !1
    )), Ut(l, m), ((ir & 2) === 0 || l !== kr) && (l === kr && ((ir & 2) === 0 && (Dc |= m), jr === 4 && Xs(
      l,
      In,
      Uo,
      !1
    )), cs(l));
  }
  function dy(l, u, m) {
    if ((ir & 6) !== 0) throw Error(a(327));
    var v = !m && (u & 127) === 0 && (u & l.expiredLanes) === 0 || hn(l, u), O = v ? gy(l, u) : Sg(l, u, !0), R = v;
    do {
      if (O === 0) {
        $u && !v && Xs(l, u, 0, !1);
        break;
      } else {
        if (m = l.current.alternate, R && !fy(m)) {
          O = Sg(l, u, !1), R = !1;
          continue;
        }
        if (O === 2) {
          if (R = u, l.errorRecoveryDisabledLanes & R)
            var B = 0;
          else
            B = l.pendingLanes & -536870913, B = B !== 0 ? B : B & 536870912 ? 536870912 : 0;
          if (B !== 0) {
            u = B;
            e: {
              var re = l;
              O = Qm;
              var ve = re.current.memoizedState.isDehydrated;
              if (ve && (us(re, B).flags |= 256), B = Sg(
                re,
                B,
                !1
              ), B !== 2) {
                if (pg && !ve) {
                  re.errorRecoveryDisabledLanes |= R, Dc |= R, O = 4;
                  break e;
                }
                R = ta, ta = O, R !== null && (ta === null ? ta = R : ta.push.apply(
                  ta,
                  R
                ));
              }
              O = B;
            }
            if (R = !1, O !== 2) continue;
          }
        }
        if (O === 1) {
          us(l, 0), Xs(l, u, 0, !0);
          break;
        }
        e: {
          switch (v = l, R = O, R) {
            case 0:
            case 1:
              throw Error(a(345));
            case 4:
              if ((u & 4194048) !== u) break;
            case 6:
              Xs(
                v,
                u,
                Uo,
                !ls
              );
              break e;
            case 2:
              ta = null;
              break;
            case 3:
            case 5:
              break;
            default:
              throw Error(a(329));
          }
          if ((u & 62914560) === u && (O = Rl + 300 - Fe(), 10 < O)) {
            if (Xs(
              v,
              u,
              Uo,
              !ls
            ), Pt(v, 0, !0) !== 0) break e;
            ss = u, v.timeoutHandle = sh(
              Zm.bind(
                null,
                v,
                m,
                ta,
                Kd,
                vg,
                u,
                Uo,
                Dc,
                ea,
                ls,
                R,
                "Throttled",
                -0,
                0
              ),
              O
            );
            break e;
          }
          Zm(
            v,
            m,
            ta,
            Kd,
            vg,
            u,
            Uo,
            Dc,
            ea,
            ls,
            R,
            null,
            -0,
            0
          );
        }
      }
      break;
    } while (!0);
    cs(l);
  }
  function Zm(l, u, m, v, O, R, B, re, ve, He, Je, nt, We, Ge) {
    if (l.timeoutHandle = -1, nt = u.subtreeFlags, nt & 8192 || (nt & 16785408) === 16785408) {
      nt = {
        stylesheets: null,
        count: 0,
        imgCount: 0,
        imgBytes: 0,
        suspenseyImages: [],
        waitingForImages: !0,
        waitingForViewTransition: !1,
        unsuspend: Va
      }, sy(
        u,
        R,
        nt
      );
      var At = (R & 62914560) === R ? Rl - Fe() : (R & 4194048) === R ? c2 - Fe() : 0;
      if (At = z2(
        nt,
        At
      ), At !== null) {
        ss = R, l.cancelPendingCommit = At(
          wy.bind(
            null,
            l,
            u,
            R,
            m,
            v,
            O,
            B,
            re,
            ve,
            Je,
            nt,
            null,
            We,
            Ge
          )
        ), Xs(l, R, B, !He);
        return;
      }
    }
    wy(
      l,
      u,
      R,
      m,
      v,
      O,
      B,
      re,
      ve
    );
  }
  function fy(l) {
    for (var u = l; ; ) {
      var m = u.tag;
      if ((m === 0 || m === 11 || m === 15) && u.flags & 16384 && (m = u.updateQueue, m !== null && (m = m.stores, m !== null)))
        for (var v = 0; v < m.length; v++) {
          var O = m[v], R = O.getSnapshot;
          O = O.value;
          try {
            if (!Co(R(), O)) return !1;
          } catch {
            return !1;
          }
        }
      if (m = u.child, u.subtreeFlags & 16384 && m !== null)
        m.return = u, u = m;
      else {
        if (u === l) break;
        for (; u.sibling === null; ) {
          if (u.return === null || u.return === l) return !0;
          u = u.return;
        }
        u.sibling.return = u.return, u = u.sibling;
      }
    }
    return !0;
  }
  function Xs(l, u, m, v) {
    u &= ~gg, u &= ~Dc, l.suspendedLanes |= u, l.pingedLanes &= ~u, v && (l.warmLanes |= u), v = l.expirationTimes;
    for (var O = u; 0 < O; ) {
      var R = 31 - ot(O), B = 1 << R;
      v[R] = -1, O &= ~B;
    }
    m !== 0 && wn(l, m, u);
  }
  function Qd() {
    return (ir & 6) === 0 ? (qs(0), !1) : !0;
  }
  function d2() {
    if (Bn !== null) {
      if (br === 0)
        var l = Bn.return;
      else
        l = Bn, Sl = zs = null, Nm(l), Cu = null, Sc = 0, l = Bn;
      for (; l !== null; )
        iy(l.alternate, l), l = l.return;
      Bn = null;
    }
  }
  function us(l, u) {
    var m = l.timeoutHandle;
    m !== -1 && (l.timeoutHandle = -1, jy(m)), m = l.cancelPendingCommit, m !== null && (l.cancelPendingCommit = null, m()), ss = 0, d2(), kr = l, Bn = m = Ds(l.current, null), In = u, br = 0, rn = null, ls = !1, $u = hn(l, u), pg = !1, ea = Uo = gg = Dc = Tl = jr = 0, ta = Qm = null, vg = !1, (u & 8) !== 0 && (u |= u & 32);
    var v = l.entangledLanes;
    if (v !== 0)
      for (l = l.entanglements, v &= u; 0 < v; ) {
        var O = 31 - ot(v), R = 1 << O;
        u |= l[O], v &= ~R;
      }
    return Ol = u, gi(), m;
  }
  function Jd(l, u) {
    Sn = null, H.H = Fm, u === yu || u === Td ? (u = wv(), br = 3) : u === yc ? (u = wv(), br = 4) : br = u === ng ? 8 : u !== null && typeof u == "object" && typeof u.then == "function" ? 6 : 1, rn = u, Bn === null && (jr = 1, Fd(
      l,
      bi(u, l.current)
    ));
  }
  function my() {
    var l = Ho.current;
    return l === null ? !0 : (In & 4194048) === In ? Hi === null : (In & 62914560) === In || (In & 536870912) !== 0 ? l === Hi : !1;
  }
  function hy() {
    var l = H.H;
    return H.H = Fm, l === null ? Fm : l;
  }
  function py() {
    var l = H.A;
    return H.A = uy, l;
  }
  function wg() {
    jr = 4, ls || (In & 4194048) !== In && Ho.current !== null || ($u = !0), (Tl & 134217727) === 0 && (Dc & 134217727) === 0 || kr === null || Xs(
      kr,
      In,
      Uo,
      !1
    );
  }
  function Sg(l, u, m) {
    var v = ir;
    ir |= 2;
    var O = hy(), R = py();
    (kr !== l || In !== u) && (Kd = null, us(l, u)), u = !1;
    var B = jr;
    e: do
      try {
        if (br !== 0 && Bn !== null) {
          var re = Bn, ve = rn;
          switch (br) {
            case 8:
              d2(), B = 6;
              break e;
            case 3:
            case 2:
            case 9:
            case 6:
              Ho.current === null && (u = !0);
              var He = br;
              if (br = 0, rn = null, $c(l, re, ve, He), m && $u) {
                B = 0;
                break e;
              }
              break;
            default:
              He = br, br = 0, rn = null, $c(l, re, ve, He);
          }
        }
        bC(), B = jr;
        break;
      } catch (Je) {
        Jd(l, Je);
      }
    while (!0);
    return u && l.shellSuspendCounter++, Sl = zs = null, ir = v, H.H = O, H.A = R, Bn === null && (kr = null, In = 0, gi()), B;
  }
  function bC() {
    for (; Bn !== null; ) vy(Bn);
  }
  function gy(l, u) {
    var m = ir;
    ir |= 2;
    var v = hy(), O = py();
    kr !== l || In !== u ? (Kd = null, dr = Fe() + 500, us(l, u)) : $u = hn(
      l,
      u
    );
    e: do
      try {
        if (br !== 0 && Bn !== null) {
          u = Bn;
          var R = rn;
          t: switch (br) {
            case 1:
              br = 0, rn = null, $c(l, u, R, 1);
              break;
            case 2:
            case 9:
              if (bv(R)) {
                br = 0, rn = null, by(u);
                break;
              }
              u = function() {
                br !== 2 && br !== 9 || kr !== l || (br = 7), cs(l);
              }, R.then(u, u);
              break e;
            case 3:
              br = 7;
              break e;
            case 4:
              br = 5;
              break e;
            case 7:
              bv(R) ? (br = 0, rn = null, by(u)) : (br = 0, rn = null, $c(l, u, R, 7));
              break;
            case 5:
              var B = null;
              switch (Bn.tag) {
                case 26:
                  B = Bn.memoizedState;
                case 5:
                case 27:
                  var re = Bn;
                  if (B ? oi(B) : re.stateNode.complete) {
                    br = 0, rn = null;
                    var ve = re.sibling;
                    if (ve !== null) Bn = ve;
                    else {
                      var He = re.return;
                      He !== null ? (Bn = He, eh(He)) : Bn = null;
                    }
                    break t;
                  }
              }
              br = 0, rn = null, $c(l, u, R, 5);
              break;
            case 6:
              br = 0, rn = null, $c(l, u, R, 6);
              break;
            case 8:
              d2(), jr = 6;
              break e;
            default:
              throw Error(a(462));
          }
        }
        ju();
        break;
      } catch (Je) {
        Jd(l, Je);
      }
    while (!0);
    return Sl = zs = null, H.H = v, H.A = O, ir = m, Bn !== null ? 0 : (kr = null, In = 0, gi(), jr);
  }
  function ju() {
    for (; Bn !== null && !je(); )
      vy(Bn);
  }
  function vy(l) {
    var u = Qv(l.alternate, l, Ol);
    l.memoizedProps = l.pendingProps, u === null ? eh(l) : Bn = u;
  }
  function by(l) {
    var u = l, m = u.alternate;
    switch (u.tag) {
      case 15:
      case 0:
        u = Au(
          m,
          u,
          u.pendingProps,
          u.type,
          void 0,
          In
        );
        break;
      case 11:
        u = Au(
          m,
          u,
          u.pendingProps,
          u.type.render,
          u.ref,
          In
        );
        break;
      case 5:
        Nm(u);
      default:
        iy(m, u), u = Bn = dv(u, Ol), u = Qv(m, u, Ol);
    }
    l.memoizedProps = l.pendingProps, u === null ? eh(l) : Bn = u;
  }
  function $c(l, u, m, v) {
    Sl = zs = null, Nm(u), Cu = null, Sc = 0;
    var O = u.return;
    try {
      if (vC(
        l,
        O,
        u,
        m,
        In
      )) {
        jr = 1, Fd(
          l,
          bi(m, l.current)
        ), Bn = null;
        return;
      }
    } catch (R) {
      if (O !== null) throw Bn = O, R;
      jr = 1, Fd(
        l,
        bi(m, l.current)
      ), Bn = null;
      return;
    }
    u.flags & 32768 ? (_n || v === 1 ? l = !0 : $u || (In & 536870912) !== 0 ? l = !1 : (ls = l = !0, (v === 2 || v === 9 || v === 3 || v === 6) && (v = Ho.current, v !== null && v.tag === 13 && (v.flags |= 16384))), yy(u, l)) : eh(u);
  }
  function eh(l) {
    var u = l;
    do {
      if ((u.flags & 32768) !== 0) {
        yy(
          u,
          ls
        );
        return;
      }
      l = u.return;
      var m = ay(
        u.alternate,
        u,
        Ol
      );
      if (m !== null) {
        Bn = m;
        return;
      }
      if (u = u.sibling, u !== null) {
        Bn = u;
        return;
      }
      Bn = u = l;
    } while (u !== null);
    jr === 0 && (jr = 5);
  }
  function yy(l, u) {
    do {
      var m = oy(l.alternate, l);
      if (m !== null) {
        m.flags &= 32767, Bn = m;
        return;
      }
      if (m = l.return, m !== null && (m.flags |= 32768, m.subtreeFlags = 0, m.deletions = null), !u && (l = l.sibling, l !== null)) {
        Bn = l;
        return;
      }
      Bn = l = m;
    } while (l !== null);
    jr = 6, Bn = null;
  }
  function wy(l, u, m, v, O, R, B, re, ve) {
    l.cancelPendingCommit = null;
    do
      Zd();
    while (ja !== 0);
    if ((ir & 6) !== 0) throw Error(a(327));
    if (u !== null) {
      if (u === l.current) throw Error(a(177));
      if (R = u.lanes | u.childLanes, R |= Ki, pn(
        l,
        m,
        R,
        B,
        re,
        ve
      ), l === kr && (Bn = kr = null, In = 0), zu = u, Us = l, ss = m, ni = R, bg = O, yg = v, (u.subtreeFlags & 10256) !== 0 || (u.flags & 10256) !== 0 ? (l.callbackNode = null, l.callbackPriority = 0, Ty(mt, function() {
        return Py(), null;
      })) : (l.callbackNode = null, l.callbackPriority = 0), v = (u.flags & 13878) !== 0, (u.subtreeFlags & 13878) !== 0 || v) {
        v = H.T, H.T = null, O = K.p, K.p = 2, B = ir, ir |= 4;
        try {
          Ud(l, u, m);
        } finally {
          ir = B, K.p = O, H.T = v;
        }
      }
      ja = 1, Sy(), Cy(), xy();
    }
  }
  function Sy() {
    if (ja === 1) {
      ja = 0;
      var l = Us, u = zu, m = (u.flags & 13878) !== 0;
      if ((u.subtreeFlags & 13878) !== 0 || m) {
        m = H.T, H.T = null;
        var v = K.p;
        K.p = 2;
        var O = ir;
        ir |= 4;
        try {
          cg(u, l);
          var R = Rg, B = hu(l.containerInfo), re = R.focusedElem, ve = R.selectionRange;
          if (B !== re && re && re.ownerDocument && dc(
            re.ownerDocument.documentElement,
            re
          )) {
            if (ve !== null && fm(re)) {
              var He = ve.start, Je = ve.end;
              if (Je === void 0 && (Je = He), "selectionStart" in re)
                re.selectionStart = He, re.selectionEnd = Math.min(
                  Je,
                  re.value.length
                );
              else {
                var nt = re.ownerDocument || document, We = nt && nt.defaultView || window;
                if (We.getSelection) {
                  var Ge = We.getSelection(), At = re.textContent.length, Zt = Math.min(ve.start, At), Or = ve.end === void 0 ? Zt : Math.min(ve.end, At);
                  !Ge.extend && Zt > Or && (B = Or, Or = Zt, Zt = B);
                  var $e = uv(
                    re,
                    Zt
                  ), Pe = uv(
                    re,
                    Or
                  );
                  if ($e && Pe && (Ge.rangeCount !== 1 || Ge.anchorNode !== $e.node || Ge.anchorOffset !== $e.offset || Ge.focusNode !== Pe.node || Ge.focusOffset !== Pe.offset)) {
                    var Ie = nt.createRange();
                    Ie.setStart($e.node, $e.offset), Ge.removeAllRanges(), Zt > Or ? (Ge.addRange(Ie), Ge.extend(Pe.node, Pe.offset)) : (Ie.setEnd(Pe.node, Pe.offset), Ge.addRange(Ie));
                  }
                }
              }
            }
            for (nt = [], Ge = re; Ge = Ge.parentNode; )
              Ge.nodeType === 1 && nt.push({
                element: Ge,
                left: Ge.scrollLeft,
                top: Ge.scrollTop
              });
            for (typeof re.focus == "function" && re.focus(), re = 0; re < nt.length; re++) {
              var et = nt[re];
              et.element.scrollLeft = et.left, et.element.scrollTop = et.top;
            }
          }
          Ia = !!Tg, Rg = Tg = null;
        } finally {
          ir = O, K.p = v, H.T = m;
        }
      }
      l.current = u, ja = 2;
    }
  }
  function Cy() {
    if (ja === 2) {
      ja = 0;
      var l = Us, u = zu, m = (u.flags & 8772) !== 0;
      if ((u.subtreeFlags & 8772) !== 0 || m) {
        m = H.T, H.T = null;
        var v = K.p;
        K.p = 2;
        var O = ir;
        ir |= 4;
        try {
          Xm(l, u.alternate, u);
        } finally {
          ir = O, K.p = v, H.T = m;
        }
      }
      ja = 3;
    }
  }
  function xy() {
    if (ja === 4 || ja === 3) {
      ja = 0, Ue();
      var l = Us, u = zu, m = ss, v = yg;
      (u.subtreeFlags & 10256) !== 0 || (u.flags & 10256) !== 0 ? ja = 5 : (ja = 0, zu = Us = null, Ey(l, l.pendingLanes));
      var O = l.pendingLanes;
      if (O === 0 && (Ur = null), Ft(m), u = u.stateNode, ut && typeof ut.onCommitFiberRoot == "function")
        try {
          ut.onCommitFiberRoot(
            Ct,
            u,
            void 0,
            (u.current.flags & 128) === 128
          );
        } catch {
        }
      if (v !== null) {
        u = H.T, O = K.p, K.p = 2, H.T = null;
        try {
          for (var R = l.onRecoverableError, B = 0; B < v.length; B++) {
            var re = v[B];
            R(re.value, {
              componentStack: re.stack
            });
          }
        } finally {
          H.T = u, K.p = O;
        }
      }
      (ss & 3) !== 0 && Zd(), cs(l), O = l.pendingLanes, (m & 261930) !== 0 && (O & 42) !== 0 ? l === Jm ? Yd++ : (Yd = 0, Jm = l) : Yd = 0, qs(0);
    }
  }
  function Ey(l, u) {
    (l.pooledCacheLanes &= u) === 0 && (u = l.pooledCache, u != null && (l.pooledCache = null, Cm(u)));
  }
  function Zd() {
    return Sy(), Cy(), xy(), Py();
  }
  function Py() {
    if (ja !== 5) return !1;
    var l = Us, u = ni;
    ni = 0;
    var m = Ft(ss), v = H.T, O = K.p;
    try {
      K.p = 32 > m ? 32 : m, H.T = null, m = bg, bg = null;
      var R = Us, B = ss;
      if (ja = 0, zu = Us = null, ss = 0, (ir & 6) !== 0) throw Error(a(331));
      var re = ir;
      if (ir |= 4, s2(R.current), Xd(
        R,
        R.current,
        B,
        m
      ), ir = re, qs(0, !1), ut && typeof ut.onPostCommitFiberRoot == "function")
        try {
          ut.onPostCommitFiberRoot(Ct, R);
        } catch {
        }
      return !0;
    } finally {
      K.p = O, H.T = v, Ey(l, u);
    }
  }
  function ky(l, u, m) {
    u = bi(m, u), u = Vv(l.stateNode, u, 2), l = Ci(l, u, 2), l !== null && (Ut(l, 2), cs(l));
  }
  function yr(l, u, m) {
    if (l.tag === 3)
      ky(l, l, m);
    else
      for (; u !== null; ) {
        if (u.tag === 3) {
          ky(
            u,
            l,
            m
          );
          break;
        } else if (u.tag === 1) {
          var v = u.stateNode;
          if (typeof u.type.getDerivedStateFromError == "function" || typeof v.componentDidCatch == "function" && (Ur === null || !Ur.has(v))) {
            l = bi(m, l), m = _v(2), v = Ci(u, m, 2), v !== null && (Bv(
              m,
              v,
              u,
              l
            ), Ut(v, 2), cs(v));
            break;
          }
        }
        u = u.return;
      }
  }
  function th(l, u, m) {
    var v = l.pingCache;
    if (v === null) {
      v = l.pingCache = new u2();
      var O = /* @__PURE__ */ new Set();
      v.set(u, O);
    } else
      O = v.get(u), O === void 0 && (O = /* @__PURE__ */ new Set(), v.set(u, O));
    O.has(m) || (pg = !0, O.add(m), l = f2.bind(null, l, u, m), u.then(l, l));
  }
  function f2(l, u, m) {
    var v = l.pingCache;
    v !== null && v.delete(u), l.pingedLanes |= l.suspendedLanes & m, l.warmLanes &= ~m, kr === l && (In & m) === m && (jr === 4 || jr === 3 && (In & 62914560) === In && 300 > Fe() - Rl ? (ir & 2) === 0 && us(l, 0) : gg |= m, ea === In && (ea = 0)), cs(l);
  }
  function My(l, u) {
    u === 0 && (u = jn()), l = Ns(l, u), l !== null && (Ut(l, u), cs(l));
  }
  function Mi(l) {
    var u = l.memoizedState, m = 0;
    u !== null && (m = u.retryLane), My(l, m);
  }
  function Oy(l, u) {
    var m = 0;
    switch (l.tag) {
      case 31:
      case 13:
        var v = l.stateNode, O = l.memoizedState;
        O !== null && (m = O.retryLane);
        break;
      case 19:
        v = l.stateNode;
        break;
      case 22:
        v = l.stateNode._retryCache;
        break;
      default:
        throw Error(a(314));
    }
    v !== null && v.delete(u), My(l, m);
  }
  function Ty(l, u) {
    return Oe(l, u);
  }
  var ef = null, zc = null, m2 = !1, Cg = !1, h2 = !1, Gs = 0;
  function cs(l) {
    l !== zc && l.next === null && (zc === null ? ef = zc = l : zc = zc.next = l), Cg = !0, m2 || (m2 = !0, rh());
  }
  function qs(l, u) {
    if (!h2 && Cg) {
      h2 = !0;
      do
        for (var m = !1, v = ef; v !== null; ) {
          if (l !== 0) {
            var O = v.pendingLanes;
            if (O === 0) var R = 0;
            else {
              var B = v.suspendedLanes, re = v.pingedLanes;
              R = (1 << 31 - ot(42 | l) + 1) - 1, R &= O & ~(B & ~re), R = R & 201326741 ? R & 201326741 | 1 : R ? R | 2 : 0;
            }
            R !== 0 && (m = !0, jc(v, R));
          } else
            R = In, R = Pt(
              v,
              v === kr ? R : 0,
              v.cancelPendingCommit !== null || v.timeoutHandle !== -1
            ), (R & 3) === 0 || hn(v, R) || (m = !0, jc(v, R));
          v = v.next;
        }
      while (m);
      h2 = !1;
    }
  }
  function xg() {
    p2();
  }
  function p2() {
    Cg = m2 = !1;
    var l = 0;
    Gs !== 0 && yC() && (l = Gs);
    for (var u = Fe(), m = null, v = ef; v !== null; ) {
      var O = v.next, R = g2(v, u);
      R === 0 ? (v.next = null, m === null ? ef = O : m.next = O, O === null && (zc = m)) : (m = v, (l !== 0 || (R & 3) !== 0) && (Cg = !0)), v = O;
    }
    ja !== 0 && ja !== 5 || qs(l), Gs !== 0 && (Gs = 0);
  }
  function g2(l, u) {
    for (var m = l.suspendedLanes, v = l.pingedLanes, O = l.expirationTimes, R = l.pendingLanes & -62914561; 0 < R; ) {
      var B = 31 - ot(R), re = 1 << B, ve = O[B];
      ve === -1 ? ((re & m) === 0 || (re & v) !== 0) && (O[B] = an(re, u)) : ve <= u && (l.expiredLanes |= re), R &= ~re;
    }
    if (u = kr, m = In, m = Pt(
      l,
      l === u ? m : 0,
      l.cancelPendingCommit !== null || l.timeoutHandle !== -1
    ), v = l.callbackNode, m === 0 || l === u && (br === 2 || br === 9) || l.cancelPendingCommit !== null)
      return v !== null && v !== null && ye(v), l.callbackNode = null, l.callbackPriority = 0;
    if ((m & 3) === 0 || hn(l, m)) {
      if (u = m & -m, u === l.callbackPriority) return u;
      switch (v !== null && ye(v), Ft(m)) {
        case 2:
        case 8:
          m = St;
          break;
        case 32:
          m = mt;
          break;
        case 268435456:
          m = Rt;
          break;
        default:
          m = mt;
      }
      return v = nh.bind(null, l), m = Oe(m, v), l.callbackPriority = u, l.callbackNode = m, u;
    }
    return v !== null && v !== null && ye(v), l.callbackPriority = 2, l.callbackNode = null, 2;
  }
  function nh(l, u) {
    if (ja !== 0 && ja !== 5)
      return l.callbackNode = null, l.callbackPriority = 0, null;
    var m = l.callbackNode;
    if (Zd() && l.callbackNode !== m)
      return null;
    var v = In;
    return v = Pt(
      l,
      l === kr ? v : 0,
      l.cancelPendingCommit !== null || l.timeoutHandle !== -1
    ), v === 0 ? null : (dy(l, v, u), g2(l, Fe()), l.callbackNode != null && l.callbackNode === m ? nh.bind(null, l) : null);
  }
  function jc(l, u) {
    if (Zd()) return null;
    dy(l, u, !0);
  }
  function rh() {
    Iy(function() {
      (ir & 6) !== 0 ? Oe(
        dt,
        xg
      ) : p2();
    });
  }
  function Eg() {
    if (Gs === 0) {
      var l = bu;
      l === 0 && (l = pt, pt <<= 1, (pt & 261888) === 0 && (pt = 256)), Gs = l;
    }
    return Gs;
  }
  function Ry(l) {
    return l == null || typeof l == "symbol" || typeof l == "boolean" ? null : typeof l == "function" ? l : tr("" + l);
  }
  function Ic(l, u) {
    var m = u.ownerDocument.createElement("input");
    return m.name = u.name, m.value = u.value, l.id && m.setAttribute("form", l.id), u.parentNode.insertBefore(m, u), l = new FormData(l), m.parentNode.removeChild(m), l;
  }
  function ah(l, u, m, v, O) {
    if (u === "submit" && m && m.stateNode === O) {
      var R = Ry(
        (O[Dt] || null).action
      ), B = v.submitter;
      B && (u = (u = B[Dt] || null) ? Ry(u.formAction) : B.getAttribute("formAction"), u !== null && (R = u, B = null));
      var re = new um(
        "action",
        "action",
        null,
        v,
        O
      );
      l.push({
        event: re,
        listeners: [
          {
            instance: null,
            listener: function() {
              if (v.defaultPrevented) {
                if (Gs !== 0) {
                  var ve = B ? Ic(O, B) : new FormData(O);
                  Ld(
                    m,
                    {
                      pending: !0,
                      data: ve,
                      method: O.method,
                      action: R
                    },
                    null,
                    ve
                  );
                }
              } else
                typeof R == "function" && (re.preventDefault(), ve = B ? Ic(O, B) : new FormData(O), Ld(
                  m,
                  {
                    pending: !0,
                    data: ve,
                    method: O.method,
                    action: R
                  },
                  R,
                  ve
                ));
            },
            currentTarget: O
          }
        ]
      });
    }
  }
  for (var Pg = 0; Pg < xd.length; Pg++) {
    var tf = xd[Pg], v2 = tf.toLowerCase(), b2 = tf[0].toUpperCase() + tf.slice(1);
    zo(
      v2,
      "on" + b2
    );
  }
  zo(hm, "onAnimationEnd"), zo(cv, "onAnimationIteration"), zo(Pp, "onAnimationStart"), zo("dblclick", "onDoubleClick"), zo("focusin", "onFocus"), zo("focusout", "onBlur"), zo(fc, "onTransitionRun"), zo(pm, "onTransitionStart"), zo(Bl, "onTransitionCancel"), zo(Wb, "onTransitionEnd"), Hr("onMouseEnter", ["mouseout", "mouseover"]), Hr("onMouseLeave", ["mouseout", "mouseover"]), Hr("onPointerEnter", ["pointerout", "pointerover"]), Hr("onPointerLeave", ["pointerout", "pointerover"]), Nr(
    "onChange",
    "change click focusin focusout input keydown keyup selectionchange".split(" ")
  ), Nr(
    "onSelect",
    "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
      " "
    )
  ), Nr("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
  ]), Nr(
    "onCompositionEnd",
    "compositionend focusout keydown keypress keyup mousedown".split(" ")
  ), Nr(
    "onCompositionStart",
    "compositionstart focusout keydown keypress keyup mousedown".split(" ")
  ), Nr(
    "onCompositionUpdate",
    "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
  );
  var nf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
    " "
  ), Ay = new Set(
    "beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(nf)
  );
  function Ny(l, u) {
    u = (u & 4) !== 0;
    for (var m = 0; m < l.length; m++) {
      var v = l[m], O = v.event;
      v = v.listeners;
      e: {
        var R = void 0;
        if (u)
          for (var B = v.length - 1; 0 <= B; B--) {
            var re = v[B], ve = re.instance, He = re.currentTarget;
            if (re = re.listener, ve !== R && O.isPropagationStopped())
              break e;
            R = re, O.currentTarget = He;
            try {
              R(O);
            } catch (Je) {
              mc(Je);
            }
            O.currentTarget = null, R = ve;
          }
        else
          for (B = 0; B < v.length; B++) {
            if (re = v[B], ve = re.instance, He = re.currentTarget, re = re.listener, ve !== R && O.isPropagationStopped())
              break e;
            R = re, O.currentTarget = He;
            try {
              R(O);
            } catch (Je) {
              mc(Je);
            }
            O.currentTarget = null, R = ve;
          }
      }
    }
  }
  function Vn(l, u) {
    var m = u[Mn];
    m === void 0 && (m = u[Mn] = /* @__PURE__ */ new Set());
    var v = l + "__bubble";
    m.has(v) || (oh(u, l, 2, !1), m.add(v));
  }
  function y2(l, u, m) {
    var v = 0;
    u && (v |= 4), oh(
      m,
      l,
      v,
      u
    );
  }
  var kg = "_reactListening" + Math.random().toString(36).slice(2);
  function rf(l) {
    if (!l[kg]) {
      l[kg] = !0, Qn.forEach(function(m) {
        m !== "selectionchange" && (Ay.has(m) || y2(m, !1, l), y2(m, !0, l));
      });
      var u = l.nodeType === 9 ? l : l.ownerDocument;
      u === null || u[kg] || (u[kg] = !0, y2("selectionchange", !1, u));
    }
  }
  function oh(l, u, m, v) {
    switch (hh(u)) {
      case 2:
        var O = fs;
        break;
      case 8:
        O = ms;
        break;
      default:
        O = fo;
    }
    m = O.bind(
      null,
      u,
      m,
      l
    ), O = void 0, !ao || u !== "touchstart" && u !== "touchmove" && u !== "wheel" || (O = !0), v ? O !== void 0 ? l.addEventListener(u, m, {
      capture: !0,
      passive: O
    }) : l.addEventListener(u, m, !0) : O !== void 0 ? l.addEventListener(u, m, {
      passive: O
    }) : l.addEventListener(u, m, !1);
  }
  function w2(l, u, m, v, O) {
    var R = v;
    if ((u & 1) === 0 && (u & 2) === 0 && v !== null)
      e: for (; ; ) {
        if (v === null) return;
        var B = v.tag;
        if (B === 3 || B === 4) {
          var re = v.stateNode.containerInfo;
          if (re === O) break;
          if (B === 4)
            for (B = v.return; B !== null; ) {
              var ve = B.tag;
              if ((ve === 3 || ve === 4) && B.stateNode.containerInfo === O)
                return;
              B = B.return;
            }
          for (; re !== null; ) {
            if (B = Wt(re), B === null) return;
            if (ve = B.tag, ve === 5 || ve === 6 || ve === 26 || ve === 27) {
              v = R = B;
              continue e;
            }
            re = re.parentNode;
          }
        }
        v = v.return;
      }
    lm(function() {
      var He = R, Je = Li(m), nt = [];
      e: {
        var We = Ul.get(l);
        if (We !== void 0) {
          var Ge = um, At = l;
          switch (l) {
            case "keypress":
              if (cd(m) === 0) break e;
            case "keydown":
            case "keyup":
              Ge = bp;
              break;
            case "focusin":
              At = "focus", Ge = gp;
              break;
            case "focusout":
              At = "blur", Ge = gp;
              break;
            case "beforeblur":
            case "afterblur":
              Ge = gp;
              break;
            case "click":
              if (m.button === 2) break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              Ge = bd;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              Ge = Tb;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              Ge = $b;
              break;
            case hm:
            case cv:
            case Pp:
              Ge = Ab;
              break;
            case Wb:
              Ge = mC;
              break;
            case "scroll":
            case "scrollend":
              Ge = dC;
              break;
            case "wheel":
              Ge = hC;
              break;
            case "copy":
            case "cut":
            case "paste":
              Ge = oc;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              Ge = pl;
              break;
            case "toggle":
            case "beforetoggle":
              Ge = tv;
          }
          var Zt = (u & 4) !== 0, Or = !Zt && (l === "scroll" || l === "scrollend"), $e = Zt ? We !== null ? We + "Capture" : null : We;
          Zt = [];
          for (var Pe = He, Ie; Pe !== null; ) {
            var et = Pe;
            if (Ie = et.stateNode, et = et.tag, et !== 5 && et !== 26 && et !== 27 || Ie === null || $e === null || (et = Jt(Pe, $e), et != null && Zt.push(
              ih(Pe, et, Ie)
            )), Or) break;
            Pe = Pe.return;
          }
          0 < Zt.length && (We = new Ge(
            We,
            At,
            null,
            m,
            Je
          ), nt.push({ event: We, listeners: Zt }));
        }
      }
      if ((u & 7) === 0) {
        e: {
          if (We = l === "mouseover" || l === "pointerover", Ge = l === "mouseout" || l === "pointerout", We && m !== pi && (At = m.relatedTarget || m.fromElement) && (Wt(At) || At[Yt]))
            break e;
          if ((Ge || We) && (We = Je.window === Je ? Je : (We = Je.ownerDocument) ? We.defaultView || We.parentWindow : window, Ge ? (At = m.relatedTarget || m.toElement, Ge = He, At = At ? Wt(At) : null, At !== null && (Or = c(At), Zt = At.tag, At !== Or || Zt !== 5 && Zt !== 27 && Zt !== 6) && (At = null)) : (Ge = null, At = He), Ge !== At)) {
            if (Zt = bd, et = "onMouseLeave", $e = "onMouseEnter", Pe = "mouse", (l === "pointerout" || l === "pointerover") && (Zt = pl, et = "onPointerLeave", $e = "onPointerEnter", Pe = "pointer"), Or = Ge == null ? We : Xt(Ge), Ie = At == null ? We : Xt(At), We = new Zt(
              et,
              Pe + "leave",
              Ge,
              m,
              Je
            ), We.target = Or, We.relatedTarget = Ie, et = null, Wt(Je) === He && (Zt = new Zt(
              $e,
              Pe + "enter",
              At,
              m,
              Je
            ), Zt.target = Ie, Zt.relatedTarget = Or, et = Zt), Or = et, Ge && At)
              t: {
                for (Zt = Dy, $e = Ge, Pe = At, Ie = 0, et = $e; et; et = Zt(et))
                  Ie++;
                et = 0;
                for (var Vt = Pe; Vt; Vt = Zt(Vt))
                  et++;
                for (; 0 < Ie - et; )
                  $e = Zt($e), Ie--;
                for (; 0 < et - Ie; )
                  Pe = Zt(Pe), et--;
                for (; Ie--; ) {
                  if ($e === Pe || Pe !== null && $e === Pe.alternate) {
                    Zt = $e;
                    break t;
                  }
                  $e = Zt($e), Pe = Zt(Pe);
                }
                Zt = null;
              }
            else Zt = null;
            Ge !== null && Mg(
              nt,
              We,
              Ge,
              Zt,
              !1
            ), At !== null && Or !== null && Mg(
              nt,
              Or,
              At,
              Zt,
              !0
            );
          }
        }
        e: {
          if (We = He ? Xt(He) : window, Ge = We.nodeName && We.nodeName.toLowerCase(), Ge === "select" || Ge === "input" && We.type === "file")
            var rr = iv;
          else if (_l(We))
            if (Sp)
              rr = cc;
            else {
              rr = Hb;
              var jt = Lb;
            }
          else
            Ge = We.nodeName, !Ge || Ge.toLowerCase() !== "input" || We.type !== "checkbox" && We.type !== "radio" ? He && Kt(He.elementType) && (rr = iv) : rr = mu;
          if (rr && (rr = rr(l, He))) {
            ov(
              nt,
              rr,
              m,
              Je
            );
            break e;
          }
          jt && jt(l, We, He), l === "focusout" && He && We.type === "number" && He.memoizedProps.value != null && er(We, "number", We.value);
        }
        switch (jt = He ? Xt(He) : window, l) {
          case "focusin":
            (_l(jt) || jt.contentEditable === "true") && (pu = jt, Sd = He, qi = null);
            break;
          case "focusout":
            qi = Sd = pu = null;
            break;
          case "mousedown":
            vl = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            vl = !1, Ep(nt, m, Je);
            break;
          case "selectionchange":
            if (mm) break;
          case "keydown":
          case "keyup":
            Ep(nt, m, Je);
        }
        var vn;
        if (yd)
          e: {
            switch (l) {
              case "compositionstart":
                var Pn = "onCompositionStart";
                break e;
              case "compositionend":
                Pn = "onCompositionEnd";
                break e;
              case "compositionupdate":
                Pn = "onCompositionUpdate";
                break e;
            }
            Pn = void 0;
          }
        else
          lc ? wp(l, m) && (Pn = "onCompositionEnd") : l === "keydown" && m.keyCode === 229 && (Pn = "onCompositionStart");
        Pn && (nv && m.locale !== "ko" && (lc || Pn !== "onCompositionStart" ? Pn === "onCompositionEnd" && lc && (vn = Zh()) : (Ea = Je, Uf = "value" in Ea ? Ea.value : Ea.textContent, lc = !0)), jt = lh(He, Pn), 0 < jt.length && (Pn = new Nb(
          Pn,
          l,
          null,
          m,
          Je
        ), nt.push({ event: Pn, listeners: jt }), vn ? Pn.data = vn : (vn = rv(m), vn !== null && (Pn.data = vn)))), (vn = So ? Ib(l, m) : pC(l, m)) && (Pn = lh(He, "onBeforeInput"), 0 < Pn.length && (jt = new Nb(
          "onBeforeInput",
          "beforeinput",
          null,
          m,
          Je
        ), nt.push({
          event: jt,
          listeners: Pn
        }), jt.data = vn)), ah(
          nt,
          l,
          He,
          m,
          Je
        );
      }
      Ny(nt, u);
    });
  }
  function ih(l, u, m) {
    return {
      instance: l,
      listener: u,
      currentTarget: m
    };
  }
  function lh(l, u) {
    for (var m = u + "Capture", v = []; l !== null; ) {
      var O = l, R = O.stateNode;
      if (O = O.tag, O !== 5 && O !== 26 && O !== 27 || R === null || (O = Jt(l, m), O != null && v.unshift(
        ih(l, O, R)
      ), O = Jt(l, u), O != null && v.push(
        ih(l, O, R)
      )), l.tag === 3) return v;
      l = l.return;
    }
    return [];
  }
  function Dy(l) {
    if (l === null) return null;
    do
      l = l.return;
    while (l && l.tag !== 5 && l.tag !== 27);
    return l || null;
  }
  function Mg(l, u, m, v, O) {
    for (var R = u._reactName, B = []; m !== null && m !== v; ) {
      var re = m, ve = re.alternate, He = re.stateNode;
      if (re = re.tag, ve !== null && ve === v) break;
      re !== 5 && re !== 26 && re !== 27 || He === null || (ve = He, O ? (He = Jt(m, R), He != null && B.unshift(
        ih(m, He, ve)
      )) : O || (He = Jt(m, R), He != null && B.push(
        ih(m, He, ve)
      ))), m = m.return;
    }
    B.length !== 0 && l.push({ event: u, listeners: B });
  }
  var $y = /\r\n?/g, S2 = /\u0000|\uFFFD/g;
  function C2(l) {
    return (typeof l == "string" ? l : "" + l).replace($y, `
`).replace(S2, "");
  }
  function x2(l, u) {
    return u = C2(u), C2(l) === u;
  }
  function Mr(l, u, m, v, O, R) {
    switch (m) {
      case "children":
        typeof v == "string" ? u === "body" || u === "textarea" && v === "" || ka(l, v) : (typeof v == "number" || typeof v == "bigint") && u !== "body" && ka(l, "" + v);
        break;
      case "className":
        Wa(l, "class", v);
        break;
      case "tabIndex":
        Wa(l, "tabindex", v);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        Wa(l, m, v);
        break;
      case "style":
        qt(l, v, R);
        break;
      case "data":
        if (u !== "object") {
          Wa(l, "data", v);
          break;
        }
      case "src":
      case "href":
        if (v === "" && (u !== "a" || m !== "href")) {
          l.removeAttribute(m);
          break;
        }
        if (v == null || typeof v == "function" || typeof v == "symbol" || typeof v == "boolean") {
          l.removeAttribute(m);
          break;
        }
        v = tr("" + v), l.setAttribute(m, v);
        break;
      case "action":
      case "formAction":
        if (typeof v == "function") {
          l.setAttribute(
            m,
            "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
          );
          break;
        } else
          typeof R == "function" && (m === "formAction" ? (u !== "input" && Mr(l, u, "name", O.name, O, null), Mr(
            l,
            u,
            "formEncType",
            O.formEncType,
            O,
            null
          ), Mr(
            l,
            u,
            "formMethod",
            O.formMethod,
            O,
            null
          ), Mr(
            l,
            u,
            "formTarget",
            O.formTarget,
            O,
            null
          )) : (Mr(l, u, "encType", O.encType, O, null), Mr(l, u, "method", O.method, O, null), Mr(l, u, "target", O.target, O, null)));
        if (v == null || typeof v == "symbol" || typeof v == "boolean") {
          l.removeAttribute(m);
          break;
        }
        v = tr("" + v), l.setAttribute(m, v);
        break;
      case "onClick":
        v != null && (l.onclick = Va);
        break;
      case "onScroll":
        v != null && Vn("scroll", l);
        break;
      case "onScrollEnd":
        v != null && Vn("scrollend", l);
        break;
      case "dangerouslySetInnerHTML":
        if (v != null) {
          if (typeof v != "object" || !("__html" in v))
            throw Error(a(61));
          if (m = v.__html, m != null) {
            if (O.children != null) throw Error(a(60));
            l.innerHTML = m;
          }
        }
        break;
      case "multiple":
        l.multiple = v && typeof v != "function" && typeof v != "symbol";
        break;
      case "muted":
        l.muted = v && typeof v != "function" && typeof v != "symbol";
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "ref":
        break;
      case "autoFocus":
        break;
      case "xlinkHref":
        if (v == null || typeof v == "function" || typeof v == "boolean" || typeof v == "symbol") {
          l.removeAttribute("xlink:href");
          break;
        }
        m = tr("" + v), l.setAttributeNS(
          "http://www.w3.org/1999/xlink",
          "xlink:href",
          m
        );
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        v != null && typeof v != "function" && typeof v != "symbol" ? l.setAttribute(m, "" + v) : l.removeAttribute(m);
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        v && typeof v != "function" && typeof v != "symbol" ? l.setAttribute(m, "") : l.removeAttribute(m);
        break;
      case "capture":
      case "download":
        v === !0 ? l.setAttribute(m, "") : v !== !1 && v != null && typeof v != "function" && typeof v != "symbol" ? l.setAttribute(m, v) : l.removeAttribute(m);
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        v != null && typeof v != "function" && typeof v != "symbol" && !isNaN(v) && 1 <= v ? l.setAttribute(m, v) : l.removeAttribute(m);
        break;
      case "rowSpan":
      case "start":
        v == null || typeof v == "function" || typeof v == "symbol" || isNaN(v) ? l.removeAttribute(m) : l.setAttribute(m, v);
        break;
      case "popover":
        Vn("beforetoggle", l), Vn("toggle", l), Yr(l, "popover", v);
        break;
      case "xlinkActuate":
        pa(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:actuate",
          v
        );
        break;
      case "xlinkArcrole":
        pa(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:arcrole",
          v
        );
        break;
      case "xlinkRole":
        pa(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:role",
          v
        );
        break;
      case "xlinkShow":
        pa(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:show",
          v
        );
        break;
      case "xlinkTitle":
        pa(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:title",
          v
        );
        break;
      case "xlinkType":
        pa(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:type",
          v
        );
        break;
      case "xmlBase":
        pa(
          l,
          "http://www.w3.org/XML/1998/namespace",
          "xml:base",
          v
        );
        break;
      case "xmlLang":
        pa(
          l,
          "http://www.w3.org/XML/1998/namespace",
          "xml:lang",
          v
        );
        break;
      case "xmlSpace":
        pa(
          l,
          "http://www.w3.org/XML/1998/namespace",
          "xml:space",
          v
        );
        break;
      case "is":
        Yr(l, "is", v);
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        (!(2 < m.length) || m[0] !== "o" && m[0] !== "O" || m[1] !== "n" && m[1] !== "N") && (m = ur.get(m) || m, Yr(l, m, v));
    }
  }
  function E2(l, u, m, v, O, R) {
    switch (m) {
      case "style":
        qt(l, v, R);
        break;
      case "dangerouslySetInnerHTML":
        if (v != null) {
          if (typeof v != "object" || !("__html" in v))
            throw Error(a(61));
          if (m = v.__html, m != null) {
            if (O.children != null) throw Error(a(60));
            l.innerHTML = m;
          }
        }
        break;
      case "children":
        typeof v == "string" ? ka(l, v) : (typeof v == "number" || typeof v == "bigint") && ka(l, "" + v);
        break;
      case "onScroll":
        v != null && Vn("scroll", l);
        break;
      case "onScrollEnd":
        v != null && Vn("scrollend", l);
        break;
      case "onClick":
        v != null && (l.onclick = Va);
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "innerHTML":
      case "ref":
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        if (!Jn.hasOwnProperty(m))
          e: {
            if (m[0] === "o" && m[1] === "n" && (O = m.endsWith("Capture"), u = m.slice(2, O ? m.length - 7 : void 0), R = l[Dt] || null, R = R != null ? R[m] : null, typeof R == "function" && l.removeEventListener(u, R, O), typeof v == "function")) {
              typeof R != "function" && R !== null && (m in l ? l[m] = null : l.hasAttribute(m) && l.removeAttribute(m)), l.addEventListener(u, v, O);
              break e;
            }
            m in l ? l[m] = v : v === !0 ? l.setAttribute(m, "") : Yr(l, m, v);
          }
    }
  }
  function co(l, u, m) {
    switch (u) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "img":
        Vn("error", l), Vn("load", l);
        var v = !1, O = !1, R;
        for (R in m)
          if (m.hasOwnProperty(R)) {
            var B = m[R];
            if (B != null)
              switch (R) {
                case "src":
                  v = !0;
                  break;
                case "srcSet":
                  O = !0;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(a(137, u));
                default:
                  Mr(l, u, R, B, m, null);
              }
          }
        O && Mr(l, u, "srcSet", m.srcSet, m, null), v && Mr(l, u, "src", m.src, m, null);
        return;
      case "input":
        Vn("invalid", l);
        var re = R = B = O = null, ve = null, He = null;
        for (v in m)
          if (m.hasOwnProperty(v)) {
            var Je = m[v];
            if (Je != null)
              switch (v) {
                case "name":
                  O = Je;
                  break;
                case "type":
                  B = Je;
                  break;
                case "checked":
                  ve = Je;
                  break;
                case "defaultChecked":
                  He = Je;
                  break;
                case "value":
                  R = Je;
                  break;
                case "defaultValue":
                  re = Je;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (Je != null)
                    throw Error(a(137, u));
                  break;
                default:
                  Mr(l, u, v, Je, m, null);
              }
          }
        nn(
          l,
          R,
          re,
          ve,
          He,
          B,
          O,
          !1
        );
        return;
      case "select":
        Vn("invalid", l), v = B = R = null;
        for (O in m)
          if (m.hasOwnProperty(O) && (re = m[O], re != null))
            switch (O) {
              case "value":
                R = re;
                break;
              case "defaultValue":
                B = re;
                break;
              case "multiple":
                v = re;
              default:
                Mr(l, u, O, re, m, null);
            }
        u = R, m = B, l.multiple = !!v, u != null ? ia(l, !!v, u, !1) : m != null && ia(l, !!v, m, !0);
        return;
      case "textarea":
        Vn("invalid", l), R = O = v = null;
        for (B in m)
          if (m.hasOwnProperty(B) && (re = m[B], re != null))
            switch (B) {
              case "value":
                v = re;
                break;
              case "defaultValue":
                O = re;
                break;
              case "children":
                R = re;
                break;
              case "dangerouslySetInnerHTML":
                if (re != null) throw Error(a(91));
                break;
              default:
                Mr(l, u, B, re, m, null);
            }
        hi(l, v, O, R);
        return;
      case "option":
        for (ve in m)
          if (m.hasOwnProperty(ve) && (v = m[ve], v != null))
            switch (ve) {
              case "selected":
                l.selected = v && typeof v != "function" && typeof v != "symbol";
                break;
              default:
                Mr(l, u, ve, v, m, null);
            }
        return;
      case "dialog":
        Vn("beforetoggle", l), Vn("toggle", l), Vn("cancel", l), Vn("close", l);
        break;
      case "iframe":
      case "object":
        Vn("load", l);
        break;
      case "video":
      case "audio":
        for (v = 0; v < nf.length; v++)
          Vn(nf[v], l);
        break;
      case "image":
        Vn("error", l), Vn("load", l);
        break;
      case "details":
        Vn("toggle", l);
        break;
      case "embed":
      case "source":
      case "link":
        Vn("error", l), Vn("load", l);
      case "area":
      case "base":
      case "br":
      case "col":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "track":
      case "wbr":
      case "menuitem":
        for (He in m)
          if (m.hasOwnProperty(He) && (v = m[He], v != null))
            switch (He) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(a(137, u));
              default:
                Mr(l, u, He, v, m, null);
            }
        return;
      default:
        if (Kt(u)) {
          for (Je in m)
            m.hasOwnProperty(Je) && (v = m[Je], v !== void 0 && E2(
              l,
              u,
              Je,
              v,
              m,
              void 0
            ));
          return;
        }
    }
    for (re in m)
      m.hasOwnProperty(re) && (v = m[re], v != null && Mr(l, u, re, v, m, null));
  }
  function P2(l, u, m, v) {
    switch (u) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "input":
        var O = null, R = null, B = null, re = null, ve = null, He = null, Je = null;
        for (Ge in m) {
          var nt = m[Ge];
          if (m.hasOwnProperty(Ge) && nt != null)
            switch (Ge) {
              case "checked":
                break;
              case "value":
                break;
              case "defaultValue":
                ve = nt;
              default:
                v.hasOwnProperty(Ge) || Mr(l, u, Ge, null, v, nt);
            }
        }
        for (var We in v) {
          var Ge = v[We];
          if (nt = m[We], v.hasOwnProperty(We) && (Ge != null || nt != null))
            switch (We) {
              case "type":
                R = Ge;
                break;
              case "name":
                O = Ge;
                break;
              case "checked":
                He = Ge;
                break;
              case "defaultChecked":
                Je = Ge;
                break;
              case "value":
                B = Ge;
                break;
              case "defaultValue":
                re = Ge;
                break;
              case "children":
              case "dangerouslySetInnerHTML":
                if (Ge != null)
                  throw Error(a(137, u));
                break;
              default:
                Ge !== nt && Mr(
                  l,
                  u,
                  We,
                  Ge,
                  v,
                  nt
                );
            }
        }
        Qt(
          l,
          B,
          re,
          ve,
          He,
          Je,
          R,
          O
        );
        return;
      case "select":
        Ge = B = re = We = null;
        for (R in m)
          if (ve = m[R], m.hasOwnProperty(R) && ve != null)
            switch (R) {
              case "value":
                break;
              case "multiple":
                Ge = ve;
              default:
                v.hasOwnProperty(R) || Mr(
                  l,
                  u,
                  R,
                  null,
                  v,
                  ve
                );
            }
        for (O in v)
          if (R = v[O], ve = m[O], v.hasOwnProperty(O) && (R != null || ve != null))
            switch (O) {
              case "value":
                We = R;
                break;
              case "defaultValue":
                re = R;
                break;
              case "multiple":
                B = R;
              default:
                R !== ve && Mr(
                  l,
                  u,
                  O,
                  R,
                  v,
                  ve
                );
            }
        u = re, m = B, v = Ge, We != null ? ia(l, !!m, We, !1) : !!v != !!m && (u != null ? ia(l, !!m, u, !0) : ia(l, !!m, m ? [] : "", !1));
        return;
      case "textarea":
        Ge = We = null;
        for (re in m)
          if (O = m[re], m.hasOwnProperty(re) && O != null && !v.hasOwnProperty(re))
            switch (re) {
              case "value":
                break;
              case "children":
                break;
              default:
                Mr(l, u, re, null, v, O);
            }
        for (B in v)
          if (O = v[B], R = m[B], v.hasOwnProperty(B) && (O != null || R != null))
            switch (B) {
              case "value":
                We = O;
                break;
              case "defaultValue":
                Ge = O;
                break;
              case "children":
                break;
              case "dangerouslySetInnerHTML":
                if (O != null) throw Error(a(91));
                break;
              default:
                O !== R && Mr(l, u, B, O, v, R);
            }
        so(l, We, Ge);
        return;
      case "option":
        for (var At in m)
          if (We = m[At], m.hasOwnProperty(At) && We != null && !v.hasOwnProperty(At))
            switch (At) {
              case "selected":
                l.selected = !1;
                break;
              default:
                Mr(
                  l,
                  u,
                  At,
                  null,
                  v,
                  We
                );
            }
        for (ve in v)
          if (We = v[ve], Ge = m[ve], v.hasOwnProperty(ve) && We !== Ge && (We != null || Ge != null))
            switch (ve) {
              case "selected":
                l.selected = We && typeof We != "function" && typeof We != "symbol";
                break;
              default:
                Mr(
                  l,
                  u,
                  ve,
                  We,
                  v,
                  Ge
                );
            }
        return;
      case "img":
      case "link":
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
      case "menuitem":
        for (var Zt in m)
          We = m[Zt], m.hasOwnProperty(Zt) && We != null && !v.hasOwnProperty(Zt) && Mr(l, u, Zt, null, v, We);
        for (He in v)
          if (We = v[He], Ge = m[He], v.hasOwnProperty(He) && We !== Ge && (We != null || Ge != null))
            switch (He) {
              case "children":
              case "dangerouslySetInnerHTML":
                if (We != null)
                  throw Error(a(137, u));
                break;
              default:
                Mr(
                  l,
                  u,
                  He,
                  We,
                  v,
                  Ge
                );
            }
        return;
      default:
        if (Kt(u)) {
          for (var Or in m)
            We = m[Or], m.hasOwnProperty(Or) && We !== void 0 && !v.hasOwnProperty(Or) && E2(
              l,
              u,
              Or,
              void 0,
              v,
              We
            );
          for (Je in v)
            We = v[Je], Ge = m[Je], !v.hasOwnProperty(Je) || We === Ge || We === void 0 && Ge === void 0 || E2(
              l,
              u,
              Je,
              We,
              v,
              Ge
            );
          return;
        }
    }
    for (var $e in m)
      We = m[$e], m.hasOwnProperty($e) && We != null && !v.hasOwnProperty($e) && Mr(l, u, $e, null, v, We);
    for (nt in v)
      We = v[nt], Ge = m[nt], !v.hasOwnProperty(nt) || We === Ge || We == null && Ge == null || Mr(l, u, nt, We, v, Ge);
  }
  function Og(l) {
    switch (l) {
      case "css":
      case "script":
      case "font":
      case "img":
      case "image":
      case "input":
      case "link":
        return !0;
      default:
        return !1;
    }
  }
  function k2() {
    if (typeof performance.getEntriesByType == "function") {
      for (var l = 0, u = 0, m = performance.getEntriesByType("resource"), v = 0; v < m.length; v++) {
        var O = m[v], R = O.transferSize, B = O.initiatorType, re = O.duration;
        if (R && re && Og(B)) {
          for (B = 0, re = O.responseEnd, v += 1; v < m.length; v++) {
            var ve = m[v], He = ve.startTime;
            if (He > re) break;
            var Je = ve.transferSize, nt = ve.initiatorType;
            Je && Og(nt) && (ve = ve.responseEnd, B += Je * (ve < re ? 1 : (re - He) / (ve - He)));
          }
          if (--v, u += 8 * (R + B) / (O.duration / 1e3), l++, 10 < l) break;
        }
      }
      if (0 < l) return u / l / 1e6;
    }
    return navigator.connection && (l = navigator.connection.downlink, typeof l == "number") ? l : 5;
  }
  var Tg = null, Rg = null;
  function Iu(l) {
    return l.nodeType === 9 ? l : l.ownerDocument;
  }
  function zy(l) {
    switch (l) {
      case "http://www.w3.org/2000/svg":
        return 1;
      case "http://www.w3.org/1998/Math/MathML":
        return 2;
      default:
        return 0;
    }
  }
  function M2(l, u) {
    if (l === 0)
      switch (u) {
        case "svg":
          return 1;
        case "math":
          return 2;
        default:
          return 0;
      }
    return l === 1 && u === "foreignObject" ? 0 : l;
  }
  function af(l, u) {
    return l === "textarea" || l === "noscript" || typeof u.children == "string" || typeof u.children == "number" || typeof u.children == "bigint" || typeof u.dangerouslySetInnerHTML == "object" && u.dangerouslySetInnerHTML !== null && u.dangerouslySetInnerHTML.__html != null;
  }
  var Ag = null;
  function yC() {
    var l = window.event;
    return l && l.type === "popstate" ? l === Ag ? !1 : (Ag = l, !0) : (Ag = null, !1);
  }
  var sh = typeof setTimeout == "function" ? setTimeout : void 0, jy = typeof clearTimeout == "function" ? clearTimeout : void 0, Lc = typeof Promise == "function" ? Promise : void 0, Iy = typeof queueMicrotask == "function" ? queueMicrotask : typeof Lc < "u" ? function(l) {
    return Lc.resolve(null).then(l).catch(O2);
  } : sh;
  function O2(l) {
    setTimeout(function() {
      throw l;
    });
  }
  function Al(l) {
    return l === "head";
  }
  function T2(l, u) {
    var m = u, v = 0;
    do {
      var O = m.nextSibling;
      if (l.removeChild(m), O && O.nodeType === 8)
        if (m = O.data, m === "/$" || m === "/&") {
          if (v === 0) {
            l.removeChild(O), vf(u);
            return;
          }
          v--;
        } else if (m === "$" || m === "$?" || m === "$~" || m === "$!" || m === "&")
          v++;
        else if (m === "html")
          Hc(l.ownerDocument.documentElement);
        else if (m === "head") {
          m = l.ownerDocument.head, Hc(m);
          for (var R = m.firstChild; R; ) {
            var B = R.nextSibling, re = R.nodeName;
            R[qn] || re === "SCRIPT" || re === "STYLE" || re === "LINK" && R.rel.toLowerCase() === "stylesheet" || m.removeChild(R), R = B;
          }
        } else
          m === "body" && Hc(l.ownerDocument.body);
      m = O;
    } while (m);
    vf(u);
  }
  function Sa(l, u) {
    var m = l;
    l = 0;
    do {
      var v = m.nextSibling;
      if (m.nodeType === 1 ? u ? (m._stashedDisplay = m.style.display, m.style.display = "none") : (m.style.display = m._stashedDisplay || "", m.getAttribute("style") === "" && m.removeAttribute("style")) : m.nodeType === 3 && (u ? (m._stashedText = m.nodeValue, m.nodeValue = "") : m.nodeValue = m._stashedText || ""), v && v.nodeType === 8)
        if (m = v.data, m === "/$") {
          if (l === 0) break;
          l--;
        } else
          m !== "$" && m !== "$?" && m !== "$~" && m !== "$!" || l++;
      m = v;
    } while (m);
  }
  function uh(l) {
    var u = l.firstChild;
    for (u && u.nodeType === 10 && (u = u.nextSibling); u; ) {
      var m = u;
      switch (u = u.nextSibling, m.nodeName) {
        case "HTML":
        case "HEAD":
        case "BODY":
          uh(m), Rr(m);
          continue;
        case "SCRIPT":
        case "STYLE":
          continue;
        case "LINK":
          if (m.rel.toLowerCase() === "stylesheet") continue;
      }
      l.removeChild(m);
    }
  }
  function wC(l, u, m, v) {
    for (; l.nodeType === 1; ) {
      var O = m;
      if (l.nodeName.toLowerCase() !== u.toLowerCase()) {
        if (!v && (l.nodeName !== "INPUT" || l.type !== "hidden"))
          break;
      } else if (v) {
        if (!l[qn])
          switch (u) {
            case "meta":
              if (!l.hasAttribute("itemprop")) break;
              return l;
            case "link":
              if (R = l.getAttribute("rel"), R === "stylesheet" && l.hasAttribute("data-precedence") || R !== O.rel || l.getAttribute("href") !== (O.href == null || O.href === "" ? null : O.href) || l.getAttribute("crossorigin") !== (O.crossOrigin == null ? null : O.crossOrigin) || l.getAttribute("title") !== (O.title == null ? null : O.title))
                break;
              return l;
            case "style":
              if (l.hasAttribute("data-precedence")) break;
              return l;
            case "script":
              if (R = l.getAttribute("src"), (R !== (O.src == null ? null : O.src) || l.getAttribute("type") !== (O.type == null ? null : O.type) || l.getAttribute("crossorigin") !== (O.crossOrigin == null ? null : O.crossOrigin)) && R && l.hasAttribute("async") && !l.hasAttribute("itemprop"))
                break;
              return l;
            default:
              return l;
          }
      } else if (u === "input" && l.type === "hidden") {
        var R = O.name == null ? null : "" + O.name;
        if (O.type === "hidden" && l.getAttribute("name") === R)
          return l;
      } else return l;
      if (l = Go(l.nextSibling), l === null) break;
    }
    return null;
  }
  function Rn(l, u, m) {
    if (u === "") return null;
    for (; l.nodeType !== 3; )
      if ((l.nodeType !== 1 || l.nodeName !== "INPUT" || l.type !== "hidden") && !m || (l = Go(l.nextSibling), l === null)) return null;
    return l;
  }
  function Ly(l, u) {
    for (; l.nodeType !== 8; )
      if ((l.nodeType !== 1 || l.nodeName !== "INPUT" || l.type !== "hidden") && !u || (l = Go(l.nextSibling), l === null)) return null;
    return l;
  }
  function nl(l) {
    return l.data === "$?" || l.data === "$~";
  }
  function Lu(l) {
    return l.data === "$!" || l.data === "$?" && l.ownerDocument.readyState !== "loading";
  }
  function of(l, u) {
    var m = l.ownerDocument;
    if (l.data === "$~") l._reactRetry = u;
    else if (l.data !== "$?" || m.readyState !== "loading")
      u();
    else {
      var v = function() {
        u(), m.removeEventListener("DOMContentLoaded", v);
      };
      m.addEventListener("DOMContentLoaded", v), l._reactRetry = v;
    }
  }
  function Go(l) {
    for (; l != null; l = l.nextSibling) {
      var u = l.nodeType;
      if (u === 1 || u === 3) break;
      if (u === 8) {
        if (u = l.data, u === "$" || u === "$!" || u === "$?" || u === "$~" || u === "&" || u === "F!" || u === "F")
          break;
        if (u === "/$" || u === "/&") return null;
      }
    }
    return l;
  }
  var ch = null;
  function Ng(l) {
    l = l.nextSibling;
    for (var u = 0; l; ) {
      if (l.nodeType === 8) {
        var m = l.data;
        if (m === "/$" || m === "/&") {
          if (u === 0)
            return Go(l.nextSibling);
          u--;
        } else
          m !== "$" && m !== "$!" && m !== "$?" && m !== "$~" && m !== "&" || u++;
      }
      l = l.nextSibling;
    }
    return null;
  }
  function Nl(l) {
    l = l.previousSibling;
    for (var u = 0; l; ) {
      if (l.nodeType === 8) {
        var m = l.data;
        if (m === "$" || m === "$!" || m === "$?" || m === "$~" || m === "&") {
          if (u === 0) return l;
          u--;
        } else m !== "/$" && m !== "/&" || u++;
      }
      l = l.previousSibling;
    }
    return null;
  }
  function lf(l, u, m) {
    switch (u = Iu(m), l) {
      case "html":
        if (l = u.documentElement, !l) throw Error(a(452));
        return l;
      case "head":
        if (l = u.head, !l) throw Error(a(453));
        return l;
      case "body":
        if (l = u.body, !l) throw Error(a(454));
        return l;
      default:
        throw Error(a(451));
    }
  }
  function Hc(l) {
    for (var u = l.attributes; u.length; )
      l.removeAttributeNode(u[0]);
    Rr(l);
  }
  var ai = /* @__PURE__ */ new Map(), dh = /* @__PURE__ */ new Set();
  function Eo(l) {
    return typeof l.getRootNode == "function" ? l.getRootNode() : l.nodeType === 9 ? l : l.ownerDocument;
  }
  var Dl = K.d;
  K.d = {
    f: SC,
    r: Hy,
    D: Xe,
    C: fr,
    L: CC,
    m: R2,
    X: Ks,
    S: A2,
    M: Hu
  };
  function SC() {
    var l = Dl.f(), u = Qd();
    return l || u;
  }
  function Hy(l) {
    var u = en(l);
    u !== null && u.tag === 5 && u.type === "form" ? Pr(u) : Dl.r(l);
  }
  var sf = typeof document > "u" ? null : document;
  function Ta(l, u, m) {
    var v = sf;
    if (v && typeof u == "string" && u) {
      var O = On(u);
      O = 'link[rel="' + l + '"][href="' + O + '"]', typeof m == "string" && (O += '[crossorigin="' + m + '"]'), dh.has(O) || (dh.add(O), l = { rel: l, crossOrigin: m, href: u }, v.querySelector(O) === null && (u = v.createElement("link"), co(u, "link", l), kt(u), v.head.appendChild(u)));
    }
  }
  function Xe(l) {
    Dl.D(l), Ta("dns-prefetch", l, null);
  }
  function fr(l, u) {
    Dl.C(l, u), Ta("preconnect", l, u);
  }
  function CC(l, u, m) {
    Dl.L(l, u, m);
    var v = sf;
    if (v && l && u) {
      var O = 'link[rel="preload"][as="' + On(u) + '"]';
      u === "image" && m && m.imageSrcSet ? (O += '[imagesrcset="' + On(
        m.imageSrcSet
      ) + '"]', typeof m.imageSizes == "string" && (O += '[imagesizes="' + On(
        m.imageSizes
      ) + '"]')) : O += '[href="' + On(l) + '"]';
      var R = O;
      switch (u) {
        case "style":
          R = Oi(l);
          break;
        case "script":
          R = Fc(l);
      }
      ai.has(R) || (l = w(
        {
          rel: "preload",
          href: u === "image" && m && m.imageSrcSet ? void 0 : l,
          as: u
        },
        m
      ), ai.set(R, l), v.querySelector(O) !== null || u === "style" && v.querySelector(Fu(R)) || u === "script" && v.querySelector(df(R)) || (u = v.createElement("link"), co(u, "link", l), kt(u), v.head.appendChild(u)));
    }
  }
  function R2(l, u) {
    Dl.m(l, u);
    var m = sf;
    if (m && l) {
      var v = u && typeof u.as == "string" ? u.as : "script", O = 'link[rel="modulepreload"][as="' + On(v) + '"][href="' + On(l) + '"]', R = O;
      switch (v) {
        case "audioworklet":
        case "paintworklet":
        case "serviceworker":
        case "sharedworker":
        case "worker":
        case "script":
          R = Fc(l);
      }
      if (!ai.has(R) && (l = w({ rel: "modulepreload", href: l }, u), ai.set(R, l), m.querySelector(O) === null)) {
        switch (v) {
          case "audioworklet":
          case "paintworklet":
          case "serviceworker":
          case "sharedworker":
          case "worker":
          case "script":
            if (m.querySelector(df(R)))
              return;
        }
        v = m.createElement("link"), co(v, "link", l), kt(v), m.head.appendChild(v);
      }
    }
  }
  function A2(l, u, m) {
    Dl.S(l, u, m);
    var v = sf;
    if (v && l) {
      var O = zt(v).hoistableStyles, R = Oi(l);
      u = u || "default";
      var B = O.get(R);
      if (!B) {
        var re = { loading: 0, preload: null };
        if (B = v.querySelector(
          Fu(R)
        ))
          re.loading = 5;
        else {
          l = w(
            { rel: "stylesheet", href: l, "data-precedence": u },
            m
          ), (m = ai.get(R)) && Dg(l, m);
          var ve = B = v.createElement("link");
          kt(ve), co(ve, "link", l), ve._p = new Promise(function(He, Je) {
            ve.onload = He, ve.onerror = Je;
          }), ve.addEventListener("load", function() {
            re.loading |= 1;
          }), ve.addEventListener("error", function() {
            re.loading |= 2;
          }), re.loading |= 4, fh(B, u, v);
        }
        B = {
          type: "stylesheet",
          instance: B,
          count: 1,
          state: re
        }, O.set(R, B);
      }
    }
  }
  function Ks(l, u) {
    Dl.X(l, u);
    var m = sf;
    if (m && l) {
      var v = zt(m).hoistableScripts, O = Fc(l), R = v.get(O);
      R || (R = m.querySelector(df(O)), R || (l = w({ src: l, async: !0 }, u), (u = ai.get(O)) && $g(l, u), R = m.createElement("script"), kt(R), co(R, "link", l), m.head.appendChild(R)), R = {
        type: "script",
        instance: R,
        count: 1,
        state: null
      }, v.set(O, R));
    }
  }
  function Hu(l, u) {
    Dl.M(l, u);
    var m = sf;
    if (m && l) {
      var v = zt(m).hoistableScripts, O = Fc(l), R = v.get(O);
      R || (R = m.querySelector(df(O)), R || (l = w({ src: l, async: !0, type: "module" }, u), (u = ai.get(O)) && $g(l, u), R = m.createElement("script"), kt(R), co(R, "link", l), m.head.appendChild(R)), R = {
        type: "script",
        instance: R,
        count: 1,
        state: null
      }, v.set(O, R));
    }
  }
  function uf(l, u, m, v) {
    var O = (O = be.current) ? Eo(O) : null;
    if (!O) throw Error(a(446));
    switch (l) {
      case "meta":
      case "title":
        return null;
      case "style":
        return typeof m.precedence == "string" && typeof m.href == "string" ? (u = Oi(m.href), m = zt(
          O
        ).hoistableStyles, v = m.get(u), v || (v = {
          type: "style",
          instance: null,
          count: 0,
          state: null
        }, m.set(u, v)), v) : { type: "void", instance: null, count: 0, state: null };
      case "link":
        if (m.rel === "stylesheet" && typeof m.href == "string" && typeof m.precedence == "string") {
          l = Oi(m.href);
          var R = zt(
            O
          ).hoistableStyles, B = R.get(l);
          if (B || (O = O.ownerDocument || O, B = {
            type: "stylesheet",
            instance: null,
            count: 0,
            state: { loading: 0, preload: null }
          }, R.set(l, B), (R = O.querySelector(
            Fu(l)
          )) && !R._p && (B.instance = R, B.state.loading = 5), ai.has(l) || (m = {
            rel: "preload",
            as: "style",
            href: m.href,
            crossOrigin: m.crossOrigin,
            integrity: m.integrity,
            media: m.media,
            hrefLang: m.hrefLang,
            referrerPolicy: m.referrerPolicy
          }, ai.set(l, m), R || Fy(
            O,
            l,
            m,
            B.state
          ))), u && v === null)
            throw Error(a(528, ""));
          return B;
        }
        if (u && v !== null)
          throw Error(a(529, ""));
        return null;
      case "script":
        return u = m.async, m = m.src, typeof m == "string" && u && typeof u != "function" && typeof u != "symbol" ? (u = Fc(m), m = zt(
          O
        ).hoistableScripts, v = m.get(u), v || (v = {
          type: "script",
          instance: null,
          count: 0,
          state: null
        }, m.set(u, v)), v) : { type: "void", instance: null, count: 0, state: null };
      default:
        throw Error(a(444, l));
    }
  }
  function Oi(l) {
    return 'href="' + On(l) + '"';
  }
  function Fu(l) {
    return 'link[rel="stylesheet"][' + l + "]";
  }
  function cf(l) {
    return w({}, l, {
      "data-precedence": l.precedence,
      precedence: null
    });
  }
  function Fy(l, u, m, v) {
    l.querySelector('link[rel="preload"][as="style"][' + u + "]") ? v.loading = 1 : (u = l.createElement("link"), v.preload = u, u.addEventListener("load", function() {
      return v.loading |= 1;
    }), u.addEventListener("error", function() {
      return v.loading |= 2;
    }), co(u, "link", m), kt(u), l.head.appendChild(u));
  }
  function Fc(l) {
    return '[src="' + On(l) + '"]';
  }
  function df(l) {
    return "script[async]" + l;
  }
  function N2(l, u, m) {
    if (u.count++, u.instance === null)
      switch (u.type) {
        case "style":
          var v = l.querySelector(
            'style[data-href~="' + On(m.href) + '"]'
          );
          if (v)
            return u.instance = v, kt(v), v;
          var O = w({}, m, {
            "data-href": m.href,
            "data-precedence": m.precedence,
            href: null,
            precedence: null
          });
          return v = (l.ownerDocument || l).createElement(
            "style"
          ), kt(v), co(v, "style", O), fh(v, m.precedence, l), u.instance = v;
        case "stylesheet":
          O = Oi(m.href);
          var R = l.querySelector(
            Fu(O)
          );
          if (R)
            return u.state.loading |= 4, u.instance = R, kt(R), R;
          v = cf(m), (O = ai.get(O)) && Dg(v, O), R = (l.ownerDocument || l).createElement("link"), kt(R);
          var B = R;
          return B._p = new Promise(function(re, ve) {
            B.onload = re, B.onerror = ve;
          }), co(R, "link", v), u.state.loading |= 4, fh(R, m.precedence, l), u.instance = R;
        case "script":
          return R = Fc(m.src), (O = l.querySelector(
            df(R)
          )) ? (u.instance = O, kt(O), O) : (v = m, (O = ai.get(R)) && (v = w({}, m), $g(v, O)), l = l.ownerDocument || l, O = l.createElement("script"), kt(O), co(O, "link", v), l.head.appendChild(O), u.instance = O);
        case "void":
          return null;
        default:
          throw Error(a(443, u.type));
      }
    else
      u.type === "stylesheet" && (u.state.loading & 4) === 0 && (v = u.instance, u.state.loading |= 4, fh(v, m.precedence, l));
    return u.instance;
  }
  function fh(l, u, m) {
    for (var v = m.querySelectorAll(
      'link[rel="stylesheet"][data-precedence],style[data-precedence]'
    ), O = v.length ? v[v.length - 1] : null, R = O, B = 0; B < v.length; B++) {
      var re = v[B];
      if (re.dataset.precedence === u) R = re;
      else if (R !== O) break;
    }
    R ? R.parentNode.insertBefore(l, R.nextSibling) : (u = m.nodeType === 9 ? m.head : m, u.insertBefore(l, u.firstChild));
  }
  function Dg(l, u) {
    l.crossOrigin == null && (l.crossOrigin = u.crossOrigin), l.referrerPolicy == null && (l.referrerPolicy = u.referrerPolicy), l.title == null && (l.title = u.title);
  }
  function $g(l, u) {
    l.crossOrigin == null && (l.crossOrigin = u.crossOrigin), l.referrerPolicy == null && (l.referrerPolicy = u.referrerPolicy), l.integrity == null && (l.integrity = u.integrity);
  }
  var ff = null;
  function D2(l, u, m) {
    if (ff === null) {
      var v = /* @__PURE__ */ new Map(), O = ff = /* @__PURE__ */ new Map();
      O.set(m, v);
    } else
      O = ff, v = O.get(m), v || (v = /* @__PURE__ */ new Map(), O.set(m, v));
    if (v.has(l)) return v;
    for (v.set(l, null), m = m.getElementsByTagName(l), O = 0; O < m.length; O++) {
      var R = m[O];
      if (!(R[qn] || R[Gt] || l === "link" && R.getAttribute("rel") === "stylesheet") && R.namespaceURI !== "http://www.w3.org/2000/svg") {
        var B = R.getAttribute(u) || "";
        B = l + B;
        var re = v.get(B);
        re ? re.push(R) : v.set(B, [R]);
      }
    }
    return v;
  }
  function zg(l, u, m) {
    l = l.ownerDocument || l, l.head.insertBefore(
      m,
      u === "title" ? l.querySelector("head > title") : null
    );
  }
  function $2(l, u, m) {
    if (m === 1 || u.itemProp != null) return !1;
    switch (l) {
      case "meta":
      case "title":
        return !0;
      case "style":
        if (typeof u.precedence != "string" || typeof u.href != "string" || u.href === "")
          break;
        return !0;
      case "link":
        if (typeof u.rel != "string" || typeof u.href != "string" || u.href === "" || u.onLoad || u.onError)
          break;
        switch (u.rel) {
          case "stylesheet":
            return l = u.disabled, typeof u.precedence == "string" && l == null;
          default:
            return !0;
        }
      case "script":
        if (u.async && typeof u.async != "function" && typeof u.async != "symbol" && !u.onLoad && !u.onError && u.src && typeof u.src == "string")
          return !0;
    }
    return !1;
  }
  function oi(l) {
    return !(l.type === "stylesheet" && (l.state.loading & 3) === 0);
  }
  function ds(l, u, m, v) {
    if (m.type === "stylesheet" && (typeof v.media != "string" || matchMedia(v.media).matches !== !1) && (m.state.loading & 4) === 0) {
      if (m.instance === null) {
        var O = Oi(v.href), R = u.querySelector(
          Fu(O)
        );
        if (R) {
          u = R._p, u !== null && typeof u == "object" && typeof u.then == "function" && (l.count++, l = jg.bind(l), u.then(l, l)), m.state.loading |= 4, m.instance = R, kt(R);
          return;
        }
        R = u.ownerDocument || u, v = cf(v), (O = ai.get(O)) && Dg(v, O), R = R.createElement("link"), kt(R);
        var B = R;
        B._p = new Promise(function(re, ve) {
          B.onload = re, B.onerror = ve;
        }), co(R, "link", v), m.instance = R;
      }
      l.stylesheets === null && (l.stylesheets = /* @__PURE__ */ new Map()), l.stylesheets.set(m, u), (u = m.state.preload) && (m.state.loading & 3) === 0 && (l.count++, m = jg.bind(l), u.addEventListener("load", m), u.addEventListener("error", m));
    }
  }
  var Ti = 0;
  function z2(l, u) {
    return l.stylesheets && l.count === 0 && Lg(l, l.stylesheets), 0 < l.count || 0 < l.imgCount ? function(m) {
      var v = setTimeout(function() {
        if (l.stylesheets && Lg(l, l.stylesheets), l.unsuspend) {
          var R = l.unsuspend;
          l.unsuspend = null, R();
        }
      }, 6e4 + u);
      0 < l.imgBytes && Ti === 0 && (Ti = 62500 * k2());
      var O = setTimeout(
        function() {
          if (l.waitingForImages = !1, l.count === 0 && (l.stylesheets && Lg(l, l.stylesheets), l.unsuspend)) {
            var R = l.unsuspend;
            l.unsuspend = null, R();
          }
        },
        (l.imgBytes > Ti ? 50 : 800) + u
      );
      return l.unsuspend = m, function() {
        l.unsuspend = null, clearTimeout(v), clearTimeout(O);
      };
    } : null;
  }
  function jg() {
    if (this.count--, this.count === 0 && (this.imgCount === 0 || !this.waitingForImages)) {
      if (this.stylesheets) Lg(this, this.stylesheets);
      else if (this.unsuspend) {
        var l = this.unsuspend;
        this.unsuspend = null, l();
      }
    }
  }
  var Ig = null;
  function Lg(l, u) {
    l.stylesheets = null, l.unsuspend !== null && (l.count++, Ig = /* @__PURE__ */ new Map(), u.forEach(Ka, l), Ig = null, jg.call(l));
  }
  function Ka(l, u) {
    if (!(u.state.loading & 4)) {
      var m = Ig.get(l);
      if (m) var v = m.get(null);
      else {
        m = /* @__PURE__ */ new Map(), Ig.set(l, m);
        for (var O = l.querySelectorAll(
          "link[data-precedence],style[data-precedence]"
        ), R = 0; R < O.length; R++) {
          var B = O[R];
          (B.nodeName === "LINK" || B.getAttribute("media") !== "not all") && (m.set(B.dataset.precedence, B), v = B);
        }
        v && m.set(null, v);
      }
      O = u.instance, B = O.getAttribute("data-precedence"), R = m.get(B) || v, R === v && m.set(null, O), m.set(B, O), this.count++, v = jg.bind(this), O.addEventListener("load", v), O.addEventListener("error", v), R ? R.parentNode.insertBefore(O, R.nextSibling) : (l = l.nodeType === 9 ? l.head : l, l.insertBefore(O, l.firstChild)), u.state.loading |= 4;
    }
  }
  var mh = {
    $$typeof: D,
    Provider: null,
    Consumer: null,
    _currentValue: X,
    _currentValue2: X,
    _threadCount: 0
  };
  function j2(l, u, m, v, O, R, B, re, ve) {
    this.tag = 1, this.containerInfo = l, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = xn(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = xn(0), this.hiddenUpdates = xn(null), this.identifierPrefix = v, this.onUncaughtError = O, this.onCaughtError = R, this.onRecoverableError = B, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = ve, this.incompleteTransitions = /* @__PURE__ */ new Map();
  }
  function Hg(l, u, m, v, O, R, B, re, ve, He, Je, nt) {
    return l = new j2(
      l,
      u,
      m,
      B,
      ve,
      He,
      Je,
      nt,
      re
    ), u = 1, R === !0 && (u |= 24), R = ca(3, null, null, u), l.current = R, R.stateNode = l, u = Sm(), u.refCount++, l.pooledCache = u, u.refCount++, R.memoizedState = {
      element: v,
      isDehydrated: m,
      cache: u
    }, Om(R), l;
  }
  function Wc(l) {
    return l ? (l = jo, l) : jo;
  }
  function Wy(l, u, m, v, O, R) {
    O = Wc(O), v.context === null ? v.context = O : v.pendingContext = O, v = Hs(u), v.payload = { element: m }, R = R === void 0 ? null : R, R !== null && (v.callback = R), m = Ci(l, v, u), m !== null && (Xo(m, l, u), Eu(m, l, u));
  }
  function Fg(l, u) {
    if (l = l.memoizedState, l !== null && l.dehydrated !== null) {
      var m = l.retryLane;
      l.retryLane = m !== 0 && m < u ? m : u;
    }
  }
  function I2(l, u) {
    Fg(l, u), (l = l.alternate) && Fg(l, u);
  }
  function Vy(l) {
    if (l.tag === 13 || l.tag === 31) {
      var u = Ns(l, 67108864);
      u !== null && Xo(u, l, 67108864), I2(l, 67108864);
    }
  }
  function Vc(l) {
    if (l.tag === 13 || l.tag === 31) {
      var u = ri();
      u = wt(u);
      var m = Ns(l, u);
      m !== null && Xo(m, l, u), I2(l, u);
    }
  }
  var Ia = !0;
  function fs(l, u, m, v) {
    var O = H.T;
    H.T = null;
    var R = K.p;
    try {
      K.p = 2, fo(l, u, m, v);
    } finally {
      K.p = R, H.T = O;
    }
  }
  function ms(l, u, m, v) {
    var O = H.T;
    H.T = null;
    var R = K.p;
    try {
      K.p = 8, fo(l, u, m, v);
    } finally {
      K.p = R, H.T = O;
    }
  }
  function fo(l, u, m, v) {
    if (Ia) {
      var O = L2(v);
      if (O === null)
        w2(
          l,
          u,
          v,
          Wg,
          m
        ), Ys(l, v);
      else if (xC(
        O,
        l,
        u,
        m,
        v
      ))
        v.stopPropagation();
      else if (Ys(l, v), u & 4 && -1 < qo.indexOf(l)) {
        for (; O !== null; ) {
          var R = en(O);
          if (R !== null)
            switch (R.tag) {
              case 3:
                if (R = R.stateNode, R.current.memoizedState.isDehydrated) {
                  var B = $t(R.pendingLanes);
                  if (B !== 0) {
                    var re = R;
                    for (re.pendingLanes |= 2, re.entangledLanes |= 2; B; ) {
                      var ve = 1 << 31 - ot(B);
                      re.entanglements[1] |= ve, B &= ~ve;
                    }
                    cs(R), (ir & 6) === 0 && (dr = Fe() + 500, qs(0));
                  }
                }
                break;
              case 31:
              case 13:
                re = Ns(R, 2), re !== null && Xo(re, R, 2), Qd(), I2(R, 2);
            }
          if (R = L2(v), R === null && w2(
            l,
            u,
            v,
            Wg,
            m
          ), R === O) break;
          O = R;
        }
        O !== null && v.stopPropagation();
      } else
        w2(
          l,
          u,
          v,
          null,
          m
        );
    }
  }
  function L2(l) {
    return l = Li(l), mf(l);
  }
  var Wg = null;
  function mf(l) {
    if (Wg = null, l = Wt(l), l !== null) {
      var u = c(l);
      if (u === null) l = null;
      else {
        var m = u.tag;
        if (m === 13) {
          if (l = d(u), l !== null) return l;
          l = null;
        } else if (m === 31) {
          if (l = f(u), l !== null) return l;
          l = null;
        } else if (m === 3) {
          if (u.stateNode.current.memoizedState.isDehydrated)
            return u.tag === 3 ? u.stateNode.containerInfo : null;
          l = null;
        } else u !== l && (l = null);
      }
    }
    return Wg = l, null;
  }
  function hh(l) {
    switch (l) {
      case "beforetoggle":
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "toggle":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 2;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 8;
      case "message":
        switch (tt()) {
          case dt:
            return 2;
          case St:
            return 8;
          case mt:
          case Ot:
            return 32;
          case Rt:
            return 268435456;
          default:
            return 32;
        }
      default:
        return 32;
    }
  }
  var hf = !1, La = null, mo = null, Po = null, Wu = /* @__PURE__ */ new Map(), rl = /* @__PURE__ */ new Map(), Xr = [], qo = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
    " "
  );
  function Ys(l, u) {
    switch (l) {
      case "focusin":
      case "focusout":
        La = null;
        break;
      case "dragenter":
      case "dragleave":
        mo = null;
        break;
      case "mouseover":
      case "mouseout":
        Po = null;
        break;
      case "pointerover":
      case "pointerout":
        Wu.delete(u.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        rl.delete(u.pointerId);
    }
  }
  function _c(l, u, m, v, O, R) {
    return l === null || l.nativeEvent !== R ? (l = {
      blockedOn: u,
      domEventName: m,
      eventSystemFlags: v,
      nativeEvent: R,
      targetContainers: [O]
    }, u !== null && (u = en(u), u !== null && Vy(u)), l) : (l.eventSystemFlags |= v, u = l.targetContainers, O !== null && u.indexOf(O) === -1 && u.push(O), l);
  }
  function xC(l, u, m, v, O) {
    switch (u) {
      case "focusin":
        return La = _c(
          La,
          l,
          u,
          m,
          v,
          O
        ), !0;
      case "dragenter":
        return mo = _c(
          mo,
          l,
          u,
          m,
          v,
          O
        ), !0;
      case "mouseover":
        return Po = _c(
          Po,
          l,
          u,
          m,
          v,
          O
        ), !0;
      case "pointerover":
        var R = O.pointerId;
        return Wu.set(
          R,
          _c(
            Wu.get(R) || null,
            l,
            u,
            m,
            v,
            O
          )
        ), !0;
      case "gotpointercapture":
        return R = O.pointerId, rl.set(
          R,
          _c(
            rl.get(R) || null,
            l,
            u,
            m,
            v,
            O
          )
        ), !0;
    }
    return !1;
  }
  function _y(l) {
    var u = Wt(l.target);
    if (u !== null) {
      var m = c(u);
      if (m !== null) {
        if (u = m.tag, u === 13) {
          if (u = d(m), u !== null) {
            l.blockedOn = u, gn(l.priority, function() {
              Vc(m);
            });
            return;
          }
        } else if (u === 31) {
          if (u = f(m), u !== null) {
            l.blockedOn = u, gn(l.priority, function() {
              Vc(m);
            });
            return;
          }
        } else if (u === 3 && m.stateNode.current.memoizedState.isDehydrated) {
          l.blockedOn = m.tag === 3 ? m.stateNode.containerInfo : null;
          return;
        }
      }
    }
    l.blockedOn = null;
  }
  function ph(l) {
    if (l.blockedOn !== null) return !1;
    for (var u = l.targetContainers; 0 < u.length; ) {
      var m = L2(l.nativeEvent);
      if (m === null) {
        m = l.nativeEvent;
        var v = new m.constructor(
          m.type,
          m
        );
        pi = v, m.target.dispatchEvent(v), pi = null;
      } else
        return u = en(m), u !== null && Vy(u), l.blockedOn = m, !1;
      u.shift();
    }
    return !0;
  }
  function pf(l, u, m) {
    ph(l) && m.delete(u);
  }
  function By() {
    hf = !1, La !== null && ph(La) && (La = null), mo !== null && ph(mo) && (mo = null), Po !== null && ph(Po) && (Po = null), Wu.forEach(pf), rl.forEach(pf);
  }
  function hs(l, u) {
    l.blockedOn === u && (l.blockedOn = null, hf || (hf = !0, e.unstable_scheduleCallback(
      e.unstable_NormalPriority,
      By
    )));
  }
  var gf = null;
  function Uy(l) {
    gf !== l && (gf = l, e.unstable_scheduleCallback(
      e.unstable_NormalPriority,
      function() {
        gf === l && (gf = null);
        for (var u = 0; u < l.length; u += 3) {
          var m = l[u], v = l[u + 1], O = l[u + 2];
          if (typeof v != "function") {
            if (mf(v || m) === null)
              continue;
            break;
          }
          var R = en(m);
          R !== null && (l.splice(u, 3), u -= 3, Ld(
            R,
            {
              pending: !0,
              data: O,
              method: m.method,
              action: v
            },
            v,
            O
          ));
        }
      }
    ));
  }
  function vf(l) {
    function u(ve) {
      return hs(ve, l);
    }
    La !== null && hs(La, l), mo !== null && hs(mo, l), Po !== null && hs(Po, l), Wu.forEach(u), rl.forEach(u);
    for (var m = 0; m < Xr.length; m++) {
      var v = Xr[m];
      v.blockedOn === l && (v.blockedOn = null);
    }
    for (; 0 < Xr.length && (m = Xr[0], m.blockedOn === null); )
      _y(m), m.blockedOn === null && Xr.shift();
    if (m = (l.ownerDocument || l).$$reactFormReplay, m != null)
      for (v = 0; v < m.length; v += 3) {
        var O = m[v], R = m[v + 1], B = O[Dt] || null;
        if (typeof R == "function")
          B || Uy(m);
        else if (B) {
          var re = null;
          if (R && R.hasAttribute("formAction")) {
            if (O = R, B = R[Dt] || null)
              re = B.formAction;
            else if (mf(O) !== null) continue;
          } else re = B.action;
          typeof re == "function" ? m[v + 1] = re : (m.splice(v, 3), v -= 3), Uy(m);
        }
      }
  }
  function H2() {
    function l(R) {
      R.canIntercept && R.info === "react-transition" && R.intercept({
        handler: function() {
          return new Promise(function(B) {
            return O = B;
          });
        },
        focusReset: "manual",
        scroll: "manual"
      });
    }
    function u() {
      O !== null && (O(), O = null), v || setTimeout(m, 20);
    }
    function m() {
      if (!v && !navigation.transition) {
        var R = navigation.currentEntry;
        R && R.url != null && navigation.navigate(R.url, {
          state: R.getState(),
          info: "react-transition",
          history: "replace"
        });
      }
    }
    if (typeof navigation == "object") {
      var v = !1, O = null;
      return navigation.addEventListener("navigate", l), navigation.addEventListener("navigatesuccess", u), navigation.addEventListener("navigateerror", u), setTimeout(m, 100), function() {
        v = !0, navigation.removeEventListener("navigate", l), navigation.removeEventListener("navigatesuccess", u), navigation.removeEventListener("navigateerror", u), O !== null && (O(), O = null);
      };
    }
  }
  function Vg(l) {
    this._internalRoot = l;
  }
  _g.prototype.render = Vg.prototype.render = function(l) {
    var u = this._internalRoot;
    if (u === null) throw Error(a(409));
    var m = u.current, v = ri();
    Wy(m, v, l, u, null, null);
  }, _g.prototype.unmount = Vg.prototype.unmount = function() {
    var l = this._internalRoot;
    if (l !== null) {
      this._internalRoot = null;
      var u = l.containerInfo;
      Wy(l.current, 2, null, l, null, null), Qd(), u[Yt] = null;
    }
  };
  function _g(l) {
    this._internalRoot = l;
  }
  _g.prototype.unstable_scheduleHydration = function(l) {
    if (l) {
      var u = yn();
      l = { blockedOn: null, target: l, priority: u };
      for (var m = 0; m < Xr.length && u !== 0 && u < Xr[m].priority; m++) ;
      Xr.splice(m, 0, l), m === 0 && _y(l);
    }
  };
  var F2 = t.version;
  if (F2 !== "19.2.4")
    throw Error(
      a(
        527,
        F2,
        "19.2.4"
      )
    );
  K.findDOMNode = function(l) {
    var u = l._reactInternals;
    if (u === void 0)
      throw typeof l.render == "function" ? Error(a(188)) : (l = Object.keys(l).join(","), Error(a(268, l)));
    return l = g(u), l = l !== null ? b(l) : null, l = l === null ? null : l.stateNode, l;
  };
  var Xy = {
    bundleType: 0,
    version: "19.2.4",
    rendererPackageName: "react-dom",
    currentDispatcherRef: H,
    reconcilerVersion: "19.2.4"
  };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var gh = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!gh.isDisabled && gh.supportsFiber)
      try {
        Ct = gh.inject(
          Xy
        ), ut = gh;
      } catch {
      }
  }
  return F5.createRoot = function(l, u) {
    if (!i(l)) throw Error(a(299));
    var m = !1, v = "", O = eg, R = Wv, B = tg;
    return u != null && (u.unstable_strictMode === !0 && (m = !0), u.identifierPrefix !== void 0 && (v = u.identifierPrefix), u.onUncaughtError !== void 0 && (O = u.onUncaughtError), u.onCaughtError !== void 0 && (R = u.onCaughtError), u.onRecoverableError !== void 0 && (B = u.onRecoverableError)), u = Hg(
      l,
      1,
      !1,
      null,
      null,
      m,
      v,
      null,
      O,
      R,
      B,
      H2
    ), l[Yt] = u.current, rf(l), new Vg(u);
  }, F5.hydrateRoot = function(l, u, m) {
    if (!i(l)) throw Error(a(299));
    var v = !1, O = "", R = eg, B = Wv, re = tg, ve = null;
    return m != null && (m.unstable_strictMode === !0 && (v = !0), m.identifierPrefix !== void 0 && (O = m.identifierPrefix), m.onUncaughtError !== void 0 && (R = m.onUncaughtError), m.onCaughtError !== void 0 && (B = m.onCaughtError), m.onRecoverableError !== void 0 && (re = m.onRecoverableError), m.formState !== void 0 && (ve = m.formState)), u = Hg(
      l,
      1,
      !0,
      u,
      m ?? null,
      v,
      O,
      ve,
      R,
      B,
      re,
      H2
    ), u.context = Wc(null), m = u.current, v = ri(), v = wt(v), O = Hs(v), O.callback = null, Ci(m, O, v), m = v, u.current.lanes = m, Ut(u, m), cs(u), l[Yt] = u.current, rf(l), new _g(u);
  }, F5.version = "19.2.4", F5;
}
var vP = {};
/**
 * @license React
 * react-dom-client.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var aB;
function TPe() {
  return aB || (aB = 1, process.env.NODE_ENV !== "production" && (function() {
    function e(n, o) {
      for (n = n.memoizedState; n !== null && 0 < o; )
        n = n.next, o--;
      return n;
    }
    function t(n, o, s, h) {
      if (s >= o.length) return h;
      var y = o[s], C = Ta(n) ? n.slice() : Rn({}, n);
      return C[y] = t(n[y], o, s + 1, h), C;
    }
    function r(n, o, s) {
      if (o.length !== s.length)
        console.warn("copyWithRename() expects paths of the same length");
      else {
        for (var h = 0; h < s.length - 1; h++)
          if (o[h] !== s[h]) {
            console.warn(
              "copyWithRename() expects paths to be the same except for the deepest key"
            );
            return;
          }
        return a(n, o, s, 0);
      }
    }
    function a(n, o, s, h) {
      var y = o[h], C = Ta(n) ? n.slice() : Rn({}, n);
      return h + 1 === o.length ? (C[s[h]] = C[y], Ta(C) ? C.splice(y, 1) : delete C[y]) : C[y] = a(
        n[y],
        o,
        s,
        h + 1
      ), C;
    }
    function i(n, o, s) {
      var h = o[s], y = Ta(n) ? n.slice() : Rn({}, n);
      return s + 1 === o.length ? (Ta(y) ? y.splice(h, 1) : delete y[h], y) : (y[h] = i(n[h], o, s + 1), y);
    }
    function c() {
      return !1;
    }
    function d() {
      return null;
    }
    function f() {
      console.error(
        "Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://react.dev/link/rules-of-hooks"
      );
    }
    function p() {
      console.error(
        "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."
      );
    }
    function g() {
    }
    function b() {
    }
    function w(n) {
      var o = [];
      return n.forEach(function(s) {
        o.push(s);
      }), o.sort().join(", ");
    }
    function x(n, o, s, h) {
      return new pC(n, o, s, h);
    }
    function E(n, o) {
      n.context === Sf && (Mg(n.current, 2, o, n, null, null), ki());
    }
    function P(n, o) {
      if (vs !== null) {
        var s = o.staleFamilies;
        o = o.updatedFamilies, Gm(), Ib(
          n.current,
          o,
          s
        ), ki();
      }
    }
    function k(n) {
      vs = n;
    }
    function M(n) {
      return !(!n || n.nodeType !== 1 && n.nodeType !== 9 && n.nodeType !== 11);
    }
    function T(n) {
      var o = n, s = n;
      if (n.alternate) for (; o.return; ) o = o.return;
      else {
        n = o;
        do
          o = n, (o.flags & 4098) !== 0 && (s = o.return), n = o.return;
        while (n);
      }
      return o.tag === 3 ? s : null;
    }
    function N(n) {
      if (n.tag === 13) {
        var o = n.memoizedState;
        if (o === null && (n = n.alternate, n !== null && (o = n.memoizedState)), o !== null) return o.dehydrated;
      }
      return null;
    }
    function D(n) {
      if (n.tag === 31) {
        var o = n.memoizedState;
        if (o === null && (n = n.alternate, n !== null && (o = n.memoizedState)), o !== null) return o.dehydrated;
      }
      return null;
    }
    function $(n) {
      if (T(n) !== n)
        throw Error("Unable to find node on an unmounted component.");
    }
    function j(n) {
      var o = n.alternate;
      if (!o) {
        if (o = T(n), o === null)
          throw Error("Unable to find node on an unmounted component.");
        return o !== n ? null : n;
      }
      for (var s = n, h = o; ; ) {
        var y = s.return;
        if (y === null) break;
        var C = y.alternate;
        if (C === null) {
          if (h = y.return, h !== null) {
            s = h;
            continue;
          }
          break;
        }
        if (y.child === C.child) {
          for (C = y.child; C; ) {
            if (C === s) return $(y), n;
            if (C === h) return $(y), o;
            C = C.sibling;
          }
          throw Error("Unable to find node on an unmounted component.");
        }
        if (s.return !== h.return) s = y, h = C;
        else {
          for (var A = !1, z = y.child; z; ) {
            if (z === s) {
              A = !0, s = y, h = C;
              break;
            }
            if (z === h) {
              A = !0, h = y, s = C;
              break;
            }
            z = z.sibling;
          }
          if (!A) {
            for (z = C.child; z; ) {
              if (z === s) {
                A = !0, s = C, h = y;
                break;
              }
              if (z === h) {
                A = !0, h = C, s = y;
                break;
              }
              z = z.sibling;
            }
            if (!A)
              throw Error(
                "Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue."
              );
          }
        }
        if (s.alternate !== h)
          throw Error(
            "Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue."
          );
      }
      if (s.tag !== 3)
        throw Error("Unable to find node on an unmounted component.");
      return s.stateNode.current === s ? n : o;
    }
    function I(n) {
      var o = n.tag;
      if (o === 5 || o === 26 || o === 27 || o === 6) return n;
      for (n = n.child; n !== null; ) {
        if (o = I(n), o !== null) return o;
        n = n.sibling;
      }
      return null;
    }
    function L(n) {
      return n === null || typeof n != "object" ? null : (n = Hy && n[Hy] || n["@@iterator"], typeof n == "function" ? n : null);
    }
    function F(n) {
      if (n == null) return null;
      if (typeof n == "function")
        return n.$$typeof === sf ? null : n.displayName || n.name || null;
      if (typeof n == "string") return n;
      switch (n) {
        case of:
          return "Fragment";
        case ch:
          return "Profiler";
        case Go:
          return "StrictMode";
        case Hc:
          return "Suspense";
        case ai:
          return "SuspenseList";
        case Dl:
          return "Activity";
      }
      if (typeof n == "object")
        switch (typeof n.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), n.$$typeof) {
          case Lu:
            return "Portal";
          case Nl:
            return n.displayName || "Context";
          case Ng:
            return (n._context.displayName || "Context") + ".Consumer";
          case lf:
            var o = n.render;
            return n = n.displayName, n || (n = o.displayName || o.name || "", n = n !== "" ? "ForwardRef(" + n + ")" : "ForwardRef"), n;
          case dh:
            return o = n.displayName || null, o !== null ? o : F(n.type) || "Memo";
          case Eo:
            o = n._payload, n = n._init;
            try {
              return F(n(o));
            } catch {
            }
        }
      return null;
    }
    function _(n) {
      return typeof n.tag == "number" ? W(n) : typeof n.name == "string" ? n.name : null;
    }
    function W(n) {
      var o = n.type;
      switch (n.tag) {
        case 31:
          return "Activity";
        case 24:
          return "Cache";
        case 9:
          return (o._context.displayName || "Context") + ".Consumer";
        case 10:
          return o.displayName || "Context";
        case 18:
          return "DehydratedFragment";
        case 11:
          return n = o.render, n = n.displayName || n.name || "", o.displayName || (n !== "" ? "ForwardRef(" + n + ")" : "ForwardRef");
        case 7:
          return "Fragment";
        case 26:
        case 27:
        case 5:
          return o;
        case 4:
          return "Portal";
        case 3:
          return "Root";
        case 6:
          return "Text";
        case 16:
          return F(o);
        case 8:
          return o === Go ? "StrictMode" : "Mode";
        case 22:
          return "Offscreen";
        case 12:
          return "Profiler";
        case 21:
          return "Scope";
        case 13:
          return "Suspense";
        case 19:
          return "SuspenseList";
        case 25:
          return "TracingMarker";
        case 1:
        case 0:
        case 14:
        case 15:
          if (typeof o == "function")
            return o.displayName || o.name || null;
          if (typeof o == "string") return o;
          break;
        case 29:
          if (o = n._debugInfo, o != null) {
            for (var s = o.length - 1; 0 <= s; s--)
              if (typeof o[s].name == "string") return o[s].name;
          }
          if (n.return !== null)
            return W(n.return);
      }
      return null;
    }
    function Q(n) {
      return { current: n };
    }
    function U(n, o) {
      0 > Ks ? console.error("Unexpected pop.") : (o !== A2[Ks] && console.error("Unexpected Fiber popped."), n.current = R2[Ks], R2[Ks] = null, A2[Ks] = null, Ks--);
    }
    function Y(n, o, s) {
      Ks++, R2[Ks] = n.current, A2[Ks] = s, n.current = o;
    }
    function G(n) {
      return n === null && console.error(
        "Expected host context to exist. This error is likely caused by a bug in React. Please file an issue."
      ), n;
    }
    function J(n, o) {
      Y(Oi, o, n), Y(uf, n, n), Y(Hu, null, n);
      var s = o.nodeType;
      switch (s) {
        case 9:
        case 11:
          s = s === 9 ? "#document" : "#fragment", o = (o = o.documentElement) && (o = o.namespaceURI) ? fy(o) : dd;
          break;
        default:
          if (s = o.tagName, o = o.namespaceURI)
            o = fy(o), o = Xs(
              o,
              s
            );
          else
            switch (s) {
              case "svg":
                o = y0;
                break;
              case "math":
                o = Iw;
                break;
              default:
                o = dd;
            }
      }
      s = s.toLowerCase(), s = Bi(null, s), s = {
        context: o,
        ancestorInfo: s
      }, U(Hu, n), Y(Hu, s, n);
    }
    function H(n) {
      U(Hu, n), U(uf, n), U(Oi, n);
    }
    function K() {
      return G(Hu.current);
    }
    function X(n) {
      n.memoizedState !== null && Y(Fu, n, n);
      var o = G(Hu.current), s = n.type, h = Xs(o.context, s);
      s = Bi(o.ancestorInfo, s), h = { context: h, ancestorInfo: s }, o !== h && (Y(uf, n, n), Y(Hu, h, n));
    }
    function te(n) {
      uf.current === n && (U(Hu, n), U(uf, n)), Fu.current === n && (U(Fu, n), T1._currentValue = Hh);
    }
    function ie() {
    }
    function ee() {
      if (cf === 0) {
        Fy = console.log, Fc = console.info, df = console.warn, N2 = console.error, fh = console.group, Dg = console.groupCollapsed, $g = console.groupEnd;
        var n = {
          configurable: !0,
          enumerable: !0,
          value: ie,
          writable: !0
        };
        Object.defineProperties(console, {
          info: n,
          log: n,
          warn: n,
          error: n,
          group: n,
          groupCollapsed: n,
          groupEnd: n
        });
      }
      cf++;
    }
    function ne() {
      if (cf--, cf === 0) {
        var n = { configurable: !0, enumerable: !0, writable: !0 };
        Object.defineProperties(console, {
          log: Rn({}, n, { value: Fy }),
          info: Rn({}, n, { value: Fc }),
          warn: Rn({}, n, { value: df }),
          error: Rn({}, n, { value: N2 }),
          group: Rn({}, n, { value: fh }),
          groupCollapsed: Rn({}, n, { value: Dg }),
          groupEnd: Rn({}, n, { value: $g })
        });
      }
      0 > cf && console.error(
        "disabledDepth fell below zero. This is a bug in React. Please file an issue."
      );
    }
    function ae(n) {
      var o = Error.prepareStackTrace;
      if (Error.prepareStackTrace = void 0, n = n.stack, Error.prepareStackTrace = o, n.startsWith(`Error: react-stack-top-frame
`) && (n = n.slice(29)), o = n.indexOf(`
`), o !== -1 && (n = n.slice(o + 1)), o = n.indexOf("react_stack_bottom_frame"), o !== -1 && (o = n.lastIndexOf(
        `
`,
        o
      )), o !== -1)
        n = n.slice(0, o);
      else return "";
      return n;
    }
    function oe(n) {
      if (ff === void 0)
        try {
          throw Error();
        } catch (s) {
          var o = s.stack.trim().match(/\n( *(at )?)/);
          ff = o && o[1] || "", D2 = -1 < s.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < s.stack.indexOf("@") ? "@unknown:0:0" : "";
        }
      return `
` + ff + n + D2;
    }
    function fe(n, o) {
      if (!n || zg) return "";
      var s = $2.get(n);
      if (s !== void 0) return s;
      zg = !0, s = Error.prepareStackTrace, Error.prepareStackTrace = void 0;
      var h = null;
      h = Xe.H, Xe.H = null, ee();
      try {
        var y = {
          DetermineComponentFrameRoot: function() {
            try {
              if (o) {
                var de = function() {
                  throw Error();
                };
                if (Object.defineProperty(de.prototype, "props", {
                  set: function() {
                    throw Error();
                  }
                }), typeof Reflect == "object" && Reflect.construct) {
                  try {
                    Reflect.construct(de, []);
                  } catch (yt) {
                    var Ve = yt;
                  }
                  Reflect.construct(n, [], de);
                } else {
                  try {
                    de.call();
                  } catch (yt) {
                    Ve = yt;
                  }
                  n.call(de.prototype);
                }
              } else {
                try {
                  throw Error();
                } catch (yt) {
                  Ve = yt;
                }
                (de = n()) && typeof de.catch == "function" && de.catch(function() {
                });
              }
            } catch (yt) {
              if (yt && Ve && typeof yt.stack == "string")
                return [yt.stack, Ve.stack];
            }
            return [null, null];
          }
        };
        y.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var C = Object.getOwnPropertyDescriptor(
          y.DetermineComponentFrameRoot,
          "name"
        );
        C && C.configurable && Object.defineProperty(
          y.DetermineComponentFrameRoot,
          "name",
          { value: "DetermineComponentFrameRoot" }
        );
        var A = y.DetermineComponentFrameRoot(), z = A[0], q = A[1];
        if (z && q) {
          var Z = z.split(`
`), xe = q.split(`
`);
          for (A = C = 0; C < Z.length && !Z[C].includes(
            "DetermineComponentFrameRoot"
          ); )
            C++;
          for (; A < xe.length && !xe[A].includes(
            "DetermineComponentFrameRoot"
          ); )
            A++;
          if (C === Z.length || A === xe.length)
            for (C = Z.length - 1, A = xe.length - 1; 1 <= C && 0 <= A && Z[C] !== xe[A]; )
              A--;
          for (; 1 <= C && 0 <= A; C--, A--)
            if (Z[C] !== xe[A]) {
              if (C !== 1 || A !== 1)
                do
                  if (C--, A--, 0 > A || Z[C] !== xe[A]) {
                    var ke = `
` + Z[C].replace(
                      " at new ",
                      " at "
                    );
                    return n.displayName && ke.includes("<anonymous>") && (ke = ke.replace("<anonymous>", n.displayName)), typeof n == "function" && $2.set(n, ke), ke;
                  }
                while (1 <= C && 0 <= A);
              break;
            }
        }
      } finally {
        zg = !1, Xe.H = h, ne(), Error.prepareStackTrace = s;
      }
      return Z = (Z = n ? n.displayName || n.name : "") ? oe(Z) : "", typeof n == "function" && $2.set(n, Z), Z;
    }
    function be(n, o) {
      switch (n.tag) {
        case 26:
        case 27:
        case 5:
          return oe(n.type);
        case 16:
          return oe("Lazy");
        case 13:
          return n.child !== o && o !== null ? oe("Suspense Fallback") : oe("Suspense");
        case 19:
          return oe("SuspenseList");
        case 0:
        case 15:
          return fe(n.type, !1);
        case 11:
          return fe(n.type.render, !1);
        case 1:
          return fe(n.type, !0);
        case 31:
          return oe("Activity");
        default:
          return "";
      }
    }
    function me(n) {
      try {
        var o = "", s = null;
        do {
          o += be(n, s);
          var h = n._debugInfo;
          if (h)
            for (var y = h.length - 1; 0 <= y; y--) {
              var C = h[y];
              if (typeof C.name == "string") {
                var A = o;
                e: {
                  var z = C.name, q = C.env, Z = C.debugLocation;
                  if (Z != null) {
                    var xe = ae(Z), ke = xe.lastIndexOf(`
`), de = ke === -1 ? xe : xe.slice(ke + 1);
                    if (de.indexOf(z) !== -1) {
                      var Ve = `
` + de;
                      break e;
                    }
                  }
                  Ve = oe(
                    z + (q ? " [" + q + "]" : "")
                  );
                }
                o = A + Ve;
              }
            }
          s = n, n = n.return;
        } while (n);
        return o;
      } catch (yt) {
        return `
Error generating stack: ` + yt.message + `
` + yt.stack;
      }
    }
    function De(n) {
      return (n = n ? n.displayName || n.name : "") ? oe(n) : "";
    }
    function Me() {
      if (oi === null) return null;
      var n = oi._debugOwner;
      return n != null ? _(n) : null;
    }
    function ze() {
      if (oi === null) return "";
      var n = oi;
      try {
        var o = "";
        switch (n.tag === 6 && (n = n.return), n.tag) {
          case 26:
          case 27:
          case 5:
            o += oe(n.type);
            break;
          case 13:
            o += oe("Suspense");
            break;
          case 19:
            o += oe("SuspenseList");
            break;
          case 31:
            o += oe("Activity");
            break;
          case 30:
          case 0:
          case 15:
          case 1:
            n._debugOwner || o !== "" || (o += De(
              n.type
            ));
            break;
          case 11:
            n._debugOwner || o !== "" || (o += De(
              n.type.render
            ));
        }
        for (; n; )
          if (typeof n.tag == "number") {
            var s = n;
            n = s._debugOwner;
            var h = s._debugStack;
            if (n && h) {
              var y = ae(h);
              y !== "" && (o += `
` + y);
            }
          } else if (n.debugStack != null) {
            var C = n.debugStack;
            (n = n.owner) && C && (o += `
` + ae(C));
          } else break;
        var A = o;
      } catch (z) {
        A = `
Error generating stack: ` + z.message + `
` + z.stack;
      }
      return A;
    }
    function le(n, o, s, h, y, C, A) {
      var z = oi;
      se(n);
      try {
        return n !== null && n._debugTask ? n._debugTask.run(
          o.bind(null, s, h, y, C, A)
        ) : o(s, h, y, C, A);
      } finally {
        se(z);
      }
      throw Error(
        "runWithFiberInDEV should never be called in production. This is a bug in React."
      );
    }
    function se(n) {
      Xe.getCurrentStack = n === null ? null : ze, ds = !1, oi = n;
    }
    function Ae(n) {
      return typeof Symbol == "function" && Symbol.toStringTag && n[Symbol.toStringTag] || n.constructor.name || "Object";
    }
    function we(n) {
      try {
        return Ne(n), !1;
      } catch {
        return !0;
      }
    }
    function Ne(n) {
      return "" + n;
    }
    function pe(n, o) {
      if (we(n))
        return console.error(
          "The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before using it here.",
          o,
          Ae(n)
        ), Ne(n);
    }
    function Qe(n, o) {
      if (we(n))
        return console.error(
          "The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before using it here.",
          o,
          Ae(n)
        ), Ne(n);
    }
    function Le(n) {
      if (we(n))
        return console.error(
          "Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before using it here.",
          Ae(n)
        ), Ne(n);
    }
    function Te(n) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u") return !1;
      var o = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (o.isDisabled) return !0;
      if (!o.supportsFiber)
        return console.error(
          "The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://react.dev/link/react-devtools"
        ), !0;
      try {
        Vc = o.inject(n), Ia = o;
      } catch (s) {
        console.error("React instrumentation encountered an error: %o.", s);
      }
      return !!o.checkDCE;
    }
    function Oe(n) {
      if (typeof I2 == "function" && Vy(n), Ia && typeof Ia.setStrictMode == "function")
        try {
          Ia.setStrictMode(Vc, n);
        } catch (o) {
          fs || (fs = !0, console.error(
            "React instrumentation encountered an error: %o",
            o
          ));
        }
    }
    function ye(n) {
      return n >>>= 0, n === 0 ? 32 : 31 - (L2(n) / Wg | 0) | 0;
    }
    function je(n) {
      var o = n & 42;
      if (o !== 0) return o;
      switch (n & -n) {
        case 1:
          return 1;
        case 2:
          return 2;
        case 4:
          return 4;
        case 8:
          return 8;
        case 16:
          return 16;
        case 32:
          return 32;
        case 64:
          return 64;
        case 128:
          return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
          return n & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return n & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
          return n & 62914560;
        case 67108864:
          return 67108864;
        case 134217728:
          return 134217728;
        case 268435456:
          return 268435456;
        case 536870912:
          return 536870912;
        case 1073741824:
          return 0;
        default:
          return console.error(
            "Should have found matching lanes. This is a bug in React."
          ), n;
      }
    }
    function Ue(n, o, s) {
      var h = n.pendingLanes;
      if (h === 0) return 0;
      var y = 0, C = n.suspendedLanes, A = n.pingedLanes;
      n = n.warmLanes;
      var z = h & 134217727;
      return z !== 0 ? (h = z & ~C, h !== 0 ? y = je(h) : (A &= z, A !== 0 ? y = je(A) : s || (s = z & ~n, s !== 0 && (y = je(s))))) : (z = h & ~C, z !== 0 ? y = je(z) : A !== 0 ? y = je(A) : s || (s = h & ~n, s !== 0 && (y = je(s)))), y === 0 ? 0 : o !== 0 && o !== y && (o & C) === 0 && (C = y & -y, s = o & -o, C >= s || C === 32 && (s & 4194048) !== 0) ? o : y;
    }
    function Fe(n, o) {
      return (n.pendingLanes & ~(n.suspendedLanes & ~n.pingedLanes) & o) === 0;
    }
    function tt(n, o) {
      switch (n) {
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
          return o + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return o + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
          return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
          return -1;
        default:
          return console.error(
            "Should have found matching lanes. This is a bug in React."
          ), -1;
      }
    }
    function dt() {
      var n = hf;
      return hf <<= 1, (hf & 62914560) === 0 && (hf = 4194304), n;
    }
    function St(n) {
      for (var o = [], s = 0; 31 > s; s++) o.push(n);
      return o;
    }
    function mt(n, o) {
      n.pendingLanes |= o, o !== 268435456 && (n.suspendedLanes = 0, n.pingedLanes = 0, n.warmLanes = 0);
    }
    function Ot(n, o, s, h, y, C) {
      var A = n.pendingLanes;
      n.pendingLanes = s, n.suspendedLanes = 0, n.pingedLanes = 0, n.warmLanes = 0, n.expiredLanes &= s, n.entangledLanes &= s, n.errorRecoveryDisabledLanes &= s, n.shellSuspendCounter = 0;
      var z = n.entanglements, q = n.expirationTimes, Z = n.hiddenUpdates;
      for (s = A & ~s; 0 < s; ) {
        var xe = 31 - fo(s), ke = 1 << xe;
        z[xe] = 0, q[xe] = -1;
        var de = Z[xe];
        if (de !== null)
          for (Z[xe] = null, xe = 0; xe < de.length; xe++) {
            var Ve = de[xe];
            Ve !== null && (Ve.lane &= -536870913);
          }
        s &= ~ke;
      }
      h !== 0 && Rt(n, h, 0), C !== 0 && y === 0 && n.tag !== 0 && (n.suspendedLanes |= C & ~(A & ~o));
    }
    function Rt(n, o, s) {
      n.pendingLanes |= o, n.suspendedLanes &= ~o;
      var h = 31 - fo(o);
      n.entangledLanes |= o, n.entanglements[h] = n.entanglements[h] | 1073741824 | s & 261930;
    }
    function ct(n, o) {
      var s = n.entangledLanes |= o;
      for (n = n.entanglements; s; ) {
        var h = 31 - fo(s), y = 1 << h;
        y & o | n[h] & o && (n[h] |= o), s &= ~y;
      }
    }
    function it(n, o) {
      var s = o & -o;
      return s = (s & 42) !== 0 ? 1 : Ct(s), (s & (n.suspendedLanes | o)) !== 0 ? 0 : s;
    }
    function Ct(n) {
      switch (n) {
        case 2:
          n = 1;
          break;
        case 8:
          n = 4;
          break;
        case 32:
          n = 16;
          break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
          n = 128;
          break;
        case 268435456:
          n = 134217728;
          break;
        default:
          n = 0;
      }
      return n;
    }
    function ut(n, o, s) {
      if (ms)
        for (n = n.pendingUpdatersLaneMap; 0 < s; ) {
          var h = 31 - fo(s), y = 1 << h;
          n[h].add(o), s &= ~y;
        }
    }
    function ht(n, o) {
      if (ms)
        for (var s = n.pendingUpdatersLaneMap, h = n.memoizedUpdaters; 0 < o; ) {
          var y = 31 - fo(o);
          n = 1 << y, y = s[y], 0 < y.size && (y.forEach(function(C) {
            var A = C.alternate;
            A !== null && h.has(A) || h.add(C);
          }), y.clear()), o &= ~n;
        }
    }
    function ot(n) {
      return n &= -n, La < n ? mo < n ? (n & 134217727) !== 0 ? Po : Wu : mo : La;
    }
    function at() {
      var n = fr.p;
      return n !== 0 ? n : (n = window.event, n === void 0 ? Po : Tg(n.type));
    }
    function ft(n, o) {
      var s = fr.p;
      try {
        return fr.p = n, o();
      } finally {
        fr.p = s;
      }
    }
    function st(n) {
      delete n[Xr], delete n[qo], delete n[_c], delete n[xC], delete n[_y];
    }
    function pt(n) {
      var o = n[Xr];
      if (o) return o;
      for (var s = n.parentNode; s; ) {
        if (o = s[Ys] || s[Xr]) {
          if (s = o.alternate, o.child !== null || s !== null && s.child !== null)
            for (n = zc(n); n !== null; ) {
              if (s = n[Xr])
                return s;
              n = zc(n);
            }
          return o;
        }
        n = s, s = n.parentNode;
      }
      return null;
    }
    function bt(n) {
      if (n = n[Xr] || n[Ys]) {
        var o = n.tag;
        if (o === 5 || o === 6 || o === 13 || o === 31 || o === 26 || o === 27 || o === 3)
          return n;
      }
      return null;
    }
    function Nt(n) {
      var o = n.tag;
      if (o === 5 || o === 26 || o === 27 || o === 6)
        return n.stateNode;
      throw Error("getNodeFromInstance: Invalid argument.");
    }
    function $t(n) {
      var o = n[ph];
      return o || (o = n[ph] = { hoistableStyles: /* @__PURE__ */ new Map(), hoistableScripts: /* @__PURE__ */ new Map() }), o;
    }
    function Pt(n) {
      n[pf] = !0;
    }
    function hn(n, o) {
      an(n, o), an(n + "Capture", o);
    }
    function an(n, o) {
      hs[n] && console.error(
        "EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.",
        n
      ), hs[n] = o;
      var s = n.toLowerCase();
      for (gf[s] = n, n === "onDoubleClick" && (gf.ondblclick = n), n = 0; n < o.length; n++)
        By.add(o[n]);
    }
    function jn(n, o) {
      Uy[o.type] || o.onChange || o.onInput || o.readOnly || o.disabled || o.value == null || console.error(
        n === "select" ? "You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set `onChange`." : "You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."
      ), o.onChange || o.readOnly || o.disabled || o.checked == null || console.error(
        "You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`."
      );
    }
    function xn(n) {
      return Ti.call(Vg, n) ? !0 : Ti.call(H2, n) ? !1 : vf.test(n) ? Vg[n] = !0 : (H2[n] = !0, console.error("Invalid attribute name: `%s`", n), !1);
    }
    function Ut(n, o, s) {
      if (xn(o)) {
        if (!n.hasAttribute(o)) {
          switch (typeof s) {
            case "symbol":
            case "object":
              return s;
            case "function":
              return s;
            case "boolean":
              if (s === !1) return s;
          }
          return s === void 0 ? void 0 : null;
        }
        return n = n.getAttribute(o), n === "" && s === !0 ? !0 : (pe(s, o), n === "" + s ? s : n);
      }
    }
    function pn(n, o, s) {
      if (xn(o))
        if (s === null) n.removeAttribute(o);
        else {
          switch (typeof s) {
            case "undefined":
            case "function":
            case "symbol":
              n.removeAttribute(o);
              return;
            case "boolean":
              var h = o.toLowerCase().slice(0, 5);
              if (h !== "data-" && h !== "aria-") {
                n.removeAttribute(o);
                return;
              }
          }
          pe(s, o), n.setAttribute(o, "" + s);
        }
    }
    function wn(n, o, s) {
      if (s === null) n.removeAttribute(o);
      else {
        switch (typeof s) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            n.removeAttribute(o);
            return;
        }
        pe(s, o), n.setAttribute(o, "" + s);
      }
    }
    function Lt(n, o, s, h) {
      if (h === null) n.removeAttribute(s);
      else {
        switch (typeof h) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            n.removeAttribute(s);
            return;
        }
        pe(h, s), n.setAttributeNS(o, s, "" + h);
      }
    }
    function gt(n) {
      switch (typeof n) {
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return n;
        case "object":
          return Le(n), n;
        default:
          return "";
      }
    }
    function wt(n) {
      var o = n.type;
      return (n = n.nodeName) && n.toLowerCase() === "input" && (o === "checkbox" || o === "radio");
    }
    function Ft(n, o, s) {
      var h = Object.getOwnPropertyDescriptor(
        n.constructor.prototype,
        o
      );
      if (!n.hasOwnProperty(o) && typeof h < "u" && typeof h.get == "function" && typeof h.set == "function") {
        var y = h.get, C = h.set;
        return Object.defineProperty(n, o, {
          configurable: !0,
          get: function() {
            return y.call(this);
          },
          set: function(A) {
            Le(A), s = "" + A, C.call(this, A);
          }
        }), Object.defineProperty(n, o, {
          enumerable: h.enumerable
        }), {
          getValue: function() {
            return s;
          },
          setValue: function(A) {
            Le(A), s = "" + A;
          },
          stopTracking: function() {
            n._valueTracker = null, delete n[o];
          }
        };
      }
    }
    function yn(n) {
      if (!n._valueTracker) {
        var o = wt(n) ? "checked" : "value";
        n._valueTracker = Ft(
          n,
          o,
          "" + n[o]
        );
      }
    }
    function gn(n) {
      if (!n) return !1;
      var o = n._valueTracker;
      if (!o) return !0;
      var s = o.getValue(), h = "";
      return n && (h = wt(n) ? n.checked ? "true" : "false" : n.value), n = h, n !== s ? (o.setValue(n), !0) : !1;
    }
    function Tn(n) {
      if (n = n || (typeof document < "u" ? document : void 0), typeof n > "u") return null;
      try {
        return n.activeElement || n.body;
      } catch {
        return n.body;
      }
    }
    function Gt(n) {
      return n.replace(
        _g,
        function(o) {
          return "\\" + o.charCodeAt(0).toString(16) + " ";
        }
      );
    }
    function Dt(n, o) {
      o.checked === void 0 || o.defaultChecked === void 0 || Xy || (console.error(
        "%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components",
        Me() || "A component",
        o.type
      ), Xy = !0), o.value === void 0 || o.defaultValue === void 0 || F2 || (console.error(
        "%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components",
        Me() || "A component",
        o.type
      ), F2 = !0);
    }
    function Yt(n, o, s, h, y, C, A, z) {
      n.name = "", A != null && typeof A != "function" && typeof A != "symbol" && typeof A != "boolean" ? (pe(A, "type"), n.type = A) : n.removeAttribute("type"), o != null ? A === "number" ? (o === 0 && n.value === "" || n.value != o) && (n.value = "" + gt(o)) : n.value !== "" + gt(o) && (n.value = "" + gt(o)) : A !== "submit" && A !== "reset" || n.removeAttribute("value"), o != null ? Gn(n, A, gt(o)) : s != null ? Gn(n, A, gt(s)) : h != null && n.removeAttribute("value"), y == null && C != null && (n.defaultChecked = !!C), y != null && (n.checked = y && typeof y != "function" && typeof y != "symbol"), z != null && typeof z != "function" && typeof z != "symbol" && typeof z != "boolean" ? (pe(z, "name"), n.name = "" + gt(z)) : n.removeAttribute("name");
    }
    function Mn(n, o, s, h, y, C, A, z) {
      if (C != null && typeof C != "function" && typeof C != "symbol" && typeof C != "boolean" && (pe(C, "type"), n.type = C), o != null || s != null) {
        if (!(C !== "submit" && C !== "reset" || o != null)) {
          yn(n);
          return;
        }
        s = s != null ? "" + gt(s) : "", o = o != null ? "" + gt(o) : s, z || o === n.value || (n.value = o), n.defaultValue = o;
      }
      h = h ?? y, h = typeof h != "function" && typeof h != "symbol" && !!h, n.checked = z ? n.checked : !!h, n.defaultChecked = !!h, A != null && typeof A != "function" && typeof A != "symbol" && typeof A != "boolean" && (pe(A, "name"), n.name = A), yn(n);
    }
    function Gn(n, o, s) {
      o === "number" && Tn(n.ownerDocument) === n || n.defaultValue === "" + s || (n.defaultValue = "" + s);
    }
    function wr(n, o) {
      o.value == null && (typeof o.children == "object" && o.children !== null ? uh.Children.forEach(o.children, function(s) {
        s == null || typeof s == "string" || typeof s == "number" || typeof s == "bigint" || l || (l = !0, console.error(
          "Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>."
        ));
      }) : o.dangerouslySetInnerHTML == null || u || (u = !0, console.error(
        "Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected."
      ))), o.selected == null || gh || (console.error(
        "Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."
      ), gh = !0);
    }
    function aa() {
      var n = Me();
      return n ? `

Check the render method of \`` + n + "`." : "";
    }
    function qn(n, o, s, h) {
      if (n = n.options, o) {
        o = {};
        for (var y = 0; y < s.length; y++)
          o["$" + s[y]] = !0;
        for (s = 0; s < n.length; s++)
          y = o.hasOwnProperty("$" + n[s].value), n[s].selected !== y && (n[s].selected = y), y && h && (n[s].defaultSelected = !0);
      } else {
        for (s = "" + gt(s), o = null, y = 0; y < n.length; y++) {
          if (n[y].value === s) {
            n[y].selected = !0, h && (n[y].defaultSelected = !0);
            return;
          }
          o !== null || n[y].disabled || (o = n[y]);
        }
        o !== null && (o.selected = !0);
      }
    }
    function Rr(n, o) {
      for (n = 0; n < v.length; n++) {
        var s = v[n];
        if (o[s] != null) {
          var h = Ta(o[s]);
          o.multiple && !h ? console.error(
            "The `%s` prop supplied to <select> must be an array if `multiple` is true.%s",
            s,
            aa()
          ) : !o.multiple && h && console.error(
            "The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s",
            s,
            aa()
          );
        }
      }
      o.value === void 0 || o.defaultValue === void 0 || m || (console.error(
        "Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://react.dev/link/controlled-components"
      ), m = !0);
    }
    function Wt(n, o) {
      o.value === void 0 || o.defaultValue === void 0 || O || (console.error(
        "%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://react.dev/link/controlled-components",
        Me() || "A component"
      ), O = !0), o.children != null && o.value == null && console.error(
        "Use the `defaultValue` or `value` props instead of setting children on <textarea>."
      );
    }
    function en(n, o, s) {
      if (o != null && (o = "" + gt(o), o !== n.value && (n.value = o), s == null)) {
        n.defaultValue !== o && (n.defaultValue = o);
        return;
      }
      n.defaultValue = s != null ? "" + gt(s) : "";
    }
    function Xt(n, o, s, h) {
      if (o == null) {
        if (h != null) {
          if (s != null)
            throw Error(
              "If you supply `defaultValue` on a <textarea>, do not pass children."
            );
          if (Ta(h)) {
            if (1 < h.length)
              throw Error("<textarea> can only have at most one child.");
            h = h[0];
          }
          s = h;
        }
        s == null && (s = ""), o = s;
      }
      s = gt(o), n.defaultValue = s, h = n.textContent, h === s && h !== "" && h !== null && (n.value = h), yn(n);
    }
    function zt(n, o) {
      return n.serverProps === void 0 && n.serverTail.length === 0 && n.children.length === 1 && 3 < n.distanceFromLeaf && n.distanceFromLeaf > 15 - o ? zt(n.children[0], o) : n;
    }
    function kt(n) {
      return "  " + "  ".repeat(n);
    }
    function Qn(n) {
      return "+ " + "  ".repeat(n);
    }
    function Jn(n) {
      return "- " + "  ".repeat(n);
    }
    function Nr(n) {
      switch (n.tag) {
        case 26:
        case 27:
        case 5:
          return n.type;
        case 16:
          return "Lazy";
        case 31:
          return "Activity";
        case 13:
          return "Suspense";
        case 19:
          return "SuspenseList";
        case 0:
        case 15:
          return n = n.type, n.displayName || n.name || null;
        case 11:
          return n = n.type.render, n.displayName || n.name || null;
        case 1:
          return n = n.type, n.displayName || n.name || null;
        default:
          return null;
      }
    }
    function Hr(n, o) {
      return R.test(n) ? (n = JSON.stringify(n), n.length > o - 2 ? 8 > o ? '{"..."}' : "{" + n.slice(0, o - 7) + '..."}' : "{" + n + "}") : n.length > o ? 5 > o ? '{"..."}' : n.slice(0, o - 3) + "..." : n;
    }
    function oa(n, o, s) {
      var h = 120 - 2 * s;
      if (o === null)
        return Qn(s) + Hr(n, h) + `
`;
      if (typeof o == "string") {
        for (var y = 0; y < o.length && y < n.length && o.charCodeAt(y) === n.charCodeAt(y); y++) ;
        return y > h - 8 && 10 < y && (n = "..." + n.slice(y - 8), o = "..." + o.slice(y - 8)), Qn(s) + Hr(n, h) + `
` + Jn(s) + Hr(o, h) + `
`;
      }
      return kt(s) + Hr(n, h) + `
`;
    }
    function dn(n) {
      return Object.prototype.toString.call(n).replace(/^\[object (.*)\]$/, function(o, s) {
        return s;
      });
    }
    function Un(n, o) {
      switch (typeof n) {
        case "string":
          return n = JSON.stringify(n), n.length > o ? 5 > o ? '"..."' : n.slice(0, o - 4) + '..."' : n;
        case "object":
          if (n === null) return "null";
          if (Ta(n)) return "[...]";
          if (n.$$typeof === nl)
            return (o = F(n.type)) ? "<" + o + ">" : "<...>";
          var s = dn(n);
          if (s === "Object") {
            s = "", o -= 2;
            for (var h in n)
              if (n.hasOwnProperty(h)) {
                var y = JSON.stringify(h);
                if (y !== '"' + h + '"' && (h = y), o -= h.length - 2, y = Un(
                  n[h],
                  15 > o ? o : 15
                ), o -= y.length, 0 > o) {
                  s += s === "" ? "..." : ", ...";
                  break;
                }
                s += (s === "" ? "" : ",") + h + ":" + y;
              }
            return "{" + s + "}";
          }
          return s;
        case "function":
          return (o = n.displayName || n.name) ? "function " + o : "function";
        default:
          return String(n);
      }
    }
    function sr(n, o) {
      return typeof n != "string" || R.test(n) ? "{" + Un(n, o - 2) + "}" : n.length > o - 2 ? 5 > o ? '"..."' : '"' + n.slice(0, o - 5) + '..."' : '"' + n + '"';
    }
    function Yr(n, o, s) {
      var h = 120 - s.length - n.length, y = [], C;
      for (C in o)
        if (o.hasOwnProperty(C) && C !== "children") {
          var A = sr(
            o[C],
            120 - s.length - C.length - 1
          );
          h -= C.length + A.length + 2, y.push(C + "=" + A);
        }
      return y.length === 0 ? s + "<" + n + `>
` : 0 < h ? s + "<" + n + " " + y.join(" ") + `>
` : s + "<" + n + `
` + s + "  " + y.join(`
` + s + "  ") + `
` + s + `>
`;
    }
    function Wa(n, o, s) {
      var h = "", y = Rn({}, o), C;
      for (C in n)
        if (n.hasOwnProperty(C)) {
          delete y[C];
          var A = 120 - 2 * s - C.length - 2, z = Un(n[C], A);
          o.hasOwnProperty(C) ? (A = Un(o[C], A), h += Qn(s) + C + ": " + z + `
`, h += Jn(s) + C + ": " + A + `
`) : h += Qn(s) + C + ": " + z + `
`;
        }
      for (var q in y)
        y.hasOwnProperty(q) && (n = Un(
          y[q],
          120 - 2 * s - q.length - 2
        ), h += Jn(s) + q + ": " + n + `
`);
      return h;
    }
    function pa(n, o, s, h) {
      var y = "", C = /* @__PURE__ */ new Map();
      for (Z in s)
        s.hasOwnProperty(Z) && C.set(
          Z.toLowerCase(),
          Z
        );
      if (C.size === 1 && C.has("children"))
        y += Yr(
          n,
          o,
          kt(h)
        );
      else {
        for (var A in o)
          if (o.hasOwnProperty(A) && A !== "children") {
            var z = 120 - 2 * (h + 1) - A.length - 1, q = C.get(A.toLowerCase());
            if (q !== void 0) {
              C.delete(A.toLowerCase());
              var Z = o[A];
              q = s[q];
              var xe = sr(
                Z,
                z
              );
              z = sr(
                q,
                z
              ), typeof Z == "object" && Z !== null && typeof q == "object" && q !== null && dn(Z) === "Object" && dn(q) === "Object" && (2 < Object.keys(Z).length || 2 < Object.keys(q).length || -1 < xe.indexOf("...") || -1 < z.indexOf("...")) ? y += kt(h + 1) + A + `={{
` + Wa(
                Z,
                q,
                h + 2
              ) + kt(h + 1) + `}}
` : (y += Qn(h + 1) + A + "=" + xe + `
`, y += Jn(h + 1) + A + "=" + z + `
`);
            } else
              y += kt(h + 1) + A + "=" + sr(o[A], z) + `
`;
          }
        C.forEach(function(ke) {
          if (ke !== "children") {
            var de = 120 - 2 * (h + 1) - ke.length - 1;
            y += Jn(h + 1) + ke + "=" + sr(s[ke], de) + `
`;
          }
        }), y = y === "" ? kt(h) + "<" + n + `>
` : kt(h) + "<" + n + `
` + y + kt(h) + `>
`;
      }
      return n = s.children, o = o.children, typeof n == "string" || typeof n == "number" || typeof n == "bigint" ? (C = "", (typeof o == "string" || typeof o == "number" || typeof o == "bigint") && (C = "" + o), y += oa(C, "" + n, h + 1)) : (typeof o == "string" || typeof o == "number" || typeof o == "bigint") && (y = n == null ? y + oa("" + o, null, h + 1) : y + oa("" + o, void 0, h + 1)), y;
    }
    function Jr(n, o) {
      var s = Nr(n);
      if (s === null) {
        for (s = "", n = n.child; n; )
          s += Jr(n, o), n = n.sibling;
        return s;
      }
      return kt(o) + "<" + s + `>
`;
    }
    function si(n, o) {
      var s = zt(n, o);
      if (s !== n && (n.children.length !== 1 || n.children[0] !== s))
        return kt(o) + `...
` + si(s, o + 1);
      s = "";
      var h = n.fiber._debugInfo;
      if (h)
        for (var y = 0; y < h.length; y++) {
          var C = h[y].name;
          typeof C == "string" && (s += kt(o) + "<" + C + `>
`, o++);
        }
      if (h = "", y = n.fiber.pendingProps, n.fiber.tag === 6)
        h = oa(y, n.serverProps, o), o++;
      else if (C = Nr(n.fiber), C !== null)
        if (n.serverProps === void 0) {
          h = o;
          var A = 120 - 2 * h - C.length - 2, z = "";
          for (Z in y)
            if (y.hasOwnProperty(Z) && Z !== "children") {
              var q = sr(y[Z], 15);
              if (A -= Z.length + q.length + 2, 0 > A) {
                z += " ...";
                break;
              }
              z += " " + Z + "=" + q;
            }
          h = kt(h) + "<" + C + z + `>
`, o++;
        } else
          n.serverProps === null ? (h = Yr(
            C,
            y,
            Qn(o)
          ), o++) : typeof n.serverProps == "string" ? console.error(
            "Should not have matched a non HostText fiber to a Text node. This is a bug in React."
          ) : (h = pa(
            C,
            y,
            n.serverProps,
            o
          ), o++);
      var Z = "";
      for (y = n.fiber.child, C = 0; y && C < n.children.length; )
        A = n.children[C], A.fiber === y ? (Z += si(A, o), C++) : Z += Jr(y, o), y = y.sibling;
      for (y && 0 < n.children.length && (Z += kt(o) + `...
`), y = n.serverTail, n.serverProps === null && o--, n = 0; n < y.length; n++)
        C = y[n], Z = typeof C == "string" ? Z + (Jn(o) + Hr(C, 120 - 2 * o) + `
`) : Z + Yr(
          C.type,
          C.props,
          Jn(o)
        );
      return s + h + Z;
    }
    function mi(n) {
      try {
        return `

` + si(n, 0);
      } catch {
        return "";
      }
    }
    function Yo(n, o, s) {
      for (var h = o, y = null, C = 0; h; )
        h === n && (C = 0), y = {
          fiber: h,
          children: y !== null ? [y] : [],
          serverProps: h === o ? s : h === n ? null : void 0,
          serverTail: [],
          distanceFromLeaf: C
        }, C++, h = h.return;
      return y !== null ? mi(y).replaceAll(/^[+-]/gm, ">") : "";
    }
    function Bi(n, o) {
      var s = Rn({}, n || Je), h = { tag: o };
      return re.indexOf(o) !== -1 && (s.aTagInScope = null, s.buttonTagInScope = null, s.nobrTagInScope = null), ve.indexOf(o) !== -1 && (s.pTagInButtonScope = null), B.indexOf(o) !== -1 && o !== "address" && o !== "div" && o !== "p" && (s.listItemTagAutoclosing = null, s.dlItemTagAutoclosing = null), s.current = h, o === "form" && (s.formTag = h), o === "a" && (s.aTagInScope = h), o === "button" && (s.buttonTagInScope = h), o === "nobr" && (s.nobrTagInScope = h), o === "p" && (s.pTagInButtonScope = h), o === "li" && (s.listItemTagAutoclosing = h), (o === "dd" || o === "dt") && (s.dlItemTagAutoclosing = h), o === "#document" || o === "html" ? s.containerTagInScope = null : s.containerTagInScope || (s.containerTagInScope = h), n !== null || o !== "#document" && o !== "html" && o !== "body" ? s.implicitRootScope === !0 && (s.implicitRootScope = !1) : s.implicitRootScope = !0, s;
    }
    function hr(n, o, s) {
      switch (o) {
        case "select":
          return n === "hr" || n === "option" || n === "optgroup" || n === "script" || n === "template" || n === "#text";
        case "optgroup":
          return n === "option" || n === "#text";
        case "option":
          return n === "#text";
        case "tr":
          return n === "th" || n === "td" || n === "style" || n === "script" || n === "template";
        case "tbody":
        case "thead":
        case "tfoot":
          return n === "tr" || n === "style" || n === "script" || n === "template";
        case "colgroup":
          return n === "col" || n === "template";
        case "table":
          return n === "caption" || n === "colgroup" || n === "tbody" || n === "tfoot" || n === "thead" || n === "style" || n === "script" || n === "template";
        case "head":
          return n === "base" || n === "basefont" || n === "bgsound" || n === "link" || n === "meta" || n === "title" || n === "noscript" || n === "noframes" || n === "style" || n === "script" || n === "template";
        case "html":
          if (s) break;
          return n === "head" || n === "body" || n === "frameset";
        case "frameset":
          return n === "frame";
        case "#document":
          if (!s) return n === "html";
      }
      switch (n) {
        case "h1":
        case "h2":
        case "h3":
        case "h4":
        case "h5":
        case "h6":
          return o !== "h1" && o !== "h2" && o !== "h3" && o !== "h4" && o !== "h5" && o !== "h6";
        case "rp":
        case "rt":
          return He.indexOf(o) === -1;
        case "caption":
        case "col":
        case "colgroup":
        case "frameset":
        case "frame":
        case "tbody":
        case "td":
        case "tfoot":
        case "th":
        case "thead":
        case "tr":
          return o == null;
        case "head":
          return s || o === null;
        case "html":
          return s && o === "#document" || o === null;
        case "body":
          return s && (o === "#document" || o === "html") || o === null;
      }
      return !0;
    }
    function zn(n, o) {
      switch (n) {
        case "address":
        case "article":
        case "aside":
        case "blockquote":
        case "center":
        case "details":
        case "dialog":
        case "dir":
        case "div":
        case "dl":
        case "fieldset":
        case "figcaption":
        case "figure":
        case "footer":
        case "header":
        case "hgroup":
        case "main":
        case "menu":
        case "nav":
        case "ol":
        case "p":
        case "section":
        case "summary":
        case "ul":
        case "pre":
        case "listing":
        case "table":
        case "hr":
        case "xmp":
        case "h1":
        case "h2":
        case "h3":
        case "h4":
        case "h5":
        case "h6":
          return o.pTagInButtonScope;
        case "form":
          return o.formTag || o.pTagInButtonScope;
        case "li":
          return o.listItemTagAutoclosing;
        case "dd":
        case "dt":
          return o.dlItemTagAutoclosing;
        case "button":
          return o.buttonTagInScope;
        case "a":
          return o.aTagInScope;
        case "nobr":
          return o.nobrTagInScope;
      }
      return null;
    }
    function On(n, o) {
      for (; n; ) {
        switch (n.tag) {
          case 5:
          case 26:
          case 27:
            if (n.type === o) return n;
        }
        n = n.return;
      }
      return null;
    }
    function Qt(n, o) {
      o = o || Je;
      var s = o.current;
      if (o = (s = hr(
        n,
        s && s.tag,
        o.implicitRootScope
      ) ? null : s) ? null : zn(n, o), o = s || o, !o) return !0;
      var h = o.tag;
      if (o = String(!!s) + "|" + n + "|" + h, nt[o]) return !1;
      nt[o] = !0;
      var y = (o = oi) ? On(o.return, h) : null, C = o !== null && y !== null ? Yo(y, o, null) : "", A = "<" + n + ">";
      return s ? (s = "", h === "table" && n === "tr" && (s += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), console.error(
        `In HTML, %s cannot be a child of <%s>.%s
This will cause a hydration error.%s`,
        A,
        h,
        s,
        C
      )) : console.error(
        `In HTML, %s cannot be a descendant of <%s>.
This will cause a hydration error.%s`,
        A,
        h,
        C
      ), o && (n = o.return, y === null || n === null || y === n && n._debugOwner === o._debugOwner || le(y, function() {
        console.error(
          `<%s> cannot contain a nested %s.
See this log for the ancestor stack trace.`,
          h,
          A
        );
      })), !1;
    }
    function nn(n, o, s) {
      if (s || hr("#text", o, !1))
        return !0;
      if (s = "#text|" + o, nt[s]) return !1;
      nt[s] = !0;
      var h = (s = oi) ? On(s, o) : null;
      return s = s !== null && h !== null ? Yo(
        h,
        s,
        s.tag !== 6 ? { children: null } : null
      ) : "", /\S/.test(n) ? console.error(
        `In HTML, text nodes cannot be a child of <%s>.
This will cause a hydration error.%s`,
        o,
        s
      ) : console.error(
        `In HTML, whitespace text nodes cannot be a child of <%s>. Make sure you don't have any extra whitespace between tags on each line of your source code.
This will cause a hydration error.%s`,
        o,
        s
      ), !1;
    }
    function er(n, o) {
      if (o) {
        var s = n.firstChild;
        if (s && s === n.lastChild && s.nodeType === 3) {
          s.nodeValue = o;
          return;
        }
      }
      n.textContent = o;
    }
    function ia(n) {
      return n.replace($e, function(o, s) {
        return s.toUpperCase();
      });
    }
    function so(n, o, s) {
      var h = o.indexOf("--") === 0;
      h || (-1 < o.indexOf("-") ? Ie.hasOwnProperty(o) && Ie[o] || (Ie[o] = !0, console.error(
        "Unsupported style property %s. Did you mean %s?",
        o,
        ia(o.replace(Or, "ms-"))
      )) : Zt.test(o) ? Ie.hasOwnProperty(o) && Ie[o] || (Ie[o] = !0, console.error(
        "Unsupported vendor-prefixed style property %s. Did you mean %s?",
        o,
        o.charAt(0).toUpperCase() + o.slice(1)
      )) : !Pe.test(s) || et.hasOwnProperty(s) && et[s] || (et[s] = !0, console.error(
        `Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`,
        o,
        s.replace(Pe, "")
      )), typeof s == "number" && (isNaN(s) ? Vt || (Vt = !0, console.error(
        "`NaN` is an invalid value for the `%s` css style property.",
        o
      )) : isFinite(s) || rr || (rr = !0, console.error(
        "`Infinity` is an invalid value for the `%s` css style property.",
        o
      )))), s == null || typeof s == "boolean" || s === "" ? h ? n.setProperty(o, "") : o === "float" ? n.cssFloat = "" : n[o] = "" : h ? n.setProperty(o, s) : typeof s != "number" || s === 0 || jt.has(o) ? o === "float" ? n.cssFloat = s : (Qe(s, o), n[o] = ("" + s).trim()) : n[o] = s + "px";
    }
    function hi(n, o, s) {
      if (o != null && typeof o != "object")
        throw Error(
          "The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX."
        );
      if (o && Object.freeze(o), n = n.style, s != null) {
        if (o) {
          var h = {};
          if (s) {
            for (var y in s)
              if (s.hasOwnProperty(y) && !o.hasOwnProperty(y))
                for (var C = We[y] || [y], A = 0; A < C.length; A++)
                  h[C[A]] = y;
          }
          for (var z in o)
            if (o.hasOwnProperty(z) && (!s || s[z] !== o[z]))
              for (y = We[z] || [z], C = 0; C < y.length; C++)
                h[y[C]] = z;
          z = {};
          for (var q in o)
            for (y = We[q] || [q], C = 0; C < y.length; C++)
              z[y[C]] = q;
          q = {};
          for (var Z in h)
            if (y = h[Z], (C = z[Z]) && y !== C && (A = y + "," + C, !q[A])) {
              q[A] = !0, A = console;
              var xe = o[y];
              A.error.call(
                A,
                "%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.",
                xe == null || typeof xe == "boolean" || xe === "" ? "Removing" : "Updating",
                y,
                C
              );
            }
        }
        for (var ke in s)
          !s.hasOwnProperty(ke) || o != null && o.hasOwnProperty(ke) || (ke.indexOf("--") === 0 ? n.setProperty(ke, "") : ke === "float" ? n.cssFloat = "" : n[ke] = "");
        for (var de in o)
          Z = o[de], o.hasOwnProperty(de) && s[de] !== Z && so(n, de, Z);
      } else
        for (h in o)
          o.hasOwnProperty(h) && so(n, h, o[h]);
    }
    function ka(n) {
      if (n.indexOf("-") === -1) return !1;
      switch (n) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    function Ui(n) {
      return lr.get(n) || n;
    }
    function sl(n, o) {
      if (Ti.call(Bg, o) && Bg[o])
        return !0;
      if (dO.test(o)) {
        if (n = "aria-" + o.slice(4).toLowerCase(), n = Gy.hasOwnProperty(n) ? n : null, n == null)
          return console.error(
            "Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.",
            o
          ), Bg[o] = !0;
        if (o !== n)
          return console.error(
            "Invalid ARIA attribute `%s`. Did you mean `%s`?",
            o,
            n
          ), Bg[o] = !0;
      }
      if (cO.test(o)) {
        if (n = o.toLowerCase(), n = Gy.hasOwnProperty(n) ? n : null, n == null) return Bg[o] = !0, !1;
        o !== n && (console.error(
          "Unknown ARIA attribute `%s`. Did you mean `%s`?",
          o,
          n
        ), Bg[o] = !0);
      }
      return !0;
    }
    function qt(n, o) {
      var s = [], h;
      for (h in o)
        sl(n, h) || s.push(h);
      o = s.map(function(y) {
        return "`" + y + "`";
      }).join(", "), s.length === 1 ? console.error(
        "Invalid aria prop %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props",
        o,
        n
      ) : 1 < s.length && console.error(
        "Invalid aria props %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props",
        o,
        n
      );
    }
    function Kt(n, o, s, h) {
      if (Ti.call(Ri, o) && Ri[o])
        return !0;
      var y = o.toLowerCase();
      if (y === "onfocusin" || y === "onfocusout")
        return console.error(
          "React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."
        ), Ri[o] = !0;
      if (typeof s == "function" && (n === "form" && o === "action" || n === "input" && o === "formAction" || n === "button" && o === "formAction"))
        return !0;
      if (h != null) {
        if (n = h.possibleRegistrationNames, h.registrationNameDependencies.hasOwnProperty(o))
          return !0;
        if (h = n.hasOwnProperty(y) ? n[y] : null, h != null)
          return console.error(
            "Invalid event handler property `%s`. Did you mean `%s`?",
            o,
            h
          ), Ri[o] = !0;
        if (p6.test(o))
          return console.error(
            "Unknown event handler property `%s`. It will be ignored.",
            o
          ), Ri[o] = !0;
      } else if (p6.test(o))
        return fO.test(o) && console.error(
          "Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.",
          o
        ), Ri[o] = !0;
      if (mO.test(o) || hO.test(o)) return !0;
      if (y === "innerhtml")
        return console.error(
          "Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."
        ), Ri[o] = !0;
      if (y === "aria")
        return console.error(
          "The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."
        ), Ri[o] = !0;
      if (y === "is" && s !== null && s !== void 0 && typeof s != "string")
        return console.error(
          "Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.",
          typeof s
        ), Ri[o] = !0;
      if (typeof s == "number" && isNaN(s))
        return console.error(
          "Received NaN for the `%s` attribute. If this is expected, cast the value to a string.",
          o
        ), Ri[o] = !0;
      if ($l.hasOwnProperty(y)) {
        if (y = $l[y], y !== o)
          return console.error(
            "Invalid DOM property `%s`. Did you mean `%s`?",
            o,
            y
          ), Ri[o] = !0;
      } else if (o !== y)
        return console.error(
          "React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.",
          o,
          y
        ), Ri[o] = !0;
      switch (o) {
        case "dangerouslySetInnerHTML":
        case "children":
        case "style":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
          return !0;
        case "innerText":
        case "textContent":
          return !0;
      }
      switch (typeof s) {
        case "boolean":
          switch (o) {
            case "autoFocus":
            case "checked":
            case "multiple":
            case "muted":
            case "selected":
            case "contentEditable":
            case "spellCheck":
            case "draggable":
            case "value":
            case "autoReverse":
            case "externalResourcesRequired":
            case "focusable":
            case "preserveAlpha":
            case "allowFullScreen":
            case "async":
            case "autoPlay":
            case "controls":
            case "default":
            case "defer":
            case "disabled":
            case "disablePictureInPicture":
            case "disableRemotePlayback":
            case "formNoValidate":
            case "hidden":
            case "loop":
            case "noModule":
            case "noValidate":
            case "open":
            case "playsInline":
            case "readOnly":
            case "required":
            case "reversed":
            case "scoped":
            case "seamless":
            case "itemScope":
            case "capture":
            case "download":
            case "inert":
              return !0;
            default:
              return y = o.toLowerCase().slice(0, 5), y === "data-" || y === "aria-" ? !0 : (s ? console.error(
                'Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.',
                s,
                o,
                o,
                s,
                o
              ) : console.error(
                'Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.',
                s,
                o,
                o,
                s,
                o,
                o,
                o
              ), Ri[o] = !0);
          }
        case "function":
        case "symbol":
          return Ri[o] = !0, !1;
        case "string":
          if (s === "false" || s === "true") {
            switch (o) {
              case "checked":
              case "selected":
              case "multiple":
              case "muted":
              case "allowFullScreen":
              case "async":
              case "autoPlay":
              case "controls":
              case "default":
              case "defer":
              case "disabled":
              case "disablePictureInPicture":
              case "disableRemotePlayback":
              case "formNoValidate":
              case "hidden":
              case "loop":
              case "noModule":
              case "noValidate":
              case "open":
              case "playsInline":
              case "readOnly":
              case "required":
              case "reversed":
              case "scoped":
              case "seamless":
              case "itemScope":
              case "inert":
                break;
              default:
                return !0;
            }
            console.error(
              "Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?",
              s,
              o,
              s === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".',
              o,
              s
            ), Ri[o] = !0;
          }
      }
      return !0;
    }
    function ur(n, o, s) {
      var h = [], y;
      for (y in o)
        Kt(n, y, o[y], s) || h.push(y);
      o = h.map(function(C) {
        return "`" + C + "`";
      }).join(", "), h.length === 1 ? console.error(
        "Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://react.dev/link/attribute-behavior ",
        o,
        n
      ) : 1 < h.length && console.error(
        "Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://react.dev/link/attribute-behavior ",
        o,
        n
      );
    }
    function pr(n) {
      return pO.test("" + n) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : n;
    }
    function tr() {
    }
    function Va(n) {
      return n = n.target || n.srcElement || window, n.correspondingUseElement && (n = n.correspondingUseElement), n.nodeType === 3 ? n.parentNode : n;
    }
    function pi(n) {
      var o = bt(n);
      if (o && (n = o.stateNode)) {
        var s = n[qo] || null;
        e: switch (n = o.stateNode, o.type) {
          case "input":
            if (Yt(
              n,
              s.value,
              s.defaultValue,
              s.defaultValue,
              s.checked,
              s.defaultChecked,
              s.type,
              s.name
            ), o = s.name, s.type === "radio" && o != null) {
              for (s = n; s.parentNode; ) s = s.parentNode;
              for (pe(o, "name"), s = s.querySelectorAll(
                'input[name="' + Gt(
                  "" + o
                ) + '"][type="radio"]'
              ), o = 0; o < s.length; o++) {
                var h = s[o];
                if (h !== n && h.form === n.form) {
                  var y = h[qo] || null;
                  if (!y)
                    throw Error(
                      "ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported."
                    );
                  Yt(
                    h,
                    y.value,
                    y.defaultValue,
                    y.defaultValue,
                    y.checked,
                    y.defaultChecked,
                    y.type,
                    y.name
                  );
                }
              }
              for (o = 0; o < s.length; o++)
                h = s[o], h.form === n.form && gn(h);
            }
            break e;
          case "textarea":
            en(n, s.value, s.defaultValue);
            break e;
          case "select":
            o = s.value, o != null && qn(n, !!s.multiple, o, !1);
        }
      }
    }
    function Li(n, o, s) {
      if (EC) return n(o, s);
      EC = !0;
      try {
        var h = n(o);
        return h;
      } finally {
        if (EC = !1, (Ug !== null || Xg !== null) && (ki(), Ug && (o = Ug, n = Xg, Xg = Ug = null, pi(o), n)))
          for (o = 0; o < n.length; o++) pi(n[o]);
      }
    }
    function yo(n, o) {
      var s = n.stateNode;
      if (s === null) return null;
      var h = s[qo] || null;
      if (h === null) return null;
      s = h[o];
      e: switch (o) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          (h = !h.disabled) || (n = n.type, h = !(n === "button" || n === "input" || n === "select" || n === "textarea")), n = !h;
          break e;
        default:
          n = !1;
      }
      if (n) return null;
      if (s && typeof s != "function")
        throw Error(
          "Expected `" + o + "` listener to be a function, instead got a value of `" + typeof s + "` type."
        );
      return s;
    }
    function ul() {
      if (qy) return qy;
      var n, o = kC, s = o.length, h, y = "value" in bf ? bf.value : bf.textContent, C = y.length;
      for (n = 0; n < s && o[n] === y[n]; n++) ;
      var A = s - n;
      for (h = 1; h <= A && o[s - h] === y[C - h]; h++) ;
      return qy = y.slice(n, 1 < h ? 1 - h : void 0);
    }
    function rc(n) {
      var o = n.keyCode;
      return "charCode" in n ? (n = n.charCode, n === 0 && o === 13 && (n = 13)) : n = o, n === 10 && (n = 13), 32 <= n || n === 13 ? n : 0;
    }
    function uu() {
      return !0;
    }
    function lm() {
      return !1;
    }
    function Jt(n) {
      function o(s, h, y, C, A) {
        this._reactName = s, this._targetInst = y, this.type = h, this.nativeEvent = C, this.target = A, this.currentTarget = null;
        for (var z in n)
          n.hasOwnProperty(z) && (s = n[z], this[z] = s ? s(C) : C[z]);
        return this.isDefaultPrevented = (C.defaultPrevented != null ? C.defaultPrevented : C.returnValue === !1) ? uu : lm, this.isPropagationStopped = lm, this;
      }
      return Rn(o.prototype, {
        preventDefault: function() {
          this.defaultPrevented = !0;
          var s = this.nativeEvent;
          s && (s.preventDefault ? s.preventDefault() : typeof s.returnValue != "unknown" && (s.returnValue = !1), this.isDefaultPrevented = uu);
        },
        stopPropagation: function() {
          var s = this.nativeEvent;
          s && (s.stopPropagation ? s.stopPropagation() : typeof s.cancelBubble != "unknown" && (s.cancelBubble = !0), this.isPropagationStopped = uu);
        },
        persist: function() {
        },
        isPersistent: uu
      }), o;
    }
    function nr(n) {
      var o = this.nativeEvent;
      return o.getModifierState ? o.getModifierState(n) : (n = OO[n]) ? !!o[n] : !1;
    }
    function ao() {
      return nr;
    }
    function wo(n, o) {
      switch (n) {
        case "keyup":
          return FO.indexOf(o.keyCode) !== -1;
        case "keydown":
          return o.keyCode !== y6;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function Ea(n) {
      return n = n.detail, typeof n == "object" && "data" in n ? n.data : null;
    }
    function Uf(n, o) {
      switch (n) {
        case "compositionend":
          return Ea(o);
        case "keypress":
          return o.which !== S6 ? null : (x6 = !0, C6);
        case "textInput":
          return n = o.data, n === C6 && x6 ? null : n;
        default:
          return null;
      }
    }
    function gd(n, o) {
      if (Gg)
        return n === "compositionend" || !RC && wo(n, o) ? (n = ul(), qy = kC = bf = null, Gg = !1, n) : null;
      switch (n) {
        case "paste":
          return null;
        case "keypress":
          if (!(o.ctrlKey || o.altKey || o.metaKey) || o.ctrlKey && o.altKey) {
            if (o.char && 1 < o.char.length)
              return o.char;
            if (o.which)
              return String.fromCharCode(o.which);
          }
          return null;
        case "compositionend":
          return w6 && o.locale !== "ko" ? null : o.data;
        default:
          return null;
      }
    }
    function Zh(n) {
      var o = n && n.nodeName && n.nodeName.toLowerCase();
      return o === "input" ? !!VO[n.type] : o === "textarea";
    }
    function cd(n) {
      if (!Vu) return !1;
      n = "on" + n;
      var o = n in document;
      return o || (o = document.createElement("div"), o.setAttribute(n, "return;"), o = typeof o[n] == "function"), o;
    }
    function sm(n, o, s, h) {
      Ug ? Xg ? Xg.push(h) : Xg = [h] : Ug = h, o = Tl(o, "onChange"), 0 < o.length && (s = new Ky(
        "onChange",
        "change",
        null,
        s,
        h
      ), n.push({ event: s, listeners: o }));
    }
    function Mb(n) {
      br(n, 0);
    }
    function uo(n) {
      var o = Nt(n);
      if (gn(o)) return n;
    }
    function cu(n, o) {
      if (n === "change") return o;
    }
    function um() {
      X2 && (X2.detachEvent("onpropertychange", vd), G2 = X2 = null);
    }
    function vd(n) {
      if (n.propertyName === "value" && uo(G2)) {
        var o = [];
        sm(
          o,
          G2,
          n,
          Va(n)
        ), Li(Mb, o);
      }
    }
    function dC(n, o, s) {
      n === "focusin" ? (um(), X2 = o, G2 = s, X2.attachEvent("onpropertychange", vd)) : n === "focusout" && um();
    }
    function K0(n) {
      if (n === "selectionchange" || n === "keyup" || n === "keydown")
        return uo(G2);
    }
    function Y0(n, o) {
      if (n === "click") return uo(o);
    }
    function cm(n, o) {
      if (n === "input" || n === "change")
        return uo(o);
    }
    function pp(n, o) {
      return n === o && (n !== 0 || 1 / n === 1 / o) || n !== n && o !== o;
    }
    function bd(n, o) {
      if (Ai(n, o)) return !0;
      if (typeof n != "object" || n === null || typeof o != "object" || o === null)
        return !1;
      var s = Object.keys(n), h = Object.keys(o);
      if (s.length !== h.length) return !1;
      for (h = 0; h < s.length; h++) {
        var y = s[h];
        if (!Ti.call(o, y) || !Ai(n[y], o[y]))
          return !1;
      }
      return !0;
    }
    function Ob(n) {
      for (; n && n.firstChild; ) n = n.firstChild;
      return n;
    }
    function Tb(n, o) {
      var s = Ob(n);
      n = 0;
      for (var h; s; ) {
        if (s.nodeType === 3) {
          if (h = n + s.textContent.length, n <= o && h >= o)
            return { node: s, offset: o - n };
          n = h;
        }
        e: {
          for (; s; ) {
            if (s.nextSibling) {
              s = s.nextSibling;
              break e;
            }
            s = s.parentNode;
          }
          s = void 0;
        }
        s = Ob(s);
      }
    }
    function Rb(n, o) {
      return n && o ? n === o ? !0 : n && n.nodeType === 3 ? !1 : o && o.nodeType === 3 ? Rb(n, o.parentNode) : "contains" in n ? n.contains(o) : n.compareDocumentPosition ? !!(n.compareDocumentPosition(o) & 16) : !1 : !1;
    }
    function gp(n) {
      n = n != null && n.ownerDocument != null && n.ownerDocument.defaultView != null ? n.ownerDocument.defaultView : window;
      for (var o = Tn(n.document); o instanceof n.HTMLIFrameElement; ) {
        try {
          var s = typeof o.contentWindow.location.href == "string";
        } catch {
          s = !1;
        }
        if (s) n = o.contentWindow;
        else break;
        o = Tn(n.document);
      }
      return o;
    }
    function Q0(n) {
      var o = n && n.nodeName && n.nodeName.toLowerCase();
      return o && (o === "input" && (n.type === "text" || n.type === "search" || n.type === "tel" || n.type === "url" || n.type === "password") || o === "textarea" || n.contentEditable === "true");
    }
    function Ab(n, o, s) {
      var h = s.window === s ? s.document : s.nodeType === 9 ? s : s.ownerDocument;
      NC || qg == null || qg !== Tn(h) || (h = qg, "selectionStart" in h && Q0(h) ? h = { start: h.selectionStart, end: h.selectionEnd } : (h = (h.ownerDocument && h.ownerDocument.defaultView || window).getSelection(), h = {
        anchorNode: h.anchorNode,
        anchorOffset: h.anchorOffset,
        focusNode: h.focusNode,
        focusOffset: h.focusOffset
      }), q2 && bd(q2, h) || (q2 = h, h = Tl(AC, "onSelect"), 0 < h.length && (o = new Ky(
        "onSelect",
        "select",
        null,
        o,
        s
      ), n.push({ event: o, listeners: h }), o.target = qg)));
    }
    function ac(n, o) {
      var s = {};
      return s[n.toLowerCase()] = o.toLowerCase(), s["Webkit" + n] = "webkit" + o, s["Moz" + n] = "moz" + o, s;
    }
    function oc(n) {
      if (DC[n]) return DC[n];
      if (!Kg[n]) return n;
      var o = Kg[n], s;
      for (s in o)
        if (o.hasOwnProperty(s) && s in P6)
          return DC[n] = o[s];
      return n;
    }
    function ml(n, o) {
      R6.set(n, o), hn(o, [n]);
    }
    function Nb(n) {
      for (var o = Qy, s = 0; s < n.length; s++) {
        var h = n[s];
        if (typeof h == "object" && h !== null)
          if (Ta(h) && h.length === 2 && typeof h[0] == "string") {
            if (o !== Qy && o !== LC)
              return jC;
            o = LC;
          } else return jC;
        else {
          if (typeof h == "function" || typeof h == "string" && 50 < h.length || o !== Qy && o !== IC)
            return jC;
          o = IC;
        }
      }
      return o;
    }
    function J0(n, o, s, h) {
      for (var y in n)
        Ti.call(n, y) && y[0] !== "_" && Vl(y, n[y], o, s, h);
    }
    function Vl(n, o, s, h, y) {
      switch (typeof o) {
        case "object":
          if (o === null) {
            o = "null";
            break;
          } else {
            if (o.$$typeof === nl) {
              var C = F(o.type) || "…", A = o.key;
              o = o.props;
              var z = Object.keys(o), q = z.length;
              if (A == null && q === 0) {
                o = "<" + C + " />";
                break;
              }
              if (3 > h || q === 1 && z[0] === "children" && A == null) {
                o = "<" + C + " … />";
                break;
              }
              s.push([
                y + "  ".repeat(h) + n,
                "<" + C
              ]), A !== null && Vl(
                "key",
                A,
                s,
                h + 1,
                y
              ), n = !1;
              for (var Z in o)
                Z === "children" ? o.children != null && (!Ta(o.children) || 0 < o.children.length) && (n = !0) : Ti.call(o, Z) && Z[0] !== "_" && Vl(
                  Z,
                  o[Z],
                  s,
                  h + 1,
                  y
                );
              s.push([
                "",
                n ? ">…</" + C + ">" : "/>"
              ]);
              return;
            }
            if (C = Object.prototype.toString.call(o), C = C.slice(8, C.length - 1), C === "Array") {
              if (Z = Nb(o), Z === IC || Z === Qy) {
                o = JSON.stringify(o);
                break;
              } else if (Z === LC) {
                for (s.push([
                  y + "  ".repeat(h) + n,
                  ""
                ]), n = 0; n < o.length; n++)
                  C = o[n], Vl(
                    C[0],
                    C[1],
                    s,
                    h + 1,
                    y
                  );
                return;
              }
            }
            if (C === "Promise") {
              if (o.status === "fulfilled") {
                if (C = s.length, Vl(
                  n,
                  o.value,
                  s,
                  h,
                  y
                ), s.length > C) {
                  s = s[C], s[1] = "Promise<" + (s[1] || "Object") + ">";
                  return;
                }
              } else if (o.status === "rejected" && (C = s.length, Vl(
                n,
                o.reason,
                s,
                h,
                y
              ), s.length > C)) {
                s = s[C], s[1] = "Rejected Promise<" + s[1] + ">";
                return;
              }
              s.push([
                "  ".repeat(h) + n,
                "Promise"
              ]);
              return;
            }
            C === "Object" && (Z = Object.getPrototypeOf(o)) && typeof Z.constructor == "function" && (C = Z.constructor.name), s.push([
              y + "  ".repeat(h) + n,
              C === "Object" ? 3 > h ? "" : "…" : C
            ]), 3 > h && J0(o, s, h + 1, y);
            return;
          }
        case "function":
          o = o.name === "" ? "() => {}" : o.name + "() {}";
          break;
        case "string":
          o = o === KO ? "…" : JSON.stringify(o);
          break;
        case "undefined":
          o = "undefined";
          break;
        case "boolean":
          o = o ? "true" : "false";
          break;
        default:
          o = String(o);
      }
      s.push([
        y + "  ".repeat(h) + n,
        o
      ]);
    }
    function Db(n, o, s, h) {
      var y = !0;
      for (A in n)
        A in o || (s.push([
          Jy + "  ".repeat(h) + A,
          "…"
        ]), y = !1);
      for (var C in o)
        if (C in n) {
          var A = n[C], z = o[C];
          if (A !== z) {
            if (h === 0 && C === "children")
              y = "  ".repeat(h) + C, s.push(
                [Jy + y, "…"],
                [Zy + y, "…"]
              );
            else {
              if (!(3 <= h)) {
                if (typeof A == "object" && typeof z == "object" && A !== null && z !== null && A.$$typeof === z.$$typeof)
                  if (z.$$typeof === nl) {
                    if (A.type === z.type && A.key === z.key) {
                      A = F(z.type) || "…", y = "  ".repeat(h) + C, A = "<" + A + " … />", s.push(
                        [Jy + y, A],
                        [Zy + y, A]
                      ), y = !1;
                      continue;
                    }
                  } else {
                    var q = Object.prototype.toString.call(A), Z = Object.prototype.toString.call(z);
                    if (q === Z && (Z === "[object Object]" || Z === "[object Array]")) {
                      q = [
                        D6 + "  ".repeat(h) + C,
                        Z === "[object Array]" ? "Array" : ""
                      ], s.push(q), Z = s.length, Db(
                        A,
                        z,
                        s,
                        h + 1
                      ) ? Z === s.length && (q[1] = "Referentially unequal but deeply equal objects. Consider memoization.") : y = !1;
                      continue;
                    }
                  }
                else if (typeof A == "function" && typeof z == "function" && A.name === z.name && A.length === z.length && (q = Function.prototype.toString.call(A), Z = Function.prototype.toString.call(z), q === Z)) {
                  A = z.name === "" ? "() => {}" : z.name + "() {}", s.push([
                    D6 + "  ".repeat(h) + C,
                    A + " Referentially unequal function closure. Consider memoization."
                  ]);
                  continue;
                }
              }
              Vl(C, A, s, h, Jy), Vl(C, z, s, h, Zy);
            }
            y = !1;
          }
        } else
          s.push([
            Zy + "  ".repeat(h) + C,
            "…"
          ]), y = !1;
      return y;
    }
    function hl(n) {
      Zn = n & 63 ? "Blocking" : n & 64 ? "Gesture" : n & 4194176 ? "Transition" : n & 62914560 ? "Suspense" : n & 2080374784 ? "Idle" : "Other";
    }
    function Xi(n, o, s, h) {
      Gr && (wf.start = o, wf.end = s, Bc.color = "warning", Bc.tooltipText = h, Bc.properties = null, (n = n._debugTask) ? n.run(
        performance.measure.bind(
          performance,
          h,
          wf
        )
      ) : performance.measure(h, wf));
    }
    function vp(n, o, s) {
      Xi(n, o, s, "Reconnect");
    }
    function bp(n, o, s, h, y) {
      var C = W(n);
      if (C !== null && Gr) {
        var A = n.alternate, z = n.actualDuration;
        if (A === null || A.child !== n.child)
          for (var q = n.child; q !== null; q = q.sibling)
            z -= q.actualDuration;
        h = 0.5 > z ? h ? "tertiary-light" : "primary-light" : 10 > z ? h ? "tertiary" : "primary" : 100 > z ? h ? "tertiary-dark" : "primary-dark" : "error";
        var Z = n.memoizedProps;
        z = n._debugTask, Z !== null && A !== null && A.memoizedProps !== Z ? (q = [YO], Z = Db(
          A.memoizedProps,
          Z,
          q,
          0
        ), 1 < q.length && (Z && !yf && (A.lanes & y) === 0 && 100 < n.actualDuration ? (yf = !0, q[0] = QO, Bc.color = "warning", Bc.tooltipText = $6) : (Bc.color = h, Bc.tooltipText = C), Bc.properties = q, wf.start = o, wf.end = s, z != null ? z.run(
          performance.measure.bind(
            performance,
            "​" + C,
            wf
          )
        ) : performance.measure(
          "​" + C,
          wf
        ))) : z != null ? z.run(
          console.timeStamp.bind(
            console,
            C,
            o,
            s,
            ps,
            void 0,
            h
          )
        ) : console.timeStamp(
          C,
          o,
          s,
          ps,
          void 0,
          h
        );
      }
    }
    function Z0(n, o, s, h) {
      if (Gr) {
        var y = W(n);
        if (y !== null) {
          for (var C = null, A = [], z = 0; z < h.length; z++) {
            var q = h[z];
            C == null && q.source !== null && (C = q.source._debugTask), q = q.value, A.push([
              "Error",
              typeof q == "object" && q !== null && typeof q.message == "string" ? String(q.message) : String(q)
            ]);
          }
          n.key !== null && Vl("key", n.key, A, 0, ""), n.memoizedProps !== null && J0(n.memoizedProps, A, 0, ""), C == null && (C = n._debugTask), n = {
            start: o,
            end: s,
            detail: {
              devtools: {
                color: "error",
                track: ps,
                tooltipText: n.tag === 13 ? "Hydration failed" : "Error boundary caught an error",
                properties: A
              }
            }
          }, C ? C.run(
            performance.measure.bind(performance, "​" + y, n)
          ) : performance.measure("​" + y, n);
        }
      }
    }
    function pl(n, o, s, h, y) {
      if (y !== null) {
        if (Gr) {
          var C = W(n);
          if (C !== null) {
            h = [];
            for (var A = 0; A < y.length; A++) {
              var z = y[A].value;
              h.push([
                "Error",
                typeof z == "object" && z !== null && typeof z.message == "string" ? String(z.message) : String(z)
              ]);
            }
            n.key !== null && Vl("key", n.key, h, 0, ""), n.memoizedProps !== null && J0(n.memoizedProps, h, 0, ""), o = {
              start: o,
              end: s,
              detail: {
                devtools: {
                  color: "error",
                  track: ps,
                  tooltipText: "A lifecycle or effect errored",
                  properties: h
                }
              }
            }, (n = n._debugTask) ? n.run(
              performance.measure.bind(
                performance,
                "​" + C,
                o
              )
            ) : performance.measure("​" + C, o);
          }
        }
      } else
        C = W(n), C !== null && Gr && (y = 1 > h ? "secondary-light" : 100 > h ? "secondary" : 500 > h ? "secondary-dark" : "error", (n = n._debugTask) ? n.run(
          console.timeStamp.bind(
            console,
            C,
            o,
            s,
            ps,
            void 0,
            y
          )
        ) : console.timeStamp(
          C,
          o,
          s,
          ps,
          void 0,
          y
        ));
    }
    function fC(n, o, s, h) {
      if (Gr && !(o <= n)) {
        var y = (s & 738197653) === s ? "tertiary-dark" : "primary-dark";
        s = (s & 536870912) === s ? "Prepared" : (s & 201326741) === s ? "Hydrated" : "Render", h ? h.run(
          console.timeStamp.bind(
            console,
            s,
            n,
            o,
            Zn,
            Kn,
            y
          )
        ) : console.timeStamp(
          s,
          n,
          o,
          Zn,
          Kn,
          y
        );
      }
    }
    function $b(n, o, s, h) {
      !Gr || o <= n || (s = (s & 738197653) === s ? "tertiary-dark" : "primary-dark", h ? h.run(
        console.timeStamp.bind(
          console,
          "Prewarm",
          n,
          o,
          Zn,
          Kn,
          s
        )
      ) : console.timeStamp(
        "Prewarm",
        n,
        o,
        Zn,
        Kn,
        s
      ));
    }
    function zb(n, o, s, h) {
      !Gr || o <= n || (s = (s & 738197653) === s ? "tertiary-dark" : "primary-dark", h ? h.run(
        console.timeStamp.bind(
          console,
          "Suspended",
          n,
          o,
          Zn,
          Kn,
          s
        )
      ) : console.timeStamp(
        "Suspended",
        n,
        o,
        Zn,
        Kn,
        s
      ));
    }
    function mC(n, o, s, h, y, C) {
      if (Gr && !(o <= n)) {
        s = [];
        for (var A = 0; A < h.length; A++) {
          var z = h[A].value;
          s.push([
            "Recoverable Error",
            typeof z == "object" && z !== null && typeof z.message == "string" ? String(z.message) : String(z)
          ]);
        }
        n = {
          start: n,
          end: o,
          detail: {
            devtools: {
              color: "primary-dark",
              track: Zn,
              trackGroup: Kn,
              tooltipText: y ? "Hydration Failed" : "Recovered after Error",
              properties: s
            }
          }
        }, C ? C.run(
          performance.measure.bind(performance, "Recovered", n)
        ) : performance.measure("Recovered", n);
      }
    }
    function ev(n, o, s, h) {
      !Gr || o <= n || (h ? h.run(
        console.timeStamp.bind(
          console,
          "Errored",
          n,
          o,
          Zn,
          Kn,
          "error"
        )
      ) : console.timeStamp(
        "Errored",
        n,
        o,
        Zn,
        Kn,
        "error"
      ));
    }
    function hC(n, o, s, h) {
      !Gr || o <= n || (h ? h.run(
        console.timeStamp.bind(
          console,
          s,
          n,
          o,
          Zn,
          Kn,
          "secondary-light"
        )
      ) : console.timeStamp(
        s,
        n,
        o,
        Zn,
        Kn,
        "secondary-light"
      ));
    }
    function jb(n, o, s, h, y) {
      if (Gr && !(o <= n)) {
        for (var C = [], A = 0; A < s.length; A++) {
          var z = s[A].value;
          C.push([
            "Error",
            typeof z == "object" && z !== null && typeof z.message == "string" ? String(z.message) : String(z)
          ]);
        }
        n = {
          start: n,
          end: o,
          detail: {
            devtools: {
              color: "error",
              track: Zn,
              trackGroup: Kn,
              tooltipText: h ? "Remaining Effects Errored" : "Commit Errored",
              properties: C
            }
          }
        }, y ? y.run(
          performance.measure.bind(performance, "Errored", n)
        ) : performance.measure("Errored", n);
      }
    }
    function tv(n, o, s) {
      !Gr || o <= n || console.timeStamp(
        "Animating",
        n,
        o,
        Zn,
        Kn,
        "secondary-dark"
      );
    }
    function yp() {
      for (var n = Yg, o = HC = Yg = 0; o < n; ) {
        var s = gs[o];
        gs[o++] = null;
        var h = gs[o];
        gs[o++] = null;
        var y = gs[o];
        gs[o++] = null;
        var C = gs[o];
        if (gs[o++] = null, h !== null && y !== null) {
          var A = h.pending;
          A === null ? y.next = y : (y.next = A.next, A.next = y), h.pending = y;
        }
        C !== 0 && nv(s, y, C);
      }
    }
    function yd(n, o, s, h) {
      gs[Yg++] = n, gs[Yg++] = o, gs[Yg++] = s, gs[Yg++] = h, HC |= h, n.lanes |= h, n = n.alternate, n !== null && (n.lanes |= h);
    }
    function ic(n, o, s, h) {
      return yd(n, o, s, h), dm(n);
    }
    function So(n, o) {
      return yd(n, null, null, o), dm(n);
    }
    function nv(n, o, s) {
      n.lanes |= s;
      var h = n.alternate;
      h !== null && (h.lanes |= s);
      for (var y = !1, C = n.return; C !== null; )
        C.childLanes |= s, h = C.alternate, h !== null && (h.childLanes |= s), C.tag === 22 && (n = C.stateNode, n === null || n._visibility & K2 || (y = !0)), n = C, C = C.return;
      return n.tag === 3 ? (C = n.stateNode, y && o !== null && (y = 31 - fo(s), n = C.hiddenUpdates, h = n[y], h === null ? n[y] = [o] : h.push(o), o.lane = s | 536870912), C) : null;
    }
    function dm(n) {
      if (C1 > hT)
        throw Dh = C1 = 0, x1 = b4 = null, Error(
          "Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops."
        );
      Dh > pT && (Dh = 0, x1 = null, console.error(
        "Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."
      )), n.alternate === null && (n.flags & 4098) !== 0 && tl(n);
      for (var o = n, s = o.return; s !== null; )
        o.alternate === null && (o.flags & 4098) !== 0 && tl(n), o = s, s = o.return;
      return o.tag === 3 ? o.stateNode : null;
    }
    function du(n) {
      if (vs === null) return n;
      var o = vs(n);
      return o === void 0 ? n : o.current;
    }
    function wp(n) {
      if (vs === null) return n;
      var o = vs(n);
      return o === void 0 ? n != null && typeof n.render == "function" && (o = du(n.render), n.render !== o) ? (o = { $$typeof: lf, render: o }, n.displayName !== void 0 && (o.displayName = n.displayName), o) : n : o.current;
    }
    function rv(n, o) {
      if (vs === null) return !1;
      var s = n.elementType;
      o = o.type;
      var h = !1, y = typeof o == "object" && o !== null ? o.$$typeof : null;
      switch (n.tag) {
        case 1:
          typeof o == "function" && (h = !0);
          break;
        case 0:
          (typeof o == "function" || y === Eo) && (h = !0);
          break;
        case 11:
          (y === lf || y === Eo) && (h = !0);
          break;
        case 14:
        case 15:
          (y === dh || y === Eo) && (h = !0);
          break;
        default:
          return !1;
      }
      return !!(h && (n = vs(s), n !== void 0 && n === vs(o)));
    }
    function lc(n) {
      vs !== null && typeof WeakSet == "function" && (Qg === null && (Qg = /* @__PURE__ */ new WeakSet()), Qg.add(n));
    }
    function Ib(n, o, s) {
      do {
        var h = n, y = h.alternate, C = h.child, A = h.sibling, z = h.tag;
        h = h.type;
        var q = null;
        switch (z) {
          case 0:
          case 15:
          case 1:
            q = h;
            break;
          case 11:
            q = h.render;
        }
        if (vs === null)
          throw Error("Expected resolveFamily to be set during hot reload.");
        var Z = !1;
        if (h = !1, q !== null && (q = vs(q), q !== void 0 && (s.has(q) ? h = !0 : o.has(q) && (z === 1 ? h = !0 : Z = !0))), Qg !== null && (Qg.has(n) || y !== null && Qg.has(y)) && (h = !0), h && (n._debugNeedsRemount = !0), (h || Z) && (y = So(n, 2), y !== null && ln(y, n, 2)), C === null || h || Ib(
          C,
          o,
          s
        ), A === null) break;
        n = A;
      } while (!0);
    }
    function pC(n, o, s, h) {
      this.tag = n, this.key = s, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = o, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = h, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null, this.actualDuration = -0, this.actualStartTime = -1.1, this.treeBaseDuration = this.selfBaseDuration = -0, this._debugTask = this._debugStack = this._debugOwner = this._debugInfo = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, z6 || typeof Object.preventExtensions != "function" || Object.preventExtensions(this);
    }
    function av(n) {
      return n = n.prototype, !(!n || !n.isReactComponent);
    }
    function _l(n, o) {
      var s = n.alternate;
      switch (s === null ? (s = x(
        n.tag,
        o,
        n.key,
        n.mode
      ), s.elementType = n.elementType, s.type = n.type, s.stateNode = n.stateNode, s._debugOwner = n._debugOwner, s._debugStack = n._debugStack, s._debugTask = n._debugTask, s._debugHookTypes = n._debugHookTypes, s.alternate = n, n.alternate = s) : (s.pendingProps = o, s.type = n.type, s.flags = 0, s.subtreeFlags = 0, s.deletions = null, s.actualDuration = -0, s.actualStartTime = -1.1), s.flags = n.flags & 65011712, s.childLanes = n.childLanes, s.lanes = n.lanes, s.child = n.child, s.memoizedProps = n.memoizedProps, s.memoizedState = n.memoizedState, s.updateQueue = n.updateQueue, o = n.dependencies, s.dependencies = o === null ? null : {
        lanes: o.lanes,
        firstContext: o.firstContext,
        _debugThenableState: o._debugThenableState
      }, s.sibling = n.sibling, s.index = n.index, s.ref = n.ref, s.refCleanup = n.refCleanup, s.selfBaseDuration = n.selfBaseDuration, s.treeBaseDuration = n.treeBaseDuration, s._debugInfo = n._debugInfo, s._debugNeedsRemount = n._debugNeedsRemount, s.tag) {
        case 0:
        case 15:
          s.type = du(n.type);
          break;
        case 1:
          s.type = du(n.type);
          break;
        case 11:
          s.type = wp(n.type);
      }
      return s;
    }
    function ov(n, o) {
      n.flags &= 65011714;
      var s = n.alternate;
      return s === null ? (n.childLanes = 0, n.lanes = o, n.child = null, n.subtreeFlags = 0, n.memoizedProps = null, n.memoizedState = null, n.updateQueue = null, n.dependencies = null, n.stateNode = null, n.selfBaseDuration = 0, n.treeBaseDuration = 0) : (n.childLanes = s.childLanes, n.lanes = s.lanes, n.child = s.child, n.subtreeFlags = 0, n.deletions = null, n.memoizedProps = s.memoizedProps, n.memoizedState = s.memoizedState, n.updateQueue = s.updateQueue, n.type = s.type, o = s.dependencies, n.dependencies = o === null ? null : {
        lanes: o.lanes,
        firstContext: o.firstContext,
        _debugThenableState: o._debugThenableState
      }, n.selfBaseDuration = s.selfBaseDuration, n.treeBaseDuration = s.treeBaseDuration), n;
    }
    function sc(n, o, s, h, y, C) {
      var A = 0, z = n;
      if (typeof n == "function")
        av(n) && (A = 1), z = du(z);
      else if (typeof n == "string")
        A = K(), A = Ny(n, s, A) ? 26 : n === "html" || n === "head" || n === "body" ? 27 : 5;
      else
        e: switch (n) {
          case Dl:
            return o = x(31, s, o, y), o.elementType = Dl, o.lanes = C, o;
          case of:
            return uc(
              s.children,
              y,
              C,
              o
            );
          case Go:
            A = 8, y |= ii, y |= Qs;
            break;
          case ch:
            return n = s, h = y, typeof n.id != "string" && console.error(
              'Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.',
              typeof n.id
            ), o = x(12, n, o, h | An), o.elementType = ch, o.lanes = C, o.stateNode = { effectDuration: 0, passiveEffectDuration: 0 }, o;
          case Hc:
            return o = x(13, s, o, y), o.elementType = Hc, o.lanes = C, o;
          case ai:
            return o = x(19, s, o, y), o.elementType = ai, o.lanes = C, o;
          default:
            if (typeof n == "object" && n !== null)
              switch (n.$$typeof) {
                case Nl:
                  A = 10;
                  break e;
                case Ng:
                  A = 9;
                  break e;
                case lf:
                  A = 11, z = wp(z);
                  break e;
                case dh:
                  A = 14;
                  break e;
                case Eo:
                  A = 16, z = null;
                  break e;
              }
            z = "", (n === void 0 || typeof n == "object" && n !== null && Object.keys(n).length === 0) && (z += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), n === null ? s = "null" : Ta(n) ? s = "array" : n !== void 0 && n.$$typeof === nl ? (s = "<" + (F(n.type) || "Unknown") + " />", z = " Did you accidentally export a JSX literal instead of a component?") : s = typeof n, (A = h ? _(h) : null) && (z += `

Check the render method of \`` + A + "`."), A = 29, s = Error(
              "Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (s + "." + z)
            ), z = null;
        }
      return o = x(A, s, o, y), o.elementType = n, o.type = z, o.lanes = C, o._debugOwner = h, o;
    }
    function fu(n, o, s) {
      return o = sc(
        n.type,
        n.key,
        n.props,
        n._owner,
        o,
        s
      ), o._debugOwner = n._owner, o._debugStack = n._debugStack, o._debugTask = n._debugTask, o;
    }
    function uc(n, o, s, h) {
      return n = x(7, n, h, o), n.lanes = s, n;
    }
    function wd(n, o, s) {
      return n = x(6, n, null, o), n.lanes = s, n;
    }
    function iv(n) {
      var o = x(18, null, null, on);
      return o.stateNode = n, o;
    }
    function Sp(n, o, s) {
      return o = x(
        4,
        n.children !== null ? n.children : [],
        n.key,
        o
      ), o.lanes = s, o.stateNode = {
        containerInfo: n.containerInfo,
        pendingChildren: null,
        implementation: n.implementation
      }, o;
    }
    function $o(n, o) {
      if (typeof n == "object" && n !== null) {
        var s = FC.get(n);
        return s !== void 0 ? s : (o = {
          value: n,
          source: o,
          stack: me(o)
        }, FC.set(n, o), o);
      }
      return {
        value: n,
        source: o,
        stack: me(o)
      };
    }
    function gl(n, o) {
      mu(), Jg[Zg++] = Y2, Jg[Zg++] = ew, ew = n, Y2 = o;
    }
    function lv(n, o, s) {
      mu(), bs[ys++] = Xc, bs[ys++] = Gc, bs[ys++] = bh, bh = n;
      var h = Xc;
      n = Gc;
      var y = 32 - fo(h) - 1;
      h &= ~(1 << y), s += 1;
      var C = 32 - fo(o) + y;
      if (30 < C) {
        var A = y - y % 5;
        C = (h & (1 << A) - 1).toString(32), h >>= A, y -= A, Xc = 1 << 32 - fo(o) + y | s << y | h, Gc = C + n;
      } else
        Xc = 1 << C | s << y | h, Gc = n;
    }
    function Cp(n) {
      mu(), n.return !== null && (gl(n, 1), lv(n, 1, 0));
    }
    function xp(n) {
      for (; n === ew; )
        ew = Jg[--Zg], Jg[Zg] = null, Y2 = Jg[--Zg], Jg[Zg] = null;
      for (; n === bh; )
        bh = bs[--ys], bs[ys] = null, Gc = bs[--ys], bs[ys] = null, Xc = bs[--ys], bs[ys] = null;
    }
    function Lb() {
      return mu(), bh !== null ? { id: Xc, overflow: Gc } : null;
    }
    function Hb(n, o) {
      mu(), bs[ys++] = Xc, bs[ys++] = Gc, bs[ys++] = bh, Xc = o.id, Gc = o.overflow, bh = n;
    }
    function mu() {
      Xn || console.error(
        "Expected to be hydrating. This is a bug in React. Please file an issue."
      );
    }
    function cc(n, o) {
      if (n.return === null) {
        if (zl === null)
          zl = {
            fiber: n,
            children: [],
            serverProps: void 0,
            serverTail: [],
            distanceFromLeaf: o
          };
        else {
          if (zl.fiber !== n)
            throw Error(
              "Saw multiple hydration diff roots in a pass. This is a bug in React."
            );
          zl.distanceFromLeaf > o && (zl.distanceFromLeaf = o);
        }
        return zl;
      }
      var s = cc(
        n.return,
        o + 1
      ).children;
      return 0 < s.length && s[s.length - 1].fiber === n ? (s = s[s.length - 1], s.distanceFromLeaf > o && (s.distanceFromLeaf = o), s) : (o = {
        fiber: n,
        children: [],
        serverProps: void 0,
        serverTail: [],
        distanceFromLeaf: o
      }, s.push(o), o);
    }
    function Fb() {
      Xn && console.error(
        "We should not be hydrating here. This is a bug in React. Please file a bug."
      );
    }
    function Co(n, o) {
      _u || (n = cc(n, 0), n.serverProps = null, o !== null && (o = Oy(o), n.serverTail.push(o)));
    }
    function Gi(n) {
      var o = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : !1, s = "", h = zl;
      throw h !== null && (zl = null, s = mi(h)), mm(
        $o(
          Error(
            "Hydration failed because the server rendered " + (o ? "text" : "HTML") + ` didn't match the client. As a result this tree will be regenerated on the client. This can happen if a SSR-ed Client Component used:

- A server/client branch \`if (typeof window !== 'undefined')\`.
- Variable input such as \`Date.now()\` or \`Math.random()\` which changes each time it's called.
- Date formatting in a user's locale which doesn't match the server.
- External changing data without sending a snapshot of it along with the HTML.
- Invalid HTML tag nesting.

It can also happen if the client has a browser extension installed which messes with the HTML before React loaded.

https://react.dev/link/hydration-mismatch` + s
          ),
          n
        )
      ), WC;
    }
    function sv(n) {
      var o = n.stateNode, s = n.type, h = n.memoizedProps;
      switch (o[Xr] = n, o[qo] = h, Uo(s, h), s) {
        case "dialog":
          rn("cancel", o), rn("close", o);
          break;
        case "iframe":
        case "object":
        case "embed":
          rn("load", o);
          break;
        case "video":
        case "audio":
          for (s = 0; s < E1.length; s++)
            rn(E1[s], o);
          break;
        case "source":
          rn("error", o);
          break;
        case "img":
        case "image":
        case "link":
          rn("error", o), rn("load", o);
          break;
        case "details":
          rn("toggle", o);
          break;
        case "input":
          jn("input", h), rn("invalid", o), Dt(o, h), Mn(
            o,
            h.value,
            h.defaultValue,
            h.checked,
            h.defaultChecked,
            h.type,
            h.name,
            !0
          );
          break;
        case "option":
          wr(o, h);
          break;
        case "select":
          jn("select", h), rn("invalid", o), Rr(o, h);
          break;
        case "textarea":
          jn("textarea", h), rn("invalid", o), Wt(o, h), Xt(
            o,
            h.value,
            h.defaultValue,
            h.children
          );
      }
      s = h.children, typeof s != "string" && typeof s != "number" && typeof s != "bigint" || o.textContent === "" + s || h.suppressHydrationWarning === !0 || c2(o.textContent, s) ? (h.popover != null && (rn("beforetoggle", o), rn("toggle", o)), h.onScroll != null && rn("scroll", o), h.onScrollEnd != null && rn("scrollend", o), h.onClick != null && (o.onclick = tr), o = !0) : o = !1, o || Gi(n, !0);
    }
    function uv(n) {
      for (Ko = n.return; Ko; )
        switch (Ko.tag) {
          case 5:
          case 31:
          case 13:
            ws = !1;
            return;
          case 27:
          case 3:
            ws = !0;
            return;
          default:
            Ko = Ko.return;
        }
    }
    function dc(n) {
      if (n !== Ko) return !1;
      if (!Xn)
        return uv(n), Xn = !0, !1;
      var o = n.tag, s;
      if ((s = o !== 3 && o !== 27) && ((s = o === 5) && (s = n.type, s = !(s !== "form" && s !== "button") || Qd(n.type, n.memoizedProps)), s = !s), s && qr) {
        for (s = qr; s; ) {
          var h = cc(n, 0), y = Oy(s);
          h.serverTail.push(y), s = y.type === "Suspense" ? ef(s) : Mi(s.nextSibling);
        }
        Gi(n);
      }
      if (uv(n), o === 13) {
        if (n = n.memoizedState, n = n !== null ? n.dehydrated : null, !n)
          throw Error(
            "Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue."
          );
        qr = ef(n);
      } else if (o === 31) {
        if (n = n.memoizedState, n = n !== null ? n.dehydrated : null, !n)
          throw Error(
            "Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue."
          );
        qr = ef(n);
      } else
        o === 27 ? (o = qr, ju(n.type) ? (n = R4, R4 = null, qr = n) : qr = o) : qr = Ko ? Mi(n.stateNode.nextSibling) : null;
      return !0;
    }
    function hu() {
      qr = Ko = null, _u = Xn = !1;
    }
    function fm() {
      var n = Cf;
      return n !== null && (zi === null ? zi = n : zi.push.apply(
        zi,
        n
      ), Cf = null), n;
    }
    function mm(n) {
      Cf === null ? Cf = [n] : Cf.push(n);
    }
    function pu() {
      var n = zl;
      if (n !== null) {
        zl = null;
        for (var o = mi(n); 0 < n.children.length; )
          n = n.children[0];
        le(n.fiber, function() {
          console.error(
            `A tree hydrated but some attributes of the server rendered HTML didn't match the client properties. This won't be patched up. This can happen if a SSR-ed Client Component used:

- A server/client branch \`if (typeof window !== 'undefined')\`.
- Variable input such as \`Date.now()\` or \`Math.random()\` which changes each time it's called.
- Date formatting in a user's locale which doesn't match the server.
- External changing data without sending a snapshot of it along with the HTML.
- Invalid HTML tag nesting.

It can also happen if the client has a browser extension installed which messes with the HTML before React loaded.

%s%s`,
            "https://react.dev/link/hydration-mismatch",
            o
          );
        });
      }
    }
    function Sd() {
      e0 = tw = null, t0 = !1;
    }
    function qi(n, o, s) {
      Y(VC, o._currentValue, n), o._currentValue = s, Y(_C, o._currentRenderer, n), o._currentRenderer !== void 0 && o._currentRenderer !== null && o._currentRenderer !== j6 && console.error(
        "Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."
      ), o._currentRenderer = j6;
    }
    function vl(n, o) {
      n._currentValue = VC.current;
      var s = _C.current;
      U(_C, o), n._currentRenderer = s, U(VC, o);
    }
    function Ep(n, o, s) {
      for (; n !== null; ) {
        var h = n.alternate;
        if ((n.childLanes & o) !== o ? (n.childLanes |= o, h !== null && (h.childLanes |= o)) : h !== null && (h.childLanes & o) !== o && (h.childLanes |= o), n === s) break;
        n = n.return;
      }
      n !== s && console.error(
        "Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue."
      );
    }
    function As(n, o, s, h) {
      var y = n.child;
      for (y !== null && (y.return = n); y !== null; ) {
        var C = y.dependencies;
        if (C !== null) {
          var A = y.child;
          C = C.firstContext;
          e: for (; C !== null; ) {
            var z = C;
            C = y;
            for (var q = 0; q < o.length; q++)
              if (z.context === o[q]) {
                C.lanes |= s, z = C.alternate, z !== null && (z.lanes |= s), Ep(
                  C.return,
                  s,
                  n
                ), h || (A = null);
                break e;
              }
            C = z.next;
          }
        } else if (y.tag === 18) {
          if (A = y.return, A === null)
            throw Error(
              "We just came from a parent so we must have had a parent. This is a bug in React."
            );
          A.lanes |= s, C = A.alternate, C !== null && (C.lanes |= s), Ep(
            A,
            s,
            n
          ), A = null;
        } else A = y.child;
        if (A !== null) A.return = y;
        else
          for (A = y; A !== null; ) {
            if (A === n) {
              A = null;
              break;
            }
            if (y = A.sibling, y !== null) {
              y.return = A.return, A = y;
              break;
            }
            A = A.return;
          }
        y = A;
      }
    }
    function bl(n, o, s, h) {
      n = null;
      for (var y = o, C = !1; y !== null; ) {
        if (!C) {
          if ((y.flags & 524288) !== 0) C = !0;
          else if ((y.flags & 262144) !== 0) break;
        }
        if (y.tag === 10) {
          var A = y.alternate;
          if (A === null)
            throw Error("Should have a current fiber. This is a bug in React.");
          if (A = A.memoizedProps, A !== null) {
            var z = y.type;
            Ai(y.pendingProps.value, A.value) || (n !== null ? n.push(z) : n = [z]);
          }
        } else if (y === Fu.current) {
          if (A = y.alternate, A === null)
            throw Error("Should have a current fiber. This is a bug in React.");
          A.memoizedState.memoizedState !== y.memoizedState.memoizedState && (n !== null ? n.push(T1) : n = [T1]);
        }
        y = y.return;
      }
      n !== null && As(
        o,
        n,
        s,
        h
      ), o.flags |= 262144;
    }
    function Cd(n) {
      for (n = n.firstContext; n !== null; ) {
        if (!Ai(
          n.context._currentValue,
          n.memoizedValue
        ))
          return !0;
        n = n.next;
      }
      return !1;
    }
    function gu(n) {
      tw = n, e0 = null, n = n.dependencies, n !== null && (n.firstContext = null);
    }
    function cr(n) {
      return t0 && console.error(
        "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."
      ), cv(tw, n);
    }
    function hm(n, o) {
      return tw === null && gu(n), cv(n, o);
    }
    function cv(n, o) {
      var s = o._currentValue;
      if (o = { context: o, memoizedValue: s, next: null }, e0 === null) {
        if (n === null)
          throw Error(
            "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."
          );
        e0 = o, n.dependencies = {
          lanes: 0,
          firstContext: o,
          _debugThenableState: null
        }, n.flags |= 524288;
      } else e0 = e0.next = o;
      return s;
    }
    function Pp() {
      return {
        controller: new tT(),
        data: /* @__PURE__ */ new Map(),
        refCount: 0
      };
    }
    function fc(n) {
      n.controller.signal.aborted && console.warn(
        "A cache instance was retained after it was already freed. This likely indicates a bug in React."
      ), n.refCount++;
    }
    function pm(n) {
      n.refCount--, 0 > n.refCount && console.warn(
        "A cache instance was released after it was already freed. This likely indicates a bug in React."
      ), n.refCount === 0 && nT(rT, function() {
        n.controller.abort();
      });
    }
    function Bl(n, o, s) {
      (n & 127) !== 0 ? 0 > Bu && (Bu = Qa(), J2 = nw(o), BC = o, s != null && (UC = W(s)), (ar & (po | Ll)) !== Oo && (Ca = !0, Ef = Q2), n = Jd(), o = us(), n !== n0 || o !== Z2 ? n0 = -1.1 : o !== null && (Ef = Q2), Sh = n, Z2 = o) : (n & 4194048) !== 0 && 0 > Ss && (Ss = Qa(), e1 = nw(o), I6 = o, s != null && (L6 = W(s)), 0 > Qc) && (n = Jd(), o = us(), (n !== kf || o !== Ch) && (kf = -1.1), Pf = n, Ch = o);
    }
    function Wb(n) {
      if (0 > Bu) {
        Bu = Qa(), J2 = n._debugTask != null ? n._debugTask : null, (ar & (po | Ll)) !== Oo && (Ef = Q2);
        var o = Jd(), s = us();
        o !== n0 || s !== Z2 ? n0 = -1.1 : s !== null && (Ef = Q2), Sh = o, Z2 = s;
      }
      0 > Ss && (Ss = Qa(), e1 = n._debugTask != null ? n._debugTask : null, 0 > Qc) && (n = Jd(), o = us(), (n !== kf || o !== Ch) && (kf = -1.1), Pf = n, Ch = o);
    }
    function Ul() {
      var n = yh;
      return yh = 0, n;
    }
    function xd(n) {
      var o = yh;
      return yh = n, o;
    }
    function zo(n) {
      var o = yh;
      return yh += n, o;
    }
    function mc() {
      tn = Bt = -1.1;
    }
    function _r() {
      var n = Bt;
      return Bt = -1.1, n;
    }
    function _a(n) {
      0 <= n && (Bt = n);
    }
    function Ki() {
      var n = ma;
      return ma = -0, n;
    }
    function gi(n) {
      0 <= n && (ma = n);
    }
    function vi() {
      var n = na;
      return na = null, n;
    }
    function Yi() {
      var n = Ca;
      return Ca = !1, n;
    }
    function Ns(n) {
      Ni = Qa(), 0 > n.actualStartTime && (n.actualStartTime = Ni);
    }
    function kp(n) {
      if (0 <= Ni) {
        var o = Qa() - Ni;
        n.actualDuration += o, n.selfBaseDuration = o, Ni = -1;
      }
    }
    function gm(n) {
      if (0 <= Ni) {
        var o = Qa() - Ni;
        n.actualDuration += o, Ni = -1;
      }
    }
    function jo() {
      if (0 <= Ni) {
        var n = Qa(), o = n - Ni;
        Ni = -1, yh += o, ma += o, tn = n;
      }
    }
    function Vb(n) {
      na === null && (na = []), na.push(n), Kc === null && (Kc = []), Kc.push(n);
    }
    function ca() {
      Ni = Qa(), 0 > Bt && (Bt = Ni);
    }
    function hc(n) {
      for (var o = n.child; o; )
        n.actualDuration += o.actualDuration, o = o.sibling;
    }
    function Ds(n, o) {
      if (n1 === null) {
        var s = n1 = [];
        GC = 0, xh = u2(), r0 = {
          status: "pending",
          value: void 0,
          then: function(h) {
            s.push(h);
          }
        };
      }
      return GC++, o.then(dv, dv), o;
    }
    function dv() {
      if (--GC === 0 && (-1 < Ss || (Qc = -1.1), n1 !== null)) {
        r0 !== null && (r0.status = "fulfilled");
        var n = n1;
        n1 = null, xh = 0, r0 = null;
        for (var o = 0; o < n.length; o++) (0, n[o])();
      }
    }
    function Mp(n, o) {
      var s = [], h = {
        status: "pending",
        value: null,
        reason: null,
        then: function(y) {
          s.push(y);
        }
      };
      return n.then(
        function() {
          h.status = "fulfilled", h.value = o;
          for (var y = 0; y < s.length; y++) (0, s[y])(o);
        },
        function(y) {
          for (h.status = "rejected", h.reason = y, y = 0; y < s.length; y++)
            (0, s[y])(void 0);
        }
      ), h;
    }
    function $s() {
      var n = Eh.current;
      return n !== null ? n : Lr.pooledCache;
    }
    function Ed(n, o) {
      o === null ? Y(Eh, Eh.current, n) : Y(Eh, o.pool, n);
    }
    function fv() {
      var n = $s();
      return n === null ? null : { parent: Ya._currentValue, pool: n };
    }
    function Op() {
      return { didWarnAboutUncachedPromise: !1, thenables: [] };
    }
    function mv(n) {
      return n = n.status, n === "fulfilled" || n === "rejected";
    }
    function bi(n, o, s) {
      Xe.actQueue !== null && (Xe.didUsePromise = !0);
      var h = n.thenables;
      if (s = h[s], s === void 0 ? h.push(o) : s !== o && (n.didWarnAboutUncachedPromise || (n.didWarnAboutUncachedPromise = !0, console.error(
        "A component was suspended by an uncached promise. Creating promises inside a Client Component or hook is not yet supported, except via a Suspense-compatible library or framework."
      )), o.then(tr, tr), o = s), o._debugInfo === void 0) {
        n = performance.now(), h = o.displayName;
        var y = {
          name: typeof h == "string" ? h : "Promise",
          start: n,
          end: n,
          value: o
        };
        o._debugInfo = [{ awaited: y }], o.status !== "fulfilled" && o.status !== "rejected" && (n = function() {
          y.end = performance.now();
        }, o.then(n, n));
      }
      switch (o.status) {
        case "fulfilled":
          return o.value;
        case "rejected":
          throw n = o.reason, vm(n), n;
        default:
          if (typeof o.status == "string")
            o.then(tr, tr);
          else {
            if (n = Lr, n !== null && 100 < n.shellSuspendCounter)
              throw Error(
                "An unknown Component is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server."
              );
            n = o, n.status = "pending", n.then(
              function(C) {
                if (o.status === "pending") {
                  var A = o;
                  A.status = "fulfilled", A.value = C;
                }
              },
              function(C) {
                if (o.status === "pending") {
                  var A = o;
                  A.status = "rejected", A.reason = C;
                }
              }
            );
          }
          switch (o.status) {
            case "fulfilled":
              return o.value;
            case "rejected":
              throw n = o.reason, vm(n), n;
          }
          throw kh = o, u1 = !0, a0;
      }
    }
    function yi(n) {
      try {
        return sT(n);
      } catch (o) {
        throw o !== null && typeof o == "object" && typeof o.then == "function" ? (kh = o, u1 = !0, a0) : o;
      }
    }
    function pc() {
      if (kh === null)
        throw Error(
          "Expected a suspended thenable. This is a bug in React. Please file an issue."
        );
      var n = kh;
      return kh = null, u1 = !1, n;
    }
    function vm(n) {
      if (n === a0 || n === cw)
        throw Error(
          "Hooks are not supported inside an async component. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server."
        );
    }
    function va(n) {
      var o = Nn;
      return n != null && (Nn = o === null ? n : o.concat(n)), o;
    }
    function Jo() {
      var n = Nn;
      if (n != null) {
        for (var o = n.length - 1; 0 <= o; o--)
          if (n[o].name != null) {
            var s = n[o].debugTask;
            if (s != null) return s;
          }
      }
      return null;
    }
    function Io(n, o, s) {
      for (var h = Object.keys(n.props), y = 0; y < h.length; y++) {
        var C = h[y];
        if (C !== "children" && C !== "key") {
          o === null && (o = fu(n, s.mode, 0), o._debugInfo = Nn, o.return = s), le(
            o,
            function(A) {
              console.error(
                "Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.",
                A
              );
            },
            C
          );
          break;
        }
      }
    }
    function yl(n) {
      var o = c1;
      return c1 += 1, o0 === null && (o0 = Op()), bi(o0, n, o);
    }
    function Zo(n, o) {
      o = o.props.ref, n.ref = o !== void 0 ? o : null;
    }
    function wl(n, o) {
      throw o.$$typeof === Ly ? Error(
        `A React Element from an older version of React was rendered. This is not supported. It can happen if:
- Multiple copies of the "react" package is used.
- A library pre-bundled an old copy of "react" or "react/jsx-runtime".
- A compiler tries to "inline" JSX instead of using the runtime.`
      ) : (n = Object.prototype.toString.call(o), Error(
        "Objects are not valid as a React child (found: " + (n === "[object Object]" ? "object with keys {" + Object.keys(o).join(", ") + "}" : n) + "). If you meant to render a collection of children, use an array instead."
      ));
    }
    function Qi(n, o) {
      var s = Jo();
      s !== null ? s.run(
        wl.bind(null, n, o)
      ) : wl(n, o);
    }
    function hv(n, o) {
      var s = W(n) || "Component";
      a8[s] || (a8[s] = !0, o = o.displayName || o.name || "Component", n.tag === 3 ? console.error(
        `Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.
  root.render(%s)`,
        o,
        o,
        o
      ) : console.error(
        `Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.
  <%s>{%s}</%s>`,
        o,
        o,
        s,
        o,
        s
      ));
    }
    function Pd(n, o) {
      var s = Jo();
      s !== null ? s.run(
        hv.bind(null, n, o)
      ) : hv(n, o);
    }
    function Tp(n, o) {
      var s = W(n) || "Component";
      o8[s] || (o8[s] = !0, o = String(o), n.tag === 3 ? console.error(
        `Symbols are not valid as a React child.
  root.render(%s)`,
        o
      ) : console.error(
        `Symbols are not valid as a React child.
  <%s>%s</%s>`,
        s,
        o,
        s
      ));
    }
    function bm(n, o) {
      var s = Jo();
      s !== null ? s.run(
        Tp.bind(null, n, o)
      ) : Tp(n, o);
    }
    function Ba(n) {
      function o(ue, he) {
        if (n) {
          var Se = ue.deletions;
          Se === null ? (ue.deletions = [he], ue.flags |= 16) : Se.push(he);
        }
      }
      function s(ue, he) {
        if (!n) return null;
        for (; he !== null; )
          o(ue, he), he = he.sibling;
        return null;
      }
      function h(ue) {
        for (var he = /* @__PURE__ */ new Map(); ue !== null; )
          ue.key !== null ? he.set(ue.key, ue) : he.set(ue.index, ue), ue = ue.sibling;
        return he;
      }
      function y(ue, he) {
        return ue = _l(ue, he), ue.index = 0, ue.sibling = null, ue;
      }
      function C(ue, he, Se) {
        return ue.index = Se, n ? (Se = ue.alternate, Se !== null ? (Se = Se.index, Se < he ? (ue.flags |= 67108866, he) : Se) : (ue.flags |= 67108866, he)) : (ue.flags |= 1048576, he);
      }
      function A(ue) {
        return n && ue.alternate === null && (ue.flags |= 67108866), ue;
      }
      function z(ue, he, Se, Ze) {
        return he === null || he.tag !== 6 ? (he = wd(
          Se,
          ue.mode,
          Ze
        ), he.return = ue, he._debugOwner = ue, he._debugTask = ue._debugTask, he._debugInfo = Nn, he) : (he = y(he, Se), he.return = ue, he._debugInfo = Nn, he);
      }
      function q(ue, he, Se, Ze) {
        var xt = Se.type;
        return xt === of ? (he = xe(
          ue,
          he,
          Se.props.children,
          Ze,
          Se.key
        ), Io(Se, he, ue), he) : he !== null && (he.elementType === xt || rv(he, Se) || typeof xt == "object" && xt !== null && xt.$$typeof === Eo && yi(xt) === he.type) ? (he = y(he, Se.props), Zo(he, Se), he.return = ue, he._debugOwner = Se._owner, he._debugInfo = Nn, he) : (he = fu(Se, ue.mode, Ze), Zo(he, Se), he.return = ue, he._debugInfo = Nn, he);
      }
      function Z(ue, he, Se, Ze) {
        return he === null || he.tag !== 4 || he.stateNode.containerInfo !== Se.containerInfo || he.stateNode.implementation !== Se.implementation ? (he = Sp(Se, ue.mode, Ze), he.return = ue, he._debugInfo = Nn, he) : (he = y(he, Se.children || []), he.return = ue, he._debugInfo = Nn, he);
      }
      function xe(ue, he, Se, Ze, xt) {
        return he === null || he.tag !== 7 ? (he = uc(
          Se,
          ue.mode,
          Ze,
          xt
        ), he.return = ue, he._debugOwner = ue, he._debugTask = ue._debugTask, he._debugInfo = Nn, he) : (he = y(he, Se), he.return = ue, he._debugInfo = Nn, he);
      }
      function ke(ue, he, Se) {
        if (typeof he == "string" && he !== "" || typeof he == "number" || typeof he == "bigint")
          return he = wd(
            "" + he,
            ue.mode,
            Se
          ), he.return = ue, he._debugOwner = ue, he._debugTask = ue._debugTask, he._debugInfo = Nn, he;
        if (typeof he == "object" && he !== null) {
          switch (he.$$typeof) {
            case nl:
              return Se = fu(
                he,
                ue.mode,
                Se
              ), Zo(Se, he), Se.return = ue, ue = va(he._debugInfo), Se._debugInfo = Nn, Nn = ue, Se;
            case Lu:
              return he = Sp(
                he,
                ue.mode,
                Se
              ), he.return = ue, he._debugInfo = Nn, he;
            case Eo:
              var Ze = va(he._debugInfo);
              return he = yi(he), ue = ke(ue, he, Se), Nn = Ze, ue;
          }
          if (Ta(he) || L(he))
            return Se = uc(
              he,
              ue.mode,
              Se,
              null
            ), Se.return = ue, Se._debugOwner = ue, Se._debugTask = ue._debugTask, ue = va(he._debugInfo), Se._debugInfo = Nn, Nn = ue, Se;
          if (typeof he.then == "function")
            return Ze = va(he._debugInfo), ue = ke(
              ue,
              yl(he),
              Se
            ), Nn = Ze, ue;
          if (he.$$typeof === Nl)
            return ke(
              ue,
              hm(ue, he),
              Se
            );
          Qi(ue, he);
        }
        return typeof he == "function" && Pd(ue, he), typeof he == "symbol" && bm(ue, he), null;
      }
      function de(ue, he, Se, Ze) {
        var xt = he !== null ? he.key : null;
        if (typeof Se == "string" && Se !== "" || typeof Se == "number" || typeof Se == "bigint")
          return xt !== null ? null : z(ue, he, "" + Se, Ze);
        if (typeof Se == "object" && Se !== null) {
          switch (Se.$$typeof) {
            case nl:
              return Se.key === xt ? (xt = va(Se._debugInfo), ue = q(
                ue,
                he,
                Se,
                Ze
              ), Nn = xt, ue) : null;
            case Lu:
              return Se.key === xt ? Z(ue, he, Se, Ze) : null;
            case Eo:
              return xt = va(Se._debugInfo), Se = yi(Se), ue = de(
                ue,
                he,
                Se,
                Ze
              ), Nn = xt, ue;
          }
          if (Ta(Se) || L(Se))
            return xt !== null ? null : (xt = va(Se._debugInfo), ue = xe(
              ue,
              he,
              Se,
              Ze,
              null
            ), Nn = xt, ue);
          if (typeof Se.then == "function")
            return xt = va(Se._debugInfo), ue = de(
              ue,
              he,
              yl(Se),
              Ze
            ), Nn = xt, ue;
          if (Se.$$typeof === Nl)
            return de(
              ue,
              he,
              hm(ue, Se),
              Ze
            );
          Qi(ue, Se);
        }
        return typeof Se == "function" && Pd(ue, Se), typeof Se == "symbol" && bm(ue, Se), null;
      }
      function Ve(ue, he, Se, Ze, xt) {
        if (typeof Ze == "string" && Ze !== "" || typeof Ze == "number" || typeof Ze == "bigint")
          return ue = ue.get(Se) || null, z(he, ue, "" + Ze, xt);
        if (typeof Ze == "object" && Ze !== null) {
          switch (Ze.$$typeof) {
            case nl:
              return Se = ue.get(
                Ze.key === null ? Se : Ze.key
              ) || null, ue = va(Ze._debugInfo), he = q(
                he,
                Se,
                Ze,
                xt
              ), Nn = ue, he;
            case Lu:
              return ue = ue.get(
                Ze.key === null ? Se : Ze.key
              ) || null, Z(he, ue, Ze, xt);
            case Eo:
              var cn = va(Ze._debugInfo);
              return Ze = yi(Ze), he = Ve(
                ue,
                he,
                Se,
                Ze,
                xt
              ), Nn = cn, he;
          }
          if (Ta(Ze) || L(Ze))
            return Se = ue.get(Se) || null, ue = va(Ze._debugInfo), he = xe(
              he,
              Se,
              Ze,
              xt,
              null
            ), Nn = ue, he;
          if (typeof Ze.then == "function")
            return cn = va(Ze._debugInfo), he = Ve(
              ue,
              he,
              Se,
              yl(Ze),
              xt
            ), Nn = cn, he;
          if (Ze.$$typeof === Nl)
            return Ve(
              ue,
              he,
              Se,
              hm(he, Ze),
              xt
            );
          Qi(he, Ze);
        }
        return typeof Ze == "function" && Pd(he, Ze), typeof Ze == "symbol" && bm(he, Ze), null;
      }
      function yt(ue, he, Se, Ze) {
        if (typeof Se != "object" || Se === null) return Ze;
        switch (Se.$$typeof) {
          case nl:
          case Lu:
            b(ue, he, Se);
            var xt = Se.key;
            if (typeof xt != "string") break;
            if (Ze === null) {
              Ze = /* @__PURE__ */ new Set(), Ze.add(xt);
              break;
            }
            if (!Ze.has(xt)) {
              Ze.add(xt);
              break;
            }
            le(he, function() {
              console.error(
                "Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.",
                xt
              );
            });
            break;
          case Eo:
            Se = yi(Se), yt(ue, he, Se, Ze);
        }
        return Ze;
      }
      function Mt(ue, he, Se, Ze) {
        for (var xt = null, cn = null, _t = null, Ht = he, kn = he = 0, Kr = null; Ht !== null && kn < Se.length; kn++) {
          Ht.index > kn ? (Kr = Ht, Ht = null) : Kr = Ht.sibling;
          var Fa = de(
            ue,
            Ht,
            Se[kn],
            Ze
          );
          if (Fa === null) {
            Ht === null && (Ht = Kr);
            break;
          }
          xt = yt(
            ue,
            Fa,
            Se[kn],
            xt
          ), n && Ht && Fa.alternate === null && o(ue, Ht), he = C(Fa, he, kn), _t === null ? cn = Fa : _t.sibling = Fa, _t = Fa, Ht = Kr;
        }
        if (kn === Se.length)
          return s(ue, Ht), Xn && gl(ue, kn), cn;
        if (Ht === null) {
          for (; kn < Se.length; kn++)
            Ht = ke(ue, Se[kn], Ze), Ht !== null && (xt = yt(
              ue,
              Ht,
              Se[kn],
              xt
            ), he = C(
              Ht,
              he,
              kn
            ), _t === null ? cn = Ht : _t.sibling = Ht, _t = Ht);
          return Xn && gl(ue, kn), cn;
        }
        for (Ht = h(Ht); kn < Se.length; kn++)
          Kr = Ve(
            Ht,
            ue,
            kn,
            Se[kn],
            Ze
          ), Kr !== null && (xt = yt(
            ue,
            Kr,
            Se[kn],
            xt
          ), n && Kr.alternate !== null && Ht.delete(
            Kr.key === null ? kn : Kr.key
          ), he = C(
            Kr,
            he,
            kn
          ), _t === null ? cn = Kr : _t.sibling = Kr, _t = Kr);
        return n && Ht.forEach(function(ad) {
          return o(ue, ad);
        }), Xn && gl(ue, kn), cn;
      }
      function Vr(ue, he, Se, Ze) {
        if (Se == null)
          throw Error("An iterable object provided no iterator.");
        for (var xt = null, cn = null, _t = he, Ht = he = 0, kn = null, Kr = null, Fa = Se.next(); _t !== null && !Fa.done; Ht++, Fa = Se.next()) {
          _t.index > Ht ? (kn = _t, _t = null) : kn = _t.sibling;
          var ad = de(ue, _t, Fa.value, Ze);
          if (ad === null) {
            _t === null && (_t = kn);
            break;
          }
          Kr = yt(
            ue,
            ad,
            Fa.value,
            Kr
          ), n && _t && ad.alternate === null && o(ue, _t), he = C(ad, he, Ht), cn === null ? xt = ad : cn.sibling = ad, cn = ad, _t = kn;
        }
        if (Fa.done)
          return s(ue, _t), Xn && gl(ue, Ht), xt;
        if (_t === null) {
          for (; !Fa.done; Ht++, Fa = Se.next())
            _t = ke(ue, Fa.value, Ze), _t !== null && (Kr = yt(
              ue,
              _t,
              Fa.value,
              Kr
            ), he = C(
              _t,
              he,
              Ht
            ), cn === null ? xt = _t : cn.sibling = _t, cn = _t);
          return Xn && gl(ue, Ht), xt;
        }
        for (_t = h(_t); !Fa.done; Ht++, Fa = Se.next())
          kn = Ve(
            _t,
            ue,
            Ht,
            Fa.value,
            Ze
          ), kn !== null && (Kr = yt(
            ue,
            kn,
            Fa.value,
            Kr
          ), n && kn.alternate !== null && _t.delete(
            kn.key === null ? Ht : kn.key
          ), he = C(
            kn,
            he,
            Ht
          ), cn === null ? xt = kn : cn.sibling = kn, cn = kn);
        return n && _t.forEach(function(NT) {
          return o(ue, NT);
        }), Xn && gl(ue, Ht), xt;
      }
      function Yn(ue, he, Se, Ze) {
        if (typeof Se == "object" && Se !== null && Se.type === of && Se.key === null && (Io(Se, null, ue), Se = Se.props.children), typeof Se == "object" && Se !== null) {
          switch (Se.$$typeof) {
            case nl:
              var xt = va(Se._debugInfo);
              e: {
                for (var cn = Se.key; he !== null; ) {
                  if (he.key === cn) {
                    if (cn = Se.type, cn === of) {
                      if (he.tag === 7) {
                        s(
                          ue,
                          he.sibling
                        ), Ze = y(
                          he,
                          Se.props.children
                        ), Ze.return = ue, Ze._debugOwner = Se._owner, Ze._debugInfo = Nn, Io(Se, Ze, ue), ue = Ze;
                        break e;
                      }
                    } else if (he.elementType === cn || rv(
                      he,
                      Se
                    ) || typeof cn == "object" && cn !== null && cn.$$typeof === Eo && yi(cn) === he.type) {
                      s(
                        ue,
                        he.sibling
                      ), Ze = y(he, Se.props), Zo(Ze, Se), Ze.return = ue, Ze._debugOwner = Se._owner, Ze._debugInfo = Nn, ue = Ze;
                      break e;
                    }
                    s(ue, he);
                    break;
                  } else o(ue, he);
                  he = he.sibling;
                }
                Se.type === of ? (Ze = uc(
                  Se.props.children,
                  ue.mode,
                  Ze,
                  Se.key
                ), Ze.return = ue, Ze._debugOwner = ue, Ze._debugTask = ue._debugTask, Ze._debugInfo = Nn, Io(Se, Ze, ue), ue = Ze) : (Ze = fu(
                  Se,
                  ue.mode,
                  Ze
                ), Zo(Ze, Se), Ze.return = ue, Ze._debugInfo = Nn, ue = Ze);
              }
              return ue = A(ue), Nn = xt, ue;
            case Lu:
              e: {
                for (xt = Se, Se = xt.key; he !== null; ) {
                  if (he.key === Se)
                    if (he.tag === 4 && he.stateNode.containerInfo === xt.containerInfo && he.stateNode.implementation === xt.implementation) {
                      s(
                        ue,
                        he.sibling
                      ), Ze = y(
                        he,
                        xt.children || []
                      ), Ze.return = ue, ue = Ze;
                      break e;
                    } else {
                      s(ue, he);
                      break;
                    }
                  else o(ue, he);
                  he = he.sibling;
                }
                Ze = Sp(
                  xt,
                  ue.mode,
                  Ze
                ), Ze.return = ue, ue = Ze;
              }
              return A(ue);
            case Eo:
              return xt = va(Se._debugInfo), Se = yi(Se), ue = Yn(
                ue,
                he,
                Se,
                Ze
              ), Nn = xt, ue;
          }
          if (Ta(Se))
            return xt = va(Se._debugInfo), ue = Mt(
              ue,
              he,
              Se,
              Ze
            ), Nn = xt, ue;
          if (L(Se)) {
            if (xt = va(Se._debugInfo), cn = L(Se), typeof cn != "function")
              throw Error(
                "An object is not an iterable. This error is likely caused by a bug in React. Please file an issue."
              );
            var _t = cn.call(Se);
            return _t === Se ? (ue.tag !== 0 || Object.prototype.toString.call(ue.type) !== "[object GeneratorFunction]" || Object.prototype.toString.call(_t) !== "[object Generator]") && (n8 || console.error(
              "Using Iterators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. You can also use an Iterable that can iterate multiple times over the same items."
            ), n8 = !0) : Se.entries !== cn || QC || (console.error(
              "Using Maps as children is not supported. Use an array of keyed ReactElements instead."
            ), QC = !0), ue = Vr(
              ue,
              he,
              _t,
              Ze
            ), Nn = xt, ue;
          }
          if (typeof Se.then == "function")
            return xt = va(Se._debugInfo), ue = Yn(
              ue,
              he,
              yl(Se),
              Ze
            ), Nn = xt, ue;
          if (Se.$$typeof === Nl)
            return Yn(
              ue,
              he,
              hm(ue, Se),
              Ze
            );
          Qi(ue, Se);
        }
        return typeof Se == "string" && Se !== "" || typeof Se == "number" || typeof Se == "bigint" ? (xt = "" + Se, he !== null && he.tag === 6 ? (s(
          ue,
          he.sibling
        ), Ze = y(he, xt), Ze.return = ue, ue = Ze) : (s(ue, he), Ze = wd(
          xt,
          ue.mode,
          Ze
        ), Ze.return = ue, Ze._debugOwner = ue, Ze._debugTask = ue._debugTask, Ze._debugInfo = Nn, ue = Ze), A(ue)) : (typeof Se == "function" && Pd(ue, Se), typeof Se == "symbol" && bm(ue, Se), s(ue, he));
      }
      return function(ue, he, Se, Ze) {
        var xt = Nn;
        Nn = null;
        try {
          c1 = 0;
          var cn = Yn(
            ue,
            he,
            Se,
            Ze
          );
          return o0 = null, cn;
        } catch (Kr) {
          if (Kr === a0 || Kr === cw) throw Kr;
          var _t = x(29, Kr, null, ue.mode);
          _t.lanes = Ze, _t.return = ue;
          var Ht = _t._debugInfo = Nn;
          if (_t._debugOwner = ue._debugOwner, _t._debugTask = ue._debugTask, Ht != null) {
            for (var kn = Ht.length - 1; 0 <= kn; kn--)
              if (typeof Ht[kn].stack == "string") {
                _t._debugOwner = Ht[kn], _t._debugTask = Ht[kn].debugTask;
                break;
              }
          }
          return _t;
        } finally {
          Nn = xt;
        }
      };
    }
    function $r(n, o) {
      var s = Ta(n);
      return n = !s && typeof L(n) == "function", s || n ? (s = s ? "array" : "iterable", console.error(
        "A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>",
        s,
        o,
        s
      ), !1) : !0;
    }
    function _n(n) {
      n.updateQueue = {
        baseState: n.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: { pending: null, lanes: 0, hiddenCallbacks: null },
        callbacks: null
      };
    }
    function Xl(n, o) {
      n = n.updateQueue, o.updateQueue === n && (o.updateQueue = {
        baseState: n.baseState,
        firstBaseUpdate: n.firstBaseUpdate,
        lastBaseUpdate: n.lastBaseUpdate,
        shared: n.shared,
        callbacks: null
      });
    }
    function $a(n) {
      return {
        lane: n,
        tag: l8,
        payload: null,
        callback: null,
        next: null
      };
    }
    function Gl(n, o, s) {
      var h = n.updateQueue;
      if (h === null) return null;
      if (h = h.shared, ZC === h && !c8) {
        var y = W(n);
        console.error(
          `An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.

Please update the following component: %s`,
          y
        ), c8 = !0;
      }
      return (ar & po) !== Oo ? (y = h.pending, y === null ? o.next = o : (o.next = y.next, y.next = o), h.pending = o, o = dm(n), nv(n, null, s), o) : (yd(n, h, o, s), dm(n));
    }
    function Ji(n, o, s) {
      if (o = o.updateQueue, o !== null && (o = o.shared, (s & 4194048) !== 0)) {
        var h = o.lanes;
        h &= n.pendingLanes, s |= h, o.lanes = s, ct(n, s);
      }
    }
    function ym(n, o) {
      var s = n.updateQueue, h = n.alternate;
      if (h !== null && (h = h.updateQueue, s === h)) {
        var y = null, C = null;
        if (s = s.firstBaseUpdate, s !== null) {
          do {
            var A = {
              lane: s.lane,
              tag: s.tag,
              payload: s.payload,
              callback: null,
              next: null
            };
            C === null ? y = C = A : C = C.next = A, s = s.next;
          } while (s !== null);
          C === null ? y = C = o : C = C.next = o;
        } else y = C = o;
        s = {
          baseState: h.baseState,
          firstBaseUpdate: y,
          lastBaseUpdate: C,
          shared: h.shared,
          callbacks: h.callbacks
        }, n.updateQueue = s;
        return;
      }
      n = s.lastBaseUpdate, n === null ? s.firstBaseUpdate = o : n.next = o, s.lastBaseUpdate = o;
    }
    function kd() {
      if (e4) {
        var n = r0;
        if (n !== null) throw n;
      }
    }
    function ql(n, o, s, h) {
      e4 = !1;
      var y = n.updateQueue;
      Mf = !1, ZC = y.shared;
      var C = y.firstBaseUpdate, A = y.lastBaseUpdate, z = y.shared.pending;
      if (z !== null) {
        y.shared.pending = null;
        var q = z, Z = q.next;
        q.next = null, A === null ? C = Z : A.next = Z, A = q;
        var xe = n.alternate;
        xe !== null && (xe = xe.updateQueue, z = xe.lastBaseUpdate, z !== A && (z === null ? xe.firstBaseUpdate = Z : z.next = Z, xe.lastBaseUpdate = q));
      }
      if (C !== null) {
        var ke = y.baseState;
        A = 0, xe = Z = q = null, z = C;
        do {
          var de = z.lane & -536870913, Ve = de !== z.lane;
          if (Ve ? (Dn & de) === de : (h & de) === de) {
            de !== 0 && de === xh && (e4 = !0), xe !== null && (xe = xe.next = {
              lane: 0,
              tag: z.tag,
              payload: z.payload,
              callback: null,
              next: null
            });
            e: {
              de = n;
              var yt = z, Mt = o, Vr = s;
              switch (yt.tag) {
                case s8:
                  if (yt = yt.payload, typeof yt == "function") {
                    t0 = !0;
                    var Yn = yt.call(
                      Vr,
                      ke,
                      Mt
                    );
                    if (de.mode & ii) {
                      Oe(!0);
                      try {
                        yt.call(Vr, ke, Mt);
                      } finally {
                        Oe(!1);
                      }
                    }
                    t0 = !1, ke = Yn;
                    break e;
                  }
                  ke = yt;
                  break e;
                case JC:
                  de.flags = de.flags & -65537 | 128;
                case l8:
                  if (Yn = yt.payload, typeof Yn == "function") {
                    if (t0 = !0, yt = Yn.call(
                      Vr,
                      ke,
                      Mt
                    ), de.mode & ii) {
                      Oe(!0);
                      try {
                        Yn.call(Vr, ke, Mt);
                      } finally {
                        Oe(!1);
                      }
                    }
                    t0 = !1;
                  } else yt = Yn;
                  if (yt == null) break e;
                  ke = Rn({}, ke, yt);
                  break e;
                case u8:
                  Mf = !0;
              }
            }
            de = z.callback, de !== null && (n.flags |= 64, Ve && (n.flags |= 8192), Ve = y.callbacks, Ve === null ? y.callbacks = [de] : Ve.push(de));
          } else
            Ve = {
              lane: de,
              tag: z.tag,
              payload: z.payload,
              callback: z.callback,
              next: null
            }, xe === null ? (Z = xe = Ve, q = ke) : xe = xe.next = Ve, A |= de;
          if (z = z.next, z === null) {
            if (z = y.shared.pending, z === null)
              break;
            Ve = z, z = Ve.next, Ve.next = null, y.lastBaseUpdate = Ve, y.shared.pending = null;
          }
        } while (!0);
        xe === null && (q = ke), y.baseState = q, y.firstBaseUpdate = Z, y.lastBaseUpdate = xe, C === null && (y.shared.lanes = 0), Rf |= A, n.lanes = A, n.memoizedState = ke;
      }
      ZC = null;
    }
    function vu(n, o) {
      if (typeof n != "function")
        throw Error(
          "Invalid argument passed as callback. Expected a function. Instead received: " + n
        );
      n.call(o);
    }
    function pv(n, o) {
      var s = n.shared.hiddenCallbacks;
      if (s !== null)
        for (n.shared.hiddenCallbacks = null, n = 0; n < s.length; n++)
          vu(s[n], o);
    }
    function Md(n, o) {
      var s = n.callbacks;
      if (s !== null)
        for (n.callbacks = null, n = 0; n < s.length; n++)
          vu(s[n], o);
    }
    function Rp(n, o) {
      var s = Xu;
      Y(fw, s, n), Y(i0, o, n), Xu = s | o.baseLanes;
    }
    function zs(n) {
      Y(fw, Xu, n), Y(
        i0,
        i0.current,
        n
      );
    }
    function Sl(n) {
      Xu = fw.current, U(i0, n), U(fw, n);
    }
    function Lo(n) {
      var o = n.alternate;
      Y(
        Ha,
        Ha.current & l0,
        n
      ), Y(jl, n, n), Ms === null && (o === null || i0.current !== null || o.memoizedState !== null) && (Ms = n);
    }
    function Cl(n) {
      Y(Ha, Ha.current, n), Y(jl, n, n), Ms === null && (Ms = n);
    }
    function Ap(n) {
      n.tag === 22 ? (Y(Ha, Ha.current, n), Y(jl, n, n), Ms === null && (Ms = n)) : Kl(n);
    }
    function Kl(n) {
      Y(Ha, Ha.current, n), Y(
        jl,
        jl.current,
        n
      );
    }
    function Ua(n) {
      U(jl, n), Ms === n && (Ms = null), U(Ha, n);
    }
    function gc(n) {
      for (var o = n; o !== null; ) {
        if (o.tag === 13) {
          var s = o.memoizedState;
          if (s !== null && (s = s.dehydrated, s === null || th(s) || f2(s)))
            return o;
        } else if (o.tag === 19 && (o.memoizedProps.revealOrder === "forwards" || o.memoizedProps.revealOrder === "backwards" || o.memoizedProps.revealOrder === "unstable_legacy-backwards" || o.memoizedProps.revealOrder === "together")) {
          if ((o.flags & 128) !== 0) return o;
        } else if (o.child !== null) {
          o.child.return = o, o = o.child;
          continue;
        }
        if (o === n) break;
        for (; o.sibling === null; ) {
          if (o.return === null || o.return === n) return null;
          o = o.return;
        }
        o.sibling.return = o.return, o = o.sibling;
      }
      return null;
    }
    function sn() {
      var n = Be;
      xs === null ? xs = [n] : xs.push(n);
    }
    function rt() {
      var n = Be;
      if (xs !== null && (ed++, xs[ed] !== n)) {
        var o = W(un);
        if (!d8.has(o) && (d8.add(o), xs !== null)) {
          for (var s = "", h = 0; h <= ed; h++) {
            var y = xs[h], C = h === ed ? n : y;
            for (y = h + 1 + ". " + y; 30 > y.length; )
              y += " ";
            y += C + `
`, s += y;
          }
          console.error(
            `React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://react.dev/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`,
            o,
            s
          );
        }
      }
    }
    function js(n) {
      n == null || Ta(n) || console.error(
        "%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.",
        Be,
        typeof n
      );
    }
    function wm() {
      var n = W(un);
      m8.has(n) || (m8.add(n), console.error(
        "ReactDOM.useFormState has been renamed to React.useActionState. Please update %s to use React.useActionState.",
        n
      ));
    }
    function da() {
      throw Error(
        `Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.`
      );
    }
    function gv(n, o) {
      if (m1) return !1;
      if (o === null)
        return console.error(
          "%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.",
          Be
        ), !1;
      n.length !== o.length && console.error(
        `The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`,
        Be,
        "[" + o.join(", ") + "]",
        "[" + n.join(", ") + "]"
      );
      for (var s = 0; s < o.length && s < n.length; s++)
        if (!Ai(n[s], o[s])) return !1;
      return !0;
    }
    function vv(n, o, s, h, y, C) {
      Jc = C, un = o, xs = n !== null ? n._debugHookTypes : null, ed = -1, m1 = n !== null && n.type !== o.type, (Object.prototype.toString.call(s) === "[object AsyncFunction]" || Object.prototype.toString.call(s) === "[object AsyncGeneratorFunction]") && (C = W(un), t4.has(C) || (t4.add(C), console.error(
        "%s is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server.",
        C === null ? "An unknown Component" : "<" + C + ">"
      ))), o.memoizedState = null, o.updateQueue = null, o.lanes = 0, Xe.H = n !== null && n.memoizedState !== null ? r4 : xs !== null ? h8 : n4, Oh = C = (o.mode & ii) !== on;
      var A = qC(s, h, y);
      if (Oh = !1, u0 && (A = Sm(
        o,
        s,
        h,
        y
      )), C) {
        Oe(!0);
        try {
          A = Sm(
            o,
            s,
            h,
            y
          );
        } finally {
          Oe(!1);
        }
      }
      return ba(n, o), A;
    }
    function ba(n, o) {
      o._debugHookTypes = xs, o.dependencies === null ? Zc !== null && (o.dependencies = {
        lanes: 0,
        firstContext: null,
        _debugThenableState: Zc
      }) : o.dependencies._debugThenableState = Zc, Xe.H = h1;
      var s = Ir !== null && Ir.next !== null;
      if (Jc = 0, xs = Be = Ja = Ir = un = null, ed = -1, n !== null && (n.flags & 65011712) !== (o.flags & 65011712) && console.error(
        "Internal React error: Expected static flag was missing. Please notify the React team."
      ), hw = !1, f1 = 0, Zc = null, s)
        throw Error(
          "Rendered fewer hooks than expected. This may be caused by an accidental early return statement."
        );
      n === null || Za || (n = n.dependencies, n !== null && Cd(n) && (Za = !0)), u1 ? (u1 = !1, n = !0) : n = !1, n && (o = W(o) || "Unknown", f8.has(o) || t4.has(o) || (f8.add(o), console.error(
        "`use` was called from inside a try/catch block. This is not allowed and can lead to unexpected behavior. To handle errors triggered by `use`, wrap your component in a error boundary."
      )));
    }
    function Sm(n, o, s, h) {
      un = n;
      var y = 0;
      do {
        if (u0 && (Zc = null), f1 = 0, u0 = !1, y >= cT)
          throw Error(
            "Too many re-renders. React limits the number of renders to prevent an infinite loop."
          );
        if (y += 1, m1 = !1, Ja = Ir = null, n.updateQueue != null) {
          var C = n.updateQueue;
          C.lastEffect = null, C.events = null, C.stores = null, C.memoCache != null && (C.memoCache.index = 0);
        }
        ed = -1, Xe.H = p8, C = qC(o, s, h);
      } while (u0);
      return C;
    }
    function Cm() {
      var n = Xe.H, o = n.useState()[0];
      return o = typeof o.then == "function" ? Pm(o) : o, n = n.useState()[0], (Ir !== null ? Ir.memoizedState : null) !== n && (un.flags |= 1024), o;
    }
    function vc() {
      var n = pw !== 0;
      return pw = 0, n;
    }
    function xm(n, o, s) {
      o.updateQueue = n.updateQueue, o.flags = (o.mode & Qs) !== on ? o.flags & -402655237 : o.flags & -2053, n.lanes &= ~s;
    }
    function bu(n) {
      if (hw) {
        for (n = n.memoizedState; n !== null; ) {
          var o = n.queue;
          o !== null && (o.pending = null), n = n.next;
        }
        hw = !1;
      }
      Jc = 0, xs = Ja = Ir = un = null, ed = -1, Be = null, u0 = !1, f1 = pw = 0, Zc = null;
    }
    function Ma() {
      var n = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return Ja === null ? un.memoizedState = Ja = n : Ja = Ja.next = n, Ja;
    }
    function gr() {
      if (Ir === null) {
        var n = un.alternate;
        n = n !== null ? n.memoizedState : null;
      } else n = Ir.next;
      var o = Ja === null ? un.memoizedState : Ja.next;
      if (o !== null)
        Ja = o, Ir = n;
      else {
        if (n === null)
          throw un.alternate === null ? Error(
            "Update hook called on initial render. This is likely a bug in React. Please file an issue."
          ) : Error("Rendered more hooks than during the previous render.");
        Ir = n, n = {
          memoizedState: Ir.memoizedState,
          baseState: Ir.baseState,
          baseQueue: Ir.baseQueue,
          queue: Ir.queue,
          next: null
        }, Ja === null ? un.memoizedState = Ja = n : Ja = Ja.next = n;
      }
      return Ja;
    }
    function Em() {
      return { lastEffect: null, events: null, stores: null, memoCache: null };
    }
    function Pm(n) {
      var o = f1;
      return f1 += 1, Zc === null && (Zc = Op()), n = bi(Zc, n, o), o = un, (Ja === null ? o.memoizedState : Ja.next) === null && (o = o.alternate, Xe.H = o !== null && o.memoizedState !== null ? r4 : n4), n;
    }
    function Is(n) {
      if (n !== null && typeof n == "object") {
        if (typeof n.then == "function") return Pm(n);
        if (n.$$typeof === Nl) return cr(n);
      }
      throw Error("An unsupported type was passed to use(): " + String(n));
    }
    function wi(n) {
      var o = null, s = un.updateQueue;
      if (s !== null && (o = s.memoCache), o == null) {
        var h = un.alternate;
        h !== null && (h = h.updateQueue, h !== null && (h = h.memoCache, h != null && (o = {
          data: h.data.map(function(y) {
            return y.slice();
          }),
          index: 0
        })));
      }
      if (o == null && (o = { data: [], index: 0 }), s === null && (s = Em(), un.updateQueue = s), s.memoCache = o, s = o.data[o.index], s === void 0 || m1)
        for (s = o.data[o.index] = Array(n), h = 0; h < n; h++)
          s[h] = SC;
      else
        s.length !== n && console.error(
          "Expected a constant size argument for each invocation of useMemoCache. The previous cache was allocated with size %s but size %s was requested.",
          s.length,
          n
        );
      return o.index++, s;
    }
    function Si(n, o) {
      return typeof o == "function" ? o(n) : o;
    }
    function Od(n, o, s) {
      var h = Ma();
      if (s !== void 0) {
        var y = s(o);
        if (Oh) {
          Oe(!0);
          try {
            s(o);
          } finally {
            Oe(!1);
          }
        }
      } else y = o;
      return h.memoizedState = h.baseState = y, n = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: n,
        lastRenderedState: y
      }, h.queue = n, n = n.dispatch = gC.bind(
        null,
        un,
        n
      ), [h.memoizedState, n];
    }
    function bc(n) {
      var o = gr();
      return yu(o, Ir, n);
    }
    function yu(n, o, s) {
      var h = n.queue;
      if (h === null)
        throw Error(
          "Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)"
        );
      h.lastRenderedReducer = s;
      var y = n.baseQueue, C = h.pending;
      if (C !== null) {
        if (y !== null) {
          var A = y.next;
          y.next = C.next, C.next = A;
        }
        o.baseQueue !== y && console.error(
          "Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."
        ), o.baseQueue = y = C, h.pending = null;
      }
      if (C = n.baseState, y === null) n.memoizedState = C;
      else {
        o = y.next;
        var z = A = null, q = null, Z = o, xe = !1;
        do {
          var ke = Z.lane & -536870913;
          if (ke !== Z.lane ? (Dn & ke) === ke : (Jc & ke) === ke) {
            var de = Z.revertLane;
            if (de === 0)
              q !== null && (q = q.next = {
                lane: 0,
                revertLane: 0,
                gesture: null,
                action: Z.action,
                hasEagerState: Z.hasEagerState,
                eagerState: Z.eagerState,
                next: null
              }), ke === xh && (xe = !0);
            else if ((Jc & de) === de) {
              Z = Z.next, de === xh && (xe = !0);
              continue;
            } else
              ke = {
                lane: 0,
                revertLane: Z.revertLane,
                gesture: null,
                action: Z.action,
                hasEagerState: Z.hasEagerState,
                eagerState: Z.eagerState,
                next: null
              }, q === null ? (z = q = ke, A = C) : q = q.next = ke, un.lanes |= de, Rf |= de;
            ke = Z.action, Oh && s(C, ke), C = Z.hasEagerState ? Z.eagerState : s(C, ke);
          } else
            de = {
              lane: ke,
              revertLane: Z.revertLane,
              gesture: Z.gesture,
              action: Z.action,
              hasEagerState: Z.hasEagerState,
              eagerState: Z.eagerState,
              next: null
            }, q === null ? (z = q = de, A = C) : q = q.next = de, un.lanes |= ke, Rf |= ke;
          Z = Z.next;
        } while (Z !== null && Z !== o);
        if (q === null ? A = C : q.next = z, !Ai(C, n.memoizedState) && (Za = !0, xe && (s = r0, s !== null)))
          throw s;
        n.memoizedState = C, n.baseState = A, n.baseQueue = q, h.lastRenderedState = C;
      }
      return y === null && (h.lanes = 0), [n.memoizedState, h.dispatch];
    }
    function yc(n) {
      var o = gr(), s = o.queue;
      if (s === null)
        throw Error(
          "Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)"
        );
      s.lastRenderedReducer = n;
      var h = s.dispatch, y = s.pending, C = o.memoizedState;
      if (y !== null) {
        s.pending = null;
        var A = y = y.next;
        do
          C = n(C, A.action), A = A.next;
        while (A !== y);
        Ai(C, o.memoizedState) || (Za = !0), o.memoizedState = C, o.baseQueue === null && (o.baseState = C), s.lastRenderedState = C;
      }
      return [C, h];
    }
    function Td(n, o, s) {
      var h = un, y = Ma();
      if (Xn) {
        if (s === void 0)
          throw Error(
            "Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering."
          );
        var C = s();
        s0 || C === s() || (console.error(
          "The result of getServerSnapshot should be cached to avoid an infinite loop"
        ), s0 = !0);
      } else {
        if (C = o(), s0 || (s = o(), Ai(C, s) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), s0 = !0)), Lr === null)
          throw Error(
            "Expected a work-in-progress root. This is a bug in React. Please file an issue."
          );
        (Dn & 127) !== 0 || bv(h, o, C);
      }
      return y.memoizedState = C, s = { value: C, getSnapshot: o }, y.queue = s, Cc(
        wu.bind(null, h, s, n),
        [n]
      ), h.flags |= 2048, Yl(
        Cs | $i,
        { destroy: void 0 },
        yv.bind(
          null,
          h,
          s,
          C,
          o
        ),
        null
      ), C;
    }
    function wc(n, o, s) {
      var h = un, y = gr(), C = Xn;
      if (C) {
        if (s === void 0)
          throw Error(
            "Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering."
          );
        s = s();
      } else if (s = o(), !s0) {
        var A = o();
        Ai(s, A) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), s0 = !0);
      }
      (A = !Ai(
        (Ir || y).memoizedState,
        s
      )) && (y.memoizedState = s, Za = !0), y = y.queue;
      var z = wu.bind(null, h, y, n);
      if (za(2048, $i, z, [n]), y.getSnapshot !== o || A || Ja !== null && Ja.memoizedState.tag & Cs) {
        if (h.flags |= 2048, Yl(
          Cs | $i,
          { destroy: void 0 },
          yv.bind(
            null,
            h,
            y,
            s,
            o
          ),
          null
        ), Lr === null)
          throw Error(
            "Expected a work-in-progress root. This is a bug in React. Please file an issue."
          );
        C || (Jc & 127) !== 0 || bv(h, o, s);
      }
      return s;
    }
    function bv(n, o, s) {
      n.flags |= 16384, n = { getSnapshot: o, value: s }, o = un.updateQueue, o === null ? (o = Em(), un.updateQueue = o, o.stores = [n]) : (s = o.stores, s === null ? o.stores = [n] : s.push(n));
    }
    function yv(n, o, s, h) {
      o.value = s, o.getSnapshot = h, Su(o) && wv(n);
    }
    function wu(n, o, s) {
      return s(function() {
        Su(o) && (Bl(2, "updateSyncExternalStore()", n), wv(n));
      });
    }
    function Su(n) {
      var o = n.getSnapshot;
      n = n.value;
      try {
        var s = o();
        return !Ai(n, s);
      } catch {
        return !0;
      }
    }
    function wv(n) {
      var o = So(n, 2);
      o !== null && ln(o, n, 2);
    }
    function Np(n) {
      var o = Ma();
      if (typeof n == "function") {
        var s = n;
        if (n = s(), Oh) {
          Oe(!0);
          try {
            s();
          } finally {
            Oe(!1);
          }
        }
      }
      return o.memoizedState = o.baseState = n, o.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Si,
        lastRenderedState: n
      }, o;
    }
    function Cu(n) {
      n = Np(n);
      var o = n.queue, s = Lp.bind(null, un, o);
      return o.dispatch = s, [n.memoizedState, s];
    }
    function Sc(n) {
      var o = Ma();
      o.memoizedState = o.baseState = n;
      var s = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
      };
      return o.queue = s, o = Nm.bind(
        null,
        un,
        !0,
        s
      ), s.dispatch = o, [n, o];
    }
    function km(n, o) {
      var s = gr();
      return Rd(s, Ir, n, o);
    }
    function Rd(n, o, s, h) {
      return n.baseState = s, yu(
        n,
        Ir,
        typeof h == "function" ? h : Si
      );
    }
    function Mm(n, o) {
      var s = gr();
      return Ir !== null ? Rd(s, Ir, n, o) : (s.baseState = n, [n, s.queue.dispatch]);
    }
    function _b(n, o, s, h, y) {
      if (Xa(n))
        throw Error("Cannot update form state while rendering.");
      if (n = o.action, n !== null) {
        var C = {
          payload: y,
          action: n,
          next: null,
          isTransition: !0,
          status: "pending",
          value: null,
          reason: null,
          listeners: [],
          then: function(A) {
            C.listeners.push(A);
          }
        };
        Xe.T !== null ? s(!0) : C.isTransition = !1, h(C), s = o.pending, s === null ? (C.next = o.pending = C, xu(o, C)) : (C.next = s.next, o.pending = s.next = C);
      }
    }
    function xu(n, o) {
      var s = o.action, h = o.payload, y = n.state;
      if (o.isTransition) {
        var C = Xe.T, A = {};
        A._updatedFibers = /* @__PURE__ */ new Set(), Xe.T = A;
        try {
          var z = s(y, h), q = Xe.S;
          q !== null && q(A, z), Sv(n, o, z);
        } catch (Z) {
          Om(n, o, Z);
        } finally {
          C !== null && A.types !== null && (C.types !== null && C.types !== A.types && console.error(
            "We expected inner Transitions to have transferred the outer types set and that you cannot add to the outer Transition while inside the inner.This is a bug in React."
          ), C.types = A.types), Xe.T = C, C === null && A._updatedFibers && (n = A._updatedFibers.size, A._updatedFibers.clear(), 10 < n && console.warn(
            "Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."
          ));
        }
      } else
        try {
          A = s(y, h), Sv(n, o, A);
        } catch (Z) {
          Om(n, o, Z);
        }
    }
    function Sv(n, o, s) {
      s !== null && typeof s == "object" && typeof s.then == "function" ? (Xe.asyncTransitions++, s.then(xc, xc), s.then(
        function(h) {
          Ls(n, o, h);
        },
        function(h) {
          return Om(n, o, h);
        }
      ), o.isTransition || console.error(
        "An async function with useActionState was called outside of a transition. This is likely not what you intended (for example, isPending will not update correctly). Either call the returned function inside startTransition, or pass it to an `action` or `formAction` prop."
      )) : Ls(n, o, s);
    }
    function Ls(n, o, s) {
      o.status = "fulfilled", o.value = s, Dp(o), n.state = s, o = n.pending, o !== null && (s = o.next, s === o ? n.pending = null : (s = s.next, o.next = s, xu(n, s)));
    }
    function Om(n, o, s) {
      var h = n.pending;
      if (n.pending = null, h !== null) {
        h = h.next;
        do
          o.status = "rejected", o.reason = s, Dp(o), o = o.next;
        while (o !== h);
      }
      n.action = null;
    }
    function Dp(n) {
      n = n.listeners;
      for (var o = 0; o < n.length; o++) (0, n[o])();
    }
    function Hs(n, o) {
      return o;
    }
    function Ci(n, o) {
      if (Xn) {
        var s = Lr.formState;
        if (s !== null) {
          e: {
            var h = un;
            if (Xn) {
              if (qr) {
                t: {
                  for (var y = qr, C = ws; y.nodeType !== 8; ) {
                    if (!C) {
                      y = null;
                      break t;
                    }
                    if (y = Mi(
                      y.nextSibling
                    ), y === null) {
                      y = null;
                      break t;
                    }
                  }
                  C = y.data, y = C === k4 || C === e5 ? y : null;
                }
                if (y) {
                  qr = Mi(
                    y.nextSibling
                  ), h = y.data === k4;
                  break e;
                }
              }
              Gi(h);
            }
            h = !1;
          }
          h && (o = s[0]);
        }
      }
      return s = Ma(), s.memoizedState = s.baseState = o, h = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Hs,
        lastRenderedState: o
      }, s.queue = h, s = Lp.bind(
        null,
        un,
        h
      ), h.dispatch = s, h = Np(!1), C = Nm.bind(
        null,
        un,
        !1,
        h.queue
      ), h = Ma(), y = {
        state: o,
        dispatch: null,
        action: n,
        pending: null
      }, h.queue = y, s = _b.bind(
        null,
        un,
        y,
        C,
        s
      ), y.dispatch = s, h.memoizedState = n, [o, s, !1];
    }
    function Eu(n) {
      var o = gr();
      return $p(o, Ir, n);
    }
    function $p(n, o, s) {
      if (o = yu(
        n,
        o,
        Hs
      )[0], n = bc(Si)[0], typeof o == "object" && o !== null && typeof o.then == "function")
        try {
          var h = Pm(o);
        } catch (A) {
          throw A === a0 ? cw : A;
        }
      else h = o;
      o = gr();
      var y = o.queue, C = y.dispatch;
      return s !== o.memoizedState && (un.flags |= 2048, Yl(
        Cs | $i,
        { destroy: void 0 },
        Cv.bind(null, y, s),
        null
      )), [h, C, n];
    }
    function Cv(n, o) {
      n.action = o;
    }
    function Pu(n) {
      var o = gr(), s = Ir;
      if (s !== null)
        return $p(o, s, n);
      gr(), o = o.memoizedState, s = gr();
      var h = s.queue.dispatch;
      return s.memoizedState = n, [o, h, !1];
    }
    function Yl(n, o, s, h) {
      return n = { tag: n, create: s, deps: h, inst: o, next: null }, o = un.updateQueue, o === null && (o = Em(), un.updateQueue = o), s = o.lastEffect, s === null ? o.lastEffect = n.next = n : (h = s.next, s.next = n, n.next = h, o.lastEffect = n), n;
    }
    function zp(n) {
      var o = Ma();
      return n = { current: n }, o.memoizedState = n;
    }
    function ku(n, o, s, h) {
      var y = Ma();
      un.flags |= n, y.memoizedState = Yl(
        Cs | o,
        { destroy: void 0 },
        s,
        h === void 0 ? null : h
      );
    }
    function za(n, o, s, h) {
      var y = gr();
      h = h === void 0 ? null : h;
      var C = y.memoizedState.inst;
      Ir !== null && h !== null && gv(h, Ir.memoizedState.deps) ? y.memoizedState = Yl(o, C, s, h) : (un.flags |= n, y.memoizedState = Yl(
        Cs | o,
        C,
        s,
        h
      ));
    }
    function Cc(n, o) {
      (un.mode & Qs) !== on ? ku(276826112, $i, n, o) : ku(8390656, $i, n, o);
    }
    function Bb(n) {
      un.flags |= 4;
      var o = un.updateQueue;
      if (o === null)
        o = Em(), un.updateQueue = o, o.events = [n];
      else {
        var s = o.events;
        s === null ? o.events = [n] : s.push(n);
      }
    }
    function Tm(n) {
      var o = Ma(), s = { impl: n };
      return o.memoizedState = s, function() {
        if ((ar & po) !== Oo)
          throw Error(
            "A function wrapped in useEffectEvent can't be called during rendering."
          );
        return s.impl.apply(void 0, arguments);
      };
    }
    function Ad(n) {
      var o = gr().memoizedState;
      return Bb({ ref: o, nextImpl: n }), function() {
        if ((ar & po) !== Oo)
          throw Error(
            "A function wrapped in useEffectEvent can't be called during rendering."
          );
        return o.impl.apply(void 0, arguments);
      };
    }
    function Ho(n, o) {
      var s = 4194308;
      return (un.mode & Qs) !== on && (s |= 134217728), ku(s, Il, n, o);
    }
    function Hi(n, o) {
      if (typeof o == "function") {
        n = n();
        var s = o(n);
        return function() {
          typeof s == "function" ? s() : o(null);
        };
      }
      if (o != null)
        return o.hasOwnProperty("current") || console.error(
          "Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.",
          "an object with keys {" + Object.keys(o).join(", ") + "}"
        ), n = n(), o.current = n, function() {
          o.current = null;
        };
    }
    function Ql(n, o, s) {
      typeof o != "function" && console.error(
        "Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.",
        o !== null ? typeof o : "null"
      ), s = s != null ? s.concat([n]) : null;
      var h = 4194308;
      (un.mode & Qs) !== on && (h |= 134217728), ku(
        h,
        Il,
        Hi.bind(null, o, n),
        s
      );
    }
    function Nd(n, o, s) {
      typeof o != "function" && console.error(
        "Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.",
        o !== null ? typeof o : "null"
      ), s = s != null ? s.concat([n]) : null, za(
        4,
        Il,
        Hi.bind(null, o, n),
        s
      );
    }
    function jp(n, o) {
      return Ma().memoizedState = [
        n,
        o === void 0 ? null : o
      ], n;
    }
    function xl(n, o) {
      var s = gr();
      o = o === void 0 ? null : o;
      var h = s.memoizedState;
      return o !== null && gv(o, h[1]) ? h[0] : (s.memoizedState = [n, o], n);
    }
    function Fo(n, o) {
      var s = Ma();
      o = o === void 0 ? null : o;
      var h = n();
      if (Oh) {
        Oe(!0);
        try {
          n();
        } finally {
          Oe(!1);
        }
      }
      return s.memoizedState = [h, o], h;
    }
    function Br(n, o) {
      var s = gr();
      o = o === void 0 ? null : o;
      var h = s.memoizedState;
      if (o !== null && gv(o, h[1]))
        return h[0];
      if (h = n(), Oh) {
        Oe(!0);
        try {
          n();
        } finally {
          Oe(!1);
        }
      }
      return s.memoizedState = [h, o], h;
    }
    function Dd(n, o) {
      var s = Ma();
      return vr(s, n, o);
    }
    function Jl(n, o) {
      var s = gr();
      return ya(
        s,
        Ir.memoizedState,
        n,
        o
      );
    }
    function Sn(n, o) {
      var s = gr();
      return Ir === null ? vr(s, n, o) : ya(
        s,
        Ir.memoizedState,
        n,
        o
      );
    }
    function vr(n, o, s) {
      return s === void 0 || (Jc & 1073741824) !== 0 && (Dn & 261930) === 0 ? n.memoizedState = o : (n.memoizedState = s, n = Wd(), un.lanes |= n, Rf |= n, s);
    }
    function ya(n, o, s, h) {
      return Ai(s, o) ? s : i0.current !== null ? (n = vr(n, s, h), Ai(n, o) || (Za = !0), n) : (Jc & 42) === 0 || (Jc & 1073741824) !== 0 && (Dn & 261930) === 0 ? (Za = !0, n.memoizedState = s) : (n = Wd(), un.lanes |= n, Rf |= n, o);
    }
    function xc() {
      Xe.asyncTransitions--;
    }
    function Ec(n, o, s, h, y) {
      var C = fr.p;
      fr.p = C !== 0 && C < mo ? C : mo;
      var A = Xe.T, z = {};
      z._updatedFibers = /* @__PURE__ */ new Set(), Xe.T = z, Nm(n, !1, o, s);
      try {
        var q = y(), Z = Xe.S;
        if (Z !== null && Z(z, q), q !== null && typeof q == "object" && typeof q.then == "function") {
          Xe.asyncTransitions++, q.then(xc, xc);
          var xe = Mp(
            q,
            h
          );
          Pc(
            n,
            o,
            xe,
            xo(n)
          );
        } else
          Pc(
            n,
            o,
            h,
            xo(n)
          );
      } catch (ke) {
        Pc(
          n,
          o,
          { then: function() {
          }, status: "rejected", reason: ke },
          xo(n)
        );
      } finally {
        fr.p = C, A !== null && z.types !== null && (A.types !== null && A.types !== z.types && console.error(
          "We expected inner Transitions to have transferred the outer types set and that you cannot add to the outer Transition while inside the inner.This is a bug in React."
        ), A.types = z.types), Xe.T = A, A === null && z._updatedFibers && (n = z._updatedFibers.size, z._updatedFibers.clear(), 10 < n && console.warn(
          "Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."
        ));
      }
    }
    function Fs(n, o, s, h) {
      if (n.tag !== 5)
        throw Error(
          "Expected the form instance to be a HostComponent. This is a bug in React."
        );
      var y = Rm(n).queue;
      Wb(n), Ec(
        n,
        y,
        o,
        Hh,
        s === null ? g : function() {
          return $d(n), s(h);
        }
      );
    }
    function Rm(n) {
      var o = n.memoizedState;
      if (o !== null) return o;
      o = {
        memoizedState: Hh,
        baseState: Hh,
        baseQueue: null,
        queue: {
          pending: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: Si,
          lastRenderedState: Hh
        },
        next: null
      };
      var s = {};
      return o.next = {
        memoizedState: s,
        baseState: s,
        baseQueue: null,
        queue: {
          pending: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: Si,
          lastRenderedState: s
        },
        next: null
      }, n.memoizedState = o, n = n.alternate, n !== null && (n.memoizedState = o), o;
    }
    function $d(n) {
      Xe.T === null && console.error(
        "requestFormReset was called outside a transition or action. To fix, move to an action, or wrap with startTransition."
      );
      var o = Rm(n);
      o.next === null && (o = n.alternate.memoizedState), Pc(
        n,
        o.next.queue,
        {},
        xo(n)
      );
    }
    function Mu() {
      var n = Np(!1);
      return n = Ec.bind(
        null,
        un,
        n.queue,
        !0,
        !1
      ), Ma().memoizedState = n, [!1, n];
    }
    function Ub() {
      var n = bc(Si)[0], o = gr().memoizedState;
      return [
        typeof n == "boolean" ? n : Pm(n),
        o
      ];
    }
    function Zr() {
      var n = yc(Si)[0], o = gr().memoizedState;
      return [
        typeof n == "boolean" ? n : Pm(n),
        o
      ];
    }
    function Ws() {
      return cr(T1);
    }
    function Am() {
      var n = Ma(), o = Lr.identifierPrefix;
      if (Xn) {
        var s = Gc, h = Xc;
        s = (h & ~(1 << 32 - fo(h) - 1)).toString(32) + s, o = "_" + o + "R_" + s, s = pw++, 0 < s && (o += "H" + s.toString(32)), o += "_";
      } else
        s = uT++, o = "_" + o + "r_" + s.toString(32) + "_";
      return n.memoizedState = o;
    }
    function Ip() {
      return Ma().memoizedState = Xb.bind(
        null,
        un
      );
    }
    function Xb(n, o) {
      for (var s = n.return; s !== null; ) {
        switch (s.tag) {
          case 24:
          case 3:
            var h = xo(s), y = $a(h), C = Gl(s, y, h);
            C !== null && (Bl(h, "refresh()", n), ln(C, s, h), Ji(C, s, h)), n = Pp(), o != null && C !== null && console.error(
              "The seed argument is not enabled outside experimental channels."
            ), y.payload = { cache: n };
            return;
        }
        s = s.return;
      }
    }
    function gC(n, o, s) {
      var h = arguments;
      typeof h[3] == "function" && console.error(
        "State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect()."
      ), h = xo(n);
      var y = {
        lane: h,
        revertLane: 0,
        gesture: null,
        action: s,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      Xa(n) ? fa(o, y) : (y = ic(n, o, y, h), y !== null && (Bl(h, "dispatch()", n), ln(y, n, h), Dm(y, o, h)));
    }
    function Lp(n, o, s) {
      var h = arguments;
      typeof h[3] == "function" && console.error(
        "State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect()."
      ), h = xo(n), Pc(n, o, s, h) && Bl(h, "setState()", n);
    }
    function Pc(n, o, s, h) {
      var y = {
        lane: h,
        revertLane: 0,
        gesture: null,
        action: s,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (Xa(n)) fa(o, y);
      else {
        var C = n.alternate;
        if (n.lanes === 0 && (C === null || C.lanes === 0) && (C = o.lastRenderedReducer, C !== null)) {
          var A = Xe.H;
          Xe.H = Zs;
          try {
            var z = o.lastRenderedState, q = C(z, s);
            if (y.hasEagerState = !0, y.eagerState = q, Ai(q, z))
              return yd(n, o, y, 0), Lr === null && yp(), !1;
          } catch {
          } finally {
            Xe.H = A;
          }
        }
        if (s = ic(n, o, y, h), s !== null)
          return ln(s, n, h), Dm(s, o, h), !0;
      }
      return !1;
    }
    function Nm(n, o, s, h) {
      if (Xe.T === null && xh === 0 && console.error(
        "An optimistic state update occurred outside a transition or action. To fix, move the update to an action, or wrap with startTransition."
      ), h = {
        lane: 2,
        revertLane: u2(),
        gesture: null,
        action: h,
        hasEagerState: !1,
        eagerState: null,
        next: null
      }, Xa(n)) {
        if (o)
          throw Error("Cannot update optimistic state while rendering.");
        console.error("Cannot call startTransition while rendering.");
      } else
        o = ic(
          n,
          s,
          h,
          2
        ), o !== null && (Bl(2, "setOptimistic()", n), ln(o, n, 2));
    }
    function Xa(n) {
      var o = n.alternate;
      return n === un || o !== null && o === un;
    }
    function fa(n, o) {
      u0 = hw = !0;
      var s = n.pending;
      s === null ? o.next = o : (o.next = s.next, s.next = o), n.pending = o;
    }
    function Dm(n, o, s) {
      if ((s & 4194048) !== 0) {
        var h = o.lanes;
        h &= n.pendingLanes, s |= h, o.lanes = s, ct(n, s);
      }
    }
    function kc(n) {
      if (n !== null && typeof n != "function") {
        var o = String(n);
        k8.has(o) || (k8.add(o), console.error(
          "Expected the last optional `callback` argument to be a function. Instead received: %s.",
          n
        ));
      }
    }
    function zd(n, o, s, h) {
      var y = n.memoizedState, C = s(h, y);
      if (n.mode & ii) {
        Oe(!0);
        try {
          C = s(h, y);
        } finally {
          Oe(!1);
        }
      }
      C === void 0 && (o = F(o) || "Component", C8.has(o) || (C8.add(o), console.error(
        "%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.",
        o
      ))), y = C == null ? y : Rn({}, y, C), n.memoizedState = y, n.lanes === 0 && (n.updateQueue.baseState = y);
    }
    function Hp(n, o, s, h, y, C, A) {
      var z = n.stateNode;
      if (typeof z.shouldComponentUpdate == "function") {
        if (s = z.shouldComponentUpdate(
          h,
          C,
          A
        ), n.mode & ii) {
          Oe(!0);
          try {
            s = z.shouldComponentUpdate(
              h,
              C,
              A
            );
          } finally {
            Oe(!1);
          }
        }
        return s === void 0 && console.error(
          "%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.",
          F(o) || "Component"
        ), s;
      }
      return o.prototype && o.prototype.isPureReactComponent ? !bd(s, h) || !bd(y, C) : !0;
    }
    function Zl(n, o, s, h) {
      var y = o.state;
      typeof o.componentWillReceiveProps == "function" && o.componentWillReceiveProps(s, h), typeof o.UNSAFE_componentWillReceiveProps == "function" && o.UNSAFE_componentWillReceiveProps(s, h), o.state !== y && (n = W(n) || "Component", v8.has(n) || (v8.add(n), console.error(
        "%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.",
        n
      )), a4.enqueueReplaceState(
        o,
        o.state,
        null
      ));
    }
    function es(n, o) {
      var s = o;
      if ("ref" in o) {
        s = {};
        for (var h in o)
          h !== "ref" && (s[h] = o[h]);
      }
      if (n = n.defaultProps) {
        s === o && (s = Rn({}, s));
        for (var y in n)
          s[y] === void 0 && (s[y] = n[y]);
      }
      return s;
    }
    function Fp(n) {
      zC(n), console.warn(
        `%s

%s
`,
        c0 ? "An error occurred in the <" + c0 + "> component." : "An error occurred in one of your React components.",
        `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://react.dev/link/error-boundaries to learn more about error boundaries.`
      );
    }
    function Wp(n) {
      var o = c0 ? "The above error occurred in the <" + c0 + "> component." : "The above error occurred in one of your React components.", s = "React will try to recreate this component tree from scratch using the error boundary you provided, " + ((o4 || "Anonymous") + ".");
      if (typeof n == "object" && n !== null && typeof n.environmentName == "string") {
        var h = n.environmentName;
        n = [
          `%o

%s

%s
`,
          n,
          o,
          s
        ].slice(0), typeof n[0] == "string" ? n.splice(
          0,
          1,
          s5 + " " + n[0],
          u5,
          Fw + h + Fw,
          c5
        ) : n.splice(
          0,
          0,
          s5,
          u5,
          Fw + h + Fw,
          c5
        ), n.unshift(console), h = RT.apply(console.error, n), h();
      } else
        console.error(
          `%o

%s

%s
`,
          n,
          o,
          s
        );
    }
    function xv(n) {
      zC(n);
    }
    function $m(n, o) {
      try {
        c0 = o.source ? W(o.source) : null, o4 = null;
        var s = o.value;
        if (Xe.actQueue !== null)
          Xe.thrownErrors.push(s);
        else {
          var h = n.onUncaughtError;
          h(s, { componentStack: o.stack });
        }
      } catch (y) {
        setTimeout(function() {
          throw y;
        });
      }
    }
    function Ev(n, o, s) {
      try {
        c0 = s.source ? W(s.source) : null, o4 = W(o);
        var h = n.onCaughtError;
        h(s.value, {
          componentStack: s.stack,
          errorBoundary: o.tag === 1 ? o.stateNode : null
        });
      } catch (y) {
        setTimeout(function() {
          throw y;
        });
      }
    }
    function Vp(n, o, s) {
      return s = $a(s), s.tag = JC, s.payload = { element: null }, s.callback = function() {
        le(o.source, $m, n, o);
      }, s;
    }
    function _p(n) {
      return n = $a(n), n.tag = JC, n;
    }
    function Bp(n, o, s, h) {
      var y = s.type.getDerivedStateFromError;
      if (typeof y == "function") {
        var C = h.value;
        n.payload = function() {
          return y(C);
        }, n.callback = function() {
          lc(s), le(
            h.source,
            Ev,
            o,
            s,
            h
          );
        };
      }
      var A = s.stateNode;
      A !== null && typeof A.componentDidCatch == "function" && (n.callback = function() {
        lc(s), le(
          h.source,
          Ev,
          o,
          s,
          h
        ), typeof y != "function" && (Nf === null ? Nf = /* @__PURE__ */ new Set([this]) : Nf.add(this)), oT(this, h), typeof y == "function" || (s.lanes & 2) === 0 && console.error(
          "%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.",
          W(s) || "Unknown"
        );
      });
    }
    function Pv(n, o, s, h, y) {
      if (s.flags |= 32768, ms && Xd(n, y), h !== null && typeof h == "object" && typeof h.then == "function") {
        if (o = s.alternate, o !== null && bl(
          o,
          s,
          y,
          !0
        ), Xn && (_u = !0), s = jl.current, s !== null) {
          switch (s.tag) {
            case 31:
            case 13:
              return Ms === null ? _d() : s.alternate === null && ha === nd && (ha = bw), s.flags &= -257, s.flags |= 65536, s.lanes = y, h === dw ? s.flags |= 16384 : (o = s.updateQueue, o === null ? s.updateQueue = /* @__PURE__ */ new Set([h]) : o.add(h), cg(n, h, y)), !1;
            case 22:
              return s.flags |= 65536, h === dw ? s.flags |= 16384 : (o = s.updateQueue, o === null ? (o = {
                transitions: null,
                markerInstances: null,
                retryQueue: /* @__PURE__ */ new Set([h])
              }, s.updateQueue = o) : (s = o.retryQueue, s === null ? o.retryQueue = /* @__PURE__ */ new Set([h]) : s.add(h)), cg(n, h, y)), !1;
          }
          throw Error(
            "Unexpected Suspense handler tag (" + s.tag + "). This is a bug in React."
          );
        }
        return cg(n, h, y), _d(), !1;
      }
      if (Xn)
        return _u = !0, o = jl.current, o !== null ? ((o.flags & 65536) === 0 && (o.flags |= 256), o.flags |= 65536, o.lanes = y, h !== WC && mm(
          $o(
            Error(
              "There was an error while hydrating but React was able to recover by instead client rendering from the nearest Suspense boundary.",
              { cause: h }
            ),
            s
          )
        )) : (h !== WC && mm(
          $o(
            Error(
              "There was an error while hydrating but React was able to recover by instead client rendering the entire root.",
              { cause: h }
            ),
            s
          )
        ), n = n.current.alternate, n.flags |= 65536, y &= -y, n.lanes |= y, h = $o(h, s), y = Vp(
          n.stateNode,
          h,
          y
        ), ym(n, y), ha !== Of && (ha = Th)), !1;
      var C = $o(
        Error(
          "There was an error during concurrent rendering but React was able to recover by instead synchronously rendering the entire root.",
          { cause: h }
        ),
        s
      );
      if (w1 === null ? w1 = [C] : w1.push(C), ha !== Of && (ha = Th), o === null) return !0;
      h = $o(h, s), s = o;
      do {
        switch (s.tag) {
          case 3:
            return s.flags |= 65536, n = y & -y, s.lanes |= n, n = Vp(
              s.stateNode,
              h,
              n
            ), ym(s, n), !1;
          case 1:
            if (o = s.type, C = s.stateNode, (s.flags & 128) === 0 && (typeof o.getDerivedStateFromError == "function" || C !== null && typeof C.componentDidCatch == "function" && (Nf === null || !Nf.has(C))))
              return s.flags |= 65536, y &= -y, s.lanes |= y, y = _p(y), Bp(
                y,
                n,
                s,
                h
              ), ym(s, y), !1;
        }
        s = s.return;
      } while (s !== null);
      return !1;
    }
    function Ga(n, o, s, h) {
      o.child = n === null ? i8(o, null, s, h) : Mh(
        o,
        n.child,
        s,
        h
      );
    }
    function Gb(n, o, s, h, y) {
      s = s.render;
      var C = o.ref;
      if ("ref" in h) {
        var A = {};
        for (var z in h)
          z !== "ref" && (A[z] = h[z]);
      } else A = h;
      return gu(o), h = vv(
        n,
        o,
        s,
        A,
        C,
        y
      ), z = vc(), n !== null && !Za ? (xm(n, o, y), El(n, o, y)) : (Xn && z && Cp(o), o.flags |= 1, Ga(n, o, h, y), o.child);
    }
    function kv(n, o, s, h, y) {
      if (n === null) {
        var C = s.type;
        return typeof C == "function" && !av(C) && C.defaultProps === void 0 && s.compare === null ? (s = du(C), o.tag = 15, o.type = s, jd(o, C), Mv(
          n,
          o,
          s,
          h,
          y
        )) : (n = sc(
          s.type,
          null,
          h,
          o,
          o.mode,
          y
        ), n.ref = o.ref, n.return = o, o.child = n);
      }
      if (C = n.child, !Kp(n, y)) {
        var A = C.memoizedProps;
        if (s = s.compare, s = s !== null ? s : bd, s(A, h) && n.ref === o.ref)
          return El(
            n,
            o,
            y
          );
      }
      return o.flags |= 1, n = _l(C, h), n.ref = o.ref, n.return = o, o.child = n;
    }
    function Mv(n, o, s, h, y) {
      if (n !== null) {
        var C = n.memoizedProps;
        if (bd(C, h) && n.ref === o.ref && o.type === n.type)
          if (Za = !1, o.pendingProps = h = C, Kp(n, y))
            (n.flags & 131072) !== 0 && (Za = !0);
          else
            return o.lanes = n.lanes, El(n, o, y);
      }
      return Av(
        n,
        o,
        s,
        h,
        y
      );
    }
    function Ov(n, o, s, h) {
      var y = h.children, C = n !== null ? n.memoizedState : null;
      if (n === null && o.stateNode === null && (o.stateNode = {
        _visibility: K2,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
      }), h.mode === "hidden") {
        if ((o.flags & 128) !== 0) {
          if (C = C !== null ? C.baseLanes | s : s, n !== null) {
            for (h = o.child = n.child, y = 0; h !== null; )
              y = y | h.lanes | h.childLanes, h = h.sibling;
            h = y & ~C;
          } else h = 0, o.child = null;
          return Tv(
            n,
            o,
            C,
            s,
            h
          );
        }
        if ((s & 536870912) !== 0)
          o.memoizedState = { baseLanes: 0, cachePool: null }, n !== null && Ed(
            o,
            C !== null ? C.cachePool : null
          ), C !== null ? Rp(o, C) : zs(o), Ap(o);
        else
          return h = o.lanes = 536870912, Tv(
            n,
            o,
            C !== null ? C.baseLanes | s : s,
            s,
            h
          );
      } else
        C !== null ? (Ed(o, C.cachePool), Rp(o, C), Kl(o), o.memoizedState = null) : (n !== null && Ed(o, null), zs(o), Kl(o));
      return Ga(n, o, y, s), o.child;
    }
    function Mc(n, o) {
      return n !== null && n.tag === 22 || o.stateNode !== null || (o.stateNode = {
        _visibility: K2,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
      }), o.sibling;
    }
    function Tv(n, o, s, h, y) {
      var C = $s();
      return C = C === null ? null : {
        parent: Ya._currentValue,
        pool: C
      }, o.memoizedState = {
        baseLanes: s,
        cachePool: C
      }, n !== null && Ed(o, null), zs(o), Ap(o), n !== null && bl(n, o, h, !0), o.childLanes = y, null;
    }
    function zm(n, o) {
      var s = o.hidden;
      return s !== void 0 && console.error(
        `<Activity> doesn't accept a hidden prop. Use mode="hidden" instead.
- <Activity %s>
+ <Activity %s>`,
        s === !0 ? "hidden" : s === !1 ? "hidden={false}" : "hidden={...}",
        s ? 'mode="hidden"' : 'mode="visible"'
      ), o = Im(
        { mode: o.mode, children: o.children },
        n.mode
      ), o.ref = n.ref, n.child = o, o.return = n, o;
    }
    function Rv(n, o, s) {
      return Mh(o, n.child, null, s), n = zm(
        o,
        o.pendingProps
      ), n.flags |= 2, Ua(o), o.memoizedState = null, n;
    }
    function qb(n, o, s) {
      var h = o.pendingProps, y = (o.flags & 128) !== 0;
      if (o.flags &= -129, n === null) {
        if (Xn) {
          if (h.mode === "hidden")
            return n = zm(o, h), o.lanes = 536870912, Mc(null, n);
          if (Cl(o), (n = qr) ? (s = yr(
            n,
            ws
          ), s = s !== null && s.data === zh ? s : null, s !== null && (h = {
            dehydrated: s,
            treeContext: Lb(),
            retryLane: 536870912,
            hydrationErrors: null
          }, o.memoizedState = h, h = iv(s), h.return = o, o.child = h, Ko = o, qr = null)) : s = null, s === null)
            throw Co(o, n), Gi(o);
          return o.lanes = 536870912, null;
        }
        return zm(o, h);
      }
      var C = n.memoizedState;
      if (C !== null) {
        var A = C.dehydrated;
        if (Cl(o), y)
          if (o.flags & 256)
            o.flags &= -257, o = Rv(
              n,
              o,
              s
            );
          else if (o.memoizedState !== null)
            o.child = n.child, o.flags |= 128, o = null;
          else
            throw Error(
              "Client rendering an Activity suspended it again. This is a bug in React."
            );
        else if (Fb(), (s & 536870912) !== 0 && Vd(o), Za || bl(
          n,
          o,
          s,
          !1
        ), y = (s & n.childLanes) !== 0, Za || y) {
          if (h = Lr, h !== null && (A = it(
            h,
            s
          ), A !== 0 && A !== C.retryLane))
            throw C.retryLane = A, So(n, A), ln(h, n, A), i4;
          _d(), o = Rv(
            n,
            o,
            s
          );
        } else
          n = C.treeContext, qr = Mi(
            A.nextSibling
          ), Ko = o, Xn = !0, Cf = null, _u = !1, zl = null, ws = !1, n !== null && Hb(o, n), o = zm(o, h), o.flags |= 4096;
        return o;
      }
      return C = n.child, h = { mode: h.mode, children: h.children }, (s & 536870912) !== 0 && (s & n.lanes) !== 0 && Vd(o), n = _l(C, h), n.ref = o.ref, o.child = n, n.return = o, n;
    }
    function jm(n, o) {
      var s = o.ref;
      if (s === null)
        n !== null && n.ref !== null && (o.flags |= 4194816);
      else {
        if (typeof s != "function" && typeof s != "object")
          throw Error(
            "Expected ref to be a function, an object returned by React.createRef(), or undefined/null."
          );
        (n === null || n.ref !== s) && (o.flags |= 4194816);
      }
    }
    function Av(n, o, s, h, y) {
      if (s.prototype && typeof s.prototype.render == "function") {
        var C = F(s) || "Unknown";
        M8[C] || (console.error(
          "The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.",
          C,
          C
        ), M8[C] = !0);
      }
      return o.mode & ii && Js.recordLegacyContextWarning(
        o,
        null
      ), n === null && (jd(o, o.type), s.contextTypes && (C = F(s) || "Unknown", T8[C] || (T8[C] = !0, console.error(
        "%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with React.useContext() instead. (https://react.dev/link/legacy-context)",
        C
      )))), gu(o), s = vv(
        n,
        o,
        s,
        h,
        void 0,
        y
      ), h = vc(), n !== null && !Za ? (xm(n, o, y), El(n, o, y)) : (Xn && h && Cp(o), o.flags |= 1, Ga(n, o, s, y), o.child);
    }
    function Nv(n, o, s, h, y, C) {
      return gu(o), ed = -1, m1 = n !== null && n.type !== o.type, o.updateQueue = null, s = Sm(
        o,
        h,
        s,
        y
      ), ba(n, o), h = vc(), n !== null && !Za ? (xm(n, o, C), El(n, o, C)) : (Xn && h && Cp(o), o.flags |= 1, Ga(n, o, s, C), o.child);
    }
    function Oc(n, o, s, h, y) {
      switch (d(o)) {
        case !1:
          var C = o.stateNode, A = new o.type(
            o.memoizedProps,
            C.context
          ).state;
          C.updater.enqueueSetState(C, A, null);
          break;
        case !0:
          o.flags |= 128, o.flags |= 65536, C = Error("Simulated error coming from DevTools");
          var z = y & -y;
          if (o.lanes |= z, A = Lr, A === null)
            throw Error(
              "Expected a work-in-progress root. This is a bug in React. Please file an issue."
            );
          z = _p(z), Bp(
            z,
            A,
            o,
            $o(C, o)
          ), ym(o, z);
      }
      if (gu(o), o.stateNode === null) {
        if (A = Sf, C = s.contextType, "contextType" in s && C !== null && (C === void 0 || C.$$typeof !== Nl) && !P8.has(s) && (P8.add(s), z = C === void 0 ? " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof C != "object" ? " However, it is set to a " + typeof C + "." : C.$$typeof === Ng ? " Did you accidentally pass the Context.Consumer instead?" : " However, it is set to an object with keys {" + Object.keys(C).join(", ") + "}.", console.error(
          "%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s",
          F(s) || "Component",
          z
        )), typeof C == "object" && C !== null && (A = cr(C)), C = new s(h, A), o.mode & ii) {
          Oe(!0);
          try {
            C = new s(h, A);
          } finally {
            Oe(!1);
          }
        }
        if (A = o.memoizedState = C.state !== null && C.state !== void 0 ? C.state : null, C.updater = a4, o.stateNode = C, C._reactInternals = o, C._reactInternalInstance = g8, typeof s.getDerivedStateFromProps == "function" && A === null && (A = F(s) || "Component", b8.has(A) || (b8.add(A), console.error(
          "`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.",
          A,
          C.state === null ? "null" : "undefined",
          A
        ))), typeof s.getDerivedStateFromProps == "function" || typeof C.getSnapshotBeforeUpdate == "function") {
          var q = z = A = null;
          if (typeof C.componentWillMount == "function" && C.componentWillMount.__suppressDeprecationWarning !== !0 ? A = "componentWillMount" : typeof C.UNSAFE_componentWillMount == "function" && (A = "UNSAFE_componentWillMount"), typeof C.componentWillReceiveProps == "function" && C.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? z = "componentWillReceiveProps" : typeof C.UNSAFE_componentWillReceiveProps == "function" && (z = "UNSAFE_componentWillReceiveProps"), typeof C.componentWillUpdate == "function" && C.componentWillUpdate.__suppressDeprecationWarning !== !0 ? q = "componentWillUpdate" : typeof C.UNSAFE_componentWillUpdate == "function" && (q = "UNSAFE_componentWillUpdate"), A !== null || z !== null || q !== null) {
            C = F(s) || "Component";
            var Z = typeof s.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            w8.has(C) || (w8.add(C), console.error(
              `Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://react.dev/link/unsafe-component-lifecycles`,
              C,
              Z,
              A !== null ? `
  ` + A : "",
              z !== null ? `
  ` + z : "",
              q !== null ? `
  ` + q : ""
            ));
          }
        }
        C = o.stateNode, A = F(s) || "Component", C.render || (s.prototype && typeof s.prototype.render == "function" ? console.error(
          "No `render` method found on the %s instance: did you accidentally return an object from the constructor?",
          A
        ) : console.error(
          "No `render` method found on the %s instance: you may have forgotten to define `render`.",
          A
        )), !C.getInitialState || C.getInitialState.isReactClassApproved || C.state || console.error(
          "getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?",
          A
        ), C.getDefaultProps && !C.getDefaultProps.isReactClassApproved && console.error(
          "getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.",
          A
        ), C.contextType && console.error(
          "contextType was defined as an instance property on %s. Use a static property to define contextType instead.",
          A
        ), s.childContextTypes && !E8.has(s) && (E8.add(s), console.error(
          "%s uses the legacy childContextTypes API which was removed in React 19. Use React.createContext() instead. (https://react.dev/link/legacy-context)",
          A
        )), s.contextTypes && !x8.has(s) && (x8.add(s), console.error(
          "%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with static contextType instead. (https://react.dev/link/legacy-context)",
          A
        )), typeof C.componentShouldUpdate == "function" && console.error(
          "%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.",
          A
        ), s.prototype && s.prototype.isPureReactComponent && typeof C.shouldComponentUpdate < "u" && console.error(
          "%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.",
          F(s) || "A pure component"
        ), typeof C.componentDidUnmount == "function" && console.error(
          "%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?",
          A
        ), typeof C.componentDidReceiveProps == "function" && console.error(
          "%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().",
          A
        ), typeof C.componentWillRecieveProps == "function" && console.error(
          "%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?",
          A
        ), typeof C.UNSAFE_componentWillRecieveProps == "function" && console.error(
          "%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?",
          A
        ), z = C.props !== h, C.props !== void 0 && z && console.error(
          "When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.",
          A
        ), C.defaultProps && console.error(
          "Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.",
          A,
          A
        ), typeof C.getSnapshotBeforeUpdate != "function" || typeof C.componentDidUpdate == "function" || y8.has(s) || (y8.add(s), console.error(
          "%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.",
          F(s)
        )), typeof C.getDerivedStateFromProps == "function" && console.error(
          "%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.",
          A
        ), typeof C.getDerivedStateFromError == "function" && console.error(
          "%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.",
          A
        ), typeof s.getSnapshotBeforeUpdate == "function" && console.error(
          "%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.",
          A
        ), (z = C.state) && (typeof z != "object" || Ta(z)) && console.error("%s.state: must be set to an object or null", A), typeof C.getChildContext == "function" && typeof s.childContextTypes != "object" && console.error(
          "%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().",
          A
        ), C = o.stateNode, C.props = h, C.state = o.memoizedState, C.refs = {}, _n(o), A = s.contextType, C.context = typeof A == "object" && A !== null ? cr(A) : Sf, C.state === h && (A = F(s) || "Component", S8.has(A) || (S8.add(A), console.error(
          "%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.",
          A
        ))), o.mode & ii && Js.recordLegacyContextWarning(
          o,
          C
        ), Js.recordUnsafeLifecycleWarnings(
          o,
          C
        ), C.state = o.memoizedState, A = s.getDerivedStateFromProps, typeof A == "function" && (zd(
          o,
          s,
          A,
          h
        ), C.state = o.memoizedState), typeof s.getDerivedStateFromProps == "function" || typeof C.getSnapshotBeforeUpdate == "function" || typeof C.UNSAFE_componentWillMount != "function" && typeof C.componentWillMount != "function" || (A = C.state, typeof C.componentWillMount == "function" && C.componentWillMount(), typeof C.UNSAFE_componentWillMount == "function" && C.UNSAFE_componentWillMount(), A !== C.state && (console.error(
          "%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.",
          W(o) || "Component"
        ), a4.enqueueReplaceState(
          C,
          C.state,
          null
        )), ql(o, h, C, y), kd(), C.state = o.memoizedState), typeof C.componentDidMount == "function" && (o.flags |= 4194308), (o.mode & Qs) !== on && (o.flags |= 134217728), C = !0;
      } else if (n === null) {
        C = o.stateNode;
        var xe = o.memoizedProps;
        z = es(s, xe), C.props = z;
        var ke = C.context;
        q = s.contextType, A = Sf, typeof q == "object" && q !== null && (A = cr(q)), Z = s.getDerivedStateFromProps, q = typeof Z == "function" || typeof C.getSnapshotBeforeUpdate == "function", xe = o.pendingProps !== xe, q || typeof C.UNSAFE_componentWillReceiveProps != "function" && typeof C.componentWillReceiveProps != "function" || (xe || ke !== A) && Zl(
          o,
          C,
          h,
          A
        ), Mf = !1;
        var de = o.memoizedState;
        C.state = de, ql(o, h, C, y), kd(), ke = o.memoizedState, xe || de !== ke || Mf ? (typeof Z == "function" && (zd(
          o,
          s,
          Z,
          h
        ), ke = o.memoizedState), (z = Mf || Hp(
          o,
          s,
          z,
          h,
          de,
          ke,
          A
        )) ? (q || typeof C.UNSAFE_componentWillMount != "function" && typeof C.componentWillMount != "function" || (typeof C.componentWillMount == "function" && C.componentWillMount(), typeof C.UNSAFE_componentWillMount == "function" && C.UNSAFE_componentWillMount()), typeof C.componentDidMount == "function" && (o.flags |= 4194308), (o.mode & Qs) !== on && (o.flags |= 134217728)) : (typeof C.componentDidMount == "function" && (o.flags |= 4194308), (o.mode & Qs) !== on && (o.flags |= 134217728), o.memoizedProps = h, o.memoizedState = ke), C.props = h, C.state = ke, C.context = A, C = z) : (typeof C.componentDidMount == "function" && (o.flags |= 4194308), (o.mode & Qs) !== on && (o.flags |= 134217728), C = !1);
      } else {
        C = o.stateNode, Xl(n, o), A = o.memoizedProps, q = es(s, A), C.props = q, Z = o.pendingProps, de = C.context, ke = s.contextType, z = Sf, typeof ke == "object" && ke !== null && (z = cr(ke)), xe = s.getDerivedStateFromProps, (ke = typeof xe == "function" || typeof C.getSnapshotBeforeUpdate == "function") || typeof C.UNSAFE_componentWillReceiveProps != "function" && typeof C.componentWillReceiveProps != "function" || (A !== Z || de !== z) && Zl(
          o,
          C,
          h,
          z
        ), Mf = !1, de = o.memoizedState, C.state = de, ql(o, h, C, y), kd();
        var Ve = o.memoizedState;
        A !== Z || de !== Ve || Mf || n !== null && n.dependencies !== null && Cd(n.dependencies) ? (typeof xe == "function" && (zd(
          o,
          s,
          xe,
          h
        ), Ve = o.memoizedState), (q = Mf || Hp(
          o,
          s,
          q,
          h,
          de,
          Ve,
          z
        ) || n !== null && n.dependencies !== null && Cd(n.dependencies)) ? (ke || typeof C.UNSAFE_componentWillUpdate != "function" && typeof C.componentWillUpdate != "function" || (typeof C.componentWillUpdate == "function" && C.componentWillUpdate(h, Ve, z), typeof C.UNSAFE_componentWillUpdate == "function" && C.UNSAFE_componentWillUpdate(
          h,
          Ve,
          z
        )), typeof C.componentDidUpdate == "function" && (o.flags |= 4), typeof C.getSnapshotBeforeUpdate == "function" && (o.flags |= 1024)) : (typeof C.componentDidUpdate != "function" || A === n.memoizedProps && de === n.memoizedState || (o.flags |= 4), typeof C.getSnapshotBeforeUpdate != "function" || A === n.memoizedProps && de === n.memoizedState || (o.flags |= 1024), o.memoizedProps = h, o.memoizedState = Ve), C.props = h, C.state = Ve, C.context = z, C = q) : (typeof C.componentDidUpdate != "function" || A === n.memoizedProps && de === n.memoizedState || (o.flags |= 4), typeof C.getSnapshotBeforeUpdate != "function" || A === n.memoizedProps && de === n.memoizedState || (o.flags |= 1024), C = !1);
      }
      if (z = C, jm(n, o), A = (o.flags & 128) !== 0, z || A) {
        if (z = o.stateNode, se(o), A && typeof s.getDerivedStateFromError != "function")
          s = null, Ni = -1;
        else if (s = X6(z), o.mode & ii) {
          Oe(!0);
          try {
            X6(z);
          } finally {
            Oe(!1);
          }
        }
        o.flags |= 1, n !== null && A ? (o.child = Mh(
          o,
          n.child,
          null,
          y
        ), o.child = Mh(
          o,
          null,
          s,
          y
        )) : Ga(n, o, s, y), o.memoizedState = z.state, n = o.child;
      } else
        n = El(
          n,
          o,
          y
        );
      return y = o.stateNode, C && y.props !== h && (d0 || console.error(
        "It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.",
        W(o) || "a component"
      ), d0 = !0), n;
    }
    function Dv(n, o, s, h) {
      return hu(), o.flags |= 256, Ga(n, o, s, h), o.child;
    }
    function jd(n, o) {
      o && o.childContextTypes && console.error(
        `childContextTypes cannot be defined on a function component.
  %s.childContextTypes = ...`,
        o.displayName || o.name || "Component"
      ), typeof o.getDerivedStateFromProps == "function" && (n = F(o) || "Unknown", R8[n] || (console.error(
        "%s: Function components do not support getDerivedStateFromProps.",
        n
      ), R8[n] = !0)), typeof o.contextType == "object" && o.contextType !== null && (o = F(o) || "Unknown", O8[o] || (console.error(
        "%s: Function components do not support contextType.",
        o
      ), O8[o] = !0));
    }
    function Id(n) {
      return { baseLanes: n, cachePool: fv() };
    }
    function Up(n, o, s) {
      return n = n !== null ? n.childLanes & ~s : 0, o && (n |= il), n;
    }
    function Xp(n, o, s) {
      var h, y = o.pendingProps;
      c(o) && (o.flags |= 128);
      var C = !1, A = (o.flags & 128) !== 0;
      if ((h = A) || (h = n !== null && n.memoizedState === null ? !1 : (Ha.current & d1) !== 0), h && (C = !0, o.flags &= -129), h = (o.flags & 32) !== 0, o.flags &= -33, n === null) {
        if (Xn) {
          if (C ? Lo(o) : Kl(o), (n = qr) ? (s = yr(
            n,
            ws
          ), s = s !== null && s.data !== zh ? s : null, s !== null && (h = {
            dehydrated: s,
            treeContext: Lb(),
            retryLane: 536870912,
            hydrationErrors: null
          }, o.memoizedState = h, h = iv(s), h.return = o, o.child = h, Ko = o, qr = null)) : s = null, s === null)
            throw Co(o, n), Gi(o);
          return f2(s) ? o.lanes = 32 : o.lanes = 536870912, null;
        }
        var z = y.children;
        if (y = y.fallback, C) {
          Kl(o);
          var q = o.mode;
          return z = Im(
            { mode: "hidden", children: z },
            q
          ), y = uc(
            y,
            q,
            s,
            null
          ), z.return = o, y.return = o, z.sibling = y, o.child = z, y = o.child, y.memoizedState = Id(s), y.childLanes = Up(
            n,
            h,
            s
          ), o.memoizedState = l4, Mc(
            null,
            y
          );
        }
        return Lo(o), $v(
          o,
          z
        );
      }
      var Z = n.memoizedState;
      if (Z !== null) {
        var xe = Z.dehydrated;
        if (xe !== null) {
          if (A)
            o.flags & 256 ? (Lo(o), o.flags &= -257, o = Gp(
              n,
              o,
              s
            )) : o.memoizedState !== null ? (Kl(o), o.child = n.child, o.flags |= 128, o = null) : (Kl(o), z = y.fallback, q = o.mode, y = Im(
              {
                mode: "visible",
                children: y.children
              },
              q
            ), z = uc(
              z,
              q,
              s,
              null
            ), z.flags |= 2, y.return = o, z.return = o, y.sibling = z, o.child = y, Mh(
              o,
              n.child,
              null,
              s
            ), y = o.child, y.memoizedState = Id(s), y.childLanes = Up(
              n,
              h,
              s
            ), o.memoizedState = l4, o = Mc(
              null,
              y
            ));
          else if (Lo(o), Fb(), (s & 536870912) !== 0 && Vd(o), f2(
            xe
          )) {
            if (h = xe.nextSibling && xe.nextSibling.dataset, h) {
              z = h.dgst;
              var ke = h.msg;
              q = h.stck;
              var de = h.cstck;
            }
            C = ke, h = z, y = q, xe = de, z = C, q = xe, z = Error(z || "The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering."), z.stack = y || "", z.digest = h, h = q === void 0 ? null : q, y = {
              value: z,
              source: null,
              stack: h
            }, typeof h == "string" && FC.set(
              z,
              y
            ), mm(y), o = Gp(
              n,
              o,
              s
            );
          } else if (Za || bl(
            n,
            o,
            s,
            !1
          ), h = (s & n.childLanes) !== 0, Za || h) {
            if (h = Lr, h !== null && (y = it(
              h,
              s
            ), y !== 0 && y !== Z.retryLane))
              throw Z.retryLane = y, So(
                n,
                y
              ), ln(
                h,
                n,
                y
              ), i4;
            th(
              xe
            ) || _d(), o = Gp(
              n,
              o,
              s
            );
          } else
            th(
              xe
            ) ? (o.flags |= 192, o.child = n.child, o = null) : (n = Z.treeContext, qr = Mi(
              xe.nextSibling
            ), Ko = o, Xn = !0, Cf = null, _u = !1, zl = null, ws = !1, n !== null && Hb(o, n), o = $v(
              o,
              y.children
            ), o.flags |= 4096);
          return o;
        }
      }
      return C ? (Kl(o), z = y.fallback, q = o.mode, de = n.child, xe = de.sibling, y = _l(
        de,
        {
          mode: "hidden",
          children: y.children
        }
      ), y.subtreeFlags = de.subtreeFlags & 65011712, xe !== null ? z = _l(
        xe,
        z
      ) : (z = uc(
        z,
        q,
        s,
        null
      ), z.flags |= 2), z.return = o, y.return = o, y.sibling = z, o.child = y, Mc(null, y), y = o.child, z = n.child.memoizedState, z === null ? z = Id(s) : (q = z.cachePool, q !== null ? (de = Ya._currentValue, q = q.parent !== de ? { parent: de, pool: de } : q) : q = fv(), z = {
        baseLanes: z.baseLanes | s,
        cachePool: q
      }), y.memoizedState = z, y.childLanes = Up(
        n,
        h,
        s
      ), o.memoizedState = l4, Mc(
        n.child,
        y
      )) : (Z !== null && (s & 62914560) === s && (s & n.lanes) !== 0 && Vd(o), Lo(o), s = n.child, n = s.sibling, s = _l(s, {
        mode: "visible",
        children: y.children
      }), s.return = o, s.sibling = null, n !== null && (h = o.deletions, h === null ? (o.deletions = [n], o.flags |= 16) : h.push(n)), o.child = s, o.memoizedState = null, s);
    }
    function $v(n, o) {
      return o = Im(
        { mode: "visible", children: o },
        n.mode
      ), o.return = n, n.child = o;
    }
    function Im(n, o) {
      return n = x(22, n, null, o), n.lanes = 0, n;
    }
    function Gp(n, o, s) {
      return Mh(o, n.child, null, s), n = $v(
        o,
        o.pendingProps.children
      ), n.flags |= 2, o.memoizedState = null, n;
    }
    function zv(n, o, s) {
      n.lanes |= o;
      var h = n.alternate;
      h !== null && (h.lanes |= o), Ep(
        n.return,
        o,
        s
      );
    }
    function qp(n, o, s, h, y, C) {
      var A = n.memoizedState;
      A === null ? n.memoizedState = {
        isBackwards: o,
        rendering: null,
        renderingStartTime: 0,
        last: h,
        tail: s,
        tailMode: y,
        treeForkCount: C
      } : (A.isBackwards = o, A.rendering = null, A.renderingStartTime = 0, A.last = h, A.tail = s, A.tailMode = y, A.treeForkCount = C);
    }
    function jv(n, o, s) {
      var h = o.pendingProps, y = h.revealOrder, C = h.tail, A = h.children, z = Ha.current;
      if ((h = (z & d1) !== 0) ? (z = z & l0 | d1, o.flags |= 128) : z &= l0, Y(Ha, z, o), z = y ?? "null", y !== "forwards" && y !== "unstable_legacy-backwards" && y !== "together" && y !== "independent" && !A8[z])
        if (A8[z] = !0, y == null)
          console.error(
            'The default for the <SuspenseList revealOrder="..."> prop is changing. To be future compatible you must explictly specify either "independent" (the current default), "together", "forwards" or "legacy_unstable-backwards".'
          );
        else if (y === "backwards")
          console.error(
            'The rendering order of <SuspenseList revealOrder="backwards"> is changing. To be future compatible you must specify revealOrder="legacy_unstable-backwards" instead.'
          );
        else if (typeof y == "string")
          switch (y.toLowerCase()) {
            case "together":
            case "forwards":
            case "backwards":
            case "independent":
              console.error(
                '"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.',
                y,
                y.toLowerCase()
              );
              break;
            case "forward":
            case "backward":
              console.error(
                '"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.',
                y,
                y.toLowerCase()
              );
              break;
            default:
              console.error(
                '"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "independent", "together", "forwards" or "backwards"?',
                y
              );
          }
        else
          console.error(
            '%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "independent", "together", "forwards" or "backwards"?',
            y
          );
      z = C ?? "null", vw[z] || (C == null ? (y === "forwards" || y === "backwards" || y === "unstable_legacy-backwards") && (vw[z] = !0, console.error(
        'The default for the <SuspenseList tail="..."> prop is changing. To be future compatible you must explictly specify either "visible" (the current default), "collapsed" or "hidden".'
      )) : C !== "visible" && C !== "collapsed" && C !== "hidden" ? (vw[z] = !0, console.error(
        '"%s" is not a supported value for tail on <SuspenseList />. Did you mean "visible", "collapsed" or "hidden"?',
        C
      )) : y !== "forwards" && y !== "backwards" && y !== "unstable_legacy-backwards" && (vw[z] = !0, console.error(
        '<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?',
        C
      )));
      e: if ((y === "forwards" || y === "backwards" || y === "unstable_legacy-backwards") && A !== void 0 && A !== null && A !== !1)
        if (Ta(A)) {
          for (z = 0; z < A.length; z++)
            if (!$r(
              A[z],
              z
            ))
              break e;
        } else if (z = L(A), typeof z == "function") {
          if (z = z.call(A))
            for (var q = z.next(), Z = 0; !q.done; q = z.next()) {
              if (!$r(q.value, Z)) break e;
              Z++;
            }
        } else
          console.error(
            'A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?',
            y
          );
      if (Ga(n, o, A, s), Xn ? (mu(), A = Y2) : A = 0, !h && n !== null && (n.flags & 128) !== 0)
        e: for (n = o.child; n !== null; ) {
          if (n.tag === 13)
            n.memoizedState !== null && zv(n, s, o);
          else if (n.tag === 19)
            zv(n, s, o);
          else if (n.child !== null) {
            n.child.return = n, n = n.child;
            continue;
          }
          if (n === o) break e;
          for (; n.sibling === null; ) {
            if (n.return === null || n.return === o)
              break e;
            n = n.return;
          }
          n.sibling.return = n.return, n = n.sibling;
        }
      switch (y) {
        case "forwards":
          for (s = o.child, y = null; s !== null; )
            n = s.alternate, n !== null && gc(n) === null && (y = s), s = s.sibling;
          s = y, s === null ? (y = o.child, o.child = null) : (y = s.sibling, s.sibling = null), qp(
            o,
            !1,
            y,
            s,
            C,
            A
          );
          break;
        case "backwards":
        case "unstable_legacy-backwards":
          for (s = null, y = o.child, o.child = null; y !== null; ) {
            if (n = y.alternate, n !== null && gc(n) === null) {
              o.child = y;
              break;
            }
            n = y.sibling, y.sibling = s, s = y, y = n;
          }
          qp(
            o,
            !0,
            s,
            null,
            C,
            A
          );
          break;
        case "together":
          qp(
            o,
            !1,
            null,
            null,
            void 0,
            A
          );
          break;
        default:
          o.memoizedState = null;
      }
      return o.child;
    }
    function El(n, o, s) {
      if (n !== null && (o.dependencies = n.dependencies), Ni = -1, Rf |= o.lanes, (s & o.childLanes) === 0)
        if (n !== null) {
          if (bl(
            n,
            o,
            s,
            !1
          ), (s & o.childLanes) === 0)
            return null;
        } else return null;
      if (n !== null && o.child !== n.child)
        throw Error("Resuming work not yet implemented.");
      if (o.child !== null) {
        for (n = o.child, s = _l(n, n.pendingProps), o.child = s, s.return = o; n.sibling !== null; )
          n = n.sibling, s = s.sibling = _l(n, n.pendingProps), s.return = o;
        s.sibling = null;
      }
      return o.child;
    }
    function Kp(n, o) {
      return (n.lanes & o) !== 0 ? !0 : (n = n.dependencies, !!(n !== null && Cd(n)));
    }
    function Kb(n, o, s) {
      switch (o.tag) {
        case 3:
          J(
            o,
            o.stateNode.containerInfo
          ), qi(
            o,
            Ya,
            n.memoizedState.cache
          ), hu();
          break;
        case 27:
        case 5:
          X(o);
          break;
        case 4:
          J(
            o,
            o.stateNode.containerInfo
          );
          break;
        case 10:
          qi(
            o,
            o.type,
            o.memoizedProps.value
          );
          break;
        case 12:
          (s & o.childLanes) !== 0 && (o.flags |= 4), o.flags |= 2048;
          var h = o.stateNode;
          h.effectDuration = -0, h.passiveEffectDuration = -0;
          break;
        case 31:
          if (o.memoizedState !== null)
            return o.flags |= 128, Cl(o), null;
          break;
        case 13:
          if (h = o.memoizedState, h !== null)
            return h.dehydrated !== null ? (Lo(o), o.flags |= 128, null) : (s & o.child.childLanes) !== 0 ? Xp(
              n,
              o,
              s
            ) : (Lo(o), n = El(
              n,
              o,
              s
            ), n !== null ? n.sibling : null);
          Lo(o);
          break;
        case 19:
          var y = (n.flags & 128) !== 0;
          if (h = (s & o.childLanes) !== 0, h || (bl(
            n,
            o,
            s,
            !1
          ), h = (s & o.childLanes) !== 0), y) {
            if (h)
              return jv(
                n,
                o,
                s
              );
            o.flags |= 128;
          }
          if (y = o.memoizedState, y !== null && (y.rendering = null, y.tail = null, y.lastEffect = null), Y(
            Ha,
            Ha.current,
            o
          ), h) break;
          return null;
        case 22:
          return o.lanes = 0, Ov(
            n,
            o,
            s,
            o.pendingProps
          );
        case 24:
          qi(
            o,
            Ya,
            n.memoizedState.cache
          );
      }
      return El(n, o, s);
    }
    function Lm(n, o, s) {
      if (o._debugNeedsRemount && n !== null) {
        s = sc(
          o.type,
          o.key,
          o.pendingProps,
          o._debugOwner || null,
          o.mode,
          o.lanes
        ), s._debugStack = o._debugStack, s._debugTask = o._debugTask;
        var h = o.return;
        if (h === null) throw Error("Cannot swap the root fiber.");
        if (n.alternate = null, o.alternate = null, s.index = o.index, s.sibling = o.sibling, s.return = o.return, s.ref = o.ref, s._debugInfo = o._debugInfo, o === h.child)
          h.child = s;
        else {
          var y = h.child;
          if (y === null)
            throw Error("Expected parent to have a child.");
          for (; y.sibling !== o; )
            if (y = y.sibling, y === null)
              throw Error("Expected to find the previous sibling.");
          y.sibling = s;
        }
        return o = h.deletions, o === null ? (h.deletions = [n], h.flags |= 16) : o.push(n), s.flags |= 2, s;
      }
      if (n !== null)
        if (n.memoizedProps !== o.pendingProps || o.type !== n.type)
          Za = !0;
        else {
          if (!Kp(n, s) && (o.flags & 128) === 0)
            return Za = !1, Kb(
              n,
              o,
              s
            );
          Za = (n.flags & 131072) !== 0;
        }
      else
        Za = !1, (h = Xn) && (mu(), h = (o.flags & 1048576) !== 0), h && (h = o.index, mu(), lv(o, Y2, h));
      switch (o.lanes = 0, o.tag) {
        case 16:
          e: if (h = o.pendingProps, n = yi(o.elementType), o.type = n, typeof n == "function")
            av(n) ? (h = es(
              n,
              h
            ), o.tag = 1, o.type = n = du(n), o = Oc(
              null,
              o,
              n,
              h,
              s
            )) : (o.tag = 0, jd(o, n), o.type = n = du(n), o = Av(
              null,
              o,
              n,
              h,
              s
            ));
          else {
            if (n != null) {
              if (y = n.$$typeof, y === lf) {
                o.tag = 11, o.type = n = wp(n), o = Gb(
                  null,
                  o,
                  n,
                  h,
                  s
                );
                break e;
              } else if (y === dh) {
                o.tag = 14, o = kv(
                  null,
                  o,
                  n,
                  h,
                  s
                );
                break e;
              }
            }
            throw o = "", n !== null && typeof n == "object" && n.$$typeof === Eo && (o = " Did you wrap a component in React.lazy() more than once?"), s = F(n) || n, Error(
              "Element type is invalid. Received a promise that resolves to: " + s + ". Lazy element type must resolve to a class or function." + o
            );
          }
          return o;
        case 0:
          return Av(
            n,
            o,
            o.type,
            o.pendingProps,
            s
          );
        case 1:
          return h = o.type, y = es(
            h,
            o.pendingProps
          ), Oc(
            n,
            o,
            h,
            y,
            s
          );
        case 3:
          e: {
            if (J(
              o,
              o.stateNode.containerInfo
            ), n === null)
              throw Error(
                "Should have a current fiber. This is a bug in React."
              );
            h = o.pendingProps;
            var C = o.memoizedState;
            y = C.element, Xl(n, o), ql(o, h, null, s);
            var A = o.memoizedState;
            if (h = A.cache, qi(o, Ya, h), h !== C.cache && As(
              o,
              [Ya],
              s,
              !0
            ), kd(), h = A.element, C.isDehydrated)
              if (C = {
                element: h,
                isDehydrated: !1,
                cache: A.cache
              }, o.updateQueue.baseState = C, o.memoizedState = C, o.flags & 256) {
                o = Dv(
                  n,
                  o,
                  h,
                  s
                );
                break e;
              } else if (h !== y) {
                y = $o(
                  Error(
                    "This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."
                  ),
                  o
                ), mm(y), o = Dv(
                  n,
                  o,
                  h,
                  s
                );
                break e;
              } else {
                switch (n = o.stateNode.containerInfo, n.nodeType) {
                  case 9:
                    n = n.body;
                    break;
                  default:
                    n = n.nodeName === "HTML" ? n.ownerDocument.body : n;
                }
                for (qr = Mi(n.firstChild), Ko = o, Xn = !0, Cf = null, _u = !1, zl = null, ws = !0, s = i8(
                  o,
                  null,
                  h,
                  s
                ), o.child = s; s; )
                  s.flags = s.flags & -3 | 4096, s = s.sibling;
              }
            else {
              if (hu(), h === y) {
                o = El(
                  n,
                  o,
                  s
                );
                break e;
              }
              Ga(
                n,
                o,
                h,
                s
              );
            }
            o = o.child;
          }
          return o;
        case 26:
          return jm(n, o), n === null ? (s = g2(
            o.type,
            null,
            o.pendingProps,
            null
          )) ? o.memoizedState = s : Xn || (s = o.type, n = o.pendingProps, h = G(
            Oi.current
          ), h = Zm(
            h
          ).createElement(s), h[Xr] = o, h[qo] = n, Ur(h, s, n), Pt(h), o.stateNode = h) : o.memoizedState = g2(
            o.type,
            n.memoizedProps,
            o.pendingProps,
            n.memoizedState
          ), null;
        case 27:
          return X(o), n === null && Xn && (h = G(Oi.current), y = K(), h = o.stateNode = Gs(
            o.type,
            o.pendingProps,
            h,
            y,
            !1
          ), _u || (y = ri(
            h,
            o.type,
            o.pendingProps,
            y
          ), y !== null && (cc(o, 0).serverProps = y)), Ko = o, ws = !0, y = qr, ju(o.type) ? (R4 = y, qr = Mi(
            h.firstChild
          )) : qr = y), Ga(
            n,
            o,
            o.pendingProps.children,
            s
          ), jm(n, o), n === null && (o.flags |= 4194304), o.child;
        case 5:
          return n === null && Xn && (C = K(), h = Qt(
            o.type,
            C.ancestorInfo
          ), y = qr, (A = !y) || (A = Py(
            y,
            o.type,
            o.pendingProps,
            ws
          ), A !== null ? (o.stateNode = A, _u || (C = ri(
            A,
            o.type,
            o.pendingProps,
            C
          ), C !== null && (cc(o, 0).serverProps = C)), Ko = o, qr = Mi(
            A.firstChild
          ), ws = !1, C = !0) : C = !1, A = !C), A && (h && Co(o, y), Gi(o))), X(o), y = o.type, C = o.pendingProps, A = n !== null ? n.memoizedProps : null, h = C.children, Qd(y, C) ? h = null : A !== null && Qd(y, A) && (o.flags |= 32), o.memoizedState !== null && (y = vv(
            n,
            o,
            Cm,
            null,
            null,
            s
          ), T1._currentValue = y), jm(n, o), Ga(
            n,
            o,
            h,
            s
          ), o.child;
        case 6:
          return n === null && Xn && (s = o.pendingProps, n = K(), h = n.ancestorInfo.current, s = h != null ? nn(
            s,
            h.tag,
            n.ancestorInfo.implicitRootScope
          ) : !0, n = qr, (h = !n) || (h = ky(
            n,
            o.pendingProps,
            ws
          ), h !== null ? (o.stateNode = h, Ko = o, qr = null, h = !0) : h = !1, h = !h), h && (s && Co(o, n), Gi(o))), null;
        case 13:
          return Xp(n, o, s);
        case 4:
          return J(
            o,
            o.stateNode.containerInfo
          ), h = o.pendingProps, n === null ? o.child = Mh(
            o,
            null,
            h,
            s
          ) : Ga(
            n,
            o,
            h,
            s
          ), o.child;
        case 11:
          return Gb(
            n,
            o,
            o.type,
            o.pendingProps,
            s
          );
        case 7:
          return Ga(
            n,
            o,
            o.pendingProps,
            s
          ), o.child;
        case 8:
          return Ga(
            n,
            o,
            o.pendingProps.children,
            s
          ), o.child;
        case 12:
          return o.flags |= 4, o.flags |= 2048, h = o.stateNode, h.effectDuration = -0, h.passiveEffectDuration = -0, Ga(
            n,
            o,
            o.pendingProps.children,
            s
          ), o.child;
        case 10:
          return h = o.type, y = o.pendingProps, C = y.value, "value" in y || N8 || (N8 = !0, console.error(
            "The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"
          )), qi(o, h, C), Ga(
            n,
            o,
            y.children,
            s
          ), o.child;
        case 9:
          return y = o.type._context, h = o.pendingProps.children, typeof h != "function" && console.error(
            "A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."
          ), gu(o), y = cr(y), h = qC(
            h,
            y,
            void 0
          ), o.flags |= 1, Ga(
            n,
            o,
            h,
            s
          ), o.child;
        case 14:
          return kv(
            n,
            o,
            o.type,
            o.pendingProps,
            s
          );
        case 15:
          return Mv(
            n,
            o,
            o.type,
            o.pendingProps,
            s
          );
        case 19:
          return jv(
            n,
            o,
            s
          );
        case 31:
          return qb(n, o, s);
        case 22:
          return Ov(
            n,
            o,
            s,
            o.pendingProps
          );
        case 24:
          return gu(o), h = cr(Ya), n === null ? (y = $s(), y === null && (y = Lr, C = Pp(), y.pooledCache = C, fc(C), C !== null && (y.pooledCacheLanes |= s), y = C), o.memoizedState = {
            parent: h,
            cache: y
          }, _n(o), qi(o, Ya, y)) : ((n.lanes & s) !== 0 && (Xl(n, o), ql(o, null, null, s), kd()), y = n.memoizedState, C = o.memoizedState, y.parent !== h ? (y = {
            parent: h,
            cache: h
          }, o.memoizedState = y, o.lanes === 0 && (o.memoizedState = o.updateQueue.baseState = y), qi(o, Ya, h)) : (h = C.cache, qi(o, Ya, h), h !== y.cache && As(
            o,
            [Ya],
            s,
            !0
          ))), Ga(
            n,
            o,
            o.pendingProps.children,
            s
          ), o.child;
        case 29:
          throw o.pendingProps;
      }
      throw Error(
        "Unknown unit of work tag (" + o.tag + "). This error is likely caused by a bug in React. Please file an issue."
      );
    }
    function ts(n) {
      n.flags |= 4;
    }
    function Yp(n, o, s, h, y) {
      if ((o = (n.mode & ZO) !== on) && (o = !1), o) {
        if (n.flags |= 16777216, (y & 335544128) === y)
          if (n.stateNode.complete) n.flags |= 8192;
          else if (e2()) n.flags |= 8192;
          else
            throw kh = dw, YC;
      } else n.flags &= -16777217;
    }
    function Yb(n, o) {
      if (o.type !== "stylesheet" || (o.state.loading & Es) !== Lh)
        n.flags &= -16777217;
      else if (n.flags |= 16777216, !Vn(o))
        if (e2()) n.flags |= 8192;
        else
          throw kh = dw, YC;
    }
    function Ld(n, o) {
      o !== null && (n.flags |= 4), n.flags & 16384 && (o = n.tag !== 22 ? dt() : 536870912, n.lanes |= o, Nh |= o);
    }
    function Hd(n, o) {
      if (!Xn)
        switch (n.tailMode) {
          case "hidden":
            o = n.tail;
            for (var s = null; o !== null; )
              o.alternate !== null && (s = o), o = o.sibling;
            s === null ? n.tail = null : s.sibling = null;
            break;
          case "collapsed":
            s = n.tail;
            for (var h = null; s !== null; )
              s.alternate !== null && (h = s), s = s.sibling;
            h === null ? o || n.tail === null ? n.tail = null : n.tail.sibling = null : h.sibling = null;
        }
    }
    function Pr(n) {
      var o = n.alternate !== null && n.alternate.child === n.child, s = 0, h = 0;
      if (o)
        if ((n.mode & An) !== on) {
          for (var y = n.selfBaseDuration, C = n.child; C !== null; )
            s |= C.lanes | C.childLanes, h |= C.subtreeFlags & 65011712, h |= C.flags & 65011712, y += C.treeBaseDuration, C = C.sibling;
          n.treeBaseDuration = y;
        } else
          for (y = n.child; y !== null; )
            s |= y.lanes | y.childLanes, h |= y.subtreeFlags & 65011712, h |= y.flags & 65011712, y.return = n, y = y.sibling;
      else if ((n.mode & An) !== on) {
        y = n.actualDuration, C = n.selfBaseDuration;
        for (var A = n.child; A !== null; )
          s |= A.lanes | A.childLanes, h |= A.subtreeFlags, h |= A.flags, y += A.actualDuration, C += A.treeBaseDuration, A = A.sibling;
        n.actualDuration = y, n.treeBaseDuration = C;
      } else
        for (y = n.child; y !== null; )
          s |= y.lanes | y.childLanes, h |= y.subtreeFlags, h |= y.flags, y.return = n, y = y.sibling;
      return n.subtreeFlags |= h, n.childLanes = s, o;
    }
    function Iv(n, o, s) {
      var h = o.pendingProps;
      switch (xp(o), o.tag) {
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
          return Pr(o), null;
        case 1:
          return Pr(o), null;
        case 3:
          return s = o.stateNode, h = null, n !== null && (h = n.memoizedState.cache), o.memoizedState.cache !== h && (o.flags |= 2048), vl(Ya, o), H(o), s.pendingContext && (s.context = s.pendingContext, s.pendingContext = null), (n === null || n.child === null) && (dc(o) ? (pu(), ts(o)) : n === null || n.memoizedState.isDehydrated && (o.flags & 256) === 0 || (o.flags |= 1024, fm())), Pr(o), null;
        case 26:
          var y = o.type, C = o.memoizedState;
          return n === null ? (ts(o), C !== null ? (Pr(o), Yb(
            o,
            C
          )) : (Pr(o), Yp(
            o,
            y,
            null,
            h,
            s
          ))) : C ? C !== n.memoizedState ? (ts(o), Pr(o), Yb(
            o,
            C
          )) : (Pr(o), o.flags &= -16777217) : (n = n.memoizedProps, n !== h && ts(o), Pr(o), Yp(
            o,
            y,
            n,
            h,
            s
          )), null;
        case 27:
          if (te(o), s = G(Oi.current), y = o.type, n !== null && o.stateNode != null)
            n.memoizedProps !== h && ts(o);
          else {
            if (!h) {
              if (o.stateNode === null)
                throw Error(
                  "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue."
                );
              return Pr(o), null;
            }
            n = K(), dc(o) ? sv(o) : (n = Gs(
              y,
              h,
              s,
              n,
              !0
            ), o.stateNode = n, ts(o));
          }
          return Pr(o), null;
        case 5:
          if (te(o), y = o.type, n !== null && o.stateNode != null)
            n.memoizedProps !== h && ts(o);
          else {
            if (!h) {
              if (o.stateNode === null)
                throw Error(
                  "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue."
                );
              return Pr(o), null;
            }
            var A = K();
            if (dc(o))
              sv(o);
            else {
              switch (C = G(Oi.current), Qt(y, A.ancestorInfo), A = A.context, C = Zm(C), A) {
                case y0:
                  C = C.createElementNS(
                    Pn,
                    y
                  );
                  break;
                case Iw:
                  C = C.createElementNS(
                    vn,
                    y
                  );
                  break;
                default:
                  switch (y) {
                    case "svg":
                      C = C.createElementNS(
                        Pn,
                        y
                      );
                      break;
                    case "math":
                      C = C.createElementNS(
                        vn,
                        y
                      );
                      break;
                    case "script":
                      C = C.createElement("div"), C.innerHTML = "<script><\/script>", C = C.removeChild(
                        C.firstChild
                      );
                      break;
                    case "select":
                      C = typeof h.is == "string" ? C.createElement("select", {
                        is: h.is
                      }) : C.createElement("select"), h.multiple ? C.multiple = !0 : h.size && (C.size = h.size);
                      break;
                    default:
                      C = typeof h.is == "string" ? C.createElement(y, {
                        is: h.is
                      }) : C.createElement(y), y.indexOf("-") === -1 && (y !== y.toLowerCase() && console.error(
                        "<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.",
                        y
                      ), Object.prototype.toString.call(C) !== "[object HTMLUnknownElement]" || Ti.call(n5, y) || (n5[y] = !0, console.error(
                        "The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.",
                        y
                      )));
                  }
              }
              C[Xr] = o, C[qo] = h;
              e: for (A = o.child; A !== null; ) {
                if (A.tag === 5 || A.tag === 6)
                  C.appendChild(A.stateNode);
                else if (A.tag !== 4 && A.tag !== 27 && A.child !== null) {
                  A.child.return = A, A = A.child;
                  continue;
                }
                if (A === o) break e;
                for (; A.sibling === null; ) {
                  if (A.return === null || A.return === o)
                    break e;
                  A = A.return;
                }
                A.sibling.return = A.return, A = A.sibling;
              }
              o.stateNode = C;
              e: switch (Ur(C, y, h), y) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  h = !!h.autoFocus;
                  break e;
                case "img":
                  h = !0;
                  break e;
                default:
                  h = !1;
              }
              h && ts(o);
            }
          }
          return Pr(o), Yp(
            o,
            o.type,
            n === null ? null : n.memoizedProps,
            o.pendingProps,
            s
          ), null;
        case 6:
          if (n && o.stateNode != null)
            n.memoizedProps !== h && ts(o);
          else {
            if (typeof h != "string" && o.stateNode === null)
              throw Error(
                "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue."
              );
            if (n = G(Oi.current), s = K(), dc(o)) {
              if (n = o.stateNode, s = o.memoizedProps, y = !_u, h = null, C = Ko, C !== null)
                switch (C.tag) {
                  case 3:
                    y && (y = Ty(
                      n,
                      s,
                      h
                    ), y !== null && (cc(o, 0).serverProps = y));
                    break;
                  case 27:
                  case 5:
                    h = C.memoizedProps, y && (y = Ty(
                      n,
                      s,
                      h
                    ), y !== null && (cc(
                      o,
                      0
                    ).serverProps = y));
                }
              n[Xr] = o, n = !!(n.nodeValue === s || h !== null && h.suppressHydrationWarning === !0 || c2(n.nodeValue, s)), n || Gi(o, !0);
            } else
              y = s.ancestorInfo.current, y != null && nn(
                h,
                y.tag,
                s.ancestorInfo.implicitRootScope
              ), n = Zm(n).createTextNode(
                h
              ), n[Xr] = o, o.stateNode = n;
          }
          return Pr(o), null;
        case 31:
          if (s = o.memoizedState, n === null || n.memoizedState !== null) {
            if (h = dc(o), s !== null) {
              if (n === null) {
                if (!h)
                  throw Error(
                    "A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React."
                  );
                if (n = o.memoizedState, n = n !== null ? n.dehydrated : null, !n)
                  throw Error(
                    "Expected to have a hydrated activity instance. This error is likely caused by a bug in React. Please file an issue."
                  );
                n[Xr] = o, Pr(o), (o.mode & An) !== on && s !== null && (n = o.child, n !== null && (o.treeBaseDuration -= n.treeBaseDuration));
              } else
                pu(), hu(), (o.flags & 128) === 0 && (s = o.memoizedState = null), o.flags |= 4, Pr(o), (o.mode & An) !== on && s !== null && (n = o.child, n !== null && (o.treeBaseDuration -= n.treeBaseDuration));
              n = !1;
            } else
              s = fm(), n !== null && n.memoizedState !== null && (n.memoizedState.hydrationErrors = s), n = !0;
            if (!n)
              return o.flags & 256 ? (Ua(o), o) : (Ua(o), null);
            if ((o.flags & 128) !== 0)
              throw Error(
                "Client rendering an Activity suspended it again. This is a bug in React."
              );
          }
          return Pr(o), null;
        case 13:
          if (h = o.memoizedState, n === null || n.memoizedState !== null && n.memoizedState.dehydrated !== null) {
            if (y = h, C = dc(o), y !== null && y.dehydrated !== null) {
              if (n === null) {
                if (!C)
                  throw Error(
                    "A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React."
                  );
                if (C = o.memoizedState, C = C !== null ? C.dehydrated : null, !C)
                  throw Error(
                    "Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue."
                  );
                C[Xr] = o, Pr(o), (o.mode & An) !== on && y !== null && (y = o.child, y !== null && (o.treeBaseDuration -= y.treeBaseDuration));
              } else
                pu(), hu(), (o.flags & 128) === 0 && (y = o.memoizedState = null), o.flags |= 4, Pr(o), (o.mode & An) !== on && y !== null && (y = o.child, y !== null && (o.treeBaseDuration -= y.treeBaseDuration));
              y = !1;
            } else
              y = fm(), n !== null && n.memoizedState !== null && (n.memoizedState.hydrationErrors = y), y = !0;
            if (!y)
              return o.flags & 256 ? (Ua(o), o) : (Ua(o), null);
          }
          return Ua(o), (o.flags & 128) !== 0 ? (o.lanes = s, (o.mode & An) !== on && hc(o), o) : (s = h !== null, n = n !== null && n.memoizedState !== null, s && (h = o.child, y = null, h.alternate !== null && h.alternate.memoizedState !== null && h.alternate.memoizedState.cachePool !== null && (y = h.alternate.memoizedState.cachePool.pool), C = null, h.memoizedState !== null && h.memoizedState.cachePool !== null && (C = h.memoizedState.cachePool.pool), C !== y && (h.flags |= 2048)), s !== n && s && (o.child.flags |= 8192), Ld(o, o.updateQueue), Pr(o), (o.mode & An) !== on && s && (n = o.child, n !== null && (o.treeBaseDuration -= n.treeBaseDuration)), null);
        case 4:
          return H(o), n === null && $u(
            o.stateNode.containerInfo
          ), Pr(o), null;
        case 10:
          return vl(o.type, o), Pr(o), null;
        case 19:
          if (U(Ha, o), h = o.memoizedState, h === null) return Pr(o), null;
          if (y = (o.flags & 128) !== 0, C = h.rendering, C === null)
            if (y) Hd(h, !1);
            else {
              if (ha !== nd || n !== null && (n.flags & 128) !== 0)
                for (n = o.child; n !== null; ) {
                  if (C = gc(n), C !== null) {
                    for (o.flags |= 128, Hd(h, !1), n = C.updateQueue, o.updateQueue = n, Ld(o, n), o.subtreeFlags = 0, n = s, s = o.child; s !== null; )
                      ov(s, n), s = s.sibling;
                    return Y(
                      Ha,
                      Ha.current & l0 | d1,
                      o
                    ), Xn && gl(o, h.treeForkCount), o.child;
                  }
                  n = n.sibling;
                }
              h.tail !== null && Ka() > Ew && (o.flags |= 128, y = !0, Hd(h, !1), o.lanes = 4194304);
            }
          else {
            if (!y)
              if (n = gc(C), n !== null) {
                if (o.flags |= 128, y = !0, n = n.updateQueue, o.updateQueue = n, Ld(o, n), Hd(h, !0), h.tail === null && h.tailMode === "hidden" && !C.alternate && !Xn)
                  return Pr(o), null;
              } else
                2 * Ka() - h.renderingStartTime > Ew && s !== 536870912 && (o.flags |= 128, y = !0, Hd(h, !1), o.lanes = 4194304);
            h.isBackwards ? (C.sibling = o.child, o.child = C) : (n = h.last, n !== null ? n.sibling = C : o.child = C, h.last = C);
          }
          return h.tail !== null ? (n = h.tail, h.rendering = n, h.tail = n.sibling, h.renderingStartTime = Ka(), n.sibling = null, s = Ha.current, s = y ? s & l0 | d1 : s & l0, Y(Ha, s, o), Xn && gl(o, h.treeForkCount), n) : (Pr(o), null);
        case 22:
        case 23:
          return Ua(o), Sl(o), h = o.memoizedState !== null, n !== null ? n.memoizedState !== null !== h && (o.flags |= 8192) : h && (o.flags |= 8192), h ? (s & 536870912) !== 0 && (o.flags & 128) === 0 && (Pr(o), o.subtreeFlags & 6 && (o.flags |= 8192)) : Pr(o), s = o.updateQueue, s !== null && Ld(o, s.retryQueue), s = null, n !== null && n.memoizedState !== null && n.memoizedState.cachePool !== null && (s = n.memoizedState.cachePool.pool), h = null, o.memoizedState !== null && o.memoizedState.cachePool !== null && (h = o.memoizedState.cachePool.pool), h !== s && (o.flags |= 2048), n !== null && U(Eh, o), null;
        case 24:
          return s = null, n !== null && (s = n.memoizedState.cache), o.memoizedState.cache !== s && (o.flags |= 2048), vl(Ya, o), Pr(o), null;
        case 25:
          return null;
        case 30:
          return null;
      }
      throw Error(
        "Unknown unit of work tag (" + o.tag + "). This error is likely caused by a bug in React. Please file an issue."
      );
    }
    function Qb(n, o) {
      switch (xp(o), o.tag) {
        case 1:
          return n = o.flags, n & 65536 ? (o.flags = n & -65537 | 128, (o.mode & An) !== on && hc(o), o) : null;
        case 3:
          return vl(Ya, o), H(o), n = o.flags, (n & 65536) !== 0 && (n & 128) === 0 ? (o.flags = n & -65537 | 128, o) : null;
        case 26:
        case 27:
        case 5:
          return te(o), null;
        case 31:
          if (o.memoizedState !== null) {
            if (Ua(o), o.alternate === null)
              throw Error(
                "Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue."
              );
            hu();
          }
          return n = o.flags, n & 65536 ? (o.flags = n & -65537 | 128, (o.mode & An) !== on && hc(o), o) : null;
        case 13:
          if (Ua(o), n = o.memoizedState, n !== null && n.dehydrated !== null) {
            if (o.alternate === null)
              throw Error(
                "Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue."
              );
            hu();
          }
          return n = o.flags, n & 65536 ? (o.flags = n & -65537 | 128, (o.mode & An) !== on && hc(o), o) : null;
        case 19:
          return U(Ha, o), null;
        case 4:
          return H(o), null;
        case 10:
          return vl(o.type, o), null;
        case 22:
        case 23:
          return Ua(o), Sl(o), n !== null && U(Eh, o), n = o.flags, n & 65536 ? (o.flags = n & -65537 | 128, (o.mode & An) !== on && hc(o), o) : null;
        case 24:
          return vl(Ya, o), null;
        case 25:
          return null;
        default:
          return null;
      }
    }
    function Lv(n, o) {
      switch (xp(o), o.tag) {
        case 3:
          vl(Ya, o), H(o);
          break;
        case 26:
        case 27:
        case 5:
          te(o);
          break;
        case 4:
          H(o);
          break;
        case 31:
          o.memoizedState !== null && Ua(o);
          break;
        case 13:
          Ua(o);
          break;
        case 19:
          U(Ha, o);
          break;
        case 10:
          vl(o.type, o);
          break;
        case 22:
        case 23:
          Ua(o), Sl(o), n !== null && U(Eh, o);
          break;
        case 24:
          vl(Ya, o);
      }
    }
    function ns(n) {
      return (n.mode & An) !== on;
    }
    function Jb(n, o) {
      ns(n) ? (ca(), Vs(o, n), jo()) : Vs(o, n);
    }
    function Qp(n, o, s) {
      ns(n) ? (ca(), Ou(
        s,
        n,
        o
      ), jo()) : Ou(
        s,
        n,
        o
      );
    }
    function Vs(n, o) {
      try {
        var s = o.updateQueue, h = s !== null ? s.lastEffect : null;
        if (h !== null) {
          var y = h.next;
          s = y;
          do {
            if ((s.tag & n) === n && (h = void 0, (n & Di) !== mw && (g0 = !0), h = le(
              o,
              iT,
              s
            ), (n & Di) !== mw && (g0 = !1), h !== void 0 && typeof h != "function")) {
              var C = void 0;
              C = (s.tag & Il) !== 0 ? "useLayoutEffect" : (s.tag & Di) !== 0 ? "useInsertionEffect" : "useEffect";
              var A = void 0;
              A = h === null ? " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof h.then == "function" ? `

It looks like you wrote ` + C + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + C + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://react.dev/link/hooks-data-fetching` : " You returned: " + h, le(
                o,
                function(z, q) {
                  console.error(
                    "%s must not return anything besides a function, which is used for clean-up.%s",
                    z,
                    q
                  );
                },
                C,
                A
              );
            }
            s = s.next;
          } while (s !== y);
        }
      } catch (z) {
        En(o, o.return, z);
      }
    }
    function Ou(n, o, s) {
      try {
        var h = o.updateQueue, y = h !== null ? h.lastEffect : null;
        if (y !== null) {
          var C = y.next;
          h = C;
          do {
            if ((h.tag & n) === n) {
              var A = h.inst, z = A.destroy;
              z !== void 0 && (A.destroy = void 0, (n & Di) !== mw && (g0 = !0), y = o, le(
                y,
                lT,
                y,
                s,
                z
              ), (n & Di) !== mw && (g0 = !1));
            }
            h = h.next;
          } while (h !== C);
        }
      } catch (q) {
        En(o, o.return, q);
      }
    }
    function Hm(n, o) {
      ns(n) ? (ca(), Vs(o, n), jo()) : Vs(o, n);
    }
    function Jp(n, o, s) {
      ns(n) ? (ca(), Ou(
        s,
        n,
        o
      ), jo()) : Ou(
        s,
        n,
        o
      );
    }
    function Hv(n) {
      var o = n.updateQueue;
      if (o !== null) {
        var s = n.stateNode;
        n.type.defaultProps || "ref" in n.memoizedProps || d0 || (s.props !== n.memoizedProps && console.error(
          "Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
          W(n) || "instance"
        ), s.state !== n.memoizedState && console.error(
          "Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
          W(n) || "instance"
        ));
        try {
          le(
            n,
            Md,
            o,
            s
          );
        } catch (h) {
          En(n, n.return, h);
        }
      }
    }
    function Fm(n, o, s) {
      return n.getSnapshotBeforeUpdate(o, s);
    }
    function Zb(n, o) {
      var s = o.memoizedProps, h = o.memoizedState;
      o = n.stateNode, n.type.defaultProps || "ref" in n.memoizedProps || d0 || (o.props !== n.memoizedProps && console.error(
        "Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
        W(n) || "instance"
      ), o.state !== n.memoizedState && console.error(
        "Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
        W(n) || "instance"
      ));
      try {
        var y = es(
          n.type,
          s
        ), C = le(
          n,
          Fm,
          o,
          y,
          h
        );
        s = D8, C !== void 0 || s.has(n.type) || (s.add(n.type), le(n, function() {
          console.error(
            "%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.",
            W(n)
          );
        })), o.__reactInternalSnapshotBeforeUpdate = C;
      } catch (A) {
        En(n, n.return, A);
      }
    }
    function Zp(n, o, s) {
      s.props = es(
        n.type,
        n.memoizedProps
      ), s.state = n.memoizedState, ns(n) ? (ca(), le(
        n,
        J6,
        n,
        o,
        s
      ), jo()) : le(
        n,
        J6,
        n,
        o,
        s
      );
    }
    function ey(n) {
      var o = n.ref;
      if (o !== null) {
        switch (n.tag) {
          case 26:
          case 27:
          case 5:
            var s = n.stateNode;
            break;
          case 30:
            s = n.stateNode;
            break;
          default:
            s = n.stateNode;
        }
        if (typeof o == "function")
          if (ns(n))
            try {
              ca(), n.refCleanup = o(s);
            } finally {
              jo();
            }
          else n.refCleanup = o(s);
        else
          typeof o == "string" ? console.error("String refs are no longer supported.") : o.hasOwnProperty("current") || console.error(
            "Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().",
            W(n)
          ), o.current = s;
      }
    }
    function Tc(n, o) {
      try {
        le(n, ey, n);
      } catch (s) {
        En(n, o, s);
      }
    }
    function Zi(n, o) {
      var s = n.ref, h = n.refCleanup;
      if (s !== null)
        if (typeof h == "function")
          try {
            if (ns(n))
              try {
                ca(), le(n, h);
              } finally {
                jo(n);
              }
            else le(n, h);
          } catch (y) {
            En(n, o, y);
          } finally {
            n.refCleanup = null, n = n.alternate, n != null && (n.refCleanup = null);
          }
        else if (typeof s == "function")
          try {
            if (ns(n))
              try {
                ca(), le(n, s, null);
              } finally {
                jo(n);
              }
            else le(n, s, null);
          } catch (y) {
            En(n, o, y);
          }
        else s.current = null;
    }
    function Fv(n, o, s, h) {
      var y = n.memoizedProps, C = y.id, A = y.onCommit;
      y = y.onRender, o = o === null ? "mount" : "update", lw && (o = "nested-update"), typeof y == "function" && y(
        C,
        o,
        n.actualDuration,
        n.treeBaseDuration,
        n.actualStartTime,
        s
      ), typeof A == "function" && A(C, o, h, s);
    }
    function ty(n, o, s, h) {
      var y = n.memoizedProps;
      n = y.id, y = y.onPostCommit, o = o === null ? "mount" : "update", lw && (o = "nested-update"), typeof y == "function" && y(
        n,
        o,
        h,
        s
      );
    }
    function Tu(n) {
      var o = n.type, s = n.memoizedProps, h = n.stateNode;
      try {
        le(
          n,
          hy,
          h,
          o,
          s,
          n
        );
      } catch (y) {
        En(n, n.return, y);
      }
    }
    function eg(n, o, s) {
      try {
        le(
          n,
          wg,
          n.stateNode,
          n.type,
          s,
          o,
          n
        );
      } catch (h) {
        En(n, n.return, h);
      }
    }
    function Wv(n) {
      return n.tag === 5 || n.tag === 3 || n.tag === 26 || n.tag === 27 && ju(n.type) || n.tag === 4;
    }
    function tg(n) {
      e: for (; ; ) {
        for (; n.sibling === null; ) {
          if (n.return === null || Wv(n.return)) return null;
          n = n.return;
        }
        for (n.sibling.return = n.return, n = n.sibling; n.tag !== 5 && n.tag !== 6 && n.tag !== 18; ) {
          if (n.tag === 27 && ju(n.type) || n.flags & 2 || n.child === null || n.tag === 4) continue e;
          n.child.return = n, n = n.child;
        }
        if (!(n.flags & 2)) return n.stateNode;
      }
    }
    function Fd(n, o, s) {
      var h = n.tag;
      if (h === 5 || h === 6)
        n = n.stateNode, o ? (gy(s), (s.nodeType === 9 ? s.body : s.nodeName === "HTML" ? s.ownerDocument.body : s).insertBefore(n, o)) : (gy(s), o = s.nodeType === 9 ? s.body : s.nodeName === "HTML" ? s.ownerDocument.body : s, o.appendChild(n), s = s._reactRootContainer, s != null || o.onclick !== null || (o.onclick = tr));
      else if (h !== 4 && (h === 27 && ju(n.type) && (s = n.stateNode, o = null), n = n.child, n !== null))
        for (Fd(n, o, s), n = n.sibling; n !== null; )
          Fd(n, o, s), n = n.sibling;
    }
    function Wm(n, o, s) {
      var h = n.tag;
      if (h === 5 || h === 6)
        n = n.stateNode, o ? s.insertBefore(n, o) : s.appendChild(n);
      else if (h !== 4 && (h === 27 && ju(n.type) && (s = n.stateNode), n = n.child, n !== null))
        for (Wm(n, o, s), n = n.sibling; n !== null; )
          Wm(n, o, s), n = n.sibling;
    }
    function Vv(n) {
      for (var o, s = n.return; s !== null; ) {
        if (Wv(s)) {
          o = s;
          break;
        }
        s = s.return;
      }
      if (o == null)
        throw Error(
          "Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue."
        );
      switch (o.tag) {
        case 27:
          o = o.stateNode, s = tg(n), Wm(
            n,
            s,
            o
          );
          break;
        case 5:
          s = o.stateNode, o.flags & 32 && (Sg(s), o.flags &= -33), o = tg(n), Wm(
            n,
            o,
            s
          );
          break;
        case 3:
        case 4:
          o = o.stateNode.containerInfo, s = tg(n), Fd(
            n,
            s,
            o
          );
          break;
        default:
          throw Error(
            "Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue."
          );
      }
    }
    function _v(n) {
      var o = n.stateNode, s = n.memoizedProps;
      try {
        le(
          n,
          cs,
          n.type,
          s,
          o,
          n
        );
      } catch (h) {
        En(n, n.return, h);
      }
    }
    function Bv(n, o) {
      return o.tag === 31 ? (o = o.memoizedState, n.memoizedState !== null && o === null) : o.tag === 13 ? (n = n.memoizedState, o = o.memoizedState, n !== null && n.dehydrated !== null && (o === null || o.dehydrated === null)) : o.tag === 3 ? n.memoizedState.isDehydrated && (o.flags & 256) === 0 : !1;
    }
    function vC(n, o) {
      if (n = n.containerInfo, M4 = Ww, n = gp(n), Q0(n)) {
        if ("selectionStart" in n)
          var s = {
            start: n.selectionStart,
            end: n.selectionEnd
          };
        else
          e: {
            s = (s = n.ownerDocument) && s.defaultView || window;
            var h = s.getSelection && s.getSelection();
            if (h && h.rangeCount !== 0) {
              s = h.anchorNode;
              var y = h.anchorOffset, C = h.focusNode;
              h = h.focusOffset;
              try {
                s.nodeType, C.nodeType;
              } catch {
                s = null;
                break e;
              }
              var A = 0, z = -1, q = -1, Z = 0, xe = 0, ke = n, de = null;
              t: for (; ; ) {
                for (var Ve; ke !== s || y !== 0 && ke.nodeType !== 3 || (z = A + y), ke !== C || h !== 0 && ke.nodeType !== 3 || (q = A + h), ke.nodeType === 3 && (A += ke.nodeValue.length), (Ve = ke.firstChild) !== null; )
                  de = ke, ke = Ve;
                for (; ; ) {
                  if (ke === n) break t;
                  if (de === s && ++Z === y && (z = A), de === C && ++xe === h && (q = A), (Ve = ke.nextSibling) !== null) break;
                  ke = de, de = ke.parentNode;
                }
                ke = Ve;
              }
              s = z === -1 || q === -1 ? null : { start: z, end: q };
            } else s = null;
          }
        s = s || { start: 0, end: 0 };
      } else s = null;
      for (O4 = {
        focusedElem: n,
        selectionRange: s
      }, Ww = !1, Mo = o; Mo !== null; )
        if (o = Mo, n = o.child, (o.subtreeFlags & 1028) !== 0 && n !== null)
          n.return = o, Mo = n;
        else
          for (; Mo !== null; ) {
            switch (n = o = Mo, s = n.alternate, y = n.flags, n.tag) {
              case 0:
                if ((y & 4) !== 0 && (n = n.updateQueue, n = n !== null ? n.events : null, n !== null))
                  for (s = 0; s < n.length; s++)
                    y = n[s], y.ref.impl = y.nextImpl;
                break;
              case 11:
              case 15:
                break;
              case 1:
                (y & 1024) !== 0 && s !== null && Zb(n, s);
                break;
              case 3:
                if ((y & 1024) !== 0) {
                  if (n = n.stateNode.containerInfo, s = n.nodeType, s === 9)
                    Zd(n);
                  else if (s === 1)
                    switch (n.nodeName) {
                      case "HEAD":
                      case "HTML":
                      case "BODY":
                        Zd(n);
                        break;
                      default:
                        n.textContent = "";
                    }
                }
                break;
              case 5:
              case 26:
              case 27:
              case 6:
              case 4:
              case 17:
                break;
              default:
                if ((y & 1024) !== 0)
                  throw Error(
                    "This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue."
                  );
            }
            if (n = o.sibling, n !== null) {
              n.return = o.return, Mo = n;
              break;
            }
            Mo = o.return;
          }
    }
    function ng(n, o, s) {
      var h = _r(), y = Ki(), C = vi(), A = Yi(), z = s.flags;
      switch (s.tag) {
        case 0:
        case 11:
        case 15:
          xi(n, s), z & 4 && Jb(s, Il | Cs);
          break;
        case 1:
          if (xi(n, s), z & 4)
            if (n = s.stateNode, o === null)
              s.type.defaultProps || "ref" in s.memoizedProps || d0 || (n.props !== s.memoizedProps && console.error(
                "Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
                W(s) || "instance"
              ), n.state !== s.memoizedState && console.error(
                "Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
                W(s) || "instance"
              )), ns(s) ? (ca(), le(
                s,
                KC,
                s,
                n
              ), jo()) : le(
                s,
                KC,
                s,
                n
              );
            else {
              var q = es(
                s.type,
                o.memoizedProps
              );
              o = o.memoizedState, s.type.defaultProps || "ref" in s.memoizedProps || d0 || (n.props !== s.memoizedProps && console.error(
                "Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
                W(s) || "instance"
              ), n.state !== s.memoizedState && console.error(
                "Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
                W(s) || "instance"
              )), ns(s) ? (ca(), le(
                s,
                K6,
                s,
                n,
                q,
                o,
                n.__reactInternalSnapshotBeforeUpdate
              ), jo()) : le(
                s,
                K6,
                s,
                n,
                q,
                o,
                n.__reactInternalSnapshotBeforeUpdate
              );
            }
          z & 64 && Hv(s), z & 512 && Tc(s, s.return);
          break;
        case 3:
          if (o = Ul(), xi(n, s), z & 64 && (z = s.updateQueue, z !== null)) {
            if (q = null, s.child !== null)
              switch (s.child.tag) {
                case 27:
                case 5:
                  q = s.child.stateNode;
                  break;
                case 1:
                  q = s.child.stateNode;
              }
            try {
              le(
                s,
                Md,
                z,
                q
              );
            } catch (xe) {
              En(s, s.return, xe);
            }
          }
          n.effectDuration += xd(o);
          break;
        case 27:
          o === null && z & 4 && _v(s);
        case 26:
        case 5:
          if (xi(n, s), o === null) {
            if (z & 4) Tu(s);
            else if (z & 64) {
              n = s.type, o = s.memoizedProps, q = s.stateNode;
              try {
                le(
                  s,
                  py,
                  q,
                  n,
                  o,
                  s
                );
              } catch (xe) {
                En(
                  s,
                  s.return,
                  xe
                );
              }
            }
          }
          z & 512 && Tc(s, s.return);
          break;
        case 12:
          if (z & 4) {
            z = Ul(), xi(n, s), n = s.stateNode, n.effectDuration += zo(z);
            try {
              le(
                s,
                Fv,
                s,
                o,
                xf,
                n.effectDuration
              );
            } catch (xe) {
              En(s, s.return, xe);
            }
          } else xi(n, s);
          break;
        case 31:
          xi(n, s), z & 4 && Xv(n, s);
          break;
        case 13:
          xi(n, s), z & 4 && Gv(n, s), z & 64 && (n = s.memoizedState, n !== null && (n = n.dehydrated, n !== null && (z = Bs.bind(
            null,
            s
          ), My(n, z))));
          break;
        case 22:
          if (z = s.memoizedState !== null || td, !z) {
            o = o !== null && o.memoizedState !== null || eo, q = td;
            var Z = eo;
            td = z, (eo = o) && !Z ? (Pl(
              n,
              s,
              (s.subtreeFlags & 8772) !== 0
            ), (s.mode & An) !== on && 0 <= Bt && 0 <= tn && 0.05 < tn - Bt && vp(
              s,
              Bt,
              tn
            )) : xi(n, s), td = q, eo = Z;
          }
          break;
        case 30:
          break;
        default:
          xi(n, s);
      }
      (s.mode & An) !== on && 0 <= Bt && 0 <= tn && ((Ca || 0.05 < ma) && pl(
        s,
        Bt,
        tn,
        ma,
        na
      ), s.alternate === null && s.return !== null && s.return.alternate !== null && 0.05 < tn - Bt && (Bv(
        s.return.alternate,
        s.return
      ) || Xi(
        s,
        Bt,
        tn,
        "Mount"
      ))), _a(h), gi(y), na = C, Ca = A;
    }
    function wa(n) {
      var o = n.alternate;
      o !== null && (n.alternate = null, wa(o)), n.child = null, n.deletions = null, n.sibling = null, n.tag === 5 && (o = n.stateNode, o !== null && st(o)), n.stateNode = null, n._debugOwner = null, n.return = null, n.dependencies = null, n.memoizedProps = null, n.memoizedState = null, n.pendingProps = null, n.stateNode = null, n.updateQueue = null;
    }
    function Wr(n, o, s) {
      for (s = s.child; s !== null; )
        Uv(
          n,
          o,
          s
        ), s = s.sibling;
    }
    function Uv(n, o, s) {
      if (Ia && typeof Ia.onCommitFiberUnmount == "function")
        try {
          Ia.onCommitFiberUnmount(Vc, s);
        } catch (Z) {
          fs || (fs = !0, console.error(
            "React instrumentation encountered an error: %o",
            Z
          ));
        }
      var h = _r(), y = Ki(), C = vi(), A = Yi();
      switch (s.tag) {
        case 26:
          eo || Zi(s, o), Wr(
            n,
            o,
            s
          ), s.memoizedState ? s.memoizedState.count-- : s.stateNode && (n = s.stateNode, n.parentNode.removeChild(n));
          break;
        case 27:
          eo || Zi(s, o);
          var z = to, q = al;
          ju(s.type) && (to = s.stateNode, al = !1), Wr(
            n,
            o,
            s
          ), le(
            s,
            qs,
            s.stateNode
          ), to = z, al = q;
          break;
        case 5:
          eo || Zi(s, o);
        case 6:
          if (z = to, q = al, to = null, Wr(
            n,
            o,
            s
          ), to = z, al = q, to !== null)
            if (al)
              try {
                le(
                  s,
                  by,
                  to,
                  s.stateNode
                );
              } catch (Z) {
                En(
                  s,
                  o,
                  Z
                );
              }
            else
              try {
                le(
                  s,
                  vy,
                  to,
                  s.stateNode
                );
              } catch (Z) {
                En(
                  s,
                  o,
                  Z
                );
              }
          break;
        case 18:
          to !== null && (al ? (n = to, $c(
            n.nodeType === 9 ? n.body : n.nodeName === "HTML" ? n.ownerDocument.body : n,
            s.stateNode
          ), Lc(n)) : $c(to, s.stateNode));
          break;
        case 4:
          z = to, q = al, to = s.stateNode.containerInfo, al = !0, Wr(
            n,
            o,
            s
          ), to = z, al = q;
          break;
        case 0:
        case 11:
        case 14:
        case 15:
          Ou(
            Di,
            s,
            o
          ), eo || Qp(
            s,
            o,
            Il
          ), Wr(
            n,
            o,
            s
          );
          break;
        case 1:
          eo || (Zi(s, o), z = s.stateNode, typeof z.componentWillUnmount == "function" && Zp(
            s,
            o,
            z
          )), Wr(
            n,
            o,
            s
          );
          break;
        case 21:
          Wr(
            n,
            o,
            s
          );
          break;
        case 22:
          eo = (z = eo) || s.memoizedState !== null, Wr(
            n,
            o,
            s
          ), eo = z;
          break;
        default:
          Wr(
            n,
            o,
            s
          );
      }
      (s.mode & An) !== on && 0 <= Bt && 0 <= tn && (Ca || 0.05 < ma) && pl(
        s,
        Bt,
        tn,
        ma,
        na
      ), _a(h), gi(y), na = C, Ca = A;
    }
    function Xv(n, o) {
      if (o.memoizedState === null && (n = o.alternate, n !== null && (n = n.memoizedState, n !== null))) {
        n = n.dehydrated;
        try {
          le(
            o,
            Cg,
            n
          );
        } catch (s) {
          En(o, o.return, s);
        }
      }
    }
    function Gv(n, o) {
      if (o.memoizedState === null && (n = o.alternate, n !== null && (n = n.memoizedState, n !== null && (n = n.dehydrated, n !== null))))
        try {
          le(
            o,
            h2,
            n
          );
        } catch (s) {
          En(o, o.return, s);
        }
    }
    function ny(n) {
      switch (n.tag) {
        case 31:
        case 13:
        case 19:
          var o = n.stateNode;
          return o === null && (o = n.stateNode = new $8()), o;
        case 22:
          return n = n.stateNode, o = n._retryCache, o === null && (o = n._retryCache = new $8()), o;
        default:
          throw Error(
            "Unexpected Suspense handler tag (" + n.tag + "). This is a bug in React."
          );
      }
    }
    function Ru(n, o) {
      var s = ny(n);
      o.forEach(function(h) {
        if (!s.has(h)) {
          if (s.add(h), ms)
            if (f0 !== null && m0 !== null)
              Xd(m0, f0);
            else
              throw Error(
                "Expected finished root and lanes to be set. This is a bug in React."
              );
          var y = Nc.bind(null, n, h);
          h.then(y, y);
        }
      });
    }
    function Wo(n, o) {
      var s = o.deletions;
      if (s !== null)
        for (var h = 0; h < s.length; h++) {
          var y = n, C = o, A = s[h], z = _r(), q = C;
          e: for (; q !== null; ) {
            switch (q.tag) {
              case 27:
                if (ju(q.type)) {
                  to = q.stateNode, al = !1;
                  break e;
                }
                break;
              case 5:
                to = q.stateNode, al = !1;
                break e;
              case 3:
              case 4:
                to = q.stateNode.containerInfo, al = !0;
                break e;
            }
            q = q.return;
          }
          if (to === null)
            throw Error(
              "Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue."
            );
          Uv(y, C, A), to = null, al = !1, (A.mode & An) !== on && 0 <= Bt && 0 <= tn && 0.05 < tn - Bt && Xi(
            A,
            Bt,
            tn,
            "Unmount"
          ), _a(z), y = A, C = y.alternate, C !== null && (C.return = null), y.return = null;
        }
      if (o.subtreeFlags & 13886)
        for (o = o.child; o !== null; )
          Vm(o, n), o = o.sibling;
    }
    function Vm(n, o) {
      var s = _r(), h = Ki(), y = vi(), C = Yi(), A = n.alternate, z = n.flags;
      switch (n.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          Wo(o, n), Vo(n), z & 4 && (Ou(
            Di | Cs,
            n,
            n.return
          ), Vs(Di | Cs, n), Qp(
            n,
            n.return,
            Il | Cs
          ));
          break;
        case 1:
          if (Wo(o, n), Vo(n), z & 512 && (eo || A === null || Zi(A, A.return)), z & 64 && td && (z = n.updateQueue, z !== null && (A = z.callbacks, A !== null))) {
            var q = z.shared.hiddenCallbacks;
            z.shared.hiddenCallbacks = q === null ? A : q.concat(A);
          }
          break;
        case 26:
          if (q = eu, Wo(o, n), Vo(n), z & 512 && (eo || A === null || Zi(A, A.return)), z & 4) {
            var Z = A !== null ? A.memoizedState : null;
            if (z = n.memoizedState, A === null)
              if (z === null)
                if (n.stateNode === null) {
                  e: {
                    z = n.type, A = n.memoizedProps, q = q.ownerDocument || q;
                    t: switch (z) {
                      case "title":
                        Z = q.getElementsByTagName(
                          "title"
                        )[0], (!Z || Z[pf] || Z[Xr] || Z.namespaceURI === Pn || Z.hasAttribute("itemprop")) && (Z = q.createElement(z), q.head.insertBefore(
                          Z,
                          q.querySelector(
                            "head > title"
                          )
                        )), Ur(Z, z, A), Z[Xr] = n, Pt(Z), z = Z;
                        break e;
                      case "link":
                        var xe = nf(
                          "link",
                          "href",
                          q
                        ).get(z + (A.href || ""));
                        if (xe) {
                          for (var ke = 0; ke < xe.length; ke++)
                            if (Z = xe[ke], Z.getAttribute("href") === (A.href == null || A.href === "" ? null : A.href) && Z.getAttribute("rel") === (A.rel == null ? null : A.rel) && Z.getAttribute("title") === (A.title == null ? null : A.title) && Z.getAttribute("crossorigin") === (A.crossOrigin == null ? null : A.crossOrigin)) {
                              xe.splice(ke, 1);
                              break t;
                            }
                        }
                        Z = q.createElement(z), Ur(Z, z, A), q.head.appendChild(
                          Z
                        );
                        break;
                      case "meta":
                        if (xe = nf(
                          "meta",
                          "content",
                          q
                        ).get(z + (A.content || ""))) {
                          for (ke = 0; ke < xe.length; ke++)
                            if (Z = xe[ke], pe(
                              A.content,
                              "content"
                            ), Z.getAttribute("content") === (A.content == null ? null : "" + A.content) && Z.getAttribute("name") === (A.name == null ? null : A.name) && Z.getAttribute("property") === (A.property == null ? null : A.property) && Z.getAttribute("http-equiv") === (A.httpEquiv == null ? null : A.httpEquiv) && Z.getAttribute("charset") === (A.charSet == null ? null : A.charSet)) {
                              xe.splice(ke, 1);
                              break t;
                            }
                        }
                        Z = q.createElement(z), Ur(Z, z, A), q.head.appendChild(
                          Z
                        );
                        break;
                      default:
                        throw Error(
                          'getNodesForType encountered a type it did not expect: "' + z + '". This is a bug in React.'
                        );
                    }
                    Z[Xr] = n, Pt(Z), z = Z;
                  }
                  n.stateNode = z;
                } else
                  Ay(
                    q,
                    n.type,
                    n.stateNode
                  );
              else
                n.stateNode = Pg(
                  q,
                  z,
                  n.memoizedProps
                );
            else
              Z !== z ? (Z === null ? A.stateNode !== null && (A = A.stateNode, A.parentNode.removeChild(A)) : Z.count--, z === null ? Ay(
                q,
                n.type,
                n.stateNode
              ) : Pg(
                q,
                z,
                n.memoizedProps
              )) : z === null && n.stateNode !== null && eg(
                n,
                n.memoizedProps,
                A.memoizedProps
              );
          }
          break;
        case 27:
          Wo(o, n), Vo(n), z & 512 && (eo || A === null || Zi(A, A.return)), A !== null && z & 4 && eg(
            n,
            n.memoizedProps,
            A.memoizedProps
          );
          break;
        case 5:
          if (Wo(o, n), Vo(n), z & 512 && (eo || A === null || Zi(A, A.return)), n.flags & 32) {
            q = n.stateNode;
            try {
              le(
                n,
                Sg,
                q
              );
            } catch (Mt) {
              En(n, n.return, Mt);
            }
          }
          z & 4 && n.stateNode != null && (q = n.memoizedProps, eg(
            n,
            q,
            A !== null ? A.memoizedProps : q
          )), z & 1024 && (s4 = !0, n.type !== "form" && console.error(
            "Unexpected host component type. Expected a form. This is a bug in React."
          ));
          break;
        case 6:
          if (Wo(o, n), Vo(n), z & 4) {
            if (n.stateNode === null)
              throw Error(
                "This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue."
              );
            z = n.memoizedProps, A = A !== null ? A.memoizedProps : z, q = n.stateNode;
            try {
              le(
                n,
                bC,
                q,
                A,
                z
              );
            } catch (Mt) {
              En(n, n.return, Mt);
            }
          }
          break;
        case 3:
          if (q = Ul(), Lw = null, Z = eu, eu = xg(o.containerInfo), Wo(o, n), eu = Z, Vo(n), z & 4 && A !== null && A.memoizedState.isDehydrated)
            try {
              le(
                n,
                m2,
                o.containerInfo
              );
            } catch (Mt) {
              En(n, n.return, Mt);
            }
          s4 && (s4 = !1, ry(n)), o.effectDuration += xd(
            q
          );
          break;
        case 4:
          z = eu, eu = xg(
            n.stateNode.containerInfo
          ), Wo(o, n), Vo(n), eu = z;
          break;
        case 12:
          z = Ul(), Wo(o, n), Vo(n), n.stateNode.effectDuration += zo(z);
          break;
        case 31:
          Wo(o, n), Vo(n), z & 4 && (z = n.updateQueue, z !== null && (n.updateQueue = null, Ru(n, z)));
          break;
        case 13:
          Wo(o, n), Vo(n), n.child.flags & 8192 && n.memoizedState !== null != (A !== null && A.memoizedState !== null) && (xw = Ka()), z & 4 && (z = n.updateQueue, z !== null && (n.updateQueue = null, Ru(n, z)));
          break;
        case 22:
          q = n.memoizedState !== null;
          var de = A !== null && A.memoizedState !== null, Ve = td, yt = eo;
          if (td = Ve || q, eo = yt || de, Wo(o, n), eo = yt, td = Ve, de && !q && !Ve && !yt && (n.mode & An) !== on && 0 <= Bt && 0 <= tn && 0.05 < tn - Bt && vp(
            n,
            Bt,
            tn
          ), Vo(n), z & 8192)
            e: for (o = n.stateNode, o._visibility = q ? o._visibility & ~K2 : o._visibility | K2, !q || A === null || de || td || eo || (Au(n), (n.mode & An) !== on && 0 <= Bt && 0 <= tn && 0.05 < tn - Bt && Xi(
              n,
              Bt,
              tn,
              "Disconnect"
            )), A = null, o = n; ; ) {
              if (o.tag === 5 || o.tag === 26) {
                if (A === null) {
                  de = A = o;
                  try {
                    Z = de.stateNode, q ? le(
                      de,
                      wy,
                      Z
                    ) : le(
                      de,
                      xy,
                      de.stateNode,
                      de.memoizedProps
                    );
                  } catch (Mt) {
                    En(de, de.return, Mt);
                  }
                }
              } else if (o.tag === 6) {
                if (A === null) {
                  de = o;
                  try {
                    xe = de.stateNode, q ? le(
                      de,
                      Sy,
                      xe
                    ) : le(
                      de,
                      Ey,
                      xe,
                      de.memoizedProps
                    );
                  } catch (Mt) {
                    En(de, de.return, Mt);
                  }
                }
              } else if (o.tag === 18) {
                if (A === null) {
                  de = o;
                  try {
                    ke = de.stateNode, q ? le(
                      de,
                      yy,
                      ke
                    ) : le(
                      de,
                      Cy,
                      de.stateNode
                    );
                  } catch (Mt) {
                    En(de, de.return, Mt);
                  }
                }
              } else if ((o.tag !== 22 && o.tag !== 23 || o.memoizedState === null || o === n) && o.child !== null) {
                o.child.return = o, o = o.child;
                continue;
              }
              if (o === n) break e;
              for (; o.sibling === null; ) {
                if (o.return === null || o.return === n)
                  break e;
                A === o && (A = null), o = o.return;
              }
              A === o && (A = null), o.sibling.return = o.return, o = o.sibling;
            }
          z & 4 && (z = n.updateQueue, z !== null && (A = z.retryQueue, A !== null && (z.retryQueue = null, Ru(n, A))));
          break;
        case 19:
          Wo(o, n), Vo(n), z & 4 && (z = n.updateQueue, z !== null && (n.updateQueue = null, Ru(n, z)));
          break;
        case 30:
          break;
        case 21:
          break;
        default:
          Wo(o, n), Vo(n);
      }
      (n.mode & An) !== on && 0 <= Bt && 0 <= tn && ((Ca || 0.05 < ma) && pl(
        n,
        Bt,
        tn,
        ma,
        na
      ), n.alternate === null && n.return !== null && n.return.alternate !== null && 0.05 < tn - Bt && (Bv(
        n.return.alternate,
        n.return
      ) || Xi(
        n,
        Bt,
        tn,
        "Mount"
      ))), _a(s), gi(h), na = y, Ca = C;
    }
    function Vo(n) {
      var o = n.flags;
      if (o & 2) {
        try {
          le(n, Vv, n);
        } catch (s) {
          En(n, n.return, s);
        }
        n.flags &= -3;
      }
      o & 4096 && (n.flags &= -4097);
    }
    function ry(n) {
      if (n.subtreeFlags & 1024)
        for (n = n.child; n !== null; ) {
          var o = n;
          ry(o), o.tag === 5 && o.flags & 1024 && o.stateNode.reset(), n = n.sibling;
        }
    }
    function xi(n, o) {
      if (o.subtreeFlags & 8772)
        for (o = o.child; o !== null; )
          ng(n, o.alternate, o), o = o.sibling;
    }
    function rg(n) {
      var o = _r(), s = Ki(), h = vi(), y = Yi();
      switch (n.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          Qp(
            n,
            n.return,
            Il
          ), Au(n);
          break;
        case 1:
          Zi(n, n.return);
          var C = n.stateNode;
          typeof C.componentWillUnmount == "function" && Zp(
            n,
            n.return,
            C
          ), Au(n);
          break;
        case 27:
          le(
            n,
            qs,
            n.stateNode
          );
        case 26:
        case 5:
          Zi(n, n.return), Au(n);
          break;
        case 22:
          n.memoizedState === null && Au(n);
          break;
        case 30:
          Au(n);
          break;
        default:
          Au(n);
      }
      (n.mode & An) !== on && 0 <= Bt && 0 <= tn && (Ca || 0.05 < ma) && pl(
        n,
        Bt,
        tn,
        ma,
        na
      ), _a(o), gi(s), na = h, Ca = y;
    }
    function Au(n) {
      for (n = n.child; n !== null; )
        rg(n), n = n.sibling;
    }
    function qv(n, o, s, h) {
      var y = _r(), C = Ki(), A = vi(), z = Yi(), q = s.flags;
      switch (s.tag) {
        case 0:
        case 11:
        case 15:
          Pl(
            n,
            s,
            h
          ), Jb(s, Il);
          break;
        case 1:
          if (Pl(
            n,
            s,
            h
          ), o = s.stateNode, typeof o.componentDidMount == "function" && le(
            s,
            KC,
            s,
            o
          ), o = s.updateQueue, o !== null) {
            n = s.stateNode;
            try {
              le(
                s,
                pv,
                o,
                n
              );
            } catch (Z) {
              En(s, s.return, Z);
            }
          }
          h && q & 64 && Hv(s), Tc(s, s.return);
          break;
        case 27:
          _v(s);
        case 26:
        case 5:
          Pl(
            n,
            s,
            h
          ), h && o === null && q & 4 && Tu(s), Tc(s, s.return);
          break;
        case 12:
          if (h && q & 4) {
            q = Ul(), Pl(
              n,
              s,
              h
            ), h = s.stateNode, h.effectDuration += zo(q);
            try {
              le(
                s,
                Fv,
                s,
                o,
                xf,
                h.effectDuration
              );
            } catch (Z) {
              En(s, s.return, Z);
            }
          } else
            Pl(
              n,
              s,
              h
            );
          break;
        case 31:
          Pl(
            n,
            s,
            h
          ), h && q & 4 && Xv(n, s);
          break;
        case 13:
          Pl(
            n,
            s,
            h
          ), h && q & 4 && Gv(n, s);
          break;
        case 22:
          s.memoizedState === null && Pl(
            n,
            s,
            h
          ), Tc(s, s.return);
          break;
        case 30:
          break;
        default:
          Pl(
            n,
            s,
            h
          );
      }
      (s.mode & An) !== on && 0 <= Bt && 0 <= tn && (Ca || 0.05 < ma) && pl(
        s,
        Bt,
        tn,
        ma,
        na
      ), _a(y), gi(C), na = A, Ca = z;
    }
    function Pl(n, o, s) {
      for (s = s && (o.subtreeFlags & 8772) !== 0, o = o.child; o !== null; )
        qv(
          n,
          o.alternate,
          o,
          s
        ), o = o.sibling;
    }
    function _m(n, o) {
      var s = null;
      n !== null && n.memoizedState !== null && n.memoizedState.cachePool !== null && (s = n.memoizedState.cachePool.pool), n = null, o.memoizedState !== null && o.memoizedState.cachePool !== null && (n = o.memoizedState.cachePool.pool), n !== s && (n != null && fc(n), s != null && pm(s));
    }
    function Bm(n, o) {
      n = null, o.alternate !== null && (n = o.alternate.memoizedState.cache), o = o.memoizedState.cache, o !== n && (fc(o), n != null && pm(n));
    }
    function Ei(n, o, s, h, y) {
      if (o.subtreeFlags & 10256 || o.actualDuration !== 0 && (o.alternate === null || o.alternate.child !== o.child))
        for (o = o.child; o !== null; ) {
          var C = o.sibling;
          Kv(
            n,
            o,
            s,
            h,
            C !== null ? C.actualStartTime : y
          ), o = C;
        }
    }
    function Kv(n, o, s, h, y) {
      var C = _r(), A = Ki(), z = vi(), q = Yi(), Z = yf, xe = o.flags;
      switch (o.tag) {
        case 0:
        case 11:
        case 15:
          (o.mode & An) !== on && 0 < o.actualStartTime && (o.flags & 1) !== 0 && bp(
            o,
            o.actualStartTime,
            y,
            ho,
            s
          ), Ei(
            n,
            o,
            s,
            h,
            y
          ), xe & 2048 && Hm(o, $i | Cs);
          break;
        case 1:
          (o.mode & An) !== on && 0 < o.actualStartTime && ((o.flags & 128) !== 0 ? Z0(
            o,
            o.actualStartTime,
            y,
            []
          ) : (o.flags & 1) !== 0 && bp(
            o,
            o.actualStartTime,
            y,
            ho,
            s
          )), Ei(
            n,
            o,
            s,
            h,
            y
          );
          break;
        case 3:
          var ke = Ul(), de = ho;
          ho = o.alternate !== null && o.alternate.memoizedState.isDehydrated && (o.flags & 256) === 0, Ei(
            n,
            o,
            s,
            h,
            y
          ), ho = de, xe & 2048 && (s = null, o.alternate !== null && (s = o.alternate.memoizedState.cache), h = o.memoizedState.cache, h !== s && (fc(h), s != null && pm(s))), n.passiveEffectDuration += xd(
            ke
          );
          break;
        case 12:
          if (xe & 2048) {
            xe = Ul(), Ei(
              n,
              o,
              s,
              h,
              y
            ), n = o.stateNode, n.passiveEffectDuration += zo(xe);
            try {
              le(
                o,
                ty,
                o,
                o.alternate,
                xf,
                n.passiveEffectDuration
              );
            } catch (Ve) {
              En(o, o.return, Ve);
            }
          } else
            Ei(
              n,
              o,
              s,
              h,
              y
            );
          break;
        case 31:
          xe = ho, ke = o.alternate !== null ? o.alternate.memoizedState : null, de = o.memoizedState, ke !== null && de === null ? (de = o.deletions, de !== null && 0 < de.length && de[0].tag === 18 ? (ho = !1, ke = ke.hydrationErrors, ke !== null && Z0(
            o,
            o.actualStartTime,
            y,
            ke
          )) : ho = !0) : ho = !1, Ei(
            n,
            o,
            s,
            h,
            y
          ), ho = xe;
          break;
        case 13:
          xe = ho, ke = o.alternate !== null ? o.alternate.memoizedState : null, de = o.memoizedState, ke === null || ke.dehydrated === null || de !== null && de.dehydrated !== null ? ho = !1 : (de = o.deletions, de !== null && 0 < de.length && de[0].tag === 18 ? (ho = !1, ke = ke.hydrationErrors, ke !== null && Z0(
            o,
            o.actualStartTime,
            y,
            ke
          )) : ho = !0), Ei(
            n,
            o,
            s,
            h,
            y
          ), ho = xe;
          break;
        case 23:
          break;
        case 22:
          de = o.stateNode, ke = o.alternate, o.memoizedState !== null ? de._visibility & Uc ? Ei(
            n,
            o,
            s,
            h,
            y
          ) : Rc(
            n,
            o,
            s,
            h,
            y
          ) : de._visibility & Uc ? Ei(
            n,
            o,
            s,
            h,
            y
          ) : (de._visibility |= Uc, Nu(
            n,
            o,
            s,
            h,
            (o.subtreeFlags & 10256) !== 0 || o.actualDuration !== 0 && (o.alternate === null || o.alternate.child !== o.child),
            y
          ), (o.mode & An) === on || ho || (n = o.actualStartTime, 0 <= n && 0.05 < y - n && vp(o, n, y), 0 <= Bt && 0 <= tn && 0.05 < tn - Bt && vp(
            o,
            Bt,
            tn
          ))), xe & 2048 && _m(
            ke,
            o
          );
          break;
        case 24:
          Ei(
            n,
            o,
            s,
            h,
            y
          ), xe & 2048 && Bm(o.alternate, o);
          break;
        default:
          Ei(
            n,
            o,
            s,
            h,
            y
          );
      }
      (o.mode & An) !== on && ((n = !ho && o.alternate === null && o.return !== null && o.return.alternate !== null) && (s = o.actualStartTime, 0 <= s && 0.05 < y - s && Xi(
        o,
        s,
        y,
        "Mount"
      )), 0 <= Bt && 0 <= tn && ((Ca || 0.05 < ma) && pl(
        o,
        Bt,
        tn,
        ma,
        na
      ), n && 0.05 < tn - Bt && Xi(
        o,
        Bt,
        tn,
        "Mount"
      ))), _a(C), gi(A), na = z, Ca = q, yf = Z;
    }
    function Nu(n, o, s, h, y, C) {
      for (y = y && ((o.subtreeFlags & 10256) !== 0 || o.actualDuration !== 0 && (o.alternate === null || o.alternate.child !== o.child)), o = o.child; o !== null; ) {
        var A = o.sibling;
        Um(
          n,
          o,
          s,
          h,
          y,
          A !== null ? A.actualStartTime : C
        ), o = A;
      }
    }
    function Um(n, o, s, h, y, C) {
      var A = _r(), z = Ki(), q = vi(), Z = Yi(), xe = yf;
      y && (o.mode & An) !== on && 0 < o.actualStartTime && (o.flags & 1) !== 0 && bp(
        o,
        o.actualStartTime,
        C,
        ho,
        s
      );
      var ke = o.flags;
      switch (o.tag) {
        case 0:
        case 11:
        case 15:
          Nu(
            n,
            o,
            s,
            h,
            y,
            C
          ), Hm(o, $i);
          break;
        case 23:
          break;
        case 22:
          var de = o.stateNode;
          o.memoizedState !== null ? de._visibility & Uc ? Nu(
            n,
            o,
            s,
            h,
            y,
            C
          ) : Rc(
            n,
            o,
            s,
            h,
            C
          ) : (de._visibility |= Uc, Nu(
            n,
            o,
            s,
            h,
            y,
            C
          )), y && ke & 2048 && _m(
            o.alternate,
            o
          );
          break;
        case 24:
          Nu(
            n,
            o,
            s,
            h,
            y,
            C
          ), y && ke & 2048 && Bm(o.alternate, o);
          break;
        default:
          Nu(
            n,
            o,
            s,
            h,
            y,
            C
          );
      }
      (o.mode & An) !== on && 0 <= Bt && 0 <= tn && (Ca || 0.05 < ma) && pl(
        o,
        Bt,
        tn,
        ma,
        na
      ), _a(A), gi(z), na = q, Ca = Z, yf = xe;
    }
    function Rc(n, o, s, h, y) {
      if (o.subtreeFlags & 10256 || o.actualDuration !== 0 && (o.alternate === null || o.alternate.child !== o.child))
        for (var C = o.child; C !== null; ) {
          o = C.sibling;
          var A = n, z = s, q = h, Z = o !== null ? o.actualStartTime : y, xe = yf;
          (C.mode & An) !== on && 0 < C.actualStartTime && (C.flags & 1) !== 0 && bp(
            C,
            C.actualStartTime,
            Z,
            ho,
            z
          );
          var ke = C.flags;
          switch (C.tag) {
            case 22:
              Rc(
                A,
                C,
                z,
                q,
                Z
              ), ke & 2048 && _m(C.alternate, C);
              break;
            case 24:
              Rc(
                A,
                C,
                z,
                q,
                Z
              ), ke & 2048 && Bm(C.alternate, C);
              break;
            default:
              Rc(
                A,
                C,
                z,
                q,
                Z
              );
          }
          yf = xe, C = o;
        }
    }
    function Ac(n, o, s) {
      if (n.subtreeFlags & p1)
        for (n = n.child; n !== null; )
          ag(
            n,
            o,
            s
          ), n = n.sibling;
    }
    function ag(n, o, s) {
      switch (n.tag) {
        case 26:
          Ac(
            n,
            o,
            s
          ), n.flags & p1 && n.memoizedState !== null && y2(
            s,
            eu,
            n.memoizedState,
            n.memoizedProps
          );
          break;
        case 5:
          Ac(
            n,
            o,
            s
          );
          break;
        case 3:
        case 4:
          var h = eu;
          eu = xg(
            n.stateNode.containerInfo
          ), Ac(
            n,
            o,
            s
          ), eu = h;
          break;
        case 22:
          n.memoizedState === null && (h = n.alternate, h !== null && h.memoizedState !== null ? (h = p1, p1 = 16777216, Ac(
            n,
            o,
            s
          ), p1 = h) : Ac(
            n,
            o,
            s
          ));
          break;
        default:
          Ac(
            n,
            o,
            s
          );
      }
    }
    function Yv(n) {
      var o = n.alternate;
      if (o !== null && (n = o.child, n !== null)) {
        o.child = null;
        do
          o = n.sibling, n.sibling = null, n = o;
        while (n !== null);
      }
    }
    function Pi(n) {
      var o = n.deletions;
      if ((n.flags & 16) !== 0) {
        if (o !== null)
          for (var s = 0; s < o.length; s++) {
            var h = o[s], y = _r();
            Mo = h, rs(
              h,
              n
            ), (h.mode & An) !== on && 0 <= Bt && 0 <= tn && 0.05 < tn - Bt && Xi(
              h,
              Bt,
              tn,
              "Unmount"
            ), _a(y);
          }
        Yv(n);
      }
      if (n.subtreeFlags & 10256)
        for (n = n.child; n !== null; )
          og(n), n = n.sibling;
    }
    function og(n) {
      var o = _r(), s = Ki(), h = vi(), y = Yi();
      switch (n.tag) {
        case 0:
        case 11:
        case 15:
          Pi(n), n.flags & 2048 && Jp(
            n,
            n.return,
            $i | Cs
          );
          break;
        case 3:
          var C = Ul();
          Pi(n), n.stateNode.passiveEffectDuration += xd(C);
          break;
        case 12:
          C = Ul(), Pi(n), n.stateNode.passiveEffectDuration += zo(C);
          break;
        case 22:
          C = n.stateNode, n.memoizedState !== null && C._visibility & Uc && (n.return === null || n.return.tag !== 13) ? (C._visibility &= ~Uc, ig(n), (n.mode & An) !== on && 0 <= Bt && 0 <= tn && 0.05 < tn - Bt && Xi(
            n,
            Bt,
            tn,
            "Disconnect"
          )) : Pi(n);
          break;
        default:
          Pi(n);
      }
      (n.mode & An) !== on && 0 <= Bt && 0 <= tn && (Ca || 0.05 < ma) && pl(
        n,
        Bt,
        tn,
        ma,
        na
      ), _a(o), gi(s), Ca = y, na = h;
    }
    function ig(n) {
      var o = n.deletions;
      if ((n.flags & 16) !== 0) {
        if (o !== null)
          for (var s = 0; s < o.length; s++) {
            var h = o[s], y = _r();
            Mo = h, rs(
              h,
              n
            ), (h.mode & An) !== on && 0 <= Bt && 0 <= tn && 0.05 < tn - Bt && Xi(
              h,
              Bt,
              tn,
              "Unmount"
            ), _a(y);
          }
        Yv(n);
      }
      for (n = n.child; n !== null; )
        Qv(n), n = n.sibling;
    }
    function Qv(n) {
      var o = _r(), s = Ki(), h = vi(), y = Yi();
      switch (n.tag) {
        case 0:
        case 11:
        case 15:
          Jp(
            n,
            n.return,
            $i
          ), ig(n);
          break;
        case 22:
          var C = n.stateNode;
          C._visibility & Uc && (C._visibility &= ~Uc, ig(n));
          break;
        default:
          ig(n);
      }
      (n.mode & An) !== on && 0 <= Bt && 0 <= tn && (Ca || 0.05 < ma) && pl(
        n,
        Bt,
        tn,
        ma,
        na
      ), _a(o), gi(s), Ca = y, na = h;
    }
    function rs(n, o) {
      for (; Mo !== null; ) {
        var s = Mo, h = s, y = o, C = _r(), A = Ki(), z = vi(), q = Yi();
        switch (h.tag) {
          case 0:
          case 11:
          case 15:
            Jp(
              h,
              y,
              $i
            );
            break;
          case 23:
          case 22:
            h.memoizedState !== null && h.memoizedState.cachePool !== null && (y = h.memoizedState.cachePool.pool, y != null && fc(y));
            break;
          case 24:
            pm(h.memoizedState.cache);
        }
        if ((h.mode & An) !== on && 0 <= Bt && 0 <= tn && (Ca || 0.05 < ma) && pl(
          h,
          Bt,
          tn,
          ma,
          na
        ), _a(C), gi(A), Ca = q, na = z, h = s.child, h !== null) h.return = s, Mo = h;
        else
          e: for (s = n; Mo !== null; ) {
            if (h = Mo, C = h.sibling, A = h.return, wa(h), h === s) {
              Mo = null;
              break e;
            }
            if (C !== null) {
              C.return = A, Mo = C;
              break e;
            }
            Mo = A;
          }
      }
    }
    function Jv() {
      fT.forEach(function(n) {
        return n();
      });
    }
    function Zv() {
      var n = typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0;
      return n || Xe.actQueue === null || console.error(
        "The current testing environment is not configured to support act(...)"
      ), n;
    }
    function xo(n) {
      if ((ar & po) !== Oo && Dn !== 0)
        return Dn & -Dn;
      var o = Xe.T;
      return o !== null ? (o._updatedFibers || (o._updatedFibers = /* @__PURE__ */ new Set()), o._updatedFibers.add(n), u2()) : at();
    }
    function Wd() {
      if (il === 0)
        if ((Dn & 536870912) === 0 || Xn) {
          var n = hh;
          hh <<= 1, (hh & 3932160) === 0 && (hh = 262144), il = n;
        } else il = 536870912;
      return n = jl.current, n !== null && (n.flags |= 32), il;
    }
    function ln(n, o, s) {
      if (g0 && console.error("useInsertionEffect must not schedule updates."), y4 && (Mw = !0), (n === Lr && (Tr === Rh || Tr === Ah) || n.cancelPendingCommit !== null) && (as(n, 0), el(
        n,
        Dn,
        il,
        !1
      )), mt(n, s), (ar & po) !== Oo && n === Lr) {
        if (ds)
          switch (o.tag) {
            case 0:
            case 11:
            case 15:
              n = Ln && W(Ln) || "Unknown", K8.has(n) || (K8.add(n), o = W(o) || "Unknown", console.error(
                "Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://react.dev/link/setstate-in-render",
                o,
                n,
                n
              ));
              break;
            case 1:
              q8 || (console.error(
                "Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."
              ), q8 = !0);
          }
      } else
        ms && ut(n, o, s), Km(o), n === Lr && ((ar & po) === Oo && (Af |= s), ha === Of && el(
          n,
          Dn,
          il,
          !1
        )), ti(n);
    }
    function ay(n, o, s) {
      if ((ar & (po | Ll)) !== Oo)
        throw Error("Should not already be working.");
      if (Dn !== 0 && Ln !== null) {
        var h = Ln, y = Ka();
        switch (W6) {
          case b1:
          case Rh:
            var C = t1;
            Gr && ((h = h._debugTask) ? h.run(
              console.timeStamp.bind(
                console,
                "Suspended",
                C,
                y,
                ps,
                void 0,
                "primary-light"
              )
            ) : console.timeStamp(
              "Suspended",
              C,
              y,
              ps,
              void 0,
              "primary-light"
            ));
            break;
          case Ah:
            C = t1, Gr && ((h = h._debugTask) ? h.run(
              console.timeStamp.bind(
                console,
                "Action",
                C,
                y,
                ps,
                void 0,
                "primary-light"
              )
            ) : console.timeStamp(
              "Action",
              C,
              y,
              ps,
              void 0,
              "primary-light"
            ));
            break;
          default:
            Gr && (h = y - t1, 3 > h || console.timeStamp(
              "Blocked",
              t1,
              y,
              ps,
              void 0,
              5 > h ? "primary-light" : 10 > h ? "primary" : 100 > h ? "primary-dark" : "error"
            ));
        }
      }
      C = (s = !s && (o & 127) === 0 && (o & n.expiredLanes) === 0 || Fe(n, o)) ? _s(n, o) : Bd(n, o, !0);
      var A = s;
      do {
        if (C === nd) {
          h0 && !s && el(n, o, 0, !1), o = Tr, t1 = Qa(), W6 = o;
          break;
        } else {
          if (h = Ka(), y = n.current.alternate, A && !iy(y)) {
            hl(o), y = ko, C = h, !Gr || C <= y || (Ra ? Ra.run(
              console.timeStamp.bind(
                console,
                "Teared Render",
                y,
                C,
                Zn,
                Kn,
                "error"
              )
            ) : console.timeStamp(
              "Teared Render",
              y,
              C,
              Zn,
              Kn,
              "error"
            )), Du(o, h), C = Bd(n, o, !1), A = !1;
            continue;
          }
          if (C === Th) {
            if (A = o, n.errorRecoveryDisabledLanes & A)
              var z = 0;
            else
              z = n.pendingLanes & -536870913, z = z !== 0 ? z : z & 536870912 ? 536870912 : 0;
            if (z !== 0) {
              hl(o), ev(
                ko,
                h,
                o,
                Ra
              ), Du(o, h), o = z;
              e: {
                h = n, C = A, A = w1;
                var q = h.current.memoizedState.isDehydrated;
                if (q && (as(h, z).flags |= 256), z = Bd(
                  h,
                  z,
                  !1
                ), z !== Th) {
                  if (d4 && !q) {
                    h.errorRecoveryDisabledLanes |= C, Af |= C, C = Of;
                    break e;
                  }
                  h = zi, zi = A, h !== null && (zi === null ? zi = h : zi.push.apply(
                    zi,
                    h
                  ));
                }
                C = z;
              }
              if (A = !1, C !== Th) continue;
              h = Ka();
            }
          }
          if (C === v1) {
            hl(o), ev(
              ko,
              h,
              o,
              Ra
            ), Du(o, h), as(n, 0), el(n, o, 0, !0);
            break;
          }
          e: {
            switch (s = n, C) {
              case nd:
              case v1:
                throw Error("Root did not complete. This is a bug in React.");
              case Of:
                if ((o & 4194048) !== o) break;
              case yw:
                hl(o), $b(
                  ko,
                  h,
                  o,
                  Ra
                ), Du(o, h), y = o, (y & 127) !== 0 ? aw = h : (y & 4194048) !== 0 && (ow = h), el(
                  s,
                  o,
                  il,
                  !Tf
                );
                break e;
              case Th:
                zi = null;
                break;
              case bw:
              case z8:
                break;
              default:
                throw Error("Unknown root exit status.");
            }
            if (Xe.actQueue !== null)
              zr(
                s,
                y,
                o,
                zi,
                S1,
                Cw,
                il,
                Af,
                Nh,
                C,
                null,
                null,
                ko,
                h
              );
            else {
              if ((o & 62914560) === o && (A = xw + L8 - Ka(), 10 < A)) {
                if (el(
                  s,
                  o,
                  il,
                  !Tf
                ), Ue(s, 0, !0) !== 0) break e;
                tu = o, s.timeoutHandle = r5(
                  oy.bind(
                    null,
                    s,
                    y,
                    zi,
                    S1,
                    Cw,
                    o,
                    il,
                    Af,
                    Nh,
                    Tf,
                    C,
                    "Throttled",
                    ko,
                    h
                  ),
                  A
                );
                break e;
              }
              oy(
                s,
                y,
                zi,
                S1,
                Cw,
                o,
                il,
                Af,
                Nh,
                Tf,
                C,
                null,
                ko,
                h
              );
            }
          }
        }
        break;
      } while (!0);
      ti(n);
    }
    function oy(n, o, s, h, y, C, A, z, q, Z, xe, ke, de, Ve) {
      n.timeoutHandle = Ih;
      var yt = o.subtreeFlags, Mt = null;
      if ((yt & 8192 || (yt & 16785408) === 16785408) && (Mt = {
        stylesheets: null,
        count: 0,
        imgCount: 0,
        imgBytes: 0,
        suspenseyImages: [],
        waitingForImages: !0,
        waitingForViewTransition: !1,
        unsuspend: tr
      }, ag(o, C, Mt), yt = (C & 62914560) === C ? xw - Ka() : (C & 4194048) === C ? I8 - Ka() : 0, yt = kg(Mt, yt), yt !== null)) {
        tu = C, n.cancelPendingCommit = yt(
          zr.bind(
            null,
            n,
            o,
            C,
            s,
            h,
            y,
            A,
            z,
            q,
            xe,
            Mt,
            Mt.waitingForViewTransition ? "Waiting for the previous Animation" : 0 < Mt.count ? 0 < Mt.imgCount ? "Suspended on CSS and Images" : "Suspended on CSS" : Mt.imgCount === 1 ? "Suspended on an Image" : 0 < Mt.imgCount ? "Suspended on Images" : null,
            de,
            Ve
          )
        ), el(
          n,
          C,
          A,
          !Z
        );
        return;
      }
      zr(
        n,
        o,
        C,
        s,
        h,
        y,
        A,
        z,
        q,
        xe,
        Mt,
        ke,
        de,
        Ve
      );
    }
    function iy(n) {
      for (var o = n; ; ) {
        var s = o.tag;
        if ((s === 0 || s === 11 || s === 15) && o.flags & 16384 && (s = o.updateQueue, s !== null && (s = s.stores, s !== null)))
          for (var h = 0; h < s.length; h++) {
            var y = s[h], C = y.getSnapshot;
            y = y.value;
            try {
              if (!Ai(C(), y)) return !1;
            } catch {
              return !1;
            }
          }
        if (s = o.child, o.subtreeFlags & 16384 && s !== null)
          s.return = o, o = s;
        else {
          if (o === n) break;
          for (; o.sibling === null; ) {
            if (o.return === null || o.return === n) return !0;
            o = o.return;
          }
          o.sibling.return = o.return, o = o.sibling;
        }
      }
      return !0;
    }
    function el(n, o, s, h) {
      o &= ~f4, o &= ~Af, n.suspendedLanes |= o, n.pingedLanes &= ~o, h && (n.warmLanes |= o), h = n.expirationTimes;
      for (var y = o; 0 < y; ) {
        var C = 31 - fo(y), A = 1 << C;
        h[C] = -1, y &= ~A;
      }
      s !== 0 && Rt(n, s, o);
    }
    function ki() {
      return (ar & (po | Ll)) === Oo ? (is(0), !1) : !0;
    }
    function lg() {
      if (Ln !== null) {
        if (Tr === ol)
          var n = Ln.return;
        else
          n = Ln, Sd(), bu(n), o0 = null, c1 = 0, n = Ln;
        for (; n !== null; )
          Lv(n.alternate, n), n = n.return;
        Ln = null;
      }
    }
    function Du(n, o) {
      (n & 127) !== 0 && (wh = o), (n & 4194048) !== 0 && (Yc = o), (n & 62914560) !== 0 && (H6 = o), (n & 2080374784) !== 0 && (F6 = o);
    }
    function as(n, o) {
      Gr && (console.timeStamp(
        "Blocking Track",
        3e-3,
        3e-3,
        "Blocking",
        Kn,
        "primary-light"
      ), console.timeStamp(
        "Transition Track",
        3e-3,
        3e-3,
        "Transition",
        Kn,
        "primary-light"
      ), console.timeStamp(
        "Suspense Track",
        3e-3,
        3e-3,
        "Suspense",
        Kn,
        "primary-light"
      ), console.timeStamp(
        "Idle Track",
        3e-3,
        3e-3,
        "Idle",
        Kn,
        "primary-light"
      ));
      var s = ko;
      if (ko = Qa(), Dn !== 0 && 0 < s) {
        if (hl(Dn), ha === bw || ha === Of)
          $b(
            s,
            ko,
            o,
            Ra
          );
        else {
          var h = ko, y = Ra;
          if (Gr && !(h <= s)) {
            var C = (o & 738197653) === o ? "tertiary-dark" : "primary-dark", A = (o & 536870912) === o ? "Prewarm" : (o & 201326741) === o ? "Interrupted Hydration" : "Interrupted Render";
            y ? y.run(
              console.timeStamp.bind(
                console,
                A,
                s,
                h,
                Zn,
                Kn,
                C
              )
            ) : console.timeStamp(
              A,
              s,
              h,
              Zn,
              Kn,
              C
            );
          }
        }
        Du(Dn, ko);
      }
      if (s = Ra, Ra = null, (o & 127) !== 0) {
        Ra = J2, y = 0 <= Bu && Bu < wh ? wh : Bu, h = 0 <= Sh && Sh < wh ? wh : Sh, C = 0 <= h ? h : 0 <= y ? y : ko, 0 <= aw ? (hl(2), zb(
          aw,
          C,
          o,
          s
        )) : iw & 127, s = y;
        var z = h, q = Z2, Z = 0 < n0, xe = Ef === Q2, ke = Ef === rw;
        if (y = ko, h = J2, C = BC, A = UC, Gr) {
          if (Zn = "Blocking", 0 < s ? s > y && (s = y) : s = y, 0 < z ? z > s && (z = s) : z = s, q !== null && s > z) {
            var de = Z ? "secondary-light" : "warning";
            h ? h.run(
              console.timeStamp.bind(
                console,
                Z ? "Consecutive" : "Event: " + q,
                z,
                s,
                Zn,
                Kn,
                de
              )
            ) : console.timeStamp(
              Z ? "Consecutive" : "Event: " + q,
              z,
              s,
              Zn,
              Kn,
              de
            );
          }
          y > s && (z = xe ? "error" : (o & 738197653) === o ? "tertiary-light" : "primary-light", xe = ke ? "Promise Resolved" : xe ? "Cascading Update" : 5 < y - s ? "Update Blocked" : "Update", ke = [], A != null && ke.push(["Component name", A]), C != null && ke.push(["Method name", C]), s = {
            start: s,
            end: y,
            detail: {
              devtools: {
                properties: ke,
                track: Zn,
                trackGroup: Kn,
                color: z
              }
            }
          }, h ? h.run(
            performance.measure.bind(
              performance,
              xe,
              s
            )
          ) : performance.measure(xe, s));
        }
        Bu = -1.1, Ef = 0, UC = BC = null, aw = -1.1, n0 = Sh, Sh = -1.1, wh = Qa();
      }
      if ((o & 4194048) !== 0 && (Ra = e1, y = 0 <= Qc && Qc < Yc ? Yc : Qc, s = 0 <= Ss && Ss < Yc ? Yc : Ss, h = 0 <= Pf && Pf < Yc ? Yc : Pf, C = 0 <= h ? h : 0 <= s ? s : ko, 0 <= ow ? (hl(256), zb(
        ow,
        C,
        o,
        Ra
      )) : iw & 4194048, ke = h, z = Ch, q = 0 < kf, Z = XC === rw, C = ko, h = e1, A = I6, xe = L6, Gr && (Zn = "Transition", 0 < s ? s > C && (s = C) : s = C, 0 < y ? y > s && (y = s) : y = s, 0 < ke ? ke > y && (ke = y) : ke = y, y > ke && z !== null && (de = q ? "secondary-light" : "warning", h ? h.run(
        console.timeStamp.bind(
          console,
          q ? "Consecutive" : "Event: " + z,
          ke,
          y,
          Zn,
          Kn,
          de
        )
      ) : console.timeStamp(
        q ? "Consecutive" : "Event: " + z,
        ke,
        y,
        Zn,
        Kn,
        de
      )), s > y && (h ? h.run(
        console.timeStamp.bind(
          console,
          "Action",
          y,
          s,
          Zn,
          Kn,
          "primary-dark"
        )
      ) : console.timeStamp(
        "Action",
        y,
        s,
        Zn,
        Kn,
        "primary-dark"
      )), C > s && (y = Z ? "Promise Resolved" : 5 < C - s ? "Update Blocked" : "Update", ke = [], xe != null && ke.push(["Component name", xe]), A != null && ke.push(["Method name", A]), s = {
        start: s,
        end: C,
        detail: {
          devtools: {
            properties: ke,
            track: Zn,
            trackGroup: Kn,
            color: "primary-light"
          }
        }
      }, h ? h.run(
        performance.measure.bind(
          performance,
          y,
          s
        )
      ) : performance.measure(y, s))), Ss = Qc = -1.1, XC = 0, ow = -1.1, kf = Pf, Pf = -1.1, Yc = Qa()), (o & 62914560) !== 0 && (iw & 62914560) !== 0 && (hl(4194304), tv(H6, ko)), (o & 2080374784) !== 0 && (iw & 2080374784) !== 0 && (hl(268435456), tv(F6, ko)), s = n.timeoutHandle, s !== Ih && (n.timeoutHandle = Ih, PT(s)), s = n.cancelPendingCommit, s !== null && (n.cancelPendingCommit = null, s()), tu = 0, lg(), Lr = n, Ln = s = _l(
        n.current,
        null
      ), Dn = o, Tr = ol, Hl = null, Tf = !1, h0 = Fe(n, o), d4 = !1, ha = nd, Nh = il = f4 = Af = Rf = 0, zi = w1 = null, Cw = !1, (o & 8) !== 0 && (o |= o & 32), h = n.entangledLanes, h !== 0)
        for (n = n.entanglements, h &= o; 0 < h; )
          y = 31 - fo(h), C = 1 << y, o |= n[y], h &= ~C;
      return Xu = o, yp(), n = N6(), 1e3 < n - A6 && (Xe.recentlyCreatedOwnerStacks = 0, A6 = n), Js.discardPendingWarnings(), s;
    }
    function kl(n, o) {
      un = null, Xe.H = h1, Xe.getCurrentStack = null, ds = !1, oi = null, o === a0 || o === cw ? (o = pc(), Tr = b1) : o === YC ? (o = pc(), Tr = j8) : Tr = o === i4 ? c4 : o !== null && typeof o == "object" && typeof o.then == "function" ? y1 : ww, Hl = o;
      var s = Ln;
      s === null ? (ha = v1, $m(
        n,
        $o(o, n.current)
      )) : s.mode & An && kp(s);
    }
    function e2() {
      var n = jl.current;
      return n === null ? !0 : (Dn & 4194048) === Dn ? Ms === null : (Dn & 62914560) === Dn || (Dn & 536870912) !== 0 ? n === Ms : !1;
    }
    function sg() {
      var n = Xe.H;
      return Xe.H = h1, n === null ? h1 : n;
    }
    function t2() {
      var n = Xe.A;
      return Xe.A = dT, n;
    }
    function Vd(n) {
      Ra === null && (Ra = n._debugTask == null ? null : n._debugTask);
    }
    function _d() {
      ha = Of, Tf || (Dn & 4194048) !== Dn && jl.current !== null || (h0 = !0), (Rf & 134217727) === 0 && (Af & 134217727) === 0 || Lr === null || el(
        Lr,
        Dn,
        il,
        !1
      );
    }
    function Bd(n, o, s) {
      var h = ar;
      ar |= po;
      var y = sg(), C = t2();
      if (Lr !== n || Dn !== o) {
        if (ms) {
          var A = n.memoizedUpdaters;
          0 < A.size && (Xd(n, Dn), A.clear()), ht(n, o);
        }
        S1 = null, as(n, o);
      }
      o = !1, A = ha;
      e: do
        try {
          if (Tr !== ol && Ln !== null) {
            var z = Ln, q = Hl;
            switch (Tr) {
              case c4:
                lg(), A = yw;
                break e;
              case b1:
              case Rh:
              case Ah:
              case y1:
                jl.current === null && (o = !0);
                var Z = Tr;
                if (Tr = ol, Hl = null, Ud(n, z, q, Z), s && h0) {
                  A = nd;
                  break e;
                }
                break;
              default:
                Z = Tr, Tr = ol, Hl = null, Ud(n, z, q, Z);
            }
          }
          n2(), A = ha;
          break;
        } catch (xe) {
          kl(n, xe);
        }
      while (!0);
      return o && n.shellSuspendCounter++, Sd(), ar = h, Xe.H = y, Xe.A = C, Ln === null && (Lr = null, Dn = 0, yp()), A;
    }
    function n2() {
      for (; Ln !== null; ) ug(Ln);
    }
    function _s(n, o) {
      var s = ar;
      ar |= po;
      var h = sg(), y = t2();
      if (Lr !== n || Dn !== o) {
        if (ms) {
          var C = n.memoizedUpdaters;
          0 < C.size && (Xd(n, Dn), C.clear()), ht(n, o);
        }
        S1 = null, Ew = Ka() + H8, as(n, o);
      } else
        h0 = Fe(
          n,
          o
        );
      e: do
        try {
          if (Tr !== ol && Ln !== null)
            t: switch (o = Ln, C = Hl, Tr) {
              case ww:
                Tr = ol, Hl = null, Ud(
                  n,
                  o,
                  C,
                  ww
                );
                break;
              case Rh:
              case Ah:
                if (mv(C)) {
                  Tr = ol, Hl = null, r2(o);
                  break;
                }
                o = function() {
                  Tr !== Rh && Tr !== Ah || Lr !== n || (Tr = Sw), ti(n);
                }, C.then(o, o);
                break e;
              case b1:
                Tr = Sw;
                break e;
              case j8:
                Tr = u4;
                break e;
              case Sw:
                mv(C) ? (Tr = ol, Hl = null, r2(o)) : (Tr = ol, Hl = null, Ud(
                  n,
                  o,
                  C,
                  Sw
                ));
                break;
              case u4:
                var A = null;
                switch (Ln.tag) {
                  case 26:
                    A = Ln.memoizedState;
                  case 5:
                  case 27:
                    var z = Ln;
                    if (A ? Vn(A) : z.stateNode.complete) {
                      Tr = ol, Hl = null;
                      var q = z.sibling;
                      if (q !== null) Ln = q;
                      else {
                        var Z = z.return;
                        Z !== null ? (Ln = Z, Xm(Z)) : Ln = null;
                      }
                      break t;
                    }
                    break;
                  default:
                    console.error(
                      "Unexpected type of fiber triggered a suspensey commit. This is a bug in React."
                    );
                }
                Tr = ol, Hl = null, Ud(
                  n,
                  o,
                  C,
                  u4
                );
                break;
              case y1:
                Tr = ol, Hl = null, Ud(
                  n,
                  o,
                  C,
                  y1
                );
                break;
              case c4:
                lg(), ha = yw;
                break e;
              default:
                throw Error(
                  "Unexpected SuspendedReason. This is a bug in React."
                );
            }
          Xe.actQueue !== null ? n2() : Oa();
          break;
        } catch (xe) {
          kl(n, xe);
        }
      while (!0);
      return Sd(), Xe.H = h, Xe.A = y, ar = s, Ln !== null ? nd : (Lr = null, Dn = 0, yp(), ha);
    }
    function Oa() {
      for (; Ln !== null && !Ig(); )
        ug(Ln);
    }
    function ug(n) {
      var o = n.alternate;
      (n.mode & An) !== on ? (Ns(n), o = le(
        n,
        Lm,
        o,
        n,
        Xu
      ), kp(n)) : o = le(
        n,
        Lm,
        o,
        n,
        Xu
      ), n.memoizedProps = n.pendingProps, o === null ? Xm(n) : Ln = o;
    }
    function r2(n) {
      var o = le(n, qa, n);
      n.memoizedProps = n.pendingProps, o === null ? Xm(n) : Ln = o;
    }
    function qa(n) {
      var o = n.alternate, s = (n.mode & An) !== on;
      switch (s && Ns(n), n.tag) {
        case 15:
        case 0:
          o = Nv(
            o,
            n,
            n.pendingProps,
            n.type,
            void 0,
            Dn
          );
          break;
        case 11:
          o = Nv(
            o,
            n,
            n.pendingProps,
            n.type.render,
            n.ref,
            Dn
          );
          break;
        case 5:
          bu(n);
        default:
          Lv(o, n), n = Ln = ov(n, Xu), o = Lm(o, n, Xu);
      }
      return s && kp(n), o;
    }
    function Ud(n, o, s, h) {
      Sd(), bu(o), o0 = null, c1 = 0;
      var y = o.return;
      try {
        if (Pv(
          n,
          y,
          o,
          s,
          Dn
        )) {
          ha = v1, $m(
            n,
            $o(s, n.current)
          ), Ln = null;
          return;
        }
      } catch (C) {
        if (y !== null) throw Ln = y, C;
        ha = v1, $m(
          n,
          $o(s, n.current)
        ), Ln = null;
        return;
      }
      o.flags & 32768 ? (Xn || h === ww ? n = !0 : h0 || (Dn & 536870912) !== 0 ? n = !1 : (Tf = n = !0, (h === Rh || h === Ah || h === b1 || h === y1) && (h = jl.current, h !== null && h.tag === 13 && (h.flags |= 16384))), a2(o, n)) : Xm(o);
    }
    function Xm(n) {
      var o = n;
      do {
        if ((o.flags & 32768) !== 0) {
          a2(
            o,
            Tf
          );
          return;
        }
        var s = o.alternate;
        if (n = o.return, Ns(o), s = le(
          o,
          Iv,
          s,
          o,
          Xu
        ), (o.mode & An) !== on && gm(o), s !== null) {
          Ln = s;
          return;
        }
        if (o = o.sibling, o !== null) {
          Ln = o;
          return;
        }
        Ln = o = n;
      } while (o !== null);
      ha === nd && (ha = z8);
    }
    function a2(n, o) {
      do {
        var s = Qb(n.alternate, n);
        if (s !== null) {
          s.flags &= 32767, Ln = s;
          return;
        }
        if ((n.mode & An) !== on) {
          gm(n), s = n.actualDuration;
          for (var h = n.child; h !== null; )
            s += h.actualDuration, h = h.sibling;
          n.actualDuration = s;
        }
        if (s = n.return, s !== null && (s.flags |= 32768, s.subtreeFlags = 0, s.deletions = null), !o && (n = n.sibling, n !== null)) {
          Ln = n;
          return;
        }
        Ln = n = s;
      } while (n !== null);
      ha = yw, Ln = null;
    }
    function zr(n, o, s, h, y, C, A, z, q, Z, xe, ke, de, Ve) {
      n.cancelPendingCommit = null;
      do
        Gm();
      while (no !== Df);
      if (Js.flushLegacyContextWarning(), Js.flushPendingUnsafeLifecycleWarnings(), (ar & (po | Ll)) !== Oo)
        throw Error("Should not already be working.");
      if (hl(s), Z === Th ? ev(
        de,
        Ve,
        s,
        Ra
      ) : h !== null ? mC(
        de,
        Ve,
        s,
        h,
        o !== null && o.alternate !== null && o.alternate.memoizedState.isDehydrated && (o.flags & 256) !== 0,
        Ra
      ) : fC(
        de,
        Ve,
        s,
        Ra
      ), o !== null) {
        if (s === 0 && console.error(
          "finishedLanes should not be empty during a commit. This is a bug in React."
        ), o === n.current)
          throw Error(
            "Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue."
          );
        if (C = o.lanes | o.childLanes, C |= HC, Ot(
          n,
          s,
          C,
          A,
          z,
          q
        ), n === Lr && (Ln = Lr = null, Dn = 0), p0 = o, $f = n, tu = s, p4 = C, v4 = y, U8 = h, g4 = Ve, X8 = ke, nu = Pw, G8 = null, o.actualDuration !== 0 || (o.subtreeFlags & 10256) !== 0 || (o.flags & 10256) !== 0 ? (n.callbackNode = null, n.callbackPriority = 0, Gd(Wc, function() {
          return M1 = window.event, nu === Pw && (nu = h4), qm(), null;
        })) : (n.callbackNode = null, n.callbackPriority = 0), Kc = null, xf = Qa(), ke !== null && hC(
          Ve,
          xf,
          ke,
          Ra
        ), h = (o.flags & 13878) !== 0, (o.subtreeFlags & 13878) !== 0 || h) {
          h = Xe.T, Xe.T = null, y = fr.p, fr.p = La, A = ar, ar |= Ll;
          try {
            vC(n, o, s);
          } finally {
            ar = A, fr.p = y, Xe.T = h;
          }
        }
        no = W8, _o(), os(), o2();
      }
    }
    function _o() {
      if (no === W8) {
        no = Df;
        var n = $f, o = p0, s = tu, h = (o.flags & 13878) !== 0;
        if ((o.subtreeFlags & 13878) !== 0 || h) {
          h = Xe.T, Xe.T = null;
          var y = fr.p;
          fr.p = La;
          var C = ar;
          ar |= Ll;
          try {
            f0 = s, m0 = n, mc(), Vm(o, n), m0 = f0 = null, s = O4;
            var A = gp(n.containerInfo), z = s.focusedElem, q = s.selectionRange;
            if (A !== z && z && z.ownerDocument && Rb(
              z.ownerDocument.documentElement,
              z
            )) {
              if (q !== null && Q0(z)) {
                var Z = q.start, xe = q.end;
                if (xe === void 0 && (xe = Z), "selectionStart" in z)
                  z.selectionStart = Z, z.selectionEnd = Math.min(
                    xe,
                    z.value.length
                  );
                else {
                  var ke = z.ownerDocument || document, de = ke && ke.defaultView || window;
                  if (de.getSelection) {
                    var Ve = de.getSelection(), yt = z.textContent.length, Mt = Math.min(
                      q.start,
                      yt
                    ), Vr = q.end === void 0 ? Mt : Math.min(q.end, yt);
                    !Ve.extend && Mt > Vr && (A = Vr, Vr = Mt, Mt = A);
                    var Yn = Tb(
                      z,
                      Mt
                    ), ue = Tb(
                      z,
                      Vr
                    );
                    if (Yn && ue && (Ve.rangeCount !== 1 || Ve.anchorNode !== Yn.node || Ve.anchorOffset !== Yn.offset || Ve.focusNode !== ue.node || Ve.focusOffset !== ue.offset)) {
                      var he = ke.createRange();
                      he.setStart(Yn.node, Yn.offset), Ve.removeAllRanges(), Mt > Vr ? (Ve.addRange(he), Ve.extend(ue.node, ue.offset)) : (he.setEnd(ue.node, ue.offset), Ve.addRange(he));
                    }
                  }
                }
              }
              for (ke = [], Ve = z; Ve = Ve.parentNode; )
                Ve.nodeType === 1 && ke.push({
                  element: Ve,
                  left: Ve.scrollLeft,
                  top: Ve.scrollTop
                });
              for (typeof z.focus == "function" && z.focus(), z = 0; z < ke.length; z++) {
                var Se = ke[z];
                Se.element.scrollLeft = Se.left, Se.element.scrollTop = Se.top;
              }
            }
            Ww = !!M4, O4 = M4 = null;
          } finally {
            ar = C, fr.p = y, Xe.T = h;
          }
        }
        n.current = o, no = V8;
      }
    }
    function os() {
      if (no === V8) {
        no = Df;
        var n = G8;
        if (n !== null) {
          xf = Qa();
          var o = qc, s = xf;
          !Gr || s <= o || console.timeStamp(
            n,
            o,
            s,
            Zn,
            Kn,
            "secondary-light"
          );
        }
        n = $f, o = p0, s = tu;
        var h = (o.flags & 8772) !== 0;
        if ((o.subtreeFlags & 8772) !== 0 || h) {
          h = Xe.T, Xe.T = null;
          var y = fr.p;
          fr.p = La;
          var C = ar;
          ar |= Ll;
          try {
            f0 = s, m0 = n, mc(), ng(
              n,
              o.alternate,
              o
            ), m0 = f0 = null;
          } finally {
            ar = C, fr.p = y, Xe.T = h;
          }
        }
        n = g4, o = X8, qc = Qa(), n = o === null ? n : xf, o = qc, s = nu === m4, h = Ra, Kc !== null ? jb(
          n,
          o,
          Kc,
          !1,
          h
        ) : !Gr || o <= n || (h ? h.run(
          console.timeStamp.bind(
            console,
            s ? "Commit Interrupted View Transition" : "Commit",
            n,
            o,
            Zn,
            Kn,
            s ? "error" : "secondary-dark"
          )
        ) : console.timeStamp(
          s ? "Commit Interrupted View Transition" : "Commit",
          n,
          o,
          Zn,
          Kn,
          s ? "error" : "secondary-dark"
        )), no = _8;
      }
    }
    function o2() {
      if (no === B8 || no === _8) {
        if (no === B8) {
          var n = qc;
          qc = Qa();
          var o = qc, s = nu === m4;
          !Gr || o <= n || console.timeStamp(
            s ? "Interrupted View Transition" : "Starting Animation",
            n,
            o,
            Zn,
            Kn,
            s ? " error" : "secondary-light"
          ), nu !== m4 && (nu = F8);
        }
        no = Df, Lg(), n = $f;
        var h = p0;
        o = tu, s = U8;
        var y = h.actualDuration !== 0 || (h.subtreeFlags & 10256) !== 0 || (h.flags & 10256) !== 0;
        y ? no = kw : (no = Df, p0 = $f = null, i2(
          n,
          n.pendingLanes
        ), Dh = 0, x1 = null);
        var C = n.pendingLanes;
        if (C === 0 && (Nf = null), y || fg(n), C = ot(o), h = h.stateNode, Ia && typeof Ia.onCommitFiberRoot == "function")
          try {
            var A = (h.current.flags & 128) === 128;
            switch (C) {
              case La:
                var z = j2;
                break;
              case mo:
                z = Hg;
                break;
              case Po:
                z = Wc;
                break;
              case Wu:
                z = Fg;
                break;
              default:
                z = Wc;
            }
            Ia.onCommitFiberRoot(
              Vc,
              h,
              z,
              A
            );
          } catch (ke) {
            fs || (fs = !0, console.error(
              "React instrumentation encountered an error: %o",
              ke
            ));
          }
        if (ms && n.memoizedUpdaters.clear(), Jv(), s !== null) {
          A = Xe.T, z = fr.p, fr.p = La, Xe.T = null;
          try {
            var q = n.onRecoverableError;
            for (h = 0; h < s.length; h++) {
              var Z = s[h], xe = ly(Z.stack);
              le(
                Z.source,
                q,
                Z.value,
                xe
              );
            }
          } finally {
            Xe.T = A, fr.p = z;
          }
        }
        (tu & 3) !== 0 && Gm(), ti(n), C = n.pendingLanes, (o & 261930) !== 0 && (C & 42) !== 0 ? (sw = !0, n === b4 ? C1++ : (C1 = 0, b4 = n)) : C1 = 0, y || Du(o, qc), is(0);
      }
    }
    function ly(n) {
      return n = { componentStack: n }, Object.defineProperty(n, "digest", {
        get: function() {
          console.error(
            'You are accessing "digest" from the errorInfo object passed to onRecoverableError. This property is no longer provided as part of errorInfo but can be accessed as a property of the Error instance itself.'
          );
        }
      }), n;
    }
    function i2(n, o) {
      (n.pooledCacheLanes &= o) === 0 && (o = n.pooledCache, o != null && (n.pooledCache = null, pm(o)));
    }
    function Gm() {
      return _o(), os(), o2(), qm();
    }
    function qm() {
      if (no !== kw) return !1;
      var n = $f, o = p4;
      p4 = 0;
      var s = ot(tu), h = Po > s ? Po : s;
      s = Xe.T;
      var y = fr.p;
      try {
        fr.p = h, Xe.T = null;
        var C = v4;
        v4 = null, h = $f;
        var A = tu;
        if (no = Df, p0 = $f = null, tu = 0, (ar & (po | Ll)) !== Oo)
          throw Error("Cannot flush passive effects while already rendering.");
        hl(A), y4 = !0, Mw = !1;
        var z = 0;
        if (Kc = null, z = Ka(), nu === F8)
          tv(
            qc,
            z,
            aT
          );
        else {
          var q = qc, Z = z, xe = nu === h4;
          !Gr || Z <= q || (Ra ? Ra.run(
            console.timeStamp.bind(
              console,
              xe ? "Waiting for Paint" : "Waiting",
              q,
              Z,
              Zn,
              Kn,
              "secondary-light"
            )
          ) : console.timeStamp(
            xe ? "Waiting for Paint" : "Waiting",
            q,
            Z,
            Zn,
            Kn,
            "secondary-light"
          ));
        }
        q = ar, ar |= Ll;
        var ke = h.current;
        mc(), og(ke);
        var de = h.current;
        ke = g4, mc(), Kv(
          h,
          de,
          A,
          C,
          ke
        ), fg(h), ar = q;
        var Ve = Ka();
        if (de = z, ke = Ra, Kc !== null ? jb(
          de,
          Ve,
          Kc,
          !0,
          ke
        ) : !Gr || Ve <= de || (ke ? ke.run(
          console.timeStamp.bind(
            console,
            "Remaining Effects",
            de,
            Ve,
            Zn,
            Kn,
            "secondary-dark"
          )
        ) : console.timeStamp(
          "Remaining Effects",
          de,
          Ve,
          Zn,
          Kn,
          "secondary-dark"
        )), Du(A, Ve), is(0, !1), Mw ? h === x1 ? Dh++ : (Dh = 0, x1 = h) : Dh = 0, Mw = y4 = !1, Ia && typeof Ia.onPostCommitFiberRoot == "function")
          try {
            Ia.onPostCommitFiberRoot(Vc, h);
          } catch (Mt) {
            fs || (fs = !0, console.error(
              "React instrumentation encountered an error: %o",
              Mt
            ));
          }
        var yt = h.current.stateNode;
        return yt.effectDuration = 0, yt.passiveEffectDuration = 0, !0;
      } finally {
        fr.p = y, Xe.T = s, i2(n, o);
      }
    }
    function Bo(n, o, s) {
      o = $o(s, o), Vb(o), o = Vp(n.stateNode, o, 2), n = Gl(n, o, 2), n !== null && (mt(n, 2), ti(n));
    }
    function En(n, o, s) {
      if (g0 = !1, n.tag === 3)
        Bo(n, n, s);
      else {
        for (; o !== null; ) {
          if (o.tag === 3) {
            Bo(
              o,
              n,
              s
            );
            return;
          }
          if (o.tag === 1) {
            var h = o.stateNode;
            if (typeof o.type.getDerivedStateFromError == "function" || typeof h.componentDidCatch == "function" && (Nf === null || !Nf.has(h))) {
              n = $o(s, n), Vb(n), s = _p(2), h = Gl(o, s, 2), h !== null && (Bp(
                s,
                h,
                o,
                n
              ), mt(h, 2), ti(h));
              return;
            }
          }
          o = o.return;
        }
        console.error(
          `Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Potential causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`,
          s
        );
      }
    }
    function cg(n, o, s) {
      var h = n.pingCache;
      if (h === null) {
        h = n.pingCache = new mT();
        var y = /* @__PURE__ */ new Set();
        h.set(o, y);
      } else
        y = h.get(o), y === void 0 && (y = /* @__PURE__ */ new Set(), h.set(o, y));
      y.has(s) || (d4 = !0, y.add(s), h = ei.bind(null, n, o, s), ms && Xd(n, s), o.then(h, h));
    }
    function ei(n, o, s) {
      var h = n.pingCache;
      h !== null && h.delete(o), n.pingedLanes |= n.suspendedLanes & s, n.warmLanes &= ~s, (s & 127) !== 0 ? 0 > Bu && (wh = Bu = Qa(), J2 = nw("Promise Resolved"), Ef = rw) : (s & 4194048) !== 0 && 0 > Ss && (Yc = Ss = Qa(), e1 = nw("Promise Resolved"), XC = rw), Zv() && Xe.actQueue === null && console.error(
        `A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act`
      ), Lr === n && (Dn & s) === s && (ha === Of || ha === bw && (Dn & 62914560) === Dn && Ka() - xw < L8 ? (ar & po) === Oo && as(n, 0) : f4 |= s, Nh === Dn && (Nh = 0)), ti(n);
    }
    function l2(n, o) {
      o === 0 && (o = dt()), n = So(n, o), n !== null && (mt(n, o), ti(n));
    }
    function Bs(n) {
      var o = n.memoizedState, s = 0;
      o !== null && (s = o.retryLane), l2(n, s);
    }
    function Nc(n, o) {
      var s = 0;
      switch (n.tag) {
        case 31:
        case 13:
          var h = n.stateNode, y = n.memoizedState;
          y !== null && (s = y.retryLane);
          break;
        case 19:
          h = n.stateNode;
          break;
        case 22:
          h = n.stateNode._retryCache;
          break;
        default:
          throw Error(
            "Pinged unknown suspense boundary type. This is probably a bug in React."
          );
      }
      h !== null && h.delete(o), l2(n, s);
    }
    function Ml(n, o, s) {
      if ((o.subtreeFlags & 67117056) !== 0)
        for (o = o.child; o !== null; ) {
          var h = n, y = o, C = y.type === Go;
          C = s || C, y.tag !== 22 ? y.flags & 67108864 ? C && le(
            y,
            dg,
            h,
            y
          ) : Ml(
            h,
            y,
            C
          ) : y.memoizedState === null && (C && y.flags & 8192 ? le(
            y,
            dg,
            h,
            y
          ) : y.subtreeFlags & 67108864 && le(
            y,
            Ml,
            h,
            y,
            C
          )), o = o.sibling;
        }
    }
    function dg(n, o) {
      Oe(!0);
      try {
        rg(o), Qv(o), qv(n, o.alternate, o, !1), Um(n, o, 0, null, !1, 0);
      } finally {
        Oe(!1);
      }
    }
    function fg(n) {
      var o = !0;
      n.current.mode & (ii | Qs) || (o = !1), Ml(
        n,
        n.current,
        o
      );
    }
    function tl(n) {
      if ((ar & po) === Oo) {
        var o = n.tag;
        if (o === 3 || o === 1 || o === 0 || o === 11 || o === 14 || o === 15) {
          if (o = W(n) || "ReactComponent", Ow !== null) {
            if (Ow.has(o)) return;
            Ow.add(o);
          } else Ow = /* @__PURE__ */ new Set([o]);
          le(n, function() {
            console.error(
              "Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously tries to update the component. Move this work to useEffect instead."
            );
          });
        }
      }
    }
    function Xd(n, o) {
      ms && n.memoizedUpdaters.forEach(function(s) {
        ut(n, s, o);
      });
    }
    function Gd(n, o) {
      var s = Xe.actQueue;
      return s !== null ? (s.push(o), gT) : z2(n, o);
    }
    function Km(n) {
      Zv() && Xe.actQueue === null && le(n, function() {
        console.error(
          `An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act`,
          W(n)
        );
      });
    }
    function ti(n) {
      n !== v0 && n.next === null && (v0 === null ? Tw = v0 = n : v0 = v0.next = n), Rw = !0, Xe.actQueue !== null ? S4 || (S4 = !0, uy()) : w4 || (w4 = !0, uy());
    }
    function is(n, o) {
      if (!C4 && Rw) {
        C4 = !0;
        do
          for (var s = !1, h = Tw; h !== null; ) {
            if (n !== 0) {
              var y = h.pendingLanes;
              if (y === 0) var C = 0;
              else {
                var A = h.suspendedLanes, z = h.pingedLanes;
                C = (1 << 31 - fo(42 | n) + 1) - 1, C &= y & ~(A & ~z), C = C & 201326741 ? C & 201326741 | 1 : C ? C | 2 : 0;
              }
              C !== 0 && (s = !0, Ym(h, C));
            } else
              C = Dn, C = Ue(
                h,
                h === Lr ? C : 0,
                h.cancelPendingCommit !== null || h.timeoutHandle !== Ih
              ), (C & 3) === 0 || Fe(h, C) || (s = !0, Ym(h, C));
            h = h.next;
          }
        while (s);
        C4 = !1;
      }
    }
    function sy() {
      M1 = window.event, mg();
    }
    function mg() {
      Rw = S4 = w4 = !1;
      var n = 0;
      zf !== 0 && d2() && (n = zf);
      for (var o = Ka(), s = null, h = Tw; h !== null; ) {
        var y = h.next, C = qd(h, o);
        C === 0 ? (h.next = null, s === null ? Tw = y : s.next = y, y === null && (v0 = s)) : (s = h, (n !== 0 || (C & 3) !== 0) && (Rw = !0)), h = y;
      }
      no !== Df && no !== kw || is(n), zf !== 0 && (zf = 0);
    }
    function qd(n, o) {
      for (var s = n.suspendedLanes, h = n.pingedLanes, y = n.expirationTimes, C = n.pendingLanes & -62914561; 0 < C; ) {
        var A = 31 - fo(C), z = 1 << A, q = y[A];
        q === -1 ? ((z & s) === 0 || (z & h) !== 0) && (y[A] = tt(z, o)) : q <= o && (n.expiredLanes |= z), C &= ~z;
      }
      if (o = Lr, s = Dn, s = Ue(
        n,
        n === o ? s : 0,
        n.cancelPendingCommit !== null || n.timeoutHandle !== Ih
      ), h = n.callbackNode, s === 0 || n === o && (Tr === Rh || Tr === Ah) || n.cancelPendingCommit !== null)
        return h !== null && hg(h), n.callbackNode = null, n.callbackPriority = 0;
      if ((s & 3) === 0 || Fe(n, s)) {
        if (o = s & -s, o !== n.callbackPriority || Xe.actQueue !== null && h !== x4)
          hg(h);
        else return o;
        switch (ot(s)) {
          case La:
          case mo:
            s = Hg;
            break;
          case Po:
            s = Wc;
            break;
          case Wu:
            s = Fg;
            break;
          default:
            s = Wc;
        }
        return h = s2.bind(null, n), Xe.actQueue !== null ? (Xe.actQueue.push(h), s = x4) : s = z2(s, h), n.callbackPriority = o, n.callbackNode = s, o;
      }
      return h !== null && hg(h), n.callbackPriority = 2, n.callbackNode = null, 2;
    }
    function s2(n, o) {
      if (sw = lw = !1, M1 = window.event, no !== Df && no !== kw)
        return n.callbackNode = null, n.callbackPriority = 0, null;
      var s = n.callbackNode;
      if (nu === Pw && (nu = h4), Gm() && n.callbackNode !== s)
        return null;
      var h = Dn;
      return h = Ue(
        n,
        n === Lr ? h : 0,
        n.cancelPendingCommit !== null || n.timeoutHandle !== Ih
      ), h === 0 ? null : (ay(
        n,
        h,
        o
      ), qd(n, Ka()), n.callbackNode != null && n.callbackNode === s ? s2.bind(null, n) : null);
    }
    function Ym(n, o) {
      if (Gm()) return null;
      lw = sw, sw = !1, ay(n, o, !0);
    }
    function hg(n) {
      n !== x4 && n !== null && jg(n);
    }
    function uy() {
      Xe.actQueue !== null && Xe.actQueue.push(function() {
        return mg(), null;
      }), kT(function() {
        (ar & (po | Ll)) !== Oo ? z2(
          j2,
          sy
        ) : mg();
      });
    }
    function u2() {
      if (zf === 0) {
        var n = xh;
        n === 0 && (n = mf, mf <<= 1, (mf & 261888) === 0 && (mf = 256)), zf = n;
      }
      return zf;
    }
    function ir(n) {
      return n == null || typeof n == "symbol" || typeof n == "boolean" ? null : typeof n == "function" ? n : (pe(n, "action"), pr("" + n));
    }
    function kr(n, o) {
      var s = o.ownerDocument.createElement("input");
      return s.name = o.name, s.value = o.value, n.id && s.setAttribute("form", n.id), o.parentNode.insertBefore(s, o), n = new FormData(n), s.parentNode.removeChild(s), n;
    }
    function Bn(n, o, s, h, y) {
      if (o === "submit" && s && s.stateNode === y) {
        var C = ir(
          (y[qo] || null).action
        ), A = h.submitter;
        A && (o = (o = A[qo] || null) ? ir(o.formAction) : A.getAttribute("formAction"), o !== null && (C = o, A = null));
        var z = new Ky(
          "action",
          "action",
          null,
          h,
          y
        );
        n.push({
          event: z,
          listeners: [
            {
              instance: null,
              listener: function() {
                if (h.defaultPrevented) {
                  if (zf !== 0) {
                    var q = A ? kr(
                      y,
                      A
                    ) : new FormData(y), Z = {
                      pending: !0,
                      data: q,
                      method: y.method,
                      action: C
                    };
                    Object.freeze(Z), Fs(
                      s,
                      Z,
                      null,
                      q
                    );
                  }
                } else
                  typeof C == "function" && (z.preventDefault(), q = A ? kr(
                    y,
                    A
                  ) : new FormData(y), Z = {
                    pending: !0,
                    data: q,
                    method: y.method,
                    action: C
                  }, Object.freeze(Z), Fs(
                    s,
                    Z,
                    C,
                    q
                  ));
              },
              currentTarget: y
            }
          ]
        });
      }
    }
    function In(n, o, s) {
      n.currentTarget = s;
      try {
        o(n);
      } catch (h) {
        zC(h);
      }
      n.currentTarget = null;
    }
    function br(n, o) {
      o = (o & 4) !== 0;
      for (var s = 0; s < n.length; s++) {
        var h = n[s];
        e: {
          var y = void 0, C = h.event;
          if (h = h.listeners, o)
            for (var A = h.length - 1; 0 <= A; A--) {
              var z = h[A], q = z.instance, Z = z.currentTarget;
              if (z = z.listener, q !== y && C.isPropagationStopped())
                break e;
              q !== null ? le(
                q,
                In,
                C,
                z,
                Z
              ) : In(C, z, Z), y = q;
            }
          else
            for (A = 0; A < h.length; A++) {
              if (z = h[A], q = z.instance, Z = z.currentTarget, z = z.listener, q !== y && C.isPropagationStopped())
                break e;
              q !== null ? le(
                q,
                In,
                C,
                z,
                Z
              ) : In(C, z, Z), y = q;
            }
        }
      }
    }
    function rn(n, o) {
      E4.has(n) || console.error(
        'Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.',
        n
      );
      var s = o[_c];
      s === void 0 && (s = o[_c] = /* @__PURE__ */ new Set());
      var h = n + "__bubble";
      s.has(h) || (pg(o, n, 2, !1), s.add(h));
    }
    function ls(n, o, s) {
      E4.has(n) && !o && console.error(
        'Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.',
        n
      );
      var h = 0;
      o && (h |= 4), pg(
        s,
        n,
        h,
        o
      );
    }
    function $u(n) {
      if (!n[Aw]) {
        n[Aw] = !0, By.forEach(function(s) {
          s !== "selectionchange" && (E4.has(s) || ls(s, !1, n), ls(s, !0, n));
        });
        var o = n.nodeType === 9 ? n : n.ownerDocument;
        o === null || o[Aw] || (o[Aw] = !0, ls("selectionchange", !1, o));
      }
    }
    function pg(n, o, s, h) {
      switch (Tg(o)) {
        case La:
          var y = E2;
          break;
        case mo:
          y = co;
          break;
        default:
          y = P2;
      }
      s = y.bind(
        null,
        o,
        s,
        n
      ), y = void 0, !PC || o !== "touchstart" && o !== "touchmove" && o !== "wheel" || (y = !0), h ? y !== void 0 ? n.addEventListener(o, s, {
        capture: !0,
        passive: y
      }) : n.addEventListener(o, s, !0) : y !== void 0 ? n.addEventListener(o, s, {
        passive: y
      }) : n.addEventListener(
        o,
        s,
        !1
      );
    }
    function Ol(n, o, s, h, y) {
      var C = h;
      if ((o & 1) === 0 && (o & 2) === 0 && h !== null)
        e: for (; ; ) {
          if (h === null) return;
          var A = h.tag;
          if (A === 3 || A === 4) {
            var z = h.stateNode.containerInfo;
            if (z === y) break;
            if (A === 4)
              for (A = h.return; A !== null; ) {
                var q = A.tag;
                if ((q === 3 || q === 4) && A.stateNode.containerInfo === y)
                  return;
                A = A.return;
              }
            for (; z !== null; ) {
              if (A = pt(z), A === null) return;
              if (q = A.tag, q === 5 || q === 6 || q === 26 || q === 27) {
                h = C = A;
                continue e;
              }
              z = z.parentNode;
            }
          }
          h = h.return;
        }
      Li(function() {
        var Z = C, xe = Va(s), ke = [];
        e: {
          var de = R6.get(n);
          if (de !== void 0) {
            var Ve = Ky, yt = n;
            switch (n) {
              case "keypress":
                if (rc(s) === 0) break e;
              case "keydown":
              case "keyup":
                Ve = RO;
                break;
              case "focusin":
                yt = "focus", Ve = TC;
                break;
              case "focusout":
                yt = "blur", Ve = TC;
                break;
              case "beforeblur":
              case "afterblur":
                Ve = TC;
                break;
              case "click":
                if (s.button === 2) break e;
              case "auxclick":
              case "dblclick":
              case "mousedown":
              case "mousemove":
              case "mouseup":
              case "mouseout":
              case "mouseover":
              case "contextmenu":
                Ve = g6;
                break;
              case "drag":
              case "dragend":
              case "dragenter":
              case "dragexit":
              case "dragleave":
              case "dragover":
              case "dragstart":
              case "drop":
                Ve = bO;
                break;
              case "touchcancel":
              case "touchend":
              case "touchmove":
              case "touchstart":
                Ve = DO;
                break;
              case k6:
              case M6:
              case O6:
                Ve = SO;
                break;
              case T6:
                Ve = zO;
                break;
              case "scroll":
              case "scrollend":
                Ve = gO;
                break;
              case "wheel":
                Ve = IO;
                break;
              case "copy":
              case "cut":
              case "paste":
                Ve = xO;
                break;
              case "gotpointercapture":
              case "lostpointercapture":
              case "pointercancel":
              case "pointerdown":
              case "pointermove":
              case "pointerout":
              case "pointerover":
              case "pointerup":
                Ve = b6;
                break;
              case "toggle":
              case "beforetoggle":
                Ve = HO;
            }
            var Mt = (o & 4) !== 0, Vr = !Mt && (n === "scroll" || n === "scrollend"), Yn = Mt ? de !== null ? de + "Capture" : null : de;
            Mt = [];
            for (var ue = Z, he; ue !== null; ) {
              var Se = ue;
              if (he = Se.stateNode, Se = Se.tag, Se !== 5 && Se !== 26 && Se !== 27 || he === null || Yn === null || (Se = yo(ue, Yn), Se != null && Mt.push(
                jr(
                  ue,
                  Se,
                  he
                )
              )), Vr) break;
              ue = ue.return;
            }
            0 < Mt.length && (de = new Ve(
              de,
              yt,
              null,
              s,
              xe
            ), ke.push({
              event: de,
              listeners: Mt
            }));
          }
        }
        if ((o & 7) === 0) {
          e: {
            if (de = n === "mouseover" || n === "pointerover", Ve = n === "mouseout" || n === "pointerout", de && s !== W2 && (yt = s.relatedTarget || s.fromElement) && (pt(yt) || yt[Ys]))
              break e;
            if ((Ve || de) && (de = xe.window === xe ? xe : (de = xe.ownerDocument) ? de.defaultView || de.parentWindow : window, Ve ? (yt = s.relatedTarget || s.toElement, Ve = Z, yt = yt ? pt(yt) : null, yt !== null && (Vr = T(yt), Mt = yt.tag, yt !== Vr || Mt !== 5 && Mt !== 27 && Mt !== 6) && (yt = null)) : (Ve = null, yt = Z), Ve !== yt)) {
              if (Mt = g6, Se = "onMouseLeave", Yn = "onMouseEnter", ue = "mouse", (n === "pointerout" || n === "pointerover") && (Mt = b6, Se = "onPointerLeave", Yn = "onPointerEnter", ue = "pointer"), Vr = Ve == null ? de : Nt(Ve), he = yt == null ? de : Nt(yt), de = new Mt(
                Se,
                ue + "leave",
                Ve,
                s,
                xe
              ), de.target = Vr, de.relatedTarget = he, Se = null, pt(xe) === Z && (Mt = new Mt(
                Yn,
                ue + "enter",
                yt,
                s,
                xe
              ), Mt.target = he, Mt.relatedTarget = Vr, Se = Mt), Vr = Se, Ve && yt)
                t: {
                  for (Mt = Dc, Yn = Ve, ue = yt, he = 0, Se = Yn; Se; Se = Mt(Se))
                    he++;
                  Se = 0;
                  for (var Ze = ue; Ze; Ze = Mt(Ze))
                    Se++;
                  for (; 0 < he - Se; )
                    Yn = Mt(Yn), he--;
                  for (; 0 < Se - he; )
                    ue = Mt(ue), Se--;
                  for (; he--; ) {
                    if (Yn === ue || ue !== null && Yn === ue.alternate) {
                      Mt = Yn;
                      break t;
                    }
                    Yn = Mt(Yn), ue = Mt(ue);
                  }
                  Mt = null;
                }
              else Mt = null;
              Ve !== null && gg(
                ke,
                de,
                Ve,
                Mt,
                !1
              ), yt !== null && Vr !== null && gg(
                ke,
                Vr,
                yt,
                Mt,
                !0
              );
            }
          }
          e: {
            if (de = Z ? Nt(Z) : window, Ve = de.nodeName && de.nodeName.toLowerCase(), Ve === "select" || Ve === "input" && de.type === "file")
              var xt = cu;
            else if (Zh(de))
              if (E6)
                xt = cm;
              else {
                xt = K0;
                var cn = dC;
              }
            else
              Ve = de.nodeName, !Ve || Ve.toLowerCase() !== "input" || de.type !== "checkbox" && de.type !== "radio" ? Z && ka(Z.elementType) && (xt = cu) : xt = Y0;
            if (xt && (xt = xt(n, Z))) {
              sm(
                ke,
                xt,
                s,
                xe
              );
              break e;
            }
            cn && cn(n, de, Z), n === "focusout" && Z && de.type === "number" && Z.memoizedProps.value != null && Gn(de, "number", de.value);
          }
          switch (cn = Z ? Nt(Z) : window, n) {
            case "focusin":
              (Zh(cn) || cn.contentEditable === "true") && (qg = cn, AC = Z, q2 = null);
              break;
            case "focusout":
              q2 = AC = qg = null;
              break;
            case "mousedown":
              NC = !0;
              break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
              NC = !1, Ab(
                ke,
                s,
                xe
              );
              break;
            case "selectionchange":
              if (_O) break;
            case "keydown":
            case "keyup":
              Ab(
                ke,
                s,
                xe
              );
          }
          var _t;
          if (RC)
            e: {
              switch (n) {
                case "compositionstart":
                  var Ht = "onCompositionStart";
                  break e;
                case "compositionend":
                  Ht = "onCompositionEnd";
                  break e;
                case "compositionupdate":
                  Ht = "onCompositionUpdate";
                  break e;
              }
              Ht = void 0;
            }
          else
            Gg ? wo(n, s) && (Ht = "onCompositionEnd") : n === "keydown" && s.keyCode === y6 && (Ht = "onCompositionStart");
          Ht && (w6 && s.locale !== "ko" && (Gg || Ht !== "onCompositionStart" ? Ht === "onCompositionEnd" && Gg && (_t = ul()) : (bf = xe, kC = "value" in bf ? bf.value : bf.textContent, Gg = !0)), cn = Tl(
            Z,
            Ht
          ), 0 < cn.length && (Ht = new v6(
            Ht,
            n,
            null,
            s,
            xe
          ), ke.push({
            event: Ht,
            listeners: cn
          }), _t ? Ht.data = _t : (_t = Ea(s), _t !== null && (Ht.data = _t)))), (_t = WO ? Uf(n, s) : gd(n, s)) && (Ht = Tl(
            Z,
            "onBeforeInput"
          ), 0 < Ht.length && (cn = new PO(
            "onBeforeInput",
            "beforeinput",
            null,
            s,
            xe
          ), ke.push({
            event: cn,
            listeners: Ht
          }), cn.data = _t)), Bn(
            ke,
            n,
            Z,
            s,
            xe
          );
        }
        br(ke, o);
      });
    }
    function jr(n, o, s) {
      return {
        instance: n,
        listener: o,
        currentTarget: s
      };
    }
    function Tl(n, o) {
      for (var s = o + "Capture", h = []; n !== null; ) {
        var y = n, C = y.stateNode;
        if (y = y.tag, y !== 5 && y !== 26 && y !== 27 || C === null || (y = yo(n, s), y != null && h.unshift(
          jr(n, y, C)
        ), y = yo(n, o), y != null && h.push(
          jr(n, y, C)
        )), n.tag === 3) return h;
        n = n.return;
      }
      return [];
    }
    function Dc(n) {
      if (n === null) return null;
      do
        n = n.return;
      while (n && n.tag !== 5 && n.tag !== 27);
      return n || null;
    }
    function gg(n, o, s, h, y) {
      for (var C = o._reactName, A = []; s !== null && s !== h; ) {
        var z = s, q = z.alternate, Z = z.stateNode;
        if (z = z.tag, q !== null && q === h) break;
        z !== 5 && z !== 26 && z !== 27 || Z === null || (q = Z, y ? (Z = yo(s, C), Z != null && A.unshift(
          jr(s, Z, q)
        )) : y || (Z = yo(s, C), Z != null && A.push(
          jr(s, Z, q)
        ))), s = s.return;
      }
      A.length !== 0 && n.push({ event: o, listeners: A });
    }
    function Uo(n, o) {
      qt(n, o), n !== "input" && n !== "textarea" && n !== "select" || o == null || o.value !== null || h6 || (h6 = !0, n === "select" && o.multiple ? console.error(
        "`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.",
        n
      ) : console.error(
        "`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.",
        n
      ));
      var s = {
        registrationNameDependencies: hs,
        possibleRegistrationNames: gf
      };
      ka(n) || typeof o.is == "string" || ur(n, o, s), o.contentEditable && !o.suppressContentEditableWarning && o.children != null && console.error(
        "A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."
      );
    }
    function ea(n, o, s, h) {
      o !== s && (s = Rl(s), Rl(o) !== s && (h[n] = o));
    }
    function Qm(n, o, s) {
      o.forEach(function(h) {
        s[Us(h)] = h === "style" ? zu(n) : n.getAttribute(h);
      });
    }
    function ta(n, o) {
      o === !1 ? console.error(
        "Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.",
        n,
        n,
        n
      ) : console.error(
        "Expected `%s` listener to be a function, instead got a value of `%s` type.",
        n,
        typeof o
      );
    }
    function vg(n, o) {
      return n = n.namespaceURI === vn || n.namespaceURI === Pn ? n.ownerDocument.createElementNS(
        n.namespaceURI,
        n.tagName
      ) : n.ownerDocument.createElement(n.tagName), n.innerHTML = o, n.innerHTML;
    }
    function Rl(n) {
      return we(n) && (console.error(
        "The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before using it here.",
        Ae(n)
      ), Ne(n)), (typeof n == "string" ? n : "" + n).replace(vT, `
`).replace(bT, "");
    }
    function c2(n, o) {
      return o = Rl(o), Rl(n) === o;
    }
    function dr(n, o, s, h, y, C) {
      switch (s) {
        case "children":
          typeof h == "string" ? (nn(h, o, !1), o === "body" || o === "textarea" && h === "" || er(n, h)) : (typeof h == "number" || typeof h == "bigint") && (nn("" + h, o, !1), o !== "body" && er(n, "" + h));
          break;
        case "className":
          wn(n, "class", h);
          break;
        case "tabIndex":
          wn(n, "tabindex", h);
          break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
          wn(n, s, h);
          break;
        case "style":
          hi(n, h, C);
          break;
        case "data":
          if (o !== "object") {
            wn(n, "data", h);
            break;
          }
        case "src":
        case "href":
          if (h === "" && (o !== "a" || s !== "href")) {
            console.error(
              s === "src" ? 'An empty string ("") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string.' : 'An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.',
              s,
              s
            ), n.removeAttribute(s);
            break;
          }
          if (h == null || typeof h == "function" || typeof h == "symbol" || typeof h == "boolean") {
            n.removeAttribute(s);
            break;
          }
          pe(h, s), h = pr("" + h), n.setAttribute(s, h);
          break;
        case "action":
        case "formAction":
          if (h != null && (o === "form" ? s === "formAction" ? console.error(
            "You can only pass the formAction prop to <input> or <button>. Use the action prop on <form>."
          ) : typeof h == "function" && (y.encType == null && y.method == null || $w || ($w = !0, console.error(
            "Cannot specify a encType or method for a form that specifies a function as the action. React provides those automatically. They will get overridden."
          )), y.target == null || Dw || (Dw = !0, console.error(
            "Cannot specify a target for a form that specifies a function as the action. The function will always be executed in the same window."
          ))) : o === "input" || o === "button" ? s === "action" ? console.error(
            "You can only pass the action prop to <form>. Use the formAction prop on <input> or <button>."
          ) : o !== "input" || y.type === "submit" || y.type === "image" || Nw ? o !== "button" || y.type == null || y.type === "submit" || Nw ? typeof h == "function" && (y.name == null || J8 || (J8 = !0, console.error(
            'Cannot specify a "name" prop for a button that specifies a function as a formAction. React needs it to encode which action should be invoked. It will get overridden.'
          )), y.formEncType == null && y.formMethod == null || $w || ($w = !0, console.error(
            "Cannot specify a formEncType or formMethod for a button that specifies a function as a formAction. React provides those automatically. They will get overridden."
          )), y.formTarget == null || Dw || (Dw = !0, console.error(
            "Cannot specify a formTarget for a button that specifies a function as a formAction. The function will always be executed in the same window."
          ))) : (Nw = !0, console.error(
            'A button can only specify a formAction along with type="submit" or no type.'
          )) : (Nw = !0, console.error(
            'An input can only specify a formAction along with type="submit" or type="image".'
          )) : console.error(
            s === "action" ? "You can only pass the action prop to <form>." : "You can only pass the formAction prop to <input> or <button>."
          )), typeof h == "function") {
            n.setAttribute(
              s,
              "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
            );
            break;
          } else
            typeof C == "function" && (s === "formAction" ? (o !== "input" && dr(n, o, "name", y.name, y, null), dr(
              n,
              o,
              "formEncType",
              y.formEncType,
              y,
              null
            ), dr(
              n,
              o,
              "formMethod",
              y.formMethod,
              y,
              null
            ), dr(
              n,
              o,
              "formTarget",
              y.formTarget,
              y,
              null
            )) : (dr(
              n,
              o,
              "encType",
              y.encType,
              y,
              null
            ), dr(n, o, "method", y.method, y, null), dr(
              n,
              o,
              "target",
              y.target,
              y,
              null
            )));
          if (h == null || typeof h == "symbol" || typeof h == "boolean") {
            n.removeAttribute(s);
            break;
          }
          pe(h, s), h = pr("" + h), n.setAttribute(s, h);
          break;
        case "onClick":
          h != null && (typeof h != "function" && ta(s, h), n.onclick = tr);
          break;
        case "onScroll":
          h != null && (typeof h != "function" && ta(s, h), rn("scroll", n));
          break;
        case "onScrollEnd":
          h != null && (typeof h != "function" && ta(s, h), rn("scrollend", n));
          break;
        case "dangerouslySetInnerHTML":
          if (h != null) {
            if (typeof h != "object" || !("__html" in h))
              throw Error(
                "`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information."
              );
            if (s = h.__html, s != null) {
              if (y.children != null)
                throw Error(
                  "Can only set one of `children` or `props.dangerouslySetInnerHTML`."
                );
              n.innerHTML = s;
            }
          }
          break;
        case "multiple":
          n.multiple = h && typeof h != "function" && typeof h != "symbol";
          break;
        case "muted":
          n.muted = h && typeof h != "function" && typeof h != "symbol";
          break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
          break;
        case "autoFocus":
          break;
        case "xlinkHref":
          if (h == null || typeof h == "function" || typeof h == "boolean" || typeof h == "symbol") {
            n.removeAttribute("xlink:href");
            break;
          }
          pe(h, s), s = pr("" + h), n.setAttributeNS($h, "xlink:href", s);
          break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
          h != null && typeof h != "function" && typeof h != "symbol" ? (pe(h, s), n.setAttribute(s, "" + h)) : n.removeAttribute(s);
          break;
        case "inert":
          h !== "" || zw[s] || (zw[s] = !0, console.error(
            "Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.",
            s
          ));
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
          h && typeof h != "function" && typeof h != "symbol" ? n.setAttribute(s, "") : n.removeAttribute(s);
          break;
        case "capture":
        case "download":
          h === !0 ? n.setAttribute(s, "") : h !== !1 && h != null && typeof h != "function" && typeof h != "symbol" ? (pe(h, s), n.setAttribute(s, h)) : n.removeAttribute(s);
          break;
        case "cols":
        case "rows":
        case "size":
        case "span":
          h != null && typeof h != "function" && typeof h != "symbol" && !isNaN(h) && 1 <= h ? (pe(h, s), n.setAttribute(s, h)) : n.removeAttribute(s);
          break;
        case "rowSpan":
        case "start":
          h == null || typeof h == "function" || typeof h == "symbol" || isNaN(h) ? n.removeAttribute(s) : (pe(h, s), n.setAttribute(s, h));
          break;
        case "popover":
          rn("beforetoggle", n), rn("toggle", n), pn(n, "popover", h);
          break;
        case "xlinkActuate":
          Lt(
            n,
            $h,
            "xlink:actuate",
            h
          );
          break;
        case "xlinkArcrole":
          Lt(
            n,
            $h,
            "xlink:arcrole",
            h
          );
          break;
        case "xlinkRole":
          Lt(
            n,
            $h,
            "xlink:role",
            h
          );
          break;
        case "xlinkShow":
          Lt(
            n,
            $h,
            "xlink:show",
            h
          );
          break;
        case "xlinkTitle":
          Lt(
            n,
            $h,
            "xlink:title",
            h
          );
          break;
        case "xlinkType":
          Lt(
            n,
            $h,
            "xlink:type",
            h
          );
          break;
        case "xmlBase":
          Lt(
            n,
            P4,
            "xml:base",
            h
          );
          break;
        case "xmlLang":
          Lt(
            n,
            P4,
            "xml:lang",
            h
          );
          break;
        case "xmlSpace":
          Lt(
            n,
            P4,
            "xml:space",
            h
          );
          break;
        case "is":
          C != null && console.error(
            'Cannot update the "is" prop after it has been initialized.'
          ), pn(n, "is", h);
          break;
        case "innerText":
        case "textContent":
          break;
        case "popoverTarget":
          Z8 || h == null || typeof h != "object" || (Z8 = !0, console.error(
            "The `popoverTarget` prop expects the ID of an Element as a string. Received %s instead.",
            h
          ));
        default:
          !(2 < s.length) || s[0] !== "o" && s[0] !== "O" || s[1] !== "n" && s[1] !== "N" ? (s = Ui(s), pn(n, s, h)) : hs.hasOwnProperty(s) && h != null && typeof h != "function" && ta(s, h);
      }
    }
    function Kd(n, o, s, h, y, C) {
      switch (s) {
        case "style":
          hi(n, h, C);
          break;
        case "dangerouslySetInnerHTML":
          if (h != null) {
            if (typeof h != "object" || !("__html" in h))
              throw Error(
                "`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information."
              );
            if (s = h.__html, s != null) {
              if (y.children != null)
                throw Error(
                  "Can only set one of `children` or `props.dangerouslySetInnerHTML`."
                );
              n.innerHTML = s;
            }
          }
          break;
        case "children":
          typeof h == "string" ? er(n, h) : (typeof h == "number" || typeof h == "bigint") && er(n, "" + h);
          break;
        case "onScroll":
          h != null && (typeof h != "function" && ta(s, h), rn("scroll", n));
          break;
        case "onScrollEnd":
          h != null && (typeof h != "function" && ta(s, h), rn("scrollend", n));
          break;
        case "onClick":
          h != null && (typeof h != "function" && ta(s, h), n.onclick = tr);
          break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
          break;
        case "innerText":
        case "textContent":
          break;
        default:
          if (hs.hasOwnProperty(s))
            h != null && typeof h != "function" && ta(s, h);
          else
            e: {
              if (s[0] === "o" && s[1] === "n" && (y = s.endsWith("Capture"), o = s.slice(2, y ? s.length - 7 : void 0), C = n[qo] || null, C = C != null ? C[s] : null, typeof C == "function" && n.removeEventListener(o, C, y), typeof h == "function")) {
                typeof C != "function" && C !== null && (s in n ? n[s] = null : n.hasAttribute(s) && n.removeAttribute(s)), n.addEventListener(o, h, y);
                break e;
              }
              s in n ? n[s] = h : h === !0 ? n.setAttribute(s, "") : pn(n, s, h);
            }
      }
    }
    function Ur(n, o, s) {
      switch (Uo(o, s), o) {
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
          break;
        case "img":
          rn("error", n), rn("load", n);
          var h = !1, y = !1, C;
          for (C in s)
            if (s.hasOwnProperty(C)) {
              var A = s[C];
              if (A != null)
                switch (C) {
                  case "src":
                    h = !0;
                    break;
                  case "srcSet":
                    y = !0;
                    break;
                  case "children":
                  case "dangerouslySetInnerHTML":
                    throw Error(
                      o + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                    );
                  default:
                    dr(n, o, C, A, s, null);
                }
            }
          y && dr(n, o, "srcSet", s.srcSet, s, null), h && dr(n, o, "src", s.src, s, null);
          return;
        case "input":
          jn("input", s), rn("invalid", n);
          var z = C = A = y = null, q = null, Z = null;
          for (h in s)
            if (s.hasOwnProperty(h)) {
              var xe = s[h];
              if (xe != null)
                switch (h) {
                  case "name":
                    y = xe;
                    break;
                  case "type":
                    A = xe;
                    break;
                  case "checked":
                    q = xe;
                    break;
                  case "defaultChecked":
                    Z = xe;
                    break;
                  case "value":
                    C = xe;
                    break;
                  case "defaultValue":
                    z = xe;
                    break;
                  case "children":
                  case "dangerouslySetInnerHTML":
                    if (xe != null)
                      throw Error(
                        o + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                      );
                    break;
                  default:
                    dr(n, o, h, xe, s, null);
                }
            }
          Dt(n, s), Mn(
            n,
            C,
            z,
            q,
            Z,
            A,
            y,
            !1
          );
          return;
        case "select":
          jn("select", s), rn("invalid", n), h = A = C = null;
          for (y in s)
            if (s.hasOwnProperty(y) && (z = s[y], z != null))
              switch (y) {
                case "value":
                  C = z;
                  break;
                case "defaultValue":
                  A = z;
                  break;
                case "multiple":
                  h = z;
                default:
                  dr(
                    n,
                    o,
                    y,
                    z,
                    s,
                    null
                  );
              }
          Rr(n, s), o = C, s = A, n.multiple = !!h, o != null ? qn(n, !!h, o, !1) : s != null && qn(n, !!h, s, !0);
          return;
        case "textarea":
          jn("textarea", s), rn("invalid", n), C = y = h = null;
          for (A in s)
            if (s.hasOwnProperty(A) && (z = s[A], z != null))
              switch (A) {
                case "value":
                  h = z;
                  break;
                case "defaultValue":
                  y = z;
                  break;
                case "children":
                  C = z;
                  break;
                case "dangerouslySetInnerHTML":
                  if (z != null)
                    throw Error(
                      "`dangerouslySetInnerHTML` does not make sense on <textarea>."
                    );
                  break;
                default:
                  dr(
                    n,
                    o,
                    A,
                    z,
                    s,
                    null
                  );
              }
          Wt(n, s), Xt(n, h, y, C);
          return;
        case "option":
          wr(n, s);
          for (q in s)
            if (s.hasOwnProperty(q) && (h = s[q], h != null))
              switch (q) {
                case "selected":
                  n.selected = h && typeof h != "function" && typeof h != "symbol";
                  break;
                default:
                  dr(n, o, q, h, s, null);
              }
          return;
        case "dialog":
          rn("beforetoggle", n), rn("toggle", n), rn("cancel", n), rn("close", n);
          break;
        case "iframe":
        case "object":
          rn("load", n);
          break;
        case "video":
        case "audio":
          for (h = 0; h < E1.length; h++)
            rn(E1[h], n);
          break;
        case "image":
          rn("error", n), rn("load", n);
          break;
        case "details":
          rn("toggle", n);
          break;
        case "embed":
        case "source":
        case "link":
          rn("error", n), rn("load", n);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
          for (Z in s)
            if (s.hasOwnProperty(Z) && (h = s[Z], h != null))
              switch (Z) {
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(
                    o + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                  );
                default:
                  dr(n, o, Z, h, s, null);
              }
          return;
        default:
          if (ka(o)) {
            for (xe in s)
              s.hasOwnProperty(xe) && (h = s[xe], h !== void 0 && Kd(
                n,
                o,
                xe,
                h,
                s,
                void 0
              ));
            return;
          }
      }
      for (z in s)
        s.hasOwnProperty(z) && (h = s[z], h != null && dr(n, o, z, h, s, null));
    }
    function ja(n, o, s, h) {
      switch (Uo(o, h), o) {
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
          break;
        case "input":
          var y = null, C = null, A = null, z = null, q = null, Z = null, xe = null;
          for (Ve in s) {
            var ke = s[Ve];
            if (s.hasOwnProperty(Ve) && ke != null)
              switch (Ve) {
                case "checked":
                  break;
                case "value":
                  break;
                case "defaultValue":
                  q = ke;
                default:
                  h.hasOwnProperty(Ve) || dr(
                    n,
                    o,
                    Ve,
                    null,
                    h,
                    ke
                  );
              }
          }
          for (var de in h) {
            var Ve = h[de];
            if (ke = s[de], h.hasOwnProperty(de) && (Ve != null || ke != null))
              switch (de) {
                case "type":
                  C = Ve;
                  break;
                case "name":
                  y = Ve;
                  break;
                case "checked":
                  Z = Ve;
                  break;
                case "defaultChecked":
                  xe = Ve;
                  break;
                case "value":
                  A = Ve;
                  break;
                case "defaultValue":
                  z = Ve;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (Ve != null)
                    throw Error(
                      o + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                    );
                  break;
                default:
                  Ve !== ke && dr(
                    n,
                    o,
                    de,
                    Ve,
                    h,
                    ke
                  );
              }
          }
          o = s.type === "checkbox" || s.type === "radio" ? s.checked != null : s.value != null, h = h.type === "checkbox" || h.type === "radio" ? h.checked != null : h.value != null, o || !h || Q8 || (console.error(
            "A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://react.dev/link/controlled-components"
          ), Q8 = !0), !o || h || Y8 || (console.error(
            "A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://react.dev/link/controlled-components"
          ), Y8 = !0), Yt(
            n,
            A,
            z,
            q,
            Z,
            xe,
            C,
            y
          );
          return;
        case "select":
          Ve = A = z = de = null;
          for (C in s)
            if (q = s[C], s.hasOwnProperty(C) && q != null)
              switch (C) {
                case "value":
                  break;
                case "multiple":
                  Ve = q;
                default:
                  h.hasOwnProperty(C) || dr(
                    n,
                    o,
                    C,
                    null,
                    h,
                    q
                  );
              }
          for (y in h)
            if (C = h[y], q = s[y], h.hasOwnProperty(y) && (C != null || q != null))
              switch (y) {
                case "value":
                  de = C;
                  break;
                case "defaultValue":
                  z = C;
                  break;
                case "multiple":
                  A = C;
                default:
                  C !== q && dr(
                    n,
                    o,
                    y,
                    C,
                    h,
                    q
                  );
              }
          h = z, o = A, s = Ve, de != null ? qn(n, !!o, de, !1) : !!s != !!o && (h != null ? qn(n, !!o, h, !0) : qn(n, !!o, o ? [] : "", !1));
          return;
        case "textarea":
          Ve = de = null;
          for (z in s)
            if (y = s[z], s.hasOwnProperty(z) && y != null && !h.hasOwnProperty(z))
              switch (z) {
                case "value":
                  break;
                case "children":
                  break;
                default:
                  dr(n, o, z, null, h, y);
              }
          for (A in h)
            if (y = h[A], C = s[A], h.hasOwnProperty(A) && (y != null || C != null))
              switch (A) {
                case "value":
                  de = y;
                  break;
                case "defaultValue":
                  Ve = y;
                  break;
                case "children":
                  break;
                case "dangerouslySetInnerHTML":
                  if (y != null)
                    throw Error(
                      "`dangerouslySetInnerHTML` does not make sense on <textarea>."
                    );
                  break;
                default:
                  y !== C && dr(n, o, A, y, h, C);
              }
          en(n, de, Ve);
          return;
        case "option":
          for (var yt in s)
            if (de = s[yt], s.hasOwnProperty(yt) && de != null && !h.hasOwnProperty(yt))
              switch (yt) {
                case "selected":
                  n.selected = !1;
                  break;
                default:
                  dr(
                    n,
                    o,
                    yt,
                    null,
                    h,
                    de
                  );
              }
          for (q in h)
            if (de = h[q], Ve = s[q], h.hasOwnProperty(q) && de !== Ve && (de != null || Ve != null))
              switch (q) {
                case "selected":
                  n.selected = de && typeof de != "function" && typeof de != "symbol";
                  break;
                default:
                  dr(
                    n,
                    o,
                    q,
                    de,
                    h,
                    Ve
                  );
              }
          return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
          for (var Mt in s)
            de = s[Mt], s.hasOwnProperty(Mt) && de != null && !h.hasOwnProperty(Mt) && dr(
              n,
              o,
              Mt,
              null,
              h,
              de
            );
          for (Z in h)
            if (de = h[Z], Ve = s[Z], h.hasOwnProperty(Z) && de !== Ve && (de != null || Ve != null))
              switch (Z) {
                case "children":
                case "dangerouslySetInnerHTML":
                  if (de != null)
                    throw Error(
                      o + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                    );
                  break;
                default:
                  dr(
                    n,
                    o,
                    Z,
                    de,
                    h,
                    Ve
                  );
              }
          return;
        default:
          if (ka(o)) {
            for (var Vr in s)
              de = s[Vr], s.hasOwnProperty(Vr) && de !== void 0 && !h.hasOwnProperty(Vr) && Kd(
                n,
                o,
                Vr,
                void 0,
                h,
                de
              );
            for (xe in h)
              de = h[xe], Ve = s[xe], !h.hasOwnProperty(xe) || de === Ve || de === void 0 && Ve === void 0 || Kd(
                n,
                o,
                xe,
                de,
                h,
                Ve
              );
            return;
          }
      }
      for (var Yn in s)
        de = s[Yn], s.hasOwnProperty(Yn) && de != null && !h.hasOwnProperty(Yn) && dr(n, o, Yn, null, h, de);
      for (ke in h)
        de = h[ke], Ve = s[ke], !h.hasOwnProperty(ke) || de === Ve || de == null && Ve == null || dr(n, o, ke, de, h, Ve);
    }
    function Us(n) {
      switch (n) {
        case "class":
          return "className";
        case "for":
          return "htmlFor";
        default:
          return n;
      }
    }
    function zu(n) {
      var o = {};
      n = n.style;
      for (var s = 0; s < n.length; s++) {
        var h = n[s];
        o[h] = n.getPropertyValue(h);
      }
      return o;
    }
    function ss(n, o, s) {
      if (o != null && typeof o != "object")
        console.error(
          "The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX."
        );
      else {
        var h, y = h = "", C;
        for (C in o)
          if (o.hasOwnProperty(C)) {
            var A = o[C];
            A != null && typeof A != "boolean" && A !== "" && (C.indexOf("--") === 0 ? (Qe(A, C), h += y + C + ":" + ("" + A).trim()) : typeof A != "number" || A === 0 || jt.has(C) ? (Qe(A, C), h += y + C.replace(Ge, "-$1").toLowerCase().replace(At, "-ms-") + ":" + ("" + A).trim()) : h += y + C.replace(Ge, "-$1").toLowerCase().replace(At, "-ms-") + ":" + A + "px", y = ";");
          }
        h = h || null, o = n.getAttribute("style"), o !== h && (h = Rl(h), Rl(o) !== h && (s.style = zu(n)));
      }
    }
    function ni(n, o, s, h, y, C) {
      if (y.delete(s), n = n.getAttribute(s), n === null)
        switch (typeof h) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            return;
        }
      else if (h != null)
        switch (typeof h) {
          case "function":
          case "symbol":
          case "boolean":
            break;
          default:
            if (pe(h, o), n === "" + h)
              return;
        }
      ea(o, n, h, C);
    }
    function bg(n, o, s, h, y, C) {
      if (y.delete(s), n = n.getAttribute(s), n === null) {
        switch (typeof h) {
          case "function":
          case "symbol":
            return;
        }
        if (!h) return;
      } else
        switch (typeof h) {
          case "function":
          case "symbol":
            break;
          default:
            if (h) return;
        }
      ea(o, n, h, C);
    }
    function yg(n, o, s, h, y, C) {
      if (y.delete(s), n = n.getAttribute(s), n === null)
        switch (typeof h) {
          case "undefined":
          case "function":
          case "symbol":
            return;
        }
      else if (h != null)
        switch (typeof h) {
          case "function":
          case "symbol":
            break;
          default:
            if (pe(h, s), n === "" + h)
              return;
        }
      ea(o, n, h, C);
    }
    function Yd(n, o, s, h, y, C) {
      if (y.delete(s), n = n.getAttribute(s), n === null)
        switch (typeof h) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            return;
          default:
            if (isNaN(h)) return;
        }
      else if (h != null)
        switch (typeof h) {
          case "function":
          case "symbol":
          case "boolean":
            break;
          default:
            if (!isNaN(h) && (pe(h, o), n === "" + h))
              return;
        }
      ea(o, n, h, C);
    }
    function Jm(n, o, s, h, y, C) {
      if (y.delete(s), n = n.getAttribute(s), n === null)
        switch (typeof h) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            return;
        }
      else if (h != null)
        switch (typeof h) {
          case "function":
          case "symbol":
          case "boolean":
            break;
          default:
            if (pe(h, o), s = pr("" + h), n === s)
              return;
        }
      ea(o, n, h, C);
    }
    function ri(n, o, s, h) {
      for (var y = {}, C = /* @__PURE__ */ new Set(), A = n.attributes, z = 0; z < A.length; z++)
        switch (A[z].name.toLowerCase()) {
          case "value":
            break;
          case "checked":
            break;
          case "selected":
            break;
          default:
            C.add(A[z].name);
        }
      if (ka(o)) {
        for (var q in s)
          if (s.hasOwnProperty(q)) {
            var Z = s[q];
            if (Z != null) {
              if (hs.hasOwnProperty(q))
                typeof Z != "function" && ta(q, Z);
              else if (s.suppressHydrationWarning !== !0)
                switch (q) {
                  case "children":
                    typeof Z != "string" && typeof Z != "number" || ea(
                      "children",
                      n.textContent,
                      Z,
                      y
                    );
                    continue;
                  case "suppressContentEditableWarning":
                  case "suppressHydrationWarning":
                  case "defaultValue":
                  case "defaultChecked":
                  case "innerHTML":
                  case "ref":
                    continue;
                  case "dangerouslySetInnerHTML":
                    A = n.innerHTML, Z = Z ? Z.__html : void 0, Z != null && (Z = vg(n, Z), ea(
                      q,
                      A,
                      Z,
                      y
                    ));
                    continue;
                  case "style":
                    C.delete(q), ss(n, Z, y);
                    continue;
                  case "offsetParent":
                  case "offsetTop":
                  case "offsetLeft":
                  case "offsetWidth":
                  case "offsetHeight":
                  case "isContentEditable":
                  case "outerText":
                  case "outerHTML":
                    C.delete(q.toLowerCase()), console.error(
                      "Assignment to read-only property will result in a no-op: `%s`",
                      q
                    );
                    continue;
                  case "className":
                    C.delete("class"), A = Ut(
                      n,
                      "class",
                      Z
                    ), ea(
                      "className",
                      A,
                      Z,
                      y
                    );
                    continue;
                  default:
                    h.context === dd && o !== "svg" && o !== "math" ? C.delete(q.toLowerCase()) : C.delete(q), A = Ut(
                      n,
                      q,
                      Z
                    ), ea(
                      q,
                      A,
                      Z,
                      y
                    );
                }
            }
          }
      } else
        for (Z in s)
          if (s.hasOwnProperty(Z) && (q = s[Z], q != null)) {
            if (hs.hasOwnProperty(Z))
              typeof q != "function" && ta(Z, q);
            else if (s.suppressHydrationWarning !== !0)
              switch (Z) {
                case "children":
                  typeof q != "string" && typeof q != "number" || ea(
                    "children",
                    n.textContent,
                    q,
                    y
                  );
                  continue;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                case "value":
                case "checked":
                case "selected":
                case "defaultValue":
                case "defaultChecked":
                case "innerHTML":
                case "ref":
                  continue;
                case "dangerouslySetInnerHTML":
                  A = n.innerHTML, q = q ? q.__html : void 0, q != null && (q = vg(n, q), A !== q && (y[Z] = { __html: A }));
                  continue;
                case "className":
                  ni(
                    n,
                    Z,
                    "class",
                    q,
                    C,
                    y
                  );
                  continue;
                case "tabIndex":
                  ni(
                    n,
                    Z,
                    "tabindex",
                    q,
                    C,
                    y
                  );
                  continue;
                case "style":
                  C.delete(Z), ss(n, q, y);
                  continue;
                case "multiple":
                  C.delete(Z), ea(
                    Z,
                    n.multiple,
                    q,
                    y
                  );
                  continue;
                case "muted":
                  C.delete(Z), ea(
                    Z,
                    n.muted,
                    q,
                    y
                  );
                  continue;
                case "autoFocus":
                  C.delete("autofocus"), ea(
                    Z,
                    n.autofocus,
                    q,
                    y
                  );
                  continue;
                case "data":
                  if (o !== "object") {
                    C.delete(Z), A = n.getAttribute("data"), ea(
                      Z,
                      A,
                      q,
                      y
                    );
                    continue;
                  }
                case "src":
                case "href":
                  if (!(q !== "" || o === "a" && Z === "href" || o === "object" && Z === "data")) {
                    console.error(
                      Z === "src" ? 'An empty string ("") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string.' : 'An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.',
                      Z,
                      Z
                    );
                    continue;
                  }
                  Jm(
                    n,
                    Z,
                    Z,
                    q,
                    C,
                    y
                  );
                  continue;
                case "action":
                case "formAction":
                  if (A = n.getAttribute(Z), typeof q == "function") {
                    C.delete(Z.toLowerCase()), Z === "formAction" ? (C.delete("name"), C.delete("formenctype"), C.delete("formmethod"), C.delete("formtarget")) : (C.delete("enctype"), C.delete("method"), C.delete("target"));
                    continue;
                  } else if (A === yT) {
                    C.delete(Z.toLowerCase()), ea(
                      Z,
                      "function",
                      q,
                      y
                    );
                    continue;
                  }
                  Jm(
                    n,
                    Z,
                    Z.toLowerCase(),
                    q,
                    C,
                    y
                  );
                  continue;
                case "xlinkHref":
                  Jm(
                    n,
                    Z,
                    "xlink:href",
                    q,
                    C,
                    y
                  );
                  continue;
                case "contentEditable":
                  yg(
                    n,
                    Z,
                    "contenteditable",
                    q,
                    C,
                    y
                  );
                  continue;
                case "spellCheck":
                  yg(
                    n,
                    Z,
                    "spellcheck",
                    q,
                    C,
                    y
                  );
                  continue;
                case "draggable":
                case "autoReverse":
                case "externalResourcesRequired":
                case "focusable":
                case "preserveAlpha":
                  yg(
                    n,
                    Z,
                    Z,
                    q,
                    C,
                    y
                  );
                  continue;
                case "allowFullScreen":
                case "async":
                case "autoPlay":
                case "controls":
                case "default":
                case "defer":
                case "disabled":
                case "disablePictureInPicture":
                case "disableRemotePlayback":
                case "formNoValidate":
                case "hidden":
                case "loop":
                case "noModule":
                case "noValidate":
                case "open":
                case "playsInline":
                case "readOnly":
                case "required":
                case "reversed":
                case "scoped":
                case "seamless":
                case "itemScope":
                  bg(
                    n,
                    Z,
                    Z.toLowerCase(),
                    q,
                    C,
                    y
                  );
                  continue;
                case "capture":
                case "download":
                  e: {
                    z = n;
                    var xe = A = Z, ke = y;
                    if (C.delete(xe), z = z.getAttribute(xe), z === null)
                      switch (typeof q) {
                        case "undefined":
                        case "function":
                        case "symbol":
                          break e;
                        default:
                          if (q === !1) break e;
                      }
                    else if (q != null)
                      switch (typeof q) {
                        case "function":
                        case "symbol":
                          break;
                        case "boolean":
                          if (q === !0 && z === "") break e;
                          break;
                        default:
                          if (pe(q, A), z === "" + q)
                            break e;
                      }
                    ea(
                      A,
                      z,
                      q,
                      ke
                    );
                  }
                  continue;
                case "cols":
                case "rows":
                case "size":
                case "span":
                  e: {
                    if (z = n, xe = A = Z, ke = y, C.delete(xe), z = z.getAttribute(xe), z === null)
                      switch (typeof q) {
                        case "undefined":
                        case "function":
                        case "symbol":
                        case "boolean":
                          break e;
                        default:
                          if (isNaN(q) || 1 > q) break e;
                      }
                    else if (q != null)
                      switch (typeof q) {
                        case "function":
                        case "symbol":
                        case "boolean":
                          break;
                        default:
                          if (!(isNaN(q) || 1 > q) && (pe(q, A), z === "" + q))
                            break e;
                      }
                    ea(
                      A,
                      z,
                      q,
                      ke
                    );
                  }
                  continue;
                case "rowSpan":
                  Yd(
                    n,
                    Z,
                    "rowspan",
                    q,
                    C,
                    y
                  );
                  continue;
                case "start":
                  Yd(
                    n,
                    Z,
                    Z,
                    q,
                    C,
                    y
                  );
                  continue;
                case "xHeight":
                  ni(
                    n,
                    Z,
                    "x-height",
                    q,
                    C,
                    y
                  );
                  continue;
                case "xlinkActuate":
                  ni(
                    n,
                    Z,
                    "xlink:actuate",
                    q,
                    C,
                    y
                  );
                  continue;
                case "xlinkArcrole":
                  ni(
                    n,
                    Z,
                    "xlink:arcrole",
                    q,
                    C,
                    y
                  );
                  continue;
                case "xlinkRole":
                  ni(
                    n,
                    Z,
                    "xlink:role",
                    q,
                    C,
                    y
                  );
                  continue;
                case "xlinkShow":
                  ni(
                    n,
                    Z,
                    "xlink:show",
                    q,
                    C,
                    y
                  );
                  continue;
                case "xlinkTitle":
                  ni(
                    n,
                    Z,
                    "xlink:title",
                    q,
                    C,
                    y
                  );
                  continue;
                case "xlinkType":
                  ni(
                    n,
                    Z,
                    "xlink:type",
                    q,
                    C,
                    y
                  );
                  continue;
                case "xmlBase":
                  ni(
                    n,
                    Z,
                    "xml:base",
                    q,
                    C,
                    y
                  );
                  continue;
                case "xmlLang":
                  ni(
                    n,
                    Z,
                    "xml:lang",
                    q,
                    C,
                    y
                  );
                  continue;
                case "xmlSpace":
                  ni(
                    n,
                    Z,
                    "xml:space",
                    q,
                    C,
                    y
                  );
                  continue;
                case "inert":
                  q !== "" || zw[Z] || (zw[Z] = !0, console.error(
                    "Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.",
                    Z
                  )), bg(
                    n,
                    Z,
                    Z,
                    q,
                    C,
                    y
                  );
                  continue;
                default:
                  if (!(2 < Z.length) || Z[0] !== "o" && Z[0] !== "O" || Z[1] !== "n" && Z[1] !== "N") {
                    z = Ui(Z), A = !1, h.context === dd && o !== "svg" && o !== "math" ? C.delete(z.toLowerCase()) : (xe = Z.toLowerCase(), xe = $l.hasOwnProperty(
                      xe
                    ) && $l[xe] || null, xe !== null && xe !== Z && (A = !0, C.delete(xe)), C.delete(z));
                    e: if (xe = n, ke = z, z = q, xn(ke))
                      if (xe.hasAttribute(ke))
                        xe = xe.getAttribute(
                          ke
                        ), pe(
                          z,
                          ke
                        ), z = xe === "" + z ? z : xe;
                      else {
                        switch (typeof z) {
                          case "function":
                          case "symbol":
                            break e;
                          case "boolean":
                            if (xe = ke.toLowerCase().slice(0, 5), xe !== "data-" && xe !== "aria-")
                              break e;
                        }
                        z = z === void 0 ? void 0 : null;
                      }
                    else z = void 0;
                    A || ea(
                      Z,
                      z,
                      q,
                      y
                    );
                  }
              }
          }
      return 0 < C.size && s.suppressHydrationWarning !== !0 && Qm(n, C, y), Object.keys(y).length === 0 ? null : y;
    }
    function cy(n, o) {
      switch (n.length) {
        case 0:
          return "";
        case 1:
          return n[0];
        case 2:
          return n[0] + " " + o + " " + n[1];
        default:
          return n.slice(0, -1).join(", ") + ", " + o + " " + n[n.length - 1];
      }
    }
    function Xo(n) {
      switch (n) {
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
          return !0;
        default:
          return !1;
      }
    }
    function dy() {
      if (typeof performance.getEntriesByType == "function") {
        for (var n = 0, o = 0, s = performance.getEntriesByType("resource"), h = 0; h < s.length; h++) {
          var y = s[h], C = y.transferSize, A = y.initiatorType, z = y.duration;
          if (C && z && Xo(A)) {
            for (A = 0, z = y.responseEnd, h += 1; h < s.length; h++) {
              var q = s[h], Z = q.startTime;
              if (Z > z) break;
              var xe = q.transferSize, ke = q.initiatorType;
              xe && Xo(ke) && (q = q.responseEnd, A += xe * (q < z ? 1 : (z - Z) / (q - Z)));
            }
            if (--h, o += 8 * (C + A) / (y.duration / 1e3), n++, 10 < n) break;
          }
        }
        if (0 < n) return o / n / 1e6;
      }
      return navigator.connection && (n = navigator.connection.downlink, typeof n == "number") ? n : 5;
    }
    function Zm(n) {
      return n.nodeType === 9 ? n : n.ownerDocument;
    }
    function fy(n) {
      switch (n) {
        case Pn:
          return y0;
        case vn:
          return Iw;
        default:
          return dd;
      }
    }
    function Xs(n, o) {
      if (n === dd)
        switch (o) {
          case "svg":
            return y0;
          case "math":
            return Iw;
          default:
            return dd;
        }
      return n === y0 && o === "foreignObject" ? dd : n;
    }
    function Qd(n, o) {
      return n === "textarea" || n === "noscript" || typeof o.children == "string" || typeof o.children == "number" || typeof o.children == "bigint" || typeof o.dangerouslySetInnerHTML == "object" && o.dangerouslySetInnerHTML !== null && o.dangerouslySetInnerHTML.__html != null;
    }
    function d2() {
      var n = window.event;
      return n && n.type === "popstate" ? n === T4 ? !1 : (T4 = n, !0) : (T4 = null, !1);
    }
    function us() {
      var n = window.event;
      return n && n !== M1 ? n.type : null;
    }
    function Jd() {
      var n = window.event;
      return n && n !== M1 ? n.timeStamp : -1.1;
    }
    function my(n) {
      setTimeout(function() {
        throw n;
      });
    }
    function hy(n, o, s) {
      switch (o) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          s.autoFocus && n.focus();
          break;
        case "img":
          s.src ? n.src = s.src : s.srcSet && (n.srcset = s.srcSet);
      }
    }
    function py() {
    }
    function wg(n, o, s, h) {
      ja(n, o, s, h), n[qo] = h;
    }
    function Sg(n) {
      er(n, "");
    }
    function bC(n, o, s) {
      n.nodeValue = s;
    }
    function gy(n) {
      if (!n.__reactWarnedAboutChildrenConflict) {
        var o = n[qo] || null;
        if (o !== null) {
          var s = bt(n);
          s !== null && (typeof o.children == "string" || typeof o.children == "number" ? (n.__reactWarnedAboutChildrenConflict = !0, le(s, function() {
            console.error(
              'Cannot use a ref on a React element as a container to `createRoot` or `createPortal` if that element also sets "children" text content using React. It should be a leaf with no children. Otherwise it\'s ambiguous which children should be used.'
            );
          })) : o.dangerouslySetInnerHTML != null && (n.__reactWarnedAboutChildrenConflict = !0, le(s, function() {
            console.error(
              'Cannot use a ref on a React element as a container to `createRoot` or `createPortal` if that element also sets "dangerouslySetInnerHTML" using React. It should be a leaf with no children. Otherwise it\'s ambiguous which children should be used.'
            );
          })));
        }
      }
    }
    function ju(n) {
      return n === "head";
    }
    function vy(n, o) {
      n.removeChild(o);
    }
    function by(n, o) {
      (n.nodeType === 9 ? n.body : n.nodeName === "HTML" ? n.ownerDocument.body : n).removeChild(o);
    }
    function $c(n, o) {
      var s = o, h = 0;
      do {
        var y = s.nextSibling;
        if (n.removeChild(s), y && y.nodeType === 8)
          if (s = y.data, s === k1 || s === jw) {
            if (h === 0) {
              n.removeChild(y), Lc(o);
              return;
            }
            h--;
          } else if (s === P1 || s === jf || s === jh || s === b0 || s === zh)
            h++;
          else if (s === ST)
            qs(
              n.ownerDocument.documentElement
            );
          else if (s === xT) {
            s = n.ownerDocument.head, qs(s);
            for (var C = s.firstChild; C; ) {
              var A = C.nextSibling, z = C.nodeName;
              C[pf] || z === "SCRIPT" || z === "STYLE" || z === "LINK" && C.rel.toLowerCase() === "stylesheet" || s.removeChild(C), C = A;
            }
          } else
            s === CT && qs(n.ownerDocument.body);
        s = y;
      } while (s);
      Lc(o);
    }
    function eh(n, o) {
      var s = n;
      n = 0;
      do {
        var h = s.nextSibling;
        if (s.nodeType === 1 ? o ? (s._stashedDisplay = s.style.display, s.style.display = "none") : (s.style.display = s._stashedDisplay || "", s.getAttribute("style") === "" && s.removeAttribute("style")) : s.nodeType === 3 && (o ? (s._stashedText = s.nodeValue, s.nodeValue = "") : s.nodeValue = s._stashedText || ""), h && h.nodeType === 8)
          if (s = h.data, s === k1) {
            if (n === 0) break;
            n--;
          } else
            s !== P1 && s !== jf && s !== jh && s !== b0 || n++;
        s = h;
      } while (s);
    }
    function yy(n) {
      eh(n, !0);
    }
    function wy(n) {
      n = n.style, typeof n.setProperty == "function" ? n.setProperty("display", "none", "important") : n.display = "none";
    }
    function Sy(n) {
      n.nodeValue = "";
    }
    function Cy(n) {
      eh(n, !1);
    }
    function xy(n, o) {
      o = o[ET], o = o != null && o.hasOwnProperty("display") ? o.display : null, n.style.display = o == null || typeof o == "boolean" ? "" : ("" + o).trim();
    }
    function Ey(n, o) {
      n.nodeValue = o;
    }
    function Zd(n) {
      var o = n.firstChild;
      for (o && o.nodeType === 10 && (o = o.nextSibling); o; ) {
        var s = o;
        switch (o = o.nextSibling, s.nodeName) {
          case "HTML":
          case "HEAD":
          case "BODY":
            Zd(s), st(s);
            continue;
          case "SCRIPT":
          case "STYLE":
            continue;
          case "LINK":
            if (s.rel.toLowerCase() === "stylesheet") continue;
        }
        n.removeChild(s);
      }
    }
    function Py(n, o, s, h) {
      for (; n.nodeType === 1; ) {
        var y = s;
        if (n.nodeName.toLowerCase() !== o.toLowerCase()) {
          if (!h && (n.nodeName !== "INPUT" || n.type !== "hidden"))
            break;
        } else if (h) {
          if (!n[pf])
            switch (o) {
              case "meta":
                if (!n.hasAttribute("itemprop")) break;
                return n;
              case "link":
                if (C = n.getAttribute("rel"), C === "stylesheet" && n.hasAttribute("data-precedence") || C !== y.rel || n.getAttribute("href") !== (y.href == null || y.href === "" ? null : y.href) || n.getAttribute("crossorigin") !== (y.crossOrigin == null ? null : y.crossOrigin) || n.getAttribute("title") !== (y.title == null ? null : y.title))
                  break;
                return n;
              case "style":
                if (n.hasAttribute("data-precedence")) break;
                return n;
              case "script":
                if (C = n.getAttribute("src"), (C !== (y.src == null ? null : y.src) || n.getAttribute("type") !== (y.type == null ? null : y.type) || n.getAttribute("crossorigin") !== (y.crossOrigin == null ? null : y.crossOrigin)) && C && n.hasAttribute("async") && !n.hasAttribute("itemprop"))
                  break;
                return n;
              default:
                return n;
            }
        } else if (o === "input" && n.type === "hidden") {
          pe(y.name, "name");
          var C = y.name == null ? null : "" + y.name;
          if (y.type === "hidden" && n.getAttribute("name") === C)
            return n;
        } else return n;
        if (n = Mi(n.nextSibling), n === null) break;
      }
      return null;
    }
    function ky(n, o, s) {
      if (o === "") return null;
      for (; n.nodeType !== 3; )
        if ((n.nodeType !== 1 || n.nodeName !== "INPUT" || n.type !== "hidden") && !s || (n = Mi(n.nextSibling), n === null)) return null;
      return n;
    }
    function yr(n, o) {
      for (; n.nodeType !== 8; )
        if ((n.nodeType !== 1 || n.nodeName !== "INPUT" || n.type !== "hidden") && !o || (n = Mi(n.nextSibling), n === null)) return null;
      return n;
    }
    function th(n) {
      return n.data === jf || n.data === jh;
    }
    function f2(n) {
      return n.data === b0 || n.data === jf && n.ownerDocument.readyState !== t5;
    }
    function My(n, o) {
      var s = n.ownerDocument;
      if (n.data === jh)
        n._reactRetry = o;
      else if (n.data !== jf || s.readyState !== t5)
        o();
      else {
        var h = function() {
          o(), s.removeEventListener("DOMContentLoaded", h);
        };
        s.addEventListener("DOMContentLoaded", h), n._reactRetry = h;
      }
    }
    function Mi(n) {
      for (; n != null; n = n.nextSibling) {
        var o = n.nodeType;
        if (o === 1 || o === 3) break;
        if (o === 8) {
          if (o = n.data, o === P1 || o === b0 || o === jf || o === jh || o === zh || o === k4 || o === e5)
            break;
          if (o === k1 || o === jw)
            return null;
        }
      }
      return n;
    }
    function Oy(n) {
      if (n.nodeType === 1) {
        for (var o = n.nodeName.toLowerCase(), s = {}, h = n.attributes, y = 0; y < h.length; y++) {
          var C = h[y];
          s[Us(C.name)] = C.name.toLowerCase() === "style" ? zu(n) : C.value;
        }
        return { type: o, props: s };
      }
      return n.nodeType === 8 ? n.data === zh ? { type: "Activity", props: {} } : { type: "Suspense", props: {} } : n.nodeValue;
    }
    function Ty(n, o, s) {
      return s === null || s[wT] !== !0 ? (n.nodeValue === o ? n = null : (o = Rl(o), n = Rl(n.nodeValue) === o ? null : n.nodeValue), n) : null;
    }
    function ef(n) {
      n = n.nextSibling;
      for (var o = 0; n; ) {
        if (n.nodeType === 8) {
          var s = n.data;
          if (s === k1 || s === jw) {
            if (o === 0)
              return Mi(n.nextSibling);
            o--;
          } else
            s !== P1 && s !== b0 && s !== jf && s !== jh && s !== zh || o++;
        }
        n = n.nextSibling;
      }
      return null;
    }
    function zc(n) {
      n = n.previousSibling;
      for (var o = 0; n; ) {
        if (n.nodeType === 8) {
          var s = n.data;
          if (s === P1 || s === b0 || s === jf || s === jh || s === zh) {
            if (o === 0) return n;
            o--;
          } else
            s !== k1 && s !== jw || o++;
        }
        n = n.previousSibling;
      }
      return null;
    }
    function m2(n) {
      Lc(n);
    }
    function Cg(n) {
      Lc(n);
    }
    function h2(n) {
      Lc(n);
    }
    function Gs(n, o, s, h, y) {
      switch (y && Qt(n, h.ancestorInfo), o = Zm(s), n) {
        case "html":
          if (n = o.documentElement, !n)
            throw Error(
              "React expected an <html> element (document.documentElement) to exist in the Document but one was not found. React never removes the documentElement for any Document it renders into so the cause is likely in some other script running on this page."
            );
          return n;
        case "head":
          if (n = o.head, !n)
            throw Error(
              "React expected a <head> element (document.head) to exist in the Document but one was not found. React never removes the head for any Document it renders into so the cause is likely in some other script running on this page."
            );
          return n;
        case "body":
          if (n = o.body, !n)
            throw Error(
              "React expected a <body> element (document.body) to exist in the Document but one was not found. React never removes the body for any Document it renders into so the cause is likely in some other script running on this page."
            );
          return n;
        default:
          throw Error(
            "resolveSingletonInstance was called with an element type that is not supported. This is a bug in React."
          );
      }
    }
    function cs(n, o, s, h) {
      if (!s[Ys] && bt(s)) {
        var y = s.tagName.toLowerCase();
        console.error(
          "You are mounting a new %s component when a previous one has not first unmounted. It is an error to render more than one %s component at a time and attributes and children of these components will likely fail in unpredictable ways. Please only render a single instance of <%s> and if you need to mount a new one, ensure any previous ones have unmounted first.",
          y,
          y,
          y
        );
      }
      switch (n) {
        case "html":
        case "head":
        case "body":
          break;
        default:
          console.error(
            "acquireSingletonInstance was called with an element type that is not supported. This is a bug in React."
          );
      }
      for (y = s.attributes; y.length; )
        s.removeAttributeNode(y[0]);
      Ur(s, n, o), s[Xr] = h, s[qo] = o;
    }
    function qs(n) {
      for (var o = n.attributes; o.length; )
        n.removeAttributeNode(o[0]);
      st(n);
    }
    function xg(n) {
      return typeof n.getRootNode == "function" ? n.getRootNode() : n.nodeType === 9 ? n : n.ownerDocument;
    }
    function p2(n, o, s) {
      var h = w0;
      if (h && typeof o == "string" && o) {
        var y = Gt(o);
        y = 'link[rel="' + n + '"][href="' + y + '"]', typeof s == "string" && (y += '[crossorigin="' + s + '"]'), l5.has(y) || (l5.add(y), n = { rel: n, crossOrigin: s, href: o }, h.querySelector(y) === null && (o = h.createElement("link"), Ur(o, "link", n), Pt(o), h.head.appendChild(o)));
      }
    }
    function g2(n, o, s, h) {
      var y = (y = Oi.current) ? xg(y) : null;
      if (!y)
        throw Error(
          '"resourceRoot" was expected to exist. This is a bug in React.'
        );
      switch (n) {
        case "meta":
        case "title":
          return null;
        case "style":
          return typeof s.precedence == "string" && typeof s.href == "string" ? (s = jc(s.href), o = $t(y).hoistableStyles, h = o.get(s), h || (h = {
            type: "style",
            instance: null,
            count: 0,
            state: null
          }, o.set(s, h)), h) : { type: "void", instance: null, count: 0, state: null };
        case "link":
          if (s.rel === "stylesheet" && typeof s.href == "string" && typeof s.precedence == "string") {
            n = jc(s.href);
            var C = $t(y).hoistableStyles, A = C.get(n);
            if (!A && (y = y.ownerDocument || y, A = {
              type: "stylesheet",
              instance: null,
              count: 0,
              state: { loading: Lh, preload: null }
            }, C.set(n, A), (C = y.querySelector(
              rh(n)
            )) && !C._p && (A.instance = C, A.state.loading = O1 | Es), !Ps.has(n))) {
              var z = {
                rel: "preload",
                as: "style",
                href: s.href,
                crossOrigin: s.crossOrigin,
                integrity: s.integrity,
                media: s.media,
                hrefLang: s.hrefLang,
                referrerPolicy: s.referrerPolicy
              };
              Ps.set(n, z), C || Ry(
                y,
                n,
                z,
                A.state
              );
            }
            if (o && h === null)
              throw s = `

  - ` + nh(o) + `
  + ` + nh(s), Error(
                "Expected <link> not to update to be updated to a stylesheet with precedence. Check the `rel`, `href`, and `precedence` props of this component. Alternatively, check whether two different <link> components render in the same slot or share the same key." + s
              );
            return A;
          }
          if (o && h !== null)
            throw s = `

  - ` + nh(o) + `
  + ` + nh(s), Error(
              "Expected stylesheet with precedence to not be updated to a different kind of <link>. Check the `rel`, `href`, and `precedence` props of this component. Alternatively, check whether two different <link> components render in the same slot or share the same key." + s
            );
          return null;
        case "script":
          return o = s.async, s = s.src, typeof s == "string" && o && typeof o != "function" && typeof o != "symbol" ? (s = Ic(s), o = $t(y).hoistableScripts, h = o.get(s), h || (h = {
            type: "script",
            instance: null,
            count: 0,
            state: null
          }, o.set(s, h)), h) : { type: "void", instance: null, count: 0, state: null };
        default:
          throw Error(
            'getResource encountered a type it did not expect: "' + n + '". this is a bug in React.'
          );
      }
    }
    function nh(n) {
      var o = 0, s = "<link";
      return typeof n.rel == "string" ? (o++, s += ' rel="' + n.rel + '"') : Ti.call(n, "rel") && (o++, s += ' rel="' + (n.rel === null ? "null" : "invalid type " + typeof n.rel) + '"'), typeof n.href == "string" ? (o++, s += ' href="' + n.href + '"') : Ti.call(n, "href") && (o++, s += ' href="' + (n.href === null ? "null" : "invalid type " + typeof n.href) + '"'), typeof n.precedence == "string" ? (o++, s += ' precedence="' + n.precedence + '"') : Ti.call(n, "precedence") && (o++, s += " precedence={" + (n.precedence === null ? "null" : "invalid type " + typeof n.precedence) + "}"), Object.getOwnPropertyNames(n).length > o && (s += " ..."), s + " />";
    }
    function jc(n) {
      return 'href="' + Gt(n) + '"';
    }
    function rh(n) {
      return 'link[rel="stylesheet"][' + n + "]";
    }
    function Eg(n) {
      return Rn({}, n, {
        "data-precedence": n.precedence,
        precedence: null
      });
    }
    function Ry(n, o, s, h) {
      n.querySelector(
        'link[rel="preload"][as="style"][' + o + "]"
      ) ? h.loading = O1 : (o = n.createElement("link"), h.preload = o, o.addEventListener("load", function() {
        return h.loading |= O1;
      }), o.addEventListener("error", function() {
        return h.loading |= o5;
      }), Ur(o, "link", s), Pt(o), n.head.appendChild(o));
    }
    function Ic(n) {
      return '[src="' + Gt(n) + '"]';
    }
    function ah(n) {
      return "script[async]" + n;
    }
    function Pg(n, o, s) {
      if (o.count++, o.instance === null)
        switch (o.type) {
          case "style":
            var h = n.querySelector(
              'style[data-href~="' + Gt(s.href) + '"]'
            );
            if (h)
              return o.instance = h, Pt(h), h;
            var y = Rn({}, s, {
              "data-href": s.href,
              "data-precedence": s.precedence,
              href: null,
              precedence: null
            });
            return h = (n.ownerDocument || n).createElement("style"), Pt(h), Ur(h, "style", y), tf(h, s.precedence, n), o.instance = h;
          case "stylesheet":
            y = jc(s.href);
            var C = n.querySelector(
              rh(y)
            );
            if (C)
              return o.state.loading |= Es, o.instance = C, Pt(C), C;
            h = Eg(s), (y = Ps.get(y)) && v2(h, y), C = (n.ownerDocument || n).createElement("link"), Pt(C);
            var A = C;
            return A._p = new Promise(function(z, q) {
              A.onload = z, A.onerror = q;
            }), Ur(C, "link", h), o.state.loading |= Es, tf(C, s.precedence, n), o.instance = C;
          case "script":
            return C = Ic(s.src), (y = n.querySelector(
              ah(C)
            )) ? (o.instance = y, Pt(y), y) : (h = s, (y = Ps.get(C)) && (h = Rn({}, s), b2(h, y)), n = n.ownerDocument || n, y = n.createElement("script"), Pt(y), Ur(y, "link", h), n.head.appendChild(y), o.instance = y);
          case "void":
            return null;
          default:
            throw Error(
              'acquireResource encountered a resource type it did not expect: "' + o.type + '". this is a bug in React.'
            );
        }
      else
        o.type === "stylesheet" && (o.state.loading & Es) === Lh && (h = o.instance, o.state.loading |= Es, tf(h, s.precedence, n));
      return o.instance;
    }
    function tf(n, o, s) {
      for (var h = s.querySelectorAll(
        'link[rel="stylesheet"][data-precedence],style[data-precedence]'
      ), y = h.length ? h[h.length - 1] : null, C = y, A = 0; A < h.length; A++) {
        var z = h[A];
        if (z.dataset.precedence === o) C = z;
        else if (C !== y) break;
      }
      C ? C.parentNode.insertBefore(n, C.nextSibling) : (o = s.nodeType === 9 ? s.head : s, o.insertBefore(n, o.firstChild));
    }
    function v2(n, o) {
      n.crossOrigin == null && (n.crossOrigin = o.crossOrigin), n.referrerPolicy == null && (n.referrerPolicy = o.referrerPolicy), n.title == null && (n.title = o.title);
    }
    function b2(n, o) {
      n.crossOrigin == null && (n.crossOrigin = o.crossOrigin), n.referrerPolicy == null && (n.referrerPolicy = o.referrerPolicy), n.integrity == null && (n.integrity = o.integrity);
    }
    function nf(n, o, s) {
      if (Lw === null) {
        var h = /* @__PURE__ */ new Map(), y = Lw = /* @__PURE__ */ new Map();
        y.set(s, h);
      } else
        y = Lw, h = y.get(s), h || (h = /* @__PURE__ */ new Map(), y.set(s, h));
      if (h.has(n)) return h;
      for (h.set(n, null), s = s.getElementsByTagName(n), y = 0; y < s.length; y++) {
        var C = s[y];
        if (!(C[pf] || C[Xr] || n === "link" && C.getAttribute("rel") === "stylesheet") && C.namespaceURI !== Pn) {
          var A = C.getAttribute(o) || "";
          A = n + A;
          var z = h.get(A);
          z ? z.push(C) : h.set(A, [C]);
        }
      }
      return h;
    }
    function Ay(n, o, s) {
      n = n.ownerDocument || n, n.head.insertBefore(
        s,
        o === "title" ? n.querySelector("head > title") : null
      );
    }
    function Ny(n, o, s) {
      var h = !s.ancestorInfo.containerTagInScope;
      if (s.context === y0 || o.itemProp != null)
        return !h || o.itemProp == null || n !== "meta" && n !== "title" && n !== "style" && n !== "link" && n !== "script" || console.error(
          "Cannot render a <%s> outside the main document if it has an `itemProp` prop. `itemProp` suggests the tag belongs to an `itemScope` which can appear anywhere in the DOM. If you were intending for React to hoist this <%s> remove the `itemProp` prop. Otherwise, try moving this tag into the <head> or <body> of the Document.",
          n,
          n
        ), !1;
      switch (n) {
        case "meta":
        case "title":
          return !0;
        case "style":
          if (typeof o.precedence != "string" || typeof o.href != "string" || o.href === "") {
            h && console.error(
              'Cannot render a <style> outside the main document without knowing its precedence and a unique href key. React can hoist and deduplicate <style> tags if you provide a `precedence` prop along with an `href` prop that does not conflict with the `href` values used in any other hoisted <style> or <link rel="stylesheet" ...> tags.  Note that hoisting <style> tags is considered an advanced feature that most will not use directly. Consider moving the <style> tag to the <head> or consider adding a `precedence="default"` and `href="some unique resource identifier"`.'
            );
            break;
          }
          return !0;
        case "link":
          if (typeof o.rel != "string" || typeof o.href != "string" || o.href === "" || o.onLoad || o.onError) {
            if (o.rel === "stylesheet" && typeof o.precedence == "string") {
              n = o.href;
              var y = o.onError, C = o.disabled;
              s = [], o.onLoad && s.push("`onLoad`"), y && s.push("`onError`"), C != null && s.push("`disabled`"), y = cy(s, "and"), y += s.length === 1 ? " prop" : " props", C = s.length === 1 ? "an " + y : "the " + y, s.length && console.error(
                'React encountered a <link rel="stylesheet" href="%s" ... /> with a `precedence` prop that also included %s. The presence of loading and error handlers indicates an intent to manage the stylesheet loading state from your from your Component code and React will not hoist or deduplicate this stylesheet. If your intent was to have React hoist and deduplciate this stylesheet using the `precedence` prop remove the %s, otherwise remove the `precedence` prop.',
                n,
                C,
                y
              );
            }
            h && (typeof o.rel != "string" || typeof o.href != "string" || o.href === "" ? console.error(
              "Cannot render a <link> outside the main document without a `rel` and `href` prop. Try adding a `rel` and/or `href` prop to this <link> or moving the link into the <head> tag"
            ) : (o.onError || o.onLoad) && console.error(
              "Cannot render a <link> with onLoad or onError listeners outside the main document. Try removing onLoad={...} and onError={...} or moving it into the root <head> tag or somewhere in the <body>."
            ));
            break;
          }
          switch (o.rel) {
            case "stylesheet":
              return n = o.precedence, o = o.disabled, typeof n != "string" && h && console.error(
                'Cannot render a <link rel="stylesheet" /> outside the main document without knowing its precedence. Consider adding precedence="default" or moving it into the root <head> tag.'
              ), typeof n == "string" && o == null;
            default:
              return !0;
          }
        case "script":
          if (n = o.async && typeof o.async != "function" && typeof o.async != "symbol", !n || o.onLoad || o.onError || !o.src || typeof o.src != "string") {
            h && (n ? o.onLoad || o.onError ? console.error(
              "Cannot render a <script> with onLoad or onError listeners outside the main document. Try removing onLoad={...} and onError={...} or moving it into the root <head> tag or somewhere in the <body>."
            ) : console.error(
              "Cannot render a <script> outside the main document without `async={true}` and a non-empty `src` prop. Ensure there is a valid `src` and either make the script async or move it into the root <head> tag or somewhere in the <body>."
            ) : console.error(
              'Cannot render a sync or defer <script> outside the main document without knowing its order. Try adding async="" or moving it into the root <head> tag.'
            ));
            break;
          }
          return !0;
        case "noscript":
        case "template":
          h && console.error(
            "Cannot render <%s> outside the main document. Try moving it into the root <head> tag.",
            n
          );
      }
      return !1;
    }
    function Vn(n) {
      return !(n.type === "stylesheet" && (n.state.loading & i5) === Lh);
    }
    function y2(n, o, s, h) {
      if (s.type === "stylesheet" && (typeof h.media != "string" || matchMedia(h.media).matches !== !1) && (s.state.loading & Es) === Lh) {
        if (s.instance === null) {
          var y = jc(h.href), C = o.querySelector(
            rh(y)
          );
          if (C) {
            o = C._p, o !== null && typeof o == "object" && typeof o.then == "function" && (n.count++, n = rf.bind(n), o.then(n, n)), s.state.loading |= Es, s.instance = C, Pt(C);
            return;
          }
          C = o.ownerDocument || o, h = Eg(h), (y = Ps.get(y)) && v2(h, y), C = C.createElement("link"), Pt(C);
          var A = C;
          A._p = new Promise(function(z, q) {
            A.onload = z, A.onerror = q;
          }), Ur(C, "link", h), s.instance = C;
        }
        n.stylesheets === null && (n.stylesheets = /* @__PURE__ */ new Map()), n.stylesheets.set(s, o), (o = s.state.preload) && (s.state.loading & i5) === Lh && (n.count++, s = rf.bind(n), o.addEventListener("load", s), o.addEventListener("error", s));
      }
    }
    function kg(n, o) {
      return n.stylesheets && n.count === 0 && oh(n, n.stylesheets), 0 < n.count || 0 < n.imgCount ? function(s) {
        var h = setTimeout(function() {
          if (n.stylesheets && oh(n, n.stylesheets), n.unsuspend) {
            var C = n.unsuspend;
            n.unsuspend = null, C();
          }
        }, MT + o);
        0 < n.imgBytes && A4 === 0 && (A4 = 125 * dy() * TT);
        var y = setTimeout(
          function() {
            if (n.waitingForImages = !1, n.count === 0 && (n.stylesheets && oh(n, n.stylesheets), n.unsuspend)) {
              var C = n.unsuspend;
              n.unsuspend = null, C();
            }
          },
          (n.imgBytes > A4 ? 50 : OT) + o
        );
        return n.unsuspend = s, function() {
          n.unsuspend = null, clearTimeout(h), clearTimeout(y);
        };
      } : null;
    }
    function rf() {
      if (this.count--, this.count === 0 && (this.imgCount === 0 || !this.waitingForImages)) {
        if (this.stylesheets)
          oh(this, this.stylesheets);
        else if (this.unsuspend) {
          var n = this.unsuspend;
          this.unsuspend = null, n();
        }
      }
    }
    function oh(n, o) {
      n.stylesheets = null, n.unsuspend !== null && (n.count++, Hw = /* @__PURE__ */ new Map(), o.forEach(w2, n), Hw = null, rf.call(n));
    }
    function w2(n, o) {
      if (!(o.state.loading & Es)) {
        var s = Hw.get(n);
        if (s) var h = s.get(N4);
        else {
          s = /* @__PURE__ */ new Map(), Hw.set(n, s);
          for (var y = n.querySelectorAll(
            "link[data-precedence],style[data-precedence]"
          ), C = 0; C < y.length; C++) {
            var A = y[C];
            (A.nodeName === "LINK" || A.getAttribute("media") !== "not all") && (s.set(A.dataset.precedence, A), h = A);
          }
          h && s.set(N4, h);
        }
        y = o.instance, A = y.getAttribute("data-precedence"), C = s.get(A) || h, C === h && s.set(N4, y), s.set(A, y), this.count++, h = rf.bind(this), y.addEventListener("load", h), y.addEventListener("error", h), C ? C.parentNode.insertBefore(y, C.nextSibling) : (n = n.nodeType === 9 ? n.head : n, n.insertBefore(y, n.firstChild)), o.state.loading |= Es;
      }
    }
    function ih(n, o, s, h, y, C, A, z, q) {
      for (this.tag = 1, this.containerInfo = n, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = Ih, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = St(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = St(0), this.hiddenUpdates = St(null), this.identifierPrefix = h, this.onUncaughtError = y, this.onCaughtError = C, this.onRecoverableError = A, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = q, this.incompleteTransitions = /* @__PURE__ */ new Map(), this.passiveEffectDuration = this.effectDuration = -0, this.memoizedUpdaters = /* @__PURE__ */ new Set(), n = this.pendingUpdatersLaneMap = [], o = 0; 31 > o; o++) n.push(/* @__PURE__ */ new Set());
      this._debugRootType = s ? "hydrateRoot()" : "createRoot()";
    }
    function lh(n, o, s, h, y, C, A, z, q, Z, xe, ke) {
      return n = new ih(
        n,
        o,
        s,
        A,
        q,
        Z,
        xe,
        ke,
        z
      ), o = JO, C === !0 && (o |= ii | Qs), o |= An, C = x(3, null, null, o), n.current = C, C.stateNode = n, o = Pp(), fc(o), n.pooledCache = o, fc(o), C.memoizedState = {
        element: h,
        isDehydrated: s,
        cache: o
      }, _n(C), n;
    }
    function Dy(n) {
      return n ? (n = Sf, n) : Sf;
    }
    function Mg(n, o, s, h, y, C) {
      if (Ia && typeof Ia.onScheduleFiberRoot == "function")
        try {
          Ia.onScheduleFiberRoot(Vc, h, s);
        } catch (A) {
          fs || (fs = !0, console.error(
            "React instrumentation encountered an error: %o",
            A
          ));
        }
      y = Dy(y), h.context === null ? h.context = y : h.pendingContext = y, ds && oi !== null && !d5 && (d5 = !0, console.error(
        `Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`,
        W(oi) || "Unknown"
      )), h = $a(o), h.payload = { element: s }, C = C === void 0 ? null : C, C !== null && (typeof C != "function" && console.error(
        "Expected the last optional `callback` argument to be a function. Instead received: %s.",
        C
      ), h.callback = C), s = Gl(n, h, o), s !== null && (Bl(o, "root.render()", null), ln(s, n, o), Ji(s, n, o));
    }
    function $y(n, o) {
      if (n = n.memoizedState, n !== null && n.dehydrated !== null) {
        var s = n.retryLane;
        n.retryLane = s !== 0 && s < o ? s : o;
      }
    }
    function S2(n, o) {
      $y(n, o), (n = n.alternate) && $y(n, o);
    }
    function C2(n) {
      if (n.tag === 13 || n.tag === 31) {
        var o = So(n, 67108864);
        o !== null && ln(o, n, 67108864), S2(n, 67108864);
      }
    }
    function x2(n) {
      if (n.tag === 13 || n.tag === 31) {
        var o = xo(n);
        o = Ct(o);
        var s = So(n, o);
        s !== null && ln(s, n, o), S2(n, o);
      }
    }
    function Mr() {
      return oi;
    }
    function E2(n, o, s, h) {
      var y = Xe.T;
      Xe.T = null;
      var C = fr.p;
      try {
        fr.p = La, P2(n, o, s, h);
      } finally {
        fr.p = C, Xe.T = y;
      }
    }
    function co(n, o, s, h) {
      var y = Xe.T;
      Xe.T = null;
      var C = fr.p;
      try {
        fr.p = mo, P2(n, o, s, h);
      } finally {
        fr.p = C, Xe.T = y;
      }
    }
    function P2(n, o, s, h) {
      if (Ww) {
        var y = Og(h);
        if (y === null)
          Ol(
            n,
            o,
            h,
            Vw,
            s
          ), Rg(n, h);
        else if (zy(
          y,
          n,
          o,
          s,
          h
        ))
          h.stopPropagation();
        else if (Rg(n, h), o & 4 && -1 < AT.indexOf(n)) {
          for (; y !== null; ) {
            var C = bt(y);
            if (C !== null)
              switch (C.tag) {
                case 3:
                  if (C = C.stateNode, C.current.memoizedState.isDehydrated) {
                    var A = je(C.pendingLanes);
                    if (A !== 0) {
                      var z = C;
                      for (z.pendingLanes |= 2, z.entangledLanes |= 2; A; ) {
                        var q = 1 << 31 - fo(A);
                        z.entanglements[1] |= q, A &= ~q;
                      }
                      ti(C), (ar & (po | Ll)) === Oo && (Ew = Ka() + H8, is(0));
                    }
                  }
                  break;
                case 31:
                case 13:
                  z = So(C, 2), z !== null && ln(z, C, 2), ki(), S2(C, 2);
              }
            if (C = Og(h), C === null && Ol(
              n,
              o,
              h,
              Vw,
              s
            ), C === y) break;
            y = C;
          }
          y !== null && h.stopPropagation();
        } else
          Ol(
            n,
            o,
            h,
            null,
            s
          );
      }
    }
    function Og(n) {
      return n = Va(n), k2(n);
    }
    function k2(n) {
      if (Vw = null, n = pt(n), n !== null) {
        var o = T(n);
        if (o === null) n = null;
        else {
          var s = o.tag;
          if (s === 13) {
            if (n = N(o), n !== null) return n;
            n = null;
          } else if (s === 31) {
            if (n = D(o), n !== null) return n;
            n = null;
          } else if (s === 3) {
            if (o.stateNode.current.memoizedState.isDehydrated)
              return o.tag === 3 ? o.stateNode.containerInfo : null;
            n = null;
          } else o !== n && (n = null);
        }
      }
      return Vw = n, null;
    }
    function Tg(n) {
      switch (n) {
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return La;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return mo;
        case "message":
          switch (mh()) {
            case j2:
              return La;
            case Hg:
              return mo;
            case Wc:
            case Wy:
              return Po;
            case Fg:
              return Wu;
            default:
              return Po;
          }
        default:
          return Po;
      }
    }
    function Rg(n, o) {
      switch (n) {
        case "focusin":
        case "focusout":
          If = null;
          break;
        case "dragenter":
        case "dragleave":
          Lf = null;
          break;
        case "mouseover":
        case "mouseout":
          Hf = null;
          break;
        case "pointerover":
        case "pointerout":
          R1.delete(o.pointerId);
          break;
        case "gotpointercapture":
        case "lostpointercapture":
          A1.delete(o.pointerId);
      }
    }
    function Iu(n, o, s, h, y, C) {
      return n === null || n.nativeEvent !== C ? (n = {
        blockedOn: o,
        domEventName: s,
        eventSystemFlags: h,
        nativeEvent: C,
        targetContainers: [y]
      }, o !== null && (o = bt(o), o !== null && C2(o)), n) : (n.eventSystemFlags |= h, o = n.targetContainers, y !== null && o.indexOf(y) === -1 && o.push(y), n);
    }
    function zy(n, o, s, h, y) {
      switch (o) {
        case "focusin":
          return If = Iu(
            If,
            n,
            o,
            s,
            h,
            y
          ), !0;
        case "dragenter":
          return Lf = Iu(
            Lf,
            n,
            o,
            s,
            h,
            y
          ), !0;
        case "mouseover":
          return Hf = Iu(
            Hf,
            n,
            o,
            s,
            h,
            y
          ), !0;
        case "pointerover":
          var C = y.pointerId;
          return R1.set(
            C,
            Iu(
              R1.get(C) || null,
              n,
              o,
              s,
              h,
              y
            )
          ), !0;
        case "gotpointercapture":
          return C = y.pointerId, A1.set(
            C,
            Iu(
              A1.get(C) || null,
              n,
              o,
              s,
              h,
              y
            )
          ), !0;
      }
      return !1;
    }
    function M2(n) {
      var o = pt(n.target);
      if (o !== null) {
        var s = T(o);
        if (s !== null) {
          if (o = s.tag, o === 13) {
            if (o = N(s), o !== null) {
              n.blockedOn = o, ft(n.priority, function() {
                x2(s);
              });
              return;
            }
          } else if (o === 31) {
            if (o = D(s), o !== null) {
              n.blockedOn = o, ft(n.priority, function() {
                x2(s);
              });
              return;
            }
          } else if (o === 3 && s.stateNode.current.memoizedState.isDehydrated) {
            n.blockedOn = s.tag === 3 ? s.stateNode.containerInfo : null;
            return;
          }
        }
      }
      n.blockedOn = null;
    }
    function af(n) {
      if (n.blockedOn !== null) return !1;
      for (var o = n.targetContainers; 0 < o.length; ) {
        var s = Og(n.nativeEvent);
        if (s === null) {
          s = n.nativeEvent;
          var h = new s.constructor(
            s.type,
            s
          ), y = h;
          W2 !== null && console.error(
            "Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."
          ), W2 = y, s.target.dispatchEvent(h), W2 === null && console.error(
            "Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."
          ), W2 = null;
        } else
          return o = bt(s), o !== null && C2(o), n.blockedOn = s, !1;
        o.shift();
      }
      return !0;
    }
    function Ag(n, o, s) {
      af(n) && s.delete(o);
    }
    function yC() {
      D4 = !1, If !== null && af(If) && (If = null), Lf !== null && af(Lf) && (Lf = null), Hf !== null && af(Hf) && (Hf = null), R1.forEach(Ag), A1.forEach(Ag);
    }
    function sh(n, o) {
      n.blockedOn === o && (n.blockedOn = null, D4 || (D4 = !0, Sa.unstable_scheduleCallback(
        Sa.unstable_NormalPriority,
        yC
      )));
    }
    function jy(n) {
      _w !== n && (_w = n, Sa.unstable_scheduleCallback(
        Sa.unstable_NormalPriority,
        function() {
          _w === n && (_w = null);
          for (var o = 0; o < n.length; o += 3) {
            var s = n[o], h = n[o + 1], y = n[o + 2];
            if (typeof h != "function") {
              if (k2(h || s) === null)
                continue;
              break;
            }
            var C = bt(s);
            C !== null && (n.splice(o, 3), o -= 3, s = {
              pending: !0,
              data: y,
              method: s.method,
              action: h
            }, Object.freeze(s), Fs(
              C,
              s,
              h,
              y
            ));
          }
        }
      ));
    }
    function Lc(n) {
      function o(q) {
        return sh(q, n);
      }
      If !== null && sh(If, n), Lf !== null && sh(Lf, n), Hf !== null && sh(Hf, n), R1.forEach(o), A1.forEach(o);
      for (var s = 0; s < Ff.length; s++) {
        var h = Ff[s];
        h.blockedOn === n && (h.blockedOn = null);
      }
      for (; 0 < Ff.length && (s = Ff[0], s.blockedOn === null); )
        M2(s), s.blockedOn === null && Ff.shift();
      if (s = (n.ownerDocument || n).$$reactFormReplay, s != null)
        for (h = 0; h < s.length; h += 3) {
          var y = s[h], C = s[h + 1], A = y[qo] || null;
          if (typeof C == "function")
            A || jy(s);
          else if (A) {
            var z = null;
            if (C && C.hasAttribute("formAction")) {
              if (y = C, A = C[qo] || null)
                z = A.formAction;
              else if (k2(y) !== null) continue;
            } else z = A.action;
            typeof z == "function" ? s[h + 1] = z : (s.splice(h, 3), h -= 3), jy(s);
          }
        }
    }
    function Iy() {
      function n(C) {
        C.canIntercept && C.info === "react-transition" && C.intercept({
          handler: function() {
            return new Promise(function(A) {
              return y = A;
            });
          },
          focusReset: "manual",
          scroll: "manual"
        });
      }
      function o() {
        y !== null && (y(), y = null), h || setTimeout(s, 20);
      }
      function s() {
        if (!h && !navigation.transition) {
          var C = navigation.currentEntry;
          C && C.url != null && navigation.navigate(C.url, {
            state: C.getState(),
            info: "react-transition",
            history: "replace"
          });
        }
      }
      if (typeof navigation == "object") {
        var h = !1, y = null;
        return navigation.addEventListener("navigate", n), navigation.addEventListener("navigatesuccess", o), navigation.addEventListener("navigateerror", o), setTimeout(s, 100), function() {
          h = !0, navigation.removeEventListener("navigate", n), navigation.removeEventListener(
            "navigatesuccess",
            o
          ), navigation.removeEventListener(
            "navigateerror",
            o
          ), y !== null && (y(), y = null);
        };
      }
    }
    function O2(n) {
      this._internalRoot = n;
    }
    function Al(n) {
      this._internalRoot = n;
    }
    function T2(n) {
      n[Ys] && (n._reactRootContainer ? console.error(
        "You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported."
      ) : console.error(
        "You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."
      ));
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var Sa = ete(), uh = Re, wC = hb, Rn = Object.assign, Ly = Symbol.for("react.element"), nl = Symbol.for("react.transitional.element"), Lu = Symbol.for("react.portal"), of = Symbol.for("react.fragment"), Go = Symbol.for("react.strict_mode"), ch = Symbol.for("react.profiler"), Ng = Symbol.for("react.consumer"), Nl = Symbol.for("react.context"), lf = Symbol.for("react.forward_ref"), Hc = Symbol.for("react.suspense"), ai = Symbol.for("react.suspense_list"), dh = Symbol.for("react.memo"), Eo = Symbol.for("react.lazy"), Dl = Symbol.for("react.activity"), SC = Symbol.for("react.memo_cache_sentinel"), Hy = Symbol.iterator, sf = Symbol.for("react.client.reference"), Ta = Array.isArray, Xe = uh.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, fr = wC.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, CC = Object.freeze({
      pending: !1,
      data: null,
      method: null,
      action: null
    }), R2 = [], A2 = [], Ks = -1, Hu = Q(null), uf = Q(null), Oi = Q(null), Fu = Q(null), cf = 0, Fy, Fc, df, N2, fh, Dg, $g;
    ie.__reactDisabledLog = !0;
    var ff, D2, zg = !1, $2 = new (typeof WeakMap == "function" ? WeakMap : Map)(), oi = null, ds = !1, Ti = Object.prototype.hasOwnProperty, z2 = Sa.unstable_scheduleCallback, jg = Sa.unstable_cancelCallback, Ig = Sa.unstable_shouldYield, Lg = Sa.unstable_requestPaint, Ka = Sa.unstable_now, mh = Sa.unstable_getCurrentPriorityLevel, j2 = Sa.unstable_ImmediatePriority, Hg = Sa.unstable_UserBlockingPriority, Wc = Sa.unstable_NormalPriority, Wy = Sa.unstable_LowPriority, Fg = Sa.unstable_IdlePriority, I2 = Sa.log, Vy = Sa.unstable_setDisableYieldValue, Vc = null, Ia = null, fs = !1, ms = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u", fo = Math.clz32 ? Math.clz32 : ye, L2 = Math.log, Wg = Math.LN2, mf = 256, hh = 262144, hf = 4194304, La = 2, mo = 8, Po = 32, Wu = 268435456, rl = Math.random().toString(36).slice(2), Xr = "__reactFiber$" + rl, qo = "__reactProps$" + rl, Ys = "__reactContainer$" + rl, _c = "__reactEvents$" + rl, xC = "__reactListeners$" + rl, _y = "__reactHandles$" + rl, ph = "__reactResources$" + rl, pf = "__reactMarker$" + rl, By = /* @__PURE__ */ new Set(), hs = {}, gf = {}, Uy = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    }, vf = RegExp(
      "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), H2 = {}, Vg = {}, _g = /[\n"\\]/g, F2 = !1, Xy = !1, gh = !1, l = !1, u = !1, m = !1, v = ["value", "defaultValue"], O = !1, R = /["'&<>\n\t]|^\s|\s$/, B = "address applet area article aside base basefont bgsound blockquote body br button caption center col colgroup dd details dir div dl dt embed fieldset figcaption figure footer form frame frameset h1 h2 h3 h4 h5 h6 head header hgroup hr html iframe img input isindex li link listing main marquee menu menuitem meta nav noembed noframes noscript object ol p param plaintext pre script section select source style summary table tbody td template textarea tfoot th thead title tr track ul wbr xmp".split(
      " "
    ), re = "applet caption html table td th marquee object template foreignObject desc title".split(
      " "
    ), ve = re.concat(["button"]), He = "dd dt li option optgroup p rp rt".split(" "), Je = {
      current: null,
      formTag: null,
      aTagInScope: null,
      buttonTagInScope: null,
      nobrTagInScope: null,
      pTagInButtonScope: null,
      listItemTagAutoclosing: null,
      dlItemTagAutoclosing: null,
      containerTagInScope: null,
      implicitRootScope: !1
    }, nt = {}, We = {
      animation: "animationDelay animationDirection animationDuration animationFillMode animationIterationCount animationName animationPlayState animationTimingFunction".split(
        " "
      ),
      background: "backgroundAttachment backgroundClip backgroundColor backgroundImage backgroundOrigin backgroundPositionX backgroundPositionY backgroundRepeat backgroundSize".split(
        " "
      ),
      backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
      border: "borderBottomColor borderBottomStyle borderBottomWidth borderImageOutset borderImageRepeat borderImageSlice borderImageSource borderImageWidth borderLeftColor borderLeftStyle borderLeftWidth borderRightColor borderRightStyle borderRightWidth borderTopColor borderTopStyle borderTopWidth".split(
        " "
      ),
      borderBlockEnd: [
        "borderBlockEndColor",
        "borderBlockEndStyle",
        "borderBlockEndWidth"
      ],
      borderBlockStart: [
        "borderBlockStartColor",
        "borderBlockStartStyle",
        "borderBlockStartWidth"
      ],
      borderBottom: [
        "borderBottomColor",
        "borderBottomStyle",
        "borderBottomWidth"
      ],
      borderColor: [
        "borderBottomColor",
        "borderLeftColor",
        "borderRightColor",
        "borderTopColor"
      ],
      borderImage: [
        "borderImageOutset",
        "borderImageRepeat",
        "borderImageSlice",
        "borderImageSource",
        "borderImageWidth"
      ],
      borderInlineEnd: [
        "borderInlineEndColor",
        "borderInlineEndStyle",
        "borderInlineEndWidth"
      ],
      borderInlineStart: [
        "borderInlineStartColor",
        "borderInlineStartStyle",
        "borderInlineStartWidth"
      ],
      borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
      borderRadius: [
        "borderBottomLeftRadius",
        "borderBottomRightRadius",
        "borderTopLeftRadius",
        "borderTopRightRadius"
      ],
      borderRight: [
        "borderRightColor",
        "borderRightStyle",
        "borderRightWidth"
      ],
      borderStyle: [
        "borderBottomStyle",
        "borderLeftStyle",
        "borderRightStyle",
        "borderTopStyle"
      ],
      borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderWidth: [
        "borderBottomWidth",
        "borderLeftWidth",
        "borderRightWidth",
        "borderTopWidth"
      ],
      columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
      columns: ["columnCount", "columnWidth"],
      flex: ["flexBasis", "flexGrow", "flexShrink"],
      flexFlow: ["flexDirection", "flexWrap"],
      font: "fontFamily fontFeatureSettings fontKerning fontLanguageOverride fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontVariantAlternates fontVariantCaps fontVariantEastAsian fontVariantLigatures fontVariantNumeric fontVariantPosition fontWeight lineHeight".split(
        " "
      ),
      fontVariant: "fontVariantAlternates fontVariantCaps fontVariantEastAsian fontVariantLigatures fontVariantNumeric fontVariantPosition".split(
        " "
      ),
      gap: ["columnGap", "rowGap"],
      grid: "gridAutoColumns gridAutoFlow gridAutoRows gridTemplateAreas gridTemplateColumns gridTemplateRows".split(
        " "
      ),
      gridArea: [
        "gridColumnEnd",
        "gridColumnStart",
        "gridRowEnd",
        "gridRowStart"
      ],
      gridColumn: ["gridColumnEnd", "gridColumnStart"],
      gridColumnGap: ["columnGap"],
      gridGap: ["columnGap", "rowGap"],
      gridRow: ["gridRowEnd", "gridRowStart"],
      gridRowGap: ["rowGap"],
      gridTemplate: [
        "gridTemplateAreas",
        "gridTemplateColumns",
        "gridTemplateRows"
      ],
      listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
      margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
      marker: ["markerEnd", "markerMid", "markerStart"],
      mask: "maskClip maskComposite maskImage maskMode maskOrigin maskPositionX maskPositionY maskRepeat maskSize".split(
        " "
      ),
      maskPosition: ["maskPositionX", "maskPositionY"],
      outline: ["outlineColor", "outlineStyle", "outlineWidth"],
      overflow: ["overflowX", "overflowY"],
      padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
      placeContent: ["alignContent", "justifyContent"],
      placeItems: ["alignItems", "justifyItems"],
      placeSelf: ["alignSelf", "justifySelf"],
      textDecoration: [
        "textDecorationColor",
        "textDecorationLine",
        "textDecorationStyle"
      ],
      textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
      transition: [
        "transitionDelay",
        "transitionDuration",
        "transitionProperty",
        "transitionTimingFunction"
      ],
      wordWrap: ["overflowWrap"]
    }, Ge = /([A-Z])/g, At = /^ms-/, Zt = /^(?:webkit|moz|o)[A-Z]/, Or = /^-ms-/, $e = /-(.)/g, Pe = /;\s*$/, Ie = {}, et = {}, Vt = !1, rr = !1, jt = new Set(
      "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
        " "
      )
    ), vn = "http://www.w3.org/1998/Math/MathML", Pn = "http://www.w3.org/2000/svg", lr = /* @__PURE__ */ new Map([
      ["acceptCharset", "accept-charset"],
      ["htmlFor", "for"],
      ["httpEquiv", "http-equiv"],
      ["crossOrigin", "crossorigin"],
      ["accentHeight", "accent-height"],
      ["alignmentBaseline", "alignment-baseline"],
      ["arabicForm", "arabic-form"],
      ["baselineShift", "baseline-shift"],
      ["capHeight", "cap-height"],
      ["clipPath", "clip-path"],
      ["clipRule", "clip-rule"],
      ["colorInterpolation", "color-interpolation"],
      ["colorInterpolationFilters", "color-interpolation-filters"],
      ["colorProfile", "color-profile"],
      ["colorRendering", "color-rendering"],
      ["dominantBaseline", "dominant-baseline"],
      ["enableBackground", "enable-background"],
      ["fillOpacity", "fill-opacity"],
      ["fillRule", "fill-rule"],
      ["floodColor", "flood-color"],
      ["floodOpacity", "flood-opacity"],
      ["fontFamily", "font-family"],
      ["fontSize", "font-size"],
      ["fontSizeAdjust", "font-size-adjust"],
      ["fontStretch", "font-stretch"],
      ["fontStyle", "font-style"],
      ["fontVariant", "font-variant"],
      ["fontWeight", "font-weight"],
      ["glyphName", "glyph-name"],
      ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
      ["glyphOrientationVertical", "glyph-orientation-vertical"],
      ["horizAdvX", "horiz-adv-x"],
      ["horizOriginX", "horiz-origin-x"],
      ["imageRendering", "image-rendering"],
      ["letterSpacing", "letter-spacing"],
      ["lightingColor", "lighting-color"],
      ["markerEnd", "marker-end"],
      ["markerMid", "marker-mid"],
      ["markerStart", "marker-start"],
      ["overlinePosition", "overline-position"],
      ["overlineThickness", "overline-thickness"],
      ["paintOrder", "paint-order"],
      ["panose-1", "panose-1"],
      ["pointerEvents", "pointer-events"],
      ["renderingIntent", "rendering-intent"],
      ["shapeRendering", "shape-rendering"],
      ["stopColor", "stop-color"],
      ["stopOpacity", "stop-opacity"],
      ["strikethroughPosition", "strikethrough-position"],
      ["strikethroughThickness", "strikethrough-thickness"],
      ["strokeDasharray", "stroke-dasharray"],
      ["strokeDashoffset", "stroke-dashoffset"],
      ["strokeLinecap", "stroke-linecap"],
      ["strokeLinejoin", "stroke-linejoin"],
      ["strokeMiterlimit", "stroke-miterlimit"],
      ["strokeOpacity", "stroke-opacity"],
      ["strokeWidth", "stroke-width"],
      ["textAnchor", "text-anchor"],
      ["textDecoration", "text-decoration"],
      ["textRendering", "text-rendering"],
      ["transformOrigin", "transform-origin"],
      ["underlinePosition", "underline-position"],
      ["underlineThickness", "underline-thickness"],
      ["unicodeBidi", "unicode-bidi"],
      ["unicodeRange", "unicode-range"],
      ["unitsPerEm", "units-per-em"],
      ["vAlphabetic", "v-alphabetic"],
      ["vHanging", "v-hanging"],
      ["vIdeographic", "v-ideographic"],
      ["vMathematical", "v-mathematical"],
      ["vectorEffect", "vector-effect"],
      ["vertAdvY", "vert-adv-y"],
      ["vertOriginX", "vert-origin-x"],
      ["vertOriginY", "vert-origin-y"],
      ["wordSpacing", "word-spacing"],
      ["writingMode", "writing-mode"],
      ["xmlnsXlink", "xmlns:xlink"],
      ["xHeight", "x-height"]
    ]), $l = {
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      fetchpriority: "fetchPriority",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      inert: "inert",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      popover: "popover",
      popovertarget: "popoverTarget",
      popovertargetaction: "popoverTargetAction",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      transformorigin: "transformOrigin",
      "transform-origin": "transformOrigin",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, Gy = {
      "aria-current": 0,
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      "aria-hidden": 0,
      "aria-invalid": 0,
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0,
      "aria-braillelabel": 0,
      "aria-brailleroledescription": 0,
      "aria-colindextext": 0,
      "aria-rowindextext": 0
    }, Bg = {}, cO = RegExp(
      "^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), dO = RegExp(
      "^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), h6 = !1, Ri = {}, p6 = /^on./, fO = /^on[^A-Z]/, mO = RegExp(
      "^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), hO = RegExp(
      "^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), pO = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i, W2 = null, Ug = null, Xg = null, EC = !1, Vu = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), PC = !1;
    if (Vu)
      try {
        var V2 = {};
        Object.defineProperty(V2, "passive", {
          get: function() {
            PC = !0;
          }
        }), window.addEventListener("test", V2, V2), window.removeEventListener("test", V2, V2);
      } catch {
        PC = !1;
      }
    var bf = null, kC = null, qy = null, vh = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function(n) {
        return n.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    }, Ky = Jt(vh), _2 = Rn({}, vh, { view: 0, detail: 0 }), gO = Jt(_2), MC, OC, B2, Yy = Rn({}, _2, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: ao,
      button: 0,
      buttons: 0,
      relatedTarget: function(n) {
        return n.relatedTarget === void 0 ? n.fromElement === n.srcElement ? n.toElement : n.fromElement : n.relatedTarget;
      },
      movementX: function(n) {
        return "movementX" in n ? n.movementX : (n !== B2 && (B2 && n.type === "mousemove" ? (MC = n.screenX - B2.screenX, OC = n.screenY - B2.screenY) : OC = MC = 0, B2 = n), MC);
      },
      movementY: function(n) {
        return "movementY" in n ? n.movementY : OC;
      }
    }), g6 = Jt(Yy), vO = Rn({}, Yy, { dataTransfer: 0 }), bO = Jt(vO), yO = Rn({}, _2, { relatedTarget: 0 }), TC = Jt(yO), wO = Rn({}, vh, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), SO = Jt(wO), CO = Rn({}, vh, {
      clipboardData: function(n) {
        return "clipboardData" in n ? n.clipboardData : window.clipboardData;
      }
    }), xO = Jt(CO), EO = Rn({}, vh, { data: 0 }), v6 = Jt(
      EO
    ), PO = v6, kO = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, MO = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    }, OO = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    }, TO = Rn({}, _2, {
      key: function(n) {
        if (n.key) {
          var o = kO[n.key] || n.key;
          if (o !== "Unidentified") return o;
        }
        return n.type === "keypress" ? (n = rc(n), n === 13 ? "Enter" : String.fromCharCode(n)) : n.type === "keydown" || n.type === "keyup" ? MO[n.keyCode] || "Unidentified" : "";
      },
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: ao,
      charCode: function(n) {
        return n.type === "keypress" ? rc(n) : 0;
      },
      keyCode: function(n) {
        return n.type === "keydown" || n.type === "keyup" ? n.keyCode : 0;
      },
      which: function(n) {
        return n.type === "keypress" ? rc(n) : n.type === "keydown" || n.type === "keyup" ? n.keyCode : 0;
      }
    }), RO = Jt(TO), AO = Rn({}, Yy, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }), b6 = Jt(AO), NO = Rn({}, _2, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: ao
    }), DO = Jt(NO), $O = Rn({}, vh, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), zO = Jt($O), jO = Rn({}, Yy, {
      deltaX: function(n) {
        return "deltaX" in n ? n.deltaX : "wheelDeltaX" in n ? -n.wheelDeltaX : 0;
      },
      deltaY: function(n) {
        return "deltaY" in n ? n.deltaY : "wheelDeltaY" in n ? -n.wheelDeltaY : "wheelDelta" in n ? -n.wheelDelta : 0;
      },
      deltaZ: 0,
      deltaMode: 0
    }), IO = Jt(jO), LO = Rn({}, vh, {
      newState: 0,
      oldState: 0
    }), HO = Jt(LO), FO = [9, 13, 27, 32], y6 = 229, RC = Vu && "CompositionEvent" in window, U2 = null;
    Vu && "documentMode" in document && (U2 = document.documentMode);
    var WO = Vu && "TextEvent" in window && !U2, w6 = Vu && (!RC || U2 && 8 < U2 && 11 >= U2), S6 = 32, C6 = String.fromCharCode(S6), x6 = !1, Gg = !1, VO = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    }, X2 = null, G2 = null, E6 = !1;
    Vu && (E6 = cd("input") && (!document.documentMode || 9 < document.documentMode));
    var Ai = typeof Object.is == "function" ? Object.is : pp, _O = Vu && "documentMode" in document && 11 >= document.documentMode, qg = null, AC = null, q2 = null, NC = !1, Kg = {
      animationend: ac("Animation", "AnimationEnd"),
      animationiteration: ac("Animation", "AnimationIteration"),
      animationstart: ac("Animation", "AnimationStart"),
      transitionrun: ac("Transition", "TransitionRun"),
      transitionstart: ac("Transition", "TransitionStart"),
      transitioncancel: ac("Transition", "TransitionCancel"),
      transitionend: ac("Transition", "TransitionEnd")
    }, DC = {}, P6 = {};
    Vu && (P6 = document.createElement("div").style, "AnimationEvent" in window || (delete Kg.animationend.animation, delete Kg.animationiteration.animation, delete Kg.animationstart.animation), "TransitionEvent" in window || delete Kg.transitionend.transition);
    var k6 = oc("animationend"), M6 = oc("animationiteration"), O6 = oc("animationstart"), BO = oc("transitionrun"), UO = oc("transitionstart"), XO = oc("transitioncancel"), T6 = oc("transitionend"), R6 = /* @__PURE__ */ new Map(), $C = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
      " "
    );
    $C.push("scrollEnd");
    var A6 = 0;
    if (typeof performance == "object" && typeof performance.now == "function")
      var GO = performance, N6 = function() {
        return GO.now();
      };
    else {
      var qO = Date;
      N6 = function() {
        return qO.now();
      };
    }
    var zC = typeof reportError == "function" ? reportError : function(n) {
      if (typeof window == "object" && typeof window.ErrorEvent == "function") {
        var o = new window.ErrorEvent("error", {
          bubbles: !0,
          cancelable: !0,
          message: typeof n == "object" && n !== null && typeof n.message == "string" ? String(n.message) : String(n),
          error: n
        });
        if (!window.dispatchEvent(o)) return;
      } else if (typeof process == "object" && typeof process.emit == "function") {
        process.emit("uncaughtException", n);
        return;
      }
      console.error(n);
    }, KO = "This object has been omitted by React in the console log to avoid sending too much data from the server. Try logging smaller or more specific objects.", Qy = 0, jC = 1, IC = 2, LC = 3, Jy = "– ", Zy = "+ ", D6 = "  ", Gr = typeof console < "u" && typeof console.timeStamp == "function" && typeof performance < "u" && typeof performance.measure == "function", ps = "Components ⚛", Kn = "Scheduler ⚛", Zn = "Blocking", yf = !1, Bc = {
      color: "primary",
      properties: null,
      tooltipText: "",
      track: ps
    }, wf = {
      start: -0,
      end: -0,
      detail: { devtools: Bc }
    }, YO = ["Changed Props", ""], $6 = "This component received deeply equal props. It might benefit from useMemo or the React Compiler in its owner.", QO = ["Changed Props", $6], K2 = 1, Uc = 2, gs = [], Yg = 0, HC = 0, Sf = {};
    Object.freeze(Sf);
    var vs = null, Qg = null, on = 0, JO = 1, An = 2, ii = 8, Qs = 16, ZO = 32, z6 = !1;
    try {
      var eT = Object.preventExtensions({});
    } catch {
      z6 = !0;
    }
    var FC = /* @__PURE__ */ new WeakMap(), Jg = [], Zg = 0, ew = null, Y2 = 0, bs = [], ys = 0, bh = null, Xc = 1, Gc = "", Ko = null, qr = null, Xn = !1, _u = !1, zl = null, Cf = null, ws = !1, WC = Error(
      "Hydration Mismatch Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."
    ), VC = Q(null), _C = Q(null), j6 = {}, tw = null, e0 = null, t0 = !1, tT = typeof AbortController < "u" ? AbortController : function() {
      var n = [], o = this.signal = {
        aborted: !1,
        addEventListener: function(s, h) {
          n.push(h);
        }
      };
      this.abort = function() {
        o.aborted = !0, n.forEach(function(s) {
          return s();
        });
      };
    }, nT = Sa.unstable_scheduleCallback, rT = Sa.unstable_NormalPriority, Ya = {
      $$typeof: Nl,
      Consumer: null,
      Provider: null,
      _currentValue: null,
      _currentValue2: null,
      _threadCount: 0,
      _currentRenderer: null,
      _currentRenderer2: null
    }, Qa = Sa.unstable_now, nw = console.createTask ? console.createTask : function() {
      return null;
    }, Q2 = 1, rw = 2, ko = -0, xf = -0, qc = -0, Kc = null, Ni = -1.1, yh = -0, ma = -0, Bt = -1.1, tn = -1.1, na = null, Ca = !1, wh = -0, Bu = -1.1, J2 = null, Ef = 0, BC = null, UC = null, Sh = -1.1, Z2 = null, n0 = -1.1, aw = -1.1, Yc = -0, Qc = -1.1, Ss = -1.1, XC = 0, e1 = null, I6 = null, L6 = null, Pf = -1.1, Ch = null, kf = -1.1, ow = -1.1, H6 = -0, F6 = -0, iw = 0, aT = null, W6 = 0, t1 = -1.1, lw = !1, sw = !1, n1 = null, GC = 0, xh = 0, r0 = null, V6 = Xe.S;
    Xe.S = function(n, o) {
      if (I8 = Ka(), typeof o == "object" && o !== null && typeof o.then == "function") {
        if (0 > Qc && 0 > Ss) {
          Qc = Qa();
          var s = Jd(), h = us();
          (s !== kf || h !== Ch) && (kf = -1.1), Pf = s, Ch = h;
        }
        Ds(n, o);
      }
      V6 !== null && V6(n, o);
    };
    var Eh = Q(null), Js = {
      recordUnsafeLifecycleWarnings: function() {
      },
      flushPendingUnsafeLifecycleWarnings: function() {
      },
      recordLegacyContextWarning: function() {
      },
      flushLegacyContextWarning: function() {
      },
      discardPendingWarnings: function() {
      }
    }, r1 = [], a1 = [], o1 = [], i1 = [], l1 = [], s1 = [], Ph = /* @__PURE__ */ new Set();
    Js.recordUnsafeLifecycleWarnings = function(n, o) {
      Ph.has(n.type) || (typeof o.componentWillMount == "function" && o.componentWillMount.__suppressDeprecationWarning !== !0 && r1.push(n), n.mode & ii && typeof o.UNSAFE_componentWillMount == "function" && a1.push(n), typeof o.componentWillReceiveProps == "function" && o.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && o1.push(n), n.mode & ii && typeof o.UNSAFE_componentWillReceiveProps == "function" && i1.push(n), typeof o.componentWillUpdate == "function" && o.componentWillUpdate.__suppressDeprecationWarning !== !0 && l1.push(n), n.mode & ii && typeof o.UNSAFE_componentWillUpdate == "function" && s1.push(n));
    }, Js.flushPendingUnsafeLifecycleWarnings = function() {
      var n = /* @__PURE__ */ new Set();
      0 < r1.length && (r1.forEach(function(z) {
        n.add(
          W(z) || "Component"
        ), Ph.add(z.type);
      }), r1 = []);
      var o = /* @__PURE__ */ new Set();
      0 < a1.length && (a1.forEach(function(z) {
        o.add(
          W(z) || "Component"
        ), Ph.add(z.type);
      }), a1 = []);
      var s = /* @__PURE__ */ new Set();
      0 < o1.length && (o1.forEach(function(z) {
        s.add(
          W(z) || "Component"
        ), Ph.add(z.type);
      }), o1 = []);
      var h = /* @__PURE__ */ new Set();
      0 < i1.length && (i1.forEach(
        function(z) {
          h.add(
            W(z) || "Component"
          ), Ph.add(z.type);
        }
      ), i1 = []);
      var y = /* @__PURE__ */ new Set();
      0 < l1.length && (l1.forEach(function(z) {
        y.add(
          W(z) || "Component"
        ), Ph.add(z.type);
      }), l1 = []);
      var C = /* @__PURE__ */ new Set();
      if (0 < s1.length && (s1.forEach(function(z) {
        C.add(
          W(z) || "Component"
        ), Ph.add(z.type);
      }), s1 = []), 0 < o.size) {
        var A = w(
          o
        );
        console.error(
          `Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`,
          A
        );
      }
      0 < h.size && (A = w(
        h
      ), console.error(
        `Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://react.dev/link/derived-state

Please update the following components: %s`,
        A
      )), 0 < C.size && (A = w(
        C
      ), console.error(
        `Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`,
        A
      )), 0 < n.size && (A = w(n), console.warn(
        `componentWillMount has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`,
        A
      )), 0 < s.size && (A = w(
        s
      ), console.warn(
        `componentWillReceiveProps has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://react.dev/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`,
        A
      )), 0 < y.size && (A = w(y), console.warn(
        `componentWillUpdate has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`,
        A
      ));
    };
    var uw = /* @__PURE__ */ new Map(), _6 = /* @__PURE__ */ new Set();
    Js.recordLegacyContextWarning = function(n, o) {
      for (var s = null, h = n; h !== null; )
        h.mode & ii && (s = h), h = h.return;
      s === null ? console.error(
        "Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue."
      ) : !_6.has(n.type) && (h = uw.get(s), n.type.contextTypes != null || n.type.childContextTypes != null || o !== null && typeof o.getChildContext == "function") && (h === void 0 && (h = [], uw.set(s, h)), h.push(n));
    }, Js.flushLegacyContextWarning = function() {
      uw.forEach(function(n) {
        if (n.length !== 0) {
          var o = n[0], s = /* @__PURE__ */ new Set();
          n.forEach(function(y) {
            s.add(W(y) || "Component"), _6.add(y.type);
          });
          var h = w(s);
          le(o, function() {
            console.error(
              `Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://react.dev/link/legacy-context`,
              h
            );
          });
        }
      });
    }, Js.discardPendingWarnings = function() {
      r1 = [], a1 = [], o1 = [], i1 = [], l1 = [], s1 = [], uw = /* @__PURE__ */ new Map();
    };
    var B6 = {
      react_stack_bottom_frame: function(n, o, s) {
        var h = ds;
        ds = !0;
        try {
          return n(o, s);
        } finally {
          ds = h;
        }
      }
    }, qC = B6.react_stack_bottom_frame.bind(B6), U6 = {
      react_stack_bottom_frame: function(n) {
        var o = ds;
        ds = !0;
        try {
          return n.render();
        } finally {
          ds = o;
        }
      }
    }, X6 = U6.react_stack_bottom_frame.bind(U6), G6 = {
      react_stack_bottom_frame: function(n, o) {
        try {
          o.componentDidMount();
        } catch (s) {
          En(n, n.return, s);
        }
      }
    }, KC = G6.react_stack_bottom_frame.bind(
      G6
    ), q6 = {
      react_stack_bottom_frame: function(n, o, s, h, y) {
        try {
          o.componentDidUpdate(s, h, y);
        } catch (C) {
          En(n, n.return, C);
        }
      }
    }, K6 = q6.react_stack_bottom_frame.bind(
      q6
    ), Y6 = {
      react_stack_bottom_frame: function(n, o) {
        var s = o.stack;
        n.componentDidCatch(o.value, {
          componentStack: s !== null ? s : ""
        });
      }
    }, oT = Y6.react_stack_bottom_frame.bind(
      Y6
    ), Q6 = {
      react_stack_bottom_frame: function(n, o, s) {
        try {
          s.componentWillUnmount();
        } catch (h) {
          En(n, o, h);
        }
      }
    }, J6 = Q6.react_stack_bottom_frame.bind(
      Q6
    ), Z6 = {
      react_stack_bottom_frame: function(n) {
        var o = n.create;
        return n = n.inst, o = o(), n.destroy = o;
      }
    }, iT = Z6.react_stack_bottom_frame.bind(Z6), e8 = {
      react_stack_bottom_frame: function(n, o, s) {
        try {
          s();
        } catch (h) {
          En(n, o, h);
        }
      }
    }, lT = e8.react_stack_bottom_frame.bind(e8), t8 = {
      react_stack_bottom_frame: function(n) {
        var o = n._init;
        return o(n._payload);
      }
    }, sT = t8.react_stack_bottom_frame.bind(t8), a0 = Error(
      "Suspense Exception: This is not a real error! It's an implementation detail of `use` to interrupt the current render. You must either rethrow it immediately, or move the `use` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary, or call the promise's `.catch` method and pass the result to `use`."
    ), YC = Error(
      "Suspense Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."
    ), cw = Error(
      "Suspense Exception: This is not a real error! It's an implementation detail of `useActionState` to interrupt the current render. You must either rethrow it immediately, or move the `useActionState` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary."
    ), dw = {
      then: function() {
        console.error(
          'Internal React error: A listener was unexpectedly attached to a "noop" thenable. This is a bug in React. Please file an issue.'
        );
      }
    }, kh = null, u1 = !1, o0 = null, c1 = 0, Nn = null, QC, n8 = QC = !1, r8 = {}, a8 = {}, o8 = {};
    b = function(n, o, s) {
      if (s !== null && typeof s == "object" && s._store && (!s._store.validated && s.key == null || s._store.validated === 2)) {
        if (typeof s._store != "object")
          throw Error(
            "React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue."
          );
        s._store.validated = 1;
        var h = W(n), y = h || "null";
        if (!r8[y]) {
          r8[y] = !0, s = s._owner, n = n._debugOwner;
          var C = "";
          n && typeof n.tag == "number" && (y = W(n)) && (C = `

Check the render method of \`` + y + "`."), C || h && (C = `

Check the top-level render call using <` + h + ">.");
          var A = "";
          s != null && n !== s && (h = null, typeof s.tag == "number" ? h = W(s) : typeof s.name == "string" && (h = s.name), h && (A = " It was passed a child from " + h + ".")), le(o, function() {
            console.error(
              'Each child in a list should have a unique "key" prop.%s%s See https://react.dev/link/warning-keys for more information.',
              C,
              A
            );
          });
        }
      }
    };
    var Mh = Ba(!0), i8 = Ba(!1), l8 = 0, s8 = 1, u8 = 2, JC = 3, Mf = !1, c8 = !1, ZC = null, e4 = !1, i0 = Q(null), fw = Q(0), jl = Q(null), Ms = null, l0 = 1, d1 = 2, Ha = Q(0), mw = 0, Cs = 1, Di = 2, Il = 4, $i = 8, s0, d8 = /* @__PURE__ */ new Set(), f8 = /* @__PURE__ */ new Set(), t4 = /* @__PURE__ */ new Set(), m8 = /* @__PURE__ */ new Set(), Jc = 0, un = null, Ir = null, Ja = null, hw = !1, u0 = !1, Oh = !1, pw = 0, f1 = 0, Zc = null, uT = 0, cT = 25, Be = null, xs = null, ed = -1, m1 = !1, h1 = {
      readContext: cr,
      use: Is,
      useCallback: da,
      useContext: da,
      useEffect: da,
      useImperativeHandle: da,
      useLayoutEffect: da,
      useInsertionEffect: da,
      useMemo: da,
      useReducer: da,
      useRef: da,
      useState: da,
      useDebugValue: da,
      useDeferredValue: da,
      useTransition: da,
      useSyncExternalStore: da,
      useId: da,
      useHostTransitionStatus: da,
      useFormState: da,
      useActionState: da,
      useOptimistic: da,
      useMemoCache: da,
      useCacheRefresh: da
    };
    h1.useEffectEvent = da;
    var n4 = null, h8 = null, r4 = null, p8 = null, Uu = null, Zs = null, gw = null;
    n4 = {
      readContext: function(n) {
        return cr(n);
      },
      use: Is,
      useCallback: function(n, o) {
        return Be = "useCallback", sn(), js(o), jp(n, o);
      },
      useContext: function(n) {
        return Be = "useContext", sn(), cr(n);
      },
      useEffect: function(n, o) {
        return Be = "useEffect", sn(), js(o), Cc(n, o);
      },
      useImperativeHandle: function(n, o, s) {
        return Be = "useImperativeHandle", sn(), js(s), Ql(n, o, s);
      },
      useInsertionEffect: function(n, o) {
        Be = "useInsertionEffect", sn(), js(o), ku(4, Di, n, o);
      },
      useLayoutEffect: function(n, o) {
        return Be = "useLayoutEffect", sn(), js(o), Ho(n, o);
      },
      useMemo: function(n, o) {
        Be = "useMemo", sn(), js(o);
        var s = Xe.H;
        Xe.H = Uu;
        try {
          return Fo(n, o);
        } finally {
          Xe.H = s;
        }
      },
      useReducer: function(n, o, s) {
        Be = "useReducer", sn();
        var h = Xe.H;
        Xe.H = Uu;
        try {
          return Od(n, o, s);
        } finally {
          Xe.H = h;
        }
      },
      useRef: function(n) {
        return Be = "useRef", sn(), zp(n);
      },
      useState: function(n) {
        Be = "useState", sn();
        var o = Xe.H;
        Xe.H = Uu;
        try {
          return Cu(n);
        } finally {
          Xe.H = o;
        }
      },
      useDebugValue: function() {
        Be = "useDebugValue", sn();
      },
      useDeferredValue: function(n, o) {
        return Be = "useDeferredValue", sn(), Dd(n, o);
      },
      useTransition: function() {
        return Be = "useTransition", sn(), Mu();
      },
      useSyncExternalStore: function(n, o, s) {
        return Be = "useSyncExternalStore", sn(), Td(
          n,
          o,
          s
        );
      },
      useId: function() {
        return Be = "useId", sn(), Am();
      },
      useFormState: function(n, o) {
        return Be = "useFormState", sn(), wm(), Ci(n, o);
      },
      useActionState: function(n, o) {
        return Be = "useActionState", sn(), Ci(n, o);
      },
      useOptimistic: function(n) {
        return Be = "useOptimistic", sn(), Sc(n);
      },
      useHostTransitionStatus: Ws,
      useMemoCache: wi,
      useCacheRefresh: function() {
        return Be = "useCacheRefresh", sn(), Ip();
      },
      useEffectEvent: function(n) {
        return Be = "useEffectEvent", sn(), Tm(n);
      }
    }, h8 = {
      readContext: function(n) {
        return cr(n);
      },
      use: Is,
      useCallback: function(n, o) {
        return Be = "useCallback", rt(), jp(n, o);
      },
      useContext: function(n) {
        return Be = "useContext", rt(), cr(n);
      },
      useEffect: function(n, o) {
        return Be = "useEffect", rt(), Cc(n, o);
      },
      useImperativeHandle: function(n, o, s) {
        return Be = "useImperativeHandle", rt(), Ql(n, o, s);
      },
      useInsertionEffect: function(n, o) {
        Be = "useInsertionEffect", rt(), ku(4, Di, n, o);
      },
      useLayoutEffect: function(n, o) {
        return Be = "useLayoutEffect", rt(), Ho(n, o);
      },
      useMemo: function(n, o) {
        Be = "useMemo", rt();
        var s = Xe.H;
        Xe.H = Uu;
        try {
          return Fo(n, o);
        } finally {
          Xe.H = s;
        }
      },
      useReducer: function(n, o, s) {
        Be = "useReducer", rt();
        var h = Xe.H;
        Xe.H = Uu;
        try {
          return Od(n, o, s);
        } finally {
          Xe.H = h;
        }
      },
      useRef: function(n) {
        return Be = "useRef", rt(), zp(n);
      },
      useState: function(n) {
        Be = "useState", rt();
        var o = Xe.H;
        Xe.H = Uu;
        try {
          return Cu(n);
        } finally {
          Xe.H = o;
        }
      },
      useDebugValue: function() {
        Be = "useDebugValue", rt();
      },
      useDeferredValue: function(n, o) {
        return Be = "useDeferredValue", rt(), Dd(n, o);
      },
      useTransition: function() {
        return Be = "useTransition", rt(), Mu();
      },
      useSyncExternalStore: function(n, o, s) {
        return Be = "useSyncExternalStore", rt(), Td(
          n,
          o,
          s
        );
      },
      useId: function() {
        return Be = "useId", rt(), Am();
      },
      useActionState: function(n, o) {
        return Be = "useActionState", rt(), Ci(n, o);
      },
      useFormState: function(n, o) {
        return Be = "useFormState", rt(), wm(), Ci(n, o);
      },
      useOptimistic: function(n) {
        return Be = "useOptimistic", rt(), Sc(n);
      },
      useHostTransitionStatus: Ws,
      useMemoCache: wi,
      useCacheRefresh: function() {
        return Be = "useCacheRefresh", rt(), Ip();
      },
      useEffectEvent: function(n) {
        return Be = "useEffectEvent", rt(), Tm(n);
      }
    }, r4 = {
      readContext: function(n) {
        return cr(n);
      },
      use: Is,
      useCallback: function(n, o) {
        return Be = "useCallback", rt(), xl(n, o);
      },
      useContext: function(n) {
        return Be = "useContext", rt(), cr(n);
      },
      useEffect: function(n, o) {
        Be = "useEffect", rt(), za(2048, $i, n, o);
      },
      useImperativeHandle: function(n, o, s) {
        return Be = "useImperativeHandle", rt(), Nd(n, o, s);
      },
      useInsertionEffect: function(n, o) {
        return Be = "useInsertionEffect", rt(), za(4, Di, n, o);
      },
      useLayoutEffect: function(n, o) {
        return Be = "useLayoutEffect", rt(), za(4, Il, n, o);
      },
      useMemo: function(n, o) {
        Be = "useMemo", rt();
        var s = Xe.H;
        Xe.H = Zs;
        try {
          return Br(n, o);
        } finally {
          Xe.H = s;
        }
      },
      useReducer: function(n, o, s) {
        Be = "useReducer", rt();
        var h = Xe.H;
        Xe.H = Zs;
        try {
          return bc(n, o, s);
        } finally {
          Xe.H = h;
        }
      },
      useRef: function() {
        return Be = "useRef", rt(), gr().memoizedState;
      },
      useState: function() {
        Be = "useState", rt();
        var n = Xe.H;
        Xe.H = Zs;
        try {
          return bc(Si);
        } finally {
          Xe.H = n;
        }
      },
      useDebugValue: function() {
        Be = "useDebugValue", rt();
      },
      useDeferredValue: function(n, o) {
        return Be = "useDeferredValue", rt(), Jl(n, o);
      },
      useTransition: function() {
        return Be = "useTransition", rt(), Ub();
      },
      useSyncExternalStore: function(n, o, s) {
        return Be = "useSyncExternalStore", rt(), wc(
          n,
          o,
          s
        );
      },
      useId: function() {
        return Be = "useId", rt(), gr().memoizedState;
      },
      useFormState: function(n) {
        return Be = "useFormState", rt(), wm(), Eu(n);
      },
      useActionState: function(n) {
        return Be = "useActionState", rt(), Eu(n);
      },
      useOptimistic: function(n, o) {
        return Be = "useOptimistic", rt(), km(n, o);
      },
      useHostTransitionStatus: Ws,
      useMemoCache: wi,
      useCacheRefresh: function() {
        return Be = "useCacheRefresh", rt(), gr().memoizedState;
      },
      useEffectEvent: function(n) {
        return Be = "useEffectEvent", rt(), Ad(n);
      }
    }, p8 = {
      readContext: function(n) {
        return cr(n);
      },
      use: Is,
      useCallback: function(n, o) {
        return Be = "useCallback", rt(), xl(n, o);
      },
      useContext: function(n) {
        return Be = "useContext", rt(), cr(n);
      },
      useEffect: function(n, o) {
        Be = "useEffect", rt(), za(2048, $i, n, o);
      },
      useImperativeHandle: function(n, o, s) {
        return Be = "useImperativeHandle", rt(), Nd(n, o, s);
      },
      useInsertionEffect: function(n, o) {
        return Be = "useInsertionEffect", rt(), za(4, Di, n, o);
      },
      useLayoutEffect: function(n, o) {
        return Be = "useLayoutEffect", rt(), za(4, Il, n, o);
      },
      useMemo: function(n, o) {
        Be = "useMemo", rt();
        var s = Xe.H;
        Xe.H = gw;
        try {
          return Br(n, o);
        } finally {
          Xe.H = s;
        }
      },
      useReducer: function(n, o, s) {
        Be = "useReducer", rt();
        var h = Xe.H;
        Xe.H = gw;
        try {
          return yc(n, o, s);
        } finally {
          Xe.H = h;
        }
      },
      useRef: function() {
        return Be = "useRef", rt(), gr().memoizedState;
      },
      useState: function() {
        Be = "useState", rt();
        var n = Xe.H;
        Xe.H = gw;
        try {
          return yc(Si);
        } finally {
          Xe.H = n;
        }
      },
      useDebugValue: function() {
        Be = "useDebugValue", rt();
      },
      useDeferredValue: function(n, o) {
        return Be = "useDeferredValue", rt(), Sn(n, o);
      },
      useTransition: function() {
        return Be = "useTransition", rt(), Zr();
      },
      useSyncExternalStore: function(n, o, s) {
        return Be = "useSyncExternalStore", rt(), wc(
          n,
          o,
          s
        );
      },
      useId: function() {
        return Be = "useId", rt(), gr().memoizedState;
      },
      useFormState: function(n) {
        return Be = "useFormState", rt(), wm(), Pu(n);
      },
      useActionState: function(n) {
        return Be = "useActionState", rt(), Pu(n);
      },
      useOptimistic: function(n, o) {
        return Be = "useOptimistic", rt(), Mm(n, o);
      },
      useHostTransitionStatus: Ws,
      useMemoCache: wi,
      useCacheRefresh: function() {
        return Be = "useCacheRefresh", rt(), gr().memoizedState;
      },
      useEffectEvent: function(n) {
        return Be = "useEffectEvent", rt(), Ad(n);
      }
    }, Uu = {
      readContext: function(n) {
        return p(), cr(n);
      },
      use: function(n) {
        return f(), Is(n);
      },
      useCallback: function(n, o) {
        return Be = "useCallback", f(), sn(), jp(n, o);
      },
      useContext: function(n) {
        return Be = "useContext", f(), sn(), cr(n);
      },
      useEffect: function(n, o) {
        return Be = "useEffect", f(), sn(), Cc(n, o);
      },
      useImperativeHandle: function(n, o, s) {
        return Be = "useImperativeHandle", f(), sn(), Ql(n, o, s);
      },
      useInsertionEffect: function(n, o) {
        Be = "useInsertionEffect", f(), sn(), ku(4, Di, n, o);
      },
      useLayoutEffect: function(n, o) {
        return Be = "useLayoutEffect", f(), sn(), Ho(n, o);
      },
      useMemo: function(n, o) {
        Be = "useMemo", f(), sn();
        var s = Xe.H;
        Xe.H = Uu;
        try {
          return Fo(n, o);
        } finally {
          Xe.H = s;
        }
      },
      useReducer: function(n, o, s) {
        Be = "useReducer", f(), sn();
        var h = Xe.H;
        Xe.H = Uu;
        try {
          return Od(n, o, s);
        } finally {
          Xe.H = h;
        }
      },
      useRef: function(n) {
        return Be = "useRef", f(), sn(), zp(n);
      },
      useState: function(n) {
        Be = "useState", f(), sn();
        var o = Xe.H;
        Xe.H = Uu;
        try {
          return Cu(n);
        } finally {
          Xe.H = o;
        }
      },
      useDebugValue: function() {
        Be = "useDebugValue", f(), sn();
      },
      useDeferredValue: function(n, o) {
        return Be = "useDeferredValue", f(), sn(), Dd(n, o);
      },
      useTransition: function() {
        return Be = "useTransition", f(), sn(), Mu();
      },
      useSyncExternalStore: function(n, o, s) {
        return Be = "useSyncExternalStore", f(), sn(), Td(
          n,
          o,
          s
        );
      },
      useId: function() {
        return Be = "useId", f(), sn(), Am();
      },
      useFormState: function(n, o) {
        return Be = "useFormState", f(), sn(), Ci(n, o);
      },
      useActionState: function(n, o) {
        return Be = "useActionState", f(), sn(), Ci(n, o);
      },
      useOptimistic: function(n) {
        return Be = "useOptimistic", f(), sn(), Sc(n);
      },
      useMemoCache: function(n) {
        return f(), wi(n);
      },
      useHostTransitionStatus: Ws,
      useCacheRefresh: function() {
        return Be = "useCacheRefresh", sn(), Ip();
      },
      useEffectEvent: function(n) {
        return Be = "useEffectEvent", f(), sn(), Tm(n);
      }
    }, Zs = {
      readContext: function(n) {
        return p(), cr(n);
      },
      use: function(n) {
        return f(), Is(n);
      },
      useCallback: function(n, o) {
        return Be = "useCallback", f(), rt(), xl(n, o);
      },
      useContext: function(n) {
        return Be = "useContext", f(), rt(), cr(n);
      },
      useEffect: function(n, o) {
        Be = "useEffect", f(), rt(), za(2048, $i, n, o);
      },
      useImperativeHandle: function(n, o, s) {
        return Be = "useImperativeHandle", f(), rt(), Nd(n, o, s);
      },
      useInsertionEffect: function(n, o) {
        return Be = "useInsertionEffect", f(), rt(), za(4, Di, n, o);
      },
      useLayoutEffect: function(n, o) {
        return Be = "useLayoutEffect", f(), rt(), za(4, Il, n, o);
      },
      useMemo: function(n, o) {
        Be = "useMemo", f(), rt();
        var s = Xe.H;
        Xe.H = Zs;
        try {
          return Br(n, o);
        } finally {
          Xe.H = s;
        }
      },
      useReducer: function(n, o, s) {
        Be = "useReducer", f(), rt();
        var h = Xe.H;
        Xe.H = Zs;
        try {
          return bc(n, o, s);
        } finally {
          Xe.H = h;
        }
      },
      useRef: function() {
        return Be = "useRef", f(), rt(), gr().memoizedState;
      },
      useState: function() {
        Be = "useState", f(), rt();
        var n = Xe.H;
        Xe.H = Zs;
        try {
          return bc(Si);
        } finally {
          Xe.H = n;
        }
      },
      useDebugValue: function() {
        Be = "useDebugValue", f(), rt();
      },
      useDeferredValue: function(n, o) {
        return Be = "useDeferredValue", f(), rt(), Jl(n, o);
      },
      useTransition: function() {
        return Be = "useTransition", f(), rt(), Ub();
      },
      useSyncExternalStore: function(n, o, s) {
        return Be = "useSyncExternalStore", f(), rt(), wc(
          n,
          o,
          s
        );
      },
      useId: function() {
        return Be = "useId", f(), rt(), gr().memoizedState;
      },
      useFormState: function(n) {
        return Be = "useFormState", f(), rt(), Eu(n);
      },
      useActionState: function(n) {
        return Be = "useActionState", f(), rt(), Eu(n);
      },
      useOptimistic: function(n, o) {
        return Be = "useOptimistic", f(), rt(), km(n, o);
      },
      useMemoCache: function(n) {
        return f(), wi(n);
      },
      useHostTransitionStatus: Ws,
      useCacheRefresh: function() {
        return Be = "useCacheRefresh", rt(), gr().memoizedState;
      },
      useEffectEvent: function(n) {
        return Be = "useEffectEvent", f(), rt(), Ad(n);
      }
    }, gw = {
      readContext: function(n) {
        return p(), cr(n);
      },
      use: function(n) {
        return f(), Is(n);
      },
      useCallback: function(n, o) {
        return Be = "useCallback", f(), rt(), xl(n, o);
      },
      useContext: function(n) {
        return Be = "useContext", f(), rt(), cr(n);
      },
      useEffect: function(n, o) {
        Be = "useEffect", f(), rt(), za(2048, $i, n, o);
      },
      useImperativeHandle: function(n, o, s) {
        return Be = "useImperativeHandle", f(), rt(), Nd(n, o, s);
      },
      useInsertionEffect: function(n, o) {
        return Be = "useInsertionEffect", f(), rt(), za(4, Di, n, o);
      },
      useLayoutEffect: function(n, o) {
        return Be = "useLayoutEffect", f(), rt(), za(4, Il, n, o);
      },
      useMemo: function(n, o) {
        Be = "useMemo", f(), rt();
        var s = Xe.H;
        Xe.H = Zs;
        try {
          return Br(n, o);
        } finally {
          Xe.H = s;
        }
      },
      useReducer: function(n, o, s) {
        Be = "useReducer", f(), rt();
        var h = Xe.H;
        Xe.H = Zs;
        try {
          return yc(n, o, s);
        } finally {
          Xe.H = h;
        }
      },
      useRef: function() {
        return Be = "useRef", f(), rt(), gr().memoizedState;
      },
      useState: function() {
        Be = "useState", f(), rt();
        var n = Xe.H;
        Xe.H = Zs;
        try {
          return yc(Si);
        } finally {
          Xe.H = n;
        }
      },
      useDebugValue: function() {
        Be = "useDebugValue", f(), rt();
      },
      useDeferredValue: function(n, o) {
        return Be = "useDeferredValue", f(), rt(), Sn(n, o);
      },
      useTransition: function() {
        return Be = "useTransition", f(), rt(), Zr();
      },
      useSyncExternalStore: function(n, o, s) {
        return Be = "useSyncExternalStore", f(), rt(), wc(
          n,
          o,
          s
        );
      },
      useId: function() {
        return Be = "useId", f(), rt(), gr().memoizedState;
      },
      useFormState: function(n) {
        return Be = "useFormState", f(), rt(), Pu(n);
      },
      useActionState: function(n) {
        return Be = "useActionState", f(), rt(), Pu(n);
      },
      useOptimistic: function(n, o) {
        return Be = "useOptimistic", f(), rt(), Mm(n, o);
      },
      useMemoCache: function(n) {
        return f(), wi(n);
      },
      useHostTransitionStatus: Ws,
      useCacheRefresh: function() {
        return Be = "useCacheRefresh", rt(), gr().memoizedState;
      },
      useEffectEvent: function(n) {
        return Be = "useEffectEvent", f(), rt(), Ad(n);
      }
    };
    var g8 = {}, v8 = /* @__PURE__ */ new Set(), b8 = /* @__PURE__ */ new Set(), y8 = /* @__PURE__ */ new Set(), w8 = /* @__PURE__ */ new Set(), S8 = /* @__PURE__ */ new Set(), C8 = /* @__PURE__ */ new Set(), x8 = /* @__PURE__ */ new Set(), E8 = /* @__PURE__ */ new Set(), P8 = /* @__PURE__ */ new Set(), k8 = /* @__PURE__ */ new Set();
    Object.freeze(g8);
    var a4 = {
      enqueueSetState: function(n, o, s) {
        n = n._reactInternals;
        var h = xo(n), y = $a(h);
        y.payload = o, s != null && (kc(s), y.callback = s), o = Gl(n, y, h), o !== null && (Bl(h, "this.setState()", n), ln(o, n, h), Ji(o, n, h));
      },
      enqueueReplaceState: function(n, o, s) {
        n = n._reactInternals;
        var h = xo(n), y = $a(h);
        y.tag = s8, y.payload = o, s != null && (kc(s), y.callback = s), o = Gl(n, y, h), o !== null && (Bl(h, "this.replaceState()", n), ln(o, n, h), Ji(o, n, h));
      },
      enqueueForceUpdate: function(n, o) {
        n = n._reactInternals;
        var s = xo(n), h = $a(s);
        h.tag = u8, o != null && (kc(o), h.callback = o), o = Gl(n, h, s), o !== null && (Bl(s, "this.forceUpdate()", n), ln(o, n, s), Ji(o, n, s));
      }
    }, c0 = null, o4 = null, i4 = Error(
      "This is not a real error. It's an implementation detail of React's selective hydration feature. If this leaks into userspace, it's a bug in React. Please file an issue."
    ), Za = !1, M8 = {}, O8 = {}, T8 = {}, R8 = {}, d0 = !1, A8 = {}, vw = {}, l4 = {
      dehydrated: null,
      treeContext: null,
      retryLane: 0,
      hydrationErrors: null
    }, N8 = !1, D8 = null;
    D8 = /* @__PURE__ */ new Set();
    var td = !1, eo = !1, s4 = !1, $8 = typeof WeakSet == "function" ? WeakSet : Set, Mo = null, f0 = null, m0 = null, to = null, al = !1, eu = null, ho = !1, p1 = 8192, dT = {
      getCacheForType: function(n) {
        var o = cr(Ya), s = o.data.get(n);
        return s === void 0 && (s = n(), o.data.set(n, s)), s;
      },
      cacheSignal: function() {
        return cr(Ya).controller.signal;
      },
      getOwner: function() {
        return oi;
      }
    };
    if (typeof Symbol == "function" && Symbol.for) {
      var g1 = Symbol.for;
      g1("selector.component"), g1("selector.has_pseudo_class"), g1("selector.role"), g1("selector.test_id"), g1("selector.text");
    }
    var fT = [], mT = typeof WeakMap == "function" ? WeakMap : Map, Oo = 0, po = 2, Ll = 4, nd = 0, v1 = 1, Th = 2, bw = 3, Of = 4, yw = 6, z8 = 5, ar = Oo, Lr = null, Ln = null, Dn = 0, ol = 0, ww = 1, Rh = 2, b1 = 3, j8 = 4, u4 = 5, y1 = 6, Sw = 7, c4 = 8, Ah = 9, Tr = ol, Hl = null, Tf = !1, h0 = !1, d4 = !1, Xu = 0, ha = nd, Rf = 0, Af = 0, f4 = 0, il = 0, Nh = 0, w1 = null, zi = null, Cw = !1, xw = 0, I8 = 0, L8 = 300, Ew = 1 / 0, H8 = 500, S1 = null, Ra = null, Nf = null, Pw = 0, m4 = 1, h4 = 2, F8 = 3, Df = 0, W8 = 1, V8 = 2, _8 = 3, B8 = 4, kw = 5, no = 0, $f = null, p0 = null, tu = 0, p4 = 0, g4 = -0, v4 = null, U8 = null, X8 = null, nu = Pw, G8 = null, hT = 50, C1 = 0, b4 = null, y4 = !1, Mw = !1, pT = 50, Dh = 0, x1 = null, g0 = !1, Ow = null, q8 = !1, K8 = /* @__PURE__ */ new Set(), gT = {}, Tw = null, v0 = null, w4 = !1, S4 = !1, Rw = !1, C4 = !1, zf = 0, x4 = {};
    (function() {
      for (var n = 0; n < $C.length; n++) {
        var o = $C[n], s = o.toLowerCase();
        o = o[0].toUpperCase() + o.slice(1), ml(s, "on" + o);
      }
      ml(k6, "onAnimationEnd"), ml(M6, "onAnimationIteration"), ml(O6, "onAnimationStart"), ml("dblclick", "onDoubleClick"), ml("focusin", "onFocus"), ml("focusout", "onBlur"), ml(BO, "onTransitionRun"), ml(UO, "onTransitionStart"), ml(XO, "onTransitionCancel"), ml(T6, "onTransitionEnd");
    })(), an("onMouseEnter", ["mouseout", "mouseover"]), an("onMouseLeave", ["mouseout", "mouseover"]), an("onPointerEnter", ["pointerout", "pointerover"]), an("onPointerLeave", ["pointerout", "pointerover"]), hn(
      "onChange",
      "change click focusin focusout input keydown keyup selectionchange".split(
        " "
      )
    ), hn(
      "onSelect",
      "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
        " "
      )
    ), hn("onBeforeInput", [
      "compositionend",
      "keypress",
      "textInput",
      "paste"
    ]), hn(
      "onCompositionEnd",
      "compositionend focusout keydown keypress keyup mousedown".split(" ")
    ), hn(
      "onCompositionStart",
      "compositionstart focusout keydown keypress keyup mousedown".split(" ")
    ), hn(
      "onCompositionUpdate",
      "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
    );
    var E1 = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
      " "
    ), E4 = new Set(
      "beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(E1)
    ), Aw = "_reactListening" + Math.random().toString(36).slice(2), Y8 = !1, Q8 = !1, Nw = !1, J8 = !1, Dw = !1, $w = !1, Z8 = !1, zw = {}, vT = /\r\n?/g, bT = /\u0000|\uFFFD/g, $h = "http://www.w3.org/1999/xlink", P4 = "http://www.w3.org/XML/1998/namespace", yT = "javascript:throw new Error('React form unexpectedly submitted.')", wT = "suppressHydrationWarning", zh = "&", jw = "/&", P1 = "$", k1 = "/$", jf = "$?", jh = "$~", b0 = "$!", ST = "html", CT = "body", xT = "head", k4 = "F!", e5 = "F", t5 = "loading", ET = "style", dd = 0, y0 = 1, Iw = 2, M4 = null, O4 = null, n5 = { dialog: !0, webview: !0 }, T4 = null, M1 = void 0, r5 = typeof setTimeout == "function" ? setTimeout : void 0, PT = typeof clearTimeout == "function" ? clearTimeout : void 0, Ih = -1, a5 = typeof Promise == "function" ? Promise : void 0, kT = typeof queueMicrotask == "function" ? queueMicrotask : typeof a5 < "u" ? function(n) {
      return a5.resolve(null).then(n).catch(my);
    } : r5, R4 = null, Lh = 0, O1 = 1, o5 = 2, i5 = 3, Es = 4, Ps = /* @__PURE__ */ new Map(), l5 = /* @__PURE__ */ new Set(), rd = fr.d;
    fr.d = {
      f: function() {
        var n = rd.f(), o = ki();
        return n || o;
      },
      r: function(n) {
        var o = bt(n);
        o !== null && o.tag === 5 && o.type === "form" ? $d(o) : rd.r(n);
      },
      D: function(n) {
        rd.D(n), p2("dns-prefetch", n, null);
      },
      C: function(n, o) {
        rd.C(n, o), p2("preconnect", n, o);
      },
      L: function(n, o, s) {
        rd.L(n, o, s);
        var h = w0;
        if (h && n && o) {
          var y = 'link[rel="preload"][as="' + Gt(o) + '"]';
          o === "image" && s && s.imageSrcSet ? (y += '[imagesrcset="' + Gt(
            s.imageSrcSet
          ) + '"]', typeof s.imageSizes == "string" && (y += '[imagesizes="' + Gt(
            s.imageSizes
          ) + '"]')) : y += '[href="' + Gt(n) + '"]';
          var C = y;
          switch (o) {
            case "style":
              C = jc(n);
              break;
            case "script":
              C = Ic(n);
          }
          Ps.has(C) || (n = Rn(
            {
              rel: "preload",
              href: o === "image" && s && s.imageSrcSet ? void 0 : n,
              as: o
            },
            s
          ), Ps.set(C, n), h.querySelector(y) !== null || o === "style" && h.querySelector(
            rh(C)
          ) || o === "script" && h.querySelector(ah(C)) || (o = h.createElement("link"), Ur(o, "link", n), Pt(o), h.head.appendChild(o)));
        }
      },
      m: function(n, o) {
        rd.m(n, o);
        var s = w0;
        if (s && n) {
          var h = o && typeof o.as == "string" ? o.as : "script", y = 'link[rel="modulepreload"][as="' + Gt(h) + '"][href="' + Gt(n) + '"]', C = y;
          switch (h) {
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
              C = Ic(n);
          }
          if (!Ps.has(C) && (n = Rn({ rel: "modulepreload", href: n }, o), Ps.set(C, n), s.querySelector(y) === null)) {
            switch (h) {
              case "audioworklet":
              case "paintworklet":
              case "serviceworker":
              case "sharedworker":
              case "worker":
              case "script":
                if (s.querySelector(ah(C)))
                  return;
            }
            h = s.createElement("link"), Ur(h, "link", n), Pt(h), s.head.appendChild(h);
          }
        }
      },
      X: function(n, o) {
        rd.X(n, o);
        var s = w0;
        if (s && n) {
          var h = $t(s).hoistableScripts, y = Ic(n), C = h.get(y);
          C || (C = s.querySelector(
            ah(y)
          ), C || (n = Rn({ src: n, async: !0 }, o), (o = Ps.get(y)) && b2(n, o), C = s.createElement("script"), Pt(C), Ur(C, "link", n), s.head.appendChild(C)), C = {
            type: "script",
            instance: C,
            count: 1,
            state: null
          }, h.set(y, C));
        }
      },
      S: function(n, o, s) {
        rd.S(n, o, s);
        var h = w0;
        if (h && n) {
          var y = $t(h).hoistableStyles, C = jc(n);
          o = o || "default";
          var A = y.get(C);
          if (!A) {
            var z = { loading: Lh, preload: null };
            if (A = h.querySelector(
              rh(C)
            ))
              z.loading = O1 | Es;
            else {
              n = Rn(
                {
                  rel: "stylesheet",
                  href: n,
                  "data-precedence": o
                },
                s
              ), (s = Ps.get(C)) && v2(n, s);
              var q = A = h.createElement("link");
              Pt(q), Ur(q, "link", n), q._p = new Promise(function(Z, xe) {
                q.onload = Z, q.onerror = xe;
              }), q.addEventListener("load", function() {
                z.loading |= O1;
              }), q.addEventListener("error", function() {
                z.loading |= o5;
              }), z.loading |= Es, tf(A, o, h);
            }
            A = {
              type: "stylesheet",
              instance: A,
              count: 1,
              state: z
            }, y.set(C, A);
          }
        }
      },
      M: function(n, o) {
        rd.M(n, o);
        var s = w0;
        if (s && n) {
          var h = $t(s).hoistableScripts, y = Ic(n), C = h.get(y);
          C || (C = s.querySelector(
            ah(y)
          ), C || (n = Rn({ src: n, async: !0, type: "module" }, o), (o = Ps.get(y)) && b2(n, o), C = s.createElement("script"), Pt(C), Ur(C, "link", n), s.head.appendChild(C)), C = {
            type: "script",
            instance: C,
            count: 1,
            state: null
          }, h.set(y, C));
        }
      }
    };
    var w0 = typeof document > "u" ? null : document, Lw = null, MT = 6e4, OT = 800, TT = 500, A4 = 0, N4 = null, Hw = null, Hh = CC, T1 = {
      $$typeof: Nl,
      Provider: null,
      Consumer: null,
      _currentValue: Hh,
      _currentValue2: Hh,
      _threadCount: 0
    }, s5 = "%c%s%c", u5 = "background: #e6e6e6;background: light-dark(rgba(0,0,0,0.1), rgba(255,255,255,0.25));color: #000000;color: light-dark(#000000, #ffffff);border-radius: 2px", c5 = "", Fw = " ", RT = Function.prototype.bind, d5 = !1, f5 = null, m5 = null, h5 = null, p5 = null, g5 = null, v5 = null, b5 = null, y5 = null, w5 = null, S5 = null;
    f5 = function(n, o, s, h) {
      o = e(n, o), o !== null && (s = t(o.memoizedState, s, 0, h), o.memoizedState = s, o.baseState = s, n.memoizedProps = Rn({}, n.memoizedProps), s = So(n, 2), s !== null && ln(s, n, 2));
    }, m5 = function(n, o, s) {
      o = e(n, o), o !== null && (s = i(o.memoizedState, s, 0), o.memoizedState = s, o.baseState = s, n.memoizedProps = Rn({}, n.memoizedProps), s = So(n, 2), s !== null && ln(s, n, 2));
    }, h5 = function(n, o, s, h) {
      o = e(n, o), o !== null && (s = r(o.memoizedState, s, h), o.memoizedState = s, o.baseState = s, n.memoizedProps = Rn({}, n.memoizedProps), s = So(n, 2), s !== null && ln(s, n, 2));
    }, p5 = function(n, o, s) {
      n.pendingProps = t(n.memoizedProps, o, 0, s), n.alternate && (n.alternate.pendingProps = n.pendingProps), o = So(n, 2), o !== null && ln(o, n, 2);
    }, g5 = function(n, o) {
      n.pendingProps = i(n.memoizedProps, o, 0), n.alternate && (n.alternate.pendingProps = n.pendingProps), o = So(n, 2), o !== null && ln(o, n, 2);
    }, v5 = function(n, o, s) {
      n.pendingProps = r(
        n.memoizedProps,
        o,
        s
      ), n.alternate && (n.alternate.pendingProps = n.pendingProps), o = So(n, 2), o !== null && ln(o, n, 2);
    }, b5 = function(n) {
      var o = So(n, 2);
      o !== null && ln(o, n, 2);
    }, y5 = function(n) {
      var o = dt(), s = So(n, o);
      s !== null && ln(s, n, o);
    }, w5 = function(n) {
      d = n;
    }, S5 = function(n) {
      c = n;
    };
    var Ww = !0, Vw = null, D4 = !1, If = null, Lf = null, Hf = null, R1 = /* @__PURE__ */ new Map(), A1 = /* @__PURE__ */ new Map(), Ff = [], AT = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
      " "
    ), _w = null;
    if (Al.prototype.render = O2.prototype.render = function(n) {
      var o = this._internalRoot;
      if (o === null) throw Error("Cannot update an unmounted root.");
      var s = arguments;
      typeof s[1] == "function" ? console.error(
        "does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect()."
      ) : M(s[1]) ? console.error(
        "You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root."
      ) : typeof s[1] < "u" && console.error(
        "You passed a second argument to root.render(...) but it only accepts one argument."
      ), s = n;
      var h = o.current, y = xo(h);
      Mg(h, y, s, o, null, null);
    }, Al.prototype.unmount = O2.prototype.unmount = function() {
      var n = arguments;
      if (typeof n[0] == "function" && console.error(
        "does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect()."
      ), n = this._internalRoot, n !== null) {
        this._internalRoot = null;
        var o = n.containerInfo;
        (ar & (po | Ll)) !== Oo && console.error(
          "Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."
        ), Mg(n.current, 2, null, n, null, null), ki(), o[Ys] = null;
      }
    }, Al.prototype.unstable_scheduleHydration = function(n) {
      if (n) {
        var o = at();
        n = { blockedOn: null, target: n, priority: o };
        for (var s = 0; s < Ff.length && o !== 0 && o < Ff[s].priority; s++) ;
        Ff.splice(s, 0, n), s === 0 && M2(n);
      }
    }, (function() {
      var n = uh.version;
      if (n !== "19.2.4")
        throw Error(
          `Incompatible React versions: The "react" and "react-dom" packages must have the exact same version. Instead got:
  - react:      ` + (n + `
  - react-dom:  19.2.4
Learn more: https://react.dev/warnings/version-mismatch`)
        );
    })(), typeof Map == "function" && Map.prototype != null && typeof Map.prototype.forEach == "function" && typeof Set == "function" && Set.prototype != null && typeof Set.prototype.clear == "function" && typeof Set.prototype.forEach == "function" || console.error(
      "React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://react.dev/link/react-polyfills"
    ), fr.findDOMNode = function(n) {
      var o = n._reactInternals;
      if (o === void 0)
        throw typeof n.render == "function" ? Error("Unable to find node on an unmounted component.") : (n = Object.keys(n).join(","), Error(
          "Argument appears to not be a ReactComponent. Keys: " + n
        ));
      return n = j(o), n = n !== null ? I(n) : null, n = n === null ? null : n.stateNode, n;
    }, !(function() {
      var n = {
        bundleType: 1,
        version: "19.2.4",
        rendererPackageName: "react-dom",
        currentDispatcherRef: Xe,
        reconcilerVersion: "19.2.4"
      };
      return n.overrideHookState = f5, n.overrideHookStateDeletePath = m5, n.overrideHookStateRenamePath = h5, n.overrideProps = p5, n.overridePropsDeletePath = g5, n.overridePropsRenamePath = v5, n.scheduleUpdate = b5, n.scheduleRetry = y5, n.setErrorHandler = w5, n.setSuspenseHandler = S5, n.scheduleRefresh = P, n.scheduleRoot = E, n.setRefreshHandler = k, n.getCurrentFiber = Mr, Te(n);
    })() && Vu && window.top === window.self && (-1 < navigator.userAgent.indexOf("Chrome") && navigator.userAgent.indexOf("Edge") === -1 || -1 < navigator.userAgent.indexOf("Firefox"))) {
      var C5 = window.location.protocol;
      /^(https?|file):$/.test(C5) && console.info(
        "%cDownload the React DevTools for a better development experience: https://react.dev/link/react-devtools" + (C5 === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://react.dev/link/react-devtools-faq` : ""),
        "font-weight:bold"
      );
    }
    vP.createRoot = function(n, o) {
      if (!M(n))
        throw Error("Target container is not a DOM element.");
      T2(n);
      var s = !1, h = "", y = Fp, C = Wp, A = xv;
      return o != null && (o.hydrate ? console.warn(
        "hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead."
      ) : typeof o == "object" && o !== null && o.$$typeof === nl && console.error(
        `You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`
      ), o.unstable_strictMode === !0 && (s = !0), o.identifierPrefix !== void 0 && (h = o.identifierPrefix), o.onUncaughtError !== void 0 && (y = o.onUncaughtError), o.onCaughtError !== void 0 && (C = o.onCaughtError), o.onRecoverableError !== void 0 && (A = o.onRecoverableError)), o = lh(
        n,
        1,
        !1,
        null,
        null,
        s,
        h,
        null,
        y,
        C,
        A,
        Iy
      ), n[Ys] = o.current, $u(n), new O2(o);
    }, vP.hydrateRoot = function(n, o, s) {
      if (!M(n))
        throw Error("Target container is not a DOM element.");
      T2(n), o === void 0 && console.error(
        "Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)"
      );
      var h = !1, y = "", C = Fp, A = Wp, z = xv, q = null;
      return s != null && (s.unstable_strictMode === !0 && (h = !0), s.identifierPrefix !== void 0 && (y = s.identifierPrefix), s.onUncaughtError !== void 0 && (C = s.onUncaughtError), s.onCaughtError !== void 0 && (A = s.onCaughtError), s.onRecoverableError !== void 0 && (z = s.onRecoverableError), s.formState !== void 0 && (q = s.formState)), o = lh(
        n,
        1,
        !0,
        o,
        s ?? null,
        h,
        y,
        q,
        C,
        A,
        z,
        Iy
      ), o.context = Dy(null), s = o.current, h = xo(s), h = Ct(h), y = $a(h), y.callback = null, Gl(s, y, h), Bl(h, "hydrateRoot()", null), s = h, o.current.lanes = s, mt(o, s), ti(o), n[Ys] = o.current, $u(n), new Al(o);
    }, vP.version = "19.2.4", typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), vP;
}
var oB;
function RPe() {
  if (oB) return gP.exports;
  oB = 1;
  function e() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
      if (process.env.NODE_ENV !== "production")
        throw new Error("^_^");
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e);
      } catch (t) {
        console.error(t);
      }
    }
  }
  return process.env.NODE_ENV === "production" ? (e(), gP.exports = OPe()) : gP.exports = TPe(), gP.exports;
}
RPe();
const tte = "pageHostingOverride";
/*! js-cookie v3.0.5 | MIT */
function bP(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var a in r)
      e[a] = r[a];
  }
  return e;
}
var APe = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function P$(e, t) {
  function r(i, c, d) {
    if (!(typeof document > "u")) {
      d = bP({}, t, d), typeof d.expires == "number" && (d.expires = new Date(Date.now() + d.expires * 864e5)), d.expires && (d.expires = d.expires.toUTCString()), i = encodeURIComponent(i).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var f = "";
      for (var p in d)
        d[p] && (f += "; " + p, d[p] !== !0 && (f += "=" + d[p].split(";")[0]));
      return document.cookie = i + "=" + e.write(c, i) + f;
    }
  }
  function a(i) {
    if (!(typeof document > "u" || arguments.length && !i)) {
      for (var c = document.cookie ? document.cookie.split("; ") : [], d = {}, f = 0; f < c.length; f++) {
        var p = c[f].split("="), g = p.slice(1).join("=");
        try {
          var b = decodeURIComponent(p[0]);
          if (d[b] = e.read(g, b), i === b)
            break;
        } catch {
        }
      }
      return i ? d[i] : d;
    }
  }
  return Object.create(
    {
      set: r,
      get: a,
      remove: function(i, c) {
        r(
          i,
          "",
          bP({}, c, {
            expires: -1
          })
        );
      },
      withAttributes: function(i) {
        return P$(this.converter, bP({}, this.attributes, i));
      },
      withConverter: function(i) {
        return P$(bP({}, this.converter, i), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(t) },
      converter: { value: Object.freeze(e) }
    }
  );
}
var yP = P$(APe, { path: "/" });
function nte(e, t = "") {
  const [r, a] = Wn(() => {
    const d = yP.get(e);
    return d === void 0 ? t : d;
  }), i = (d, f) => {
    a(d), yP.set(e, d, f);
  }, c = (d) => {
    a(t), yP.remove(e, d);
  };
  return Er(() => {
    const d = yP.get(e);
    d !== r && a(d || t);
  }, [e, t, r]), { cookie: r, setCookie: i, removeCookie: c };
}
function NPe(e) {
  const [t, r] = Wn(() => {
    const a = new URLSearchParams(window.location.search ?? ""), i = { ...e };
    for (const c of Object.keys(e)) {
      const d = a.get(c.toString());
      if (d)
        if (Array.isArray(e[c]))
          i[c] = d.split(",").map((f) => f.trim());
        else if (typeof e[c] == "object")
          try {
            i[c] = JSON.parse(d);
          } catch (f) {
            console.warn(
              `Failed to parse URL parameter ${c.toString()} as JSON`,
              f
            );
          }
        else
          i[c] = d;
    }
    return i;
  });
  return [t, (a) => {
    let i;
    try {
      i = new URL(window.location.href, window.location.origin);
    } catch (c) {
      console.warn(
        "Failed to parse URL from href %s and origin %s",
        window.location.href,
        window.location.origin,
        c
      );
      return;
    }
    for (const [c, d] of Object.entries(a))
      if (Array.isArray(d))
        d.length > 0 ? i.searchParams.set(c, d.join(",")) : i.searchParams.delete(c);
      else if (typeof d == "object")
        try {
          i.searchParams.set(c, JSON.stringify(d));
        } catch (f) {
          console.warn(
            `Failed to stringify URL parameter ${c} as JSON`,
            f
          );
        }
      else
        d ? i.searchParams.set(c, d) : i.searchParams.delete(c);
    window.history.replaceState({}, "", i.toString()), r(a);
  }];
}
const DPe = Re[typeof document < "u" && document.createElement !== void 0 ? "useLayoutEffect" : "useEffect"], $Pe = (e) => {
  const t = S.useRef(e);
  return S.useEffect(() => {
    t.current = e;
  }), t;
};
function zPe() {
}
function jPe(e, t, r = {}) {
  const a = LPe(r.polyfill), i = $Pe(t);
  return DPe(() => {
    let c = !1;
    const d = e && "current" in e ? e.current : e;
    if (!d) return zPe;
    function f(p, g) {
      c || i.current(p, g);
    }
    return a.subscribe(d, f), () => {
      c = !0, a.unsubscribe(d, f);
    };
  }, [e, a, i]), a.observer;
}
function IPe(e) {
  let t = !1, r = [];
  const a = /* @__PURE__ */ new Map(), i = new (e || window.ResizeObserver)((c, d) => {
    r = r.concat(c);
    function f() {
      const p = /* @__PURE__ */ new Set();
      for (let g = 0; g < r.length; g++) {
        if (p.has(r[g].target)) continue;
        p.add(r[g].target);
        const b = a.get(r[g].target);
        b?.forEach((w) => w(r[g], d));
      }
      r = [], t = !1;
    }
    t || window.requestAnimationFrame(f), t = !0;
  });
  return {
    observer: i,
    subscribe(c, d) {
      var f;
      i.observe(c);
      const p = (f = a.get(c)) !== null && f !== void 0 ? f : [];
      p.push(d), a.set(c, p);
    },
    unsubscribe(c, d) {
      var f;
      const p = (f = a.get(c)) !== null && f !== void 0 ? f : [];
      if (p.length === 1) {
        i.unobserve(c), a.delete(c);
        return;
      }
      const g = p.indexOf(d);
      g !== -1 && p.splice(g, 1), a.set(c, p);
    }
  };
}
let pA;
const LPe = (e) => pA || (pA = IPe(e)), HPe = "data:image/svg+xml,%3csvg%20width='208'%20height='29'%20viewBox='0%200%20208%2029'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_2478_2457)'%3e%3cpath%20d='M204.421%207.2706C204.676%207.2706%20204.93%207.26749%20205.184%207.27187C205.321%207.27428%20205.352%207.30891%20205.356%207.43966C205.359%207.49592%20205.358%207.55274%20205.353%207.60872C205.346%207.68575%20205.305%207.7324%20205.228%207.7365C205.087%207.74399%20204.945%207.74017%20204.804%207.74569C204.698%207.74993%20204.672%207.77664%20204.667%207.8811C204.663%207.96563%20204.665%208.0503%20204.665%208.13497C204.665%208.41711%20204.666%208.69939%20204.664%208.98153C204.663%209.25236%20204.662%209.25236%20204.403%209.25236C204.375%209.25236%20204.347%209.25321%20204.318%209.25208C204.152%209.24515%20204.125%209.22169%20204.123%209.04825C204.119%208.70024%20204.123%208.35223%20204.121%208.00422C204.12%207.74597%20204.118%207.74611%20203.85%207.743C203.756%207.74187%20203.662%207.74102%20203.568%207.73763C203.529%207.73622%20203.488%207.71812%20203.476%207.68264C203.436%207.56433%20203.433%207.44277%20203.479%207.32516C203.487%207.3041%20203.522%207.2846%20203.546%207.2805C203.602%207.27145%20203.659%207.27046%20203.715%207.27018C203.95%207.26919%20204.186%207.26975%20204.421%207.26975V7.2706Z'%20fill='%23304764'/%3e%3cpath%20d='M207.68%209.2771C207.645%209.23356%20207.596%209.24572%20207.551%209.24487C207.466%209.24317%20207.381%209.24529%20207.297%209.23865C207.234%209.2337%20207.193%209.19285%20207.191%209.12825C207.186%209.01559%20207.187%208.9028%20207.186%208.79014C207.184%208.6608%20207.184%208.53146%20207.183%208.40778C207.115%208.39152%20207.094%208.42375%20207.08%208.45796C206.99%208.6649%20206.895%208.86972%20206.816%209.0809C206.767%209.21123%20206.682%209.25307%20206.556%209.24473C206.537%209.24345%20206.518%209.24317%20206.499%209.24459C206.392%209.25293%20206.323%209.20755%20206.283%209.10535C206.206%208.9134%20206.123%208.72413%20206.042%208.53401C206.021%208.48467%20206.01%208.42785%20205.953%208.40015C205.898%208.40834%20205.913%208.45584%20205.913%208.48609C205.909%208.68342%20205.913%208.88089%20205.908%209.07821C205.905%209.21094%20205.873%209.24133%20205.735%209.24345C205.332%209.24967%20205.358%209.25985%20205.358%208.88498C205.358%208.45259%20205.358%208.02019%20205.358%207.58794C205.358%207.52221%20205.359%207.45634%20205.361%207.39075C205.364%207.32629%20205.398%207.2771%20205.46%207.27329C205.591%207.26509%20205.723%207.26226%20205.854%207.27046C205.938%207.27569%20205.977%207.34622%20206.009%207.41789C206.134%207.69169%20206.26%207.96464%20206.387%208.23703C206.427%208.32099%20206.453%208.41273%20206.519%208.48058C206.602%208.46277%20206.616%208.39096%20206.644%208.33399C206.765%208.0797%20206.884%207.82385%20207.004%207.56871C207.032%207.5092%20207.062%207.45068%20207.09%207.39117C207.13%207.30594%20207.197%207.26749%20207.291%207.26198C207.421%207.25434%20207.552%207.28318%20207.68%207.24487V9.27724L207.68%209.2771Z'%20fill='%23304764'/%3e%3cpath%20d='M155.158%2014.0372C154.75%2014.0372%20154.342%2014.0372%20153.934%2014.0372C153.872%2014.0372%20153.81%2014.0385%20153.748%2014.0349C153.604%2014.0267%20153.498%2013.9537%20153.424%2013.8332C153.396%2013.7882%20153.376%2013.7386%20153.354%2013.6901C153.055%2013.0087%20152.543%2012.5622%20151.84%2012.3315C151.144%2012.1027%20150.443%2012.1047%20149.75%2012.3408C148.942%2012.6162%20148.362%2013.1541%20148.041%2013.9434C147.635%2014.9437%20147.644%2015.95%20148.11%2016.9306C148.532%2017.8195%20149.26%2018.3254%20150.218%2018.5041C150.851%2018.6223%20151.471%2018.5606%20152.068%2018.3071C152.647%2018.0608%20153.083%2017.6581%20153.329%2017.078C153.451%2016.7925%20153.625%2016.6781%20153.939%2016.6849C154.745%2016.7025%20155.552%2016.6908%20156.359%2016.6909C156.43%2016.6909%20156.501%2016.6876%20156.572%2016.6944C156.733%2016.7099%20156.828%2016.8082%20156.836%2016.9719C156.839%2017.0327%20156.832%2017.096%20156.817%2017.1554C156.474%2018.5896%20155.727%2019.7569%20154.512%2020.6099C153.768%2021.1327%20152.941%2021.4593%20152.044%2021.6074C150.979%2021.7833%20149.92%2021.7604%20148.886%2021.4393C146.837%2020.8036%20145.452%2019.4659%20144.781%2017.4313C144.268%2015.8775%20144.318%2014.3157%20144.96%2012.81C145.852%2010.7168%20147.464%209.49558%20149.701%209.10219C150.72%208.92305%20151.736%208.97957%20152.729%209.27069C154.51%209.79308%20155.791%2010.8925%20156.514%2012.6147C156.648%2012.9338%20156.743%2013.2659%20156.82%2013.6029C156.831%2013.6541%20156.838%2013.7079%20156.836%2013.7602C156.83%2013.9094%20156.742%2014.0082%20156.593%2014.0302C156.524%2014.0404%20156.452%2014.0372%20156.381%2014.0373C155.973%2014.0379%20155.565%2014.0376%20155.158%2014.0376V14.0372Z'%20fill='%23304764'/%3e%3cpath%20d='M171.639%2017.8319C171.639%2018.8231%20171.639%2019.8142%20171.639%2020.8053C171.639%2020.8937%20171.64%2020.9828%20171.63%2021.0702C171.608%2021.2474%20171.505%2021.3625%20171.332%2021.4004C171.255%2021.4172%20171.174%2021.4178%20171.095%2021.418C170.395%2021.4192%20169.694%2021.41%20168.994%2021.4221C168.597%2021.429%20168.462%2021.2549%20168.47%2020.9266C168.478%2020.5997%20168.459%2020.2723%20168.451%2019.9451C168.45%2019.9135%20168.463%2019.8677%20168.414%2019.8589C168.374%2019.8516%20168.355%2019.8882%20168.334%2019.9153C168.191%2020.1071%20168.035%2020.2872%20167.86%2020.4517C167.279%2020.9992%20166.595%2021.3559%20165.821%2021.5409C164.717%2021.805%20163.62%2021.7723%20162.547%2021.3954C161.255%2020.9413%20160.294%2020.085%20159.614%2018.9071C159.197%2018.1856%20158.948%2017.4054%20158.818%2016.5851C158.672%2015.6669%20158.684%2014.751%20158.874%2013.841C159.175%2012.4039%20159.862%2011.1968%20161.041%2010.2953C161.778%209.73209%20162.61%209.36982%20163.517%209.18337C164.823%208.91486%20166.123%208.93268%20167.411%209.29362C168.268%209.53393%20169.038%209.94248%20169.702%2010.5387C170.522%2011.2745%20171.058%2012.1864%20171.365%2013.2383C171.565%2013.9234%20171.639%2014.6252%20171.639%2015.3364C171.639%2016.1683%20171.639%2017.0002%20171.639%2017.832L171.639%2017.8319ZM168.25%2015.2436C168.25%2014.9113%20168.19%2014.4741%20168.027%2014.0569C167.669%2013.1414%20167.03%2012.5241%20166.075%2012.2535C165.607%2012.121%20165.13%2012.0977%20164.652%2012.1811C163.545%2012.3743%20162.754%2012.9781%20162.329%2014.0238C162.025%2014.7696%20161.996%2015.5423%20162.203%2016.3162C162.465%2017.2935%20163.061%2017.9915%20164.013%2018.3636C164.534%2018.5675%20165.079%2018.625%20165.633%2018.5494C166.63%2018.4131%20167.384%2017.9134%20167.864%2017.0206C168.143%2016.5017%20168.251%2015.9416%20168.25%2015.2436H168.25Z'%20fill='%23304764'/%3e%3cpath%20d='M173.525%2020.1053C173.525%2018.4326%20173.525%2016.7599%20173.524%2015.0872C173.524%2014.1721%20173.7%2013.2931%20174.07%2012.4554C174.597%2011.2626%20175.439%2010.3603%20176.594%209.75266C177.366%209.34717%20178.192%209.12708%20179.056%209.04342C179.881%208.96363%20180.702%208.99063%20181.517%209.15088C182.525%209.34917%20183.442%209.74894%20184.244%2010.3967C184.94%2010.9581%20185.461%2011.6544%20185.83%2012.4641C186.233%2013.3473%20186.411%2014.2782%20186.421%2015.2473C186.428%2015.9962%20186.349%2016.7317%20186.142%2017.4512C185.856%2018.4459%20185.381%2019.3376%20184.652%2020.0809C183.609%2021.1449%20182.337%2021.6793%20180.844%2021.6988C180.218%2021.7069%20179.607%2021.6286%20179.011%2021.4368C178.307%2021.2103%20177.687%2020.8454%20177.172%2020.3105C177.148%2020.285%20177.123%2020.2599%20177.099%2020.2331C177.075%2020.2056%20177.045%2020.1771%20177.01%2020.186C176.973%2020.1955%20176.968%2020.2369%20176.968%2020.2728C176.967%2020.3524%20176.966%2020.4321%20176.966%2020.5117C176.966%2022.1756%20176.966%2023.8394%20176.966%2025.5033C176.966%2025.5917%20176.97%2025.6808%20176.96%2025.7685C176.939%2025.9606%20176.827%2026.0706%20176.634%2026.0932C176.572%2026.1004%20176.51%2026.098%20176.448%2026.098C175.641%2026.0983%20174.834%2026.0892%20174.028%2026.102C173.638%2026.1083%20173.519%2025.9516%20173.521%2025.6012C173.529%2023.7692%20173.525%2021.9371%20173.525%2020.1052L173.525%2020.1053ZM180%2018.5787C180.101%2018.5713%20180.19%2018.567%20180.278%2018.5578C181.394%2018.4407%20182.243%2017.9103%20182.729%2016.8896C183.198%2015.9015%20183.195%2014.8825%20182.76%2013.8802C182.454%2013.177%20181.932%2012.6739%20181.22%2012.3779C180.587%2012.1147%20179.931%2012.0612%20179.264%2012.2069C178.245%2012.4295%20177.536%2013.0294%20177.145%2013.9965C176.904%2014.5931%20176.852%2015.2146%20176.927%2015.8487C176.989%2016.3849%20177.159%2016.886%20177.471%2017.329C178.089%2018.2052%20178.968%2018.5618%20180%2018.579L180%2018.5787Z'%20fill='%23304764'/%3e%3cpath%20d='M193.002%2021.6953C192.123%2021.7073%20191.333%2021.5707%20190.575%2021.2667C189.764%2020.9412%20189.072%2020.4471%20188.482%2019.8024C188.276%2019.577%20188.25%2019.3765%20188.391%2019.0733C188.421%2019.0097%20188.462%2018.9508%20188.504%2018.8932C188.766%2018.5256%20189.027%2018.1574%20189.293%2017.7928C189.513%2017.4919%20189.676%2017.4663%20189.984%2017.6902C190.286%2017.9087%20190.59%2018.1218%20190.914%2018.306C191.317%2018.5352%20191.74%2018.715%20192.199%2018.7941C192.569%2018.8577%20192.939%2018.8682%20193.306%2018.772C193.366%2018.7563%20193.425%2018.7361%20193.483%2018.7149C194.223%2018.4434%20194.237%2017.4844%20193.737%2017.1115C193.565%2016.9832%20193.386%2016.8709%20193.19%2016.7874C192.775%2016.6103%20192.357%2016.4391%20191.94%2016.2665C191.629%2016.1379%20191.315%2016.0161%20191.007%2015.8816C190.5%2015.6605%20190.032%2015.3765%20189.63%2014.9927C189.034%2014.4236%20188.704%2013.7282%20188.653%2012.9053C188.622%2012.4148%20188.675%2011.9337%20188.841%2011.4681C189.146%2010.6089%20189.726%209.98986%20190.52%209.56083C191.212%209.18686%20191.958%209.02129%20192.74%209.00187C193.412%208.98525%20194.065%209.07874%20194.7%209.3015C195.536%209.59541%20196.247%2010.0775%20196.839%2010.735C196.857%2010.7547%20196.875%2010.7744%20196.892%2010.7949C197.078%2011.0205%20197.084%2011.1779%20196.894%2011.4103C196.553%2011.8289%20196.207%2012.2437%20195.859%2012.6563C195.677%2012.8719%20195.513%2012.8893%20195.281%2012.7235C195.159%2012.6358%20195.046%2012.536%20194.926%2012.4451C194.578%2012.1821%20194.209%2011.9575%20193.793%2011.8142C193.505%2011.7146%20193.209%2011.6743%20192.904%2011.6937C192.697%2011.7069%20192.502%2011.7616%20192.325%2011.8704C191.859%2012.1568%20191.757%2012.7912%20192.11%2013.2093C192.214%2013.3323%20192.338%2013.4307%20192.476%2013.5138C192.635%2013.6105%20192.805%2013.6863%20192.978%2013.7543C193.572%2013.9869%20194.166%2014.2176%20194.759%2014.4537C195.204%2014.6312%20195.63%2014.8477%20196.02%2015.1294C196.294%2015.3274%20196.542%2015.5534%20196.757%2015.815C197.192%2016.3456%20197.424%2016.9564%20197.473%2017.638C197.512%2018.1825%20197.458%2018.7167%20197.269%2019.2319C196.979%2020.0228%20196.439%2020.6016%20195.721%2021.0233C195.164%2021.3509%20194.556%2021.5325%20193.919%2021.6305C193.594%2021.6805%20193.268%2021.703%20193.002%2021.6956L193.002%2021.6953Z'%20fill='%23304764'/%3e%3cpath%20d='M67.5047%2028.6423C67.3846%2028.4884%2067.3245%2028.3106%2067.3243%2028.1091C67.3243%2025.6925%2067.3253%2023.276%2067.3237%2020.8593C67.3233%2020.1625%2067.4507%2019.4924%2067.7484%2018.8618C68.2265%2017.8485%2069.013%2017.17%2070.0638%2016.7958C70.877%2016.5063%2071.7189%2016.4532%2072.5717%2016.5319C72.985%2016.5701%2073.3917%2016.6475%2073.7847%2016.787C75.1845%2017.2843%2076.0975%2018.2468%2076.4688%2019.6797C76.8014%2020.963%2076.6825%2022.2202%2076.0631%2023.4057C75.5359%2024.4151%2074.724%2025.0949%2073.6109%2025.3786C72.7648%2025.5941%2071.9303%2025.5314%2071.1233%2025.1872C70.871%2025.0796%2070.6387%2024.9369%2070.4273%2024.761C70.4006%2024.7387%2070.3581%2024.712%2070.3306%2024.7185C70.2722%2024.7325%2070.289%2024.7928%2070.2875%2024.8366C70.2848%2024.9118%2070.2865%2024.987%2070.2865%2025.0622C70.2865%2026.0684%2070.2865%2027.0745%2070.2865%2028.0807C70.2865%2028.1465%2070.2844%2028.2124%2070.2865%2028.2781C70.2899%2028.388%2070.2579%2028.4801%2070.1701%2028.5525C70.1426%2028.5751%2070.1268%2028.6119%2070.1056%2028.6421H67.5048L67.5047%2028.6423ZM73.7315%2020.9955C73.7611%2020.1816%2073.2553%2019.3148%2072.1898%2019.1818C71.5465%2019.1014%2070.7026%2019.3728%2070.3583%2020.2469C70.1755%2020.7107%2070.1677%2021.1825%2070.3293%2021.652C70.5625%2022.3293%2071.043%2022.7277%2071.7527%2022.8089C72.4636%2022.8904%2073.0484%2022.6434%2073.4507%2022.0345C73.6582%2021.7202%2073.744%2021.3669%2073.7315%2020.9957V20.9955Z'%20fill='%23F06627'/%3e%3cpath%20d='M60.325%200.357178C60.3999%200.47973%2060.4299%200.609774%2060.4296%200.756215C60.4263%203.31526%2060.4307%205.8743%2060.4249%208.43334C60.4234%209.13685%2060.2911%209.81789%2059.9792%2010.4557C59.4475%2011.5434%2058.5895%2012.2445%2057.4229%2012.5542C56.4329%2012.817%2055.4423%2012.7932%2054.4757%2012.4401C53.2339%2011.9865%2052.4153%2011.1103%2052.0177%209.85874C51.6291%208.6359%2051.6903%207.42027%2052.2314%206.25454C52.8302%204.96442%2053.8437%204.20309%2055.268%204.00972C55.8171%203.93523%2056.3584%203.97156%2056.8921%204.1163C57.5859%204.30458%2058.1631%204.67464%2058.6196%205.23072C58.6674%205.28896%2058.7122%205.3496%2058.7608%205.40699C58.7712%205.41929%2058.7943%205.43059%2058.8087%205.42777C58.839%205.42169%2058.8498%205.39455%2058.8501%205.36487C58.851%205.2802%2058.8517%205.19553%2058.8517%205.11086C58.8517%203.71839%2058.8517%202.32607%2058.8517%200.933612C58.8517%200.830143%2058.8616%200.725542%2058.85%200.623486C58.8388%200.523973%2058.933%200.454994%2058.9115%200.357178H60.3249L60.325%200.357178ZM58.8855%208.36238C58.886%207.93776%2058.8251%207.53519%2058.6805%207.14562C58.4271%206.46261%2057.9821%205.94893%2057.3085%205.64969C56.8066%205.42678%2056.2819%205.3561%2055.7366%205.43116C54.7944%205.56092%2054.074%206.02427%2053.6462%206.87719C53.1857%207.79528%2053.1801%208.74516%2053.5795%209.68629C53.873%2010.3779%2054.3896%2010.8536%2055.1%2011.1094C55.6259%2011.2988%2056.1674%2011.3381%2056.7136%2011.2269C57.7493%2011.016%2058.4097%2010.3832%2058.7355%209.3903C58.8447%209.05727%2058.8825%208.71181%2058.8857%208.36224L58.8855%208.36238Z'%20fill='%23304764'/%3e%3cpath%20d='M62.9265%200.357178C62.9232%200.454145%2063.0141%200.436476%2063.0633%200.46192C63.3622%200.616842%2063.5302%200.862937%2063.5744%201.19102C63.6386%201.66667%2063.3108%202.12493%2062.8496%202.21596C62.3766%202.30925%2061.9024%202.02839%2061.7751%201.5656C61.6411%201.07779%2061.8755%200.665467%2062.2481%200.470684C62.3073%200.439728%2062.3986%200.449905%2062.4177%200.357319H62.9266L62.9265%200.357178Z'%20fill='%23304764'/%3e%3cpath%20d='M89.7171%2024.4482C89.6526%2024.4316%2089.6313%2024.4682%2089.6084%2024.4943C89.1112%2025.059%2088.466%2025.3472%2087.7391%2025.4522C86.7092%2025.601%2085.7536%2025.3958%2084.9025%2024.7778C84.3416%2024.3706%2083.9208%2023.8446%2083.6377%2023.2161C83.0773%2021.9725%2082.9962%2020.6896%2083.414%2019.3937C83.8535%2018.0308%2084.804%2017.165%2086.1595%2016.7388C86.943%2016.4924%2087.7497%2016.4533%2088.5632%2016.537C89.1484%2016.5972%2089.7087%2016.7438%2090.2378%2017.0102C91.2517%2017.5208%2091.915%2018.3239%2092.2563%2019.3978C92.4083%2019.8759%2092.4767%2020.3673%2092.4757%2020.8697C92.4732%2022.1672%2092.4749%2023.4646%2092.4749%2024.7621C92.4749%2024.828%2092.4776%2024.8939%2092.4739%2024.9596C92.4633%2025.1487%2092.3696%2025.2533%2092.1838%2025.2806C92.1283%2025.2888%2092.0712%2025.2872%2092.0148%2025.2872C91.4027%2025.2877%2090.7908%2025.2875%2090.1787%2025.2875C90.1693%2025.2875%2090.1599%2025.2877%2090.1505%2025.2875C89.8374%2025.2799%2089.7565%2025.1989%2089.7472%2024.8786C89.743%2024.7322%2089.7531%2024.5846%2089.7171%2024.4485V24.4482ZM89.5624%2020.9979C89.5656%2020.0363%2088.9705%2019.3025%2088.0549%2019.1856C87.1607%2019.0714%2086.3161%2019.5859%2086.0982%2020.5056C86.05%2020.7088%2086.034%2020.9142%2086.0466%2021.121C86.132%2022.522%2087.4485%2023.1185%2088.5138%2022.6906C88.8194%2022.5678%2089.0604%2022.3634%2089.2434%2022.091C89.4655%2021.7608%2089.5575%2021.3919%2089.5624%2020.9979Z'%20fill='%23F06627'/%3e%3cpath%20d='M37.7197%2022.6775C37.7197%2023.3544%2037.7197%2024.0315%2037.7197%2024.7086C37.7197%2024.7744%2037.7213%2024.8403%2037.719%2024.906C37.7097%2025.1746%2037.6127%2025.2771%2037.3382%2025.2851C37.0747%2025.2929%2036.811%2025.2872%2036.5473%2025.2872C36.1896%2025.2872%2035.8317%2025.2877%2035.4739%2025.287C35.3987%2025.2868%2035.3224%2025.2896%2035.2485%2025.279C35.0976%2025.2571%2035.0123%2025.1723%2034.9957%2025.0195C34.9836%2024.9079%2034.9915%2024.7941%2034.9857%2024.6816C34.9824%2024.6167%2034.9737%2024.5515%2034.9597%2024.4882C34.953%2024.4584%2034.9161%2024.4495%2034.892%2024.464C34.8606%2024.4828%2034.8336%2024.5107%2034.8084%2024.5381C34.4071%2024.9758%2033.905%2025.2427%2033.3343%2025.3774C32.1492%2025.657%2031.0527%2025.4603%2030.0716%2024.7247C29.5258%2024.3153%2029.1214%2023.7848%2028.8493%2023.163C28.328%2021.972%2028.2459%2020.7423%2028.6162%2019.4976C28.9844%2018.2605%2029.7835%2017.3944%2030.9749%2016.8895C31.4835%2016.6739%2032.017%2016.5647%2032.5635%2016.5209C33.2528%2016.4657%2033.9384%2016.5012%2034.6091%2016.6824C35.6913%2016.9749%2036.555%2017.5688%2037.1232%2018.5501C37.4828%2019.1711%2037.6724%2019.8457%2037.7074%2020.5621C37.718%2020.778%2037.7183%2020.9944%2037.719%2021.2105C37.7206%2021.6994%2037.7196%2022.1884%2037.7196%2022.6773L37.7197%2022.6775ZM33.0647%2022.825C33.8631%2022.8229%2034.4982%2022.3463%2034.7163%2021.5818C34.8023%2021.28%2034.825%2020.9729%2034.7741%2020.6618C34.6635%2019.9846%2034.3097%2019.4917%2033.6488%2019.2717C32.9718%2019.0465%2032.3434%2019.1644%2031.815%2019.6586C31.4034%2020.0436%2031.2561%2020.5461%2031.2838%2021.0928C31.3409%2022.2175%2032.1637%2022.8304%2033.0646%2022.825H33.0647Z'%20fill='%23F06627'/%3e%3cpath%20d='M93.4903%2020.9634C93.4903%2019.7216%2093.4903%2018.4797%2093.4904%2017.2379C93.4904%2017.1532%2093.486%2017.0677%2093.4964%2016.9842C93.5164%2016.8215%2093.6092%2016.7323%2093.7713%2016.7104C93.8177%2016.7041%2093.8653%2016.7057%2093.9124%2016.7057C94.6002%2016.7054%2095.2879%2016.7054%2095.9757%2016.7057C96.0228%2016.7057%2096.0702%2016.706%2096.1166%2016.7122C96.2558%2016.731%2096.319%2016.7843%2096.3483%2016.9198C96.3661%2017.0021%2096.3708%2017.0873%2096.3791%2017.1713C96.3986%2017.3678%2096.4164%2017.5644%2096.4361%2017.7609C96.4387%2017.7873%2096.4457%2017.8224%2096.4786%2017.8198C96.5019%2017.818%2096.5296%2017.7988%2096.5448%2017.7793C96.6422%2017.6525%2096.7294%2017.5173%2096.8333%2017.3963C97.2559%2016.9047%2097.7901%2016.6089%2098.4349%2016.5298C99.2394%2016.4312%2099.9928%2016.5677%20100.663%2017.0499C101.211%2017.4441%20101.563%2017.9791%20101.772%2018.6118C101.914%2019.0432%20101.988%2019.4879%20101.988%2019.9432C101.989%2021.5802%20101.989%2023.2171%20101.989%2024.8541C101.989%2024.8729%20101.989%2024.8917%20101.989%2024.9105C101.982%2025.1864%20101.894%2025.2811%20101.611%2025.2848C101.131%2025.2911%20100.65%2025.2868%20100.17%2025.2868C99.9341%2025.2868%2099.6985%2025.2885%2099.463%2025.2856C99.3882%2025.2848%2099.3119%2025.2797%2099.2395%2025.2629C99.1277%2025.2372%2099.0591%2025.1622%2099.0502%2025.0455C99.0437%2024.9612%2099.0456%2024.8763%2099.0456%2024.7917C99.0453%2023.5312%2099.0454%2022.2704%2099.0454%2021.0099C99.0454%2020.784%2099.043%2020.5581%2099.0044%2020.3349C98.9868%2020.2331%2098.9684%2020.1304%2098.9369%2020.0324C98.7715%2019.5187%2098.4188%2019.2493%2097.8745%2019.211C97.7808%2019.2044%2097.6855%2019.2044%2097.592%2019.2136C97.0839%2019.2637%2096.7311%2019.5203%2096.5638%2020.0087C96.4809%2020.2508%2096.4509%2020.5031%2096.4508%2020.759C96.4508%2021.1728%2096.4508%2021.5869%2096.4508%2022.0007C96.4508%2022.9226%2096.4508%2023.8447%2096.4508%2024.7666C96.4508%2024.8325%2096.4536%2024.8985%2096.4496%2024.9641C96.4372%2025.1759%2096.3484%2025.2656%2096.1337%2025.2845C96.0869%2025.2886%2096.0396%2025.2866%2095.9925%2025.2866C95.3142%2025.2866%2094.6358%2025.2866%2093.9575%2025.2866C93.9009%2025.2866%2093.8439%2025.2887%2093.7881%2025.2825C93.6008%2025.262%2093.5162%2025.1816%2093.4964%2024.9987C93.4872%2024.9149%2093.4906%2024.8296%2093.4906%2024.745C93.4903%2023.4844%2093.4904%2022.2237%2093.4903%2020.9631V20.9634Z'%20fill='%23F06627'/%3e%3cpath%20d='M117.833%2022.1258C117.136%2022.1258%20116.439%2022.1258%20115.742%2022.126C115.667%2022.126%20115.592%2022.127%20115.517%2022.1314C115.468%2022.1342%20115.438%2022.188%20115.46%2022.2345C115.489%2022.2934%20115.52%2022.3518%20115.556%2022.4066C115.737%2022.6842%20115.991%2022.8708%20116.295%2022.9944C116.47%2023.0656%20116.653%2023.1109%20116.84%2023.137C117.433%2023.2196%20118.022%2023.219%20118.605%2023.0619C118.788%2023.0128%20118.961%2022.94%20119.133%2022.8643C119.194%2022.8379%20119.252%2022.8072%20119.313%2022.7822C119.411%2022.7419%20119.497%2022.7624%20119.568%2022.8427C119.58%2022.8568%20119.592%2022.8711%20119.603%2022.8864C119.867%2023.2526%20120.135%2023.6166%20120.394%2023.9862C120.508%2024.1498%20120.492%2024.2585%20120.344%2024.4126C120.033%2024.7361%20119.662%2024.973%20119.247%2025.1417C118.871%2025.2947%20118.481%2025.3996%20118.077%2025.4488C117.312%2025.5418%20116.555%2025.5131%20115.809%2025.309C115.222%2025.1484%20114.679%2024.8971%20114.194%2024.5248C113.452%2023.9549%20112.953%2023.2171%20112.703%2022.3198C112.396%2021.2148%20112.439%2020.1177%20112.896%2019.0618C113.513%2017.6361%20114.626%2016.8251%20116.148%2016.5647C116.766%2016.4588%20117.387%2016.4664%20118%2016.6092C119.566%2016.9743%20120.552%2017.9468%20120.978%2019.4878C121.12%2020.0005%20121.139%2020.5265%20121.095%2021.0549C121.081%2021.2245%20121.043%2021.3899%20120.98%2021.5479C120.856%2021.8626%20120.626%2022.0523%20120.289%2022.0988C120.159%2022.1167%20120.026%2022.1239%20119.895%2022.1244C119.207%2022.1268%20118.52%2022.1255%20117.833%2022.1255L117.833%2022.1258ZM116.926%2020.1071C116.973%2020.1071%20117.02%2020.1071%20117.067%2020.1071C117.5%2020.1068%20117.933%2020.1077%20118.366%2020.1056C118.456%2020.1051%20118.489%2020.0632%20118.468%2019.9829C118.328%2019.4462%20118.004%2019.0921%20117.453%2018.9603C117.239%2018.9092%20117.023%2018.92%20116.807%2018.9224C116.558%2018.9251%20116.323%2018.9937%20116.103%2019.1072C115.741%2019.2942%20115.512%2019.5939%20115.39%2019.9778C115.365%2020.0574%20115.398%2020.0993%20115.486%2020.1046C115.533%2020.1074%20115.58%2020.1068%20115.627%2020.107C116.06%2020.1071%20116.493%2020.107%20116.926%2020.107L116.926%2020.1071Z'%20fill='%23F06627'/%3e%3cpath%20d='M63.2043%2022.1254C62.4976%2022.1254%2061.791%2022.1245%2061.0845%2022.1266C61.0037%2022.1269%2060.895%2022.0897%2060.8492%2022.1685C60.7934%2022.2645%2060.8927%2022.3408%2060.9416%2022.4161C61.1223%2022.6943%2061.3797%2022.8776%2061.685%2022.9986C61.9057%2023.086%2062.1362%2023.1341%2062.3707%2023.1602C62.7464%2023.202%2063.1236%2023.202%2063.4988%2023.1594C63.8381%2023.1208%2064.1624%2023.0224%2064.473%2022.8806C64.5245%2022.8571%2064.5741%2022.8299%2064.6261%2022.8078C64.8075%2022.7304%2064.8758%2022.7417%2064.9901%2022.8973C65.2465%2023.246%2065.4993%2023.5976%2065.7479%2023.9519C65.8884%2024.1521%2065.877%2024.2455%2065.708%2024.423C65.3633%2024.7853%2064.9418%2025.0268%2064.4764%2025.1991C63.738%2025.4726%2062.9727%2025.5303%2062.1947%2025.4785C61.4607%2025.4298%2060.7649%2025.2388%2060.1221%2024.8805C58.9179%2024.209%2058.2082%2023.1791%2057.9672%2021.8314C57.8032%2020.9138%2057.8773%2020.0089%2058.2364%2019.1437C58.8%2017.7857%2059.8151%2016.9473%2061.2455%2016.6176C61.9427%2016.4569%2062.6485%2016.4477%2063.3484%2016.6037C64.8587%2016.9404%2065.8459%2017.8529%2066.3089%2019.3266C66.4774%2019.8627%2066.5149%2020.4154%2066.4798%2020.9733C66.4663%2021.19%2066.4216%2021.4015%2066.3315%2021.6017C66.2107%2021.8706%2066.0052%2022.0329%2065.7172%2022.0913C65.5783%2022.1194%2065.4375%2022.1265%2065.2956%2022.1262C64.5984%2022.1249%2063.9013%2022.1257%2063.2041%2022.1257L63.2043%2022.1254ZM62.3014%2020.1067C62.6584%2020.1067%2063.0151%2020.107%2063.372%2020.1067C63.5035%2020.1066%2063.635%2020.107%2063.7663%2020.1029C63.8353%2020.1008%2063.8621%2020.0596%2063.8443%2019.988C63.7194%2019.4856%2063.4279%2019.1336%2062.9196%2018.9856C62.5786%2018.8864%2062.2322%2018.8974%2061.8878%2018.9637C61.7693%2018.9866%2061.6515%2019.0275%2061.5414%2019.0777C61.1411%2019.2599%2060.8934%2019.5769%2060.7614%2019.9898C60.7392%2020.0594%2060.7665%2020.0992%2060.8368%2020.104C60.8835%2020.1071%2060.9306%2020.1067%2060.9775%2020.1067C61.4188%2020.1069%2061.8603%2020.1067%2062.3016%2020.1069L62.3014%2020.1067Z'%20fill='%23F06627'/%3e%3cpath%20d='M45.9499%2020.178C45.573%2020.178%2045.196%2020.1742%2044.8192%2020.1795C44.6418%2020.1821%2044.5133%2020.1261%2044.4293%2019.9606C44.2172%2019.5423%2043.8587%2019.3242%2043.4078%2019.2394C43.0348%2019.1691%2042.6756%2019.2123%2042.3329%2019.3742C42.0624%2019.5022%2041.8367%2019.6892%2041.6897%2019.9497C41.2973%2020.645%2041.2944%2021.3501%2041.6885%2022.0443C41.8661%2022.3571%2042.145%2022.5668%2042.4859%2022.687C42.8627%2022.8197%2043.2434%2022.824%2043.6241%2022.7051C43.9715%2022.5965%2044.2493%2022.3921%2044.4144%2022.065C44.5079%2021.8797%2044.6371%2021.8099%2044.8404%2021.8117C45.5848%2021.8185%2046.3293%2021.8232%2047.0735%2021.8099C47.3577%2021.8048%2047.4604%2021.9415%2047.3883%2022.2153C47.0102%2023.6513%2046.1678%2024.683%2044.7576%2025.2001C43.5265%2025.6514%2042.2949%2025.6161%2041.1009%2025.0654C39.9133%2024.5175%2039.1392%2023.5915%2038.7685%2022.3436C38.4312%2021.2086%2038.4962%2020.0847%2039.0116%2019.0149C39.6851%2017.6167%2040.814%2016.8019%2042.3467%2016.5577C43.1611%2016.4279%2043.9654%2016.4946%2044.7398%2016.7865C46.1312%2017.3111%2046.985%2018.321%2047.3717%2019.7413C47.3914%2019.8136%2047.4062%2019.8889%2047.4086%2019.9634C47.4123%2020.0779%2047.3375%2020.1586%2047.2218%2020.1726C47.1566%2020.1804%2047.0902%2020.178%2047.0242%2020.178C46.6661%2020.1784%2046.3081%2020.1781%2045.95%2020.178H45.9499Z'%20fill='%23F06627'/%3e%3cpath%20d='M110.248%2020.1776C109.871%2020.1776%20109.495%2020.1738%20109.118%2020.1793C108.938%2020.182%20108.816%2020.117%20108.733%2019.9532C108.525%2019.5445%20108.176%2019.3242%20107.735%2019.2439C107.116%2019.1312%20106.576%2019.2815%20106.144%2019.7534C105.922%2019.9966%20105.795%2020.2926%20105.745%2020.6122C105.685%2020.9966%20105.701%2021.3803%20105.847%2021.7508C106.298%2022.8932%20107.581%2022.9863%20108.274%2022.5478C108.47%2022.4242%20108.628%2022.2639%20108.726%2022.0548C108.808%2021.8784%20108.936%2021.8103%20109.129%2021.8117C109.882%2021.8172%20110.636%2021.8125%20111.39%2021.8148C111.684%2021.8156%20111.768%2021.9163%20111.697%2022.1987C111.341%2023.6167%20110.514%2024.6461%20109.135%2025.1745C107.872%2025.6583%20106.603%2025.6305%20105.375%2025.0467C104.092%2024.437%20103.305%2023.4109%20102.999%2022.0328C102.763%2020.9722%20102.865%2019.9348%20103.348%2018.9517C103.899%2017.8278%20104.786%2017.0761%20105.978%2016.7101C107.128%2016.3573%20108.274%2016.415%20109.37%2016.9207C110.626%2017.4999%20111.376%2018.5018%20111.7%2019.8335C111.711%2019.8785%20111.718%2019.9263%20111.716%2019.9727C111.713%2020.077%20111.649%2020.153%20111.548%2020.1686C111.483%2020.1785%20111.417%2020.1771%20111.351%2020.1772C110.983%2020.1779%20110.616%2020.1775%20110.248%2020.1775L110.248%2020.1776Z'%20fill='%23F06627'/%3e%3cpath%20d='M55.6563%2020.1774C55.3077%2020.1774%2054.959%2020.1775%2054.6104%2020.1774C54.5445%2020.1774%2054.4782%2020.1788%2054.4126%2020.1735C54.3131%2020.1658%2054.2337%2020.1194%2054.1786%2020.0349C54.1684%2020.0192%2054.1603%2020.0019%2054.1521%2019.985C53.8269%2019.3035%2053.014%2019.1172%2052.4419%2019.2423C51.7446%2019.3947%2051.322%2019.8293%2051.1629%2020.5184C51.0722%2020.9115%2051.089%2021.3044%2051.2208%2021.6874C51.6235%2022.859%2052.9498%2023.0236%2053.7086%2022.5237C53.8933%2022.402%2054.0399%2022.2419%2054.1329%2022.0419C54.2109%2021.8741%2054.3329%2021.811%2054.5136%2021.812C55.2767%2021.8162%2056.04%2021.8137%2056.8032%2021.8141C56.8501%2021.8141%2056.8979%2021.8141%2056.9437%2021.8227C57.0438%2021.8414%2057.1143%2021.917%2057.1132%2022.0185C57.1123%2022.1021%2057.1023%2022.1885%2057.0797%2022.2689C56.5919%2023.9992%2055.4683%2025.0595%2053.7025%2025.4106C52.8474%2025.5807%2051.9945%2025.5288%2051.1711%2025.2156C49.6044%2024.6196%2048.6733%2023.4809%2048.3555%2021.8505C48.1731%2020.9142%2048.2782%2019.996%2048.666%2019.1165C49.0424%2018.2629%2049.6334%2017.6006%2050.4331%2017.1202C51.8092%2016.2937%2053.6421%2016.3411%2054.8843%2016.9729C55.71%2017.3929%2056.3302%2018.0137%2056.7416%2018.8421C56.8757%2019.1123%2056.9845%2019.3927%2057.063%2019.6845C57.0727%2019.7208%2057.0839%2019.7567%2057.0927%2019.7933C57.1655%2020.0972%2057.0428%2020.1867%2056.7865%2020.1799C56.4099%2020.1699%2056.0328%2020.1774%2055.6558%2020.1774H55.6563Z'%20fill='%23F06627'/%3e%3cpath%20d='M78.192%2021.0156C78.192%2020.4514%2078.192%2019.8873%2078.192%2019.3232C78.192%2019.248%2078.1937%2019.1726%2078.1896%2019.0976C78.1851%2019.0121%2078.1561%2018.9821%2078.0658%2018.9807C77.8304%2018.9771%2077.5951%2018.9786%2077.3596%2018.978C77.2843%2018.9777%2077.2086%2018.9815%2077.1337%2018.9756C76.9871%2018.964%2076.9077%2018.8974%2076.8814%2018.7559C76.866%2018.6735%2076.863%2018.5879%2076.8626%2018.5036C76.8609%2018.0617%2076.8609%2017.6197%2076.8626%2017.1779C76.8629%2017.0936%2076.8677%2017.0085%2076.8806%2016.9253C76.8982%2016.8109%2076.9716%2016.7397%2077.0845%2016.7199C77.158%2016.707%2077.2344%2016.7066%2077.3094%2016.706C77.5542%2016.7042%2077.7991%2016.7072%2078.0439%2016.7035C78.1635%2016.7018%2078.19%2016.6739%2078.1906%2016.5496C78.1927%2016.023%2078.1917%2015.4965%2078.1923%2014.9699C78.1923%2014.8854%2078.1885%2014.8%2078.1975%2014.7164C78.2151%2014.5525%2078.3034%2014.4646%2078.4686%2014.4411C78.5242%2014.4332%2078.5813%2014.4346%2078.6377%2014.4346C79.3344%2014.4342%2080.0313%2014.4342%2080.728%2014.4346C80.7937%2014.4346%2080.8605%2014.4337%2080.9251%2014.444C81.078%2014.4681%2081.1573%2014.5494%2081.1771%2014.7046C81.1866%2014.7788%2081.1829%2014.8547%2081.1829%2014.9299C81.1833%2015.4189%2081.1829%2015.9078%2081.1835%2016.3968C81.1835%2016.4718%2081.1846%2016.5473%2081.1915%2016.6219C81.1952%2016.6614%2081.2259%2016.6903%2081.2656%2016.6947C81.3308%2016.7021%2081.3966%2016.7046%2081.4622%2016.7049C81.7353%2016.7059%2082.0084%2016.7049%2082.2813%2016.7058C82.3472%2016.7059%2082.4138%2016.7039%2082.4785%2016.7134C82.6286%2016.7353%2082.7123%2016.8252%2082.7262%2016.9753C82.7314%2017.0313%2082.7284%2017.0881%2082.7284%2017.1445C82.7284%2017.6146%2082.7284%2018.0848%2082.7284%2018.5549C82.7284%2018.5737%2082.7267%2018.5927%2082.7286%2018.6113C82.7539%2018.8651%2082.6176%2018.9906%2082.3563%2018.9804C82.0648%2018.9691%2081.7726%2018.9777%2081.4807%2018.9781C81.4149%2018.9781%2081.3488%2018.9774%2081.2833%2018.9825C81.2325%2018.9865%2081.1949%2019.014%2081.1897%2019.069C81.1852%2019.1157%2081.1835%2019.1627%2081.1833%2019.2095C81.183%2020.2155%2081.183%2021.2217%2081.1833%2022.2277C81.1833%2022.2653%2081.182%2022.303%2081.1854%2022.3405C81.2093%2022.6103%2081.3479%2022.7945%2081.6017%2022.8911C81.6994%2022.9282%2081.8007%2022.9465%2081.9056%2022.9463C82.075%2022.9459%2082.2443%2022.9472%2082.4136%2022.9476C82.6537%2022.9483%2082.7536%2023.0282%2082.7569%2023.2567C82.7641%2023.755%2082.7594%2024.2534%2082.7593%2024.7517C82.7593%2024.9422%2082.6602%2025.0691%2082.4962%2025.1524C82.3096%2025.2471%2082.11%2025.3022%2081.9042%2025.3307C81.2838%2025.416%2080.6658%2025.4215%2080.0565%2025.2519C79.8661%2025.1989%2079.6803%2025.1313%2079.5035%2025.0413C78.8675%2024.718%2078.4833%2024.1979%2078.3038%2023.5165C78.2169%2023.1866%2078.1919%2022.8501%2078.1919%2022.5107C78.192%2022.0124%2078.1919%2021.514%2078.1919%2021.0157L78.192%2021.0156Z'%20fill='%23F06627'/%3e%3cpath%20d='M47.5309%208.91533C46.5984%208.91533%2045.6659%208.9159%2044.7334%208.91505C44.478%208.91477%2044.4471%208.91265%2044.5062%209.18192C44.7064%2010.0944%2045.2046%2010.7733%2046.0731%2011.1569C46.3769%2011.291%2046.6966%2011.3698%2047.0263%2011.4061C47.6625%2011.4762%2048.286%2011.426%2048.8903%2011.2017C49.1297%2011.1128%2049.356%2010.9986%2049.5724%2010.864C49.6444%2010.8193%2049.7136%2010.7697%2049.7877%2010.7289C49.9244%2010.6535%2050.0086%2010.667%2050.1065%2010.7942C50.2326%2010.9582%2050.3527%2011.1271%2050.4672%2011.2994C50.5343%2011.4004%2050.5212%2011.4887%2050.4412%2011.5838C50.4051%2011.6268%2050.3616%2011.6635%2050.3206%2011.7022C49.937%2012.0641%2049.4879%2012.3199%2048.9882%2012.4759C47.8549%2012.8298%2046.7201%2012.829%2045.6093%2012.3937C44.3226%2011.8895%2043.4919%2010.9505%2043.1179%209.62662C42.8339%208.62146%2042.8578%207.61122%2043.2365%206.63278C43.807%205.15932%2044.8866%204.28887%2046.449%204.02751C46.983%203.93817%2047.5194%203.94821%2048.0502%204.06044C49.4615%204.3587%2050.3882%205.21049%2050.8756%206.55206C51.0643%207.07153%2051.1207%207.6132%2051.0924%208.16348C51.0872%208.2661%2051.0686%208.36915%2051.0456%208.46965C50.9861%208.72974%2050.8153%208.8718%2050.554%208.90516C50.4704%208.9159%2050.3849%208.91477%2050.3004%208.91491C49.3774%208.91547%2048.4542%208.91533%2047.5312%208.91533H47.5309ZM47.0872%207.75469C47.8491%207.75469%2048.611%207.75469%2049.3727%207.75469C49.4479%207.75469%2049.5232%207.75554%2049.5983%207.75087C49.6684%207.74649%2049.7042%207.71143%2049.6967%207.64274C49.6814%207.50308%2049.6687%207.36159%2049.6355%207.22547C49.3962%206.24278%2048.7988%205.61009%2047.8034%205.36993C47.4697%205.28936%2047.1313%205.29261%2046.7939%205.32456C46.2656%205.37474%2045.7906%205.56542%2045.382%205.90651C44.8828%206.3235%2044.6214%206.87505%2044.4989%207.50096C44.4524%207.73872%2044.4655%207.75384%2044.7168%207.75426C45.5069%207.7554%2046.297%207.75469%2047.087%207.75469H47.0872Z'%20fill='%23304764'/%3e%3cpath%20d='M36.345%207.24157C36.1755%207.24157%2036.0059%207.2396%2035.8364%207.24214C35.6845%207.2444%2035.5876%207.17288%2035.5373%207.03266C35.5278%207.00608%2035.5175%206.97979%2035.5073%206.9535C35.2362%206.24773%2034.7299%205.78381%2034.0173%205.55467C33.1991%205.29148%2032.3989%205.35664%2031.638%205.7643C31.0766%206.0651%2030.6821%206.52322%2030.4509%207.11351C30.1781%207.81009%2030.142%208.5283%2030.3443%209.24539C30.6582%2010.3585%2031.4027%2011.0179%2032.5406%2011.2204C33.1272%2011.3247%2033.705%2011.2703%2034.2581%2011.0348C34.841%2010.7866%2035.2525%2010.3681%2035.4918%209.78168C35.5809%209.56315%2035.7466%209.45364%2035.9886%209.45317C36.2336%209.45275%2036.4784%209.45275%2036.7234%209.45331C36.7893%209.45346%2036.8557%209.45134%2036.9207%209.45968C37.0276%209.47325%2037.0847%209.54265%2037.0901%209.65135C37.0939%209.72825%2037.0703%209.79935%2037.0492%209.87186C36.7375%2010.9401%2036.0836%2011.7329%2035.1018%2012.249C33.7435%2012.963%2031.8388%2012.8776%2030.5296%2011.953C29.5669%2011.2729%2028.9851%2010.3477%2028.7771%209.19238C28.6205%208.32235%2028.6776%207.46237%2029.0214%206.64295C29.6568%205.12836%2030.805%204.25692%2032.4295%204.02058C33.3167%203.89152%2034.1803%203.99937%2034.9962%204.37749C36.0457%204.86403%2036.7436%205.6614%2037.0546%206.78317C37.0747%206.8554%2037.0951%206.9289%2037.1017%207.00311C37.113%207.13302%2037.041%207.21698%2036.9097%207.23634C36.8635%207.24313%2036.8158%207.24172%2036.7688%207.24186C36.6274%207.24242%2036.4862%207.24214%2036.3449%207.24214V7.24157H36.345Z'%20fill='%23304764'/%3e%3cpath%20d='M65.8133%208.23359C65.8133%207.38703%2065.8138%206.54033%2065.8129%205.69377C65.8126%205.44258%2065.8108%205.44159%2065.5703%205.44018C65.3254%205.43877%2065.0804%205.44258%2064.8356%205.43891C64.5761%205.43509%2064.4915%205.3565%2064.4845%205.10715C64.4785%204.90036%2064.4831%204.69327%2064.4836%204.48633C64.4836%204.45821%2064.4857%204.42979%2064.4904%204.40209C64.5127%204.26922%2064.579%204.19868%2064.7098%204.18172C64.7841%204.17197%2064.8602%204.17508%2064.9355%204.17479C65.1805%204.17366%2065.4255%204.17592%2065.6703%204.17211C65.7736%204.17055%2065.8071%204.13663%2065.8108%204.03811C65.8153%203.91598%2065.8133%203.79357%2065.8133%203.6713C65.8135%203.24795%2065.8133%202.82474%2065.8135%202.40139C65.8135%202.33552%2065.8104%202.26936%2065.8167%202.20406C65.8316%202.04914%2065.8923%201.98623%2066.0519%201.9827C66.3438%201.97634%2066.636%201.97959%2066.928%201.97959C67.0128%201.97959%2067.0979%201.97761%2067.1822%201.98482C67.2814%201.9933%2067.3389%202.04292%2067.3562%202.14017C67.3693%202.21353%2067.3703%202.28958%2067.3705%202.36449C67.3716%202.86304%2067.371%203.36159%2067.3712%203.86014C67.3712%204.18441%2067.3551%204.17522%2067.6734%204.17479C67.9937%204.17437%2068.314%204.17267%2068.6343%204.1755C68.9448%204.17819%2068.9925%204.22738%2068.9947%204.53779C68.9963%204.74473%2068.9993%204.95181%2068.9932%205.15861C68.9873%205.35664%2068.9149%205.43226%2068.7173%205.43735C68.4348%205.44456%2068.1521%205.43976%2067.8694%205.44018C67.747%205.44032%2067.6245%205.4382%2067.5021%205.44174C67.3965%205.4447%2067.3774%205.46661%2067.3726%205.5797C67.3698%205.64542%2067.3713%205.71144%2067.3713%205.77716C67.3713%207.28229%2067.3713%208.78741%2067.3713%2010.2925C67.3713%2010.3677%2067.3693%2010.4432%2067.373%2010.5183C67.3979%2011.0366%2067.6455%2011.2728%2068.1594%2011.2655C68.2816%2011.2638%2068.4038%2011.2526%2068.526%2011.2458C68.5824%2011.2427%2068.6388%2011.2363%2068.6952%2011.2373C68.8995%2011.2407%2068.9701%2011.3048%2068.9783%2011.5032C68.9843%2011.6441%2068.9802%2011.7853%2068.9803%2011.9264C68.9803%2012.0016%2068.9779%2012.077%2068.9803%2012.1522C68.9846%2012.2908%2068.9178%2012.3882%2068.798%2012.4446C68.7051%2012.4884%2068.607%2012.528%2068.5068%2012.5485C68.0396%2012.6438%2067.5693%2012.6551%2067.1054%2012.5393C66.489%2012.3855%2066.0812%2012.0036%2065.9073%2011.386C65.8406%2011.1491%2065.813%2010.9068%2065.8133%2010.6609C65.8142%209.85193%2065.8136%209.04283%2065.8136%208.23387L65.8133%208.23359Z'%20fill='%23304764'/%3e%3cpath%20d='M40.0823%205.1781C40.1421%205.18927%2040.1534%205.15888%2040.1664%205.13683C40.1999%205.08029%2040.229%205.02106%2040.2614%204.96381C40.7788%204.04827%2041.6304%203.87059%2042.3971%204.01859C42.4522%204.02919%2042.5068%204.04601%2042.5594%204.06594C42.7915%204.15344%2042.8541%204.2391%2042.8566%204.48491C42.8595%204.75758%2042.8603%205.03039%2042.8557%205.30292C42.853%205.45883%2042.8004%205.50717%2042.6483%205.49911C42.5646%205.49473%2042.4816%205.47367%2042.3985%205.45841C42.1381%205.41077%2041.8792%205.38575%2041.6133%205.42858C41.053%205.51876%2040.6405%205.81122%2040.3705%206.30539C40.1724%206.66824%2040.0967%207.06332%2040.0798%207.47169C40.0751%207.58434%2040.0785%207.69729%2040.0784%207.81023C40.0784%209.21131%2040.0784%2010.6123%2040.0784%2012.0133C40.0784%2012.0885%2040.0809%2012.1639%2040.0772%2012.2389C40.0671%2012.4436%2040.0043%2012.5154%2039.8057%2012.5195C39.4762%2012.526%2039.1466%2012.526%2038.8171%2012.5199C38.6046%2012.516%2038.5324%2012.438%2038.5209%2012.2276C38.5178%2012.1714%2038.5198%2012.1148%2038.5198%2012.0584C38.5198%209.58547%2038.5198%207.11251%2038.5198%204.63941C38.5198%204.56421%2038.516%204.48845%2038.5232%204.41395C38.5378%204.26398%2038.608%204.18312%2038.7547%204.18001C39.1029%204.17266%2039.4515%204.17281%2039.7998%204.18044C39.95%204.18369%2040.0118%204.25479%2040.0254%204.41593C40.0395%204.58442%2040.0437%204.75376%2040.0507%204.92282C40.0543%205.01272%2040.0574%205.1022%2040.0826%205.17782L40.0823%205.1781Z'%20fill='%23304764'/%3e%3cpath%20d='M63.4356%208.33621C63.4356%209.57643%2063.4356%2010.8168%2063.4356%2012.057C63.4356%2012.1416%2063.4392%2012.2267%2063.4308%2012.3105C63.4188%2012.4296%2063.3523%2012.492%2063.2308%2012.5112C63.203%2012.5156%2063.1745%2012.5171%2063.1465%2012.5171C62.8266%2012.5177%2062.5066%2012.5177%2062.1867%2012.5176C62.1586%2012.5176%2062.1302%2012.517%2062.1023%2012.513C61.9741%2012.4949%2061.9148%2012.4418%2061.9012%2012.3168C61.8912%2012.2238%2061.8929%2012.1293%2061.8927%2012.0354C61.8923%2010.5978%2061.8924%209.16015%2061.8924%207.7226C61.8924%206.69836%2061.8924%205.67426%2061.8926%204.65002C61.8926%204.56549%2061.8897%204.48054%2061.8978%204.39658C61.9118%204.25056%2061.9689%204.19586%2062.1097%204.18116C62.1377%204.17819%2062.1661%204.17875%2062.1942%204.17875C62.5048%204.17875%2062.8153%204.17875%2063.1257%204.17918C63.1633%204.17918%2063.2012%204.17932%2063.2382%204.18483C63.357%204.20236%2063.42%204.26653%2063.4318%204.38993C63.4388%204.46443%2063.4356%204.54005%2063.4356%204.61525C63.4357%205.85548%2063.4356%207.09584%2063.4356%208.33607V8.33621Z'%20fill='%23304764'/%3e%3cpath%20d='M0.000141352%2014.0755C0.052159%2013.9062%200.0930098%2013.7346%200.11082%2013.5576C0.267721%2011.999%200.738425%2010.5414%201.53848%209.19376C2.41854%207.71139%203.58526%206.50297%205.0419%205.57556C6.3986%204.71175%207.87658%204.18423%209.47202%203.98534C9.75204%203.95043%2010.0347%203.93672%2010.3165%203.91481C10.3727%203.91043%2010.4298%203.90887%2010.4858%203.91325C10.6672%203.92753%2010.7801%204.02563%2010.8167%204.20515C10.8297%204.2689%2010.8314%204.3359%2010.8315%204.40134C10.8324%205.41753%2010.8321%206.43371%2010.8315%207.44989C10.8315%207.50615%2010.8311%207.5634%2010.8219%207.61867C10.7942%207.78546%2010.6954%207.88907%2010.5303%207.92215C10.4662%207.93501%2010.3993%207.93473%2010.3337%207.9401C8.6509%208.07834%207.20416%208.73563%206.01977%209.9367C4.88768%2011.0849%204.23181%2012.4696%204.11081%2014.0795C3.93369%2016.4354%204.78181%2018.3811%206.59366%2019.883C8.47732%2021.4443%2011.0836%2021.8177%2013.3582%2020.8878C15.5892%2019.976%2017.1856%2017.9292%2017.486%2015.5299C17.5071%2015.3621%2017.5184%2015.193%2017.5342%2015.0245C17.5578%2014.7736%2017.6809%2014.6556%2017.9342%2014.6437C18.0001%2014.6406%2018.0661%2014.643%2018.1321%2014.643C19.0838%2014.643%2020.0354%2014.643%2020.9871%2014.643C21.0532%2014.643%2021.1192%2014.6403%2021.185%2014.6439C21.4434%2014.6574%2021.5808%2014.8006%2021.5723%2015.0621C21.5654%2015.2781%2021.5509%2015.4944%2021.5284%2015.7094C21.3602%2017.3242%2020.8753%2018.8365%2020.0238%2020.2221C18.7008%2022.3753%2016.8509%2023.8944%2014.4753%2024.7706C13.649%2025.0754%2012.7951%2025.2678%2011.9204%2025.3541C9.55316%2025.5877%207.35004%2025.082%205.32291%2023.8405C3.38991%2022.6569%201.94925%2021.0286%200.996817%2018.9748C0.518056%2017.9423%200.224326%2016.8559%200.110113%2015.7227C0.0923031%2015.5457%200.0474944%2015.3751%200%2015.2046V14.0755H0.000141352Z'%20fill='%23304764'/%3e%3cpath%20d='M14.826%208.83597C13.7577%208.87229%2012.8475%207.93923%2012.8503%206.83456C12.8532%205.74105%2013.7276%204.85746%2014.8591%204.85718C16.2118%204.8569%2016.8584%206.01514%2016.8482%206.8812C16.8335%208.12835%2015.7272%208.89138%2014.826%208.83597Z'%20fill='%23F06627'/%3e%3cpath%20d='M20.6436%2010.7021C20.6451%2011.8216%2019.7738%2012.71%2018.6726%2012.7148C17.6657%2012.7192%2016.6608%2011.9258%2016.6621%2010.7376C16.6632%209.62525%2017.5396%208.72795%2018.6368%208.72413C19.6165%208.72074%2020.6572%209.49281%2020.6436%2010.7019V10.7021Z'%20fill='%23F06627'/%3e%3cpath%20d='M131.944%2014.9292C131.944%2011.4772%20131.944%208.02513%20131.945%204.57317C131.945%204.45118%20131.949%204.32863%20131.959%204.20707C131.986%203.86768%20132.323%203.48829%20132.807%203.50002C133.257%203.51076%20133.595%203.91008%20133.603%204.23604C133.606%204.33004%20133.612%204.4239%20133.612%204.5179C133.612%2011.4501%20133.612%2018.3824%20133.612%2025.3146C133.612%2025.418%20133.612%2025.522%20133.6%2025.6245C133.552%2026.0408%20133.216%2026.3387%20132.793%2026.3447C132.369%2026.3508%20132.021%2026.0641%20131.961%2025.6512C131.943%2025.5311%20131.945%2025.4074%20131.945%2025.2854C131.944%2023.5359%20131.945%2021.7864%20131.945%2020.0368V14.9293L131.944%2014.9292Z'%20fill='%23304764'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_2478_2457'%3e%3crect%20width='208'%20height='28.2846'%20fill='white'%20transform='translate(0%200.357666)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", FPe = "_screen-reader-only_305y9_30", WPe = "_caps-header_305y9_41", VPe = "_top_305y9_51", _Pe = "_mobile_305y9_57", BPe = "_links_305y9_63", UPe = "_logo_305y9_66", XPe = "_logoMobile_305y9_72", GPe = "_caps_305y9_41", qPe = "_warning_305y9_105", KPe = "_navItemPadding_305y9_111", YPe = "_nav_305y9_111", QPe = "_nav-items_305y9_127", JPe = "_header_305y9_133", ZPe = "_mobile-menu-button_305y9_147", eke = "_sign-out_305y9_148", tke = "_mobile-menu_305y9_147", nke = "_inboxText_305y9_198", id = {
  screenReaderOnly: FPe,
  capsHeader: WPe,
  top: VPe,
  mobile: _Pe,
  links: BPe,
  logo: UPe,
  logoMobile: XPe,
  caps: GPe,
  warning: qPe,
  navItemPadding: KPe,
  nav: YPe,
  navItems: QPe,
  header: JPe,
  mobileMenuButton: ZPe,
  signOut: eke,
  mobileMenu: tke,
  inboxText: nke
}, rke = "Benefits", ake = "Loyalty Benefits", oke = "Pool Purchase Offers", ike = "SALESPERSON (APPROVAL ENTRY)", lke = {
  DEALS: "deals",
  VEHICLES: "vehicles",
  BENEFITS: "benefits",
  SETTINGS: "settings",
  COLLECTION_CONNECTION: "collections"
}, or = {
  HOME: "home",
  LEADS: "leads",
  NEW_APPROVALS: "newApproval",
  APPROVALS_IN_PROCESS: "approvals",
  CONTRACTS_IN_PROCESS: "contracts",
  OBTAIN_ACCOUNT_STATUS: "collectionsStatus",
  RECORD_ACCOUNT_PAYMENT: "collectionsPayments",
  PROVIDE_ACCOUNT_INFO: "collectionsAccount",
  DISPOSITION_DESCRIPTIONS: "collectionsDispositions",
  ADD_VEHICLE: "vehiclesNew",
  VIEW_ALL_VEHICLES: "vehiclesAll",
  REVIEW_INVENTORY_ISSUES: "inventoryIssues",
  LOYALTY_BENEFITS: "loyaltyBenefits",
  POOL_PURCHASE_OFFERS: "poolPurchaseOffers",
  RESOURCES: "resources",
  DEALER_PROFILE: "dealerProfile",
  USER_SETUP: "userSetup",
  CHANGE_PASSWORD: "changePassword",
  CUSTOMER_TOOLS: "customerTools",
  NOTIFICATIONS: "notifications",
  SALES_TOOLS: "salesTools",
  CONTACT_US: "contactUs",
  // The follow menuItem are Parent menu Items that hold submenu
  ...lke
}, ske = [
  or.NEW_APPROVALS,
  or.APPROVALS_IN_PROCESS,
  or.LOYALTY_BENEFITS
], uke = ({
  navigationMenus: e,
  hasSettingsCustomerTools: t = !1,
  role: r,
  dealerActive: a,
  proxied: i
}) => {
  let c = !1, d = !1;
  const f = e.find(
    (p) => p.title.toLowerCase() === rke.toLowerCase()
  );
  return f && (c = f.submenus.some(
    (p) => p.title.toLowerCase() === oke.toLowerCase()
  ), d = f.submenus.some(
    (p) => p.title.toLowerCase() === ake.toLowerCase()
  )), [
    {
      label: "capsHeader.navItem.home",
      goTo: or.HOME,
      testId: or.HOME,
      active: Ku({
        item: or.HOME,
        role: r,
        dealerActive: a,
        proxied: i
      })
    },
    {
      label: "capsHeader.navItem.leads",
      goTo: or.LEADS,
      testId: or.LEADS,
      requiresFlagCheckToShow: !0,
      active: Ku({
        item: or.LEADS,
        role: r,
        dealerActive: a,
        proxied: i
      })
    },
    {
      label: "capsHeader.navItem.approvals.new",
      goTo: or.NEW_APPROVALS,
      testId: or.NEW_APPROVALS,
      active: Ku({
        item: or.NEW_APPROVALS,
        role: r,
        dealerActive: a,
        proxied: i
      })
    },
    {
      label: "capsHeader.navItem.deals",
      testId: or.DEALS,
      children: [
        {
          label: "capsHeader.navItem.approvals.process",
          goTo: or.APPROVALS_IN_PROCESS,
          testId: or.APPROVALS_IN_PROCESS,
          active: Ku({
            item: or.APPROVALS_IN_PROCESS,
            role: r,
            dealerActive: a,
            proxied: i
          })
        },
        {
          label: "capsHeader.navItem.contracts",
          goTo: or.CONTRACTS_IN_PROCESS,
          testId: or.CONTRACTS_IN_PROCESS,
          active: Ku({
            item: or.CONTRACTS_IN_PROCESS,
            role: r,
            dealerActive: a,
            proxied: i
          })
        },
        {
          label: "capsHeader.navItem.collections",
          testId: or.COLLECTION_CONNECTION,
          children: [
            {
              label: "capsHeader.navItem.account.status",
              goTo: or.OBTAIN_ACCOUNT_STATUS,
              testId: or.OBTAIN_ACCOUNT_STATUS,
              active: Ku({
                item: or.OBTAIN_ACCOUNT_STATUS,
                role: r,
                dealerActive: a,
                proxied: i
              })
            },
            {
              label: "capsHeader.navItem.account.payments",
              goTo: or.RECORD_ACCOUNT_PAYMENT,
              testId: or.RECORD_ACCOUNT_PAYMENT,
              active: Ku({
                item: or.RECORD_ACCOUNT_PAYMENT,
                role: r,
                dealerActive: a,
                proxied: i
              })
            },
            {
              label: "capsHeader.navItem.account.info",
              goTo: or.PROVIDE_ACCOUNT_INFO,
              testId: or.PROVIDE_ACCOUNT_INFO,
              active: Ku({
                item: or.PROVIDE_ACCOUNT_INFO,
                role: r,
                dealerActive: a,
                proxied: i
              })
            },
            {
              label: "capsHeader.navItem.dispositions",
              goTo: or.DISPOSITION_DESCRIPTIONS,
              testId: or.DISPOSITION_DESCRIPTIONS,
              active: Ku({
                item: or.DISPOSITION_DESCRIPTIONS,
                role: r,
                dealerActive: a,
                proxied: i
              })
            }
          ]
        }
      ]
    },
    {
      label: "capsHeader.navItem.vehicles.menu",
      testId: or.VEHICLES,
      children: [
        {
          label: "capsHeader.navItem.vehicles.add",
          goTo: or.ADD_VEHICLE,
          testId: or.ADD_VEHICLE,
          active: Ku({
            item: or.ADD_VEHICLE,
            proxied: i,
            role: r,
            dealerActive: a
          })
        },
        {
          label: "capsHeader.navItem.vehicles.all",
          goTo: or.VIEW_ALL_VEHICLES,
          testId: or.VIEW_ALL_VEHICLES,
          active: Ku({
            item: or.VIEW_ALL_VEHICLES,
            role: r,
            proxied: i,
            dealerActive: a
          })
        },
        {
          label: "capsHeader.navItem.inventory",
          goTo: or.REVIEW_INVENTORY_ISSUES,
          testId: or.REVIEW_INVENTORY_ISSUES,
          active: Ku({
            item: or.REVIEW_INVENTORY_ISSUES,
            role: r,
            dealerActive: a,
            proxied: i
          })
        }
      ]
    },
    ...d || c ? [
      {
        label: "capsHeader.navItem.benefits.menu",
        testId: or.BENEFITS,
        children: dke({
          hasPoolPurchaseOffer: c,
          hasLoyalty: d,
          role: r,
          dealerActive: a,
          proxied: i
        })
      }
    ] : [],
    {
      label: "capsHeader.navItem.resources",
      goTo: or.RESOURCES,
      active: !0,
      testId: or.RESOURCES
    },
    {
      label: "capsHeader.navItem.settings",
      testId: "settings",
      children: [
        {
          label: "capsHeader.navItem.profile",
          goTo: or.DEALER_PROFILE,
          testId: or.DEALER_PROFILE,
          active: Ku({
            item: or.DEALER_PROFILE,
            role: r,
            proxied: i,
            dealerActive: a
          })
        },
        {
          label: "capsHeader.navItem.user",
          goTo: or.USER_SETUP,
          testId: or.USER_SETUP,
          active: Ku({
            item: or.USER_SETUP,
            role: r,
            proxied: i,
            dealerActive: a
          })
        },
        ...E8e(r) ? [] : [fke],
        ...t ? cke(r, a, i) : [],
        {
          label: "capsHeader.navItem.notifications",
          goTo: or.NOTIFICATIONS,
          testId: or.NOTIFICATIONS,
          requiresFlagCheckToShow: !0,
          active: Ku({
            item: or.NOTIFICATIONS,
            role: r,
            proxied: i,
            dealerActive: a
          })
        },
        {
          label: "capsHeader.navItem.salesTools",
          goTo: or.SALES_TOOLS,
          testId: or.SALES_TOOLS,
          requiresFlagCheckToShow: !0,
          active: Ku({
            item: or.SALES_TOOLS,
            role: r,
            proxied: i,
            dealerActive: a
          })
        }
      ]
    },
    {
      label: "capsHeader.navItem.contact",
      goTo: or.CONTACT_US,
      testId: or.CONTACT_US,
      active: !0
    }
  ];
};
function cke(e, t, r) {
  return [
    {
      label: "capsHeader.navItem.customerTools",
      goTo: or.CUSTOMER_TOOLS,
      testId: or.CUSTOMER_TOOLS,
      active: Ku({
        item: or.CUSTOMER_TOOLS,
        role: e,
        dealerActive: t,
        proxied: r
      })
    }
  ];
}
function dke({
  hasPoolPurchaseOffer: e = !1,
  hasLoyalty: t = !1,
  role: r,
  proxied: a,
  dealerActive: i
}) {
  const c = [];
  return e && c.push({
    label: "capsHeader.navItem.benefits.poolPurchaseOffers",
    goTo: or.POOL_PURCHASE_OFFERS,
    testId: or.POOL_PURCHASE_OFFERS,
    active: Ku({
      item: or.POOL_PURCHASE_OFFERS,
      role: r,
      proxied: a,
      dealerActive: i
    })
  }), t && c.push({
    label: "capsHeader.navItem.benefits.loyaltyBenefits",
    goTo: or.LOYALTY_BENEFITS,
    testId: or.LOYALTY_BENEFITS,
    active: Ku({
      item: or.LOYALTY_BENEFITS,
      role: r,
      proxied: a,
      dealerActive: i
    })
  }), c;
}
const fke = {
  label: "capsHeader.navItem.password",
  goTo: or.CHANGE_PASSWORD,
  testId: or.CHANGE_PASSWORD,
  active: !0
};
function Ku({
  role: e,
  dealerActive: t,
  item: r,
  proxied: a
}) {
  return a ? !0 : !t || hee(e) ? !1 : e === ike ? ske.includes(r) : !0;
}
function mke() {
  const [e, t] = Wn(!1), {
    isLoading: r,
    launchDarklyClient: a,
    error: i
  } = cI({
    project: xM.DVM
  });
  return Er(() => {
    (async () => {
      if (!i && !r && a) {
        await a.identify({
          kind: "dealer",
          key: `dealer-${a.getContext().key}`
        });
        const d = a.variation(
          O8e.customerTools,
          !1
        );
        d !== e && t(d);
      }
    })();
  }, [r, a, i, e]), e;
}
function hke(e, t) {
  if ("goTo" in e) {
    if (!e.requiresFlagCheckToShow)
      return !1;
    const r = sx[e.goTo];
    if (!r)
      return !1;
    const a = t?.variation(r), i = M8e[r];
    return i ? !i(a) : !1;
  }
  return !1;
}
const dTt = (e) => {
  const { t } = fi(), [r, a] = Wn(!1), [i, c] = Wn(!1), [d, f] = Wn(!1), p = It(null), { user: g, isDealerActive: b, heading: w, numberOfUnreadEmails: x } = e, E = g?.name ?? "", P = g?.userRole ?? "", k = g?.dealerName ?? "", M = g?.dealerId ?? "", T = g?.isProxied ?? !1, N = g?.vehicleWarningCount ?? 0, $ = (g?.carLots?.length ?? 0) > 1, { launchDarklyClient: j, isLoading: I } = cI(), { goTo: L, toURL: F } = CPe(j), _ = mke();
  jPe(
    p,
    (oe) => a(oe.contentRect.width <= l6e.maxMobileHeader)
  );
  const W = !g, Q = P ? `(${P.toUpperCase()})` : "", U = W ? t("capsHeader.loading") : t("capsHeader.user", {
    dealerLongName: k.toUpperCase(),
    dealerShortName: M.toUpperCase(),
    userName: E.toUpperCase(),
    userRole: Q
  }), Y = e.testId || "capsHeader", G = `${Y}-navMenu`, J = _e(id.top, {
    [id.mobile]: r
  }), H = _e(id.links, {
    [id.caps]: !r
  }), K = _e(id.capsHeader, {
    [id.mobile]: r
  }), X = mn(() => {
    const oe = mr("--header-color"), fe = mr("--caps-font-family");
    return {
      components: {
        Tooltip: {},
        Menu: {
          itemBorderRadius: 0,
          itemBg: mr("--header-mobile-menu-background"),
          // for item background in mobile menu
          itemColor: oe,
          // menu items mobile dropdown font color
          darkItemBg: oe,
          darkItemColor: mr("--header-nav-color")
        }
      },
      token: {
        fontFamily: fe
      }
    };
  }, []);
  function te() {
    f(!1);
  }
  function ie() {
    f(!0);
  }
  const ee = Cn(
    (oe, fe, be) => {
      const me = "goTo" in oe && !I && oe.active;
      let De;
      try {
        me && (De = bee(oe.goTo, void 0, j));
      } catch {
      }
      let Me;
      if ("requiresFlagCheckToShow" in oe && oe.requiresFlagCheckToShow && I)
        return;
      if (me) {
        if (hke(oe, j))
          return;
        Me = /* @__PURE__ */ V.jsx("a", { "data-testid": `${G}-${oe.testId}`, href: De, children: t(oe.label) });
      } else
        Me = /* @__PURE__ */ V.jsx("span", { "data-testid": `${G}-${oe.testId}`, children: t(oe.label) });
      const ze = {
        label: Me,
        key: oe.label
      };
      return "goTo" in oe && !oe.active && (ze.onClick = () => {
        be();
      }), "goTo" in oe && oe.active && I && (ze.onClick = () => {
        L(oe.goTo);
      }), "children" in oe && (ze.children = oe.children.map((le) => ee(le, fe, be)).filter(Boolean)), ze;
    },
    [L, I, G, t, j]
  ), ne = mn(() => uke({
    role: P ?? "",
    hasSettingsCustomerTools: _,
    navigationMenus: g?.navigationMenus ?? [],
    dealerActive: b ?? !1,
    proxied: T
  }).map(
    (be) => ee(be, `${Y}-navMenu`, ie)
  ).filter(Boolean), [
    Y,
    _,
    b,
    g?.navigationMenus,
    T,
    P,
    ee
  ]), ae = Ku({
    item: or.REVIEW_INVENTORY_ISSUES,
    role: P,
    dealerActive: b,
    proxied: T
  });
  return /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
    /* @__PURE__ */ V.jsx(tc, { theme: X, children: /* @__PURE__ */ V.jsxs(
      "nav",
      {
        ref: p,
        className: K,
        "data-testid": Y,
        children: [
          /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
            /* @__PURE__ */ V.jsxs(
              "div",
              {
                className: J,
                "data-testid": `${Y}-topMenuBar`,
                children: [
                  r && /* @__PURE__ */ V.jsx(
                    wke,
                    {
                      isOpen: i,
                      onChange: () => c((oe) => !oe),
                      testId: `${Y}-mobileMenuButton`
                    }
                  ),
                  /* @__PURE__ */ V.jsx(
                    pke,
                    {
                      testId: `${Y}-capsLogo`,
                      toURL: F,
                      isMobile: r
                    }
                  ),
                  r && /* @__PURE__ */ V.jsx(
                    lB,
                    {
                      isMobile: r,
                      testId: `${Y}-signOutMobile`,
                      toURL: F
                    }
                  ),
                  /* @__PURE__ */ V.jsxs(
                    "ul",
                    {
                      className: H,
                      "data-testid": `${Y}-links`,
                      children: [
                        /* @__PURE__ */ V.jsx("li", { "data-testid": `${Y}-welcomeMessage`, children: U }),
                        /* @__PURE__ */ V.jsx(
                          gke,
                          {
                            proxied: T,
                            testId: `${Y}-unproxyLink`,
                            toURL: F
                          }
                        ),
                        /* @__PURE__ */ V.jsx(
                          vke,
                          {
                            changeDealership: $,
                            testId: `${Y}-changeDealershipLink`,
                            toURL: F
                          }
                        ),
                        /* @__PURE__ */ V.jsx(
                          bke,
                          {
                            numberOfUnreadEmails: x,
                            testId: `${Y}-unreadEmailsLink`,
                            toURL: F
                          }
                        ),
                        /* @__PURE__ */ V.jsx(
                          yke,
                          {
                            inventoryIssueCount: N,
                            testId: `${Y}-inventoryIssuesLink`,
                            toURL: F,
                            isAccessible: ae,
                            onNoAccessClick: ie
                          }
                        ),
                        /* @__PURE__ */ V.jsx("li", { children: /* @__PURE__ */ V.jsx(
                          lB,
                          {
                            isMobile: r,
                            testId: `${Y}-signOut`,
                            toURL: F
                          }
                        ) })
                      ]
                    }
                  )
                ]
              }
            ),
            !r && /* @__PURE__ */ V.jsx(
              iB,
              {
                menuItems: ne,
                isMobile: !1,
                isOpen: !0,
                heading: w,
                testId: `${Y}-navMenu`
              }
            )
          ] }),
          i && r && /* @__PURE__ */ V.jsx(
            iB,
            {
              menuItems: ne,
              isMobile: !0,
              isOpen: !0,
              testId: `${Y}-navMenuMobile`
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ V.jsx(
      qoe,
      {
        closeable: !0,
        headerTitle: t("noAccessModal.header"),
        footerButtons: [
          {
            closesModal: !0,
            kind: "primary",
            label: t("noAccessModal.ok"),
            onClick: te,
            size: "small"
          }
        ],
        closeOnClickOutside: !1,
        onClose: te,
        open: d,
        children: /* @__PURE__ */ V.jsx("span", { "data-testid": `${Y}-noAccessModal`, children: t("noAccessModal.message") })
      }
    )
  ] });
};
function pke({
  testId: e,
  toURL: t,
  isMobile: r
}) {
  const { t: a } = fi();
  let i;
  try {
    i = t("home");
  } catch {
  }
  const c = _e(id.logo, {
    [id.logoMobile]: r
  }), d = /* @__PURE__ */ V.jsx(
    "img",
    {
      alt: a("capsHeader.logo.alt.text"),
      width: 230,
      height: 46,
      src: HPe,
      className: c,
      "data-testid": `${e}-image`
    }
  );
  if (i) {
    const f = a("capsHeader.logo.alt.text");
    return /* @__PURE__ */ V.jsxs(
      "a",
      {
        href: i,
        "aria-labelledby": "capsheader-logo-label",
        "data-testid": `${e}-dealerPortalLink`,
        children: [
          /* @__PURE__ */ V.jsx("span", { className: id.screenReaderOnly, id: "capsheader-logo-label", children: f }),
          /* @__PURE__ */ V.jsx(U1, { title: f, children: d })
        ]
      }
    );
  }
  return d;
}
function gke({
  proxied: e = !1,
  testId: t,
  toURL: r
}) {
  const { t: a } = fi();
  if (!e)
    return null;
  let i;
  try {
    i = r("unproxy");
  } catch {
  }
  const c = a("capsHeader.unproxy");
  return /* @__PURE__ */ V.jsx("li", { "data-testid": t, children: /* @__PURE__ */ V.jsx("a", { href: i, children: c }) });
}
function vke({
  changeDealership: e = !1,
  testId: t,
  toURL: r
}) {
  const { t: a } = fi();
  if (e)
    return /* @__PURE__ */ V.jsx("li", { "data-testid": t, children: /* @__PURE__ */ V.jsx("a", { href: r("changeDealership"), children: a("capsHeader.changeDealership") }) });
}
function bke({
  numberOfUnreadEmails: e = 0,
  testId: t,
  toURL: r
}) {
  const { t: a } = fi();
  return /* @__PURE__ */ V.jsx("li", { "data-testid": t, children: /* @__PURE__ */ V.jsxs("a", { href: r("unreadEmails"), children: [
    /* @__PURE__ */ V.jsx("span", { className: id.inboxText, children: a("capsHeader.navItem.inbox") }),
    /* @__PURE__ */ V.jsx(_f, { name: "faEnvelope", "aria-hidden": "true", size: 15 }),
    0 < e && ` (${e}) `
  ] }) });
}
function yke({
  inventoryIssueCount: e,
  testId: t,
  toURL: r,
  isAccessible: a,
  onNoAccessClick: i
}) {
  const { t: c } = fi();
  let d;
  try {
    d = r("inventoryIssues");
  } catch {
  }
  const f = c("capsHeader.inventoryIssues", { inventoryIssueCount: e });
  return /* @__PURE__ */ V.jsx("li", { "data-testid": t, children: /* @__PURE__ */ V.jsx(
    "a",
    {
      className: id.warning,
      href: a ? d : void 0,
      onClick: a ? void 0 : i,
      children: f
    }
  ) });
}
function wke({
  isOpen: e = !1,
  onChange: t,
  testId: r
}) {
  const a = () => {
    t();
  }, { t: i } = fi(), c = i("capsHeader.mobile.menu.open"), d = i("capsHeader.mobile.menu.close");
  return /* @__PURE__ */ V.jsx(V.Fragment, { children: /* @__PURE__ */ V.jsx(
    "button",
    {
      className: id.mobileMenuButton,
      onClick: a,
      "aria-label": e ? d : c,
      "aria-expanded": e,
      "data-testid": r,
      children: /* @__PURE__ */ V.jsx(s7, { children: /* @__PURE__ */ V.jsx(_f, { name: e ? "closeX" : "hamburgerMenu", size: 24 }) })
    }
  ) });
}
function iB({
  menuItems: e,
  heading: t,
  isMobile: r,
  isOpen: a = !0,
  testId: i
}) {
  const c = _e({
    [id.nav]: !r,
    [id.mobileMenu]: r,
    [id.navItems]: !r,
    [id.navItemPadding]: !r
  });
  return /* @__PURE__ */ V.jsx(V.Fragment, { children: a && /* @__PURE__ */ V.jsxs("nav", { className: id.nav, "data-testid": i, children: [
    t && !r && /* @__PURE__ */ V.jsx("header", { className: id.header, "data-testid": `${i}-header`, children: t }),
    /* @__PURE__ */ V.jsx(
      aC,
      {
        className: c,
        theme: r ? "light" : "dark",
        mode: r ? "inline" : "horizontal",
        items: e,
        "data-testid": i
      }
    )
  ] }) });
}
function lB({
  isMobile: e,
  testId: t,
  toURL: r
}) {
  const { t: a } = fi();
  let i;
  try {
    i = r("signOut");
  } catch {
  }
  const c = a("capsHeader.signout"), d = e ? /* @__PURE__ */ V.jsx("button", { className: id.signOut, "data-testid": `${t}-button`, children: /* @__PURE__ */ V.jsx(_f, { name: "signOut", size: 24, "aria-hidden": "true" }) }) : c;
  return /* @__PURE__ */ V.jsx("a", { href: i, "data-testid": `${t}-link`, children: d });
}
const Ske = fl(
  lt(
    "flex flex-col gap-3 rounded-lg border p-4 text-left text-(--card-text)",
    "shadow-(--card-shadow)"
  ),
  {
    variants: {
      kind: {
        info: "bg-(--card-background-info) border-(--card-border-info)",
        success: "bg-(--card-background-success) border-(--card-border-success)",
        warning: "bg-(--card-background-warning) border-(--card-border-warning)",
        error: "bg-(--card-background-error) border-(--card-border-error)"
      }
    }
  }
);
function fTt({
  kind: e,
  heading: t,
  children: r,
  footer: a,
  className: i,
  dataTestId: c = "card"
}) {
  return /* @__PURE__ */ V.jsx("div", { "data-preflight": !0, className: "contents", children: /* @__PURE__ */ V.jsxs(
    "section",
    {
      className: lt(Ske({ kind: e }), i),
      "data-testid": c,
      children: [
        t != null && /* @__PURE__ */ V.jsx("h3", { className: "font-sans text-lg font-semibold leading-tight", children: t }),
        r,
        a != null && /* @__PURE__ */ V.jsx("div", { children: a })
      ]
    }
  ) });
}
const Cke = {}, xke = mr("--carousel-bg-color"), gA = mr("--carousel-dot-size");
function mTt(e) {
  const { children: t, autoplay: r } = e;
  return /* @__PURE__ */ V.jsx(
    tc,
    {
      theme: {
        components: {
          Carousel: {
            colorBgContainer: xke,
            dotActiveWidth: gA,
            dotWidth: gA,
            dotHeight: gA
          }
        }
      },
      children: /* @__PURE__ */ V.jsx(
        eJ,
        {
          autoplay: r,
          rootClassName: Cke.fullSize,
          autoplaySpeed: 1e4,
          children: t
        }
      )
    }
  );
}
const Eke = "_contact-info_1r1ud_13", Pke = {
  contactInfo: Eke
}, hTt = ({
  text: e,
  kind: t
}) => {
  const r = mn(() => Number.parseInt(mr("--contact-info-font-size")), []), a = t === "email" ? `mailto:${e}` : `tel:${e}`;
  return /* @__PURE__ */ V.jsxs("div", { className: Pke.contactInfo, children: [
    /* @__PURE__ */ V.jsx(_f, { name: t, size: r }),
    t === "fax" ? /* @__PURE__ */ V.jsx("span", { children: e }) : /* @__PURE__ */ V.jsx("a", { href: a, children: e })
  ] });
}, sB = ({ children: e, href: t, className: r, ...a }) => t ? /* @__PURE__ */ V.jsx(
  "a",
  {
    href: t,
    target: "_blank",
    rel: "noopener noreferrer",
    className: lt(
      "text-(--dpf-link) no-underline transition-colors duration-300",
      "hover:text-(--dpf-link-hover) active:text-(--dpf-link-active)",
      "focus-visible:text-(--dpf-link-hover) focus-visible:outline-(--dpf-link-hover) focus-visible:outline-2 focus-visible:outline-offset-2",
      r
    ),
    ...a,
    children: e
  }
) : /* @__PURE__ */ V.jsx("span", { className: "text-(--dpf-link)", children: e }), kke = ({
  hideCaliforniaResidentWarning: e = !1
}) => {
  const { t } = fi(), r = t("dealerPageFooter.copyright", {
    currentYear: h6e()
  });
  let a, i;
  try {
    a = tS("dealerTerms"), i = tS("dealerCaliforniaTerms");
  } catch {
  }
  return /* @__PURE__ */ V.jsx("div", { "data-preflight": !0, className: "contents", children: /* @__PURE__ */ V.jsx(
    "footer",
    {
      "data-dealer-footer": !0,
      role: "contentinfo",
      className: "bg-(--dpf-bg) font-sans text-[14px]",
      children: /* @__PURE__ */ V.jsxs("div", { className: "p-(--dpf-padding) lg:w-(--dpf-container) mx-auto text-center", children: [
        !e && /* @__PURE__ */ V.jsx("p", { className: "text-(length:--dpf-font) leading-(--dpf-leading) text-(--dpf-text) mb-(--dpf-gap) m-0", children: /* @__PURE__ */ V.jsxs(LV, { i18nKey: "dealerPageFooter.californiaResidentNotice", children: [
          "placeholder",
          /* @__PURE__ */ V.jsx(sB, { href: i, children: "here" }),
          "placeholder"
        ] }) }),
        /* @__PURE__ */ V.jsxs("div", { className: "flex flex-col items-center lg:flex-row lg:flex-nowrap lg:justify-center lg:gap-x-1 [&>p]:lg:whitespace-nowrap", children: [
          /* @__PURE__ */ V.jsx("p", { className: "text-(length:--dpf-font) leading-(--dpf-leading) text-(--dpf-text) m-0", children: /* @__PURE__ */ V.jsxs(LV, { i18nKey: "dealerPageFooter.terms", children: [
            "placeholder",
            /* @__PURE__ */ V.jsx(sB, { href: a, children: "placeholder" })
          ] }) }),
          /* @__PURE__ */ V.jsx("p", { className: "text-(length:--dpf-font) leading-(--dpf-leading) text-(--dpf-text) m-0", children: r })
        ] })
      ] })
    }
  ) });
};
function Mke() {
  return {
    paddingXS: vo(
      "--Components-Drawer-Global-paddingXS"
    ),
    paddingLG: vo(
      "--Components-Drawer-Global-paddingLG"
    ),
    padding: vo("--Components-Drawer-Global-padding"),
    marginSM: vo(
      "--Components-Drawer-Global-marginSM"
    ),
    lineWidth: vo(
      "--Components-Drawer-Global-lineWidth"
    ),
    lineHeightLG: vo(
      "--Components-Drawer-Global-lineHeightLG"
    ),
    fontWeightStrong: vo(
      "--Components-Drawer-Global-fontWeightStrong"
    ),
    lineWidthFocus: vo(
      "--Components-Drawer-Global-lineWidthFocus"
    ),
    fontSizeLG: vo(
      "--Components-Drawer-Global-fontSizeLG"
    ),
    colorText: mr("--Components-Drawer-Global-colorText"),
    colorSplit: mr("--Components-Drawer-Global-colorSplit"),
    colorIconHover: mr(
      "--Components-Drawer-Global-colorIconHover"
    ),
    colorIcon: mr("--Components-Drawer-Global-colorIcon"),
    colorBgMask: mr("--Components-Drawer-Global-colorBgMask"),
    colorBgElevated: mr(
      "--Components-Drawer-Global-colorBgElevated"
    )
  };
}
const pTt = ({
  children: e,
  className: t,
  footer: r,
  onClick: a,
  onClose: i,
  open: c,
  title: d,
  placement: f = "right",
  theme: p = "classic"
}) => {
  const g = {
    classic: {
      token: Mke()
    },
    apollo: {}
  };
  return /* @__PURE__ */ V.jsx(tc, { theme: g[p], children: /* @__PURE__ */ V.jsx(
    $j,
    {
      className: t,
      footer: r,
      height: 360,
      open: c,
      onClick: a,
      onClose: i,
      placement: f,
      title: d,
      width: 400,
      children: e
    }
  ) });
}, gTt = ({
  items: e,
  children: t,
  popupClassName: r = "",
  ...a
}) => /* @__PURE__ */ V.jsx(
  gM,
  {
    menu: { items: e },
    rootClassName: r,
    ...a,
    children: t
  }
), Oke = "data:image/svg+xml,%3csvg%20width='228'%20height='31'%20viewBox='0%200%20228%2031'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='Layer_1'%20clip-path='url(%23clip0_10148_21361)'%3e%3cpath%20id='Vector'%20d='M0.000154922%2015.0352C0.0571664%2014.8496%200.101939%2014.6616%200.121459%2014.4676C0.293423%2012.7594%200.809315%2011.1619%201.68618%209.68483C2.65072%208.06016%203.92945%206.73573%205.52593%205.71928C7.01288%204.77255%208.63275%204.19438%2010.3814%203.9764C10.6883%203.93814%2010.9981%203.92311%2011.3069%203.8991C11.3685%203.89429%2011.4311%203.89259%2011.4925%203.89739C11.6912%203.91304%2011.815%204.02056%2011.8551%204.21731C11.8694%204.28718%2011.8712%204.36061%2011.8714%204.43234C11.8723%205.54608%2011.872%206.65982%2011.8714%207.77355C11.8714%207.83521%2011.8709%207.89796%2011.8609%207.95853C11.8305%208.14134%2011.7222%208.2549%2011.5413%208.29115C11.4709%208.30525%2011.3976%208.30494%2011.3258%208.31083C9.48141%208.46234%207.89578%209.18273%206.59768%2010.4991C5.35691%2011.7575%204.63807%2013.2752%204.50546%2015.0396C4.31134%2017.6217%205.24087%2019.7542%207.22667%2021.4002C9.29117%2023.1115%2012.1476%2023.5207%2014.6406%2022.5016C17.0858%2021.5022%2018.8355%2019.2589%2019.1647%2016.6292C19.1878%2016.4453%2019.2002%2016.2601%2019.2175%2016.0754C19.2434%2015.8004%2019.3783%2015.671%2019.6559%2015.658C19.7281%2015.6546%2019.8005%2015.6573%2019.8728%2015.6573C20.9159%2015.6573%2021.9589%2015.6573%2023.002%2015.6573C23.0743%2015.6573%2023.1467%2015.6543%2023.2189%2015.6582C23.5021%2015.6731%2023.6526%2015.83%2023.6433%2016.1166C23.6357%2016.3533%2023.6198%2016.5904%2023.5952%2016.826C23.4108%2018.5958%2022.8794%2020.2533%2021.9462%2021.7719C20.4961%2024.1318%2018.4686%2025.7968%2015.865%2026.7571C14.9593%2027.0912%2014.0234%2027.302%2013.0648%2027.3967C10.4703%2027.6526%208.05566%2027.0984%205.83392%2025.7378C3.71535%2024.4404%202.13638%2022.6559%201.09251%2020.4049C0.567791%2019.2733%200.245862%2018.0826%200.120685%2016.8405C0.101164%2016.6466%200.052054%2016.4596%200%2016.2728V15.0352H0.000154922Z'%20fill='white'/%3e%3cpath%20id='Vector_2'%20d='M73.9859%2031.0004C73.8543%2030.8318%2073.7884%2030.637%2073.7882%2030.4161C73.7882%2027.7675%2073.7893%2025.1189%2073.7876%2022.4702C73.7871%2021.7066%2073.9267%2020.9721%2074.253%2020.281C74.7771%2019.1704%2075.6391%2018.4268%2076.7908%2018.0167C77.682%2017.6994%2078.6048%2017.6411%2079.5394%2017.7274C79.9924%2017.7693%2080.4381%2017.8542%2080.8688%2018.0071C82.403%2018.5521%2083.4036%2019.607%2083.8106%2021.1774C84.1752%2022.5839%2084.0449%2023.9618%2083.366%2025.2612C82.7881%2026.3675%2081.8983%2027.1125%2080.6784%2027.4234C79.751%2027.6597%2078.8364%2027.5909%2077.9519%2027.2137C77.6754%2027.0958%2077.4208%2026.9393%2077.1891%2026.7466C77.1598%2026.7221%2077.1133%2026.6928%2077.0831%2026.6999C77.0191%2026.7153%2077.0376%2026.7814%2077.0359%2026.8294C77.0329%2026.9119%2077.0348%2026.9943%2077.0348%2027.0767C77.0348%2028.1794%2077.0348%2029.2822%2077.0348%2030.3849C77.0348%2030.4571%2077.0325%2030.5293%2077.0348%2030.6013C77.0385%2030.7217%2077.0035%2030.8227%2076.9073%2030.9021C76.8771%2030.9268%2076.8597%2030.9671%2076.8365%2031.0003H73.9861L73.9859%2031.0004ZM80.8106%2022.6196C80.8429%2021.7275%2080.2886%2020.7776%2079.1208%2020.6318C78.4158%2020.5436%2077.4909%2020.8411%2077.1135%2021.7991C76.9132%2022.3074%2076.9046%2022.8245%2077.0817%2023.339C77.3373%2024.0814%2077.8639%2024.518%2078.6418%2024.6071C79.4209%2024.6963%2080.0618%2024.4257%2080.5027%2023.7583C80.7301%2023.4139%2080.8242%2023.0266%2080.8106%2022.6197V22.6196Z'%20fill='%23F06627'/%3e%3cpath%20id='Vector_3'%20d='M66.1164%200C66.1985%200.134318%2066.2314%200.276846%2066.2311%200.437346C66.2275%203.24206%2066.2323%206.04678%2066.2259%208.85149C66.2242%209.62254%2066.0792%2010.369%2065.7375%2011.068C65.1547%2012.2601%2064.2143%2013.0285%2062.9357%2013.368C61.8506%2013.656%2060.7649%2013.6299%2059.7056%2013.2429C58.3446%2012.7458%2057.4474%2011.7854%2057.0116%2010.4137C56.5857%209.0735%2056.6528%207.74117%2057.2459%206.46352C57.9021%205.04954%2059.0129%204.21513%2060.5739%204.0032C61.1758%203.92155%2061.769%203.96137%2062.354%204.12001C63.1143%204.32636%2063.747%204.73195%2064.2473%205.34142C64.2996%205.40525%2064.3488%205.47171%2064.402%205.53461C64.4135%205.54808%2064.4388%205.56048%2064.4546%205.55738C64.4877%205.55072%2064.4997%205.52097%2064.5%205.48844C64.5009%205.39564%2064.5017%205.30284%2064.5017%205.21004C64.5017%203.6839%2064.5017%202.15792%2064.5017%200.631774C64.5017%200.518371%2064.5125%200.403728%2064.4998%200.291874C64.4876%200.182809%2064.5907%200.107206%2064.5672%200H66.1163L66.1164%200ZM64.5387%208.77372C64.5393%208.30834%2064.4725%207.86712%2064.3141%207.44015C64.0363%206.69157%2063.5486%206.12858%2062.8104%205.80061C62.2602%205.55629%2061.6852%205.47883%2061.0875%205.5611C60.0549%205.70332%2059.2653%206.21115%2058.7965%207.14595C58.2917%208.15218%2058.2856%209.19325%2058.7234%2010.2247C59.045%2010.9828%2059.6112%2011.5041%2060.3899%2011.7845C60.9662%2011.9921%2061.5597%2012.0352%2062.1583%2011.9132C63.2934%2011.6821%2064.0172%2010.9885%2064.3743%209.90032C64.4941%209.53532%2064.5354%209.15669%2064.539%208.77357L64.5387%208.77372Z'%20fill='white'/%3e%3cpath%20id='Vector_4'%20d='M227.969%209.77615C227.93%209.72843%20227.876%209.74176%20227.826%209.74083C227.734%209.73897%20227.641%209.74129%20227.548%209.73401C227.479%209.72859%20227.435%209.68382%20227.432%209.61302C227.427%209.48954%20227.428%209.36591%20227.426%209.24244C227.425%209.10069%20227.424%208.95893%20227.423%208.82338C227.349%208.80556%20227.326%208.84088%20227.31%208.87837C227.212%209.10518%20227.107%209.32966%20227.021%209.56112C226.968%209.70396%20226.874%209.74981%20226.736%209.74067C226.715%209.73928%20226.694%209.73897%20226.674%209.74052C226.556%209.74966%20226.481%209.69993%20226.436%209.58792C226.353%209.37753%20226.262%209.17009%20226.173%208.96172C226.15%208.90765%20226.138%208.84538%20226.076%208.81501C226.015%208.824%20226.032%208.87605%20226.031%208.9092C226.027%209.12548%20226.032%209.3419%20226.026%209.55817C226.022%209.70365%20225.988%209.73695%20225.836%209.73928C225.395%209.74609%20225.423%209.75725%20225.423%209.34639C225.424%208.87249%20225.423%208.39858%20225.423%207.92483C225.423%207.85279%20225.425%207.78059%20225.427%207.70871C225.429%207.63806%20225.467%207.58415%20225.535%207.57997C225.679%207.57098%20225.824%207.56788%20225.967%207.57687C226.058%207.5826%20226.101%207.65991%20226.137%207.73845C226.274%208.03854%20226.412%208.33769%20226.551%208.63623C226.595%208.72825%20226.624%208.8288%20226.696%208.90316C226.787%208.88364%20226.802%208.80494%20226.832%208.74251C226.966%208.4638%20227.096%208.18339%20227.227%207.90376C227.258%207.83853%20227.291%207.7744%20227.322%207.70917C227.366%207.61575%20227.439%207.57362%20227.542%207.56757C227.684%207.55921%20227.828%207.59081%20227.969%207.54883V9.7763L227.969%209.77615Z'%20fill='white'/%3e%3cpath%20id='Vector_5'%20d='M68.9667%200C68.9631%200.106277%2069.0627%200.0869116%2069.1166%200.114798C69.4443%200.284593%2069.6283%200.554313%2069.6768%200.913888C69.7472%201.4352%2069.3879%201.93746%2068.8824%202.03723C68.364%202.13948%2067.8443%201.83165%2067.7048%201.32443C67.558%200.789795%2067.8148%200.337886%2068.2232%200.124403C68.2881%200.0904748%2068.3882%200.101629%2068.4091%200.000154923H68.9668L68.9667%200Z'%20fill='white'/%3e%3cpath%20id='Vector_6'%20d='M192.565%2021.2414C192.565%2019.2928%20192.565%2017.3443%20192.565%2015.3957C192.564%2014.3297%20192.769%2013.3058%20193.2%2012.33C193.814%2010.9405%20194.794%209.88932%20196.141%209.18147C197.04%208.70912%20198.001%208.45272%20199.008%208.35527C199.97%208.26232%20200.926%208.29377%20201.875%208.48045C203.049%208.71144%20204.117%209.17714%20205.053%209.93176C205.863%2010.5857%20206.47%2011.3969%20206.9%2012.34C207.369%2013.3689%20207.576%2014.4533%20207.588%2015.5823C207.596%2016.4546%20207.504%2017.3115%20207.263%2018.1496C206.93%2019.3083%20206.377%2020.347%20205.527%2021.2129C204.312%2022.4524%20202.831%2023.0749%20201.092%2023.0977C200.362%2023.1071%20199.65%2023.0159%20198.956%2022.7925C198.136%2022.5287%20197.414%2022.1036%20196.814%2021.4805C196.785%2021.4507%20196.756%2021.4214%20196.729%2021.3903C196.701%2021.3582%20196.666%2021.3251%20196.625%2021.3355C196.582%2021.3465%20196.576%2021.3946%20196.576%2021.4365C196.575%2021.5293%20196.574%2021.6221%20196.574%2021.7149C196.574%2023.6531%20196.574%2025.5913%20196.574%2027.5296C196.574%2027.6326%20196.578%2027.7364%20196.567%2027.8385C196.542%2028.0623%20196.412%2028.1905%20196.187%2028.2168C196.115%2028.2252%20196.042%2028.2224%20195.97%2028.2224C195.03%2028.2227%20194.091%2028.2122%20193.151%2028.227C192.697%2028.2343%20192.558%2028.0518%20192.56%2027.6436C192.57%2025.5095%20192.565%2023.3753%20192.565%2021.2413L192.565%2021.2414ZM200.108%2019.4631C200.226%2019.4544%20200.329%2019.4494%20200.432%2019.4387C201.732%2019.3023%20202.721%2018.6844%20203.287%2017.4954C203.834%2016.3443%20203.83%2015.1573%20203.323%2013.9896C202.967%2013.1706%20202.358%2012.5845%20201.529%2012.2396C200.792%2011.9331%20200.027%2011.8708%20199.251%2012.0404C198.064%2012.2998%20197.238%2012.9986%20196.782%2014.1252C196.501%2014.8202%20196.442%2015.5441%20196.528%2016.2828C196.601%2016.9075%20196.798%2017.4912%20197.162%2018.0073C197.882%2019.0279%20198.906%2019.4434%20200.108%2019.4634L200.108%2019.4631Z'%20fill='white'/%3e%3cpath%20id='Vector_7'%20d='M189.738%2018.5872C189.738%2019.7418%20189.738%2020.8965%20189.738%2022.051C189.738%2022.154%20189.74%2022.2578%20189.728%2022.3596C189.702%2022.5659%20189.583%2022.7001%20189.381%2022.7442C189.291%2022.7638%20189.197%2022.7645%20189.104%2022.7647C188.289%2022.7661%20187.473%2022.7554%20186.657%2022.7695C186.194%2022.7775%20186.037%2022.5748%20186.046%2022.1922C186.055%2021.8114%20186.034%2021.43%20186.025%2021.0489C186.024%2021.012%20186.038%2020.9588%20185.981%2020.9485C185.934%2020.94%20185.912%2020.9826%20185.889%2021.0142C185.722%2021.2376%20185.54%2021.4474%20185.336%2021.639C184.659%2022.2768%20183.862%2022.6923%20182.961%2022.9078C181.675%2023.2155%20180.397%2023.1774%20179.147%2022.7383C177.642%2022.2094%20176.523%2021.2119%20175.73%2019.8398C175.244%2018.9993%20174.954%2018.0904%20174.803%2017.1348C174.633%2016.0652%20174.646%2014.9983%20174.868%2013.9381C175.219%2012.264%20176.019%2010.858%20177.393%209.80774C178.251%209.15165%20179.22%208.72964%20180.277%208.51244C181.798%208.19965%20183.313%208.22041%20184.813%208.64087C185.811%208.92081%20186.709%209.39673%20187.482%2010.0913C188.437%2010.9484%20189.062%2012.0107%20189.419%2013.236C189.652%2014.0342%20189.738%2014.8517%20189.738%2015.6802C189.738%2016.6493%20189.738%2017.6183%20189.738%2018.5874L189.738%2018.5872ZM185.791%2015.5721C185.791%2015.1849%20185.72%2014.6757%20185.53%2014.1897C185.113%2013.1232%20184.369%2012.4041%20183.256%2012.0888C182.711%2011.9345%20182.156%2011.9074%20181.599%2012.0045C180.31%2012.2296%20179.388%2012.933%20178.893%2014.1512C178.539%2015.02%20178.505%2015.9201%20178.746%2016.8215C179.052%2017.9601%20179.745%2018.7731%20180.854%2019.2066C181.462%2019.4441%20182.097%2019.5112%20182.741%2019.423C183.904%2019.2642%20184.782%2018.6822%20185.341%2017.6422C185.665%2017.0377%20185.792%2016.3851%20185.79%2015.5721H185.791Z'%20fill='white'/%3e%3cpath%20id='Vector_8'%20d='M170.792%2014.1609C170.317%2014.1609%20169.842%2014.1609%20169.367%2014.1609C169.295%2014.1609%20169.222%2014.1624%20169.15%2014.1582C168.982%2014.1486%20168.858%2014.0636%20168.772%2013.9232C168.74%2013.8709%20168.716%2013.8131%20168.691%2013.7565C168.343%2012.9627%20167.746%2012.4426%20166.928%2012.1738C166.117%2011.9074%20165.3%2011.9097%20164.493%2012.1847C163.552%2012.5055%20162.875%2013.1322%20162.502%2014.0517C162.029%2015.2168%20162.04%2016.3891%20162.582%2017.5314C163.074%2018.5669%20163.922%2019.1562%20165.038%2019.3644C165.776%2019.5021%20166.498%2019.4303%20167.193%2019.135C167.868%2018.8481%20168.376%2018.379%20168.663%2017.7032C168.804%2017.3706%20169.007%2017.2373%20169.372%2017.2452C170.312%2017.2657%20171.252%2017.252%20172.192%2017.2522C172.274%2017.2522%20172.357%2017.2483%20172.439%2017.2562C172.627%2017.2744%20172.738%2017.3888%20172.747%2017.5796C172.751%2017.6504%20172.742%2017.7241%20172.726%2017.7933C172.326%2019.464%20171.456%2020.8238%20170.04%2021.8175C169.173%2022.4265%20168.21%2022.8069%20167.165%2022.9795C165.925%2023.1843%20164.691%2023.1577%20163.486%2022.7837C161.1%2022.0432%20159.486%2020.4848%20158.704%2018.1147C158.107%2016.3047%20158.165%2014.4853%20158.913%2012.7313C159.953%2010.2929%20161.83%208.87027%20164.436%208.41201C165.623%208.20333%20166.806%208.26917%20167.963%208.6083C170.038%209.21683%20171.53%2010.4976%20172.372%2012.5038C172.528%2012.8755%20172.639%2013.2623%20172.728%2013.6549C172.742%2013.7145%20172.75%2013.7773%20172.748%2013.8382C172.74%2014.012%20172.638%2014.1271%20172.465%2014.1527C172.384%2014.1646%20172.3%2014.1609%20172.217%2014.161C171.742%2014.1616%20171.267%2014.1613%20170.792%2014.1613V14.1609Z'%20fill='white'/%3e%3cpath%20id='Vector_9'%20d='M214.884%2023.0956C213.86%2023.1095%20212.94%2022.9504%20212.057%2022.5962C211.112%2022.2171%20210.305%2021.6415%20209.619%2020.8905C209.379%2020.628%20209.348%2020.3943%20209.513%2020.0411C209.548%2019.9671%20209.596%2019.8984%20209.644%2019.8313C209.949%2019.4031%20210.253%2018.9742%20210.563%2018.5495C210.819%2018.1989%20211.009%2018.1692%20211.369%2018.4299C211.72%2018.6844%20212.074%2018.9328%20212.452%2019.1474C212.921%2019.4143%20213.414%2019.6237%20213.949%2019.7159C214.379%2019.79%20214.811%2019.8022%20215.238%2019.6902C215.308%2019.6719%20215.376%2019.6484%20215.444%2019.6236C216.306%2019.3074%20216.322%2018.1902%20215.74%2017.7558C215.54%2017.6063%20215.331%2017.4756%20215.103%2017.3783C214.619%2017.1719%20214.132%2016.9726%20213.646%2016.7715C213.284%2016.6217%20212.919%2016.4797%20212.56%2016.3231C211.969%2016.0655%20211.424%2015.7347%20210.956%2015.2876C210.262%2014.6247%20209.877%2013.8146%20209.817%2012.856C209.782%2012.2846%20209.844%2011.7241%20210.036%2011.1817C210.392%2010.1809%20211.068%209.45974%20211.992%208.95996C212.799%208.52432%20213.668%208.33144%20214.579%208.30882C215.361%208.28946%20216.123%208.39837%20216.861%208.65786C217.836%209.00024%20218.664%209.56184%20219.354%2010.3278C219.375%2010.3507%20219.395%2010.3736%20219.415%2010.3975C219.632%2010.6604%20219.639%2010.8437%20219.418%2011.1145C219.021%2011.602%20218.618%2012.0852%20218.212%2012.5659C218%2012.8171%20217.808%2012.8374%20217.539%2012.6442C217.397%2012.5421%20217.265%2012.4257%20217.125%2012.3199C216.72%2012.0135%20216.289%2011.7518%20215.806%2011.585C215.469%2011.4689%20215.125%2011.422%20214.77%2011.4446C214.529%2011.4599%20214.302%2011.5236%20214.095%2011.6503C213.552%2011.9841%20213.434%2012.723%20213.845%2013.2101C213.965%2013.3534%20214.111%2013.4681%20214.271%2013.5649C214.457%2013.6775%20214.654%2013.7658%20214.856%2013.845C215.548%2014.1159%20216.24%2014.3847%20216.93%2014.6597C217.449%2014.8665%20217.945%2015.1188%20218.4%2015.4469C218.719%2015.6776%20219.008%2015.9408%20219.258%2016.2455C219.764%2016.8636%20220.036%2017.5752%20220.092%2018.3692C220.137%2019.0034%20220.074%2019.6258%20219.855%2020.2259C219.517%2021.1473%20218.888%2021.8215%20218.052%2022.3127C217.402%2022.6943%20216.694%2022.9059%20215.952%2023.0201C215.574%2023.0784%20215.194%2023.1045%20214.884%2023.0959L214.884%2023.0956Z'%20fill='white'/%3e%3cpath%20id='Vector_10'%20d='M98.3312%2026.4039C98.2605%2026.3858%2098.2371%2026.4259%2098.212%2026.4544C97.6672%2027.0733%2096.9599%2027.3892%2096.1633%2027.5043C95.0346%2027.6674%2093.9871%2027.4425%2093.0543%2026.7652C92.4396%2026.3188%2091.9784%2025.7424%2091.6681%2025.0536C91.054%2023.6906%2090.9651%2022.2845%2091.423%2020.8642C91.9047%2019.3704%2092.9464%2018.4215%2094.4321%2017.9544C95.2908%2017.6844%2096.175%2017.6415%2097.0665%2017.7332C97.7079%2017.7992%2098.322%2017.9598%2098.9019%2018.2519C100.013%2018.8114%20100.74%2019.6917%20101.114%2020.8687C101.281%2021.3926%20101.356%2021.9313%20101.355%2022.4819C101.352%2023.9039%20101.354%2025.3259%20101.354%2026.748C101.354%2026.8202%20101.357%2026.8924%20101.353%2026.9644C101.341%2027.1717%20101.238%2027.2863%20101.035%2027.3162C100.974%2027.3252%20100.911%2027.3235%20100.849%2027.3235C100.179%2027.324%2099.508%2027.3238%2098.8371%2027.3238C98.8268%2027.3238%2098.8165%2027.324%2098.8062%2027.3238C98.463%2027.3154%2098.3744%2027.2267%2098.3642%2026.8756C98.3595%2026.7151%2098.3707%2026.5534%2098.3312%2026.4042V26.4039ZM98.1617%2022.6224C98.1651%2021.5684%2097.5129%2020.7642%2096.5094%2020.6361C95.5294%2020.5109%2094.6037%2021.0749%2094.3648%2022.0828C94.312%2022.3056%2094.2945%2022.5307%2094.3083%2022.7573C94.4019%2024.2928%2095.8448%2024.9465%2097.0123%2024.4776C97.3473%2024.3429%2097.6114%2024.1189%2097.812%2023.8204C98.0554%2023.4585%2098.1563%2023.0541%2098.1617%2022.6224Z'%20fill='%23F06627'/%3e%3cpath%20id='Vector_11'%20d='M41.3404%2024.4632C41.3404%2025.2051%2041.3404%2025.9472%2041.3404%2026.6893C41.3404%2026.7614%2041.3421%2026.8336%2041.3397%2026.9057C41.3294%2027.2%2041.2232%2027.3124%2040.9223%2027.3212C40.6335%2027.3297%2040.3444%2027.3235%2040.0555%2027.3235C39.6634%2027.3235%2039.2711%2027.324%2038.879%2027.3232C38.7966%2027.323%2038.713%2027.3261%2038.6319%2027.3145C38.4666%2027.2905%2038.3731%2027.1976%2038.3549%2027.0301C38.3416%2026.9077%2038.3503%2026.783%2038.3439%2026.6597C38.3404%2026.5886%2038.3308%2026.5171%2038.3154%2026.4477C38.3081%2026.415%2038.2677%2026.4053%2038.2412%2026.4212C38.2068%2026.4418%2038.1772%2026.4724%2038.1497%2026.5024C37.7098%2026.9822%2037.1595%2027.2747%2036.534%2027.4223C35.2351%2027.7288%2034.0334%2027.5131%2032.958%2026.7069C32.3599%2026.2583%2031.9167%2025.6768%2031.6184%2024.9953C31.0471%2023.69%2030.9571%2022.3423%2031.363%2020.978C31.7665%2019.6222%2032.6423%2018.6729%2033.9482%2018.1196C34.5056%2017.8833%2035.0902%2017.7635%2035.6892%2017.7155C36.4447%2017.6551%2037.1961%2017.694%2037.9312%2017.8926C39.1173%2018.2131%2040.0639%2018.8641%2040.6867%2019.9396C41.0808%2020.6202%2041.2885%2021.3596%2041.327%2022.1448C41.3386%2022.3813%2041.3389%2022.6185%2041.3397%2022.8554C41.3414%2023.3913%2041.3403%2023.9271%2041.3403%2024.463L41.3404%2024.4632ZM36.2385%2024.6249C37.1135%2024.6226%2037.8096%2024.1002%2038.0487%2023.2624C38.143%2022.9316%2038.1678%2022.595%2038.112%2022.254C37.9909%2021.5117%2037.6031%2020.9715%2036.8787%2020.7305C36.1368%2020.4837%2035.448%2020.6129%2034.8689%2021.1545C34.4177%2021.5765%2034.2563%2022.1273%2034.2867%2022.7263C34.3493%2023.9591%2035.2511%2024.6308%2036.2384%2024.6249H36.2385Z'%20fill='%23F06627'/%3e%3cpath%20id='Vector_12'%20d='M102.465%2022.5855C102.465%2021.2245%20102.465%2019.8633%20102.465%2018.5023C102.465%2018.4095%20102.46%2018.3158%20102.471%2018.2243C102.493%2018.0459%20102.595%2017.9482%20102.773%2017.9242C102.824%2017.9174%20102.876%2017.9191%20102.927%2017.9191C103.681%2017.9188%20104.435%2017.9188%20105.189%2017.9191C105.24%2017.9191%20105.292%2017.9194%20105.343%2017.9262C105.496%2017.9468%20105.565%2018.0052%20105.597%2018.1538C105.617%2018.2439%20105.622%2018.3374%20105.631%2018.4294C105.652%2018.6447%20105.672%2018.8602%20105.693%2019.0756C105.696%2019.1045%20105.704%2019.1429%20105.74%2019.1402C105.766%2019.1381%20105.796%2019.1171%20105.812%2019.0957C105.919%2018.9567%20106.015%2018.8086%20106.129%2018.676C106.592%2018.1372%20107.177%2017.8129%20107.884%2017.7263C108.766%2017.6182%20109.591%2017.7679%20110.326%2018.2963C110.927%2018.7284%20111.312%2019.3148%20111.541%2020.0082C111.697%2020.481%20111.779%2020.9684%20111.779%2021.4674C111.779%2023.2616%20111.779%2025.0556%20111.779%2026.8497C111.779%2026.8703%20111.779%2026.8909%20111.779%2026.9115C111.771%2027.2139%20111.676%2027.3177%20111.365%2027.3218C110.838%2027.3287%20110.312%2027.3239%20109.785%2027.3239C109.527%2027.3239%20109.269%2027.3258%20109.011%2027.3227C108.929%2027.3218%20108.845%2027.3162%20108.766%2027.2978C108.643%2027.2696%20108.568%2027.1875%20108.558%2027.0595C108.551%2026.9672%20108.553%2026.874%20108.553%2026.7814C108.553%2025.3998%20108.553%2024.0181%20108.553%2022.6365C108.553%2022.3889%20108.551%2022.1413%20108.508%2021.8967C108.489%2021.7852%20108.469%2021.6725%20108.434%2021.5652C108.253%2021.0022%20107.866%2020.7069%20107.27%2020.6649C107.167%2020.6576%20107.063%2020.6576%20106.96%2020.6677C106.403%2020.7227%20106.017%2021.0039%20105.833%2021.5391C105.742%2021.8045%20105.71%2022.0811%20105.709%2022.3615C105.709%2022.8151%20105.709%2023.2688%20105.709%2023.7225C105.709%2024.7329%20105.709%2025.7434%20105.709%2026.7538C105.709%2026.826%20105.713%2026.8984%20105.708%2026.9703C105.695%2027.2025%20105.597%2027.3007%20105.362%2027.3215C105.311%2027.326%20105.259%2027.3238%20105.207%2027.3238C104.464%2027.3238%20103.72%2027.3238%20102.977%2027.3238C102.915%2027.3238%20102.852%2027.3261%20102.791%2027.3193C102.586%2027.2968%20102.493%2027.2087%20102.471%2027.0082C102.461%2026.9163%20102.465%2026.8229%20102.465%2026.7301C102.465%2025.3485%20102.465%2023.9668%20102.465%2022.5852V22.5855Z'%20fill='%23F06627'/%3e%3cpath%20id='Vector_13'%20d='M129.144%2023.8575C128.38%2023.8575%20127.617%2023.8575%20126.853%2023.8578C126.77%2023.8578%20126.688%2023.8589%20126.605%2023.8637C126.552%2023.8668%20126.519%2023.9256%20126.544%2023.9766C126.575%2024.0412%20126.609%2024.1052%20126.648%2024.1653C126.847%2024.4696%20127.125%2024.6741%20127.458%2024.8095C127.651%2024.8876%20127.851%2024.9371%20128.056%2024.9658C128.706%2025.0563%20129.352%2025.0556%20129.991%2024.8835C130.191%2024.8296%20130.381%2024.7498%20130.569%2024.6669C130.636%2024.638%20130.7%2024.6044%20130.766%2024.5769C130.874%2024.5328%20130.968%2024.5552%20131.045%2024.6432C131.059%2024.6587%20131.072%2024.6744%20131.085%2024.6911C131.374%2025.0925%20131.667%2025.4914%20131.951%2025.8966C132.077%2026.0758%20132.059%2026.1949%20131.897%2026.3638C131.556%2026.7184%20131.149%2026.9781%20130.694%2027.1629C130.282%2027.3307%20129.854%2027.4456%20129.412%2027.4995C128.574%2027.6015%20127.743%2027.57%20126.926%2027.3463C126.283%2027.1703%20125.687%2026.8949%20125.156%2026.4868C124.342%2025.8622%20123.796%2025.0536%20123.522%2024.0702C123.185%2022.859%20123.232%2021.6566%20123.733%2020.4994C124.41%2018.9368%20125.629%2018.0479%20127.297%2017.7625C127.975%2017.6465%20128.656%2017.6548%20129.327%2017.8113C131.044%2018.2115%20132.124%2019.2773%20132.591%2020.9663C132.747%2021.5282%20132.768%2022.1047%20132.719%2022.6838C132.704%2022.8697%20132.662%2023.0509%20132.594%2023.2242C132.457%2023.569%20132.206%2023.7769%20131.836%2023.8279C131.693%2023.8476%20131.548%2023.8555%20131.404%2023.8559C130.651%2023.8586%20129.897%2023.8572%20129.144%2023.8572L129.144%2023.8575ZM128.15%2021.645C128.202%2021.645%20128.253%2021.645%20128.305%2021.645C128.779%2021.6447%20129.254%2021.6456%20129.729%2021.6433C129.828%2021.6429%20129.863%2021.5968%20129.84%2021.5088C129.686%2020.9206%20129.332%2020.5325%20128.728%2020.3881C128.493%2020.3321%20128.256%2020.344%20128.019%2020.3466C127.746%2020.3496%20127.489%2020.4247%20127.248%2020.5491C126.851%2020.7541%20126.601%2021.0825%20126.467%2021.5033C126.439%2021.5905%20126.476%2021.6365%20126.572%2021.6422C126.624%2021.6453%20126.675%2021.6447%20126.727%2021.6449C127.201%2021.645%20127.676%2021.6449%20128.15%2021.6449L128.15%2021.645Z'%20fill='%23F06627'/%3e%3cpath%20id='Vector_14'%20d='M69.2716%2023.8581C68.4972%2023.8581%2067.7227%2023.8572%2066.9484%2023.8595C66.8598%2023.8598%2066.7407%2023.8191%2066.6905%2023.9054C66.6293%2024.0105%2066.7382%2024.0942%2066.7918%2024.1768C66.9898%2024.4817%2067.2719%2024.6826%2067.6065%2024.8152C67.8484%2024.911%2068.101%2024.9636%2068.3581%2024.9923C68.7698%2025.0382%2069.1832%2025.0382%2069.5945%2024.9914C69.9663%2024.9491%2070.3217%2024.8412%2070.6622%2024.6859C70.7186%2024.6601%2070.773%2024.6302%2070.83%2024.6061C71.0288%2024.5212%2071.1036%2024.5336%2071.2289%2024.7041C71.51%2025.0863%2071.787%2025.4716%2072.0595%2025.86C72.2135%2026.0794%2072.2009%2026.1818%2072.0158%2026.3764C71.6379%2026.7734%2071.1759%2027.038%2070.6659%2027.2269C69.8566%2027.5267%2069.0179%2027.5899%2068.1652%2027.5332C67.3607%2027.4797%2066.5981%2027.2704%2065.8936%2026.8777C64.5738%2026.1418%2063.7959%2025.0131%2063.5318%2023.5359C63.352%2022.5303%2063.4332%2021.5385%2063.8269%2020.5902C64.4446%2019.1018%2065.5571%2018.183%2067.1249%2017.8215C67.889%2017.6454%2068.6625%2017.6353%2069.4297%2017.8064C71.0848%2018.1754%2072.1668%2019.1754%2072.6744%2020.7906C72.859%2021.3783%2072.9001%2021.984%2072.8617%2022.5955C72.8468%2022.833%2072.7978%2023.0647%2072.6991%2023.2841C72.5667%2023.5789%2072.3414%2023.7568%2072.0259%2023.8208C71.8736%2023.8516%2071.7193%2023.8593%2071.5637%2023.859C70.7996%2023.8576%2070.0356%2023.8584%2069.2715%2023.8584L69.2716%2023.8581ZM68.2821%2021.6457C68.6733%2021.6457%2069.0643%2021.646%2069.4555%2021.6457C69.5996%2021.6455%2069.7437%2021.646%2069.8876%2021.6415C69.9632%2021.6392%2069.9926%2021.5941%2069.9731%2021.5155C69.8362%2020.9649%2069.5167%2020.5792%2068.9596%2020.417C68.586%2020.3082%2068.2062%2020.3203%2067.8288%2020.393C67.6989%2020.4181%2067.5698%2020.4628%2067.4491%2020.5178C67.0104%2020.7175%2066.739%2021.065%2066.5943%2021.5175C66.5699%2021.5938%2066.5998%2021.6374%2066.6768%2021.6427C66.7281%2021.6461%2066.7797%2021.6457%2066.8311%2021.6457C67.3148%2021.6458%2067.7986%2021.6457%2068.2823%2021.6458L68.2821%2021.6457Z'%20fill='%23F06627'/%3e%3cpath%20id='Vector_15'%20d='M50.3617%2021.7228C49.9487%2021.7228%2049.5355%2021.7186%2049.1225%2021.7245C48.9281%2021.7273%2048.7873%2021.6659%2048.6952%2021.4845C48.4627%2021.0261%2048.0698%2020.787%2047.5756%2020.6941C47.1668%2020.6171%2046.7731%2020.6643%2046.3976%2020.8419C46.101%2020.9821%2045.8536%2021.1871%2045.6925%2021.4726C45.2625%2022.2346%2045.2594%2023.0074%2045.6913%2023.7682C45.8859%2024.1111%2046.1915%2024.341%2046.5652%2024.4726C46.9782%2024.6181%2047.3954%2024.6228%2047.8126%2024.4925C48.1934%2024.3735%2048.4979%2024.1495%2048.6788%2023.791C48.7814%2023.5879%2048.923%2023.5114%2049.1457%2023.5134C49.9616%2023.5208%2050.7775%2023.5259%2051.5932%2023.5114C51.9048%2023.5058%2052.0172%2023.6556%2051.9382%2023.9557C51.5238%2025.5295%2050.6006%2026.6603%2049.055%2027.227C47.7057%2027.7217%2046.3559%2027.683%2045.0473%2027.0794C43.7456%2026.4789%2042.8973%2025.464%2042.4909%2024.0963C42.1212%2022.8523%2042.1925%2021.6205%2042.7574%2020.4481C43.4956%2018.9156%2044.7328%2018.0226%2046.4126%2017.7549C47.3053%2017.6127%2048.1868%2017.6858%2049.0354%2018.0057C50.5605%2018.5806%2051.4962%2019.6876%2051.9201%2021.2442C51.9416%2021.3234%2051.9579%2021.406%2051.9605%2021.4876C51.9646%2021.6131%2051.8826%2021.7015%2051.7557%2021.7169C51.6843%2021.7254%2051.6115%2021.7228%2051.5391%2021.7228C51.1467%2021.7232%2050.7543%2021.7229%2050.3619%2021.7228H50.3617Z'%20fill='%23F06627'/%3e%3cpath%20id='Vector_16'%20d='M120.832%2021.7242C120.419%2021.7242%20120.006%2021.72%20119.593%2021.7261C119.397%2021.729%20119.262%2021.6578%20119.171%2021.4782C118.944%2021.0303%20118.561%2020.7888%20118.078%2020.7008C117.4%2020.5773%20116.808%2020.742%20116.335%2021.2593C116.091%2021.5258%20115.952%2021.8502%20115.897%2022.2005C115.831%2022.6219%20115.849%2023.0423%20116.009%2023.4484C116.503%2024.7004%20117.909%2024.8025%20118.669%2024.322C118.883%2024.1864%20119.056%2024.0107%20119.164%2023.7816C119.254%2023.5883%20119.394%2023.5136%20119.605%2023.5151C120.431%2023.5212%20121.257%2023.5161%20122.083%2023.5185C122.406%2023.5195%20122.498%2023.6298%20122.42%2023.9393C122.029%2025.4935%20121.123%2026.6216%20119.612%2027.2007C118.228%2027.731%20116.837%2027.7005%20115.491%2027.0607C114.085%2026.3925%20113.223%2025.2679%20112.887%2023.7574C112.629%2022.595%20112.741%2021.4581%20113.269%2020.3806C113.874%2019.1488%20114.846%2018.3249%20116.153%2017.9238C117.413%2017.5371%20118.668%2017.6003%20119.87%2018.1547C121.246%2018.7894%20122.069%2019.8875%20122.424%2021.347C122.436%2021.3964%20122.443%2021.4488%20122.441%2021.4996C122.438%2021.6139%20122.368%2021.6973%20122.257%2021.7143C122.186%2021.7252%20122.113%2021.7236%20122.041%2021.7238C121.638%2021.7245%20121.235%2021.7241%20120.833%2021.7241L120.832%2021.7242Z'%20fill='%23F06627'/%3e%3cpath%20id='Vector_17'%20d='M60.9988%2021.7229C60.6168%2021.7229%2060.2346%2021.723%2059.8525%2021.7229C59.7803%2021.7229%2059.7077%2021.7244%2059.6358%2021.7187C59.5267%2021.7102%2059.4397%2021.6593%2059.3792%2021.5667C59.3681%2021.5495%2059.3592%2021.5306%2059.3503%2021.512C58.9938%2020.7651%2058.1028%2020.5609%2057.4759%2020.6981C56.7116%2020.8651%2056.2484%2021.3414%2056.0741%2022.0967C55.9747%2022.5275%2055.9931%2022.9581%2056.1375%2023.3779C56.5789%2024.6619%2058.0325%2024.8424%2058.8641%2024.2944C59.0666%2024.161%2059.2273%2023.9857%2059.3292%2023.7664C59.4147%2023.5826%2059.5484%2023.5133%2059.7464%2023.5144C60.5828%2023.519%2061.4194%2023.5162%2062.2558%2023.5167C62.3073%2023.5167%2062.3596%2023.5167%2062.4098%2023.5262C62.5195%2023.5466%2062.5968%2023.6295%2062.5956%2023.7407C62.5946%2023.8324%2062.5837%2023.9271%2062.5589%2024.0153C62.0242%2025.9117%2060.7927%2027.0737%2058.8575%2027.4586C57.9203%2027.6449%2056.9855%2027.5881%2056.0831%2027.2448C54.3659%2026.5916%2053.3455%2025.3436%2052.9972%2023.5567C52.7972%2022.5305%2052.9125%2021.5241%2053.3374%2020.5602C53.75%2019.6246%2054.3977%2018.8988%2055.2743%2018.3722C56.7824%2017.4664%2058.7913%2017.5183%2060.1528%2018.2108C61.0577%2018.671%2061.7375%2019.3515%2062.1883%2020.2595C62.3353%2020.5555%2062.4546%2020.8629%2062.5406%2021.1827C62.5513%2021.2225%2062.5635%2021.2618%2062.5731%2021.3019C62.6529%2021.635%2062.5184%2021.7331%2062.2376%2021.7257C61.8248%2021.7147%2061.4115%2021.7229%2060.9983%2021.7229H60.9988Z'%20fill='%23F06627'/%3e%3cpath%20id='Vector_18'%20d='M85.6987%2022.6408C85.6987%2022.0225%2085.6987%2021.4042%2085.6987%2020.7859C85.6987%2020.7035%2085.7005%2020.6209%2085.696%2020.5387C85.6911%2020.4449%2085.6593%2020.4121%2085.5603%2020.4105C85.3024%2020.4067%2085.0444%2020.4082%2084.7863%2020.4076C84.7038%2020.4073%2084.6209%2020.4115%2084.5388%2020.405C84.3781%2020.3923%2084.2911%2020.3193%2084.2622%2020.1642C84.2453%2020.0739%2084.2421%2019.98%2084.2416%2019.8877C84.2398%2019.4034%2084.2398%2018.919%2084.2416%2018.4347C84.2419%2018.3423%2084.2472%2018.2491%2084.2613%2018.1578C84.2807%2018.0325%2084.3611%2017.9544%2084.4849%2017.9327C84.5654%2017.9186%2084.6491%2017.9182%2084.7313%2017.9175C84.9997%2017.9155%2085.268%2017.9188%2085.5363%2017.9147C85.6674%2017.9129%2085.6965%2017.8824%2085.6971%2017.746C85.6995%2017.1689%2085.6984%2016.5919%2085.699%2016.0148C85.699%2015.9221%2085.6948%2015.8286%2085.7047%2015.7368C85.7239%2015.5573%2085.8208%2015.4609%2086.0019%2015.4352C86.0627%2015.4265%2086.1253%2015.4281%2086.1871%2015.4281C86.9508%2015.4276%2087.7145%2015.4276%2088.4781%2015.4281C88.5502%2015.4281%2088.6233%2015.427%2088.6941%2015.4383C88.8617%2015.4648%2088.9486%2015.5539%2088.9703%2015.724C88.9807%2015.8053%2088.9767%2015.8885%2088.9767%2015.9709C88.9771%2016.5068%2088.9767%2017.0427%2088.9773%2017.5786C88.9773%2017.6608%2088.9785%2017.7436%2088.9861%2017.8254C88.9902%2017.8686%2089.0238%2017.9003%2089.0673%2017.9051C89.1387%2017.9132%2089.2109%2017.916%2089.2828%2017.9163C89.5821%2017.9174%2089.8814%2017.9163%2090.1806%2017.9172C90.2528%2017.9174%2090.3257%2017.9152%2090.3967%2017.9256C90.5612%2017.9496%2090.6529%2018.0481%2090.6681%2018.2127C90.6739%2018.274%2090.6706%2018.3363%2090.6706%2018.3981C90.6706%2018.9134%2090.6706%2019.4286%2090.6706%2019.9439C90.6706%2019.9645%2090.6687%2019.9853%2090.6708%2020.0057C90.6985%2020.2838%2090.5491%2020.4214%2090.2627%2020.4102C89.9432%2020.3978%2089.623%2020.4073%2089.3031%2020.4078C89.2309%2020.4078%2089.1586%2020.407%2089.0867%2020.4126C89.0311%2020.4169%2088.9898%2020.4471%2088.9841%2020.5074C88.9792%2020.5585%2088.9773%2020.6101%2088.9771%2020.6614C88.9768%2021.7639%2088.9768%2022.8667%2088.9771%2023.9693C88.9771%2024.0105%2088.9758%2024.0518%2088.9795%2024.0929C89.0057%2024.3886%2089.1575%2024.5905%2089.4357%2024.6963C89.5428%2024.7371%2089.6538%2024.7571%2089.7688%2024.7569C89.9544%2024.7564%2090.14%2024.7578%2090.3256%2024.7583C90.5886%2024.7591%2090.6982%2024.8466%2090.7017%2025.0971C90.7096%2025.6432%2090.7045%2026.1895%2090.7044%2026.7356C90.7044%2026.9444%2090.5958%2027.0835%2090.4161%2027.1748C90.2116%2027.2786%2089.9928%2027.339%2089.7672%2027.3701C89.0873%2027.4637%2088.41%2027.4697%2087.7421%2027.2838C87.5334%2027.2257%2087.3299%2027.1517%2087.136%2027.053C86.4391%2026.6987%2086.018%2026.1286%2085.8212%2025.3819C85.7259%2025.0203%2085.6985%2024.6514%2085.6985%2024.2794C85.6987%2023.7333%2085.6985%2023.1871%2085.6985%2022.641L85.6987%2022.6408Z'%20fill='%23F06627'/%3e%3cpath%20id='Vector_19'%20d='M144.611%2015.972C144.611%2012.1887%20144.611%208.40514%20144.612%204.62178C144.612%204.48808%20144.616%204.35376%20144.627%204.22053C144.657%203.84856%20145.026%203.43274%20145.557%203.4456C146.05%203.45738%20146.42%203.89503%20146.429%204.25228C146.432%204.35531%20146.439%204.45818%20146.439%204.5612C146.44%2012.1589%20146.44%2019.7568%20146.439%2027.3545C146.439%2027.4677%20146.439%2027.5818%20146.426%2027.6941C146.373%2028.1503%20146.005%2028.4769%20145.541%2028.4834C145.077%2028.4901%20144.695%2028.1759%20144.63%2027.7234C144.61%2027.5917%20144.612%2027.4561%20144.612%2027.3224C144.611%2025.4049%20144.612%2023.4875%20144.612%2021.57V15.9722L144.611%2015.972Z'%20fill='white'/%3e%3cpath%20id='Vector_20'%20d='M52.0946%209.37984C51.0725%209.37984%2050.0505%209.38046%2049.0285%209.37953C48.7485%209.37922%2048.7148%209.37689%2048.7795%209.67202C48.9989%2010.672%2049.545%2011.4161%2050.4968%2011.8366C50.8298%2011.9836%2051.1802%2012.0699%2051.5415%2012.1097C52.2388%2012.1866%2052.9222%2012.1316%2053.5845%2011.8857C53.8469%2011.7883%2054.0949%2011.6631%2054.3321%2011.5156C54.411%2011.4666%2054.4869%2011.4123%2054.5681%2011.3675C54.7179%2011.2849%2054.8102%2011.2996%2054.9174%2011.4391C55.0556%2011.6188%2055.1873%2011.8039%2055.3128%2011.9928C55.3864%2012.1035%2055.372%2012.2002%2055.2843%2012.3045C55.2448%2012.3516%2055.197%2012.3918%2055.1521%2012.4343C54.7317%2012.8309%2054.2395%2013.1113%2053.6918%2013.2822C52.4496%2013.6701%2051.2059%2013.6692%2049.9885%2013.1922C48.5783%2012.6396%2047.6678%2011.6104%2047.2579%2010.1594C46.9466%209.05775%2046.9728%207.95052%2047.3879%206.87815C48.0131%205.26323%2049.1964%204.30922%2050.9088%204.02277C51.4941%203.92486%2052.082%203.93586%2052.6638%204.05887C54.2105%204.38575%2055.2262%205.31932%2055.7603%206.78969C55.9672%207.35903%2056.029%207.95269%2055.998%208.5558C55.9923%208.66828%2055.972%208.78121%2055.9467%208.89136C55.8815%209.17642%2055.6943%209.33212%2055.4079%209.36868C55.3163%209.38046%2055.2226%209.37922%2055.13%209.37937C54.1183%209.37999%2053.1065%209.37984%2052.0949%209.37984H52.0946ZM51.6083%208.10777C52.4433%208.10777%2053.2783%208.10777%2054.1132%208.10777C54.1956%208.10777%2054.2782%208.1087%2054.3605%208.10358C54.4373%208.09878%2054.4765%208.06036%2054.4683%207.98507C54.4516%207.832%2054.4376%207.67693%2054.4012%207.52774C54.1389%206.45072%2053.4842%205.75728%2052.3933%205.49407C52.0275%205.40576%2051.6566%205.40933%2051.2868%205.44434C50.7079%205.49934%2050.1872%205.70833%2049.7394%206.08215C49.1922%206.53918%2048.9058%207.14368%2048.7715%207.82968C48.7205%208.09026%2048.7349%208.10684%2049.0104%208.1073C49.8762%208.10854%2050.7422%208.10777%2051.6081%208.10777H51.6083Z'%20fill='white'/%3e%3cpath%20id='Vector_21'%20d='M39.8339%207.54432C39.6481%207.54432%2039.4622%207.54215%2039.2765%207.54494C39.1099%207.54742%2039.0038%207.46903%2038.9486%207.31535C38.9383%207.28622%2038.927%207.25741%2038.9158%207.22859C38.6187%206.45506%2038.0637%205.94661%2037.2828%205.69548C36.3859%205.40701%2035.5089%205.47843%2034.6749%205.92523C34.0597%206.2549%2033.6274%206.75701%2033.3739%207.40396C33.0749%208.16742%2033.0354%208.95458%2033.2571%209.7405C33.6012%2010.9605%2034.4172%2011.6832%2035.6643%2011.9051C36.3072%2012.0194%2036.9404%2011.9598%2037.5466%2011.7017C38.1855%2011.4296%2038.6365%2010.9711%2038.8988%2010.3283C38.9965%2010.0888%2039.178%209.96876%2039.4433%209.96824C39.7118%209.96777%2039.9801%209.96777%2040.2486%209.96839C40.3208%209.96855%2040.3936%209.96623%2040.4649%209.97537C40.582%209.99024%2040.6446%2010.0663%2040.6505%2010.1854C40.6546%2010.2697%2040.6288%2010.3476%2040.6057%2010.4271C40.2641%2011.5979%2039.5474%2012.4668%2038.4713%2013.0325C36.9827%2013.815%2034.8951%2013.7214%2033.4602%2012.708C32.405%2011.9627%2031.7674%2010.9486%2031.5395%209.68241C31.3678%208.72886%2031.4304%207.78631%2031.8072%206.88822C32.5036%205.22823%2033.762%204.27313%2035.5425%204.0141C36.5148%203.87266%2037.4614%203.99086%2038.3556%204.40528C39.5059%204.93852%2040.2707%205.81244%2040.6116%207.04191C40.6336%207.12107%2040.656%207.20163%2040.6632%207.28297C40.6756%207.42534%2040.5967%207.51737%2040.4528%207.53859C40.4021%207.54603%2040.3499%207.54448%2040.2983%207.54463C40.1434%207.54525%2039.9886%207.54494%2039.8337%207.54494V7.54432H39.8339Z'%20fill='white'/%3e%3cpath%20id='Vector_22'%20d='M72.1311%208.63265C72.1311%207.70482%2072.1316%206.77683%2072.1307%205.849C72.1304%205.5737%2072.1283%205.57262%2071.8648%205.57107C71.5963%205.56952%2071.3279%205.5737%2071.0595%205.56967C70.7751%205.56549%2070.6825%205.47935%2070.6747%205.20607C70.6682%204.97942%2070.6732%204.75246%2070.6738%204.52565C70.6738%204.49482%2070.6761%204.46368%2070.6812%204.43332C70.7057%204.28769%2070.7783%204.21038%2070.9217%204.19179C71.0031%204.1811%2071.0865%204.18451%2071.1691%204.1842C71.4375%204.18296%2071.706%204.18544%2071.9743%204.18126C72.0876%204.17955%2072.1243%204.14237%2072.1283%204.03439C72.1333%203.90054%2072.1311%203.76638%2072.1311%203.63237C72.1313%203.16837%2072.1311%202.70454%2072.1313%202.24054C72.1313%202.16835%2072.1279%202.09585%2072.1349%202.02427C72.1511%201.85448%2072.2177%201.78554%2072.3926%201.78166C72.7126%201.77469%2073.0328%201.77825%2073.3528%201.77825C73.4458%201.77825%2073.5391%201.77609%2073.6314%201.78399C73.7402%201.79328%2073.8032%201.84766%2073.8221%201.95425C73.8365%202.03465%2073.8376%202.118%2073.8378%202.20011C73.839%202.74652%2073.8384%203.29293%2073.8385%203.83934C73.8385%204.19474%2073.8209%204.18467%2074.1698%204.1842C74.5208%204.18374%2074.8719%204.18188%2075.2229%204.18498C75.5633%204.18792%2075.6155%204.24183%2075.618%204.58204C75.6197%204.80885%2075.6229%205.03581%2075.6163%205.26246C75.6098%205.47951%2075.5304%205.56239%2075.3139%205.56797C75.0043%205.57587%2074.6945%205.5706%2074.3846%205.57107C74.2505%205.57122%2074.1162%205.5689%2073.982%205.57277C73.8663%205.57603%2073.8453%205.60004%2073.8401%205.72398C73.837%205.79602%2073.8387%205.86837%2073.8387%205.9404C73.8387%207.59002%2073.8387%209.23963%2073.8387%2010.8893C73.8387%2010.9717%2073.8365%2011.0544%2073.8405%2011.1367C73.8678%2011.7048%2074.1392%2011.9636%2074.7024%2011.9556C74.8364%2011.9537%2074.9702%2011.9415%2075.1043%2011.934C75.1661%2011.9306%2075.2279%2011.9237%2075.2897%2011.9248C75.5136%2011.9285%2075.591%2011.9987%2075.6%2012.2162C75.6065%2012.3706%2075.602%2012.5254%2075.6022%2012.68C75.6022%2012.7624%2075.5995%2012.845%2075.6022%2012.9274C75.6068%2013.0794%2075.5337%2013.1861%2075.4023%2013.2479C75.3005%2013.296%2075.193%2013.3394%2075.0832%2013.3618C74.5712%2013.4662%2074.0557%2013.4786%2073.5473%2013.3517C72.8717%2013.1832%2072.4247%2012.7646%2072.2342%2012.0877C72.161%2011.8281%2072.1308%2011.5625%2072.1311%2011.293C72.1321%2010.4064%2072.1314%209.51958%2072.1314%208.63296L72.1311%208.63265Z'%20fill='white'/%3e%3cpath%20id='Vector_23'%20d='M43.9304%205.28265C43.9959%205.29488%2044.0083%205.26158%2044.0226%205.23741C44.0593%205.17544%2044.0912%205.11053%2044.1267%205.04778C44.6937%204.04435%2045.6271%203.84961%2046.4674%204.01182C46.5278%204.02344%2046.5876%204.04187%2046.6453%204.06372C46.8997%204.15961%2046.9683%204.2535%2046.9711%204.52291C46.9742%204.82175%2046.9751%205.12075%2046.97%205.41944C46.9671%205.59032%2046.9094%205.64331%2046.7427%205.63447C46.651%205.62967%2046.5601%205.60659%2046.469%205.58986C46.1836%205.53765%2045.8998%205.51023%2045.6084%205.55717C44.9943%205.65601%2044.5422%205.97654%2044.2463%206.51815C44.0291%206.91584%2043.9462%207.34885%2043.9276%207.79642C43.9225%207.91989%2043.9262%208.04367%2043.9261%208.16746C43.9261%209.70305%2043.9261%2011.2385%2043.9261%2012.7741C43.9261%2012.8565%2043.9289%2012.9391%2043.9248%2013.0213C43.9137%2013.2457%2043.8449%2013.3244%2043.6272%2013.3289C43.2661%2013.336%2042.9048%2013.336%2042.5437%2013.3293C42.3109%2013.325%2042.2317%2013.2395%2042.2191%2013.0089C42.2157%2012.9473%2042.2179%2012.8853%2042.2179%2012.8235C42.2179%2010.1131%2042.2179%207.40276%2042.2179%204.69224C42.2179%204.60982%2042.2137%204.52678%2042.2216%204.44513C42.2376%204.28076%2042.3146%204.19215%2042.4754%204.18874C42.857%204.18068%2043.239%204.18084%2043.6207%204.1892C43.7854%204.19277%2043.8531%204.27069%2043.868%204.4473C43.8835%204.63197%2043.8881%204.81757%2043.8957%205.00286C43.8997%205.10139%2043.9031%205.19945%2043.9307%205.28234L43.9304%205.28265Z'%20fill='white'/%3e%3cpath%20id='Vector_24'%20d='M69.5261%208.74608C69.5261%2010.1054%2069.5261%2011.4648%2069.5261%2012.8241C69.5261%2012.9167%2069.5302%2013.01%2069.5209%2013.1019C69.5077%2013.2325%2069.4349%2013.3008%2069.3017%2013.3219C69.2713%2013.3267%2069.24%2013.3284%2069.2093%2013.3284C68.8587%2013.329%2068.508%2013.329%2068.1574%2013.3288C68.1266%2013.3288%2068.0954%2013.3282%2068.0649%2013.3239C67.9244%2013.3041%2067.8593%2013.2458%2067.8444%2013.1089C67.8335%2013.0069%2067.8353%2012.9033%2067.8352%2012.8004C67.8347%2011.2248%2067.8348%209.64912%2067.8348%208.07356C67.8348%206.95099%2067.8348%205.82858%2067.835%204.70601C67.835%204.61337%2067.8319%204.52026%2067.8407%204.42824C67.8561%204.2682%2067.9187%204.20825%2068.073%204.19213C68.1036%204.18888%2068.1348%204.1895%2068.1656%204.1895C68.506%204.1895%2068.8463%204.1895%2069.1865%204.18996C69.2278%204.18996%2069.2693%204.19012%2069.3099%204.19616C69.44%204.21537%2069.5091%204.28571%2069.5219%204.42095C69.5297%204.5026%2069.5261%204.58548%2069.5261%204.6679C69.5263%206.02719%2069.5261%207.38664%2069.5261%208.74593V8.74608Z'%20fill='white'/%3e%3cpath%20id='Vector_25'%20d='M16.2498%209.2924C15.0789%209.33222%2014.0814%208.30957%2014.0845%207.09885C14.0876%205.90037%2015.0459%204.93195%2016.2861%204.93164C17.7687%204.93133%2018.4773%206.20077%2018.4662%207.14998C18.45%208.51686%2017.2375%209.35313%2016.2498%209.2924Z'%20fill='%23F06627'/%3e%3cpath%20id='Vector_26'%20d='M22.6249%2011.3378C22.6266%2012.5648%2021.6717%2013.5384%2020.4647%2013.5437C19.3612%2013.5485%2018.2598%2012.6789%2018.2612%2011.3767C18.2625%2010.1576%2019.223%209.17412%2020.4255%209.16993C21.4993%209.16622%2022.6398%2010.0124%2022.6249%2011.3376V11.3378Z'%20fill='%23F06627'/%3e%3cpath%20id='Vector_27'%20d='M224.046%207.56953C224.325%207.56953%20224.603%207.56612%20224.882%207.57093C225.032%207.57356%20225.065%207.61152%20225.071%207.75482C225.073%207.81648%20225.073%207.87876%20225.067%207.94011C225.059%208.02454%20225.014%208.07566%20224.93%208.08016C224.775%208.08837%20224.62%208.08418%20224.466%208.09023C224.349%208.09487%20224.321%208.12415%20224.315%208.23864C224.311%208.33129%20224.313%208.42409%20224.313%208.51688C224.312%208.82611%20224.314%209.13549%20224.312%209.44471C224.311%209.74155%20224.31%209.74155%20224.026%209.74155C223.995%209.74155%20223.964%209.74248%20223.933%209.74124C223.751%209.73364%20223.721%209.70793%20223.719%209.51784C223.715%209.13642%20223.719%208.755%20223.717%208.37358C223.715%208.09054%20223.714%208.09069%20223.42%208.08728C223.317%208.08604%20223.214%208.08511%20223.11%208.0814C223.067%208.07985%20223.022%208.06002%20223.009%208.02113C222.966%207.89146%20222.963%207.75823%20223.013%207.62933C223.022%207.60625%20223.06%207.58487%20223.087%207.58038C223.147%207.57046%20223.21%207.56938%20223.272%207.56907C223.53%207.56798%20223.788%207.5686%20224.046%207.5686V7.56953Z'%20fill='white'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_10148_21361'%3e%3crect%20width='227.968'%20height='31'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";
class Tke extends Cz {
  state = {
    hasError: !1
  };
  //https://react.dev/reference/react/Component#catching-rendering-errors-with-an-error-boundary
  static getDerivedStateFromError(t) {
    return { hasError: !0, error: t };
  }
  componentDidCatch(t, r) {
    console.error("Uncaught error:", t, r);
  }
  render() {
    return this.props.children(this.state.hasError);
  }
}
function vTt({ children: e }) {
  const { t } = fi(), r = () => /* @__PURE__ */ V.jsx("header", { className: "h-16 bg-[#041e42]", children: /* @__PURE__ */ V.jsx(
    "img",
    {
      alt: "Credit Acceptance Logo",
      width: 228,
      height: 31,
      src: Oke,
      className: "p-5"
    }
  ) });
  return /* @__PURE__ */ V.jsx(Tke, { children: (a) => a ? /* @__PURE__ */ V.jsxs("div", { className: "flex min-h-dvh flex-col", children: [
    /* @__PURE__ */ V.jsx(r, {}),
    /* @__PURE__ */ V.jsxs("div", { className: "flex flex-1 flex-col items-center justify-center gap-4", children: [
      /* @__PURE__ */ V.jsx("h1", { className: "text-3xl font-semibold text-gray-900", children: t("errorBoundary.somethingWentWrong") }),
      /* @__PURE__ */ V.jsx("p", { className: "text-gray-600", children: t("errorBoundary.contactSupportText") }),
      /* @__PURE__ */ V.jsx(
        Qw,
        {
          label: t("errorBoundary.refreshPage"),
          onClick: () => window.location.reload(),
          kind: "primary",
          data_testid: "error-boundary-refresh-button"
        }
      )
    ] }),
    /* @__PURE__ */ V.jsx(kke, { hideCaliforniaResidentWarning: !0 })
  ] }) : e });
}
const rte = fp(
  void 0
);
function v7() {
  const e = Do(rte);
  if (e === void 0)
    throw new Error("useFieldContext must be used within a FieldProvider");
  return e;
}
const Rke = {
  alignColumns: !1
}, ate = fp(Rke);
function Ake() {
  return Do(ate);
}
function Nke({
  alignColumns: e,
  children: t
}) {
  return /* @__PURE__ */ V.jsx(ate.Provider, { value: { alignColumns: e }, children: t });
}
const ote = fl(
  lt("mr-auto [text-wrap:inherit] text-(color:--field-label-color)"),
  {
    variants: {
      important: {
        true: "font-(--field-label-important-font-weight)",
        false: "font-(--field-label-font-weight)"
      },
      required: {
        true: "after:content-['*']"
      },
      button: {
        true: "text-(color:--field-onSecondary-label-color) cursor-pointer underline"
      }
    }
  }
), Dke = () => {
  const { important: e, label: t, onSecondary: r, required: a, testId: i } = v7();
  return /* @__PURE__ */ V.jsx(
    "button",
    {
      "data-testid": `${i}-label`,
      onClick: r,
      className: ote({ important: e, required: a, button: !0 }),
      children: t
    }
  );
}, $ke = () => {
  const { id: e, important: t, label: r, required: a, testId: i } = v7();
  return /* @__PURE__ */ V.jsx(
    "label",
    {
      "data-testid": `${i}-label`,
      htmlFor: e,
      className: ote({ important: t, required: a }),
      children: r
    }
  );
}, zke = () => {
  const { classNames: e, labelSuffix: t, onSecondary: r, size: a, sublabel: i, testId: c } = v7();
  return /* @__PURE__ */ V.jsxs(
    "div",
    {
      className: lt(
        "col-start-1 m-0 flex flex-col gap-1 p-0",
        "font-sans",
        e?.label,
        // The Figma spec does not include designs for a large label size
        a === "small" ? "text-(length:--text-xs) leading-(--text-xs)" : "text-(length:--text-sm) leading-(--text-sm)"
      ),
      children: [
        /* @__PURE__ */ V.jsxs(
          "span",
          {
            className: lt("inline-flex items-center gap-1", t && "w-fit"),
            children: [
              r ? /* @__PURE__ */ V.jsx(Dke, {}) : /* @__PURE__ */ V.jsx($ke, {}),
              t
            ]
          }
        ),
        i && /* @__PURE__ */ V.jsx("p", { "data-testid": `${c}-sublabel`, children: i })
      ]
    }
  );
}, jke = () => {
  const { error: e, testId: t, alignInput: r } = v7();
  return e ? /* @__PURE__ */ V.jsxs(
    "p",
    {
      "data-testid": `${t}-error`,
      className: lt(
        "gap-(--field-error-label-gap) m-0 flex items-center p-0",
        "font-(family-name:--font-sans) font-(--field-error-font-weight)",
        "text-(color:--field-error-text-color)",
        "text-(length:--field-error-font-size)",
        r === "left" ? "justify-start" : "justify-end"
      ),
      children: [
        /* @__PURE__ */ V.jsx(
          _f,
          {
            name: "warning",
            className: "w-(--field-error-icon-size) h-(--field-error-icon-size)"
          }
        ),
        e
      ]
    }
  ) : null;
}, Ike = ({
  text: e,
  testId: t,
  size: r,
  id: a
}) => /* @__PURE__ */ V.jsx(
  "p",
  {
    className: lt(
      "m-0 p-0",
      // The Figma spec does not include designs for a large label size
      r === "small" ? "text-(length:--text-xs) leading-(--text-xs)" : "text-(length:--text-sm) leading-(--text-sm)"
    ),
    "data-testid": t,
    id: a,
    children: e
  }
), Lke = () => {
  const {
    alignInput: e,
    id: t,
    position: r,
    size: a,
    required: i,
    testId: c,
    properties: d,
    isError: f,
    error: p
  } = v7();
  return /* @__PURE__ */ V.jsxs(
    "div",
    {
      className: lt(
        "font-(family-name:--font-sans)",
        r === "horizontal" && "col-start-2",
        "grid grid-cols-1 grid-rows-subgrid",
        p && "row-span-2",
        e === "left" ? "text-left" : "text-right"
      ),
      children: [
        d.kind === "inputSplit" ? /* @__PURE__ */ V.jsx(q6t, { ...d, size: a, inputSplitId: t }) : d.kind === "static" ? /* @__PURE__ */ V.jsx(
          Ike,
          {
            ...d,
            testId: `${c}-static`,
            size: a,
            id: t
          }
        ) : /* @__PURE__ */ V.jsx(
          sS,
          {
            ...d,
            id: t,
            isError: f,
            required: i,
            size: a,
            "data-testid": d.dataTestId ?? `${c}-input`
          }
        ),
        /* @__PURE__ */ V.jsx(jke, {})
      ]
    }
  );
}, Hke = ({
  alignInput: e = "right",
  className: t,
  classNames: r,
  error: a,
  id: i,
  important: c = !1,
  label: d,
  labelSuffix: f,
  onSecondary: p,
  position: g = "horizontal",
  required: b = !1,
  size: w = "medium",
  sublabel: x,
  testId: E = "field",
  ...P
}) => {
  const k = i || (d ?? "").replaceAll(/\s+/g, ""), M = !!a || a === "", { alignColumns: T } = Ake();
  return /* @__PURE__ */ V.jsx(
    rte.Provider,
    {
      value: {
        alignInput: e,
        classNames: r,
        required: b,
        onSecondary: p,
        id: k,
        important: c,
        label: d,
        labelSuffix: f,
        error: a,
        isError: M,
        testId: E,
        position: g,
        properties: P,
        size: w,
        sublabel: x
      },
      children: /* @__PURE__ */ V.jsx("div", { "data-preflight": !0, className: "contents", children: /* @__PURE__ */ V.jsxs(
        "div",
        {
          className: lt(
            "font-inherit gap-x-(--field-gap) gap-y-(--field-gap) grid text-inherit",
            w === "small" && "gap-x-(--field-gap-sm) gap-y-(--field-gap-sm)",
            g === "horizontal" ? "grid-cols-[auto_1fr] items-center" : "grid-cols-1",
            T && "col-span-2 grid grid-cols-subgrid",
            t
          ),
          "data-testid": E,
          children: [
            /* @__PURE__ */ V.jsx(zke, {}),
            /* @__PURE__ */ V.jsx(Lke, {})
          ]
        }
      ) })
    }
  );
}, bTt = ({
  alignColumns: e = !1,
  children: t,
  fields: r,
  layout: a = "vertical",
  groupLabel: i
}) => /* @__PURE__ */ V.jsx(Nke, { alignColumns: e, children: /* @__PURE__ */ V.jsxs("div", { "data-preflight": !0, className: "contents", children: [
  i && /* @__PURE__ */ V.jsx("h3", { className: "font-(--font-semibold) text-(length:--text-md) font-(family-name:--font-sans) mb-1", children: i }),
  /* @__PURE__ */ V.jsxs(
    "div",
    {
      className: lt(
        "flex flex-col gap-3",
        e && "grid grid-cols-[max-content_1fr]"
      ),
      children: [
        r && r.map((c, d) => /* @__PURE__ */ V.jsx(Hke, { ...c, position: a }, d)),
        t
      ]
    }
  )
] }) });
var k$ = function(e, t) {
  return k$ = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, a) {
    r.__proto__ = a;
  } || function(r, a) {
    for (var i in a) Object.prototype.hasOwnProperty.call(a, i) && (r[i] = a[i]);
  }, k$(e, t);
};
function Fke(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  k$(e, t);
  function r() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
}
var Fl = function() {
  return Fl = Object.assign || function(t) {
    for (var r, a = 1, i = arguments.length; a < i; a++) {
      r = arguments[a];
      for (var c in r) Object.prototype.hasOwnProperty.call(r, c) && (t[c] = r[c]);
    }
    return t;
  }, Fl.apply(this, arguments);
};
function dI(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, a = Object.getOwnPropertySymbols(e); i < a.length; i++)
      t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (r[a[i]] = e[a[i]]);
  return r;
}
function wP(e, t, r, a) {
  function i(c) {
    return c instanceof r ? c : new r(function(d) {
      d(c);
    });
  }
  return new (r || (r = Promise))(function(c, d) {
    function f(b) {
      try {
        g(a.next(b));
      } catch (w) {
        d(w);
      }
    }
    function p(b) {
      try {
        g(a.throw(b));
      } catch (w) {
        d(w);
      }
    }
    function g(b) {
      b.done ? c(b.value) : i(b.value).then(f, p);
    }
    g((a = a.apply(e, t || [])).next());
  });
}
function Wke(e, t, r) {
  if (r || arguments.length === 2) for (var a = 0, i = t.length, c; a < i; a++)
    (c || !(a in t)) && (c || (c = Array.prototype.slice.call(t, 0, a)), c[a] = t[a]);
  return e.concat(c || Array.prototype.slice.call(t));
}
var vA, uB;
function Vke() {
  if (uB) return vA;
  uB = 1;
  var e = !1, t, r, a, i, c, d, f, p, g, b, w, x, E, P, k;
  function M() {
    if (!e) {
      e = !0;
      var N = navigator.userAgent, D = /(?:MSIE.(\d+\.\d+))|(?:(?:Firefox|GranParadiso|Iceweasel).(\d+\.\d+))|(?:Opera(?:.+Version.|.)(\d+\.\d+))|(?:AppleWebKit.(\d+(?:\.\d+)?))|(?:Trident\/\d+\.\d+.*rv:(\d+\.\d+))/.exec(N), $ = /(Mac OS X)|(Windows)|(Linux)/.exec(N);
      if (x = /\b(iPhone|iP[ao]d)/.exec(N), E = /\b(iP[ao]d)/.exec(N), b = /Android/i.exec(N), P = /FBAN\/\w+;/i.exec(N), k = /Mobile/i.exec(N), w = !!/Win64/.exec(N), D) {
        t = D[1] ? parseFloat(D[1]) : D[5] ? parseFloat(D[5]) : NaN, t && document && document.documentMode && (t = document.documentMode);
        var j = /(?:Trident\/(\d+.\d+))/.exec(N);
        d = j ? parseFloat(j[1]) + 4 : t, r = D[2] ? parseFloat(D[2]) : NaN, a = D[3] ? parseFloat(D[3]) : NaN, i = D[4] ? parseFloat(D[4]) : NaN, i ? (D = /(?:Chrome\/(\d+\.\d+))/.exec(N), c = D && D[1] ? parseFloat(D[1]) : NaN) : c = NaN;
      } else
        t = r = a = c = i = NaN;
      if ($) {
        if ($[1]) {
          var I = /(?:Mac OS X (\d+(?:[._]\d+)?))/.exec(N);
          f = I ? parseFloat(I[1].replace("_", ".")) : !0;
        } else
          f = !1;
        p = !!$[2], g = !!$[3];
      } else
        f = p = g = !1;
    }
  }
  var T = {
    /**
     *  Check if the UA is Internet Explorer.
     *
     *
     *  @return float|NaN Version number (if match) or NaN.
     */
    ie: function() {
      return M() || t;
    },
    /**
     * Check if we're in Internet Explorer compatibility mode.
     *
     * @return bool true if in compatibility mode, false if
     * not compatibility mode or not ie
     */
    ieCompatibilityMode: function() {
      return M() || d > t;
    },
    /**
     * Whether the browser is 64-bit IE.  Really, this is kind of weak sauce;  we
     * only need this because Skype can't handle 64-bit IE yet.  We need to remove
     * this when we don't need it -- tracked by #601957.
     */
    ie64: function() {
      return T.ie() && w;
    },
    /**
     *  Check if the UA is Firefox.
     *
     *
     *  @return float|NaN Version number (if match) or NaN.
     */
    firefox: function() {
      return M() || r;
    },
    /**
     *  Check if the UA is Opera.
     *
     *
     *  @return float|NaN Version number (if match) or NaN.
     */
    opera: function() {
      return M() || a;
    },
    /**
     *  Check if the UA is WebKit.
     *
     *
     *  @return float|NaN Version number (if match) or NaN.
     */
    webkit: function() {
      return M() || i;
    },
    /**
     *  For Push
     *  WILL BE REMOVED VERY SOON. Use UserAgent_DEPRECATED.webkit
     */
    safari: function() {
      return T.webkit();
    },
    /**
     *  Check if the UA is a Chrome browser.
     *
     *
     *  @return float|NaN Version number (if match) or NaN.
     */
    chrome: function() {
      return M() || c;
    },
    /**
     *  Check if the user is running Windows.
     *
     *  @return bool `true' if the user's OS is Windows.
     */
    windows: function() {
      return M() || p;
    },
    /**
     *  Check if the user is running Mac OS X.
     *
     *  @return float|bool   Returns a float if a version number is detected,
     *                       otherwise true/false.
     */
    osx: function() {
      return M() || f;
    },
    /**
     * Check if the user is running Linux.
     *
     * @return bool `true' if the user's OS is some flavor of Linux.
     */
    linux: function() {
      return M() || g;
    },
    /**
     * Check if the user is running on an iPhone or iPod platform.
     *
     * @return bool `true' if the user is running some flavor of the
     *    iPhone OS.
     */
    iphone: function() {
      return M() || x;
    },
    mobile: function() {
      return M() || x || E || b || k;
    },
    nativeApp: function() {
      return M() || P;
    },
    android: function() {
      return M() || b;
    },
    ipad: function() {
      return M() || E;
    }
  };
  return vA = T, vA;
}
var bA, cB;
function _ke() {
  if (cB) return bA;
  cB = 1;
  var e = !!(typeof window < "u" && window.document && window.document.createElement), t = {
    canUseDOM: e,
    canUseWorkers: typeof Worker < "u",
    canUseEventListeners: e && !!(window.addEventListener || window.attachEvent),
    canUseViewport: e && !!window.screen,
    isInWorker: !e
    // For now, this is true - might change in the future.
  };
  return bA = t, bA;
}
var yA, dB;
function Bke() {
  if (dB) return yA;
  dB = 1;
  var e = _ke(), t;
  e.canUseDOM && (t = document.implementation && document.implementation.hasFeature && // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature("", "") !== !0);
  /**
   * Checks if an event is supported in the current execution environment.
   *
   * NOTE: This will not work correctly for non-generic events such as `change`,
   * `reset`, `load`, `error`, and `select`.
   *
   * Borrows from Modernizr.
   *
   * @param {string} eventNameSuffix Event name, e.g. "click".
   * @param {?boolean} capture Check if the capture phase is supported.
   * @return {boolean} True if the event is supported.
   * @internal
   * @license Modernizr 3.0.0pre (Custom Build) | MIT
   */
  function r(a, i) {
    if (!e.canUseDOM || i && !("addEventListener" in document))
      return !1;
    var c = "on" + a, d = c in document;
    if (!d) {
      var f = document.createElement("div");
      f.setAttribute(c, "return;"), d = typeof f[c] == "function";
    }
    return !d && t && a === "wheel" && (d = document.implementation.hasFeature("Events.wheel", "3.0")), d;
  }
  return yA = r, yA;
}
var wA, fB;
function Uke() {
  if (fB) return wA;
  fB = 1;
  var e = Vke(), t = Bke(), r = 10, a = 40, i = 800;
  function c(d) {
    var f = 0, p = 0, g = 0, b = 0;
    return "detail" in d && (p = d.detail), "wheelDelta" in d && (p = -d.wheelDelta / 120), "wheelDeltaY" in d && (p = -d.wheelDeltaY / 120), "wheelDeltaX" in d && (f = -d.wheelDeltaX / 120), "axis" in d && d.axis === d.HORIZONTAL_AXIS && (f = p, p = 0), g = f * r, b = p * r, "deltaY" in d && (b = d.deltaY), "deltaX" in d && (g = d.deltaX), (g || b) && d.deltaMode && (d.deltaMode == 1 ? (g *= a, b *= a) : (g *= i, b *= i)), g && !f && (f = g < 1 ? -1 : 1), b && !p && (p = b < 1 ? -1 : 1), {
      spinX: f,
      spinY: p,
      pixelX: g,
      pixelY: b
    };
  }
  return c.getEventType = function() {
    return e.firefox() ? "DOMMouseScroll" : t("wheel") ? "wheel" : "mousewheel";
  }, wA = c, wA;
}
var SA, mB;
function Xke() {
  return mB || (mB = 1, SA = Uke()), SA;
}
var Gke = Xke();
const qke = /* @__PURE__ */ Sb(Gke);
function Kke(e, t, r, a, i, c) {
  c === void 0 && (c = 0);
  var d = Ax(e, t, c), f = d.width, p = d.height, g = Math.min(f, r), b = Math.min(p, a);
  return g > b * i ? {
    width: b * i,
    height: b
  } : {
    width: g,
    height: g / i
  };
}
function Yke(e) {
  return e.width > e.height ? e.width / e.naturalWidth : e.height / e.naturalHeight;
}
function W5(e, t, r, a, i) {
  i === void 0 && (i = 0);
  var c = Ax(t.width, t.height, i), d = c.width, f = c.height;
  return {
    x: hB(e.x, d, r.width, a),
    y: hB(e.y, f, r.height, a)
  };
}
function hB(e, t, r, a) {
  var i = t * a / 2 - r / 2;
  return AM(e, -i, i);
}
function pB(e, t) {
  return Math.sqrt(Math.pow(e.y - t.y, 2) + Math.pow(e.x - t.x, 2));
}
function gB(e, t) {
  return Math.atan2(t.y - e.y, t.x - e.x) * 180 / Math.PI;
}
function Qke(e, t, r, a, i, c, d) {
  c === void 0 && (c = 0), d === void 0 && (d = !0);
  var f = d ? Jke : Zke, p = Ax(t.width, t.height, c), g = Ax(t.naturalWidth, t.naturalHeight, c), b = {
    x: f(100, ((p.width - r.width / i) / 2 - e.x / i) / p.width * 100),
    y: f(100, ((p.height - r.height / i) / 2 - e.y / i) / p.height * 100),
    width: f(100, r.width / p.width * 100 / i),
    height: f(100, r.height / p.height * 100 / i)
  }, w = Math.round(f(g.width, b.width * g.width / 100)), x = Math.round(f(g.height, b.height * g.height / 100)), E = g.width >= g.height * a, P = E ? {
    width: Math.round(x * a),
    height: x
  } : {
    width: w,
    height: Math.round(w / a)
  }, k = Fl(Fl({}, P), {
    x: Math.round(f(g.width - P.width, b.x * g.width / 100)),
    y: Math.round(f(g.height - P.height, b.y * g.height / 100))
  });
  return {
    croppedAreaPercentages: b,
    croppedAreaPixels: k
  };
}
function Jke(e, t) {
  return Math.min(e, Math.max(0, t));
}
function Zke(e, t) {
  return t;
}
function e9e(e, t, r, a, i, c) {
  var d = Ax(t.width, t.height, r), f = AM(a.width / d.width * (100 / e.width), i, c), p = {
    x: f * d.width / 2 - a.width / 2 - d.width * f * (e.x / 100),
    y: f * d.height / 2 - a.height / 2 - d.height * f * (e.y / 100)
  };
  return {
    crop: p,
    zoom: f
  };
}
function t9e(e, t, r) {
  var a = Yke(t);
  return r.height > r.width ? r.height / (e.height * a) : r.width / (e.width * a);
}
function n9e(e, t, r, a, i, c) {
  r === void 0 && (r = 0);
  var d = Ax(t.naturalWidth, t.naturalHeight, r), f = AM(t9e(e, t, a), i, c), p = a.height > a.width ? a.height / e.height : a.width / e.width, g = {
    x: ((d.width - e.width) / 2 - e.x) * p,
    y: ((d.height - e.height) / 2 - e.y) * p
  };
  return {
    crop: g,
    zoom: f
  };
}
function vB(e, t) {
  return {
    x: (t.x + e.x) / 2,
    y: (t.y + e.y) / 2
  };
}
function r9e(e) {
  return e * Math.PI / 180;
}
function Ax(e, t, r) {
  var a = r9e(r);
  return {
    width: Math.abs(Math.cos(a) * e) + Math.abs(Math.sin(a) * t),
    height: Math.abs(Math.sin(a) * e) + Math.abs(Math.cos(a) * t)
  };
}
function AM(e, t, r) {
  return Math.min(Math.max(e, t), r);
}
function SP() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return e.filter(function(r) {
    return typeof r == "string" && r.length > 0;
  }).join(" ").trim();
}
var a9e = `.reactEasyCrop_Container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  user-select: none;
  touch-action: none;
  cursor: move;
  display: flex;
  justify-content: center;
  align-items: center;
}

.reactEasyCrop_Image,
.reactEasyCrop_Video {
  will-change: transform; /* this improves performances and prevent painting issues on iOS Chrome */
}

.reactEasyCrop_Contain {
  max-width: 100%;
  max-height: 100%;
  margin: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.reactEasyCrop_Cover_Horizontal {
  width: 100%;
  height: auto;
}
.reactEasyCrop_Cover_Vertical {
  width: auto;
  height: 100%;
}

.reactEasyCrop_CropArea {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border: 1px solid rgba(255, 255, 255, 0.5);
  box-sizing: border-box;
  box-shadow: 0 0 0 9999em;
  color: rgba(0, 0, 0, 0.5);
  overflow: hidden;
}

.reactEasyCrop_CropAreaRound {
  border-radius: 50%;
}

.reactEasyCrop_CropAreaGrid::before {
  content: ' ';
  box-sizing: border-box;
  position: absolute;
  border: 1px solid rgba(255, 255, 255, 0.5);
  top: 0;
  bottom: 0;
  left: 33.33%;
  right: 33.33%;
  border-top: 0;
  border-bottom: 0;
}

.reactEasyCrop_CropAreaGrid::after {
  content: ' ';
  box-sizing: border-box;
  position: absolute;
  border: 1px solid rgba(255, 255, 255, 0.5);
  top: 33.33%;
  bottom: 33.33%;
  left: 0;
  right: 0;
  border-left: 0;
  border-right: 0;
}
`, o9e = 1, i9e = 3, l9e = 1, s9e = (
  /** @class */
  (function(e) {
    Fke(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r.cropperRef = S.createRef(), r.imageRef = S.createRef(), r.videoRef = S.createRef(), r.containerPosition = {
        x: 0,
        y: 0
      }, r.containerRef = null, r.styleRef = null, r.containerRect = null, r.mediaSize = {
        width: 0,
        height: 0,
        naturalWidth: 0,
        naturalHeight: 0
      }, r.dragStartPosition = {
        x: 0,
        y: 0
      }, r.dragStartCrop = {
        x: 0,
        y: 0
      }, r.gestureZoomStart = 0, r.gestureRotationStart = 0, r.isTouching = !1, r.lastPinchDistance = 0, r.lastPinchRotation = 0, r.rafDragTimeout = null, r.rafPinchTimeout = null, r.wheelTimer = null, r.currentDoc = typeof document < "u" ? document : null, r.currentWindow = typeof window < "u" ? window : null, r.resizeObserver = null, r.previousCropSize = null, r.isInitialized = !1, r.state = {
        cropSize: null,
        hasWheelJustStarted: !1,
        mediaObjectFit: void 0
      }, r.initResizeObserver = function() {
        if (!(typeof window.ResizeObserver > "u" || !r.containerRef)) {
          var a = !0;
          r.resizeObserver = new window.ResizeObserver(function(i) {
            if (a) {
              a = !1;
              return;
            }
            r.computeSizes();
          }), r.resizeObserver.observe(r.containerRef);
        }
      }, r.preventZoomSafari = function(a) {
        return a.preventDefault();
      }, r.cleanEvents = function() {
        r.currentDoc && (r.currentDoc.removeEventListener("mousemove", r.onMouseMove), r.currentDoc.removeEventListener("mouseup", r.onDragStopped), r.currentDoc.removeEventListener("touchmove", r.onTouchMove), r.currentDoc.removeEventListener("touchend", r.onDragStopped), r.currentDoc.removeEventListener("gesturechange", r.onGestureChange), r.currentDoc.removeEventListener("gestureend", r.onGestureEnd), r.currentDoc.removeEventListener("scroll", r.onScroll));
      }, r.clearScrollEvent = function() {
        r.containerRef && r.containerRef.removeEventListener("wheel", r.onWheel), r.wheelTimer && clearTimeout(r.wheelTimer);
      }, r.onMediaLoad = function() {
        var a = r.computeSizes();
        a && (r.previousCropSize = a, r.emitCropData(), r.setInitialCrop(a), r.isInitialized = !0), r.props.onMediaLoaded && r.props.onMediaLoaded(r.mediaSize);
      }, r.setInitialCrop = function(a) {
        if (r.props.initialCroppedAreaPercentages) {
          var i = e9e(r.props.initialCroppedAreaPercentages, r.mediaSize, r.props.rotation, a, r.props.minZoom, r.props.maxZoom), c = i.crop, d = i.zoom;
          r.props.onCropChange(c), r.props.onZoomChange && r.props.onZoomChange(d);
        } else if (r.props.initialCroppedAreaPixels) {
          var f = n9e(r.props.initialCroppedAreaPixels, r.mediaSize, r.props.rotation, a, r.props.minZoom, r.props.maxZoom), c = f.crop, d = f.zoom;
          r.props.onCropChange(c), r.props.onZoomChange && r.props.onZoomChange(d);
        }
      }, r.computeSizes = function() {
        var a, i, c, d, f, p, g = r.imageRef.current || r.videoRef.current;
        if (g && r.containerRef) {
          r.containerRect = r.containerRef.getBoundingClientRect(), r.saveContainerPosition();
          var b = r.containerRect.width / r.containerRect.height, w = ((a = r.imageRef.current) === null || a === void 0 ? void 0 : a.naturalWidth) || ((i = r.videoRef.current) === null || i === void 0 ? void 0 : i.videoWidth) || 0, x = ((c = r.imageRef.current) === null || c === void 0 ? void 0 : c.naturalHeight) || ((d = r.videoRef.current) === null || d === void 0 ? void 0 : d.videoHeight) || 0, E = g.offsetWidth < w || g.offsetHeight < x, P = w / x, k = void 0;
          if (E)
            switch (r.state.mediaObjectFit) {
              default:
              case "contain":
                k = b > P ? {
                  width: r.containerRect.height * P,
                  height: r.containerRect.height
                } : {
                  width: r.containerRect.width,
                  height: r.containerRect.width / P
                };
                break;
              case "horizontal-cover":
                k = {
                  width: r.containerRect.width,
                  height: r.containerRect.width / P
                };
                break;
              case "vertical-cover":
                k = {
                  width: r.containerRect.height * P,
                  height: r.containerRect.height
                };
                break;
            }
          else
            k = {
              width: g.offsetWidth,
              height: g.offsetHeight
            };
          r.mediaSize = Fl(Fl({}, k), {
            naturalWidth: w,
            naturalHeight: x
          }), r.props.setMediaSize && r.props.setMediaSize(r.mediaSize);
          var M = r.props.cropSize ? r.props.cropSize : Kke(r.mediaSize.width, r.mediaSize.height, r.containerRect.width, r.containerRect.height, r.props.aspect, r.props.rotation);
          return (((f = r.state.cropSize) === null || f === void 0 ? void 0 : f.height) !== M.height || ((p = r.state.cropSize) === null || p === void 0 ? void 0 : p.width) !== M.width) && r.props.onCropSizeChange && r.props.onCropSizeChange(M), r.setState({
            cropSize: M
          }, r.recomputeCropPosition), r.props.setCropSize && r.props.setCropSize(M), M;
        }
      }, r.saveContainerPosition = function() {
        if (r.containerRef) {
          var a = r.containerRef.getBoundingClientRect();
          r.containerPosition = {
            x: a.left,
            y: a.top
          };
        }
      }, r.onMouseDown = function(a) {
        r.currentDoc && (a.preventDefault(), r.currentDoc.addEventListener("mousemove", r.onMouseMove), r.currentDoc.addEventListener("mouseup", r.onDragStopped), r.saveContainerPosition(), r.onDragStart(t.getMousePoint(a)));
      }, r.onMouseMove = function(a) {
        return r.onDrag(t.getMousePoint(a));
      }, r.onScroll = function(a) {
        r.currentDoc && (a.preventDefault(), r.saveContainerPosition());
      }, r.onTouchStart = function(a) {
        r.currentDoc && (r.isTouching = !0, !(r.props.onTouchRequest && !r.props.onTouchRequest(a)) && (r.currentDoc.addEventListener("touchmove", r.onTouchMove, {
          passive: !1
        }), r.currentDoc.addEventListener("touchend", r.onDragStopped), r.saveContainerPosition(), a.touches.length === 2 ? r.onPinchStart(a) : a.touches.length === 1 && r.onDragStart(t.getTouchPoint(a.touches[0]))));
      }, r.onTouchMove = function(a) {
        a.preventDefault(), a.touches.length === 2 ? r.onPinchMove(a) : a.touches.length === 1 && r.onDrag(t.getTouchPoint(a.touches[0]));
      }, r.onGestureStart = function(a) {
        r.currentDoc && (a.preventDefault(), r.currentDoc.addEventListener("gesturechange", r.onGestureChange), r.currentDoc.addEventListener("gestureend", r.onGestureEnd), r.gestureZoomStart = r.props.zoom, r.gestureRotationStart = r.props.rotation);
      }, r.onGestureChange = function(a) {
        if (a.preventDefault(), !r.isTouching) {
          var i = t.getMousePoint(a), c = r.gestureZoomStart - 1 + a.scale;
          if (r.setNewZoom(c, i, {
            shouldUpdatePosition: !0
          }), r.props.onRotationChange) {
            var d = r.gestureRotationStart + a.rotation;
            r.props.onRotationChange(d);
          }
        }
      }, r.onGestureEnd = function(a) {
        r.cleanEvents();
      }, r.onDragStart = function(a) {
        var i, c, d = a.x, f = a.y;
        r.dragStartPosition = {
          x: d,
          y: f
        }, r.dragStartCrop = Fl({}, r.props.crop), (c = (i = r.props).onInteractionStart) === null || c === void 0 || c.call(i);
      }, r.onDrag = function(a) {
        var i = a.x, c = a.y;
        r.currentWindow && (r.rafDragTimeout && r.currentWindow.cancelAnimationFrame(r.rafDragTimeout), r.rafDragTimeout = r.currentWindow.requestAnimationFrame(function() {
          if (r.state.cropSize && !(i === void 0 || c === void 0)) {
            var d = i - r.dragStartPosition.x, f = c - r.dragStartPosition.y, p = {
              x: r.dragStartCrop.x + d,
              y: r.dragStartCrop.y + f
            }, g = r.props.restrictPosition ? W5(p, r.mediaSize, r.state.cropSize, r.props.zoom, r.props.rotation) : p;
            r.props.onCropChange(g);
          }
        }));
      }, r.onDragStopped = function() {
        var a, i;
        r.isTouching = !1, r.cleanEvents(), r.emitCropData(), (i = (a = r.props).onInteractionEnd) === null || i === void 0 || i.call(a);
      }, r.onWheel = function(a) {
        if (r.currentWindow && !(r.props.onWheelRequest && !r.props.onWheelRequest(a))) {
          a.preventDefault();
          var i = t.getMousePoint(a), c = qke(a).pixelY, d = r.props.zoom - c * r.props.zoomSpeed / 200;
          r.setNewZoom(d, i, {
            shouldUpdatePosition: !0
          }), r.state.hasWheelJustStarted || r.setState({
            hasWheelJustStarted: !0
          }, function() {
            var f, p;
            return (p = (f = r.props).onInteractionStart) === null || p === void 0 ? void 0 : p.call(f);
          }), r.wheelTimer && clearTimeout(r.wheelTimer), r.wheelTimer = r.currentWindow.setTimeout(function() {
            return r.setState({
              hasWheelJustStarted: !1
            }, function() {
              var f, p;
              return (p = (f = r.props).onInteractionEnd) === null || p === void 0 ? void 0 : p.call(f);
            });
          }, 250);
        }
      }, r.getPointOnContainer = function(a, i) {
        var c = a.x, d = a.y;
        if (!r.containerRect)
          throw new Error("The Cropper is not mounted");
        return {
          x: r.containerRect.width / 2 - (c - i.x),
          y: r.containerRect.height / 2 - (d - i.y)
        };
      }, r.getPointOnMedia = function(a) {
        var i = a.x, c = a.y, d = r.props, f = d.crop, p = d.zoom;
        return {
          x: (i + f.x) / p,
          y: (c + f.y) / p
        };
      }, r.setNewZoom = function(a, i, c) {
        var d = c === void 0 ? {} : c, f = d.shouldUpdatePosition, p = f === void 0 ? !0 : f;
        if (!(!r.state.cropSize || !r.props.onZoomChange)) {
          var g = AM(a, r.props.minZoom, r.props.maxZoom);
          if (p) {
            var b = r.getPointOnContainer(i, r.containerPosition), w = r.getPointOnMedia(b), x = {
              x: w.x * g - b.x,
              y: w.y * g - b.y
            }, E = r.props.restrictPosition ? W5(x, r.mediaSize, r.state.cropSize, g, r.props.rotation) : x;
            r.props.onCropChange(E);
          }
          r.props.onZoomChange(g);
        }
      }, r.getCropData = function() {
        if (!r.state.cropSize)
          return null;
        var a = r.props.restrictPosition ? W5(r.props.crop, r.mediaSize, r.state.cropSize, r.props.zoom, r.props.rotation) : r.props.crop;
        return Qke(a, r.mediaSize, r.state.cropSize, r.getAspect(), r.props.zoom, r.props.rotation, r.props.restrictPosition);
      }, r.emitCropData = function() {
        var a = r.getCropData();
        if (a) {
          var i = a.croppedAreaPercentages, c = a.croppedAreaPixels;
          r.props.onCropComplete && r.props.onCropComplete(i, c), r.props.onCropAreaChange && r.props.onCropAreaChange(i, c);
        }
      }, r.emitCropAreaChange = function() {
        var a = r.getCropData();
        if (a) {
          var i = a.croppedAreaPercentages, c = a.croppedAreaPixels;
          r.props.onCropAreaChange && r.props.onCropAreaChange(i, c);
        }
      }, r.recomputeCropPosition = function() {
        var a, i;
        if (r.state.cropSize) {
          var c = r.props.crop;
          if (r.isInitialized && (!((a = r.previousCropSize) === null || a === void 0) && a.width) && (!((i = r.previousCropSize) === null || i === void 0) && i.height)) {
            var d = Math.abs(r.previousCropSize.width - r.state.cropSize.width) > 1e-6 || Math.abs(r.previousCropSize.height - r.state.cropSize.height) > 1e-6;
            if (d) {
              var f = r.state.cropSize.width / r.previousCropSize.width, p = r.state.cropSize.height / r.previousCropSize.height;
              c = {
                x: r.props.crop.x * f,
                y: r.props.crop.y * p
              };
            }
          }
          var g = r.props.restrictPosition ? W5(c, r.mediaSize, r.state.cropSize, r.props.zoom, r.props.rotation) : c;
          r.previousCropSize = r.state.cropSize, r.props.onCropChange(g), r.emitCropData();
        }
      }, r.onKeyDown = function(a) {
        var i, c, d = r.props, f = d.crop, p = d.onCropChange, g = d.keyboardStep, b = d.zoom, w = d.rotation, x = g;
        if (r.state.cropSize) {
          a.shiftKey && (x *= 0.2);
          var E = Fl({}, f);
          switch (a.key) {
            case "ArrowUp":
              E.y -= x, a.preventDefault();
              break;
            case "ArrowDown":
              E.y += x, a.preventDefault();
              break;
            case "ArrowLeft":
              E.x -= x, a.preventDefault();
              break;
            case "ArrowRight":
              E.x += x, a.preventDefault();
              break;
            default:
              return;
          }
          r.props.restrictPosition && (E = W5(E, r.mediaSize, r.state.cropSize, b, w)), a.repeat || (c = (i = r.props).onInteractionStart) === null || c === void 0 || c.call(i), p(E);
        }
      }, r.onKeyUp = function(a) {
        var i, c;
        switch (a.key) {
          case "ArrowUp":
          case "ArrowDown":
          case "ArrowLeft":
          case "ArrowRight":
            a.preventDefault();
            break;
          default:
            return;
        }
        r.emitCropData(), (c = (i = r.props).onInteractionEnd) === null || c === void 0 || c.call(i);
      }, r;
    }
    return t.prototype.componentDidMount = function() {
      !this.currentDoc || !this.currentWindow || (this.containerRef && (this.containerRef.ownerDocument && (this.currentDoc = this.containerRef.ownerDocument), this.currentDoc.defaultView && (this.currentWindow = this.currentDoc.defaultView), this.initResizeObserver(), typeof window.ResizeObserver > "u" && this.currentWindow.addEventListener("resize", this.computeSizes), this.props.zoomWithScroll && this.containerRef.addEventListener("wheel", this.onWheel, {
        passive: !1
      }), this.containerRef.addEventListener("gesturestart", this.onGestureStart)), this.currentDoc.addEventListener("scroll", this.onScroll), this.props.disableAutomaticStylesInjection || (this.styleRef = this.currentDoc.createElement("style"), this.styleRef.setAttribute("type", "text/css"), this.props.nonce && this.styleRef.setAttribute("nonce", this.props.nonce), this.styleRef.innerHTML = a9e, this.currentDoc.head.appendChild(this.styleRef)), this.imageRef.current && this.imageRef.current.complete && this.onMediaLoad(), this.props.setImageRef && this.props.setImageRef(this.imageRef), this.props.setVideoRef && this.props.setVideoRef(this.videoRef), this.props.setCropperRef && this.props.setCropperRef(this.cropperRef));
    }, t.prototype.componentWillUnmount = function() {
      var r, a;
      !this.currentDoc || !this.currentWindow || (typeof window.ResizeObserver > "u" && this.currentWindow.removeEventListener("resize", this.computeSizes), (r = this.resizeObserver) === null || r === void 0 || r.disconnect(), this.containerRef && this.containerRef.removeEventListener("gesturestart", this.preventZoomSafari), this.styleRef && ((a = this.styleRef.parentNode) === null || a === void 0 || a.removeChild(this.styleRef)), this.cleanEvents(), this.props.zoomWithScroll && this.clearScrollEvent());
    }, t.prototype.componentDidUpdate = function(r) {
      var a, i, c, d, f, p, g, b, w;
      r.rotation !== this.props.rotation ? (this.computeSizes(), this.recomputeCropPosition()) : r.aspect !== this.props.aspect ? this.computeSizes() : r.objectFit !== this.props.objectFit ? this.computeSizes() : r.zoom !== this.props.zoom ? this.recomputeCropPosition() : ((a = r.cropSize) === null || a === void 0 ? void 0 : a.height) !== ((i = this.props.cropSize) === null || i === void 0 ? void 0 : i.height) || ((c = r.cropSize) === null || c === void 0 ? void 0 : c.width) !== ((d = this.props.cropSize) === null || d === void 0 ? void 0 : d.width) ? this.computeSizes() : (((f = r.crop) === null || f === void 0 ? void 0 : f.x) !== ((p = this.props.crop) === null || p === void 0 ? void 0 : p.x) || ((g = r.crop) === null || g === void 0 ? void 0 : g.y) !== ((b = this.props.crop) === null || b === void 0 ? void 0 : b.y)) && this.emitCropAreaChange(), r.zoomWithScroll !== this.props.zoomWithScroll && this.containerRef && (this.props.zoomWithScroll ? this.containerRef.addEventListener("wheel", this.onWheel, {
        passive: !1
      }) : this.clearScrollEvent()), r.video !== this.props.video && ((w = this.videoRef.current) === null || w === void 0 || w.load());
      var x = this.getObjectFit();
      x !== this.state.mediaObjectFit && this.setState({
        mediaObjectFit: x
      }, this.computeSizes);
    }, t.prototype.getAspect = function() {
      var r = this.props, a = r.cropSize, i = r.aspect;
      return a ? a.width / a.height : i;
    }, t.prototype.getObjectFit = function() {
      var r, a, i, c;
      if (this.props.objectFit === "cover") {
        var d = this.imageRef.current || this.videoRef.current;
        if (d && this.containerRef) {
          this.containerRect = this.containerRef.getBoundingClientRect();
          var f = this.containerRect.width / this.containerRect.height, p = ((r = this.imageRef.current) === null || r === void 0 ? void 0 : r.naturalWidth) || ((a = this.videoRef.current) === null || a === void 0 ? void 0 : a.videoWidth) || 0, g = ((i = this.imageRef.current) === null || i === void 0 ? void 0 : i.naturalHeight) || ((c = this.videoRef.current) === null || c === void 0 ? void 0 : c.videoHeight) || 0, b = p / g;
          return b < f ? "horizontal-cover" : "vertical-cover";
        }
        return "horizontal-cover";
      }
      return this.props.objectFit;
    }, t.prototype.onPinchStart = function(r) {
      var a = t.getTouchPoint(r.touches[0]), i = t.getTouchPoint(r.touches[1]);
      this.lastPinchDistance = pB(a, i), this.lastPinchRotation = gB(a, i), this.onDragStart(vB(a, i));
    }, t.prototype.onPinchMove = function(r) {
      var a = this;
      if (!(!this.currentDoc || !this.currentWindow)) {
        var i = t.getTouchPoint(r.touches[0]), c = t.getTouchPoint(r.touches[1]), d = vB(i, c);
        this.onDrag(d), this.rafPinchTimeout && this.currentWindow.cancelAnimationFrame(this.rafPinchTimeout), this.rafPinchTimeout = this.currentWindow.requestAnimationFrame(function() {
          var f = pB(i, c), p = a.props.zoom * (f / a.lastPinchDistance);
          a.setNewZoom(p, d, {
            shouldUpdatePosition: !1
          }), a.lastPinchDistance = f;
          var g = gB(i, c), b = a.props.rotation + (g - a.lastPinchRotation);
          a.props.onRotationChange && a.props.onRotationChange(b), a.lastPinchRotation = g;
        });
      }
    }, t.prototype.render = function() {
      var r = this, a, i = this.props, c = i.image, d = i.video, f = i.mediaProps, p = i.cropperProps, g = i.transform, b = i.crop, w = b.x, x = b.y, E = i.rotation, P = i.zoom, k = i.cropShape, M = i.showGrid, T = i.roundCropAreaPixels, N = i.style, D = N.containerStyle, $ = N.cropAreaStyle, j = N.mediaStyle, I = i.classes, L = I.containerClassName, F = I.cropAreaClassName, _ = I.mediaClassName, W = (a = this.state.mediaObjectFit) !== null && a !== void 0 ? a : this.getObjectFit();
      return S.createElement("div", {
        onMouseDown: this.onMouseDown,
        onTouchStart: this.onTouchStart,
        ref: function(U) {
          return r.containerRef = U;
        },
        "data-testid": "container",
        style: D,
        className: SP("reactEasyCrop_Container", L)
      }, c ? S.createElement("img", Fl({
        alt: "",
        className: SP("reactEasyCrop_Image", W === "contain" && "reactEasyCrop_Contain", W === "horizontal-cover" && "reactEasyCrop_Cover_Horizontal", W === "vertical-cover" && "reactEasyCrop_Cover_Vertical", _)
      }, f, {
        src: c,
        ref: this.imageRef,
        style: Fl(Fl({}, j), {
          transform: g || "translate(".concat(w, "px, ").concat(x, "px) rotate(").concat(E, "deg) scale(").concat(P, ")")
        }),
        onLoad: this.onMediaLoad
      })) : d && S.createElement("video", Fl({
        autoPlay: !0,
        playsInline: !0,
        loop: !0,
        muted: !0,
        className: SP("reactEasyCrop_Video", W === "contain" && "reactEasyCrop_Contain", W === "horizontal-cover" && "reactEasyCrop_Cover_Horizontal", W === "vertical-cover" && "reactEasyCrop_Cover_Vertical", _)
      }, f, {
        ref: this.videoRef,
        onLoadedMetadata: this.onMediaLoad,
        style: Fl(Fl({}, j), {
          transform: g || "translate(".concat(w, "px, ").concat(x, "px) rotate(").concat(E, "deg) scale(").concat(P, ")")
        }),
        controls: !1
      }), (Array.isArray(d) ? d : [{
        src: d
      }]).map(function(Q) {
        return S.createElement("source", Fl({
          key: Q.src
        }, Q));
      })), this.state.cropSize && S.createElement("div", Fl({
        ref: this.cropperRef,
        style: Fl(Fl({}, $), {
          width: T ? Math.round(this.state.cropSize.width) : this.state.cropSize.width,
          height: T ? Math.round(this.state.cropSize.height) : this.state.cropSize.height
        }),
        tabIndex: 0,
        onKeyDown: this.onKeyDown,
        onKeyUp: this.onKeyUp,
        "data-testid": "cropper",
        className: SP("reactEasyCrop_CropArea", k === "round" && "reactEasyCrop_CropAreaRound", M && "reactEasyCrop_CropAreaGrid", F)
      }, p)));
    }, t.defaultProps = {
      zoom: 1,
      rotation: 0,
      aspect: 4 / 3,
      maxZoom: i9e,
      minZoom: o9e,
      cropShape: "rect",
      objectFit: "contain",
      showGrid: !0,
      style: {},
      classes: {},
      mediaProps: {},
      cropperProps: {},
      zoomSpeed: 1,
      restrictPosition: !0,
      zoomWithScroll: !0,
      keyboardStep: l9e
    }, t.getMousePoint = function(r) {
      return {
        x: Number(r.clientX),
        y: Number(r.clientY)
      };
    }, t.getTouchPoint = function(r) {
      return {
        x: Number(r.clientX),
        y: Number(r.clientY)
      };
    }, t;
  })(S.Component)
);
const nb = "img-crop", CA = 1, V5 = 0.1, wk = 0, bB = -180, yB = 180, xA = 1, _5 = 0.01, u9e = ks((e, t) => {
  const { cropperRef: r, zoomSlider: a, rotationSlider: i, aspectSlider: c, showReset: d, resetBtnText: f, modalImage: p, aspect: g, minZoom: b, maxZoom: w, minAspect: x, maxAspect: E, cropShape: P, showGrid: k, cropperProps: M } = e, [T, N] = Wn({ x: 0, y: 0 }), [D, $] = Wn(CA), [j, I] = Wn(wk), [L, F] = Wn(g), _ = It({ width: 0, height: 0, x: 0, y: 0 }), W = Cn((K, X) => {
    _.current = X;
  }, []), Q = It(g);
  Q.current !== g && (Q.current = g, F(g));
  const U = D !== CA || j !== wk || L !== g, Y = () => {
    $(CA), I(wk), F(g);
  };
  pS(t, () => ({
    rotation: j,
    cropPixelsRef: _,
    onReset: Y
  }));
  const G = "[display:flex] [align-items:center] [width:60%] [margin-inline:auto]", J = "[display:flex] [align-items:center] [justify-content:center] [height:32px] [width:32px] [background:transparent] [border:0] [font-family:inherit] [font-size:18px] [cursor:pointer] disabled:[opacity:20%] disabled:[cursor:default]", H = "[flex:1]";
  return V.jsxs(V.Fragment, { children: [V.jsx(s9e, Object.assign({}, M, { ref: r, image: p, crop: T, zoom: D, rotation: j, aspect: L, minZoom: b, maxZoom: w, zoomWithScroll: a, cropShape: P, showGrid: k, onCropChange: N, onZoomChange: $, onRotationChange: I, onCropComplete: W, classes: {
    containerClassName: `${nb}-container ![position:relative] [width:100%] [height:40vh] [&~section:first-of-type]:[margin-top:16px] [&~section:last-of-type]:[margin-bottom:16px]`,
    mediaClassName: `${nb}-media`
  } })), a && V.jsxs("section", { className: `${nb}-control ${nb}-control-zoom ${G}`, children: [V.jsx("button", { className: J, onClick: () => $(+(D - V5).toFixed(1)), disabled: D - V5 < b, children: "－" }), V.jsx(hk, { className: H, min: b, max: w, step: V5, value: D, onChange: $ }), V.jsx("button", { className: J, onClick: () => $(+(D + V5).toFixed(1)), disabled: D + V5 > w, children: "＋" })] }), i && V.jsxs("section", { className: `${nb}-control ${nb}-control-rotation ${G}`, children: [V.jsx("button", { className: `${J} [font-size:16px]`, onClick: () => I(j - xA), disabled: j === bB, children: "↺" }), V.jsx(hk, { className: H, min: bB, max: yB, step: xA, value: j, onChange: I }), V.jsx("button", { className: `${J} [font-size:16px]`, onClick: () => I(j + xA), disabled: j === yB, children: "↻" })] }), c && V.jsxs("section", { className: `${nb}-control ${nb}-control-aspect ${G}`, children: [V.jsx("button", { className: J, onClick: () => F(+(L - _5).toFixed(2)), disabled: L - _5 < x, children: "↕" }), V.jsx(hk, { className: H, min: x, max: E, step: _5, value: L, onChange: F }), V.jsx("button", { className: J, onClick: () => F(+(L + _5).toFixed(2)), disabled: L + _5 > E, children: "↔" })] }), d && (a || i || c) && V.jsx(cp, { className: "[position:absolute] [bottom:20px]", style: U ? {} : { opacity: 0.3, pointerEvents: "none" }, onClick: Y, children: f })] });
});
var c9e = fG(u9e), d9e = "/*! tailwindcss v4.1.14 | MIT License | https://tailwindcss.com */.visible{visibility:visible}.\\!\\[position\\:relative\\]{position:relative!important}.\\[position\\:absolute\\]{position:absolute}.\\[bottom\\:20px\\]{bottom:20px}.container{width:100%}.\\[margin-inline\\:auto\\]{margin-inline:auto}.\\[display\\:flex\\]{display:flex}.grid{display:grid}.\\[height\\:32px\\]{height:32px}.\\[height\\:40vh\\]{height:40vh}.\\[width\\:32px\\]{width:32px}.\\[width\\:60\\%\\]{width:60%}.\\[width\\:100\\%\\]{width:100%}.\\[flex\\:1\\]{flex:1}.\\[cursor\\:pointer\\]{cursor:pointer}.\\[align-items\\:center\\]{align-items:center}.\\[justify-content\\:center\\]{justify-content:center}.\\[font-family\\:inherit\\]{font-family:inherit}.\\[font-size\\:16px\\]{font-size:16px}.\\[font-size\\:18px\\]{font-size:18px}.\\[background\\:transparent\\]{background:transparent}.\\[border\\:0\\]{border:0}.disabled\\:\\[cursor\\:default\\]{&:disabled{cursor:default}}.disabled\\:\\[opacity\\:20\\%\\]{&:disabled{opacity:20%}}.\\[\\&\\~section\\:first-of-type\\]\\:\\[margin-top\\:16px\\]{&~section:first-of-type{margin-top:16px}}.\\[\\&\\~section\\:last-of-type\\]\\:\\[margin-bottom\\:16px\\]{&~section:last-of-type{margin-bottom:16px}}";
(function() {
  if (typeof document > "u") return;
  const e = document.createElement("style"), t = document.querySelector('meta[name="csp-nonce"]');
  t && t.content && e.setAttribute("nonce", t.content), e.textContent = d9e, document.head.appendChild(e);
})();
const f9e = ks((e, t) => {
  const { quality: r = 0.4, fillColor: a = "white", zoomSlider: i = !0, rotationSlider: c = !1, aspectSlider: d = !1, showReset: f = !1, resetText: p, aspect: g = 1, minZoom: b = 1, maxZoom: w = 3, minAspect: x = 0.5, maxAspect: E = 2, cropShape: P = "rect", showGrid: k = !1, cropperProps: M, modalClassName: T, modalTitle: N, modalWidth: D, modalOk: $, modalCancel: j, onModalOk: I, onModalCancel: L, modalProps: F, beforeCrop: _, children: W } = e, Q = It({});
  Q.current.onModalOk = I, Q.current.onModalCancel = L, Q.current.beforeCrop = _;
  const U = It(null), Y = Cn((Me) => {
    var ze;
    const le = document.createElement("canvas"), se = le.getContext("2d"), we = (((ze = Me?.getRootNode) === null || ze === void 0 ? void 0 : ze.call(Me)) || document).querySelector(`.${nb}-media`), { width: Ne, height: pe, x: Qe, y: Le } = U.current.cropPixelsRef.current;
    if (c && U.current.rotation !== wk) {
      const { naturalWidth: Te, naturalHeight: Oe } = we, ye = U.current.rotation * (Math.PI / 180), je = Math.abs(Math.sin(ye)), Ue = Math.abs(Math.cos(ye)), Fe = Te * Ue + Oe * je, tt = Oe * Ue + Te * je;
      le.width = Fe, le.height = tt, se.fillStyle = a, se.fillRect(0, 0, Fe, tt);
      const dt = Fe / 2, St = tt / 2;
      se.translate(dt, St), se.rotate(ye), se.translate(-dt, -St);
      const mt = (Fe - Te) / 2, Ot = (tt - Oe) / 2;
      se.drawImage(we, 0, 0, Te, Oe, mt, Ot, Te, Oe);
      const Rt = se.getImageData(0, 0, Fe, tt);
      le.width = Ne, le.height = pe, se.putImageData(Rt, -Qe, -Le);
    } else
      le.width = Ne, le.height = pe, se.fillStyle = a, se.fillRect(0, 0, Ne, pe), se.drawImage(we, Qe, Le, Ne, pe, 0, 0, Ne, pe);
    return le;
  }, [a, c]), [G, J] = Wn(!1), [H, K] = Wn(""), X = It(void 0), te = It(void 0), ie = Cn((Me) => wP(void 0, [Me], void 0, function* ({ beforeUpload: ze, file: le, resolve: se, reject: Ae }) {
    const we = le;
    if (typeof ze != "function") {
      se(we);
      return;
    }
    try {
      const Ne = yield ze(le, [le]);
      se(Ne === !1 ? !1 : Ne !== !0 && Ne || we);
    } catch (Ne) {
      Ae(Ne);
    }
  }), []), ee = Cn((Me) => ((ze, le) => new Promise((se, Ae) => wP(void 0, void 0, void 0, function* () {
    let we = ze;
    if (typeof Q.current.beforeCrop == "function")
      try {
        const pe = yield Q.current.beforeCrop(ze, le);
        if (pe === !1)
          return ie({ beforeUpload: Me, file: ze, resolve: se, reject: Ae });
        pe !== !0 && (we = pe || ze);
      } catch {
        return ie({ beforeUpload: Me, file: ze, resolve: se, reject: Ae });
      }
    const Ne = new FileReader();
    Ne.addEventListener("load", () => {
      typeof Ne.result == "string" && (J(!0), setTimeout(() => {
        K(Ne.result);
      }, 10));
    }), Ne.readAsDataURL(we), X.current = () => {
      var pe, Qe;
      J(!1), K(""), U.current.onReset();
      let Le = !1;
      (Qe = (pe = Q.current).onModalCancel) === null || Qe === void 0 || Qe.call(pe, (Te) => {
        se(Te), Le = !0;
      }), Le || se(n6.LIST_IGNORE);
    }, te.current = (pe) => wP(void 0, void 0, void 0, function* () {
      J(!1), K(""), U.current.onReset();
      const Qe = Y(pe.target), { type: Le, name: Te, uid: Oe } = we;
      Qe.toBlob((ye) => wP(void 0, void 0, void 0, function* () {
        const je = new File([ye], Te, { type: Le });
        Object.assign(je, { uid: Oe }), ie({
          beforeUpload: Me,
          file: je,
          resolve: (Ue) => {
            var Fe, tt;
            se(Ue), (tt = (Fe = Q.current).onModalOk) === null || tt === void 0 || tt.call(Fe, Ue);
          },
          reject: (Ue) => {
            var Fe, tt;
            Ae(Ue), (tt = (Fe = Q.current).onModalOk) === null || tt === void 0 || tt.call(Fe, Ue);
          }
        });
      }), Le, r);
    });
  }))), [Y, r, ie]), ne = Cn((Me) => {
    const ze = Array.isArray(Me) ? Me[0] : Me, le = ze.props, { beforeUpload: se, accept: Ae } = le, we = dI(le, ["beforeUpload", "accept"]);
    return Object.assign(Object.assign({}, ze), { props: Object.assign(Object.assign({}, we), { accept: Ae || "image/*", beforeUpload: ee(se) }) });
  }, [ee]), ae = mn(() => {
    const Me = {};
    return D !== void 0 && (Me.width = D), $ !== void 0 && (Me.okText = $), j !== void 0 && (Me.cancelText = j), Me;
  }, [j, $, D]), oe = `${nb}-modal${T ? ` ${T}` : ""}`, be = (typeof window > "u" ? "" : window.navigator.language) === "zh-CN", me = N || (be ? "编辑图片" : "Edit image"), De = p || (be ? "重置" : "Reset");
  return V.jsxs(V.Fragment, { children: [ne(W), V.jsx(U0, Object.assign({}, F, ae, { open: G, title: me, onCancel: X.current, onOk: te.current, wrapClassName: oe, maskClosable: !1, destroyOnHidden: !0, children: V.jsx(c9e, { ref: U, cropperRef: t, zoomSlider: i, rotationSlider: c, aspectSlider: d, showReset: f, resetBtnText: De, modalImage: H, aspect: g, minZoom: b, maxZoom: w, minAspect: x, maxAspect: E, cropShape: P, showGrid: k, cropperProps: M }) }))] });
}), { Dragger: m9e } = n6, fI = (e) => (t) => {
  e(t.file.status);
}, mI = (e) => async ({ file: t, onSuccess: r, onError: a }) => {
  try {
    await e?.(t), r?.("ok");
  } catch (i) {
    a?.(i);
  }
}, h9e = ({
  disabled: e,
  children: t,
  onUpload: r,
  onFileStatusChange: a
}) => /* @__PURE__ */ V.jsx(
  m9e,
  {
    disabled: e,
    customRequest: mI(r),
    onChange: fI(a),
    children: t
  }
), p9e = ({
  disabled: e,
  children: t,
  onUpload: r,
  onFileStatusChange: a
}) => /* @__PURE__ */ V.jsx(f9e, { children: /* @__PURE__ */ V.jsx(
  n6,
  {
    disabled: e,
    customRequest: mI(r),
    onChange: fI(a),
    children: t
  }
) });
function ite({
  children: e,
  disabled: t,
  onUpload: r,
  onFileStatusChange: a
}) {
  return /* @__PURE__ */ V.jsx(
    n6,
    {
      disabled: t,
      customRequest: mI(r),
      onChange: fI(a),
      children: e
    }
  );
}
ite.Dragger = h9e;
ite.Cropper = p9e;
const g9e = "_section_1x1qc_14", v9e = "_subsection_1x1qc_24", wB = {
  section: g9e,
  subsection: v9e
}, Sk = ({
  kind: e,
  text: t,
  ...r
}) => /* @__PURE__ */ V.jsx(
  "header",
  {
    className: e === "section" ? wB.section : wB.subsection,
    ...r,
    children: t
  }
), b9e = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "arrow-left",
    viewBox: "64 64 896 896",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M872 474H286.9l350.2-304c5.6-4.9 2.2-14-5.2-14h-88.5c-3.9 0-7.6 1.4-10.5 3.9L155 487.8a31.96 31.96 0 0 0 0 48.3L535.1 866c1.5 1.3 3.3 2 5.2 2h91.5c7.4 0 10.8-9.2 5.2-14L286.9 550H872c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8" })
  }
), y9e = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "calendar",
    viewBox: "64 64 896 896",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32m-40 656H184V460h656zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136z" })
  }
), w9e = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "camera",
    viewBox: "64 64 896 896",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M864 248H728l-32.4-90.8a32.07 32.07 0 0 0-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 248H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V328c0-44.2-35.8-80-80-80m8 536c0 4.4-3.6 8-8 8H160c-4.4 0-8-3.6-8-8V328c0-4.4 3.6-8 8-8h186.7l17.1-47.8 22.9-64.2h250.5l22.9 64.2 17.1 47.8H864c4.4 0 8 3.6 8 8zM512 384c-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160-71.6-160-160-160m0 256c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96" })
  }
), S9e = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "car",
    viewBox: "64 64 896 896",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M959 413.4 935.3 372a8 8 0 0 0-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 0 0-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 0 0-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 0 0 3-10.8M264 621c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40m388 75c0 4.4-3.6 8-8 8H380c-4.4 0-8-3.6-8-8v-84c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v36h168v-36c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8zm108-75c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40M220 418l72.7-199.9.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208z" })
  }
), SB = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "caret-down",
    viewBox: "0 0 8 6",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M1 0a1 1 0 0 0-.8 1.6l3 4a1 1 0 0 0 1.6 0l3-4A1 1 0 0 0 7 0z" })
  }
), CB = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "caret-up",
    viewBox: "0 0 8 6",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M1 6a1 1 0 0 1-.8-1.6l3-4a1 1 0 0 1 1.6 0l3 4A1 1 0 0 1 7 6z" })
  }
), C9e = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "car",
    viewBox: "64 64 896 896",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M380 704h264c4.4 0 8-3.6 8-8v-84c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v36H428v-36c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v84c0 4.4 3.6 8 8 8m340-123a40 40 0 1 0 80 0 40 40 0 1 0-80 0m239-167.6L935.3 372a8 8 0 0 0-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 0 0-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 0 0-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 0 0 3-10.8M840 517v237H184V517l15.6-43h624.8zM292.7 218.1l.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208H220zM224 581a40 40 0 1 0 80 0 40 40 0 1 0-80 0" })
  }
), x9e = (e) => /* @__PURE__ */ V.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 800,
    height: 800,
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 5.149,
    transform: "scale(-1 1)",
    viewBox: "0 0 190.712 190.712",
    ...e,
    children: [
      /* @__PURE__ */ V.jsx("path", { d: "M188.976 125.657c-2.051-7.098-11.162-8.747-17.617-6.611-12.936-18.814-32.144-29.435-55.065-26.681-17.817 2.141-39.328 6.837-43.877 26.364-5.205-3.202-11.924-.594-14.211 5-2.437 5.961 2.26 11.216 7.874 11.619-4.373 5.353-5.146 14.076-5.931 20.5-1.042 8.539-.444 16.651 4.811 23.635 6.9 9.173 18.805 9.213 20.406-2.34 11.133 2.867 22.498 3.064 33.988 4.031 10.654.896 21.446 2.137 31.874-.57-.488 10.666 12.69 9.912 20.115 5.074 14.322-9.332 10.99-32.972 6.524-47.394 6.83.383 13.16-5.53 11.109-12.627zm-75.851-27.909c23.627-3.912 37.217 7.238 52.688 22.206-30.492 8.498-59.157 7.383-88.845-3.677 8.421-12.31 21.106-16.037 36.157-18.529zm70.285 34.735c-2.286 1.33-5.044 1.232-7.559 1.638a1.6 1.6 0 0 0-1.148.769c-1.088.223-2.001 1.158-1.574 2.541 3.823 12.393 4.551 25.526.849 38.031-1.227 4.143-5.936 7.209-9.654 8.768-5.598 2.349-8.592-.266-10.063-5.166.612-1.375-.511-3.327-2.479-2.989-20.875 3.579-45.158.812-66.316-2.032-.39-1.357-2.348-1.596-3.07-.373-1.373-.017-1.975 1.715-.789 2.37-1.541 4.771-3.803 8.429-9.499 4.878-3.913-2.439-6.455-7.162-7.623-11.461-1.746-6.428.064-14.509 1.445-20.79 1.015-4.62 3.272-9.175 3.286-13.922.284-.468.166-1.112-.243-1.517a.7.7 0 0 0-.13-.096c-.103-.074-.173-.185-.303-.222-4.021-1.144-8.171-2.888-6.916-7.844.474-1.868 1.821-3.286 3.517-4.117 2.435-1.192 4.812.112 7.128.802.119.035.234.034.351.034.455.257 1.033.218 1.341-.399a46 46 0 0 1 1.567-2.871c28.566 14.828 62.441 15.936 92.602 5.138a2.1 2.1 0 0 0 1.219-1.069c.224.01.447.041.667-.01 4.734.303 10.872-.762 14.562 2.794 1.014.976 1.563 2.608 1.665 3.968.123 1.688-1.649 2.457-2.833 3.147z" }),
      /* @__PURE__ */ V.jsx("path", { d: "M92.833 145.11c-.545-3.445-4.354-7.422-8.025-6.463-4.656-1.502-8.688 2.273-9.091 7.08-.461 5.5 4.091 10.066 9.631 9.397 4.895-.591 8.252-5.169 7.485-10.014zm-7.64 5.386c-2.879.746-4.626-1.821-4.656-4.343-.027-2.278 1.562-3.643 3.46-4.383 2.34.5 4.413.379 4.583 3.527.126 2.35-1.048 4.592-3.387 5.199zM158.874 141.821c-.032-.027-.039-.074-.077-.098-4.456-2.58-9.229.131-11.021 4.584-2.111 5.246 1.109 9.969 6.384 11.14 5.132 1.14 10.185-1.929 11.09-7.207.667-3.896-2.382-8.437-6.376-8.419zm2.005 7.429c-.288 2.812-2.887 4.375-5.532 3.888-6.178-1.141-3.651-8.004.745-9.519.059.251.188.483.498.625 2.579 1.192 4.625 1.715 4.289 5.006zM127.216 68.8c-2.957-1.774-6.76-1.876-10.219-1.321-3.864-49.641-83.401-42.894-99.246-4.022-2.797-2.121-7.146-2.963-10.223-1.669-3.343 1.407-5.198 4.678-5.702 8.164-.523 3.626.126 7.208 2.44 10.098 1.369 1.71 3.319 2.468 5.302 2.431-6.282 13.821-14.425 31.212-5.877 45.25 3.799 6.24 12.847 9.4 19.792 7.597 11.266-2.925 13.831-15.04 26.31-14.546 1.876.074 1.922-2.43.411-3.036-4.025-1.619-12.035-3.901-15.622.201-2.279 2.604-2.824 5.745-4.981 8.536-5.092 6.588-15.468 4.63-20.85-.047-11.509-10 1.374-34.53 5.569-45.567.713-1.876-2.252-3.19-3.245-1.609-3.716-.543-5.015-4.392-4.669-8.313.16-1.817 1.038-3.764 2.624-4.735 2.745-1.681 5.638 1.047 8.217 1.549.811.158 1.716-.293 2.161-.972.179-.112.344-.256.472-.456.425-.661.888-1.295 1.339-1.937 28.557 8.969 61.823 10.181 91.136 5.031.393 1.349 1.717 1.848 2.876 1.63 4.77-.632 13.442-.323 12.139 6.655-.45 2.41-2.738 3.126-4.893 3.103-2.743-.029-4.445-1.994-6.911-2.557-1.285-.293-2.589.837-2.189 2.189 1.068 3.615 6.369 4.891 9.663 4.798 3.795-.108 6.914-2.299 8.191-5.852 1.438-4.004-.505-8.488-4.015-10.593zM22.309 62.874c22.635-29.992 74.332-36.875 88.744 2.534-30.298 4.016-58.657-.381-88.744-2.534z" }),
      /* @__PURE__ */ V.jsx("path", { d: "M35.346 85.364c-1.555-1.972-4.139-3.148-6.626-3.134-2.222.013-4.987 1.341-6.05 3.408-3.061 2.25-4.413 6.413-3.353 10.439 1.787 6.789 10.043 7.398 14.995 3.697 4.771-3.565 4.466-10.059 1.034-14.41zm-3.758 10.83c-2.762 1.927-6.808 1.742-7.801-1.825-.556-1.996.002-4.133 1.078-5.955 1.384-.573 2.391-1.856 3.946-2.223 1.379-.325 2.566.749 3.386 1.688 2.082 2.379 2.066 6.45-.609 8.315zM187.18 35.873c-3.7-2.667-8.422-1.955-12.503-.563C168.41-5.358 93.032-10.149 77.7 26.216c-.802 1.903 2.341 3.157 3.295 1.389 17.719-32.79 76.265-25.078 89.756 7.67-19.938 6.814-38.964 6.741-59.465 3.116-.587-.104-1.027.333-.922.922 1.273 7.051 18.041 6.014 22.949 6.09 13.261.206 27.625.41 38.999-7.281.251.828 1.02 1.469 2.163 1.173 4.349-1.125 12.918-1.709 11.562 5.259-.427 2.197-1.768 4.203-3.61 5.463-1.048.716-2.275 1.136-3.53 1.296-1.601.204-3.205-.313-4.646.625a2 2 0 0 0-.564.571c-.354.315-.539.802-.347 1.424 3.15 10.177 5.493 19.758 5.115 30.534-.094 2.673-2.468 21.692-9.633 15.363-3.338-2.948-4.45-7.814-5.563-11.909a1.6 1.6 0 0 0-.896-1.05c-1.346-6.146-14.443-8.643-19.46-8.282-2.611.188-3.025 3.567-.604 4.462 5.097 1.883 13.222.607 17.768 4.412a1.53 1.53 0 0 0-.259.925c.425 8.677 9.599 25.007 18.577 13.853 8.741-10.861 6.625-33.062-.09-45.794 2.409-.105 5.023-1.127 6.609-2.192 3.176-2.133 5.28-5.707 5.725-9.488.396-3.374-.607-6.845-3.449-8.894z" }),
      /* @__PURE__ */ V.jsx("path", { d: "M168.323 62.33c-.739-2.153-2.294-4.051-4.437-4.9-1.67-.661-4.602-.802-5.893.703-.787.047-1.548.299-2.363.912-1.711 1.286-2.308 3.479-2.571 5.502-.62 4.75 3.338 8.773 8.012 8.514 5.413-.3 9.011-5.608 7.252-10.731zm-7.674 5.678c-3.642.366-4.014-5.737-1.816-7.61 1.122.175 2.188-.375 3.318.248 1.048.578 1.455 1.83 1.667 2.925.459 2.379-.775 4.197-3.169 4.437z" })
    ]
  }
), E9e = (e) => /* @__PURE__ */ V.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 800,
    height: 800,
    fill: "#041e42",
    transform: "scale(-1 1)",
    viewBox: "0 0 99.488 99.488",
    ...e,
    children: [
      /* @__PURE__ */ V.jsx("path", { d: "m98.587 52.231-.68-.106c.244-9.324-1.22-11.202-2.858-16.912h.901a.773.773 0 0 0 .773-.774v-.889a.774.774 0 0 0-.773-.773H41.123c-.805 0-1.594.216-2.286.625L22.22 43.218s-16.635.671-19.213 3.222C1.704 47.729.526 50.272.096 53.207c-.43 2.934.693 6.062 1.331 6.737.639.675 1.663.998 1.663.998l.406.771c.262.496.78.801 1.341.787l2.674-.064v-7.383a5.19 5.19 0 0 1 5.189-5.188h7.099a4.55 4.55 0 0 1 4.548 4.549v7.612l.121-.003 43.416-.667.625.063v-6.367a5.19 5.19 0 0 1 5.188-5.188h7.101a4.546 4.546 0 0 1 4.547 4.549v8.323l5.991-1.272c.315-.067.585-.276.729-.566l.438-.872 6.059-.793c.53-.069.927-.522.927-1.058v-4.893a1.07 1.07 0 0 0-.902-1.051m-52.152-8.534a.7.7 0 0 1-.515.223H32.695s.812-.417 1.237-1.012c.426-.593.19-1.998-.288-2.472-.439-.434-1.322-.729-1.322-.729l6.651-4.095a2.7 2.7 0 0 1 1.417-.401h5.628a.7.7 0 0 1 .702.712l-.097 7.244a.7.7 0 0 1-.188.53m16.61-.588a2.4 2.4 0 0 1-1.803.873l-10.585.23a.706.706 0 0 1-.72-.703v-7.595c0-.388.314-.702.702-.702h11.748a.7.7 0 0 1 .699.64l.474 5.323a2.4 2.4 0 0 1-.515 1.934m31.313.006a.35.35 0 0 1-.297.169l-21.502.162a2.7 2.7 0 0 1-2.298-1.255l-2.254-6.031a.7.7 0 0 1 .657-.948H91.41c.306 0 .574.196.669.486l2.288 7.074a.35.35 0 0 1-.009.343" }),
      /* @__PURE__ */ V.jsx("path", { d: "M15.926 51.364a7.673 7.673 0 0 0-7.673 7.672c0 .329.027.647.067.966a7.67 7.67 0 0 0 15.249-.311 8 8 0 0 0 .033-.655 7.67 7.67 0 0 0-7.676-7.672m-3.843 4.782 1.568 1.563a2.6 2.6 0 0 0-.279.678h-2.207c.114-.838.434-1.6.918-2.241m-.926 3.569h2.224c.063.234.154.459.279.666l-1.571 1.567a4.8 4.8 0 0 1-.932-2.233m4.105 4.088a4.7 4.7 0 0 1-2.225-.92l1.561-1.562c.203.12.43.207.664.27zm0-7.318a2.7 2.7 0 0 0-.678.282l-1.561-1.563a4.76 4.76 0 0 1 2.238-.929zm1.328-2.209c.84.116 1.602.438 2.244.931l-1.563 1.561a2.6 2.6 0 0 0-.682-.281zm0 9.527V61.59a2.6 2.6 0 0 0 .669-.271l1.559 1.564a4.75 4.75 0 0 1-2.228.92m3.181-1.851-1.572-1.573c.12-.205.222-.426.284-.664h2.204a4.74 4.74 0 0 1-.916 2.237m-1.288-3.565a2.6 2.6 0 0 0-.275-.678l1.564-1.563a4.76 4.76 0 0 1 .92 2.241zM76.924 51.364a7.674 7.674 0 0 0-7.675 7.672c0 .329.026.647.068.966.476 3.782 3.696 6.709 7.605 6.709a7.67 7.67 0 0 0 7.643-7.02c.02-.219.033-.434.033-.655a7.67 7.67 0 0 0-7.674-7.672m-3.843 4.782 1.566 1.563c-.123.213-.22.438-.278.678h-2.206c.113-.838.433-1.6.918-2.241m-.927 3.569h2.224c.063.234.153.459.278.666l-1.569 1.567a4.8 4.8 0 0 1-.933-2.233m4.105 4.088a4.7 4.7 0 0 1-2.226-.92l1.562-1.562c.203.12.431.207.664.27zm0-7.318a2.8 2.8 0 0 0-.679.282l-1.561-1.563a4.75 4.75 0 0 1 2.238-.929zm1.33-2.209a4.7 4.7 0 0 1 2.243.931l-1.563 1.561a2.6 2.6 0 0 0-.681-.281zm0 9.527V61.59c.235-.062.461-.149.668-.271l1.559 1.564a4.75 4.75 0 0 1-2.227.92m3.18-1.851-1.573-1.573c.12-.205.223-.426.285-.664h2.204a4.75 4.75 0 0 1-.916 2.237m-1.288-3.565a2.7 2.7 0 0 0-.274-.678l1.563-1.563a4.8 4.8 0 0 1 .92 2.241z" })
    ]
  }
), P9e = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "shopping-cart",
    viewBox: "0 0 1024 1024",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M922.9 701.9H327.4l29.9-60.9 496.8-.9c16.8 0 31.2-12 34.2-28.6l68.8-385.1c1.8-10.1-.9-20.5-7.5-28.4a34.99 34.99 0 0 0-26.6-12.5l-632-2.1-5.4-25.4c-3.4-16.2-18-28-34.6-28H96.5a35.3 35.3 0 1 0 0 70.6h125.9L246 312.8l58.1 281.3-74.8 122.1a34.96 34.96 0 0 0-3 36.8c6 11.9 18.1 19.4 31.5 19.4h62.8a102.43 102.43 0 0 0-20.6 61.7c0 56.6 46 102.6 102.6 102.6s102.6-46 102.6-102.6c0-22.3-7.4-44-20.6-61.7h161.1a102.43 102.43 0 0 0-20.6 61.7c0 56.6 46 102.6 102.6 102.6s102.6-46 102.6-102.6c0-22.3-7.4-44-20.6-61.7H923c19.4 0 35.3-15.8 35.3-35.3a35.42 35.42 0 0 0-35.4-35.2M305.7 253l575.8 1.9-56.4 315.8-452.3.8zm96.9 612.7c-17.4 0-31.6-14.2-31.6-31.6s14.2-31.6 31.6-31.6 31.6 14.2 31.6 31.6a31.6 31.6 0 0 1-31.6 31.6m325.1 0c-17.4 0-31.6-14.2-31.6-31.6s14.2-31.6 31.6-31.6 31.6 14.2 31.6 31.6a31.6 31.6 0 0 1-31.6 31.6" })
  }
), k9e = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "down",
    viewBox: "64 64 896 896",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7" })
  }
), M9e = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "left",
    viewBox: "64 64 896 896",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 0 0 0 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6" })
  }
), O9e = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "right",
    viewBox: "64 64 896 896",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M765.7 486.8 314.9 134.7A7.97 7.97 0 0 0 302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 0 0 0-50.4" })
  }
), T9e = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "up",
    viewBox: "64 64 896 896",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M890.5 755.3 537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 0 0 140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7" })
  }
), R9e = (e) => /* @__PURE__ */ V.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...e,
    children: [
      /* @__PURE__ */ V.jsx("g", { clipPath: "url(#CircleAlert_svg__a)", children: /* @__PURE__ */ V.jsx(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.33,
          d: "M8 5.333V8m0 2.667h.007M14.667 8A6.667 6.667 0 1 1 1.333 8a6.667 6.667 0 0 1 13.334 0"
        }
      ) }),
      /* @__PURE__ */ V.jsx("defs", { children: /* @__PURE__ */ V.jsx("clipPath", { id: "CircleAlert_svg__a", children: /* @__PURE__ */ V.jsx("path", { fill: "#fff", d: "M0 0h16v16H0z" }) }) })
    ]
  }
), A9e = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "check-circle",
    viewBox: "64 64 896 896",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64m193.5 301.7-210.6 292a31.8 31.8 0 0 1-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7" })
  }
), N9e = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    fillRule: "evenodd",
    "aria-hidden": "true",
    "data-icon": "close-circle",
    viewBox: "64 64 896 896",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64m127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 0 0-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 0 0-.05.09.12.12 0 0 0 0 .07v.02a.3.3 0 0 0 .06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 0 0 0 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 0 0 .09.05.12.12 0 0 0 .07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 0 0 .07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 0 0 .05-.09.12.12 0 0 0 0-.07v-.02a.3.3 0 0 0-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 0 0 0-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 0 0-.09-.05.12.12 0 0 0-.07 0z" })
  }
), D9e = (e) => /* @__PURE__ */ V.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "clock-circle",
    viewBox: "64 64 896 896",
    ...e,
    children: [
      /* @__PURE__ */ V.jsx("path", { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372" }),
      /* @__PURE__ */ V.jsx("path", { d: "M686.7 638.6 544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2" })
    ]
  }
), $9e = (e) => /* @__PURE__ */ V.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "close-square",
    viewBox: "64 64 896 896",
    ...e,
    children: [
      /* @__PURE__ */ V.jsx(
        "path",
        {
          fill: "#1677ff",
          d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32m-40 728H184V184h656z"
        }
      ),
      /* @__PURE__ */ V.jsx(
        "path",
        {
          fill: "#e6f4ff",
          d: "M184 840h656V184H184zm163.9-473.9A7.95 7.95 0 0 1 354 353h58.9c4.7 0 9.2 2.1 12.3 5.7L512 462.2l86.8-103.5c3-3.6 7.5-5.7 12.3-5.7H670c6.8 0 10.5 7.9 6.1 13.1L553.8 512l122.3 145.9c4.4 5.2.7 13.1-6.1 13.1h-58.9c-4.7 0-9.2-2.1-12.3-5.7L512 561.8l-86.8 103.5c-3 3.6-7.5 5.7-12.3 5.7H354c-6.8 0-10.5-7.9-6.1-13.1L470.2 512z"
        }
      ),
      /* @__PURE__ */ V.jsx(
        "path",
        {
          fill: "#1677ff",
          d: "M354 671h58.9c4.8 0 9.3-2.1 12.3-5.7L512 561.8l86.8 103.5c3.1 3.6 7.6 5.7 12.3 5.7H670c6.8 0 10.5-7.9 6.1-13.1L553.8 512l122.3-145.9c4.4-5.2.7-13.1-6.1-13.1h-58.9c-4.8 0-9.3 2.1-12.3 5.7L512 462.2l-86.8-103.5c-3.1-3.6-7.6-5.7-12.3-5.7H354c-6.8 0-10.5 7.9-6.1 13.1L470.2 512 347.9 657.9A7.95 7.95 0 0 0 354 671"
        }
      )
    ]
  }
), z9e = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    fillRule: "evenodd",
    "aria-hidden": "true",
    "data-icon": "close-circle",
    viewBox: "64 64 896 896",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64m0 76c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372m128.01 198.83c.03 0 .05.01.09.06l45.02 45.01a.2.2 0 0 1 .05.09.12.12 0 0 1 0 .07c0 .02-.01.04-.05.08L557.25 512l127.87 127.86a.3.3 0 0 1 .05.06v.02a.12.12 0 0 1 0 .07c0 .03-.01.05-.05.09l-45.02 45.02a.2.2 0 0 1-.09.05.12.12 0 0 1-.07 0c-.02 0-.04-.01-.08-.05L512 557.25 384.14 685.12c-.04.04-.06.05-.08.05a.12.12 0 0 1-.07 0c-.03 0-.05-.01-.09-.05l-45.02-45.02a.2.2 0 0 1-.05-.09.12.12 0 0 1 0-.07c0-.02.01-.04.06-.08L466.75 512 338.88 384.14a.3.3 0 0 1-.05-.06l-.01-.02a.12.12 0 0 1 0-.07c0-.03.01-.05.05-.09l45.02-45.02a.2.2 0 0 1 .09-.05.12.12 0 0 1 .07 0c.02 0 .04.01.08.06L512 466.75l127.86-127.86c.04-.05.06-.06.08-.06a.12.12 0 0 1 .07 0" })
  }
), j9e = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    fillRule: "evenodd",
    "aria-hidden": "true",
    "data-icon": "close",
    viewBox: "64 64 896 896",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.1.1 0 0 1 0 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 0 1 0 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 0 1-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 0 1-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7a.17.17 0 0 1-.06-.07.12.12 0 0 1 0-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7a.2.2 0 0 1-.06-.09.12.12 0 0 1 0-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 0 1 .07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 0 1 .07 0" })
  }
), I9e = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none",
    ...e,
    children: /* @__PURE__ */ V.jsx(
      "path",
      {
        stroke: "#041E42",
        strokeLinecap: "round",
        strokeOpacity: 0.45,
        strokeWidth: 1.5,
        d: "m4.75 5.25 14.5 14.5m0-14.5-14.5 14.5"
      }
    )
  }
), L9e = (e) => /* @__PURE__ */ V.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "comment",
    viewBox: "64 64 896 896",
    ...e,
    children: [
      /* @__PURE__ */ V.jsx("path", { d: "M573 421c-23.1 0-41 17.9-41 40s17.9 40 41 40c21.1 0 39-17.9 39-40s-17.9-40-39-40m-280 0c-23.1 0-41 17.9-41 40s17.9 40 41 40c21.1 0 39-17.9 39-40s-17.9-40-39-40" }),
      /* @__PURE__ */ V.jsx("path", { d: "M894 345a343.92 343.92 0 0 0-189-130v.1c-17.1-19-36.4-36.5-58-52.1-163.7-119-393.5-82.7-513 81-96.3 133-92.2 311.9 6 439l.8 132.6c0 3.2.5 6.4 1.5 9.4a31.95 31.95 0 0 0 40.1 20.9L309 806c33.5 11.9 68.1 18.7 102.5 20.6l-.5.4c89.1 64.9 205.9 84.4 313 49l127.1 41.4c3.2 1 6.5 1.6 9.9 1.6 17.7 0 32-14.3 32-32V753c88.1-119.6 90.4-284.9 1-408M323 735l-12-5-99 31-1-104-8-9c-84.6-103.2-90.2-251.9-11-361 96.4-132.2 281.2-161.4 413-66 132.2 96.1 161.5 280.6 66 412-80.1 109.9-223.5 150.5-348 102m505-17-8 10 1 104-98-33-12 5c-56 20.8-115.7 22.5-171 7l-.2-.1A367.3 367.3 0 0 0 729 676c76.4-105.3 88.8-237.6 44.4-350.4l.6.4c23 16.5 44.1 37.1 62 62 72.6 99.6 68.5 235.2-8 330" }),
      /* @__PURE__ */ V.jsx("path", { d: "M433 421c-23.1 0-41 17.9-41 40s17.9 40 41 40c21.1 0 39-17.9 39-40s-17.9-40-39-40" })
    ]
  }
), H9e = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "delete",
    viewBox: "64 64 896 896",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M360 184h-8c4.4 0 8-3.6 8-8zh304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32M731.3 840H292.7l-24.2-512h487z" })
  }
), F9e = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "dollar",
    viewBox: "64 64 896 896",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372m47.7-395.2-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4m-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4" })
  }
), W9e = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "double-left",
    viewBox: "64 64 896 896",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "m272.9 512 265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 0 0 0 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9zm304 0 265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 0 0 0 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9z" })
  }
), V9e = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "double-right",
    viewBox: "64 64 896 896",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M533.2 492.3 277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 0 0 188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5m304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 0 0 492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5" })
  }
), _9e = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "edit",
    viewBox: "64 64 896 896",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 0 0 0-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 0 0 9.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9m67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32" })
  }
), B9e = (e) => /* @__PURE__ */ V.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", ...e, children: /* @__PURE__ */ V.jsx(
  "path",
  {
    fill: "#31ac9a",
    d: "M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4l217.6 163.2c11.4 8.5 27 8.5 38.4 0l217.6-163.2c12.1-9.1 19.2-23.3 19.2-38.4 0-26.5-21.5-48-48-48zM0 176v208c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V176L294.4 339.2a63.9 63.9 0 0 1-76.8 0z"
  }
) }), U9e = (e) => /* @__PURE__ */ V.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "eye-crossed-out",
    viewBox: "64 64 896 896",
    ...e,
    children: [
      /* @__PURE__ */ V.jsx("path", { d: "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 0 0 0-51.5m-63.57-320.64L836 122.88a8 8 0 0 0-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 0 0 0 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 0 0 0 11.31L155.17 889a8 8 0 0 0 11.31 0l712.15-712.12a8 8 0 0 0 0-11.32M149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 0 0-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512m246.7 0a112.11 112.11 0 0 1 146.2-106.69L401.31 546.2A112 112 0 0 1 396 512" }),
      /* @__PURE__ */ V.jsx("path", { d: "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 0 0 227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 0 1-112 112" })
    ]
  }
), X9e = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "eye",
    viewBox: "64 64 896 896",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5M512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258s279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766m-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176m0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112" })
  }
), G9e = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "bullhorn",
    viewBox: "0 0 1800 800",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M1664 128q53 0 90.5 37.5T1792 256t-37.5 90.5T1664 384v384q0 52-38 90t-90 38q-417-347-812-380-58 19-91 66t-31 100.5 40 92.5q-20 33-23 65.5t6 58 33.5 55 48 50T768 1054q-29 58-111.5 83T488 1148.5 356 1093q-7-23-29.5-87.5t-32-94.5-23-89-15-101 3.5-98.5T282 512H160q-66 0-113-47T0 352V160Q0 94 47 47T160 0h480q435 0 896-384 52 0 90 38t38 90zm-128 604v-954Q1142 80 768 121v270q377 42 768 341" })
  }
), q9e = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "check",
    viewBox: "0 0 1700 10",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M1621-370q0 40-28 68L869 422 733 558q-28 28-68 28t-68-28L461 422 99 60Q71 32 71-8t28-68l136-136q28-28 68-28t68 28L665 83l656-657q28-28 68-28t68 28l136 136q28 28 28 68" })
  }
), K9e = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "remove",
    viewBox: "0 0 1250 10",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M1223 361q0 40-28 68l-136 136q-28 28-68 28t-68-28L629 271 335 565q-28 28-68 28t-68-28L63 429q-28-28-28-68t28-68L357-1 63-295q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 294 294-294q28-28 68-28t68 28l136 136q28 28 28 68t-28 68L901-1l294 294q28 28 28 68" })
  }
), Y9e = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "dollar",
    viewBox: "0 0 1024 1750",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M978 1149q0 153-99.5 263.5T620 1549v175q0 14-9 23t-23 9H453q-13 0-22.5-9.5T421 1724v-175q-66-9-127.5-31T192 1473.5t-74-48-46.5-37.5-17.5-18q-17-21-2-41l103-135q7-10 23-12 15-2 24 9l2 2q113 99 243 125 37 8 74 8 81 0 142.5-43t61.5-122q0-28-15-53t-33.5-42-58.5-37.5-66-32-80-32.5q-39-16-61.5-25T349 912.5t-62.5-31T230 846t-53.5-42.5-43.5-49-35.5-58-21-66.5-8.5-78q0-138 98-242t255-134V-4q0-13 9.5-22.5T453-36h135q14 0 23 9t9 23v176q57 6 110.5 23t87 33.5T881 266t39 29 15 14q17 18 5 38l-81 146q-8 15-23 16-14 3-27-7-3-3-14.5-12t-39-26.5-58.5-32-74.5-26T537 394q-95 0-155 43t-60 111q0 26 8.5 48t29.5 41.5 39.5 33 56 31 60.5 27 70 27.5q53 20 81 31.5t76 35 75.5 42.5 62 50 53 63.5T965 1055t13 94" })
  }
), Q9e = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "envelope_alt",
    viewBox: "0 0 1900 10",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M1842-226v794q0 66-47 113t-113 47H210q-66 0-113-47T50 568v-794q44 49 101 87 362 246 497 345 57 42 92.5 65.5t94.5 48T945 344h2q51 0 110-24.5t94.5-48T1244 206q170-123 498-345 57-39 100-87m0-294q0 79-49 151t-122 123Q1295 15 1203 79q-10 7-42.5 30.5t-54 38-52 32.5-57.5 27-50 9h-2q-23 0-50-9t-57.5-27-52-32.5-54-38T689 79q-91-64-262-182.5T222-246q-62-42-117-115.5T50-498q0-78 41.5-130T210-680h1472q65 0 112.5 47t47.5 113" })
  }
), J9e = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "warning",
    viewBox: "0 0 1800 1400",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M1024 1239v-190q0-14-9.5-23.5T992 1016H800q-13 0-22.5 9.5T768 1049v190q0 14 9.5 23.5t22.5 9.5h192q13 0 22.5-9.5t9.5-23.5m-2-374 18-459q0-12-10-19-13-11-24-11H786q-11 0-24 11-10 7-10 21l17 457q0 10 10 16.5t24 6.5h185q14 0 23.5-6.5T1022 865m-14-934 768 1408q35 63-2 126-17 29-46.5 46t-63.5 17H128q-34 0-63.5-17T18 1465q-37-63-2-126L784-69q17-31 47-49t65-18 65 18 47 49" })
  }
), Z9e = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "i",
    viewBox: "0 0 1450 10",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M1040 508v128q0 26-19 45t-45 19H464q-26 0-45-19t-19-45V508q0-26 19-45t45-19h64V60h-64q-26 0-45-19T400-4v-128q0-26 19-45t45-19h384q26 0 45 19t19 45v576h64q26 0 45 19t19 45M912-644v192q0 26-19 45t-45 19H592q-26 0-45-19t-19-45v-192q0-26 19-45t45-19h256q26 0 45 19t19 45" })
  }
), eMe = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "pdf",
    viewBox: "0 0 1800 10",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M1618-506q28 28 48 76t20 88V810q0 40-28 68t-68 28H246q-40 0-68-28t-28-68V-790q0-40 28-68t68-28h896q40 0 88 20t76 48zm-444-244v376h376q-10-29-22-41l-313-313q-12-12-41-22m384 1528V-246h-416q-40 0-68-28t-28-68v-416H278V778zm-514-593q33 26 84 56 59-7 117-7 147 0 177 49 16 22 2 52 0 1-1 2l-2 2v1q-6 38-71 38-48 0-115-20t-130-53q-221 24-392 83-153 262-242 262-15 0-28-7l-24-12q-1-1-6-5-10-10-6-36 9-40 56-91.5T595 402q14-9 23 6 2 2 2 4 52-85 107-197Q795 79 831-47q-24-82-30.5-159.5T807-334q11-40 42-40h22q23 0 35 15 18 21 9 68-2 6-4 8 1 3 1 8v30q-2 123-14 192 55 164 146 238M468 596q52-24 137-158-51 40-87.5 84T468 596m398-920q-15 42-2 132 1-7 7-44 0-3 7-43 1-4 4-8-1-1-1-2-1-2-1-3-1-22-13-36 0 1-1 2zM742 337q135-54 284-81-2-1-13-9.5T997 233q-76-67-127-176-27 86-83 197-30 56-45 83m646-16q-24-24-140-24 76 28 124 28 14 0 18-1 0-1-2-3" })
  }
), tMe = (e) => /* @__PURE__ */ V.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", ...e, children: /* @__PURE__ */ V.jsx(
  "path",
  {
    fill: "#31ac9a",
    d: "M128 64v96h64V64h194.7L416 93.3V160h64V93.3c0-17-6.7-33.3-18.7-45.3L432 18.7C420 6.7 403.7 0 386.7 0H192c-35.3 0-64 28.7-64 64M0 160v320c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32m480 32H128v288c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32m-224 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64m96 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0m32 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-160 32a32 32 0 1 1 64 0 32 32 0 1 1-64 0"
  }
) }), nMe = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "file-text",
    viewBox: "64 64 896 896",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M854.6 288.6 639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7M790.2 326H602V137.8zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216zM504 618H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8M312 490v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8" })
  }
), rMe = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none",
    ...e,
    children: /* @__PURE__ */ V.jsx(
      "path",
      {
        stroke: "#041E42",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M3 12.5h18m-18-6h18m-18 12h18"
      }
    )
  }
), aMe = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "home",
    viewBox: "64 64 896 896",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M946.5 505 560.1 118.8l-25.9-25.9a31.5 31.5 0 0 0-44.4 0L77.5 505a63.9 63.9 0 0 0-18.8 46c.4 35.2 29.7 63.3 64.9 63.3h42.5V940h691.8V614.3h43.4c17.1 0 33.2-6.7 45.3-18.8a63.6 63.6 0 0 0 18.7-45.3c0-17-6.7-33.1-18.8-45.2M568 868H456V664h112zm217.9-325.7V868H632V640c0-22.1-17.9-40-40-40H432c-22.1 0-40 17.9-40 40v228H238.1V542.3h-96l370-369.7 23.1 23.1L882 542.3z" })
  }
), oMe = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "info-circle",
    viewBox: "64 64 896 896",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64m32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8zm-32-344a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96" })
  }
), iMe = (e) => /* @__PURE__ */ V.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "info-circle",
    viewBox: "64 64 896 896",
    ...e,
    children: [
      /* @__PURE__ */ V.jsx("path", { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372" }),
      /* @__PURE__ */ V.jsx("path", { d: "M464 336a48 48 0 1 0 96 0 48 48 0 1 0-96 0m72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8" })
    ]
  }
), lMe = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "line-chart",
    viewBox: "64 64 896 896",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8M305.8 637.7c3.1 3.1 8.1 3.1 11.3 0l138.3-137.6L583 628.5c3.1 3.1 8.2 3.1 11.3 0l275.4-275.3c3.1-3.1 3.1-8.2 0-11.3l-39.6-39.6a8.03 8.03 0 0 0-11.3 0l-230 229.9L461.4 404a8.03 8.03 0 0 0-11.3 0L266.3 586.7a8.03 8.03 0 0 0 0 11.3z" })
  }
), sMe = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "loading",
    viewBox: "0 0 1024 1024",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.5 440.5 0 0 0-94.3-139.9 437.7 437.7 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150s83.9 101.8 109.7 162.7c26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36" })
  }
), uMe = (e) => /* @__PURE__ */ V.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    fill: "none",
    ...e,
    children: [
      /* @__PURE__ */ V.jsxs("g", { fill: "#fff", clipPath: "url(#Magic_svg__a)", children: [
        /* @__PURE__ */ V.jsx("path", { d: "M4.935 8.842c.173-.265.351-.42.378-.598.275-1.798 1.269-2.848 3.092-3.104.168-.023.308-.252.461-.386-.153-.131-.293-.357-.461-.382-1.817-.264-2.817-1.309-3.095-3.108-.025-.165-.258-.297-.394-.444-.117.135-.318.26-.338.407C4.322 3.08 3.276 4.113 1.435 4.39c-.159.023-.285.265-.427.405.142.112.27.3.425.323 1.838.275 2.89 1.309 3.141 3.161.022.158.185.299.361.566zM17.133 9.701c-1.11.384-2.236.732-3.324 1.172-.32.129-.65.466-.78.786-.347.862-.575 1.772-.883 2.652-.082.236-.282.43-.427.643-.165-.224-.394-.425-.483-.676-.313-.877-.54-1.787-.882-2.652-.118-.301-.426-.624-.726-.742-.941-.369-1.924-.636-2.881-.969-.178-.062-.312-.25-.467-.38.155-.13.29-.317.468-.38.904-.317 1.808-.644 2.735-.886.553-.145.807-.434.947-.97.213-.822.49-1.63.783-2.425.102-.277.333-.506.505-.757.153.24.357.462.45.722.308.879.542 1.785.878 2.654.109.28.402.576.682.685 1.121.437 2.268.801 3.405 1.192V9.7M.651 13.496c.149-.07.29-.173.445-.2 1.2-.202 1.949-.842 2.131-2.091.027-.176.24-.325.366-.486.147.171.302.338.439.516a.5.5 0 0 1 .079.23c.147.976.699 1.522 1.673 1.71.278.054.517.318.774.486-.257.168-.494.438-.771.486-1.03.181-1.52.8-1.712 1.783-.048.246-.315.45-.48.673-.147-.213-.414-.42-.42-.638-.053-1.668-1.533-1.607-2.522-2.14v-.33z" }),
        /* @__PURE__ */ V.jsx("path", { d: "M4.935 8.842c-.176-.267-.34-.406-.36-.565C4.321 6.424 3.27 5.39 1.432 5.115c-.155-.023-.283-.21-.425-.323.142-.14.267-.38.427-.405 1.84-.275 2.887-1.309 3.143-3.161.02-.147.22-.27.338-.406.136.147.369.279.394.444.276 1.8 1.277 2.843 3.095 3.108.17.025.308.25.461.382-.153.134-.293.363-.461.386-1.823.256-2.819 1.306-3.092 3.104-.027.178-.205.333-.378.598" })
      ] }),
      /* @__PURE__ */ V.jsx("defs", { children: /* @__PURE__ */ V.jsx("clipPath", { id: "Magic_svg__a", children: /* @__PURE__ */ V.jsx("path", { fill: "#fff", d: "M.651.82h16.482v15.783H.651z" }) }) })
    ]
  }
), cMe = (e) => /* @__PURE__ */ V.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 800,
    height: 800,
    fill: "#041e42",
    transform: "scale(-1 1)",
    viewBox: "0 0 99.442 99.443",
    ...e,
    children: [
      /* @__PURE__ */ V.jsx("path", { d: "M19.097 54.071a7.56 7.56 0 0 0-7.561 7.56c0 .324.026.641.066.951.469 3.729 3.642 6.611 7.494 6.611a7.56 7.56 0 0 0 7.53-6.916c.018-.214.033-.428.033-.646a7.56 7.56 0 0 0-7.562-7.56m-3.787 4.711 1.543 1.543a2.6 2.6 0 0 0-.274.665h-2.174a4.7 4.7 0 0 1 .905-2.208m-.913 3.516h2.189q.093.351.274.656L15.314 64.5a4.75 4.75 0 0 1-.917-2.202m4.046 4.03a4.7 4.7 0 0 1-2.193-.908l1.537-1.538c.202.118.424.205.656.266zm0-7.212a2.6 2.6 0 0 0-.668.279l-1.541-1.541c.633-.48 1.385-.8 2.209-.913zm1.309-2.175a4.7 4.7 0 0 1 2.209.914l-1.54 1.54a2.6 2.6 0 0 0-.669-.279zm0 9.387v-2.182c.233-.061.454-.147.657-.268l1.538 1.54a4.7 4.7 0 0 1-2.195.91m3.133-1.824-1.551-1.551c.12-.203.22-.42.282-.655h2.172a4.7 4.7 0 0 1-.903 2.206m-1.268-3.514a2.6 2.6 0 0 0-.274-.665l1.543-1.543a4.7 4.7 0 0 1 .905 2.208zM83.965 54.071a7.56 7.56 0 0 0-7.561 7.56c0 .324.025.641.065.951.468 3.729 3.643 6.611 7.494 6.611 3.958 0 7.201-3.042 7.53-6.916q.029-.32.031-.646a7.556 7.556 0 0 0-7.559-7.56m-3.788 4.711 1.543 1.543c-.12.206-.214.429-.273.665h-2.175a4.7 4.7 0 0 1 .905-2.208m-.912 3.516h2.19q.093.351.272.656L80.182 64.5a4.7 4.7 0 0 1-.917-2.202m4.045 4.03a4.7 4.7 0 0 1-2.192-.908l1.537-1.538c.201.118.424.205.655.266zm0-7.212a2.6 2.6 0 0 0-.669.279L81.1 57.854c.634-.48 1.385-.8 2.209-.913zm1.31-2.175a4.7 4.7 0 0 1 2.209.914l-1.541 1.54a2.6 2.6 0 0 0-.668-.279zm0 9.387v-2.182c.231-.061.454-.147.655-.268l1.538 1.54a4.7 4.7 0 0 1-2.193.91m3.132-1.824-1.551-1.551c.12-.203.22-.42.281-.655h2.174a4.7 4.7 0 0 1-.904 2.206m-1.269-3.514a2.6 2.6 0 0 0-.272-.665l1.542-1.543c.478.633.792 1.383.906 2.208z" }),
      /* @__PURE__ */ V.jsx("path", { d: "M99.091 47.939a10.35 10.35 0 0 0-1.339-4.754l-5.43-9.581A5.27 5.27 0 0 0 88 30.94c-9.1-.456-37.002-1.618-45.786.744-5.942 1.599-20.936 11.456-20.936 11.456S4.781 45.695 1.634 53.219c0 0-1.358.793-1.605 2.826-.127 1.046.183 2.634.525 3.965a3.77 3.77 0 0 0 3.067 2.783l7.16 1.122a8.7 8.7 0 0 1-.323-2.285c0-4.763 3.875-8.637 8.639-8.637 4.765 0 8.64 3.874 8.64 8.637 0 .249-.016.493-.036.735a8.5 8.5 0 0 1-.567 2.408l.842.045 47.568-1.287a8.8 8.8 0 0 1-.219-1.901c0-4.763 3.875-8.637 8.638-8.637 4.765 0 8.64 3.874 8.64 8.637 0 .249-.016.493-.037.735-.013.16-.041.315-.062.473L96.609 62a3.54 3.54 0 0 0 2.831-3.589zM71.715 32.71l1.093 10.911-16.774.686V32.655c4.904-.113 10.502-.062 15.681.055M29.387 45.087l-1.659.093a1.018 1.018 0 0 1-.658-1.839c.975-.712 2.169-1.563 3.499-2.462v2.784c-.81.685-1.182 1.424-1.182 1.424m4.111-2.554c-.105.004-.191.03-.291.04V39.15c3.382-2.144 7.215-4.273 10.511-5.34 1.5-.485 4.236-.795 7.636-.98v11.668l-14.412.589s-.5-2.664-3.444-2.554m58.27-1.058a2.94 2.94 0 0 1-2.426 1.471l-11.852.484-1.062-10.594c4.898.149 8.99.333 11.063.445a2.73 2.73 0 0 1 2.271 1.454l2.057 3.903a2.94 2.94 0 0 1-.051 2.837" })
    ]
  }
), dMe = (e) => /* @__PURE__ */ V.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "minus-circle",
    viewBox: "64 64 896 896",
    ...e,
    children: [
      /* @__PURE__ */ V.jsx("path", { d: "M696 480H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8" }),
      /* @__PURE__ */ V.jsx("path", { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372" })
    ]
  }
), fMe = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "minus-square",
    viewBox: "64 64 896 896",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32M704 536c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8z" })
  }
), mMe = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "more",
    viewBox: "64 64 896 896",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M456 231a56 56 0 1 0 112 0 56 56 0 1 0-112 0m0 280a56 56 0 1 0 112 0 56 56 0 1 0-112 0m0 280a56 56 0 1 0 112 0 56 56 0 1 0-112 0" })
  }
), hMe = (e) => /* @__PURE__ */ V.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", ...e, children: /* @__PURE__ */ V.jsx(
  "path",
  {
    fill: "#31ac9a",
    d: "M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64c0 247.4 200.6 448 448 448 18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368c-70.4-33.3-127.4-90.3-160.7-160.7l49.3-40.3c13.7-11.2 18.4-30 11.6-46.3l-40-96z"
  }
) }), pMe = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "plus-square",
    viewBox: "64 64 896 896",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32M704 536c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8z" })
  }
), gMe = (e) => /* @__PURE__ */ V.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "plus",
    viewBox: "64 64 896 896",
    ...e,
    children: [
      /* @__PURE__ */ V.jsx("path", { d: "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8" }),
      /* @__PURE__ */ V.jsx("path", { d: "M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z" })
    ]
  }
), vMe = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "pushpin",
    viewBox: "64 64 896 896",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M878.3 392.1 631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3-15.4 12.3-16.6 35.4-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 0 0-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8" })
  }
), bMe = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "save",
    viewBox: "64 64 896 896",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M893.3 293.3 730.7 130.7c-7.5-7.5-16.7-13-26.7-16V112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2M384 184h256v104H384zm456 656H184V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136zM512 442c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144m0 224c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80" })
  }
), yMe = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "search",
    viewBox: "64 64 896 896",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M909.6 854.5 649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1S492.1 112 412 112s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0 0 11.6 0l43.6-43.5a8.2 8.2 0 0 0 0-11.6M570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4" })
  }
), wMe = (e) => /* @__PURE__ */ V.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 800,
    height: 800,
    fill: "#041e42",
    transform: "scale(-1 1)",
    viewBox: "0 0 98.967 98.967",
    ...e,
    children: [
      /* @__PURE__ */ V.jsx("path", { d: "M17.275 52.156a7.47 7.47 0 0 0-7.468 7.468c0 .318.026.631.066.938.463 3.681 3.596 6.528 7.401 6.528a7.467 7.467 0 0 0 7.437-6.83c.017-.209.031-.422.031-.637a7.466 7.466 0 0 0-7.467-7.467m-3.738 4.654 1.522 1.523a2.6 2.6 0 0 0-.271.656h-2.146c.11-.812.421-1.554.895-2.179m-.905 3.472h2.163q.091.346.271.648l-1.526 1.525a4.7 4.7 0 0 1-.908-2.173m3.997 3.981a4.65 4.65 0 0 1-2.166-.899l1.518-1.519c.2.117.419.203.648.263zm0-7.123a2.6 2.6 0 0 0-.66.275l-1.521-1.521a4.64 4.64 0 0 1 2.181-.902zm1.293-2.15a4.65 4.65 0 0 1 2.181.903l-1.52 1.521a2.6 2.6 0 0 0-.66-.275zm0 9.271v-2.152a2.6 2.6 0 0 0 .647-.264l1.519 1.519a4.65 4.65 0 0 1-2.166.897m3.092-1.799-1.531-1.533c.12-.201.217-.416.278-.646h2.146a4.66 4.66 0 0 1-.893 2.179m-1.25-3.473a2.6 2.6 0 0 0-.271-.656l1.524-1.523c.471.625.782 1.367.894 2.18zM79.284 52.156a7.47 7.47 0 0 0-7.468 7.468c0 .318.026.631.066.938.463 3.681 3.596 6.528 7.4 6.528 3.908 0 7.112-3.004 7.438-6.83.017-.209.031-.422.031-.637a7.465 7.465 0 0 0-7.467-7.467m-3.738 4.654 1.521 1.523a2.6 2.6 0 0 0-.271.656H74.65a4.6 4.6 0 0 1 .896-2.179m-.904 3.472h2.163q.091.346.271.648l-1.525 1.525a4.63 4.63 0 0 1-.909-2.173m3.996 3.981a4.65 4.65 0 0 1-2.166-.899l1.518-1.519c.2.117.419.203.648.263zm0-7.123a2.6 2.6 0 0 0-.66.275l-1.521-1.521a4.64 4.64 0 0 1 2.181-.902zm1.294-2.15a4.65 4.65 0 0 1 2.181.903l-1.521 1.521a2.5 2.5 0 0 0-.66-.275zm0 9.271v-2.152a2.6 2.6 0 0 0 .647-.264l1.519 1.519a4.66 4.66 0 0 1-2.166.897m3.091-1.799-1.531-1.531c.12-.202.218-.416.278-.647h2.146a4.65 4.65 0 0 1-.893 2.178m-1.25-3.473a2.6 2.6 0 0 0-.271-.656l1.523-1.523c.472.625.782 1.367.895 2.18z" }),
      /* @__PURE__ */ V.jsx("path", { d: "M97.216 48.29v-5.526c0-.889-.646-1.642-1.524-1.779-2.107-.33-5.842-.953-7.52-1.47-2.406-.742-11.702-4.678-14.921-5.417-3.22-.739-17.738-4.685-31.643.135-2.353.815-12.938 5.875-19.162 8.506-1.833.04-19.976 3.822-20.942 6.414C.538 51.746.235 53.004.057 53.662s0 3.807 1.348 6c1.374.777 4.019 1.299 7.077 1.649-.035-.187-.073-.371-.097-.56a9 9 0 0 1-.078-1.125c0-4.945 4.022-8.969 8.968-8.969s8.968 4.023 8.968 8.969c0 .254-.017.506-.036.754a8.7 8.7 0 0 1-.292 1.613h.024l44.516-.896c-.02-.115-.046-.229-.061-.346a9 9 0 0 1-.078-1.125c0-4.945 4.022-8.968 8.968-8.968s8.969 4.022 8.969 8.968q0 .027-.003.053l.19-.016 7.611-1.433s2.915-1.552 2.915-5.822c.001-2.848-1.75-4.118-1.75-4.118m-44.159-5.239-16.625.509c.306-2.491-1.169-3.05-1.169-3.05 6.609-5.999 19.929-6.202 19.929-6.202zm18.658-.761-15.15.509 1.373-8.49c7.83-.102 12.303 1.626 12.303 1.626l2.237 3.61zm8.541-.052h-4.221l-4.22-5.795a80 80 0 0 1 7.209 3.287 2.35 2.35 0 0 1 1.232 2.508" })
    ]
  }
), SMe = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "setting",
    viewBox: "64 64 896 896",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "m924.8 625.7-65.5-56c3.1-19 4.7-38.4 4.7-57.8s-1.6-38.8-4.7-57.8l65.5-56a32.03 32.03 0 0 0 9.3-35.2l-.9-2.6a443.7 443.7 0 0 0-79.7-137.9l-1.8-2.1a32.12 32.12 0 0 0-35.1-9.5l-81.3 28.9c-30-24.6-63.5-44-99.7-57.6l-15.7-85a32.05 32.05 0 0 0-25.8-25.7l-2.7-.5c-52.1-9.4-106.9-9.4-159 0l-2.7.5a32.05 32.05 0 0 0-25.8 25.7l-15.8 85.4a351.9 351.9 0 0 0-99 57.4l-81.9-29.1a32 32 0 0 0-35.1 9.5l-1.8 2.1a446 446 0 0 0-79.7 137.9l-.9 2.6c-4.5 12.5-.8 26.5 9.3 35.2l66.3 56.6c-3.1 18.8-4.6 38-4.6 57.1 0 19.2 1.5 38.4 4.6 57.1L99 625.5a32.03 32.03 0 0 0-9.3 35.2l.9 2.6c18.1 50.4 44.9 96.9 79.7 137.9l1.8 2.1a32.12 32.12 0 0 0 35.1 9.5l81.9-29.1c29.8 24.5 63.1 43.9 99 57.4l15.8 85.4a32.05 32.05 0 0 0 25.8 25.7l2.7.5a449.4 449.4 0 0 0 159 0l2.7-.5a32.05 32.05 0 0 0 25.8-25.7l15.7-85a350 350 0 0 0 99.7-57.6l81.3 28.9a32 32 0 0 0 35.1-9.5l1.8-2.1c34.8-41.1 61.6-87.5 79.7-137.9l.9-2.6c4.5-12.3.8-26.3-9.3-35M788.3 465.9c2.5 15.1 3.8 30.6 3.8 46.1s-1.3 31-3.8 46.1l-6.6 40.1 74.7 63.9a370 370 0 0 1-42.6 73.6L721 702.8l-31.4 25.8c-23.9 19.6-50.5 35-79.3 45.8l-38.1 14.3-17.9 97a377.5 377.5 0 0 1-85 0l-17.9-97.2-37.8-14.5c-28.5-10.8-55-26.2-78.7-45.7l-31.4-25.9-93.4 33.2c-17-22.9-31.2-47.6-42.6-73.6l75.5-64.5-6.5-40c-2.4-14.9-3.7-30.3-3.7-45.5 0-15.3 1.2-30.6 3.7-45.5l6.5-40-75.5-64.5c11.3-26.1 25.6-50.7 42.6-73.6l93.4 33.2 31.4-25.9c23.7-19.5 50.2-34.9 78.7-45.7l37.9-14.3 17.9-97.2c28.1-3.2 56.8-3.2 85 0l17.9 97 38.1 14.3c28.7 10.8 55.4 26.2 79.3 45.8l31.4 25.8 92.8-32.9c17 22.9 31.2 47.6 42.6 73.6L781.8 426zM512 326c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176m79.2 255.2A111.6 111.6 0 0 1 512 614c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 0 1 400 502c0-29.9 11.7-58 32.8-79.2C454 401.6 482.1 390 512 390s58 11.6 79.2 32.8A111.6 111.6 0 0 1 624 502c0 29.9-11.7 58-32.8 79.2" })
  }
), CMe = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none",
    ...e,
    children: /* @__PURE__ */ V.jsx(
      "path",
      {
        stroke: "#041E42",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M11.25 20.5H5a1 1 0 0 1-1-1v-14a1 1 0 0 1 1-1h6.25m8.75 8H8.75m11.25 0L15.5 17m4.5-4.5L15.5 8"
      }
    )
  }
), xMe = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "star",
    viewBox: "64 64 896 896",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "m908.1 353.1-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3M664.8 561.6l36.1 210.3L512 672.7 323.1 772l36.1-210.3-152.8-149L417.6 382 512 190.7 606.4 382l211.2 30.7z" })
  }
), EMe = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "sync",
    viewBox: "64 64 896 896",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M168 504.2c1-43.7 10-86.1 26.9-126 17.3-41 42.1-77.7 73.7-109.4S337 212.3 378 195c42.4-17.9 87.4-27 133.9-27s91.5 9.1 133.8 27A341.5 341.5 0 0 1 755 268.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 0 0 3 14.1l175.7 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c0-6.7-7.7-10.5-12.9-6.3l-56.4 44.1C765.8 155.1 646.2 92 511.8 92 282.7 92 96.3 275.6 92 503.8a8 8 0 0 0 8 8.2h60c4.4 0 7.9-3.5 8-7.8m756 7.8h-60c-4.4 0-7.9 3.5-8 7.8-1 43.7-10 86.1-26.9 126-17.3 41-42.1 77.8-73.7 109.4A342.45 342.45 0 0 1 512.1 856a342.24 342.24 0 0 1-243.2-100.8c-9.9-9.9-19.2-20.4-27.8-31.4l60.2-47a8 8 0 0 0-3-14.1l-175.7-43c-5-1.2-9.9 2.6-9.9 7.7l-.7 181c0 6.7 7.7 10.5 12.9 6.3l56.4-44.1C258.2 868.9 377.8 932 512.2 932c229.2 0 415.5-183.7 419.8-411.8a8 8 0 0 0-8-8.2" })
  }
), PMe = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 800,
    height: 800,
    fill: "#041e42",
    transform: "scale(-1 1)",
    viewBox: "0 -32.56 122.88 122.88",
    ...e,
    children: /* @__PURE__ */ V.jsx(
      "path",
      {
        d: "M55.2.01h-2c-4.58 0-10.98-.3-14.66 2.81C32.26 7.29 27.4 15.21 22.1 20.38c-4.3.56-14.26 2.03-16.55 4.07-2.65 2.36-2.62 9.95-2.58 13.17-4.92-.1-2.93 11.81.26 12.49h6.85c-4.4-26.18 32.92-22.94 27.3 0h38.19c-5.76-21.96 31.01-27.57 27.47-.21 6.53-.02 10.06-.1 16.89 0 2.71-.62 2.97-2.13 2.97-5.75l-2.66-.33.08-1.5.09-2.65c.16-5.81.14-11.43-.19-16.74H59.77V5.58c.1-3.72-1.53-5.46-4.57-5.57m34.67 41.16c3.02 0 5.46 2.45 5.46 5.46s-2.45 5.46-5.46 5.46a5.46 5.46 0 0 1 0-10.92M54.4 4.74h-8.8c-4.54 0-10.59 6.56-14.02 13.01-.35.65-3.08 5.18-1.25 5.18H54.4V4.74M23.5 41.17c3.02 0 5.46 2.45 5.46 5.46s-2.45 5.46-5.46 5.46a5.46 5.46 0 0 1 0-10.92m0-5.65c6.14 0 11.11 4.98 11.11 11.11S29.64 57.75 23.5 57.75s-11.11-4.98-11.11-11.11 4.97-11.12 11.11-11.12m66.37 0c6.14 0 11.11 4.98 11.11 11.11S96 57.74 89.87 57.74c-6.14 0-11.11-4.98-11.11-11.11s4.97-11.11 11.11-11.11",
        style: {
          fillRule: "evenodd",
          clipRule: "evenodd"
        }
      }
    )
  }
), kMe = (e) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "warning",
    viewBox: "64 64 896 896",
    ...e,
    children: /* @__PURE__ */ V.jsx("path", { d: "M464 720a48 48 0 1 0 96 0 48 48 0 1 0-96 0m16-304v184c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V416c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8m475.7 440-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48m-783.5-27.9L512 239.9l339.8 588.2z" })
  }
), MMe = "data:image/webp;base64,UklGRpIEAABXRUJQVlA4WAoAAAAQAAAAqQAAMQAAQUxQSJAAAAABcFXbVtxcCU8CEpCABCREQiREAhIiIRIiAQmVgIPbuf06HT8iYgL0JzUXzrsxN0xjEqVDFqU9RKnpktCootSzKG0hSovuhDOqKPUkSmuI0qxHuYwiSj2J0hqiNOmpbx+vwck9cfIonOwZlNfg5J44eVRO9gLKW3Byz5w8Kie7gfIenHzInDwmTnbLhbP+pAJWUDgg3AMAAPAVAJ0BKqoAMgA+kTybSqWioimmlVq5MBIJbAhwAXl4of27s/xUIy6Z/neADOLYo/0fsT/N29n8xf7H/sB77vo9/4XqAf6TqHf2A6dT2Zf3S9I1oqTc0GhwIbcRS9ywIRMpviVnTF0ZKJPg+UhHvraNw1vbSPtkRqjyieEjq+S9Ders0dhdzEzQrrqx5its5GaUsMjhoFJol2+KzHF8AsXPqe8kIFbe+Rf3521x95iSxjAYnpFwmgAA/hDSf2YyIfCwj0/f/7Rx+HHjNpTgmNU7/Oi73fQLfYiGyOVuZ0cKVDVVWqjASUIOBfYbhgJ4nE8iLPlM5Wf42J+/wMQZ8B2m7PM8iWsg1Vr1vvIXGR/cCBS53O3saJBxh5ikPC5BReCeIxii+Yrsu1ZJGwN/SXWjcvC+f0h+YuvWpXtm/qhFs7xHfbHGdX7H8PIK0Dvaa+6dWBce/IyTNhhhIDH3KH8pbHBEd0AZavrTbPHlfxf3eeBRd3Lofe63j4ZmJYdpsYUD0GRNX6Qt1hRSq849QG9Wcu752vxknyP3+RZWGAxm6nAsZWTg31PNANlArCb7I3tOSx0A4TZ8SgrpPNWG+US+muIfX8vq1lCFdAaBi/7pZD/2HZbm8qTFIfgA5MhruoZ4aXTzhlMyei9Xg5lzEh5A0XlpcZMYebIH5RgugtLgldOj5hB34E8+6MqXNS/KAHCWuQbYTopGrGz3gvO1HE67xn9uAI3oM6Od0BrDWFw1GhtQkaUTTlOGM/Q0r9eiO6aomXEtu0k0uZztgLw7+2mq76F5Gq2KnMvcqtKTJHss4HhslARIkhWAW0CbACF+td/TrY+/wB30Qh1L6zLWo1oq0Pup+5UKdxtO0fkq6h7yxh4umNKjL2RaX1ADGS+w90l7G/OeltE/8hlGPPacoIETFr9exwdZy1/HeRVO9dPq2IE8wDYVjuHZEKimqOnnvnz3v4MT6/VLsPKlCXCPpws6dGwdrt/+jiluNJTiZGOX84S7fXRv/vf2+uhlZlcf/nSw0IB/br+7GzuxHEE1Kufj3JsFpyiGK1nhZN7i14eMCSgmaibQnPVm41NzSaifGfZa/YWhYkf0cdq8fPbBH0mQAMFXKnbvEIDkoZF37lHPQ8/LXN/2ZgTQ74eTxyAEkF4pDHUbB118JehELnG+21V3GM/3phOAjsn5gPK0xfDElPzrRilNiA+61AnJrw7m7G3F66k+2CTTBjmdPA9mDD5m9/ugY8xW3H4W7bWd9VSo1GA5j41mD4mYCiXwvZtVarKbzJDw/JHS0zqlbfMDVsBQmgBakWChMdUAAAA=", OMe = "data:image/jpeg;base64,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", TMe = "data:image/webp;base64,UklGRkAFAABXRUJQVlA4WAoAAAAQAAAAqgAAMQAAQUxQSJEAAAABcFXbVtxcCU8CEpCABCREQiREAhIiIRIiAQmVgIPbuf06HT8iYgL0ZzUXztqNuXEakzAdsjDtIUxNVwmNKkw9C9MWwrToXjijClNPwrSGMM16mMsowtSTMK0hTJOe+/7xGqDcEyiPAsqeSXkNUO4JlEcFZS+kvAUo9wzKo4KyGynvAcqHDMpjAmU35cJZ/1UBAFZQOCCIBAAAUBcAnQEqqwAyAD6RPJpLpaKiLyOzPLHgEgllAM9cmK4s42hxHe0A3PLMPHebu5n+Y8rrul3AcYH4B5HHm//luQA8MH/c8wf0L7B5M6sSrHeremB50RUWL2PLn5nw2ZkIF7cqIixKBV0KwmiYJVZxu2JR7n/bxX6gi1o5o0pEe+lROwzZyVg1HuoiK/rT7JiwebJS1MJY7sdpk56u5xd0pmZE/zn2tLkY0JIzUjRHRnpqJ0srzXt2ROCWNTJgOB15Mz5gAP71ZFR6vEbZbNBpBi+3VET+uMPXmif+L47QldS15ydp54AFBlQv7KTwM/ChpeDCwgDohHmo2W9P5reKwQRpMpH6wmDQiaAIF8/3zo+pj4J/hzbcAeaLaYKF0sosjsSlhtRNL/fH+jzs0olRYfmN/zXFCMedMgbYxr/2wlYJjZzso2nvKZeG7JtfXFkich9RgERe5kr4P6pIa0H81BrB6ULERkMDQUNYiFVVaCTeZpli+qayiG3s13NvQclBrWe2K9Wnqw4UBMvs0fqmXxC5oahjDU7Wr+StgLfKwG0vt3Bd7G+1LNSuMBMxJfBi5lsLl8DOX/X5M2cM5m+9cGgYz/I/rjgBJzYTGMJIQ7pmn37jy8XBK/hq9ix05ZZS0NzWr/V3s/Lyv3hVOgfaHWD4/0dFYqu5A24gct/asxWECP8rtneBPCF4g0zCfCVgGZW0yEPuCnzabZ0jfvj+cJb21V9vP8TCe9eyBXzVizFophpKeubTw8M6f82Vs888A1pGeKkbPuXsNSHhEZfJh7+CPygXsNG5LMvJZJqx/T9mXdRpCBLvzpeoxR1QK8r/jMouNzSswz+tIO5lmTtc/g8vB/0i9PMMEVMc5y17V25AE+lrnGaIbGbvV8elPYX0ABEaYu6SlxWLZaERtrBFLi5XmW2iYscroMnmn9FQB1rWfjWH9dcYqCGh0cQLIfLxm2vNroRsg+v60YryyPC+USrdvrMEEXGDmsGHZGTKlJH8LCHA4l2pW/QFy4vIeoQAL/nnZJzAFrfS4PAituJ4LWl3DwkDJqHScD59rbWmq9u+KSo7ghjbtbCX7ByPMw+RnsMM5PKP9NHKj93lEQk1jMkukilrNfzzZbvwWOSb9hA7U/HPzyvE6DDICdUXhb3TQtyK0OYM5bGh/pcs+aVzlCD0P/g3d/8t0+YkNWCDH+H3FzaKZHX+CsKUwBIhAAr5JmuHOpdzYg92xYBgPRif6Cdwbx5kQGZpj5GcqmP7bXvlcYgFhwabYI192x/oxTh/sxs8Kwv8wPbi1/Dv0hENN8KeJdO0hX2+IN+MDCWILS917gVVJrFB826qxmV2gQoRVIz6v5hamGYe5QchS9Ba3a5coBXretDJ2LZrWvdV74EPUb1M+xRp11+KUIDsj/d71tyi31LDVqNNeiEYENJ2Wag2sECJPSJPQ5rpTGXyO0gPrarlI42UgTeVt9ynG1fOh128TMuHWZA7YZbSy04ehv+O/JkOxOpGQnmUDSRx0BHA0TOeHxD+u0sFR1G61k52cHHqQAAAAAA=", RMe = "data:image/webp;base64,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", AMe = "data:image/webp;base64,UklGRv4CAABXRUJQVlA4WAoAAAAQAAAAqQAAMQAAQUxQSIAAAAABf0CQbTODDeH+oGeIiKR1BaPa1m7c//fMYIlABVGIIIIoIoggigj/0PAWOJ6jiP5PgH7Tp4lnpBSRWhGtQiqQehHtAakW0SiiIyI1IlpElHKkTkRbQCpFNOg+uWTaApI7ppQjeWFyw3REJI9Mrpn2gOSeyQXTyuSWKUUkT/pNA1ZQOCBYAgAA8A8AnQEqqgAyAD6RPJpJJaM0ISdTPlqAEglpL773/cABCgJd4c3D0TPfJXV/7c2wBoC9V7jGpow5/7IoIl9jUxfEHjw9IEJMfYcSmk7552lbsl/5KJRh4iBq1BHRSvROi1p0NMfXI98axZodOu+X0FEhC0QoYdmTA6k9N5C1LxlKiF4GfUUaYAD+8tU///HH5TKJJORPpqDuTbjiZY8g/0kZ00Z+nAA4M+Dr31AFpkHG6PeyJ3SPovR6s05cWv/6+PLa78/9n8A+anwPK3GKWbYTSBgjYXcxkcgveZiyBzcz3Ct+XS6XBtFkV0LVZSN9p4tALM8sPQMlHJTrrCJFEYT//vqEsZAlUms8TITlySlZCJMrk2Yj+dCopzK40u2VQKaDX+nRbLT5y+hthrYq3v1unUaAu3BlPz8tfQfTc8xQQrSh3P/q1OYgWiH5bKAJiyvXCPFV3Grh/mwPFbbCXRX9z97epkl53s3xdnV3N5PrFz9qnRgZrcsu6foGLm5H+Gw6aGfnG77P2Wj8zVVbLYDo5QVPOK/RFwIDZ37fE3h7eL+0d3+M4PerOBKubzaOQWQ/F3Pni8YtbHj8T3MYJeWyMndl0ggZ1bQaE3ZLP/nUNstPVjcJMtPPxObT+DnbYq8+zRlS5S80wk8rXEorhrQ1I6wJ6vqnWWWK/eSmQKFdkds7YjpAbQDFukWmUoABPIUfbpiiBzLxOTTxM4DV5+B3LEXgFRc8ertg5Scj3291ZIUs7DfMLSkTk7bCheOoXgDf14in1fFjkQpQleEh/wptOAAAAAAA", M$ = {
  // SVG
  affiliatedLots: x9e,
  arrowLeftOutlined: b9e,
  calendarOutlined: y9e,
  cameraOutlined: w9e,
  car: S9e,
  carOutlined: C9e,
  caretDownFilled: SB,
  caretUpFilled: CB,
  cart: P9e,
  chevronLeft: M9e,
  chevronRight: O9e,
  circleChecked: A9e,
  circleWarning: N9e,
  clockCircleOutlined: D9e,
  close: $9e,
  closeCircleOutlined: z9e,
  closeOutlined: j9e,
  closeX: I9e,
  commentOutlined: L9e,
  coupeSedan: wMe,
  deleteOutlined: H9e,
  dollar: F9e,
  doubleLeft: W9e,
  doubleRight: V9e,
  downArrow: SB,
  downOutlined: k9e,
  editOutlined: _9e,
  email: B9e,
  eyeCrossedOutOutlined: U9e,
  eyeOutlined: X9e,
  fax: tMe,
  fileTextOutlined: nMe,
  hamburgerMenu: rMe,
  homeOutlined: aMe,
  info: oMe,
  infoOutlined: iMe,
  lineChartOutlined: lMe,
  loadingOutlined: (e) => /* @__PURE__ */ V.jsx("span", { className: "flex h-min w-min animate-spin items-center justify-center", children: /* @__PURE__ */ V.jsx(sMe, { ...e }) }),
  magic: uMe,
  minusCircle: dMe,
  minusSquare: fMe,
  moreOutlined: mMe,
  phone: hMe,
  plus: pMe,
  plusOutlined: gMe,
  pushPin: vMe,
  save: bMe,
  search: yMe,
  settingOutlined: SMe,
  signOut: CMe,
  starOutlined: xMe,
  suvCrossover: E9e,
  sync: EMe,
  truck: PMe,
  upArrow: CB,
  upOutlined: T9e,
  vanMinivan: cMe,
  warning: kMe,
  circleAlertOutlined: R9e,
  // Non-SVG icons
  routeOne: B5(RMe),
  // Font Awesome
  faUsd: Y9e,
  faExclamationTriangle: J9e,
  faBullhorn: G9e,
  faCheck: q9e,
  faEnvelope: Q9e,
  faInfo: Z9e,
  faClose: K9e,
  faPdfFile: eMe,
  // Programs
  goldProgram: B5(MMe),
  platinumProgram: B5(TMe),
  silverProgram: B5(AMe),
  goldProgramModal: B5(OMe),
  // None
  none: lte
}, yTt = Object.keys(M$), _f = ({
  name: e = "none",
  color: t = "",
  size: r = 20,
  width: a = r,
  height: i = a,
  style: c,
  className: d,
  ...f
}) => {
  if (!M$[e])
    return /* @__PURE__ */ V.jsx(lte, {});
  const p = M$[e], g = t || mr("--icon-color"), b = { ...c }, w = c != null && Object.prototype.hasOwnProperty.call(c, "color");
  return t ? b.color = t : !w && (d == null || d === "") && g && (b.color = g), /* @__PURE__ */ V.jsx(
    p,
    {
      className: d,
      color: g,
      height: i,
      size: r,
      style: b,
      width: a,
      ...f
    }
  );
};
function B5(e) {
  return ({
    color: r,
    size: a,
    alt: i,
    testId: c,
    width: d = a
  }) => /* @__PURE__ */ V.jsx(
    "img",
    {
      src: e,
      alt: i ?? "",
      loading: "lazy",
      height: a,
      width: d,
      "data-testId": c,
      style: { color: r }
    }
  );
}
function lte() {
  return /* @__PURE__ */ V.jsx("span", { children: "No Icon Found" });
}
const NMe = "_select_c0zfb_35", DMe = {
  select: NMe
};
function ste() {
  return {
    colorPrimary: mr("--input-components-primary-color"),
    backgroundColor: mr("--input-components-background-color"),
    fontFamily: mr("--input-components-font-family"),
    fontSize: mr("--input-components-font-size"),
    fontColor: mr("--input-components-font-color"),
    errorBg: mr("--input-component-error-background-color"),
    colorBorder: mr("--input-components-color-border"),
    optionPadding: mr("--input-components-option-padding"),
    optionActiveBg: mr(
      "--input-components-option-hover-bg-color"
    ),
    optionSelectedBg: mr(
      "--input-components-option-selected-bg-color"
    ),
    defaultBackgroundColorForInputNumber: mr(
      "--input-component-number-default-background-color"
    )
  };
}
function $Me(e) {
  const {
    colorPrimary: t,
    fontFamily: r,
    fontColor: a,
    fontSize: i,
    optionPadding: c,
    optionActiveBg: d,
    optionSelectedBg: f
  } = ste(), p = {
    classic: {
      components: {
        Select: {
          optionPadding: c,
          optionActiveBg: d,
          // The hovered option's background color, selected state's bg color takes precedence over the hover's
          optionSelectedColor: a,
          // The selected option's text color
          optionSelectedBg: f,
          // The selected option's background color
          optionHeight: Number.parseInt(i)
        }
      },
      token: {
        colorPrimary: t,
        fontFamily: r
      }
    }
  };
  return p[e] || p.classic;
}
const zMe = ({
  value: e,
  theme: t = "classic",
  className: r = "",
  popupClassName: a = "",
  popupMatchSelectWidth: i = !0,
  onChange: c,
  dataTestId: d,
  size: f,
  ...p
}) => {
  const g = mn(() => $Me(t), [t]), b = (x) => {
    c(x, e);
  }, w = f === "medium" ? "middle" : f;
  return /* @__PURE__ */ V.jsx(tc, { theme: g, children: /* @__PURE__ */ V.jsx(
    aj,
    {
      className: _e(r, DMe.select, "input"),
      onChange: b,
      value: e,
      popupMatchSelectWidth: i,
      popupClassName: a,
      "data-testid": d,
      size: w,
      ...p
    }
  ) });
};
function xB(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function fS(...e) {
  return (t) => {
    let r = !1;
    const a = e.map((i) => {
      const c = xB(i, t);
      return !r && typeof c == "function" && (r = !0), c;
    });
    if (r)
      return () => {
        for (let i = 0; i < a.length; i++) {
          const c = a[i];
          typeof c == "function" ? c() : xB(e[i], null);
        }
      };
  };
}
function Wl(...e) {
  return S.useCallback(fS(...e), e);
}
function jMe(e, t) {
  const r = S.createContext(t), a = (c) => {
    const { children: d, ...f } = c, p = S.useMemo(() => f, Object.values(f));
    return /* @__PURE__ */ V.jsx(r.Provider, { value: p, children: d });
  };
  a.displayName = e + "Provider";
  function i(c) {
    const d = S.useContext(r);
    if (d) return d;
    if (t !== void 0) return t;
    throw new Error(`\`${c}\` must be used within \`${e}\``);
  }
  return [a, i];
}
function Eb(e, t = []) {
  let r = [];
  function a(c, d) {
    const f = S.createContext(d), p = r.length;
    r = [...r, d];
    const g = (w) => {
      const { scope: x, children: E, ...P } = w, k = x?.[e]?.[p] || f, M = S.useMemo(() => P, Object.values(P));
      return /* @__PURE__ */ V.jsx(k.Provider, { value: M, children: E });
    };
    g.displayName = c + "Provider";
    function b(w, x) {
      const E = x?.[e]?.[p] || f, P = S.useContext(E);
      if (P) return P;
      if (d !== void 0) return d;
      throw new Error(`\`${w}\` must be used within \`${c}\``);
    }
    return [g, b];
  }
  const i = () => {
    const c = r.map((d) => S.createContext(d));
    return function(f) {
      const p = f?.[e] || c;
      return S.useMemo(
        () => ({ [`__scope${e}`]: { ...f, [e]: p } }),
        [f, p]
      );
    };
  };
  return i.scopeName = e, [a, IMe(i, ...t)];
}
function IMe(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const a = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(c) {
      const d = a.reduce((f, { useScope: p, scopeName: g }) => {
        const w = p(c)[`__scope${g}`];
        return { ...f, ...w };
      }, {});
      return S.useMemo(() => ({ [`__scope${t.scopeName}`]: d }), [d]);
    };
  };
  return r.scopeName = t.scopeName, r;
}
function io(e, t, { checkForDefaultPrevented: r = !0 } = {}) {
  return function(i) {
    if (e?.(i), r === !1 || !i.defaultPrevented)
      return t?.(i);
  };
}
var G1 = globalThis?.document ? S.useLayoutEffect : () => {
}, LMe = S[" useInsertionEffect ".trim().toString()] || G1;
function iC({
  prop: e,
  defaultProp: t,
  onChange: r = () => {
  },
  caller: a
}) {
  const [i, c, d] = HMe({
    defaultProp: t,
    onChange: r
  }), f = e !== void 0, p = f ? e : i;
  {
    const b = S.useRef(e !== void 0);
    S.useEffect(() => {
      const w = b.current;
      w !== f && console.warn(
        `${a} is changing from ${w ? "controlled" : "uncontrolled"} to ${f ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), b.current = f;
    }, [f, a]);
  }
  const g = S.useCallback(
    (b) => {
      if (f) {
        const w = FMe(b) ? b(e) : b;
        w !== e && d.current?.(w);
      } else
        c(b);
    },
    [f, e, c, d]
  );
  return [p, g];
}
function HMe({
  defaultProp: e,
  onChange: t
}) {
  const [r, a] = S.useState(e), i = S.useRef(r), c = S.useRef(t);
  return LMe(() => {
    c.current = t;
  }, [t]), S.useEffect(() => {
    i.current !== r && (c.current?.(r), i.current = r);
  }, [r, i]), [r, a, c];
}
function FMe(e) {
  return typeof e == "function";
}
function NM(e) {
  const t = S.useRef({ value: e, previous: e });
  return S.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
function DM(e) {
  const [t, r] = S.useState(void 0);
  return G1(() => {
    if (e) {
      r({ width: e.offsetWidth, height: e.offsetHeight });
      const a = new ResizeObserver((i) => {
        if (!Array.isArray(i) || !i.length)
          return;
        const c = i[0];
        let d, f;
        if ("borderBoxSize" in c) {
          const p = c.borderBoxSize, g = Array.isArray(p) ? p[0] : p;
          d = g.inlineSize, f = g.blockSize;
        } else
          d = e.offsetWidth, f = e.offsetHeight;
        r({ width: d, height: f });
      });
      return a.observe(e, { box: "border-box" }), () => a.unobserve(e);
    } else
      r(void 0);
  }, [e]), t;
}
function WMe(e, t) {
  return S.useReducer((r, a) => t[r][a] ?? r, e);
}
var X0 = (e) => {
  const { present: t, children: r } = e, a = VMe(t), i = typeof r == "function" ? r({ present: a.isPresent }) : S.Children.only(r), c = Wl(a.ref, _Me(i));
  return typeof r == "function" || a.isPresent ? S.cloneElement(i, { ref: c }) : null;
};
X0.displayName = "Presence";
function VMe(e) {
  const [t, r] = S.useState(), a = S.useRef(null), i = S.useRef(e), c = S.useRef("none"), d = e ? "mounted" : "unmounted", [f, p] = WMe(d, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return S.useEffect(() => {
    const g = CP(a.current);
    c.current = f === "mounted" ? g : "none";
  }, [f]), G1(() => {
    const g = a.current, b = i.current;
    if (b !== e) {
      const x = c.current, E = CP(g);
      e ? p("MOUNT") : E === "none" || g?.display === "none" ? p("UNMOUNT") : p(b && x !== E ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
    }
  }, [e, p]), G1(() => {
    if (t) {
      let g;
      const b = t.ownerDocument.defaultView ?? window, w = (E) => {
        const k = CP(a.current).includes(CSS.escape(E.animationName));
        if (E.target === t && k && (p("ANIMATION_END"), !i.current)) {
          const M = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", g = b.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = M);
          });
        }
      }, x = (E) => {
        E.target === t && (c.current = CP(a.current));
      };
      return t.addEventListener("animationstart", x), t.addEventListener("animationcancel", w), t.addEventListener("animationend", w), () => {
        b.clearTimeout(g), t.removeEventListener("animationstart", x), t.removeEventListener("animationcancel", w), t.removeEventListener("animationend", w);
      };
    } else
      p("ANIMATION_END");
  }, [t, p]), {
    isPresent: ["mounted", "unmountSuspended"].includes(f),
    ref: S.useCallback((g) => {
      a.current = g ? getComputedStyle(g) : null, r(g);
    }, [])
  };
}
function CP(e) {
  return e?.animationName || "none";
}
function _Me(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
// @__NO_SIDE_EFFECTS__
function IE(e) {
  const t = /* @__PURE__ */ BMe(e), r = S.forwardRef((a, i) => {
    const { children: c, ...d } = a, f = S.Children.toArray(c), p = f.find(XMe);
    if (p) {
      const g = p.props.children, b = f.map((w) => w === p ? S.Children.count(g) > 1 ? S.Children.only(null) : S.isValidElement(g) ? g.props.children : null : w);
      return /* @__PURE__ */ V.jsx(t, { ...d, ref: i, children: S.isValidElement(g) ? S.cloneElement(g, void 0, b) : null });
    }
    return /* @__PURE__ */ V.jsx(t, { ...d, ref: i, children: c });
  });
  return r.displayName = `${e}.Slot`, r;
}
// @__NO_SIDE_EFFECTS__
function BMe(e) {
  const t = S.forwardRef((r, a) => {
    const { children: i, ...c } = r;
    if (S.isValidElement(i)) {
      const d = qMe(i), f = GMe(c, i.props);
      return i.type !== S.Fragment && (f.ref = a ? fS(a, d) : d), S.cloneElement(i, f);
    }
    return S.Children.count(i) > 1 ? S.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var UMe = Symbol("radix.slottable");
function XMe(e) {
  return S.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === UMe;
}
function GMe(e, t) {
  const r = { ...t };
  for (const a in t) {
    const i = e[a], c = t[a];
    /^on[A-Z]/.test(a) ? i && c ? r[a] = (...f) => {
      const p = c(...f);
      return i(...f), p;
    } : i && (r[a] = i) : a === "style" ? r[a] = { ...i, ...c } : a === "className" && (r[a] = [i, c].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function qMe(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var KMe = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Ro = KMe.reduce((e, t) => {
  const r = /* @__PURE__ */ IE(`Primitive.${t}`), a = S.forwardRef((i, c) => {
    const { asChild: d, ...f } = i, p = d ? r : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ V.jsx(p, { ...f, ref: c });
  });
  return a.displayName = `Primitive.${t}`, { ...e, [t]: a };
}, {});
function O$(e, t) {
  e && sp.flushSync(() => e.dispatchEvent(t));
}
var $M = "Checkbox", [YMe] = Eb($M), [QMe, hI] = YMe($M);
function JMe(e) {
  const {
    __scopeCheckbox: t,
    checked: r,
    children: a,
    defaultChecked: i,
    disabled: c,
    form: d,
    name: f,
    onCheckedChange: p,
    required: g,
    value: b = "on",
    // @ts-expect-error
    internal_do_not_use_render: w
  } = e, [x, E] = iC({
    prop: r,
    defaultProp: i ?? !1,
    onChange: p,
    caller: $M
  }), [P, k] = S.useState(null), [M, T] = S.useState(null), N = S.useRef(!1), D = P ? !!d || !!P.closest("form") : (
    // We set this to true by default so that events bubble to forms without JS (SSR)
    !0
  ), $ = {
    checked: x,
    disabled: c,
    setChecked: E,
    control: P,
    setControl: k,
    name: f,
    form: d,
    value: b,
    hasConsumerStoppedPropagationRef: N,
    required: g,
    defaultChecked: IS(i) ? !1 : i,
    isFormControl: D,
    bubbleInput: M,
    setBubbleInput: T
  };
  return /* @__PURE__ */ V.jsx(
    QMe,
    {
      scope: t,
      ...$,
      children: ZMe(w) ? w($) : a
    }
  );
}
var ute = "CheckboxTrigger", cte = S.forwardRef(
  ({ __scopeCheckbox: e, onKeyDown: t, onClick: r, ...a }, i) => {
    const {
      control: c,
      value: d,
      disabled: f,
      checked: p,
      required: g,
      setControl: b,
      setChecked: w,
      hasConsumerStoppedPropagationRef: x,
      isFormControl: E,
      bubbleInput: P
    } = hI(ute, e), k = Wl(i, b), M = S.useRef(p);
    return S.useEffect(() => {
      const T = c?.form;
      if (T) {
        const N = () => w(M.current);
        return T.addEventListener("reset", N), () => T.removeEventListener("reset", N);
      }
    }, [c, w]), /* @__PURE__ */ V.jsx(
      Ro.button,
      {
        type: "button",
        role: "checkbox",
        "aria-checked": IS(p) ? "mixed" : p,
        "aria-required": g,
        "data-state": gte(p),
        "data-disabled": f ? "" : void 0,
        disabled: f,
        value: d,
        ...a,
        ref: k,
        onKeyDown: io(t, (T) => {
          T.key === "Enter" && T.preventDefault();
        }),
        onClick: io(r, (T) => {
          w((N) => IS(N) ? !0 : !N), P && E && (x.current = T.isPropagationStopped(), x.current || T.stopPropagation());
        })
      }
    );
  }
);
cte.displayName = ute;
var dte = S.forwardRef(
  (e, t) => {
    const {
      __scopeCheckbox: r,
      name: a,
      checked: i,
      defaultChecked: c,
      required: d,
      disabled: f,
      value: p,
      onCheckedChange: g,
      form: b,
      ...w
    } = e;
    return /* @__PURE__ */ V.jsx(
      JMe,
      {
        __scopeCheckbox: r,
        checked: i,
        defaultChecked: c,
        disabled: f,
        required: d,
        onCheckedChange: g,
        name: a,
        form: b,
        value: p,
        internal_do_not_use_render: ({ isFormControl: x }) => /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
          /* @__PURE__ */ V.jsx(
            cte,
            {
              ...w,
              ref: t,
              __scopeCheckbox: r
            }
          ),
          x && /* @__PURE__ */ V.jsx(
            pte,
            {
              __scopeCheckbox: r
            }
          )
        ] })
      }
    );
  }
);
dte.displayName = $M;
var fte = "CheckboxIndicator", mte = S.forwardRef(
  (e, t) => {
    const { __scopeCheckbox: r, forceMount: a, ...i } = e, c = hI(fte, r);
    return /* @__PURE__ */ V.jsx(
      X0,
      {
        present: a || IS(c.checked) || c.checked === !0,
        children: /* @__PURE__ */ V.jsx(
          Ro.span,
          {
            "data-state": gte(c.checked),
            "data-disabled": c.disabled ? "" : void 0,
            ...i,
            ref: t,
            style: { pointerEvents: "none", ...e.style }
          }
        )
      }
    );
  }
);
mte.displayName = fte;
var hte = "CheckboxBubbleInput", pte = S.forwardRef(
  ({ __scopeCheckbox: e, ...t }, r) => {
    const {
      control: a,
      hasConsumerStoppedPropagationRef: i,
      checked: c,
      defaultChecked: d,
      required: f,
      disabled: p,
      name: g,
      value: b,
      form: w,
      bubbleInput: x,
      setBubbleInput: E
    } = hI(hte, e), P = Wl(r, E), k = NM(c), M = DM(a);
    S.useEffect(() => {
      const N = x;
      if (!N) return;
      const D = window.HTMLInputElement.prototype, j = Object.getOwnPropertyDescriptor(
        D,
        "checked"
      ).set, I = !i.current;
      if (k !== c && j) {
        const L = new Event("click", { bubbles: I });
        N.indeterminate = IS(c), j.call(N, IS(c) ? !1 : c), N.dispatchEvent(L);
      }
    }, [x, k, c, i]);
    const T = S.useRef(IS(c) ? !1 : c);
    return /* @__PURE__ */ V.jsx(
      Ro.input,
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: d ?? T.current,
        required: f,
        disabled: p,
        name: g,
        value: b,
        form: w,
        ...t,
        tabIndex: -1,
        ref: P,
        style: {
          ...t.style,
          ...M,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0,
          // We transform because the input is absolutely positioned but we have
          // rendered it **after** the button. This pulls it back to sit on top
          // of the button.
          transform: "translateX(-100%)"
        }
      }
    );
  }
);
pte.displayName = hte;
function ZMe(e) {
  return typeof e == "function";
}
function IS(e) {
  return e === "indeterminate";
}
function gte(e) {
  return IS(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
/**
 * @license lucide-react v0.503.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eOe = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), tOe = (e) => e.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (t, r, a) => a ? a.toUpperCase() : r.toLowerCase()
), EB = (e) => {
  const t = tOe(e);
  return t.charAt(0).toUpperCase() + t.slice(1);
}, vte = (...e) => e.filter((t, r, a) => !!t && t.trim() !== "" && a.indexOf(t) === r).join(" ").trim(), nOe = (e) => {
  for (const t in e)
    if (t.startsWith("aria-") || t === "role" || t === "title")
      return !0;
};
/**
 * @license lucide-react v0.503.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var rOe = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.503.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aOe = ks(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: r = 2,
    absoluteStrokeWidth: a,
    className: i = "",
    children: c,
    iconNode: d,
    ...f
  }, p) => SE(
    "svg",
    {
      ref: p,
      ...rOe,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: a ? Number(r) * 24 / Number(t) : r,
      className: vte("lucide", i),
      ...!c && !nOe(f) && { "aria-hidden": "true" },
      ...f
    },
    [
      ...d.map(([g, b]) => SE(g, b)),
      ...Array.isArray(c) ? c : [c]
    ]
  )
);
/**
 * @license lucide-react v0.503.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const y3 = (e, t) => {
  const r = ks(
    ({ className: a, ...i }, c) => SE(aOe, {
      ref: c,
      iconNode: t,
      className: vte(
        `lucide-${eOe(EB(e))}`,
        `lucide-${e}`,
        a
      ),
      ...i
    })
  );
  return r.displayName = EB(e), r;
};
/**
 * @license lucide-react v0.503.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oOe = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }]
], iOe = y3("calendar", oOe);
/**
 * @license lucide-react v0.503.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lOe = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], sOe = y3("check", lOe);
/**
 * @license lucide-react v0.503.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uOe = [["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]], cOe = y3("chevron-down", uOe);
/**
 * @license lucide-react v0.503.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dOe = [["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]], pI = y3("chevron-left", dOe);
/**
 * @license lucide-react v0.503.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fOe = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]], gI = y3("chevron-right", fOe);
/**
 * @license lucide-react v0.503.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mOe = [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
  ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }]
], hOe = y3("ellipsis", mOe);
/**
 * @license lucide-react v0.503.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pOe = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
], gOe = y3("x", pOe);
function bte({
  checkboxLabel: e,
  checkboxValue: t,
  dataTestId: r,
  disabled: a = !1,
  className: i,
  isError: c,
  onBlur: d,
  onChange: f,
  onlyChangeOnBlur: p,
  selected: g,
  style: b,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  value: w,
  ...x
}) {
  const [E, P] = Wn(), k = Cn(
    (T) => {
      d?.(T), p && f && E !== void 0 && (f(E), P(void 0));
    },
    [E, p, d, f]
  ), M = Cn(
    (T) => {
      const N = T === !0;
      p ? P(N) : f && f(N);
    },
    [p, f]
  );
  return /* @__PURE__ */ V.jsx("span", { "data-preflight": !0, className: "contents", children: /* @__PURE__ */ V.jsxs(
    "label",
    {
      className: lt(
        "group inline-flex cursor-pointer items-center",
        a && "cursor-not-allowed"
      ),
      style: b,
      children: [
        /* @__PURE__ */ V.jsx(
          dte,
          {
            "data-slot": "checkbox",
            value: t,
            className: lt(
              "enabled:text-white",
              "enabled:data-[state=checked]:border-0 enabled:data-[state=checked]:bg-[#1677ff] enabled:data-[state=checked]:group-hover:bg-[#4096ff] enabled:dark:data-[state=checked]:bg-[#1677ff]",
              "enabled:data-[state=unchecked]:group-hover:border-[#1677ff]",
              "dark:bg-input/30 flex cursor-pointer items-center justify-center border-[rgb(217,217,217)] bg-white transition-all",
              "focus-visible:ring-ring/50",
              "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
              "shadow-xs peer size-4 shrink-0 rounded-[4px] border outline-none",
              "ring-offset-[1px] focus-visible:ring-[3px] focus-visible:ring-[rgb(145,202,255)]",
              "disabled:cursor-not-allowed disabled:border-[#d9d9d9] disabled:bg-[rgba(0,0,0,0.04)] disabled:text-[rgba(0,0,0,0.25)]",
              i
            ),
            checked: g,
            onBlur: k,
            onCheckedChange: M,
            "data-testid": r,
            disabled: a,
            "aria-disabled": a,
            ...x,
            children: /* @__PURE__ */ V.jsx(
              mte,
              {
                "data-slot": "checkbox-indicator",
                className: "flex items-center justify-center text-current transition-none",
                children: /* @__PURE__ */ V.jsx(sOe, { className: "size-3.5" })
              }
            )
          },
          t
        ),
        e && /* @__PURE__ */ V.jsx(
          "span",
          {
            "data-error": c,
            className: "data-[error=true]:text-destructive px-[4px] font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:text-[rgba(0,0,0,0.25)]",
            children: e
          }
        )
      ]
    }
  ) });
}
const vOe = ({
  checkboxGroupClassname: e,
  checkboxItemClassname: t,
  checkboxPosition: r = "vertical",
  dataTestId: a,
  disabled: i = !1,
  isError: c = !1,
  onBlur: d,
  // apparently we're treating this as onBlur for each Checkbox, shouldn't this be onBlur for the group?
  onChange: f,
  onClick: p,
  onFocus: g,
  // apparently we're treating this as onFocus for each Checkbox, shouldn't this be onFocus for the group?
  onKeyDown: b,
  onKeyUp: w,
  onlyChangeOnBlur: x,
  options: E,
  selectedOptions: P,
  size: k,
  style: M,
  width: T
}) => {
  const [N, D] = Wn(), [$, j] = Wn(P);
  Er(() => {
    j(P), D(void 0);
  }, [P]);
  const I = It(), L = Cn(
    (W) => {
      !x || !N || (I.current = setTimeout(() => {
        f(N), D(void 0);
      }, 100));
    },
    [N, x, f]
  ), F = Cn(
    (W) => {
      clearTimeout(I.current), g?.(W);
    },
    [g]
  ), _ = Cn(
    (W) => {
      const Q = $.includes(W) ? $.filter(
        (U) => W !== U
      ) : [...$, W];
      j(Q), x ? D(Q) : f && f(Q);
    },
    [x, f, $]
  );
  return /* @__PURE__ */ V.jsx("span", { "data-preflight": !0, className: "contents", onBlur: L, children: /* @__PURE__ */ V.jsx(
    "div",
    {
      className: lt(
        "inline-flex justify-end",
        r === "horizontal" ? "flex-row gap-[8px]" : "flex-col gap-[3px]",
        i && "cursor-not-allowed",
        e
      ),
      "data-testid": a,
      style: { width: T, ...M },
      children: E.map(
        ({
          label: W,
          value: Q,
          disabled: U,
          dataTestId: Y
        }) => /* @__PURE__ */ V.jsx(
          bte,
          {
            kind: "checkbox",
            className: lt(t, "mr-[4px]"),
            selected: $.includes(Q.toString()),
            checkboxLabel: W,
            checkboxValue: Q.toString(),
            onChange: () => _(Q.toString()),
            disabled: U || i,
            "data-testid": Y,
            onClick: p,
            onFocus: F,
            onBlur: d,
            onKeyDown: b,
            onKeyUp: w,
            size: k,
            isError: c
          },
          Q.toString()
        )
      )
    }
  ) });
};
function T$({
  inputReference: e,
  inputSelection: t
}) {
  if (!e.current)
    return;
  const r = e.current;
  t.current = {
    selectionStart: r.selectionStart ?? void 0,
    selectionEnd: r.selectionEnd ?? void 0
  };
}
function bOe({
  format: e,
  inputReference: t
}) {
  const { selectionStart: r, selectionEnd: a } = t.current ?? {};
  if (typeof r != "number" || typeof a != "number")
    return;
  const i = e.slice(r, a).toLowerCase()[0];
  let c;
  switch (i) {
    case "d": {
      c = "day";
      break;
    }
    case "m": {
      c = "month";
      break;
    }
    case "y": {
      c = "year";
      break;
    }
  }
  return c;
}
const PB = /\d/;
function yte({
  format: e,
  inputReference: t,
  inputSelection: r,
  setSelectedDatePart: a
}) {
  const { selectionStart: i, value: c } = t.current ?? {
    value: ""
  };
  if (typeof i != "number")
    return;
  let d = i;
  for (; d && PB.test(c[d - 1]); )
    d--;
  let f = i;
  for (; f < c.length && PB.test(c[f]); )
    f++;
  d === null || f === null || d === f || t.current && (t.current.selectionStart = d, t.current.selectionEnd = f, T$({ inputReference: t, inputSelection: r }), a(
    bOe({
      format: e,
      inputReference: t
    })
  ));
}
function yOe({
  format: e,
  inputReference: t,
  inputSelection: r,
  onClick: a,
  setSelectedDatePart: i
}, c) {
  c.stopPropagation(), a?.(c), yte({
    format: e,
    inputReference: t,
    inputSelection: r,
    setSelectedDatePart: i
  });
}
function wOe({ onFocus: e, setOpen: t }, r) {
  e?.(r), t(!0);
}
function Ck(e = navigator.language, t = "long") {
  const r = [], a = /* @__PURE__ */ new Date();
  for (let i = 0; i < 12; i++) {
    const c = new Date(a.getFullYear(), i, 1);
    r.push(c.toLocaleString(e, { month: t }));
  }
  return r;
}
const kB = {
  zero: "e",
  one: "e",
  two: "e",
  few: "e",
  many: "e",
  other: "e"
}, MB = {
  zero: "o",
  one: "o",
  two: "o",
  few: "o",
  many: "o",
  other: "o"
}, EA = {
  en: {
    zero: "th",
    one: "st",
    two: "nd",
    few: "rd",
    many: "th",
    other: "th"
  },
  es: {
    zero: ".o",
    one: ".er",
    two: ".o",
    few: ".er",
    many: ".o",
    other: ".o"
  },
  fi: {
    zero: ":s",
    one: ":nen",
    two: ":nen",
    few: ":s",
    many: ":s",
    other: ":s"
  },
  fr: {
    ...kB,
    one: "er"
  },
  gl: MB,
  ir: {
    zero: "ú",
    one: "ú",
    two: "ú",
    few: "ú",
    many: "ú",
    other: "ú"
  },
  it: MB,
  ko: {
    zero: "번째",
    one: "번째",
    two: "번째",
    few: "번째",
    many: "번째",
    other: "번째"
  },
  nl: kB,
  pt: {
    zero: ".o",
    one: ".o",
    two: ".o",
    few: ".o",
    many: ".o",
    other: ".o"
  },
  sv: {
    zero: ":e",
    one: ":a",
    two: ":a",
    few: ":e",
    many: ":e",
    other: ":e"
  }
  // TODO: add other languages that support ordinal suffixes, e.g. Russian, Catalan
};
function SOe(e = navigator.language) {
  e || (e = "en-US");
  const t = Array.isArray(e) ? e[0] : e, r = typeof t == "string" ? t : t.baseName;
  return EA[r] ?? EA[r.split("-")[0]] ?? EA.en;
}
function PA(e = navigator.language, t = "long") {
  const r = [], a = /* @__PURE__ */ new Date();
  for (let i = 0; i < 7; i++) {
    const c = new Date(
      a.getFullYear(),
      a.getMonth(),
      a.getDate() - a.getDay() + i
    ), d = new Intl.DateTimeFormat(e, { weekday: t });
    r.push(d.format(c));
  }
  return r;
}
const COe = /([$()*+.?[\\\]^{|}])/g, OB = "01", TB = "02", RB = "03", AB = "04", NB = "05", DB = "06", $B = "07", zB = "08", jB = "09", IB = "10", LB = "11", HB = "12";
function R$(e, t = navigator.language) {
  const r = `(${Object.values(SOe(t)).join("|")})`, a = `(${Ck(t, "narrow").join("|")})`, i = `(${Ck(t, "short").join("|")})`, c = `(${Ck(t, "long").join("|")})`, d = `(${PA(t, "narrow").join("|")})`, f = PA(t, "short"), p = `(${f.join("|")})`, g = `(${f.map((E) => E.slice(0, 2)).join("|")})`, b = `(${PA(t, "long").join("|")})`;
  let w = e;
  return w = w.replaceAll(
    COe,
    "\\$1"
  ), w = w.replaceAll(/G+/g, OB), w = w.replaceAll("o", TB), w = w.replaceAll(
    /[Qq]{4}/g,
    RB
  ), w = w.replaceAll(
    /[Qq]{3}/g,
    AB
  ), w = w.replaceAll(
    /M{5}|L{5}/g,
    $B
  ), w = w.replaceAll(
    /M{4}|L{4}/g,
    NB
  ), w = w.replaceAll(
    /M{3}|L{3}/g,
    DB
  ), w = w.replaceAll(
    /[Ece]{6}/g,
    IB
  ), w = w.replaceAll(
    /[Ece]{5}/g,
    LB
  ), w = w.replaceAll(
    /[Ece]{4}/g,
    zB
  ), w = w.replaceAll(
    /[Ece]{3}/g,
    jB
  ), w = w.replaceAll(
    /[DLMQRYcdluwy]/g,
    HB
  ), new RegExp(
    `^${w.replaceAll(OB, "(AD|BC|A|B)").replaceAll(RB, `\\d${r} quarter`).replaceAll(AB, "Q\\d").replaceAll(TB, r).replaceAll($B, a).replaceAll(NB, c).replaceAll(DB, i).replaceAll(IB, g).replaceAll(LB, d).replaceAll(zB, b).replaceAll(jB, p).replaceAll(HB, "\\d")}$`
  );
}
function wte(e, t, r) {
  const a = Ts(e, r?.in);
  if (isNaN(t)) return _1(e, NaN);
  if (!t)
    return a;
  const i = a.getDate(), c = _1(e, a.getTime());
  c.setMonth(a.getMonth() + t + 1, 0);
  const d = c.getDate();
  return i >= d ? c : (a.setFullYear(
    c.getFullYear(),
    c.getMonth(),
    i
  ), a);
}
function xOe(e, t, r) {
  return pG(e, t * 7, r);
}
function EOe(e, t, r) {
  return wte(e, t * 12, r);
}
function POe(e, t) {
  let r, a = t?.in;
  return e.forEach((i) => {
    !a && typeof i == "object" && (a = _1.bind(null, i));
    const c = Ts(i, a);
    (!r || r < c || isNaN(+c)) && (r = c);
  }), _1(a, r || NaN);
}
function kOe(e, t) {
  let r, a = t?.in;
  return e.forEach((i) => {
    !a && typeof i == "object" && (a = _1.bind(null, i));
    const c = Ts(i, a);
    (!r || r > c || isNaN(+c)) && (r = c);
  }), _1(a, r || NaN);
}
function MOe(e, t, r) {
  const [a, i] = Lx(
    r?.in,
    e,
    t
  );
  return +EN(a) == +EN(i);
}
function Ste(e, t, r) {
  const [a, i] = Lx(
    r?.in,
    e,
    t
  ), c = a.getFullYear() - i.getFullYear(), d = a.getMonth() - i.getMonth();
  return c * 12 + d;
}
function OOe(e, t) {
  const r = Ts(e, t?.in), a = r.getMonth();
  return r.setFullYear(r.getFullYear(), a + 1, 0), r.setHours(23, 59, 59, 999), r;
}
function Cte(e, t) {
  const [r, a] = Lx(e, t.start, t.end);
  return { start: r, end: a };
}
function TOe(e, t) {
  const { start: r, end: a } = Cte(t?.in, e);
  let i = +r > +a;
  const c = i ? +r : +a, d = i ? a : r;
  d.setHours(0, 0, 0, 0), d.setDate(1);
  let f = 1;
  const p = [];
  for (; +d <= c; )
    p.push(_1(r, d)), d.setMonth(d.getMonth() + f);
  return i ? p.reverse() : p;
}
function ROe(e, t) {
  const r = Ts(e, t?.in);
  return r.setDate(1), r.setHours(0, 0, 0, 0), r;
}
function AOe(e, t) {
  const r = Ts(e, t?.in), a = r.getFullYear();
  return r.setFullYear(a + 1, 0, 0), r.setHours(23, 59, 59, 999), r;
}
function NOe(e, t) {
  const { start: r, end: a } = Cte(t?.in, e);
  let i = +r > +a;
  const c = i ? +r : +a, d = i ? a : r;
  d.setHours(0, 0, 0, 0), d.setMonth(0, 1);
  let f = 1;
  const p = [];
  for (; +d <= c; )
    p.push(_1(r, d)), d.setFullYear(d.getFullYear() + f);
  return i ? p.reverse() : p;
}
function xte(e, t) {
  const r = sle(), a = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? r.weekStartsOn ?? r.locale?.options?.weekStartsOn ?? 0, i = Ts(e, t?.in), c = i.getDay(), d = (c < a ? -7 : 0) + 6 - (c - a);
  return i.setDate(i.getDate() + d), i.setHours(23, 59, 59, 999), i;
}
function DOe(e, t) {
  return xte(e, { ...t, weekStartsOn: 1 });
}
function $Oe(e, t) {
  const r = Ts(e, t?.in), a = r.getFullYear(), i = r.getMonth(), c = _1(r, 0);
  return c.setFullYear(a, i + 1, 0), c.setHours(0, 0, 0, 0), c.getDate();
}
function zOe(e, t) {
  return Ts(e, t?.in).getMonth();
}
function jOe(e, t) {
  return Ts(e, t?.in).getFullYear();
}
function IOe(e, t) {
  return +Ts(e) > +Ts(t);
}
function LOe(e, t) {
  return +Ts(e) < +Ts(t);
}
function su(e, t, r) {
  const [a, i] = Lx(
    r?.in,
    e,
    t
  );
  return +PN(a, r) == +PN(i, r);
}
function HOe(e, t, r) {
  const [a, i] = Lx(
    r?.in,
    e,
    t
  );
  return a.getFullYear() === i.getFullYear() && a.getMonth() === i.getMonth();
}
function FOe(e, t, r) {
  const [a, i] = Lx(
    r?.in,
    e,
    t
  );
  return a.getFullYear() === i.getFullYear();
}
function WOe(e, t, r) {
  const a = Ts(e, r?.in), i = a.getFullYear(), c = a.getDate(), d = _1(e, 0);
  d.setFullYear(i, t, 15), d.setHours(0, 0, 0, 0);
  const f = $Oe(d);
  return a.setMonth(t, Math.min(c, f)), a;
}
function VOe(e, t, r) {
  const a = Ts(e, r?.in);
  return isNaN(+a) ? _1(e, NaN) : (a.setFullYear(t), a);
}
function KS({
  format: e,
  date: t,
  fallbackValue: r
}) {
  if (!t)
    return "";
  try {
    return q3(t, e);
  } catch {
    return r ?? "";
  }
}
const _Oe = {
  lessThanXSeconds: {
    one: "minder as 'n sekonde",
    other: "minder as {{count}} sekondes"
  },
  xSeconds: {
    one: "1 sekonde",
    other: "{{count}} sekondes"
  },
  halfAMinute: "'n halwe minuut",
  lessThanXMinutes: {
    one: "minder as 'n minuut",
    other: "minder as {{count}} minute"
  },
  xMinutes: {
    one: "'n minuut",
    other: "{{count}} minute"
  },
  aboutXHours: {
    one: "ongeveer 1 uur",
    other: "ongeveer {{count}} ure"
  },
  xHours: {
    one: "1 uur",
    other: "{{count}} ure"
  },
  xDays: {
    one: "1 dag",
    other: "{{count}} dae"
  },
  aboutXWeeks: {
    one: "ongeveer 1 week",
    other: "ongeveer {{count}} weke"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weke"
  },
  aboutXMonths: {
    one: "ongeveer 1 maand",
    other: "ongeveer {{count}} maande"
  },
  xMonths: {
    one: "1 maand",
    other: "{{count}} maande"
  },
  aboutXYears: {
    one: "ongeveer 1 jaar",
    other: "ongeveer {{count}} jaar"
  },
  xYears: {
    one: "1 jaar",
    other: "{{count}} jaar"
  },
  overXYears: {
    one: "meer as 1 jaar",
    other: "meer as {{count}} jaar"
  },
  almostXYears: {
    one: "byna 1 jaar",
    other: "byna {{count}} jaar"
  }
}, BOe = (e, t, r) => {
  let a;
  const i = _Oe[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? "oor " + a : a + " gelede" : a;
}, UOe = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "yyyy/MM/dd"
}, XOe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, GOe = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, qOe = {
  date: Ke({
    formats: UOe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: XOe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: GOe,
    defaultWidth: "full"
  })
}, KOe = {
  lastWeek: "'verlede' eeee 'om' p",
  yesterday: "'gister om' p",
  today: "'vandag om' p",
  tomorrow: "'môre om' p",
  nextWeek: "eeee 'om' p",
  other: "P"
}, YOe = (e, t, r, a) => KOe[e], QOe = {
  narrow: ["vC", "nC"],
  abbreviated: ["vC", "nC"],
  wide: ["voor Christus", "na Christus"]
}, JOe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1ste kwartaal", "2de kwartaal", "3de kwartaal", "4de kwartaal"]
}, ZOe = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mrt",
    "Apr",
    "Mei",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Des"
  ],
  wide: [
    "Januarie",
    "Februarie",
    "Maart",
    "April",
    "Mei",
    "Junie",
    "Julie",
    "Augustus",
    "September",
    "Oktober",
    "November",
    "Desember"
  ]
}, eTe = {
  narrow: ["S", "M", "D", "W", "D", "V", "S"],
  short: ["So", "Ma", "Di", "Wo", "Do", "Vr", "Sa"],
  abbreviated: ["Son", "Maa", "Din", "Woe", "Don", "Vry", "Sat"],
  wide: [
    "Sondag",
    "Maandag",
    "Dinsdag",
    "Woensdag",
    "Donderdag",
    "Vrydag",
    "Saterdag"
  ]
}, tTe = {
  narrow: {
    am: "vm",
    pm: "nm",
    midnight: "middernag",
    noon: "middaguur",
    morning: "oggend",
    afternoon: "middag",
    evening: "laat middag",
    night: "aand"
  },
  abbreviated: {
    am: "vm",
    pm: "nm",
    midnight: "middernag",
    noon: "middaguur",
    morning: "oggend",
    afternoon: "middag",
    evening: "laat middag",
    night: "aand"
  },
  wide: {
    am: "vm",
    pm: "nm",
    midnight: "middernag",
    noon: "middaguur",
    morning: "oggend",
    afternoon: "middag",
    evening: "laat middag",
    night: "aand"
  }
}, nTe = {
  narrow: {
    am: "vm",
    pm: "nm",
    midnight: "middernag",
    noon: "uur die middag",
    morning: "uur die oggend",
    afternoon: "uur die middag",
    evening: "uur die aand",
    night: "uur die aand"
  },
  abbreviated: {
    am: "vm",
    pm: "nm",
    midnight: "middernag",
    noon: "uur die middag",
    morning: "uur die oggend",
    afternoon: "uur die middag",
    evening: "uur die aand",
    night: "uur die aand"
  },
  wide: {
    am: "vm",
    pm: "nm",
    midnight: "middernag",
    noon: "uur die middag",
    morning: "uur die oggend",
    afternoon: "uur die middag",
    evening: "uur die aand",
    night: "uur die aand"
  }
}, rTe = (e) => {
  const t = Number(e), r = t % 100;
  if (r < 20)
    switch (r) {
      case 1:
      case 8:
        return t + "ste";
      default:
        return t + "de";
    }
  return t + "ste";
}, aTe = {
  ordinalNumber: rTe,
  era: Ce({
    values: QOe,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: JOe,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: ZOe,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: eTe,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: tTe,
    defaultWidth: "wide",
    formattingValues: nTe,
    defaultFormattingWidth: "wide"
  })
}, oTe = /^(\d+)(ste|de)?/i, iTe = /\d+/i, lTe = {
  narrow: /^([vn]\.? ?C\.?)/,
  abbreviated: /^([vn]\. ?C\.?)/,
  wide: /^((voor|na) Christus)/
}, sTe = {
  any: [/^v/, /^n/]
}, uTe = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234](st|d)e kwartaal/i
}, cTe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, dTe = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(Jan|Feb|Mrt|Apr|Mei|Jun|Jul|Aug|Sep|Okt|Nov|Dec)\.?/i,
  wide: /^(Januarie|Februarie|Maart|April|Mei|Junie|Julie|Augustus|September|Oktober|November|Desember)/i
}, fTe = {
  narrow: [
    /^J/i,
    /^F/i,
    /^M/i,
    /^A/i,
    /^M/i,
    /^J/i,
    /^J/i,
    /^A/i,
    /^S/i,
    /^O/i,
    /^N/i,
    /^D/i
  ],
  any: [
    /^Jan/i,
    /^Feb/i,
    /^Mrt/i,
    /^Apr/i,
    /^Mei/i,
    /^Jun/i,
    /^Jul/i,
    /^Aug/i,
    /^Sep/i,
    /^Okt/i,
    /^Nov/i,
    /^Dec/i
  ]
}, mTe = {
  narrow: /^[smdwv]/i,
  short: /^(So|Ma|Di|Wo|Do|Vr|Sa)/i,
  abbreviated: /^(Son|Maa|Din|Woe|Don|Vry|Sat)/i,
  wide: /^(Sondag|Maandag|Dinsdag|Woensdag|Donderdag|Vrydag|Saterdag)/i
}, hTe = {
  narrow: [/^S/i, /^M/i, /^D/i, /^W/i, /^D/i, /^V/i, /^S/i],
  any: [/^So/i, /^Ma/i, /^Di/i, /^Wo/i, /^Do/i, /^Vr/i, /^Sa/i]
}, pTe = {
  any: /^(vm|nm|middernag|(?:uur )?die (oggend|middag|aand))/i
}, gTe = {
  any: {
    am: /^vm/i,
    pm: /^nm/i,
    midnight: /^middernag/i,
    noon: /^middaguur/i,
    morning: /oggend/i,
    afternoon: /middag/i,
    evening: /laat middag/i,
    night: /aand/i
  }
}, vTe = {
  ordinalNumber: Fn({
    matchPattern: oTe,
    parsePattern: iTe,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: lTe,
    defaultMatchWidth: "wide",
    parsePatterns: sTe,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: uTe,
    defaultMatchWidth: "wide",
    parsePatterns: cTe,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: dTe,
    defaultMatchWidth: "wide",
    parsePatterns: fTe,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: mTe,
    defaultMatchWidth: "wide",
    parsePatterns: hTe,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: pTe,
    defaultMatchWidth: "any",
    parsePatterns: gTe,
    defaultParseWidth: "any"
  })
}, bTe = {
  code: "af",
  formatDistance: BOe,
  formatLong: qOe,
  formatRelative: YOe,
  localize: aTe,
  match: vTe,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, yTe = {
  lessThanXSeconds: {
    one: "أقل من ثانية",
    two: "أقل من ثانيتين",
    threeToTen: "أقل من {{count}} ثواني",
    other: "أقل من {{count}} ثانية"
  },
  xSeconds: {
    one: "ثانية واحدة",
    two: "ثانيتان",
    threeToTen: "{{count}} ثواني",
    other: "{{count}} ثانية"
  },
  halfAMinute: "نصف دقيقة",
  lessThanXMinutes: {
    one: "أقل من دقيقة",
    two: "أقل من دقيقتين",
    threeToTen: "أقل من {{count}} دقائق",
    other: "أقل من {{count}} دقيقة"
  },
  xMinutes: {
    one: "دقيقة واحدة",
    two: "دقيقتان",
    threeToTen: "{{count}} دقائق",
    other: "{{count}} دقيقة"
  },
  aboutXHours: {
    one: "ساعة واحدة تقريباً",
    two: "ساعتين تقريبا",
    threeToTen: "{{count}} ساعات تقريباً",
    other: "{{count}} ساعة تقريباً"
  },
  xHours: {
    one: "ساعة واحدة",
    two: "ساعتان",
    threeToTen: "{{count}} ساعات",
    other: "{{count}} ساعة"
  },
  xDays: {
    one: "يوم واحد",
    two: "يومان",
    threeToTen: "{{count}} أيام",
    other: "{{count}} يوم"
  },
  aboutXWeeks: {
    one: "أسبوع واحد تقريبا",
    two: "أسبوعين تقريبا",
    threeToTen: "{{count}} أسابيع تقريبا",
    other: "{{count}} أسبوعا تقريبا"
  },
  xWeeks: {
    one: "أسبوع واحد",
    two: "أسبوعان",
    threeToTen: "{{count}} أسابيع",
    other: "{{count}} أسبوعا"
  },
  aboutXMonths: {
    one: "شهر واحد تقريباً",
    two: "شهرين تقريبا",
    threeToTen: "{{count}} أشهر تقريبا",
    other: "{{count}} شهرا تقريباً"
  },
  xMonths: {
    one: "شهر واحد",
    two: "شهران",
    threeToTen: "{{count}} أشهر",
    other: "{{count}} شهرا"
  },
  aboutXYears: {
    one: "سنة واحدة تقريباً",
    two: "سنتين تقريبا",
    threeToTen: "{{count}} سنوات تقريباً",
    other: "{{count}} سنة تقريباً"
  },
  xYears: {
    one: "سنة واحد",
    two: "سنتان",
    threeToTen: "{{count}} سنوات",
    other: "{{count}} سنة"
  },
  overXYears: {
    one: "أكثر من سنة",
    two: "أكثر من سنتين",
    threeToTen: "أكثر من {{count}} سنوات",
    other: "أكثر من {{count}} سنة"
  },
  almostXYears: {
    one: "ما يقارب سنة واحدة",
    two: "ما يقارب سنتين",
    threeToTen: "ما يقارب {{count}} سنوات",
    other: "ما يقارب {{count}} سنة"
  }
}, wTe = (e, t, r) => {
  const a = yTe[e];
  let i;
  return typeof a == "string" ? i = a : t === 1 ? i = a.one : t === 2 ? i = a.two : t <= 10 ? i = a.threeToTen.replace("{{count}}", String(t)) : i = a.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? "خلال " + i : "منذ " + i : i;
}, STe = {
  full: "EEEE، do MMMM y",
  long: "do MMMM y",
  medium: "d MMM y",
  short: "dd/MM/yyyy"
}, CTe = {
  full: "HH:mm:ss",
  long: "HH:mm:ss",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, xTe = {
  full: "{{date}} 'عند الساعة' {{time}}",
  long: "{{date}} 'عند الساعة' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, ETe = {
  date: Ke({
    formats: STe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: CTe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: xTe,
    defaultWidth: "full"
  })
}, PTe = {
  lastWeek: "eeee 'الماضي عند الساعة' p",
  yesterday: "'الأمس عند الساعة' p",
  today: "'اليوم عند الساعة' p",
  tomorrow: "'غدا عند الساعة' p",
  nextWeek: "eeee 'القادم عند الساعة' p",
  other: "P"
}, kTe = (e) => PTe[e], MTe = {
  narrow: ["ق", "ب"],
  abbreviated: ["ق.م.", "ب.م."],
  wide: ["قبل الميلاد", "بعد الميلاد"]
}, OTe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["ر1", "ر2", "ر3", "ر4"],
  wide: ["الربع الأول", "الربع الثاني", "الربع الثالث", "الربع الرابع"]
}, TTe = {
  narrow: ["ي", "ف", "م", "أ", "م", "ي", "ي", "أ", "س", "أ", "ن", "د"],
  abbreviated: [
    "يناير",
    "فبراير",
    "مارس",
    "أبريل",
    "مايو",
    "يونيو",
    "يوليو",
    "أغسطس",
    "سبتمبر",
    "أكتوبر",
    "نوفمبر",
    "ديسمبر"
  ],
  wide: [
    "يناير",
    "فبراير",
    "مارس",
    "أبريل",
    "مايو",
    "يونيو",
    "يوليو",
    "أغسطس",
    "سبتمبر",
    "أكتوبر",
    "نوفمبر",
    "ديسمبر"
  ]
}, RTe = {
  narrow: ["ح", "ن", "ث", "ر", "خ", "ج", "س"],
  short: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
  abbreviated: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
  wide: [
    "الأحد",
    "الاثنين",
    "الثلاثاء",
    "الأربعاء",
    "الخميس",
    "الجمعة",
    "السبت"
  ]
}, ATe = {
  narrow: {
    am: "ص",
    pm: "م",
    morning: "الصباح",
    noon: "الظهر",
    afternoon: "بعد الظهر",
    evening: "المساء",
    night: "الليل",
    midnight: "منتصف الليل"
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    morning: "الصباح",
    noon: "الظهر",
    afternoon: "بعد الظهر",
    evening: "المساء",
    night: "الليل",
    midnight: "منتصف الليل"
  },
  wide: {
    am: "ص",
    pm: "م",
    morning: "الصباح",
    noon: "الظهر",
    afternoon: "بعد الظهر",
    evening: "المساء",
    night: "الليل",
    midnight: "منتصف الليل"
  }
}, NTe = {
  narrow: {
    am: "ص",
    pm: "م",
    morning: "في الصباح",
    noon: "الظهر",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل",
    midnight: "منتصف الليل"
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    morning: "في الصباح",
    noon: "الظهر",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل",
    midnight: "منتصف الليل"
  },
  wide: {
    am: "ص",
    pm: "م",
    morning: "في الصباح",
    noon: "الظهر",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل",
    midnight: "منتصف الليل"
  }
}, DTe = (e) => String(e), $Te = {
  ordinalNumber: DTe,
  era: Ce({
    values: MTe,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: OTe,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: TTe,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: RTe,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: ATe,
    defaultWidth: "wide",
    formattingValues: NTe,
    defaultFormattingWidth: "wide"
  })
}, zTe = /^(\d+)(th|st|nd|rd)?/i, jTe = /\d+/i, ITe = {
  narrow: /[قب]/,
  abbreviated: /[قب]\.م\./,
  wide: /(قبل|بعد) الميلاد/
}, LTe = {
  any: [/قبل/, /بعد/]
}, HTe = {
  narrow: /^[1234]/i,
  abbreviated: /ر[1234]/,
  wide: /الربع (الأول|الثاني|الثالث|الرابع)/
}, FTe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, WTe = {
  narrow: /^[أيفمسند]/,
  abbreviated: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
  wide: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
}, VTe = {
  narrow: [
    /^ي/i,
    /^ف/i,
    /^م/i,
    /^أ/i,
    /^م/i,
    /^ي/i,
    /^ي/i,
    /^أ/i,
    /^س/i,
    /^أ/i,
    /^ن/i,
    /^د/i
  ],
  any: [
    /^يناير/i,
    /^فبراير/i,
    /^مارس/i,
    /^أبريل/i,
    /^مايو/i,
    /^يونيو/i,
    /^يوليو/i,
    /^أغسطس/i,
    /^سبتمبر/i,
    /^أكتوبر/i,
    /^نوفمبر/i,
    /^ديسمبر/i
  ]
}, _Te = {
  narrow: /^[حنثرخجس]/i,
  short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
}, BTe = {
  narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
  wide: [
    /^الأحد/i,
    /^الاثنين/i,
    /^الثلاثاء/i,
    /^الأربعاء/i,
    /^الخميس/i,
    /^الجمعة/i,
    /^السبت/i
  ],
  any: [/^أح/i, /^اث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
}, UTe = {
  narrow: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/,
  any: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/
}, XTe = {
  any: {
    am: /^ص/,
    pm: /^م/,
    midnight: /منتصف الليل/,
    noon: /الظهر/,
    afternoon: /بعد الظهر/,
    morning: /في الصباح/,
    evening: /في المساء/,
    night: /في الليل/
  }
}, GTe = {
  ordinalNumber: Fn({
    matchPattern: zTe,
    parsePattern: jTe,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: ITe,
    defaultMatchWidth: "wide",
    parsePatterns: LTe,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: HTe,
    defaultMatchWidth: "wide",
    parsePatterns: FTe,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: WTe,
    defaultMatchWidth: "wide",
    parsePatterns: VTe,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: _Te,
    defaultMatchWidth: "wide",
    parsePatterns: BTe,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: UTe,
    defaultMatchWidth: "any",
    parsePatterns: XTe,
    defaultParseWidth: "any"
  })
}, qTe = {
  code: "ar",
  formatDistance: wTe,
  formatLong: ETe,
  formatRelative: kTe,
  localize: $Te,
  match: GTe,
  options: {
    weekStartsOn: 6,
    firstWeekContainsDate: 1
  }
}, KTe = {
  lessThanXSeconds: {
    one: "أقل من ثانية واحدة",
    two: "أقل من ثانتين",
    threeToTen: "أقل من {{count}} ثواني",
    other: "أقل من {{count}} ثانية"
  },
  xSeconds: {
    one: "ثانية واحدة",
    two: "ثانتين",
    threeToTen: "{{count}} ثواني",
    other: "{{count}} ثانية"
  },
  halfAMinute: "نصف دقيقة",
  lessThanXMinutes: {
    one: "أقل من دقيقة",
    two: "أقل من دقيقتين",
    threeToTen: "أقل من {{count}} دقائق",
    other: "أقل من {{count}} دقيقة"
  },
  xMinutes: {
    one: "دقيقة واحدة",
    two: "دقيقتين",
    threeToTen: "{{count}} دقائق",
    other: "{{count}} دقيقة"
  },
  aboutXHours: {
    one: "ساعة واحدة تقريباً",
    two: "ساعتين تقريباً",
    threeToTen: "{{count}} ساعات تقريباً",
    other: "{{count}} ساعة تقريباً"
  },
  xHours: {
    one: "ساعة واحدة",
    two: "ساعتين",
    threeToTen: "{{count}} ساعات",
    other: "{{count}} ساعة"
  },
  xDays: {
    one: "يوم واحد",
    two: "يومين",
    threeToTen: "{{count}} أيام",
    other: "{{count}} يوم"
  },
  aboutXWeeks: {
    one: "أسبوع واحد تقريباً",
    two: "أسبوعين تقريباً",
    threeToTen: "{{count}} أسابيع تقريباً",
    other: "{{count}} أسبوع تقريباً"
  },
  xWeeks: {
    one: "أسبوع واحد",
    two: "أسبوعين",
    threeToTen: "{{count}} أسابيع",
    other: "{{count}} أسبوع"
  },
  aboutXMonths: {
    one: "شهر واحد تقريباً",
    two: "شهرين تقريباً",
    threeToTen: "{{count}} أشهر تقريباً",
    other: "{{count}} شهر تقريباً"
  },
  xMonths: {
    one: "شهر واحد",
    two: "شهرين",
    threeToTen: "{{count}} أشهر",
    other: "{{count}} شهر"
  },
  aboutXYears: {
    one: "عام واحد تقريباً",
    two: "عامين تقريباً",
    threeToTen: "{{count}} أعوام تقريباً",
    other: "{{count}} عام تقريباً"
  },
  xYears: {
    one: "عام واحد",
    two: "عامين",
    threeToTen: "{{count}} أعوام",
    other: "{{count}} عام"
  },
  overXYears: {
    one: "أكثر من عام",
    two: "أكثر من عامين",
    threeToTen: "أكثر من {{count}} أعوام",
    other: "أكثر من {{count}} عام"
  },
  almostXYears: {
    one: "عام واحد تقريباً",
    two: "عامين تقريباً",
    threeToTen: "{{count}} أعوام تقريباً",
    other: "{{count}} عام تقريباً"
  }
}, YTe = (e, t, r) => {
  r = r || {};
  const a = KTe[e];
  let i;
  return typeof a == "string" ? i = a : t === 1 ? i = a.one : t === 2 ? i = a.two : t <= 10 ? i = a.threeToTen.replace("{{count}}", String(t)) : i = a.other.replace("{{count}}", String(t)), r.addSuffix ? r.comparison && r.comparison > 0 ? "في خلال " + i : "منذ " + i : i;
}, QTe = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, JTe = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, ZTe = {
  full: "{{date}} 'عند' {{time}}",
  long: "{{date}} 'عند' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, eRe = {
  date: Ke({
    formats: QTe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: JTe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: ZTe,
    defaultWidth: "full"
  })
}, tRe = {
  lastWeek: "'أخر' eeee 'عند' p",
  yesterday: "'أمس عند' p",
  today: "'اليوم عند' p",
  tomorrow: "'غداً عند' p",
  nextWeek: "eeee 'عند' p",
  other: "P"
}, nRe = (e, t, r, a) => tRe[e], rRe = {
  narrow: ["ق", "ب"],
  abbreviated: ["ق.م.", "ب.م."],
  wide: ["قبل الميلاد", "بعد الميلاد"]
}, aRe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["ر1", "ر2", "ر3", "ر4"],
  wide: ["الربع الأول", "الربع الثاني", "الربع الثالث", "الربع الرابع"]
}, oRe = {
  narrow: ["ج", "ف", "م", "أ", "م", "ج", "ج", "أ", "س", "أ", "ن", "د"],
  abbreviated: [
    "جانـ",
    "فيفـ",
    "مارس",
    "أفريل",
    "مايـ",
    "جوانـ",
    "جويـ",
    "أوت",
    "سبتـ",
    "أكتـ",
    "نوفـ",
    "ديسـ"
  ],
  wide: [
    "جانفي",
    "فيفري",
    "مارس",
    "أفريل",
    "ماي",
    "جوان",
    "جويلية",
    "أوت",
    "سبتمبر",
    "أكتوبر",
    "نوفمبر",
    "ديسمبر"
  ]
}, iRe = {
  narrow: ["ح", "ن", "ث", "ر", "خ", "ج", "س"],
  short: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
  abbreviated: ["أحد", "اثنـ", "ثلا", "أربـ", "خميـ", "جمعة", "سبت"],
  wide: [
    "الأحد",
    "الاثنين",
    "الثلاثاء",
    "الأربعاء",
    "الخميس",
    "الجمعة",
    "السبت"
  ]
}, lRe = {
  narrow: {
    am: "ص",
    pm: "م",
    midnight: "ن",
    noon: "ظ",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً"
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً"
  },
  wide: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً"
  }
}, sRe = {
  narrow: {
    am: "ص",
    pm: "م",
    midnight: "ن",
    noon: "ظ",
    morning: "في الصباح",
    afternoon: "بعد الظـهر",
    evening: "في المساء",
    night: "في الليل"
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "في الصباح",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل"
  },
  wide: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظـهر",
    evening: "في المساء",
    night: "في الليل"
  }
}, uRe = (e) => String(e), cRe = {
  ordinalNumber: uRe,
  era: Ce({
    values: rRe,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: aRe,
    defaultWidth: "wide",
    argumentCallback: (e) => Number(e) - 1
  }),
  month: Ce({
    values: oRe,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: iRe,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: lRe,
    defaultWidth: "wide",
    formattingValues: sRe,
    defaultFormattingWidth: "wide"
  })
}, dRe = /^(\d+)(th|st|nd|rd)?/i, fRe = /\d+/i, mRe = {
  narrow: /^(ق|ب)/i,
  abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
  wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
}, hRe = {
  any: [/^قبل/i, /^بعد/i]
}, pRe = {
  narrow: /^[1234]/i,
  abbreviated: /^ر[1234]/i,
  wide: /^الربع [1234]/i
}, gRe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, vRe = {
  narrow: /^[جفمأسند]/i,
  abbreviated: /^(جان|فيف|مار|أفر|ماي|جوا|جوي|أوت|سبت|أكت|نوف|ديس)/i,
  wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/i
}, bRe = {
  narrow: [
    /^ج/i,
    /^ف/i,
    /^م/i,
    /^أ/i,
    /^م/i,
    /^ج/i,
    /^ج/i,
    /^أ/i,
    /^س/i,
    /^أ/i,
    /^ن/i,
    /^د/i
  ],
  any: [
    /^جان/i,
    /^فيف/i,
    /^مار/i,
    /^أفر/i,
    /^ماي/i,
    /^جوا/i,
    /^جوي/i,
    /^أوت/i,
    /^سبت/i,
    /^أكت/i,
    /^نوف/i,
    /^ديس/i
  ]
}, yRe = {
  narrow: /^[حنثرخجس]/i,
  short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
  wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
}, wRe = {
  narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
  wide: [
    /^الأحد/i,
    /^الاثنين/i,
    /^الثلاثاء/i,
    /^الأربعاء/i,
    /^الخميس/i,
    /^الجمعة/i,
    /^السبت/i
  ],
  any: [/^أح/i, /^اث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
}, SRe = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, CRe = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, xRe = {
  ordinalNumber: Fn({
    matchPattern: dRe,
    parsePattern: fRe,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: mRe,
    defaultMatchWidth: "wide",
    parsePatterns: hRe,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: pRe,
    defaultMatchWidth: "wide",
    parsePatterns: gRe,
    defaultParseWidth: "any",
    valueCallback: (e) => Number(e) + 1
  }),
  month: Ee({
    matchPatterns: vRe,
    defaultMatchWidth: "wide",
    parsePatterns: bRe,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: yRe,
    defaultMatchWidth: "wide",
    parsePatterns: wRe,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: SRe,
    defaultMatchWidth: "any",
    parsePatterns: CRe,
    defaultParseWidth: "any"
  })
}, ERe = {
  code: "ar-DZ",
  formatDistance: YTe,
  formatLong: eRe,
  formatRelative: nRe,
  localize: cRe,
  match: xRe,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, PRe = {
  lessThanXSeconds: {
    one: "أقل من ثانية",
    two: "أقل من ثانيتين",
    threeToTen: "أقل من {{count}} ثواني",
    other: "أقل من {{count}} ثانية"
  },
  xSeconds: {
    one: "ثانية",
    two: "ثانيتين",
    threeToTen: "{{count}} ثواني",
    other: "{{count}} ثانية"
  },
  halfAMinute: "نص دقيقة",
  lessThanXMinutes: {
    one: "أقل من دقيقة",
    two: "أقل من دقيقتين",
    threeToTen: "أقل من {{count}} دقايق",
    other: "أقل من {{count}} دقيقة"
  },
  xMinutes: {
    one: "دقيقة",
    two: "دقيقتين",
    threeToTen: "{{count}} دقايق",
    other: "{{count}} دقيقة"
  },
  aboutXHours: {
    one: "حوالي ساعة",
    two: "حوالي ساعتين",
    threeToTen: "حوالي {{count}} ساعات",
    other: "حوالي {{count}} ساعة"
  },
  xHours: {
    one: "ساعة",
    two: "ساعتين",
    threeToTen: "{{count}} ساعات",
    other: "{{count}} ساعة"
  },
  xDays: {
    one: "يوم",
    two: "يومين",
    threeToTen: "{{count}} أيام",
    other: "{{count}} يوم"
  },
  aboutXWeeks: {
    one: "حوالي أسبوع",
    two: "حوالي أسبوعين",
    threeToTen: "حوالي {{count}} أسابيع",
    other: "حوالي {{count}} أسبوع"
  },
  xWeeks: {
    one: "أسبوع",
    two: "أسبوعين",
    threeToTen: "{{count}} أسابيع",
    other: "{{count}} أسبوع"
  },
  aboutXMonths: {
    one: "حوالي شهر",
    two: "حوالي شهرين",
    threeToTen: "حوالي {{count}} أشهر",
    other: "حوالي {{count}} شهر"
  },
  xMonths: {
    one: "شهر",
    two: "شهرين",
    threeToTen: "{{count}} أشهر",
    other: "{{count}} شهر"
  },
  aboutXYears: {
    one: "حوالي سنة",
    two: "حوالي سنتين",
    threeToTen: "حوالي {{count}} سنين",
    other: "حوالي {{count}} سنة"
  },
  xYears: {
    one: "عام",
    two: "عامين",
    threeToTen: "{{count}} أعوام",
    other: "{{count}} عام"
  },
  overXYears: {
    one: "أكثر من سنة",
    two: "أكثر من سنتين",
    threeToTen: "أكثر من {{count}} سنين",
    other: "أكثر من {{count}} سنة"
  },
  almostXYears: {
    one: "عام تقريبًا",
    two: "عامين تقريبًا",
    threeToTen: "{{count}} أعوام تقريبًا",
    other: "{{count}} عام تقريبًا"
  }
}, kRe = (e, t, r) => {
  let a;
  const i = PRe[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : t === 2 ? a = i.two : t <= 10 ? a = i.threeToTen.replace("{{count}}", String(t)) : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? `في خلال ${a}` : `منذ ${a}` : a;
}, MRe = {
  full: "EEEE، do MMMM y",
  long: "do MMMM y",
  medium: "dd/MMM/y",
  short: "d/MM/y"
}, ORe = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, TRe = {
  full: "{{date}} 'الساعة' {{time}}",
  long: "{{date}} 'الساعة' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, RRe = {
  date: Ke({
    formats: MRe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: ORe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: TRe,
    defaultWidth: "full"
  })
}, ARe = {
  lastWeek: "eeee 'اللي جاي الساعة' p",
  yesterday: "'إمبارح الساعة' p",
  today: "'النهاردة الساعة' p",
  tomorrow: "'بكرة الساعة' p",
  nextWeek: "eeee 'الساعة' p",
  other: "P"
}, NRe = (e, t, r, a) => ARe[e], DRe = {
  narrow: ["ق", "ب"],
  abbreviated: ["ق.م", "ب.م"],
  wide: ["قبل الميلاد", "بعد الميلاد"]
}, $Re = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["ر1", "ر2", "ر3", "ر4"],
  wide: ["الربع الأول", "الربع الثاني", "الربع الثالث", "الربع الرابع"]
}, zRe = {
  narrow: ["ي", "ف", "م", "أ", "م", "ي", "ي", "أ", "س", "أ", "ن", "د"],
  abbreviated: [
    "ينا",
    "فبر",
    "مارس",
    "أبريل",
    "مايو",
    "يونـ",
    "يولـ",
    "أغسـ",
    "سبتـ",
    "أكتـ",
    "نوفـ",
    "ديسـ"
  ],
  wide: [
    "يناير",
    "فبراير",
    "مارس",
    "أبريل",
    "مايو",
    "يونيو",
    "يوليو",
    "أغسطس",
    "سبتمبر",
    "أكتوبر",
    "نوفمبر",
    "ديسمبر"
  ]
}, jRe = {
  narrow: ["ح", "ن", "ث", "ر", "خ", "ج", "س"],
  short: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
  abbreviated: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
  wide: [
    "الأحد",
    "الاثنين",
    "الثلاثاء",
    "الأربعاء",
    "الخميس",
    "الجمعة",
    "السبت"
  ]
}, IRe = {
  narrow: {
    am: "ص",
    pm: "م",
    midnight: "ن",
    noon: "ظ",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءً",
    night: "ليلاً"
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهراً",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءً",
    night: "ليلاً"
  },
  wide: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهراً",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءً",
    night: "ليلاً"
  }
}, LRe = {
  narrow: {
    am: "ص",
    pm: "م",
    midnight: "ن",
    noon: "ظ",
    morning: "في الصباح",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل"
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهراً",
    morning: "في الصباح",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل"
  },
  wide: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    morning: "في الصباح",
    noon: "ظهراً",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل"
  }
}, HRe = (e, t) => String(e), FRe = {
  ordinalNumber: HRe,
  era: Ce({
    values: DRe,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: $Re,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: zRe,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: jRe,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: IRe,
    defaultWidth: "wide",
    formattingValues: LRe,
    defaultFormattingWidth: "wide"
  })
}, WRe = /^(\d+)/, VRe = /\d+/i, _Re = {
  narrow: /^(ق|ب)/g,
  abbreviated: /^(ق.م|ب.م)/g,
  wide: /^(قبل الميلاد|بعد الميلاد)/g
}, BRe = {
  any: [/^ق/g, /^ب/g]
}, URe = {
  narrow: /^[1234]/,
  abbreviated: /^ر[1234]/,
  wide: /^الربع (الأول|الثاني|الثالث|الرابع)/
}, XRe = {
  wide: [/الربع الأول/, /الربع الثاني/, /الربع الثالث/, /الربع الرابع/],
  any: [/1/, /2/, /3/, /4/]
}, GRe = {
  narrow: /^(ي|ف|م|أ|س|ن|د)/,
  abbreviated: /^(ينا|فبر|مارس|أبريل|مايو|يونـ|يولـ|أغسـ|سبتـ|أكتـ|نوفـ|ديسـ)/,
  wide: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
}, qRe = {
  narrow: [
    /^ي/,
    /^ف/,
    /^م/,
    /^أ/,
    /^م/,
    /^ي/,
    /^ي/,
    /^أ/,
    /^س/,
    /^أ/,
    /^ن/,
    /^د/
  ],
  any: [
    /^ينا/,
    /^فبر/,
    /^مارس/,
    /^أبريل/,
    /^مايو/,
    /^يون/,
    /^يول/,
    /^أغس/,
    /^سبت/,
    /^أكت/,
    /^نوف/,
    /^ديس/
  ]
}, KRe = {
  narrow: /^(ح|ن|ث|ر|خ|ج|س)/,
  short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/,
  abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/,
  wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/
}, YRe = {
  narrow: [/^ح/, /^ن/, /^ث/, /^ر/, /^خ/, /^ج/, /^س/],
  any: [/أحد/, /اثنين/, /ثلاثاء/, /أربعاء/, /خميس/, /جمعة/, /سبت/]
}, QRe = {
  narrow: /^(ص|م|ن|ظ|في الصباح|بعد الظهر|في المساء|في الليل)/,
  abbreviated: /^(ص|م|نصف الليل|ظهراً|في الصباح|بعد الظهر|في المساء|في الليل)/,
  wide: /^(ص|م|نصف الليل|في الصباح|ظهراً|بعد الظهر|في المساء|في الليل)/,
  any: /^(ص|م|صباح|ظهر|مساء|ليل)/
}, JRe = {
  any: {
    am: /^ص/,
    pm: /^م/,
    midnight: /^ن/,
    noon: /^ظ/,
    morning: /^ص/,
    afternoon: /^بعد/,
    evening: /^م/,
    night: /^ل/
  }
}, ZRe = {
  ordinalNumber: Fn({
    matchPattern: WRe,
    parsePattern: VRe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: Ee({
    matchPatterns: _Re,
    defaultMatchWidth: "wide",
    parsePatterns: BRe,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: URe,
    defaultMatchWidth: "wide",
    parsePatterns: XRe,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: GRe,
    defaultMatchWidth: "wide",
    parsePatterns: qRe,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: KRe,
    defaultMatchWidth: "wide",
    parsePatterns: YRe,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: QRe,
    defaultMatchWidth: "any",
    parsePatterns: JRe,
    defaultParseWidth: "any"
  })
}, eAe = {
  code: "ar-EG",
  formatDistance: kRe,
  formatLong: RRe,
  formatRelative: NRe,
  localize: FRe,
  match: ZRe,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, tAe = {
  lessThanXSeconds: {
    one: "أقل من ثانية واحدة",
    two: "أقل من ثانتين",
    threeToTen: "أقل من {{count}} ثواني",
    other: "أقل من {{count}} ثانية"
  },
  xSeconds: {
    one: "ثانية واحدة",
    two: "ثانتين",
    threeToTen: "{{count}} ثواني",
    other: "{{count}} ثانية"
  },
  halfAMinute: "نصف دقيقة",
  lessThanXMinutes: {
    one: "أقل من دقيقة",
    two: "أقل من دقيقتين",
    threeToTen: "أقل من {{count}} دقائق",
    other: "أقل من {{count}} دقيقة"
  },
  xMinutes: {
    one: "دقيقة واحدة",
    two: "دقيقتين",
    threeToTen: "{{count}} دقائق",
    other: "{{count}} دقيقة"
  },
  aboutXHours: {
    one: "ساعة واحدة تقريباً",
    two: "ساعتين تقريباً",
    threeToTen: "{{count}} ساعات تقريباً",
    other: "{{count}} ساعة تقريباً"
  },
  xHours: {
    one: "ساعة واحدة",
    two: "ساعتين",
    threeToTen: "{{count}} ساعات",
    other: "{{count}} ساعة"
  },
  xDays: {
    one: "يوم واحد",
    two: "يومين",
    threeToTen: "{{count}} أيام",
    other: "{{count}} يوم"
  },
  aboutXWeeks: {
    one: "أسبوع واحد تقريباً",
    two: "أسبوعين تقريباً",
    threeToTen: "{{count}} أسابيع تقريباً",
    other: "{{count}} أسبوع تقريباً"
  },
  xWeeks: {
    one: "أسبوع واحد",
    two: "أسبوعين",
    threeToTen: "{{count}} أسابيع",
    other: "{{count}} أسبوع"
  },
  aboutXMonths: {
    one: "شهر واحد تقريباً",
    two: "شهرين تقريباً",
    threeToTen: "{{count}} أشهر تقريباً",
    other: "{{count}} شهر تقريباً"
  },
  xMonths: {
    one: "شهر واحد",
    two: "شهرين",
    threeToTen: "{{count}} أشهر",
    other: "{{count}} شهر"
  },
  aboutXYears: {
    one: "عام واحد تقريباً",
    two: "عامين تقريباً",
    threeToTen: "{{count}} أعوام تقريباً",
    other: "{{count}} عام تقريباً"
  },
  xYears: {
    one: "عام واحد",
    two: "عامين",
    threeToTen: "{{count}} أعوام",
    other: "{{count}} عام"
  },
  overXYears: {
    one: "أكثر من عام",
    two: "أكثر من عامين",
    threeToTen: "أكثر من {{count}} أعوام",
    other: "أكثر من {{count}} عام"
  },
  almostXYears: {
    one: "عام واحد تقريباً",
    two: "عامين تقريباً",
    threeToTen: "{{count}} أعوام تقريباً",
    other: "{{count}} عام تقريباً"
  }
}, nAe = (e, t, r) => {
  r = r || {};
  const a = tAe[e];
  let i;
  return typeof a == "string" ? i = a : t === 1 ? i = a.one : t === 2 ? i = a.two : t <= 10 ? i = a.threeToTen.replace("{{count}}", String(t)) : i = a.other.replace("{{count}}", String(t)), r.addSuffix ? r.comparison && r.comparison > 0 ? "في خلال " + i : "منذ " + i : i;
}, rAe = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, aAe = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, oAe = {
  full: "{{date}} 'عند' {{time}}",
  long: "{{date}} 'عند' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, iAe = {
  date: Ke({
    formats: rAe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: aAe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: oAe,
    defaultWidth: "full"
  })
}, lAe = {
  lastWeek: "'أخر' eeee 'عند' p",
  yesterday: "'أمس عند' p",
  today: "'اليوم عند' p",
  tomorrow: "'غداً عند' p",
  nextWeek: "eeee 'عند' p",
  other: "P"
}, sAe = (e, t, r, a) => lAe[e], uAe = {
  narrow: ["ق", "ب"],
  abbreviated: ["ق.م.", "ب.م."],
  wide: ["قبل الميلاد", "بعد الميلاد"]
}, cAe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["ر1", "ر2", "ر3", "ر4"],
  wide: ["الربع الأول", "الربع الثاني", "الربع الثالث", "الربع الرابع"]
}, dAe = {
  narrow: ["ي", "ف", "م", "أ", "م", "ي", "ي", "غ", "ش", "أ", "ن", "د"],
  abbreviated: [
    "ينا",
    "فبر",
    "مارس",
    "أبريل",
    "ماي",
    "يونـ",
    "يولـ",
    "غشت",
    "شتنـ",
    "أكتـ",
    "نونـ",
    "دجنـ"
  ],
  wide: [
    "يناير",
    "فبراير",
    "مارس",
    "أبريل",
    "ماي",
    "يونيو",
    "يوليوز",
    "غشت",
    "شتنبر",
    "أكتوبر",
    "نونبر",
    "دجنبر"
  ]
}, fAe = {
  narrow: ["ح", "ن", "ث", "ر", "خ", "ج", "س"],
  short: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
  abbreviated: ["أحد", "اثنـ", "ثلا", "أربـ", "خميـ", "جمعة", "سبت"],
  wide: [
    "الأحد",
    "الإثنين",
    "الثلاثاء",
    "الأربعاء",
    "الخميس",
    "الجمعة",
    "السبت"
  ]
}, mAe = {
  narrow: {
    am: "ص",
    pm: "م",
    midnight: "ن",
    noon: "ظ",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً"
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً"
  },
  wide: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً"
  }
}, hAe = {
  narrow: {
    am: "ص",
    pm: "م",
    midnight: "ن",
    noon: "ظ",
    morning: "في الصباح",
    afternoon: "بعد الظـهر",
    evening: "في المساء",
    night: "في الليل"
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "في الصباح",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل"
  },
  wide: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظـهر",
    evening: "في المساء",
    night: "في الليل"
  }
}, pAe = (e) => String(e), gAe = {
  ordinalNumber: pAe,
  era: Ce({
    values: uAe,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: cAe,
    defaultWidth: "wide",
    argumentCallback: (e) => Number(e) - 1
  }),
  month: Ce({
    values: dAe,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: fAe,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: mAe,
    defaultWidth: "wide",
    formattingValues: hAe,
    defaultFormattingWidth: "wide"
  })
}, vAe = /^(\d+)(th|st|nd|rd)?/i, bAe = /\d+/i, yAe = {
  narrow: /^(ق|ب)/i,
  abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
  wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
}, wAe = {
  any: [/^قبل/i, /^بعد/i]
}, SAe = {
  narrow: /^[1234]/i,
  abbreviated: /^ر[1234]/i,
  wide: /^الربع [1234]/i
}, CAe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, xAe = {
  narrow: /^[يفمأمسند]/i,
  abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i,
  wide: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i
}, EAe = {
  narrow: [
    /^ي/i,
    /^ف/i,
    /^م/i,
    /^أ/i,
    /^م/i,
    /^ي/i,
    /^ي/i,
    /^غ/i,
    /^ش/i,
    /^أ/i,
    /^ن/i,
    /^د/i
  ],
  any: [
    /^ين/i,
    /^فب/i,
    /^مار/i,
    /^أب/i,
    /^ماي/i,
    /^يون/i,
    /^يول/i,
    /^غشت/i,
    /^ش/i,
    /^أك/i,
    /^ن/i,
    /^د/i
  ]
}, PAe = {
  narrow: /^[حنثرخجس]/i,
  short: /^(أحد|إثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  abbreviated: /^(أحد|إثن|ثلا|أرب|خمي|جمعة|سبت)/i,
  wide: /^(الأحد|الإثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
}, kAe = {
  narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
  wide: [
    /^الأحد/i,
    /^الإثنين/i,
    /^الثلاثاء/i,
    /^الأربعاء/i,
    /^الخميس/i,
    /^الجمعة/i,
    /^السبت/i
  ],
  any: [/^أح/i, /^إث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
}, MAe = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, OAe = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, TAe = {
  ordinalNumber: Fn({
    matchPattern: vAe,
    parsePattern: bAe,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: yAe,
    defaultMatchWidth: "wide",
    parsePatterns: wAe,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: SAe,
    defaultMatchWidth: "wide",
    parsePatterns: CAe,
    defaultParseWidth: "any",
    valueCallback: (e) => Number(e) + 1
  }),
  month: Ee({
    matchPatterns: xAe,
    defaultMatchWidth: "wide",
    parsePatterns: EAe,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: PAe,
    defaultMatchWidth: "wide",
    parsePatterns: kAe,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: MAe,
    defaultMatchWidth: "any",
    parsePatterns: OAe,
    defaultParseWidth: "any"
  })
}, RAe = {
  code: "ar-MA",
  formatDistance: nAe,
  formatLong: iAe,
  formatRelative: sAe,
  localize: gAe,
  match: TAe,
  options: {
    // Monday is 1
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, AAe = {
  lessThanXSeconds: {
    one: "أقل من ثانية واحدة",
    two: "أقل من ثانتين",
    threeToTen: "أقل من {{count}} ثواني",
    other: "أقل من {{count}} ثانية"
  },
  xSeconds: {
    one: "ثانية واحدة",
    two: "ثانتين",
    threeToTen: "{{count}} ثواني",
    other: "{{count}} ثانية"
  },
  halfAMinute: "نصف دقيقة",
  lessThanXMinutes: {
    one: "أقل من دقيقة",
    two: "أقل من دقيقتين",
    threeToTen: "أقل من {{count}} دقائق",
    other: "أقل من {{count}} دقيقة"
  },
  xMinutes: {
    one: "دقيقة واحدة",
    two: "دقيقتين",
    threeToTen: "{{count}} دقائق",
    other: "{{count}} دقيقة"
  },
  aboutXHours: {
    one: "ساعة واحدة تقريباً",
    two: "ساعتين تقريباً",
    threeToTen: "{{count}} ساعات تقريباً",
    other: "{{count}} ساعة تقريباً"
  },
  xHours: {
    one: "ساعة واحدة",
    two: "ساعتين",
    threeToTen: "{{count}} ساعات",
    other: "{{count}} ساعة"
  },
  xDays: {
    one: "يوم واحد",
    two: "يومين",
    threeToTen: "{{count}} أيام",
    other: "{{count}} يوم"
  },
  aboutXWeeks: {
    one: "أسبوع واحد تقريباً",
    two: "أسبوعين تقريباً",
    threeToTen: "{{count}} أسابيع تقريباً",
    other: "{{count}} أسبوع تقريباً"
  },
  xWeeks: {
    one: "أسبوع واحد",
    two: "أسبوعين",
    threeToTen: "{{count}} أسابيع",
    other: "{{count}} أسبوع"
  },
  aboutXMonths: {
    one: "شهر واحد تقريباً",
    two: "شهرين تقريباً",
    threeToTen: "{{count}} أشهر تقريباً",
    other: "{{count}} شهر تقريباً"
  },
  xMonths: {
    one: "شهر واحد",
    two: "شهرين",
    threeToTen: "{{count}} أشهر",
    other: "{{count}} شهر"
  },
  aboutXYears: {
    one: "عام واحد تقريباً",
    two: "عامين تقريباً",
    threeToTen: "{{count}} أعوام تقريباً",
    other: "{{count}} عام تقريباً"
  },
  xYears: {
    one: "عام واحد",
    two: "عامين",
    threeToTen: "{{count}} أعوام",
    other: "{{count}} عام"
  },
  overXYears: {
    one: "أكثر من عام",
    two: "أكثر من عامين",
    threeToTen: "أكثر من {{count}} أعوام",
    other: "أكثر من {{count}} عام"
  },
  almostXYears: {
    one: "عام واحد تقريباً",
    two: "عامين تقريباً",
    threeToTen: "{{count}} أعوام تقريباً",
    other: "{{count}} عام تقريباً"
  }
}, NAe = (e, t, r) => {
  let a;
  const i = AAe[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : t === 2 ? a = i.two : t <= 10 ? a = i.threeToTen.replace("{{count}}", String(t)) : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? "في خلال " + a : "منذ " + a : a;
}, DAe = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, $Ae = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, zAe = {
  full: "{{date}} 'عند' {{time}}",
  long: "{{date}} 'عند' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, jAe = {
  date: Ke({
    formats: DAe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: $Ae,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: zAe,
    defaultWidth: "full"
  })
}, IAe = {
  lastWeek: "'أخر' eeee 'عند' p",
  yesterday: "'أمس عند' p",
  today: "'اليوم عند' p",
  tomorrow: "'غداً عند' p",
  nextWeek: "eeee 'عند' p",
  other: "P"
}, LAe = (e, t, r, a) => IAe[e], HAe = {
  narrow: ["ق", "ب"],
  abbreviated: ["ق.م.", "ب.م."],
  wide: ["قبل الميلاد", "بعد الميلاد"]
}, FAe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["ر1", "ر2", "ر3", "ر4"],
  wide: ["الربع الأول", "الربع الثاني", "الربع الثالث", "الربع الرابع"]
}, WAe = {
  narrow: ["ي", "ف", "م", "أ", "م", "ي", "ي", "أ", "س", "أ", "ن", "د"],
  abbreviated: [
    "ينا",
    "فبر",
    "مارس",
    "أبريل",
    "مايو",
    "يونـ",
    "يولـ",
    "أغسـ",
    "سبتـ",
    "أكتـ",
    "نوفـ",
    "ديسـ"
  ],
  wide: [
    "يناير",
    "فبراير",
    "مارس",
    "أبريل",
    "مايو",
    "يونيو",
    "يوليو",
    "أغسطس",
    "سبتمبر",
    "أكتوبر",
    "نوفمبر",
    "ديسمبر"
  ]
}, VAe = {
  narrow: ["ح", "ن", "ث", "ر", "خ", "ج", "س"],
  short: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
  abbreviated: ["أحد", "اثنـ", "ثلا", "أربـ", "خميـ", "جمعة", "سبت"],
  wide: [
    "الأحد",
    "الاثنين",
    "الثلاثاء",
    "الأربعاء",
    "الخميس",
    "الجمعة",
    "السبت"
  ]
}, _Ae = {
  narrow: {
    am: "ص",
    pm: "م",
    midnight: "ن",
    noon: "ظ",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً"
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً"
  },
  wide: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً"
  }
}, BAe = {
  narrow: {
    am: "ص",
    pm: "م",
    midnight: "ن",
    noon: "ظ",
    morning: "في الصباح",
    afternoon: "بعد الظـهر",
    evening: "في المساء",
    night: "في الليل"
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "في الصباح",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل"
  },
  wide: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظـهر",
    evening: "في المساء",
    night: "في الليل"
  }
}, UAe = (e) => String(e), XAe = {
  ordinalNumber: UAe,
  era: Ce({
    values: HAe,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: FAe,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: WAe,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: VAe,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: _Ae,
    defaultWidth: "wide",
    formattingValues: BAe,
    defaultFormattingWidth: "wide"
  })
}, GAe = /^(\d+)(th|st|nd|rd)?/i, qAe = /\d+/i, KAe = {
  narrow: /^(ق|ب)/i,
  abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
  wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
}, YAe = {
  any: [/^قبل/i, /^بعد/i]
}, QAe = {
  narrow: /^[1234]/i,
  abbreviated: /^ر[1234]/i,
  wide: /^الربع [1234]/i
}, JAe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, ZAe = {
  narrow: /^[يفمأمسند]/i,
  abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i,
  wide: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i
}, eNe = {
  narrow: [
    /^ي/i,
    /^ف/i,
    /^م/i,
    /^أ/i,
    /^م/i,
    /^ي/i,
    /^ي/i,
    /^أ/i,
    /^س/i,
    /^أ/i,
    /^ن/i,
    /^د/i
  ],
  any: [
    /^ين/i,
    /^ف/i,
    /^مار/i,
    /^أب/i,
    /^ماي/i,
    /^يون/i,
    /^يول/i,
    /^أغ/i,
    /^س/i,
    /^أك/i,
    /^ن/i,
    /^د/i
  ]
}, tNe = {
  narrow: /^[حنثرخجس]/i,
  short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
  wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
}, nNe = {
  narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
  wide: [
    /^الأحد/i,
    /^الاثنين/i,
    /^الثلاثاء/i,
    /^الأربعاء/i,
    /^الخميس/i,
    /^الجمعة/i,
    /^السبت/i
  ],
  any: [/^أح/i, /^اث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
}, rNe = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, aNe = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, oNe = {
  ordinalNumber: Fn({
    matchPattern: GAe,
    parsePattern: qAe,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: KAe,
    defaultMatchWidth: "wide",
    parsePatterns: YAe,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: QAe,
    defaultMatchWidth: "wide",
    parsePatterns: JAe,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: ZAe,
    defaultMatchWidth: "wide",
    parsePatterns: eNe,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: tNe,
    defaultMatchWidth: "wide",
    parsePatterns: nNe,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: rNe,
    defaultMatchWidth: "any",
    parsePatterns: aNe,
    defaultParseWidth: "any"
  })
}, iNe = {
  code: "ar-SA",
  formatDistance: NAe,
  formatLong: jAe,
  formatRelative: LAe,
  localize: XAe,
  match: oNe,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, lNe = {
  lessThanXSeconds: {
    one: "أقل من ثانية",
    two: "أقل من زوز ثواني",
    threeToTen: "أقل من {{count}} ثواني",
    other: "أقل من {{count}} ثانية"
  },
  xSeconds: {
    one: "ثانية",
    two: "زوز ثواني",
    threeToTen: "{{count}} ثواني",
    other: "{{count}} ثانية"
  },
  halfAMinute: "نص دقيقة",
  lessThanXMinutes: {
    one: "أقل من دقيقة",
    two: "أقل من دقيقتين",
    threeToTen: "أقل من {{count}} دقايق",
    other: "أقل من {{count}} دقيقة"
  },
  xMinutes: {
    one: "دقيقة",
    two: "دقيقتين",
    threeToTen: "{{count}} دقايق",
    other: "{{count}} دقيقة"
  },
  aboutXHours: {
    one: "ساعة تقريب",
    two: "ساعتين تقريب",
    threeToTen: "{{count}} سوايع تقريب",
    other: "{{count}} ساعة تقريب"
  },
  xHours: {
    one: "ساعة",
    two: "ساعتين",
    threeToTen: "{{count}} سوايع",
    other: "{{count}} ساعة"
  },
  xDays: {
    one: "نهار",
    two: "نهارين",
    threeToTen: "{{count}} أيام",
    other: "{{count}} يوم"
  },
  aboutXWeeks: {
    one: "جمعة تقريب",
    two: "جمعتين تقريب",
    threeToTen: "{{count}} جماع تقريب",
    other: "{{count}} جمعة تقريب"
  },
  xWeeks: {
    one: "جمعة",
    two: "جمعتين",
    threeToTen: "{{count}} جماع",
    other: "{{count}} جمعة"
  },
  aboutXMonths: {
    one: "شهر تقريب",
    two: "شهرين تقريب",
    threeToTen: "{{count}} أشهرة تقريب",
    other: "{{count}} شهر تقريب"
  },
  xMonths: {
    one: "شهر",
    two: "شهرين",
    threeToTen: "{{count}} أشهرة",
    other: "{{count}} شهر"
  },
  aboutXYears: {
    one: "عام تقريب",
    two: "عامين تقريب",
    threeToTen: "{{count}} أعوام تقريب",
    other: "{{count}} عام تقريب"
  },
  xYears: {
    one: "عام",
    two: "عامين",
    threeToTen: "{{count}} أعوام",
    other: "{{count}} عام"
  },
  overXYears: {
    one: "أكثر من عام",
    two: "أكثر من عامين",
    threeToTen: "أكثر من {{count}} أعوام",
    other: "أكثر من {{count}} عام"
  },
  almostXYears: {
    one: "عام تقريب",
    two: "عامين تقريب",
    threeToTen: "{{count}} أعوام تقريب",
    other: "{{count}} عام تقريب"
  }
}, sNe = (e, t, r) => {
  const a = lNe[e];
  let i;
  return typeof a == "string" ? i = a : t === 1 ? i = a.one : t === 2 ? i = a.two : t <= 10 ? i = a.threeToTen.replace("{{count}}", String(t)) : i = a.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? "في " + i : "عندو " + i : i;
}, uNe = {
  full: "EEEE، do MMMM y",
  long: "do MMMM y",
  medium: "d MMM y",
  short: "dd/MM/yyyy"
}, cNe = {
  full: "HH:mm:ss",
  long: "HH:mm:ss",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, dNe = {
  full: "{{date}} 'مع' {{time}}",
  long: "{{date}} 'مع' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, fNe = {
  date: Ke({
    formats: uNe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: cNe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: dNe,
    defaultWidth: "full"
  })
}, mNe = {
  lastWeek: "eeee 'إلي فات مع' p",
  yesterday: "'البارح مع' p",
  today: "'اليوم مع' p",
  tomorrow: "'غدوة مع' p",
  nextWeek: "eeee 'الجمعة الجاية مع' p 'نهار'",
  other: "P"
}, hNe = (e) => mNe[e], pNe = {
  narrow: ["ق", "ب"],
  abbreviated: ["ق.م.", "ب.م."],
  wide: ["قبل الميلاد", "بعد الميلاد"]
}, gNe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["ر1", "ر2", "ر3", "ر4"],
  wide: ["الربع الأول", "الربع الثاني", "الربع الثالث", "الربع الرابع"]
}, vNe = {
  narrow: ["د", "ن", "أ", "س", "أ", "ج", "ج", "م", "أ", "م", "ف", "ج"],
  abbreviated: [
    "جانفي",
    "فيفري",
    "مارس",
    "أفريل",
    "ماي",
    "جوان",
    "جويلية",
    "أوت",
    "سبتمبر",
    "أكتوبر",
    "نوفمبر",
    "ديسمبر"
  ],
  wide: [
    "جانفي",
    "فيفري",
    "مارس",
    "أفريل",
    "ماي",
    "جوان",
    "جويلية",
    "أوت",
    "سبتمبر",
    "أكتوبر",
    "نوفمبر",
    "ديسمبر"
  ]
}, bNe = {
  narrow: ["ح", "ن", "ث", "ر", "خ", "ج", "س"],
  short: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
  abbreviated: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
  wide: [
    "الأحد",
    "الاثنين",
    "الثلاثاء",
    "الأربعاء",
    "الخميس",
    "الجمعة",
    "السبت"
  ]
}, yNe = {
  narrow: {
    am: "ص",
    pm: "ع",
    morning: "الصباح",
    noon: "القايلة",
    afternoon: "بعد القايلة",
    evening: "العشية",
    night: "الليل",
    midnight: "نص الليل"
  },
  abbreviated: {
    am: "ص",
    pm: "ع",
    morning: "الصباح",
    noon: "القايلة",
    afternoon: "بعد القايلة",
    evening: "العشية",
    night: "الليل",
    midnight: "نص الليل"
  },
  wide: {
    am: "ص",
    pm: "ع",
    morning: "الصباح",
    noon: "القايلة",
    afternoon: "بعد القايلة",
    evening: "العشية",
    night: "الليل",
    midnight: "نص الليل"
  }
}, wNe = {
  narrow: {
    am: "ص",
    pm: "ع",
    morning: "في الصباح",
    noon: "في القايلة",
    afternoon: "بعد القايلة",
    evening: "في العشية",
    night: "في الليل",
    midnight: "نص الليل"
  },
  abbreviated: {
    am: "ص",
    pm: "ع",
    morning: "في الصباح",
    noon: "في القايلة",
    afternoon: "بعد القايلة",
    evening: "في العشية",
    night: "في الليل",
    midnight: "نص الليل"
  },
  wide: {
    am: "ص",
    pm: "ع",
    morning: "في الصباح",
    noon: "في القايلة",
    afternoon: "بعد القايلة",
    evening: "في العشية",
    night: "في الليل",
    midnight: "نص الليل"
  }
}, SNe = (e) => String(e), CNe = {
  ordinalNumber: SNe,
  era: Ce({
    values: pNe,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: gNe,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: vNe,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: bNe,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: yNe,
    defaultWidth: "wide",
    formattingValues: wNe,
    defaultFormattingWidth: "wide"
  })
}, xNe = /^(\d+)(th|st|nd|rd)?/i, ENe = /\d+/i, PNe = {
  narrow: /[قب]/,
  abbreviated: /[قب]\.م\./,
  wide: /(قبل|بعد) الميلاد/
}, kNe = {
  any: [/قبل/, /بعد/]
}, MNe = {
  narrow: /^[1234]/i,
  abbreviated: /ر[1234]/,
  wide: /الربع (الأول|الثاني|الثالث|الرابع)/
}, ONe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, TNe = {
  narrow: /^[جفمأسند]/,
  abbreviated: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
  wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
}, RNe = {
  narrow: [
    /^ج/i,
    /^ف/i,
    /^م/i,
    /^أ/i,
    /^م/i,
    /^ج/i,
    /^ج/i,
    /^أ/i,
    /^س/i,
    /^أ/i,
    /^ن/i,
    /^د/i
  ],
  any: [
    /^جانفي/i,
    /^فيفري/i,
    /^مارس/i,
    /^أفريل/i,
    /^ماي/i,
    /^جوان/i,
    /^جويلية/i,
    /^أوت/i,
    /^سبتمبر/i,
    /^أكتوبر/i,
    /^نوفمبر/i,
    /^ديسمبر/i
  ]
}, ANe = {
  narrow: /^[حنثرخجس]/i,
  short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
}, NNe = {
  narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
  wide: [
    /^الأحد/i,
    /^الاثنين/i,
    /^الثلاثاء/i,
    /^الأربعاء/i,
    /^الخميس/i,
    /^الجمعة/i,
    /^السبت/i
  ],
  any: [/^أح/i, /^اث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
}, DNe = {
  narrow: /^(ص|ع|ن ل|ل|(في|مع) (صباح|قايلة|عشية|ليل))/,
  any: /^([صع]|نص الليل|قايلة|(في|مع) (صباح|قايلة|عشية|ليل))/
}, $Ne = {
  any: {
    am: /^ص/,
    pm: /^ع/,
    midnight: /نص الليل/,
    noon: /قايلة/,
    afternoon: /بعد القايلة/,
    morning: /صباح/,
    evening: /عشية/,
    night: /ليل/
  }
}, zNe = {
  ordinalNumber: Fn({
    matchPattern: xNe,
    parsePattern: ENe,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: PNe,
    defaultMatchWidth: "wide",
    parsePatterns: kNe,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: MNe,
    defaultMatchWidth: "wide",
    parsePatterns: ONe,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: TNe,
    defaultMatchWidth: "wide",
    parsePatterns: RNe,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: ANe,
    defaultMatchWidth: "wide",
    parsePatterns: NNe,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: DNe,
    defaultMatchWidth: "any",
    parsePatterns: $Ne,
    defaultParseWidth: "any"
  })
}, jNe = {
  code: "ar-TN",
  formatDistance: sNe,
  formatLong: fNe,
  formatRelative: hNe,
  localize: CNe,
  match: zNe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, INe = {
  lessThanXSeconds: {
    one: "bir saniyədən az",
    other: "{{count}} bir saniyədən az"
  },
  xSeconds: {
    one: "1 saniyə",
    other: "{{count}} saniyə"
  },
  halfAMinute: "yarım dəqiqə",
  lessThanXMinutes: {
    one: "bir dəqiqədən az",
    other: "{{count}} bir dəqiqədən az"
  },
  xMinutes: {
    one: "bir dəqiqə",
    other: "{{count}} dəqiqə"
  },
  aboutXHours: {
    one: "təxminən 1 saat",
    other: "təxminən {{count}} saat"
  },
  xHours: {
    one: "1 saat",
    other: "{{count}} saat"
  },
  xDays: {
    one: "1 gün",
    other: "{{count}} gün"
  },
  aboutXWeeks: {
    one: "təxminən 1 həftə",
    other: "təxminən {{count}} həftə"
  },
  xWeeks: {
    one: "1 həftə",
    other: "{{count}} həftə"
  },
  aboutXMonths: {
    one: "təxminən 1 ay",
    other: "təxminən {{count}} ay"
  },
  xMonths: {
    one: "1 ay",
    other: "{{count}} ay"
  },
  aboutXYears: {
    one: "təxminən 1 il",
    other: "təxminən {{count}} il"
  },
  xYears: {
    one: "1 il",
    other: "{{count}} il"
  },
  overXYears: {
    one: "1 ildən çox",
    other: "{{count}} ildən çox"
  },
  almostXYears: {
    one: "demək olar ki 1 il",
    other: "demək olar ki {{count}} il"
  }
}, LNe = (e, t, r) => {
  let a;
  const i = INe[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? a + " sonra" : a + " əvvəl" : a;
}, HNe = {
  full: "EEEE, do MMMM y 'il'",
  long: "do MMMM y 'il'",
  medium: "d MMM y 'il'",
  short: "dd.MM.yyyy"
}, FNe = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, WNe = {
  full: "{{date}} {{time}} - 'də'",
  long: "{{date}} {{time}} - 'də'",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, VNe = {
  date: Ke({
    formats: HNe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: FNe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: WNe,
    defaultWidth: "full"
  })
}, _Ne = {
  lastWeek: "'sonuncu' eeee p -'də'",
  yesterday: "'dünən' p -'də'",
  today: "'bugün' p -'də'",
  tomorrow: "'sabah' p -'də'",
  nextWeek: "eeee p -'də'",
  other: "P"
}, BNe = (e, t, r, a) => _Ne[e], UNe = {
  narrow: ["e.ə", "b.e"],
  abbreviated: ["e.ə", "b.e"],
  wide: ["eramızdan əvvəl", "bizim era"]
}, XNe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1ci kvartal", "2ci kvartal", "3cü kvartal", "4cü kvartal"]
}, GNe = {
  narrow: ["Y", "F", "M", "A", "M", "İ", "İ", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Yan",
    "Fev",
    "Mar",
    "Apr",
    "May",
    "İyun",
    "İyul",
    "Avq",
    "Sen",
    "Okt",
    "Noy",
    "Dek"
  ],
  wide: [
    "Yanvar",
    "Fevral",
    "Mart",
    "Aprel",
    "May",
    "İyun",
    "İyul",
    "Avqust",
    "Sentyabr",
    "Oktyabr",
    "Noyabr",
    "Dekabr"
  ]
}, qNe = {
  narrow: ["B.", "B.e", "Ç.a", "Ç.", "C.a", "C.", "Ş."],
  short: ["B.", "B.e", "Ç.a", "Ç.", "C.a", "C.", "Ş."],
  abbreviated: ["Baz", "Baz.e", "Çər.a", "Çər", "Cüm.a", "Cüm", "Şə"],
  wide: [
    "Bazar",
    "Bazar ertəsi",
    "Çərşənbə axşamı",
    "Çərşənbə",
    "Cümə axşamı",
    "Cümə",
    "Şənbə"
  ]
}, KNe = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "gecəyarı",
    noon: "gün",
    morning: "səhər",
    afternoon: "gündüz",
    evening: "axşam",
    night: "gecə"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "gecəyarı",
    noon: "gün",
    morning: "səhər",
    afternoon: "gündüz",
    evening: "axşam",
    night: "gecə"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "gecəyarı",
    noon: "gün",
    morning: "səhər",
    afternoon: "gündüz",
    evening: "axşam",
    night: "gecə"
  }
}, YNe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "gecəyarı",
    noon: "gün",
    morning: "səhər",
    afternoon: "gündüz",
    evening: "axşam",
    night: "gecə"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "gecəyarı",
    noon: "gün",
    morning: "səhər",
    afternoon: "gündüz",
    evening: "axşam",
    night: "gecə"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "gecəyarı",
    noon: "gün",
    morning: "səhər",
    afternoon: "gündüz",
    evening: "axşam",
    night: "gecə"
  }
}, U5 = {
  1: "-inci",
  5: "-inci",
  8: "-inci",
  70: "-inci",
  80: "-inci",
  2: "-nci",
  7: "-nci",
  20: "-nci",
  50: "-nci",
  3: "-üncü",
  4: "-üncü",
  100: "-üncü",
  6: "-ncı",
  9: "-uncu",
  10: "-uncu",
  30: "-uncu",
  60: "-ıncı",
  90: "-ıncı"
}, QNe = (e) => {
  if (e === 0)
    return e + "-ıncı";
  const t = e % 10, r = e % 100 - t, a = e >= 100 ? 100 : null;
  return U5[t] ? U5[t] : U5[r] ? U5[r] : a !== null ? U5[a] : "";
}, JNe = (e, t) => {
  const r = Number(e), a = QNe(r);
  return r + a;
}, ZNe = {
  ordinalNumber: JNe,
  era: Ce({
    values: UNe,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: XNe,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: GNe,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: qNe,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: KNe,
    defaultWidth: "wide",
    formattingValues: YNe,
    defaultFormattingWidth: "wide"
  })
}, eDe = /^(\d+)(-?(ci|inci|nci|uncu|üncü|ncı))?/i, tDe = /\d+/i, nDe = {
  narrow: /^(b|a)$/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)$/i,
  wide: /^(bizim eradan əvvəl|bizim era)$/i
}, rDe = {
  any: [/^b$/i, /^(a|c)$/i]
}, aDe = {
  narrow: /^[1234]$/i,
  abbreviated: /^K[1234]$/i,
  wide: /^[1234](ci)? kvartal$/i
}, oDe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, iDe = {
  narrow: /^[(?-i)yfmaisond]$/i,
  abbreviated: /^(Yan|Fev|Mar|Apr|May|İyun|İyul|Avq|Sen|Okt|Noy|Dek)$/i,
  wide: /^(Yanvar|Fevral|Mart|Aprel|May|İyun|İyul|Avgust|Sentyabr|Oktyabr|Noyabr|Dekabr)$/i
}, lDe = {
  narrow: [
    /^[(?-i)y]$/i,
    /^[(?-i)f]$/i,
    /^[(?-i)m]$/i,
    /^[(?-i)a]$/i,
    /^[(?-i)m]$/i,
    /^[(?-i)i]$/i,
    /^[(?-i)i]$/i,
    /^[(?-i)a]$/i,
    /^[(?-i)s]$/i,
    /^[(?-i)o]$/i,
    /^[(?-i)n]$/i,
    /^[(?-i)d]$/i
  ],
  abbreviated: [
    /^Yan$/i,
    /^Fev$/i,
    /^Mar$/i,
    /^Apr$/i,
    /^May$/i,
    /^İyun$/i,
    /^İyul$/i,
    /^Avg$/i,
    /^Sen$/i,
    /^Okt$/i,
    /^Noy$/i,
    /^Dek$/i
  ],
  wide: [
    /^Yanvar$/i,
    /^Fevral$/i,
    /^Mart$/i,
    /^Aprel$/i,
    /^May$/i,
    /^İyun$/i,
    /^İyul$/i,
    /^Avgust$/i,
    /^Sentyabr$/i,
    /^Oktyabr$/i,
    /^Noyabr$/i,
    /^Dekabr$/i
  ]
}, sDe = {
  narrow: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
  short: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
  abbreviated: /^(Baz\.e|Çər|Çər\.a|Cüm|Cüm\.a|Şə)$/i,
  wide: /^(Bazar|Bazar ertəsi|Çərşənbə axşamı|Çərşənbə|Cümə axşamı|Cümə|Şənbə)$/i
}, uDe = {
  narrow: [
    /^B\.$/i,
    /^B\.e$/i,
    /^Ç\.a$/i,
    /^Ç\.$/i,
    /^C\.a$/i,
    /^C\.$/i,
    /^Ş\.$/i
  ],
  abbreviated: [
    /^Baz$/i,
    /^Baz\.e$/i,
    /^Çər\.a$/i,
    /^Çər$/i,
    /^Cüm\.a$/i,
    /^Cüm$/i,
    /^Şə$/i
  ],
  wide: [
    /^Bazar$/i,
    /^Bazar ertəsi$/i,
    /^Çərşənbə axşamı$/i,
    /^Çərşənbə$/i,
    /^Cümə axşamı$/i,
    /^Cümə$/i,
    /^Şənbə$/i
  ],
  any: [
    /^B\.$/i,
    /^B\.e$/i,
    /^Ç\.a$/i,
    /^Ç\.$/i,
    /^C\.a$/i,
    /^C\.$/i,
    /^Ş\.$/i
  ]
}, cDe = {
  narrow: /^(a|p|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i,
  any: /^(am|pm|a\.m\.|p\.m\.|AM|PM|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i
}, dDe = {
  any: {
    am: /^a$/i,
    pm: /^p$/i,
    midnight: /^gecəyarı$/i,
    noon: /^gün$/i,
    morning: /səhər$/i,
    afternoon: /gündüz$/i,
    evening: /axşam$/i,
    night: /gecə$/i
  }
}, fDe = {
  ordinalNumber: Fn({
    matchPattern: eDe,
    parsePattern: tDe,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: nDe,
    defaultMatchWidth: "wide",
    parsePatterns: rDe,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: aDe,
    defaultMatchWidth: "wide",
    parsePatterns: oDe,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: iDe,
    defaultMatchWidth: "wide",
    parsePatterns: lDe,
    defaultParseWidth: "narrow"
  }),
  day: Ee({
    matchPatterns: sDe,
    defaultMatchWidth: "wide",
    parsePatterns: uDe,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: cDe,
    defaultMatchWidth: "any",
    parsePatterns: dDe,
    defaultParseWidth: "any"
  })
}, mDe = {
  code: "az",
  formatDistance: LNe,
  formatLong: VNe,
  formatRelative: BNe,
  localize: ZNe,
  match: fDe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
function X5(e, t) {
  if (e.one !== void 0 && t === 1)
    return e.one;
  const r = t % 10, a = t % 100;
  return r === 1 && a !== 11 ? e.singularNominative.replace("{{count}}", String(t)) : r >= 2 && r <= 4 && (a < 10 || a > 20) ? e.singularGenitive.replace("{{count}}", String(t)) : e.pluralGenitive.replace("{{count}}", String(t));
}
function Fh(e) {
  return (t, r) => r && r.addSuffix ? r.comparison && r.comparison > 0 ? e.future ? X5(e.future, t) : "праз " + X5(e.regular, t) : e.past ? X5(e.past, t) : X5(e.regular, t) + " таму" : X5(e.regular, t);
}
const hDe = (e, t) => t && t.addSuffix ? t.comparison && t.comparison > 0 ? "праз паўхвіліны" : "паўхвіліны таму" : "паўхвіліны", pDe = {
  lessThanXSeconds: Fh({
    regular: {
      one: "менш за секунду",
      singularNominative: "менш за {{count}} секунду",
      singularGenitive: "менш за {{count}} секунды",
      pluralGenitive: "менш за {{count}} секунд"
    },
    future: {
      one: "менш, чым праз секунду",
      singularNominative: "менш, чым праз {{count}} секунду",
      singularGenitive: "менш, чым праз {{count}} секунды",
      pluralGenitive: "менш, чым праз {{count}} секунд"
    }
  }),
  xSeconds: Fh({
    regular: {
      singularNominative: "{{count}} секунда",
      singularGenitive: "{{count}} секунды",
      pluralGenitive: "{{count}} секунд"
    },
    past: {
      singularNominative: "{{count}} секунду таму",
      singularGenitive: "{{count}} секунды таму",
      pluralGenitive: "{{count}} секунд таму"
    },
    future: {
      singularNominative: "праз {{count}} секунду",
      singularGenitive: "праз {{count}} секунды",
      pluralGenitive: "праз {{count}} секунд"
    }
  }),
  halfAMinute: hDe,
  lessThanXMinutes: Fh({
    regular: {
      one: "менш за хвіліну",
      singularNominative: "менш за {{count}} хвіліну",
      singularGenitive: "менш за {{count}} хвіліны",
      pluralGenitive: "менш за {{count}} хвілін"
    },
    future: {
      one: "менш, чым праз хвіліну",
      singularNominative: "менш, чым праз {{count}} хвіліну",
      singularGenitive: "менш, чым праз {{count}} хвіліны",
      pluralGenitive: "менш, чым праз {{count}} хвілін"
    }
  }),
  xMinutes: Fh({
    regular: {
      singularNominative: "{{count}} хвіліна",
      singularGenitive: "{{count}} хвіліны",
      pluralGenitive: "{{count}} хвілін"
    },
    past: {
      singularNominative: "{{count}} хвіліну таму",
      singularGenitive: "{{count}} хвіліны таму",
      pluralGenitive: "{{count}} хвілін таму"
    },
    future: {
      singularNominative: "праз {{count}} хвіліну",
      singularGenitive: "праз {{count}} хвіліны",
      pluralGenitive: "праз {{count}} хвілін"
    }
  }),
  aboutXHours: Fh({
    regular: {
      singularNominative: "каля {{count}} гадзіны",
      singularGenitive: "каля {{count}} гадзін",
      pluralGenitive: "каля {{count}} гадзін"
    },
    future: {
      singularNominative: "прыблізна праз {{count}} гадзіну",
      singularGenitive: "прыблізна праз {{count}} гадзіны",
      pluralGenitive: "прыблізна праз {{count}} гадзін"
    }
  }),
  xHours: Fh({
    regular: {
      singularNominative: "{{count}} гадзіна",
      singularGenitive: "{{count}} гадзіны",
      pluralGenitive: "{{count}} гадзін"
    },
    past: {
      singularNominative: "{{count}} гадзіну таму",
      singularGenitive: "{{count}} гадзіны таму",
      pluralGenitive: "{{count}} гадзін таму"
    },
    future: {
      singularNominative: "праз {{count}} гадзіну",
      singularGenitive: "праз {{count}} гадзіны",
      pluralGenitive: "праз {{count}} гадзін"
    }
  }),
  xDays: Fh({
    regular: {
      singularNominative: "{{count}} дзень",
      singularGenitive: "{{count}} дні",
      pluralGenitive: "{{count}} дзён"
    }
  }),
  aboutXWeeks: Fh({
    regular: {
      singularNominative: "каля {{count}} тыдні",
      singularGenitive: "каля {{count}} тыдняў",
      pluralGenitive: "каля {{count}} тыдняў"
    },
    future: {
      singularNominative: "прыблізна праз {{count}} тыдзень",
      singularGenitive: "прыблізна праз {{count}} тыдні",
      pluralGenitive: "прыблізна праз {{count}} тыдняў"
    }
  }),
  xWeeks: Fh({
    regular: {
      singularNominative: "{{count}} тыдзень",
      singularGenitive: "{{count}} тыдні",
      pluralGenitive: "{{count}} тыдняў"
    }
  }),
  aboutXMonths: Fh({
    regular: {
      singularNominative: "каля {{count}} месяца",
      singularGenitive: "каля {{count}} месяцаў",
      pluralGenitive: "каля {{count}} месяцаў"
    },
    future: {
      singularNominative: "прыблізна праз {{count}} месяц",
      singularGenitive: "прыблізна праз {{count}} месяцы",
      pluralGenitive: "прыблізна праз {{count}} месяцаў"
    }
  }),
  xMonths: Fh({
    regular: {
      singularNominative: "{{count}} месяц",
      singularGenitive: "{{count}} месяцы",
      pluralGenitive: "{{count}} месяцаў"
    }
  }),
  aboutXYears: Fh({
    regular: {
      singularNominative: "каля {{count}} года",
      singularGenitive: "каля {{count}} гадоў",
      pluralGenitive: "каля {{count}} гадоў"
    },
    future: {
      singularNominative: "прыблізна праз {{count}} год",
      singularGenitive: "прыблізна праз {{count}} гады",
      pluralGenitive: "прыблізна праз {{count}} гадоў"
    }
  }),
  xYears: Fh({
    regular: {
      singularNominative: "{{count}} год",
      singularGenitive: "{{count}} гады",
      pluralGenitive: "{{count}} гадоў"
    }
  }),
  overXYears: Fh({
    regular: {
      singularNominative: "больш за {{count}} год",
      singularGenitive: "больш за {{count}} гады",
      pluralGenitive: "больш за {{count}} гадоў"
    },
    future: {
      singularNominative: "больш, чым праз {{count}} год",
      singularGenitive: "больш, чым праз {{count}} гады",
      pluralGenitive: "больш, чым праз {{count}} гадоў"
    }
  }),
  almostXYears: Fh({
    regular: {
      singularNominative: "амаль {{count}} год",
      singularGenitive: "амаль {{count}} гады",
      pluralGenitive: "амаль {{count}} гадоў"
    },
    future: {
      singularNominative: "амаль праз {{count}} год",
      singularGenitive: "амаль праз {{count}} гады",
      pluralGenitive: "амаль праз {{count}} гадоў"
    }
  })
}, gDe = (e, t, r) => (r = r || {}, pDe[e](t, r)), vDe = {
  full: "EEEE, d MMMM y 'г.'",
  long: "d MMMM y 'г.'",
  medium: "d MMM y 'г.'",
  short: "dd.MM.y"
}, bDe = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, yDe = {
  any: "{{date}}, {{time}}"
}, wDe = {
  date: Ke({
    formats: vDe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: bDe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: yDe,
    defaultWidth: "any"
  })
}, vI = [
  "нядзелю",
  "панядзелак",
  "аўторак",
  "сераду",
  "чацвер",
  "пятніцу",
  "суботу"
];
function SDe(e) {
  const t = vI[e];
  switch (e) {
    case 0:
    case 3:
    case 5:
    case 6:
      return "'у мінулую " + t + " а' p";
    case 1:
    case 2:
    case 4:
      return "'у мінулы " + t + " а' p";
  }
}
function Ete(e) {
  return "'у " + vI[e] + " а' p";
}
function CDe(e) {
  const t = vI[e];
  switch (e) {
    case 0:
    case 3:
    case 5:
    case 6:
      return "'у наступную " + t + " а' p";
    case 1:
    case 2:
    case 4:
      return "'у наступны " + t + " а' p";
  }
}
const xDe = (e, t, r) => {
  const a = Ts(e), i = a.getDay();
  return su(a, t, r) ? Ete(i) : SDe(i);
}, EDe = (e, t, r) => {
  const a = Ts(e), i = a.getDay();
  return su(a, t, r) ? Ete(i) : CDe(i);
}, PDe = {
  lastWeek: xDe,
  yesterday: "'учора а' p",
  today: "'сёння а' p",
  tomorrow: "'заўтра а' p",
  nextWeek: EDe,
  other: "P"
}, kDe = (e, t, r, a) => {
  const i = PDe[e];
  return typeof i == "function" ? i(t, r, a) : i;
}, MDe = {
  narrow: ["да н.э.", "н.э."],
  abbreviated: ["да н. э.", "н. э."],
  wide: ["да нашай эры", "нашай эры"]
}, ODe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-ы кв.", "2-і кв.", "3-і кв.", "4-ы кв."],
  wide: ["1-ы квартал", "2-і квартал", "3-і квартал", "4-ы квартал"]
}, TDe = {
  narrow: ["С", "Л", "С", "К", "М", "Ч", "Л", "Ж", "В", "К", "Л", "С"],
  abbreviated: [
    "студз.",
    "лют.",
    "сак.",
    "крас.",
    "май",
    "чэрв.",
    "ліп.",
    "жн.",
    "вер.",
    "кастр.",
    "ліст.",
    "снеж."
  ],
  wide: [
    "студзень",
    "люты",
    "сакавік",
    "красавік",
    "май",
    "чэрвень",
    "ліпень",
    "жнівень",
    "верасень",
    "кастрычнік",
    "лістапад",
    "снежань"
  ]
}, RDe = {
  narrow: ["С", "Л", "С", "К", "М", "Ч", "Л", "Ж", "В", "К", "Л", "С"],
  abbreviated: [
    "студз.",
    "лют.",
    "сак.",
    "крас.",
    "мая",
    "чэрв.",
    "ліп.",
    "жн.",
    "вер.",
    "кастр.",
    "ліст.",
    "снеж."
  ],
  wide: [
    "студзеня",
    "лютага",
    "сакавіка",
    "красавіка",
    "мая",
    "чэрвеня",
    "ліпеня",
    "жніўня",
    "верасня",
    "кастрычніка",
    "лістапада",
    "снежня"
  ]
}, ADe = {
  narrow: ["Н", "П", "А", "С", "Ч", "П", "С"],
  short: ["нд", "пн", "аў", "ср", "чц", "пт", "сб"],
  abbreviated: ["нядз", "пан", "аўт", "сер", "чац", "пят", "суб"],
  wide: [
    "нядзеля",
    "панядзелак",
    "аўторак",
    "серада",
    "чацвер",
    "пятніца",
    "субота"
  ]
}, NDe = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўн.",
    noon: "поўд.",
    morning: "ран.",
    afternoon: "дзень",
    evening: "веч.",
    night: "ноч"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўн.",
    noon: "поўд.",
    morning: "ран.",
    afternoon: "дзень",
    evening: "веч.",
    night: "ноч"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўнач",
    noon: "поўдзень",
    morning: "раніца",
    afternoon: "дзень",
    evening: "вечар",
    night: "ноч"
  }
}, DDe = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўн.",
    noon: "поўд.",
    morning: "ран.",
    afternoon: "дня",
    evening: "веч.",
    night: "ночы"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўн.",
    noon: "поўд.",
    morning: "ран.",
    afternoon: "дня",
    evening: "веч.",
    night: "ночы"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўнач",
    noon: "поўдзень",
    morning: "раніцы",
    afternoon: "дня",
    evening: "вечара",
    night: "ночы"
  }
}, $De = (e, t) => {
  const r = String(t?.unit), a = Number(e);
  let i;
  return r === "date" ? i = "-га" : r === "hour" || r === "minute" || r === "second" ? i = "-я" : i = (a % 10 === 2 || a % 10 === 3) && a % 100 !== 12 && a % 100 !== 13 ? "-і" : "-ы", a + i;
}, zDe = {
  ordinalNumber: $De,
  era: Ce({
    values: MDe,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: ODe,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: TDe,
    defaultWidth: "wide",
    formattingValues: RDe,
    defaultFormattingWidth: "wide"
  }),
  day: Ce({
    values: ADe,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: NDe,
    defaultWidth: "any",
    formattingValues: DDe,
    defaultFormattingWidth: "wide"
  })
}, jDe = /^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i, IDe = /\d+/i, LDe = {
  narrow: /^((да )?н\.?\s?э\.?)/i,
  abbreviated: /^((да )?н\.?\s?э\.?)/i,
  wide: /^(да нашай эры|нашай эры|наша эра)/i
}, HDe = {
  any: [/^д/i, /^н/i]
}, FDe = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[ыі]?)? кв.?/i,
  wide: /^[1234](-?[ыі]?)? квартал/i
}, WDe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, VDe = {
  narrow: /^[слкмчжв]/i,
  abbreviated: /^(студз|лют|сак|крас|ма[йя]|чэрв|ліп|жн|вер|кастр|ліст|снеж)\.?/i,
  wide: /^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|ма[йя]|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|снеж(ань|ня))/i
}, _De = {
  narrow: [
    /^с/i,
    /^л/i,
    /^с/i,
    /^к/i,
    /^м/i,
    /^ч/i,
    /^л/i,
    /^ж/i,
    /^в/i,
    /^к/i,
    /^л/i,
    /^с/i
  ],
  any: [
    /^ст/i,
    /^лю/i,
    /^са/i,
    /^кр/i,
    /^ма/i,
    /^ч/i,
    /^ліп/i,
    /^ж/i,
    /^в/i,
    /^ка/i,
    /^ліс/i,
    /^сн/i
  ]
}, BDe = {
  narrow: /^[нпасч]/i,
  short: /^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
  abbreviated: /^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцв|чац|птн|пят|суб).?/i,
  wide: /^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацв(ер|ярга)|пятніц[аы]|субот[аы])/i
}, UDe = {
  narrow: [/^н/i, /^п/i, /^а/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^н/i, /^п[ан]/i, /^а/i, /^с[ер]/i, /^ч/i, /^п[ят]/i, /^с[уб]/i]
}, XDe = {
  narrow: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
  abbreviated: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
  wide: /^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i
}, GDe = {
  any: {
    am: /^дп/i,
    pm: /^пп/i,
    midnight: /^поўн/i,
    noon: /^поўд/i,
    morning: /^р/i,
    afternoon: /^д[зн]/i,
    evening: /^в/i,
    night: /^н/i
  }
}, qDe = {
  ordinalNumber: Fn({
    matchPattern: jDe,
    parsePattern: IDe,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: LDe,
    defaultMatchWidth: "wide",
    parsePatterns: HDe,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: FDe,
    defaultMatchWidth: "wide",
    parsePatterns: WDe,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: VDe,
    defaultMatchWidth: "wide",
    parsePatterns: _De,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: BDe,
    defaultMatchWidth: "wide",
    parsePatterns: UDe,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: XDe,
    defaultMatchWidth: "wide",
    parsePatterns: GDe,
    defaultParseWidth: "any"
  })
}, KDe = {
  code: "be",
  formatDistance: gDe,
  formatLong: wDe,
  formatRelative: kDe,
  localize: zDe,
  match: qDe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
function G5(e, t) {
  if (e.one !== void 0 && t === 1)
    return e.one;
  const r = t % 10, a = t % 100;
  return r === 1 && a !== 11 ? e.singularNominative.replace("{{count}}", String(t)) : r >= 2 && r <= 4 && (a < 10 || a > 20) ? e.singularGenitive.replace("{{count}}", String(t)) : e.pluralGenitive.replace("{{count}}", String(t));
}
function Wh(e) {
  return (t, r) => r && r.addSuffix ? r.comparison && r.comparison > 0 ? e.future ? G5(e.future, t) : "праз " + G5(e.regular, t) : e.past ? G5(e.past, t) : G5(e.regular, t) + " таму" : G5(e.regular, t);
}
const YDe = (e, t) => t && t.addSuffix ? t.comparison && t.comparison > 0 ? "праз паўхвіліны" : "паўхвіліны таму" : "паўхвіліны", QDe = {
  lessThanXSeconds: Wh({
    regular: {
      one: "менш за секунду",
      singularNominative: "менш за {{count}} секунду",
      singularGenitive: "менш за {{count}} секунды",
      pluralGenitive: "менш за {{count}} секунд"
    },
    future: {
      one: "менш, чым праз секунду",
      singularNominative: "менш, чым праз {{count}} секунду",
      singularGenitive: "менш, чым праз {{count}} секунды",
      pluralGenitive: "менш, чым праз {{count}} секунд"
    }
  }),
  xSeconds: Wh({
    regular: {
      singularNominative: "{{count}} секунда",
      singularGenitive: "{{count}} секунды",
      pluralGenitive: "{{count}} секунд"
    },
    past: {
      singularNominative: "{{count}} секунду таму",
      singularGenitive: "{{count}} секунды таму",
      pluralGenitive: "{{count}} секунд таму"
    },
    future: {
      singularNominative: "праз {{count}} секунду",
      singularGenitive: "праз {{count}} секунды",
      pluralGenitive: "праз {{count}} секунд"
    }
  }),
  halfAMinute: YDe,
  lessThanXMinutes: Wh({
    regular: {
      one: "менш за хвіліну",
      singularNominative: "менш за {{count}} хвіліну",
      singularGenitive: "менш за {{count}} хвіліны",
      pluralGenitive: "менш за {{count}} хвілін"
    },
    future: {
      one: "менш, чым праз хвіліну",
      singularNominative: "менш, чым праз {{count}} хвіліну",
      singularGenitive: "менш, чым праз {{count}} хвіліны",
      pluralGenitive: "менш, чым праз {{count}} хвілін"
    }
  }),
  xMinutes: Wh({
    regular: {
      singularNominative: "{{count}} хвіліна",
      singularGenitive: "{{count}} хвіліны",
      pluralGenitive: "{{count}} хвілін"
    },
    past: {
      singularNominative: "{{count}} хвіліну таму",
      singularGenitive: "{{count}} хвіліны таму",
      pluralGenitive: "{{count}} хвілін таму"
    },
    future: {
      singularNominative: "праз {{count}} хвіліну",
      singularGenitive: "праз {{count}} хвіліны",
      pluralGenitive: "праз {{count}} хвілін"
    }
  }),
  aboutXHours: Wh({
    regular: {
      singularNominative: "каля {{count}} гадзіны",
      singularGenitive: "каля {{count}} гадзін",
      pluralGenitive: "каля {{count}} гадзін"
    },
    future: {
      singularNominative: "прыблізна праз {{count}} гадзіну",
      singularGenitive: "прыблізна праз {{count}} гадзіны",
      pluralGenitive: "прыблізна праз {{count}} гадзін"
    }
  }),
  xHours: Wh({
    regular: {
      singularNominative: "{{count}} гадзіна",
      singularGenitive: "{{count}} гадзіны",
      pluralGenitive: "{{count}} гадзін"
    },
    past: {
      singularNominative: "{{count}} гадзіну таму",
      singularGenitive: "{{count}} гадзіны таму",
      pluralGenitive: "{{count}} гадзін таму"
    },
    future: {
      singularNominative: "праз {{count}} гадзіну",
      singularGenitive: "праз {{count}} гадзіны",
      pluralGenitive: "праз {{count}} гадзін"
    }
  }),
  xDays: Wh({
    regular: {
      singularNominative: "{{count}} дзень",
      singularGenitive: "{{count}} дні",
      pluralGenitive: "{{count}} дзён"
    }
  }),
  aboutXWeeks: Wh({
    regular: {
      singularNominative: "каля {{count}} тыдні",
      singularGenitive: "каля {{count}} тыдняў",
      pluralGenitive: "каля {{count}} тыдняў"
    },
    future: {
      singularNominative: "прыблізна праз {{count}} тыдзень",
      singularGenitive: "прыблізна праз {{count}} тыдні",
      pluralGenitive: "прыблізна праз {{count}} тыдняў"
    }
  }),
  xWeeks: Wh({
    regular: {
      singularNominative: "{{count}} тыдзень",
      singularGenitive: "{{count}} тыдні",
      pluralGenitive: "{{count}} тыдняў"
    }
  }),
  aboutXMonths: Wh({
    regular: {
      singularNominative: "каля {{count}} месяца",
      singularGenitive: "каля {{count}} месяцаў",
      pluralGenitive: "каля {{count}} месяцаў"
    },
    future: {
      singularNominative: "прыблізна праз {{count}} месяц",
      singularGenitive: "прыблізна праз {{count}} месяцы",
      pluralGenitive: "прыблізна праз {{count}} месяцаў"
    }
  }),
  xMonths: Wh({
    regular: {
      singularNominative: "{{count}} месяц",
      singularGenitive: "{{count}} месяцы",
      pluralGenitive: "{{count}} месяцаў"
    }
  }),
  aboutXYears: Wh({
    regular: {
      singularNominative: "каля {{count}} года",
      singularGenitive: "каля {{count}} гадоў",
      pluralGenitive: "каля {{count}} гадоў"
    },
    future: {
      singularNominative: "прыблізна праз {{count}} год",
      singularGenitive: "прыблізна праз {{count}} гады",
      pluralGenitive: "прыблізна праз {{count}} гадоў"
    }
  }),
  xYears: Wh({
    regular: {
      singularNominative: "{{count}} год",
      singularGenitive: "{{count}} гады",
      pluralGenitive: "{{count}} гадоў"
    }
  }),
  overXYears: Wh({
    regular: {
      singularNominative: "больш за {{count}} год",
      singularGenitive: "больш за {{count}} гады",
      pluralGenitive: "больш за {{count}} гадоў"
    },
    future: {
      singularNominative: "больш, чым праз {{count}} год",
      singularGenitive: "больш, чым праз {{count}} гады",
      pluralGenitive: "больш, чым праз {{count}} гадоў"
    }
  }),
  almostXYears: Wh({
    regular: {
      singularNominative: "амаль {{count}} год",
      singularGenitive: "амаль {{count}} гады",
      pluralGenitive: "амаль {{count}} гадоў"
    },
    future: {
      singularNominative: "амаль праз {{count}} год",
      singularGenitive: "амаль праз {{count}} гады",
      pluralGenitive: "амаль праз {{count}} гадоў"
    }
  })
}, JDe = (e, t, r) => (r = r || {}, QDe[e](t, r)), ZDe = {
  full: "EEEE, d MMMM y 'г.'",
  long: "d MMMM y 'г.'",
  medium: "d MMM y 'г.'",
  short: "dd.MM.y"
}, e$e = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, t$e = {
  any: "{{date}}, {{time}}"
}, n$e = {
  date: Ke({
    formats: ZDe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: e$e,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: t$e,
    defaultWidth: "any"
  })
}, bI = [
  "нядзелю",
  "панядзелак",
  "аўторак",
  "сераду",
  "чацьвер",
  "пятніцу",
  "суботу"
];
function r$e(e) {
  const t = bI[e];
  switch (e) {
    case 0:
    case 3:
    case 5:
    case 6:
      return "'у мінулую " + t + " а' p";
    case 1:
    case 2:
    case 4:
      return "'у мінулы " + t + " а' p";
  }
}
function Pte(e) {
  return "'у " + bI[e] + " а' p";
}
function a$e(e) {
  const t = bI[e];
  switch (e) {
    case 0:
    case 3:
    case 5:
    case 6:
      return "'у наступную " + t + " а' p";
    case 1:
    case 2:
    case 4:
      return "'у наступны " + t + " а' p";
  }
}
const o$e = (e, t, r) => {
  const a = Ts(e), i = a.getDay();
  return su(a, t, r) ? Pte(i) : r$e(i);
}, i$e = (e, t, r) => {
  const a = Ts(e), i = a.getDay();
  return su(a, t, r) ? Pte(i) : a$e(i);
}, l$e = {
  lastWeek: o$e,
  yesterday: "'учора а' p",
  today: "'сёньня а' p",
  tomorrow: "'заўтра а' p",
  nextWeek: i$e,
  other: "P"
}, s$e = (e, t, r, a) => {
  const i = l$e[e];
  return typeof i == "function" ? i(t, r, a) : i;
}, u$e = {
  narrow: ["да н.э.", "н.э."],
  abbreviated: ["да н. э.", "н. э."],
  wide: ["да нашай эры", "нашай эры"]
}, c$e = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-ы кв.", "2-і кв.", "3-і кв.", "4-ы кв."],
  wide: ["1-ы квартал", "2-і квартал", "3-і квартал", "4-ы квартал"]
}, d$e = {
  narrow: ["С", "Л", "С", "К", "Т", "Ч", "Л", "Ж", "В", "К", "Л", "С"],
  abbreviated: [
    "студз.",
    "лют.",
    "сак.",
    "крас.",
    "трав.",
    "чэрв.",
    "ліп.",
    "жн.",
    "вер.",
    "кастр.",
    "ліст.",
    "сьнеж."
  ],
  wide: [
    "студзень",
    "люты",
    "сакавік",
    "красавік",
    "травень",
    "чэрвень",
    "ліпень",
    "жнівень",
    "верасень",
    "кастрычнік",
    "лістапад",
    "сьнежань"
  ]
}, f$e = {
  narrow: ["С", "Л", "С", "К", "Т", "Ч", "Л", "Ж", "В", "К", "Л", "С"],
  abbreviated: [
    "студз.",
    "лют.",
    "сак.",
    "крас.",
    "трав.",
    "чэрв.",
    "ліп.",
    "жн.",
    "вер.",
    "кастр.",
    "ліст.",
    "сьнеж."
  ],
  wide: [
    "студзеня",
    "лютага",
    "сакавіка",
    "красавіка",
    "траўня",
    "чэрвеня",
    "ліпеня",
    "жніўня",
    "верасня",
    "кастрычніка",
    "лістапада",
    "сьнежня"
  ]
}, m$e = {
  narrow: ["Н", "П", "А", "С", "Ч", "П", "С"],
  short: ["нд", "пн", "аў", "ср", "чц", "пт", "сб"],
  abbreviated: ["нядз", "пан", "аўт", "сер", "чаць", "пят", "суб"],
  wide: [
    "нядзеля",
    "панядзелак",
    "аўторак",
    "серада",
    "чацьвер",
    "пятніца",
    "субота"
  ]
}, h$e = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўн.",
    noon: "поўд.",
    morning: "ран.",
    afternoon: "дзень",
    evening: "веч.",
    night: "ноч"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўн.",
    noon: "поўд.",
    morning: "ран.",
    afternoon: "дзень",
    evening: "веч.",
    night: "ноч"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўнач",
    noon: "поўдзень",
    morning: "раніца",
    afternoon: "дзень",
    evening: "вечар",
    night: "ноч"
  }
}, p$e = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўн.",
    noon: "поўд.",
    morning: "ран.",
    afternoon: "дня",
    evening: "веч.",
    night: "ночы"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўн.",
    noon: "поўд.",
    morning: "ран.",
    afternoon: "дня",
    evening: "веч.",
    night: "ночы"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўнач",
    noon: "поўдзень",
    morning: "раніцы",
    afternoon: "дня",
    evening: "вечара",
    night: "ночы"
  }
}, g$e = (e, t) => {
  const r = String(t?.unit), a = Number(e);
  let i;
  return r === "date" ? i = "-га" : r === "hour" || r === "minute" || r === "second" ? i = "-я" : i = (a % 10 === 2 || a % 10 === 3) && a % 100 !== 12 && a % 100 !== 13 ? "-і" : "-ы", a + i;
}, v$e = {
  ordinalNumber: g$e,
  era: Ce({
    values: u$e,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: c$e,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: d$e,
    defaultWidth: "wide",
    formattingValues: f$e,
    defaultFormattingWidth: "wide"
  }),
  day: Ce({
    values: m$e,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: h$e,
    defaultWidth: "any",
    formattingValues: p$e,
    defaultFormattingWidth: "wide"
  })
}, b$e = /^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i, y$e = /\d+/i, w$e = {
  narrow: /^((да )?н\.?\s?э\.?)/i,
  abbreviated: /^((да )?н\.?\s?э\.?)/i,
  wide: /^(да нашай эры|нашай эры|наша эра)/i
}, S$e = {
  any: [/^д/i, /^н/i]
}, C$e = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[ыі]?)? кв.?/i,
  wide: /^[1234](-?[ыі]?)? квартал/i
}, x$e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, E$e = {
  narrow: /^[слкмчжв]/i,
  abbreviated: /^(студз|лют|сак|крас|тр(ав)?|чэрв|ліп|жн|вер|кастр|ліст|сьнеж)\.?/i,
  wide: /^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|тра(вень|ўня)|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|сьнеж(ань|ня))/i
}, P$e = {
  narrow: [
    /^с/i,
    /^л/i,
    /^с/i,
    /^к/i,
    /^т/i,
    /^ч/i,
    /^л/i,
    /^ж/i,
    /^в/i,
    /^к/i,
    /^л/i,
    /^с/i
  ],
  any: [
    /^ст/i,
    /^лю/i,
    /^са/i,
    /^кр/i,
    /^тр/i,
    /^ч/i,
    /^ліп/i,
    /^ж/i,
    /^в/i,
    /^ка/i,
    /^ліс/i,
    /^сн/i
  ]
}, k$e = {
  narrow: /^[нпасч]/i,
  short: /^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
  abbreviated: /^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцьв|чаць|птн|пят|суб).?/i,
  wide: /^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацьв(ер|ярга)|пятніц[аы]|субот[аы])/i
}, M$e = {
  narrow: [/^н/i, /^п/i, /^а/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^н/i, /^п[ан]/i, /^а/i, /^с[ер]/i, /^ч/i, /^п[ят]/i, /^с[уб]/i]
}, O$e = {
  narrow: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
  abbreviated: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
  wide: /^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i
}, T$e = {
  any: {
    am: /^дп/i,
    pm: /^пп/i,
    midnight: /^поўн/i,
    noon: /^поўд/i,
    morning: /^р/i,
    afternoon: /^д[зн]/i,
    evening: /^в/i,
    night: /^н/i
  }
}, R$e = {
  ordinalNumber: Fn({
    matchPattern: b$e,
    parsePattern: y$e,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: w$e,
    defaultMatchWidth: "wide",
    parsePatterns: S$e,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: C$e,
    defaultMatchWidth: "wide",
    parsePatterns: x$e,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: E$e,
    defaultMatchWidth: "wide",
    parsePatterns: P$e,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: k$e,
    defaultMatchWidth: "wide",
    parsePatterns: M$e,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: O$e,
    defaultMatchWidth: "wide",
    parsePatterns: T$e,
    defaultParseWidth: "any"
  })
}, A$e = {
  code: "be-tarask",
  formatDistance: JDe,
  formatLong: n$e,
  formatRelative: s$e,
  localize: v$e,
  match: R$e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, N$e = {
  lessThanXSeconds: {
    one: "по-малко от секунда",
    other: "по-малко от {{count}} секунди"
  },
  xSeconds: {
    one: "1 секунда",
    other: "{{count}} секунди"
  },
  halfAMinute: "половин минута",
  lessThanXMinutes: {
    one: "по-малко от минута",
    other: "по-малко от {{count}} минути"
  },
  xMinutes: {
    one: "1 минута",
    other: "{{count}} минути"
  },
  aboutXHours: {
    one: "около час",
    other: "около {{count}} часа"
  },
  xHours: {
    one: "1 час",
    other: "{{count}} часа"
  },
  xDays: {
    one: "1 ден",
    other: "{{count}} дни"
  },
  aboutXWeeks: {
    one: "около седмица",
    other: "около {{count}} седмици"
  },
  xWeeks: {
    one: "1 седмица",
    other: "{{count}} седмици"
  },
  aboutXMonths: {
    one: "около месец",
    other: "около {{count}} месеца"
  },
  xMonths: {
    one: "1 месец",
    other: "{{count}} месеца"
  },
  aboutXYears: {
    one: "около година",
    other: "около {{count}} години"
  },
  xYears: {
    one: "1 година",
    other: "{{count}} години"
  },
  overXYears: {
    one: "над година",
    other: "над {{count}} години"
  },
  almostXYears: {
    one: "почти година",
    other: "почти {{count}} години"
  }
}, D$e = (e, t, r) => {
  let a;
  const i = N$e[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? "след " + a : "преди " + a : a;
}, $$e = {
  full: "EEEE, dd MMMM yyyy",
  long: "dd MMMM yyyy",
  medium: "dd MMM yyyy",
  short: "dd.MM.yyyy"
}, z$e = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "H:mm"
}, j$e = {
  any: "{{date}} {{time}}"
}, I$e = {
  date: Ke({
    formats: $$e,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: z$e,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: j$e,
    defaultWidth: "any"
  })
}, yI = [
  "неделя",
  "понеделник",
  "вторник",
  "сряда",
  "четвъртък",
  "петък",
  "събота"
];
function L$e(e) {
  const t = yI[e];
  switch (e) {
    case 0:
    case 3:
    case 6:
      return "'миналата " + t + " в' p";
    case 1:
    case 2:
    case 4:
    case 5:
      return "'миналия " + t + " в' p";
  }
}
function kte(e) {
  const t = yI[e];
  return e === 2 ? "'във " + t + " в' p" : "'в " + t + " в' p";
}
function H$e(e) {
  const t = yI[e];
  switch (e) {
    case 0:
    case 3:
    case 6:
      return "'следващата " + t + " в' p";
    case 1:
    case 2:
    case 4:
    case 5:
      return "'следващия " + t + " в' p";
  }
}
const F$e = (e, t, r) => {
  const a = Ts(e), i = a.getDay();
  return su(a, t, r) ? kte(i) : L$e(i);
}, W$e = (e, t, r) => {
  const a = Ts(e), i = a.getDay();
  return su(a, t, r) ? kte(i) : H$e(i);
}, V$e = {
  lastWeek: F$e,
  yesterday: "'вчера в' p",
  today: "'днес в' p",
  tomorrow: "'утре в' p",
  nextWeek: W$e,
  other: "P"
}, _$e = (e, t, r, a) => {
  const i = V$e[e];
  return typeof i == "function" ? i(t, r, a) : i;
}, B$e = {
  narrow: ["пр.н.е.", "н.е."],
  abbreviated: ["преди н. е.", "н. е."],
  wide: ["преди новата ера", "новата ера"]
}, U$e = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-во тримес.", "2-ро тримес.", "3-то тримес.", "4-то тримес."],
  wide: [
    "1-во тримесечие",
    "2-ро тримесечие",
    "3-то тримесечие",
    "4-то тримесечие"
  ]
}, X$e = {
  abbreviated: [
    "яну",
    "фев",
    "мар",
    "апр",
    "май",
    "юни",
    "юли",
    "авг",
    "сеп",
    "окт",
    "ное",
    "дек"
  ],
  wide: [
    "януари",
    "февруари",
    "март",
    "април",
    "май",
    "юни",
    "юли",
    "август",
    "септември",
    "октомври",
    "ноември",
    "декември"
  ]
}, G$e = {
  narrow: ["Н", "П", "В", "С", "Ч", "П", "С"],
  short: ["нд", "пн", "вт", "ср", "чт", "пт", "сб"],
  abbreviated: ["нед", "пон", "вто", "сря", "чет", "пет", "съб"],
  wide: [
    "неделя",
    "понеделник",
    "вторник",
    "сряда",
    "четвъртък",
    "петък",
    "събота"
  ]
}, q$e = {
  wide: {
    am: "преди обяд",
    pm: "след обяд",
    midnight: "в полунощ",
    noon: "на обяд",
    morning: "сутринта",
    afternoon: "следобед",
    evening: "вечерта",
    night: "през нощта"
  }
};
function K$e(e) {
  return e === "year" || e === "week" || e === "minute" || e === "second";
}
function Y$e(e) {
  return e === "quarter";
}
function L4(e, t, r, a, i) {
  const c = Y$e(t) ? i : K$e(t) ? a : r;
  return e + "-" + c;
}
const Q$e = (e, t) => {
  const r = Number(e), a = t?.unit;
  if (r === 0)
    return L4(0, a, "ев", "ева", "ево");
  if (r % 1e3 === 0)
    return L4(r, a, "ен", "на", "но");
  if (r % 100 === 0)
    return L4(r, a, "тен", "тна", "тно");
  const i = r % 100;
  if (i > 20 || i < 10)
    switch (i % 10) {
      case 1:
        return L4(r, a, "ви", "ва", "во");
      case 2:
        return L4(r, a, "ри", "ра", "ро");
      case 7:
      case 8:
        return L4(r, a, "ми", "ма", "мо");
    }
  return L4(r, a, "ти", "та", "то");
}, J$e = {
  ordinalNumber: Q$e,
  era: Ce({
    values: B$e,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: U$e,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: X$e,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: G$e,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: q$e,
    defaultWidth: "wide"
  })
}, Z$e = /^(\d+)(-?[врмт][аи]|-?т?(ен|на)|-?(ев|ева))?/i, eze = /\d+/i, tze = {
  narrow: /^((пр)?н\.?\s?е\.?)/i,
  abbreviated: /^((пр)?н\.?\s?е\.?)/i,
  wide: /^(преди новата ера|новата ера|нова ера)/i
}, nze = {
  any: [/^п/i, /^н/i]
}, rze = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[врт]?o?)? тримес.?/i,
  wide: /^[1234](-?[врт]?о?)? тримесечие/i
}, aze = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, oze = {
  narrow: /^[нпвсч]/i,
  short: /^(нд|пн|вт|ср|чт|пт|сб)/i,
  abbreviated: /^(нед|пон|вто|сря|чет|пет|съб)/i,
  wide: /^(неделя|понеделник|вторник|сряда|четвъртък|петък|събота)/i
}, ize = {
  narrow: [/^н/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^н[ед]/i, /^п[он]/i, /^вт/i, /^ср/i, /^ч[ет]/i, /^п[ет]/i, /^с[ъб]/i]
}, lze = {
  abbreviated: /^(яну|фев|мар|апр|май|юни|юли|авг|сеп|окт|ное|дек)/i,
  wide: /^(януари|февруари|март|април|май|юни|юли|август|септември|октомври|ноември|декември)/i
}, sze = {
  any: [
    /^я/i,
    /^ф/i,
    /^мар/i,
    /^ап/i,
    /^май/i,
    /^юн/i,
    /^юл/i,
    /^ав/i,
    /^се/i,
    /^окт/i,
    /^но/i,
    /^де/i
  ]
}, uze = {
  any: /^(преди о|след о|в по|на о|през|веч|сут|следо)/i
}, cze = {
  any: {
    am: /^преди о/i,
    pm: /^след о/i,
    midnight: /^в пол/i,
    noon: /^на об/i,
    morning: /^сут/i,
    afternoon: /^следо/i,
    evening: /^веч/i,
    night: /^през н/i
  }
}, dze = {
  ordinalNumber: Fn({
    matchPattern: Z$e,
    parsePattern: eze,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: tze,
    defaultMatchWidth: "wide",
    parsePatterns: nze,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: rze,
    defaultMatchWidth: "wide",
    parsePatterns: aze,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: lze,
    defaultMatchWidth: "wide",
    parsePatterns: sze,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: oze,
    defaultMatchWidth: "wide",
    parsePatterns: ize,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: uze,
    defaultMatchWidth: "any",
    parsePatterns: cze,
    defaultParseWidth: "any"
  })
}, fze = {
  code: "bg",
  formatDistance: D$e,
  formatLong: I$e,
  formatRelative: _$e,
  localize: J$e,
  match: dze,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, mze = {
  locale: {
    1: "১",
    2: "২",
    3: "৩",
    4: "৪",
    5: "৫",
    6: "৬",
    7: "৭",
    8: "৮",
    9: "৯",
    0: "০"
  }
}, hze = {
  narrow: ["খ্রিঃপূঃ", "খ্রিঃ"],
  abbreviated: ["খ্রিঃপূর্ব", "খ্রিঃ"],
  wide: ["খ্রিস্টপূর্ব", "খ্রিস্টাব্দ"]
}, pze = {
  narrow: ["১", "২", "৩", "৪"],
  abbreviated: ["১ত্রৈ", "২ত্রৈ", "৩ত্রৈ", "৪ত্রৈ"],
  wide: ["১ম ত্রৈমাসিক", "২য় ত্রৈমাসিক", "৩য় ত্রৈমাসিক", "৪র্থ ত্রৈমাসিক"]
}, gze = {
  narrow: [
    "জানু",
    "ফেব্রু",
    "মার্চ",
    "এপ্রিল",
    "মে",
    "জুন",
    "জুলাই",
    "আগস্ট",
    "সেপ্ট",
    "অক্টো",
    "নভে",
    "ডিসে"
  ],
  abbreviated: [
    "জানু",
    "ফেব্রু",
    "মার্চ",
    "এপ্রিল",
    "মে",
    "জুন",
    "জুলাই",
    "আগস্ট",
    "সেপ্ট",
    "অক্টো",
    "নভে",
    "ডিসে"
  ],
  wide: [
    "জানুয়ারি",
    "ফেব্রুয়ারি",
    "মার্চ",
    "এপ্রিল",
    "মে",
    "জুন",
    "জুলাই",
    "আগস্ট",
    "সেপ্টেম্বর",
    "অক্টোবর",
    "নভেম্বর",
    "ডিসেম্বর"
  ]
}, vze = {
  narrow: ["র", "সো", "ম", "বু", "বৃ", "শু", "শ"],
  short: ["রবি", "সোম", "মঙ্গল", "বুধ", "বৃহ", "শুক্র", "শনি"],
  abbreviated: ["রবি", "সোম", "মঙ্গল", "বুধ", "বৃহ", "শুক্র", "শনি"],
  wide: [
    "রবিবার",
    "সোমবার",
    "মঙ্গলবার",
    "বুধবার",
    "বৃহস্পতিবার ",
    "শুক্রবার",
    "শনিবার"
  ]
}, bze = {
  narrow: {
    am: "পূ",
    pm: "অপ",
    midnight: "মধ্যরাত",
    noon: "মধ্যাহ্ন",
    morning: "সকাল",
    afternoon: "বিকাল",
    evening: "সন্ধ্যা",
    night: "রাত"
  },
  abbreviated: {
    am: "পূর্বাহ্ন",
    pm: "অপরাহ্ন",
    midnight: "মধ্যরাত",
    noon: "মধ্যাহ্ন",
    morning: "সকাল",
    afternoon: "বিকাল",
    evening: "সন্ধ্যা",
    night: "রাত"
  },
  wide: {
    am: "পূর্বাহ্ন",
    pm: "অপরাহ্ন",
    midnight: "মধ্যরাত",
    noon: "মধ্যাহ্ন",
    morning: "সকাল",
    afternoon: "বিকাল",
    evening: "সন্ধ্যা",
    night: "রাত"
  }
}, yze = {
  narrow: {
    am: "পূ",
    pm: "অপ",
    midnight: "মধ্যরাত",
    noon: "মধ্যাহ্ন",
    morning: "সকাল",
    afternoon: "বিকাল",
    evening: "সন্ধ্যা",
    night: "রাত"
  },
  abbreviated: {
    am: "পূর্বাহ্ন",
    pm: "অপরাহ্ন",
    midnight: "মধ্যরাত",
    noon: "মধ্যাহ্ন",
    morning: "সকাল",
    afternoon: "বিকাল",
    evening: "সন্ধ্যা",
    night: "রাত"
  },
  wide: {
    am: "পূর্বাহ্ন",
    pm: "অপরাহ্ন",
    midnight: "মধ্যরাত",
    noon: "মধ্যাহ্ন",
    morning: "সকাল",
    afternoon: "বিকাল",
    evening: "সন্ধ্যা",
    night: "রাত"
  }
};
function wze(e, t) {
  if (e > 18 && e <= 31)
    return t + "শে";
  switch (e) {
    case 1:
      return t + "লা";
    case 2:
    case 3:
      return t + "রা";
    case 4:
      return t + "ঠা";
    default:
      return t + "ই";
  }
}
const Sze = (e, t) => {
  const r = Number(e), a = Mte(r);
  if (t?.unit === "date")
    return wze(r, a);
  if (r > 10 || r === 0) return a + "তম";
  switch (r % 10) {
    case 2:
    case 3:
      return a + "য়";
    case 4:
      return a + "র্থ";
    case 6:
      return a + "ষ্ঠ";
    default:
      return a + "ম";
  }
};
function Mte(e) {
  return e.toString().replace(/\d/g, function(t) {
    return mze.locale[t];
  });
}
const Cze = {
  ordinalNumber: Sze,
  era: Ce({
    values: hze,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: pze,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: gze,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: vze,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: bze,
    defaultWidth: "wide",
    formattingValues: yze,
    defaultFormattingWidth: "wide"
  })
}, xze = {
  lessThanXSeconds: {
    one: "প্রায় ১ সেকেন্ড",
    other: "প্রায় {{count}} সেকেন্ড"
  },
  xSeconds: {
    one: "১ সেকেন্ড",
    other: "{{count}} সেকেন্ড"
  },
  halfAMinute: "আধ মিনিট",
  lessThanXMinutes: {
    one: "প্রায় ১ মিনিট",
    other: "প্রায় {{count}} মিনিট"
  },
  xMinutes: {
    one: "১ মিনিট",
    other: "{{count}} মিনিট"
  },
  aboutXHours: {
    one: "প্রায় ১ ঘন্টা",
    other: "প্রায় {{count}} ঘন্টা"
  },
  xHours: {
    one: "১ ঘন্টা",
    other: "{{count}} ঘন্টা"
  },
  xDays: {
    one: "১ দিন",
    other: "{{count}} দিন"
  },
  aboutXWeeks: {
    one: "প্রায় ১ সপ্তাহ",
    other: "প্রায় {{count}} সপ্তাহ"
  },
  xWeeks: {
    one: "১ সপ্তাহ",
    other: "{{count}} সপ্তাহ"
  },
  aboutXMonths: {
    one: "প্রায় ১ মাস",
    other: "প্রায় {{count}} মাস"
  },
  xMonths: {
    one: "১ মাস",
    other: "{{count}} মাস"
  },
  aboutXYears: {
    one: "প্রায় ১ বছর",
    other: "প্রায় {{count}} বছর"
  },
  xYears: {
    one: "১ বছর",
    other: "{{count}} বছর"
  },
  overXYears: {
    one: "১ বছরের বেশি",
    other: "{{count}} বছরের বেশি"
  },
  almostXYears: {
    one: "প্রায় ১ বছর",
    other: "প্রায় {{count}} বছর"
  }
}, Eze = (e, t, r) => {
  let a;
  const i = xze[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", Mte(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? a + " এর মধ্যে" : a + " আগে" : a;
}, Pze = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, kze = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Mze = {
  full: "{{date}} {{time}} 'সময়'",
  long: "{{date}} {{time}} 'সময়'",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Oze = {
  date: Ke({
    formats: Pze,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: kze,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: Mze,
    defaultWidth: "full"
  })
}, Tze = {
  lastWeek: "'গত' eeee 'সময়' p",
  yesterday: "'গতকাল' 'সময়' p",
  today: "'আজ' 'সময়' p",
  tomorrow: "'আগামীকাল' 'সময়' p",
  nextWeek: "eeee 'সময়' p",
  other: "P"
}, Rze = (e, t, r, a) => Tze[e], Aze = /^(\d+)(ম|য়|র্থ|ষ্ঠ|শে|ই|তম)?/i, Nze = /\d+/i, Dze = {
  narrow: /^(খ্রিঃপূঃ|খ্রিঃ)/i,
  abbreviated: /^(খ্রিঃপূর্ব|খ্রিঃ)/i,
  wide: /^(খ্রিস্টপূর্ব|খ্রিস্টাব্দ)/i
}, $ze = {
  narrow: [/^খ্রিঃপূঃ/i, /^খ্রিঃ/i],
  abbreviated: [/^খ্রিঃপূর্ব/i, /^খ্রিঃ/i],
  wide: [/^খ্রিস্টপূর্ব/i, /^খ্রিস্টাব্দ/i]
}, zze = {
  narrow: /^[১২৩৪]/i,
  abbreviated: /^[১২৩৪]ত্রৈ/i,
  wide: /^[১২৩৪](ম|য়|র্থ)? ত্রৈমাসিক/i
}, jze = {
  any: [/১/i, /২/i, /৩/i, /৪/i]
}, Ize = {
  narrow: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
  abbreviated: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
  wide: /^(জানুয়ারি|ফেব্রুয়ারি|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্টেম্বর|অক্টোবর|নভেম্বর|ডিসেম্বর)/i
}, Lze = {
  any: [
    /^জানু/i,
    /^ফেব্রু/i,
    /^মার্চ/i,
    /^এপ্রিল/i,
    /^মে/i,
    /^জুন/i,
    /^জুলাই/i,
    /^আগস্ট/i,
    /^সেপ্ট/i,
    /^অক্টো/i,
    /^নভে/i,
    /^ডিসে/i
  ]
}, Hze = {
  narrow: /^(র|সো|ম|বু|বৃ|শু|শ)+/i,
  short: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
  abbreviated: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
  wide: /^(রবিবার|সোমবার|মঙ্গলবার|বুধবার|বৃহস্পতিবার |শুক্রবার|শনিবার)+/i
}, Fze = {
  narrow: [/^র/i, /^সো/i, /^ম/i, /^বু/i, /^বৃ/i, /^শু/i, /^শ/i],
  short: [/^রবি/i, /^সোম/i, /^মঙ্গল/i, /^বুধ/i, /^বৃহ/i, /^শুক্র/i, /^শনি/i],
  abbreviated: [
    /^রবি/i,
    /^সোম/i,
    /^মঙ্গল/i,
    /^বুধ/i,
    /^বৃহ/i,
    /^শুক্র/i,
    /^শনি/i
  ],
  wide: [
    /^রবিবার/i,
    /^সোমবার/i,
    /^মঙ্গলবার/i,
    /^বুধবার/i,
    /^বৃহস্পতিবার /i,
    /^শুক্রবার/i,
    /^শনিবার/i
  ]
}, Wze = {
  narrow: /^(পূ|অপ|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
  abbreviated: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
  wide: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i
}, Vze = {
  any: {
    am: /^পূ/i,
    pm: /^অপ/i,
    midnight: /^মধ্যরাত/i,
    noon: /^মধ্যাহ্ন/i,
    morning: /সকাল/i,
    afternoon: /বিকাল/i,
    evening: /সন্ধ্যা/i,
    night: /রাত/i
  }
}, _ze = {
  ordinalNumber: Fn({
    matchPattern: Aze,
    parsePattern: Nze,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: Dze,
    defaultMatchWidth: "wide",
    parsePatterns: $ze,
    defaultParseWidth: "wide"
  }),
  quarter: Ee({
    matchPatterns: zze,
    defaultMatchWidth: "wide",
    parsePatterns: jze,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: Ize,
    defaultMatchWidth: "wide",
    parsePatterns: Lze,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: Hze,
    defaultMatchWidth: "wide",
    parsePatterns: Fze,
    defaultParseWidth: "wide"
  }),
  dayPeriod: Ee({
    matchPatterns: Wze,
    defaultMatchWidth: "wide",
    parsePatterns: Vze,
    defaultParseWidth: "any"
  })
}, Bze = {
  code: "bn",
  formatDistance: Eze,
  formatLong: Oze,
  formatRelative: Rze,
  localize: Cze,
  match: _ze,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, Uze = {
  lessThanXSeconds: {
    one: {
      standalone: "manje od 1 sekunde",
      withPrepositionAgo: "manje od 1 sekunde",
      withPrepositionIn: "manje od 1 sekundu"
    },
    dual: "manje od {{count}} sekunde",
    other: "manje od {{count}} sekundi"
  },
  xSeconds: {
    one: {
      standalone: "1 sekunda",
      withPrepositionAgo: "1 sekunde",
      withPrepositionIn: "1 sekundu"
    },
    dual: "{{count}} sekunde",
    other: "{{count}} sekundi"
  },
  halfAMinute: "pola minute",
  lessThanXMinutes: {
    one: {
      standalone: "manje od 1 minute",
      withPrepositionAgo: "manje od 1 minute",
      withPrepositionIn: "manje od 1 minutu"
    },
    dual: "manje od {{count}} minute",
    other: "manje od {{count}} minuta"
  },
  xMinutes: {
    one: {
      standalone: "1 minuta",
      withPrepositionAgo: "1 minute",
      withPrepositionIn: "1 minutu"
    },
    dual: "{{count}} minute",
    other: "{{count}} minuta"
  },
  aboutXHours: {
    one: {
      standalone: "oko 1 sat",
      withPrepositionAgo: "oko 1 sat",
      withPrepositionIn: "oko 1 sat"
    },
    dual: "oko {{count}} sata",
    other: "oko {{count}} sati"
  },
  xHours: {
    one: {
      standalone: "1 sat",
      withPrepositionAgo: "1 sat",
      withPrepositionIn: "1 sat"
    },
    dual: "{{count}} sata",
    other: "{{count}} sati"
  },
  xDays: {
    one: {
      standalone: "1 dan",
      withPrepositionAgo: "1 dan",
      withPrepositionIn: "1 dan"
    },
    dual: "{{count}} dana",
    other: "{{count}} dana"
  },
  aboutXWeeks: {
    one: {
      standalone: "oko 1 sedmicu",
      withPrepositionAgo: "oko 1 sedmicu",
      withPrepositionIn: "oko 1 sedmicu"
    },
    dual: "oko {{count}} sedmice",
    other: "oko {{count}} sedmice"
  },
  xWeeks: {
    one: {
      standalone: "1 sedmicu",
      withPrepositionAgo: "1 sedmicu",
      withPrepositionIn: "1 sedmicu"
    },
    dual: "{{count}} sedmice",
    other: "{{count}} sedmice"
  },
  aboutXMonths: {
    one: {
      standalone: "oko 1 mjesec",
      withPrepositionAgo: "oko 1 mjesec",
      withPrepositionIn: "oko 1 mjesec"
    },
    dual: "oko {{count}} mjeseca",
    other: "oko {{count}} mjeseci"
  },
  xMonths: {
    one: {
      standalone: "1 mjesec",
      withPrepositionAgo: "1 mjesec",
      withPrepositionIn: "1 mjesec"
    },
    dual: "{{count}} mjeseca",
    other: "{{count}} mjeseci"
  },
  aboutXYears: {
    one: {
      standalone: "oko 1 godinu",
      withPrepositionAgo: "oko 1 godinu",
      withPrepositionIn: "oko 1 godinu"
    },
    dual: "oko {{count}} godine",
    other: "oko {{count}} godina"
  },
  xYears: {
    one: {
      standalone: "1 godina",
      withPrepositionAgo: "1 godine",
      withPrepositionIn: "1 godinu"
    },
    dual: "{{count}} godine",
    other: "{{count}} godina"
  },
  overXYears: {
    one: {
      standalone: "preko 1 godinu",
      withPrepositionAgo: "preko 1 godinu",
      withPrepositionIn: "preko 1 godinu"
    },
    dual: "preko {{count}} godine",
    other: "preko {{count}} godina"
  },
  almostXYears: {
    one: {
      standalone: "gotovo 1 godinu",
      withPrepositionAgo: "gotovo 1 godinu",
      withPrepositionIn: "gotovo 1 godinu"
    },
    dual: "gotovo {{count}} godine",
    other: "gotovo {{count}} godina"
  }
}, Xze = (e, t, r) => {
  let a;
  const i = Uze[e];
  return typeof i == "string" ? a = i : t === 1 ? r?.addSuffix ? r.comparison && r.comparison > 0 ? a = i.one.withPrepositionIn : a = i.one.withPrepositionAgo : a = i.one.standalone : t % 10 > 1 && t % 10 < 5 && // if last digit is between 2 and 4
  String(t).substr(-2, 1) !== "1" ? a = i.dual.replace("{{count}}", String(t)) : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? "za " + a : "prije " + a : a;
}, Gze = {
  full: "EEEE, d. MMMM yyyy.",
  long: "d. MMMM yyyy.",
  medium: "d. MMM yy.",
  short: "dd. MM. yy."
}, qze = {
  full: "HH:mm:ss (zzzz)",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Kze = {
  full: "{{date}} 'u' {{time}}",
  long: "{{date}} 'u' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Yze = {
  date: Ke({
    formats: Gze,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: qze,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: Kze,
    defaultWidth: "full"
  })
}, Qze = {
  lastWeek: (e) => {
    switch (e.getDay()) {
      case 0:
        return "'prošle nedjelje u' p";
      case 3:
        return "'prošle srijede u' p";
      case 6:
        return "'prošle subote u' p";
      default:
        return "'prošli' EEEE 'u' p";
    }
  },
  yesterday: "'juče u' p",
  today: "'danas u' p",
  tomorrow: "'sutra u' p",
  nextWeek: (e) => {
    switch (e.getDay()) {
      case 0:
        return "'sljedeće nedjelje u' p";
      case 3:
        return "'sljedeću srijedu u' p";
      case 6:
        return "'sljedeću subotu u' p";
      default:
        return "'sljedeći' EEEE 'u' p";
    }
  },
  other: "P"
}, Jze = (e, t, r, a) => {
  const i = Qze[e];
  return typeof i == "function" ? i(t) : i;
}, Zze = {
  narrow: ["pr.n.e.", "AD"],
  abbreviated: ["pr. Hr.", "po. Hr."],
  wide: ["Prije Hrista", "Poslije Hrista"]
}, eje = {
  narrow: ["1.", "2.", "3.", "4."],
  abbreviated: ["1. kv.", "2. kv.", "3. kv.", "4. kv."],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, tje = {
  narrow: [
    "1.",
    "2.",
    "3.",
    "4.",
    "5.",
    "6.",
    "7.",
    "8.",
    "9.",
    "10.",
    "11.",
    "12."
  ],
  abbreviated: [
    "jan",
    "feb",
    "mar",
    "apr",
    "maj",
    "jun",
    "jul",
    "avg",
    "sep",
    "okt",
    "nov",
    "dec"
  ],
  wide: [
    "januar",
    "februar",
    "mart",
    "april",
    "maj",
    "juni",
    "juli",
    "avgust",
    "septembar",
    "oktobar",
    "novembar",
    "decembar"
  ]
}, nje = {
  narrow: [
    "1.",
    "2.",
    "3.",
    "4.",
    "5.",
    "6.",
    "7.",
    "8.",
    "9.",
    "10.",
    "11.",
    "12."
  ],
  abbreviated: [
    "jan",
    "feb",
    "mar",
    "apr",
    "maj",
    "jun",
    "jul",
    "avg",
    "sep",
    "okt",
    "nov",
    "dec"
  ],
  wide: [
    "januar",
    "februar",
    "mart",
    "april",
    "maj",
    "juni",
    "juli",
    "avgust",
    "septembar",
    "oktobar",
    "novembar",
    "decembar"
  ]
}, rje = {
  narrow: ["N", "P", "U", "S", "Č", "P", "S"],
  short: ["ned", "pon", "uto", "sre", "čet", "pet", "sub"],
  abbreviated: ["ned", "pon", "uto", "sre", "čet", "pet", "sub"],
  wide: [
    "nedjelja",
    "ponedjeljak",
    "utorak",
    "srijeda",
    "četvrtak",
    "petak",
    "subota"
  ]
}, aje = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "poslije podne",
    evening: "uveče",
    night: "noću"
  }
}, oje = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "poslije podne",
    evening: "uveče",
    night: "noću"
  }
}, ije = (e, t) => {
  const r = Number(e);
  return String(r) + ".";
}, lje = {
  ordinalNumber: ije,
  era: Ce({
    values: Zze,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: eje,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: tje,
    defaultWidth: "wide",
    formattingValues: nje,
    defaultFormattingWidth: "wide"
  }),
  day: Ce({
    values: rje,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: aje,
    defaultWidth: "wide",
    formattingValues: oje,
    defaultFormattingWidth: "wide"
  })
}, sje = /^(\d+)\./i, uje = /\d+/i, cje = {
  narrow: /^(pr\.n\.e\.|AD)/i,
  abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
  wide: /^(Prije Hrista|prije nove ere|Poslije Hrista|nova era)/i
}, dje = {
  any: [/^pr/i, /^(po|nova)/i]
}, fje = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\.\s?kv\.?/i,
  wide: /^[1234]\. kvartal/i
}, mje = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, hje = {
  narrow: /^(10|11|12|[123456789])\./i,
  abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
  wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(juni|juna)|(juli|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
}, pje = {
  narrow: [
    /^1/i,
    /^2/i,
    /^3/i,
    /^4/i,
    /^5/i,
    /^6/i,
    /^7/i,
    /^8/i,
    /^9/i,
    /^10/i,
    /^11/i,
    /^12/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^maj/i,
    /^jun/i,
    /^jul/i,
    /^avg/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, gje = {
  narrow: /^[npusčc]/i,
  short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
  abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
  wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
}, vje = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, bje = {
  any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|poslije podne|ujutru)/i
}, yje = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^pono/i,
    noon: /^pod/i,
    morning: /jutro/i,
    afternoon: /(poslije\s|po)+podne/i,
    evening: /(uvece|uveče)/i,
    night: /(nocu|noću)/i
  }
}, wje = {
  ordinalNumber: Fn({
    matchPattern: sje,
    parsePattern: uje,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: cje,
    defaultMatchWidth: "wide",
    parsePatterns: dje,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: fje,
    defaultMatchWidth: "wide",
    parsePatterns: mje,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: hje,
    defaultMatchWidth: "wide",
    parsePatterns: pje,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: gje,
    defaultMatchWidth: "wide",
    parsePatterns: vje,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: bje,
    defaultMatchWidth: "any",
    parsePatterns: yje,
    defaultParseWidth: "any"
  })
}, Sje = {
  code: "bs",
  formatDistance: Xze,
  formatLong: Yze,
  formatRelative: Jze,
  localize: lje,
  match: wje,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Cje = {
  lessThanXSeconds: {
    one: "menys d'un segon",
    eleven: "menys d'onze segons",
    other: "menys de {{count}} segons"
  },
  xSeconds: {
    one: "1 segon",
    other: "{{count}} segons"
  },
  halfAMinute: "mig minut",
  lessThanXMinutes: {
    one: "menys d'un minut",
    eleven: "menys d'onze minuts",
    other: "menys de {{count}} minuts"
  },
  xMinutes: {
    one: "1 minut",
    other: "{{count}} minuts"
  },
  aboutXHours: {
    one: "aproximadament una hora",
    other: "aproximadament {{count}} hores"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} hores"
  },
  xDays: {
    one: "1 dia",
    other: "{{count}} dies"
  },
  aboutXWeeks: {
    one: "aproximadament una setmana",
    other: "aproximadament {{count}} setmanes"
  },
  xWeeks: {
    one: "1 setmana",
    other: "{{count}} setmanes"
  },
  aboutXMonths: {
    one: "aproximadament un mes",
    other: "aproximadament {{count}} mesos"
  },
  xMonths: {
    one: "1 mes",
    other: "{{count}} mesos"
  },
  aboutXYears: {
    one: "aproximadament un any",
    other: "aproximadament {{count}} anys"
  },
  xYears: {
    one: "1 any",
    other: "{{count}} anys"
  },
  overXYears: {
    one: "més d'un any",
    eleven: "més d'onze anys",
    other: "més de {{count}} anys"
  },
  almostXYears: {
    one: "gairebé un any",
    other: "gairebé {{count}} anys"
  }
}, xje = (e, t, r) => {
  let a;
  const i = Cje[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : t === 11 && i.eleven ? a = i.eleven : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? "en " + a : "fa " + a : a;
}, Eje = {
  full: "EEEE, d 'de' MMMM y",
  long: "d 'de' MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, Pje = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, kje = {
  full: "{{date}} 'a les' {{time}}",
  long: "{{date}} 'a les' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Mje = {
  date: Ke({
    formats: Eje,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: Pje,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: kje,
    defaultWidth: "full"
  })
}, Oje = {
  lastWeek: "'el' eeee 'passat a la' LT",
  yesterday: "'ahir a la' p",
  today: "'avui a la' p",
  tomorrow: "'demà a la' p",
  nextWeek: "eeee 'a la' p",
  other: "P"
}, Tje = {
  lastWeek: "'el' eeee 'passat a les' p",
  yesterday: "'ahir a les' p",
  today: "'avui a les' p",
  tomorrow: "'demà a les' p",
  nextWeek: "eeee 'a les' p",
  other: "P"
}, Rje = (e, t, r, a) => t.getHours() !== 1 ? Tje[e] : Oje[e], Aje = {
  narrow: ["aC", "dC"],
  abbreviated: ["a. de C.", "d. de C."],
  wide: ["abans de Crist", "després de Crist"]
}, Nje = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1r trimestre", "2n trimestre", "3r trimestre", "4t trimestre"]
}, Dje = {
  narrow: [
    "GN",
    "FB",
    "MÇ",
    "AB",
    "MG",
    "JN",
    "JL",
    "AG",
    "ST",
    "OC",
    "NV",
    "DS"
  ],
  /**
   * Les abreviatures dels mesos de l'any es formen seguint una de les normes generals de formació d'abreviatures.
   * S'escriu la primera síl·laba i les consonants de la síl·laba següent anteriors a la primera vocal.
   * Els mesos de març, maig i juny no s'abreugen perquè són paraules d'una sola síl·laba.
   */
  abbreviated: [
    "gen.",
    "febr.",
    "març",
    "abr.",
    "maig",
    "juny",
    "jul.",
    "ag.",
    "set.",
    "oct.",
    "nov.",
    "des."
  ],
  wide: [
    "gener",
    "febrer",
    "març",
    "abril",
    "maig",
    "juny",
    "juliol",
    "agost",
    "setembre",
    "octubre",
    "novembre",
    "desembre"
  ]
}, $je = {
  narrow: ["dg.", "dl.", "dt.", "dm.", "dj.", "dv.", "ds."],
  short: ["dg.", "dl.", "dt.", "dm.", "dj.", "dv.", "ds."],
  abbreviated: ["dg.", "dl.", "dt.", "dm.", "dj.", "dv.", "ds."],
  wide: [
    "diumenge",
    "dilluns",
    "dimarts",
    "dimecres",
    "dijous",
    "divendres",
    "dissabte"
  ]
}, zje = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "mitjanit",
    noon: "migdia",
    morning: "matí",
    afternoon: "tarda",
    evening: "vespre",
    night: "nit"
  },
  abbreviated: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "mitjanit",
    noon: "migdia",
    morning: "matí",
    afternoon: "tarda",
    evening: "vespre",
    night: "nit"
  },
  wide: {
    am: "ante meridiem",
    pm: "post meridiem",
    midnight: "mitjanit",
    noon: "migdia",
    morning: "matí",
    afternoon: "tarda",
    evening: "vespre",
    night: "nit"
  }
}, jje = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "de la mitjanit",
    noon: "del migdia",
    morning: "del matí",
    afternoon: "de la tarda",
    evening: "del vespre",
    night: "de la nit"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "de la mitjanit",
    noon: "del migdia",
    morning: "del matí",
    afternoon: "de la tarda",
    evening: "del vespre",
    night: "de la nit"
  },
  wide: {
    am: "ante meridiem",
    pm: "post meridiem",
    midnight: "de la mitjanit",
    noon: "del migdia",
    morning: "del matí",
    afternoon: "de la tarda",
    evening: "del vespre",
    night: "de la nit"
  }
}, Ije = (e, t) => {
  const r = Number(e), a = r % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return r + "r";
      case 2:
        return r + "n";
      case 3:
        return r + "r";
      case 4:
        return r + "t";
    }
  return r + "è";
}, Lje = {
  ordinalNumber: Ije,
  era: Ce({
    values: Aje,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: Nje,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: Dje,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: $je,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: zje,
    defaultWidth: "wide",
    formattingValues: jje,
    defaultFormattingWidth: "wide"
  })
}, Hje = /^(\d+)(è|r|n|r|t)?/i, Fje = /\d+/i, Wje = {
  narrow: /^(aC|dC)/i,
  abbreviated: /^(a. de C.|d. de C.)/i,
  wide: /^(abans de Crist|despr[eé]s de Crist)/i
}, Vje = {
  narrow: [/^aC/i, /^dC/i],
  abbreviated: [/^(a. de C.)/i, /^(d. de C.)/i],
  wide: [/^(abans de Crist)/i, /^(despr[eé]s de Crist)/i]
}, _je = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](è|r|n|r|t)? trimestre/i
}, Bje = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Uje = {
  narrow: /^(GN|FB|MÇ|AB|MG|JN|JL|AG|ST|OC|NV|DS)/i,
  abbreviated: /^(gen.|febr.|març|abr.|maig|juny|jul.|ag.|set.|oct.|nov.|des.)/i,
  wide: /^(gener|febrer|març|abril|maig|juny|juliol|agost|setembre|octubre|novembre|desembre)/i
}, Xje = {
  narrow: [
    /^GN/i,
    /^FB/i,
    /^MÇ/i,
    /^AB/i,
    /^MG/i,
    /^JN/i,
    /^JL/i,
    /^AG/i,
    /^ST/i,
    /^OC/i,
    /^NV/i,
    /^DS/i
  ],
  abbreviated: [
    /^gen./i,
    /^febr./i,
    /^març/i,
    /^abr./i,
    /^maig/i,
    /^juny/i,
    /^jul./i,
    /^ag./i,
    /^set./i,
    /^oct./i,
    /^nov./i,
    /^des./i
  ],
  wide: [
    /^gener/i,
    /^febrer/i,
    /^març/i,
    /^abril/i,
    /^maig/i,
    /^juny/i,
    /^juliol/i,
    /^agost/i,
    /^setembre/i,
    /^octubre/i,
    /^novembre/i,
    /^desembre/i
  ]
}, Gje = {
  narrow: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
  short: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
  abbreviated: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
  wide: /^(diumenge|dilluns|dimarts|dimecres|dijous|divendres|dissabte)/i
}, qje = {
  narrow: [/^dg./i, /^dl./i, /^dt./i, /^dm./i, /^dj./i, /^dv./i, /^ds./i],
  abbreviated: [/^dg./i, /^dl./i, /^dt./i, /^dm./i, /^dj./i, /^dv./i, /^ds./i],
  wide: [
    /^diumenge/i,
    /^dilluns/i,
    /^dimarts/i,
    /^dimecres/i,
    /^dijous/i,
    /^divendres/i,
    /^disssabte/i
  ]
}, Kje = {
  narrow: /^(a|p|mn|md|(del|de la) (matí|tarda|vespre|nit))/i,
  abbreviated: /^([ap]\.?\s?m\.?|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i,
  wide: /^(ante meridiem|post meridiem|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i
}, Yje = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mitjanit/i,
    noon: /^migdia/i,
    morning: /matí/i,
    afternoon: /tarda/i,
    evening: /vespre/i,
    night: /nit/i
  }
}, Qje = {
  ordinalNumber: Fn({
    matchPattern: Hje,
    parsePattern: Fje,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: Wje,
    defaultMatchWidth: "wide",
    parsePatterns: Vje,
    defaultParseWidth: "wide"
  }),
  quarter: Ee({
    matchPatterns: _je,
    defaultMatchWidth: "wide",
    parsePatterns: Bje,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: Uje,
    defaultMatchWidth: "wide",
    parsePatterns: Xje,
    defaultParseWidth: "wide"
  }),
  day: Ee({
    matchPatterns: Gje,
    defaultMatchWidth: "wide",
    parsePatterns: qje,
    defaultParseWidth: "wide"
  }),
  dayPeriod: Ee({
    matchPatterns: Kje,
    defaultMatchWidth: "wide",
    parsePatterns: Yje,
    defaultParseWidth: "any"
  })
}, Jje = {
  code: "ca",
  formatDistance: xje,
  formatLong: Mje,
  formatRelative: Rje,
  localize: Lje,
  match: Qje,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Zje = {
  lessThanXSeconds: {
    one: "کەمتر لە یەک چرکە",
    other: "کەمتر لە {{count}} چرکە"
  },
  xSeconds: {
    one: "1 چرکە",
    other: "{{count}} چرکە"
  },
  halfAMinute: "نیو کاتژمێر",
  lessThanXMinutes: {
    one: "کەمتر لە یەک خولەک",
    other: "کەمتر لە {{count}} خولەک"
  },
  xMinutes: {
    one: "1 خولەک",
    other: "{{count}} خولەک"
  },
  aboutXHours: {
    one: "دەوروبەری 1 کاتژمێر",
    other: "دەوروبەری {{count}} کاتژمێر"
  },
  xHours: {
    one: "1 کاتژمێر",
    other: "{{count}} کاتژمێر"
  },
  xDays: {
    one: "1 ڕۆژ",
    other: "{{count}} ژۆژ"
  },
  aboutXWeeks: {
    one: "دەوروبەری 1 هەفتە",
    other: "دوروبەری {{count}} هەفتە"
  },
  xWeeks: {
    one: "1 هەفتە",
    other: "{{count}} هەفتە"
  },
  aboutXMonths: {
    one: "داوروبەری 1 مانگ",
    other: "دەوروبەری {{count}} مانگ"
  },
  xMonths: {
    one: "1 مانگ",
    other: "{{count}} مانگ"
  },
  aboutXYears: {
    one: "دەوروبەری  1 ساڵ",
    other: "دەوروبەری {{count}} ساڵ"
  },
  xYears: {
    one: "1 ساڵ",
    other: "{{count}} ساڵ"
  },
  overXYears: {
    one: "زیاتر لە ساڵێک",
    other: "زیاتر لە {{count}} ساڵ"
  },
  almostXYears: {
    one: "بەنزیکەیی ساڵێک  ",
    other: "بەنزیکەیی {{count}} ساڵ"
  }
}, eIe = (e, t, r) => {
  let a;
  const i = Zje[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", t.toString()), r?.addSuffix ? r.comparison && r.comparison > 0 ? "لە ماوەی " + a + "دا" : a + "پێش ئێستا" : a;
}, tIe = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, nIe = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, rIe = {
  full: "{{date}} 'کاتژمێر' {{time}}",
  long: "{{date}} 'کاتژمێر' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, aIe = {
  date: Ke({
    formats: tIe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: nIe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: rIe,
    defaultWidth: "full"
  })
}, oIe = {
  lastWeek: "'هەفتەی ڕابردوو' eeee 'کاتژمێر' p",
  yesterday: "'دوێنێ کاتژمێر' p",
  today: "'ئەمڕۆ کاتژمێر' p",
  tomorrow: "'بەیانی کاتژمێر' p",
  nextWeek: "eeee 'کاتژمێر' p",
  other: "P"
}, iIe = (e, t, r, a) => oIe[e], lIe = {
  narrow: ["پ", "د"],
  abbreviated: ["پ-ز", "د-ز"],
  wide: ["پێش زاین", "دوای زاین"]
}, sIe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["چ1م", "چ2م", "چ3م", "چ4م"],
  wide: ["چارەگی یەکەم", "چارەگی دووەم", "چارەگی سێیەم", "چارەگی چوارەم"]
}, uIe = {
  narrow: [
    "ک-د",
    "ش",
    "ئا",
    "ن",
    "م",
    "ح",
    "ت",
    "ئا",
    "ئە",
    "تش-ی",
    "تش-د",
    "ک-ی"
  ],
  abbreviated: [
    "کان-دوو",
    "شوب",
    "ئاد",
    "نیس",
    "مایس",
    "حوز",
    "تەم",
    "ئاب",
    "ئەل",
    "تش-یەک",
    "تش-دوو",
    "کان-یەک"
  ],
  wide: [
    "کانوونی دووەم",
    "شوبات",
    "ئادار",
    "نیسان",
    "مایس",
    "حوزەیران",
    "تەمموز",
    "ئاب",
    "ئەیلول",
    "تشرینی یەکەم",
    "تشرینی دووەم",
    "کانوونی یەکەم"
  ]
}, cIe = {
  narrow: ["ی-ش", "د-ش", "س-ش", "چ-ش", "پ-ش", "هە", "ش"],
  short: ["یە-شە", "دوو-شە", "سێ-شە", "چو-شە", "پێ-شە", "هەی", "شە"],
  abbreviated: [
    "یەک-شەم",
    "دوو-شەم",
    "سێ-شەم",
    "چوار-شەم",
    "پێنج-شەم",
    "هەینی",
    "شەمە"
  ],
  wide: [
    "یەک شەمە",
    "دوو شەمە",
    "سێ شەمە",
    "چوار شەمە",
    "پێنج شەمە",
    "هەینی",
    "شەمە"
  ]
}, dIe = {
  narrow: {
    am: "پ",
    pm: "د",
    midnight: "ن-ش",
    noon: "ن",
    morning: "بەیانی",
    afternoon: "دوای نیوەڕۆ",
    evening: "ئێوارە",
    night: "شەو"
  },
  abbreviated: {
    am: "پ-ن",
    pm: "د-ن",
    midnight: "نیوە شەو",
    noon: "نیوەڕۆ",
    morning: "بەیانی",
    afternoon: "دوای نیوەڕۆ",
    evening: "ئێوارە",
    night: "شەو"
  },
  wide: {
    am: "پێش نیوەڕۆ",
    pm: "دوای نیوەڕۆ",
    midnight: "نیوە شەو",
    noon: "نیوەڕۆ",
    morning: "بەیانی",
    afternoon: "دوای نیوەڕۆ",
    evening: "ئێوارە",
    night: "شەو"
  }
}, fIe = {
  narrow: {
    am: "پ",
    pm: "د",
    midnight: "ن-ش",
    noon: "ن",
    morning: "لە بەیانیدا",
    afternoon: "لە دوای نیوەڕۆدا",
    evening: "لە ئێوارەدا",
    night: "لە شەودا"
  },
  abbreviated: {
    am: "پ-ن",
    pm: "د-ن",
    midnight: "نیوە شەو",
    noon: "نیوەڕۆ",
    morning: "لە بەیانیدا",
    afternoon: "لە دوای نیوەڕۆدا",
    evening: "لە ئێوارەدا",
    night: "لە شەودا"
  },
  wide: {
    am: "پێش نیوەڕۆ",
    pm: "دوای نیوەڕۆ",
    midnight: "نیوە شەو",
    noon: "نیوەڕۆ",
    morning: "لە بەیانیدا",
    afternoon: "لە دوای نیوەڕۆدا",
    evening: "لە ئێوارەدا",
    night: "لە شەودا"
  }
}, mIe = (e, t) => String(e), hIe = {
  ordinalNumber: mIe,
  era: Ce({
    values: lIe,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: sIe,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: uIe,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: cIe,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: dIe,
    defaultWidth: "wide",
    formattingValues: fIe,
    defaultFormattingWidth: "wide"
  })
}, pIe = /^(\d+)(th|st|nd|rd)?/i, gIe = /\d+/i, vIe = {
  narrow: /^(پ|د)/i,
  abbreviated: /^(پ-ز|د.ز)/i,
  wide: /^(پێش زاین| دوای زاین)/i
}, bIe = {
  any: [/^د/g, /^پ/g]
}, yIe = {
  narrow: /^[1234]/i,
  abbreviated: /^م[1234]چ/i,
  wide: /^(یەکەم|دووەم|سێیەم| چوارەم) (چارەگی)? quarter/i
}, wIe = {
  wide: [/چارەگی یەکەم/, /چارەگی دووەم/, /چارەگی سيیەم/, /چارەگی چوارەم/],
  any: [/1/i, /2/i, /3/i, /4/i]
}, SIe = {
  narrow: /^(ک-د|ش|ئا|ن|م|ح|ت|ئە|تش-ی|تش-د|ک-ی)/i,
  abbreviated: /^(کان-دوو|شوب|ئاد|نیس|مایس|حوز|تەم|ئاب|ئەل|تش-یەک|تش-دوو|کان-یەک)/i,
  wide: /^(کانوونی دووەم|شوبات|ئادار|نیسان|مایس|حوزەیران|تەمموز|ئاب|ئەیلول|تشرینی یەکەم|تشرینی دووەم|کانوونی یەکەم)/i
}, CIe = {
  narrow: [
    /^ک-د/i,
    /^ش/i,
    /^ئا/i,
    /^ن/i,
    /^م/i,
    /^ح/i,
    /^ت/i,
    /^ئا/i,
    /^ئە/i,
    /^تش-ی/i,
    /^تش-د/i,
    /^ک-ی/i
  ],
  any: [
    /^کان-دوو/i,
    /^شوب/i,
    /^ئاد/i,
    /^نیس/i,
    /^مایس/i,
    /^حوز/i,
    /^تەم/i,
    /^ئاب/i,
    /^ئەل/i,
    /^تش-یەک/i,
    /^تش-دوو/i,
    /^|کان-یەک/i
  ]
}, xIe = {
  narrow: /^(ش|ی|د|س|چ|پ|هە)/i,
  short: /^(یە-شە|دوو-شە|سێ-شە|چو-شە|پێ-شە|هە|شە)/i,
  abbreviated: /^(یەک-شەم|دوو-شەم|سێ-شەم|چوار-شەم|پێنخ-شەم|هەینی|شەمە)/i,
  wide: /^(یەک شەمە|دوو شەمە|سێ شەمە|چوار شەمە|پێنج شەمە|هەینی|شەمە)/i
}, EIe = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, PIe = {
  narrow: /^(پ|د|ن-ش|ن| (بەیانی|دوای نیوەڕۆ|ئێوارە|شەو))/i,
  abbreviated: /^(پ-ن|د-ن|نیوە شەو|نیوەڕۆ|بەیانی|دوای نیوەڕۆ|ئێوارە|شەو)/,
  wide: /^(پێش نیوەڕۆ|دوای نیوەڕۆ|نیوەڕۆ|نیوە شەو|لەبەیانیدا|لەدواینیوەڕۆدا|لە ئێوارەدا|لە شەودا)/,
  any: /^(پ|د|بەیانی|نیوەڕۆ|ئێوارە|شەو)/
}, kIe = {
  any: {
    am: /^د/i,
    pm: /^پ/i,
    midnight: /^ن-ش/i,
    noon: /^ن/i,
    morning: /بەیانی/i,
    afternoon: /دواینیوەڕۆ/i,
    evening: /ئێوارە/i,
    night: /شەو/i
  }
}, MIe = {
  ordinalNumber: Fn({
    matchPattern: pIe,
    parsePattern: gIe,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: vIe,
    defaultMatchWidth: "wide",
    parsePatterns: bIe,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: yIe,
    defaultMatchWidth: "wide",
    parsePatterns: wIe,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: SIe,
    defaultMatchWidth: "wide",
    parsePatterns: CIe,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: xIe,
    defaultMatchWidth: "wide",
    parsePatterns: EIe,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: PIe,
    defaultMatchWidth: "any",
    parsePatterns: kIe,
    defaultParseWidth: "any"
  })
}, OIe = {
  code: "ckb",
  formatDistance: eIe,
  formatLong: aIe,
  formatRelative: iIe,
  localize: hIe,
  match: MIe,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, TIe = {
  lessThanXSeconds: {
    one: {
      regular: "méně než 1 sekunda",
      past: "před méně než 1 sekundou",
      future: "za méně než 1 sekundu"
    },
    few: {
      regular: "méně než {{count}} sekundy",
      past: "před méně než {{count}} sekundami",
      future: "za méně než {{count}} sekundy"
    },
    many: {
      regular: "méně než {{count}} sekund",
      past: "před méně než {{count}} sekundami",
      future: "za méně než {{count}} sekund"
    }
  },
  xSeconds: {
    one: {
      regular: "1 sekunda",
      past: "před 1 sekundou",
      future: "za 1 sekundu"
    },
    few: {
      regular: "{{count}} sekundy",
      past: "před {{count}} sekundami",
      future: "za {{count}} sekundy"
    },
    many: {
      regular: "{{count}} sekund",
      past: "před {{count}} sekundami",
      future: "za {{count}} sekund"
    }
  },
  halfAMinute: {
    type: "other",
    other: {
      regular: "půl minuty",
      past: "před půl minutou",
      future: "za půl minuty"
    }
  },
  lessThanXMinutes: {
    one: {
      regular: "méně než 1 minuta",
      past: "před méně než 1 minutou",
      future: "za méně než 1 minutu"
    },
    few: {
      regular: "méně než {{count}} minuty",
      past: "před méně než {{count}} minutami",
      future: "za méně než {{count}} minuty"
    },
    many: {
      regular: "méně než {{count}} minut",
      past: "před méně než {{count}} minutami",
      future: "za méně než {{count}} minut"
    }
  },
  xMinutes: {
    one: {
      regular: "1 minuta",
      past: "před 1 minutou",
      future: "za 1 minutu"
    },
    few: {
      regular: "{{count}} minuty",
      past: "před {{count}} minutami",
      future: "za {{count}} minuty"
    },
    many: {
      regular: "{{count}} minut",
      past: "před {{count}} minutami",
      future: "za {{count}} minut"
    }
  },
  aboutXHours: {
    one: {
      regular: "přibližně 1 hodina",
      past: "přibližně před 1 hodinou",
      future: "přibližně za 1 hodinu"
    },
    few: {
      regular: "přibližně {{count}} hodiny",
      past: "přibližně před {{count}} hodinami",
      future: "přibližně za {{count}} hodiny"
    },
    many: {
      regular: "přibližně {{count}} hodin",
      past: "přibližně před {{count}} hodinami",
      future: "přibližně za {{count}} hodin"
    }
  },
  xHours: {
    one: {
      regular: "1 hodina",
      past: "před 1 hodinou",
      future: "za 1 hodinu"
    },
    few: {
      regular: "{{count}} hodiny",
      past: "před {{count}} hodinami",
      future: "za {{count}} hodiny"
    },
    many: {
      regular: "{{count}} hodin",
      past: "před {{count}} hodinami",
      future: "za {{count}} hodin"
    }
  },
  xDays: {
    one: {
      regular: "1 den",
      past: "před 1 dnem",
      future: "za 1 den"
    },
    few: {
      regular: "{{count}} dny",
      past: "před {{count}} dny",
      future: "za {{count}} dny"
    },
    many: {
      regular: "{{count}} dní",
      past: "před {{count}} dny",
      future: "za {{count}} dní"
    }
  },
  aboutXWeeks: {
    one: {
      regular: "přibližně 1 týden",
      past: "přibližně před 1 týdnem",
      future: "přibližně za 1 týden"
    },
    few: {
      regular: "přibližně {{count}} týdny",
      past: "přibližně před {{count}} týdny",
      future: "přibližně za {{count}} týdny"
    },
    many: {
      regular: "přibližně {{count}} týdnů",
      past: "přibližně před {{count}} týdny",
      future: "přibližně za {{count}} týdnů"
    }
  },
  xWeeks: {
    one: {
      regular: "1 týden",
      past: "před 1 týdnem",
      future: "za 1 týden"
    },
    few: {
      regular: "{{count}} týdny",
      past: "před {{count}} týdny",
      future: "za {{count}} týdny"
    },
    many: {
      regular: "{{count}} týdnů",
      past: "před {{count}} týdny",
      future: "za {{count}} týdnů"
    }
  },
  aboutXMonths: {
    one: {
      regular: "přibližně 1 měsíc",
      past: "přibližně před 1 měsícem",
      future: "přibližně za 1 měsíc"
    },
    few: {
      regular: "přibližně {{count}} měsíce",
      past: "přibližně před {{count}} měsíci",
      future: "přibližně za {{count}} měsíce"
    },
    many: {
      regular: "přibližně {{count}} měsíců",
      past: "přibližně před {{count}} měsíci",
      future: "přibližně za {{count}} měsíců"
    }
  },
  xMonths: {
    one: {
      regular: "1 měsíc",
      past: "před 1 měsícem",
      future: "za 1 měsíc"
    },
    few: {
      regular: "{{count}} měsíce",
      past: "před {{count}} měsíci",
      future: "za {{count}} měsíce"
    },
    many: {
      regular: "{{count}} měsíců",
      past: "před {{count}} měsíci",
      future: "za {{count}} měsíců"
    }
  },
  aboutXYears: {
    one: {
      regular: "přibližně 1 rok",
      past: "přibližně před 1 rokem",
      future: "přibližně za 1 rok"
    },
    few: {
      regular: "přibližně {{count}} roky",
      past: "přibližně před {{count}} roky",
      future: "přibližně za {{count}} roky"
    },
    many: {
      regular: "přibližně {{count}} roků",
      past: "přibližně před {{count}} roky",
      future: "přibližně za {{count}} roků"
    }
  },
  xYears: {
    one: {
      regular: "1 rok",
      past: "před 1 rokem",
      future: "za 1 rok"
    },
    few: {
      regular: "{{count}} roky",
      past: "před {{count}} roky",
      future: "za {{count}} roky"
    },
    many: {
      regular: "{{count}} roků",
      past: "před {{count}} roky",
      future: "za {{count}} roků"
    }
  },
  overXYears: {
    one: {
      regular: "více než 1 rok",
      past: "před více než 1 rokem",
      future: "za více než 1 rok"
    },
    few: {
      regular: "více než {{count}} roky",
      past: "před více než {{count}} roky",
      future: "za více než {{count}} roky"
    },
    many: {
      regular: "více než {{count}} roků",
      past: "před více než {{count}} roky",
      future: "za více než {{count}} roků"
    }
  },
  almostXYears: {
    one: {
      regular: "skoro 1 rok",
      past: "skoro před 1 rokem",
      future: "skoro za 1 rok"
    },
    few: {
      regular: "skoro {{count}} roky",
      past: "skoro před {{count}} roky",
      future: "skoro za {{count}} roky"
    },
    many: {
      regular: "skoro {{count}} roků",
      past: "skoro před {{count}} roky",
      future: "skoro za {{count}} roků"
    }
  }
}, RIe = (e, t, r) => {
  let a;
  const i = TIe[e];
  i.type === "other" ? a = i.other : t === 1 ? a = i.one : t > 1 && t < 5 ? a = i.few : a = i.many;
  const c = r?.addSuffix === !0, d = r?.comparison;
  let f;
  return c && d === -1 ? f = a.past : c && d === 1 ? f = a.future : f = a.regular, f.replace("{{count}}", String(t));
}, AIe = {
  full: "EEEE, d. MMMM yyyy",
  long: "d. MMMM yyyy",
  medium: "d. M. yyyy",
  short: "dd.MM.yyyy"
}, NIe = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, DIe = {
  full: "{{date}} 'v' {{time}}",
  long: "{{date}} 'v' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, $Ie = {
  date: Ke({
    formats: AIe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: NIe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: DIe,
    defaultWidth: "full"
  })
}, zIe = [
  "neděli",
  "pondělí",
  "úterý",
  "středu",
  "čtvrtek",
  "pátek",
  "sobotu"
], jIe = {
  lastWeek: "'poslední' eeee 've' p",
  yesterday: "'včera v' p",
  today: "'dnes v' p",
  tomorrow: "'zítra v' p",
  nextWeek: (e) => {
    const t = e.getDay();
    return "'v " + zIe[t] + " o' p";
  },
  other: "P"
}, IIe = (e, t) => {
  const r = jIe[e];
  return typeof r == "function" ? r(t) : r;
}, LIe = {
  narrow: ["př. n. l.", "n. l."],
  abbreviated: ["př. n. l.", "n. l."],
  wide: ["před naším letopočtem", "našeho letopočtu"]
}, HIe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. čtvrtletí", "2. čtvrtletí", "3. čtvrtletí", "4. čtvrtletí"],
  wide: ["1. čtvrtletí", "2. čtvrtletí", "3. čtvrtletí", "4. čtvrtletí"]
}, FIe = {
  narrow: ["L", "Ú", "B", "D", "K", "Č", "Č", "S", "Z", "Ř", "L", "P"],
  abbreviated: [
    "led",
    "úno",
    "bře",
    "dub",
    "kvě",
    "čvn",
    "čvc",
    "srp",
    "zář",
    "říj",
    "lis",
    "pro"
  ],
  wide: [
    "leden",
    "únor",
    "březen",
    "duben",
    "květen",
    "červen",
    "červenec",
    "srpen",
    "září",
    "říjen",
    "listopad",
    "prosinec"
  ]
}, WIe = {
  narrow: ["L", "Ú", "B", "D", "K", "Č", "Č", "S", "Z", "Ř", "L", "P"],
  abbreviated: [
    "led",
    "úno",
    "bře",
    "dub",
    "kvě",
    "čvn",
    "čvc",
    "srp",
    "zář",
    "říj",
    "lis",
    "pro"
  ],
  wide: [
    "ledna",
    "února",
    "března",
    "dubna",
    "května",
    "června",
    "července",
    "srpna",
    "září",
    "října",
    "listopadu",
    "prosince"
  ]
}, VIe = {
  narrow: ["ne", "po", "út", "st", "čt", "pá", "so"],
  short: ["ne", "po", "út", "st", "čt", "pá", "so"],
  abbreviated: ["ned", "pon", "úte", "stř", "čtv", "pát", "sob"],
  wide: ["neděle", "pondělí", "úterý", "středa", "čtvrtek", "pátek", "sobota"]
}, _Ie = {
  narrow: {
    am: "dop.",
    pm: "odp.",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  },
  abbreviated: {
    am: "dop.",
    pm: "odp.",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  },
  wide: {
    am: "dopoledne",
    pm: "odpoledne",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  }
}, BIe = {
  narrow: {
    am: "dop.",
    pm: "odp.",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  },
  abbreviated: {
    am: "dop.",
    pm: "odp.",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  },
  wide: {
    am: "dopoledne",
    pm: "odpoledne",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  }
}, UIe = (e, t) => Number(e) + ".", XIe = {
  ordinalNumber: UIe,
  era: Ce({
    values: LIe,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: HIe,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: FIe,
    defaultWidth: "wide",
    formattingValues: WIe,
    defaultFormattingWidth: "wide"
  }),
  day: Ce({
    values: VIe,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: _Ie,
    defaultWidth: "wide",
    formattingValues: BIe,
    defaultFormattingWidth: "wide"
  })
}, GIe = /^(\d+)\.?/i, qIe = /\d+/i, KIe = {
  narrow: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
  abbreviated: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
  wide: /^(p[řr](\.|ed) Kristem|p[řr](\.|ed) na[šs][íi]m letopo[čc]tem|po Kristu|na[šs]eho letopo[čc]tu)/i
}, YIe = {
  any: [/^p[řr]/i, /^(po|n)/i]
}, QIe = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\. [čc]tvrtlet[íi]/i,
  wide: /^[1234]\. [čc]tvrtlet[íi]/i
}, JIe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, ZIe = {
  narrow: /^[lúubdkčcszřrlp]/i,
  abbreviated: /^(led|[úu]no|b[řr]e|dub|kv[ěe]|[čc]vn|[čc]vc|srp|z[áa][řr]|[řr][íi]j|lis|pro)/i,
  wide: /^(leden|ledna|[úu]nora?|b[řr]ezen|b[řr]ezna|duben|dubna|kv[ěe]ten|kv[ěe]tna|[čc]erven(ec|ce)?|[čc]ervna|srpen|srpna|z[áa][řr][íi]|[řr][íi]jen|[řr][íi]jna|listopad(a|u)?|prosinec|prosince)/i
}, eLe = {
  narrow: [
    /^l/i,
    /^[úu]/i,
    /^b/i,
    /^d/i,
    /^k/i,
    /^[čc]/i,
    /^[čc]/i,
    /^s/i,
    /^z/i,
    /^[řr]/i,
    /^l/i,
    /^p/i
  ],
  any: [
    /^led/i,
    /^[úu]n/i,
    /^b[řr]e/i,
    /^dub/i,
    /^kv[ěe]/i,
    /^[čc]vn|[čc]erven(?!\w)|[čc]ervna/i,
    /^[čc]vc|[čc]erven(ec|ce)/i,
    /^srp/i,
    /^z[áa][řr]/i,
    /^[řr][íi]j/i,
    /^lis/i,
    /^pro/i
  ]
}, tLe = {
  narrow: /^[npuúsčps]/i,
  short: /^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
  abbreviated: /^(ned|pon|[úu]te|st[rř]|[čc]tv|p[áa]t|sob)/i,
  wide: /^(ned[ěe]le|pond[ěe]l[íi]|[úu]ter[ýy]|st[řr]eda|[čc]tvrtek|p[áa]tek|sobota)/i
}, nLe = {
  narrow: [/^n/i, /^p/i, /^[úu]/i, /^s/i, /^[čc]/i, /^p/i, /^s/i],
  any: [/^ne/i, /^po/i, /^[úu]t/i, /^st/i, /^[čc]t/i, /^p[áa]/i, /^so/i]
}, rLe = {
  any: /^dopoledne|dop\.?|odpoledne|odp\.?|p[ůu]lnoc|poledne|r[áa]no|odpoledne|ve[čc]er|(v )?noci?/i
}, aLe = {
  any: {
    am: /^dop/i,
    pm: /^odp/i,
    midnight: /^p[ůu]lnoc/i,
    noon: /^poledne/i,
    morning: /r[áa]no/i,
    afternoon: /odpoledne/i,
    evening: /ve[čc]er/i,
    night: /noc/i
  }
}, oLe = {
  ordinalNumber: Fn({
    matchPattern: GIe,
    parsePattern: qIe,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: KIe,
    defaultMatchWidth: "wide",
    parsePatterns: YIe,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: QIe,
    defaultMatchWidth: "wide",
    parsePatterns: JIe,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: ZIe,
    defaultMatchWidth: "wide",
    parsePatterns: eLe,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: tLe,
    defaultMatchWidth: "wide",
    parsePatterns: nLe,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: rLe,
    defaultMatchWidth: "any",
    parsePatterns: aLe,
    defaultParseWidth: "any"
  })
}, iLe = {
  code: "cs",
  formatDistance: RIe,
  formatLong: $Ie,
  formatRelative: IIe,
  localize: XIe,
  match: oLe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, lLe = {
  lessThanXSeconds: {
    one: "llai na eiliad",
    other: "llai na {{count}} eiliad"
  },
  xSeconds: {
    one: "1 eiliad",
    other: "{{count}} eiliad"
  },
  halfAMinute: "hanner munud",
  lessThanXMinutes: {
    one: "llai na munud",
    two: "llai na 2 funud",
    other: "llai na {{count}} munud"
  },
  xMinutes: {
    one: "1 munud",
    two: "2 funud",
    other: "{{count}} munud"
  },
  aboutXHours: {
    one: "tua 1 awr",
    other: "tua {{count}} awr"
  },
  xHours: {
    one: "1 awr",
    other: "{{count}} awr"
  },
  xDays: {
    one: "1 diwrnod",
    two: "2 ddiwrnod",
    other: "{{count}} diwrnod"
  },
  aboutXWeeks: {
    one: "tua 1 wythnos",
    two: "tua pythefnos",
    other: "tua {{count}} wythnos"
  },
  xWeeks: {
    one: "1 wythnos",
    two: "pythefnos",
    other: "{{count}} wythnos"
  },
  aboutXMonths: {
    one: "tua 1 mis",
    two: "tua 2 fis",
    other: "tua {{count}} mis"
  },
  xMonths: {
    one: "1 mis",
    two: "2 fis",
    other: "{{count}} mis"
  },
  aboutXYears: {
    one: "tua 1 flwyddyn",
    two: "tua 2 flynedd",
    other: "tua {{count}} mlynedd"
  },
  xYears: {
    one: "1 flwyddyn",
    two: "2 flynedd",
    other: "{{count}} mlynedd"
  },
  overXYears: {
    one: "dros 1 flwyddyn",
    two: "dros 2 flynedd",
    other: "dros {{count}} mlynedd"
  },
  almostXYears: {
    one: "bron 1 flwyddyn",
    two: "bron 2 flynedd",
    other: "bron {{count}} mlynedd"
  }
}, sLe = (e, t, r) => {
  let a;
  const i = lLe[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : t === 2 && i.two ? a = i.two : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? "mewn " + a : a + " yn ôl" : a;
}, uLe = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, cLe = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, dLe = {
  full: "{{date}} 'am' {{time}}",
  long: "{{date}} 'am' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, fLe = {
  date: Ke({
    formats: uLe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: cLe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: dLe,
    defaultWidth: "full"
  })
}, mLe = {
  lastWeek: "eeee 'diwethaf am' p",
  yesterday: "'ddoe am' p",
  today: "'heddiw am' p",
  tomorrow: "'yfory am' p",
  nextWeek: "eeee 'am' p",
  other: "P"
}, hLe = (e, t, r, a) => mLe[e], pLe = {
  narrow: ["C", "O"],
  abbreviated: ["CC", "OC"],
  wide: ["Cyn Crist", "Ar ôl Crist"]
}, gLe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Ch1", "Ch2", "Ch3", "Ch4"],
  wide: ["Chwarter 1af", "2ail chwarter", "3ydd chwarter", "4ydd chwarter"]
}, vLe = {
  narrow: ["I", "Ch", "Ma", "E", "Mi", "Me", "G", "A", "Md", "H", "T", "Rh"],
  abbreviated: [
    "Ion",
    "Chwe",
    "Maw",
    "Ebr",
    "Mai",
    "Meh",
    "Gor",
    "Aws",
    "Med",
    "Hyd",
    "Tach",
    "Rhag"
  ],
  wide: [
    "Ionawr",
    "Chwefror",
    "Mawrth",
    "Ebrill",
    "Mai",
    "Mehefin",
    "Gorffennaf",
    "Awst",
    "Medi",
    "Hydref",
    "Tachwedd",
    "Rhagfyr"
  ]
}, bLe = {
  narrow: ["S", "Ll", "M", "M", "I", "G", "S"],
  short: ["Su", "Ll", "Ma", "Me", "Ia", "Gw", "Sa"],
  abbreviated: ["Sul", "Llun", "Maw", "Mer", "Iau", "Gwe", "Sad"],
  wide: [
    "dydd Sul",
    "dydd Llun",
    "dydd Mawrth",
    "dydd Mercher",
    "dydd Iau",
    "dydd Gwener",
    "dydd Sadwrn"
  ]
}, yLe = {
  narrow: {
    am: "b",
    pm: "h",
    midnight: "hn",
    noon: "hd",
    morning: "bore",
    afternoon: "prynhawn",
    evening: "gyda'r nos",
    night: "nos"
  },
  abbreviated: {
    am: "yb",
    pm: "yh",
    midnight: "hanner nos",
    noon: "hanner dydd",
    morning: "bore",
    afternoon: "prynhawn",
    evening: "gyda'r nos",
    night: "nos"
  },
  wide: {
    am: "y.b.",
    pm: "y.h.",
    midnight: "hanner nos",
    noon: "hanner dydd",
    morning: "bore",
    afternoon: "prynhawn",
    evening: "gyda'r nos",
    night: "nos"
  }
}, wLe = {
  narrow: {
    am: "b",
    pm: "h",
    midnight: "hn",
    noon: "hd",
    morning: "yn y bore",
    afternoon: "yn y prynhawn",
    evening: "gyda'r nos",
    night: "yn y nos"
  },
  abbreviated: {
    am: "yb",
    pm: "yh",
    midnight: "hanner nos",
    noon: "hanner dydd",
    morning: "yn y bore",
    afternoon: "yn y prynhawn",
    evening: "gyda'r nos",
    night: "yn y nos"
  },
  wide: {
    am: "y.b.",
    pm: "y.h.",
    midnight: "hanner nos",
    noon: "hanner dydd",
    morning: "yn y bore",
    afternoon: "yn y prynhawn",
    evening: "gyda'r nos",
    night: "yn y nos"
  }
}, SLe = (e, t) => {
  const r = Number(e);
  if (r < 20)
    switch (r) {
      case 0:
        return r + "fed";
      case 1:
        return r + "af";
      case 2:
        return r + "ail";
      case 3:
      case 4:
        return r + "ydd";
      case 5:
      case 6:
        return r + "ed";
      case 7:
      case 8:
      case 9:
      case 10:
      case 12:
      case 15:
      case 18:
        return r + "fed";
      case 11:
      case 13:
      case 14:
      case 16:
      case 17:
      case 19:
        return r + "eg";
    }
  else if (r >= 50 && r <= 60 || r === 80 || r >= 100)
    return r + "fed";
  return r + "ain";
}, CLe = {
  ordinalNumber: SLe,
  era: Ce({
    values: pLe,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: gLe,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: vLe,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: bLe,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: yLe,
    defaultWidth: "wide",
    formattingValues: wLe,
    defaultFormattingWidth: "wide"
  })
}, xLe = /^(\d+)(af|ail|ydd|ed|fed|eg|ain)?/i, ELe = /\d+/i, PLe = {
  narrow: /^(c|o)/i,
  abbreviated: /^(c\.?\s?c\.?|o\.?\s?c\.?)/i,
  wide: /^(cyn christ|ar ôl crist|ar ol crist)/i
}, kLe = {
  wide: [/^c/i, /^(ar ôl crist|ar ol crist)/i],
  any: [/^c/i, /^o/i]
}, MLe = {
  narrow: /^[1234]/i,
  abbreviated: /^ch[1234]/i,
  wide: /^(chwarter 1af)|([234](ail|ydd)? chwarter)/i
}, OLe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, TLe = {
  narrow: /^(i|ch|m|e|g|a|h|t|rh)/i,
  abbreviated: /^(ion|chwe|maw|ebr|mai|meh|gor|aws|med|hyd|tach|rhag)/i,
  wide: /^(ionawr|chwefror|mawrth|ebrill|mai|mehefin|gorffennaf|awst|medi|hydref|tachwedd|rhagfyr)/i
}, RLe = {
  narrow: [
    /^i/i,
    /^ch/i,
    /^m/i,
    /^e/i,
    /^m/i,
    /^m/i,
    /^g/i,
    /^a/i,
    /^m/i,
    /^h/i,
    /^t/i,
    /^rh/i
  ],
  any: [
    /^io/i,
    /^ch/i,
    /^maw/i,
    /^e/i,
    /^mai/i,
    /^meh/i,
    /^g/i,
    /^a/i,
    /^med/i,
    /^h/i,
    /^t/i,
    /^rh/i
  ]
}, ALe = {
  narrow: /^(s|ll|m|i|g)/i,
  short: /^(su|ll|ma|me|ia|gw|sa)/i,
  abbreviated: /^(sul|llun|maw|mer|iau|gwe|sad)/i,
  wide: /^dydd (sul|llun|mawrth|mercher|iau|gwener|sadwrn)/i
}, NLe = {
  narrow: [/^s/i, /^ll/i, /^m/i, /^m/i, /^i/i, /^g/i, /^s/i],
  wide: [
    /^dydd su/i,
    /^dydd ll/i,
    /^dydd ma/i,
    /^dydd me/i,
    /^dydd i/i,
    /^dydd g/i,
    /^dydd sa/i
  ],
  any: [/^su/i, /^ll/i, /^ma/i, /^me/i, /^i/i, /^g/i, /^sa/i]
}, DLe = {
  narrow: /^(b|h|hn|hd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i,
  any: /^(y\.?\s?[bh]\.?|hanner nos|hanner dydd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i
}, $Le = {
  any: {
    am: /^b|(y\.?\s?b\.?)/i,
    pm: /^h|(y\.?\s?h\.?)|(yr hwyr)/i,
    midnight: /^hn|hanner nos/i,
    noon: /^hd|hanner dydd/i,
    morning: /bore/i,
    afternoon: /prynhawn/i,
    evening: /^gyda'r nos$/i,
    night: /blah/i
  }
}, zLe = {
  ordinalNumber: Fn({
    matchPattern: xLe,
    parsePattern: ELe,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: PLe,
    defaultMatchWidth: "wide",
    parsePatterns: kLe,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: MLe,
    defaultMatchWidth: "wide",
    parsePatterns: OLe,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: TLe,
    defaultMatchWidth: "wide",
    parsePatterns: RLe,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: ALe,
    defaultMatchWidth: "wide",
    parsePatterns: NLe,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: DLe,
    defaultMatchWidth: "any",
    parsePatterns: $Le,
    defaultParseWidth: "any"
  })
}, jLe = {
  code: "cy",
  formatDistance: sLe,
  formatLong: fLe,
  formatRelative: hLe,
  localize: CLe,
  match: zLe,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, ILe = {
  lessThanXSeconds: {
    one: "mindre end ét sekund",
    other: "mindre end {{count}} sekunder"
  },
  xSeconds: {
    one: "1 sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "ét halvt minut",
  lessThanXMinutes: {
    one: "mindre end ét minut",
    other: "mindre end {{count}} minutter"
  },
  xMinutes: {
    one: "1 minut",
    other: "{{count}} minutter"
  },
  aboutXHours: {
    one: "cirka 1 time",
    other: "cirka {{count}} timer"
  },
  xHours: {
    one: "1 time",
    other: "{{count}} timer"
  },
  xDays: {
    one: "1 dag",
    other: "{{count}} dage"
  },
  aboutXWeeks: {
    one: "cirka 1 uge",
    other: "cirka {{count}} uger"
  },
  xWeeks: {
    one: "1 uge",
    other: "{{count}} uger"
  },
  aboutXMonths: {
    one: "cirka 1 måned",
    other: "cirka {{count}} måneder"
  },
  xMonths: {
    one: "1 måned",
    other: "{{count}} måneder"
  },
  aboutXYears: {
    one: "cirka 1 år",
    other: "cirka {{count}} år"
  },
  xYears: {
    one: "1 år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "over 1 år",
    other: "over {{count}} år"
  },
  almostXYears: {
    one: "næsten 1 år",
    other: "næsten {{count}} år"
  }
}, LLe = (e, t, r) => {
  let a;
  const i = ILe[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? "om " + a : a + " siden" : a;
}, HLe = {
  full: "EEEE 'den' d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd/MM/y"
}, FLe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, WLe = {
  full: "{{date}} 'kl'. {{time}}",
  long: "{{date}} 'kl'. {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, VLe = {
  date: Ke({
    formats: HLe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: FLe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: WLe,
    defaultWidth: "full"
  })
}, _Le = {
  lastWeek: "'sidste' eeee 'kl.' p",
  yesterday: "'i går kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgen kl.' p",
  nextWeek: "'på' eeee 'kl.' p",
  other: "P"
}, BLe = (e, t, r, a) => _Le[e], ULe = {
  narrow: ["fvt", "vt"],
  abbreviated: ["f.v.t.", "v.t."],
  wide: ["før vesterlandsk tidsregning", "vesterlandsk tidsregning"]
}, XLe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. kvt.", "2. kvt.", "3. kvt.", "4. kvt."],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, GLe = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jan.",
    "feb.",
    "mar.",
    "apr.",
    "maj",
    "jun.",
    "jul.",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "dec."
  ],
  wide: [
    "januar",
    "februar",
    "marts",
    "april",
    "maj",
    "juni",
    "juli",
    "august",
    "september",
    "oktober",
    "november",
    "december"
  ]
}, qLe = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sø", "ma", "ti", "on", "to", "fr", "lø"],
  abbreviated: ["søn.", "man.", "tir.", "ons.", "tor.", "fre.", "lør."],
  wide: [
    "søndag",
    "mandag",
    "tirsdag",
    "onsdag",
    "torsdag",
    "fredag",
    "lørdag"
  ]
}, KLe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  }
}, YLe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  }
}, QLe = (e, t) => Number(e) + ".", JLe = {
  ordinalNumber: QLe,
  era: Ce({
    values: ULe,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: XLe,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: GLe,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: qLe,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: KLe,
    defaultWidth: "wide",
    formattingValues: YLe,
    defaultFormattingWidth: "wide"
  })
}, ZLe = /^(\d+)(\.)?/i, eHe = /\d+/i, tHe = {
  narrow: /^(fKr|fvt|eKr|vt)/i,
  abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
  wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
}, nHe = {
  any: [/^f/i, /^(v|e)/i]
}, rHe = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]. kvt\./i,
  wide: /^[1234]\.? kvartal/i
}, aHe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, oHe = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
}, iHe = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^maj/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, lHe = {
  narrow: /^[smtofl]/i,
  short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
  abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
  wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
}, sHe = {
  narrow: [/^s/i, /^m/i, /^t/i, /^o/i, /^t/i, /^f/i, /^l/i],
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, uHe = {
  narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
  any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
}, cHe = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /midnat/i,
    noon: /middag/i,
    morning: /morgen/i,
    afternoon: /eftermiddag/i,
    evening: /aften/i,
    night: /nat/i
  }
}, dHe = {
  ordinalNumber: Fn({
    matchPattern: ZLe,
    parsePattern: eHe,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: tHe,
    defaultMatchWidth: "wide",
    parsePatterns: nHe,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: rHe,
    defaultMatchWidth: "wide",
    parsePatterns: aHe,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: oHe,
    defaultMatchWidth: "wide",
    parsePatterns: iHe,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: lHe,
    defaultMatchWidth: "wide",
    parsePatterns: sHe,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: uHe,
    defaultMatchWidth: "any",
    parsePatterns: cHe,
    defaultParseWidth: "any"
  })
}, fHe = {
  code: "da",
  formatDistance: LLe,
  formatLong: VLe,
  formatRelative: BLe,
  localize: JLe,
  match: dHe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, FB = {
  lessThanXSeconds: {
    standalone: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    },
    withPreposition: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    }
  },
  xSeconds: {
    standalone: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    },
    withPreposition: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    }
  },
  halfAMinute: {
    standalone: "eine halbe Minute",
    withPreposition: "einer halben Minute"
  },
  lessThanXMinutes: {
    standalone: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    },
    withPreposition: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    }
  },
  xMinutes: {
    standalone: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    },
    withPreposition: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    }
  },
  aboutXHours: {
    standalone: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    },
    withPreposition: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    }
  },
  xHours: {
    standalone: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    },
    withPreposition: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    }
  },
  xDays: {
    standalone: {
      one: "1 Tag",
      other: "{{count}} Tage"
    },
    withPreposition: {
      one: "1 Tag",
      other: "{{count}} Tagen"
    }
  },
  aboutXWeeks: {
    standalone: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    },
    withPreposition: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    }
  },
  xWeeks: {
    standalone: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    },
    withPreposition: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    }
  },
  aboutXMonths: {
    standalone: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monate"
    },
    withPreposition: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monaten"
    }
  },
  xMonths: {
    standalone: {
      one: "1 Monat",
      other: "{{count}} Monate"
    },
    withPreposition: {
      one: "1 Monat",
      other: "{{count}} Monaten"
    }
  },
  aboutXYears: {
    standalone: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahre"
    },
    withPreposition: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahren"
    }
  },
  xYears: {
    standalone: {
      one: "1 Jahr",
      other: "{{count}} Jahre"
    },
    withPreposition: {
      one: "1 Jahr",
      other: "{{count}} Jahren"
    }
  },
  overXYears: {
    standalone: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahre"
    },
    withPreposition: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahren"
    }
  },
  almostXYears: {
    standalone: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahre"
    },
    withPreposition: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahren"
    }
  }
}, Ote = (e, t, r) => {
  let a;
  const i = r?.addSuffix ? FB[e].withPreposition : FB[e].standalone;
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? "in " + a : "vor " + a : a;
}, mHe = {
  full: "EEEE, do MMMM y",
  // Montag, 7. Januar 2018
  long: "do MMMM y",
  // 7. Januar 2018
  medium: "do MMM y",
  // 7. Jan. 2018
  short: "dd.MM.y"
  // 07.01.2018
}, hHe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, pHe = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Tte = {
  date: Ke({
    formats: mHe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: hHe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: pHe,
    defaultWidth: "full"
  })
}, gHe = {
  lastWeek: "'letzten' eeee 'um' p",
  yesterday: "'gestern um' p",
  today: "'heute um' p",
  tomorrow: "'morgen um' p",
  nextWeek: "eeee 'um' p",
  other: "P"
}, Rte = (e, t, r, a) => gHe[e], vHe = {
  narrow: ["v.Chr.", "n.Chr."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["vor Christus", "nach Christus"]
}, bHe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
}, A$ = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mär",
    "Apr",
    "Mai",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dez"
  ],
  wide: [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember"
  ]
}, yHe = {
  narrow: A$.narrow,
  abbreviated: [
    "Jan.",
    "Feb.",
    "März",
    "Apr.",
    "Mai",
    "Juni",
    "Juli",
    "Aug.",
    "Sep.",
    "Okt.",
    "Nov.",
    "Dez."
  ],
  wide: A$.wide
}, wHe = {
  narrow: ["S", "M", "D", "M", "D", "F", "S"],
  short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
  wide: [
    "Sonntag",
    "Montag",
    "Dienstag",
    "Mittwoch",
    "Donnerstag",
    "Freitag",
    "Samstag"
  ]
}, SHe = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachm.",
    evening: "Abend",
    night: "Nacht"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  }
}, CHe = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachm.",
    evening: "abends",
    night: "nachts"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  }
}, xHe = (e) => Number(e) + ".", EHe = {
  ordinalNumber: xHe,
  era: Ce({
    values: vHe,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: bHe,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: A$,
    formattingValues: yHe,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: wHe,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: SHe,
    defaultWidth: "wide",
    formattingValues: CHe,
    defaultFormattingWidth: "wide"
  })
}, PHe = /^(\d+)(\.)?/i, kHe = /\d+/i, MHe = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
}, OHe = {
  any: [/^v/i, /^n/i]
}, THe = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i
}, RHe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, AHe = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
  wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
}, NHe = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^j[aä]/i,
    /^f/i,
    /^mär/i,
    /^ap/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, DHe = {
  narrow: /^[smdmf]/i,
  short: /^(so|mo|di|mi|do|fr|sa)/i,
  abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
  wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
}, $He = {
  any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
}, zHe = {
  narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
}, jHe = {
  any: {
    am: /^v/i,
    pm: /^n/i,
    midnight: /^Mitte/i,
    noon: /^Mitta/i,
    morning: /morgens/i,
    afternoon: /nachmittags/i,
    // will never be matched. Afternoon is matched by `pm`
    evening: /abends/i,
    night: /nachts/i
    // will never be matched. Night is matched by `pm`
  }
}, Ate = {
  ordinalNumber: Fn({
    matchPattern: PHe,
    parsePattern: kHe,
    valueCallback: (e) => parseInt(e)
  }),
  era: Ee({
    matchPatterns: MHe,
    defaultMatchWidth: "wide",
    parsePatterns: OHe,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: THe,
    defaultMatchWidth: "wide",
    parsePatterns: RHe,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: AHe,
    defaultMatchWidth: "wide",
    parsePatterns: NHe,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: DHe,
    defaultMatchWidth: "wide",
    parsePatterns: $He,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: zHe,
    defaultMatchWidth: "wide",
    parsePatterns: jHe,
    defaultParseWidth: "any"
  })
}, IHe = {
  code: "de",
  formatDistance: Ote,
  formatLong: Tte,
  formatRelative: Rte,
  localize: EHe,
  match: Ate,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, LHe = {
  narrow: ["v.Chr.", "n.Chr."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["vor Christus", "nach Christus"]
}, HHe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
}, N$ = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jän",
    "Feb",
    "Mär",
    "Apr",
    "Mai",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dez"
  ],
  wide: [
    "Jänner",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember"
  ]
}, FHe = {
  narrow: N$.narrow,
  abbreviated: [
    "Jän.",
    "Feb.",
    "März",
    "Apr.",
    "Mai",
    "Juni",
    "Juli",
    "Aug.",
    "Sep.",
    "Okt.",
    "Nov.",
    "Dez."
  ],
  wide: N$.wide
}, WHe = {
  narrow: ["S", "M", "D", "M", "D", "F", "S"],
  short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
  wide: [
    "Sonntag",
    "Montag",
    "Dienstag",
    "Mittwoch",
    "Donnerstag",
    "Freitag",
    "Samstag"
  ]
}, VHe = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachm.",
    evening: "Abend",
    night: "Nacht"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  }
}, _He = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachm.",
    evening: "abends",
    night: "nachts"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  }
}, BHe = (e) => Number(e) + ".", UHe = {
  ordinalNumber: BHe,
  era: Ce({
    values: LHe,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: HHe,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: N$,
    formattingValues: FHe,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: WHe,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: VHe,
    defaultWidth: "wide",
    formattingValues: _He,
    defaultFormattingWidth: "wide"
  })
}, XHe = {
  code: "de-AT",
  formatDistance: Ote,
  formatLong: Tte,
  formatRelative: Rte,
  localize: UHe,
  match: Ate,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, GHe = {
  lessThanXSeconds: {
    one: "λιγότερο από ένα δευτερόλεπτο",
    other: "λιγότερο από {{count}} δευτερόλεπτα"
  },
  xSeconds: {
    one: "1 δευτερόλεπτο",
    other: "{{count}} δευτερόλεπτα"
  },
  halfAMinute: "μισό λεπτό",
  lessThanXMinutes: {
    one: "λιγότερο από ένα λεπτό",
    other: "λιγότερο από {{count}} λεπτά"
  },
  xMinutes: {
    one: "1 λεπτό",
    other: "{{count}} λεπτά"
  },
  aboutXHours: {
    one: "περίπου 1 ώρα",
    other: "περίπου {{count}} ώρες"
  },
  xHours: {
    one: "1 ώρα",
    other: "{{count}} ώρες"
  },
  xDays: {
    one: "1 ημέρα",
    other: "{{count}} ημέρες"
  },
  aboutXWeeks: {
    one: "περίπου 1 εβδομάδα",
    other: "περίπου {{count}} εβδομάδες"
  },
  xWeeks: {
    one: "1 εβδομάδα",
    other: "{{count}} εβδομάδες"
  },
  aboutXMonths: {
    one: "περίπου 1 μήνας",
    other: "περίπου {{count}} μήνες"
  },
  xMonths: {
    one: "1 μήνας",
    other: "{{count}} μήνες"
  },
  aboutXYears: {
    one: "περίπου 1 χρόνο",
    other: "περίπου {{count}} χρόνια"
  },
  xYears: {
    one: "1 χρόνο",
    other: "{{count}} χρόνια"
  },
  overXYears: {
    one: "πάνω από 1 χρόνο",
    other: "πάνω από {{count}} χρόνια"
  },
  almostXYears: {
    one: "περίπου 1 χρόνο",
    other: "περίπου {{count}} χρόνια"
  }
}, qHe = (e, t, r) => {
  let a;
  const i = GHe[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? "σε " + a : a + " πριν" : a;
}, KHe = {
  full: "EEEE, d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "d/M/yy"
}, YHe = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, QHe = {
  full: "{{date}} - {{time}}",
  long: "{{date}} - {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, JHe = {
  date: Ke({
    formats: KHe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: YHe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: QHe,
    defaultWidth: "full"
  })
}, ZHe = {
  lastWeek: (e) => {
    switch (e.getDay()) {
      case 6:
        return "'το προηγούμενο' eeee 'στις' p";
      default:
        return "'την προηγούμενη' eeee 'στις' p";
    }
  },
  yesterday: "'χθες στις' p",
  today: "'σήμερα στις' p",
  tomorrow: "'αύριο στις' p",
  nextWeek: "eeee 'στις' p",
  other: "P"
}, eFe = (e, t) => {
  const r = ZHe[e];
  return typeof r == "function" ? r(t) : r;
}, tFe = {
  narrow: ["πΧ", "μΧ"],
  abbreviated: ["π.Χ.", "μ.Χ."],
  wide: ["προ Χριστού", "μετά Χριστόν"]
}, nFe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Τ1", "Τ2", "Τ3", "Τ4"],
  wide: ["1ο τρίμηνο", "2ο τρίμηνο", "3ο τρίμηνο", "4ο τρίμηνο"]
}, rFe = {
  narrow: ["Ι", "Φ", "Μ", "Α", "Μ", "Ι", "Ι", "Α", "Σ", "Ο", "Ν", "Δ"],
  abbreviated: [
    "Ιαν",
    "Φεβ",
    "Μάρ",
    "Απρ",
    "Μάι",
    "Ιούν",
    "Ιούλ",
    "Αύγ",
    "Σεπ",
    "Οκτ",
    "Νοέ",
    "Δεκ"
  ],
  wide: [
    "Ιανουάριος",
    "Φεβρουάριος",
    "Μάρτιος",
    "Απρίλιος",
    "Μάιος",
    "Ιούνιος",
    "Ιούλιος",
    "Αύγουστος",
    "Σεπτέμβριος",
    "Οκτώβριος",
    "Νοέμβριος",
    "Δεκέμβριος"
  ]
}, aFe = {
  narrow: ["Ι", "Φ", "Μ", "Α", "Μ", "Ι", "Ι", "Α", "Σ", "Ο", "Ν", "Δ"],
  abbreviated: [
    "Ιαν",
    "Φεβ",
    "Μαρ",
    "Απρ",
    "Μαΐ",
    "Ιουν",
    "Ιουλ",
    "Αυγ",
    "Σεπ",
    "Οκτ",
    "Νοε",
    "Δεκ"
  ],
  wide: [
    "Ιανουαρίου",
    "Φεβρουαρίου",
    "Μαρτίου",
    "Απριλίου",
    "Μαΐου",
    "Ιουνίου",
    "Ιουλίου",
    "Αυγούστου",
    "Σεπτεμβρίου",
    "Οκτωβρίου",
    "Νοεμβρίου",
    "Δεκεμβρίου"
  ]
}, oFe = {
  narrow: ["Κ", "Δ", "T", "Τ", "Π", "Π", "Σ"],
  short: ["Κυ", "Δε", "Τρ", "Τε", "Πέ", "Πα", "Σά"],
  abbreviated: ["Κυρ", "Δευ", "Τρί", "Τετ", "Πέμ", "Παρ", "Σάβ"],
  wide: [
    "Κυριακή",
    "Δευτέρα",
    "Τρίτη",
    "Τετάρτη",
    "Πέμπτη",
    "Παρασκευή",
    "Σάββατο"
  ]
}, iFe = {
  narrow: {
    am: "πμ",
    pm: "μμ",
    midnight: "μεσάνυχτα",
    noon: "μεσημέρι",
    morning: "πρωί",
    afternoon: "απόγευμα",
    evening: "βράδυ",
    night: "νύχτα"
  },
  abbreviated: {
    am: "π.μ.",
    pm: "μ.μ.",
    midnight: "μεσάνυχτα",
    noon: "μεσημέρι",
    morning: "πρωί",
    afternoon: "απόγευμα",
    evening: "βράδυ",
    night: "νύχτα"
  },
  wide: {
    am: "π.μ.",
    pm: "μ.μ.",
    midnight: "μεσάνυχτα",
    noon: "μεσημέρι",
    morning: "πρωί",
    afternoon: "απόγευμα",
    evening: "βράδυ",
    night: "νύχτα"
  }
}, lFe = (e, t) => {
  const r = Number(e), a = t?.unit;
  let i;
  return a === "year" || a === "month" ? i = "ος" : a === "week" || a === "dayOfYear" || a === "day" || a === "hour" || a === "date" ? i = "η" : i = "ο", r + i;
}, sFe = {
  ordinalNumber: lFe,
  era: Ce({
    values: tFe,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: nFe,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: rFe,
    defaultWidth: "wide",
    formattingValues: aFe,
    defaultFormattingWidth: "wide"
  }),
  day: Ce({
    values: oFe,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: iFe,
    defaultWidth: "wide"
  })
}, uFe = /^(\d+)(ος|η|ο)?/i, cFe = /\d+/i, dFe = {
  narrow: /^(πΧ|μΧ)/i,
  abbreviated: /^(π\.?\s?χ\.?|π\.?\s?κ\.?\s?χ\.?|μ\.?\s?χ\.?|κ\.?\s?χ\.?)/i,
  wide: /^(προ Χριστο(ύ|υ)|πριν απ(ό|ο) την Κοιν(ή|η) Χρονολογ(ί|ι)α|μετ(ά|α) Χριστ(ό|ο)ν|Κοιν(ή|η) Χρονολογ(ί|ι)α)/i
}, fFe = {
  any: [/^π/i, /^(μ|κ)/i]
}, mFe = {
  narrow: /^[1234]/i,
  abbreviated: /^τ[1234]/i,
  wide: /^[1234]ο? τρ(ί|ι)μηνο/i
}, hFe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, pFe = {
  narrow: /^[ιφμαμιιασονδ]/i,
  abbreviated: /^(ιαν|φεβ|μ[άα]ρ|απρ|μ[άα][ιΐ]|ιο[ύυ]ν|ιο[ύυ]λ|α[ύυ]γ|σεπ|οκτ|νο[έε]|δεκ)/i,
  wide: /^(μ[άα][ιΐ]|α[ύυ]γο[υύ]στ)(ος|ου)|(ιανου[άα]ρ|φεβρου[άα]ρ|μ[άα]ρτ|απρ[ίι]λ|ιο[ύυ]ν|ιο[ύυ]λ|σεπτ[έε]μβρ|οκτ[ώω]βρ|νο[έε]μβρ|δεκ[έε]μβρ)(ιος|ίου)/i
}, gFe = {
  narrow: [
    /^ι/i,
    /^φ/i,
    /^μ/i,
    /^α/i,
    /^μ/i,
    /^ι/i,
    /^ι/i,
    /^α/i,
    /^σ/i,
    /^ο/i,
    /^ν/i,
    /^δ/i
  ],
  any: [
    /^ια/i,
    /^φ/i,
    /^μ[άα]ρ/i,
    /^απ/i,
    /^μ[άα][ιΐ]/i,
    /^ιο[ύυ]ν/i,
    /^ιο[ύυ]λ/i,
    /^α[ύυ]/i,
    /^σ/i,
    /^ο/i,
    /^ν/i,
    /^δ/i
  ]
}, vFe = {
  narrow: /^[κδτπσ]/i,
  short: /^(κυ|δε|τρ|τε|π[εέ]|π[αά]|σ[αά])/i,
  abbreviated: /^(κυρ|δευ|τρι|τετ|πεμ|παρ|σαβ)/i,
  wide: /^(κυριακ(ή|η)|δευτ(έ|ε)ρα|τρ(ί|ι)τη|τετ(ά|α)ρτη|π(έ|ε)μπτη|παρασκευ(ή|η)|σ(ά|α)ββατο)/i
}, bFe = {
  narrow: [/^κ/i, /^δ/i, /^τ/i, /^τ/i, /^π/i, /^π/i, /^σ/i],
  any: [/^κ/i, /^δ/i, /^τρ/i, /^τε/i, /^π[εέ]/i, /^π[αά]/i, /^σ/i]
}, yFe = {
  narrow: /^(πμ|μμ|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i,
  any: /^([πμ]\.?\s?μ\.?|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i
}, wFe = {
  any: {
    am: /^πμ|π\.\s?μ\./i,
    pm: /^μμ|μ\.\s?μ\./i,
    midnight: /^μεσάν/i,
    noon: /^μεσημ(έ|ε)/i,
    morning: /πρω(ί|ι)/i,
    afternoon: /απ(ό|ο)γευμα/i,
    evening: /βρ(ά|α)δυ/i,
    night: /ν(ύ|υ)χτα/i
  }
}, SFe = {
  ordinalNumber: Fn({
    matchPattern: uFe,
    parsePattern: cFe,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: dFe,
    defaultMatchWidth: "wide",
    parsePatterns: fFe,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: mFe,
    defaultMatchWidth: "wide",
    parsePatterns: hFe,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: pFe,
    defaultMatchWidth: "wide",
    parsePatterns: gFe,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: vFe,
    defaultMatchWidth: "wide",
    parsePatterns: bFe,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: yFe,
    defaultMatchWidth: "any",
    parsePatterns: wFe,
    defaultParseWidth: "any"
  })
}, CFe = {
  code: "el",
  formatDistance: qHe,
  formatLong: JHe,
  formatRelative: eFe,
  localize: sFe,
  match: SFe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, xFe = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, EFe = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, PFe = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, kFe = {
  date: Ke({
    formats: xFe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: EFe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: PFe,
    defaultWidth: "full"
  })
}, MFe = {
  code: "en-AU",
  formatDistance: Hx,
  formatLong: kFe,
  formatRelative: f3,
  localize: d3,
  match: c3,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, OFe = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "a second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "a minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about an hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "an hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "a day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about a week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "a week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about a month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "a month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about a year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "a year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over a year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost a year",
    other: "almost {{count}} years"
  }
}, TFe = (e, t, r) => {
  let a;
  const i = OFe[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", t.toString()), r?.addSuffix ? r.comparison && r.comparison > 0 ? "in " + a : a + " ago" : a;
}, RFe = {
  full: "EEEE, MMMM do, yyyy",
  long: "MMMM do, yyyy",
  medium: "MMM d, yyyy",
  short: "yyyy-MM-dd"
}, AFe = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, NFe = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, DFe = {
  date: Ke({
    formats: RFe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: AFe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: NFe,
    defaultWidth: "full"
  })
}, $Fe = {
  code: "en-CA",
  formatDistance: TFe,
  formatLong: DFe,
  formatRelative: f3,
  localize: d3,
  match: c3,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, zFe = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, jFe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, IFe = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Nte = {
  date: Ke({
    formats: zFe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: jFe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: IFe,
    defaultWidth: "full"
  })
}, LFe = {
  code: "en-GB",
  formatDistance: Hx,
  formatLong: Nte,
  formatRelative: f3,
  localize: d3,
  match: c3,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, HFe = {
  code: "en-IE",
  formatDistance: Hx,
  formatLong: Nte,
  formatRelative: f3,
  localize: d3,
  match: c3,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, FFe = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM, yyyy",
  medium: "d MMM, yyyy",
  short: "dd/MM/yyyy"
}, WFe = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, VFe = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, _Fe = {
  date: Ke({
    formats: FFe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: WFe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: VFe,
    defaultWidth: "full"
  })
}, BFe = {
  code: "en-IN",
  formatDistance: Hx,
  formatLong: _Fe,
  formatRelative: f3,
  localize: d3,
  match: c3,
  options: {
    weekStartsOn: 1,
    // Monday is the first day of the week.
    firstWeekContainsDate: 4
    // The week that contains Jan 4th is the first week of the year.
  }
}, UFe = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, XFe = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, GFe = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, qFe = {
  date: Ke({
    formats: UFe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: XFe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: GFe,
    defaultWidth: "full"
  })
}, KFe = {
  code: "en-NZ",
  formatDistance: Hx,
  formatLong: qFe,
  formatRelative: f3,
  localize: d3,
  match: c3,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, YFe = {
  full: "EEEE, dd MMMM yyyy",
  long: "dd MMMM yyyy",
  medium: "dd MMM yyyy",
  short: "yyyy/MM/dd"
}, QFe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, JFe = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, ZFe = {
  date: Ke({
    formats: YFe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: QFe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: JFe,
    defaultWidth: "full"
  })
}, eWe = {
  code: "en-ZA",
  formatDistance: Hx,
  formatLong: ZFe,
  formatRelative: f3,
  localize: d3,
  match: c3,
  options: {
    weekStartsOn: 0,
    // Sunday is the first day of the week.
    firstWeekContainsDate: 1
    // The week that contains Jan 1st is the first week of the year.
  }
}, tWe = {
  lessThanXSeconds: {
    one: "malpli ol sekundo",
    other: "malpli ol {{count}} sekundoj"
  },
  xSeconds: {
    one: "1 sekundo",
    other: "{{count}} sekundoj"
  },
  halfAMinute: "duonminuto",
  lessThanXMinutes: {
    one: "malpli ol minuto",
    other: "malpli ol {{count}} minutoj"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutoj"
  },
  aboutXHours: {
    one: "proksimume 1 horo",
    other: "proksimume {{count}} horoj"
  },
  xHours: {
    one: "1 horo",
    other: "{{count}} horoj"
  },
  xDays: {
    one: "1 tago",
    other: "{{count}} tagoj"
  },
  aboutXMonths: {
    one: "proksimume 1 monato",
    other: "proksimume {{count}} monatoj"
  },
  xWeeks: {
    one: "1 semajno",
    other: "{{count}} semajnoj"
  },
  aboutXWeeks: {
    one: "proksimume 1 semajno",
    other: "proksimume {{count}} semajnoj"
  },
  xMonths: {
    one: "1 monato",
    other: "{{count}} monatoj"
  },
  aboutXYears: {
    one: "proksimume 1 jaro",
    other: "proksimume {{count}} jaroj"
  },
  xYears: {
    one: "1 jaro",
    other: "{{count}} jaroj"
  },
  overXYears: {
    one: "pli ol 1 jaro",
    other: "pli ol {{count}} jaroj"
  },
  almostXYears: {
    one: "preskaŭ 1 jaro",
    other: "preskaŭ {{count}} jaroj"
  }
}, nWe = (e, t, r) => {
  let a;
  const i = tWe[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r?.comparison && r.comparison > 0 ? "post " + a : "antaŭ " + a : a;
}, rWe = {
  full: "EEEE, do 'de' MMMM y",
  long: "y-MMMM-dd",
  medium: "y-MMM-dd",
  short: "yyyy-MM-dd"
}, aWe = {
  full: "Ho 'horo kaj' m:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, oWe = {
  any: "{{date}} {{time}}"
}, iWe = {
  date: Ke({
    formats: rWe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: aWe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: oWe,
    defaultWidth: "any"
  })
}, lWe = {
  lastWeek: "'pasinta' eeee 'je' p",
  yesterday: "'hieraŭ je' p",
  today: "'hodiaŭ je' p",
  tomorrow: "'morgaŭ je' p",
  nextWeek: "eeee 'je' p",
  other: "P"
}, sWe = (e, t, r, a) => lWe[e], uWe = {
  narrow: ["aK", "pK"],
  abbreviated: ["a.K.E.", "p.K.E."],
  wide: ["antaŭ Komuna Erao", "Komuna Erao"]
}, cWe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: [
    "1-a kvaronjaro",
    "2-a kvaronjaro",
    "3-a kvaronjaro",
    "4-a kvaronjaro"
  ]
}, dWe = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jan",
    "feb",
    "mar",
    "apr",
    "maj",
    "jun",
    "jul",
    "aŭg",
    "sep",
    "okt",
    "nov",
    "dec"
  ],
  wide: [
    "januaro",
    "februaro",
    "marto",
    "aprilo",
    "majo",
    "junio",
    "julio",
    "aŭgusto",
    "septembro",
    "oktobro",
    "novembro",
    "decembro"
  ]
}, fWe = {
  narrow: ["D", "L", "M", "M", "Ĵ", "V", "S"],
  short: ["di", "lu", "ma", "me", "ĵa", "ve", "sa"],
  abbreviated: ["dim", "lun", "mar", "mer", "ĵaŭ", "ven", "sab"],
  wide: [
    "dimanĉo",
    "lundo",
    "mardo",
    "merkredo",
    "ĵaŭdo",
    "vendredo",
    "sabato"
  ]
}, mWe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "noktomezo",
    noon: "tagmezo",
    morning: "matene",
    afternoon: "posttagmeze",
    evening: "vespere",
    night: "nokte"
  },
  abbreviated: {
    am: "a.t.m.",
    pm: "p.t.m.",
    midnight: "noktomezo",
    noon: "tagmezo",
    morning: "matene",
    afternoon: "posttagmeze",
    evening: "vespere",
    night: "nokte"
  },
  wide: {
    am: "antaŭtagmeze",
    pm: "posttagmeze",
    midnight: "noktomezo",
    noon: "tagmezo",
    morning: "matene",
    afternoon: "posttagmeze",
    evening: "vespere",
    night: "nokte"
  }
}, hWe = (e) => Number(e) + "-a", pWe = {
  ordinalNumber: hWe,
  era: Ce({
    values: uWe,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: cWe,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return Number(e) - 1;
    }
  }),
  month: Ce({
    values: dWe,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: fWe,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: mWe,
    defaultWidth: "wide"
  })
}, gWe = /^(\d+)(-?a)?/i, vWe = /\d+/i, bWe = {
  narrow: /^([ap]k)/i,
  abbreviated: /^([ap]\.?\s?k\.?\s?e\.?)/i,
  wide: /^((antaǔ |post )?komuna erao)/i
}, yWe = {
  any: [/^a/i, /^[kp]/i]
}, wWe = {
  narrow: /^[1234]/i,
  abbreviated: /^k[1234]/i,
  wide: /^[1234](-?a)? kvaronjaro/i
}, SWe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, CWe = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|a(ŭ|ux|uh|u)g|sep|okt|nov|dec)/i,
  wide: /^(januaro|februaro|marto|aprilo|majo|junio|julio|a(ŭ|ux|uh|u)gusto|septembro|oktobro|novembro|decembro)/i
}, xWe = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^maj/i,
    /^jun/i,
    /^jul/i,
    /^a(u|ŭ)/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, EWe = {
  narrow: /^[dlmĵjvs]/i,
  short: /^(di|lu|ma|me|(ĵ|jx|jh|j)a|ve|sa)/i,
  abbreviated: /^(dim|lun|mar|mer|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)|ven|sab)/i,
  wide: /^(diman(ĉ|cx|ch|c)o|lundo|mardo|merkredo|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)do|vendredo|sabato)/i
}, PWe = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^(j|ĵ)/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^(j|ĵ)/i, /^v/i, /^s/i]
}, kWe = {
  narrow: /^([ap]|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
  abbreviated: /^([ap][.\s]?t[.\s]?m[.\s]?|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
  wide: /^(anta(ŭ|ux)tagmez|posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo]/i
}, MWe = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^noktom/i,
    noon: /^t/i,
    morning: /^m/i,
    afternoon: /^posttagmeze/i,
    evening: /^v/i,
    night: /^n/i
  }
}, OWe = {
  ordinalNumber: Fn({
    matchPattern: gWe,
    parsePattern: vWe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: Ee({
    matchPatterns: bWe,
    defaultMatchWidth: "wide",
    parsePatterns: yWe,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: wWe,
    defaultMatchWidth: "wide",
    parsePatterns: SWe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: Ee({
    matchPatterns: CWe,
    defaultMatchWidth: "wide",
    parsePatterns: xWe,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: EWe,
    defaultMatchWidth: "wide",
    parsePatterns: PWe,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: kWe,
    defaultMatchWidth: "wide",
    parsePatterns: MWe,
    defaultParseWidth: "any"
  })
}, TWe = {
  code: "eo",
  formatDistance: nWe,
  formatLong: iWe,
  formatRelative: sWe,
  localize: pWe,
  match: OWe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, RWe = {
  lessThanXSeconds: {
    one: "menos de un segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "medio minuto",
  lessThanXMinutes: {
    one: "menos de un minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "alrededor de 1 hora",
    other: "alrededor de {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 día",
    other: "{{count}} días"
  },
  aboutXWeeks: {
    one: "alrededor de 1 semana",
    other: "alrededor de {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "alrededor de 1 mes",
    other: "alrededor de {{count}} meses"
  },
  xMonths: {
    one: "1 mes",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "alrededor de 1 año",
    other: "alrededor de {{count}} años"
  },
  xYears: {
    one: "1 año",
    other: "{{count}} años"
  },
  overXYears: {
    one: "más de 1 año",
    other: "más de {{count}} años"
  },
  almostXYears: {
    one: "casi 1 año",
    other: "casi {{count}} años"
  }
}, AWe = (e, t, r) => {
  let a;
  const i = RWe[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", t.toString()), r?.addSuffix ? r.comparison && r.comparison > 0 ? "en " + a : "hace " + a : a;
}, NWe = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, DWe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, $We = {
  full: "{{date}} 'a las' {{time}}",
  long: "{{date}} 'a las' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, zWe = {
  date: Ke({
    formats: NWe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: DWe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: $We,
    defaultWidth: "full"
  })
}, jWe = {
  lastWeek: "'el' eeee 'pasado a la' p",
  yesterday: "'ayer a la' p",
  today: "'hoy a la' p",
  tomorrow: "'mañana a la' p",
  nextWeek: "eeee 'a la' p",
  other: "P"
}, IWe = {
  lastWeek: "'el' eeee 'pasado a las' p",
  yesterday: "'ayer a las' p",
  today: "'hoy a las' p",
  tomorrow: "'mañana a las' p",
  nextWeek: "eeee 'a las' p",
  other: "P"
}, LWe = (e, t, r, a) => t.getHours() !== 1 ? IWe[e] : jWe[e], HWe = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "después de cristo"]
}, FWe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, WWe = {
  narrow: ["e", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "ene",
    "feb",
    "mar",
    "abr",
    "may",
    "jun",
    "jul",
    "ago",
    "sep",
    "oct",
    "nov",
    "dic"
  ],
  wide: [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre"
  ]
}, VWe = {
  narrow: ["d", "l", "m", "m", "j", "v", "s"],
  short: ["do", "lu", "ma", "mi", "ju", "vi", "sá"],
  abbreviated: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
  wide: [
    "domingo",
    "lunes",
    "martes",
    "miércoles",
    "jueves",
    "viernes",
    "sábado"
  ]
}, _We = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  }
}, BWe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  }
}, UWe = (e, t) => Number(e) + "º", XWe = {
  ordinalNumber: UWe,
  era: Ce({
    values: HWe,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: FWe,
    defaultWidth: "wide",
    argumentCallback: (e) => Number(e) - 1
  }),
  month: Ce({
    values: WWe,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: VWe,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: _We,
    defaultWidth: "wide",
    formattingValues: BWe,
    defaultFormattingWidth: "wide"
  })
}, GWe = /^(\d+)(º)?/i, qWe = /\d+/i, KWe = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
}, YWe = {
  any: [/^ac/i, /^dc/i],
  wide: [
    /^(antes de cristo|antes de la era com[uú]n)/i,
    /^(despu[eé]s de cristo|era com[uú]n)/i
  ]
}, QWe = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, JWe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, ZWe = {
  narrow: /^[efmajsond]/i,
  abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
  wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
}, eVe = {
  narrow: [
    /^e/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^en/i,
    /^feb/i,
    /^mar/i,
    /^abr/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^ago/i,
    /^sep/i,
    /^oct/i,
    /^nov/i,
    /^dic/i
  ]
}, tVe = {
  narrow: /^[dlmjvs]/i,
  short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
  abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
  wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
}, nVe = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i]
}, rVe = {
  narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
  any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
}, aVe = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /^md/i,
    morning: /mañana/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noche/i
  }
}, oVe = {
  ordinalNumber: Fn({
    matchPattern: GWe,
    parsePattern: qWe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: Ee({
    matchPatterns: KWe,
    defaultMatchWidth: "wide",
    parsePatterns: YWe,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: QWe,
    defaultMatchWidth: "wide",
    parsePatterns: JWe,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: ZWe,
    defaultMatchWidth: "wide",
    parsePatterns: eVe,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: tVe,
    defaultMatchWidth: "wide",
    parsePatterns: nVe,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: rVe,
    defaultMatchWidth: "any",
    parsePatterns: aVe,
    defaultParseWidth: "any"
  })
}, iVe = {
  code: "es",
  formatDistance: AWe,
  formatLong: zWe,
  formatRelative: LWe,
  localize: XWe,
  match: oVe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, WB = {
  lessThanXSeconds: {
    standalone: {
      one: "vähem kui üks sekund",
      other: "vähem kui {{count}} sekundit"
    },
    withPreposition: {
      one: "vähem kui ühe sekundi",
      other: "vähem kui {{count}} sekundi"
    }
  },
  xSeconds: {
    standalone: {
      one: "üks sekund",
      other: "{{count}} sekundit"
    },
    withPreposition: {
      one: "ühe sekundi",
      other: "{{count}} sekundi"
    }
  },
  halfAMinute: {
    standalone: "pool minutit",
    withPreposition: "poole minuti"
  },
  lessThanXMinutes: {
    standalone: {
      one: "vähem kui üks minut",
      other: "vähem kui {{count}} minutit"
    },
    withPreposition: {
      one: "vähem kui ühe minuti",
      other: "vähem kui {{count}} minuti"
    }
  },
  xMinutes: {
    standalone: {
      one: "üks minut",
      other: "{{count}} minutit"
    },
    withPreposition: {
      one: "ühe minuti",
      other: "{{count}} minuti"
    }
  },
  aboutXHours: {
    standalone: {
      one: "umbes üks tund",
      other: "umbes {{count}} tundi"
    },
    withPreposition: {
      one: "umbes ühe tunni",
      other: "umbes {{count}} tunni"
    }
  },
  xHours: {
    standalone: {
      one: "üks tund",
      other: "{{count}} tundi"
    },
    withPreposition: {
      one: "ühe tunni",
      other: "{{count}} tunni"
    }
  },
  xDays: {
    standalone: {
      one: "üks päev",
      other: "{{count}} päeva"
    },
    withPreposition: {
      one: "ühe päeva",
      other: "{{count}} päeva"
    }
  },
  aboutXWeeks: {
    standalone: {
      one: "umbes üks nädal",
      other: "umbes {{count}} nädalat"
    },
    withPreposition: {
      one: "umbes ühe nädala",
      other: "umbes {{count}} nädala"
    }
  },
  xWeeks: {
    standalone: {
      one: "üks nädal",
      other: "{{count}} nädalat"
    },
    withPreposition: {
      one: "ühe nädala",
      other: "{{count}} nädala"
    }
  },
  aboutXMonths: {
    standalone: {
      one: "umbes üks kuu",
      other: "umbes {{count}} kuud"
    },
    withPreposition: {
      one: "umbes ühe kuu",
      other: "umbes {{count}} kuu"
    }
  },
  xMonths: {
    standalone: {
      one: "üks kuu",
      other: "{{count}} kuud"
    },
    withPreposition: {
      one: "ühe kuu",
      other: "{{count}} kuu"
    }
  },
  aboutXYears: {
    standalone: {
      one: "umbes üks aasta",
      other: "umbes {{count}} aastat"
    },
    withPreposition: {
      one: "umbes ühe aasta",
      other: "umbes {{count}} aasta"
    }
  },
  xYears: {
    standalone: {
      one: "üks aasta",
      other: "{{count}} aastat"
    },
    withPreposition: {
      one: "ühe aasta",
      other: "{{count}} aasta"
    }
  },
  overXYears: {
    standalone: {
      one: "rohkem kui üks aasta",
      other: "rohkem kui {{count}} aastat"
    },
    withPreposition: {
      one: "rohkem kui ühe aasta",
      other: "rohkem kui {{count}} aasta"
    }
  },
  almostXYears: {
    standalone: {
      one: "peaaegu üks aasta",
      other: "peaaegu {{count}} aastat"
    },
    withPreposition: {
      one: "peaaegu ühe aasta",
      other: "peaaegu {{count}} aasta"
    }
  }
}, lVe = (e, t, r) => {
  const a = r?.addSuffix ? WB[e].withPreposition : WB[e].standalone;
  let i;
  return typeof a == "string" ? i = a : t === 1 ? i = a.one : i = a.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? i + " pärast" : i + " eest" : i;
}, sVe = {
  full: "EEEE, d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd.MM.y"
}, uVe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, cVe = {
  full: "{{date}} 'kell' {{time}}",
  long: "{{date}} 'kell' {{time}}",
  medium: "{{date}}. {{time}}",
  short: "{{date}}. {{time}}"
}, dVe = {
  date: Ke({
    formats: sVe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: uVe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: cVe,
    defaultWidth: "full"
  })
}, fVe = {
  lastWeek: "'eelmine' eeee 'kell' p",
  yesterday: "'eile kell' p",
  today: "'täna kell' p",
  tomorrow: "'homme kell' p",
  nextWeek: "'järgmine' eeee 'kell' p",
  other: "P"
}, mVe = (e, t, r, a) => fVe[e], hVe = {
  narrow: ["e.m.a", "m.a.j"],
  abbreviated: ["e.m.a", "m.a.j"],
  wide: ["enne meie ajaarvamist", "meie ajaarvamise järgi"]
}, pVe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, VB = {
  narrow: ["J", "V", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jaan",
    "veebr",
    "märts",
    "apr",
    "mai",
    "juuni",
    "juuli",
    "aug",
    "sept",
    "okt",
    "nov",
    "dets"
  ],
  wide: [
    "jaanuar",
    "veebruar",
    "märts",
    "aprill",
    "mai",
    "juuni",
    "juuli",
    "august",
    "september",
    "oktoober",
    "november",
    "detsember"
  ]
}, _B = {
  narrow: ["P", "E", "T", "K", "N", "R", "L"],
  short: ["P", "E", "T", "K", "N", "R", "L"],
  abbreviated: [
    "pühap.",
    "esmasp.",
    "teisip.",
    "kolmap.",
    "neljap.",
    "reede.",
    "laup."
  ],
  wide: [
    "pühapäev",
    "esmaspäev",
    "teisipäev",
    "kolmapäev",
    "neljapäev",
    "reede",
    "laupäev"
  ]
}, gVe = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "kesköö",
    noon: "keskpäev",
    morning: "hommik",
    afternoon: "pärastlõuna",
    evening: "õhtu",
    night: "öö"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "kesköö",
    noon: "keskpäev",
    morning: "hommik",
    afternoon: "pärastlõuna",
    evening: "õhtu",
    night: "öö"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "kesköö",
    noon: "keskpäev",
    morning: "hommik",
    afternoon: "pärastlõuna",
    evening: "õhtu",
    night: "öö"
  }
}, vVe = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "keskööl",
    noon: "keskpäeval",
    morning: "hommikul",
    afternoon: "pärastlõunal",
    evening: "õhtul",
    night: "öösel"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "keskööl",
    noon: "keskpäeval",
    morning: "hommikul",
    afternoon: "pärastlõunal",
    evening: "õhtul",
    night: "öösel"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "keskööl",
    noon: "keskpäeval",
    morning: "hommikul",
    afternoon: "pärastlõunal",
    evening: "õhtul",
    night: "öösel"
  }
}, bVe = (e, t) => Number(e) + ".", yVe = {
  ordinalNumber: bVe,
  era: Ce({
    values: hVe,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: pVe,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: VB,
    defaultWidth: "wide",
    formattingValues: VB,
    defaultFormattingWidth: "wide"
  }),
  day: Ce({
    values: _B,
    defaultWidth: "wide",
    formattingValues: _B,
    defaultFormattingWidth: "wide"
  }),
  dayPeriod: Ce({
    values: gVe,
    defaultWidth: "wide",
    formattingValues: vVe,
    defaultFormattingWidth: "wide"
  })
}, wVe = /^\d+\./i, SVe = /\d+/i, CVe = {
  narrow: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
  abbreviated: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
  wide: /^(enne meie ajaarvamist|meie ajaarvamise järgi|enne Kristust|pärast Kristust)/i
}, xVe = {
  any: [/^e/i, /^(m|p)/i]
}, EVe = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234](\.)? kvartal/i
}, PVe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, kVe = {
  narrow: /^[jvmasond]/i,
  abbreviated: /^(jaan|veebr|märts|apr|mai|juuni|juuli|aug|sept|okt|nov|dets)/i,
  wide: /^(jaanuar|veebruar|märts|aprill|mai|juuni|juuli|august|september|oktoober|november|detsember)/i
}, MVe = {
  narrow: [
    /^j/i,
    /^v/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^v/i,
    /^mär/i,
    /^ap/i,
    /^mai/i,
    /^juun/i,
    /^juul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, OVe = {
  narrow: /^[petknrl]/i,
  short: /^[petknrl]/i,
  abbreviated: /^(püh?|esm?|tei?|kolm?|nel?|ree?|laup?)\.?/i,
  wide: /^(pühapäev|esmaspäev|teisipäev|kolmapäev|neljapäev|reede|laupäev)/i
}, TVe = {
  any: [/^p/i, /^e/i, /^t/i, /^k/i, /^n/i, /^r/i, /^l/i]
}, RVe = {
  any: /^(am|pm|keskööl?|keskpäev(al)?|hommik(ul)?|pärastlõunal?|õhtul?|öö(sel)?)/i
}, AVe = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^keskö/i,
    noon: /^keskp/i,
    morning: /hommik/i,
    afternoon: /pärastlõuna/i,
    evening: /õhtu/i,
    night: /öö/i
  }
}, NVe = {
  ordinalNumber: Fn({
    matchPattern: wVe,
    parsePattern: SVe,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: CVe,
    defaultMatchWidth: "wide",
    parsePatterns: xVe,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: EVe,
    defaultMatchWidth: "wide",
    parsePatterns: PVe,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: kVe,
    defaultMatchWidth: "wide",
    parsePatterns: MVe,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: OVe,
    defaultMatchWidth: "wide",
    parsePatterns: TVe,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: RVe,
    defaultMatchWidth: "any",
    parsePatterns: AVe,
    defaultParseWidth: "any"
  })
}, DVe = {
  code: "et",
  formatDistance: lVe,
  formatLong: dVe,
  formatRelative: mVe,
  localize: yVe,
  match: NVe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, $Ve = {
  lessThanXSeconds: {
    one: "segundo bat baino gutxiago",
    other: "{{count}} segundo baino gutxiago"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundo"
  },
  halfAMinute: "minutu erdi",
  lessThanXMinutes: {
    one: "minutu bat baino gutxiago",
    other: "{{count}} minutu baino gutxiago"
  },
  xMinutes: {
    one: "1 minutu",
    other: "{{count}} minutu"
  },
  aboutXHours: {
    one: "1 ordu gutxi gorabehera",
    other: "{{count}} ordu gutxi gorabehera"
  },
  xHours: {
    one: "1 ordu",
    other: "{{count}} ordu"
  },
  xDays: {
    one: "1 egun",
    other: "{{count}} egun"
  },
  aboutXWeeks: {
    one: "aste 1 inguru",
    other: "{{count}} aste inguru"
  },
  xWeeks: {
    one: "1 aste",
    other: "{{count}} astean"
  },
  aboutXMonths: {
    one: "1 hilabete gutxi gorabehera",
    other: "{{count}} hilabete gutxi gorabehera"
  },
  xMonths: {
    one: "1 hilabete",
    other: "{{count}} hilabete"
  },
  aboutXYears: {
    one: "1 urte gutxi gorabehera",
    other: "{{count}} urte gutxi gorabehera"
  },
  xYears: {
    one: "1 urte",
    other: "{{count}} urte"
  },
  overXYears: {
    one: "1 urte baino gehiago",
    other: "{{count}} urte baino gehiago"
  },
  almostXYears: {
    one: "ia 1 urte",
    other: "ia {{count}} urte"
  }
}, zVe = (e, t, r) => {
  let a;
  const i = $Ve[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? "en " + a : "duela " + a : a;
}, jVe = {
  full: "EEEE, y'ko' MMMM'ren' d'a' y'ren'",
  long: "y'ko' MMMM'ren' d'a'",
  medium: "y MMM d",
  short: "yy/MM/dd"
}, IVe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, LVe = {
  full: "{{date}} 'tan' {{time}}",
  long: "{{date}} 'tan' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, HVe = {
  date: Ke({
    formats: jVe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: IVe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: LVe,
    defaultWidth: "full"
  })
}, FVe = {
  lastWeek: "'joan den' eeee, LT",
  yesterday: "'atzo,' p",
  today: "'gaur,' p",
  tomorrow: "'bihar,' p",
  nextWeek: "eeee, p",
  other: "P"
}, WVe = {
  lastWeek: "'joan den' eeee, p",
  yesterday: "'atzo,' p",
  today: "'gaur,' p",
  tomorrow: "'bihar,' p",
  nextWeek: "eeee, p",
  other: "P"
}, VVe = (e, t) => t.getHours() !== 1 ? WVe[e] : FVe[e], _Ve = {
  narrow: ["k.a.", "k.o."],
  abbreviated: ["k.a.", "k.o."],
  wide: ["kristo aurretik", "kristo ondoren"]
}, BVe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1H", "2H", "3H", "4H"],
  wide: [
    "1. hiruhilekoa",
    "2. hiruhilekoa",
    "3. hiruhilekoa",
    "4. hiruhilekoa"
  ]
}, UVe = {
  narrow: ["u", "o", "m", "a", "m", "e", "u", "a", "i", "u", "a", "a"],
  abbreviated: [
    "urt",
    "ots",
    "mar",
    "api",
    "mai",
    "eka",
    "uzt",
    "abu",
    "ira",
    "urr",
    "aza",
    "abe"
  ],
  wide: [
    "urtarrila",
    "otsaila",
    "martxoa",
    "apirila",
    "maiatza",
    "ekaina",
    "uztaila",
    "abuztua",
    "iraila",
    "urria",
    "azaroa",
    "abendua"
  ]
}, XVe = {
  narrow: ["i", "a", "a", "a", "o", "o", "l"],
  short: ["ig", "al", "as", "az", "og", "or", "lr"],
  abbreviated: ["iga", "ast", "ast", "ast", "ost", "ost", "lar"],
  wide: [
    "igandea",
    "astelehena",
    "asteartea",
    "asteazkena",
    "osteguna",
    "ostirala",
    "larunbata"
  ]
}, GVe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "ge",
    noon: "eg",
    morning: "goiza",
    afternoon: "arratsaldea",
    evening: "arratsaldea",
    night: "gaua"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "gauerdia",
    noon: "eguerdia",
    morning: "goiza",
    afternoon: "arratsaldea",
    evening: "arratsaldea",
    night: "gaua"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "gauerdia",
    noon: "eguerdia",
    morning: "goiza",
    afternoon: "arratsaldea",
    evening: "arratsaldea",
    night: "gaua"
  }
}, qVe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "ge",
    noon: "eg",
    morning: "goizean",
    afternoon: "arratsaldean",
    evening: "arratsaldean",
    night: "gauean"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "gauerdia",
    noon: "eguerdia",
    morning: "goizean",
    afternoon: "arratsaldean",
    evening: "arratsaldean",
    night: "gauean"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "gauerdia",
    noon: "eguerdia",
    morning: "goizean",
    afternoon: "arratsaldean",
    evening: "arratsaldean",
    night: "gauean"
  }
}, KVe = (e, t) => Number(e) + ".", YVe = {
  ordinalNumber: KVe,
  era: Ce({
    values: _Ve,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: BVe,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: UVe,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: XVe,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: GVe,
    defaultWidth: "wide",
    formattingValues: qVe,
    defaultFormattingWidth: "wide"
  })
}, QVe = /^(\d+)(.)?/i, JVe = /\d+/i, ZVe = {
  narrow: /^(k.a.|k.o.)/i,
  abbreviated: /^(k.a.|k.o.)/i,
  wide: /^(kristo aurretik|kristo ondoren)/i
}, e_e = {
  narrow: [/^k.a./i, /^k.o./i],
  abbreviated: [/^(k.a.)/i, /^(k.o.)/i],
  wide: [/^(kristo aurretik)/i, /^(kristo ondoren)/i]
}, t_e = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]H/i,
  wide: /^[1234](.)? hiruhilekoa/i
}, n_e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, r_e = {
  narrow: /^[uomaei]/i,
  abbreviated: /^(urt|ots|mar|api|mai|eka|uzt|abu|ira|urr|aza|abe)/i,
  wide: /^(urtarrila|otsaila|martxoa|apirila|maiatza|ekaina|uztaila|abuztua|iraila|urria|azaroa|abendua)/i
}, a_e = {
  narrow: [
    /^u/i,
    /^o/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^e/i,
    /^u/i,
    /^a/i,
    /^i/i,
    /^u/i,
    /^a/i,
    /^a/i
  ],
  any: [
    /^urt/i,
    /^ots/i,
    /^mar/i,
    /^api/i,
    /^mai/i,
    /^eka/i,
    /^uzt/i,
    /^abu/i,
    /^ira/i,
    /^urr/i,
    /^aza/i,
    /^abe/i
  ]
}, o_e = {
  narrow: /^[iaol]/i,
  short: /^(ig|al|as|az|og|or|lr)/i,
  abbreviated: /^(iga|ast|ast|ast|ost|ost|lar)/i,
  wide: /^(igandea|astelehena|asteartea|asteazkena|osteguna|ostirala|larunbata)/i
}, i_e = {
  narrow: [/^i/i, /^a/i, /^a/i, /^a/i, /^o/i, /^o/i, /^l/i],
  short: [/^ig/i, /^al/i, /^as/i, /^az/i, /^og/i, /^or/i, /^lr/i],
  abbreviated: [/^iga/i, /^ast/i, /^ast/i, /^ast/i, /^ost/i, /^ost/i, /^lar/i],
  wide: [
    /^igandea/i,
    /^astelehena/i,
    /^asteartea/i,
    /^asteazkena/i,
    /^osteguna/i,
    /^ostirala/i,
    /^larunbata/i
  ]
}, l_e = {
  narrow: /^(a|p|ge|eg|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i,
  any: /^([ap]\.?\s?m\.?|gauerdia|eguerdia|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i
}, s_e = {
  narrow: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^ge/i,
    noon: /^eg/i,
    morning: /goiz/i,
    afternoon: /arratsaldea/i,
    evening: /arratsaldea/i,
    night: /gau/i
  },
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^gauerdia/i,
    noon: /^eguerdia/i,
    morning: /goiz/i,
    afternoon: /arratsaldea/i,
    evening: /arratsaldea/i,
    night: /gau/i
  }
}, u_e = {
  ordinalNumber: Fn({
    matchPattern: QVe,
    parsePattern: JVe,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: ZVe,
    defaultMatchWidth: "wide",
    parsePatterns: e_e,
    defaultParseWidth: "wide"
  }),
  quarter: Ee({
    matchPatterns: t_e,
    defaultMatchWidth: "wide",
    parsePatterns: n_e,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: r_e,
    defaultMatchWidth: "wide",
    parsePatterns: a_e,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: o_e,
    defaultMatchWidth: "wide",
    parsePatterns: i_e,
    defaultParseWidth: "wide"
  }),
  dayPeriod: Ee({
    matchPatterns: l_e,
    defaultMatchWidth: "any",
    parsePatterns: s_e,
    defaultParseWidth: "any"
  })
}, c_e = {
  code: "eu",
  formatDistance: zVe,
  formatLong: HVe,
  formatRelative: VVe,
  localize: YVe,
  match: u_e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, d_e = {
  lessThanXSeconds: {
    one: "کمتر از یک ثانیه",
    other: "کمتر از {{count}} ثانیه"
  },
  xSeconds: {
    one: "1 ثانیه",
    other: "{{count}} ثانیه"
  },
  halfAMinute: "نیم دقیقه",
  lessThanXMinutes: {
    one: "کمتر از یک دقیقه",
    other: "کمتر از {{count}} دقیقه"
  },
  xMinutes: {
    one: "1 دقیقه",
    other: "{{count}} دقیقه"
  },
  aboutXHours: {
    one: "حدود 1 ساعت",
    other: "حدود {{count}} ساعت"
  },
  xHours: {
    one: "1 ساعت",
    other: "{{count}} ساعت"
  },
  xDays: {
    one: "1 روز",
    other: "{{count}} روز"
  },
  aboutXWeeks: {
    one: "حدود 1 هفته",
    other: "حدود {{count}} هفته"
  },
  xWeeks: {
    one: "1 هفته",
    other: "{{count}} هفته"
  },
  aboutXMonths: {
    one: "حدود 1 ماه",
    other: "حدود {{count}} ماه"
  },
  xMonths: {
    one: "1 ماه",
    other: "{{count}} ماه"
  },
  aboutXYears: {
    one: "حدود 1 سال",
    other: "حدود {{count}} سال"
  },
  xYears: {
    one: "1 سال",
    other: "{{count}} سال"
  },
  overXYears: {
    one: "بیشتر از 1 سال",
    other: "بیشتر از {{count}} سال"
  },
  almostXYears: {
    one: "نزدیک 1 سال",
    other: "نزدیک {{count}} سال"
  }
}, f_e = (e, t, r) => {
  let a;
  const i = d_e[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? "در " + a : a + " قبل" : a;
}, m_e = {
  full: "EEEE do MMMM y",
  long: "do MMMM y",
  medium: "d MMM y",
  short: "yyyy/MM/dd"
}, h_e = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, p_e = {
  full: "{{date}} 'در' {{time}}",
  long: "{{date}} 'در' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, g_e = {
  date: Ke({
    formats: m_e,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: h_e,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: p_e,
    defaultWidth: "full"
  })
}, v_e = {
  lastWeek: "eeee 'گذشته در' p",
  yesterday: "'دیروز در' p",
  today: "'امروز در' p",
  tomorrow: "'فردا در' p",
  nextWeek: "eeee 'در' p",
  other: "P"
}, b_e = (e, t, r, a) => v_e[e], y_e = {
  narrow: ["ق", "ب"],
  abbreviated: ["ق.م.", "ب.م."],
  wide: ["قبل از میلاد", "بعد از میلاد"]
}, w_e = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["س‌م1", "س‌م2", "س‌م3", "س‌م4"],
  wide: ["سه‌ماهه 1", "سه‌ماهه 2", "سه‌ماهه 3", "سه‌ماهه 4"]
}, S_e = {
  narrow: ["ژ", "ف", "م", "آ", "م", "ج", "ج", "آ", "س", "ا", "ن", "د"],
  abbreviated: [
    "ژانـ",
    "فور",
    "مارس",
    "آپر",
    "می",
    "جون",
    "جولـ",
    "آگو",
    "سپتـ",
    "اکتـ",
    "نوامـ",
    "دسامـ"
  ],
  wide: [
    "ژانویه",
    "فوریه",
    "مارس",
    "آپریل",
    "می",
    "جون",
    "جولای",
    "آگوست",
    "سپتامبر",
    "اکتبر",
    "نوامبر",
    "دسامبر"
  ]
}, C_e = {
  narrow: ["ی", "د", "س", "چ", "پ", "ج", "ش"],
  short: ["1ش", "2ش", "3ش", "4ش", "5ش", "ج", "ش"],
  abbreviated: [
    "یکشنبه",
    "دوشنبه",
    "سه‌شنبه",
    "چهارشنبه",
    "پنجشنبه",
    "جمعه",
    "شنبه"
  ],
  wide: ["یکشنبه", "دوشنبه", "سه‌شنبه", "چهارشنبه", "پنجشنبه", "جمعه", "شنبه"]
}, x_e = {
  narrow: {
    am: "ق",
    pm: "ب",
    midnight: "ن",
    noon: "ظ",
    morning: "ص",
    afternoon: "ب.ظ.",
    evening: "ع",
    night: "ش"
  },
  abbreviated: {
    am: "ق.ظ.",
    pm: "ب.ظ.",
    midnight: "نیمه‌شب",
    noon: "ظهر",
    morning: "صبح",
    afternoon: "بعدازظهر",
    evening: "عصر",
    night: "شب"
  },
  wide: {
    am: "قبل‌ازظهر",
    pm: "بعدازظهر",
    midnight: "نیمه‌شب",
    noon: "ظهر",
    morning: "صبح",
    afternoon: "بعدازظهر",
    evening: "عصر",
    night: "شب"
  }
}, E_e = {
  narrow: {
    am: "ق",
    pm: "ب",
    midnight: "ن",
    noon: "ظ",
    morning: "ص",
    afternoon: "ب.ظ.",
    evening: "ع",
    night: "ش"
  },
  abbreviated: {
    am: "ق.ظ.",
    pm: "ب.ظ.",
    midnight: "نیمه‌شب",
    noon: "ظهر",
    morning: "صبح",
    afternoon: "بعدازظهر",
    evening: "عصر",
    night: "شب"
  },
  wide: {
    am: "قبل‌ازظهر",
    pm: "بعدازظهر",
    midnight: "نیمه‌شب",
    noon: "ظهر",
    morning: "صبح",
    afternoon: "بعدازظهر",
    evening: "عصر",
    night: "شب"
  }
}, P_e = (e, t) => String(e), k_e = {
  ordinalNumber: P_e,
  era: Ce({
    values: y_e,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: w_e,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: S_e,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: C_e,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: x_e,
    defaultWidth: "wide",
    formattingValues: E_e,
    defaultFormattingWidth: "wide"
  })
}, M_e = /^(\d+)(th|st|nd|rd)?/i, O_e = /\d+/i, T_e = {
  narrow: /^(ق|ب)/i,
  abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?د\.?\s?م\.?|م\.?\s?|د\.?\s?م\.?)/i,
  wide: /^(قبل از میلاد|قبل از دوران مشترک|میلادی|دوران مشترک|بعد از میلاد)/i
}, R_e = {
  any: [/^قبل/i, /^بعد/i]
}, A_e = {
  narrow: /^[1234]/i,
  abbreviated: /^س‌م[1234]/i,
  wide: /^سه‌ماهه [1234]/i
}, N_e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, D_e = {
  narrow: /^[جژفمآاماسند]/i,
  abbreviated: /^(جنو|ژانـ|ژانویه|فوریه|فور|مارس|آوریل|آپر|مه|می|ژوئن|جون|جول|جولـ|ژوئیه|اوت|آگو|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نوامـ|دسامبر|دسامـ|دسم)/i,
  wide: /^(ژانویه|جنوری|فبروری|فوریه|مارچ|مارس|آپریل|اپریل|ایپریل|آوریل|مه|می|ژوئن|جون|جولای|ژوئیه|آگست|اگست|آگوست|اوت|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نومبر|دسامبر|دسمبر)/i
}, $_e = {
  narrow: [
    /^(ژ|ج)/i,
    /^ف/i,
    /^م/i,
    /^(آ|ا)/i,
    /^م/i,
    /^(ژ|ج)/i,
    /^(ج|ژ)/i,
    /^(آ|ا)/i,
    /^س/i,
    /^ا/i,
    /^ن/i,
    /^د/i
  ],
  any: [
    /^ژا/i,
    /^ف/i,
    /^ما/i,
    /^آپ/i,
    /^(می|مه)/i,
    /^(ژوئن|جون)/i,
    /^(ژوئی|جول)/i,
    /^(اوت|آگ)/i,
    /^س/i,
    /^(اوک|اک)/i,
    /^ن/i,
    /^د/i
  ]
}, z_e = {
  narrow: /^[شیدسچپج]/i,
  short: /^(ش|ج|1ش|2ش|3ش|4ش|5ش)/i,
  abbreviated: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i,
  wide: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i
}, j_e = {
  narrow: [/^ی/i, /^دو/i, /^س/i, /^چ/i, /^پ/i, /^ج/i, /^ش/i],
  any: [
    /^(ی|1ش|یکشنبه)/i,
    /^(د|2ش|دوشنبه)/i,
    /^(س|3ش|سه‌شنبه)/i,
    /^(چ|4ش|چهارشنبه)/i,
    /^(پ|5ش|پنجشنبه)/i,
    /^(ج|جمعه)/i,
    /^(ش|شنبه)/i
  ]
}, I_e = {
  narrow: /^(ب|ق|ن|ظ|ص|ب.ظ.|ع|ش)/i,
  abbreviated: /^(ق.ظ.|ب.ظ.|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i,
  wide: /^(قبل‌ازظهر|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i
}, L_e = {
  any: {
    am: /^(ق|ق.ظ.|قبل‌ازظهر)/i,
    pm: /^(ب|ب.ظ.|بعدازظهر)/i,
    midnight: /^(‌نیمه‌شب|ن)/i,
    noon: /^(ظ|ظهر)/i,
    morning: /(ص|صبح)/i,
    afternoon: /(ب|ب.ظ.|بعدازظهر)/i,
    evening: /(ع|عصر)/i,
    night: /(ش|شب)/i
  }
}, H_e = {
  ordinalNumber: Fn({
    matchPattern: M_e,
    parsePattern: O_e,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: T_e,
    defaultMatchWidth: "wide",
    parsePatterns: R_e,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: A_e,
    defaultMatchWidth: "wide",
    parsePatterns: N_e,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: D_e,
    defaultMatchWidth: "wide",
    parsePatterns: $_e,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: z_e,
    defaultMatchWidth: "wide",
    parsePatterns: j_e,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: I_e,
    defaultMatchWidth: "wide",
    parsePatterns: L_e,
    defaultParseWidth: "any"
  })
}, F_e = {
  code: "fa-IR",
  formatDistance: f_e,
  formatLong: g_e,
  formatRelative: b_e,
  localize: k_e,
  match: H_e,
  options: {
    weekStartsOn: 6,
    firstWeekContainsDate: 1
  }
};
function BB(e) {
  return e.replace(/sekuntia?/, "sekunnin");
}
function UB(e) {
  return e.replace(/minuuttia?/, "minuutin");
}
function XB(e) {
  return e.replace(/tuntia?/, "tunnin");
}
function W_e(e) {
  return e.replace(/päivää?/, "päivän");
}
function GB(e) {
  return e.replace(/(viikko|viikkoa)/, "viikon");
}
function qB(e) {
  return e.replace(/(kuukausi|kuukautta)/, "kuukauden");
}
function xP(e) {
  return e.replace(/(vuosi|vuotta)/, "vuoden");
}
const V_e = {
  lessThanXSeconds: {
    one: "alle sekunti",
    other: "alle {{count}} sekuntia",
    futureTense: BB
  },
  xSeconds: {
    one: "sekunti",
    other: "{{count}} sekuntia",
    futureTense: BB
  },
  halfAMinute: {
    one: "puoli minuuttia",
    other: "puoli minuuttia",
    futureTense: (e) => "puolen minuutin"
  },
  lessThanXMinutes: {
    one: "alle minuutti",
    other: "alle {{count}} minuuttia",
    futureTense: UB
  },
  xMinutes: {
    one: "minuutti",
    other: "{{count}} minuuttia",
    futureTense: UB
  },
  aboutXHours: {
    one: "noin tunti",
    other: "noin {{count}} tuntia",
    futureTense: XB
  },
  xHours: {
    one: "tunti",
    other: "{{count}} tuntia",
    futureTense: XB
  },
  xDays: {
    one: "päivä",
    other: "{{count}} päivää",
    futureTense: W_e
  },
  aboutXWeeks: {
    one: "noin viikko",
    other: "noin {{count}} viikkoa",
    futureTense: GB
  },
  xWeeks: {
    one: "viikko",
    other: "{{count}} viikkoa",
    futureTense: GB
  },
  aboutXMonths: {
    one: "noin kuukausi",
    other: "noin {{count}} kuukautta",
    futureTense: qB
  },
  xMonths: {
    one: "kuukausi",
    other: "{{count}} kuukautta",
    futureTense: qB
  },
  aboutXYears: {
    one: "noin vuosi",
    other: "noin {{count}} vuotta",
    futureTense: xP
  },
  xYears: {
    one: "vuosi",
    other: "{{count}} vuotta",
    futureTense: xP
  },
  overXYears: {
    one: "yli vuosi",
    other: "yli {{count}} vuotta",
    futureTense: xP
  },
  almostXYears: {
    one: "lähes vuosi",
    other: "lähes {{count}} vuotta",
    futureTense: xP
  }
}, __e = (e, t, r) => {
  const a = V_e[e], i = t === 1 ? a.one : a.other.replace("{{count}}", String(t));
  return r?.addSuffix ? r.comparison && r.comparison > 0 ? a.futureTense(i) + " kuluttua" : i + " sitten" : i;
}, B_e = {
  full: "eeee d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "d.M.y"
}, U_e = {
  full: "HH.mm.ss zzzz",
  long: "HH.mm.ss z",
  medium: "HH.mm.ss",
  short: "HH.mm"
}, X_e = {
  full: "{{date}} 'klo' {{time}}",
  long: "{{date}} 'klo' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, G_e = {
  date: Ke({
    formats: B_e,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: U_e,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: X_e,
    defaultWidth: "full"
  })
}, q_e = {
  lastWeek: "'viime' eeee 'klo' p",
  yesterday: "'eilen klo' p",
  today: "'tänään klo' p",
  tomorrow: "'huomenna klo' p",
  nextWeek: "'ensi' eeee 'klo' p",
  other: "P"
}, K_e = (e, t, r, a) => q_e[e], Y_e = {
  narrow: ["eaa.", "jaa."],
  abbreviated: ["eaa.", "jaa."],
  wide: ["ennen ajanlaskun alkua", "jälkeen ajanlaskun alun"]
}, Q_e = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. kvartaali", "2. kvartaali", "3. kvartaali", "4. kvartaali"]
}, D$ = {
  narrow: ["T", "H", "M", "H", "T", "K", "H", "E", "S", "L", "M", "J"],
  abbreviated: [
    "tammi",
    "helmi",
    "maalis",
    "huhti",
    "touko",
    "kesä",
    "heinä",
    "elo",
    "syys",
    "loka",
    "marras",
    "joulu"
  ],
  wide: [
    "tammikuu",
    "helmikuu",
    "maaliskuu",
    "huhtikuu",
    "toukokuu",
    "kesäkuu",
    "heinäkuu",
    "elokuu",
    "syyskuu",
    "lokakuu",
    "marraskuu",
    "joulukuu"
  ]
}, J_e = {
  narrow: D$.narrow,
  abbreviated: D$.abbreviated,
  wide: [
    "tammikuuta",
    "helmikuuta",
    "maaliskuuta",
    "huhtikuuta",
    "toukokuuta",
    "kesäkuuta",
    "heinäkuuta",
    "elokuuta",
    "syyskuuta",
    "lokakuuta",
    "marraskuuta",
    "joulukuuta"
  ]
}, xk = {
  narrow: ["S", "M", "T", "K", "T", "P", "L"],
  short: ["su", "ma", "ti", "ke", "to", "pe", "la"],
  abbreviated: ["sunn.", "maan.", "tiis.", "kesk.", "torst.", "perj.", "la"],
  wide: [
    "sunnuntai",
    "maanantai",
    "tiistai",
    "keskiviikko",
    "torstai",
    "perjantai",
    "lauantai"
  ]
}, Z_e = {
  narrow: xk.narrow,
  short: xk.short,
  abbreviated: xk.abbreviated,
  wide: [
    "sunnuntaina",
    "maanantaina",
    "tiistaina",
    "keskiviikkona",
    "torstaina",
    "perjantaina",
    "lauantaina"
  ]
}, eBe = {
  narrow: {
    am: "ap",
    pm: "ip",
    midnight: "keskiyö",
    noon: "keskipäivä",
    morning: "ap",
    afternoon: "ip",
    evening: "illalla",
    night: "yöllä"
  },
  abbreviated: {
    am: "ap",
    pm: "ip",
    midnight: "keskiyö",
    noon: "keskipäivä",
    morning: "ap",
    afternoon: "ip",
    evening: "illalla",
    night: "yöllä"
  },
  wide: {
    am: "ap",
    pm: "ip",
    midnight: "keskiyöllä",
    noon: "keskipäivällä",
    morning: "aamupäivällä",
    afternoon: "iltapäivällä",
    evening: "illalla",
    night: "yöllä"
  }
}, tBe = (e, t) => Number(e) + ".", nBe = {
  ordinalNumber: tBe,
  era: Ce({
    values: Y_e,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: Q_e,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: D$,
    defaultWidth: "wide",
    formattingValues: J_e,
    defaultFormattingWidth: "wide"
  }),
  day: Ce({
    values: xk,
    defaultWidth: "wide",
    formattingValues: Z_e,
    defaultFormattingWidth: "wide"
  }),
  dayPeriod: Ce({
    values: eBe,
    defaultWidth: "wide"
  })
}, rBe = /^(\d+)(\.)/i, aBe = /\d+/i, oBe = {
  narrow: /^(e|j)/i,
  abbreviated: /^(eaa.|jaa.)/i,
  wide: /^(ennen ajanlaskun alkua|jälkeen ajanlaskun alun)/i
}, iBe = {
  any: [/^e/i, /^j/i]
}, lBe = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]\.? kvartaali/i
}, sBe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, uBe = {
  narrow: /^[thmkeslj]/i,
  abbreviated: /^(tammi|helmi|maalis|huhti|touko|kesä|heinä|elo|syys|loka|marras|joulu)/i,
  wide: /^(tammikuu|helmikuu|maaliskuu|huhtikuu|toukokuu|kesäkuu|heinäkuu|elokuu|syyskuu|lokakuu|marraskuu|joulukuu)(ta)?/i
}, cBe = {
  narrow: [
    /^t/i,
    /^h/i,
    /^m/i,
    /^h/i,
    /^t/i,
    /^k/i,
    /^h/i,
    /^e/i,
    /^s/i,
    /^l/i,
    /^m/i,
    /^j/i
  ],
  any: [
    /^ta/i,
    /^hel/i,
    /^maa/i,
    /^hu/i,
    /^to/i,
    /^k/i,
    /^hei/i,
    /^e/i,
    /^s/i,
    /^l/i,
    /^mar/i,
    /^j/i
  ]
}, dBe = {
  narrow: /^[smtkpl]/i,
  short: /^(su|ma|ti|ke|to|pe|la)/i,
  abbreviated: /^(sunn.|maan.|tiis.|kesk.|torst.|perj.|la)/i,
  wide: /^(sunnuntai|maanantai|tiistai|keskiviikko|torstai|perjantai|lauantai)(na)?/i
}, fBe = {
  narrow: [/^s/i, /^m/i, /^t/i, /^k/i, /^t/i, /^p/i, /^l/i],
  any: [/^s/i, /^m/i, /^ti/i, /^k/i, /^to/i, /^p/i, /^l/i]
}, mBe = {
  narrow: /^(ap|ip|keskiyö|keskipäivä|aamupäivällä|iltapäivällä|illalla|yöllä)/i,
  any: /^(ap|ip|keskiyöllä|keskipäivällä|aamupäivällä|iltapäivällä|illalla|yöllä)/i
}, hBe = {
  any: {
    am: /^ap/i,
    pm: /^ip/i,
    midnight: /^keskiyö/i,
    noon: /^keskipäivä/i,
    morning: /aamupäivällä/i,
    afternoon: /iltapäivällä/i,
    evening: /illalla/i,
    night: /yöllä/i
  }
}, pBe = {
  ordinalNumber: Fn({
    matchPattern: rBe,
    parsePattern: aBe,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: oBe,
    defaultMatchWidth: "wide",
    parsePatterns: iBe,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: lBe,
    defaultMatchWidth: "wide",
    parsePatterns: sBe,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: uBe,
    defaultMatchWidth: "wide",
    parsePatterns: cBe,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: dBe,
    defaultMatchWidth: "wide",
    parsePatterns: fBe,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: mBe,
    defaultMatchWidth: "any",
    parsePatterns: hBe,
    defaultParseWidth: "any"
  })
}, gBe = {
  code: "fi",
  formatDistance: __e,
  formatLong: G_e,
  formatRelative: K_e,
  localize: nBe,
  match: pBe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, vBe = {
  lessThanXSeconds: {
    one: "moins d’une seconde",
    other: "moins de {{count}} secondes"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} secondes"
  },
  halfAMinute: "30 secondes",
  lessThanXMinutes: {
    one: "moins d’une minute",
    other: "moins de {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "environ 1 heure",
    other: "environ {{count}} heures"
  },
  xHours: {
    one: "1 heure",
    other: "{{count}} heures"
  },
  xDays: {
    one: "1 jour",
    other: "{{count}} jours"
  },
  aboutXWeeks: {
    one: "environ 1 semaine",
    other: "environ {{count}} semaines"
  },
  xWeeks: {
    one: "1 semaine",
    other: "{{count}} semaines"
  },
  aboutXMonths: {
    one: "environ 1 mois",
    other: "environ {{count}} mois"
  },
  xMonths: {
    one: "1 mois",
    other: "{{count}} mois"
  },
  aboutXYears: {
    one: "environ 1 an",
    other: "environ {{count}} ans"
  },
  xYears: {
    one: "1 an",
    other: "{{count}} ans"
  },
  overXYears: {
    one: "plus d’un an",
    other: "plus de {{count}} ans"
  },
  almostXYears: {
    one: "presqu’un an",
    other: "presque {{count}} ans"
  }
}, wI = (e, t, r) => {
  let a;
  const i = vBe[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? "dans " + a : "il y a " + a : a;
}, bBe = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, yBe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, wBe = {
  full: "{{date}} 'à' {{time}}",
  long: "{{date}} 'à' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, SBe = {
  date: Ke({
    formats: bBe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: yBe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: wBe,
    defaultWidth: "full"
  })
}, CBe = {
  lastWeek: "eeee 'dernier à' p",
  yesterday: "'hier à' p",
  today: "'aujourd’hui à' p",
  tomorrow: "'demain à' p'",
  nextWeek: "eeee 'prochain à' p",
  other: "P"
}, Dte = (e, t, r, a) => CBe[e], xBe = {
  narrow: ["av. J.-C", "ap. J.-C"],
  abbreviated: ["av. J.-C", "ap. J.-C"],
  wide: ["avant Jésus-Christ", "après Jésus-Christ"]
}, EBe = {
  narrow: ["T1", "T2", "T3", "T4"],
  abbreviated: ["1er trim.", "2ème trim.", "3ème trim.", "4ème trim."],
  wide: ["1er trimestre", "2ème trimestre", "3ème trimestre", "4ème trimestre"]
}, PBe = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "janv.",
    "févr.",
    "mars",
    "avr.",
    "mai",
    "juin",
    "juil.",
    "août",
    "sept.",
    "oct.",
    "nov.",
    "déc."
  ],
  wide: [
    "janvier",
    "février",
    "mars",
    "avril",
    "mai",
    "juin",
    "juillet",
    "août",
    "septembre",
    "octobre",
    "novembre",
    "décembre"
  ]
}, kBe = {
  narrow: ["D", "L", "M", "M", "J", "V", "S"],
  short: ["di", "lu", "ma", "me", "je", "ve", "sa"],
  abbreviated: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
  wide: [
    "dimanche",
    "lundi",
    "mardi",
    "mercredi",
    "jeudi",
    "vendredi",
    "samedi"
  ]
}, MBe = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "mat.",
    afternoon: "ap.m.",
    evening: "soir",
    night: "mat."
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "matin",
    afternoon: "après-midi",
    evening: "soir",
    night: "matin"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "du matin",
    afternoon: "de l’après-midi",
    evening: "du soir",
    night: "du matin"
  }
}, OBe = (e, t) => {
  const r = Number(e), a = t?.unit;
  if (r === 0) return "0";
  const i = ["year", "week", "hour", "minute", "second"];
  let c;
  return r === 1 ? c = a && i.includes(a) ? "ère" : "er" : c = "ème", r + c;
}, TBe = ["MMM", "MMMM"], SI = {
  preprocessor: (e, t) => e.getDate() === 1 || !t.some(
    (a) => a.isToken && TBe.includes(a.value)
  ) ? t : t.map(
    (a) => a.isToken && a.value === "do" ? { isToken: !0, value: "d" } : a
  ),
  ordinalNumber: OBe,
  era: Ce({
    values: xBe,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: EBe,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: PBe,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: kBe,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: MBe,
    defaultWidth: "wide"
  })
}, RBe = /^(\d+)(ième|ère|ème|er|e)?/i, ABe = /\d+/i, NBe = {
  narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
  abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
  wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
}, DBe = {
  any: [/^av/i, /^ap/i]
}, $Be = {
  narrow: /^T?[1234]/i,
  abbreviated: /^[1234](er|ème|e)? trim\.?/i,
  wide: /^[1234](er|ème|e)? trimestre/i
}, zBe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, jBe = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
  wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
}, IBe = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^av/i,
    /^ma/i,
    /^juin/i,
    /^juil/i,
    /^ao/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, LBe = {
  narrow: /^[lmjvsd]/i,
  short: /^(di|lu|ma|me|je|ve|sa)/i,
  abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
  wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
}, HBe = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i]
}, FBe = {
  narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
  any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
}, WBe = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^min/i,
    noon: /^mid/i,
    morning: /mat/i,
    afternoon: /ap/i,
    evening: /soir/i,
    night: /nuit/i
  }
}, CI = {
  ordinalNumber: Fn({
    matchPattern: RBe,
    parsePattern: ABe,
    valueCallback: (e) => parseInt(e)
  }),
  era: Ee({
    matchPatterns: NBe,
    defaultMatchWidth: "wide",
    parsePatterns: DBe,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: $Be,
    defaultMatchWidth: "wide",
    parsePatterns: zBe,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: jBe,
    defaultMatchWidth: "wide",
    parsePatterns: IBe,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: LBe,
    defaultMatchWidth: "wide",
    parsePatterns: HBe,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: FBe,
    defaultMatchWidth: "any",
    parsePatterns: WBe,
    defaultParseWidth: "any"
  })
}, VBe = {
  code: "fr",
  formatDistance: wI,
  formatLong: SBe,
  formatRelative: Dte,
  localize: SI,
  match: CI,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, _Be = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "yy-MM-dd"
}, BBe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, UBe = {
  full: "{{date}} 'à' {{time}}",
  long: "{{date}} 'à' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, XBe = {
  date: Ke({
    formats: _Be,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: BBe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: UBe,
    defaultWidth: "full"
  })
}, GBe = {
  code: "fr-CA",
  formatDistance: wI,
  formatLong: XBe,
  formatRelative: Dte,
  localize: SI,
  match: CI,
  // Unique for fr-CA
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, qBe = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd.MM.y"
}, KBe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, YBe = {
  full: "{{date}} 'à' {{time}}",
  long: "{{date}} 'à' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, QBe = {
  date: Ke({
    formats: qBe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: KBe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: YBe,
    defaultWidth: "full"
  })
}, JBe = {
  lastWeek: "eeee 'la semaine dernière à' p",
  yesterday: "'hier à' p",
  today: "'aujourd’hui à' p",
  tomorrow: "'demain à' p'",
  nextWeek: "eeee 'la semaine prochaine à' p",
  other: "P"
}, ZBe = (e, t, r, a) => JBe[e], eUe = {
  code: "fr-CH",
  formatDistance: wI,
  formatLong: QBe,
  formatRelative: ZBe,
  localize: SI,
  match: CI,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, tUe = {
  lessThanXSeconds: {
    one: "minder as 1 sekonde",
    other: "minder as {{count}} sekonden"
  },
  xSeconds: {
    one: "1 sekonde",
    other: "{{count}} sekonden"
  },
  halfAMinute: "oardel minút",
  lessThanXMinutes: {
    one: "minder as 1 minút",
    other: "minder as {{count}} minuten"
  },
  xMinutes: {
    one: "1 minút",
    other: "{{count}} minuten"
  },
  aboutXHours: {
    one: "sawat 1 oere",
    other: "sawat {{count}} oere"
  },
  xHours: {
    one: "1 oere",
    other: "{{count}} oere"
  },
  xDays: {
    one: "1 dei",
    other: "{{count}} dagen"
  },
  aboutXWeeks: {
    one: "sawat 1 wike",
    other: "sawat {{count}} wiken"
  },
  xWeeks: {
    one: "1 wike",
    other: "{{count}} wiken"
  },
  aboutXMonths: {
    one: "sawat 1 moanne",
    other: "sawat {{count}} moannen"
  },
  xMonths: {
    one: "1 moanne",
    other: "{{count}} moannen"
  },
  aboutXYears: {
    one: "sawat 1 jier",
    other: "sawat {{count}} jier"
  },
  xYears: {
    one: "1 jier",
    other: "{{count}} jier"
  },
  overXYears: {
    one: "mear as 1 jier",
    other: "mear as {{count}}s jier"
  },
  almostXYears: {
    one: "hast 1 jier",
    other: "hast {{count}} jier"
  }
}, nUe = (e, t, r) => {
  let a;
  const i = tUe[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? "oer " + a : a + " lyn" : a;
}, rUe = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd-MM-y"
}, aUe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, oUe = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, iUe = {
  date: Ke({
    formats: rUe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: aUe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: oUe,
    defaultWidth: "full"
  })
}, lUe = {
  lastWeek: "'ôfrûne' eeee 'om' p",
  yesterday: "'juster om' p",
  today: "'hjoed om' p",
  tomorrow: "'moarn om' p",
  nextWeek: "eeee 'om' p",
  other: "P"
}, sUe = (e, t, r, a) => lUe[e], uUe = {
  narrow: ["f.K.", "n.K."],
  abbreviated: ["f.Kr.", "n.Kr."],
  wide: ["foar Kristus", "nei Kristus"]
}, cUe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1e fearnsjier", "2e fearnsjier", "3e fearnsjier", "4e fearnsjier"]
}, dUe = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan.",
    "feb.",
    "mrt.",
    "apr.",
    "mai.",
    "jun.",
    "jul.",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "des."
  ],
  wide: [
    "jannewaris",
    "febrewaris",
    "maart",
    "april",
    "maaie",
    "juny",
    "july",
    "augustus",
    "septimber",
    "oktober",
    "novimber",
    "desimber"
  ]
}, fUe = {
  narrow: ["s", "m", "t", "w", "t", "f", "s"],
  short: ["si", "mo", "ti", "wo", "to", "fr", "so"],
  abbreviated: ["snein", "moa", "tii", "woa", "ton", "fre", "sneon"],
  wide: [
    "snein",
    "moandei",
    "tiisdei",
    "woansdei",
    "tongersdei",
    "freed",
    "sneon"
  ]
}, mUe = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "middei",
    morning: "moarns",
    afternoon: "middeis",
    evening: "jûns",
    night: "nachts"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "middei",
    morning: "moarns",
    afternoon: "middeis",
    evening: "jûns",
    night: "nachts"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "middei",
    morning: "moarns",
    afternoon: "middeis",
    evening: "jûns",
    night: "nachts"
  }
}, hUe = (e, t) => Number(e) + "e", pUe = {
  ordinalNumber: hUe,
  era: Ce({
    values: uUe,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: cUe,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: dUe,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: fUe,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: mUe,
    defaultWidth: "wide"
  })
}, gUe = /^(\d+)e?/i, vUe = /\d+/i, bUe = {
  narrow: /^([fn]\.? ?K\.?)/,
  abbreviated: /^([fn]\. ?Kr\.?)/,
  wide: /^((foar|nei) Kristus)/
}, yUe = {
  any: [/^f/, /^n/]
}, wUe = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234]e fearnsjier/i
}, SUe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, CUe = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mrt.|apr.|mai.|jun.|jul.|aug.|sep.|okt.|nov.|des.)/i,
  wide: /^(jannewaris|febrewaris|maart|april|maaie|juny|july|augustus|septimber|oktober|novimber|desimber)/i
}, xUe = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^jan/i,
    /^feb/i,
    /^m(r|a)/i,
    /^apr/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^aug/i,
    /^sep/i,
    /^okt/i,
    /^nov/i,
    /^des/i
  ]
}, EUe = {
  narrow: /^[smtwf]/i,
  short: /^(si|mo|ti|wo|to|fr|so)/i,
  abbreviated: /^(snein|moa|tii|woa|ton|fre|sneon)/i,
  wide: /^(snein|moandei|tiisdei|woansdei|tongersdei|freed|sneon)/i
}, PUe = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^sn/i, /^mo/i, /^ti/i, /^wo/i, /^to/i, /^fr/i, /^sn/i]
}, kUe = {
  any: /^(am|pm|middernacht|middeis|moarns|middei|jûns|nachts)/i
}, MUe = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^middernacht/i,
    noon: /^middei/i,
    morning: /moarns/i,
    afternoon: /^middeis/i,
    evening: /jûns/i,
    night: /nachts/i
  }
}, OUe = {
  ordinalNumber: Fn({
    matchPattern: gUe,
    parsePattern: vUe,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: bUe,
    defaultMatchWidth: "wide",
    parsePatterns: yUe,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: wUe,
    defaultMatchWidth: "wide",
    parsePatterns: SUe,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: CUe,
    defaultMatchWidth: "wide",
    parsePatterns: xUe,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: EUe,
    defaultMatchWidth: "wide",
    parsePatterns: PUe,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: kUe,
    defaultMatchWidth: "any",
    parsePatterns: MUe,
    defaultParseWidth: "any"
  })
}, TUe = {
  code: "fy",
  formatDistance: nUe,
  formatLong: iUe,
  formatRelative: sUe,
  localize: pUe,
  match: OUe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, RUe = {
  lessThanXSeconds: {
    one: "nas lugha na diog",
    other: "nas lugha na {{count}} diogan"
  },
  xSeconds: {
    one: "1 diog",
    two: "2 dhiog",
    twenty: "20 diog",
    other: "{{count}} diogan"
  },
  halfAMinute: "leth mhionaid",
  lessThanXMinutes: {
    one: "nas lugha na mionaid",
    other: "nas lugha na {{count}} mionaidean"
  },
  xMinutes: {
    one: "1 mionaid",
    two: "2 mhionaid",
    twenty: "20 mionaid",
    other: "{{count}} mionaidean"
  },
  aboutXHours: {
    one: "mu uair de thìde",
    other: "mu {{count}} uairean de thìde"
  },
  xHours: {
    one: "1 uair de thìde",
    two: "2 uair de thìde",
    twenty: "20 uair de thìde",
    other: "{{count}} uairean de thìde"
  },
  xDays: {
    one: "1 là",
    other: "{{count}} là"
  },
  aboutXWeeks: {
    one: "mu 1 seachdain",
    other: "mu {{count}} seachdainean"
  },
  xWeeks: {
    one: "1 seachdain",
    other: "{{count}} seachdainean"
  },
  aboutXMonths: {
    one: "mu mhìos",
    other: "mu {{count}} mìosan"
  },
  xMonths: {
    one: "1 mìos",
    other: "{{count}} mìosan"
  },
  aboutXYears: {
    one: "mu bhliadhna",
    other: "mu {{count}} bliadhnaichean"
  },
  xYears: {
    one: "1 bhliadhna",
    other: "{{count}} bliadhna"
  },
  overXYears: {
    one: "còrr is bliadhna",
    other: "còrr is {{count}} bliadhnaichean"
  },
  almostXYears: {
    one: "cha mhòr bliadhna",
    other: "cha mhòr {{count}} bliadhnaichean"
  }
}, AUe = (e, t, r) => {
  let a;
  const i = RUe[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : t === 2 && i.two ? a = i.two : t === 20 && i.twenty ? a = i.twenty : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? "ann an " + a : "o chionn " + a : a;
}, NUe = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, DUe = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, $Ue = {
  full: "{{date}} 'aig' {{time}}",
  long: "{{date}} 'aig' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, zUe = {
  date: Ke({
    formats: NUe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: DUe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: $Ue,
    defaultWidth: "full"
  })
}, jUe = {
  lastWeek: "'mu dheireadh' eeee 'aig' p",
  //FIX
  yesterday: "'an-dè aig' p",
  today: "'an-diugh aig' p",
  tomorrow: "'a-màireach aig' p",
  nextWeek: "eeee 'aig' p",
  other: "P"
}, IUe = (e, t, r, a) => jUe[e], LUe = {
  narrow: ["R", "A"],
  abbreviated: ["RC", "AD"],
  wide: ["ro Chrìosta", "anno domini"]
}, HUe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["C1", "C2", "C3", "C4"],
  wide: [
    "a' chiad chairteal",
    "an dàrna cairteal",
    "an treas cairteal",
    "an ceathramh cairteal"
  ]
}, FUe = {
  narrow: ["F", "G", "M", "G", "C", "Ò", "I", "L", "S", "D", "S", "D"],
  abbreviated: [
    "Faoi",
    "Gear",
    "Màrt",
    "Gibl",
    "Cèit",
    "Ògmh",
    "Iuch",
    "Lùn",
    "Sult",
    "Dàmh",
    "Samh",
    "Dùbh"
  ],
  wide: [
    "Am Faoilleach",
    "An Gearran",
    "Am Màrt",
    "An Giblean",
    "An Cèitean",
    "An t-Ògmhios",
    "An t-Iuchar",
    "An Lùnastal",
    "An t-Sultain",
    "An Dàmhair",
    "An t-Samhain",
    "An Dùbhlachd"
  ]
}, WUe = {
  narrow: ["D", "L", "M", "C", "A", "H", "S"],
  short: ["Dò", "Lu", "Mà", "Ci", "Ar", "Ha", "Sa"],
  abbreviated: ["Did", "Dil", "Dim", "Dic", "Dia", "Dih", "Dis"],
  wide: [
    "Didòmhnaich",
    "Diluain",
    "Dimàirt",
    "Diciadain",
    "Diardaoin",
    "Dihaoine",
    "Disathairne"
  ]
}, VUe = {
  narrow: {
    am: "m",
    pm: "f",
    midnight: "m.o.",
    noon: "m.l.",
    morning: "madainn",
    afternoon: "feasgar",
    evening: "feasgar",
    night: "oidhche"
  },
  abbreviated: {
    am: "M.",
    pm: "F.",
    midnight: "meadhan oidhche",
    noon: "meadhan là",
    morning: "madainn",
    afternoon: "feasgar",
    evening: "feasgar",
    night: "oidhche"
  },
  wide: {
    am: "m.",
    pm: "f.",
    midnight: "meadhan oidhche",
    noon: "meadhan là",
    morning: "madainn",
    afternoon: "feasgar",
    evening: "feasgar",
    night: "oidhche"
  }
}, _Ue = {
  narrow: {
    am: "m",
    pm: "f",
    midnight: "m.o.",
    noon: "m.l.",
    morning: "sa mhadainn",
    afternoon: "feasgar",
    evening: "feasgar",
    night: "air an oidhche"
  },
  abbreviated: {
    am: "M.",
    pm: "F.",
    midnight: "meadhan oidhche",
    noon: "meadhan là",
    morning: "sa mhadainn",
    afternoon: "feasgar",
    evening: "feasgar",
    night: "air an oidhche"
  },
  wide: {
    am: "m.",
    pm: "f.",
    midnight: "meadhan oidhche",
    noon: "meadhan là",
    morning: "sa mhadainn",
    afternoon: "feasgar",
    evening: "feasgar",
    night: "air an oidhche"
  }
}, BUe = (e) => {
  const t = Number(e), r = t % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return t + "d";
      case 2:
        return t + "na";
    }
  return r === 12 ? t + "na" : t + "mh";
}, UUe = {
  ordinalNumber: BUe,
  era: Ce({
    values: LUe,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: HUe,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: FUe,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: WUe,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: VUe,
    defaultWidth: "wide",
    formattingValues: _Ue,
    defaultFormattingWidth: "wide"
  })
}, XUe = /^(\d+)(d|na|tr|mh)?/i, GUe = /\d+/i, qUe = {
  narrow: /^(r|a)/i,
  abbreviated: /^(r\.?\s?c\.?|r\.?\s?a\.?\s?c\.?|a\.?\s?d\.?|a\.?\s?c\.?)/i,
  wide: /^(ro Chrìosta|ron aois choitchinn|anno domini|aois choitcheann)/i
}, KUe = {
  any: [/^b/i, /^(a|c)/i]
}, YUe = {
  narrow: /^[1234]/i,
  abbreviated: /^c[1234]/i,
  wide: /^[1234](cd|na|tr|mh)? cairteal/i
}, QUe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, JUe = {
  narrow: /^[fgmcòilsd]/i,
  abbreviated: /^(faoi|gear|màrt|gibl|cèit|ògmh|iuch|lùn|sult|dàmh|samh|dùbh)/i,
  wide: /^(am faoilleach|an gearran|am màrt|an giblean|an cèitean|an t-Ògmhios|an t-Iuchar|an lùnastal|an t-Sultain|an dàmhair|an t-Samhain|an dùbhlachd)/i
}, ZUe = {
  narrow: [
    /^f/i,
    /^g/i,
    /^m/i,
    /^g/i,
    /^c/i,
    /^ò/i,
    /^i/i,
    /^l/i,
    /^s/i,
    /^d/i,
    /^s/i,
    /^d/i
  ],
  any: [
    /^fa/i,
    /^ge/i,
    /^mà/i,
    /^gi/i,
    /^c/i,
    /^ò/i,
    /^i/i,
    /^l/i,
    /^su/i,
    /^d/i,
    /^sa/i,
    /^d/i
  ]
}, eXe = {
  narrow: /^[dlmcahs]/i,
  short: /^(dò|lu|mà|ci|ar|ha|sa)/i,
  abbreviated: /^(did|dil|dim|dic|dia|dih|dis)/i,
  wide: /^(didòmhnaich|diluain|dimàirt|diciadain|diardaoin|dihaoine|disathairne)/i
}, tXe = {
  narrow: [/^d/i, /^l/i, /^m/i, /^c/i, /^a/i, /^h/i, /^s/i],
  any: [/^d/i, /^l/i, /^m/i, /^c/i, /^a/i, /^h/i, /^s/i]
}, nXe = {
  narrow: /^(a|p|mi|n|(san|aig) (madainn|feasgar|feasgar|oidhche))/i,
  any: /^([ap]\.?\s?m\.?|meadhan oidhche|meadhan là|(san|aig) (madainn|feasgar|feasgar|oidhche))/i
}, rXe = {
  any: {
    am: /^m/i,
    pm: /^f/i,
    midnight: /^meadhan oidhche/i,
    noon: /^meadhan là/i,
    morning: /sa mhadainn/i,
    afternoon: /feasgar/i,
    evening: /feasgar/i,
    night: /air an oidhche/i
  }
}, aXe = {
  ordinalNumber: Fn({
    matchPattern: XUe,
    parsePattern: GUe,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: qUe,
    defaultMatchWidth: "wide",
    parsePatterns: KUe,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: YUe,
    defaultMatchWidth: "wide",
    parsePatterns: QUe,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: JUe,
    defaultMatchWidth: "wide",
    parsePatterns: ZUe,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: eXe,
    defaultMatchWidth: "wide",
    parsePatterns: tXe,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: nXe,
    defaultMatchWidth: "any",
    parsePatterns: rXe,
    defaultParseWidth: "any"
  })
}, oXe = {
  code: "gd",
  formatDistance: AUe,
  formatLong: zUe,
  formatRelative: IUe,
  localize: UUe,
  match: aXe,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, iXe = {
  lessThanXSeconds: {
    one: "menos dun segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "medio minuto",
  lessThanXMinutes: {
    one: "menos dun minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "arredor dunha hora",
    other: "arredor de {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 día",
    other: "{{count}} días"
  },
  aboutXWeeks: {
    one: "arredor dunha semana",
    other: "arredor de {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "arredor de 1 mes",
    other: "arredor de {{count}} meses"
  },
  xMonths: {
    one: "1 mes",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "arredor dun ano",
    other: "arredor de {{count}} anos"
  },
  xYears: {
    one: "1 ano",
    other: "{{count}} anos"
  },
  overXYears: {
    one: "máis dun ano",
    other: "máis de {{count}} anos"
  },
  almostXYears: {
    one: "case un ano",
    other: "case {{count}} anos"
  }
}, lXe = (e, t, r) => {
  let a;
  const i = iXe[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? "en " + a : "hai " + a : a;
}, sXe = {
  full: "EEEE, d 'de' MMMM y",
  long: "d 'de' MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, uXe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, cXe = {
  full: "{{date}} 'ás' {{time}}",
  long: "{{date}} 'ás' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, dXe = {
  date: Ke({
    formats: sXe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: uXe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: cXe,
    defaultWidth: "full"
  })
}, fXe = {
  lastWeek: "'o' eeee 'pasado á' LT",
  yesterday: "'onte á' p",
  today: "'hoxe á' p",
  tomorrow: "'mañá á' p",
  nextWeek: "eeee 'á' p",
  other: "P"
}, mXe = {
  lastWeek: "'o' eeee 'pasado ás' p",
  yesterday: "'onte ás' p",
  today: "'hoxe ás' p",
  tomorrow: "'mañá ás' p",
  nextWeek: "eeee 'ás' p",
  other: "P"
}, hXe = (e, t, r, a) => t.getHours() !== 1 ? mXe[e] : fXe[e], pXe = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "despois de cristo"]
}, gXe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, vXe = {
  narrow: ["e", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "xan",
    "feb",
    "mar",
    "abr",
    "mai",
    "xun",
    "xul",
    "ago",
    "set",
    "out",
    "nov",
    "dec"
  ],
  wide: [
    "xaneiro",
    "febreiro",
    "marzo",
    "abril",
    "maio",
    "xuño",
    "xullo",
    "agosto",
    "setembro",
    "outubro",
    "novembro",
    "decembro"
  ]
}, bXe = {
  narrow: ["d", "l", "m", "m", "j", "v", "s"],
  short: ["do", "lu", "ma", "me", "xo", "ve", "sa"],
  abbreviated: ["dom", "lun", "mar", "mer", "xov", "ven", "sab"],
  wide: ["domingo", "luns", "martes", "mércores", "xoves", "venres", "sábado"]
}, yXe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "mañá",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoite",
    noon: "mediodía",
    morning: "mañá",
    afternoon: "tarde",
    evening: "tardiña",
    night: "noite"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoite",
    noon: "mediodía",
    morning: "mañá",
    afternoon: "tarde",
    evening: "tardiña",
    night: "noite"
  }
}, wXe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "da mañá",
    afternoon: "da tarde",
    evening: "da tardiña",
    night: "da noite"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoite",
    noon: "mediodía",
    morning: "da mañá",
    afternoon: "da tarde",
    evening: "da tardiña",
    night: "da noite"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoite",
    noon: "mediodía",
    morning: "da mañá",
    afternoon: "da tarde",
    evening: "da tardiña",
    night: "da noite"
  }
}, SXe = (e, t) => Number(e) + "º", CXe = {
  ordinalNumber: SXe,
  era: Ce({
    values: pXe,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: gXe,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: vXe,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: bXe,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: yXe,
    defaultWidth: "wide",
    formattingValues: wXe,
    defaultFormattingWidth: "wide"
  })
}, xXe = /^(\d+)(º)?/i, EXe = /\d+/i, PXe = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes da era com[uú]n|despois de cristo|era com[uú]n)/i
}, kXe = {
  any: [/^ac/i, /^dc/i],
  wide: [
    /^(antes de cristo|antes da era com[uú]n)/i,
    /^(despois de cristo|era com[uú]n)/i
  ]
}, MXe = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, OXe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, TXe = {
  narrow: /^[xfmasond]/i,
  abbreviated: /^(xan|feb|mar|abr|mai|xun|xul|ago|set|out|nov|dec)/i,
  wide: /^(xaneiro|febreiro|marzo|abril|maio|xuño|xullo|agosto|setembro|outubro|novembro|decembro)/i
}, RXe = {
  narrow: [
    /^x/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^x/i,
    /^x/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^xan/i,
    /^feb/i,
    /^mar/i,
    /^abr/i,
    /^mai/i,
    /^xun/i,
    /^xul/i,
    /^ago/i,
    /^set/i,
    /^out/i,
    /^nov/i,
    /^dec/i
  ]
}, AXe = {
  narrow: /^[dlmxvs]/i,
  short: /^(do|lu|ma|me|xo|ve|sa)/i,
  abbreviated: /^(dom|lun|mar|mer|xov|ven|sab)/i,
  wide: /^(domingo|luns|martes|m[eé]rcores|xoves|venres|s[áa]bado)/i
}, NXe = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^x/i, /^v/i, /^s/i],
  any: [/^do/i, /^lu/i, /^ma/i, /^me/i, /^xo/i, /^ve/i, /^sa/i]
}, DXe = {
  narrow: /^(a|p|mn|md|(da|[aá]s) (mañ[aá]|tarde|noite))/i,
  any: /^([ap]\.?\s?m\.?|medianoite|mediod[ií]a|(da|[aá]s) (mañ[aá]|tarde|noite))/i
}, $Xe = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /^md/i,
    morning: /mañ[aá]/i,
    afternoon: /tarde/i,
    evening: /tardiña/i,
    night: /noite/i
  }
}, zXe = {
  ordinalNumber: Fn({
    matchPattern: xXe,
    parsePattern: EXe,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: PXe,
    defaultMatchWidth: "wide",
    parsePatterns: kXe,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: MXe,
    defaultMatchWidth: "wide",
    parsePatterns: OXe,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: TXe,
    defaultMatchWidth: "wide",
    parsePatterns: RXe,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: AXe,
    defaultMatchWidth: "wide",
    parsePatterns: NXe,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: DXe,
    defaultMatchWidth: "any",
    parsePatterns: $Xe,
    defaultParseWidth: "any"
  })
}, jXe = {
  code: "gl",
  formatDistance: lXe,
  formatLong: dXe,
  formatRelative: hXe,
  localize: CXe,
  match: zXe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, IXe = {
  lessThanXSeconds: {
    one: "હમણાં",
    // CLDR #1461
    other: "​આશરે {{count}} સેકંડ"
  },
  xSeconds: {
    one: "1 સેકંડ",
    other: "{{count}} સેકંડ"
  },
  halfAMinute: "અડધી મિનિટ",
  lessThanXMinutes: {
    one: "આ મિનિટ",
    // CLDR #1448
    other: "​આશરે {{count}} મિનિટ"
  },
  xMinutes: {
    one: "1 મિનિટ",
    other: "{{count}} મિનિટ"
  },
  aboutXHours: {
    one: "​આશરે 1 કલાક",
    other: "​આશરે {{count}} કલાક"
  },
  xHours: {
    one: "1 કલાક",
    other: "{{count}} કલાક"
  },
  xDays: {
    one: "1 દિવસ",
    other: "{{count}} દિવસ"
  },
  aboutXWeeks: {
    one: "આશરે 1 અઠવાડિયું",
    other: "આશરે {{count}} અઠવાડિયા"
  },
  xWeeks: {
    one: "1 અઠવાડિયું",
    other: "{{count}} અઠવાડિયા"
  },
  aboutXMonths: {
    one: "આશરે 1 મહિનો",
    other: "આશરે {{count}} મહિના"
  },
  xMonths: {
    one: "1 મહિનો",
    other: "{{count}} મહિના"
  },
  aboutXYears: {
    one: "આશરે 1 વર્ષ",
    other: "આશરે {{count}} વર્ષ"
  },
  xYears: {
    one: "1 વર્ષ",
    other: "{{count}} વર્ષ"
  },
  overXYears: {
    one: "1 વર્ષથી વધુ",
    other: "{{count}} વર્ષથી વધુ"
  },
  almostXYears: {
    one: "લગભગ 1 વર્ષ",
    other: "લગભગ {{count}} વર્ષ"
  }
}, LXe = (e, t, r) => {
  let a;
  const i = IXe[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? a + "માં" : a + " પહેલાં" : a;
}, HXe = {
  full: "EEEE, d MMMM, y",
  // CLDR #1825
  long: "d MMMM, y",
  // CLDR #1826
  medium: "d MMM, y",
  // CLDR #1827
  short: "d/M/yy"
  // CLDR #1828
}, FXe = {
  full: "hh:mm:ss a zzzz",
  // CLDR #1829
  long: "hh:mm:ss a z",
  // CLDR #1830
  medium: "hh:mm:ss a",
  // CLDR #1831
  short: "hh:mm a"
  // CLDR #1832
}, WXe = {
  full: "{{date}} {{time}}",
  // CLDR #1833
  long: "{{date}} {{time}}",
  // CLDR #1834
  medium: "{{date}} {{time}}",
  // CLDR #1835
  short: "{{date}} {{time}}"
  // CLDR #1836
}, VXe = {
  date: Ke({
    formats: HXe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: FXe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: WXe,
    defaultWidth: "full"
  })
}, _Xe = {
  lastWeek: "'પાછલા' eeee p",
  // CLDR #1384
  yesterday: "'ગઈકાલે' p",
  // CLDR #1409
  today: "'આજે' p",
  // CLDR #1410
  tomorrow: "'આવતીકાલે' p",
  // CLDR #1411
  nextWeek: "eeee p",
  // CLDR #1386
  other: "P"
}, BXe = (e, t, r, a) => _Xe[e], UXe = {
  narrow: ["ઈસપૂ", "ઈસ"],
  abbreviated: ["ઈ.સ.પૂર્વે", "ઈ.સ."],
  wide: ["ઈસવીસન પૂર્વે", "ઈસવીસન"]
}, XXe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1લો ત્રિમાસ", "2જો ત્રિમાસ", "3જો ત્રિમાસ", "4થો ત્રિમાસ"]
}, GXe = {
  narrow: ["જા", "ફે", "મા", "એ", "મે", "જૂ", "જુ", "ઓ", "સ", "ઓ", "ન", "ડિ"],
  abbreviated: [
    "જાન્યુ",
    "ફેબ્રુ",
    "માર્ચ",
    "એપ્રિલ",
    "મે",
    "જૂન",
    "જુલાઈ",
    "ઑગસ્ટ",
    "સપ્ટે",
    "ઓક્ટો",
    "નવે",
    "ડિસે"
  ],
  wide: [
    "જાન્યુઆરી",
    "ફેબ્રુઆરી",
    "માર્ચ",
    "એપ્રિલ",
    "મે",
    "જૂન",
    "જુલાઇ",
    "ઓગસ્ટ",
    "સપ્ટેમ્બર",
    "ઓક્ટોબર",
    "નવેમ્બર",
    "ડિસેમ્બર"
  ]
}, qXe = {
  narrow: ["ર", "સો", "મં", "બુ", "ગુ", "શુ", "શ"],
  short: ["ર", "સો", "મં", "બુ", "ગુ", "શુ", "શ"],
  abbreviated: ["રવિ", "સોમ", "મંગળ", "બુધ", "ગુરુ", "શુક્ર", "શનિ"],
  wide: [
    "રવિવાર",
    "સોમવાર",
    "મંગળવાર",
    "બુધવાર",
    "ગુરુવાર",
    "શુક્રવાર",
    "શનિવાર"
  ]
}, KXe = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "મ.રાત્રિ",
    noon: "બ.",
    morning: "સવારે",
    afternoon: "બપોરે",
    evening: "સાંજે",
    night: "રાત્રે"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "​મધ્યરાત્રિ",
    noon: "બપોરે",
    morning: "સવારે",
    afternoon: "બપોરે",
    evening: "સાંજે",
    night: "રાત્રે"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "​મધ્યરાત્રિ",
    noon: "બપોરે",
    morning: "સવારે",
    afternoon: "બપોરે",
    evening: "સાંજે",
    night: "રાત્રે"
  }
}, YXe = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "મ.રાત્રિ",
    noon: "બપોરે",
    morning: "સવારે",
    afternoon: "બપોરે",
    evening: "સાંજે",
    night: "રાત્રે"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "મધ્યરાત્રિ",
    noon: "બપોરે",
    morning: "સવારે",
    afternoon: "બપોરે",
    evening: "સાંજે",
    night: "રાત્રે"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "​મધ્યરાત્રિ",
    noon: "બપોરે",
    morning: "સવારે",
    afternoon: "બપોરે",
    evening: "સાંજે",
    night: "રાત્રે"
  }
}, QXe = (e, t) => String(e), JXe = {
  ordinalNumber: QXe,
  era: Ce({
    values: UXe,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: XXe,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: GXe,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: qXe,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: KXe,
    defaultWidth: "wide",
    formattingValues: YXe,
    defaultFormattingWidth: "wide"
  })
}, ZXe = /^(\d+)(લ|જ|થ|ઠ્ઠ|મ)?/i, eGe = /\d+/i, tGe = {
  narrow: /^(ઈસપૂ|ઈસ)/i,
  abbreviated: /^(ઈ\.સ\.પૂર્વે|ઈ\.સ\.)/i,
  wide: /^(ઈસવીસન\sપૂર્વે|ઈસવીસન)/i
}, nGe = {
  any: [/^ઈસપૂ/i, /^ઈસ/i]
}, rGe = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](લો|જો|થો)? ત્રિમાસ/i
}, aGe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, oGe = {
  // eslint-disable-next-line no-misleading-character-class
  narrow: /^[જાફેમાએમેજૂજુઓસઓનડિ]/i,
  abbreviated: /^(જાન્યુ|ફેબ્રુ|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઈ|ઑગસ્ટ|સપ્ટે|ઓક્ટો|નવે|ડિસે)/i,
  wide: /^(જાન્યુઆરી|ફેબ્રુઆરી|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઇ|ઓગસ્ટ|સપ્ટેમ્બર|ઓક્ટોબર|નવેમ્બર|ડિસેમ્બર)/i
}, iGe = {
  narrow: [
    /^જા/i,
    /^ફે/i,
    /^મા/i,
    /^એ/i,
    /^મે/i,
    /^જૂ/i,
    /^જુ/i,
    /^ઑગ/i,
    /^સ/i,
    /^ઓક્ટો/i,
    /^ન/i,
    /^ડિ/i
  ],
  any: [
    /^જા/i,
    /^ફે/i,
    /^મા/i,
    /^એ/i,
    /^મે/i,
    /^જૂ/i,
    /^જુ/i,
    /^ઑગ/i,
    /^સ/i,
    /^ઓક્ટો/i,
    /^ન/i,
    /^ડિ/i
  ]
}, lGe = {
  narrow: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
  short: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
  abbreviated: /^(રવિ|સોમ|મંગળ|બુધ|ગુરુ|શુક્ર|શનિ)/i,
  wide: /^(રવિવાર|સોમવાર|મંગળવાર|બુધવાર|ગુરુવાર|શુક્રવાર|શનિવાર)/i
}, sGe = {
  narrow: [/^ર/i, /^સો/i, /^મં/i, /^બુ/i, /^ગુ/i, /^શુ/i, /^શ/i],
  any: [/^ર/i, /^સો/i, /^મં/i, /^બુ/i, /^ગુ/i, /^શુ/i, /^શ/i]
}, uGe = {
  narrow: /^(a|p|મ\.?|સ|બ|સાં|રા)/i,
  any: /^(a|p|મ\.?|સ|બ|સાં|રા)/i
}, cGe = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^મ\.?/i,
    noon: /^બ/i,
    morning: /સ/i,
    afternoon: /બ/i,
    evening: /સાં/i,
    night: /રા/i
  }
}, dGe = {
  ordinalNumber: Fn({
    matchPattern: ZXe,
    parsePattern: eGe,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: tGe,
    defaultMatchWidth: "wide",
    parsePatterns: nGe,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: rGe,
    defaultMatchWidth: "wide",
    parsePatterns: aGe,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: oGe,
    defaultMatchWidth: "wide",
    parsePatterns: iGe,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: lGe,
    defaultMatchWidth: "wide",
    parsePatterns: sGe,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: uGe,
    defaultMatchWidth: "any",
    parsePatterns: cGe,
    defaultParseWidth: "any"
  })
}, fGe = {
  code: "gu",
  formatDistance: LXe,
  formatLong: VXe,
  formatRelative: BXe,
  localize: JXe,
  match: dGe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, mGe = {
  lessThanXSeconds: {
    one: "פחות משנייה",
    two: "פחות משתי שניות",
    other: "פחות מ־{{count}} שניות"
  },
  xSeconds: {
    one: "שנייה",
    two: "שתי שניות",
    other: "{{count}} שניות"
  },
  halfAMinute: "חצי דקה",
  lessThanXMinutes: {
    one: "פחות מדקה",
    two: "פחות משתי דקות",
    other: "פחות מ־{{count}} דקות"
  },
  xMinutes: {
    one: "דקה",
    two: "שתי דקות",
    other: "{{count}} דקות"
  },
  aboutXHours: {
    one: "כשעה",
    two: "כשעתיים",
    other: "כ־{{count}} שעות"
  },
  xHours: {
    one: "שעה",
    two: "שעתיים",
    other: "{{count}} שעות"
  },
  xDays: {
    one: "יום",
    two: "יומיים",
    other: "{{count}} ימים"
  },
  aboutXWeeks: {
    one: "כשבוע",
    two: "כשבועיים",
    other: "כ־{{count}} שבועות"
  },
  xWeeks: {
    one: "שבוע",
    two: "שבועיים",
    other: "{{count}} שבועות"
  },
  aboutXMonths: {
    one: "כחודש",
    two: "כחודשיים",
    other: "כ־{{count}} חודשים"
  },
  xMonths: {
    one: "חודש",
    two: "חודשיים",
    other: "{{count}} חודשים"
  },
  aboutXYears: {
    one: "כשנה",
    two: "כשנתיים",
    other: "כ־{{count}} שנים"
  },
  xYears: {
    one: "שנה",
    two: "שנתיים",
    other: "{{count}} שנים"
  },
  overXYears: {
    one: "יותר משנה",
    two: "יותר משנתיים",
    other: "יותר מ־{{count}} שנים"
  },
  almostXYears: {
    one: "כמעט שנה",
    two: "כמעט שנתיים",
    other: "כמעט {{count}} שנים"
  }
}, hGe = (e, t, r) => {
  if (e === "xDays" && r?.addSuffix && t <= 2)
    return r.comparison && r.comparison > 0 ? t === 1 ? "מחר" : "מחרתיים" : t === 1 ? "אתמול" : "שלשום";
  let a;
  const i = mGe[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : t === 2 ? a = i.two : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? "בעוד " + a : "לפני " + a : a;
}, pGe = {
  full: "EEEE, d בMMMM y",
  long: "d בMMMM y",
  medium: "d בMMM y",
  short: "d.M.y"
}, gGe = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, vGe = {
  full: "{{date}} 'בשעה' {{time}}",
  long: "{{date}} 'בשעה' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, bGe = {
  date: Ke({
    formats: pGe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: gGe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: vGe,
    defaultWidth: "full"
  })
}, yGe = {
  lastWeek: "eeee 'שעבר בשעה' p",
  yesterday: "'אתמול בשעה' p",
  today: "'היום בשעה' p",
  tomorrow: "'מחר בשעה' p",
  nextWeek: "eeee 'בשעה' p",
  other: "P"
}, wGe = (e, t, r, a) => yGe[e], SGe = {
  narrow: ["לפנה״ס", "לספירה"],
  abbreviated: ["לפנה״ס", "לספירה"],
  wide: ["לפני הספירה", "לספירה"]
}, CGe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["רבעון 1", "רבעון 2", "רבעון 3", "רבעון 4"]
}, xGe = {
  narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
  abbreviated: [
    "ינו׳",
    "פבר׳",
    "מרץ",
    "אפר׳",
    "מאי",
    "יוני",
    "יולי",
    "אוג׳",
    "ספט׳",
    "אוק׳",
    "נוב׳",
    "דצמ׳"
  ],
  wide: [
    "ינואר",
    "פברואר",
    "מרץ",
    "אפריל",
    "מאי",
    "יוני",
    "יולי",
    "אוגוסט",
    "ספטמבר",
    "אוקטובר",
    "נובמבר",
    "דצמבר"
  ]
}, EGe = {
  narrow: ["א׳", "ב׳", "ג׳", "ד׳", "ה׳", "ו׳", "ש׳"],
  short: ["א׳", "ב׳", "ג׳", "ד׳", "ה׳", "ו׳", "ש׳"],
  abbreviated: [
    "יום א׳",
    "יום ב׳",
    "יום ג׳",
    "יום ד׳",
    "יום ה׳",
    "יום ו׳",
    "שבת"
  ],
  wide: [
    "יום ראשון",
    "יום שני",
    "יום שלישי",
    "יום רביעי",
    "יום חמישי",
    "יום שישי",
    "יום שבת"
  ]
}, PGe = {
  narrow: {
    am: "לפנה״צ",
    pm: "אחה״צ",
    midnight: "חצות",
    noon: "צהריים",
    morning: "בוקר",
    afternoon: "אחר הצהריים",
    evening: "ערב",
    night: "לילה"
  },
  abbreviated: {
    am: "לפנה״צ",
    pm: "אחה״צ",
    midnight: "חצות",
    noon: "צהריים",
    morning: "בוקר",
    afternoon: "אחר הצהריים",
    evening: "ערב",
    night: "לילה"
  },
  wide: {
    am: "לפנה״צ",
    pm: "אחה״צ",
    midnight: "חצות",
    noon: "צהריים",
    morning: "בוקר",
    afternoon: "אחר הצהריים",
    evening: "ערב",
    night: "לילה"
  }
}, kGe = {
  narrow: {
    am: "לפנה״צ",
    pm: "אחה״צ",
    midnight: "חצות",
    noon: "צהריים",
    morning: "בבוקר",
    afternoon: "בצהריים",
    evening: "בערב",
    night: "בלילה"
  },
  abbreviated: {
    am: "לפנה״צ",
    pm: "אחה״צ",
    midnight: "חצות",
    noon: "צהריים",
    morning: "בבוקר",
    afternoon: "אחר הצהריים",
    evening: "בערב",
    night: "בלילה"
  },
  wide: {
    am: "לפנה״צ",
    pm: "אחה״צ",
    midnight: "חצות",
    noon: "צהריים",
    morning: "בבוקר",
    afternoon: "אחר הצהריים",
    evening: "בערב",
    night: "בלילה"
  }
}, MGe = (e, t) => {
  const r = Number(e);
  if (r <= 0 || r > 10) return String(r);
  const a = String(t?.unit), i = ["year", "hour", "minute", "second"].indexOf(a) >= 0, c = [
    "ראשון",
    "שני",
    "שלישי",
    "רביעי",
    "חמישי",
    "שישי",
    "שביעי",
    "שמיני",
    "תשיעי",
    "עשירי"
  ], d = [
    "ראשונה",
    "שנייה",
    "שלישית",
    "רביעית",
    "חמישית",
    "שישית",
    "שביעית",
    "שמינית",
    "תשיעית",
    "עשירית"
  ], f = r - 1;
  return i ? d[f] : c[f];
}, OGe = {
  ordinalNumber: MGe,
  era: Ce({
    values: SGe,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: CGe,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: xGe,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: EGe,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: PGe,
    defaultWidth: "wide",
    formattingValues: kGe,
    defaultFormattingWidth: "wide"
  })
}, TGe = /^(\d+|(ראשון|שני|שלישי|רביעי|חמישי|שישי|שביעי|שמיני|תשיעי|עשירי|ראשונה|שנייה|שלישית|רביעית|חמישית|שישית|שביעית|שמינית|תשיעית|עשירית))/i, RGe = /^(\d+|רא|שנ|של|רב|ח|שי|שב|שמ|ת|ע)/i, AGe = {
  narrow: /^ל(ספירה|פנה״ס)/i,
  abbreviated: /^ל(ספירה|פנה״ס)/i,
  wide: /^ל(פני ה)?ספירה/i
}, NGe = {
  any: [/^לפ/i, /^לס/i]
}, DGe = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^רבעון [1234]/i
}, $Ge = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, zGe = {
  narrow: /^\d+/i,
  abbreviated: /^(ינו|פבר|מרץ|אפר|מאי|יוני|יולי|אוג|ספט|אוק|נוב|דצמ)׳?/i,
  wide: /^(ינואר|פברואר|מרץ|אפריל|מאי|יוני|יולי|אוגוסט|ספטמבר|אוקטובר|נובמבר|דצמבר)/i
}, jGe = {
  narrow: [
    /^1$/i,
    /^2/i,
    /^3/i,
    /^4/i,
    /^5/i,
    /^6/i,
    /^7/i,
    /^8/i,
    /^9/i,
    /^10/i,
    /^11/i,
    /^12/i
  ],
  any: [
    /^ינ/i,
    /^פ/i,
    /^מר/i,
    /^אפ/i,
    /^מא/i,
    /^יונ/i,
    /^יול/i,
    /^אוג/i,
    /^ס/i,
    /^אוק/i,
    /^נ/i,
    /^ד/i
  ]
}, IGe = {
  narrow: /^[אבגדהוש]׳/i,
  short: /^[אבגדהוש]׳/i,
  abbreviated: /^(שבת|יום (א|ב|ג|ד|ה|ו)׳)/i,
  wide: /^יום (ראשון|שני|שלישי|רביעי|חמישי|שישי|שבת)/i
}, LGe = {
  abbreviated: [/א׳$/i, /ב׳$/i, /ג׳$/i, /ד׳$/i, /ה׳$/i, /ו׳$/i, /^ש/i],
  wide: [/ן$/i, /ני$/i, /לישי$/i, /עי$/i, /מישי$/i, /שישי$/i, /ת$/i],
  any: [/^א/i, /^ב/i, /^ג/i, /^ד/i, /^ה/i, /^ו/i, /^ש/i]
}, HGe = {
  any: /^(אחר ה|ב)?(חצות|צהריים|בוקר|ערב|לילה|אחה״צ|לפנה״צ)/i
}, FGe = {
  any: {
    am: /^לפ/i,
    pm: /^אחה/i,
    midnight: /^ח/i,
    noon: /^צ/i,
    morning: /בוקר/i,
    afternoon: /בצ|אחר/i,
    evening: /ערב/i,
    night: /לילה/i
  }
}, WGe = ["רא", "שנ", "של", "רב", "ח", "שי", "שב", "שמ", "ת", "ע"], VGe = {
  ordinalNumber: Fn({
    matchPattern: TGe,
    parsePattern: RGe,
    valueCallback: (e) => {
      const t = parseInt(e, 10);
      return isNaN(t) ? WGe.indexOf(e) + 1 : t;
    }
  }),
  era: Ee({
    matchPatterns: AGe,
    defaultMatchWidth: "wide",
    parsePatterns: NGe,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: DGe,
    defaultMatchWidth: "wide",
    parsePatterns: $Ge,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: zGe,
    defaultMatchWidth: "wide",
    parsePatterns: jGe,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: IGe,
    defaultMatchWidth: "wide",
    parsePatterns: LGe,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: HGe,
    defaultMatchWidth: "any",
    parsePatterns: FGe,
    defaultParseWidth: "any"
  })
}, _Ge = {
  code: "he",
  formatDistance: hGe,
  formatLong: bGe,
  formatRelative: wGe,
  localize: OGe,
  match: VGe,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, $te = {
  locale: {
    1: "१",
    2: "२",
    3: "३",
    4: "४",
    5: "५",
    6: "६",
    7: "७",
    8: "८",
    9: "९",
    0: "०"
  },
  number: {
    "१": "1",
    "२": "2",
    "३": "3",
    "४": "4",
    "५": "5",
    "६": "6",
    "७": "7",
    "८": "8",
    "९": "9",
    "०": "0"
  }
}, BGe = {
  narrow: ["ईसा-पूर्व", "ईस्वी"],
  abbreviated: ["ईसा-पूर्व", "ईस्वी"],
  wide: ["ईसा-पूर्व", "ईसवी सन"]
}, UGe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["ति1", "ति2", "ति3", "ति4"],
  wide: ["पहली तिमाही", "दूसरी तिमाही", "तीसरी तिमाही", "चौथी तिमाही"]
}, XGe = {
  narrow: [
    "ज",
    "फ़",
    "मा",
    "अ",
    "मई",
    "जू",
    "जु",
    "अग",
    "सि",
    "अक्टू",
    "न",
    "दि"
  ],
  abbreviated: [
    "जन",
    "फ़र",
    "मार्च",
    "अप्रैल",
    "मई",
    "जून",
    "जुल",
    "अग",
    "सित",
    "अक्टू",
    "नव",
    "दिस"
  ],
  wide: [
    "जनवरी",
    "फ़रवरी",
    "मार्च",
    "अप्रैल",
    "मई",
    "जून",
    "जुलाई",
    "अगस्त",
    "सितंबर",
    "अक्टूबर",
    "नवंबर",
    "दिसंबर"
  ]
}, GGe = {
  narrow: ["र", "सो", "मं", "बु", "गु", "शु", "श"],
  short: ["र", "सो", "मं", "बु", "गु", "शु", "श"],
  abbreviated: ["रवि", "सोम", "मंगल", "बुध", "गुरु", "शुक्र", "शनि"],
  wide: [
    "रविवार",
    "सोमवार",
    "मंगलवार",
    "बुधवार",
    "गुरुवार",
    "शुक्रवार",
    "शनिवार"
  ]
}, qGe = {
  narrow: {
    am: "पूर्वाह्न",
    pm: "अपराह्न",
    midnight: "मध्यरात्रि",
    noon: "दोपहर",
    morning: "सुबह",
    afternoon: "दोपहर",
    evening: "शाम",
    night: "रात"
  },
  abbreviated: {
    am: "पूर्वाह्न",
    pm: "अपराह्न",
    midnight: "मध्यरात्रि",
    noon: "दोपहर",
    morning: "सुबह",
    afternoon: "दोपहर",
    evening: "शाम",
    night: "रात"
  },
  wide: {
    am: "पूर्वाह्न",
    pm: "अपराह्न",
    midnight: "मध्यरात्रि",
    noon: "दोपहर",
    morning: "सुबह",
    afternoon: "दोपहर",
    evening: "शाम",
    night: "रात"
  }
}, KGe = {
  narrow: {
    am: "पूर्वाह्न",
    pm: "अपराह्न",
    midnight: "मध्यरात्रि",
    noon: "दोपहर",
    morning: "सुबह",
    afternoon: "दोपहर",
    evening: "शाम",
    night: "रात"
  },
  abbreviated: {
    am: "पूर्वाह्न",
    pm: "अपराह्न",
    midnight: "मध्यरात्रि",
    noon: "दोपहर",
    morning: "सुबह",
    afternoon: "दोपहर",
    evening: "शाम",
    night: "रात"
  },
  wide: {
    am: "पूर्वाह्न",
    pm: "अपराह्न",
    midnight: "मध्यरात्रि",
    noon: "दोपहर",
    morning: "सुबह",
    afternoon: "दोपहर",
    evening: "शाम",
    night: "रात"
  }
}, YGe = (e, t) => {
  const r = Number(e);
  return zte(r);
};
function QGe(e) {
  const t = e.toString().replace(/[१२३४५६७८९०]/g, function(r) {
    return $te.number[r];
  });
  return Number(t);
}
function zte(e) {
  return e.toString().replace(/\d/g, function(t) {
    return $te.locale[t];
  });
}
const JGe = {
  ordinalNumber: YGe,
  era: Ce({
    values: BGe,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: UGe,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: XGe,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: GGe,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: qGe,
    defaultWidth: "wide",
    formattingValues: KGe,
    defaultFormattingWidth: "wide"
  })
}, ZGe = {
  lessThanXSeconds: {
    one: "१ सेकंड से कम",
    // CLDR #1310
    other: "{{count}} सेकंड से कम"
  },
  xSeconds: {
    one: "१ सेकंड",
    other: "{{count}} सेकंड"
  },
  halfAMinute: "आधा मिनट",
  lessThanXMinutes: {
    one: "१ मिनट से कम",
    other: "{{count}} मिनट से कम"
  },
  xMinutes: {
    one: "१ मिनट",
    // CLDR #1307
    other: "{{count}} मिनट"
  },
  aboutXHours: {
    one: "लगभग १ घंटा",
    other: "लगभग {{count}} घंटे"
  },
  xHours: {
    one: "१ घंटा",
    // CLDR #1304
    other: "{{count}} घंटे"
    // CLDR #4467
  },
  xDays: {
    one: "१ दिन",
    // CLDR #1286
    other: "{{count}} दिन"
  },
  aboutXWeeks: {
    one: "लगभग १ सप्ताह",
    other: "लगभग {{count}} सप्ताह"
  },
  xWeeks: {
    one: "१ सप्ताह",
    other: "{{count}} सप्ताह"
  },
  aboutXMonths: {
    one: "लगभग १ महीना",
    other: "लगभग {{count}} महीने"
  },
  xMonths: {
    one: "१ महीना",
    other: "{{count}} महीने"
  },
  aboutXYears: {
    one: "लगभग १ वर्ष",
    other: "लगभग {{count}} वर्ष"
    // CLDR #4823
  },
  xYears: {
    one: "१ वर्ष",
    other: "{{count}} वर्ष"
  },
  overXYears: {
    one: "१ वर्ष से अधिक",
    other: "{{count}} वर्ष से अधिक"
  },
  almostXYears: {
    one: "लगभग १ वर्ष",
    other: "लगभग {{count}} वर्ष"
  }
}, eqe = (e, t, r) => {
  let a;
  const i = ZGe[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", zte(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? a + "मे " : a + " पहले" : a;
}, tqe = {
  full: "EEEE, do MMMM, y",
  // CLDR #1787
  long: "do MMMM, y",
  // CLDR #1788
  medium: "d MMM, y",
  // CLDR #1789
  short: "dd/MM/yyyy"
  // CLDR #1790
}, nqe = {
  full: "h:mm:ss a zzzz",
  // CLDR #1791
  long: "h:mm:ss a z",
  // CLDR #1792
  medium: "h:mm:ss a",
  // CLDR #1793
  short: "h:mm a"
  // CLDR #1794
}, rqe = {
  full: "{{date}} 'को' {{time}}",
  // CLDR #1795
  long: "{{date}} 'को' {{time}}",
  // CLDR #1796
  medium: "{{date}}, {{time}}",
  // CLDR #1797
  short: "{{date}}, {{time}}"
  // CLDR #1798
}, aqe = {
  date: Ke({
    formats: tqe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: nqe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: rqe,
    defaultWidth: "full"
  })
}, oqe = {
  lastWeek: "'पिछले' eeee p",
  yesterday: "'कल' p",
  today: "'आज' p",
  tomorrow: "'कल' p",
  nextWeek: "eeee 'को' p",
  other: "P"
}, iqe = (e, t, r, a) => oqe[e], lqe = /^[०१२३४५६७८९]+/i, sqe = /^[०१२३४५६७८९]+/i, uqe = {
  narrow: /^(ईसा-पूर्व|ईस्वी)/i,
  abbreviated: /^(ईसा\.?\s?पूर्व\.?|ईसा\.?)/i,
  wide: /^(ईसा-पूर्व|ईसवी पूर्व|ईसवी सन|ईसवी)/i
}, cqe = {
  any: [/^b/i, /^(a|c)/i]
}, dqe = {
  narrow: /^[1234]/i,
  abbreviated: /^ति[1234]/i,
  wide: /^[1234](पहली|दूसरी|तीसरी|चौथी)? तिमाही/i
}, fqe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, mqe = {
  // eslint-disable-next-line no-misleading-character-class
  narrow: /^[जफ़माअप्मईजूनजुअगसिअक्तनदि]/i,
  abbreviated: /^(जन|फ़र|मार्च|अप्|मई|जून|जुल|अग|सित|अक्तू|नव|दिस)/i,
  wide: /^(जनवरी|फ़रवरी|मार्च|अप्रैल|मई|जून|जुलाई|अगस्त|सितंबर|अक्तूबर|नवंबर|दिसंबर)/i
}, hqe = {
  narrow: [
    /^ज/i,
    /^फ़/i,
    /^मा/i,
    /^अप्/i,
    /^मई/i,
    /^जू/i,
    /^जु/i,
    /^अग/i,
    /^सि/i,
    /^अक्तू/i,
    /^न/i,
    /^दि/i
  ],
  any: [
    /^जन/i,
    /^फ़/i,
    /^मा/i,
    /^अप्/i,
    /^मई/i,
    /^जू/i,
    /^जु/i,
    /^अग/i,
    /^सि/i,
    /^अक्तू/i,
    /^नव/i,
    /^दिस/i
  ]
}, pqe = {
  // eslint-disable-next-line no-misleading-character-class
  narrow: /^[रविसोममंगलबुधगुरुशुक्रशनि]/i,
  short: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
  abbreviated: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
  wide: /^(रविवार|सोमवार|मंगलवार|बुधवार|गुरुवार|शुक्रवार|शनिवार)/i
}, gqe = {
  narrow: [/^रवि/i, /^सोम/i, /^मंगल/i, /^बुध/i, /^गुरु/i, /^शुक्र/i, /^शनि/i],
  any: [/^रवि/i, /^सोम/i, /^मंगल/i, /^बुध/i, /^गुरु/i, /^शुक्र/i, /^शनि/i]
}, vqe = {
  narrow: /^(पू|अ|म|द.\?|सु|दो|शा|रा)/i,
  any: /^(पूर्वाह्न|अपराह्न|म|द.\?|सु|दो|शा|रा)/i
}, bqe = {
  any: {
    am: /^पूर्वाह्न/i,
    pm: /^अपराह्न/i,
    midnight: /^मध्य/i,
    noon: /^दो/i,
    morning: /सु/i,
    afternoon: /दो/i,
    evening: /शा/i,
    night: /रा/i
  }
}, yqe = {
  ordinalNumber: Fn({
    matchPattern: lqe,
    parsePattern: sqe,
    valueCallback: QGe
  }),
  era: Ee({
    matchPatterns: uqe,
    defaultMatchWidth: "wide",
    parsePatterns: cqe,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: dqe,
    defaultMatchWidth: "wide",
    parsePatterns: fqe,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: mqe,
    defaultMatchWidth: "wide",
    parsePatterns: hqe,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: pqe,
    defaultMatchWidth: "wide",
    parsePatterns: gqe,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: vqe,
    defaultMatchWidth: "any",
    parsePatterns: bqe,
    defaultParseWidth: "any"
  })
}, wqe = {
  code: "hi",
  formatDistance: eqe,
  formatLong: aqe,
  formatRelative: iqe,
  localize: JGe,
  match: yqe,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 4
  }
}, Sqe = {
  lessThanXSeconds: {
    one: {
      standalone: "manje od 1 sekunde",
      withPrepositionAgo: "manje od 1 sekunde",
      withPrepositionIn: "manje od 1 sekundu"
    },
    dual: "manje od {{count}} sekunde",
    other: "manje od {{count}} sekundi"
  },
  xSeconds: {
    one: {
      standalone: "1 sekunda",
      withPrepositionAgo: "1 sekunde",
      withPrepositionIn: "1 sekundu"
    },
    dual: "{{count}} sekunde",
    other: "{{count}} sekundi"
  },
  halfAMinute: "pola minute",
  lessThanXMinutes: {
    one: {
      standalone: "manje od 1 minute",
      withPrepositionAgo: "manje od 1 minute",
      withPrepositionIn: "manje od 1 minutu"
    },
    dual: "manje od {{count}} minute",
    other: "manje od {{count}} minuta"
  },
  xMinutes: {
    one: {
      standalone: "1 minuta",
      withPrepositionAgo: "1 minute",
      withPrepositionIn: "1 minutu"
    },
    dual: "{{count}} minute",
    other: "{{count}} minuta"
  },
  aboutXHours: {
    one: {
      standalone: "oko 1 sat",
      withPrepositionAgo: "oko 1 sat",
      withPrepositionIn: "oko 1 sat"
    },
    dual: "oko {{count}} sata",
    other: "oko {{count}} sati"
  },
  xHours: {
    one: {
      standalone: "1 sat",
      withPrepositionAgo: "1 sat",
      withPrepositionIn: "1 sat"
    },
    dual: "{{count}} sata",
    other: "{{count}} sati"
  },
  xDays: {
    one: {
      standalone: "1 dan",
      withPrepositionAgo: "1 dan",
      withPrepositionIn: "1 dan"
    },
    dual: "{{count}} dana",
    other: "{{count}} dana"
  },
  aboutXWeeks: {
    one: {
      standalone: "oko 1 tjedan",
      withPrepositionAgo: "oko 1 tjedan",
      withPrepositionIn: "oko 1 tjedan"
    },
    dual: "oko {{count}} tjedna",
    other: "oko {{count}} tjedana"
  },
  xWeeks: {
    one: {
      standalone: "1 tjedan",
      withPrepositionAgo: "1 tjedan",
      withPrepositionIn: "1 tjedan"
    },
    dual: "{{count}} tjedna",
    other: "{{count}} tjedana"
  },
  aboutXMonths: {
    one: {
      standalone: "oko 1 mjesec",
      withPrepositionAgo: "oko 1 mjesec",
      withPrepositionIn: "oko 1 mjesec"
    },
    dual: "oko {{count}} mjeseca",
    other: "oko {{count}} mjeseci"
  },
  xMonths: {
    one: {
      standalone: "1 mjesec",
      withPrepositionAgo: "1 mjesec",
      withPrepositionIn: "1 mjesec"
    },
    dual: "{{count}} mjeseca",
    other: "{{count}} mjeseci"
  },
  aboutXYears: {
    one: {
      standalone: "oko 1 godinu",
      withPrepositionAgo: "oko 1 godinu",
      withPrepositionIn: "oko 1 godinu"
    },
    dual: "oko {{count}} godine",
    other: "oko {{count}} godina"
  },
  xYears: {
    one: {
      standalone: "1 godina",
      withPrepositionAgo: "1 godine",
      withPrepositionIn: "1 godinu"
    },
    dual: "{{count}} godine",
    other: "{{count}} godina"
  },
  overXYears: {
    one: {
      standalone: "preko 1 godinu",
      withPrepositionAgo: "preko 1 godinu",
      withPrepositionIn: "preko 1 godinu"
    },
    dual: "preko {{count}} godine",
    other: "preko {{count}} godina"
  },
  almostXYears: {
    one: {
      standalone: "gotovo 1 godinu",
      withPrepositionAgo: "gotovo 1 godinu",
      withPrepositionIn: "gotovo 1 godinu"
    },
    dual: "gotovo {{count}} godine",
    other: "gotovo {{count}} godina"
  }
}, Cqe = (e, t, r) => {
  let a;
  const i = Sqe[e];
  return typeof i == "string" ? a = i : t === 1 ? r?.addSuffix ? r.comparison && r.comparison > 0 ? a = i.one.withPrepositionIn : a = i.one.withPrepositionAgo : a = i.one.standalone : t % 10 > 1 && t % 10 < 5 && // if last digit is between 2 and 4
  String(t).substr(-2, 1) !== "1" ? a = i.dual.replace("{{count}}", String(t)) : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? "za " + a : "prije " + a : a;
}, xqe = {
  full: "EEEE, d. MMMM y.",
  long: "d. MMMM y.",
  medium: "d. MMM y.",
  short: "dd. MM. y."
}, Eqe = {
  full: "HH:mm:ss (zzzz)",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Pqe = {
  full: "{{date}} 'u' {{time}}",
  long: "{{date}} 'u' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, kqe = {
  date: Ke({
    formats: xqe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: Eqe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: Pqe,
    defaultWidth: "full"
  })
}, Mqe = {
  lastWeek: (e) => {
    switch (e.getDay()) {
      case 0:
        return "'prošlu nedjelju u' p";
      case 3:
        return "'prošlu srijedu u' p";
      case 6:
        return "'prošlu subotu u' p";
      default:
        return "'prošli' EEEE 'u' p";
    }
  },
  yesterday: "'jučer u' p",
  today: "'danas u' p",
  tomorrow: "'sutra u' p",
  nextWeek: (e) => {
    switch (e.getDay()) {
      case 0:
        return "'iduću nedjelju u' p";
      case 3:
        return "'iduću srijedu u' p";
      case 6:
        return "'iduću subotu u' p";
      default:
        return "'prošli' EEEE 'u' p";
    }
  },
  other: "P"
}, Oqe = (e, t, r, a) => {
  const i = Mqe[e];
  return typeof i == "function" ? i(t) : i;
}, Tqe = {
  narrow: ["pr.n.e.", "AD"],
  abbreviated: ["pr. Kr.", "po. Kr."],
  wide: ["Prije Krista", "Poslije Krista"]
}, Rqe = {
  narrow: ["1.", "2.", "3.", "4."],
  abbreviated: ["1. kv.", "2. kv.", "3. kv.", "4. kv."],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, Aqe = {
  narrow: [
    "1.",
    "2.",
    "3.",
    "4.",
    "5.",
    "6.",
    "7.",
    "8.",
    "9.",
    "10.",
    "11.",
    "12."
  ],
  abbreviated: [
    "sij",
    "velj",
    "ožu",
    "tra",
    "svi",
    "lip",
    "srp",
    "kol",
    "ruj",
    "lis",
    "stu",
    "pro"
  ],
  wide: [
    "siječanj",
    "veljača",
    "ožujak",
    "travanj",
    "svibanj",
    "lipanj",
    "srpanj",
    "kolovoz",
    "rujan",
    "listopad",
    "studeni",
    "prosinac"
  ]
}, Nqe = {
  narrow: [
    "1.",
    "2.",
    "3.",
    "4.",
    "5.",
    "6.",
    "7.",
    "8.",
    "9.",
    "10.",
    "11.",
    "12."
  ],
  abbreviated: [
    "sij",
    "velj",
    "ožu",
    "tra",
    "svi",
    "lip",
    "srp",
    "kol",
    "ruj",
    "lis",
    "stu",
    "pro"
  ],
  wide: [
    "siječnja",
    "veljače",
    "ožujka",
    "travnja",
    "svibnja",
    "lipnja",
    "srpnja",
    "kolovoza",
    "rujna",
    "listopada",
    "studenog",
    "prosinca"
  ]
}, Dqe = {
  narrow: ["N", "P", "U", "S", "Č", "P", "S"],
  short: ["ned", "pon", "uto", "sri", "čet", "pet", "sub"],
  abbreviated: ["ned", "pon", "uto", "sri", "čet", "pet", "sub"],
  wide: [
    "nedjelja",
    "ponedjeljak",
    "utorak",
    "srijeda",
    "četvrtak",
    "petak",
    "subota"
  ]
}, $qe = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutro",
    afternoon: "popodne",
    evening: "navečer",
    night: "noću"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutro",
    afternoon: "popodne",
    evening: "navečer",
    night: "noću"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutro",
    afternoon: "poslije podne",
    evening: "navečer",
    night: "noću"
  }
}, zqe = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutro",
    afternoon: "popodne",
    evening: "navečer",
    night: "noću"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutro",
    afternoon: "popodne",
    evening: "navečer",
    night: "noću"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutro",
    afternoon: "poslije podne",
    evening: "navečer",
    night: "noću"
  }
}, jqe = (e, t) => Number(e) + ".", Iqe = {
  ordinalNumber: jqe,
  era: Ce({
    values: Tqe,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: Rqe,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: Aqe,
    defaultWidth: "wide",
    formattingValues: Nqe,
    defaultFormattingWidth: "wide"
  }),
  day: Ce({
    values: Dqe,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: zqe,
    defaultWidth: "wide",
    formattingValues: $qe,
    defaultFormattingWidth: "wide"
  })
}, Lqe = /^(\d+)\./i, Hqe = /\d+/i, Fqe = {
  narrow: /^(pr\.n\.e\.|AD)/i,
  abbreviated: /^(pr\.\s?Kr\.|po\.\s?Kr\.)/i,
  wide: /^(Prije Krista|prije nove ere|Poslije Krista|nova era)/i
}, Wqe = {
  any: [/^pr/i, /^(po|nova)/i]
}, Vqe = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\.\s?kv\.?/i,
  wide: /^[1234]\. kvartal/i
}, _qe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Bqe = {
  narrow: /^(10|11|12|[123456789])\./i,
  abbreviated: /^(sij|velj|(ožu|ozu)|tra|svi|lip|srp|kol|ruj|lis|stu|pro)/i,
  wide: /^((siječanj|siječnja|sijecanj|sijecnja)|(veljača|veljače|veljaca|veljace)|(ožujak|ožujka|ozujak|ozujka)|(travanj|travnja)|(svibanj|svibnja)|(lipanj|lipnja)|(srpanj|srpnja)|(kolovoz|kolovoza)|(rujan|rujna)|(listopad|listopada)|(studeni|studenog)|(prosinac|prosinca))/i
}, Uqe = {
  narrow: [
    /1/i,
    /2/i,
    /3/i,
    /4/i,
    /5/i,
    /6/i,
    /7/i,
    /8/i,
    /9/i,
    /10/i,
    /11/i,
    /12/i
  ],
  abbreviated: [
    /^sij/i,
    /^velj/i,
    /^(ožu|ozu)/i,
    /^tra/i,
    /^svi/i,
    /^lip/i,
    /^srp/i,
    /^kol/i,
    /^ruj/i,
    /^lis/i,
    /^stu/i,
    /^pro/i
  ],
  wide: [
    /^sij/i,
    /^velj/i,
    /^(ožu|ozu)/i,
    /^tra/i,
    /^svi/i,
    /^lip/i,
    /^srp/i,
    /^kol/i,
    /^ruj/i,
    /^lis/i,
    /^stu/i,
    /^pro/i
  ]
}, Xqe = {
  narrow: /^[npusčc]/i,
  short: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
  abbreviated: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
  wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
}, Gqe = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, qqe = {
  any: /^(am|pm|ponoc|ponoć|(po)?podne|navecer|navečer|noću|poslije podne|ujutro)/i
}, Kqe = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^pono/i,
    noon: /^pod/i,
    morning: /jutro/i,
    afternoon: /(poslije\s|po)+podne/i,
    evening: /(navece|naveče)/i,
    night: /(nocu|noću)/i
  }
}, Yqe = {
  ordinalNumber: Fn({
    matchPattern: Lqe,
    parsePattern: Hqe,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: Fqe,
    defaultMatchWidth: "wide",
    parsePatterns: Wqe,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: Vqe,
    defaultMatchWidth: "wide",
    parsePatterns: _qe,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: Bqe,
    defaultMatchWidth: "wide",
    parsePatterns: Uqe,
    defaultParseWidth: "wide"
  }),
  day: Ee({
    matchPatterns: Xqe,
    defaultMatchWidth: "wide",
    parsePatterns: Gqe,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: qqe,
    defaultMatchWidth: "any",
    parsePatterns: Kqe,
    defaultParseWidth: "any"
  })
}, Qqe = {
  code: "hr",
  formatDistance: Cqe,
  formatLong: kqe,
  formatRelative: Oqe,
  localize: Iqe,
  match: Yqe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, Jqe = {
  lessThanXSeconds: {
    one: "mwens pase yon segond",
    other: "mwens pase {{count}} segond"
  },
  xSeconds: {
    one: "1 segond",
    other: "{{count}} segond"
  },
  halfAMinute: "30 segond",
  lessThanXMinutes: {
    one: "mwens pase yon minit",
    other: "mwens pase {{count}} minit"
  },
  xMinutes: {
    one: "1 minit",
    other: "{{count}} minit"
  },
  aboutXHours: {
    one: "anviwon inè",
    other: "anviwon {{count}} è"
  },
  xHours: {
    one: "1 lè",
    other: "{{count}} lè"
  },
  xDays: {
    one: "1 jou",
    other: "{{count}} jou"
  },
  aboutXWeeks: {
    one: "anviwon 1 semèn",
    other: "anviwon {{count}} semèn"
  },
  xWeeks: {
    one: "1 semèn",
    other: "{{count}} semèn"
  },
  aboutXMonths: {
    one: "anviwon 1 mwa",
    other: "anviwon {{count}} mwa"
  },
  xMonths: {
    one: "1 mwa",
    other: "{{count}} mwa"
  },
  aboutXYears: {
    one: "anviwon 1 an",
    other: "anviwon {{count}} an"
  },
  xYears: {
    one: "1 an",
    other: "{{count}} an"
  },
  overXYears: {
    one: "plis pase 1 an",
    other: "plis pase {{count}} an"
  },
  almostXYears: {
    one: "prèske 1 an",
    other: "prèske {{count}} an"
  }
}, Zqe = (e, t, r) => {
  let a;
  const i = Jqe[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? "nan " + a : "sa fè " + a : a;
}, eKe = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, tKe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, nKe = {
  full: "{{date}} 'nan lè' {{time}}",
  long: "{{date}} 'nan lè' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, rKe = {
  date: Ke({
    formats: eKe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: tKe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: nKe,
    defaultWidth: "full"
  })
}, aKe = {
  lastWeek: "eeee 'pase nan lè' p",
  yesterday: "'yè nan lè' p",
  today: "'jodi a' p",
  tomorrow: "'demen nan lè' p'",
  nextWeek: "eeee 'pwochen nan lè' p",
  other: "P"
}, oKe = (e, t, r, a) => aKe[e], iKe = {
  narrow: ["av. J.-K", "ap. J.-K"],
  abbreviated: ["av. J.-K", "ap. J.-K"],
  wide: ["anvan Jezi Kris", "apre Jezi Kris"]
}, lKe = {
  narrow: ["T1", "T2", "T3", "T4"],
  abbreviated: ["1ye trim.", "2yèm trim.", "3yèm trim.", "4yèm trim."],
  wide: ["1ye trimès", "2yèm trimès", "3yèm trimès", "4yèm trimès"]
}, sKe = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "O", "S", "O", "N", "D"],
  abbreviated: [
    "janv.",
    "fevr.",
    "mas",
    "avr.",
    "me",
    "jen",
    "jiyè",
    "out",
    "sept.",
    "okt.",
    "nov.",
    "des."
  ],
  wide: [
    "janvye",
    "fevrye",
    "mas",
    "avril",
    "me",
    "jen",
    "jiyè",
    "out",
    "septanm",
    "oktòb",
    "novanm",
    "desanm"
  ]
}, uKe = {
  narrow: ["D", "L", "M", "M", "J", "V", "S"],
  short: ["di", "le", "ma", "mè", "je", "va", "sa"],
  abbreviated: ["dim.", "len.", "mad.", "mèk.", "jed.", "van.", "sam."],
  wide: ["dimanch", "lendi", "madi", "mèkredi", "jedi", "vandredi", "samdi"]
}, cKe = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "minwit",
    noon: "midi",
    morning: "mat.",
    afternoon: "ap.m.",
    evening: "swa",
    night: "mat."
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "minwit",
    noon: "midi",
    morning: "maten",
    afternoon: "aprèmidi",
    evening: "swa",
    night: "maten"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "minwit",
    noon: "midi",
    morning: "nan maten",
    afternoon: "nan aprèmidi",
    evening: "nan aswè",
    night: "nan maten"
  }
}, dKe = (e, t) => {
  const r = Number(e);
  return r === 0 ? String(r) : r + (r === 1 ? "ye" : "yèm");
}, fKe = {
  ordinalNumber: dKe,
  era: Ce({
    values: iKe,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: lKe,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: sKe,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: uKe,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: cKe,
    defaultWidth: "wide"
  })
}, mKe = /^(\d+)(ye|yèm)?/i, hKe = /\d+/i, pKe = {
  narrow: /^(av\.J\.K|ap\.J\.K|ap\.J\.-K)/i,
  abbreviated: /^(av\.J\.-K|av\.J-K|apr\.J\.-K|apr\.J-K|ap\.J-K)/i,
  wide: /^(avan Jezi Kris|apre Jezi Kris)/i
}, gKe = {
  any: [/^av/i, /^ap/i]
}, vKe = {
  narrow: /^[1234]/i,
  abbreviated: /^t[1234]/i,
  wide: /^[1234](ye|yèm)? trimès/i
}, bKe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, yKe = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(janv|fevr|mas|avr|me|jen|jiyè|out|sept|okt|nov|des)\.?/i,
  wide: /^(janvye|fevrye|mas|avril|me|jen|jiyè|out|septanm|oktòb|novanm|desanm)/i
}, wKe = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^o/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^ma/i,
    /^av/i,
    /^me/i,
    /^je/i,
    /^ji/i,
    /^ou/i,
    /^s/i,
    /^ok/i,
    /^n/i,
    /^d/i
  ]
}, SKe = {
  narrow: /^[lmjvsd]/i,
  short: /^(di|le|ma|me|je|va|sa)/i,
  abbreviated: /^(dim|len|mad|mèk|jed|van|sam)\.?/i,
  wide: /^(dimanch|lendi|madi|mèkredi|jedi|vandredi|samdi)/i
}, CKe = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^di/i, /^le/i, /^ma/i, /^mè/i, /^je/i, /^va/i, /^sa/i]
}, xKe = {
  narrow: /^(a|p|minwit|midi|mat\.?|ap\.?m\.?|swa)/i,
  any: /^([ap]\.?\s?m\.?|nan maten|nan aprèmidi|nan aswè)/i
}, EKe = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^min/i,
    noon: /^mid/i,
    morning: /mat/i,
    afternoon: /ap/i,
    evening: /sw/i,
    night: /nwit/i
  }
}, PKe = {
  ordinalNumber: Fn({
    matchPattern: mKe,
    parsePattern: hKe,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: pKe,
    defaultMatchWidth: "wide",
    parsePatterns: gKe,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: vKe,
    defaultMatchWidth: "wide",
    parsePatterns: bKe,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: yKe,
    defaultMatchWidth: "wide",
    parsePatterns: wKe,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: SKe,
    defaultMatchWidth: "wide",
    parsePatterns: CKe,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: xKe,
    defaultMatchWidth: "any",
    parsePatterns: EKe,
    defaultParseWidth: "any"
  })
}, kKe = {
  code: "ht",
  formatDistance: Zqe,
  formatLong: rKe,
  formatRelative: oKe,
  localize: fKe,
  match: PKe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, MKe = {
  about: "körülbelül",
  over: "több mint",
  almost: "majdnem",
  lessthan: "kevesebb mint"
}, OKe = {
  xseconds: " másodperc",
  halfaminute: "fél perc",
  xminutes: " perc",
  xhours: " óra",
  xdays: " nap",
  xweeks: " hét",
  xmonths: " hónap",
  xyears: " év"
}, TKe = {
  xseconds: {
    "-1": " másodperccel ezelőtt",
    1: " másodperc múlva",
    0: " másodperce"
  },
  halfaminute: {
    "-1": "fél perccel ezelőtt",
    1: "fél perc múlva",
    0: "fél perce"
  },
  xminutes: {
    "-1": " perccel ezelőtt",
    1: " perc múlva",
    0: " perce"
  },
  xhours: {
    "-1": " órával ezelőtt",
    1: " óra múlva",
    0: " órája"
  },
  xdays: {
    "-1": " nappal ezelőtt",
    1: " nap múlva",
    0: " napja"
  },
  xweeks: {
    "-1": " héttel ezelőtt",
    1: " hét múlva",
    0: " hete"
  },
  xmonths: {
    "-1": " hónappal ezelőtt",
    1: " hónap múlva",
    0: " hónapja"
  },
  xyears: {
    "-1": " évvel ezelőtt",
    1: " év múlva",
    0: " éve"
  }
}, RKe = (e, t, r) => {
  const a = e.match(/about|over|almost|lessthan/i), i = a ? e.replace(a[0], "") : e, c = r?.addSuffix === !0, d = i.toLowerCase(), f = r?.comparison || 0, p = c ? TKe[d][f] : OKe[d];
  let g = d === "halfaminute" ? p : t + p;
  if (a) {
    const b = a[0].toLowerCase();
    g = MKe[b] + " " + g;
  }
  return g;
}, AKe = {
  full: "y. MMMM d., EEEE",
  long: "y. MMMM d.",
  medium: "y. MMM d.",
  short: "y. MM. dd."
}, NKe = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, DKe = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, $Ke = {
  date: Ke({
    formats: AKe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: NKe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: DKe,
    defaultWidth: "full"
  })
}, zKe = [
  "vasárnap",
  "hétfőn",
  "kedden",
  "szerdán",
  "csütörtökön",
  "pénteken",
  "szombaton"
];
function KB(e) {
  return (t) => {
    const r = zKe[t.getDay()];
    return `${e ? "" : "'múlt' "}'${r}' p'-kor'`;
  };
}
const jKe = {
  lastWeek: KB(!1),
  yesterday: "'tegnap' p'-kor'",
  today: "'ma' p'-kor'",
  tomorrow: "'holnap' p'-kor'",
  nextWeek: KB(!0),
  other: "P"
}, IKe = (e, t) => {
  const r = jKe[e];
  return typeof r == "function" ? r(t) : r;
}, LKe = {
  narrow: ["ie.", "isz."],
  abbreviated: ["i. e.", "i. sz."],
  wide: ["Krisztus előtt", "időszámításunk szerint"]
}, HKe = {
  narrow: ["1.", "2.", "3.", "4."],
  abbreviated: ["1. n.év", "2. n.év", "3. n.év", "4. n.év"],
  wide: ["1. negyedév", "2. negyedév", "3. negyedév", "4. negyedév"]
}, FKe = {
  narrow: ["I.", "II.", "III.", "IV."],
  abbreviated: ["I. n.év", "II. n.év", "III. n.év", "IV. n.év"],
  wide: ["I. negyedév", "II. negyedév", "III. negyedév", "IV. negyedév"]
}, WKe = {
  narrow: ["J", "F", "M", "Á", "M", "J", "J", "A", "Sz", "O", "N", "D"],
  abbreviated: [
    "jan.",
    "febr.",
    "márc.",
    "ápr.",
    "máj.",
    "jún.",
    "júl.",
    "aug.",
    "szept.",
    "okt.",
    "nov.",
    "dec."
  ],
  wide: [
    "január",
    "február",
    "március",
    "április",
    "május",
    "június",
    "július",
    "augusztus",
    "szeptember",
    "október",
    "november",
    "december"
  ]
}, VKe = {
  narrow: ["V", "H", "K", "Sz", "Cs", "P", "Sz"],
  short: ["V", "H", "K", "Sze", "Cs", "P", "Szo"],
  abbreviated: ["V", "H", "K", "Sze", "Cs", "P", "Szo"],
  wide: [
    "vasárnap",
    "hétfő",
    "kedd",
    "szerda",
    "csütörtök",
    "péntek",
    "szombat"
  ]
}, _Ke = {
  narrow: {
    am: "de.",
    pm: "du.",
    midnight: "éjfél",
    noon: "dél",
    morning: "reggel",
    afternoon: "du.",
    evening: "este",
    night: "éjjel"
  },
  abbreviated: {
    am: "de.",
    pm: "du.",
    midnight: "éjfél",
    noon: "dél",
    morning: "reggel",
    afternoon: "du.",
    evening: "este",
    night: "éjjel"
  },
  wide: {
    am: "de.",
    pm: "du.",
    midnight: "éjfél",
    noon: "dél",
    morning: "reggel",
    afternoon: "délután",
    evening: "este",
    night: "éjjel"
  }
}, BKe = (e, t) => Number(e) + ".", UKe = {
  ordinalNumber: BKe,
  era: Ce({
    values: LKe,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: HKe,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1,
    formattingValues: FKe,
    defaultFormattingWidth: "wide"
  }),
  month: Ce({
    values: WKe,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: VKe,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: _Ke,
    defaultWidth: "wide"
  })
}, XKe = /^(\d+)\.?/i, GKe = /\d+/i, qKe = {
  narrow: /^(ie\.|isz\.)/i,
  abbreviated: /^(i\.\s?e\.?|b?\s?c\s?e|i\.\s?sz\.?)/i,
  wide: /^(Krisztus előtt|időszámításunk előtt|időszámításunk szerint|i\. sz\.)/i
}, KKe = {
  narrow: [/ie/i, /isz/i],
  abbreviated: [/^(i\.?\s?e\.?|b\s?ce)/i, /^(i\.?\s?sz\.?|c\s?e)/i],
  any: [/előtt/i, /(szerint|i. sz.)/i]
}, YKe = {
  narrow: /^[1234]\.?/i,
  abbreviated: /^[1234]?\.?\s?n\.év/i,
  wide: /^([1234]|I|II|III|IV)?\.?\s?negyedév/i
}, QKe = {
  any: [/1|I$/i, /2|II$/i, /3|III/i, /4|IV/i]
}, JKe = {
  narrow: /^[jfmaásond]|sz/i,
  abbreviated: /^(jan\.?|febr\.?|márc\.?|ápr\.?|máj\.?|jún\.?|júl\.?|aug\.?|szept\.?|okt\.?|nov\.?|dec\.?)/i,
  wide: /^(január|február|március|április|május|június|július|augusztus|szeptember|október|november|december)/i
}, ZKe = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a|á/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s|sz/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^már/i,
    /^áp/i,
    /^máj/i,
    /^jún/i,
    /^júl/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, eYe = {
  narrow: /^([vhkpc]|sz|cs|sz)/i,
  short: /^([vhkp]|sze|cs|szo)/i,
  abbreviated: /^([vhkp]|sze|cs|szo)/i,
  wide: /^(vasárnap|hétfő|kedd|szerda|csütörtök|péntek|szombat)/i
}, tYe = {
  narrow: [/^v/i, /^h/i, /^k/i, /^sz/i, /^c/i, /^p/i, /^sz/i],
  any: [/^v/i, /^h/i, /^k/i, /^sze/i, /^c/i, /^p/i, /^szo/i]
}, nYe = {
  any: /^((de|du)\.?|éjfél|délután|dél|reggel|este|éjjel)/i
}, rYe = {
  any: {
    am: /^de\.?/i,
    pm: /^du\.?/i,
    midnight: /^éjf/i,
    noon: /^dé/i,
    morning: /reg/i,
    afternoon: /^délu\.?/i,
    evening: /es/i,
    night: /éjj/i
  }
}, aYe = {
  ordinalNumber: Fn({
    matchPattern: XKe,
    parsePattern: GKe,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: qKe,
    defaultMatchWidth: "wide",
    parsePatterns: KKe,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: YKe,
    defaultMatchWidth: "wide",
    parsePatterns: QKe,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: JKe,
    defaultMatchWidth: "wide",
    parsePatterns: ZKe,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: eYe,
    defaultMatchWidth: "wide",
    parsePatterns: tYe,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: nYe,
    defaultMatchWidth: "any",
    parsePatterns: rYe,
    defaultParseWidth: "any"
  })
}, oYe = {
  code: "hu",
  formatDistance: RKe,
  formatLong: $Ke,
  formatRelative: IKe,
  localize: UKe,
  match: aYe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, iYe = {
  lessThanXSeconds: {
    one: "ավելի քիչ քան 1 վայրկյան",
    other: "ավելի քիչ քան {{count}} վայրկյան"
  },
  xSeconds: {
    one: "1 վայրկյան",
    other: "{{count}} վայրկյան"
  },
  halfAMinute: "կես րոպե",
  lessThanXMinutes: {
    one: "ավելի քիչ քան 1 րոպե",
    other: "ավելի քիչ քան {{count}} րոպե"
  },
  xMinutes: {
    one: "1 րոպե",
    other: "{{count}} րոպե"
  },
  aboutXHours: {
    one: "մոտ 1 ժամ",
    other: "մոտ {{count}} ժամ"
  },
  xHours: {
    one: "1 ժամ",
    other: "{{count}} ժամ"
  },
  xDays: {
    one: "1 օր",
    other: "{{count}} օր"
  },
  aboutXWeeks: {
    one: "մոտ 1 շաբաթ",
    other: "մոտ {{count}} շաբաթ"
  },
  xWeeks: {
    one: "1 շաբաթ",
    other: "{{count}} շաբաթ"
  },
  aboutXMonths: {
    one: "մոտ 1 ամիս",
    other: "մոտ {{count}} ամիս"
  },
  xMonths: {
    one: "1 ամիս",
    other: "{{count}} ամիս"
  },
  aboutXYears: {
    one: "մոտ 1 տարի",
    other: "մոտ {{count}} տարի"
  },
  xYears: {
    one: "1 տարի",
    other: "{{count}} տարի"
  },
  overXYears: {
    one: "ավելի քան 1 տարի",
    other: "ավելի քան {{count}} տարի"
  },
  almostXYears: {
    one: "համարյա 1 տարի",
    other: "համարյա {{count}} տարի"
  }
}, lYe = (e, t, r) => {
  let a;
  const i = iYe[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? a + " հետո" : a + " առաջ" : a;
}, sYe = {
  full: "d MMMM, y, EEEE",
  long: "d MMMM, y",
  medium: "d MMM, y",
  short: "dd.MM.yyyy"
}, uYe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, cYe = {
  full: "{{date}} 'ժ․'{{time}}",
  long: "{{date}} 'ժ․'{{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, dYe = {
  date: Ke({
    formats: sYe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: uYe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: cYe,
    defaultWidth: "full"
  })
}, fYe = {
  lastWeek: "'նախորդ' eeee p'֊ին'",
  yesterday: "'երեկ' p'֊ին'",
  today: "'այսօր' p'֊ին'",
  tomorrow: "'վաղը' p'֊ին'",
  nextWeek: "'հաջորդ' eeee p'֊ին'",
  other: "P"
}, mYe = (e, t, r, a) => fYe[e], hYe = {
  narrow: ["Ք", "Մ"],
  abbreviated: ["ՔԱ", "ՄԹ"],
  wide: ["Քրիստոսից առաջ", "Մեր թվարկության"]
}, pYe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Ք1", "Ք2", "Ք3", "Ք4"],
  wide: ["1֊ին քառորդ", "2֊րդ քառորդ", "3֊րդ քառորդ", "4֊րդ քառորդ"]
}, gYe = {
  narrow: ["Հ", "Փ", "Մ", "Ա", "Մ", "Հ", "Հ", "Օ", "Ս", "Հ", "Ն", "Դ"],
  abbreviated: [
    "հուն",
    "փետ",
    "մար",
    "ապր",
    "մայ",
    "հուն",
    "հուլ",
    "օգս",
    "սեպ",
    "հոկ",
    "նոյ",
    "դեկ"
  ],
  wide: [
    "հունվար",
    "փետրվար",
    "մարտ",
    "ապրիլ",
    "մայիս",
    "հունիս",
    "հուլիս",
    "օգոստոս",
    "սեպտեմբեր",
    "հոկտեմբեր",
    "նոյեմբեր",
    "դեկտեմբեր"
  ]
}, vYe = {
  narrow: ["Կ", "Ե", "Ե", "Չ", "Հ", "Ո", "Շ"],
  short: ["կր", "եր", "եք", "չք", "հգ", "ուր", "շբ"],
  abbreviated: ["կիր", "երկ", "երք", "չոր", "հնգ", "ուրբ", "շաբ"],
  wide: [
    "կիրակի",
    "երկուշաբթի",
    "երեքշաբթի",
    "չորեքշաբթի",
    "հինգշաբթի",
    "ուրբաթ",
    "շաբաթ"
  ]
}, bYe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "կեսգշ",
    noon: "կեսօր",
    morning: "առավոտ",
    afternoon: "ցերեկ",
    evening: "երեկո",
    night: "գիշեր"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "կեսգիշեր",
    noon: "կեսօր",
    morning: "առավոտ",
    afternoon: "ցերեկ",
    evening: "երեկո",
    night: "գիշեր"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "կեսգիշեր",
    noon: "կեսօր",
    morning: "առավոտ",
    afternoon: "ցերեկ",
    evening: "երեկո",
    night: "գիշեր"
  }
}, yYe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "կեսգշ",
    noon: "կեսօր",
    morning: "առավոտը",
    afternoon: "ցերեկը",
    evening: "երեկոյան",
    night: "գիշերը"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "կեսգիշերին",
    noon: "կեսօրին",
    morning: "առավոտը",
    afternoon: "ցերեկը",
    evening: "երեկոյան",
    night: "գիշերը"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "կեսգիշերին",
    noon: "կեսօրին",
    morning: "առավոտը",
    afternoon: "ցերեկը",
    evening: "երեկոյան",
    night: "գիշերը"
  }
}, wYe = (e, t) => {
  const r = Number(e), a = r % 100;
  return a < 10 && a % 10 === 1 ? r + "֊ին" : r + "֊րդ";
}, SYe = {
  ordinalNumber: wYe,
  era: Ce({
    values: hYe,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: pYe,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: gYe,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: vYe,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: bYe,
    defaultWidth: "wide",
    formattingValues: yYe,
    defaultFormattingWidth: "wide"
  })
}, CYe = /^(\d+)((-|֊)?(ին|րդ))?/i, xYe = /\d+/i, EYe = {
  narrow: /^(Ք|Մ)/i,
  abbreviated: /^(Ք\.?\s?Ա\.?|Մ\.?\s?Թ\.?\s?Ա\.?|Մ\.?\s?Թ\.?|Ք\.?\s?Հ\.?)/i,
  wide: /^(քրիստոսից առաջ|մեր թվարկությունից առաջ|մեր թվարկության|քրիստոսից հետո)/i
}, PYe = {
  any: [/^ք/i, /^մ/i]
}, kYe = {
  narrow: /^[1234]/i,
  abbreviated: /^ք[1234]/i,
  wide: /^[1234]((-|֊)?(ին|րդ)) քառորդ/i
}, MYe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, OYe = {
  narrow: /^[հփմաօսնդ]/i,
  abbreviated: /^(հուն|փետ|մար|ապր|մայ|հուն|հուլ|օգս|սեպ|հոկ|նոյ|դեկ)/i,
  wide: /^(հունվար|փետրվար|մարտ|ապրիլ|մայիս|հունիս|հուլիս|օգոստոս|սեպտեմբեր|հոկտեմբեր|նոյեմբեր|դեկտեմբեր)/i
}, TYe = {
  narrow: [
    /^հ/i,
    /^փ/i,
    /^մ/i,
    /^ա/i,
    /^մ/i,
    /^հ/i,
    /^հ/i,
    /^օ/i,
    /^ս/i,
    /^հ/i,
    /^ն/i,
    /^դ/i
  ],
  any: [
    /^հու/i,
    /^փ/i,
    /^մար/i,
    /^ա/i,
    /^մայ/i,
    /^հուն/i,
    /^հուլ/i,
    /^օ/i,
    /^ս/i,
    /^հոկ/i,
    /^ն/i,
    /^դ/i
  ]
}, RYe = {
  narrow: /^[եչհոշկ]/i,
  short: /^(կր|եր|եք|չք|հգ|ուր|շբ)/i,
  abbreviated: /^(կիր|երկ|երք|չոր|հնգ|ուրբ|շաբ)/i,
  wide: /^(կիրակի|երկուշաբթի|երեքշաբթի|չորեքշաբթի|հինգշաբթի|ուրբաթ|շաբաթ)/i
}, AYe = {
  narrow: [/^կ/i, /^ե/i, /^ե/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i],
  short: [/^կ/i, /^եր/i, /^եք/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i],
  abbreviated: [/^կ/i, /^երկ/i, /^երք/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i],
  wide: [/^կ/i, /^երկ/i, /^երե/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i]
}, NYe = {
  narrow: /^([ap]|կեսգշ|կեսօր|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i,
  any: /^([ap]\.?\s?m\.?|կեսգիշեր(ին)?|կեսօր(ին)?|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i
}, DYe = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /կեսգիշեր/i,
    noon: /կեսօր/i,
    morning: /առավոտ/i,
    afternoon: /ցերեկ/i,
    evening: /երեկո/i,
    night: /գիշեր/i
  }
}, $Ye = {
  ordinalNumber: Fn({
    matchPattern: CYe,
    parsePattern: xYe,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: EYe,
    defaultMatchWidth: "wide",
    parsePatterns: PYe,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: kYe,
    defaultMatchWidth: "wide",
    parsePatterns: MYe,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: OYe,
    defaultMatchWidth: "wide",
    parsePatterns: TYe,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: RYe,
    defaultMatchWidth: "wide",
    parsePatterns: AYe,
    defaultParseWidth: "wide"
  }),
  dayPeriod: Ee({
    matchPatterns: NYe,
    defaultMatchWidth: "any",
    parsePatterns: DYe,
    defaultParseWidth: "any"
  })
}, zYe = {
  code: "hy",
  formatDistance: lYe,
  formatLong: dYe,
  formatRelative: mYe,
  localize: SYe,
  match: $Ye,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, jYe = {
  lessThanXSeconds: {
    one: "kurang dari 1 detik",
    other: "kurang dari {{count}} detik"
  },
  xSeconds: {
    one: "1 detik",
    other: "{{count}} detik"
  },
  halfAMinute: "setengah menit",
  lessThanXMinutes: {
    one: "kurang dari 1 menit",
    other: "kurang dari {{count}} menit"
  },
  xMinutes: {
    one: "1 menit",
    other: "{{count}} menit"
  },
  aboutXHours: {
    one: "sekitar 1 jam",
    other: "sekitar {{count}} jam"
  },
  xHours: {
    one: "1 jam",
    other: "{{count}} jam"
  },
  xDays: {
    one: "1 hari",
    other: "{{count}} hari"
  },
  aboutXWeeks: {
    one: "sekitar 1 minggu",
    other: "sekitar {{count}} minggu"
  },
  xWeeks: {
    one: "1 minggu",
    other: "{{count}} minggu"
  },
  aboutXMonths: {
    one: "sekitar 1 bulan",
    other: "sekitar {{count}} bulan"
  },
  xMonths: {
    one: "1 bulan",
    other: "{{count}} bulan"
  },
  aboutXYears: {
    one: "sekitar 1 tahun",
    other: "sekitar {{count}} tahun"
  },
  xYears: {
    one: "1 tahun",
    other: "{{count}} tahun"
  },
  overXYears: {
    one: "lebih dari 1 tahun",
    other: "lebih dari {{count}} tahun"
  },
  almostXYears: {
    one: "hampir 1 tahun",
    other: "hampir {{count}} tahun"
  }
}, IYe = (e, t, r) => {
  let a;
  const i = jYe[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", t.toString()), r?.addSuffix ? r.comparison && r.comparison > 0 ? "dalam waktu " + a : a + " yang lalu" : a;
}, LYe = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "d/M/yyyy"
}, HYe = {
  full: "HH.mm.ss",
  long: "HH.mm.ss",
  medium: "HH.mm",
  short: "HH.mm"
}, FYe = {
  full: "{{date}} 'pukul' {{time}}",
  long: "{{date}} 'pukul' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, WYe = {
  date: Ke({
    formats: LYe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: HYe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: FYe,
    defaultWidth: "full"
  })
}, VYe = {
  lastWeek: "eeee 'lalu pukul' p",
  yesterday: "'Kemarin pukul' p",
  today: "'Hari ini pukul' p",
  tomorrow: "'Besok pukul' p",
  nextWeek: "eeee 'pukul' p",
  other: "P"
}, _Ye = (e, t, r, a) => VYe[e], BYe = {
  narrow: ["SM", "M"],
  abbreviated: ["SM", "M"],
  wide: ["Sebelum Masehi", "Masehi"]
}, UYe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["Kuartal ke-1", "Kuartal ke-2", "Kuartal ke-3", "Kuartal ke-4"]
}, XYe = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "Mei",
    "Jun",
    "Jul",
    "Agt",
    "Sep",
    "Okt",
    "Nov",
    "Des"
  ],
  wide: [
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember"
  ]
}, GYe = {
  narrow: ["M", "S", "S", "R", "K", "J", "S"],
  short: ["Min", "Sen", "Sel", "Rab", "Kam", "Jum", "Sab"],
  abbreviated: ["Min", "Sen", "Sel", "Rab", "Kam", "Jum", "Sab"],
  wide: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"]
}, qYe = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "siang",
    evening: "sore",
    night: "malam"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "siang",
    evening: "sore",
    night: "malam"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "siang",
    evening: "sore",
    night: "malam"
  }
}, KYe = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "siang",
    evening: "sore",
    night: "malam"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "siang",
    evening: "sore",
    night: "malam"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "siang",
    evening: "sore",
    night: "malam"
  }
}, YYe = (e, t) => "ke-" + Number(e), QYe = {
  ordinalNumber: YYe,
  era: Ce({
    values: BYe,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: UYe,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: XYe,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: GYe,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: qYe,
    defaultWidth: "wide",
    formattingValues: KYe,
    defaultFormattingWidth: "wide"
  })
}, JYe = /^ke-(\d+)?/i, ZYe = /\d+/i, eQe = {
  narrow: /^(sm|m)/i,
  abbreviated: /^(s\.?\s?m\.?|s\.?\s?e\.?\s?u\.?|m\.?|e\.?\s?u\.?)/i,
  wide: /^(sebelum masehi|sebelum era umum|masehi|era umum)/i
}, tQe = {
  any: [/^s/i, /^(m|e)/i]
}, nQe = {
  narrow: /^[1234]/i,
  abbreviated: /^K-?\s[1234]/i,
  wide: /^Kuartal ke-?\s?[1234]/i
}, rQe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, aQe = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|mei|jun|jul|agt|sep|okt|nov|des)/i,
  wide: /^(januari|februari|maret|april|mei|juni|juli|agustus|september|oktober|november|desember)/i
}, oQe = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^ma/i,
    /^ap/i,
    /^me/i,
    /^jun/i,
    /^jul/i,
    /^ag/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, iQe = {
  narrow: /^[srkjm]/i,
  short: /^(min|sen|sel|rab|kam|jum|sab)/i,
  abbreviated: /^(min|sen|sel|rab|kam|jum|sab)/i,
  wide: /^(minggu|senin|selasa|rabu|kamis|jumat|sabtu)/i
}, lQe = {
  narrow: [/^m/i, /^s/i, /^s/i, /^r/i, /^k/i, /^j/i, /^s/i],
  any: [/^m/i, /^sen/i, /^sel/i, /^r/i, /^k/i, /^j/i, /^sa/i]
}, sQe = {
  narrow: /^(a|p|tengah m|tengah h|(di(\swaktu)?) (pagi|siang|sore|malam))/i,
  any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|(di(\swaktu)?) (pagi|siang|sore|malam))/i
}, uQe = {
  any: {
    am: /^a/i,
    pm: /^pm/i,
    midnight: /^tengah m/i,
    noon: /^tengah h/i,
    morning: /pagi/i,
    afternoon: /siang/i,
    evening: /sore/i,
    night: /malam/i
  }
}, cQe = {
  ordinalNumber: Fn({
    matchPattern: JYe,
    parsePattern: ZYe,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: eQe,
    defaultMatchWidth: "wide",
    parsePatterns: tQe,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: nQe,
    defaultMatchWidth: "wide",
    parsePatterns: rQe,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: aQe,
    defaultMatchWidth: "wide",
    parsePatterns: oQe,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: iQe,
    defaultMatchWidth: "wide",
    parsePatterns: lQe,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: sQe,
    defaultMatchWidth: "any",
    parsePatterns: uQe,
    defaultParseWidth: "any"
  })
}, dQe = {
  code: "id",
  formatDistance: IYe,
  formatLong: WYe,
  formatRelative: _Ye,
  localize: QYe,
  match: cQe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, fQe = {
  lessThanXSeconds: {
    one: "minna en 1 sekúnda",
    other: "minna en {{count}} sekúndur"
  },
  xSeconds: {
    one: "1 sekúnda",
    other: "{{count}} sekúndur"
  },
  halfAMinute: "hálf mínúta",
  lessThanXMinutes: {
    one: "minna en 1 mínúta",
    other: "minna en {{count}} mínútur"
  },
  xMinutes: {
    one: "1 mínúta",
    other: "{{count}} mínútur"
  },
  aboutXHours: {
    one: "u.þ.b. 1 klukkustund",
    other: "u.þ.b. {{count}} klukkustundir"
  },
  xHours: {
    one: "1 klukkustund",
    other: "{{count}} klukkustundir"
  },
  xDays: {
    one: "1 dagur",
    other: "{{count}} dagar"
  },
  aboutXWeeks: {
    one: "um viku",
    other: "um {{count}} vikur"
  },
  xWeeks: {
    one: "1 viku",
    other: "{{count}} vikur"
  },
  aboutXMonths: {
    one: "u.þ.b. 1 mánuður",
    other: "u.þ.b. {{count}} mánuðir"
  },
  xMonths: {
    one: "1 mánuður",
    other: "{{count}} mánuðir"
  },
  aboutXYears: {
    one: "u.þ.b. 1 ár",
    other: "u.þ.b. {{count}} ár"
  },
  xYears: {
    one: "1 ár",
    other: "{{count}} ár"
  },
  overXYears: {
    one: "meira en 1 ár",
    other: "meira en {{count}} ár"
  },
  almostXYears: {
    one: "næstum 1 ár",
    other: "næstum {{count}} ár"
  }
}, mQe = (e, t, r) => {
  let a;
  const i = fQe[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", t.toString()), r?.addSuffix ? r.comparison && r.comparison > 0 ? "í " + a : a + " síðan" : a;
}, hQe = {
  full: "EEEE, do MMMM y",
  long: "do MMMM y",
  medium: "do MMM y",
  short: "d.MM.y"
}, pQe = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, gQe = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, vQe = {
  date: Ke({
    formats: hQe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: pQe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: gQe,
    defaultWidth: "full"
  })
}, bQe = {
  lastWeek: "'síðasta' dddd 'kl.' p",
  yesterday: "'í gær kl.' p",
  today: "'í dag kl.' p",
  tomorrow: "'á morgun kl.' p",
  nextWeek: "dddd 'kl.' p",
  other: "P"
}, yQe = (e, t, r, a) => bQe[e], wQe = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["fyrir Krist", "eftir Krist"]
}, SQe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1F", "2F", "3F", "4F"],
  wide: ["1. fjórðungur", "2. fjórðungur", "3. fjórðungur", "4. fjórðungur"]
}, CQe = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "Á", "S", "Ó", "N", "D"],
  abbreviated: [
    "jan.",
    "feb.",
    "mars",
    "apríl",
    "maí",
    "júní",
    "júlí",
    "ágúst",
    "sept.",
    "okt.",
    "nóv.",
    "des."
  ],
  wide: [
    "janúar",
    "febrúar",
    "mars",
    "apríl",
    "maí",
    "júní",
    "júlí",
    "ágúst",
    "september",
    "október",
    "nóvember",
    "desember"
  ]
}, xQe = {
  narrow: ["S", "M", "Þ", "M", "F", "F", "L"],
  short: ["Su", "Má", "Þr", "Mi", "Fi", "Fö", "La"],
  abbreviated: ["sun.", "mán.", "þri.", "mið.", "fim.", "fös.", "lau."],
  wide: [
    "sunnudagur",
    "mánudagur",
    "þriðjudagur",
    "miðvikudagur",
    "fimmtudagur",
    "föstudagur",
    "laugardagur"
  ]
}, EQe = {
  narrow: {
    am: "f",
    pm: "e",
    midnight: "miðnætti",
    noon: "hádegi",
    morning: "morgunn",
    afternoon: "síðdegi",
    evening: "kvöld",
    night: "nótt"
  },
  abbreviated: {
    am: "f.h.",
    pm: "e.h.",
    midnight: "miðnætti",
    noon: "hádegi",
    morning: "morgunn",
    afternoon: "síðdegi",
    evening: "kvöld",
    night: "nótt"
  },
  wide: {
    am: "fyrir hádegi",
    pm: "eftir hádegi",
    midnight: "miðnætti",
    noon: "hádegi",
    morning: "morgunn",
    afternoon: "síðdegi",
    evening: "kvöld",
    night: "nótt"
  }
}, PQe = {
  narrow: {
    am: "f",
    pm: "e",
    midnight: "á miðnætti",
    noon: "á hádegi",
    morning: "að morgni",
    afternoon: "síðdegis",
    evening: "um kvöld",
    night: "um nótt"
  },
  abbreviated: {
    am: "f.h.",
    pm: "e.h.",
    midnight: "á miðnætti",
    noon: "á hádegi",
    morning: "að morgni",
    afternoon: "síðdegis",
    evening: "um kvöld",
    night: "um nótt"
  },
  wide: {
    am: "fyrir hádegi",
    pm: "eftir hádegi",
    midnight: "á miðnætti",
    noon: "á hádegi",
    morning: "að morgni",
    afternoon: "síðdegis",
    evening: "um kvöld",
    night: "um nótt"
  }
}, kQe = (e, t) => Number(e) + ".", MQe = {
  ordinalNumber: kQe,
  era: Ce({
    values: wQe,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: SQe,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: CQe,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: xQe,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: EQe,
    defaultWidth: "wide",
    formattingValues: PQe,
    defaultFormattingWidth: "wide"
  })
}, OQe = /^(\d+)(\.)?/i, TQe = /\d+(\.)?/i, RQe = {
  narrow: /^(f\.Kr\.|e\.Kr\.)/i,
  abbreviated: /^(f\.Kr\.|e\.Kr\.)/i,
  wide: /^(fyrir Krist|eftir Krist)/i
}, AQe = {
  any: [/^(f\.Kr\.)/i, /^(e\.Kr\.)/i]
}, NQe = {
  narrow: /^[1234]\.?/i,
  abbreviated: /^q[1234]\.?/i,
  wide: /^[1234]\.? fjórðungur/i
}, DQe = {
  any: [/1\.?/i, /2\.?/i, /3\.?/i, /4\.?/i]
}, $Qe = {
  narrow: /^[jfmásónd]/i,
  abbreviated: /^(jan\.|feb\.|mars\.|apríl\.|maí|júní|júlí|águst|sep\.|oct\.|nov\.|dec\.)/i,
  wide: /^(januar|febrúar|mars|apríl|maí|júní|júlí|águst|september|október|nóvember|desember)/i
}, zQe = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^á/i,
    /^s/i,
    /^ó/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^maí/i,
    /^jún/i,
    /^júl/i,
    /^áu/i,
    /^s/i,
    /^ó/i,
    /^n/i,
    /^d/i
  ]
}, jQe = {
  narrow: /^[smtwf]/i,
  short: /^(su|má|þr|mi|fi|fö|la)/i,
  abbreviated: /^(sun|mán|þri|mið|fim|fös|lau)\.?/i,
  wide: /^(sunnudagur|mánudagur|þriðjudagur|miðvikudagur|fimmtudagur|föstudagur|laugardagur)/i
}, IQe = {
  narrow: [/^s/i, /^m/i, /^þ/i, /^m/i, /^f/i, /^f/i, /^l/i],
  any: [/^su/i, /^má/i, /^þr/i, /^mi/i, /^fi/i, /^fö/i, /^la/i]
}, LQe = {
  narrow: /^(f|e|síðdegis|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i,
  any: /^(fyrir hádegi|eftir hádegi|[ef]\.?h\.?|síðdegis|morgunn|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i
}, HQe = {
  any: {
    am: /^f/i,
    pm: /^e/i,
    midnight: /^mi/i,
    noon: /^há/i,
    morning: /morgunn/i,
    afternoon: /síðdegi/i,
    evening: /kvöld/i,
    night: /nótt/i
  }
}, FQe = {
  ordinalNumber: Fn({
    matchPattern: OQe,
    parsePattern: TQe,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: RQe,
    defaultMatchWidth: "wide",
    parsePatterns: AQe,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: NQe,
    defaultMatchWidth: "wide",
    parsePatterns: DQe,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: $Qe,
    defaultMatchWidth: "wide",
    parsePatterns: zQe,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: jQe,
    defaultMatchWidth: "wide",
    parsePatterns: IQe,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: LQe,
    defaultMatchWidth: "any",
    parsePatterns: HQe,
    defaultParseWidth: "any"
  })
}, WQe = {
  code: "is",
  formatDistance: mQe,
  formatLong: vQe,
  formatRelative: yQe,
  localize: MQe,
  match: FQe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, VQe = {
  lessThanXSeconds: {
    one: "meno di un secondo",
    other: "meno di {{count}} secondi"
  },
  xSeconds: {
    one: "un secondo",
    other: "{{count}} secondi"
  },
  halfAMinute: "alcuni secondi",
  lessThanXMinutes: {
    one: "meno di un minuto",
    other: "meno di {{count}} minuti"
  },
  xMinutes: {
    one: "un minuto",
    other: "{{count}} minuti"
  },
  aboutXHours: {
    one: "circa un'ora",
    other: "circa {{count}} ore"
  },
  xHours: {
    one: "un'ora",
    other: "{{count}} ore"
  },
  xDays: {
    one: "un giorno",
    other: "{{count}} giorni"
  },
  aboutXWeeks: {
    one: "circa una settimana",
    other: "circa {{count}} settimane"
  },
  xWeeks: {
    one: "una settimana",
    other: "{{count}} settimane"
  },
  aboutXMonths: {
    one: "circa un mese",
    other: "circa {{count}} mesi"
  },
  xMonths: {
    one: "un mese",
    other: "{{count}} mesi"
  },
  aboutXYears: {
    one: "circa un anno",
    other: "circa {{count}} anni"
  },
  xYears: {
    one: "un anno",
    other: "{{count}} anni"
  },
  overXYears: {
    one: "più di un anno",
    other: "più di {{count}} anni"
  },
  almostXYears: {
    one: "quasi un anno",
    other: "quasi {{count}} anni"
  }
}, jte = (e, t, r) => {
  let a;
  const i = VQe[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", t.toString()), r?.addSuffix ? r.comparison && r.comparison > 0 ? "tra " + a : a + " fa" : a;
}, _Qe = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, BQe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, UQe = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, XQe = {
  date: Ke({
    formats: _Qe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: BQe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: UQe,
    defaultWidth: "full"
  })
}, xI = [
  "domenica",
  "lunedì",
  "martedì",
  "mercoledì",
  "giovedì",
  "venerdì",
  "sabato"
];
function GQe(e) {
  switch (e) {
    case 0:
      return "'domenica scorsa alle' p";
    default:
      return "'" + xI[e] + " scorso alle' p";
  }
}
function YB(e) {
  return "'" + xI[e] + " alle' p";
}
function qQe(e) {
  switch (e) {
    case 0:
      return "'domenica prossima alle' p";
    default:
      return "'" + xI[e] + " prossimo alle' p";
  }
}
const KQe = {
  lastWeek: (e, t, r) => {
    const a = e.getDay();
    return su(e, t, r) ? YB(a) : GQe(a);
  },
  yesterday: "'ieri alle' p",
  today: "'oggi alle' p",
  tomorrow: "'domani alle' p",
  nextWeek: (e, t, r) => {
    const a = e.getDay();
    return su(e, t, r) ? YB(a) : qQe(a);
  },
  other: "P"
}, Ite = (e, t, r, a) => {
  const i = KQe[e];
  return typeof i == "function" ? i(t, r, a) : i;
}, YQe = {
  narrow: ["aC", "dC"],
  abbreviated: ["a.C.", "d.C."],
  wide: ["avanti Cristo", "dopo Cristo"]
}, QQe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, JQe = {
  narrow: ["G", "F", "M", "A", "M", "G", "L", "A", "S", "O", "N", "D"],
  abbreviated: [
    "gen",
    "feb",
    "mar",
    "apr",
    "mag",
    "giu",
    "lug",
    "ago",
    "set",
    "ott",
    "nov",
    "dic"
  ],
  wide: [
    "gennaio",
    "febbraio",
    "marzo",
    "aprile",
    "maggio",
    "giugno",
    "luglio",
    "agosto",
    "settembre",
    "ottobre",
    "novembre",
    "dicembre"
  ]
}, ZQe = {
  narrow: ["D", "L", "M", "M", "G", "V", "S"],
  short: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  abbreviated: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  wide: [
    "domenica",
    "lunedì",
    "martedì",
    "mercoledì",
    "giovedì",
    "venerdì",
    "sabato"
  ]
}, eJe = {
  narrow: {
    am: "m.",
    pm: "p.",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  }
}, tJe = {
  narrow: {
    am: "m.",
    pm: "p.",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  }
}, nJe = (e, t) => {
  const r = Number(e);
  return String(r);
}, Lte = {
  ordinalNumber: nJe,
  era: Ce({
    values: YQe,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: QQe,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: JQe,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: ZQe,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: eJe,
    defaultWidth: "wide",
    formattingValues: tJe,
    defaultFormattingWidth: "wide"
  })
}, rJe = /^(\d+)(º)?/i, aJe = /\d+/i, oJe = {
  narrow: /^(aC|dC)/i,
  abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
  wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
}, iJe = {
  any: [/^a/i, /^(d|e)/i]
}, lJe = {
  narrow: /^[1234]/i,
  abbreviated: /^t[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, sJe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, uJe = {
  narrow: /^[gfmalsond]/i,
  abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
  wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
}, cJe = {
  narrow: [
    /^g/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^g/i,
    /^l/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ge/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^mag/i,
    /^gi/i,
    /^l/i,
    /^ag/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, dJe = {
  narrow: /^[dlmgvs]/i,
  short: /^(do|lu|ma|me|gi|ve|sa)/i,
  abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
  wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
}, fJe = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^g/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^g/i, /^v/i, /^s/i]
}, mJe = {
  narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
  any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
}, hJe = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mezza/i,
    noon: /^mezzo/i,
    morning: /mattina/i,
    afternoon: /pomeriggio/i,
    evening: /sera/i,
    night: /notte/i
  }
}, Hte = {
  ordinalNumber: Fn({
    matchPattern: rJe,
    parsePattern: aJe,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: oJe,
    defaultMatchWidth: "wide",
    parsePatterns: iJe,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: lJe,
    defaultMatchWidth: "wide",
    parsePatterns: sJe,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: uJe,
    defaultMatchWidth: "wide",
    parsePatterns: cJe,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: dJe,
    defaultMatchWidth: "wide",
    parsePatterns: fJe,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: mJe,
    defaultMatchWidth: "any",
    parsePatterns: hJe,
    defaultParseWidth: "any"
  })
}, pJe = {
  code: "it",
  formatDistance: jte,
  formatLong: XQe,
  formatRelative: Ite,
  localize: Lte,
  match: Hte,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, gJe = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd.MM.y"
}, vJe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, bJe = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, yJe = {
  date: Ke({
    formats: gJe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: vJe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: bJe,
    defaultWidth: "full"
  })
}, wJe = {
  code: "it-CH",
  formatDistance: jte,
  formatLong: yJe,
  formatRelative: Ite,
  localize: Lte,
  match: Hte,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, SJe = {
  lessThanXSeconds: {
    one: "1秒未満",
    other: "{{count}}秒未満",
    oneWithSuffix: "約1秒",
    otherWithSuffix: "約{{count}}秒"
  },
  xSeconds: {
    one: "1秒",
    other: "{{count}}秒"
  },
  halfAMinute: "30秒",
  lessThanXMinutes: {
    one: "1分未満",
    other: "{{count}}分未満",
    oneWithSuffix: "約1分",
    otherWithSuffix: "約{{count}}分"
  },
  xMinutes: {
    one: "1分",
    other: "{{count}}分"
  },
  aboutXHours: {
    one: "約1時間",
    other: "約{{count}}時間"
  },
  xHours: {
    one: "1時間",
    other: "{{count}}時間"
  },
  xDays: {
    one: "1日",
    other: "{{count}}日"
  },
  aboutXWeeks: {
    one: "約1週間",
    other: "約{{count}}週間"
  },
  xWeeks: {
    one: "1週間",
    other: "{{count}}週間"
  },
  aboutXMonths: {
    one: "約1か月",
    other: "約{{count}}か月"
  },
  xMonths: {
    one: "1か月",
    other: "{{count}}か月"
  },
  aboutXYears: {
    one: "約1年",
    other: "約{{count}}年"
  },
  xYears: {
    one: "1年",
    other: "{{count}}年"
  },
  overXYears: {
    one: "1年以上",
    other: "{{count}}年以上"
  },
  almostXYears: {
    one: "1年近く",
    other: "{{count}}年近く"
  }
}, CJe = (e, t, r) => {
  r = r || {};
  let a;
  const i = SJe[e];
  return typeof i == "string" ? a = i : t === 1 ? r.addSuffix && i.oneWithSuffix ? a = i.oneWithSuffix : a = i.one : r.addSuffix && i.otherWithSuffix ? a = i.otherWithSuffix.replace("{{count}}", String(t)) : a = i.other.replace("{{count}}", String(t)), r.addSuffix ? r.comparison && r.comparison > 0 ? a + "後" : a + "前" : a;
}, xJe = {
  full: "y年M月d日EEEE",
  long: "y年M月d日",
  medium: "y/MM/dd",
  short: "y/MM/dd"
}, EJe = {
  full: "H時mm分ss秒 zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, PJe = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, kJe = {
  date: Ke({
    formats: xJe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: EJe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: PJe,
    defaultWidth: "full"
  })
}, MJe = {
  lastWeek: "先週のeeeeのp",
  yesterday: "昨日のp",
  today: "今日のp",
  tomorrow: "明日のp",
  nextWeek: "翌週のeeeeのp",
  other: "P"
}, OJe = (e, t, r, a) => MJe[e], TJe = {
  narrow: ["BC", "AC"],
  abbreviated: ["紀元前", "西暦"],
  wide: ["紀元前", "西暦"]
}, RJe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["第1四半期", "第2四半期", "第3四半期", "第4四半期"]
}, AJe = {
  narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
  abbreviated: [
    "1月",
    "2月",
    "3月",
    "4月",
    "5月",
    "6月",
    "7月",
    "8月",
    "9月",
    "10月",
    "11月",
    "12月"
  ],
  wide: [
    "1月",
    "2月",
    "3月",
    "4月",
    "5月",
    "6月",
    "7月",
    "8月",
    "9月",
    "10月",
    "11月",
    "12月"
  ]
}, NJe = {
  narrow: ["日", "月", "火", "水", "木", "金", "土"],
  short: ["日", "月", "火", "水", "木", "金", "土"],
  abbreviated: ["日", "月", "火", "水", "木", "金", "土"],
  wide: ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"]
}, DJe = {
  narrow: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  },
  abbreviated: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  },
  wide: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  }
}, $Je = {
  narrow: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  },
  abbreviated: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  },
  wide: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  }
}, zJe = (e, t) => {
  const r = Number(e);
  switch (String(t?.unit)) {
    case "year":
      return `${r}年`;
    case "quarter":
      return `第${r}四半期`;
    case "month":
      return `${r}月`;
    case "week":
      return `第${r}週`;
    case "date":
      return `${r}日`;
    case "hour":
      return `${r}時`;
    case "minute":
      return `${r}分`;
    case "second":
      return `${r}秒`;
    default:
      return `${r}`;
  }
}, jJe = {
  ordinalNumber: zJe,
  era: Ce({
    values: TJe,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: RJe,
    defaultWidth: "wide",
    argumentCallback: (e) => Number(e) - 1
  }),
  month: Ce({
    values: AJe,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: NJe,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: DJe,
    defaultWidth: "wide",
    formattingValues: $Je,
    defaultFormattingWidth: "wide"
  })
}, IJe = /^第?\d+(年|四半期|月|週|日|時|分|秒)?/i, LJe = /\d+/i, HJe = {
  narrow: /^(B\.?C\.?|A\.?D\.?)/i,
  abbreviated: /^(紀元[前後]|西暦)/i,
  wide: /^(紀元[前後]|西暦)/i
}, FJe = {
  narrow: [/^B/i, /^A/i],
  any: [/^(紀元前)/i, /^(西暦|紀元後)/i]
}, WJe = {
  narrow: /^[1234]/i,
  abbreviated: /^Q[1234]/i,
  wide: /^第[1234一二三四１２３４]四半期/i
}, VJe = {
  any: [/(1|一|１)/i, /(2|二|２)/i, /(3|三|３)/i, /(4|四|４)/i]
}, _Je = {
  narrow: /^([123456789]|1[012])/,
  abbreviated: /^([123456789]|1[012])月/i,
  wide: /^([123456789]|1[012])月/i
}, BJe = {
  any: [
    /^1\D/,
    /^2/,
    /^3/,
    /^4/,
    /^5/,
    /^6/,
    /^7/,
    /^8/,
    /^9/,
    /^10/,
    /^11/,
    /^12/
  ]
}, UJe = {
  narrow: /^[日月火水木金土]/,
  short: /^[日月火水木金土]/,
  abbreviated: /^[日月火水木金土]/,
  wide: /^[日月火水木金土]曜日/
}, XJe = {
  any: [/^日/, /^月/, /^火/, /^水/, /^木/, /^金/, /^土/]
}, GJe = {
  any: /^(AM|PM|午前|午後|正午|深夜|真夜中|夜|朝)/i
}, qJe = {
  any: {
    am: /^(A|午前)/i,
    pm: /^(P|午後)/i,
    midnight: /^深夜|真夜中/i,
    noon: /^正午/i,
    morning: /^朝/i,
    afternoon: /^午後/i,
    evening: /^夜/i,
    night: /^深夜/i
  }
}, KJe = {
  ordinalNumber: Fn({
    matchPattern: IJe,
    parsePattern: LJe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: Ee({
    matchPatterns: HJe,
    defaultMatchWidth: "wide",
    parsePatterns: FJe,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: WJe,
    defaultMatchWidth: "wide",
    parsePatterns: VJe,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: _Je,
    defaultMatchWidth: "wide",
    parsePatterns: BJe,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: UJe,
    defaultMatchWidth: "wide",
    parsePatterns: XJe,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: GJe,
    defaultMatchWidth: "any",
    parsePatterns: qJe,
    defaultParseWidth: "any"
  })
}, YJe = {
  code: "ja",
  formatDistance: CJe,
  formatLong: kJe,
  formatRelative: OJe,
  localize: jJe,
  match: KJe,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, QJe = {
  lessThanXSeconds: {
    one: "1びょうみまん",
    other: "{{count}}びょうみまん",
    oneWithSuffix: "やく1びょう",
    otherWithSuffix: "やく{{count}}びょう"
  },
  xSeconds: {
    one: "1びょう",
    other: "{{count}}びょう"
  },
  halfAMinute: "30びょう",
  lessThanXMinutes: {
    one: "1ぷんみまん",
    other: "{{count}}ふんみまん",
    oneWithSuffix: "やく1ぷん",
    otherWithSuffix: "やく{{count}}ふん"
  },
  xMinutes: {
    one: "1ぷん",
    other: "{{count}}ふん"
  },
  aboutXHours: {
    one: "やく1じかん",
    other: "やく{{count}}じかん"
  },
  xHours: {
    one: "1じかん",
    other: "{{count}}じかん"
  },
  xDays: {
    one: "1にち",
    other: "{{count}}にち"
  },
  aboutXWeeks: {
    one: "やく1しゅうかん",
    other: "やく{{count}}しゅうかん"
  },
  xWeeks: {
    one: "1しゅうかん",
    other: "{{count}}しゅうかん"
  },
  aboutXMonths: {
    one: "やく1かげつ",
    other: "やく{{count}}かげつ"
  },
  xMonths: {
    one: "1かげつ",
    other: "{{count}}かげつ"
  },
  aboutXYears: {
    one: "やく1ねん",
    other: "やく{{count}}ねん"
  },
  xYears: {
    one: "1ねん",
    other: "{{count}}ねん"
  },
  overXYears: {
    one: "1ねんいじょう",
    other: "{{count}}ねんいじょう"
  },
  almostXYears: {
    one: "1ねんちかく",
    other: "{{count}}ねんちかく"
  }
}, JJe = (e, t, r) => {
  r = r || {};
  let a;
  const i = QJe[e];
  return typeof i == "string" ? a = i : t === 1 ? r.addSuffix && i.oneWithSuffix ? a = i.oneWithSuffix : a = i.one : r.addSuffix && i.otherWithSuffix ? a = i.otherWithSuffix.replace("{{count}}", String(t)) : a = i.other.replace("{{count}}", String(t)), r.addSuffix ? r.comparison && r.comparison > 0 ? a + "あと" : a + "まえ" : a;
}, ZJe = {
  full: "yねんMがつdにちEEEE",
  long: "yねんMがつdにち",
  medium: "y/MM/dd",
  short: "y/MM/dd"
}, eZe = {
  full: "Hじmmふんssびょう zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, tZe = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, nZe = {
  date: Ke({
    formats: ZJe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: eZe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: tZe,
    defaultWidth: "full"
  })
}, rZe = {
  lastWeek: "せんしゅうのeeeeのp",
  yesterday: "きのうのp",
  today: "きょうのp",
  tomorrow: "あしたのp",
  nextWeek: "よくしゅうのeeeeのp",
  other: "P"
}, aZe = (e, t, r, a) => rZe[e], oZe = {
  narrow: ["BC", "AC"],
  abbreviated: ["きげんぜん", "せいれき"],
  wide: ["きげんぜん", "せいれき"]
}, iZe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["だい1しはんき", "だい2しはんき", "だい3しはんき", "だい4しはんき"]
}, lZe = {
  narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
  abbreviated: [
    "1がつ",
    "2がつ",
    "3がつ",
    "4がつ",
    "5がつ",
    "6がつ",
    "7がつ",
    "8がつ",
    "9がつ",
    "10がつ",
    "11がつ",
    "12がつ"
  ],
  wide: [
    "1がつ",
    "2がつ",
    "3がつ",
    "4がつ",
    "5がつ",
    "6がつ",
    "7がつ",
    "8がつ",
    "9がつ",
    "10がつ",
    "11がつ",
    "12がつ"
  ]
}, sZe = {
  narrow: ["にち", "げつ", "か", "すい", "もく", "きん", "ど"],
  short: ["にち", "げつ", "か", "すい", "もく", "きん", "ど"],
  abbreviated: ["にち", "げつ", "か", "すい", "もく", "きん", "ど"],
  wide: [
    "にちようび",
    "げつようび",
    "かようび",
    "すいようび",
    "もくようび",
    "きんようび",
    "どようび"
  ]
}, uZe = {
  narrow: {
    am: "ごぜん",
    pm: "ごご",
    midnight: "しんや",
    noon: "しょうご",
    morning: "あさ",
    afternoon: "ごご",
    evening: "よる",
    night: "しんや"
  },
  abbreviated: {
    am: "ごぜん",
    pm: "ごご",
    midnight: "しんや",
    noon: "しょうご",
    morning: "あさ",
    afternoon: "ごご",
    evening: "よる",
    night: "しんや"
  },
  wide: {
    am: "ごぜん",
    pm: "ごご",
    midnight: "しんや",
    noon: "しょうご",
    morning: "あさ",
    afternoon: "ごご",
    evening: "よる",
    night: "しんや"
  }
}, cZe = {
  narrow: {
    am: "ごぜん",
    pm: "ごご",
    midnight: "しんや",
    noon: "しょうご",
    morning: "あさ",
    afternoon: "ごご",
    evening: "よる",
    night: "しんや"
  },
  abbreviated: {
    am: "ごぜん",
    pm: "ごご",
    midnight: "しんや",
    noon: "しょうご",
    morning: "あさ",
    afternoon: "ごご",
    evening: "よる",
    night: "しんや"
  },
  wide: {
    am: "ごぜん",
    pm: "ごご",
    midnight: "しんや",
    noon: "しょうご",
    morning: "あさ",
    afternoon: "ごご",
    evening: "よる",
    night: "しんや"
  }
}, dZe = (e, t) => {
  const r = Number(e);
  switch (String(t?.unit)) {
    case "year":
      return `${r}ねん`;
    case "quarter":
      return `だい${r}しはんき`;
    case "month":
      return `${r}がつ`;
    case "week":
      return `だい${r}しゅう`;
    case "date":
      return `${r}にち`;
    case "hour":
      return `${r}じ`;
    case "minute":
      return `${r}ふん`;
    case "second":
      return `${r}びょう`;
    default:
      return `${r}`;
  }
}, fZe = {
  ordinalNumber: dZe,
  era: Ce({
    values: oZe,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: iZe,
    defaultWidth: "wide",
    argumentCallback: (e) => Number(e) - 1
  }),
  month: Ce({
    values: lZe,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: sZe,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: uZe,
    defaultWidth: "wide",
    formattingValues: cZe,
    defaultFormattingWidth: "wide"
  })
}, mZe = /^だ?い?\d+(ねん|しはんき|がつ|しゅう|にち|じ|ふん|びょう)?/i, hZe = /\d+/i, pZe = {
  narrow: /^(B\.?C\.?|A\.?D\.?)/i,
  abbreviated: /^(きげん[前後]|せいれき)/i,
  wide: /^(きげん[前後]|せいれき)/i
}, gZe = {
  narrow: [/^B/i, /^A/i],
  any: [/^(きげんぜん)/i, /^(せいれき|きげんご)/i]
}, vZe = {
  narrow: /^[1234]/i,
  abbreviated: /^Q[1234]/i,
  wide: /^だい[1234一二三四１２３４]しはんき/i
}, bZe = {
  any: [/(1|一|１)/i, /(2|二|２)/i, /(3|三|３)/i, /(4|四|４)/i]
}, yZe = {
  narrow: /^([123456789]|1[012])/,
  abbreviated: /^([123456789]|1[012])がつ/i,
  wide: /^([123456789]|1[012])がつ/i
}, wZe = {
  any: [
    /^1\D/,
    /^2/,
    /^3/,
    /^4/,
    /^5/,
    /^6/,
    /^7/,
    /^8/,
    /^9/,
    /^10/,
    /^11/,
    /^12/
  ]
}, SZe = {
  narrow: /^(にち|げつ|か|すい|もく|きん|ど)/,
  short: /^(にち|げつ|か|すい|もく|きん|ど)/,
  abbreviated: /^(にち|げつ|か|すい|もく|きん|ど)/,
  wide: /^(にち|げつ|か|すい|もく|きん|ど)ようび/
}, CZe = {
  any: [/^にち/, /^げつ/, /^か/, /^すい/, /^もく/, /^きん/, /^ど/]
}, xZe = {
  any: /^(AM|PM|ごぜん|ごご|しょうご|しんや|まよなか|よる|あさ)/i
}, EZe = {
  any: {
    am: /^(A|ごぜん)/i,
    pm: /^(P|ごご)/i,
    midnight: /^しんや|まよなか/i,
    noon: /^しょうご/i,
    morning: /^あさ/i,
    afternoon: /^ごご/i,
    evening: /^よる/i,
    night: /^しんや/i
  }
}, PZe = {
  ordinalNumber: Fn({
    matchPattern: mZe,
    parsePattern: hZe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: Ee({
    matchPatterns: pZe,
    defaultMatchWidth: "wide",
    parsePatterns: gZe,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: vZe,
    defaultMatchWidth: "wide",
    parsePatterns: bZe,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: yZe,
    defaultMatchWidth: "wide",
    parsePatterns: wZe,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: SZe,
    defaultMatchWidth: "wide",
    parsePatterns: CZe,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: xZe,
    defaultMatchWidth: "any",
    parsePatterns: EZe,
    defaultParseWidth: "any"
  })
}, kZe = {
  code: "ja-Hira",
  formatDistance: JJe,
  formatLong: nZe,
  formatRelative: aZe,
  localize: fZe,
  match: PZe,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, MZe = {
  lessThanXSeconds: {
    past: "{{count}} წამზე ნაკლები ხნის წინ",
    present: "{{count}} წამზე ნაკლები",
    future: "{{count}} წამზე ნაკლებში"
  },
  xSeconds: {
    past: "{{count}} წამის წინ",
    present: "{{count}} წამი",
    future: "{{count}} წამში"
  },
  halfAMinute: {
    past: "ნახევარი წუთის წინ",
    present: "ნახევარი წუთი",
    future: "ნახევარი წუთში"
  },
  lessThanXMinutes: {
    past: "{{count}} წუთზე ნაკლები ხნის წინ",
    present: "{{count}} წუთზე ნაკლები",
    future: "{{count}} წუთზე ნაკლებში"
  },
  xMinutes: {
    past: "{{count}} წუთის წინ",
    present: "{{count}} წუთი",
    future: "{{count}} წუთში"
  },
  aboutXHours: {
    past: "დაახლოებით {{count}} საათის წინ",
    present: "დაახლოებით {{count}} საათი",
    future: "დაახლოებით {{count}} საათში"
  },
  xHours: {
    past: "{{count}} საათის წინ",
    present: "{{count}} საათი",
    future: "{{count}} საათში"
  },
  xDays: {
    past: "{{count}} დღის წინ",
    present: "{{count}} დღე",
    future: "{{count}} დღეში"
  },
  aboutXWeeks: {
    past: "დაახლოებით {{count}} კვირას წინ",
    present: "დაახლოებით {{count}} კვირა",
    future: "დაახლოებით {{count}} კვირაში"
  },
  xWeeks: {
    past: "{{count}} კვირას კვირა",
    present: "{{count}} კვირა",
    future: "{{count}} კვირაში"
  },
  aboutXMonths: {
    past: "დაახლოებით {{count}} თვის წინ",
    present: "დაახლოებით {{count}} თვე",
    future: "დაახლოებით {{count}} თვეში"
  },
  xMonths: {
    past: "{{count}} თვის წინ",
    present: "{{count}} თვე",
    future: "{{count}} თვეში"
  },
  aboutXYears: {
    past: "დაახლოებით {{count}} წლის წინ",
    present: "დაახლოებით {{count}} წელი",
    future: "დაახლოებით {{count}} წელში"
  },
  xYears: {
    past: "{{count}} წლის წინ",
    present: "{{count}} წელი",
    future: "{{count}} წელში"
  },
  overXYears: {
    past: "{{count}} წელზე მეტი ხნის წინ",
    present: "{{count}} წელზე მეტი",
    future: "{{count}} წელზე მეტი ხნის შემდეგ"
  },
  almostXYears: {
    past: "თითქმის {{count}} წლის წინ",
    present: "თითქმის {{count}} წელი",
    future: "თითქმის {{count}} წელში"
  }
}, OZe = (e, t, r) => {
  let a;
  const i = MZe[e];
  return typeof i == "string" ? a = i : r?.addSuffix && r.comparison && r.comparison > 0 ? a = i.future.replace("{{count}}", String(t)) : r?.addSuffix ? a = i.past.replace("{{count}}", String(t)) : a = i.present.replace("{{count}}", String(t)), a;
}, TZe = {
  full: "EEEE, do MMMM, y",
  long: "do, MMMM, y",
  medium: "d, MMM, y",
  short: "dd/MM/yyyy"
}, RZe = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, AZe = {
  full: "{{date}} {{time}}'-ზე'",
  long: "{{date}} {{time}}'-ზე'",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, NZe = {
  date: Ke({
    formats: TZe,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: RZe,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: AZe,
    defaultWidth: "full"
  })
}, DZe = {
  lastWeek: "'წინა' eeee p'-ზე'",
  yesterday: "'გუშინ' p'-ზე'",
  today: "'დღეს' p'-ზე'",
  tomorrow: "'ხვალ' p'-ზე'",
  nextWeek: "'შემდეგი' eeee p'-ზე'",
  other: "P"
}, $Ze = (e, t, r, a) => DZe[e], zZe = {
  narrow: ["ჩ.წ-მდე", "ჩ.წ"],
  abbreviated: ["ჩვ.წ-მდე", "ჩვ.წ"],
  wide: ["ჩვენს წელთაღრიცხვამდე", "ჩვენი წელთაღრიცხვით"]
}, jZe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-ლი კვ", "2-ე კვ", "3-ე კვ", "4-ე კვ"],
  wide: ["1-ლი კვარტალი", "2-ე კვარტალი", "3-ე კვარტალი", "4-ე კვარტალი"]
}, IZe = {
  narrow: [
    "ია",
    "თე",
    "მა",
    "აპ",
    "მს",
    "ვნ",
    "ვლ",
    "აგ",
    "სე",
    "ოქ",
    "ნო",
    "დე"
  ],
  abbreviated: [
    "იან",
    "თებ",
    "მარ",
    "აპრ",
    "მაი",
    "ივნ",
    "ივლ",
    "აგვ",
    "სექ",
    "ოქტ",
    "ნოე",
    "დეკ"
  ],
  wide: [
    "იანვარი",
    "თებერვალი",
    "მარტი",
    "აპრილი",
    "მაისი",
    "ივნისი",
    "ივლისი",
    "აგვისტო",
    "სექტემბერი",
    "ოქტომბერი",
    "ნოემბერი",
    "დეკემბერი"
  ]
}, LZe = {
  narrow: ["კვ", "ორ", "სა", "ოთ", "ხუ", "პა", "შა"],
  short: ["კვი", "ორშ", "სამ", "ოთხ", "ხუთ", "პარ", "შაბ"],
  abbreviated: ["კვი", "ორშ", "სამ", "ოთხ", "ხუთ", "პარ", "შაბ"],
  wide: [
    "კვირა",
    "ორშაბათი",
    "სამშაბათი",
    "ოთხშაბათი",
    "ხუთშაბათი",
    "პარასკევი",
    "შაბათი"
  ]
}, HZe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "შუაღამე",
    noon: "შუადღე",
    morning: "დილა",
    afternoon: "საღამო",
    evening: "საღამო",
    night: "ღამე"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "შუაღამე",
    noon: "შუადღე",
    morning: "დილა",
    afternoon: "საღამო",
    evening: "საღამო",
    night: "ღამე"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "შუაღამე",
    noon: "შუადღე",
    morning: "დილა",
    afternoon: "საღამო",
    evening: "საღამო",
    night: "ღამე"
  }
}, FZe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "შუაღამით",
    noon: "შუადღისას",
    morning: "დილით",
    afternoon: "ნაშუადღევს",
    evening: "საღამოს",
    night: "ღამით"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "შუაღამით",
    noon: "შუადღისას",
    morning: "დილით",
    afternoon: "ნაშუადღევს",
    evening: "საღამოს",
    night: "ღამით"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "შუაღამით",
    noon: "შუადღისას",
    morning: "დილით",
    afternoon: "ნაშუადღევს",
    evening: "საღამოს",
    night: "ღამით"
  }
}, WZe = (e) => {
  const t = Number(e);
  return t === 1 ? t + "-ლი" : t + "-ე";
}, VZe = {
  ordinalNumber: WZe,
  era: Ce({
    values: zZe,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: jZe,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: IZe,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: LZe,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: HZe,
    defaultWidth: "wide",
    formattingValues: FZe,
    defaultFormattingWidth: "wide"
  })
}, _Ze = /^(\d+)(-ლი|-ე)?/i, BZe = /\d+/i, UZe = {
  narrow: /^(ჩვ?\.წ)/i,
  abbreviated: /^(ჩვ?\.წ)/i,
  wide: /^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე|ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i
}, XZe = {
  any: [
    /^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე)/i,
    /^(ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i
  ]
}, GZe = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]-(ლი|ე)? კვ/i,
  wide: /^[1234]-(ლი|ე)? კვარტალი/i
}, qZe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, KZe = {
  any: /^(ია|თე|მა|აპ|მს|ვნ|ვლ|აგ|სე|ოქ|ნო|დე)/i
}, YZe = {
  any: [
    /^ია/i,
    /^თ/i,
    /^მარ/i,
    /^აპ/i,
    /^მაი/i,
    /^ი?ვნ/i,
    /^ი?ვლ/i,
    /^აგ/i,
    /^ს/i,
    /^ო/i,
    /^ნ/i,
    /^დ/i
  ]
}, QZe = {
  narrow: /^(კვ|ორ|სა|ოთ|ხუ|პა|შა)/i,
  short: /^(კვი|ორშ|სამ|ოთხ|ხუთ|პარ|შაბ)/i,
  wide: /^(კვირა|ორშაბათი|სამშაბათი|ოთხშაბათი|ხუთშაბათი|პარასკევი|შაბათი)/i
}, JZe = {
  any: [/^კვ/i, /^ორ/i, /^სა/i, /^ოთ/i, /^ხუ/i, /^პა/i, /^შა/i]
}, ZZe = {
  any: /^([ap]\.?\s?m\.?|შუაღ|დილ)/i
}, eet = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^შუაღ/i,
    noon: /^შუადღ/i,
    morning: /^დილ/i,
    afternoon: /ნაშუადღევს/i,
    evening: /საღამო/i,
    night: /ღამ/i
  }
}, tet = {
  ordinalNumber: Fn({
    matchPattern: _Ze,
    parsePattern: BZe,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: UZe,
    defaultMatchWidth: "wide",
    parsePatterns: XZe,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: GZe,
    defaultMatchWidth: "wide",
    parsePatterns: qZe,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: KZe,
    defaultMatchWidth: "any",
    parsePatterns: YZe,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: QZe,
    defaultMatchWidth: "wide",
    parsePatterns: JZe,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: ZZe,
    defaultMatchWidth: "any",
    parsePatterns: eet,
    defaultParseWidth: "any"
  })
}, net = {
  code: "ka",
  formatDistance: OZe,
  formatLong: NZe,
  formatRelative: $Ze,
  localize: VZe,
  match: tet,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, ret = {
  lessThanXSeconds: {
    regular: {
      one: "1 секундтан аз",
      singularNominative: "{{count}} секундтан аз",
      singularGenitive: "{{count}} секундтан аз",
      pluralGenitive: "{{count}} секундтан аз"
    },
    future: {
      one: "бір секундтан кейін",
      singularNominative: "{{count}} секундтан кейін",
      singularGenitive: "{{count}} секундтан кейін",
      pluralGenitive: "{{count}} секундтан кейін"
    }
  },
  xSeconds: {
    regular: {
      singularNominative: "{{count}} секунд",
      singularGenitive: "{{count}} секунд",
      pluralGenitive: "{{count}} секунд"
    },
    past: {
      singularNominative: "{{count}} секунд бұрын",
      singularGenitive: "{{count}} секунд бұрын",
      pluralGenitive: "{{count}} секунд бұрын"
    },
    future: {
      singularNominative: "{{count}} секундтан кейін",
      singularGenitive: "{{count}} секундтан кейін",
      pluralGenitive: "{{count}} секундтан кейін"
    }
  },
  halfAMinute: (e) => e?.addSuffix ? e.comparison && e.comparison > 0 ? "жарты минут ішінде" : "жарты минут бұрын" : "жарты минут",
  lessThanXMinutes: {
    regular: {
      one: "1 минуттан аз",
      singularNominative: "{{count}} минуттан аз",
      singularGenitive: "{{count}} минуттан аз",
      pluralGenitive: "{{count}} минуттан аз"
    },
    future: {
      one: "минуттан кем ",
      singularNominative: "{{count}} минуттан кем",
      singularGenitive: "{{count}} минуттан кем",
      pluralGenitive: "{{count}} минуттан кем"
    }
  },
  xMinutes: {
    regular: {
      singularNominative: "{{count}} минут",
      singularGenitive: "{{count}} минут",
      pluralGenitive: "{{count}} минут"
    },
    past: {
      singularNominative: "{{count}} минут бұрын",
      singularGenitive: "{{count}} минут бұрын",
      pluralGenitive: "{{count}} минут бұрын"
    },
    future: {
      singularNominative: "{{count}} минуттан кейін",
      singularGenitive: "{{count}} минуттан кейін",
      pluralGenitive: "{{count}} минуттан кейін"
    }
  },
  aboutXHours: {
    regular: {
      singularNominative: "шамамен {{count}} сағат",
      singularGenitive: "шамамен {{count}} сағат",
      pluralGenitive: "шамамен {{count}} сағат"
    },
    future: {
      singularNominative: "шамамен {{count}} сағаттан кейін",
      singularGenitive: "шамамен {{count}} сағаттан кейін",
      pluralGenitive: "шамамен {{count}} сағаттан кейін"
    }
  },
  xHours: {
    regular: {
      singularNominative: "{{count}} сағат",
      singularGenitive: "{{count}} сағат",
      pluralGenitive: "{{count}} сағат"
    }
  },
  xDays: {
    regular: {
      singularNominative: "{{count}} күн",
      singularGenitive: "{{count}} күн",
      pluralGenitive: "{{count}} күн"
    },
    future: {
      singularNominative: "{{count}} күннен кейін",
      singularGenitive: "{{count}} күннен кейін",
      pluralGenitive: "{{count}} күннен кейін"
    }
  },
  aboutXWeeks: {
    type: "weeks",
    one: "шамамен 1 апта",
    other: "шамамен {{count}} апта"
  },
  xWeeks: {
    type: "weeks",
    one: "1 апта",
    other: "{{count}} апта"
  },
  aboutXMonths: {
    regular: {
      singularNominative: "шамамен {{count}} ай",
      singularGenitive: "шамамен {{count}} ай",
      pluralGenitive: "шамамен {{count}} ай"
    },
    future: {
      singularNominative: "шамамен {{count}} айдан кейін",
      singularGenitive: "шамамен {{count}} айдан кейін",
      pluralGenitive: "шамамен {{count}} айдан кейін"
    }
  },
  xMonths: {
    regular: {
      singularNominative: "{{count}} ай",
      singularGenitive: "{{count}} ай",
      pluralGenitive: "{{count}} ай"
    }
  },
  aboutXYears: {
    regular: {
      singularNominative: "шамамен {{count}} жыл",
      singularGenitive: "шамамен {{count}} жыл",
      pluralGenitive: "шамамен {{count}} жыл"
    },
    future: {
      singularNominative: "шамамен {{count}} жылдан кейін",
      singularGenitive: "шамамен {{count}} жылдан кейін",
      pluralGenitive: "шамамен {{count}} жылдан кейін"
    }
  },
  xYears: {
    regular: {
      singularNominative: "{{count}} жыл",
      singularGenitive: "{{count}} жыл",
      pluralGenitive: "{{count}} жыл"
    },
    future: {
      singularNominative: "{{count}} жылдан кейін",
      singularGenitive: "{{count}} жылдан кейін",
      pluralGenitive: "{{count}} жылдан кейін"
    }
  },
  overXYears: {
    regular: {
      singularNominative: "{{count}} жылдан астам",
      singularGenitive: "{{count}} жылдан астам",
      pluralGenitive: "{{count}} жылдан астам"
    },
    future: {
      singularNominative: "{{count}} жылдан астам",
      singularGenitive: "{{count}} жылдан астам",
      pluralGenitive: "{{count}} жылдан астам"
    }
  },
  almostXYears: {
    regular: {
      singularNominative: "{{count}} жылға жақын",
      singularGenitive: "{{count}} жылға жақын",
      pluralGenitive: "{{count}} жылға жақын"
    },
    future: {
      singularNominative: "{{count}} жылдан кейін",
      singularGenitive: "{{count}} жылдан кейін",
      pluralGenitive: "{{count}} жылдан кейін"
    }
  }
};
function q5(e, t) {
  if (e.one && t === 1) return e.one;
  const r = t % 10, a = t % 100;
  return r === 1 && a !== 11 ? e.singularNominative.replace("{{count}}", String(t)) : r >= 2 && r <= 4 && (a < 10 || a > 20) ? e.singularGenitive.replace("{{count}}", String(t)) : e.pluralGenitive.replace("{{count}}", String(t));
}
const aet = (e, t, r) => {
  const a = ret[e];
  return typeof a == "function" ? a(r) : a.type === "weeks" ? t === 1 ? a.one : a.other.replace("{{count}}", String(t)) : r?.addSuffix ? r.comparison && r.comparison > 0 ? a.future ? q5(a.future, t) : q5(a.regular, t) + " кейін" : a.past ? q5(a.past, t) : q5(a.regular, t) + " бұрын" : q5(a.regular, t);
}, oet = {
  full: "EEEE, do MMMM y 'ж.'",
  long: "do MMMM y 'ж.'",
  medium: "d MMM y 'ж.'",
  short: "dd.MM.yyyy"
}, iet = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, set = {
  any: "{{date}}, {{time}}"
}, uet = {
  date: Ke({
    formats: oet,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: iet,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: set,
    defaultWidth: "any"
  })
}, EI = [
  "жексенбіде",
  "дүйсенбіде",
  "сейсенбіде",
  "сәрсенбіде",
  "бейсенбіде",
  "жұмада",
  "сенбіде"
];
function cet(e) {
  return "'өткен " + EI[e] + " сағат' p'-де'";
}
function QB(e) {
  return "'" + EI[e] + " сағат' p'-де'";
}
function det(e) {
  return "'келесі " + EI[e] + " сағат' p'-де'";
}
const fet = {
  lastWeek: (e, t, r) => {
    const a = e.getDay();
    return su(e, t, r) ? QB(a) : cet(a);
  },
  yesterday: "'кеше сағат' p'-де'",
  today: "'бүгін сағат' p'-де'",
  tomorrow: "'ертең сағат' p'-де'",
  nextWeek: (e, t, r) => {
    const a = e.getDay();
    return su(e, t, r) ? QB(a) : det(a);
  },
  other: "P"
}, met = (e, t, r, a) => {
  const i = fet[e];
  return typeof i == "function" ? i(t, r, a) : i;
}, het = {
  narrow: ["б.з.д.", "б.з."],
  abbreviated: ["б.з.д.", "б.з."],
  wide: ["біздің заманымызға дейін", "біздің заманымыз"]
}, pet = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-ші тоқ.", "2-ші тоқ.", "3-ші тоқ.", "4-ші тоқ."],
  wide: ["1-ші тоқсан", "2-ші тоқсан", "3-ші тоқсан", "4-ші тоқсан"]
}, get = {
  narrow: ["Қ", "А", "Н", "С", "М", "М", "Ш", "Т", "Қ", "Қ", "Қ", "Ж"],
  abbreviated: [
    "қаң",
    "ақп",
    "нау",
    "сәу",
    "мам",
    "мау",
    "шіл",
    "там",
    "қыр",
    "қаз",
    "қар",
    "жел"
  ],
  wide: [
    "қаңтар",
    "ақпан",
    "наурыз",
    "сәуір",
    "мамыр",
    "маусым",
    "шілде",
    "тамыз",
    "қыркүйек",
    "қазан",
    "қараша",
    "желтоқсан"
  ]
}, vet = {
  narrow: ["Қ", "А", "Н", "С", "М", "М", "Ш", "Т", "Қ", "Қ", "Қ", "Ж"],
  abbreviated: [
    "қаң",
    "ақп",
    "нау",
    "сәу",
    "мам",
    "мау",
    "шіл",
    "там",
    "қыр",
    "қаз",
    "қар",
    "жел"
  ],
  wide: [
    "қаңтар",
    "ақпан",
    "наурыз",
    "сәуір",
    "мамыр",
    "маусым",
    "шілде",
    "тамыз",
    "қыркүйек",
    "қазан",
    "қараша",
    "желтоқсан"
  ]
}, bet = {
  narrow: ["Ж", "Д", "С", "С", "Б", "Ж", "С"],
  short: ["жс", "дс", "сс", "ср", "бс", "жм", "сб"],
  abbreviated: ["жс", "дс", "сс", "ср", "бс", "жм", "сб"],
  wide: [
    "жексенбі",
    "дүйсенбі",
    "сейсенбі",
    "сәрсенбі",
    "бейсенбі",
    "жұма",
    "сенбі"
  ]
}, yet = {
  narrow: {
    am: "ТД",
    pm: "ТК",
    midnight: "түн ортасы",
    noon: "түс",
    morning: "таң",
    afternoon: "күндіз",
    evening: "кеш",
    night: "түн"
  },
  wide: {
    am: "ТД",
    pm: "ТК",
    midnight: "түн ортасы",
    noon: "түс",
    morning: "таң",
    afternoon: "күндіз",
    evening: "кеш",
    night: "түн"
  }
}, wet = {
  narrow: {
    am: "ТД",
    pm: "ТК",
    midnight: "түн ортасында",
    noon: "түс",
    morning: "таң",
    afternoon: "күн",
    evening: "кеш",
    night: "түн"
  },
  wide: {
    am: "ТД",
    pm: "ТК",
    midnight: "түн ортасында",
    noon: "түсте",
    morning: "таңертең",
    afternoon: "күндіз",
    evening: "кеште",
    night: "түнде"
  }
}, kA = {
  0: "-ші",
  1: "-ші",
  2: "-ші",
  3: "-ші",
  4: "-ші",
  5: "-ші",
  6: "-шы",
  7: "-ші",
  8: "-ші",
  9: "-шы",
  10: "-шы",
  20: "-шы",
  30: "-шы",
  40: "-шы",
  50: "-ші",
  60: "-шы",
  70: "-ші",
  80: "-ші",
  90: "-шы",
  100: "-ші"
}, Cet = (e, t) => {
  const r = Number(e), a = r % 10, i = r >= 100 ? 100 : null, c = kA[r] || kA[a] || i && kA[i] || "";
  return r + c;
}, xet = {
  ordinalNumber: Cet,
  era: Ce({
    values: het,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: pet,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: get,
    defaultWidth: "wide",
    formattingValues: vet,
    defaultFormattingWidth: "wide"
  }),
  day: Ce({
    values: bet,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: yet,
    defaultWidth: "any",
    formattingValues: wet,
    defaultFormattingWidth: "wide"
  })
}, Eet = /^(\d+)(-?(ші|шы))?/i, Pet = /\d+/i, ket = {
  narrow: /^((б )?з\.?\s?д\.?)/i,
  abbreviated: /^((б )?з\.?\s?д\.?)/i,
  wide: /^(біздің заманымызға дейін|біздің заманымыз|біздің заманымыздан)/i
}, Met = {
  any: [/^б/i, /^з/i]
}, Oet = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?ші)? тоқ.?/i,
  wide: /^[1234](-?ші)? тоқсан/i
}, Tet = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Ret = {
  narrow: /^(қ|а|н|с|м|мау|ш|т|қыр|қаз|қар|ж)/i,
  abbreviated: /^(қаң|ақп|нау|сәу|мам|мау|шіл|там|қыр|қаз|қар|жел)/i,
  wide: /^(қаңтар|ақпан|наурыз|сәуір|мамыр|маусым|шілде|тамыз|қыркүйек|қазан|қараша|желтоқсан)/i
}, Aet = {
  narrow: [
    /^қ/i,
    /^а/i,
    /^н/i,
    /^с/i,
    /^м/i,
    /^м/i,
    /^ш/i,
    /^т/i,
    /^қ/i,
    /^қ/i,
    /^қ/i,
    /^ж/i
  ],
  abbreviated: [
    /^қаң/i,
    /^ақп/i,
    /^нау/i,
    /^сәу/i,
    /^мам/i,
    /^мау/i,
    /^шіл/i,
    /^там/i,
    /^қыр/i,
    /^қаз/i,
    /^қар/i,
    /^жел/i
  ],
  any: [
    /^қ/i,
    /^а/i,
    /^н/i,
    /^с/i,
    /^м/i,
    /^м/i,
    /^ш/i,
    /^т/i,
    /^қ/i,
    /^қ/i,
    /^қ/i,
    /^ж/i
  ]
}, Net = {
  narrow: /^(ж|д|с|с|б|ж|с)/i,
  short: /^(жс|дс|сс|ср|бс|жм|сб)/i,
  wide: /^(жексенбі|дүйсенбі|сейсенбі|сәрсенбі|бейсенбі|жұма|сенбі)/i
}, Det = {
  narrow: [/^ж/i, /^д/i, /^с/i, /^с/i, /^б/i, /^ж/i, /^с/i],
  short: [/^жс/i, /^дс/i, /^сс/i, /^ср/i, /^бс/i, /^жм/i, /^сб/i],
  any: [
    /^ж[ек]/i,
    /^д[үй]/i,
    /^сe[й]/i,
    /^сә[р]/i,
    /^б[ей]/i,
    /^ж[ұм]/i,
    /^се[н]/i
  ]
}, $et = {
  narrow: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
  wide: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
  any: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i
}, zet = {
  any: {
    am: /^ТД/i,
    pm: /^ТК/i,
    midnight: /^түн орта/i,
    noon: /^күндіз/i,
    morning: /таң/i,
    afternoon: /түс/i,
    evening: /кеш/i,
    night: /түн/i
  }
}, jet = {
  ordinalNumber: Fn({
    matchPattern: Eet,
    parsePattern: Pet,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: ket,
    defaultMatchWidth: "wide",
    parsePatterns: Met,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: Oet,
    defaultMatchWidth: "wide",
    parsePatterns: Tet,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: Ret,
    defaultMatchWidth: "wide",
    parsePatterns: Aet,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: Net,
    defaultMatchWidth: "wide",
    parsePatterns: Det,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: $et,
    defaultMatchWidth: "wide",
    parsePatterns: zet,
    defaultParseWidth: "any"
  })
}, Iet = {
  code: "kk",
  formatDistance: aet,
  formatLong: uet,
  formatRelative: met,
  localize: xet,
  match: jet,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, Let = {
  lessThanXSeconds: "តិចជាង {{count}} វិនាទី",
  xSeconds: "{{count}} វិនាទី",
  halfAMinute: "កន្លះនាទី",
  lessThanXMinutes: "តិចជាង {{count}} នាទី",
  xMinutes: "{{count}} នាទី",
  aboutXHours: "ប្រហែល {{count}} ម៉ោង",
  xHours: "{{count}} ម៉ោង",
  xDays: "{{count}} ថ្ងៃ",
  aboutXWeeks: "ប្រហែល {{count}} សប្តាហ៍",
  xWeeks: "{{count}} សប្តាហ៍",
  aboutXMonths: "ប្រហែល {{count}} ខែ",
  xMonths: "{{count}} ខែ",
  aboutXYears: "ប្រហែល {{count}} ឆ្នាំ",
  xYears: "{{count}} ឆ្នាំ",
  overXYears: "ជាង {{count}} ឆ្នាំ",
  almostXYears: "ជិត {{count}} ឆ្នាំ"
}, Het = (e, t, r) => {
  let i = Let[e];
  return typeof t == "number" && (i = i.replace("{{count}}", t.toString())), r?.addSuffix ? r.comparison && r.comparison > 0 ? "ក្នុងរយៈពេល " + i : i + "មុន" : i;
}, Fet = {
  full: "EEEE do MMMM y",
  long: "do MMMM y",
  medium: "d MMM y",
  short: "dd/MM/yyyy"
}, Wet = {
  full: "h:mm:ss a",
  long: "h:mm:ss a",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Vet = {
  full: "{{date}} 'ម៉ោង' {{time}}",
  long: "{{date}} 'ម៉ោង' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, _et = {
  date: Ke({
    formats: Fet,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: Wet,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: Vet,
    defaultWidth: "full"
  })
}, Bet = {
  lastWeek: "'ថ្ងៃ'eeee'ស​ប្តា​ហ៍​មុនម៉ោង' p",
  yesterday: "'ម្សិលមិញនៅម៉ោង' p",
  today: "'ថ្ងៃនេះម៉ោង' p",
  tomorrow: "'ថ្ងៃស្អែកម៉ោង' p",
  nextWeek: "'ថ្ងៃ'eeee'ស​ប្តា​ហ៍​ក្រោយម៉ោង' p",
  other: "P"
}, Uet = (e, t, r, a) => Bet[e], Xet = {
  narrow: ["ម.គស", "គស"],
  abbreviated: ["មុនគ.ស", "គ.ស"],
  wide: ["មុនគ្រិស្តសករាជ", "នៃគ្រិស្តសករាជ"]
}, Get = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["ត្រីមាសទី 1", "ត្រីមាសទី 2", "ត្រីមាសទី 3", "ត្រីមាសទី 4"]
}, qet = {
  narrow: [
    "ម.ក",
    "ក.ម",
    "មិ",
    "ម.ស",
    "ឧ.ស",
    "ម.ថ",
    "ក.ដ",
    "សី",
    "កញ",
    "តុ",
    "វិ",
    "ធ"
  ],
  abbreviated: [
    "មករា",
    "កុម្ភៈ",
    "មីនា",
    "មេសា",
    "ឧសភា",
    "មិថុនា",
    "កក្កដា",
    "សីហា",
    "កញ្ញា",
    "តុលា",
    "វិច្ឆិកា",
    "ធ្នូ"
  ],
  wide: [
    "មករា",
    "កុម្ភៈ",
    "មីនា",
    "មេសា",
    "ឧសភា",
    "មិថុនា",
    "កក្កដា",
    "សីហា",
    "កញ្ញា",
    "តុលា",
    "វិច្ឆិកា",
    "ធ្នូ"
  ]
}, Ket = {
  narrow: ["អា", "ច", "អ", "ព", "ព្រ", "សុ", "ស"],
  short: ["អា", "ច", "អ", "ព", "ព្រ", "សុ", "ស"],
  abbreviated: ["អា", "ច", "អ", "ព", "ព្រ", "សុ", "ស"],
  wide: ["អាទិត្យ", "ចន្ទ", "អង្គារ", "ពុធ", "ព្រហស្បតិ៍", "សុក្រ", "សៅរ៍"]
}, Yet = {
  narrow: {
    am: "ព្រឹក",
    pm: "ល្ងាច",
    midnight: "​ពេលកណ្ដាលអធ្រាត្រ",
    noon: "ពេលថ្ងៃត្រង់",
    morning: "ពេលព្រឹក",
    afternoon: "ពេលរសៀល",
    evening: "ពេលល្ងាច",
    night: "ពេលយប់"
  },
  abbreviated: {
    am: "ព្រឹក",
    pm: "ល្ងាច",
    midnight: "​ពេលកណ្ដាលអធ្រាត្រ",
    noon: "ពេលថ្ងៃត្រង់",
    morning: "ពេលព្រឹក",
    afternoon: "ពេលរសៀល",
    evening: "ពេលល្ងាច",
    night: "ពេលយប់"
  },
  wide: {
    am: "ព្រឹក",
    pm: "ល្ងាច",
    midnight: "​ពេលកណ្ដាលអធ្រាត្រ",
    noon: "ពេលថ្ងៃត្រង់",
    morning: "ពេលព្រឹក",
    afternoon: "ពេលរសៀល",
    evening: "ពេលល្ងាច",
    night: "ពេលយប់"
  }
}, Qet = {
  narrow: {
    am: "ព្រឹក",
    pm: "ល្ងាច",
    midnight: "​ពេលកណ្ដាលអធ្រាត្រ",
    noon: "ពេលថ្ងៃត្រង់",
    morning: "ពេលព្រឹក",
    afternoon: "ពេលរសៀល",
    evening: "ពេលល្ងាច",
    night: "ពេលយប់"
  },
  abbreviated: {
    am: "ព្រឹក",
    pm: "ល្ងាច",
    midnight: "​ពេលកណ្ដាលអធ្រាត្រ",
    noon: "ពេលថ្ងៃត្រង់",
    morning: "ពេលព្រឹក",
    afternoon: "ពេលរសៀល",
    evening: "ពេលល្ងាច",
    night: "ពេលយប់"
  },
  wide: {
    am: "ព្រឹក",
    pm: "ល្ងាច",
    midnight: "​ពេលកណ្ដាលអធ្រាត្រ",
    noon: "ពេលថ្ងៃត្រង់",
    morning: "ពេលព្រឹក",
    afternoon: "ពេលរសៀល",
    evening: "ពេលល្ងាច",
    night: "ពេលយប់"
  }
}, Jet = (e, t) => Number(e).toString(), Zet = {
  ordinalNumber: Jet,
  era: Ce({
    values: Xet,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: Get,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: qet,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: Ket,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: Yet,
    defaultWidth: "wide",
    formattingValues: Qet,
    defaultFormattingWidth: "wide"
  })
}, ett = /^(\d+)(th|st|nd|rd)?/i, ttt = /\d+/i, ntt = {
  narrow: /^(ម\.)?គស/i,
  abbreviated: /^(មុន)?គ\.ស/i,
  wide: /^(មុន|នៃ)គ្រិស្តសករាជ/i
}, rtt = {
  any: [/^(ម|មុន)គ\.?ស/i, /^(នៃ)?គ\.?ស/i]
}, att = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^(ត្រីមាស)(ទី)?\s?[1234]/i
}, ott = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, itt = {
  narrow: /^(ម\.ក|ក\.ម|មិ|ម\.ស|ឧ\.ស|ម\.ថ|ក\.ដ|សី|កញ|តុ|វិ|ធ)/i,
  abbreviated: /^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i,
  wide: /^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i
}, ltt = {
  narrow: [
    /^ម\.ក/i,
    /^ក\.ម/i,
    /^មិ/i,
    /^ម\.ស/i,
    /^ឧ\.ស/i,
    /^ម\.ថ/i,
    /^ក\.ដ/i,
    /^សី/i,
    /^កញ/i,
    /^តុ/i,
    /^វិ/i,
    /^ធ/i
  ],
  any: [
    /^មក/i,
    /^កុ/i,
    /^មីន/i,
    /^មេ/i,
    /^ឧស/i,
    /^មិថ/i,
    /^កក/i,
    /^សី/i,
    /^កញ/i,
    /^តុ/i,
    /^វិច/i,
    /^ធ/i
  ]
}, stt = {
  narrow: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
  short: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
  abbreviated: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
  wide: /^(អាទិត្យ|ចន្ទ|អង្គារ|ពុធ|ព្រហស្បតិ៍|សុក្រ|សៅរ៍)/i
}, utt = {
  narrow: [/^អា/i, /^ច/i, /^អ/i, /^ព/i, /^ព្រ/i, /^សុ/i, /^ស/i],
  any: [/^អា/i, /^ច/i, /^អ/i, /^ព/i, /^ព្រ/i, /^សុ/i, /^សៅ/i]
}, ctt = {
  narrow: /^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i,
  any: /^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i
}, dtt = {
  any: {
    am: /^ព្រឹក/i,
    pm: /^ល្ងាច/i,
    midnight: /^ពេលកណ្ដាលអធ្រាត្រ/i,
    noon: /^ពេលថ្ងៃត្រង់/i,
    morning: /ពេលព្រឹក/i,
    afternoon: /ពេលរសៀល/i,
    evening: /ពេលល្ងាច/i,
    night: /ពេលយប់/i
  }
}, ftt = {
  ordinalNumber: Fn({
    matchPattern: ett,
    parsePattern: ttt,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: Ee({
    matchPatterns: ntt,
    defaultMatchWidth: "wide",
    parsePatterns: rtt,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: att,
    defaultMatchWidth: "wide",
    parsePatterns: ott,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: itt,
    defaultMatchWidth: "wide",
    parsePatterns: ltt,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: stt,
    defaultMatchWidth: "wide",
    parsePatterns: utt,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: ctt,
    defaultMatchWidth: "any",
    parsePatterns: dtt,
    defaultParseWidth: "any"
  })
}, mtt = {
  code: "km",
  formatDistance: Het,
  formatLong: _et,
  formatRelative: Uet,
  localize: Zet,
  match: ftt,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, htt = {
  lessThanXSeconds: {
    one: {
      default: "1 ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ",
      future: "1 ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ",
      past: "1 ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ"
    },
    other: {
      default: "{{count}} ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ",
      future: "{{count}} ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ",
      past: "{{count}} ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ"
    }
  },
  xSeconds: {
    one: {
      default: "1 ಸೆಕೆಂಡ್",
      future: "1 ಸೆಕೆಂಡ್‌ನಲ್ಲಿ",
      past: "1 ಸೆಕೆಂಡ್ ಹಿಂದೆ"
    },
    other: {
      default: "{{count}} ಸೆಕೆಂಡುಗಳು",
      future: "{{count}} ಸೆಕೆಂಡ್‌ಗಳಲ್ಲಿ",
      past: "{{count}} ಸೆಕೆಂಡ್ ಹಿಂದೆ"
    }
  },
  halfAMinute: {
    other: {
      default: "ಅರ್ಧ ನಿಮಿಷ",
      future: "ಅರ್ಧ ನಿಮಿಷದಲ್ಲಿ",
      past: "ಅರ್ಧ ನಿಮಿಷದ ಹಿಂದೆ"
    }
  },
  lessThanXMinutes: {
    one: {
      default: "1 ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ",
      future: "1 ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ",
      past: "1 ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ"
    },
    other: {
      default: "{{count}} ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ",
      future: "{{count}} ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ",
      past: "{{count}} ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ"
    }
  },
  xMinutes: {
    one: {
      default: "1 ನಿಮಿಷ",
      future: "1 ನಿಮಿಷದಲ್ಲಿ",
      past: "1 ನಿಮಿಷದ ಹಿಂದೆ"
    },
    other: {
      default: "{{count}} ನಿಮಿಷಗಳು",
      future: "{{count}} ನಿಮಿಷಗಳಲ್ಲಿ",
      past: "{{count}} ನಿಮಿಷಗಳ ಹಿಂದೆ"
    }
  },
  aboutXHours: {
    one: {
      default: "ಸುಮಾರು 1 ಗಂಟೆ",
      future: "ಸುಮಾರು 1 ಗಂಟೆಯಲ್ಲಿ",
      past: "ಸುಮಾರು 1 ಗಂಟೆ ಹಿಂದೆ"
    },
    other: {
      default: "ಸುಮಾರು {{count}} ಗಂಟೆಗಳು",
      future: "ಸುಮಾರು {{count}} ಗಂಟೆಗಳಲ್ಲಿ",
      past: "ಸುಮಾರು {{count}} ಗಂಟೆಗಳ ಹಿಂದೆ"
    }
  },
  xHours: {
    one: {
      default: "1 ಗಂಟೆ",
      future: "1 ಗಂಟೆಯಲ್ಲಿ",
      past: "1 ಗಂಟೆ ಹಿಂದೆ"
    },
    other: {
      default: "{{count}} ಗಂಟೆಗಳು",
      future: "{{count}} ಗಂಟೆಗಳಲ್ಲಿ",
      past: "{{count}} ಗಂಟೆಗಳ ಹಿಂದೆ"
    }
  },
  xDays: {
    one: {
      default: "1 ದಿನ",
      future: "1 ದಿನದಲ್ಲಿ",
      past: "1 ದಿನದ ಹಿಂದೆ"
    },
    other: {
      default: "{{count}} ದಿನಗಳು",
      future: "{{count}} ದಿನಗಳಲ್ಲಿ",
      past: "{{count}} ದಿನಗಳ ಹಿಂದೆ"
    }
  },
  // TODO
  // aboutXWeeks: {},
  // TODO
  // xWeeks: {},
  aboutXMonths: {
    one: {
      default: "ಸುಮಾರು 1 ತಿಂಗಳು",
      future: "ಸುಮಾರು 1 ತಿಂಗಳಲ್ಲಿ",
      past: "ಸುಮಾರು 1 ತಿಂಗಳ ಹಿಂದೆ"
    },
    other: {
      default: "ಸುಮಾರು {{count}} ತಿಂಗಳು",
      future: "ಸುಮಾರು {{count}} ತಿಂಗಳುಗಳಲ್ಲಿ",
      past: "ಸುಮಾರು {{count}} ತಿಂಗಳುಗಳ ಹಿಂದೆ"
    }
  },
  xMonths: {
    one: {
      default: "1 ತಿಂಗಳು",
      future: "1 ತಿಂಗಳಲ್ಲಿ",
      past: "1 ತಿಂಗಳ ಹಿಂದೆ"
    },
    other: {
      default: "{{count}} ತಿಂಗಳು",
      future: "{{count}} ತಿಂಗಳುಗಳಲ್ಲಿ",
      past: "{{count}} ತಿಂಗಳುಗಳ ಹಿಂದೆ"
    }
  },
  aboutXYears: {
    one: {
      default: "ಸುಮಾರು 1 ವರ್ಷ",
      future: "ಸುಮಾರು 1 ವರ್ಷದಲ್ಲಿ",
      past: "ಸುಮಾರು 1 ವರ್ಷದ ಹಿಂದೆ"
    },
    other: {
      default: "ಸುಮಾರು {{count}} ವರ್ಷಗಳು",
      future: "ಸುಮಾರು {{count}} ವರ್ಷಗಳಲ್ಲಿ",
      past: "ಸುಮಾರು {{count}} ವರ್ಷಗಳ ಹಿಂದೆ"
    }
  },
  xYears: {
    one: {
      default: "1 ವರ್ಷ",
      future: "1 ವರ್ಷದಲ್ಲಿ",
      past: "1 ವರ್ಷದ ಹಿಂದೆ"
    },
    other: {
      default: "{{count}} ವರ್ಷಗಳು",
      future: "{{count}} ವರ್ಷಗಳಲ್ಲಿ",
      past: "{{count}} ವರ್ಷಗಳ ಹಿಂದೆ"
    }
  },
  overXYears: {
    one: {
      default: "1 ವರ್ಷದ ಮೇಲೆ",
      future: "1 ವರ್ಷದ ಮೇಲೆ",
      past: "1 ವರ್ಷದ ಮೇಲೆ"
    },
    other: {
      default: "{{count}} ವರ್ಷಗಳ ಮೇಲೆ",
      future: "{{count}} ವರ್ಷಗಳ ಮೇಲೆ",
      past: "{{count}} ವರ್ಷಗಳ ಮೇಲೆ"
    }
  },
  almostXYears: {
    one: {
      default: "ಬಹುತೇಕ 1 ವರ್ಷದಲ್ಲಿ",
      future: "ಬಹುತೇಕ 1 ವರ್ಷದಲ್ಲಿ",
      past: "ಬಹುತೇಕ 1 ವರ್ಷದಲ್ಲಿ"
    },
    other: {
      default: "ಬಹುತೇಕ {{count}} ವರ್ಷಗಳಲ್ಲಿ",
      future: "ಬಹುತೇಕ {{count}} ವರ್ಷಗಳಲ್ಲಿ",
      past: "ಬಹುತೇಕ {{count}} ವರ್ಷಗಳಲ್ಲಿ"
    }
  }
};
function JB(e, t) {
  return t?.addSuffix ? t.comparison && t.comparison > 0 ? e.future : e.past : e.default;
}
const ptt = (e, t, r) => {
  let a;
  const i = htt[e];
  return i.one && t === 1 ? a = JB(i.one, r) : a = JB(i.other, r), a.replace("{{count}}", String(t));
}, gtt = {
  full: "EEEE, MMMM d, y",
  // CLDR 1816
  long: "MMMM d, y",
  // CLDR 1817
  medium: "MMM d, y",
  // CLDR 1818
  short: "d/M/yy"
  // CLDR 1819
}, vtt = {
  full: "hh:mm:ss a zzzz",
  // CLDR 1820
  long: "hh:mm:ss a z",
  // CLDR 1821
  medium: "hh:mm:ss a",
  // CLDR 1822
  short: "hh:mm a"
  // CLDR 1823
}, btt = {
  full: "{{date}} {{time}}",
  // CLDR 1824
  long: "{{date}} {{time}}",
  // CLDR 1825
  medium: "{{date}} {{time}}",
  // CLDR 1826
  short: "{{date}} {{time}}"
  // CLDR 1827
}, ytt = {
  date: Ke({
    formats: gtt,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: vtt,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: btt,
    defaultWidth: "full"
  })
}, wtt = {
  lastWeek: "'ಕಳೆದ' eeee p 'ಕ್ಕೆ'",
  yesterday: "'ನಿನ್ನೆ' p 'ಕ್ಕೆ'",
  today: "'ಇಂದು' p 'ಕ್ಕೆ'",
  tomorrow: "'ನಾಳೆ' p 'ಕ್ಕೆ'",
  nextWeek: "eeee p 'ಕ್ಕೆ'",
  other: "P"
}, Stt = (e, t, r, a) => wtt[e], Ctt = {
  narrow: ["ಕ್ರಿ.ಪೂ", "ಕ್ರಿ.ಶ"],
  abbreviated: ["ಕ್ರಿ.ಪೂ", "ಕ್ರಿ.ಶ"],
  // CLDR #1618, #1620
  wide: ["ಕ್ರಿಸ್ತ ಪೂರ್ವ", "ಕ್ರಿಸ್ತ ಶಕ"]
  // CLDR #1614, #1616
}, xtt = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["ತ್ರೈ 1", "ತ್ರೈ 2", "ತ್ರೈ 3", "ತ್ರೈ 4"],
  // CLDR #1630 - #1638
  wide: ["1ನೇ ತ್ರೈಮಾಸಿಕ", "2ನೇ ತ್ರೈಮಾಸಿಕ", "3ನೇ ತ್ರೈಮಾಸಿಕ", "4ನೇ ತ್ರೈಮಾಸಿಕ"]
  // CLDR #1622 - #1629
}, Ett = {
  narrow: ["ಜ", "ಫೆ", "ಮಾ", "ಏ", "ಮೇ", "ಜೂ", "ಜು", "ಆ", "ಸೆ", "ಅ", "ನ", "ಡಿ"],
  abbreviated: [
    "ಜನ",
    "ಫೆಬ್ರ",
    "ಮಾರ್ಚ್",
    "ಏಪ್ರಿ",
    "ಮೇ",
    "ಜೂನ್",
    "ಜುಲೈ",
    "ಆಗ",
    "ಸೆಪ್ಟೆಂ",
    "ಅಕ್ಟೋ",
    "ನವೆಂ",
    "ಡಿಸೆಂ"
  ],
  wide: [
    "ಜನವರಿ",
    "ಫೆಬ್ರವರಿ",
    "ಮಾರ್ಚ್",
    "ಏಪ್ರಿಲ್",
    "ಮೇ",
    "ಜೂನ್",
    "ಜುಲೈ",
    "ಆಗಸ್ಟ್",
    "ಸೆಪ್ಟೆಂಬರ್",
    "ಅಕ್ಟೋಬರ್",
    "ನವೆಂಬರ್",
    "ಡಿಸೆಂಬರ್"
  ]
}, Ptt = {
  narrow: ["ಭಾ", "ಸೋ", "ಮಂ", "ಬು", "ಗು", "ಶು", "ಶ"],
  short: ["ಭಾನು", "ಸೋಮ", "ಮಂಗಳ", "ಬುಧ", "ಗುರು", "ಶುಕ್ರ", "ಶನಿ"],
  abbreviated: ["ಭಾನು", "ಸೋಮ", "ಮಂಗಳ", "ಬುಧ", "ಗುರು", "ಶುಕ್ರ", "ಶನಿ"],
  wide: [
    "ಭಾನುವಾರ",
    "ಸೋಮವಾರ",
    "ಮಂಗಳವಾರ",
    "ಬುಧವಾರ",
    "ಗುರುವಾರ",
    "ಶುಕ್ರವಾರ",
    "ಶನಿವಾರ"
  ]
}, ktt = {
  narrow: {
    am: "ಪೂರ್ವಾಹ್ನ",
    pm: "ಅಪರಾಹ್ನ",
    midnight: "ಮಧ್ಯರಾತ್ರಿ",
    noon: "ಮಧ್ಯಾಹ್ನ",
    morning: "ಬೆಳಗ್ಗೆ",
    afternoon: "ಮಧ್ಯಾಹ್ನ",
    evening: "ಸಂಜೆ",
    night: "ರಾತ್ರಿ"
  },
  abbreviated: {
    am: "ಪೂರ್ವಾಹ್ನ",
    pm: "ಅಪರಾಹ್ನ",
    midnight: "ಮಧ್ಯರಾತ್ರಿ",
    noon: "ಮಧ್ಯಾನ್ಹ",
    morning: "ಬೆಳಗ್ಗೆ",
    afternoon: "ಮಧ್ಯಾನ್ಹ",
    evening: "ಸಂಜೆ",
    night: "ರಾತ್ರಿ"
  },
  wide: {
    am: "ಪೂರ್ವಾಹ್ನ",
    pm: "ಅಪರಾಹ್ನ",
    midnight: "ಮಧ್ಯರಾತ್ರಿ",
    noon: "ಮಧ್ಯಾನ್ಹ",
    morning: "ಬೆಳಗ್ಗೆ",
    afternoon: "ಮಧ್ಯಾನ್ಹ",
    evening: "ಸಂಜೆ",
    night: "ರಾತ್ರಿ"
  }
}, Mtt = {
  narrow: {
    am: "ಪೂ",
    pm: "ಅ",
    midnight: "ಮಧ್ಯರಾತ್ರಿ",
    noon: "ಮಧ್ಯಾನ್ಹ",
    morning: "ಬೆಳಗ್ಗೆ",
    afternoon: "ಮಧ್ಯಾನ್ಹ",
    evening: "ಸಂಜೆ",
    night: "ರಾತ್ರಿ"
  },
  abbreviated: {
    am: "ಪೂರ್ವಾಹ್ನ",
    pm: "ಅಪರಾಹ್ನ",
    midnight: "ಮಧ್ಯ ರಾತ್ರಿ",
    noon: "ಮಧ್ಯಾನ್ಹ",
    morning: "ಬೆಳಗ್ಗೆ",
    afternoon: "ಮಧ್ಯಾನ್ಹ",
    evening: "ಸಂಜೆ",
    night: "ರಾತ್ರಿ"
  },
  wide: {
    am: "ಪೂರ್ವಾಹ್ನ",
    pm: "ಅಪರಾಹ್ನ",
    midnight: "ಮಧ್ಯ ರಾತ್ರಿ",
    noon: "ಮಧ್ಯಾನ್ಹ",
    morning: "ಬೆಳಗ್ಗೆ",
    afternoon: "ಮಧ್ಯಾನ್ಹ",
    evening: "ಸಂಜೆ",
    night: "ರಾತ್ರಿ"
  }
}, Ott = (e, t) => Number(e) + "ನೇ", Ttt = {
  ordinalNumber: Ott,
  era: Ce({
    values: Ctt,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: xtt,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: Ett,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: Ptt,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: ktt,
    defaultWidth: "wide",
    formattingValues: Mtt,
    defaultFormattingWidth: "wide"
  })
}, Rtt = /^(\d+)(ನೇ|ನೆ)?/i, Att = /\d+/i, Ntt = {
  narrow: /^(ಕ್ರಿ.ಪೂ|ಕ್ರಿ.ಶ)/i,
  abbreviated: /^(ಕ್ರಿ\.?\s?ಪೂ\.?|ಕ್ರಿ\.?\s?ಶ\.?|ಪ್ರ\.?\s?ಶ\.?)/i,
  wide: /^(ಕ್ರಿಸ್ತ ಪೂರ್ವ|ಕ್ರಿಸ್ತ ಶಕ|ಪ್ರಸಕ್ತ ಶಕ)/i
}, Dtt = {
  any: [/^ಪೂ/i, /^(ಶ|ಪ್ರ)/i]
}, $tt = {
  narrow: /^[1234]/i,
  abbreviated: /^ತ್ರೈ[1234]|ತ್ರೈ [1234]| [1234]ತ್ರೈ/i,
  wide: /^[1234](ನೇ)? ತ್ರೈಮಾಸಿಕ/i
}, ztt = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, jtt = {
  narrow: /^(ಜೂ|ಜು|ಜ|ಫೆ|ಮಾ|ಏ|ಮೇ|ಆ|ಸೆ|ಅ|ನ|ಡಿ)/i,
  abbreviated: /^(ಜನ|ಫೆಬ್ರ|ಮಾರ್ಚ್|ಏಪ್ರಿ|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗ|ಸೆಪ್ಟೆಂ|ಅಕ್ಟೋ|ನವೆಂ|ಡಿಸೆಂ)/i,
  wide: /^(ಜನವರಿ|ಫೆಬ್ರವರಿ|ಮಾರ್ಚ್|ಏಪ್ರಿಲ್|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗಸ್ಟ್|ಸೆಪ್ಟೆಂಬರ್|ಅಕ್ಟೋಬರ್|ನವೆಂಬರ್|ಡಿಸೆಂಬರ್)/i
}, Itt = {
  narrow: [
    /^ಜ$/i,
    /^ಫೆ/i,
    /^ಮಾ/i,
    /^ಏ/i,
    /^ಮೇ/i,
    /^ಜೂ/i,
    /^ಜು$/i,
    /^ಆ/i,
    /^ಸೆ/i,
    /^ಅ/i,
    /^ನ/i,
    /^ಡಿ/i
  ],
  any: [
    /^ಜನ/i,
    /^ಫೆ/i,
    /^ಮಾ/i,
    /^ಏ/i,
    /^ಮೇ/i,
    /^ಜೂನ್/i,
    /^ಜುಲೈ/i,
    /^ಆ/i,
    /^ಸೆ/i,
    /^ಅ/i,
    /^ನ/i,
    /^ಡಿ/i
  ]
}, Ltt = {
  narrow: /^(ಭಾ|ಸೋ|ಮ|ಬು|ಗು|ಶು|ಶ)/i,
  short: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
  abbreviated: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
  wide: /^(ಭಾನುವಾರ|ಸೋಮವಾರ|ಮಂಗಳವಾರ|ಬುಧವಾರ|ಗುರುವಾರ|ಶುಕ್ರವಾರ|ಶನಿವಾರ)/i
}, Htt = {
  narrow: [/^ಭಾ/i, /^ಸೋ/i, /^ಮ/i, /^ಬು/i, /^ಗು/i, /^ಶು/i, /^ಶ/i],
  any: [/^ಭಾ/i, /^ಸೋ/i, /^ಮ/i, /^ಬು/i, /^ಗು/i, /^ಶು/i, /^ಶ/i]
}, Ftt = {
  narrow: /^(ಪೂ|ಅ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i,
  any: /^(ಪೂರ್ವಾಹ್ನ|ಅಪರಾಹ್ನ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i
}, Wtt = {
  any: {
    am: /^ಪೂ/i,
    pm: /^ಅ/i,
    midnight: /ಮಧ್ಯರಾತ್ರಿ/i,
    noon: /ಮಧ್ಯಾನ್ಹ/i,
    morning: /ಬೆಳಗ್ಗೆ/i,
    afternoon: /ಮಧ್ಯಾನ್ಹ/i,
    evening: /ಸಂಜೆ/i,
    night: /ರಾತ್ರಿ/i
  }
}, Vtt = {
  ordinalNumber: Fn({
    matchPattern: Rtt,
    parsePattern: Att,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: Ntt,
    defaultMatchWidth: "wide",
    parsePatterns: Dtt,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: $tt,
    defaultMatchWidth: "wide",
    parsePatterns: ztt,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: jtt,
    defaultMatchWidth: "wide",
    parsePatterns: Itt,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: Ltt,
    defaultMatchWidth: "wide",
    parsePatterns: Htt,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: Ftt,
    defaultMatchWidth: "any",
    parsePatterns: Wtt,
    defaultParseWidth: "any"
  })
}, _tt = {
  code: "kn",
  formatDistance: ptt,
  formatLong: ytt,
  formatRelative: Stt,
  localize: Ttt,
  match: Vtt,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, Btt = {
  lessThanXSeconds: {
    one: "1초 미만",
    other: "{{count}}초 미만"
  },
  xSeconds: {
    one: "1초",
    other: "{{count}}초"
  },
  halfAMinute: "30초",
  lessThanXMinutes: {
    one: "1분 미만",
    other: "{{count}}분 미만"
  },
  xMinutes: {
    one: "1분",
    other: "{{count}}분"
  },
  aboutXHours: {
    one: "약 1시간",
    other: "약 {{count}}시간"
  },
  xHours: {
    one: "1시간",
    other: "{{count}}시간"
  },
  xDays: {
    one: "1일",
    other: "{{count}}일"
  },
  aboutXWeeks: {
    one: "약 1주",
    other: "약 {{count}}주"
  },
  xWeeks: {
    one: "1주",
    other: "{{count}}주"
  },
  aboutXMonths: {
    one: "약 1개월",
    other: "약 {{count}}개월"
  },
  xMonths: {
    one: "1개월",
    other: "{{count}}개월"
  },
  aboutXYears: {
    one: "약 1년",
    other: "약 {{count}}년"
  },
  xYears: {
    one: "1년",
    other: "{{count}}년"
  },
  overXYears: {
    one: "1년 이상",
    other: "{{count}}년 이상"
  },
  almostXYears: {
    one: "거의 1년",
    other: "거의 {{count}}년"
  }
}, Utt = (e, t, r) => {
  let a;
  const i = Btt[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", t.toString()), r?.addSuffix ? r.comparison && r.comparison > 0 ? a + " 후" : a + " 전" : a;
}, Xtt = {
  full: "y년 M월 d일 EEEE",
  long: "y년 M월 d일",
  medium: "y.MM.dd",
  short: "y.MM.dd"
}, Gtt = {
  full: "a H시 mm분 ss초 zzzz",
  long: "a H:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, qtt = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Ktt = {
  date: Ke({
    formats: Xtt,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: Gtt,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: qtt,
    defaultWidth: "full"
  })
}, Ytt = {
  lastWeek: "'지난' eeee p",
  yesterday: "'어제' p",
  today: "'오늘' p",
  tomorrow: "'내일' p",
  nextWeek: "'다음' eeee p",
  other: "P"
}, Qtt = (e, t, r, a) => Ytt[e], Jtt = {
  narrow: ["BC", "AD"],
  abbreviated: ["BC", "AD"],
  wide: ["기원전", "서기"]
}, Ztt = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1분기", "2분기", "3분기", "4분기"]
}, ent = {
  narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
  abbreviated: [
    "1월",
    "2월",
    "3월",
    "4월",
    "5월",
    "6월",
    "7월",
    "8월",
    "9월",
    "10월",
    "11월",
    "12월"
  ],
  wide: [
    "1월",
    "2월",
    "3월",
    "4월",
    "5월",
    "6월",
    "7월",
    "8월",
    "9월",
    "10월",
    "11월",
    "12월"
  ]
}, tnt = {
  narrow: ["일", "월", "화", "수", "목", "금", "토"],
  short: ["일", "월", "화", "수", "목", "금", "토"],
  abbreviated: ["일", "월", "화", "수", "목", "금", "토"],
  wide: ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"]
}, nnt = {
  narrow: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  },
  abbreviated: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  },
  wide: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  }
}, rnt = {
  narrow: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  },
  abbreviated: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  },
  wide: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  }
}, ant = (e, t) => {
  const r = Number(e);
  switch (String(t?.unit)) {
    case "minute":
    case "second":
      return String(r);
    case "date":
      return r + "일";
    default:
      return r + "번째";
  }
}, ont = {
  ordinalNumber: ant,
  era: Ce({
    values: Jtt,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: Ztt,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: ent,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: tnt,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: nnt,
    defaultWidth: "wide",
    formattingValues: rnt,
    defaultFormattingWidth: "wide"
  })
}, int = /^(\d+)(일|번째)?/i, lnt = /\d+/i, snt = {
  narrow: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(기원전|서기)/i
}, unt = {
  any: [/^(bc|기원전)/i, /^(ad|서기)/i]
}, cnt = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]사?분기/i
}, dnt = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, fnt = {
  narrow: /^(1[012]|[123456789])/,
  abbreviated: /^(1[012]|[123456789])월/i,
  wide: /^(1[012]|[123456789])월/i
}, mnt = {
  any: [
    /^1월?$/,
    /^2/,
    /^3/,
    /^4/,
    /^5/,
    /^6/,
    /^7/,
    /^8/,
    /^9/,
    /^10/,
    /^11/,
    /^12/
  ]
}, hnt = {
  narrow: /^[일월화수목금토]/,
  short: /^[일월화수목금토]/,
  abbreviated: /^[일월화수목금토]/,
  wide: /^[일월화수목금토]요일/
}, pnt = {
  any: [/^일/, /^월/, /^화/, /^수/, /^목/, /^금/, /^토/]
}, gnt = {
  any: /^(am|pm|오전|오후|자정|정오|아침|저녁|밤)/i
}, vnt = {
  any: {
    am: /^(am|오전)/i,
    pm: /^(pm|오후)/i,
    midnight: /^자정/i,
    noon: /^정오/i,
    morning: /^아침/i,
    afternoon: /^오후/i,
    evening: /^저녁/i,
    night: /^밤/i
  }
}, bnt = {
  ordinalNumber: Fn({
    matchPattern: int,
    parsePattern: lnt,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: snt,
    defaultMatchWidth: "wide",
    parsePatterns: unt,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: cnt,
    defaultMatchWidth: "wide",
    parsePatterns: dnt,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: fnt,
    defaultMatchWidth: "wide",
    parsePatterns: mnt,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: hnt,
    defaultMatchWidth: "wide",
    parsePatterns: pnt,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: gnt,
    defaultMatchWidth: "any",
    parsePatterns: vnt,
    defaultParseWidth: "any"
  })
}, ynt = {
  code: "ko",
  formatDistance: Utt,
  formatLong: Ktt,
  formatRelative: Qtt,
  localize: ont,
  match: bnt,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, wnt = {
  lessThanXSeconds: {
    standalone: {
      one: "manner wéi eng Sekonn",
      other: "manner wéi {{count}} Sekonnen"
    },
    withPreposition: {
      one: "manner wéi enger Sekonn",
      other: "manner wéi {{count}} Sekonnen"
    }
  },
  xSeconds: {
    standalone: {
      one: "eng Sekonn",
      other: "{{count}} Sekonnen"
    },
    withPreposition: {
      one: "enger Sekonn",
      other: "{{count}} Sekonnen"
    }
  },
  halfAMinute: {
    standalone: "eng hallef Minutt",
    withPreposition: "enger hallwer Minutt"
  },
  lessThanXMinutes: {
    standalone: {
      one: "manner wéi eng Minutt",
      other: "manner wéi {{count}} Minutten"
    },
    withPreposition: {
      one: "manner wéi enger Minutt",
      other: "manner wéi {{count}} Minutten"
    }
  },
  xMinutes: {
    standalone: {
      one: "eng Minutt",
      other: "{{count}} Minutten"
    },
    withPreposition: {
      one: "enger Minutt",
      other: "{{count}} Minutten"
    }
  },
  aboutXHours: {
    standalone: {
      one: "ongeféier eng Stonn",
      other: "ongeféier {{count}} Stonnen"
    },
    withPreposition: {
      one: "ongeféier enger Stonn",
      other: "ongeféier {{count}} Stonnen"
    }
  },
  xHours: {
    standalone: {
      one: "eng Stonn",
      other: "{{count}} Stonnen"
    },
    withPreposition: {
      one: "enger Stonn",
      other: "{{count}} Stonnen"
    }
  },
  xDays: {
    standalone: {
      one: "een Dag",
      other: "{{count}} Deeg"
    },
    withPreposition: {
      one: "engem Dag",
      other: "{{count}} Deeg"
    }
  },
  aboutXWeeks: {
    standalone: {
      one: "ongeféier eng Woch",
      other: "ongeféier {{count}} Wochen"
    },
    withPreposition: {
      one: "ongeféier enger Woche",
      other: "ongeféier {{count}} Wochen"
    }
  },
  xWeeks: {
    standalone: {
      one: "eng Woch",
      other: "{{count}} Wochen"
    },
    withPreposition: {
      one: "enger Woch",
      other: "{{count}} Wochen"
    }
  },
  aboutXMonths: {
    standalone: {
      one: "ongeféier ee Mount",
      other: "ongeféier {{count}} Méint"
    },
    withPreposition: {
      one: "ongeféier engem Mount",
      other: "ongeféier {{count}} Méint"
    }
  },
  xMonths: {
    standalone: {
      one: "ee Mount",
      other: "{{count}} Méint"
    },
    withPreposition: {
      one: "engem Mount",
      other: "{{count}} Méint"
    }
  },
  aboutXYears: {
    standalone: {
      one: "ongeféier ee Joer",
      other: "ongeféier {{count}} Joer"
    },
    withPreposition: {
      one: "ongeféier engem Joer",
      other: "ongeféier {{count}} Joer"
    }
  },
  xYears: {
    standalone: {
      one: "ee Joer",
      other: "{{count}} Joer"
    },
    withPreposition: {
      one: "engem Joer",
      other: "{{count}} Joer"
    }
  },
  overXYears: {
    standalone: {
      one: "méi wéi ee Joer",
      other: "méi wéi {{count}} Joer"
    },
    withPreposition: {
      one: "méi wéi engem Joer",
      other: "méi wéi {{count}} Joer"
    }
  },
  almostXYears: {
    standalone: {
      one: "bal ee Joer",
      other: "bal {{count}} Joer"
    },
    withPreposition: {
      one: "bal engem Joer",
      other: "bal {{count}} Joer"
    }
  }
}, Snt = ["d", "h", "n", "t", "z"], Cnt = ["a,", "e", "i", "o", "u"], xnt = [0, 1, 2, 3, 8, 9], Ent = [40, 50, 60, 70];
function ZB(e) {
  const t = e.charAt(0).toLowerCase();
  if (Cnt.indexOf(t) != -1 || Snt.indexOf(t) != -1)
    return !0;
  const r = e.split(" ")[0], a = parseInt(r);
  return !isNaN(a) && xnt.indexOf(a % 10) != -1 && Ent.indexOf(
    parseInt(r.substring(0, 2))
  ) == -1;
}
const Pnt = (e, t, r) => {
  let a;
  const i = wnt[e], c = r?.addSuffix ? i.withPreposition : i.standalone;
  return typeof c == "string" ? a = c : t === 1 ? a = c.one : a = c.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? "a" + (ZB(a) ? "n" : "") + " " + a : "viru" + (ZB(a) ? "n" : "") + " " + a : a;
}, knt = {
  full: "EEEE, do MMMM y",
  // Méindeg, 7. Januar 2018
  long: "do MMMM y",
  // 7. Januar 2018
  medium: "do MMM y",
  // 7. Jan 2018
  short: "dd.MM.yy"
  // 07.01.18
}, Mnt = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Ont = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Tnt = {
  date: Ke({
    formats: knt,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: Mnt,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: Ont,
    defaultWidth: "full"
  })
}, Rnt = {
  lastWeek: (e) => {
    const t = e.getDay();
    let r = "'läschte";
    return (t === 2 || t === 4) && (r += "n"), r += "' eeee 'um' p", r;
  },
  yesterday: "'gëschter um' p",
  today: "'haut um' p",
  tomorrow: "'moien um' p",
  nextWeek: "eeee 'um' p",
  other: "P"
}, Ant = (e, t, r, a) => {
  const i = Rnt[e];
  return typeof i == "function" ? i(t) : i;
}, Nnt = {
  narrow: ["v.Chr.", "n.Chr."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["viru Christus", "no Christus"]
}, Dnt = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
}, $nt = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mäe",
    "Abr",
    "Mee",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dez"
  ],
  wide: [
    "Januar",
    "Februar",
    "Mäerz",
    "Abrëll",
    "Mee",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember"
  ]
}, znt = {
  narrow: ["S", "M", "D", "M", "D", "F", "S"],
  short: ["So", "Mé", "Dë", "Më", "Do", "Fr", "Sa"],
  abbreviated: ["So.", "Mé.", "Dë.", "Më.", "Do.", "Fr.", "Sa."],
  wide: [
    "Sonndeg",
    "Méindeg",
    "Dënschdeg",
    "Mëttwoch",
    "Donneschdeg",
    "Freideg",
    "Samschdeg"
  ]
}, jnt = {
  narrow: {
    am: "mo.",
    pm: "nomë.",
    midnight: "Mëtternuecht",
    noon: "Mëtteg",
    morning: "Moien",
    afternoon: "Nomëtteg",
    evening: "Owend",
    night: "Nuecht"
  },
  abbreviated: {
    am: "moies",
    pm: "nomëttes",
    midnight: "Mëtternuecht",
    noon: "Mëtteg",
    morning: "Moien",
    afternoon: "Nomëtteg",
    evening: "Owend",
    night: "Nuecht"
  },
  wide: {
    am: "moies",
    pm: "nomëttes",
    midnight: "Mëtternuecht",
    noon: "Mëtteg",
    morning: "Moien",
    afternoon: "Nomëtteg",
    evening: "Owend",
    night: "Nuecht"
  }
}, Int = {
  narrow: {
    am: "mo.",
    pm: "nom.",
    midnight: "Mëtternuecht",
    noon: "mëttes",
    morning: "moies",
    afternoon: "nomëttes",
    evening: "owes",
    night: "nuets"
  },
  abbreviated: {
    am: "moies",
    pm: "nomëttes",
    midnight: "Mëtternuecht",
    noon: "mëttes",
    morning: "moies",
    afternoon: "nomëttes",
    evening: "owes",
    night: "nuets"
  },
  wide: {
    am: "moies",
    pm: "nomëttes",
    midnight: "Mëtternuecht",
    noon: "mëttes",
    morning: "moies",
    afternoon: "nomëttes",
    evening: "owes",
    night: "nuets"
  }
}, Lnt = (e, t) => Number(e) + ".", Hnt = {
  ordinalNumber: Lnt,
  era: Ce({
    values: Nnt,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: Dnt,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: $nt,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: znt,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: jnt,
    defaultWidth: "wide",
    formattingValues: Int,
    defaultFormattingWidth: "wide"
  })
}, Fnt = /^(\d+)(\.)?/i, Wnt = /\d+/i, Vnt = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(viru Christus|virun eiser Zäitrechnung|no Christus|eiser Zäitrechnung)/i
}, _nt = {
  any: [/^v/i, /^n/i]
}, Bnt = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i
}, Unt = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Xnt = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mäe|abr|mee|jun|jul|aug|sep|okt|nov|dez)/i,
  wide: /^(januar|februar|mäerz|abrëll|mee|juni|juli|august|september|oktober|november|dezember)/i
}, Gnt = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mä/i,
    /^ab/i,
    /^me/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, qnt = {
  narrow: /^[smdf]/i,
  short: /^(so|mé|dë|më|do|fr|sa)/i,
  abbreviated: /^(son?|méi?|dën?|mët?|don?|fre?|sam?)\.?/i,
  wide: /^(sonndeg|méindeg|dënschdeg|mëttwoch|donneschdeg|freideg|samschdeg)/i
}, Knt = {
  any: [/^so/i, /^mé/i, /^dë/i, /^më/i, /^do/i, /^f/i, /^sa/i]
}, Ynt = {
  narrow: /^(mo\.?|nomë\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
  abbreviated: /^(moi\.?|nomët\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
  wide: /^(moies|nomëttes|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i
}, Qnt = {
  any: {
    am: /^m/i,
    pm: /^n/i,
    midnight: /^Mëtter/i,
    noon: /^mëttes/i,
    morning: /moies/i,
    afternoon: /nomëttes/i,
    // will never be matched. Afternoon is matched by `pm`
    evening: /owes/i,
    night: /nuets/i
    // will never be matched. Night is matched by `pm`
  }
}, Jnt = {
  ordinalNumber: Fn({
    matchPattern: Fnt,
    parsePattern: Wnt,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: Vnt,
    defaultMatchWidth: "wide",
    parsePatterns: _nt,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: Bnt,
    defaultMatchWidth: "wide",
    parsePatterns: Unt,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: Xnt,
    defaultMatchWidth: "wide",
    parsePatterns: Gnt,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: qnt,
    defaultMatchWidth: "wide",
    parsePatterns: Knt,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: Ynt,
    defaultMatchWidth: "wide",
    parsePatterns: Qnt,
    defaultParseWidth: "any"
  })
}, Znt = {
  code: "lb",
  formatDistance: Pnt,
  formatLong: Tnt,
  formatRelative: Ant,
  localize: Hnt,
  match: Jnt,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Fte = {
  xseconds_other: "sekundė_sekundžių_sekundes",
  xminutes_one: "minutė_minutės_minutę",
  xminutes_other: "minutės_minučių_minutes",
  xhours_one: "valanda_valandos_valandą",
  xhours_other: "valandos_valandų_valandas",
  xdays_one: "diena_dienos_dieną",
  xdays_other: "dienos_dienų_dienas",
  xweeks_one: "savaitė_savaitės_savaitę",
  xweeks_other: "savaitės_savaičių_savaites",
  xmonths_one: "mėnuo_mėnesio_mėnesį",
  xmonths_other: "mėnesiai_mėnesių_mėnesius",
  xyears_one: "metai_metų_metus",
  xyears_other: "metai_metų_metus",
  about: "apie",
  over: "daugiau nei",
  almost: "beveik",
  lessthan: "mažiau nei"
}, eU = (e, t, r, a) => t ? a ? "kelių sekundžių" : "kelias sekundes" : "kelios sekundės", tp = (e, t, r, a) => t ? a ? TS(r)[1] : TS(r)[2] : TS(r)[0], Vh = (e, t, r, a) => {
  const i = e + " ";
  return e === 1 ? i + tp(e, t, r, a) : t ? a ? i + TS(r)[1] : i + (tU(e) ? TS(r)[1] : TS(r)[2]) : i + (tU(e) ? TS(r)[1] : TS(r)[0]);
};
function tU(e) {
  return e % 10 === 0 || e > 10 && e < 20;
}
function TS(e) {
  return Fte[e].split("_");
}
const ert = {
  lessThanXSeconds: {
    one: eU,
    other: Vh
  },
  xSeconds: {
    one: eU,
    other: Vh
  },
  halfAMinute: "pusė minutės",
  lessThanXMinutes: {
    one: tp,
    other: Vh
  },
  xMinutes: {
    one: tp,
    other: Vh
  },
  aboutXHours: {
    one: tp,
    other: Vh
  },
  xHours: {
    one: tp,
    other: Vh
  },
  xDays: {
    one: tp,
    other: Vh
  },
  aboutXWeeks: {
    one: tp,
    other: Vh
  },
  xWeeks: {
    one: tp,
    other: Vh
  },
  aboutXMonths: {
    one: tp,
    other: Vh
  },
  xMonths: {
    one: tp,
    other: Vh
  },
  aboutXYears: {
    one: tp,
    other: Vh
  },
  xYears: {
    one: tp,
    other: Vh
  },
  overXYears: {
    one: tp,
    other: Vh
  },
  almostXYears: {
    one: tp,
    other: Vh
  }
}, trt = (e, t, r) => {
  const a = e.match(/about|over|almost|lessthan/i), i = a ? e.replace(a[0], "") : e, c = r?.comparison !== void 0 && r.comparison > 0;
  let d;
  const f = ert[e];
  if (typeof f == "string" ? d = f : t === 1 ? d = f.one(
    t,
    r?.addSuffix === !0,
    i.toLowerCase() + "_one",
    c
  ) : d = f.other(
    t,
    r?.addSuffix === !0,
    i.toLowerCase() + "_other",
    c
  ), a) {
    const p = a[0].toLowerCase();
    d = Fte[p] + " " + d;
  }
  return r?.addSuffix ? r.comparison && r.comparison > 0 ? "po " + d : "prieš " + d : d;
}, nrt = {
  full: "y 'm'. MMMM d 'd'., EEEE",
  long: "y 'm'. MMMM d 'd'.",
  medium: "y-MM-dd",
  short: "y-MM-dd"
}, rrt = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, art = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, ort = {
  date: Ke({
    formats: nrt,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: rrt,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: art,
    defaultWidth: "full"
  })
}, irt = {
  lastWeek: "'Praėjusį' eeee p",
  yesterday: "'Vakar' p",
  today: "'Šiandien' p",
  tomorrow: "'Rytoj' p",
  nextWeek: "eeee p",
  other: "P"
}, lrt = (e, t, r, a) => irt[e], srt = {
  narrow: ["pr. Kr.", "po Kr."],
  abbreviated: ["pr. Kr.", "po Kr."],
  wide: ["prieš Kristų", "po Kristaus"]
}, urt = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["I ketv.", "II ketv.", "III ketv.", "IV ketv."],
  wide: ["I ketvirtis", "II ketvirtis", "III ketvirtis", "IV ketvirtis"]
}, crt = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["I k.", "II k.", "III k.", "IV k."],
  wide: ["I ketvirtis", "II ketvirtis", "III ketvirtis", "IV ketvirtis"]
}, drt = {
  narrow: ["S", "V", "K", "B", "G", "B", "L", "R", "R", "S", "L", "G"],
  abbreviated: [
    "saus.",
    "vas.",
    "kov.",
    "bal.",
    "geg.",
    "birž.",
    "liep.",
    "rugp.",
    "rugs.",
    "spal.",
    "lapkr.",
    "gruod."
  ],
  wide: [
    "sausis",
    "vasaris",
    "kovas",
    "balandis",
    "gegužė",
    "birželis",
    "liepa",
    "rugpjūtis",
    "rugsėjis",
    "spalis",
    "lapkritis",
    "gruodis"
  ]
}, frt = {
  narrow: ["S", "V", "K", "B", "G", "B", "L", "R", "R", "S", "L", "G"],
  abbreviated: [
    "saus.",
    "vas.",
    "kov.",
    "bal.",
    "geg.",
    "birž.",
    "liep.",
    "rugp.",
    "rugs.",
    "spal.",
    "lapkr.",
    "gruod."
  ],
  wide: [
    "sausio",
    "vasario",
    "kovo",
    "balandžio",
    "gegužės",
    "birželio",
    "liepos",
    "rugpjūčio",
    "rugsėjo",
    "spalio",
    "lapkričio",
    "gruodžio"
  ]
}, mrt = {
  narrow: ["S", "P", "A", "T", "K", "P", "Š"],
  short: ["Sk", "Pr", "An", "Tr", "Kt", "Pn", "Št"],
  abbreviated: ["sk", "pr", "an", "tr", "kt", "pn", "št"],
  wide: [
    "sekmadienis",
    "pirmadienis",
    "antradienis",
    "trečiadienis",
    "ketvirtadienis",
    "penktadienis",
    "šeštadienis"
  ]
}, hrt = {
  narrow: ["S", "P", "A", "T", "K", "P", "Š"],
  short: ["Sk", "Pr", "An", "Tr", "Kt", "Pn", "Št"],
  abbreviated: ["sk", "pr", "an", "tr", "kt", "pn", "št"],
  wide: [
    "sekmadienį",
    "pirmadienį",
    "antradienį",
    "trečiadienį",
    "ketvirtadienį",
    "penktadienį",
    "šeštadienį"
  ]
}, prt = {
  narrow: {
    am: "pr. p.",
    pm: "pop.",
    midnight: "vidurnaktis",
    noon: "vidurdienis",
    morning: "rytas",
    afternoon: "diena",
    evening: "vakaras",
    night: "naktis"
  },
  abbreviated: {
    am: "priešpiet",
    pm: "popiet",
    midnight: "vidurnaktis",
    noon: "vidurdienis",
    morning: "rytas",
    afternoon: "diena",
    evening: "vakaras",
    night: "naktis"
  },
  wide: {
    am: "priešpiet",
    pm: "popiet",
    midnight: "vidurnaktis",
    noon: "vidurdienis",
    morning: "rytas",
    afternoon: "diena",
    evening: "vakaras",
    night: "naktis"
  }
}, grt = {
  narrow: {
    am: "pr. p.",
    pm: "pop.",
    midnight: "vidurnaktis",
    noon: "perpiet",
    morning: "rytas",
    afternoon: "popietė",
    evening: "vakaras",
    night: "naktis"
  },
  abbreviated: {
    am: "priešpiet",
    pm: "popiet",
    midnight: "vidurnaktis",
    noon: "perpiet",
    morning: "rytas",
    afternoon: "popietė",
    evening: "vakaras",
    night: "naktis"
  },
  wide: {
    am: "priešpiet",
    pm: "popiet",
    midnight: "vidurnaktis",
    noon: "perpiet",
    morning: "rytas",
    afternoon: "popietė",
    evening: "vakaras",
    night: "naktis"
  }
}, vrt = (e, t) => Number(e) + "-oji", brt = {
  ordinalNumber: vrt,
  era: Ce({
    values: srt,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: urt,
    defaultWidth: "wide",
    formattingValues: crt,
    defaultFormattingWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: drt,
    defaultWidth: "wide",
    formattingValues: frt,
    defaultFormattingWidth: "wide"
  }),
  day: Ce({
    values: mrt,
    defaultWidth: "wide",
    formattingValues: hrt,
    defaultFormattingWidth: "wide"
  }),
  dayPeriod: Ce({
    values: prt,
    defaultWidth: "wide",
    formattingValues: grt,
    defaultFormattingWidth: "wide"
  })
}, yrt = /^(\d+)(-oji)?/i, wrt = /\d+/i, Srt = {
  narrow: /^p(r|o)\.?\s?(kr\.?|me)/i,
  abbreviated: /^(pr\.\s?(kr\.|m\.\s?e\.)|po\s?kr\.|mūsų eroje)/i,
  wide: /^(prieš Kristų|prieš mūsų erą|po Kristaus|mūsų eroje)/i
}, Crt = {
  wide: [/prieš/i, /(po|mūsų)/i],
  any: [/^pr/i, /^(po|m)/i]
}, xrt = {
  narrow: /^([1234])/i,
  abbreviated: /^(I|II|III|IV)\s?ketv?\.?/i,
  wide: /^(I|II|III|IV)\s?ketvirtis/i
}, Ert = {
  narrow: [/1/i, /2/i, /3/i, /4/i],
  any: [/I$/i, /II$/i, /III/i, /IV/i]
}, Prt = {
  narrow: /^[svkbglr]/i,
  abbreviated: /^(saus\.|vas\.|kov\.|bal\.|geg\.|birž\.|liep\.|rugp\.|rugs\.|spal\.|lapkr\.|gruod\.)/i,
  wide: /^(sausi(s|o)|vasari(s|o)|kov(a|o)s|balandž?i(s|o)|gegužės?|birželi(s|o)|liep(a|os)|rugpjū(t|č)i(s|o)|rugsėj(is|o)|spali(s|o)|lapkri(t|č)i(s|o)|gruodž?i(s|o))/i
}, krt = {
  narrow: [
    /^s/i,
    /^v/i,
    /^k/i,
    /^b/i,
    /^g/i,
    /^b/i,
    /^l/i,
    /^r/i,
    /^r/i,
    /^s/i,
    /^l/i,
    /^g/i
  ],
  any: [
    /^saus/i,
    /^vas/i,
    /^kov/i,
    /^bal/i,
    /^geg/i,
    /^birž/i,
    /^liep/i,
    /^rugp/i,
    /^rugs/i,
    /^spal/i,
    /^lapkr/i,
    /^gruod/i
  ]
}, Mrt = {
  narrow: /^[spatkš]/i,
  short: /^(sk|pr|an|tr|kt|pn|št)/i,
  abbreviated: /^(sk|pr|an|tr|kt|pn|št)/i,
  wide: /^(sekmadien(is|į)|pirmadien(is|į)|antradien(is|į)|trečiadien(is|į)|ketvirtadien(is|į)|penktadien(is|į)|šeštadien(is|į))/i
}, Ort = {
  narrow: [/^s/i, /^p/i, /^a/i, /^t/i, /^k/i, /^p/i, /^š/i],
  wide: [/^se/i, /^pi/i, /^an/i, /^tr/i, /^ke/i, /^pe/i, /^še/i],
  any: [/^sk/i, /^pr/i, /^an/i, /^tr/i, /^kt/i, /^pn/i, /^št/i]
}, Trt = {
  narrow: /^(pr.\s?p.|pop.|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i,
  any: /^(priešpiet|popiet$|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i
}, Rrt = {
  narrow: {
    am: /^pr/i,
    pm: /^pop./i,
    midnight: /^vidurnaktis/i,
    noon: /^(vidurdienis|perp)/i,
    morning: /rytas/i,
    afternoon: /(die|popietė)/i,
    evening: /vakaras/i,
    night: /naktis/i
  },
  any: {
    am: /^pr/i,
    pm: /^popiet$/i,
    midnight: /^vidurnaktis/i,
    noon: /^(vidurdienis|perp)/i,
    morning: /rytas/i,
    afternoon: /(die|popietė)/i,
    evening: /vakaras/i,
    night: /naktis/i
  }
}, Art = {
  ordinalNumber: Fn({
    matchPattern: yrt,
    parsePattern: wrt,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: Srt,
    defaultMatchWidth: "wide",
    parsePatterns: Crt,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: xrt,
    defaultMatchWidth: "wide",
    parsePatterns: Ert,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: Prt,
    defaultMatchWidth: "wide",
    parsePatterns: krt,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: Mrt,
    defaultMatchWidth: "wide",
    parsePatterns: Ort,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: Trt,
    defaultMatchWidth: "any",
    parsePatterns: Rrt,
    defaultParseWidth: "any"
  })
}, Nrt = {
  code: "lt",
  formatDistance: trt,
  formatLong: ort,
  formatRelative: lrt,
  localize: brt,
  match: Art,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
function _h(e) {
  return (t, r) => {
    if (t === 1)
      return r?.addSuffix ? e.one[0].replace("{{time}}", e.one[2]) : e.one[0].replace("{{time}}", e.one[1]);
    {
      const a = t % 10 === 1 && t % 100 !== 11;
      return r?.addSuffix ? e.other[0].replace("{{time}}", a ? e.other[3] : e.other[4]).replace("{{count}}", String(t)) : e.other[0].replace("{{time}}", a ? e.other[1] : e.other[2]).replace("{{count}}", String(t));
    }
  };
}
const Drt = {
  lessThanXSeconds: _h({
    one: ["mazāk par {{time}}", "sekundi", "sekundi"],
    other: [
      "mazāk nekā {{count}} {{time}}",
      "sekunde",
      "sekundes",
      "sekundes",
      "sekundēm"
    ]
  }),
  xSeconds: _h({
    one: ["1 {{time}}", "sekunde", "sekundes"],
    other: [
      "{{count}} {{time}}",
      "sekunde",
      "sekundes",
      "sekundes",
      "sekundēm"
    ]
  }),
  halfAMinute: (e, t) => t?.addSuffix ? "pusminūtes" : "pusminūte",
  lessThanXMinutes: _h({
    one: ["mazāk par {{time}}", "minūti", "minūti"],
    other: [
      "mazāk nekā {{count}} {{time}}",
      "minūte",
      "minūtes",
      "minūtes",
      "minūtēm"
    ]
  }),
  xMinutes: _h({
    one: ["1 {{time}}", "minūte", "minūtes"],
    other: ["{{count}} {{time}}", "minūte", "minūtes", "minūtes", "minūtēm"]
  }),
  aboutXHours: _h({
    one: ["apmēram 1 {{time}}", "stunda", "stundas"],
    other: [
      "apmēram {{count}} {{time}}",
      "stunda",
      "stundas",
      "stundas",
      "stundām"
    ]
  }),
  xHours: _h({
    one: ["1 {{time}}", "stunda", "stundas"],
    other: ["{{count}} {{time}}", "stunda", "stundas", "stundas", "stundām"]
  }),
  xDays: _h({
    one: ["1 {{time}}", "diena", "dienas"],
    other: ["{{count}} {{time}}", "diena", "dienas", "dienas", "dienām"]
  }),
  aboutXWeeks: _h({
    one: ["apmēram 1 {{time}}", "nedēļa", "nedēļas"],
    other: [
      "apmēram {{count}} {{time}}",
      "nedēļa",
      "nedēļu",
      "nedēļas",
      "nedēļām"
    ]
  }),
  xWeeks: _h({
    one: ["1 {{time}}", "nedēļa", "nedēļas"],
    other: [
      "{{count}} {{time}}",
      // TODO
      "nedēļa",
      "nedēļu",
      "nedēļas",
      "nedēļām"
    ]
  }),
  aboutXMonths: _h({
    one: ["apmēram 1 {{time}}", "mēnesis", "mēneša"],
    other: [
      "apmēram {{count}} {{time}}",
      "mēnesis",
      "mēneši",
      "mēneša",
      "mēnešiem"
    ]
  }),
  xMonths: _h({
    one: ["1 {{time}}", "mēnesis", "mēneša"],
    other: ["{{count}} {{time}}", "mēnesis", "mēneši", "mēneša", "mēnešiem"]
  }),
  aboutXYears: _h({
    one: ["apmēram 1 {{time}}", "gads", "gada"],
    other: ["apmēram {{count}} {{time}}", "gads", "gadi", "gada", "gadiem"]
  }),
  xYears: _h({
    one: ["1 {{time}}", "gads", "gada"],
    other: ["{{count}} {{time}}", "gads", "gadi", "gada", "gadiem"]
  }),
  overXYears: _h({
    one: ["ilgāk par 1 {{time}}", "gadu", "gadu"],
    other: ["vairāk nekā {{count}} {{time}}", "gads", "gadi", "gada", "gadiem"]
  }),
  almostXYears: _h({
    one: ["gandrīz 1 {{time}}", "gads", "gada"],
    other: ["vairāk nekā {{count}} {{time}}", "gads", "gadi", "gada", "gadiem"]
  })
}, $rt = (e, t, r) => {
  const a = Drt[e](t, r);
  return r?.addSuffix ? r.comparison && r.comparison > 0 ? "pēc " + a : "pirms " + a : a;
}, zrt = {
  full: "EEEE, y. 'gada' d. MMMM",
  long: "y. 'gada' d. MMMM",
  medium: "dd.MM.y.",
  short: "dd.MM.y."
}, jrt = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Irt = {
  full: "{{date}} 'plkst.' {{time}}",
  long: "{{date}} 'plkst.' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Lrt = {
  date: Ke({
    formats: zrt,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: jrt,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: Irt,
    defaultWidth: "full"
  })
}, nU = [
  "svētdienā",
  "pirmdienā",
  "otrdienā",
  "trešdienā",
  "ceturtdienā",
  "piektdienā",
  "sestdienā"
], Hrt = {
  lastWeek: (e, t, r) => su(e, t, r) ? "eeee 'plkst.' p" : "'Pagājušā " + nU[e.getDay()] + " plkst.' p",
  yesterday: "'Vakar plkst.' p",
  today: "'Šodien plkst.' p",
  tomorrow: "'Rīt plkst.' p",
  nextWeek: (e, t, r) => su(e, t, r) ? "eeee 'plkst.' p" : "'Nākamajā " + nU[e.getDay()] + " plkst.' p",
  other: "P"
}, Frt = (e, t, r, a) => {
  const i = Hrt[e];
  return typeof i == "function" ? i(t, r, a) : i;
}, Wrt = {
  narrow: ["p.m.ē", "m.ē"],
  abbreviated: ["p. m. ē.", "m. ē."],
  wide: ["pirms mūsu ēras", "mūsu ērā"]
}, Vrt = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. cet.", "2. cet.", "3. cet.", "4. cet."],
  wide: [
    "pirmais ceturksnis",
    "otrais ceturksnis",
    "trešais ceturksnis",
    "ceturtais ceturksnis"
  ]
}, _rt = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. cet.", "2. cet.", "3. cet.", "4. cet."],
  wide: [
    "pirmajā ceturksnī",
    "otrajā ceturksnī",
    "trešajā ceturksnī",
    "ceturtajā ceturksnī"
  ]
}, Brt = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "janv.",
    "febr.",
    "marts",
    "apr.",
    "maijs",
    "jūn.",
    "jūl.",
    "aug.",
    "sept.",
    "okt.",
    "nov.",
    "dec."
  ],
  wide: [
    "janvāris",
    "februāris",
    "marts",
    "aprīlis",
    "maijs",
    "jūnijs",
    "jūlijs",
    "augusts",
    "septembris",
    "oktobris",
    "novembris",
    "decembris"
  ]
}, Urt = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "janv.",
    "febr.",
    "martā",
    "apr.",
    "maijs",
    "jūn.",
    "jūl.",
    "aug.",
    "sept.",
    "okt.",
    "nov.",
    "dec."
  ],
  wide: [
    "janvārī",
    "februārī",
    "martā",
    "aprīlī",
    "maijā",
    "jūnijā",
    "jūlijā",
    "augustā",
    "septembrī",
    "oktobrī",
    "novembrī",
    "decembrī"
  ]
}, Xrt = {
  narrow: ["S", "P", "O", "T", "C", "P", "S"],
  short: ["Sv", "P", "O", "T", "C", "Pk", "S"],
  abbreviated: [
    "svētd.",
    "pirmd.",
    "otrd.",
    "trešd.",
    "ceturtd.",
    "piektd.",
    "sestd."
  ],
  wide: [
    "svētdiena",
    "pirmdiena",
    "otrdiena",
    "trešdiena",
    "ceturtdiena",
    "piektdiena",
    "sestdiena"
  ]
}, Grt = {
  narrow: ["S", "P", "O", "T", "C", "P", "S"],
  short: ["Sv", "P", "O", "T", "C", "Pk", "S"],
  abbreviated: [
    "svētd.",
    "pirmd.",
    "otrd.",
    "trešd.",
    "ceturtd.",
    "piektd.",
    "sestd."
  ],
  wide: [
    "svētdienā",
    "pirmdienā",
    "otrdienā",
    "trešdienā",
    "ceturtdienā",
    "piektdienā",
    "sestdienā"
  ]
}, qrt = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "pusn.",
    noon: "pusd.",
    morning: "rīts",
    afternoon: "diena",
    evening: "vakars",
    night: "nakts"
  },
  abbreviated: {
    am: "am",
    pm: "pm",
    midnight: "pusn.",
    noon: "pusd.",
    morning: "rīts",
    afternoon: "pēcpusd.",
    evening: "vakars",
    night: "nakts"
  },
  wide: {
    am: "am",
    pm: "pm",
    midnight: "pusnakts",
    noon: "pusdienlaiks",
    morning: "rīts",
    afternoon: "pēcpusdiena",
    evening: "vakars",
    night: "nakts"
  }
}, Krt = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "pusn.",
    noon: "pusd.",
    morning: "rītā",
    afternoon: "dienā",
    evening: "vakarā",
    night: "naktī"
  },
  abbreviated: {
    am: "am",
    pm: "pm",
    midnight: "pusn.",
    noon: "pusd.",
    morning: "rītā",
    afternoon: "pēcpusd.",
    evening: "vakarā",
    night: "naktī"
  },
  wide: {
    am: "am",
    pm: "pm",
    midnight: "pusnaktī",
    noon: "pusdienlaikā",
    morning: "rītā",
    afternoon: "pēcpusdienā",
    evening: "vakarā",
    night: "naktī"
  }
}, Yrt = (e, t) => Number(e) + ".", Qrt = {
  ordinalNumber: Yrt,
  era: Ce({
    values: Wrt,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: Vrt,
    defaultWidth: "wide",
    formattingValues: _rt,
    defaultFormattingWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: Brt,
    defaultWidth: "wide",
    formattingValues: Urt,
    defaultFormattingWidth: "wide"
  }),
  day: Ce({
    values: Xrt,
    defaultWidth: "wide",
    formattingValues: Grt,
    defaultFormattingWidth: "wide"
  }),
  dayPeriod: Ce({
    values: qrt,
    defaultWidth: "wide",
    formattingValues: Krt,
    defaultFormattingWidth: "wide"
  })
}, Jrt = /^(\d+)\./i, Zrt = /\d+/i, eat = {
  narrow: /^(p\.m\.ē|m\.ē)/i,
  abbreviated: /^(p\. m\. ē\.|m\. ē\.)/i,
  wide: /^(pirms mūsu ēras|mūsu ērā)/i
}, tat = {
  any: [/^p/i, /^m/i]
}, nat = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](\. cet\.)/i,
  wide: /^(pirma(is|jā)|otra(is|jā)|treša(is|jā)|ceturta(is|jā)) ceturksn(is|ī)/i
}, rat = {
  narrow: [/^1/i, /^2/i, /^3/i, /^4/i],
  abbreviated: [/^1/i, /^2/i, /^3/i, /^4/i],
  wide: [/^p/i, /^o/i, /^t/i, /^c/i]
}, aat = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(janv\.|febr\.|marts|apr\.|maijs|jūn\.|jūl\.|aug\.|sept\.|okt\.|nov\.|dec\.)/i,
  wide: /^(janvār(is|ī)|februār(is|ī)|mart[sā]|aprīl(is|ī)|maij[sā]|jūnij[sā]|jūlij[sā]|august[sā]|septembr(is|ī)|oktobr(is|ī)|novembr(is|ī)|decembr(is|ī))/i
}, oat = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^mai/i,
    /^jūn/i,
    /^jūl/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, iat = {
  narrow: /^[spotc]/i,
  short: /^(sv|pi|o|t|c|pk|s)/i,
  abbreviated: /^(svētd\.|pirmd\.|otrd.\|trešd\.|ceturtd\.|piektd\.|sestd\.)/i,
  wide: /^(svētdien(a|ā)|pirmdien(a|ā)|otrdien(a|ā)|trešdien(a|ā)|ceturtdien(a|ā)|piektdien(a|ā)|sestdien(a|ā))/i
}, lat = {
  narrow: [/^s/i, /^p/i, /^o/i, /^t/i, /^c/i, /^p/i, /^s/i],
  any: [/^sv/i, /^pi/i, /^o/i, /^t/i, /^c/i, /^p/i, /^se/i]
}, sat = {
  narrow: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|dien(a|ā)|vakar(s|ā)|nakt(s|ī))/,
  abbreviated: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|pēcpusd\.|vakar(s|ā)|nakt(s|ī))/,
  wide: /^(am|pm|pusnakt(s|ī)|pusdienlaik(s|ā)|rīt(s|ā)|pēcpusdien(a|ā)|vakar(s|ā)|nakt(s|ī))/i
}, uat = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^pusn/i,
    noon: /^pusd/i,
    morning: /^r/i,
    afternoon: /^(d|pēc)/i,
    evening: /^v/i,
    night: /^n/i
  }
}, cat = {
  ordinalNumber: Fn({
    matchPattern: Jrt,
    parsePattern: Zrt,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: eat,
    defaultMatchWidth: "wide",
    parsePatterns: tat,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: nat,
    defaultMatchWidth: "wide",
    parsePatterns: rat,
    defaultParseWidth: "wide",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: aat,
    defaultMatchWidth: "wide",
    parsePatterns: oat,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: iat,
    defaultMatchWidth: "wide",
    parsePatterns: lat,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: sat,
    defaultMatchWidth: "wide",
    parsePatterns: uat,
    defaultParseWidth: "any"
  })
}, dat = {
  code: "lv",
  formatDistance: $rt,
  formatLong: Lrt,
  formatRelative: Frt,
  localize: Qrt,
  match: cat,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, fat = {
  lessThanXSeconds: {
    one: "помалку од секунда",
    other: "помалку од {{count}} секунди"
  },
  xSeconds: {
    one: "1 секунда",
    other: "{{count}} секунди"
  },
  halfAMinute: "половина минута",
  lessThanXMinutes: {
    one: "помалку од минута",
    other: "помалку од {{count}} минути"
  },
  xMinutes: {
    one: "1 минута",
    other: "{{count}} минути"
  },
  aboutXHours: {
    one: "околу 1 час",
    other: "околу {{count}} часа"
  },
  xHours: {
    one: "1 час",
    other: "{{count}} часа"
  },
  xDays: {
    one: "1 ден",
    other: "{{count}} дена"
  },
  aboutXWeeks: {
    one: "околу 1 недела",
    other: "околу {{count}} месеци"
  },
  xWeeks: {
    one: "1 недела",
    other: "{{count}} недели"
  },
  aboutXMonths: {
    one: "околу 1 месец",
    other: "околу {{count}} недели"
  },
  xMonths: {
    one: "1 месец",
    other: "{{count}} месеци"
  },
  aboutXYears: {
    one: "околу 1 година",
    other: "околу {{count}} години"
  },
  xYears: {
    one: "1 година",
    other: "{{count}} години"
  },
  overXYears: {
    one: "повеќе од 1 година",
    other: "повеќе од {{count}} години"
  },
  almostXYears: {
    one: "безмалку 1 година",
    other: "безмалку {{count}} години"
  }
}, mat = (e, t, r) => {
  let a;
  const i = fat[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? "за " + a : "пред " + a : a;
}, hat = {
  full: "EEEE, dd MMMM yyyy",
  long: "dd MMMM yyyy",
  medium: "dd MMM yyyy",
  short: "dd/MM/yyyy"
}, pat = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "H:mm"
}, gat = {
  any: "{{date}} {{time}}"
}, vat = {
  date: Ke({
    formats: hat,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: pat,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: gat,
    defaultWidth: "any"
  })
}, PI = [
  "недела",
  "понеделник",
  "вторник",
  "среда",
  "четврток",
  "петок",
  "сабота"
];
function bat(e) {
  const t = PI[e];
  switch (e) {
    case 0:
    case 3:
    case 6:
      return "'минатата " + t + " во' p";
    case 1:
    case 2:
    case 4:
    case 5:
      return "'минатиот " + t + " во' p";
  }
}
function rU(e) {
  const t = PI[e];
  switch (e) {
    case 0:
    case 3:
    case 6:
      return "'ова " + t + " вo' p";
    case 1:
    case 2:
    case 4:
    case 5:
      return "'овој " + t + " вo' p";
  }
}
function yat(e) {
  const t = PI[e];
  switch (e) {
    case 0:
    case 3:
    case 6:
      return "'следната " + t + " вo' p";
    case 1:
    case 2:
    case 4:
    case 5:
      return "'следниот " + t + " вo' p";
  }
}
const wat = {
  lastWeek: (e, t, r) => {
    const a = e.getDay();
    return su(e, t, r) ? rU(a) : bat(a);
  },
  yesterday: "'вчера во' p",
  today: "'денес во' p",
  tomorrow: "'утре во' p",
  nextWeek: (e, t, r) => {
    const a = e.getDay();
    return su(e, t, r) ? rU(a) : yat(a);
  },
  other: "P"
}, Sat = (e, t, r, a) => {
  const i = wat[e];
  return typeof i == "function" ? i(t, r, a) : i;
}, Cat = {
  narrow: ["пр.н.е.", "н.е."],
  abbreviated: ["пред н. е.", "н. е."],
  wide: ["пред нашата ера", "нашата ера"]
}, xat = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-ви кв.", "2-ри кв.", "3-ти кв.", "4-ти кв."],
  wide: ["1-ви квартал", "2-ри квартал", "3-ти квартал", "4-ти квартал"]
}, Eat = {
  abbreviated: [
    "јан",
    "фев",
    "мар",
    "апр",
    "мај",
    "јун",
    "јул",
    "авг",
    "септ",
    "окт",
    "ноем",
    "дек"
  ],
  wide: [
    "јануари",
    "февруари",
    "март",
    "април",
    "мај",
    "јуни",
    "јули",
    "август",
    "септември",
    "октомври",
    "ноември",
    "декември"
  ]
}, Pat = {
  narrow: ["Н", "П", "В", "С", "Ч", "П", "С"],
  short: ["не", "по", "вт", "ср", "че", "пе", "са"],
  abbreviated: ["нед", "пон", "вто", "сре", "чет", "пет", "саб"],
  wide: [
    "недела",
    "понеделник",
    "вторник",
    "среда",
    "четврток",
    "петок",
    "сабота"
  ]
}, kat = {
  wide: {
    am: "претпладне",
    pm: "попладне",
    midnight: "полноќ",
    noon: "напладне",
    morning: "наутро",
    afternoon: "попладне",
    evening: "навечер",
    night: "ноќе"
  }
}, Mat = (e, t) => {
  const r = Number(e), a = r % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return r + "-ви";
      case 2:
        return r + "-ри";
      case 7:
      case 8:
        return r + "-ми";
    }
  return r + "-ти";
}, Oat = {
  ordinalNumber: Mat,
  era: Ce({
    values: Cat,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: xat,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: Eat,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: Pat,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: kat,
    defaultWidth: "wide"
  })
}, Tat = /^(\d+)(-?[врмт][и])?/i, Rat = /\d+/i, Aat = {
  narrow: /^((пр)?н\.?\s?е\.?)/i,
  abbreviated: /^((пр)?н\.?\s?е\.?)/i,
  wide: /^(пред нашата ера|нашата ера)/i
}, Nat = {
  any: [/^п/i, /^н/i]
}, Dat = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[врт]?и?)? кв.?/i,
  wide: /^[1234](-?[врт]?и?)? квартал/i
}, $at = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, zat = {
  narrow: /^[нпвсч]/i,
  short: /^(не|по|вт|ср|че|пе|са)/i,
  abbreviated: /^(нед|пон|вто|сре|чет|пет|саб)/i,
  wide: /^(недела|понеделник|вторник|среда|четврток|петок|сабота)/i
}, jat = {
  narrow: [/^н/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^н[ед]/i, /^п[он]/i, /^вт/i, /^ср/i, /^ч[ет]/i, /^п[ет]/i, /^с[аб]/i]
}, Iat = {
  abbreviated: /^(јан|фев|мар|апр|мај|јун|јул|авг|сеп|окт|ноем|дек)/i,
  wide: /^(јануари|февруари|март|април|мај|јуни|јули|август|септември|октомври|ноември|декември)/i
}, Lat = {
  any: [
    /^ја/i,
    /^Ф/i,
    /^мар/i,
    /^ап/i,
    /^мај/i,
    /^јун/i,
    /^јул/i,
    /^ав/i,
    /^се/i,
    /^окт/i,
    /^но/i,
    /^де/i
  ]
}, Hat = {
  any: /^(претп|попл|полноќ|утро|пладне|вечер|ноќ)/i
}, Fat = {
  any: {
    am: /претпладне/i,
    pm: /попладне/i,
    midnight: /полноќ/i,
    noon: /напладне/i,
    morning: /наутро/i,
    afternoon: /попладне/i,
    evening: /навечер/i,
    night: /ноќе/i
  }
}, Wat = {
  ordinalNumber: Fn({
    matchPattern: Tat,
    parsePattern: Rat,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: Aat,
    defaultMatchWidth: "wide",
    parsePatterns: Nat,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: Dat,
    defaultMatchWidth: "wide",
    parsePatterns: $at,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: Iat,
    defaultMatchWidth: "wide",
    parsePatterns: Lat,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: zat,
    defaultMatchWidth: "wide",
    parsePatterns: jat,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: Hat,
    defaultMatchWidth: "any",
    parsePatterns: Fat,
    defaultParseWidth: "any"
  })
}, Vat = {
  code: "mk",
  formatDistance: mat,
  formatLong: vat,
  formatRelative: Sat,
  localize: Oat,
  match: Wat,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, _at = {
  lessThanXSeconds: {
    one: "секунд хүрэхгүй",
    other: "{{count}} секунд хүрэхгүй"
  },
  xSeconds: {
    one: "1 секунд",
    other: "{{count}} секунд"
  },
  halfAMinute: "хагас минут",
  lessThanXMinutes: {
    one: "минут хүрэхгүй",
    other: "{{count}} минут хүрэхгүй"
  },
  xMinutes: {
    one: "1 минут",
    other: "{{count}} минут"
  },
  aboutXHours: {
    one: "ойролцоогоор 1 цаг",
    other: "ойролцоогоор {{count}} цаг"
  },
  xHours: {
    one: "1 цаг",
    other: "{{count}} цаг"
  },
  xDays: {
    one: "1 өдөр",
    other: "{{count}} өдөр"
  },
  aboutXWeeks: {
    one: "ойролцоогоор 1 долоо хоног",
    other: "ойролцоогоор {{count}} долоо хоног"
  },
  xWeeks: {
    one: "1 долоо хоног",
    other: "{{count}} долоо хоног"
  },
  aboutXMonths: {
    one: "ойролцоогоор 1 сар",
    other: "ойролцоогоор {{count}} сар"
  },
  xMonths: {
    one: "1 сар",
    other: "{{count}} сар"
  },
  aboutXYears: {
    one: "ойролцоогоор 1 жил",
    other: "ойролцоогоор {{count}} жил"
  },
  xYears: {
    one: "1 жил",
    other: "{{count}} жил"
  },
  overXYears: {
    one: "1 жил гаран",
    other: "{{count}} жил гаран"
  },
  almostXYears: {
    one: "бараг 1 жил",
    other: "бараг {{count}} жил"
  }
}, Bat = (e, t, r) => {
  let a;
  const i = _at[e];
  if (typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", String(t)), r?.addSuffix) {
    const c = a.split(" "), d = c.pop();
    switch (a = c.join(" "), d) {
      case "секунд":
        a += " секундийн";
        break;
      case "минут":
        a += " минутын";
        break;
      case "цаг":
        a += " цагийн";
        break;
      case "өдөр":
        a += " өдрийн";
        break;
      case "сар":
        a += " сарын";
        break;
      case "жил":
        a += " жилийн";
        break;
      case "хоног":
        a += " хоногийн";
        break;
      case "гаран":
        a += " гараны";
        break;
      case "хүрэхгүй":
        a += " хүрэхгүй хугацааны";
        break;
      default:
        a += d + "-н";
    }
    return r.comparison && r.comparison > 0 ? a + " дараа" : a + " өмнө";
  }
  return a;
}, Uat = {
  full: "y 'оны' MMMM'ын' d, EEEE 'гараг'",
  long: "y 'оны' MMMM'ын' d",
  medium: "y 'оны' MMM'ын' d",
  short: "y.MM.dd"
}, Xat = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, Gat = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, qat = {
  date: Ke({
    formats: Uat,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: Xat,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: Gat,
    defaultWidth: "full"
  })
}, Kat = {
  lastWeek: "'өнгөрсөн' eeee 'гарагийн' p 'цагт'",
  yesterday: "'өчигдөр' p 'цагт'",
  today: "'өнөөдөр' p 'цагт'",
  tomorrow: "'маргааш' p 'цагт'",
  nextWeek: "'ирэх' eeee 'гарагийн' p 'цагт'",
  other: "P"
}, Yat = (e, t, r, a) => Kat[e], Qat = {
  narrow: ["НТӨ", "НТ"],
  abbreviated: ["НТӨ", "НТ"],
  wide: ["нийтийн тооллын өмнөх", "нийтийн тооллын"]
}, Jat = {
  narrow: ["I", "II", "III", "IV"],
  abbreviated: ["I улирал", "II улирал", "III улирал", "IV улирал"],
  wide: ["1-р улирал", "2-р улирал", "3-р улирал", "4-р улирал"]
}, Zat = {
  narrow: [
    "I",
    "II",
    "III",
    "IV",
    "V",
    "VI",
    "VII",
    "VIII",
    "IX",
    "X",
    "XI",
    "XII"
  ],
  abbreviated: [
    "1-р сар",
    "2-р сар",
    "3-р сар",
    "4-р сар",
    "5-р сар",
    "6-р сар",
    "7-р сар",
    "8-р сар",
    "9-р сар",
    "10-р сар",
    "11-р сар",
    "12-р сар"
  ],
  wide: [
    "Нэгдүгээр сар",
    "Хоёрдугаар сар",
    "Гуравдугаар сар",
    "Дөрөвдүгээр сар",
    "Тавдугаар сар",
    "Зургаадугаар сар",
    "Долоодугаар сар",
    "Наймдугаар сар",
    "Есдүгээр сар",
    "Аравдугаар сар",
    "Арваннэгдүгээр сар",
    "Арван хоёрдугаар сар"
  ]
}, eot = {
  narrow: [
    "I",
    "II",
    "III",
    "IV",
    "V",
    "VI",
    "VII",
    "VIII",
    "IX",
    "X",
    "XI",
    "XII"
  ],
  abbreviated: [
    "1-р сар",
    "2-р сар",
    "3-р сар",
    "4-р сар",
    "5-р сар",
    "6-р сар",
    "7-р сар",
    "8-р сар",
    "9-р сар",
    "10-р сар",
    "11-р сар",
    "12-р сар"
  ],
  wide: [
    "нэгдүгээр сар",
    "хоёрдугаар сар",
    "гуравдугаар сар",
    "дөрөвдүгээр сар",
    "тавдугаар сар",
    "зургаадугаар сар",
    "долоодугаар сар",
    "наймдугаар сар",
    "есдүгээр сар",
    "аравдугаар сар",
    "арваннэгдүгээр сар",
    "арван хоёрдугаар сар"
  ]
}, tot = {
  narrow: ["Н", "Д", "М", "Л", "П", "Б", "Б"],
  short: ["Ня", "Да", "Мя", "Лх", "Пү", "Ба", "Бя"],
  abbreviated: ["Ням", "Дав", "Мяг", "Лха", "Пүр", "Баа", "Бям"],
  wide: ["Ням", "Даваа", "Мягмар", "Лхагва", "Пүрэв", "Баасан", "Бямба"]
}, not = {
  narrow: ["Н", "Д", "М", "Л", "П", "Б", "Б"],
  short: ["Ня", "Да", "Мя", "Лх", "Пү", "Ба", "Бя"],
  abbreviated: ["Ням", "Дав", "Мяг", "Лха", "Пүр", "Баа", "Бям"],
  wide: ["ням", "даваа", "мягмар", "лхагва", "пүрэв", "баасан", "бямба"]
}, rot = {
  narrow: {
    am: "ү.ө.",
    pm: "ү.х.",
    midnight: "шөнө дунд",
    noon: "үд дунд",
    morning: "өглөө",
    afternoon: "өдөр",
    evening: "орой",
    night: "шөнө"
  },
  abbreviated: {
    am: "ү.ө.",
    pm: "ү.х.",
    midnight: "шөнө дунд",
    noon: "үд дунд",
    morning: "өглөө",
    afternoon: "өдөр",
    evening: "орой",
    night: "шөнө"
  },
  wide: {
    am: "ү.ө.",
    pm: "ү.х.",
    midnight: "шөнө дунд",
    noon: "үд дунд",
    morning: "өглөө",
    afternoon: "өдөр",
    evening: "орой",
    night: "шөнө"
  }
}, aot = (e, t) => String(e), oot = {
  ordinalNumber: aot,
  era: Ce({
    values: Qat,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: Jat,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: Zat,
    defaultWidth: "wide",
    formattingValues: eot,
    defaultFormattingWidth: "wide"
  }),
  day: Ce({
    values: tot,
    defaultWidth: "wide",
    formattingValues: not,
    defaultFormattingWidth: "wide"
  }),
  dayPeriod: Ce({
    values: rot,
    defaultWidth: "wide"
  })
}, iot = /\d+/i, lot = /\d+/i, sot = {
  narrow: /^(нтө|нт)/i,
  abbreviated: /^(нтө|нт)/i,
  wide: /^(нийтийн тооллын өмнө|нийтийн тооллын)/i
}, uot = {
  any: [/^(нтө|нийтийн тооллын өмнө)/i, /^(нт|нийтийн тооллын)/i]
}, cot = {
  narrow: /^(iv|iii|ii|i)/i,
  abbreviated: /^(iv|iii|ii|i) улирал/i,
  wide: /^[1-4]-р улирал/i
}, dot = {
  any: [/^(i(\s|$)|1)/i, /^(ii(\s|$)|2)/i, /^(iii(\s|$)|3)/i, /^(iv(\s|$)|4)/i]
}, fot = {
  narrow: /^(xii|xi|x|ix|viii|vii|vi|v|iv|iii|ii|i)/i,
  abbreviated: /^(1-р сар|2-р сар|3-р сар|4-р сар|5-р сар|6-р сар|7-р сар|8-р сар|9-р сар|10-р сар|11-р сар|12-р сар)/i,
  wide: /^(нэгдүгээр сар|хоёрдугаар сар|гуравдугаар сар|дөрөвдүгээр сар|тавдугаар сар|зургаадугаар сар|долоодугаар сар|наймдугаар сар|есдүгээр сар|аравдугаар сар|арван нэгдүгээр сар|арван хоёрдугаар сар)/i
}, mot = {
  narrow: [
    /^i$/i,
    /^ii$/i,
    /^iii$/i,
    /^iv$/i,
    /^v$/i,
    /^vi$/i,
    /^vii$/i,
    /^viii$/i,
    /^ix$/i,
    /^x$/i,
    /^xi$/i,
    /^xii$/i
  ],
  any: [
    /^(1|нэгдүгээр)/i,
    /^(2|хоёрдугаар)/i,
    /^(3|гуравдугаар)/i,
    /^(4|дөрөвдүгээр)/i,
    /^(5|тавдугаар)/i,
    /^(6|зургаадугаар)/i,
    /^(7|долоодугаар)/i,
    /^(8|наймдугаар)/i,
    /^(9|есдүгээр)/i,
    /^(10|аравдугаар)/i,
    /^(11|арван нэгдүгээр)/i,
    /^(12|арван хоёрдугаар)/i
  ]
}, hot = {
  narrow: /^[ндмлпбб]/i,
  short: /^(ня|да|мя|лх|пү|ба|бя)/i,
  abbreviated: /^(ням|дав|мяг|лха|пүр|баа|бям)/i,
  wide: /^(ням|даваа|мягмар|лхагва|пүрэв|баасан|бямба)/i
}, pot = {
  narrow: [/^н/i, /^д/i, /^м/i, /^л/i, /^п/i, /^б/i, /^б/i],
  any: [/^ня/i, /^да/i, /^мя/i, /^лх/i, /^пү/i, /^ба/i, /^бя/i]
}, got = {
  narrow: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i,
  any: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i
}, vot = {
  any: {
    am: /^ү\.ө\./i,
    pm: /^ү\.х\./i,
    midnight: /^шөнө дунд/i,
    noon: /^үд дунд/i,
    morning: /өглөө/i,
    afternoon: /өдөр/i,
    evening: /орой/i,
    night: /шөнө/i
  }
}, bot = {
  ordinalNumber: Fn({
    matchPattern: iot,
    parsePattern: lot,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: sot,
    defaultMatchWidth: "wide",
    parsePatterns: uot,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: cot,
    defaultMatchWidth: "wide",
    parsePatterns: dot,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: fot,
    defaultMatchWidth: "wide",
    parsePatterns: mot,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: hot,
    defaultMatchWidth: "wide",
    parsePatterns: pot,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: got,
    defaultMatchWidth: "any",
    parsePatterns: vot,
    defaultParseWidth: "any"
  })
}, yot = {
  code: "mn",
  formatDistance: Bat,
  formatLong: qat,
  formatRelative: Yat,
  localize: oot,
  match: bot,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, wot = {
  lessThanXSeconds: {
    one: "kurang dari 1 saat",
    other: "kurang dari {{count}} saat"
  },
  xSeconds: {
    one: "1 saat",
    other: "{{count}} saat"
  },
  halfAMinute: "setengah minit",
  lessThanXMinutes: {
    one: "kurang dari 1 minit",
    other: "kurang dari {{count}} minit"
  },
  xMinutes: {
    one: "1 minit",
    other: "{{count}} minit"
  },
  aboutXHours: {
    one: "sekitar 1 jam",
    other: "sekitar {{count}} jam"
  },
  xHours: {
    one: "1 jam",
    other: "{{count}} jam"
  },
  xDays: {
    one: "1 hari",
    other: "{{count}} hari"
  },
  aboutXWeeks: {
    one: "sekitar 1 minggu",
    other: "sekitar {{count}} minggu"
  },
  xWeeks: {
    one: "1 minggu",
    other: "{{count}} minggu"
  },
  aboutXMonths: {
    one: "sekitar 1 bulan",
    other: "sekitar {{count}} bulan"
  },
  xMonths: {
    one: "1 bulan",
    other: "{{count}} bulan"
  },
  aboutXYears: {
    one: "sekitar 1 tahun",
    other: "sekitar {{count}} tahun"
  },
  xYears: {
    one: "1 tahun",
    other: "{{count}} tahun"
  },
  overXYears: {
    one: "lebih dari 1 tahun",
    other: "lebih dari {{count}} tahun"
  },
  almostXYears: {
    one: "hampir 1 tahun",
    other: "hampir {{count}} tahun"
  }
}, Sot = (e, t, r) => {
  let a;
  const i = wot[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? "dalam masa " + a : a + " yang lalu" : a;
}, Cot = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "d/M/yyyy"
}, xot = {
  full: "HH.mm.ss",
  long: "HH.mm.ss",
  medium: "HH.mm",
  short: "HH.mm"
}, Eot = {
  full: "{{date}} 'pukul' {{time}}",
  long: "{{date}} 'pukul' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Pot = {
  date: Ke({
    formats: Cot,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: xot,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: Eot,
    defaultWidth: "full"
  })
}, kot = {
  lastWeek: "eeee 'lepas pada jam' p",
  yesterday: "'Semalam pada jam' p",
  today: "'Hari ini pada jam' p",
  tomorrow: "'Esok pada jam' p",
  nextWeek: "eeee 'pada jam' p",
  other: "P"
}, Mot = (e, t, r, a) => kot[e], Oot = {
  narrow: ["SM", "M"],
  abbreviated: ["SM", "M"],
  wide: ["Sebelum Masihi", "Masihi"]
}, Tot = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["S1", "S2", "S3", "S4"],
  wide: ["Suku pertama", "Suku kedua", "Suku ketiga", "Suku keempat"]
}, Rot = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "O", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mac",
    "Apr",
    "Mei",
    "Jun",
    "Jul",
    "Ogo",
    "Sep",
    "Okt",
    "Nov",
    "Dis"
  ],
  wide: [
    "Januari",
    "Februari",
    "Mac",
    "April",
    "Mei",
    "Jun",
    "Julai",
    "Ogos",
    "September",
    "Oktober",
    "November",
    "Disember"
  ]
}, Aot = {
  narrow: ["A", "I", "S", "R", "K", "J", "S"],
  short: ["Ahd", "Isn", "Sel", "Rab", "Kha", "Jum", "Sab"],
  abbreviated: ["Ahd", "Isn", "Sel", "Rab", "Kha", "Jum", "Sab"],
  wide: ["Ahad", "Isnin", "Selasa", "Rabu", "Khamis", "Jumaat", "Sabtu"]
}, Not = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "tgh malam",
    noon: "tgh hari",
    morning: "pagi",
    afternoon: "tengah hari",
    evening: "petang",
    night: "malam"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "tengah hari",
    evening: "petang",
    night: "malam"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "tengah hari",
    evening: "petang",
    night: "malam"
  }
}, Dot = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "tengah hari",
    evening: "petang",
    night: "malam"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "tengah hari",
    evening: "petang",
    night: "malam"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "tengah hari",
    evening: "petang",
    night: "malam"
  }
}, $ot = (e, t) => "ke-" + Number(e), zot = {
  ordinalNumber: $ot,
  era: Ce({
    values: Oot,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: Tot,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: Rot,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: Aot,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: Not,
    defaultWidth: "wide",
    formattingValues: Dot,
    defaultFormattingWidth: "wide"
  })
}, jot = /^ke-(\d+)?/i, Iot = /petama|\d+/i, Lot = {
  narrow: /^(sm|m)/i,
  abbreviated: /^(s\.?\s?m\.?|m\.?)/i,
  wide: /^(sebelum masihi|masihi)/i
}, Hot = {
  any: [/^s/i, /^(m)/i]
}, Fot = {
  narrow: /^[1234]/i,
  abbreviated: /^S[1234]/i,
  wide: /Suku (pertama|kedua|ketiga|keempat)/i
}, Wot = {
  any: [/pertama|1/i, /kedua|2/i, /ketiga|3/i, /keempat|4/i]
}, Vot = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mac|apr|mei|jun|jul|ogo|sep|okt|nov|dis)/i,
  wide: /^(januari|februari|mac|april|mei|jun|julai|ogos|september|oktober|november|disember)/i
}, _ot = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^o/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^ma/i,
    /^ap/i,
    /^me/i,
    /^jun/i,
    /^jul/i,
    /^og/i,
    /^s/i,
    /^ok/i,
    /^n/i,
    /^d/i
  ]
}, Bot = {
  narrow: /^[aisrkj]/i,
  short: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
  abbreviated: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
  wide: /^(ahad|isnin|selasa|rabu|khamis|jumaat|sabtu)/i
}, Uot = {
  narrow: [/^a/i, /^i/i, /^s/i, /^r/i, /^k/i, /^j/i, /^s/i],
  any: [/^a/i, /^i/i, /^se/i, /^r/i, /^k/i, /^j/i, /^sa/i]
}, Xot = {
  narrow: /^(am|pm|tengah malam|tengah hari|pagi|petang|malam)/i,
  any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|pagi|petang|malam)/i
}, Got = {
  any: {
    am: /^a/i,
    pm: /^pm/i,
    midnight: /^tengah m/i,
    noon: /^tengah h/i,
    morning: /pa/i,
    afternoon: /tengah h/i,
    evening: /pe/i,
    night: /m/i
  }
}, qot = {
  ordinalNumber: Fn({
    matchPattern: jot,
    parsePattern: Iot,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: Lot,
    defaultMatchWidth: "wide",
    parsePatterns: Hot,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: Fot,
    defaultMatchWidth: "wide",
    parsePatterns: Wot,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: Vot,
    defaultMatchWidth: "wide",
    parsePatterns: _ot,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: Bot,
    defaultMatchWidth: "wide",
    parsePatterns: Uot,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: Xot,
    defaultMatchWidth: "any",
    parsePatterns: Got,
    defaultParseWidth: "any"
  })
}, Kot = {
  code: "ms",
  formatDistance: Sot,
  formatLong: Pot,
  formatRelative: Mot,
  localize: zot,
  match: qot,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, Yot = {
  lessThanXSeconds: {
    one: "inqas minn sekonda",
    other: "inqas minn {{count}} sekondi"
  },
  xSeconds: {
    one: "sekonda",
    other: "{{count}} sekondi"
  },
  halfAMinute: "nofs minuta",
  lessThanXMinutes: {
    one: "inqas minn minuta",
    other: "inqas minn {{count}} minuti"
  },
  xMinutes: {
    one: "minuta",
    other: "{{count}} minuti"
  },
  aboutXHours: {
    one: "madwar siegħa",
    other: "madwar {{count}} siegħat"
  },
  xHours: {
    one: "siegħa",
    other: "{{count}} siegħat"
  },
  xDays: {
    one: "ġurnata",
    other: "{{count}} ġranet"
  },
  aboutXWeeks: {
    one: "madwar ġimgħa",
    other: "madwar {{count}} ġimgħat"
  },
  xWeeks: {
    one: "ġimgħa",
    other: "{{count}} ġimgħat"
  },
  aboutXMonths: {
    one: "madwar xahar",
    other: "madwar {{count}} xhur"
  },
  xMonths: {
    one: "xahar",
    other: "{{count}} xhur"
  },
  aboutXYears: {
    one: "madwar sena",
    two: "madwar sentejn",
    other: "madwar {{count}} snin"
  },
  xYears: {
    one: "sena",
    two: "sentejn",
    other: "{{count}} snin"
  },
  overXYears: {
    one: "aktar minn sena",
    two: "aktar minn sentejn",
    other: "aktar minn {{count}} snin"
  },
  almostXYears: {
    one: "kważi sena",
    two: "kważi sentejn",
    other: "kważi {{count}} snin"
  }
}, Qot = (e, t, r) => {
  let a;
  const i = Yot[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : t === 2 && i.two ? a = i.two : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? "f'" + a : a + " ilu" : a;
}, Jot = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, Zot = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, eit = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, tit = {
  date: Ke({
    formats: Jot,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: Zot,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: eit,
    defaultWidth: "full"
  })
}, nit = {
  lastWeek: "eeee 'li għadda' 'fil-'p",
  yesterday: "'Il-bieraħ fil-'p",
  today: "'Illum fil-'p",
  tomorrow: "'Għada fil-'p",
  nextWeek: "eeee 'fil-'p",
  other: "P"
}, rit = (e, t, r, a) => nit[e], ait = {
  narrow: ["Q", "W"],
  abbreviated: ["QK", "WK"],
  wide: ["qabel Kristu", "wara Kristu"]
}, oit = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1. kwart", "2. kwart", "3. kwart", "4. kwart"]
}, iit = {
  narrow: ["J", "F", "M", "A", "M", "Ġ", "L", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Fra",
    "Mar",
    "Apr",
    "Mej",
    "Ġun",
    "Lul",
    "Aww",
    "Set",
    "Ott",
    "Nov",
    "Diċ"
  ],
  wide: [
    "Jannar",
    "Frar",
    "Marzu",
    "April",
    "Mejju",
    "Ġunju",
    "Lulju",
    "Awwissu",
    "Settembru",
    "Ottubru",
    "Novembru",
    "Diċembru"
  ]
}, lit = {
  narrow: ["Ħ", "T", "T", "E", "Ħ", "Ġ", "S"],
  short: ["Ħa", "Tn", "Tl", "Er", "Ħa", "Ġi", "Si"],
  abbreviated: ["Ħad", "Tne", "Tli", "Erb", "Ħam", "Ġim", "Sib"],
  wide: [
    "Il-Ħadd",
    "It-Tnejn",
    "It-Tlieta",
    "L-Erbgħa",
    "Il-Ħamis",
    "Il-Ġimgħa",
    "Is-Sibt"
  ]
}, sit = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "nofsillejl",
    noon: "nofsinhar",
    morning: "għodwa",
    afternoon: "wara nofsinhar",
    evening: "filgħaxija",
    night: "lejl"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "nofsillejl",
    noon: "nofsinhar",
    morning: "għodwa",
    afternoon: "wara nofsinhar",
    evening: "filgħaxija",
    night: "lejl"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "nofsillejl",
    noon: "nofsinhar",
    morning: "għodwa",
    afternoon: "wara nofsinhar",
    evening: "filgħaxija",
    night: "lejl"
  }
}, uit = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "f'nofsillejl",
    noon: "f'nofsinhar",
    morning: "filgħodu",
    afternoon: "wara nofsinhar",
    evening: "filgħaxija",
    night: "billejl"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "f'nofsillejl",
    noon: "f'nofsinhar",
    morning: "filgħodu",
    afternoon: "wara nofsinhar",
    evening: "filgħaxija",
    night: "billejl"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "f'nofsillejl",
    noon: "f'nofsinhar",
    morning: "filgħodu",
    afternoon: "wara nofsinhar",
    evening: "filgħaxija",
    night: "billejl"
  }
}, cit = (e, t) => Number(e) + "º", dit = {
  ordinalNumber: cit,
  era: Ce({
    values: ait,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: oit,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: iit,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: lit,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: sit,
    defaultWidth: "wide",
    formattingValues: uit,
    defaultFormattingWidth: "wide"
  })
}, fit = /^(\d+)(º)?/i, mit = /\d+/i, hit = {
  narrow: /^(q|w)/i,
  abbreviated: /^(q\.?\s?k\.?|b\.?\s?c\.?\s?e\.?|w\.?\s?k\.?)/i,
  wide: /^(qabel kristu|before common era|wara kristu|common era)/i
}, pit = {
  any: [/^(q|b)/i, /^(w|c)/i]
}, git = {
  narrow: /^[1234]/i,
  abbreviated: /^k[1234]/i,
  wide: /^[1234](\.)? kwart/i
}, vit = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, bit = {
  narrow: /^[jfmaglsond]/i,
  abbreviated: /^(jan|fra|mar|apr|mej|ġun|lul|aww|set|ott|nov|diċ)/i,
  wide: /^(jannar|frar|marzu|april|mejju|ġunju|lulju|awwissu|settembru|ottubru|novembru|diċembru)/i
}, yit = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^ġ/i,
    /^l/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^mej/i,
    /^ġ/i,
    /^l/i,
    /^aw/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, wit = {
  narrow: /^[ħteġs]/i,
  short: /^(ħa|tn|tl|er|ħa|ġi|si)/i,
  abbreviated: /^(ħad|tne|tli|erb|ħam|ġim|sib)/i,
  wide: /^(il-ħadd|it-tnejn|it-tlieta|l-erbgħa|il-ħamis|il-ġimgħa|is-sibt)/i
}, Sit = {
  narrow: [/^ħ/i, /^t/i, /^t/i, /^e/i, /^ħ/i, /^ġ/i, /^s/i],
  any: [
    /^(il-)?ħad/i,
    /^(it-)?tn/i,
    /^(it-)?tl/i,
    /^(l-)?er/i,
    /^(il-)?ham/i,
    /^(il-)?ġi/i,
    /^(is-)?si/i
  ]
}, Cit = {
  narrow: /^(a|p|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i,
  any: /^([ap]\.?\s?m\.?|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i
}, xit = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^f'nofsillejl/i,
    noon: /^f'nofsinhar/i,
    morning: /għodwa/i,
    afternoon: /wara(\s.*)nofsinhar/i,
    evening: /filgħaxija/i,
    night: /lejl/i
  }
}, Eit = {
  ordinalNumber: Fn({
    matchPattern: fit,
    parsePattern: mit,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: hit,
    defaultMatchWidth: "wide",
    parsePatterns: pit,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: git,
    defaultMatchWidth: "wide",
    parsePatterns: vit,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: bit,
    defaultMatchWidth: "wide",
    parsePatterns: yit,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: wit,
    defaultMatchWidth: "wide",
    parsePatterns: Sit,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: Cit,
    defaultMatchWidth: "any",
    parsePatterns: xit,
    defaultParseWidth: "any"
  })
}, Pit = {
  code: "mt",
  formatDistance: Qot,
  formatLong: tit,
  formatRelative: rit,
  localize: dit,
  match: Eit,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, kit = {
  lessThanXSeconds: {
    one: "mindre enn ett sekund",
    other: "mindre enn {{count}} sekunder"
  },
  xSeconds: {
    one: "ett sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "et halvt minutt",
  lessThanXMinutes: {
    one: "mindre enn ett minutt",
    other: "mindre enn {{count}} minutter"
  },
  xMinutes: {
    one: "ett minutt",
    other: "{{count}} minutter"
  },
  aboutXHours: {
    one: "omtrent en time",
    other: "omtrent {{count}} timer"
  },
  xHours: {
    one: "en time",
    other: "{{count}} timer"
  },
  xDays: {
    one: "en dag",
    other: "{{count}} dager"
  },
  aboutXWeeks: {
    one: "omtrent en uke",
    other: "omtrent {{count}} uker"
  },
  xWeeks: {
    one: "en uke",
    other: "{{count}} uker"
  },
  aboutXMonths: {
    one: "omtrent en måned",
    other: "omtrent {{count}} måneder"
  },
  xMonths: {
    one: "en måned",
    other: "{{count}} måneder"
  },
  aboutXYears: {
    one: "omtrent ett år",
    other: "omtrent {{count}} år"
  },
  xYears: {
    one: "ett år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "over ett år",
    other: "over {{count}} år"
  },
  almostXYears: {
    one: "nesten ett år",
    other: "nesten {{count}} år"
  }
}, Mit = (e, t, r) => {
  let a;
  const i = kit[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? "om " + a : a + " siden" : a;
}, Oit = {
  full: "EEEE d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd.MM.y"
}, Tit = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Rit = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Ait = {
  date: Ke({
    formats: Oit,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: Tit,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: Rit,
    defaultWidth: "full"
  })
}, Nit = {
  lastWeek: "'forrige' eeee 'kl.' p",
  yesterday: "'i går kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgen kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: "P"
}, Dit = (e, t, r, a) => Nit[e], $it = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["før Kristus", "etter Kristus"]
}, zit = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, jit = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jan.",
    "feb.",
    "mars",
    "apr.",
    "mai",
    "juni",
    "juli",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "des."
  ],
  wide: [
    "januar",
    "februar",
    "mars",
    "april",
    "mai",
    "juni",
    "juli",
    "august",
    "september",
    "oktober",
    "november",
    "desember"
  ]
}, Iit = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sø", "ma", "ti", "on", "to", "fr", "lø"],
  abbreviated: ["søn", "man", "tir", "ons", "tor", "fre", "lør"],
  wide: [
    "søndag",
    "mandag",
    "tirsdag",
    "onsdag",
    "torsdag",
    "fredag",
    "lørdag"
  ]
}, Lit = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på etterm.",
    evening: "på kvelden",
    night: "på natten"
  },
  abbreviated: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på etterm.",
    evening: "på kvelden",
    night: "på natten"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morgenen",
    afternoon: "på ettermiddagen",
    evening: "på kvelden",
    night: "på natten"
  }
}, Hit = (e, t) => Number(e) + ".", Fit = {
  ordinalNumber: Hit,
  era: Ce({
    values: $it,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: zit,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: jit,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: Iit,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: Lit,
    defaultWidth: "wide"
  })
}, Wit = /^(\d+)\.?/i, Vit = /\d+/i, _it = {
  narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
}, Bit = {
  any: [/^f/i, /^e/i]
}, Uit = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? kvartal/i
}, Xit = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Git = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
  wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
}, qit = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^aug/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Kit = {
  narrow: /^[smtofl]/i,
  short: /^(sø|ma|ti|on|to|fr|lø)/i,
  abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
  wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
}, Yit = {
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, Qit = {
  narrow: /^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
  any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i
}, Jit = {
  any: {
    am: /^a(\.?\s?m\.?)?$/i,
    pm: /^p(\.?\s?m\.?)?$/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgen/i,
    afternoon: /ettermiddag/i,
    evening: /kveld/i,
    night: /natt/i
  }
}, Zit = {
  ordinalNumber: Fn({
    matchPattern: Wit,
    parsePattern: Vit,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: _it,
    defaultMatchWidth: "wide",
    parsePatterns: Bit,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: Uit,
    defaultMatchWidth: "wide",
    parsePatterns: Xit,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: Git,
    defaultMatchWidth: "wide",
    parsePatterns: qit,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: Kit,
    defaultMatchWidth: "wide",
    parsePatterns: Yit,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: Qit,
    defaultMatchWidth: "any",
    parsePatterns: Jit,
    defaultParseWidth: "any"
  })
}, elt = {
  code: "nb",
  formatDistance: Mit,
  formatLong: Ait,
  formatRelative: Dit,
  localize: Fit,
  match: Zit,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, tlt = {
  lessThanXSeconds: {
    one: "minder dan een seconde",
    other: "minder dan {{count}} seconden"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} seconden"
  },
  halfAMinute: "een halve minuut",
  lessThanXMinutes: {
    one: "minder dan een minuut",
    other: "minder dan {{count}} minuten"
  },
  xMinutes: {
    one: "een minuut",
    other: "{{count}} minuten"
  },
  aboutXHours: {
    one: "ongeveer 1 uur",
    other: "ongeveer {{count}} uur"
  },
  xHours: {
    one: "1 uur",
    other: "{{count}} uur"
  },
  xDays: {
    one: "1 dag",
    other: "{{count}} dagen"
  },
  aboutXWeeks: {
    one: "ongeveer 1 week",
    other: "ongeveer {{count}} weken"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weken"
  },
  aboutXMonths: {
    one: "ongeveer 1 maand",
    other: "ongeveer {{count}} maanden"
  },
  xMonths: {
    one: "1 maand",
    other: "{{count}} maanden"
  },
  aboutXYears: {
    one: "ongeveer 1 jaar",
    other: "ongeveer {{count}} jaar"
  },
  xYears: {
    one: "1 jaar",
    other: "{{count}} jaar"
  },
  overXYears: {
    one: "meer dan 1 jaar",
    other: "meer dan {{count}} jaar"
  },
  almostXYears: {
    one: "bijna 1 jaar",
    other: "bijna {{count}} jaar"
  }
}, nlt = (e, t, r) => {
  let a;
  const i = tlt[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? "over " + a : a + " geleden" : a;
}, rlt = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd-MM-y"
}, alt = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, olt = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, ilt = {
  date: Ke({
    formats: rlt,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: alt,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: olt,
    defaultWidth: "full"
  })
}, llt = {
  lastWeek: "'afgelopen' eeee 'om' p",
  yesterday: "'gisteren om' p",
  today: "'vandaag om' p",
  tomorrow: "'morgen om' p",
  nextWeek: "eeee 'om' p",
  other: "P"
}, slt = (e, t, r, a) => llt[e], ult = {
  narrow: ["v.C.", "n.C."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["voor Christus", "na Christus"]
}, clt = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1e kwartaal", "2e kwartaal", "3e kwartaal", "4e kwartaal"]
}, dlt = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jan.",
    "feb.",
    "mrt.",
    "apr.",
    "mei",
    "jun.",
    "jul.",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "dec."
  ],
  wide: [
    "januari",
    "februari",
    "maart",
    "april",
    "mei",
    "juni",
    "juli",
    "augustus",
    "september",
    "oktober",
    "november",
    "december"
  ]
}, flt = {
  narrow: ["Z", "M", "D", "W", "D", "V", "Z"],
  short: ["zo", "ma", "di", "wo", "do", "vr", "za"],
  abbreviated: ["zon", "maa", "din", "woe", "don", "vri", "zat"],
  wide: [
    "zondag",
    "maandag",
    "dinsdag",
    "woensdag",
    "donderdag",
    "vrijdag",
    "zaterdag"
  ]
}, mlt = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  }
}, hlt = (e, t) => Number(e) + "e", plt = {
  ordinalNumber: hlt,
  era: Ce({
    values: ult,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: clt,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: dlt,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: flt,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: mlt,
    defaultWidth: "wide"
  })
}, glt = /^(\d+)e?/i, vlt = /\d+/i, blt = {
  narrow: /^([vn]\.? ?C\.?)/,
  abbreviated: /^([vn]\. ?Chr\.?)/,
  wide: /^((voor|na) Christus)/
}, ylt = {
  any: [/^v/, /^n/]
}, wlt = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234]e kwartaal/i
}, Slt = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Clt = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
}, xlt = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^jan/i,
    /^feb/i,
    /^m(r|a)/i,
    /^apr/i,
    /^mei/i,
    /^jun/i,
    /^jul/i,
    /^aug/i,
    /^sep/i,
    /^okt/i,
    /^nov/i,
    /^dec/i
  ]
}, Elt = {
  narrow: /^[zmdwv]/i,
  short: /^(zo|ma|di|wo|do|vr|za)/i,
  abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
  wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
}, Plt = {
  narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
  any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
}, klt = {
  any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
}, Mlt = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^middernacht/i,
    noon: /^het middaguur/i,
    morning: /ochtend/i,
    afternoon: /middag/i,
    evening: /avond/i,
    night: /nacht/i
  }
}, Olt = {
  ordinalNumber: Fn({
    matchPattern: glt,
    parsePattern: vlt,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: blt,
    defaultMatchWidth: "wide",
    parsePatterns: ylt,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: wlt,
    defaultMatchWidth: "wide",
    parsePatterns: Slt,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: Clt,
    defaultMatchWidth: "wide",
    parsePatterns: xlt,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: Elt,
    defaultMatchWidth: "wide",
    parsePatterns: Plt,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: klt,
    defaultMatchWidth: "any",
    parsePatterns: Mlt,
    defaultParseWidth: "any"
  })
}, Tlt = {
  code: "nl",
  formatDistance: nlt,
  formatLong: ilt,
  formatRelative: slt,
  localize: plt,
  match: Olt,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Rlt = {
  lessThanXSeconds: {
    one: "minder dan een seconde",
    other: "minder dan {{count}} seconden"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} seconden"
  },
  halfAMinute: "een halve minuut",
  lessThanXMinutes: {
    one: "minder dan een minuut",
    other: "minder dan {{count}} minuten"
  },
  xMinutes: {
    one: "een minuut",
    other: "{{count}} minuten"
  },
  aboutXHours: {
    one: "ongeveer 1 uur",
    other: "ongeveer {{count}} uur"
  },
  xHours: {
    one: "1 uur",
    other: "{{count}} uur"
  },
  xDays: {
    one: "1 dag",
    other: "{{count}} dagen"
  },
  aboutXWeeks: {
    one: "ongeveer 1 week",
    other: "ongeveer {{count}} weken"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weken"
  },
  aboutXMonths: {
    one: "ongeveer 1 maand",
    other: "ongeveer {{count}} maanden"
  },
  xMonths: {
    one: "1 maand",
    other: "{{count}} maanden"
  },
  aboutXYears: {
    one: "ongeveer 1 jaar",
    other: "ongeveer {{count}} jaar"
  },
  xYears: {
    one: "1 jaar",
    other: "{{count}} jaar"
  },
  overXYears: {
    one: "meer dan 1 jaar",
    other: "meer dan {{count}} jaar"
  },
  almostXYears: {
    one: "bijna 1 jaar",
    other: "bijna {{count}} jaar"
  }
}, Alt = (e, t, r) => {
  let a;
  const i = Rlt[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? "over " + a : a + " geleden" : a;
}, Nlt = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd.MM.y"
}, Dlt = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, $lt = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, zlt = {
  date: Ke({
    formats: Nlt,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: Dlt,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: $lt,
    defaultWidth: "full"
  })
}, jlt = {
  lastWeek: "'vorige' eeee 'om' p",
  yesterday: "'gisteren om' p",
  today: "'vandaag om' p",
  tomorrow: "'morgen om' p",
  nextWeek: "eeee 'om' p",
  other: "P"
}, Ilt = (e, t, r, a) => jlt[e], Llt = {
  narrow: ["v.C.", "n.C."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["voor Christus", "na Christus"]
}, Hlt = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1e kwartaal", "2e kwartaal", "3e kwartaal", "4e kwartaal"]
}, Flt = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jan.",
    "feb.",
    "mrt.",
    "apr.",
    "mei",
    "jun.",
    "jul.",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "dec."
  ],
  wide: [
    "januari",
    "februari",
    "maart",
    "april",
    "mei",
    "juni",
    "juli",
    "augustus",
    "september",
    "oktober",
    "november",
    "december"
  ]
}, Wlt = {
  narrow: ["Z", "M", "D", "W", "D", "V", "Z"],
  short: ["zo", "ma", "di", "wo", "do", "vr", "za"],
  abbreviated: ["zon", "maa", "din", "woe", "don", "vri", "zat"],
  wide: [
    "zondag",
    "maandag",
    "dinsdag",
    "woensdag",
    "donderdag",
    "vrijdag",
    "zaterdag"
  ]
}, Vlt = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middag",
    morning: "'s ochtends",
    afternoon: "'s namiddags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middag",
    morning: "'s ochtends",
    afternoon: "'s namiddags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middag",
    morning: "'s ochtends",
    afternoon: "'s namiddags",
    evening: "'s avonds",
    night: "'s nachts"
  }
}, _lt = (e, t) => Number(e) + "e", Blt = {
  ordinalNumber: _lt,
  era: Ce({
    values: Llt,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: Hlt,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: Flt,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: Wlt,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: Vlt,
    defaultWidth: "wide"
  })
}, Ult = /^(\d+)e?/i, Xlt = /\d+/i, Glt = {
  narrow: /^([vn]\.? ?C\.?)/,
  abbreviated: /^([vn]\. ?Chr\.?)/,
  wide: /^((voor|na) Christus)/
}, qlt = {
  any: [/^v/, /^n/]
}, Klt = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234]e kwartaal/i
}, Ylt = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Qlt = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
}, Jlt = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^jan/i,
    /^feb/i,
    /^m(r|a)/i,
    /^apr/i,
    /^mei/i,
    /^jun/i,
    /^jul/i,
    /^aug/i,
    /^sep/i,
    /^okt/i,
    /^nov/i,
    /^dec/i
  ]
}, Zlt = {
  narrow: /^[zmdwv]/i,
  short: /^(zo|ma|di|wo|do|vr|za)/i,
  abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
  wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
}, est = {
  narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
  any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
}, tst = {
  any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
}, nst = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^middernacht/i,
    noon: /^het middaguur/i,
    morning: /ochtend/i,
    afternoon: /middag/i,
    evening: /avond/i,
    night: /nacht/i
  }
}, rst = {
  ordinalNumber: Fn({
    matchPattern: Ult,
    parsePattern: Xlt,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: Glt,
    defaultMatchWidth: "wide",
    parsePatterns: qlt,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: Klt,
    defaultMatchWidth: "wide",
    parsePatterns: Ylt,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: Qlt,
    defaultMatchWidth: "wide",
    parsePatterns: Jlt,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: Zlt,
    defaultMatchWidth: "wide",
    parsePatterns: est,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: tst,
    defaultMatchWidth: "any",
    parsePatterns: nst,
    defaultParseWidth: "any"
  })
}, ast = {
  code: "nl-BE",
  formatDistance: Alt,
  formatLong: zlt,
  formatRelative: Ilt,
  localize: Blt,
  match: rst,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, ost = {
  lessThanXSeconds: {
    one: "mindre enn eitt sekund",
    other: "mindre enn {{count}} sekund"
  },
  xSeconds: {
    one: "eitt sekund",
    other: "{{count}} sekund"
  },
  halfAMinute: "eit halvt minutt",
  lessThanXMinutes: {
    one: "mindre enn eitt minutt",
    other: "mindre enn {{count}} minutt"
  },
  xMinutes: {
    one: "eitt minutt",
    other: "{{count}} minutt"
  },
  aboutXHours: {
    one: "omtrent ein time",
    other: "omtrent {{count}} timar"
  },
  xHours: {
    one: "ein time",
    other: "{{count}} timar"
  },
  xDays: {
    one: "ein dag",
    other: "{{count}} dagar"
  },
  aboutXWeeks: {
    one: "omtrent ei veke",
    other: "omtrent {{count}} veker"
  },
  xWeeks: {
    one: "ei veke",
    other: "{{count}} veker"
  },
  aboutXMonths: {
    one: "omtrent ein månad",
    other: "omtrent {{count}} månader"
  },
  xMonths: {
    one: "ein månad",
    other: "{{count}} månader"
  },
  aboutXYears: {
    one: "omtrent eitt år",
    other: "omtrent {{count}} år"
  },
  xYears: {
    one: "eitt år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "over eitt år",
    other: "over {{count}} år"
  },
  almostXYears: {
    one: "nesten eitt år",
    other: "nesten {{count}} år"
  }
}, ist = [
  "null",
  "ein",
  "to",
  "tre",
  "fire",
  "fem",
  "seks",
  "sju",
  "åtte",
  "ni",
  "ti",
  "elleve",
  "tolv"
], lst = (e, t, r) => {
  let a;
  const i = ost[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace(
    "{{count}}",
    t < 13 ? ist[t] : String(t)
  ), r?.addSuffix ? r.comparison && r.comparison > 0 ? "om " + a : a + " sidan" : a;
}, sst = {
  full: "EEEE d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd.MM.y"
}, ust = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, cst = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, dst = {
  date: Ke({
    formats: sst,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: ust,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: cst,
    defaultWidth: "full"
  })
}, fst = {
  lastWeek: "'førre' eeee 'kl.' p",
  yesterday: "'i går kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgon kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: "P"
}, mst = (e, t, r, a) => fst[e], hst = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["før Kristus", "etter Kristus"]
}, pst = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, gst = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jan.",
    "feb.",
    "mars",
    "apr.",
    "mai",
    "juni",
    "juli",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "des."
  ],
  wide: [
    "januar",
    "februar",
    "mars",
    "april",
    "mai",
    "juni",
    "juli",
    "august",
    "september",
    "oktober",
    "november",
    "desember"
  ]
}, vst = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["su", "må", "ty", "on", "to", "fr", "lau"],
  abbreviated: ["sun", "mån", "tys", "ons", "tor", "fre", "laur"],
  wide: [
    "sundag",
    "måndag",
    "tysdag",
    "onsdag",
    "torsdag",
    "fredag",
    "laurdag"
  ]
}, bst = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på etterm.",
    evening: "på kvelden",
    night: "på natta"
  },
  abbreviated: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på etterm.",
    evening: "på kvelden",
    night: "på natta"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morgonen",
    afternoon: "på ettermiddagen",
    evening: "på kvelden",
    night: "på natta"
  }
}, yst = (e, t) => Number(e) + ".", wst = {
  ordinalNumber: yst,
  era: Ce({
    values: hst,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: pst,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: gst,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: vst,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: bst,
    defaultWidth: "wide"
  })
}, Sst = /^(\d+)\.?/i, Cst = /\d+/i, xst = {
  narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
}, Est = {
  any: [/^f/i, /^e/i]
}, Pst = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? kvartal/i
}, kst = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Mst = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
  wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
}, Ost = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^aug/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Tst = {
  narrow: /^[smtofl]/i,
  short: /^(su|må|ty|on|to|fr|la)/i,
  abbreviated: /^(sun|mån|tys|ons|tor|fre|laur)/i,
  wide: /^(sundag|måndag|tysdag|onsdag|torsdag|fredag|laurdag)/i
}, Rst = {
  any: [/^s/i, /^m/i, /^ty/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, Ast = {
  narrow: /^(midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta)|[ap])/i,
  any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta))/i
}, Nst = {
  any: {
    am: /^a(\.?\s?m\.?)?$/i,
    pm: /^p(\.?\s?m\.?)?$/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgon/i,
    afternoon: /ettermiddag/i,
    evening: /kveld/i,
    night: /natt/i
  }
}, Dst = {
  ordinalNumber: Fn({
    matchPattern: Sst,
    parsePattern: Cst,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: xst,
    defaultMatchWidth: "wide",
    parsePatterns: Est,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: Pst,
    defaultMatchWidth: "wide",
    parsePatterns: kst,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: Mst,
    defaultMatchWidth: "wide",
    parsePatterns: Ost,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: Tst,
    defaultMatchWidth: "wide",
    parsePatterns: Rst,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: Ast,
    defaultMatchWidth: "any",
    parsePatterns: Nst,
    defaultParseWidth: "any"
  })
}, $st = {
  code: "nn",
  formatDistance: lst,
  formatLong: dst,
  formatRelative: mst,
  localize: wst,
  match: Dst,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, zst = {
  lessThanXSeconds: {
    one: "mens d’una segonda",
    other: "mens de {{count}} segondas"
  },
  xSeconds: {
    one: "1 segonda",
    other: "{{count}} segondas"
  },
  halfAMinute: "30 segondas",
  lessThanXMinutes: {
    one: "mens d’una minuta",
    other: "mens de {{count}} minutas"
  },
  xMinutes: {
    one: "1 minuta",
    other: "{{count}} minutas"
  },
  aboutXHours: {
    one: "environ 1 ora",
    other: "environ {{count}} oras"
  },
  xHours: {
    one: "1 ora",
    other: "{{count}} oras"
  },
  xDays: {
    one: "1 jorn",
    other: "{{count}} jorns"
  },
  aboutXWeeks: {
    one: "environ 1 setmana",
    other: "environ {{count}} setmanas"
  },
  xWeeks: {
    one: "1 setmana",
    other: "{{count}} setmanas"
  },
  aboutXMonths: {
    one: "environ 1 mes",
    other: "environ {{count}} meses"
  },
  xMonths: {
    one: "1 mes",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "environ 1 an",
    other: "environ {{count}} ans"
  },
  xYears: {
    one: "1 an",
    other: "{{count}} ans"
  },
  overXYears: {
    one: "mai d’un an",
    other: "mai de {{count}} ans"
  },
  almostXYears: {
    one: "gaireben un an",
    other: "gaireben {{count}} ans"
  }
}, jst = (e, t, r) => {
  let a;
  const i = zst[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? "d’aquí " + a : "fa " + a : a;
}, Ist = {
  full: "EEEE d 'de' MMMM y",
  long: "d 'de' MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, Lst = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Hst = {
  full: "{{date}} 'a' {{time}}",
  long: "{{date}} 'a' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Fst = {
  date: Ke({
    formats: Ist,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: Lst,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: Hst,
    defaultWidth: "full"
  })
}, Wst = {
  lastWeek: "eeee 'passat a' p",
  yesterday: "'ièr a' p",
  today: "'uèi a' p",
  tomorrow: "'deman a' p",
  nextWeek: "eeee 'a' p",
  other: "P"
}, Vst = (e, t, r, a) => Wst[e], _st = {
  narrow: ["ab. J.C.", "apr. J.C."],
  abbreviated: ["ab. J.C.", "apr. J.C."],
  wide: ["abans Jèsus-Crist", "après Jèsus-Crist"]
}, Bst = {
  narrow: ["T1", "T2", "T3", "T4"],
  abbreviated: ["1èr trim.", "2nd trim.", "3en trim.", "4en trim."],
  wide: ["1èr trimèstre", "2nd trimèstre", "3en trimèstre", "4en trimèstre"]
}, Ust = {
  narrow: [
    "GN",
    "FB",
    "MÇ",
    "AB",
    "MA",
    "JN",
    "JL",
    "AG",
    "ST",
    "OC",
    "NV",
    "DC"
  ],
  abbreviated: [
    "gen.",
    "febr.",
    "març",
    "abr.",
    "mai",
    "junh",
    "jul.",
    "ag.",
    "set.",
    "oct.",
    "nov.",
    "dec."
  ],
  wide: [
    "genièr",
    "febrièr",
    "març",
    "abril",
    "mai",
    "junh",
    "julhet",
    "agost",
    "setembre",
    "octòbre",
    "novembre",
    "decembre"
  ]
}, Xst = {
  narrow: ["dg.", "dl.", "dm.", "dc.", "dj.", "dv.", "ds."],
  short: ["dg.", "dl.", "dm.", "dc.", "dj.", "dv.", "ds."],
  abbreviated: ["dg.", "dl.", "dm.", "dc.", "dj.", "dv.", "ds."],
  wide: [
    "dimenge",
    "diluns",
    "dimars",
    "dimècres",
    "dijòus",
    "divendres",
    "dissabte"
  ]
}, Gst = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "mièjanuèch",
    noon: "miègjorn",
    morning: "matin",
    afternoon: "aprèp-miègjorn",
    evening: "vèspre",
    night: "nuèch"
  },
  abbreviated: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "mièjanuèch",
    noon: "miègjorn",
    morning: "matin",
    afternoon: "aprèp-miègjorn",
    evening: "vèspre",
    night: "nuèch"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "mièjanuèch",
    noon: "miègjorn",
    morning: "matin",
    afternoon: "aprèp-miègjorn",
    evening: "vèspre",
    night: "nuèch"
  }
}, qst = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "mièjanuèch",
    noon: "miègjorn",
    morning: "del matin",
    afternoon: "de l’aprèp-miègjorn",
    evening: "del ser",
    night: "de la nuèch"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mièjanuèch",
    noon: "miègjorn",
    morning: "del matin",
    afternoon: "de l’aprèp-miègjorn",
    evening: "del ser",
    night: "de la nuèch"
  },
  wide: {
    am: "ante meridiem",
    pm: "post meridiem",
    midnight: "mièjanuèch",
    noon: "miègjorn",
    morning: "del matin",
    afternoon: "de l’aprèp-miègjorn",
    evening: "del ser",
    night: "de la nuèch"
  }
}, Kst = (e, t) => {
  const r = Number(e), a = t?.unit;
  let i;
  switch (r) {
    case 1:
      i = "èr";
      break;
    case 2:
      i = "nd";
      break;
    default:
      i = "en";
  }
  return (a === "year" || a === "week" || a === "hour" || a === "minute" || a === "second") && (i += "a"), r + i;
}, Yst = {
  ordinalNumber: Kst,
  era: Ce({
    values: _st,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: Bst,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: Ust,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: Xst,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: Gst,
    defaultWidth: "wide",
    formattingValues: qst,
    defaultFormattingWidth: "wide"
  })
}, Qst = /^(\d+)(èr|nd|en)?[a]?/i, Jst = /\d+/i, Zst = {
  narrow: /^(ab\.J\.C|apr\.J\.C|apr\.J\.-C)/i,
  abbreviated: /^(ab\.J\.-C|ab\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
  wide: /^(abans Jèsus-Crist|après Jèsus-Crist)/i
}, eut = {
  any: [/^ab/i, /^ap/i]
}, tut = {
  narrow: /^T[1234]/i,
  abbreviated: /^[1234](èr|nd|en)? trim\.?/i,
  wide: /^[1234](èr|nd|en)? trimèstre/i
}, nut = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, rut = {
  narrow: /^(GN|FB|MÇ|AB|MA|JN|JL|AG|ST|OC|NV|DC)/i,
  abbreviated: /^(gen|febr|març|abr|mai|junh|jul|ag|set|oct|nov|dec)\.?/i,
  wide: /^(genièr|febrièr|març|abril|mai|junh|julhet|agost|setembre|octòbre|novembre|decembre)/i
}, aut = {
  any: [
    /^g/i,
    /^f/i,
    /^ma[r?]|MÇ/i,
    /^ab/i,
    /^ma[i?]/i,
    /^ju[n?]|JN/i,
    /^ju[l?]|JL/i,
    /^ag/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, out = {
  narrow: /^d[glmcjvs]\.?/i,
  short: /^d[glmcjvs]\.?/i,
  abbreviated: /^d[glmcjvs]\.?/i,
  wide: /^(dimenge|diluns|dimars|dimècres|dijòus|divendres|dissabte)/i
}, iut = {
  narrow: [/^dg/i, /^dl/i, /^dm/i, /^dc/i, /^dj/i, /^dv/i, /^ds/i],
  short: [/^dg/i, /^dl/i, /^dm/i, /^dc/i, /^dj/i, /^dv/i, /^ds/i],
  abbreviated: [/^dg/i, /^dl/i, /^dm/i, /^dc/i, /^dj/i, /^dv/i, /^ds/i],
  any: [
    /^dg|dime/i,
    /^dl|dil/i,
    /^dm|dima/i,
    /^dc|dimè/i,
    /^dj|dij/i,
    /^dv|div/i,
    /^ds|dis/i
  ]
}, lut = {
  any: /(^(a\.?m|p\.?m))|(ante meridiem|post meridiem)|((del |de la |de l’)(matin|aprèp-miègjorn|vèspre|ser|nuèch))/i
}, sut = {
  any: {
    am: /(^a)|ante meridiem/i,
    pm: /(^p)|post meridiem/i,
    midnight: /^mièj/i,
    noon: /^mièg/i,
    morning: /matin/i,
    afternoon: /aprèp-miègjorn/i,
    evening: /vèspre|ser/i,
    night: /nuèch/i
  }
}, uut = {
  ordinalNumber: Fn({
    matchPattern: Qst,
    parsePattern: Jst,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: Zst,
    defaultMatchWidth: "wide",
    parsePatterns: eut,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: tut,
    defaultMatchWidth: "wide",
    parsePatterns: nut,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: rut,
    defaultMatchWidth: "wide",
    parsePatterns: aut,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: out,
    defaultMatchWidth: "wide",
    parsePatterns: iut,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: lut,
    defaultMatchWidth: "any",
    parsePatterns: sut,
    defaultParseWidth: "any"
  })
}, cut = {
  code: "oc",
  formatDistance: jst,
  formatLong: Fst,
  formatRelative: Vst,
  localize: Yst,
  match: uut,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, dut = {
  lessThanXSeconds: {
    one: {
      regular: "mniej niż sekunda",
      past: "mniej niż sekundę",
      future: "mniej niż sekundę"
    },
    twoFour: "mniej niż {{count}} sekundy",
    other: "mniej niż {{count}} sekund"
  },
  xSeconds: {
    one: {
      regular: "sekunda",
      past: "sekundę",
      future: "sekundę"
    },
    twoFour: "{{count}} sekundy",
    other: "{{count}} sekund"
  },
  halfAMinute: {
    one: "pół minuty",
    twoFour: "pół minuty",
    other: "pół minuty"
  },
  lessThanXMinutes: {
    one: {
      regular: "mniej niż minuta",
      past: "mniej niż minutę",
      future: "mniej niż minutę"
    },
    twoFour: "mniej niż {{count}} minuty",
    other: "mniej niż {{count}} minut"
  },
  xMinutes: {
    one: {
      regular: "minuta",
      past: "minutę",
      future: "minutę"
    },
    twoFour: "{{count}} minuty",
    other: "{{count}} minut"
  },
  aboutXHours: {
    one: {
      regular: "około godziny",
      past: "około godziny",
      future: "około godzinę"
    },
    twoFour: "około {{count}} godziny",
    other: "około {{count}} godzin"
  },
  xHours: {
    one: {
      regular: "godzina",
      past: "godzinę",
      future: "godzinę"
    },
    twoFour: "{{count}} godziny",
    other: "{{count}} godzin"
  },
  xDays: {
    one: {
      regular: "dzień",
      past: "dzień",
      future: "1 dzień"
    },
    twoFour: "{{count}} dni",
    other: "{{count}} dni"
  },
  aboutXWeeks: {
    one: "około tygodnia",
    twoFour: "około {{count}} tygodni",
    other: "około {{count}} tygodni"
  },
  xWeeks: {
    one: "tydzień",
    twoFour: "{{count}} tygodnie",
    other: "{{count}} tygodni"
  },
  aboutXMonths: {
    one: "około miesiąc",
    twoFour: "około {{count}} miesiące",
    other: "około {{count}} miesięcy"
  },
  xMonths: {
    one: "miesiąc",
    twoFour: "{{count}} miesiące",
    other: "{{count}} miesięcy"
  },
  aboutXYears: {
    one: "około rok",
    twoFour: "około {{count}} lata",
    other: "około {{count}} lat"
  },
  xYears: {
    one: "rok",
    twoFour: "{{count}} lata",
    other: "{{count}} lat"
  },
  overXYears: {
    one: "ponad rok",
    twoFour: "ponad {{count}} lata",
    other: "ponad {{count}} lat"
  },
  almostXYears: {
    one: "prawie rok",
    twoFour: "prawie {{count}} lata",
    other: "prawie {{count}} lat"
  }
};
function fut(e, t) {
  if (t === 1)
    return e.one;
  const r = t % 100;
  if (r <= 20 && r > 10)
    return e.other;
  const a = r % 10;
  return a >= 2 && a <= 4 ? e.twoFour : e.other;
}
function MA(e, t, r) {
  const a = fut(e, t);
  return (typeof a == "string" ? a : a[r]).replace("{{count}}", String(t));
}
const mut = (e, t, r) => {
  const a = dut[e];
  return r?.addSuffix ? r.comparison && r.comparison > 0 ? "za " + MA(a, t, "future") : MA(a, t, "past") + " temu" : MA(a, t, "regular");
}, hut = {
  full: "EEEE, do MMMM y",
  long: "do MMMM y",
  medium: "do MMM y",
  short: "dd.MM.y"
}, put = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, gut = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, vut = {
  date: Ke({
    formats: hut,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: put,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: gut,
    defaultWidth: "full"
  })
}, but = {
  masculine: "ostatni",
  feminine: "ostatnia"
}, yut = {
  masculine: "ten",
  feminine: "ta"
}, wut = {
  masculine: "następny",
  feminine: "następna"
}, Sut = {
  0: "feminine",
  1: "masculine",
  2: "masculine",
  3: "feminine",
  4: "masculine",
  5: "masculine",
  6: "feminine"
};
function aU(e, t, r, a) {
  let i;
  if (su(t, r, a))
    i = yut;
  else if (e === "lastWeek")
    i = but;
  else if (e === "nextWeek")
    i = wut;
  else
    throw new Error(`Cannot determine adjectives for token ${e}`);
  const c = t.getDay(), d = Sut[c];
  return `'${i[d]}' eeee 'o' p`;
}
const Cut = {
  lastWeek: aU,
  yesterday: "'wczoraj o' p",
  today: "'dzisiaj o' p",
  tomorrow: "'jutro o' p",
  nextWeek: aU,
  other: "P"
}, xut = (e, t, r, a) => {
  const i = Cut[e];
  return typeof i == "function" ? i(e, t, r, a) : i;
}, Eut = {
  narrow: ["p.n.e.", "n.e."],
  abbreviated: ["p.n.e.", "n.e."],
  wide: ["przed naszą erą", "naszej ery"]
}, Put = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["I kw.", "II kw.", "III kw.", "IV kw."],
  wide: ["I kwartał", "II kwartał", "III kwartał", "IV kwartał"]
}, kut = {
  narrow: ["S", "L", "M", "K", "M", "C", "L", "S", "W", "P", "L", "G"],
  abbreviated: [
    "sty",
    "lut",
    "mar",
    "kwi",
    "maj",
    "cze",
    "lip",
    "sie",
    "wrz",
    "paź",
    "lis",
    "gru"
  ],
  wide: [
    "styczeń",
    "luty",
    "marzec",
    "kwiecień",
    "maj",
    "czerwiec",
    "lipiec",
    "sierpień",
    "wrzesień",
    "październik",
    "listopad",
    "grudzień"
  ]
}, Mut = {
  narrow: ["s", "l", "m", "k", "m", "c", "l", "s", "w", "p", "l", "g"],
  abbreviated: [
    "sty",
    "lut",
    "mar",
    "kwi",
    "maj",
    "cze",
    "lip",
    "sie",
    "wrz",
    "paź",
    "lis",
    "gru"
  ],
  wide: [
    "stycznia",
    "lutego",
    "marca",
    "kwietnia",
    "maja",
    "czerwca",
    "lipca",
    "sierpnia",
    "września",
    "października",
    "listopada",
    "grudnia"
  ]
}, Out = {
  narrow: ["N", "P", "W", "Ś", "C", "P", "S"],
  short: ["nie", "pon", "wto", "śro", "czw", "pią", "sob"],
  abbreviated: ["niedz.", "pon.", "wt.", "śr.", "czw.", "pt.", "sob."],
  wide: [
    "niedziela",
    "poniedziałek",
    "wtorek",
    "środa",
    "czwartek",
    "piątek",
    "sobota"
  ]
}, Tut = {
  narrow: ["n", "p", "w", "ś", "c", "p", "s"],
  short: ["nie", "pon", "wto", "śro", "czw", "pią", "sob"],
  abbreviated: ["niedz.", "pon.", "wt.", "śr.", "czw.", "pt.", "sob."],
  wide: [
    "niedziela",
    "poniedziałek",
    "wtorek",
    "środa",
    "czwartek",
    "piątek",
    "sobota"
  ]
}, Rut = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "półn.",
    noon: "poł",
    morning: "rano",
    afternoon: "popoł.",
    evening: "wiecz.",
    night: "noc"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "północ",
    noon: "południe",
    morning: "rano",
    afternoon: "popołudnie",
    evening: "wieczór",
    night: "noc"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "północ",
    noon: "południe",
    morning: "rano",
    afternoon: "popołudnie",
    evening: "wieczór",
    night: "noc"
  }
}, Aut = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "o półn.",
    noon: "w poł.",
    morning: "rano",
    afternoon: "po poł.",
    evening: "wiecz.",
    night: "w nocy"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "o północy",
    noon: "w południe",
    morning: "rano",
    afternoon: "po południu",
    evening: "wieczorem",
    night: "w nocy"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "o północy",
    noon: "w południe",
    morning: "rano",
    afternoon: "po południu",
    evening: "wieczorem",
    night: "w nocy"
  }
}, Nut = (e, t) => String(e), Dut = {
  ordinalNumber: Nut,
  era: Ce({
    values: Eut,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: Put,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: kut,
    defaultWidth: "wide",
    formattingValues: Mut,
    defaultFormattingWidth: "wide"
  }),
  day: Ce({
    values: Out,
    defaultWidth: "wide",
    formattingValues: Tut,
    defaultFormattingWidth: "wide"
  }),
  dayPeriod: Ce({
    values: Rut,
    defaultWidth: "wide",
    formattingValues: Aut,
    defaultFormattingWidth: "wide"
  })
}, $ut = /^(\d+)?/i, zut = /\d+/i, jut = {
  narrow: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
  abbreviated: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
  wide: /^(przed\s*nasz(ą|a)\s*er(ą|a)|naszej\s*ery)/i
}, Iut = {
  any: [/^p/i, /^n/i]
}, Lut = {
  narrow: /^[1234]/i,
  abbreviated: /^(I|II|III|IV)\s*kw\.?/i,
  wide: /^(I|II|III|IV)\s*kwarta(ł|l)/i
}, Hut = {
  narrow: [/1/i, /2/i, /3/i, /4/i],
  any: [/^I kw/i, /^II kw/i, /^III kw/i, /^IV kw/i]
}, Fut = {
  narrow: /^[slmkcwpg]/i,
  abbreviated: /^(sty|lut|mar|kwi|maj|cze|lip|sie|wrz|pa(ź|z)|lis|gru)/i,
  wide: /^(stycznia|stycze(ń|n)|lutego|luty|marca|marzec|kwietnia|kwiecie(ń|n)|maja|maj|czerwca|czerwiec|lipca|lipiec|sierpnia|sierpie(ń|n)|wrze(ś|s)nia|wrzesie(ń|n)|pa(ź|z)dziernika|pa(ź|z)dziernik|listopada|listopad|grudnia|grudzie(ń|n))/i
}, Wut = {
  narrow: [
    /^s/i,
    /^l/i,
    /^m/i,
    /^k/i,
    /^m/i,
    /^c/i,
    /^l/i,
    /^s/i,
    /^w/i,
    /^p/i,
    /^l/i,
    /^g/i
  ],
  any: [
    /^st/i,
    /^lu/i,
    /^mar/i,
    /^k/i,
    /^maj/i,
    /^c/i,
    /^lip/i,
    /^si/i,
    /^w/i,
    /^p/i,
    /^lis/i,
    /^g/i
  ]
}, Vut = {
  narrow: /^[npwścs]/i,
  short: /^(nie|pon|wto|(ś|s)ro|czw|pi(ą|a)|sob)/i,
  abbreviated: /^(niedz|pon|wt|(ś|s)r|czw|pt|sob)\.?/i,
  wide: /^(niedziela|poniedzia(ł|l)ek|wtorek|(ś|s)roda|czwartek|pi(ą|a)tek|sobota)/i
}, _ut = {
  narrow: [/^n/i, /^p/i, /^w/i, /^ś/i, /^c/i, /^p/i, /^s/i],
  abbreviated: [/^n/i, /^po/i, /^w/i, /^(ś|s)r/i, /^c/i, /^pt/i, /^so/i],
  any: [/^n/i, /^po/i, /^w/i, /^(ś|s)r/i, /^c/i, /^pi/i, /^so/i]
}, But = {
  narrow: /^(^a$|^p$|pó(ł|l)n\.?|o\s*pó(ł|l)n\.?|po(ł|l)\.?|w\s*po(ł|l)\.?|po\s*po(ł|l)\.?|rano|wiecz\.?|noc|w\s*nocy)/i,
  any: /^(am|pm|pó(ł|l)noc|o\s*pó(ł|l)nocy|po(ł|l)udnie|w\s*po(ł|l)udnie|popo(ł|l)udnie|po\s*po(ł|l)udniu|rano|wieczór|wieczorem|noc|w\s*nocy)/i
}, Uut = {
  narrow: {
    am: /^a$/i,
    pm: /^p$/i,
    midnight: /pó(ł|l)n/i,
    noon: /po(ł|l)/i,
    morning: /rano/i,
    afternoon: /po\s*po(ł|l)/i,
    evening: /wiecz/i,
    night: /noc/i
  },
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /pó(ł|l)n/i,
    noon: /po(ł|l)/i,
    morning: /rano/i,
    afternoon: /po\s*po(ł|l)/i,
    evening: /wiecz/i,
    night: /noc/i
  }
}, Xut = {
  ordinalNumber: Fn({
    matchPattern: $ut,
    parsePattern: zut,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: jut,
    defaultMatchWidth: "wide",
    parsePatterns: Iut,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: Lut,
    defaultMatchWidth: "wide",
    parsePatterns: Hut,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: Fut,
    defaultMatchWidth: "wide",
    parsePatterns: Wut,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: Vut,
    defaultMatchWidth: "wide",
    parsePatterns: _ut,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: But,
    defaultMatchWidth: "any",
    parsePatterns: Uut,
    defaultParseWidth: "any"
  })
}, Gut = {
  code: "pl",
  formatDistance: mut,
  formatLong: vut,
  formatRelative: xut,
  localize: Dut,
  match: Xut,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, qut = {
  lessThanXSeconds: {
    one: "menos de um segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "meio minuto",
  lessThanXMinutes: {
    one: "menos de um minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "aproximadamente 1 hora",
    other: "aproximadamente {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 dia",
    other: "{{count}} dias"
  },
  aboutXWeeks: {
    one: "aproximadamente 1 semana",
    other: "aproximadamente {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "aproximadamente 1 mês",
    other: "aproximadamente {{count}} meses"
  },
  xMonths: {
    one: "1 mês",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "aproximadamente 1 ano",
    other: "aproximadamente {{count}} anos"
  },
  xYears: {
    one: "1 ano",
    other: "{{count}} anos"
  },
  overXYears: {
    one: "mais de 1 ano",
    other: "mais de {{count}} anos"
  },
  almostXYears: {
    one: "quase 1 ano",
    other: "quase {{count}} anos"
  }
}, Kut = (e, t, r) => {
  let a;
  const i = qut[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? "daqui a " + a : "há " + a : a;
}, Yut = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d 'de' MMM 'de' y",
  short: "dd/MM/y"
}, Qut = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Jut = {
  full: "{{date}} 'às' {{time}}",
  long: "{{date}} 'às' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Zut = {
  date: Ke({
    formats: Yut,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: Qut,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: Jut,
    defaultWidth: "full"
  })
}, ect = {
  lastWeek: (e) => {
    const t = e.getDay();
    return "'" + (t === 0 || t === 6 ? "último" : "última") + "' eeee 'às' p";
  },
  yesterday: "'ontem às' p",
  today: "'hoje às' p",
  tomorrow: "'amanhã às' p",
  nextWeek: "eeee 'às' p",
  other: "P"
}, tct = (e, t, r, a) => {
  const i = ect[e];
  return typeof i == "function" ? i(t) : i;
}, nct = {
  narrow: ["aC", "dC"],
  abbreviated: ["a.C.", "d.C."],
  wide: ["antes de Cristo", "depois de Cristo"]
}, rct = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, act = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan",
    "fev",
    "mar",
    "abr",
    "mai",
    "jun",
    "jul",
    "ago",
    "set",
    "out",
    "nov",
    "dez"
  ],
  wide: [
    "janeiro",
    "fevereiro",
    "março",
    "abril",
    "maio",
    "junho",
    "julho",
    "agosto",
    "setembro",
    "outubro",
    "novembro",
    "dezembro"
  ]
}, oct = {
  narrow: ["d", "s", "t", "q", "q", "s", "s"],
  short: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
  abbreviated: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
  wide: [
    "domingo",
    "segunda-feira",
    "terça-feira",
    "quarta-feira",
    "quinta-feira",
    "sexta-feira",
    "sábado"
  ]
}, ict = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  }
}, lct = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  }
}, sct = (e, t) => Number(e) + "º", uct = {
  ordinalNumber: sct,
  era: Ce({
    values: nct,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: rct,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: act,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: oct,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: ict,
    defaultWidth: "wide",
    formattingValues: lct,
    defaultFormattingWidth: "wide"
  })
}, cct = /^(\d+)(º|ª)?/i, dct = /\d+/i, fct = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
}, mct = {
  any: [/^ac/i, /^dc/i],
  wide: [
    /^(antes de cristo|antes da era comum)/i,
    /^(depois de cristo|era comum)/i
  ]
}, hct = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º|ª)? trimestre/i
}, pct = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, gct = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
}, vct = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ab/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^ag/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, bct = {
  narrow: /^[dstq]/i,
  short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
  wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
}, yct = {
  narrow: [/^d/i, /^s/i, /^t/i, /^q/i, /^q/i, /^s/i, /^s/i],
  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[áa]/i]
}, wct = {
  narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
  any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
}, Sct = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^meia/i,
    noon: /^meio/i,
    morning: /manh[ãa]/i,
    afternoon: /tarde/i,
    evening: /noite/i,
    night: /madrugada/i
  }
}, Cct = {
  ordinalNumber: Fn({
    matchPattern: cct,
    parsePattern: dct,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: fct,
    defaultMatchWidth: "wide",
    parsePatterns: mct,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: hct,
    defaultMatchWidth: "wide",
    parsePatterns: pct,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: gct,
    defaultMatchWidth: "wide",
    parsePatterns: vct,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: bct,
    defaultMatchWidth: "wide",
    parsePatterns: yct,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: wct,
    defaultMatchWidth: "any",
    parsePatterns: Sct,
    defaultParseWidth: "any"
  })
}, xct = {
  code: "pt",
  formatDistance: Kut,
  formatLong: Zut,
  formatRelative: tct,
  localize: uct,
  match: Cct,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Ect = {
  lessThanXSeconds: {
    one: "menos de um segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "meio minuto",
  lessThanXMinutes: {
    one: "menos de um minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "cerca de 1 hora",
    other: "cerca de {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 dia",
    other: "{{count}} dias"
  },
  aboutXWeeks: {
    one: "cerca de 1 semana",
    other: "cerca de {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "cerca de 1 mês",
    other: "cerca de {{count}} meses"
  },
  xMonths: {
    one: "1 mês",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "cerca de 1 ano",
    other: "cerca de {{count}} anos"
  },
  xYears: {
    one: "1 ano",
    other: "{{count}} anos"
  },
  overXYears: {
    one: "mais de 1 ano",
    other: "mais de {{count}} anos"
  },
  almostXYears: {
    one: "quase 1 ano",
    other: "quase {{count}} anos"
  }
}, Pct = (e, t, r) => {
  let a;
  const i = Ect[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? "em " + a : "há " + a : a;
}, kct = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d MMM y",
  short: "dd/MM/yyyy"
}, Mct = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Oct = {
  full: "{{date}} 'às' {{time}}",
  long: "{{date}} 'às' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Tct = {
  date: Ke({
    formats: kct,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: Mct,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: Oct,
    defaultWidth: "full"
  })
}, Rct = {
  lastWeek: (e) => {
    const t = e.getDay();
    return "'" + (t === 0 || t === 6 ? "último" : "última") + "' eeee 'às' p";
  },
  yesterday: "'ontem às' p",
  today: "'hoje às' p",
  tomorrow: "'amanhã às' p",
  nextWeek: "eeee 'às' p",
  other: "P"
}, Act = (e, t, r, a) => {
  const i = Rct[e];
  return typeof i == "function" ? i(t) : i;
}, Nct = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "depois de cristo"]
}, Dct = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, $ct = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan",
    "fev",
    "mar",
    "abr",
    "mai",
    "jun",
    "jul",
    "ago",
    "set",
    "out",
    "nov",
    "dez"
  ],
  wide: [
    "janeiro",
    "fevereiro",
    "março",
    "abril",
    "maio",
    "junho",
    "julho",
    "agosto",
    "setembro",
    "outubro",
    "novembro",
    "dezembro"
  ]
}, zct = {
  narrow: ["D", "S", "T", "Q", "Q", "S", "S"],
  short: ["dom", "seg", "ter", "qua", "qui", "sex", "sab"],
  abbreviated: [
    "domingo",
    "segunda",
    "terça",
    "quarta",
    "quinta",
    "sexta",
    "sábado"
  ],
  wide: [
    "domingo",
    "segunda-feira",
    "terça-feira",
    "quarta-feira",
    "quinta-feira",
    "sexta-feira",
    "sábado"
  ]
}, jct = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "manhã",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  }
}, Ict = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite"
  }
}, Lct = (e, t) => {
  const r = Number(e);
  return t?.unit === "week" ? r + "ª" : r + "º";
}, Hct = {
  ordinalNumber: Lct,
  era: Ce({
    values: Nct,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: Dct,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: $ct,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: zct,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: jct,
    defaultWidth: "wide",
    formattingValues: Ict,
    defaultFormattingWidth: "wide"
  })
}, Fct = /^(\d+)[ºªo]?/i, Wct = /\d+/i, Vct = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
  wide: /^(antes de cristo|depois de cristo)/i
}, _ct = {
  any: [/^ac/i, /^dc/i],
  wide: [/^antes de cristo/i, /^depois de cristo/i]
}, Bct = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, Uct = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Xct = {
  narrow: /^[jfmajsond]/i,
  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
}, Gct = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^fev/i,
    /^mar/i,
    /^abr/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^ago/i,
    /^set/i,
    /^out/i,
    /^nov/i,
    /^dez/i
  ]
}, qct = {
  narrow: /^(dom|[23456]ª?|s[aá]b)/i,
  short: /^(dom|[23456]ª?|s[aá]b)/i,
  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
  wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
}, Kct = {
  short: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
  narrow: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[aá]b/i]
}, Yct = {
  narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
  any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
}, Qct = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn|^meia[-\s]noite/i,
    noon: /^md|^meio[-\s]dia/i,
    morning: /manhã/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noite/i
  }
}, Jct = {
  ordinalNumber: Fn({
    matchPattern: Fct,
    parsePattern: Wct,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: Vct,
    defaultMatchWidth: "wide",
    parsePatterns: _ct,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: Bct,
    defaultMatchWidth: "wide",
    parsePatterns: Uct,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: Xct,
    defaultMatchWidth: "wide",
    parsePatterns: Gct,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: qct,
    defaultMatchWidth: "wide",
    parsePatterns: Kct,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: Yct,
    defaultMatchWidth: "any",
    parsePatterns: Qct,
    defaultParseWidth: "any"
  })
}, Zct = {
  code: "pt-BR",
  formatDistance: Pct,
  formatLong: Tct,
  formatRelative: Act,
  localize: Hct,
  match: Jct,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, edt = {
  lessThanXSeconds: {
    one: "mai puțin de o secundă",
    other: "mai puțin de {{count}} secunde"
  },
  xSeconds: {
    one: "1 secundă",
    other: "{{count}} secunde"
  },
  halfAMinute: "jumătate de minut",
  lessThanXMinutes: {
    one: "mai puțin de un minut",
    other: "mai puțin de {{count}} minute"
  },
  xMinutes: {
    one: "1 minut",
    other: "{{count}} minute"
  },
  aboutXHours: {
    one: "circa 1 oră",
    other: "circa {{count}} ore"
  },
  xHours: {
    one: "1 oră",
    other: "{{count}} ore"
  },
  xDays: {
    one: "1 zi",
    other: "{{count}} zile"
  },
  aboutXWeeks: {
    one: "circa o săptămână",
    other: "circa {{count}} săptămâni"
  },
  xWeeks: {
    one: "1 săptămână",
    other: "{{count}} săptămâni"
  },
  aboutXMonths: {
    one: "circa 1 lună",
    other: "circa {{count}} luni"
  },
  xMonths: {
    one: "1 lună",
    other: "{{count}} luni"
  },
  aboutXYears: {
    one: "circa 1 an",
    other: "circa {{count}} ani"
  },
  xYears: {
    one: "1 an",
    other: "{{count}} ani"
  },
  overXYears: {
    one: "peste 1 an",
    other: "peste {{count}} ani"
  },
  almostXYears: {
    one: "aproape 1 an",
    other: "aproape {{count}} ani"
  }
}, tdt = (e, t, r) => {
  let a;
  const i = edt[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? "în " + a : a + " în urmă" : a;
}, ndt = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd.MM.yyyy"
}, rdt = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, adt = {
  full: "{{date}} 'la' {{time}}",
  long: "{{date}} 'la' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, odt = {
  date: Ke({
    formats: ndt,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: rdt,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: adt,
    defaultWidth: "full"
  })
}, idt = {
  lastWeek: "eeee 'trecută la' p",
  yesterday: "'ieri la' p",
  today: "'astăzi la' p",
  tomorrow: "'mâine la' p",
  nextWeek: "eeee 'viitoare la' p",
  other: "P"
}, ldt = (e, t, r, a) => idt[e], sdt = {
  narrow: ["Î", "D"],
  abbreviated: ["Î.d.C.", "D.C."],
  wide: ["Înainte de Cristos", "După Cristos"]
}, udt = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: [
    "primul trimestru",
    "al doilea trimestru",
    "al treilea trimestru",
    "al patrulea trimestru"
  ]
}, cdt = {
  narrow: ["I", "F", "M", "A", "M", "I", "I", "A", "S", "O", "N", "D"],
  abbreviated: [
    "ian",
    "feb",
    "mar",
    "apr",
    "mai",
    "iun",
    "iul",
    "aug",
    "sep",
    "oct",
    "noi",
    "dec"
  ],
  wide: [
    "ianuarie",
    "februarie",
    "martie",
    "aprilie",
    "mai",
    "iunie",
    "iulie",
    "august",
    "septembrie",
    "octombrie",
    "noiembrie",
    "decembrie"
  ]
}, ddt = {
  narrow: ["d", "l", "m", "m", "j", "v", "s"],
  short: ["du", "lu", "ma", "mi", "jo", "vi", "sâ"],
  abbreviated: ["dum", "lun", "mar", "mie", "joi", "vin", "sâm"],
  wide: ["duminică", "luni", "marți", "miercuri", "joi", "vineri", "sâmbătă"]
}, fdt = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "ami",
    morning: "dim",
    afternoon: "da",
    evening: "s",
    night: "n"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "miezul nopții",
    noon: "amiază",
    morning: "dimineață",
    afternoon: "după-amiază",
    evening: "seară",
    night: "noapte"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "miezul nopții",
    noon: "amiază",
    morning: "dimineață",
    afternoon: "după-amiază",
    evening: "seară",
    night: "noapte"
  }
}, mdt = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "amiază",
    morning: "dimineață",
    afternoon: "după-amiază",
    evening: "seară",
    night: "noapte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "miezul nopții",
    noon: "amiază",
    morning: "dimineață",
    afternoon: "după-amiază",
    evening: "seară",
    night: "noapte"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "miezul nopții",
    noon: "amiază",
    morning: "dimineață",
    afternoon: "după-amiază",
    evening: "seară",
    night: "noapte"
  }
}, hdt = (e, t) => String(e), pdt = {
  ordinalNumber: hdt,
  era: Ce({
    values: sdt,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: udt,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: cdt,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: ddt,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: fdt,
    defaultWidth: "wide",
    formattingValues: mdt,
    defaultFormattingWidth: "wide"
  })
}, gdt = /^(\d+)?/i, vdt = /\d+/i, bdt = {
  narrow: /^(Î|D)/i,
  abbreviated: /^(Î\.?\s?d\.?\s?C\.?|Î\.?\s?e\.?\s?n\.?|D\.?\s?C\.?|e\.?\s?n\.?)/i,
  wide: /^(Înainte de Cristos|Înaintea erei noastre|După Cristos|Era noastră)/i
}, ydt = {
  any: [/^ÎC/i, /^DC/i],
  wide: [
    /^(Înainte de Cristos|Înaintea erei noastre)/i,
    /^(După Cristos|Era noastră)/i
  ]
}, wdt = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^trimestrul [1234]/i
}, Sdt = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Cdt = {
  narrow: /^[ifmaasond]/i,
  abbreviated: /^(ian|feb|mar|apr|mai|iun|iul|aug|sep|oct|noi|dec)/i,
  wide: /^(ianuarie|februarie|martie|aprilie|mai|iunie|iulie|august|septembrie|octombrie|noiembrie|decembrie)/i
}, xdt = {
  narrow: [
    /^i/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^i/i,
    /^i/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ia/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^mai/i,
    /^iun/i,
    /^iul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Edt = {
  narrow: /^[dlmjvs]/i,
  short: /^(d|l|ma|mi|j|v|s)/i,
  abbreviated: /^(dum|lun|mar|mie|jo|vi|sâ)/i,
  wide: /^(duminica|luni|marţi|miercuri|joi|vineri|sâmbătă)/i
}, Pdt = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^mi/i, /^j/i, /^v/i, /^s/i]
}, kdt = {
  narrow: /^(a|p|mn|a|(dimineaţa|după-amiaza|seara|noaptea))/i,
  any: /^([ap]\.?\s?m\.?|miezul nopții|amiaza|(dimineaţa|după-amiaza|seara|noaptea))/i
}, Mdt = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /amiaza/i,
    morning: /dimineaţa/i,
    afternoon: /după-amiaza/i,
    evening: /seara/i,
    night: /noaptea/i
  }
}, Odt = {
  ordinalNumber: Fn({
    matchPattern: gdt,
    parsePattern: vdt,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: bdt,
    defaultMatchWidth: "wide",
    parsePatterns: ydt,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: wdt,
    defaultMatchWidth: "wide",
    parsePatterns: Sdt,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: Cdt,
    defaultMatchWidth: "wide",
    parsePatterns: xdt,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: Edt,
    defaultMatchWidth: "wide",
    parsePatterns: Pdt,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: kdt,
    defaultMatchWidth: "any",
    parsePatterns: Mdt,
    defaultParseWidth: "any"
  })
}, Tdt = {
  code: "ro",
  formatDistance: tdt,
  formatLong: odt,
  formatRelative: ldt,
  localize: pdt,
  match: Odt,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
function K5(e, t) {
  if (e.one !== void 0 && t === 1)
    return e.one;
  const r = t % 10, a = t % 100;
  return r === 1 && a !== 11 ? e.singularNominative.replace("{{count}}", String(t)) : r >= 2 && r <= 4 && (a < 10 || a > 20) ? e.singularGenitive.replace("{{count}}", String(t)) : e.pluralGenitive.replace("{{count}}", String(t));
}
function Bh(e) {
  return (t, r) => r?.addSuffix ? r.comparison && r.comparison > 0 ? e.future ? K5(e.future, t) : "через " + K5(e.regular, t) : e.past ? K5(e.past, t) : K5(e.regular, t) + " назад" : K5(e.regular, t);
}
const Rdt = {
  lessThanXSeconds: Bh({
    regular: {
      one: "меньше секунды",
      singularNominative: "меньше {{count}} секунды",
      singularGenitive: "меньше {{count}} секунд",
      pluralGenitive: "меньше {{count}} секунд"
    },
    future: {
      one: "меньше, чем через секунду",
      singularNominative: "меньше, чем через {{count}} секунду",
      singularGenitive: "меньше, чем через {{count}} секунды",
      pluralGenitive: "меньше, чем через {{count}} секунд"
    }
  }),
  xSeconds: Bh({
    regular: {
      singularNominative: "{{count}} секунда",
      singularGenitive: "{{count}} секунды",
      pluralGenitive: "{{count}} секунд"
    },
    past: {
      singularNominative: "{{count}} секунду назад",
      singularGenitive: "{{count}} секунды назад",
      pluralGenitive: "{{count}} секунд назад"
    },
    future: {
      singularNominative: "через {{count}} секунду",
      singularGenitive: "через {{count}} секунды",
      pluralGenitive: "через {{count}} секунд"
    }
  }),
  halfAMinute: (e, t) => t?.addSuffix ? t.comparison && t.comparison > 0 ? "через полминуты" : "полминуты назад" : "полминуты",
  lessThanXMinutes: Bh({
    regular: {
      one: "меньше минуты",
      singularNominative: "меньше {{count}} минуты",
      singularGenitive: "меньше {{count}} минут",
      pluralGenitive: "меньше {{count}} минут"
    },
    future: {
      one: "меньше, чем через минуту",
      singularNominative: "меньше, чем через {{count}} минуту",
      singularGenitive: "меньше, чем через {{count}} минуты",
      pluralGenitive: "меньше, чем через {{count}} минут"
    }
  }),
  xMinutes: Bh({
    regular: {
      singularNominative: "{{count}} минута",
      singularGenitive: "{{count}} минуты",
      pluralGenitive: "{{count}} минут"
    },
    past: {
      singularNominative: "{{count}} минуту назад",
      singularGenitive: "{{count}} минуты назад",
      pluralGenitive: "{{count}} минут назад"
    },
    future: {
      singularNominative: "через {{count}} минуту",
      singularGenitive: "через {{count}} минуты",
      pluralGenitive: "через {{count}} минут"
    }
  }),
  aboutXHours: Bh({
    regular: {
      singularNominative: "около {{count}} часа",
      singularGenitive: "около {{count}} часов",
      pluralGenitive: "около {{count}} часов"
    },
    future: {
      singularNominative: "приблизительно через {{count}} час",
      singularGenitive: "приблизительно через {{count}} часа",
      pluralGenitive: "приблизительно через {{count}} часов"
    }
  }),
  xHours: Bh({
    regular: {
      singularNominative: "{{count}} час",
      singularGenitive: "{{count}} часа",
      pluralGenitive: "{{count}} часов"
    }
  }),
  xDays: Bh({
    regular: {
      singularNominative: "{{count}} день",
      singularGenitive: "{{count}} дня",
      pluralGenitive: "{{count}} дней"
    }
  }),
  aboutXWeeks: Bh({
    regular: {
      singularNominative: "около {{count}} недели",
      singularGenitive: "около {{count}} недель",
      pluralGenitive: "около {{count}} недель"
    },
    future: {
      singularNominative: "приблизительно через {{count}} неделю",
      singularGenitive: "приблизительно через {{count}} недели",
      pluralGenitive: "приблизительно через {{count}} недель"
    }
  }),
  xWeeks: Bh({
    regular: {
      singularNominative: "{{count}} неделя",
      singularGenitive: "{{count}} недели",
      pluralGenitive: "{{count}} недель"
    }
  }),
  aboutXMonths: Bh({
    regular: {
      singularNominative: "около {{count}} месяца",
      singularGenitive: "около {{count}} месяцев",
      pluralGenitive: "около {{count}} месяцев"
    },
    future: {
      singularNominative: "приблизительно через {{count}} месяц",
      singularGenitive: "приблизительно через {{count}} месяца",
      pluralGenitive: "приблизительно через {{count}} месяцев"
    }
  }),
  xMonths: Bh({
    regular: {
      singularNominative: "{{count}} месяц",
      singularGenitive: "{{count}} месяца",
      pluralGenitive: "{{count}} месяцев"
    }
  }),
  aboutXYears: Bh({
    regular: {
      singularNominative: "около {{count}} года",
      singularGenitive: "около {{count}} лет",
      pluralGenitive: "около {{count}} лет"
    },
    future: {
      singularNominative: "приблизительно через {{count}} год",
      singularGenitive: "приблизительно через {{count}} года",
      pluralGenitive: "приблизительно через {{count}} лет"
    }
  }),
  xYears: Bh({
    regular: {
      singularNominative: "{{count}} год",
      singularGenitive: "{{count}} года",
      pluralGenitive: "{{count}} лет"
    }
  }),
  overXYears: Bh({
    regular: {
      singularNominative: "больше {{count}} года",
      singularGenitive: "больше {{count}} лет",
      pluralGenitive: "больше {{count}} лет"
    },
    future: {
      singularNominative: "больше, чем через {{count}} год",
      singularGenitive: "больше, чем через {{count}} года",
      pluralGenitive: "больше, чем через {{count}} лет"
    }
  }),
  almostXYears: Bh({
    regular: {
      singularNominative: "почти {{count}} год",
      singularGenitive: "почти {{count}} года",
      pluralGenitive: "почти {{count}} лет"
    },
    future: {
      singularNominative: "почти через {{count}} год",
      singularGenitive: "почти через {{count}} года",
      pluralGenitive: "почти через {{count}} лет"
    }
  })
}, Adt = (e, t, r) => Rdt[e](t, r), Ndt = {
  full: "EEEE, d MMMM y 'г.'",
  long: "d MMMM y 'г.'",
  medium: "d MMM y 'г.'",
  short: "dd.MM.y"
}, Ddt = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, $dt = {
  any: "{{date}}, {{time}}"
}, zdt = {
  date: Ke({
    formats: Ndt,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: Ddt,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: $dt,
    defaultWidth: "any"
  })
}, kI = [
  "воскресенье",
  "понедельник",
  "вторник",
  "среду",
  "четверг",
  "пятницу",
  "субботу"
];
function jdt(e) {
  const t = kI[e];
  switch (e) {
    case 0:
      return "'в прошлое " + t + " в' p";
    case 1:
    case 2:
    case 4:
      return "'в прошлый " + t + " в' p";
    case 3:
    case 5:
    case 6:
      return "'в прошлую " + t + " в' p";
  }
}
function oU(e) {
  const t = kI[e];
  return e === 2 ? "'во " + t + " в' p" : "'в " + t + " в' p";
}
function Idt(e) {
  const t = kI[e];
  switch (e) {
    case 0:
      return "'в следующее " + t + " в' p";
    case 1:
    case 2:
    case 4:
      return "'в следующий " + t + " в' p";
    case 3:
    case 5:
    case 6:
      return "'в следующую " + t + " в' p";
  }
}
const Ldt = {
  lastWeek: (e, t, r) => {
    const a = e.getDay();
    return su(e, t, r) ? oU(a) : jdt(a);
  },
  yesterday: "'вчера в' p",
  today: "'сегодня в' p",
  tomorrow: "'завтра в' p",
  nextWeek: (e, t, r) => {
    const a = e.getDay();
    return su(e, t, r) ? oU(a) : Idt(a);
  },
  other: "P"
}, Hdt = (e, t, r, a) => {
  const i = Ldt[e];
  return typeof i == "function" ? i(t, r, a) : i;
}, Fdt = {
  narrow: ["до н.э.", "н.э."],
  abbreviated: ["до н. э.", "н. э."],
  wide: ["до нашей эры", "нашей эры"]
}, Wdt = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-й кв.", "2-й кв.", "3-й кв.", "4-й кв."],
  wide: ["1-й квартал", "2-й квартал", "3-й квартал", "4-й квартал"]
}, Vdt = {
  narrow: ["Я", "Ф", "М", "А", "М", "И", "И", "А", "С", "О", "Н", "Д"],
  abbreviated: [
    "янв.",
    "фев.",
    "март",
    "апр.",
    "май",
    "июнь",
    "июль",
    "авг.",
    "сент.",
    "окт.",
    "нояб.",
    "дек."
  ],
  wide: [
    "январь",
    "февраль",
    "март",
    "апрель",
    "май",
    "июнь",
    "июль",
    "август",
    "сентябрь",
    "октябрь",
    "ноябрь",
    "декабрь"
  ]
}, _dt = {
  narrow: ["Я", "Ф", "М", "А", "М", "И", "И", "А", "С", "О", "Н", "Д"],
  abbreviated: [
    "янв.",
    "фев.",
    "мар.",
    "апр.",
    "мая",
    "июн.",
    "июл.",
    "авг.",
    "сент.",
    "окт.",
    "нояб.",
    "дек."
  ],
  wide: [
    "января",
    "февраля",
    "марта",
    "апреля",
    "мая",
    "июня",
    "июля",
    "августа",
    "сентября",
    "октября",
    "ноября",
    "декабря"
  ]
}, Bdt = {
  narrow: ["В", "П", "В", "С", "Ч", "П", "С"],
  short: ["вс", "пн", "вт", "ср", "чт", "пт", "сб"],
  abbreviated: ["вск", "пнд", "втр", "срд", "чтв", "птн", "суб"],
  wide: [
    "воскресенье",
    "понедельник",
    "вторник",
    "среда",
    "четверг",
    "пятница",
    "суббота"
  ]
}, Udt = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утро",
    afternoon: "день",
    evening: "веч.",
    night: "ночь"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утро",
    afternoon: "день",
    evening: "веч.",
    night: "ночь"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "полночь",
    noon: "полдень",
    morning: "утро",
    afternoon: "день",
    evening: "вечер",
    night: "ночь"
  }
}, Xdt = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утра",
    afternoon: "дня",
    evening: "веч.",
    night: "ночи"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утра",
    afternoon: "дня",
    evening: "веч.",
    night: "ночи"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "полночь",
    noon: "полдень",
    morning: "утра",
    afternoon: "дня",
    evening: "вечера",
    night: "ночи"
  }
}, Gdt = (e, t) => {
  const r = Number(e), a = t?.unit;
  let i;
  return a === "date" ? i = "-е" : a === "week" || a === "minute" || a === "second" ? i = "-я" : i = "-й", r + i;
}, qdt = {
  ordinalNumber: Gdt,
  era: Ce({
    values: Fdt,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: Wdt,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: Vdt,
    defaultWidth: "wide",
    formattingValues: _dt,
    defaultFormattingWidth: "wide"
  }),
  day: Ce({
    values: Bdt,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: Udt,
    defaultWidth: "any",
    formattingValues: Xdt,
    defaultFormattingWidth: "wide"
  })
}, Kdt = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i, Ydt = /\d+/i, Qdt = {
  narrow: /^((до )?н\.?\s?э\.?)/i,
  abbreviated: /^((до )?н\.?\s?э\.?)/i,
  wide: /^(до нашей эры|нашей эры|наша эра)/i
}, Jdt = {
  any: [/^д/i, /^н/i]
}, Zdt = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
  wide: /^[1234](-?[ыои]?й?)? квартал/i
}, eft = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, tft = {
  narrow: /^[яфмаисонд]/i,
  abbreviated: /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
  wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i
}, nft = {
  narrow: [
    /^я/i,
    /^ф/i,
    /^м/i,
    /^а/i,
    /^м/i,
    /^и/i,
    /^и/i,
    /^а/i,
    /^с/i,
    /^о/i,
    /^н/i,
    /^я/i
  ],
  any: [
    /^я/i,
    /^ф/i,
    /^мар/i,
    /^ап/i,
    /^ма[йя]/i,
    /^июн/i,
    /^июл/i,
    /^ав/i,
    /^с/i,
    /^о/i,
    /^н/i,
    /^д/i
  ]
}, rft = {
  narrow: /^[впсч]/i,
  short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
  abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
  wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i
}, aft = {
  narrow: [/^в/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^в[ос]/i, /^п[он]/i, /^в/i, /^ср/i, /^ч/i, /^п[ят]/i, /^с[уб]/i]
}, oft = {
  narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
  abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
  wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i
}, ift = {
  any: {
    am: /^дп/i,
    pm: /^пп/i,
    midnight: /^полн/i,
    noon: /^полд/i,
    morning: /^у/i,
    afternoon: /^д[ен]/i,
    evening: /^в/i,
    night: /^н/i
  }
}, lft = {
  ordinalNumber: Fn({
    matchPattern: Kdt,
    parsePattern: Ydt,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: Qdt,
    defaultMatchWidth: "wide",
    parsePatterns: Jdt,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: Zdt,
    defaultMatchWidth: "wide",
    parsePatterns: eft,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: tft,
    defaultMatchWidth: "wide",
    parsePatterns: nft,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: rft,
    defaultMatchWidth: "wide",
    parsePatterns: aft,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: oft,
    defaultMatchWidth: "wide",
    parsePatterns: ift,
    defaultParseWidth: "any"
  })
}, sft = {
  code: "ru",
  formatDistance: Adt,
  formatLong: zdt,
  formatRelative: Hdt,
  localize: qdt,
  match: lft,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, uft = {
  lessThanXSeconds: {
    one: "unnit go ovtta sekundda",
    other: "unnit go {{count}} sekundda"
  },
  xSeconds: {
    one: "sekundda",
    other: "{{count}} sekundda"
  },
  halfAMinute: "bealle minuhta",
  lessThanXMinutes: {
    one: "unnit go bealle minuhta",
    other: "unnit go {{count}} minuhta"
  },
  xMinutes: {
    one: "minuhta",
    other: "{{count}} minuhta"
  },
  aboutXHours: {
    one: "sullii ovtta diimmu",
    other: "sullii {{count}} diimmu"
  },
  xHours: {
    one: "diimmu",
    other: "{{count}} diimmu"
  },
  xDays: {
    one: "beaivvi",
    other: "{{count}} beaivvi"
  },
  aboutXWeeks: {
    one: "sullii ovtta vahku",
    other: "sullii {{count}} vahku"
  },
  xWeeks: {
    one: "vahku",
    other: "{{count}} vahku"
  },
  aboutXMonths: {
    one: "sullii ovtta mánu",
    other: "sullii {{count}} mánu"
  },
  xMonths: {
    one: "mánu",
    other: "{{count}} mánu"
  },
  aboutXYears: {
    one: "sullii ovtta jagi",
    other: "sullii {{count}} jagi"
  },
  xYears: {
    one: "jagi",
    other: "{{count}} jagi"
  },
  overXYears: {
    one: "guhkit go jagi",
    other: "guhkit go {{count}} jagi"
  },
  almostXYears: {
    one: "measta jagi",
    other: "measta {{count}} jagi"
  }
}, cft = (e, t, r) => {
  let a;
  const i = uft[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? "geahčen " + a : a + " áigi" : a;
}, dft = {
  full: "EEEE MMMM d. 'b.' y",
  long: "MMMM d. 'b.' y",
  medium: "MMM d. 'b.' y",
  short: "dd.MM.y"
}, fft = {
  full: "'dii.' HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, mft = {
  full: "{{date}} 'dii.' {{time}}",
  long: "{{date}} 'dii.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, hft = {
  date: Ke({
    formats: dft,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: fft,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: mft,
    defaultWidth: "full"
  })
}, pft = {
  lastWeek: "'ovddit' eeee 'dii.' p",
  yesterday: "'ikte dii.' p",
  today: "'odne dii.' p",
  tomorrow: "'ihtin dii.' p",
  nextWeek: "EEEE 'dii.' p",
  other: "P"
}, gft = (e, t, r, a) => pft[e], vft = {
  narrow: ["o.Kr.", "m.Kr."],
  abbreviated: ["o.Kr.", "m.Kr."],
  wide: ["ovdal Kristusa", "maŋŋel Kristusa"]
}, bft = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. kvartála", "2. kvartála", "3. kvartála", "4. kvartála"]
}, yft = {
  narrow: ["O", "G", "N", "C", "M", "G", "S", "B", "Č", "G", "S", "J"],
  abbreviated: [
    "ođđa",
    "guov",
    "njuk",
    "cuo",
    "mies",
    "geas",
    "suoi",
    "borg",
    "čakč",
    "golg",
    "skáb",
    "juov"
  ],
  wide: [
    "ođđajagemánnu",
    "guovvamánnu",
    "njukčamánnu",
    "cuoŋománnu",
    "miessemánnu",
    "geassemánnu",
    "suoidnemánnu",
    "borgemánnu",
    "čakčamánnu",
    "golggotmánnu",
    "skábmamánnu",
    "juovlamánnu"
  ]
}, wft = {
  narrow: ["S", "V", "M", "G", "D", "B", "L"],
  short: ["sotn", "vuos", "maŋ", "gask", "duor", "bear", "láv"],
  abbreviated: ["sotn", "vuos", "maŋ", "gask", "duor", "bear", "láv"],
  wide: [
    "sotnabeaivi",
    "vuossárga",
    "maŋŋebárga",
    "gaskavahkku",
    "duorastat",
    "bearjadat",
    "lávvardat"
  ]
}, Sft = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "gaskaidja",
    noon: "gaskabeaivi",
    morning: "iđđes",
    afternoon: "maŋŋel gaska.",
    evening: "eahkes",
    night: "ihkku"
  },
  abbreviated: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "gaskaidja",
    noon: "gaskabeaivvi",
    morning: "iđđes",
    afternoon: "maŋŋel gaskabea.",
    evening: "eahkes",
    night: "ihkku"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "gaskaidja",
    noon: "gaskabeavvi",
    morning: "iđđes",
    afternoon: "maŋŋel gaskabeaivvi",
    evening: "eahkes",
    night: "ihkku"
  }
}, Cft = (e, t) => Number(e) + ".", xft = {
  ordinalNumber: Cft,
  era: Ce({
    values: vft,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: bft,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: yft,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: wft,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: Sft,
    defaultWidth: "wide"
  })
}, Eft = /^(\d+)\.?/i, Pft = /\d+/i, kft = {
  narrow: /^(o\.? ?Kr\.?|m\.? ?Kr\.?)/i,
  abbreviated: /^(o\.? ?Kr\.?|m\.? ?Kr\.?)/i,
  wide: /^(ovdal Kristusa|ovdal min áiggi|maŋŋel Kristusa|min áigi)/i
}, Mft = {
  any: [/^o/i, /^m/i]
}, Oft = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? kvartála/i
}, Tft = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Rft = {
  narrow: /^[ogncmsbčj]/i,
  abbreviated: /^(ođđa|guov|njuk|cuo|mies|geas|suoi|borg|čakč|golg|skáb|juov)\.?/i,
  wide: /^(ođđajagemánnu|guovvamánnu|njukčamánnu|cuoŋománnu|miessemánnu|geassemánnu|suoidnemánnu|borgemánnu|čakčamánnu|golggotmánnu|skábmamánnu|juovlamánnu)/i
}, Aft = {
  narrow: [
    /^o/i,
    /^g/i,
    /^n/i,
    /^c/i,
    /^m/i,
    /^g/i,
    /^s/i,
    /^b/i,
    /^č/i,
    /^g/i,
    /^s/i,
    /^j/i
  ],
  any: [
    /^o/i,
    /^gu/i,
    /^n/i,
    /^c/i,
    /^m/i,
    /^ge/i,
    /^su/i,
    /^b/i,
    /^č/i,
    /^go/i,
    /^sk/i,
    /^j/i
  ]
}, Nft = {
  narrow: /^[svmgdbl]/i,
  short: /^(sotn|vuos|maŋ|gask|duor|bear|láv)/i,
  abbreviated: /^(sotn|vuos|maŋ|gask|duor|bear|láv)/i,
  wide: /^(sotnabeaivi|vuossárga|maŋŋebárga|gaskavahkku|duorastat|bearjadat|lávvardat)/i
}, Dft = {
  any: [/^s/i, /^v/i, /^m/i, /^g/i, /^d/i, /^b/i, /^l/i]
}, $ft = {
  narrow: /^(gaskaidja|gaskabeaivvi|(på) (iđđes|maŋŋel gaskabeaivvi|eahkes|ihkku)|[ap])/i,
  any: /^([ap]\.?\s?m\.?|gaskaidja|gaskabeaivvi|(på) (iđđes|maŋŋel gaskabeaivvi|eahkes|ihkku))/i
}, zft = {
  any: {
    am: /^a(\.?\s?m\.?)?$/i,
    pm: /^p(\.?\s?m\.?)?$/i,
    midnight: /^gaskai/i,
    noon: /^gaskab/i,
    morning: /iđđes/i,
    afternoon: /maŋŋel gaskabeaivvi/i,
    evening: /eahkes/i,
    night: /ihkku/i
  }
}, jft = {
  ordinalNumber: Fn({
    matchPattern: Eft,
    parsePattern: Pft,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: kft,
    defaultMatchWidth: "wide",
    parsePatterns: Mft,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: Oft,
    defaultMatchWidth: "wide",
    parsePatterns: Tft,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: Rft,
    defaultMatchWidth: "wide",
    parsePatterns: Aft,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: Nft,
    defaultMatchWidth: "wide",
    parsePatterns: Dft,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: $ft,
    defaultMatchWidth: "any",
    parsePatterns: zft,
    defaultParseWidth: "any"
  })
}, Ift = {
  code: "se",
  formatDistance: cft,
  formatLong: hft,
  formatRelative: gft,
  localize: xft,
  match: jft,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
function Lft(e, t) {
  return t === 1 && e.one ? e.one : t >= 2 && t <= 4 && e.twoFour ? e.twoFour : e.other;
}
function OA(e, t, r) {
  return Lft(e, t)[r].replace("{{count}}", String(t));
}
function Hft(e) {
  return ["lessThan", "about", "over", "almost"].filter(
    function(r) {
      return !!e.match(new RegExp("^" + r));
    }
  )[0];
}
function TA(e) {
  let t = "";
  return e === "almost" && (t = "takmer"), e === "about" && (t = "približne"), t.length > 0 ? t + " " : "";
}
function RA(e) {
  let t = "";
  return e === "lessThan" && (t = "menej než"), e === "over" && (t = "viac než"), t.length > 0 ? t + " " : "";
}
function Fft(e) {
  return e.charAt(0).toLowerCase() + e.slice(1);
}
const Wft = {
  xSeconds: {
    one: {
      present: "sekunda",
      past: "sekundou",
      future: "sekundu"
    },
    twoFour: {
      present: "{{count}} sekundy",
      past: "{{count}} sekundami",
      future: "{{count}} sekundy"
    },
    other: {
      present: "{{count}} sekúnd",
      past: "{{count}} sekundami",
      future: "{{count}} sekúnd"
    }
  },
  halfAMinute: {
    other: {
      present: "pol minúty",
      past: "pol minútou",
      future: "pol minúty"
    }
  },
  xMinutes: {
    one: {
      present: "minúta",
      past: "minútou",
      future: "minútu"
    },
    twoFour: {
      present: "{{count}} minúty",
      past: "{{count}} minútami",
      future: "{{count}} minúty"
    },
    other: {
      present: "{{count}} minút",
      past: "{{count}} minútami",
      future: "{{count}} minút"
    }
  },
  xHours: {
    one: {
      present: "hodina",
      past: "hodinou",
      future: "hodinu"
    },
    twoFour: {
      present: "{{count}} hodiny",
      past: "{{count}} hodinami",
      future: "{{count}} hodiny"
    },
    other: {
      present: "{{count}} hodín",
      past: "{{count}} hodinami",
      future: "{{count}} hodín"
    }
  },
  xDays: {
    one: {
      present: "deň",
      past: "dňom",
      future: "deň"
    },
    twoFour: {
      present: "{{count}} dni",
      past: "{{count}} dňami",
      future: "{{count}} dni"
    },
    other: {
      present: "{{count}} dní",
      past: "{{count}} dňami",
      future: "{{count}} dní"
    }
  },
  xWeeks: {
    one: {
      present: "týždeň",
      past: "týždňom",
      future: "týždeň"
    },
    twoFour: {
      present: "{{count}} týždne",
      past: "{{count}} týždňami",
      future: "{{count}} týždne"
    },
    other: {
      present: "{{count}} týždňov",
      past: "{{count}} týždňami",
      future: "{{count}} týždňov"
    }
  },
  xMonths: {
    one: {
      present: "mesiac",
      past: "mesiacom",
      future: "mesiac"
    },
    twoFour: {
      present: "{{count}} mesiace",
      past: "{{count}} mesiacmi",
      future: "{{count}} mesiace"
    },
    other: {
      present: "{{count}} mesiacov",
      past: "{{count}} mesiacmi",
      future: "{{count}} mesiacov"
    }
  },
  xYears: {
    one: {
      present: "rok",
      past: "rokom",
      future: "rok"
    },
    twoFour: {
      present: "{{count}} roky",
      past: "{{count}} rokmi",
      future: "{{count}} roky"
    },
    other: {
      present: "{{count}} rokov",
      past: "{{count}} rokmi",
      future: "{{count}} rokov"
    }
  }
}, Vft = (e, t, r) => {
  const a = Hft(e) || "", i = Fft(e.substring(a.length)), c = Wft[i];
  return r?.addSuffix ? r.comparison && r.comparison > 0 ? TA(a) + "o " + RA(a) + OA(c, t, "future") : TA(a) + "pred " + RA(a) + OA(c, t, "past") : TA(a) + RA(a) + OA(c, t, "present");
}, _ft = {
  full: "EEEE d. MMMM y",
  long: "d. MMMM y",
  medium: "d. M. y",
  short: "d. M. y"
}, Bft = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, Uft = {
  full: "{{date}}, {{time}}",
  long: "{{date}}, {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}} {{time}}"
}, Xft = {
  date: Ke({
    formats: _ft,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: Bft,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: Uft,
    defaultWidth: "full"
  })
}, MI = [
  "nedeľu",
  "pondelok",
  "utorok",
  "stredu",
  "štvrtok",
  "piatok",
  "sobotu"
];
function Gft(e) {
  const t = MI[e];
  switch (e) {
    case 0:
    /* Sun */
    case 3:
    /* Wed */
    case 6:
      return "'minulú " + t + " o' p";
    default:
      return "'minulý' eeee 'o' p";
  }
}
function iU(e) {
  const t = MI[e];
  return e === 4 ? "'vo' eeee 'o' p" : "'v " + t + " o' p";
}
function qft(e) {
  const t = MI[e];
  switch (e) {
    case 0:
    /* Sun */
    case 4:
    /* Wed */
    case 6:
      return "'budúcu " + t + " o' p";
    default:
      return "'budúci' eeee 'o' p";
  }
}
const Kft = {
  lastWeek: (e, t, r) => {
    const a = e.getDay();
    return su(e, t, r) ? iU(a) : Gft(a);
  },
  yesterday: "'včera o' p",
  today: "'dnes o' p",
  tomorrow: "'zajtra o' p",
  nextWeek: (e, t, r) => {
    const a = e.getDay();
    return su(e, t, r) ? iU(a) : qft(a);
  },
  other: "P"
}, Yft = (e, t, r, a) => {
  const i = Kft[e];
  return typeof i == "function" ? i(t, r, a) : i;
}, Qft = {
  narrow: ["pred Kr.", "po Kr."],
  abbreviated: ["pred Kr.", "po Kr."],
  wide: ["pred Kristom", "po Kristovi"]
}, Jft = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. štvrťrok", "2. štvrťrok", "3. štvrťrok", "4. štvrťrok"]
}, Zft = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan",
    "feb",
    "mar",
    "apr",
    "máj",
    "jún",
    "júl",
    "aug",
    "sep",
    "okt",
    "nov",
    "dec"
  ],
  wide: [
    "január",
    "február",
    "marec",
    "apríl",
    "máj",
    "jún",
    "júl",
    "august",
    "september",
    "október",
    "november",
    "december"
  ]
}, emt = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan",
    "feb",
    "mar",
    "apr",
    "máj",
    "jún",
    "júl",
    "aug",
    "sep",
    "okt",
    "nov",
    "dec"
  ],
  wide: [
    "januára",
    "februára",
    "marca",
    "apríla",
    "mája",
    "júna",
    "júla",
    "augusta",
    "septembra",
    "októbra",
    "novembra",
    "decembra"
  ]
}, tmt = {
  narrow: ["n", "p", "u", "s", "š", "p", "s"],
  short: ["ne", "po", "ut", "st", "št", "pi", "so"],
  abbreviated: ["ne", "po", "ut", "st", "št", "pi", "so"],
  wide: [
    "nedeľa",
    "pondelok",
    "utorok",
    "streda",
    "štvrtok",
    "piatok",
    "sobota"
  ]
}, nmt = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "poln.",
    noon: "pol.",
    morning: "ráno",
    afternoon: "pop.",
    evening: "več.",
    night: "noc"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "poln.",
    noon: "pol.",
    morning: "ráno",
    afternoon: "popol.",
    evening: "večer",
    night: "noc"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "polnoc",
    noon: "poludnie",
    morning: "ráno",
    afternoon: "popoludnie",
    evening: "večer",
    night: "noc"
  }
}, rmt = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "o poln.",
    noon: "nap.",
    morning: "ráno",
    afternoon: "pop.",
    evening: "več.",
    night: "v n."
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "o poln.",
    noon: "napol.",
    morning: "ráno",
    afternoon: "popol.",
    evening: "večer",
    night: "v noci"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "o polnoci",
    noon: "napoludnie",
    morning: "ráno",
    afternoon: "popoludní",
    evening: "večer",
    night: "v noci"
  }
}, amt = (e, t) => Number(e) + ".", omt = {
  ordinalNumber: amt,
  era: Ce({
    values: Qft,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: Jft,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: Zft,
    defaultWidth: "wide",
    formattingValues: emt,
    defaultFormattingWidth: "wide"
  }),
  day: Ce({
    values: tmt,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: nmt,
    defaultWidth: "wide",
    formattingValues: rmt,
    defaultFormattingWidth: "wide"
  })
}, imt = /^(\d+)\.?/i, lmt = /\d+/i, smt = {
  narrow: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
  abbreviated: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
  wide: /^(pred Kristom|pred na[šs][íi]m letopo[čc]tom|po Kristovi|n[áa][šs]ho letopo[čc]tu)/i
}, umt = {
  any: [/^pr/i, /^(po|n)/i]
}, cmt = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]\. [šs]tvr[ťt]rok/i
}, dmt = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, fmt = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|m[áa]j|j[úu]n|j[úu]l|aug|sep|okt|nov|dec)/i,
  wide: /^(janu[áa]ra?|febru[áa]ra?|(marec|marca)|apr[íi]la?|m[áa]ja?|j[úu]na?|j[úu]la?|augusta?|(september|septembra)|(okt[óo]ber|okt[óo]bra)|(november|novembra)|(december|decembra))/i
}, mmt = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^m[áa]j/i,
    /^j[úu]n/i,
    /^j[úu]l/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, hmt = {
  narrow: /^[npusšp]/i,
  short: /^(ne|po|ut|st|št|pi|so)/i,
  abbreviated: /^(ne|po|ut|st|št|pi|so)/i,
  wide: /^(nede[ľl]a|pondelok|utorok|streda|[šs]tvrtok|piatok|sobota])/i
}, pmt = {
  narrow: [/^n/i, /^p/i, /^u/i, /^s/i, /^š/i, /^p/i, /^s/i],
  any: [/^n/i, /^po/i, /^u/i, /^st/i, /^(št|stv)/i, /^pi/i, /^so/i]
}, gmt = {
  narrow: /^(am|pm|(o )?poln\.?|(nap\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]\.?|(v n\.?|noc))/i,
  abbreviated: /^(am|pm|(o )?poln\.?|(napol\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]er|(v )?noci?)/i,
  any: /^(am|pm|(o )?polnoci?|(na)?poludnie|r[áa]no|popoludn(ie|í|i)|ve[čc]er|(v )?noci?)/i
}, vmt = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /poln/i,
    noon: /^(nap|(na)?pol(\.|u))/i,
    morning: /^r[áa]no/i,
    afternoon: /^pop/i,
    evening: /^ve[čc]/i,
    night: /^(noc|v n\.)/i
  }
}, bmt = {
  ordinalNumber: Fn({
    matchPattern: imt,
    parsePattern: lmt,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: smt,
    defaultMatchWidth: "wide",
    parsePatterns: umt,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: cmt,
    defaultMatchWidth: "wide",
    parsePatterns: dmt,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: fmt,
    defaultMatchWidth: "wide",
    parsePatterns: mmt,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: hmt,
    defaultMatchWidth: "wide",
    parsePatterns: pmt,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: gmt,
    defaultMatchWidth: "any",
    parsePatterns: vmt,
    defaultParseWidth: "any"
  })
}, ymt = {
  code: "sk",
  formatDistance: Vft,
  formatLong: Xft,
  formatRelative: Yft,
  localize: omt,
  match: bmt,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
function wmt(e) {
  return e.one !== void 0;
}
const Smt = {
  lessThanXSeconds: {
    present: {
      one: "manj kot {{count}} sekunda",
      two: "manj kot {{count}} sekundi",
      few: "manj kot {{count}} sekunde",
      other: "manj kot {{count}} sekund"
    },
    past: {
      one: "manj kot {{count}} sekundo",
      two: "manj kot {{count}} sekundama",
      few: "manj kot {{count}} sekundami",
      other: "manj kot {{count}} sekundami"
    },
    future: {
      one: "manj kot {{count}} sekundo",
      two: "manj kot {{count}} sekundi",
      few: "manj kot {{count}} sekunde",
      other: "manj kot {{count}} sekund"
    }
  },
  xSeconds: {
    present: {
      one: "{{count}} sekunda",
      two: "{{count}} sekundi",
      few: "{{count}} sekunde",
      other: "{{count}} sekund"
    },
    past: {
      one: "{{count}} sekundo",
      two: "{{count}} sekundama",
      few: "{{count}} sekundami",
      other: "{{count}} sekundami"
    },
    future: {
      one: "{{count}} sekundo",
      two: "{{count}} sekundi",
      few: "{{count}} sekunde",
      other: "{{count}} sekund"
    }
  },
  halfAMinute: "pol minute",
  lessThanXMinutes: {
    present: {
      one: "manj kot {{count}} minuta",
      two: "manj kot {{count}} minuti",
      few: "manj kot {{count}} minute",
      other: "manj kot {{count}} minut"
    },
    past: {
      one: "manj kot {{count}} minuto",
      two: "manj kot {{count}} minutama",
      few: "manj kot {{count}} minutami",
      other: "manj kot {{count}} minutami"
    },
    future: {
      one: "manj kot {{count}} minuto",
      two: "manj kot {{count}} minuti",
      few: "manj kot {{count}} minute",
      other: "manj kot {{count}} minut"
    }
  },
  xMinutes: {
    present: {
      one: "{{count}} minuta",
      two: "{{count}} minuti",
      few: "{{count}} minute",
      other: "{{count}} minut"
    },
    past: {
      one: "{{count}} minuto",
      two: "{{count}} minutama",
      few: "{{count}} minutami",
      other: "{{count}} minutami"
    },
    future: {
      one: "{{count}} minuto",
      two: "{{count}} minuti",
      few: "{{count}} minute",
      other: "{{count}} minut"
    }
  },
  aboutXHours: {
    present: {
      one: "približno {{count}} ura",
      two: "približno {{count}} uri",
      few: "približno {{count}} ure",
      other: "približno {{count}} ur"
    },
    past: {
      one: "približno {{count}} uro",
      two: "približno {{count}} urama",
      few: "približno {{count}} urami",
      other: "približno {{count}} urami"
    },
    future: {
      one: "približno {{count}} uro",
      two: "približno {{count}} uri",
      few: "približno {{count}} ure",
      other: "približno {{count}} ur"
    }
  },
  xHours: {
    present: {
      one: "{{count}} ura",
      two: "{{count}} uri",
      few: "{{count}} ure",
      other: "{{count}} ur"
    },
    past: {
      one: "{{count}} uro",
      two: "{{count}} urama",
      few: "{{count}} urami",
      other: "{{count}} urami"
    },
    future: {
      one: "{{count}} uro",
      two: "{{count}} uri",
      few: "{{count}} ure",
      other: "{{count}} ur"
    }
  },
  xDays: {
    present: {
      one: "{{count}} dan",
      two: "{{count}} dni",
      few: "{{count}} dni",
      other: "{{count}} dni"
    },
    past: {
      one: "{{count}} dnem",
      two: "{{count}} dnevoma",
      few: "{{count}} dnevi",
      other: "{{count}} dnevi"
    },
    future: {
      one: "{{count}} dan",
      two: "{{count}} dni",
      few: "{{count}} dni",
      other: "{{count}} dni"
    }
  },
  // no tenses for weeks?
  aboutXWeeks: {
    one: "približno {{count}} teden",
    two: "približno {{count}} tedna",
    few: "približno {{count}} tedne",
    other: "približno {{count}} tednov"
  },
  // no tenses for weeks?
  xWeeks: {
    one: "{{count}} teden",
    two: "{{count}} tedna",
    few: "{{count}} tedne",
    other: "{{count}} tednov"
  },
  aboutXMonths: {
    present: {
      one: "približno {{count}} mesec",
      two: "približno {{count}} meseca",
      few: "približno {{count}} mesece",
      other: "približno {{count}} mesecev"
    },
    past: {
      one: "približno {{count}} mesecem",
      two: "približno {{count}} mesecema",
      few: "približno {{count}} meseci",
      other: "približno {{count}} meseci"
    },
    future: {
      one: "približno {{count}} mesec",
      two: "približno {{count}} meseca",
      few: "približno {{count}} mesece",
      other: "približno {{count}} mesecev"
    }
  },
  xMonths: {
    present: {
      one: "{{count}} mesec",
      two: "{{count}} meseca",
      few: "{{count}} meseci",
      other: "{{count}} mesecev"
    },
    past: {
      one: "{{count}} mesecem",
      two: "{{count}} mesecema",
      few: "{{count}} meseci",
      other: "{{count}} meseci"
    },
    future: {
      one: "{{count}} mesec",
      two: "{{count}} meseca",
      few: "{{count}} mesece",
      other: "{{count}} mesecev"
    }
  },
  aboutXYears: {
    present: {
      one: "približno {{count}} leto",
      two: "približno {{count}} leti",
      few: "približno {{count}} leta",
      other: "približno {{count}} let"
    },
    past: {
      one: "približno {{count}} letom",
      two: "približno {{count}} letoma",
      few: "približno {{count}} leti",
      other: "približno {{count}} leti"
    },
    future: {
      one: "približno {{count}} leto",
      two: "približno {{count}} leti",
      few: "približno {{count}} leta",
      other: "približno {{count}} let"
    }
  },
  xYears: {
    present: {
      one: "{{count}} leto",
      two: "{{count}} leti",
      few: "{{count}} leta",
      other: "{{count}} let"
    },
    past: {
      one: "{{count}} letom",
      two: "{{count}} letoma",
      few: "{{count}} leti",
      other: "{{count}} leti"
    },
    future: {
      one: "{{count}} leto",
      two: "{{count}} leti",
      few: "{{count}} leta",
      other: "{{count}} let"
    }
  },
  overXYears: {
    present: {
      one: "več kot {{count}} leto",
      two: "več kot {{count}} leti",
      few: "več kot {{count}} leta",
      other: "več kot {{count}} let"
    },
    past: {
      one: "več kot {{count}} letom",
      two: "več kot {{count}} letoma",
      few: "več kot {{count}} leti",
      other: "več kot {{count}} leti"
    },
    future: {
      one: "več kot {{count}} leto",
      two: "več kot {{count}} leti",
      few: "več kot {{count}} leta",
      other: "več kot {{count}} let"
    }
  },
  almostXYears: {
    present: {
      one: "skoraj {{count}} leto",
      two: "skoraj {{count}} leti",
      few: "skoraj {{count}} leta",
      other: "skoraj {{count}} let"
    },
    past: {
      one: "skoraj {{count}} letom",
      two: "skoraj {{count}} letoma",
      few: "skoraj {{count}} leti",
      other: "skoraj {{count}} leti"
    },
    future: {
      one: "skoraj {{count}} leto",
      two: "skoraj {{count}} leti",
      few: "skoraj {{count}} leta",
      other: "skoraj {{count}} let"
    }
  }
};
function Cmt(e) {
  switch (e % 100) {
    case 1:
      return "one";
    case 2:
      return "two";
    case 3:
    case 4:
      return "few";
    default:
      return "other";
  }
}
const xmt = (e, t, r) => {
  let a = "", i = "present";
  r?.addSuffix && (r.comparison && r.comparison > 0 ? (i = "future", a = "čez ") : (i = "past", a = "pred "));
  const c = Smt[e];
  if (typeof c == "string")
    a += c;
  else {
    const d = Cmt(t);
    wmt(c) ? a += c[d].replace("{{count}}", String(t)) : a += c[i][d].replace("{{count}}", String(t));
  }
  return a;
}, Emt = {
  full: "EEEE, dd. MMMM y",
  long: "dd. MMMM y",
  medium: "d. MMM y",
  short: "d. MM. yy"
}, Pmt = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, kmt = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Mmt = {
  date: Ke({
    formats: Emt,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: Pmt,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: kmt,
    defaultWidth: "full"
  })
}, Omt = {
  lastWeek: (e) => {
    switch (e.getDay()) {
      case 0:
        return "'prejšnjo nedeljo ob' p";
      case 3:
        return "'prejšnjo sredo ob' p";
      case 6:
        return "'prejšnjo soboto ob' p";
      default:
        return "'prejšnji' EEEE 'ob' p";
    }
  },
  yesterday: "'včeraj ob' p",
  today: "'danes ob' p",
  tomorrow: "'jutri ob' p",
  nextWeek: (e) => {
    switch (e.getDay()) {
      case 0:
        return "'naslednjo nedeljo ob' p";
      case 3:
        return "'naslednjo sredo ob' p";
      case 6:
        return "'naslednjo soboto ob' p";
      default:
        return "'naslednji' EEEE 'ob' p";
    }
  },
  other: "P"
}, Tmt = (e, t, r, a) => {
  const i = Omt[e];
  return typeof i == "function" ? i(t) : i;
}, Rmt = {
  narrow: ["pr. n. št.", "po n. št."],
  abbreviated: ["pr. n. št.", "po n. št."],
  wide: ["pred našim štetjem", "po našem štetju"]
}, Amt = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. čet.", "2. čet.", "3. čet.", "4. čet."],
  wide: ["1. četrtletje", "2. četrtletje", "3. četrtletje", "4. četrtletje"]
}, Nmt = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan.",
    "feb.",
    "mar.",
    "apr.",
    "maj",
    "jun.",
    "jul.",
    "avg.",
    "sep.",
    "okt.",
    "nov.",
    "dec."
  ],
  wide: [
    "januar",
    "februar",
    "marec",
    "april",
    "maj",
    "junij",
    "julij",
    "avgust",
    "september",
    "oktober",
    "november",
    "december"
  ]
}, Dmt = {
  narrow: ["n", "p", "t", "s", "č", "p", "s"],
  short: ["ned.", "pon.", "tor.", "sre.", "čet.", "pet.", "sob."],
  abbreviated: ["ned.", "pon.", "tor.", "sre.", "čet.", "pet.", "sob."],
  wide: [
    "nedelja",
    "ponedeljek",
    "torek",
    "sreda",
    "četrtek",
    "petek",
    "sobota"
  ]
}, $mt = {
  narrow: {
    am: "d",
    pm: "p",
    midnight: "24.00",
    noon: "12.00",
    morning: "j",
    afternoon: "p",
    evening: "v",
    night: "n"
  },
  abbreviated: {
    am: "dop.",
    pm: "pop.",
    midnight: "poln.",
    noon: "pold.",
    morning: "jut.",
    afternoon: "pop.",
    evening: "več.",
    night: "noč"
  },
  wide: {
    am: "dop.",
    pm: "pop.",
    midnight: "polnoč",
    noon: "poldne",
    morning: "jutro",
    afternoon: "popoldne",
    evening: "večer",
    night: "noč"
  }
}, zmt = {
  narrow: {
    am: "d",
    pm: "p",
    midnight: "24.00",
    noon: "12.00",
    morning: "zj",
    afternoon: "p",
    evening: "zv",
    night: "po"
  },
  abbreviated: {
    am: "dop.",
    pm: "pop.",
    midnight: "opoln.",
    noon: "opold.",
    morning: "zjut.",
    afternoon: "pop.",
    evening: "zveč.",
    night: "ponoči"
  },
  wide: {
    am: "dop.",
    pm: "pop.",
    midnight: "opolnoči",
    noon: "opoldne",
    morning: "zjutraj",
    afternoon: "popoldan",
    evening: "zvečer",
    night: "ponoči"
  }
}, jmt = (e, t) => Number(e) + ".", Imt = {
  ordinalNumber: jmt,
  era: Ce({
    values: Rmt,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: Amt,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: Nmt,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: Dmt,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: $mt,
    defaultWidth: "wide",
    formattingValues: zmt,
    defaultFormattingWidth: "wide"
  })
}, Lmt = /^(\d+)\./i, Hmt = /\d+/i, Fmt = {
  abbreviated: /^(pr\. n\. št\.|po n\. št\.)/i,
  wide: /^(pred Kristusom|pred na[sš]im [sš]tetjem|po Kristusu|po na[sš]em [sš]tetju|na[sš]ega [sš]tetja)/i
}, Wmt = {
  any: [/^pr/i, /^(po|na[sš]em)/i]
}, Vmt = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\.\s?[čc]et\.?/i,
  wide: /^[1234]\. [čc]etrtletje/i
}, _mt = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Bmt = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan\.|feb\.|mar\.|apr\.|maj|jun\.|jul\.|avg\.|sep\.|okt\.|nov\.|dec\.)/i,
  wide: /^(januar|februar|marec|april|maj|junij|julij|avgust|september|oktober|november|december)/i
}, Umt = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  abbreviated: [
    /^ja/i,
    /^fe/i,
    /^mar/i,
    /^ap/i,
    /^maj/i,
    /^jun/i,
    /^jul/i,
    /^av/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  wide: [
    /^ja/i,
    /^fe/i,
    /^mar/i,
    /^ap/i,
    /^maj/i,
    /^jun/i,
    /^jul/i,
    /^av/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Xmt = {
  narrow: /^[nptsčc]/i,
  short: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
  abbreviated: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
  wide: /^(nedelja|ponedeljek|torek|sreda|[cč]etrtek|petek|sobota)/i
}, Gmt = {
  narrow: [/^n/i, /^p/i, /^t/i, /^s/i, /^[cč]/i, /^p/i, /^s/i],
  any: [/^n/i, /^po/i, /^t/i, /^sr/i, /^[cč]/i, /^pe/i, /^so/i]
}, qmt = {
  narrow: /^(d|po?|z?v|n|z?j|24\.00|12\.00)/i,
  any: /^(dop\.|pop\.|o?poln(\.|o[cč]i?)|o?pold(\.|ne)|z?ve[cč](\.|er)|(po)?no[cč]i?|popold(ne|an)|jut(\.|ro)|zjut(\.|raj))/i
}, Kmt = {
  narrow: {
    am: /^d/i,
    pm: /^p/i,
    midnight: /^24/i,
    noon: /^12/i,
    morning: /^(z?j)/i,
    afternoon: /^p/i,
    evening: /^(z?v)/i,
    night: /^(n|po)/i
  },
  any: {
    am: /^dop\./i,
    pm: /^pop\./i,
    midnight: /^o?poln/i,
    noon: /^o?pold/i,
    morning: /j/i,
    afternoon: /^pop\./i,
    evening: /^z?ve/i,
    night: /(po)?no/i
  }
}, Ymt = {
  ordinalNumber: Fn({
    matchPattern: Lmt,
    parsePattern: Hmt,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: Fmt,
    defaultMatchWidth: "wide",
    parsePatterns: Wmt,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: Vmt,
    defaultMatchWidth: "wide",
    parsePatterns: _mt,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: Bmt,
    defaultMatchWidth: "wide",
    parsePatterns: Umt,
    defaultParseWidth: "wide"
  }),
  day: Ee({
    matchPatterns: Xmt,
    defaultMatchWidth: "wide",
    parsePatterns: Gmt,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: qmt,
    defaultMatchWidth: "any",
    parsePatterns: Kmt,
    defaultParseWidth: "any"
  })
}, Qmt = {
  code: "sl",
  formatDistance: xmt,
  formatLong: Mmt,
  formatRelative: Tmt,
  localize: Imt,
  match: Ymt,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, Jmt = {
  lessThanXSeconds: {
    one: "më pak se një sekondë",
    other: "më pak se {{count}} sekonda"
  },
  xSeconds: {
    one: "1 sekondë",
    other: "{{count}} sekonda"
  },
  halfAMinute: "gjysëm minuti",
  lessThanXMinutes: {
    one: "më pak se një minute",
    other: "më pak se {{count}} minuta"
  },
  xMinutes: {
    one: "1 minutë",
    other: "{{count}} minuta"
  },
  aboutXHours: {
    one: "rreth 1 orë",
    other: "rreth {{count}} orë"
  },
  xHours: {
    one: "1 orë",
    other: "{{count}} orë"
  },
  xDays: {
    one: "1 ditë",
    other: "{{count}} ditë"
  },
  aboutXWeeks: {
    one: "rreth 1 javë",
    other: "rreth {{count}} javë"
  },
  xWeeks: {
    one: "1 javë",
    other: "{{count}} javë"
  },
  aboutXMonths: {
    one: "rreth 1 muaj",
    other: "rreth {{count}} muaj"
  },
  xMonths: {
    one: "1 muaj",
    other: "{{count}} muaj"
  },
  aboutXYears: {
    one: "rreth 1 vit",
    other: "rreth {{count}} vite"
  },
  xYears: {
    one: "1 vit",
    other: "{{count}} vite"
  },
  overXYears: {
    one: "mbi 1 vit",
    other: "mbi {{count}} vite"
  },
  almostXYears: {
    one: "pothuajse 1 vit",
    other: "pothuajse {{count}} vite"
  }
}, Zmt = (e, t, r) => {
  let a;
  const i = Jmt[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? "në " + a : a + " më parë" : a;
}, eht = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, tht = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, nht = {
  full: "{{date}} 'në' {{time}}",
  long: "{{date}} 'në' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, rht = {
  date: Ke({
    formats: eht,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: tht,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: nht,
    defaultWidth: "full"
  })
}, aht = {
  lastWeek: "'të' eeee 'e shkuar në' p",
  yesterday: "'dje në' p",
  today: "'sot në' p",
  tomorrow: "'nesër në' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, oht = (e, t, r, a) => aht[e], iht = {
  narrow: ["P", "M"],
  abbreviated: ["PK", "MK"],
  wide: ["Para Krishtit", "Mbas Krishtit"]
}, lht = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["4-mujori I", "4-mujori II", "4-mujori III", "4-mujori IV"]
}, sht = {
  narrow: ["J", "S", "M", "P", "M", "Q", "K", "G", "S", "T", "N", "D"],
  abbreviated: [
    "Jan",
    "Shk",
    "Mar",
    "Pri",
    "Maj",
    "Qer",
    "Kor",
    "Gus",
    "Sht",
    "Tet",
    "Nën",
    "Dhj"
  ],
  wide: [
    "Janar",
    "Shkurt",
    "Mars",
    "Prill",
    "Maj",
    "Qershor",
    "Korrik",
    "Gusht",
    "Shtator",
    "Tetor",
    "Nëntor",
    "Dhjetor"
  ]
}, uht = {
  narrow: ["D", "H", "M", "M", "E", "P", "S"],
  short: ["Di", "Hë", "Ma", "Më", "En", "Pr", "Sh"],
  abbreviated: ["Die", "Hën", "Mar", "Mër", "Enj", "Pre", "Sht"],
  wide: ["Dielë", "Hënë", "Martë", "Mërkurë", "Enjte", "Premte", "Shtunë"]
}, cht = {
  narrow: {
    am: "p",
    pm: "m",
    midnight: "m",
    noon: "d",
    morning: "mëngjes",
    afternoon: "dite",
    evening: "mbrëmje",
    night: "natë"
  },
  abbreviated: {
    am: "PD",
    pm: "MD",
    midnight: "mesnëtë",
    noon: "drek",
    morning: "mëngjes",
    afternoon: "mbasdite",
    evening: "mbrëmje",
    night: "natë"
  },
  wide: {
    am: "p.d.",
    pm: "m.d.",
    midnight: "mesnëtë",
    noon: "drek",
    morning: "mëngjes",
    afternoon: "mbasdite",
    evening: "mbrëmje",
    night: "natë"
  }
}, dht = {
  narrow: {
    am: "p",
    pm: "m",
    midnight: "m",
    noon: "d",
    morning: "në mëngjes",
    afternoon: "në mbasdite",
    evening: "në mbrëmje",
    night: "në mesnatë"
  },
  abbreviated: {
    am: "PD",
    pm: "MD",
    midnight: "mesnatë",
    noon: "drek",
    morning: "në mëngjes",
    afternoon: "në mbasdite",
    evening: "në mbrëmje",
    night: "në mesnatë"
  },
  wide: {
    am: "p.d.",
    pm: "m.d.",
    midnight: "mesnatë",
    noon: "drek",
    morning: "në mëngjes",
    afternoon: "në mbasdite",
    evening: "në mbrëmje",
    night: "në mesnatë"
  }
}, fht = (e, t) => {
  const r = Number(e);
  return t?.unit === "hour" ? String(r) : r === 1 ? r + "-rë" : r === 4 ? r + "t" : r + "-të";
}, mht = {
  ordinalNumber: fht,
  era: Ce({
    values: iht,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: lht,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: sht,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: uht,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: cht,
    defaultWidth: "wide",
    formattingValues: dht,
    defaultFormattingWidth: "wide"
  })
}, hht = /^(\d+)(-rë|-të|t|)?/i, pht = /\d+/i, ght = {
  narrow: /^(p|m)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(para krishtit|mbas krishtit)/i
}, vht = {
  any: [/^b/i, /^(p|m)/i]
}, bht = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]-mujori (i{1,3}|iv)/i
}, yht = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, wht = {
  narrow: /^[jsmpqkftnd]/i,
  abbreviated: /^(jan|shk|mar|pri|maj|qer|kor|gus|sht|tet|nën|dhj)/i,
  wide: /^(janar|shkurt|mars|prill|maj|qershor|korrik|gusht|shtator|tetor|nëntor|dhjetor)/i
}, Sht = {
  narrow: [
    /^j/i,
    /^s/i,
    /^m/i,
    /^p/i,
    /^m/i,
    /^q/i,
    /^k/i,
    /^g/i,
    /^s/i,
    /^t/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^shk/i,
    /^mar/i,
    /^pri/i,
    /^maj/i,
    /^qer/i,
    /^kor/i,
    /^gu/i,
    /^sht/i,
    /^tet/i,
    /^n/i,
    /^d/i
  ]
}, Cht = {
  narrow: /^[dhmeps]/i,
  short: /^(di|hë|ma|më|en|pr|sh)/i,
  abbreviated: /^(die|hën|mar|mër|enj|pre|sht)/i,
  wide: /^(dielë|hënë|martë|mërkurë|enjte|premte|shtunë)/i
}, xht = {
  narrow: [/^d/i, /^h/i, /^m/i, /^m/i, /^e/i, /^p/i, /^s/i],
  any: [/^d/i, /^h/i, /^ma/i, /^më/i, /^e/i, /^p/i, /^s/i]
}, Eht = {
  narrow: /^(p|m|me|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i,
  any: /^([pm]\.?\s?d\.?|drek|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i
}, Pht = {
  any: {
    am: /^p/i,
    pm: /^m/i,
    midnight: /^me/i,
    noon: /^dr/i,
    morning: /mëngjes/i,
    afternoon: /mbasdite/i,
    evening: /mbrëmje/i,
    night: /natë/i
  }
}, kht = {
  ordinalNumber: Fn({
    matchPattern: hht,
    parsePattern: pht,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: ght,
    defaultMatchWidth: "wide",
    parsePatterns: vht,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: bht,
    defaultMatchWidth: "wide",
    parsePatterns: yht,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: wht,
    defaultMatchWidth: "wide",
    parsePatterns: Sht,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: Cht,
    defaultMatchWidth: "wide",
    parsePatterns: xht,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: Eht,
    defaultMatchWidth: "any",
    parsePatterns: Pht,
    defaultParseWidth: "any"
  })
}, Mht = {
  code: "sq",
  formatDistance: Zmt,
  formatLong: rht,
  formatRelative: oht,
  localize: mht,
  match: kht,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, Oht = {
  lessThanXSeconds: {
    one: {
      standalone: "мање од 1 секунде",
      withPrepositionAgo: "мање од 1 секунде",
      withPrepositionIn: "мање од 1 секунду"
    },
    dual: "мање од {{count}} секунде",
    other: "мање од {{count}} секунди"
  },
  xSeconds: {
    one: {
      standalone: "1 секунда",
      withPrepositionAgo: "1 секунде",
      withPrepositionIn: "1 секунду"
    },
    dual: "{{count}} секунде",
    other: "{{count}} секунди"
  },
  halfAMinute: "пола минуте",
  lessThanXMinutes: {
    one: {
      standalone: "мање од 1 минуте",
      withPrepositionAgo: "мање од 1 минуте",
      withPrepositionIn: "мање од 1 минуту"
    },
    dual: "мање од {{count}} минуте",
    other: "мање од {{count}} минута"
  },
  xMinutes: {
    one: {
      standalone: "1 минута",
      withPrepositionAgo: "1 минуте",
      withPrepositionIn: "1 минуту"
    },
    dual: "{{count}} минуте",
    other: "{{count}} минута"
  },
  aboutXHours: {
    one: {
      standalone: "око 1 сат",
      withPrepositionAgo: "око 1 сат",
      withPrepositionIn: "око 1 сат"
    },
    dual: "око {{count}} сата",
    other: "око {{count}} сати"
  },
  xHours: {
    one: {
      standalone: "1 сат",
      withPrepositionAgo: "1 сат",
      withPrepositionIn: "1 сат"
    },
    dual: "{{count}} сата",
    other: "{{count}} сати"
  },
  xDays: {
    one: {
      standalone: "1 дан",
      withPrepositionAgo: "1 дан",
      withPrepositionIn: "1 дан"
    },
    dual: "{{count}} дана",
    other: "{{count}} дана"
  },
  aboutXWeeks: {
    one: {
      standalone: "око 1 недељу",
      withPrepositionAgo: "око 1 недељу",
      withPrepositionIn: "око 1 недељу"
    },
    dual: "око {{count}} недеље",
    other: "око {{count}} недеље"
  },
  xWeeks: {
    one: {
      standalone: "1 недељу",
      withPrepositionAgo: "1 недељу",
      withPrepositionIn: "1 недељу"
    },
    dual: "{{count}} недеље",
    other: "{{count}} недеље"
  },
  aboutXMonths: {
    one: {
      standalone: "око 1 месец",
      withPrepositionAgo: "око 1 месец",
      withPrepositionIn: "око 1 месец"
    },
    dual: "око {{count}} месеца",
    other: "око {{count}} месеци"
  },
  xMonths: {
    one: {
      standalone: "1 месец",
      withPrepositionAgo: "1 месец",
      withPrepositionIn: "1 месец"
    },
    dual: "{{count}} месеца",
    other: "{{count}} месеци"
  },
  aboutXYears: {
    one: {
      standalone: "око 1 годину",
      withPrepositionAgo: "око 1 годину",
      withPrepositionIn: "око 1 годину"
    },
    dual: "око {{count}} године",
    other: "око {{count}} година"
  },
  xYears: {
    one: {
      standalone: "1 година",
      withPrepositionAgo: "1 године",
      withPrepositionIn: "1 годину"
    },
    dual: "{{count}} године",
    other: "{{count}} година"
  },
  overXYears: {
    one: {
      standalone: "преко 1 годину",
      withPrepositionAgo: "преко 1 годину",
      withPrepositionIn: "преко 1 годину"
    },
    dual: "преко {{count}} године",
    other: "преко {{count}} година"
  },
  almostXYears: {
    one: {
      standalone: "готово 1 годину",
      withPrepositionAgo: "готово 1 годину",
      withPrepositionIn: "готово 1 годину"
    },
    dual: "готово {{count}} године",
    other: "готово {{count}} година"
  }
}, Tht = (e, t, r) => {
  let a;
  const i = Oht[e];
  return typeof i == "string" ? a = i : t === 1 ? r?.addSuffix ? r.comparison && r.comparison > 0 ? a = i.one.withPrepositionIn : a = i.one.withPrepositionAgo : a = i.one.standalone : t % 10 > 1 && t % 10 < 5 && // if last digit is between 2 and 4
  String(t).substr(-2, 1) !== "1" ? a = i.dual.replace("{{count}}", String(t)) : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? "за " + a : "пре " + a : a;
}, Rht = {
  full: "EEEE, d. MMMM yyyy.",
  long: "d. MMMM yyyy.",
  medium: "d. MMM yy.",
  short: "dd. MM. yy."
}, Aht = {
  full: "HH:mm:ss (zzzz)",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Nht = {
  full: "{{date}} 'у' {{time}}",
  long: "{{date}} 'у' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Dht = {
  date: Ke({
    formats: Rht,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: Aht,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: Nht,
    defaultWidth: "full"
  })
}, $ht = {
  lastWeek: (e) => {
    switch (e.getDay()) {
      case 0:
        return "'прошле недеље у' p";
      case 3:
        return "'прошле среде у' p";
      case 6:
        return "'прошле суботе у' p";
      default:
        return "'прошли' EEEE 'у' p";
    }
  },
  yesterday: "'јуче у' p",
  today: "'данас у' p",
  tomorrow: "'сутра у' p",
  nextWeek: (e) => {
    switch (e.getDay()) {
      case 0:
        return "'следеће недеље у' p";
      case 3:
        return "'следећу среду у' p";
      case 6:
        return "'следећу суботу у' p";
      default:
        return "'следећи' EEEE 'у' p";
    }
  },
  other: "P"
}, zht = (e, t, r, a) => {
  const i = $ht[e];
  return typeof i == "function" ? i(t) : i;
}, jht = {
  narrow: ["пр.н.е.", "АД"],
  abbreviated: ["пр. Хр.", "по. Хр."],
  wide: ["Пре Христа", "После Христа"]
}, Iht = {
  narrow: ["1.", "2.", "3.", "4."],
  abbreviated: ["1. кв.", "2. кв.", "3. кв.", "4. кв."],
  wide: ["1. квартал", "2. квартал", "3. квартал", "4. квартал"]
}, Lht = {
  narrow: [
    "1.",
    "2.",
    "3.",
    "4.",
    "5.",
    "6.",
    "7.",
    "8.",
    "9.",
    "10.",
    "11.",
    "12."
  ],
  abbreviated: [
    "јан",
    "феб",
    "мар",
    "апр",
    "мај",
    "јун",
    "јул",
    "авг",
    "сеп",
    "окт",
    "нов",
    "дец"
  ],
  wide: [
    "јануар",
    "фебруар",
    "март",
    "април",
    "мај",
    "јун",
    "јул",
    "август",
    "септембар",
    "октобар",
    "новембар",
    "децембар"
  ]
}, Hht = {
  narrow: [
    "1.",
    "2.",
    "3.",
    "4.",
    "5.",
    "6.",
    "7.",
    "8.",
    "9.",
    "10.",
    "11.",
    "12."
  ],
  abbreviated: [
    "јан",
    "феб",
    "мар",
    "апр",
    "мај",
    "јун",
    "јул",
    "авг",
    "сеп",
    "окт",
    "нов",
    "дец"
  ],
  wide: [
    "јануар",
    "фебруар",
    "март",
    "април",
    "мај",
    "јун",
    "јул",
    "август",
    "септембар",
    "октобар",
    "новембар",
    "децембар"
  ]
}, Fht = {
  narrow: ["Н", "П", "У", "С", "Ч", "П", "С"],
  short: ["нед", "пон", "уто", "сре", "чет", "пет", "суб"],
  abbreviated: ["нед", "пон", "уто", "сре", "чет", "пет", "суб"],
  wide: [
    "недеља",
    "понедељак",
    "уторак",
    "среда",
    "четвртак",
    "петак",
    "субота"
  ]
}, Wht = {
  narrow: {
    am: "АМ",
    pm: "ПМ",
    midnight: "поноћ",
    noon: "подне",
    morning: "ујутру",
    afternoon: "поподне",
    evening: "увече",
    night: "ноћу"
  },
  abbreviated: {
    am: "АМ",
    pm: "ПМ",
    midnight: "поноћ",
    noon: "подне",
    morning: "ујутру",
    afternoon: "поподне",
    evening: "увече",
    night: "ноћу"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "поноћ",
    noon: "подне",
    morning: "ујутру",
    afternoon: "после подне",
    evening: "увече",
    night: "ноћу"
  }
}, Vht = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "поноћ",
    noon: "подне",
    morning: "ујутру",
    afternoon: "поподне",
    evening: "увече",
    night: "ноћу"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "поноћ",
    noon: "подне",
    morning: "ујутру",
    afternoon: "поподне",
    evening: "увече",
    night: "ноћу"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "поноћ",
    noon: "подне",
    morning: "ујутру",
    afternoon: "после подне",
    evening: "увече",
    night: "ноћу"
  }
}, _ht = (e, t) => Number(e) + ".", Bht = {
  ordinalNumber: _ht,
  era: Ce({
    values: jht,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: Iht,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: Lht,
    defaultWidth: "wide",
    formattingValues: Hht,
    defaultFormattingWidth: "wide"
  }),
  day: Ce({
    values: Fht,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: Vht,
    defaultWidth: "wide",
    formattingValues: Wht,
    defaultFormattingWidth: "wide"
  })
}, Uht = /^(\d+)\./i, Xht = /\d+/i, Ght = {
  narrow: /^(пр\.н\.е\.|АД)/i,
  abbreviated: /^(пр\.\s?Хр\.|по\.\s?Хр\.)/i,
  wide: /^(Пре Христа|пре нове ере|После Христа|нова ера)/i
}, qht = {
  any: [/^пр/i, /^(по|нова)/i]
}, Kht = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\.\s?кв\.?/i,
  wide: /^[1234]\. квартал/i
}, Yht = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Qht = {
  narrow: /^(10|11|12|[123456789])\./i,
  abbreviated: /^(јан|феб|мар|апр|мај|јун|јул|авг|сеп|окт|нов|дец)/i,
  wide: /^((јануар|јануара)|(фебруар|фебруара)|(март|марта)|(април|априла)|(мја|маја)|(јун|јуна)|(јул|јула)|(август|августа)|(септембар|септембра)|(октобар|октобра)|(новембар|новембра)|(децембар|децембра))/i
}, Jht = {
  narrow: [
    /^1/i,
    /^2/i,
    /^3/i,
    /^4/i,
    /^5/i,
    /^6/i,
    /^7/i,
    /^8/i,
    /^9/i,
    /^10/i,
    /^11/i,
    /^12/i
  ],
  any: [
    /^ја/i,
    /^ф/i,
    /^мар/i,
    /^ап/i,
    /^мај/i,
    /^јун/i,
    /^јул/i,
    /^авг/i,
    /^с/i,
    /^о/i,
    /^н/i,
    /^д/i
  ]
}, Zht = {
  narrow: /^[пусчн]/i,
  short: /^(нед|пон|уто|сре|чет|пет|суб)/i,
  abbreviated: /^(нед|пон|уто|сре|чет|пет|суб)/i,
  wide: /^(недеља|понедељак|уторак|среда|четвртак|петак|субота)/i
}, ept = {
  narrow: [/^п/i, /^у/i, /^с/i, /^ч/i, /^п/i, /^с/i, /^н/i],
  any: [/^нед/i, /^пон/i, /^уто/i, /^сре/i, /^чет/i, /^пет/i, /^суб/i]
}, tpt = {
  any: /^(ам|пм|поноћ|(по)?подне|увече|ноћу|после подне|ујутру)/i
}, npt = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^поно/i,
    noon: /^под/i,
    morning: /ујутру/i,
    afternoon: /(после\s|по)+подне/i,
    evening: /(увече)/i,
    night: /(ноћу)/i
  }
}, rpt = {
  ordinalNumber: Fn({
    matchPattern: Uht,
    parsePattern: Xht,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: Ght,
    defaultMatchWidth: "wide",
    parsePatterns: qht,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: Kht,
    defaultMatchWidth: "wide",
    parsePatterns: Yht,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: Qht,
    defaultMatchWidth: "wide",
    parsePatterns: Jht,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: Zht,
    defaultMatchWidth: "wide",
    parsePatterns: ept,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: tpt,
    defaultMatchWidth: "any",
    parsePatterns: npt,
    defaultParseWidth: "any"
  })
}, apt = {
  code: "sr",
  formatDistance: Tht,
  formatLong: Dht,
  formatRelative: zht,
  localize: Bht,
  match: rpt,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, opt = {
  lessThanXSeconds: {
    one: {
      standalone: "manje od 1 sekunde",
      withPrepositionAgo: "manje od 1 sekunde",
      withPrepositionIn: "manje od 1 sekundu"
    },
    dual: "manje od {{count}} sekunde",
    other: "manje od {{count}} sekundi"
  },
  xSeconds: {
    one: {
      standalone: "1 sekunda",
      withPrepositionAgo: "1 sekunde",
      withPrepositionIn: "1 sekundu"
    },
    dual: "{{count}} sekunde",
    other: "{{count}} sekundi"
  },
  halfAMinute: "pola minute",
  lessThanXMinutes: {
    one: {
      standalone: "manje od 1 minute",
      withPrepositionAgo: "manje od 1 minute",
      withPrepositionIn: "manje od 1 minutu"
    },
    dual: "manje od {{count}} minute",
    other: "manje od {{count}} minuta"
  },
  xMinutes: {
    one: {
      standalone: "1 minuta",
      withPrepositionAgo: "1 minute",
      withPrepositionIn: "1 minutu"
    },
    dual: "{{count}} minute",
    other: "{{count}} minuta"
  },
  aboutXHours: {
    one: {
      standalone: "oko 1 sat",
      withPrepositionAgo: "oko 1 sat",
      withPrepositionIn: "oko 1 sat"
    },
    dual: "oko {{count}} sata",
    other: "oko {{count}} sati"
  },
  xHours: {
    one: {
      standalone: "1 sat",
      withPrepositionAgo: "1 sat",
      withPrepositionIn: "1 sat"
    },
    dual: "{{count}} sata",
    other: "{{count}} sati"
  },
  xDays: {
    one: {
      standalone: "1 dan",
      withPrepositionAgo: "1 dan",
      withPrepositionIn: "1 dan"
    },
    dual: "{{count}} dana",
    other: "{{count}} dana"
  },
  aboutXWeeks: {
    one: {
      standalone: "oko 1 nedelju",
      withPrepositionAgo: "oko 1 nedelju",
      withPrepositionIn: "oko 1 nedelju"
    },
    dual: "oko {{count}} nedelje",
    other: "oko {{count}} nedelje"
  },
  xWeeks: {
    one: {
      standalone: "1 nedelju",
      withPrepositionAgo: "1 nedelju",
      withPrepositionIn: "1 nedelju"
    },
    dual: "{{count}} nedelje",
    other: "{{count}} nedelje"
  },
  aboutXMonths: {
    one: {
      standalone: "oko 1 mesec",
      withPrepositionAgo: "oko 1 mesec",
      withPrepositionIn: "oko 1 mesec"
    },
    dual: "oko {{count}} meseca",
    other: "oko {{count}} meseci"
  },
  xMonths: {
    one: {
      standalone: "1 mesec",
      withPrepositionAgo: "1 mesec",
      withPrepositionIn: "1 mesec"
    },
    dual: "{{count}} meseca",
    other: "{{count}} meseci"
  },
  aboutXYears: {
    one: {
      standalone: "oko 1 godinu",
      withPrepositionAgo: "oko 1 godinu",
      withPrepositionIn: "oko 1 godinu"
    },
    dual: "oko {{count}} godine",
    other: "oko {{count}} godina"
  },
  xYears: {
    one: {
      standalone: "1 godina",
      withPrepositionAgo: "1 godine",
      withPrepositionIn: "1 godinu"
    },
    dual: "{{count}} godine",
    other: "{{count}} godina"
  },
  overXYears: {
    one: {
      standalone: "preko 1 godinu",
      withPrepositionAgo: "preko 1 godinu",
      withPrepositionIn: "preko 1 godinu"
    },
    dual: "preko {{count}} godine",
    other: "preko {{count}} godina"
  },
  almostXYears: {
    one: {
      standalone: "gotovo 1 godinu",
      withPrepositionAgo: "gotovo 1 godinu",
      withPrepositionIn: "gotovo 1 godinu"
    },
    dual: "gotovo {{count}} godine",
    other: "gotovo {{count}} godina"
  }
}, ipt = (e, t, r) => {
  let a;
  const i = opt[e];
  return typeof i == "string" ? a = i : t === 1 ? r?.addSuffix ? r.comparison && r.comparison > 0 ? a = i.one.withPrepositionIn : a = i.one.withPrepositionAgo : a = i.one.standalone : t % 10 > 1 && t % 10 < 5 && // if last digit is between 2 and 4
  String(t).substr(-2, 1) !== "1" ? a = i.dual.replace("{{count}}", String(t)) : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? "za " + a : "pre " + a : a;
}, lpt = {
  full: "EEEE, d. MMMM yyyy.",
  long: "d. MMMM yyyy.",
  medium: "d. MMM yy.",
  short: "dd. MM. yy."
}, spt = {
  full: "HH:mm:ss (zzzz)",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, upt = {
  full: "{{date}} 'u' {{time}}",
  long: "{{date}} 'u' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, cpt = {
  date: Ke({
    formats: lpt,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: spt,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: upt,
    defaultWidth: "full"
  })
}, dpt = {
  lastWeek: (e) => {
    switch (e.getDay()) {
      case 0:
        return "'prošle nedelje u' p";
      case 3:
        return "'prošle srede u' p";
      case 6:
        return "'prošle subote u' p";
      default:
        return "'prošli' EEEE 'u' p";
    }
  },
  yesterday: "'juče u' p",
  today: "'danas u' p",
  tomorrow: "'sutra u' p",
  nextWeek: (e) => {
    switch (e.getDay()) {
      case 0:
        return "'sledeće nedelje u' p";
      case 3:
        return "'sledeću sredu u' p";
      case 6:
        return "'sledeću subotu u' p";
      default:
        return "'sledeći' EEEE 'u' p";
    }
  },
  other: "P"
}, fpt = (e, t, r, a) => {
  const i = dpt[e];
  return typeof i == "function" ? i(t) : i;
}, mpt = {
  narrow: ["pr.n.e.", "AD"],
  abbreviated: ["pr. Hr.", "po. Hr."],
  wide: ["Pre Hrista", "Posle Hrista"]
}, hpt = {
  narrow: ["1.", "2.", "3.", "4."],
  abbreviated: ["1. kv.", "2. kv.", "3. kv.", "4. kv."],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, ppt = {
  narrow: [
    "1.",
    "2.",
    "3.",
    "4.",
    "5.",
    "6.",
    "7.",
    "8.",
    "9.",
    "10.",
    "11.",
    "12."
  ],
  abbreviated: [
    "jan",
    "feb",
    "mar",
    "apr",
    "maj",
    "jun",
    "jul",
    "avg",
    "sep",
    "okt",
    "nov",
    "dec"
  ],
  wide: [
    "januar",
    "februar",
    "mart",
    "april",
    "maj",
    "jun",
    "jul",
    "avgust",
    "septembar",
    "oktobar",
    "novembar",
    "decembar"
  ]
}, gpt = {
  narrow: [
    "1.",
    "2.",
    "3.",
    "4.",
    "5.",
    "6.",
    "7.",
    "8.",
    "9.",
    "10.",
    "11.",
    "12."
  ],
  abbreviated: [
    "jan",
    "feb",
    "mar",
    "apr",
    "maj",
    "jun",
    "jul",
    "avg",
    "sep",
    "okt",
    "nov",
    "dec"
  ],
  wide: [
    "januar",
    "februar",
    "mart",
    "april",
    "maj",
    "jun",
    "jul",
    "avgust",
    "septembar",
    "oktobar",
    "novembar",
    "decembar"
  ]
}, vpt = {
  narrow: ["N", "P", "U", "S", "Č", "P", "S"],
  short: ["ned", "pon", "uto", "sre", "čet", "pet", "sub"],
  abbreviated: ["ned", "pon", "uto", "sre", "čet", "pet", "sub"],
  wide: [
    "nedelja",
    "ponedeljak",
    "utorak",
    "sreda",
    "četvrtak",
    "petak",
    "subota"
  ]
}, bpt = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "posle podne",
    evening: "uveče",
    night: "noću"
  }
}, ypt = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "posle podne",
    evening: "uveče",
    night: "noću"
  }
}, wpt = (e, t) => Number(e) + ".", Spt = {
  ordinalNumber: wpt,
  era: Ce({
    values: mpt,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: hpt,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: ppt,
    defaultWidth: "wide",
    formattingValues: gpt,
    defaultFormattingWidth: "wide"
  }),
  day: Ce({
    values: vpt,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: ypt,
    defaultWidth: "wide",
    formattingValues: bpt,
    defaultFormattingWidth: "wide"
  })
}, Cpt = /^(\d+)\./i, xpt = /\d+/i, Ept = {
  narrow: /^(pr\.n\.e\.|AD)/i,
  abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
  wide: /^(Pre Hrista|pre nove ere|Posle Hrista|nova era)/i
}, Ppt = {
  any: [/^pr/i, /^(po|nova)/i]
}, kpt = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\.\s?kv\.?/i,
  wide: /^[1234]\. kvartal/i
}, Mpt = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Opt = {
  narrow: /^(10|11|12|[123456789])\./i,
  abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
  wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(jun|juna)|(jul|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
}, Tpt = {
  narrow: [
    /^1/i,
    /^2/i,
    /^3/i,
    /^4/i,
    /^5/i,
    /^6/i,
    /^7/i,
    /^8/i,
    /^9/i,
    /^10/i,
    /^11/i,
    /^12/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^maj/i,
    /^jun/i,
    /^jul/i,
    /^avg/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Rpt = {
  narrow: /^[npusčc]/i,
  short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
  abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
  wide: /^(nedelja|ponedeljak|utorak|sreda|(četvrtak|cetvrtak)|petak|subota)/i
}, Apt = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Npt = {
  any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|posle podne|ujutru)/i
}, Dpt = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^pono/i,
    noon: /^pod/i,
    morning: /jutro/i,
    afternoon: /(posle\s|po)+podne/i,
    evening: /(uvece|uveče)/i,
    night: /(nocu|noću)/i
  }
}, $pt = {
  ordinalNumber: Fn({
    matchPattern: Cpt,
    parsePattern: xpt,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: Ept,
    defaultMatchWidth: "wide",
    parsePatterns: Ppt,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: kpt,
    defaultMatchWidth: "wide",
    parsePatterns: Mpt,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: Opt,
    defaultMatchWidth: "wide",
    parsePatterns: Tpt,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: Rpt,
    defaultMatchWidth: "wide",
    parsePatterns: Apt,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: Npt,
    defaultMatchWidth: "any",
    parsePatterns: Dpt,
    defaultParseWidth: "any"
  })
}, zpt = {
  code: "sr-Latn",
  formatDistance: ipt,
  formatLong: cpt,
  formatRelative: fpt,
  localize: Spt,
  match: $pt,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, jpt = {
  lessThanXSeconds: {
    one: "mindre än en sekund",
    other: "mindre än {{count}} sekunder"
  },
  xSeconds: {
    one: "en sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "en halv minut",
  lessThanXMinutes: {
    one: "mindre än en minut",
    other: "mindre än {{count}} minuter"
  },
  xMinutes: {
    one: "en minut",
    other: "{{count}} minuter"
  },
  aboutXHours: {
    one: "ungefär en timme",
    other: "ungefär {{count}} timmar"
  },
  xHours: {
    one: "en timme",
    other: "{{count}} timmar"
  },
  xDays: {
    one: "en dag",
    other: "{{count}} dagar"
  },
  aboutXWeeks: {
    one: "ungefär en vecka",
    other: "ungefär {{count}} veckor"
  },
  xWeeks: {
    one: "en vecka",
    other: "{{count}} veckor"
  },
  aboutXMonths: {
    one: "ungefär en månad",
    other: "ungefär {{count}} månader"
  },
  xMonths: {
    one: "en månad",
    other: "{{count}} månader"
  },
  aboutXYears: {
    one: "ungefär ett år",
    other: "ungefär {{count}} år"
  },
  xYears: {
    one: "ett år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "över ett år",
    other: "över {{count}} år"
  },
  almostXYears: {
    one: "nästan ett år",
    other: "nästan {{count}} år"
  }
}, Ipt = [
  "noll",
  "en",
  "två",
  "tre",
  "fyra",
  "fem",
  "sex",
  "sju",
  "åtta",
  "nio",
  "tio",
  "elva",
  "tolv"
], Lpt = (e, t, r) => {
  let a;
  const i = jpt[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace(
    "{{count}}",
    t < 13 ? Ipt[t] : String(t)
  ), r?.addSuffix ? r.comparison && r.comparison > 0 ? "om " + a : a + " sedan" : a;
}, Hpt = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "y-MM-dd"
}, Fpt = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Wpt = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Vpt = {
  date: Ke({
    formats: Hpt,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: Fpt,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: Wpt,
    defaultWidth: "full"
  })
}, _pt = {
  lastWeek: "'i' EEEE's kl.' p",
  yesterday: "'igår kl.' p",
  today: "'idag kl.' p",
  tomorrow: "'imorgon kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: "P"
}, Bpt = (e, t, r, a) => _pt[e], Upt = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["före Kristus", "efter Kristus"]
}, Xpt = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1:a kvartalet", "2:a kvartalet", "3:e kvartalet", "4:e kvartalet"]
}, Gpt = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jan.",
    "feb.",
    "mars",
    "apr.",
    "maj",
    "juni",
    "juli",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "dec."
  ],
  wide: [
    "januari",
    "februari",
    "mars",
    "april",
    "maj",
    "juni",
    "juli",
    "augusti",
    "september",
    "oktober",
    "november",
    "december"
  ]
}, qpt = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sö", "må", "ti", "on", "to", "fr", "lö"],
  abbreviated: ["sön", "mån", "tis", "ons", "tors", "fre", "lör"],
  wide: ["söndag", "måndag", "tisdag", "onsdag", "torsdag", "fredag", "lördag"]
}, Kpt = {
  narrow: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "morg.",
    afternoon: "efterm.",
    evening: "kväll",
    night: "natt"
  },
  abbreviated: {
    am: "f.m.",
    pm: "e.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "morgon",
    afternoon: "efterm.",
    evening: "kväll",
    night: "natt"
  },
  wide: {
    am: "förmiddag",
    pm: "eftermiddag",
    midnight: "midnatt",
    noon: "middag",
    morning: "morgon",
    afternoon: "eftermiddag",
    evening: "kväll",
    night: "natt"
  }
}, Ypt = {
  narrow: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på efterm.",
    evening: "på kvällen",
    night: "på natten"
  },
  abbreviated: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på efterm.",
    evening: "på kvällen",
    night: "på natten"
  },
  wide: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morgonen",
    afternoon: "på eftermiddagen",
    evening: "på kvällen",
    night: "på natten"
  }
}, Qpt = (e, t) => {
  const r = Number(e), a = r % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
      case 2:
        return r + ":a";
    }
  return r + ":e";
}, Jpt = {
  ordinalNumber: Qpt,
  era: Ce({
    values: Upt,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: Xpt,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: Gpt,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: qpt,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: Kpt,
    defaultWidth: "wide",
    formattingValues: Ypt,
    defaultFormattingWidth: "wide"
  })
}, Zpt = /^(\d+)(:a|:e)?/i, egt = /\d+/i, tgt = {
  narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
}, ngt = {
  any: [/^f/i, /^[ev]/i]
}, rgt = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](:a|:e)? kvartalet/i
}, agt = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, ogt = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
  wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
}, igt = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^maj/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, lgt = {
  narrow: /^[smtofl]/i,
  short: /^(sö|må|ti|on|to|fr|lö)/i,
  abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
  wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
}, sgt = {
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, ugt = {
  any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
}, cgt = {
  any: {
    am: /^f/i,
    pm: /^e/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgon/i,
    afternoon: /eftermiddag/i,
    evening: /kväll/i,
    night: /natt/i
  }
}, dgt = {
  ordinalNumber: Fn({
    matchPattern: Zpt,
    parsePattern: egt,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: tgt,
    defaultMatchWidth: "wide",
    parsePatterns: ngt,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: rgt,
    defaultMatchWidth: "wide",
    parsePatterns: agt,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: ogt,
    defaultMatchWidth: "wide",
    parsePatterns: igt,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: lgt,
    defaultMatchWidth: "wide",
    parsePatterns: sgt,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: ugt,
    defaultMatchWidth: "any",
    parsePatterns: cgt,
    defaultParseWidth: "any"
  })
}, fgt = {
  code: "sv",
  formatDistance: Lpt,
  formatLong: Vpt,
  formatRelative: Bpt,
  localize: Jpt,
  match: dgt,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
function mgt(e) {
  return e.one !== void 0;
}
const hgt = {
  lessThanXSeconds: {
    one: {
      default: "ஒரு வினாடிக்கு குறைவாக",
      in: "ஒரு வினாடிக்குள்",
      ago: "ஒரு வினாடிக்கு முன்பு"
    },
    other: {
      default: "{{count}} வினாடிகளுக்கு குறைவாக",
      in: "{{count}} வினாடிகளுக்குள்",
      ago: "{{count}} வினாடிகளுக்கு முன்பு"
    }
  },
  xSeconds: {
    one: {
      default: "1 வினாடி",
      in: "1 வினாடியில்",
      ago: "1 வினாடி முன்பு"
    },
    other: {
      default: "{{count}} விநாடிகள்",
      in: "{{count}} வினாடிகளில்",
      ago: "{{count}} விநாடிகளுக்கு முன்பு"
    }
  },
  halfAMinute: {
    default: "அரை நிமிடம்",
    in: "அரை நிமிடத்தில்",
    ago: "அரை நிமிடம் முன்பு"
  },
  lessThanXMinutes: {
    one: {
      default: "ஒரு நிமிடத்திற்கும் குறைவாக",
      in: "ஒரு நிமிடத்திற்குள்",
      ago: "ஒரு நிமிடத்திற்கு முன்பு"
    },
    other: {
      default: "{{count}} நிமிடங்களுக்கும் குறைவாக",
      in: "{{count}} நிமிடங்களுக்குள்",
      ago: "{{count}} நிமிடங்களுக்கு முன்பு"
    }
  },
  xMinutes: {
    one: {
      default: "1 நிமிடம்",
      in: "1 நிமிடத்தில்",
      ago: "1 நிமிடம் முன்பு"
    },
    other: {
      default: "{{count}} நிமிடங்கள்",
      in: "{{count}} நிமிடங்களில்",
      ago: "{{count}} நிமிடங்களுக்கு முன்பு"
    }
  },
  aboutXHours: {
    one: {
      default: "சுமார் 1 மணி நேரம்",
      in: "சுமார் 1 மணி நேரத்தில்",
      ago: "சுமார் 1 மணி நேரத்திற்கு முன்பு"
    },
    other: {
      default: "சுமார் {{count}} மணி நேரம்",
      in: "சுமார் {{count}} மணி நேரத்திற்கு முன்பு",
      ago: "சுமார் {{count}} மணி நேரத்தில்"
    }
  },
  xHours: {
    one: {
      default: "1 மணி நேரம்",
      in: "1 மணி நேரத்தில்",
      ago: "1 மணி நேரத்திற்கு முன்பு"
    },
    other: {
      default: "{{count}} மணி நேரம்",
      in: "{{count}} மணி நேரத்தில்",
      ago: "{{count}} மணி நேரத்திற்கு முன்பு"
    }
  },
  xDays: {
    one: {
      default: "1 நாள்",
      in: "1 நாளில்",
      ago: "1 நாள் முன்பு"
    },
    other: {
      default: "{{count}} நாட்கள்",
      in: "{{count}} நாட்களில்",
      ago: "{{count}} நாட்களுக்கு முன்பு"
    }
  },
  aboutXWeeks: {
    one: {
      default: "சுமார் 1 வாரம்",
      in: "சுமார் 1 வாரத்தில்",
      ago: "சுமார் 1 வாரம் முன்பு"
    },
    other: {
      default: "சுமார் {{count}} வாரங்கள்",
      in: "சுமார் {{count}} வாரங்களில்",
      ago: "சுமார் {{count}} வாரங்களுக்கு முன்பு"
    }
  },
  xWeeks: {
    one: {
      default: "1 வாரம்",
      in: "1 வாரத்தில்",
      ago: "1 வாரம் முன்பு"
    },
    other: {
      default: "{{count}} வாரங்கள்",
      in: "{{count}} வாரங்களில்",
      ago: "{{count}} வாரங்களுக்கு முன்பு"
    }
  },
  aboutXMonths: {
    one: {
      default: "சுமார் 1 மாதம்",
      in: "சுமார் 1 மாதத்தில்",
      ago: "சுமார் 1 மாதத்திற்கு முன்பு"
    },
    other: {
      default: "சுமார் {{count}} மாதங்கள்",
      in: "சுமார் {{count}} மாதங்களில்",
      ago: "சுமார் {{count}} மாதங்களுக்கு முன்பு"
    }
  },
  xMonths: {
    one: {
      default: "1 மாதம்",
      in: "1 மாதத்தில்",
      ago: "1 மாதம் முன்பு"
    },
    other: {
      default: "{{count}} மாதங்கள்",
      in: "{{count}} மாதங்களில்",
      ago: "{{count}} மாதங்களுக்கு முன்பு"
    }
  },
  aboutXYears: {
    one: {
      default: "சுமார் 1 வருடம்",
      in: "சுமார் 1 ஆண்டில்",
      ago: "சுமார் 1 வருடம் முன்பு"
    },
    other: {
      default: "சுமார் {{count}} ஆண்டுகள்",
      in: "சுமார் {{count}} ஆண்டுகளில்",
      ago: "சுமார் {{count}} ஆண்டுகளுக்கு முன்பு"
    }
  },
  xYears: {
    one: {
      default: "1 வருடம்",
      in: "1 ஆண்டில்",
      ago: "1 வருடம் முன்பு"
    },
    other: {
      default: "{{count}} ஆண்டுகள்",
      in: "{{count}} ஆண்டுகளில்",
      ago: "{{count}} ஆண்டுகளுக்கு முன்பு"
    }
  },
  overXYears: {
    one: {
      default: "1 வருடத்திற்கு மேல்",
      in: "1 வருடத்திற்கும் மேலாக",
      ago: "1 வருடம் முன்பு"
    },
    other: {
      default: "{{count}} ஆண்டுகளுக்கும் மேலாக",
      in: "{{count}} ஆண்டுகளில்",
      ago: "{{count}} ஆண்டுகளுக்கு முன்பு"
    }
  },
  almostXYears: {
    one: {
      default: "கிட்டத்தட்ட 1 வருடம்",
      in: "கிட்டத்தட்ட 1 ஆண்டில்",
      ago: "கிட்டத்தட்ட 1 வருடம் முன்பு"
    },
    other: {
      default: "கிட்டத்தட்ட {{count}} ஆண்டுகள்",
      in: "கிட்டத்தட்ட {{count}} ஆண்டுகளில்",
      ago: "கிட்டத்தட்ட {{count}} ஆண்டுகளுக்கு முன்பு"
    }
  }
}, pgt = (e, t, r) => {
  const a = r?.addSuffix ? r.comparison && r.comparison > 0 ? "in" : "ago" : "default", i = hgt[e];
  return mgt(i) ? t === 1 ? i.one[a] : i.other[a].replace("{{count}}", String(t)) : i[a];
}, ggt = {
  full: "EEEE, d MMMM, y",
  long: "d MMMM, y",
  medium: "d MMM, y",
  short: "d/M/yy"
}, vgt = {
  full: "a h:mm:ss zzzz",
  long: "a h:mm:ss z",
  medium: "a h:mm:ss",
  short: "a h:mm"
}, bgt = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, ygt = {
  date: Ke({
    formats: ggt,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: vgt,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: bgt,
    defaultWidth: "full"
  })
}, wgt = {
  lastWeek: "'கடந்த' eeee p 'மணிக்கு'",
  yesterday: "'நேற்று ' p 'மணிக்கு'",
  today: "'இன்று ' p 'மணிக்கு'",
  tomorrow: "'நாளை ' p 'மணிக்கு'",
  nextWeek: "eeee p 'மணிக்கு'",
  other: "P"
}, Sgt = (e, t, r, a) => wgt[e], Cgt = {
  narrow: ["கி.மு.", "கி.பி."],
  abbreviated: ["கி.மு.", "கி.பி."],
  // CLDR #1624, #1626
  wide: ["கிறிஸ்துவுக்கு முன்", "அன்னோ டோமினி"]
  // CLDR #1620, #1622
}, xgt = {
  // CLDR #1644 - #1647
  narrow: ["1", "2", "3", "4"],
  // CLDR #1636 - #1639
  abbreviated: ["காலா.1", "காலா.2", "காலா.3", "காலா.4"],
  // CLDR #1628 - #1631
  wide: [
    "ஒன்றாம் காலாண்டு",
    "இரண்டாம் காலாண்டு",
    "மூன்றாம் காலாண்டு",
    "நான்காம் காலாண்டு"
  ]
}, Egt = {
  // CLDR #700 - #711
  narrow: ["ஜ", "பி", "மா", "ஏ", "மே", "ஜூ", "ஜூ", "ஆ", "செ", "அ", "ந", "டி"],
  // CLDR #1676 - #1687
  abbreviated: [
    "ஜன.",
    "பிப்.",
    "மார்.",
    "ஏப்.",
    "மே",
    "ஜூன்",
    "ஜூலை",
    "ஆக.",
    "செப்.",
    "அக்.",
    "நவ.",
    "டிச."
  ],
  // CLDR #1652 - #1663
  wide: [
    "ஜனவரி",
    // January
    "பிப்ரவரி",
    // February
    "மார்ச்",
    // March
    "ஏப்ரல்",
    // April
    "மே",
    // May
    "ஜூன்",
    // June
    "ஜூலை",
    // July
    "ஆகஸ்ட்",
    // August
    "செப்டம்பர்",
    // September
    "அக்டோபர்",
    // October
    "நவம்பர்",
    // November
    "டிசம்பர்"
    // December
  ]
}, Pgt = {
  // CLDR #1766 - #1772
  narrow: ["ஞா", "தி", "செ", "பு", "வி", "வெ", "ச"],
  // CLDR #1752 - #1758
  short: ["ஞா", "தி", "செ", "பு", "வி", "வெ", "ச"],
  // CLDR #1738 - #1744
  abbreviated: ["ஞாயி.", "திங்.", "செவ்.", "புத.", "வியா.", "வெள்.", "சனி"],
  // CLDR #1724 - #1730
  wide: [
    "ஞாயிறு",
    // Sunday
    "திங்கள்",
    // Monday
    "செவ்வாய்",
    // Tuesday
    "புதன்",
    // Wednesday
    "வியாழன்",
    // Thursday
    "வெள்ளி",
    // Friday
    "சனி"
    // Saturday
  ]
}, kgt = {
  narrow: {
    am: "மு.ப",
    pm: "பி.ப",
    midnight: "நள்.",
    noon: "நண்.",
    morning: "கா.",
    afternoon: "மதி.",
    evening: "மா.",
    night: "இர."
  },
  abbreviated: {
    am: "முற்பகல்",
    pm: "பிற்பகல்",
    midnight: "நள்ளிரவு",
    noon: "நண்பகல்",
    morning: "காலை",
    afternoon: "மதியம்",
    evening: "மாலை",
    night: "இரவு"
  },
  wide: {
    am: "முற்பகல்",
    pm: "பிற்பகல்",
    midnight: "நள்ளிரவு",
    noon: "நண்பகல்",
    morning: "காலை",
    afternoon: "மதியம்",
    evening: "மாலை",
    night: "இரவு"
  }
}, Mgt = {
  narrow: {
    am: "மு.ப",
    pm: "பி.ப",
    midnight: "நள்.",
    noon: "நண்.",
    morning: "கா.",
    afternoon: "மதி.",
    evening: "மா.",
    night: "இர."
  },
  abbreviated: {
    am: "முற்பகல்",
    pm: "பிற்பகல்",
    midnight: "நள்ளிரவு",
    noon: "நண்பகல்",
    morning: "காலை",
    afternoon: "மதியம்",
    evening: "மாலை",
    night: "இரவு"
  },
  wide: {
    am: "முற்பகல்",
    pm: "பிற்பகல்",
    midnight: "நள்ளிரவு",
    noon: "நண்பகல்",
    morning: "காலை",
    afternoon: "மதியம்",
    evening: "மாலை",
    night: "இரவு"
  }
}, Ogt = (e, t) => String(e), Tgt = {
  ordinalNumber: Ogt,
  era: Ce({
    values: Cgt,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: xgt,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: Egt,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: Pgt,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: kgt,
    defaultWidth: "wide",
    formattingValues: Mgt,
    defaultFormattingWidth: "wide"
  })
}, Rgt = /^(\d+)(வது)?/i, Agt = /\d+/i, Ngt = {
  narrow: /^(கி.மு.|கி.பி.)/i,
  abbreviated: /^(கி\.?\s?மு\.?|கி\.?\s?பி\.?)/,
  wide: /^(கிறிஸ்துவுக்கு\sமுன்|அன்னோ\sடோமினி)/i
}, Dgt = {
  any: [/கி\.?\s?மு\.?/, /கி\.?\s?பி\.?/]
}, $gt = {
  narrow: /^[1234]/i,
  abbreviated: /^காலா.[1234]/i,
  wide: /^(ஒன்றாம்|இரண்டாம்|மூன்றாம்|நான்காம்) காலாண்டு/i
}, zgt = {
  narrow: [/1/i, /2/i, /3/i, /4/i],
  any: [
    /(1|காலா.1|ஒன்றாம்)/i,
    /(2|காலா.2|இரண்டாம்)/i,
    /(3|காலா.3|மூன்றாம்)/i,
    /(4|காலா.4|நான்காம்)/i
  ]
}, jgt = {
  narrow: /^(ஜ|பி|மா|ஏ|மே|ஜூ|ஆ|செ|அ|ந|டி)$/i,
  abbreviated: /^(ஜன.|பிப்.|மார்.|ஏப்.|மே|ஜூன்|ஜூலை|ஆக.|செப்.|அக்.|நவ.|டிச.)/i,
  wide: /^(ஜனவரி|பிப்ரவரி|மார்ச்|ஏப்ரல்|மே|ஜூன்|ஜூலை|ஆகஸ்ட்|செப்டம்பர்|அக்டோபர்|நவம்பர்|டிசம்பர்)/i
}, Igt = {
  narrow: [
    /^ஜ$/i,
    /^பி/i,
    /^மா/i,
    /^ஏ/i,
    /^மே/i,
    /^ஜூ/i,
    /^ஜூ/i,
    /^ஆ/i,
    /^செ/i,
    /^அ/i,
    /^ந/i,
    /^டி/i
  ],
  any: [
    /^ஜன/i,
    /^பி/i,
    /^மா/i,
    /^ஏ/i,
    /^மே/i,
    /^ஜூன்/i,
    /^ஜூலை/i,
    /^ஆ/i,
    /^செ/i,
    /^அ/i,
    /^ந/i,
    /^டி/i
  ]
}, Lgt = {
  narrow: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
  short: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
  abbreviated: /^(ஞாயி.|திங்.|செவ்.|புத.|வியா.|வெள்.|சனி)/i,
  wide: /^(ஞாயிறு|திங்கள்|செவ்வாய்|புதன்|வியாழன்|வெள்ளி|சனி)/i
}, Hgt = {
  narrow: [/^ஞா/i, /^தி/i, /^செ/i, /^பு/i, /^வி/i, /^வெ/i, /^ச/i],
  any: [/^ஞா/i, /^தி/i, /^செ/i, /^பு/i, /^வி/i, /^வெ/i, /^ச/i]
}, Fgt = {
  narrow: /^(மு.ப|பி.ப|நள்|நண்|காலை|மதியம்|மாலை|இரவு)/i,
  any: /^(மு.ப|பி.ப|முற்பகல்|பிற்பகல்|நள்ளிரவு|நண்பகல்|காலை|மதியம்|மாலை|இரவு)/i
}, Wgt = {
  any: {
    am: /^மு/i,
    pm: /^பி/i,
    midnight: /^நள்/i,
    noon: /^நண்/i,
    morning: /காலை/i,
    afternoon: /மதியம்/i,
    evening: /மாலை/i,
    night: /இரவு/i
  }
}, Vgt = {
  ordinalNumber: Fn({
    matchPattern: Rgt,
    parsePattern: Agt,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: Ngt,
    defaultMatchWidth: "wide",
    parsePatterns: Dgt,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: $gt,
    defaultMatchWidth: "wide",
    parsePatterns: zgt,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: jgt,
    defaultMatchWidth: "wide",
    parsePatterns: Igt,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: Lgt,
    defaultMatchWidth: "wide",
    parsePatterns: Hgt,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: Fgt,
    defaultMatchWidth: "any",
    parsePatterns: Wgt,
    defaultParseWidth: "any"
  })
}, _gt = {
  code: "ta",
  formatDistance: pgt,
  formatLong: ygt,
  formatRelative: Sgt,
  localize: Tgt,
  match: Vgt,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, lU = {
  lessThanXSeconds: {
    standalone: {
      one: "సెకను కన్నా తక్కువ",
      other: "{{count}} సెకన్ల కన్నా తక్కువ"
    },
    withPreposition: {
      one: "సెకను",
      other: "{{count}} సెకన్ల"
    }
  },
  xSeconds: {
    standalone: {
      one: "ఒక సెకను",
      // CLDR #1314
      other: "{{count}} సెకన్ల"
    },
    withPreposition: {
      one: "ఒక సెకను",
      other: "{{count}} సెకన్ల"
    }
  },
  halfAMinute: {
    standalone: "అర నిమిషం",
    withPreposition: "అర నిమిషం"
  },
  lessThanXMinutes: {
    standalone: {
      one: "ఒక నిమిషం కన్నా తక్కువ",
      other: "{{count}} నిమిషాల కన్నా తక్కువ"
    },
    withPreposition: {
      one: "ఒక నిమిషం",
      other: "{{count}} నిమిషాల"
    }
  },
  xMinutes: {
    standalone: {
      one: "ఒక నిమిషం",
      // CLDR #1311
      other: "{{count}} నిమిషాలు"
    },
    withPreposition: {
      one: "ఒక నిమిషం",
      // CLDR #1311
      other: "{{count}} నిమిషాల"
    }
  },
  aboutXHours: {
    standalone: {
      one: "సుమారు ఒక గంట",
      other: "సుమారు {{count}} గంటలు"
    },
    withPreposition: {
      one: "సుమారు ఒక గంట",
      other: "సుమారు {{count}} గంటల"
    }
  },
  xHours: {
    standalone: {
      one: "ఒక గంట",
      // CLDR #1308
      other: "{{count}} గంటలు"
    },
    withPreposition: {
      one: "ఒక గంట",
      other: "{{count}} గంటల"
    }
  },
  xDays: {
    standalone: {
      one: "ఒక రోజు",
      // CLDR #1292
      other: "{{count}} రోజులు"
    },
    withPreposition: {
      one: "ఒక రోజు",
      other: "{{count}} రోజుల"
    }
  },
  aboutXWeeks: {
    standalone: {
      one: "సుమారు ఒక వారం",
      other: "సుమారు {{count}} వారాలు"
    },
    withPreposition: {
      one: "సుమారు ఒక వారం",
      other: "సుమారు {{count}} వారాలల"
    }
  },
  xWeeks: {
    standalone: {
      one: "ఒక వారం",
      other: "{{count}} వారాలు"
    },
    withPreposition: {
      one: "ఒక వారం",
      other: "{{count}} వారాలల"
    }
  },
  aboutXMonths: {
    standalone: {
      one: "సుమారు ఒక నెల",
      other: "సుమారు {{count}} నెలలు"
    },
    withPreposition: {
      one: "సుమారు ఒక నెల",
      other: "సుమారు {{count}} నెలల"
    }
  },
  xMonths: {
    standalone: {
      one: "ఒక నెల",
      // CLDR #1281
      other: "{{count}} నెలలు"
    },
    withPreposition: {
      one: "ఒక నెల",
      other: "{{count}} నెలల"
    }
  },
  aboutXYears: {
    standalone: {
      one: "సుమారు ఒక సంవత్సరం",
      other: "సుమారు {{count}} సంవత్సరాలు"
    },
    withPreposition: {
      one: "సుమారు ఒక సంవత్సరం",
      other: "సుమారు {{count}} సంవత్సరాల"
    }
  },
  xYears: {
    standalone: {
      one: "ఒక సంవత్సరం",
      // CLDR #1275
      other: "{{count}} సంవత్సరాలు"
    },
    withPreposition: {
      one: "ఒక సంవత్సరం",
      other: "{{count}} సంవత్సరాల"
    }
  },
  overXYears: {
    standalone: {
      one: "ఒక సంవత్సరం పైగా",
      other: "{{count}} సంవత్సరాలకు పైగా"
    },
    withPreposition: {
      one: "ఒక సంవత్సరం",
      other: "{{count}} సంవత్సరాల"
    }
  },
  almostXYears: {
    standalone: {
      one: "దాదాపు ఒక సంవత్సరం",
      other: "దాదాపు {{count}} సంవత్సరాలు"
    },
    withPreposition: {
      one: "దాదాపు ఒక సంవత్సరం",
      other: "దాదాపు {{count}} సంవత్సరాల"
    }
  }
}, Bgt = (e, t, r) => {
  let a;
  const i = r?.addSuffix ? lU[e].withPreposition : lU[e].standalone;
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? a + "లో" : a + " క్రితం" : a;
}, Ugt = {
  full: "d, MMMM y, EEEE",
  long: "d MMMM, y",
  medium: "d MMM, y",
  short: "dd-MM-yy"
}, Xgt = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Ggt = {
  full: "{{date}} {{time}}'కి'",
  long: "{{date}} {{time}}'కి'",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, qgt = {
  date: Ke({
    formats: Ugt,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: Xgt,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: Ggt,
    defaultWidth: "full"
  })
}, Kgt = {
  lastWeek: "'గత' eeee p",
  // CLDR #1384
  yesterday: "'నిన్న' p",
  // CLDR #1393
  today: "'ఈ రోజు' p",
  // CLDR #1394
  tomorrow: "'రేపు' p",
  // CLDR #1395
  nextWeek: "'తదుపరి' eeee p",
  // CLDR #1386
  other: "P"
}, Ygt = (e, t, r, a) => Kgt[e], Qgt = {
  narrow: ["క్రీ.పూ.", "క్రీ.శ."],
  abbreviated: ["క్రీ.పూ.", "క్రీ.శ."],
  wide: ["క్రీస్తు పూర్వం", "క్రీస్తుశకం"]
}, Jgt = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["త్రై1", "త్రై2", "త్రై3", "త్రై4"],
  wide: ["1వ త్రైమాసికం", "2వ త్రైమాసికం", "3వ త్రైమాసికం", "4వ త్రైమాసికం"]
}, Zgt = {
  narrow: ["జ", "ఫి", "మా", "ఏ", "మే", "జూ", "జు", "ఆ", "సె", "అ", "న", "డి"],
  abbreviated: [
    "జన",
    "ఫిబ్ర",
    "మార్చి",
    "ఏప్రి",
    "మే",
    "జూన్",
    "జులై",
    "ఆగ",
    "సెప్టెం",
    "అక్టో",
    "నవం",
    "డిసెం"
  ],
  wide: [
    "జనవరి",
    "ఫిబ్రవరి",
    "మార్చి",
    "ఏప్రిల్",
    "మే",
    "జూన్",
    "జులై",
    "ఆగస్టు",
    "సెప్టెంబర్",
    "అక్టోబర్",
    "నవంబర్",
    "డిసెంబర్"
  ]
}, e0t = {
  narrow: ["ఆ", "సో", "మ", "బు", "గు", "శు", "శ"],
  short: ["ఆది", "సోమ", "మంగళ", "బుధ", "గురు", "శుక్ర", "శని"],
  abbreviated: ["ఆది", "సోమ", "మంగళ", "బుధ", "గురు", "శుక్ర", "శని"],
  wide: [
    "ఆదివారం",
    "సోమవారం",
    "మంగళవారం",
    "బుధవారం",
    "గురువారం",
    "శుక్రవారం",
    "శనివారం"
  ]
}, t0t = {
  narrow: {
    am: "పూర్వాహ్నం",
    pm: "అపరాహ్నం",
    midnight: "అర్ధరాత్రి",
    noon: "మిట్టమధ్యాహ్నం",
    morning: "ఉదయం",
    afternoon: "మధ్యాహ్నం",
    evening: "సాయంత్రం",
    night: "రాత్రి"
  },
  abbreviated: {
    am: "పూర్వాహ్నం",
    pm: "అపరాహ్నం",
    midnight: "అర్ధరాత్రి",
    noon: "మిట్టమధ్యాహ్నం",
    morning: "ఉదయం",
    afternoon: "మధ్యాహ్నం",
    evening: "సాయంత్రం",
    night: "రాత్రి"
  },
  wide: {
    am: "పూర్వాహ్నం",
    pm: "అపరాహ్నం",
    midnight: "అర్ధరాత్రి",
    noon: "మిట్టమధ్యాహ్నం",
    morning: "ఉదయం",
    afternoon: "మధ్యాహ్నం",
    evening: "సాయంత్రం",
    night: "రాత్రి"
  }
}, n0t = {
  narrow: {
    am: "పూర్వాహ్నం",
    pm: "అపరాహ్నం",
    midnight: "అర్ధరాత్రి",
    noon: "మిట్టమధ్యాహ్నం",
    morning: "ఉదయం",
    afternoon: "మధ్యాహ్నం",
    evening: "సాయంత్రం",
    night: "రాత్రి"
  },
  abbreviated: {
    am: "పూర్వాహ్నం",
    pm: "అపరాహ్నం",
    midnight: "అర్ధరాత్రి",
    noon: "మిట్టమధ్యాహ్నం",
    morning: "ఉదయం",
    afternoon: "మధ్యాహ్నం",
    evening: "సాయంత్రం",
    night: "రాత్రి"
  },
  wide: {
    am: "పూర్వాహ్నం",
    pm: "అపరాహ్నం",
    midnight: "అర్ధరాత్రి",
    noon: "మిట్టమధ్యాహ్నం",
    morning: "ఉదయం",
    afternoon: "మధ్యాహ్నం",
    evening: "సాయంత్రం",
    night: "రాత్రి"
  }
}, r0t = (e, t) => Number(e) + "వ", a0t = {
  ordinalNumber: r0t,
  era: Ce({
    values: Qgt,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: Jgt,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: Zgt,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: e0t,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: t0t,
    defaultWidth: "wide",
    formattingValues: n0t,
    defaultFormattingWidth: "wide"
  })
}, o0t = /^(\d+)(వ)?/i, i0t = /\d+/i, l0t = {
  narrow: /^(క్రీ\.పూ\.|క్రీ\.శ\.)/i,
  abbreviated: /^(క్రీ\.?\s?పూ\.?|ప్ర\.?\s?శ\.?\s?పూ\.?|క్రీ\.?\s?శ\.?|సా\.?\s?శ\.?)/i,
  wide: /^(క్రీస్తు పూర్వం|ప్రస్తుత శకానికి పూర్వం|క్రీస్తు శకం|ప్రస్తుత శకం)/i
}, s0t = {
  any: [/^(పూ|శ)/i, /^సా/i]
}, u0t = {
  narrow: /^[1234]/i,
  abbreviated: /^త్రై[1234]/i,
  wide: /^[1234](వ)? త్రైమాసికం/i
}, c0t = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, d0t = {
  narrow: /^(జూ|జు|జ|ఫి|మా|ఏ|మే|ఆ|సె|అ|న|డి)/i,
  abbreviated: /^(జన|ఫిబ్ర|మార్చి|ఏప్రి|మే|జూన్|జులై|ఆగ|సెప్|అక్టో|నవ|డిసె)/i,
  wide: /^(జనవరి|ఫిబ్రవరి|మార్చి|ఏప్రిల్|మే|జూన్|జులై|ఆగస్టు|సెప్టెంబర్|అక్టోబర్|నవంబర్|డిసెంబర్)/i
}, f0t = {
  narrow: [
    /^జ/i,
    /^ఫి/i,
    /^మా/i,
    /^ఏ/i,
    /^మే/i,
    /^జూ/i,
    /^జు/i,
    /^ఆ/i,
    /^సె/i,
    /^అ/i,
    /^న/i,
    /^డి/i
  ],
  any: [
    /^జన/i,
    /^ఫి/i,
    /^మా/i,
    /^ఏ/i,
    /^మే/i,
    /^జూన్/i,
    /^జులై/i,
    /^ఆగ/i,
    /^సె/i,
    /^అ/i,
    /^న/i,
    /^డి/i
  ]
}, m0t = {
  narrow: /^(ఆ|సో|మ|బు|గు|శు|శ)/i,
  short: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
  abbreviated: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
  wide: /^(ఆదివారం|సోమవారం|మంగళవారం|బుధవారం|గురువారం|శుక్రవారం|శనివారం)/i
}, h0t = {
  narrow: [/^ఆ/i, /^సో/i, /^మ/i, /^బు/i, /^గు/i, /^శు/i, /^శ/i],
  any: [/^ఆది/i, /^సోమ/i, /^మం/i, /^బుధ/i, /^గురు/i, /^శుక్ర/i, /^శని/i]
}, p0t = {
  narrow: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i,
  any: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i
}, g0t = {
  any: {
    am: /^పూర్వాహ్నం/i,
    pm: /^అపరాహ్నం/i,
    midnight: /^అర్ధ/i,
    noon: /^మిట్ట/i,
    morning: /ఉదయం/i,
    afternoon: /మధ్యాహ్నం/i,
    evening: /సాయంత్రం/i,
    night: /రాత్రి/i
  }
}, v0t = {
  ordinalNumber: Fn({
    matchPattern: o0t,
    parsePattern: i0t,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: l0t,
    defaultMatchWidth: "wide",
    parsePatterns: s0t,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: u0t,
    defaultMatchWidth: "wide",
    parsePatterns: c0t,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: d0t,
    defaultMatchWidth: "wide",
    parsePatterns: f0t,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: m0t,
    defaultMatchWidth: "wide",
    parsePatterns: h0t,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: p0t,
    defaultMatchWidth: "any",
    parsePatterns: g0t,
    defaultParseWidth: "any"
  })
}, b0t = {
  code: "te",
  formatDistance: Bgt,
  formatLong: qgt,
  formatRelative: Ygt,
  localize: a0t,
  match: v0t,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, y0t = {
  lessThanXSeconds: {
    one: "น้อยกว่า 1 วินาที",
    other: "น้อยกว่า {{count}} วินาที"
  },
  xSeconds: {
    one: "1 วินาที",
    other: "{{count}} วินาที"
  },
  halfAMinute: "ครึ่งนาที",
  lessThanXMinutes: {
    one: "น้อยกว่า 1 นาที",
    other: "น้อยกว่า {{count}} นาที"
  },
  xMinutes: {
    one: "1 นาที",
    other: "{{count}} นาที"
  },
  aboutXHours: {
    one: "ประมาณ 1 ชั่วโมง",
    other: "ประมาณ {{count}} ชั่วโมง"
  },
  xHours: {
    one: "1 ชั่วโมง",
    other: "{{count}} ชั่วโมง"
  },
  xDays: {
    one: "1 วัน",
    other: "{{count}} วัน"
  },
  aboutXWeeks: {
    one: "ประมาณ 1 สัปดาห์",
    other: "ประมาณ {{count}} สัปดาห์"
  },
  xWeeks: {
    one: "1 สัปดาห์",
    other: "{{count}} สัปดาห์"
  },
  aboutXMonths: {
    one: "ประมาณ 1 เดือน",
    other: "ประมาณ {{count}} เดือน"
  },
  xMonths: {
    one: "1 เดือน",
    other: "{{count}} เดือน"
  },
  aboutXYears: {
    one: "ประมาณ 1 ปี",
    other: "ประมาณ {{count}} ปี"
  },
  xYears: {
    one: "1 ปี",
    other: "{{count}} ปี"
  },
  overXYears: {
    one: "มากกว่า 1 ปี",
    other: "มากกว่า {{count}} ปี"
  },
  almostXYears: {
    one: "เกือบ 1 ปี",
    other: "เกือบ {{count}} ปี"
  }
}, w0t = (e, t, r) => {
  let a;
  const i = y0t[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? e === "halfAMinute" ? "ใน" + a : "ใน " + a : a + "ที่ผ่านมา" : a;
}, S0t = {
  full: "วันEEEEที่ do MMMM y",
  long: "do MMMM y",
  medium: "d MMM y",
  short: "dd/MM/yyyy"
}, C0t = {
  full: "H:mm:ss น. zzzz",
  long: "H:mm:ss น. z",
  medium: "H:mm:ss น.",
  short: "H:mm น."
}, x0t = {
  full: "{{date}} 'เวลา' {{time}}",
  long: "{{date}} 'เวลา' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, E0t = {
  date: Ke({
    formats: S0t,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: C0t,
    defaultWidth: "medium"
  }),
  dateTime: Ke({
    formats: x0t,
    defaultWidth: "full"
  })
}, P0t = {
  lastWeek: "eeee'ที่แล้วเวลา' p",
  yesterday: "'เมื่อวานนี้เวลา' p",
  today: "'วันนี้เวลา' p",
  tomorrow: "'พรุ่งนี้เวลา' p",
  nextWeek: "eeee 'เวลา' p",
  other: "P"
}, k0t = (e, t, r, a) => P0t[e], M0t = {
  narrow: ["B", "คศ"],
  abbreviated: ["BC", "ค.ศ."],
  wide: ["ปีก่อนคริสตกาล", "คริสต์ศักราช"]
}, O0t = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["ไตรมาสแรก", "ไตรมาสที่สอง", "ไตรมาสที่สาม", "ไตรมาสที่สี่"]
}, T0t = {
  narrow: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
  short: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
  abbreviated: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
  wide: ["อาทิตย์", "จันทร์", "อังคาร", "พุธ", "พฤหัสบดี", "ศุกร์", "เสาร์"]
}, R0t = {
  narrow: [
    "ม.ค.",
    "ก.พ.",
    "มี.ค.",
    "เม.ย.",
    "พ.ค.",
    "มิ.ย.",
    "ก.ค.",
    "ส.ค.",
    "ก.ย.",
    "ต.ค.",
    "พ.ย.",
    "ธ.ค."
  ],
  abbreviated: [
    "ม.ค.",
    "ก.พ.",
    "มี.ค.",
    "เม.ย.",
    "พ.ค.",
    "มิ.ย.",
    "ก.ค.",
    "ส.ค.",
    "ก.ย.",
    "ต.ค.",
    "พ.ย.",
    "ธ.ค."
  ],
  wide: [
    "มกราคม",
    "กุมภาพันธ์",
    "มีนาคม",
    "เมษายน",
    "พฤษภาคม",
    "มิถุนายน",
    "กรกฎาคม",
    "สิงหาคม",
    "กันยายน",
    "ตุลาคม",
    "พฤศจิกายน",
    "ธันวาคม"
  ]
}, A0t = {
  narrow: {
    am: "ก่อนเที่ยง",
    pm: "หลังเที่ยง",
    midnight: "เที่ยงคืน",
    noon: "เที่ยง",
    morning: "เช้า",
    afternoon: "บ่าย",
    evening: "เย็น",
    night: "กลางคืน"
  },
  abbreviated: {
    am: "ก่อนเที่ยง",
    pm: "หลังเที่ยง",
    midnight: "เที่ยงคืน",
    noon: "เที่ยง",
    morning: "เช้า",
    afternoon: "บ่าย",
    evening: "เย็น",
    night: "กลางคืน"
  },
  wide: {
    am: "ก่อนเที่ยง",
    pm: "หลังเที่ยง",
    midnight: "เที่ยงคืน",
    noon: "เที่ยง",
    morning: "เช้า",
    afternoon: "บ่าย",
    evening: "เย็น",
    night: "กลางคืน"
  }
}, N0t = {
  narrow: {
    am: "ก่อนเที่ยง",
    pm: "หลังเที่ยง",
    midnight: "เที่ยงคืน",
    noon: "เที่ยง",
    morning: "ตอนเช้า",
    afternoon: "ตอนกลางวัน",
    evening: "ตอนเย็น",
    night: "ตอนกลางคืน"
  },
  abbreviated: {
    am: "ก่อนเที่ยง",
    pm: "หลังเที่ยง",
    midnight: "เที่ยงคืน",
    noon: "เที่ยง",
    morning: "ตอนเช้า",
    afternoon: "ตอนกลางวัน",
    evening: "ตอนเย็น",
    night: "ตอนกลางคืน"
  },
  wide: {
    am: "ก่อนเที่ยง",
    pm: "หลังเที่ยง",
    midnight: "เที่ยงคืน",
    noon: "เที่ยง",
    morning: "ตอนเช้า",
    afternoon: "ตอนกลางวัน",
    evening: "ตอนเย็น",
    night: "ตอนกลางคืน"
  }
}, D0t = (e, t) => String(e), $0t = {
  ordinalNumber: D0t,
  era: Ce({
    values: M0t,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: O0t,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: R0t,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: T0t,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: A0t,
    defaultWidth: "wide",
    formattingValues: N0t,
    defaultFormattingWidth: "wide"
  })
}, z0t = /^\d+/i, j0t = /\d+/i, I0t = {
  narrow: /^([bB]|[aA]|คศ)/i,
  abbreviated: /^([bB]\.?\s?[cC]\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?|ค\.?ศ\.?)/i,
  wide: /^(ก่อนคริสตกาล|คริสต์ศักราช|คริสตกาล)/i
}, L0t = {
  any: [/^[bB]/i, /^(^[aA]|ค\.?ศ\.?|คริสตกาล|คริสต์ศักราช|)/i]
}, H0t = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^ไตรมาส(ที่)? ?[1234]/i
}, F0t = {
  any: [/(1|แรก|หนึ่ง)/i, /(2|สอง)/i, /(3|สาม)/i, /(4|สี่)/i]
}, W0t = {
  narrow: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?)/i,
  abbreviated: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?')/i,
  wide: /^(มกราคม|กุมภาพันธ์|มีนาคม|เมษายน|พฤษภาคม|มิถุนายน|กรกฎาคม|สิงหาคม|กันยายน|ตุลาคม|พฤศจิกายน|ธันวาคม)/i
}, V0t = {
  wide: [
    /^มก/i,
    /^กุม/i,
    /^มี/i,
    /^เม/i,
    /^พฤษ/i,
    /^มิ/i,
    /^กรก/i,
    /^ส/i,
    /^กัน/i,
    /^ต/i,
    /^พฤศ/i,
    /^ธ/i
  ],
  any: [
    /^ม\.?ค\.?/i,
    /^ก\.?พ\.?/i,
    /^มี\.?ค\.?/i,
    /^เม\.?ย\.?/i,
    /^พ\.?ค\.?/i,
    /^มิ\.?ย\.?/i,
    /^ก\.?ค\.?/i,
    /^ส\.?ค\.?/i,
    /^ก\.?ย\.?/i,
    /^ต\.?ค\.?/i,
    /^พ\.?ย\.?/i,
    /^ธ\.?ค\.?/i
  ]
}, _0t = {
  narrow: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
  short: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
  abbreviated: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
  wide: /^(อาทิตย์|จันทร์|อังคาร|พุธ|พฤหัสบดี|ศุกร์|เสาร์)/i
}, B0t = {
  wide: [/^อา/i, /^จั/i, /^อั/i, /^พุธ/i, /^พฤ/i, /^ศ/i, /^เส/i],
  any: [/^อา/i, /^จ/i, /^อ/i, /^พ(?!ฤ)/i, /^พฤ/i, /^ศ/i, /^ส/i]
}, U0t = {
  any: /^(ก่อนเที่ยง|หลังเที่ยง|เที่ยงคืน|เที่ยง|(ตอน.*?)?.*(เที่ยง|เช้า|บ่าย|เย็น|กลางคืน))/i
}, X0t = {
  any: {
    am: /^ก่อนเที่ยง/i,
    pm: /^หลังเที่ยง/i,
    midnight: /^เที่ยงคืน/i,
    noon: /^เที่ยง/i,
    morning: /เช้า/i,
    afternoon: /บ่าย/i,
    evening: /เย็น/i,
    night: /กลางคืน/i
  }
}, G0t = {
  ordinalNumber: Fn({
    matchPattern: z0t,
    parsePattern: j0t,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: I0t,
    defaultMatchWidth: "wide",
    parsePatterns: L0t,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: H0t,
    defaultMatchWidth: "wide",
    parsePatterns: F0t,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: W0t,
    defaultMatchWidth: "wide",
    parsePatterns: V0t,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: _0t,
    defaultMatchWidth: "wide",
    parsePatterns: B0t,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: U0t,
    defaultMatchWidth: "any",
    parsePatterns: X0t,
    defaultParseWidth: "any"
  })
}, q0t = {
  code: "th",
  formatDistance: w0t,
  formatLong: E0t,
  formatRelative: k0t,
  localize: $0t,
  match: G0t,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, K0t = {
  lessThanXSeconds: {
    one: "bir saniyeden az",
    other: "{{count}} saniyeden az"
  },
  xSeconds: {
    one: "1 saniye",
    other: "{{count}} saniye"
  },
  halfAMinute: "yarım dakika",
  lessThanXMinutes: {
    one: "bir dakikadan az",
    other: "{{count}} dakikadan az"
  },
  xMinutes: {
    one: "1 dakika",
    other: "{{count}} dakika"
  },
  aboutXHours: {
    one: "yaklaşık 1 saat",
    other: "yaklaşık {{count}} saat"
  },
  xHours: {
    one: "1 saat",
    other: "{{count}} saat"
  },
  xDays: {
    one: "1 gün",
    other: "{{count}} gün"
  },
  aboutXWeeks: {
    one: "yaklaşık 1 hafta",
    other: "yaklaşık {{count}} hafta"
  },
  xWeeks: {
    one: "1 hafta",
    other: "{{count}} hafta"
  },
  aboutXMonths: {
    one: "yaklaşık 1 ay",
    other: "yaklaşık {{count}} ay"
  },
  xMonths: {
    one: "1 ay",
    other: "{{count}} ay"
  },
  aboutXYears: {
    one: "yaklaşık 1 yıl",
    other: "yaklaşık {{count}} yıl"
  },
  xYears: {
    one: "1 yıl",
    other: "{{count}} yıl"
  },
  overXYears: {
    one: "1 yıldan fazla",
    other: "{{count}} yıldan fazla"
  },
  almostXYears: {
    one: "neredeyse 1 yıl",
    other: "neredeyse {{count}} yıl"
  }
}, Y0t = (e, t, r) => {
  let a;
  const i = K0t[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", t.toString()), r?.addSuffix ? r.comparison && r.comparison > 0 ? a + " sonra" : a + " önce" : a;
}, Q0t = {
  full: "d MMMM y EEEE",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd.MM.yyyy"
}, J0t = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Z0t = {
  full: "{{date}} 'saat' {{time}}",
  long: "{{date}} 'saat' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, evt = {
  date: Ke({
    formats: Q0t,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: J0t,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: Z0t,
    defaultWidth: "full"
  })
}, tvt = {
  lastWeek: "'geçen hafta' eeee 'saat' p",
  yesterday: "'dün saat' p",
  today: "'bugün saat' p",
  tomorrow: "'yarın saat' p",
  nextWeek: "eeee 'saat' p",
  other: "P"
}, nvt = (e, t, r, a) => tvt[e], rvt = {
  narrow: ["MÖ", "MS"],
  abbreviated: ["MÖ", "MS"],
  wide: ["Milattan Önce", "Milattan Sonra"]
}, avt = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1Ç", "2Ç", "3Ç", "4Ç"],
  wide: ["İlk çeyrek", "İkinci Çeyrek", "Üçüncü çeyrek", "Son çeyrek"]
}, ovt = {
  narrow: ["O", "Ş", "M", "N", "M", "H", "T", "A", "E", "E", "K", "A"],
  abbreviated: [
    "Oca",
    "Şub",
    "Mar",
    "Nis",
    "May",
    "Haz",
    "Tem",
    "Ağu",
    "Eyl",
    "Eki",
    "Kas",
    "Ara"
  ],
  wide: [
    "Ocak",
    "Şubat",
    "Mart",
    "Nisan",
    "Mayıs",
    "Haziran",
    "Temmuz",
    "Ağustos",
    "Eylül",
    "Ekim",
    "Kasım",
    "Aralık"
  ]
}, ivt = {
  narrow: ["P", "P", "S", "Ç", "P", "C", "C"],
  short: ["Pz", "Pt", "Sa", "Ça", "Pe", "Cu", "Ct"],
  abbreviated: ["Paz", "Pzt", "Sal", "Çar", "Per", "Cum", "Cts"],
  wide: [
    "Pazar",
    "Pazartesi",
    "Salı",
    "Çarşamba",
    "Perşembe",
    "Cuma",
    "Cumartesi"
  ]
}, lvt = {
  narrow: {
    am: "öö",
    pm: "ös",
    midnight: "gy",
    noon: "ö",
    morning: "sa",
    afternoon: "ös",
    evening: "ak",
    night: "ge"
  },
  abbreviated: {
    am: "ÖÖ",
    pm: "ÖS",
    midnight: "gece yarısı",
    noon: "öğle",
    morning: "sabah",
    afternoon: "öğleden sonra",
    evening: "akşam",
    night: "gece"
  },
  wide: {
    am: "Ö.Ö.",
    pm: "Ö.S.",
    midnight: "gece yarısı",
    noon: "öğle",
    morning: "sabah",
    afternoon: "öğleden sonra",
    evening: "akşam",
    night: "gece"
  }
}, svt = {
  narrow: {
    am: "öö",
    pm: "ös",
    midnight: "gy",
    noon: "ö",
    morning: "sa",
    afternoon: "ös",
    evening: "ak",
    night: "ge"
  },
  abbreviated: {
    am: "ÖÖ",
    pm: "ÖS",
    midnight: "gece yarısı",
    noon: "öğlen",
    morning: "sabahleyin",
    afternoon: "öğleden sonra",
    evening: "akşamleyin",
    night: "geceleyin"
  },
  wide: {
    am: "ö.ö.",
    pm: "ö.s.",
    midnight: "gece yarısı",
    noon: "öğlen",
    morning: "sabahleyin",
    afternoon: "öğleden sonra",
    evening: "akşamleyin",
    night: "geceleyin"
  }
}, uvt = (e, t) => Number(e) + ".", cvt = {
  ordinalNumber: uvt,
  era: Ce({
    values: rvt,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: avt,
    defaultWidth: "wide",
    argumentCallback: (e) => Number(e) - 1
  }),
  month: Ce({
    values: ovt,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: ivt,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: lvt,
    defaultWidth: "wide",
    formattingValues: svt,
    defaultFormattingWidth: "wide"
  })
}, dvt = /^(\d+)(\.)?/i, fvt = /\d+/i, mvt = {
  narrow: /^(mö|ms)/i,
  abbreviated: /^(mö|ms)/i,
  wide: /^(milattan önce|milattan sonra)/i
}, hvt = {
  any: [/(^mö|^milattan önce)/i, /(^ms|^milattan sonra)/i]
}, pvt = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]ç/i,
  wide: /^((i|İ)lk|(i|İ)kinci|üçüncü|son) çeyrek/i
}, gvt = {
  any: [/1/i, /2/i, /3/i, /4/i],
  abbreviated: [/1ç/i, /2ç/i, /3ç/i, /4ç/i],
  wide: [
    /^(i|İ)lk çeyrek/i,
    /(i|İ)kinci çeyrek/i,
    /üçüncü çeyrek/i,
    /son çeyrek/i
  ]
}, vvt = {
  narrow: /^[oşmnhtaek]/i,
  abbreviated: /^(oca|şub|mar|nis|may|haz|tem|ağu|eyl|eki|kas|ara)/i,
  wide: /^(ocak|şubat|mart|nisan|mayıs|haziran|temmuz|ağustos|eylül|ekim|kasım|aralık)/i
}, bvt = {
  narrow: [
    /^o/i,
    /^ş/i,
    /^m/i,
    /^n/i,
    /^m/i,
    /^h/i,
    /^t/i,
    /^a/i,
    /^e/i,
    /^e/i,
    /^k/i,
    /^a/i
  ],
  any: [
    /^o/i,
    /^ş/i,
    /^mar/i,
    /^n/i,
    /^may/i,
    /^h/i,
    /^t/i,
    /^ağ/i,
    /^ey/i,
    /^ek/i,
    /^k/i,
    /^ar/i
  ]
}, yvt = {
  narrow: /^[psçc]/i,
  short: /^(pz|pt|sa|ça|pe|cu|ct)/i,
  abbreviated: /^(paz|pzt|sal|çar|per|cum|cts)/i,
  wide: /^(pazar(?!tesi)|pazartesi|salı|çarşamba|perşembe|cuma(?!rtesi)|cumartesi)/i
}, wvt = {
  narrow: [/^p/i, /^p/i, /^s/i, /^ç/i, /^p/i, /^c/i, /^c/i],
  any: [/^pz/i, /^pt/i, /^sa/i, /^ça/i, /^pe/i, /^cu/i, /^ct/i],
  wide: [
    /^pazar(?!tesi)/i,
    /^pazartesi/i,
    /^salı/i,
    /^çarşamba/i,
    /^perşembe/i,
    /^cuma(?!rtesi)/i,
    /^cumartesi/i
  ]
}, Svt = {
  narrow: /^(öö|ös|gy|ö|sa|ös|ak|ge)/i,
  any: /^(ö\.?\s?[ös]\.?|öğleden sonra|gece yarısı|öğle|(sabah|öğ|akşam|gece)(leyin))/i
}, Cvt = {
  any: {
    am: /^ö\.?ö\.?/i,
    pm: /^ö\.?s\.?/i,
    midnight: /^(gy|gece yarısı)/i,
    noon: /^öğ/i,
    morning: /^sa/i,
    afternoon: /^öğleden sonra/i,
    evening: /^ak/i,
    night: /^ge/i
  }
}, xvt = {
  ordinalNumber: Fn({
    matchPattern: dvt,
    parsePattern: fvt,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: Ee({
    matchPatterns: mvt,
    defaultMatchWidth: "wide",
    parsePatterns: hvt,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: pvt,
    defaultMatchWidth: "wide",
    parsePatterns: gvt,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: vvt,
    defaultMatchWidth: "wide",
    parsePatterns: bvt,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: yvt,
    defaultMatchWidth: "wide",
    parsePatterns: wvt,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: Svt,
    defaultMatchWidth: "any",
    parsePatterns: Cvt,
    defaultParseWidth: "any"
  })
}, Evt = {
  code: "tr",
  formatDistance: Y0t,
  formatLong: evt,
  formatRelative: nvt,
  localize: cvt,
  match: xvt,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, Pvt = {
  lessThanXSeconds: {
    one: "بىر سىكۇنت ئىچىدە",
    other: "سىكۇنت ئىچىدە {{count}}"
  },
  xSeconds: {
    one: "بىر سىكۇنت",
    other: "سىكۇنت {{count}}"
  },
  halfAMinute: "يىرىم مىنۇت",
  lessThanXMinutes: {
    one: "بىر مىنۇت ئىچىدە",
    other: "مىنۇت ئىچىدە {{count}}"
  },
  xMinutes: {
    one: "بىر مىنۇت",
    other: "مىنۇت {{count}}"
  },
  aboutXHours: {
    one: "تەخمىنەن بىر سائەت",
    other: "سائەت {{count}} تەخمىنەن"
  },
  xHours: {
    one: "بىر سائەت",
    other: "سائەت {{count}}"
  },
  xDays: {
    one: "بىر كۈن",
    other: "كۈن {{count}}"
  },
  aboutXWeeks: {
    one: "تەخمىنەن بىرھەپتە",
    other: "ھەپتە {{count}} تەخمىنەن"
  },
  xWeeks: {
    one: "بىرھەپتە",
    other: "ھەپتە {{count}}"
  },
  aboutXMonths: {
    one: "تەخمىنەن بىر ئاي",
    other: "ئاي {{count}} تەخمىنەن"
  },
  xMonths: {
    one: "بىر ئاي",
    other: "ئاي {{count}}"
  },
  aboutXYears: {
    one: "تەخمىنەن بىر يىل",
    other: "يىل {{count}} تەخمىنەن"
  },
  xYears: {
    one: "بىر يىل",
    other: "يىل {{count}}"
  },
  overXYears: {
    one: "بىر يىلدىن ئارتۇق",
    other: "يىلدىن ئارتۇق {{count}}"
  },
  almostXYears: {
    one: "ئاساسەن بىر يىل",
    other: "يىل {{count}} ئاساسەن"
  }
}, kvt = (e, t, r) => {
  let a;
  const i = Pvt[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? a : a + " بولدى" : a;
}, Mvt = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Ovt = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Tvt = {
  full: "{{date}} 'دە' {{time}}",
  long: "{{date}} 'دە' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Rvt = {
  date: Ke({
    formats: Mvt,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: Ovt,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: Tvt,
    defaultWidth: "full"
  })
}, Avt = {
  lastWeek: "'ئ‍ۆتكەن' eeee 'دە' p",
  yesterday: "'تۈنۈگۈن دە' p",
  today: "'بۈگۈن دە' p",
  tomorrow: "'ئەتە دە' p",
  nextWeek: "eeee 'دە' p",
  other: "P"
}, Nvt = (e, t, r, a) => Avt[e], Dvt = {
  narrow: ["ب", "ك"],
  abbreviated: ["ب", "ك"],
  wide: ["مىيلادىدىن بۇرۇن", "مىيلادىدىن كىيىن"]
}, $vt = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1", "2", "3", "4"],
  wide: ["بىرىنجى چارەك", "ئىككىنجى چارەك", "ئۈچىنجى چارەك", "تۆتىنجى چارەك"]
}, zvt = {
  narrow: ["ي", "ف", "م", "ا", "م", "ى", "ى", "ا", "س", "ۆ", "ن", "د"],
  abbreviated: [
    "يانۋار",
    "فېۋىرال",
    "مارت",
    "ئاپرىل",
    "ماي",
    "ئىيۇن",
    "ئىيول",
    "ئاۋغۇست",
    "سىنتەبىر",
    "ئۆكتەبىر",
    "نويابىر",
    "دىكابىر"
  ],
  wide: [
    "يانۋار",
    "فېۋىرال",
    "مارت",
    "ئاپرىل",
    "ماي",
    "ئىيۇن",
    "ئىيول",
    "ئاۋغۇست",
    "سىنتەبىر",
    "ئۆكتەبىر",
    "نويابىر",
    "دىكابىر"
  ]
}, jvt = {
  narrow: ["ي", "د", "س", "چ", "پ", "ج", "ش"],
  short: ["ي", "د", "س", "چ", "پ", "ج", "ش"],
  abbreviated: [
    "يەكشەنبە",
    "دۈشەنبە",
    "سەيشەنبە",
    "چارشەنبە",
    "پەيشەنبە",
    "جۈمە",
    "شەنبە"
  ],
  wide: [
    "يەكشەنبە",
    "دۈشەنبە",
    "سەيشەنبە",
    "چارشەنبە",
    "پەيشەنبە",
    "جۈمە",
    "شەنبە"
  ]
}, Ivt = {
  narrow: {
    am: "ئە",
    pm: "چ",
    midnight: "ك",
    noon: "چ",
    morning: "ئەتىگەن",
    afternoon: "چۈشتىن كىيىن",
    evening: "ئاخشىم",
    night: "كىچە"
  },
  abbreviated: {
    am: "ئە",
    pm: "چ",
    midnight: "ك",
    noon: "چ",
    morning: "ئەتىگەن",
    afternoon: "چۈشتىن كىيىن",
    evening: "ئاخشىم",
    night: "كىچە"
  },
  wide: {
    am: "ئە",
    pm: "چ",
    midnight: "ك",
    noon: "چ",
    morning: "ئەتىگەن",
    afternoon: "چۈشتىن كىيىن",
    evening: "ئاخشىم",
    night: "كىچە"
  }
}, Lvt = {
  narrow: {
    am: "ئە",
    pm: "چ",
    midnight: "ك",
    noon: "چ",
    morning: "ئەتىگەندە",
    afternoon: "چۈشتىن كىيىن",
    evening: "ئاخشامدا",
    night: "كىچىدە"
  },
  abbreviated: {
    am: "ئە",
    pm: "چ",
    midnight: "ك",
    noon: "چ",
    morning: "ئەتىگەندە",
    afternoon: "چۈشتىن كىيىن",
    evening: "ئاخشامدا",
    night: "كىچىدە"
  },
  wide: {
    am: "ئە",
    pm: "چ",
    midnight: "ك",
    noon: "چ",
    morning: "ئەتىگەندە",
    afternoon: "چۈشتىن كىيىن",
    evening: "ئاخشامدا",
    night: "كىچىدە"
  }
}, Hvt = (e, t) => String(e), Fvt = {
  ordinalNumber: Hvt,
  era: Ce({
    values: Dvt,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: $vt,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: zvt,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: jvt,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: Ivt,
    defaultWidth: "wide",
    formattingValues: Lvt,
    defaultFormattingWidth: "wide"
  })
}, Wvt = /^(\d+)(th|st|nd|rd)?/i, Vvt = /\d+/i, _vt = {
  narrow: /^(ب|ك)/i,
  wide: /^(مىيلادىدىن بۇرۇن|مىيلادىدىن كىيىن)/i
}, Bvt = {
  any: [/^بۇرۇن/i, /^كىيىن/i]
}, Uvt = {
  narrow: /^[1234]/i,
  abbreviated: /^چ[1234]/i,
  wide: /^چارەك [1234]/i
}, Xvt = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Gvt = {
  // eslint-disable-next-line no-misleading-character-class
  narrow: /^[يفمئامئ‍ئاسۆند]/i,
  abbreviated: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i,
  wide: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i
}, qvt = {
  narrow: [
    /^ي/i,
    /^ف/i,
    /^م/i,
    /^ا/i,
    /^م/i,
    /^ى‍/i,
    /^ى‍/i,
    /^ا‍/i,
    /^س/i,
    /^ۆ/i,
    /^ن/i,
    /^د/i
  ],
  any: [
    /^يان/i,
    /^فېۋ/i,
    /^مار/i,
    /^ئاپ/i,
    /^ماي/i,
    /^ئىيۇن/i,
    /^ئىيول/i,
    /^ئاۋ/i,
    /^سىن/i,
    /^ئۆك/i,
    /^نوي/i,
    /^دىك/i
  ]
}, Kvt = {
  narrow: /^[دسچپجشي]/i,
  short: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
  abbreviated: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
  wide: /^(يەكشەنبە|دۈشەنبە|سەيشەنبە|چارشەنبە|پەيشەنبە|جۈمە|شەنبە)/i
}, Yvt = {
  narrow: [/^ي/i, /^د/i, /^س/i, /^چ/i, /^پ/i, /^ج/i, /^ش/i],
  any: [/^ي/i, /^د/i, /^س/i, /^چ/i, /^پ/i, /^ج/i, /^ش/i]
}, Qvt = {
  narrow: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i,
  any: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i
}, Jvt = {
  any: {
    am: /^ئە/i,
    pm: /^چ/i,
    midnight: /^ك/i,
    noon: /^چ/i,
    morning: /ئەتىگەن/i,
    afternoon: /چۈشتىن كىيىن/i,
    evening: /ئاخشىم/i,
    night: /كىچە/i
  }
}, Zvt = {
  ordinalNumber: Fn({
    matchPattern: Wvt,
    parsePattern: Vvt,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: _vt,
    defaultMatchWidth: "wide",
    parsePatterns: Bvt,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: Uvt,
    defaultMatchWidth: "wide",
    parsePatterns: Xvt,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: Gvt,
    defaultMatchWidth: "wide",
    parsePatterns: qvt,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: Kvt,
    defaultMatchWidth: "wide",
    parsePatterns: Yvt,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: Qvt,
    defaultMatchWidth: "any",
    parsePatterns: Jvt,
    defaultParseWidth: "any"
  })
}, e2t = {
  code: "ug",
  formatDistance: kvt,
  formatLong: Rvt,
  formatRelative: Nvt,
  localize: Fvt,
  match: Zvt,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function Y5(e, t) {
  if (e.one !== void 0 && t === 1)
    return e.one;
  const r = t % 10, a = t % 100;
  return r === 1 && a !== 11 ? e.singularNominative.replace("{{count}}", String(t)) : r >= 2 && r <= 4 && (a < 10 || a > 20) ? e.singularGenitive.replace("{{count}}", String(t)) : e.pluralGenitive.replace("{{count}}", String(t));
}
function Uh(e) {
  return (t, r) => r && r.addSuffix ? r.comparison && r.comparison > 0 ? e.future ? Y5(e.future, t) : "за " + Y5(e.regular, t) : e.past ? Y5(e.past, t) : Y5(e.regular, t) + " тому" : Y5(e.regular, t);
}
const t2t = (e, t) => t && t.addSuffix ? t.comparison && t.comparison > 0 ? "за півхвилини" : "півхвилини тому" : "півхвилини", n2t = {
  lessThanXSeconds: Uh({
    regular: {
      one: "менше секунди",
      singularNominative: "менше {{count}} секунди",
      singularGenitive: "менше {{count}} секунд",
      pluralGenitive: "менше {{count}} секунд"
    },
    future: {
      one: "менше, ніж за секунду",
      singularNominative: "менше, ніж за {{count}} секунду",
      singularGenitive: "менше, ніж за {{count}} секунди",
      pluralGenitive: "менше, ніж за {{count}} секунд"
    }
  }),
  xSeconds: Uh({
    regular: {
      singularNominative: "{{count}} секунда",
      singularGenitive: "{{count}} секунди",
      pluralGenitive: "{{count}} секунд"
    },
    past: {
      singularNominative: "{{count}} секунду тому",
      singularGenitive: "{{count}} секунди тому",
      pluralGenitive: "{{count}} секунд тому"
    },
    future: {
      singularNominative: "за {{count}} секунду",
      singularGenitive: "за {{count}} секунди",
      pluralGenitive: "за {{count}} секунд"
    }
  }),
  halfAMinute: t2t,
  lessThanXMinutes: Uh({
    regular: {
      one: "менше хвилини",
      singularNominative: "менше {{count}} хвилини",
      singularGenitive: "менше {{count}} хвилин",
      pluralGenitive: "менше {{count}} хвилин"
    },
    future: {
      one: "менше, ніж за хвилину",
      singularNominative: "менше, ніж за {{count}} хвилину",
      singularGenitive: "менше, ніж за {{count}} хвилини",
      pluralGenitive: "менше, ніж за {{count}} хвилин"
    }
  }),
  xMinutes: Uh({
    regular: {
      singularNominative: "{{count}} хвилина",
      singularGenitive: "{{count}} хвилини",
      pluralGenitive: "{{count}} хвилин"
    },
    past: {
      singularNominative: "{{count}} хвилину тому",
      singularGenitive: "{{count}} хвилини тому",
      pluralGenitive: "{{count}} хвилин тому"
    },
    future: {
      singularNominative: "за {{count}} хвилину",
      singularGenitive: "за {{count}} хвилини",
      pluralGenitive: "за {{count}} хвилин"
    }
  }),
  aboutXHours: Uh({
    regular: {
      singularNominative: "близько {{count}} години",
      singularGenitive: "близько {{count}} годин",
      pluralGenitive: "близько {{count}} годин"
    },
    future: {
      singularNominative: "приблизно за {{count}} годину",
      singularGenitive: "приблизно за {{count}} години",
      pluralGenitive: "приблизно за {{count}} годин"
    }
  }),
  xHours: Uh({
    regular: {
      singularNominative: "{{count}} годину",
      singularGenitive: "{{count}} години",
      pluralGenitive: "{{count}} годин"
    }
  }),
  xDays: Uh({
    regular: {
      singularNominative: "{{count}} день",
      singularGenitive: "{{count}} днi",
      pluralGenitive: "{{count}} днів"
    }
  }),
  aboutXWeeks: Uh({
    regular: {
      singularNominative: "близько {{count}} тижня",
      singularGenitive: "близько {{count}} тижнів",
      pluralGenitive: "близько {{count}} тижнів"
    },
    future: {
      singularNominative: "приблизно за {{count}} тиждень",
      singularGenitive: "приблизно за {{count}} тижні",
      pluralGenitive: "приблизно за {{count}} тижнів"
    }
  }),
  xWeeks: Uh({
    regular: {
      singularNominative: "{{count}} тиждень",
      singularGenitive: "{{count}} тижні",
      pluralGenitive: "{{count}} тижнів"
    }
  }),
  aboutXMonths: Uh({
    regular: {
      singularNominative: "близько {{count}} місяця",
      singularGenitive: "близько {{count}} місяців",
      pluralGenitive: "близько {{count}} місяців"
    },
    future: {
      singularNominative: "приблизно за {{count}} місяць",
      singularGenitive: "приблизно за {{count}} місяці",
      pluralGenitive: "приблизно за {{count}} місяців"
    }
  }),
  xMonths: Uh({
    regular: {
      singularNominative: "{{count}} місяць",
      singularGenitive: "{{count}} місяці",
      pluralGenitive: "{{count}} місяців"
    }
  }),
  aboutXYears: Uh({
    regular: {
      singularNominative: "близько {{count}} року",
      singularGenitive: "близько {{count}} років",
      pluralGenitive: "близько {{count}} років"
    },
    future: {
      singularNominative: "приблизно за {{count}} рік",
      singularGenitive: "приблизно за {{count}} роки",
      pluralGenitive: "приблизно за {{count}} років"
    }
  }),
  xYears: Uh({
    regular: {
      singularNominative: "{{count}} рік",
      singularGenitive: "{{count}} роки",
      pluralGenitive: "{{count}} років"
    }
  }),
  overXYears: Uh({
    regular: {
      singularNominative: "більше {{count}} року",
      singularGenitive: "більше {{count}} років",
      pluralGenitive: "більше {{count}} років"
    },
    future: {
      singularNominative: "більше, ніж за {{count}} рік",
      singularGenitive: "більше, ніж за {{count}} роки",
      pluralGenitive: "більше, ніж за {{count}} років"
    }
  }),
  almostXYears: Uh({
    regular: {
      singularNominative: "майже {{count}} рік",
      singularGenitive: "майже {{count}} роки",
      pluralGenitive: "майже {{count}} років"
    },
    future: {
      singularNominative: "майже за {{count}} рік",
      singularGenitive: "майже за {{count}} роки",
      pluralGenitive: "майже за {{count}} років"
    }
  })
}, r2t = (e, t, r) => (r = r || {}, n2t[e](t, r)), a2t = {
  full: "EEEE, do MMMM y 'р.'",
  long: "do MMMM y 'р.'",
  medium: "d MMM y 'р.'",
  short: "dd.MM.y"
}, o2t = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, i2t = {
  full: "{{date}} 'о' {{time}}",
  long: "{{date}} 'о' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, l2t = {
  date: Ke({
    formats: a2t,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: o2t,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: i2t,
    defaultWidth: "full"
  })
}, OI = [
  "неділю",
  "понеділок",
  "вівторок",
  "середу",
  "четвер",
  "п’ятницю",
  "суботу"
];
function s2t(e) {
  const t = OI[e];
  switch (e) {
    case 0:
    case 3:
    case 5:
    case 6:
      return "'у минулу " + t + " о' p";
    case 1:
    case 2:
    case 4:
      return "'у минулий " + t + " о' p";
  }
}
function Wte(e) {
  return "'у " + OI[e] + " о' p";
}
function u2t(e) {
  const t = OI[e];
  switch (e) {
    case 0:
    case 3:
    case 5:
    case 6:
      return "'у наступну " + t + " о' p";
    case 1:
    case 2:
    case 4:
      return "'у наступний " + t + " о' p";
  }
}
const c2t = (e, t, r) => {
  const a = Ts(e), i = a.getDay();
  return su(a, t, r) ? Wte(i) : s2t(i);
}, d2t = (e, t, r) => {
  const a = Ts(e), i = a.getDay();
  return su(a, t, r) ? Wte(i) : u2t(i);
}, f2t = {
  lastWeek: c2t,
  yesterday: "'вчора о' p",
  today: "'сьогодні о' p",
  tomorrow: "'завтра о' p",
  nextWeek: d2t,
  other: "P"
}, m2t = (e, t, r, a) => {
  const i = f2t[e];
  return typeof i == "function" ? i(t, r, a) : i;
}, h2t = {
  narrow: ["до н.е.", "н.е."],
  abbreviated: ["до н. е.", "н. е."],
  wide: ["до нашої ери", "нашої ери"]
}, p2t = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-й кв.", "2-й кв.", "3-й кв.", "4-й кв."],
  wide: ["1-й квартал", "2-й квартал", "3-й квартал", "4-й квартал"]
}, g2t = {
  // ДСТУ 3582:2013
  narrow: ["С", "Л", "Б", "К", "Т", "Ч", "Л", "С", "В", "Ж", "Л", "Г"],
  abbreviated: [
    "січ.",
    "лют.",
    "берез.",
    "квіт.",
    "трав.",
    "черв.",
    "лип.",
    "серп.",
    "верес.",
    "жовт.",
    "листоп.",
    "груд."
  ],
  wide: [
    "січень",
    "лютий",
    "березень",
    "квітень",
    "травень",
    "червень",
    "липень",
    "серпень",
    "вересень",
    "жовтень",
    "листопад",
    "грудень"
  ]
}, v2t = {
  narrow: ["С", "Л", "Б", "К", "Т", "Ч", "Л", "С", "В", "Ж", "Л", "Г"],
  abbreviated: [
    "січ.",
    "лют.",
    "берез.",
    "квіт.",
    "трав.",
    "черв.",
    "лип.",
    "серп.",
    "верес.",
    "жовт.",
    "листоп.",
    "груд."
  ],
  wide: [
    "січня",
    "лютого",
    "березня",
    "квітня",
    "травня",
    "червня",
    "липня",
    "серпня",
    "вересня",
    "жовтня",
    "листопада",
    "грудня"
  ]
}, b2t = {
  narrow: ["Н", "П", "В", "С", "Ч", "П", "С"],
  short: ["нд", "пн", "вт", "ср", "чт", "пт", "сб"],
  abbreviated: ["нед", "пон", "вів", "сер", "чтв", "птн", "суб"],
  wide: [
    "неділя",
    "понеділок",
    "вівторок",
    "середа",
    "четвер",
    "п’ятниця",
    "субота"
  ]
}, y2t = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "півн.",
    noon: "пол.",
    morning: "ранок",
    afternoon: "день",
    evening: "веч.",
    night: "ніч"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "півн.",
    noon: "пол.",
    morning: "ранок",
    afternoon: "день",
    evening: "веч.",
    night: "ніч"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "північ",
    noon: "полудень",
    morning: "ранок",
    afternoon: "день",
    evening: "вечір",
    night: "ніч"
  }
}, w2t = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "півн.",
    noon: "пол.",
    morning: "ранку",
    afternoon: "дня",
    evening: "веч.",
    night: "ночі"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "півн.",
    noon: "пол.",
    morning: "ранку",
    afternoon: "дня",
    evening: "веч.",
    night: "ночі"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "північ",
    noon: "полудень",
    morning: "ранку",
    afternoon: "дня",
    evening: "веч.",
    night: "ночі"
  }
}, S2t = (e, t) => {
  const r = String(t?.unit), a = Number(e);
  let i;
  return r === "date" ? a === 3 || a === 23 ? i = "-є" : i = "-е" : r === "minute" || r === "second" || r === "hour" ? i = "-а" : i = "-й", a + i;
}, C2t = {
  ordinalNumber: S2t,
  era: Ce({
    values: h2t,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: p2t,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: g2t,
    defaultWidth: "wide",
    formattingValues: v2t,
    defaultFormattingWidth: "wide"
  }),
  day: Ce({
    values: b2t,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: y2t,
    defaultWidth: "any",
    formattingValues: w2t,
    defaultFormattingWidth: "wide"
  })
}, x2t = /^(\d+)(-?(е|й|є|а|я))?/i, E2t = /\d+/i, P2t = {
  narrow: /^((до )?н\.?\s?е\.?)/i,
  abbreviated: /^((до )?н\.?\s?е\.?)/i,
  wide: /^(до нашої ери|нашої ери|наша ера)/i
}, k2t = {
  any: [/^д/i, /^н/i]
}, M2t = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[иі]?й?)? кв.?/i,
  wide: /^[1234](-?[иі]?й?)? квартал/i
}, O2t = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, T2t = {
  narrow: /^[слбктчвжг]/i,
  abbreviated: /^(січ|лют|бер(ез)?|квіт|трав|черв|лип|серп|вер(ес)?|жовт|лис(топ)?|груд)\.?/i,
  wide: /^(січень|січня|лютий|лютого|березень|березня|квітень|квітня|травень|травня|червня|червень|липень|липня|серпень|серпня|вересень|вересня|жовтень|жовтня|листопад[а]?|грудень|грудня)/i
}, R2t = {
  narrow: [
    /^с/i,
    /^л/i,
    /^б/i,
    /^к/i,
    /^т/i,
    /^ч/i,
    /^л/i,
    /^с/i,
    /^в/i,
    /^ж/i,
    /^л/i,
    /^г/i
  ],
  any: [
    /^сі/i,
    /^лю/i,
    /^б/i,
    /^к/i,
    /^т/i,
    /^ч/i,
    /^лип/i,
    /^се/i,
    /^в/i,
    /^ж/i,
    /^лис/i,
    /^г/i
  ]
}, A2t = {
  narrow: /^[нпвсч]/i,
  short: /^(нд|пн|вт|ср|чт|пт|сб)\.?/i,
  abbreviated: /^(нед|пон|вів|сер|че?тв|птн?|суб)\.?/i,
  wide: /^(неділ[яі]|понеділ[ок][ка]|вівтор[ок][ка]|серед[аи]|четвер(га)?|п\W*?ятниц[яі]|субот[аи])/i
}, N2t = {
  narrow: [/^н/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^н/i, /^п[он]/i, /^в/i, /^с[ер]/i, /^ч/i, /^п\W*?[ят]/i, /^с[уб]/i]
}, D2t = {
  narrow: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
  abbreviated: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
  wide: /^([дп]п|північ|полудень|ранок|ранку|день|дня|вечір|вечора|ніч|ночі)/i
}, $2t = {
  any: {
    am: /^дп/i,
    pm: /^пп/i,
    midnight: /^півн/i,
    noon: /^пол/i,
    morning: /^р/i,
    afternoon: /^д[ен]/i,
    evening: /^в/i,
    night: /^н/i
  }
}, z2t = {
  ordinalNumber: Fn({
    matchPattern: x2t,
    parsePattern: E2t,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: P2t,
    defaultMatchWidth: "wide",
    parsePatterns: k2t,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: M2t,
    defaultMatchWidth: "wide",
    parsePatterns: O2t,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: T2t,
    defaultMatchWidth: "wide",
    parsePatterns: R2t,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: A2t,
    defaultMatchWidth: "wide",
    parsePatterns: N2t,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: D2t,
    defaultMatchWidth: "wide",
    parsePatterns: $2t,
    defaultParseWidth: "any"
  })
}, j2t = {
  code: "uk",
  formatDistance: r2t,
  formatLong: l2t,
  formatRelative: m2t,
  localize: C2t,
  match: z2t,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, I2t = {
  lessThanXSeconds: {
    one: "sekunddan kam",
    other: "{{count}} sekunddan kam"
  },
  xSeconds: {
    one: "1 sekund",
    other: "{{count}} sekund"
  },
  halfAMinute: "yarim minut",
  lessThanXMinutes: {
    one: "bir minutdan kam",
    other: "{{count}} minutdan kam"
  },
  xMinutes: {
    one: "1 minut",
    other: "{{count}} minut"
  },
  aboutXHours: {
    one: "tahminan 1 soat",
    other: "tahminan {{count}} soat"
  },
  xHours: {
    one: "1 soat",
    other: "{{count}} soat"
  },
  xDays: {
    one: "1 kun",
    other: "{{count}} kun"
  },
  aboutXWeeks: {
    one: "tahminan 1 hafta",
    other: "tahminan {{count}} hafta"
  },
  xWeeks: {
    one: "1 hafta",
    other: "{{count}} hafta"
  },
  aboutXMonths: {
    one: "tahminan 1 oy",
    other: "tahminan {{count}} oy"
  },
  xMonths: {
    one: "1 oy",
    other: "{{count}} oy"
  },
  aboutXYears: {
    one: "tahminan 1 yil",
    other: "tahminan {{count}} yil"
  },
  xYears: {
    one: "1 yil",
    other: "{{count}} yil"
  },
  overXYears: {
    one: "1 yildan ko'p",
    other: "{{count}} yildan ko'p"
  },
  almostXYears: {
    one: "deyarli 1 yil",
    other: "deyarli {{count}} yil"
  }
}, L2t = (e, t, r) => {
  let a;
  const i = I2t[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? a + " dan keyin" : a + " oldin" : a;
}, H2t = {
  full: "EEEE, do MMMM, y",
  long: "do MMMM, y",
  medium: "d MMM, y",
  short: "dd/MM/yyyy"
}, F2t = {
  full: "h:mm:ss zzzz",
  long: "h:mm:ss z",
  medium: "h:mm:ss",
  short: "h:mm"
}, W2t = {
  any: "{{date}}, {{time}}"
}, V2t = {
  date: Ke({
    formats: H2t,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: F2t,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: W2t,
    defaultWidth: "any"
  })
}, _2t = {
  lastWeek: "'oldingi' eeee p 'da'",
  yesterday: "'kecha' p 'da'",
  today: "'bugun' p 'da'",
  tomorrow: "'ertaga' p 'da'",
  nextWeek: "eeee p 'da'",
  other: "P"
}, B2t = (e, t, r, a) => _2t[e], U2t = {
  narrow: ["M.A", "M."],
  abbreviated: ["M.A", "M."],
  wide: ["Miloddan Avvalgi", "Milodiy"]
}, X2t = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["CH.1", "CH.2", "CH.3", "CH.4"],
  wide: ["1-chi chorak", "2-chi chorak", "3-chi chorak", "4-chi chorak"]
}, G2t = {
  narrow: ["Y", "F", "M", "A", "M", "I", "I", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Yan",
    "Fev",
    "Mar",
    "Apr",
    "May",
    "Iyun",
    "Iyul",
    "Avg",
    "Sen",
    "Okt",
    "Noy",
    "Dek"
  ],
  wide: [
    "Yanvar",
    "Fevral",
    "Mart",
    "Aprel",
    "May",
    "Iyun",
    "Iyul",
    "Avgust",
    "Sentabr",
    "Oktabr",
    "Noyabr",
    "Dekabr"
  ]
}, q2t = {
  narrow: ["Y", "D", "S", "CH", "P", "J", "SH"],
  short: ["Ya", "Du", "Se", "Cho", "Pa", "Ju", "Sha"],
  abbreviated: ["Yak", "Dush", "Sesh", "Chor", "Pay", "Jum", "Shan"],
  wide: [
    "Yakshanba",
    "Dushanba",
    "Seshanba",
    "Chorshanba",
    "Payshanba",
    "Juma",
    "Shanba"
  ]
}, K2t = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "y.t",
    noon: "p.",
    morning: "ertalab",
    afternoon: "tushdan keyin",
    evening: "kechqurun",
    night: "tun"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "yarim tun",
    noon: "peshin",
    morning: "ertalab",
    afternoon: "tushdan keyin",
    evening: "kechqurun",
    night: "tun"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "yarim tun",
    noon: "peshin",
    morning: "ertalab",
    afternoon: "tushdan keyin",
    evening: "kechqurun",
    night: "tun"
  }
}, Y2t = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "y.t",
    noon: "p.",
    morning: "ertalab",
    afternoon: "tushdan keyin",
    evening: "kechqurun",
    night: "tun"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "yarim tun",
    noon: "peshin",
    morning: "ertalab",
    afternoon: "tushdan keyin",
    evening: "kechqurun",
    night: "tun"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "yarim tun",
    noon: "peshin",
    morning: "ertalab",
    afternoon: "tushdan keyin",
    evening: "kechqurun",
    night: "tun"
  }
}, Q2t = (e, t) => String(e), J2t = {
  ordinalNumber: Q2t,
  era: Ce({
    values: U2t,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: X2t,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: G2t,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: q2t,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: K2t,
    defaultWidth: "wide",
    formattingValues: Y2t,
    defaultFormattingWidth: "wide"
  })
}, Z2t = /^(\d+)(chi)?/i, e1t = /\d+/i, t1t = {
  narrow: /^(m\.a|m\.)/i,
  abbreviated: /^(m\.a\.?\s?m\.?)/i,
  wide: /^(miloddan avval|miloddan keyin)/i
}, n1t = {
  any: [/^b/i, /^(a|c)/i]
}, r1t = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](chi)? chorak/i
}, a1t = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, o1t = {
  narrow: /^[yfmasond]/i,
  abbreviated: /^(yan|fev|mar|apr|may|iyun|iyul|avg|sen|okt|noy|dek)/i,
  wide: /^(yanvar|fevral|mart|aprel|may|iyun|iyul|avgust|sentabr|oktabr|noyabr|dekabr)/i
}, i1t = {
  narrow: [
    /^y/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^i/i,
    /^i/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ya/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^iyun/i,
    /^iyul/i,
    /^av/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, l1t = {
  narrow: /^[ydschj]/i,
  short: /^(ya|du|se|cho|pa|ju|sha)/i,
  abbreviated: /^(yak|dush|sesh|chor|pay|jum|shan)/i,
  wide: /^(yakshanba|dushanba|seshanba|chorshanba|payshanba|juma|shanba)/i
}, s1t = {
  narrow: [/^y/i, /^d/i, /^s/i, /^ch/i, /^p/i, /^j/i, /^sh/i],
  any: [/^ya/i, /^d/i, /^se/i, /^ch/i, /^p/i, /^j/i, /^sh/i]
}, u1t = {
  narrow: /^(a|p|y\.t|p| (ertalab|tushdan keyin|kechqurun|tun))/i,
  any: /^([ap]\.?\s?m\.?|yarim tun|peshin| (ertalab|tushdan keyin|kechqurun|tun))/i
}, c1t = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^y\.t/i,
    noon: /^pe/i,
    morning: /ertalab/i,
    afternoon: /tushdan keyin/i,
    evening: /kechqurun/i,
    night: /tun/i
  }
}, d1t = {
  ordinalNumber: Fn({
    matchPattern: Z2t,
    parsePattern: e1t,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: t1t,
    defaultMatchWidth: "wide",
    parsePatterns: n1t,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: r1t,
    defaultMatchWidth: "wide",
    parsePatterns: a1t,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: o1t,
    defaultMatchWidth: "wide",
    parsePatterns: i1t,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: l1t,
    defaultMatchWidth: "wide",
    parsePatterns: s1t,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: u1t,
    defaultMatchWidth: "any",
    parsePatterns: c1t,
    defaultParseWidth: "any"
  })
}, f1t = {
  code: "uz",
  formatDistance: L2t,
  formatLong: V2t,
  formatRelative: B2t,
  localize: J2t,
  match: d1t,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, m1t = {
  lessThanXSeconds: {
    one: "1 сониядан кам",
    other: "{{count}} сониядан кам"
  },
  xSeconds: {
    one: "1 сония",
    other: "{{count}} сония"
  },
  halfAMinute: "ярим дақиқа",
  lessThanXMinutes: {
    one: "1 дақиқадан кам",
    other: "{{count}} дақиқадан кам"
  },
  xMinutes: {
    one: "1 дақиқа",
    other: "{{count}} дақиқа"
  },
  aboutXHours: {
    one: "тахминан 1 соат",
    other: "тахминан {{count}} соат"
  },
  xHours: {
    one: "1 соат",
    other: "{{count}} соат"
  },
  xDays: {
    one: "1 кун",
    other: "{{count}} кун"
  },
  aboutXWeeks: {
    one: "тахминан 1 хафта",
    other: "тахминан {{count}} хафта"
  },
  xWeeks: {
    one: "1 хафта",
    other: "{{count}} хафта"
  },
  aboutXMonths: {
    one: "тахминан 1 ой",
    other: "тахминан {{count}} ой"
  },
  xMonths: {
    one: "1 ой",
    other: "{{count}} ой"
  },
  aboutXYears: {
    one: "тахминан 1 йил",
    other: "тахминан {{count}} йил"
  },
  xYears: {
    one: "1 йил",
    other: "{{count}} йил"
  },
  overXYears: {
    one: "1 йилдан кўп",
    other: "{{count}} йилдан кўп"
  },
  almostXYears: {
    one: "деярли 1 йил",
    other: "деярли {{count}} йил"
  }
}, h1t = (e, t, r) => {
  let a;
  const i = m1t[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? a + "дан кейин" : a + " олдин" : a;
}, p1t = {
  full: "EEEE, do MMMM, y",
  long: "do MMMM, y",
  medium: "d MMM, y",
  short: "dd/MM/yyyy"
}, g1t = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, v1t = {
  any: "{{date}}, {{time}}"
}, b1t = {
  date: Ke({
    formats: p1t,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: g1t,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: v1t,
    defaultWidth: "any"
  })
}, y1t = {
  lastWeek: "'ўтган' eeee p 'да'",
  yesterday: "'кеча' p 'да'",
  today: "'бугун' p 'да'",
  tomorrow: "'эртага' p 'да'",
  nextWeek: "eeee p 'да'",
  other: "P"
}, w1t = (e, t, r, a) => y1t[e], S1t = {
  narrow: ["М.А", "М"],
  abbreviated: ["М.А", "М"],
  wide: ["Милоддан Аввалги", "Милодий"]
}, C1t = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-чор.", "2-чор.", "3-чор.", "4-чор."],
  wide: ["1-чорак", "2-чорак", "3-чорак", "4-чорак"]
}, x1t = {
  narrow: ["Я", "Ф", "М", "А", "М", "И", "И", "А", "С", "О", "Н", "Д"],
  abbreviated: [
    "янв",
    "фев",
    "мар",
    "апр",
    "май",
    "июн",
    "июл",
    "авг",
    "сен",
    "окт",
    "ноя",
    "дек"
  ],
  wide: [
    "январ",
    "феврал",
    "март",
    "апрел",
    "май",
    "июн",
    "июл",
    "август",
    "сентабр",
    "октабр",
    "ноябр",
    "декабр"
  ]
}, E1t = {
  narrow: ["Я", "Д", "С", "Ч", "П", "Ж", "Ш"],
  short: ["як", "ду", "се", "чо", "па", "жу", "ша"],
  abbreviated: ["якш", "душ", "сеш", "чор", "пай", "жум", "шан"],
  wide: [
    "якшанба",
    "душанба",
    "сешанба",
    "чоршанба",
    "пайшанба",
    "жума",
    "шанба"
  ]
}, P1t = {
  any: {
    am: "П.О.",
    pm: "П.К.",
    midnight: "ярим тун",
    noon: "пешин",
    morning: "эрталаб",
    afternoon: "пешиндан кейин",
    evening: "кечаси",
    night: "тун"
  }
}, k1t = {
  any: {
    am: "П.О.",
    pm: "П.К.",
    midnight: "ярим тун",
    noon: "пешин",
    morning: "эрталаб",
    afternoon: "пешиндан кейин",
    evening: "кечаси",
    night: "тун"
  }
}, M1t = (e, t) => String(e), O1t = {
  ordinalNumber: M1t,
  era: Ce({
    values: S1t,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: C1t,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: x1t,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: E1t,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: P1t,
    defaultWidth: "any",
    formattingValues: k1t,
    defaultFormattingWidth: "any"
  })
}, T1t = /^(\d+)(чи)?/i, R1t = /\d+/i, A1t = {
  narrow: /^(м\.а|м\.)/i,
  abbreviated: /^(м\.а|м\.)/i,
  wide: /^(милоддан аввал|милоддан кейин)/i
}, N1t = {
  any: [/^м/i, /^а/i]
}, D1t = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]-чор./i,
  wide: /^[1234]-чорак/i
}, $1t = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, z1t = {
  narrow: /^[яфмамииасонд]/i,
  abbreviated: /^(янв|фев|мар|апр|май|июн|июл|авг|сен|окт|ноя|дек)/i,
  wide: /^(январ|феврал|март|апрел|май|июн|июл|август|сентабр|октабр|ноябр|декабр)/i
}, j1t = {
  narrow: [
    /^я/i,
    /^ф/i,
    /^м/i,
    /^а/i,
    /^м/i,
    /^и/i,
    /^и/i,
    /^а/i,
    /^с/i,
    /^о/i,
    /^н/i,
    /^д/i
  ],
  any: [
    /^я/i,
    /^ф/i,
    /^мар/i,
    /^ап/i,
    /^май/i,
    /^июн/i,
    /^июл/i,
    /^ав/i,
    /^с/i,
    /^о/i,
    /^н/i,
    /^д/i
  ]
}, I1t = {
  narrow: /^[ядсчпжш]/i,
  short: /^(як|ду|се|чо|па|жу|ша)/i,
  abbreviated: /^(якш|душ|сеш|чор|пай|жум|шан)/i,
  wide: /^(якшанба|душанба|сешанба|чоршанба|пайшанба|жума|шанба)/i
}, L1t = {
  narrow: [/^я/i, /^д/i, /^с/i, /^ч/i, /^п/i, /^ж/i, /^ш/i],
  any: [/^як/i, /^ду/i, /^се/i, /^чор/i, /^пай/i, /^жу/i, /^шан/i]
}, H1t = {
  any: /^(п\.о\.|п\.к\.|ярим тун|пешиндан кейин|(эрталаб|пешиндан кейин|кечаси|тун))/i
}, F1t = {
  any: {
    am: /^п\.о\./i,
    pm: /^п\.к\./i,
    midnight: /^ярим тун/i,
    noon: /^пешиндан кейин/i,
    morning: /эрталаб/i,
    afternoon: /пешиндан кейин/i,
    evening: /кечаси/i,
    night: /тун/i
  }
}, W1t = {
  ordinalNumber: Fn({
    matchPattern: T1t,
    parsePattern: R1t,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: A1t,
    defaultMatchWidth: "wide",
    parsePatterns: N1t,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: D1t,
    defaultMatchWidth: "wide",
    parsePatterns: $1t,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: z1t,
    defaultMatchWidth: "wide",
    parsePatterns: j1t,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: I1t,
    defaultMatchWidth: "wide",
    parsePatterns: L1t,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: H1t,
    defaultMatchWidth: "any",
    parsePatterns: F1t,
    defaultParseWidth: "any"
  })
}, V1t = {
  code: "uz-Cyrl",
  formatDistance: h1t,
  formatLong: b1t,
  formatRelative: w1t,
  localize: O1t,
  match: W1t,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, _1t = {
  lessThanXSeconds: {
    one: "dưới 1 giây",
    other: "dưới {{count}} giây"
  },
  xSeconds: {
    one: "1 giây",
    other: "{{count}} giây"
  },
  halfAMinute: "nửa phút",
  lessThanXMinutes: {
    one: "dưới 1 phút",
    other: "dưới {{count}} phút"
  },
  xMinutes: {
    one: "1 phút",
    other: "{{count}} phút"
  },
  aboutXHours: {
    one: "khoảng 1 giờ",
    other: "khoảng {{count}} giờ"
  },
  xHours: {
    one: "1 giờ",
    other: "{{count}} giờ"
  },
  xDays: {
    one: "1 ngày",
    other: "{{count}} ngày"
  },
  aboutXWeeks: {
    one: "khoảng 1 tuần",
    other: "khoảng {{count}} tuần"
  },
  xWeeks: {
    one: "1 tuần",
    other: "{{count}} tuần"
  },
  aboutXMonths: {
    one: "khoảng 1 tháng",
    other: "khoảng {{count}} tháng"
  },
  xMonths: {
    one: "1 tháng",
    other: "{{count}} tháng"
  },
  aboutXYears: {
    one: "khoảng 1 năm",
    other: "khoảng {{count}} năm"
  },
  xYears: {
    one: "1 năm",
    other: "{{count}} năm"
  },
  overXYears: {
    one: "hơn 1 năm",
    other: "hơn {{count}} năm"
  },
  almostXYears: {
    one: "gần 1 năm",
    other: "gần {{count}} năm"
  }
}, B1t = (e, t, r) => {
  let a;
  const i = _1t[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? a + " nữa" : a + " trước" : a;
}, U1t = {
  // thứ Sáu, ngày 25 tháng 08 năm 2017
  full: "EEEE, 'ngày' d MMMM 'năm' y",
  // ngày 25 tháng 08 năm 2017
  long: "'ngày' d MMMM 'năm' y",
  // 25 thg 08 năm 2017
  medium: "d MMM 'năm' y",
  // 25/08/2017
  short: "dd/MM/y"
}, X1t = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, G1t = {
  // thứ Sáu, ngày 25 tháng 08 năm 2017 23:25:59
  full: "{{date}} {{time}}",
  // ngày 25 tháng 08 năm 2017 23:25
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, q1t = {
  date: Ke({
    formats: U1t,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: X1t,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: G1t,
    defaultWidth: "full"
  })
}, K1t = {
  lastWeek: "eeee 'tuần trước vào lúc' p",
  yesterday: "'hôm qua vào lúc' p",
  today: "'hôm nay vào lúc' p",
  tomorrow: "'ngày mai vào lúc' p",
  nextWeek: "eeee 'tới vào lúc' p",
  other: "P"
}, Y1t = (e, t, r, a) => K1t[e], Q1t = {
  narrow: ["TCN", "SCN"],
  abbreviated: ["trước CN", "sau CN"],
  wide: ["trước Công Nguyên", "sau Công Nguyên"]
}, J1t = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["Quý 1", "Quý 2", "Quý 3", "Quý 4"]
}, Z1t = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  // I notice many news outlet use this "quý II/2018"
  wide: ["quý I", "quý II", "quý III", "quý IV"]
}, ebt = {
  narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
  abbreviated: [
    "Thg 1",
    "Thg 2",
    "Thg 3",
    "Thg 4",
    "Thg 5",
    "Thg 6",
    "Thg 7",
    "Thg 8",
    "Thg 9",
    "Thg 10",
    "Thg 11",
    "Thg 12"
  ],
  wide: [
    "Tháng Một",
    "Tháng Hai",
    "Tháng Ba",
    "Tháng Tư",
    "Tháng Năm",
    "Tháng Sáu",
    "Tháng Bảy",
    "Tháng Tám",
    "Tháng Chín",
    "Tháng Mười",
    "Tháng Mười Một",
    "Tháng Mười Hai"
  ]
}, tbt = {
  narrow: [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12"
  ],
  abbreviated: [
    "thg 1",
    "thg 2",
    "thg 3",
    "thg 4",
    "thg 5",
    "thg 6",
    "thg 7",
    "thg 8",
    "thg 9",
    "thg 10",
    "thg 11",
    "thg 12"
  ],
  wide: [
    "tháng 01",
    "tháng 02",
    "tháng 03",
    "tháng 04",
    "tháng 05",
    "tháng 06",
    "tháng 07",
    "tháng 08",
    "tháng 09",
    "tháng 10",
    "tháng 11",
    "tháng 12"
  ]
}, nbt = {
  narrow: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
  short: ["CN", "Th 2", "Th 3", "Th 4", "Th 5", "Th 6", "Th 7"],
  abbreviated: ["CN", "Thứ 2", "Thứ 3", "Thứ 4", "Thứ 5", "Thứ 6", "Thứ 7"],
  wide: [
    "Chủ Nhật",
    "Thứ Hai",
    "Thứ Ba",
    "Thứ Tư",
    "Thứ Năm",
    "Thứ Sáu",
    "Thứ Bảy"
  ]
}, rbt = {
  // narrow date period is extremely rare in Vietnamese
  // I used abbreviated form for noon, morning and afternoon
  // which are regconizable by Vietnamese, others cannot be any shorter
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "nửa đêm",
    noon: "tr",
    morning: "sg",
    afternoon: "ch",
    evening: "tối",
    night: "đêm"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "nửa đêm",
    noon: "trưa",
    morning: "sáng",
    afternoon: "chiều",
    evening: "tối",
    night: "đêm"
  },
  wide: {
    am: "SA",
    pm: "CH",
    midnight: "nửa đêm",
    noon: "trưa",
    morning: "sáng",
    afternoon: "chiều",
    evening: "tối",
    night: "đêm"
  }
}, abt = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "nửa đêm",
    noon: "tr",
    morning: "sg",
    afternoon: "ch",
    evening: "tối",
    night: "đêm"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "nửa đêm",
    noon: "trưa",
    morning: "sáng",
    afternoon: "chiều",
    evening: "tối",
    night: "đêm"
  },
  wide: {
    am: "SA",
    pm: "CH",
    midnight: "nửa đêm",
    noon: "giữa trưa",
    morning: "vào buổi sáng",
    afternoon: "vào buổi chiều",
    evening: "vào buổi tối",
    night: "vào ban đêm"
  }
}, obt = (e, t) => {
  const r = Number(e), a = t?.unit;
  if (a === "quarter")
    switch (r) {
      case 1:
        return "I";
      case 2:
        return "II";
      case 3:
        return "III";
      case 4:
        return "IV";
    }
  else if (a === "day")
    switch (r) {
      case 1:
        return "thứ 2";
      // meaning 2nd day but it's the first day of the week :D
      case 2:
        return "thứ 3";
      // meaning 3rd day
      case 3:
        return "thứ 4";
      // meaning 4th day and so on
      case 4:
        return "thứ 5";
      case 5:
        return "thứ 6";
      case 6:
        return "thứ 7";
      case 7:
        return "chủ nhật";
    }
  else {
    if (a === "week")
      return r === 1 ? "thứ nhất" : "thứ " + r;
    if (a === "dayOfYear")
      return r === 1 ? "đầu tiên" : "thứ " + r;
  }
  return String(r);
}, ibt = {
  ordinalNumber: obt,
  era: Ce({
    values: Q1t,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: J1t,
    defaultWidth: "wide",
    formattingValues: Z1t,
    defaultFormattingWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: ebt,
    defaultWidth: "wide",
    formattingValues: tbt,
    defaultFormattingWidth: "wide"
  }),
  day: Ce({
    values: nbt,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: rbt,
    defaultWidth: "wide",
    formattingValues: abt,
    defaultFormattingWidth: "wide"
  })
}, lbt = /^(\d+)/i, sbt = /\d+/i, ubt = {
  narrow: /^(tcn|scn)/i,
  abbreviated: /^(trước CN|sau CN)/i,
  wide: /^(trước Công Nguyên|sau Công Nguyên)/i
}, cbt = {
  any: [/^t/i, /^s/i]
}, dbt = {
  narrow: /^([1234]|i{1,3}v?)/i,
  abbreviated: /^q([1234]|i{1,3}v?)/i,
  wide: /^quý ([1234]|i{1,3}v?)/i
}, fbt = {
  any: [/(1|i)$/i, /(2|ii)$/i, /(3|iii)$/i, /(4|iv)$/i]
}, mbt = {
  // month number may contain leading 0, 'thg' prefix may have space, underscore or empty before number
  // note the order of '1' since it is a sub-string of '10', so must be lower priority
  narrow: /^(0?[2-9]|10|11|12|0?1)/i,
  // note the order of 'thg 1' since it is sub-string of 'thg 10', so must be lower priority
  abbreviated: /^thg[ _]?(0?[1-9](?!\d)|10|11|12)/i,
  // note the order of 'Mười' since it is sub-string of Mười Một, so must be lower priority
  wide: /^tháng ?(Một|Hai|Ba|Tư|Năm|Sáu|Bảy|Tám|Chín|Mười|Mười ?Một|Mười ?Hai|0?[1-9](?!\d)|10|11|12)/i
}, hbt = {
  narrow: [
    /0?1$/i,
    /0?2/i,
    /3/,
    /4/,
    /5/,
    /6/,
    /7/,
    /8/,
    /9/,
    /10/,
    /11/,
    /12/
  ],
  abbreviated: [
    /^thg[ _]?0?1(?!\d)/i,
    /^thg[ _]?0?2/i,
    /^thg[ _]?0?3/i,
    /^thg[ _]?0?4/i,
    /^thg[ _]?0?5/i,
    /^thg[ _]?0?6/i,
    /^thg[ _]?0?7/i,
    /^thg[ _]?0?8/i,
    /^thg[ _]?0?9/i,
    /^thg[ _]?10/i,
    /^thg[ _]?11/i,
    /^thg[ _]?12/i
  ],
  wide: [
    /^tháng ?(Một|0?1(?!\d))/i,
    /^tháng ?(Hai|0?2)/i,
    /^tháng ?(Ba|0?3)/i,
    /^tháng ?(Tư|0?4)/i,
    /^tháng ?(Năm|0?5)/i,
    /^tháng ?(Sáu|0?6)/i,
    /^tháng ?(Bảy|0?7)/i,
    /^tháng ?(Tám|0?8)/i,
    /^tháng ?(Chín|0?9)/i,
    /^tháng ?(Mười|10)/i,
    /^tháng ?(Mười ?Một|11)/i,
    /^tháng ?(Mười ?Hai|12)/i
  ]
}, pbt = {
  narrow: /^(CN|T2|T3|T4|T5|T6|T7)/i,
  short: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
  abbreviated: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
  wide: /^(Chủ ?Nhật|Chúa ?Nhật|thứ ?Hai|thứ ?Ba|thứ ?Tư|thứ ?Năm|thứ ?Sáu|thứ ?Bảy)/i
}, gbt = {
  narrow: [/CN/i, /2/i, /3/i, /4/i, /5/i, /6/i, /7/i],
  short: [/CN/i, /2/i, /3/i, /4/i, /5/i, /6/i, /7/i],
  abbreviated: [/CN/i, /2/i, /3/i, /4/i, /5/i, /6/i, /7/i],
  wide: [/(Chủ|Chúa) ?Nhật/i, /Hai/i, /Ba/i, /Tư/i, /Năm/i, /Sáu/i, /Bảy/i]
}, vbt = {
  narrow: /^(a|p|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
  abbreviated: /^(am|pm|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
  wide: /^(ch[^i]*|sa|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i
}, bbt = {
  any: {
    am: /^(a|sa)/i,
    pm: /^(p|ch[^i]*)/i,
    midnight: /nửa đêm/i,
    noon: /trưa/i,
    morning: /sáng/i,
    afternoon: /chiều/i,
    evening: /tối/i,
    night: /^đêm/i
  }
}, ybt = {
  ordinalNumber: Fn({
    matchPattern: lbt,
    parsePattern: sbt,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: ubt,
    defaultMatchWidth: "wide",
    parsePatterns: cbt,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: dbt,
    defaultMatchWidth: "wide",
    parsePatterns: fbt,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: mbt,
    defaultMatchWidth: "wide",
    parsePatterns: hbt,
    defaultParseWidth: "wide"
  }),
  day: Ee({
    matchPatterns: pbt,
    defaultMatchWidth: "wide",
    parsePatterns: gbt,
    defaultParseWidth: "wide"
  }),
  dayPeriod: Ee({
    matchPatterns: vbt,
    defaultMatchWidth: "wide",
    parsePatterns: bbt,
    defaultParseWidth: "any"
  })
}, wbt = {
  code: "vi",
  formatDistance: B1t,
  formatLong: q1t,
  formatRelative: Y1t,
  localize: ibt,
  match: ybt,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, Sbt = {
  lessThanXSeconds: {
    one: "不到 1 秒",
    other: "不到 {{count}} 秒"
  },
  xSeconds: {
    one: "1 秒",
    other: "{{count}} 秒"
  },
  halfAMinute: "半分钟",
  lessThanXMinutes: {
    one: "不到 1 分钟",
    other: "不到 {{count}} 分钟"
  },
  xMinutes: {
    one: "1 分钟",
    other: "{{count}} 分钟"
  },
  xHours: {
    one: "1 小时",
    other: "{{count}} 小时"
  },
  aboutXHours: {
    one: "大约 1 小时",
    other: "大约 {{count}} 小时"
  },
  xDays: {
    one: "1 天",
    other: "{{count}} 天"
  },
  aboutXWeeks: {
    one: "大约 1 个星期",
    other: "大约 {{count}} 个星期"
  },
  xWeeks: {
    one: "1 个星期",
    other: "{{count}} 个星期"
  },
  aboutXMonths: {
    one: "大约 1 个月",
    other: "大约 {{count}} 个月"
  },
  xMonths: {
    one: "1 个月",
    other: "{{count}} 个月"
  },
  aboutXYears: {
    one: "大约 1 年",
    other: "大约 {{count}} 年"
  },
  xYears: {
    one: "1 年",
    other: "{{count}} 年"
  },
  overXYears: {
    one: "超过 1 年",
    other: "超过 {{count}} 年"
  },
  almostXYears: {
    one: "将近 1 年",
    other: "将近 {{count}} 年"
  }
}, Cbt = (e, t, r) => {
  let a;
  const i = Sbt[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? a + "内" : a + "前" : a;
}, xbt = {
  full: "y'年'M'月'd'日' EEEE",
  long: "y'年'M'月'd'日'",
  medium: "yyyy-MM-dd",
  short: "yy-MM-dd"
}, Ebt = {
  full: "zzzz a h:mm:ss",
  long: "z a h:mm:ss",
  medium: "a h:mm:ss",
  short: "a h:mm"
}, Pbt = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, kbt = {
  date: Ke({
    formats: xbt,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: Ebt,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: Pbt,
    defaultWidth: "full"
  })
};
function sU(e, t, r) {
  const a = "eeee p";
  return su(e, t, r) ? a : e.getTime() > t.getTime() ? "'下个'" + a : "'上个'" + a;
}
const Mbt = {
  lastWeek: sU,
  // days before yesterday, maybe in this week or last week
  yesterday: "'昨天' p",
  today: "'今天' p",
  tomorrow: "'明天' p",
  nextWeek: sU,
  // days after tomorrow, maybe in this week or next week
  other: "PP p"
}, Obt = (e, t, r, a) => {
  const i = Mbt[e];
  return typeof i == "function" ? i(t, r, a) : i;
}, Tbt = {
  narrow: ["前", "公元"],
  abbreviated: ["前", "公元"],
  wide: ["公元前", "公元"]
}, Rbt = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["第一季", "第二季", "第三季", "第四季"],
  wide: ["第一季度", "第二季度", "第三季度", "第四季度"]
}, Abt = {
  narrow: [
    "一",
    "二",
    "三",
    "四",
    "五",
    "六",
    "七",
    "八",
    "九",
    "十",
    "十一",
    "十二"
  ],
  abbreviated: [
    "1月",
    "2月",
    "3月",
    "4月",
    "5月",
    "6月",
    "7月",
    "8月",
    "9月",
    "10月",
    "11月",
    "12月"
  ],
  wide: [
    "一月",
    "二月",
    "三月",
    "四月",
    "五月",
    "六月",
    "七月",
    "八月",
    "九月",
    "十月",
    "十一月",
    "十二月"
  ]
}, Nbt = {
  narrow: ["日", "一", "二", "三", "四", "五", "六"],
  short: ["日", "一", "二", "三", "四", "五", "六"],
  abbreviated: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
  wide: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"]
}, Dbt = {
  narrow: {
    am: "上",
    pm: "下",
    midnight: "凌晨",
    noon: "午",
    morning: "早",
    afternoon: "下午",
    evening: "晚",
    night: "夜"
  },
  abbreviated: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜间"
  },
  wide: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜间"
  }
}, $bt = {
  narrow: {
    am: "上",
    pm: "下",
    midnight: "凌晨",
    noon: "午",
    morning: "早",
    afternoon: "下午",
    evening: "晚",
    night: "夜"
  },
  abbreviated: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜间"
  },
  wide: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜间"
  }
}, zbt = (e, t) => {
  const r = Number(e);
  switch (t?.unit) {
    case "date":
      return r.toString() + "日";
    case "hour":
      return r.toString() + "时";
    case "minute":
      return r.toString() + "分";
    case "second":
      return r.toString() + "秒";
    default:
      return "第 " + r.toString();
  }
}, jbt = {
  ordinalNumber: zbt,
  era: Ce({
    values: Tbt,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: Rbt,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: Abt,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: Nbt,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: Dbt,
    defaultWidth: "wide",
    formattingValues: $bt,
    defaultFormattingWidth: "wide"
  })
}, Ibt = /^(第\s*)?\d+(日|时|分|秒)?/i, Lbt = /\d+/i, Hbt = {
  narrow: /^(前)/i,
  abbreviated: /^(前)/i,
  wide: /^(公元前|公元)/i
}, Fbt = {
  any: [/^(前)/i, /^(公元)/i]
}, Wbt = {
  narrow: /^[1234]/i,
  abbreviated: /^第[一二三四]刻/i,
  wide: /^第[一二三四]刻钟/i
}, Vbt = {
  any: [/(1|一)/i, /(2|二)/i, /(3|三)/i, /(4|四)/i]
}, _bt = {
  narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
  abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
  wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
}, Bbt = {
  narrow: [
    /^一/i,
    /^二/i,
    /^三/i,
    /^四/i,
    /^五/i,
    /^六/i,
    /^七/i,
    /^八/i,
    /^九/i,
    /^十(?!(一|二))/i,
    /^十一/i,
    /^十二/i
  ],
  any: [
    /^一|1/i,
    /^二|2/i,
    /^三|3/i,
    /^四|4/i,
    /^五|5/i,
    /^六|6/i,
    /^七|7/i,
    /^八|8/i,
    /^九|9/i,
    /^十(?!(一|二))|10/i,
    /^十一|11/i,
    /^十二|12/i
  ]
}, Ubt = {
  narrow: /^[一二三四五六日]/i,
  short: /^[一二三四五六日]/i,
  abbreviated: /^周[一二三四五六日]/i,
  wide: /^星期[一二三四五六日]/i
}, Xbt = {
  any: [/日/i, /一/i, /二/i, /三/i, /四/i, /五/i, /六/i]
}, Gbt = {
  any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨|)/i
}, qbt = {
  any: {
    am: /^上午?/i,
    pm: /^下午?/i,
    midnight: /^午夜/i,
    noon: /^[中正]午/i,
    morning: /^早上/i,
    afternoon: /^下午/i,
    evening: /^晚上?/i,
    night: /^凌晨/i
  }
}, Kbt = {
  ordinalNumber: Fn({
    matchPattern: Ibt,
    parsePattern: Lbt,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: Hbt,
    defaultMatchWidth: "wide",
    parsePatterns: Fbt,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: Wbt,
    defaultMatchWidth: "wide",
    parsePatterns: Vbt,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: _bt,
    defaultMatchWidth: "wide",
    parsePatterns: Bbt,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: Ubt,
    defaultMatchWidth: "wide",
    parsePatterns: Xbt,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: Gbt,
    defaultMatchWidth: "any",
    parsePatterns: qbt,
    defaultParseWidth: "any"
  })
}, Ybt = {
  code: "zh-CN",
  formatDistance: Cbt,
  formatLong: kbt,
  formatRelative: Obt,
  localize: jbt,
  match: Kbt,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Qbt = {
  lessThanXSeconds: {
    one: "少於 1 秒",
    other: "少於 {{count}} 秒"
  },
  xSeconds: {
    one: "1 秒",
    other: "{{count}} 秒"
  },
  halfAMinute: "半分鐘",
  lessThanXMinutes: {
    one: "少於 1 分鐘",
    other: "少於 {{count}} 分鐘"
  },
  xMinutes: {
    one: "1 分鐘",
    other: "{{count}} 分鐘"
  },
  xHours: {
    one: "1 小時",
    other: "{{count}} 小時"
  },
  aboutXHours: {
    one: "大約 1 小時",
    other: "大約 {{count}} 小時"
  },
  xDays: {
    one: "1 天",
    other: "{{count}} 天"
  },
  aboutXWeeks: {
    one: "大約 1 個星期",
    other: "大約 {{count}} 個星期"
  },
  xWeeks: {
    one: "1 個星期",
    other: "{{count}} 個星期"
  },
  aboutXMonths: {
    one: "大約 1 個月",
    other: "大約 {{count}} 個月"
  },
  xMonths: {
    one: "1 個月",
    other: "{{count}} 個月"
  },
  aboutXYears: {
    one: "大約 1 年",
    other: "大約 {{count}} 年"
  },
  xYears: {
    one: "1 年",
    other: "{{count}} 年"
  },
  overXYears: {
    one: "超過 1 年",
    other: "超過 {{count}} 年"
  },
  almostXYears: {
    one: "將近 1 年",
    other: "將近 {{count}} 年"
  }
}, Jbt = (e, t, r) => {
  let a;
  const i = Qbt[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? a + "內" : a + "前" : a;
}, Zbt = {
  full: "y'年'M'月'd'日' EEEE",
  long: "y'年'M'月'd'日'",
  medium: "yyyy-MM-dd",
  short: "yy-MM-dd"
}, eyt = {
  full: "zzzz a h:mm:ss",
  long: "z a h:mm:ss",
  medium: "a h:mm:ss",
  short: "a h:mm"
}, tyt = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, nyt = {
  date: Ke({
    formats: Zbt,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: eyt,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: tyt,
    defaultWidth: "full"
  })
}, ryt = {
  lastWeek: "'上個'eeee p",
  yesterday: "'昨天' p",
  today: "'今天' p",
  tomorrow: "'明天' p",
  nextWeek: "'下個'eeee p",
  other: "P"
}, ayt = (e, t, r, a) => ryt[e], oyt = {
  narrow: ["前", "公元"],
  abbreviated: ["前", "公元"],
  wide: ["公元前", "公元"]
}, iyt = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["第一季", "第二季", "第三季", "第四季"],
  wide: ["第一季度", "第二季度", "第三季度", "第四季度"]
}, lyt = {
  narrow: [
    "一",
    "二",
    "三",
    "四",
    "五",
    "六",
    "七",
    "八",
    "九",
    "十",
    "十一",
    "十二"
  ],
  abbreviated: [
    "1月",
    "2月",
    "3月",
    "4月",
    "5月",
    "6月",
    "7月",
    "8月",
    "9月",
    "10月",
    "11月",
    "12月"
  ],
  wide: [
    "一月",
    "二月",
    "三月",
    "四月",
    "五月",
    "六月",
    "七月",
    "八月",
    "九月",
    "十月",
    "十一月",
    "十二月"
  ]
}, syt = {
  narrow: ["日", "一", "二", "三", "四", "五", "六"],
  short: ["日", "一", "二", "三", "四", "五", "六"],
  abbreviated: ["週日", "週一", "週二", "週三", "週四", "週五", "週六"],
  wide: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"]
}, uyt = {
  narrow: {
    am: "上",
    pm: "下",
    midnight: "午夜",
    noon: "晌",
    morning: "早",
    afternoon: "午",
    evening: "晚",
    night: "夜"
  },
  abbreviated: {
    am: "上午",
    pm: "下午",
    midnight: "午夜",
    noon: "中午",
    morning: "上午",
    afternoon: "下午",
    evening: "晚上",
    night: "夜晚"
  },
  wide: {
    am: "上午",
    pm: "下午",
    midnight: "午夜",
    noon: "中午",
    morning: "上午",
    afternoon: "下午",
    evening: "晚上",
    night: "夜晚"
  }
}, cyt = {
  narrow: {
    am: "上",
    pm: "下",
    midnight: "午夜",
    noon: "晌",
    morning: "早",
    afternoon: "午",
    evening: "晚",
    night: "夜"
  },
  abbreviated: {
    am: "上午",
    pm: "下午",
    midnight: "午夜",
    noon: "中午",
    morning: "上午",
    afternoon: "下午",
    evening: "晚上",
    night: "夜晚"
  },
  wide: {
    am: "上午",
    pm: "下午",
    midnight: "午夜",
    noon: "中午",
    morning: "上午",
    afternoon: "下午",
    evening: "晚上",
    night: "夜晚"
  }
}, dyt = (e, t) => {
  const r = Number(e);
  switch (t?.unit) {
    case "date":
      return r + "日";
    case "hour":
      return r + "時";
    case "minute":
      return r + "分";
    case "second":
      return r + "秒";
    default:
      return "第 " + r;
  }
}, fyt = {
  ordinalNumber: dyt,
  era: Ce({
    values: oyt,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: iyt,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: lyt,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: syt,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: uyt,
    defaultWidth: "wide",
    formattingValues: cyt,
    defaultFormattingWidth: "wide"
  })
}, myt = /^(第\s*)?\d+(日|時|分|秒)?/i, hyt = /\d+/i, pyt = {
  narrow: /^(前)/i,
  abbreviated: /^(前)/i,
  wide: /^(公元前|公元)/i
}, gyt = {
  any: [/^(前)/i, /^(公元)/i]
}, vyt = {
  narrow: /^[1234]/i,
  abbreviated: /^第[一二三四]季/i,
  wide: /^第[一二三四]季度/i
}, byt = {
  any: [/(1|一)/i, /(2|二)/i, /(3|三)/i, /(4|四)/i]
}, yyt = {
  narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
  abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
  wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
}, wyt = {
  narrow: [
    /^一/i,
    /^二/i,
    /^三/i,
    /^四/i,
    /^五/i,
    /^六/i,
    /^七/i,
    /^八/i,
    /^九/i,
    /^十(?!(一|二))/i,
    /^十一/i,
    /^十二/i
  ],
  any: [
    /^一|1/i,
    /^二|2/i,
    /^三|3/i,
    /^四|4/i,
    /^五|5/i,
    /^六|6/i,
    /^七|7/i,
    /^八|8/i,
    /^九|9/i,
    /^十(?!(一|二))|10/i,
    /^十一|11/i,
    /^十二|12/i
  ]
}, Syt = {
  narrow: /^[一二三四五六日]/i,
  short: /^[一二三四五六日]/i,
  abbreviated: /^週[一二三四五六日]/i,
  wide: /^星期[一二三四五六日]/i
}, Cyt = {
  any: [/日/i, /一/i, /二/i, /三/i, /四/i, /五/i, /六/i]
}, xyt = {
  any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
}, Eyt = {
  any: {
    am: /^上午?/i,
    pm: /^下午?/i,
    midnight: /^午夜/i,
    noon: /^[中正]午/i,
    morning: /^早上/i,
    afternoon: /^下午/i,
    evening: /^晚上?/i,
    night: /^凌晨/i
  }
}, Pyt = {
  ordinalNumber: Fn({
    matchPattern: myt,
    parsePattern: hyt,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: pyt,
    defaultMatchWidth: "wide",
    parsePatterns: gyt,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: vyt,
    defaultMatchWidth: "wide",
    parsePatterns: byt,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: yyt,
    defaultMatchWidth: "wide",
    parsePatterns: wyt,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: Syt,
    defaultMatchWidth: "wide",
    parsePatterns: Cyt,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: xyt,
    defaultMatchWidth: "any",
    parsePatterns: Eyt,
    defaultParseWidth: "any"
  })
}, kyt = {
  code: "zh-HK",
  formatDistance: Jbt,
  formatLong: nyt,
  formatRelative: ayt,
  localize: fyt,
  match: Pyt,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, Myt = {
  lessThanXSeconds: {
    one: "少於 1 秒",
    other: "少於 {{count}} 秒"
  },
  xSeconds: {
    one: "1 秒",
    other: "{{count}} 秒"
  },
  halfAMinute: "半分鐘",
  lessThanXMinutes: {
    one: "少於 1 分鐘",
    other: "少於 {{count}} 分鐘"
  },
  xMinutes: {
    one: "1 分鐘",
    other: "{{count}} 分鐘"
  },
  xHours: {
    one: "1 小時",
    other: "{{count}} 小時"
  },
  aboutXHours: {
    one: "大約 1 小時",
    other: "大約 {{count}} 小時"
  },
  xDays: {
    one: "1 天",
    other: "{{count}} 天"
  },
  aboutXWeeks: {
    one: "大約 1 個星期",
    other: "大約 {{count}} 個星期"
  },
  xWeeks: {
    one: "1 個星期",
    other: "{{count}} 個星期"
  },
  aboutXMonths: {
    one: "大約 1 個月",
    other: "大約 {{count}} 個月"
  },
  xMonths: {
    one: "1 個月",
    other: "{{count}} 個月"
  },
  aboutXYears: {
    one: "大約 1 年",
    other: "大約 {{count}} 年"
  },
  xYears: {
    one: "1 年",
    other: "{{count}} 年"
  },
  overXYears: {
    one: "超過 1 年",
    other: "超過 {{count}} 年"
  },
  almostXYears: {
    one: "將近 1 年",
    other: "將近 {{count}} 年"
  }
}, Oyt = (e, t, r) => {
  let a;
  const i = Myt[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", String(t)), r?.addSuffix ? r.comparison && r.comparison > 0 ? a + "內" : a + "前" : a;
}, Tyt = {
  full: "y'年'M'月'd'日' EEEE",
  long: "y'年'M'月'd'日'",
  medium: "yyyy-MM-dd",
  short: "yy-MM-dd"
}, Ryt = {
  full: "zzzz a h:mm:ss",
  long: "z a h:mm:ss",
  medium: "a h:mm:ss",
  short: "a h:mm"
}, Ayt = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Nyt = {
  date: Ke({
    formats: Tyt,
    defaultWidth: "full"
  }),
  time: Ke({
    formats: Ryt,
    defaultWidth: "full"
  }),
  dateTime: Ke({
    formats: Ayt,
    defaultWidth: "full"
  })
}, Dyt = {
  lastWeek: "'上個'eeee p",
  yesterday: "'昨天' p",
  today: "'今天' p",
  tomorrow: "'明天' p",
  nextWeek: "'下個'eeee p",
  other: "P"
}, $yt = (e, t, r, a) => Dyt[e], zyt = {
  narrow: ["前", "公元"],
  abbreviated: ["前", "公元"],
  wide: ["公元前", "公元"]
}, jyt = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["第一刻", "第二刻", "第三刻", "第四刻"],
  wide: ["第一刻鐘", "第二刻鐘", "第三刻鐘", "第四刻鐘"]
}, Iyt = {
  narrow: [
    "一",
    "二",
    "三",
    "四",
    "五",
    "六",
    "七",
    "八",
    "九",
    "十",
    "十一",
    "十二"
  ],
  abbreviated: [
    "1月",
    "2月",
    "3月",
    "4月",
    "5月",
    "6月",
    "7月",
    "8月",
    "9月",
    "10月",
    "11月",
    "12月"
  ],
  wide: [
    "一月",
    "二月",
    "三月",
    "四月",
    "五月",
    "六月",
    "七月",
    "八月",
    "九月",
    "十月",
    "十一月",
    "十二月"
  ]
}, Lyt = {
  narrow: ["日", "一", "二", "三", "四", "五", "六"],
  short: ["日", "一", "二", "三", "四", "五", "六"],
  abbreviated: ["週日", "週一", "週二", "週三", "週四", "週五", "週六"],
  wide: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"]
}, Hyt = {
  narrow: {
    am: "上",
    pm: "下",
    midnight: "凌晨",
    noon: "午",
    morning: "早",
    afternoon: "下午",
    evening: "晚",
    night: "夜"
  },
  abbreviated: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜間"
  },
  wide: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜間"
  }
}, Fyt = {
  narrow: {
    am: "上",
    pm: "下",
    midnight: "凌晨",
    noon: "午",
    morning: "早",
    afternoon: "下午",
    evening: "晚",
    night: "夜"
  },
  abbreviated: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜間"
  },
  wide: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜間"
  }
}, Wyt = (e, t) => {
  const r = Number(e);
  switch (t?.unit) {
    case "date":
      return r + "日";
    case "hour":
      return r + "時";
    case "minute":
      return r + "分";
    case "second":
      return r + "秒";
    default:
      return "第 " + r;
  }
}, Vyt = {
  ordinalNumber: Wyt,
  era: Ce({
    values: zyt,
    defaultWidth: "wide"
  }),
  quarter: Ce({
    values: jyt,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ce({
    values: Iyt,
    defaultWidth: "wide"
  }),
  day: Ce({
    values: Lyt,
    defaultWidth: "wide"
  }),
  dayPeriod: Ce({
    values: Hyt,
    defaultWidth: "wide",
    formattingValues: Fyt,
    defaultFormattingWidth: "wide"
  })
}, _yt = /^(第\s*)?\d+(日|時|分|秒)?/i, Byt = /\d+/i, Uyt = {
  narrow: /^(前)/i,
  abbreviated: /^(前)/i,
  wide: /^(公元前|公元)/i
}, Xyt = {
  any: [/^(前)/i, /^(公元)/i]
}, Gyt = {
  narrow: /^[1234]/i,
  abbreviated: /^第[一二三四]刻/i,
  wide: /^第[一二三四]刻鐘/i
}, qyt = {
  any: [/(1|一)/i, /(2|二)/i, /(3|三)/i, /(4|四)/i]
}, Kyt = {
  narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
  abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
  wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
}, Yyt = {
  narrow: [
    /^一/i,
    /^二/i,
    /^三/i,
    /^四/i,
    /^五/i,
    /^六/i,
    /^七/i,
    /^八/i,
    /^九/i,
    /^十(?!(一|二))/i,
    /^十一/i,
    /^十二/i
  ],
  any: [
    /^一|1/i,
    /^二|2/i,
    /^三|3/i,
    /^四|4/i,
    /^五|5/i,
    /^六|6/i,
    /^七|7/i,
    /^八|8/i,
    /^九|9/i,
    /^十(?!(一|二))|10/i,
    /^十一|11/i,
    /^十二|12/i
  ]
}, Qyt = {
  narrow: /^[一二三四五六日]/i,
  short: /^[一二三四五六日]/i,
  abbreviated: /^週[一二三四五六日]/i,
  wide: /^星期[一二三四五六日]/i
}, Jyt = {
  any: [/日/i, /一/i, /二/i, /三/i, /四/i, /五/i, /六/i]
}, Zyt = {
  any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
}, ewt = {
  any: {
    am: /^上午?/i,
    pm: /^下午?/i,
    midnight: /^午夜/i,
    noon: /^[中正]午/i,
    morning: /^早上/i,
    afternoon: /^下午/i,
    evening: /^晚上?/i,
    night: /^凌晨/i
  }
}, twt = {
  ordinalNumber: Fn({
    matchPattern: _yt,
    parsePattern: Byt,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ee({
    matchPatterns: Uyt,
    defaultMatchWidth: "wide",
    parsePatterns: Xyt,
    defaultParseWidth: "any"
  }),
  quarter: Ee({
    matchPatterns: Gyt,
    defaultMatchWidth: "wide",
    parsePatterns: qyt,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ee({
    matchPatterns: Kyt,
    defaultMatchWidth: "wide",
    parsePatterns: Yyt,
    defaultParseWidth: "any"
  }),
  day: Ee({
    matchPatterns: Qyt,
    defaultMatchWidth: "wide",
    parsePatterns: Jyt,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ee({
    matchPatterns: Zyt,
    defaultMatchWidth: "any",
    parsePatterns: ewt,
    defaultParseWidth: "any"
  })
}, nwt = {
  code: "zh-TW",
  formatDistance: Oyt,
  formatLong: Nyt,
  formatRelative: $yt,
  localize: Vyt,
  match: twt,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, rwt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  af: bTe,
  ar: qTe,
  arDZ: ERe,
  arEG: eAe,
  arMA: RAe,
  arSA: iNe,
  arTN: jNe,
  az: mDe,
  be: KDe,
  beTarask: A$e,
  bg: fze,
  bn: Bze,
  bs: Sje,
  ca: Jje,
  ckb: OIe,
  cs: iLe,
  cy: jLe,
  da: fHe,
  de: IHe,
  deAT: XHe,
  el: CFe,
  enAU: MFe,
  enCA: $Fe,
  enGB: LFe,
  enIE: HFe,
  enIN: BFe,
  enNZ: KFe,
  enUS: B3,
  enZA: eWe,
  eo: TWe,
  es: iVe,
  et: DVe,
  eu: c_e,
  faIR: F_e,
  fi: gBe,
  fr: VBe,
  frCA: GBe,
  frCH: eUe,
  fy: TUe,
  gd: oXe,
  gl: jXe,
  gu: fGe,
  he: _Ge,
  hi: wqe,
  hr: Qqe,
  ht: kKe,
  hu: oYe,
  hy: zYe,
  id: dQe,
  is: WQe,
  it: pJe,
  itCH: wJe,
  ja: YJe,
  jaHira: kZe,
  ka: net,
  kk: Iet,
  km: mtt,
  kn: _tt,
  ko: ynt,
  lb: Znt,
  lt: Nrt,
  lv: dat,
  mk: Vat,
  mn: yot,
  ms: Kot,
  mt: Pit,
  nb: elt,
  nl: Tlt,
  nlBE: ast,
  nn: $st,
  oc: cut,
  pl: Gut,
  pt: xct,
  ptBR: Zct,
  ro: Tdt,
  ru: sft,
  se: Ift,
  sk: ymt,
  sl: Qmt,
  sq: Mht,
  sr: apt,
  srLatn: zpt,
  sv: fgt,
  ta: _gt,
  te: b0t,
  th: q0t,
  tr: Evt,
  ug: e2t,
  uk: j2t,
  uz: f1t,
  uzCyrl: V1t,
  vi: wbt,
  zhCN: Ybt,
  zhHK: kyt,
  zhTW: nwt
}, Symbol.toStringTag, { value: "Module" }));
function awt(e = navigator.language) {
  const t = Array.isArray(e) ? e[0] : e, a = (typeof t == "string" ? t : t.baseName).replace("-", ""), i = a.slice(0, 2), c = rwt;
  return (c[a] ?? c[i])?.formatLong?.date({ width: "short" });
}
const owt = /[A-Za-z]/g;
function uU(e, t, r) {
  if (r)
    return r.includes("D") && cU(
      "capital 'D' to represent day of the month. Please use 'd' instead."
    ), r.includes("Y") && cU(
      "capital 'Y' to represent year. Please use 'y' instead."
    ), r.replaceAll("D", "d").replaceAll("Y", "y");
  const a = awt(t);
  if (e === "date")
    return a;
  const i = a.replaceAll(owt, "")[0];
  let c = a.replaceAll("d", "");
  const d = new RegExp(`${i}${i}`);
  d.test(c) && (c = c.replace(d, i));
  const f = new RegExp(`^${i}`);
  f.test(c) && (c = c.replace(f, ""));
  const p = new RegExp(`${i}$`);
  return p.test(c) && (c = c.replace(p, "")), c;
}
function cU(e) {
  console.warn(
    // eslint-disable-next-line github/unescaped-html-literal
    `<Input kind="date"> and <Input kind="month"> no longer support dateFormat using ${e}`
  );
}
function j1({
  format: e,
  formatRegExp: t,
  date: r
}) {
  if (!r)
    return;
  if (r instanceof Date)
    return r;
  if (!(t ?? R$(e)).test(r))
    return;
  const i = ule(r, e, /* @__PURE__ */ new Date());
  return Number.isNaN(i.getTime()) ? void 0 : i;
}
function Vte({
  inputReference: e,
  inputSelection: t
}) {
  const r = e.current;
  if (!r)
    return;
  const { selectionStart: a, selectionEnd: i } = t.current ?? {};
  typeof a == "number" && (r.selectionStart = a), typeof i == "number" && (r.selectionEnd = i);
}
function iwt({
  format: e,
  direction: t,
  inputReference: r,
  inputSelection: a,
  setSelectedDatePart: i
}) {
  if (!r.current)
    return;
  const { value: c } = r.current ?? { value: "" };
  let { selectionStart: d, selectionEnd: f } = r.current ?? {};
  d = d ?? 0, f = f ?? 0, t > 0 ? (d = f + 2 >= c.length ? 0 : f + 1, f = d + 1) : (f = d - 1, d = d - 2), r.current.selectionStart = d, r.current.selectionStart = f, yte({
    format: e,
    inputReference: r,
    inputSelection: a,
    setSelectedDatePart: i
  });
}
function lwt({
  date: e,
  datePart: t,
  direction: r
}) {
  if (!e)
    return;
  const a = new Date(e.getTime());
  switch (t) {
    case "day": {
      a.setDate(e.getDate() + r);
      break;
    }
    case "month": {
      a.setMonth(e.getMonth() + r), (r > 0 && a.getMonth() === (e.getMonth() + 2) % 12 || r < 0 && a.getMonth() === e.getMonth()) && a.setDate(0);
      break;
    }
    case "year": {
      a.setFullYear(e.getFullYear() + r);
      break;
    }
  }
  return a;
}
function swt({
  inputReference: e,
  inputSelection: t,
  format: r,
  formatRegExp: a,
  onChange: i,
  onKeyUp: c,
  returnType: d,
  selectedDatePart: f,
  setSelectedDatePart: p
}, g) {
  if (c?.(g), !["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(g.key) || !e.current)
    return;
  const b = g.target, { value: w } = b;
  if (a.test(w)) {
    if (g.preventDefault(), Vte({ inputReference: e, inputSelection: t }), T$({ inputReference: e, inputSelection: t }), ["ArrowUp", "ArrowDown"].includes(g.key)) {
      const x = j1({
        format: r,
        formatRegExp: a,
        date: w
      });
      if (!x)
        return;
      const E = lwt({
        date: x,
        datePart: f,
        direction: g.key === "ArrowUp" ? 1 : -1
      });
      if (E && E.getTime() !== x.getTime()) {
        const P = d === "Date" ? x : KS({ format: r, date: x, fallbackValue: w }), k = d === "Date" ? E : KS({ format: r, date: E });
        i?.(k, P);
      }
      return;
    }
    iwt({
      direction: g.key === "ArrowRight" ? 1 : -1,
      format: r,
      inputReference: e,
      inputSelection: t,
      setSelectedDatePart: p
    }), T$({ inputReference: e, inputSelection: t });
  }
}
function uwt({
  formatRegExp: e,
  inputReference: t
}) {
  const r = It({}), [a, i] = Wn();
  if (t.current) {
    const { value: c } = t.current;
    e.test(c) ? requestAnimationFrame(() => {
      Vte({ inputReference: t, inputSelection: r });
    }) : r.current = {};
  }
  return {
    inputSelection: r,
    selectedDatePart: a,
    setSelectedDatePart: i
  };
}
function cwt({
  format: e,
  formatRegExp: t,
  inputReference: r,
  onChange: a,
  onClick: i,
  onFocus: c,
  onKeyUp: d,
  returnType: f,
  setOpen: p
}) {
  const { inputSelection: g, selectedDatePart: b, setSelectedDatePart: w } = uwt({ formatRegExp: t, inputReference: r }), x = mn(
    () => wOe.bind(void 0, {
      onFocus: c,
      setOpen: p
    }),
    [c, p]
  ), E = mn(
    () => yOe.bind(void 0, {
      format: e,
      inputReference: r,
      inputSelection: g,
      onClick: i,
      setSelectedDatePart: w
    }),
    [
      e,
      r,
      g,
      i,
      w
    ]
  ), P = mn(
    () => swt.bind(void 0, {
      format: e,
      formatRegExp: t,
      inputReference: r,
      inputSelection: g,
      onChange: a,
      onKeyUp: d,
      returnType: f,
      selectedDatePart: b,
      setSelectedDatePart: w
    }),
    [
      e,
      t,
      r,
      g,
      a,
      d,
      f,
      b,
      w
    ]
  );
  return { onClick: E, onFocus: x, onKeyUp: P };
}
function dwt({
  format: e,
  formatRegExp: t,
  onChange: r,
  returnType: a,
  setDisplayValue: i,
  setMonth: c,
  setSelectedDate: d,
  value: f
}, p, g, b) {
  i(p);
  const w = j1({ format: e, formatRegExp: t, date: p });
  if (d(w), c(w), fwt(w ?? p, f)) {
    const x = dU(
      f,
      a,
      e,
      g ?? ""
    ), E = dU(w, a, e, p);
    r(E || void 0, x, b);
  }
}
function fwt(e, t) {
  return e instanceof Date && t instanceof Date ? e.getTime() !== t.getTime() : e !== t;
}
function dU(e, t, r, a) {
  if (e)
    return t === "Date" ? e instanceof Date ? e : j1({ format: r, date: e }) : typeof e == "string" ? e : KS({ format: r, date: e, fallbackValue: a });
}
function mwt({
  format: e,
  onChange: t,
  returnType: r,
  setDisplayValue: a,
  setOpen: i,
  setSelectedDate: c,
  value: d
}, f) {
  f && c(f);
  const p = KS({ format: e, date: f });
  if (a(p), i(!1), f) {
    let g = d;
    d instanceof Date && r !== "Date" ? g = KS({ format: e, date: d }) : typeof d == "string" && r === "Date" && (g = j1({ format: e, date: d })), t(r === "Date" ? f : p, g);
  }
}
function hwt({ inputReference: e }, t) {
  e.current?.contains(t.target) && t.preventDefault();
}
function pwt(e) {
  e.preventDefault();
}
function gwt({
  format: e,
  formatRegExp: t,
  inputReference: r,
  onChange: a,
  returnType: i,
  setDisplayValue: c,
  setMonth: d,
  setOpen: f,
  setSelectedDate: p,
  value: g
}) {
  const b = mn(
    () => mwt.bind(void 0, {
      format: e,
      onChange: a,
      returnType: i,
      setDisplayValue: c,
      setOpen: f,
      setSelectedDate: p,
      value: g
    }),
    [
      e,
      a,
      i,
      c,
      f,
      p,
      g
    ]
  ), w = mn(
    () => dwt.bind(void 0, {
      format: e,
      formatRegExp: t,
      onChange: a,
      returnType: i,
      setDisplayValue: c,
      setMonth: d,
      setSelectedDate: p,
      value: g
    }),
    [
      e,
      t,
      a,
      i,
      c,
      d,
      p,
      g
    ]
  ), x = mn(
    () => hwt.bind(void 0, { inputReference: r }),
    [r]
  );
  return {
    onSelect: b,
    onChange: w,
    popoverShouldNotPullFocus: pwt,
    dismissPopoverUnlessInput: x
  };
}
function rp(e) {
  const t = S.useRef(e);
  return S.useEffect(() => {
    t.current = e;
  }), S.useMemo(() => (...r) => t.current?.(...r), []);
}
function vwt(e, t = globalThis?.document) {
  const r = rp(e);
  S.useEffect(() => {
    const a = (i) => {
      i.key === "Escape" && r(i);
    };
    return t.addEventListener("keydown", a, { capture: !0 }), () => t.removeEventListener("keydown", a, { capture: !0 });
  }, [r, t]);
}
var bwt = "DismissableLayer", $$ = "dismissableLayer.update", ywt = "dismissableLayer.pointerDownOutside", wwt = "dismissableLayer.focusOutside", fU, _te = S.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), zM = S.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: r = !1,
      onEscapeKeyDown: a,
      onPointerDownOutside: i,
      onFocusOutside: c,
      onInteractOutside: d,
      onDismiss: f,
      ...p
    } = e, g = S.useContext(_te), [b, w] = S.useState(null), x = b?.ownerDocument ?? globalThis?.document, [, E] = S.useState({}), P = Wl(t, (L) => w(L)), k = Array.from(g.layers), [M] = [...g.layersWithOutsidePointerEventsDisabled].slice(-1), T = k.indexOf(M), N = b ? k.indexOf(b) : -1, D = g.layersWithOutsidePointerEventsDisabled.size > 0, $ = N >= T, j = xwt((L) => {
      const F = L.target, _ = [...g.branches].some((W) => W.contains(F));
      !$ || _ || (i?.(L), d?.(L), L.defaultPrevented || f?.());
    }, x), I = Ewt((L) => {
      const F = L.target;
      [...g.branches].some((W) => W.contains(F)) || (c?.(L), d?.(L), L.defaultPrevented || f?.());
    }, x);
    return vwt((L) => {
      N === g.layers.size - 1 && (a?.(L), !L.defaultPrevented && f && (L.preventDefault(), f()));
    }, x), S.useEffect(() => {
      if (b)
        return r && (g.layersWithOutsidePointerEventsDisabled.size === 0 && (fU = x.body.style.pointerEvents, x.body.style.pointerEvents = "none"), g.layersWithOutsidePointerEventsDisabled.add(b)), g.layers.add(b), mU(), () => {
          r && g.layersWithOutsidePointerEventsDisabled.size === 1 && (x.body.style.pointerEvents = fU);
        };
    }, [b, x, r, g]), S.useEffect(() => () => {
      b && (g.layers.delete(b), g.layersWithOutsidePointerEventsDisabled.delete(b), mU());
    }, [b, g]), S.useEffect(() => {
      const L = () => E({});
      return document.addEventListener($$, L), () => document.removeEventListener($$, L);
    }, []), /* @__PURE__ */ V.jsx(
      Ro.div,
      {
        ...p,
        ref: P,
        style: {
          pointerEvents: D ? $ ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: io(e.onFocusCapture, I.onFocusCapture),
        onBlurCapture: io(e.onBlurCapture, I.onBlurCapture),
        onPointerDownCapture: io(
          e.onPointerDownCapture,
          j.onPointerDownCapture
        )
      }
    );
  }
);
zM.displayName = bwt;
var Swt = "DismissableLayerBranch", Cwt = S.forwardRef((e, t) => {
  const r = S.useContext(_te), a = S.useRef(null), i = Wl(t, a);
  return S.useEffect(() => {
    const c = a.current;
    if (c)
      return r.branches.add(c), () => {
        r.branches.delete(c);
      };
  }, [r.branches]), /* @__PURE__ */ V.jsx(Ro.div, { ...e, ref: i });
});
Cwt.displayName = Swt;
function xwt(e, t = globalThis?.document) {
  const r = rp(e), a = S.useRef(!1), i = S.useRef(() => {
  });
  return S.useEffect(() => {
    const c = (f) => {
      if (f.target && !a.current) {
        let p = function() {
          Bte(
            ywt,
            r,
            g,
            { discrete: !0 }
          );
        };
        const g = { originalEvent: f };
        f.pointerType === "touch" ? (t.removeEventListener("click", i.current), i.current = p, t.addEventListener("click", i.current, { once: !0 })) : p();
      } else
        t.removeEventListener("click", i.current);
      a.current = !1;
    }, d = window.setTimeout(() => {
      t.addEventListener("pointerdown", c);
    }, 0);
    return () => {
      window.clearTimeout(d), t.removeEventListener("pointerdown", c), t.removeEventListener("click", i.current);
    };
  }, [t, r]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => a.current = !0
  };
}
function Ewt(e, t = globalThis?.document) {
  const r = rp(e), a = S.useRef(!1);
  return S.useEffect(() => {
    const i = (c) => {
      c.target && !a.current && Bte(wwt, r, { originalEvent: c }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", i), () => t.removeEventListener("focusin", i);
  }, [t, r]), {
    onFocusCapture: () => a.current = !0,
    onBlurCapture: () => a.current = !1
  };
}
function mU() {
  const e = new CustomEvent($$);
  document.dispatchEvent(e);
}
function Bte(e, t, r, { discrete: a }) {
  const i = r.originalEvent.target, c = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: r });
  t && i.addEventListener(e, t, { once: !0 }), a ? O$(i, c) : i.dispatchEvent(c);
}
var AA = 0;
function Ute() {
  S.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? hU()), document.body.insertAdjacentElement("beforeend", e[1] ?? hU()), AA++, () => {
      AA === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), AA--;
    };
  }, []);
}
function hU() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var NA = "focusScope.autoFocusOnMount", DA = "focusScope.autoFocusOnUnmount", pU = { bubbles: !1, cancelable: !0 }, Pwt = "FocusScope", TI = S.forwardRef((e, t) => {
  const {
    loop: r = !1,
    trapped: a = !1,
    onMountAutoFocus: i,
    onUnmountAutoFocus: c,
    ...d
  } = e, [f, p] = S.useState(null), g = rp(i), b = rp(c), w = S.useRef(null), x = Wl(t, (k) => p(k)), E = S.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  S.useEffect(() => {
    if (a) {
      let k = function(D) {
        if (E.paused || !f) return;
        const $ = D.target;
        f.contains($) ? w.current = $ : MS(w.current, { select: !0 });
      }, M = function(D) {
        if (E.paused || !f) return;
        const $ = D.relatedTarget;
        $ !== null && (f.contains($) || MS(w.current, { select: !0 }));
      }, T = function(D) {
        if (document.activeElement === document.body)
          for (const j of D)
            j.removedNodes.length > 0 && MS(f);
      };
      document.addEventListener("focusin", k), document.addEventListener("focusout", M);
      const N = new MutationObserver(T);
      return f && N.observe(f, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", k), document.removeEventListener("focusout", M), N.disconnect();
      };
    }
  }, [a, f, E.paused]), S.useEffect(() => {
    if (f) {
      vU.add(E);
      const k = document.activeElement;
      if (!f.contains(k)) {
        const T = new CustomEvent(NA, pU);
        f.addEventListener(NA, g), f.dispatchEvent(T), T.defaultPrevented || (kwt(Awt(Xte(f)), { select: !0 }), document.activeElement === k && MS(f));
      }
      return () => {
        f.removeEventListener(NA, g), setTimeout(() => {
          const T = new CustomEvent(DA, pU);
          f.addEventListener(DA, b), f.dispatchEvent(T), T.defaultPrevented || MS(k ?? document.body, { select: !0 }), f.removeEventListener(DA, b), vU.remove(E);
        }, 0);
      };
    }
  }, [f, g, b, E]);
  const P = S.useCallback(
    (k) => {
      if (!r && !a || E.paused) return;
      const M = k.key === "Tab" && !k.altKey && !k.ctrlKey && !k.metaKey, T = document.activeElement;
      if (M && T) {
        const N = k.currentTarget, [D, $] = Mwt(N);
        D && $ ? !k.shiftKey && T === $ ? (k.preventDefault(), r && MS(D, { select: !0 })) : k.shiftKey && T === D && (k.preventDefault(), r && MS($, { select: !0 })) : T === N && k.preventDefault();
      }
    },
    [r, a, E.paused]
  );
  return /* @__PURE__ */ V.jsx(Ro.div, { tabIndex: -1, ...d, ref: x, onKeyDown: P });
});
TI.displayName = Pwt;
function kwt(e, { select: t = !1 } = {}) {
  const r = document.activeElement;
  for (const a of e)
    if (MS(a, { select: t }), document.activeElement !== r) return;
}
function Mwt(e) {
  const t = Xte(e), r = gU(t, e), a = gU(t.reverse(), e);
  return [r, a];
}
function Xte(e) {
  const t = [], r = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (a) => {
      const i = a.tagName === "INPUT" && a.type === "hidden";
      return a.disabled || a.hidden || i ? NodeFilter.FILTER_SKIP : a.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; r.nextNode(); ) t.push(r.currentNode);
  return t;
}
function gU(e, t) {
  for (const r of e)
    if (!Owt(r, { upTo: t })) return r;
}
function Owt(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function Twt(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function MS(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const r = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== r && Twt(e) && t && e.select();
  }
}
var vU = Rwt();
function Rwt() {
  let e = [];
  return {
    add(t) {
      const r = e[0];
      t !== r && r?.pause(), e = bU(e, t), e.unshift(t);
    },
    remove(t) {
      e = bU(e, t), e[0]?.resume();
    }
  };
}
function bU(e, t) {
  const r = [...e], a = r.indexOf(t);
  return a !== -1 && r.splice(a, 1), r;
}
function Awt(e) {
  return e.filter((t) => t.tagName !== "A");
}
var Nwt = S[" useId ".trim().toString()] || (() => {
}), Dwt = 0;
function T0(e) {
  const [t, r] = S.useState(Nwt());
  return G1(() => {
    r((a) => a ?? String(Dwt++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
const $wt = ["top", "right", "bottom", "left"], YS = Math.min, k0 = Math.max, Nx = Math.round, Z3 = Math.floor, fb = (e) => ({
  x: e,
  y: e
}), zwt = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, jwt = {
  start: "end",
  end: "start"
};
function l9(e, t, r) {
  return k0(e, YS(t, r));
}
function wb(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function lp(e) {
  return e.split("-")[0];
}
function bS(e) {
  return e.split("-")[1];
}
function RI(e) {
  return e === "x" ? "y" : "x";
}
function jM(e) {
  return e === "y" ? "height" : "width";
}
const Iwt = /* @__PURE__ */ new Set(["top", "bottom"]);
function V0(e) {
  return Iwt.has(lp(e)) ? "y" : "x";
}
function IM(e) {
  return RI(V0(e));
}
function Lwt(e, t, r) {
  r === void 0 && (r = !1);
  const a = bS(e), i = IM(e), c = jM(i);
  let d = i === "x" ? a === (r ? "end" : "start") ? "right" : "left" : a === "start" ? "bottom" : "top";
  return t.reference[c] > t.floating[c] && (d = s9(d)), [d, s9(d)];
}
function Hwt(e) {
  const t = s9(e);
  return [z$(e), t, z$(t)];
}
function z$(e) {
  return e.replace(/start|end/g, (t) => jwt[t]);
}
const yU = ["left", "right"], wU = ["right", "left"], Fwt = ["top", "bottom"], Wwt = ["bottom", "top"];
function Vwt(e, t, r) {
  switch (e) {
    case "top":
    case "bottom":
      return r ? t ? wU : yU : t ? yU : wU;
    case "left":
    case "right":
      return t ? Fwt : Wwt;
    default:
      return [];
  }
}
function _wt(e, t, r, a) {
  const i = bS(e);
  let c = Vwt(lp(e), r === "start", a);
  return i && (c = c.map((d) => d + "-" + i), t && (c = c.concat(c.map(z$)))), c;
}
function s9(e) {
  return e.replace(/left|right|bottom|top/g, (t) => zwt[t]);
}
function Bwt(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function AI(e) {
  return typeof e != "number" ? Bwt(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function u9(e) {
  const {
    x: t,
    y: r,
    width: a,
    height: i
  } = e;
  return {
    width: a,
    height: i,
    top: r,
    left: t,
    right: t + a,
    bottom: r + i,
    x: t,
    y: r
  };
}
function SU(e, t, r) {
  let {
    reference: a,
    floating: i
  } = e;
  const c = V0(t), d = IM(t), f = jM(d), p = lp(t), g = c === "y", b = a.x + a.width / 2 - i.width / 2, w = a.y + a.height / 2 - i.height / 2, x = a[f] / 2 - i[f] / 2;
  let E;
  switch (p) {
    case "top":
      E = {
        x: b,
        y: a.y - i.height
      };
      break;
    case "bottom":
      E = {
        x: b,
        y: a.y + a.height
      };
      break;
    case "right":
      E = {
        x: a.x + a.width,
        y: w
      };
      break;
    case "left":
      E = {
        x: a.x - i.width,
        y: w
      };
      break;
    default:
      E = {
        x: a.x,
        y: a.y
      };
  }
  switch (bS(t)) {
    case "start":
      E[d] -= x * (r && g ? -1 : 1);
      break;
    case "end":
      E[d] += x * (r && g ? -1 : 1);
      break;
  }
  return E;
}
async function Uwt(e, t) {
  var r;
  t === void 0 && (t = {});
  const {
    x: a,
    y: i,
    platform: c,
    rects: d,
    elements: f,
    strategy: p
  } = e, {
    boundary: g = "clippingAncestors",
    rootBoundary: b = "viewport",
    elementContext: w = "floating",
    altBoundary: x = !1,
    padding: E = 0
  } = wb(t, e), P = AI(E), M = f[x ? w === "floating" ? "reference" : "floating" : w], T = u9(await c.getClippingRect({
    element: (r = await (c.isElement == null ? void 0 : c.isElement(M))) == null || r ? M : M.contextElement || await (c.getDocumentElement == null ? void 0 : c.getDocumentElement(f.floating)),
    boundary: g,
    rootBoundary: b,
    strategy: p
  })), N = w === "floating" ? {
    x: a,
    y: i,
    width: d.floating.width,
    height: d.floating.height
  } : d.reference, D = await (c.getOffsetParent == null ? void 0 : c.getOffsetParent(f.floating)), $ = await (c.isElement == null ? void 0 : c.isElement(D)) ? await (c.getScale == null ? void 0 : c.getScale(D)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, j = u9(c.convertOffsetParentRelativeRectToViewportRelativeRect ? await c.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: f,
    rect: N,
    offsetParent: D,
    strategy: p
  }) : N);
  return {
    top: (T.top - j.top + P.top) / $.y,
    bottom: (j.bottom - T.bottom + P.bottom) / $.y,
    left: (T.left - j.left + P.left) / $.x,
    right: (j.right - T.right + P.right) / $.x
  };
}
const Xwt = async (e, t, r) => {
  const {
    placement: a = "bottom",
    strategy: i = "absolute",
    middleware: c = [],
    platform: d
  } = r, f = c.filter(Boolean), p = await (d.isRTL == null ? void 0 : d.isRTL(t));
  let g = await d.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), {
    x: b,
    y: w
  } = SU(g, a, p), x = a, E = {}, P = 0;
  for (let M = 0; M < f.length; M++) {
    var k;
    const {
      name: T,
      fn: N
    } = f[M], {
      x: D,
      y: $,
      data: j,
      reset: I
    } = await N({
      x: b,
      y: w,
      initialPlacement: a,
      placement: x,
      strategy: i,
      middlewareData: E,
      rects: g,
      platform: {
        ...d,
        detectOverflow: (k = d.detectOverflow) != null ? k : Uwt
      },
      elements: {
        reference: e,
        floating: t
      }
    });
    b = D ?? b, w = $ ?? w, E = {
      ...E,
      [T]: {
        ...E[T],
        ...j
      }
    }, I && P <= 50 && (P++, typeof I == "object" && (I.placement && (x = I.placement), I.rects && (g = I.rects === !0 ? await d.getElementRects({
      reference: e,
      floating: t,
      strategy: i
    }) : I.rects), {
      x: b,
      y: w
    } = SU(g, x, p)), M = -1);
  }
  return {
    x: b,
    y: w,
    placement: x,
    strategy: i,
    middlewareData: E
  };
}, Gwt = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: r,
      y: a,
      placement: i,
      rects: c,
      platform: d,
      elements: f,
      middlewareData: p
    } = t, {
      element: g,
      padding: b = 0
    } = wb(e, t) || {};
    if (g == null)
      return {};
    const w = AI(b), x = {
      x: r,
      y: a
    }, E = IM(i), P = jM(E), k = await d.getDimensions(g), M = E === "y", T = M ? "top" : "left", N = M ? "bottom" : "right", D = M ? "clientHeight" : "clientWidth", $ = c.reference[P] + c.reference[E] - x[E] - c.floating[P], j = x[E] - c.reference[E], I = await (d.getOffsetParent == null ? void 0 : d.getOffsetParent(g));
    let L = I ? I[D] : 0;
    (!L || !await (d.isElement == null ? void 0 : d.isElement(I))) && (L = f.floating[D] || c.floating[P]);
    const F = $ / 2 - j / 2, _ = L / 2 - k[P] / 2 - 1, W = YS(w[T], _), Q = YS(w[N], _), U = W, Y = L - k[P] - Q, G = L / 2 - k[P] / 2 + F, J = l9(U, G, Y), H = !p.arrow && bS(i) != null && G !== J && c.reference[P] / 2 - (G < U ? W : Q) - k[P] / 2 < 0, K = H ? G < U ? G - U : G - Y : 0;
    return {
      [E]: x[E] + K,
      data: {
        [E]: J,
        centerOffset: G - J - K,
        ...H && {
          alignmentOffset: K
        }
      },
      reset: H
    };
  }
}), qwt = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var r, a;
      const {
        placement: i,
        middlewareData: c,
        rects: d,
        initialPlacement: f,
        platform: p,
        elements: g
      } = t, {
        mainAxis: b = !0,
        crossAxis: w = !0,
        fallbackPlacements: x,
        fallbackStrategy: E = "bestFit",
        fallbackAxisSideDirection: P = "none",
        flipAlignment: k = !0,
        ...M
      } = wb(e, t);
      if ((r = c.arrow) != null && r.alignmentOffset)
        return {};
      const T = lp(i), N = V0(f), D = lp(f) === f, $ = await (p.isRTL == null ? void 0 : p.isRTL(g.floating)), j = x || (D || !k ? [s9(f)] : Hwt(f)), I = P !== "none";
      !x && I && j.push(..._wt(f, k, P, $));
      const L = [f, ...j], F = await p.detectOverflow(t, M), _ = [];
      let W = ((a = c.flip) == null ? void 0 : a.overflows) || [];
      if (b && _.push(F[T]), w) {
        const G = Lwt(i, d, $);
        _.push(F[G[0]], F[G[1]]);
      }
      if (W = [...W, {
        placement: i,
        overflows: _
      }], !_.every((G) => G <= 0)) {
        var Q, U;
        const G = (((Q = c.flip) == null ? void 0 : Q.index) || 0) + 1, J = L[G];
        if (J && (!(w === "alignment" ? N !== V0(J) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        W.every((X) => V0(X.placement) === N ? X.overflows[0] > 0 : !0)))
          return {
            data: {
              index: G,
              overflows: W
            },
            reset: {
              placement: J
            }
          };
        let H = (U = W.filter((K) => K.overflows[0] <= 0).sort((K, X) => K.overflows[1] - X.overflows[1])[0]) == null ? void 0 : U.placement;
        if (!H)
          switch (E) {
            case "bestFit": {
              var Y;
              const K = (Y = W.filter((X) => {
                if (I) {
                  const te = V0(X.placement);
                  return te === N || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  te === "y";
                }
                return !0;
              }).map((X) => [X.placement, X.overflows.filter((te) => te > 0).reduce((te, ie) => te + ie, 0)]).sort((X, te) => X[1] - te[1])[0]) == null ? void 0 : Y[0];
              K && (H = K);
              break;
            }
            case "initialPlacement":
              H = f;
              break;
          }
        if (i !== H)
          return {
            reset: {
              placement: H
            }
          };
      }
      return {};
    }
  };
};
function CU(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function xU(e) {
  return $wt.some((t) => e[t] >= 0);
}
const Kwt = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: r,
        platform: a
      } = t, {
        strategy: i = "referenceHidden",
        ...c
      } = wb(e, t);
      switch (i) {
        case "referenceHidden": {
          const d = await a.detectOverflow(t, {
            ...c,
            elementContext: "reference"
          }), f = CU(d, r.reference);
          return {
            data: {
              referenceHiddenOffsets: f,
              referenceHidden: xU(f)
            }
          };
        }
        case "escaped": {
          const d = await a.detectOverflow(t, {
            ...c,
            altBoundary: !0
          }), f = CU(d, r.floating);
          return {
            data: {
              escapedOffsets: f,
              escaped: xU(f)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, Gte = /* @__PURE__ */ new Set(["left", "top"]);
async function Ywt(e, t) {
  const {
    placement: r,
    platform: a,
    elements: i
  } = e, c = await (a.isRTL == null ? void 0 : a.isRTL(i.floating)), d = lp(r), f = bS(r), p = V0(r) === "y", g = Gte.has(d) ? -1 : 1, b = c && p ? -1 : 1, w = wb(t, e);
  let {
    mainAxis: x,
    crossAxis: E,
    alignmentAxis: P
  } = typeof w == "number" ? {
    mainAxis: w,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: w.mainAxis || 0,
    crossAxis: w.crossAxis || 0,
    alignmentAxis: w.alignmentAxis
  };
  return f && typeof P == "number" && (E = f === "end" ? P * -1 : P), p ? {
    x: E * b,
    y: x * g
  } : {
    x: x * g,
    y: E * b
  };
}
const Qwt = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var r, a;
      const {
        x: i,
        y: c,
        placement: d,
        middlewareData: f
      } = t, p = await Ywt(t, e);
      return d === ((r = f.offset) == null ? void 0 : r.placement) && (a = f.arrow) != null && a.alignmentOffset ? {} : {
        x: i + p.x,
        y: c + p.y,
        data: {
          ...p,
          placement: d
        }
      };
    }
  };
}, Jwt = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: r,
        y: a,
        placement: i,
        platform: c
      } = t, {
        mainAxis: d = !0,
        crossAxis: f = !1,
        limiter: p = {
          fn: (T) => {
            let {
              x: N,
              y: D
            } = T;
            return {
              x: N,
              y: D
            };
          }
        },
        ...g
      } = wb(e, t), b = {
        x: r,
        y: a
      }, w = await c.detectOverflow(t, g), x = V0(lp(i)), E = RI(x);
      let P = b[E], k = b[x];
      if (d) {
        const T = E === "y" ? "top" : "left", N = E === "y" ? "bottom" : "right", D = P + w[T], $ = P - w[N];
        P = l9(D, P, $);
      }
      if (f) {
        const T = x === "y" ? "top" : "left", N = x === "y" ? "bottom" : "right", D = k + w[T], $ = k - w[N];
        k = l9(D, k, $);
      }
      const M = p.fn({
        ...t,
        [E]: P,
        [x]: k
      });
      return {
        ...M,
        data: {
          x: M.x - r,
          y: M.y - a,
          enabled: {
            [E]: d,
            [x]: f
          }
        }
      };
    }
  };
}, Zwt = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: r,
        y: a,
        placement: i,
        rects: c,
        middlewareData: d
      } = t, {
        offset: f = 0,
        mainAxis: p = !0,
        crossAxis: g = !0
      } = wb(e, t), b = {
        x: r,
        y: a
      }, w = V0(i), x = RI(w);
      let E = b[x], P = b[w];
      const k = wb(f, t), M = typeof k == "number" ? {
        mainAxis: k,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...k
      };
      if (p) {
        const D = x === "y" ? "height" : "width", $ = c.reference[x] - c.floating[D] + M.mainAxis, j = c.reference[x] + c.reference[D] - M.mainAxis;
        E < $ ? E = $ : E > j && (E = j);
      }
      if (g) {
        var T, N;
        const D = x === "y" ? "width" : "height", $ = Gte.has(lp(i)), j = c.reference[w] - c.floating[D] + ($ && ((T = d.offset) == null ? void 0 : T[w]) || 0) + ($ ? 0 : M.crossAxis), I = c.reference[w] + c.reference[D] + ($ ? 0 : ((N = d.offset) == null ? void 0 : N[w]) || 0) - ($ ? M.crossAxis : 0);
        P < j ? P = j : P > I && (P = I);
      }
      return {
        [x]: E,
        [w]: P
      };
    }
  };
}, eSt = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var r, a;
      const {
        placement: i,
        rects: c,
        platform: d,
        elements: f
      } = t, {
        apply: p = () => {
        },
        ...g
      } = wb(e, t), b = await d.detectOverflow(t, g), w = lp(i), x = bS(i), E = V0(i) === "y", {
        width: P,
        height: k
      } = c.floating;
      let M, T;
      w === "top" || w === "bottom" ? (M = w, T = x === (await (d.isRTL == null ? void 0 : d.isRTL(f.floating)) ? "start" : "end") ? "left" : "right") : (T = w, M = x === "end" ? "top" : "bottom");
      const N = k - b.top - b.bottom, D = P - b.left - b.right, $ = YS(k - b[M], N), j = YS(P - b[T], D), I = !t.middlewareData.shift;
      let L = $, F = j;
      if ((r = t.middlewareData.shift) != null && r.enabled.x && (F = D), (a = t.middlewareData.shift) != null && a.enabled.y && (L = N), I && !x) {
        const W = k0(b.left, 0), Q = k0(b.right, 0), U = k0(b.top, 0), Y = k0(b.bottom, 0);
        E ? F = P - 2 * (W !== 0 || Q !== 0 ? W + Q : k0(b.left, b.right)) : L = k - 2 * (U !== 0 || Y !== 0 ? U + Y : k0(b.top, b.bottom));
      }
      await p({
        ...t,
        availableWidth: F,
        availableHeight: L
      });
      const _ = await d.getDimensions(f.floating);
      return P !== _.width || k !== _.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function LM() {
  return typeof window < "u";
}
function lC(e) {
  return NI(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function lu(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Pb(e) {
  var t;
  return (t = (NI(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function NI(e) {
  return LM() ? e instanceof Node || e instanceof lu(e).Node : !1;
}
function di(e) {
  return LM() ? e instanceof Element || e instanceof lu(e).Element : !1;
}
function Os(e) {
  return LM() ? e instanceof HTMLElement || e instanceof lu(e).HTMLElement : !1;
}
function j$(e) {
  return !LM() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof lu(e).ShadowRoot;
}
const tSt = /* @__PURE__ */ new Set(["inline", "contents"]);
function sC(e) {
  const {
    overflow: t,
    overflowX: r,
    overflowY: a,
    display: i
  } = dp(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + a + r) && !tSt.has(i);
}
const nSt = /* @__PURE__ */ new Set(["table", "td", "th"]);
function rSt(e) {
  return nSt.has(lC(e));
}
const aSt = [":popover-open", ":modal"];
function HM(e) {
  return aSt.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
const oSt = ["transform", "translate", "scale", "rotate", "perspective"], iSt = ["transform", "translate", "scale", "rotate", "perspective", "filter"], lSt = ["paint", "layout", "strict", "content"];
function DI(e) {
  const t = FM(), r = di(e) ? dp(e) : e;
  return oSt.some((a) => r[a] ? r[a] !== "none" : !1) || (r.containerType ? r.containerType !== "normal" : !1) || !t && (r.backdropFilter ? r.backdropFilter !== "none" : !1) || !t && (r.filter ? r.filter !== "none" : !1) || iSt.some((a) => (r.willChange || "").includes(a)) || lSt.some((a) => (r.contain || "").includes(a));
}
function sSt(e) {
  let t = mS(e);
  for (; Os(t) && !lS(t); ) {
    if (DI(t))
      return t;
    if (HM(t))
      return null;
    t = mS(t);
  }
  return null;
}
function FM() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const uSt = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function lS(e) {
  return uSt.has(lC(e));
}
function dp(e) {
  return lu(e).getComputedStyle(e);
}
function WM(e) {
  return di(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function mS(e) {
  if (lC(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    j$(e) && e.host || // Fallback.
    Pb(e)
  );
  return j$(t) ? t.host : t;
}
function qte(e) {
  const t = mS(e);
  return lS(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Os(t) && sC(t) ? t : qte(t);
}
function LS(e, t, r) {
  var a;
  t === void 0 && (t = []), r === void 0 && (r = !0);
  const i = qte(e), c = i === ((a = e.ownerDocument) == null ? void 0 : a.body), d = lu(i);
  if (c) {
    const f = I$(d);
    return t.concat(d, d.visualViewport || [], sC(i) ? i : [], f && r ? LS(f) : []);
  }
  return t.concat(i, LS(i, [], r));
}
function I$(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Kte(e) {
  const t = dp(e);
  let r = parseFloat(t.width) || 0, a = parseFloat(t.height) || 0;
  const i = Os(e), c = i ? e.offsetWidth : r, d = i ? e.offsetHeight : a, f = Nx(r) !== c || Nx(a) !== d;
  return f && (r = c, a = d), {
    width: r,
    height: a,
    $: f
  };
}
function $I(e) {
  return di(e) ? e : e.contextElement;
}
function cx(e) {
  const t = $I(e);
  if (!Os(t))
    return fb(1);
  const r = t.getBoundingClientRect(), {
    width: a,
    height: i,
    $: c
  } = Kte(t);
  let d = (c ? Nx(r.width) : r.width) / a, f = (c ? Nx(r.height) : r.height) / i;
  return (!d || !Number.isFinite(d)) && (d = 1), (!f || !Number.isFinite(f)) && (f = 1), {
    x: d,
    y: f
  };
}
const cSt = /* @__PURE__ */ fb(0);
function Yte(e) {
  const t = lu(e);
  return !FM() || !t.visualViewport ? cSt : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function dSt(e, t, r) {
  return t === void 0 && (t = !1), !r || t && r !== lu(e) ? !1 : t;
}
function a3(e, t, r, a) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  const i = e.getBoundingClientRect(), c = $I(e);
  let d = fb(1);
  t && (a ? di(a) && (d = cx(a)) : d = cx(e));
  const f = dSt(c, r, a) ? Yte(c) : fb(0);
  let p = (i.left + f.x) / d.x, g = (i.top + f.y) / d.y, b = i.width / d.x, w = i.height / d.y;
  if (c) {
    const x = lu(c), E = a && di(a) ? lu(a) : a;
    let P = x, k = I$(P);
    for (; k && a && E !== P; ) {
      const M = cx(k), T = k.getBoundingClientRect(), N = dp(k), D = T.left + (k.clientLeft + parseFloat(N.paddingLeft)) * M.x, $ = T.top + (k.clientTop + parseFloat(N.paddingTop)) * M.y;
      p *= M.x, g *= M.y, b *= M.x, w *= M.y, p += D, g += $, P = lu(k), k = I$(P);
    }
  }
  return u9({
    width: b,
    height: w,
    x: p,
    y: g
  });
}
function VM(e, t) {
  const r = WM(e).scrollLeft;
  return t ? t.left + r : a3(Pb(e)).left + r;
}
function Qte(e, t) {
  const r = e.getBoundingClientRect(), a = r.left + t.scrollLeft - VM(e, r), i = r.top + t.scrollTop;
  return {
    x: a,
    y: i
  };
}
function fSt(e) {
  let {
    elements: t,
    rect: r,
    offsetParent: a,
    strategy: i
  } = e;
  const c = i === "fixed", d = Pb(a), f = t ? HM(t.floating) : !1;
  if (a === d || f && c)
    return r;
  let p = {
    scrollLeft: 0,
    scrollTop: 0
  }, g = fb(1);
  const b = fb(0), w = Os(a);
  if ((w || !w && !c) && ((lC(a) !== "body" || sC(d)) && (p = WM(a)), Os(a))) {
    const E = a3(a);
    g = cx(a), b.x = E.x + a.clientLeft, b.y = E.y + a.clientTop;
  }
  const x = d && !w && !c ? Qte(d, p) : fb(0);
  return {
    width: r.width * g.x,
    height: r.height * g.y,
    x: r.x * g.x - p.scrollLeft * g.x + b.x + x.x,
    y: r.y * g.y - p.scrollTop * g.y + b.y + x.y
  };
}
function mSt(e) {
  return Array.from(e.getClientRects());
}
function hSt(e) {
  const t = Pb(e), r = WM(e), a = e.ownerDocument.body, i = k0(t.scrollWidth, t.clientWidth, a.scrollWidth, a.clientWidth), c = k0(t.scrollHeight, t.clientHeight, a.scrollHeight, a.clientHeight);
  let d = -r.scrollLeft + VM(e);
  const f = -r.scrollTop;
  return dp(a).direction === "rtl" && (d += k0(t.clientWidth, a.clientWidth) - i), {
    width: i,
    height: c,
    x: d,
    y: f
  };
}
const EU = 25;
function pSt(e, t) {
  const r = lu(e), a = Pb(e), i = r.visualViewport;
  let c = a.clientWidth, d = a.clientHeight, f = 0, p = 0;
  if (i) {
    c = i.width, d = i.height;
    const b = FM();
    (!b || b && t === "fixed") && (f = i.offsetLeft, p = i.offsetTop);
  }
  const g = VM(a);
  if (g <= 0) {
    const b = a.ownerDocument, w = b.body, x = getComputedStyle(w), E = b.compatMode === "CSS1Compat" && parseFloat(x.marginLeft) + parseFloat(x.marginRight) || 0, P = Math.abs(a.clientWidth - w.clientWidth - E);
    P <= EU && (c -= P);
  } else g <= EU && (c += g);
  return {
    width: c,
    height: d,
    x: f,
    y: p
  };
}
const gSt = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function vSt(e, t) {
  const r = a3(e, !0, t === "fixed"), a = r.top + e.clientTop, i = r.left + e.clientLeft, c = Os(e) ? cx(e) : fb(1), d = e.clientWidth * c.x, f = e.clientHeight * c.y, p = i * c.x, g = a * c.y;
  return {
    width: d,
    height: f,
    x: p,
    y: g
  };
}
function PU(e, t, r) {
  let a;
  if (t === "viewport")
    a = pSt(e, r);
  else if (t === "document")
    a = hSt(Pb(e));
  else if (di(t))
    a = vSt(t, r);
  else {
    const i = Yte(e);
    a = {
      x: t.x - i.x,
      y: t.y - i.y,
      width: t.width,
      height: t.height
    };
  }
  return u9(a);
}
function Jte(e, t) {
  const r = mS(e);
  return r === t || !di(r) || lS(r) ? !1 : dp(r).position === "fixed" || Jte(r, t);
}
function bSt(e, t) {
  const r = t.get(e);
  if (r)
    return r;
  let a = LS(e, [], !1).filter((f) => di(f) && lC(f) !== "body"), i = null;
  const c = dp(e).position === "fixed";
  let d = c ? mS(e) : e;
  for (; di(d) && !lS(d); ) {
    const f = dp(d), p = DI(d);
    !p && f.position === "fixed" && (i = null), (c ? !p && !i : !p && f.position === "static" && !!i && gSt.has(i.position) || sC(d) && !p && Jte(e, d)) ? a = a.filter((b) => b !== d) : i = f, d = mS(d);
  }
  return t.set(e, a), a;
}
function ySt(e) {
  let {
    element: t,
    boundary: r,
    rootBoundary: a,
    strategy: i
  } = e;
  const d = [...r === "clippingAncestors" ? HM(t) ? [] : bSt(t, this._c) : [].concat(r), a], f = d[0], p = d.reduce((g, b) => {
    const w = PU(t, b, i);
    return g.top = k0(w.top, g.top), g.right = YS(w.right, g.right), g.bottom = YS(w.bottom, g.bottom), g.left = k0(w.left, g.left), g;
  }, PU(t, f, i));
  return {
    width: p.right - p.left,
    height: p.bottom - p.top,
    x: p.left,
    y: p.top
  };
}
function wSt(e) {
  const {
    width: t,
    height: r
  } = Kte(e);
  return {
    width: t,
    height: r
  };
}
function SSt(e, t, r) {
  const a = Os(t), i = Pb(t), c = r === "fixed", d = a3(e, !0, c, t);
  let f = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const p = fb(0);
  function g() {
    p.x = VM(i);
  }
  if (a || !a && !c)
    if ((lC(t) !== "body" || sC(i)) && (f = WM(t)), a) {
      const E = a3(t, !0, c, t);
      p.x = E.x + t.clientLeft, p.y = E.y + t.clientTop;
    } else i && g();
  c && !a && i && g();
  const b = i && !a && !c ? Qte(i, f) : fb(0), w = d.left + f.scrollLeft - p.x - b.x, x = d.top + f.scrollTop - p.y - b.y;
  return {
    x: w,
    y: x,
    width: d.width,
    height: d.height
  };
}
function $A(e) {
  return dp(e).position === "static";
}
function kU(e, t) {
  if (!Os(e) || dp(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let r = e.offsetParent;
  return Pb(e) === r && (r = r.ownerDocument.body), r;
}
function Zte(e, t) {
  const r = lu(e);
  if (HM(e))
    return r;
  if (!Os(e)) {
    let i = mS(e);
    for (; i && !lS(i); ) {
      if (di(i) && !$A(i))
        return i;
      i = mS(i);
    }
    return r;
  }
  let a = kU(e, t);
  for (; a && rSt(a) && $A(a); )
    a = kU(a, t);
  return a && lS(a) && $A(a) && !DI(a) ? r : a || sSt(e) || r;
}
const CSt = async function(e) {
  const t = this.getOffsetParent || Zte, r = this.getDimensions, a = await r(e.floating);
  return {
    reference: SSt(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: a.width,
      height: a.height
    }
  };
};
function xSt(e) {
  return dp(e).direction === "rtl";
}
const ESt = {
  convertOffsetParentRelativeRectToViewportRelativeRect: fSt,
  getDocumentElement: Pb,
  getClippingRect: ySt,
  getOffsetParent: Zte,
  getElementRects: CSt,
  getClientRects: mSt,
  getDimensions: wSt,
  getScale: cx,
  isElement: di,
  isRTL: xSt
};
function ene(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function PSt(e, t) {
  let r = null, a;
  const i = Pb(e);
  function c() {
    var f;
    clearTimeout(a), (f = r) == null || f.disconnect(), r = null;
  }
  function d(f, p) {
    f === void 0 && (f = !1), p === void 0 && (p = 1), c();
    const g = e.getBoundingClientRect(), {
      left: b,
      top: w,
      width: x,
      height: E
    } = g;
    if (f || t(), !x || !E)
      return;
    const P = Z3(w), k = Z3(i.clientWidth - (b + x)), M = Z3(i.clientHeight - (w + E)), T = Z3(b), D = {
      rootMargin: -P + "px " + -k + "px " + -M + "px " + -T + "px",
      threshold: k0(0, YS(1, p)) || 1
    };
    let $ = !0;
    function j(I) {
      const L = I[0].intersectionRatio;
      if (L !== p) {
        if (!$)
          return d();
        L ? d(!1, L) : a = setTimeout(() => {
          d(!1, 1e-7);
        }, 1e3);
      }
      L === 1 && !ene(g, e.getBoundingClientRect()) && d(), $ = !1;
    }
    try {
      r = new IntersectionObserver(j, {
        ...D,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(j, D);
    }
    r.observe(e);
  }
  return d(!0), c;
}
function L$(e, t, r, a) {
  a === void 0 && (a = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: c = !0,
    elementResize: d = typeof ResizeObserver == "function",
    layoutShift: f = typeof IntersectionObserver == "function",
    animationFrame: p = !1
  } = a, g = $I(e), b = i || c ? [...g ? LS(g) : [], ...LS(t)] : [];
  b.forEach((T) => {
    i && T.addEventListener("scroll", r, {
      passive: !0
    }), c && T.addEventListener("resize", r);
  });
  const w = g && f ? PSt(g, r) : null;
  let x = -1, E = null;
  d && (E = new ResizeObserver((T) => {
    let [N] = T;
    N && N.target === g && E && (E.unobserve(t), cancelAnimationFrame(x), x = requestAnimationFrame(() => {
      var D;
      (D = E) == null || D.observe(t);
    })), r();
  }), g && !p && E.observe(g), E.observe(t));
  let P, k = p ? a3(e) : null;
  p && M();
  function M() {
    const T = a3(e);
    k && !ene(k, T) && r(), k = T, P = requestAnimationFrame(M);
  }
  return r(), () => {
    var T;
    b.forEach((N) => {
      i && N.removeEventListener("scroll", r), c && N.removeEventListener("resize", r);
    }), w?.(), (T = E) == null || T.disconnect(), E = null, p && cancelAnimationFrame(P);
  };
}
const kSt = Qwt, MSt = Jwt, OSt = qwt, TSt = eSt, RSt = Kwt, MU = Gwt, ASt = Zwt, NSt = (e, t, r) => {
  const a = /* @__PURE__ */ new Map(), i = {
    platform: ESt,
    ...r
  }, c = {
    ...i.platform,
    _c: a
  };
  return Xwt(e, t, {
    ...i,
    platform: c
  });
};
var DSt = typeof document < "u", $St = function() {
}, Ek = DSt ? zS : $St;
function c9(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let r, a, i;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (r = e.length, r !== t.length) return !1;
      for (a = r; a-- !== 0; )
        if (!c9(e[a], t[a]))
          return !1;
      return !0;
    }
    if (i = Object.keys(e), r = i.length, r !== Object.keys(t).length)
      return !1;
    for (a = r; a-- !== 0; )
      if (!{}.hasOwnProperty.call(t, i[a]))
        return !1;
    for (a = r; a-- !== 0; ) {
      const c = i[a];
      if (!(c === "_owner" && e.$$typeof) && !c9(e[c], t[c]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function tne(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function OU(e, t) {
  const r = tne(e);
  return Math.round(t * r) / r;
}
function zA(e) {
  const t = S.useRef(e);
  return Ek(() => {
    t.current = e;
  }), t;
}
function nne(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: r = "absolute",
    middleware: a = [],
    platform: i,
    elements: {
      reference: c,
      floating: d
    } = {},
    transform: f = !0,
    whileElementsMounted: p,
    open: g
  } = e, [b, w] = S.useState({
    x: 0,
    y: 0,
    strategy: r,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [x, E] = S.useState(a);
  c9(x, a) || E(a);
  const [P, k] = S.useState(null), [M, T] = S.useState(null), N = S.useCallback((X) => {
    X !== I.current && (I.current = X, k(X));
  }, []), D = S.useCallback((X) => {
    X !== L.current && (L.current = X, T(X));
  }, []), $ = c || P, j = d || M, I = S.useRef(null), L = S.useRef(null), F = S.useRef(b), _ = p != null, W = zA(p), Q = zA(i), U = zA(g), Y = S.useCallback(() => {
    if (!I.current || !L.current)
      return;
    const X = {
      placement: t,
      strategy: r,
      middleware: x
    };
    Q.current && (X.platform = Q.current), NSt(I.current, L.current, X).then((te) => {
      const ie = {
        ...te,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: U.current !== !1
      };
      G.current && !c9(F.current, ie) && (F.current = ie, sp.flushSync(() => {
        w(ie);
      }));
    });
  }, [x, t, r, Q, U]);
  Ek(() => {
    g === !1 && F.current.isPositioned && (F.current.isPositioned = !1, w((X) => ({
      ...X,
      isPositioned: !1
    })));
  }, [g]);
  const G = S.useRef(!1);
  Ek(() => (G.current = !0, () => {
    G.current = !1;
  }), []), Ek(() => {
    if ($ && (I.current = $), j && (L.current = j), $ && j) {
      if (W.current)
        return W.current($, j, Y);
      Y();
    }
  }, [$, j, Y, W, _]);
  const J = S.useMemo(() => ({
    reference: I,
    floating: L,
    setReference: N,
    setFloating: D
  }), [N, D]), H = S.useMemo(() => ({
    reference: $,
    floating: j
  }), [$, j]), K = S.useMemo(() => {
    const X = {
      position: r,
      left: 0,
      top: 0
    };
    if (!H.floating)
      return X;
    const te = OU(H.floating, b.x), ie = OU(H.floating, b.y);
    return f ? {
      ...X,
      transform: "translate(" + te + "px, " + ie + "px)",
      ...tne(H.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: r,
      left: te,
      top: ie
    };
  }, [r, f, H.floating, b.x, b.y]);
  return S.useMemo(() => ({
    ...b,
    update: Y,
    refs: J,
    elements: H,
    floatingStyles: K
  }), [b, Y, J, H, K]);
}
const zSt = (e) => {
  function t(r) {
    return {}.hasOwnProperty.call(r, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(r) {
      const {
        element: a,
        padding: i
      } = typeof e == "function" ? e(r) : e;
      return a && t(a) ? a.current != null ? MU({
        element: a.current,
        padding: i
      }).fn(r) : {} : a ? MU({
        element: a,
        padding: i
      }).fn(r) : {};
    }
  };
}, rne = (e, t) => ({
  ...kSt(e),
  options: [e, t]
}), ane = (e, t) => ({
  ...MSt(e),
  options: [e, t]
}), one = (e, t) => ({
  ...ASt(e),
  options: [e, t]
}), ine = (e, t) => ({
  ...OSt(e),
  options: [e, t]
}), lne = (e, t) => ({
  ...TSt(e),
  options: [e, t]
}), sne = (e, t) => ({
  ...RSt(e),
  options: [e, t]
}), jSt = (e, t) => ({
  ...zSt(e),
  options: [e, t]
});
var ISt = "Arrow", une = S.forwardRef((e, t) => {
  const { children: r, width: a = 10, height: i = 5, ...c } = e;
  return /* @__PURE__ */ V.jsx(
    Ro.svg,
    {
      ...c,
      ref: t,
      width: a,
      height: i,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? r : /* @__PURE__ */ V.jsx("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
une.displayName = ISt;
var LSt = une, zI = "Popper", [cne, dne] = Eb(zI), [HSt, fne] = cne(zI), mne = (e) => {
  const { __scopePopper: t, children: r } = e, [a, i] = S.useState(null);
  return /* @__PURE__ */ V.jsx(HSt, { scope: t, anchor: a, onAnchorChange: i, children: r });
};
mne.displayName = zI;
var hne = "PopperAnchor", pne = S.forwardRef(
  (e, t) => {
    const { __scopePopper: r, virtualRef: a, ...i } = e, c = fne(hne, r), d = S.useRef(null), f = Wl(t, d), p = S.useRef(null);
    return S.useEffect(() => {
      const g = p.current;
      p.current = a?.current || d.current, g !== p.current && c.onAnchorChange(p.current);
    }), a ? null : /* @__PURE__ */ V.jsx(Ro.div, { ...i, ref: f });
  }
);
pne.displayName = hne;
var jI = "PopperContent", [FSt, WSt] = cne(jI), gne = S.forwardRef(
  (e, t) => {
    const {
      __scopePopper: r,
      side: a = "bottom",
      sideOffset: i = 0,
      align: c = "center",
      alignOffset: d = 0,
      arrowPadding: f = 0,
      avoidCollisions: p = !0,
      collisionBoundary: g = [],
      collisionPadding: b = 0,
      sticky: w = "partial",
      hideWhenDetached: x = !1,
      updatePositionStrategy: E = "optimized",
      onPlaced: P,
      ...k
    } = e, M = fne(jI, r), [T, N] = S.useState(null), D = Wl(t, (me) => N(me)), [$, j] = S.useState(null), I = DM($), L = I?.width ?? 0, F = I?.height ?? 0, _ = a + (c !== "center" ? "-" + c : ""), W = typeof b == "number" ? b : { top: 0, right: 0, bottom: 0, left: 0, ...b }, Q = Array.isArray(g) ? g : [g], U = Q.length > 0, Y = {
      padding: W,
      boundary: Q.filter(_St),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: U
    }, { refs: G, floatingStyles: J, placement: H, isPositioned: K, middlewareData: X } = nne({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: _,
      whileElementsMounted: (...me) => L$(...me, {
        animationFrame: E === "always"
      }),
      elements: {
        reference: M.anchor
      },
      middleware: [
        rne({ mainAxis: i + F, alignmentAxis: d }),
        p && ane({
          mainAxis: !0,
          crossAxis: !1,
          limiter: w === "partial" ? one() : void 0,
          ...Y
        }),
        p && ine({ ...Y }),
        lne({
          ...Y,
          apply: ({ elements: me, rects: De, availableWidth: Me, availableHeight: ze }) => {
            const { width: le, height: se } = De.reference, Ae = me.floating.style;
            Ae.setProperty("--radix-popper-available-width", `${Me}px`), Ae.setProperty("--radix-popper-available-height", `${ze}px`), Ae.setProperty("--radix-popper-anchor-width", `${le}px`), Ae.setProperty("--radix-popper-anchor-height", `${se}px`);
          }
        }),
        $ && jSt({ element: $, padding: f }),
        BSt({ arrowWidth: L, arrowHeight: F }),
        x && sne({ strategy: "referenceHidden", ...Y })
      ]
    }), [te, ie] = yne(H), ee = rp(P);
    G1(() => {
      K && ee?.();
    }, [K, ee]);
    const ne = X.arrow?.x, ae = X.arrow?.y, oe = X.arrow?.centerOffset !== 0, [fe, be] = S.useState();
    return G1(() => {
      T && be(window.getComputedStyle(T).zIndex);
    }, [T]), /* @__PURE__ */ V.jsx(
      "div",
      {
        ref: G.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...J,
          transform: K ? J.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: fe,
          "--radix-popper-transform-origin": [
            X.transformOrigin?.x,
            X.transformOrigin?.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...X.hide?.referenceHidden && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ V.jsx(
          FSt,
          {
            scope: r,
            placedSide: te,
            onArrowChange: j,
            arrowX: ne,
            arrowY: ae,
            shouldHideArrow: oe,
            children: /* @__PURE__ */ V.jsx(
              Ro.div,
              {
                "data-side": te,
                "data-align": ie,
                ...k,
                ref: D,
                style: {
                  ...k.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: K ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
gne.displayName = jI;
var vne = "PopperArrow", VSt = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, bne = S.forwardRef(function(t, r) {
  const { __scopePopper: a, ...i } = t, c = WSt(vne, a), d = VSt[c.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ V.jsx(
      "span",
      {
        ref: c.onArrowChange,
        style: {
          position: "absolute",
          left: c.arrowX,
          top: c.arrowY,
          [d]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[c.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[c.placedSide],
          visibility: c.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ V.jsx(
          LSt,
          {
            ...i,
            ref: r,
            style: {
              ...i.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
bne.displayName = vne;
function _St(e) {
  return e !== null;
}
var BSt = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    const { placement: r, rects: a, middlewareData: i } = t, d = i.arrow?.centerOffset !== 0, f = d ? 0 : e.arrowWidth, p = d ? 0 : e.arrowHeight, [g, b] = yne(r), w = { start: "0%", center: "50%", end: "100%" }[b], x = (i.arrow?.x ?? 0) + f / 2, E = (i.arrow?.y ?? 0) + p / 2;
    let P = "", k = "";
    return g === "bottom" ? (P = d ? w : `${x}px`, k = `${-p}px`) : g === "top" ? (P = d ? w : `${x}px`, k = `${a.floating.height + p}px`) : g === "right" ? (P = `${-p}px`, k = d ? w : `${E}px`) : g === "left" && (P = `${a.floating.width + p}px`, k = d ? w : `${E}px`), { data: { x: P, y: k } };
  }
});
function yne(e) {
  const [t, r = "center"] = e.split("-");
  return [t, r];
}
var USt = mne, wne = pne, XSt = gne, GSt = bne, qSt = "Portal", II = S.forwardRef((e, t) => {
  const { container: r, ...a } = e, [i, c] = S.useState(!1);
  G1(() => c(!0), []);
  const d = r || i && globalThis?.document?.body;
  return d ? hb.createPortal(/* @__PURE__ */ V.jsx(Ro.div, { ...a, ref: t }), d) : null;
});
II.displayName = qSt;
var KSt = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, I3 = /* @__PURE__ */ new WeakMap(), EP = /* @__PURE__ */ new WeakMap(), PP = {}, jA = 0, Sne = function(e) {
  return e && (e.host || Sne(e.parentNode));
}, YSt = function(e, t) {
  return t.map(function(r) {
    if (e.contains(r))
      return r;
    var a = Sne(r);
    return a && e.contains(a) ? a : (console.error("aria-hidden", r, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(r) {
    return !!r;
  });
}, QSt = function(e, t, r, a) {
  var i = YSt(t, Array.isArray(e) ? e : [e]);
  PP[r] || (PP[r] = /* @__PURE__ */ new WeakMap());
  var c = PP[r], d = [], f = /* @__PURE__ */ new Set(), p = new Set(i), g = function(w) {
    !w || f.has(w) || (f.add(w), g(w.parentNode));
  };
  i.forEach(g);
  var b = function(w) {
    !w || p.has(w) || Array.prototype.forEach.call(w.children, function(x) {
      if (f.has(x))
        b(x);
      else
        try {
          var E = x.getAttribute(a), P = E !== null && E !== "false", k = (I3.get(x) || 0) + 1, M = (c.get(x) || 0) + 1;
          I3.set(x, k), c.set(x, M), d.push(x), k === 1 && P && EP.set(x, !0), M === 1 && x.setAttribute(r, "true"), P || x.setAttribute(a, "true");
        } catch (T) {
          console.error("aria-hidden: cannot operate on ", x, T);
        }
    });
  };
  return b(t), f.clear(), jA++, function() {
    d.forEach(function(w) {
      var x = I3.get(w) - 1, E = c.get(w) - 1;
      I3.set(w, x), c.set(w, E), x || (EP.has(w) || w.removeAttribute(a), EP.delete(w)), E || w.removeAttribute(r);
    }), jA--, jA || (I3 = /* @__PURE__ */ new WeakMap(), I3 = /* @__PURE__ */ new WeakMap(), EP = /* @__PURE__ */ new WeakMap(), PP = {});
  };
}, Cne = function(e, t, r) {
  r === void 0 && (r = "data-aria-hidden");
  var a = Array.from(Array.isArray(e) ? e : [e]), i = KSt(e);
  return i ? (a.push.apply(a, Array.from(i.querySelectorAll("[aria-live], script"))), QSt(a, i, r, "aria-hidden")) : function() {
    return null;
  };
}, Pk = "right-scroll-bar-position", kk = "width-before-scroll-bar", JSt = "with-scroll-bars-hidden", ZSt = "--removed-body-scroll-bar-size";
function IA(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function eCt(e, t) {
  var r = Wn(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return r.value;
        },
        set current(a) {
          var i = r.value;
          i !== a && (r.value = a, r.callback(a, i));
        }
      }
    };
  })[0];
  return r.callback = t, r.facade;
}
var tCt = typeof window < "u" ? S.useLayoutEffect : S.useEffect, TU = /* @__PURE__ */ new WeakMap();
function nCt(e, t) {
  var r = eCt(null, function(a) {
    return e.forEach(function(i) {
      return IA(i, a);
    });
  });
  return tCt(function() {
    var a = TU.get(r);
    if (a) {
      var i = new Set(a), c = new Set(e), d = r.current;
      i.forEach(function(f) {
        c.has(f) || IA(f, null);
      }), c.forEach(function(f) {
        i.has(f) || IA(f, d);
      });
    }
    TU.set(r, e);
  }, [e]), r;
}
function rCt(e) {
  return e;
}
function aCt(e, t) {
  t === void 0 && (t = rCt);
  var r = [], a = !1, i = {
    read: function() {
      if (a)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return r.length ? r[r.length - 1] : e;
    },
    useMedium: function(c) {
      var d = t(c, a);
      return r.push(d), function() {
        r = r.filter(function(f) {
          return f !== d;
        });
      };
    },
    assignSyncMedium: function(c) {
      for (a = !0; r.length; ) {
        var d = r;
        r = [], d.forEach(c);
      }
      r = {
        push: function(f) {
          return c(f);
        },
        filter: function() {
          return r;
        }
      };
    },
    assignMedium: function(c) {
      a = !0;
      var d = [];
      if (r.length) {
        var f = r;
        r = [], f.forEach(c), d = r;
      }
      var p = function() {
        var b = d;
        d = [], b.forEach(c);
      }, g = function() {
        return Promise.resolve().then(p);
      };
      g(), r = {
        push: function(b) {
          d.push(b), g();
        },
        filter: function(b) {
          return d = d.filter(b), r;
        }
      };
    }
  };
  return i;
}
function oCt(e) {
  e === void 0 && (e = {});
  var t = aCt(null);
  return t.options = Fl({ async: !0, ssr: !1 }, e), t;
}
var xne = function(e) {
  var t = e.sideCar, r = dI(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var a = t.read();
  if (!a)
    throw new Error("Sidecar medium not found");
  return S.createElement(a, Fl({}, r));
};
xne.isSideCarExport = !0;
function iCt(e, t) {
  return e.useMedium(t), xne;
}
var Ene = oCt(), LA = function() {
}, _M = S.forwardRef(function(e, t) {
  var r = S.useRef(null), a = S.useState({
    onScrollCapture: LA,
    onWheelCapture: LA,
    onTouchMoveCapture: LA
  }), i = a[0], c = a[1], d = e.forwardProps, f = e.children, p = e.className, g = e.removeScrollBar, b = e.enabled, w = e.shards, x = e.sideCar, E = e.noRelative, P = e.noIsolation, k = e.inert, M = e.allowPinchZoom, T = e.as, N = T === void 0 ? "div" : T, D = e.gapMode, $ = dI(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), j = x, I = nCt([r, t]), L = Fl(Fl({}, $), i);
  return S.createElement(
    S.Fragment,
    null,
    b && S.createElement(j, { sideCar: Ene, removeScrollBar: g, shards: w, noRelative: E, noIsolation: P, inert: k, setCallbacks: c, allowPinchZoom: !!M, lockRef: r, gapMode: D }),
    d ? S.cloneElement(S.Children.only(f), Fl(Fl({}, L), { ref: I })) : S.createElement(N, Fl({}, L, { className: p, ref: I }), f)
  );
});
_M.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
_M.classNames = {
  fullWidth: kk,
  zeroRight: Pk
};
var lCt = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function sCt() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = lCt();
  return t && e.setAttribute("nonce", t), e;
}
function uCt(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function cCt(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var dCt = function() {
  var e = 0, t = null;
  return {
    add: function(r) {
      e == 0 && (t = sCt()) && (uCt(t, r), cCt(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, fCt = function() {
  var e = dCt();
  return function(t, r) {
    S.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && r]);
  };
}, Pne = function() {
  var e = fCt(), t = function(r) {
    var a = r.styles, i = r.dynamic;
    return e(a, i), null;
  };
  return t;
}, mCt = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, HA = function(e) {
  return parseInt(e || "", 10) || 0;
}, hCt = function(e) {
  var t = window.getComputedStyle(document.body), r = t[e === "padding" ? "paddingLeft" : "marginLeft"], a = t[e === "padding" ? "paddingTop" : "marginTop"], i = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [HA(r), HA(a), HA(i)];
}, pCt = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return mCt;
  var t = hCt(e), r = document.documentElement.clientWidth, a = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, a - r + t[2] - t[0])
  };
}, gCt = Pne(), dx = "data-scroll-locked", vCt = function(e, t, r, a) {
  var i = e.left, c = e.top, d = e.right, f = e.gap;
  return r === void 0 && (r = "margin"), `
  .`.concat(JSt, ` {
   overflow: hidden `).concat(a, `;
   padding-right: `).concat(f, "px ").concat(a, `;
  }
  body[`).concat(dx, `] {
    overflow: hidden `).concat(a, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(a, ";"),
    r === "margin" && `
    padding-left: `.concat(i, `px;
    padding-top: `).concat(c, `px;
    padding-right: `).concat(d, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(f, "px ").concat(a, `;
    `),
    r === "padding" && "padding-right: ".concat(f, "px ").concat(a, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Pk, ` {
    right: `).concat(f, "px ").concat(a, `;
  }
  
  .`).concat(kk, ` {
    margin-right: `).concat(f, "px ").concat(a, `;
  }
  
  .`).concat(Pk, " .").concat(Pk, ` {
    right: 0 `).concat(a, `;
  }
  
  .`).concat(kk, " .").concat(kk, ` {
    margin-right: 0 `).concat(a, `;
  }
  
  body[`).concat(dx, `] {
    `).concat(ZSt, ": ").concat(f, `px;
  }
`);
}, RU = function() {
  var e = parseInt(document.body.getAttribute(dx) || "0", 10);
  return isFinite(e) ? e : 0;
}, bCt = function() {
  S.useEffect(function() {
    return document.body.setAttribute(dx, (RU() + 1).toString()), function() {
      var e = RU() - 1;
      e <= 0 ? document.body.removeAttribute(dx) : document.body.setAttribute(dx, e.toString());
    };
  }, []);
}, yCt = function(e) {
  var t = e.noRelative, r = e.noImportant, a = e.gapMode, i = a === void 0 ? "margin" : a;
  bCt();
  var c = S.useMemo(function() {
    return pCt(i);
  }, [i]);
  return S.createElement(gCt, { styles: vCt(c, !t, i, r ? "" : "!important") });
}, H$ = !1;
if (typeof window < "u")
  try {
    var kP = Object.defineProperty({}, "passive", {
      get: function() {
        return H$ = !0, !0;
      }
    });
    window.addEventListener("test", kP, kP), window.removeEventListener("test", kP, kP);
  } catch {
    H$ = !1;
  }
var L3 = H$ ? { passive: !1 } : !1, wCt = function(e) {
  return e.tagName === "TEXTAREA";
}, kne = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var r = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    r[t] !== "hidden" && // contains scroll inside self
    !(r.overflowY === r.overflowX && !wCt(e) && r[t] === "visible")
  );
}, SCt = function(e) {
  return kne(e, "overflowY");
}, CCt = function(e) {
  return kne(e, "overflowX");
}, AU = function(e, t) {
  var r = t.ownerDocument, a = t;
  do {
    typeof ShadowRoot < "u" && a instanceof ShadowRoot && (a = a.host);
    var i = Mne(e, a);
    if (i) {
      var c = One(e, a), d = c[1], f = c[2];
      if (d > f)
        return !0;
    }
    a = a.parentNode;
  } while (a && a !== r.body);
  return !1;
}, xCt = function(e) {
  var t = e.scrollTop, r = e.scrollHeight, a = e.clientHeight;
  return [
    t,
    r,
    a
  ];
}, ECt = function(e) {
  var t = e.scrollLeft, r = e.scrollWidth, a = e.clientWidth;
  return [
    t,
    r,
    a
  ];
}, Mne = function(e, t) {
  return e === "v" ? SCt(t) : CCt(t);
}, One = function(e, t) {
  return e === "v" ? xCt(t) : ECt(t);
}, PCt = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, kCt = function(e, t, r, a, i) {
  var c = PCt(e, window.getComputedStyle(t).direction), d = c * a, f = r.target, p = t.contains(f), g = !1, b = d > 0, w = 0, x = 0;
  do {
    if (!f)
      break;
    var E = One(e, f), P = E[0], k = E[1], M = E[2], T = k - M - c * P;
    (P || T) && Mne(e, f) && (w += T, x += P);
    var N = f.parentNode;
    f = N && N.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? N.host : N;
  } while (
    // portaled content
    !p && f !== document.body || // self content
    p && (t.contains(f) || t === f)
  );
  return (b && Math.abs(w) < 1 || !b && Math.abs(x) < 1) && (g = !0), g;
}, MP = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, NU = function(e) {
  return [e.deltaX, e.deltaY];
}, DU = function(e) {
  return e && "current" in e ? e.current : e;
}, MCt = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, OCt = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, TCt = 0, H3 = [];
function RCt(e) {
  var t = S.useRef([]), r = S.useRef([0, 0]), a = S.useRef(), i = S.useState(TCt++)[0], c = S.useState(Pne)[0], d = S.useRef(e);
  S.useEffect(function() {
    d.current = e;
  }, [e]), S.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(i));
      var k = Wke([e.lockRef.current], (e.shards || []).map(DU), !0).filter(Boolean);
      return k.forEach(function(M) {
        return M.classList.add("allow-interactivity-".concat(i));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(i)), k.forEach(function(M) {
          return M.classList.remove("allow-interactivity-".concat(i));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var f = S.useCallback(function(k, M) {
    if ("touches" in k && k.touches.length === 2 || k.type === "wheel" && k.ctrlKey)
      return !d.current.allowPinchZoom;
    var T = MP(k), N = r.current, D = "deltaX" in k ? k.deltaX : N[0] - T[0], $ = "deltaY" in k ? k.deltaY : N[1] - T[1], j, I = k.target, L = Math.abs(D) > Math.abs($) ? "h" : "v";
    if ("touches" in k && L === "h" && I.type === "range")
      return !1;
    var F = window.getSelection(), _ = F && F.anchorNode, W = _ ? _ === I || _.contains(I) : !1;
    if (W)
      return !1;
    var Q = AU(L, I);
    if (!Q)
      return !0;
    if (Q ? j = L : (j = L === "v" ? "h" : "v", Q = AU(L, I)), !Q)
      return !1;
    if (!a.current && "changedTouches" in k && (D || $) && (a.current = j), !j)
      return !0;
    var U = a.current || j;
    return kCt(U, M, k, U === "h" ? D : $);
  }, []), p = S.useCallback(function(k) {
    var M = k;
    if (!(!H3.length || H3[H3.length - 1] !== c)) {
      var T = "deltaY" in M ? NU(M) : MP(M), N = t.current.filter(function(j) {
        return j.name === M.type && (j.target === M.target || M.target === j.shadowParent) && MCt(j.delta, T);
      })[0];
      if (N && N.should) {
        M.cancelable && M.preventDefault();
        return;
      }
      if (!N) {
        var D = (d.current.shards || []).map(DU).filter(Boolean).filter(function(j) {
          return j.contains(M.target);
        }), $ = D.length > 0 ? f(M, D[0]) : !d.current.noIsolation;
        $ && M.cancelable && M.preventDefault();
      }
    }
  }, []), g = S.useCallback(function(k, M, T, N) {
    var D = { name: k, delta: M, target: T, should: N, shadowParent: ACt(T) };
    t.current.push(D), setTimeout(function() {
      t.current = t.current.filter(function($) {
        return $ !== D;
      });
    }, 1);
  }, []), b = S.useCallback(function(k) {
    r.current = MP(k), a.current = void 0;
  }, []), w = S.useCallback(function(k) {
    g(k.type, NU(k), k.target, f(k, e.lockRef.current));
  }, []), x = S.useCallback(function(k) {
    g(k.type, MP(k), k.target, f(k, e.lockRef.current));
  }, []);
  S.useEffect(function() {
    return H3.push(c), e.setCallbacks({
      onScrollCapture: w,
      onWheelCapture: w,
      onTouchMoveCapture: x
    }), document.addEventListener("wheel", p, L3), document.addEventListener("touchmove", p, L3), document.addEventListener("touchstart", b, L3), function() {
      H3 = H3.filter(function(k) {
        return k !== c;
      }), document.removeEventListener("wheel", p, L3), document.removeEventListener("touchmove", p, L3), document.removeEventListener("touchstart", b, L3);
    };
  }, []);
  var E = e.removeScrollBar, P = e.inert;
  return S.createElement(
    S.Fragment,
    null,
    P ? S.createElement(c, { styles: OCt(i) }) : null,
    E ? S.createElement(yCt, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function ACt(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const NCt = iCt(Ene, RCt);
var LI = S.forwardRef(function(e, t) {
  return S.createElement(_M, Fl({}, e, { ref: t, sideCar: NCt }));
});
LI.classNames = _M.classNames;
var BM = "Popover", [Tne] = Eb(BM, [
  dne
]), b7 = dne(), [DCt, uC] = Tne(BM), Rne = (e) => {
  const {
    __scopePopover: t,
    children: r,
    open: a,
    defaultOpen: i,
    onOpenChange: c,
    modal: d = !1
  } = e, f = b7(t), p = S.useRef(null), [g, b] = S.useState(!1), [w, x] = iC({
    prop: a,
    defaultProp: i ?? !1,
    onChange: c,
    caller: BM
  });
  return /* @__PURE__ */ V.jsx(USt, { ...f, children: /* @__PURE__ */ V.jsx(
    DCt,
    {
      scope: t,
      contentId: T0(),
      triggerRef: p,
      open: w,
      onOpenChange: x,
      onOpenToggle: S.useCallback(() => x((E) => !E), [x]),
      hasCustomAnchor: g,
      onCustomAnchorAdd: S.useCallback(() => b(!0), []),
      onCustomAnchorRemove: S.useCallback(() => b(!1), []),
      modal: d,
      children: r
    }
  ) });
};
Rne.displayName = BM;
var Ane = "PopoverAnchor", $Ct = S.forwardRef(
  (e, t) => {
    const { __scopePopover: r, ...a } = e, i = uC(Ane, r), c = b7(r), { onCustomAnchorAdd: d, onCustomAnchorRemove: f } = i;
    return S.useEffect(() => (d(), () => f()), [d, f]), /* @__PURE__ */ V.jsx(wne, { ...c, ...a, ref: t });
  }
);
$Ct.displayName = Ane;
var Nne = "PopoverTrigger", Dne = S.forwardRef(
  (e, t) => {
    const { __scopePopover: r, ...a } = e, i = uC(Nne, r), c = b7(r), d = Wl(t, i.triggerRef), f = /* @__PURE__ */ V.jsx(
      Ro.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": i.open,
        "aria-controls": i.contentId,
        "data-state": Lne(i.open),
        ...a,
        ref: d,
        onClick: io(e.onClick, i.onOpenToggle)
      }
    );
    return i.hasCustomAnchor ? f : /* @__PURE__ */ V.jsx(wne, { asChild: !0, ...c, children: f });
  }
);
Dne.displayName = Nne;
var HI = "PopoverPortal", [zCt, jCt] = Tne(HI, {
  forceMount: void 0
}), $ne = (e) => {
  const { __scopePopover: t, forceMount: r, children: a, container: i } = e, c = uC(HI, t);
  return /* @__PURE__ */ V.jsx(zCt, { scope: t, forceMount: r, children: /* @__PURE__ */ V.jsx(X0, { present: r || c.open, children: /* @__PURE__ */ V.jsx(II, { asChild: !0, container: i, children: a }) }) });
};
$ne.displayName = HI;
var Dx = "PopoverContent", zne = S.forwardRef(
  (e, t) => {
    const r = jCt(Dx, e.__scopePopover), { forceMount: a = r.forceMount, ...i } = e, c = uC(Dx, e.__scopePopover);
    return /* @__PURE__ */ V.jsx(X0, { present: a || c.open, children: c.modal ? /* @__PURE__ */ V.jsx(LCt, { ...i, ref: t }) : /* @__PURE__ */ V.jsx(HCt, { ...i, ref: t }) });
  }
);
zne.displayName = Dx;
var ICt = /* @__PURE__ */ IE("PopoverContent.RemoveScroll"), LCt = S.forwardRef(
  (e, t) => {
    const r = uC(Dx, e.__scopePopover), a = S.useRef(null), i = Wl(t, a), c = S.useRef(!1);
    return S.useEffect(() => {
      const d = a.current;
      if (d) return Cne(d);
    }, []), /* @__PURE__ */ V.jsx(LI, { as: ICt, allowPinchZoom: !0, children: /* @__PURE__ */ V.jsx(
      jne,
      {
        ...e,
        ref: i,
        trapFocus: r.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: io(e.onCloseAutoFocus, (d) => {
          d.preventDefault(), c.current || r.triggerRef.current?.focus();
        }),
        onPointerDownOutside: io(
          e.onPointerDownOutside,
          (d) => {
            const f = d.detail.originalEvent, p = f.button === 0 && f.ctrlKey === !0, g = f.button === 2 || p;
            c.current = g;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: io(
          e.onFocusOutside,
          (d) => d.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), HCt = S.forwardRef(
  (e, t) => {
    const r = uC(Dx, e.__scopePopover), a = S.useRef(!1), i = S.useRef(!1);
    return /* @__PURE__ */ V.jsx(
      jne,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (c) => {
          e.onCloseAutoFocus?.(c), c.defaultPrevented || (a.current || r.triggerRef.current?.focus(), c.preventDefault()), a.current = !1, i.current = !1;
        },
        onInteractOutside: (c) => {
          e.onInteractOutside?.(c), c.defaultPrevented || (a.current = !0, c.detail.originalEvent.type === "pointerdown" && (i.current = !0));
          const d = c.target;
          r.triggerRef.current?.contains(d) && c.preventDefault(), c.detail.originalEvent.type === "focusin" && i.current && c.preventDefault();
        }
      }
    );
  }
), jne = S.forwardRef(
  (e, t) => {
    const {
      __scopePopover: r,
      trapFocus: a,
      onOpenAutoFocus: i,
      onCloseAutoFocus: c,
      disableOutsidePointerEvents: d,
      onEscapeKeyDown: f,
      onPointerDownOutside: p,
      onFocusOutside: g,
      onInteractOutside: b,
      ...w
    } = e, x = uC(Dx, r), E = b7(r);
    return Ute(), /* @__PURE__ */ V.jsx(
      TI,
      {
        asChild: !0,
        loop: !0,
        trapped: a,
        onMountAutoFocus: i,
        onUnmountAutoFocus: c,
        children: /* @__PURE__ */ V.jsx(
          zM,
          {
            asChild: !0,
            disableOutsidePointerEvents: d,
            onInteractOutside: b,
            onEscapeKeyDown: f,
            onPointerDownOutside: p,
            onFocusOutside: g,
            onDismiss: () => x.onOpenChange(!1),
            children: /* @__PURE__ */ V.jsx(
              XSt,
              {
                "data-state": Lne(x.open),
                role: "dialog",
                id: x.contentId,
                ...E,
                ...w,
                ref: t,
                style: {
                  ...w.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), Ine = "PopoverClose", FCt = S.forwardRef(
  (e, t) => {
    const { __scopePopover: r, ...a } = e, i = uC(Ine, r);
    return /* @__PURE__ */ V.jsx(
      Ro.button,
      {
        type: "button",
        ...a,
        ref: t,
        onClick: io(e.onClick, () => i.onOpenChange(!1))
      }
    );
  }
);
FCt.displayName = Ine;
var WCt = "PopoverArrow", VCt = S.forwardRef(
  (e, t) => {
    const { __scopePopover: r, ...a } = e, i = b7(r);
    return /* @__PURE__ */ V.jsx(GSt, { ...i, ...a, ref: t });
  }
);
VCt.displayName = WCt;
function Lne(e) {
  return e ? "open" : "closed";
}
var Hne = Rne, Fne = Dne, Wne = $ne, Vne = zne;
function _Ct(e, t, r = "long") {
  return new Intl.DateTimeFormat("en-US", {
    // Enforces engine to render the time. Without the option JavaScriptCore omits it.
    hour: "numeric",
    timeZone: e,
    timeZoneName: r
  }).format(t).split(/\s/g).slice(2).join(" ");
}
const BCt = {}, uE = {};
function X4(e, t) {
  try {
    const a = (BCt[e] ||= new Intl.DateTimeFormat("en-US", {
      timeZone: e,
      timeZoneName: "longOffset"
    }).format)(t).split("GMT")[1];
    return a in uE ? uE[a] : $U(a, a.split(":"));
  } catch {
    if (e in uE) return uE[e];
    const r = e?.match(UCt);
    return r ? $U(e, r.slice(1)) : NaN;
  }
}
const UCt = /([+-]\d\d):?(\d\d)?/;
function $U(e, t) {
  const r = +(t[0] || 0), a = +(t[1] || 0), i = +(t[2] || 0) / 60;
  return uE[e] = r * 60 + a > 0 ? r * 60 + a + i : r * 60 - a - i;
}
class sb extends Date {
  //#region static
  constructor(...t) {
    super(), t.length > 1 && typeof t[t.length - 1] == "string" && (this.timeZone = t.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(X4(this.timeZone, this)) ? this.setTime(NaN) : t.length ? typeof t[0] == "number" && (t.length === 1 || t.length === 2 && typeof t[1] != "number") ? this.setTime(t[0]) : typeof t[0] == "string" ? this.setTime(+new Date(t[0])) : t[0] instanceof Date ? this.setTime(+t[0]) : (this.setTime(+new Date(...t)), _ne(this), F$(this)) : this.setTime(Date.now());
  }
  static tz(t, ...r) {
    return r.length ? new sb(...r, t) : new sb(Date.now(), t);
  }
  //#endregion
  //#region time zone
  withTimeZone(t) {
    return new sb(+this, t);
  }
  getTimezoneOffset() {
    const t = -X4(this.timeZone, this);
    return t > 0 ? Math.floor(t) : Math.ceil(t);
  }
  //#endregion
  //#region time
  setTime(t) {
    return Date.prototype.setTime.apply(this, arguments), F$(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](t) {
    return new sb(+new Date(t), this.timeZone);
  }
  //#endregion
}
const zU = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((e) => {
  if (!zU.test(e)) return;
  const t = e.replace(zU, "$1UTC");
  sb.prototype[t] && (e.startsWith("get") ? sb.prototype[e] = function() {
    return this.internal[t]();
  } : (sb.prototype[e] = function() {
    return Date.prototype[t].apply(this.internal, arguments), XCt(this), +this;
  }, sb.prototype[t] = function() {
    return Date.prototype[t].apply(this, arguments), F$(this), +this;
  }));
});
function F$(e) {
  e.internal.setTime(+e), e.internal.setUTCSeconds(e.internal.getUTCSeconds() - Math.round(-X4(e.timeZone, e) * 60));
}
function XCt(e) {
  Date.prototype.setFullYear.call(e, e.internal.getUTCFullYear(), e.internal.getUTCMonth(), e.internal.getUTCDate()), Date.prototype.setHours.call(e, e.internal.getUTCHours(), e.internal.getUTCMinutes(), e.internal.getUTCSeconds(), e.internal.getUTCMilliseconds()), _ne(e);
}
function _ne(e) {
  const t = X4(e.timeZone, e), r = t > 0 ? Math.floor(t) : Math.ceil(t), a = /* @__PURE__ */ new Date(+e);
  a.setUTCHours(a.getUTCHours() - 1);
  const i = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset(), c = -(/* @__PURE__ */ new Date(+a)).getTimezoneOffset(), d = i - c, f = Date.prototype.getHours.apply(e) !== e.internal.getUTCHours();
  d && f && e.internal.setUTCMinutes(e.internal.getUTCMinutes() + d);
  const p = i - r;
  p && Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + p);
  const g = /* @__PURE__ */ new Date(+e);
  g.setUTCSeconds(0);
  const b = i > 0 ? g.getSeconds() : (g.getSeconds() - 60) % 60, w = Math.round(-(X4(e.timeZone, e) * 60)) % 60;
  (w || b) && (e.internal.setUTCSeconds(e.internal.getUTCSeconds() + w), Date.prototype.setUTCSeconds.call(e, Date.prototype.getUTCSeconds.call(e) + w + b));
  const x = X4(e.timeZone, e), E = x > 0 ? Math.floor(x) : Math.ceil(x), k = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset() - E, M = E !== r, T = k - p;
  if (M && T) {
    Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + T);
    const N = X4(e.timeZone, e), D = N > 0 ? Math.floor(N) : Math.ceil(N), $ = E - D;
    $ && (e.internal.setUTCMinutes(e.internal.getUTCMinutes() + $), Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + $));
  }
}
class Zf extends sb {
  //#region static
  static tz(t, ...r) {
    return r.length ? new Zf(...r, t) : new Zf(Date.now(), t);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [t, r, a] = this.tzComponents(), i = `${t}${r}:${a}`;
    return this.internal.toISOString().slice(0, -1) + i;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [t, r, a, i] = this.internal.toUTCString().split(" ");
    return `${t?.slice(0, -1)} ${a} ${r} ${i}`;
  }
  toTimeString() {
    const t = this.internal.toUTCString().split(" ")[4], [r, a, i] = this.tzComponents();
    return `${t} GMT${r}${a}${i} (${_Ct(this.timeZone, this)})`;
  }
  toLocaleString(t, r) {
    return Date.prototype.toLocaleString.call(this, t, {
      ...r,
      timeZone: r?.timeZone || this.timeZone
    });
  }
  toLocaleDateString(t, r) {
    return Date.prototype.toLocaleDateString.call(this, t, {
      ...r,
      timeZone: r?.timeZone || this.timeZone
    });
  }
  toLocaleTimeString(t, r) {
    return Date.prototype.toLocaleTimeString.call(this, t, {
      ...r,
      timeZone: r?.timeZone || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const t = this.getTimezoneOffset(), r = t > 0 ? "-" : "+", a = String(Math.floor(Math.abs(t) / 60)).padStart(2, "0"), i = String(Math.abs(t) % 60).padStart(2, "0");
    return [r, a, i];
  }
  //#endregion
  withTimeZone(t) {
    return new Zf(+this, t);
  }
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](t) {
    return new Zf(+new Date(t), this.timeZone);
  }
  //#endregion
}
const jU = 5, GCt = 4;
function qCt(e, t) {
  const r = t.startOfMonth(e), a = r.getDay() > 0 ? r.getDay() : 7, i = t.addDays(e, -a + 1), c = t.addDays(i, jU * 7 - 1);
  return t.getMonth(e) === t.getMonth(c) ? jU : GCt;
}
function Bne(e, t) {
  const r = t.startOfMonth(e), a = r.getDay();
  return a === 1 ? r : a === 0 ? t.addDays(r, -6) : t.addDays(r, -1 * (a - 1));
}
function KCt(e, t) {
  const r = Bne(e, t), a = qCt(e, t);
  return t.addDays(r, a * 7 - 1);
}
const Une = {
  ...B3,
  labels: {
    labelDayButton: (e, t, r, a) => {
      let i;
      a && typeof a.format == "function" ? i = a.format.bind(a) : i = (d, f) => q3(d, f, { locale: B3, ...r });
      let c = i(e, "PPPP");
      return t.today && (c = `Today, ${c}`), t.selected && (c = `${c}, selected`), c;
    },
    labelMonthDropdown: "Choose the Month",
    labelNext: "Go to the Next Month",
    labelPrevious: "Go to the Previous Month",
    labelWeekNumber: (e) => `Week ${e}`,
    labelYearDropdown: "Choose the Year",
    labelGrid: (e, t, r) => {
      let a;
      return r && typeof r.format == "function" ? a = r.format.bind(r) : a = (i, c) => q3(i, c, { locale: B3, ...t }), a(e, "LLLL yyyy");
    },
    labelGridcell: (e, t, r, a) => {
      let i;
      a && typeof a.format == "function" ? i = a.format.bind(a) : i = (d, f) => q3(d, f, { locale: B3, ...r });
      let c = i(e, "PPPP");
      return t?.today && (c = `Today, ${c}`), c;
    },
    labelNav: "Navigation bar",
    labelWeekNumberHeader: "Week Number",
    labelWeekday: (e, t, r) => {
      let a;
      return r && typeof r.format == "function" ? a = r.format.bind(r) : a = (i, c) => q3(i, c, { locale: B3, ...t }), a(e, "cccc");
    }
  }
};
class D0 {
  /**
   * Creates an instance of `DateLib`.
   *
   * @param options Configuration options for the date library.
   * @param overrides Custom overrides for the date library functions.
   */
  constructor(t, r) {
    this.Date = Date, this.today = () => this.overrides?.today ? this.overrides.today() : this.options.timeZone ? Zf.tz(this.options.timeZone) : new this.Date(), this.newDate = (a, i, c) => this.overrides?.newDate ? this.overrides.newDate(a, i, c) : this.options.timeZone ? new Zf(a, i, c, this.options.timeZone) : new Date(a, i, c), this.addDays = (a, i) => this.overrides?.addDays ? this.overrides.addDays(a, i) : pG(a, i), this.addMonths = (a, i) => this.overrides?.addMonths ? this.overrides.addMonths(a, i) : wte(a, i), this.addWeeks = (a, i) => this.overrides?.addWeeks ? this.overrides.addWeeks(a, i) : xOe(a, i), this.addYears = (a, i) => this.overrides?.addYears ? this.overrides.addYears(a, i) : EOe(a, i), this.differenceInCalendarDays = (a, i) => this.overrides?.differenceInCalendarDays ? this.overrides.differenceInCalendarDays(a, i) : gG(a, i), this.differenceInCalendarMonths = (a, i) => this.overrides?.differenceInCalendarMonths ? this.overrides.differenceInCalendarMonths(a, i) : Ste(a, i), this.eachMonthOfInterval = (a) => this.overrides?.eachMonthOfInterval ? this.overrides.eachMonthOfInterval(a) : TOe(a), this.eachYearOfInterval = (a) => {
      const i = this.overrides?.eachYearOfInterval ? this.overrides.eachYearOfInterval(a) : NOe(a), c = new Set(i.map((f) => this.getYear(f)));
      if (c.size === i.length)
        return i;
      const d = [];
      return c.forEach((f) => {
        d.push(new Date(f, 0, 1));
      }), d;
    }, this.endOfBroadcastWeek = (a) => this.overrides?.endOfBroadcastWeek ? this.overrides.endOfBroadcastWeek(a) : KCt(a, this), this.endOfISOWeek = (a) => this.overrides?.endOfISOWeek ? this.overrides.endOfISOWeek(a) : DOe(a), this.endOfMonth = (a) => this.overrides?.endOfMonth ? this.overrides.endOfMonth(a) : OOe(a), this.endOfWeek = (a, i) => this.overrides?.endOfWeek ? this.overrides.endOfWeek(a, i) : xte(a, this.options), this.endOfYear = (a) => this.overrides?.endOfYear ? this.overrides.endOfYear(a) : AOe(a), this.format = (a, i, c) => {
      const d = this.overrides?.format ? this.overrides.format(a, i, this.options) : q3(a, i, this.options);
      return this.options.numerals && this.options.numerals !== "latn" ? this.replaceDigits(d) : d;
    }, this.getISOWeek = (a) => this.overrides?.getISOWeek ? this.overrides.getISOWeek(a) : vG(a), this.getMonth = (a, i) => this.overrides?.getMonth ? this.overrides.getMonth(a, this.options) : zOe(a, this.options), this.getYear = (a, i) => this.overrides?.getYear ? this.overrides.getYear(a, this.options) : jOe(a, this.options), this.getWeek = (a, i) => this.overrides?.getWeek ? this.overrides.getWeek(a, this.options) : bG(a, this.options), this.isAfter = (a, i) => this.overrides?.isAfter ? this.overrides.isAfter(a, i) : IOe(a, i), this.isBefore = (a, i) => this.overrides?.isBefore ? this.overrides.isBefore(a, i) : LOe(a, i), this.isDate = (a) => this.overrides?.isDate ? this.overrides.isDate(a) : cle(a), this.isSameDay = (a, i) => this.overrides?.isSameDay ? this.overrides.isSameDay(a, i) : MOe(a, i), this.isSameMonth = (a, i) => this.overrides?.isSameMonth ? this.overrides.isSameMonth(a, i) : HOe(a, i), this.isSameYear = (a, i) => this.overrides?.isSameYear ? this.overrides.isSameYear(a, i) : FOe(a, i), this.max = (a) => this.overrides?.max ? this.overrides.max(a) : POe(a), this.min = (a) => this.overrides?.min ? this.overrides.min(a) : kOe(a), this.setMonth = (a, i) => this.overrides?.setMonth ? this.overrides.setMonth(a, i) : WOe(a, i), this.setYear = (a, i) => this.overrides?.setYear ? this.overrides.setYear(a, i) : VOe(a, i), this.startOfBroadcastWeek = (a, i) => this.overrides?.startOfBroadcastWeek ? this.overrides.startOfBroadcastWeek(a, this) : Bne(a, this), this.startOfDay = (a) => this.overrides?.startOfDay ? this.overrides.startOfDay(a) : EN(a), this.startOfISOWeek = (a) => this.overrides?.startOfISOWeek ? this.overrides.startOfISOWeek(a) : dle(a), this.startOfMonth = (a) => this.overrides?.startOfMonth ? this.overrides.startOfMonth(a) : ROe(a), this.startOfWeek = (a, i) => this.overrides?.startOfWeek ? this.overrides.startOfWeek(a, this.options) : PN(a, this.options), this.startOfYear = (a) => this.overrides?.startOfYear ? this.overrides.startOfYear(a) : fle(a), this.options = { locale: Une, ...t }, this.overrides = r;
  }
  /**
   * Generates a mapping of Arabic digits (0-9) to the target numbering system
   * digits.
   *
   * @since 9.5.0
   * @returns A record mapping Arabic digits to the target numerals.
   */
  getDigitMap() {
    const { numerals: t = "latn" } = this.options, r = new Intl.NumberFormat("en-US", {
      numberingSystem: t
    }), a = {};
    for (let i = 0; i < 10; i++)
      a[i.toString()] = r.format(i);
    return a;
  }
  /**
   * Replaces Arabic digits in a string with the target numbering system digits.
   *
   * @since 9.5.0
   * @param input The string containing Arabic digits.
   * @returns The string with digits replaced.
   */
  replaceDigits(t) {
    const r = this.getDigitMap();
    return t.replace(/\d/g, (a) => r[a] || a);
  }
  /**
   * Formats a number using the configured numbering system.
   *
   * @since 9.5.0
   * @param value The number to format.
   * @returns The formatted number as a string.
   */
  formatNumber(t) {
    return this.replaceDigits(t.toString());
  }
  /**
   * Returns the preferred ordering for month and year labels for the current
   * locale.
   */
  getMonthYearOrder() {
    const t = this.options.locale?.code;
    return t && D0.yearFirstLocales.has(t) ? "year-first" : "month-first";
  }
  /**
   * Formats the month/year pair respecting locale conventions.
   *
   * @since 9.11.0
   */
  formatMonthYear(t) {
    const { locale: r, timeZone: a, numerals: i } = this.options, c = r?.code;
    if (c && D0.yearFirstLocales.has(c))
      try {
        return new Intl.DateTimeFormat(c, {
          month: "long",
          year: "numeric",
          timeZone: a,
          numberingSystem: i
        }).format(t);
      } catch {
      }
    const d = this.getMonthYearOrder() === "year-first" ? "y LLLL" : "LLLL y";
    return this.format(t, d);
  }
}
D0.yearFirstLocales = /* @__PURE__ */ new Set([
  "eu",
  "hu",
  "ja",
  "ja-Hira",
  "ja-JP",
  "ko",
  "ko-KR",
  "lt",
  "lt-LT",
  "lv",
  "lv-LV",
  "mn",
  "mn-MN",
  "zh",
  "zh-CN",
  "zh-HK",
  "zh-TW"
]);
const kb = new D0();
class Xne {
  constructor(t, r, a = kb) {
    this.date = t, this.displayMonth = r, this.outside = !!(r && !a.isSameMonth(t, r)), this.dateLib = a, this.isoDate = a.format(t, "yyyy-MM-dd"), this.displayMonthId = a.format(r, "yyyy-MM"), this.dateMonthId = a.format(t, "yyyy-MM");
  }
  /**
   * Checks if this day is equal to another `CalendarDay`, considering both the
   * date and the displayed month.
   *
   * @param day The `CalendarDay` to compare with.
   * @returns `true` if the days are equal, otherwise `false`.
   */
  isEqualTo(t) {
    return this.dateLib.isSameDay(t.date, this.date) && this.dateLib.isSameMonth(t.displayMonth, this.displayMonth);
  }
}
class YCt {
  constructor(t, r) {
    this.date = t, this.weeks = r;
  }
}
class QCt {
  constructor(t, r) {
    this.days = r, this.weekNumber = t;
  }
}
function JCt(e) {
  return Re.createElement("button", { ...e });
}
function ZCt(e) {
  return Re.createElement("span", { ...e });
}
function e4t(e) {
  const { size: t = 24, orientation: r = "left", className: a } = e;
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: handled by the parent component
    Re.createElement(
      "svg",
      { className: a, width: t, height: t, viewBox: "0 0 24 24" },
      r === "up" && Re.createElement("polygon", { points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28" }),
      r === "down" && Re.createElement("polygon", { points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72" }),
      r === "left" && Re.createElement("polygon", { points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20" }),
      r === "right" && Re.createElement("polygon", { points: "8 18.112 14.18888889 12 8 5.87733333 9.91111111 4 18 12 9.91111111 20" })
    )
  );
}
function t4t(e) {
  const { day: t, modifiers: r, ...a } = e;
  return Re.createElement("td", { ...a });
}
function n4t(e) {
  const { day: t, modifiers: r, ...a } = e, i = Re.useRef(null);
  return Re.useEffect(() => {
    r.focused && i.current?.focus();
  }, [r.focused]), Re.createElement("button", { ref: i, ...a });
}
var Fr;
(function(e) {
  e.Root = "root", e.Chevron = "chevron", e.Day = "day", e.DayButton = "day_button", e.CaptionLabel = "caption_label", e.Dropdowns = "dropdowns", e.Dropdown = "dropdown", e.DropdownRoot = "dropdown_root", e.Footer = "footer", e.MonthGrid = "month_grid", e.MonthCaption = "month_caption", e.MonthsDropdown = "months_dropdown", e.Month = "month", e.Months = "months", e.Nav = "nav", e.NextMonthButton = "button_next", e.PreviousMonthButton = "button_previous", e.Week = "week", e.Weeks = "weeks", e.Weekday = "weekday", e.Weekdays = "weekdays", e.WeekNumber = "week_number", e.WeekNumberHeader = "week_number_header", e.YearsDropdown = "years_dropdown";
})(Fr || (Fr = {}));
var au;
(function(e) {
  e.disabled = "disabled", e.hidden = "hidden", e.outside = "outside", e.focused = "focused", e.today = "today";
})(au || (au = {}));
var I1;
(function(e) {
  e.range_end = "range_end", e.range_middle = "range_middle", e.range_start = "range_start", e.selected = "selected";
})(I1 || (I1 = {}));
var P0;
(function(e) {
  e.weeks_before_enter = "weeks_before_enter", e.weeks_before_exit = "weeks_before_exit", e.weeks_after_enter = "weeks_after_enter", e.weeks_after_exit = "weeks_after_exit", e.caption_after_enter = "caption_after_enter", e.caption_after_exit = "caption_after_exit", e.caption_before_enter = "caption_before_enter", e.caption_before_exit = "caption_before_exit";
})(P0 || (P0 = {}));
function r4t(e) {
  const { options: t, className: r, components: a, classNames: i, ...c } = e, d = [i[Fr.Dropdown], r].join(" "), f = t?.find(({ value: p }) => p === c.value);
  return Re.createElement(
    "span",
    { "data-disabled": c.disabled, className: i[Fr.DropdownRoot] },
    Re.createElement(a.Select, { className: d, ...c }, t?.map(({ value: p, label: g, disabled: b }) => Re.createElement(a.Option, { key: p, value: p, disabled: b }, g))),
    Re.createElement(
      "span",
      { className: i[Fr.CaptionLabel], "aria-hidden": !0 },
      f?.label,
      Re.createElement(a.Chevron, { orientation: "down", size: 18, className: i[Fr.Chevron] })
    )
  );
}
function a4t(e) {
  return Re.createElement("div", { ...e });
}
function o4t(e) {
  return Re.createElement("div", { ...e });
}
function i4t(e) {
  const { calendarMonth: t, displayIndex: r, ...a } = e;
  return Re.createElement("div", { ...a }, e.children);
}
function l4t(e) {
  const { calendarMonth: t, displayIndex: r, ...a } = e;
  return Re.createElement("div", { ...a });
}
function s4t(e) {
  return Re.createElement("table", { ...e });
}
function u4t(e) {
  return Re.createElement("div", { ...e });
}
const Gne = fp(void 0);
function y7() {
  const e = Do(Gne);
  if (e === void 0)
    throw new Error("useDayPicker() must be used within a custom component.");
  return e;
}
function c4t(e) {
  const { components: t } = y7();
  return Re.createElement(t.Dropdown, { ...e });
}
function d4t(e) {
  const { onPreviousClick: t, onNextClick: r, previousMonth: a, nextMonth: i, ...c } = e, { components: d, classNames: f, labels: { labelPrevious: p, labelNext: g } } = y7(), b = Cn((x) => {
    i && r?.(x);
  }, [i, r]), w = Cn((x) => {
    a && t?.(x);
  }, [a, t]);
  return Re.createElement(
    "nav",
    { ...c },
    Re.createElement(
      d.PreviousMonthButton,
      { type: "button", className: f[Fr.PreviousMonthButton], tabIndex: a ? void 0 : -1, "aria-disabled": a ? void 0 : !0, "aria-label": p(a), onClick: w },
      Re.createElement(d.Chevron, { disabled: a ? void 0 : !0, className: f[Fr.Chevron], orientation: "left" })
    ),
    Re.createElement(
      d.NextMonthButton,
      { type: "button", className: f[Fr.NextMonthButton], tabIndex: i ? void 0 : -1, "aria-disabled": i ? void 0 : !0, "aria-label": g(i), onClick: b },
      Re.createElement(d.Chevron, { disabled: i ? void 0 : !0, orientation: "right", className: f[Fr.Chevron] })
    )
  );
}
function f4t(e) {
  const { components: t } = y7();
  return Re.createElement(t.Button, { ...e });
}
function m4t(e) {
  return Re.createElement("option", { ...e });
}
function h4t(e) {
  const { components: t } = y7();
  return Re.createElement(t.Button, { ...e });
}
function p4t(e) {
  const { rootRef: t, ...r } = e;
  return Re.createElement("div", { ...r, ref: t });
}
function g4t(e) {
  return Re.createElement("select", { ...e });
}
function v4t(e) {
  const { week: t, ...r } = e;
  return Re.createElement("tr", { ...r });
}
function b4t(e) {
  return Re.createElement("th", { ...e });
}
function y4t(e) {
  return Re.createElement(
    "thead",
    { "aria-hidden": !0 },
    Re.createElement("tr", { ...e })
  );
}
function w4t(e) {
  const { week: t, ...r } = e;
  return Re.createElement("th", { ...r });
}
function S4t(e) {
  return Re.createElement("th", { ...e });
}
function C4t(e) {
  return Re.createElement("tbody", { ...e });
}
function x4t(e) {
  const { components: t } = y7();
  return Re.createElement(t.Dropdown, { ...e });
}
const E4t = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button: JCt,
  CaptionLabel: ZCt,
  Chevron: e4t,
  Day: t4t,
  DayButton: n4t,
  Dropdown: r4t,
  DropdownNav: a4t,
  Footer: o4t,
  Month: i4t,
  MonthCaption: l4t,
  MonthGrid: s4t,
  Months: u4t,
  MonthsDropdown: c4t,
  Nav: d4t,
  NextMonthButton: f4t,
  Option: m4t,
  PreviousMonthButton: h4t,
  Root: p4t,
  Select: g4t,
  Week: v4t,
  WeekNumber: w4t,
  WeekNumberHeader: S4t,
  Weekday: b4t,
  Weekdays: y4t,
  Weeks: C4t,
  YearsDropdown: x4t
}, Symbol.toStringTag, { value: "Module" }));
function rS(e, t, r = !1, a = kb) {
  let { from: i, to: c } = e;
  const { differenceInCalendarDays: d, isSameDay: f } = a;
  return i && c ? (d(c, i) < 0 && ([i, c] = [c, i]), d(t, i) >= (r ? 1 : 0) && d(c, t) >= (r ? 1 : 0)) : !r && c ? f(c, t) : !r && i ? f(i, t) : !1;
}
function FI(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function UM(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function WI(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function VI(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function qne(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function Kne(e, t) {
  return Array.isArray(e) && e.every(t.isDate);
}
function aS(e, t, r = kb) {
  const a = Array.isArray(t) ? t : [t], { isSameDay: i, differenceInCalendarDays: c, isAfter: d } = r;
  return a.some((f) => {
    if (typeof f == "boolean")
      return f;
    if (r.isDate(f))
      return i(e, f);
    if (Kne(f, r))
      return f.some((p) => i(e, p));
    if (UM(f))
      return rS(f, e, !1, r);
    if (qne(f))
      return Array.isArray(f.dayOfWeek) ? f.dayOfWeek.includes(e.getDay()) : f.dayOfWeek === e.getDay();
    if (FI(f)) {
      const p = c(f.before, e), g = c(f.after, e), b = p > 0, w = g < 0;
      return d(f.before, f.after) ? w && b : b || w;
    }
    return WI(f) ? c(e, f.after) > 0 : VI(f) ? c(f.before, e) > 0 : typeof f == "function" ? f(e) : !1;
  });
}
function P4t(e, t, r, a, i) {
  const { disabled: c, hidden: d, modifiers: f, showOutsideDays: p, broadcastCalendar: g, today: b = i.today() } = t, { isSameDay: w, isSameMonth: x, startOfMonth: E, isBefore: P, endOfMonth: k, isAfter: M } = i, T = r && E(r), N = a && k(a), D = {
    [au.focused]: [],
    [au.outside]: [],
    [au.disabled]: [],
    [au.hidden]: [],
    [au.today]: []
  }, $ = {};
  for (const j of e) {
    const { date: I, displayMonth: L } = j, F = !!(L && !x(I, L)), _ = !!(T && P(I, T)), W = !!(N && M(I, N)), Q = !!(c && aS(I, c, i)), U = !!(d && aS(I, d, i)) || _ || W || // Broadcast calendar will show outside days as default
    !g && !p && F || g && p === !1 && F, Y = w(I, b);
    F && D.outside.push(j), Q && D.disabled.push(j), U && D.hidden.push(j), Y && D.today.push(j), f && Object.keys(f).forEach((G) => {
      const J = f?.[G];
      J && aS(I, J, i) && ($[G] ? $[G].push(j) : $[G] = [j]);
    });
  }
  return (j) => {
    const I = {
      [au.focused]: !1,
      [au.disabled]: !1,
      [au.hidden]: !1,
      [au.outside]: !1,
      [au.today]: !1
    }, L = {};
    for (const F in D) {
      const _ = D[F];
      I[F] = _.some((W) => W === j);
    }
    for (const F in $)
      L[F] = $[F].some((_) => _ === j);
    return {
      ...I,
      // custom modifiers should override all the previous ones
      ...L
    };
  };
}
function k4t(e, t, r = {}) {
  return Object.entries(e).filter(([, i]) => i === !0).reduce((i, [c]) => (r[c] ? i.push(r[c]) : t[au[c]] ? i.push(t[au[c]]) : t[I1[c]] && i.push(t[I1[c]]), i), [t[Fr.Day]]);
}
function M4t(e) {
  return {
    ...E4t,
    ...e
  };
}
function O4t(e) {
  const t = {
    "data-mode": e.mode ?? void 0,
    "data-required": "required" in e ? e.required : void 0,
    "data-multiple-months": e.numberOfMonths && e.numberOfMonths > 1 || void 0,
    "data-week-numbers": e.showWeekNumber || void 0,
    "data-broadcast-calendar": e.broadcastCalendar || void 0,
    "data-nav-layout": e.navLayout || void 0
  };
  return Object.entries(e).forEach(([r, a]) => {
    r.startsWith("data-") && (t[r] = a);
  }), t;
}
function _I() {
  const e = {};
  for (const t in Fr)
    e[Fr[t]] = `rdp-${Fr[t]}`;
  for (const t in au)
    e[au[t]] = `rdp-${au[t]}`;
  for (const t in I1)
    e[I1[t]] = `rdp-${I1[t]}`;
  for (const t in P0)
    e[P0[t]] = `rdp-${P0[t]}`;
  return e;
}
function Yne(e, t, r) {
  return (r ?? new D0(t)).formatMonthYear(e);
}
const T4t = Yne;
function R4t(e, t, r) {
  return (r ?? new D0(t)).format(e, "d");
}
function A4t(e, t = kb) {
  return t.format(e, "LLLL");
}
function N4t(e, t, r) {
  return (r ?? new D0(t)).format(e, "cccccc");
}
function D4t(e, t = kb) {
  return e < 10 ? t.formatNumber(`0${e.toLocaleString()}`) : t.formatNumber(`${e.toLocaleString()}`);
}
function $4t() {
  return "";
}
function Qne(e, t = kb) {
  return t.format(e, "yyyy");
}
const z4t = Qne, j4t = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatCaption: Yne,
  formatDay: R4t,
  formatMonthCaption: T4t,
  formatMonthDropdown: A4t,
  formatWeekNumber: D4t,
  formatWeekNumberHeader: $4t,
  formatWeekdayName: N4t,
  formatYearCaption: z4t,
  formatYearDropdown: Qne
}, Symbol.toStringTag, { value: "Module" }));
function I4t(e) {
  return e?.formatMonthCaption && !e.formatCaption && (e.formatCaption = e.formatMonthCaption), e?.formatYearCaption && !e.formatYearDropdown && (e.formatYearDropdown = e.formatYearCaption), {
    ...j4t,
    ...e
  };
}
function BI(e, t, r, a) {
  let i = (a ?? new D0(r)).format(e, "PPPP");
  return t.today && (i = `Today, ${i}`), t.selected && (i = `${i}, selected`), i;
}
const L4t = BI;
function UI(e, t, r) {
  return (r ?? new D0(t)).formatMonthYear(e);
}
const H4t = UI;
function Jne(e, t, r, a) {
  let i = (a ?? new D0(r)).format(e, "PPPP");
  return t?.today && (i = `Today, ${i}`), i;
}
function Zne(e) {
  return "Choose the Month";
}
function ere() {
  return "";
}
const F4t = "Go to the Next Month";
function tre(e, t) {
  return F4t;
}
function nre(e) {
  return "Go to the Previous Month";
}
function rre(e, t, r) {
  return (r ?? new D0(t)).format(e, "cccc");
}
function are(e, t) {
  return `Week ${e}`;
}
function ore(e) {
  return "Week Number";
}
function ire(e) {
  return "Choose the Year";
}
const W4t = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  labelCaption: H4t,
  labelDay: L4t,
  labelDayButton: BI,
  labelGrid: UI,
  labelGridcell: Jne,
  labelMonthDropdown: Zne,
  labelNav: ere,
  labelNext: tre,
  labelPrevious: nre,
  labelWeekNumber: are,
  labelWeekNumberHeader: ore,
  labelWeekday: rre,
  labelYearDropdown: ire
}, Symbol.toStringTag, { value: "Module" })), N1 = (e, t, r) => t || (r ? typeof r == "function" ? r : (...a) => r : e);
function V4t(e, t) {
  const r = t.locale?.labels ?? {};
  return {
    ...W4t,
    ...e ?? {},
    labelDayButton: N1(BI, e?.labelDayButton, r.labelDayButton),
    labelMonthDropdown: N1(Zne, e?.labelMonthDropdown, r.labelMonthDropdown),
    labelNext: N1(tre, e?.labelNext, r.labelNext),
    labelPrevious: N1(nre, e?.labelPrevious, r.labelPrevious),
    labelWeekNumber: N1(are, e?.labelWeekNumber, r.labelWeekNumber),
    labelYearDropdown: N1(ire, e?.labelYearDropdown, r.labelYearDropdown),
    labelGrid: N1(UI, e?.labelGrid, r.labelGrid),
    labelGridcell: N1(Jne, e?.labelGridcell, r.labelGridcell),
    labelNav: N1(ere, e?.labelNav, r.labelNav),
    labelWeekNumberHeader: N1(ore, e?.labelWeekNumberHeader, r.labelWeekNumberHeader),
    labelWeekday: N1(rre, e?.labelWeekday, r.labelWeekday)
  };
}
function _4t(e, t, r, a, i) {
  const { startOfMonth: c, startOfYear: d, endOfYear: f, eachMonthOfInterval: p, getMonth: g } = i;
  return p({
    start: d(e),
    end: f(e)
  }).map((x) => {
    const E = a.formatMonthDropdown(x, i), P = g(x), k = t && x < c(t) || r && x > c(r) || !1;
    return { value: P, label: E, disabled: k };
  });
}
function B4t(e, t = {}, r = {}) {
  let a = { ...t?.[Fr.Day] };
  return Object.entries(e).filter(([, i]) => i === !0).forEach(([i]) => {
    a = {
      ...a,
      ...r?.[i]
    };
  }), a;
}
function U4t(e, t, r, a) {
  const i = a ?? e.today(), c = r ? e.startOfBroadcastWeek(i, e) : t ? e.startOfISOWeek(i) : e.startOfWeek(i), d = [];
  for (let f = 0; f < 7; f++) {
    const p = e.addDays(c, f);
    d.push(p);
  }
  return d;
}
function X4t(e, t, r, a, i = !1) {
  if (!e || !t)
    return;
  const { startOfYear: c, endOfYear: d, eachYearOfInterval: f, getYear: p } = a, g = c(e), b = d(t), w = f({ start: g, end: b });
  return i && w.reverse(), w.map((x) => {
    const E = r.formatYearDropdown(x, a);
    return {
      value: p(x),
      label: E,
      disabled: !1
    };
  });
}
function G4t(e, t = {}) {
  const { weekStartsOn: r, locale: a } = t, i = r ?? a?.options?.weekStartsOn ?? 0, c = (f) => {
    const p = typeof f == "number" || typeof f == "string" ? new Date(f) : f;
    return new Zf(p.getFullYear(), p.getMonth(), p.getDate(), 12, 0, 0, e);
  }, d = (f) => {
    const p = c(f);
    return new Date(p.getFullYear(), p.getMonth(), p.getDate(), 0, 0, 0, 0);
  };
  return {
    today: () => c(Zf.tz(e)),
    newDate: (f, p, g) => new Zf(f, p, g, 12, 0, 0, e),
    startOfDay: (f) => c(f),
    startOfWeek: (f, p) => {
      const g = c(f), b = p?.weekStartsOn ?? i, w = (g.getDay() - b + 7) % 7;
      return g.setDate(g.getDate() - w), g;
    },
    startOfISOWeek: (f) => {
      const p = c(f), g = (p.getDay() - 1 + 7) % 7;
      return p.setDate(p.getDate() - g), p;
    },
    startOfMonth: (f) => {
      const p = c(f);
      return p.setDate(1), p;
    },
    startOfYear: (f) => {
      const p = c(f);
      return p.setMonth(0, 1), p;
    },
    endOfWeek: (f, p) => {
      const g = c(f), x = (((p?.weekStartsOn ?? i) + 6) % 7 - g.getDay() + 7) % 7;
      return g.setDate(g.getDate() + x), g;
    },
    endOfISOWeek: (f) => {
      const p = c(f), g = (7 - p.getDay()) % 7;
      return p.setDate(p.getDate() + g), p;
    },
    endOfMonth: (f) => {
      const p = c(f);
      return p.setMonth(p.getMonth() + 1, 0), p;
    },
    endOfYear: (f) => {
      const p = c(f);
      return p.setMonth(11, 31), p;
    },
    eachMonthOfInterval: (f) => {
      const p = c(f.start), g = c(f.end), b = [], w = new Zf(p.getFullYear(), p.getMonth(), 1, 12, 0, 0, e), x = g.getFullYear() * 12 + g.getMonth();
      for (; w.getFullYear() * 12 + w.getMonth() <= x; )
        b.push(new Zf(w, e)), w.setMonth(w.getMonth() + 1, 1);
      return b;
    },
    // Normalize to noon once before arithmetic (avoid DST/midnight edge cases),
    // mutate the same TZDate, and return it.
    addDays: (f, p) => {
      const g = c(f);
      return g.setDate(g.getDate() + p), g;
    },
    addWeeks: (f, p) => {
      const g = c(f);
      return g.setDate(g.getDate() + p * 7), g;
    },
    addMonths: (f, p) => {
      const g = c(f);
      return g.setMonth(g.getMonth() + p), g;
    },
    addYears: (f, p) => {
      const g = c(f);
      return g.setFullYear(g.getFullYear() + p), g;
    },
    eachYearOfInterval: (f) => {
      const p = c(f.start), g = c(f.end), b = [], w = new Zf(p.getFullYear(), 0, 1, 12, 0, 0, e);
      for (; w.getFullYear() <= g.getFullYear(); )
        b.push(new Zf(w, e)), w.setFullYear(w.getFullYear() + 1, 0, 1);
      return b;
    },
    getWeek: (f, p) => {
      const g = d(f);
      return bG(g, {
        weekStartsOn: p?.weekStartsOn ?? i,
        firstWeekContainsDate: p?.firstWeekContainsDate ?? a?.options?.firstWeekContainsDate ?? 1
      });
    },
    getISOWeek: (f) => {
      const p = d(f);
      return vG(p);
    },
    differenceInCalendarDays: (f, p) => {
      const g = d(f), b = d(p);
      return gG(g, b);
    },
    differenceInCalendarMonths: (f, p) => {
      const g = d(f), b = d(p);
      return Ste(g, b);
    }
  };
}
const w7 = (e) => e instanceof HTMLElement ? e : null, FA = (e) => [
  ...e.querySelectorAll("[data-animated-month]") ?? []
], q4t = (e) => w7(e.querySelector("[data-animated-month]")), WA = (e) => w7(e.querySelector("[data-animated-caption]")), VA = (e) => w7(e.querySelector("[data-animated-weeks]")), K4t = (e) => w7(e.querySelector("[data-animated-nav]")), Y4t = (e) => w7(e.querySelector("[data-animated-weekdays]"));
function Q4t(e, t, { classNames: r, months: a, focused: i, dateLib: c }) {
  const d = It(null), f = It(a), p = It(!1);
  zS(() => {
    const g = f.current;
    if (f.current = a, !t || !e.current || // safety check because the ref can be set to anything by consumers
    !(e.current instanceof HTMLElement) || // validation required for the animation to work as expected
    a.length === 0 || g.length === 0 || a.length !== g.length)
      return;
    const b = c.isSameMonth(a[0].date, g[0].date), w = c.isAfter(a[0].date, g[0].date), x = w ? r[P0.caption_after_enter] : r[P0.caption_before_enter], E = w ? r[P0.weeks_after_enter] : r[P0.weeks_before_enter], P = d.current, k = e.current.cloneNode(!0);
    if (k instanceof HTMLElement ? (FA(k).forEach((D) => {
      if (!(D instanceof HTMLElement))
        return;
      const $ = q4t(D);
      $ && D.contains($) && D.removeChild($);
      const j = WA(D);
      j && j.classList.remove(x);
      const I = VA(D);
      I && I.classList.remove(E);
    }), d.current = k) : d.current = null, p.current || b || // skip animation if a day is focused because it can cause issues to the animation and is better for a11y
    i)
      return;
    const M = P instanceof HTMLElement ? FA(P) : [], T = FA(e.current);
    if (T?.every((N) => N instanceof HTMLElement) && M && M.every((N) => N instanceof HTMLElement)) {
      p.current = !0, e.current.style.isolation = "isolate";
      const N = K4t(e.current);
      N && (N.style.zIndex = "1"), T.forEach((D, $) => {
        const j = M[$];
        if (!j)
          return;
        D.style.position = "relative", D.style.overflow = "hidden";
        const I = WA(D);
        I && I.classList.add(x);
        const L = VA(D);
        L && L.classList.add(E);
        const F = () => {
          p.current = !1, e.current && (e.current.style.isolation = ""), N && (N.style.zIndex = ""), I && I.classList.remove(x), L && L.classList.remove(E), D.style.position = "", D.style.overflow = "", D.contains(j) && D.removeChild(j);
        };
        j.style.pointerEvents = "none", j.style.position = "absolute", j.style.overflow = "hidden", j.setAttribute("aria-hidden", "true");
        const _ = Y4t(j);
        _ && (_.style.opacity = "0");
        const W = WA(j);
        W && (W.classList.add(w ? r[P0.caption_before_exit] : r[P0.caption_after_exit]), W.addEventListener("animationend", F));
        const Q = VA(j);
        Q && Q.classList.add(w ? r[P0.weeks_before_exit] : r[P0.weeks_after_exit]), D.insertBefore(j, D.firstChild);
      });
    }
  });
}
function J4t(e, t, r, a) {
  const i = e[0], c = e[e.length - 1], { ISOWeek: d, fixedWeeks: f, broadcastCalendar: p } = r ?? {}, { addDays: g, differenceInCalendarDays: b, differenceInCalendarMonths: w, endOfBroadcastWeek: x, endOfISOWeek: E, endOfMonth: P, endOfWeek: k, isAfter: M, startOfBroadcastWeek: T, startOfISOWeek: N, startOfWeek: D } = a, $ = p ? T(i, a) : d ? N(i) : D(i), j = p ? x(c) : d ? E(P(c)) : k(P(c)), I = t && (p ? x(t) : d ? E(t) : k(t)), L = I && M(j, I) ? I : j, F = b(L, $), _ = w(c, i) + 1, W = [];
  for (let Y = 0; Y <= F; Y++) {
    const G = g($, Y);
    W.push(G);
  }
  const U = (p ? 35 : 42) * _;
  if (f && W.length < U) {
    const Y = U - W.length;
    for (let G = 0; G < Y; G++) {
      const J = g(W[W.length - 1], 1);
      W.push(J);
    }
  }
  return W;
}
function Z4t(e) {
  const t = [];
  return e.reduce((r, a) => {
    const i = a.weeks.reduce((c, d) => c.concat(d.days.slice()), t.slice());
    return r.concat(i.slice());
  }, t.slice());
}
function e3t(e, t, r, a) {
  const { numberOfMonths: i = 1 } = r, c = [];
  for (let d = 0; d < i; d++) {
    const f = a.addMonths(e, d);
    if (t && f > t)
      break;
    c.push(f);
  }
  return c;
}
function IU(e, t, r, a) {
  const { month: i, defaultMonth: c, today: d = a.today(), numberOfMonths: f = 1 } = e;
  let p = i || c || d;
  const { differenceInCalendarMonths: g, addMonths: b, startOfMonth: w } = a;
  if (r && g(r, p) < f - 1) {
    const x = -1 * (f - 1);
    p = b(r, x);
  }
  return t && g(p, t) < 0 && (p = t), w(p);
}
function t3t(e, t, r, a) {
  const { addDays: i, endOfBroadcastWeek: c, endOfISOWeek: d, endOfMonth: f, endOfWeek: p, getISOWeek: g, getWeek: b, startOfBroadcastWeek: w, startOfISOWeek: x, startOfWeek: E } = a, P = e.reduce((k, M) => {
    const T = r.broadcastCalendar ? w(M, a) : r.ISOWeek ? x(M) : E(M), N = r.broadcastCalendar ? c(M) : r.ISOWeek ? d(f(M)) : p(f(M)), D = t.filter((L) => L >= T && L <= N), $ = r.broadcastCalendar ? 35 : 42;
    if (r.fixedWeeks && D.length < $) {
      const L = t.filter((F) => {
        const _ = $ - D.length;
        return F > N && F <= i(N, _);
      });
      D.push(...L);
    }
    const j = D.reduce((L, F) => {
      const _ = r.ISOWeek ? g(F) : b(F), W = L.find((U) => U.weekNumber === _), Q = new Xne(F, M, a);
      return W ? W.days.push(Q) : L.push(new QCt(_, [Q])), L;
    }, []), I = new YCt(M, j);
    return k.push(I), k;
  }, []);
  return r.reverseMonths ? P.reverse() : P;
}
function n3t(e, t) {
  let { startMonth: r, endMonth: a } = e;
  const { startOfYear: i, startOfDay: c, startOfMonth: d, endOfMonth: f, addYears: p, endOfYear: g, newDate: b, today: w } = t, { fromYear: x, toYear: E, fromMonth: P, toMonth: k } = e;
  !r && P && (r = P), !r && x && (r = t.newDate(x, 0, 1)), !a && k && (a = k), !a && E && (a = b(E, 11, 31));
  const M = e.captionLayout === "dropdown" || e.captionLayout === "dropdown-years";
  return r ? r = d(r) : x ? r = b(x, 0, 1) : !r && M && (r = i(p(e.today ?? w(), -100))), a ? a = f(a) : E ? a = b(E, 11, 31) : !a && M && (a = g(e.today ?? w())), [
    r && c(r),
    a && c(a)
  ];
}
function r3t(e, t, r, a) {
  if (r.disableNavigation)
    return;
  const { pagedNavigation: i, numberOfMonths: c = 1 } = r, { startOfMonth: d, addMonths: f, differenceInCalendarMonths: p } = a, g = i ? c : 1, b = d(e);
  if (!t)
    return f(b, g);
  if (!(p(t, e) < c))
    return f(b, g);
}
function a3t(e, t, r, a) {
  if (r.disableNavigation)
    return;
  const { pagedNavigation: i, numberOfMonths: c } = r, { startOfMonth: d, addMonths: f, differenceInCalendarMonths: p } = a, g = i ? c ?? 1 : 1, b = d(e);
  if (!t)
    return f(b, -g);
  if (!(p(b, t) <= 0))
    return f(b, -g);
}
function o3t(e) {
  const t = [];
  return e.reduce((r, a) => r.concat(a.weeks.slice()), t.slice());
}
function XM(e, t) {
  const [r, a] = Wn(e);
  return [t === void 0 ? r : t, a];
}
function i3t(e, t) {
  const [r, a] = n3t(e, t), { startOfMonth: i, endOfMonth: c } = t, d = IU(e, r, a, t), [f, p] = XM(
    d,
    // initialMonth is always computed from props.month if provided
    e.month ? d : void 0
  );
  Er(() => {
    const $ = IU(e, r, a, t);
    p($);
  }, [e.timeZone]);
  const { months: g, weeks: b, days: w, previousMonth: x, nextMonth: E } = mn(() => {
    const $ = e3t(f, a, { numberOfMonths: e.numberOfMonths }, t), j = J4t($, e.endMonth ? c(e.endMonth) : void 0, {
      ISOWeek: e.ISOWeek,
      fixedWeeks: e.fixedWeeks,
      broadcastCalendar: e.broadcastCalendar
    }, t), I = t3t($, j, {
      broadcastCalendar: e.broadcastCalendar,
      fixedWeeks: e.fixedWeeks,
      ISOWeek: e.ISOWeek,
      reverseMonths: e.reverseMonths
    }, t), L = o3t(I), F = Z4t(I), _ = a3t(f, r, e, t), W = r3t(f, a, e, t);
    return {
      months: I,
      weeks: L,
      days: F,
      previousMonth: _,
      nextMonth: W
    };
  }, [
    t,
    f.getTime(),
    a?.getTime(),
    r?.getTime(),
    e.disableNavigation,
    e.broadcastCalendar,
    e.endMonth?.getTime(),
    e.fixedWeeks,
    e.ISOWeek,
    e.numberOfMonths,
    e.pagedNavigation,
    e.reverseMonths
  ]), { disableNavigation: P, onMonthChange: k } = e, M = ($) => b.some((j) => j.days.some((I) => I.isEqualTo($))), T = ($) => {
    if (P)
      return;
    let j = i($);
    r && j < i(r) && (j = i(r)), a && j > i(a) && (j = i(a)), p(j), k?.(j);
  };
  return {
    months: g,
    weeks: b,
    days: w,
    navStart: r,
    navEnd: a,
    previousMonth: x,
    nextMonth: E,
    goToMonth: T,
    goToDay: ($) => {
      M($) || T($.date);
    }
  };
}
var rb;
(function(e) {
  e[e.Today = 0] = "Today", e[e.Selected = 1] = "Selected", e[e.LastFocused = 2] = "LastFocused", e[e.FocusedModifier = 3] = "FocusedModifier";
})(rb || (rb = {}));
function LU(e) {
  return !e[au.disabled] && !e[au.hidden] && !e[au.outside];
}
function l3t(e, t, r, a) {
  let i, c = -1;
  for (const d of e) {
    const f = t(d);
    LU(f) && (f[au.focused] && c < rb.FocusedModifier ? (i = d, c = rb.FocusedModifier) : a?.isEqualTo(d) && c < rb.LastFocused ? (i = d, c = rb.LastFocused) : r(d.date) && c < rb.Selected ? (i = d, c = rb.Selected) : f[au.today] && c < rb.Today && (i = d, c = rb.Today));
  }
  return i || (i = e.find((d) => LU(t(d)))), i;
}
function s3t(e, t, r, a, i, c, d) {
  const { ISOWeek: f, broadcastCalendar: p } = c, { addDays: g, addMonths: b, addWeeks: w, addYears: x, endOfBroadcastWeek: E, endOfISOWeek: P, endOfWeek: k, max: M, min: T, startOfBroadcastWeek: N, startOfISOWeek: D, startOfWeek: $ } = d;
  let I = {
    day: g,
    week: w,
    month: b,
    year: x,
    startOfWeek: (L) => p ? N(L, d) : f ? D(L) : $(L),
    endOfWeek: (L) => p ? E(L) : f ? P(L) : k(L)
  }[e](r, t === "after" ? 1 : -1);
  return t === "before" && a ? I = M([a, I]) : t === "after" && i && (I = T([i, I])), I;
}
function lre(e, t, r, a, i, c, d, f = 0) {
  if (f > 365)
    return;
  const p = s3t(e, t, r.date, a, i, c, d), g = !!(c.disabled && aS(p, c.disabled, d)), b = !!(c.hidden && aS(p, c.hidden, d)), w = p, x = new Xne(p, w, d);
  return !g && !b ? x : lre(e, t, x, a, i, c, d, f + 1);
}
function u3t(e, t, r, a, i) {
  const { autoFocus: c } = e, [d, f] = Wn(), p = l3t(t.days, r, a || (() => !1), d), [g, b] = Wn(c ? p : void 0);
  return {
    isFocusTarget: (k) => !!p?.isEqualTo(k),
    setFocused: b,
    focused: g,
    blur: () => {
      f(g), b(void 0);
    },
    moveFocus: (k, M) => {
      if (!g)
        return;
      const T = lre(k, M, g, t.navStart, t.navEnd, e, i);
      T && (e.disableNavigation && !t.days.some((D) => D.isEqualTo(T)) || (t.goToDay(T), b(T)));
    }
  };
}
function c3t(e, t) {
  const { selected: r, required: a, onSelect: i } = e, [c, d] = XM(r, i ? r : void 0), f = i ? r : c, { isSameDay: p } = t, g = (E) => f?.some((P) => p(P, E)) ?? !1, { min: b, max: w } = e;
  return {
    selected: f,
    select: (E, P, k) => {
      let M = [...f ?? []];
      if (g(E)) {
        if (f?.length === b || a && f?.length === 1)
          return;
        M = f?.filter((T) => !p(T, E));
      } else
        f?.length === w ? M = [E] : M = [...M, E];
      return i || d(M), i?.(M, E, P, k), M;
    },
    isSelected: g
  };
}
function d3t(e, t, r = 0, a = 0, i = !1, c = kb) {
  const { from: d, to: f } = t || {}, { isSameDay: p, isAfter: g, isBefore: b } = c;
  let w;
  if (!d && !f)
    w = { from: e, to: r > 0 ? void 0 : e };
  else if (d && !f)
    p(d, e) ? r === 0 ? w = { from: d, to: e } : i ? w = { from: d, to: void 0 } : w = void 0 : b(e, d) ? w = { from: e, to: d } : w = { from: d, to: e };
  else if (d && f)
    if (p(d, e) && p(f, e))
      i ? w = { from: d, to: f } : w = void 0;
    else if (p(d, e))
      w = { from: d, to: r > 0 ? void 0 : e };
    else if (p(f, e))
      w = { from: e, to: r > 0 ? void 0 : e };
    else if (b(e, d))
      w = { from: e, to: f };
    else if (g(e, d))
      w = { from: d, to: e };
    else if (g(e, f))
      w = { from: d, to: e };
    else
      throw new Error("Invalid range");
  if (w?.from && w?.to) {
    const x = c.differenceInCalendarDays(w.to, w.from);
    a > 0 && x > a ? w = { from: e, to: void 0 } : r > 1 && x < r && (w = { from: e, to: void 0 });
  }
  return w;
}
function f3t(e, t, r = kb) {
  const a = Array.isArray(t) ? t : [t];
  let i = e.from;
  const c = r.differenceInCalendarDays(e.to, e.from), d = Math.min(c, 6);
  for (let f = 0; f <= d; f++) {
    if (a.includes(i.getDay()))
      return !0;
    i = r.addDays(i, 1);
  }
  return !1;
}
function HU(e, t, r = kb) {
  return rS(e, t.from, !1, r) || rS(e, t.to, !1, r) || rS(t, e.from, !1, r) || rS(t, e.to, !1, r);
}
function m3t(e, t, r = kb) {
  const a = Array.isArray(t) ? t : [t];
  if (a.filter((f) => typeof f != "function").some((f) => typeof f == "boolean" ? f : r.isDate(f) ? rS(e, f, !1, r) : Kne(f, r) ? f.some((p) => rS(e, p, !1, r)) : UM(f) ? f.from && f.to ? HU(e, { from: f.from, to: f.to }, r) : !1 : qne(f) ? f3t(e, f.dayOfWeek, r) : FI(f) ? r.isAfter(f.before, f.after) ? HU(e, {
    from: r.addDays(f.after, 1),
    to: r.addDays(f.before, -1)
  }, r) : aS(e.from, f, r) || aS(e.to, f, r) : WI(f) || VI(f) ? aS(e.from, f, r) || aS(e.to, f, r) : !1))
    return !0;
  const d = a.filter((f) => typeof f == "function");
  if (d.length) {
    let f = e.from;
    const p = r.differenceInCalendarDays(e.to, e.from);
    for (let g = 0; g <= p; g++) {
      if (d.some((b) => b(f)))
        return !0;
      f = r.addDays(f, 1);
    }
  }
  return !1;
}
function h3t(e, t) {
  const { disabled: r, excludeDisabled: a, selected: i, required: c, onSelect: d } = e, [f, p] = XM(i, d ? i : void 0), g = d ? i : f;
  return {
    selected: g,
    select: (x, E, P) => {
      const { min: k, max: M } = e, T = x ? d3t(x, g, k, M, c, t) : void 0;
      return a && r && T?.from && T.to && m3t({ from: T.from, to: T.to }, r, t) && (T.from = x, T.to = void 0), d || p(T), d?.(T, x, E, P), T;
    },
    isSelected: (x) => g && rS(g, x, !1, t)
  };
}
function p3t(e, t) {
  const { selected: r, required: a, onSelect: i } = e, [c, d] = XM(r, i ? r : void 0), f = i ? r : c, { isSameDay: p } = t;
  return {
    selected: f,
    select: (w, x, E) => {
      let P = w;
      return !a && f && f && p(w, f) && (P = void 0), i || d(P), i?.(P, w, x, E), P;
    },
    isSelected: (w) => f ? p(f, w) : !1
  };
}
function g3t(e, t) {
  const r = p3t(e, t), a = c3t(e, t), i = h3t(e, t);
  switch (e.mode) {
    case "single":
      return r;
    case "multiple":
      return a;
    case "range":
      return i;
    default:
      return;
  }
}
function W0(e, t) {
  return e instanceof Zf && e.timeZone === t ? e : new Zf(e, t);
}
function F3(e, t, r) {
  return W0(e, t);
}
function FU(e, t, r) {
  return typeof e == "boolean" || typeof e == "function" ? e : e instanceof Date ? F3(e, t) : Array.isArray(e) ? e.map((a) => a instanceof Date ? F3(a, t) : a) : UM(e) ? {
    ...e,
    from: e.from ? W0(e.from, t) : e.from,
    to: e.to ? W0(e.to, t) : e.to
  } : FI(e) ? {
    before: F3(e.before, t),
    after: F3(e.after, t)
  } : WI(e) ? {
    after: F3(e.after, t)
  } : VI(e) ? {
    before: F3(e.before, t)
  } : e;
}
function _A(e, t, r) {
  return e && (Array.isArray(e) ? e.map((a) => FU(a, t)) : FU(e, t));
}
function v3t(e) {
  let t = e;
  const r = t.timeZone;
  if (r && (t = {
    ...e,
    timeZone: r
  }, t.today && (t.today = W0(t.today, r)), t.month && (t.month = W0(t.month, r)), t.defaultMonth && (t.defaultMonth = W0(t.defaultMonth, r)), t.startMonth && (t.startMonth = W0(t.startMonth, r)), t.endMonth && (t.endMonth = W0(t.endMonth, r)), t.mode === "single" && t.selected ? t.selected = W0(t.selected, r) : t.mode === "multiple" && t.selected ? t.selected = t.selected?.map((st) => W0(st, r)) : t.mode === "range" && t.selected && (t.selected = {
    from: t.selected.from ? W0(t.selected.from, r) : t.selected.from,
    to: t.selected.to ? W0(t.selected.to, r) : t.selected.to
  }), t.disabled !== void 0 && (t.disabled = _A(t.disabled, r)), t.hidden !== void 0 && (t.hidden = _A(t.hidden, r)), t.modifiers)) {
    const st = {};
    Object.keys(t.modifiers).forEach((pt) => {
      st[pt] = _A(t.modifiers?.[pt], r);
    }), t.modifiers = st;
  }
  const { components: a, formatters: i, labels: c, dateLib: d, locale: f, classNames: p } = mn(() => {
    const st = { ...Une, ...t.locale }, pt = t.broadcastCalendar ? 1 : t.weekStartsOn, bt = t.noonSafe && t.timeZone ? G4t(t.timeZone, {
      weekStartsOn: pt,
      locale: st
    }) : void 0, Nt = t.dateLib && bt ? { ...bt, ...t.dateLib } : t.dateLib ?? bt, $t = new D0({
      locale: st,
      weekStartsOn: pt,
      firstWeekContainsDate: t.firstWeekContainsDate,
      useAdditionalWeekYearTokens: t.useAdditionalWeekYearTokens,
      useAdditionalDayOfYearTokens: t.useAdditionalDayOfYearTokens,
      timeZone: t.timeZone,
      numerals: t.numerals
    }, Nt);
    return {
      dateLib: $t,
      components: M4t(t.components),
      formatters: I4t(t.formatters),
      labels: V4t(t.labels, $t.options),
      locale: st,
      classNames: { ..._I(), ...t.classNames }
    };
  }, [
    t.locale,
    t.broadcastCalendar,
    t.weekStartsOn,
    t.firstWeekContainsDate,
    t.useAdditionalWeekYearTokens,
    t.useAdditionalDayOfYearTokens,
    t.timeZone,
    t.numerals,
    t.dateLib,
    t.noonSafe,
    t.components,
    t.formatters,
    t.labels,
    t.classNames
  ]);
  t.today || (t = { ...t, today: d.today() });
  const { captionLayout: g, mode: b, navLayout: w, numberOfMonths: x = 1, onDayBlur: E, onDayClick: P, onDayFocus: k, onDayKeyDown: M, onDayMouseEnter: T, onDayMouseLeave: N, onNextClick: D, onPrevClick: $, showWeekNumber: j, styles: I } = t, { formatCaption: L, formatDay: F, formatMonthDropdown: _, formatWeekNumber: W, formatWeekNumberHeader: Q, formatWeekdayName: U, formatYearDropdown: Y } = i, G = i3t(t, d), { days: J, months: H, navStart: K, navEnd: X, previousMonth: te, nextMonth: ie, goToMonth: ee } = G, ne = P4t(J, t, K, X, d), { isSelected: ae, select: oe, selected: fe } = g3t(t, d) ?? {}, { blur: be, focused: me, isFocusTarget: De, moveFocus: Me, setFocused: ze } = u3t(t, G, ne, ae ?? (() => !1), d), { labelDayButton: le, labelGridcell: se, labelGrid: Ae, labelMonthDropdown: we, labelNav: Ne, labelPrevious: pe, labelNext: Qe, labelWeekday: Le, labelWeekNumber: Te, labelWeekNumberHeader: Oe, labelYearDropdown: ye } = c, je = mn(() => U4t(d, t.ISOWeek, t.broadcastCalendar, t.today), [d, t.ISOWeek, t.broadcastCalendar, t.today]), Ue = b !== void 0 || P !== void 0, Fe = Cn(() => {
    te && (ee(te), $?.(te));
  }, [te, ee, $]), tt = Cn(() => {
    ie && (ee(ie), D?.(ie));
  }, [ee, ie, D]), dt = Cn((st, pt) => (bt) => {
    bt.preventDefault(), bt.stopPropagation(), ze(st), !pt.disabled && (oe?.(st.date, pt, bt), P?.(st.date, pt, bt));
  }, [oe, P, ze]), St = Cn((st, pt) => (bt) => {
    ze(st), k?.(st.date, pt, bt);
  }, [k, ze]), mt = Cn((st, pt) => (bt) => {
    be(), E?.(st.date, pt, bt);
  }, [be, E]), Ot = Cn((st, pt) => (bt) => {
    const Nt = {
      ArrowLeft: [
        bt.shiftKey ? "month" : "day",
        t.dir === "rtl" ? "after" : "before"
      ],
      ArrowRight: [
        bt.shiftKey ? "month" : "day",
        t.dir === "rtl" ? "before" : "after"
      ],
      ArrowDown: [bt.shiftKey ? "year" : "week", "after"],
      ArrowUp: [bt.shiftKey ? "year" : "week", "before"],
      PageUp: [bt.shiftKey ? "year" : "month", "before"],
      PageDown: [bt.shiftKey ? "year" : "month", "after"],
      Home: ["startOfWeek", "before"],
      End: ["endOfWeek", "after"]
    };
    if (Nt[bt.key]) {
      bt.preventDefault(), bt.stopPropagation();
      const [$t, Pt] = Nt[bt.key];
      Me($t, Pt);
    }
    M?.(st.date, pt, bt);
  }, [Me, M, t.dir]), Rt = Cn((st, pt) => (bt) => {
    T?.(st.date, pt, bt);
  }, [T]), ct = Cn((st, pt) => (bt) => {
    N?.(st.date, pt, bt);
  }, [N]), it = Cn((st) => (pt) => {
    const bt = Number(pt.target.value), Nt = d.setMonth(d.startOfMonth(st), bt);
    ee(Nt);
  }, [d, ee]), Ct = Cn((st) => (pt) => {
    const bt = Number(pt.target.value), Nt = d.setYear(d.startOfMonth(st), bt);
    ee(Nt);
  }, [d, ee]), { className: ut, style: ht } = mn(() => ({
    className: [p[Fr.Root], t.className].filter(Boolean).join(" "),
    style: { ...I?.[Fr.Root], ...t.style }
  }), [p, t.className, t.style, I]), ot = O4t(t), at = It(null);
  Q4t(at, !!t.animate, {
    classNames: p,
    months: H,
    focused: me,
    dateLib: d
  });
  const ft = {
    dayPickerProps: t,
    selected: fe,
    select: oe,
    isSelected: ae,
    months: H,
    nextMonth: ie,
    previousMonth: te,
    goToMonth: ee,
    getModifiers: ne,
    components: a,
    classNames: p,
    styles: I,
    labels: c,
    formatters: i
  };
  return Re.createElement(
    Gne.Provider,
    { value: ft },
    Re.createElement(
      a.Root,
      { rootRef: t.animate ? at : void 0, className: ut, style: ht, dir: t.dir, id: t.id, lang: t.lang, nonce: t.nonce, title: t.title, role: t.role, "aria-label": t["aria-label"], "aria-labelledby": t["aria-labelledby"], ...ot },
      Re.createElement(
        a.Months,
        { className: p[Fr.Months], style: I?.[Fr.Months] },
        !t.hideNavigation && !w && Re.createElement(a.Nav, { "data-animated-nav": t.animate ? "true" : void 0, className: p[Fr.Nav], style: I?.[Fr.Nav], "aria-label": Ne(), onPreviousClick: Fe, onNextClick: tt, previousMonth: te, nextMonth: ie }),
        H.map((st, pt) => Re.createElement(
          a.Month,
          {
            "data-animated-month": t.animate ? "true" : void 0,
            className: p[Fr.Month],
            style: I?.[Fr.Month],
            // biome-ignore lint/suspicious/noArrayIndexKey: breaks animation
            key: pt,
            displayIndex: pt,
            calendarMonth: st
          },
          w === "around" && !t.hideNavigation && pt === 0 && Re.createElement(
            a.PreviousMonthButton,
            { type: "button", className: p[Fr.PreviousMonthButton], tabIndex: te ? void 0 : -1, "aria-disabled": te ? void 0 : !0, "aria-label": pe(te), onClick: Fe, "data-animated-button": t.animate ? "true" : void 0 },
            Re.createElement(a.Chevron, { disabled: te ? void 0 : !0, className: p[Fr.Chevron], orientation: t.dir === "rtl" ? "right" : "left" })
          ),
          Re.createElement(a.MonthCaption, { "data-animated-caption": t.animate ? "true" : void 0, className: p[Fr.MonthCaption], style: I?.[Fr.MonthCaption], calendarMonth: st, displayIndex: pt }, g?.startsWith("dropdown") ? Re.createElement(
            a.DropdownNav,
            { className: p[Fr.Dropdowns], style: I?.[Fr.Dropdowns] },
            (() => {
              const bt = g === "dropdown" || g === "dropdown-months" ? Re.createElement(a.MonthsDropdown, { key: "month", className: p[Fr.MonthsDropdown], "aria-label": we(), classNames: p, components: a, disabled: !!t.disableNavigation, onChange: it(st.date), options: _4t(st.date, K, X, i, d), style: I?.[Fr.Dropdown], value: d.getMonth(st.date) }) : Re.createElement("span", { key: "month" }, _(st.date, d)), Nt = g === "dropdown" || g === "dropdown-years" ? Re.createElement(a.YearsDropdown, { key: "year", className: p[Fr.YearsDropdown], "aria-label": ye(d.options), classNames: p, components: a, disabled: !!t.disableNavigation, onChange: Ct(st.date), options: X4t(K, X, i, d, !!t.reverseYears), style: I?.[Fr.Dropdown], value: d.getYear(st.date) }) : Re.createElement("span", { key: "year" }, Y(st.date, d));
              return d.getMonthYearOrder() === "year-first" ? [Nt, bt] : [bt, Nt];
            })(),
            Re.createElement("span", { role: "status", "aria-live": "polite", style: {
              border: 0,
              clip: "rect(0 0 0 0)",
              height: "1px",
              margin: "-1px",
              overflow: "hidden",
              padding: 0,
              position: "absolute",
              width: "1px",
              whiteSpace: "nowrap",
              wordWrap: "normal"
            } }, L(st.date, d.options, d))
          ) : Re.createElement(a.CaptionLabel, { className: p[Fr.CaptionLabel], role: "status", "aria-live": "polite" }, L(st.date, d.options, d))),
          w === "around" && !t.hideNavigation && pt === x - 1 && Re.createElement(
            a.NextMonthButton,
            { type: "button", className: p[Fr.NextMonthButton], tabIndex: ie ? void 0 : -1, "aria-disabled": ie ? void 0 : !0, "aria-label": Qe(ie), onClick: tt, "data-animated-button": t.animate ? "true" : void 0 },
            Re.createElement(a.Chevron, { disabled: ie ? void 0 : !0, className: p[Fr.Chevron], orientation: t.dir === "rtl" ? "left" : "right" })
          ),
          pt === x - 1 && w === "after" && !t.hideNavigation && Re.createElement(a.Nav, { "data-animated-nav": t.animate ? "true" : void 0, className: p[Fr.Nav], style: I?.[Fr.Nav], "aria-label": Ne(), onPreviousClick: Fe, onNextClick: tt, previousMonth: te, nextMonth: ie }),
          Re.createElement(
            a.MonthGrid,
            { role: "grid", "aria-multiselectable": b === "multiple" || b === "range", "aria-label": Ae(st.date, d.options, d) || void 0, className: p[Fr.MonthGrid], style: I?.[Fr.MonthGrid] },
            !t.hideWeekdays && Re.createElement(
              a.Weekdays,
              { "data-animated-weekdays": t.animate ? "true" : void 0, className: p[Fr.Weekdays], style: I?.[Fr.Weekdays] },
              j && Re.createElement(a.WeekNumberHeader, { "aria-label": Oe(d.options), className: p[Fr.WeekNumberHeader], style: I?.[Fr.WeekNumberHeader], scope: "col" }, Q()),
              je.map((bt) => Re.createElement(a.Weekday, { "aria-label": Le(bt, d.options, d), className: p[Fr.Weekday], key: String(bt), style: I?.[Fr.Weekday], scope: "col" }, U(bt, d.options, d)))
            ),
            Re.createElement(a.Weeks, { "data-animated-weeks": t.animate ? "true" : void 0, className: p[Fr.Weeks], style: I?.[Fr.Weeks] }, st.weeks.map((bt) => Re.createElement(
              a.Week,
              { className: p[Fr.Week], key: bt.weekNumber, style: I?.[Fr.Week], week: bt },
              j && Re.createElement(a.WeekNumber, { week: bt, style: I?.[Fr.WeekNumber], "aria-label": Te(bt.weekNumber, {
                locale: f
              }), className: p[Fr.WeekNumber], scope: "row", role: "rowheader" }, W(bt.weekNumber, d)),
              bt.days.map((Nt) => {
                const { date: $t } = Nt, Pt = ne(Nt);
                if (Pt[au.focused] = !Pt.hidden && !!me?.isEqualTo(Nt), Pt[I1.selected] = ae?.($t) || Pt.selected, UM(fe)) {
                  const { from: xn, to: Ut } = fe;
                  Pt[I1.range_start] = !!(xn && Ut && d.isSameDay($t, xn)), Pt[I1.range_end] = !!(xn && Ut && d.isSameDay($t, Ut)), Pt[I1.range_middle] = rS(fe, $t, !0, d);
                }
                const hn = B4t(Pt, I, t.modifiersStyles), an = k4t(Pt, p, t.modifiersClassNames), jn = !Ue && !Pt.hidden ? se($t, Pt, d.options, d) : void 0;
                return Re.createElement(a.Day, { key: `${Nt.isoDate}_${Nt.displayMonthId}`, day: Nt, modifiers: Pt, className: an.join(" "), style: hn, role: "gridcell", "aria-selected": Pt.selected || void 0, "aria-label": jn, "data-day": Nt.isoDate, "data-month": Nt.outside ? Nt.dateMonthId : void 0, "data-selected": Pt.selected || void 0, "data-disabled": Pt.disabled || void 0, "data-hidden": Pt.hidden || void 0, "data-outside": Nt.outside || void 0, "data-focused": Pt.focused || void 0, "data-today": Pt.today || void 0 }, !Pt.hidden && Ue ? Re.createElement(a.DayButton, { className: p[Fr.DayButton], style: I?.[Fr.DayButton], type: "button", day: Nt, modifiers: Pt, disabled: !Pt.focused && Pt.disabled || void 0, "aria-disabled": Pt.focused && Pt.disabled || void 0, tabIndex: De(Nt) ? 0 : -1, "aria-label": le($t, Pt, d.options, d), onClick: dt(Nt, Pt), onBlur: mt(Nt, Pt), onFocus: St(Nt, Pt), onKeyDown: Ot(Nt, Pt), onMouseEnter: Rt(Nt, Pt), onMouseLeave: ct(Nt, Pt) }, F($t, d.options, d)) : !Pt.hidden && F(Nt.date, d.options, d));
              })
            )))
          )
        ))
      ),
      t.footer && Re.createElement(a.Footer, { className: p[Fr.Footer], style: I?.[Fr.Footer], role: "status", "aria-live": "polite" }, t.footer)
    )
  );
}
const HS = fl(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground shadow-xs hover:bg-primary/90",
        destructive: "bg-destructive text-white shadow-xs hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60",
        outline: "border bg-background shadow-xs hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50",
        secondary: "bg-secondary text-secondary-foreground shadow-xs hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50",
        link: "text-primary underline-offset-4 hover:underline"
      },
      size: {
        default: "h-9 px-4 py-2 has-[>svg]:px-3",
        sm: "h-8 rounded-md gap-1.5 px-3 has-[>svg]:px-2.5",
        lg: "h-10 rounded-md px-6 has-[>svg]:px-4",
        icon: "size-9"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), b3t = fl("", {
  variants: {
    size: {
      small: ["h-[var(--input-small-height)] size-5"],
      medium: ["h-[var(--input-medium-height)] size-6"],
      large: ["h-[var(--input-large-height)] size-7"]
    }
  },
  defaultVariants: {
    size: "medium"
  }
}), y3t = fl("", {
  variants: {
    size: {
      small: ["size-3"],
      medium: ["size-3.5"],
      large: ["size-5"]
    }
  },
  defaultVariants: {
    size: "medium"
  }
});
function w3t({
  className: e,
  orientation: t,
  ...r
}) {
  return t === "left" ? /* @__PURE__ */ V.jsx(pI, { className: lt("size-4", e), ...r }) : t === "right" ? /* @__PURE__ */ V.jsx(gI, { className: lt("size-4", e), ...r }) : /* @__PURE__ */ V.jsx(cOe, { className: lt("size-4", e), ...r });
}
function S3t({
  className: e,
  day: t,
  modifiers: r,
  ...a
}) {
  const i = _I(), c = It(null);
  return Er(() => {
    r.focused && c.current?.focus();
  }, [r.focused]), /* @__PURE__ */ V.jsx(
    "button",
    {
      ref: c,
      "data-day": t.date.toLocaleDateString(),
      "data-selected-single": r.selected && !r.range_start && !r.range_end && !r.range_middle,
      "data-range-start": r.range_start,
      "data-range-end": r.range_end,
      "data-range-middle": r.range_middle,
      className: lt(
        HS({
          variant: "ghost",
          size: "icon"
        }),
        "data-[selected-single=true]:bg-primary data-[selected-single=true]:text-primary-foreground data-[range-middle=true]:bg-accent data-[range-middle=true]:text-accent-foreground data-[range-start=true]:bg-primary data-[range-start=true]:text-primary-foreground data-[range-end=true]:bg-primary data-[range-end=true]:text-primary-foreground group-data-[focused=true]/day:border-ring group-data-[focused=true]/day:ring-ring/50 dark:hover:text-accent-foreground min-w-(--cell-size) flex aspect-square size-auto w-full flex-col gap-1 font-normal leading-none data-[range-end=true]:rounded-md data-[range-middle=true]:rounded-none data-[range-start=true]:rounded-md data-[range-end=true]:rounded-r-md data-[range-start=true]:rounded-l-md group-data-[focused=true]/day:relative group-data-[focused=true]/day:z-10 group-data-[focused=true]/day:ring-[3px] [&>span]:text-xs [&>span]:opacity-70",
        "border-0 bg-transparent",
        i.day,
        e
      ),
      ...a
    }
  );
}
function C3t({
  children: e,
  className: t,
  setToday: r,
  rootRef: a,
  ...i
}) {
  const { t: c } = fi(), d = (f) => {
    r?.(/* @__PURE__ */ new Date(), /* @__PURE__ */ new Date(), {}, f);
  };
  return /* @__PURE__ */ V.jsxs(
    "div",
    {
      "data-slot": "calendar",
      ref: a,
      className: lt(t),
      ...i,
      children: [
        e,
        r && /* @__PURE__ */ V.jsx("div", { className: lt("flex justify-center"), children: /* @__PURE__ */ V.jsx(
          "button",
          {
            className: lt(
              HS({ variant: "ghost" }),
              "has-focus:border-ring border-input shadow-xs has-focus:ring-ring/50 has-focus:ring-[3px] rounded-md bg-transparent"
            ),
            onClick: d,
            children: c("datepicker.today")
          }
        ) })
      ]
    }
  );
}
function x3t({
  children: e,
  ...t
}) {
  return /* @__PURE__ */ V.jsx("td", { ...t, children: /* @__PURE__ */ V.jsx("div", { className: "size-(--cell-size) flex items-center justify-center text-center", children: e }) });
}
function E3t({
  className: e,
  classNames: t,
  showOutsideDays: r = !0,
  captionLayout: a = "label",
  buttonVariant: i = "ghost",
  formatters: c,
  components: d,
  onSelect: f,
  todayEnabled: p,
  ...g
}) {
  const b = _I(), w = Cn(
    (x) => /* @__PURE__ */ V.jsx(
      C3t,
      {
        setToday: p ? f : void 0,
        ...x
      }
    ),
    [f, p]
  );
  return /* @__PURE__ */ V.jsx(
    v3t,
    {
      showOutsideDays: r,
      className: lt(
        "bg-background group/calendar p-3 [--cell-size:--spacing(8)] [[data-slot=card-content]_&]:bg-transparent [[data-slot=popover-content]_&]:bg-transparent",
        String.raw`rtl:**:[.rdp-button\_next>svg]:rotate-180`,
        String.raw`rtl:**:[.rdp-button\_previous>svg]:rotate-180`,
        e
      ),
      captionLayout: a,
      formatters: {
        formatMonthDropdown: (x) => x.toLocaleString("default", { month: "short" }),
        ...c
      },
      classNames: {
        root: lt("w-fit", b.root),
        months: lt(
          "flex gap-4 flex-col md:flex-row relative",
          b.months
        ),
        month: lt(
          "flex flex-col w-full gap-4 justify-items-center",
          b.month
        ),
        nav: lt(
          "flex items-center gap-1 w-full absolute top-0 inset-x-0 justify-between",
          b.nav
        ),
        button_previous: lt(
          HS({ variant: i }),
          "size-(--cell-size) aria-disabled:opacity-50 p-0 select-none",
          "border-0 bg-transparent",
          b.button_previous
        ),
        button_next: lt(
          HS({ variant: i }),
          "size-(--cell-size) aria-disabled:opacity-50 p-0 select-none",
          "border-0 bg-transparent",
          b.button_next
        ),
        month_caption: lt(
          // "flex items-center justify-center h-(--cell-size) w-full px-(--cell-size)",
          "flex items-center justify-center h-(--cell-size) w-full",
          b.month_caption
        ),
        dropdowns: lt(
          "w-full flex items-center text-sm font-medium justify-center h-(--cell-size) gap-1.5",
          b.dropdowns
        ),
        dropdown_root: lt(
          "relative has-focus:border-ring border border-input shadow-xs has-focus:ring-ring/50 has-focus:ring-[3px] rounded-md",
          b.dropdown_root
        ),
        dropdown: lt("absolute inset-0 opacity-0", b.dropdown),
        caption_label: lt(
          "select-none font-medium",
          a === "label" ? "text-sm" : "rounded-md pl-2 pr-1 flex items-center gap-1 text-sm h-8 [&>svg]:text-muted-foreground [&>svg]:size-3.5",
          b.caption_label
        ),
        table: "w-full border-collapse",
        weekdays: lt("flex", b.weekdays),
        weekday: lt(
          "text-muted-foreground rounded-md flex-1 font-normal text-[0.8rem] select-none",
          b.weekday
        ),
        week: lt("flex w-full mt-2", b.week),
        week_number_header: lt(
          "select-none w-(--cell-size)",
          b.week_number_header
        ),
        week_number: lt(
          "text-[0.8rem] select-none text-muted-foreground",
          b.week_number
        ),
        day: lt(
          "relative w-full h-full p-0 text-center [&:first-child[data-selected=true]_button]:rounded-l-md [&:last-child[data-selected=true]_button]:rounded-r-md group/day aspect-square select-none",
          b.day
        ),
        range_start: lt(
          "rounded-l-md bg-accent",
          b.range_start
        ),
        range_middle: lt("rounded-none", b.range_middle),
        range_end: lt("rounded-r-md bg-accent", b.range_end),
        today: lt(
          "bg-accent text-accent-foreground rounded-md data-[selected=true]:rounded-none",
          b.today
        ),
        outside: lt(
          "text-muted-foreground aria-selected:text-muted-foreground",
          b.outside
        ),
        disabled: lt(
          "text-muted-foreground opacity-50",
          b.disabled
        ),
        hidden: lt("invisible", b.hidden),
        ...t
      },
      components: {
        Root: w,
        Chevron: w3t,
        DayButton: S3t,
        WeekNumber: x3t,
        ...d
      },
      onSelect: f,
      ...g
    }
  );
}
function sre({
  callbacks: e,
  className: t,
  disabledDates: r,
  locale: a = navigator.language,
  maxDate: i,
  minDate: c,
  onMonthSelect: d,
  onYearBackward: f,
  onYearForward: p,
  selectedMonth: g,
  variant: b,
  ...w
}) {
  const [x] = Wn(() => {
    const P = Ck(a, "short").map((k, M) => ({ number: M, name: k }));
    return [P.slice(0, 4), P.slice(4, 8), P.slice(8, 12)];
  });
  return /* @__PURE__ */ V.jsx(
    "div",
    {
      className: lt("w-[280px] min-w-[200px] p-3", t),
      ...w,
      children: /* @__PURE__ */ V.jsx("div", { className: "flex flex-col space-y-4 sm:flex-row sm:space-x-4 sm:space-y-0", children: /* @__PURE__ */ V.jsx("div", { className: "w-full space-y-4", children: /* @__PURE__ */ V.jsx(
        P3t,
        {
          callbacks: e,
          disabledDates: r,
          maxDate: i,
          minDate: c,
          months: x,
          onMonthSelect: d,
          onYearBackward: f,
          onYearForward: p,
          selectedMonth: g,
          variant: b
        }
      ) }) })
    }
  );
}
function P3t({
  callbacks: e,
  disabledDates: t,
  maxDate: r,
  minDate: a,
  months: i,
  onMonthSelect: c,
  onYearBackward: d,
  onYearForward: f,
  selectedMonth: p,
  variant: g
}) {
  const [b, w] = Wn(
    p?.getFullYear() ?? (/* @__PURE__ */ new Date()).getFullYear()
  ), [x, E] = Wn(
    p?.getMonth() ?? (/* @__PURE__ */ new Date()).getMonth()
  ), [P, k] = Wn(b);
  if (Er(() => {
    p && (E(p.getMonth()), w(p.getFullYear()), k(p.getFullYear()));
  }, [p]), a && r && a > r) {
    const T = a;
    a = r, r = T;
  }
  const M = t?.map((T) => ({ year: T.getFullYear(), month: T.getMonth() }));
  return /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
    /* @__PURE__ */ V.jsxs("div", { className: "relative flex items-center justify-center pt-1", children: [
      /* @__PURE__ */ V.jsx("div", { className: "text-sm font-medium", children: e?.yearLabel ? e?.yearLabel(P) : P }),
      /* @__PURE__ */ V.jsxs("div", { className: "flex items-center space-x-1", children: [
        /* @__PURE__ */ V.jsx(
          "button",
          {
            onClick: () => {
              k(P - 1), d && d();
            },
            className: lt(
              HS({ variant: g?.chevrons ?? "outline" }),
              "absolute left-1 inline-flex h-7 w-7 items-center justify-center p-0",
              "border-0 bg-transparent"
            ),
            children: /* @__PURE__ */ V.jsx(pI, { className: "h-4 w-4 opacity-50" })
          }
        ),
        /* @__PURE__ */ V.jsx(
          "button",
          {
            onClick: () => {
              k(P + 1), f && f();
            },
            className: lt(
              HS({ variant: g?.chevrons ?? "outline" }),
              "absolute right-1 inline-flex h-7 w-7 items-center justify-center p-0",
              "border-0 bg-transparent"
            ),
            children: /* @__PURE__ */ V.jsx(gI, { className: "h-4 w-4 opacity-50" })
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ V.jsx("table", { className: "w-full border-collapse space-y-1", children: /* @__PURE__ */ V.jsx("tbody", { children: i.map((T, N) => /* @__PURE__ */ V.jsx("tr", { className: "mt-2 flex w-full", children: T.map((D) => /* @__PURE__ */ V.jsx(
      "td",
      {
        className: "[&:has([aria-selected].day-outside)]:bg-accent/50 [&:has([aria-selected])]:bg-accent relative h-10 w-1/4 p-0 text-center text-sm focus-within:relative focus-within:z-20 first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md [&:has([aria-selected].day-range-end)]:rounded-r-md",
        children: /* @__PURE__ */ V.jsx(
          "button",
          {
            "data-day": `${KS({ date: new Date(P, D.number), format: "MM/dd/yyyy" })}`,
            onClick: () => {
              E(D.number), w(P), c && c(new Date(P, D.number));
            },
            disabled: (r ? P > r?.getFullYear() || P === r?.getFullYear() && D.number > r.getMonth() : !1) || (a ? P < a?.getFullYear() || P === a?.getFullYear() && D.number < a.getMonth() : !1) || (M ? M?.some(
              ($) => $.year === P && $.month === D.number
            ) : !1),
            className: lt(
              "border-0 bg-transparent",
              HS({
                variant: x === D.number && P === b ? g?.calendar?.selected ?? "default" : g?.calendar?.main ?? "ghost"
              }),
              "h-full w-full p-0 font-normal aria-selected:opacity-100"
            ),
            children: e?.monthLabel ? e.monthLabel(D) : D.name
          }
        )
      },
      D.number
    )) }, `row-${N}`)) }) })
  ] });
}
sre.displayName = "MonthPicker";
function k3t({
  children: e,
  dataTestId: t,
  dismissPopoverUnlessInput: r,
  format: a,
  kind: i,
  maxDate: c,
  minDate: d,
  month: f,
  onSelect: p,
  open: g,
  popoverShouldNotPullFocus: b,
  selectedDate: w,
  setMonth: x,
  setOpen: E
}) {
  const { maxDate: P, minDate: k, todayEnabled: M } = mn(() => {
    let D = !0, $;
    c && ($ = j1({ format: a, date: c }), ($?.getTime() ?? Number.POSITIVE_INFINITY < Date.now()) && (D = !1));
    let j;
    return d && (j = j1({ format: a, date: d }), (j?.getTime() ?? Number.NEGATIVE_INFINITY > Date.now()) && (D = !1)), { maxDate: $, minDate: j, todayEnabled: D };
  }, [a, c, d]), T = mn(() => {
    let D;
    P && (D = j1({ format: a, date: P }));
    let $;
    k && ($ = j1({ format: a, date: k }));
    const j = [];
    return D && j.push({ after: D }), $ && j.push({ before: $ }), j.length > 0 ? j : void 0;
  }, [a, P, k]);
  let N;
  return i === "month" ? N = /* @__PURE__ */ V.jsx(
    sre,
    {
      autoFocus: !1,
      "data-testid": `${t}-calendar`,
      maxDate: P,
      minDate: k,
      selectedMonth: w,
      onMonthSelect: p
    }
  ) : N = /* @__PURE__ */ V.jsx(
    E3t,
    {
      autoFocus: !1,
      "data-testid": `${t}-calendar`,
      disabled: T,
      mode: "single",
      selected: w,
      captionLayout: "dropdown",
      month: f,
      onMonthChange: x,
      onSelect: p,
      todayEnabled: M
    }
  ), /* @__PURE__ */ V.jsxs(
    Hne,
    {
      "data-slot": "popover",
      open: g,
      onOpenChange: E,
      "data-testid": `${t}-popover`,
      children: [
        /* @__PURE__ */ V.jsx(Fne, { "data-slot": "popover-trigger", asChild: !0, children: /* @__PURE__ */ V.jsx("span", { children: e }) }),
        /* @__PURE__ */ V.jsx(Wne, { children: /* @__PURE__ */ V.jsx(
          Vne,
          {
            "data-slot": "popover-content",
            className: lt(
              "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-(--radix-popover-content-transform-origin) outline-hidden z-50 w-72 rounded-md p-4 shadow-md",
              "w-auto overflow-hidden p-0",
              "shadow-[var(--uikit-datepicker-shadow)]"
            ),
            align: "start",
            alignOffset: -8,
            sideOffset: 10,
            onCloseAutoFocus: b,
            onFocusOutside: r,
            onInteractOutside: r,
            onOpenAutoFocus: b,
            onPointerDownOutside: r,
            children: N
          }
        ) })
      ]
    }
  );
}
function M3t({
  kind: e,
  dataTestId: t = `${e}-picker-input-${Date.now()}`,
  dateFormat: r,
  disabled: a,
  locale: i = navigator.language,
  maxDate: c,
  minDate: d,
  onFocus: f,
  onChange: p,
  onClick: g,
  onKeyUp: b,
  placeholder: w,
  returnType: x = "string",
  size: E,
  suffix: P,
  value: k,
  width: M,
  ...T
}) {
  const { t: N } = fi(), D = It(null), [$, j] = Wn(!1), [I, L] = Wn(
    uU(e, i, r)
  );
  Er(() => {
    L(uU(e, i, r));
  }, [r, e, i]);
  const [F, _] = Wn(
    R$(I)
  );
  Er(() => {
    _(R$(I));
  }, [I]);
  const [W, Q] = Wn(
    j1({ format: I, formatRegExp: F, date: k })
  ), [U, Y] = Wn(W), [G, J] = Wn(
    KS({
      format: I,
      date: W,
      fallbackValue: typeof k == "string" ? k : void 0
    })
  ), H = (me) => {
    me?.getTime() !== W?.getTime() && Q(me), (me?.getMonth() !== U?.getMonth() || me?.getFullYear() !== U?.getFullYear()) && Y(me);
  };
  Er(() => {
    const me = j1({ format: I, formatRegExp: F, date: k });
    if (H(me), me || k === "") {
      const De = KS({
        format: I,
        date: me,
        fallbackValue: G
      });
      De !== G && J(De);
    }
  }, [I, F, k]), Er(() => {
    const me = j1({ format: I, formatRegExp: F, date: G });
    H(me);
  }, [G, I, F]);
  const {
    onChange: K,
    onSelect: X,
    popoverShouldNotPullFocus: te,
    dismissPopoverUnlessInput: ie
  } = gwt({
    format: I,
    formatRegExp: F,
    inputReference: D,
    onChange: p,
    returnType: x,
    setDisplayValue: J,
    setMonth: Y,
    setOpen: j,
    setSelectedDate: Q,
    value: k
  }), { onClick: ee, onFocus: ne, onKeyUp: ae } = cwt({
    format: I,
    formatRegExp: F,
    inputReference: D,
    onChange: p,
    onClick: g,
    onFocus: f,
    onKeyUp: b,
    returnType: x,
    setOpen: j
  }), oe = mn(() => {
    const me = /* @__PURE__ */ V.jsxs(
      "button",
      {
        "data-testid": `${t}-button`,
        className: lt(
          b3t({ size: E }),
          HS({
            variant: "ghost"
          })
        ),
        type: "button",
        children: [
          /* @__PURE__ */ V.jsx(iOe, { className: y3t({ size: E }) }),
          /* @__PURE__ */ V.jsx("span", { className: "sr-only", children: N(`${e}picker.select.${e}`) })
        ]
      }
    );
    return P ? /* @__PURE__ */ V.jsxs("span", { className: lt("flex"), children: [
      P,
      me
    ] }) : me;
  }, [t, e, E, P, N]);
  let fe = "";
  try {
    fe = W?.toISOString() ?? "";
  } catch {
  }
  const be = /* @__PURE__ */ V.jsx(
    qM,
    {
      allowClear: !0,
      className: "bg-background",
      dataTestId: t,
      "data-value": fe,
      disabled: a,
      innerRef: D,
      onChange: K,
      onClick: ee,
      onFocus: ne,
      onKeyUp: ae,
      placeholder: w,
      size: E,
      suffix: oe,
      value: G,
      ...T,
      width: M ?? "100%",
      kind: "text",
      type: "text"
    }
  );
  return a ? be : /* @__PURE__ */ V.jsx(
    k3t,
    {
      kind: e,
      dataTestId: t,
      dismissPopoverUnlessInput: ie,
      format: I,
      maxDate: c,
      minDate: d,
      month: U,
      onSelect: X,
      open: $,
      popoverShouldNotPullFocus: te,
      selectedDate: W,
      setMonth: Y,
      setOpen: j,
      children: be
    }
  );
}
function BA(e, t, r) {
  if (e !== void 0)
    return t === void 0 && r === void 0 || t !== void 0 && r !== void 0 && t <= e && e <= r ? e : t !== void 0 && e < t ? t : r !== void 0 && e > r ? r : e;
}
function O3t(e, t, r, a) {
  return new Intl.NumberFormat(e, {
    style: t ? "currency" : "decimal",
    currency: t,
    currencyDisplay: t ? "code" : void 0,
    minimumFractionDigits: r,
    maximumFractionDigits: r
  }).format(a).replace(t ?? "", "").trim();
}
function T3t(e = "USD", t = "en-US") {
  const r = new Intl.NumberFormat(t, {
    style: "currency",
    currency: e,
    currencyDisplay: "narrowSymbol"
  });
  let a = "", i;
  for (const { type: c, value: d } of r.formatToParts(0))
    if (c === "currency") {
      if (a = d, i === void 0) {
        i = !0;
        break;
      }
    } else
      i = !1;
  return { symbol: a, prefix: i };
}
function ure(e) {
  const r = new Intl.NumberFormat(e).formatToParts(11111111111e-2), a = r.find(({ type: d }) => d === "decimal")?.value ?? ".", i = r.find(({ type: d }) => d === "group")?.value ?? ",", c = r.find(({ type: d }) => d === "minusSign")?.value ?? "-";
  return {
    decimal: a,
    group: i,
    negative: c
  };
}
const R3t = /[^\d.-]/g;
function W$(e, t, r = 2) {
  if (!(typeof t != "string" || t.length === 0))
    try {
      const {
        negative: a,
        group: i,
        decimal: c
      } = ure(e);
      let d = t;
      if (a && (d = d.replace(a, "-")), i && (d = d.replaceAll(
        new RegExp(`\\${i}`, "g"),
        ""
      )), c && (d = d.replaceAll(
        new RegExp(`\\${c}`, "g"),
        "."
      )), d = d.replaceAll(R3t, ""), !d)
        return;
      const [f, p] = d.split("."), g = BigInt(f);
      if (g >= Number.MAX_SAFE_INTEGER)
        return Number.MAX_SAFE_INTEGER;
      if (g <= Number.MIN_SAFE_INTEGER)
        return Number.MIN_SAFE_INTEGER;
      const b = p ? Number((+`0.${p}`).toFixed(r)) : 0, w = Number(g) + b;
      return Number.isNaN(w) ? void 0 : w;
    } catch {
      return 0;
    }
}
const WU = /[\d.-]/g, A3t = 1e3;
function N3t(e) {
  const {
    currency: t,
    enableFormatting: r,
    locale: a,
    onBlur: i,
    onChange: c,
    onlyChangeOnBlur: d,
    precision: f,
    value: p
  } = e, [g, b] = Wn(
    UA(e)
  ), w = It({ id: void 0, callback: void 0 }), x = It(null), E = It(), P = It(), k = Cn(
    /**
     * Capture the current cursor/selection position in the input before
     * programmatically setting the input.value and losing the cursor/selection position.
     * @param {string} newValue The value to display in the input
     */
    (N) => {
      const D = D3t.bind(void 0, {
        displayValue: g,
        end: P,
        inputReference: x,
        newValue: N,
        setDisplayValue: b,
        start: E
      });
      if (document.activeElement !== x.current) {
        D();
        return;
      }
      XA(w), w.current.callback = () => {
        w.current.id = void 0, w.current.callback = void 0, D();
      }, w.current.id = setTimeout(
        w.current.callback,
        A3t
      );
    },
    [g]
  );
  Er(() => {
    const N = UA({
      currency: t,
      enableFormatting: r,
      locale: a,
      precision: f,
      value: p
    });
    k(N);
  }, [t, r, a, f, p]), Er(() => {
    !x.current || E.current === void 0 && P.current === void 0 || (E.current && (x.current.selectionStart = E.current, E.current = void 0), P.current && (x.current.selectionEnd = P.current, P.current = void 0));
  }, [g]);
  const M = Cn(
    (N) => {
      XA(w);
      const { negative: D, group: $, decimal: j } = ure(a);
      if (N === D) {
        b(D);
        return;
      }
      const I = W$(
        a,
        N,
        f
      ), L = UA({
        currency: t,
        enableFormatting: r,
        locale: a,
        precision: f,
        value: I
      }), F = [...N].filter(
        (_) => `0123456789${D}${$}${j}`.includes(_)
      ).join("");
      b(F), F !== g && (k(L), !d && I !== p && c(I ?? void 0, p));
    },
    [
      t,
      g,
      r,
      a,
      c,
      d,
      f,
      k,
      p
    ]
  ), T = Cn(
    (N) => {
      w.current.id && w.current.callback && w.current.callback(), XA(w);
      const D = W$(
        a,
        g,
        f
      ), $ = typeof D == "number" ? Number(D.toFixed(f)) : void 0;
      d && $ !== p && c($ ?? void 0, p), i && i(N);
    },
    [g, a, i, c, d, f, p]
  );
  return {
    displayValue: g,
    handleBlur: T,
    handleChange: M,
    inputReference: x
  };
}
function UA({
  currency: e,
  enableFormatting: t,
  locale: r,
  precision: a,
  value: i
}) {
  return i === void 0 ? "" : t ? O3t(r, e, a, i) : i.toString();
}
function D3t({
  newValue: e,
  displayValue: t,
  inputReference: r,
  start: a,
  end: i,
  setDisplayValue: c
}) {
  const d = e.replaceAll(WU, "").length - t.replaceAll(WU, "").length;
  if (r.current) {
    const f = {
      start: r.current?.selectionStart ? r.current.selectionStart + d : void 0,
      end: r.current?.selectionEnd ? r.current.selectionEnd + d : void 0
    };
    if (a.current = f.start, i.current = f.end, e !== r.current?.value) {
      c(r.current?.value), requestAnimationFrame(() => {
        a.current = f.start, i.current = f.end, c(e);
      });
      return;
    }
  }
  c(e);
}
function XA(e) {
  e.current.id && clearTimeout(e.current.id), e.current.id = void 0, e.current.callback = void 0;
}
function $3t({
  displayValue: e,
  keyStep: t,
  locale: r,
  onChange: a,
  onKeyDown: i,
  precision: c,
  step: d,
  value: f
}) {
  return mn(() => {
    const p = (x, E) => {
      a(
        (W$(r, e, c) ?? 0) + (x ? 1 : -1) * d,
        f,
        E
      );
    };
    return {
      onStep: (x) => {
        t && (x.key === "ArrowDown" ? p(!1, x) : x.key === "ArrowUp" && p(!0, x)), i && i(x);
      },
      onStepUp: () => {
        p(!0);
      },
      onStepDown: () => {
        p(!1);
      }
    };
  }, [
    e,
    t,
    r,
    a,
    i,
    c,
    d,
    f
  ]);
}
const z3t = ({ className: e }) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    viewBox: "64 64 896 896",
    focusable: "false",
    "data-icon": "up",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    className: lt("h-[7px] w-[7px]", e),
    children: /* @__PURE__ */ V.jsx("path", { d: "M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 00140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z" })
  }
), j3t = ({ className: e }) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    viewBox: "64 64 896 896",
    focusable: "false",
    "data-icon": "down",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    className: lt("h-[7px] w-[7px]", e),
    children: /* @__PURE__ */ V.jsx("path", { d: "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z" })
  }
), VU = ({
  dataTestId: e,
  disabled: t,
  onClick: r,
  direction: a = "up"
}) => /* @__PURE__ */ V.jsx(
  "button",
  {
    tabIndex: -1,
    "data-testid": e,
    type: "button",
    className: lt(
      "flex w-full cursor-pointer items-center justify-center px-0",
      "text-tertiary border-(--input-components-color-border) border-l",
      "transition-all duration-200",
      "flex-4 hover:flex-6",
      // hover increases size to 60% using flex-grow
      a === "up" && "border-b"
    ),
    disabled: t,
    onClick: r,
    children: a === "up" ? /* @__PURE__ */ V.jsx(z3t, {}) : /* @__PURE__ */ V.jsx(j3t, {})
  }
), I3t = ({
  dataTestId: e,
  disabled: t = !1,
  onStepDown: r,
  onStepUp: a,
  size: i = "medium"
}) => /* @__PURE__ */ V.jsxs(
  "span",
  {
    className: lt(
      "bg-white",
      i === "small" && "h-[var(--input-small-height)]",
      i === "medium" && "h-[var(--input-medium-height)]",
      i === "large" && "h-[var(--input-large-height)]",
      "-mr-[var(--input-component-input-padding-x)]",
      "ml-[var(--input-component-input-padding-x)]",
      "flex w-0 flex-col opacity-0 transition-all",
      "group-hover/input:w-[var(--stepper-button-width)] group-hover/input:opacity-100"
    ),
    "data-testid": `${e}-stepper-buttons`,
    children: [
      /* @__PURE__ */ V.jsx(
        VU,
        {
          dataTestId: `${e}-step-up`,
          disabled: t,
          onClick: a,
          direction: "up"
        }
      ),
      /* @__PURE__ */ V.jsx(
        VU,
        {
          dataTestId: `${e}-step-down`,
          disabled: t,
          onClick: r,
          direction: "down"
        }
      )
    ]
  }
);
function L3t({
  controls: e = !1,
  dataTestId: t = "",
  disabled: r = !1,
  onStepDown: a,
  onStepUp: i,
  size: c = "medium",
  suffix: d
}) {
  const f = e && !r, p = !!d;
  return !f && !p ? !1 : /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
    p && /* @__PURE__ */ V.jsx("span", { className: "text-(--input-suffix-color) flex items-center", children: d }),
    f && /* @__PURE__ */ V.jsx(
      I3t,
      {
        dataTestId: `${t}-spinner-buttons`,
        disabled: r,
        onStepDown: a,
        onStepUp: i,
        size: c
      }
    )
  ] });
}
const H3t = ({
  disabled: e = !1,
  className: t,
  controls: r = !e,
  dataTestId: a = `input-number-${Date.now()}`,
  enableFormatting: i = !0,
  isError: c = !1,
  keyStep: d = !e,
  // this must be passed
  kind: f,
  locale: p = navigator.language,
  max: g,
  min: b,
  onBlur: w,
  onChange: x,
  onKeyDown: E,
  onlyChangeOnBlur: P = !1,
  placeholder: k,
  // there are currencies that use more than 2 decimal places, but this is the most common
  precision: M = f === "currency" ? 2 : 0,
  size: T,
  step: N = 1,
  suffix: D,
  value: $,
  ...j
}) => {
  const I = f === "currency" ? j.currency ?? "USD" : void 0, { symbol: L, prefix: F } = mn(() => f === "currency" ? T3t(I, p) : { symbol: void 0, prefix: void 0 }, [f, I, p]), _ = mn(() => ({ max: typeof g == "number" || f === "currency" ? g ?? 999999999999 : void 0, min: typeof b == "number" || f === "currency" ? b ?? 0 : void 0 }), [f, g, b]), [W, Q] = Wn(
    BA($, _.min, _.max)
  );
  Er(() => {
    Q(
      BA($, _.min, _.max)
    );
  }, [$, _.min, _.max]);
  const U = Cn(
    (ee, ne, ae) => {
      const oe = BA(
        ee,
        _.min,
        _.max
      );
      x?.(oe, ne, ae), Q(oe);
    },
    [x, _.min, _.max]
  ), { displayValue: Y, inputReference: G, handleBlur: J, handleChange: H } = N3t({
    currency: I,
    enableFormatting: i,
    locale: p,
    onBlur: w,
    onChange: U,
    onlyChangeOnBlur: P,
    precision: M,
    value: W
  }), { onStep: K, onStepUp: X, onStepDown: te } = $3t({
    displayValue: Y,
    keyStep: d && !e,
    locale: p,
    onChange: U,
    onKeyDown: E,
    precision: M,
    value: W,
    step: N
  }), ie = mn(() => /* @__PURE__ */ V.jsx(
    L3t,
    {
      controls: r,
      dataTestId: a,
      disabled: e,
      onStepDown: te,
      onStepUp: X,
      size: T,
      suffix: D
    }
  ), [
    r,
    a,
    e,
    te,
    X,
    T,
    D
  ]);
  return /* @__PURE__ */ V.jsx(
    qM,
    {
      addonAfter: F ? void 0 : L,
      addonBefore: F ? L : void 0,
      className: lt(t),
      "data-testid": a,
      "data-value": W,
      disabled: e,
      innerRef: G,
      inputMode: "numeric",
      isError: c,
      kind: "text",
      max: _.max,
      min: _.min,
      onBlur: J,
      onChange: H,
      onKeyDown: K,
      placeholder: k,
      size: T,
      suffix: ie,
      type: "text",
      value: Y,
      ...j
    }
  );
};
function F3t(e) {
  let t = !1, r = !1;
  const {
    nativeEvent: a = new Event("input", {
      bubbles: !0,
      cancelable: !1,
      composed: !0
    })
  } = e;
  return {
    nativeEvent: a,
    currentTarget: a.currentTarget,
    target: a.target,
    bubbles: a.bubbles ?? !0,
    cancelable: a.cancelable ?? !1,
    defaultPrevented: t,
    eventPhase: a.eventPhase ?? 0,
    isTrusted: a.isTrusted,
    preventDefault: () => (t = !0, e.preventDefault?.()),
    isDefaultPrevented: () => t,
    stopPropagation: () => {
      r = !0, e.stopPropagation?.();
    },
    isPropagationStopped: () => r,
    persist: () => {
    },
    timeStamp: a?.timeStamp ?? Date.now(),
    type: a?.type ?? "input"
  };
}
const cre = fp(
  void 0
), GM = () => {
  const e = Do(cre);
  if (!e)
    throw new Error(
      "useInputTextContext must be used within an InputTextContext.Provider"
    );
  return e;
}, W3t = fl(
  lt(
    "border border-(--input-components-color-border) leading-none",
    "flex items-center px-[11px] bg-quaternary-fill"
  ),
  {
    variants: {
      size: {
        small: "rounded-(--input-small-radius)",
        medium: "rounded-(--input-medium-radius)",
        large: "rounded-(--input-large-radius)"
      },
      position: {
        before: "rounded-r-none border-r-0",
        after: "rounded-l-none border-l-0"
      }
    },
    defaultVariants: {
      size: "medium",
      position: "before"
    }
  }
), _U = ({
  position: e = "before",
  children: t
}) => {
  const { dataTestId: r, size: a } = GM();
  return /* @__PURE__ */ V.jsx(
    "span",
    {
      className: W3t({ size: a, position: e }),
      "data-slot": e === "before" ? "addon-before" : "addon-after",
      "data-testid": `${r}-add-on-${e}`,
      children: t
    }
  );
}, V3t = () => {
  const { dataTestId: e, clearInput: t, hasSuffix: r } = GM(), { t: a } = fi();
  return /* @__PURE__ */ V.jsx(
    "button",
    {
      className: lt(
        "fill-quaternary hover:fill-tertiary active:fill-active cursor-pointer transition-colors",
        r ? "mx-[4px]" : ""
      ),
      tabIndex: -1,
      "data-slot": "clear-button",
      "data-testid": `${e}-clear`,
      "aria-label": a("input.clearButtonLabel"),
      type: "button",
      onClick: t,
      children: /* @__PURE__ */ V.jsx("span", { role: "img", "aria-label": a("input.clearButtonIconLabel"), children: /* @__PURE__ */ V.jsx(
        "svg",
        {
          fillRule: "evenodd",
          viewBox: "64 64 896 896",
          focusable: "false",
          "data-icon": "close-circle",
          "aria-hidden": "true",
          className: "h-(--input-clear-button-size) aspect-square",
          children: /* @__PURE__ */ V.jsx("path", { d: "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z" })
        }
      ) })
    }
  );
}, XI = fl(
  lt([
    "flex font-(family-name:--font-sans) overflow-hidden items-center w-full min-w-0 bg-transparent outline-none transition-all",
    "text-(--input-text-color) text-(length:--text-sm)",
    "rounded-(--input-radius)",
    [
      "border border-(--input-components-color-border)",
      "data-[disabled=false]:data-[invalid=false]:hover:border-(--input-border-hover-color)",
      "focus-within:border-(--input-border-focus-color)",
      "focus-within:border-(length:--input-border-focus-width)"
    ],
    "leading-(--input-line-height)",
    [
      "data-[disabled=true]:cursor-not-allowed",
      "data-[disabled=true]:bg-(--input-disabled-background-color)",
      "data-[disabled=true]:text-(--input-disabled-color)",
      "data-[disabled=true]:border-(--input-components-disabled-border)"
    ],
    [
      "data-[invalid=true]:text-(--input-error-text-color)",
      "data-[invalid=true]:border-(--input-error-border-color)",
      "data-[invalid=true]:data-[disabled=false]:hover:border-(--input-error-border-hover-color)",
      "data-[invalid=true]:data-[disabled=false]:bg-(--input-component-error-background-color)",
      "data-[invalid=true]:data-[disabled=true]:bg-(--input-error-background-disabled-color)"
    ]
  ]),
  {
    variants: {
      size: {
        small: [
          "h-(--input-small-height) px-(--input-component-input-padding-sm-x) text-(length:--text-xs)"
        ],
        medium: [
          "h-(--input-medium-height) px-(--input-component-input-padding-x)"
        ],
        large: [
          "h-(--input-large-height) px-(--input-component-input-padding-x)"
        ]
      },
      hasAddonBefore: {
        true: "rounded-l-none"
      },
      hasAddonAfter: {
        true: "rounded-r-none"
      },
      exceedsMaxLength: {
        true: [
          "data-[disabled=false]:text-(--input-exceeds-max-length-color)",
          "data-[disabled=true]:text-(--input-placeholder-color)"
        ]
      },
      theme: {
        apollo: [],
        classic: ["bg-(--input-background-color)"]
      }
    },
    defaultVariants: {
      size: "medium",
      theme: "classic"
    }
  }
), _3t = () => {
  const { dataTestId: e, suffix: t, showClearButton: r } = GM();
  return /* @__PURE__ */ V.jsxs(
    "span",
    {
      "data-slot": "suffix",
      className: "ml-[4px] flex h-full items-center",
      "data-testid": `${e}-suffix`,
      children: [
        r && /* @__PURE__ */ V.jsx(V3t, {}),
        t
      ]
    }
  );
}, B3t = ({
  children: e
}) => /* @__PURE__ */ V.jsx("span", { "data-slot": "prefix", className: "mr-[4px] flex items-center", children: e }), U3t = () => {
  const {
    className: e,
    dataTestId: t,
    disabled: r,
    hasAddonBefore: a,
    hasAddonAfter: i,
    inputRef: c,
    internalValue: d,
    isError: f,
    kind: p,
    maxLength: g,
    prefix: b,
    shouldShowSuffix: w,
    size: x,
    theme: E,
    type: P,
    remainingProps: k
  } = GM(), M = k["data-pseudo"], T = g ? d?.length > g : !1;
  return /* @__PURE__ */ V.jsxs(
    "span",
    {
      "data-invalid": f,
      "data-slot": "input-wrapper",
      "data-disabled": r,
      className: lt(
        XI({
          size: x,
          hasAddonBefore: a,
          hasAddonAfter: i,
          exceedsMaxLength: T,
          theme: E
        }),
        e
      ),
      "data-pseudo": M,
      children: [
        b && /* @__PURE__ */ V.jsx(B3t, { children: b }),
        /* @__PURE__ */ V.jsx(
          "input",
          {
            ref: c,
            value: d,
            type: P ?? p,
            "data-slot": "input",
            className: lt(
              "placeholder:text-(--input-placeholder-color) min-w-0 flex-1 outline-none",
              "disabled:pointer-events-none [&::-webkit-search-cancel-button]:hidden"
            ),
            "aria-invalid": f,
            "data-testid": t,
            disabled: r,
            ...k
          }
        ),
        w && /* @__PURE__ */ V.jsx(_3t, {})
      ]
    }
  );
};
function qM({
  addonAfter: e,
  addonBefore: t,
  allowClear: r = !1,
  className: a,
  dataTestId: i = `input-text-${Date.now()}`,
  disabled: c = !1,
  kind: d,
  innerRef: f,
  isError: p = !1,
  maxLength: g,
  onBlur: b,
  onBeforeInput: w,
  onChange: x,
  onlyChangeOnBlur: E = !1,
  prefix: P,
  size: k = "medium",
  suffix: M,
  theme: T,
  type: N,
  value: D,
  width: $,
  defaultValue: j = "",
  filter: I,
  ...L
}) {
  const F = D !== void 0, _ = F ? D ?? "" : void 0, [W, Q] = Wn(
    () => F ? _ : j ?? ""
  ), U = It({
    beforeStart: 0,
    beforeEnd: 0
  }), Y = It(null), G = f || Y, J = Do(Kj), H = T ?? J, [K, X] = Wn(), te = Cn(
    (ae) => {
      w?.(ae);
      const oe = ae.data ?? "";
      if (I && oe !== I(oe)) {
        ae.preventDefault();
        return;
      }
    },
    [I, w]
  ), ie = Cn(
    (ae) => {
      b?.(ae), E && K && (x?.(...K), X(void 0));
    },
    [K, E, b, x]
  ), ee = Cn(
    (ae) => {
      const oe = ae.currentTarget.value;
      if (g && oe.length > g) {
        ae.preventDefault();
        return;
      }
      const fe = ae.target.selectionStart ?? 0, be = ae.target.selectionEnd ?? 0;
      U.current = {
        beforeStart: fe,
        beforeEnd: be
      };
      const me = F ? _ : W;
      FS(() => {
        Q(oe), x && !E ? x(oe, me, ae) : E && X([oe, me, ae]);
      }), G.current && G.current.setSelectionRange(fe, be);
    },
    [
      F,
      _,
      W,
      g,
      x,
      E,
      G
    ]
  ), ne = Cn(() => {
    Q("");
    let ae;
    if (G.current) {
      G.current.value = "";
      const fe = {
        ...new Event("input", {
          bubbles: !0,
          cancelable: !1,
          composed: !0
        })
      };
      fe.target = G.current, fe.currentTarget = G.current, ae = F3t({ nativeEvent: fe });
    }
    const oe = F ? _ : W;
    E ? X(["", oe, ae]) : x?.("", oe, ae);
  }, [
    F,
    _,
    W,
    G,
    E,
    x
  ]);
  return zS(() => {
    if (F && W !== _ && (Q(_), G.current)) {
      const { beforeStart: ae, beforeEnd: oe } = U.current, fe = W.length - _.length;
      if (fe > 0) {
        const be = Math.max(0, ae - fe), me = Math.max(0, oe - fe);
        requestAnimationFrame(() => {
          G.current && G.current.setSelectionRange(
            be,
            me
          );
        });
      }
    }
  }, [_, F, W, G]), /* @__PURE__ */ V.jsx(
    cre.Provider,
    {
      value: {
        className: a,
        clearInput: ne,
        dataTestId: i,
        disabled: c,
        hasAddonAfter: !!e,
        hasAddonBefore: !!t,
        hasSuffix: !!M,
        inputRef: G,
        internalValue: W,
        isError: p,
        kind: d,
        maxLength: g,
        prefix: P,
        shouldShowSuffix: !!M || r && !!W,
        showClearButton: r && !!W && !c,
        size: k,
        suffix: M,
        theme: H,
        type: N,
        width: $,
        remainingProps: {
          ...L,
          onBeforeInput: te,
          onBlur: ie,
          onChange: ee
        }
      },
      children: /* @__PURE__ */ V.jsx(
        "div",
        {
          "data-preflight": !0,
          className: "contents",
          "data-testid": `${i}-container`,
          children: /* @__PURE__ */ V.jsxs(
            "div",
            {
              className: lt(
                "group/input font-(family-name:--font-sans) flex",
                k === "small" && "h-(--input-small-height) text-(length:--text-xs)",
                k === "medium" && "h-(--input-medium-height)",
                k === "large" && "h-(--input-large-height)",
                a
              ),
              style: { width: $ },
              children: [
                t && /* @__PURE__ */ V.jsx(_U, { position: "before", children: t }),
                /* @__PURE__ */ V.jsx(U3t, {}),
                e && /* @__PURE__ */ V.jsx(_U, { position: "after", children: e })
              ]
            }
          )
        }
      )
    }
  );
}
const X3t = ({
  suffix: e,
  type: t = "password",
  // pull type out of rest
  ...r
}) => {
  const [a, i] = Wn(!1), c = () => i((d) => !d);
  return /* @__PURE__ */ V.jsx(
    qM,
    {
      type: a ? "text" : t,
      suffix: /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
        e,
        /* @__PURE__ */ V.jsx(
          _f,
          {
            className: "cursor-pointer",
            name: a ? "eyeOutlined" : "eyeCrossedOutOutlined",
            onClick: c
          }
        )
      ] }),
      ...r
    }
  );
}, dre = fl(["flex items-center"], {
  variants: {
    size: {
      small: ["h-[var(--input-small-height)]"],
      medium: ["h-[var(--input-medium-height)]"],
      large: ["h-[var(--input-large-height)]"]
    }
  },
  defaultVariants: {
    size: "medium"
  }
}), fre = fl(
  lt(
    "flex size-[var(--input-radio-size)] rounded-full aspect-square",
    "shadow-black shadow-[0_2px_10px] outline-none focus:shadow-[0_0_0_2px] focus:shadow-(color:--input-radio-active-color)",
    "cursor-default bg-[var(--input-radio-color)] hover:bg-[var(--input-radio-hover-color)]"
  ),
  {
    variants: {
      disabled: {
        true: "cursor-not-allowed opacity-50 bg-[var(--input-radio-disabled-color)] hover:bg-[var(--input-radio-disabled-color)]",
        false: ""
      },
      isError: {
        true: [
          "data-invalid",
          "bg-[var(--input-error-border-color)] hover:bg-[var(--input-error-border-hover-color)]"
        ],
        false: ["data-valid", "border-[var(--input-border-hover-color)]"]
      }
    },
    compoundVariants: [
      {
        disabled: !0,
        isError: !0,
        class: "hover:bg-[var(--input-error-border-color)]"
      }
    ],
    defaultVariants: {
      disabled: !1,
      isError: !1
    }
  }
), mre = fl(
  lt(
    "relative flex items-center justify-center after:block after:size-[var(--input-radio-indicator-size)] after:rounded-full after:bg-[var(--input-radio-indicator-color)]",
    "size-full"
  )
), hre = fl(
  lt("block pl-[15px] text-[15px] leading-none"),
  {
    variants: {
      disabled: {
        true: "opacity-50",
        false: ""
      }
    },
    defaultVariants: {
      disabled: !1
    }
  }
);
function G3t({
  checked: e,
  value: t,
  dataTestId: r = `radio-${Date.now()}`,
  disabled: a,
  id: i = r,
  isError: c,
  label: d,
  name: f,
  onChange: p,
  onClick: g,
  size: b
}) {
  const w = (k) => {
    g && g(k), p && p(e ? "" : t, t);
  }, x = e ? "checked" : "unchecked", E = `${r}-option-${t}`, P = /* @__PURE__ */ V.jsx(
    "button",
    {
      "aria-checked": e,
      className: lt(
        fre({
          disabled: a,
          isError: c
        })
      ),
      "data-orientation": "vertical",
      "data-radix-collection-item": "",
      "data-state": x,
      "data-testid": `${r}-option-${t}`,
      id: i,
      name: f,
      onClick: w,
      role: "radio",
      type: "button",
      tabIndex: 0,
      value: t,
      children: e && /* @__PURE__ */ V.jsx(
        "span",
        {
          "data-state": x,
          className: mre(),
          "data-testid": `${E}-indicator`
        }
      )
    }
  );
  return d ? /* @__PURE__ */ V.jsx("span", { "data-preflight": !0, className: "contents", children: /* @__PURE__ */ V.jsxs("div", { className: dre({ size: b }), children: [
    P,
    d && /* @__PURE__ */ V.jsx("label", { className: hre({ disabled: a }), htmlFor: i, children: d })
  ] }) }) : /* @__PURE__ */ V.jsx("span", { "data-preflight": !0, className: "contents", children: P });
}
function GI(e) {
  const t = e + "CollectionProvider", [r, a] = Eb(t), [i, c] = r(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), d = (k) => {
    const { scope: M, children: T } = k, N = Re.useRef(null), D = Re.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ V.jsx(i, { scope: M, itemMap: D, collectionRef: N, children: T });
  };
  d.displayName = t;
  const f = e + "CollectionSlot", p = /* @__PURE__ */ IE(f), g = Re.forwardRef(
    (k, M) => {
      const { scope: T, children: N } = k, D = c(f, T), $ = Wl(M, D.collectionRef);
      return /* @__PURE__ */ V.jsx(p, { ref: $, children: N });
    }
  );
  g.displayName = f;
  const b = e + "CollectionItemSlot", w = "data-radix-collection-item", x = /* @__PURE__ */ IE(b), E = Re.forwardRef(
    (k, M) => {
      const { scope: T, children: N, ...D } = k, $ = Re.useRef(null), j = Wl(M, $), I = c(b, T);
      return Re.useEffect(() => (I.itemMap.set($, { ref: $, ...D }), () => void I.itemMap.delete($))), /* @__PURE__ */ V.jsx(x, { [w]: "", ref: j, children: N });
    }
  );
  E.displayName = b;
  function P(k) {
    const M = c(e + "CollectionConsumer", k);
    return Re.useCallback(() => {
      const N = M.collectionRef.current;
      if (!N) return [];
      const D = Array.from(N.querySelectorAll(`[${w}]`));
      return Array.from(M.itemMap.values()).sort(
        (I, L) => D.indexOf(I.ref.current) - D.indexOf(L.ref.current)
      );
    }, [M.collectionRef, M.itemMap]);
  }
  return [
    { Provider: d, Slot: g, ItemSlot: E },
    P,
    a
  ];
}
var q3t = S.createContext(void 0);
function qI(e) {
  const t = S.useContext(q3t);
  return e || t || "ltr";
}
var GA = "rovingFocusGroup.onEntryFocus", K3t = { bubbles: !1, cancelable: !0 }, S7 = "RovingFocusGroup", [V$, pre, Y3t] = GI(S7), [Q3t, gre] = Eb(
  S7,
  [Y3t]
), [J3t, Z3t] = Q3t(S7), vre = S.forwardRef(
  (e, t) => /* @__PURE__ */ V.jsx(V$.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ V.jsx(V$.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ V.jsx(ext, { ...e, ref: t }) }) })
);
vre.displayName = S7;
var ext = S.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: r,
    orientation: a,
    loop: i = !1,
    dir: c,
    currentTabStopId: d,
    defaultCurrentTabStopId: f,
    onCurrentTabStopIdChange: p,
    onEntryFocus: g,
    preventScrollOnEntryFocus: b = !1,
    ...w
  } = e, x = S.useRef(null), E = Wl(t, x), P = qI(c), [k, M] = iC({
    prop: d,
    defaultProp: f ?? null,
    onChange: p,
    caller: S7
  }), [T, N] = S.useState(!1), D = rp(g), $ = pre(r), j = S.useRef(!1), [I, L] = S.useState(0);
  return S.useEffect(() => {
    const F = x.current;
    if (F)
      return F.addEventListener(GA, D), () => F.removeEventListener(GA, D);
  }, [D]), /* @__PURE__ */ V.jsx(
    J3t,
    {
      scope: r,
      orientation: a,
      dir: P,
      loop: i,
      currentTabStopId: k,
      onItemFocus: S.useCallback(
        (F) => M(F),
        [M]
      ),
      onItemShiftTab: S.useCallback(() => N(!0), []),
      onFocusableItemAdd: S.useCallback(
        () => L((F) => F + 1),
        []
      ),
      onFocusableItemRemove: S.useCallback(
        () => L((F) => F - 1),
        []
      ),
      children: /* @__PURE__ */ V.jsx(
        Ro.div,
        {
          tabIndex: T || I === 0 ? -1 : 0,
          "data-orientation": a,
          ...w,
          ref: E,
          style: { outline: "none", ...e.style },
          onMouseDown: io(e.onMouseDown, () => {
            j.current = !0;
          }),
          onFocus: io(e.onFocus, (F) => {
            const _ = !j.current;
            if (F.target === F.currentTarget && _ && !T) {
              const W = new CustomEvent(GA, K3t);
              if (F.currentTarget.dispatchEvent(W), !W.defaultPrevented) {
                const Q = $().filter((H) => H.focusable), U = Q.find((H) => H.active), Y = Q.find((H) => H.id === k), J = [U, Y, ...Q].filter(
                  Boolean
                ).map((H) => H.ref.current);
                wre(J, b);
              }
            }
            j.current = !1;
          }),
          onBlur: io(e.onBlur, () => N(!1))
        }
      )
    }
  );
}), bre = "RovingFocusGroupItem", yre = S.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: r,
      focusable: a = !0,
      active: i = !1,
      tabStopId: c,
      children: d,
      ...f
    } = e, p = T0(), g = c || p, b = Z3t(bre, r), w = b.currentTabStopId === g, x = pre(r), { onFocusableItemAdd: E, onFocusableItemRemove: P, currentTabStopId: k } = b;
    return S.useEffect(() => {
      if (a)
        return E(), () => P();
    }, [a, E, P]), /* @__PURE__ */ V.jsx(
      V$.ItemSlot,
      {
        scope: r,
        id: g,
        focusable: a,
        active: i,
        children: /* @__PURE__ */ V.jsx(
          Ro.span,
          {
            tabIndex: w ? 0 : -1,
            "data-orientation": b.orientation,
            ...f,
            ref: t,
            onMouseDown: io(e.onMouseDown, (M) => {
              a ? b.onItemFocus(g) : M.preventDefault();
            }),
            onFocus: io(e.onFocus, () => b.onItemFocus(g)),
            onKeyDown: io(e.onKeyDown, (M) => {
              if (M.key === "Tab" && M.shiftKey) {
                b.onItemShiftTab();
                return;
              }
              if (M.target !== M.currentTarget) return;
              const T = rxt(M, b.orientation, b.dir);
              if (T !== void 0) {
                if (M.metaKey || M.ctrlKey || M.altKey || M.shiftKey) return;
                M.preventDefault();
                let D = x().filter(($) => $.focusable).map(($) => $.ref.current);
                if (T === "last") D.reverse();
                else if (T === "prev" || T === "next") {
                  T === "prev" && D.reverse();
                  const $ = D.indexOf(M.currentTarget);
                  D = b.loop ? axt(D, $ + 1) : D.slice($ + 1);
                }
                setTimeout(() => wre(D));
              }
            }),
            children: typeof d == "function" ? d({ isCurrentTabStop: w, hasTabStop: k != null }) : d
          }
        )
      }
    );
  }
);
yre.displayName = bre;
var txt = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function nxt(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function rxt(e, t, r) {
  const a = nxt(e.key, r);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(a)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(a)))
    return txt[a];
}
function wre(e, t = !1) {
  const r = document.activeElement;
  for (const a of e)
    if (a === r || (a.focus({ preventScroll: t }), document.activeElement !== r)) return;
}
function axt(e, t) {
  return e.map((r, a) => e[(t + a) % e.length]);
}
var oxt = vre, ixt = yre, KI = "Radio", [lxt, Sre] = Eb(KI), [sxt, uxt] = lxt(KI), Cre = S.forwardRef(
  (e, t) => {
    const {
      __scopeRadio: r,
      name: a,
      checked: i = !1,
      required: c,
      disabled: d,
      value: f = "on",
      onCheck: p,
      form: g,
      ...b
    } = e, [w, x] = S.useState(null), E = Wl(t, (M) => x(M)), P = S.useRef(!1), k = w ? g || !!w.closest("form") : !0;
    return /* @__PURE__ */ V.jsxs(sxt, { scope: r, checked: i, disabled: d, children: [
      /* @__PURE__ */ V.jsx(
        Ro.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": i,
          "data-state": kre(i),
          "data-disabled": d ? "" : void 0,
          disabled: d,
          value: f,
          ...b,
          ref: E,
          onClick: io(e.onClick, (M) => {
            i || p?.(), k && (P.current = M.isPropagationStopped(), P.current || M.stopPropagation());
          })
        }
      ),
      k && /* @__PURE__ */ V.jsx(
        Pre,
        {
          control: w,
          bubbles: !P.current,
          name: a,
          value: f,
          checked: i,
          required: c,
          disabled: d,
          form: g,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
Cre.displayName = KI;
var xre = "RadioIndicator", Ere = S.forwardRef(
  (e, t) => {
    const { __scopeRadio: r, forceMount: a, ...i } = e, c = uxt(xre, r);
    return /* @__PURE__ */ V.jsx(X0, { present: a || c.checked, children: /* @__PURE__ */ V.jsx(
      Ro.span,
      {
        "data-state": kre(c.checked),
        "data-disabled": c.disabled ? "" : void 0,
        ...i,
        ref: t
      }
    ) });
  }
);
Ere.displayName = xre;
var cxt = "RadioBubbleInput", Pre = S.forwardRef(
  ({
    __scopeRadio: e,
    control: t,
    checked: r,
    bubbles: a = !0,
    ...i
  }, c) => {
    const d = S.useRef(null), f = Wl(d, c), p = NM(r), g = DM(t);
    return S.useEffect(() => {
      const b = d.current;
      if (!b) return;
      const w = window.HTMLInputElement.prototype, E = Object.getOwnPropertyDescriptor(
        w,
        "checked"
      ).set;
      if (p !== r && E) {
        const P = new Event("click", { bubbles: a });
        E.call(b, r), b.dispatchEvent(P);
      }
    }, [p, r, a]), /* @__PURE__ */ V.jsx(
      Ro.input,
      {
        type: "radio",
        "aria-hidden": !0,
        defaultChecked: r,
        ...i,
        tabIndex: -1,
        ref: f,
        style: {
          ...i.style,
          ...g,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
Pre.displayName = cxt;
function kre(e) {
  return e ? "checked" : "unchecked";
}
var dxt = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], KM = "RadioGroup", [fxt] = Eb(KM, [
  gre,
  Sre
]), Mre = gre(), Ore = Sre(), [mxt, hxt] = fxt(KM), Tre = S.forwardRef(
  (e, t) => {
    const {
      __scopeRadioGroup: r,
      name: a,
      defaultValue: i,
      value: c,
      required: d = !1,
      disabled: f = !1,
      orientation: p,
      dir: g,
      loop: b = !0,
      onValueChange: w,
      ...x
    } = e, E = Mre(r), P = qI(g), [k, M] = iC({
      prop: c,
      defaultProp: i ?? null,
      onChange: w,
      caller: KM
    });
    return /* @__PURE__ */ V.jsx(
      mxt,
      {
        scope: r,
        name: a,
        required: d,
        disabled: f,
        value: k,
        onValueChange: M,
        children: /* @__PURE__ */ V.jsx(
          oxt,
          {
            asChild: !0,
            ...E,
            orientation: p,
            dir: P,
            loop: b,
            children: /* @__PURE__ */ V.jsx(
              Ro.div,
              {
                role: "radiogroup",
                "aria-required": d,
                "aria-orientation": p,
                "data-disabled": f ? "" : void 0,
                dir: P,
                ...x,
                ref: t
              }
            )
          }
        )
      }
    );
  }
);
Tre.displayName = KM;
var Rre = "RadioGroupItem", Are = S.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: r, disabled: a, ...i } = e, c = hxt(Rre, r), d = c.disabled || a, f = Mre(r), p = Ore(r), g = S.useRef(null), b = Wl(t, g), w = c.value === i.value, x = S.useRef(!1);
    return S.useEffect(() => {
      const E = (k) => {
        dxt.includes(k.key) && (x.current = !0);
      }, P = () => x.current = !1;
      return document.addEventListener("keydown", E), document.addEventListener("keyup", P), () => {
        document.removeEventListener("keydown", E), document.removeEventListener("keyup", P);
      };
    }, []), /* @__PURE__ */ V.jsx(
      ixt,
      {
        asChild: !0,
        ...f,
        focusable: !d,
        active: w,
        children: /* @__PURE__ */ V.jsx(
          Cre,
          {
            disabled: d,
            required: c.required,
            checked: w,
            ...p,
            ...i,
            name: c.name,
            ref: b,
            onCheck: () => c.onValueChange(i.value),
            onKeyDown: io((E) => {
              E.key === "Enter" && E.preventDefault();
            }),
            onFocus: io(i.onFocus, () => {
              x.current && g.current?.click();
            })
          }
        )
      }
    );
  }
);
Are.displayName = Rre;
var pxt = "RadioGroupIndicator", Nre = S.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: r, ...a } = e, i = Ore(r);
    return /* @__PURE__ */ V.jsx(Ere, { ...i, ...a, ref: t });
  }
);
Nre.displayName = pxt;
var gxt = Tre, Dre = Are, vxt = Nre;
function bxt({
  dataTestId: e,
  disabled: t,
  id: r,
  isError: a,
  label: i,
  size: c,
  value: d
}) {
  return /* @__PURE__ */ V.jsxs("div", { className: lt(dre({ size: c })), "data-slot": "radio-option", children: [
    /* @__PURE__ */ V.jsx(
      Dre,
      {
        className: lt(
          fre({
            disabled: t,
            isError: a
          })
        ),
        "data-testid": e,
        disabled: t,
        id: r,
        tabIndex: 0,
        value: d.toString(),
        children: /* @__PURE__ */ V.jsx(
          vxt,
          {
            className: mre(),
            "data-testid": `${e}-option-${d}-indicator`
          }
        )
      }
    ),
    /* @__PURE__ */ V.jsx("label", { className: hre({ disabled: t }), htmlFor: r, children: i })
  ] });
}
const yxt = fl(
  lt(
    "border border-gray-300 grow m-0 cursor-pointer outline-none bg-white",
    "data-[state=checked]:shadow-[0_0_0_1.5px] data-[state=checked]:shadow-black data-[state=checked]:z-1",
    "bg-white"
  ),
  {
    variants: {
      direction: {
        horizontal: [],
        vertical: []
      },
      disabled: {
        true: "cursor-not-allowed opacity-50 bg-[var(--input-disabled-background-color)]",
        false: "hover:bg-gray-200"
      },
      isError: {
        true: [
          "bg-[var(--input-error-border-color)] hover:bg-[var(--input-error-border-hover-color)]"
        ],
        false: []
      },
      size: {
        small: ["h-[var(--input-small-height)]"],
        medium: ["h-[var(--input-medium-height)]"],
        large: ["h-[var(--input-large-height)]"]
      }
    },
    compoundVariants: [
      {
        disabled: !0,
        isError: !0,
        class: "hover:bg-[var(--input-error-border-color)]"
      },
      {
        direction: "horizontal",
        size: "small",
        class: "first:rounded-l[var(--input-small-radius)] last:rounded-r[var(--input-small-radius)]"
      },
      {
        direction: "horizontal",
        size: "medium",
        class: "first:rounded-l-[var(--input-medium-radius)] last:rounded-r-[var(--input-medium-radius)]"
      },
      {
        direction: "horizontal",
        size: "large",
        class: "first:rounded-l-[var(--input-large-radius)] last:rounded-r-[var(--input-large-radius)]"
      },
      {
        direction: "vertical",
        size: "small",
        class: "first:rounded-t-[var(--input-small-radius)] last:rounded-b-[var(--input-small-radius)]"
      },
      {
        direction: "vertical",
        size: "medium",
        class: "first:rounded-t-[var(--input-medium-radius)] last:rounded-b-[var(--input-medium-radius)]"
      },
      {
        direction: "vertical",
        size: "large",
        class: "first:rounded-t-[var(--input-large-radius)] last:rounded-b-[var(--input-large-radius)]"
      }
    ],
    defaultVariants: {
      size: "medium"
    }
  }
);
function wxt({
  dataTestId: e,
  direction: t,
  disabled: r,
  end: a,
  id: i,
  isError: c,
  label: d,
  onClick: f,
  size: p,
  start: g,
  value: b
}) {
  return /* @__PURE__ */ V.jsx(
    Dre,
    {
      className: lt(
        yxt({
          direction: t,
          disabled: r,
          isError: c,
          size: p
        })
      ),
      "data-end": a,
      "data-slot": "radio-option",
      "data-start": g,
      "data-testid": e,
      disabled: r,
      id: i,
      onClick: f,
      tabIndex: 0,
      value: b.toString(),
      children: d
    }
  );
}
const Sxt = fl(lt("flex"), {
  variants: {
    direction: {
      horizontal: ["flex-row"],
      vertical: ["flex-col"]
    },
    size: {
      small: ["rounded-[var(--input-small-radius)]"],
      medium: ["rounded-[var(--input-medium-radius)]"],
      large: ["rounded-[var(--input-large-radius)]"]
    },
    displayType: {
      default: ["gap-2.5"],
      button: ["shadow-gray-300 shadow-[0_2px_3px]"]
    }
  },
  defaultVariants: {
    direction: "vertical",
    displayType: "default"
  }
}), Cxt = ({
  dataTestId: e = `radio-group-${Date.now()}`,
  displayType: t = "default",
  direction: r = t === "button" ? "horizontal" : "vertical",
  disabled: a = !1,
  id: i = e,
  isError: c,
  onChange: d,
  options: f,
  size: p = "medium",
  value: g,
  ...b
}) => {
  const [w, x] = Wn(g);
  Er(() => {
    x(g);
  }, [g]);
  const E = Cn(
    (k) => {
      x(k), d && d(k, w);
    },
    [d, w]
  ), P = mn(() => JSON.stringify(f), [f]);
  return /* @__PURE__ */ V.jsx("span", { "data-preflight": !0, className: "contents", children: /* @__PURE__ */ V.jsx(
    gxt,
    {
      className: lt(Sxt({ direction: r, displayType: t, size: p })),
      "data-options": P,
      "data-testid": e,
      "data-value": w,
      disabled: a,
      id: i,
      orientation: r,
      value: w,
      onValueChange: E,
      ...b,
      children: f?.map(
        ({ disabled: k, label: M, value: T }, N) => {
          const D = T.toString(), $ = {
            ...b,
            dataTestId: `${e}-option-${T}`,
            direction: r,
            disabled: k ?? a,
            end: N === f.length - 1,
            id: `${i}-option-${T}`,
            isError: c,
            label: M,
            size: p,
            start: N === 0,
            value: T.toString()
          };
          return t === "button" ? /* @__PURE__ */ V.jsx(wxt, { ...$ }, D) : /* @__PURE__ */ V.jsx(bxt, { ...$ }, D);
        }
      )
    }
  ) });
};
var BU = 1, xxt = 0.9, Ext = 0.8, Pxt = 0.17, qA = 0.1, KA = 0.999, kxt = 0.9999, Mxt = 0.99, Oxt = /[\\\/_+.#"@\[\(\{&]/, Txt = /[\\\/_+.#"@\[\(\{&]/g, Rxt = /[\s-]/, $re = /[\s-]/g;
function _$(e, t, r, a, i, c, d) {
  if (c === t.length) return i === e.length ? BU : Mxt;
  var f = `${i},${c}`;
  if (d[f] !== void 0) return d[f];
  for (var p = a.charAt(c), g = r.indexOf(p, i), b = 0, w, x, E, P; g >= 0; ) w = _$(e, t, r, a, g + 1, c + 1, d), w > b && (g === i ? w *= BU : Oxt.test(e.charAt(g - 1)) ? (w *= Ext, E = e.slice(i, g - 1).match(Txt), E && i > 0 && (w *= Math.pow(KA, E.length))) : Rxt.test(e.charAt(g - 1)) ? (w *= xxt, P = e.slice(i, g - 1).match($re), P && i > 0 && (w *= Math.pow(KA, P.length))) : (w *= Pxt, i > 0 && (w *= Math.pow(KA, g - i))), e.charAt(g) !== t.charAt(c) && (w *= kxt)), (w < qA && r.charAt(g - 1) === a.charAt(c + 1) || a.charAt(c + 1) === a.charAt(c) && r.charAt(g - 1) !== a.charAt(c)) && (x = _$(e, t, r, a, g + 1, c + 2, d), x * qA > w && (w = x * qA)), w > b && (b = w), g = r.indexOf(p, g + 1);
  return d[f] = b, b;
}
function UU(e) {
  return e.toLowerCase().replace($re, " ");
}
function Axt(e, t, r) {
  return e = r && r.length > 0 ? `${e + " " + r.join(" ")}` : e, _$(e, t, UU(e), UU(t), 0, 0, {});
}
var YM = "Dialog", [zre] = Eb(YM), [Nxt, Q1] = zre(YM), jre = (e) => {
  const {
    __scopeDialog: t,
    children: r,
    open: a,
    defaultOpen: i,
    onOpenChange: c,
    modal: d = !0
  } = e, f = S.useRef(null), p = S.useRef(null), [g, b] = iC({
    prop: a,
    defaultProp: i ?? !1,
    onChange: c,
    caller: YM
  });
  return /* @__PURE__ */ V.jsx(
    Nxt,
    {
      scope: t,
      triggerRef: f,
      contentRef: p,
      contentId: T0(),
      titleId: T0(),
      descriptionId: T0(),
      open: g,
      onOpenChange: b,
      onOpenToggle: S.useCallback(() => b((w) => !w), [b]),
      modal: d,
      children: r
    }
  );
};
jre.displayName = YM;
var Ire = "DialogTrigger", Dxt = S.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...a } = e, i = Q1(Ire, r), c = Wl(t, i.triggerRef);
    return /* @__PURE__ */ V.jsx(
      Ro.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": i.open,
        "aria-controls": i.contentId,
        "data-state": JI(i.open),
        ...a,
        ref: c,
        onClick: io(e.onClick, i.onOpenToggle)
      }
    );
  }
);
Dxt.displayName = Ire;
var YI = "DialogPortal", [$xt, Lre] = zre(YI, {
  forceMount: void 0
}), Hre = (e) => {
  const { __scopeDialog: t, forceMount: r, children: a, container: i } = e, c = Q1(YI, t);
  return /* @__PURE__ */ V.jsx($xt, { scope: t, forceMount: r, children: S.Children.map(a, (d) => /* @__PURE__ */ V.jsx(X0, { present: r || c.open, children: /* @__PURE__ */ V.jsx(II, { asChild: !0, container: i, children: d }) })) });
};
Hre.displayName = YI;
var d9 = "DialogOverlay", Fre = S.forwardRef(
  (e, t) => {
    const r = Lre(d9, e.__scopeDialog), { forceMount: a = r.forceMount, ...i } = e, c = Q1(d9, e.__scopeDialog);
    return c.modal ? /* @__PURE__ */ V.jsx(X0, { present: a || c.open, children: /* @__PURE__ */ V.jsx(jxt, { ...i, ref: t }) }) : null;
  }
);
Fre.displayName = d9;
var zxt = /* @__PURE__ */ IE("DialogOverlay.RemoveScroll"), jxt = S.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...a } = e, i = Q1(d9, r);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ V.jsx(LI, { as: zxt, allowPinchZoom: !0, shards: [i.contentRef], children: /* @__PURE__ */ V.jsx(
        Ro.div,
        {
          "data-state": JI(i.open),
          ...a,
          ref: t,
          style: { pointerEvents: "auto", ...a.style }
        }
      ) })
    );
  }
), o3 = "DialogContent", Wre = S.forwardRef(
  (e, t) => {
    const r = Lre(o3, e.__scopeDialog), { forceMount: a = r.forceMount, ...i } = e, c = Q1(o3, e.__scopeDialog);
    return /* @__PURE__ */ V.jsx(X0, { present: a || c.open, children: c.modal ? /* @__PURE__ */ V.jsx(Ixt, { ...i, ref: t }) : /* @__PURE__ */ V.jsx(Lxt, { ...i, ref: t }) });
  }
);
Wre.displayName = o3;
var Ixt = S.forwardRef(
  (e, t) => {
    const r = Q1(o3, e.__scopeDialog), a = S.useRef(null), i = Wl(t, r.contentRef, a);
    return S.useEffect(() => {
      const c = a.current;
      if (c) return Cne(c);
    }, []), /* @__PURE__ */ V.jsx(
      Vre,
      {
        ...e,
        ref: i,
        trapFocus: r.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: io(e.onCloseAutoFocus, (c) => {
          c.preventDefault(), r.triggerRef.current?.focus();
        }),
        onPointerDownOutside: io(e.onPointerDownOutside, (c) => {
          const d = c.detail.originalEvent, f = d.button === 0 && d.ctrlKey === !0;
          (d.button === 2 || f) && c.preventDefault();
        }),
        onFocusOutside: io(
          e.onFocusOutside,
          (c) => c.preventDefault()
        )
      }
    );
  }
), Lxt = S.forwardRef(
  (e, t) => {
    const r = Q1(o3, e.__scopeDialog), a = S.useRef(!1), i = S.useRef(!1);
    return /* @__PURE__ */ V.jsx(
      Vre,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (c) => {
          e.onCloseAutoFocus?.(c), c.defaultPrevented || (a.current || r.triggerRef.current?.focus(), c.preventDefault()), a.current = !1, i.current = !1;
        },
        onInteractOutside: (c) => {
          e.onInteractOutside?.(c), c.defaultPrevented || (a.current = !0, c.detail.originalEvent.type === "pointerdown" && (i.current = !0));
          const d = c.target;
          r.triggerRef.current?.contains(d) && c.preventDefault(), c.detail.originalEvent.type === "focusin" && i.current && c.preventDefault();
        }
      }
    );
  }
), Vre = S.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, trapFocus: a, onOpenAutoFocus: i, onCloseAutoFocus: c, ...d } = e, f = Q1(o3, r), p = S.useRef(null), g = Wl(t, p);
    return Ute(), /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
      /* @__PURE__ */ V.jsx(
        TI,
        {
          asChild: !0,
          loop: !0,
          trapped: a,
          onMountAutoFocus: i,
          onUnmountAutoFocus: c,
          children: /* @__PURE__ */ V.jsx(
            zM,
            {
              role: "dialog",
              id: f.contentId,
              "aria-describedby": f.descriptionId,
              "aria-labelledby": f.titleId,
              "data-state": JI(f.open),
              ...d,
              ref: g,
              onDismiss: () => f.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
        /* @__PURE__ */ V.jsx(Hxt, { titleId: f.titleId }),
        /* @__PURE__ */ V.jsx(Wxt, { contentRef: p, descriptionId: f.descriptionId })
      ] })
    ] });
  }
), QI = "DialogTitle", _re = S.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...a } = e, i = Q1(QI, r);
    return /* @__PURE__ */ V.jsx(Ro.h2, { id: i.titleId, ...a, ref: t });
  }
);
_re.displayName = QI;
var Bre = "DialogDescription", Ure = S.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...a } = e, i = Q1(Bre, r);
    return /* @__PURE__ */ V.jsx(Ro.p, { id: i.descriptionId, ...a, ref: t });
  }
);
Ure.displayName = Bre;
var Xre = "DialogClose", Gre = S.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...a } = e, i = Q1(Xre, r);
    return /* @__PURE__ */ V.jsx(
      Ro.button,
      {
        type: "button",
        ...a,
        ref: t,
        onClick: io(e.onClick, () => i.onOpenChange(!1))
      }
    );
  }
);
Gre.displayName = Xre;
function JI(e) {
  return e ? "open" : "closed";
}
var qre = "DialogTitleWarning", [wTt, Kre] = jMe(qre, {
  contentName: o3,
  titleName: QI,
  docsSlug: "dialog"
}), Hxt = ({ titleId: e }) => {
  const t = Kre(qre), r = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return S.useEffect(() => {
    e && (document.getElementById(e) || console.error(r));
  }, [r, e]), null;
}, Fxt = "DialogDescriptionWarning", Wxt = ({ contentRef: e, descriptionId: t }) => {
  const a = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Kre(Fxt).contentName}}.`;
  return S.useEffect(() => {
    const i = e.current?.getAttribute("aria-describedby");
    t && i && (document.getElementById(t) || console.warn(a));
  }, [a, e, t]), null;
}, Yre = jre, Qre = Hre, ZI = Fre, Jre = Wre, Vxt = _re, _xt = Ure, Bxt = Gre, Uxt = Symbol.for("react.lazy"), f9 = S[" use ".trim().toString()];
function Xxt(e) {
  return typeof e == "object" && e !== null && "then" in e;
}
function Zre(e) {
  return e != null && typeof e == "object" && "$$typeof" in e && e.$$typeof === Uxt && "_payload" in e && Xxt(e._payload);
}
// @__NO_SIDE_EFFECTS__
function Gxt(e) {
  const t = /* @__PURE__ */ qxt(e), r = S.forwardRef((a, i) => {
    let { children: c, ...d } = a;
    Zre(c) && typeof f9 == "function" && (c = f9(c._payload));
    const f = S.Children.toArray(c), p = f.find(Yxt);
    if (p) {
      const g = p.props.children, b = f.map((w) => w === p ? S.Children.count(g) > 1 ? S.Children.only(null) : S.isValidElement(g) ? g.props.children : null : w);
      return /* @__PURE__ */ V.jsx(t, { ...d, ref: i, children: S.isValidElement(g) ? S.cloneElement(g, void 0, b) : null });
    }
    return /* @__PURE__ */ V.jsx(t, { ...d, ref: i, children: c });
  });
  return r.displayName = `${e}.Slot`, r;
}
// @__NO_SIDE_EFFECTS__
function qxt(e) {
  const t = S.forwardRef((r, a) => {
    let { children: i, ...c } = r;
    if (Zre(i) && typeof f9 == "function" && (i = f9(i._payload)), S.isValidElement(i)) {
      const d = Jxt(i), f = Qxt(c, i.props);
      return i.type !== S.Fragment && (f.ref = a ? fS(a, d) : d), S.cloneElement(i, f);
    }
    return S.Children.count(i) > 1 ? S.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var Kxt = Symbol("radix.slottable");
function Yxt(e) {
  return S.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Kxt;
}
function Qxt(e, t) {
  const r = { ...t };
  for (const a in t) {
    const i = e[a], c = t[a];
    /^on[A-Z]/.test(a) ? i && c ? r[a] = (...f) => {
      const p = c(...f);
      return i(...f), p;
    } : i && (r[a] = i) : a === "style" ? r[a] = { ...i, ...c } : a === "className" && (r[a] = [i, c].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function Jxt(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var Zxt = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], cC = Zxt.reduce((e, t) => {
  const r = /* @__PURE__ */ Gxt(`Primitive.${t}`), a = S.forwardRef((i, c) => {
    const { asChild: d, ...f } = i, p = d ? r : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ V.jsx(p, { ...f, ref: c });
  });
  return a.displayName = `Primitive.${t}`, { ...e, [t]: a };
}, {}), Q5 = '[cmdk-group=""]', YA = '[cmdk-group-items=""]', e6t = '[cmdk-group-heading=""]', eae = '[cmdk-item=""]', XU = `${eae}:not([aria-disabled="true"])`, B$ = "cmdk-item-select", X3 = "data-value", t6t = (e, t, r) => Axt(e, t, r), tae = S.createContext(void 0), C7 = () => S.useContext(tae), nae = S.createContext(void 0), eL = () => S.useContext(nae), rae = S.createContext(void 0), aae = S.forwardRef((e, t) => {
  let r = G3(() => {
    var ne, ae;
    return { search: "", value: (ae = (ne = e.value) != null ? ne : e.defaultValue) != null ? ae : "", selectedItemId: void 0, filtered: { count: 0, items: /* @__PURE__ */ new Map(), groups: /* @__PURE__ */ new Set() } };
  }), a = G3(() => /* @__PURE__ */ new Set()), i = G3(() => /* @__PURE__ */ new Map()), c = G3(() => /* @__PURE__ */ new Map()), d = G3(() => /* @__PURE__ */ new Set()), f = oae(e), { label: p, children: g, value: b, onValueChange: w, filter: x, shouldFilter: E, loop: P, disablePointerSelection: k = !1, vimBindings: M = !0, ...T } = e, N = T0(), D = T0(), $ = T0(), j = S.useRef(null), I = f6t();
  i3(() => {
    if (b !== void 0) {
      let ne = b.trim();
      r.current.value = ne, L.emit();
    }
  }, [b]), i3(() => {
    I(6, Y);
  }, []);
  let L = S.useMemo(() => ({ subscribe: (ne) => (d.current.add(ne), () => d.current.delete(ne)), snapshot: () => r.current, setState: (ne, ae, oe) => {
    var fe, be, me, De;
    if (!Object.is(r.current[ne], ae)) {
      if (r.current[ne] = ae, ne === "search") U(), W(), I(1, Q);
      else if (ne === "value") {
        if (document.activeElement.hasAttribute("cmdk-input") || document.activeElement.hasAttribute("cmdk-root")) {
          let Me = document.getElementById($);
          Me ? Me.focus() : (fe = document.getElementById(N)) == null || fe.focus();
        }
        if (I(7, () => {
          var Me;
          r.current.selectedItemId = (Me = G()) == null ? void 0 : Me.id, L.emit();
        }), oe || I(5, Y), ((be = f.current) == null ? void 0 : be.value) !== void 0) {
          let Me = ae ?? "";
          (De = (me = f.current).onValueChange) == null || De.call(me, Me);
          return;
        }
      }
      L.emit();
    }
  }, emit: () => {
    d.current.forEach((ne) => ne());
  } }), []), F = S.useMemo(() => ({ value: (ne, ae, oe) => {
    var fe;
    ae !== ((fe = c.current.get(ne)) == null ? void 0 : fe.value) && (c.current.set(ne, { value: ae, keywords: oe }), r.current.filtered.items.set(ne, _(ae, oe)), I(2, () => {
      W(), L.emit();
    }));
  }, item: (ne, ae) => (a.current.add(ne), ae && (i.current.has(ae) ? i.current.get(ae).add(ne) : i.current.set(ae, /* @__PURE__ */ new Set([ne]))), I(3, () => {
    U(), W(), r.current.value || Q(), L.emit();
  }), () => {
    c.current.delete(ne), a.current.delete(ne), r.current.filtered.items.delete(ne);
    let oe = G();
    I(4, () => {
      U(), oe?.getAttribute("id") === ne && Q(), L.emit();
    });
  }), group: (ne) => (i.current.has(ne) || i.current.set(ne, /* @__PURE__ */ new Set()), () => {
    c.current.delete(ne), i.current.delete(ne);
  }), filter: () => f.current.shouldFilter, label: p || e["aria-label"], getDisablePointerSelection: () => f.current.disablePointerSelection, listId: N, inputId: $, labelId: D, listInnerRef: j }), []);
  function _(ne, ae) {
    var oe, fe;
    let be = (fe = (oe = f.current) == null ? void 0 : oe.filter) != null ? fe : t6t;
    return ne ? be(ne, r.current.search, ae) : 0;
  }
  function W() {
    if (!r.current.search || f.current.shouldFilter === !1) return;
    let ne = r.current.filtered.items, ae = [];
    r.current.filtered.groups.forEach((fe) => {
      let be = i.current.get(fe), me = 0;
      be.forEach((De) => {
        let Me = ne.get(De);
        me = Math.max(Me, me);
      }), ae.push([fe, me]);
    });
    let oe = j.current;
    J().sort((fe, be) => {
      var me, De;
      let Me = fe.getAttribute("id"), ze = be.getAttribute("id");
      return ((me = ne.get(ze)) != null ? me : 0) - ((De = ne.get(Me)) != null ? De : 0);
    }).forEach((fe) => {
      let be = fe.closest(YA);
      be ? be.appendChild(fe.parentElement === be ? fe : fe.closest(`${YA} > *`)) : oe.appendChild(fe.parentElement === oe ? fe : fe.closest(`${YA} > *`));
    }), ae.sort((fe, be) => be[1] - fe[1]).forEach((fe) => {
      var be;
      let me = (be = j.current) == null ? void 0 : be.querySelector(`${Q5}[${X3}="${encodeURIComponent(fe[0])}"]`);
      me?.parentElement.appendChild(me);
    });
  }
  function Q() {
    let ne = J().find((oe) => oe.getAttribute("aria-disabled") !== "true"), ae = ne?.getAttribute(X3);
    L.setState("value", ae || void 0);
  }
  function U() {
    var ne, ae, oe, fe;
    if (!r.current.search || f.current.shouldFilter === !1) {
      r.current.filtered.count = a.current.size;
      return;
    }
    r.current.filtered.groups = /* @__PURE__ */ new Set();
    let be = 0;
    for (let me of a.current) {
      let De = (ae = (ne = c.current.get(me)) == null ? void 0 : ne.value) != null ? ae : "", Me = (fe = (oe = c.current.get(me)) == null ? void 0 : oe.keywords) != null ? fe : [], ze = _(De, Me);
      r.current.filtered.items.set(me, ze), ze > 0 && be++;
    }
    for (let [me, De] of i.current) for (let Me of De) if (r.current.filtered.items.get(Me) > 0) {
      r.current.filtered.groups.add(me);
      break;
    }
    r.current.filtered.count = be;
  }
  function Y() {
    var ne, ae, oe;
    let fe = G();
    fe && (((ne = fe.parentElement) == null ? void 0 : ne.firstChild) === fe && ((oe = (ae = fe.closest(Q5)) == null ? void 0 : ae.querySelector(e6t)) == null || oe.scrollIntoView({ block: "nearest" })), fe.scrollIntoView({ block: "nearest" }));
  }
  function G() {
    var ne;
    return (ne = j.current) == null ? void 0 : ne.querySelector(`${eae}[aria-selected="true"]`);
  }
  function J() {
    var ne;
    return Array.from(((ne = j.current) == null ? void 0 : ne.querySelectorAll(XU)) || []);
  }
  function H(ne) {
    let ae = J()[ne];
    ae && L.setState("value", ae.getAttribute(X3));
  }
  function K(ne) {
    var ae;
    let oe = G(), fe = J(), be = fe.findIndex((De) => De === oe), me = fe[be + ne];
    (ae = f.current) != null && ae.loop && (me = be + ne < 0 ? fe[fe.length - 1] : be + ne === fe.length ? fe[0] : fe[be + ne]), me && L.setState("value", me.getAttribute(X3));
  }
  function X(ne) {
    let ae = G(), oe = ae?.closest(Q5), fe;
    for (; oe && !fe; ) oe = ne > 0 ? c6t(oe, Q5) : d6t(oe, Q5), fe = oe?.querySelector(XU);
    fe ? L.setState("value", fe.getAttribute(X3)) : K(ne);
  }
  let te = () => H(J().length - 1), ie = (ne) => {
    ne.preventDefault(), ne.metaKey ? te() : ne.altKey ? X(1) : K(1);
  }, ee = (ne) => {
    ne.preventDefault(), ne.metaKey ? H(0) : ne.altKey ? X(-1) : K(-1);
  };
  return S.createElement(cC.div, { ref: t, tabIndex: -1, ...T, "cmdk-root": "", onKeyDown: (ne) => {
    var ae;
    (ae = T.onKeyDown) == null || ae.call(T, ne);
    let oe = ne.nativeEvent.isComposing || ne.keyCode === 229;
    if (!(ne.defaultPrevented || oe)) switch (ne.key) {
      case "n":
      case "j": {
        M && ne.ctrlKey && ie(ne);
        break;
      }
      case "ArrowDown": {
        ie(ne);
        break;
      }
      case "p":
      case "k": {
        M && ne.ctrlKey && ee(ne);
        break;
      }
      case "ArrowUp": {
        ee(ne);
        break;
      }
      case "Home": {
        ne.preventDefault(), H(0);
        break;
      }
      case "End": {
        ne.preventDefault(), te();
        break;
      }
      case "Enter": {
        ne.preventDefault();
        let fe = G();
        if (fe) {
          let be = new Event(B$);
          fe.dispatchEvent(be);
        }
      }
    }
  } }, S.createElement("label", { "cmdk-label": "", htmlFor: F.inputId, id: F.labelId, style: h6t }, p), QM(e, (ne) => S.createElement(nae.Provider, { value: L }, S.createElement(tae.Provider, { value: F }, ne))));
}), n6t = S.forwardRef((e, t) => {
  var r, a;
  let i = T0(), c = S.useRef(null), d = S.useContext(rae), f = C7(), p = oae(e), g = (a = (r = p.current) == null ? void 0 : r.forceMount) != null ? a : d?.forceMount;
  i3(() => {
    if (!g) return f.item(i, d?.id);
  }, [g]);
  let b = iae(i, c, [e.value, e.children, c], e.keywords), w = eL(), x = QS((I) => I.value && I.value === b.current), E = QS((I) => g || f.filter() === !1 ? !0 : I.search ? I.filtered.items.get(i) > 0 : !0);
  S.useEffect(() => {
    let I = c.current;
    if (!(!I || e.disabled)) return I.addEventListener(B$, P), () => I.removeEventListener(B$, P);
  }, [E, e.onSelect, e.disabled]);
  function P() {
    var I, L;
    k(), (L = (I = p.current).onSelect) == null || L.call(I, b.current);
  }
  function k() {
    w.setState("value", b.current, !0);
  }
  if (!E) return null;
  let { disabled: M, value: T, onSelect: N, forceMount: D, keywords: $, ...j } = e;
  return S.createElement(cC.div, { ref: fS(c, t), ...j, id: i, "cmdk-item": "", role: "option", "aria-disabled": !!M, "aria-selected": !!x, "data-disabled": !!M, "data-selected": !!x, onPointerMove: M || f.getDisablePointerSelection() ? void 0 : k, onClick: M ? void 0 : P }, e.children);
}), r6t = S.forwardRef((e, t) => {
  let { heading: r, children: a, forceMount: i, ...c } = e, d = T0(), f = S.useRef(null), p = S.useRef(null), g = T0(), b = C7(), w = QS((E) => i || b.filter() === !1 ? !0 : E.search ? E.filtered.groups.has(d) : !0);
  i3(() => b.group(d), []), iae(d, f, [e.value, e.heading, p]);
  let x = S.useMemo(() => ({ id: d, forceMount: i }), [i]);
  return S.createElement(cC.div, { ref: fS(f, t), ...c, "cmdk-group": "", role: "presentation", hidden: w ? void 0 : !0 }, r && S.createElement("div", { ref: p, "cmdk-group-heading": "", "aria-hidden": !0, id: g }, r), QM(e, (E) => S.createElement("div", { "cmdk-group-items": "", role: "group", "aria-labelledby": r ? g : void 0 }, S.createElement(rae.Provider, { value: x }, E))));
}), a6t = S.forwardRef((e, t) => {
  let { alwaysRender: r, ...a } = e, i = S.useRef(null), c = QS((d) => !d.search);
  return !r && !c ? null : S.createElement(cC.div, { ref: fS(i, t), ...a, "cmdk-separator": "", role: "separator" });
}), o6t = S.forwardRef((e, t) => {
  let { onValueChange: r, ...a } = e, i = e.value != null, c = eL(), d = QS((g) => g.search), f = QS((g) => g.selectedItemId), p = C7();
  return S.useEffect(() => {
    e.value != null && c.setState("search", e.value);
  }, [e.value]), S.createElement(cC.input, { ref: t, ...a, "cmdk-input": "", autoComplete: "off", autoCorrect: "off", spellCheck: !1, "aria-autocomplete": "list", role: "combobox", "aria-expanded": !0, "aria-controls": p.listId, "aria-labelledby": p.labelId, "aria-activedescendant": f, id: p.inputId, type: "text", value: i ? e.value : d, onChange: (g) => {
    i || c.setState("search", g.target.value), r?.(g.target.value);
  } });
}), i6t = S.forwardRef((e, t) => {
  let { children: r, label: a = "Suggestions", ...i } = e, c = S.useRef(null), d = S.useRef(null), f = QS((g) => g.selectedItemId), p = C7();
  return S.useEffect(() => {
    if (d.current && c.current) {
      let g = d.current, b = c.current, w, x = new ResizeObserver(() => {
        w = requestAnimationFrame(() => {
          let E = g.offsetHeight;
          b.style.setProperty("--cmdk-list-height", E.toFixed(1) + "px");
        });
      });
      return x.observe(g), () => {
        cancelAnimationFrame(w), x.unobserve(g);
      };
    }
  }, []), S.createElement(cC.div, { ref: fS(c, t), ...i, "cmdk-list": "", role: "listbox", tabIndex: -1, "aria-activedescendant": f, "aria-label": a, id: p.listId }, QM(e, (g) => S.createElement("div", { ref: fS(d, p.listInnerRef), "cmdk-list-sizer": "" }, g)));
}), l6t = S.forwardRef((e, t) => {
  let { open: r, onOpenChange: a, overlayClassName: i, contentClassName: c, container: d, ...f } = e;
  return S.createElement(Yre, { open: r, onOpenChange: a }, S.createElement(Qre, { container: d }, S.createElement(ZI, { "cmdk-overlay": "", className: i }), S.createElement(Jre, { "aria-label": e.label, "cmdk-dialog": "", className: c }, S.createElement(aae, { ref: t, ...f }))));
}), s6t = S.forwardRef((e, t) => QS((r) => r.filtered.count === 0) ? S.createElement(cC.div, { ref: t, ...e, "cmdk-empty": "", role: "presentation" }) : null), u6t = S.forwardRef((e, t) => {
  let { progress: r, children: a, label: i = "Loading...", ...c } = e;
  return S.createElement(cC.div, { ref: t, ...c, "cmdk-loading": "", role: "progressbar", "aria-valuenow": r, "aria-valuemin": 0, "aria-valuemax": 100, "aria-label": i }, QM(e, (d) => S.createElement("div", { "aria-hidden": !0 }, d)));
}), x7 = Object.assign(aae, { List: i6t, Item: n6t, Input: o6t, Group: r6t, Separator: a6t, Dialog: l6t, Empty: s6t, Loading: u6t });
function c6t(e, t) {
  let r = e.nextElementSibling;
  for (; r; ) {
    if (r.matches(t)) return r;
    r = r.nextElementSibling;
  }
}
function d6t(e, t) {
  let r = e.previousElementSibling;
  for (; r; ) {
    if (r.matches(t)) return r;
    r = r.previousElementSibling;
  }
}
function oae(e) {
  let t = S.useRef(e);
  return i3(() => {
    t.current = e;
  }), t;
}
var i3 = typeof window > "u" ? S.useEffect : S.useLayoutEffect;
function G3(e) {
  let t = S.useRef();
  return t.current === void 0 && (t.current = e()), t;
}
function QS(e) {
  let t = eL(), r = () => e(t.snapshot());
  return S.useSyncExternalStore(t.subscribe, r, r);
}
function iae(e, t, r, a = []) {
  let i = S.useRef(), c = C7();
  return i3(() => {
    var d;
    let f = (() => {
      var g;
      for (let b of r) {
        if (typeof b == "string") return b.trim();
        if (typeof b == "object" && "current" in b) return b.current ? (g = b.current.textContent) == null ? void 0 : g.trim() : i.current;
      }
    })(), p = a.map((g) => g.trim());
    c.value(e, f, p), (d = t.current) == null || d.setAttribute(X3, f), i.current = f;
  }), i;
}
var f6t = () => {
  let [e, t] = S.useState(), r = G3(() => /* @__PURE__ */ new Map());
  return i3(() => {
    r.current.forEach((a) => a()), r.current = /* @__PURE__ */ new Map();
  }, [e]), (a, i) => {
    r.current.set(a, i), t({});
  };
};
function m6t(e) {
  let t = e.type;
  return typeof t == "function" ? t(e.props) : "render" in t ? t.render(e.props) : e;
}
function QM({ asChild: e, children: t }, r) {
  return e && S.isValidElement(t) ? S.cloneElement(m6t(t), { ref: t.ref }, r(t.props.children)) : r(t);
}
var h6t = { position: "absolute", width: "1px", height: "1px", padding: "0", margin: "-1px", overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0" };
function p6t(e) {
  const { disabled: t, handleValueChange: r, id: a, multiple: i } = e;
  Er(() => {
    const c = v6t.bind(void 0, {
      disabled: t,
      handleValueChange: r,
      id: a,
      multiple: i
    });
    return window.document.body.addEventListener("setSelected", c), () => {
      window.document.body.removeEventListener("setSelected", c);
    };
  }, [t, r, a, i]);
}
function g6t(e, t) {
  const r = e.detail?.value;
  return r ? t ? Array.isArray(r) ? r : [r] : Array.isArray(r) && r.length > 0 ? r[0] : r : t ? [] : void 0;
}
function v6t({
  disabled: e,
  handleValueChange: t,
  id: r,
  multiple: a
}, i) {
  if (console.log("Received playwright 'setSelected' event", i), i.target.id !== `${r}${kN}` || e)
    return;
  const c = g6t(i, a);
  console.log("Handling playwright 'setSelected' event", c), t(c);
}
const lae = fp(
  void 0
);
function G0() {
  const e = Do(lae);
  if (e === void 0)
    throw new Error("useSelectContext must be used within a SelectProvider");
  return e;
}
const b6t = ({
  className: e,
  align: t = "start",
  sideOffset: r = 4,
  ...a
}) => /* @__PURE__ */ V.jsx(Wne, { children: /* @__PURE__ */ V.jsx(
  Vne,
  {
    "data-slot": "popover-content",
    align: t,
    sideOffset: r,
    className: lt(
      "box-border",
      // because we can't seem to get preflight scoped here without breaking the animation
      "data-[state=open]:animate-in data-[state=open]:fade-in-0",
      "data-[state=closed]:animate-out data-[state=closed]:fade-out-0",
      "data-[side=bottom]:slide-in-from-top-2 data-[side=bottom]:slide-out-to-top-2",
      "data-[side=left]:slide-in-from-right-2 data-[side=left]:slide-out-to-right-2",
      "data-[side=right]:slide-in-from-left-2 data-[side=right]:slide-out-to-left-2",
      "data-[side=top]:slide-in-from-bottom-2 data-[side=top]:slide-out-to-bottom-2",
      "origin-(--radix-popover-content-transform-origin) outline-hidden z-50",
      "min-w-(--radix-popover-trigger-width)",
      "max-w-(--radix-popover-content-available-width)",
      e
    ),
    ...a
  }
) }), y6t = () => {
  const { t: e } = fi(), { dataTestId: t } = G0();
  return /* @__PURE__ */ V.jsx(
    x7.Empty,
    {
      "data-testid": `${t}-empty`,
      "data-slot": "command-empty",
      className: "py-0 text-center text-sm",
      children: /* @__PURE__ */ V.jsxs("div", { className: "flex flex-col items-center justify-center gap-2 py-3", children: [
        /* @__PURE__ */ V.jsxs(
          "svg",
          {
            width: "64",
            height: "41",
            viewBox: "0 0 64 41",
            xmlns: "http://www.w3.org/2000/svg",
            className: "text-(--select-text-color)",
            children: [
              /* @__PURE__ */ V.jsx("title", { children: e("noData") }),
              /* @__PURE__ */ V.jsxs("g", { transform: "translate(0 1)", fill: "none", fillRule: "evenodd", children: [
                /* @__PURE__ */ V.jsx(
                  "ellipse",
                  {
                    fill: "currentColor",
                    cx: "32",
                    cy: "33",
                    rx: "32",
                    ry: "7"
                  }
                ),
                /* @__PURE__ */ V.jsxs("g", { fillRule: "nonzero", stroke: "currentColor", children: [
                  /* @__PURE__ */ V.jsx("path", { d: "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z" }),
                  /* @__PURE__ */ V.jsx(
                    "path",
                    {
                      d: "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
                      fill: "currentColor"
                    }
                  )
                ] })
              ] })
            ]
          }
        ),
        /* @__PURE__ */ V.jsx("div", { className: "text-(--select-no-options-text-color)", children: e("noData") })
      ] })
    }
  );
}, w6t = ({ className: e }) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    viewBox: "64 64 896 896",
    focusable: "false",
    "data-icon": "check",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    className: lt("aspect-square", e),
    children: /* @__PURE__ */ V.jsx("path", { d: "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" })
  }
), S6t = ({
  option: e
}) => {
  const {
    dataTestId: t,
    value: r,
    toggleValue: a,
    setOpen: i,
    multiple: c,
    maxCount: d
  } = G0(), f = String(e.value), p = Array.isArray(r) ? r.includes(f) : f === r, g = c && d !== void 0 && Array.isArray(r) ? r.length >= d : !1, b = e.disabled || g && !p;
  return /* @__PURE__ */ V.jsxs(
    x7.Item,
    {
      "data-slot": "command-item",
      "data-testid": `${t}-option-${f}`,
      "aria-selected": p,
      value: f,
      disabled: b,
      className: lt(
        "p-(--select-option-padding) data-[selected=true]:bg-(--select-option-hover-background) text-(color:--select-text-color) text-(length:--select-popover-font-size) flex cursor-pointer items-center transition-colors",
        "[&_svg:not([class*='text-'])]:text-[var(--input-components-primary-color)] [&_svg]:shrink-0",
        "data-[disabled=true]:text-(--select-option-disabled-text) data-[disabled=true]:cursor-not-allowed",
        p && "bg-(--select-option-selected-background) data-[selected=true]:bg-(--select-option-selected-background) font-semibold"
      ),
      onSelect: (w) => {
        a?.(w), c || i(!1);
      },
      onMouseDown: (w) => {
        w.preventDefault();
      },
      children: [
        /* @__PURE__ */ V.jsx("span", { className: "truncate", children: e.label }),
        c && p && /* @__PURE__ */ V.jsx(w6t, { className: "text-(--select-check-icon-color) h-(--select-check-icon-size) ml-auto" })
      ]
    },
    f
  );
}, GU = () => {
  const { dataTestId: e, dropdownMenuRef: t, visibleOptions: r } = G0();
  return /* @__PURE__ */ V.jsxs(
    x7.List,
    {
      ref: t,
      "data-slot": "command-list",
      "data-testid": `${e}-dropdown-menu`,
      className: "max-h-(--select-popover-max-height) overflow-y-auto overflow-x-hidden",
      children: [
        /* @__PURE__ */ V.jsx(y6t, {}),
        r.map((a, i) => /* @__PURE__ */ V.jsx(
          S6t,
          {
            option: a,
            index: i
          },
          String(a.value)
        ))
      ]
    }
  );
}, U$ = ({
  option: { label: e, value: t },
  className: r,
  placeholder: a
}) => {
  const { toggleValue: i, disabled: c, size: d, tagRender: f, dataTestId: p } = G0(), { t: g } = fi(), b = String(t), w = typeof e == "string" ? e : void 0, x = (M) => {
    M?.stopPropagation(), i?.(b);
  };
  if (f)
    return f({
      label: e,
      value: b,
      disabled: !!c,
      onClose: x,
      closable: !0,
      isMaxTag: !1
    });
  const E = `${p}-option-${b}`, P = `${p}-option-${b}-remove`, k = !c && !a;
  return /* @__PURE__ */ V.jsx(
    "div",
    {
      className: lt(
        "py-(--select-chip-margin) inline-flex h-full min-w-0 items-center",
        a && "shrink-0"
      ),
      children: /* @__PURE__ */ V.jsxs(
        "div",
        {
          "data-testid": E,
          className: lt(
            "inline-flex h-full min-w-0 max-w-full items-center justify-center overflow-hidden whitespace-nowrap",
            "bg-(--select-chip-bg) p-(--select-chip-padding) gap-(--select-chip-gap)",
            // literally just looks better with a bit of extra padding when there's a clear button
            k && "pr-(--select-chip-clear-padding)",
            d === "small" && "rounded-(--select-chip-radius-sm)",
            d === "medium" && "rounded-(--select-chip-radius-md)",
            d === "large" && "rounded-(--select-chip-radius-lg)",
            r
          ),
          children: [
            /* @__PURE__ */ V.jsx(
              "span",
              {
                className: lt(
                  "pointer-events-auto",
                  a ? "whitespace-nowrap" : "truncate"
                ),
                title: w,
                children: e
              }
            ),
            k && //eslint-disable-next-line jsx-a11y/click-events-have-key-events
            /* @__PURE__ */ V.jsx(
              "div",
              {
                role: "button",
                tabIndex: -1,
                "data-testid": P,
                className: lt(
                  "flex h-[10px] w-[10px] items-center justify-center p-0",
                  "fill-(--select-chip-clear-color) hover:fill-(--select-chip-clear-hover-color)",
                  c && "cursor-not-allowed"
                ),
                onClick: x,
                "aria-label": e ? g("removeXItem", { item: e }) : g("removeSelectedItem"),
                children: /* @__PURE__ */ V.jsx(
                  "svg",
                  {
                    fillRule: "evenodd",
                    viewBox: "64 64 896 896",
                    focusable: "false",
                    "data-icon": "close",
                    width: "1em",
                    height: "1em",
                    "aria-hidden": "true",
                    className: "aspect-square h-[10px]",
                    children: /* @__PURE__ */ V.jsx("path", { d: "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z" })
                  }
                )
              }
            )
          ]
        },
        b
      )
    }
  );
}, C6t = ({
  hiddenTags: e
}) => {
  const { maxTagPlaceholder: t } = G0(), r = e.length, a = t !== void 0 && r > 0, i = typeof t == "function", c = !a && r > 0;
  return /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
    c && /* @__PURE__ */ V.jsx(
      U$,
      {
        placeholder: !0,
        option: { label: `+ ${r} ...`, value: "" },
        className: "mr-(--select-chip-spacing)"
      }
    ),
    a && /* @__PURE__ */ V.jsx(
      U$,
      {
        placeholder: !0,
        option: {
          label: i ? t(e) : t,
          value: ""
        },
        className: "mr-(--select-chip-spacing)"
      }
    )
  ] });
}, x6t = () => {
  const { value: e, maxTagCount: t, options: r } = G0();
  if (typeof e != "object" || !e || e.length === 0)
    return null;
  const a = e.map(
    (f) => r.find((p) => p.value === f) ?? {
      label: "",
      value: ""
    }
  ), i = typeof t == "number" && t >= 0, c = i ? a.slice(0, t) : a, d = i ? a.slice(t) : [];
  return /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
    c.map((f) => /* @__PURE__ */ V.jsx(
      U$,
      {
        option: f,
        className: "mr-(--select-chip-spacing)"
      },
      String(f.value)
    )),
    /* @__PURE__ */ V.jsx(C6t, { hiddenTags: d })
  ] });
}, E6t = () => {
  const {
    commandInputRef: e,
    options: t,
    value: r,
    setValue: a,
    shouldShowLabel: i,
    placeholder: c,
    open: d,
    setOpen: f,
    disabled: p,
    dataTestId: g,
    filterText: b,
    setFilterText: w
  } = G0(), x = (T) => {
    if (T.key === "Backspace" && b === "") {
      T.preventDefault(), Array.isArray(r) && r.length > 0 && a(r.slice(0, -1));
      return;
    }
    if (T.key === "Escape") {
      T.preventDefault(), b === "" ? f(!1) : w("");
      return;
    }
    T.key !== "Backspace" && !d && f(!0);
  };
  Er(() => {
    w("");
  }, [r, d]);
  const E = t.find((T) => T.value === r)?.label, P = typeof E == "string", k = E ?? c, M = typeof k == "string";
  return /* @__PURE__ */ V.jsxs(
    "div",
    {
      className: "relative h-full flex-1",
      "data-slot": "select-value",
      "data-testid": `${g}-value`,
      children: [
        /* @__PURE__ */ V.jsx(
          x7.Input,
          {
            "data-slot": "command-input",
            ref: e,
            value: b,
            onValueChange: w,
            onKeyDown: x,
            onFocus: () => f(!0),
            onBlur: () => f(!1),
            onMouseDown: () => f(!0),
            disabled: p,
            placeholder: "",
            className: lt(
              "h-full w-full min-w-0 border-0 bg-transparent outline-none"
            ),
            title: E && P ? E : void 0
          }
        ),
        i && b === "" && /* @__PURE__ */ V.jsx(
          "span",
          {
            className: lt(
              "pointer-events-none absolute inset-y-0 left-0 flex w-full items-center",
              "text-(--input-text-color) group-data-[state=open]:opacity-25",
              p && "opacity-25"
            ),
            children: /* @__PURE__ */ V.jsx("span", { className: lt(M && "truncate"), children: k })
          }
        )
      ]
    }
  );
}, P6t = () => {
  const { prefix: e, dataTestId: t } = G0();
  return e ? /* @__PURE__ */ V.jsx(
    "span",
    {
      "data-slot": "prefix",
      className: "mr-(--select-prefix-margin) flex items-center",
      "data-testid": `${t}-prefix`,
      children: e
    }
  ) : null;
}, k6t = ({ className: e }) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    fillRule: "evenodd",
    viewBox: "64 64 896 896",
    focusable: "false",
    "data-icon": "close-circle",
    "aria-hidden": "true",
    className: lt("h-(--select-clear-button-size) aspect-square", e),
    children: /* @__PURE__ */ V.jsx("path", { d: "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z" })
  }
), M6t = ({ className: e }) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    viewBox: "64 64 896 896",
    focusable: "false",
    "data-icon": "down",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    className: lt(e),
    children: /* @__PURE__ */ V.jsx("path", { d: "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z" })
  }
), O6t = ({ className: e }) => /* @__PURE__ */ V.jsx(
  "svg",
  {
    viewBox: "64 64 896 896",
    focusable: "false",
    "data-icon": "search",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    className: lt("h-(--select-suffix-icon-size) aspect-square", e),
    children: /* @__PURE__ */ V.jsx("path", { d: "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" })
  }
), T6t = () => {
  const { dataTestId: e, clearInput: t, hasSuffix: r } = G0(), { t: a } = fi();
  return r ? /* @__PURE__ */ V.jsx(
    "button",
    {
      className: lt(
        "fill-(--select-clear-button-color) hover:fill-(--select-clear-button-hover-color) active:fill-(--select-clear-button-active-color)",
        "cursor-pointer transition-colors",
        r && "mx-(--select-clear-button-margin)"
      ),
      tabIndex: -1,
      "data-slot": "clear-button",
      "data-testid": `${e}-clear`,
      "aria-label": a("input.clearButtonLabel"),
      type: "button",
      onClick: (i) => {
        i.preventDefault(), t?.();
      },
      children: /* @__PURE__ */ V.jsx("span", { role: "img", "aria-label": a("input.clearButtonIconLabel"), children: /* @__PURE__ */ V.jsx(k6t, {}) })
    }
  ) : null;
}, R6t = () => {
  const {
    dataTestId: e,
    disabled: t,
    focusInput: r,
    open: a,
    searchable: i,
    setOpen: c,
    suffixIcon: d
  } = G0(), f = Cn(
    (w) => {
      !i || t || (w && (w.preventDefault(), w.stopPropagation()), r?.(), c(!0));
    },
    [t, r, i, c]
  );
  let p;
  d ? p = /* @__PURE__ */ V.jsx("span", { className: "text-(--select-suffix-icon-color)", children: d }) : a && i ? p = /* @__PURE__ */ V.jsx(O6t, { className: "w-(--select-suffix-icon-size) text-(--select-suffix-icon-color) aspect-square" }) : p = /* @__PURE__ */ V.jsx(M6t, { className: "w-(--select-suffix-icon-size) text-(--select-suffix-icon-color) aspect-square" });
  const b = i && !d ? (
    //eslint-disable-next-line jsx-a11y/click-events-have-key-events
    /* @__PURE__ */ V.jsx(
      "span",
      {
        role: "button",
        tabIndex: -1,
        className: "inline-flex select-none items-center",
        onPointerDown: (w) => {
          f(w);
        },
        onClick: (w) => {
          f(w);
        },
        children: p
      }
    )
  ) : p;
  return /* @__PURE__ */ V.jsxs(
    "span",
    {
      "data-slot": "suffix",
      className: "ml-(--select-suffix-margin) flex h-full shrink-0 items-center",
      "data-testid": `${e}-suffix`,
      children: [
        /* @__PURE__ */ V.jsx(T6t, {}),
        b
      ]
    }
  );
}, A6t = () => {
  const { options: e, shouldShowLabel: t, value: r, disabled: a, placeholder: i, dataTestId: c } = G0(), d = e.find((b) => b.value === r)?.label, f = typeof d == "string", p = d ?? i, g = typeof p == "string";
  return /* @__PURE__ */ V.jsx(
    "div",
    {
      className: "relative h-full flex-1",
      "data-slot": "select-value",
      "data-testid": `${c}-value`,
      children: /* @__PURE__ */ V.jsx(
        "span",
        {
          className: lt(
            "pointer-events-none absolute inset-y-0 left-0 flex w-full items-center",
            "text-(--input-text-color) group-data-[state=open]:opacity-25",
            a && "opacity-25"
          ),
          children: /* @__PURE__ */ V.jsx(
            "span",
            {
              className: lt(
                "pointer-events-auto",
                g && "truncate"
              ),
              title: f ? d : void 0,
              children: t && p
            }
          )
        }
      )
    }
  );
}, N6t = (e) => {
  (e.key === "Enter" || e.key === " ") && (e.preventDefault(), e.stopPropagation(), e.currentTarget.click());
}, sae = ks(
  (e, t) => {
    const {
      searchable: r,
      multiple: a,
      disabled: i,
      size: c,
      isError: d,
      hasSelection: f,
      prefix: p,
      dataTestId: g
    } = G0(), b = r ? E6t : A6t, w = r || i ? -1 : 0, x = r ? void 0 : N6t;
    return /* @__PURE__ */ V.jsxs(
      "div",
      {
        ref: t,
        role: "button",
        tabIndex: w,
        "data-testid": g,
        "data-disabled": i,
        "data-invalid": d,
        className: lt(
          "group",
          XI({ size: c }),
          // only add left‑padding in the multi case when there’s a selection but no prefix
          a && f && !p && "pl-(--select-chip-margin)"
        ),
        onKeyDown: x,
        ...e,
        children: [
          /* @__PURE__ */ V.jsx(P6t, {}),
          /* @__PURE__ */ V.jsx(x6t, {}),
          /* @__PURE__ */ V.jsx(b, {}),
          /* @__PURE__ */ V.jsx(R6t, {})
        ]
      }
    );
  }
);
sae.displayName = "SelectTrigger";
const D6t = (e, t) => e.toLowerCase().includes(t.toLowerCase()) ? 1 : 0;
function $6t({
  allowClear: e = !1,
  className: t = "",
  dataTestId: r = `select-${Date.now()}`,
  defaultValue: a,
  disabled: i = !1,
  dropdownRender: c,
  isError: d = !1,
  maxCount: f,
  maxTagCount: p,
  maxTagPlaceholder: g,
  multiple: b = !1,
  onChange: w,
  onDropdownVisibleChange: x,
  open: E,
  options: P,
  placeholder: k,
  popupClassName: M = "",
  popupMatchSelectWidth: T = !0,
  prefix: N,
  searchable: D,
  size: $ = "medium",
  suffixIcon: j,
  tagRender: I,
  value: L,
  width: F
}) {
  const _ = It(`select-${Date.now()}`), [W, Q] = Wn(E ?? !1), [U, Y] = Wn(
    L ?? a ?? (b ? [] : void 0)
  ), [G, J] = Wn(
    !L && !!a
  ), [H, K] = Wn(""), X = It(null), te = It(null), ie = Array.isArray(U) ? U.length > 0 : !!U, ee = L !== void 0, ne = e && !i && ie, ae = () => {
    oe(b ? [] : void 0), Q(!1);
  }, oe = Cn(
    (le) => {
      w?.(le, U), ee || Y(le);
    },
    [ee, w, U]
  );
  p6t({
    disabled: i,
    handleValueChange: oe,
    id: _.current,
    multiple: b
  });
  const fe = (le) => {
    let se;
    b ? Array.isArray(U) ? se = U.includes(le) ? U.filter((Ae) => Ae !== le) : [...U, le] : se = [le] : U !== le && (se = le), !(b && f !== void 0 && Array.isArray(se) && se.length > f) && oe(se);
  };
  zS(() => {
    E !== void 0 && Q(E);
  }, [E]), zS(() => {
    G && a !== void 0 ? (Y(a), J(!1)) : Y(L);
  }, [L]), zS(() => {
    x && x(W);
  }, [W]);
  const be = mn(
    () => P.filter((le) => H === "" ? !0 : D6t(String(le.label), H.trim()) > 0),
    [H, P]
  ), [me, De] = mn(() => {
    const le = P.map(({ label: se, value: Ae }) => ({
      label: typeof se == "string" ? se : String(se),
      value: String(Ae)
    }));
    return [le, JSON.stringify(le)];
  }, [P]), Me = mn(() => {
    if (U === null)
      return [];
    const le = Array.isArray(U) ? U : [U];
    return me.filter((se) => le.includes(se.value));
  }, [me, U]), ze = Cn(() => {
    i || te.current?.focus({ preventScroll: !0 });
  }, [i]);
  return /* @__PURE__ */ V.jsx(
    lae.Provider,
    {
      value: {
        className: t,
        commandInputRef: te,
        clearInput: ae,
        dataTestId: r,
        disabled: i,
        dropdownMenuRef: X,
        filterText: H,
        focusInput: ze,
        hasSelection: ie,
        hasSuffix: ne,
        isError: d,
        maxCount: f,
        maxTagCount: p,
        maxTagPlaceholder: g,
        multiple: b,
        open: W,
        options: P,
        placeholder: k,
        prefix: N,
        searchable: D,
        setFilterText: K,
        setOpen: Q,
        setValue: oe,
        shouldShowLabel: !(b && ie),
        size: $,
        suffixIcon: j,
        tagRender: I,
        toggleValue: fe,
        value: U,
        visibleOptions: be
      },
      children: /* @__PURE__ */ V.jsx("div", { "data-preflight": !0, className: "contents", children: /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
        /* @__PURE__ */ V.jsx(
          x7,
          {
            "data-slot": "command",
            className: lt(
              "font-(family-name:--select-font) min-w-0 overflow-visible",
              t
            ),
            style: { width: F },
            loop: !0,
            shouldFilter: !1,
            children: /* @__PURE__ */ V.jsxs(
              Hne,
              {
                "data-slot": "popover",
                open: W,
                onOpenChange: (le) => i || D ? !1 : Q(le),
                children: [
                  /* @__PURE__ */ V.jsx(Fne, { "data-slot": "popover-trigger", asChild: !0, disabled: !0, children: /* @__PURE__ */ V.jsx(sae, {}) }),
                  /* @__PURE__ */ V.jsx(
                    b6t,
                    {
                      onOpenAutoFocus: (le) => {
                        D && le.preventDefault();
                      },
                      className: lt(
                        "font-(family-name:--select-font) shadow-(--select-popover-shadow) rounded-(--select-popover-radius)",
                        "border-(--select-popover-border-color) p-(--select-popover-padding) bg-(--select-popover-background) border",
                        !T && "w-auto",
                        M
                      ),
                      children: c ? c(/* @__PURE__ */ V.jsx(GU, {})) : /* @__PURE__ */ V.jsx(GU, {})
                    }
                  )
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ V.jsx(
          "input",
          {
            "data-testid": `${r}${mle}`,
            type: "hidden",
            value: De
          }
        ),
        /* @__PURE__ */ V.jsx(
          "input",
          {
            id: `${_.current}${kN}`,
            "data-testid": `${r}${kN}`,
            type: "hidden",
            value: JSON.stringify(Me)
          }
        )
      ] }) })
    }
  );
}
var JM = "Switch", [z6t] = Eb(JM), [j6t, I6t] = z6t(JM), uae = S.forwardRef(
  (e, t) => {
    const {
      __scopeSwitch: r,
      name: a,
      checked: i,
      defaultChecked: c,
      required: d,
      disabled: f,
      value: p = "on",
      onCheckedChange: g,
      form: b,
      ...w
    } = e, [x, E] = S.useState(null), P = Wl(t, (D) => E(D)), k = S.useRef(!1), M = x ? b || !!x.closest("form") : !0, [T, N] = iC({
      prop: i,
      defaultProp: c ?? !1,
      onChange: g,
      caller: JM
    });
    return /* @__PURE__ */ V.jsxs(j6t, { scope: r, checked: T, disabled: f, children: [
      /* @__PURE__ */ V.jsx(
        Ro.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": T,
          "aria-required": d,
          "data-state": mae(T),
          "data-disabled": f ? "" : void 0,
          disabled: f,
          value: p,
          ...w,
          ref: P,
          onClick: io(e.onClick, (D) => {
            N(($) => !$), M && (k.current = D.isPropagationStopped(), k.current || D.stopPropagation());
          })
        }
      ),
      M && /* @__PURE__ */ V.jsx(
        fae,
        {
          control: x,
          bubbles: !k.current,
          name: a,
          value: p,
          checked: T,
          required: d,
          disabled: f,
          form: b,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
uae.displayName = JM;
var cae = "SwitchThumb", dae = S.forwardRef(
  (e, t) => {
    const { __scopeSwitch: r, ...a } = e, i = I6t(cae, r);
    return /* @__PURE__ */ V.jsx(
      Ro.span,
      {
        "data-state": mae(i.checked),
        "data-disabled": i.disabled ? "" : void 0,
        ...a,
        ref: t
      }
    );
  }
);
dae.displayName = cae;
var L6t = "SwitchBubbleInput", fae = S.forwardRef(
  ({
    __scopeSwitch: e,
    control: t,
    checked: r,
    bubbles: a = !0,
    ...i
  }, c) => {
    const d = S.useRef(null), f = Wl(d, c), p = NM(r), g = DM(t);
    return S.useEffect(() => {
      const b = d.current;
      if (!b) return;
      const w = window.HTMLInputElement.prototype, E = Object.getOwnPropertyDescriptor(
        w,
        "checked"
      ).set;
      if (p !== r && E) {
        const P = new Event("click", { bubbles: a });
        E.call(b, r), b.dispatchEvent(P);
      }
    }, [p, r, a]), /* @__PURE__ */ V.jsx(
      "input",
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: r,
        ...i,
        tabIndex: -1,
        ref: f,
        style: {
          ...i.style,
          ...g,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
fae.displayName = L6t;
function mae(e) {
  return e ? "checked" : "unchecked";
}
var H6t = uae, F6t = dae;
const W6t = lt(
  "peer inline-flex shrink-0 cursor-pointer items-center rounded-full border border-transparent",
  "transition-all duration-200 ease-in-out outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
  "data-[state=checked]:bg-[#3D5470] data-[state=unchecked]:bg-[rgba(0,0,0,0.25)]",
  "dark:data-[state=unchecked]:bg-[rgba(0,0,0,0.32)] shadow-xs disabled:cursor-not-allowed disabled:opacity-50"
), qU = {
  small: "h-5 w-9",
  medium: "h-6 w-11",
  large: "h-7 w-13"
}, V6t = lt(
  "pointer-events-none block rounded-full ring-0 transition-transform duration-200 ease-in-out",
  "bg-white dark:data-[state=unchecked]:bg-black dark:data-[state=checked]:bg-white"
), KU = {
  small: "h-4 w-4 data-[state=checked]:translate-x-[1.125rem]",
  medium: "h-5 w-5 data-[state=checked]:translate-x-[1.375rem]",
  large: "h-6 w-6 data-[state=checked]:translate-x-[1.625rem]"
};
function _6t({
  asChild: e = !1,
  checked: t,
  className: r,
  dataTestId: a,
  disabled: i = !1,
  defaultChecked: c,
  id: d,
  isError: f = !1,
  kind: p,
  name: g,
  onCheckedChange: b,
  onBlur: w,
  onChange: x,
  onClick: E,
  onFocus: P,
  onKeyDown: k,
  onKeyUp: M,
  onlyChangeOnBlur: T,
  size: N = "medium",
  style: D,
  switchLabel: $,
  switchValue: j = "on",
  title: I,
  width: L,
  required: F,
  value: _,
  theme: W,
  ...Q
}) {
  const [U, Y] = Wn(), G = mn(() => T && U !== void 0 ? U : t, [U, t, T]), J = mn(() => ({ ...D, width: L }), [D, L]), H = Cn(
    (X) => {
      if (T) {
        Y(X);
        return;
      }
      x?.(X, t), b?.(X);
    },
    [t, T, x, b]
  ), K = Cn(
    (X) => {
      w?.(X), T && U !== void 0 && (x?.(U, t), b?.(U), Y(void 0));
    },
    [
      U,
      t,
      T,
      w,
      x,
      b
    ]
  );
  return /* @__PURE__ */ V.jsx("span", { "data-preflight": !0, className: "contents", children: /* @__PURE__ */ V.jsxs(
    "label",
    {
      className: lt(
        "font-(family-name:--font-sans) group inline-flex items-center gap-2 align-middle",
        i ? "cursor-not-allowed" : "cursor-pointer"
      ),
      htmlFor: d,
      "data-slot": "switch-wrapper",
      children: [
        /* @__PURE__ */ V.jsx(
          H6t,
          {
            "aria-invalid": f,
            asChild: e,
            checked: G,
            defaultChecked: c,
            className: lt(
              W6t,
              qU[N] ?? qU.medium,
              f && "aria-invalid:border-[var(--input-error-border-color)] data-[state=checked]:border-[var(--input-error-border-color)] data-[state=unchecked]:border-[var(--input-error-border-color)] data-[state=checked]:bg-[var(--input-error-border-color)] data-[state=unchecked]:bg-[var(--input-error-border-color)]",
              r
            ),
            "data-slot": "switch",
            "data-testid": a,
            disabled: i,
            id: d,
            name: g,
            onBlur: K,
            onCheckedChange: H,
            onClick: E,
            onFocus: P,
            onKeyDown: k,
            onKeyUp: M,
            required: F,
            style: J,
            title: I,
            value: typeof _ == "string" ? _ : j,
            ...Q,
            children: /* @__PURE__ */ V.jsx(
              F6t,
              {
                className: lt(
                  V6t,
                  KU[N] ?? KU.medium,
                  "data-[state=unchecked]:translate-x-0"
                ),
                "data-slot": "switch-thumb"
              }
            )
          }
        ),
        $ ? /* @__PURE__ */ V.jsx(
          "span",
          {
            "aria-hidden": !$,
            className: lt(
              "text-sm text-[rgba(0,0,0,0.88)]",
              i && "opacity-60"
            ),
            "data-slot": "switch-label",
            children: $
          }
        ) : null
      ]
    }
  ) });
}
function B6t({
  className: e,
  disabled: t = !1,
  isError: r = !1,
  size: a = "medium",
  theme: i = "classic",
  dataTestId: c = `input-textarea-${Date.now()}`,
  onChange: d,
  ...f
}) {
  const p = (g) => {
    const b = g.target.value;
    d?.(b, f.value, g);
  };
  return /* @__PURE__ */ V.jsx("div", { "data-preflight": !0, className: "contents", children: /* @__PURE__ */ V.jsx(
    "textarea",
    {
      "data-slot": "textarea",
      "data-disabled": t,
      "data-invalid": r,
      "data-testid": c,
      className: lt(
        XI({
          size: a,
          theme: i
        }),
        "field-sizing-content overflow-auto transition-colors",
        "p-(--textarea-padding-y)",
        "placeholder:text-(--input-placeholder-color)",
        a === "small" && "min-h-(--textarea-min-height-sm)",
        a === "medium" && "min-h-(--textarea-min-height-md)",
        a === "large" && "min-h-(--textarea-min-height-lg)",
        e
      ),
      disabled: t,
      onChange: p,
      ...f
    }
  ) });
}
const hae = "hh:mm A";
function pae(e) {
  const { fontFamily: t, fontSize: r, colorPrimary: a, errorBg: i } = ste();
  return {
    components: {
      DatePicker: {
        fontSize: Number.parseInt(r)
      }
    },
    token: {
      colorPrimary: a,
      fontFamily: t,
      colorBgContainer: e ? i : ""
    }
  };
}
const U6t = ({
  value: e,
  isError: t = !1,
  format: r = hae,
  minuteStep: a = 1,
  use12Hours: i = !0,
  onChange: c,
  dataTestId: d,
  size: f,
  ...p
}) => {
  const g = (x) => {
    c(x?.format(r), e);
  }, b = mn(
    () => pae(t),
    [t]
  ), w = f === "medium" ? "middle" : f;
  return /* @__PURE__ */ V.jsx(tc, { theme: b, children: /* @__PURE__ */ V.jsx(
    b3,
    {
      format: r,
      minuteStep: a,
      use12Hours: i,
      value: e ? Vf(e) : void 0,
      onChange: g,
      size: w,
      ...p,
      "data-testid": d
    }
  ) });
}, X6t = ({
  value: e,
  isError: t = !1,
  format: r = hae,
  minuteStep: a = 1,
  use12Hours: i = !0,
  disabled: c = !1,
  onChange: d,
  dataTestId: f,
  size: p,
  placeholder: g,
  placeholder2: b,
  ...w
}) => {
  const x = (M, T) => {
    d(T, e);
  }, E = mn(
    () => pae(t),
    [t]
  ), P = mn(() => {
    if (g && b)
      return [g, b];
    if (g && !b)
      return [g, ""];
    if (!g && b)
      return ["", b];
  }, [g, b]), k = p === "medium" ? "middle" : p;
  return /* @__PURE__ */ V.jsx(tc, { theme: E, children: /* @__PURE__ */ V.jsx(
    b3.RangePicker,
    {
      format: r,
      minuteStep: a,
      use12Hours: i,
      disabled: c,
      value: e && e.every((M) => !!M) ? [Vf(e[0], r), Vf(e[1], r)] : void 0,
      onChange: x,
      allowEmpty: c ? [!0, !0] : void 0,
      size: k,
      placeholder: P,
      ...w,
      "data-testid": f
    }
  ) });
}, STt = [
  "autoComplete",
  "checkbox",
  "checkbox-group",
  "currency",
  "date",
  "email",
  "file",
  "month",
  "number",
  "password",
  "radio",
  "radio-group",
  "range",
  "search",
  "select",
  "switch",
  "tel",
  "text",
  "textarea",
  "time",
  "time-range",
  "url"
], sS = ({
  ...e
}) => {
  const t = mn(() => {
    if (e.kind === "radio-group")
      return;
    let i;
    switch (e.size) {
      case "small": {
        i = "--input-component-small-height";
        break;
      }
      case "large": {
        i = "--input-component-large-height";
        break;
      }
      default: {
        i = "--input-component-medium-height";
        break;
      }
    }
    return mr(i);
  }, [e.size, e.kind]), r = e.kind, a = e.width;
  switch (e.kind) {
    case "text":
    case "email":
    case "tel":
    case "url":
    case "search":
      return /* @__PURE__ */ V.jsx(qM, { ...e, style: { height: t, width: a } });
    case "password":
      return /* @__PURE__ */ V.jsx(X3t, { ...e, style: { height: t, width: a } });
    case "textarea":
      return /* @__PURE__ */ V.jsx(B6t, { ...e, style: { height: t, width: a } });
    case "select":
      return /* @__PURE__ */ V.jsx($6t, { ...e, style: { height: t, width: a } });
    case "autoComplete":
      return /* @__PURE__ */ V.jsx(zMe, { ...e, style: { height: t, width: a } });
    case "date":
    case "month":
      return /* @__PURE__ */ V.jsx(M3t, { ...e, style: { height: t, width: a } });
    case "radio-group": {
      const i = { ...e };
      return e.type === "button" && !e.displayType && (delete i.type, i.displayType = "button"), /* @__PURE__ */ V.jsx(
        Cxt,
        {
          ...i,
          style: { height: t, width: a }
        }
      );
    }
    case "radio":
      return /* @__PURE__ */ V.jsx(G3t, { ...e, style: { height: t, width: a } });
    case "currency":
    case "number":
      return /* @__PURE__ */ V.jsx(H3t, { ...e, style: { height: t, width: a } });
    case "checkbox": {
      const { isError: i, ...c } = e;
      return /* @__PURE__ */ V.jsx(bte, { ...c });
    }
    case "checkbox-group": {
      const { isError: i, ...c } = e;
      return /* @__PURE__ */ V.jsx(vOe, { ...c });
    }
    case "switch":
      return /* @__PURE__ */ V.jsx(_6t, { ...e });
    case "time":
      return /* @__PURE__ */ V.jsx(U6t, { ...e, style: { height: t, width: a } });
    case "time-range":
      return /* @__PURE__ */ V.jsx(X6t, { ...e, style: { height: t, width: a } });
    default:
      return /* @__PURE__ */ V.jsxs("span", { children: [
        " ",
        r,
        " is an unrecognized Kind "
      ] });
  }
}, G6t = ({
  addInput: e,
  dataTestId: t,
  isLast: r,
  removeInput: a,
  ...i
}) => {
  const { t: c } = xz();
  return /* @__PURE__ */ V.jsxs("div", { className: lt("gap-(--input-set-spacing) flex w-full items-center"), children: [
    /* @__PURE__ */ V.jsx(
      sS,
      {
        ...i,
        className: lt("flex-1"),
        dataTestId: t
      }
    ),
    /* @__PURE__ */ V.jsxs(
      "div",
      {
        className: lt(
          "gap-(--input-set-spacing) flex flex-none items-center justify-between"
        ),
        children: [
          r && /* @__PURE__ */ V.jsx(
            "button",
            {
              "aria-label": c("inputSet.addInput"),
              "data-role": "add",
              "data-testid": `${t}-add`,
              onClick: e,
              disabled: !i.value,
              children: "➕"
            }
          ),
          /* @__PURE__ */ V.jsx(
            "button",
            {
              "aria-label": c("inputSet.removeInput"),
              "data-role": "delete",
              "data-testid": `${t}-delete`,
              onClick: a,
              children: "🗑️"
            }
          )
        ]
      }
    )
  ] });
};
function tL({
  dataTestId: e,
  kind: t,
  values: r,
  onChange: a,
  ...i
}) {
  const [c, d] = Wn(
    r === void 0 ? [] : r
  );
  Er(() => {
    r && d(r);
  }, [r]);
  const f = Cn(
    (w, x, E, P) => {
      if (E !== void 0 && x === E)
        return;
      const k = [...c];
      k.splice(w, 1, x), d(k), a(k, c, P);
    },
    [c, a]
  ), p = Cn(() => {
    d([...c, YU(t)]);
  }, [t, c]), g = Cn(
    (w) => {
      const x = [...c];
      x.splice(w, 1), d(x), a(x, c);
    },
    [c, a]
  ), b = (c.length > 0 ? c : [YU(t)]).map((w, x, E) => {
    const P = {
      addInput: p,
      array: E,
      dataTestId: `${e}-${x}`,
      isLast: x === c.length - 1,
      kind: t,
      onChange: f.bind(
        void 0,
        x
      ),
      removeInput: g.bind(void 0, x),
      value: w,
      id: `${e}-${x}`,
      ...i
    };
    return /* @__PURE__ */ V.jsx(G6t, { ...P }, x);
  });
  return /* @__PURE__ */ V.jsx(
    "div",
    {
      "data-slot": "input-set",
      "data-testid": e,
      className: lt(
        "gap-(--input-set-spacing) flex w-full flex-col items-start"
      ),
      children: b
    }
  );
}
function YU(e) {
  switch (e) {
    case "text":
    case "email":
    case "tel":
    case "url":
    case "search":
    case "password":
    case "textarea":
      return "";
    case "select":
      return;
    case "date":
    case "month":
      return /* @__PURE__ */ new Date();
    default:
      throw new TypeError(`Unknown kind ${e}`);
  }
}
fG(tL);
const q6t = ({
  inputs: e = [],
  delimiter: t = "-",
  inputSplitClassName: r,
  inputSplitId: a = "input-split",
  numericAsStrings: i,
  size: c
}) => {
  const d = It([]);
  return /* @__PURE__ */ V.jsx(
    "div",
    {
      className: lt("flex items-center", r),
      id: a,
      children: e.map((f, p) => {
        function g(w) {
          let x = w.length;
          i ? /^-?\d*(\.\d*)?$/.test(w) || w === "" || w === "-" ? f.onChange?.(w) : x > 0 && (x -= 1) : f.onChange?.(w), f.maxLength && x === f.maxLength && p + 1 < e.length && d.current[p + 1]?.focus();
        }
        function b(w) {
          f.value === "" && w.code === "Backspace" && d.current[p - 1]?.focus();
        }
        return p > 0 ? /* @__PURE__ */ V.jsxs(qL, { children: [
          t,
          /* @__PURE__ */ V.jsx(
            sS,
            {
              width: f.width ?? "50px",
              size: c,
              ...f,
              innerRef: (w) => {
                d.current[p] = w;
              },
              onChange: (w) => g(w),
              onKeyDown: (w) => b(w)
            },
            `${a}_${p}`
          )
        ] }, p) : /* @__PURE__ */ V.jsx(qL, { children: /* @__PURE__ */ V.jsx(
          sS,
          {
            width: f.width ?? "50px",
            size: c,
            ...f,
            innerRef: (w) => {
              d.current[p] = w;
            },
            onChange: (w) => g(w)
          },
          `${a}_${p}`
        ) }, p);
      })
    }
  );
}, CTt = (e) => {
  const { children: t, to: r, onClick: a, newTab: i = !1 } = e, c = i ? "_blank" : "_self";
  return /* @__PURE__ */ V.jsx(hle, { to: r, target: c, onClick: a, children: t });
}, K6t = fl(
  lt(
    "absolute scale-75 rounded-full bg-current opacity-30",
    "[&:nth-child(2)]:bottom-0 [&:nth-child(3)]:bottom-0",
    "[&:nth-child(1)]:right-0 [&:nth-child(3)]:right-0",
    "animate-loader-dot-fade",
    "[&:nth-child(1)]:[animation-delay:0.4s] [&:nth-child(2)]:[animation-delay:1.2s] [&:nth-child(3)]:[animation-delay:0.8s]"
  ),
  {
    variants: {
      size: {
        small: "h-(--loading-dot-size-small) w-(--loading-dot-size-small)",
        medium: "h-(--loading-dot-size-medium) w-(--loading-dot-size-medium)",
        large: "h-(--loading-dot-size-large) w-(--loading-dot-size-large)"
      }
    },
    defaultVariants: { size: "medium" }
  }
), OP = ({ size: e }) => /* @__PURE__ */ V.jsx("span", { "aria-hidden": "true", className: K6t({ size: e }) }), Y6t = fl("animate-loader-spin relative", {
  variants: {
    size: {
      small: "h-(--loading-spinner-size-small) w-(--loading-spinner-size-small)",
      medium: "h-(--loading-spinner-size-medium) w-(--loading-spinner-size-medium)",
      large: "h-(--loading-spinner-size-large) w-(--loading-spinner-size-large)"
    }
  },
  defaultVariants: { size: "medium" }
}), QU = ({
  label: e,
  size: t = "medium",
  spinnerClassName: r,
  ariaLabel: a
}) => {
  const i = mG(), c = e ? { "aria-labelledby": i } : { "aria-label": a ?? "Loading" };
  return /* @__PURE__ */ V.jsxs(
    "div",
    {
      className: lt(
        "text-(size:--loader-label-text-size) leading-(--loader-label-line-height) text-(--loader-color)",
        "flex flex-col items-center justify-center font-sans"
      ),
      role: "status",
      "aria-atomic": "true",
      ...c,
      children: [
        /* @__PURE__ */ V.jsxs("span", { className: lt(Y6t({ size: t }), r), children: [
          /* @__PURE__ */ V.jsx(OP, { size: t }),
          /* @__PURE__ */ V.jsx(OP, { size: t }),
          /* @__PURE__ */ V.jsx(OP, { size: t }),
          /* @__PURE__ */ V.jsx(OP, { size: t })
        ] }),
        e && /* @__PURE__ */ V.jsx("span", { id: i, className: "pt-(--loader-label-top-gap) text-center", children: e })
      ]
    }
  );
}, xTt = ({
  label: e,
  size: t = "medium",
  loading: r = !0,
  overlay: a = !1,
  children: i,
  wrapperClassName: c,
  spinnerClassName: d,
  overlayClassName: f,
  "aria-label": p,
  testId: g = "loading"
}) => a ? /* @__PURE__ */ V.jsxs(
  "div",
  {
    "data-testid": g,
    className: lt("relative", c),
    "aria-busy": r || void 0,
    children: [
      /* @__PURE__ */ V.jsx(
        "div",
        {
          className: lt(
            "transition-opacity duration-200",
            r ? "opacity-(--loader-children-opacity) pointer-events-none" : "opacity-100"
          ),
          children: i
        }
      ),
      r && // Scope reset to spinner only
      /* @__PURE__ */ V.jsx("div", { "data-preflight": !0, className: "contents", children: /* @__PURE__ */ V.jsx(
        "div",
        {
          className: lt(
            "absolute inset-0 flex items-center justify-center",
            // Intercept clicks while loading (set to pointer-events-none for passthrough)
            "pointer-events-auto",
            f
          ),
          children: /* @__PURE__ */ V.jsx("div", { className: "relative z-10", children: /* @__PURE__ */ V.jsx(
            QU,
            {
              label: e,
              size: t,
              spinnerClassName: d,
              ariaLabel: p
            }
          ) })
        }
      ) })
    ]
  }
) : /* @__PURE__ */ V.jsx(
  "div",
  {
    "data-testid": g,
    className: lt(c),
    "aria-busy": r || void 0,
    children: r ? (
      // Scope reset to spinner only
      /* @__PURE__ */ V.jsx("div", { "data-preflight": !0, className: "contents", children: /* @__PURE__ */ V.jsx("div", { className: "flex h-full w-full items-center justify-center", children: /* @__PURE__ */ V.jsx(
        QU,
        {
          label: e,
          size: t,
          spinnerClassName: d,
          ariaLabel: p
        }
      ) }) })
    ) : i
  }
), Q6t = {
  dataTestId: "Menu-default",
  allowDeselect: !0,
  handleOpenChange: void 0,
  handleSelect: void 0,
  inline: !1,
  items: [],
  menuRootRef: {
    current: void 0
  },
  multiple: !0,
  onClick: void 0,
  openKeys: [],
  orientation: void 0,
  selectedKeys: []
}, nL = fp(Q6t);
function gae(e, t, r) {
  const { removeIfExists: a, singleSelect: i = !1 } = r;
  return e.includes(t) ? a ? e.filter((d) => d !== t) : e : i ? [t] : [...e, t];
}
function vae(e, t, r = []) {
  for (const a of t) {
    if (a.key === e)
      return {
        item: a,
        key: e,
        keyPath: [...r, e]
      };
    const i = vae(e, a.children || [], [...r, a.key]);
    if (i)
      return i;
  }
}
function bae(e, t) {
  for (const r of t) {
    if (r.key === e)
      return t;
    const a = bae(e, r.children ?? []);
    if (a)
      return a;
  }
}
function J6t(e) {
  return typeof CSS < "u" && typeof CSS.escape == "function" ? CSS.escape(e) : e.replaceAll("\\", "\\\\").replaceAll('"', '\\"');
}
function m9(e, t) {
  if (!e)
    return;
  const a = `[data-slot="menubar-item"][data-key="${J6t(e)}"] > [data-slot="menubar-item-button"]`;
  (t ?? document).querySelector(a)?.focus();
}
function JU(e, t, r, a) {
  if (!e)
    return;
  const i = e.findIndex((p) => p.key === t.key);
  if (i === -1)
    return;
  let c = i + r;
  c < 0 ? c = e.length - 1 : c >= e.length && (c = 0);
  const f = e[c].key;
  m9(f, a);
}
function Z6t(e, t) {
  const r = [];
  function a(i) {
    for (const c of i)
      r.push({ key: c.key }), c.children?.length && t.includes(c.key) && a(c.children);
  }
  return a(e), r;
}
function ZU(e, t, r) {
  return e instanceof Node ? !!(t?.closest('[data-slot="menubar-item"]')?.contains(e) || r?.contains(e)) : !1;
}
function e8t(e, t) {
  if (!e?.length)
    return;
  const a = e[0]?.key;
  m9(a, t);
}
const yae = /* @__PURE__ */ new Set(["Enter", " "]), wae = /* @__PURE__ */ new Set(["Enter", " ", "ArrowRight"]), t8t = /* @__PURE__ */ new Set([
  ...yae,
  ...wae,
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "Escape"
]);
function n8t({
  event: e,
  item: t,
  items: r,
  onActivate: a,
  onClose: i,
  openSubmenu: c,
  inline: d,
  visibleItemsInOrder: f,
  menuRoot: p
}) {
  const { key: g } = e ?? {};
  if (t8t.has(g))
    switch (e?.preventDefault(), wae.has(g) && c ? (FS(() => {
      c();
    }), e8t(t.children, p)) : yae.has(g) && a(), g) {
      case "ArrowUp": {
        if (d && f?.length) {
          const b = f.findIndex(
            (w) => w.key === t.key
          );
          if (b >= 0) {
            const w = (b - 1 + f.length) % f.length;
            m9(f[w].key, p);
          }
        } else
          JU(r, t, -1, p);
        break;
      }
      case "ArrowDown": {
        if (d && f?.length) {
          const b = f.findIndex(
            (w) => w.key === t.key
          );
          if (b >= 0) {
            const w = (b + 1) % f.length;
            m9(f[w].key, p);
          }
        } else
          JU(r, t, 1, p);
        break;
      }
      case "ArrowLeft":
      case "Escape": {
        i?.();
        break;
      }
    }
}
function r8t(e, t = 5) {
  return e <= 0 ? "var(--menu-item-color-inactive)" : `color-mix(in srgb, var(--menu-item-color-inactive) ${Math.pow(1 - t / 100, e) * 100}%, black)`;
}
function a8t(e = 100) {
  const t = It(), r = It(e);
  r.current = e, Er(() => () => clearTimeout(t.current), []);
  const a = Cn((c) => {
    clearTimeout(t.current), t.current = setTimeout(() => {
      t.current = void 0, c();
    }, r.current);
  }, []), i = Cn(() => {
    clearTimeout(t.current), t.current = void 0;
  }, []);
  return mn(() => ({ start: a, clear: i }), [a, i]);
}
function o8t({
  defaultOpenKeys: e,
  inline: t,
  menuRootRef: r,
  onOpenChange: a
}) {
  const [i, c] = Wn(e), d = Cn(
    (p, g) => {
      c((b) => {
        if (!g && !b.includes(p))
          return b;
        const w = gae(b, p, {
          removeIfExists: !g
        });
        return a?.(w), w;
      });
    },
    [a]
  ), f = Cn(() => {
    c([]), a?.([]);
  }, [a]);
  return Er(() => {
    if (t || i.length === 0)
      return;
    const p = (g) => {
      const b = g.target;
      r.current?.contains(b) || b instanceof Element && b.closest("[data-submenu-popup]") || f();
    };
    return document.addEventListener("mousedown", p), () => document.removeEventListener("mousedown", p);
  }, [t, i.length, f, r]), { openKeys: i, handleOpenChange: d };
}
function i8t({
  allowDeselect: e,
  controlledSelectedKeys: t,
  defaultSelectedKeys: r = [],
  multiple: a,
  onSelect: i
}) {
  const [c, d] = Wn(r);
  Er(() => {
    if (t === void 0)
      return;
    const p = Array.isArray(t) ? t : [t];
    d((g) => g.length === p.length && g.every((b, w) => b === p[w]) ? g : p);
  }, [t]);
  const f = Cn(
    (p) => {
      const g = p?.key ?? "";
      g && d((b) => {
        const w = gae(b, g, {
          removeIfExists: e,
          singleSelect: !a
        });
        if (i && p && w !== b) {
          const E = w.includes(g);
          i(g, E);
        }
        return w;
      });
    },
    [e, a, i]
  );
  return { selectedKeys: c, handleSelect: f };
}
function l8t({
  closeTimer: e,
  handleOpenChange: t,
  key: r,
  open: a,
  propertyOnClick: i,
  triggerButtonReference: c
}) {
  const d = Cn(() => {
    e.clear(), t?.(r, !0);
  }, [e, t, r]), f = Cn(() => {
    t?.(r, !1);
  }, [t, r]), p = Cn(() => {
    t?.(r, !1), c.current?.focus();
  }, [t, r, c]), g = Cn(() => {
    e.start(f);
  }, [f, e]), b = Cn(() => {
    i?.(r), a ? (e.clear(), t?.(r, !1)) : d();
  }, [e, t, r, a, d, i]);
  return {
    openSubmenu: d,
    closeThisSubmenu: f,
    closeAndFocusTrigger: p,
    handleMouseLeave: g,
    onActivate: b
  };
}
function s8t({
  closeTimer: e,
  closeThisSubmenu: t,
  popupReference: r,
  triggerButtonReference: a
}) {
  const [i, c] = Wn(!1), d = Cn(() => {
    c(!0);
  }, []), f = Cn(() => {
    c(!1);
  }, []), p = Cn(() => {
    c(!0), e.clear();
  }, [e]), g = Cn(
    (w) => {
      c(!1), !ZU(
        w.relatedTarget,
        a.current,
        r.current
      ) && e.start(t);
    },
    [t, e, a, r]
  ), b = Cn(
    (w) => {
      ZU(
        w.relatedTarget,
        a.current,
        r.current
      ) || e.start(t);
    },
    [t, e, a, r]
  );
  return {
    focused: i,
    handleInlineTriggerFocus: d,
    handleInlineTriggerBlur: f,
    handleTriggerFocus: p,
    handleTriggerBlur: g,
    handlePopupBlur: b
  };
}
function Sae(e, t = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set()) {
  for (const a of e)
    if (t.has(a.key) ? r.add(a.key) : t.add(a.key), a.children?.length) {
      const i = Sae(a.children, t, r);
      if (i?.size)
        for (const c of i)
          r.add(c);
    }
  return r?.size ? r : void 0;
}
const u8t = fl(
  lt([
    // SVG descendants — inline-block overrides Tailwind preflight under [data-preflight]
    // (`svg { display: block }`), which would stack chevrons below submenu labels.
    "[&_svg:not([class*='text-'])]:text-muted-foreground [&_svg:not([class*='size-'])]:size-4 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg]:inline-block",
    // Layout (min-w-0 allows truncation in flex context). Stretch children to full row
    // width — items-center would shrink/center the button so labels looked horizontally centered.
    "relative flex min-w-0 flex-col select-none items-stretch",
    // Background (nested items use compound darkening via inline style)
    "bg-(--menu-item-background-color)",
    // Border
    "box-border",
    "border-(--menu-item-border-color)",
    "border-t-(length:--menu-item-border-width-top)",
    "border-r-(length:--menu-item-border-width-right)",
    "border-b-(length:--menu-item-border-width-bottom)",
    "border-l-(length:--menu-item-border-width-left)",
    "rounded-(--menu-item-border-radius)",
    "divide-solid",
    // Spacing
    "gap-(--menu-item-gap) p-0 mx-(--menu-item-margin-x) my-(--menu-item-margin-y)",
    "min-h-(--menu-item-height)",
    // Text (inherited by label content; avoid truncate on the flex li — it interacted poorly with full-width buttons)
    "text-(length:--menu-item-font-size)",
    // Cursor
    "cursor-pointer",
    // Hover
    "hover:border-(--menu-item-border-color-hover)",
    // Disabled
    "data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
    // Focus ring on keyboard navigation only. Inset outline (negative offset) stays within
    // the element so it isn't clipped by overflow-hidden on parent panels or covered by siblings.
    "has-[:focus-visible]:outline has-[:focus-visible]:outline-(length:--menu-item-border-width-focus) has-[:focus-visible]:outline-(--menu-item-border-color-focus) has-[:focus-visible]:outline-offset-[-2px]",
    "has-[:focus-visible]:z-10",
    // Destructive variant
    "data-[variant=destructive]:text-destructive data-[variant=destructive]:focus:bg-destructive/10 dark:data-[variant=destructive]:focus:bg-destructive/20 data-[variant=destructive]:focus:text-destructive data-[variant=destructive]:*:[svg]:!text-destructive",
    // Inset variant
    "data-[inset]:pl-8"
  ]),
  {
    variants: {
      selected: {
        true: [
          "border-(--menu-item-border-color-active)",
          "hover:bg-(--menu-item-background-color-active)",
          "hover:border-(--menu-item-border-color-active)",
          "hover:text-(--menu-item-text-color-active)"
        ],
        false: ""
      }
    }
  }
), c8t = fl(
  lt([
    // Layout (min-w-0 allows truncation in flex context). gap-1 separates optional leading icon from label.
    "flex min-w-0 flex-row items-center justify-start gap-1 text-left",
    // Size
    "h-(--menu-item-height) w-full",
    // Spacing
    "m-0 px-(--menu-item-padding-x) py-(--menu-item-padding-y)",
    // Appearance
    "border-none bg-transparent cursor-pointer select-none",
    // Text (truncation lives on the inner label span only — truncate on the flex button broke row width in CAPS)
    "text-(--menu-item-text-color) text-(length:--menu-item-font-size)",
    // Hover
    "hover:animate-(--animate-menu-item-active)",
    "hover:text-(--menu-item-text-color-hover)",
    // Keyboard focus only (not mouse click focus)
    "focus-visible:animate-(--animate-menu-item-active)",
    "focus-visible:text-(--menu-item-text-color-focus)",
    // Suppress browser default outline; focus ring is on the parent li
    "focus-visible:outline-none"
  ]),
  {
    variants: {
      selected: {
        true: [
          "bg-(--menu-item-background-color-active)",
          "text-(--menu-item-text-color-active)",
          "hover:bg-(--menu-item-background-color-active)",
          "hover:text-(--menu-item-text-color-active)"
        ],
        false: ""
      }
    }
  }
), X$ = ks(
  function({
    blurCallback: t,
    closeCallback: r,
    children: a,
    className: i,
    depth: c = 0,
    focusCallback: d,
    inset: f,
    item: p,
    onActivate: g,
    openSubmenu: b,
    submenu: w,
    variant: x = "default",
    ...E
  }, P) {
    const { icon: k, key: M, label: T } = p, {
      dataTestId: N,
      inline: D,
      items: $,
      menuRootRef: j,
      selectedKeys: I,
      visibleItemsInOrder: L,
      handleSelect: F,
      onClick: _
    } = Do(nL), W = mn(
      () => I.includes(M),
      [I, M]
    ), Q = Cn(() => {
      g ? g() : (_?.(M), F?.(vae(M, $)));
    }, [F, $, M, g, _]), U = Cn(
      (G) => n8t({
        event: G,
        item: p,
        items: bae(M, $) ?? [],
        onActivate: Q,
        onClose: r,
        openSubmenu: b,
        inline: D,
        visibleItemsInOrder: L,
        // Popover submenus render in a portal outside the menu tree,
        // so scoping keyboard navigation to menuRoot would miss them.
        menuRoot: D ? j.current : void 0
      }),
      [
        r,
        D,
        p,
        $,
        M,
        j,
        Q,
        b,
        L
      ]
    ), Y = c > 0 ? r8t(c) : void 0;
    return /* @__PURE__ */ V.jsxs(
      "li",
      {
        ...E,
        className: lt(u8t({ selected: W }), i),
        "data-key": M,
        "data-selected": W,
        "data-slot": "menubar-item",
        "data-inset": f,
        "data-testid": `${N}-${M}`,
        "data-variant": x,
        style: {
          ...E.style,
          ...Y && { backgroundColor: Y }
        },
        tabIndex: -1,
        children: [
          /* @__PURE__ */ V.jsxs(
            "button",
            {
              className: lt(c8t({ selected: W }), i),
              "data-slot": "menubar-item-button",
              "data-testid": `${N}-${M}-button`,
              role: "menuitem",
              onBlur: t,
              onFocus: d,
              onClick: Q,
              onKeyDown: U,
              ref: P,
              style: {
                width: E.style?.width,
                paddingLeft: c ? `calc(var(--menu-item-padding-x) + ${c} * var(--menu-nested-offset))` : void 0
              },
              tabIndex: 0,
              children: [
                k ? /* @__PURE__ */ V.jsx("span", { className: "shrink-0", children: k }) : null,
                T == null ? null : /* @__PURE__ */ V.jsx("span", { className: "w-full min-w-0 flex-1 basis-0 truncate text-left", children: T }),
                a
              ]
            }
          ),
          w && /* @__PURE__ */ V.jsx("div", { className: "w-full", children: w })
        ]
      }
    );
  }
), eX = {};
function am(e, t) {
  const r = S.useRef(eX);
  return r.current === eX && (r.current = e(t)), r;
}
const QA = S[`useInsertionEffect${Math.random().toFixed(1)}`.slice(0, -3)], d8t = (
  // React 17 doesn't have useInsertionEffect.
  QA && // Preact replaces useInsertionEffect with useLayoutEffect and fires too late.
  QA !== S.useLayoutEffect ? QA : (e) => e()
);
function Ar(e) {
  const t = am(f8t).current;
  return t.next = e, d8t(t.effect), t.trampoline;
}
function f8t() {
  const e = {
    next: void 0,
    callback: m8t,
    trampoline: (...t) => e.callback?.(...t),
    effect: () => {
      e.callback = e.next;
    }
  };
  return e;
}
function m8t() {
  if (process.env.NODE_ENV !== "production")
    throw (
      /* minify-error-disabled */
      new Error("Base UI: Cannot call an event handler while rendering.")
    );
}
function ud(e, ...t) {
  const r = new URL("https://base-ui.com/production-error");
  return r.searchParams.set("code", e.toString()), t.forEach((a) => r.searchParams.append("args[]", a)), `Base UI error #${e}; visit ${r} for the full message.`;
}
function l3(e, t, r, a) {
  const i = am(Cae).current;
  return p8t(i, e, t, r, a) && xae(i, [e, t, r, a]), i.callback;
}
function h8t(e) {
  const t = am(Cae).current;
  return g8t(t, e) && xae(t, e), t.callback;
}
function Cae() {
  return {
    callback: null,
    cleanup: null,
    refs: []
  };
}
function p8t(e, t, r, a, i) {
  return e.refs[0] !== t || e.refs[1] !== r || e.refs[2] !== a || e.refs[3] !== i;
}
function g8t(e, t) {
  return e.refs.length !== t.length || e.refs.some((r, a) => r !== t[a]);
}
function xae(e, t) {
  if (e.refs = t, t.every((r) => r == null)) {
    e.callback = null;
    return;
  }
  e.callback = (r) => {
    if (e.cleanup && (e.cleanup(), e.cleanup = null), r != null) {
      const a = Array(t.length).fill(null);
      for (let i = 0; i < t.length; i += 1) {
        const c = t[i];
        if (c != null)
          switch (typeof c) {
            case "function": {
              const d = c(r);
              typeof d == "function" && (a[i] = d);
              break;
            }
            case "object": {
              c.current = r;
              break;
            }
          }
      }
      e.cleanup = () => {
        for (let i = 0; i < t.length; i += 1) {
          const c = t[i];
          if (c != null)
            switch (typeof c) {
              case "function": {
                const d = a[i];
                typeof d == "function" ? d() : c(null);
                break;
              }
              case "object": {
                c.current = null;
                break;
              }
            }
        }
      };
    }
  };
}
const v8t = parseInt(S.version, 10);
function rL(e) {
  return v8t >= e;
}
function tX(e) {
  if (!/* @__PURE__ */ S.isValidElement(e))
    return null;
  const t = e, r = t.props;
  return (rL(19) ? r?.ref : t.ref) ?? null;
}
function G$(e, t) {
  if (e && !t)
    return e;
  if (!e && t)
    return t;
  if (e || t)
    return {
      ...e,
      ...t
    };
}
function b8t(e, t) {
  const r = {};
  for (const a in e) {
    const i = e[a];
    if (t?.hasOwnProperty(a)) {
      const c = t[a](i);
      c != null && Object.assign(r, c);
      continue;
    }
    i === !0 ? r[`data-${a.toLowerCase()}`] = "" : i && (r[`data-${a.toLowerCase()}`] = i.toString());
  }
  return r;
}
function y8t(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function w8t(e, t) {
  return typeof e == "function" ? e(t) : e;
}
const gE = {};
function Eae(e, t, r, a, i) {
  let c = {
    ...q$(e, gE)
  };
  return t && (c = Mk(c, t)), r && (c = Mk(c, r)), a && (c = Mk(c, a)), c;
}
function S8t(e) {
  if (e.length === 0)
    return gE;
  if (e.length === 1)
    return q$(e[0], gE);
  let t = {
    ...q$(e[0], gE)
  };
  for (let r = 1; r < e.length; r += 1)
    t = Mk(t, e[r]);
  return t;
}
function Mk(e, t) {
  return Pae(t) ? t(e) : C8t(e, t);
}
function C8t(e, t) {
  if (!t)
    return e;
  for (const r in t) {
    const a = t[r];
    switch (r) {
      case "style": {
        e[r] = G$(e.style, a);
        break;
      }
      case "className": {
        e[r] = kae(e.className, a);
        break;
      }
      default:
        x8t(r, a) ? e[r] = E8t(e[r], a) : e[r] = a;
    }
  }
  return e;
}
function x8t(e, t) {
  const r = e.charCodeAt(0), a = e.charCodeAt(1), i = e.charCodeAt(2);
  return r === 111 && a === 110 && i >= 65 && i <= 90 && (typeof t == "function" || typeof t > "u");
}
function Pae(e) {
  return typeof e == "function";
}
function q$(e, t) {
  return Pae(e) ? e(t) : e ?? gE;
}
function E8t(e, t) {
  return t ? e ? (r) => {
    if (P8t(r)) {
      const i = r;
      K$(i);
      const c = t(i);
      return i.baseUIHandlerPrevented || e?.(i), c;
    }
    const a = t(r);
    return e?.(r), a;
  } : t : e;
}
function K$(e) {
  return e.preventBaseUIHandler = () => {
    e.baseUIHandlerPrevented = !0;
  }, e;
}
function kae(e, t) {
  return t ? e ? t + " " + e : t : e;
}
function P8t(e) {
  return e != null && typeof e == "object" && "nativeEvent" in e;
}
function Mae() {
}
const Y$ = Object.freeze([]), Gh = Object.freeze({}), k8t = 500, M8t = {
  style: {
    transition: "none"
  }
}, Oae = "data-base-ui-click-trigger", Tae = {
  fallbackAxisSide: "end"
}, O8t = {
  clipPath: "inset(50%)",
  position: "fixed",
  top: 0,
  left: 0
};
function nc(e, t, r = {}) {
  const a = t.render, i = T8t(t, r);
  if (r.enabled === !1)
    return null;
  const c = r.state ?? Gh;
  return A8t(e, a, i, c);
}
function T8t(e, t = {}) {
  const {
    className: r,
    style: a,
    render: i
  } = e, {
    state: c = Gh,
    ref: d,
    props: f,
    stateAttributesMapping: p,
    enabled: g = !0
  } = t, b = g ? y8t(r, c) : void 0, w = g ? w8t(a, c) : void 0, x = g ? b8t(c, p) : Gh, E = g ? G$(x, Array.isArray(f) ? S8t(f) : f) ?? Gh : Gh;
  return typeof document < "u" && (g ? Array.isArray(d) ? E.ref = h8t([E.ref, tX(i), ...d]) : E.ref = l3(E.ref, tX(i), d) : l3(null, null)), g ? (b !== void 0 && (E.className = kae(E.className, b)), w !== void 0 && (E.style = G$(E.style, w)), E) : Gh;
}
const R8t = Symbol.for("react.lazy");
function A8t(e, t, r, a) {
  if (t) {
    if (typeof t == "function")
      return t(r, a);
    const i = Eae(r, t.props);
    i.ref = r.ref;
    let c = t;
    if (c?.$$typeof === R8t && (c = S.Children.toArray(t)[0]), process.env.NODE_ENV !== "production" && !/* @__PURE__ */ S.isValidElement(c))
      throw new Error(["Base UI: The `render` prop was provided an invalid React element as `React.isValidElement(render)` is `false`.", "A valid React element must be provided to the `render` prop because it is cloned with props to replace the default element.", "https://base-ui.com/r/invalid-render-prop"].join(`
`));
    return /* @__PURE__ */ S.cloneElement(c, i);
  }
  if (e && typeof e == "string")
    return N8t(e, r);
  throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: Render element or function are not defined." : ud(8));
}
function N8t(e, t) {
  return e === "button" ? /* @__PURE__ */ SE("button", {
    type: "button",
    ...t,
    key: t.key
  }) : e === "img" ? /* @__PURE__ */ SE("img", {
    alt: "",
    ...t,
    key: t.key
  }) : /* @__PURE__ */ S.createElement(e, t);
}
function Rae({
  controlled: e,
  default: t,
  name: r,
  state: a = "value"
}) {
  const {
    current: i
  } = S.useRef(e !== void 0), [c, d] = S.useState(t), f = i ? e : c;
  if (process.env.NODE_ENV !== "production") {
    S.useEffect(() => {
      i !== (e !== void 0) && console.error([`Base UI: A component is changing the ${i ? "" : "un"}controlled ${a} state of ${r} to be ${i ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${r} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [a, r, e]);
    const {
      current: g
    } = S.useRef(t);
    S.useEffect(() => {
      !i && JSON.stringify(g) !== JSON.stringify(t) && console.error([`Base UI: A component is changing the default ${a} state of an uncontrolled ${r} after being initialized. To suppress this warning opt to use a controlled ${r}.`].join(`
`));
    }, [JSON.stringify(t)]);
  }
  const p = S.useCallback((g) => {
    i || d(g);
  }, []);
  return [f, p];
}
const D8t = () => {
}, Dr = typeof document < "u" ? S.useLayoutEffect : D8t, Q$ = {
  ...S
};
let nX = 0;
function $8t(e, t = "mui") {
  const [r, a] = S.useState(e), i = e || r;
  return S.useEffect(() => {
    r == null && (nX += 1, a(`${t}-${nX}`));
  }, [r, t]), i;
}
const rX = Q$.useId;
function w3(e, t) {
  if (rX !== void 0) {
    const r = rX();
    return e ?? (t ? `${t}-${r}` : r);
  }
  return $8t(e, t);
}
function E7(e) {
  return w3(e, "base-ui");
}
const $x = "none", hS = "trigger-press", Xh = "trigger-hover", Ok = "trigger-focus", Aae = "outside-press", LE = "focus-out", ZM = "escape-key", z8t = "disabled", Nae = "imperative-action";
function ji(e, t, r, a) {
  let i = !1, c = !1;
  const d = a ?? Gh;
  return {
    reason: e,
    event: t ?? new Event("base-ui"),
    cancel() {
      i = !0;
    },
    allowPropagation() {
      c = !0;
    },
    get isCanceled() {
      return i;
    },
    get isPropagationAllowed() {
      return c;
    },
    trigger: r,
    ...d
  };
}
const j8t = [];
function S3(e) {
  S.useEffect(e, j8t);
}
const TP = null;
let aX = globalThis.requestAnimationFrame;
class I8t {
  /* This implementation uses an array as a backing data-structure for frame callbacks.
   * It allows `O(1)` callback cancelling by inserting a `null` in the array, though it
   * never calls the native `cancelAnimationFrame` if there are no frames left. This can
   * be much more efficient if there is a call pattern that alterns as
   * "request-cancel-request-cancel-…".
   * But in the case of "request-request-…-cancel-cancel-…", it leaves the final animation
   * frame to run anyway. We turn that frame into a `O(1)` no-op via `callbacksCount`. */
  callbacks = [];
  callbacksCount = 0;
  nextId = 1;
  startId = 1;
  isScheduled = !1;
  tick = (t) => {
    this.isScheduled = !1;
    const r = this.callbacks, a = this.callbacksCount;
    if (this.callbacks = [], this.callbacksCount = 0, this.startId = this.nextId, a > 0)
      for (let i = 0; i < r.length; i += 1)
        r[i]?.(t);
  };
  request(t) {
    const r = this.nextId;
    this.nextId += 1, this.callbacks.push(t), this.callbacksCount += 1;
    const a = process.env.NODE_ENV !== "production" && aX !== requestAnimationFrame && (aX = requestAnimationFrame, !0);
    return (!this.isScheduled || a) && (requestAnimationFrame(this.tick), this.isScheduled = !0), r;
  }
  cancel(t) {
    const r = t - this.startId;
    r < 0 || r >= this.callbacks.length || (this.callbacks[r] = null, this.callbacksCount -= 1);
  }
}
const RP = new I8t();
class ou {
  static create() {
    return new ou();
  }
  static request(t) {
    return RP.request(t);
  }
  static cancel(t) {
    return RP.cancel(t);
  }
  currentId = TP;
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  request(t) {
    this.cancel(), this.currentId = RP.request(() => {
      this.currentId = TP, t();
    });
  }
  cancel = () => {
    this.currentId !== TP && (RP.cancel(this.currentId), this.currentId = TP);
  };
  disposeEffect = () => this.cancel;
}
function eO() {
  const e = am(ou.create).current;
  return S3(e.disposeEffect), e;
}
function qw(e) {
  return e == null ? e : "current" in e ? e.current : e;
}
let s3 = /* @__PURE__ */ (function(e) {
  return e.startingStyle = "data-starting-style", e.endingStyle = "data-ending-style", e;
})({});
const L8t = {
  [s3.startingStyle]: ""
}, H8t = {
  [s3.endingStyle]: ""
}, i6 = {
  transitionStatus(e) {
    return e === "starting" ? L8t : e === "ending" ? H8t : null;
  }
};
function aL(e, t = !1, r = !0) {
  const a = eO();
  return Ar((i, c = null) => {
    a.cancel();
    function d() {
      sp.flushSync(i);
    }
    const f = qw(e);
    if (f == null)
      return;
    const p = f;
    if (typeof p.getAnimations != "function" || globalThis.BASE_UI_ANIMATIONS_DISABLED)
      i();
    else {
      let g = function() {
        const w = s3.startingStyle;
        if (!p.hasAttribute(w)) {
          a.request(b);
          return;
        }
        const x = new MutationObserver(() => {
          p.hasAttribute(w) || (x.disconnect(), b());
        });
        x.observe(p, {
          attributes: !0,
          attributeFilter: [w]
        }), c?.addEventListener("abort", () => x.disconnect(), {
          once: !0
        });
      }, b = function() {
        Promise.all(p.getAnimations().map((w) => w.finished)).then(() => {
          c?.aborted || d();
        }).catch(() => {
          const w = p.getAnimations();
          if (r) {
            if (c?.aborted)
              return;
            d();
          } else w.length > 0 && w.some((x) => x.pending || x.playState !== "finished") && b();
        });
      };
      if (t) {
        g();
        return;
      }
      a.request(b);
    }
  });
}
function oL(e, t = !1, r = !1) {
  const [a, i] = S.useState(e && t ? "idle" : void 0), [c, d] = S.useState(e);
  return e && !c && (d(!0), i("starting")), !e && c && a !== "ending" && !r && i("ending"), !e && !c && a === "ending" && i(void 0), Dr(() => {
    if (!e && c && a !== "ending" && r) {
      const f = ou.request(() => {
        i("ending");
      });
      return () => {
        ou.cancel(f);
      };
    }
  }, [e, c, a, r]), Dr(() => {
    if (!e || t)
      return;
    const f = ou.request(() => {
      i(void 0);
    });
    return () => {
      ou.cancel(f);
    };
  }, [t, e]), Dr(() => {
    if (!e || !t)
      return;
    e && c && a !== "idle" && i("starting");
    const f = ou.request(() => {
      i("idle");
    });
    return () => {
      ou.cancel(f);
    };
  }, [t, e, c, i, a]), S.useMemo(() => ({
    mounted: c,
    setMounted: d,
    transitionStatus: a
  }), [c, a]);
}
function F8t(e) {
  const {
    open: t,
    defaultOpen: r,
    onOpenChange: a,
    disabled: i
  } = e, c = t !== void 0, [d, f] = Rae({
    controlled: t,
    default: r,
    name: "Collapsible",
    state: "open"
  }), {
    mounted: p,
    setMounted: g,
    transitionStatus: b
  } = oL(d, !0, !0), [w, x] = S.useState(d), [{
    height: E,
    width: P
  }, k] = S.useState({
    height: void 0,
    width: void 0
  }), M = E7(), [T, N] = S.useState(), D = T ?? M, [$, j] = S.useState(!1), [I, L] = S.useState(!1), F = S.useRef(null), _ = S.useRef(null), W = S.useRef(null), Q = S.useRef(null), U = aL(Q, !1), Y = Ar((G) => {
    const J = !d, H = ji(hS, G.nativeEvent);
    if (a(J, H), H.isCanceled)
      return;
    const K = Q.current;
    _.current === "css-animation" && K != null && K.style.removeProperty("animation-name"), !$ && !I && (_.current != null && _.current !== "css-animation" && !p && J && g(!0), _.current === "css-animation" && (!w && J && x(!0), !p && J && g(!0))), f(J), _.current === "none" && p && !J && g(!1);
  });
  return Dr(() => {
    c && _.current === "none" && !I && !d && g(!1);
  }, [c, I, d, t, g]), S.useMemo(() => ({
    abortControllerRef: F,
    animationTypeRef: _,
    disabled: i,
    handleTrigger: Y,
    height: E,
    mounted: p,
    open: d,
    panelId: D,
    panelRef: Q,
    runOnceAnimationsFinish: U,
    setDimensions: k,
    setHiddenUntilFound: j,
    setKeepMounted: L,
    setMounted: g,
    setOpen: f,
    setPanelIdState: N,
    setVisible: x,
    transitionDimensionRef: W,
    transitionStatus: b,
    visible: w,
    width: P
  }), [F, _, i, Y, E, p, d, D, Q, U, k, j, L, g, f, x, W, b, w, P]);
}
const iL = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (iL.displayName = "CollapsibleRootContext");
function Dae() {
  const e = S.useContext(iL);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: CollapsibleRootContext is missing. Collapsible parts must be placed within <Collapsible.Root>." : ud(15));
  return e;
}
let vE = (function(e) {
  return e.open = "data-open", e.closed = "data-closed", e[e.startingStyle = s3.startingStyle] = "startingStyle", e[e.endingStyle = s3.endingStyle] = "endingStyle", e;
})({}), W8t = /* @__PURE__ */ (function(e) {
  return e.panelOpen = "data-panel-open", e;
})({});
const V8t = {
  [vE.open]: ""
}, _8t = {
  [vE.closed]: ""
}, B8t = {
  open(e) {
    return e ? {
      [W8t.panelOpen]: ""
    } : null;
  }
}, U8t = {
  open(e) {
    return e ? V8t : _8t;
  }
}, $ae = {
  ...U8t,
  ...i6
}, zae = /* @__PURE__ */ S.forwardRef(function(t, r) {
  const {
    render: a,
    className: i,
    defaultOpen: c = !1,
    disabled: d = !1,
    onOpenChange: f,
    open: p,
    ...g
  } = t, b = Ar(f), w = F8t({
    open: p,
    defaultOpen: c,
    onOpenChange: b,
    disabled: d
  }), x = S.useMemo(() => ({
    open: w.open,
    disabled: w.disabled,
    transitionStatus: w.transitionStatus
  }), [w.open, w.disabled, w.transitionStatus]), E = S.useMemo(() => ({
    ...w,
    onOpenChange: b,
    state: x
  }), [w, b, x]), P = nc("div", t, {
    state: x,
    ref: r,
    props: g,
    stateAttributesMapping: $ae
  });
  return /* @__PURE__ */ V.jsx(iL.Provider, {
    value: E,
    children: P
  });
});
process.env.NODE_ENV !== "production" && (zae.displayName = "CollapsibleRoot");
let J$;
process.env.NODE_ENV !== "production" && (J$ = /* @__PURE__ */ new Set());
function oX(...e) {
  if (process.env.NODE_ENV !== "production") {
    const t = e.join(" ");
    J$.has(t) || (J$.add(t), console.error(`Base UI: ${t}`));
  }
}
const lL = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (lL.displayName = "CompositeRootContext");
function jae(e = !1) {
  const t = S.useContext(lL);
  if (t === void 0 && !e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: CompositeRootContext is missing. Composite parts must be placed within <Composite.Root>." : ud(16));
  return t;
}
function X8t(e) {
  const {
    focusableWhenDisabled: t,
    disabled: r,
    composite: a = !1,
    tabIndex: i = 0,
    isNativeButton: c
  } = e, d = a && t !== !1, f = a && t === !1;
  return {
    props: S.useMemo(() => {
      const g = {
        // allow Tabbing away from focusableWhenDisabled elements
        onKeyDown(b) {
          r && t && b.key !== "Tab" && b.preventDefault();
        }
      };
      return a || (g.tabIndex = i, !c && r && (g.tabIndex = t ? i : -1)), (c && (t || d) || !c && r) && (g["aria-disabled"] = r), c && (!t || f) && (g.disabled = r), g;
    }, [a, r, t, d, f, c, i])
  };
}
function sL(e = {}) {
  const {
    disabled: t = !1,
    focusableWhenDisabled: r,
    tabIndex: a = 0,
    native: i = !0
  } = e, c = S.useRef(null), d = jae(!0) !== void 0, f = Ar(() => {
    const x = c.current;
    return !!(x?.tagName === "A" && x?.href);
  }), {
    props: p
  } = X8t({
    focusableWhenDisabled: r,
    disabled: t,
    composite: d,
    tabIndex: a,
    isNativeButton: i
  });
  process.env.NODE_ENV !== "production" && S.useEffect(() => {
    if (!c.current)
      return;
    const x = c.current.tagName === "BUTTON";
    if (i) {
      if (!x) {
        const E = Q$.captureOwnerStack?.() || "";
        oX(`A component that acts as a button expected a native <button> because the \`nativeButton\` prop is true. Rendering a non-<button> removes native button semantics, which can impact forms and accessibility. Use a real <button> in the \`render\` prop, or set \`nativeButton\` to \`false\`.${E}`);
      }
    } else if (x) {
      const E = Q$.captureOwnerStack?.() || "";
      oX(`A component that acts as a button expected a non-<button> because the \`nativeButton\` prop is false. Rendering a <button> keeps native behavior while Base UI applies non-native attributes and handlers, which can add unintended extra attributes (such as \`role\` or \`aria-disabled\`). Use a non-<button> in the \`render\` prop, or set \`nativeButton\` to \`true\`.${E}`);
    }
  }, [i]);
  const g = S.useCallback(() => {
    const x = c.current;
    G8t(x) && d && t && p.disabled === void 0 && x.disabled && (x.disabled = !1);
  }, [t, p.disabled, d]);
  Dr(g, [g]);
  const b = S.useCallback((x = {}) => {
    const {
      onClick: E,
      onMouseDown: P,
      onKeyUp: k,
      onKeyDown: M,
      onPointerDown: T,
      ...N
    } = x;
    return Eae({
      type: i ? "button" : void 0,
      onClick($) {
        if (t) {
          $.preventDefault();
          return;
        }
        E?.($);
      },
      onMouseDown($) {
        t || P?.($);
      },
      onKeyDown($) {
        if (t || (K$($), M?.($)), $.baseUIHandlerPrevented)
          return;
        const j = $.target === $.currentTarget && !i && !f() && !t, I = $.key === "Enter", L = $.key === " ";
        j && ((L || I) && $.preventDefault(), I && E?.($));
      },
      onKeyUp($) {
        t || (K$($), k?.($)), !$.baseUIHandlerPrevented && $.target === $.currentTarget && !i && !t && $.key === " " && E?.($);
      },
      onPointerDown($) {
        if (t) {
          $.preventDefault();
          return;
        }
        T?.($);
      }
    }, i ? void 0 : {
      role: "button"
    }, p, N);
  }, [t, p, i, f]), w = Ar((x) => {
    c.current = x, g();
  });
  return {
    getButtonProps: b,
    buttonRef: w
  };
}
function G8t(e) {
  return Os(e) && e.tagName === "BUTTON";
}
const q8t = {
  ...B8t,
  ...i6
}, Iae = /* @__PURE__ */ S.forwardRef(function(t, r) {
  const {
    panelId: a,
    open: i,
    handleTrigger: c,
    state: d,
    disabled: f
  } = Dae(), {
    className: p,
    disabled: g = f,
    id: b,
    render: w,
    nativeButton: x = !0,
    ...E
  } = t, {
    getButtonProps: P,
    buttonRef: k
  } = sL({
    disabled: g,
    focusableWhenDisabled: !0,
    native: x
  }), M = S.useMemo(() => ({
    "aria-controls": i ? a : void 0,
    "aria-expanded": i,
    onClick: c
  }), [a, i, c]);
  return nc("button", t, {
    state: d,
    ref: [r, k],
    props: [M, E, P],
    stateAttributesMapping: q8t
  });
});
process.env.NODE_ENV !== "production" && (Iae.displayName = "CollapsibleTrigger");
let Z$;
process.env.NODE_ENV !== "production" && (Z$ = /* @__PURE__ */ new Set());
function Lae(...e) {
  if (process.env.NODE_ENV !== "production") {
    const t = e.join(" ");
    Z$.has(t) || (Z$.add(t), console.warn(`Base UI: ${t}`));
  }
}
let K8t = /* @__PURE__ */ (function(e) {
  return e.disabled = "data-disabled", e.orientation = "data-orientation", e;
})({});
function Y8t(e) {
  const {
    abortControllerRef: t,
    animationTypeRef: r,
    externalRef: a,
    height: i,
    hiddenUntilFound: c,
    keepMounted: d,
    id: f,
    mounted: p,
    onOpenChange: g,
    open: b,
    panelRef: w,
    runOnceAnimationsFinish: x,
    setDimensions: E,
    setMounted: P,
    setOpen: k,
    setVisible: M,
    transitionDimensionRef: T,
    visible: N,
    width: D
  } = e, $ = S.useRef(!1), j = S.useRef(null), I = S.useRef(b), L = S.useRef(b), F = eO(), _ = S.useMemo(() => r.current === "css-animation" ? !N : !b && !p, [b, p, N, r]), W = Ar((U) => {
    if (!U)
      return;
    if (r.current == null || T.current == null) {
      const J = getComputedStyle(U), H = J.animationName !== "none" && J.animationName !== "", K = J.transitionDuration !== "0s" && J.transitionDuration !== "";
      H && K ? process.env.NODE_ENV !== "production" && Lae("CSS transitions and CSS animations both detected on Collapsible or Accordion panel.", "Only one of either animation type should be used.") : J.animationName === "none" && J.transitionDuration !== "0s" ? r.current = "css-transition" : J.animationName !== "none" && J.transitionDuration === "0s" ? r.current = "css-animation" : r.current = "none", U.getAttribute(K8t.orientation) === "horizontal" || J.transitionProperty.indexOf("width") > -1 ? T.current = "width" : T.current = "height";
    }
    if (r.current !== "css-transition")
      return;
    (i === void 0 || D === void 0) && (E({
      height: U.scrollHeight,
      width: U.scrollWidth
    }), L.current && U.style.setProperty("transition-duration", "0s"));
    let Y = -1, G = -1;
    return Y = ou.request(() => {
      L.current = !1, G = ou.request(() => {
        setTimeout(() => {
          U.style.removeProperty("transition-duration");
        });
      });
    }), () => {
      ou.cancel(Y), ou.cancel(G);
    };
  }), Q = l3(a, w, W);
  return Dr(() => {
    if (r.current !== "css-transition")
      return;
    const U = w.current;
    if (!U)
      return;
    let Y = -1;
    if (t.current != null && (t.current.abort(), t.current = null), b) {
      const G = {
        "justify-content": U.style.justifyContent,
        "align-items": U.style.alignItems,
        "align-content": U.style.alignContent,
        "justify-items": U.style.justifyItems
      };
      Object.keys(G).forEach((J) => {
        U.style.setProperty(J, "initial", "important");
      }), !L.current && !d && U.setAttribute(vE.startingStyle, ""), E({
        height: U.scrollHeight,
        width: U.scrollWidth
      }), Y = ou.request(() => {
        Object.entries(G).forEach(([J, H]) => {
          H === "" ? U.style.removeProperty(J) : U.style.setProperty(J, H);
        });
      });
    } else {
      if (U.scrollHeight === 0 && U.scrollWidth === 0)
        return;
      E({
        height: U.scrollHeight,
        width: U.scrollWidth
      });
      const G = new AbortController();
      t.current = G;
      const J = G.signal;
      let H = null;
      const K = vE.endingStyle;
      return H = new MutationObserver((X) => {
        X.some((ie) => ie.type === "attributes" && ie.attributeName === K) && (H?.disconnect(), H = null, x(() => {
          E({
            height: 0,
            width: 0
          }), U.style.removeProperty("content-visibility"), P(!1), t.current === G && (t.current = null);
        }, J));
      }), H.observe(U, {
        attributes: !0,
        attributeFilter: [K]
      }), () => {
        H?.disconnect(), F.cancel(), t.current === G && (G.abort(), t.current = null);
      };
    }
    return () => {
      ou.cancel(Y);
    };
  }, [t, r, F, c, d, p, b, w, x, E, P]), Dr(() => {
    if (r.current !== "css-animation")
      return;
    const U = w.current;
    U && (j.current = U.style.animationName || j.current, U.style.setProperty("animation-name", "none"), E({
      height: U.scrollHeight,
      width: U.scrollWidth
    }), !I.current && !$.current && U.style.removeProperty("animation-name"), b ? (t.current != null && (t.current.abort(), t.current = null), P(!0), M(!0)) : (t.current = new AbortController(), x(() => {
      P(!1), M(!1), t.current = null;
    }, t.current.signal)));
  }, [t, r, b, w, x, E, P, M, N]), S3(() => {
    const U = ou.request(() => {
      I.current = !1;
    });
    return () => ou.cancel(U);
  }), Dr(() => {
    if (!c)
      return;
    const U = w.current;
    if (!U)
      return;
    let Y = -1, G = -1;
    return b && $.current && (U.style.transitionDuration = "0s", E({
      height: U.scrollHeight,
      width: U.scrollWidth
    }), Y = ou.request(() => {
      $.current = !1, G = ou.request(() => {
        setTimeout(() => {
          U.style.removeProperty("transition-duration");
        });
      });
    })), () => {
      ou.cancel(Y), ou.cancel(G);
    };
  }, [c, b, w, E]), Dr(() => {
    const U = w.current;
    U && c && _ && (U.setAttribute("hidden", "until-found"), r.current === "css-transition" && U.setAttribute(vE.startingStyle, ""));
  }, [c, _, r, w]), S.useEffect(function() {
    const Y = w.current;
    if (!Y)
      return;
    function G(J) {
      $.current = !0, k(!0), g(!0, ji($x, J));
    }
    return Y.addEventListener("beforematch", G), () => {
      Y.removeEventListener("beforematch", G);
    };
  }, [g, w, k]), S.useMemo(() => ({
    props: {
      hidden: _,
      id: f,
      ref: Q
    }
  }), [_, f, Q]);
}
let iX = /* @__PURE__ */ (function(e) {
  return e.collapsiblePanelHeight = "--collapsible-panel-height", e.collapsiblePanelWidth = "--collapsible-panel-width", e;
})({});
function l6(e) {
  const {
    enabled: t = !0,
    open: r,
    ref: a,
    onComplete: i
  } = e, c = Ar(i), d = aL(a, r, !1);
  S.useEffect(() => {
    if (!t)
      return;
    const f = new AbortController();
    return d(c, f.signal), () => {
      f.abort();
    };
  }, [t, r, c, d]);
}
const Hae = /* @__PURE__ */ S.forwardRef(function(t, r) {
  const {
    className: a,
    hiddenUntilFound: i,
    keepMounted: c,
    render: d,
    id: f,
    ...p
  } = t;
  process.env.NODE_ENV !== "production" && Dr(() => {
    i && c === !1 && Lae("The `keepMounted={false}` prop on a Collapsible will be ignored when using `hiddenUntilFound` since it requires the Panel to remain mounted even when closed.");
  }, [i, c]);
  const {
    abortControllerRef: g,
    animationTypeRef: b,
    height: w,
    mounted: x,
    onOpenChange: E,
    open: P,
    panelId: k,
    panelRef: M,
    runOnceAnimationsFinish: T,
    setDimensions: N,
    setHiddenUntilFound: D,
    setKeepMounted: $,
    setMounted: j,
    setPanelIdState: I,
    setOpen: L,
    setVisible: F,
    state: _,
    transitionDimensionRef: W,
    visible: Q,
    width: U,
    transitionStatus: Y
  } = Dae(), G = i ?? !1, J = c ?? !1;
  Dr(() => {
    if (f)
      return I(f), () => {
        I(void 0);
      };
  }, [f, I]), Dr(() => {
    D(G);
  }, [D, G]), Dr(() => {
    $(J);
  }, [$, J]);
  const {
    props: H
  } = Y8t({
    abortControllerRef: g,
    animationTypeRef: b,
    externalRef: r,
    height: w,
    hiddenUntilFound: G,
    id: k,
    keepMounted: J,
    mounted: x,
    onOpenChange: E,
    open: P,
    panelRef: M,
    runOnceAnimationsFinish: T,
    setDimensions: N,
    setMounted: j,
    setOpen: L,
    setVisible: F,
    transitionDimensionRef: W,
    visible: Q,
    width: U
  });
  l6({
    open: P && Y === "idle",
    ref: M,
    onComplete() {
      P && N({
        height: void 0,
        width: void 0
      });
    }
  });
  const K = S.useMemo(() => ({
    ..._,
    transitionStatus: Y
  }), [_, Y]), X = nc("div", t, {
    state: K,
    ref: [r, M],
    props: [H, {
      style: {
        [iX.collapsiblePanelHeight]: w === void 0 ? "auto" : `${w}px`,
        [iX.collapsiblePanelWidth]: U === void 0 ? "auto" : `${U}px`
      }
    }, p],
    stateAttributesMapping: $ae
  });
  return J || G || !J && x ? X : null;
});
process.env.NODE_ENV !== "production" && (Hae.displayName = "CollapsiblePanel");
const s6 = typeof navigator < "u", JA = J8t(), Fae = e5t(), Wae = Z8t(), Vae = typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter:none"), _ae = (
  // iPads can claim to be MacIntel
  JA.platform === "MacIntel" && JA.maxTouchPoints > 1 ? !0 : /iP(hone|ad|od)|iOS/.test(JA.platform)
), Bae = s6 && /apple/i.test(navigator.vendor), ez = s6 && /android/i.test(Fae) || /android/i.test(Wae), Q8t = s6 && Fae.toLowerCase().startsWith("mac") && !navigator.maxTouchPoints, Uae = Wae.includes("jsdom/");
function J8t() {
  if (!s6)
    return {
      platform: "",
      maxTouchPoints: -1
    };
  const e = navigator.userAgentData;
  return e?.platform ? {
    platform: e.platform,
    maxTouchPoints: navigator.maxTouchPoints
  } : {
    platform: navigator.platform ?? "",
    maxTouchPoints: navigator.maxTouchPoints ?? -1
  };
}
function Z8t() {
  if (!s6)
    return "";
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? e.brands.map(({
    brand: t,
    version: r
  }) => `${t}/${r}`).join(" ") : navigator.userAgent;
}
function e5t() {
  if (!s6)
    return "";
  const e = navigator.userAgentData;
  return e?.platform ? e.platform : navigator.platform ?? "";
}
function Qo(e) {
  return e?.ownerDocument || document;
}
const J5 = 0;
class $0 {
  static create() {
    return new $0();
  }
  currentId = J5;
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(t, r) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = J5, r();
    }, t);
  }
  isStarted() {
    return this.currentId !== J5;
  }
  clear = () => {
    this.currentId !== J5 && (clearTimeout(this.currentId), this.currentId = J5);
  };
  disposeEffect = () => this.clear;
}
function JS() {
  const e = am($0.create).current;
  return S3(e.disposeEffect), e;
}
let lX = {}, sX = {}, uX = "";
function t5t(e) {
  if (typeof document > "u")
    return !1;
  const t = Qo(e);
  return lu(t).innerWidth - t.documentElement.clientWidth > 0;
}
function n5t(e) {
  if (!(typeof CSS < "u" && CSS.supports && CSS.supports("scrollbar-gutter", "stable")) || typeof document > "u")
    return !1;
  const r = Qo(e), a = r.documentElement, i = r.body, c = sC(a) ? a : i, d = c.style.overflowY, f = a.style.scrollbarGutter;
  a.style.scrollbarGutter = "stable", c.style.overflowY = "scroll";
  const p = c.offsetWidth;
  c.style.overflowY = "hidden";
  const g = c.offsetWidth;
  return c.style.overflowY = d, a.style.scrollbarGutter = f, p === g;
}
function r5t(e) {
  const t = Qo(e), r = t.documentElement, a = t.body, i = sC(r) ? r : a, c = {
    overflowY: i.style.overflowY,
    overflowX: i.style.overflowX
  };
  return Object.assign(i.style, {
    overflowY: "hidden",
    overflowX: "hidden"
  }), () => {
    Object.assign(i.style, c);
  };
}
function a5t(e) {
  const t = Qo(e), r = t.documentElement, a = t.body, i = lu(r);
  let c = 0, d = 0, f = !1;
  const p = ou.create();
  if (Vae && (i.visualViewport?.scale ?? 1) !== 1)
    return () => {
    };
  function g() {
    const x = i.getComputedStyle(r), E = i.getComputedStyle(a), M = (x.scrollbarGutter || "").includes("both-edges") ? "stable both-edges" : "stable";
    c = r.scrollTop, d = r.scrollLeft, lX = {
      scrollbarGutter: r.style.scrollbarGutter,
      overflowY: r.style.overflowY,
      overflowX: r.style.overflowX
    }, uX = r.style.scrollBehavior, sX = {
      position: a.style.position,
      height: a.style.height,
      width: a.style.width,
      boxSizing: a.style.boxSizing,
      overflowY: a.style.overflowY,
      overflowX: a.style.overflowX,
      scrollBehavior: a.style.scrollBehavior
    };
    const T = r.scrollHeight > r.clientHeight, N = r.scrollWidth > r.clientWidth, D = x.overflowY === "scroll" || E.overflowY === "scroll", $ = x.overflowX === "scroll" || E.overflowX === "scroll", j = Math.max(0, i.innerWidth - a.clientWidth), I = Math.max(0, i.innerHeight - a.clientHeight), L = parseFloat(E.marginTop) + parseFloat(E.marginBottom), F = parseFloat(E.marginLeft) + parseFloat(E.marginRight), _ = sC(r) ? r : a;
    if (f = n5t(e), f) {
      r.style.scrollbarGutter = M, _.style.overflowY = "hidden", _.style.overflowX = "hidden";
      return;
    }
    Object.assign(r.style, {
      scrollbarGutter: M,
      overflowY: "hidden",
      overflowX: "hidden"
    }), (T || D) && (r.style.overflowY = "scroll"), (N || $) && (r.style.overflowX = "scroll"), Object.assign(a.style, {
      position: "relative",
      height: L || I ? `calc(100dvh - ${L + I}px)` : "100dvh",
      width: F || j ? `calc(100vw - ${F + j}px)` : "100vw",
      boxSizing: "border-box",
      overflow: "hidden",
      scrollBehavior: "unset"
    }), a.scrollTop = c, a.scrollLeft = d, r.setAttribute("data-base-ui-scroll-locked", ""), r.style.scrollBehavior = "unset";
  }
  function b() {
    Object.assign(r.style, lX), Object.assign(a.style, sX), f || (r.scrollTop = c, r.scrollLeft = d, r.removeAttribute("data-base-ui-scroll-locked"), r.style.scrollBehavior = uX);
  }
  function w() {
    b(), p.request(g);
  }
  return g(), i.addEventListener("resize", w), () => {
    p.cancel(), b(), typeof i.removeEventListener == "function" && i.removeEventListener("resize", w);
  };
}
class o5t {
  lockCount = 0;
  restore = null;
  timeoutLock = $0.create();
  timeoutUnlock = $0.create();
  acquire(t) {
    return this.lockCount += 1, this.lockCount === 1 && this.restore === null && this.timeoutLock.start(0, () => this.lock(t)), this.release;
  }
  release = () => {
    this.lockCount -= 1, this.lockCount === 0 && this.restore && this.timeoutUnlock.start(0, this.unlock);
  };
  unlock = () => {
    this.lockCount === 0 && this.restore && (this.restore?.(), this.restore = null);
  };
  lock(t) {
    if (this.lockCount === 0 || this.restore !== null)
      return;
    const a = Qo(t).documentElement, i = lu(a).getComputedStyle(a).overflowY;
    if (i === "hidden" || i === "clip") {
      this.restore = Mae;
      return;
    }
    const c = _ae || !t5t(t);
    this.restore = c ? r5t(t) : a5t(t);
  }
}
const i5t = new o5t();
function l5t(e = !0, t = null) {
  Dr(() => {
    if (e)
      return i5t.acquire(t);
  }, [e, t]);
}
function Xae(e) {
  const t = S.useRef(!0);
  t.current && (t.current = !1, e());
}
function ub(e) {
  const t = am(s5t, e).current;
  return t.next = e, Dr(t.effect), t;
}
function s5t(e) {
  const t = {
    current: e,
    next: e,
    effect: () => {
      t.current = t.next;
    }
  };
  return t;
}
const tz = "data-base-ui-focusable", Gae = "active", qae = "selected", Kae = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])", ZA = "ArrowLeft", eN = "ArrowRight", u5t = "ArrowUp", c5t = "ArrowDown";
function ap(e) {
  let t = e.activeElement;
  for (; t?.shadowRoot?.activeElement != null; )
    t = t.shadowRoot.activeElement;
  return t;
}
function oo(e, t) {
  if (!e || !t)
    return !1;
  const r = t.getRootNode?.();
  if (e.contains(t))
    return !0;
  if (r && j$(r)) {
    let a = t;
    for (; a; ) {
      if (e === a)
        return !0;
      a = a.parentNode || a.host;
    }
  }
  return !1;
}
function h9(e, t) {
  if (!di(e))
    return !1;
  const r = e;
  if (t.hasElement(r))
    return !r.hasAttribute("data-trigger-disabled");
  for (const [, a] of t.entries())
    if (oo(a, r))
      return !a.hasAttribute("data-trigger-disabled");
  return !1;
}
function tm(e) {
  return "composedPath" in e ? e.composedPath()[0] : e.target;
}
function D1(e, t) {
  if (t == null)
    return !1;
  if ("composedPath" in e)
    return e.composedPath().includes(t);
  const r = e;
  return r.target != null && t.contains(r.target);
}
function d5t(e) {
  return e.matches("html,body");
}
function tO(e) {
  return Os(e) && e.matches(Kae);
}
function cX(e) {
  return e ? e.getAttribute("role") === "combobox" && tO(e) : !1;
}
function p9(e) {
  if (!e || Uae)
    return !0;
  try {
    return e.matches(":focus-visible");
  } catch {
    return !0;
  }
}
function nz(e) {
  return e ? e.hasAttribute(tz) ? e : e.querySelector(`[${tz}]`) || e : null;
}
function Y4(e, t, r = !0) {
  return e.filter((i) => i.parentId === t && (!r || i.context?.open)).flatMap((i) => [i, ...Y4(e, i.id, r)]);
}
function dX(e, t) {
  let r = [], a = e.find((i) => i.id === t)?.parentId;
  for (; a; ) {
    const i = e.find((c) => c.id === a);
    a = i?.parentId, i && (r = r.concat(i));
  }
  return r;
}
function F4(e) {
  e.preventDefault(), e.stopPropagation();
}
function f5t(e) {
  return "nativeEvent" in e;
}
function m5t(e) {
  return e.pointerType === "" && e.isTrusted ? !0 : ez && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function h5t(e) {
  return Uae ? !1 : !ez && e.width === 0 && e.height === 0 || ez && e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  e.width < 1 && e.height < 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "touch";
}
function u3(e, t) {
  const r = ["mouse", "pen"];
  return t || r.push("", void 0), r.includes(e);
}
function Yae(e) {
  const t = e.type;
  return t === "click" || t === "mousedown" || t === "keydown" || t === "keyup";
}
function AP(e, t, r) {
  return Math.floor(e / t) !== r;
}
function Tk(e, t) {
  return t < 0 || t >= e.current.length;
}
function p5t(e, t) {
  return E0(e, {
    disabledIndices: t
  });
}
function g5t(e, t) {
  return E0(e, {
    decrement: !0,
    startingIndex: e.current.length,
    disabledIndices: t
  });
}
function E0(e, {
  startingIndex: t = -1,
  decrement: r = !1,
  disabledIndices: a,
  amount: i = 1
} = {}) {
  let c = t;
  do
    c += r ? -i : i;
  while (c >= 0 && c <= e.current.length - 1 && bE(e, c, a));
  return c;
}
function v5t(e, {
  event: t,
  orientation: r,
  loopFocus: a,
  rtl: i,
  cols: c,
  disabledIndices: d,
  minIndex: f,
  maxIndex: p,
  prevIndex: g,
  stopEvent: b = !1
}) {
  let w = g;
  const x = [], E = {};
  let P = !1;
  {
    let T = null, N = -1;
    e.current.forEach((D, $) => {
      if (D == null)
        return;
      const j = D.closest('[role="row"]');
      j && (P = !0), (j !== T || N === -1) && (T = j, N += 1, x[N] = []), x[N].push($), E[$] = N;
    });
  }
  const k = P && x.length > 0 && x.some((T) => T.length !== c);
  function M(T) {
    if (!k || g === -1)
      return;
    const N = E[g];
    if (N == null)
      return;
    const D = x[N].indexOf(g);
    let $ = T === "up" ? N - 1 : N + 1;
    a && ($ < 0 ? $ = x.length - 1 : $ >= x.length && ($ = 0));
    const j = /* @__PURE__ */ new Set();
    for (; $ >= 0 && $ < x.length && !j.has($); ) {
      j.add($);
      const I = x[$];
      if (I.length === 0) {
        $ = T === "up" ? $ - 1 : $ + 1;
        continue;
      }
      const L = Math.min(D, I.length - 1);
      for (let F = L; F >= 0; F -= 1) {
        const _ = I[F];
        if (!bE(e, _, d))
          return _;
      }
      $ = T === "up" ? $ - 1 : $ + 1, a && ($ < 0 ? $ = x.length - 1 : $ >= x.length && ($ = 0));
    }
  }
  if (t.key === u5t) {
    const T = M("up");
    if (T !== void 0)
      b && F4(t), w = T;
    else {
      if (b && F4(t), g === -1)
        w = p;
      else if (w = E0(e, {
        startingIndex: w,
        amount: c,
        decrement: !0,
        disabledIndices: d
      }), a && (g - c < f || w < 0)) {
        const N = g % c, D = p % c, $ = p - (D - N);
        D === N ? w = p : w = D > N ? $ : $ - c;
      }
      Tk(e, w) && (w = g);
    }
  }
  if (t.key === c5t) {
    const T = M("down");
    T !== void 0 ? (b && F4(t), w = T) : (b && F4(t), g === -1 ? w = f : (w = E0(e, {
      startingIndex: g,
      amount: c,
      disabledIndices: d
    }), a && g + c > p && (w = E0(e, {
      startingIndex: g % c - c,
      amount: c,
      disabledIndices: d
    }))), Tk(e, w) && (w = g));
  }
  if (r === "both") {
    const T = Z3(g / c);
    t.key === (i ? ZA : eN) && (b && F4(t), g % c !== c - 1 ? (w = E0(e, {
      startingIndex: g,
      disabledIndices: d
    }), a && AP(w, c, T) && (w = E0(e, {
      startingIndex: g - g % c - 1,
      disabledIndices: d
    }))) : a && (w = E0(e, {
      startingIndex: g - g % c - 1,
      disabledIndices: d
    })), AP(w, c, T) && (w = g)), t.key === (i ? eN : ZA) && (b && F4(t), g % c !== 0 ? (w = E0(e, {
      startingIndex: g,
      decrement: !0,
      disabledIndices: d
    }), a && AP(w, c, T) && (w = E0(e, {
      startingIndex: g + (c - g % c),
      decrement: !0,
      disabledIndices: d
    }))) : a && (w = E0(e, {
      startingIndex: g + (c - g % c),
      decrement: !0,
      disabledIndices: d
    })), AP(w, c, T) && (w = g));
    const N = Z3(p / c) === T;
    Tk(e, w) && (a && N ? w = t.key === (i ? eN : ZA) ? p : E0(e, {
      startingIndex: g - g % c - 1,
      disabledIndices: d
    }) : w = g);
  }
  return w;
}
function b5t(e, t, r) {
  const a = [];
  let i = 0;
  return e.forEach(({
    width: c,
    height: d
  }, f) => {
    if (c > t && process.env.NODE_ENV !== "production")
      throw new Error(`[Floating UI]: Invalid grid - item width at index ${f} is greater than grid columns`);
    let p = !1;
    for (r && (i = 0); !p; ) {
      const g = [];
      for (let b = 0; b < c; b += 1)
        for (let w = 0; w < d; w += 1)
          g.push(i + b + w * t);
      i % t + c <= t && g.every((b) => a[b] == null) ? (g.forEach((b) => {
        a[b] = f;
      }), p = !0) : i += 1;
    }
  }), [...a];
}
function y5t(e, t, r, a, i) {
  if (e === -1)
    return -1;
  const c = r.indexOf(e), d = t[e];
  switch (i) {
    case "tl":
      return c;
    case "tr":
      return d ? c + d.width - 1 : c;
    case "bl":
      return d ? c + (d.height - 1) * a : c;
    case "br":
      return r.lastIndexOf(e);
    default:
      return -1;
  }
}
function w5t(e, t) {
  return t.flatMap((r, a) => e.includes(r) ? [a] : []);
}
function bE(e, t, r) {
  if (typeof r == "function")
    return r(t);
  if (r)
    return r.includes(t);
  const a = e.current[t];
  return a ? a.hasAttribute("disabled") || a.getAttribute("aria-disabled") === "true" : !1;
}
/*!
* tabbable 6.4.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var S5t = ["input:not([inert]):not([inert] *)", "select:not([inert]):not([inert] *)", "textarea:not([inert]):not([inert] *)", "a[href]:not([inert]):not([inert] *)", "button:not([inert]):not([inert] *)", "[tabindex]:not(slot):not([inert]):not([inert] *)", "audio[controls]:not([inert]):not([inert] *)", "video[controls]:not([inert]):not([inert] *)", '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)', "details>summary:first-of-type:not([inert]):not([inert] *)", "details:not([inert]):not([inert] *)"], g9 = /* @__PURE__ */ S5t.join(","), Qae = typeof Element > "u", zx = Qae ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, v9 = !Qae && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e?.ownerDocument;
}, b9 = function(t, r) {
  var a;
  r === void 0 && (r = !0);
  var i = t == null || (a = t.getAttribute) === null || a === void 0 ? void 0 : a.call(t, "inert"), c = i === "" || i === "true", d = c || r && t && // closest does not exist on shadow roots, so we fall back to a manual
  // lookup upward, in case it is not defined.
  (typeof t.closest == "function" ? t.closest("[inert]") : b9(t.parentNode));
  return d;
}, C5t = function(t) {
  var r, a = t == null || (r = t.getAttribute) === null || r === void 0 ? void 0 : r.call(t, "contenteditable");
  return a === "" || a === "true";
}, Jae = function(t, r, a) {
  if (b9(t))
    return [];
  var i = Array.prototype.slice.apply(t.querySelectorAll(g9));
  return r && zx.call(t, g9) && i.unshift(t), i = i.filter(a), i;
}, y9 = function(t, r, a) {
  for (var i = [], c = Array.from(t); c.length; ) {
    var d = c.shift();
    if (!b9(d, !1))
      if (d.tagName === "SLOT") {
        var f = d.assignedElements(), p = f.length ? f : d.children, g = y9(p, !0, a);
        a.flatten ? i.push.apply(i, g) : i.push({
          scopeParent: d,
          candidates: g
        });
      } else {
        var b = zx.call(d, g9);
        b && a.filter(d) && (r || !t.includes(d)) && i.push(d);
        var w = d.shadowRoot || // check for an undisclosed shadow
        typeof a.getShadowRoot == "function" && a.getShadowRoot(d), x = !b9(w, !1) && (!a.shadowRootFilter || a.shadowRootFilter(d));
        if (w && x) {
          var E = y9(w === !0 ? d.children : w.children, !0, a);
          a.flatten ? i.push.apply(i, E) : i.push({
            scopeParent: d,
            candidates: E
          });
        } else
          c.unshift.apply(c, d.children);
      }
  }
  return i;
}, Zae = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, eoe = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || C5t(t)) && !Zae(t) ? 0 : t.tabIndex;
}, x5t = function(t, r) {
  var a = eoe(t);
  return a < 0 && r && !Zae(t) ? 0 : a;
}, E5t = function(t, r) {
  return t.tabIndex === r.tabIndex ? t.documentOrder - r.documentOrder : t.tabIndex - r.tabIndex;
}, toe = function(t) {
  return t.tagName === "INPUT";
}, P5t = function(t) {
  return toe(t) && t.type === "hidden";
}, k5t = function(t) {
  var r = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(a) {
    return a.tagName === "SUMMARY";
  });
  return r;
}, M5t = function(t, r) {
  for (var a = 0; a < t.length; a++)
    if (t[a].checked && t[a].form === r)
      return t[a];
}, O5t = function(t) {
  if (!t.name)
    return !0;
  var r = t.form || v9(t), a = function(f) {
    return r.querySelectorAll('input[type="radio"][name="' + f + '"]');
  }, i;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    i = a(window.CSS.escape(t.name));
  else
    try {
      i = a(t.name);
    } catch (d) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", d.message), !1;
    }
  var c = M5t(i, t.form);
  return !c || c === t;
}, T5t = function(t) {
  return toe(t) && t.type === "radio";
}, R5t = function(t) {
  return T5t(t) && !O5t(t);
}, A5t = function(t) {
  var r, a = t && v9(t), i = (r = a) === null || r === void 0 ? void 0 : r.host, c = !1;
  if (a && a !== t) {
    var d, f, p;
    for (c = !!((d = i) !== null && d !== void 0 && (f = d.ownerDocument) !== null && f !== void 0 && f.contains(i) || t != null && (p = t.ownerDocument) !== null && p !== void 0 && p.contains(t)); !c && i; ) {
      var g, b, w;
      a = v9(i), i = (g = a) === null || g === void 0 ? void 0 : g.host, c = !!((b = i) !== null && b !== void 0 && (w = b.ownerDocument) !== null && w !== void 0 && w.contains(i));
    }
  }
  return c;
}, fX = function(t) {
  var r = t.getBoundingClientRect(), a = r.width, i = r.height;
  return a === 0 && i === 0;
}, N5t = function(t, r) {
  var a = r.displayCheck, i = r.getShadowRoot;
  if (a === "full-native" && "checkVisibility" in t) {
    var c = t.checkVisibility({
      // Checking opacity might be desirable for some use cases, but natively,
      // opacity zero elements _are_ focusable and tabbable.
      checkOpacity: !1,
      opacityProperty: !1,
      contentVisibilityAuto: !0,
      visibilityProperty: !0,
      // This is an alias for `visibilityProperty`. Contemporary browsers
      // support both. However, this alias has wider browser support (Chrome
      // >= 105 and Firefox >= 106, vs. Chrome >= 121 and Firefox >= 122), so
      // we include it anyway.
      checkVisibilityCSS: !0
    });
    return !c;
  }
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var d = zx.call(t, "details>summary:first-of-type"), f = d ? t.parentElement : t;
  if (zx.call(f, "details:not([open]) *"))
    return !0;
  if (!a || a === "full" || // full-native can run this branch when it falls through in case
  // Element#checkVisibility is unsupported
  a === "full-native" || a === "legacy-full") {
    if (typeof i == "function") {
      for (var p = t; t; ) {
        var g = t.parentElement, b = v9(t);
        if (g && !g.shadowRoot && i(g) === !0)
          return fX(t);
        t.assignedSlot ? t = t.assignedSlot : !g && b !== t.ownerDocument ? t = b.host : t = g;
      }
      t = p;
    }
    if (A5t(t))
      return !t.getClientRects().length;
    if (a !== "legacy-full")
      return !0;
  } else if (a === "non-zero-area")
    return fX(t);
  return !1;
}, D5t = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var r = t.parentElement; r; ) {
      if (r.tagName === "FIELDSET" && r.disabled) {
        for (var a = 0; a < r.children.length; a++) {
          var i = r.children.item(a);
          if (i.tagName === "LEGEND")
            return zx.call(r, "fieldset[disabled] *") ? !0 : !i.contains(t);
        }
        return !0;
      }
      r = r.parentElement;
    }
  return !1;
}, rz = function(t, r) {
  return !(r.disabled || P5t(r) || N5t(r, t) || // For a details element with a summary, the summary element gets the focus
  k5t(r) || D5t(r));
}, az = function(t, r) {
  return !(R5t(r) || eoe(r) < 0 || !rz(t, r));
}, $5t = function(t) {
  var r = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(r) || r >= 0);
}, noe = function(t) {
  var r = [], a = [];
  return t.forEach(function(i, c) {
    var d = !!i.scopeParent, f = d ? i.scopeParent : i, p = x5t(f, d), g = d ? noe(i.candidates) : f;
    p === 0 ? d ? r.push.apply(r, g) : r.push(f) : a.push({
      documentOrder: c,
      tabIndex: p,
      item: i,
      isScope: d,
      content: g
    });
  }), a.sort(E5t).reduce(function(i, c) {
    return c.isScope ? i.push.apply(i, c.content) : i.push(c.content), i;
  }, []).concat(r);
}, P7 = function(t, r) {
  r = r || {};
  var a;
  return r.getShadowRoot ? a = y9([t], r.includeContainer, {
    filter: az.bind(null, r),
    flatten: !1,
    getShadowRoot: r.getShadowRoot,
    shadowRootFilter: $5t
  }) : a = Jae(t, r.includeContainer, az.bind(null, r)), noe(a);
}, z5t = function(t, r) {
  r = r || {};
  var a;
  return r.getShadowRoot ? a = y9([t], r.includeContainer, {
    filter: rz.bind(null, r),
    flatten: !0,
    getShadowRoot: r.getShadowRoot
  }) : a = Jae(t, r.includeContainer, rz.bind(null, r)), a;
}, roe = function(t, r) {
  if (r = r || {}, !t)
    throw new Error("No node provided");
  return zx.call(t, g9) === !1 ? !1 : az(r, t);
};
const u6 = () => ({
  getShadowRoot: !0,
  displayCheck: (
    // JSDOM does not support the `tabbable` library. To solve this we can
    // check if `ResizeObserver` is a real function (not polyfilled), which
    // determines if the current environment is JSDOM-like.
    typeof ResizeObserver == "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
  )
});
function aoe(e, t) {
  const r = P7(e, u6()), a = r.length;
  if (a === 0)
    return;
  const i = ap(Qo(e)), c = r.indexOf(i), d = c === -1 ? t === 1 ? 0 : a - 1 : c + t;
  return r[d];
}
function uL(e) {
  return aoe(Qo(e).body, 1) || e;
}
function ooe(e) {
  return aoe(Qo(e).body, -1) || e;
}
function ioe(e, t) {
  if (!e)
    return null;
  const r = P7(Qo(e).body, u6()), a = r.length;
  if (a === 0)
    return null;
  const i = r.indexOf(e);
  if (i === -1)
    return null;
  const c = (i + t + a) % a;
  return r[c];
}
function j5t(e) {
  return ioe(e, 1);
}
function I5t(e) {
  return ioe(e, -1);
}
function fx(e, t) {
  const r = t || e.currentTarget, a = e.relatedTarget;
  return !a || !oo(r, a);
}
function L5t(e) {
  P7(e, u6()).forEach((r) => {
    r.dataset.tabindex = r.getAttribute("tabindex") || "", r.setAttribute("tabindex", "-1");
  });
}
function mX(e) {
  e.querySelectorAll("[data-tabindex]").forEach((r) => {
    const a = r.dataset.tabindex;
    delete r.dataset.tabindex, a ? r.setAttribute("tabindex", a) : r.removeAttribute("tabindex");
  });
}
function loe() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(t, r) {
      e.get(t)?.forEach((a) => a(r));
    },
    on(t, r) {
      e.has(t) || e.set(t, /* @__PURE__ */ new Set()), e.get(t).add(r);
    },
    off(t, r) {
      e.get(t)?.delete(r);
    }
  };
}
class H5t {
  nodesRef = {
    current: []
  };
  events = loe();
  addNode(t) {
    this.nodesRef.current.push(t);
  }
  removeNode(t) {
    const r = this.nodesRef.current.findIndex((a) => a === t);
    r !== -1 && this.nodesRef.current.splice(r, 1);
  }
}
const cL = /* @__PURE__ */ S.createContext(null);
process.env.NODE_ENV !== "production" && (cL.displayName = "FloatingNodeContext");
const dL = /* @__PURE__ */ S.createContext(null);
process.env.NODE_ENV !== "production" && (dL.displayName = "FloatingTreeContext");
const C3 = () => S.useContext(cL)?.id || null, c6 = (e) => {
  const t = S.useContext(dL);
  return e ?? t;
};
function F5t(e) {
  const t = w3(), r = c6(e), a = C3();
  return Dr(() => {
    if (!t)
      return;
    const i = {
      id: t,
      parentId: a
    };
    return r?.addNode(i), () => {
      r?.removeNode(i);
    };
  }, [r, t, a]), t;
}
function W5t(e) {
  const {
    children: t,
    id: r
  } = e, a = C3();
  return /* @__PURE__ */ V.jsx(cL.Provider, {
    value: S.useMemo(() => ({
      id: r,
      parentId: a
    }), [r, a]),
    children: t
  });
}
function V5t(e) {
  const {
    children: t,
    externalTree: r
  } = e, a = am(() => r ?? new H5t()).current;
  return /* @__PURE__ */ V.jsx(dL.Provider, {
    value: a,
    children: t
  });
}
function jx(e) {
  return `data-base-ui-${e}`;
}
function Rk(e, t, r) {
  if (r && !u3(r))
    return 0;
  if (typeof e == "number")
    return e;
  if (typeof e == "function") {
    const a = e();
    return typeof a == "number" ? a : a?.[t];
  }
  return e?.[t];
}
const fL = /* @__PURE__ */ S.createContext({
  hasProvider: !1,
  timeoutMs: 0,
  delayRef: {
    current: 0
  },
  initialDelayRef: {
    current: 0
  },
  timeout: new $0(),
  currentIdRef: {
    current: null
  },
  currentContextRef: {
    current: null
  }
});
process.env.NODE_ENV !== "production" && (fL.displayName = "FloatingDelayGroupContext");
function _5t(e) {
  const {
    children: t,
    delay: r,
    timeoutMs: a = 0
  } = e, i = S.useRef(r), c = S.useRef(r), d = S.useRef(null), f = S.useRef(null), p = JS();
  return /* @__PURE__ */ V.jsx(fL.Provider, {
    value: S.useMemo(() => ({
      hasProvider: !0,
      delayRef: i,
      initialDelayRef: c,
      currentIdRef: d,
      timeoutMs: a,
      currentContextRef: f,
      timeout: p
    }), [a, p]),
    children: t
  });
}
function B5t(e, t = {
  open: !1
}) {
  const r = "rootStore" in e ? e.rootStore : e, a = r.useState("floatingId"), {
    open: i
  } = t, c = S.useContext(fL), {
    currentIdRef: d,
    delayRef: f,
    timeoutMs: p,
    initialDelayRef: g,
    currentContextRef: b,
    hasProvider: w,
    timeout: x
  } = c, [E, P] = S.useState(!1);
  return Dr(() => {
    function k() {
      P(!1), b.current?.setIsInstantPhase(!1), d.current = null, b.current = null, f.current = g.current;
    }
    if (d.current && !i && d.current === a) {
      if (P(!1), p) {
        const M = a;
        return x.start(p, () => {
          r.select("open") || d.current && d.current !== M || k();
        }), () => {
          x.clear();
        };
      }
      k();
    }
  }, [i, a, d, f, p, g, b, x, r]), Dr(() => {
    if (!i)
      return;
    const k = b.current, M = d.current;
    x.clear(), b.current = {
      onOpenChange: r.setOpen,
      setIsInstantPhase: P
    }, d.current = a, f.current = {
      open: 0,
      close: Rk(g.current, "close")
    }, M !== null && M !== a ? (P(!0), k?.setIsInstantPhase(!0), k?.onOpenChange(!1, ji($x))) : (P(!1), k?.setIsInstantPhase(!1));
  }, [i, a, r, d, f, p, g, b, x]), Dr(() => () => {
    b.current = null;
  }, [b]), S.useMemo(() => ({
    hasProvider: w,
    delayRef: f,
    isInstantPhase: E
  }), [w, f, E]);
}
const U5t = {
  clipPath: "inset(50%)",
  overflow: "hidden",
  whiteSpace: "nowrap",
  border: 0,
  padding: 0,
  width: 1,
  height: 1,
  margin: -1
}, mL = {
  ...U5t,
  position: "fixed",
  top: 0,
  left: 0
}, mb = /* @__PURE__ */ S.forwardRef(function(t, r) {
  const [a, i] = S.useState();
  Dr(() => {
    Bae && i("button");
  }, []);
  const c = {
    tabIndex: 0,
    // Role is only for VoiceOver
    role: a
  };
  return /* @__PURE__ */ V.jsx("span", {
    ...t,
    ref: r,
    style: mL,
    "aria-hidden": a ? void 0 : !0,
    ...c,
    "data-base-ui-focus-guard": ""
  });
});
process.env.NODE_ENV !== "production" && (mb.displayName = "FocusGuard");
let hX = 0;
function tN(e, t = {}) {
  const {
    preventScroll: r = !1,
    cancelPrevious: a = !0,
    sync: i = !1
  } = t;
  a && cancelAnimationFrame(hX);
  const c = () => e?.focus({
    preventScroll: r
  });
  i ? c() : hX = requestAnimationFrame(c);
}
const mx = {
  inert: /* @__PURE__ */ new WeakMap(),
  "aria-hidden": /* @__PURE__ */ new WeakMap(),
  none: /* @__PURE__ */ new WeakMap()
};
function pX(e) {
  return e === "inert" ? mx.inert : e === "aria-hidden" ? mx["aria-hidden"] : mx.none;
}
let NP = /* @__PURE__ */ new WeakSet(), DP = {}, nN = 0;
const soe = (e) => e && (e.host || soe(e.parentNode)), X5t = (e, t) => t.map((r) => {
  if (e.contains(r))
    return r;
  const a = soe(r);
  return e.contains(a) ? a : null;
}).filter((r) => r != null);
function G5t(e, t, r, a) {
  const i = "data-base-ui-inert", c = a ? "inert" : r ? "aria-hidden" : null, d = X5t(t, e), f = /* @__PURE__ */ new Set(), p = new Set(d), g = [];
  DP[i] || (DP[i] = /* @__PURE__ */ new WeakMap());
  const b = DP[i];
  d.forEach(w), x(t), f.clear();
  function w(E) {
    !E || f.has(E) || (f.add(E), E.parentNode && w(E.parentNode));
  }
  function x(E) {
    !E || p.has(E) || [].forEach.call(E.children, (P) => {
      if (lC(P) !== "script")
        if (f.has(P))
          x(P);
        else {
          const k = c ? P.getAttribute(c) : null, M = k !== null && k !== "false", T = pX(c), N = (T.get(P) || 0) + 1, D = (b.get(P) || 0) + 1;
          T.set(P, N), b.set(P, D), g.push(P), N === 1 && M && NP.add(P), D === 1 && P.setAttribute(i, ""), !M && c && P.setAttribute(c, c === "inert" ? "" : "true");
        }
    });
  }
  return nN += 1, () => {
    g.forEach((E) => {
      const P = pX(c), M = (P.get(E) || 0) - 1, T = (b.get(E) || 0) - 1;
      P.set(E, M), b.set(E, T), M || (!NP.has(E) && c && E.removeAttribute(c), NP.delete(E)), T || E.removeAttribute(i);
    }), nN -= 1, nN || (mx.inert = /* @__PURE__ */ new WeakMap(), mx["aria-hidden"] = /* @__PURE__ */ new WeakMap(), mx.none = /* @__PURE__ */ new WeakMap(), NP = /* @__PURE__ */ new WeakSet(), DP = {});
  };
}
function q5t(e, t = !1, r = !1) {
  const a = Qo(e[0]).body;
  return G5t(e.concat(Array.from(a.querySelectorAll("[aria-live]"))), a, t, r);
}
const hL = /* @__PURE__ */ S.createContext(null);
process.env.NODE_ENV !== "production" && (hL.displayName = "PortalContext");
const uoe = () => S.useContext(hL), K5t = jx("portal");
function coe(e = {}) {
  const {
    ref: t,
    container: r,
    componentProps: a = Gh,
    elementProps: i
  } = e, c = w3(), f = uoe()?.portalNode, [p, g] = S.useState(null), [b, w] = S.useState(null), x = Ar((M) => {
    M !== null && w(M);
  }), E = S.useRef(null);
  Dr(() => {
    if (r === null) {
      E.current && (E.current = null, w(null), g(null));
      return;
    }
    if (c == null)
      return;
    const M = (r && (NI(r) ? r : r.current)) ?? f ?? document.body;
    if (M == null) {
      E.current && (E.current = null, w(null), g(null));
      return;
    }
    E.current !== M && (E.current = M, w(null), g(M));
  }, [r, f, c]);
  const P = nc("div", a, {
    ref: [t, x],
    props: [{
      id: c,
      [K5t]: ""
    }, i]
  });
  return {
    portalNode: b,
    portalSubtree: p && P ? /* @__PURE__ */ sp.createPortal(P, p) : null
  };
}
const doe = /* @__PURE__ */ S.forwardRef(function(t, r) {
  const {
    children: a,
    container: i,
    className: c,
    render: d,
    renderGuards: f,
    ...p
  } = t, {
    portalNode: g,
    portalSubtree: b
  } = coe({
    container: i,
    ref: r,
    componentProps: t,
    elementProps: p
  }), w = S.useRef(null), x = S.useRef(null), E = S.useRef(null), P = S.useRef(null), [k, M] = S.useState(null), T = k?.modal, N = k?.open, D = typeof f == "boolean" ? f : !!k && !k.modal && k.open && !!g;
  S.useEffect(() => {
    if (!g || T)
      return;
    function j(I) {
      g && I.relatedTarget && fx(I) && (I.type === "focusin" ? mX : L5t)(g);
    }
    return g.addEventListener("focusin", j, !0), g.addEventListener("focusout", j, !0), () => {
      g.removeEventListener("focusin", j, !0), g.removeEventListener("focusout", j, !0);
    };
  }, [g, T]), S.useEffect(() => {
    !g || N || mX(g);
  }, [N, g]);
  const $ = S.useMemo(() => ({
    beforeOutsideRef: w,
    afterOutsideRef: x,
    beforeInsideRef: E,
    afterInsideRef: P,
    portalNode: g,
    setFocusManagerState: M
  }), [g]);
  return /* @__PURE__ */ V.jsxs(S.Fragment, {
    children: [b, /* @__PURE__ */ V.jsxs(hL.Provider, {
      value: $,
      children: [D && g && /* @__PURE__ */ V.jsx(mb, {
        "data-type": "outside",
        ref: w,
        onFocus: (j) => {
          if (fx(j, g))
            E.current?.focus();
          else {
            const I = k ? k.domReference : null;
            ooe(I)?.focus();
          }
        }
      }), D && g && /* @__PURE__ */ V.jsx("span", {
        "aria-owns": g.id,
        style: O8t
      }), g && /* @__PURE__ */ sp.createPortal(a, g), D && g && /* @__PURE__ */ V.jsx(mb, {
        "data-type": "outside",
        ref: x,
        onFocus: (j) => {
          if (fx(j, g))
            P.current?.focus();
          else {
            const I = k ? k.domReference : null;
            uL(I)?.focus(), k?.closeOnFocusOut && k?.onOpenChange(!1, ji(LE, j.nativeEvent));
          }
        }
      })]
    })]
  });
});
process.env.NODE_ENV !== "production" && (doe.displayName = "FloatingPortal");
function Y5t(e, t) {
  const r = lu(e.target);
  return e instanceof r.KeyboardEvent ? "keyboard" : e instanceof r.FocusEvent ? t || "keyboard" : "pointerType" in e ? e.pointerType || "keyboard" : "touches" in e ? "touch" : e instanceof r.MouseEvent ? t || (e.detail === 0 ? "keyboard" : "mouse") : "";
}
const gX = 20;
let DS = [];
function pL() {
  DS = DS.filter((e) => e.deref()?.isConnected);
}
function Q5t(e) {
  pL(), e && lC(e) !== "body" && (DS.push(new WeakRef(e)), DS.length > gX && (DS = DS.slice(-gX)));
}
function rN() {
  return pL(), DS[DS.length - 1]?.deref();
}
function J5t(e) {
  if (!e)
    return null;
  const t = u6();
  return roe(e, t) ? e : P7(e, t)[0] || e;
}
function Z5t(e) {
  return !e || !e.isConnected ? !1 : typeof e.checkVisibility == "function" ? e.checkVisibility() : dp(e).display !== "none";
}
function vX(e, t) {
  if (!t.current.includes("floating") && !e.getAttribute("role")?.includes("dialog"))
    return;
  const r = u6(), i = z5t(e, r).filter((d) => {
    const f = d.getAttribute("data-tabindex") || "";
    return roe(d, r) || d.hasAttribute("data-tabindex") && !f.startsWith("-");
  }), c = e.getAttribute("tabindex");
  t.current.includes("floating") || i.length === 0 ? c !== "0" && e.setAttribute("tabindex", "0") : (c !== "-1" || e.hasAttribute("data-tabindex") && e.getAttribute("data-tabindex") !== "-1") && (e.setAttribute("tabindex", "-1"), e.setAttribute("data-tabindex", "-1"));
}
function eEt(e) {
  const {
    context: t,
    children: r,
    disabled: a = !1,
    initialFocus: i = !0,
    returnFocus: c = !0,
    restoreFocus: d = !1,
    modal: f = !0,
    closeOnFocusOut: p = !0,
    openInteractionType: g = "",
    nextFocusableElement: b,
    previousFocusableElement: w,
    beforeContentFocusGuardRef: x,
    externalTree: E
  } = e, P = "rootStore" in t ? t.rootStore : t, k = P.useState("open"), M = P.useState("domReferenceElement"), T = P.useState("floatingElement"), {
    events: N,
    dataRef: D
  } = P.context, $ = Ar(() => D.current.floatingContext?.nodeId), j = i === !1, I = cX(M) && j, L = S.useRef(["content"]), F = ub(i), _ = ub(c), W = ub(g), Q = c6(E), U = uoe(), Y = S.useRef(null), G = S.useRef(null), J = S.useRef(!1), H = S.useRef(!1), K = S.useRef(!1), X = S.useRef(-1), te = S.useRef(""), ie = S.useRef(""), ee = S.useRef(null), ne = S.useRef(null), ae = l3(ee, x, U?.beforeInsideRef), oe = l3(ne, U?.afterInsideRef), fe = JS(), be = JS(), me = eO(), De = U != null, Me = nz(T), ze = Ar((Ae = Me) => Ae ? P7(Ae, u6()) : []), le = Ar((Ae) => {
    const we = ze(Ae);
    return L.current.map(() => we).filter(Boolean).flat();
  });
  S.useEffect(() => {
    if (a || !f)
      return;
    function Ae(Ne) {
      Ne.key === "Tab" && oo(Me, ap(Qo(Me))) && ze().length === 0 && !I && F4(Ne);
    }
    const we = Qo(Me);
    return we.addEventListener("keydown", Ae), () => {
      we.removeEventListener("keydown", Ae);
    };
  }, [a, M, Me, f, L, I, ze, le]), S.useEffect(() => {
    if (a || !k)
      return;
    const Ae = Qo(Me);
    function we() {
      K.current = !1;
    }
    function Ne(Qe) {
      const Le = tm(Qe), Te = oo(T, Le) || oo(M, Le) || oo(U?.portalNode, Le);
      K.current = !Te, ie.current = Qe.pointerType || "keyboard", Le?.closest(`[${Oae}]`) && (H.current = !0);
    }
    function pe() {
      ie.current = "keyboard";
    }
    return Ae.addEventListener("pointerdown", Ne, !0), Ae.addEventListener("pointerup", we, !0), Ae.addEventListener("pointercancel", we, !0), Ae.addEventListener("keydown", pe, !0), () => {
      Ae.removeEventListener("pointerdown", Ne, !0), Ae.removeEventListener("pointerup", we, !0), Ae.removeEventListener("pointercancel", we, !0), Ae.removeEventListener("keydown", pe, !0);
    };
  }, [a, T, M, Me, k, U]), S.useEffect(() => {
    if (a || !p)
      return;
    const Ae = Qo(Me);
    function we() {
      H.current = !0, be.start(0, () => {
        H.current = !1;
      });
    }
    function Ne(Oe) {
      const ye = tm(Oe), Ue = ze().indexOf(ye);
      Ue !== -1 && (X.current = Ue);
    }
    function pe(Oe) {
      const ye = Oe.relatedTarget, je = Oe.currentTarget, Ue = tm(Oe);
      queueMicrotask(() => {
        const Fe = $(), tt = P.context.triggerElements, dt = ye?.hasAttribute(jx("focus-guard")) && [ee.current, ne.current, U?.beforeInsideRef.current, U?.afterInsideRef.current, U?.beforeOutsideRef.current, U?.afterOutsideRef.current, qw(w), qw(b)].includes(ye), St = !(oo(M, ye) || oo(T, ye) || oo(ye, T) || oo(U?.portalNode, ye) || ye != null && tt.hasElement(ye) || tt.hasMatchingElement((mt) => oo(mt, ye)) || dt || Q && (Y4(Q.nodesRef.current, Fe).find((mt) => oo(mt.context?.elements.floating, ye) || oo(mt.context?.elements.domReference, ye)) || dX(Q.nodesRef.current, Fe).find((mt) => [mt.context?.elements.floating, nz(mt.context?.elements.floating)].includes(ye) || mt.context?.elements.domReference === ye)));
        if (je === M && Me && vX(Me, L), d && je !== M && !Z5t(Ue) && ap(Ae) === Ae.body) {
          if (Os(Me) && (Me.focus(), d === "popup")) {
            me.request(() => {
              Me.focus();
            });
            return;
          }
          const mt = X.current, Ot = ze(), Rt = Ot[mt] || Ot[Ot.length - 1] || Me;
          Os(Rt) && Rt.focus();
        }
        if (D.current.insideReactTree) {
          D.current.insideReactTree = !1;
          return;
        }
        (I || !f) && ye && St && !H.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
        // For an "untrapped" typeable combobox (input role=combobox with
        // initialFocus=false), re-opening the popup and tabbing out should still close it even
        // when the previously focused element (e.g. the next tabbable outside the popup) is
        // focused again. Otherwise, the popup remains open on the second Tab sequence:
        // click input -> Tab (closes) -> click input -> Tab.
        // Allow closing when `isUntrappedTypeableCombobox` regardless of the previously focused element.
        (I || ye !== rN()) && (J.current = !0, P.setOpen(!1, ji(LE, Oe)));
      });
    }
    function Qe() {
      K.current || (D.current.insideReactTree = !0, fe.start(0, () => {
        D.current.insideReactTree = !1;
      }));
    }
    const Le = Os(M) ? M : null, Te = [];
    if (!(!T && !Le))
      return Le && (Le.addEventListener("focusout", pe), Le.addEventListener("pointerdown", we), Te.push(() => {
        Le.removeEventListener("focusout", pe), Le.removeEventListener("pointerdown", we);
      })), T && (T.addEventListener("focusin", Ne), T.addEventListener("focusout", pe), U && (T.addEventListener("focusout", Qe, !0), Te.push(() => {
        T.removeEventListener("focusout", Qe, !0);
      })), Te.push(() => {
        T.removeEventListener("focusin", Ne), T.removeEventListener("focusout", pe);
      })), () => {
        Te.forEach((Oe) => {
          Oe();
        });
      };
  }, [a, M, T, Me, f, Q, U, P, p, d, ze, I, $, L, D, fe, be, me, b, w]), S.useEffect(() => {
    if (a || !T || !k)
      return;
    const Ae = Array.from(U?.portalNode?.querySelectorAll(`[${jx("portal")}]`) || []), Ne = (Q ? dX(Q.nodesRef.current, $()) : []).find((Qe) => cX(Qe.context?.elements.domReference || null))?.context?.elements.domReference, pe = [T, Ne, ...Ae, Y.current, G.current, ee.current, ne.current, U?.beforeOutsideRef.current, U?.afterOutsideRef.current, qw(w), qw(b), I ? M : null].filter((Qe) => Qe != null);
    return q5t(pe, f || I);
  }, [k, a, M, T, f, L, U, I, Q, $, b, w]), Dr(() => {
    if (!k || a || !Os(Me))
      return;
    const Ae = Qo(Me), we = ap(Ae);
    queueMicrotask(() => {
      const Ne = le(Me), pe = F.current, Qe = typeof pe == "function" ? pe(W.current || "") : pe;
      if (Qe === void 0 || Qe === !1)
        return;
      let Le;
      Qe === !0 || Qe === null ? Le = Ne[0] || Me : Le = qw(Qe), Le = Le || Ne[0] || Me, !oo(Me, we) && tN(Le, {
        preventScroll: Le === Me
      });
    });
  }, [a, k, Me, j, le, F, W]), Dr(() => {
    if (a || !Me)
      return;
    const Ae = Qo(Me), we = ap(Ae);
    Q5t(we);
    function Ne(Le) {
      if (Le.open || (te.current = Y5t(Le.nativeEvent, ie.current)), Le.reason === Xh && Le.nativeEvent.type === "mouseleave" && (J.current = !0), Le.reason === Aae)
        if (Le.nested)
          J.current = !1;
        else if (m5t(Le.nativeEvent) || h5t(Le.nativeEvent))
          J.current = !1;
        else {
          let Te = !1;
          document.createElement("div").focus({
            get preventScroll() {
              return Te = !0, !1;
            }
          }), Te ? J.current = !1 : J.current = !0;
        }
    }
    N.on("openchange", Ne);
    const pe = Ae.createElement("span");
    pe.setAttribute("tabindex", "-1"), pe.setAttribute("aria-hidden", "true"), Object.assign(pe.style, mL), De && M && M.insertAdjacentElement("afterend", pe);
    function Qe() {
      const Le = _.current;
      let Te = typeof Le == "function" ? Le(te.current) : Le;
      if (Te === void 0 || Te === !1)
        return null;
      if (Te === null && (Te = !0), typeof Te == "boolean") {
        const ye = M || rN();
        return ye && ye.isConnected ? ye : pe;
      }
      const Oe = M || rN() || pe;
      return qw(Te) || Oe;
    }
    return () => {
      N.off("openchange", Ne);
      const Le = ap(Ae), Te = oo(T, Le) || Q && Y4(Q.nodesRef.current, $(), !1).some((ye) => oo(ye.context?.elements.floating, Le)), Oe = Qe();
      queueMicrotask(() => {
        const ye = J5t(Oe), je = typeof _.current != "boolean";
        // eslint-disable-next-line react-hooks/exhaustive-deps
        _.current && !J.current && Os(ye) && // If the focus moved somewhere else after mount, avoid returning focus
        // since it likely entered a different element which should be
        // respected: https://github.com/floating-ui/floating-ui/issues/2607
        (!(!je && ye !== Le && Le !== Ae.body) || Te) && ye.focus({
          preventScroll: !0
        }), pe.remove(), J.current = !1;
      });
    };
  }, [a, T, Me, _, D, N, Q, De, M, $]), Dr(() => {
    if (!Vae || k || !T)
      return;
    const Ae = ap(Qo(T));
    !Os(Ae) || !tO(Ae) || oo(T, Ae) && Ae.blur();
  }, [k, T]), Dr(() => {
    if (!(a || !U))
      return U.setFocusManagerState({
        modal: f,
        closeOnFocusOut: p,
        open: k,
        onOpenChange: P.setOpen,
        domReference: M
      }), () => {
        U.setFocusManagerState(null);
      };
  }, [a, U, f, k, P, p, M]), Dr(() => {
    if (!(a || !Me))
      return vX(Me, L), () => {
        queueMicrotask(pL);
      };
  }, [a, Me, L]);
  const se = !a && (f ? !I : !0) && (De || f);
  return /* @__PURE__ */ V.jsxs(S.Fragment, {
    children: [se && /* @__PURE__ */ V.jsx(mb, {
      "data-type": "inside",
      ref: ae,
      onFocus: (Ae) => {
        if (f) {
          const we = le();
          tN(we[we.length - 1]);
        } else U?.portalNode && (J.current = !1, fx(Ae, U.portalNode) ? uL(M)?.focus() : qw(w ?? U.beforeOutsideRef)?.focus());
      }
    }), r, se && /* @__PURE__ */ V.jsx(mb, {
      "data-type": "inside",
      ref: oe,
      onFocus: (Ae) => {
        f ? tN(le()[0]) : U?.portalNode && (p && (J.current = !0), fx(Ae, U.portalNode) ? ooe(M)?.focus() : qw(b ?? U.afterOutsideRef)?.focus());
      }
    })]
  });
}
function tEt(e, t = {}) {
  const r = "rootStore" in e ? e.rootStore : e, a = r.context.dataRef, {
    enabled: i = !0,
    event: c = "click",
    toggle: d = !0,
    ignoreMouse: f = !1,
    stickIfOpen: p = !0,
    touchOpenDelay: g = 0,
    reason: b = hS
  } = t, w = S.useRef(void 0), x = eO(), E = JS(), P = S.useMemo(() => ({
    onPointerDown(k) {
      w.current = k.pointerType;
    },
    onMouseDown(k) {
      const M = w.current, T = k.nativeEvent, N = r.select("open");
      if (k.button !== 0 || c === "click" || u3(M, !0) && f)
        return;
      const D = a.current.openEvent, $ = D?.type, j = r.select("domReferenceElement") !== k.currentTarget, I = N && j || !(N && d && (!(D && p) || $ === "click" || $ === "mousedown"));
      if (tO(T.target)) {
        const F = ji(b, T, T.target);
        I && M === "touch" && g > 0 ? E.start(g, () => {
          r.setOpen(!0, F);
        }) : r.setOpen(I, F);
        return;
      }
      const L = k.currentTarget;
      x.request(() => {
        const F = ji(b, T, L);
        I && M === "touch" && g > 0 ? E.start(g, () => {
          r.setOpen(!0, F);
        }) : r.setOpen(I, F);
      });
    },
    onClick(k) {
      if (c === "mousedown-only")
        return;
      const M = w.current;
      if (c === "mousedown" && M) {
        w.current = void 0;
        return;
      }
      if (u3(M, !0) && f)
        return;
      const T = r.select("open"), N = a.current.openEvent, D = r.select("domReferenceElement") !== k.currentTarget, $ = T && D || !(T && d && (!(N && p) || Yae(N))), j = ji(b, k.nativeEvent, k.currentTarget);
      $ && M === "touch" && g > 0 ? E.start(g, () => {
        r.setOpen(!0, j);
      }) : r.setOpen($, j);
    },
    onKeyDown() {
      w.current = void 0;
    }
  }), [a, c, f, r, p, d, x, E, g, b]);
  return S.useMemo(() => i ? {
    reference: P
  } : Gh, [i, P]);
}
function nEt(e, t) {
  let r = null, a = null, i = !1;
  return {
    contextElement: e || void 0,
    getBoundingClientRect() {
      const c = e?.getBoundingClientRect() || {
        width: 0,
        height: 0,
        x: 0,
        y: 0
      }, d = t.axis === "x" || t.axis === "both", f = t.axis === "y" || t.axis === "both", p = ["mouseenter", "mousemove"].includes(t.dataRef.current.openEvent?.type || "") && t.pointerType !== "touch";
      let g = c.width, b = c.height, w = c.x, x = c.y;
      return r == null && t.x && d && (r = c.x - t.x), a == null && t.y && f && (a = c.y - t.y), w -= r || 0, x -= a || 0, g = 0, b = 0, !i || p ? (g = t.axis === "y" ? c.width : 0, b = t.axis === "x" ? c.height : 0, w = d && t.x != null ? t.x : w, x = f && t.y != null ? t.y : x) : i && !p && (b = t.axis === "x" ? c.height : b, g = t.axis === "y" ? c.width : g), i = !0, {
        width: g,
        height: b,
        x: w,
        y: x,
        top: x,
        right: w + g,
        bottom: x + b,
        left: w
      };
    }
  };
}
function bX(e) {
  return e != null && e.clientX != null;
}
function rEt(e, t = {}) {
  const r = "rootStore" in e ? e.rootStore : e, a = r.useState("open"), i = r.useState("floatingElement"), c = r.useState("domReferenceElement"), d = r.context.dataRef, {
    enabled: f = !0,
    axis: p = "both"
  } = t, g = S.useRef(!1), b = S.useRef(null), [w, x] = S.useState(), [E, P] = S.useState([]), k = Ar(($, j, I) => {
    g.current || d.current.openEvent && !bX(d.current.openEvent) || r.set("positionReference", nEt(I ?? c, {
      x: $,
      y: j,
      axis: p,
      dataRef: d,
      pointerType: w
    }));
  }), M = Ar(($) => {
    a ? b.current || P([]) : k($.clientX, $.clientY, $.currentTarget);
  }), T = u3(w) ? i : a, N = S.useCallback(() => {
    if (!T || !f)
      return;
    const $ = lu(i);
    function j(I) {
      const L = tm(I);
      oo(i, L) ? ($.removeEventListener("mousemove", j), b.current = null) : k(I.clientX, I.clientY);
    }
    if (!d.current.openEvent || bX(d.current.openEvent)) {
      $.addEventListener("mousemove", j);
      const I = () => {
        $.removeEventListener("mousemove", j), b.current = null;
      };
      return b.current = I, I;
    }
    r.set("positionReference", c);
  }, [T, f, i, d, c, r, k]);
  S.useEffect(() => N(), [N, E]), S.useEffect(() => {
    f && !i && (g.current = !1);
  }, [f, i]), S.useEffect(() => {
    !f && a && (g.current = !0);
  }, [f, a]);
  const D = S.useMemo(() => {
    function $(j) {
      x(j.pointerType);
    }
    return {
      onPointerDown: $,
      onPointerEnter: $,
      onMouseMove: M,
      onMouseEnter: M
    };
  }, [M]);
  return S.useMemo(() => f ? {
    reference: D,
    trigger: D
  } : {}, [f, D]);
}
const aEt = {
  intentional: "onClick",
  sloppy: "onPointerDown"
};
function oEt(e) {
  return {
    escapeKey: typeof e == "boolean" ? e : e?.escapeKey ?? !1,
    outsidePress: typeof e == "boolean" ? e : e?.outsidePress ?? !0
  };
}
function foe(e, t = {}) {
  const r = "rootStore" in e ? e.rootStore : e, a = r.useState("open"), i = r.useState("floatingElement"), c = r.useState("referenceElement"), d = r.useState("domReferenceElement"), {
    onOpenChange: f,
    dataRef: p
  } = r.context, {
    enabled: g = !0,
    escapeKey: b = !0,
    outsidePress: w = !0,
    outsidePressEvent: x = "sloppy",
    referencePress: E = !1,
    referencePressEvent: P = "sloppy",
    ancestorScroll: k = !1,
    bubbles: M,
    externalTree: T
  } = t, N = c6(T), D = Ar(typeof w == "function" ? w : () => !1), $ = typeof w == "function" ? D : w, j = S.useRef(!1), {
    escapeKey: I,
    outsidePress: L
  } = oEt(M), F = S.useRef(null), _ = JS(), W = JS(), Q = Ar(() => {
    W.clear(), p.current.insideReactTree = !1;
  }), U = S.useRef(!1), Y = S.useRef(""), G = Ar((se) => {
    Y.current = se.pointerType;
  }), J = Ar(() => {
    const se = Y.current, Ae = se === "pen" || !se ? "mouse" : se, we = typeof x == "function" ? x() : x;
    return typeof we == "string" ? we : we[Ae];
  }), H = Ar((se) => {
    if (!a || !g || !b || se.key !== "Escape" || U.current)
      return;
    const Ae = p.current.floatingContext?.nodeId, we = N ? Y4(N.nodesRef.current, Ae) : [];
    if (!I && we.length > 0) {
      let Qe = !0;
      if (we.forEach((Le) => {
        Le.context?.open && !Le.context.dataRef.current.__escapeKeyBubbles && (Qe = !1);
      }), !Qe)
        return;
    }
    const Ne = f5t(se) ? se.nativeEvent : se, pe = ji(ZM, Ne);
    r.setOpen(!1, pe), !I && !pe.isPropagationAllowed && se.stopPropagation();
  }), K = Ar((se) => {
    const Ae = J();
    return Ae === "intentional" && se.type !== "click" || Ae === "sloppy" && se.type === "click";
  }), X = Ar(() => {
    p.current.insideReactTree = !0, W.start(0, Q);
  }), te = Ar((se, Ae = !1) => {
    if (K(se)) {
      Q();
      return;
    }
    if (p.current.insideReactTree) {
      Q();
      return;
    }
    if (J() === "intentional" && Ae || typeof $ == "function" && !$(se))
      return;
    const we = tm(se), Ne = `[${jx("inert")}]`, pe = Qo(r.select("floatingElement")).querySelectorAll(Ne), Qe = r.context.triggerElements;
    if (we && (Qe.hasElement(we) || Qe.hasMatchingElement((je) => oo(je, we))))
      return;
    let Le = di(we) ? we : null;
    for (; Le && !lS(Le); ) {
      const je = mS(Le);
      if (lS(je) || !di(je))
        break;
      Le = je;
    }
    if (pe.length && di(we) && !d5t(we) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
    !oo(we, r.select("floatingElement")) && // If the target root element contains none of the markers, then the
    // element was injected after the floating element rendered.
    Array.from(pe).every((je) => !oo(Le, je)))
      return;
    if (Os(we) && !("touches" in se)) {
      const je = lS(we), Ue = dp(we), Fe = /auto|scroll/, tt = je || Fe.test(Ue.overflowX), dt = je || Fe.test(Ue.overflowY), St = tt && we.clientWidth > 0 && we.scrollWidth > we.clientWidth, mt = dt && we.clientHeight > 0 && we.scrollHeight > we.clientHeight, Ot = Ue.direction === "rtl", Rt = mt && (Ot ? se.offsetX <= we.offsetWidth - we.clientWidth : se.offsetX > we.clientWidth), ct = St && se.offsetY > we.clientHeight;
      if (Rt || ct)
        return;
    }
    const Te = p.current.floatingContext?.nodeId, Oe = N && Y4(N.nodesRef.current, Te).some((je) => D1(se, je.context?.elements.floating));
    if (D1(se, r.select("floatingElement")) || D1(se, r.select("domReferenceElement")) || Oe)
      return;
    const ye = N ? Y4(N.nodesRef.current, Te) : [];
    if (ye.length > 0) {
      let je = !0;
      if (ye.forEach((Ue) => {
        Ue.context?.open && !Ue.context.dataRef.current.__outsidePressBubbles && (je = !1);
      }), !je)
        return;
    }
    r.setOpen(!1, ji(Aae, se)), Q();
  }), ie = Ar((se) => {
    J() !== "sloppy" || se.pointerType === "touch" || !r.select("open") || !g || D1(se, r.select("floatingElement")) || D1(se, r.select("domReferenceElement")) || te(se);
  }), ee = Ar((se) => {
    if (J() !== "sloppy" || !r.select("open") || !g || D1(se, r.select("floatingElement")) || D1(se, r.select("domReferenceElement")))
      return;
    const Ae = se.touches[0];
    Ae && (F.current = {
      startTime: Date.now(),
      startX: Ae.clientX,
      startY: Ae.clientY,
      dismissOnTouchEnd: !1,
      dismissOnMouseDown: !0
    }, _.start(1e3, () => {
      F.current && (F.current.dismissOnTouchEnd = !1, F.current.dismissOnMouseDown = !1);
    }));
  }), ne = Ar((se) => {
    const Ae = tm(se);
    function we() {
      ee(se), Ae?.removeEventListener(se.type, we);
    }
    Ae?.addEventListener(se.type, we);
  }), ae = Ar((se) => {
    const Ae = j.current;
    if (j.current = !1, _.clear(), se.type === "mousedown" && F.current && !F.current.dismissOnMouseDown)
      return;
    const we = tm(se);
    function Ne() {
      se.type === "pointerdown" ? ie(se) : te(se, Ae), we?.removeEventListener(se.type, Ne);
    }
    we?.addEventListener(se.type, Ne);
  }), oe = Ar((se) => {
    if (J() !== "sloppy" || !F.current || D1(se, r.select("floatingElement")) || D1(se, r.select("domReferenceElement")))
      return;
    const Ae = se.touches[0];
    if (!Ae)
      return;
    const we = Math.abs(Ae.clientX - F.current.startX), Ne = Math.abs(Ae.clientY - F.current.startY), pe = Math.sqrt(we * we + Ne * Ne);
    pe > 5 && (F.current.dismissOnTouchEnd = !0), pe > 10 && (te(se), _.clear(), F.current = null);
  }), fe = Ar((se) => {
    const Ae = tm(se);
    function we() {
      oe(se), Ae?.removeEventListener(se.type, we);
    }
    Ae?.addEventListener(se.type, we);
  }), be = Ar((se) => {
    J() !== "sloppy" || !F.current || D1(se, r.select("floatingElement")) || D1(se, r.select("domReferenceElement")) || (F.current.dismissOnTouchEnd && te(se), _.clear(), F.current = null);
  }), me = Ar((se) => {
    const Ae = tm(se);
    function we() {
      be(se), Ae?.removeEventListener(se.type, we);
    }
    Ae?.addEventListener(se.type, we);
  });
  S.useEffect(() => {
    if (!a || !g)
      return;
    p.current.__escapeKeyBubbles = I, p.current.__outsidePressBubbles = L;
    const se = new $0();
    function Ae(Le) {
      r.setOpen(!1, ji($x, Le));
    }
    function we() {
      se.clear(), U.current = !0;
    }
    function Ne() {
      se.start(
        // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
        // Only apply to WebKit for the test to remain 0ms.
        FM() ? 5 : 0,
        () => {
          U.current = !1;
        }
      );
    }
    const pe = Qo(i);
    pe.addEventListener("pointerdown", G, !0), b && (pe.addEventListener("keydown", H), pe.addEventListener("compositionstart", we), pe.addEventListener("compositionend", Ne)), $ && (pe.addEventListener("click", ae, !0), pe.addEventListener("pointerdown", ae, !0), pe.addEventListener("touchstart", ne, !0), pe.addEventListener("touchmove", fe, !0), pe.addEventListener("touchend", me, !0), pe.addEventListener("mousedown", ae, !0));
    let Qe = [];
    return k && (di(d) && (Qe = LS(d)), di(i) && (Qe = Qe.concat(LS(i))), !di(c) && c && c.contextElement && (Qe = Qe.concat(LS(c.contextElement)))), Qe = Qe.filter((Le) => Le !== pe.defaultView?.visualViewport), Qe.forEach((Le) => {
      Le.addEventListener("scroll", Ae, {
        passive: !0
      });
    }), () => {
      pe.removeEventListener("pointerdown", G, !0), b && (pe.removeEventListener("keydown", H), pe.removeEventListener("compositionstart", we), pe.removeEventListener("compositionend", Ne)), $ && (pe.removeEventListener("click", ae, !0), pe.removeEventListener("pointerdown", ae, !0), pe.removeEventListener("touchstart", ne, !0), pe.removeEventListener("touchmove", fe, !0), pe.removeEventListener("touchend", me, !0), pe.removeEventListener("mousedown", ae, !0)), Qe.forEach((Le) => {
        Le.removeEventListener("scroll", Ae);
      }), se.clear(), j.current = !1;
    };
  }, [p, i, c, d, b, $, a, f, k, g, I, L, H, te, ae, ie, ne, fe, me, G, r]), S.useEffect(Q, [$, Q]);
  const De = S.useMemo(() => ({
    onKeyDown: H,
    ...E && {
      [aEt[P]]: (se) => {
        r.setOpen(!1, ji(hS, se.nativeEvent));
      },
      ...P !== "intentional" && {
        onClick(se) {
          r.setOpen(!1, ji(hS, se.nativeEvent));
        }
      }
    }
  }), [H, r, E, P]), Me = Ar((se) => {
    const Ae = tm(se.nativeEvent);
    !oo(r.select("floatingElement"), Ae) || se.button !== 0 || (j.current = !0);
  }), ze = Ar((se) => {
    !a || !g || se.button !== 0 || (j.current = !0);
  }), le = S.useMemo(() => ({
    onKeyDown: H,
    // `onMouseDown` may be blocked if `event.preventDefault()` is called in
    // `onPointerDown`, such as with <NumberField.ScrubArea>.
    // See https://github.com/mui/base-ui/pull/3379
    onPointerDown: Me,
    onMouseDown: Me,
    onMouseUp: Me,
    onClickCapture: X,
    onMouseDownCapture(se) {
      X(), ze(se);
    },
    onPointerDownCapture(se) {
      X(), ze(se);
    },
    onMouseUpCapture: X,
    onTouchEndCapture: X,
    onTouchMoveCapture: X
  }), [H, Me, X, ze]);
  return S.useMemo(() => g ? {
    reference: De,
    floating: le,
    trigger: De
  } : {}, [g, De, le]);
}
var iEt = (e, t, r) => {
  if (t.length === 1 && t[0] === r) {
    let a = !1;
    try {
      const i = {};
      e(i) === i && (a = !0);
    } catch {
    }
    if (a) {
      let i;
      try {
        throw new Error();
      } catch (c) {
        ({ stack: i } = c);
      }
      console.warn(
        `The result function returned its own inputs without modification. e.g
\`createSelector([state => state.todos], todos => todos)\`
This could lead to inefficient memoization and unnecessary re-renders.
Ensure transformation logic is in the result function, and extraction logic is in the input selectors.`,
        { stack: i }
      );
    }
  }
}, lEt = (e, t, r) => {
  const { memoize: a, memoizeOptions: i } = t, { inputSelectorResults: c, inputSelectorResultsCopy: d } = e, f = a(() => ({}), ...i);
  if (!(f.apply(null, c) === f.apply(null, d))) {
    let g;
    try {
      throw new Error();
    } catch (b) {
      ({ stack: g } = b);
    }
    console.warn(
      `An input selector returned a different result when passed same arguments.
This means your output selector will likely run more frequently than intended.
Avoid returning a new reference inside your input selector, e.g.
\`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)\``,
      {
        arguments: r,
        firstInputs: c,
        secondInputs: d,
        stack: g
      }
    );
  }
}, sEt = {
  inputStabilityCheck: "once",
  identityFunctionCheck: "once"
}, w9 = /* @__PURE__ */ Symbol("NOT_FOUND");
function uEt(e, t = `expected a function, instead received ${typeof e}`) {
  if (typeof e != "function")
    throw new TypeError(t);
}
function cEt(e, t = `expected an object, instead received ${typeof e}`) {
  if (typeof e != "object")
    throw new TypeError(t);
}
function dEt(e, t = "expected all items to be functions, instead received the following types: ") {
  if (!e.every((r) => typeof r == "function")) {
    const r = e.map(
      (a) => typeof a == "function" ? `function ${a.name || "unnamed"}()` : typeof a
    ).join(", ");
    throw new TypeError(`${t}[${r}]`);
  }
}
var yX = (e) => Array.isArray(e) ? e : [e];
function fEt(e) {
  const t = Array.isArray(e[0]) ? e[0] : e;
  return dEt(
    t,
    "createSelector expects all input-selectors to be functions, but received the following types: "
  ), t;
}
function wX(e, t) {
  const r = [], { length: a } = e;
  for (let i = 0; i < a; i++)
    r.push(e[i].apply(null, t));
  return r;
}
var mEt = (e, t) => {
  const { identityFunctionCheck: r, inputStabilityCheck: a } = {
    ...sEt,
    ...t
  };
  return {
    identityFunctionCheck: {
      shouldRun: r === "always" || r === "once" && e,
      run: iEt
    },
    inputStabilityCheck: {
      shouldRun: a === "always" || a === "once" && e,
      run: lEt
    }
  };
};
function hEt(e) {
  let t;
  return {
    get(r) {
      return t && e(t.key, r) ? t.value : w9;
    },
    put(r, a) {
      t = { key: r, value: a };
    },
    getEntries() {
      return t ? [t] : [];
    },
    clear() {
      t = void 0;
    }
  };
}
function pEt(e, t) {
  let r = [];
  function a(f) {
    const p = r.findIndex((g) => t(f, g.key));
    if (p > -1) {
      const g = r[p];
      return p > 0 && (r.splice(p, 1), r.unshift(g)), g.value;
    }
    return w9;
  }
  function i(f, p) {
    a(f) === w9 && (r.unshift({ key: f, value: p }), r.length > e && r.pop());
  }
  function c() {
    return r;
  }
  function d() {
    r = [];
  }
  return { get: a, put: i, getEntries: c, clear: d };
}
var gEt = (e, t) => e === t;
function vEt(e) {
  return function(r, a) {
    if (r === null || a === null || r.length !== a.length)
      return !1;
    const { length: i } = r;
    for (let c = 0; c < i; c++)
      if (!e(r[c], a[c]))
        return !1;
    return !0;
  };
}
function bEt(e, t) {
  const r = typeof t == "object" ? t : { equalityCheck: t }, {
    equalityCheck: a = gEt,
    maxSize: i = 1,
    resultEqualityCheck: c
  } = r, d = vEt(a);
  let f = 0;
  const p = i <= 1 ? hEt(d) : pEt(i, d);
  function g() {
    let b = p.get(arguments);
    if (b === w9) {
      if (b = e.apply(null, arguments), f++, c) {
        const x = p.getEntries().find(
          (E) => c(E.value, b)
        );
        x && (b = x.value, f !== 0 && f--);
      }
      p.put(arguments, b);
    }
    return b;
  }
  return g.clearCache = () => {
    p.clear(), g.resetResultsCount();
  }, g.resultsCount = () => f, g.resetResultsCount = () => {
    f = 0;
  }, g;
}
var yEt = class {
  constructor(e) {
    this.value = e;
  }
  deref() {
    return this.value;
  }
}, wEt = typeof WeakRef < "u" ? WeakRef : yEt, SEt = 0, SX = 1;
function $P() {
  return {
    s: SEt,
    v: void 0,
    o: null,
    p: null
  };
}
function moe(e, t = {}) {
  let r = $P();
  const { resultEqualityCheck: a } = t;
  let i, c = 0;
  function d() {
    let f = r;
    const { length: p } = arguments;
    for (let w = 0, x = p; w < x; w++) {
      const E = arguments[w];
      if (typeof E == "function" || typeof E == "object" && E !== null) {
        let P = f.o;
        P === null && (f.o = P = /* @__PURE__ */ new WeakMap());
        const k = P.get(E);
        k === void 0 ? (f = $P(), P.set(E, f)) : f = k;
      } else {
        let P = f.p;
        P === null && (f.p = P = /* @__PURE__ */ new Map());
        const k = P.get(E);
        k === void 0 ? (f = $P(), P.set(E, f)) : f = k;
      }
    }
    const g = f;
    let b;
    if (f.s === SX)
      b = f.v;
    else if (b = e.apply(null, arguments), c++, a) {
      const w = i?.deref?.() ?? i;
      w != null && a(w, b) && (b = w, c !== 0 && c--), i = typeof b == "object" && b !== null || typeof b == "function" ? new wEt(b) : b;
    }
    return g.s = SX, g.v = b, b;
  }
  return d.clearCache = () => {
    r = $P(), d.resetResultsCount();
  }, d.resultsCount = () => c, d.resetResultsCount = () => {
    c = 0;
  }, d;
}
function hoe(e, ...t) {
  const r = typeof e == "function" ? {
    memoize: e,
    memoizeOptions: t
  } : e, a = (...i) => {
    let c = 0, d = 0, f, p = {}, g = i.pop();
    typeof g == "object" && (p = g, g = i.pop()), uEt(
      g,
      `createSelector expects an output function after the inputs, but received: [${typeof g}]`
    );
    const b = {
      ...r,
      ...p
    }, {
      memoize: w,
      memoizeOptions: x = [],
      argsMemoize: E = moe,
      argsMemoizeOptions: P = [],
      devModeChecks: k = {}
    } = b, M = yX(x), T = yX(P), N = fEt(i), D = w(function() {
      return c++, g.apply(
        null,
        arguments
      );
    }, ...M);
    let $ = !0;
    const j = E(function() {
      d++;
      const L = wX(
        N,
        arguments
      );
      if (f = D.apply(null, L), process.env.NODE_ENV !== "production") {
        const { identityFunctionCheck: F, inputStabilityCheck: _ } = mEt($, k);
        if (F.shouldRun && F.run(
          g,
          L,
          f
        ), _.shouldRun) {
          const W = wX(
            N,
            arguments
          );
          _.run(
            { inputSelectorResults: L, inputSelectorResultsCopy: W },
            { memoize: w, memoizeOptions: M },
            arguments
          );
        }
        $ && ($ = !1);
      }
      return f;
    }, ...T);
    return Object.assign(j, {
      resultFunc: g,
      memoizedResultFunc: D,
      dependencies: N,
      dependencyRecomputations: () => d,
      resetDependencyRecomputations: () => {
        d = 0;
      },
      lastResult: () => f,
      recomputations: () => c,
      resetRecomputations: () => {
        c = 0;
      },
      memoize: w,
      argsMemoize: E
    });
  };
  return Object.assign(a, {
    withTypes: () => a
  }), a;
}
var CEt = /* @__PURE__ */ hoe(moe), xEt = Object.assign(
  (e, t = CEt) => {
    cEt(
      e,
      `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof e}`
    );
    const r = Object.keys(e), a = r.map(
      (c) => e[c]
    );
    return t(
      a,
      (...c) => c.reduce((d, f, p) => (d[r[p]] = f, d), {})
    );
  },
  { withTypes: () => xEt }
);
const EEt = hoe({
  memoize: bEt,
  memoizeOptions: {
    maxSize: 1,
    equalityCheck: Object.is
  }
}), ua = (e, t, r, a, i, c, ...d) => {
  if (d.length > 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Unsupported number of selectors" : ud(1));
  let f;
  if (e && t)
    f = (p, g, b, w) => {
      const x = e(p, g, b, w);
      return t(x, g, b, w);
    };
  else if (e)
    f = e;
  else
    throw (
      /* minify-error-disabled */
      new Error("Missing arguments")
    );
  return f;
}, PEt = (...e) => {
  const t = /* @__PURE__ */ new WeakMap();
  let r = 1;
  const a = e[e.length - 1], i = e.length - 1 || 1, c = a.length - i;
  if (c > 3)
    throw new Error(process.env.NODE_ENV !== "production" ? "Unsupported number of arguments" : ud(2));
  return (f, p, g, b) => {
    let w = f.__cacheKey__;
    w || (w = {
      id: r
    }, f.__cacheKey__ = w, r += 1);
    let x = t.get(w);
    if (!x) {
      let E = e;
      const P = [void 0, void 0, void 0];
      switch (c) {
        case 0:
          break;
        case 1: {
          E = [...e.slice(0, -1), () => P[0], a];
          break;
        }
        case 2: {
          E = [...e.slice(0, -1), () => P[0], () => P[1], a];
          break;
        }
        case 3: {
          E = [...e.slice(0, -1), () => P[0], () => P[1], () => P[2], a];
          break;
        }
        default:
          throw new Error(process.env.NODE_ENV !== "production" ? "Unsupported number of arguments" : ud(2));
      }
      x = EEt(...E), x.selectorArgs = P, t.set(w, x);
    }
    switch (x.selectorArgs[0] = p, x.selectorArgs[1] = g, x.selectorArgs[2] = b, c) {
      case 0:
        return x(f);
      case 1:
        return x(f, p);
      case 2:
        return x(f, p, g);
      case 3:
        return x(f, p, g, b);
      default:
        throw (
          /* minify-error-disabled */
          new Error("unreachable")
        );
    }
  };
};
var zP = { exports: {} }, aN = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var CX;
function kEt() {
  if (CX) return aN;
  CX = 1;
  var e = Re;
  function t(w, x) {
    return w === x && (w !== 0 || 1 / w === 1 / x) || w !== w && x !== x;
  }
  var r = typeof Object.is == "function" ? Object.is : t, a = e.useState, i = e.useEffect, c = e.useLayoutEffect, d = e.useDebugValue;
  function f(w, x) {
    var E = x(), P = a({ inst: { value: E, getSnapshot: x } }), k = P[0].inst, M = P[1];
    return c(
      function() {
        k.value = E, k.getSnapshot = x, p(k) && M({ inst: k });
      },
      [w, E, x]
    ), i(
      function() {
        return p(k) && M({ inst: k }), w(function() {
          p(k) && M({ inst: k });
        });
      },
      [w]
    ), d(E), E;
  }
  function p(w) {
    var x = w.getSnapshot;
    w = w.value;
    try {
      var E = x();
      return !r(w, E);
    } catch {
      return !0;
    }
  }
  function g(w, x) {
    return x();
  }
  var b = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? g : f;
  return aN.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : b, aN;
}
var oN = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xX;
function MEt() {
  return xX || (xX = 1, process.env.NODE_ENV !== "production" && (function() {
    function e(E, P) {
      return E === P && (E !== 0 || 1 / E === 1 / P) || E !== E && P !== P;
    }
    function t(E, P) {
      b || i.startTransition === void 0 || (b = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var k = P();
      if (!w) {
        var M = P();
        c(k, M) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), w = !0);
      }
      M = d({
        inst: { value: k, getSnapshot: P }
      });
      var T = M[0].inst, N = M[1];
      return p(
        function() {
          T.value = k, T.getSnapshot = P, r(T) && N({ inst: T });
        },
        [E, k, P]
      ), f(
        function() {
          return r(T) && N({ inst: T }), E(function() {
            r(T) && N({ inst: T });
          });
        },
        [E]
      ), g(k), k;
    }
    function r(E) {
      var P = E.getSnapshot;
      E = E.value;
      try {
        var k = P();
        return !c(E, k);
      } catch {
        return !0;
      }
    }
    function a(E, P) {
      return P();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var i = Re, c = typeof Object.is == "function" ? Object.is : e, d = i.useState, f = i.useEffect, p = i.useLayoutEffect, g = i.useDebugValue, b = !1, w = !1, x = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? a : t;
    oN.useSyncExternalStore = i.useSyncExternalStore !== void 0 ? i.useSyncExternalStore : x, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), oN;
}
var EX;
function gL() {
  return EX || (EX = 1, process.env.NODE_ENV === "production" ? zP.exports = kEt() : zP.exports = MEt()), zP.exports;
}
var poe = gL(), jP = { exports: {} }, iN = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var PX;
function OEt() {
  if (PX) return iN;
  PX = 1;
  var e = Re, t = gL();
  function r(g, b) {
    return g === b && (g !== 0 || 1 / g === 1 / b) || g !== g && b !== b;
  }
  var a = typeof Object.is == "function" ? Object.is : r, i = t.useSyncExternalStore, c = e.useRef, d = e.useEffect, f = e.useMemo, p = e.useDebugValue;
  return iN.useSyncExternalStoreWithSelector = function(g, b, w, x, E) {
    var P = c(null);
    if (P.current === null) {
      var k = { hasValue: !1, value: null };
      P.current = k;
    } else k = P.current;
    P = f(
      function() {
        function T(I) {
          if (!N) {
            if (N = !0, D = I, I = x(I), E !== void 0 && k.hasValue) {
              var L = k.value;
              if (E(L, I))
                return $ = L;
            }
            return $ = I;
          }
          if (L = $, a(D, I)) return L;
          var F = x(I);
          return E !== void 0 && E(L, F) ? (D = I, L) : (D = I, $ = F);
        }
        var N = !1, D, $, j = w === void 0 ? null : w;
        return [
          function() {
            return T(b());
          },
          j === null ? void 0 : function() {
            return T(j());
          }
        ];
      },
      [b, w, x, E]
    );
    var M = i(g, P[0], P[1]);
    return d(
      function() {
        k.hasValue = !0, k.value = M;
      },
      [M]
    ), p(M), M;
  }, iN;
}
var lN = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var kX;
function TEt() {
  return kX || (kX = 1, process.env.NODE_ENV !== "production" && (function() {
    function e(g, b) {
      return g === b && (g !== 0 || 1 / g === 1 / b) || g !== g && b !== b;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var t = Re, r = gL(), a = typeof Object.is == "function" ? Object.is : e, i = r.useSyncExternalStore, c = t.useRef, d = t.useEffect, f = t.useMemo, p = t.useDebugValue;
    lN.useSyncExternalStoreWithSelector = function(g, b, w, x, E) {
      var P = c(null);
      if (P.current === null) {
        var k = { hasValue: !1, value: null };
        P.current = k;
      } else k = P.current;
      P = f(
        function() {
          function T(I) {
            if (!N) {
              if (N = !0, D = I, I = x(I), E !== void 0 && k.hasValue) {
                var L = k.value;
                if (E(L, I))
                  return $ = L;
              }
              return $ = I;
            }
            if (L = $, a(D, I))
              return L;
            var F = x(I);
            return E !== void 0 && E(L, F) ? (D = I, L) : (D = I, $ = F);
          }
          var N = !1, D, $, j = w === void 0 ? null : w;
          return [
            function() {
              return T(b());
            },
            j === null ? void 0 : function() {
              return T(j());
            }
          ];
        },
        [b, w, x, E]
      );
      var M = i(g, P[0], P[1]);
      return d(
        function() {
          k.hasValue = !0, k.value = M;
        },
        [M]
      ), p(M), M;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), lN;
}
var MX;
function REt() {
  return MX || (MX = 1, process.env.NODE_ENV === "production" ? jP.exports = OEt() : jP.exports = TEt()), jP.exports;
}
var AEt = REt();
const oz = [];
let iz;
function NEt() {
  return iz;
}
function DEt(e) {
  oz.push(e);
}
function goe(e) {
  const t = (r, a) => {
    const i = am(zEt).current;
    let c;
    try {
      iz = i;
      for (const d of oz)
        d.before(i);
      c = e(r, a);
      for (const d of oz)
        d.after(i);
      i.didInitialize = !0;
    } finally {
      iz = void 0;
    }
    return c;
  };
  return t.displayName = e.displayName || e.name, t;
}
function $Et(e) {
  return /* @__PURE__ */ S.forwardRef(goe(e));
}
function zEt() {
  return {
    didInitialize: !1
  };
}
const jEt = rL(19), IEt = jEt ? HEt : FEt;
function voe(e, t, r, a, i) {
  return IEt(e, t, r, a, i);
}
function LEt(e, t, r, a, i) {
  const c = S.useCallback(() => t(e.getSnapshot(), r, a, i), [e, t, r, a, i]);
  return poe.useSyncExternalStore(e.subscribe, c, c);
}
DEt({
  before(e) {
    e.syncIndex = 0, e.didInitialize || (e.syncTick = 1, e.syncHooks = [], e.didChangeStore = !0, e.getSnapshot = () => {
      let t = !1;
      for (let r = 0; r < e.syncHooks.length; r += 1) {
        const a = e.syncHooks[r], i = a.selector(a.store.state, a.a1, a.a2, a.a3);
        (a.didChange || !Object.is(a.value, i)) && (t = !0, a.value = i, a.didChange = !1);
      }
      return t && (e.syncTick += 1), e.syncTick;
    });
  },
  after(e) {
    e.syncHooks.length > 0 && (e.didChangeStore && (e.didChangeStore = !1, e.subscribe = (t) => {
      const r = /* @__PURE__ */ new Set();
      for (const i of e.syncHooks)
        r.add(i.store);
      const a = [];
      for (const i of r)
        a.push(i.subscribe(t));
      return () => {
        for (const i of a)
          i();
      };
    }), poe.useSyncExternalStore(e.subscribe, e.getSnapshot, e.getSnapshot));
  }
});
function HEt(e, t, r, a, i) {
  const c = NEt();
  if (!c)
    return LEt(e, t, r, a, i);
  const d = c.syncIndex;
  c.syncIndex += 1;
  let f;
  return c.didInitialize ? (f = c.syncHooks[d], (f.store !== e || f.selector !== t || !Object.is(f.a1, r) || !Object.is(f.a2, a) || !Object.is(f.a3, i)) && (f.store !== e && (c.didChangeStore = !0), f.store = e, f.selector = t, f.a1 = r, f.a2 = a, f.a3 = i, f.didChange = !0)) : (f = {
    store: e,
    selector: t,
    a1: r,
    a2: a,
    a3: i,
    value: t(e.getSnapshot(), r, a, i),
    didChange: !1
  }, c.syncHooks.push(f)), f.value;
}
function FEt(e, t, r, a, i) {
  return AEt.useSyncExternalStoreWithSelector(e.subscribe, e.getSnapshot, e.getSnapshot, (c) => t(c, r, a, i));
}
class WEt {
  /**
   * The current state of the store.
   * This property is updated immediately when the state changes as a result of calling {@link setState}, {@link update}, or {@link set}.
   * To subscribe to state changes, use the {@link useState} method. The value returned by {@link useState} is updated after the component renders (similarly to React's useState).
   * The values can be used directly (to avoid subscribing to the store) in effects or event handlers.
   *
   * Do not modify properties in state directly. Instead, use the provided methods to ensure proper state management and listener notification.
   */
  // Internal state to handle recursive `setState()` calls
  constructor(t) {
    this.state = t, this.listeners = /* @__PURE__ */ new Set(), this.updateTick = 0;
  }
  /**
   * Registers a listener that will be called whenever the store's state changes.
   *
   * @param fn The listener function to be called on state changes.
   * @returns A function to unsubscribe the listener.
   */
  subscribe = (t) => (this.listeners.add(t), () => {
    this.listeners.delete(t);
  });
  /**
   * Returns the current state of the store.
   */
  getSnapshot = () => this.state;
  /**
   * Updates the entire store's state and notifies all registered listeners.
   *
   * @param newState The new state to set for the store.
   */
  setState(t) {
    if (this.state === t)
      return;
    this.state = t, this.updateTick += 1;
    const r = this.updateTick;
    for (const a of this.listeners) {
      if (r !== this.updateTick)
        return;
      a(t);
    }
  }
  /**
   * Merges the provided changes into the current state and notifies listeners if there are changes.
   *
   * @param changes An object containing the changes to apply to the current state.
   */
  update(t) {
    for (const r in t)
      if (!Object.is(this.state[r], t[r])) {
        this.setState({
          ...this.state,
          ...t
        });
        return;
      }
  }
  /**
   * Sets a specific key in the store's state to a new value and notifies listeners if the value has changed.
   *
   * @param key The key in the store's state to update.
   * @param value The new value to set for the specified key.
   */
  set(t, r) {
    Object.is(this.state[t], r) || this.setState({
      ...this.state,
      [t]: r
    });
  }
  /**
   * Gives the state a new reference and updates all registered listeners.
   */
  notifyAll() {
    const t = {
      ...this.state
    };
    this.setState(t);
  }
  use(t, r, a, i) {
    return voe(this, t, r, a, i);
  }
}
class nO extends WEt {
  /**
   * Creates a new ReactStore instance.
   *
   * @param state Initial state of the store.
   * @param context Non-reactive context values.
   * @param selectors Optional selectors for use with `useState`.
   */
  constructor(t, r = {}, a) {
    super(t), this.context = r, this.selectors = a;
  }
  /**
   * Non-reactive values such as refs, callbacks, etc.
   */
  /**
   * Synchronizes a single external value into the store.
   *
   * Note that the while the value in `state` is updated immediately, the value returned
   * by `useState` is updated before the next render (similarly to React's `useState`).
   */
  useSyncedValue(t, r) {
    S.useDebugValue(t), Dr(() => {
      this.state[t] !== r && this.set(t, r);
    }, [t, r]);
  }
  /**
   * Synchronizes a single external value into the store and
   * cleans it up (sets to `undefined`) on unmount.
   *
   * Note that the while the value in `state` is updated immediately, the value returned
   * by `useState` is updated before the next render (similarly to React's `useState`).
   */
  useSyncedValueWithCleanup(t, r) {
    const a = this;
    Dr(() => (a.state[t] !== r && a.set(t, r), () => {
      a.set(t, void 0);
    }), [a, t, r]);
  }
  /**
   * Synchronizes multiple external values into the store.
   *
   * Note that the while the values in `state` are updated immediately, the values returned
   * by `useState` are updated before the next render (similarly to React's `useState`).
   */
  useSyncedValues(t) {
    const r = this;
    if (process.env.NODE_ENV !== "production") {
      S.useDebugValue(t, (d) => Object.keys(d));
      const i = S.useRef(Object.keys(t)).current, c = Object.keys(t);
      (i.length !== c.length || i.some((d, f) => d !== c[f])) && console.error("ReactStore.useSyncedValues expects the same prop keys on every render. Keys should be stable.");
    }
    const a = Object.values(t);
    Dr(() => {
      r.update(t);
    }, [r, ...a]);
  }
  /**
   * Registers a controllable prop pair (`controlled`, `defaultValue`) for a specific key. If `controlled`
   * is non-undefined, the store's state at `key` is updated to match `controlled`.
   */
  useControlledProp(t, r) {
    S.useDebugValue(t);
    const a = r !== void 0;
    if (Dr(() => {
      a && !Object.is(this.state[t], r) && super.setState({
        ...this.state,
        [t]: r
      });
    }, [t, r, a]), process.env.NODE_ENV !== "production") {
      const i = this.controlledValues ??= /* @__PURE__ */ new Map();
      i.has(t) || i.set(t, a);
      const c = i.get(t);
      c !== void 0 && c !== a && console.error(`A component is changing the ${a ? "" : "un"}controlled state of ${t.toString()} to be ${a ? "un" : ""}controlled. Elements should not switch from uncontrolled to controlled (or vice versa).`);
    }
  }
  /** Gets the current value from the store using a selector with the provided key.
   *
   * @param key Key of the selector to use.
   */
  select(t, r, a, i) {
    const c = this.selectors[t];
    return c(this.state, r, a, i);
  }
  /**
   * Returns a value from the store's state using a selector function.
   * Used to subscribe to specific parts of the state.
   * This methods causes a rerender whenever the selected state changes.
   *
   * @param key Key of the selector to use.
   */
  useState(t, r, a, i) {
    return S.useDebugValue(t), voe(this, this.selectors[t], r, a, i);
  }
  /**
   * Wraps a function with `useStableCallback` to ensure it has a stable reference
   * and assigns it to the context.
   *
   * @param key Key of the event callback. Must be a function in the context.
   * @param fn Function to assign.
   */
  useContextCallback(t, r) {
    S.useDebugValue(t);
    const a = Ar(r ?? Mae);
    this.context[t] = a;
  }
  /**
   * Returns a stable setter function for a specific key in the store's state.
   * It's commonly used to pass as a ref callback to React elements.
   *
   * @param key Key of the state to set.
   */
  useStateSetter(t) {
    const r = S.useRef(void 0);
    return r.current === void 0 && (r.current = (a) => {
      this.set(t, a);
    }), r.current;
  }
  /**
   * Observes changes derived from the store's selectors and calls the listener when the selected value changes.
   *
   * @param key Key of the selector to observe.
   * @param listener Listener function called when the selector result changes.
   */
  observe(t, r) {
    let a;
    typeof t == "function" ? a = t : a = this.selectors[t];
    let i = a(this.state);
    return r(i, i, this), this.subscribe((c) => {
      const d = a(c);
      if (!Object.is(i, d)) {
        const f = i;
        i = d, r(d, f, this);
      }
    });
  }
}
function VEt() {
  const [, e] = S.useState({});
  return S.useCallback(() => {
    e({});
  }, []);
}
const _Et = {
  open: ua((e) => e.open),
  domReferenceElement: ua((e) => e.domReferenceElement),
  referenceElement: ua((e) => e.positionReference ?? e.referenceElement),
  floatingElement: ua((e) => e.floatingElement),
  floatingId: ua((e) => e.floatingId)
};
class vL extends nO {
  constructor(t) {
    const {
      nested: r,
      noEmit: a,
      onOpenChange: i,
      triggerElements: c,
      ...d
    } = t;
    super({
      ...d,
      positionReference: d.referenceElement,
      domReferenceElement: d.referenceElement
    }, {
      onOpenChange: i,
      dataRef: {
        current: {}
      },
      events: loe(),
      nested: r,
      noEmit: a,
      triggerElements: c
    }, _Et);
  }
  /**
   * Emits the `openchange` event through the internal event emitter and calls the `onOpenChange` handler with the provided arguments.
   *
   * @param newOpen The new open state.
   * @param eventDetails Details about the event that triggered the open state change.
   */
  setOpen = (t, r) => {
    if ((!t || !this.state.open || // Prevent a pending hover-open from overwriting a click-open event, while allowing
    // click events to upgrade a hover-open.
    Yae(r.event)) && (this.context.dataRef.current.openEvent = t ? r.event : void 0), !this.context.noEmit) {
      const a = {
        open: t,
        reason: r.reason,
        nativeEvent: r.event,
        nested: this.context.nested,
        triggerElement: r.trigger
      };
      this.context.events.emit("openchange", a);
    }
    this.context.onOpenChange?.(t, r);
  };
}
function BEt(e, t) {
  const r = S.useRef(null), a = S.useRef(null);
  return S.useCallback((i) => {
    if (e !== void 0) {
      if (r.current !== null) {
        const c = r.current, d = a.current, f = t.context.triggerElements.getById(c);
        d && f === d && t.context.triggerElements.delete(c), r.current = null, a.current = null;
      }
      i !== null && (r.current = e, a.current = i, t.context.triggerElements.add(e, i));
    }
  }, [t, e]);
}
function boe(e, t, r, a) {
  const i = r.useState("isMountedByTrigger", e), c = BEt(e, r), d = Ar((f) => {
    if (c(f), !f || !r.select("open"))
      return;
    const p = r.select("activeTriggerId");
    if (p === e) {
      r.update({
        activeTriggerElement: f,
        ...a
      });
      return;
    }
    p == null && r.update({
      activeTriggerId: e,
      activeTriggerElement: f,
      ...a
    });
  });
  return Dr(() => {
    i && r.update({
      activeTriggerElement: t.current,
      ...a
    });
  }, [i, r, t, ...Object.values(a)]), {
    registerTrigger: d,
    isMountedByThisTrigger: i
  };
}
function yoe(e) {
  const t = e.useState("open");
  Dr(() => {
    if (t && !e.select("activeTriggerId") && e.context.triggerElements.size === 1) {
      const r = e.context.triggerElements.entries().next();
      if (!r.done) {
        const [a, i] = r.value;
        e.update({
          activeTriggerId: a,
          activeTriggerElement: i
        });
      }
    }
  }, [t, e]);
}
function woe(e, t, r) {
  const {
    mounted: a,
    setMounted: i,
    transitionStatus: c
  } = oL(e);
  t.useSyncedValues({
    mounted: a,
    transitionStatus: c
  });
  const d = Ar(() => {
    i(!1), t.update({
      activeTriggerId: null,
      activeTriggerElement: null,
      mounted: !1
    }), r?.(), t.context.onOpenChangeComplete?.(!1);
  }), f = t.useState("preventUnmountingOnClose");
  return l6({
    enabled: !f,
    open: e,
    ref: t.context.popupRef,
    onComplete() {
      e || d();
    }
  }), {
    forceUnmount: d,
    transitionStatus: c
  };
}
class rO {
  constructor() {
    this.elementsSet = /* @__PURE__ */ new Set(), this.idMap = /* @__PURE__ */ new Map();
  }
  /**
   * Adds a trigger element with the given ID.
   *
   * Note: The provided element is assumed to not be registered under multiple IDs.
   */
  add(t, r) {
    const a = this.idMap.get(t);
    if (a !== r && (a !== void 0 && this.elementsSet.delete(a), this.elementsSet.add(r), this.idMap.set(t, r), process.env.NODE_ENV !== "production" && this.elementsSet.size !== this.idMap.size))
      throw new Error("Base UI: A trigger element cannot be registered under multiple IDs in PopupTriggerMap.");
  }
  /**
   * Removes the trigger element with the given ID.
   */
  delete(t) {
    const r = this.idMap.get(t);
    r && (this.elementsSet.delete(r), this.idMap.delete(t));
  }
  /**
   * Whether the given element is registered as a trigger.
   */
  hasElement(t) {
    return this.elementsSet.has(t);
  }
  /**
   * Whether there is a registered trigger element matching the given predicate.
   */
  hasMatchingElement(t) {
    for (const r of this.elementsSet)
      if (t(r))
        return !0;
    return !1;
  }
  /**
   * Returns the trigger element associated with the given ID, or undefined if no such element exists.
   */
  getById(t) {
    return this.idMap.get(t);
  }
  /**
   * Returns an iterable of all registered trigger entries, where each entry is a tuple of [id, element].
   */
  entries() {
    return this.idMap.entries();
  }
  /**
   * Returns an iterable of all registered trigger elements.
   */
  elements() {
    return this.elementsSet.values();
  }
  /**
   * Returns the number of registered trigger elements.
   */
  get size() {
    return this.idMap.size;
  }
}
function UEt() {
  return new vL({
    open: !1,
    floatingElement: null,
    referenceElement: null,
    triggerElements: new rO(),
    floatingId: "",
    nested: !1,
    noEmit: !1,
    onOpenChange: void 0
  });
}
function Soe() {
  return {
    open: !1,
    openProp: void 0,
    mounted: !1,
    transitionStatus: "idle",
    floatingRootContext: UEt(),
    preventUnmountingOnClose: !1,
    payload: void 0,
    activeTriggerId: null,
    activeTriggerElement: null,
    triggerIdProp: void 0,
    popupElement: null,
    positionerElement: null,
    activeTriggerProps: Gh,
    inactiveTriggerProps: Gh,
    popupProps: Gh
  };
}
const IP = ua((e) => e.triggerIdProp ?? e.activeTriggerId), Coe = {
  open: ua((e) => e.openProp ?? e.open),
  mounted: ua((e) => e.mounted),
  transitionStatus: ua((e) => e.transitionStatus),
  floatingRootContext: ua((e) => e.floatingRootContext),
  preventUnmountingOnClose: ua((e) => e.preventUnmountingOnClose),
  payload: ua((e) => e.payload),
  activeTriggerId: IP,
  activeTriggerElement: ua((e) => e.mounted ? e.activeTriggerElement : null),
  /**
   * Whether the trigger with the given ID was used to open the popup.
   */
  isTriggerActive: ua((e, t) => t !== void 0 && IP(e) === t),
  /**
   * Whether the popup is open and was activated by a trigger with the given ID.
   */
  isOpenedByTrigger: ua((e, t) => t !== void 0 && IP(e) === t && e.open),
  /**
   * Whether the popup is mounted and was activated by a trigger with the given ID.
   */
  isMountedByTrigger: ua((e, t) => t !== void 0 && IP(e) === t && e.mounted),
  triggerProps: ua((e, t) => t ? e.activeTriggerProps : e.inactiveTriggerProps),
  popupProps: ua((e) => e.popupProps),
  popupElement: ua((e) => e.popupElement),
  positionerElement: ua((e) => e.positionerElement)
};
function XEt(e) {
  const {
    open: t = !1,
    onOpenChange: r,
    elements: a = {}
  } = e, i = w3(), c = C3() != null;
  if (process.env.NODE_ENV !== "production") {
    const f = a.reference;
    f && !di(f) && console.error("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `context.setPositionReference()`", "instead.");
  }
  const d = am(() => new vL({
    open: t,
    onOpenChange: r,
    referenceElement: a.reference ?? null,
    floatingElement: a.floating ?? null,
    triggerElements: new rO(),
    floatingId: i,
    nested: c,
    noEmit: !1
  })).current;
  return Dr(() => {
    const f = {
      open: t,
      floatingId: i
    };
    a.reference !== void 0 && (f.referenceElement = a.reference, f.domReferenceElement = di(a.reference) ? a.reference : null), a.floating !== void 0 && (f.floatingElement = a.floating), d.update(f);
  }, [t, i, a.reference, a.floating, d]), d.context.onOpenChange = r, d.context.nested = c, d.context.noEmit = !1, d;
}
function GEt(e = {}) {
  const {
    nodeId: t,
    externalTree: r
  } = e, a = XEt(e), i = e.rootContext || a, c = {
    reference: i.useState("referenceElement"),
    floating: i.useState("floatingElement"),
    domReference: i.useState("domReferenceElement")
  }, [d, f] = S.useState(null), p = S.useRef(null), g = c6(r);
  Dr(() => {
    c.domReference && (p.current = c.domReference);
  }, [c.domReference]);
  const b = nne({
    ...e,
    elements: {
      ...c,
      ...d && {
        reference: d
      }
    }
  }), w = S.useCallback((L) => {
    const F = di(L) ? {
      getBoundingClientRect: () => L.getBoundingClientRect(),
      getClientRects: () => L.getClientRects(),
      contextElement: L
    } : L;
    f(F), b.refs.setReference(F);
  }, [b.refs]), [x, E] = S.useState(null), [P, k] = S.useState(null);
  i.useSyncedValue("referenceElement", x), i.useSyncedValue("domReferenceElement", di(x) ? x : null), i.useSyncedValue("floatingElement", P);
  const M = S.useCallback((L) => {
    (di(L) || L === null) && (p.current = L, E(L)), (di(b.refs.reference.current) || b.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    L !== null && !di(L)) && b.refs.setReference(L);
  }, [b.refs, E]), T = S.useCallback((L) => {
    k(L), b.refs.setFloating(L);
  }, [b.refs]), N = S.useMemo(() => ({
    ...b.refs,
    setReference: M,
    setFloating: T,
    setPositionReference: w,
    domReference: p
  }), [b.refs, M, T, w]), D = S.useMemo(() => ({
    ...b.elements,
    domReference: c.domReference
  }), [b.elements, c.domReference]), $ = i.useState("open"), j = i.useState("floatingId"), I = S.useMemo(() => ({
    ...b,
    dataRef: i.context.dataRef,
    open: $,
    onOpenChange: i.setOpen,
    events: i.context.events,
    floatingId: j,
    refs: N,
    elements: D,
    nodeId: t,
    rootStore: i
  }), [b, N, D, t, i, $, j]);
  return Dr(() => {
    i.context.dataRef.current.floatingContext = I;
    const L = g?.nodesRef.current.find((F) => F.id === t);
    L && (L.context = I);
  }), S.useMemo(() => ({
    ...b,
    context: I,
    refs: N,
    elements: D,
    rootStore: i
  }), [b, N, D, I, i]);
}
function xoe(e) {
  const {
    popupStore: t,
    noEmit: r = !1,
    treatPopupAsFloatingElement: a = !1,
    onOpenChange: i
  } = e, c = w3(), d = C3() != null, f = t.useState("open"), p = t.useState("activeTriggerElement"), g = t.useState(a ? "popupElement" : "positionerElement"), b = t.context.triggerElements, w = am(() => new vL({
    open: f,
    referenceElement: p,
    floatingElement: g,
    triggerElements: b,
    onOpenChange: i,
    floatingId: c,
    nested: d,
    noEmit: r
  })).current;
  return Dr(() => {
    const x = {
      open: f,
      floatingId: c,
      referenceElement: p,
      floatingElement: g
    };
    di(p) && (x.domReferenceElement = p), w.state.positionReference === w.state.referenceElement && (x.positionReference = p), w.update(x);
  }, [f, c, p, g, w]), w.context.onOpenChange = i, w.context.nested = d, w.context.noEmit = r, w;
}
const sN = Q8t && Bae;
function qEt(e, t = {}) {
  const r = "rootStore" in e ? e.rootStore : e, {
    events: a,
    dataRef: i
  } = r.context, {
    enabled: c = !0,
    delay: d
  } = t, f = S.useRef(!1), p = S.useRef(null), g = JS(), b = S.useRef(!0);
  S.useEffect(() => {
    const x = r.select("domReferenceElement");
    if (!c)
      return;
    const E = lu(x);
    function P() {
      const T = r.select("domReferenceElement");
      !r.select("open") && Os(T) && T === ap(Qo(T)) && (f.current = !0);
    }
    function k() {
      b.current = !0;
    }
    function M() {
      b.current = !1;
    }
    return E.addEventListener("blur", P), sN && (E.addEventListener("keydown", k, !0), E.addEventListener("pointerdown", M, !0)), () => {
      E.removeEventListener("blur", P), sN && (E.removeEventListener("keydown", k, !0), E.removeEventListener("pointerdown", M, !0));
    };
  }, [r, c]), S.useEffect(() => {
    if (!c)
      return;
    function x(E) {
      if (E.reason === hS || E.reason === ZM) {
        const P = r.select("domReferenceElement");
        di(P) && (p.current = P, f.current = !0);
      }
    }
    return a.on("openchange", x), () => {
      a.off("openchange", x);
    };
  }, [a, c, r]);
  const w = S.useMemo(() => ({
    onMouseLeave() {
      f.current = !1, p.current = null;
    },
    onFocus(x) {
      const E = x.currentTarget;
      if (f.current) {
        if (p.current === E)
          return;
        f.current = !1, p.current = null;
      }
      const P = tm(x.nativeEvent);
      if (di(P)) {
        if (sN && !x.relatedTarget) {
          if (!b.current && !tO(P))
            return;
        } else if (!p9(P))
          return;
      }
      const k = h9(x.relatedTarget, r.context.triggerElements), {
        nativeEvent: M,
        currentTarget: T
      } = x, N = typeof d == "function" ? d() : d;
      if (r.select("open") && k || N === 0 || N === void 0) {
        r.setOpen(!0, ji(Ok, M, T));
        return;
      }
      g.start(N, () => {
        f.current || r.setOpen(!0, ji(Ok, M, T));
      });
    },
    onBlur(x) {
      f.current = !1, p.current = null;
      const E = x.relatedTarget, P = x.nativeEvent, k = di(E) && E.hasAttribute(jx("focus-guard")) && E.getAttribute("data-type") === "outside";
      g.start(0, () => {
        const M = r.select("domReferenceElement"), T = ap(M ? M.ownerDocument : document);
        !E && T === M || oo(i.current.floatingContext?.refs.floating.current, T) || oo(M, T) || k || h9(E ?? T, r.context.triggerElements) || r.setOpen(!1, ji(Ok, P));
      });
    }
  }), [i, r, g, d]);
  return S.useMemo(() => c ? {
    reference: w,
    trigger: w
  } : {}, [c, w]);
}
const lz = jx("safe-polygon"), KEt = `button,a,[role="button"],select,[tabindex]:not([tabindex="-1"]),${Kae}`;
function YEt(e) {
  return e ? !!e.closest(KEt) : !1;
}
class bL {
  constructor() {
    this.pointerType = void 0, this.interactedInside = !1, this.handler = void 0, this.blockMouseMove = !0, this.performedPointerEventsMutation = !1, this.unbindMouseMove = () => {
    }, this.restTimeoutPending = !1, this.openChangeTimeout = new $0(), this.restTimeout = new $0(), this.handleCloseOptions = void 0;
  }
  static create() {
    return new bL();
  }
  dispose = () => {
    this.openChangeTimeout.clear(), this.restTimeout.clear();
  };
  disposeEffect = () => this.dispose;
}
function Eoe(e) {
  const t = am(bL.create).current, r = e.context.dataRef.current;
  return r.hoverInteractionState || (r.hoverInteractionState = t), S3(r.hoverInteractionState.disposeEffect), r.hoverInteractionState;
}
const QEt = /* @__PURE__ */ new Set(["click", "mousedown"]);
function Poe(e, t = {}) {
  const r = "rootStore" in e ? e.rootStore : e, a = r.useState("open"), i = r.useState("floatingElement"), c = r.useState("domReferenceElement"), {
    dataRef: d
  } = r.context, {
    enabled: f = !0,
    closeDelay: p = 0
  } = t, g = Eoe(r), b = c6(), w = C3(), x = Ar(() => g.interactedInside ? !0 : d.current.openEvent ? QEt.has(d.current.openEvent.type) : !1), E = Ar(() => {
    const D = d.current.openEvent?.type;
    return D?.includes("mouse") && D !== "mousedown";
  }), P = Ar((D) => h9(D, r.context.triggerElements)), k = S.useCallback((D, $ = !0) => {
    const j = JEt(p, g.pointerType);
    j && !g.handler ? g.openChangeTimeout.start(j, () => r.setOpen(!1, ji(Xh, D))) : $ && (g.openChangeTimeout.clear(), r.setOpen(!1, ji(Xh, D)));
  }, [p, r, g]), M = Ar(() => {
    g.unbindMouseMove(), g.handler = void 0;
  }), T = Ar(() => {
    if (g.performedPointerEventsMutation) {
      const D = Qo(i).body;
      D.style.pointerEvents = "", D.removeAttribute(lz), g.performedPointerEventsMutation = !1;
    }
  }), N = Ar((D) => {
    const $ = tm(D);
    if (!YEt($)) {
      g.interactedInside = !1;
      return;
    }
    g.interactedInside = !0;
  });
  Dr(() => {
    a || (g.pointerType = void 0, g.restTimeoutPending = !1, g.interactedInside = !1, M(), T());
  }, [a, g, M, T]), S.useEffect(() => () => {
    M();
  }, [M]), S.useEffect(() => T, [T]), Dr(() => {
    if (f && a && g.handleCloseOptions?.blockPointerEvents && E() && di(c) && i) {
      g.performedPointerEventsMutation = !0;
      const D = Qo(i).body;
      D.setAttribute(lz, "");
      const $ = c, j = i, I = b?.nodesRef.current.find((L) => L.id === w)?.context?.elements.floating;
      return I && (I.style.pointerEvents = ""), D.style.pointerEvents = "none", $.style.pointerEvents = "auto", j.style.pointerEvents = "auto", () => {
        D.style.pointerEvents = "", $.style.pointerEvents = "", j.style.pointerEvents = "";
      };
    }
  }, [f, a, c, i, g, E, b, w]), S.useEffect(() => {
    if (!f)
      return;
    function D(L) {
      x() || !d.current.floatingContext || !r.select("open") || P(L.relatedTarget) || (T(), M(), x() || k(L));
    }
    function $(L) {
      g.openChangeTimeout.clear(), T(), g.handler?.(L), M();
    }
    function j(L) {
      x() || k(L, !1);
    }
    const I = i;
    return I && (I.addEventListener("mouseleave", D), I.addEventListener("mouseenter", $), I.addEventListener("mouseleave", j), I.addEventListener("pointerdown", N, !0)), () => {
      I && (I.removeEventListener("mouseleave", D), I.removeEventListener("mouseenter", $), I.removeEventListener("mouseleave", j), I.removeEventListener("pointerdown", N, !0));
    };
  }, [f, i, r, d, x, P, k, T, M, N, g]);
}
function JEt(e, t) {
  return t && !u3(t) ? 0 : typeof e == "function" ? e() : e;
}
function uN(e) {
  return typeof e == "function" ? e() : e;
}
const ZEt = {
  current: null
};
function koe(e, t = {}) {
  const r = "rootStore" in e ? e.rootStore : e, {
    dataRef: a,
    events: i
  } = r.context, {
    enabled: c = !0,
    delay: d = 0,
    handleClose: f = null,
    mouseOnly: p = !1,
    restMs: g = 0,
    move: b = !0,
    triggerElementRef: w = ZEt,
    externalTree: x,
    isActiveTrigger: E = !0
  } = t, P = c6(x), k = Eoe(r), M = ub(f), T = ub(d), N = ub(g), D = ub(c);
  E && (k.handleCloseOptions = M.current?.__options);
  const $ = Ar(() => k.interactedInside ? !0 : a.current.openEvent ? ["click", "mousedown"].includes(a.current.openEvent.type) : !1), j = Ar((W) => h9(W, r.context.triggerElements)), I = S.useCallback((W, Q = !0) => {
    const U = Rk(T.current, "close", k.pointerType);
    U && !k.handler ? k.openChangeTimeout.start(U, () => r.setOpen(!1, ji(Xh, W))) : Q && (k.openChangeTimeout.clear(), r.setOpen(!1, ji(Xh, W)));
  }, [T, r, k]), L = Ar(() => {
    k.unbindMouseMove(), k.handler = void 0;
  }), F = Ar(() => {
    if (k.performedPointerEventsMutation) {
      const W = Qo(r.select("domReferenceElement")).body;
      W.style.pointerEvents = "", W.removeAttribute(lz), k.performedPointerEventsMutation = !1;
    }
  });
  S.useEffect(() => {
    if (!c)
      return;
    function W(Q) {
      Q.open || (k.openChangeTimeout.clear(), k.restTimeout.clear(), k.blockMouseMove = !0, k.restTimeoutPending = !1);
    }
    return i.on("openchange", W), () => {
      i.off("openchange", W);
    };
  }, [c, i, k]);
  const _ = Ar((W) => {
    if ($() || !a.current.floatingContext || j(W.relatedTarget))
      return;
    const Q = w.current;
    M.current?.({
      ...a.current.floatingContext,
      tree: P,
      x: W.clientX,
      y: W.clientY,
      onClose() {
        F(), L(), !$() && Q === r.select("domReferenceElement") && I(W);
      }
    })(W);
  });
  return S.useEffect(() => {
    if (!c)
      return;
    const W = w.current ?? (E ? r.select("domReferenceElement") : null);
    if (!di(W))
      return;
    function Q(G) {
      if (k.openChangeTimeout.clear(), k.blockMouseMove = !1, p && !u3(k.pointerType) || uN(N.current) > 0 && !Rk(T.current, "open"))
        return;
      const J = Rk(T.current, "open", k.pointerType), H = r.select("domReferenceElement"), K = r.context.triggerElements, X = (K.hasElement(G.target) || K.hasMatchingElement((ne) => oo(ne, G.target))) && (!H || !oo(H, G.target)), te = G.currentTarget ?? null, ie = r.select("open"), ee = !ie || X;
      X && ie ? r.setOpen(!0, ji(Xh, G, te)) : J ? k.openChangeTimeout.start(J, () => {
        ee && r.setOpen(!0, ji(Xh, G, te));
      }) : ee && r.setOpen(!0, ji(Xh, G, te));
    }
    function U(G) {
      if ($()) {
        F();
        return;
      }
      k.unbindMouseMove();
      const J = r.select("domReferenceElement"), H = Qo(J);
      if (k.restTimeout.clear(), k.restTimeoutPending = !1, j(G.relatedTarget))
        return;
      if (M.current && a.current.floatingContext) {
        r.select("open") || k.openChangeTimeout.clear();
        const X = w.current;
        k.handler = M.current({
          ...a.current.floatingContext,
          tree: P,
          x: G.clientX,
          y: G.clientY,
          onClose() {
            F(), L(), D.current && !$() && X === r.select("domReferenceElement") && I(G, !0);
          }
        });
        const te = k.handler;
        te(G), H.addEventListener("mousemove", te), k.unbindMouseMove = () => {
          H.removeEventListener("mousemove", te);
        };
        return;
      }
      (k.pointerType === "touch" ? !oo(r.select("floatingElement"), G.relatedTarget) : !0) && I(G);
    }
    function Y(G) {
      _(G);
    }
    return r.select("open") && W.addEventListener("mouseleave", Y), b && W.addEventListener("mousemove", Q, {
      once: !0
    }), W.addEventListener("mouseenter", Q), W.addEventListener("mouseleave", U), () => {
      W.removeEventListener("mouseleave", Y), b && W.removeEventListener("mousemove", Q), W.removeEventListener("mouseenter", Q), W.removeEventListener("mouseleave", U);
    };
  }, [L, F, a, T, I, r, c, M, _, k, E, $, j, p, b, N, w, P, D]), S.useMemo(() => {
    if (!c)
      return;
    function W(Q) {
      k.pointerType = Q.pointerType;
    }
    return {
      onPointerDown: W,
      onPointerEnter: W,
      onMouseMove(Q) {
        const {
          nativeEvent: U
        } = Q, Y = Q.currentTarget, G = r.select("domReferenceElement"), J = r.context.triggerElements, H = r.select("open"), K = (J.hasElement(Q.target) || J.hasMatchingElement((te) => oo(te, Q.target))) && (!G || !oo(G, Q.target));
        if (p && !u3(k.pointerType) || H && !K || uN(N.current) === 0 || !K && k.restTimeoutPending && Q.movementX ** 2 + Q.movementY ** 2 < 2)
          return;
        k.restTimeout.clear();
        function X() {
          if (k.restTimeoutPending = !1, $())
            return;
          const te = r.select("open");
          !k.blockMouseMove && (!te || K) && r.setOpen(!0, ji(Xh, U, Y));
        }
        k.pointerType === "touch" ? sp.flushSync(() => {
          X();
        }) : K && H ? X() : (k.restTimeoutPending = !0, k.restTimeout.start(uN(N.current), X));
      }
    };
  }, [c, k, $, p, r, N]);
}
function yL(e = []) {
  const t = e.map((g) => g?.reference), r = e.map((g) => g?.floating), a = e.map((g) => g?.item), i = e.map((g) => g?.trigger), c = S.useCallback(
    (g) => LP(g, e, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), d = S.useCallback(
    (g) => LP(g, e, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    r
  ), f = S.useCallback(
    (g) => LP(g, e, "item"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    a
  ), p = S.useCallback(
    (g) => LP(g, e, "trigger"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    i
  );
  return S.useMemo(() => ({
    getReferenceProps: c,
    getFloatingProps: d,
    getItemProps: f,
    getTriggerProps: p
  }), [c, d, f, p]);
}
function LP(e, t, r) {
  const a = /* @__PURE__ */ new Map(), i = r === "item", c = {};
  r === "floating" && (c.tabIndex = -1, c[tz] = "");
  for (const d in e)
    i && e && (d === Gae || d === qae) || (c[d] = e[d]);
  for (let d = 0; d < t.length; d += 1) {
    let f;
    const p = t[d]?.[r];
    typeof p == "function" ? f = e ? p(e) : null : f = p, f && OX(c, f, i, a);
  }
  return OX(c, e, i, a), c;
}
function OX(e, t, r, a) {
  for (const i in t) {
    const c = t[i];
    r && (i === Gae || i === qae) || (i.startsWith("on") ? (a.has(i) || a.set(i, []), typeof c == "function" && (a.get(i)?.push(c), e[i] = (...d) => a.get(i)?.map((f) => f(...d)).find((f) => f !== void 0))) : e[i] = c);
  }
}
const e7t = /* @__PURE__ */ new Map([["select", "listbox"], ["combobox", "listbox"], ["label", !1]]);
function t7t(e, t = {}) {
  const r = "rootStore" in e ? e.rootStore : e, a = r.useState("open"), i = r.useState("floatingId"), c = r.useState("domReferenceElement"), d = r.useState("floatingElement"), {
    role: f = "dialog"
  } = t, p = w3(), g = c?.id || p, b = S.useMemo(() => nz(d)?.id || i, [d, i]), w = e7t.get(f) ?? f, E = C3() != null, P = S.useMemo(() => w === "tooltip" || f === "label" ? Gh : {
    "aria-haspopup": w === "alertdialog" ? "dialog" : w,
    "aria-expanded": "false",
    ...w === "listbox" && {
      role: "combobox"
    },
    ...w === "menu" && E && {
      role: "menuitem"
    },
    ...f === "select" && {
      "aria-autocomplete": "none"
    },
    ...f === "combobox" && {
      "aria-autocomplete": "list"
    }
  }, [w, E, f]), k = S.useMemo(() => w === "tooltip" || f === "label" ? {
    [`aria-${f === "label" ? "labelledby" : "describedby"}`]: a ? b : void 0
  } : {
    ...P,
    "aria-expanded": a ? "true" : "false",
    "aria-controls": a ? b : void 0,
    ...w === "menu" && {
      id: g
    }
  }, [w, b, a, g, f, P]), M = S.useMemo(() => {
    const N = {
      id: b,
      ...w && {
        role: w
      }
    };
    return w === "tooltip" || f === "label" ? N : {
      ...N,
      ...w === "menu" && {
        "aria-labelledby": g
      }
    };
  }, [w, b, g, f]), T = S.useCallback(({
    active: N,
    selected: D
  }) => {
    const $ = {
      role: "option",
      ...N && {
        id: `${b}-fui-option`
      }
    };
    switch (f) {
      case "select":
      case "combobox":
        return {
          ...$,
          "aria-selected": D
        };
    }
    return {};
  }, [b, f]);
  return S.useMemo(() => ({
    reference: k,
    floating: M,
    item: T,
    trigger: P
  }), [k, M, P, T]);
}
function TX(e, t) {
  const [r, a] = e;
  let i = !1;
  const c = t.length;
  for (let d = 0, f = c - 1; d < c; f = d++) {
    const [p, g] = t[d] || [0, 0], [b, w] = t[f] || [0, 0];
    g >= a != w >= a && r <= (b - p) * (a - g) / (w - g) + p && (i = !i);
  }
  return i;
}
function n7t(e, t) {
  return e[0] >= t.x && e[0] <= t.x + t.width && e[1] >= t.y && e[1] <= t.y + t.height;
}
function Moe(e = {}) {
  const {
    buffer: t = 0.5,
    blockPointerEvents: r = !1,
    requireIntent: a = !0
  } = e, i = new $0();
  let c = !1, d = null, f = null, p = typeof performance < "u" ? performance.now() : 0;
  function g(w, x) {
    const E = performance.now(), P = E - p;
    if (d === null || f === null || P === 0)
      return d = w, f = x, p = E, null;
    const k = w - d, M = x - f, N = Math.sqrt(k * k + M * M) / P;
    return d = w, f = x, p = E, N;
  }
  const b = ({
    x: w,
    y: x,
    placement: E,
    elements: P,
    onClose: k,
    nodeId: M,
    tree: T
  }) => function(D) {
    function $() {
      i.clear(), k();
    }
    if (i.clear(), !P.domReference || !P.floating || E == null || w == null || x == null)
      return;
    const {
      clientX: j,
      clientY: I
    } = D, L = [j, I], F = tm(D), _ = D.type === "mouseleave", W = oo(P.floating, F), Q = oo(P.domReference, F), U = P.domReference.getBoundingClientRect(), Y = P.floating.getBoundingClientRect(), G = E.split("-")[0], J = w > Y.right - Y.width / 2, H = x > Y.bottom - Y.height / 2, K = n7t(L, U), X = Y.width > U.width, te = Y.height > U.height, ie = (X ? U : Y).left, ee = (X ? U : Y).right, ne = (te ? U : Y).top, ae = (te ? U : Y).bottom;
    if (W && (c = !0, !_))
      return;
    if (Q && (c = !1), Q && !_) {
      c = !0;
      return;
    }
    if (_ && di(D.relatedTarget) && oo(P.floating, D.relatedTarget) || T && Y4(T.nodesRef.current, M).some(({
      context: be
    }) => be?.open))
      return;
    if (G === "top" && x >= U.bottom - 1 || G === "bottom" && x <= U.top + 1 || G === "left" && w >= U.right - 1 || G === "right" && w <= U.left + 1)
      return $();
    let oe = [];
    switch (G) {
      case "top":
        oe = [[ie, U.top + 1], [ie, Y.bottom - 1], [ee, Y.bottom - 1], [ee, U.top + 1]];
        break;
      case "bottom":
        oe = [[ie, Y.top + 1], [ie, U.bottom - 1], [ee, U.bottom - 1], [ee, Y.top + 1]];
        break;
      case "left":
        oe = [[Y.right - 1, ae], [Y.right - 1, ne], [U.left + 1, ne], [U.left + 1, ae]];
        break;
      case "right":
        oe = [[U.right - 1, ae], [U.right - 1, ne], [Y.left + 1, ne], [Y.left + 1, ae]];
        break;
    }
    function fe([be, me]) {
      switch (G) {
        case "top": {
          const De = [X ? be + t / 2 : J ? be + t * 4 : be - t * 4, me + t + 1], Me = [X ? be - t / 2 : J ? be + t * 4 : be - t * 4, me + t + 1], ze = [[Y.left, J || X ? Y.bottom - t : Y.top], [Y.right, J ? X ? Y.bottom - t : Y.top : Y.bottom - t]];
          return [De, Me, ...ze];
        }
        case "bottom": {
          const De = [X ? be + t / 2 : J ? be + t * 4 : be - t * 4, me - t], Me = [X ? be - t / 2 : J ? be + t * 4 : be - t * 4, me - t], ze = [[Y.left, J || X ? Y.top + t : Y.bottom], [Y.right, J ? X ? Y.top + t : Y.bottom : Y.top + t]];
          return [De, Me, ...ze];
        }
        case "left": {
          const De = [be + t + 1, te ? me + t / 2 : H ? me + t * 4 : me - t * 4], Me = [be + t + 1, te ? me - t / 2 : H ? me + t * 4 : me - t * 4];
          return [...[[H || te ? Y.right - t : Y.left, Y.top], [H ? te ? Y.right - t : Y.left : Y.right - t, Y.bottom]], De, Me];
        }
        case "right": {
          const De = [be - t, te ? me + t / 2 : H ? me + t * 4 : me - t * 4], Me = [be - t, te ? me - t / 2 : H ? me + t * 4 : me - t * 4], ze = [[H || te ? Y.left + t : Y.right, Y.top], [H ? te ? Y.left + t : Y.right : Y.left + t, Y.bottom]];
          return [De, Me, ...ze];
        }
        default:
          return [];
      }
    }
    if (!TX([j, I], oe)) {
      if (c && !K)
        return $();
      if (!_ && a) {
        const be = g(D.clientX, D.clientY);
        if (be !== null && be < 0.1)
          return $();
      }
      TX([j, I], fe([w, x])) ? !c && a && i.start(40, $) : $();
    }
  };
  return b.__options = {
    blockPointerEvents: r
  }, b;
}
const wL = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (wL.displayName = "PopoverRootContext");
function k7(e) {
  const t = S.useContext(wL);
  if (t === void 0 && !e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: PopoverRootContext is missing. Popover parts must be placed within <Popover.Root>." : ud(47));
  return t;
}
function r7t() {
  return {
    ...Soe(),
    disabled: !1,
    modal: !1,
    instantType: void 0,
    openMethod: null,
    openChangeReason: null,
    titleElementId: void 0,
    descriptionElementId: void 0,
    stickIfOpen: !0,
    nested: !1,
    openOnHover: !1,
    closeDelay: 0,
    hasViewport: !1
  };
}
const a7t = {
  ...Coe,
  disabled: ua((e) => e.disabled),
  instantType: ua((e) => e.instantType),
  openMethod: ua((e) => e.openMethod),
  openChangeReason: ua((e) => e.openChangeReason),
  modal: ua((e) => e.modal),
  stickIfOpen: ua((e) => e.stickIfOpen),
  titleElementId: ua((e) => e.titleElementId),
  descriptionElementId: ua((e) => e.descriptionElementId),
  openOnHover: ua((e) => e.openOnHover),
  closeDelay: ua((e) => e.closeDelay),
  hasViewport: ua((e) => e.hasViewport)
};
class SL extends nO {
  constructor(t) {
    const r = {
      ...r7t(),
      ...t
    };
    r.open && t?.mounted === void 0 && (r.mounted = !0), super(r, {
      popupRef: /* @__PURE__ */ S.createRef(),
      backdropRef: /* @__PURE__ */ S.createRef(),
      internalBackdropRef: /* @__PURE__ */ S.createRef(),
      onOpenChange: void 0,
      onOpenChangeComplete: void 0,
      triggerFocusTargetRef: /* @__PURE__ */ S.createRef(),
      beforeContentFocusGuardRef: /* @__PURE__ */ S.createRef(),
      stickIfOpenTimeout: new $0(),
      triggerElements: new rO()
    }, a7t);
  }
  setOpen = (t, r) => {
    const a = r.reason === Xh, i = r.reason === hS && r.event.detail === 0, c = !t && (r.reason === ZM || r.reason == null);
    if (r.preventUnmountOnClose = () => {
      this.set("preventUnmountingOnClose", !0);
    }, this.context.onOpenChange?.(t, r), r.isCanceled)
      return;
    const d = {
      open: t,
      nativeEvent: r.event,
      reason: r.reason,
      nested: this.state.nested,
      triggerElement: r.trigger
    };
    this.state.floatingRootContext.context.events?.emit("openchange", d);
    const p = () => {
      const g = {
        open: t,
        openChangeReason: r.reason
      }, b = r.trigger?.id ?? null;
      (b || t) && (g.activeTriggerId = b, g.activeTriggerElement = r.trigger ?? null), this.update(g);
    };
    a ? (this.set("stickIfOpen", !0), this.context.stickIfOpenTimeout.start(k8t, () => {
      this.set("stickIfOpen", !1);
    }), sp.flushSync(p)) : p(), i || c ? this.set("instantType", i ? "click" : "dismiss") : r.reason === LE ? this.set("instantType", "focus") : this.set("instantType", void 0);
  };
  static useStore(t, r) {
    const a = am(() => new SL(r)).current, i = t ?? a;
    return S3(a.disposeEffect), i;
  }
  disposeEffect = () => this.context.stickIfOpenTimeout.disposeEffect();
}
function o7t(e) {
  const t = S.useRef(""), r = S.useCallback((i) => {
    i.defaultPrevented || (t.current = i.pointerType, e(i, i.pointerType));
  }, [e]);
  return {
    onClick: S.useCallback((i) => {
      if (i.detail === 0) {
        e(i, "keyboard");
        return;
      }
      "pointerType" in i ? e(i, i.pointerType) : e(i, t.current), t.current = "";
    }, [e]),
    onPointerDown: r
  };
}
function i7t(e) {
  const [t, r] = S.useState(null), a = Ar((f, p) => {
    e || r(p || // On iOS Safari, the hitslop around touch targets means tapping outside an element's
    // bounds does not fire `pointerdown` but does fire `mousedown`. The `interactionType`
    // will be "" in that case.
    (_ae ? "touch" : ""));
  }), i = S.useCallback(() => {
    r(null);
  }, []), {
    onClick: c,
    onPointerDown: d
  } = o7t(a);
  return S.useMemo(() => ({
    openMethod: t,
    reset: i,
    triggerProps: {
      onClick: c,
      onPointerDown: d
    }
  }), [t, i, c, d]);
}
function RX({
  props: e
}) {
  const {
    children: t,
    open: r,
    defaultOpen: a = !1,
    onOpenChange: i,
    onOpenChangeComplete: c,
    modal: d = !1,
    handle: f,
    triggerId: p,
    defaultTriggerId: g = null
  } = e, b = SL.useStore(f?.store, {
    modal: d,
    open: a,
    openProp: r,
    activeTriggerId: g,
    triggerIdProp: p
  });
  Xae(() => {
    r === void 0 && b.state.open === !1 && a === !0 && b.update({
      open: !0,
      activeTriggerId: g
    });
  }), b.useControlledProp("openProp", r), b.useControlledProp("triggerIdProp", p);
  const w = b.useState("open"), x = b.useState("positionerElement"), E = b.useState("payload"), P = b.useState("openChangeReason");
  b.useContextCallback("onOpenChange", i), b.useContextCallback("onOpenChangeComplete", c);
  const {
    openMethod: k,
    triggerProps: M,
    reset: T
  } = i7t(w);
  yoe(b);
  const {
    forceUnmount: N
  } = woe(w, b, () => {
    b.update({
      stickIfOpen: !0,
      openChangeReason: null
    }), T();
  });
  l5t(w && d === !0 && P !== Xh && k !== "touch", x), S.useEffect(() => {
    w || b.context.stickIfOpenTimeout.clear();
  }, [b, w]);
  const D = S.useCallback((J) => {
    const H = ji(J);
    return H.preventUnmountOnClose = () => {
      b.set("preventUnmountingOnClose", !0);
    }, H;
  }, [b]), $ = S.useCallback(() => {
    b.setOpen(!1, D(Nae));
  }, [b, D]);
  S.useImperativeHandle(e.actionsRef, () => ({
    unmount: N,
    close: $
  }), [N, $]);
  const j = xoe({
    popupStore: b,
    onOpenChange: b.setOpen
  }), I = foe(j, {
    outsidePressEvent: {
      // Ensure `aria-hidden` on outside elements is removed immediately
      // on outside press when trapping focus.
      mouse: d === "trap-focus" ? "sloppy" : "intentional",
      touch: "sloppy"
    }
  }), L = t7t(j), {
    getReferenceProps: F,
    getFloatingProps: _,
    getTriggerProps: W
  } = yL([I, L]), Q = S.useMemo(() => F(M), [F, M]), U = S.useMemo(() => W(M), [W, M]), Y = S.useMemo(() => _(), [_]);
  b.useSyncedValues({
    modal: d,
    openMethod: k,
    activeTriggerProps: Q,
    inactiveTriggerProps: U,
    popupProps: Y,
    floatingRootContext: j,
    nested: C3() != null
  });
  const G = S.useMemo(() => ({
    store: b
  }), [b]);
  return /* @__PURE__ */ V.jsx(wL.Provider, {
    value: G,
    children: typeof t == "function" ? t({
      payload: E
    }) : t
  });
}
function l7t(e) {
  return k7(!0) ? /* @__PURE__ */ V.jsx(RX, {
    props: e
  }) : /* @__PURE__ */ V.jsx(V5t, {
    children: /* @__PURE__ */ V.jsx(RX, {
      props: e
    })
  });
}
let CL = (function(e) {
  return e.open = "data-open", e.closed = "data-closed", e[e.startingStyle = s3.startingStyle] = "startingStyle", e[e.endingStyle = s3.endingStyle] = "endingStyle", e.anchorHidden = "data-anchor-hidden", e.side = "data-side", e.align = "data-align", e;
})({}), S9 = /* @__PURE__ */ (function(e) {
  return e.popupOpen = "data-popup-open", e.pressed = "data-pressed", e;
})({});
const s7t = {
  [S9.popupOpen]: ""
}, u7t = {
  [S9.popupOpen]: "",
  [S9.pressed]: ""
}, c7t = {
  [CL.open]: ""
}, d7t = {
  [CL.closed]: ""
}, f7t = {
  [CL.anchorHidden]: ""
}, Ooe = {
  open(e) {
    return e ? s7t : null;
  }
}, m7t = {
  open(e) {
    return e ? u7t : null;
  }
}, M7 = {
  open(e) {
    return e ? c7t : d7t;
  },
  anchorHidden(e) {
    return e ? f7t : null;
  }
}, h7t = 300, Toe = /* @__PURE__ */ S.forwardRef(function(t, r) {
  const {
    render: a,
    className: i,
    disabled: c = !1,
    nativeButton: d = !0,
    handle: f,
    payload: p,
    openOnHover: g = !1,
    delay: b = h7t,
    closeDelay: w = 0,
    id: x,
    ...E
  } = t, P = k7(!0), k = f?.store ?? P?.store;
  if (!k)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Popover.Trigger> must be either used within a <Popover.Root> component or provided with a handle." : ud(74));
  const M = E7(x), T = k.useState("isTriggerActive", M), N = k.useState("floatingRootContext"), D = k.useState("isOpenedByTrigger", M), $ = S.useRef(null), {
    registerTrigger: j,
    isMountedByThisTrigger: I
  } = boe(M, $, k, {
    payload: p,
    disabled: c,
    openOnHover: g,
    closeDelay: w
  }), L = k.useState("openChangeReason"), F = k.useState("stickIfOpen"), _ = k.useState("openMethod"), W = koe(N, {
    enabled: N != null && g && (_ !== "touch" || L !== hS),
    mouseOnly: !0,
    move: !1,
    handleClose: Moe(),
    restMs: b,
    delay: {
      close: w
    },
    triggerElementRef: $,
    isActiveTrigger: T
  }), Q = tEt(N, {
    enabled: N != null,
    stickIfOpen: F
  }), U = yL([Q]), Y = k.useState("triggerProps", I), G = {
    disabled: c,
    open: D
  }, {
    getButtonProps: J,
    buttonRef: H
  } = sL({
    disabled: c,
    native: d
  }), K = S.useMemo(() => ({
    open(ne) {
      return ne && L === hS ? m7t.open(ne) : Ooe.open(ne);
    }
  }), [L]), X = nc("button", t, {
    state: G,
    ref: [H, r, j, $],
    props: [U.getReferenceProps(), W, Y, {
      [Oae]: "",
      id: M
    }, E, J],
    stateAttributesMapping: K
  }), te = S.useRef(null), ie = Ar((ne) => {
    sp.flushSync(() => {
      k.setOpen(!1, ji(LE, ne.nativeEvent, ne.currentTarget));
    }), I5t(te.current)?.focus();
  }), ee = Ar((ne) => {
    const ae = k.select("positionerElement");
    if (ae && fx(ne, ae))
      k.context.beforeContentFocusGuardRef.current?.focus();
    else {
      sp.flushSync(() => {
        k.setOpen(!1, ji(LE, ne.nativeEvent, ne.currentTarget));
      });
      let oe = j5t(k.context.triggerFocusTargetRef.current || $.current);
      for (; oe !== null && oo(ae, oe); ) {
        const fe = oe;
        if (oe = uL(oe), oe === fe)
          break;
      }
      oe?.focus();
    }
  });
  return T ? /* @__PURE__ */ V.jsxs(S.Fragment, {
    children: [/* @__PURE__ */ V.jsx(mb, {
      ref: te,
      onFocus: ie
    }), /* @__PURE__ */ V.jsx(S.Fragment, {
      children: X
    }, M), /* @__PURE__ */ V.jsx(mb, {
      ref: k.context.triggerFocusTargetRef,
      onFocus: ee
    })]
  }) : /* @__PURE__ */ V.jsx(S.Fragment, {
    children: X
  }, M);
});
process.env.NODE_ENV !== "production" && (Toe.displayName = "PopoverTrigger");
const xL = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (xL.displayName = "PopoverPortalContext");
function p7t() {
  const e = S.useContext(xL);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Popover.Portal> is missing." : ud(45));
  return e;
}
const Roe = /* @__PURE__ */ S.forwardRef(function(t, r) {
  const {
    keepMounted: a = !1,
    ...i
  } = t, {
    store: c
  } = k7();
  return c.useState("mounted") || a ? /* @__PURE__ */ V.jsx(xL.Provider, {
    value: a,
    children: /* @__PURE__ */ V.jsx(doe, {
      ref: r,
      ...i
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (Roe.displayName = "PopoverPortal");
function EL(e) {
  return rL(19) ? e : e ? "true" : void 0;
}
const PL = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (PL.displayName = "PopoverPositionerContext");
function g7t() {
  const e = S.useContext(PL);
  if (!e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: PopoverPositionerContext is missing. PopoverPositioner parts must be placed within <Popover.Positioner>." : ud(46));
  return e;
}
const Aoe = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (Aoe.displayName = "DirectionContext");
function kL() {
  return S.useContext(Aoe)?.direction ?? "ltr";
}
const v7t = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: r,
      y: a,
      placement: i,
      rects: c,
      platform: d,
      elements: f,
      middlewareData: p
    } = t, {
      element: g,
      padding: b = 0,
      offsetParent: w = "real"
    } = wb(e, t) || {};
    if (g == null)
      return {};
    const x = AI(b), E = {
      x: r,
      y: a
    }, P = IM(i), k = jM(P), M = await d.getDimensions(g), T = P === "y", N = T ? "top" : "left", D = T ? "bottom" : "right", $ = T ? "clientHeight" : "clientWidth", j = c.reference[k] + c.reference[P] - E[P] - c.floating[k], I = E[P] - c.reference[P], L = w === "real" ? await d.getOffsetParent?.(g) : f.floating;
    let F = f.floating[$] || c.floating[k];
    (!F || !await d.isElement?.(L)) && (F = f.floating[$] || c.floating[k]);
    const _ = j / 2 - I / 2, W = F / 2 - M[k] / 2 - 1, Q = Math.min(x[N], W), U = Math.min(x[D], W), Y = Q, G = F - M[k] - U, J = F / 2 - M[k] / 2 + _, H = l9(Y, J, G), K = !p.arrow && bS(i) != null && J !== H && c.reference[k] / 2 - (J < Y ? Q : U) - M[k] / 2 < 0, X = K ? J < Y ? J - Y : J - G : 0;
    return {
      [P]: E[P] + X,
      data: {
        [P]: H,
        centerOffset: J - H - X,
        ...K && {
          alignmentOffset: X
        }
      },
      reset: K
    };
  }
}), b7t = (e, t) => ({
  ...v7t(e),
  options: [e, t]
}), y7t = {
  name: "hide",
  async fn(e) {
    const {
      width: t,
      height: r,
      x: a,
      y: i
    } = e.rects.reference, c = t === 0 && r === 0 && a === 0 && i === 0;
    return {
      data: {
        referenceHidden: (await sne().fn(e)).data?.referenceHidden || c
      }
    };
  }
}, Ak = {
  sideX: "left",
  sideY: "top"
}, Noe = {
  name: "adaptiveOrigin",
  async fn(e) {
    const {
      x: t,
      y: r,
      rects: {
        floating: a
      },
      elements: {
        floating: i
      },
      platform: c,
      strategy: d,
      placement: f
    } = e, p = lu(i), g = p.getComputedStyle(i);
    if (!(g.transitionDuration !== "0s" && g.transitionDuration !== ""))
      return {
        x: t,
        y: r,
        data: Ak
      };
    const w = await c.getOffsetParent?.(i);
    let x = {
      width: 0,
      height: 0
    };
    if (d === "fixed" && p?.visualViewport)
      x = {
        width: p.visualViewport.width,
        height: p.visualViewport.height
      };
    else if (w === p) {
      const N = Qo(i);
      x = {
        width: N.documentElement.clientWidth,
        height: N.documentElement.clientHeight
      };
    } else await c.isElement?.(w) && (x = await c.getDimensions(w));
    const E = lp(f);
    let P = t, k = r;
    E === "left" && (P = x.width - (t + a.width)), E === "top" && (k = x.height - (r + a.height));
    const M = E === "left" ? "right" : Ak.sideX, T = E === "top" ? "bottom" : Ak.sideY;
    return {
      x: P,
      y: k,
      data: {
        sideX: M,
        sideY: T
      }
    };
  }
};
function Doe(e, t, r) {
  const a = e === "inline-start" || e === "inline-end";
  return {
    top: "top",
    right: a ? r ? "inline-start" : "inline-end" : "right",
    bottom: "bottom",
    left: a ? r ? "inline-end" : "inline-start" : "left"
  }[t];
}
function AX(e, t, r) {
  const {
    rects: a,
    placement: i
  } = e;
  return {
    side: Doe(t, lp(i), r),
    align: bS(i) || "center",
    anchor: {
      width: a.reference.width,
      height: a.reference.height
    },
    positioner: {
      width: a.floating.width,
      height: a.floating.height
    }
  };
}
function $oe(e) {
  const {
    // Public parameters
    anchor: t,
    positionMethod: r = "absolute",
    side: a = "bottom",
    sideOffset: i = 0,
    align: c = "center",
    alignOffset: d = 0,
    collisionBoundary: f,
    collisionPadding: p = 5,
    sticky: g = !1,
    arrowPadding: b = 5,
    disableAnchorTracking: w = !1,
    // Private parameters
    keepMounted: x = !1,
    floatingRootContext: E,
    mounted: P,
    collisionAvoidance: k,
    shiftCrossAxis: M = !1,
    nodeId: T,
    adaptiveOrigin: N,
    lazyFlip: D = !1,
    externalTree: $
  } = e, [j, I] = S.useState(null);
  !P && j !== null && I(null);
  const L = k.side || "flip", F = k.align || "flip", _ = k.fallbackAxisSide || "end", W = typeof t == "function" ? t : void 0, Q = Ar(W), U = W ? Q : t, Y = ub(t), J = kL() === "rtl", H = j || {
    top: "top",
    right: "right",
    bottom: "bottom",
    left: "left",
    "inline-end": J ? "left" : "right",
    "inline-start": J ? "right" : "left"
  }[a], K = c === "center" ? H : `${H}-${c}`;
  let X = p;
  const te = 1, ie = a === "bottom" ? te : 0, ee = a === "top" ? te : 0, ne = a === "right" ? te : 0, ae = a === "left" ? te : 0;
  typeof X == "number" ? X = {
    top: X + ie,
    right: X + ae,
    bottom: X + ee,
    left: X + ne
  } : X && (X = {
    top: (X.top || 0) + ie,
    right: (X.right || 0) + ae,
    bottom: (X.bottom || 0) + ee,
    left: (X.left || 0) + ne
  });
  const oe = {
    boundary: f === "clipping-ancestors" ? "clippingAncestors" : f,
    padding: X
  }, fe = S.useRef(null), be = ub(i), me = ub(d), ze = [rne((at) => {
    const ft = AX(at, a, J), st = typeof be.current == "function" ? be.current(ft) : be.current, pt = typeof me.current == "function" ? me.current(ft) : me.current;
    return {
      mainAxis: st,
      crossAxis: pt,
      alignmentAxis: pt
    };
  }, [typeof i != "function" ? i : 0, typeof d != "function" ? d : 0, J, a])], le = F === "none" && L !== "shift", se = !le && (g || M || L === "shift"), Ae = L === "none" ? null : ine({
    ...oe,
    // Ensure the popup flips if it's been limited by its --available-height and it resizes.
    // Since the size() padding is smaller than the flip() padding, flip() will take precedence.
    padding: {
      top: X.top + te,
      right: X.right + te,
      bottom: X.bottom + te,
      left: X.left + te
    },
    mainAxis: !M && L === "flip",
    crossAxis: F === "flip" ? "alignment" : !1,
    fallbackAxisSideDirection: _
  }), we = le ? null : ane((at) => {
    const ft = Qo(at.elements.floating).documentElement;
    return {
      ...oe,
      // Use the Layout Viewport to avoid shifting around when pinch-zooming
      // for context menus.
      rootBoundary: M ? {
        x: 0,
        y: 0,
        width: ft.clientWidth,
        height: ft.clientHeight
      } : void 0,
      mainAxis: F !== "none",
      crossAxis: se,
      limiter: g || M ? void 0 : one((st) => {
        if (!fe.current)
          return {};
        const {
          width: pt,
          height: bt
        } = fe.current.getBoundingClientRect(), Nt = V0(lp(st.placement)), $t = Nt === "y" ? pt : bt, Pt = Nt === "y" ? X.left + X.right : X.top + X.bottom;
        return {
          offset: $t / 2 + Pt / 2
        };
      })
    };
  }, [oe, g, M, X, F]);
  L === "shift" || F === "shift" || c === "center" ? ze.push(we, Ae) : ze.push(Ae, we), ze.push(lne({
    ...oe,
    apply({
      elements: {
        floating: at
      },
      rects: {
        reference: ft
      },
      availableWidth: st,
      availableHeight: pt
    }) {
      const bt = at.style;
      bt.setProperty("--available-width", `${st}px`), bt.setProperty("--available-height", `${pt}px`), bt.setProperty("--anchor-width", `${ft.width}px`), bt.setProperty("--anchor-height", `${ft.height}px`);
    }
  }), b7t(() => ({
    // `transform-origin` calculations rely on an element existing. If the arrow hasn't been set,
    // we'll create a fake element.
    element: fe.current || document.createElement("div"),
    padding: b,
    offsetParent: "floating"
  }), [b]), {
    name: "transformOrigin",
    fn(at) {
      const {
        elements: ft,
        middlewareData: st,
        placement: pt,
        rects: bt,
        y: Nt
      } = at, $t = lp(pt), Pt = V0($t), hn = fe.current, an = st.arrow?.x || 0, jn = st.arrow?.y || 0, xn = hn?.clientWidth || 0, Ut = hn?.clientHeight || 0, pn = an + xn / 2, wn = jn + Ut / 2, Lt = Math.abs(st.shift?.y || 0), gt = bt.reference.height / 2, wt = typeof i == "function" ? i(AX(at, a, J)) : i, Ft = Lt > wt, yn = {
        top: `${pn}px calc(100% + ${wt}px)`,
        bottom: `${pn}px ${-wt}px`,
        left: `calc(100% + ${wt}px) ${wn}px`,
        right: `${-wt}px ${wn}px`
      }[$t], gn = `${pn}px ${bt.reference.y + gt - Nt}px`;
      return ft.floating.style.setProperty("--transform-origin", se && Pt === "y" && Ft ? gn : yn), {};
    }
  }, y7t, N), Dr(() => {
    !P && E && E.update({
      referenceElement: null,
      floatingElement: null,
      domReferenceElement: null
    });
  }, [P, E]);
  const Ne = S.useMemo(() => ({
    elementResize: !w && typeof ResizeObserver < "u",
    layoutShift: !w && typeof IntersectionObserver < "u"
  }), [w]), {
    refs: pe,
    elements: Qe,
    x: Le,
    y: Te,
    middlewareData: Oe,
    update: ye,
    placement: je,
    context: Ue,
    isPositioned: Fe,
    floatingStyles: tt
  } = GEt({
    rootContext: E,
    placement: K,
    middleware: ze,
    strategy: r,
    whileElementsMounted: x ? void 0 : (...at) => L$(...at, Ne),
    nodeId: T,
    externalTree: $
  }), {
    sideX: dt,
    sideY: St
  } = Oe.adaptiveOrigin || Ak, mt = Fe ? r : "fixed", Ot = S.useMemo(() => {
    const at = N ? {
      position: mt,
      [dt]: Le,
      [St]: Te
    } : {
      position: mt,
      ...tt
    };
    return Fe || (at.opacity = 0), at;
  }, [N, mt, dt, Le, St, Te, tt, Fe]), Rt = S.useRef(null);
  Dr(() => {
    if (!P)
      return;
    const at = Y.current, ft = typeof at == "function" ? at() : at, pt = (NX(ft) ? ft.current : ft) || null || null;
    pt !== Rt.current && (pe.setPositionReference(pt), Rt.current = pt);
  }, [P, pe, U, Y]), S.useEffect(() => {
    if (!P)
      return;
    const at = Y.current;
    typeof at != "function" && NX(at) && at.current !== Rt.current && (pe.setPositionReference(at.current), Rt.current = at.current);
  }, [P, pe, U, Y]), S.useEffect(() => {
    if (x && P && Qe.domReference && Qe.floating)
      return L$(Qe.domReference, Qe.floating, ye, Ne);
  }, [x, P, Qe, ye, Ne]);
  const ct = lp(je), it = Doe(a, ct, J), Ct = bS(je) || "center", ut = !!Oe.hide?.referenceHidden;
  Dr(() => {
    D && P && Fe && I(ct);
  }, [D, P, Fe, ct]);
  const ht = S.useMemo(() => ({
    position: "absolute",
    top: Oe.arrow?.y,
    left: Oe.arrow?.x
  }), [Oe.arrow]), ot = Oe.arrow?.centerOffset !== 0;
  return S.useMemo(() => ({
    positionerStyles: Ot,
    arrowStyles: ht,
    arrowRef: fe,
    arrowUncentered: ot,
    side: it,
    align: Ct,
    physicalSide: ct,
    anchorHidden: ut,
    refs: pe,
    context: Ue,
    isPositioned: Fe,
    update: ye
  }), [Ot, ht, fe, ot, it, Ct, ct, ut, pe, Ue, Fe, ye]);
}
function NX(e) {
  return e != null && "current" in e;
}
const zoe = /* @__PURE__ */ S.forwardRef(function(t, r) {
  const {
    cutout: a,
    ...i
  } = t;
  let c;
  if (a) {
    const d = a?.getBoundingClientRect();
    c = `polygon(
      0% 0%,
      100% 0%,
      100% 100%,
      0% 100%,
      0% 0%,
      ${d.left}px ${d.top}px,
      ${d.left}px ${d.bottom}px,
      ${d.right}px ${d.bottom}px,
      ${d.right}px ${d.top}px,
      ${d.left}px ${d.top}px
    )`;
  }
  return /* @__PURE__ */ V.jsx("div", {
    ref: r,
    role: "presentation",
    "data-base-ui-inert": "",
    ...i,
    style: {
      position: "fixed",
      inset: 0,
      userSelect: "none",
      WebkitUserSelect: "none",
      clipPath: c
    }
  });
});
process.env.NODE_ENV !== "production" && (zoe.displayName = "InternalBackdrop");
function aO(e) {
  return e === "starting" ? M8t : Gh;
}
const joe = /* @__PURE__ */ S.forwardRef(function(t, r) {
  const {
    render: a,
    className: i,
    anchor: c,
    positionMethod: d = "absolute",
    side: f = "bottom",
    align: p = "center",
    sideOffset: g = 0,
    alignOffset: b = 0,
    collisionBoundary: w = "clipping-ancestors",
    collisionPadding: x = 5,
    arrowPadding: E = 5,
    sticky: P = !1,
    disableAnchorTracking: k = !1,
    collisionAvoidance: M = Tae,
    ...T
  } = t, {
    store: N
  } = k7(), D = p7t(), $ = F5t(), j = N.useState("floatingRootContext"), I = N.useState("mounted"), L = N.useState("open"), F = N.useState("openChangeReason"), _ = N.useState("activeTriggerElement"), W = N.useState("modal"), Q = N.useState("positionerElement"), U = N.useState("instantType"), Y = N.useState("transitionStatus"), G = N.useState("hasViewport"), J = S.useRef(null), H = aL(Q, !1, !1), K = $oe({
    anchor: c,
    floatingRootContext: j,
    positionMethod: d,
    mounted: I,
    side: f,
    sideOffset: g,
    align: p,
    alignOffset: b,
    arrowPadding: E,
    collisionBoundary: w,
    collisionPadding: x,
    sticky: P,
    disableAnchorTracking: k,
    keepMounted: D,
    nodeId: $,
    collisionAvoidance: M,
    adaptiveOrigin: G ? Noe : void 0
  }), X = S.useMemo(() => {
    const oe = {};
    return L || (oe.pointerEvents = "none"), {
      role: "presentation",
      hidden: !I,
      style: {
        ...K.positionerStyles,
        ...oe
      }
    };
  }, [L, I, K.positionerStyles]), te = S.useMemo(() => ({
    props: X,
    ...K
  }), [X, K]), ie = j.useState("domReferenceElement");
  Dr(() => {
    const oe = ie, fe = J.current;
    if (oe && (J.current = oe), fe && oe && oe !== fe) {
      N.set("instantType", void 0);
      const be = new AbortController();
      return H(() => {
        N.set("instantType", "trigger-change");
      }, be.signal), () => {
        be.abort();
      };
    }
  }, [ie, H, N]);
  const ee = {
    open: L,
    side: te.side,
    align: te.align,
    anchorHidden: te.anchorHidden,
    instant: U
  }, ne = S.useCallback((oe) => {
    N.set("positionerElement", oe);
  }, [N]), ae = nc("div", t, {
    state: ee,
    props: [te.props, aO(Y), T],
    ref: [r, ne],
    stateAttributesMapping: M7
  });
  return /* @__PURE__ */ V.jsxs(PL.Provider, {
    value: te,
    children: [I && W === !0 && F !== Xh && /* @__PURE__ */ V.jsx(zoe, {
      ref: N.context.internalBackdropRef,
      inert: EL(!L),
      cutout: _
    }), /* @__PURE__ */ V.jsx(W5t, {
      id: $,
      children: ae
    })]
  });
});
process.env.NODE_ENV !== "production" && (joe.displayName = "PopoverPositioner");
const hx = "ArrowUp", G4 = "ArrowDown", HE = "ArrowLeft", px = "ArrowRight", O7 = "Home", T7 = "End", Ioe = /* @__PURE__ */ new Set([HE, px]), w7t = /* @__PURE__ */ new Set([HE, px, O7, T7]), Loe = /* @__PURE__ */ new Set([hx, G4]), S7t = /* @__PURE__ */ new Set([hx, G4, O7, T7]), Hoe = /* @__PURE__ */ new Set([...Ioe, ...Loe]), C7t = /* @__PURE__ */ new Set([...Hoe, O7, T7]), x7t = /* @__PURE__ */ new Set([hx, G4, HE, px, O7, T7]), E7t = "Shift", P7t = "Control", k7t = "Alt", M7t = "Meta", O7t = /* @__PURE__ */ new Set([E7t, P7t, k7t, M7t]);
function T7t(e) {
  return Os(e) && e.tagName === "INPUT";
}
function DX(e) {
  return !!(T7t(e) && e.selectionStart != null || Os(e) && e.tagName === "TEXTAREA");
}
function $X(e, t, r, a) {
  if (!e || !t || !t.scrollTo)
    return;
  let i = e.scrollLeft, c = e.scrollTop;
  const d = e.clientWidth < e.scrollWidth, f = e.clientHeight < e.scrollHeight;
  if (d && a !== "vertical") {
    const p = zX(e, t, "left"), g = HP(e), b = HP(t);
    r === "ltr" && (p + t.offsetWidth + b.scrollMarginRight > e.scrollLeft + e.clientWidth - g.scrollPaddingRight ? i = p + t.offsetWidth + b.scrollMarginRight - e.clientWidth + g.scrollPaddingRight : p - b.scrollMarginLeft < e.scrollLeft + g.scrollPaddingLeft && (i = p - b.scrollMarginLeft - g.scrollPaddingLeft)), r === "rtl" && (p - b.scrollMarginRight < e.scrollLeft + g.scrollPaddingLeft ? i = p - b.scrollMarginLeft - g.scrollPaddingLeft : p + t.offsetWidth + b.scrollMarginRight > e.scrollLeft + e.clientWidth - g.scrollPaddingRight && (i = p + t.offsetWidth + b.scrollMarginRight - e.clientWidth + g.scrollPaddingRight));
  }
  if (f && a !== "horizontal") {
    const p = zX(e, t, "top"), g = HP(e), b = HP(t);
    p - b.scrollMarginTop < e.scrollTop + g.scrollPaddingTop ? c = p - b.scrollMarginTop - g.scrollPaddingTop : p + t.offsetHeight + b.scrollMarginBottom > e.scrollTop + e.clientHeight - g.scrollPaddingBottom && (c = p + t.offsetHeight + b.scrollMarginBottom - e.clientHeight + g.scrollPaddingBottom);
  }
  e.scrollTo({
    left: i,
    top: c,
    behavior: "auto"
  });
}
function zX(e, t, r) {
  const a = r === "left" ? "offsetLeft" : "offsetTop";
  let i = 0;
  for (; t.offsetParent && (i += t[a], t.offsetParent !== e); )
    t = t.offsetParent;
  return i;
}
function HP(e) {
  const t = getComputedStyle(e);
  return {
    scrollMarginTop: parseFloat(t.scrollMarginTop) || 0,
    scrollMarginRight: parseFloat(t.scrollMarginRight) || 0,
    scrollMarginBottom: parseFloat(t.scrollMarginBottom) || 0,
    scrollMarginLeft: parseFloat(t.scrollMarginLeft) || 0,
    scrollPaddingTop: parseFloat(t.scrollPaddingTop) || 0,
    scrollPaddingRight: parseFloat(t.scrollPaddingRight) || 0,
    scrollPaddingBottom: parseFloat(t.scrollPaddingBottom) || 0,
    scrollPaddingLeft: parseFloat(t.scrollPaddingLeft) || 0
  };
}
const Foe = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (Foe.displayName = "ToolbarRootContext");
function R7t(e) {
  return S.useContext(Foe);
}
const A7t = {
  ...M7,
  ...i6
}, Woe = /* @__PURE__ */ S.forwardRef(function(t, r) {
  const {
    className: a,
    render: i,
    initialFocus: c,
    finalFocus: d,
    ...f
  } = t, {
    store: p
  } = k7(), g = g7t(), b = R7t() != null, w = p.useState("open"), x = p.useState("openMethod"), E = p.useState("instantType"), P = p.useState("transitionStatus"), k = p.useState("popupProps"), M = p.useState("titleElementId"), T = p.useState("descriptionElementId"), N = p.useState("modal"), D = p.useState("mounted"), $ = p.useState("openChangeReason"), j = p.useState("activeTriggerElement"), I = p.useState("floatingRootContext");
  l6({
    open: w,
    ref: p.context.popupRef,
    onComplete() {
      w && p.context.onOpenChangeComplete?.(!0);
    }
  });
  const L = p.useState("disabled"), F = p.useState("openOnHover"), _ = p.useState("closeDelay");
  Poe(I, {
    enabled: F && !L,
    closeDelay: _
  });
  function W(J) {
    return J === "touch" ? p.context.popupRef.current : !0;
  }
  const Q = c === void 0 ? W : c, U = {
    open: w,
    side: g.side,
    align: g.align,
    instant: E,
    transitionStatus: P
  }, Y = S.useCallback((J) => {
    p.set("popupElement", J);
  }, [p]), G = nc("div", t, {
    state: U,
    ref: [r, p.context.popupRef, Y],
    props: [k, {
      "aria-labelledby": M,
      "aria-describedby": T,
      onKeyDown(J) {
        b && x7t.has(J.key) && J.stopPropagation();
      }
    }, aO(P), f],
    stateAttributesMapping: A7t
  });
  return /* @__PURE__ */ V.jsx(eEt, {
    context: I,
    openInteractionType: x,
    modal: N === "trap-focus",
    disabled: !D || $ === Xh,
    initialFocus: Q,
    returnFocus: d,
    restoreFocus: "popup",
    previousFocusableElement: Os(j) ? j : void 0,
    nextFocusableElement: p.context.triggerFocusTargetRef,
    beforeContentFocusGuardRef: p.context.beforeContentFocusGuardRef,
    children: G
  });
});
process.env.NODE_ENV !== "production" && (Woe.displayName = "PopoverPopup");
function jX(e) {
  const t = dp(e);
  let r = parseFloat(t.width) || 0, a = parseFloat(t.height) || 0;
  const i = Os(e), c = i ? e.offsetWidth : r, d = i ? e.offsetHeight : a;
  return (Nx(r) !== c || Nx(a) !== d) && (r = c, a = d), {
    width: r,
    height: a
  };
}
function Voe({
  closeCallback: e,
  depth: t = 0,
  item: r,
  ...a
}) {
  const { children: i, key: c } = r, {
    dataTestId: d,
    handleOpenChange: f,
    inline: p,
    onClick: g,
    openKeys: b,
    orientation: w
  } = Do(nL), x = mn(() => b.includes(c), [b, c]), E = It(null), P = It(null), k = a8t(), {
    openSubmenu: M,
    closeThisSubmenu: T,
    closeAndFocusTrigger: N,
    handleMouseLeave: D,
    onActivate: $
  } = l8t({
    closeTimer: k,
    handleOpenChange: f,
    key: c,
    open: x,
    propertyOnClick: g,
    triggerButtonReference: E
  }), {
    focused: j,
    handleInlineTriggerFocus: I,
    handleInlineTriggerBlur: L,
    handleTriggerFocus: F,
    handleTriggerBlur: _,
    handlePopupBlur: W
  } = s8t({
    closeTimer: k,
    closeThisSubmenu: T,
    popupReference: P,
    triggerButtonReference: E
  }), Q = /* @__PURE__ */ V.jsx(
    X$,
    {
      item: {
        ...r,
        label: /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
          r.label,
          /* @__PURE__ */ V.jsx(
            _f,
            {
              name: "chevronRight",
              className: lt(
                "ml-1",
                p && "transition-transform duration-200",
                p && x && "rotate-90"
              )
            }
          )
        ] })
      },
      ...a,
      blurCallback: p ? L : _,
      closeCallback: e,
      depth: t,
      focusCallback: p ? I : F,
      className: lt("justify-between", a.className),
      onActivate: $,
      onMouseEnter: p ? void 0 : M,
      onMouseLeave: p ? void 0 : D,
      openSubmenu: j ? M : void 0,
      ref: E,
      submenu: void 0
    }
  ), U = /* @__PURE__ */ V.jsx(
    "ul",
    {
      className: lt(_oe({ nested: !0, orientation: w })),
      "data-slot": "menubar-sub",
      "data-testid": `${d}-${c}-submenu`,
      onBlur: p ? void 0 : W,
      onFocus: p ? void 0 : k.clear,
      onMouseEnter: p ? void 0 : k.clear,
      onMouseLeave: p ? void 0 : D,
      children: i?.map(
        (Y) => Y.children ? /* @__PURE__ */ V.jsx(
          Voe,
          {
            item: Y,
            closeCallback: N,
            depth: p ? t + 1 : 0
          },
          Y.key
        ) : /* @__PURE__ */ V.jsx(
          X$,
          {
            item: Y,
            closeCallback: N,
            depth: p ? t + 1 : 0
          },
          Y.key
        )
      )
    }
  );
  return p ? /* @__PURE__ */ V.jsxs(
    zae,
    {
      className: "flex w-full min-w-0 flex-col gap-0",
      open: x,
      onOpenChange: (Y) => {
        Y || f?.(c, !1);
      },
      children: [
        /* @__PURE__ */ V.jsx(Iae, { nativeButton: !0, render: Q }),
        /* @__PURE__ */ V.jsx(
          Hae,
          {
            className: lt(
              "overflow-hidden",
              "data-open:animate-accordion-down",
              "data-closed:animate-accordion-up"
            ),
            children: U
          }
        )
      ]
    }
  ) : /* @__PURE__ */ V.jsxs(
    l7t,
    {
      open: x,
      onOpenChange: (Y) => {
        Y || f?.(c, !1);
      },
      children: [
        /* @__PURE__ */ V.jsx(Toe, { nativeButton: !0, render: Q }),
        /* @__PURE__ */ V.jsx(Roe, { keepMounted: !0, children: /* @__PURE__ */ V.jsx(
          joe,
          {
            anchor: E,
            side: "right",
            align: "start",
            alignOffset: ({ anchor: Y }) => -Y.height / 2,
            sideOffset: 4,
            collisionAvoidance: { side: "flip", align: "shift" },
            children: /* @__PURE__ */ V.jsx(
              Woe,
              {
                ref: P,
                initialFocus: !1,
                finalFocus: !1,
                "data-submenu-popup": !0,
                className: lt(
                  "origin-(--transform-origin)",
                  "transition-[scale,opacity] duration-150 ease-out",
                  "data-starting-style:scale-90 data-starting-style:opacity-0",
                  "data-ending-style:scale-90 data-ending-style:opacity-0"
                ),
                children: U
              }
            )
          }
        ) })
      ]
    }
  );
}
const _oe = fl(
  lt([
    "flex list-none flex-col px-(--menu-padding-x) py-(--menu-padding-y)",
    "bg-(--menu-background-color) w-fit",
    "border border-(--menu-border-color) rounded-(--menu-border-radius)"
  ]),
  {
    variants: {
      orientation: {
        horizontal: "flex-row"
      },
      /** When true, removes gap between items (for nested submenus). Top-level menus keep gap for section separation. */
      nested: {
        true: "min-w-0 w-full gap-0 overflow-hidden border-0",
        false: "gap-(--menu-gap)"
      }
    },
    defaultVariants: {
      orientation: void 0,
      nested: !1
    }
  }
);
function ETt({
  className: e,
  dataTestId: t,
  defaultOpenKeys: r = [],
  defaultSelectedKeys: a = [],
  allowDeselect: i = !0,
  inline: c = !1,
  items: d,
  multiple: f = !0,
  onClick: p,
  onOpenChange: g,
  onSelect: b,
  orientation: w,
  selectedKeys: x,
  width: E
}) {
  const P = mG(), k = t ?? `Menu-${P}`;
  Er(() => {
    const _ = Sae(d);
    _?.size && console.warn(
      `Duplicate menu item keys found for Menu ${k} [${[
        ..._
      ].join(", ")}]. Menu item key values should be unique.`
    );
  }, [k, d]);
  const M = It(null), { openKeys: T, handleOpenChange: N } = o8t({
    defaultOpenKeys: r,
    inline: c,
    menuRootRef: M,
    onOpenChange: g
  }), { selectedKeys: D, handleSelect: $ } = i8t({
    allowDeselect: i,
    controlledSelectedKeys: x,
    defaultSelectedKeys: a,
    multiple: f,
    onSelect: b
  }), j = mn(
    () => c ? Z6t(d, T) : void 0,
    [c, d, T]
  ), I = mn(
    () => ({
      dataTestId: k,
      allowDeselect: i,
      handleOpenChange: N,
      handleSelect: $,
      inline: c,
      items: d,
      menuRootRef: M,
      multiple: f,
      onClick: p,
      openKeys: T,
      orientation: w,
      selectedKeys: D,
      visibleItemsInOrder: j
    }),
    [
      k,
      i,
      N,
      $,
      c,
      d,
      f,
      p,
      T,
      w,
      D,
      j
    ]
  ), L = mn(
    () => JSON.stringify(
      (function _(W) {
        return W.map(({ key: Q, label: U, children: Y }) => ({
          key: Q,
          label: typeof U == "string" ? U : "",
          ...Y ? { children: _(Y) } : {}
        }));
      })(d)
    ),
    [d]
  ), F = mn(
    () => JSON.stringify(D),
    [D]
  );
  return /* @__PURE__ */ V.jsx(nL.Provider, { value: I, children: /* @__PURE__ */ V.jsx("div", { "data-preflight": !0, className: "contents", children: /* @__PURE__ */ V.jsx(
    "ul",
    {
      ref: M,
      "data-menu-root": !0,
      "data-items": L,
      "data-selected": F,
      "data-testid": k,
      className: lt(_oe({ orientation: w }), e),
      style: { width: E },
      children: d.map(
        (_) => _.children ? /* @__PURE__ */ V.jsx(Voe, { item: _ }, _.key) : /* @__PURE__ */ V.jsx(X$, { item: _ }, _.key)
      )
    }
  ) }) });
}
const Boe = fp(void 0), d6 = () => {
  const e = Do(Boe);
  if (!e)
    throw new Error(
      "useModalContext must be used within a ModalContext.Provider"
    );
  return e;
};
function N7t(e) {
  const { testId: t } = d6();
  return /* @__PURE__ */ V.jsx(
    Bxt,
    {
      "data-slot": "dialog-close",
      "data-testid": `${t}-close`,
      ...e
    }
  );
}
const D7t = fl(
  lt(
    "bg-background data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 fixed left-[50%] top-[50%] z-50 grid w-full translate-x-[-50%] translate-y-[-50%] gap-4 rounded-lg border p-6 shadow-lg duration-200",
    "box-border p-0"
  ),
  {
    variants: {
      theme: {
        apollo: [],
        classic: ["border-none rounded-none"]
      }
    },
    defaultVariants: {
      theme: "classic"
    }
  }
);
function $7t({
  className: e,
  children: t,
  ...r
}) {
  const {
    className: a,
    handleClickOutside: i,
    handleManualClose: c,
    testId: d,
    theme: f,
    width: p
  } = d6();
  return /* @__PURE__ */ V.jsxs(Qre, { "data-slot": "dialog-portal", "data-testid": `${d}-portal`, children: [
    /* @__PURE__ */ V.jsx(ZI, {}),
    /* @__PURE__ */ V.jsx(
      Jre,
      {
        className: lt(D7t({ theme: f }), a, e),
        "data-slot": "dialog-content",
        "data-testid": `${d}-content`,
        onEscapeKeyDown: c,
        onPointerDownOutside: i,
        onInteractOutside: i,
        style: { width: p },
        ...r,
        children: t
      }
    )
  ] });
}
function z7t({
  className: e,
  testId: t,
  ...r
}) {
  return /* @__PURE__ */ V.jsx(
    _xt,
    {
      className: lt("text-muted-foreground text-sm", e),
      "data-slot": "dialog-description",
      "data-testid": `${t}-description`,
      ...r
    }
  );
}
const Aa = (e) => typeof e == "string", Z5 = () => {
  let e, t;
  const r = new Promise((a, i) => {
    e = a, t = i;
  });
  return r.resolve = e, r.reject = t, r;
}, IX = (e) => e == null ? "" : "" + e, j7t = (e, t, r) => {
  e.forEach((a) => {
    t[a] && (r[a] = t[a]);
  });
}, I7t = /###/g, LX = (e) => e && e.indexOf("###") > -1 ? e.replace(I7t, ".") : e, HX = (e) => !e || Aa(e), yE = (e, t, r) => {
  const a = Aa(t) ? t.split(".") : t;
  let i = 0;
  for (; i < a.length - 1; ) {
    if (HX(e)) return {};
    const c = LX(a[i]);
    !e[c] && r && (e[c] = new r()), Object.prototype.hasOwnProperty.call(e, c) ? e = e[c] : e = {}, ++i;
  }
  return HX(e) ? {} : {
    obj: e,
    k: LX(a[i])
  };
}, FX = (e, t, r) => {
  const {
    obj: a,
    k: i
  } = yE(e, t, Object);
  if (a !== void 0 || t.length === 1) {
    a[i] = r;
    return;
  }
  let c = t[t.length - 1], d = t.slice(0, t.length - 1), f = yE(e, d, Object);
  for (; f.obj === void 0 && d.length; )
    c = `${d[d.length - 1]}.${c}`, d = d.slice(0, d.length - 1), f = yE(e, d, Object), f && f.obj && typeof f.obj[`${f.k}.${c}`] < "u" && (f.obj = void 0);
  f.obj[`${f.k}.${c}`] = r;
}, L7t = (e, t, r, a) => {
  const {
    obj: i,
    k: c
  } = yE(e, t, Object);
  i[c] = i[c] || [], i[c].push(r);
}, C9 = (e, t) => {
  const {
    obj: r,
    k: a
  } = yE(e, t);
  if (r)
    return r[a];
}, H7t = (e, t, r) => {
  const a = C9(e, r);
  return a !== void 0 ? a : C9(t, r);
}, Uoe = (e, t, r) => {
  for (const a in t)
    a !== "__proto__" && a !== "constructor" && (a in e ? Aa(e[a]) || e[a] instanceof String || Aa(t[a]) || t[a] instanceof String ? r && (e[a] = t[a]) : Uoe(e[a], t[a], r) : e[a] = t[a]);
  return e;
}, W3 = (e) => e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var F7t = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const W7t = (e) => Aa(e) ? e.replace(/[&<>"'\/]/g, (t) => F7t[t]) : e;
class V7t {
  constructor(t) {
    this.capacity = t, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(t) {
    const r = this.regExpMap.get(t);
    if (r !== void 0)
      return r;
    const a = new RegExp(t);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(t, a), this.regExpQueue.push(t), a;
  }
}
const _7t = [" ", ",", "?", "!", ";"], B7t = new V7t(20), U7t = (e, t, r) => {
  t = t || "", r = r || "";
  const a = _7t.filter((d) => t.indexOf(d) < 0 && r.indexOf(d) < 0);
  if (a.length === 0) return !0;
  const i = B7t.getRegExp(`(${a.map((d) => d === "?" ? "\\?" : d).join("|")})`);
  let c = !i.test(e);
  if (!c) {
    const d = e.indexOf(r);
    d > 0 && !i.test(e.substring(0, d)) && (c = !0);
  }
  return c;
}, sz = function(e, t) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!e) return;
  if (e[t]) return e[t];
  const a = t.split(r);
  let i = e;
  for (let c = 0; c < a.length; ) {
    if (!i || typeof i != "object")
      return;
    let d, f = "";
    for (let p = c; p < a.length; ++p)
      if (p !== c && (f += r), f += a[p], d = i[f], d !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof d) > -1 && p < a.length - 1)
          continue;
        c += p - c + 1;
        break;
      }
    i = d;
  }
  return i;
}, x9 = (e) => e && e.replace("_", "-"), X7t = {
  type: "logger",
  log(e) {
    this.output("log", e);
  },
  warn(e) {
    this.output("warn", e);
  },
  error(e) {
    this.output("error", e);
  },
  output(e, t) {
    console && console[e] && console[e].apply(console, t);
  }
};
class E9 {
  constructor(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(t, r);
  }
  init(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = r.prefix || "i18next:", this.logger = t || X7t, this.options = r, this.debug = r.debug;
  }
  log() {
    for (var t = arguments.length, r = new Array(t), a = 0; a < t; a++)
      r[a] = arguments[a];
    return this.forward(r, "log", "", !0);
  }
  warn() {
    for (var t = arguments.length, r = new Array(t), a = 0; a < t; a++)
      r[a] = arguments[a];
    return this.forward(r, "warn", "", !0);
  }
  error() {
    for (var t = arguments.length, r = new Array(t), a = 0; a < t; a++)
      r[a] = arguments[a];
    return this.forward(r, "error", "");
  }
  deprecate() {
    for (var t = arguments.length, r = new Array(t), a = 0; a < t; a++)
      r[a] = arguments[a];
    return this.forward(r, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(t, r, a, i) {
    return i && !this.debug ? null : (Aa(t[0]) && (t[0] = `${a}${this.prefix} ${t[0]}`), this.logger[r](t));
  }
  create(t) {
    return new E9(this.logger, {
      prefix: `${this.prefix}:${t}:`,
      ...this.options
    });
  }
  clone(t) {
    return t = t || this.options, t.prefix = t.prefix || this.prefix, new E9(this.logger, t);
  }
}
var cb = new E9();
class oO {
  constructor() {
    this.observers = {};
  }
  on(t, r) {
    return t.split(" ").forEach((a) => {
      this.observers[a] || (this.observers[a] = /* @__PURE__ */ new Map());
      const i = this.observers[a].get(r) || 0;
      this.observers[a].set(r, i + 1);
    }), this;
  }
  off(t, r) {
    if (this.observers[t]) {
      if (!r) {
        delete this.observers[t];
        return;
      }
      this.observers[t].delete(r);
    }
  }
  emit(t) {
    for (var r = arguments.length, a = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++)
      a[i - 1] = arguments[i];
    this.observers[t] && Array.from(this.observers[t].entries()).forEach((d) => {
      let [f, p] = d;
      for (let g = 0; g < p; g++)
        f(...a);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((d) => {
      let [f, p] = d;
      for (let g = 0; g < p; g++)
        f.apply(f, [t, ...a]);
    });
  }
}
class WX extends oO {
  constructor(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = t || {}, this.options = r, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(t) {
    this.options.ns.indexOf(t) < 0 && this.options.ns.push(t);
  }
  removeNamespaces(t) {
    const r = this.options.ns.indexOf(t);
    r > -1 && this.options.ns.splice(r, 1);
  }
  getResource(t, r, a) {
    let i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const c = i.keySeparator !== void 0 ? i.keySeparator : this.options.keySeparator, d = i.ignoreJSONStructure !== void 0 ? i.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let f;
    t.indexOf(".") > -1 ? f = t.split(".") : (f = [t, r], a && (Array.isArray(a) ? f.push(...a) : Aa(a) && c ? f.push(...a.split(c)) : f.push(a)));
    const p = C9(this.data, f);
    return !p && !r && !a && t.indexOf(".") > -1 && (t = f[0], r = f[1], a = f.slice(2).join(".")), p || !d || !Aa(a) ? p : sz(this.data && this.data[t] && this.data[t][r], a, c);
  }
  addResource(t, r, a, i) {
    let c = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const d = c.keySeparator !== void 0 ? c.keySeparator : this.options.keySeparator;
    let f = [t, r];
    a && (f = f.concat(d ? a.split(d) : a)), t.indexOf(".") > -1 && (f = t.split("."), i = r, r = f[1]), this.addNamespaces(r), FX(this.data, f, i), c.silent || this.emit("added", t, r, a, i);
  }
  addResources(t, r, a) {
    let i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const c in a)
      (Aa(a[c]) || Array.isArray(a[c])) && this.addResource(t, r, c, a[c], {
        silent: !0
      });
    i.silent || this.emit("added", t, r, a);
  }
  addResourceBundle(t, r, a, i, c) {
    let d = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, f = [t, r];
    t.indexOf(".") > -1 && (f = t.split("."), i = a, a = r, r = f[1]), this.addNamespaces(r);
    let p = C9(this.data, f) || {};
    d.skipCopy || (a = JSON.parse(JSON.stringify(a))), i ? Uoe(p, a, c) : p = {
      ...p,
      ...a
    }, FX(this.data, f, p), d.silent || this.emit("added", t, r, a);
  }
  removeResourceBundle(t, r) {
    this.hasResourceBundle(t, r) && delete this.data[t][r], this.removeNamespaces(r), this.emit("removed", t, r);
  }
  hasResourceBundle(t, r) {
    return this.getResource(t, r) !== void 0;
  }
  getResourceBundle(t, r) {
    return r || (r = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? {
      ...this.getResource(t, r)
    } : this.getResource(t, r);
  }
  getDataByLanguage(t) {
    return this.data[t];
  }
  hasLanguageSomeTranslations(t) {
    const r = this.getDataByLanguage(t);
    return !!(r && Object.keys(r) || []).find((i) => r[i] && Object.keys(r[i]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var Xoe = {
  processors: {},
  addPostProcessor(e) {
    this.processors[e.name] = e;
  },
  handle(e, t, r, a, i) {
    return e.forEach((c) => {
      this.processors[c] && (t = this.processors[c].process(t, r, a, i));
    }), t;
  }
};
const VX = {};
class P9 extends oO {
  constructor(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), j7t(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], t, this), this.options = r, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = cb.create("translator");
  }
  changeLanguage(t) {
    t && (this.language = t);
  }
  exists(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (t == null)
      return !1;
    const a = this.resolve(t, r);
    return a && a.res !== void 0;
  }
  extractFromKey(t, r) {
    let a = r.nsSeparator !== void 0 ? r.nsSeparator : this.options.nsSeparator;
    a === void 0 && (a = ":");
    const i = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator;
    let c = r.ns || this.options.defaultNS || [];
    const d = a && t.indexOf(a) > -1, f = !this.options.userDefinedKeySeparator && !r.keySeparator && !this.options.userDefinedNsSeparator && !r.nsSeparator && !U7t(t, a, i);
    if (d && !f) {
      const p = t.match(this.interpolator.nestingRegexp);
      if (p && p.length > 0)
        return {
          key: t,
          namespaces: Aa(c) ? [c] : c
        };
      const g = t.split(a);
      (a !== i || a === i && this.options.ns.indexOf(g[0]) > -1) && (c = g.shift()), t = g.join(i);
    }
    return {
      key: t,
      namespaces: Aa(c) ? [c] : c
    };
  }
  translate(t, r, a) {
    if (typeof r != "object" && this.options.overloadTranslationOptionHandler && (r = this.options.overloadTranslationOptionHandler(arguments)), typeof r == "object" && (r = {
      ...r
    }), r || (r = {}), t == null) return "";
    Array.isArray(t) || (t = [String(t)]);
    const i = r.returnDetails !== void 0 ? r.returnDetails : this.options.returnDetails, c = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator, {
      key: d,
      namespaces: f
    } = this.extractFromKey(t[t.length - 1], r), p = f[f.length - 1], g = r.lng || this.language, b = r.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (g && g.toLowerCase() === "cimode") {
      if (b) {
        const $ = r.nsSeparator || this.options.nsSeparator;
        return i ? {
          res: `${p}${$}${d}`,
          usedKey: d,
          exactUsedKey: d,
          usedLng: g,
          usedNS: p,
          usedParams: this.getUsedParamsDetails(r)
        } : `${p}${$}${d}`;
      }
      return i ? {
        res: d,
        usedKey: d,
        exactUsedKey: d,
        usedLng: g,
        usedNS: p,
        usedParams: this.getUsedParamsDetails(r)
      } : d;
    }
    const w = this.resolve(t, r);
    let x = w && w.res;
    const E = w && w.usedKey || d, P = w && w.exactUsedKey || d, k = Object.prototype.toString.apply(x), M = ["[object Number]", "[object Function]", "[object RegExp]"], T = r.joinArrays !== void 0 ? r.joinArrays : this.options.joinArrays, N = !this.i18nFormat || this.i18nFormat.handleAsObject, D = !Aa(x) && typeof x != "boolean" && typeof x != "number";
    if (N && x && D && M.indexOf(k) < 0 && !(Aa(T) && Array.isArray(x))) {
      if (!r.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const $ = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(E, x, {
          ...r,
          ns: f
        }) : `key '${d} (${this.language})' returned an object instead of string.`;
        return i ? (w.res = $, w.usedParams = this.getUsedParamsDetails(r), w) : $;
      }
      if (c) {
        const $ = Array.isArray(x), j = $ ? [] : {}, I = $ ? P : E;
        for (const L in x)
          if (Object.prototype.hasOwnProperty.call(x, L)) {
            const F = `${I}${c}${L}`;
            j[L] = this.translate(F, {
              ...r,
              joinArrays: !1,
              ns: f
            }), j[L] === F && (j[L] = x[L]);
          }
        x = j;
      }
    } else if (N && Aa(T) && Array.isArray(x))
      x = x.join(T), x && (x = this.extendTranslation(x, t, r, a));
    else {
      let $ = !1, j = !1;
      const I = r.count !== void 0 && !Aa(r.count), L = P9.hasDefaultValue(r), F = I ? this.pluralResolver.getSuffix(g, r.count, r) : "", _ = r.ordinal && I ? this.pluralResolver.getSuffix(g, r.count, {
        ordinal: !1
      }) : "", W = I && !r.ordinal && r.count === 0 && this.pluralResolver.shouldUseIntlApi(), Q = W && r[`defaultValue${this.options.pluralSeparator}zero`] || r[`defaultValue${F}`] || r[`defaultValue${_}`] || r.defaultValue;
      !this.isValidLookup(x) && L && ($ = !0, x = Q), this.isValidLookup(x) || (j = !0, x = d);
      const Y = (r.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && j ? void 0 : x, G = L && Q !== x && this.options.updateMissing;
      if (j || $ || G) {
        if (this.logger.log(G ? "updateKey" : "missingKey", g, p, d, G ? Q : x), c) {
          const X = this.resolve(d, {
            ...r,
            keySeparator: !1
          });
          X && X.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let J = [];
        const H = this.languageUtils.getFallbackCodes(this.options.fallbackLng, r.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && H && H[0])
          for (let X = 0; X < H.length; X++)
            J.push(H[X]);
        else this.options.saveMissingTo === "all" ? J = this.languageUtils.toResolveHierarchy(r.lng || this.language) : J.push(r.lng || this.language);
        const K = (X, te, ie) => {
          const ee = L && ie !== x ? ie : Y;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(X, p, te, ee, G, r) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(X, p, te, ee, G, r), this.emit("missingKey", X, p, te, x);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && I ? J.forEach((X) => {
          const te = this.pluralResolver.getSuffixes(X, r);
          W && r[`defaultValue${this.options.pluralSeparator}zero`] && te.indexOf(`${this.options.pluralSeparator}zero`) < 0 && te.push(`${this.options.pluralSeparator}zero`), te.forEach((ie) => {
            K([X], d + ie, r[`defaultValue${ie}`] || Q);
          });
        }) : K(J, d, Q));
      }
      x = this.extendTranslation(x, t, r, w, a), j && x === d && this.options.appendNamespaceToMissingKey && (x = `${p}:${d}`), (j || $) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? x = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${p}:${d}` : d, $ ? x : void 0) : x = this.options.parseMissingKeyHandler(x));
    }
    return i ? (w.res = x, w.usedParams = this.getUsedParamsDetails(r), w) : x;
  }
  extendTranslation(t, r, a, i, c) {
    var d = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      t = this.i18nFormat.parse(t, {
        ...this.options.interpolation.defaultVariables,
        ...a
      }, a.lng || this.language || i.usedLng, i.usedNS, i.usedKey, {
        resolved: i
      });
    else if (!a.skipInterpolation) {
      a.interpolation && this.interpolator.init({
        ...a,
        interpolation: {
          ...this.options.interpolation,
          ...a.interpolation
        }
      });
      const g = Aa(t) && (a && a.interpolation && a.interpolation.skipOnVariables !== void 0 ? a.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let b;
      if (g) {
        const x = t.match(this.interpolator.nestingRegexp);
        b = x && x.length;
      }
      let w = a.replace && !Aa(a.replace) ? a.replace : a;
      if (this.options.interpolation.defaultVariables && (w = {
        ...this.options.interpolation.defaultVariables,
        ...w
      }), t = this.interpolator.interpolate(t, w, a.lng || this.language || i.usedLng, a), g) {
        const x = t.match(this.interpolator.nestingRegexp), E = x && x.length;
        b < E && (a.nest = !1);
      }
      !a.lng && this.options.compatibilityAPI !== "v1" && i && i.res && (a.lng = this.language || i.usedLng), a.nest !== !1 && (t = this.interpolator.nest(t, function() {
        for (var x = arguments.length, E = new Array(x), P = 0; P < x; P++)
          E[P] = arguments[P];
        return c && c[0] === E[0] && !a.context ? (d.logger.warn(`It seems you are nesting recursively key: ${E[0]} in key: ${r[0]}`), null) : d.translate(...E, r);
      }, a)), a.interpolation && this.interpolator.reset();
    }
    const f = a.postProcess || this.options.postProcess, p = Aa(f) ? [f] : f;
    return t != null && p && p.length && a.applyPostProcessor !== !1 && (t = Xoe.handle(p, t, r, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...i,
        usedParams: this.getUsedParamsDetails(a)
      },
      ...a
    } : a, this)), t;
  }
  resolve(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a, i, c, d, f;
    return Aa(t) && (t = [t]), t.forEach((p) => {
      if (this.isValidLookup(a)) return;
      const g = this.extractFromKey(p, r), b = g.key;
      i = b;
      let w = g.namespaces;
      this.options.fallbackNS && (w = w.concat(this.options.fallbackNS));
      const x = r.count !== void 0 && !Aa(r.count), E = x && !r.ordinal && r.count === 0 && this.pluralResolver.shouldUseIntlApi(), P = r.context !== void 0 && (Aa(r.context) || typeof r.context == "number") && r.context !== "", k = r.lngs ? r.lngs : this.languageUtils.toResolveHierarchy(r.lng || this.language, r.fallbackLng);
      w.forEach((M) => {
        this.isValidLookup(a) || (f = M, !VX[`${k[0]}-${M}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(f) && (VX[`${k[0]}-${M}`] = !0, this.logger.warn(`key "${i}" for languages "${k.join(", ")}" won't get resolved as namespace "${f}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), k.forEach((T) => {
          if (this.isValidLookup(a)) return;
          d = T;
          const N = [b];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(N, b, T, M, r);
          else {
            let $;
            x && ($ = this.pluralResolver.getSuffix(T, r.count, r));
            const j = `${this.options.pluralSeparator}zero`, I = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (x && (N.push(b + $), r.ordinal && $.indexOf(I) === 0 && N.push(b + $.replace(I, this.options.pluralSeparator)), E && N.push(b + j)), P) {
              const L = `${b}${this.options.contextSeparator}${r.context}`;
              N.push(L), x && (N.push(L + $), r.ordinal && $.indexOf(I) === 0 && N.push(L + $.replace(I, this.options.pluralSeparator)), E && N.push(L + j));
            }
          }
          let D;
          for (; D = N.pop(); )
            this.isValidLookup(a) || (c = D, a = this.getResource(T, M, D, r));
        }));
      });
    }), {
      res: a,
      usedKey: i,
      exactUsedKey: c,
      usedLng: d,
      usedNS: f
    };
  }
  isValidLookup(t) {
    return t !== void 0 && !(!this.options.returnNull && t === null) && !(!this.options.returnEmptyString && t === "");
  }
  getResource(t, r, a) {
    let i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(t, r, a, i) : this.resourceStore.getResource(t, r, a, i);
  }
  getUsedParamsDetails() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const r = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], a = t.replace && !Aa(t.replace);
    let i = a ? t.replace : t;
    if (a && typeof t.count < "u" && (i.count = t.count), this.options.interpolation.defaultVariables && (i = {
      ...this.options.interpolation.defaultVariables,
      ...i
    }), !a) {
      i = {
        ...i
      };
      for (const c of r)
        delete i[c];
    }
    return i;
  }
  static hasDefaultValue(t) {
    const r = "defaultValue";
    for (const a in t)
      if (Object.prototype.hasOwnProperty.call(t, a) && r === a.substring(0, r.length) && t[a] !== void 0)
        return !0;
    return !1;
  }
}
const cN = (e) => e.charAt(0).toUpperCase() + e.slice(1);
class _X {
  constructor(t) {
    this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = cb.create("languageUtils");
  }
  getScriptPartFromCode(t) {
    if (t = x9(t), !t || t.indexOf("-") < 0) return null;
    const r = t.split("-");
    return r.length === 2 || (r.pop(), r[r.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(r.join("-"));
  }
  getLanguagePartFromCode(t) {
    if (t = x9(t), !t || t.indexOf("-") < 0) return t;
    const r = t.split("-");
    return this.formatLanguageCode(r[0]);
  }
  formatLanguageCode(t) {
    if (Aa(t) && t.indexOf("-") > -1) {
      if (typeof Intl < "u" && typeof Intl.getCanonicalLocales < "u")
        try {
          let i = Intl.getCanonicalLocales(t)[0];
          if (i && this.options.lowerCaseLng && (i = i.toLowerCase()), i) return i;
        } catch {
        }
      const r = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let a = t.split("-");
      return this.options.lowerCaseLng ? a = a.map((i) => i.toLowerCase()) : a.length === 2 ? (a[0] = a[0].toLowerCase(), a[1] = a[1].toUpperCase(), r.indexOf(a[1].toLowerCase()) > -1 && (a[1] = cN(a[1].toLowerCase()))) : a.length === 3 && (a[0] = a[0].toLowerCase(), a[1].length === 2 && (a[1] = a[1].toUpperCase()), a[0] !== "sgn" && a[2].length === 2 && (a[2] = a[2].toUpperCase()), r.indexOf(a[1].toLowerCase()) > -1 && (a[1] = cN(a[1].toLowerCase())), r.indexOf(a[2].toLowerCase()) > -1 && (a[2] = cN(a[2].toLowerCase()))), a.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? t.toLowerCase() : t;
  }
  isSupportedCode(t) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (t = this.getLanguagePartFromCode(t)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(t) > -1;
  }
  getBestMatchFromCodes(t) {
    if (!t) return null;
    let r;
    return t.forEach((a) => {
      if (r) return;
      const i = this.formatLanguageCode(a);
      (!this.options.supportedLngs || this.isSupportedCode(i)) && (r = i);
    }), !r && this.options.supportedLngs && t.forEach((a) => {
      if (r) return;
      const i = this.getLanguagePartFromCode(a);
      if (this.isSupportedCode(i)) return r = i;
      r = this.options.supportedLngs.find((c) => {
        if (c === i) return c;
        if (!(c.indexOf("-") < 0 && i.indexOf("-") < 0) && (c.indexOf("-") > 0 && i.indexOf("-") < 0 && c.substring(0, c.indexOf("-")) === i || c.indexOf(i) === 0 && i.length > 1))
          return c;
      });
    }), r || (r = this.getFallbackCodes(this.options.fallbackLng)[0]), r;
  }
  getFallbackCodes(t, r) {
    if (!t) return [];
    if (typeof t == "function" && (t = t(r)), Aa(t) && (t = [t]), Array.isArray(t)) return t;
    if (!r) return t.default || [];
    let a = t[r];
    return a || (a = t[this.getScriptPartFromCode(r)]), a || (a = t[this.formatLanguageCode(r)]), a || (a = t[this.getLanguagePartFromCode(r)]), a || (a = t.default), a || [];
  }
  toResolveHierarchy(t, r) {
    const a = this.getFallbackCodes(r || this.options.fallbackLng || [], t), i = [], c = (d) => {
      d && (this.isSupportedCode(d) ? i.push(d) : this.logger.warn(`rejecting language code not found in supportedLngs: ${d}`));
    };
    return Aa(t) && (t.indexOf("-") > -1 || t.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && c(this.formatLanguageCode(t)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && c(this.getScriptPartFromCode(t)), this.options.load !== "currentOnly" && c(this.getLanguagePartFromCode(t))) : Aa(t) && c(this.formatLanguageCode(t)), a.forEach((d) => {
      i.indexOf(d) < 0 && c(this.formatLanguageCode(d));
    }), i;
  }
}
let G7t = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], q7t = {
  1: (e) => +(e > 1),
  2: (e) => +(e != 1),
  3: (e) => 0,
  4: (e) => e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
  5: (e) => e == 0 ? 0 : e == 1 ? 1 : e == 2 ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5,
  6: (e) => e == 1 ? 0 : e >= 2 && e <= 4 ? 1 : 2,
  7: (e) => e == 1 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
  8: (e) => e == 1 ? 0 : e == 2 ? 1 : e != 8 && e != 11 ? 2 : 3,
  9: (e) => +(e >= 2),
  10: (e) => e == 1 ? 0 : e == 2 ? 1 : e < 7 ? 2 : e < 11 ? 3 : 4,
  11: (e) => e == 1 || e == 11 ? 0 : e == 2 || e == 12 ? 1 : e > 2 && e < 20 ? 2 : 3,
  12: (e) => +(e % 10 != 1 || e % 100 == 11),
  13: (e) => +(e !== 0),
  14: (e) => e == 1 ? 0 : e == 2 ? 1 : e == 3 ? 2 : 3,
  15: (e) => e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
  16: (e) => e % 10 == 1 && e % 100 != 11 ? 0 : e !== 0 ? 1 : 2,
  17: (e) => e == 1 || e % 10 == 1 && e % 100 != 11 ? 0 : 1,
  18: (e) => e == 0 ? 0 : e == 1 ? 1 : 2,
  19: (e) => e == 1 ? 0 : e == 0 || e % 100 > 1 && e % 100 < 11 ? 1 : e % 100 > 10 && e % 100 < 20 ? 2 : 3,
  20: (e) => e == 1 ? 0 : e == 0 || e % 100 > 0 && e % 100 < 20 ? 1 : 2,
  21: (e) => e % 100 == 1 ? 1 : e % 100 == 2 ? 2 : e % 100 == 3 || e % 100 == 4 ? 3 : 0,
  22: (e) => e == 1 ? 0 : e == 2 ? 1 : (e < 0 || e > 10) && e % 10 == 0 ? 2 : 3
};
const K7t = ["v1", "v2", "v3"], Y7t = ["v4"], BX = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, Q7t = () => {
  const e = {};
  return G7t.forEach((t) => {
    t.lngs.forEach((r) => {
      e[r] = {
        numbers: t.nr,
        plurals: q7t[t.fc]
      };
    });
  }), e;
};
class J7t {
  constructor(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = t, this.options = r, this.logger = cb.create("pluralResolver"), (!this.options.compatibilityJSON || Y7t.includes(this.options.compatibilityJSON)) && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = Q7t(), this.pluralRulesCache = {};
  }
  addRule(t, r) {
    this.rules[t] = r;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi()) {
      const a = x9(t === "dev" ? "en" : t), i = r.ordinal ? "ordinal" : "cardinal", c = JSON.stringify({
        cleanedCode: a,
        type: i
      });
      if (c in this.pluralRulesCache)
        return this.pluralRulesCache[c];
      let d;
      try {
        d = new Intl.PluralRules(a, {
          type: i
        });
      } catch {
        if (!t.match(/-|_/)) return;
        const p = this.languageUtils.getLanguagePartFromCode(t);
        d = this.getRule(p, r);
      }
      return this.pluralRulesCache[c] = d, d;
    }
    return this.rules[t] || this.rules[this.languageUtils.getLanguagePartFromCode(t)];
  }
  needsPlural(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const a = this.getRule(t, r);
    return this.shouldUseIntlApi() ? a && a.resolvedOptions().pluralCategories.length > 1 : a && a.numbers.length > 1;
  }
  getPluralFormsOfKey(t, r) {
    let a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(t, a).map((i) => `${r}${i}`);
  }
  getSuffixes(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const a = this.getRule(t, r);
    return a ? this.shouldUseIntlApi() ? a.resolvedOptions().pluralCategories.sort((i, c) => BX[i] - BX[c]).map((i) => `${this.options.prepend}${r.ordinal ? `ordinal${this.options.prepend}` : ""}${i}`) : a.numbers.map((i) => this.getSuffix(t, i, r)) : [];
  }
  getSuffix(t, r) {
    let a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const i = this.getRule(t, a);
    return i ? this.shouldUseIntlApi() ? `${this.options.prepend}${a.ordinal ? `ordinal${this.options.prepend}` : ""}${i.select(r)}` : this.getSuffixRetroCompatible(i, r) : (this.logger.warn(`no plural rule found for: ${t}`), "");
  }
  getSuffixRetroCompatible(t, r) {
    const a = t.noAbs ? t.plurals(r) : t.plurals(Math.abs(r));
    let i = t.numbers[a];
    this.options.simplifyPluralSuffix && t.numbers.length === 2 && t.numbers[0] === 1 && (i === 2 ? i = "plural" : i === 1 && (i = ""));
    const c = () => this.options.prepend && i.toString() ? this.options.prepend + i.toString() : i.toString();
    return this.options.compatibilityJSON === "v1" ? i === 1 ? "" : typeof i == "number" ? `_plural_${i.toString()}` : c() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && t.numbers.length === 2 && t.numbers[0] === 1 ? c() : this.options.prepend && a.toString() ? this.options.prepend + a.toString() : a.toString();
  }
  shouldUseIntlApi() {
    return !K7t.includes(this.options.compatibilityJSON);
  }
}
const UX = function(e, t, r) {
  let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, c = H7t(e, t, r);
  return !c && i && Aa(r) && (c = sz(e, r, a), c === void 0 && (c = sz(t, r, a))), c;
}, dN = (e) => e.replace(/\$/g, "$$$$");
class Z7t {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = cb.create("interpolator"), this.options = t, this.format = t.interpolation && t.interpolation.format || ((r) => r), this.init(t);
  }
  init() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    t.interpolation || (t.interpolation = {
      escapeValue: !0
    });
    const {
      escape: r,
      escapeValue: a,
      useRawValueToEscape: i,
      prefix: c,
      prefixEscaped: d,
      suffix: f,
      suffixEscaped: p,
      formatSeparator: g,
      unescapeSuffix: b,
      unescapePrefix: w,
      nestingPrefix: x,
      nestingPrefixEscaped: E,
      nestingSuffix: P,
      nestingSuffixEscaped: k,
      nestingOptionsSeparator: M,
      maxReplaces: T,
      alwaysFormat: N
    } = t.interpolation;
    this.escape = r !== void 0 ? r : W7t, this.escapeValue = a !== void 0 ? a : !0, this.useRawValueToEscape = i !== void 0 ? i : !1, this.prefix = c ? W3(c) : d || "{{", this.suffix = f ? W3(f) : p || "}}", this.formatSeparator = g || ",", this.unescapePrefix = b ? "" : w || "-", this.unescapeSuffix = this.unescapePrefix ? "" : b || "", this.nestingPrefix = x ? W3(x) : E || W3("$t("), this.nestingSuffix = P ? W3(P) : k || W3(")"), this.nestingOptionsSeparator = M || ",", this.maxReplaces = T || 1e3, this.alwaysFormat = N !== void 0 ? N : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const t = (r, a) => r && r.source === a ? (r.lastIndex = 0, r) : new RegExp(a, "g");
    this.regexp = t(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = t(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = t(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(t, r, a, i) {
    let c, d, f;
    const p = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, g = (E) => {
      if (E.indexOf(this.formatSeparator) < 0) {
        const T = UX(r, p, E, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(T, void 0, a, {
          ...i,
          ...r,
          interpolationkey: E
        }) : T;
      }
      const P = E.split(this.formatSeparator), k = P.shift().trim(), M = P.join(this.formatSeparator).trim();
      return this.format(UX(r, p, k, this.options.keySeparator, this.options.ignoreJSONStructure), M, a, {
        ...i,
        ...r,
        interpolationkey: k
      });
    };
    this.resetRegExp();
    const b = i && i.missingInterpolationHandler || this.options.missingInterpolationHandler, w = i && i.interpolation && i.interpolation.skipOnVariables !== void 0 ? i.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (E) => dN(E)
    }, {
      regex: this.regexp,
      safeValue: (E) => this.escapeValue ? dN(this.escape(E)) : dN(E)
    }].forEach((E) => {
      for (f = 0; c = E.regex.exec(t); ) {
        const P = c[1].trim();
        if (d = g(P), d === void 0)
          if (typeof b == "function") {
            const M = b(t, c, i);
            d = Aa(M) ? M : "";
          } else if (i && Object.prototype.hasOwnProperty.call(i, P))
            d = "";
          else if (w) {
            d = c[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${P} for interpolating ${t}`), d = "";
        else !Aa(d) && !this.useRawValueToEscape && (d = IX(d));
        const k = E.safeValue(d);
        if (t = t.replace(c[0], k), w ? (E.regex.lastIndex += d.length, E.regex.lastIndex -= c[0].length) : E.regex.lastIndex = 0, f++, f >= this.maxReplaces)
          break;
      }
    }), t;
  }
  nest(t, r) {
    let a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i, c, d;
    const f = (p, g) => {
      const b = this.nestingOptionsSeparator;
      if (p.indexOf(b) < 0) return p;
      const w = p.split(new RegExp(`${b}[ ]*{`));
      let x = `{${w[1]}`;
      p = w[0], x = this.interpolate(x, d);
      const E = x.match(/'/g), P = x.match(/"/g);
      (E && E.length % 2 === 0 && !P || P.length % 2 !== 0) && (x = x.replace(/'/g, '"'));
      try {
        d = JSON.parse(x), g && (d = {
          ...g,
          ...d
        });
      } catch (k) {
        return this.logger.warn(`failed parsing options string in nesting for key ${p}`, k), `${p}${b}${x}`;
      }
      return d.defaultValue && d.defaultValue.indexOf(this.prefix) > -1 && delete d.defaultValue, p;
    };
    for (; i = this.nestingRegexp.exec(t); ) {
      let p = [];
      d = {
        ...a
      }, d = d.replace && !Aa(d.replace) ? d.replace : d, d.applyPostProcessor = !1, delete d.defaultValue;
      let g = !1;
      if (i[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(i[1])) {
        const b = i[1].split(this.formatSeparator).map((w) => w.trim());
        i[1] = b.shift(), p = b, g = !0;
      }
      if (c = r(f.call(this, i[1].trim(), d), d), c && i[0] === t && !Aa(c)) return c;
      Aa(c) || (c = IX(c)), c || (this.logger.warn(`missed to resolve ${i[1]} for nesting ${t}`), c = ""), g && (c = p.reduce((b, w) => this.format(b, w, a.lng, {
        ...a,
        interpolationkey: i[1].trim()
      }), c.trim())), t = t.replace(i[0], c), this.regexp.lastIndex = 0;
    }
    return t;
  }
}
const ePt = (e) => {
  let t = e.toLowerCase().trim();
  const r = {};
  if (e.indexOf("(") > -1) {
    const a = e.split("(");
    t = a[0].toLowerCase().trim();
    const i = a[1].substring(0, a[1].length - 1);
    t === "currency" && i.indexOf(":") < 0 ? r.currency || (r.currency = i.trim()) : t === "relativetime" && i.indexOf(":") < 0 ? r.range || (r.range = i.trim()) : i.split(";").forEach((d) => {
      if (d) {
        const [f, ...p] = d.split(":"), g = p.join(":").trim().replace(/^'+|'+$/g, ""), b = f.trim();
        r[b] || (r[b] = g), g === "false" && (r[b] = !1), g === "true" && (r[b] = !0), isNaN(g) || (r[b] = parseInt(g, 10));
      }
    });
  }
  return {
    formatName: t,
    formatOptions: r
  };
}, V3 = (e) => {
  const t = {};
  return (r, a, i) => {
    let c = i;
    i && i.interpolationkey && i.formatParams && i.formatParams[i.interpolationkey] && i[i.interpolationkey] && (c = {
      ...c,
      [i.interpolationkey]: void 0
    });
    const d = a + JSON.stringify(c);
    let f = t[d];
    return f || (f = e(x9(a), i), t[d] = f), f(r);
  };
};
class tPt {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = cb.create("formatter"), this.options = t, this.formats = {
      number: V3((r, a) => {
        const i = new Intl.NumberFormat(r, {
          ...a
        });
        return (c) => i.format(c);
      }),
      currency: V3((r, a) => {
        const i = new Intl.NumberFormat(r, {
          ...a,
          style: "currency"
        });
        return (c) => i.format(c);
      }),
      datetime: V3((r, a) => {
        const i = new Intl.DateTimeFormat(r, {
          ...a
        });
        return (c) => i.format(c);
      }),
      relativetime: V3((r, a) => {
        const i = new Intl.RelativeTimeFormat(r, {
          ...a
        });
        return (c) => i.format(c, a.range || "day");
      }),
      list: V3((r, a) => {
        const i = new Intl.ListFormat(r, {
          ...a
        });
        return (c) => i.format(c);
      })
    }, this.init(t);
  }
  init(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    this.formatSeparator = r.interpolation.formatSeparator || ",";
  }
  add(t, r) {
    this.formats[t.toLowerCase().trim()] = r;
  }
  addCached(t, r) {
    this.formats[t.toLowerCase().trim()] = V3(r);
  }
  format(t, r, a) {
    let i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const c = r.split(this.formatSeparator);
    if (c.length > 1 && c[0].indexOf("(") > 1 && c[0].indexOf(")") < 0 && c.find((f) => f.indexOf(")") > -1)) {
      const f = c.findIndex((p) => p.indexOf(")") > -1);
      c[0] = [c[0], ...c.splice(1, f)].join(this.formatSeparator);
    }
    return c.reduce((f, p) => {
      const {
        formatName: g,
        formatOptions: b
      } = ePt(p);
      if (this.formats[g]) {
        let w = f;
        try {
          const x = i && i.formatParams && i.formatParams[i.interpolationkey] || {}, E = x.locale || x.lng || i.locale || i.lng || a;
          w = this.formats[g](f, E, {
            ...b,
            ...i,
            ...x
          });
        } catch (x) {
          this.logger.warn(x);
        }
        return w;
      } else
        this.logger.warn(`there was no format function for ${g}`);
      return f;
    }, t);
  }
}
const nPt = (e, t) => {
  e.pending[t] !== void 0 && (delete e.pending[t], e.pendingCount--);
};
class rPt extends oO {
  constructor(t, r, a) {
    let i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = t, this.store = r, this.services = a, this.languageUtils = a.languageUtils, this.options = i, this.logger = cb.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = i.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = i.maxRetries >= 0 ? i.maxRetries : 5, this.retryTimeout = i.retryTimeout >= 1 ? i.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(a, i.backend, i);
  }
  queueLoad(t, r, a, i) {
    const c = {}, d = {}, f = {}, p = {};
    return t.forEach((g) => {
      let b = !0;
      r.forEach((w) => {
        const x = `${g}|${w}`;
        !a.reload && this.store.hasResourceBundle(g, w) ? this.state[x] = 2 : this.state[x] < 0 || (this.state[x] === 1 ? d[x] === void 0 && (d[x] = !0) : (this.state[x] = 1, b = !1, d[x] === void 0 && (d[x] = !0), c[x] === void 0 && (c[x] = !0), p[w] === void 0 && (p[w] = !0)));
      }), b || (f[g] = !0);
    }), (Object.keys(c).length || Object.keys(d).length) && this.queue.push({
      pending: d,
      pendingCount: Object.keys(d).length,
      loaded: {},
      errors: [],
      callback: i
    }), {
      toLoad: Object.keys(c),
      pending: Object.keys(d),
      toLoadLanguages: Object.keys(f),
      toLoadNamespaces: Object.keys(p)
    };
  }
  loaded(t, r, a) {
    const i = t.split("|"), c = i[0], d = i[1];
    r && this.emit("failedLoading", c, d, r), !r && a && this.store.addResourceBundle(c, d, a, void 0, void 0, {
      skipCopy: !0
    }), this.state[t] = r ? -1 : 2, r && a && (this.state[t] = 0);
    const f = {};
    this.queue.forEach((p) => {
      L7t(p.loaded, [c], d), nPt(p, t), r && p.errors.push(r), p.pendingCount === 0 && !p.done && (Object.keys(p.loaded).forEach((g) => {
        f[g] || (f[g] = {});
        const b = p.loaded[g];
        b.length && b.forEach((w) => {
          f[g][w] === void 0 && (f[g][w] = !0);
        });
      }), p.done = !0, p.errors.length ? p.callback(p.errors) : p.callback());
    }), this.emit("loaded", f), this.queue = this.queue.filter((p) => !p.done);
  }
  read(t, r, a) {
    let i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, c = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, d = arguments.length > 5 ? arguments[5] : void 0;
    if (!t.length) return d(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: t,
        ns: r,
        fcName: a,
        tried: i,
        wait: c,
        callback: d
      });
      return;
    }
    this.readingCalls++;
    const f = (g, b) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const w = this.waitingReads.shift();
        this.read(w.lng, w.ns, w.fcName, w.tried, w.wait, w.callback);
      }
      if (g && b && i < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, t, r, a, i + 1, c * 2, d);
        }, c);
        return;
      }
      d(g, b);
    }, p = this.backend[a].bind(this.backend);
    if (p.length === 2) {
      try {
        const g = p(t, r);
        g && typeof g.then == "function" ? g.then((b) => f(null, b)).catch(f) : f(null, g);
      } catch (g) {
        f(g);
      }
      return;
    }
    return p(t, r, f);
  }
  prepareLoading(t, r) {
    let a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), i && i();
    Aa(t) && (t = this.languageUtils.toResolveHierarchy(t)), Aa(r) && (r = [r]);
    const c = this.queueLoad(t, r, a, i);
    if (!c.toLoad.length)
      return c.pending.length || i(), null;
    c.toLoad.forEach((d) => {
      this.loadOne(d);
    });
  }
  load(t, r, a) {
    this.prepareLoading(t, r, {}, a);
  }
  reload(t, r, a) {
    this.prepareLoading(t, r, {
      reload: !0
    }, a);
  }
  loadOne(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const a = t.split("|"), i = a[0], c = a[1];
    this.read(i, c, "read", void 0, void 0, (d, f) => {
      d && this.logger.warn(`${r}loading namespace ${c} for language ${i} failed`, d), !d && f && this.logger.log(`${r}loaded namespace ${c} for language ${i}`, f), this.loaded(t, d, f);
    });
  }
  saveMissing(t, r, a, i, c) {
    let d = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, f = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(r)) {
      this.logger.warn(`did not save key "${a}" as the namespace "${r}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(a == null || a === "")) {
      if (this.backend && this.backend.create) {
        const p = {
          ...d,
          isUpdate: c
        }, g = this.backend.create.bind(this.backend);
        if (g.length < 6)
          try {
            let b;
            g.length === 5 ? b = g(t, r, a, i, p) : b = g(t, r, a, i), b && typeof b.then == "function" ? b.then((w) => f(null, w)).catch(f) : f(null, b);
          } catch (b) {
            f(b);
          }
        else
          g(t, r, a, i, f, p);
      }
      !t || !t[0] || this.store.addResource(t[0], r, a, i);
    }
  }
}
const XX = () => ({
  debug: !1,
  initImmediate: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (e) => {
    let t = {};
    if (typeof e[1] == "object" && (t = e[1]), Aa(e[1]) && (t.defaultValue = e[1]), Aa(e[2]) && (t.tDescription = e[2]), typeof e[2] == "object" || typeof e[3] == "object") {
      const r = e[3] || e[2];
      Object.keys(r).forEach((a) => {
        t[a] = r[a];
      });
    }
    return t;
  },
  interpolation: {
    escapeValue: !0,
    format: (e) => e,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  }
}), GX = (e) => (Aa(e.ns) && (e.ns = [e.ns]), Aa(e.fallbackLng) && (e.fallbackLng = [e.fallbackLng]), Aa(e.fallbackNS) && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs && e.supportedLngs.indexOf("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), e), FP = () => {
}, aPt = (e) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach((r) => {
    typeof e[r] == "function" && (e[r] = e[r].bind(e));
  });
};
class FE extends oO {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = GX(t), this.services = {}, this.logger = cb, this.modules = {
      external: []
    }, aPt(this), r && !this.isInitialized && !t.isClone) {
      if (!this.options.initImmediate)
        return this.init(t, r), this;
      setTimeout(() => {
        this.init(t, r);
      }, 0);
    }
  }
  init() {
    var t = this;
    let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof r == "function" && (a = r, r = {}), !r.defaultNS && r.defaultNS !== !1 && r.ns && (Aa(r.ns) ? r.defaultNS = r.ns : r.ns.indexOf("translation") < 0 && (r.defaultNS = r.ns[0]));
    const i = XX();
    this.options = {
      ...i,
      ...this.options,
      ...GX(r)
    }, this.options.compatibilityAPI !== "v1" && (this.options.interpolation = {
      ...i.interpolation,
      ...this.options.interpolation
    }), r.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = r.keySeparator), r.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = r.nsSeparator);
    const c = (b) => b ? typeof b == "function" ? new b() : b : null;
    if (!this.options.isClone) {
      this.modules.logger ? cb.init(c(this.modules.logger), this.options) : cb.init(null, this.options);
      let b;
      this.modules.formatter ? b = this.modules.formatter : typeof Intl < "u" && (b = tPt);
      const w = new _X(this.options);
      this.store = new WX(this.options.resources, this.options);
      const x = this.services;
      x.logger = cb, x.resourceStore = this.store, x.languageUtils = w, x.pluralResolver = new J7t(w, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), b && (!this.options.interpolation.format || this.options.interpolation.format === i.interpolation.format) && (x.formatter = c(b), x.formatter.init(x, this.options), this.options.interpolation.format = x.formatter.format.bind(x.formatter)), x.interpolator = new Z7t(this.options), x.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, x.backendConnector = new rPt(c(this.modules.backend), x.resourceStore, x, this.options), x.backendConnector.on("*", function(E) {
        for (var P = arguments.length, k = new Array(P > 1 ? P - 1 : 0), M = 1; M < P; M++)
          k[M - 1] = arguments[M];
        t.emit(E, ...k);
      }), this.modules.languageDetector && (x.languageDetector = c(this.modules.languageDetector), x.languageDetector.init && x.languageDetector.init(x, this.options.detection, this.options)), this.modules.i18nFormat && (x.i18nFormat = c(this.modules.i18nFormat), x.i18nFormat.init && x.i18nFormat.init(this)), this.translator = new P9(this.services, this.options), this.translator.on("*", function(E) {
        for (var P = arguments.length, k = new Array(P > 1 ? P - 1 : 0), M = 1; M < P; M++)
          k[M - 1] = arguments[M];
        t.emit(E, ...k);
      }), this.modules.external.forEach((E) => {
        E.init && E.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, a || (a = FP), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const b = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      b.length > 0 && b[0] !== "dev" && (this.options.lng = b[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((b) => {
      this[b] = function() {
        return t.store[b](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((b) => {
      this[b] = function() {
        return t.store[b](...arguments), t;
      };
    });
    const p = Z5(), g = () => {
      const b = (w, x) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), p.resolve(x), a(w, x);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized) return b(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, b);
    };
    return this.options.resources || !this.options.initImmediate ? g() : setTimeout(g, 0), p;
  }
  loadResources(t) {
    let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : FP;
    const i = Aa(t) ? t : this.language;
    if (typeof t == "function" && (a = t), !this.options.resources || this.options.partialBundledLanguages) {
      if (i && i.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return a();
      const c = [], d = (f) => {
        if (!f || f === "cimode") return;
        this.services.languageUtils.toResolveHierarchy(f).forEach((g) => {
          g !== "cimode" && c.indexOf(g) < 0 && c.push(g);
        });
      };
      i ? d(i) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((p) => d(p)), this.options.preload && this.options.preload.forEach((f) => d(f)), this.services.backendConnector.load(c, this.options.ns, (f) => {
        !f && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), a(f);
      });
    } else
      a(null);
  }
  reloadResources(t, r, a) {
    const i = Z5();
    return typeof t == "function" && (a = t, t = void 0), typeof r == "function" && (a = r, r = void 0), t || (t = this.languages), r || (r = this.options.ns), a || (a = FP), this.services.backendConnector.reload(t, r, (c) => {
      i.resolve(), a(c);
    }), i;
  }
  use(t) {
    if (!t) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!t.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return t.type === "backend" && (this.modules.backend = t), (t.type === "logger" || t.log && t.warn && t.error) && (this.modules.logger = t), t.type === "languageDetector" && (this.modules.languageDetector = t), t.type === "i18nFormat" && (this.modules.i18nFormat = t), t.type === "postProcessor" && Xoe.addPostProcessor(t), t.type === "formatter" && (this.modules.formatter = t), t.type === "3rdParty" && this.modules.external.push(t), this;
  }
  setResolvedLanguage(t) {
    if (!(!t || !this.languages) && !(["cimode", "dev"].indexOf(t) > -1))
      for (let r = 0; r < this.languages.length; r++) {
        const a = this.languages[r];
        if (!(["cimode", "dev"].indexOf(a) > -1) && this.store.hasLanguageSomeTranslations(a)) {
          this.resolvedLanguage = a;
          break;
        }
      }
  }
  changeLanguage(t, r) {
    var a = this;
    this.isLanguageChangingTo = t;
    const i = Z5();
    this.emit("languageChanging", t);
    const c = (p) => {
      this.language = p, this.languages = this.services.languageUtils.toResolveHierarchy(p), this.resolvedLanguage = void 0, this.setResolvedLanguage(p);
    }, d = (p, g) => {
      g ? (c(g), this.translator.changeLanguage(g), this.isLanguageChangingTo = void 0, this.emit("languageChanged", g), this.logger.log("languageChanged", g)) : this.isLanguageChangingTo = void 0, i.resolve(function() {
        return a.t(...arguments);
      }), r && r(p, function() {
        return a.t(...arguments);
      });
    }, f = (p) => {
      !t && !p && this.services.languageDetector && (p = []);
      const g = Aa(p) ? p : this.services.languageUtils.getBestMatchFromCodes(p);
      g && (this.language || c(g), this.translator.language || this.translator.changeLanguage(g), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(g)), this.loadResources(g, (b) => {
        d(b, g);
      });
    };
    return !t && this.services.languageDetector && !this.services.languageDetector.async ? f(this.services.languageDetector.detect()) : !t && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(f) : this.services.languageDetector.detect(f) : f(t), i;
  }
  getFixedT(t, r, a) {
    var i = this;
    const c = function(d, f) {
      let p;
      if (typeof f != "object") {
        for (var g = arguments.length, b = new Array(g > 2 ? g - 2 : 0), w = 2; w < g; w++)
          b[w - 2] = arguments[w];
        p = i.options.overloadTranslationOptionHandler([d, f].concat(b));
      } else
        p = {
          ...f
        };
      p.lng = p.lng || c.lng, p.lngs = p.lngs || c.lngs, p.ns = p.ns || c.ns, p.keyPrefix !== "" && (p.keyPrefix = p.keyPrefix || a || c.keyPrefix);
      const x = i.options.keySeparator || ".";
      let E;
      return p.keyPrefix && Array.isArray(d) ? E = d.map((P) => `${p.keyPrefix}${x}${P}`) : E = p.keyPrefix ? `${p.keyPrefix}${x}${d}` : d, i.t(E, p);
    };
    return Aa(t) ? c.lng = t : c.lngs = t, c.ns = r, c.keyPrefix = a, c;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(t) {
    this.options.defaultNS = t;
  }
  hasLoadedNamespace(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const a = r.lng || this.resolvedLanguage || this.languages[0], i = this.options ? this.options.fallbackLng : !1, c = this.languages[this.languages.length - 1];
    if (a.toLowerCase() === "cimode") return !0;
    const d = (f, p) => {
      const g = this.services.backendConnector.state[`${f}|${p}`];
      return g === -1 || g === 0 || g === 2;
    };
    if (r.precheck) {
      const f = r.precheck(this, d);
      if (f !== void 0) return f;
    }
    return !!(this.hasResourceBundle(a, t) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || d(a, t) && (!i || d(c, t)));
  }
  loadNamespaces(t, r) {
    const a = Z5();
    return this.options.ns ? (Aa(t) && (t = [t]), t.forEach((i) => {
      this.options.ns.indexOf(i) < 0 && this.options.ns.push(i);
    }), this.loadResources((i) => {
      a.resolve(), r && r(i);
    }), a) : (r && r(), Promise.resolve());
  }
  loadLanguages(t, r) {
    const a = Z5();
    Aa(t) && (t = [t]);
    const i = this.options.preload || [], c = t.filter((d) => i.indexOf(d) < 0 && this.services.languageUtils.isSupportedCode(d));
    return c.length ? (this.options.preload = i.concat(c), this.loadResources((d) => {
      a.resolve(), r && r(d);
    }), a) : (r && r(), Promise.resolve());
  }
  dir(t) {
    if (t || (t = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !t) return "rtl";
    const r = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], a = this.services && this.services.languageUtils || new _X(XX());
    return r.indexOf(a.getLanguagePartFromCode(t)) > -1 || t.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    return new FE(t, r);
  }
  cloneInstance() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : FP;
    const a = t.forkResourceStore;
    a && delete t.forkResourceStore;
    const i = {
      ...this.options,
      ...t,
      isClone: !0
    }, c = new FE(i);
    return (t.debug !== void 0 || t.prefix !== void 0) && (c.logger = c.logger.clone(t)), ["store", "services", "language"].forEach((f) => {
      c[f] = this[f];
    }), c.services = {
      ...this.services
    }, c.services.utils = {
      hasLoadedNamespace: c.hasLoadedNamespace.bind(c)
    }, a && (c.store = new WX(this.store.data, i), c.services.resourceStore = c.store), c.translator = new P9(c.services, i), c.translator.on("*", function(f) {
      for (var p = arguments.length, g = new Array(p > 1 ? p - 1 : 0), b = 1; b < p; b++)
        g[b - 1] = arguments[b];
      c.emit(f, ...g);
    }), c.init(i, r), c.translator.options = i, c.translator.backendConnector.services.utils = {
      hasLoadedNamespace: c.hasLoadedNamespace.bind(c)
    }, c;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const Jh = FE.createInstance();
Jh.createInstance = FE.createInstance;
Jh.createInstance;
Jh.dir;
Jh.init;
Jh.loadResources;
Jh.reloadResources;
Jh.use;
Jh.changeLanguage;
Jh.getFixedT;
const Goe = Jh.t;
Jh.exists;
Jh.setDefaultNamespace;
Jh.hasLoadedNamespace;
Jh.loadNamespaces;
Jh.loadLanguages;
const oPt = Goe("modal.error.footer.buttons.required"), iPt = Goe("modal.error.footer.buttons.onePrimary"), lPt = fl(
  lt("flex flex-col-reverse gap-2 p-6 pt-0 sm:flex-row sm:justify-end"),
  {
    variants: {
      theme: {
        apollo: [],
        classic: ["sm:justify-center"]
      }
    },
    defaultVariants: {
      theme: "classic"
    }
  }
);
function sPt({
  className: e,
  ...t
}) {
  const { footerButtons: r, onClose: a, testId: i, theme: c } = d6(), d = uPt(r);
  return d || /* @__PURE__ */ V.jsx(
    "footer",
    {
      "data-slot": "dialog-footer",
      "data-testid": `${i}-footer`,
      className: lt(lPt({ theme: c }), e),
      ...t,
      children: r?.map((f, p) => {
        const { closesModal: g, onClick: b, ...w } = f, x = w.id ?? w.data_testid ?? p, { data_testid: E = `${i}-footer-button-${x}` } = f, P = g ? async (k) => {
          if (b) {
            const M = await b(k);
            if (typeof M == "boolean" && M === !1)
              return;
          }
          a();
        } : b;
        return /* @__PURE__ */ V.jsx(
          Qw,
          {
            "data-slot": "dialog-footer-button",
            "data-testid": E,
            ...w,
            onClick: P
          },
          x
        );
      })
    }
  );
}
function uPt(e) {
  if (!e)
    return oPt;
  if (e.filter(({ kind: r }) => r === "primary").length > 1)
    return iPt;
}
function cPt({
  className: e,
  ...t
}) {
  const { testId: r } = d6();
  return /* @__PURE__ */ V.jsx(
    Vxt,
    {
      "data-slot": "dialog-title",
      "data-testid": `${r}-title`,
      className: lt("m-0 text-lg font-semibold leading-none", e),
      ...t
    }
  );
}
const dPt = fl(
  lt("flex flex-col items-start justify-between p-6 pb-0 gap-3"),
  {
    variants: {
      theme: {
        apollo: [],
        classic: ["bg-[var(--modal-header-background-color)] text-white pb-6"]
      }
    },
    defaultVariants: {
      theme: "classic"
    }
  }
), fPt = fl(
  lt(
    "cursor-pointer text-foreground hover:bg-accent hover:text-accent-foreground focus:ring-offset-background focus:ring-ring flex items-center justify-between border-0 bg-transparent"
  ),
  {
    variants: {
      theme: {
        apollo: [
          "ring-offset-background data-[state=open]:bg-accent data-[state=open]:text-muted-foreground rounded-xs focus:outline-hidden absolute right-4 top-4 opacity-70 transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 disabled:pointer-events-none [&_svg:not([class*='size-'])]:size-4 [&_svg]:pointer-events-none [&_svg]:shrink-0"
        ],
        classic: [
          "border-none focus:outline-none hover:bg-transparent text-white"
        ]
      }
    },
    defaultVariants: {
      theme: "classic"
    }
  }
), mPt = fl(lt(""), {
  variants: {
    theme: {
      apollo: [],
      classic: ["text-[var(--modal-description-color)]"]
    }
  },
  defaultVariants: {
    theme: "classic"
  }
});
function hPt({
  className: e,
  ...t
}) {
  const { closeable: r, description: a, headerTitle: i, testId: c, theme: d } = d6(), { t: f } = fi(), p = r ?? !0, g = f("modal.close");
  return /* @__PURE__ */ V.jsxs(
    "header",
    {
      "data-slot": "dialog-header",
      "data-testid": `${c}-header`,
      className: lt(dPt({ theme: d }), e),
      ...t,
      children: [
        /* @__PURE__ */ V.jsxs(
          "div",
          {
            className: lt(
              "flex w-full items-baseline justify-between sm:text-left"
            ),
            children: [
              i && /* @__PURE__ */ V.jsx(cPt, { children: i }),
              p && /* @__PURE__ */ V.jsxs(N7t, { className: lt(fPt({ theme: d })), children: [
                d === "classic" && /* @__PURE__ */ V.jsx("span", { className: "underline", children: g }),
                /* @__PURE__ */ V.jsx(gOe, {}),
                /* @__PURE__ */ V.jsx("span", { className: "sr-only", children: g })
              ] })
            ]
          }
        ),
        a && /* @__PURE__ */ V.jsx(
          z7t,
          {
            className: lt("m-0", mPt({ theme: d })),
            testId: c,
            children: a
          }
        )
      ]
    }
  );
}
function pPt({
  className: e,
  ...t
}) {
  const { testId: r } = d6();
  return /* @__PURE__ */ V.jsx(
    ZI,
    {
      "data-slot": "dialog-overlay",
      "data-testid": `${r}-overlay`,
      className: lt(
        "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/50",
        e
      ),
      ...t
    }
  );
}
const qoe = ({
  children: e,
  className: t = "",
  closeable: r = !0,
  closeOnClickOutside: a = !0,
  description: i,
  footerButtons: c,
  headerTitle: d,
  noPadding: f = !1,
  onClose: p,
  open: g,
  testId: b = `modal-${Date.now()}`,
  theme: w,
  width: x = 450
  // current width taken from CAPS step4 modal, will update in future to have different size flavours eg. small, medium, large once we discover more use cases
}) => {
  const E = Do(Kj), P = w ?? E ?? "classic", k = Cn(
    ($) => {
      $ || p && p();
    },
    [p]
  ), M = Cn(
    ($) => {
      if (!r || p && !p()) {
        $.preventDefault();
        return;
      }
    },
    [r, p]
  ), T = Cn(
    ($) => {
      if (!r || !a || p && !p()) {
        $.preventDefault();
        return;
      }
    },
    [r, a, p]
  ), N = d || r, D = c && c.length > 0;
  return /* @__PURE__ */ V.jsx(
    Boe.Provider,
    {
      value: {
        className: t,
        closeable: r,
        description: i,
        footerButtons: c,
        handleClickOutside: T,
        handleManualClose: M,
        headerTitle: d,
        onClose: p,
        testId: b,
        theme: P,
        width: x
      },
      children: /* @__PURE__ */ V.jsxs(
        Yre,
        {
          "data-slot": "dialog",
          "data-testid": b,
          modal: !0,
          onOpenChange: k,
          open: g,
          children: [
            /* @__PURE__ */ V.jsx(pPt, {}),
            /* @__PURE__ */ V.jsx("div", { style: { width: x }, children: /* @__PURE__ */ V.jsxs($7t, { children: [
              N && /* @__PURE__ */ V.jsx(hPt, {}),
              /* @__PURE__ */ V.jsx(
                "main",
                {
                  className: lt("px-6", f && "p-0"),
                  "data-testid": `${b}-body`,
                  children: e
                }
              ),
              D && /* @__PURE__ */ V.jsx(sPt, {})
            ] }) })
          ]
        }
      )
    }
  );
}, PTt = () => {
  const [e, t] = Wn(!1), [r, a] = Wn(!1), { cookie: i, removeCookie: c } = nte(tte, ""), { t: d } = fi(), { message: f, edit: p, remove: g } = mn(
    () => ({
      message: d("overrideBanner.message"),
      edit: d("overrideBanner.edit"),
      remove: d("overrideBanner.remove")
    }),
    [d]
  ), b = mn(
    () => mr("--override-editor-width"),
    []
  ), w = () => {
    c({
      path: window.location.pathname
    }), t(!0);
  }, x = () => {
    a(!0);
  }, E = () => {
    t(!0);
  }, P = (k = !1) => {
    a(!1), k && t(!0);
  };
  return /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
    i && !e && /* @__PURE__ */ V.jsx(
      dee,
      {
        actions: [
          {
            kind: "primary",
            label: g,
            onClick: w
          },
          {
            kind: "primary",
            label: p,
            onClick: x
          }
        ],
        kind: "info",
        message: f,
        onClose: E,
        topOfPage: !0
      }
    ),
    /* @__PURE__ */ V.jsx(
      qoe,
      {
        open: r,
        onClose: () => a(!1),
        width: b,
        children: /* @__PURE__ */ V.jsx(
          "div",
          {
            className: lt(
              "max-h-(--override-editor-height) max-w-(--override-editor-width) overflow-auto"
            ),
            children: /* @__PURE__ */ V.jsx(PPt, { isOverridePage: !1, onDone: P })
          }
        )
      }
    )
  ] });
}, db = window.location.pathname.split("/")[1] || "pages", fN = {
  scripts: [],
  styles: [],
  secondaryScripts: [],
  secondaryStyles: [],
  images: [],
  fonts: [],
  data: [],
  csp: {},
  pathname: ""
}, gPt = [
  "scripts",
  "styles",
  "secondaryScripts",
  "secondaryStyles",
  "images",
  "fonts",
  "data"
], vPt = 3e3;
function bPt({
  scripts: e,
  secondaryScripts: t,
  styles: r,
  secondaryStyles: a,
  images: i,
  fonts: c,
  data: d,
  csp: f,
  pathname: p
}) {
  const g = new URLSearchParams();
  if (g.set("scripts", e.join(",")), g.set("pathname", p), t && t.length > 0 && g.set("secondaryScripts", t.join(",")), r && r.length > 0 && g.set("styles", r.join(",")), a && a.length > 0 && g.set("secondaryStyles", a.join(",")), i && i.length > 0 && g.set("images", i.join(",")), c && c.length > 0 && g.set("fonts", c.join(",")), d && d.length > 0 && g.set("data", d.join(",")), f && Object.keys(f).length > 0)
    try {
      g.set("csp", JSON.stringify(f));
    } catch (w) {
      console.error("Error serializing CSP:", w);
    }
  const b = new URL(
    `/${db}/override?${g.toString()}`,
    window.location.origin
  );
  try {
    navigator.clipboard.writeText(b.toString());
  } catch (w) {
    console.error("Error copying link to clipboard:", w);
  }
}
function qX(e) {
  let t = e;
  return t ? t.startsWith(`${db}/`) ? t = `/${t}` : t.startsWith(`/${db}/`) || (t = `/${db}/${t.charAt(0) === "/" ? t.slice(1) : t}`) : t = `/${db}`, t;
}
function KX(e) {
  let t = e;
  return t.startsWith(`/${db}/`) ? t = t.slice(`/${db}/`.length) : t.startsWith(`${db}/`) ? t = t.slice(`${db}/`.length) : t.startsWith("/") && (t = t.slice(1)), t;
}
function yPt(e) {
  if (!e)
    return;
  const t = e.startsWith("/") ? e.slice(1) : e;
  window.location.assign(
    `${window.location.origin}/${db}/${t}`
  );
}
function YX({ scripts: e, pathname: t }) {
  return !!t && e.length > 0;
}
function wPt(e) {
  const t = Object.fromEntries(
    Object.entries(e).filter(([, d]) => !(!d || Array.isArray(d) && d.length === 0 || typeof d == "object" && Object.keys(d).length === 0))
  );
  let r;
  try {
    r = JSON.stringify(t);
  } catch (d) {
    console.error("Could not serialize override data", d);
  }
  if (!r)
    return "";
  const a = new TextEncoder();
  let i = a.encode(r).length;
  if (i >= 4096)
    console.warn(
      `Override data exceeds maximum size (${i} bytes >= 4096 bytes), limiting cookie to entry point scripts, styles, and CSP`
    );
  else
    return r;
  let c = {
    scripts: t.scripts,
    styles: t.styles,
    csp: t.csp,
    pathname: t.pathname
  };
  try {
    r = JSON.stringify(c);
  } catch (d) {
    console.error("Could not serialize limited override data", d);
  }
  if (!r)
    return "";
  if (i = a.encode(r).length, i >= 4096)
    console.warn(
      `Limited override data still exceeds maximum size (${i} bytes >= 4096 bytes), limiting cookie to entry point scripts and styles`
    );
  else
    return r;
  c = {
    scripts: t.scripts,
    styles: t.styles,
    pathname: t.pathname
  };
  try {
    r = JSON.stringify(c);
  } catch (d) {
    console.error("Could not serialize very limited override data", d);
  }
  return r ? (i = a.encode(r).length, i >= 4096 ? (console.error(
    `Very limited override data still exceeds maximum size (${i} bytes >= 4096 bytes), unable to serialize cookie data`
  ), "") : r) : "";
}
function SPt(e) {
  return e.split("-").map((a, i) => i === 0 ? a.toLowerCase() : a.charAt(0).toUpperCase() + a.slice(1).toLowerCase()).join("");
}
const Gu = [""];
function CPt({
  label: e,
  onChange: t,
  options: r,
  property: a,
  value: i
}) {
  let c;
  if (r === Gu ? c = "inputSet" : Array.isArray(r) ? c = "select" : typeof r == "boolean" ? c = "checkbox" : typeof r == "string" && (c = "text"), !c)
    return null;
  let d;
  switch (c) {
    case "checkbox": {
      d = /* @__PURE__ */ V.jsx(
        sS,
        {
          id: `override-${a}`,
          kind: "checkbox",
          checkboxValue: a,
          selected: !!i,
          onChange: (f) => t(a, f || void 0),
          dataTestId: `override-${a}`
        }
      );
      break;
    }
    case "inputSet": {
      d = /* @__PURE__ */ V.jsx(
        tL,
        {
          id: `override-${a}`,
          kind: "text",
          onChange: (f) => t(a, f?.length ? f : void 0),
          values: i,
          dataTestId: `override-${a}`
        }
      );
      break;
    }
    case "select": {
      d = /* @__PURE__ */ V.jsx(
        sS,
        {
          id: `override-${a}`,
          kind: "select",
          onChange: (f) => t(a, f),
          options: r.map((f) => ({
            label: f,
            value: f
          })),
          value: i,
          width: "100%",
          dataTestId: `override-${a}`
        }
      );
      break;
    }
    case "text": {
      d = /* @__PURE__ */ V.jsx(
        sS,
        {
          id: `override-${a}`,
          kind: "text",
          value: i,
          onChange: (f) => t(a, f),
          width: "100%",
          dataTestId: `override-${a}`
        }
      );
      break;
    }
  }
  return /* @__PURE__ */ V.jsxs("div", { className: lt("gap-(--override-editor-spacing) flex items-center"), children: [
    /* @__PURE__ */ V.jsx(
      "label",
      {
        className: lt("flex-0 text-nowrap"),
        htmlFor: `override-${a}`,
        children: e
      }
    ),
    d
  ] });
}
const xPt = {
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/base-uri
  "base-uri": Gu,
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/block-all-mixed-content
  // "block-all-mixed-content": "",
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/child-src
  "child-src": Gu,
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/connect-src
  "connect-src": Gu,
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/default-src
  "default-src": Gu,
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/fenced-frame-src
  "fenced-frame-src": Gu,
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/font-src
  "font-src": Gu,
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/form-action
  "form-action": Gu,
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/frame-ancestors
  "frame-ancestors": Gu,
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/frame-src
  "frame-src": Gu,
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/img-src
  "img-src": Gu,
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/manifest-src
  "manifest-src": Gu,
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/media-src
  "media-src": Gu,
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/object-src
  "object-src": Gu,
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/prefetch-src
  // "prefetch-src": STRING_SET,
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/report-to
  "report-to": "",
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/report-uri
  // "report-uri": "",
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/require-trusted-types-for
  "require-trusted-types-for": ["'script'"],
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/sandbox
  sandbox: [
    "true",
    "allow-downloads",
    "allow-forms",
    "allow-modals",
    "allow-orientation-lock",
    "allow-pointer-lock",
    "allow-popups",
    "allow-popups-to-escape-sandbox",
    "allow-presentation",
    "allow-same-origin",
    "allow-scripts",
    "allow-storage-access-by-user-activation",
    "allow-top-navigation-by-user-activation",
    "allow-top-navigation-to-custom-protocols"
  ],
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/script-src
  "script-src": Gu,
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/script-src-attr
  "script-src-attr": Gu,
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/script-src-elem
  "script-src-elem": Gu,
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/style-src
  "style-src": Gu,
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/style-src-attr
  "style-src-attr": Gu,
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/style-src-elem
  "style-src-elem": Gu,
  // TODO: implement trusted-types component
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/trusted-types
  // "trusted-types": ["'none'", "*"],
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/upgrade-insecure-requests
  "upgrade-insecure-requests": !0,
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/worker-src
  "worker-src": Gu
};
function EPt({
  onChange: e,
  value: t
}) {
  const { t: r } = fi(), [a, i] = Wn(
    t
  );
  Er(() => {
    i(t);
  }, [t]);
  const c = (f, p) => {
    if (!a && p === void 0) {
      i(void 0), e(void 0, a);
      return;
    }
    const g = a ? { ...a, [f]: p } : { [f]: p };
    i(g), e(g, a);
  }, d = Object.entries(xPt).map(
    ([f, p]) => {
      const g = SPt(
        f
      );
      return /* @__PURE__ */ V.jsx(
        CPt,
        {
          label: f,
          property: g,
          options: p,
          value: a?.[g],
          onChange: c
        },
        f
      );
    }
  );
  return /* @__PURE__ */ V.jsxs(
    "div",
    {
      className: lt(
        "gap-(--override-editor-spacing) bg-(--override-editor-color) font-(family-name:--font-sans) flex flex-col"
      ),
      "data-testid": "override-csp",
      children: [
        /* @__PURE__ */ V.jsx(Sk, { kind: "subsection", text: r("overrideEditor.csp") }),
        d
      ]
    }
  );
}
function PPt({
  isOverridePage: e = !1,
  onDone: t
}) {
  const { t: r } = fi(), a = Object.fromEntries(
    Object.keys(fN).map((W) => [
      W,
      r(`overrideEditor.inputHeadings.${W}`)
    ])
  ), [i, c] = NPe(fN), { cookie: d, setCookie: f, removeCookie: p } = nte(tte, ""), g = mn(() => {
    try {
      return d ? JSON.parse(d) : {};
    } catch {
      return {};
    }
  }, [d]), [b, w] = Wn({
    ...fN,
    ...g
  });
  e || (b.pathname = window.location.pathname);
  const [x, E] = Wn(!1), [P, k] = Wn(!1), M = Cn(
    (W = b) => {
      if (!YX(W))
        return;
      const Q = wPt(W);
      Q && (f(Q, {
        path: qX(W.pathname)
      }), E(!0), k(!0), setTimeout(() => k(!1), vPt));
    },
    [b, f]
  ), T = Cn(() => {
    M(), t && t();
  }, [M, t]), N = Cn(() => {
    p({
      path: qX(b.pathname)
    }), t && t(!0);
  }, [t, b.pathname, p]), D = Cn(
    (W) => {
      w(W), e && (Object.keys(W.csp ?? {}).length === 0 && delete W.csp, c(W));
    },
    [e, c]
  ), $ = Cn(
    (W, Q) => {
      const U = {
        ...b,
        [W]: Q
      };
      D(U);
    },
    [b, D]
  ), j = Cn(
    (W) => {
      const Q = {
        ...b,
        csp: W
      };
      D(Q);
    },
    [b, D]
  ), I = Cn(
    (W) => {
      const Q = {
        ...b,
        pathname: KX(W)
      };
      D(Q);
    },
    [b, D]
  ), L = () => {
    const W = window.prompt(r("overrideEditor.localDevPort"));
    D({
      ...b,
      scripts: [
        `https://localhost:${W}/assets/src/vitePreamble.ts`,
        `https://localhost:${W}/assets/@vite/client`,
        `https://localhost:${W}/assets/src/index.ts`
      ],
      csp: {
        connectSrc: [`ws://localhost:${W}`, `wss://localhost:${W}`]
      }
    });
  };
  Er(() => {
    if (!e)
      return;
    const W = {
      ...i,
      pathname: KX(i.pathname)
    };
    M(W), w(W);
  }, []);
  const F = x && b.pathname && b.pathname !== window.location.pathname, _ = gPt.map((W) => /* @__PURE__ */ V.jsxs(
    "div",
    {
      className: lt(
        "gap-(--override-editor-spacing) flex w-full flex-col items-start justify-between"
      ),
      children: [
        /* @__PURE__ */ V.jsx(Sk, { kind: "subsection", text: a[W] }),
        /* @__PURE__ */ V.jsx(
          tL,
          {
            dataTestId: `override-${W}`,
            kind: "url",
            onChange: (Q) => $(W, Q),
            values: b[W]
          }
        )
      ]
    },
    W
  ));
  return /* @__PURE__ */ V.jsxs(
    "section",
    {
      "data-testid": "override-editor",
      className: lt(
        "gap-(--override-editor-spacing) bg-(--override-editor-color) p-(--override-editor-spacing) flex flex-col"
      ),
      children: [
        P && /* @__PURE__ */ V.jsx(
          dee,
          {
            dataTestId: "override-success-banner",
            kind: "success",
            topOfPage: !0,
            message: r("overrideEditor.feedbackMessage.savedCookie"),
            onClose: () => k(!1)
          }
        ),
        /* @__PURE__ */ V.jsx(
          Sk,
          {
            kind: "section",
            text: r("overrideEditor.header"),
            "data-testid": "override-header"
          }
        ),
        _,
        /* @__PURE__ */ V.jsx(
          EPt,
          {
            onChange: j,
            value: b.csp
          }
        ),
        e && /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
          /* @__PURE__ */ V.jsx(
            Sk,
            {
              kind: "subsection",
              text: r("overrideEditor.pathname.heading"),
              "data-testid": "override-pathname-header"
            }
          ),
          /* @__PURE__ */ V.jsx(
            sS,
            {
              kind: "text",
              placeholder: r("overrideEditor.pathname.placeholder"),
              value: b.pathname,
              onChange: I,
              dataTestId: "override-pathname"
            }
          )
        ] }),
        /* @__PURE__ */ V.jsxs(
          "footer",
          {
            className: lt(
              "mt-(--override-editor-spacing) flex items-center justify-around"
            ),
            "data-testid": "override-footer",
            children: [
              /* @__PURE__ */ V.jsx(
                Qw,
                {
                  label: r("overrideEditor.buttons.saveCookie"),
                  disabled: !YX(b),
                  onClick: T,
                  kind: "primary",
                  "data-testid": "override-save-button"
                }
              ),
              /* @__PURE__ */ V.jsx(
                Qw,
                {
                  kind: "secondary",
                  label: r("overrideEditor.buttons.localDev"),
                  onClick: L,
                  "data-testid": "override-local-dev-button"
                }
              ),
              e && /* @__PURE__ */ V.jsx(
                Qw,
                {
                  label: r("overrideEditor.buttons.goToOverridenPage"),
                  onClick: () => yPt(b.pathname),
                  disabled: !F,
                  kind: "secondary",
                  "data-testid": "override-go-to-page-button"
                }
              ),
              e && /* @__PURE__ */ V.jsx(
                Qw,
                {
                  label: r("overrideEditor.buttons.copySharableLink"),
                  onClick: () => bPt(b),
                  disabled: !d,
                  kind: "secondary",
                  "data-testid": "override-copy-link-button"
                }
              ),
              /* @__PURE__ */ V.jsx(
                Qw,
                {
                  label: r("overrideEditor.buttons.deleteCookie"),
                  onClick: N,
                  disabled: !d,
                  kind: "secondary",
                  "data-testid": "override-delete-button"
                }
              )
            ]
          }
        )
      ]
    }
  );
}
const kPt = "_page_vdf87_22", MPt = "_caps_vdf87_22", OPt = "_portal_vdf87_29", TPt = "_dealer_vdf87_38", WP = {
  page: kPt,
  caps: MPt,
  portal: OPt,
  dealer: TPt
}, kTt = ({
  kind: e,
  header: t,
  children: r,
  footer: a,
  classes: i
}) => {
  const c = _e(WP.page, {
    [WP.caps]: e === "caps",
    [WP.dealer]: e !== "caps",
    [i?.wrapper]: !!i?.wrapper
  }), d = _e(WP.portal, {
    [i?.portal]: !!i?.portal
  });
  return /* @__PURE__ */ V.jsx("div", { className: c, children: /* @__PURE__ */ V.jsxs("div", { className: d, children: [
    /* @__PURE__ */ V.jsx("section", { children: t }),
    /* @__PURE__ */ V.jsx("main", { children: r }),
    /* @__PURE__ */ V.jsx("section", { children: a })
  ] }) });
}, RPt = ({
  className: e,
  ...t
}) => {
  const { t: r } = fi();
  return /* @__PURE__ */ V.jsx(
    "nav",
    {
      role: "navigation",
      "aria-label": r("pagination.navigationLabel"),
      "data-slot": "pagination",
      className: lt("font-(family-name:--font-sans) flex", e),
      ...t
    }
  );
}, APt = ({
  className: e,
  ...t
}) => /* @__PURE__ */ V.jsx(
  "ul",
  {
    "data-slot": "pagination-content",
    className: lt("flex flex-row items-center -space-x-px", e),
    ...t
  }
), mN = ({ ...e }) => /* @__PURE__ */ V.jsx("li", { "data-slot": "pagination-item", ...e }), ML = ({
  className: e,
  isActive: t,
  children: r,
  ...a
}) => /* @__PURE__ */ V.jsx(
  "a",
  {
    "aria-current": t ? "page" : void 0,
    "data-slot": "pagination-link",
    "data-active": t,
    className: lt(
      "inline-flex items-center justify-center whitespace-nowrap text-sm font-normal",
      "border-(--input-components-color-border) h-10 min-w-10 border bg-white px-3 text-gray-700",
      "hover:bg-gray-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-400 focus-visible:ring-offset-0",
      "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
      "rounded-none transition-colors",
      t && "bg-(--pagination-selected-bg-color)",
      e
    ),
    ...a,
    children: r ?? (a["aria-label"] ? (
      // fallback SR-only label if icon-only links are allowed
      /* @__PURE__ */ V.jsx("span", { className: "sr-only", children: a["aria-label"] })
    ) : null)
  }
), NPt = ({
  className: e,
  ...t
}) => {
  const { t: r } = fi();
  return /* @__PURE__ */ V.jsxs(
    ML,
    {
      "aria-label": r("pagination.previous.ariaLabel"),
      className: lt(
        "rounded-l-(--button-radius) gap-1 rounded-r-none pl-2",
        e
      ),
      ...t,
      children: [
        /* @__PURE__ */ V.jsx(pI, { className: "size-4" }),
        /* @__PURE__ */ V.jsx("span", { children: r("pagination.previous.label") })
      ]
    }
  );
}, DPt = ({
  className: e,
  ...t
}) => {
  const { t: r } = fi();
  return /* @__PURE__ */ V.jsxs(
    ML,
    {
      "aria-label": r("pagination.next.ariaLabel"),
      className: lt(
        "rounded-r-(--button-radius) gap-1 rounded-l-none pr-2",
        e
      ),
      ...t,
      children: [
        /* @__PURE__ */ V.jsx("span", { children: r("pagination.next.label") }),
        /* @__PURE__ */ V.jsx(gI, { className: "size-4" })
      ]
    }
  );
}, $Pt = ({
  className: e,
  ...t
}) => {
  const { t: r } = fi();
  return /* @__PURE__ */ V.jsxs(
    "span",
    {
      "aria-hidden": !0,
      "data-slot": "pagination-ellipsis",
      className: lt(
        "inline-flex items-center justify-center whitespace-nowrap text-sm font-normal",
        "border-(--input-components-color-border) h-10 w-10 border bg-white px-3 text-gray-700",
        "rounded-none transition-colors",
        e
      ),
      ...t,
      children: [
        /* @__PURE__ */ V.jsx(hOe, { className: "size-4" }),
        /* @__PURE__ */ V.jsx("span", { className: "sr-only", children: r("pagination.ellipsis.srLabel") })
      ]
    }
  );
}, zPt = ({
  currentPage: e,
  totalPages: t = 1,
  onPageChange: r,
  hasPreviousPage: a = e > 1,
  hasNextPage: i = e < t
}) => {
  const c = () => {
    const d = [];
    if (t <= 5)
      for (let p = 1; p <= t; p++)
        d.push(p);
    else {
      d.push(1), e > 3 && d.push("ellipsis-start");
      const p = Math.max(2, e - 1), g = Math.min(t - 1, e + 1);
      for (let b = p; b <= g; b++)
        d.push(b);
      e < t - 2 && d.push("ellipsis-end"), d.push(t);
    }
    return d;
  };
  return /* @__PURE__ */ V.jsx("div", { "data-preflight": !0, className: "contents", children: /* @__PURE__ */ V.jsx(RPt, { children: /* @__PURE__ */ V.jsxs(APt, { children: [
    /* @__PURE__ */ V.jsx(mN, { children: /* @__PURE__ */ V.jsx(
      NPt,
      {
        onClick: (d) => {
          d.preventDefault(), a && r(e - 1);
        },
        className: a ? "cursor-pointer" : "pointer-events-none opacity-50"
      }
    ) }),
    c().map((d, f) => /* @__PURE__ */ V.jsx(mN, { children: typeof d == "number" ? /* @__PURE__ */ V.jsx(
      ML,
      {
        onClick: (p) => {
          p.preventDefault(), r(d);
        },
        isActive: e === d,
        className: "cursor-pointer",
        children: d
      }
    ) : /* @__PURE__ */ V.jsx($Pt, {}) }, `${d}-${f}`)),
    /* @__PURE__ */ V.jsx(mN, { children: /* @__PURE__ */ V.jsx(
      DPt,
      {
        onClick: (d) => {
          d.preventDefault(), i && r(e + 1);
        },
        className: i ? "cursor-pointer" : "pointer-events-none opacity-50"
      }
    ) })
  ] }) }) });
}, jPt = {}, Koe = (e) => {
  const {
    children: t,
    textContent: r,
    placement: a,
    backgroundColor: i,
    render: c,
    textColor: d,
    containerDisplay: f
  } = e, p = mn(() => {
    const b = mr(c ? "--custom-popover-padding" : "--default-popover-padding"), w = i ?? mr("--default-background-color"), x = d ?? mr("--default-text-color");
    return {
      components: {
        Tooltip: {
          colorBgElevated: w,
          colorTextLightSolid: x,
          paddingXS: Number.parseInt(b),
          paddingSM: Number.parseInt(b)
        }
      }
    };
  }, [i, d, c]);
  if (!c && !r)
    return /* @__PURE__ */ V.jsx("div", { children: " ⚠️ Error: Please provide render or textContent ⚠️" });
  const g = c ?? r;
  return /* @__PURE__ */ V.jsx(tc, { theme: p, children: /* @__PURE__ */ V.jsx(
    U1,
    {
      title: g,
      placement: a,
      color: i,
      classNames: { root: jPt.popover },
      children: /* @__PURE__ */ V.jsx("span", { style: { display: f, width: "fit-content" }, children: t })
    }
  ) });
}, IPt = "_popover-container_1emvi_5", LPt = "_label_1emvi_8", HPt = "_popoverIcon_1emvi_11", hN = {
  popoverContainer: IPt,
  label: LPt,
  popoverIcon: HPt
}, MTt = ({
  label: e,
  backgroundColor: t = "#fff",
  textColor: r = "#000",
  textContent: a,
  iconPosition: i = "right",
  render: c
}) => {
  const d = /* @__PURE__ */ V.jsxs("span", { className: hN.label, children: [
    " ",
    e,
    " "
  ] });
  return /* @__PURE__ */ V.jsxs("div", { className: hN.popoverContainer, children: [
    e && i === "right" && d,
    /* @__PURE__ */ V.jsx(
      Koe,
      {
        textContent: a,
        backgroundColor: t,
        textColor: r,
        render: c,
        children: /* @__PURE__ */ V.jsx("span", { className: hN.popoverIcon, children: /* @__PURE__ */ V.jsx(
          _f,
          {
            name: "info",
            size: 13,
            color: mr("--caps-info-icon-color")
          }
        ) })
      }
    ),
    e && i === "left" && d
  ] });
}, L1 = {
  STANDARD: "programStatus.standard",
  GOLD: "programStatus.gold",
  SILVER: "programStatus.silver",
  PLATINUM: "programStatus.platinum"
}, FPt = {
  1: L1.STANDARD,
  2: L1.GOLD,
  3: L1.SILVER,
  4: L1.PLATINUM
}, WPt = {
  1: L1.STANDARD,
  2: L1.GOLD,
  4: L1.SILVER,
  5: L1.PLATINUM
}, xS = ({
  label: e,
  value: t,
  "data-testid": r
}) => /* @__PURE__ */ V.jsxs("div", { className: "mb-4 last:mb-0", children: [
  /* @__PURE__ */ V.jsx("div", { className: "text-xs text-gray-500", children: e }),
  /* @__PURE__ */ V.jsx(
    "div",
    {
      className: "break-all text-base text-black",
      "data-testid": r ?? `info-${e.toLowerCase().replaceAll(/\s/g, "-")}`,
      children: t
    }
  )
] }), OTt = ({
  name: e,
  phone: t,
  email: r,
  address: a,
  creditScore: i,
  secondSigner: c,
  scoringProgramId: d,
  isLowerEnvironment: f = !1
}) => {
  const { t: p } = fi(), g = e?.trim() || p("labels.unavailableData"), b = t?.trim() || p("labels.unavailableData"), w = r?.trim() || p("labels.unavailableData"), x = {
    street: a?.street?.trim() || "",
    city: a?.city?.trim() || "",
    state: a?.state?.trim() || "",
    zipCode: a?.zipCode?.trim() || ""
  }, E = c ? {
    name: c.name?.trim() || p("labels.unavailableData"),
    phone: c.phone?.trim() || p("labels.unavailableData"),
    email: c.email?.trim() || p("labels.unavailableData"),
    creditScore: c.creditScore
  } : void 0;
  function P(D) {
    return !D.street && !D.city && !D.state && !D.zipCode ? p("labels.unavailableData") : /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
      D.street && /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
        D.street,
        /* @__PURE__ */ V.jsx("br", {})
      ] }),
      D.city && D.state && /* @__PURE__ */ V.jsx(V.Fragment, { children: `${D.city}, ${D.state}` }),
      D.city && !D.state && D.zipCode && /* @__PURE__ */ V.jsx(V.Fragment, { children: `${D.city},` }),
      D.city && !D.state && !D.zipCode && /* @__PURE__ */ V.jsx(V.Fragment, { children: D.city }),
      !D.city && D.state && /* @__PURE__ */ V.jsx(V.Fragment, { children: D.state }),
      (D.city || D.state) && D.zipCode && " ",
      D.zipCode
    ] });
  }
  const k = mn(
    () => (D) => {
      if (!D)
        return;
      const $ = f ? FPt[D] : WPt[D];
      return $ ? p($) : void 0;
    },
    [p, f]
  ), M = mn(
    () => (D) => {
      const $ = k(D);
      return $ === p(L1.GOLD) || $ === p(L1.SILVER) || $ === p(L1.PLATINUM);
    },
    [k, p]
  ), T = mn(
    () => (D) => {
      const $ = k(D);
      return $ ? p("labels.programFinancing.title", { program: $ }) : "";
    },
    [k, p]
  ), N = mn(
    () => (D) => {
      const $ = k(D);
      return $ ? p("labels.programFinancing.description", {
        program: $
      }) : "";
    },
    [k, p]
  );
  return /* @__PURE__ */ V.jsxs("div", { className: "w-[264px] rounded-lg bg-white px-8 pb-8 pt-6 shadow-md", children: [
    /* @__PURE__ */ V.jsx(
      "h1",
      {
        className: "mb-4 mt-0 text-2xl font-bold",
        "data-testid": "primary-signer-name",
        style: {
          overflowWrap: "break-word",
          wordBreak: "break-word",
          //TW doesn't have this
          whiteSpace: "normal"
        },
        children: g
      }
    ),
    /* @__PURE__ */ V.jsx(
      xS,
      {
        "data-testid": "primary-signer-phone",
        label: p("labels.mobilePhone"),
        value: b
      }
    ),
    /* @__PURE__ */ V.jsx(
      xS,
      {
        "data-testid": "primary-signer-email",
        label: p("labels.email"),
        value: w
      }
    ),
    /* @__PURE__ */ V.jsx(
      xS,
      {
        "data-testid": "primary-signer-address",
        label: p("labels.address"),
        value: P(x)
      }
    ),
    /* @__PURE__ */ V.jsx(
      xS,
      {
        "data-testid": "primary-signer-credit-score",
        label: p("labels.creditScore"),
        value: i && i > 0 ? i : p("labels.notAvailable")
      }
    ),
    E && /* @__PURE__ */ V.jsx("hr", { className: "my-4 border-t border-gray-200" }),
    E && /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
      /* @__PURE__ */ V.jsx(
        xS,
        {
          "data-testid": "second-signer-name",
          label: p("labels.secondSigner"),
          value: E.name
        }
      ),
      /* @__PURE__ */ V.jsx(
        xS,
        {
          "data-testid": "second-signer-phone",
          label: p("labels.mobilePhone"),
          value: E.phone
        }
      ),
      /* @__PURE__ */ V.jsx(
        xS,
        {
          "data-testid": "second-signer-email",
          label: p("labels.email"),
          value: E.email
        }
      ),
      /* @__PURE__ */ V.jsx(
        xS,
        {
          "data-testid": "second-signer-credit-score",
          label: p("labels.creditScore"),
          value: E.creditScore && E.creditScore > 0 ? E.creditScore : p("labels.notAvailable")
        }
      )
    ] }),
    M(d) && /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
      /* @__PURE__ */ V.jsx("hr", { className: "my-4 border-t border-gray-200" }),
      /* @__PURE__ */ V.jsx("p", { className: "mb-0 break-all text-base", "data-testid": "financing-title", children: T(d) }),
      /* @__PURE__ */ V.jsx(
        "p",
        {
          className: "m-0 break-all text-xs text-black",
          "data-testid": "financing-description",
          children: N(d)
        }
      )
    ] })
  ] });
};
var VPt = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), _Pt = "VisuallyHidden", Yoe = S.forwardRef(
  (e, t) => /* @__PURE__ */ V.jsx(
    Ro.span,
    {
      ...e,
      ref: t,
      style: { ...VPt, ...e.style }
    }
  )
);
Yoe.displayName = _Pt;
var BPt = Yoe, x3 = "NavigationMenu", [OL, Qoe, UPt] = GI(x3), [uz, XPt, GPt] = GI(x3), [TL] = Eb(
  x3,
  [UPt, GPt]
), [qPt, q0] = TL(x3), [KPt, YPt] = TL(x3), Joe = S.forwardRef(
  (e, t) => {
    const {
      __scopeNavigationMenu: r,
      value: a,
      onValueChange: i,
      defaultValue: c,
      delayDuration: d = 200,
      skipDelayDuration: f = 300,
      orientation: p = "horizontal",
      dir: g,
      ...b
    } = e, [w, x] = S.useState(null), E = Wl(t, (_) => x(_)), P = qI(g), k = S.useRef(0), M = S.useRef(0), T = S.useRef(0), [N, D] = S.useState(!0), [$, j] = iC({
      prop: a,
      onChange: (_) => {
        const W = _ !== "", Q = f > 0;
        W ? (window.clearTimeout(T.current), Q && D(!1)) : (window.clearTimeout(T.current), T.current = window.setTimeout(
          () => D(!0),
          f
        )), i?.(_);
      },
      defaultProp: c ?? "",
      caller: x3
    }), I = S.useCallback(() => {
      window.clearTimeout(M.current), M.current = window.setTimeout(() => j(""), 150);
    }, [j]), L = S.useCallback(
      (_) => {
        window.clearTimeout(M.current), j(_);
      },
      [j]
    ), F = S.useCallback(
      (_) => {
        $ === _ ? window.clearTimeout(M.current) : k.current = window.setTimeout(() => {
          window.clearTimeout(M.current), j(_);
        }, d);
      },
      [$, j, d]
    );
    return S.useEffect(() => () => {
      window.clearTimeout(k.current), window.clearTimeout(M.current), window.clearTimeout(T.current);
    }, []), /* @__PURE__ */ V.jsx(
      Zoe,
      {
        scope: r,
        isRootMenu: !0,
        value: $,
        dir: P,
        orientation: p,
        rootNavigationMenu: w,
        onTriggerEnter: (_) => {
          window.clearTimeout(k.current), N ? F(_) : L(_);
        },
        onTriggerLeave: () => {
          window.clearTimeout(k.current), I();
        },
        onContentEnter: () => window.clearTimeout(M.current),
        onContentLeave: I,
        onItemSelect: (_) => {
          j((W) => W === _ ? "" : _);
        },
        onItemDismiss: () => j(""),
        children: /* @__PURE__ */ V.jsx(
          Ro.nav,
          {
            "aria-label": "Main",
            "data-orientation": p,
            dir: P,
            ...b,
            ref: E
          }
        )
      }
    );
  }
);
Joe.displayName = x3;
var cz = "NavigationMenuSub", QPt = S.forwardRef(
  (e, t) => {
    const {
      __scopeNavigationMenu: r,
      value: a,
      onValueChange: i,
      defaultValue: c,
      orientation: d = "horizontal",
      ...f
    } = e, p = q0(cz, r), [g, b] = iC({
      prop: a,
      onChange: i,
      defaultProp: c ?? "",
      caller: cz
    });
    return /* @__PURE__ */ V.jsx(
      Zoe,
      {
        scope: r,
        isRootMenu: !1,
        value: g,
        dir: p.dir,
        orientation: d,
        rootNavigationMenu: p.rootNavigationMenu,
        onTriggerEnter: (w) => b(w),
        onItemSelect: (w) => b(w),
        onItemDismiss: () => b(""),
        children: /* @__PURE__ */ V.jsx(Ro.div, { "data-orientation": d, ...f, ref: t })
      }
    );
  }
);
QPt.displayName = cz;
var Zoe = (e) => {
  const {
    scope: t,
    isRootMenu: r,
    rootNavigationMenu: a,
    dir: i,
    orientation: c,
    children: d,
    value: f,
    onItemSelect: p,
    onItemDismiss: g,
    onTriggerEnter: b,
    onTriggerLeave: w,
    onContentEnter: x,
    onContentLeave: E
  } = e, [P, k] = S.useState(null), [M, T] = S.useState(/* @__PURE__ */ new Map()), [N, D] = S.useState(null);
  return /* @__PURE__ */ V.jsx(
    qPt,
    {
      scope: t,
      isRootMenu: r,
      rootNavigationMenu: a,
      value: f,
      previousValue: NM(f),
      baseId: T0(),
      dir: i,
      orientation: c,
      viewport: P,
      onViewportChange: k,
      indicatorTrack: N,
      onIndicatorTrackChange: D,
      onTriggerEnter: rp(b),
      onTriggerLeave: rp(w),
      onContentEnter: rp(x),
      onContentLeave: rp(E),
      onItemSelect: rp(p),
      onItemDismiss: rp(g),
      onViewportContentChange: S.useCallback(($, j) => {
        T((I) => (I.set($, j), new Map(I)));
      }, []),
      onViewportContentRemove: S.useCallback(($) => {
        T((j) => j.has($) ? (j.delete($), new Map(j)) : j);
      }, []),
      children: /* @__PURE__ */ V.jsx(OL.Provider, { scope: t, children: /* @__PURE__ */ V.jsx(KPt, { scope: t, items: M, children: d }) })
    }
  );
}, eie = "NavigationMenuList", tie = S.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: r, ...a } = e, i = q0(eie, r), c = /* @__PURE__ */ V.jsx(Ro.ul, { "data-orientation": i.orientation, ...a, ref: t });
    return /* @__PURE__ */ V.jsx(Ro.div, { style: { position: "relative" }, ref: i.onIndicatorTrackChange, children: /* @__PURE__ */ V.jsx(OL.Slot, { scope: r, children: i.isRootMenu ? /* @__PURE__ */ V.jsx(lie, { asChild: !0, children: c }) : c }) });
  }
);
tie.displayName = eie;
var nie = "NavigationMenuItem", [JPt, rie] = TL(nie), aie = S.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: r, value: a, ...i } = e, c = T0(), d = a || c || "LEGACY_REACT_AUTO_VALUE", f = S.useRef(null), p = S.useRef(null), g = S.useRef(null), b = S.useRef(() => {
    }), w = S.useRef(!1), x = S.useCallback((P = "start") => {
      if (f.current) {
        b.current();
        const k = fz(f.current);
        k.length && NL(P === "start" ? k : k.reverse());
      }
    }, []), E = S.useCallback(() => {
      if (f.current) {
        const P = fz(f.current);
        P.length && (b.current = ukt(P));
      }
    }, []);
    return /* @__PURE__ */ V.jsx(
      JPt,
      {
        scope: r,
        value: d,
        triggerRef: p,
        contentRef: f,
        focusProxyRef: g,
        wasEscapeCloseRef: w,
        onEntryKeyDown: x,
        onFocusProxyEnter: x,
        onRootContentClose: E,
        onContentFocusOutside: E,
        children: /* @__PURE__ */ V.jsx(Ro.li, { ...i, ref: t })
      }
    );
  }
);
aie.displayName = nie;
var dz = "NavigationMenuTrigger", ZPt = S.forwardRef((e, t) => {
  const { __scopeNavigationMenu: r, disabled: a, ...i } = e, c = q0(dz, e.__scopeNavigationMenu), d = rie(dz, e.__scopeNavigationMenu), f = S.useRef(null), p = Wl(f, d.triggerRef, t), g = uie(c.baseId, d.value), b = cie(c.baseId, d.value), w = S.useRef(!1), x = S.useRef(!1), E = d.value === c.value;
  return /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
    /* @__PURE__ */ V.jsx(OL.ItemSlot, { scope: r, value: d.value, children: /* @__PURE__ */ V.jsx(sie, { asChild: !0, children: /* @__PURE__ */ V.jsx(
      Ro.button,
      {
        id: g,
        disabled: a,
        "data-disabled": a ? "" : void 0,
        "data-state": DL(E),
        "aria-expanded": E,
        "aria-controls": b,
        ...i,
        ref: p,
        onPointerEnter: io(e.onPointerEnter, () => {
          x.current = !1, d.wasEscapeCloseRef.current = !1;
        }),
        onPointerMove: io(
          e.onPointerMove,
          k9(() => {
            a || x.current || d.wasEscapeCloseRef.current || w.current || (c.onTriggerEnter(d.value), w.current = !0);
          })
        ),
        onPointerLeave: io(
          e.onPointerLeave,
          k9(() => {
            a || (c.onTriggerLeave(), w.current = !1);
          })
        ),
        onClick: io(e.onClick, () => {
          c.onItemSelect(d.value), x.current = E;
        }),
        onKeyDown: io(e.onKeyDown, (P) => {
          const M = { horizontal: "ArrowDown", vertical: c.dir === "rtl" ? "ArrowLeft" : "ArrowRight" }[c.orientation];
          E && P.key === M && (d.onEntryKeyDown(), P.preventDefault());
        })
      }
    ) }) }),
    E && /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
      /* @__PURE__ */ V.jsx(
        BPt,
        {
          "aria-hidden": !0,
          tabIndex: 0,
          ref: d.focusProxyRef,
          onFocus: (P) => {
            const k = d.contentRef.current, M = P.relatedTarget, T = M === f.current, N = k?.contains(M);
            (T || !N) && d.onFocusProxyEnter(T ? "start" : "end");
          }
        }
      ),
      c.viewport && /* @__PURE__ */ V.jsx("span", { "aria-owns": b })
    ] })
  ] });
});
ZPt.displayName = dz;
var ekt = "NavigationMenuLink", QX = "navigationMenu.linkSelect", oie = S.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: r, active: a, onSelect: i, ...c } = e;
    return /* @__PURE__ */ V.jsx(sie, { asChild: !0, children: /* @__PURE__ */ V.jsx(
      Ro.a,
      {
        "data-active": a ? "" : void 0,
        "aria-current": a ? "page" : void 0,
        ...c,
        ref: t,
        onClick: io(
          e.onClick,
          (d) => {
            const f = d.target, p = new CustomEvent(QX, {
              bubbles: !0,
              cancelable: !0
            });
            if (f.addEventListener(QX, (g) => i?.(g), { once: !0 }), O$(f, p), !p.defaultPrevented && !d.metaKey) {
              const g = new CustomEvent(Nk, {
                bubbles: !0,
                cancelable: !0
              });
              O$(f, g);
            }
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
oie.displayName = ekt;
var RL = "NavigationMenuIndicator", tkt = S.forwardRef((e, t) => {
  const { forceMount: r, ...a } = e, i = q0(RL, e.__scopeNavigationMenu), c = !!i.value;
  return i.indicatorTrack ? hb.createPortal(
    /* @__PURE__ */ V.jsx(X0, { present: r || c, children: /* @__PURE__ */ V.jsx(nkt, { ...a, ref: t }) }),
    i.indicatorTrack
  ) : null;
});
tkt.displayName = RL;
var nkt = S.forwardRef((e, t) => {
  const { __scopeNavigationMenu: r, ...a } = e, i = q0(RL, r), c = Qoe(r), [d, f] = S.useState(
    null
  ), [p, g] = S.useState(null), b = i.orientation === "horizontal", w = !!i.value;
  S.useEffect(() => {
    const P = c().find((k) => k.value === i.value)?.ref.current;
    P && f(P);
  }, [c, i.value]);
  const x = () => {
    d && g({
      size: b ? d.offsetWidth : d.offsetHeight,
      offset: b ? d.offsetLeft : d.offsetTop
    });
  };
  return mz(d, x), mz(i.indicatorTrack, x), p ? /* @__PURE__ */ V.jsx(
    Ro.div,
    {
      "aria-hidden": !0,
      "data-state": w ? "visible" : "hidden",
      "data-orientation": i.orientation,
      ...a,
      ref: t,
      style: {
        position: "absolute",
        ...b ? {
          left: 0,
          width: p.size + "px",
          transform: `translateX(${p.offset}px)`
        } : {
          top: 0,
          height: p.size + "px",
          transform: `translateY(${p.offset}px)`
        },
        ...a.style
      }
    }
  ) : null;
}), Ix = "NavigationMenuContent", rkt = S.forwardRef((e, t) => {
  const { forceMount: r, ...a } = e, i = q0(Ix, e.__scopeNavigationMenu), c = rie(Ix, e.__scopeNavigationMenu), d = Wl(c.contentRef, t), f = c.value === i.value, p = {
    value: c.value,
    triggerRef: c.triggerRef,
    focusProxyRef: c.focusProxyRef,
    wasEscapeCloseRef: c.wasEscapeCloseRef,
    onContentFocusOutside: c.onContentFocusOutside,
    onRootContentClose: c.onRootContentClose,
    ...a
  };
  return i.viewport ? /* @__PURE__ */ V.jsx(akt, { forceMount: r, ...p, ref: d }) : /* @__PURE__ */ V.jsx(X0, { present: r || f, children: /* @__PURE__ */ V.jsx(
    iie,
    {
      "data-state": DL(f),
      ...p,
      ref: d,
      onPointerEnter: io(e.onPointerEnter, i.onContentEnter),
      onPointerLeave: io(
        e.onPointerLeave,
        k9(i.onContentLeave)
      ),
      style: {
        // Prevent interaction when animating out
        pointerEvents: !f && i.isRootMenu ? "none" : void 0,
        ...p.style
      }
    }
  ) });
});
rkt.displayName = Ix;
var akt = S.forwardRef((e, t) => {
  const r = q0(Ix, e.__scopeNavigationMenu), { onViewportContentChange: a, onViewportContentRemove: i } = r;
  return G1(() => {
    a(e.value, {
      ref: t,
      ...e
    });
  }, [e, t, a]), G1(() => () => i(e.value), [e.value, i]), null;
}), Nk = "navigationMenu.rootContentDismiss", iie = S.forwardRef((e, t) => {
  const {
    __scopeNavigationMenu: r,
    value: a,
    triggerRef: i,
    focusProxyRef: c,
    wasEscapeCloseRef: d,
    onRootContentClose: f,
    onContentFocusOutside: p,
    ...g
  } = e, b = q0(Ix, r), w = S.useRef(null), x = Wl(w, t), E = uie(b.baseId, a), P = cie(b.baseId, a), k = Qoe(r), M = S.useRef(null), { onItemDismiss: T } = b;
  S.useEffect(() => {
    const D = w.current;
    if (b.isRootMenu && D) {
      const $ = () => {
        T(), f(), D.contains(document.activeElement) && i.current?.focus();
      };
      return D.addEventListener(Nk, $), () => D.removeEventListener(Nk, $);
    }
  }, [b.isRootMenu, e.value, i, T, f]);
  const N = S.useMemo(() => {
    const $ = k().map((W) => W.value);
    b.dir === "rtl" && $.reverse();
    const j = $.indexOf(b.value), I = $.indexOf(b.previousValue), L = a === b.value, F = I === $.indexOf(a);
    if (!L && !F) return M.current;
    const _ = (() => {
      if (j !== I) {
        if (L && I !== -1) return j > I ? "from-end" : "from-start";
        if (F && j !== -1) return j > I ? "to-start" : "to-end";
      }
      return null;
    })();
    return M.current = _, _;
  }, [b.previousValue, b.value, b.dir, k, a]);
  return /* @__PURE__ */ V.jsx(lie, { asChild: !0, children: /* @__PURE__ */ V.jsx(
    zM,
    {
      id: P,
      "aria-labelledby": E,
      "data-motion": N,
      "data-orientation": b.orientation,
      ...g,
      ref: x,
      disableOutsidePointerEvents: !1,
      onDismiss: () => {
        const D = new Event(Nk, {
          bubbles: !0,
          cancelable: !0
        });
        w.current?.dispatchEvent(D);
      },
      onFocusOutside: io(e.onFocusOutside, (D) => {
        p();
        const $ = D.target;
        b.rootNavigationMenu?.contains($) && D.preventDefault();
      }),
      onPointerDownOutside: io(e.onPointerDownOutside, (D) => {
        const $ = D.target, j = k().some((L) => L.ref.current?.contains($)), I = b.isRootMenu && b.viewport?.contains($);
        (j || I || !b.isRootMenu) && D.preventDefault();
      }),
      onKeyDown: io(e.onKeyDown, (D) => {
        const $ = D.altKey || D.ctrlKey || D.metaKey;
        if (D.key === "Tab" && !$) {
          const I = fz(D.currentTarget), L = document.activeElement, F = I.findIndex((Q) => Q === L), W = D.shiftKey ? I.slice(0, F).reverse() : I.slice(F + 1, I.length);
          NL(W) ? D.preventDefault() : c.current?.focus();
        }
      }),
      onEscapeKeyDown: io(e.onEscapeKeyDown, (D) => {
        d.current = !0;
      })
    }
  ) });
}), AL = "NavigationMenuViewport", okt = S.forwardRef((e, t) => {
  const { forceMount: r, ...a } = e, c = !!q0(AL, e.__scopeNavigationMenu).value;
  return /* @__PURE__ */ V.jsx(X0, { present: r || c, children: /* @__PURE__ */ V.jsx(ikt, { ...a, ref: t }) });
});
okt.displayName = AL;
var ikt = S.forwardRef((e, t) => {
  const { __scopeNavigationMenu: r, children: a, ...i } = e, c = q0(AL, r), d = Wl(t, c.onViewportChange), f = YPt(
    Ix,
    e.__scopeNavigationMenu
  ), [p, g] = S.useState(null), [b, w] = S.useState(null), x = p ? p?.width + "px" : void 0, E = p ? p?.height + "px" : void 0, P = !!c.value, k = P ? c.value : c.previousValue;
  return mz(b, () => {
    b && g({ width: b.offsetWidth, height: b.offsetHeight });
  }), /* @__PURE__ */ V.jsx(
    Ro.div,
    {
      "data-state": DL(P),
      "data-orientation": c.orientation,
      ...i,
      ref: d,
      style: {
        // Prevent interaction when animating out
        pointerEvents: !P && c.isRootMenu ? "none" : void 0,
        "--radix-navigation-menu-viewport-width": x,
        "--radix-navigation-menu-viewport-height": E,
        ...i.style
      },
      onPointerEnter: io(e.onPointerEnter, c.onContentEnter),
      onPointerLeave: io(e.onPointerLeave, k9(c.onContentLeave)),
      children: Array.from(f.items).map(([T, { ref: N, forceMount: D, ...$ }]) => {
        const j = k === T;
        return /* @__PURE__ */ V.jsx(X0, { present: D || j, children: /* @__PURE__ */ V.jsx(
          iie,
          {
            ...$,
            ref: fS(N, (I) => {
              j && I && w(I);
            })
          }
        ) }, T);
      })
    }
  );
}), lkt = "FocusGroup", lie = S.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: r, ...a } = e, i = q0(lkt, r);
    return /* @__PURE__ */ V.jsx(uz.Provider, { scope: r, children: /* @__PURE__ */ V.jsx(uz.Slot, { scope: r, children: /* @__PURE__ */ V.jsx(Ro.div, { dir: i.dir, ...a, ref: t }) }) });
  }
), JX = ["ArrowRight", "ArrowLeft", "ArrowUp", "ArrowDown"], skt = "FocusGroupItem", sie = S.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: r, ...a } = e, i = XPt(r), c = q0(skt, r);
    return /* @__PURE__ */ V.jsx(uz.ItemSlot, { scope: r, children: /* @__PURE__ */ V.jsx(
      Ro.button,
      {
        ...a,
        ref: t,
        onKeyDown: io(e.onKeyDown, (d) => {
          if (["Home", "End", ...JX].includes(d.key)) {
            let p = i().map((w) => w.ref.current);
            if ([c.dir === "rtl" ? "ArrowRight" : "ArrowLeft", "ArrowUp", "End"].includes(d.key) && p.reverse(), JX.includes(d.key)) {
              const w = p.indexOf(d.currentTarget);
              p = p.slice(w + 1);
            }
            setTimeout(() => NL(p)), d.preventDefault();
          }
        })
      }
    ) });
  }
);
function fz(e) {
  const t = [], r = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (a) => {
      const i = a.tagName === "INPUT" && a.type === "hidden";
      return a.disabled || a.hidden || i ? NodeFilter.FILTER_SKIP : a.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; r.nextNode(); ) t.push(r.currentNode);
  return t;
}
function NL(e) {
  const t = document.activeElement;
  return e.some((r) => r === t ? !0 : (r.focus(), document.activeElement !== t));
}
function ukt(e) {
  return e.forEach((t) => {
    t.dataset.tabindex = t.getAttribute("tabindex") || "", t.setAttribute("tabindex", "-1");
  }), () => {
    e.forEach((t) => {
      const r = t.dataset.tabindex;
      t.setAttribute("tabindex", r);
    });
  };
}
function mz(e, t) {
  const r = rp(t);
  G1(() => {
    let a = 0;
    if (e) {
      const i = new ResizeObserver(() => {
        cancelAnimationFrame(a), a = window.requestAnimationFrame(r);
      });
      return i.observe(e), () => {
        window.cancelAnimationFrame(a), i.unobserve(e);
      };
    }
  }, [e, r]);
}
function DL(e) {
  return e ? "open" : "closed";
}
function uie(e, t) {
  return `${e}-trigger-${t}`;
}
function cie(e, t) {
  return `${e}-content-${t}`;
}
function k9(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
const ckt = "data:image/webp;base64,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", dkt = "_root_1kpg6_8", fkt = "_list_1kpg6_16", mkt = "_link_1kpg6_25", pN = {
  root: dkt,
  list: fkt,
  link: mkt
}, VP = (e, t) => {
  try {
    return tS(e, t);
  } catch (r) {
    return console.error(`Could not create a url for ${e}: ${r}`), "#";
  }
}, hkt = (e, t, r) => [
  {
    testId: "nav-item-deal-structure",
    href: VP("dealStructureRehash", {
      approvalId: e.toString()
    }),
    label: r("rehashHeader.menuItems.dealStructure"),
    key: "dealStructure"
  },
  {
    testId: "nav-item-alternative-deals",
    href: VP("alternativeDealsRehash", {
      approvalId: e.toString()
    }),
    label: r("rehashHeader.menuItems.alternativeDeals"),
    key: "alternativeDeals"
  },
  {
    testId: "nav-item-inventory",
    href: VP("changeVehicleRehash", {
      approvalId: e.toString()
    }),
    label: r("rehashHeader.menuItems.changeVehicle"),
    key: "inventory"
  },
  {
    testId: "nav-item-stipulations",
    href: VP("stipulationsRehash", {
      approvalId: e.toString()
    }),
    label: r("rehashHeader.menuItems.stipulations"),
    key: "stipulations"
  }
].filter(
  (i) => i.key !== "inventory" || t
);
function pkt({ testId: e, t }) {
  return /* @__PURE__ */ V.jsx("div", { className: "flex h-[46px] items-center bg-white pl-6", children: /* @__PURE__ */ V.jsx(
    "img",
    {
      alt: t("rehashHeader.rehash"),
      width: 205,
      height: 28,
      src: ckt,
      className: "object-contain",
      "data-testid": `${e}-image`
    }
  ) });
}
const TTt = ({
  approvalId: e,
  activeTab: t,
  dealerId: r,
  dealerName: a,
  onTabClick: i
}) => {
  const { t: c } = fi(), { isLoading: d, launchDarklyClient: f, error: p } = cI(), [g, b] = Wn(!1);
  Er(() => {
    (async () => {
      if (p && d && !f)
        return;
      const P = f?.variation(
        sx.inventoryRehash,
        !1
      );
      b(P);
    })();
  }, [f, p, d]);
  const w = hkt(e, g, c), x = async (E, P) => {
    if (i) {
      E.preventDefault();
      const k = E.currentTarget.href;
      await i(P), window.location.href = k;
    }
  };
  return /* @__PURE__ */ V.jsxs(
    "div",
    {
      className: "flex w-full flex-col bg-white text-sm",
      "data-testid": "logoBar",
      children: [
        /* @__PURE__ */ V.jsxs("div", { className: "mx-auto flex w-full items-center justify-between", children: [
          /* @__PURE__ */ V.jsx(pkt, { testId: "rehash-test-id", t: c }),
          /* @__PURE__ */ V.jsx(
            "div",
            {
              className: "pr-6 text-right text-gray-700",
              "data-testid": "dealer-info",
              children: /* @__PURE__ */ V.jsxs("span", { className: "text-xs", children: [
                a,
                " | ",
                r
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ V.jsx("nav", { className: "flex h-[47px] w-full justify-end bg-[#214361] text-[16px]", children: /* @__PURE__ */ V.jsxs("div", { className: "mx-auto flex w-full", children: [
          /* @__PURE__ */ V.jsxs(
            "header",
            {
              className: "overflow-wrap-break-word flex-none self-center overflow-hidden pl-6 text-[18px] font-semibold text-white",
              "data-testid": "approval-number-header",
              children: [
                c("rehashHeader.approval"),
                " ",
                e
              ]
            }
          ),
          /* @__PURE__ */ V.jsx(
            Joe,
            {
              className: `mr-[28px] h-full ${pN.root}`,
              "data-testid": "rehash-nav-menu",
              children: /* @__PURE__ */ V.jsx(tie, { className: `${pN.list} h-full`, children: w.map((E) => /* @__PURE__ */ V.jsx(aie, { className: "h-full", children: /* @__PURE__ */ V.jsx(
                oie,
                {
                  className: `${pN.link} px-5 ${t === E.key ? "relative bg-[#FFFFFF4D] font-bold after:absolute after:bottom-0 after:left-0 after:h-[3px] after:w-full after:rounded-sm after:bg-[#f60]" : "text-white"}`,
                  href: E.href,
                  "data-testid": E.testId,
                  tabIndex: 0,
                  onClick: (P) => x(P, E.key),
                  children: E.label
                }
              ) }, E.key)) })
            }
          )
        ] }) })
      ]
    }
  );
}, gkt = mr(
  "--scoring-program-banner-background-color"
);
function vkt(e) {
  const { programType: t, size: r = "m" } = e, { t: a } = fi();
  if (t === "STANDARD")
    return;
  const i = {
    GOLD: "goldProgram",
    PLATINUM: "platinumProgram",
    SILVER: "silverProgram"
  }[t], c = a(
    `approvalInformation.${t.toLowerCase()}ProgramMoreInfo`
  ), [d, f] = { xs: [45, 15], s: [105, 32], m: [140, 42] }[r];
  return /* @__PURE__ */ V.jsx(
    Koe,
    {
      textContent: c,
      placement: "bottom",
      backgroundColor: gkt,
      containerDisplay: "inline-flex",
      children: /* @__PURE__ */ V.jsx(
        _f,
        {
          name: i,
          width: d,
          size: f,
          alt: i,
          testId: `scoring-program-banner-${t.toLowerCase()}`
        }
      )
    }
  );
}
const f6 = "bg-(--skeleton-color)", m6 = lt(
  "animate-skeleton-shimmer",
  "bg-[length:400%_100%]",
  "bg-[linear-gradient(90deg,var(--skeleton-color)_25%,var(--skeleton-color-highlight)_37%,var(--skeleton-color)_63%)]"
), bkt = fl(lt(f6, "inline-block rounded-full"), {
  variants: {
    size: {
      small: "h-(--skeleton-control-height-sm) w-(--skeleton-control-height-sm)",
      default: "h-(--skeleton-control-height) w-(--skeleton-control-height)",
      large: "h-(--skeleton-control-height-lg) w-(--skeleton-control-height-lg)"
    }
  },
  defaultVariants: { size: "default" }
}), ykt = ({
  size: e = "default",
  active: t = !1,
  className: r,
  ...a
}) => /* @__PURE__ */ V.jsx("span", { "data-preflight": !0, className: "contents", children: /* @__PURE__ */ V.jsx(
  "span",
  {
    className: lt(
      bkt({ size: e }),
      t && m6,
      r
    ),
    ...a
  }
) }), wkt = fl(
  lt(f6, "inline-block rounded-(--skeleton-radius)"),
  {
    variants: {
      size: {
        small: "h-(--skeleton-control-height-sm) w-(--skeleton-button-width-sm)",
        default: "h-(--skeleton-control-height) w-(--skeleton-button-width)",
        large: "h-(--skeleton-control-height-lg) w-(--skeleton-button-width-lg)"
      }
    },
    defaultVariants: { size: "default" }
  }
), Skt = ({
  size: e = "default",
  active: t = !1,
  className: r,
  ...a
}) => /* @__PURE__ */ V.jsx("span", { "data-preflight": !0, className: "contents", children: /* @__PURE__ */ V.jsx(
  "span",
  {
    className: lt(
      wkt({ size: e }),
      t && m6,
      r
    ),
    ...a
  }
) }), Ckt = fl(
  lt(f6, "inline-block rounded-(--skeleton-radius)"),
  {
    variants: {
      size: {
        small: "h-(--skeleton-control-height-sm) w-(--skeleton-input-width-sm)",
        default: "h-(--skeleton-control-height) w-(--skeleton-input-width)",
        large: "h-(--skeleton-control-height-lg) w-(--skeleton-input-width-lg)"
      }
    },
    defaultVariants: { size: "default" }
  }
), xkt = ({
  size: e = "default",
  active: t = !1,
  className: r,
  ...a
}) => /* @__PURE__ */ V.jsx("span", { "data-preflight": !0, className: "contents", children: /* @__PURE__ */ V.jsx(
  "span",
  {
    className: lt(
      Ckt({ size: e }),
      t && m6,
      r
    ),
    ...a
  }
) }), Ekt = lt(
  f6,
  "inline-flex items-center justify-center",
  "h-(--skeleton-node-size) w-(--skeleton-node-size) rounded-(--skeleton-radius)"
), Pkt = ({
  active: e = !1,
  className: t,
  ...r
}) => /* @__PURE__ */ V.jsx("span", { "data-preflight": !0, className: "contents", children: /* @__PURE__ */ V.jsx(
  "span",
  {
    className: lt(Ekt, e && m6, t),
    ...r
  }
) }), die = 3;
function kkt(e, t, r) {
  return e?.widths ? e.widths[t] : e?.lastRowWidth != null ? t === r - 1 ? e.lastRowWidth : void 0 : e?.width != null ? Array.isArray(e.width) ? e.width[t] : t === r - 1 ? e.width : void 0 : t === r - 1 && r > 2 ? "var(--skeleton-paragraph-last-row-width)" : void 0;
}
function Mkt(e) {
  if (!e || process.env.NODE_ENV === "production")
    return;
  const t = e.rows ?? die;
  e.width != null && (e.widths || e.lastRowWidth != null ? console.warn(
    "Skeleton: Both `width` and `widths`/`lastRowWidth` provided. `width` will be ignored."
  ) : console.warn(
    "Skeleton: `paragraph.width` is deprecated. Use `widths` for per-row widths or `lastRowWidth` for last-row-only width."
  )), e.widths && e.widths.length < t && console.warn(
    "Skeleton: `widths` has fewer entries than `rows`. Unmatched rows will use full width."
  );
}
function Okt(e, t) {
  Mkt(e);
  const r = e?.rows ?? die;
  return Array.from({ length: r }, (a, i) => {
    const c = kkt(e, i, r);
    return /* @__PURE__ */ V.jsx(
      "div",
      {
        className: lt(
          f6,
          t && m6,
          "h-(--skeleton-paragraph-height) rounded-(--skeleton-radius)"
        ),
        style: c === void 0 ? void 0 : { width: c }
      },
      i
    );
  });
}
const Tkt = ({
  loading: e,
  active: t = !1,
  children: r,
  paragraph: a,
  className: i,
  testId: c = "skeleton"
}) => /* @__PURE__ */ V.jsx(
  "div",
  {
    "data-testid": c,
    "aria-busy": e || void 0,
    className: "contents",
    children: e ? /* @__PURE__ */ V.jsx("div", { "data-preflight": !0, className: "contents", children: /* @__PURE__ */ V.jsxs("div", { className: lt("flex flex-col", i), children: [
      /* @__PURE__ */ V.jsx(
        "div",
        {
          className: lt(
            f6,
            t && m6,
            "mb-(--skeleton-title-gap) h-(--skeleton-title-height) w-(--skeleton-title-width) rounded-(--skeleton-radius)"
          )
        }
      ),
      /* @__PURE__ */ V.jsx("div", { className: "gap-(--skeleton-row-gap) flex flex-col", children: Okt(a, t) })
    ] }) }) : r
  }
), RTt = Object.assign(Tkt, {
  Input: xkt,
  Button: Skt,
  Avatar: ykt,
  Node: Pkt
}), Rkt = "_stepIndicator_p24cv_11", Akt = "_step_p24cv_11", Nkt = "_stepContent_p24cv_26", Dkt = "_numberAndLabel_p24cv_32", $kt = "_circle_p24cv_38", zkt = "_label_p24cv_50", jkt = "_line_p24cv_57", Ikt = "_active_p24cv_62", OS = {
  stepIndicator: Rkt,
  step: Akt,
  stepContent: Nkt,
  numberAndLabel: Dkt,
  circle: $kt,
  label: zkt,
  line: jkt,
  active: Ikt
}, Lkt = ({ step: e, isActive: t, showLine: r }) => /* @__PURE__ */ V.jsx(
  "li",
  {
    className: `${OS.step} ${t ? OS.active : ""}`,
    "data-testid": t ? `active-step-${e.number}` : `inactive-step-${e.number}`,
    children: /* @__PURE__ */ V.jsxs("div", { className: OS.stepContent, children: [
      /* @__PURE__ */ V.jsxs("div", { className: OS.numberAndLabel, children: [
        /* @__PURE__ */ V.jsx("div", { className: OS.circle, children: e.number }),
        /* @__PURE__ */ V.jsx("div", { className: OS.label, children: e.label })
      ] }),
      r && /* @__PURE__ */ V.jsx("div", { className: OS.line })
    ] })
  }
), Hkt = ({
  currentStep: e
}) => {
  const { t } = fi(), r = [
    { number: 1, label: t("capsStepIndicator.step1") },
    { number: 2, label: t("capsStepIndicator.step2") },
    { number: 3, label: t("capsStepIndicator.step3") },
    { number: 4, label: t("capsStepIndicator.step4") },
    { number: 5, label: t("capsStepIndicator.step5") },
    { number: 6, label: t("capsStepIndicator.step6") }
  ];
  return /* @__PURE__ */ V.jsx("ol", { className: OS.stepIndicator, children: r.map((a, i) => /* @__PURE__ */ V.jsx(
    Lkt,
    {
      step: a,
      isActive: a.number === e,
      showLine: i < r.length - 1
    },
    a.number
  )) });
}, Fkt = "_approvalInformation_196pn_12", Wkt = "_wrapperApprovalInfo_196pn_34", Vkt = "_labelValuePair_196pn_46", _kt = "_label_196pn_46", Bkt = "_value_196pn_57", x0 = {
  approvalInformation: Fkt,
  wrapperApprovalInfo: Wkt,
  labelValuePair: Vkt,
  label: _kt,
  value: Bkt
}, Ukt = ({
  scoringProgram: e = "STANDARD",
  ...t
}) => /* @__PURE__ */ V.jsxs("div", { className: x0.approvalInformation, children: [
  e !== "STANDARD" && /* @__PURE__ */ V.jsx(vkt, { programType: e }),
  /* @__PURE__ */ V.jsx(Gkt, { ...t })
] });
function Xkt(e) {
  switch (e) {
    case "RO":
      return "routeOne";
    default:
      return;
  }
}
function Gkt({
  applicationStatus: e,
  approvalId: t,
  driver: r,
  driverCapsCreditScore: a,
  secondSigner: i,
  secondSignerCapsCreditScore: c,
  leadId: d,
  leadSource: f
}) {
  const { t: p } = fi(), g = p("approvalInformation.approval"), b = p("approvalInformation.driver"), w = p("approvalInformation.secondSigner"), x = f ? Xkt(f) : void 0;
  let E, P;
  r === void 0 && a === void 0 ? E = "" : a === void 0 ? E = `${r}` : E = p("approvalInformation.driverDetails", {
    driver: r,
    driverCapsCreditScore: a
  }), i === void 0 && c === void 0 ? P = "" : c === void 0 ? P = `${i}` : P = p("approvalInformation.secondDriverDetails", {
    secondSigner: i,
    secondSignerCapsCreditScore: c
  });
  const k = _e({
    [xPe]: !0,
    [x0.value]: !0
  });
  return /* @__PURE__ */ V.jsxs("div", { className: x0.wrapperApprovalInfo, children: [
    d && /* @__PURE__ */ V.jsxs("div", { className: x0.labelValuePair, children: [
      /* @__PURE__ */ V.jsx("div", { className: x0.label, children: g }),
      /* @__PURE__ */ V.jsx("div", { className: x0.value, children: /* @__PURE__ */ V.jsxs("span", { id: "fsLeadNumber", children: [
        d,
        " ()"
      ] }) }),
      x && /* @__PURE__ */ V.jsx(_f, { name: x, size: 15 })
    ] }),
    t && !d && /* @__PURE__ */ V.jsxs("div", { className: x0.labelValuePair, children: [
      /* @__PURE__ */ V.jsx("div", { className: x0.label, children: g }),
      /* @__PURE__ */ V.jsxs("div", { className: x0.value, children: [
        /* @__PURE__ */ V.jsx("span", { id: "fsApprovalNumber", children: t }),
        e && /* @__PURE__ */ V.jsx("span", { id: "fsApprovalStatus", children: p("approvalInformation.applicationStatus", {
          applicationStatus: e
        }) })
      ] }),
      x && /* @__PURE__ */ V.jsx(_f, { name: x, size: 15 })
    ] }),
    r && !d && /* @__PURE__ */ V.jsxs("div", { className: x0.labelValuePair, children: [
      /* @__PURE__ */ V.jsx("div", { className: x0.label, children: b }),
      /* @__PURE__ */ V.jsx("div", { className: k, children: E })
    ] }),
    i && !d && /* @__PURE__ */ V.jsxs("div", { className: x0.labelValuePair, children: [
      /* @__PURE__ */ V.jsx("div", { className: x0.label, children: w }),
      /* @__PURE__ */ V.jsx("div", { className: k, children: P })
    ] })
  ] });
}
const qkt = "_container_14nen_6", Kkt = "_onlyStep_14nen_19", ZX = {
  container: qkt,
  onlyStep: Kkt
}, ATt = ({
  currentStep: e,
  approvalInformation: t
}) => {
  const r = _e({
    [ZX.container]: !0,
    [ZX.onlyStep]: !t
  });
  return /* @__PURE__ */ V.jsxs("div", { className: r, children: [
    t && /* @__PURE__ */ V.jsx(Ukt, { ...t }),
    /* @__PURE__ */ V.jsx(Hkt, { currentStep: e })
  ] });
};
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function $S(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function z0(e, t) {
  return (r) => {
    t.setState((a) => ({
      ...a,
      [e]: $S(r, a[e])
    }));
  };
}
function iO(e) {
  return e instanceof Function;
}
function Ykt(e) {
  return Array.isArray(e) && e.every((t) => typeof t == "number");
}
function Qkt(e, t) {
  const r = [], a = (i) => {
    i.forEach((c) => {
      r.push(c);
      const d = t(c);
      d != null && d.length && a(d);
    });
  };
  return a(e), r;
}
function la(e, t, r) {
  let a = [], i;
  return (c) => {
    let d;
    r.key && r.debug && (d = Date.now());
    const f = e(c);
    if (!(f.length !== a.length || f.some((b, w) => a[w] !== b)))
      return i;
    a = f;
    let g;
    if (r.key && r.debug && (g = Date.now()), i = t(...f), r == null || r.onChange == null || r.onChange(i), r.key && r.debug && r != null && r.debug()) {
      const b = Math.round((Date.now() - d) * 100) / 100, w = Math.round((Date.now() - g) * 100) / 100, x = w / 16, E = (P, k) => {
        for (P = String(P); P.length < k; )
          P = " " + P;
        return P;
      };
      console.info(`%c⏱ ${E(w, 5)} /${E(b, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * x, 120))}deg 100% 31%);`, r?.key);
    }
    return i;
  };
}
function sa(e, t, r, a) {
  return {
    debug: () => {
      var i;
      return (i = e?.debugAll) != null ? i : e[t];
    },
    key: process.env.NODE_ENV === "development" && r,
    onChange: a
  };
}
function Jkt(e, t, r, a) {
  const i = () => {
    var d;
    return (d = c.getValue()) != null ? d : e.options.renderFallbackValue;
  }, c = {
    id: `${t.id}_${r.id}`,
    row: t,
    column: r,
    getValue: () => t.getValue(a),
    renderValue: i,
    getContext: la(() => [e, r, t, c], (d, f, p, g) => ({
      table: d,
      column: f,
      row: p,
      cell: g,
      getValue: g.getValue,
      renderValue: g.renderValue
    }), sa(e.options, "debugCells", "cell.getContext"))
  };
  return e._features.forEach((d) => {
    d.createCell == null || d.createCell(c, r, t, e);
  }, {}), c;
}
function Zkt(e, t, r, a) {
  var i, c;
  const f = {
    ...e._getDefaultColumnDef(),
    ...t
  }, p = f.accessorKey;
  let g = (i = (c = f.id) != null ? c : p ? typeof String.prototype.replaceAll == "function" ? p.replaceAll(".", "_") : p.replace(/\./g, "_") : void 0) != null ? i : typeof f.header == "string" ? f.header : void 0, b;
  if (f.accessorFn ? b = f.accessorFn : p && (p.includes(".") ? b = (x) => {
    let E = x;
    for (const k of p.split(".")) {
      var P;
      E = (P = E) == null ? void 0 : P[k], process.env.NODE_ENV !== "production" && E === void 0 && console.warn(`"${k}" in deeply nested key "${p}" returned undefined.`);
    }
    return E;
  } : b = (x) => x[f.accessorKey]), !g)
    throw process.env.NODE_ENV !== "production" ? new Error(f.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header") : new Error();
  let w = {
    id: `${String(g)}`,
    accessorFn: b,
    parent: a,
    depth: r,
    columnDef: f,
    columns: [],
    getFlatColumns: la(() => [!0], () => {
      var x;
      return [w, ...(x = w.columns) == null ? void 0 : x.flatMap((E) => E.getFlatColumns())];
    }, sa(e.options, "debugColumns", "column.getFlatColumns")),
    getLeafColumns: la(() => [e._getOrderColumnsFn()], (x) => {
      var E;
      if ((E = w.columns) != null && E.length) {
        let P = w.columns.flatMap((k) => k.getLeafColumns());
        return x(P);
      }
      return [w];
    }, sa(e.options, "debugColumns", "column.getLeafColumns"))
  };
  for (const x of e._features)
    x.createColumn == null || x.createColumn(w, e);
  return w;
}
const Yf = "debugHeaders";
function eG(e, t, r) {
  var a;
  let c = {
    id: (a = r.id) != null ? a : t.id,
    column: t,
    index: r.index,
    isPlaceholder: !!r.isPlaceholder,
    placeholderId: r.placeholderId,
    depth: r.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const d = [], f = (p) => {
        p.subHeaders && p.subHeaders.length && p.subHeaders.map(f), d.push(p);
      };
      return f(c), d;
    },
    getContext: () => ({
      table: e,
      header: c,
      column: t
    })
  };
  return e._features.forEach((d) => {
    d.createHeader == null || d.createHeader(c, e);
  }), c;
}
const e9t = {
  createTable: (e) => {
    e.getHeaderGroups = la(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, r, a, i) => {
      var c, d;
      const f = (c = a?.map((w) => r.find((x) => x.id === w)).filter(Boolean)) != null ? c : [], p = (d = i?.map((w) => r.find((x) => x.id === w)).filter(Boolean)) != null ? d : [], g = r.filter((w) => !(a != null && a.includes(w.id)) && !(i != null && i.includes(w.id)));
      return _P(t, [...f, ...g, ...p], e);
    }, sa(e.options, Yf, "getHeaderGroups")), e.getCenterHeaderGroups = la(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, r, a, i) => (r = r.filter((c) => !(a != null && a.includes(c.id)) && !(i != null && i.includes(c.id))), _P(t, r, e, "center")), sa(e.options, Yf, "getCenterHeaderGroups")), e.getLeftHeaderGroups = la(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left], (t, r, a) => {
      var i;
      const c = (i = a?.map((d) => r.find((f) => f.id === d)).filter(Boolean)) != null ? i : [];
      return _P(t, c, e, "left");
    }, sa(e.options, Yf, "getLeftHeaderGroups")), e.getRightHeaderGroups = la(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.right], (t, r, a) => {
      var i;
      const c = (i = a?.map((d) => r.find((f) => f.id === d)).filter(Boolean)) != null ? i : [];
      return _P(t, c, e, "right");
    }, sa(e.options, Yf, "getRightHeaderGroups")), e.getFooterGroups = la(() => [e.getHeaderGroups()], (t) => [...t].reverse(), sa(e.options, Yf, "getFooterGroups")), e.getLeftFooterGroups = la(() => [e.getLeftHeaderGroups()], (t) => [...t].reverse(), sa(e.options, Yf, "getLeftFooterGroups")), e.getCenterFooterGroups = la(() => [e.getCenterHeaderGroups()], (t) => [...t].reverse(), sa(e.options, Yf, "getCenterFooterGroups")), e.getRightFooterGroups = la(() => [e.getRightHeaderGroups()], (t) => [...t].reverse(), sa(e.options, Yf, "getRightFooterGroups")), e.getFlatHeaders = la(() => [e.getHeaderGroups()], (t) => t.map((r) => r.headers).flat(), sa(e.options, Yf, "getFlatHeaders")), e.getLeftFlatHeaders = la(() => [e.getLeftHeaderGroups()], (t) => t.map((r) => r.headers).flat(), sa(e.options, Yf, "getLeftFlatHeaders")), e.getCenterFlatHeaders = la(() => [e.getCenterHeaderGroups()], (t) => t.map((r) => r.headers).flat(), sa(e.options, Yf, "getCenterFlatHeaders")), e.getRightFlatHeaders = la(() => [e.getRightHeaderGroups()], (t) => t.map((r) => r.headers).flat(), sa(e.options, Yf, "getRightFlatHeaders")), e.getCenterLeafHeaders = la(() => [e.getCenterFlatHeaders()], (t) => t.filter((r) => {
      var a;
      return !((a = r.subHeaders) != null && a.length);
    }), sa(e.options, Yf, "getCenterLeafHeaders")), e.getLeftLeafHeaders = la(() => [e.getLeftFlatHeaders()], (t) => t.filter((r) => {
      var a;
      return !((a = r.subHeaders) != null && a.length);
    }), sa(e.options, Yf, "getLeftLeafHeaders")), e.getRightLeafHeaders = la(() => [e.getRightFlatHeaders()], (t) => t.filter((r) => {
      var a;
      return !((a = r.subHeaders) != null && a.length);
    }), sa(e.options, Yf, "getRightLeafHeaders")), e.getLeafHeaders = la(() => [e.getLeftHeaderGroups(), e.getCenterHeaderGroups(), e.getRightHeaderGroups()], (t, r, a) => {
      var i, c, d, f, p, g;
      return [...(i = (c = t[0]) == null ? void 0 : c.headers) != null ? i : [], ...(d = (f = r[0]) == null ? void 0 : f.headers) != null ? d : [], ...(p = (g = a[0]) == null ? void 0 : g.headers) != null ? p : []].map((b) => b.getLeafHeaders()).flat();
    }, sa(e.options, Yf, "getLeafHeaders"));
  }
};
function _P(e, t, r, a) {
  var i, c;
  let d = 0;
  const f = function(x, E) {
    E === void 0 && (E = 1), d = Math.max(d, E), x.filter((P) => P.getIsVisible()).forEach((P) => {
      var k;
      (k = P.columns) != null && k.length && f(P.columns, E + 1);
    }, 0);
  };
  f(e);
  let p = [];
  const g = (x, E) => {
    const P = {
      depth: E,
      id: [a, `${E}`].filter(Boolean).join("_"),
      headers: []
    }, k = [];
    x.forEach((M) => {
      const T = [...k].reverse()[0], N = M.column.depth === P.depth;
      let D, $ = !1;
      if (N && M.column.parent ? D = M.column.parent : (D = M.column, $ = !0), T && T?.column === D)
        T.subHeaders.push(M);
      else {
        const j = eG(r, D, {
          id: [a, E, D.id, M?.id].filter(Boolean).join("_"),
          isPlaceholder: $,
          placeholderId: $ ? `${k.filter((I) => I.column === D).length}` : void 0,
          depth: E,
          index: k.length
        });
        j.subHeaders.push(M), k.push(j);
      }
      P.headers.push(M), M.headerGroup = P;
    }), p.push(P), E > 0 && g(k, E - 1);
  }, b = t.map((x, E) => eG(r, x, {
    depth: d,
    index: E
  }));
  g(b, d - 1), p.reverse();
  const w = (x) => x.filter((P) => P.column.getIsVisible()).map((P) => {
    let k = 0, M = 0, T = [0];
    P.subHeaders && P.subHeaders.length ? (T = [], w(P.subHeaders).forEach((D) => {
      let {
        colSpan: $,
        rowSpan: j
      } = D;
      k += $, T.push(j);
    })) : k = 1;
    const N = Math.min(...T);
    return M = M + N, P.colSpan = k, P.rowSpan = M, {
      colSpan: k,
      rowSpan: M
    };
  });
  return w((i = (c = p[0]) == null ? void 0 : c.headers) != null ? i : []), p;
}
const $L = (e, t, r, a, i, c, d) => {
  let f = {
    id: t,
    index: a,
    original: r,
    depth: i,
    parentId: d,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: (p) => {
      if (f._valuesCache.hasOwnProperty(p))
        return f._valuesCache[p];
      const g = e.getColumn(p);
      if (g != null && g.accessorFn)
        return f._valuesCache[p] = g.accessorFn(f.original, a), f._valuesCache[p];
    },
    getUniqueValues: (p) => {
      if (f._uniqueValuesCache.hasOwnProperty(p))
        return f._uniqueValuesCache[p];
      const g = e.getColumn(p);
      if (g != null && g.accessorFn)
        return g.columnDef.getUniqueValues ? (f._uniqueValuesCache[p] = g.columnDef.getUniqueValues(f.original, a), f._uniqueValuesCache[p]) : (f._uniqueValuesCache[p] = [f.getValue(p)], f._uniqueValuesCache[p]);
    },
    renderValue: (p) => {
      var g;
      return (g = f.getValue(p)) != null ? g : e.options.renderFallbackValue;
    },
    subRows: [],
    getLeafRows: () => Qkt(f.subRows, (p) => p.subRows),
    getParentRow: () => f.parentId ? e.getRow(f.parentId, !0) : void 0,
    getParentRows: () => {
      let p = [], g = f;
      for (; ; ) {
        const b = g.getParentRow();
        if (!b) break;
        p.push(b), g = b;
      }
      return p.reverse();
    },
    getAllCells: la(() => [e.getAllLeafColumns()], (p) => p.map((g) => Jkt(e, f, g, g.id)), sa(e.options, "debugRows", "getAllCells")),
    _getAllCellsByColumnId: la(() => [f.getAllCells()], (p) => p.reduce((g, b) => (g[b.column.id] = b, g), {}), sa(e.options, "debugRows", "getAllCellsByColumnId"))
  };
  for (let p = 0; p < e._features.length; p++) {
    const g = e._features[p];
    g == null || g.createRow == null || g.createRow(f, e);
  }
  return f;
}, t9t = {
  createColumn: (e, t) => {
    e._getFacetedRowModel = t.options.getFacetedRowModel && t.options.getFacetedRowModel(t, e.id), e.getFacetedRowModel = () => e._getFacetedRowModel ? e._getFacetedRowModel() : t.getPreFilteredRowModel(), e._getFacetedUniqueValues = t.options.getFacetedUniqueValues && t.options.getFacetedUniqueValues(t, e.id), e.getFacetedUniqueValues = () => e._getFacetedUniqueValues ? e._getFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getFacetedMinMaxValues = t.options.getFacetedMinMaxValues && t.options.getFacetedMinMaxValues(t, e.id), e.getFacetedMinMaxValues = () => {
      if (e._getFacetedMinMaxValues)
        return e._getFacetedMinMaxValues();
    };
  }
}, fie = (e, t, r) => {
  var a, i;
  const c = r == null || (a = r.toString()) == null ? void 0 : a.toLowerCase();
  return !!(!((i = e.getValue(t)) == null || (i = i.toString()) == null || (i = i.toLowerCase()) == null) && i.includes(c));
};
fie.autoRemove = (e) => V1(e);
const mie = (e, t, r) => {
  var a;
  return !!(!((a = e.getValue(t)) == null || (a = a.toString()) == null) && a.includes(r));
};
mie.autoRemove = (e) => V1(e);
const hie = (e, t, r) => {
  var a;
  return ((a = e.getValue(t)) == null || (a = a.toString()) == null ? void 0 : a.toLowerCase()) === r?.toLowerCase();
};
hie.autoRemove = (e) => V1(e);
const pie = (e, t, r) => {
  var a;
  return (a = e.getValue(t)) == null ? void 0 : a.includes(r);
};
pie.autoRemove = (e) => V1(e);
const gie = (e, t, r) => !r.some((a) => {
  var i;
  return !((i = e.getValue(t)) != null && i.includes(a));
});
gie.autoRemove = (e) => V1(e) || !(e != null && e.length);
const vie = (e, t, r) => r.some((a) => {
  var i;
  return (i = e.getValue(t)) == null ? void 0 : i.includes(a);
});
vie.autoRemove = (e) => V1(e) || !(e != null && e.length);
const bie = (e, t, r) => e.getValue(t) === r;
bie.autoRemove = (e) => V1(e);
const yie = (e, t, r) => e.getValue(t) == r;
yie.autoRemove = (e) => V1(e);
const zL = (e, t, r) => {
  let [a, i] = r;
  const c = e.getValue(t);
  return c >= a && c <= i;
};
zL.resolveFilterValue = (e) => {
  let [t, r] = e, a = typeof t != "number" ? parseFloat(t) : t, i = typeof r != "number" ? parseFloat(r) : r, c = t === null || Number.isNaN(a) ? -1 / 0 : a, d = r === null || Number.isNaN(i) ? 1 / 0 : i;
  if (c > d) {
    const f = c;
    c = d, d = f;
  }
  return [c, d];
};
zL.autoRemove = (e) => V1(e) || V1(e[0]) && V1(e[1]);
const Yw = {
  includesString: fie,
  includesStringSensitive: mie,
  equalsString: hie,
  arrIncludes: pie,
  arrIncludesAll: gie,
  arrIncludesSome: vie,
  equals: bie,
  weakEquals: yie,
  inNumberRange: zL
};
function V1(e) {
  return e == null || e === "";
}
const n9t = {
  getDefaultColumnDef: () => ({
    filterFn: "auto"
  }),
  getInitialState: (e) => ({
    columnFilters: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnFiltersChange: z0("columnFilters", e),
    filterFromLeafRows: !1,
    maxLeafRowFilterDepth: 100
  }),
  createColumn: (e, t) => {
    e.getAutoFilterFn = () => {
      const r = t.getCoreRowModel().flatRows[0], a = r?.getValue(e.id);
      return typeof a == "string" ? Yw.includesString : typeof a == "number" ? Yw.inNumberRange : typeof a == "boolean" || a !== null && typeof a == "object" ? Yw.equals : Array.isArray(a) ? Yw.arrIncludes : Yw.weakEquals;
    }, e.getFilterFn = () => {
      var r, a;
      return iO(e.columnDef.filterFn) ? e.columnDef.filterFn : e.columnDef.filterFn === "auto" ? e.getAutoFilterFn() : (
        // @ts-ignore
        (r = (a = t.options.filterFns) == null ? void 0 : a[e.columnDef.filterFn]) != null ? r : Yw[e.columnDef.filterFn]
      );
    }, e.getCanFilter = () => {
      var r, a, i;
      return ((r = e.columnDef.enableColumnFilter) != null ? r : !0) && ((a = t.options.enableColumnFilters) != null ? a : !0) && ((i = t.options.enableFilters) != null ? i : !0) && !!e.accessorFn;
    }, e.getIsFiltered = () => e.getFilterIndex() > -1, e.getFilterValue = () => {
      var r;
      return (r = t.getState().columnFilters) == null || (r = r.find((a) => a.id === e.id)) == null ? void 0 : r.value;
    }, e.getFilterIndex = () => {
      var r, a;
      return (r = (a = t.getState().columnFilters) == null ? void 0 : a.findIndex((i) => i.id === e.id)) != null ? r : -1;
    }, e.setFilterValue = (r) => {
      t.setColumnFilters((a) => {
        const i = e.getFilterFn(), c = a?.find((b) => b.id === e.id), d = $S(r, c ? c.value : void 0);
        if (tG(i, d, e)) {
          var f;
          return (f = a?.filter((b) => b.id !== e.id)) != null ? f : [];
        }
        const p = {
          id: e.id,
          value: d
        };
        if (c) {
          var g;
          return (g = a?.map((b) => b.id === e.id ? p : b)) != null ? g : [];
        }
        return a != null && a.length ? [...a, p] : [p];
      });
    };
  },
  createRow: (e, t) => {
    e.columnFilters = {}, e.columnFiltersMeta = {};
  },
  createTable: (e) => {
    e.setColumnFilters = (t) => {
      const r = e.getAllLeafColumns(), a = (i) => {
        var c;
        return (c = $S(t, i)) == null ? void 0 : c.filter((d) => {
          const f = r.find((p) => p.id === d.id);
          if (f) {
            const p = f.getFilterFn();
            if (tG(p, d.value, f))
              return !1;
          }
          return !0;
        });
      };
      e.options.onColumnFiltersChange == null || e.options.onColumnFiltersChange(a);
    }, e.resetColumnFilters = (t) => {
      var r, a;
      e.setColumnFilters(t ? [] : (r = (a = e.initialState) == null ? void 0 : a.columnFilters) != null ? r : []);
    }, e.getPreFilteredRowModel = () => e.getCoreRowModel(), e.getFilteredRowModel = () => (!e._getFilteredRowModel && e.options.getFilteredRowModel && (e._getFilteredRowModel = e.options.getFilteredRowModel(e)), e.options.manualFiltering || !e._getFilteredRowModel ? e.getPreFilteredRowModel() : e._getFilteredRowModel());
  }
};
function tG(e, t, r) {
  return (e && e.autoRemove ? e.autoRemove(t, r) : !1) || typeof t > "u" || typeof t == "string" && !t;
}
const r9t = (e, t, r) => r.reduce((a, i) => {
  const c = i.getValue(e);
  return a + (typeof c == "number" ? c : 0);
}, 0), a9t = (e, t, r) => {
  let a;
  return r.forEach((i) => {
    const c = i.getValue(e);
    c != null && (a > c || a === void 0 && c >= c) && (a = c);
  }), a;
}, o9t = (e, t, r) => {
  let a;
  return r.forEach((i) => {
    const c = i.getValue(e);
    c != null && (a < c || a === void 0 && c >= c) && (a = c);
  }), a;
}, i9t = (e, t, r) => {
  let a, i;
  return r.forEach((c) => {
    const d = c.getValue(e);
    d != null && (a === void 0 ? d >= d && (a = i = d) : (a > d && (a = d), i < d && (i = d)));
  }), [a, i];
}, l9t = (e, t) => {
  let r = 0, a = 0;
  if (t.forEach((i) => {
    let c = i.getValue(e);
    c != null && (c = +c) >= c && (++r, a += c);
  }), r) return a / r;
}, s9t = (e, t) => {
  if (!t.length)
    return;
  const r = t.map((c) => c.getValue(e));
  if (!Ykt(r))
    return;
  if (r.length === 1)
    return r[0];
  const a = Math.floor(r.length / 2), i = r.sort((c, d) => c - d);
  return r.length % 2 !== 0 ? i[a] : (i[a - 1] + i[a]) / 2;
}, u9t = (e, t) => Array.from(new Set(t.map((r) => r.getValue(e))).values()), c9t = (e, t) => new Set(t.map((r) => r.getValue(e))).size, d9t = (e, t) => t.length, gN = {
  sum: r9t,
  min: a9t,
  max: o9t,
  extent: i9t,
  mean: l9t,
  median: s9t,
  unique: u9t,
  uniqueCount: c9t,
  count: d9t
}, f9t = {
  getDefaultColumnDef: () => ({
    aggregatedCell: (e) => {
      var t, r;
      return (t = (r = e.getValue()) == null || r.toString == null ? void 0 : r.toString()) != null ? t : null;
    },
    aggregationFn: "auto"
  }),
  getInitialState: (e) => ({
    grouping: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGroupingChange: z0("grouping", e),
    groupedColumnMode: "reorder"
  }),
  createColumn: (e, t) => {
    e.toggleGrouping = () => {
      t.setGrouping((r) => r != null && r.includes(e.id) ? r.filter((a) => a !== e.id) : [...r ?? [], e.id]);
    }, e.getCanGroup = () => {
      var r, a;
      return ((r = e.columnDef.enableGrouping) != null ? r : !0) && ((a = t.options.enableGrouping) != null ? a : !0) && (!!e.accessorFn || !!e.columnDef.getGroupingValue);
    }, e.getIsGrouped = () => {
      var r;
      return (r = t.getState().grouping) == null ? void 0 : r.includes(e.id);
    }, e.getGroupedIndex = () => {
      var r;
      return (r = t.getState().grouping) == null ? void 0 : r.indexOf(e.id);
    }, e.getToggleGroupingHandler = () => {
      const r = e.getCanGroup();
      return () => {
        r && e.toggleGrouping();
      };
    }, e.getAutoAggregationFn = () => {
      const r = t.getCoreRowModel().flatRows[0], a = r?.getValue(e.id);
      if (typeof a == "number")
        return gN.sum;
      if (Object.prototype.toString.call(a) === "[object Date]")
        return gN.extent;
    }, e.getAggregationFn = () => {
      var r, a;
      if (!e)
        throw new Error();
      return iO(e.columnDef.aggregationFn) ? e.columnDef.aggregationFn : e.columnDef.aggregationFn === "auto" ? e.getAutoAggregationFn() : (r = (a = t.options.aggregationFns) == null ? void 0 : a[e.columnDef.aggregationFn]) != null ? r : gN[e.columnDef.aggregationFn];
    };
  },
  createTable: (e) => {
    e.setGrouping = (t) => e.options.onGroupingChange == null ? void 0 : e.options.onGroupingChange(t), e.resetGrouping = (t) => {
      var r, a;
      e.setGrouping(t ? [] : (r = (a = e.initialState) == null ? void 0 : a.grouping) != null ? r : []);
    }, e.getPreGroupedRowModel = () => e.getFilteredRowModel(), e.getGroupedRowModel = () => (!e._getGroupedRowModel && e.options.getGroupedRowModel && (e._getGroupedRowModel = e.options.getGroupedRowModel(e)), e.options.manualGrouping || !e._getGroupedRowModel ? e.getPreGroupedRowModel() : e._getGroupedRowModel());
  },
  createRow: (e, t) => {
    e.getIsGrouped = () => !!e.groupingColumnId, e.getGroupingValue = (r) => {
      if (e._groupingValuesCache.hasOwnProperty(r))
        return e._groupingValuesCache[r];
      const a = t.getColumn(r);
      return a != null && a.columnDef.getGroupingValue ? (e._groupingValuesCache[r] = a.columnDef.getGroupingValue(e.original), e._groupingValuesCache[r]) : e.getValue(r);
    }, e._groupingValuesCache = {};
  },
  createCell: (e, t, r, a) => {
    e.getIsGrouped = () => t.getIsGrouped() && t.id === r.groupingColumnId, e.getIsPlaceholder = () => !e.getIsGrouped() && t.getIsGrouped(), e.getIsAggregated = () => {
      var i;
      return !e.getIsGrouped() && !e.getIsPlaceholder() && !!((i = r.subRows) != null && i.length);
    };
  }
};
function m9t(e, t, r) {
  if (!(t != null && t.length) || !r)
    return e;
  const a = e.filter((c) => !t.includes(c.id));
  return r === "remove" ? a : [...t.map((c) => e.find((d) => d.id === c)).filter(Boolean), ...a];
}
const h9t = {
  getInitialState: (e) => ({
    columnOrder: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnOrderChange: z0("columnOrder", e)
  }),
  createColumn: (e, t) => {
    e.getIndex = la((r) => [wE(t, r)], (r) => r.findIndex((a) => a.id === e.id), sa(t.options, "debugColumns", "getIndex")), e.getIsFirstColumn = (r) => {
      var a;
      return ((a = wE(t, r)[0]) == null ? void 0 : a.id) === e.id;
    }, e.getIsLastColumn = (r) => {
      var a;
      const i = wE(t, r);
      return ((a = i[i.length - 1]) == null ? void 0 : a.id) === e.id;
    };
  },
  createTable: (e) => {
    e.setColumnOrder = (t) => e.options.onColumnOrderChange == null ? void 0 : e.options.onColumnOrderChange(t), e.resetColumnOrder = (t) => {
      var r;
      e.setColumnOrder(t ? [] : (r = e.initialState.columnOrder) != null ? r : []);
    }, e._getOrderColumnsFn = la(() => [e.getState().columnOrder, e.getState().grouping, e.options.groupedColumnMode], (t, r, a) => (i) => {
      let c = [];
      if (!(t != null && t.length))
        c = i;
      else {
        const d = [...t], f = [...i];
        for (; f.length && d.length; ) {
          const p = d.shift(), g = f.findIndex((b) => b.id === p);
          g > -1 && c.push(f.splice(g, 1)[0]);
        }
        c = [...c, ...f];
      }
      return m9t(c, r, a);
    }, sa(e.options, "debugTable", "_getOrderColumnsFn"));
  }
}, vN = () => ({
  left: [],
  right: []
}), p9t = {
  getInitialState: (e) => ({
    columnPinning: vN(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnPinningChange: z0("columnPinning", e)
  }),
  createColumn: (e, t) => {
    e.pin = (r) => {
      const a = e.getLeafColumns().map((i) => i.id).filter(Boolean);
      t.setColumnPinning((i) => {
        var c, d;
        if (r === "right") {
          var f, p;
          return {
            left: ((f = i?.left) != null ? f : []).filter((w) => !(a != null && a.includes(w))),
            right: [...((p = i?.right) != null ? p : []).filter((w) => !(a != null && a.includes(w))), ...a]
          };
        }
        if (r === "left") {
          var g, b;
          return {
            left: [...((g = i?.left) != null ? g : []).filter((w) => !(a != null && a.includes(w))), ...a],
            right: ((b = i?.right) != null ? b : []).filter((w) => !(a != null && a.includes(w)))
          };
        }
        return {
          left: ((c = i?.left) != null ? c : []).filter((w) => !(a != null && a.includes(w))),
          right: ((d = i?.right) != null ? d : []).filter((w) => !(a != null && a.includes(w)))
        };
      });
    }, e.getCanPin = () => e.getLeafColumns().some((a) => {
      var i, c, d;
      return ((i = a.columnDef.enablePinning) != null ? i : !0) && ((c = (d = t.options.enableColumnPinning) != null ? d : t.options.enablePinning) != null ? c : !0);
    }), e.getIsPinned = () => {
      const r = e.getLeafColumns().map((f) => f.id), {
        left: a,
        right: i
      } = t.getState().columnPinning, c = r.some((f) => a?.includes(f)), d = r.some((f) => i?.includes(f));
      return c ? "left" : d ? "right" : !1;
    }, e.getPinnedIndex = () => {
      var r, a;
      const i = e.getIsPinned();
      return i ? (r = (a = t.getState().columnPinning) == null || (a = a[i]) == null ? void 0 : a.indexOf(e.id)) != null ? r : -1 : 0;
    };
  },
  createRow: (e, t) => {
    e.getCenterVisibleCells = la(() => [e._getAllVisibleCells(), t.getState().columnPinning.left, t.getState().columnPinning.right], (r, a, i) => {
      const c = [...a ?? [], ...i ?? []];
      return r.filter((d) => !c.includes(d.column.id));
    }, sa(t.options, "debugRows", "getCenterVisibleCells")), e.getLeftVisibleCells = la(() => [e._getAllVisibleCells(), t.getState().columnPinning.left], (r, a) => (a ?? []).map((c) => r.find((d) => d.column.id === c)).filter(Boolean).map((c) => ({
      ...c,
      position: "left"
    })), sa(t.options, "debugRows", "getLeftVisibleCells")), e.getRightVisibleCells = la(() => [e._getAllVisibleCells(), t.getState().columnPinning.right], (r, a) => (a ?? []).map((c) => r.find((d) => d.column.id === c)).filter(Boolean).map((c) => ({
      ...c,
      position: "right"
    })), sa(t.options, "debugRows", "getRightVisibleCells"));
  },
  createTable: (e) => {
    e.setColumnPinning = (t) => e.options.onColumnPinningChange == null ? void 0 : e.options.onColumnPinningChange(t), e.resetColumnPinning = (t) => {
      var r, a;
      return e.setColumnPinning(t ? vN() : (r = (a = e.initialState) == null ? void 0 : a.columnPinning) != null ? r : vN());
    }, e.getIsSomeColumnsPinned = (t) => {
      var r;
      const a = e.getState().columnPinning;
      if (!t) {
        var i, c;
        return !!((i = a.left) != null && i.length || (c = a.right) != null && c.length);
      }
      return !!((r = a[t]) != null && r.length);
    }, e.getLeftLeafColumns = la(() => [e.getAllLeafColumns(), e.getState().columnPinning.left], (t, r) => (r ?? []).map((a) => t.find((i) => i.id === a)).filter(Boolean), sa(e.options, "debugColumns", "getLeftLeafColumns")), e.getRightLeafColumns = la(() => [e.getAllLeafColumns(), e.getState().columnPinning.right], (t, r) => (r ?? []).map((a) => t.find((i) => i.id === a)).filter(Boolean), sa(e.options, "debugColumns", "getRightLeafColumns")), e.getCenterLeafColumns = la(() => [e.getAllLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, r, a) => {
      const i = [...r ?? [], ...a ?? []];
      return t.filter((c) => !i.includes(c.id));
    }, sa(e.options, "debugColumns", "getCenterLeafColumns"));
  }
};
function g9t(e) {
  return e || (typeof document < "u" ? document : null);
}
const BP = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
}, bN = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: !1,
  columnSizingStart: []
}), v9t = {
  getDefaultColumnDef: () => BP,
  getInitialState: (e) => ({
    columnSizing: {},
    columnSizingInfo: bN(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    columnResizeMode: "onEnd",
    columnResizeDirection: "ltr",
    onColumnSizingChange: z0("columnSizing", e),
    onColumnSizingInfoChange: z0("columnSizingInfo", e)
  }),
  createColumn: (e, t) => {
    e.getSize = () => {
      var r, a, i;
      const c = t.getState().columnSizing[e.id];
      return Math.min(Math.max((r = e.columnDef.minSize) != null ? r : BP.minSize, (a = c ?? e.columnDef.size) != null ? a : BP.size), (i = e.columnDef.maxSize) != null ? i : BP.maxSize);
    }, e.getStart = la((r) => [r, wE(t, r), t.getState().columnSizing], (r, a) => a.slice(0, e.getIndex(r)).reduce((i, c) => i + c.getSize(), 0), sa(t.options, "debugColumns", "getStart")), e.getAfter = la((r) => [r, wE(t, r), t.getState().columnSizing], (r, a) => a.slice(e.getIndex(r) + 1).reduce((i, c) => i + c.getSize(), 0), sa(t.options, "debugColumns", "getAfter")), e.resetSize = () => {
      t.setColumnSizing((r) => {
        let {
          [e.id]: a,
          ...i
        } = r;
        return i;
      });
    }, e.getCanResize = () => {
      var r, a;
      return ((r = e.columnDef.enableResizing) != null ? r : !0) && ((a = t.options.enableColumnResizing) != null ? a : !0);
    }, e.getIsResizing = () => t.getState().columnSizingInfo.isResizingColumn === e.id;
  },
  createHeader: (e, t) => {
    e.getSize = () => {
      let r = 0;
      const a = (i) => {
        if (i.subHeaders.length)
          i.subHeaders.forEach(a);
        else {
          var c;
          r += (c = i.column.getSize()) != null ? c : 0;
        }
      };
      return a(e), r;
    }, e.getStart = () => {
      if (e.index > 0) {
        const r = e.headerGroup.headers[e.index - 1];
        return r.getStart() + r.getSize();
      }
      return 0;
    }, e.getResizeHandler = (r) => {
      const a = t.getColumn(e.column.id), i = a?.getCanResize();
      return (c) => {
        if (!a || !i || (c.persist == null || c.persist(), yN(c) && c.touches && c.touches.length > 1))
          return;
        const d = e.getSize(), f = e ? e.getLeafHeaders().map((T) => [T.column.id, T.column.getSize()]) : [[a.id, a.getSize()]], p = yN(c) ? Math.round(c.touches[0].clientX) : c.clientX, g = {}, b = (T, N) => {
          typeof N == "number" && (t.setColumnSizingInfo((D) => {
            var $, j;
            const I = t.options.columnResizeDirection === "rtl" ? -1 : 1, L = (N - (($ = D?.startOffset) != null ? $ : 0)) * I, F = Math.max(L / ((j = D?.startSize) != null ? j : 0), -0.999999);
            return D.columnSizingStart.forEach((_) => {
              let [W, Q] = _;
              g[W] = Math.round(Math.max(Q + Q * F, 0) * 100) / 100;
            }), {
              ...D,
              deltaOffset: L,
              deltaPercentage: F
            };
          }), (t.options.columnResizeMode === "onChange" || T === "end") && t.setColumnSizing((D) => ({
            ...D,
            ...g
          })));
        }, w = (T) => b("move", T), x = (T) => {
          b("end", T), t.setColumnSizingInfo((N) => ({
            ...N,
            isResizingColumn: !1,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        }, E = g9t(r), P = {
          moveHandler: (T) => w(T.clientX),
          upHandler: (T) => {
            E?.removeEventListener("mousemove", P.moveHandler), E?.removeEventListener("mouseup", P.upHandler), x(T.clientX);
          }
        }, k = {
          moveHandler: (T) => (T.cancelable && (T.preventDefault(), T.stopPropagation()), w(T.touches[0].clientX), !1),
          upHandler: (T) => {
            var N;
            E?.removeEventListener("touchmove", k.moveHandler), E?.removeEventListener("touchend", k.upHandler), T.cancelable && (T.preventDefault(), T.stopPropagation()), x((N = T.touches[0]) == null ? void 0 : N.clientX);
          }
        }, M = b9t() ? {
          passive: !1
        } : !1;
        yN(c) ? (E?.addEventListener("touchmove", k.moveHandler, M), E?.addEventListener("touchend", k.upHandler, M)) : (E?.addEventListener("mousemove", P.moveHandler, M), E?.addEventListener("mouseup", P.upHandler, M)), t.setColumnSizingInfo((T) => ({
          ...T,
          startOffset: p,
          startSize: d,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart: f,
          isResizingColumn: a.id
        }));
      };
    };
  },
  createTable: (e) => {
    e.setColumnSizing = (t) => e.options.onColumnSizingChange == null ? void 0 : e.options.onColumnSizingChange(t), e.setColumnSizingInfo = (t) => e.options.onColumnSizingInfoChange == null ? void 0 : e.options.onColumnSizingInfoChange(t), e.resetColumnSizing = (t) => {
      var r;
      e.setColumnSizing(t ? {} : (r = e.initialState.columnSizing) != null ? r : {});
    }, e.resetHeaderSizeInfo = (t) => {
      var r;
      e.setColumnSizingInfo(t ? bN() : (r = e.initialState.columnSizingInfo) != null ? r : bN());
    }, e.getTotalSize = () => {
      var t, r;
      return (t = (r = e.getHeaderGroups()[0]) == null ? void 0 : r.headers.reduce((a, i) => a + i.getSize(), 0)) != null ? t : 0;
    }, e.getLeftTotalSize = () => {
      var t, r;
      return (t = (r = e.getLeftHeaderGroups()[0]) == null ? void 0 : r.headers.reduce((a, i) => a + i.getSize(), 0)) != null ? t : 0;
    }, e.getCenterTotalSize = () => {
      var t, r;
      return (t = (r = e.getCenterHeaderGroups()[0]) == null ? void 0 : r.headers.reduce((a, i) => a + i.getSize(), 0)) != null ? t : 0;
    }, e.getRightTotalSize = () => {
      var t, r;
      return (t = (r = e.getRightHeaderGroups()[0]) == null ? void 0 : r.headers.reduce((a, i) => a + i.getSize(), 0)) != null ? t : 0;
    };
  }
};
let UP = null;
function b9t() {
  if (typeof UP == "boolean") return UP;
  let e = !1;
  try {
    const t = {
      get passive() {
        return e = !0, !1;
      }
    }, r = () => {
    };
    window.addEventListener("test", r, t), window.removeEventListener("test", r);
  } catch {
    e = !1;
  }
  return UP = e, UP;
}
function yN(e) {
  return e.type === "touchstart";
}
const y9t = {
  getInitialState: (e) => ({
    columnVisibility: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnVisibilityChange: z0("columnVisibility", e)
  }),
  createColumn: (e, t) => {
    e.toggleVisibility = (r) => {
      e.getCanHide() && t.setColumnVisibility((a) => ({
        ...a,
        [e.id]: r ?? !e.getIsVisible()
      }));
    }, e.getIsVisible = () => {
      var r, a;
      const i = e.columns;
      return (r = i.length ? i.some((c) => c.getIsVisible()) : (a = t.getState().columnVisibility) == null ? void 0 : a[e.id]) != null ? r : !0;
    }, e.getCanHide = () => {
      var r, a;
      return ((r = e.columnDef.enableHiding) != null ? r : !0) && ((a = t.options.enableHiding) != null ? a : !0);
    }, e.getToggleVisibilityHandler = () => (r) => {
      e.toggleVisibility == null || e.toggleVisibility(r.target.checked);
    };
  },
  createRow: (e, t) => {
    e._getAllVisibleCells = la(() => [e.getAllCells(), t.getState().columnVisibility], (r) => r.filter((a) => a.column.getIsVisible()), sa(t.options, "debugRows", "_getAllVisibleCells")), e.getVisibleCells = la(() => [e.getLeftVisibleCells(), e.getCenterVisibleCells(), e.getRightVisibleCells()], (r, a, i) => [...r, ...a, ...i], sa(t.options, "debugRows", "getVisibleCells"));
  },
  createTable: (e) => {
    const t = (r, a) => la(() => [a(), a().filter((i) => i.getIsVisible()).map((i) => i.id).join("_")], (i) => i.filter((c) => c.getIsVisible == null ? void 0 : c.getIsVisible()), sa(e.options, "debugColumns", r));
    e.getVisibleFlatColumns = t("getVisibleFlatColumns", () => e.getAllFlatColumns()), e.getVisibleLeafColumns = t("getVisibleLeafColumns", () => e.getAllLeafColumns()), e.getLeftVisibleLeafColumns = t("getLeftVisibleLeafColumns", () => e.getLeftLeafColumns()), e.getRightVisibleLeafColumns = t("getRightVisibleLeafColumns", () => e.getRightLeafColumns()), e.getCenterVisibleLeafColumns = t("getCenterVisibleLeafColumns", () => e.getCenterLeafColumns()), e.setColumnVisibility = (r) => e.options.onColumnVisibilityChange == null ? void 0 : e.options.onColumnVisibilityChange(r), e.resetColumnVisibility = (r) => {
      var a;
      e.setColumnVisibility(r ? {} : (a = e.initialState.columnVisibility) != null ? a : {});
    }, e.toggleAllColumnsVisible = (r) => {
      var a;
      r = (a = r) != null ? a : !e.getIsAllColumnsVisible(), e.setColumnVisibility(e.getAllLeafColumns().reduce((i, c) => ({
        ...i,
        [c.id]: r || !(c.getCanHide != null && c.getCanHide())
      }), {}));
    }, e.getIsAllColumnsVisible = () => !e.getAllLeafColumns().some((r) => !(r.getIsVisible != null && r.getIsVisible())), e.getIsSomeColumnsVisible = () => e.getAllLeafColumns().some((r) => r.getIsVisible == null ? void 0 : r.getIsVisible()), e.getToggleAllColumnsVisibilityHandler = () => (r) => {
      var a;
      e.toggleAllColumnsVisible((a = r.target) == null ? void 0 : a.checked);
    };
  }
};
function wE(e, t) {
  return t ? t === "center" ? e.getCenterVisibleLeafColumns() : t === "left" ? e.getLeftVisibleLeafColumns() : e.getRightVisibleLeafColumns() : e.getVisibleLeafColumns();
}
const w9t = {
  createTable: (e) => {
    e._getGlobalFacetedRowModel = e.options.getFacetedRowModel && e.options.getFacetedRowModel(e, "__global__"), e.getGlobalFacetedRowModel = () => e.options.manualFiltering || !e._getGlobalFacetedRowModel ? e.getPreFilteredRowModel() : e._getGlobalFacetedRowModel(), e._getGlobalFacetedUniqueValues = e.options.getFacetedUniqueValues && e.options.getFacetedUniqueValues(e, "__global__"), e.getGlobalFacetedUniqueValues = () => e._getGlobalFacetedUniqueValues ? e._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getGlobalFacetedMinMaxValues = e.options.getFacetedMinMaxValues && e.options.getFacetedMinMaxValues(e, "__global__"), e.getGlobalFacetedMinMaxValues = () => {
      if (e._getGlobalFacetedMinMaxValues)
        return e._getGlobalFacetedMinMaxValues();
    };
  }
}, S9t = {
  getInitialState: (e) => ({
    globalFilter: void 0,
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGlobalFilterChange: z0("globalFilter", e),
    globalFilterFn: "auto",
    getColumnCanGlobalFilter: (t) => {
      var r;
      const a = (r = e.getCoreRowModel().flatRows[0]) == null || (r = r._getAllCellsByColumnId()[t.id]) == null ? void 0 : r.getValue();
      return typeof a == "string" || typeof a == "number";
    }
  }),
  createColumn: (e, t) => {
    e.getCanGlobalFilter = () => {
      var r, a, i, c;
      return ((r = e.columnDef.enableGlobalFilter) != null ? r : !0) && ((a = t.options.enableGlobalFilter) != null ? a : !0) && ((i = t.options.enableFilters) != null ? i : !0) && ((c = t.options.getColumnCanGlobalFilter == null ? void 0 : t.options.getColumnCanGlobalFilter(e)) != null ? c : !0) && !!e.accessorFn;
    };
  },
  createTable: (e) => {
    e.getGlobalAutoFilterFn = () => Yw.includesString, e.getGlobalFilterFn = () => {
      var t, r;
      const {
        globalFilterFn: a
      } = e.options;
      return iO(a) ? a : a === "auto" ? e.getGlobalAutoFilterFn() : (t = (r = e.options.filterFns) == null ? void 0 : r[a]) != null ? t : Yw[a];
    }, e.setGlobalFilter = (t) => {
      e.options.onGlobalFilterChange == null || e.options.onGlobalFilterChange(t);
    }, e.resetGlobalFilter = (t) => {
      e.setGlobalFilter(t ? void 0 : e.initialState.globalFilter);
    };
  }
}, C9t = {
  getInitialState: (e) => ({
    expanded: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onExpandedChange: z0("expanded", e),
    paginateExpandedRows: !0
  }),
  createTable: (e) => {
    let t = !1, r = !1;
    e._autoResetExpanded = () => {
      var a, i;
      if (!t) {
        e._queue(() => {
          t = !0;
        });
        return;
      }
      if ((a = (i = e.options.autoResetAll) != null ? i : e.options.autoResetExpanded) != null ? a : !e.options.manualExpanding) {
        if (r) return;
        r = !0, e._queue(() => {
          e.resetExpanded(), r = !1;
        });
      }
    }, e.setExpanded = (a) => e.options.onExpandedChange == null ? void 0 : e.options.onExpandedChange(a), e.toggleAllRowsExpanded = (a) => {
      a ?? !e.getIsAllRowsExpanded() ? e.setExpanded(!0) : e.setExpanded({});
    }, e.resetExpanded = (a) => {
      var i, c;
      e.setExpanded(a ? {} : (i = (c = e.initialState) == null ? void 0 : c.expanded) != null ? i : {});
    }, e.getCanSomeRowsExpand = () => e.getPrePaginationRowModel().flatRows.some((a) => a.getCanExpand()), e.getToggleAllRowsExpandedHandler = () => (a) => {
      a.persist == null || a.persist(), e.toggleAllRowsExpanded();
    }, e.getIsSomeRowsExpanded = () => {
      const a = e.getState().expanded;
      return a === !0 || Object.values(a).some(Boolean);
    }, e.getIsAllRowsExpanded = () => {
      const a = e.getState().expanded;
      return typeof a == "boolean" ? a === !0 : !(!Object.keys(a).length || e.getRowModel().flatRows.some((i) => !i.getIsExpanded()));
    }, e.getExpandedDepth = () => {
      let a = 0;
      return (e.getState().expanded === !0 ? Object.keys(e.getRowModel().rowsById) : Object.keys(e.getState().expanded)).forEach((c) => {
        const d = c.split(".");
        a = Math.max(a, d.length);
      }), a;
    }, e.getPreExpandedRowModel = () => e.getSortedRowModel(), e.getExpandedRowModel = () => (!e._getExpandedRowModel && e.options.getExpandedRowModel && (e._getExpandedRowModel = e.options.getExpandedRowModel(e)), e.options.manualExpanding || !e._getExpandedRowModel ? e.getPreExpandedRowModel() : e._getExpandedRowModel());
  },
  createRow: (e, t) => {
    e.toggleExpanded = (r) => {
      t.setExpanded((a) => {
        var i;
        const c = a === !0 ? !0 : !!(a != null && a[e.id]);
        let d = {};
        if (a === !0 ? Object.keys(t.getRowModel().rowsById).forEach((f) => {
          d[f] = !0;
        }) : d = a, r = (i = r) != null ? i : !c, !c && r)
          return {
            ...d,
            [e.id]: !0
          };
        if (c && !r) {
          const {
            [e.id]: f,
            ...p
          } = d;
          return p;
        }
        return a;
      });
    }, e.getIsExpanded = () => {
      var r;
      const a = t.getState().expanded;
      return !!((r = t.options.getIsRowExpanded == null ? void 0 : t.options.getIsRowExpanded(e)) != null ? r : a === !0 || a?.[e.id]);
    }, e.getCanExpand = () => {
      var r, a, i;
      return (r = t.options.getRowCanExpand == null ? void 0 : t.options.getRowCanExpand(e)) != null ? r : ((a = t.options.enableExpanding) != null ? a : !0) && !!((i = e.subRows) != null && i.length);
    }, e.getIsAllParentsExpanded = () => {
      let r = !0, a = e;
      for (; r && a.parentId; )
        a = t.getRow(a.parentId, !0), r = a.getIsExpanded();
      return r;
    }, e.getToggleExpandedHandler = () => {
      const r = e.getCanExpand();
      return () => {
        r && e.toggleExpanded();
      };
    };
  }
}, hz = 0, pz = 10, wN = () => ({
  pageIndex: hz,
  pageSize: pz
}), x9t = {
  getInitialState: (e) => ({
    ...e,
    pagination: {
      ...wN(),
      ...e?.pagination
    }
  }),
  getDefaultOptions: (e) => ({
    onPaginationChange: z0("pagination", e)
  }),
  createTable: (e) => {
    let t = !1, r = !1;
    e._autoResetPageIndex = () => {
      var a, i;
      if (!t) {
        e._queue(() => {
          t = !0;
        });
        return;
      }
      if ((a = (i = e.options.autoResetAll) != null ? i : e.options.autoResetPageIndex) != null ? a : !e.options.manualPagination) {
        if (r) return;
        r = !0, e._queue(() => {
          e.resetPageIndex(), r = !1;
        });
      }
    }, e.setPagination = (a) => {
      const i = (c) => $S(a, c);
      return e.options.onPaginationChange == null ? void 0 : e.options.onPaginationChange(i);
    }, e.resetPagination = (a) => {
      var i;
      e.setPagination(a ? wN() : (i = e.initialState.pagination) != null ? i : wN());
    }, e.setPageIndex = (a) => {
      e.setPagination((i) => {
        let c = $S(a, i.pageIndex);
        const d = typeof e.options.pageCount > "u" || e.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : e.options.pageCount - 1;
        return c = Math.max(0, Math.min(c, d)), {
          ...i,
          pageIndex: c
        };
      });
    }, e.resetPageIndex = (a) => {
      var i, c;
      e.setPageIndex(a ? hz : (i = (c = e.initialState) == null || (c = c.pagination) == null ? void 0 : c.pageIndex) != null ? i : hz);
    }, e.resetPageSize = (a) => {
      var i, c;
      e.setPageSize(a ? pz : (i = (c = e.initialState) == null || (c = c.pagination) == null ? void 0 : c.pageSize) != null ? i : pz);
    }, e.setPageSize = (a) => {
      e.setPagination((i) => {
        const c = Math.max(1, $S(a, i.pageSize)), d = i.pageSize * i.pageIndex, f = Math.floor(d / c);
        return {
          ...i,
          pageIndex: f,
          pageSize: c
        };
      });
    }, e.setPageCount = (a) => e.setPagination((i) => {
      var c;
      let d = $S(a, (c = e.options.pageCount) != null ? c : -1);
      return typeof d == "number" && (d = Math.max(-1, d)), {
        ...i,
        pageCount: d
      };
    }), e.getPageOptions = la(() => [e.getPageCount()], (a) => {
      let i = [];
      return a && a > 0 && (i = [...new Array(a)].fill(null).map((c, d) => d)), i;
    }, sa(e.options, "debugTable", "getPageOptions")), e.getCanPreviousPage = () => e.getState().pagination.pageIndex > 0, e.getCanNextPage = () => {
      const {
        pageIndex: a
      } = e.getState().pagination, i = e.getPageCount();
      return i === -1 ? !0 : i === 0 ? !1 : a < i - 1;
    }, e.previousPage = () => e.setPageIndex((a) => a - 1), e.nextPage = () => e.setPageIndex((a) => a + 1), e.firstPage = () => e.setPageIndex(0), e.lastPage = () => e.setPageIndex(e.getPageCount() - 1), e.getPrePaginationRowModel = () => e.getExpandedRowModel(), e.getPaginationRowModel = () => (!e._getPaginationRowModel && e.options.getPaginationRowModel && (e._getPaginationRowModel = e.options.getPaginationRowModel(e)), e.options.manualPagination || !e._getPaginationRowModel ? e.getPrePaginationRowModel() : e._getPaginationRowModel()), e.getPageCount = () => {
      var a;
      return (a = e.options.pageCount) != null ? a : Math.ceil(e.getRowCount() / e.getState().pagination.pageSize);
    }, e.getRowCount = () => {
      var a;
      return (a = e.options.rowCount) != null ? a : e.getPrePaginationRowModel().rows.length;
    };
  }
}, SN = () => ({
  top: [],
  bottom: []
}), E9t = {
  getInitialState: (e) => ({
    rowPinning: SN(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowPinningChange: z0("rowPinning", e)
  }),
  createRow: (e, t) => {
    e.pin = (r, a, i) => {
      const c = a ? e.getLeafRows().map((p) => {
        let {
          id: g
        } = p;
        return g;
      }) : [], d = i ? e.getParentRows().map((p) => {
        let {
          id: g
        } = p;
        return g;
      }) : [], f = /* @__PURE__ */ new Set([...d, e.id, ...c]);
      t.setRowPinning((p) => {
        var g, b;
        if (r === "bottom") {
          var w, x;
          return {
            top: ((w = p?.top) != null ? w : []).filter((k) => !(f != null && f.has(k))),
            bottom: [...((x = p?.bottom) != null ? x : []).filter((k) => !(f != null && f.has(k))), ...Array.from(f)]
          };
        }
        if (r === "top") {
          var E, P;
          return {
            top: [...((E = p?.top) != null ? E : []).filter((k) => !(f != null && f.has(k))), ...Array.from(f)],
            bottom: ((P = p?.bottom) != null ? P : []).filter((k) => !(f != null && f.has(k)))
          };
        }
        return {
          top: ((g = p?.top) != null ? g : []).filter((k) => !(f != null && f.has(k))),
          bottom: ((b = p?.bottom) != null ? b : []).filter((k) => !(f != null && f.has(k)))
        };
      });
    }, e.getCanPin = () => {
      var r;
      const {
        enableRowPinning: a,
        enablePinning: i
      } = t.options;
      return typeof a == "function" ? a(e) : (r = a ?? i) != null ? r : !0;
    }, e.getIsPinned = () => {
      const r = [e.id], {
        top: a,
        bottom: i
      } = t.getState().rowPinning, c = r.some((f) => a?.includes(f)), d = r.some((f) => i?.includes(f));
      return c ? "top" : d ? "bottom" : !1;
    }, e.getPinnedIndex = () => {
      var r, a;
      const i = e.getIsPinned();
      if (!i) return -1;
      const c = (r = i === "top" ? t.getTopRows() : t.getBottomRows()) == null ? void 0 : r.map((d) => {
        let {
          id: f
        } = d;
        return f;
      });
      return (a = c?.indexOf(e.id)) != null ? a : -1;
    };
  },
  createTable: (e) => {
    e.setRowPinning = (t) => e.options.onRowPinningChange == null ? void 0 : e.options.onRowPinningChange(t), e.resetRowPinning = (t) => {
      var r, a;
      return e.setRowPinning(t ? SN() : (r = (a = e.initialState) == null ? void 0 : a.rowPinning) != null ? r : SN());
    }, e.getIsSomeRowsPinned = (t) => {
      var r;
      const a = e.getState().rowPinning;
      if (!t) {
        var i, c;
        return !!((i = a.top) != null && i.length || (c = a.bottom) != null && c.length);
      }
      return !!((r = a[t]) != null && r.length);
    }, e._getPinnedRows = (t, r, a) => {
      var i;
      return ((i = e.options.keepPinnedRows) == null || i ? (
        //get all rows that are pinned even if they would not be otherwise visible
        //account for expanded parent rows, but not pagination or filtering
        (r ?? []).map((d) => {
          const f = e.getRow(d, !0);
          return f.getIsAllParentsExpanded() ? f : null;
        })
      ) : (
        //else get only visible rows that are pinned
        (r ?? []).map((d) => t.find((f) => f.id === d))
      )).filter(Boolean).map((d) => ({
        ...d,
        position: a
      }));
    }, e.getTopRows = la(() => [e.getRowModel().rows, e.getState().rowPinning.top], (t, r) => e._getPinnedRows(t, r, "top"), sa(e.options, "debugRows", "getTopRows")), e.getBottomRows = la(() => [e.getRowModel().rows, e.getState().rowPinning.bottom], (t, r) => e._getPinnedRows(t, r, "bottom"), sa(e.options, "debugRows", "getBottomRows")), e.getCenterRows = la(() => [e.getRowModel().rows, e.getState().rowPinning.top, e.getState().rowPinning.bottom], (t, r, a) => {
      const i = /* @__PURE__ */ new Set([...r ?? [], ...a ?? []]);
      return t.filter((c) => !i.has(c.id));
    }, sa(e.options, "debugRows", "getCenterRows"));
  }
}, P9t = {
  getInitialState: (e) => ({
    rowSelection: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowSelectionChange: z0("rowSelection", e),
    enableRowSelection: !0,
    enableMultiRowSelection: !0,
    enableSubRowSelection: !0
    // enableGroupingRowSelection: false,
    // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
    // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
  }),
  createTable: (e) => {
    e.setRowSelection = (t) => e.options.onRowSelectionChange == null ? void 0 : e.options.onRowSelectionChange(t), e.resetRowSelection = (t) => {
      var r;
      return e.setRowSelection(t ? {} : (r = e.initialState.rowSelection) != null ? r : {});
    }, e.toggleAllRowsSelected = (t) => {
      e.setRowSelection((r) => {
        t = typeof t < "u" ? t : !e.getIsAllRowsSelected();
        const a = {
          ...r
        }, i = e.getPreGroupedRowModel().flatRows;
        return t ? i.forEach((c) => {
          c.getCanSelect() && (a[c.id] = !0);
        }) : i.forEach((c) => {
          delete a[c.id];
        }), a;
      });
    }, e.toggleAllPageRowsSelected = (t) => e.setRowSelection((r) => {
      const a = typeof t < "u" ? t : !e.getIsAllPageRowsSelected(), i = {
        ...r
      };
      return e.getRowModel().rows.forEach((c) => {
        gz(i, c.id, a, !0, e);
      }), i;
    }), e.getPreSelectedRowModel = () => e.getCoreRowModel(), e.getSelectedRowModel = la(() => [e.getState().rowSelection, e.getCoreRowModel()], (t, r) => Object.keys(t).length ? CN(e, r) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, sa(e.options, "debugTable", "getSelectedRowModel")), e.getFilteredSelectedRowModel = la(() => [e.getState().rowSelection, e.getFilteredRowModel()], (t, r) => Object.keys(t).length ? CN(e, r) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, sa(e.options, "debugTable", "getFilteredSelectedRowModel")), e.getGroupedSelectedRowModel = la(() => [e.getState().rowSelection, e.getSortedRowModel()], (t, r) => Object.keys(t).length ? CN(e, r) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, sa(e.options, "debugTable", "getGroupedSelectedRowModel")), e.getIsAllRowsSelected = () => {
      const t = e.getFilteredRowModel().flatRows, {
        rowSelection: r
      } = e.getState();
      let a = !!(t.length && Object.keys(r).length);
      return a && t.some((i) => i.getCanSelect() && !r[i.id]) && (a = !1), a;
    }, e.getIsAllPageRowsSelected = () => {
      const t = e.getPaginationRowModel().flatRows.filter((i) => i.getCanSelect()), {
        rowSelection: r
      } = e.getState();
      let a = !!t.length;
      return a && t.some((i) => !r[i.id]) && (a = !1), a;
    }, e.getIsSomeRowsSelected = () => {
      var t;
      const r = Object.keys((t = e.getState().rowSelection) != null ? t : {}).length;
      return r > 0 && r < e.getFilteredRowModel().flatRows.length;
    }, e.getIsSomePageRowsSelected = () => {
      const t = e.getPaginationRowModel().flatRows;
      return e.getIsAllPageRowsSelected() ? !1 : t.filter((r) => r.getCanSelect()).some((r) => r.getIsSelected() || r.getIsSomeSelected());
    }, e.getToggleAllRowsSelectedHandler = () => (t) => {
      e.toggleAllRowsSelected(t.target.checked);
    }, e.getToggleAllPageRowsSelectedHandler = () => (t) => {
      e.toggleAllPageRowsSelected(t.target.checked);
    };
  },
  createRow: (e, t) => {
    e.toggleSelected = (r, a) => {
      const i = e.getIsSelected();
      t.setRowSelection((c) => {
        var d;
        if (r = typeof r < "u" ? r : !i, e.getCanSelect() && i === r)
          return c;
        const f = {
          ...c
        };
        return gz(f, e.id, r, (d = a?.selectChildren) != null ? d : !0, t), f;
      });
    }, e.getIsSelected = () => {
      const {
        rowSelection: r
      } = t.getState();
      return jL(e, r);
    }, e.getIsSomeSelected = () => {
      const {
        rowSelection: r
      } = t.getState();
      return vz(e, r) === "some";
    }, e.getIsAllSubRowsSelected = () => {
      const {
        rowSelection: r
      } = t.getState();
      return vz(e, r) === "all";
    }, e.getCanSelect = () => {
      var r;
      return typeof t.options.enableRowSelection == "function" ? t.options.enableRowSelection(e) : (r = t.options.enableRowSelection) != null ? r : !0;
    }, e.getCanSelectSubRows = () => {
      var r;
      return typeof t.options.enableSubRowSelection == "function" ? t.options.enableSubRowSelection(e) : (r = t.options.enableSubRowSelection) != null ? r : !0;
    }, e.getCanMultiSelect = () => {
      var r;
      return typeof t.options.enableMultiRowSelection == "function" ? t.options.enableMultiRowSelection(e) : (r = t.options.enableMultiRowSelection) != null ? r : !0;
    }, e.getToggleSelectedHandler = () => {
      const r = e.getCanSelect();
      return (a) => {
        var i;
        r && e.toggleSelected((i = a.target) == null ? void 0 : i.checked);
      };
    };
  }
}, gz = (e, t, r, a, i) => {
  var c;
  const d = i.getRow(t, !0);
  r ? (d.getCanMultiSelect() || Object.keys(e).forEach((f) => delete e[f]), d.getCanSelect() && (e[t] = !0)) : delete e[t], a && (c = d.subRows) != null && c.length && d.getCanSelectSubRows() && d.subRows.forEach((f) => gz(e, f.id, r, a, i));
};
function CN(e, t) {
  const r = e.getState().rowSelection, a = [], i = {}, c = function(d, f) {
    return d.map((p) => {
      var g;
      const b = jL(p, r);
      if (b && (a.push(p), i[p.id] = p), (g = p.subRows) != null && g.length && (p = {
        ...p,
        subRows: c(p.subRows)
      }), b)
        return p;
    }).filter(Boolean);
  };
  return {
    rows: c(t.rows),
    flatRows: a,
    rowsById: i
  };
}
function jL(e, t) {
  var r;
  return (r = t[e.id]) != null ? r : !1;
}
function vz(e, t, r) {
  var a;
  if (!((a = e.subRows) != null && a.length)) return !1;
  let i = !0, c = !1;
  return e.subRows.forEach((d) => {
    if (!(c && !i) && (d.getCanSelect() && (jL(d, t) ? c = !0 : i = !1), d.subRows && d.subRows.length)) {
      const f = vz(d, t);
      f === "all" ? c = !0 : (f === "some" && (c = !0), i = !1);
    }
  }), i ? "all" : c ? "some" : !1;
}
const bz = /([0-9]+)/gm, k9t = (e, t, r) => wie(ZS(e.getValue(r)).toLowerCase(), ZS(t.getValue(r)).toLowerCase()), M9t = (e, t, r) => wie(ZS(e.getValue(r)), ZS(t.getValue(r))), O9t = (e, t, r) => IL(ZS(e.getValue(r)).toLowerCase(), ZS(t.getValue(r)).toLowerCase()), T9t = (e, t, r) => IL(ZS(e.getValue(r)), ZS(t.getValue(r))), R9t = (e, t, r) => {
  const a = e.getValue(r), i = t.getValue(r);
  return a > i ? 1 : a < i ? -1 : 0;
}, A9t = (e, t, r) => IL(e.getValue(r), t.getValue(r));
function IL(e, t) {
  return e === t ? 0 : e > t ? 1 : -1;
}
function ZS(e) {
  return typeof e == "number" ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : typeof e == "string" ? e : "";
}
function wie(e, t) {
  const r = e.split(bz).filter(Boolean), a = t.split(bz).filter(Boolean);
  for (; r.length && a.length; ) {
    const i = r.shift(), c = a.shift(), d = parseInt(i, 10), f = parseInt(c, 10), p = [d, f].sort();
    if (isNaN(p[0])) {
      if (i > c)
        return 1;
      if (c > i)
        return -1;
      continue;
    }
    if (isNaN(p[1]))
      return isNaN(d) ? -1 : 1;
    if (d > f)
      return 1;
    if (f > d)
      return -1;
  }
  return r.length - a.length;
}
const eE = {
  alphanumeric: k9t,
  alphanumericCaseSensitive: M9t,
  text: O9t,
  textCaseSensitive: T9t,
  datetime: R9t,
  basic: A9t
}, N9t = {
  getInitialState: (e) => ({
    sorting: [],
    ...e
  }),
  getDefaultColumnDef: () => ({
    sortingFn: "auto",
    sortUndefined: 1
  }),
  getDefaultOptions: (e) => ({
    onSortingChange: z0("sorting", e),
    isMultiSortEvent: (t) => t.shiftKey
  }),
  createColumn: (e, t) => {
    e.getAutoSortingFn = () => {
      const r = t.getFilteredRowModel().flatRows.slice(10);
      let a = !1;
      for (const i of r) {
        const c = i?.getValue(e.id);
        if (Object.prototype.toString.call(c) === "[object Date]")
          return eE.datetime;
        if (typeof c == "string" && (a = !0, c.split(bz).length > 1))
          return eE.alphanumeric;
      }
      return a ? eE.text : eE.basic;
    }, e.getAutoSortDir = () => {
      const r = t.getFilteredRowModel().flatRows[0];
      return typeof r?.getValue(e.id) == "string" ? "asc" : "desc";
    }, e.getSortingFn = () => {
      var r, a;
      if (!e)
        throw new Error();
      return iO(e.columnDef.sortingFn) ? e.columnDef.sortingFn : e.columnDef.sortingFn === "auto" ? e.getAutoSortingFn() : (r = (a = t.options.sortingFns) == null ? void 0 : a[e.columnDef.sortingFn]) != null ? r : eE[e.columnDef.sortingFn];
    }, e.toggleSorting = (r, a) => {
      const i = e.getNextSortingOrder(), c = typeof r < "u" && r !== null;
      t.setSorting((d) => {
        const f = d?.find((E) => E.id === e.id), p = d?.findIndex((E) => E.id === e.id);
        let g = [], b, w = c ? r : i === "desc";
        if (d != null && d.length && e.getCanMultiSort() && a ? f ? b = "toggle" : b = "add" : d != null && d.length && p !== d.length - 1 ? b = "replace" : f ? b = "toggle" : b = "replace", b === "toggle" && (c || i || (b = "remove")), b === "add") {
          var x;
          g = [...d, {
            id: e.id,
            desc: w
          }], g.splice(0, g.length - ((x = t.options.maxMultiSortColCount) != null ? x : Number.MAX_SAFE_INTEGER));
        } else b === "toggle" ? g = d.map((E) => E.id === e.id ? {
          ...E,
          desc: w
        } : E) : b === "remove" ? g = d.filter((E) => E.id !== e.id) : g = [{
          id: e.id,
          desc: w
        }];
        return g;
      });
    }, e.getFirstSortDir = () => {
      var r, a;
      return ((r = (a = e.columnDef.sortDescFirst) != null ? a : t.options.sortDescFirst) != null ? r : e.getAutoSortDir() === "desc") ? "desc" : "asc";
    }, e.getNextSortingOrder = (r) => {
      var a, i;
      const c = e.getFirstSortDir(), d = e.getIsSorted();
      return d ? d !== c && ((a = t.options.enableSortingRemoval) == null || a) && // If enableSortRemove, enable in general
      (!(r && (i = t.options.enableMultiRemove) != null) || i) ? !1 : d === "desc" ? "asc" : "desc" : c;
    }, e.getCanSort = () => {
      var r, a;
      return ((r = e.columnDef.enableSorting) != null ? r : !0) && ((a = t.options.enableSorting) != null ? a : !0) && !!e.accessorFn;
    }, e.getCanMultiSort = () => {
      var r, a;
      return (r = (a = e.columnDef.enableMultiSort) != null ? a : t.options.enableMultiSort) != null ? r : !!e.accessorFn;
    }, e.getIsSorted = () => {
      var r;
      const a = (r = t.getState().sorting) == null ? void 0 : r.find((i) => i.id === e.id);
      return a ? a.desc ? "desc" : "asc" : !1;
    }, e.getSortIndex = () => {
      var r, a;
      return (r = (a = t.getState().sorting) == null ? void 0 : a.findIndex((i) => i.id === e.id)) != null ? r : -1;
    }, e.clearSorting = () => {
      t.setSorting((r) => r != null && r.length ? r.filter((a) => a.id !== e.id) : []);
    }, e.getToggleSortingHandler = () => {
      const r = e.getCanSort();
      return (a) => {
        r && (a.persist == null || a.persist(), e.toggleSorting == null || e.toggleSorting(void 0, e.getCanMultiSort() ? t.options.isMultiSortEvent == null ? void 0 : t.options.isMultiSortEvent(a) : !1));
      };
    };
  },
  createTable: (e) => {
    e.setSorting = (t) => e.options.onSortingChange == null ? void 0 : e.options.onSortingChange(t), e.resetSorting = (t) => {
      var r, a;
      e.setSorting(t ? [] : (r = (a = e.initialState) == null ? void 0 : a.sorting) != null ? r : []);
    }, e.getPreSortedRowModel = () => e.getGroupedRowModel(), e.getSortedRowModel = () => (!e._getSortedRowModel && e.options.getSortedRowModel && (e._getSortedRowModel = e.options.getSortedRowModel(e)), e.options.manualSorting || !e._getSortedRowModel ? e.getPreSortedRowModel() : e._getSortedRowModel());
  }
}, D9t = [
  e9t,
  y9t,
  h9t,
  p9t,
  t9t,
  n9t,
  w9t,
  //depends on ColumnFaceting
  S9t,
  //depends on ColumnFiltering
  N9t,
  f9t,
  //depends on RowSorting
  C9t,
  x9t,
  E9t,
  P9t,
  v9t
];
function $9t(e) {
  var t, r;
  process.env.NODE_ENV !== "production" && (e.debugAll || e.debugTable) && console.info("Creating Table Instance...");
  const a = [...D9t, ...(t = e._features) != null ? t : []];
  let i = {
    _features: a
  };
  const c = i._features.reduce((x, E) => Object.assign(x, E.getDefaultOptions == null ? void 0 : E.getDefaultOptions(i)), {}), d = (x) => i.options.mergeOptions ? i.options.mergeOptions(c, x) : {
    ...c,
    ...x
  };
  let p = {
    ...{},
    ...(r = e.initialState) != null ? r : {}
  };
  i._features.forEach((x) => {
    var E;
    p = (E = x.getInitialState == null ? void 0 : x.getInitialState(p)) != null ? E : p;
  });
  const g = [];
  let b = !1;
  const w = {
    _features: a,
    options: {
      ...c,
      ...e
    },
    initialState: p,
    _queue: (x) => {
      g.push(x), b || (b = !0, Promise.resolve().then(() => {
        for (; g.length; )
          g.shift()();
        b = !1;
      }).catch((E) => setTimeout(() => {
        throw E;
      })));
    },
    reset: () => {
      i.setState(i.initialState);
    },
    setOptions: (x) => {
      const E = $S(x, i.options);
      i.options = d(E);
    },
    getState: () => i.options.state,
    setState: (x) => {
      i.options.onStateChange == null || i.options.onStateChange(x);
    },
    _getRowId: (x, E, P) => {
      var k;
      return (k = i.options.getRowId == null ? void 0 : i.options.getRowId(x, E, P)) != null ? k : `${P ? [P.id, E].join(".") : E}`;
    },
    getCoreRowModel: () => (i._getCoreRowModel || (i._getCoreRowModel = i.options.getCoreRowModel(i)), i._getCoreRowModel()),
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => i.getPaginationRowModel(),
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (x, E) => {
      let P = (E ? i.getPrePaginationRowModel() : i.getRowModel()).rowsById[x];
      if (!P && (P = i.getCoreRowModel().rowsById[x], !P))
        throw process.env.NODE_ENV !== "production" ? new Error(`getRow could not find row with ID: ${x}`) : new Error();
      return P;
    },
    _getDefaultColumnDef: la(() => [i.options.defaultColumn], (x) => {
      var E;
      return x = (E = x) != null ? E : {}, {
        header: (P) => {
          const k = P.header.column.columnDef;
          return k.accessorKey ? k.accessorKey : k.accessorFn ? k.id : null;
        },
        // footer: props => props.header.column.id,
        cell: (P) => {
          var k, M;
          return (k = (M = P.renderValue()) == null || M.toString == null ? void 0 : M.toString()) != null ? k : null;
        },
        ...i._features.reduce((P, k) => Object.assign(P, k.getDefaultColumnDef == null ? void 0 : k.getDefaultColumnDef()), {}),
        ...x
      };
    }, sa(e, "debugColumns", "_getDefaultColumnDef")),
    _getColumnDefs: () => i.options.columns,
    getAllColumns: la(() => [i._getColumnDefs()], (x) => {
      const E = function(P, k, M) {
        return M === void 0 && (M = 0), P.map((T) => {
          const N = Zkt(i, T, M, k), D = T;
          return N.columns = D.columns ? E(D.columns, N, M + 1) : [], N;
        });
      };
      return E(x);
    }, sa(e, "debugColumns", "getAllColumns")),
    getAllFlatColumns: la(() => [i.getAllColumns()], (x) => x.flatMap((E) => E.getFlatColumns()), sa(e, "debugColumns", "getAllFlatColumns")),
    _getAllFlatColumnsById: la(() => [i.getAllFlatColumns()], (x) => x.reduce((E, P) => (E[P.id] = P, E), {}), sa(e, "debugColumns", "getAllFlatColumnsById")),
    getAllLeafColumns: la(() => [i.getAllColumns(), i._getOrderColumnsFn()], (x, E) => {
      let P = x.flatMap((k) => k.getLeafColumns());
      return E(P);
    }, sa(e, "debugColumns", "getAllLeafColumns")),
    getColumn: (x) => {
      const E = i._getAllFlatColumnsById()[x];
      return process.env.NODE_ENV !== "production" && !E && console.error(`[Table] Column with id '${x}' does not exist.`), E;
    }
  };
  Object.assign(i, w);
  for (let x = 0; x < i._features.length; x++) {
    const E = i._features[x];
    E == null || E.createTable == null || E.createTable(i);
  }
  return i;
}
function z9t() {
  return (e) => la(() => [e.options.data], (t) => {
    const r = {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, a = function(i, c, d) {
      c === void 0 && (c = 0);
      const f = [];
      for (let g = 0; g < i.length; g++) {
        const b = $L(e, e._getRowId(i[g], g, d), i[g], g, c, void 0, d?.id);
        if (r.flatRows.push(b), r.rowsById[b.id] = b, f.push(b), e.options.getSubRows) {
          var p;
          b.originalSubRows = e.options.getSubRows(i[g], g), (p = b.originalSubRows) != null && p.length && (b.subRows = a(b.originalSubRows, c + 1, b));
        }
      }
      return f;
    };
    return r.rows = a(t), r;
  }, sa(e.options, "debugTable", "getRowModel", () => e._autoResetPageIndex()));
}
function j9t(e) {
  const t = [], r = (a) => {
    var i;
    t.push(a), (i = a.subRows) != null && i.length && a.getIsExpanded() && a.subRows.forEach(r);
  };
  return e.rows.forEach(r), {
    rows: t,
    flatRows: e.flatRows,
    rowsById: e.rowsById
  };
}
function I9t(e, t, r) {
  return r.options.filterFromLeafRows ? L9t(e, t, r) : H9t(e, t, r);
}
function L9t(e, t, r) {
  var a;
  const i = [], c = {}, d = (a = r.options.maxLeafRowFilterDepth) != null ? a : 100, f = function(p, g) {
    g === void 0 && (g = 0);
    const b = [];
    for (let x = 0; x < p.length; x++) {
      var w;
      let E = p[x];
      const P = $L(r, E.id, E.original, E.index, E.depth, void 0, E.parentId);
      if (P.columnFilters = E.columnFilters, (w = E.subRows) != null && w.length && g < d) {
        if (P.subRows = f(E.subRows, g + 1), E = P, t(E) && !P.subRows.length) {
          b.push(E), c[E.id] = E, i.push(E);
          continue;
        }
        if (t(E) || P.subRows.length) {
          b.push(E), c[E.id] = E, i.push(E);
          continue;
        }
      } else
        E = P, t(E) && (b.push(E), c[E.id] = E, i.push(E));
    }
    return b;
  };
  return {
    rows: f(e),
    flatRows: i,
    rowsById: c
  };
}
function H9t(e, t, r) {
  var a;
  const i = [], c = {}, d = (a = r.options.maxLeafRowFilterDepth) != null ? a : 100, f = function(p, g) {
    g === void 0 && (g = 0);
    const b = [];
    for (let x = 0; x < p.length; x++) {
      let E = p[x];
      if (t(E)) {
        var w;
        if ((w = E.subRows) != null && w.length && g < d) {
          const k = $L(r, E.id, E.original, E.index, E.depth, void 0, E.parentId);
          k.subRows = f(E.subRows, g + 1), E = k;
        }
        b.push(E), i.push(E), c[E.id] = E;
      }
    }
    return b;
  };
  return {
    rows: f(e),
    flatRows: i,
    rowsById: c
  };
}
function F9t() {
  return (e) => la(() => [e.getPreFilteredRowModel(), e.getState().columnFilters, e.getState().globalFilter], (t, r, a) => {
    if (!t.rows.length || !(r != null && r.length) && !a) {
      for (let x = 0; x < t.flatRows.length; x++)
        t.flatRows[x].columnFilters = {}, t.flatRows[x].columnFiltersMeta = {};
      return t;
    }
    const i = [], c = [];
    (r ?? []).forEach((x) => {
      var E;
      const P = e.getColumn(x.id);
      if (!P)
        return;
      const k = P.getFilterFn();
      if (!k) {
        process.env.NODE_ENV !== "production" && console.warn(`Could not find a valid 'column.filterFn' for column with the ID: ${P.id}.`);
        return;
      }
      i.push({
        id: x.id,
        filterFn: k,
        resolvedValue: (E = k.resolveFilterValue == null ? void 0 : k.resolveFilterValue(x.value)) != null ? E : x.value
      });
    });
    const d = (r ?? []).map((x) => x.id), f = e.getGlobalFilterFn(), p = e.getAllLeafColumns().filter((x) => x.getCanGlobalFilter());
    a && f && p.length && (d.push("__global__"), p.forEach((x) => {
      var E;
      c.push({
        id: x.id,
        filterFn: f,
        resolvedValue: (E = f.resolveFilterValue == null ? void 0 : f.resolveFilterValue(a)) != null ? E : a
      });
    }));
    let g, b;
    for (let x = 0; x < t.flatRows.length; x++) {
      const E = t.flatRows[x];
      if (E.columnFilters = {}, i.length)
        for (let P = 0; P < i.length; P++) {
          g = i[P];
          const k = g.id;
          E.columnFilters[k] = g.filterFn(E, k, g.resolvedValue, (M) => {
            E.columnFiltersMeta[k] = M;
          });
        }
      if (c.length) {
        for (let P = 0; P < c.length; P++) {
          b = c[P];
          const k = b.id;
          if (b.filterFn(E, k, b.resolvedValue, (M) => {
            E.columnFiltersMeta[k] = M;
          })) {
            E.columnFilters.__global__ = !0;
            break;
          }
        }
        E.columnFilters.__global__ !== !0 && (E.columnFilters.__global__ = !1);
      }
    }
    const w = (x) => {
      for (let E = 0; E < d.length; E++)
        if (x.columnFilters[d[E]] === !1)
          return !1;
      return !0;
    };
    return I9t(t.rows, w, e);
  }, sa(e.options, "debugTable", "getFilteredRowModel", () => e._autoResetPageIndex()));
}
function W9t(e) {
  return (t) => la(() => [t.getState().pagination, t.getPrePaginationRowModel(), t.options.paginateExpandedRows ? void 0 : t.getState().expanded], (r, a) => {
    if (!a.rows.length)
      return a;
    const {
      pageSize: i,
      pageIndex: c
    } = r;
    let {
      rows: d,
      flatRows: f,
      rowsById: p
    } = a;
    const g = i * c, b = g + i;
    d = d.slice(g, b);
    let w;
    t.options.paginateExpandedRows ? w = {
      rows: d,
      flatRows: f,
      rowsById: p
    } : w = j9t({
      rows: d,
      flatRows: f,
      rowsById: p
    }), w.flatRows = [];
    const x = (E) => {
      w.flatRows.push(E), E.subRows.length && E.subRows.forEach(x);
    };
    return w.rows.forEach(x), w;
  }, sa(t.options, "debugTable", "getPaginationRowModel"));
}
function V9t() {
  return (e) => la(() => [e.getState().sorting, e.getPreSortedRowModel()], (t, r) => {
    if (!r.rows.length || !(t != null && t.length))
      return r;
    const a = e.getState().sorting, i = [], c = a.filter((p) => {
      var g;
      return (g = e.getColumn(p.id)) == null ? void 0 : g.getCanSort();
    }), d = {};
    c.forEach((p) => {
      const g = e.getColumn(p.id);
      g && (d[p.id] = {
        sortUndefined: g.columnDef.sortUndefined,
        invertSorting: g.columnDef.invertSorting,
        sortingFn: g.getSortingFn()
      });
    });
    const f = (p) => {
      const g = p.map((b) => ({
        ...b
      }));
      return g.sort((b, w) => {
        for (let E = 0; E < c.length; E += 1) {
          var x;
          const P = c[E], k = d[P.id], M = k.sortUndefined, T = (x = P?.desc) != null ? x : !1;
          let N = 0;
          if (M) {
            const D = b.getValue(P.id), $ = w.getValue(P.id), j = D === void 0, I = $ === void 0;
            if (j || I) {
              if (M === "first") return j ? -1 : 1;
              if (M === "last") return j ? 1 : -1;
              N = j && I ? 0 : j ? M : -M;
            }
          }
          if (N === 0 && (N = k.sortingFn(b, w, P.id)), N !== 0)
            return T && (N *= -1), k.invertSorting && (N *= -1), N;
        }
        return b.index - w.index;
      }), g.forEach((b) => {
        var w;
        i.push(b), (w = b.subRows) != null && w.length && (b.subRows = f(b.subRows));
      }), g;
    };
    return {
      rows: f(r.rows),
      flatRows: i,
      rowsById: r.rowsById
    };
  }, sa(e.options, "debugTable", "getSortedRowModel", () => e._autoResetPageIndex()));
}
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function Sie(e, t) {
  return e ? _9t(e) ? /* @__PURE__ */ S.createElement(e, t) : e : null;
}
function _9t(e) {
  return B9t(e) || typeof e == "function" || U9t(e);
}
function B9t(e) {
  return typeof e == "function" && (() => {
    const t = Object.getPrototypeOf(e);
    return t.prototype && t.prototype.isReactComponent;
  })();
}
function U9t(e) {
  return typeof e == "object" && typeof e.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(e.$$typeof.description);
}
function X9t(e) {
  const t = {
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    ...e
  }, [r] = S.useState(() => ({
    current: $9t(t)
  })), [a, i] = S.useState(() => r.current.initialState);
  return r.current.setOptions((c) => ({
    ...c,
    ...e,
    state: {
      ...a,
      ...e.state
    },
    // Similarly, we'll maintain both our internal state and any user-provided
    // state.
    onStateChange: (d) => {
      i(d), e.onStateChange == null || e.onStateChange(d);
    }
  })), r.current;
}
const G9t = ({
  sorting: e,
  initialSorting: t = [],
  onSortChange: r,
  enableSorting: a
}) => {
  const i = e !== void 0, c = q9t({
    sorting: e,
    onSortChange: r,
    enableSorting: a
  }), d = mn(() => {
    if (!(!a || e !== void 0) && t.length !== 0)
      return Cie(t);
  }, [a, t, e]);
  return i ? {
    sortingState: c.sortingState,
    initialSortingState: void 0,
    handleSortingChange: c.handle
  } : {
    sortingState: void 0,
    initialSortingState: d,
    handleSortingChange: void 0
  };
}, q9t = ({
  sorting: e,
  onSortChange: t,
  enableSorting: r
}) => {
  const a = mn(
    () => e ? Cie(e) : void 0,
    [e]
  ), i = r && a !== void 0, c = Cn(
    (d) => {
      if (!i || a === void 0)
        return;
      const f = typeof d == "function" ? d(a) : d;
      t?.(K9t(f));
    },
    [i, a, t]
  );
  return i ? { sortingState: a, handle: c } : { sortingState: void 0, handle: void 0 };
};
function K9t(e) {
  return e.map(({ id: t, desc: r }) => ({
    columnId: t,
    direction: r ? "descending" : "ascending"
  }));
}
function Cie(e) {
  return e.map(({ columnId: t, direction: r }) => ({
    id: t,
    desc: r === "descending"
  }));
}
function Y9t(e) {
  const {
    columns: t,
    data: r,
    enableSorting: a,
    enableFiltering: i,
    enablePagination: c,
    manualSorting: d,
    manualPagination: f,
    columnFilters: p,
    onColumnFiltersChange: g,
    onPageSizeChange: b,
    onPageChange: w,
    onSortChange: x,
    sorting: E,
    pageCount: P,
    totalItems: k,
    pageIndex: M,
    pageSize: T,
    initialPageSize: N,
    initialSorting: D
  } = e, $ = a ?? !0, j = i ?? !0, I = c ?? !0, L = d ?? !1, F = mn(
    () => N ?? T ?? 10,
    [N, T]
  ), _ = mn(
    () => t.map((ae) => Q9t(ae)),
    [t]
  ), [W, Q] = Wn(
    () => ({
      pageIndex: M ?? 0,
      pageSize: T ?? F
    })
  ), { sortingState: U, initialSortingState: Y, handleSortingChange: G } = G9t({
    sorting: E,
    initialSorting: D,
    onSortChange: x,
    enableSorting: $
  });
  Er(() => {
    T === void 0 && Q((ae) => ae.pageSize === F ? ae : {
      ...ae,
      pageSize: F
    });
  }, [T, F]), Er(() => {
    M === void 0 && T === void 0 || Q((ae) => {
      const oe = {
        pageIndex: M ?? ae.pageIndex,
        pageSize: T ?? ae.pageSize
      };
      return oe.pageIndex === ae.pageIndex && oe.pageSize === ae.pageSize ? ae : oe;
    });
  }, [M, T]);
  const J = mn(
    () => ({
      pageIndex: M ?? W.pageIndex,
      pageSize: T ?? W.pageSize
    }),
    [
      W.pageIndex,
      W.pageSize,
      M,
      T
    ]
  ), H = mn(
    () => I && (f || typeof P == "number" || typeof k == "number" || typeof M == "number" || typeof T == "number"),
    [
      I,
      f,
      P,
      k,
      M,
      T
    ]
  ), K = mn(() => !I || !H ? r.length : typeof k == "number" ? k : r.length, [r.length, I, H, k]), X = H ? P ?? Math.max(
    1,
    Math.ceil(
      K / (J.pageSize === 0 ? 1 : J.pageSize)
    )
  ) : void 0, te = H ? K : void 0, ie = Cn(
    (ae) => {
      Q((oe) => {
        const fe = {
          pageIndex: M ?? oe.pageIndex,
          pageSize: T ?? oe.pageSize
        }, be = typeof ae == "function" ? ae(fe) : ae, me = typeof be.pageSize == "number" ? be.pageSize : fe.pageSize, De = me !== fe.pageSize, Me = typeof be.pageIndex == "number" ? be.pageIndex : fe.pageIndex, ze = Z9t(me), le = De ? eMt(
          fe,
          ze,
          K
        ) : Me, se = {
          pageIndex: M ?? le,
          pageSize: T ?? ze
        };
        return se.pageIndex === oe.pageIndex && se.pageSize === oe.pageSize ? oe : (se.pageIndex !== fe.pageIndex && w?.(se.pageIndex + 1), se.pageSize !== fe.pageSize && b?.(se.pageSize), se);
      });
    },
    [w, b, M, T, K]
  ), ee = Cn(
    (ae) => {
      if (!g)
        return;
      const oe = typeof ae == "function" ? ae(p ?? []) : ae;
      g(oe);
    },
    [g, p]
  );
  return {
    table: X9t({
      data: r,
      columns: _,
      getCoreRowModel: z9t(),
      getSortedRowModel: $ && !L ? V9t() : void 0,
      getFilteredRowModel: j ? F9t() : void 0,
      getPaginationRowModel: I && !H ? W9t() : void 0,
      onColumnFiltersChange: g ? ee : void 0,
      ...G ? { onSortingChange: G } : {},
      onPaginationChange: I ? ie : void 0,
      manualSorting: L,
      manualPagination: H,
      pageCount: X,
      state: {
        ...p === void 0 ? {} : { columnFilters: p },
        ...U === void 0 ? {} : { sorting: U },
        ...I ? { pagination: J } : {}
      },
      initialState: {
        pagination: {
          pageIndex: J.pageIndex,
          pageSize: J.pageSize
        },
        ...Y === void 0 ? {} : { sorting: Y }
      }
    }),
    resolvedPageCount: X,
    totalItemsForPagination: te
  };
}
function Q9t(e) {
  const {
    cellClassName: t,
    headerCellClassName: r,
    sortingFn: a,
    ...i
  } = e, c = J9t(a), d = {
    sortUndefined: -1,
    // undefined value at bottom on asc unless overridden
    ...i,
    meta: {
      cellClassName: t,
      headerCellClassName: r
    }
  };
  return c !== void 0 && (d.sortingFn = c), d;
}
function J9t(e) {
  return typeof e == "string" || e === void 0 ? e : (t, r, a) => e(
    nG(t),
    nG(r),
    a
  );
}
function nG(e) {
  return {
    getValue: (t) => e.getValue(t),
    original: e.original
  };
}
function Z9t(e) {
  return e > 0 ? e : 1;
}
function eMt(e, t, r) {
  const a = e.pageIndex * e.pageSize, i = Math.max(
    0,
    Math.ceil(r / t) - 1
  );
  return Math.min(Math.floor(a / t), i);
}
const tMt = ({ className: e, ...t }) => /* @__PURE__ */ V.jsx(
  "div",
  {
    "data-slot": "table-container",
    className: "font-(family-name:--font-sans) relative w-full",
    children: /* @__PURE__ */ V.jsx(
      "table",
      {
        "data-slot": "table",
        className: lt(
          "w-full caption-bottom border-separate border-spacing-0 text-sm",
          e
        ),
        ...t
      }
    )
  }
), nMt = ({
  className: e,
  ...t
}) => /* @__PURE__ */ V.jsx("thead", { "data-slot": "table-header", className: lt(e), ...t }), rMt = ({
  className: e,
  ...t
}) => /* @__PURE__ */ V.jsx("tbody", { "data-slot": "table-body", className: lt(e), ...t }), yz = ({ className: e, ...t }) => /* @__PURE__ */ V.jsx(
  "tr",
  {
    "data-slot": "table-row",
    className: lt(
      "data-[state=selected]:bg-muted border-(--table-border-color)",
      e
    ),
    ...t
  }
), aMt = ({
  className: e,
  ...t
}) => /* @__PURE__ */ V.jsx(
  "th",
  {
    "data-slot": "table-head",
    className: lt(
      "text-foreground h-10 whitespace-nowrap px-2 text-left align-middle font-medium [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]",
      e
    ),
    ...t
  }
), rG = ({
  className: e,
  ...t
}) => /* @__PURE__ */ V.jsx(
  "td",
  {
    "data-slot": "table-cell",
    className: lt(
      "whitespace-nowrap p-0 align-middle [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]",
      e
    ),
    ...t
  }
), oMt = ({
  table: e,
  columnsCount: t,
  rowClassName: r,
  enableRowHover: a = !1,
  hoverClassName: i = "hover:bg-(--table-row-hover-bg-color)",
  stripedRows: c = !1,
  showVerticalBorders: d = !1,
  showHorizontalBorders: f = !0,
  borderClassName: p = "border-(--table-border-color)",
  stickyHeader: g = !1,
  emptyStateDisplay: b
}) => {
  const { t: w } = fi();
  return /* @__PURE__ */ V.jsx(rMt, { children: e.getRowModel().rows?.length ? e.getRowModel().rows.map((x, E) => {
    const P = typeof r == "function" ? r(x.original) : r, k = E === e.getRowModel().rows.length - 1, M = f && !k;
    return /* @__PURE__ */ V.jsx(
      yz,
      {
        className: lt(
          c && E % 2 === 1 && "bg-(--table-even-row-color)",
          a && i,
          P,
          "border-b-0",
          p
        ),
        children: x.getVisibleCells().map((T) => {
          const N = T.column.columnDef.meta?.cellClassName, D = typeof N == "function" ? N({ getValue: T.getValue, row: T.row }) : N, $ = T.column.columnDef.size !== void 0, j = T.column.getSize();
          return /* @__PURE__ */ V.jsx(
            rG,
            {
              className: lt(
                d && "border-r",
                d && p,
                g && p,
                M && "border-b",
                M && p,
                D
              ),
              style: $ ? {
                width: j,
                minWidth: j,
                maxWidth: j
              } : void 0,
              children: /* @__PURE__ */ V.jsx("div", { className: "min-h-full p-2 [&:has([role=checkbox])]:pr-0", children: Sie(
                T.column.columnDef.cell,
                T.getContext()
              ) })
            },
            T.id
          );
        })
      },
      x.id
    );
  }) : /* @__PURE__ */ V.jsx(yz, { children: /* @__PURE__ */ V.jsx(rG, { colSpan: t, className: "h-24 text-center", children: /* @__PURE__ */ V.jsx("div", { className: "flex min-h-full items-center justify-center p-2", children: typeof b == "function" ? b : b ?? w("dataTable.noResults") }) }) }) });
}, iMt = ({
  table: e,
  showVerticalBorders: t = !1,
  borderClassName: r = "border-(--table-border-color)",
  headerClassName: a,
  stickyHeader: i = !1
}) => /* @__PURE__ */ V.jsx(nMt, { children: e.getHeaderGroups().map((c) => /* @__PURE__ */ V.jsx(
  yz,
  {
    className: lt(a, r),
    children: c.headers.map((d) => {
      const f = d.column.columnDef.meta, p = d.column.columnDef.enableSorting, g = {
        column: {
          toggleSorting: () => d.column.toggleSorting(),
          getIsSorted: () => d.column.getIsSorted(),
          getCanSort: () => !!p
        }
      }, b = typeof f?.headerCellClassName == "function" ? f.headerCellClassName(g) : f?.headerCellClassName, w = d.column.columnDef.size !== void 0, x = d.column.getSize();
      return /* @__PURE__ */ V.jsx(
        aMt,
        {
          scope: "col",
          "aria-sort": p ? d.column.getIsSorted() === "asc" ? "ascending" : d.column.getIsSorted() === "desc" ? "descending" : "none" : void 0,
          style: w ? {
            width: x,
            minWidth: x,
            maxWidth: x
          } : void 0,
          className: lt(
            "overflow-hidden border-b",
            r,
            t && ["border-r", r],
            i && [
              "sticky top-0 z-10 bg-[#F4F4F5]",
              a
            ],
            b
          ),
          children: /* @__PURE__ */ V.jsx(
            lMt,
            {
              header: d,
              headerCellClassName: b
            }
          )
        },
        d.id
      );
    })
  },
  c.id
)) }), lMt = ({
  header: e,
  headerCellClassName: t
}) => {
  const r = e.column.columnDef.enableSorting, a = r ? "button" : "div", i = e.column.getIsSorted(), c = e.column.columnDef, d = c.headerTooltip, f = typeof c.header == "string" ? c.header : e.id, p = r ? i === "asc" ? `${f}, sorted ascending` : i === "desc" ? `${f}, sorted descending` : `${f}, not sorted` : void 0, g = d === !0 ? f : typeof d == "string" ? d : void 0;
  return /* @__PURE__ */ V.jsxs(
    a,
    {
      className: lt(
        "flex w-full min-w-0 items-center gap-1",
        r && "cursor-pointer transition-colors hover:text-blue-700"
      ),
      onClick: r ? e.column.getToggleSortingHandler() : void 0,
      "aria-label": p,
      title: g,
      children: [
        /* @__PURE__ */ V.jsx("span", { className: lt("min-w-0 flex-1 text-left", t), children: e.isPlaceholder ? null : Sie(e.column.columnDef.header, e.getContext()) }),
        r && /* @__PURE__ */ V.jsx(sMt, { state: i })
      ]
    }
  );
}, sMt = ({ state: e }) => /* @__PURE__ */ V.jsx("div", { className: "w-2", children: e === "asc" ? /* @__PURE__ */ V.jsx(_f, { name: "caretUpFilled", width: 8, height: 6 }) : e === "desc" ? /* @__PURE__ */ V.jsx(_f, { name: "caretDownFilled", width: 8, height: 6 }) : null }), uMt = ({
  table: e,
  onPageSizeChange: t,
  onPageChange: r,
  pageSizeOptions: a = [10, 25, 50],
  totalItems: i,
  pageCount: c
}) => {
  const { t: d, i18n: f } = fi(), p = mn(
    () => new Intl.NumberFormat(f.language),
    [f.language]
  ), g = e.getState().pagination.pageSize, [b, w] = Wn(g.toString());
  Er(() => {
    w(g.toString());
  }, [g]);
  const x = (N) => {
    const D = Number(N);
    Number.isNaN(D) || D === g || (e.setPageSize(D), t?.(D));
  }, E = e.getState().pagination.pageIndex + 1, P = Math.max(c ?? e.getPageCount(), 1), k = typeof i == "number" ? i : e.getFilteredRowModel().rows.length, M = k === 0 ? 0 : e.getState().pagination.pageIndex * g + 1, T = k === 0 ? 0 : Math.min(
    (e.getState().pagination.pageIndex + 1) * g,
    k
  );
  return /* @__PURE__ */ V.jsxs("div", { className: "flex items-center justify-between", children: [
    /* @__PURE__ */ V.jsxs("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ V.jsx("span", { className: "text-sm", children: d("dataTable.pagination.itemsPerPage") }),
      /* @__PURE__ */ V.jsx(
        sS,
        {
          kind: "select",
          value: b,
          onChange: (N) => x(N),
          options: a.map((N) => ({
            value: N.toString(),
            label: p.format(N)
          })),
          className: "w-20",
          size: "medium"
        }
      ),
      /* @__PURE__ */ V.jsx("span", { className: "text-sm", children: d("dataTable.pagination.showingRange", {
        start: p.format(M),
        end: p.format(T),
        total: p.format(k)
      }) })
    ] }),
    /* @__PURE__ */ V.jsx(
      zPt,
      {
        currentPage: E,
        totalPages: P,
        onPageChange: (N) => {
          e.setPageIndex(N - 1), r?.(N);
        },
        hasPreviousPage: e.getCanPreviousPage(),
        hasNextPage: e.getCanNextPage()
      }
    )
  ] });
}, cMt = "border-separate border-spacing-0 [&_tr]:border-b-0 [&_td]:border-b [&_tbody_tr:last-child_td]:border-b-0", NTt = ({
  columns: e,
  data: t,
  enableSorting: r = !0,
  enableFiltering: a = !0,
  enablePagination: i = !0,
  manualSorting: c = !1,
  manualPagination: d = !1,
  columnFilters: f,
  onColumnFiltersChange: p,
  pageSizeOptions: g,
  initialPageSize: b = g ? g[0] : 10,
  onPageSizeChange: w,
  onPageChange: x,
  onSortChange: E,
  sorting: P,
  pageCount: k,
  totalItems: M,
  pageIndex: T,
  pageSize: N,
  rowClassName: D,
  enableRowHover: $ = !1,
  hoverClassName: j,
  stripedRows: I = !1,
  showVerticalBorders: L = !1,
  showHorizontalBorders: F = !0,
  borderClassName: _,
  headerClassName: W,
  initialSorting: Q,
  emptyStateDisplay: U,
  stickyHeader: Y = !1,
  maxHeight: G
}) => {
  const { table: J, resolvedPageCount: H, totalItemsForPagination: K } = Y9t({
    columns: e,
    data: t,
    enableSorting: r,
    enableFiltering: a,
    enablePagination: i,
    manualSorting: c,
    manualPagination: d,
    columnFilters: f,
    onColumnFiltersChange: p,
    initialPageSize: b,
    onPageSizeChange: w,
    onPageChange: x,
    onSortChange: E,
    sorting: P,
    pageCount: k,
    totalItems: M,
    pageIndex: T,
    pageSize: N,
    initialSorting: Q
  }), X = mn(
    () => G ? {
      maxHeight: typeof G == "number" ? `${G}px` : G
    } : void 0,
    [G]
  ), te = Y ? cMt : void 0, ie = /* @__PURE__ */ V.jsxs(tMt, { className: te, children: [
    /* @__PURE__ */ V.jsx(
      iMt,
      {
        table: J,
        showVerticalBorders: L,
        borderClassName: _,
        headerClassName: W,
        stickyHeader: Y
      }
    ),
    /* @__PURE__ */ V.jsx(
      oMt,
      {
        table: J,
        columnsCount: e.length,
        rowClassName: D,
        enableRowHover: $,
        hoverClassName: j,
        stripedRows: I,
        showVerticalBorders: L,
        showHorizontalBorders: F,
        borderClassName: _,
        stickyHeader: Y,
        emptyStateDisplay: U
      }
    )
  ] }), ee = /* @__PURE__ */ V.jsx(
    "div",
    {
      className: lt(
        "border-(--table-border-color) overflow-hidden rounded-lg border bg-white shadow-sm",
        _
      ),
      children: Y || G ? /* @__PURE__ */ V.jsx("div", { className: "overflow-y-auto", style: X, children: ie }) : ie
    }
  );
  return /* @__PURE__ */ V.jsx("div", { "data-preflight": !0, className: "contents", children: /* @__PURE__ */ V.jsx("div", { className: "font-sans", children: /* @__PURE__ */ V.jsxs("div", { className: "min-w-min space-y-4", children: [
    ee,
    i && /* @__PURE__ */ V.jsx(
      uMt,
      {
        table: J,
        onPageSizeChange: w,
        onPageChange: x,
        pageSizeOptions: g,
        totalItems: K,
        pageCount: H
      }
    )
  ] }) }) });
};
function dMt(e) {
  return {
    dataIndex: e.dataIndex,
    key: e.key ?? e.dataIndex,
    onHeaderCell: mMt(e),
    onCell: fMt(e),
    render: pMt(e),
    sortDirections: ["descend", "ascend"],
    sorter: hMt(e),
    title: gMt(e),
    width: e.width
  };
}
function fMt(e) {
  const { cellClassName: t, cellRowSpan: r } = e;
  return !t && !r ? void 0 : (i, c) => {
    let d;
    typeof t == "string" ? d = t : typeof t == "function" && (d = t({ isHeader: !1, column: e, record: i, rowIndex: c }));
    let f = 1;
    return typeof r == "number" ? f = r : typeof r == "function" && (f = () => r({ isHeader: !1, column: e, record: i, rowIndex: c })), {
      className: d,
      rowSpan: f
    };
  };
}
function mMt(e) {
  const { headerClassName: t } = e;
  return t ? () => ({
    className: typeof t == "string" ? t : t(e)
  }) : void 0;
}
function hMt(e) {
  const { sort: t } = e;
  if (t)
    return t;
}
function pMt(e) {
  const { renderCell: t } = e;
  return t ? (a, i, c) => t(a, i, c) : void 0;
}
function gMt(e) {
  const { title: t } = e;
  return t ? typeof t != "function" ? t : ({
    sortOrder: a,
    filters: i
  }) => t({
    sortOrder: xie(a),
    column: e,
    filters: i ?? void 0
  }) : void 0;
}
const aG = {
  currentPage: 0,
  currentPageSize: 10,
  pageSizes: [10, 20, 50, 100]
};
function vMt(e, t, r) {
  if (!e)
    return !1;
  const a = typeof e == "boolean" ? {
    ...aG
  } : {
    ...aG,
    ...e
  };
  return {
    pageSize: a.currentPageSize,
    pageSizeOptions: a.pageSizes?.map(String),
    showSizeChanger: a.showSizeChanger ?? !1,
    position: [t === "apollo" ? "bottomCenter" : "bottomLeft"],
    total: a.total ?? r.length,
    hideOnSinglePage: a.hideOnSinglePage ?? !1,
    onShowSizeChange: a.onShowSizeChange ?? (() => {
    }),
    onChange: a.onChange ?? (() => {
    })
  };
}
function bMt(e, t) {
  if (!e)
    return;
  const {
    columnHeader: r,
    onChange: a,
    onSelect: i,
    selection: c,
    setSelectionInputProperties: d
  } = e;
  if (c && c.length > 0 && !t)
    throw new Error(
      "Table component setRowKey property is required when rowSelection.selection property is provided"
    );
  const f = c ? c.map((g) => t(g)) : void 0;
  return {
    columnTitle: r,
    getCheckboxProps: d ? (g) => {
      const { visible: b } = d(g);
      return {
        style: {
          visibility: b ? "visible" : "hidden"
        }
      };
    } : void 0,
    onChange: a ? (g, b) => {
      a(b);
    } : void 0,
    onSelect: i ? (g) => {
      i(g);
    } : void 0,
    selectedRowKeys: f,
    type: "radio"
  };
}
function yMt({
  onSortChange: e,
  previousSorterReference: t
}) {
  return (r, a, i, c) => {
    const d = wMt(i);
    JSON.stringify(t.current) !== JSON.stringify(d) && (t.current = d, e?.(d));
  };
}
function wMt(e) {
  return (Array.isArray(e) ? e : [e]).filter(({ field: r, order: a }) => !!r && !!a).map(({ field: r, order: a }) => ({
    field: r,
    // Change this line to ensure correct typing
    direction: xie(a)
  }));
}
function xie(e) {
  return e === "ascend" ? "ascending" : e === "descend" ? "descending" : void 0;
}
const SMt = "_table_18826_11", CMt = {
  table: SMt
};
function xMt() {
  return {
    itemSizeSM: vo(
      "--Components-Pagination-Component-itemSizeSM"
    ),
    itemSize: vo(
      "--Components-Pagination-Component-itemSize"
    ),
    itemLinkBg: mr(
      "--Components-Pagination-Component-itemLinkBg"
    ),
    itemInputBg: mr(
      "--Components-Pagination-Component-itemInputBg"
    ),
    itemBg: mr("--Components-Pagination-Component-itemBg"),
    itemActiveColorDisabled: mr(
      "--Components-Pagination-Component-itemActiveColorDisabled"
    ),
    itemActiveBgDisabled: mr(
      "--Components-Pagination-Component-itemActiveBgDisabled"
    ),
    itemActiveBg: mr(
      "--Components-Pagination-Component-itemActiveBg"
    )
  };
}
function EMt() {
  return {
    screenSM: vo(
      "--Components-Pagination-Global-screenSM"
    ),
    screenLG: vo(
      "--Components-Pagination-Global-screenLG"
    ),
    paddingXXS: vo(
      "--Components-Pagination-Global-paddingXXS"
    ),
    paddingSM: vo(
      "--Components-Pagination-Global-paddingSM"
    ),
    marginXXS: vo(
      "--Components-Pagination-Global-marginXXS"
    ),
    marginXS: vo(
      "--Components-Pagination-Global-marginXS"
    ),
    marginSM: vo(
      "--Components-Pagination-Global-marginSM"
    ),
    margin: vo(
      "--Components-Pagination-Global-margin"
    ),
    lineWidthFocus: vo(
      "--Components-Pagination-Global-lineWidthFocus"
    ),
    lineWidth: vo(
      "--Components-Pagination-Global-lineWidth"
    ),
    lineHeightLG: vo(
      "--Components-Pagination-Global-lineHeightLG"
    ),
    lineHeight: vo(
      "--Components-Pagination-Global-lineHeight"
    ),
    fontWeightStrong: vo(
      "--Components-Pagination-Global-fontWeightStrong"
    ),
    fontSizeSM: vo(
      "--Components-Pagination-Global-fontSizeSM"
    ),
    fontSizeLG: vo(
      "--Components-Pagination-Global-fontSizeLG"
    ),
    fontSize: vo(
      "--Components-Pagination-Global-fontSize"
    ),
    controlPaddingHorizontalSM: vo(
      "--Components-Pagination-Global-controlPaddingHorizontalSM"
    ),
    controlPaddingHorizontal: vo(
      "--Components-Pagination-Global-controlPaddingHorizontal"
    ),
    controlOutlineWidth: vo(
      "--Components-Pagination-Global-controlOutlineWidth"
    ),
    controlOutline: mr(
      "--Components-Pagination-Global-controlOutline"
    ),
    controlItemBgActiveDisabled: mr(
      "--Components-Pagination-Global-controlItemBgActiveDisabled"
    ),
    controlHeightSM: vo(
      "--Components-Pagination-Global-controlHeightSM"
    ),
    controlHeightLG: vo(
      "--Components-Pagination-Global-controlHeightLG"
    ),
    controlHeight: vo(
      "--Components-Pagination-Global-controlHeight"
    ),
    borderRadiusSM: vo(
      "--Components-Pagination-Global-borderRadiusSM"
    ),
    borderRadiusLG: vo(
      "--Components-Pagination-Global-borderRadiusLG"
    ),
    borderRadius: vo(
      "--Components-Pagination-Global-borderRadius"
    ),
    colorWarningOutline: mr(
      "--Components-Pagination-Global-colorWarningOutline"
    ),
    colorWhite: mr(
      "--Components-Pagination-Global-colorWhite"
    ),
    colorTextLightSolid: mr(
      "--Components-Pagination-Global-colorTextLightSolid"
    ),
    colorTextPlaceholder: mr(
      "--Components-Pagination-Global-colorTextPlaceholder"
    ),
    colorTextDisabled: mr(
      "--Components-Pagination-Global-colorTextDisabled"
    ),
    colorText: mr("--Components-Pagination-Global-colorText"),
    colorPrimaryHover: mr(
      "--Components-Pagination-Global-colorPrimaryHover"
    ),
    colorPrimaryBorderHover: mr(
      "--Components-Pagination-Global-colorPrimaryBorderHover"
    ),
    colorPrimaryBorder: mr(
      "--Components-Pagination-Global-colorPrimaryBorder"
    ),
    colorPrimaryActive: mr(
      "--Components-Pagination-Global-colorPrimaryActive"
    ),
    colorPrimary: mr(
      "--Components-Pagination-Global-colorPrimary"
    ),
    colorFillAlter: mr(
      "--Components-Pagination-Global-colorFillAlter"
    ),
    colorErrorOutline: mr(
      "--Components-Pagination-Global-colorErrorOutline"
    ),
    colorBorder: mr(
      "--Components-Pagination-Global-colorBorder"
    ),
    colorBgTextHover: mr(
      "--Components-Pagination-Global-colorBgTextHover"
    ),
    colorBgTextActive: mr(
      "--Components-Pagination-Global-colorBgTextActive"
    ),
    colorBgContainerDisabled: mr(
      "--Components-Pagination-Global-colorBgContainerDisabled"
    ),
    colorBgContainer: mr(
      "--Components-Pagination-Global-colorBgContainer"
    )
  };
}
const DTt = (e) => {
  const {
    alternateRowColor: t = !0,
    columns: r,
    data: a = [],
    pagination: i = !1,
    rowSelection: c,
    setRowKey: d,
    size: f = "small",
    theme: p = "classic",
    width: g,
    rowClassName: b,
    onSortChange: w
  } = e, x = It([]), E = mn(() => r.map((D) => dMt(D)), [r]), P = mn(
    () => vMt(i, p, a),
    [i, p, a]
  ), k = mn(
    () => bMt(c, d),
    [d, c]
  ), M = mn(
    () => yMt({
      previousSorterReference: x,
      onSortChange: w
    }),
    [w]
  ), T = mn(() => {
    const $ = {
      classic: {
        borderRadius: 4,
        fontFamily: "inherit",
        headerColor: mr("--table-header-color"),
        headerBg: mr("--table-header-background")
      },
      apollo: {
        borderRadius: 4,
        fontFamily: "inherit",
        headerBg: mr("--standard-table-header-bg-color"),
        borderColor: mr(
          "--standard-table-header-border-color"
        ),
        headerColor: mr("--standard-table-header-color"),
        cellPaddingBlock: 0,
        cellPaddingInline: 0,
        rowHoverBg: mr("--standard-table-row-hover-bg-color")
      }
    }[p], { fontFamily: j, ...I } = $;
    return {
      fontFamily: j,
      components: {
        Table: I,
        Pagination: xMt()
      },
      token: EMt()
    };
  }, [p]), N = f === "medium" ? "middle" : f;
  return /* @__PURE__ */ V.jsx(tc, { theme: T, children: /* @__PURE__ */ V.jsx(
    xb,
    {
      bordered: !0,
      className: t ? CMt.table : "",
      columns: E,
      dataSource: a,
      pagination: P,
      rowHoverable: p !== "apollo",
      rowKey: d,
      rowSelection: k,
      size: N,
      style: { width: g },
      rowClassName: b,
      onChange: M
    }
  ) });
}, LL = /* @__PURE__ */ S.createContext({
  register: () => {
  },
  unregister: () => {
  },
  subscribeMapChange: () => () => {
  },
  elementsRef: {
    current: []
  },
  nextIndexRef: {
    current: 0
  }
});
process.env.NODE_ENV !== "production" && (LL.displayName = "CompositeListContext");
function PMt() {
  return S.useContext(LL);
}
function Eie(e) {
  const {
    children: t,
    elementsRef: r,
    labelsRef: a,
    onMapChange: i
  } = e, c = Ar(i), d = S.useRef(0), f = am(MMt).current, p = am(kMt).current, [g, b] = S.useState(0), w = S.useRef(g), x = Ar((T, N) => {
    p.set(T, N ?? null), w.current += 1, b(w.current);
  }), E = Ar((T) => {
    p.delete(T), w.current += 1, b(w.current);
  }), P = S.useMemo(() => {
    const T = /* @__PURE__ */ new Map();
    return Array.from(p.keys()).filter((D) => D.isConnected).sort(OMt).forEach((D, $) => {
      const j = p.get(D) ?? {};
      T.set(D, {
        ...j,
        index: $
      });
    }), T;
  }, [p, g]);
  Dr(() => {
    if (typeof MutationObserver != "function" || P.size === 0)
      return;
    const T = new MutationObserver((N) => {
      const D = /* @__PURE__ */ new Set(), $ = (j) => D.has(j) ? D.delete(j) : D.add(j);
      N.forEach((j) => {
        j.removedNodes.forEach($), j.addedNodes.forEach($);
      }), D.size === 0 && (w.current += 1, b(w.current));
    });
    return P.forEach((N, D) => {
      D.parentElement && T.observe(D.parentElement, {
        childList: !0
      });
    }), () => {
      T.disconnect();
    };
  }, [P]), Dr(() => {
    w.current === g && (r.current.length !== P.size && (r.current.length = P.size), a && a.current.length !== P.size && (a.current.length = P.size), d.current = P.size), c(P);
  }, [c, P, r, a, g]), Dr(() => () => {
    r.current = [];
  }, [r]), Dr(() => () => {
    a && (a.current = []);
  }, [a]);
  const k = Ar((T) => (f.add(T), () => {
    f.delete(T);
  }));
  Dr(() => {
    f.forEach((T) => T(P));
  }, [f, P]);
  const M = S.useMemo(() => ({
    register: x,
    unregister: E,
    subscribeMapChange: k,
    elementsRef: r,
    labelsRef: a,
    nextIndexRef: d
  }), [x, E, k, r, a, d]);
  return /* @__PURE__ */ V.jsx(LL.Provider, {
    value: M,
    children: t
  });
}
function kMt() {
  return /* @__PURE__ */ new Map();
}
function MMt() {
  return /* @__PURE__ */ new Set();
}
function OMt(e, t) {
  const r = e.compareDocumentPosition(t);
  return r & Node.DOCUMENT_POSITION_FOLLOWING || r & Node.DOCUMENT_POSITION_CONTAINED_BY ? -1 : r & Node.DOCUMENT_POSITION_PRECEDING || r & Node.DOCUMENT_POSITION_CONTAINS ? 1 : 0;
}
const HL = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (HL.displayName = "TabsRootContext");
function WE() {
  const e = S.useContext(HL);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TabsRootContext is missing. Tabs parts must be placed within <Tabs.Root>." : ud(64));
  return e;
}
let TMt = /* @__PURE__ */ (function(e) {
  return e.activationDirection = "data-activation-direction", e.orientation = "data-orientation", e;
})({});
const lO = {
  tabActivationDirection: (e) => ({
    [TMt.activationDirection]: e
  })
}, Pie = /* @__PURE__ */ S.forwardRef(function(t, r) {
  const {
    className: a,
    defaultValue: i = 0,
    onValueChange: c,
    orientation: d = "horizontal",
    render: f,
    value: p,
    ...g
  } = t, b = kL(), w = Object.hasOwn(t, "defaultValue"), x = S.useRef([]), [E, P] = S.useState(() => /* @__PURE__ */ new Map()), [k, M] = Rae({
    controlled: p,
    default: i,
    name: "Tabs",
    state: "value"
  }), T = p !== void 0, [N, D] = S.useState(() => /* @__PURE__ */ new Map()), [$, j] = S.useState("none"), I = Ar((K, X) => {
    c?.(K, X), !X.isCanceled && (M(K), j(X.activationDirection));
  }), L = Ar((K, X) => {
    P((te) => {
      if (te.get(K) === X)
        return te;
      const ie = new Map(te);
      return ie.set(K, X), ie;
    });
  }), F = Ar((K, X) => {
    P((te) => {
      if (!te.has(K) || te.get(K) !== X)
        return te;
      const ie = new Map(te);
      return ie.delete(K), ie;
    });
  }), _ = S.useCallback((K) => E.get(K), [E]), W = S.useCallback((K) => {
    for (const X of N.values())
      if (K === X?.value)
        return X?.id;
  }, [N]), Q = S.useCallback((K) => {
    if (K === void 0)
      return null;
    for (const [X, te] of N.entries())
      if (te != null && K === (te.value ?? te.index))
        return X;
    return null;
  }, [N]), U = S.useMemo(() => ({
    direction: b,
    getTabElementBySelectedValue: Q,
    getTabIdByPanelValue: W,
    getTabPanelIdByValue: _,
    onValueChange: I,
    orientation: d,
    registerMountedTabPanel: L,
    setTabMap: D,
    unregisterMountedTabPanel: F,
    tabActivationDirection: $,
    value: k
  }), [b, Q, W, _, I, d, L, D, F, $, k]), Y = S.useMemo(() => {
    for (const K of N.values())
      if (K != null && K.value === k)
        return K;
  }, [N, k]), G = S.useMemo(() => {
    for (const K of N.values())
      if (K != null && !K.disabled)
        return K.value;
  }, [N]);
  Dr(() => {
    if (T || N.size === 0)
      return;
    const K = Y?.disabled, X = Y == null && k !== null;
    if (w && K && k === i || !K && !X)
      return;
    const ie = G ?? null;
    k !== ie && (M(ie), j("none"));
  }, [i, G, w, T, Y, j, M, N, k]);
  const H = nc("div", t, {
    state: {
      orientation: d,
      tabActivationDirection: $
    },
    ref: r,
    props: g,
    stateAttributesMapping: lO
  });
  return /* @__PURE__ */ V.jsx(HL.Provider, {
    value: U,
    children: /* @__PURE__ */ V.jsx(Eie, {
      elementsRef: x,
      children: H
    })
  });
});
process.env.NODE_ENV !== "production" && (Pie.displayName = "TabsRoot");
const kie = "data-composite-item-active";
let RMt = /* @__PURE__ */ (function(e) {
  return e[e.None = 0] = "None", e[e.GuessFromOrder = 1] = "GuessFromOrder", e;
})({});
function Mie(e = {}) {
  const {
    label: t,
    metadata: r,
    textRef: a,
    indexGuessBehavior: i,
    index: c
  } = e, {
    register: d,
    unregister: f,
    subscribeMapChange: p,
    elementsRef: g,
    labelsRef: b,
    nextIndexRef: w
  } = PMt(), x = S.useRef(-1), [E, P] = S.useState(c ?? (i === RMt.GuessFromOrder ? () => {
    if (x.current === -1) {
      const T = w.current;
      w.current += 1, x.current = T;
    }
    return x.current;
  } : -1)), k = S.useRef(null), M = S.useCallback((T) => {
    if (k.current = T, E !== -1 && T !== null && (g.current[E] = T, b)) {
      const N = t !== void 0;
      b.current[E] = N ? t : a?.current?.textContent ?? T.textContent;
    }
  }, [E, g, b, t, a]);
  return Dr(() => {
    if (c != null)
      return;
    const T = k.current;
    if (T)
      return d(T, r), () => {
        f(T);
      };
  }, [c, d, f, r]), Dr(() => {
    if (c == null)
      return p((T) => {
        const N = k.current ? T.get(k.current)?.index : null;
        N != null && P(N);
      });
  }, [c, p, P]), S.useMemo(() => ({
    ref: M,
    index: E
  }), [E, M]);
}
function AMt(e = {}) {
  const {
    highlightItemOnHover: t,
    highlightedIndex: r,
    onHighlightedIndexChange: a
  } = jae(), {
    ref: i,
    index: c
  } = Mie(e), d = r === c, f = S.useRef(null), p = l3(i, f);
  return {
    compositeProps: S.useMemo(() => ({
      tabIndex: d ? 0 : -1,
      onFocus() {
        a(c);
      },
      onMouseMove() {
        const b = f.current;
        if (!t || !b)
          return;
        const w = b.hasAttribute("disabled") || b.ariaDisabled === "true";
        !d && !w && b.focus();
      }
    }), [d, a, c, t]),
    compositeRef: p,
    index: c
  };
}
const FL = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (FL.displayName = "TabsListContext");
function Oie() {
  const e = S.useContext(FL);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TabsListContext is missing. TabsList parts must be placed within <Tabs.List>." : ud(65));
  return e;
}
const Tie = /* @__PURE__ */ S.forwardRef(function(t, r) {
  const {
    className: a,
    disabled: i = !1,
    render: c,
    value: d,
    id: f,
    nativeButton: p = !0,
    ...g
  } = t, {
    value: b,
    getTabPanelIdByValue: w,
    orientation: x
  } = WE(), {
    activateOnFocus: E,
    highlightedTabIndex: P,
    onTabActivation: k,
    setHighlightedTabIndex: M,
    tabsListElement: T
  } = Oie(), N = E7(f), D = S.useMemo(() => ({
    disabled: i,
    id: N,
    value: d
  }), [i, N, d]), {
    compositeProps: $,
    compositeRef: j,
    index: I
    // hook is used instead of the CompositeItem component
    // because the index is needed for Tab internals
  } = AMt({
    metadata: D
  }), L = d === b, F = S.useRef(!1);
  Dr(() => {
    if (F.current) {
      F.current = !1;
      return;
    }
    if (!(L && I > -1 && P !== I))
      return;
    const te = T;
    if (te != null) {
      const ie = ap(Qo(te));
      if (ie && oo(te, ie))
        return;
    }
    i || M(I);
  }, [L, I, P, M, i, T]);
  const {
    getButtonProps: _,
    buttonRef: W
  } = sL({
    disabled: i,
    native: p,
    focusableWhenDisabled: !0
  }), Q = w(d), U = S.useRef(!1), Y = S.useRef(!1);
  function G(te) {
    L || i || k(d, ji($x, te.nativeEvent, void 0, {
      activationDirection: "none"
    }));
  }
  function J(te) {
    L || (I > -1 && !i && M(I), !i && E && (!U.current || // keyboard or touch focus
    U.current && Y.current) && k(d, ji($x, te.nativeEvent, void 0, {
      activationDirection: "none"
    })));
  }
  function H(te) {
    if (L || i)
      return;
    U.current = !0;
    function ie() {
      U.current = !1, Y.current = !1;
    }
    (!te.button || te.button === 0) && (Y.current = !0, Qo(te.currentTarget).addEventListener("pointerup", ie, {
      once: !0
    }));
  }
  return nc("button", t, {
    state: {
      disabled: i,
      active: L,
      orientation: x
    },
    ref: [r, W, j],
    props: [$, {
      role: "tab",
      "aria-controls": Q,
      "aria-selected": L,
      id: N,
      onClick: G,
      onFocus: J,
      onPointerDown: H,
      [kie]: L ? "" : void 0,
      onKeyDownCapture() {
        F.current = !0;
      }
    }, g, _]
  });
});
process.env.NODE_ENV !== "production" && (Tie.displayName = "TabsTab");
const NMt = '!function(){const t=document.currentScript.previousElementSibling;if(!t)return;const e=t.closest(\'[role="tablist"]\');if(!e)return;const i=e.querySelector("[data-active]");if(!i)return;if(0===i.offsetWidth||0===e.offsetWidth)return;let o=0,n=0,h=0,l=0,r=0,f=0;function s(t){const e=getComputedStyle(t);let i=parseFloat(e.width)||0,o=parseFloat(e.height)||0;return(Math.round(i)!==t.offsetWidth||Math.round(o)!==t.offsetHeight)&&(i=t.offsetWidth,o=t.offsetHeight),{width:i,height:o}}if(null!=i&&null!=e){const{width:t,height:c}=s(i),{width:u,height:d}=s(e),a=i.getBoundingClientRect(),g=e.getBoundingClientRect(),p=u>0?g.width/u:1,b=d>0?g.height/d:1;if(Math.abs(p)>Number.EPSILON&&Math.abs(b)>Number.EPSILON){const t=a.left-g.left,i=a.top-g.top;o=t/p+e.scrollLeft-e.clientLeft,h=i/b+e.scrollTop-e.clientTop}else o=i.offsetLeft,h=i.offsetTop;r=t,f=c,n=e.scrollWidth-o-r,l=e.scrollHeight-h-f}function c(e,i){t.style.setProperty(`--active-tab-${e}`,`${i}px`)}c("left",o),c("right",n),c("top",h),c("bottom",l),c("width",r),c("height",f),r>0&&f>0&&t.removeAttribute("hidden")}();';
let _3 = /* @__PURE__ */ (function(e) {
  return e.activeTabLeft = "--active-tab-left", e.activeTabRight = "--active-tab-right", e.activeTabTop = "--active-tab-top", e.activeTabBottom = "--active-tab-bottom", e.activeTabWidth = "--active-tab-width", e.activeTabHeight = "--active-tab-height", e;
})({});
const Rie = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (Rie.displayName = "CSPContext");
const DMt = {
  disableStyleElements: !1
};
function $Mt() {
  return S.useContext(Rie) ?? DMt;
}
const zMt = {
  ...lO,
  activeTabPosition: () => null,
  activeTabSize: () => null
}, Aie = /* @__PURE__ */ S.forwardRef(function(t, r) {
  const {
    className: a,
    render: i,
    renderBeforeHydration: c = !1,
    ...d
  } = t, {
    nonce: f
  } = $Mt(), {
    getTabElementBySelectedValue: p,
    orientation: g,
    tabActivationDirection: b,
    value: w
  } = WE(), {
    tabsListElement: x
  } = Oie(), [E, P] = S.useState(!1), {
    value: k
  } = WE();
  S3(() => P(!0));
  const M = VEt();
  S.useEffect(() => {
    if (w != null && x != null && typeof ResizeObserver < "u") {
      const G = new ResizeObserver(M);
      return G.observe(x), () => {
        G.disconnect();
      };
    }
  }, [w, x, M]);
  let T = 0, N = 0, D = 0, $ = 0, j = 0, I = 0, L = !1;
  if (w != null && x != null) {
    const G = p(w);
    if (L = !0, G != null) {
      const {
        width: J,
        height: H
      } = jX(G), {
        width: K,
        height: X
      } = jX(x), te = G.getBoundingClientRect(), ie = x.getBoundingClientRect(), ee = K > 0 ? ie.width / K : 1, ne = X > 0 ? ie.height / X : 1;
      if (Math.abs(ee) > Number.EPSILON && Math.abs(ne) > Number.EPSILON) {
        const oe = te.left - ie.left, fe = te.top - ie.top;
        T = oe / ee + x.scrollLeft - x.clientLeft, D = fe / ne + x.scrollTop - x.clientTop;
      } else
        T = G.offsetLeft, D = G.offsetTop;
      j = J, I = H, N = x.scrollWidth - T - j, $ = x.scrollHeight - D - I;
    }
  }
  const F = S.useMemo(() => L ? {
    left: T,
    right: N,
    top: D,
    bottom: $
  } : null, [T, N, D, $, L]), _ = S.useMemo(() => L ? {
    width: j,
    height: I
  } : null, [j, I, L]), W = S.useMemo(() => {
    if (L)
      return {
        [_3.activeTabLeft]: `${T}px`,
        [_3.activeTabRight]: `${N}px`,
        [_3.activeTabTop]: `${D}px`,
        [_3.activeTabBottom]: `${$}px`,
        [_3.activeTabWidth]: `${j}px`,
        [_3.activeTabHeight]: `${I}px`
      };
  }, [T, N, D, $, j, I, L]), Q = L && j > 0 && I > 0, Y = nc("span", t, {
    state: {
      orientation: g,
      activeTabPosition: F,
      activeTabSize: _,
      tabActivationDirection: b
    },
    ref: r,
    props: [{
      role: "presentation",
      style: W,
      hidden: !Q
      // do not display the indicator before the layout is settled
    }, d, {
      suppressHydrationWarning: !0
    }],
    stateAttributesMapping: zMt
  });
  return k == null ? null : /* @__PURE__ */ V.jsxs(S.Fragment, {
    children: [Y, !E && c && /* @__PURE__ */ V.jsx("script", {
      nonce: f,
      dangerouslySetInnerHTML: {
        __html: NMt
      },
      suppressHydrationWarning: !0
    })]
  });
});
process.env.NODE_ENV !== "production" && (Aie.displayName = "TabsIndicator");
let jMt = /* @__PURE__ */ (function(e) {
  return e.index = "data-index", e.activationDirection = "data-activation-direction", e.orientation = "data-orientation", e.hidden = "data-hidden", e;
})({});
const IMt = {
  ...lO,
  ...i6
}, Nie = /* @__PURE__ */ S.forwardRef(function(t, r) {
  const {
    className: a,
    value: i,
    render: c,
    keepMounted: d = !1,
    ...f
  } = t, {
    value: p,
    getTabIdByPanelValue: g,
    orientation: b,
    tabActivationDirection: w,
    registerMountedTabPanel: x,
    unregisterMountedTabPanel: E
  } = WE(), P = E7(), k = S.useMemo(() => ({
    id: P,
    value: i
  }), [P, i]), {
    ref: M,
    index: T
  } = Mie({
    metadata: k
  }), N = i === p, {
    mounted: D,
    transitionStatus: $,
    setMounted: j
  } = oL(N), I = !D, L = g(i), F = {
    hidden: I,
    orientation: b,
    tabActivationDirection: w,
    transitionStatus: $
  }, _ = S.useRef(null), W = nc("div", t, {
    state: F,
    ref: [r, M, _],
    props: [{
      "aria-labelledby": L,
      hidden: I,
      id: P,
      role: "tabpanel",
      tabIndex: N ? 0 : -1,
      inert: EL(!N),
      [jMt.index]: T
    }, f],
    stateAttributesMapping: IMt
  });
  return l6({
    open: N,
    ref: _,
    onComplete() {
      N || j(!1);
    }
  }), Dr(() => {
    if (!(I && !d) && P != null)
      return x(i, P), () => {
        E(i, P);
      };
  }, [I, d, i, P, x, E]), d || D ? W : null;
});
process.env.NODE_ENV !== "production" && (Nie.displayName = "TabsPanel");
function LMt(e) {
  return e == null || e.hasAttribute("disabled") || e.getAttribute("aria-disabled") === "true";
}
const HMt = [];
function FMt(e) {
  const {
    itemSizes: t,
    cols: r = 1,
    loopFocus: a = !0,
    dense: i = !1,
    orientation: c = "both",
    direction: d,
    highlightedIndex: f,
    onHighlightedIndexChange: p,
    rootRef: g,
    enableHomeAndEndKeys: b = !1,
    stopEventPropagation: w = !1,
    disabledIndices: x,
    modifierKeys: E = HMt
  } = e, [P, k] = S.useState(0), M = r > 1, T = S.useRef(null), N = l3(T, g), D = S.useRef([]), $ = S.useRef(!1), j = f ?? P, I = Ar((_, W = !1) => {
    if ((p ?? k)(_), W) {
      const Q = D.current[_];
      $X(T.current, Q, d, c);
    }
  }), L = Ar((_) => {
    if (_.size === 0 || $.current)
      return;
    $.current = !0;
    const W = Array.from(_.keys()), Q = W.find((Y) => Y?.hasAttribute(kie)) ?? null, U = Q ? W.indexOf(Q) : -1;
    U !== -1 && I(U), $X(T.current, Q, d, c);
  }), F = S.useMemo(() => ({
    "aria-orientation": c === "both" ? void 0 : c,
    ref: N,
    onFocus(_) {
      !T.current || !DX(_.target) || _.target.setSelectionRange(0, _.target.value.length ?? 0);
    },
    onKeyDown(_) {
      const W = b ? C7t : Hoe;
      if (!W.has(_.key) || WMt(_, E) || !T.current)
        return;
      const U = d === "rtl", Y = U ? HE : px, G = {
        horizontal: Y,
        vertical: G4,
        both: Y
      }[c], J = U ? px : HE, H = {
        horizontal: J,
        vertical: hx,
        both: J
      }[c];
      if (DX(_.target) && !LMt(_.target)) {
        const ae = _.target.selectionStart, oe = _.target.selectionEnd, fe = _.target.value ?? "";
        if (ae == null || _.shiftKey || ae !== oe || _.key !== H && ae < fe.length || _.key !== G && ae > 0)
          return;
      }
      let K = j;
      const X = p5t(D, x), te = g5t(D, x);
      if (M) {
        const ae = t || Array.from({
          length: D.current.length
        }, () => ({
          width: 1,
          height: 1
        })), oe = b5t(ae, r, i), fe = oe.findIndex((me) => me != null && !bE(D, me, x)), be = oe.reduce((me, De, Me) => De != null && !bE(D, De, x) ? Me : me, -1);
        K = oe[v5t({
          current: oe.map((me) => me ? D.current[me] : null)
        }, {
          event: _,
          orientation: c,
          loopFocus: a,
          cols: r,
          // treat undefined (empty grid spaces) as disabled indices so we
          // don't end up in them
          disabledIndices: w5t([...x || D.current.map((me, De) => bE(D, De) ? De : void 0), void 0], oe),
          minIndex: fe,
          maxIndex: be,
          prevIndex: y5t(
            j > te ? X : j,
            ae,
            oe,
            r,
            // use a corner matching the edge closest to the direction we're
            // moving in so we don't end up in the same item. Prefer
            // top/left over bottom/right.
            // eslint-disable-next-line no-nested-ternary
            _.key === G4 ? "bl" : _.key === px ? "tr" : "tl"
          ),
          rtl: U
        })];
      }
      const ie = {
        horizontal: [Y],
        vertical: [G4],
        both: [Y, G4]
      }[c], ee = {
        horizontal: [J],
        vertical: [hx],
        both: [J, hx]
      }[c], ne = M ? W : {
        horizontal: b ? w7t : Ioe,
        vertical: b ? S7t : Loe,
        both: W
      }[c];
      b && (_.key === O7 ? K = X : _.key === T7 && (K = te)), K === j && (ie.includes(_.key) || ee.includes(_.key)) && (a && K === te && ie.includes(_.key) ? K = X : a && K === X && ee.includes(_.key) ? K = te : K = E0(D, {
        startingIndex: K,
        decrement: ee.includes(_.key),
        disabledIndices: x
      })), K !== j && !Tk(D, K) && (w && _.stopPropagation(), ne.has(_.key) && _.preventDefault(), I(K, !0), queueMicrotask(() => {
        D.current[K]?.focus();
      }));
    }
  }), [r, i, d, x, D, b, j, M, t, a, N, E, I, c, w]);
  return S.useMemo(() => ({
    props: F,
    highlightedIndex: j,
    onHighlightedIndexChange: I,
    elementsRef: D,
    disabledIndices: x,
    onMapChange: L,
    relayKeyboardEvent: F.onKeyDown
  }), [F, j, I, D, x, L]);
}
function WMt(e, t) {
  for (const r of O7t.values())
    if (!t.includes(r) && e.getModifierState(r))
      return !0;
  return !1;
}
function VMt(e) {
  const {
    render: t,
    className: r,
    refs: a = Y$,
    props: i = Y$,
    state: c = Gh,
    stateAttributesMapping: d,
    highlightedIndex: f,
    onHighlightedIndexChange: p,
    orientation: g,
    dense: b,
    itemSizes: w,
    loopFocus: x,
    cols: E,
    enableHomeAndEndKeys: P,
    onMapChange: k,
    stopEventPropagation: M = !0,
    rootRef: T,
    disabledIndices: N,
    modifierKeys: D,
    highlightItemOnHover: $ = !1,
    tag: j = "div",
    ...I
  } = e, L = kL(), {
    props: F,
    highlightedIndex: _,
    onHighlightedIndexChange: W,
    elementsRef: Q,
    onMapChange: U,
    relayKeyboardEvent: Y
  } = FMt({
    itemSizes: w,
    cols: E,
    loopFocus: x,
    dense: b,
    orientation: g,
    highlightedIndex: f,
    onHighlightedIndexChange: p,
    rootRef: T,
    stopEventPropagation: M,
    enableHomeAndEndKeys: P,
    direction: L,
    disabledIndices: N,
    modifierKeys: D
  }), G = nc(j, e, {
    state: c,
    ref: a,
    props: [F, ...i, I],
    stateAttributesMapping: d
  }), J = S.useMemo(() => ({
    highlightedIndex: _,
    onHighlightedIndexChange: W,
    highlightItemOnHover: $,
    relayKeyboardEvent: Y
  }), [_, W, $, Y]);
  return /* @__PURE__ */ V.jsx(lL.Provider, {
    value: J,
    children: /* @__PURE__ */ V.jsx(Eie, {
      elementsRef: Q,
      onMapChange: (H) => {
        k?.(H), U(H);
      },
      children: G
    })
  });
}
const Die = /* @__PURE__ */ S.forwardRef(function(t, r) {
  const {
    activateOnFocus: a = !1,
    className: i,
    loopFocus: c = !0,
    render: d,
    ...f
  } = t, {
    getTabElementBySelectedValue: p,
    onValueChange: g,
    orientation: b,
    value: w,
    setTabMap: x,
    tabActivationDirection: E
  } = WE(), [P, k] = S.useState(0), [M, T] = S.useState(null), N = _Mt(
    w,
    // the old value
    b,
    M,
    p
  ), D = Ar((L, F) => {
    if (L !== w) {
      const _ = N(L);
      F.activationDirection = _, g(L, F);
    }
  }), $ = {
    orientation: b,
    tabActivationDirection: E
  }, j = {
    "aria-orientation": b === "vertical" ? "vertical" : void 0,
    role: "tablist"
  }, I = S.useMemo(() => ({
    activateOnFocus: a,
    highlightedTabIndex: P,
    onTabActivation: D,
    setHighlightedTabIndex: k,
    tabsListElement: M,
    value: w
  }), [a, P, D, k, M, w]);
  return /* @__PURE__ */ V.jsx(FL.Provider, {
    value: I,
    children: /* @__PURE__ */ V.jsx(VMt, {
      render: d,
      className: i,
      state: $,
      refs: [r, T],
      props: [j, f],
      stateAttributesMapping: lO,
      highlightedIndex: P,
      enableHomeAndEndKeys: !0,
      loopFocus: c,
      orientation: b,
      onHighlightedIndexChange: k,
      onMapChange: x,
      disabledIndices: Y$
    })
  });
});
process.env.NODE_ENV !== "production" && (Die.displayName = "TabsList");
function oG(e, t) {
  const {
    left: r,
    top: a
  } = e.getBoundingClientRect(), {
    left: i,
    top: c
  } = t.getBoundingClientRect(), d = r - i, f = a - c;
  return {
    left: d,
    top: f
  };
}
function _Mt(e, t, r, a) {
  const [i, c] = S.useState(null);
  return Dr(() => {
    if (e == null || r == null) {
      c(null);
      return;
    }
    const d = a(e);
    if (d == null) {
      c(null);
      return;
    }
    const {
      left: f,
      top: p
    } = oG(d, r);
    c(t === "horizontal" ? f : p);
  }, [t, a, r, e]), S.useCallback((d) => {
    if (d === e)
      return "none";
    if (d == null)
      return c(null), "none";
    if (d != null && r != null) {
      const f = a(d);
      if (f != null) {
        const {
          left: p,
          top: g
        } = oG(f, r);
        if (i == null)
          return c(t === "horizontal" ? p : g), "none";
        if (t === "horizontal") {
          if (p < i)
            return c(p), "left";
          if (p > i)
            return c(p), "right";
        } else {
          if (g < i)
            return c(g), "up";
          if (g > i)
            return c(g), "down";
        }
      }
    }
    return "none";
  }, [a, t, i, r, e]);
}
const $ie = ks(({ className: e, ...t }, r) => /* @__PURE__ */ V.jsx("div", { "data-preflight": !0, className: "contents", children: /* @__PURE__ */ V.jsx(
  Pie,
  {
    ref: r,
    className: lt("flex flex-col", e),
    ...t
  }
) }));
$ie.displayName = "TabsRoot";
const zie = ks(({ className: e, ...t }, r) => /* @__PURE__ */ V.jsx(
  Die,
  {
    ref: r,
    className: lt("relative flex", e),
    ...t
  }
));
zie.displayName = "TabsList";
const jie = ks(({ className: e, ...t }, r) => /* @__PURE__ */ V.jsx(
  Tie,
  {
    ref: r,
    className: lt(
      "inline-flex cursor-pointer select-none items-center border-0 bg-transparent p-0 font-[inherit]",
      "text-(--tabs-color-text) transition-colors duration-300",
      "hover:text-(--tabs-hover-color)",
      "data-active:text-(--tabs-color-primary) data-active:[text-shadow:0_0_0.25px_currentcolor]",
      e
    ),
    ...t
  }
));
jie.displayName = "TabsTab";
const Iie = ks(({ className: e, ...t }, r) => /* @__PURE__ */ V.jsx(
  Aie,
  {
    ref: r,
    className: lt(
      "pointer-events-none absolute bottom-0 h-0.5",
      "left-(--active-tab-left) w-(--active-tab-width)",
      "bg-(--tabs-color-primary) transition-[left,width] duration-300",
      e
    ),
    ...t
  }
));
Iie.displayName = "TabsIndicator";
const BMt = Nie, UMt = lt(
  "before:inset-x-0 before:inset-y-[5px] before:rounded-sm",
  "before:outline-(--tabs-focus-color)",
  "outline-hidden focus-visible:relative",
  "focus-visible:before:absolute focus-visible:before:outline-3"
), XMt = lt(
  "before:inset-[2px]",
  "before:rounded-t-(--tabs-card-border-radius)",
  "before:outline-(--tabs-focus-color)",
  "outline-hidden focus-visible:relative",
  "focus-visible:before:absolute focus-visible:before:outline-3",
  "focus-visible:before:z-[1]"
), GMt = lt(
  "before:inset-[-1px]",
  "before:outline-(--tabs-focus-color)",
  "outline-hidden focus-visible:relative",
  "focus-visible:before:absolute focus-visible:before:outline-3"
), qMt = lt(
  "rounded-t-(--tabs-card-border-radius)",
  "border border-(--tabs-border-color) border-b-0",
  "bg-(--tabs-inactive-tab-card-bg)",
  "data-active:bg-(--tabs-bg-color)"
), KMt = lt(
  "data-active:relative data-active:after:absolute",
  "data-active:after:bottom-[-1px] data-active:after:left-0",
  "data-active:after:h-px data-active:after:w-full data-active:after:bg-(--tabs-bg-color)"
), YMt = {
  line: UMt,
  card: lt(XMt, qMt, KMt)
}, QMt = {
  line: {
    small: "py-2 text-sm leading-(--tabs-line-height)",
    medium: "py-3 text-sm leading-(--tabs-line-height)",
    large: "py-4 text-base leading-(--tabs-line-height-lg)"
  },
  card: {
    small: "px-2 py-1 text-sm leading-(--tabs-line-height)",
    medium: "px-4 py-2 text-sm leading-(--tabs-line-height)",
    large: "px-4 py-(--tabs-card-padding-y-lg) text-base leading-(--tabs-line-height-lg)"
  }
}, JMt = {
  line: "gap-8 shadow-[inset_0_-1px_0_var(--tabs-border-color)]",
  card: "border-b border-(--tabs-border-color) gap-0.5"
}, ZMt = ({
  items: e,
  size: t = "medium",
  activeKey: r,
  defaultActiveKey: a,
  type: i = "card",
  onChange: c,
  testId: d
}) => /* @__PURE__ */ V.jsxs(
  $ie,
  {
    value: r ?? void 0,
    defaultValue: a ?? e[0]?.key,
    onValueChange: c ? (f) => c(String(f)) : void 0,
    "data-testid": d,
    children: [
      /* @__PURE__ */ V.jsxs(zie, { className: JMt[i], children: [
        e.map((f) => /* @__PURE__ */ V.jsx(
          jie,
          {
            value: f.key,
            "data-key": f.key,
            "data-testid": d ? `${d}-tab-${f.key}` : void 0,
            className: lt(YMt[i], QMt[i][t]),
            children: f.label
          },
          f.key
        )),
        i === "line" && /* @__PURE__ */ V.jsx(Iie, {})
      ] }),
      e.map((f) => /* @__PURE__ */ V.jsx(BMt, { value: f.key, className: GMt, children: f.children }, f.key))
    ]
  }
);
ZMt.displayName = "Tabs";
let wz;
const eOt = (e) => {
  wz = e;
}, tOt = () => {
  if (!wz)
    throw new Error("ToastProvider is not initialized");
  return wz;
}, nOt = {
  success: "toast-success",
  error: "toast-error",
  info: "toast-info",
  warning: "toast-warning"
}, rOt = 3, R7 = ({
  type: e,
  content: t,
  duration: r,
  dataTestId: a
}) => {
  tOt().add({
    type: e,
    description: t,
    timeout: (r ?? rOt) * 1e3,
    data: { dataTestId: a }
  });
};
function sO(e) {
  return (t, r) => R7({
    type: e,
    content: t,
    duration: r?.duration,
    dataTestId: r?.dataTestId ?? nOt[e]
  });
}
R7.success = sO("success");
R7.error = sO("error");
R7.info = sO("info");
R7.warning = sO("warning");
const uO = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (uO.displayName = "ToastContext");
function Lie() {
  const e = S.useContext(uO);
  if (!e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: useToastManager must be used within <Toast.Provider>." : ud(73));
  return e;
}
let iG = 0;
function Hie(e) {
  return iG += 1, `${e}-${Math.random().toString(36).slice(2, 6)}-${iG}`;
}
function xN(e, t) {
  if (typeof e == "string")
    return {
      description: e
    };
  if (typeof e == "function") {
    const r = e(t);
    return typeof r == "string" ? {
      description: r
    } : r;
  }
  return e;
}
const XP = PEt((e) => e.toasts, (e) => {
  const t = /* @__PURE__ */ new Map();
  let r = 0, a = 0;
  return e.forEach((i, c) => {
    const d = i.transitionStatus === "ending";
    t.set(i.id, {
      value: i,
      domIndex: c,
      visibleIndex: d ? -1 : r,
      offsetY: a
    }), a += i.height || 0, d || (r += 1);
  }), t;
}), Uw = {
  toasts: ua((e) => e.toasts),
  isEmpty: ua((e) => e.toasts.length === 0),
  toast: ua(XP, (e, t) => e.get(t)?.value),
  toastIndex: ua(XP, (e, t) => e.get(t)?.domIndex ?? -1),
  toastOffsetY: ua(XP, (e, t) => e.get(t)?.offsetY ?? 0),
  toastVisibleIndex: ua(XP, (e, t) => e.get(t)?.visibleIndex ?? -1),
  hovering: ua((e) => e.hovering),
  focused: ua((e) => e.focused),
  expanded: ua((e) => e.hovering || e.focused),
  expandedOrOutOfFocus: ua((e) => e.hovering || e.focused || !e.isWindowFocused),
  prevFocusElement: ua((e) => e.prevFocusElement)
};
class aOt extends nO {
  timers = /* @__PURE__ */ new Map();
  areTimersPaused = !1;
  constructor(t) {
    super(t, {}, Uw);
  }
  setFocused(t) {
    this.set("focused", t);
  }
  setHovering(t) {
    this.set("hovering", t);
  }
  setIsWindowFocused(t) {
    this.set("isWindowFocused", t);
  }
  setPrevFocusElement(t) {
    this.set("prevFocusElement", t);
  }
  setViewport = (t) => {
    this.set("viewport", t);
  };
  disposeEffect = () => () => {
    this.timers.forEach((t) => {
      t.timeout?.clear();
    }), this.timers.clear();
  };
  removeToast(t) {
    const r = Uw.toastIndex(this.state, t);
    if (r === -1)
      return;
    this.state.toasts[r]?.onRemove?.();
    const i = [...this.state.toasts];
    i.splice(r, 1), this.setToasts(i);
  }
  addToast = (t) => {
    const {
      toasts: r,
      timeout: a,
      limit: i
    } = this.state, c = t.id || Hie("toast"), d = {
      ...t,
      id: c,
      transitionStatus: "starting"
    }, f = [d, ...r], p = f.filter((b) => b.transitionStatus !== "ending");
    if (p.length > i) {
      const b = p.length - i, w = p.slice(-b), x = new Set(w.map((E) => E.id));
      this.setToasts(f.map((E) => {
        const P = x.has(E.id);
        return E.limited !== P ? {
          ...E,
          limited: P
        } : E;
      }));
    } else
      this.setToasts(f.map((b) => b.limited ? {
        ...b,
        limited: !1
      } : b));
    const g = d.timeout ?? a;
    return d.type !== "loading" && g > 0 && this.scheduleTimer(c, g, () => this.closeToast(c)), Uw.expandedOrOutOfFocus(this.state) && this.pauseTimers(), c;
  };
  updateToast = (t, r) => {
    this.updateToastInternal(t, r);
  };
  updateToastInternal = (t, r) => {
    const {
      timeout: a,
      toasts: i
    } = this.state, c = Uw.toast(this.state, t) ?? null;
    if (!c || c.transitionStatus === "ending")
      return;
    const d = {
      ...c,
      ...r
    };
    this.setToasts(i.map((P) => P.id === t ? {
      ...P,
      ...r
    } : P));
    const f = d.timeout ?? a, p = c?.timeout ?? a, g = Object.hasOwn(r, "timeout"), b = d.transitionStatus !== "ending" && d.type !== "loading" && f > 0, w = this.timers.has(t), x = p !== f, E = c?.type === "loading";
    if (!b && w) {
      this.timers.get(t)?.timeout?.clear(), this.timers.delete(t);
      return;
    }
    if (b && (!w || x || g || E)) {
      const P = this.timers.get(t);
      P && (P.timeout?.clear(), this.timers.delete(t)), this.scheduleTimer(t, f, () => this.closeToast(t)), Uw.expandedOrOutOfFocus(this.state) && this.pauseTimers();
    }
  };
  closeToast = (t) => {
    Uw.toast(this.state, t)?.onClose?.();
    const {
      limit: a,
      toasts: i
    } = this.state;
    let c = 0;
    const d = i.map((p) => {
      if (p.id === t)
        return {
          ...p,
          transitionStatus: "ending",
          height: 0
        };
      if (p.transitionStatus === "ending")
        return p;
      const g = c >= a;
      return c += 1, p.limited !== g ? {
        ...p,
        limited: g
      } : p;
    }), f = this.timers.get(t);
    f && f.timeout && (f.timeout.clear(), this.timers.delete(t)), this.handleFocusManagement(t), this.setToasts(d);
  };
  promiseToast = (t, r) => {
    const a = xN(r.loading), i = this.addToast({
      ...a,
      type: "loading"
    }), c = t.then((d) => {
      const f = xN(r.success, d);
      return this.updateToast(i, {
        ...f,
        type: "success",
        timeout: f.timeout
      }), d;
    }).catch((d) => {
      const f = xN(r.error, d);
      return this.updateToast(i, {
        ...f,
        type: "error",
        timeout: f.timeout
      }), Promise.reject(d);
    });
    return {}.hasOwnProperty.call(r, "setPromise") && r.setPromise(c), c;
  };
  pauseTimers() {
    this.areTimersPaused || (this.areTimersPaused = !0, this.timers.forEach((t) => {
      if (t.timeout) {
        t.timeout.clear();
        const r = Date.now() - t.start, a = t.delay - r;
        t.remaining = a > 0 ? a : 0;
      }
    }));
  }
  resumeTimers() {
    this.areTimersPaused && (this.areTimersPaused = !1, this.timers.forEach((t, r) => {
      t.remaining = t.remaining > 0 ? t.remaining : t.delay, t.timeout ??= $0.create(), t.timeout.start(t.remaining, () => {
        this.timers.delete(r), t.callback();
      }), t.start = Date.now();
    }));
  }
  restoreFocusToPrevElement() {
    this.state.prevFocusElement?.focus({
      preventScroll: !0
    });
  }
  handleDocumentPointerDown = (t) => {
    if (t.pointerType !== "touch")
      return;
    const r = tm(t);
    oo(this.state.viewport, r) || (this.resumeTimers(), this.update({
      hovering: !1,
      focused: !1
    }));
  };
  scheduleTimer(t, r, a) {
    const i = Date.now(), c = !Uw.expandedOrOutOfFocus(this.state), d = c ? $0.create() : void 0;
    d?.start(r, () => {
      this.timers.delete(t), a();
    }), this.timers.set(t, {
      timeout: d,
      start: c ? i : 0,
      delay: r,
      remaining: r,
      callback: a
    });
  }
  setToasts(t) {
    const r = {
      toasts: t
    };
    t.length === 0 && (r.hovering = !1, r.focused = !1), this.update(r);
  }
  handleFocusManagement(t) {
    const r = ap(Qo(this.state.viewport));
    if (!this.state.viewport || !oo(this.state.viewport, r) || !p9(r))
      return;
    const a = Uw.toasts(this.state), i = Uw.toastIndex(this.state, t);
    let c = null, d = i + 1;
    for (; d < a.length; ) {
      if (a[d].transitionStatus !== "ending") {
        c = a[d];
        break;
      }
      d += 1;
    }
    if (!c)
      for (d = i - 1; d >= 0; ) {
        if (a[d].transitionStatus !== "ending") {
          c = a[d];
          break;
        }
        d -= 1;
      }
    c ? c.ref?.current?.focus() : this.restoreFocusToPrevElement();
  }
}
const Fie = function(t) {
  const {
    children: r,
    timeout: a = 5e3,
    limit: i = 3,
    toastManager: c
  } = t, d = am(() => new aOt({
    timeout: a,
    limit: i,
    viewport: null,
    toasts: [],
    hovering: !1,
    focused: !1,
    isWindowFocused: !0,
    prevFocusElement: null
  })).current;
  return S3(d.disposeEffect), S.useEffect(function() {
    return c ? c[" subscribe"](({
      action: g,
      options: b
    }) => {
      const w = b.id;
      g === "promise" && b.promise ? d.promiseToast(b.promise, b) : g === "update" && w ? d.updateToast(w, b) : g === "close" && w ? d.closeToast(w) : d.addToast(b);
    }) : void 0;
  }, [d, a, c]), d.useSyncedValues({
    timeout: a,
    limit: i
  }), /* @__PURE__ */ V.jsx(uO.Provider, {
    value: d,
    children: r
  });
};
process.env.NODE_ENV !== "production" && (Fie.displayName = "ToastProvider");
let oOt = /* @__PURE__ */ (function(e) {
  return e.frontmostHeight = "--toast-frontmost-height", e;
})({});
const Wie = /* @__PURE__ */ S.forwardRef(function(t, r) {
  const {
    render: a,
    className: i,
    children: c,
    ...d
  } = t, f = Lie(), p = JS(), g = S.useRef(!1), b = S.useRef(!1), w = f.useState("isEmpty"), x = f.useState("toasts"), E = f.useState("focused"), P = f.useState("expanded"), k = f.useState("prevFocusElement"), M = x[0]?.height ?? 0, T = S.useMemo(() => x.some((U) => U.transitionStatus === "ending"), [x]);
  S.useEffect(() => {
    const U = f.state.viewport;
    if (!U)
      return;
    function Y(J) {
      w || J.key === "F6" && J.target !== U && (J.preventDefault(), f.setPrevFocusElement(ap(Qo(U))), U?.focus({
        preventScroll: !0
      }), f.pauseTimers(), f.setFocused(!0));
    }
    const G = lu(U);
    return G.addEventListener("keydown", Y), () => {
      G.removeEventListener("keydown", Y);
    };
  }, [f, w]), S.useEffect(() => {
    const U = f.state.viewport;
    if (!U || w)
      return;
    const Y = lu(U);
    function G(H) {
      H.target === Y && (f.setIsWindowFocused(!1), f.pauseTimers());
    }
    function J(H) {
      if (H.relatedTarget || H.target === Y)
        return;
      const K = tm(H), X = ap(Qo(U));
      (!oo(U, K) || !p9(X)) && f.resumeTimers(), p.start(0, () => f.setIsWindowFocused(!0));
    }
    return Y.addEventListener("blur", G, !0), Y.addEventListener("focus", J, !0), () => {
      Y.removeEventListener("blur", G, !0), Y.removeEventListener("focus", J, !0);
    };
  }, [
    f,
    p,
    // `store.state.viewport` isn't available on the first render,
    // since the portal node hasn't yet been created.
    // By adding this dependency, we ensure the window listeners
    // are added when toasts have been created, once the ref is available.
    w
  ]), S.useEffect(() => {
    const U = f.state.viewport;
    if (!U || w)
      return;
    const Y = Qo(U);
    return Y.addEventListener("pointerdown", f.handleDocumentPointerDown, !0), () => {
      Y.removeEventListener("pointerdown", f.handleDocumentPointerDown, !0);
    };
  }, [w, f]);
  function N(U) {
    const Y = f.state.viewport;
    Y && (g.current = !0, U.relatedTarget === Y ? x[0]?.ref?.current?.focus() : f.restoreFocusToPrevElement());
  }
  function D(U) {
    U.key === "Tab" && U.shiftKey && U.target === f.state.viewport && (U.preventDefault(), f.restoreFocusToPrevElement(), f.resumeTimers());
  }
  S.useEffect(() => {
    !f.state.isWindowFocused || T || !b.current || (f.resumeTimers(), f.setHovering(!1), b.current = !1);
  }, [T, f]);
  function $() {
    f.pauseTimers(), f.setHovering(!0), b.current = !1;
  }
  function j() {
    T ? b.current = !0 : (f.resumeTimers(), f.setHovering(!1));
  }
  function I() {
    if (g.current) {
      g.current = !1;
      return;
    }
    E || p9(Qo(f.state.viewport).activeElement) && (f.setFocused(!0), f.pauseTimers());
  }
  function L(U) {
    !E || oo(f.state.viewport, U.relatedTarget) || (f.setFocused(!1), f.resumeTimers());
  }
  const F = {
    tabIndex: -1,
    role: "region",
    "aria-live": "polite",
    "aria-atomic": !1,
    "aria-relevant": "additions text",
    "aria-label": "Notifications",
    onMouseEnter: $,
    onMouseMove: $,
    onMouseLeave: j,
    onFocus: I,
    onBlur: L,
    onKeyDown: D,
    onClick: I
  }, _ = {
    expanded: P
  }, W = nc("div", t, {
    ref: [r, f.setViewport],
    state: _,
    props: [F, {
      style: {
        [oOt.frontmostHeight]: M ? `${M}px` : void 0
      }
    }, d, {
      children: /* @__PURE__ */ V.jsxs(S.Fragment, {
        children: [!w && k && /* @__PURE__ */ V.jsx(mb, {
          onFocus: N
        }), c, !w && k && /* @__PURE__ */ V.jsx(mb, {
          onFocus: N
        })]
      })
    }]
  }), Q = S.useMemo(() => x.filter((U) => U.priority === "high"), [x]);
  return /* @__PURE__ */ V.jsxs(S.Fragment, {
    children: [!w && k && /* @__PURE__ */ V.jsx(mb, {
      onFocus: N
    }), W, !E && Q.length > 0 && /* @__PURE__ */ V.jsx("div", {
      style: mL,
      children: Q.map((U) => /* @__PURE__ */ V.jsxs("div", {
        role: "alert",
        "aria-atomic": !0,
        children: [/* @__PURE__ */ V.jsx("div", {
          children: U.title
        }), /* @__PURE__ */ V.jsx("div", {
          children: U.description
        })]
      }, U.id))
    })]
  });
});
process.env.NODE_ENV !== "production" && (Wie.displayName = "ToastViewport");
const WL = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (WL.displayName = "ToastRootContext");
function Vie() {
  const e = S.useContext(WL);
  if (!e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ToastRootContext is missing. Toast parts must be used within <Toast.Root>." : ud(66));
  return e;
}
let H4 = /* @__PURE__ */ (function(e) {
  return e.index = "--toast-index", e.offsetY = "--toast-offset-y", e.height = "--toast-height", e.swipeMovementX = "--toast-swipe-movement-x", e.swipeMovementY = "--toast-swipe-movement-y", e;
})({});
const iOt = {
  ...i6,
  swipeDirection(e) {
    return e ? {
      "data-swipe-direction": e
    } : null;
  }
}, tE = 40, lOt = 10, ES = 0.5, sOt = 1;
function lG(e, t, r) {
  switch (e) {
    case "up":
      return -r;
    case "down":
      return r;
    case "left":
      return -t;
    case "right":
      return t;
    default:
      return 0;
  }
}
function uOt(e) {
  const r = window.getComputedStyle(e).transform;
  let a = 0, i = 0, c = 1;
  if (r && r !== "none") {
    const d = r.match(/matrix(?:3d)?\(([^)]+)\)/);
    if (d) {
      const f = d[1].split(", ").map(parseFloat);
      f.length === 6 ? (a = f[4], i = f[5], c = Math.sqrt(f[0] * f[0] + f[1] * f[1])) : f.length === 16 && (a = f[12], i = f[13], c = f[0]);
    }
  }
  return {
    x: a,
    y: i,
    scale: c
  };
}
const _ie = /* @__PURE__ */ S.forwardRef(function(t, r) {
  const {
    toast: a,
    render: i,
    className: c,
    swipeDirection: d = ["down", "right"],
    ...f
  } = t, p = a.positionerProps?.anchor !== void 0;
  let g = [];
  p || (g = Array.isArray(d) ? d : [d]);
  const b = g.length > 0, w = Lie(), [x, E] = S.useState(void 0), [P, k] = S.useState(!1), [M, T] = S.useState(!1), [N, D] = S.useState(!1), [$, j] = S.useState({
    x: 0,
    y: 0
  }), [I, L] = S.useState({
    x: 0,
    y: 0,
    scale: 1
  }), [F, _] = S.useState(), [W, Q] = S.useState(), [U, Y] = S.useState(null), G = S.useRef(null), J = S.useRef({
    x: 0,
    y: 0
  }), H = S.useRef({
    x: 0,
    y: 0,
    scale: 1
  }), K = S.useRef(void 0), X = S.useRef(0), te = S.useRef(!1), ie = S.useRef({
    x: 0,
    y: 0
  }), ee = S.useRef(!1), ne = w.useState("toastIndex", a.id), ae = w.useState("toastVisibleIndex", a.id), oe = w.useState("toastOffsetY", a.id), fe = w.useState("focused"), be = w.useState("expanded");
  l6({
    open: a.transitionStatus !== "ending",
    ref: G,
    onComplete() {
      a.transitionStatus === "ending" && w.removeToast(a.id);
    }
  });
  const me = Ar((Te = !1) => {
    const Oe = G.current;
    if (!Oe)
      return;
    const ye = Oe.style.height;
    Oe.style.height = "auto";
    const je = Oe.offsetHeight;
    Oe.style.height = ye;
    function Ue() {
      w.updateToastInternal(a.id, {
        ref: G,
        height: je,
        ...a.transitionStatus === "starting" ? {
          transitionStatus: void 0
        } : {}
      });
    }
    Te ? sp.flushSync(Ue) : Ue();
  });
  Dr(me, [me]);
  function De(Te, Oe) {
    let ye = Te, je = Oe;
    return !g.includes("left") && !g.includes("right") ? ye = Te > 0 ? Te ** ES : -(Math.abs(Te) ** ES) : (!g.includes("right") && Te > 0 && (ye = Te ** ES), !g.includes("left") && Te < 0 && (ye = -(Math.abs(Te) ** ES))), !g.includes("up") && !g.includes("down") ? je = Oe > 0 ? Oe ** ES : -(Math.abs(Oe) ** ES) : (!g.includes("down") && Oe > 0 && (je = Oe ** ES), !g.includes("up") && Oe < 0 && (je = -(Math.abs(Oe) ** ES))), {
      x: ye,
      y: je
    };
  }
  function Me(Te) {
    if (Te.button !== 0)
      return;
    Te.pointerType === "touch" && w.pauseTimers();
    const Oe = tm(Te.nativeEvent);
    if (!(Oe && Oe.closest('button,a,input,textarea,[role="button"],[data-swipe-ignore]'))) {
      if (te.current = !1, K.current = void 0, X.current = 0, J.current = {
        x: Te.clientX,
        y: Te.clientY
      }, ie.current = J.current, G.current) {
        const je = uOt(G.current);
        H.current = je, L(je), j({
          x: je.x,
          y: je.y
        });
      }
      w.setHovering(!0), k(!0), T(!1), Y(null), ee.current = !0, G.current?.setPointerCapture(Te.pointerId);
    }
  }
  function ze(Te) {
    if (!P)
      return;
    Te.preventDefault(), ee.current && (J.current = {
      x: Te.clientX,
      y: Te.clientY
    }, ee.current = !1);
    const {
      clientY: Oe,
      clientX: ye,
      movementX: je,
      movementY: Ue
    } = Te;
    (Ue < 0 && Oe > ie.current.y || Ue > 0 && Oe < ie.current.y) && (ie.current = {
      x: ie.current.x,
      y: Oe
    }), (je < 0 && ye > ie.current.x || je > 0 && ye < ie.current.x) && (ie.current = {
      x: ye,
      y: ie.current.y
    });
    const Fe = ye - J.current.x, tt = Oe - J.current.y, dt = Oe - ie.current.y, St = ye - ie.current.x;
    if (!M && Math.sqrt(Fe * Fe + tt * tt) >= sOt && (T(!0), U === null)) {
      const Ct = g.includes("left") || g.includes("right"), ut = g.includes("up") || g.includes("down");
      if (Ct && ut) {
        const ht = Math.abs(Fe), ot = Math.abs(tt);
        Y(ht > ot ? "horizontal" : "vertical");
      }
    }
    let mt;
    if (!K.current)
      U === "vertical" ? tt > 0 ? mt = "down" : tt < 0 && (mt = "up") : U === "horizontal" ? Fe > 0 ? mt = "right" : Fe < 0 && (mt = "left") : Math.abs(Fe) >= Math.abs(tt) ? mt = Fe > 0 ? "right" : "left" : mt = tt > 0 ? "down" : "up", mt && g.includes(mt) && (K.current = mt, X.current = lG(mt, Fe, tt), E(mt));
    else {
      const it = K.current, Ct = lG(it, St, dt);
      Ct > tE ? (te.current = !1, E(it)) : !(g.includes("left") && g.includes("right")) && !(g.includes("up") && g.includes("down")) && X.current - Ct >= lOt && (te.current = !0);
    }
    const Ot = De(Fe, tt);
    let Rt = H.current.x, ct = H.current.y;
    U === "horizontal" ? (g.includes("left") || g.includes("right")) && (Rt += Ot.x) : (U === "vertical" || (g.includes("left") || g.includes("right")) && (Rt += Ot.x), (g.includes("up") || g.includes("down")) && (ct += Ot.y)), j({
      x: Rt,
      y: ct
    });
  }
  function le(Te) {
    if (!P)
      return;
    if (k(!1), T(!1), Y(null), G.current?.releasePointerCapture(Te.pointerId), te.current) {
      j({
        x: I.x,
        y: I.y
      }), E(void 0);
      return;
    }
    let Oe = !1;
    const ye = $.x - I.x, je = $.y - I.y;
    let Ue;
    for (const Fe of g) {
      switch (Fe) {
        case "right":
          ye > tE && (Oe = !0, Ue = "right");
          break;
        case "left":
          ye < -tE && (Oe = !0, Ue = "left");
          break;
        case "down":
          je > tE && (Oe = !0, Ue = "down");
          break;
        case "up":
          je < -tE && (Oe = !0, Ue = "up");
          break;
      }
      if (Oe)
        break;
    }
    Oe ? (E(Ue), D(!0), w.closeToast(a.id)) : (j({
      x: I.x,
      y: I.y
    }), E(void 0));
  }
  function se(Te) {
    if (Te.key === "Escape") {
      if (!G.current || !oo(G.current, ap(Qo(G.current))))
        return;
      w.closeToast(a.id);
    }
  }
  S.useEffect(() => {
    if (!b)
      return;
    const Te = G.current;
    if (!Te)
      return;
    function Oe(ye) {
      oo(Te, ye.target) && ye.preventDefault();
    }
    return Te.addEventListener("touchmove", Oe, {
      passive: !1
    }), () => {
      Te.removeEventListener("touchmove", Oe);
    };
  }, [b]);
  function Ae() {
    if (!P && $.x === I.x && $.y === I.y && !N)
      return {
        [H4.swipeMovementX]: "0px",
        [H4.swipeMovementY]: "0px"
      };
    const Te = $.x - I.x, Oe = $.y - I.y;
    return {
      transition: P ? "none" : void 0,
      // While swiping, freeze the element at its current visual transform so it doesn't snap to the
      // end position.
      transform: P ? `translateX(${$.x}px) translateY(${$.y}px) scale(${I.scale})` : void 0,
      [H4.swipeMovementX]: `${Te}px`,
      [H4.swipeMovementY]: `${Oe}px`
    };
  }
  const we = a.priority === "high", Ne = {
    role: we ? "alertdialog" : "dialog",
    tabIndex: 0,
    "aria-modal": !1,
    "aria-labelledby": F,
    "aria-describedby": W,
    "aria-hidden": we && !fe ? !0 : void 0,
    onPointerDown: b ? Me : void 0,
    onPointerMove: b ? ze : void 0,
    onPointerUp: b ? le : void 0,
    onKeyDown: se,
    inert: EL(a.limited),
    style: {
      ...Ae(),
      [H4.index]: a.transitionStatus === "ending" ? ne : ae,
      [H4.offsetY]: `${oe}px`,
      [H4.height]: a.height ? `${a.height}px` : void 0
    }
  }, pe = S.useMemo(() => ({
    rootRef: G,
    toast: a,
    titleId: F,
    setTitleId: _,
    descriptionId: W,
    setDescriptionId: Q,
    swiping: P,
    swipeDirection: x,
    recalculateHeight: me,
    index: ne,
    visibleIndex: ae,
    expanded: be
  }), [a, F, W, P, x, me, ne, ae, be]), Qe = {
    transitionStatus: a.transitionStatus,
    expanded: be,
    limited: a.limited || !1,
    type: a.type,
    swiping: pe.swiping,
    swipeDirection: pe.swipeDirection
  }, Le = nc("div", t, {
    ref: [r, pe.rootRef],
    state: Qe,
    stateAttributesMapping: iOt,
    props: [Ne, f]
  });
  return /* @__PURE__ */ V.jsx(WL.Provider, {
    value: pe,
    children: Le
  });
});
process.env.NODE_ENV !== "production" && (_ie.displayName = "ToastRoot");
const Bie = /* @__PURE__ */ S.forwardRef(function(t, r) {
  const {
    render: a,
    className: i,
    ...c
  } = t, {
    visibleIndex: d,
    expanded: f,
    recalculateHeight: p
  } = Vie(), g = S.useRef(null);
  Dr(() => {
    const E = g.current;
    if (!E || (p(), typeof ResizeObserver != "function" || typeof MutationObserver != "function"))
      return;
    const P = new ResizeObserver(() => p(!0)), k = new MutationObserver(() => p(!0));
    return P.observe(E), k.observe(E, {
      childList: !0,
      subtree: !0,
      characterData: !0
    }), () => {
      P.disconnect(), k.disconnect();
    };
  }, [p]);
  const b = d > 0;
  return nc("div", t, {
    ref: [r, g],
    state: {
      expanded: f,
      behind: b
    },
    props: c
  });
});
process.env.NODE_ENV !== "production" && (Bie.displayName = "ToastContent");
const Uie = /* @__PURE__ */ S.forwardRef(function(t, r) {
  const {
    render: a,
    className: i,
    id: c,
    children: d,
    ...f
  } = t, {
    toast: p,
    setDescriptionId: g
  } = Vie(), b = d ?? p.description, w = !!b, x = w3(c);
  Dr(() => {
    if (w)
      return g(x), () => {
        g(void 0);
      };
  }, [w, x, g]);
  const E = {
    type: p.type
  }, P = nc("p", t, {
    ref: r,
    state: E,
    props: {
      ...f,
      id: x,
      children: b
    }
  });
  return w ? P : null;
});
process.env.NODE_ENV !== "production" && (Uie.displayName = "ToastDescription");
const VL = /* @__PURE__ */ S.forwardRef(function(t, r) {
  const {
    children: a,
    container: i,
    className: c,
    render: d,
    ...f
  } = t, {
    portalNode: p,
    portalSubtree: g
  } = coe({
    container: i,
    ref: r,
    componentProps: t,
    elementProps: f
  });
  return !g && !p ? null : /* @__PURE__ */ V.jsxs(S.Fragment, {
    children: [g, p && /* @__PURE__ */ sp.createPortal(a, p)]
  });
});
process.env.NODE_ENV !== "production" && (VL.displayName = "FloatingPortalLite");
const cOt = VL;
function dOt() {
  const e = S.useContext(uO);
  if (!e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: useToastManager must be used within <Toast.Provider>." : ud(73));
  const t = e.useState("toasts");
  return S.useMemo(() => ({
    toasts: t,
    add: e.addToast,
    close: e.closeToast,
    update: e.updateToast,
    promise: e.promiseToast
  }), [t, e]);
}
function fOt() {
  const e = /* @__PURE__ */ new Set();
  function t(r) {
    e.forEach((a) => a(r));
  }
  return {
    // This should be private aside from ToastProvider needing to access it.
    // https://x.com/drosenwasser/status/1816947740032872664
    " subscribe": function(a) {
      return e.add(a), () => {
        e.delete(a);
      };
    },
    add(r) {
      const a = r.id || Hie("toast"), i = {
        ...r,
        id: a,
        transitionStatus: "starting"
      };
      return t({
        action: "add",
        options: i
      }), a;
    },
    close(r) {
      t({
        action: "close",
        options: {
          id: r
        }
      });
    },
    update(r, a) {
      t({
        action: "update",
        options: {
          ...a,
          id: r
        }
      });
    },
    promise(r, a) {
      let i = r;
      return t({
        action: "promise",
        options: {
          ...a,
          promise: r,
          setPromise(c) {
            i = c;
          }
        }
      }), i;
    }
  };
}
const sG = {
  success: { icon: /* @__PURE__ */ V.jsx(z9, {}), color: "#52c41a" },
  error: { icon: /* @__PURE__ */ V.jsx(_x, {}), color: "#ff4d4f" },
  info: { icon: /* @__PURE__ */ V.jsx(Iz, {}), color: "#1677ff" },
  warning: { icon: /* @__PURE__ */ V.jsx(jz, {}), color: "#faad14" }
};
function mOt({
  toast: e,
  offsetY: t,
  onHeightChange: r,
  isExiting: a,
  children: i
}) {
  const c = It(null);
  return Er(() => {
    const d = c.current;
    if (!d)
      return;
    const f = new ResizeObserver(() => {
      r(e.id, d.getBoundingClientRect().height);
    });
    return f.observe(d), r(e.id, d.getBoundingClientRect().height), () => f.disconnect();
  }, [e.id, r]), /* @__PURE__ */ V.jsx(
    "div",
    {
      ref: c,
      className: lt(
        "pointer-events-none absolute left-0 right-0 top-0 flex w-full justify-center",
        "duration-250 transition-transform ease-[cubic-bezier(0.645,0.045,0.355,1)]",
        a && "-z-10"
      ),
      style: { transform: `translateY(${t}px)` },
      children: i
    }
  );
}
let hOt = 0;
const M9 = /* @__PURE__ */ new Set();
let Dk;
const Sz = /* @__PURE__ */ new Set();
function uG() {
  const e = M9.size > 0 ? Math.min(...M9) : void 0;
  if (e !== Dk) {
    Dk = e;
    for (const t of Sz)
      t(Dk);
  }
}
function pOt() {
  const [e, t] = Wn(!1), r = It();
  return Er(() => {
    const a = ++hOt;
    M9.add(a), r.current = a, uG(), t(Dk === a);
    const i = (c) => {
      t(r.current === c);
    };
    return Sz.add(i), () => {
      M9.delete(a), r.current = void 0, Sz.delete(i), uG();
    };
  }, []), e;
}
const cG = fOt();
function gOt() {
  const { toasts: e } = dOt(), [t, r] = Wn(/* @__PURE__ */ new Map()), a = mn(() => [...e].reverse(), [e]);
  Er(() => {
    const f = new Set(e.map((p) => p.id));
    r((p) => {
      let g = !1;
      for (const w of p.keys())
        if (!f.has(w)) {
          g = !0;
          break;
        }
      if (!g)
        return p;
      const b = new Map(p);
      for (const w of b.keys())
        f.has(w) || b.delete(w);
      return b;
    });
  }, [e]);
  const i = Cn((f, p) => {
    r((g) => {
      if (g.get(f) === p)
        return g;
      const b = new Map(g);
      return b.set(f, p), b;
    });
  }, []), c = vo("--toast-gap"), d = mn(() => {
    const f = /* @__PURE__ */ new Map();
    let p = 0;
    for (const [g, b] of a.entries()) {
      f.set(g, p);
      const w = b.transitionStatus === "ending" ? 0 : (t.get(b.id) ?? 0) + c;
      p += w;
    }
    return f;
  }, [a, t, c]);
  return /* @__PURE__ */ V.jsx(
    cOt,
    {
      container: typeof document > "u" ? void 0 : document.body,
      children: /* @__PURE__ */ V.jsx(
        Wie,
        {
          "data-preflight": !0,
          className: lt(
            "toast-viewport top-(--toast-edge-margin-y) z-1000 pointer-events-none fixed",
            "inset-x-0 m-0 min-h-0 list-none p-0"
          ),
          children: a.map((f, p) => {
            const g = f.type ?? "info", b = sG[g] ?? sG.info, w = f.transitionStatus === "ending";
            return /* @__PURE__ */ V.jsx(
              mOt,
              {
                toast: f,
                offsetY: d.get(p) ?? 0,
                onHeightChange: i,
                isExiting: w,
                children: /* @__PURE__ */ V.jsx(
                  _ie,
                  {
                    toast: f,
                    className: lt(
                      "pointer-events-auto mx-auto flex w-fit max-w-full shrink-0 overflow-hidden",
                      "rounded-(--toast-border-radius) bg-(--toast-message-content-background)",
                      "px-(--toast-content-padding-x) py-(--toast-content-padding-y)",
                      "shadow-(--toast-box-shadow) animate-toast-move-in text-center",
                      "data-ending-style:animate-toast-move-out data-ending-style:overflow-hidden"
                    ),
                    children: /* @__PURE__ */ V.jsxs(Bie, { className: "inline-flex min-w-0 items-center", children: [
                      /* @__PURE__ */ V.jsx(
                        "span",
                        {
                          className: lt(
                            "flex shrink-0",
                            "mr-(--toast-icon-margin-end) text-(length:--toast-icon-size)"
                          ),
                          style: { color: b.color },
                          children: b.icon
                        }
                      ),
                      /* @__PURE__ */ V.jsx(
                        Uie,
                        {
                          className: lt(
                            "my-0",
                            "text-(length:--toast-message-font-size) leading-(--toast-line-height) text-(--toast-message-content-color)"
                          ),
                          "data-testid": f.data?.dataTestId,
                          children: f.description
                        }
                      )
                    ] })
                  }
                )
              },
              f.id
            );
          })
        }
      )
    }
  );
}
const $Tt = ({
  children: e
}) => {
  const t = pOt();
  return Er(() => {
    eOt(cG);
  }, []), /* @__PURE__ */ V.jsxs(Fie, { toastManager: t ? cG : void 0, children: [
    t && /* @__PURE__ */ V.jsx(gOt, {}),
    e
  ] });
};
function vOt(e, t, r, a, i, c) {
  Er(() => {
    if (!t)
      return;
    const d = e === "click" && r || e === "focus", f = e === "click" && r, p = (b) => {
      b.key === "Escape" && a(!1);
    }, g = (b) => {
      const w = b.target;
      i.current && !i.current.contains(w) && c.current && !c.current.contains(w) && a(!1);
    };
    return d && document.addEventListener("keydown", p, !0), f && document.addEventListener("pointerdown", g), () => {
      document.removeEventListener("keydown", p, !0), document.removeEventListener("pointerdown", g);
    };
  }, [
    e,
    t,
    r,
    a,
    i,
    c
  ]);
}
function bOt(e, t) {
  return mn(() => {
    const r = {};
    return e === "click" ? r.onClick = () => {
      t((a) => !a);
    } : e === "focus" && (r.onFocus = () => t(!0), r.onBlur = () => t(!1)), r;
  }, [e, t]);
}
function yOt(e) {
  return e.includes("-") ? e.split("-")[0] : e;
}
function wOt(e) {
  return e.endsWith("-left") || e.endsWith("-top") ? "start" : e.endsWith("-right") || e.endsWith("-bottom") ? "end" : "center";
}
function SOt(e) {
  return mn(
    () => ({
      side: yOt(e),
      alignment: wOt(e)
    }),
    [e]
  );
}
function COt(e) {
  return /* @__PURE__ */ V.jsxs("svg", { width: "20", height: "10", viewBox: "0 0 20 10", fill: "none", ...e, children: [
    /* @__PURE__ */ V.jsx(
      "path",
      {
        d: "M9.66437 2.60207L4.80758 6.97318C4.07308 7.63423 3.11989 8 2.13172 8H0V10H20V8H18.5349C17.5468 8 16.5936 7.63423 15.8591 6.97318L11.0023 2.60207C10.622 2.2598 10.0447 2.25979 9.66437 2.60207Z",
        className: "fill-(--tooltip-arrow-fill)"
      }
    ),
    /* @__PURE__ */ V.jsx(
      "path",
      {
        d: "M10.3333 3.34539L5.47654 7.71648C4.55842 8.54279 3.36693 9 2.13172 9H0V8H2.13172C3.11989 8 4.07308 7.63423 4.80758 6.97318L9.66437 2.60207C10.0447 2.25979 10.622 2.2598 11.0023 2.60207L15.8591 6.97318C16.5936 7.63423 17.5468 8 18.5349 8H20V9H18.5349C17.2998 9 16.1083 8.54278 15.1901 7.71648L10.3333 3.34539Z",
        className: "fill-(--tooltip-arrow-stroke)"
      }
    )
  ] });
}
const _L = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (_L.displayName = "TooltipRootContext");
function A7(e) {
  const t = S.useContext(_L);
  if (t === void 0 && !e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TooltipRootContext is missing. Tooltip parts must be placed within <Tooltip.Root>." : ud(72));
  return t;
}
const xOt = {
  ...Coe,
  disabled: ua((e) => e.disabled),
  instantType: ua((e) => e.instantType),
  isInstantPhase: ua((e) => e.isInstantPhase),
  trackCursorAxis: ua((e) => e.trackCursorAxis),
  disableHoverablePopup: ua((e) => e.disableHoverablePopup),
  lastOpenChangeReason: ua((e) => e.openChangeReason),
  closeDelay: ua((e) => e.closeDelay),
  hasViewport: ua((e) => e.hasViewport)
};
class BL extends nO {
  constructor(t) {
    super({
      ...EOt(),
      ...t
    }, {
      popupRef: /* @__PURE__ */ S.createRef(),
      onOpenChange: void 0,
      onOpenChangeComplete: void 0,
      triggerElements: new rO()
    }, xOt);
  }
  setOpen = (t, r) => {
    const a = r.reason, i = a === Xh, c = t && a === Ok, d = !t && (a === hS || a === ZM);
    if (r.preventUnmountOnClose = () => {
      this.set("preventUnmountingOnClose", !0);
    }, this.context.onOpenChange?.(t, r), r.isCanceled)
      return;
    const f = () => {
      const p = {
        open: t,
        openChangeReason: a
      };
      c ? p.instantType = "focus" : d ? p.instantType = "dismiss" : a === Xh && (p.instantType = void 0);
      const g = r.trigger?.id ?? null;
      (g || t) && (p.activeTriggerId = g, p.activeTriggerElement = r.trigger ?? null), this.update(p);
    };
    i ? sp.flushSync(f) : f();
  };
  static useStore(t, r) {
    const a = am(() => new BL(r)).current, i = t ?? a, c = xoe({
      popupStore: i,
      onOpenChange: i.setOpen
    });
    return i.state.floatingRootContext = c, i;
  }
}
function EOt() {
  return {
    ...Soe(),
    disabled: !1,
    instantType: void 0,
    isInstantPhase: !1,
    trackCursorAxis: "none",
    disableHoverablePopup: !1,
    openChangeReason: null,
    closeDelay: 0,
    hasViewport: !1
  };
}
const Xie = goe(function(t) {
  const {
    disabled: r = !1,
    defaultOpen: a = !1,
    open: i,
    disableHoverablePopup: c = !1,
    trackCursorAxis: d = "none",
    actionsRef: f,
    onOpenChange: p,
    onOpenChangeComplete: g,
    handle: b,
    triggerId: w,
    defaultTriggerId: x = null,
    children: E
  } = t, P = BL.useStore(b?.store, {
    open: a,
    openProp: i,
    activeTriggerId: x,
    triggerIdProp: w
  });
  Xae(() => {
    i === void 0 && P.state.open === !1 && a === !0 && P.update({
      open: !0,
      activeTriggerId: x
    });
  }), P.useControlledProp("openProp", i), P.useControlledProp("triggerIdProp", w), P.useContextCallback("onOpenChange", p), P.useContextCallback("onOpenChangeComplete", g);
  const k = P.useState("open"), M = !r && k, T = P.useState("activeTriggerId"), N = P.useState("payload");
  P.useSyncedValues({
    trackCursorAxis: d,
    disableHoverablePopup: c
  }), Dr(() => {
    k && r && P.setOpen(!1, ji(z8t));
  }, [k, r, P]), P.useSyncedValue("disabled", r), yoe(P);
  const {
    forceUnmount: D,
    transitionStatus: $
  } = woe(M, P), j = P.useState("isInstantPhase"), I = P.useState("instantType"), L = P.useState("lastOpenChangeReason"), F = S.useRef(null);
  Dr(() => {
    $ === "ending" && L === $x || $ !== "ending" && j ? (I !== "delay" && (F.current = I), P.set("instantType", "delay")) : F.current !== null && (P.set("instantType", F.current), F.current = null);
  }, [$, j, L, I, P]), Dr(() => {
    M && T == null && P.set("payload", void 0);
  }, [P, T, M]);
  const _ = S.useCallback(() => {
    P.setOpen(!1, POt(P, Nae));
  }, [P]);
  S.useImperativeHandle(f, () => ({
    unmount: D,
    close: _
  }), [D, _]);
  const W = P.useState("floatingRootContext"), Q = foe(W, {
    enabled: !r,
    referencePress: !0
  }), U = rEt(W, {
    enabled: !r && d !== "none",
    axis: d === "none" ? void 0 : d
  }), {
    getReferenceProps: Y,
    getFloatingProps: G,
    getTriggerProps: J
  } = yL([Q, U]), H = S.useMemo(() => Y(), [Y]), K = S.useMemo(() => J(), [J]), X = S.useMemo(() => G(), [G]);
  return P.useSyncedValues({
    activeTriggerProps: H,
    inactiveTriggerProps: K,
    popupProps: X
  }), /* @__PURE__ */ V.jsx(_L.Provider, {
    value: P,
    children: typeof E == "function" ? E({
      payload: N
    }) : E
  });
});
process.env.NODE_ENV !== "production" && (Xie.displayName = "TooltipRoot");
function POt(e, t) {
  const r = ji(t);
  return r.preventUnmountOnClose = () => {
    e.set("preventUnmountingOnClose", !0);
  }, r;
}
const UL = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (UL.displayName = "TooltipProviderContext");
function kOt() {
  return S.useContext(UL);
}
let MOt = (function(e) {
  return e[e.popupOpen = S9.popupOpen] = "popupOpen", e.triggerDisabled = "data-trigger-disabled", e;
})({});
const OOt = 600, Gie = $Et(function(t, r) {
  const {
    className: a,
    render: i,
    handle: c,
    payload: d,
    disabled: f,
    delay: p,
    closeDelay: g,
    id: b,
    ...w
  } = t, x = A7(!0), E = c?.store ?? x;
  if (!E)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Tooltip.Trigger> must be either used within a <Tooltip.Root> component or provided with a handle." : ud(82));
  const P = E7(b), k = E.useState("isTriggerActive", P), M = E.useState("isOpenedByTrigger", P), T = E.useState("floatingRootContext"), N = S.useRef(null), D = p ?? OOt, $ = g ?? 0, {
    registerTrigger: j,
    isMountedByThisTrigger: I
  } = boe(P, N, E, {
    payload: d,
    closeDelay: $
  }), L = kOt(), {
    delayRef: F,
    isInstantPhase: _,
    hasProvider: W
  } = B5t(T, {
    open: M
  });
  E.useSyncedValue("isInstantPhase", _);
  const Q = E.useState("disabled"), U = f ?? Q, Y = E.useState("trackCursorAxis"), G = E.useState("disableHoverablePopup"), J = koe(T, {
    enabled: !U,
    mouseOnly: !0,
    move: !1,
    handleClose: !G && Y !== "both" ? Moe() : null,
    restMs() {
      const ie = L?.delay, ee = typeof F.current == "object" ? F.current.open : void 0;
      let ne = D;
      return W && (ee !== 0 ? ne = p ?? ie ?? D : ne = 0), ne;
    },
    delay() {
      const ie = typeof F.current == "object" ? F.current.close : void 0;
      let ee = $;
      return g == null && W && (ee = ie), {
        close: ee
      };
    },
    triggerElementRef: N,
    isActiveTrigger: k
  }), H = qEt(T, {
    enabled: !U
  }).reference, K = {
    open: M
  }, X = E.useState("triggerProps", I);
  return nc("button", t, {
    state: K,
    ref: [r, j, N],
    props: [J, H, X, {
      id: P,
      [MOt.triggerDisabled]: U ? "" : void 0
    }, w],
    stateAttributesMapping: Ooe
  });
});
process.env.NODE_ENV !== "production" && (Gie.displayName = "TooltipTrigger");
const XL = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (XL.displayName = "TooltipPortalContext");
function TOt() {
  const e = S.useContext(XL);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Tooltip.Portal> is missing." : ud(70));
  return e;
}
const qie = /* @__PURE__ */ S.forwardRef(function(t, r) {
  const {
    keepMounted: a = !1,
    ...i
  } = t;
  return A7().useState("mounted") || a ? /* @__PURE__ */ V.jsx(XL.Provider, {
    value: a,
    children: /* @__PURE__ */ V.jsx(VL, {
      ref: r,
      ...i
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (qie.displayName = "TooltipPortal");
const GL = /* @__PURE__ */ S.createContext(void 0);
process.env.NODE_ENV !== "production" && (GL.displayName = "TooltipPositionerContext");
function Kie() {
  const e = S.useContext(GL);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TooltipPositionerContext is missing. TooltipPositioner parts must be placed within <Tooltip.Positioner>." : ud(71));
  return e;
}
const Yie = /* @__PURE__ */ S.forwardRef(function(t, r) {
  const {
    render: a,
    className: i,
    anchor: c,
    positionMethod: d = "absolute",
    side: f = "top",
    align: p = "center",
    sideOffset: g = 0,
    alignOffset: b = 0,
    collisionBoundary: w = "clipping-ancestors",
    collisionPadding: x = 5,
    arrowPadding: E = 5,
    sticky: P = !1,
    disableAnchorTracking: k = !1,
    collisionAvoidance: M = Tae,
    ...T
  } = t, N = A7(), D = TOt(), $ = N.useState("open"), j = N.useState("mounted"), I = N.useState("trackCursorAxis"), L = N.useState("disableHoverablePopup"), F = N.useState("floatingRootContext"), _ = N.useState("instantType"), W = N.useState("transitionStatus"), Q = N.useState("hasViewport"), U = $oe({
    anchor: c,
    positionMethod: d,
    floatingRootContext: F,
    mounted: j,
    side: f,
    sideOffset: g,
    align: p,
    alignOffset: b,
    collisionBoundary: w,
    collisionPadding: x,
    sticky: P,
    arrowPadding: E,
    disableAnchorTracking: k,
    keepMounted: D,
    collisionAvoidance: M,
    adaptiveOrigin: Q ? Noe : void 0
  }), Y = S.useMemo(() => {
    const K = {};
    return (!$ || I === "both" || L) && (K.pointerEvents = "none"), {
      role: "presentation",
      hidden: !j,
      style: {
        ...U.positionerStyles,
        ...K
      }
    };
  }, [$, I, L, j, U.positionerStyles]), G = S.useMemo(() => ({
    open: $,
    side: U.side,
    align: U.align,
    anchorHidden: U.anchorHidden,
    instant: I !== "none" ? "tracking-cursor" : _
  }), [$, U.side, U.align, U.anchorHidden, I, _]), J = S.useMemo(() => ({
    ...G,
    arrowRef: U.arrowRef,
    arrowStyles: U.arrowStyles,
    arrowUncentered: U.arrowUncentered
  }), [G, U.arrowRef, U.arrowStyles, U.arrowUncentered]), H = nc("div", t, {
    state: G,
    props: [Y, aO(W), T],
    ref: [r, N.useStateSetter("positionerElement")],
    stateAttributesMapping: M7
  });
  return /* @__PURE__ */ V.jsx(GL.Provider, {
    value: J,
    children: H
  });
});
process.env.NODE_ENV !== "production" && (Yie.displayName = "TooltipPositioner");
const ROt = {
  ...M7,
  ...i6
}, Qie = /* @__PURE__ */ S.forwardRef(function(t, r) {
  const {
    className: a,
    render: i,
    ...c
  } = t, d = A7(), {
    side: f,
    align: p
  } = Kie(), g = d.useState("open"), b = d.useState("instantType"), w = d.useState("transitionStatus"), x = d.useState("popupProps"), E = d.useState("floatingRootContext");
  l6({
    open: g,
    ref: d.context.popupRef,
    onComplete() {
      g && d.context.onOpenChangeComplete?.(!0);
    }
  });
  const P = d.useState("disabled"), k = d.useState("closeDelay");
  return Poe(E, {
    enabled: !P,
    closeDelay: k
  }), nc("div", t, {
    state: {
      open: g,
      side: f,
      align: p,
      instant: b,
      transitionStatus: w
    },
    ref: [r, d.context.popupRef, d.useStateSetter("popupElement")],
    props: [x, aO(w), c],
    stateAttributesMapping: ROt
  });
});
process.env.NODE_ENV !== "production" && (Qie.displayName = "TooltipPopup");
const Jie = /* @__PURE__ */ S.forwardRef(function(t, r) {
  const {
    className: a,
    render: i,
    ...c
  } = t, f = A7().useState("instantType"), {
    open: p,
    arrowRef: g,
    side: b,
    align: w,
    arrowUncentered: x,
    arrowStyles: E
  } = Kie();
  return nc("div", t, {
    state: {
      open: p,
      side: b,
      align: w,
      uncentered: x,
      instant: f
    },
    ref: [r, g],
    props: [{
      style: E,
      "aria-hidden": !0
    }, c],
    stateAttributesMapping: M7
  });
});
process.env.NODE_ENV !== "production" && (Jie.displayName = "TooltipArrow");
const Zie = function(t) {
  const {
    delay: r,
    closeDelay: a,
    timeout: i = 400
  } = t, c = S.useMemo(() => ({
    delay: r,
    closeDelay: a
  }), [r, a]), d = S.useMemo(() => ({
    open: r,
    close: a
  }), [r, a]);
  return /* @__PURE__ */ V.jsx(UL.Provider, {
    value: c,
    children: /* @__PURE__ */ V.jsx(_5t, {
      delay: d,
      timeoutMs: i,
      children: t.children
    })
  });
};
process.env.NODE_ENV !== "production" && (Zie.displayName = "TooltipProvider");
const AOt = Zie, NOt = Xie, DOt = Gie, $Ot = qie, zOt = Yie, jOt = Jie, ele = ks(({ className: e, ...t }, r) => /* @__PURE__ */ V.jsx(
  Qie,
  {
    ref: r,
    className: lt(
      "border-(--tooltip-border) bg-(--tooltip-bg) text-(--tooltip-text) max-w-xs overflow-visible rounded-[3px] border px-3 py-2 text-sm shadow-lg",
      "data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95",
      "data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95",
      e
    ),
    ...t
  }
));
ele.displayName = "TooltipPopup";
function IOt({
  content: e,
  children: t,
  position: r = "top",
  trigger: a = "hover",
  delayDuration: i = 200,
  dismissible: c = !0,
  disabled: d = !1,
  className: f,
  triggerClassName: p = "inline-flex",
  showArrow: g = !0,
  defaultOpen: b = !1,
  "data-testid": w,
  "aria-label": x
}) {
  const E = a === "click" || a === "focus", [P, k] = Wn(b), M = It(null), T = It(null), { side: N, alignment: D } = SOt(r), { onClick: $, onFocus: j, onBlur: I } = bOt(
    a,
    k
  );
  if (vOt(
    a,
    P,
    c,
    k,
    M,
    T
  ), d)
    return /* @__PURE__ */ V.jsx(V.Fragment, { children: t });
  const L = E ? { open: P, openOnHover: !1 } : { defaultOpen: b };
  return /* @__PURE__ */ V.jsx(AOt, { children: /* @__PURE__ */ V.jsxs(NOt, { ...L, children: [
    /* @__PURE__ */ V.jsx(
      DOt,
      {
        render: /* @__PURE__ */ V.jsx(
          "span",
          {
            ref: M,
            "data-testid": w ? `${w}-trigger` : void 0
          }
        ),
        className: p,
        delay: i,
        onClick: $,
        onFocus: j,
        onBlur: I,
        children: t
      }
    ),
    /* @__PURE__ */ V.jsx($Ot, { children: /* @__PURE__ */ V.jsx(
      zOt,
      {
        side: N,
        align: D,
        sideOffset: vo(g ? "--tooltip-offset-with-arrow" : "--tooltip-offset-without-arrow"),
        className: "z-60",
        children: /* @__PURE__ */ V.jsxs(
          ele,
          {
            ref: T,
            className: f,
            "data-testid": w ? `${w}-content` : void 0,
            "aria-label": x,
            children: [
              e,
              g && /* @__PURE__ */ V.jsx(
                jOt,
                {
                  className: lt(
                    "flex",
                    "data-[side=top]:bottom-[-8px] data-[side=top]:rotate-180",
                    "data-[side=bottom]:top-[-8px]",
                    "data-[side=left]:right-[-13px] data-[side=left]:rotate-90",
                    "data-[side=right]:left-[-13px] data-[side=right]:-rotate-90"
                  ),
                  children: /* @__PURE__ */ V.jsx(COt, {})
                }
              )
            ]
          }
        )
      }
    ) })
  ] }) });
}
IOt.displayName = "Tooltip";
const zTt = ({
  children: e,
  kind: t,
  noPadding: r = !1,
  noBorder: a = !1,
  highlight: i = !1,
  margin: c,
  testId: d,
  fillHeight: f = !1,
  title: p
}) => {
  const g = c ?? "var(--well-margin)";
  return /* @__PURE__ */ V.jsxs(
    "section",
    {
      "data-testid": d,
      style: { margin: g },
      className: lt(
        "block leading-[var(--well-line-height)]",
        a ? "border-none" : "border",
        i ? "bg-[var(--well-background-color-highlight)]" : "bg-[var(--well-background-color)]",
        // kind-specific
        t === "dealer" ? lt(
          !r && "p-[var(--well-dealer-padding)]",
          !a && "border-[var(--well-dealer-border-color)] shadow-[var(--well-dealer-box-shadow)]",
          "rounded-[var(--well-border-radius)]",
          "font-[var(--dealer-font-family)]",
          "text-(length:--dealer-font-size)",
          "text-(color:--dealer-portal-primary-color)",
          /* style any <input> inside the Well */
          "[&_input]:p-[var(--well-dealer-input-padding)]"
        ) : lt(
          !r && "p-[var(--well-caps-padding)]",
          !a && "border-[var(--well-caps-border-color)]",
          "rounded-none",
          "font-[var(--caps-font-family)]",
          "text-(length:--caps-font-size)",
          "text-(color:--caps-primary-color)",
          /* style any <input> inside the Well */
          "[&_input]:rounded-[calc(var(--well-border-radius)/2)]"
        ),
        // fill-height toggles a column flexbox
        f && "flex min-h-full flex-col"
      ),
      children: [
        p && /* @__PURE__ */ V.jsx("header", { className: "mb-2", children: p }),
        /* @__PURE__ */ V.jsx("div", { className: lt(f && "flex-1"), children: e })
      ]
    }
  );
};
export {
  dee as AlertBanner,
  Vxe as AlertBannerI18n,
  GOt as AntdLayerProvider,
  zMe as AutoComplete,
  qOt as Avatar,
  Qw as Button,
  dTt as CapsHeader,
  _xe as CapsHeaderI18n,
  fTt as Card,
  mTt as Carousel,
  bte as Checkbox,
  vOe as CheckboxGroup,
  hTt as ContactInfo,
  hae as DEFAULT_TIME_FORMAT,
  NTt as DataTable,
  r6e as DataTableI18n,
  M3t as DatePicker,
  Xxe as DatePickerI18n,
  kke as DealerPageFooter,
  Bxe as DealerPageFooterI18n,
  pTt as Drawer,
  gTt as Dropdown,
  vTt as ErrorBoundary,
  Uxe as ErrorBoundaryI18n,
  Hke as Field,
  bTt as FieldGroup,
  ite as FileUpload,
  Sk as Header,
  M$ as ICON_MAP,
  yTt as ICON_NAMES,
  _f as Icon,
  sS as Input,
  H3t as InputNumber,
  tL as InputSet,
  Kxe as InputSetI18n,
  q6t as InputSplit,
  qM as InputText,
  Gxe as InputTextI18n,
  STt as KINDS,
  CTt as Link,
  xTt as Loading,
  Yxe as LoadingI18n,
  ETt as Menu,
  qoe as Modal,
  Qxe as ModalI18n,
  PTt as OverrideBanner,
  Jxe as OverrideBannerI18n,
  PPt as OverrideEditor,
  qZ as OverrideEditorI18n,
  kTt as PageLayout,
  zPt as Pagination,
  Zxe as PaginationI18n,
  X3t as Password,
  Koe as Popover,
  MTt as PopoverWithLabel,
  G3t as Radio,
  Cxt as RadioGroup,
  OTt as RehashCustomerInformation,
  e6e as RehashCustomerInformationI18n,
  TTt as RehashHeader,
  t6e as RehashHeaderI18n,
  vkt as ScoringProgramBanner,
  $6t as Select,
  qxe as SelectI18n,
  RTt as Skeleton,
  ATt as StepsHeader,
  n6e as StepsHeaderI18n,
  _6t as Switch,
  DTt as Table,
  ZMt as Tabs,
  B6t as TextArea,
  Kj as ThemeContext,
  U6t as TimePicker,
  X6t as TimeRangePicker,
  $Tt as ToastProvider,
  IOt as Tooltip,
  LV as Trans,
  zTt as Well,
  u8e as alertVariants,
  l6e as breakpoints,
  c8e as buttonVariants,
  lt as cn,
  UOt as generateFields,
  mr as getCSSVariableValue,
  vo as getCSSVariableValueAsNumber,
  h6e as getCurrentYear,
  XOt as getStoryUrl,
  pae as getTimePickerTheme,
  CM as getValueFromPath,
  BOt as i18n,
  _oe as menuClassNames,
  fre as radioButtonVariants,
  mre as radioIndicatorVariants,
  hre as radioLabelVariants,
  dre as radioOptionVariants,
  R7 as toast,
  fi as useTranslation
};
//# sourceMappingURL=index.js.map
